(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('@charset "UTF-8";.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__navigation-icon:before{border-color:#ccc;border-style:solid;border-width:3px 3px 0 0;content:"";display:block;height:9px;position:absolute;top:6px;width:9px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{margin-left:-4px;position:absolute;width:0}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:after,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:after{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px;content:"";z-index:-1;border-width:8px;left:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:after{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:after{top:0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:after{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:after{bottom:0}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker-wrapper{display:inline-block;padding:0;border:0}.react-datepicker{font-family:Helvetica Neue,helvetica,arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;display:inline-block;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{padding-top:10px}.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle,.react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle{left:auto;right:50px}.react-datepicker-popper[data-placement^=top]{padding-bottom:10px}.react-datepicker-popper[data-placement^=right]{padding-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{padding-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;padding:8px 0;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__header--time:not(.react-datepicker__header--time--only){border-top-left-radius:0}.react-datepicker__header:not(.react-datepicker__header--has-time-select){border-top-right-radius:.3rem}.react-datepicker__year-dropdown-container--select,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--scroll{display:inline-block;margin:0 15px}.react-datepicker__current-month,.react-datepicker-time__header,.react-datepicker-year-header{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{align-items:center;background:none;display:flex;justify-content:center;text-align:center;cursor:pointer;position:absolute;top:2px;padding:0;border:none;z-index:1;height:32px;width:32px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:2px}.react-datepicker__navigation--next{right:2px}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:85px}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px}.react-datepicker__navigation--years-upcoming{top:-4px}.react-datepicker__navigation:hover *:before{border-color:#a6a6a6}.react-datepicker__navigation-icon{position:relative;top:-1px;font-size:20px;width:0}.react-datepicker__navigation-icon--next{left:-2px}.react-datepicker__navigation-icon--next:before{transform:rotate(45deg);left:-7px}.react-datepicker__navigation-icon--previous{right:-2px}.react-datepicker__navigation-icon--previous:before{transform:rotate(225deg);right:-7px}.react-datepicker__month-container{float:left}.react-datepicker__year{margin:.4rem;text-align:center}.react-datepicker__year-wrapper{display:flex;flex-wrap:wrap;max-width:180px}.react-datepicker__year .react-datepicker__year-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__month .react-datepicker__month-text,.react-datepicker__month .react-datepicker__quarter-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__input-time-container{clear:both;width:100%;float:left;margin:5px 0 10px 15px;text-align:left}.react-datepicker__input-time-container .react-datepicker-time__caption,.react-datepicker__input-time-container .react-datepicker-time__input-container{display:inline-block}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input{display:inline-block;margin-left:10px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input{width:auto}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]{-moz-appearance:textfield}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter{margin-left:5px;display:inline-block}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:85px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-87px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:white;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:85px;overflow-x:hidden;margin:0 auto;text-align:center;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + .85rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px;white-space:nowrap}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected,.react-datepicker__week-number--keyboard-selected):hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__week-number--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__week-number--selected:hover{background-color:#1d5d90}.react-datepicker__week-number--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__week-number--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day-names{white-space:nowrap;margin-bottom:-8px}.react-datepicker__week{white-space:nowrap}.react-datepicker__day-name,.react-datepicker__day,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day,.react-datepicker__month-text,.react-datepicker__quarter-text,.react-datepicker__year-text{cursor:pointer}.react-datepicker__day:hover,.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover,.react-datepicker__year-text:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today,.react-datepicker__month-text--today,.react-datepicker__quarter-text--today,.react-datepicker__year-text--today{font-weight:700}.react-datepicker__day--highlighted,.react-datepicker__month-text--highlighted,.react-datepicker__quarter-text--highlighted,.react-datepicker__year-text--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover,.react-datepicker__month-text--highlighted:hover,.react-datepicker__quarter-text--highlighted:hover,.react-datepicker__year-text--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1,.react-datepicker__month-text--highlighted-custom-1,.react-datepicker__quarter-text--highlighted-custom-1,.react-datepicker__year-text--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2,.react-datepicker__month-text--highlighted-custom-2,.react-datepicker__quarter-text--highlighted-custom-2,.react-datepicker__year-text--highlighted-custom-2{color:green}.react-datepicker__day--holidays,.react-datepicker__month-text--holidays,.react-datepicker__quarter-text--holidays,.react-datepicker__year-text--holidays{position:relative;border-radius:.3rem;background-color:#ff6803;color:#fff}.react-datepicker__day--holidays .holiday-overlay,.react-datepicker__month-text--holidays .holiday-overlay,.react-datepicker__quarter-text--holidays .holiday-overlay,.react-datepicker__year-text--holidays .holiday-overlay{position:absolute;bottom:100%;left:50%;transform:translate(-50%);background-color:#333;color:#fff;padding:4px;border-radius:4px;white-space:nowrap;visibility:hidden;opacity:0;transition:visibility 0s,opacity .3s ease-in-out}.react-datepicker__day--holidays:hover,.react-datepicker__month-text--holidays:hover,.react-datepicker__quarter-text--holidays:hover,.react-datepicker__year-text--holidays:hover{background-color:#cf5300}.react-datepicker__day--holidays:hover .holiday-overlay,.react-datepicker__month-text--holidays:hover .holiday-overlay,.react-datepicker__quarter-text--holidays:hover .holiday-overlay,.react-datepicker__year-text--holidays:hover .holiday-overlay{visibility:visible;opacity:1}.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range,.react-datepicker__month-text--selected,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--selected,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--selected,.react-datepicker__year-text--in-selecting-range,.react-datepicker__year-text--in-range{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--selected:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--in-range:hover,.react-datepicker__month-text--selected:hover,.react-datepicker__month-text--in-selecting-range:hover,.react-datepicker__month-text--in-range:hover,.react-datepicker__quarter-text--selected:hover,.react-datepicker__quarter-text--in-selecting-range:hover,.react-datepicker__quarter-text--in-range:hover,.react-datepicker__year-text--selected:hover,.react-datepicker__year-text--in-selecting-range:hover,.react-datepicker__year-text--in-range:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected,.react-datepicker__month-text--keyboard-selected,.react-datepicker__quarter-text--keyboard-selected,.react-datepicker__year-text--keyboard-selected{border-radius:.3rem;background-color:#bad9f1;color:#000}.react-datepicker__day--keyboard-selected:hover,.react-datepicker__month-text--keyboard-selected:hover,.react-datepicker__quarter-text--keyboard-selected:hover,.react-datepicker__year-text--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range){background-color:#216ba580}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled,.react-datepicker__month-text--disabled,.react-datepicker__quarter-text--disabled,.react-datepicker__year-text--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover,.react-datepicker__month-text--disabled:hover,.react-datepicker__quarter-text--disabled:hover,.react-datepicker__year-text--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block;width:100%}.react-datepicker__input-container .react-datepicker__calendar-icon{position:absolute;padding:.5rem;box-sizing:content-box}.react-datepicker__view-calendar-icon input{padding:6px 10px 5px 25px}.react-datepicker__year-read-view,.react-datepicker__month-read-view,.react-datepicker__month-year-read-view{border:1px solid transparent;border-radius:.3rem;position:relative}.react-datepicker__year-read-view:hover,.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover{cursor:pointer}.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow{transform:rotate(135deg);right:-16px;top:0}.react-datepicker__year-dropdown,.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__year-dropdown:hover,.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover{cursor:pointer}.react-datepicker__year-dropdown--scrollable,.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__year-option,.react-datepicker__month-option,.react-datepicker__month-year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__year-option:first-of-type,.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__year-option:last-of-type,.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__year-option:hover,.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover{background-color:#ccc}.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__year-option--selected,.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{cursor:pointer;background-color:transparent;border:0;outline:0;padding:0 6px 0 0;position:absolute;top:0;right:0;height:100%;display:table-cell;vertical-align:middle}.react-datepicker__close-icon:after{cursor:pointer;background-color:#216ba5;color:#fff;border-radius:50%;height:16px;width:16px;padding:2px;font-size:12px;line-height:1;text-align:center;display:table-cell;vertical-align:middle;content:"×"}.react-datepicker__close-icon--disabled{cursor:default}.react-datepicker__close-icon--disabled:after{cursor:default;background-color:#ccc}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:#000c;left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-width: 400px),(max-height: 550px){.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker__current-month,.react-datepicker__portal .react-datepicker-time__header{font-size:1.44rem}.react-datepicker__children-container{width:13.8rem;margin:.4rem;padding-right:.2rem;padding-left:.2rem;height:auto}.react-datepicker__aria-live{position:absolute;clip-path:circle(0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;width:1px;white-space:nowrap}.react-datepicker__calendar-icon{width:1em;height:1em;vertical-align:-.125em}:root{--PhoneInput-color--focus: #03b2cb;--PhoneInputInternationalIconPhone-opacity: .8;--PhoneInputInternationalIconGlobe-opacity: .65;--PhoneInputCountrySelect-marginRight: .35em;--PhoneInputCountrySelectArrow-width: .3em;--PhoneInputCountrySelectArrow-marginLeft: var(--PhoneInputCountrySelect-marginRight);--PhoneInputCountrySelectArrow-borderWidth: 1px;--PhoneInputCountrySelectArrow-opacity: .45;--PhoneInputCountrySelectArrow-color: currentColor;--PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);--PhoneInputCountrySelectArrow-transform: rotate(45deg);--PhoneInputCountryFlag-aspectRatio: 1.5;--PhoneInputCountryFlag-height: 1em;--PhoneInputCountryFlag-borderWidth: 1px;--PhoneInputCountryFlag-borderColor: rgba(0,0,0,.5);--PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);--PhoneInputCountryFlag-backgroundColor--loading: rgba(0,0,0,.1)}.PhoneInput{display:flex;align-items:center}.PhoneInputInput{flex:1;min-width:0}.PhoneInputCountryIcon{width:calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio));height:var(--PhoneInputCountryFlag-height)}.PhoneInputCountryIcon--square{width:var(--PhoneInputCountryFlag-height)}.PhoneInputCountryIcon--border{background-color:var(--PhoneInputCountryFlag-backgroundColor--loading);box-shadow:0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor)}.PhoneInputCountryIconImg{display:block;width:100%;height:100%}.PhoneInputInternationalIconPhone{opacity:var(--PhoneInputInternationalIconPhone-opacity)}.PhoneInputInternationalIconGlobe{opacity:var(--PhoneInputInternationalIconGlobe-opacity)}.PhoneInputCountry{position:relative;align-self:stretch;display:flex;align-items:center;margin-right:var(--PhoneInputCountrySelect-marginRight)}.PhoneInputCountrySelect{position:absolute;top:0;left:0;height:100%;width:100%;z-index:1;border:0;opacity:0;cursor:pointer}.PhoneInputCountrySelect[disabled],.PhoneInputCountrySelect[readonly]{cursor:default}.PhoneInputCountrySelectArrow{display:block;content:"";width:var(--PhoneInputCountrySelectArrow-width);height:var(--PhoneInputCountrySelectArrow-width);margin-left:var(--PhoneInputCountrySelectArrow-marginLeft);border-style:solid;border-color:var(--PhoneInputCountrySelectArrow-color);border-top-width:0;border-bottom-width:var(--PhoneInputCountrySelectArrow-borderWidth);border-left-width:0;border-right-width:var(--PhoneInputCountrySelectArrow-borderWidth);transform:var(--PhoneInputCountrySelectArrow-transform);opacity:var(--PhoneInputCountrySelectArrow-opacity)}.PhoneInputCountrySelect:focus+.PhoneInputCountryIcon+.PhoneInputCountrySelectArrow{opacity:1;color:var(--PhoneInputCountrySelectArrow-color--focus)}.PhoneInputCountrySelect:focus+.PhoneInputCountryIcon--border{box-shadow:0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus)}.PhoneInputCountrySelect:focus+.PhoneInputCountryIcon .PhoneInputInternationalIconGlobe{opacity:1;color:var(--PhoneInputCountrySelectArrow-color--focus)}@container (width < 600px){.radio-card-group[data-options="1"]{grid-template-columns:repeat(1,minmax(0,1fr))}}@container (width < 425px){.radio-card-group[data-options="1"]{grid-template-columns:repeat(1,minmax(0,1fr))}}@container (width < 320px){.radio-card-group[data-options="1"]{grid-template-columns:repeat(1,minmax(0,1fr))}}@container (width < 600px){.radio-card-group[data-options="2"]{grid-template-columns:repeat(2,minmax(0,1fr))}}@container (width < 425px){.radio-card-group[data-options="2"]{grid-template-columns:repeat(2,minmax(0,1fr))}}@container (width < 768px){.radio-card-group[data-options="3"]{grid-template-columns:repeat(3,minmax(0,1fr))}}@container (width < 768px){.radio-card-group{grid-template-columns:repeat(4,minmax(0,1fr))}}@container (width < 600px){.radio-card-group{grid-template-columns:repeat(3,minmax(0,1fr))}}@container (width < 425px){.radio-card-group{grid-template-columns:repeat(2,minmax(0,1fr))}}@container (width < 320px){.radio-card-group{grid-template-columns:repeat(1,minmax(0,1fr))}}')),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import * as React from "react";
import React__default, { useState, useEffect, useMemo, Children as Children$1, useRef, useLayoutEffect, createElement as createElement$1, Component, createRef, useCallback, forwardRef, useContext, createContext, Fragment as Fragment$1, useReducer, useImperativeHandle } from "react";
import styled, { createGlobalStyle, ThemeProvider as ThemeProvider$1, css as css$3, keyframes as keyframes$1 } from "styled-components";
import { ToastContainer, toast, Zoom as Zoom$1 } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { findDOMNode, createPortal } from "react-dom";
function _mergeNamespaces(t, r) {
  for (var n = 0; n < r.length; n++) {
    const a = r[n];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const s in a)
        if (s !== "default" && !(s in t)) {
          const o = Object.getOwnPropertyDescriptor(a, s);
          o && Object.defineProperty(t, s, o.get ? o : {
            enumerable: !0,
            get: () => a[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
const useForm = (t = {}) => {
  const [r, n] = useState(t);
  useEffect(() => {
    n(t);
  }, [t]);
  const a = ({
    id: c,
    value: l,
    isValid: d
  }) => {
    n((h) => ({
      ...h,
      [c]: {
        value: l,
        isValid: d
      }
    }));
  }, s = useMemo(() => Object.keys(r).every((c) => r[c].isValid), [r]);
  return {
    formValues: r,
    isValidForm: s,
    onInputChange: a,
    onResetForm: () => {
      n(t);
    }
  };
};
var ChipTypes = /* @__PURE__ */ ((t) => (t.neutral = "neutral", t.neutral_shaded = "neutral_shaded", t.neutral_line = "neutral_line", t.cold = "cold", t.cold_shaded = "cold_shaded", t.cold_line = "cold_line", t.warning = "warning", t.warning_shaded = "warning_shaded", t.warning_line = "warning_line", t.error = "error", t.error_line = "error_line", t.error_shaded = "error_shaded", t.success = "success", t.success_line = "success_line", t.success_shaded = "success_shaded", t.dark_line = "dark_line", t))(ChipTypes || {});
const ASSETS_DOMAIN = "https://assets.taxdown.es/assets/", ILLUSTRATION_DOMAIN = "https://assets.taxdown.es/assets/illustrations/", SilkaRegularEot = `${ASSETS_DOMAIN}fonts/Silka-Regular/silka-regular-webfont.eot`, SilkaRegularWoff2 = `${ASSETS_DOMAIN}fonts/Silka-Regular/silka-regular-webfont.woff2`, SilkaRegularWoff = `${ASSETS_DOMAIN}fonts/Silka-Regular/silka-regular-webfont.woff`, SilkaRegularTtf = `${ASSETS_DOMAIN}fonts/Silka-Regular/silka-regular-webfont.ttf`, SilkaMediumEot = `${ASSETS_DOMAIN}fonts/Silka-Medium/silka-medium-webfont.eot`, SilkaMediumWoff2 = `${ASSETS_DOMAIN}fonts/Silka-Medium/silka-medium-webfont.woff2`, SilkaMediumWoff = `${ASSETS_DOMAIN}fonts/Silka-Medium/silka-medium-webfont.woff`, SilkaMediumTtf = `${ASSETS_DOMAIN}fonts/Silka-Medium/silka-medium-webfont.ttf`, SilkaSemiBoldEot = `${ASSETS_DOMAIN}fonts/Silka-SemiBold/silka-semibold-webfont.eot`, SilkaSemiBoldWoff2 = `${ASSETS_DOMAIN}fonts/Silka-SemiBold/silka-semibold-webfont.woff2`, SilkaSemiBoldWoff = `${ASSETS_DOMAIN}fonts/Silka-SemiBold/silka-semibold-webfont.woff`, SilkaSemiBoldTtf = `${ASSETS_DOMAIN}fonts/Silka-SemiBold/silka-semibold-webfont.ttf`, SilkaBoldEot = `${ASSETS_DOMAIN}fonts/Silka-Bold/silka-bold-webfont.eot`, SilkaBoldWoff2 = `${ASSETS_DOMAIN}fonts/Silka-Bold/silka-bold-webfont.woff2`, SilkaBoldWoff = `${ASSETS_DOMAIN}fonts/Silka-Bold/silka-bold-webfont.woff`, SilkaBoldTtf = `${ASSETS_DOMAIN}fonts/Silka-Bold/silka-bold-webfont.ttf`, ArboriaBookEot = `${ASSETS_DOMAIN}fonts/Arboria-Book/Arboria-Book.eot`, ArboriaBookWoff2 = `${ASSETS_DOMAIN}fonts/Arboria-Book/Arboria-Book.woff2`, ArboriaBookWoff = `${ASSETS_DOMAIN}fonts/Arboria-Book/Arboria-Book.woff`, ArboriaBookTtf = `${ASSETS_DOMAIN}fonts/Arboria-Book/Arboria-Book.ttf`, ArboriaBookSvg = `${ASSETS_DOMAIN}fonts/Arboria-Book/Arboria-Book.svg`, ArboriaBoldEot = `${ASSETS_DOMAIN}fonts/Arboria-Bold/Arboria-Bold.eot`, ArboriaBoldWoff2 = `${ASSETS_DOMAIN}fonts/Arboria-Bold/Arboria-Bold.woff2`, ArboriaBoldWoff = `${ASSETS_DOMAIN}fonts/Arboria-Bold/Arboria-Bold.woff`, ArboriaBoldTtf = `${ASSETS_DOMAIN}fonts/Arboria-Bold/Arboria-Bold.ttf`, ArboriaBoldSvg = `${ASSETS_DOMAIN}fonts/Arboria-Bold/Arboria-Bold.svg`, ArboriaMediumEot = `${ASSETS_DOMAIN}fonts/Arboria-Medium/Arboria-Medium.eot`, ArboriaMediumWoff2 = `${ASSETS_DOMAIN}fonts/Arboria-Medium/Arboria-Medium.woff2`, ArboriaMediumWoff = `${ASSETS_DOMAIN}fonts/Arboria-Medium/Arboria-Medium.woff`, ArboriaMediumTtf = `${ASSETS_DOMAIN}fonts/Arboria-Medium/Arboria-Medium.ttf`, ArboriaMediumSvg = `${ASSETS_DOMAIN}fonts/Arboria-Medium/Arboria-Medium.svg`, OpenSansRegularEot = `${ASSETS_DOMAIN}fonts/OpenSans-Regular/OpenSans-Regular.eot`, OpenSansRegularWoff2 = `${ASSETS_DOMAIN}fonts/OpenSans-Regular/OpenSans-Regular.woff2`, OpenSansRegularWoff = `${ASSETS_DOMAIN}fonts/OpenSans-Regular/OpenSans-Regular.woff`, OpenSansRegularTtf = `${ASSETS_DOMAIN}fonts/OpenSans-Regular/OpenSans-Regular.ttf`, OpenSansRegularSvg = `${ASSETS_DOMAIN}fonts/OpenSans-Regular/OpenSans-Regular.svg`, GlobalStyle = createGlobalStyle`
  //Legacy
  @font-face {
    font-family: 'OpenSans';
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
    src: url('${OpenSansRegularEot}'); /* IE9 Compat Modes */
    src: local('Open Sans Regular'), local('OpenSans-Regular'),
      url('${OpenSansRegularEot}?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url(${OpenSansRegularWoff2}) format('woff2'),
      /* Super Modern Browsers */ url(${OpenSansRegularWoff}) format('woff'),
      /* Modern Browsers */ url(${OpenSansRegularTtf}) format('truetype'),
      /* Safari, Android, iOS */ url('${OpenSansRegularSvg}#OpenSans') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Arboria';
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
    src: url('${ArboriaBookEot}'); /* IE9 Compat Modes */
    src: local('Arboria-Book'), local('Arboria-Book'),
      url('${ArboriaBookEot}?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url(${ArboriaBookWoff2}) format('woff2'),
      /* Super Modern Browsers */ url(${ArboriaBookWoff}) format('woff'),
      /* Modern Browsers */ url(${ArboriaBookTtf}) format('truetype'),
      /* Safari, Android, iOS */ url('${ArboriaBookSvg}#Arboria') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Arboria';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: url('${ArboriaMediumEot}'); /* IE9 Compat Modes */
    src: local('Arboria-Medium'), local('Arboria-Medium'),
      url('${ArboriaMediumEot}?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url(${ArboriaMediumWoff2}) format('woff2'),
      /* Super Modern Browsers */ url(${ArboriaMediumWoff}) format('woff'),
      /* Modern Browsers */ url(${ArboriaMediumTtf}) format('truetype'),
      /* Safari, Android, iOS */ url('${ArboriaMediumSvg}#ArboriaMedium') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Arboria';
    font-weight: bold;
    src: url('${ArboriaBoldEot}'); /* IE9 Compat Modes */
    src: local('Arboria-Bold'), local('Arboria-Bold'),
      url('${ArboriaBoldEot}?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url(${ArboriaBoldWoff2}) format('woff2'),
      /* Super Modern Browsers */ url(${ArboriaBoldWoff}) format('woff'),
      /* Modern Browsers */ url(${ArboriaBoldTtf}) format('truetype'),
      /* Safari, Android, iOS */ url('${ArboriaBoldSvg}#ArboriaBold') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Silka';
    src: url('${SilkaBoldEot}');
    src: url('${SilkaBoldEot}?#iefix') format('embedded-opentype'),
      url(${SilkaBoldWoff2}) format('woff2'), url(${SilkaBoldWoff}) format('woff'),
      url(${SilkaBoldTtf}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Silka';
    src: url('${SilkaSemiBoldEot}');
    src: url('${SilkaSemiBoldEot}?#iefix') format('embedded-opentype'),
      url(${SilkaSemiBoldWoff2}) format('woff2'), url(${SilkaSemiBoldWoff}) format('woff'),
      url(${SilkaSemiBoldTtf}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Silka';
    src: url('${SilkaMediumEot}');
    src: url('${SilkaMediumEot}?#iefix') format('embedded-opentype'),
      url(${SilkaMediumWoff2}) format('woff2'), url(${SilkaMediumWoff}) format('woff'),
      url(${SilkaMediumTtf}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Silka';
    src: url('${SilkaRegularEot}');
    src: url('${SilkaRegularEot}?#iefix') format('embedded-opentype'),
      url(${SilkaRegularWoff2}) format('woff2'), url(${SilkaRegularWoff}) format('woff'),
      url(${SilkaRegularTtf}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  body {
    &.not-overflow {
      overflow: hidden;
    }
  }
`, colorsLegacy = {
  black: "#1B1E21",
  white: "#FFFFFF",
  cyan: "#0075DB",
  // ---------------//
  green_1: "#397451",
  green_2: "#00B94B",
  green_3: "#00DC5A",
  green_4: "#99F1BD",
  green_5: "#C9EBD6",
  green_6: "#E0F7E9",
  green_7: "#F5F9F6",
  // ---------------//
  blue_1: "#2F2E46",
  blue_2: "#3D3A62",
  blue_3: "#848395",
  blue_4: "#C2C2CA",
  blue_5: "#E1E1E8",
  blue_6: "#F2F2F9",
  // ---------------//
  grey_1: "#F4F4F4",
  grey_2: "#5C6B7C",
  // ---------------//
  orange_1: "#DB9E00",
  orange_2: "#FFC01D",
  orange_3: "#FFF0A4",
  // ---------------//
  red_1: "#FF6060",
  red_2: "#EB9090",
  red_3: "#FACFCF",
  red_4: "#FFE7E7"
}, gradientsLegacy = {
  gold_gradient: "linear-gradient(180deg, #FFF38A 0%, #FFC700 100%)",
  green_gradient_1: "linear-gradient(180deg, #F4FEF9 25%, #99F3C3 100%)",
  green_gradient_2: "linear-gradient(270deg, #FFFFFF 2.62%, #E2FCEE 61.39%, #C4F8DC 102.31%)",
  green_blue_gradient: "linear-gradient(90deg, rgba(0,220,90,1) 0%, rgba(61,58,98,1) 100%)",
  grey_gradient: "linear-gradient(180deg, #E1E1E8 0%, #C2C2CA 100%)"
}, mediaQueries = {
  mobile_extra_small_width: "320px",
  mobile_small_width: "375px",
  mobile_medium_width: "425px",
  mobile_width: "600px",
  tablet_width: "768px",
  desktop_extra_small_width: "900px",
  desktop_small_witdh: "1024px",
  desktop_witdh: "1200px"
}, fontSizesLegacy = {
  xe: 70,
  enormus: 60,
  xb: 40,
  big: 34,
  xxl: 30,
  xl: 28,
  l: 24,
  xxm: 20,
  xm: 18,
  m: 16,
  s: 14,
  xs: 12,
  xxs: 10
}, buttonSizesLegacy = {
  xs: 60,
  small: 100,
  medium: 130,
  large: 270
}, dimensions = {
  dimension_01: "1px",
  dimension_02: "2px",
  dimension_03: "3px",
  dimension_04: "4px",
  dimension_08: "8px",
  dimension_10: "10px",
  dimension_12: "12px",
  dimension_14: "14px",
  dimension_16: "16px",
  dimension_18: "18px",
  dimension_20: "20px",
  dimension_22: "22px",
  dimension_24: "24px",
  dimension_32: "32px",
  dimension_40: "40px",
  dimension_48: "48px",
  dimension_64: "64px",
  dimension_72: "72px",
  dimension_80: "80px",
  dimension_96: "96px",
  dimension_112: "112px",
  dimension_128: "128px",
  dimension_240: "240px",
  dimension_320: "320px",
  dimension_375: "375px",
  dimension_425: "425px",
  dimension_480: "480px",
  dimension_600: "600px",
  dimension_768: "768px",
  dimension_900: "900px",
  dimension_1024: "1024px",
  dimension_1200: "1200px"
}, reference$1 = {
  brand: {
    dark_500: "#3d3a62",
    tax_500: "#0fd48e",
    tax_300: "#99f1bd"
  },
  extended: {
    grass_100: "#F3FBF9",
    grass_200: "#D0FBF2",
    grass_300: "#A8EBDE",
    grass_400: "#58DAC0",
    grass_500: "#0FB997",
    grass_600: "#0EA98A",
    grass_700: "#0C8D73",
    grass_800: "#0C8D73",
    grass_900: "#0A6654",
    sky_100: "#F6FBFE",
    sky_200: "#EEF7FD",
    sky_250: "#def1ff",
    sky_300: "#CDC9E2",
    sky_400: "#6B8CE1",
    sky_450: "#5E82D4",
    sky_500: "#5974D4",
    sky_600: "#536AC1",
    sky_700: "#4D63B2",
    sky_800: "#46589B",
    sky_900: "#3A4A83",
    sand_100: "#FFF5F5",
    sand_200: "#FFEDE9",
    sand_300: "#FFD9D1",
    sand_400: "#FFB09E",
    sand_500: "#FF7F63",
    sand_600: "#D75047",
    sand_700: "#B94927",
    sand_800: "#A04122",
    sand_900: "#883511"
  },
  neutral: {
    white: "#ffffff",
    moon_100: "#FBFBFB",
    moon_200: "#F7F7F7",
    moon_300: "#f3f3f3",
    moon_400: "#E6E6E6",
    moon_500: "#d9d9d9",
    moon_600: "#b4b4b4",
    moon_700: "#888",
    moon_800: "#555",
    moon_900: "#474747",
    moongreen_200: "#f5f9f6",
    moongreen_400: "#e2eae5"
  },
  gradients: {
    gradient_300: "linear-gradient(225deg, #eef7fd 0%, #dff8e9 72.42%)",
    gradient_500: "linear-gradient(225deg, #eef7fd 35.42%, #ffede9 100%)",
    gradient_700: "linear-gradient(225deg, #dff8e9 0%, #ffede9 70.39%)",
    iridiscent: "linear-gradient(45deg, #DFF8E9 0%, #EEF7FD 9.38%, #FFEDE9 16.15%, #EEF7FD 29.17%, #DFF8E9 46.88%, #EEF7FD 57.81%, #FFEDE9 65.63%, #EEF7FD 82.81%, #DFF8E9 96.88%)"
  },
  functional: {
    warning_100: "#FFFCF3",
    warning_200: "#FCF5DD",
    warning_300: "#F3E7BF",
    warning_400: "#ECD089",
    warning_450: "#E6BD56",
    warning_500: "#D9A31B",
    warning_600: "#B78815",
    warning_700: "#876101",
    warning_800: "#755401",
    warning_900: "#674B04",
    warning_550: "#B79746",
    danger_100: "#FFFAFA",
    danger_200: "#FFE9E5",
    danger_300: "#FFD6D0",
    danger_400: "#FEB5AF",
    danger_450: "#FE8C85",
    danger_500: "#FB6B62",
    danger_600: "#D75047",
    danger_700: "#BC3E36",
    danger_800: "#A63730",
    danger_900: "#8F2F29",
    danger_550: "#E0726B",
    success_100: "#F3FBF8",
    success_200: "#DFF6E8",
    success_300: "#C4E9D2",
    success_400: "#97DDBE",
    success_500: "#0FBA75",
    success_600: "#15A46A",
    success_700: "#1A8F60",
    success_800: "#207955",
    success_900: "#1B6546",
    success_480: "#19cc85",
    fds_ref_color_smooth_transition: "linear-gradient(180deg, rgba(135, 199, 159, 0.1) 0%, rgba(135, 199, 159, 0) 100%)",
    darken_600: "rgba(100,100,110,0.6)",
    darken_700: "rgba(100,100,110,0.95)"
  },
  weight_300: "300",
  weight_400: "400",
  weight_500: "500",
  weight_600: "600",
  weight_700: "700",
  plans: {
    basic_100: "#FBFBFD",
    basic_200: "#F6F6F9",
    basic_300: "#F1F1F4",
    basic_400: "#DFDFE9",
    basic_450: "#E6E6EA",
    basic_500: "#C3C3CD",
    basic_600: "#ACACB9",
    basic_700: "#93939F",
    basic_800: "#83838A",
    basic_900: "#727279",
    basic_gradient_alpha: "linear-gradient(90deg, rgba(234, 234, 234, 0.00) 0%, #C7C7C7 100%)",
    basic_gradient: "linear-gradient(180deg, #f0f0f0 0%, #83838A 100%)",
    pro_100: "#F7F9FC",
    pro_200: "#F1F3FA",
    pro_300: "#E4E8F7",
    pro_400: "#DDE6FF",
    pro_450: "#D4DFFC",
    pro_500: "#C8D1EB",
    pro_600: "#B4C0E4",
    pro_700: "#8EA1D7",
    pro_800: "#7486BC",
    pro_900: "#5E72B1",
    pro_gradient_alpha: "linear-gradient(90deg, rgba(212, 227, 226, 0) 0%, #8290C1 100%)",
    pro_gradient: "linear-gradient(180deg, #DDE6FF 0.81%, #8290C1 99.85%)",
    live_100: "#FCF6F2",
    live_200: "#FAEFE8",
    live_300: "#F9E7DC",
    live_400: "#FFE1D0",
    live_450: "#FCDCCA",
    live_500: "#FCD8CA",
    live_600: "#F3CCC4",
    live_700: "#D6A8AC",
    live_800: "#B17986",
    live_900: "#A76877",
    live_gradient_alpha: "linear-gradient(90deg, rgba(255, 225, 208, 0) 0%, #B27E7B 99%)",
    live_gradient: "linear-gradient(180deg, #FFE1D0 0%, #B27E7B 100%)",
    expert_100: "#F3FAFC",
    expert_200: "#EBF8FA",
    expert_300: "#DCF6F9",
    expert_400: "#CCF3FB",
    expert_450: "#C2ECF4",
    expert_500: "#BCE7F0",
    expert_600: "#A1DCE8",
    expert_700: "#72BCCB",
    expert_800: "#6FA3AF",
    expert_900: "#5E8C97",
    expert_gradient_alpha: "linear-gradient(270deg, #558691 0%, rgba(85, 134, 145, 0.00) 100%)",
    expert_gradient: "linear-gradient(180deg, #D0F7FF 0%, #7BA8B2 100%)",
    full_100: "#F8F5ED",
    full_200: "#F4F0E4",
    full_300: "#F9EABE",
    full_400: "#FAE6A3",
    full_450: "#F1DE9D",
    full_500: "#EBD594",
    full_600: "#D6C58F",
    full_700: "#B3A475",
    full_800: "#AB9163",
    full_900: "#977F53",
    full_gradient_alpha: "linear-gradient(90deg, rgba(255, 241, 191, 0) 0%, #AB9163 99%)",
    full_gradient: "linear-gradient(180deg, #FFF1BF 0%, #DABA7C 100%)"
  },
  lineheight_100: "100%",
  lineheight_110: "110%",
  lineheight_120: "120%",
  lineheight_130: "130%",
  lineheight_140: "140%",
  lineheight_150: "150%",
  lineheight_160: "160%",
  lineheight_170: "170%",
  lineheight_180: "180%",
  lineheight_200: "200%",
  ...dimensions,
  Silka: '"Silka"',
  breakpoints: {
    MOBILE_EXTRA_SMALL_WIDTH: dimensions.dimension_320,
    MOBILE_SMALL_WIDTH: dimensions.dimension_375,
    MOBILE_MEDIUM_WIDTH: dimensions.dimension_425,
    MOBILE_WIDTH: dimensions.dimension_600,
    TABLET_WIDTH: dimensions.dimension_768,
    DESKTOP_EXTRA_SMALL_WIDTH: dimensions.dimension_900,
    DESKTOP_SMALL_WIDTH: dimensions.dimension_1024,
    DESKTOP_WIDTH: dimensions.dimension_1200
  },
  hex_opacity_10: "1A",
  hex_opacity_20: "33",
  hex_opacity_30: "4C",
  hex_opacity_40: "66",
  hex_opacity_50: "7F",
  hex_opacity_60: "99",
  hex_opacity_70: "B2",
  hex_opacity_80: "CC",
  hex_opacity_90: "E5"
}, system = {
  fds_sys_borderradius_XS: reference$1.dimension_02,
  fds_sys_borderradius_S: reference$1.dimension_04,
  fds_sys_borderradius_M: reference$1.dimension_08,
  fds_sys_borderradius_L: reference$1.dimension_16,
  fds_sys_borderradius_XL: reference$1.dimension_24,
  fds_sys_borderradius_O: reference$1.dimension_240,
  fds_sys_weight_XS: reference$1.weight_300,
  fds_sys_weight_S: reference$1.weight_400,
  fds_sys_weight_M: reference$1.weight_500,
  fds_sys_weight_L: reference$1.weight_600,
  fds_sys_weight_XL: reference$1.weight_700,
  fds_sys_elevation_S: {
    x: "0",
    y: reference$1.dimension_02,
    blur: reference$1.dimension_04,
    spread: "0",
    color: "rgba(0,0,0,0.15)",
    type: "dropShadow"
  },
  fds_sys_elevation_M: {
    x: "0",
    y: reference$1.dimension_04,
    blur: reference$1.dimension_08,
    spread: "0",
    color: "rgba(0,0,0,0.15)",
    type: "dropShadow"
  },
  fds_sys_elevation_L: {
    x: "0",
    y: reference$1.dimension_08,
    blur: reference$1.dimension_16,
    spread: "0",
    color: "rgba(0,0,0,0.15)",
    type: "dropShadow"
  },
  fds_sys_borderwidth_none: "0",
  fds_sys_borderwidth_S: reference$1.dimension_01,
  fds_sys_borderwidth_M: reference$1.dimension_02,
  fds_sys_borderwidth_L: reference$1.dimension_03,
  fds_sys_decoration_linethrough: "line-through",
  fds_sys_decoration_underline: "underline",
  fds_sys_decoration_none: "none",
  fds_sys_textcase_upper: "uppercase",
  fds_sys_embed_S: {
    x: "0",
    y: reference$1.dimension_02,
    blur: reference$1.dimension_04,
    spread: "0",
    color: "rgba(0,0,0,0.32)",
    type: "innerShadow"
  },
  fds_sys_embed_M: {
    x: "0",
    y: reference$1.dimension_04,
    blur: reference$1.dimension_04,
    spread: "0",
    color: "rgba(0,0,0,0.24)",
    type: "innerShadow"
  },
  fds_sys_embed_L: {
    x: "0",
    y: reference$1.dimension_08,
    blur: reference$1.dimension_16,
    spread: "0",
    color: "rgba(0,0,0,0.24)",
    type: "innerShadow"
  },
  fds_sys_spacing_none: "0",
  fds_sys_spacing_XXS: reference$1.dimension_04,
  fds_sys_spacing_XS: reference$1.dimension_08,
  fds_sys_spacing_S: reference$1.dimension_16,
  fds_sys_spacing_M: reference$1.dimension_24,
  fds_sys_spacing_L: reference$1.dimension_32,
  fds_sys_spacing_XL: reference$1.dimension_40,
  fds_sys_spacing_XXL: reference$1.dimension_48,
  fds_sys_spacing_wide_XXS: reference$1.dimension_64,
  fds_sys_spacing_wide_XS: reference$1.dimension_80,
  fds_sys_spacing_wide_S: reference$1.dimension_128,
  fds_sys_spacing_wide_M: reference$1.dimension_240,
  fds_sys_spacing_wide_L: reference$1.dimension_320,
  fds_sys_spacing_wide_XL: reference$1.dimension_375,
  fds_sys_sizing_none: "0",
  fds_sys_sizing_XXS: reference$1.dimension_08,
  fds_sys_sizing_XS: reference$1.dimension_16,
  fds_sys_sizing_S: reference$1.dimension_24,
  fds_sys_sizing_M: reference$1.dimension_32,
  fds_sys_sizing_L: reference$1.dimension_40,
  fds_sys_sizing_XL: reference$1.dimension_48,
  fds_sys_sizing_XXL: reference$1.dimension_64,
  fds_sys_XS: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_500,
    "font-size": reference$1.dimension_12
  },
  fds_sys_S: {
    "font-weight": reference$1.weight_500,
    "font-size": reference$1.dimension_14,
    "font-family": reference$1.Silka
  },
  fds_sys_M: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_500,
    "font-size": reference$1.dimension_16
  },
  fds_sys_L: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_500,
    "font-size": reference$1.dimension_18
  },
  fds_sys_XL: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_500,
    "font-size": reference$1.dimension_22
  },
  fds_sys_H_XS: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_700,
    "font-size": reference$1.dimension_24
  },
  fds_sys_H_S: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_700,
    "font-size": reference$1.dimension_32
  },
  fds_sys_H_M: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_700,
    "font-size": reference$1.dimension_48
  },
  fds_sys_H_L: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_700,
    "font-size": reference$1.dimension_64
  },
  fds_sys_H_XL: {
    "font-family": reference$1.Silka,
    "font-weight": reference$1.weight_700,
    "font-size": reference$1.dimension_80
  },
  text: {
    fds_sys_color_text_primary: reference$1.brand.dark_500,
    fds_sys_color_text_primary_inverse: reference$1.neutral.white,
    fds_sys_color_text_secondary: reference$1.neutral.moon_700,
    fds_sys_color_text_placeholder: reference$1.neutral.moon_600,
    fds_sys_color_text_danger: reference$1.functional.danger_500,
    fds_sys_color_text_danger_strong: reference$1.functional.danger_550,
    fds_sys_color_text_danger_stronger: reference$1.functional.danger_700,
    fds_sys_color_text_warning: reference$1.functional.warning_500,
    fds_sys_color_text_warning_strong: reference$1.functional.warning_550,
    fds_sys_color_text_warning_stronger: reference$1.functional.warning_700,
    fds_sys_color_text_success: reference$1.functional.success_500,
    fds_sys_color_text_success_stronger: reference$1.functional.success_800
  },
  accent: {
    fds_sys_color_accent_cold: reference$1.extended.sky_500,
    fds_sys_color_accent_fresh: reference$1.extended.grass_500,
    fds_sys_color_accent_warm: reference$1.extended.sand_500
  },
  background: {
    fds_sys_color_background_primary: reference$1.neutral.white,
    fds_sys_color_background_primary_inverse: reference$1.brand.dark_500,
    fds_sys_color_background_secondary: reference$1.neutral.moongreen_200,
    fds_sys_color_background_tertiary: reference$1.neutral.moon_300,
    fds_sys_color_background_supersoft: reference$1.neutral.moon_100,
    fds_sys_color_background_hover: reference$1.neutral.white,
    fds_sys_color_background_cold: reference$1.extended.sky_200,
    fds_sys_color_background_fresh: reference$1.extended.grass_200,
    fds_sys_color_background_warm: reference$1.extended.sand_200,
    fds_sys_color_background_selected: reference$1.gradients.iridiscent,
    fds_sys_color_background_error: reference$1.functional.danger_100,
    fds_sys_color_background_error_strong: reference$1.functional.danger_200,
    fds_sys_color_background_warning: reference$1.functional.warning_100,
    fds_sys_color_background_warning_strong: reference$1.functional.warning_200,
    fds_sys_color_background_success: reference$1.extended.grass_100,
    fds_sys_color_background_success_strong: reference$1.functional.success_200,
    fds_sys_color_background_gradient_A: reference$1.gradients.gradient_300,
    fds_sys_color_background_gradient_B: reference$1.gradients.gradient_500,
    fds_sys_color_background_gradient_C: reference$1.gradients.gradient_700,
    fds_sys_color_skeleton: reference$1.neutral.moon_300,
    fds_sys_color_skeleton_strong: reference$1.neutral.moon_400,
    fds_sys_color_blur_M: "rgba(255,255,255,0.7)"
  },
  border: {
    fds_sys_color_border_primary: reference$1.neutral.moon_500,
    fds_sys_color_border_primary_inverse: reference$1.brand.dark_500,
    fds_sys_color_border_secondary: reference$1.neutral.moon_300,
    fds_sys_color_border_tertiary: reference$1.neutral.moon_700,
    fds_sys_color_border_light: reference$1.neutral.white,
    fds_sys_color_border_error: reference$1.functional.danger_500,
    fds_sys_color_border_warning: reference$1.functional.warning_500,
    fds_sys_color_border_success: reference$1.functional.success_500
  },
  global: {
    fds_sys_color_transparent: "transparent",
    fds_sys_color_darker: reference$1.functional.darken_600
  },
  zIndex: {
    fds_sys_zindex_default: "0",
    fds_sys_zindex_highlighted: "100",
    fds_sys_zindex_navigation: "200",
    fds_sys_zindex_overlay: "300",
    fds_sys_zindex_notice: "400",
    fds_sys_zindex_transitions: "500"
  },
  easings: {
    fds_sys_ease_default: "cubic-bezier(0.8,0,0.2,1)",
    fds_sys_ease_basic: "cubic-bezier(0.5,0,0.5,1)",
    fds_sys_ease_soft_in: "cubic-bezier(0.8,0,1,1)",
    fds_sys_ease_soft_out: "cubic-bezier(0,0,0.2,1)",
    fds_sys_ease_elastic_in_S: "cubic-bezier(0,-0.2,0.2,1)",
    fds_sys_ease_elastic_in_M: "cubic-bezier(0,-0.4,0.2,1)",
    fds_sys_ease_elastic_in_L: "cubic-bezier(0,-0.8,0.2,1)",
    fds_sys_ease_elastic_in_XL: "cubic-bezier(0,-1,0.2,1)",
    fds_sys_ease_elastic_out_S: "cubic-bezier(0,0,0.2,1.2)",
    fds_sys_ease_elastic_out_M: "cubic-bezier(0,0,0.2,1.4)",
    fds_sys_ease_elastic_out_L: "cubic-bezier(0,0,0.2,1.8)",
    fds_sys_ease_elastic_out_XL: "cubic-bezier(0,0,0.2,2)"
  },
  fds_sys_lineheight_XS: reference$1.lineheight_100,
  fds_sys_lineheight_S: reference$1.lineheight_110,
  fds_sys_lineheight_M: reference$1.lineheight_120,
  fds_sys_lineheight_L: reference$1.lineheight_140,
  fds_sys_lineheight_XL: reference$1.lineheight_180,
  plans: {
    fds_sys_color_plan_basic_primary: reference$1.plans.basic_800,
    fds_sys_color_plan_basic_secondary: reference$1.plans.basic_300,
    fds_sys_color_plan_basic_tertiary: reference$1.plans.basic_200,
    fds_sys_color_plan_basic_quaternary: reference$1.plans.basic_500,
    fds_sys_color_plan_pro_primary: reference$1.plans.pro_800,
    fds_sys_color_plan_pro_secondary: reference$1.plans.pro_400,
    fds_sys_color_plan_pro_tertiary: reference$1.plans.pro_200,
    fds_sys_color_plan_pro_quaternary: reference$1.plans.pro_500,
    fds_sys_color_plan_live_primary: reference$1.plans.live_800,
    fds_sys_color_plan_live_secondary: reference$1.plans.live_400,
    fds_sys_color_plan_live_tertiary: reference$1.plans.live_200,
    fds_sys_color_plan_live_quaternary: reference$1.plans.live_500,
    fds_sys_color_plan_full_primary: reference$1.plans.full_800,
    fds_sys_color_plan_full_secondary: reference$1.plans.full_400,
    fds_sys_color_plan_full_tertiary: reference$1.plans.full_200,
    fds_sys_color_plan_full_quaternary: reference$1.plans.full_500,
    fds_sys_color_plan_expert_primary: reference$1.plans.expert_800,
    fds_sys_color_plan_expert_secondary: reference$1.plans.expert_400,
    fds_sys_color_plan_expert_tertiary: reference$1.plans.expert_200,
    fds_sys_color_plan_expert_quaternary: reference$1.plans.expert_500
  },
  fds_sys_disabled_opacity_XXS: "0.2",
  fds_sys_disabled_opacity_XS: "0.3",
  fds_sys_disabled_opacity_S: "0.4",
  fds_sys_disabled_opacity_M: "0.5",
  fds_sys_disabled_opacity_L: "0.6",
  fds_sys_disabled_opacity_XL: "0.7",
  fds_sys_disabled_opacity_XXL: "0.8",
  fds_c_blur_light_background: {
    fill: "rgba(255,255,255,0.6)",
    "background-blur": reference$1.dimension_08
  },
  animations: {
    fds_sys_animation_shake: "@keyframes shake { 0% { transform: none; } 25% { transform: translateX(-50%); } 50% { transform: translateX(50%); } 75% { transform: translateX(-50%); } 100% { transform: none; }}"
  }
}, text$1 = {
  fds_forms_input_label: reference$1.dimension_16,
  fds_c_text_styled_text: {
    "font-weight": reference$1.weight_600,
    "font-family": reference$1.Silka,
    "font-size": reference$1.dimension_12
  },
  fds_c_text_dark: reference$1.brand.dark_500,
  fds_c_text_light: system.text.fds_sys_color_text_primary_inverse,
  fds_c_text_grey: system.text.fds_sys_color_text_secondary,
  fds_c_text_accent_fresh: system.accent.fds_sys_color_accent_fresh,
  fds_c_text_accent_cold: system.accent.fds_sys_color_accent_cold,
  fds_c_text_warning_strong: system.text.fds_sys_color_text_warning_stronger,
  fds_c_text_danger_strong: system.text.fds_sys_color_text_danger_stronger,
  fds_c_text_success_strong: system.text.fds_sys_color_text_success_stronger
}, textColors = {
  dark: reference$1.brand.dark_500,
  light: system.text.fds_sys_color_text_primary_inverse,
  grey: system.text.fds_sys_color_text_secondary,
  fresh: system.accent.fds_sys_color_accent_fresh,
  cold: system.accent.fds_sys_color_accent_cold,
  warning_strong: system.text.fds_sys_color_text_warning_stronger,
  danger_strong: system.text.fds_sys_color_text_danger_stronger,
  success_strong: system.text.fds_sys_color_text_success_stronger
}, components$1 = {
  buttons: {
    fds_c_bottomnav_icon_size: reference$1.dimension_48,
    fds_c_icon_S: reference$1.dimension_16,
    fds_c_icon_M: reference$1.dimension_24,
    fds_c_icon_L: reference$1.dimension_32,
    fds_c_button_bottomnav_borderwidth: system.fds_sys_borderwidth_M,
    fds_c_classic_height_XS: system.fds_sys_sizing_S,
    fds_c_classic_height_S: system.fds_sys_sizing_M,
    fds_c_classic_height_M: system.fds_sys_sizing_L,
    fds_c_classic_height_L: system.fds_sys_sizing_XL,
    fds_c_classic_height_XL: system.fds_sys_sizing_XL,
    fds_c_contextual_height: system.fds_sys_sizing_XS,
    fds_c_button_text_XS: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_12,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_button_text_S: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_14
    },
    fds_c_button_text_M: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_14,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_button_text_L: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_16,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_button_skeleton_text_radius: system.fds_sys_borderradius_S,
    fds_c_button_contextual_radius: system.fds_sys_borderradius_O,
    fds_c_button_padding_horizontal_XS: reference$1.dimension_16,
    fds_c_button_gap_XS: reference$1.dimension_08,
    fds_c_button_padding_horizontal_S: reference$1.dimension_08,
    fds_c_button_gap_S: reference$1.dimension_08,
    fds_c_button_padding_horizontal_M: reference$1.dimension_08,
    fds_button_c_gap_M: reference$1.dimension_08,
    fds_c_button_padding_horizontal_L: reference$1.dimension_08,
    fds_c_button_gap_L: reference$1.dimension_08,
    fds_c_button_padding_horizontal_XL: reference$1.dimension_08,
    fds_c_button_gap_XL: reference$1.dimension_08,
    fds_c_button_padding_horizontal_XXS: "0px",
    fds_c_button_gap_XXS: reference$1.dimension_08,
    fds_c_button_contextual_horizontal_padding: reference$1.dimension_08,
    fds_c_button_contextual: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_XL,
      "font-size": reference$1.dimension_10
    },
    fds_c_button_classic_radius: system.fds_sys_borderradius_O,
    fds_c_button_floating_padding: reference$1.dimension_16,
    fds_c_button_floating_gap: reference$1.dimension_16,
    fds_c_button_navbarbutton_gap: reference$1.dimension_02,
    fds_c_button_bottomnav_gap: reference$1.dimension_08,
    fds_c_button_topbar: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_12,
      "line-height": reference$1.lineheight_110
    },
    fds_c_topbarbutton_icon: reference$1.dimension_16,
    fds_c_button_tiny_underline_height: reference$1.dimension_02,
    fds_c_button_bottomnav_text: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_XL,
      "font-size": reference$1.dimension_14
    },
    fds_c_button_sticky_padding: reference$1.dimension_16,
    fds_c_button_sticky_padding_pill: reference$1.dimension_08,
    fds_c_button_sticky_gap: reference$1.dimension_16,
    fds_c_sticky_background_blur: reference$1.dimension_08,
    fds_c_bottomnav_color: system.text.fds_sys_color_text_primary,
    fds_c_bottomnav_color_arrow_active: system.text.fds_sys_color_text_primary_inverse,
    fds_c_button_success_primary: reference$1.functional.success_500,
    fds_c_button_success_primary_hover: reference$1.functional.success_480,
    fds_c_button_success_secondary: reference$1.functional.success_200,
    fds_c_button_success_secondary_hover: reference$1.functional.success_300,
    fds_c_button_success_tertiary: reference$1.functional.success_700,
    fds_c_button_warning_primary: reference$1.functional.warning_500,
    fds_c_button_warning_primary_hover: reference$1.functional.warning_450,
    fds_c_button_warning_secondary: reference$1.functional.warning_200,
    fds_c_button_warning_secondary_hover: reference$1.functional.warning_300,
    fds_c_button_warning_tertiary: reference$1.functional.warning_700,
    fds_c_button_danger_primary: reference$1.functional.danger_500,
    fds_c_button_danger_primary_hover: reference$1.functional.danger_450,
    fds_c_button_danger_secondary: reference$1.functional.danger_200,
    fds_c_button_danger_secondary_hover: reference$1.functional.danger_300,
    fds_c_button_danger_tertiary: reference$1.functional.danger_700,
    fds_c_button_secondary: system.background.fds_sys_color_background_cold,
    fds_c_button_secondary_hover: reference$1.extended.sky_250,
    fds_c_button_background_light: system.background.fds_sys_color_background_primary,
    fds_c_button_background_light_hover: reference$1.neutral.moon_300,
    fds_c_button_cold: reference$1.extended.sky_500,
    fds_c_button_cold_hover: reference$1.extended.sky_450,
    fds_c_button_background_dark: system.background.fds_sys_color_background_primary_inverse,
    fds_c_button_background_dark_hover: reference$1.extended.sky_900,
    fds_c_button_background_plan_basic_dark: system.plans.fds_sys_color_plan_basic_primary,
    fds_c_button_background_plan_basic_dark_hover: reference$1.plans.basic_700,
    fds_c_button_background_plan_basic_light: system.plans.fds_sys_color_plan_basic_secondary,
    fds_c_button_background_plan_basic_light_hover: reference$1.plans.basic_450,
    fds_c_button_background_plan_pro_dark: system.plans.fds_sys_color_plan_pro_primary,
    fds_c_button_background_plan_pro_dark_hover: reference$1.plans.pro_700,
    fds_c_button_background_plan_pro_light: system.plans.fds_sys_color_plan_pro_secondary,
    fds_c_button_background_plan_pro_light_hover: reference$1.plans.pro_500,
    fds_c_button_background_plan_live_dark: system.plans.fds_sys_color_plan_live_primary,
    fds_c_button_background_plan_live_dark_hover: reference$1.plans.live_700,
    fds_c_button_background_plan_live_light: system.plans.fds_sys_color_plan_live_secondary,
    fds_c_button_background_plan_live_light_hover: reference$1.plans.live_500,
    fds_c_button_background_plan_expert_dark: system.plans.fds_sys_color_plan_expert_primary,
    fds_c_button_background_plan_expert_dark_hover: reference$1.plans.expert_700,
    fds_c_button_background_plan_expert_light: system.plans.fds_sys_color_plan_expert_secondary,
    fds_c_button_background_plan_expert_light_hover: reference$1.plans.expert_500,
    fds_c_button_background_plan_full_dark: system.plans.fds_sys_color_plan_full_primary,
    fds_c_button_background_plan_full_dark_hover: reference$1.plans.full_700,
    fds_c_button_background_plan_full_light: system.plans.fds_sys_color_plan_full_secondary,
    fds_c_button_background_plan_full_light_hover: reference$1.plans.full_450,
    fds_c_button_light_text: reference$1.neutral.white,
    fds_c_button_text_dark: reference$1.brand.dark_500,
    fds_c_button_tiny_underline_radius: reference$1.dimension_02,
    fds_c_button_tiny_underline_ease: system.easings.fds_sys_ease_default
  },
  fds_forms_input_text: reference$1.dimension_16,
  fds_forms_input_numeric: reference$1.dimension_20,
  inputs: {
    fds_c_input_focus: system.fds_sys_embed_M,
    fds_c_input_focus_error: {
      x: "0",
      y: "4px",
      blur: "4px",
      spread: "0",
      color: `${reference$1.functional.danger_800}${reference$1.hex_opacity_40}`,
      type: "innerShadow"
    },
    fds_c_input_focus_warning: {
      x: "0",
      y: "4px",
      blur: "4px",
      spread: "0",
      color: `${reference$1.functional.warning_800}${reference$1.hex_opacity_40}`,
      type: "innerShadow"
    },
    fds_c_input_header_label: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_16,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_input_color_accent: system.accent.fds_sys_color_accent_cold,
    fds_c_input_color_accent_background: system.background.fds_sys_color_background_cold,
    fds_c_input_color_background: system.background.fds_sys_color_background_primary,
    fds_c_input_color_background_focus: reference$1.neutral.moon_200,
    fds_c_input_color_background_textarea: system.global.fds_sys_color_transparent,
    fds_c_input_switch_background_off: reference$1.neutral.moon_500,
    fds_c_input_switch_background_on: system.accent.fds_sys_color_accent_fresh,
    fds_c_input_color_selected: system.background.fds_sys_color_background_supersoft,
    fds_c_input_tick_color_selected: system.accent.fds_sys_color_accent_fresh,
    fds_c_input_card_selected: system.fds_sys_embed_M,
    fds_c_input_card_hovered: system.fds_sys_elevation_M,
    fds_c_input_optional_label: {
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_14,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_M
    },
    fds_c_input_cards: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_16
    },
    fds_c_input_bordercolor: system.border.fds_sys_color_border_primary,
    fds_c_input_bordercolor_selected: system.border.fds_sys_color_border_light,
    fds_c_input_bordercolor_strong: system.border.fds_sys_color_border_primary_inverse,
    fds_c_input_bordercolor_option_selected: system.accent.fds_sys_color_accent_cold,
    fds_c_input_infobtn_color: system.border.fds_sys_color_border_primary_inverse,
    fds_c_input_optional_selected: system.accent.fds_sys_color_accent_cold,
    fds_c_input_optional_extra_background: system.background.fds_sys_color_background_primary,
    fds_c_input_default_borderwidth: system.fds_sys_borderwidth_S,
    fds_c_input_optionals_borderwidth: system.fds_sys_borderwidth_M,
    fds_c_input_textarea_padding_M: system.fds_sys_spacing_S,
    fds_c_input_textarea_padding_S: system.fds_sys_spacing_XS,
    fds_c_input_textarea_gap_M: system.fds_sys_spacing_S,
    fds_c_input_uploader_background: system.background.fds_sys_color_background_primary,
    fds_c_input_uploader_padding: system.fds_sys_spacing_XS,
    fds_c_input_uploader_message_padding_horizonal: system.fds_sys_spacing_XS,
    fds_c_input_uploader_gap: system.fds_sys_spacing_XS,
    fds_c_input_text_color_success: system.text.fds_sys_color_text_success_stronger,
    fds_c_input_text_color_error: system.text.fds_sys_color_text_danger_stronger,
    fds_c_nps_range_guide: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_12
    },
    fds_c_input_sectionheader_padding_M: system.fds_sys_spacing_S,
    fds_c_input_header_description: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_12,
      "line-height": system.fds_sys_lineheight_L
    },
    fds_c_input_content: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_14
    },
    fds_c_input_bigger: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_18
    },
    fds_c_section_header: {
      "letter-spacing": "4%",
      "font-weight": system.fds_sys_weight_XL,
      "text-case": "UPPERCASE",
      "font-size": reference$1.dimension_16,
      "font-family": reference$1.Silka
    },
    fds_c_input_default_gap: reference$1.dimension_08,
    fds_c_input_mandatory_text: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "line-height": system.fds_sys_lineheight_M,
      "font-size": reference$1.dimension_08,
      "letter-spacing": "12%"
    },
    fds_c_input_switcher_embed: {
      x: "0",
      y: "1px",
      blur: "1px",
      spread: "0",
      color: "rgba(0,0,0,0.24)",
      type: "innerShadow"
    },
    fds_c_input_switcher_elevated: system.fds_sys_elevation_S
  },
  fds_forms_input_label: reference$1.dimension_16,
  fds_forms_contextualhelp: reference$1.dimension_10,
  text: {
    fds_c_text_styled_text: {
      "font-weight": reference$1.weight_600,
      "font-family": reference$1.Silka,
      "font-size": reference$1.dimension_12
    },
    fds_c_text_dark: reference$1.brand.dark_500,
    fds_c_text_light: system.text.fds_sys_color_text_primary_inverse,
    fds_c_text_grey: system.text.fds_sys_color_text_secondary,
    fds_c_text_accent_fresh: system.accent.fds_sys_color_accent_fresh,
    fds_c_text_accent_cold: system.accent.fds_sys_color_accent_cold,
    fds_c_text_warning_strong: system.text.fds_sys_color_text_warning_stronger,
    fds_c_text_danger_strong: system.text.fds_sys_color_text_danger_stronger,
    fds_c_text_success_strong: system.text.fds_sys_color_text_success_stronger
  },
  avatar: {
    fds_c_avatar_size: reference$1.dimension_64,
    fds_c_avatar_borderwidth: system.fds_sys_borderwidth_S,
    fds_c_avatar_color_border: system.border.fds_sys_color_border_primary,
    fds_c_avatar_color_border_light: reference$1.neutral.white,
    fds_c_avatar_color_background: system.background.fds_sys_color_background_secondary,
    fds_c_avatar_color_background_error: system.background.fds_sys_color_background_error_strong,
    fds_c_avatar_color_border_error: system.border.fds_sys_color_border_error,
    fds_c_avatar_color_background_warning: system.background.fds_sys_color_background_warning_strong,
    fds_c_avatar_color_border_warning: system.border.fds_sys_color_border_warning
  },
  chips: {
    fds_c_chips_color_default: reference$1.brand.dark_500,
    fds_c_chips_color_cold: system.accent.fds_sys_color_accent_cold,
    fds_c_chips_color_cold_shaded: system.background.fds_sys_color_background_cold,
    fds_c_chips_color_light: reference$1.neutral.white,
    fds_c_chip_default_radius: system.fds_sys_borderradius_S,
    fds_c_chips_text_S: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "font-size": reference$1.dimension_10
    },
    fds_c_chips_text_M: {
      "font-family": reference$1.Silka,
      "font-size": reference$1.dimension_12,
      "font-weight": system.fds_sys_weight_L
    },
    fds_c_chips_text_L: {
      "font-family": reference$1.Silka,
      "font-size": reference$1.dimension_14,
      "font-weight": system.fds_sys_weight_L
    },
    fds_c_chips_padding_horizontal_XS: reference$1.dimension_04,
    fds_c_chips_padding_horizontal_S: reference$1.dimension_08,
    fds_c_chips_padding_vertical_XS: "0",
    fds_c_chips_padding_vertical_S: reference$1.dimension_04,
    fds_c_chips_gap_S: reference$1.dimension_04,
    fds_c_chips_padding_horizontal_M: reference$1.dimension_08,
    fds_c_chips_padding_vertical_M: reference$1.dimension_04,
    fds_c_chips_gap_M: reference$1.dimension_04,
    fds_c_chips_padding_horizontal_L: reference$1.dimension_16,
    fds_c_chips_padding_vertical_L: reference$1.dimension_08,
    fds_c_chips_gap_L: reference$1.dimension_08,
    fds_c_height_S: reference$1.dimension_16,
    fds_c_height_M: reference$1.dimension_24,
    fds_c_height_L: reference$1.dimension_32,
    fds_c_chips_color_neutral: reference$1.neutral.moon_700,
    fds_c_chips_color_neutral_shaded: reference$1.neutral.moon_200,
    fds_c_chips_color_warning: reference$1.functional.warning_550,
    fds_c_chips_color_warning_shaded: system.background.fds_sys_color_background_warning,
    fds_c_chips_color_danger: reference$1.functional.danger_550,
    fds_c_chips_color_danger_shaded: system.background.fds_sys_color_background_error,
    fds_c_chips_color_success: reference$1.functional.success_700,
    fds_c_chips_color_success_shaded: system.background.fds_sys_color_background_success,
    fds_c_chip_default_width: system.fds_sys_borderwidth_S
  },
  loader: {
    fds_c_loader_text: {
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_14,
      "font-family": reference$1.Silka
    },
    fds_c_loader_padding: system.fds_sys_spacing_S,
    fds_c_loader_gap: system.fds_sys_spacing_S,
    fds_c_loader_color_text: system.text.fds_sys_color_text_primary,
    fds_c_loader_color_background_fullscreen: system.background.fds_sys_color_background_selected,
    fds_c_loader_color_skeleton: "rgba(180,180,180,0.4)"
  },
  cells: {
    fds_c_table_cell_color_text: system.text.fds_sys_color_text_primary,
    fds_c_table_cell_color_text_success: system.text.fds_sys_color_text_success,
    fds_c_table_cell_color_text_warning: system.text.fds_sys_color_text_warning,
    fds_c_table_cell_color_text_danger: system.text.fds_sys_color_text_danger,
    fds_c_table_cell_color_border_default: system.border.fds_sys_color_border_primary,
    fds_c_table_cell_color_background_header: system.background.fds_sys_color_background_secondary,
    fds_c_table_cell_color_background_default: system.background.fds_sys_color_background_primary,
    fds_c_table_cell_header_label: {
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_14,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_table_cell_label: system.fds_sys_S,
    fds_c_table_cell_padding: system.fds_sys_spacing_XS,
    fds_c_table_cell_gap: system.fds_sys_spacing_XS,
    fds_c_tableviewcell_gap_S: system.fds_sys_spacing_XS,
    fds_c_tableviewcell_gap_M: system.fds_sys_spacing_S,
    fds_c_cell_selected: system.fds_sys_embed_S,
    fds_c_cells_subitem_hover_translate: reference$1.dimension_04,
    fds_c_tableviewcell_spacing_S: reference$1.dimension_08,
    fds_c_subcell_background_color_selected: system.background.fds_sys_color_background_primary,
    fds_c_subcell_subitem_background_color_hover: "rgba(255,255,255,0.6)",
    fds_c_cells_border_color: system.border.fds_sys_color_border_primary,
    fds_c_cells_border_color_selected: system.border.fds_sys_color_border_light,
    fds_c_cells_border_color_hover: reference$1.neutral.white,
    fds_c_cells_background_color_selected: system.background.fds_sys_color_background_secondary,
    fds_c_cells_subitem_radius: system.fds_sys_borderradius_S,
    fds_c_tableviewcell_spacing_M: reference$1.dimension_16,
    fds_c_tableviewcell_spacing_L: reference$1.dimension_24,
    fds_c_subcell_selected: system.fds_sys_elevation_S,
    fds_c_tableviewcell_borderradius_S: reference$1.dimension_08,
    fds_c_tableviewcell_borderradius_M: reference$1.dimension_16
  },
  multistep: {
    wizard: {
      fds_c_wizard_step_color_done: system.accent.fds_sys_color_accent_fresh,
      fds_c_wizard_step_color_current: system.text.fds_sys_color_text_success_stronger,
      fds_c_wizard_step_color_pending: system.background.fds_sys_color_background_success_strong,
      fds_c_wizard_step_color_content_light: system.text.fds_sys_color_text_primary_inverse,
      fds_c_wizard_step_color_content_dark: system.text.fds_sys_color_text_success_stronger,
      fds_c_wizard_step: {
        "font-family": reference$1.Silka,
        "font-weight": system.fds_sys_weight_L,
        "font-size": reference$1.dimension_12
      },
      fds_c_wizard_step_num: {
        "font-family": reference$1.Silka,
        "font-weight": system.fds_sys_weight_XL,
        "font-size": reference$1.dimension_14
      },
      fds_c_wizard_bullet_size: system.fds_sys_sizing_S,
      fds_c_wizard_step_gap: reference$1.dimension_16,
      fds_c_wizard_bullet_radius: system.fds_sys_borderradius_O
    },
    multiple: {
      fds_c_background_previous: system.background.fds_sys_color_background_cold,
      fds_c_background_current: system.background.fds_sys_color_background_primary_inverse,
      fds_c_background_pending: system.background.fds_sys_color_background_secondary,
      fds_c_text_color_previous_primary: system.text.fds_sys_color_text_primary_inverse,
      fds_c_text_color_previous_secondary: system.text.fds_sys_color_text_primary_inverse,
      fds_c_text_color_current_primary: system.text.fds_sys_color_text_primary,
      fds_c_text_color_current_secondary: system.text.fds_sys_color_text_success_stronger,
      fds_c_text_color_pending: system.text.fds_sys_color_text_secondary,
      fds_c_text_primary: {
        "font-family": reference$1.Silka,
        "font-weight": system.fds_sys_weight_XL,
        "font-size": reference$1.dimension_16
      },
      fds_c_text_secondary: {
        "font-family": reference$1.Silka,
        "font-weight": system.fds_sys_weight_XL,
        "font-size": reference$1.dimension_14,
        "line-height": system.fds_sys_lineheight_S
      },
      fds_c_text_tertiary: {
        "font-family": reference$1.Silka,
        "font-weight": system.fds_sys_weight_L,
        "font-size": reference$1.dimension_14,
        "line-height": system.fds_sys_lineheight_S
      },
      fds_c_row_padding: reference$1.dimension_16,
      fds_c_row_gap: reference$1.dimension_16,
      fds_c_content_padding_bottom: reference$1.dimension_24
    },
    single: {
      fds_c_step_definition: {
        "font-family": reference$1.Silka,
        "font-weight": system.fds_sys_weight_L,
        "line-height": reference$1.lineheight_120,
        "font-size": reference$1.dimension_14
      },
      fds_c_step_number: {
        "font-family": reference$1.Silka,
        "font-weight": system.fds_sys_weight_XL,
        "line-height": reference$1.lineheight_100,
        "font-size": reference$1.dimension_14
      }
    }
  },
  messages: {
    fds_c_messages_description: {
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_14,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_L
    },
    fds_c_messages_list_item: {
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_12,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_XL
    },
    fds_c_messages_title: {
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_16,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_M
    },
    fds_c_messages_banner_title_S: {
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_14,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_messages_banner_title_M: {
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_16,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_messages_banner_title_L: {
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_18,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_messages_banner_description: {
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_12,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_M
    },
    fds_c_messages_spacing_XS: reference$1.dimension_04,
    fds_c_messages_spacing_S: reference$1.dimension_08,
    fds_c_messages_spacing_M: reference$1.dimension_16,
    fds_c_messages_spacing_L: reference$1.dimension_24,
    fds_c_messages_spacing_XL: reference$1.dimension_32,
    fds_c_messages_color_light: system.background.fds_sys_color_background_primary,
    fds_c_messages_color_default: reference$1.neutral.moongreen_200,
    fds_c_messages_color_pro: system.plans.fds_sys_color_plan_pro_tertiary,
    fds_c_messages_color_pro_strong: system.plans.fds_sys_color_plan_pro_primary,
    fds_c_messages_color_live: system.plans.fds_sys_color_plan_live_tertiary,
    fds_c_messages_color_live_strong: system.plans.fds_sys_color_plan_live_primary,
    fds_c_messages_color_expert: system.plans.fds_sys_color_plan_expert_tertiary,
    fds_c_messages_color_expert_strong: system.plans.fds_sys_color_plan_expert_primary,
    fds_c_messages_color_full: system.plans.fds_sys_color_plan_full_tertiary,
    fds_c_messages_color_full_strong: system.plans.fds_sys_color_plan_full_primary,
    fds_c_messages_color_border: system.border.fds_sys_color_border_primary,
    fds_c_messages_color_dark: reference$1.brand.dark_500,
    fds_c_messages_color_cold_background: system.background.fds_sys_color_background_cold,
    fds_c_messages_color_cold: system.accent.fds_sys_color_accent_cold,
    fds_c_messages_progressbar_neutral: "rgba(0,0,0,0.1)",
    fds_c_messages_warning: system.background.fds_sys_color_background_warning_strong,
    fds_c_messages_warning_strong: system.text.fds_sys_color_text_warning_stronger,
    fds_c_messages_error: system.background.fds_sys_color_background_error_strong,
    fds_c_messages_error_strong: system.text.fds_sys_color_text_danger_stronger,
    fds_c_messages_success: reference$1.functional.success_200,
    fds_c_messages_success_strong: system.text.fds_sys_color_text_success_stronger,
    fds_c_tooltip_shadow: system.fds_sys_elevation_M,
    fds_c_floating_message_shadow: system.fds_sys_elevation_L,
    fds_c_tooltip_title: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_12
    },
    fds_c_tooltip_description: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_M,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_12
    }
  },
  tabs: {
    fds_c_tabs_spacing_S: system.fds_sys_spacing_XXS,
    fds_c_tabs_spacing_M: system.fds_sys_spacing_XS,
    fds_c_tabs_spacing_L: system.fds_sys_spacing_S,
    fds_c_tabs_color_background_dark: reference$1.brand.dark_500,
    fds_c_tabs_color_background_default: system.background.fds_sys_color_background_cold,
    fds_c_tabs_color_background_light: system.background.fds_sys_color_background_primary,
    fds_c_tabs_color_text_dark: reference$1.brand.dark_500,
    fds_c_tabs_color_text_light: reference$1.neutral.white
  },
  bullets: {
    fds_c_bullets_label: {
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_14,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_bullets_extra: {
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_12,
      "font-family": reference$1.Silka,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_bullets_color_extratext: system.accent.fds_sys_color_accent_cold,
    fds_c_bullets_spacing_XS: reference$1.dimension_01,
    fds_c_bullets_spacing_S: "5px",
    fds_c_bullets_spacing_M: system.fds_sys_spacing_XS,
    fds_c_bullets_top_padding_XXS: reference$1.dimension_02,
    fds_c_bullets_top_padding_XS: reference$1.dimension_04,
    fds_c_top_bullets_padding_S: reference$1.dimension_08,
    fds_c_bullets_top_padding_M: reference$1.dimension_16,
    fds_c_bullets_gap: reference$1.dimension_08
  },
  navigation: {
    fds_c_navigation_nav_btn_active: system.accent.fds_sys_color_accent_fresh,
    fds_c_navigation_nav_btn_default: reference$1.brand.dark_500,
    fds_c_navigation_nav_btn_background: reference$1.neutral.moon_300,
    fds_c_topbar_color_background: "rgba(255,255,255,0.6)",
    fds_c_popover_list_padding: reference$1.dimension_16,
    fds_c_popover_list_gap: reference$1.dimension_16,
    fds_c_topbar_end_separation: reference$1.dimension_16,
    fds_c_topbar_end_gap: reference$1.dimension_08,
    fds_c_topbar_right_gap: reference$1.dimension_32,
    fds_c_topbar_left_gap: reference$1.dimension_16,
    fds_c_topbar_responsive_gap: reference$1.dimension_16,
    fds_c_topbar_padding_vertical: reference$1.dimension_08,
    fds_c_topbar_responsive_padding_vertical: reference$1.dimension_08,
    fds_c_topbar_padding_horizontal: reference$1.dimension_24,
    fds_c_topbar_responsive_padding_horizontal: reference$1.dimension_16,
    fds_c_breadcrumbs_gap: reference$1.dimension_08,
    fds_c_taxflow_padding_external: reference$1.dimension_16,
    fds_c_taxflow_pill_padding: reference$1.dimension_08,
    fds_c_mobiletopbar_padding_vertical: reference$1.dimension_08,
    fds_c_mobiletopbar_padding_horizontal: reference$1.dimension_16,
    fds_c_mobiletopbar_gap: reference$1.dimension_16,
    fds_c_sidebar_iconbutton_text: {
      fill: system.text.fds_sys_color_text_secondary,
      "font-size": reference$1.dimension_10,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_rootnav_button_background: system.global.fds_sys_color_transparent,
    fds_c_rootnav_button_background_hover: system.background.fds_sys_color_background_primary,
    fds_c_rootnav_button_background_active: "rgba(61,58,98,0.08)",
    fds_c_rootnav_button_border: system.border.fds_sys_color_border_primary,
    fds_c_rootnav_button_hover: system.fds_sys_elevation_M,
    fds_c_rootnav_button_selected: system.fds_sys_embed_M,
    fds_c_tabbar_elevation: system.fds_sys_elevation_M,
    fds_c_tabbar_spacing_S: system.fds_sys_spacing_XS,
    fds_c_tabbar_spacing_M: system.fds_sys_spacing_S,
    fds_c_bottomnav_content: {
      "background-blur": reference$1.dimension_08,
      "border-color": system.border.fds_sys_color_border_light,
      "border-width": system.fds_sys_borderwidth_S,
      "box-shadow": system.fds_sys_elevation_L,
      "horizontal-padding": system.fds_sys_spacing_XS,
      "vertical-padding": system.fds_sys_spacing_XS,
      "border-radius": reference$1.dimension_40
    },
    fds_c_bottomnav_wrapper: {
      "horizontal-padding": system.fds_sys_spacing_XS,
      "vertical-padding": system.fds_sys_spacing_XS,
      "max-width": "768px"
    },
    fds_c_bottomnav_content_vertical: {
      "background-blur": reference$1.dimension_08,
      "border-color": system.border.fds_sys_color_border_light,
      "horizontal-padding": system.fds_sys_spacing_S,
      "vertical-padding": system.fds_sys_spacing_S,
      "border-radius": `${reference$1.dimension_24}, ${reference$1.dimension_24}, 0, ,`,
      "border-width-top": system.fds_sys_borderwidth_S,
      "border-width-right": system.fds_sys_borderwidth_S,
      "border-width-left": system.fds_sys_borderwidth_S,
      "border-width-bottom": "0"
    },
    fds_c_bottomnav_notice_info_text: {
      color: system.accent.fds_sys_color_accent_cold,
      "font-size": "10px",
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_bottomnav_notice_warning_text: {
      color: system.text.fds_sys_color_text_warning_stronger,
      "font-size": "10px",
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_bottomnav_spacing: system.fds_sys_spacing_XS,
    fds_c_bottomnav_button_shadow_dark: {
      x: "0",
      y: "2px",
      blur: "4px",
      spread: "0",
      color: "rgba(0,0,0,0.16)",
      type: "dropShadow"
    },
    fds_c_bottomnav_button_shadow_light: {
      x: "0",
      y: "-2px",
      blur: "4px",
      spread: "0",
      color: "rgba(255,255,255,0.9)",
      type: "dropShadow"
    },
    fds_c_bottomnav_text_spacing: system.fds_sys_spacing_XS,
    fds_c_bottomnav_tab_gap: system.fds_sys_spacing_XXS,
    fds_c_sidebar_close_spacing: system.fds_sys_spacing_S,
    fds_c_sidebar_floating_spacing: system.fds_sys_spacing_XS,
    fds_c_bottomnav_notice_default_background: "rgba(255,255,255,0.7)",
    fds_c_bottomnav_notice_info_background: "rgba(238,247,253,0.7)",
    fds_c_bottomnav_notice_warning_background: "rgba(252,245,221,0.7)",
    fds_c_sidebar_responsive_background: {
      fill: "rgba(0,0,0,0.3)",
      "background-blur": reference$1.dimension_08
    },
    fds_c_sidebar_left: {
      fill: system.background.fds_sys_color_background_primary,
      "border-right-width": system.fds_sys_borderwidth_S,
      "border-color": system.border.fds_sys_color_border_primary,
      "border-left-width": system.fds_sys_borderwidth_none
    },
    fds_c_sidebar_right: {
      fill: system.background.fds_sys_color_background_primary,
      "border-color": system.border.fds_sys_color_border_primary,
      "border-left-width": system.fds_sys_borderwidth_S,
      "border-right-width": system.fds_sys_borderwidth_none
    },
    fds_c_sidebar_floating_styles: {
      fill: system.background.fds_sys_color_background_primary,
      "border-width": system.fds_sys_borderwidth_S,
      "border-color": system.border.fds_sys_color_border_primary,
      "border-radius": system.fds_sys_borderradius_L,
      "box-shadow": system.fds_sys_elevation_L
    },
    fds_c_sidebar_max_width_XS: reference$1.dimension_80,
    fds_c_sidebar_max_width_S: reference$1.dimension_128,
    fds_c_sidebar_max_width_M: reference$1.dimension_240,
    fds_c_sidebar_max_width_L: reference$1.dimension_320,
    fds_c_sidebar_max_width_XL: reference$1.dimension_425
  },
  accordion: {
    fds_c_accordion_spacing_M: reference$1.dimension_16,
    fds_c_accordion_spacing_S: reference$1.dimension_08,
    fds_c_accordion_border_color: system.border.fds_sys_color_border_primary,
    fds_c_accordion_border_color_selected: system.border.fds_sys_color_border_light,
    fds_c_accordion_border_color_hover: reference$1.neutral.white,
    fds_c_accordion_background_color_selected: system.background.fds_sys_color_background_supersoft,
    fds_c_accordion_borderradius_M: reference$1.dimension_16,
    fds_c_accordion_borderradius_S: reference$1.dimension_08
  },
  utils: {
    progress_line: {
      fds_c_progress_color_filled: reference$1.functional.success_600,
      fds_c_progress_color_tofill: reference$1.functional.success_300,
      fds_c_progress_color_text: system.accent.fds_sys_color_accent_cold,
      fds_c_progressbar_height: reference$1.dimension_08,
      fds_c_progressbar_step_gap: reference$1.dimension_04
    },
    progress_circle: {
      fds_c_circle_color_filled: system.accent.fds_sys_color_accent_fresh,
      fds_c_circle_color_unfilled: system.background.fds_sys_color_background_fresh,
      fds_c_circle_size: reference$1.dimension_16
    },
    progress_steps: {
      fds_c_radius: reference$1.dimension_02
    }
  },
  progress: {
    fds_c_text_counter: {
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_16,
      "font-family": reference$1.Silka
    }
  },
  forms: {
    fds_c_related_content_text: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_12,
      "line-height": system.fds_sys_lineheight_M
    }
  },
  pagination: {
    fds_c_pagination_slider_light: reference$1.neutral.white,
    fds_c_pagination_slider_dark: reference$1.brand.dark_500,
    fds_c_pagination_pages_accent_soft: system.background.fds_sys_color_background_cold,
    fds_c_pagination_pages_accent_strong: system.accent.fds_sys_color_accent_cold,
    fds_c_pagination_pages_gap: system.fds_sys_spacing_M,
    fds_c_pages_selector_number: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "line-height": reference$1.lineheight_110,
      "font-size": reference$1.dimension_12
    },
    fds_c_pages_range: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "line-height": reference$1.lineheight_110,
      "font-size": reference$1.dimension_12
    }
  },
  plans: {
    fds_c_price_typo_S: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "line-height": reference$1.lineheight_120,
      "font-size": reference$1.dimension_16
    },
    fds_c_price_typo_M: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "line-height": reference$1.lineheight_120,
      "font-size": reference$1.dimension_16
    },
    fds_c_price_typo_S_extended: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_XL,
      "line-height": "90%",
      "font-size": reference$1.dimension_32
    },
    fds_c_price_typo_M_extended: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_XL,
      "line-height": "80%",
      "font-size": reference$1.dimension_48
    },
    fds_c_price_typo_previous_M: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_M,
      "line-height": "90%",
      "font-size": reference$1.dimension_32
    },
    fds_c_price_typo_previous_S: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_M,
      "line-height": system.fds_sys_lineheight_M,
      "font-size": reference$1.dimension_24
    },
    fds_c_card_disccount_bg: system.accent.fds_sys_color_accent_fresh,
    fds_c_card_disccount_bg_soft: system.background.fds_sys_color_background_success_strong,
    fds_c_card_disccount_text_color_dark: system.text.fds_sys_color_text_success_stronger,
    fds_c_card_disccount_text_color_light: system.text.fds_sys_color_text_primary_inverse,
    fds_c_card_recommended_bg: reference$1.brand.dark_500,
    fds_c_card_recommended_color_text: reference$1.neutral.white,
    fds_c_plan_typo_highlighted: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_16
    },
    fds_c_plan_price_previous: reference$1.functional.danger_550,
    fds_c_plan_cover_spacing: reference$1.dimension_24,
    fds_c_plan_cover_gap: reference$1.dimension_16,
    fds_c_plan_color_description: system.text.fds_sys_color_text_secondary,
    fds_c_plan_color_subtitle: system.text.fds_sys_color_text_primary,
    fds_c_plan_typo_subtitle: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_18,
      "line-height": system.fds_sys_lineheight_M
    },
    fds_c_plan_typo_description: {
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_16,
      "line-height": system.fds_sys_lineheight_S
    },
    fds_c_freemodule_typo_title: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_L,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": text$1.fds_forms_input_label
    },
    fds_c_freemodule_typo_description: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_M,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_12
    },
    fds_c_plancard_image_background_PRO: "#C8D1EB",
    fds_c_horizontalimage_radius: reference$1.dimension_80
  },
  "Pro start price": "35",
  "Live start price": "45",
  "Expert start price": "55",
  "Full start price": "65",
  cards: {
    fds_c_table_data_key: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_M,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_12
    },
    fds_c_table_data_value: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_M,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_12
    },
    fds_c_table_data_gap: reference$1.dimension_08,
    fds_c_table_data_lines_gap: reference$1.dimension_16,
    fds_c_table_coloured_radius: system.fds_sys_borderradius_M,
    fds_c_table_coloured_bg: system.background.fds_sys_color_background_supersoft,
    fds_c_card_typo_description: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_M,
      "line-height": system.fds_sys_lineheight_XL,
      "font-size": reference$1.dimension_12
    },
    fds_c_content_padding_horizontal: reference$1.dimension_16,
    fds_c_card_footer_spacing_S: reference$1.dimension_08,
    fds_c_card_footer_spacing_M: reference$1.dimension_16,
    fds_c_card_header_title_M: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_XL,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_16
    },
    fds_c_card_header_title_L: {
      "font-family": reference$1.Silka,
      "font-weight": system.fds_sys_weight_XL,
      "line-height": system.fds_sys_lineheight_S,
      "font-size": reference$1.dimension_18
    },
    fds_c_card_gap_S: reference$1.dimension_08,
    fds_c_card_gap_M: reference$1.dimension_16,
    fds_c_basiccard_gap: "-16px",
    fds_c_basiccard_elevation_hover: {
      x: "0",
      y: "16px",
      blur: "16px",
      spread: "0",
      color: "#00000026",
      type: "dropShadow"
    }
  },
  headline: {
    XL_L_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_80
    },
    L_L_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_64
    },
    M_L_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_48
    },
    S_L_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_32
    },
    XS_L_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_24
    },
    XL_M_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_80
    },
    L_M_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_64
    },
    M_M_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_48
    },
    S_M_S: {
      "line-height": reference$1.lineheight_100,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_32
    },
    XS_M_S: {
      "line-height": "100%",
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_24
    },
    XL_L_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_80
    },
    L_L_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_64
    },
    M_L_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_48
    },
    S_L_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_32
    },
    XS_L_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_24
    },
    XL_M_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_80
    },
    L_M_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_64
    },
    M_M_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_48
    },
    S_M_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_32
    },
    XS_M_M: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_24
    },
    XL_L_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_80
    },
    L_L_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_64
    },
    M_L_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_48
    },
    S_L_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_32
    },
    XS_L_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_24
    },
    XL_M_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_80
    },
    L_M_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_64
    },
    M_M_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_48
    },
    S_M_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_32
    },
    XS_M_L: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_24
    },
    headline_text_sizes: {
      text: {
        [reference$1.breakpoints.MOBILE_EXTRA_SMALL_WIDTH]: {
          XL: "M",
          L: "S",
          M: "XS",
          S: "XS"
        },
        [reference$1.breakpoints.MOBILE_SMALL_WIDTH]: {
          XL: "M",
          L: "S",
          M: "S",
          S: "XS"
        },
        [reference$1.breakpoints.MOBILE_MEDIUM_WIDTH]: {
          XL: "M",
          L: "S",
          M: "S",
          S: "XS"
        },
        [reference$1.breakpoints.MOBILE_WIDTH]: {
          XL: "M",
          L: "M",
          M: "S"
        },
        [reference$1.breakpoints.TABLET_WIDTH]: {
          XL: "M",
          L: "M"
        },
        [reference$1.breakpoints.DESKTOP_EXTRA_SMALL_WIDTH]: {
          XL: "L"
        },
        [reference$1.breakpoints.DESKTOP_SMALL_WIDTH]: {
          XL: "L"
        }
      }
    }
  },
  paragraphs: {
    XS_S_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_12
    },
    S_S_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_14
    },
    M_S_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_16
    },
    L_S_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_20
    },
    XL_S_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_24
    },
    XS_M_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_12
    },
    S_M_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_14
    },
    M_M_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_16
    },
    L_M_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_20
    },
    XL_M_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_24
    },
    XS_L_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_12
    },
    S_L_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_14
    },
    M_L_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_16
    },
    L_L_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_20
    },
    XL_L_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_24
    },
    XS_XL_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_12
    },
    S_XL_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_14
    },
    M_XL_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_16
    },
    L_XL_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_20
    },
    XL_XL_S: {
      "line-height": reference$1.lineheight_120,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_24
    },
    XS_S_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_12
    },
    S_S_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_14
    },
    M_S_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_16
    },
    L_S_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_20
    },
    XL_S_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_24
    },
    XS_M_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_12
    },
    S_M_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_14
    },
    M_M_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_16
    },
    L_M_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_20
    },
    XL_M_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_24
    },
    XS_L_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_12
    },
    S_L_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_14
    },
    M_L_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_16
    },
    L_L_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_20
    },
    XL_L_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_24
    },
    XS_XL_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_12
    },
    S_XL_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_14
    },
    M_XL_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_16
    },
    L_XL_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_20
    },
    XL_XL_M: {
      "line-height": reference$1.lineheight_140,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_24
    },
    XS_S_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_12
    },
    S_S_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_14
    },
    M_S_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_16
    },
    L_S_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_20
    },
    XL_S_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_400,
      "font-size": reference$1.dimension_24
    },
    XS_M_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_12
    },
    S_M_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_14
    },
    M_M_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_16
    },
    L_M_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_20
    },
    XL_M_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_500,
      "font-size": reference$1.dimension_24
    },
    XS_L_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_12
    },
    S_L_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_14
    },
    M_L_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_16
    },
    L_L_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_20
    },
    XL_L_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_600,
      "font-size": reference$1.dimension_24
    },
    XS_XL_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_12
    },
    S_XL_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_14
    },
    M_XL_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_16
    },
    L_XL_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_20
    },
    XL_XL_L: {
      "line-height": reference$1.lineheight_180,
      "font-family": reference$1.Silka,
      "font-weight": reference$1.weight_700,
      "font-size": reference$1.dimension_24
    },
    paragraphs_text_sizes: {
      text: {
        [reference$1.breakpoints.MOBILE_EXTRA_SMALL_WIDTH]: {
          XL: "M",
          L: "M",
          M: "S"
        },
        [reference$1.breakpoints.MOBILE_SMALL_WIDTH]: {
          XL: "M",
          L: "M",
          M: "S"
        },
        [reference$1.breakpoints.MOBILE_MEDIUM_WIDTH]: {
          XL: "M"
        },
        [reference$1.breakpoints.MOBILE_WIDTH]: {
          XL: "L"
        },
        [reference$1.breakpoints.TABLET_WIDTH]: {
          XL: "L"
        },
        [reference$1.breakpoints.DESKTOP_EXTRA_SMALL_WIDTH]: {
          XL: "L"
        }
      }
    }
  },
  modals: {
    fds_c_modal_bottom_dragger_color: system.border.fds_sys_color_border_primary,
    fds_c_modals_background: {
      fill: "rgba(0,0,0,0.3)",
      "background-blur": reference$1.dimension_08
    },
    fds_c_dragger_width: reference$1.dimension_72,
    fds_c_modal_bottom_dragger_border_width: system.fds_sys_borderwidth_L,
    fds_c_modal_centered_minwidth_XS: "248px",
    fds_c_modal_centered_minwidth_S: "288px",
    fds_c_modal_centered_minwidth_M: "640px",
    fds_c_modal_centered_minwidth_L: "1024px",
    fds_c_modal_centered_minwidth_XL: "1280px"
  },
  message: {
    fds_c_tooltip_size_S: reference$1.dimension_96,
    fds_c_tooltip_size_M: reference$1.dimension_128,
    fds_c_tooltip_size_L: reference$1.dimension_240
  },
  layout: {
    fds_c_inputwrapper_gap: system.fds_sys_spacing_L
  },
  icons: {
    fds_c_icons_color_dark: reference$1.brand.dark_500,
    fds_c_icons_color_light: reference$1.neutral.white,
    fds_c_icons_color_cold: system.accent.fds_sys_color_accent_cold,
    fds_c_icons_color_error: reference$1.functional.danger_500,
    fds_c_icons_color_error_strong: reference$1.functional.danger_800,
    fds_c_icons_color_warning: reference$1.functional.warning_500,
    fds_c_icons_color_warning_strong: reference$1.functional.warning_800,
    fds_c_icons_color_success: reference$1.functional.success_500,
    fds_c_icons_color_success_strong: reference$1.functional.success_800,
    fds_c_icons_color_grey: reference$1.neutral.moon_500,
    fds_c_icons_color_grey_strong: reference$1.neutral.moon_700,
    fds_c_icons_color_plan_pro: system.plans.fds_sys_color_plan_pro_primary,
    fds_c_icons_color_plan_live: system.plans.fds_sys_color_plan_live_primary,
    fds_c_icons_color_plan_expert: system.plans.fds_sys_color_plan_expert_primary,
    fds_c_icons_color_plan_full: system.plans.fds_sys_color_plan_full_primary
  },
  loaders: {
    fds_c_spinner_XS: system.fds_sys_sizing_XS,
    fds_c_spinner_S: system.fds_sys_sizing_S,
    fds_c_spinner_M: system.fds_sys_sizing_M,
    fds_c_spinner_L: system.fds_sys_sizing_XL,
    fds_c_spinner_XL: system.fds_sys_sizing_XXL,
    fds_c_spinner_border_width_XS: reference$1.dimension_03,
    fds_c_spinner_border_width_S: reference$1.dimension_04,
    fds_c_spinner_border_width_M: reference$1.dimension_04,
    fds_c_spinner_border_width_L: reference$1.dimension_08,
    fds_c_spinner_border_width_XL: reference$1.dimension_08,
    fds_c_spinner_color_secondary: system.border.fds_sys_color_border_light,
    fds_c_spinner_color_primary: system.border.fds_sys_color_border_primary_inverse
  },
  textColors
}, boxShadows = {
  fds_elevation_500: {
    x: "0",
    y: "4px",
    blur: "10px",
    spread: "0",
    color: "rgba(0,0,0,0.15)",
    type: "dropShadow"
  }
}, colors$1 = {
  danger_100: "#FFFAFA",
  danger_200: "#FFE5E1",
  danger_300: "#ffd6d0",
  danger_500: "#fb6b62",
  danger_550: "#E0726B",
  danger_600: "#B27E7B",
  danger_700: "#BC3E36",
  dark_500: "#3d3a62",
  darken: "rgba(100, 100,110, 0.95)",
  gold: "linear-gradient(180deg, #FFF38A 0%, #FFC700 100%);",
  grad_300: "linear-gradient(225deg, #eef7fd 0%, #dff8e9 72.42%)",
  grad_500: "linear-gradient(225deg, #eef7fd 35.42%, #ffede9 100%)",
  grad_700: "linear-gradient(225deg, #dff8e9 0%, #ffede9 70.39%)",
  grass_100: "#F3FDF7",
  grass_200: "#dff8e9",
  grass_500: "#0fb990",
  grass_700: "#0C7A60",
  green_100: "#F5F9F6",
  green_200: "#E0F7E9",
  green_300: "#C9EBD6",
  green_400: "#87C79F",
  green_500: "#00DC5A",
  green_600: "#25C076",
  green_800: "#397451",
  modal_bg: "rgba(224,247,233,0.9)",
  moon_100: "#FBFBFB",
  moon_300: "#f3f3f3",
  moon_500: "#d9d9d9",
  moon_700: "#b4b4b4",
  moon_800: "#888",
  moon_g_200: "#f5f9f6",
  moon_g_400: "#e2eae5",
  sand_200: "#ffede9",
  sand_500: "#ff7f63",
  sky_200: "#eef7fd",
  sky_300: "#CDC9E2",
  sky_500: "#5A74D0",
  tax_300: "#99f1bd",
  tax_500: "#0fd48e",
  warning_100: "#FFFCF3",
  warning_200: "#fff2c7",
  warning_300: "#ffecae",
  warning_500: "#e1a613",
  warning_550: "#B79746",
  warning_700: "#886200",
  white: "#ffffff",
  pro_200: "#F1F3FA",
  pro_400: "#DDE6FF",
  pro_800: "#7486BC",
  pro_gradient: "linear-gradient(177.49deg, #DDE6FF 0.81%, #8290C1 99.85%)",
  live_200: "#FAEFE8",
  live_400: "#FFE1D0",
  live_800: "#B17986",
  live_gradient: "linear-gradient(180deg, #FFE1D0 0%, #B27E7B 100%)",
  full_200: "#F4F0E4",
  full_400: "#FFE693",
  full_800: "#AB9163",
  full_gradient: "linear-gradient(180deg, #FFF1BF 0%, #DABA7C 100%)",
  pro_gradient_transparent: "linear-gradient(90deg, rgba(212, 227, 226, 0) 0%, #8290C1 100%)",
  live_gradient_transparent: "linear-gradient(90deg, rgba(255, 225, 208, 0) 0%, #B27E7B 99%)",
  full_gradient_transparent: "linear-gradient(90deg, rgba(255, 241, 191, 0) 0%, #AB9163 99%)",
  iridiscent_gradient: "linear-gradient(135deg, #DFF8E9 12.33%, #EEF7FD 27.7%, #FFEDE9 44.99%, #FFEDE9 54.97%, #EEF7FD 71.87%, #DFF8E9 85.32%)"
}, fontWeights = {
  Bold: "700",
  Medium: "500",
  SemiBold: "600",
  Regular: "400",
  Light: "300"
}, sizes = {
  fds_size_08: "8px",
  fds_size_16: "16px",
  fds_size_24: "24px",
  fds_size_32: "32px",
  fds_size_40: "40px",
  fds_size_48: "48px",
  fds_size_56: "56px",
  fds_size_64: "64px",
  fds_size_72: "72px",
  fds_size_80: "80px",
  fds_size_96: "96px",
  fds_size_112: "112px",
  fds_size_128: "128px",
  fds_size_160: "160px"
}, buttonSizes = {
  fds_circlebutton_icon: "53px",
  fds_button_icon_S: "16px",
  fds_button_icon_M: "24px",
  fds_button_icon_L: "32px"
}, bordersSizes = {
  fds_border_width_S: "1px",
  fds_border_width_M: "2px",
  fds_border_width_L: "3px"
}, borderRadius$1 = {
  fds_borderradius_XS: "2px",
  fds_borderradius_S: "4px",
  fds_borderradius_M: "8px",
  fds_borderradius_L: "16px",
  fds_borderradius_round: "300px"
}, fontSizes = {
  fds_forms_input_text: "16px",
  fds_forms_input_numeric: "20px",
  fds_forms_input_label: "15px",
  fds_forms_contextualhelp: "10px"
}, sizing = {
  ...sizes,
  ...buttonSizes,
  ...bordersSizes,
  ...borderRadius$1,
  ...fontSizes
}, spacing$1 = {
  fds_button_fix_L: "2px",
  fds_button_fix_M: "3px",
  fds_button_fix_S: "1px",
  fds_forms_contextualhelp_padding_horizontal: "8px",
  fds_forms_contextualhelp_padding_vertical: "4px",
  fds_forms_input_default_v_gap: "16px",
  fds_forms_input_padding_horizontal: "16px",
  fds_forms_input_padding_vertical: "16px",
  fds_forms_input_spacing_bottom_L: "32px",
  fds_forms_input_spacing_bottom_M: "24px",
  fds_forms_input_spacing_bottom_S: "16px",
  spacing_02: "2px",
  spacing_04: "4px",
  spacing_08: "8px",
  spacing_16: "16px",
  spacing_24: "24px",
  spacing_32: "32px",
  spacing_40: "40px",
  spacing_48: "48px",
  spacing_56: "56px",
  spacing_64: "64px",
  spacing_72: "72px",
  spacing_80: "80px",
  spacing_96: "96px",
  spacing_112: "112px",
  spacing_128: "128px"
}, typographyBase = {
  fds_paragraph_regular_S: {
    "font-family": "Silka",
    "font-weight": fontWeights.Regular,
    "font-size": "14px",
    "line-height": "170%"
  },
  fds_paragraph_regular_M: {
    "font-family": "Silka",
    "font-weight": fontWeights.Regular,
    "font-size": "16px",
    "line-height": "170%"
  },
  fds_paragraph_medium_XS: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "12px",
    "line-height": "180%"
  },
  fds_paragraph_medium_S: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "14px",
    "line-height": "170%"
  },
  fds_paragraph_medium_M: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "16px",
    "line-height": "170%"
  },
  fds_paragraph_medium_L: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "18px",
    "line-height": "170%"
  },
  fds_paragraph_semibold_XS: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "12px",
    "line-height": "180%"
  },
  fds_paragraph_semibold_S: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "14px",
    "line-height": "170%"
  },
  fds_paragraph_semibold_M: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "16px",
    "line-height": "170%"
  },
  fds_paragraph_semibold_L: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "18px",
    "line-height": "170%"
  },
  fds_text_regular_XS: {
    "font-family": "Silka",
    "font-weight": fontWeights.Regular,
    "font-size": "12px",
    "line-height": "110%"
  },
  fds_text_regular_S: {
    "font-family": "Silka",
    "font-weight": fontWeights.Regular,
    "font-size": "14px",
    "line-height": "110%"
  },
  fds_text_regular_M: {
    "font-family": "Silka",
    "font-weight": fontWeights.Regular,
    "font-size": "16px",
    "line-height": "110%"
  },
  fds_text_regular_L: {
    "font-family": "Silka",
    "font-weight": fontWeights.Regular,
    "font-size": "18px",
    "line-height": "110%"
  },
  fds_text_regular_XL: {
    "font-family": "Silka",
    "font-weight": fontWeights.Regular,
    "font-size": "24px",
    "line-height": "110%"
  },
  fds_text_medium_XS: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "12px",
    "line-height": "110%"
  },
  fds_text_medium_S: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "14px",
    "line-height": "110%"
  },
  fds_text_medium_M: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "16px",
    "line-height": "110%"
  },
  fds_text_medium_L: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "18px",
    "line-height": "120%"
  },
  fds_text_medium_XL: {
    "font-family": "Silka",
    "font-weight": fontWeights.Medium,
    "font-size": "24px",
    "line-height": "110%"
  },
  fds_text_semibold_XS: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "12px",
    "line-height": "110%"
  },
  fds_text_semibold_S: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "14px",
    "line-height": "110%"
  },
  fds_text_semibold_M: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "16px",
    "line-height": "110%"
  },
  fds_text_semibold_L: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": "18px",
    "line-height": "110%"
  },
  fds_text_bold_XS: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "12px"
  },
  fds_text_bold_S: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "14px"
  },
  fds_text_bold_M: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "16px"
  },
  fds_text_bold_L: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "18px",
    "line-height": "110%"
  },
  fds_text_bold_XL: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "22px",
    "line-height": "110%"
  },
  fds_heading_bold_H5: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "24px",
    "line-height": "120%"
  },
  fds_heading_bold_H4: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "32px",
    "line-height": "120%"
  },
  fds_heading_bold_H3: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "48px",
    "line-height": "120%"
  },
  fds_heading_bold_H2: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "64px",
    "line-height": "110%"
  },
  fds_heading_bold_H1: {
    "font-family": "Silka",
    "font-weight": fontWeights.Bold,
    "font-size": "80px",
    "line-height": "110%"
  },
  fds_form_divider: {
    "font-family": "Silka",
    "letter-spacing": "4%",
    "font-size": sizing.fds_size_16
  }
}, typographyForms = {
  fds_forms_label: typographyBase.fds_text_semibold_M,
  fds_forms_contextualhelp: {
    "font-family": "Silka",
    "font-weight": fontWeights.SemiBold,
    "font-size": sizing.fds_forms_contextualhelp
  }
}, typography = { ...typographyBase, ...typographyForms }, piccoloTheme = {
  // FLYNN V2
  components: components$1,
  reference: reference$1,
  system,
  // FLYNN V1
  boxShadows,
  colors: { ...colors$1, ...colorsLegacy },
  fontWeights,
  sizing,
  spacing: spacing$1,
  typography,
  // Legacy
  buttons: {
    sizes: buttonSizesLegacy
  },
  fontFamily: {
    silka: "Silka",
    arboria: "Arboria",
    arboriaBold: "Arboria-Bold",
    arboriaBook: "Arboria-Book",
    openSans: "OpenSans"
  },
  gradients: gradientsLegacy,
  fontSizes: fontSizesLegacy,
  mediaQueries
};
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function getAugmentedNamespace(t) {
  if (t.__esModule)
    return t;
  var r = t.default;
  if (typeof r == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    n.prototype = r.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(a) {
    var s = Object.getOwnPropertyDescriptor(t, a);
    Object.defineProperty(n, a, s.get ? s : {
      enumerable: !0,
      get: function() {
        return t[a];
      }
    });
  }), n;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var t = React__default, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(l, d, h) {
    var u, p = {}, m = null, g = null;
    h !== void 0 && (m = "" + h), d.key !== void 0 && (m = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d)
      a.call(d, u) && !o.hasOwnProperty(u) && (p[u] = d[u]);
    if (l && l.defaultProps)
      for (u in d = l.defaultProps, d)
        p[u] === void 0 && (p[u] = d[u]);
    return { $$typeof: r, type: l, key: m, ref: g, props: p, _owner: s.current };
  }
  return reactJsxRuntime_production_min.Fragment = n, reactJsxRuntime_production_min.jsx = c, reactJsxRuntime_production_min.jsxs = c, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var t = React__default, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), v = Symbol.iterator, y = "@@iterator";
    function x(pr) {
      if (pr === null || typeof pr != "object")
        return null;
      var Lr = v && pr[v] || pr[y];
      return typeof Lr == "function" ? Lr : null;
    }
    var _ = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(pr) {
      {
        for (var Lr = arguments.length, Fr = new Array(Lr > 1 ? Lr - 1 : 0), Br = 1; Br < Lr; Br++)
          Fr[Br - 1] = arguments[Br];
        b("error", pr, Fr);
      }
    }
    function b(pr, Lr, Fr) {
      {
        var Br = _.ReactDebugCurrentFrame, W = Br.getStackAddendum();
        W !== "" && (Lr += "%s", Fr = Fr.concat([W]));
        var Y = Fr.map(function(X) {
          return String(X);
        });
        Y.unshift("Warning: " + Lr), Function.prototype.apply.call(console[pr], console, Y);
      }
    }
    var M = !1, C = !1, S = !1, A = !1, D = !1, N;
    N = Symbol.for("react.module.reference");
    function T(pr) {
      return !!(typeof pr == "string" || typeof pr == "function" || pr === a || pr === o || D || pr === s || pr === h || pr === u || A || pr === g || M || C || S || typeof pr == "object" && pr !== null && (pr.$$typeof === m || pr.$$typeof === p || pr.$$typeof === c || pr.$$typeof === l || pr.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      pr.$$typeof === N || pr.getModuleId !== void 0));
    }
    function R(pr, Lr, Fr) {
      var Br = pr.displayName;
      if (Br)
        return Br;
      var W = Lr.displayName || Lr.name || "";
      return W !== "" ? Fr + "(" + W + ")" : Fr;
    }
    function F(pr) {
      return pr.displayName || "Context";
    }
    function z(pr) {
      if (pr == null)
        return null;
      if (typeof pr.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof pr == "function")
        return pr.displayName || pr.name || null;
      if (typeof pr == "string")
        return pr;
      switch (pr) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case h:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof pr == "object")
        switch (pr.$$typeof) {
          case l:
            var Lr = pr;
            return F(Lr) + ".Consumer";
          case c:
            var Fr = pr;
            return F(Fr._context) + ".Provider";
          case d:
            return R(pr, pr.render, "ForwardRef");
          case p:
            var Br = pr.displayName || null;
            return Br !== null ? Br : z(pr.type) || "Memo";
          case m: {
            var W = pr, Y = W._payload, X = W._init;
            try {
              return z(X(Y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var O = Object.assign, G = 0, I, k, B, L, V, U, J;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Z() {
      {
        if (G === 0) {
          I = console.log, k = console.info, B = console.warn, L = console.error, V = console.group, U = console.groupCollapsed, J = console.groupEnd;
          var pr = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: pr,
            log: pr,
            warn: pr,
            error: pr,
            group: pr,
            groupCollapsed: pr,
            groupEnd: pr
          });
        }
        G++;
      }
    }
    function ae() {
      {
        if (G--, G === 0) {
          var pr = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: O({}, pr, {
              value: I
            }),
            info: O({}, pr, {
              value: k
            }),
            warn: O({}, pr, {
              value: B
            }),
            error: O({}, pr, {
              value: L
            }),
            group: O({}, pr, {
              value: V
            }),
            groupCollapsed: O({}, pr, {
              value: U
            }),
            groupEnd: O({}, pr, {
              value: J
            })
          });
        }
        G < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ee = _.ReactCurrentDispatcher, se;
    function nr(pr, Lr, Fr) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (W) {
            var Br = W.stack.trim().match(/\n( *(at )?)/);
            se = Br && Br[1] || "";
          }
        return `
` + se + pr;
      }
    }
    var ce = !1, oe;
    {
      var ur = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new ur();
    }
    function ir(pr, Lr) {
      if (!pr || ce)
        return "";
      {
        var Fr = oe.get(pr);
        if (Fr !== void 0)
          return Fr;
      }
      var Br;
      ce = !0;
      var W = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Y;
      Y = ee.current, ee.current = null, Z();
      try {
        if (Lr) {
          var X = function() {
            throw Error();
          };
          if (Object.defineProperty(X.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(X, []);
            } catch (Dr) {
              Br = Dr;
            }
            Reflect.construct(pr, [], X);
          } else {
            try {
              X.call();
            } catch (Dr) {
              Br = Dr;
            }
            pr.call(X.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Dr) {
            Br = Dr;
          }
          pr();
        }
      } catch (Dr) {
        if (Dr && Br && typeof Dr.stack == "string") {
          for (var K = Dr.stack.split(`
`), te = Br.stack.split(`
`), ie = K.length - 1, lr = te.length - 1; ie >= 1 && lr >= 0 && K[ie] !== te[lr]; )
            lr--;
          for (; ie >= 1 && lr >= 0; ie--, lr--)
            if (K[ie] !== te[lr]) {
              if (ie !== 1 || lr !== 1)
                do
                  if (ie--, lr--, lr < 0 || K[ie] !== te[lr]) {
                    var vr = `
` + K[ie].replace(" at new ", " at ");
                    return pr.displayName && vr.includes("<anonymous>") && (vr = vr.replace("<anonymous>", pr.displayName)), typeof pr == "function" && oe.set(pr, vr), vr;
                  }
                while (ie >= 1 && lr >= 0);
              break;
            }
        }
      } finally {
        ce = !1, ee.current = Y, ae(), Error.prepareStackTrace = W;
      }
      var Mr = pr ? pr.displayName || pr.name : "", br = Mr ? nr(Mr) : "";
      return typeof pr == "function" && oe.set(pr, br), br;
    }
    function _r(pr, Lr, Fr) {
      return ir(pr, !1);
    }
    function yr(pr) {
      var Lr = pr.prototype;
      return !!(Lr && Lr.isReactComponent);
    }
    function ne(pr, Lr, Fr) {
      if (pr == null)
        return "";
      if (typeof pr == "function")
        return ir(pr, yr(pr));
      if (typeof pr == "string")
        return nr(pr);
      switch (pr) {
        case h:
          return nr("Suspense");
        case u:
          return nr("SuspenseList");
      }
      if (typeof pr == "object")
        switch (pr.$$typeof) {
          case d:
            return _r(pr.render);
          case p:
            return ne(pr.type, Lr, Fr);
          case m: {
            var Br = pr, W = Br._payload, Y = Br._init;
            try {
              return ne(Y(W), Lr, Fr);
            } catch {
            }
          }
        }
      return "";
    }
    var pe = Object.prototype.hasOwnProperty, hr = {}, $r = _.ReactDebugCurrentFrame;
    function Sr(pr) {
      if (pr) {
        var Lr = pr._owner, Fr = ne(pr.type, pr._source, Lr ? Lr.type : null);
        $r.setExtraStackFrame(Fr);
      } else
        $r.setExtraStackFrame(null);
    }
    function ze(pr, Lr, Fr, Br, W) {
      {
        var Y = Function.call.bind(pe);
        for (var X in pr)
          if (Y(pr, X)) {
            var K = void 0;
            try {
              if (typeof pr[X] != "function") {
                var te = Error((Br || "React class") + ": " + Fr + " type `" + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof pr[X] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              K = pr[X](Lr, X, Br, Fr, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ie) {
              K = ie;
            }
            K && !(K instanceof Error) && (Sr(W), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Br || "React class", Fr, X, typeof K), Sr(null)), K instanceof Error && !(K.message in hr) && (hr[K.message] = !0, Sr(W), $("Failed %s type: %s", Fr, K.message), Sr(null));
          }
      }
    }
    var cr = Array.isArray;
    function fr(pr) {
      return cr(pr);
    }
    function mr(pr) {
      {
        var Lr = typeof Symbol == "function" && Symbol.toStringTag, Fr = Lr && pr[Symbol.toStringTag] || pr.constructor.name || "Object";
        return Fr;
      }
    }
    function wr(pr) {
      try {
        return Nr(pr), !1;
      } catch {
        return !0;
      }
    }
    function Nr(pr) {
      return "" + pr;
    }
    function xr(pr) {
      if (wr(pr))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", mr(pr)), Nr(pr);
    }
    var Er = _.ReactCurrentOwner, Ir = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Rr, Yr, Qr;
    Qr = {};
    function nn(pr) {
      if (pe.call(pr, "ref")) {
        var Lr = Object.getOwnPropertyDescriptor(pr, "ref").get;
        if (Lr && Lr.isReactWarning)
          return !1;
      }
      return pr.ref !== void 0;
    }
    function on(pr) {
      if (pe.call(pr, "key")) {
        var Lr = Object.getOwnPropertyDescriptor(pr, "key").get;
        if (Lr && Lr.isReactWarning)
          return !1;
      }
      return pr.key !== void 0;
    }
    function en(pr, Lr) {
      if (typeof pr.ref == "string" && Er.current && Lr && Er.current.stateNode !== Lr) {
        var Fr = z(Er.current.type);
        Qr[Fr] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(Er.current.type), pr.ref), Qr[Fr] = !0);
      }
    }
    function zr(pr, Lr) {
      {
        var Fr = function() {
          Rr || (Rr = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Lr));
        };
        Fr.isReactWarning = !0, Object.defineProperty(pr, "key", {
          get: Fr,
          configurable: !0
        });
      }
    }
    function Jr(pr, Lr) {
      {
        var Fr = function() {
          Yr || (Yr = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Lr));
        };
        Fr.isReactWarning = !0, Object.defineProperty(pr, "ref", {
          get: Fr,
          configurable: !0
        });
      }
    }
    var H = function(pr, Lr, Fr, Br, W, Y, X) {
      var K = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: pr,
        key: Lr,
        ref: Fr,
        props: X,
        // Record the component responsible for creating this element.
        _owner: Y
      };
      return K._store = {}, Object.defineProperty(K._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(K, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Br
      }), Object.defineProperty(K, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: W
      }), Object.freeze && (Object.freeze(K.props), Object.freeze(K)), K;
    };
    function dr(pr, Lr, Fr, Br, W) {
      {
        var Y, X = {}, K = null, te = null;
        Fr !== void 0 && (xr(Fr), K = "" + Fr), on(Lr) && (xr(Lr.key), K = "" + Lr.key), nn(Lr) && (te = Lr.ref, en(Lr, W));
        for (Y in Lr)
          pe.call(Lr, Y) && !Ir.hasOwnProperty(Y) && (X[Y] = Lr[Y]);
        if (pr && pr.defaultProps) {
          var ie = pr.defaultProps;
          for (Y in ie)
            X[Y] === void 0 && (X[Y] = ie[Y]);
        }
        if (K || te) {
          var lr = typeof pr == "function" ? pr.displayName || pr.name || "Unknown" : pr;
          K && zr(X, lr), te && Jr(X, lr);
        }
        return H(pr, K, te, W, Br, Er.current, X);
      }
    }
    var Ar = _.ReactCurrentOwner, jr = _.ReactDebugCurrentFrame;
    function Vr(pr) {
      if (pr) {
        var Lr = pr._owner, Fr = ne(pr.type, pr._source, Lr ? Lr.type : null);
        jr.setExtraStackFrame(Fr);
      } else
        jr.setExtraStackFrame(null);
    }
    var Zr;
    Zr = !1;
    function pn(pr) {
      return typeof pr == "object" && pr !== null && pr.$$typeof === r;
    }
    function gr() {
      {
        if (Ar.current) {
          var pr = z(Ar.current.type);
          if (pr)
            return `

Check the render method of \`` + pr + "`.";
        }
        return "";
      }
    }
    function Cr(pr) {
      {
        if (pr !== void 0) {
          var Lr = pr.fileName.replace(/^.*[\\\/]/, ""), Fr = pr.lineNumber;
          return `

Check your code at ` + Lr + ":" + Fr + ".";
        }
        return "";
      }
    }
    var Pr = {};
    function Tr(pr) {
      {
        var Lr = gr();
        if (!Lr) {
          var Fr = typeof pr == "string" ? pr : pr.displayName || pr.name;
          Fr && (Lr = `

Check the top-level render call using <` + Fr + ">.");
        }
        return Lr;
      }
    }
    function Xr(pr, Lr) {
      {
        if (!pr._store || pr._store.validated || pr.key != null)
          return;
        pr._store.validated = !0;
        var Fr = Tr(Lr);
        if (Pr[Fr])
          return;
        Pr[Fr] = !0;
        var Br = "";
        pr && pr._owner && pr._owner !== Ar.current && (Br = " It was passed a child from " + z(pr._owner.type) + "."), Vr(pr), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Fr, Br), Vr(null);
      }
    }
    function rn(pr, Lr) {
      {
        if (typeof pr != "object")
          return;
        if (fr(pr))
          for (var Fr = 0; Fr < pr.length; Fr++) {
            var Br = pr[Fr];
            pn(Br) && Xr(Br, Lr);
          }
        else if (pn(pr))
          pr._store && (pr._store.validated = !0);
        else if (pr) {
          var W = x(pr);
          if (typeof W == "function" && W !== pr.entries)
            for (var Y = W.call(pr), X; !(X = Y.next()).done; )
              pn(X.value) && Xr(X.value, Lr);
        }
      }
    }
    function un(pr) {
      {
        var Lr = pr.type;
        if (Lr == null || typeof Lr == "string")
          return;
        var Fr;
        if (typeof Lr == "function")
          Fr = Lr.propTypes;
        else if (typeof Lr == "object" && (Lr.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Lr.$$typeof === p))
          Fr = Lr.propTypes;
        else
          return;
        if (Fr) {
          var Br = z(Lr);
          ze(Fr, pr.props, "prop", Br, pr);
        } else if (Lr.PropTypes !== void 0 && !Zr) {
          Zr = !0;
          var W = z(Lr);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", W || "Unknown");
        }
        typeof Lr.getDefaultProps == "function" && !Lr.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ln(pr) {
      {
        for (var Lr = Object.keys(pr.props), Fr = 0; Fr < Lr.length; Fr++) {
          var Br = Lr[Fr];
          if (Br !== "children" && Br !== "key") {
            Vr(pr), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Br), Vr(null);
            break;
          }
        }
        pr.ref !== null && (Vr(pr), $("Invalid attribute `ref` supplied to `React.Fragment`."), Vr(null));
      }
    }
    var bn = {};
    function $n(pr, Lr, Fr, Br, W, Y) {
      {
        var X = T(pr);
        if (!X) {
          var K = "";
          (pr === void 0 || typeof pr == "object" && pr !== null && Object.keys(pr).length === 0) && (K += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Cr(W);
          te ? K += te : K += gr();
          var ie;
          pr === null ? ie = "null" : fr(pr) ? ie = "array" : pr !== void 0 && pr.$$typeof === r ? (ie = "<" + (z(pr.type) || "Unknown") + " />", K = " Did you accidentally export a JSX literal instead of a component?") : ie = typeof pr, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ie, K);
        }
        var lr = dr(pr, Lr, Fr, W, Y);
        if (lr == null)
          return lr;
        if (X) {
          var vr = Lr.children;
          if (vr !== void 0)
            if (Br)
              if (fr(vr)) {
                for (var Mr = 0; Mr < vr.length; Mr++)
                  rn(vr[Mr], pr);
                Object.freeze && Object.freeze(vr);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              rn(vr, pr);
        }
        if (pe.call(Lr, "key")) {
          var br = z(pr), Dr = Object.keys(Lr).filter(function(Gr) {
            return Gr !== "key";
          }), Or = Dr.length > 0 ? "{key: someKey, " + Dr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[br + Or]) {
            var kr = Dr.length > 0 ? "{" + Dr.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Or, br, kr, br), bn[br + Or] = !0;
          }
        }
        return pr === a ? ln(lr) : un(lr), lr;
      }
    }
    function An(pr, Lr, Fr) {
      return $n(pr, Lr, Fr, !0);
    }
    function Nn(pr, Lr, Fr) {
      return $n(pr, Lr, Fr, !1);
    }
    var Pn = Nn, Tn = An;
    reactJsxRuntime_development.Fragment = a, reactJsxRuntime_development.jsx = Pn, reactJsxRuntime_development.jsxs = Tn;
  }()), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const Fragment = jsxRuntimeExports.Fragment, jsx$1 = jsxRuntimeExports.jsx, jsxs = jsxRuntimeExports.jsxs, ThemeProvider = ({
  children: t
}) => /* @__PURE__ */ jsxs(ThemeProvider$1, {
  theme: piccoloTheme,
  children: [/* @__PURE__ */ jsx$1(GlobalStyle, {}), t]
}), IconDotsMS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "24",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("g", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#dots_M_S_svg__a)",
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M11 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0M11 19a1 1 0 1 0 2 0 1 1 0 0 0-2 0M11 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
    })
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "dots_M_S_svg__a",
      children: /* @__PURE__ */ jsx$1("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
}), IconAddRoundedL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 20C1 9.50659 9.50659 1 20 1V1C30.4934 1 39 9.50659 39 20V20C39 30.4934 30.4934 39 20 39V39C9.50659 39 1 30.4934 1 20V20Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M27 20H13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 13L20 27",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddRoundedM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 16C1 7.71573 7.71573 1 16 1V1C24.2843 1 31 7.71573 31 16V16C31 24.2843 24.2843 31 16 31V31C7.71573 31 1 24.2843 1 16V16Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M22 16H10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 10L16 22",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddRoundedS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 12C1 5.92487 5.92487 1 12 1V1C18.0751 1 23 5.92487 23 12V12C23 18.0751 18.0751 23 12 23V23C5.92487 23 1 18.0751 1 12V12Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 12H8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 8L12 16",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddRoundedXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 8C1 4.13401 4.13401 1 8 1V1C11.866 1 15 4.13401 15 8V8C15 11.866 11.866 15 8 15V15C4.13401 15 1 11.866 1 8V8Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 5L8 11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 8L11 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
var IconColor = /* @__PURE__ */ ((t) => (t.default = "#3D3A62", t.active = "#0FB990", t.error = "#E0726B", t.error_strong = "#BC3E36", t.warning = "#E1A613", t.warning_strong = "#B79746", t.idle = "#D9D9D9", t.light = "#FFFFFF", t.cold = "#5A74D0", t.secondary = "#888888", t.success = "#207955", t))(IconColor || {});
const IconAddS$1 = ({
  width: t = 24,
  height: r = 24,
  color: n = IconColor.default
}) => /* @__PURE__ */ jsxs("svg", {
  width: t,
  height: r,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 5C3 3.89543 3.89543 3 5 3L19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z",
    stroke: n,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 12H9",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 9L12 15",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAlertM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 13V5M12 18v-1"
  })]
}), IconAlertS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M9 9V5M9 13v-2"
  })]
}), IconAlertSThin = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: t
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    d: "M9 9V5M9 13v-2"
  })]
}), IconAppleDark = ({
  width: t = 32,
  height: r = 32
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    fill: "#0B0B0A",
    d: "M0 16.186c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16Z"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.511 6.586c.168 1.138-.295 2.252-.906 3.04-.654.847-1.78 1.501-2.872 1.467-.2-1.09.311-2.212.932-2.966.68-.833 1.848-1.472 2.846-1.541Zm3.28 16.014c.562-.862.772-1.297 1.209-2.27-3.177-1.209-3.686-5.726-.542-7.46-.959-1.202-2.307-1.9-3.579-1.9-.917 0-1.545.24-2.116.457-.475.181-.912.348-1.442.348-.573 0-1.08-.182-1.613-.373-.584-.21-1.197-.43-1.957-.43-1.428 0-2.947.873-3.91 2.364-1.355 2.1-1.124 6.05 1.072 9.413.785 1.204 1.834 2.556 3.206 2.569.569.005.948-.165 1.358-.349.469-.21.979-.439 1.861-.443.889-.006 1.39.226 1.853.44.4.183.77.354 1.335.348 1.372-.01 2.48-1.51 3.264-2.714Z",
    clipRule: "evenodd"
  })]
}), IconAppleLight = ({
  width: t = 32,
  height: r = 32
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    fill: "#fff",
    d: "M0 16.186c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16Z"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: "#0B0B0A",
    fillRule: "evenodd",
    d: "M19.511 6.586c.168 1.138-.295 2.252-.906 3.041-.654.846-1.78 1.5-2.872 1.466-.2-1.09.311-2.212.932-2.966.68-.833 1.848-1.472 2.846-1.54Zm3.28 16.014c.562-.862.772-1.297 1.209-2.27-3.177-1.209-3.686-5.726-.542-7.46-.959-1.202-2.307-1.9-3.579-1.9-.917 0-1.545.24-2.116.457-.475.182-.912.348-1.442.348-.573 0-1.08-.182-1.613-.373-.584-.21-1.197-.43-1.957-.43-1.428 0-2.947.873-3.91 2.365-1.355 2.1-1.124 6.049 1.072 9.412.785 1.204 1.834 2.556 3.206 2.569.569.005.948-.165 1.358-.348.469-.21.979-.44 1.861-.444.889-.006 1.39.226 1.853.44.4.184.77.354 1.335.348 1.372-.01 2.48-1.51 3.264-2.713Z",
    clipRule: "evenodd"
  })]
}), IconArrowBottomM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m18 9.186-6 6-6-6"
  })
}), IconArrowBottomS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m13 6.186-5 5-5-5"
  })
}), IconArrowBottomStoppedMsvg = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m18 6.186-6 6-6-6M18 17.186H6"
  })
}), IconArrowDropBottomM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "m11.808 14.956-3.715-4.458a.8.8 0 0 1 .615-1.312h6.584a.8.8 0 0 1 .614 1.312l-3.714 4.458a.25.25 0 0 1-.384 0Z"
  })
}), IconArrowDropLeftM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "m9.23 11.994 4.458-3.715A.8.8 0 0 1 15 8.894v6.584a.8.8 0 0 1-1.312.615L9.23 12.378a.25.25 0 0 1 0-.384Z"
  })
}), IconArrowDropRightM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "m14.77 12.378-4.458 3.715A.8.8 0 0 1 9 15.478V8.894a.8.8 0 0 1 1.312-.615l4.458 3.715c.12.1.12.284 0 .384Z"
  })
}), IconArrowDropTopM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "m12.192 9.416 3.714 4.458a.8.8 0 0 1-.614 1.312H8.708a.8.8 0 0 1-.615-1.312l3.715-4.458a.25.25 0 0 1 .384 0Z"
  })
}), IconArrowLeftM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m15 18.186-6-6 6-6"
  })
}), IconArrowLeftS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m10 13.186-5-5 5-5"
  })
}), IconArrowLeftStoppedMsvg = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m18 18.186-6-6 6-6M7 18.186v-12"
  })
}), IconArrowRightM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m9 6.186 6 6-6 6"
  })
}), IconArrowRightS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M9 6L15 12L9 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}), IconArrowRightStoppedMsvg = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m6 6.186 6 6-6 6M17 6.186v12"
  })
}), IconArrowRightXS = ({
  color: t,
  width: r = 8,
  height: n = 8
}) => /* @__PURE__ */ jsx$1("svg", {
  width: r,
  height: n,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M1 7L4 4L1 1",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}), IconArrowTopM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m6 15.186 6-6 6 6"
  })
}), IconArrowTopS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m3 10.186 5-5 5 5"
  })
}), IconArrowTopStoppedM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m6 18.186 6-6 6 6M6 7.186h12"
  })
}), IconBinS$1 = ({
  width: t = 24,
  height: r = 24,
  color: n = IconColor.default
}) => /* @__PURE__ */ jsxs("svg", {
  width: t,
  height: r,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M5 7V21C5 22.1046 5.89543 23 7 23H17C18.1046 23 19 22.1046 19 21V7",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 1H9",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 4H3",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 18V10",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 18V10",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconBpm = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    fill: "#0FB990",
    fillRule: "evenodd",
    d: "M4 13.767c0-.462.375-.837.837-.837h22.326a.837.837 0 1 1 0 1.675H4.837A.837.837 0 0 1 4 13.767Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: "#0FB990",
    fillRule: "evenodd",
    d: "M16 12.93c.462 0 .837.375.837.837v13.396a.837.837 0 1 1-1.674 0V13.767c0-.462.375-.837.837-.837Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: "#0FB990",
    fillRule: "evenodd",
    d: "M11.814 4.837c0-.462.375-.837.837-.837h6.698c2.873 0 5.102.57 6.592 2.06C27.43 7.548 28 9.777 28 12.65v6.698c0 2.873-.57 5.102-2.06 6.592C24.452 27.43 22.223 28 19.35 28H12.65c-2.873 0-5.102-.57-6.592-2.06C4.57 24.452 4 22.223 4 19.35V12.65c0-3.14.686-5.512 2.496-6.989A.837.837 0 0 1 7.554 6.96c-1.226 1.002-1.88 2.737-1.88 5.692v6.698c0 2.708.547 4.386 1.57 5.408 1.021 1.022 2.699 1.569 5.407 1.569h6.698c2.708 0 4.386-.547 5.408-1.57 1.022-1.021 1.569-2.7 1.569-5.407V12.65c0-2.708-.547-4.386-1.57-5.408-1.021-1.022-2.7-1.569-5.407-1.569H12.65a.837.837 0 0 1-.837-.837Z",
    clipRule: "evenodd"
  })]
}), IconBriefcaseM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 3h-4M13 10h-2"
  }), /* @__PURE__ */ jsx$1("rect", {
    width: 18,
    height: 15,
    x: 3,
    y: 6,
    stroke: t,
    strokeWidth: 2,
    rx: 2
  }), /* @__PURE__ */ jsx$1("rect", {
    width: 18,
    height: 8,
    x: 3,
    y: 6,
    stroke: t,
    strokeWidth: 2,
    rx: 2
  })]
}), IconBureaucracy = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M21 14V9c0-.943 0-1.414-.293-1.707C20.414 7 19.943 7 19 7h-4.343c-.818 0-1.226 0-1.594-.152-.368-.152-.657-.442-1.235-1.02l-.656-.656c-.579-.578-.867-.868-1.235-1.02C9.569 4 9.16 4 8.343 4H7c-1.886 0-2.828 0-3.414.586C3 5.172 3 6.114 3 8v8c0 1.886 0 2.828.586 3.414C4.172 20 5.114 20 7 20h8"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 3.5,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m16 16 4 4"
  })]
}), CalculatorM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsxs("g", {
    id: "icon",
    children: [/* @__PURE__ */ jsx$1("rect", {
      id: "Rectangle 2085",
      x: "4",
      y: "4",
      width: "32",
      height: "32",
      rx: "4",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1635",
      d: "M20 4V36",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1636",
      d: "M4 20L36 20",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1637",
      d: "M12 9V15",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1640",
      d: "M30.2422 25.8789L25.9995 30.1215",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1638",
      d: "M9 12L15 12",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1643",
      d: "M9 28L15 28",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1641",
      d: "M26 25.8789L30.2426 30.1215",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 1639",
      d: "M25 12L31 12",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("circle", {
      id: "Ellipse 621",
      cx: "1",
      cy: "1",
      r: "1",
      transform: "matrix(1 0 0 -1 11 26)",
      fill: t
    }), /* @__PURE__ */ jsx$1("circle", {
      id: "Ellipse 622",
      cx: "1",
      cy: "1",
      r: "1",
      transform: "matrix(1 0 0 -1 11 32)",
      fill: t
    })]
  })
}), CalendarM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_6288_29491)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M5 9C5 6.79086 6.79086 5 9 5H31C33.2091 5 35 6.79086 35 9V31C35 33.2091 33.2091 35 31 35H9C6.79086 35 5 33.2091 5 31V9Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M35 14H6",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M14 20H10",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M22 20H18",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 20H26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M14 25H10",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M22 25H18",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 25H26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M14 30H10",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M22 30H18",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 30H26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_6288_29491",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconCallXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    clipPath: "url(#CallXS_svg__a)",
    children: [/* @__PURE__ */ jsx$1("path", {
      strokeLinejoin: "round",
      d: "M11 8a3 3 0 0 0-3-3M15 8a7 7 0 0 0-7-7"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M11 15C5.477 15 1 10.523 1 5"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M11 13c-.893 0-1.757-.13-2.571-.373M3 5c0 .894.13 1.757.373 2.571"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "CallXS_svg__a",
      children: /* @__PURE__ */ jsx$1("path", {
        fill: "#fff",
        d: "M0 0h16v16H0z"
      })
    })
  })]
}), CheckboxCheckedXS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    stroke: t,
    strokeWidth: 2,
    clipPath: "url(#checkbox_checked_M_XS_svg__a)",
    children: [/* @__PURE__ */ jsx$1("rect", {
      width: 14,
      height: 14,
      x: 1,
      y: 1,
      rx: 1
    }), /* @__PURE__ */ jsx$1("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m11 6.5-4 4-2-2"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "checkbox_checked_M_XS_svg__a",
      children: /* @__PURE__ */ jsx$1("path", {
        fill: "#fff",
        d: "M0 0h16v16H0z"
      })
    })
  })]
}), CheckboxXS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("g", {
    clipPath: "url(#checkbox_M_XS_svg__a)",
    children: /* @__PURE__ */ jsx$1("rect", {
      width: 14,
      height: 14,
      x: 1,
      y: 1,
      stroke: t,
      strokeWidth: 2,
      rx: 1
    })
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "checkbox_M_XS_svg__a",
      children: /* @__PURE__ */ jsx$1("path", {
        fill: "#fff",
        d: "M0 0h16v16H0z"
      })
    })
  })]
}), IconClavemM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("g", {
    clipPath: "url(#clavem_M_svg__a)",
    children: /* @__PURE__ */ jsx$1("path", {
      fill: t,
      d: "M15.983 0C24.71 0 31.8 7.218 31.94 16.177l.002.272h-2.418c0-7.708-6.062-13.957-13.54-13.957-7.48 0-13.542 6.249-13.542 13.957 0 7.631 5.942 13.832 13.317 13.955l.224.002v2.492C7.17 32.898.024 25.534.024 16.45.024 7.365 7.17 0 15.984 0M15.5 8.723c2.233 0 4.23 1.075 5.561 2.765v-.771h2.418V22.18h-2.418v-.771c-1.33 1.69-3.328 2.765-5.561 2.765-4.007 0-7.254-3.459-7.254-7.726s3.247-7.726 7.254-7.726m0 5.483c-.802 0-1.451.67-1.451 1.495 0 .541.278 1.015.695 1.277l.03.019v1.695l.605.748h.483v-.748h.121v-.249h-.12v-.374h.241v-1.008c.5-.236.847-.756.847-1.36 0-.825-.65-1.495-1.451-1.495m0 1.246c.133 0 .242.112.242.25 0 .137-.109.249-.242.249a.246.246 0 0 1-.242-.25c0-.137.108-.249.242-.249"
    })
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clavem_M_svg__a",
      children: /* @__PURE__ */ jsx$1("path", {
        fill: "#fff",
        d: "M0 0h32v32.898H0z"
      })
    })
  })]
}), ClockXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  viewBox: "0 0 16 17",
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_5780_15834)",
    children: [/* @__PURE__ */ jsxs("mask", {
      id: "mask0_5780_15834",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "16",
      height: "17",
      children: [/* @__PURE__ */ jsx$1("rect", {
        x: "2",
        y: "3.5",
        width: "12",
        height: "12",
        rx: "6",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M6 6.5L8 8.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M10 7.5L8 8.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M3 1.5L1 3.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M15 3.5L13 1.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /* @__PURE__ */ jsx$1("g", {
      mask: "url(#mask0_5780_15834)",
      children: /* @__PURE__ */ jsx$1("rect", {
        y: "0.5",
        width: "16",
        height: "16",
        fill: t
      })
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_5780_15834",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    })
  })]
}), IconCloud = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "m10.528 8 .745.667-.298.333h-.447V8ZM15 7c-1.48 0-2.81.642-3.727 1.667l-1.49-1.334A6.985 6.985 0 0 1 15 5v2Zm5 5a5 5 0 0 0-5-5V5a7 7 0 0 1 7 7h-2Zm-5 5a5 5 0 0 0 5-5h2a7 7 0 0 1-7 7v-2Zm-7 0h7v2H8v-2Zm-4-4a4 4 0 0 0 4 4v2a6 6 0 0 1-6-6h2Zm4-4a4 4 0 0 0-4 4H2a6 6 0 0 1 6-6v2Zm2.528 0H8V7h2.528v2Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M16.318 17.854A6 6 0 1 0 9 12.024"
  })]
}), IconCopiar = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("rect", {
    width: 11,
    height: 14,
    x: 8.5,
    y: 10.5,
    stroke: t,
    rx: 0.5
  }), /* @__PURE__ */ jsx$1("rect", {
    width: 11,
    height: 14,
    x: 11.5,
    y: 7.5,
    stroke: t,
    rx: 0.5
  })]
}), IconCoupleXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  viewBox: "0 0 16 17",
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_5780_10727)",
    children: [/* @__PURE__ */ jsxs("mask", {
      id: "mask0_5780_10727",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "-1",
      y: "0",
      width: "18",
      height: "17",
      children: [/* @__PURE__ */ jsx$1("circle", {
        cx: "11.5",
        cy: "8",
        r: "2.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /* @__PURE__ */ jsx$1("circle", {
        cx: "4.5",
        cy: "4",
        r: "2.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M15 15.5C15 15.5 14.5 13.5 11.5 13.5C8.5 13.5 8 15.5 8 15.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M1 11.5C1 11.5 1.5 9.5 4.5 9.5C5.09233 9.5 5.5872 9.57797 6 9.70311",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /* @__PURE__ */ jsx$1("g", {
      mask: "url(#mask0_5780_10727)",
      children: /* @__PURE__ */ jsx$1("rect", {
        y: "0.5",
        width: "16",
        height: "16",
        fill: t
      })
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_5780_10727",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    })
  })]
}), IconCrossAccentM = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#5A74D0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14 14 2 2M14 2 2 14"
  })
}), IconCrossAccentS = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#5A74D0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M7 1 1 7M1 1l6 6"
  })
}), IconCrossAccentXs = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#5A74D0",
    strokeLinecap: "round",
    d: "M5 1 1 5M1 1l4 4"
  })
}), IconCrossDangerM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M14 14 2 2M14 2 2 14"
  })
}), IconCrossDangerS = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#FB6B62",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M7 1 1 7M1 1l6 6"
  })
}), IconCrossDarkM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14 14 2 2M14 2 2 14"
  })
}), IconCrossDarkS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M7 1 1 7M1 1l6 6"
  })
}), IconCrossLightM = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14 14 2 2M14 2 2 14"
  })
}), IconCrossLightS = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M7 1 1 7M1 1l6 6"
  })
}), CorssS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M21 3L3 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3L21 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconDangerAttentionSolidM = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: "#FB6B62"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M12 14.186v-9M12 18.186v-2"
  })]
}), IconDangerAttentionSolidS = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: "#FB6B62"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M8 8.186v-4M8 12.186v-2"
  })]
}), IconDangerCrossLineM = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 11,
    stroke: "#FB6B62",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#FB6B62",
    strokeWidth: 2,
    d: "m16 16.186-8-8M16 8.186l-8 8"
  })]
}), IconDangerCrossLineS = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 7,
    stroke: "#FB6B62",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#FB6B62",
    strokeWidth: 2,
    d: "m11 11.186-6-6M11 5.186l-6 6"
  })]
}), IconDangerCrossSolidM = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: "#FB6B62"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m16 16.186-8-8M16 8.186l-8 8"
  })]
}), IconDangerCrossSolidS = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: "#FB6B62"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m11 11.186-6-6M11 5.186l-6 6"
  })]
}), IconDashboard = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("rect", {
    width: 16,
    height: 10,
    x: 4,
    y: 11,
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6 7h12M8 3h8"
  })]
}), IconDateCalendar = () => /* @__PURE__ */ jsxs("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "4.5",
    y: "4",
    width: "16",
    height: "17",
    stroke: "#3D3A62",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4.5 9H20.5",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.5 12L12.5 14",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.5 12L16.5 14",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8.5 16L8.5 18",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.5 16L12.5 18",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8.5 2L8.5 6",
    stroke: "#3D3A62",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.5 2L16.5 6",
    stroke: "#3D3A62",
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconDoubtsM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M9 9v0a3 3 0 0 1 3-3v0c1.657 0 3 1.37 3 3.027v0c0 .923-.42 1.809-1.14 2.386l-1.289 1.031a1.85 1.85 0 0 0-.694 1.445V15M11.877 18.5v.5"
  })]
}), IconDoubtsS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6 6v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-.8 1.6l-.756.567c-.28.21-.444.539-.444.889V9.5M8 12v.5"
  })]
}), IconDoubtsSThin = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: t
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    d: "M6 6v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-.8 1.6l-.756.567c-.28.21-.444.539-.444.889V9.5M8 11.5v.5"
  })]
}), IconEdit = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 16v4H6V4h12v1"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M11.293 15.293a1 1 0 1 0 1.414 1.414l-1.414-1.414Zm1.414 1.414 8-8-1.414-1.414-8 8 1.414 1.414ZM22.707 6.707a1 1 0 0 0-1.414-1.414l1.414 1.414Zm-1.414-1.414-1 1 1.414 1.414 1-1-1.414-1.414Z"
  })]
}), IconEditSabina = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.217 13H3"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: "#fff",
    stroke: t,
    strokeWidth: 1.5,
    d: "M3.62 8.47a.25.25 0 0 1 .055-.085l6.148-6.148a.25.25 0 0 1 .354 0l1.586 1.586a.25.25 0 0 1 0 .354l-6.148 6.148a.25.25 0 0 1-.084.055l-2.643 1.057a.25.25 0 0 1-.325-.325L3.62 8.47Z"
  })]
}), IconEmailL = ({
  color: t,
  width: r = 40,
  height: n = 40
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 10a4 4 0 0 1 4-4h30a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M38 8 20 20 2 8"
  })]
}), IconEmailM = ({
  color: t,
  width: r = 32,
  height: n = 32
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("rect", {
    width: 30,
    height: 22,
    x: 1,
    y: 5,
    stroke: t,
    strokeWidth: 2,
    rx: 3
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M30 6 16 16 2 6"
  })]
}), IconEmailS = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m22 6-10 6L2 6"
  }), /* @__PURE__ */ jsx$1("rect", {
    width: 22,
    height: 14,
    x: 1,
    y: 5,
    stroke: t,
    strokeWidth: 2,
    rx: 2
  })]
}), IconEmailXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M14 4L8 8L2 4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "1",
    y: "3",
    width: "14",
    height: "10",
    rx: "1",
    stroke: t,
    strokeWidth: "2"
  })]
}), EntityM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsxs("g", {
    id: "icon",
    children: [/* @__PURE__ */ jsx$1("rect", {
      id: "Rectangle 1508",
      x: "4",
      y: "30",
      width: "32",
      height: "6",
      stroke: t,
      strokeWidth: "2",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Rectangle 1510",
      d: "M4 8.2L19.9484 4L36 8.2V11L4 11V8.2Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 870",
      d: "M8 15V26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 871",
      d: "M14 15V26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 872",
      d: "M20 15V26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 876",
      d: "M18 8L22 8",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 873",
      d: "M26 15V26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 874",
      d: "M32 15V26",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  })
}), IconExpediente = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M3 7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 4 5.08 4 6.2 4h1.965c.626 0 .939 0 1.223.086a2 2 0 0 1 .689.369c.23.188.403.449.75.97l.1.15c.348.521.521.782.75.97a2 2 0 0 0 .69.369C12.65 7 12.963 7 13.59 7h4.21c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 8.52 21 9.08 21 10.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 19 18.92 19 17.8 19H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 17.48 3 16.92 3 15.8V7.2Z"
  })
}), IconFlowNavArrowLeft = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  width: "48px",
  height: "48px",
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    stroke: t,
    strokeWidth: 2,
    clipPath: "url(#Icon_svg__a)",
    children: [/* @__PURE__ */ jsx$1("path", {
      strokeLinecap: "square",
      d: "m27 17-7 8 7 8"
    }), /* @__PURE__ */ jsx$1("rect", {
      width: 46,
      height: 46,
      x: 47,
      y: 47,
      strokeLinecap: "round",
      rx: 23,
      transform: "rotate(-180 47 47)"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "Icon_svg__a",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: 48,
        height: 48,
        x: 48,
        y: 48,
        fill: "#fff",
        rx: 24,
        transform: "rotate(-180 48 48)"
      })
    })
  })]
}), IconFlowNavArrowRight = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  width: "48px",
  height: "48px",
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    stroke: t,
    strokeWidth: 2,
    clipPath: "url(#FlowNavArrowRight_svg__a)",
    children: [/* @__PURE__ */ jsx$1("path", {
      strokeLinecap: "square",
      d: "m21 31 7-8-7-8"
    }), /* @__PURE__ */ jsx$1("rect", {
      width: 46,
      height: 46,
      x: 1,
      y: 1,
      strokeLinecap: "round",
      rx: 23
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "FlowNavArrowRight_svg__a",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: 48,
        height: 48,
        fill: "#fff",
        rx: 24
      })
    })
  })]
}), IconGraphsM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: t,
    strokeWidth: 2,
    rx: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14 9v6M6 11v4M10 13v2M18 13v2"
  })]
}), IconHelmetM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M15 7V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 13,
    r: 3,
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6 16H3a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-3M20 12c0-1.941-.85-3.615-2-5M4 12c0-1.941.85-3.615 2-5"
  })]
}), IconHelp = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    stroke: "#0FB990",
    strokeWidth: 2,
    transform: "rotate(-45 16 16)"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 16,
    cy: 16,
    r: 6,
    stroke: "#0FB990",
    strokeWidth: 2,
    transform: "rotate(-45 16 16)"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m8 24 3-3M24 24l-3-3M21 11l3-3M11 11 8 8"
  })]
}), HelpXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  viewBox: "0 0 16 17",
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_5780_15878)",
    children: [/* @__PURE__ */ jsx$1("mask", {
      id: "mask0_5780_15878",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "16",
      height: "17",
      children: /* @__PURE__ */ jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 8.5C2 7.20417 2.41079 6.00428 3.10925 5.02347L1.68014 3.59436C0.627082 4.94904 0 6.65129 0 8.5C0 10.3487 0.627095 12.051 1.68018 13.4057L3.10928 11.9766C2.4108 10.9957 2 9.79585 2 8.5ZM3 8.5C3 7.48092 3.30488 6.53304 3.8284 5.74261L5.29237 7.20658C5.10495 7.59822 5 8.03685 5 8.5C5 8.96315 5.10496 9.40179 5.29238 9.79343L3.82842 11.2574C3.30488 10.467 3 9.51909 3 8.5ZM5.24261 4.3284L6.70658 5.79237C7.09822 5.60495 7.53685 5.5 8 5.5C8.46315 5.5 8.90178 5.60495 9.29342 5.79237L10.7574 4.3284C9.96696 3.80488 9.01908 3.5 8 3.5C6.98092 3.5 6.03304 3.80488 5.24261 4.3284ZM3.09436 2.18014L4.52347 3.60925C5.50428 2.91079 6.70417 2.5 8 2.5C9.29583 2.5 10.4957 2.91079 11.4765 3.60925L12.9056 2.18014C11.551 1.12708 9.84871 0.5 8 0.5C6.15129 0.5 4.44904 1.12708 3.09436 2.18014ZM4.5235 13.3908L3.0944 14.8199C4.44908 15.8729 6.15131 16.5 8 16.5C9.84873 16.5 11.551 15.8729 12.9057 14.8198L11.4766 13.3907C10.4958 14.0892 9.29585 14.5 8 14.5C6.70418 14.5 5.50431 14.0892 4.5235 13.3908ZM12.8908 11.9765L14.3199 13.4056C15.3729 12.0509 16 10.3487 16 8.5C16 6.65129 15.3729 4.94904 14.3199 3.59436L12.8907 5.02347C13.5892 6.00428 14 7.20417 14 8.5C14 9.79581 13.5892 10.9957 12.8908 11.9765ZM12.1716 11.2573L10.7077 9.79335C10.8951 9.40173 11 8.96312 11 8.5C11 8.03685 10.895 7.59822 10.7076 7.20658L12.1716 5.74261C12.6951 6.53304 13 7.48092 13 8.5C13 9.51906 12.6951 10.4669 12.1716 11.2573ZM9.29348 11.2076L10.7574 12.6716C9.967 13.1951 9.01911 13.5 8 13.5C6.98093 13.5 6.03307 13.1951 5.24264 12.6716L6.7066 11.2076C7.09823 11.3951 7.53686 11.5 8 11.5C8.46317 11.5 8.90183 11.395 9.29348 11.2076Z",
        fill: t
      })
    }), /* @__PURE__ */ jsx$1("g", {
      mask: "url(#mask0_5780_15878)",
      children: /* @__PURE__ */ jsx$1("rect", {
        y: "0.5",
        width: "16",
        height: "16",
        fill: t
      })
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_5780_15878",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    })
  })]
}), IconHiddenCoinM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m2.95 20.95 18-18"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeDasharray: "2 4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.5 5.5a9.192 9.192 0 0 1-13 13"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.5 5.5a9.192 9.192 0 0 0-13 13"
  })]
}), HidePassword = () => /* @__PURE__ */ jsxs("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12.5",
    cy: "12",
    r: "4",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M22.5 12C22.5 12 18.0228 19 12.5 19C6.97715 19 2.5 12 2.5 12C2.5 12 6.97715 5 12.5 5C18.0228 5 22.5 12 22.5 12Z",
    stroke: "#3D3A62",
    strokeWidth: "2"
  })]
}), IconHome = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M4 12.785c0-1.354 0-2.03.314-2.626.313-.595.902-1.035 2.08-1.916l1.143-.855C9.667 5.796 10.732 5 12 5c1.268 0 2.333.796 4.463 2.388l1.142.855c1.179.88 1.768 1.321 2.081 1.916.314.595.314 1.272.314 2.626v4.227c0 1.88 0 2.82-.67 3.404-.669.584-1.746.584-3.901.584H8.57c-2.155 0-3.232 0-3.902-.584C4 19.832 4 18.892 4 17.012v-4.227Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 21v-5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5"
  })]
}), IconHomeMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M9 8H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m1 5 6.008-3.433a2 2 0 0 1 1.984 0L15 5"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: t,
    fillRule: "evenodd",
    d: "M13 7.009V13H3V7.009l-1.504.86A1 1 0 0 1 1 8v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8a1 1 0 0 1-.496-.132z",
    clipRule: "evenodd"
  })]
}), IconHouseM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M3 12v5c0 1.886 0 2.828.586 3.414C4.172 21 5.114 21 7 21h10c1.886 0 2.828 0 3.414-.586C21 19.828 21 18.886 21 17v-5M3 8l7.057-3.92c.95-.528 1.425-.792 1.943-.792s.993.264 1.943.791L21 8"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M14 20v-4a2 2 0 1 0-4 0v4"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M7 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM17 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })]
}), IconInfoLineMDark = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 11,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M12 18.186v-7M12 9.186v-2"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#FB6B62",
    d: "M0 .186h24v24H0z"
  })]
}), IconInfoLineMLight = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 11,
    stroke: "#fff",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M12 18.186v-7M12 9.186v-2"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#FB6B62",
    d: "M0 .186h24v24H0z"
  })]
}), IconInfoLineSDark = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 7,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M8 7.186v5M8 4.186v2"
  })]
}), IconInfoLineSLight = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 7,
    stroke: "#fff",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M8 7.186v5M8 4.186v2"
  })]
}), IconInfoSolidMDark = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M12 18.186v-7M12 9.186v-2"
  })]
}), IconInfoSolidMLight = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: "#fff"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M12 18.186v-7M12 9.186v-2"
  })]
}), IconInfoSolidSDark = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M8 7.186v5M8 4.186v2"
  })]
}), IconInfoSolidSLight = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: "#fff"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M8 7.186v5M8 4.186v2"
  })]
}), IconInfoSolidXSLight = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8",
    r: "8",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 7L8 13",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 4V6",
    stroke: "#3D3A62",
    strokeWidth: "2"
  })]
}), IconLike = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m5.17 13.648 6.298 5.857c.18.168.27.251.371.286a.501.501 0 0 0 .322 0c.101-.035.191-.119.371-.286l6.298-5.857a4.71 4.71 0 0 0 .5-6.355l-.257-.328c-1.794-2.29-5.367-1.903-6.63.717a.491.491 0 0 1-.885 0c-1.264-2.62-4.837-3.006-6.631-.717l-.257.328a4.71 4.71 0 0 0 .5 6.355Z"
  })
}), IconMgm = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M9.848 5.346C10.76 3.116 11.216 2 12 2s1.24 1.115 2.152 3.346l.043.104c.515 1.26.772 1.89 1.297 2.273.525.383 1.214.443 2.593.564l.249.022c2.256.198 3.384.297 3.625 1.002.242.704-.596 1.451-2.271 2.947l-.56.499c-.848.757-1.272 1.135-1.47 1.631a2.24 2.24 0 0 0-.091.284c-.13.517-.006 1.066.243 2.164l.077.342c.456 2.018.684 3.027.286 3.462-.149.163-.342.28-.557.338-.576.154-1.392-.5-3.026-1.805-1.072-.857-1.609-1.286-2.224-1.383a2.36 2.36 0 0 0-.732 0c-.615.097-1.152.526-2.224 1.383-1.634 1.306-2.45 1.959-3.026 1.805a1.162 1.162 0 0 1-.557-.338c-.398-.435-.17-1.444.286-3.462l.077-.342c.249-1.098.373-1.647.243-2.164a2.251 2.251 0 0 0-.092-.284c-.197-.496-.621-.874-1.47-1.631l-.559-.5C2.637 10.763 1.8 10.016 2.041 9.312c.241-.705 1.37-.804 3.625-1.002l.25-.022c1.378-.12 2.067-.181 2.592-.564.525-.383.782-1.013 1.298-2.273l.042-.104Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 10v4.243M10 12h4"
  })]
}), IconMoneyUpMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16px",
  height: "16px",
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 3 2 14M8 2h6v6M12 12.284A5.858 5.858 0 0 1 3.716 4"
  })
}), IconNotification = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M26.95 35.306a3.896 3.896 0 1 1-5.509 0"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M24.061 35.106H10.84c-1.7 0-2.755-1.846-1.894-3.31l2.215-3.768a12.205 12.205 0 0 0 1.683-6.185v-6.26c0-5.392 4.371-9.764 9.764-9.764h1.453M24.061 35.106H37.27c1.702 0 2.757-1.852 1.89-3.316l-2.18-3.683a12.204 12.204 0 0 1-1.701-6.216v-6.308c0-5.392-4.372-9.764-9.764-9.764h-1.454"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 34.654,
    cy: 9.403,
    r: 4.403,
    fill: "#FB6B62"
  })]
}), IconNumber1S = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    y: "0.505005",
    width: "24",
    height: "24",
    rx: "12",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.0983 17.505V10.561H9.77427V9.175C11.6363 9.175 12.2243 8.699 12.2243 7.705H13.9463V17.505H12.0983Z",
    fill: "white"
  })]
}), IconNumber2S = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    y: "0.505005",
    width: "24",
    height: "24",
    rx: "12",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8.83644 17.505V15.951C8.83644 14.649 9.43844 13.823 10.7404 13.025L12.5464 11.905C13.0784 11.569 13.4144 11.149 13.4144 10.519C13.4144 9.805 12.8964 9.231 11.9724 9.231C11.1044 9.231 10.5444 9.875 10.5444 10.603H8.82244C8.82244 9.063 9.92844 7.523 12.0004 7.523C14.0304 7.523 15.2764 8.867 15.2764 10.449C15.2764 11.723 14.6604 12.577 13.4984 13.277L11.6224 14.411C10.9084 14.859 10.6844 15.223 10.6844 15.727V15.867H15.3044V17.505H8.83644Z",
    fill: "white"
  })]
}), IconNumber3S = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    y: "0.505005",
    width: "24",
    height: "24",
    rx: "12",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11.9754 17.673C9.86139 17.673 8.76939 16.091 8.76939 14.593H10.4914C10.5194 15.335 11.0934 15.923 11.9614 15.923C12.8994 15.923 13.5154 15.321 13.5154 14.439C13.5154 13.627 12.8994 12.969 11.9334 12.969H10.6314V11.527L12.8014 9.455V9.357H8.96539V7.705H15.0834V9.329L12.8574 11.443V11.527C14.2854 11.709 15.3774 12.885 15.3774 14.425C15.3774 16.147 14.1314 17.673 11.9754 17.673Z",
    fill: "white"
  })]
}), IconNumber4S = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    y: "0.505005",
    width: "24",
    height: "24",
    rx: "12",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.6728 17.505V15.531H8.40282V14.005L11.0628 7.705H12.9808L10.4328 13.809V13.893H12.6728V11.807H14.5068V13.893H15.5988V15.531H14.5068V17.505H12.6728Z",
    fill: "white"
  })]
}), IconOutputM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M3 3h9a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3M3 12h19"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20 8 3 4-3 4"
  })]
}), PadLock = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  width: r,
  height: n,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "6.5",
    y: "11",
    width: "12",
    height: "10",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8.5 7C8.5 4.79086 10.2909 3 12.5 3V3C14.7091 3 16.5 4.79086 16.5 7V11H8.5V7Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.5 14L12.5 17",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconPdfS$1 = ({
  width: t = 24,
  height: r = 24,
  color: n = IconColor.default
}) => /* @__PURE__ */ jsxs("svg", {
  width: t,
  height: r,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 6.5C3 4.84315 4.34315 3.5 6 3.5H11.8849C12.6805 3.5 13.4436 3.81607 14.0062 4.37868L20.1213 10.4938C20.6839 11.0564 21 11.8195 21 12.6151V18.5C21 20.1569 19.6569 21.5 18 21.5H6C4.34315 21.5 3 20.1569 3 18.5V6.5Z",
    stroke: n,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 12.5H7",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 16.5H7",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13 3.5V8.5C13 10.1569 14.3431 11.5 16 11.5H21",
    stroke: n,
    strokeWidth: "2"
  })]
}), PdfXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  viewBox: "0 0 16 17",
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_5780_15807)",
    children: [/* @__PURE__ */ jsxs("mask", {
      id: "mask0_5780_15807",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "16",
      height: "17",
      children: [/* @__PURE__ */ jsx$1("path", {
        d: "M2 3.5C2 2.94772 2.44772 2.5 3 2.5H8.58579C8.851 2.5 9.10536 2.60536 9.29289 2.79289L13.7071 7.20711C13.8946 7.39464 14 7.649 14 7.91421V13.5C14 14.0523 13.5523 14.5 13 14.5H3C2.44772 14.5 2 14.0523 2 13.5V3.5Z",
        stroke: t,
        strokeWidth: "2"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M8 11.5H5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M8 2.5V6.5C8 7.60457 8.89543 8.5 10 8.5H14",
        stroke: t,
        strokeWidth: "2"
      })]
    }), /* @__PURE__ */ jsx$1("g", {
      mask: "url(#mask0_5780_15807)",
      children: /* @__PURE__ */ jsx$1("rect", {
        y: "0.5",
        width: "16",
        height: "16",
        fill: t
      })
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_5780_15807",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    })
  })]
}), IconPercentageM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7.95 15.95 8-8"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM15.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /* @__PURE__ */ jsx$1("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: t,
    strokeWidth: 2,
    rx: 2
  })]
}), IconPicture = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M3 11c0-3.771 0-5.657 1.172-6.828C5.343 3 7.229 3 11 3h2c3.771 0 5.657 0 6.828 1.172C21 5.343 21 7.229 21 11v2c0 3.771 0 5.657-1.172 6.828C18.657 21 16.771 21 13 21h-2c-3.771 0-5.657 0-6.828-1.172C3 18.657 3 16.771 3 13v-2Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m3 14.5 2.203-2.019c1.628-1.492 2.442-2.239 3.325-2.156.137.012.272.039.403.08.848.26 1.32 1.271 2.266 3.293.452.967.677 1.45 1.076 1.589a1 1 0 0 0 .271.053c.422.025.811-.332 1.59-1.046 1.088-.998 1.633-1.497 2.284-1.569a1.99 1.99 0 0 1 .437 0c.65.072 1.195.571 2.285 1.57L21 16"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 16.5,
    cy: 7.5,
    r: 1.5,
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2
  })]
}), IconPieChart = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 3v4.5M18 18l-3-3m3-9-3 3M3 12h4.5"
  })]
}), IconPlans = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.414 13.414a2 2 0 0 1 0-2.828l8.172-8.172a2 2 0 0 1 2.828 0l8.172 8.172a2 2 0 0 1 0 2.828l-8.172 8.172a2 2 0 0 1-2.828 0l-8.172-8.172Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m17.5 12-6 6M12.5 12 9 15.5M8 12l-1 1"
  })]
}), IconProfile = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("mask", {
    id: "Profile_svg__a",
    width: 24,
    height: 24,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    children: /* @__PURE__ */ jsx$1("circle", {
      cx: 16,
      cy: 16,
      r: 12,
      fill: "#F3F3F3",
      transform: "rotate(-90 16 16)"
    })
  }), /* @__PURE__ */ jsxs("g", {
    mask: "url(#Profile_svg__a)",
    children: [/* @__PURE__ */ jsx$1("circle", {
      cx: 16,
      cy: 16,
      r: 12,
      fill: "#F3F3F3",
      transform: "rotate(-90 16 16)"
    }), /* @__PURE__ */ jsx$1("circle", {
      cx: 16,
      cy: 14,
      r: 5,
      stroke: "#0FB990",
      strokeWidth: 2,
      transform: "rotate(-90 16 14)"
    }), /* @__PURE__ */ jsx$1("path", {
      stroke: "#0FB990",
      strokeWidth: 2,
      d: "M25 25c-1.482-3.526-4.953-6-9-6-4.046 0-7.518 2.474-9 6"
    })]
  })]
}), IconReset = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6.343 6.343a8 8 0 1 1-2.34 5.876"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M5 4v3a1 1 0 0 0 1 1h3"
  })]
}), IconReviewtool = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M3 13.512c0 5.805 4.706 10.512 10.512 10.512 5.805 0 10.512-4.707 10.512-10.512C24.024 7.706 19.317 3 13.512 3 7.706 3 3 7.706 3 13.512Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m8.669 13.727 2.107 2.126a2.309 2.309 0 0 0 3.284 0l4.35-4.378M28.977 28.998l-4.926-4.926"
  })]
}), IconRevisin = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8.877 7h6M8.877 11h4M8.877 15h1"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 2.5,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M18.5 18.5 20 20M18.877 11V5c0-.943 0-1.414-.293-1.707C18.291 3 17.82 3 16.877 3h-10c-.943 0-1.414 0-1.707.293-.293.293-.293.764-.293 1.707v14c0 .943 0 1.414.293 1.707.293.293.764.293 1.707.293h9"
  })]
}), IconSearch = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M20 12v-2c0-.943 0-1.414-.293-1.707C19.414 8 18.943 8 18 8h-3.343c-.818 0-1.226 0-1.594-.152-.368-.152-.657-.442-1.235-1.02l-.656-.656c-.579-.578-.867-.868-1.235-1.02C9.569 5 9.16 5 8.343 5H8c-1.886 0-2.828 0-3.414.586C4 6.172 4 7.114 4 9v6c0 1.886 0 2.828.586 3.414C5.172 19 6.114 19 8 19h3"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 2.5,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M18.5 18.5 20 20"
  })]
}), IconSheetM$1 = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 13H7M17 17H7"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /* @__PURE__ */ jsx$1("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: t,
    strokeWidth: 2,
    rx: 2
  })]
}), ShowPassword = () => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90002 18.9284C9.14411 19.5697 10.5265 20 12 20C15.1648 20 17.9088 18.0151 19.7663 16.2189C20.7148 15.3016 21.4792 14.3878 22.0061 13.7044C22.2702 13.3619 22.4763 13.0752 22.6177 12.872C22.6884 12.7704 22.743 12.6895 22.7808 12.6329C22.7996 12.6045 22.8143 12.5822 22.8246 12.5664L22.8368 12.5476L22.8405 12.5419L22.8417 12.5401L22.8421 12.5394C22.8423 12.5391 22.8425 12.5388 22 12L22.8425 12.5388L23.1871 12L22.8425 11.4612L22 12C22.8425 11.4612 22.8423 11.4609 22.8421 11.4606L22.8417 11.4599L22.8405 11.4581L22.8368 11.4524L22.8246 11.4336C22.8143 11.4178 22.7996 11.3955 22.7808 11.3671C22.743 11.3105 22.6884 11.2296 22.6177 11.128C22.4763 10.9248 22.2702 10.6381 22.0061 10.2956C21.4792 9.61225 20.7148 8.69844 19.7663 7.78115C19.6466 7.66541 19.5232 7.54889 19.3963 7.43216L17.9807 8.84776C18.115 8.9701 18.2468 9.09397 18.3759 9.21885C19.237 10.0516 19.9372 10.8878 20.4223 11.5169C20.5614 11.6974 20.6824 11.8601 20.7838 12C20.6824 12.1399 20.5614 12.3026 20.4223 12.4831C19.9372 13.1122 19.237 13.9484 18.3759 14.7811C16.6141 16.4849 14.3581 18 12 18C11.1125 18 10.2394 17.7854 9.40166 17.4268L7.90002 18.9284ZM6.01937 15.1522C5.88507 15.0299 5.75327 14.906 5.62413 14.7811C4.76304 13.9484 4.06291 13.1122 3.5778 12.4831C3.43863 12.3026 3.31769 12.1399 3.21626 12C3.31769 11.8601 3.43863 11.6974 3.5778 11.5169C4.06291 10.8878 4.76304 10.0516 5.62413 9.21885C7.38597 7.51508 9.642 6 12 6C12.8876 6 13.7607 6.21464 14.5984 6.5732L16.1001 5.07156C14.856 4.43032 13.4736 4 12 4C8.83522 4 6.09125 5.98492 4.23381 7.78115C3.28525 8.69844 2.52091 9.61225 1.99397 10.2956C1.72987 10.6381 1.52379 10.9248 1.38241 11.128C1.31168 11.2296 1.25704 11.3105 1.21932 11.3671C1.20045 11.3955 1.18581 11.4178 1.17549 11.4336L1.16327 11.4524L1.15961 11.4581L1.1584 11.4599L1.15795 11.4606C1.15777 11.4609 1.15761 11.4612 2.00003 12L1.15761 11.4612L0.812988 12L1.15761 12.5388L2.00003 12C1.15761 12.5388 1.15777 12.5391 1.15795 12.5394L1.1584 12.5401L1.15961 12.5419L1.16327 12.5476L1.17549 12.5664C1.18581 12.5822 1.20045 12.6045 1.21932 12.6329C1.25704 12.6895 1.31168 12.7704 1.38241 12.872C1.52379 13.0752 1.72987 13.3619 1.99397 13.7044C2.52091 14.3878 3.28525 15.3016 4.23381 16.2189C4.35349 16.3346 4.47685 16.4511 4.60377 16.5678L6.01937 15.1522Z",
    fill: "#3D3A62"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1728 16.6556C10.7388 16.8779 11.3551 17 12 17C14.7614 17 17 14.7614 17 12C17 11.3551 16.8779 10.7388 16.6556 10.1728L14.9954 11.833C14.9985 11.8883 15 11.944 15 12C15 13.6569 13.6569 15 12 15C11.944 15 11.8883 14.9985 11.833 14.9954L10.1728 16.6556ZM12.167 9.00457C12.1117 9.00154 12.056 9 12 9C10.3431 9 9 10.3431 9 12C9 12.056 9.00154 12.1117 9.00457 12.167L7.34438 13.8272C7.12208 13.2612 7 12.6449 7 12C7 9.23858 9.23858 7 12 7C12.6449 7 13.2612 7.12208 13.8272 7.34438L12.167 9.00457Z",
    fill: "#3D3A62"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 4L4 20",
    stroke: "#3D3A62",
    strokeWidth: "2"
  })]
}), IconTechnicalSupportXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 10.5V8a7 7 0 0 1 14 0v2.5M3 11a3 3 0 0 0 3 3h3M3 7v4M8 13h1M13 7v4"
  })
}), IconTickCleanMDark = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "m5 10 5.25 6L19 6"
  })
}), IconTickCleanMGreen = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeWidth: 2,
    d: "m5 10 5.25 6L19 6"
  })
}), IconTickCleanSDark = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeWidth: 2,
    d: "M3 6.8 6.75 11 13 4"
  })
}), IconTickCleanSGreen = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsx$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeWidth: 2,
    d: "M3 6.8 6.75 11 13 4"
  })
}), IconTickLineMDark = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 11,
    stroke: "#0FB990",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeWidth: 2,
    d: "m7 10.986 3.75 4.2 6.25-7"
  })]
}), IconTickLineSGreen = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 7,
    stroke: "#0FB990",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeWidth: 2,
    d: "m4 7.186 3 3 5-5"
  })]
}), IconTickSolidMDark = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7 10.986 3.75 4.2 6.25-7"
  })]
}), IconTickSolidMDisabledDark = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: "#D9D9D9"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7 10.986 3.75 4.2 6.25-7"
  })]
}), IconTickSolidMGreen = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: "#0FB990",
    stroke: "none"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7 10.986 3.75 4.2 6.25-7"
  })]
}), IconTickSolidSDark = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m4 7.186 3 3 5-5"
  })]
}), IconTickSolidSDisabledGreen = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: "#D9D9D9"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m4 7.186 3 3 5-5"
  })]
}), IconTickSolidSGreen = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: "#0FB990",
    stroke: "none"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m4 7.186 3 3 5-5"
  })]
}), IconTiming = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 14,
    r: 8,
    stroke: t,
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 14v-3M17.5 7.5 19 6M10.068 2.37c.114-.106.365-.2.715-.267A6.68 6.68 0 0 1 12 2c.44 0 .868.036 1.217.103.35.067.6.161.715.268"
  })]
}), IconTrash = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M20 5h-5c0-1.654-1.346-3-3-3S9 3.346 9 5H4a1 1 0 1 0 0 2h1v12c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3V7h1a1 1 0 1 0 0-2Zm-8-1c.551 0 1 .448 1 1h-2c0-.552.449-1 1-1Zm5 15a1 1 0 0 1-1 1H8c-.551 0-1-.448-1-1V7h10v12Z"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M10 18a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v7a1 1 0 0 0 1 1ZM14 18a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v7a1 1 0 0 0 1 1Z"
  })]
}), IconUpload = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M47.7413 30.0008L47.7553 31.0007L46.8553 31.0134L46.7483 30.1196L47.7413 30.0008ZM18.244 26.0324L19.1768 26.3926L18.9503 26.9793L18.3233 27.0292L18.244 26.0324ZM32.5 49H19.06V47H32.5V49ZM47.86 49H32.5V47H47.86V49ZM57.5 39C57.5 44.484 53.2221 49 47.86 49V47C52.0414 47 55.5 43.4571 55.5 39H57.5ZM47.86 29C53.2221 29 57.5 33.516 57.5 39H55.5C55.5 34.5429 52.0414 31 47.86 31V29ZM47.7272 29.0009C47.7714 29.0003 47.8156 29 47.86 29V31C47.8251 31 47.7902 31.0002 47.7553 31.0007L47.7272 29.0009ZM32.5 15C40.8771 15 47.7341 21.5246 48.7342 29.882L46.7483 30.1196C45.8594 22.691 39.7891 17 32.5 17V15ZM17.3111 25.6721C19.7185 19.4378 25.5955 15 32.5 15V17C26.4885 17 21.3112 20.8654 19.1768 26.3926L17.3111 25.6721ZM7.5 37C7.5 30.7196 12.1643 25.5132 18.1646 25.0355L18.3233 27.0292C13.422 27.4194 9.5 31.7021 9.5 37H7.5ZM19.06 49C12.6375 49 7.5 43.5886 7.5 37H9.5C9.5 42.5617 13.8182 47 19.06 47V49ZM19.06 49C19.06 49 19.06 49 19.06 49C19.06 49 19.06 49 19.06 49H19.06C19.06 49 19.06 49 19.06 49C19.06 49 19.06 49 19.06 49H19.06C19.06 49 19.06 49 19.06 49C19.06 49 19.06 49 19.06 49V47C19.06 47 19.06 47 19.06 47C19.06 47 19.06 47 19.06 47H19.06C19.06 47 19.06 47 19.06 47C19.06 47 19.06 47 19.06 47H19.06C19.06 47 19.06 47 19.06 47C19.06 47 19.06 47 19.06 47V49Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M32.5 38V30",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M28.5 34L32.3939 30.1061C32.4525 30.0475 32.5475 30.0475 32.6061 30.1061L36.5 34",
    fill: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconUploadDrop = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "65",
  height: "64",
  viewBox: "0 0 65 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M47.7413 30.0008L47.7553 31.0007L46.8553 31.0134L46.7483 30.1196L47.7413 30.0008ZM18.244 26.0324L19.1768 26.3926L18.9503 26.9793L18.3233 27.0292L18.244 26.0324ZM32.5 49H19.06V47H32.5V49ZM47.86 49H32.5V47H47.86V49ZM57.5 39C57.5 44.484 53.2221 49 47.86 49V47C52.0414 47 55.5 43.4571 55.5 39H57.5ZM47.86 29C53.2221 29 57.5 33.516 57.5 39H55.5C55.5 34.5429 52.0414 31 47.86 31V29ZM47.7272 29.0009C47.7714 29.0003 47.8156 29 47.86 29V31C47.8251 31 47.7902 31.0002 47.7553 31.0007L47.7272 29.0009ZM32.5 15C40.8771 15 47.7341 21.5246 48.7342 29.882L46.7483 30.1196C45.8594 22.691 39.7891 17 32.5 17V15ZM17.3111 25.6721C19.7185 19.4378 25.5955 15 32.5 15V17C26.4885 17 21.3112 20.8654 19.1768 26.3926L17.3111 25.6721ZM7.5 37C7.5 30.7196 12.1643 25.5132 18.1646 25.0355L18.3233 27.0292C13.422 27.4194 9.5 31.7021 9.5 37H7.5ZM19.06 49C12.6375 49 7.5 43.5886 7.5 37H9.5C9.5 42.5617 13.8182 47 19.06 47V49ZM19.06 49C19.06 49 19.06 49 19.06 49C19.06 49 19.06 49 19.06 49H19.06C19.06 49 19.06 49 19.06 49C19.06 49 19.06 49 19.06 49H19.06C19.06 49 19.06 49 19.06 49C19.06 49 19.06 49 19.06 49V47C19.06 47 19.06 47 19.06 47C19.06 47 19.06 47 19.06 47H19.06C19.06 47 19.06 47 19.06 47C19.06 47 19.06 47 19.06 47H19.06C19.06 47 19.06 47 19.06 47C19.06 47 19.06 47 19.06 47V49Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M32.5 38V30",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M36.5 34L28.5 34",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconUserSpaceM$1 = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 8,
    r: 3,
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M17.671 18.036C18.033 19.08 17.105 20 16 20H8c-1.105 0-2.033-.92-1.671-1.964a6.003 6.003 0 0 1 11.342 0Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 3v18M21 3v18"
  })]
}), IconUserSpaceXS = ({
  color: t,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  viewBox: "0 0 16 17",
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_5780_15779)",
    children: [/* @__PURE__ */ jsxs("mask", {
      id: "mask0_5780_15779",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "16",
      height: "17",
      children: [/* @__PURE__ */ jsx$1("path", {
        d: "M1 3.5V13.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M15 3.5V13.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("circle", {
        cx: "8",
        cy: "5.5",
        r: "2",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M12 13.5C12 13.5 11 11.5 8 11.5C5 11.5 4 13.5 4 13.5",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round"
      })]
    }), /* @__PURE__ */ jsx$1("g", {
      mask: "url(#mask0_5780_15779)",
      children: /* @__PURE__ */ jsx$1("rect", {
        y: "0.5",
        width: "16",
        height: "16",
        fill: t
      })
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_5780_15779",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    })
  })]
}), IconUtilities = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M27.764 13.441h-.005a1.346 1.346 0 0 1-1.275-.926 10.99 10.99 0 0 0-.605-1.46 1.348 1.348 0 0 1 .245-1.56l.003-.004a1.341 1.341 0 0 0 0-1.896l-1.722-1.722a1.34 1.34 0 0 0-1.896 0l-.003.003a1.347 1.347 0 0 1-1.56.245 10.982 10.982 0 0 0-1.46-.605 1.346 1.346 0 0 1-.928-1.275v-.005c0-.74-.6-1.34-1.34-1.34h-2.436c-.74 0-1.34.6-1.34 1.34v.005c0 .58-.376 1.092-.927 1.275-.504.167-.992.37-1.46.605a1.348 1.348 0 0 1-1.56-.245l-.004-.003a1.34 1.34 0 0 0-1.896 0L5.873 7.595a1.341 1.341 0 0 0 0 1.896l.003.003c.412.412.506 1.04.245 1.56-.235.469-.438.957-.605 1.46a1.346 1.346 0 0 1-1.275.928h-.005c-.74 0-1.34.6-1.34 1.34v2.436c0 .74.6 1.34 1.34 1.34h.005c.58 0 1.092.376 1.275.927.167.504.37.992.605 1.46.261.521.167 1.149-.245 1.56l-.003.004a1.341 1.341 0 0 0 0 1.896l1.722 1.722a1.341 1.341 0 0 0 1.896 0l.003-.003a1.347 1.347 0 0 1 1.56-.245c.469.235.957.438 1.46.605.552.183.928.694.928 1.275v.005c0 .74.6 1.34 1.34 1.34h2.436c.74 0 1.34-.6 1.34-1.34v-.005c0-.58.376-1.092.927-1.275.504-.167.992-.37 1.46-.605a1.347 1.347 0 0 1 1.56.245l.004.003a1.341 1.341 0 0 0 1.896 0l1.722-1.722a1.341 1.341 0 0 0 0-1.896l-.003-.003a1.348 1.348 0 0 1-.245-1.56c.235-.469.438-.957.605-1.46a1.346 1.346 0 0 1 1.275-.928h.005c.74 0 1.34-.6 1.34-1.34v-2.436c0-.74-.6-1.34-1.34-1.34Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.251 20.763A7.86 7.86 0 0 0 11.235 9.747m-1.34 1.3a7.86 7.86 0 0 0 11.07 11.045"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#0FB990",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M13 15.828h5.657M15.828 13v5.657"
  })]
}), IconVerifiedDocumentM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 13H7M21 3l-7 7-2-2M17 17H7"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M21 8v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
  })]
}), IconVerifiedDocumentS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M10 13H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 3L14 10L12 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 17H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 8V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconWarningAttentionSolidM = ({
  width: t = 24,
  height: r = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: t,
  height: r,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 12.186,
    r: 12,
    fill: "#E1A613"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M12 14.186v-9M12 18.186v-2"
  })]
}), IconWarningAttentionSolidS = () => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 8.186,
    r: 8,
    fill: "#E1A613"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M8 8.186v-4M8 12.186v-2"
  })]
}), WarningBoxM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsxs("g", {
    id: "icon",
    children: [/* @__PURE__ */ jsx$1("path", {
      id: "Vector 102",
      d: "M20 11.5V22.5",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Vector 103",
      d: "M20 27V28",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      id: "Rectangle 2086",
      d: "M20 4H8C5.79086 4 4 5.79086 4 8V32C4 34.2091 5.79086 36 8 36H32C34.2091 36 36 34.2091 36 32V19M36 11V8C36 5.79086 34.2091 4 32 4H28",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  })
}), IconWhatsappXS = ({
  color: t = IconColor.default,
  width: r = 16,
  height: n = 16
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#WhatsappXS_svg__a)",
    children: [/* @__PURE__ */ jsx$1("path", {
      fill: t,
      d: "M11.971 9.2c-.049-.077-.18-.124-.377-.217-.197-.092-1.164-.541-1.345-.603-.18-.062-.312-.093-.443.093a11 11 0 0 1-.623.727c-.115.124-.23.14-.426.047-.197-.093-.831-.29-1.583-.921A5.7 5.7 0 0 1 6.079 7.04c-.115-.186-.012-.286.086-.379.089-.083.197-.217.295-.325.099-.108.132-.186.197-.31.066-.123.033-.232-.016-.325-.05-.092-.443-1.006-.607-1.377-.16-.362-.322-.313-.443-.318A8 8 0 0 0 5.214 4a.74.74 0 0 0-.525.232C4.509 4.418 4 4.867 4 5.78s.705 1.795.804 1.919c.098.124 1.388 1.998 3.362 2.801.47.191.836.305 1.122.39.472.142.9.122 1.24.074.378-.053 1.165-.448 1.329-.882.164-.433.164-.805.114-.882"
    }), /* @__PURE__ */ jsx$1("circle", {
      cx: 8,
      cy: 8,
      r: 7,
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }), /* @__PURE__ */ jsx$1("path", {
      stroke: t,
      strokeLinecap: "round",
      strokeWidth: 2,
      d: "m2 12-.905 2.715a.15.15 0 0 0 .19.19L4 14"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "WhatsappXS_svg__a",
      children: /* @__PURE__ */ jsx$1("path", {
        fill: "#fff",
        d: "M0 0h16v16H0z"
      })
    })
  })]
}), IconWheelchair = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 6,
    cy: 4,
    r: 1,
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 5v4a1 1 0 0 0 1 1h3l2 3h1M6 7h3"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.465 12A4 4 0 1 1 4 6.535"
  })]
}), IconYear = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M21 12V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 5 18.92 5 17.8 5H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 6.52 3 7.08 3 8.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21H12m9-2v0a2 2 0 0 1-2 2v0M8 7.5v-5M16 7.5v-5"
  }), /* @__PURE__ */ jsx$1("path", {
    fill: t,
    d: "M13.757 20.828a1 1 0 1 0 1.415 1.415l-1.415-1.415Zm1.415 1.415 5.656-5.657-1.414-1.414-5.657 5.656 1.415 1.415ZM22.243 15.172a1 1 0 1 0-1.415-1.415l1.415 1.415Zm-1.415-1.415-.707.707 1.415 1.415.707-.707-1.415-1.415Z"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    fill: t
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 11,
    r: 1,
    fill: t
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 16,
    cy: 11,
    r: 1,
    fill: t
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 14,
    r: 1,
    fill: t
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 14,
    r: 1,
    fill: t
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 16,
    cy: 14,
    r: 1,
    fill: t
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 8,
    cy: 17,
    r: 1,
    fill: t
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: 12,
    cy: 17,
    r: 1,
    fill: t
  })]
}), IconMobilePhoneXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M7 12H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "3",
    y: "1",
    width: "10",
    height: "14",
    rx: "1",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconDotsXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11590_14261)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M7 8C7 8.26522 7.10536 8.51957 7.29289 8.70711C7.48043 8.89464 7.73478 9 8 9C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8C9 7.73478 8.89464 7.48043 8.70711 7.29289C8.51957 7.10536 8.26522 7 8 7C7.73478 7 7.48043 7.10536 7.29289 7.29289C7.10536 7.48043 7 7.73478 7 8Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7 13C7 13.2652 7.10536 13.5196 7.29289 13.7071C7.48043 13.8946 7.73478 14 8 14C8.26522 14 8.51957 13.8946 8.70711 13.7071C8.89464 13.5196 9 13.2652 9 13C9 12.7348 8.89464 12.4804 8.70711 12.2929C8.51957 12.1054 8.26522 12 8 12C7.73478 12 7.48043 12.1054 7.29289 12.2929C7.10536 12.4804 7 12.7348 7 13Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7 3C7 3.26522 7.10536 3.51957 7.29289 3.70711C7.48043 3.89464 7.73478 4 8 4C8.26522 4 8.51957 3.89464 8.70711 3.70711C8.89464 3.51957 9 3.26522 9 3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3Z",
      fill: t
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11590_14261",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })
  })]
}), IconDotsS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11590_14274)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 19C10 19.5304 10.2107 20.0391 10.5858 20.4142C10.9609 20.7893 11.4696 21 12 21C12.5304 21 13.0391 20.7893 13.4142 20.4142C13.7893 20.0391 14 19.5304 14 19C14 18.4696 13.7893 17.9609 13.4142 17.5858C13.0391 17.2107 12.5304 17 12 17C11.4696 17 10.9609 17.2107 10.5858 17.5858C10.2107 17.9609 10 18.4696 10 19Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5Z",
      fill: t
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11590_14274",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    })
  })]
}), IconDotsM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11590_14287)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M14 16C14 16.5304 14.2107 17.0391 14.5858 17.4142C14.9609 17.7893 15.4696 18 16 18C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16C18 15.4696 17.7893 14.9609 17.4142 14.5858C17.0391 14.2107 16.5304 14 16 14C15.4696 14 14.9609 14.2107 14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M14 25C14 25.5304 14.2107 26.0391 14.5858 26.4142C14.9609 26.7893 15.4696 27 16 27C16.5304 27 17.0391 26.7893 17.4142 26.4142C17.7893 26.0391 18 25.5304 18 25C18 24.4696 17.7893 23.9609 17.4142 23.5858C17.0391 23.2107 16.5304 23 16 23C15.4696 23 14.9609 23.2107 14.5858 23.5858C14.2107 23.9609 14 24.4696 14 25Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M14 7C14 7.53043 14.2107 8.03914 14.5858 8.41421C14.9609 8.78929 15.4696 9 16 9C16.5304 9 17.0391 8.78929 17.4142 8.41421C17.7893 8.03914 18 7.53043 18 7C18 6.46957 17.7893 5.96086 17.4142 5.58579C17.0391 5.21071 16.5304 5 16 5C15.4696 5 14.9609 5.21071 14.5858 5.58579C14.2107 5.96086 14 6.46957 14 7Z",
      fill: t
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11590_14287",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "32",
        height: "32",
        fill: "white"
      })
    })
  })]
}), IconDotsL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11590_14300)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M17 20C17 20.7956 17.3161 21.5587 17.8787 22.1213C18.4413 22.6839 19.2044 23 20 23C20.7956 23 21.5587 22.6839 22.1213 22.1213C22.6839 21.5587 23 20.7956 23 20C23 19.2044 22.6839 18.4413 22.1213 17.8787C21.5587 17.3161 20.7956 17 20 17C19.2044 17 18.4413 17.3161 17.8787 17.8787C17.3161 18.4413 17 19.2044 17 20Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17 32C17 32.7956 17.3161 33.5587 17.8787 34.1213C18.4413 34.6839 19.2044 35 20 35C20.7956 35 21.5587 34.6839 22.1213 34.1213C22.6839 33.5587 23 32.7956 23 32C23 31.2044 22.6839 30.4413 22.1213 29.8787C21.5587 29.3161 20.7956 29 20 29C19.2044 29 18.4413 29.3161 17.8787 29.8787C17.3161 30.4413 17 31.2044 17 32Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17 8C17 8.79565 17.3161 9.55871 17.8787 10.1213C18.4413 10.6839 19.2044 11 20 11C20.7956 11 21.5587 10.6839 22.1213 10.1213C22.6839 9.55871 23 8.79565 23 8C23 7.20435 22.6839 6.44129 22.1213 5.87868C21.5587 5.31607 20.7956 5 20 5C19.2044 5 18.4413 5.31607 17.8787 5.87868C17.3161 6.44129 17 7.20435 17 8Z",
      fill: t
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11590_14300",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconLockMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "3",
    y: "7",
    width: "10",
    height: "8",
    rx: "1",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 11L8 12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 4C5 2.34315 6.34315 1 8 1V1C9.65685 1 11 2.34315 11 4V7H5V4Z",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconLockS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "5",
    y: "11",
    width: "14",
    height: "12",
    rx: "2",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 16L12 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M7 6C7 3.23858 9.23858 1 12 1V1C14.7614 1 17 3.23858 17 6V11H7V6Z",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconLockM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "5",
    y: "14",
    width: "22",
    height: "17",
    rx: "3",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 20L16 25",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 7C10 3.68629 12.6863 1 16 1V1C19.3137 1 22 3.68629 22 7V14H10V7Z",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconLockL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "6",
    y: "19",
    width: "28",
    height: "20",
    rx: "4",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 27L20 31",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 10C11 5.02944 15.0294 1 20 1V1C24.9706 1 29 5.02944 29 10V19H11V10Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 10C15 7.23858 17.2386 5 20 5V5C22.7614 5 25 7.23858 25 10V19H15V10Z",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconZoomL$5 = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M14 4L6 12L2 7.99999",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}), IconZoomL$4 = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M21 7L10 18L5 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}), IconZoomL$3 = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M28 9L14 23L7 16",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}), IconZoomL$2 = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M36 9L16 29L7 20",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}), IconInfoMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 11V8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "5",
    r: "1",
    fill: t
  })]
}), IconInfoS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 17V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "8",
    r: "1",
    fill: t
  })]
}), IconInfoM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 22V15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "11",
    r: "1",
    fill: t
  })]
}), IconInfoL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "20",
    r: "19",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 27V18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "14",
    r: "1",
    fill: t
  })]
}), IconAddSimpleMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M8 2L8 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 8L14 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddSimpleS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M21 12H3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 3L12 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddSimpleM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M29 16H3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 3L16 29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddSimpleL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M36 20H4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 4L20 36",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 6L8 10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.00488 8.005L10.0049 8.005",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 5C3 3.89543 3.89543 3 5 3L19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 12H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 9L12 15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 6C3 4.34315 4.34315 3 6 3L26 3C27.6569 3 29 4.34315 29 6V26C29 27.6569 27.6569 29 26 29H6C4.34315 29 3 27.6569 3 26V6Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 16H12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 12L16 20",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M4 8C4 5.79086 5.79086 4 8 4L32 4C34.2091 4 36 5.79086 36 8V32C36 34.2091 34.2091 36 32 36H8C5.79086 36 4 34.2091 4 32V8Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M25 20H15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 15L20 25",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAddSolidMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM8 11C7.44772 11 7 10.5523 7 10V9.005H6.00488C5.4526 9.005 5.00488 8.55729 5.00488 8.00501C5.00488 7.45272 5.4526 7.00501 6.00488 7.00501H7V6C7 5.44772 7.44771 5 8 5C8.55228 5 9 5.44772 9 6V7.005H10.0049C10.5572 7.005 11.0049 7.45272 11.0049 8.005C11.0049 8.55729 10.5572 9.005 10.0049 9.005H9V10C9 10.5523 8.55228 11 8 11Z",
    fill: t
  })
}), IconAddSolidS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM8 12C8 11.4477 8.44772 11 9 11H11V9C11 8.44771 11.4477 8 12 8C12.5523 8 13 8.44771 13 9V11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V13H9C8.44772 13 8 12.5523 8 12Z",
    fill: t
  })
}), IconAddSolidM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 3.34315 3.34315 2 5 2H27C28.6569 2 30 3.34315 30 5V27C30 28.6569 28.6569 30 27 30H5C3.34315 30 2 28.6569 2 27V5ZM11 16C11 15.4477 11.4477 15 12 15H15V12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12V15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H17V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V17H12C11.4477 17 11 16.5523 11 16Z",
    fill: t
  })
}), IconAddSolidL = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7C3 4.79086 4.79086 3 7 3H33C35.2091 3 37 4.79086 37 7V33C37 35.2091 35.2091 37 33 37H7C4.79086 37 3 35.2091 3 33V7ZM14 20C14 19.4477 14.4477 19 15 19H19V15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V19H25C25.5523 19 26 19.4477 26 20C26 20.5523 25.5523 21 25 21H21V25C21 25.5523 20.5523 26 20 26C19.4477 26 19 25.5523 19 25V21H15C14.4477 21 14 20.5523 14 20Z",
    fill: t
  })
}), IconAddRoundedSolidMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 12C7.44772 12 7 11.5523 7 11V9H5C4.44771 9 4 8.55229 4 8C4 7.44772 4.44771 7 5 7H7V5C7 4.44771 7.44771 4 8 4C8.55228 4 9 4.44771 9 5V7H11C11.5523 7 12 7.44772 12 8C12 8.55228 11.5523 9 11 9H9V11C9 11.5523 8.55229 12 8 12Z",
    fill: t
  })
}), IconAddRoundedSolidS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM7 12C7 11.4477 7.44772 11 8 11H11V8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12Z",
    fill: t
  })
}), IconAddRoundedSolidM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM9 16C9 15.4477 9.44771 15 10 15H15V10C15 9.44771 15.4477 9 16 9C16.5523 9 17 9.44771 17 10V15H22C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H17V22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22V17H10C9.44771 17 9 16.5523 9 16Z",
    fill: t
  })
}), IconAddRoundedSolidL = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20ZM12 20C12 19.4477 12.4477 19 13 19H19V13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V19H27C27.5523 19 28 19.4477 28 20C28 20.5523 27.5523 21 27 21H21V27C21 27.5523 20.5523 28 20 28C19.4477 28 19 27.5523 19 27V21H13C12.4477 21 12 20.5523 12 20Z",
    fill: t
  })
}), IconBinMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 6V14C3 14.5523 3.44772 15 4 15H12C12.5523 15 13 14.5523 13 14V6",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 4H2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 1H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconBinS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M5 7V21C5 22.1046 5.89543 23 7 23H17C18.1046 23 19 22.1046 19 21V7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 1H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 4H3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 18V10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 18V10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconBinM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M5 7V29C5 30.1046 5.89543 31 7 31H25C26.1046 31 27 30.1046 27 29V7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M19 1H13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M29 4H3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 25V9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 25V9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 25V9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconBinL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M6 12V37C6 38.1046 6.89543 39 8 39H32C33.1046 39 34 38.1046 34 37V12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "4",
    y: "5",
    width: "32",
    height: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M23 4V1H17V4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 32V15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 32V15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M23 32V15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M28 32V15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCrossMXxs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M7 1L1 7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M1 1L7 7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCrossMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M12 4L4 12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 4L12 12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCrossS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M21 3L3 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3L21 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCrossM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M29 3L3 29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3L29 29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCrossL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M36 4L4 36",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 4L36 36",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconZoomMXs$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8",
    r: "1",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8",
    r: "5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 1V3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 13V15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4.5 1.93799L5.5 3.67004",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10.5 12.3301L11.5 14.0621",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M1.93774 4.5L3.66979 5.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.3301 10.5L14.0621 11.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M1 8L3 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13 8L15 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M1.93774 11.5L3.66979 10.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.3301 5.5L14.0621 4.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4.5 14.062L5.5 12.33",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10.5 3.66992L11.5 1.93787",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconZoomS$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("mask", {
    id: "path-1-inside-1_11922_84147",
    fill: "white",
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6074 2.05055C14.5087 1.59833 14.4594 1.37222 14.3752 1.18398C14.1133 0.597816 13.5858 0.173052 12.9573 0.0420657C12.7555 0 12.524 0 12.0612 0H11.9388C11.4759 0 11.2445 0 11.0426 0.0420698C10.4141 0.173059 9.88666 0.597814 9.6247 1.18396C9.54057 1.37221 9.49124 1.59833 9.39256 2.05058L9.19931 2.93634C9.12508 3.27657 8.87546 3.54995 8.55381 3.68338C8.23194 3.81691 7.86461 3.79894 7.57135 3.61073L6.80805 3.12086C6.41887 2.87108 6.22428 2.74619 6.03187 2.6726C5.43196 2.44315 4.75835 2.51578 4.22114 2.86784C4.04885 2.98076 3.88535 3.14425 3.55835 3.47125L3.47119 3.55841C3.14417 3.88543 2.98066 4.04894 2.86775 4.22125C2.51571 4.75845 2.44308 5.43203 2.67251 6.03193C2.74611 6.22435 2.871 6.41895 3.1208 6.80816L3.61067 7.57146C3.79889 7.86472 3.81685 8.23205 3.68333 8.55393C3.5499 8.87559 3.27651 9.12522 2.93627 9.19946L2.05053 9.39271C1.59833 9.49137 1.37223 9.5407 1.18399 9.62482C0.597819 9.88678 0.173045 10.4142 0.0420619 11.0428C0 11.2446 0 11.476 0 11.9389V12.0613C0 12.5242 0 12.7556 0.0420734 12.9575C0.173066 13.586 0.597811 14.1134 1.18394 14.3753C1.3722 14.4595 1.59833 14.5088 2.0506 14.6075L2.93627 14.8007C3.27656 14.875 3.54998 15.1246 3.68345 15.4463C3.817 15.7683 3.79904 16.1357 3.61079 16.429L3.12094 17.1923C2.87116 17.5815 2.74627 17.7761 2.67267 17.9685C2.44323 18.5684 2.51586 19.242 2.86791 19.7792C2.98083 19.9515 3.14433 20.115 3.47134 20.442L3.55832 20.529C3.8855 20.8562 4.04908 21.0197 4.22148 21.1327C4.7586 21.4846 5.43203 21.5572 6.03182 21.3279C6.22434 21.2543 6.41904 21.1293 6.80843 20.8794L7.57197 20.3894C7.86513 20.2012 8.23233 20.1833 8.55409 20.3167C8.87566 20.4501 9.12521 20.7234 9.19942 21.0636L9.39271 21.9495C9.49137 22.4017 9.5407 22.6278 9.62482 22.816C9.88678 23.4022 10.4142 23.827 11.0428 23.9579C11.2446 24 11.476 24 11.9389 24H12.0613C12.5242 24 12.7556 24 12.9575 23.9579C13.586 23.8269 14.1134 23.4022 14.3753 22.8161C14.4595 22.6278 14.5088 22.4017 14.6075 21.9494L14.8008 21.0636C14.875 20.7234 15.1246 20.45 15.4463 20.3166C15.7681 20.1831 16.1355 20.201 16.4287 20.3892L17.192 20.8791C17.5811 21.1288 17.7756 21.2537 17.968 21.3272C18.5679 21.5567 19.2416 21.4841 19.7789 21.132C19.9511 21.0191 20.1146 20.8556 20.4415 20.5287L20.5288 20.4414C20.8558 20.1144 21.0193 19.951 21.1322 19.7787C21.4842 19.2415 21.5569 18.5678 21.3274 17.9679C21.2538 17.7755 21.1289 17.5809 20.8792 17.1918L20.3892 16.4283C20.2011 16.1352 20.1831 15.768 20.3166 15.4463C20.4499 15.1248 20.7232 14.8753 21.0632 14.8011L21.9493 14.6078C22.4017 14.5091 22.6278 14.4598 22.8161 14.3756C23.4022 14.1136 23.8269 13.5863 23.9579 12.9579C24 12.756 24 12.5245 24 12.0614V11.9391C24 11.4763 24 11.2449 23.958 11.0431C23.827 10.4145 23.4022 9.88704 22.8159 9.62508C22.6277 9.54099 22.4017 9.49167 21.9496 9.39302L21.064 9.19982C20.7237 9.12556 20.4502 8.87583 20.3167 8.55404C20.1832 8.23206 20.2011 7.86461 20.3894 7.57124L20.8792 6.80802C21.1291 6.4187 21.254 6.22403 21.3276 6.03155C21.557 5.43172 21.4844 4.75823 21.1324 4.22108C21.0195 4.04872 20.8559 3.88516 20.5288 3.55805L20.4419 3.47114C20.1148 3.144 19.9512 2.98043 19.7788 2.86748C19.2417 2.51554 18.5682 2.44292 17.9684 2.67228C17.7759 2.74588 17.5812 2.87082 17.1919 3.12071L16.4284 3.61068C16.1352 3.79887 15.7679 3.81684 15.4461 3.68333C15.1244 3.54991 14.8748 3.27656 14.8006 2.93636L14.6074 2.05055Z"
    })
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.4284 3.61068L17.5087 5.29385L16.4284 3.61068ZM20.4419 3.47114L19.0277 4.88535L20.4419 3.47114ZM19.7788 2.86748L18.6827 4.54037L19.7788 2.86748ZM17.1919 3.12071L18.2721 4.80388L17.1919 3.12071ZM17.9684 2.67228L18.6827 4.54037L17.9684 2.67228ZM20.8792 6.80802L19.1961 5.72777L20.8792 6.80802ZM21.3276 6.03155L19.4596 5.31722L21.3276 6.03155ZM20.5288 3.55805L19.1146 4.97226L20.5288 3.55805ZM21.1324 4.22108L22.8053 3.12495L21.1324 4.22108ZM20.3894 7.57124L22.0726 8.65149L20.3894 7.57124ZM21.064 9.19982L20.6377 11.1539L21.064 9.19982ZM23.958 11.0431L25.9159 10.6352L23.958 11.0431ZM22.8159 9.62508L22 11.4511L22.8159 9.62508ZM21.9493 14.6078L21.523 12.6538L21.9493 14.6078ZM22.8161 14.3756L23.6323 16.2015L22.8161 14.3756ZM23.9579 12.9579L25.9158 13.366L23.9579 12.9579ZM21.0632 14.8011L21.4896 16.7552L21.0632 14.8011ZM20.3892 16.4283L22.0724 15.3481L20.3892 16.4283ZM21.1322 19.7787L22.8049 20.875L21.1322 19.7787ZM20.8792 17.1918L19.196 18.272L20.8792 17.1918ZM21.3274 17.9679L23.1954 17.2534L21.3274 17.9679ZM17.192 20.8791L16.1117 22.5623L17.192 20.8791ZM17.968 21.3272L18.6825 19.4592L17.968 21.3272ZM19.7789 21.132L18.6825 19.4592L19.7789 21.132ZM16.4287 20.3892L15.3485 22.0724L16.4287 20.3892ZM12.9575 23.9579L12.5494 22L12.9575 23.9579ZM14.6075 21.9494L16.5615 22.3757L14.6075 21.9494ZM14.3753 22.8161L12.5494 22L14.3753 22.8161ZM9.39271 21.9495L11.3467 21.5231L9.39271 21.9495ZM9.62482 22.816L7.79886 23.632L9.62482 22.816ZM11.0428 23.9579L10.6347 25.9159L11.0428 23.9579ZM9.19942 21.0636L11.1535 20.6372L9.19942 21.0636ZM7.57197 20.3894L6.49172 18.7062L7.57197 20.3894ZM3.55832 20.529L4.97254 19.1148L3.55832 20.529ZM4.22148 21.1327L5.31755 19.4598L4.22148 21.1327ZM6.80843 20.8794L7.88868 22.5626L6.80843 20.8794ZM6.03182 21.3279L5.31755 19.4598L6.03182 21.3279ZM3.12094 17.1923L4.80412 18.2725L3.12094 17.1923ZM2.67267 17.9685L0.80464 17.254L2.67267 17.9685ZM3.47134 20.442L4.88555 19.0278L3.47134 20.442ZM2.86791 19.7792L4.54071 18.6829L2.86791 19.7792ZM3.61079 16.429L1.92762 15.3488L3.61079 16.429ZM2.93627 14.8007L2.50994 16.7548L2.93627 14.8007ZM0.0420734 12.9575L-1.91585 13.3656L0.0420734 12.9575ZM2.0506 14.6075L2.47693 12.6535L2.0506 14.6075ZM1.18394 14.3753L2 12.5494L1.18394 14.3753ZM1.18399 9.62482L2 11.4508L1.18399 9.62482ZM2.86775 4.22125L1.19494 3.12502L2.86775 4.22125ZM2.67251 6.03193L4.54055 5.31748L2.67251 6.03193ZM6.03187 2.6726L5.3174 4.54063L6.03187 2.6726ZM4.22114 2.86784L5.3174 4.54063L4.22114 2.86784ZM7.57135 3.61073L6.4911 5.2939L7.57135 3.61073ZM9.19931 2.93634L11.1533 3.36268L9.19931 2.93634ZM12.9573 0.0420657L12.5493 2L12.9573 0.0420657ZM14.6074 2.05055L16.5614 1.62422L14.6074 2.05055ZM14.3752 1.18398L16.2012 0.36795L14.3752 1.18398ZM9.39256 2.05058L11.3466 2.47691L9.39256 2.05058ZM9.6247 1.18396L7.79876 0.367915L9.6247 1.18396ZM11.9388 2H12.0612V-2H11.9388V2ZM11.1533 3.36268L11.3466 2.47691L7.43853 1.62425L7.24528 2.51001L11.1533 3.36268ZM5.72781 4.80403L6.4911 5.2939L8.65159 1.92756L7.8883 1.43768L5.72781 4.80403ZM4.88541 4.97262L4.97257 4.88546L2.14414 2.05703L2.05698 2.14419L4.88541 4.97262ZM5.29384 6.49121L4.80397 5.72792L1.43762 7.88841L1.9275 8.6517L5.29384 6.49121ZM2.47687 11.3467L3.3626 11.1535L2.50993 7.24543L1.6242 7.43868L2.47687 11.3467ZM2 12.0613V11.9389H-2V12.0613H2ZM3.3626 12.8467L2.47693 12.6535L1.62427 16.5615L2.50994 16.7548L3.3626 12.8467ZM4.80412 18.2725L5.29396 17.5093L1.92762 15.3488L1.43777 16.112L4.80412 18.2725ZM4.97254 19.1148L4.88555 19.0278L2.05713 21.8562L2.14411 21.9432L4.97254 19.1148ZM6.49172 18.7062L5.72818 19.1962L7.88868 22.5626L8.65221 22.0726L6.49172 18.7062ZM11.3467 21.5231L11.1535 20.6372L7.24539 21.4899L7.43868 22.3758L11.3467 21.5231ZM12.0613 22H11.9389V26H12.0613V22ZM12.8467 20.6373L12.6535 21.5231L16.5615 22.3757L16.7548 21.49L12.8467 20.6373ZM18.2722 19.1959L17.509 18.7061L15.3485 22.0724L16.1117 22.5623L18.2722 19.1959ZM19.1146 19.0272L19.0273 19.1145L21.8557 21.9429L21.943 21.8556L19.1146 19.0272ZM18.706 17.5085L19.196 18.272L22.5624 16.1115L22.0724 15.3481L18.706 17.5085ZM21.523 12.6538L20.6369 12.8471L21.4896 16.7552L22.3756 16.5618L21.523 12.6538ZM22 11.9391V12.0614H26V11.9391H22ZM20.6377 11.1539L21.5232 11.3471L22.3759 7.43899L21.4904 7.24579L20.6377 11.1539ZM19.1961 5.72777L18.7062 6.491L22.0726 8.65149L22.5624 7.88827L19.1961 5.72777ZM19.0277 4.88535L19.1146 4.97226L21.943 2.14383L21.8561 2.05692L19.0277 4.88535ZM17.5087 5.29385L18.2721 4.80388L16.1116 1.43754L15.3482 1.92751L17.5087 5.29385ZM12.6533 2.47689L12.8466 3.36269L16.7547 2.51002L16.5614 1.62422L12.6533 2.47689ZM16.2124 1.83597C16.4275 1.92518 16.6744 2.14213 16.7547 2.51002L12.8466 3.36269C13.0753 4.41098 13.8214 5.17465 14.6797 5.53069L16.2124 1.83597ZM15.3482 1.92751C15.6601 1.72733 15.9904 1.74387 16.2124 1.83597L14.6797 5.53069C15.5454 5.88981 16.6103 5.87041 17.5087 5.29385L15.3482 1.92751ZM21.8561 2.05692C21.5953 1.79613 21.2619 1.44818 20.8749 1.19459L18.6827 4.54037C18.6382 4.51122 18.6303 4.49787 18.6918 4.55492C18.7615 4.61961 18.8538 4.71148 19.0277 4.88535L21.8561 2.05692ZM18.2721 4.80388C18.479 4.67108 18.5888 4.60099 18.6707 4.55265C18.7429 4.51002 18.7324 4.52137 18.6827 4.54037L17.2541 0.804186C16.8219 0.969445 16.422 1.23833 16.1116 1.43754L18.2721 4.80388ZM20.8749 1.19459C19.8006 0.49071 18.4537 0.345481 17.2541 0.804186L18.6827 4.54037L20.8749 1.19459ZM22.5624 7.88827C22.7616 7.5779 23.0305 7.17805 23.1957 6.74589L19.4596 5.31722C19.4785 5.26754 19.4899 5.25699 19.4473 5.32919C19.3989 5.41107 19.3289 5.52086 19.1961 5.72777L22.5624 7.88827ZM19.1146 4.97226C19.2885 5.14611 19.3803 5.23844 19.445 5.30813C19.502 5.36959 19.4887 5.3617 19.4596 5.31722L22.8053 3.12495C22.5517 2.73796 22.2038 2.4046 21.943 2.14383L19.1146 4.97226ZM23.1957 6.74589C23.6545 5.54623 23.5092 4.19925 22.8053 3.12495L19.4596 5.31722L23.1957 6.74589ZM22.1641 7.78774C22.2561 8.00959 22.2727 8.33971 22.0726 8.65149L18.7062 6.491C18.1296 7.3895 18.1102 8.45453 18.4693 9.32035L22.1641 7.78774ZM21.4904 7.24579C21.8581 7.32603 22.075 7.57287 22.1641 7.78774L18.4693 9.32035C18.8254 10.1788 19.5892 10.9251 20.6377 11.1539L21.4904 7.24579ZM26 11.9391C26 11.5702 26.0103 11.0883 25.9159 10.6352L22 11.4511C21.9891 11.399 21.993 11.384 21.9961 11.4678C21.9997 11.5628 22 11.6931 22 11.9391H26ZM21.5232 11.3471C21.7635 11.3995 21.8907 11.4276 21.9828 11.4513C22.0641 11.4722 22.0486 11.4728 22 11.4511L23.6319 7.79909C23.2093 7.61028 22.7363 7.51763 22.3759 7.43899L21.5232 11.3471ZM25.9159 10.6352C25.654 9.378 24.8043 8.323 23.6319 7.79909L22 11.4511L25.9159 10.6352ZM22.3756 16.5618C22.7362 16.4832 23.2095 16.3905 23.6323 16.2015L22 12.5497C22.0486 12.528 22.0641 12.5286 21.9828 12.5495C21.8907 12.5732 21.7634 12.6013 21.523 12.6538L22.3756 16.5618ZM22 12.0614C22 12.3075 21.9997 12.4379 21.9961 12.533C21.993 12.6168 21.9891 12.6018 22 12.5497L25.9158 13.366C26.0103 12.9127 26 12.4305 26 12.0614H22ZM23.6323 16.2015C24.8044 15.6776 25.6538 14.6229 25.9158 13.366L22 12.5497L23.6323 16.2015ZM22.1639 16.2127C22.0746 16.4279 21.8576 16.6749 21.4896 16.7552L20.6369 12.8471C19.5888 13.0758 18.8253 13.8217 18.4692 14.6799L22.1639 16.2127ZM22.0724 15.3481C22.2726 15.6601 22.2561 15.9905 22.1639 16.2127L18.4692 14.6799C18.1101 15.5455 18.1295 16.6103 18.706 17.5085L22.0724 15.3481ZM21.943 21.8556C22.2037 21.595 22.5514 21.2618 22.8049 20.875L19.4594 18.6824C19.4885 18.6379 19.5019 18.6301 19.4448 18.6915C19.3802 18.7611 19.2884 18.8534 19.1146 19.0272L21.943 21.8556ZM19.196 18.272C19.3287 18.4788 19.3988 18.5886 19.4471 18.6704C19.4897 18.7426 19.4784 18.7321 19.4594 18.6824L23.1954 17.2534C23.0302 16.8214 22.7615 16.4218 22.5624 16.1115L19.196 18.272ZM22.8049 20.875C23.5091 19.8005 23.6544 18.4532 23.1954 17.2534L19.4594 18.6824L22.8049 20.875ZM16.1117 22.5623C16.4219 22.7613 16.8215 23.03 17.2534 23.1952L18.6825 19.4592C18.7322 19.4782 18.7427 19.4896 18.6706 19.447C18.5887 19.3987 18.479 19.3286 18.2722 19.1959L16.1117 22.5623ZM19.0273 19.1145C18.8535 19.2882 18.7613 19.3801 18.6916 19.4447C18.6302 19.5017 18.6381 19.4884 18.6825 19.4592L20.8752 22.8047C21.2619 22.5513 21.5951 22.2035 21.8557 21.9429L19.0273 19.1145ZM17.2534 23.1952C18.4533 23.6542 19.8007 23.509 20.8752 22.8047L18.6825 19.4592L17.2534 23.1952ZM16.2126 22.1639C15.9906 22.256 15.6604 22.2726 15.3485 22.0724L17.509 18.7061C16.6106 18.1295 15.5456 18.1101 14.6799 18.4692L16.2126 22.1639ZM16.7548 21.49C16.6745 21.8578 16.4276 22.0747 16.2126 22.1639L14.6799 18.4692C13.8216 18.8253 13.0754 19.589 12.8467 20.6373L16.7548 21.49ZM12.0613 26C12.4303 26 12.9123 26.0103 13.3656 25.9159L12.5494 22C12.6015 21.9891 12.6165 21.993 12.5327 21.9961C12.4376 21.9997 12.3073 22 12.0613 22V26ZM12.6535 21.5231C12.601 21.7634 12.5729 21.8907 12.5492 21.9828C12.5283 22.0641 12.5277 22.0486 12.5494 22L16.2013 23.6321C16.3902 23.2094 16.4829 22.7363 16.5615 22.3757L12.6535 21.5231ZM13.3656 25.9159C14.6226 25.6539 15.6774 24.8044 16.2013 23.6321L12.5494 22L13.3656 25.9159ZM7.43868 22.3758C7.51733 22.7363 7.60999 23.2094 7.79886 23.632L11.4508 22C11.4725 22.0486 11.4719 22.0641 11.451 21.9828C11.4273 21.8907 11.3992 21.7635 11.3467 21.5231L7.43868 22.3758ZM11.9389 22C11.6929 22 11.5626 21.9997 11.4675 21.9961C11.3837 21.993 11.3987 21.9891 11.4508 22L10.6347 25.9159C11.0879 26.0103 11.5699 26 11.9389 26V22ZM7.79886 23.632C8.32277 24.8044 9.37767 25.6539 10.6347 25.9159L11.4508 22L7.79886 23.632ZM7.7878 22.1641C7.57266 22.0749 7.32567 21.8579 7.24539 21.4899L11.1535 20.6372C10.9247 19.589 10.1787 18.8254 9.32038 18.4694L7.7878 22.1641ZM8.65221 22.0726C8.34027 22.2728 8.00991 22.2562 7.7878 22.1641L9.32038 18.4694C8.45475 18.1103 7.38999 18.1297 6.49172 18.7062L8.65221 22.0726ZM2.14411 21.9432C2.40493 22.204 2.73834 22.552 3.12541 22.8056L5.31755 19.4598C5.36205 19.4889 5.36994 19.5023 5.30847 19.4452C5.23876 19.3805 5.14642 19.2887 4.97254 19.1148L2.14411 21.9432ZM5.72818 19.1962C5.52123 19.3291 5.41143 19.3992 5.32953 19.4475C5.25731 19.4901 5.26787 19.4788 5.31755 19.4598L6.74609 23.196C7.17833 23.0307 7.57826 22.7618 7.88868 22.5626L5.72818 19.1962ZM3.12541 22.8056C4.19965 23.5094 5.54651 23.6547 6.74609 23.196L5.31755 19.4598L3.12541 22.8056ZM1.43777 16.112C1.23864 16.4223 0.969868 16.822 0.80464 17.254L4.54071 18.6829C4.52171 18.7326 4.51036 18.7431 4.55298 18.671C4.60131 18.5891 4.67136 18.4794 4.80412 18.2725L1.43777 16.112ZM4.88555 19.0278C4.71176 18.854 4.61991 18.7617 4.55525 18.692C4.49823 18.6306 4.51156 18.6385 4.54071 18.6829L1.19511 20.8754C1.44863 21.2623 1.79644 21.5955 2.05713 21.8562L4.88555 19.0278ZM0.80464 17.254C0.345756 18.4538 0.491014 19.801 1.19511 20.8754L4.54071 18.6829L0.80464 17.254ZM1.83611 16.2127C1.74404 15.9908 1.72748 15.6606 1.92762 15.3488L5.29396 17.5093C5.87061 16.6108 5.88997 15.5457 5.53078 14.68L1.83611 16.2127ZM2.50994 16.7548C2.14214 16.6745 1.92528 16.4277 1.83611 16.2127L5.53078 14.68C5.17469 13.8216 4.41097 13.0754 3.3626 12.8467L2.50994 16.7548ZM-2 12.0613C-2 12.4303 -2.01032 12.9123 -1.91585 13.3656L2 12.5494C2.01086 12.6015 2.007 12.6165 2.00387 12.5327C2.00032 12.4376 2 12.3073 2 12.0613H-2ZM2.47693 12.6535C2.23657 12.601 2.1093 12.5729 2.01716 12.5492C1.93591 12.5283 1.95141 12.5277 2 12.5494L0.367883 16.2013C0.790561 16.3902 1.26373 16.4829 1.62427 16.5615L2.47693 12.6535ZM-1.91585 13.3656C-1.65387 14.6226 -0.804378 15.6774 0.367883 16.2013L2 12.5494L-1.91585 13.3656ZM1.6242 7.43868C1.26371 7.51733 0.79061 7.61 0.367984 7.79886L2 11.4508C1.95142 11.4725 1.93592 11.4719 2.01716 11.451C2.10929 11.4273 2.23653 11.3992 2.47687 11.3467L1.6242 7.43868ZM2 11.9389C2 11.6929 2.00032 11.5626 2.00387 11.4675C2.00699 11.3837 2.01086 11.3987 2 11.4508L-1.91588 10.6347C-2.01031 11.0879 -2 11.5699 -2 11.9389H2ZM0.367984 7.79886C-0.804363 8.32278 -1.65391 9.37767 -1.91588 10.6347L2 11.4508L0.367984 7.79886ZM1.83597 7.7876C1.92516 7.57259 2.14207 7.32569 2.50993 7.24543L3.3626 11.1535C4.41094 10.9248 5.17463 10.1786 5.53069 9.32025L1.83597 7.7876ZM1.9275 8.6517C1.72734 8.33983 1.74389 8.00958 1.83597 7.7876L5.53069 9.32025C5.88982 8.45452 5.87043 7.38961 5.29384 6.49121L1.9275 8.6517ZM2.05698 2.14419C1.79628 2.40489 1.44847 2.73815 1.19494 3.12502L4.54055 5.31748C4.51141 5.36195 4.49807 5.36983 4.55509 5.3084C4.61976 5.23872 4.71161 5.14642 4.88541 4.97262L2.05698 2.14419ZM4.80397 5.72792C4.67121 5.52106 4.60115 5.41131 4.55282 5.32945C4.51021 5.25727 4.52156 5.26781 4.54055 5.31748L0.804477 6.74637C0.969707 7.17839 1.23849 7.57813 1.43762 7.88841L4.80397 5.72792ZM1.19494 3.12502C0.490861 4.19941 0.345606 5.54658 0.804477 6.74637L4.54055 5.31748L1.19494 3.12502ZM7.8883 1.43768C7.57805 1.23857 7.17834 0.969801 6.74635 0.804577L5.3174 4.54063C5.26774 4.52164 5.25719 4.51029 5.32937 4.5529C5.41122 4.60123 5.52097 4.67128 5.72781 4.80403L7.8883 1.43768ZM4.97257 4.88546C5.14636 4.71167 5.23865 4.61983 5.30832 4.55517C5.36975 4.49815 5.36187 4.51149 5.3174 4.54063L3.12488 1.19505C2.73805 1.44857 2.40482 1.79636 2.14414 2.05703L4.97257 4.88546ZM6.74635 0.804577C5.54653 0.345672 4.19931 0.490933 3.12488 1.19505L5.3174 4.54063L6.74635 0.804577ZM7.78745 1.83603C8.00945 1.74394 8.33971 1.72739 8.65159 1.92756L6.4911 5.2939C7.38951 5.87049 8.45443 5.88987 9.32016 5.53073L7.78745 1.83603ZM7.24528 2.51001C7.32554 2.14215 7.57244 1.92523 7.78745 1.83603L9.32016 5.53073C10.1785 5.17467 10.9246 4.41099 11.1533 3.36268L7.24528 2.51001ZM12.0612 2C12.3072 2 12.4375 2.00032 12.5326 2.00387C12.6164 2.007 12.6014 2.01086 12.5493 2L13.3653 -1.91587C12.9122 -2.01031 12.4302 -2 12.0612 -2V2ZM16.5614 1.62422C16.4827 1.26371 16.3901 0.790594 16.2012 0.36795L12.5493 2C12.5276 1.95142 12.5281 1.93592 12.5491 2.01716C12.5728 2.10929 12.6009 2.23654 12.6533 2.47689L16.5614 1.62422ZM12.5493 2L16.2012 0.36795C15.6773 -0.804368 14.6224 -1.6539 13.3653 -1.91587L12.5493 2ZM11.9388 -2C11.5698 -2 11.0878 -2.01032 10.6345 -1.91586L11.4506 2C11.3986 2.01086 11.3835 2.007 11.4674 2.00387C11.5624 2.00032 11.6928 2 11.9388 2V-2ZM11.3466 2.47691C11.399 2.23656 11.4271 2.1093 11.4509 2.01716C11.4718 1.93591 11.4724 1.95141 11.4506 2L7.79876 0.367915C7.60987 0.790577 7.51719 1.26372 7.43853 1.62425L11.3466 2.47691ZM10.6345 -1.91586C9.37751 -1.65388 8.32267 -0.804373 7.79876 0.367915L11.4506 2L10.6345 -1.91586Z",
    fill: t,
    mask: "url(#path-1-inside-1_11922_84147)"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "12",
    r: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconZoomM$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("mask", {
    id: "path-1-inside-1_11922_84131",
    fill: "white",
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.4765 2.73409C19.2352 1.62788 19.1145 1.07477 18.7798 0.689118C18.6238 0.509358 18.437 0.358888 18.2281 0.244788C17.7799 0 17.2138 0 16.0816 0H15.9184C14.7862 0 14.2201 0 13.7719 0.244787C13.563 0.358888 13.3762 0.509358 13.2202 0.689119C12.8855 1.07477 12.7648 1.62788 12.5235 2.73409L12.2658 3.9151C12.1668 4.36874 11.834 4.73325 11.4051 4.91116C10.976 5.08918 10.4862 5.06523 10.0952 4.81428L9.07742 4.16109C8.12498 3.54982 7.64876 3.24418 7.13964 3.20805C6.90193 3.19118 6.66311 3.21693 6.43445 3.28408C5.94474 3.42791 5.54462 3.82804 4.74437 4.62829L4.62825 4.74441C3.82798 5.54467 3.42785 5.94481 3.28402 6.43453C3.21687 6.66317 3.19112 6.90198 3.20799 7.13968C3.24412 7.6488 3.54976 8.12504 4.16105 9.0775L4.81427 10.0953C5.0652 10.4863 5.08915 10.976 4.91114 11.4052C4.73324 11.834 4.36876 12.1668 3.91515 12.2658L2.73409 12.5235C1.62788 12.7648 1.07477 12.8855 0.689118 13.2202C0.509358 13.3762 0.358888 13.563 0.244788 13.7719C0 14.2201 0 14.7862 0 15.9184V16.0816C0 17.2138 0 17.7799 0.244787 18.2281C0.358888 18.437 0.509358 18.6238 0.689119 18.7798C1.07477 19.1145 1.62788 19.2352 2.73409 19.4765L3.91514 19.7342C4.36875 19.8332 4.73324 20.166 4.91114 20.5948C5.08916 21.024 5.06521 21.5137 4.81427 21.9047L4.16105 22.9225C3.54977 23.875 3.24413 24.3512 3.208 24.8603C3.19113 25.098 3.21688 25.3368 3.28403 25.5655C3.42786 26.0552 3.82799 26.4553 4.62826 27.2556L4.74438 27.3717C5.54463 28.172 5.94476 28.5721 6.43447 28.7159C6.66312 28.7831 6.90194 28.8088 7.13965 28.792C7.64877 28.7558 8.12499 28.4502 9.07744 27.8389L10.0952 27.1857C10.4862 26.9348 10.976 26.9108 11.4052 27.0889C11.834 27.2668 12.1669 27.6313 12.2659 28.0849L12.5235 29.2659C12.7649 30.3721 12.8856 30.9252 13.2202 31.3109C13.3762 31.4906 13.5631 31.6411 13.772 31.7552C14.2201 32 14.7862 32 15.9184 32H16.0816C17.2139 32 17.78 32 18.2281 31.7552C18.437 31.6411 18.6238 31.4906 18.7798 31.3109C19.1145 30.9252 19.2352 30.3721 19.4766 29.2659L19.7343 28.0849C19.8332 27.6312 20.1661 27.2667 20.5949 27.0888C21.0241 26.9108 21.5139 26.9347 21.9049 27.1857L22.9226 27.8389C23.875 28.4501 24.3512 28.7557 24.8602 28.7919C25.098 28.8087 25.3369 28.783 25.5656 28.7158C26.0552 28.572 26.4553 28.1719 27.2555 27.3717L27.3717 27.2555C28.172 26.4552 28.5721 26.0551 28.7159 25.5654C28.7831 25.3367 28.8088 25.0979 28.792 24.8602C28.7558 24.3511 28.4502 23.8749 27.8389 22.9224L27.1857 21.9046C26.9348 21.5136 26.9108 21.024 27.0888 20.5949C27.2667 20.1662 27.6311 19.8334 28.0847 19.7345L29.2658 19.4767C30.3721 19.2354 30.9253 19.1147 31.3109 18.78C31.4907 18.624 31.6411 18.4372 31.7552 18.2283C32 17.7802 32 17.214 32 16.0817V15.9185C32 14.7864 32 14.2203 31.7552 13.7722C31.6411 13.5632 31.4906 13.3764 31.3108 13.2203C30.9252 12.8857 30.3721 12.765 29.266 12.5237L28.0851 12.266C27.6314 12.167 27.2668 11.8342 27.0889 11.4052C26.9108 10.976 26.9348 10.4861 27.1858 10.0951L27.8389 9.07733C28.4503 8.12479 28.7559 7.64852 28.7921 7.13935C28.8089 6.9017 28.7832 6.66295 28.716 6.43435C28.5722 5.94459 28.1721 5.54442 27.3717 4.74409L27.2558 4.62817C26.4554 3.82779 26.0552 3.4276 25.5654 3.28379C25.3369 3.21668 25.0982 3.19094 24.8606 3.20779C24.3514 3.24388 23.8751 3.54957 22.9225 4.16094L21.9045 4.81425C21.5136 5.06516 21.0239 5.08911 20.5948 4.91112C20.166 4.73323 19.8332 4.36878 19.7342 3.9152L19.4765 2.73409Z"
    })
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21.9045 4.81425L20.8243 3.13108L21.9045 4.81425ZM27.2558 4.62817L25.8416 6.04239L27.2558 4.62817ZM25.5654 3.28379L26.1289 1.3648L25.5654 3.28379ZM24.8606 3.20779L24.7191 1.21279L24.8606 3.20779ZM27.8389 9.07733L26.1558 7.99708L27.8389 9.07733ZM28.7921 7.13935L26.7971 6.99786L28.7921 7.13935ZM28.716 6.43435L30.635 5.87085L28.716 6.43435ZM27.1858 10.0951L25.5026 9.01483L27.1858 10.0951ZM31.7552 13.7722L33.5105 12.8135L31.7552 13.7722ZM29.266 12.5237L28.8396 14.4777L29.266 12.5237ZM31.3108 13.2203L30 14.7309L31.3108 13.2203ZM29.2658 19.4767L28.8395 17.5227L29.2658 19.4767ZM31.3109 18.78L30 17.2695L31.3109 18.78ZM31.7552 18.2283L33.5104 19.1871L31.7552 18.2283ZM28.0847 19.7345L28.511 21.6885L28.0847 19.7345ZM27.1857 21.9046L28.8689 20.8243L27.1857 21.9046ZM28.7159 25.5654L26.797 25.0018L28.7159 25.5654ZM27.8389 22.9224L26.1558 24.0027L27.8389 22.9224ZM28.792 24.8602L26.797 25.0018L28.792 24.8602ZM22.9226 27.8389L21.8423 29.522L22.9226 27.8389ZM24.8602 28.7919L25.0019 26.7969L24.8602 28.7919ZM25.5656 28.7158L26.1292 30.6347L25.5656 28.7158ZM21.9049 27.1857L20.8246 28.8689L21.9049 27.1857ZM19.7343 28.0849L17.7802 27.6585L19.7343 28.0849ZM18.2281 31.7552L17.2694 30L18.2281 31.7552ZM19.4766 29.2659L21.4306 29.6922L19.4766 29.2659ZM18.7798 31.3109L17.2694 30L18.7798 31.3109ZM13.2202 31.3109L11.7097 32.6217L13.2202 31.3109ZM13.772 31.7552L12.8132 33.5104L13.772 31.7552ZM12.2659 28.0849L10.3118 28.5113L12.2659 28.0849ZM4.74438 27.3717L6.15859 25.9575L4.74438 27.3717ZM6.43447 28.7159L5.87087 30.6349L6.43447 28.7159ZM9.07744 27.8389L10.1577 29.5221L9.07744 27.8389ZM7.13965 28.792L7.28124 30.7869L7.13965 28.792ZM3.208 24.8603L1.21302 24.7188L3.208 24.8603ZM3.28403 25.5655L5.20299 25.0019L3.28403 25.5655ZM4.81427 21.9047L6.49744 22.985L4.81427 21.9047ZM0.244787 18.2281L2 17.2693L0.244787 18.2281ZM0.689119 18.7798L2 17.2693L0.689119 18.7798ZM2.73409 12.5235L3.16042 14.4775L2.73409 12.5235ZM0.689118 13.2202L2 14.7307L0.689118 13.2202ZM0.244788 13.7719L2 14.7307L0.244788 13.7719ZM3.91515 12.2658L3.48881 10.3118L3.91515 12.2658ZM4.81427 10.0953L6.49744 9.01507L4.81427 10.0953ZM4.62825 4.74441L3.21404 3.33019L4.62825 4.74441ZM3.28402 6.43453L5.20297 6.99811L3.28402 6.43453ZM3.20799 7.13968L5.20297 6.99811L3.20799 7.13968ZM9.07742 4.16109L7.99718 5.84426L9.07742 4.16109ZM7.13964 3.20805L6.99805 5.20303L7.13964 3.20805ZM6.43445 3.28408L5.87085 1.36514L6.43445 3.28408ZM10.0952 4.81428L9.01495 6.49745L10.0952 4.81428ZM12.2658 3.9151L10.3118 3.48877L12.2658 3.9151ZM18.2281 0.244788L17.2693 2L18.2281 0.244788ZM18.7798 0.689118L17.2693 2L18.7798 0.689118ZM13.7719 0.244787L12.8132 -1.51043L13.7719 0.244787ZM12.5235 2.73409L14.4775 3.16042L12.5235 2.73409ZM13.2202 0.689119L11.7097 -0.621762L13.2202 0.689119ZM15.9184 2H16.0816V-2H15.9184V2ZM14.2198 4.34144L14.4775 3.16042L10.5694 2.30775L10.3118 3.48877L14.2198 4.34144ZM7.99718 5.84426L9.01495 6.49745L11.1754 3.13111L10.1577 2.47791L7.99718 5.84426ZM6.04246 6.15862L6.15858 6.0425L3.33015 3.21408L3.21404 3.33019L6.04246 6.15862ZM6.49744 9.01507L5.84422 7.99726L2.47787 10.1578L3.1311 11.1756L6.49744 9.01507ZM3.16042 14.4775L4.34148 14.2198L3.48881 10.3118L2.30775 10.5694L3.16042 14.4775ZM2 16.0816V15.9184H-2V16.0816H2ZM4.34147 17.7802L3.16042 17.5225L2.30775 21.4306L3.4888 21.6882L4.34147 17.7802ZM5.84423 24.0028L6.49744 22.985L3.1311 20.8245L2.47788 21.8423L5.84423 24.0028ZM6.15859 25.9575L6.04247 25.8414L3.21405 28.6698L3.33016 28.7859L6.15859 25.9575ZM9.01495 25.5026L7.99719 26.1557L10.1577 29.5221L11.1754 28.8689L9.01495 25.5026ZM14.4776 28.8396L14.2199 27.6586L10.3118 28.5113L10.5695 29.6923L14.4776 28.8396ZM16.0816 30H15.9184V34H16.0816V30ZM17.7802 27.6585L17.5226 28.8396L21.4306 29.6922L21.6883 28.5112L17.7802 27.6585ZM24.0028 26.1557L22.9851 25.5025L20.8246 28.8689L21.8423 29.522L24.0028 26.1557ZM25.9575 25.8412L25.8413 25.9575L28.6697 28.7859L28.786 28.6697L25.9575 25.8412ZM25.5025 22.9848L26.1558 24.0027L29.5221 21.8422L28.8689 20.8243L25.5025 22.9848ZM28.8395 17.5227L27.6583 17.7804L28.511 21.6885L29.6922 21.4308L28.8395 17.5227ZM30 15.9185V16.0817H34V15.9185H30ZM27.6588 14.2201L28.8396 14.4777L29.6923 10.5697L28.5114 10.312L27.6588 14.2201ZM26.1558 7.99708L25.5026 9.01483L28.8689 11.1753L29.5221 10.1576L26.1558 7.99708ZM25.8416 6.04239L25.9575 6.15831L28.7859 3.32988L28.67 3.21396L25.8416 6.04239ZM22.9848 6.49742L24.0027 5.84411L21.8422 2.47777L20.8243 3.13108L22.9848 6.49742ZM17.5225 3.16042L17.7802 4.34154L21.6883 3.48887L21.4306 2.30776L17.5225 3.16042ZM21.3611 3.06376C21.469 3.1085 21.6327 3.23436 21.6883 3.48887L17.7802 4.34154C18.0336 5.5032 18.863 6.35796 19.8284 6.75848L21.3611 3.06376ZM20.8243 3.13108C21.0384 2.99362 21.2463 3.01614 21.3611 3.06376L19.8284 6.75848C20.8014 7.16208 21.9887 7.1367 22.9848 6.49742L20.8243 3.13108ZM28.67 3.21396C28.2953 2.83926 27.9221 2.46341 27.5756 2.17421C27.2032 1.86349 26.7378 1.54359 26.1289 1.3648L25.002 5.20278C24.8828 5.1678 24.8624 5.1199 25.0127 5.24533C25.1888 5.39227 25.4159 5.61671 25.8416 6.04239L28.67 3.21396ZM24.0027 5.84411C24.5093 5.51896 24.7791 5.34809 24.9824 5.24206C25.156 5.15156 25.1258 5.194 25.002 5.20278L24.7191 1.21279C24.0861 1.25767 23.5632 1.47101 23.1331 1.69521C22.7329 1.90389 22.2882 2.19155 21.8422 2.47777L24.0027 5.84411ZM26.1289 1.3648C25.6718 1.23058 25.1943 1.1791 24.7191 1.21279L25.002 5.20278L26.1289 1.3648ZM29.5221 10.1576C29.8083 9.71164 30.096 9.26695 30.3046 8.86673C30.5288 8.43674 30.7421 7.91387 30.787 7.28085L26.7971 6.99786C26.8059 6.87401 26.8483 6.84385 26.7578 7.01743C26.6518 7.22077 26.4809 7.49048 26.1558 7.99708L29.5221 10.1576ZM25.9575 6.15831C26.3832 6.58396 26.6076 6.81105 26.7545 6.98712C26.8799 7.13741 26.8321 7.11699 26.7971 6.99786L30.635 5.87085C30.4562 5.26195 30.1363 4.79656 29.8256 4.42425C29.5364 4.07771 29.1606 3.70456 28.7859 3.32988L25.9575 6.15831ZM30.787 7.28085C30.8208 6.80554 30.7693 6.32804 30.635 5.87085L26.7971 6.99786L30.787 7.28085ZM28.9362 10.6389C28.9838 10.7535 29.0063 10.9612 28.8689 11.1753L25.5026 9.01483C24.8632 10.011 24.8379 11.1985 25.2415 12.1715L28.9362 10.6389ZM28.5114 10.312C28.7658 10.3675 28.8916 10.5312 28.9362 10.6389L25.2415 12.1715C25.6421 13.1371 26.4969 13.9666 27.6588 14.2201L28.5114 10.312ZM34 15.9185C34 15.3885 34.0019 14.8587 33.9613 14.4091C33.9177 13.926 33.8148 13.3706 33.5105 12.8135L30 14.7309C29.9405 14.6219 29.9599 14.5736 29.9775 14.7686C29.9981 14.997 30 15.3164 30 15.9185H34ZM28.8396 14.4777C29.4279 14.6061 29.7396 14.676 29.9584 14.7448C30.1452 14.8036 30.0938 14.8123 30 14.7309L32.6217 11.7098C32.1422 11.2938 31.6215 11.0748 31.1588 10.9292C30.7281 10.7937 30.2102 10.6826 29.6923 10.5697L28.8396 14.4777ZM33.5105 12.8135C33.2823 12.3956 32.9813 12.0219 32.6217 11.7098L30 14.7309L33.5105 12.8135ZM29.6922 21.4308C30.2101 21.3178 30.7281 21.2067 31.1589 21.0712C31.6216 20.9256 32.1424 20.7066 32.6219 20.2904L30 17.2695C30.0938 17.1881 30.1452 17.1968 29.9584 17.2556C29.7395 17.3244 29.4279 17.3943 28.8395 17.5227L29.6922 21.4308ZM30 16.0817C30 16.6839 29.9981 17.0033 29.9775 17.2318C29.9599 17.4268 29.9405 17.3785 30 17.2695L33.5104 19.1871C33.8147 18.63 33.9177 18.0745 33.9613 17.5913C34.0019 17.1416 34 16.6118 34 16.0817H30ZM32.6219 20.2904C32.9813 19.9784 33.2822 19.6048 33.5104 19.1871L30 17.2695L32.6219 20.2904ZM28.9362 21.3613C28.8914 21.4692 28.7655 21.6329 28.511 21.6885L27.6583 17.7804C26.4967 18.0339 25.642 18.8631 25.2415 19.8286L28.9362 21.3613ZM28.8689 20.8243C29.0063 21.0385 28.9838 21.2465 28.9362 21.3613L25.2415 19.8286C24.8379 20.8015 24.8632 21.9888 25.5025 22.9848L28.8689 20.8243ZM28.786 28.6697C29.1606 28.295 29.5364 27.9219 29.8255 27.5754C30.1362 27.2032 30.456 26.7379 30.6349 26.129L26.797 25.0018C26.832 24.8827 26.8798 24.8623 26.7544 25.0125C26.6075 25.1886 26.3831 25.4156 25.9575 25.8412L28.786 28.6697ZM26.1558 24.0027C26.4809 24.5092 26.6517 24.7789 26.7577 24.9822C26.8482 25.1558 26.8058 25.1256 26.797 25.0018L30.7869 24.7186C30.742 24.0856 30.5287 23.5628 30.3045 23.1329C30.0959 22.7327 29.8083 22.2881 29.5221 21.8422L26.1558 24.0027ZM30.6349 26.129C30.7692 25.6717 30.8207 25.194 30.7869 24.7186L26.797 25.0018L30.6349 26.129ZM21.8423 29.522C22.2882 29.8082 22.7328 30.0958 23.133 30.3044C23.5629 30.5286 24.0857 30.7419 24.7186 30.7868L25.0019 26.7969C25.1257 26.8057 25.1559 26.8481 24.9823 26.7576C24.779 26.6516 24.5094 26.4808 24.0028 26.1557L21.8423 29.522ZM25.8413 25.9575C25.4157 26.383 25.1887 26.6074 25.0126 26.7543C24.8624 26.8797 24.8828 26.8319 25.0019 26.7969L26.1292 30.6347C26.738 30.4559 27.2033 30.1361 27.5756 29.8254C27.922 29.5363 28.2951 29.1605 28.6697 28.7859L25.8413 25.9575ZM24.7186 30.7868C25.1941 30.8206 25.6718 30.7691 26.1292 30.6347L25.0019 26.7969L24.7186 30.7868ZM21.3613 28.9362C21.2466 28.9838 21.0387 29.0063 20.8246 28.8689L22.9851 25.5025C21.989 24.8632 20.8016 24.8378 19.8286 25.2415L21.3613 28.9362ZM21.6883 28.5112C21.6328 28.7657 21.4691 28.8915 21.3613 28.9362L19.8286 25.2415C18.863 25.642 18.0337 26.4968 17.7802 27.6585L21.6883 28.5112ZM16.0816 34C16.6117 34 17.1415 34.0019 17.5912 33.9613C18.0743 33.9177 18.6298 33.8147 19.1869 33.5104L17.2694 30C17.3784 29.9405 17.4267 29.9599 17.2317 29.9775C17.0032 29.9981 16.6838 30 16.0816 30V34ZM17.5226 28.8396C17.3942 29.4279 17.3243 29.7395 17.2554 29.9584C17.1966 30.1452 17.188 30.0938 17.2694 30L20.2903 32.6218C20.7064 32.1423 20.9254 31.6216 21.071 31.1588C21.2065 30.7281 21.3176 30.2101 21.4306 29.6922L17.5226 28.8396ZM19.1869 33.5104C19.6047 33.2822 19.9783 32.9813 20.2903 32.6218L17.2694 30L19.1869 33.5104ZM10.5695 29.6923C10.6825 30.2101 10.7936 30.7281 10.9291 31.1588C11.0747 31.6216 11.2936 32.1423 11.7097 32.6217L14.7307 30C14.8121 30.0938 14.8035 30.1452 14.7447 29.9584C14.6758 29.7396 14.6059 29.4279 14.4776 28.8396L10.5695 29.6923ZM15.9184 30C15.3163 30 14.9969 29.9981 14.7684 29.9775C14.5734 29.9599 14.6217 29.9405 14.7307 30L12.8132 33.5104C13.3704 33.8148 13.9258 33.9177 14.4089 33.9613C14.8586 34.0019 15.3884 34 15.9184 34V30ZM11.7097 32.6217C12.0218 32.9813 12.3954 33.2822 12.8132 33.5104L14.7307 30L11.7097 32.6217ZM10.6388 28.9362C10.531 28.8915 10.3673 28.7657 10.3118 28.5113L14.2199 27.6586C13.9664 26.4969 13.137 25.642 12.1715 25.2415L10.6388 28.9362ZM11.1754 28.8689C10.9613 29.0063 10.7535 28.9838 10.6388 28.9362L12.1715 25.2415C11.1985 24.8379 10.0111 24.8632 9.01495 25.5026L11.1754 28.8689ZM3.33016 28.7859C3.7048 29.1606 4.07793 29.5364 4.42443 29.8255C4.7967 30.1362 5.26204 30.4561 5.87087 30.6349L6.99807 26.797C7.11719 26.832 7.1376 26.8799 6.98732 26.7544C6.81127 26.6075 6.5842 26.3831 6.15859 25.9575L3.33016 28.7859ZM7.99719 26.1557C7.49064 26.4809 7.22095 26.6517 7.01763 26.7577C6.84407 26.8482 6.87422 26.8058 6.99807 26.797L7.28124 30.7869C7.9142 30.742 8.43702 30.5287 8.86696 30.3045C9.26714 30.0959 9.71179 29.8083 10.1577 29.5221L7.99719 26.1557ZM5.87087 30.6349C6.32818 30.7692 6.80581 30.8207 7.28124 30.7869L6.99807 26.797L5.87087 30.6349ZM2.47788 21.8423C2.19171 22.2882 1.90409 22.7328 1.69543 23.133C1.47125 23.563 1.25794 24.0858 1.21302 24.7188L5.20299 25.0019C5.1942 25.1257 5.15176 25.1559 5.24226 24.9823C5.34827 24.779 5.51912 24.5093 5.84423 24.0028L2.47788 21.8423ZM6.04247 25.8414C5.61686 25.4158 5.39245 25.1887 5.24553 25.0126C5.12011 24.8624 5.168 24.8828 5.20299 25.0019L1.36508 26.1291C1.5439 26.7379 1.86376 27.2033 2.17444 27.5755C2.46361 27.922 2.8394 28.2952 3.21405 28.6698L6.04247 25.8414ZM1.21302 24.7188C1.17928 25.1942 1.23078 25.6718 1.36508 26.1291L5.20299 25.0019L1.21302 24.7188ZM3.06379 21.3612C3.01619 21.2465 2.99366 21.0386 3.1311 20.8245L6.49744 22.985C7.13675 21.9888 7.16213 20.8015 6.7585 19.8285L3.06379 21.3612ZM3.4888 21.6882C3.23433 21.6327 3.10851 21.469 3.06379 21.3612L6.7585 19.8285C6.35797 18.863 5.50317 18.0336 4.34147 17.7802L3.4888 21.6882ZM-2 16.0816C-2 16.6117 -2.00189 17.1414 -1.96131 17.5911C-1.91771 18.0743 -1.81475 18.6297 -1.51042 19.1868L2 17.2693C2.05954 17.3783 2.0401 17.4266 2.0225 17.2316C2.00189 17.0031 2 16.6838 2 16.0816H-2ZM3.16042 17.5225C2.57209 17.3941 2.26045 17.3242 2.04162 17.2554C1.85484 17.1966 1.9062 17.1879 2 17.2693L-0.621762 20.2903C-0.142306 20.7064 0.378434 20.9254 0.841166 21.071C1.27186 21.2065 1.78988 21.3176 2.30775 21.4306L3.16042 17.5225ZM-1.51042 19.1868C-1.28222 19.6046 -0.981283 19.9783 -0.621762 20.2903L2 17.2693L-1.51042 19.1868ZM2.30775 10.5694C1.78988 10.6824 1.27186 10.7935 0.841164 10.929C0.378432 11.0746 -0.142308 11.2936 -0.621764 11.7097L2 14.7307C1.9062 14.8121 1.85484 14.8034 2.04162 14.7446C2.26045 14.6758 2.57209 14.6059 3.16042 14.4775L2.30775 10.5694ZM2 15.9184C2 15.3162 2.00189 14.9969 2.0225 14.7684C2.0401 14.5734 2.05954 14.6217 2 14.7307L-1.51042 12.8132C-1.81475 13.3703 -1.91771 13.9257 -1.96131 14.4089C-2.00189 14.8586 -2 15.3884 -2 15.9184H2ZM-0.621764 11.7097C-0.981284 12.0217 -1.28222 12.3954 -1.51042 12.8132L2 14.7307L-0.621764 11.7097ZM3.06378 10.6388C3.10851 10.531 3.23433 10.3673 3.48881 10.3118L4.34148 14.2198C5.50318 13.9664 6.35797 13.137 6.75849 12.1715L3.06378 10.6388ZM3.1311 11.1756C2.99366 10.9614 3.01619 10.7536 3.06378 10.6388L6.75849 12.1715C7.16212 11.1985 7.13674 10.0112 6.49744 9.01507L3.1311 11.1756ZM3.21404 3.33019C2.83939 3.70484 2.46359 4.07797 2.17442 4.42448C1.86375 4.79676 1.54388 5.26211 1.36507 5.87095L5.20297 6.99811C5.16799 7.11723 5.1201 7.13765 5.24552 6.98737C5.39244 6.81131 5.61684 6.58424 6.04246 6.15862L3.21404 3.33019ZM5.84422 7.99726C5.51911 7.49069 5.34826 7.221 5.24225 7.01767C5.15175 6.84411 5.19418 6.87427 5.20297 6.99811L1.21301 7.28125C1.25792 7.91422 1.47124 8.43705 1.69542 8.867C1.90408 9.26719 2.1917 9.71185 2.47787 10.1578L5.84422 7.99726ZM1.36507 5.87095C1.23077 6.32824 1.17927 6.80584 1.21301 7.28125L5.20297 6.99811L1.36507 5.87095ZM10.1577 2.47791C9.71178 2.19175 9.26713 1.90413 8.86695 1.69548C8.43701 1.4713 7.91419 1.25799 7.28123 1.21307L6.99805 5.20303C6.87421 5.19424 6.84406 5.15181 7.01762 5.2423C7.22094 5.34832 7.49062 5.51916 7.99718 5.84426L10.1577 2.47791ZM6.15858 6.0425C6.58419 5.61689 6.81126 5.39249 6.98731 5.24557C7.13759 5.12016 7.11717 5.16804 6.99805 5.20303L5.87085 1.36514C5.26202 1.54395 4.79669 1.86381 4.42441 2.17449C4.07791 2.46365 3.70479 2.83944 3.33015 3.21408L6.15858 6.0425ZM7.28123 1.21307C6.8058 1.17932 6.32816 1.23082 5.87085 1.36514L6.99805 5.20303L7.28123 1.21307ZM10.6388 3.0638C10.7535 3.01622 10.9613 2.99368 11.1754 3.13111L9.01495 6.49745C10.0111 7.13678 11.1985 7.16215 12.1715 6.75851L10.6388 3.0638ZM10.3118 3.48877C10.3673 3.23432 10.531 3.10852 10.6388 3.0638L12.1715 6.75851C13.137 6.35797 13.9664 5.50316 14.2198 4.34144L10.3118 3.48877ZM16.0816 2C16.6838 2 17.0031 2.00189 17.2316 2.0225C17.4266 2.0401 17.3783 2.05954 17.2693 2L19.1868 -1.51042C18.6297 -1.81475 18.0743 -1.91771 17.5911 -1.96131C17.1414 -2.00189 16.6117 -2 16.0816 -2V2ZM21.4306 2.30776C21.3176 1.78988 21.2065 1.27186 21.071 0.841166C20.9254 0.378433 20.7064 -0.142307 20.2903 -0.621763L17.2693 2C17.1879 1.9062 17.1966 1.85484 17.2554 2.04162C17.3242 2.26045 17.3941 2.57209 17.5225 3.16042L21.4306 2.30776ZM17.2693 2L20.2903 -0.621763C19.9783 -0.981284 19.6046 -1.28222 19.1868 -1.51042L17.2693 2ZM15.9184 -2C15.3883 -2 14.8586 -2.00189 14.4089 -1.96131C13.9257 -1.91771 13.3703 -1.81475 12.8132 -1.51043L14.7307 2C14.6217 2.05954 14.5734 2.0401 14.7684 2.0225C14.9968 2.00189 15.3162 2 15.9184 2V-2ZM14.4775 3.16042C14.6059 2.57209 14.6758 2.26045 14.7446 2.04162C14.8034 1.85484 14.8121 1.9062 14.7307 2L11.7097 -0.621762C11.2936 -0.142306 11.0746 0.378434 10.929 0.841166C10.7935 1.27186 10.6824 1.78988 10.5694 2.30775L14.4775 3.16042ZM12.8132 -1.51043C12.3954 -1.28222 12.0217 -0.981283 11.7097 -0.621762L14.7307 2L12.8132 -1.51043Z",
    fill: t,
    mask: "url(#path-1-inside-1_11922_84131)"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconZoomL$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("mask", {
    id: "path-1-inside-1_11922_84163",
    fill: "white",
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.3456 3.41761C24.1266 2.41392 24.0171 1.91207 23.7897 1.51341C23.4143 0.855374 22.8038 0.363735 22.0809 0.137226C21.6429 0 21.1292 0 20.1019 0H19.8979C18.8706 0 18.357 0 17.919 0.137225C17.1961 0.363733 16.5856 0.855375 16.2102 1.51342C15.9828 1.91208 15.8733 2.41392 15.6543 3.41761L15.3322 4.89391C15.2085 5.46094 14.7924 5.91655 14.2564 6.13893C13.72 6.36146 13.1078 6.33151 12.619 6.01784L11.3468 5.20131C10.4827 4.64675 10.0506 4.36947 9.60818 4.24839C8.87712 4.04832 8.09743 4.13239 7.42582 4.4837C7.01935 4.69631 6.65634 5.05932 5.93034 5.78533L5.78525 5.93041C5.05925 6.65641 4.69624 7.01942 4.48363 7.42588C4.13232 8.0975 4.04826 8.87719 4.24832 9.60826C4.3694 10.0507 4.64668 10.4827 5.20124 11.3468L6.01775 12.619C6.33144 13.1078 6.36138 13.72 6.13884 14.2565C5.91646 14.7926 5.46081 15.2086 4.89375 15.3324L3.41754 15.6544C2.41392 15.8734 1.91211 15.9829 1.51347 16.2103C0.855383 16.5857 0.363713 17.1962 0.137207 17.9192C0 18.3572 0 18.8708 0 19.898V20.1021C0 21.1294 0 21.643 0.137221 22.081C0.363729 22.8039 0.855377 23.4144 1.51343 23.7898C1.91208 24.0173 2.41392 24.1268 3.4176 24.3457L4.89388 24.6678C5.4609 24.7915 5.91651 25.2076 6.13889 25.7436C6.36141 26.28 6.33148 26.8922 6.0178 27.381L5.20128 28.6532C4.64675 29.5173 4.36948 29.9493 4.2484 30.3917C4.04832 31.1228 4.13239 31.9025 4.48372 32.5742C4.69633 32.9806 5.05931 33.3436 5.78529 34.0696L5.93042 34.2147C6.65641 34.9407 7.01941 35.3037 7.42587 35.5163C8.09749 35.8676 8.8772 35.9517 9.60827 35.7516C10.0507 35.6305 10.4827 35.3533 11.3468 34.7987L12.6191 33.9822C13.1078 33.6685 13.72 33.6386 14.2564 33.8611C14.7924 34.0835 15.2085 34.5391 15.3322 35.1061L15.6543 36.5824C15.8733 37.5861 15.9828 38.0879 16.2102 38.4866C16.5856 39.1446 17.1961 39.6363 17.919 39.8628C18.357 40 18.8706 40 19.8979 40H20.1019C21.1292 40 21.6429 40 22.0809 39.8628C22.8038 39.6363 23.4143 39.1446 23.7897 38.4866C24.0171 38.0879 24.1266 37.5861 24.3456 36.5824L24.6677 35.1061C24.7914 34.5391 25.2074 34.0834 25.7435 33.8611C26.2799 33.6385 26.8921 33.6685 27.3808 33.9822L28.6531 34.7987C29.5172 35.3533 29.9492 35.6305 30.3917 35.7516C31.1227 35.9517 31.9024 35.8676 32.574 35.5163C32.9805 35.3037 33.3435 34.9407 34.0695 34.2147L34.2146 34.0696C34.9406 33.3436 35.3036 32.9806 35.5162 32.5741C35.8675 31.9025 35.9516 31.1228 35.7515 30.3918C35.6305 29.9493 35.3532 29.5173 34.7986 28.6532L33.9821 27.3809C33.6684 26.8921 33.6385 26.28 33.861 25.7436C34.0833 25.2076 34.5389 24.7916 35.1059 24.6679L36.5823 24.3458C37.5861 24.1268 38.088 24.0173 38.4866 23.7898C39.1446 23.4144 39.6362 22.804 39.8628 22.0811C40 21.6431 40 21.1294 40 20.102L40 19.8981C40 18.8708 40 18.3571 39.8628 17.9191C39.6363 17.1962 39.1446 16.5857 38.4866 16.2103C38.0879 15.9829 37.5861 15.8734 36.5824 15.6544L35.106 15.3323C34.539 15.2086 34.0834 14.7926 33.861 14.2565C33.6385 13.7201 33.6684 13.1079 33.9821 12.6192L34.7987 11.3469C35.3532 10.4827 35.6305 10.0507 35.7516 9.60821C35.9517 8.87718 35.8676 8.09751 35.5163 7.42592C35.3037 7.01943 34.9407 6.65641 34.2146 5.93037L34.0696 5.78533C33.3436 5.05932 32.9806 4.69631 32.5741 4.48369C31.9025 4.13239 31.1228 4.04833 30.3918 4.24839C29.9493 4.36947 29.5173 4.64675 28.6532 5.20132L27.3809 6.01785C26.8921 6.33153 26.2799 6.36147 25.7435 6.13894C25.2074 5.91656 24.7914 5.46094 24.6677 4.8939L24.3456 3.41761Z"
    })
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24.6677 4.8939L22.7137 5.32024L24.6677 4.8939ZM27.3809 6.01785L26.3007 4.33468L27.3809 6.01785ZM32.5741 4.48369L33.5011 2.71149L32.5741 4.48369ZM28.6532 5.20132L27.5729 3.51815L28.6532 5.20132ZM30.3918 4.24839L30.9197 6.17746L30.3918 4.24839ZM34.7987 11.3469L33.1155 10.2666L34.7987 11.3469ZM35.7516 9.60821L33.8225 9.08032L35.7516 9.60821ZM34.2146 5.93037L35.6289 4.51615L34.2146 5.93037ZM35.5163 7.42592L37.2885 6.49895L35.5163 7.42592ZM33.9821 12.6192L32.2989 11.5389L33.9821 12.6192ZM35.106 15.3323L34.6797 17.2863L35.106 15.3323ZM40 19.8981L38 19.8981L40 19.8981ZM39.8628 17.9191L37.9543 18.5171L39.8628 17.9191ZM36.5824 15.6544L37.0087 13.7004L36.5824 15.6544ZM38.4866 16.2103L37.4955 17.9475L38.4866 16.2103ZM36.5823 24.3458L36.156 22.3917L36.5823 24.3458ZM38.4866 23.7898L37.4955 22.0526L38.4866 23.7898ZM40 20.102H38H40ZM39.8628 22.0811L41.7713 22.6791L39.8628 22.0811ZM35.1059 24.6679L34.6796 22.7138L35.1059 24.6679ZM33.9821 27.3809L32.2989 28.4611L33.9821 27.3809ZM35.5162 32.5741L33.744 31.6471L35.5162 32.5741ZM34.7986 28.6532L36.4818 27.5729L34.7986 28.6532ZM35.7515 30.3918L33.8225 30.9197L35.7515 30.3918ZM28.6531 34.7987L27.5729 36.4819L28.6531 34.7987ZM30.3917 35.7516L30.9196 33.8225L30.3917 35.7516ZM32.574 35.5163L31.6471 33.7441L32.574 35.5163ZM27.3808 33.9822L28.4611 32.299L27.3808 33.9822ZM24.6677 35.1061L22.7137 34.6797L24.6677 35.1061ZM22.0809 39.8628L22.6788 41.7713L22.0809 39.8628ZM24.3456 36.5824L22.3916 36.1561L24.3456 36.5824ZM23.7897 38.4866L25.5269 39.4776L23.7897 38.4866ZM15.6543 36.5824L13.7002 37.0087L15.6543 36.5824ZM16.2102 38.4866L14.473 39.4776L16.2102 38.4866ZM17.919 39.8628L17.3211 41.7713L17.919 39.8628ZM15.3322 35.1061L13.3781 35.5324L15.3322 35.1061ZM12.6191 33.9822L13.6993 35.6653L12.6191 33.9822ZM5.93042 34.2147L4.5162 35.6289L5.93042 34.2147ZM7.42587 35.5163L6.49887 37.2885L7.42587 35.5163ZM11.3468 34.7987L12.4271 36.4819L11.3468 34.7987ZM9.60827 35.7516L9.08034 33.8225L9.60827 35.7516ZM5.20128 28.6532L3.51811 27.573L5.20128 28.6532ZM4.2484 30.3917L2.31934 29.8638L4.2484 30.3917ZM5.78529 34.0696L7.1995 32.6553L5.78529 34.0696ZM4.48372 32.5742L6.2559 31.6471L4.48372 32.5742ZM6.0178 27.381L7.70098 28.4612L6.0178 27.381ZM4.89388 24.6678L5.32022 22.7138L4.89388 24.6678ZM0.137221 22.081L2.04574 21.483L0.137221 22.081ZM3.4176 24.3457L2.99126 26.2998L3.4176 24.3457ZM1.51343 23.7898L2.50448 22.0526L1.51343 23.7898ZM1.51347 16.2103L2.50449 17.9475L1.51347 16.2103ZM4.89375 15.3324L5.32009 17.2864L4.89375 15.3324ZM6.01775 12.619L7.70092 11.5388L6.01775 12.619ZM4.48363 7.42588L2.71144 6.49889L4.48363 7.42588ZM4.24832 9.60826L6.17739 9.08034L4.24832 9.60826ZM11.3468 5.20131L10.2665 6.88448L11.3468 5.20131ZM7.42582 4.4837L6.49882 2.7115L7.42582 4.4837ZM12.619 6.01784L11.5388 7.70101L12.619 6.01784ZM15.3322 4.89391L13.3781 4.46758L15.3322 4.89391ZM22.0809 0.137226L21.4829 2.04574L22.0809 0.137226ZM24.3456 3.41761L22.3916 3.84395L24.3456 3.41761ZM23.7897 1.51341L22.0525 2.50447L23.7897 1.51341ZM17.919 0.137225L17.3211 -1.77129L17.919 0.137225ZM16.2102 1.51342L14.473 0.522362L16.2102 1.51342ZM19.8979 2H20.1019V-2H19.8979V2ZM17.2862 5.32025L17.6083 3.84394L13.7002 2.99128L13.3781 4.46758L17.2862 5.32025ZM10.2665 6.88448L11.5388 7.70101L13.6993 4.33467L12.427 3.51814L10.2665 6.88448ZM7.19947 7.34462L7.34455 7.19954L4.51612 4.37111L4.37104 4.51619L7.19947 7.34462ZM7.70092 11.5388L6.88442 10.2666L3.51807 12.4271L4.33458 13.6993L7.70092 11.5388ZM3.84387 17.6085L5.32009 17.2864L4.46742 13.3783L2.9912 13.7004L3.84387 17.6085ZM2 20.1021V19.898H-2V20.1021H2ZM5.32022 22.7138L3.84393 22.3917L2.99126 26.2998L4.46755 26.6219L5.32022 22.7138ZM6.88446 29.7335L7.70098 28.4612L4.33463 26.3007L3.51811 27.573L6.88446 29.7335ZM7.34463 32.8005L7.1995 32.6553L4.37108 35.4838L4.5162 35.6289L7.34463 32.8005ZM11.5388 32.299L10.2666 33.1155L12.4271 36.4819L13.6993 35.6653L11.5388 32.299ZM17.6083 36.1561L17.2862 34.6797L13.3781 35.5324L13.7002 37.0087L17.6083 36.1561ZM20.1019 38H19.8979V42H20.1019V38ZM22.7137 34.6797L22.3916 36.1561L26.2996 37.0087L26.6217 35.5324L22.7137 34.6797ZM29.7334 33.1155L28.4611 32.299L26.3006 35.6653L27.5729 36.4819L29.7334 33.1155ZM32.8004 32.6554L32.6553 32.8005L35.4837 35.6289L35.6288 35.4838L32.8004 32.6554ZM32.2989 28.4611L33.1154 29.7334L36.4818 27.5729L35.6652 26.3006L32.2989 28.4611ZM36.156 22.3917L34.6796 22.7138L35.5323 26.6219L37.0087 26.2998L36.156 22.3917ZM38 19.8981L38 20.102L42 20.102L42 19.8981L38 19.8981ZM34.6797 17.2863L36.156 17.6084L37.0087 13.7004L35.5324 13.3783L34.6797 17.2863ZM33.1155 10.2666L32.2989 11.5389L35.6653 13.6994L36.4818 12.4271L33.1155 10.2666ZM32.6554 7.19955L32.8004 7.34458L35.6289 4.51615L35.4838 4.37112L32.6554 7.19955ZM28.4611 7.70102L29.7334 6.88449L27.5729 3.51815L26.3007 4.33468L28.4611 7.70102ZM22.3916 3.84395L22.7137 5.32024L26.6217 4.46757L26.2996 2.99128L22.3916 3.84395ZM26.5099 4.29159C26.5169 4.29451 26.5334 4.30276 26.5545 4.32677C26.5772 4.35271 26.607 4.39996 26.6217 4.46757L22.7137 5.32024C22.9919 6.59536 23.9044 7.54129 24.9772 7.98629L26.5099 4.29159ZM26.3007 4.33468C26.417 4.25998 26.5024 4.2885 26.5099 4.29159L24.9772 7.98629C26.0575 8.43444 27.3672 8.40307 28.4611 7.70102L26.3007 4.33468ZM35.4838 4.37112C34.8571 3.74442 34.245 3.1006 33.5011 2.71149L31.6471 6.25589C31.7162 6.29201 31.8301 6.37421 32.6554 7.19955L35.4838 4.37112ZM29.7334 6.88449C30.7157 6.25406 30.8445 6.19803 30.9197 6.17746L29.8638 2.31932C29.0541 2.54091 28.3188 3.03944 27.5729 3.51815L29.7334 6.88449ZM33.5011 2.71149C32.3818 2.126 31.0823 1.98588 29.8638 2.31932L30.9197 6.17746C31.1634 6.11077 31.4232 6.13879 31.6471 6.25589L33.5011 2.71149ZM36.4818 12.4271C36.9606 11.6812 37.4591 10.9459 37.6807 10.1361L33.8225 9.08032C33.802 9.15549 33.7459 9.28429 33.1155 10.2666L36.4818 12.4271ZM32.8004 7.34458C33.6258 8.16995 33.708 8.28384 33.7441 8.35289L37.2885 6.49895C36.8994 5.75503 36.2556 5.14288 35.6289 4.51615L32.8004 7.34458ZM37.6807 10.1361C38.0141 8.91771 37.874 7.61827 37.2885 6.49895L33.7441 8.35289C33.8612 8.57676 33.8892 8.83665 33.8225 9.08032L37.6807 10.1361ZM35.7084 13.4902C35.7115 13.4976 35.74 13.583 35.6653 13.6994L32.2989 11.5389C31.5969 12.6328 31.5655 13.9426 32.0137 15.0228L35.7084 13.4902ZM35.5324 13.3783C35.6 13.393 35.6472 13.4228 35.6732 13.4455C35.6972 13.4666 35.7055 13.4831 35.7084 13.4902L32.0137 15.0228C32.4587 16.0956 33.4046 17.0081 34.6797 17.2863L35.5324 13.3783ZM42 19.8981C42 19.0113 42.0224 18.1227 41.7713 17.3212L37.9543 18.5171C37.9776 18.5915 38 18.7302 38 19.8981L42 19.8981ZM36.156 17.6084C37.2971 17.8574 37.4278 17.9089 37.4955 17.9475L39.4777 14.4732C38.7481 14.0569 37.8751 13.8894 37.0087 13.7004L36.156 17.6084ZM41.7713 17.3212C41.3938 16.1163 40.5744 15.0988 39.4777 14.4732L37.4955 17.9475C37.7149 18.0727 37.8788 18.2761 37.9543 18.5171L41.7713 17.3212ZM37.0087 26.2998C37.8751 26.1107 38.7481 25.9432 39.4777 25.527L37.4955 22.0526C37.4278 22.0913 37.2971 22.1428 36.156 22.3917L37.0087 26.2998ZM38 20.102C38 21.2699 37.9776 21.4086 37.9543 21.4831L41.7713 22.6791C42.0224 21.8775 42 20.9888 42 20.102L38 20.102ZM39.4777 25.527C40.5744 24.9013 41.3937 23.8839 41.7713 22.6791L37.9543 21.4831C37.8787 21.724 37.7149 21.9275 37.4955 22.0526L39.4777 25.527ZM35.7083 26.51C35.7054 26.517 35.6971 26.5336 35.6731 26.5546C35.6472 26.5774 35.5999 26.6072 35.5323 26.6219L34.6796 22.7138C33.4045 22.992 32.4586 23.9046 32.0136 24.9773L35.7083 26.51ZM35.6652 26.3006C35.7399 26.417 35.7114 26.5025 35.7083 26.51L32.0136 24.9773C31.5655 26.0575 31.5969 27.3673 32.2989 28.4611L35.6652 26.3006ZM35.6288 35.4838C36.2555 34.8571 36.8993 34.245 37.2884 33.5011L33.744 31.6471C33.7079 31.7162 33.6257 31.8301 32.8004 32.6554L35.6288 35.4838ZM33.1154 29.7334C33.7459 30.7157 33.8019 30.8445 33.8225 30.9197L37.6806 29.8638C37.459 29.0541 36.9605 28.3188 36.4818 27.5729L33.1154 29.7334ZM37.2884 33.5011C37.8739 32.3818 38.0141 31.0823 37.6806 29.8638L33.8225 30.9197C33.8892 31.1634 33.8611 31.4232 33.744 31.6471L37.2884 33.5011ZM27.5729 36.4819C28.3187 36.9606 29.054 37.4591 29.8638 37.6807L30.9196 33.8225C30.8444 33.802 30.7156 33.7459 29.7334 33.1155L27.5729 36.4819ZM32.6553 32.8005C31.83 33.6258 31.7161 33.708 31.6471 33.7441L33.501 37.2885C34.2449 36.8994 34.8571 36.2556 35.4837 35.6289L32.6553 32.8005ZM29.8638 37.6807C31.0822 38.0141 32.3817 37.874 33.501 37.2885L31.6471 33.7441C31.4232 33.8612 31.1633 33.8892 30.9196 33.8225L29.8638 37.6807ZM26.5098 35.7084C26.5024 35.7115 26.417 35.74 26.3006 35.6653L28.4611 32.299C27.3672 31.5969 26.0574 31.5656 24.9772 32.0137L26.5098 35.7084ZM26.6217 35.5324C26.607 35.6 26.5772 35.6473 26.5545 35.6732C26.5334 35.6972 26.5169 35.7055 26.5098 35.7084L24.9772 32.0137C23.9044 32.4587 22.9919 33.4046 22.7137 34.6797L26.6217 35.5324ZM20.1019 42C20.9887 42 21.8773 42.0224 22.6788 41.7713L21.4829 37.9543C21.4085 37.9776 21.2698 38 20.1019 38V42ZM22.3916 36.1561C22.1426 37.2971 22.0911 37.4278 22.0525 37.4955L25.5269 39.4776C25.9431 38.748 26.1106 37.8751 26.2996 37.0087L22.3916 36.1561ZM22.6788 41.7713C23.8837 41.3938 24.9012 40.5744 25.5269 39.4776L22.0525 37.4955C21.9274 37.7149 21.7239 37.8788 21.4829 37.9543L22.6788 41.7713ZM13.7002 37.0087C13.8893 37.8751 14.0568 38.748 14.473 39.4776L17.9474 37.4955C17.9087 37.4278 17.8573 37.2971 17.6083 36.1561L13.7002 37.0087ZM19.8979 38C18.7301 38 18.5914 37.9776 18.517 37.9543L17.3211 41.7713C18.1226 42.0224 19.0112 42 19.8979 42V38ZM14.473 39.4776C15.0987 40.5744 16.1161 41.3938 17.3211 41.7713L18.517 37.9543C18.276 37.8788 18.0725 37.7149 17.9474 37.4955L14.473 39.4776ZM13.4901 35.7084C13.483 35.7055 13.4665 35.6972 13.4454 35.6732C13.4226 35.6473 13.3929 35.6 13.3781 35.5324L17.2862 34.6797C17.008 33.4046 16.0955 32.4587 15.0227 32.0137L13.4901 35.7084ZM13.6993 35.6653C13.5829 35.74 13.4975 35.7115 13.4901 35.7084L15.0227 32.0137C13.9425 31.5656 12.6327 31.597 11.5388 32.299L13.6993 35.6653ZM4.5162 35.6289C5.14288 36.2556 5.755 36.8994 6.49887 37.2885L8.35288 33.7441C8.28383 33.708 8.16994 33.6258 7.34463 32.8005L4.5162 35.6289ZM10.2666 33.1155C9.28429 33.7459 9.1555 33.802 9.08034 33.8225L10.1362 37.6807C10.9459 37.4591 11.6812 36.9606 12.4271 36.4819L10.2666 33.1155ZM6.49887 37.2885C7.61823 37.874 8.91774 38.0141 10.1362 37.6807L9.08034 33.8225C8.83665 33.8892 8.57675 33.8612 8.35288 33.7441L6.49887 37.2885ZM3.51811 27.573C3.03944 28.3188 2.54093 29.0541 2.31934 29.8638L6.17746 30.9197C6.19803 30.8445 6.25406 30.7157 6.88446 29.7335L3.51811 27.573ZM7.1995 32.6553C6.37421 31.8301 6.29202 31.7162 6.2559 31.6471L2.71153 33.5012C3.10063 34.245 3.74441 34.8571 4.37108 35.4838L7.1995 32.6553ZM2.31934 29.8638C1.98587 31.0822 2.12599 32.3818 2.71153 33.5012L6.2559 31.6471C6.13879 31.4233 6.11077 31.1633 6.17746 30.9197L2.31934 29.8638ZM4.29154 26.51C4.28845 26.5025 4.25993 26.4171 4.33463 26.3007L7.70098 28.4612C8.40302 27.3673 8.43438 26.0576 7.98624 24.9773L4.29154 26.51ZM4.46755 26.6219C4.39993 26.6071 4.35268 26.5774 4.32674 26.5546C4.30272 26.5335 4.29447 26.517 4.29154 26.51L7.98624 24.9773C7.54123 23.9045 6.59532 22.992 5.32022 22.7138L4.46755 26.6219ZM-2 20.1021C-2 20.9888 -2.02243 21.8774 -1.7713 22.6789L2.04574 21.483C2.02243 21.4086 2 21.2699 2 20.1021H-2ZM3.84393 22.3917C2.70295 22.1428 2.5722 22.0913 2.50448 22.0526L0.522382 25.527C1.25197 25.9432 2.12489 26.1107 2.99126 26.2998L3.84393 22.3917ZM-1.7713 22.6789C-1.39379 23.8839 -0.574371 24.9013 0.522382 25.527L2.50448 22.0526C2.28513 21.9275 2.12124 21.724 2.04574 21.483L-1.7713 22.6789ZM2.9912 13.7004C2.12488 13.8894 1.252 14.0569 0.522449 14.4731L2.50449 17.9475C2.57221 17.9089 2.70295 17.8574 3.84387 17.6085L2.9912 13.7004ZM2 19.898C2 18.7303 2.02243 18.5915 2.04574 18.5171L-1.77132 17.3213C-2.02243 18.1228 -2 19.0113 -2 19.898H2ZM0.522449 14.4731C-0.574361 15.0988 -1.39381 16.1163 -1.77132 17.3213L2.04574 18.5171C2.12124 18.2762 2.28513 18.0726 2.50449 17.9475L0.522449 14.4731ZM4.29149 13.4902C4.29441 13.4831 4.30265 13.4666 4.32665 13.4456C4.35258 13.4228 4.39982 13.3931 4.46742 13.3783L5.32009 17.2864C6.59524 17.0082 7.54119 16.0956 7.9862 15.0228L4.29149 13.4902ZM4.33458 13.6993C4.25989 13.5829 4.28841 13.4976 4.29149 13.4902L7.9862 15.0228C8.43434 13.9425 8.40298 12.6327 7.70092 11.5388L4.33458 13.6993ZM4.37104 4.51619C3.74435 5.14288 3.10054 5.75501 2.71144 6.49889L6.25583 8.35288C6.29194 8.28383 6.37414 8.16995 7.19947 7.34462L4.37104 4.51619ZM6.88442 10.2666C6.25399 9.28429 6.19796 9.1555 6.17739 9.08034L2.31925 10.1362C2.54085 10.9459 3.03938 11.6812 3.51807 12.4271L6.88442 10.2666ZM2.71144 6.49889C2.12593 7.61824 1.98581 8.91773 2.31925 10.1362L6.17739 9.08034C6.1107 8.83665 6.13872 8.57675 6.25583 8.35288L2.71144 6.49889ZM12.427 3.51814C11.6811 3.03944 10.9458 2.54091 10.1361 2.31932L9.08027 6.17746C9.15543 6.19803 9.28422 6.25406 10.2665 6.88448L12.427 3.51814ZM7.34455 7.19954C8.16988 6.37421 8.28376 6.29201 8.35281 6.25589L6.49882 2.7115C5.75494 3.10061 5.14281 3.74442 4.51612 4.37111L7.34455 7.19954ZM10.1361 2.31932C8.91766 1.98588 7.61817 2.12599 6.49882 2.7115L8.35281 6.25589C8.57668 6.13879 8.83658 6.11077 9.08027 6.17746L10.1361 2.31932ZM13.49 4.29158C13.4975 4.28849 13.5829 4.25997 13.6993 4.33467L11.5388 7.70101C12.6327 8.40306 13.9424 8.43442 15.0227 7.98629L13.49 4.29158ZM13.3781 4.46758C13.3929 4.39997 13.4226 4.35271 13.4454 4.32677C13.4665 4.30276 13.483 4.2945 13.49 4.29158L15.0227 7.98629C16.0955 7.54128 17.008 6.59536 17.2862 5.32025L13.3781 4.46758ZM20.1019 2C21.2698 2 21.4085 2.02243 21.4829 2.04574L22.6788 -1.77129C21.8773 -2.02243 20.9887 -2 20.1019 -2V2ZM26.2996 2.99128C26.1106 2.12489 25.9431 1.25195 25.5269 0.522353L22.0525 2.50447C22.0911 2.57219 22.1426 2.70295 22.3916 3.84395L26.2996 2.99128ZM21.4829 2.04574C21.7239 2.12124 21.9274 2.28512 22.0525 2.50447L25.5269 0.522353C24.9012 -0.574377 23.8837 -1.39378 22.6788 -1.77129L21.4829 2.04574ZM19.8979 -2C19.0112 -2 18.1226 -2.02243 17.3211 -1.77129L18.517 2.04574C18.5914 2.02243 18.7301 2 19.8979 2V-2ZM17.6083 3.84394C17.8573 2.70295 17.9087 2.5722 17.9474 2.50447L14.473 0.522362C14.0568 1.25196 13.8893 2.1249 13.7002 2.99128L17.6083 3.84394ZM17.3211 -1.77129C16.1161 -1.39378 15.0987 -0.574375 14.473 0.522362L17.9474 2.50447C18.0725 2.28513 18.276 2.12124 18.517 2.04574L17.3211 -1.77129Z",
    fill: t,
    mask: "url(#path-1-inside-1_11922_84163)"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "20",
    r: "6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconZoomMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16px",
  height: "16px",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 10,
    cy: 6,
    r: 5,
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m1 15 5-5"
  })]
}), IconZoomS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "15",
    cy: "9",
    r: "8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 9C20 11.7614 17.7614 14 15 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M1 23L9 15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconZoomM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "19.4603",
    cy: "12.4147",
    r: "9.4603",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M25.0012 12.4147C25.0012 15.4748 22.5204 17.9556 19.4602 17.9556",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2.80127 29.2L12.782 19.2194",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconZoomL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("ellipse", {
    cx: "26",
    cy: "14",
    rx: "11",
    ry: "11",
    transform: "rotate(-180 26 14)",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M33 14C33 17.866 29.866 21 26 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 23L14.8787 25.1213",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "13",
    y: "25",
    width: "3",
    height: "15",
    rx: "1.5",
    transform: "rotate(45 13 25)",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconAeatMXs$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 1L8 8M15 15L12.5 12.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M1 15V15C8.17842 13.8036 13.8036 8.17842 15 1V1",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 11.5C2 11.5 2 9.5 3.5 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAeatS$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 3L11.5 14M17 21L15 18.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M7 3L13.5 11M21 21L17.7069 16.772",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 21H21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 21L3.40346 20.9433C12.3478 19.6855 19 12.0324 19 3V3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 17V17C5 15.7194 5.50871 14.4913 6.41421 13.5858L7 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAeatM$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 3L15.5 19.25M23 29L19.6667 24.5312",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 3L18.1667 15.1875M29 29L23.2647 21.6875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M23 29H29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 29L3.47379 28.9331C16.3944 27.1073 26 16.0489 26 3V3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 25V24.2426C6 21.5261 7.07913 18.9209 9 17V17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconAeatL$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9516_2581)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M4 4L19 24M28 36L24 30.5",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M12 4L23 19M36 36L29.1176 27",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M4 4H12",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M28 36H36",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M4 36L4.28143 35.9598C20.1862 33.6877 32 20.0663 32 4V4",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8 32V29.6569C8 26.0348 9.43884 22.5612 12 20V20",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9516_2581",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconPdfMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M2 3.5C2 2.94772 2.44772 2.5 3 2.5H8.58579C8.851 2.5 9.10536 2.60536 9.29289 2.79289L13.7071 7.20711C13.8946 7.39464 14 7.649 14 7.91421V13.5C14 14.0523 13.5523 14.5 13 14.5H3C2.44772 14.5 2 14.0523 2 13.5V3.5Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 11.5H5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 2.5V6.5C8 7.60457 8.89543 8.5 10 8.5H14",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconPdfS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 6.5C3 4.84315 4.34315 3.5 6 3.5H11.8849C12.6805 3.5 13.4436 3.81607 14.0062 4.37868L20.1213 10.4938C20.6839 11.0564 21 11.8195 21 12.6151V18.5C21 20.1569 19.6569 21.5 18 21.5H6C4.34315 21.5 3 20.1569 3 18.5V6.5Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 12.5H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 16.5H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13 3.5V8.5C13 10.1569 14.3431 11.5 16 11.5H21",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconPdfM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M4 7.5C4 5.84315 5.34315 4.5 7 4.5H18.7574C19.553 4.5 20.3161 4.81607 20.8787 5.37868L28.1213 12.6213C28.6839 13.1839 29 13.947 29 14.7426V26.5C29 28.1569 27.6569 29.5 26 29.5H7C5.34315 29.5 4 28.1569 4 26.5V7.5Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 10.5H8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 14.5H8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 26.5V20.5H10.5C11.3284 20.5 12 21.1716 12 22V22C12 22.8284 11.3284 23.5 10.5 23.5H8",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M22 26.5V20.5H26M25 23.5H22",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 20.5V25.5H16.5C17.8807 25.5 19 24.3807 19 23C19 21.6193 17.8807 20.5 16.5 20.5H15Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M19 4.5V11.5C19 13.1569 20.3431 14.5 22 14.5H29",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconPdfL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "41",
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M4 8.5C4 6.29086 5.79086 4.5 8 4.5H21.3431C22.404 4.5 23.4214 4.92143 24.1716 5.67157L34.8284 16.3284C35.5786 17.0786 36 18.096 36 19.1569V32.5C36 34.7091 34.2091 36.5 32 36.5H8C5.79086 36.5 4 34.7091 4 32.5V8.5Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 10.5H8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18 14.5H8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18 18.5H8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 33.5V27.5H10.5C11.3284 27.5 12 28.1716 12 29V29C12 29.8284 11.3284 30.5 10.5 30.5H8",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M22 33.5V27.5H26M25 30.5H22",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 27.5V32.5H16.5C17.8807 32.5 19 31.3807 19 30C19 28.6193 17.8807 27.5 16.5 27.5H15Z",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M22 4.5V14.5C22 16.7091 23.7909 18.5 26 18.5H36",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconEntityMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M2 14L14 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 4L7.98063 1L14 4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 7V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 7V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 7V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 7V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "4",
    r: "1",
    fill: t
  })]
}), IconEntityS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "3",
    y: "17",
    width: "18",
    height: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 7L21 7V4.85714L11.9709 2L3 4.85714L3 7L8 7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "7",
    r: "1",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 10V14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 10V14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 10V14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 10V14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconEntityM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "3",
    y: "25",
    width: "26",
    height: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 6L15.958 2L29 6V9L3 9L3 6Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 13V21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 13V21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 13V21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 6L17 6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 13V21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26 13V21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconEntityL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "4",
    y: "30",
    width: "32",
    height: "6",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 8.2L19.9484 4L36 8.2V11L4 11V8.2Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 15V26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 15V26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 15V26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18 8L22 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26 15V26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M32 15V26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconChatMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 6V15L4 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13.2929 13.7071C13.5789 13.9931 14.009 14.0787 14.3827 13.9239C14.7564 13.7691 15 13.4045 15 13V4C15 2.89543 14.1046 2 13 2H6C4.89543 2 4 2.89543 4 4V8C4 9.10457 4.89543 10 6 10L9.58579 10L13.2929 13.7071Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconChatS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M6 7C6 5.34315 7.34315 4 9 4H19C20.6569 4 22 5.34315 22 7V17.238C22 18.1732 20.8305 18.5966 20.2318 17.8781L19.0989 16.5187C17.769 14.9228 15.7988 14 13.7214 14H9C7.34315 14 6 12.6569 6 11V7Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.53516C1.8044 8.22678 1 9.51946 1 11V21.238C1 23.1086 3.33892 23.9554 4.53644 22.5183L5.6693 21.1589C6.80926 19.791 8.49794 19 10.2786 19H15C15.8814 19 16.6963 18.7149 17.3574 18.2319L17.1235 17.9917C16.6981 17.5548 16.2215 17.1794 15.7075 16.8713C15.4876 16.9545 15.2491 17 15 17H10.2786C7.90439 17 5.65281 18.0546 4.13286 19.8785L3 21.238V12.875V11V7.53516Z",
    fill: t
  })]
}), IconSheetMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M11 8H5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 5H5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 11H5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "2",
    y: "2",
    width: "12",
    height: "12",
    rx: "1",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconSheetS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M17 13H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 17H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconSheetM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M25 19H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M25 14L7 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M25 24H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "3",
    y: "3",
    width: "26",
    height: "26",
    rx: "3",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconSheetL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M31 24H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M31 18L9 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M31 30H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "4",
    y: "4",
    width: "32",
    height: "32",
    rx: "4",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconUserSpaceMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 3V13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 3V13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "5",
    r: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 13C12 13 11 11 8 11C5 11 4 13 4 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconUserSpaceS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "8",
    r: "3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.6065 17.0525C17.0371 18.0697 16.1046 19 15 19H9C7.89543 19 6.96289 18.0697 7.39346 17.0525C8.15279 15.2586 9.92942 14 12 14C14.0706 14 15.8472 15.2586 16.6065 17.0525Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3V21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 3V21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconUserSpaceM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "10",
    r: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M23.7531 24.0202C24.0257 25.0907 23.1046 26 22 26H10C8.89543 26 7.97435 25.0907 8.24685 24.0202C9.12788 20.5595 12.265 18 16 18C19.735 18 22.8721 20.5595 23.7531 24.0202Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3V29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M29 3V29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconUserSpaceL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "13",
    r: "6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M29.8025 32.0128C30.0209 33.0955 29.1046 34 28 34H12C10.8954 34 9.97914 33.0955 10.1975 32.0128C11.1191 27.4419 15.1576 24 20 24C24.8424 24 28.8809 27.4419 29.8025 32.0128Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 4V36",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M36 4V36",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconStarMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M6.70879 4.11306C7.25596 2.70435 7.52954 2 8 2C8.47046 2 8.74404 2.70436 9.29121 4.11307L9.31668 4.17866C9.62581 4.97451 9.78037 5.37244 10.0954 5.61431C10.4104 5.85617 10.8239 5.89441 11.6509 5.9709L11.8004 5.98473C13.1539 6.10992 13.8307 6.17251 13.9755 6.61716C14.1203 7.06182 13.6177 7.53403 12.6125 8.47845L12.2771 8.79365C11.7682 9.27174 11.5138 9.51078 11.3952 9.82408C11.3731 9.88252 11.3547 9.9424 11.3402 10.0033C11.2622 10.3299 11.3367 10.6767 11.4857 11.3703L11.5321 11.5861C11.806 12.8608 11.9429 13.4981 11.7038 13.773C11.6145 13.8757 11.4984 13.9496 11.3694 13.986C11.0242 14.0833 10.5342 13.6709 9.55412 12.8461C8.91057 12.3046 8.58879 12.0338 8.21936 11.9729C8.07404 11.9489 7.92596 11.9489 7.78064 11.9729C7.41121 12.0338 7.08943 12.3046 6.44588 12.8461C5.4658 13.6709 4.97576 14.0833 4.6306 13.986C4.50163 13.9496 4.38552 13.8757 4.29619 13.773C4.05712 13.4981 4.19405 12.8608 4.46789 11.5861L4.51427 11.3703C4.66327 10.6767 4.73777 10.3299 4.65983 10.0033C4.64529 9.9424 4.6269 9.88252 4.60478 9.82408C4.4862 9.51078 4.23178 9.27174 3.72294 8.79365L3.38746 8.47845C2.38228 7.53403 1.87969 7.06182 2.0245 6.61716C2.16931 6.17251 2.84607 6.10992 4.19959 5.98473L4.3491 5.9709C5.17612 5.89441 5.58962 5.85617 5.90463 5.61431C6.21963 5.37244 6.37419 4.97451 6.68332 4.17866L6.70879 4.11306Z",
    stroke: t,
    strokeWidth: "2"
  })
}), IconStarS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M10.0632 6.1696C10.8839 4.05653 11.2943 3 12 3C12.7057 3 13.1161 4.05653 13.9368 6.1696L13.975 6.26799C14.4387 7.46177 14.6706 8.05866 15.1431 8.42146C15.6156 8.78425 16.2358 8.84162 17.4764 8.95636L17.7006 8.9771C19.7309 9.16487 20.746 9.25876 20.9633 9.92575C21.1805 10.5927 20.4266 11.301 18.9188 12.7177L18.4156 13.1905C17.6523 13.9076 17.2707 14.2662 17.0928 14.7361C17.0597 14.8238 17.0321 14.9136 17.0103 15.005C16.8933 15.4949 17.0051 16.0151 17.2286 17.0554L17.2982 17.3792C17.7089 19.2912 17.9143 20.2471 17.5557 20.6595C17.4217 20.8135 17.2476 20.9245 17.0541 20.979C16.5364 21.1249 15.8013 20.5063 14.3312 19.2692C13.3659 18.4569 12.8832 18.0507 12.329 17.9593C12.1111 17.9234 11.8889 17.9234 11.671 17.9593C11.1168 18.0507 10.6341 18.4569 9.66881 19.2692C8.1987 20.5063 7.46364 21.1249 6.9459 20.979C6.75244 20.9245 6.57828 20.8135 6.44428 20.6595C6.08569 20.2471 6.29107 19.2912 6.70183 17.3792L6.7714 17.0554C6.99491 16.0151 7.10666 15.4949 6.98974 15.005C6.96793 14.9136 6.94035 14.8238 6.90717 14.7361C6.72929 14.2662 6.34767 13.9076 5.58441 13.1905L5.08119 12.7177C3.57342 11.301 2.81953 10.5927 3.03675 9.92575C3.25396 9.25876 4.2691 9.16487 6.29938 8.9771L6.52365 8.95636C7.76417 8.84162 8.38443 8.78425 8.85694 8.42146C9.32945 8.05866 9.56129 7.46177 10.025 6.26799L10.0632 6.1696Z",
    stroke: t,
    strokeWidth: "2"
  })
}), IconStarM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M13.2024 7.57831C14.3879 4.5261 14.9807 3 16 3C17.0193 3 17.6121 4.5261 18.7976 7.57831L18.8528 7.72044C19.5226 9.44478 19.8575 10.307 20.54 10.831C21.2225 11.355 22.1184 11.4379 23.9103 11.6036L24.2342 11.6336C27.1668 11.9048 28.6332 12.0404 28.9469 13.0039C29.2607 13.9673 28.1717 14.9904 25.9938 17.0366L25.267 17.7196C24.1645 18.7554 23.6132 19.2734 23.3563 19.9522C23.3084 20.0788 23.2685 20.2085 23.237 20.3405C23.0682 21.0482 23.2296 21.7995 23.5524 23.3022L23.6529 23.77C24.2462 26.5317 24.5429 27.9125 24.0249 28.5081C23.8314 28.7307 23.5798 28.8909 23.3004 28.9697C22.5525 29.1804 21.4908 28.2869 19.3673 26.5C17.9729 25.3266 17.2757 24.7399 16.4753 24.6079C16.1604 24.556 15.8396 24.556 15.5247 24.6079C14.7243 24.7399 14.0271 25.3266 12.6327 26.5C10.5092 28.2869 9.44749 29.1804 8.69964 28.9697C8.42019 28.8909 8.16863 28.7307 7.97508 28.5081C7.4571 27.9125 7.75377 26.5317 8.34709 23.77L8.44758 23.3022C8.77042 21.7995 8.93185 21.0482 8.76296 20.3405C8.73146 20.2085 8.69162 20.0788 8.64369 19.9522C8.38676 19.2734 7.83552 18.7554 6.73303 17.7196L6.00616 17.0366C3.82827 14.9904 2.73933 13.9673 3.05308 13.0039C3.36684 12.0404 4.83315 11.9048 7.76577 11.6336L8.08971 11.6036C9.88158 11.4379 10.7775 11.355 11.46 10.831C12.1425 10.307 12.4774 9.44478 13.1472 7.72043L13.2024 7.57831Z",
    stroke: t,
    strokeWidth: "2"
  })
}), IconStarL = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    d: "M16.5568 9.63484C18.0159 5.87828 18.7454 4 20 4C21.2546 4 21.9841 5.87828 23.4432 9.63484L23.5112 9.80977C24.3355 11.932 24.7476 12.9932 25.5877 13.6381C26.4277 14.2831 27.5304 14.3851 29.7357 14.5891L30.1344 14.626C33.7438 14.9598 35.5485 15.1267 35.9347 16.3124C36.3208 17.4982 34.9806 18.7574 32.3001 21.2759L31.4055 22.1164C30.0486 23.3913 29.3701 24.0287 29.0539 24.8642C28.9949 25.0201 28.9459 25.1797 28.9071 25.3422C28.6993 26.2131 28.8979 27.1379 29.2953 28.9874L29.419 29.5631C30.1492 32.9621 30.5143 34.6615 29.8768 35.3946C29.6386 35.6685 29.329 35.8657 28.9851 35.9626C28.0646 36.222 26.7579 35.1224 24.1443 32.923C22.4282 31.4789 21.5701 30.7568 20.5849 30.5943C20.1974 30.5304 19.8026 30.5304 19.4151 30.5943C18.4299 30.7568 17.5718 31.4789 15.8557 32.923C13.2421 35.1223 11.9354 36.222 11.0149 35.9626C10.671 35.8657 10.3614 35.6685 10.1232 35.3946C9.48567 34.6615 9.85079 32.962 10.581 29.5631L10.7047 28.9874C11.1021 27.1379 11.3007 26.2131 11.0929 25.3422C11.0541 25.1797 11.0051 25.0201 10.9461 24.8642C10.6299 24.0287 9.9514 23.3913 8.5945 22.1164L7.69989 21.2759C5.01941 18.7574 3.67917 17.4982 4.06533 16.3124C4.45149 15.1267 6.25618 14.9598 9.86557 14.626L10.2643 14.5891C12.4696 14.3851 13.5723 14.2831 14.4123 13.6381C15.2524 12.9932 15.6645 11.932 16.4888 9.80977L16.5568 9.63484Z",
    stroke: t,
    strokeWidth: "2"
  })
}), IconShareMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M9 11L6 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 5L6 7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "11",
    cy: "12",
    rx: "2",
    ry: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "12",
    cy: "4",
    rx: "2",
    ry: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "4",
    cy: "8",
    rx: "2",
    ry: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconShareS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M13 17L7 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 6L7 11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "15",
    cy: "18",
    rx: "2",
    ry: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "19",
    cy: "5",
    rx: "2",
    ry: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "5",
    cy: "12",
    rx: "2",
    ry: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconShareM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M16 21L11 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 9L11 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "20",
    cy: "24",
    rx: "4",
    ry: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "25",
    cy: "7",
    rx: "4",
    ry: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "7",
    cy: "16",
    rx: "4",
    ry: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconShareL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M20 28L12 22",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M28 10L12 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "24",
    cy: "31",
    rx: "4",
    ry: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "32",
    cy: "8",
    rx: "4",
    ry: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("ellipse", {
    cx: "8",
    cy: "20",
    rx: "4",
    ry: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconQuestionMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "12",
    r: "1",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 5.99423C6 3.33526 10 3.33526 10 5.99423C10 6.77789 9.49938 7.36891 8.94473 7.69934C8.46934 7.98253 8 8.44665 8 9V9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconQuestionS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 9V9C9 7.34315 10.3431 6 12 6V6V6C13.6569 6 15 7.34315 15 9L15 9.06461C15 9.97413 14.596 10.8367 13.8973 11.4189L12.6667 12.4444C12.2442 12.7965 12 13.3179 12 13.8678L12 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 17L12 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconQuestionM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13 12V12C13 10.3431 14.3431 9 16 9V9V9C17.6569 9 19 10.3431 19 12V12.0646C19 12.9741 18.596 13.8367 17.8973 14.4189L16.6667 15.4444C16.2442 15.7965 16 16.3179 16 16.8678L16 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 22L16 23",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconQuestionL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "20",
    r: "19",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 17V17C17 15.3431 18.3431 14 20 14V14V14C21.6569 14 23 15.3431 23 17L23 17.2569C23 18.3459 22.4558 19.3628 21.5497 19.9669L20.6667 20.5556C20.2502 20.8332 20 21.3007 20 21.8012L20 23",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 26L20 27",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconAeatMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M8 5L8 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 8L8.10607 10.8939C8.04749 10.9525 7.95251 10.9525 7.89393 10.8939L5 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "14",
    y: "14",
    width: "12",
    height: "12",
    rx: "1",
    transform: "rotate(-180 14 14)",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconAeatS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 3H21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 3H19V16.9006C19 16.9373 19 16.9556 18.9959 16.9729C18.9922 16.9882 18.9861 17.0028 18.9779 17.0162C18.9686 17.0314 18.9556 17.0444 18.9297 17.0703L15.0703 20.9297C15.0444 20.9556 15.0314 20.9686 15.0162 20.9779C15.0028 20.9861 14.9882 20.9922 14.9729 20.9959C14.9556 21 14.9373 21 14.9006 21H8.2C7.07989 21 6.51984 21 6.09202 20.782C5.71569 20.5903 5.40973 20.2843 5.21799 19.908C5 19.4802 5 18.9201 5 17.8V3Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 21V16.15C14 16.0672 14.0672 16 14.15 16H19",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 7L12 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 10L12.1061 12.8939C12.0475 12.9525 11.9525 12.9525 11.8939 12.8939L9 10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconAeatM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 4L29 4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 4H27V24.8973C27 24.9352 27 24.9541 26.9956 24.9718C26.9917 24.9876 26.9853 25.0026 26.9766 25.0163C26.9668 25.0317 26.9531 25.0448 26.9257 25.0709L20.7838 30.9336C20.7581 30.9581 20.7453 30.9704 20.7305 30.9792C20.7173 30.9869 20.7031 30.9926 20.6882 30.9961C20.6714 31 20.6536 31 20.6181 31H8.2C7.07989 31 6.51984 31 6.09202 30.782C5.71569 30.5903 5.40973 30.2843 5.21799 29.908C5 29.4802 5 28.9201 5 27.8V4Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 30V24.15C20 24.0672 20.0672 24 20.15 24H26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 9.33301L16 17.333",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 13.333L16.1061 17.2269C16.0475 17.2855 15.9525 17.2855 15.8939 17.2269L12 13.333",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconAeatL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M4 1L36 1",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 1H34V30.4599C34 30.4953 34 30.5129 33.9961 30.5296C33.9927 30.5444 33.987 30.5586 33.9794 30.5717C33.9707 30.5865 33.9585 30.5993 33.9342 30.625L26.071 38.9251C26.0448 38.9527 26.0317 38.9665 26.0163 38.9764C26.0025 38.9852 25.9875 38.9916 25.9717 38.9956C25.9539 39 25.9348 39 25.8968 39H9.2C8.0799 39 7.51984 39 7.09202 38.782C6.71569 38.5903 6.40973 38.2843 6.21799 37.908C6 37.4802 6 36.9201 6 35.8V1Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26 39V30.15C26 30.0672 26.0672 30 26.15 30H33",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 13L20 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24 17L20.1061 20.8939C20.0475 20.9525 19.9525 20.9525 19.8939 20.8939L16 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconBellMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "14",
    r: "1",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 12H14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 9V8C12 5.79086 10.2091 4 8 4V4C5.79086 4 4 5.79086 4 8V9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M7 1H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconBellS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "21",
    r: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 16H19",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 2H13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 16V10C17 7.23858 14.7614 5 12 5V5C9.23858 5 7 7.23858 7 10V16",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconBellM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "28",
    r: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 22H27",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 1H18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24 22V13C24 8.58172 20.4183 5 16 5V5C11.5817 5 8 8.58172 8 13V22",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconBellL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "34",
    r: "3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 27L34 27",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18 2H22",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M30 27V16C30 10.4772 25.5228 6 20 6V6C14.4772 6 10 10.4772 10 16V27",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCopyMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "3",
    y: "4",
    width: "8",
    height: "11",
    rx: "1",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 1H13C13.5523 1 14 1.44772 14 2V10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCopyS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "5",
    y: "5",
    width: "12",
    height: "18",
    rx: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 1H19C20.1046 1 21 1.89543 21 3V15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCopyM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "5",
    y: "9",
    width: "16",
    height: "22",
    rx: "3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24 23V23C25.6569 23 27 21.6569 27 20V4C27 2.34315 25.6569 1 24 1H14C12.3431 1 11 2.34315 11 4V6.0625",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  })]
}), IconCopyL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "6",
    y: "7",
    width: "21",
    height: "32",
    rx: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M30 33V33C32.2091 33 34 31.2091 34 29V5C34 2.79086 32.2091 1 30 1H16C14.3431 1 13 2.34315 13 4V4",
    stroke: t,
    strokeWidth: "2",
    strokeLinejoin: "round"
  })]
}), IconRefreshMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M10.3879 3.60597C11.944 4.45342 13 6.10338 13 7.99997C13 10.0503 11.7659 11.8124 10 12.5839M5.33052 12.2285C3.92997 11.3425 3 9.77982 3 7.99997C3 5.94965 4.2341 4.18757 6 3.41602",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12.7929 2H9.5C9.22386 2 9 2.22386 9 2.5V5.79289C9 6.23835 9.53857 6.46143 9.85355 6.14645L13.1464 2.85355C13.4614 2.53857 13.2383 2 12.7929 2Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3.20711 14L6.5 14C6.77614 14 7 13.7761 7 13.5L7 10.2071C7 9.76165 6.46143 9.53857 6.14645 9.85355L2.85355 13.1464C2.53857 13.4614 2.76165 14 3.20711 14Z",
    fill: t
  })]
}), IconRefreshS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 8.46628 18.9634 5.40822 16 3.93552M12 3C7.02944 3 3 7.02944 3 12C3 15.5337 5.03656 18.5918 8 20.0645",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 4H16V9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 20L8 20L8 15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconRefreshM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M16 29C23.1797 29 29 23.1797 29 16C29 11.3976 26.6083 7.35377 23 5.04364M16 3C8.8203 3 3 8.8203 3 16C3 20.6024 5.39169 24.6462 9 26.9564",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M29 5H23V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 27L9 27L9 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconRefreshL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M20 36C28.8366 36 36 28.8366 36 20C36 14.7206 33.4431 10.0384 29.5 7.12432M20 4C11.1634 4 4 11.1634 4 20C4 25.3551 6.63084 30.0958 10.6705 33",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 33L11 33L11 26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M36 7L29 7L29 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconEyeMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11163_6491)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M15 8C13.1333 11.3333 10.8 13 8 13C5.2 13 2.86667 11.3333 1 8C2.86667 4.66667 5.2 3 8 3C10.8 3 13.1333 4.66667 15 8Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7 8C7 8.26522 7.10536 8.51957 7.29289 8.70711C7.48043 8.89464 7.73478 9 8 9C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8C9 7.73478 8.89464 7.48043 8.70711 7.29289C8.51957 7.10536 8.26522 7 8 7C7.73478 7 7.48043 7.10536 7.29289 7.29289C7.10536 7.48043 7 7.73478 7 8Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11163_6491",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })
  })]
}), IconEyeS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11163_6492)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M23 12C20.0667 16.6667 16.4 19 12 19C7.6 19 3.93333 16.6667 1 12C3.93333 7.33333 7.6 5 12 5C16.4 5 20.0667 7.33333 23 12Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11163_6492",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    })
  })]
}), IconEyeM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11163_6493)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12 16C12 17.0609 12.4214 18.0783 13.1716 18.8284C13.9217 19.5786 14.9391 20 16 20C17.0609 20 18.0783 19.5786 18.8284 18.8284C19.5786 18.0783 20 17.0609 20 16C20 14.9391 19.5786 13.9217 18.8284 13.1716C18.0783 12.4214 17.0609 12 16 12C14.9391 12 13.9217 12.4214 13.1716 13.1716C12.4214 13.9217 12 14.9391 12 16Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M31 16C27 22.6667 22 26 16 26C10 26 5 22.6667 1 16C5 9.33333 10 6 16 6C22 6 27 9.33333 31 16Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11163_6493",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "32",
        height: "32",
        fill: "white"
      })
    })
  })]
}), IconEyeL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("g", {
    clipPath: "url(#clip0_11163_6494)",
    children: /* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip1_11163_6494)",
      children: [/* @__PURE__ */ jsx$1("path", {
        d: "M15 20C15 21.3261 15.5268 22.5979 16.4645 23.5355C17.4021 24.4732 18.6739 25 20 25C21.3261 25 22.5979 24.4732 23.5355 23.5355C24.4732 22.5979 25 21.3261 25 20C25 18.6739 24.4732 17.4021 23.5355 16.4645C22.5979 15.5268 21.3261 15 20 15C18.6739 15 17.4021 15.5268 16.4645 16.4645C15.5268 17.4021 15 18.6739 15 20Z",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M39 20C33.9333 28 27.6 32 20 32C12.4 32 6.06667 28 1 20C6.06667 12 12.4 8 20 8C27.6 8 33.9333 12 39 20Z",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  }), /* @__PURE__ */ jsxs("defs", {
    children: [/* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11163_6494",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    }), /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip1_11163_6494",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })]
  })]
}), EyeClosedXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_13436_7592)",
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.31647 13.512C6.15491 13.8336 7.04912 14 8 14C11.2903 14 13.9022 12.0071 15.8725 8.4886C16.0425 8.18505 16.0425 7.81495 15.8725 7.5114C15.2993 6.48777 14.6718 5.59327 13.989 4.8394L12.5743 6.25408C13.0119 6.74752 13.4348 7.32766 13.8428 8C12.1445 10.7988 10.1864 12 8 12C7.63687 12 7.28003 11.9669 6.92964 11.8988L5.31647 13.512ZM7.83307 10.9954C7.88851 10.9984 7.94418 11 8 11C8.79565 11 9.55871 10.6839 10.1213 10.1213C10.6839 9.55871 11 8.79565 11 8C11 7.94418 10.9984 7.88852 10.9954 7.83307L7.83307 10.9954ZM8.16693 5.00464L5.00464 8.16693C5.00156 8.11149 5 8.05582 5 8C5 7.20435 5.31607 6.44129 5.87868 5.87868C6.44129 5.31607 7.20435 5 8 5C8.05582 5 8.11149 5.00156 8.16693 5.00464ZM9.07036 4.10122C8.71997 4.03313 8.36313 4 8 4C5.81356 4 3.85551 5.20118 2.15722 8C2.56519 8.67234 2.98814 9.25248 3.42565 9.74592L2.01098 11.1606C1.32825 10.4067 0.700723 9.51223 0.127494 8.4886C-0.042498 8.18505 -0.042498 7.81495 0.127494 7.5114C2.09785 3.99291 4.70969 2 8 2C8.95088 2 9.84509 2.16644 10.6835 2.48804L9.07036 4.10122Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13 3L3 13",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_13436_7592",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })
  })]
}), EyeClosedS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_13436_7593)",
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.14109 19.3944C9.35788 19.7958 10.6442 20 12 20C16.8329 20 20.7833 17.4057 23.8466 12.5322C24.0511 12.2069 24.0511 11.7931 23.8466 11.4678C22.7788 9.76901 21.6032 8.34713 20.32 7.21555L18.9035 8.63199C19.931 9.51984 20.8993 10.6391 21.8085 12C19.074 16.0927 15.8058 18 12 18C11.2347 18 10.4911 17.9229 9.76918 17.7663L8.14109 19.3944ZM11.5598 15.9757C11.7053 15.9918 11.8522 16 12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 11.8522 15.9918 11.7053 15.9757 11.5598L11.5598 15.9757ZM12.4402 8.02428L8.02428 12.4402C8.00818 12.2947 8 12.1478 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C12.1478 8 12.2947 8.00818 12.4402 8.02428ZM14.2308 6.23365C13.5089 6.07713 12.7653 6 12 6C8.19415 6 4.926 7.90728 2.19145 12C3.10073 13.3609 4.06902 14.4802 5.09645 15.368L3.68001 16.7844C2.39681 15.6529 1.22119 14.231 0.153363 12.5322C-0.0511211 12.2069 -0.0511211 11.7931 0.153363 11.4678C3.21673 6.59429 7.16715 4 12 4C13.3558 4 14.6421 4.20417 15.8589 4.60556L14.2308 6.23365Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M19 5L5 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_13436_7593",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    })
  })]
}), EyeClosedM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_13436_7590)",
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.7898 25.7457C11.723 26.5769 13.7929 27 16 27C22.4556 27 27.7378 23.3806 31.8575 16.5145C32.0475 16.1978 32.0475 15.8022 31.8575 15.4855C30.2617 12.8258 28.4914 10.6532 26.546 8.98954L25.1279 10.4076C26.8087 11.8176 28.3754 13.6755 29.8275 16C26.0078 22.1144 21.3953 25 16 25C14.3728 25 12.8168 24.7375 11.3323 24.2032L9.7898 25.7457ZM14.7059 20.8296C15.1244 20.9418 15.5592 21 16 21C17.3261 21 18.5979 20.4732 19.5355 19.5355C20.4732 18.5979 21 17.3261 21 16C21 15.5592 20.9418 15.1244 20.8296 14.7059L18.9404 16.5951C18.8242 17.1691 18.5415 17.7011 18.1213 18.1213C17.7011 18.5415 17.1691 18.8242 16.5951 18.9404L14.7059 20.8296ZM13.0596 15.4049L11.1704 17.2941C11.0582 16.8756 11 16.4408 11 16C11 14.6739 11.5268 13.4021 12.4645 12.4645C13.4021 11.5268 14.6739 11 16 11C16.4408 11 16.8756 11.0582 17.2941 11.1704L15.4049 13.0596C14.8309 13.1758 14.2989 13.4585 13.8787 13.8787C13.4585 14.2989 13.1758 14.8309 13.0596 15.4049ZM20.6677 7.79681C19.1832 7.26246 17.6272 7 16 7C10.6047 7 5.99223 9.88556 2.17246 16C3.62461 18.3245 5.19132 20.1823 6.87206 21.5924L5.45401 23.0105C3.50864 21.3468 1.73835 19.1742 0.142507 16.5145C-0.0475024 16.1978 -0.0475024 15.8022 0.142507 15.4855C4.26219 8.61936 9.54444 5 16 5C18.2071 5 20.277 5.42305 22.2102 6.25427L20.6677 7.79681Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M27 5L5 27",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_13436_7590",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "32",
        height: "32",
        fill: "white"
      })
    })
  })]
}), EyeClosedL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("g", {
    clipPath: "url(#clip0_13436_7591)",
    children: /* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip1_13436_7591)",
      children: [/* @__PURE__ */ jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0874 31.4482C14.5517 32.4783 17.1893 33 20 33C28.0292 33 34.6465 28.743 39.8448 20.5351C40.0517 20.2084 40.0517 19.7916 39.8448 19.4649C37.6236 15.9577 35.1432 13.1718 32.4043 11.1312L30.9741 12.5614C33.4479 14.3499 35.7265 16.822 37.8104 20C32.9393 27.4285 27.0046 31 20 31C17.7688 31 15.6462 30.6376 13.6319 29.9036L12.0874 31.4482ZM17.911 25.6246C18.5732 25.8706 19.2799 26 20 26C21.5913 26 23.1174 25.3679 24.2426 24.2426C25.3679 23.1174 26 21.5913 26 20C26 19.2799 25.8706 18.5732 25.6246 17.911L23.9757 19.5598C23.9918 19.7053 24 19.8522 24 20C24 21.0609 23.5786 22.0783 22.8284 22.8284C22.0783 23.5786 21.0609 24 20 24C19.8522 24 19.7053 23.9918 19.5598 23.9757L17.911 25.6246ZM16.0243 20.4402L14.3754 22.089C14.1294 21.4268 14 20.7201 14 20C14 18.4087 14.6321 16.8826 15.7574 15.7574C16.8826 14.6321 18.4087 14 20 14C20.7201 14 21.4268 14.1294 22.089 14.3754L20.4402 16.0243C20.2947 16.0082 20.1478 16 20 16C18.9391 16 17.9217 16.4214 17.1716 17.1716C16.4214 17.9217 16 18.9391 16 20C16 20.1478 16.0082 20.2947 16.0243 20.4402ZM26.3681 10.0964C24.3538 9.36238 22.2312 9 20 9C12.9954 9 7.06072 12.5715 2.18961 20C4.27354 23.178 6.55212 25.6501 9.02586 27.4386L7.59566 28.8688C4.85678 26.8282 2.37644 24.0423 0.155181 20.5351C-0.051727 20.2084 -0.051727 19.7916 0.155181 19.4649C5.35352 11.257 11.9708 7 20 7C22.8107 7 25.4483 7.52165 27.9126 8.55182L26.3681 10.0964Z",
        fill: t
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M34 6L6 34",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  }), /* @__PURE__ */ jsxs("defs", {
    children: [/* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_13436_7591",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    }), /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip1_13436_7591",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })]
  })]
}), IconCardMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11101_6507)",
    children: [/* @__PURE__ */ jsx$1("rect", {
      x: "1",
      y: "3",
      width: "14",
      height: "10",
      rx: "2",
      stroke: t,
      strokeWidth: "2"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M2 6H14",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 10H12",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11101_6507",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })
  })]
}), IconCardS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11101_6508)",
    children: [/* @__PURE__ */ jsx$1("rect", {
      x: "1",
      y: "5",
      width: "22",
      height: "14",
      rx: "2",
      stroke: t,
      strokeWidth: "2"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M2 9H22",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M15 15H19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11101_6508",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    })
  })]
}), IconCardM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11101_6509)",
    children: [/* @__PURE__ */ jsx$1("rect", {
      x: "1",
      y: "5",
      width: "30",
      height: "22",
      rx: "3",
      stroke: t,
      strokeWidth: "2"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M2 11H38",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M22 23H27",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11101_6509",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "32",
        height: "32",
        fill: "white"
      })
    })
  })]
}), IconCardL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_11101_6510)",
    children: [/* @__PURE__ */ jsx$1("rect", {
      x: "1",
      y: "6",
      width: "38",
      height: "28",
      rx: "4",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M2 14H38",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M29 29H34",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_11101_6510",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconMailMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M14 4L8 8L2 4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "1",
    y: "3",
    width: "14",
    height: "10",
    rx: "1",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconMailS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M22 6L12 12L2 6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("rect", {
    x: "1",
    y: "5",
    width: "22",
    height: "14",
    rx: "2",
    stroke: t,
    strokeWidth: "2"
  })]
}), IconMailM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "1",
    y: "5",
    width: "30",
    height: "22",
    rx: "3",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M30 6L16 16L2 6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconMailL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M1 10C1 7.79086 2.79086 6 5 6H35C37.2091 6 39 7.79086 39 10V30C39 32.2091 37.2091 34 35 34H5C2.79086 34 1 32.2091 1 30V10Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M38 8L20 20L2 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconMoneyL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "20",
    r: "19",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26.0455 26.0454C22.7066 29.3842 17.2934 29.3842 13.9545 26.0454C10.6157 22.7066 10.6157 17.2933 13.9545 13.9545C17.2934 10.6157 22.7066 10.6157 26.0455 13.9545",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 20L20 20",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconMoneyM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20.7727 20.7727C18.1368 23.4086 13.8632 23.4086 11.2273 20.7727C8.59136 18.1368 8.59136 13.8631 11.2273 11.2272C13.8632 8.59132 18.1368 8.59132 20.7727 11.2272",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 16L16 16",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconMoneyS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15.5 15.5C13.567 17.433 10.433 17.433 8.5 15.5C6.567 13.567 6.567 10.433 8.5 8.49997C10.433 6.56697 13.567 6.56697 15.5 8.49997",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 12L13 12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconMoneyXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 9L11 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 14C11.2386 16.7614 6.76142 16.7614 4 14C1.23857 11.2386 1.23857 6.76143 4 4C6.76142 1.23858 11.2386 1.23858 14 4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconFlyingMoneyMXs = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M10 1L1 10L6 15L15 6L10 1Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9C8.55228 9 9 8.55228 9 8Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3L2 2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 14L13 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconFlyingMoneyS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M13.6066 3.3934L3 14L10.0711 21.0711L20.6777 10.4645L13.6066 3.3934Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 8L17 7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M7 17L8 16",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 6L3 3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 21L18 18",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconFlyingMoneyM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M18.8284 4.68599L4.68628 18.8281L13.1716 27.3134L27.3137 13.1713L18.8284 4.68599Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 11L22.2929 9.70711",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 23L11.2929 20.7071",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M19 16.0005C19 14.3436 17.6569 13.0005 16 13.0005C14.3431 13.0005 13 14.3436 13 16.0005C13 17.6573 14.3431 19.0005 16 19.0005C17.6569 19.0005 19 17.6573 19 16.0005Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 9L3 3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M29 29L23 23",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 12L3 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M29 23L26 20",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconFlyingMoneyL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M23.5355 6.56508L6.56494 23.5356L16.4644 33.4351L33.435 16.4646L23.5355 6.56508Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26 14L28 12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 28L14 26",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M23.4644 20.0356C23.4644 18.1026 21.8974 16.5356 19.9644 16.5356C18.0314 16.5356 16.4644 18.1026 16.4644 20.0356C16.4644 21.9686 18.0314 23.5356 19.9644 23.5356C21.8974 23.5356 23.4644 21.9686 23.4644 20.0356Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 12L4 4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M36 36L28 28",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 16L4 12",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M36 28L32 24",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCircleTickSolidMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L7 8.58579L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.7071L6.29289 10.7071C6.48043 10.8946 6.73478 11 7 11C7.26522 11 7.51957 10.8946 7.70711 10.7071L11.7071 6.70711Z",
    fill: t
  })
}), IconCircleTickSolidS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM17.7071 9.70711C18.0976 9.31658 18.0976 8.68342 17.7071 8.29289C17.3166 7.90237 16.6834 7.90237 16.2929 8.29289L11 13.5858L8.70711 11.2929C8.31658 10.9024 7.68342 10.9024 7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L10.2929 15.7071C10.6834 16.0976 11.3166 16.0976 11.7071 15.7071L17.7071 9.70711Z",
    fill: t
  })
}), IconCircleTickSolidM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0ZM22.7071 12.7071C23.0976 12.3166 23.0976 11.6834 22.7071 11.2929C22.3166 10.9024 21.6834 10.9024 21.2929 11.2929L14 18.5858L10.7071 15.2929C10.3166 14.9024 9.68342 14.9024 9.29289 15.2929C8.90237 15.6834 8.90237 16.3166 9.29289 16.7071L13.2929 20.7071C13.6834 21.0976 14.3166 21.0976 14.7071 20.7071L22.7071 12.7071Z",
    fill: t
  })
}), IconCircleTickSolidL = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM28.7071 14.7071C29.0976 14.3166 29.0976 13.6834 28.7071 13.2929C28.3166 12.9024 27.6834 12.9024 27.2929 13.2929L17 23.5858L12.7071 19.2929C12.3166 18.9024 11.6834 18.9024 11.2929 19.2929C10.9024 19.6834 10.9024 20.3166 11.2929 20.7071L16.2929 25.7071C16.4804 25.8946 16.7348 26 17 26C17.2652 26 17.5196 25.8946 17.7071 25.7071L28.7071 14.7071Z",
    fill: t
  })
}), IconWarningRoundedSolidMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8.00003 3.99999C7.44774 3.99999 7.00003 4.44771 7.00003 4.99999L7.00003 7.99999C7.00003 8.55228 7.44774 8.99999 8.00002 8.99999C8.55231 8.99999 9.00002 8.55228 9.00003 7.99999V4.99999C9.00003 4.44771 8.55231 3.99999 8.00003 3.99999ZM7.00003 11C7.00003 10.4477 7.44775 9.99999 8.00004 9.99999C8.55232 10 9.00003 10.4477 9.00003 11V11.01C9.00002 11.5623 8.5523 12.01 8.00002 12.01C7.44773 12.01 7.00002 11.5623 7.00003 11.01V11Z",
    fill: t
  })
}), IconWarningRoundedSolidS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12.0001 7.00001C11.4478 7.00001 11.0001 7.44773 11.0001 8.00001V12C11.0001 12.5523 11.4478 13 12.0001 13C12.5524 13 13.0001 12.5523 13.0001 12V8.00001C13.0001 7.44773 12.5524 7.00001 12.0001 7.00001ZM11.0051 15C11.0051 14.4477 11.4528 14 12.0051 14C12.5574 14 13.0051 14.4477 13.0051 15V15.01C13.0051 15.5623 12.5574 16.01 12.0051 16.01C11.4528 16.01 11.0051 15.5623 11.0051 15.01V15Z",
    fill: t
  })
}), IconWarningRoundedSolidM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM16 10C15.4477 10 15 10.4477 15 11V16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16V11C17 10.4477 16.5523 10 16 10ZM15.005 20C15.005 19.4477 15.4528 19 16.005 19C16.5573 19 17.005 19.4477 17.005 20V20.01C17.005 20.5623 16.5573 21.01 16.005 21.01C15.4527 21.01 15.005 20.5623 15.005 20.01V20Z",
    fill: t
  })
}), IconWarningRoundedSolidL = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20ZM20 13C19.4477 13 19 13.4477 19 14V20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13ZM19.005 25C19.005 24.4477 19.4528 24 20.005 24C20.5573 24 21.005 24.4477 21.005 25V25.01C21.005 25.5623 20.5573 26.01 20.005 26.01C19.4527 26.01 19.005 25.5623 19.005 25.01V25Z",
    fill: t
  })
}), IconCrossRoundedSolidMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM5.29295 10.7071C4.90243 10.3166 4.90243 9.68341 5.29295 9.29289L6.58583 8.00001L5.29292 6.7071C4.90239 6.31658 4.90239 5.68341 5.29292 5.29289C5.68344 4.90236 6.31661 4.90236 6.70713 5.29289L8.00004 6.5858L9.29295 5.29289C9.68348 4.90236 10.3166 4.90236 10.7072 5.29289C11.0977 5.68341 11.0977 6.31658 10.7072 6.7071L9.41426 8.00001L10.7071 9.29289C11.0977 9.68341 11.0977 10.3166 10.7071 10.7071C10.3166 11.0976 9.68344 11.0976 9.29292 10.7071L8.00004 9.41422L6.70717 10.7071C6.31664 11.0976 5.68348 11.0976 5.29295 10.7071Z",
    fill: t
  })
}), IconCrossRoundedSolidS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM8.29299 8.2929C8.68352 7.90238 9.31668 7.90238 9.70721 8.2929L12 10.5857L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.2929C16.0976 8.68343 16.0976 9.31659 15.7071 9.70711L13.4142 11.9999L15.7072 14.2929C16.0977 14.6834 16.0977 15.3166 15.7072 15.7071C15.3167 16.0976 14.6835 16.0976 14.293 15.7071L12 13.4141L9.70711 15.707C9.31658 16.0975 8.68342 16.0975 8.2929 15.707C7.90237 15.3165 7.90238 14.6833 8.29291 14.2928L10.5858 11.9999L8.29299 9.70712C7.90247 9.31659 7.90247 8.68343 8.29299 8.2929Z",
    fill: t
  })
}), IconCrossRoundedSolidM = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L16 14.5858L19.2929 11.2929C19.6834 10.9024 20.3166 10.9024 20.7071 11.2929C21.0977 11.6834 21.0977 12.3166 20.7071 12.7071L17.4142 16L20.7071 19.2929C21.0977 19.6834 21.0977 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L16 17.4142L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071C10.9024 20.3166 10.9024 19.6834 11.2929 19.2929L14.5858 16L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929Z",
    fill: t
  })
}), IconCrossRoundedSolidL = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20ZM14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L20.0001 18.5858L24.293 14.2929C24.6835 13.9024 25.3166 13.9024 25.7072 14.2929C26.0977 14.6834 26.0977 15.3166 25.7072 15.7071L21.4143 20L25.7072 24.2929C26.0977 24.6834 26.0977 25.3166 25.7072 25.7071C25.3166 26.0976 24.6835 26.0976 24.2929 25.7071L20.0001 21.4142L15.7071 25.7071C15.3166 26.0976 14.6834 26.0976 14.2929 25.7071C13.9024 25.3166 13.9024 24.6834 14.2929 24.2929L18.5858 20L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
    fill: t
  })
}), IconInfoSolidMXs = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 7C8.55229 7 9 7.44772 9 8V12C9 12.5523 8.55229 13 8 13C7.44772 13 7 12.5523 7 12V8C7 7.44772 7.44772 7 8 7ZM8 3C8.55229 3 9 3.44772 9 4C9 4.55228 8.55229 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3Z",
    fill: t
  })
}), IconInfoSolidS = ({
  color: t
}) => /* @__PURE__ */ jsx$1("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6ZM13 10C13 9.44771 12.5523 9 12 9C11.4477 9 11 9.44771 11 10V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V10Z",
    fill: t
  })
}), IconUserDataS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "10",
    r: "3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21.6713 20.0362C22.0326 21.08 21.1046 22 20 22H12C10.8954 22 9.96737 21.08 10.3287 20.0362C11.1421 17.6869 13.3741 16 16 16C18.6259 16 20.8579 17.6869 21.6713 20.0362Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 2H13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 6H8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 14H6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2 10H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconUserDataM = ({
  color: t,
  width: r = 24,
  height: n = 24
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: r,
  height: n,
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: 15,
    cy: 9,
    r: 3,
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M20.671 19.036C21.033 20.08 20.105 21 19 21h-8c-1.105 0-2.033-.92-1.671-1.964a6.003 6.003 0 0 1 11.342 0Z"
  }), /* @__PURE__ */ jsx$1("path", {
    stroke: t,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 3h8M3 7h3M3 15h2M3 11h5"
  })]
}), IconUserDataL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9516_2251)",
    children: [/* @__PURE__ */ jsx$1("circle", {
      cx: "20",
      cy: "17",
      r: "5",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M4 4H17.5",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M36 16H32",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M4 9H11",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M36 21H30",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M29.8025 34.0128C30.0209 35.0955 29.105 36 28.0004 36C26.1759 36 23.2714 36 20 36C16.7286 36 13.824 36 11.9996 36C10.895 36 9.97914 35.0955 10.1975 34.0128C11.1191 29.4419 15.1576 26 20 26C24.8424 26 28.8809 29.4419 29.8025 34.0128Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9516_2251",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconShineL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9516_2510)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M31.7277 19.7277C25.2507 19.7277 20 14.477 20 8",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20.0001 31.7277C20.0001 25.2507 25.2508 20 31.7278 20",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8.00008 19.9998C14.4771 19.9998 19.7278 25.2505 19.7278 31.7275",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M19.7277 7.99983C19.7277 14.4769 14.477 19.7275 8 19.7275",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 30L35 35",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 10L5 5",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 10L35 5",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 30L5 35",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9516_2510",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), GoogleDark = () => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#0B0B0A"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.2356 9.68063C18.1576 9.68063 19.4541 10.4917 20.1933 11.1695L23.082 8.41397C21.3079 6.80285 18.9992 5.81396 16.2356 5.81396C12.2323 5.81396 8.77498 8.05841 7.0918 11.3251L10.4013 13.8362C11.2315 11.4251 13.5288 9.68063 16.2356 9.68063Z",
    fill: "#EA4335"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26.062 16.036C26.062 15.2138 25.9937 14.6138 25.8459 13.9916H16.2358V17.7027H21.8768C21.763 18.6249 21.1489 20.0138 19.7842 20.9471L23.0141 23.3916C24.9474 21.6471 26.062 19.0805 26.062 16.036Z",
    fill: "#4285F4"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10.4127 17.7919C10.1966 17.1696 10.0715 16.503 10.0715 15.8141C10.0715 15.1252 10.1966 14.4585 10.4013 13.8363L7.09179 11.3252C6.39805 12.6808 6 14.203 6 15.8141C6 17.4252 6.39805 18.9474 7.09179 20.303L10.4127 17.7919Z",
    fill: "#FBBC05"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.2354 25.8141C18.999 25.8141 21.3191 24.9252 23.0136 23.3919L19.7838 20.9474C18.9194 21.5363 17.7594 21.9474 16.2354 21.9474C13.5287 21.9474 11.2314 20.203 10.4125 17.7919L7.10303 20.303C8.78621 23.5696 12.2322 25.8141 16.2354 25.8141Z",
    fill: "#34A853"
  })]
}), GoogleLight = () => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "white"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.2356 9.68063C18.1576 9.68063 19.4541 10.4917 20.1933 11.1695L23.082 8.41397C21.3079 6.80285 18.9992 5.81396 16.2356 5.81396C12.2323 5.81396 8.77498 8.05841 7.0918 11.3251L10.4013 13.8362C11.2315 11.4251 13.5288 9.68063 16.2356 9.68063Z",
    fill: "#EA4335"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26.062 16.036C26.062 15.2138 25.9937 14.6138 25.8459 13.9916H16.2358V17.7027H21.8768C21.763 18.6249 21.1489 20.0138 19.7842 20.9471L23.0141 23.3916C24.9474 21.6471 26.062 19.0805 26.062 16.036Z",
    fill: "#4285F4"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10.4127 17.7919C10.1966 17.1696 10.0715 16.503 10.0715 15.8141C10.0715 15.1252 10.1966 14.4585 10.4013 13.8363L7.09179 11.3252C6.39805 12.6808 6 14.203 6 15.8141C6 17.4252 6.39805 18.9474 7.09179 20.303L10.4127 17.7919Z",
    fill: "#FBBC05"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16.2354 25.8141C18.999 25.8141 21.3191 24.9252 23.0136 23.3919L19.7838 20.9474C18.9194 21.5363 17.7594 21.9474 16.2354 21.9474C13.5287 21.9474 11.2314 20.203 10.4125 17.7919L7.10303 20.303C8.78621 23.5696 12.2322 25.8141 16.2354 25.8141Z",
    fill: "#34A853"
  })]
}), Facebook = () => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "white"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.16344 0 0 7.20173 0 16.0855C0 24.1696 5.93185 30.8609 13.6584 32V19.6032H11V15.2721H13.6584V12.6718C13.6584 9.13846 15.1595 7.03741 19.4243 7.03741H22.9749V11.369H20.7555C19.0953 11.369 18.9855 11.9743 18.9855 13.1039L18.9795 15.2717H23L22.5295 19.6028H18.9795V31.8926C26.3922 30.4891 32 23.9457 32 16.0855C32 7.20173 24.8366 0 16 0Z",
    fill: "#1877F2"
  })]
}), IconWriteDocS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M15.9375 5.8125V5C15.9375 3.89543 15.0421 3 13.9375 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H13.9375C15.0421 21 15.9375 20.1046 15.9375 19V18.1875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13 8H6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 12H6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 16H6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13.6875 15.9375L21 8.625",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconWriteDocM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M21.6875 8.0625V6C21.6875 4.89543 20.7921 4 19.6875 4H5C3.89543 4 3 4.89543 3 6V28C3 29.1046 3.89543 30 5 30H19.6875C20.7921 30 21.6875 29.1046 21.6875 28V25.9375",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 24.3125H8.6875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 9.6875H17.625",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 14.5625H15.1875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 19.4375H15.1875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18.4375 22.6875L29 12.125",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconWriteDocL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9753_2831)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M29 9V6C29 4.89543 28.1046 4 27 4H8C6.89543 4 6 4.89543 6 6V34C6 35.1046 6.89543 36 8 36H27C28.1046 36 29 35.1046 29 34V31",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 29H13",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 11H24",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 17H21",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 23H21",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M25 27L38 14",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9753_2831",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconCreateDocS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M15.9375 5.8125V5C15.9375 3.89543 15.0421 3 13.9375 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H13.9375C15.0421 21 15.9375 20.1046 15.9375 19V18.1875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M13 8H6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 12H6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 16H6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 12H21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18 15L18 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCreateDocM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M21.6875 7.0625V5C21.6875 3.89543 20.7921 3 19.6875 3H5C3.89543 3 3 3.89543 3 5V27C3 28.1046 3.89543 29 5 29H19.6875C20.7921 29 21.6875 28.1046 21.6875 27V24.9375",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 23.3125H8.6875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 8.6875H17.625",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 13.5625H15.1875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6.25 18.4375H15.1875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M22.25 15.6875H27.125",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24.6875 18.125L24.6875 13.25",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "24.6875",
    cy: "15.6875",
    r: "5.6875",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconCreateDocL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9549_440364)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M27 9V6C27 4.89543 26.1046 4 25 4H6C4.89543 4 4 4.89543 4 6V34C4 35.1046 4.89543 36 6 36H25C26.1046 36 27 35.1046 27 34V31",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8 29H11",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8 11H22",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8 17H19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8 23H19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M29 20H35",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M32 23L32 17",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("circle", {
      cx: "32",
      cy: "20",
      r: "7",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9549_440364",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconProtectedL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9516_2389)",
    children: [/* @__PURE__ */ jsx$1("circle", {
      cx: "20",
      cy: "20",
      r: "9",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.6912 18V18.8049",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M23.4756 18V18.8049",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M23.5906 21.9097C21.6535 23.8467 18.513 23.8467 16.5759 21.9097",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M32.0207 7.97918C38.6596 14.6181 38.6596 25.3819 32.0207 32.0208M7.97907 32.0208C1.34015 25.3819 1.34015 14.6181 7.97907 7.97918",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9516_2389",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconClockXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("rect", {
    x: "2",
    y: "3",
    width: "12",
    height: "12",
    rx: "6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M6 6L8 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M10 7L8 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 1L1 3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M15 3L13 1",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconClockL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9600_2533)",
    children: [/* @__PURE__ */ jsx$1("circle", {
      cx: "20",
      cy: "20",
      r: "12",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("rect", {
      x: "4",
      y: "4",
      width: "32",
      height: "32",
      rx: "4",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17 17L20 20",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M25 15L20 20",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9600_2533",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), IconShieldXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M2 3.5247C2 3.26235 2.25335 3.07389 2.5052 3.14735V3.14735C4.27972 3.66492 6.20154 3.09821 7.4045 1.69475V1.69475C7.71752 1.32956 8.28248 1.32956 8.5955 1.69475V1.69475C9.79846 3.09821 11.7203 3.66492 13.4948 3.14735V3.14735C13.7467 3.07389 14 3.26235 14 3.5247V7.7889C14 9.79502 12.9974 11.6684 11.3282 12.7812L9.1094 14.2604C8.4376 14.7083 7.5624 14.7083 6.8906 14.2604L4.6718 12.7812C3.00261 11.6684 2 9.79502 2 7.7889V3.5247Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 11L8 5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 8L5 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconShieldS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 4.22903C3 3.85929 3.36833 3.60263 3.7152 3.73067V3.73067C5.8442 4.51656 8.23049 4.11134 9.98073 2.6667L11.0644 1.77224C11.6076 1.32391 12.3924 1.32391 12.9356 1.77224L14.0193 2.6667C15.7695 4.11134 18.1558 4.51656 20.2848 3.73067V3.73067C20.6317 3.60263 21 3.85929 21 4.22903V6.87678C21 12.9947 18.0312 18.7323 13.0371 22.2661V22.2661C12.4156 22.7059 11.5844 22.7059 10.9629 22.2661V22.2661C5.96877 18.7323 3 12.9947 3 6.87678V4.22903Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 19L12 5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 12H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconShieldM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 6.16736C3 5.55628 3.54871 5.09145 4.15148 5.19191V5.19191C7.25593 5.70932 10.4388 4.9723 12.9998 3.14298L14.4373 2.11622C15.3721 1.4485 16.6279 1.4485 17.5627 2.11622L19.0002 3.14298C21.5612 4.9723 24.7441 5.70932 27.8485 5.19191V5.19191C28.4513 5.09145 29 5.55628 29 6.16736V11.0895C29 18.104 25.4978 24.6553 19.665 28.5517L17.111 30.2579C16.4384 30.7071 15.5616 30.7071 14.889 30.2579L12.335 28.5517C6.50223 24.6553 3 18.104 3 11.0895V6.16736Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 27L16 5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M25 16H7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), IconShieldL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9736_2707)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M4 5.9162C4 4.89871 4.89177 4.11147 5.9014 4.23768V4.23768C9.87799 4.73475 13.9127 4.04363 17.4972 2.2514L18.2734 1.86331C19.3603 1.31985 20.6397 1.31985 21.7266 1.86331L22.5028 2.2514C26.0873 4.04363 30.122 4.73475 34.0986 4.23768V4.23768C35.1082 4.11147 36 4.89871 36 5.9162V16.9534C36 23.8686 32.5955 30.3406 26.8971 34.2582L21.1331 38.221C20.4506 38.6902 19.5494 38.6902 18.8669 38.221L13.1029 34.2582C7.40446 30.3406 4 23.8686 4 16.9534V5.9162Z",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20 34L20 6",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M32 20H8",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9736_2707",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), WarningRoundedXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 5L8 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "11",
    r: "1",
    transform: "rotate(-180 8 11)",
    fill: t
  })]
}), WarningRoundedS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 7L12 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "17",
    r: "1",
    transform: "rotate(-180 12 17)",
    fill: t
  })]
}), WarningRoundedM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 10L16 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "22",
    r: "1",
    transform: "rotate(-180 16 22)",
    fill: t
  })]
}), WarningRoundedL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "20",
    r: "19",
    stroke: t,
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 13L20 22",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "27",
    r: "1",
    transform: "rotate(-180 20 27)",
    fill: t
  })]
}), BalanceXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M2 14L14 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 3.00001L13 3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 6L8 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 1L8 3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 4V6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 4V6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 9L5 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 10L4 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 9L13 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 10L12 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), BalanceS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 21L21 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 5H10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 5H21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 10L12 21",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 2L12 3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 4L5 9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M19 4V9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 9L3 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 9L7 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M3 13L7 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M19 9L17 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M19 9L21 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M17 13L21 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "5",
    r: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), BalanceM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M3 29H29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 5L14 5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18 5H27",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 7L16 29",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M16 1L16 3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 6V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24 6V11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 11L5 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 11L11 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 17L11 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 17C5 17 5 20 8 20C11 20 11 17 11 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24 11L21 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M24 11L27 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 17L27 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 17C21 17 21 20 24 20C27 20 27 17 27 17",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "5",
    r: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), BalanceL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_13547_7779)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M4 36H36",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M6 6L18 6",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M22 6H34",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20 8L20 36",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20 2L20 4",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 7V11",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 7V11",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 11L6 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10 11L14 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M6 19L14 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M6 19C6 19 6 23.5 10 23.5C14 23.5 14 19 14 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 11L26 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M30 11L34 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M26 19L34 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M26 19C26 19 26 23.5 30 23.5C34 23.5 34 19 34 19",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("circle", {
      cx: "20",
      cy: "6",
      r: "2",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_13547_7779",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), ExternalXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M13 3L8 8",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9 2L14 2L14 7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 11V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), ExternalS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M21 3L13 11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 3L21 3L21 10",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), ExternalM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M29 3L17 15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M29 19V26C29 27.6569 27.6569 29 26 29H6C4.34315 29 3 27.6569 3 26V6C3 4.34315 4.34315 3 6 3H13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M21 3L29 3L29 11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), ExternalL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_13395_7557)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M36 4L23 17",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M36 20V32C36 34.2091 34.2091 36 32 36H8C5.79086 36 4 34.2091 4 32V8C4 5.79086 5.79086 4 8 4H20",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M27 4L36 4L36 13",
      stroke: t,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_13395_7557",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), UserXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "5",
    r: "3",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14 14C14 14 12.5 11 8 11C3.5 11 2 14 2 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), UserS$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "7",
    r: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18.7179 19.0264C19.0288 20.0863 18.1046 21 17 21H7C5.89543 21 4.9712 20.0863 5.28208 19.0264C6.13414 16.1214 8.81933 14 12 14C15.1807 14 17.8659 16.1214 18.7179 19.0264Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), UserM$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "9",
    r: "6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26.8205 27.0101C27.019 28.0966 26.1046 29 25 29L7 29C5.89543 29 4.98099 28.0966 5.17953 27.0101C6.11601 21.8848 10.6043 18 16 18C21.3957 18 25.884 21.8848 26.8205 27.0101Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), UserL$1 = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "11",
    r: "7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M33.8591 34.0059C34.015 35.0994 33.1046 36 32 36H8C6.89543 36 5.98499 35.0994 6.14093 34.0059C7.10883 27.2185 12.945 22 20 22C27.055 22 32.8912 27.2185 33.8591 34.0059Z",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), UserCircleXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "6",
    r: "2",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 13C12 13 11 11 8 11C5 11 4 13 4 13",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), UserS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "9",
    r: "4",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5 20C6.61725 17.5668 9.15132 16 12 16C14.8487 16 17.3827 17.5668 19 20",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), UserM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "11",
    r: "6",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M5.38037 26.5C7.73472 23.1724 11.6137 21 16.0001 21C20.3864 21 24.2654 23.1724 26.6197 26.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), UserL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "14",
    r: "7",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "20",
    cy: "20",
    r: "19",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M33 34C30.4565 29.2274 25.588 26 20 26C14.412 26 9.54353 29.2274 7 34",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round"
  })]
}), LinkXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C12.2091 2 14 3.79086 14 6C14 7.07247 13.5779 8.04636 12.8908 8.76462C13.0381 9.58996 13.0365 10.4366 12.8861 11.2615C14.7421 10.2413 16 8.26754 16 6C16 2.68629 13.3137 0 10 0C6.68629 0 4 2.68629 4 6C4 8.76332 5.86804 11.0903 8.41019 11.7871C8.82986 11.2226 9.0256 10.5441 8.99743 9.87332C7.2735 9.42838 6 7.86291 6 6C6 3.79086 7.79086 2 10 2Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64878 4.22949C7.23352 4.79611 7.04213 5.47552 7.0746 6.14611C8.76185 6.61555 10 8.16324 10 10.0001C10 12.2093 8.20914 14.0001 6 14.0001C3.79086 14.0001 2 12.2093 2 10.0001C2 8.89656 2.44689 7.89738 3.16958 7.17368C3.03085 6.35365 3.03865 5.51367 3.19295 4.69588C1.29368 5.70308 0 7.70052 0 10.0001C0 13.3138 2.68629 16.0001 6 16.0001C9.31371 16.0001 12 13.3138 12 10.0001C12 7.25821 10.1608 4.94587 7.64878 4.22949Z",
    fill: t
  })]
}), LinkS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57939 7.76599C2.8723 9.04832 1 11.8055 1 14.9999C1 19.4182 4.58172 22.9999 9 22.9999C13.4183 22.9999 17 19.4182 17 14.9999C17 11.2242 14.3844 8.05945 10.8662 7.21875C10.6306 7.76499 10.5 8.3672 10.5 8.99991C10.5 9.06289 10.4977 9.12534 10.4931 9.18716C13.0844 9.85081 15 12.2017 15 14.9999C15 18.3136 12.3137 20.9999 9 20.9999C5.68629 20.9999 3 18.3136 3 14.9999C3 12.9043 4.07433 11.0597 5.70226 9.98663C5.57209 9.68391 5.49999 9.35033 5.49999 8.99991C5.49999 8.58174 5.52701 8.16989 5.57939 7.76599Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7576 4.75736C13.1007 2.41421 16.8997 2.41421 19.2429 4.75736C21.586 7.10051 21.586 10.8995 19.2429 13.2426C18.9905 13.4951 18.7211 13.7203 18.4385 13.9184C18.5262 14.688 18.52 15.4663 18.4198 16.2347C19.2292 15.8522 19.9877 15.3262 20.6571 14.6569C23.7813 11.5327 23.7813 6.46734 20.6571 3.34315C17.5329 0.218952 12.4676 0.218951 9.34339 3.34315C6.2192 6.46734 6.2192 11.5327 9.34339 14.6569C10.4273 15.7408 11.7449 16.4486 13.134 16.7804C13.4035 16.1542 13.5241 15.4792 13.4959 14.8093C12.4926 14.5505 11.5433 14.0283 10.7576 13.2426C8.41446 10.8995 8.41446 7.1005 10.7576 4.75736Z",
    fill: t
  })]
}), LinkM = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05915 10.8064C4.49578 12.3358 2 15.8764 2 19.9999C2 25.5228 6.47715 29.9999 12 29.9999C17.5228 29.9999 22 25.5228 22 19.9999C22 15.2535 18.6933 11.2795 14.2579 10.2559C14.0613 10.9051 13.9771 11.5811 14.0053 12.2533C17.4531 13.1432 20 16.2741 20 19.9999C20 24.4182 16.4183 27.9999 12 27.9999C7.58172 27.9999 4 24.4182 4 19.9999C4 17.0201 5.62911 14.4209 8.04524 13.0442C7.98059 12.2996 7.98523 11.5502 8.05915 10.8064Z",
    fill: t
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4C24.4183 4 28 7.58172 28 12C28 14.9797 26.3709 17.579 23.9548 18.9557C24.0195 19.7002 24.0148 20.4497 23.9409 21.1935C27.5043 19.664 30 16.1235 30 12C30 6.47715 25.5228 2 20 2C14.4772 2 10 6.47715 10 12C10 16.7464 13.3068 20.7205 17.7422 21.7441C17.9388 21.0948 18.023 20.4188 17.9947 19.7466C14.547 18.8567 12 15.7258 12 12C12 7.58172 15.5817 4 20 4Z",
    fill: t
  })]
}), LinkL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_9516_2484)",
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.40646 11.8505C3.98626 14.3346 1 19.0685 1 24.4999C1 32.508 7.49187 38.9999 15.5 38.9999C23.5081 38.9999 30 32.508 30 24.4999C30 16.5094 23.5367 10.0285 15.5529 10C15.1538 10.648 14.8317 11.33 14.5864 12.0328C14.8881 12.011 15.1928 11.9999 15.5 11.9999C22.4036 11.9999 28 17.5963 28 24.4999C28 31.4035 22.4036 36.9999 15.5 36.9999C8.59644 36.9999 3 31.4035 3 24.4999C3 20.3962 4.97754 16.7543 8.03165 14.4753C8.08617 13.5938 8.2111 12.7158 8.40646 11.8505Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9999 15.5C11.9999 8.59644 17.5963 3 24.4999 3C31.4035 3 36.9999 8.59644 36.9999 15.5C36.9999 19.6037 35.0224 23.2455 31.9684 25.5245C31.9139 26.406 31.7889 27.284 31.5936 28.1493C36.0137 25.6652 38.9999 20.9313 38.9999 15.5C38.9999 7.49187 32.508 1 24.4999 1C16.4918 1 9.9999 7.49187 9.9999 15.5C9.9999 23.4905 16.4633 29.9715 24.4471 29.9999C24.8462 29.3519 25.1684 28.6699 25.4136 27.9671C25.1119 27.9889 24.8072 28 24.4999 28C17.5963 28 11.9999 22.4036 11.9999 15.5Z",
      fill: t
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_9516_2484",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}), UnlinkXS = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_10049_12205)",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M5.86602 4.45146C6.25654 4.84198 6.88971 4.84198 7.28023 4.45146L8.05272 3.67897C9.22429 2.5074 11.1238 2.5074 12.2954 3.67897C13.4669 4.85055 13.4669 6.75004 12.2954 7.92161L11.5229 8.6941C11.1323 9.08462 11.1323 9.71779 11.5229 10.1083C11.9134 10.4988 12.5466 10.4988 12.9371 10.1083L13.7096 9.33583C15.6622 7.3832 15.6622 4.21738 13.7096 2.26476C11.7569 0.312138 8.59113 0.312137 6.6385 2.26476L5.86602 3.03724C5.47549 3.42777 5.4755 4.06093 5.86602 4.45146Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M4.45181 7.27988C4.84233 6.88936 4.84233 6.25619 4.45181 5.86567C4.06128 5.47515 3.42812 5.47515 3.03759 5.86567L2.39586 6.5074C0.443241 8.46002 0.443241 11.6258 2.39586 13.5785C4.34848 15.5311 7.51431 15.5311 9.46693 13.5785L10.1087 12.9367C10.4992 12.5462 10.4992 11.913 10.1087 11.5225C9.71814 11.132 9.08497 11.132 8.69445 11.5225L8.05272 12.1643C6.88114 13.3358 4.98165 13.3358 3.81008 12.1643C2.6385 10.9927 2.6385 9.09319 3.81008 7.92161L4.45181 7.27988Z",
      fill: t
    }), /* @__PURE__ */ jsx$1("rect", {
      x: "3",
      y: "1",
      width: "2",
      height: "2",
      rx: "1",
      fill: t
    }), /* @__PURE__ */ jsx$1("rect", {
      x: "1",
      y: "3",
      width: "2",
      height: "2",
      rx: "1",
      fill: t
    }), /* @__PURE__ */ jsx$1("rect", {
      x: "13",
      y: "11",
      width: "2",
      height: "2",
      rx: "1",
      fill: t
    }), /* @__PURE__ */ jsx$1("rect", {
      x: "11",
      y: "13",
      width: "2",
      height: "2",
      rx: "1",
      fill: t
    })]
  }), /* @__PURE__ */ jsx$1("defs", {
    children: /* @__PURE__ */ jsx$1("clipPath", {
      id: "clip0_10049_12205",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })
  })]
}), CarryMoneyL = ({
  color: t
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M14 16V16C16.7614 18.7614 16.7614 23.2386 14 26L13 27",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 24V24C18.1115 27.7771 18.1115 32.2229 20 36V36",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M26 24V24C26.6295 29.0361 29.5934 33.4819 34 36V36",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "9.5",
    cy: "9.5",
    r: "4.5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M35 12.5C35 16.6421 31.6421 20 27.5 20C23.3579 20 20 16.6421 20 12.5C20 8.35786 23.3579 5 27.5 5",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M20 20L26 14",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), IconsComponent = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddL: IconAddL,
  AddM: IconAddM,
  AddRoundedL: IconAddRoundedL,
  AddRoundedM: IconAddRoundedM,
  AddRoundedS: IconAddRoundedS,
  AddRoundedSolidL: IconAddRoundedSolidL,
  AddRoundedSolidM: IconAddRoundedSolidM,
  AddRoundedSolidS: IconAddRoundedSolidS,
  AddRoundedSolidXS: IconAddRoundedSolidMXs,
  AddRoundedXS: IconAddRoundedXS,
  AddS: IconAddS,
  AddSimpleL: IconAddSimpleL,
  AddSimpleM: IconAddSimpleM,
  AddSimpleS: IconAddSimpleS,
  AddSimpleXS: IconAddSimpleMXs,
  AddSolidL: IconAddSolidL,
  AddSolidM: IconAddSolidM,
  AddSolidS: IconAddSolidS,
  AddSolidXS: IconAddSolidMXs,
  AddXS: IconAddMXs,
  AeatL: IconAeatL$1,
  AeatM: IconAeatM$1,
  AeatS: IconAeatS$1,
  AeatXS: IconAeatMXs$1,
  BalanceL,
  BalanceM,
  BalanceS,
  BalanceXS,
  BellL: IconBellL,
  BellM: IconBellM,
  BellS: IconBellS,
  BellXS: IconBellMXs,
  BinL: IconBinL,
  BinM: IconBinM,
  BinS: IconBinS,
  BinXS: IconBinMXs,
  CardL: IconCardL,
  CardM: IconCardM,
  CardS: IconCardS,
  CardXS: IconCardMXs,
  CarryMoneyL,
  ChatS: IconChatS,
  ChatXS: IconChatMXs,
  CircleTickSolidL: IconCircleTickSolidL,
  CircleTickSolidM: IconCircleTickSolidM,
  CircleTickSolidS: IconCircleTickSolidS,
  CircleTickSolidXS: IconCircleTickSolidMXs,
  ClockL: IconClockL,
  ClockXS: IconClockXS,
  CopyL: IconCopyL,
  CopyM: IconCopyM,
  CopyS: IconCopyS,
  CopyXS: IconCopyMXs,
  CreateDocL: IconCreateDocL,
  CreateDocM: IconCreateDocM,
  CreateDocS: IconCreateDocS,
  CrossL: IconCrossL,
  CrossM: IconCrossM,
  CrossRoundedSolidL: IconCrossRoundedSolidL,
  CrossRoundedSolidM: IconCrossRoundedSolidM,
  CrossRoundedSolidS: IconCrossRoundedSolidS,
  CrossRoundedSolidXS: IconCrossRoundedSolidMXs,
  CrossS: IconCrossS,
  CrossXS: IconCrossMXs,
  CrossXXS: IconCrossMXxs,
  DotsL: IconDotsL,
  DotsM: IconDotsM,
  DotsS: IconDotsS,
  DotsXS: IconDotsXS,
  DownloadL: IconAeatL,
  DownloadM: IconAeatM,
  DownloadS: IconAeatS,
  DownloadXS: IconAeatMXs,
  EntityL: IconEntityL,
  EntityM: IconEntityM,
  EntityS: IconEntityS,
  EntityXS: IconEntityMXs,
  ExternalUpL: ExternalL,
  ExternalUpM: ExternalM,
  ExternalUpS: ExternalS,
  ExternalUpXS: ExternalXS,
  EyeClosedL,
  EyeClosedM,
  EyeClosedS,
  EyeClosedXS,
  EyeL: IconEyeL,
  EyeM: IconEyeM,
  EyeS: IconEyeS,
  EyeXS: IconEyeMXs,
  Facebook,
  FlyingMoneyL: IconFlyingMoneyL,
  FlyingMoneyM: IconFlyingMoneyM,
  FlyingMoneyS: IconFlyingMoneyS,
  FlyingMoneyXS: IconFlyingMoneyMXs,
  GoogleDark,
  GoogleLight,
  IconAddRoundedL,
  IconAddRoundedM,
  IconAddRoundedS,
  IconAddRoundedXS,
  IconAddS: IconAddS$1,
  IconAlertM,
  IconAlertS,
  IconAlertSThin,
  IconAppleDark,
  IconAppleLight,
  IconArrowBottomM,
  IconArrowBottomS,
  IconArrowBottomStoppedMSvg: IconArrowBottomStoppedMsvg,
  IconArrowDropBottomM,
  IconArrowDropLeftM,
  IconArrowDropRightM,
  IconArrowDropTopM,
  IconArrowLeftM,
  IconArrowLeftS,
  IconArrowLeftStoppedMSvg: IconArrowLeftStoppedMsvg,
  IconArrowRightM,
  IconArrowRightS,
  IconArrowRightStoppedMSvg: IconArrowRightStoppedMsvg,
  IconArrowRightXS,
  IconArrowTopM,
  IconArrowTopS,
  IconArrowTopStoppedM,
  IconBinS: IconBinS$1,
  IconBpm,
  IconBriefcaseM,
  IconBureaucracy,
  IconCalculatorM: CalculatorM,
  IconCalendarM: CalendarM,
  IconCallXS,
  IconCheckboxCheckedXS: CheckboxCheckedXS,
  IconCheckboxXS: CheckboxXS,
  IconClavemM,
  IconClockXS: ClockXS,
  IconCloud,
  IconCopiar,
  IconCoupleXS,
  IconCrossAccentM,
  IconCrossAccentS,
  IconCrossAccentXs,
  IconCrossDangerM,
  IconCrossDangerS,
  IconCrossDarkM,
  IconCrossDarkS,
  IconCrossLightM,
  IconCrossLightS,
  IconCrossS: CorssS,
  IconDangerAttentionSolidM,
  IconDangerAttentionSolidS,
  IconDangerCrossLineM,
  IconDangerCrossLineS,
  IconDangerCrossSolidM,
  IconDangerCrossSolidS,
  IconDashboard,
  IconDateCalendar,
  IconDotsMS,
  IconDoubtsM,
  IconDoubtsS,
  IconDoubtsSThin,
  IconEdit,
  IconEditSabina,
  IconEmailL,
  IconEmailM,
  IconEmailS,
  IconEmailXS,
  IconEntityM: EntityM,
  IconExpediente,
  IconFlowNavArrowLeft,
  IconFlowNavArrowRight,
  IconGraphsM,
  IconHelmetM,
  IconHelp,
  IconHelpXS: HelpXS,
  IconHiddenCoinM,
  IconHidePassword: HidePassword,
  IconHome,
  IconHomeMXs,
  IconHouseM,
  IconInfoLineMDark,
  IconInfoLineMLight,
  IconInfoLineSDark,
  IconInfoLineSLight,
  IconInfoSolidMDark,
  IconInfoSolidMLight,
  IconInfoSolidSDark,
  IconInfoSolidSLight,
  IconInfoSolidXSLight,
  IconLike,
  IconMgm,
  IconMobilePhoneXS,
  IconMoneyUpMXs,
  IconNotification,
  IconNumber1S,
  IconNumber2S,
  IconNumber3S,
  IconNumber4S,
  IconOutputM,
  IconPadLock: PadLock,
  IconPdfS: IconPdfS$1,
  IconPdfXS: PdfXS,
  IconPercentageM,
  IconPicture,
  IconPieChart,
  IconPlans,
  IconProfile,
  IconReset,
  IconReviewtool,
  IconRevisión: IconRevisin,
  IconSearch,
  IconSheetM: IconSheetM$1,
  IconShowPassword: ShowPassword,
  IconTechnicalSupportXS,
  IconTickCleanMDark,
  IconTickCleanMGreen,
  IconTickCleanSDark,
  IconTickCleanSGreen,
  IconTickLineMDark,
  IconTickLineSGreen,
  IconTickSolidMDark,
  IconTickSolidMDisabledDark,
  IconTickSolidMGreen,
  IconTickSolidSDark,
  IconTickSolidSDisabledGreen,
  IconTickSolidSGreen,
  IconTiming,
  IconTrash,
  IconUpload,
  IconUploadDrop,
  IconUserSpaceM: IconUserSpaceM$1,
  IconUserSpaceXS,
  IconUtilities,
  IconVerifiedDocumentM,
  IconVerifiedDocumentS,
  IconWarningAttentionSolidM,
  IconWarningAttentionSolidS,
  IconWarningBoxM: WarningBoxM,
  IconWhatsappXS,
  IconWheelchair,
  IconYear,
  InfoL: IconInfoL,
  InfoM: IconInfoM,
  InfoS: IconInfoS,
  InfoSolidS: IconInfoSolidS,
  InfoSolidXS: IconInfoSolidMXs,
  InfoXS: IconInfoMXs,
  LinkL,
  LinkM,
  LinkS,
  LinkXS,
  LockL: IconLockL,
  LockM: IconLockM,
  LockS: IconLockS,
  LockXS: IconLockMXs,
  MailL: IconMailL,
  MailM: IconMailM,
  MailS: IconMailS,
  MailXS: IconMailMXs,
  MoneyL: IconMoneyL,
  MoneyM: IconMoneyM,
  MoneyS: IconMoneyS,
  MoneyXS: IconMoneyXS,
  PdfL: IconPdfL,
  PdfM: IconPdfM,
  PdfS: IconPdfS,
  PdfXS: IconPdfMXs,
  ProtectedL: IconProtectedL,
  QuestionL: IconQuestionL,
  QuestionM: IconQuestionM,
  QuestionS: IconQuestionS,
  QuestionXS: IconQuestionMXs,
  RefreshL: IconRefreshL,
  RefreshM: IconRefreshM,
  RefreshS: IconRefreshS,
  RefreshXS: IconRefreshMXs,
  SettingsL: IconZoomL$1,
  SettingsM: IconZoomM$1,
  SettingsS: IconZoomS$1,
  SettingsXS: IconZoomMXs$1,
  ShareL: IconShareL,
  ShareM: IconShareM,
  ShareS: IconShareS,
  ShareXS: IconShareMXs,
  SheetL: IconSheetL,
  SheetM: IconSheetM,
  SheetS: IconSheetS,
  SheetXS: IconSheetMXs,
  ShieldL: IconShieldL,
  ShieldM: IconShieldM,
  ShieldS: IconShieldS,
  ShieldXS: IconShieldXS,
  ShineL: IconShineL,
  StarL: IconStarL,
  StarM: IconStarM,
  StarS: IconStarS,
  StarXS: IconStarMXs,
  TickL: IconZoomL$2,
  TickM: IconZoomL$3,
  TickS: IconZoomL$4,
  TickXS: IconZoomL$5,
  UnlinkXS,
  UserCircleL: UserL,
  UserCircleM: UserM,
  UserCircleS: UserS,
  UserCircleXS,
  UserDataL: IconUserDataL,
  UserDataM: IconUserDataM,
  UserDataS: IconUserDataS,
  UserL: UserL$1,
  UserM: UserM$1,
  UserS: UserS$1,
  UserSpaceL: IconUserSpaceL,
  UserSpaceM: IconUserSpaceM,
  UserSpaceS: IconUserSpaceS,
  UserSpaceXS: IconUserSpaceMXs,
  UserXS,
  WarningRoundedL,
  WarningRoundedM,
  WarningRoundedS,
  WarningRoundedSolidL: IconWarningRoundedSolidL,
  WarningRoundedSolidM: IconWarningRoundedSolidM,
  WarningRoundedSolidS: IconWarningRoundedSolidS,
  WarningRoundedSolidXS: IconWarningRoundedSolidMXs,
  WarningRoundedXS,
  WriteDocL: IconWriteDocL,
  WriteDocM: IconWriteDocM,
  WriteDocS: IconWriteDocS,
  ZoomL: IconZoomL,
  ZoomM: IconZoomM,
  ZoomS: IconZoomS,
  ZoomXS: IconZoomMXs
}, Symbol.toStringTag, { value: "Module" })), Icon$4 = ({
  icon: t,
  color: r = void 0,
  width: n,
  height: a
}) => {
  const s = IconsComponent[t];
  return /* @__PURE__ */ jsx$1(s, {
    color: r && IconColor[r],
    width: n,
    height: a
  });
};
var Events = /* @__PURE__ */ ((t) => (t.BUTTON_PRESSED = "buttonPressed", t.HELP_BUTTON_PRESSED = "helpButtonPressed", t.SEND_FILES = "sendFiles", t))(Events || {}), MandatoryLabels = /* @__PURE__ */ ((t) => (t.IS_MANDATORY = "OBLIGATORIO", t.OPTIONAL = "OPCIONAL", t))(MandatoryLabels || {}), Direction = /* @__PURE__ */ ((t) => (t.PREV = "prev", t.NEXT = "next", t))(Direction || {}), Sizes$1 = /* @__PURE__ */ ((t) => (t.XS = "XS", t.S = "S", t.M = "M", t.L = "L", t.XL = "XL", t))(Sizes$1 || {}), Gap = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t))(Gap || {}), LayoutDirection = /* @__PURE__ */ ((t) => (t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t))(LayoutDirection || {});
const sendButtonEvent = (t, r) => {
  const n = new CustomEvent(Events.BUTTON_PRESSED, {
    detail: { label: t.currentTarget.innerText, id: r }
  });
  dispatchEvent(n);
};
var ButtonMode = /* @__PURE__ */ ((t) => (t.primary = "primary", t.secondary = "secondary", t.cold = "cold", t.light = "light", t.skeleton = "skeleton", t.success = "success", t.success_light = "success_light", t.error = "error", t.error_light = "error_light", t.warning = "warning", t.warning_light = "warning_light", t.basic = "basic", t.basic_light = "basic_light", t.pro = "pro", t.pro_light = "pro_light", t.live = "live", t.live_light = "live_light", t.expert = "expert", t.expert_light = "expert_light", t.full = "full", t.full_light = "full_light", t.empty = "empty", t))(ButtonMode || {}), ButtonModeXXS = /* @__PURE__ */ ((t) => (t.default = "default", t.dark = "dark", t.light = "light", t.success = "success", t.danger = "danger", t.warning = "warning", t.skeleton = "skeleton", t))(ButtonModeXXS || {}), ButtonSize = /* @__PURE__ */ ((t) => (t.xxs = "xxs", t.xs = "xs", t.s = "s", t.m = "m", t.l = "l", t.xl = "xl", t))(ButtonSize || {});
const types$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ButtonMode,
  ButtonModeXXS,
  ButtonSize
}, Symbol.toStringTag, { value: "Module" })), arrow$2 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03IDExLjVMMiA2LjVMNyAxLjUiIHN0cm9rZT0iIzNEM0E2MiIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", danger500 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNGQjZCNjIiLz4KPHBhdGggZD0iTTExIDEwLjk5OTlMNSA1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTExIDQuOTk5ODhMNSAxMC45OTk4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==", darkCross = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDEzLjk5OTdMMi4wMDAwNCAyLjAwMDIxIiBzdHJva2U9IiMzRDNBNjIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy45OTk4IDIuMDAwMDNMMi4wMDAyMSAxNCIgc3Ryb2tlPSIjM0QzQTYyIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K", dark = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNiAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjEwIiByPSI3IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTggOS4wMDAxMkw4IDE0LjAwMDEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNOCA2LjAwMDEyTDggOC4wMDAxMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", lightApple = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTYuNUMwIDcuNjYzNDQgNy4xNjM0NCAwLjUgMTYgMC41QzI0LjgzNjYgMC41IDMyIDcuNjYzNDQgMzIgMTYuNUMzMiAyNS4zMzY2IDI0LjgzNjYgMzIuNSAxNiAzMi41QzcuMTYzNDQgMzIuNSAwIDI1LjMzNjYgMCAxNi41WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS41MTEzIDYuODk5OUMxOS42Nzg4IDguMDM3NjUgMTkuMjE1NyA5LjE1MjI3IDE4LjYwNDggOS45NDA4OEMxNy45NTEyIDEwLjc4NjggMTYuODI0NiAxMS40NDEgMTUuNzMzMSAxMS40MDY4QzE1LjUzMzggMTAuMzE3NiAxNi4wNDQgOS4xOTUyMyAxNi42NjQ4IDguNDQwNzdDMTcuMzQ1NyA3LjYwODEgMTguNTEyOCA2Ljk2OTI5IDE5LjUxMTMgNi44OTk5Wk0yMi43OTAyIDIyLjkxNDNDMjMuMzUzIDIyLjA1MTkgMjMuNTYzMiAyMS42MTY5IDI0IDIwLjY0MzJDMjAuODIyOSAxOS40MzUgMjAuMzEzOCAxNC45MTgxIDIzLjQ1ODEgMTMuMTg0NUMyMi40OTkgMTEuOTgxOCAyMS4xNTEzIDExLjI4NDYgMTkuODc5MSAxMS4yODQ2QzE4Ljk2MjUgMTEuMjg0NiAxOC4zMzQ0IDExLjUyMzggMTcuNzYzNSAxMS43NDEzQzE3LjI4NzcgMTEuOTIyNSAxNi44NTE1IDEyLjA4ODYgMTYuMzIxIDEyLjA4ODZDMTUuNzQ3NyAxMi4wODg2IDE1LjI0MDEgMTEuOTA2NiAxNC43MDg1IDExLjcxNkMxNC4xMjQ0IDExLjUwNjYgMTMuNTExNCAxMS4yODY4IDEyLjc1MDggMTEuMjg2OEMxMS4zMjMyIDExLjI4NjggOS44MDM1OSAxMi4xNTkxIDguODQwMTYgMTMuNjUwNEM3LjQ4NTg4IDE1Ljc1MDggNy43MTY4OSAxOS42OTkzIDkuOTEzMDggMjMuMDYzQzEwLjY5ODEgMjQuMjY2OCAxMS43NDY5IDI1LjYxOTQgMTMuMTE4NyAyNS42MzE1QzEzLjY4NzkgMjUuNjM3MSAxNC4wNjY3IDI1LjQ2NzIgMTQuNDc2NiAyNS4yODM0QzE0Ljk0NTcgMjUuMDczIDE1LjQ1NTYgMjQuODQ0MyAxNi4zMzg1IDI0LjgzOTZDMTcuMjI2NiAyNC44MzQyIDE3LjcyODUgMjUuMDY1NyAxOC4xOTE0IDI1LjI3OTNDMTguNTkwOCAyNS40NjM1IDE4Ljk2MTIgMjUuNjM0MyAxOS41MjU1IDI1LjYyODJDMjAuODk4NCAyNS42MTcyIDIyLjAwNTMgMjQuMTE4MSAyMi43OTAyIDIyLjkxNDNaIiBmaWxsPSIjMEIwQjBBIi8+Cjwvc3ZnPgo=", lightCross = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNiAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDEzLjk5OTdMMi4wMDAwNCAyLjAwMDIxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuOTk5OCAyLjAwMDAxTDIuMDAwMjEgMTMuOTk5OSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==", lightInfo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNiAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjEwIiByPSI4IiBmaWxsPSIjM0QzQTYyIi8+CjxwYXRoIGQ9Ik04IDguOTk5ODhMOCAxMy45OTk5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTggNS45OTk4OEw4IDcuOTk5ODgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", lightGoogle = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAxNi41QzAuNSA3LjY2MzQ0IDcuNjYzNDQgMC41IDE2LjUgMC41QzI1LjMzNjYgMC41IDMyLjUgNy42NjM0NCAzMi41IDE2LjVDMzIuNSAyNS4zMzY2IDI1LjMzNjYgMzIuNSAxNi41IDMyLjVDNy42NjM0NCAzMi41IDAuNSAyNS4zMzY2IDAuNSAxNi41WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE2LjM3NjcgMTAuMTgwNkMxOC4yNTQ1IDEwLjE4MDYgMTkuNTIxMSAxMC45OTE3IDIwLjI0MzQgMTEuNjY5NUwyMy4wNjU2IDguOTEzOTdDMjEuMzMyMiA3LjMwMjg1IDE5LjA3NjcgNi4zMTM5NiAxNi4zNzY3IDYuMzEzOTZDMTIuNDY1NiA2LjMxMzk2IDkuMDg3OCA4LjU1ODQxIDcuNDQzMzYgMTEuODI1MUwxMC42NzY3IDE0LjMzNjJDMTEuNDg3OCAxMS45MjUxIDEzLjczMjIgMTAuMTgwNiAxNi4zNzY3IDEwLjE4MDZaIiBmaWxsPSIjRUE0MzM1Ii8+CjxwYXRoIGQ9Ik0yNS45NzcgMTYuNTM2MUMyNS45NzcgMTUuNzEzOSAyNS45MTAzIDE1LjExMzkgMjUuNzY1OCAxNC40OTE3SDE2LjM3N1YxOC4yMDI4SDIxLjg4ODFDMjEuNzc3IDE5LjEyNSAyMS4xNzcgMjAuNTEzOSAxOS44NDM2IDIxLjQ0NzNMMjIuOTk5MiAyMy44OTE3QzI0Ljg4ODEgMjIuMTQ3MyAyNS45NzcgMTkuNTgwNiAyNS45NzcgMTYuNTM2MVoiIGZpbGw9IiM0Mjg1RjQiLz4KPHBhdGggZD0iTTEwLjY4ODEgMTguMjkxOUMxMC40NzcgMTcuNjY5NiAxMC4zNTQ3IDE3LjAwMyAxMC4zNTQ3IDE2LjMxNDFDMTAuMzU0NyAxNS42MjUyIDEwLjQ3NyAxNC45NTg1IDEwLjY3NyAxNC4zMzYzTDcuNDQzNjIgMTEuODI1MkM2Ljc2NTg0IDEzLjE4MDggNi4zNzY5NSAxNC43MDMgNi4zNzY5NSAxNi4zMTQxQzYuMzc2OTUgMTcuOTI1MiA2Ljc2NTg0IDE5LjQ0NzQgNy40NDM2MiAyMC44MDNMMTAuNjg4MSAxOC4yOTE5WiIgZmlsbD0iI0ZCQkMwNSIvPgo8cGF0aCBkPSJNMTYuMzc3MyAyNi4zMTRDMTkuMDc3MyAyNi4zMTQgMjEuMzQ0IDI1LjQyNTEgMjIuOTk5NSAyMy44OTE3TDE5Ljg0NCAyMS40NDczQzE4Ljk5OTUgMjIuMDM2MiAxNy44NjYyIDIyLjQ0NzMgMTYuMzc3MyAyMi40NDczQzEzLjczMjkgMjIuNDQ3MyAxMS40ODg0IDIwLjcwMjkgMTAuNjg4NCAxOC4yOTE3TDcuNDU1MDggMjAuODAyOUM5LjA5OTUyIDI0LjA2OTUgMTIuNDY2MiAyNi4zMTQgMTYuMzc3MyAyNi4zMTRaIiBmaWxsPSIjMzRBODUzIi8+Cjwvc3ZnPgo=", mail = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDMyLjVDMjQuODM2NiAzMi41IDMyIDI1LjMzNjYgMzIgMTYuNUMzMiA3LjY2MzQ0IDI0LjgzNjYgMC41IDE2IDAuNUM3LjE2MzQ0IDAuNSAwIDcuNjYzNDQgMCAxNi41QzAgMjUuMzM2NiA3LjE2MzQ0IDMyLjUgMTYgMzIuNVoiIGZpbGw9IiMwRkI5OTAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUzMzIgMTEuOTUwMkM4LjUzMzIgMTEuOTUwMiAxNC45NzI5IDE1LjYwMiAxNi4yMjI4IDE1LjYwMkMxNy41MzI5IDE1LjYwMiAyMy45MDI4IDEyLjAyIDIzLjkwMjggMTIuMDJMMjMuOTEzIDExLjM4QzIzLjkxMyAxMC42NzM0IDIzLjMzOTYgMTAuMSAyMi42MzExIDEwLjFIOS44MTQ0OEM5LjEwNjY0IDEwLjEgOC41MzMyIDEwLjY3MzQgOC41MzMyIDExLjM4VjExLjk1MDJaTTIzLjkwMjggMTMuOTRDMjMuOTAyOCAxMy45NCAxNy41OTMgMTcuMzYyIDE2LjIyMjggMTcuMzYyQzE0Ljk3MjkgMTcuMzYyIDguNTQyOCAxMy45NCA4LjU0MzQ0IDEzLjk0TDguNTMzMiAyMS42MkM4LjUzMzIgMjIuMzI2NSA5LjEwNzI4IDIyLjkgOS44MTQ0OCAyMi45SDIyLjYzMTFDMjMuMzM5NiAyMi45IDIzLjkxMyAyMi4zMjY1IDIzLjkxMyAyMS42MkwyMy45MDI4IDEzLjk0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==", success = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiMyNUMwNzYiLz4KPHBhdGggZD0iTTQgN0w3IDEwTDEyIDUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", warning$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNFMUE2MTMiLz4KPHBhdGggZD0iTTggOFY0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTggMTJWMTAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K", tick = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDExIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjE5OTIyIDMuOTk5OTlMNC4wNjczNSA2LjcxNDI4TDkuODAzNjEgMS4yODU3MSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=", Icon$3 = {
  arrow: arrow$2,
  danger: danger500,
  danger_500: danger500,
  dark_cross: darkCross,
  dark,
  light: lightInfo,
  legacy_300: lightInfo,
  light_apple: lightApple,
  light_cross: lightCross,
  light_google: lightGoogle,
  mail,
  success,
  warning: warning$1,
  tick
}, MarginsStyles = css$3`
  margin-top: ${({ mt: t, theme: { reference: r } }) => t && (sizing[t] ?? r[t])};
  margin-bottom: ${({ mb: t, theme: { reference: r } }) => t && (sizing[t] ?? r[t])};
  margin-left: ${({ ml: t, theme: { reference: r } }) => t && (sizing[t] ?? r[t])};
  margin-right: ${({ mr: t, theme: { reference: r } }) => t && (sizing[t] ?? r[t])};
`, inputBaseStyles = css$3`
  display: flex;
  width: 100%;
  border: 0;
  outline: none;
  ${({ theme: { components: t } }) => t.inputs.fds_c_input_content};
  color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary};
  border: 1px solid ${({ theme: { components: t } }) => t.inputs.fds_c_input_bordercolor};
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
  padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
  gap: ${({ theme: { components: t } }) => t.inputs.fds_c_input_default_gap};
  background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_primary};
  transition: box-shadow ${({ theme: { system: t } }) => t.easings.fds_sys_ease_elastic_out_M}
      0.25s,
    background-color ${({ theme: { system: t } }) => t.easings.fds_sys_ease_elastic_out_M} 0.25s,
    border-color ${({ theme: { system: t } }) => t.easings.fds_sys_ease_elastic_out_M} 0.25s;
`, InputOptionStyles = css$3`
  ${({ $withInput: t }) => t ? css$3`
          cursor: pointer;
          position: relative;
          margin: 0;
          appearance: none;
          background: transparent;
          outline: none;
          width: ${({ theme: { system: r } }) => r.fds_sys_sizing_XS};
          height: ${({ theme: { system: r } }) => r.fds_sys_sizing_XS};
          background-color: transparent;
          border: ${({ theme: { components: r } }) => `${r.inputs.fds_c_input_optionals_borderwidth} solid ${r.inputs.fds_c_input_bordercolor_strong}`};
          :checked {
            background-color: ${({ theme: { components: r } }) => r.inputs.fds_c_input_optional_selected};
            border-color: ${({ theme: { components: r } }) => r.inputs.fds_c_input_bordercolor_option_selected};
            ::after {
              content: '';
              display: inline-block;
              width: 100%;
              height: 100%;
              background-image: url(${`${Icon$3.tick}`});
              background-repeat: no-repeat;
              background-position: center;
            }
          }
        ` : css$3`
          display: none;
        `}
  &:disabled {
    cursor: ${({ $readOnly: t }) => t ? "default" : "pointer"};
    opacity: 0.38;
  }
`, TextInputStyles = css$3`
  ${inputBaseStyles};
  ${({ readOnly: t }) => t && css$3`
      color: ${({ theme: { system: r } }) => r.text.fds_sys_color_text_placeholder};
      background: ${({ theme: { colors: r } }) => r.moon_100};
      cursor: default;
    `};
  ${({ $hasError: t, theme: { system: r } }) => t && css$3`
      background-color: ${r.background.fds_sys_color_background_error};
      border: 1px solid ${r.border.fds_sys_color_border_error};
      color: ${r.text.fds_sys_color_text_danger_stronger};
    `};
  ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
      background-color: ${r.background.fds_sys_color_background_warning};
      border: 1px solid ${r.border.fds_sys_color_border_warning};
      color: ${r.text.fds_sys_color_text_warning_stronger};
    `};
  ::placeholder {
    ${({ theme: { components: t } }) => t.inputs.fds_c_input_content};
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_placeholder};
    ${({ $hasError: t, theme: { system: r } }) => t && css$3`
        color: ${r.text.fds_sys_color_text_danger_stronger};
        opacity: ${r.fds_sys_disabled_opacity_S};
      `}
    ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
        color: ${r.text.fds_sys_color_text_warning_stronger};
        opacity: ${r.fds_sys_disabled_opacity_S};
      `}
  }
  &:disabled {
    border: 1px solid ${({ theme: { components: t } }) => t.inputs.fds_c_input_bordercolor};
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_placeholder};
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_primary};
    cursor: not-allowed;
    opacity: 0.38;
  }
  &:focus {
    box-shadow: ${({ theme: { system: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.fds_sys_embed_M;
  return `inset ${r} ${n} ${a} ${s} ${o}`;
}};
    border-color: ${({ theme: { system: t } }) => t.global.fds_sys_color_transparent};
    ${({ $hasWarning: t, theme: { system: r, components: n } }) => t && css$3`
        box-shadow: ${() => {
  const { x: a, y: s, blur: o, spread: c, color: l } = n.inputs.fds_c_input_focus_warning;
  return `inset ${a} ${s} ${o} ${c} ${l}`;
}};
        border-color: ${r.border.fds_sys_color_border_warning};
      `};
    ${({ readOnly: t }) => t && css$3`
        box-shadow: none;
      `};
    ${({ $hasError: t, theme: { system: r, components: n } }) => t && css$3`
        box-shadow: ${() => {
  const { x: a, y: s, blur: o, spread: c, color: l } = n.inputs.fds_c_input_focus_error;
  return `inset ${a} ${s} ${o} ${c} ${l}`;
}};
        border-color: ${r.border.fds_sys_color_border_error};
      `};
    ${({ $hasError: t, $hasWarning: r, readOnly: n, theme: { components: a } }) => !t && !r && !n && css$3`
        background: ${a.inputs.fds_c_input_color_background_focus};
      `};
  }
`, ButtonLabel = styled.span`
  color: ${({ theme: { colors: t } }) => t.white};
`, ButtonStyleStyles$1 = {
  [ButtonMode.primary]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark};
    & > svg {
      stroke: ${({ theme: { colors: t } }) => `${t.white}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
    }
  `,
  [ButtonMode.secondary]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_secondary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_secondary_hover};
    }
  `,
  [ButtonMode.cold]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold};
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold_hover};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
  `,
  [ButtonMode.light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_light};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_light_hover};
    }
  `,
  [ButtonMode.success_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_secondary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_tertiary};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_success_tertiary}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_secondary_hover};
    }
  `,
  [ButtonMode.success]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_primary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_primary_hover};
    }
  `,
  [ButtonMode.error_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_secondary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_tertiary};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_danger_tertiary}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_secondary_hover};
    }
  `,
  [ButtonMode.error]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_primary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_primary_hover};
    }
  `,
  [ButtonMode.warning_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_secondary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_tertiary};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_warning_tertiary}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_secondary_hover};
    }
  `,
  [ButtonMode.warning]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_primary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_primary_hover};
    }
  `,
  [ButtonMode.skeleton]: css$3`
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_skeleton};
    ${ButtonLabel} {
      color: ${({ theme: { system: t } }) => t.background.fds_sys_color_skeleton};
    }
    & > svg {
      stroke: ${({ theme: { system: t } }) => `${t.background.fds_sys_color_skeleton}`};
    }
  `,
  [ButtonMode.basic]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_basic_dark};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_basic_dark_hover};
    }
  `,
  [ButtonMode.basic_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_basic_light};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_basic_light_hover};
    }
  `,
  [ButtonMode.pro]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_pro_dark};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_pro_dark_hover};
    }
  `,
  [ButtonMode.pro_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_pro_light};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_pro_light_hover};
    }
  `,
  [ButtonMode.live]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_live_dark};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_live_dark_hover};
    }
  `,
  [ButtonMode.live_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_live_light};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_live_light_hover};
    }
  `,
  [ButtonMode.expert]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_expert_dark};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_expert_dark_hover};
    }
  `,
  [ButtonMode.expert_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_expert_light};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_expert_light_hover};
    }
  `,
  [ButtonMode.full]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_full_dark};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_full_dark_hover};
    }
  `,
  [ButtonMode.full_light]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_full_light};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_plan_full_light_hover};
    }
  `,
  [ButtonMode.empty]: css$3`
    background-color: transparent;
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
  `
}, buttonSizeStyles = {
  [ButtonSize.xxs]: () => css$3`
    gap: ${({ theme: { components: t } }) => t.buttons.fds_c_button_gap_XXS};
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_XXS}`};
    ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_S};
    background-color: transparent;
  `,
  [ButtonSize.xs]: () => css$3`
    gap: ${({ theme: { components: t } }) => t.buttons.fds_c_button_gap_XS};
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_XS}`};
    height: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_XS};
    ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_XS};
  `,
  [ButtonSize.s]: (t, r) => css$3`
    gap: ${({ theme: { components: n } }) => n.buttons.fds_c_button_gap_S};
    padding: ${({ theme: { components: n } }) => `0 ${n.buttons.fds_c_button_padding_horizontal_S}`};
    ${!t && css$3`
      padding-left: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    ${!r && css$3`
      padding-right: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    height: ${({ theme: { components: n } }) => n.buttons.fds_c_classic_height_S};
    ${({ theme: { components: n } }) => n.buttons.fds_c_button_text_S};
  `,
  [ButtonSize.m]: (t, r) => css$3`
    gap: ${({ theme: { components: n } }) => n.buttons.fds_button_c_gap_M};
    padding: ${({ theme: { components: n } }) => `0 ${n.buttons.fds_c_button_padding_horizontal_M}`};
    ${!t && css$3`
      padding-left: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    ${!r && css$3`
      padding-right: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    height: ${({ theme: { components: n } }) => n.buttons.fds_c_classic_height_M};
    ${({ theme: { components: n } }) => n.buttons.fds_c_button_text_M};
  `,
  [ButtonSize.l]: (t, r) => css$3`
    gap: ${({ theme: { components: n } }) => n.buttons.fds_c_button_gap_L};
    padding: ${({ theme: { components: n } }) => `0 ${n.buttons.fds_c_button_padding_horizontal_L}`};
    ${!t && css$3`
      padding-left: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    ${!r && css$3`
      padding-right: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    height: ${({ theme: { components: n } }) => n.buttons.fds_c_classic_height_L};
    ${({ theme: { components: n } }) => n.buttons.fds_c_button_text_L};
  `,
  [ButtonSize.xl]: (t, r) => css$3`
    gap: ${({ theme: { components: n } }) => n.buttons.fds_c_button_gap_XL};
    padding: ${({ theme: { components: n } }) => `0 ${n.buttons.fds_c_button_padding_horizontal_XL}`};
    ${!t && css$3`
      padding-left: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    ${!r && css$3`
      padding-right: ${({ theme: { reference: n } }) => n.dimension_16};
    `}
    height: ${({ theme: { components: n } }) => n.buttons.fds_c_classic_height_XL};
    ${({ theme: { components: n } }) => n.buttons.fds_c_button_text_L};
  `
}, Button$5 = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${MarginsStyles}

  border: none;
  border-radius: ${({ theme: { components: t } }) => t.buttons.fds_c_button_classic_radius};

  transition: background-color 0.15s
    ${({ theme: { system: t } }) => t.easings.fds_sys_ease_soft_out};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  ${({ $mode: t }) => ButtonStyleStyles$1[t]}
  ${({ $iconStart: t, $iconEnd: r, $size: n }) => buttonSizeStyles[n](t, r)}

  ${({ fullWidth: t }) => t && css$3`
      width: 100%;
    `}
`, isLittleSize = (t) => t !== ButtonSize.xs && t !== ButtonSize.xxs, Button$4 = ({
  id: t,
  label: r,
  mode: n = ButtonMode.primary,
  size: a = ButtonSize.s,
  iconEnd: s,
  iconStart: o,
  disabled: c,
  fullWidth: l,
  onClick: d,
  ...h
}) => /* @__PURE__ */ jsxs(Button$5, {
  id: t,
  type: "button",
  role: "button",
  $mode: n,
  $size: a,
  $iconStart: !!o,
  $iconEnd: !!s,
  disabled: c,
  fullWidth: l,
  onClick: (p) => {
    t && sendButtonEvent(p, t), d == null || d(p);
  },
  ...h,
  children: [o && /* @__PURE__ */ jsx$1(Icon$4, {
    icon: o
  }), /* @__PURE__ */ jsx$1(ButtonLabel, {
    children: r
  }), s && /* @__PURE__ */ jsx$1(Icon$4, {
    icon: s
  })]
}), ButtonBaseStyled$2 = styled(Button$4)`
  ${({ size: t }) => isLittleSize(t) && "min-width: 100px;"};
`, Classic$1 = ({
  label: t,
  mode: r,
  size: n,
  iconEnd: a,
  iconStart: s,
  disabled: o,
  ...c
}) => /* @__PURE__ */ jsx$1(ButtonBaseStyled$2, {
  label: t,
  mode: r,
  size: n,
  iconStart: s,
  iconEnd: a,
  disabled: o,
  ...c
}), ButtonIconSize = {
  [ButtonSize.xxs]: css$3`
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_XXS}`};
    background-color: transparent;
  `,
  [ButtonSize.xs]: css$3`
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_XS}`};
    height: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_XS};
    width: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_XS};
  `,
  [ButtonSize.s]: css$3`
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_S}`};
    height: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_S};
    width: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_S};

    & > svg {
      width: fit-content;
    }
  `,
  [ButtonSize.m]: css$3`
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_M}`};
    height: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_M};
    width: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_M};
  `,
  [ButtonSize.l]: css$3`
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_L}`};
    height: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_L};
    width: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_L};
  `,
  [ButtonSize.xl]: css$3`
    padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_padding_horizontal_XL}`};
    height: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_XL};
    width: ${({ theme: { components: t } }) => t.buttons.fds_c_classic_height_XL};
  `
}, ButtonBaseStyled$1 = styled(Button$4)`
  & {
    gap: 0;
  }

  ${({ size: t = ButtonSize.m }) => ButtonIconSize[t]}

  padding: ${({ theme: { components: t } }) => t.buttons.fds_c_button_padding_horizontal_L};
  ${ButtonLabel} {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
  }
`, Icon$2 = ({
  icon: t,
  size: r = ButtonSize.m,
  mode: n = ButtonMode.secondary,
  ...a
}) => /* @__PURE__ */ jsx$1(ButtonBaseStyled$1, {
  iconStart: t,
  size: r,
  mode: n,
  ...a
}), ButtonHoverStyle = css$3`
  &&:hover:not(:disabled) {
    background-color: inherit;
  }
  && > span {
    position: relative;
    transition: color 0.4s
      ${({ theme: { components: t } }) => t.buttons.fds_c_button_tiny_underline_ease};
  }
  & span::after {
    content: '';
    position: absolute;
    bottom: calc(-1 * ${({ theme: { reference: t } }) => t.dimension_04});
    right: 0;
    width: 100%;
    height: ${({ theme: { components: t } }) => t.buttons.fds_c_button_tiny_underline_height};
    border-radius: ${({ theme: { components: t } }) => t.buttons.fds_c_button_tiny_underline_radius};
    transition: transform 0.4s
      ${({ theme: { components: t } }) => t.buttons.fds_c_button_tiny_underline_ease};
    transform: scaleX(0);
    transform-origin: right;
  }

  && > svg {
    position: relative;
    transition: stroke 0.4s
      ${({ theme: { components: t } }) => t.buttons.fds_c_button_tiny_underline_ease};
  }
`, ButtonStyleStylesXXS = {
  [ButtonModeXXS.default]: css$3`
    && > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold};
    }
    & span::after {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold_hover};
    }
    &&:hover:not(:disabled) > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold_hover};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_cold}`};
    }
    &&:hover:not(:disabled) > svg {
      stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold_hover};
    }
  `,
  [ButtonModeXXS.dark]: css$3`
    && > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark};
    }
    & span::after {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
    }
    &&:hover:not(:disabled) > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }
    &&:hover:not(:disabled) > svg {
      stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
    }
  `,
  [ButtonModeXXS.light]: css$3`
    && > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_light};
    }
    & span::after {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_light_hover};
    }
    &&:hover:not(:disabled) > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_light_hover};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
    &&:hover:not(:disabled) > svg {
      stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_light_hover};
    }
  `,
  [ButtonModeXXS.skeleton]: css$3`
    && > span {
      color: ${({ theme: { system: t } }) => t.background.fds_sys_color_skeleton};
    }
    & > svg {
      stroke: ${({ theme: { system: t } }) => `${t.background.fds_sys_color_skeleton}`};
    }

    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_skeleton};
  `,
  [ButtonModeXXS.success]: css$3`
    && > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_primary};
    }
    & span::after {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_primary_hover};
    }
    &&:hover:not(:disabled) > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_primary_hover};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_success_primary}`};
    }
    &&:hover:not(:disabled) > svg {
      stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_success_primary_hover};
    }
  `,
  [ButtonModeXXS.danger]: css$3`
    && > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_primary};
    }
    & span::after {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_primary_hover};
    }
    &&:hover:not(:disabled) > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_primary_hover};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_danger_primary}`};
    }
    &&:hover:not(:disabled) > svg {
      stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_danger_primary_hover};
    }
  `,
  [ButtonModeXXS.warning]: css$3`
    && > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_primary};
    }
    & span::after {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_primary_hover};
    }
    &&:hover:not(:disabled) > span {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_primary_hover};
    }
    & > svg {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_warning_primary}`};
    }
    &&:hover:not(:disabled) > svg {
      stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_warning_primary_hover};
    }
  `
}, ButtonBaseStyled = styled(Button$4)`
  position: relative;
  ${ButtonHoverStyle}
  ${({ mode: t = "default" }) => ButtonStyleStylesXXS[t]}
  ${({ mode: t }) => t !== ButtonMode.skeleton && css$3`
      &:hover:not(:disabled) {
        transform: none;
        background-color: transparent;
      }
    `}
  ${({ $hasHoverUnderline: t }) => t && css$3`
      &:hover:not(:disabled) {
        & span::after {
          transform: scaleX(1);
          transform-origin: left;
        }
      }
    `}
`, Button$3 = styled(Button$4)`
  && > span {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark};
  }
  & span::after {
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
  }
  &&:hover:not(:disabled) > span {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
  }
  & > svg {
    stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
  }
  &&:hover:not(:disabled) > svg {
    stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
  }
  ${ButtonHoverStyle}

  gap: ${({ theme: { components: t } }) => t.buttons.fds_c_button_bottomnav_gap};
  ${({ theme: { components: t } }) => t.buttons.fds_c_button_bottomnav_text};
  ${ButtonLabel} {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
  }
  background-color: transparent;

  @media screen and (min-width: 1024px) {
    &:hover:not(:disabled) > svg {
      background-color: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    }

    &:hover:not(:disabled) > svg > g > path {
      stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_light_text}`};
    }
  }

  & > svg {
    stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
    border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_round};
    width: ${({ theme: { components: t } }) => `${t.buttons.fds_c_bottomnav_icon_size}`};
    height: ${({ theme: { components: t } }) => `${t.buttons.fds_c_bottomnav_icon_size}`};
  }
`, BottomNav$1 = ({
  label: t,
  direction: r,
  disabled: n = !1,
  ...a
}) => /* @__PURE__ */ jsx$1(Button$3, {
  label: t,
  disabled: n,
  ...r === "PREV" ? {
    iconStart: "IconFlowNavArrowLeft"
  } : {
    iconEnd: "IconFlowNavArrowRight"
  },
  mode: "dark",
  ...a
}), ButtonStyleStyles = {
  [ButtonMode.primary]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_secondary};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_secondary_hover};
    }
  `,
  [ButtonMode.secondary]: css$3`
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark};
    ${ButtonLabel} {
      color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_light_text};
    }
    &&:hover:not(:disabled) {
      background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
    }
  `
}, Button$2 = styled(Button$4)`
  ${({ mode: t }) => ButtonStyleStyles[t]}
  gap: 0;
  padding: ${({ theme: { components: t } }) => `0 ${t.buttons.fds_c_button_contextual_horizontal_padding}`};
  height: ${({ theme: { components: t } }) => t.buttons.fds_c_contextual_height};
  ${({ theme: { components: t } }) => t.buttons.fds_c_button_contextual};
`, Contextual = ({
  label: t,
  mode: r = ButtonMode.secondary,
  ...n
}) => /* @__PURE__ */ jsx$1(Button$2, {
  label: t,
  mode: r,
  ...n
}), Button$1 = styled(Button$4)`
  && > span {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark};
  }
  & span::after {
    background-color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
  }
  &&:hover:not(:disabled) > span {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
  }
  & > svg {
    stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
  }
  &&:hover:not(:disabled) > svg {
    stroke: ${({ theme: { components: t } }) => t.buttons.fds_c_button_background_dark_hover};
  }
  ${ButtonHoverStyle}

  gap: ${({ theme: { components: t } }) => t.buttons.fds_c_button_topbar};
  ${({ theme: { components: t } }) => t.buttons.fds_c_button_topbar};
  ${ButtonLabel} {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_text_dark};
  }
  background-color: transparent;
  & > svg {
    stroke: ${({ theme: { components: t } }) => `${t.buttons.fds_c_button_text_dark}`};
  }
`, TopNav = ({
  label: t,
  side: r,
  showIcon: n,
  ...a
}) => /* @__PURE__ */ jsx$1(Button$1, {
  label: t,
  ...n ? r === "PREV" ? {
    iconStart: "IconArrowLeftM"
  } : {
    iconEnd: "IconArrowRightM"
  } : {},
  mode: "dark",
  ...a
}), Tiny$1 = ({
  label: t,
  mode: r,
  hasHoverUnderline: n = !0,
  iconEnd: a,
  iconStart: s,
  disabled: o,
  ...c
}) => /* @__PURE__ */ jsx$1(ButtonBaseStyled, {
  label: t,
  mode: r,
  size: ButtonSize.xxs,
  $hasHoverUnderline: n,
  iconStart: s,
  iconEnd: a,
  disabled: o,
  ...c
}), Buttons = {
  Button: Button$4,
  Classic: Classic$1,
  Icon: Icon$2,
  BottomNav: BottomNav$1,
  Contextual,
  TopNav,
  Tiny: Tiny$1
}, Container$m = styled.div`
  display: flex;
  align-items: ${({ align: t }) => t};
  justify-content: ${({ justify: t }) => t};
  flex-direction: ${({ direction: t }) => t};
  gap: ${({ gap: t, theme: { reference: r } }) => t && r[t]};
  flex-wrap: ${({ wrap: t }) => t};
  width: ${({ fullWidth: t }) => t ? "100%" : "initial"};
  height: ${({ fullHeight: t }) => t ? "100%" : "initial"};
  flex-grow: ${({ flexGrow: t }) => t};
  ${MarginsStyles};
`, FlexContainer$1 = ({
  children: t,
  align: r,
  justify: n,
  wrap: a,
  direction: s,
  fullWidth: o,
  fullHeight: c,
  flexGrow: l,
  gap: d,
  testID: h,
  ...u
}) => /* @__PURE__ */ jsx$1(Container$m, {
  align: r,
  justify: n,
  wrap: a,
  direction: s,
  gap: d,
  fullWidth: o,
  fullHeight: c,
  flexGrow: l,
  "data-testid": h,
  ...u,
  children: t
});
var TextTypes = /* @__PURE__ */ ((t) => (t.headline = "headline", t.paragraphs = "paragraphs", t))(TextTypes || {}), Sizes = /* @__PURE__ */ ((t) => (t.XL = "h1", t.L = "h2", t.M = "h3", t.S = "h4", t.XS = "h5", t))(Sizes || {});
const getTag = (t, r, n) => {
  if (n)
    return n;
  if (t === TextTypes.headline && r) {
    const [a] = r.split("_");
    return Sizes[a];
  }
  if (t) {
    const [a, s, o, c] = t.split("_");
    if (s && s.includes("text") || s != null && s.includes("paragraph"))
      return "p";
    if (s != null && s.includes("heading"))
      return c.toLowerCase();
  }
  return "p";
}, getResponsiveFontSize = (t, r, n) => {
  var h;
  const [a, s, o] = r.split("_"), l = (h = components$1[t][`${t}_text_sizes`].text[n]) == null ? void 0 : h[a], d = l ? `${l}_${s}_${o}` : r;
  return components$1[t][d];
}, {
  MOBILE_EXTRA_SMALL_WIDTH,
  MOBILE_SMALL_WIDTH,
  MOBILE_MEDIUM_WIDTH,
  MOBILE_WIDTH,
  TABLET_WIDTH,
  DESKTOP_EXTRA_SMALL_WIDTH,
  DESKTOP_SMALL_WIDTH,
  DESKTOP_WIDTH
} = reference$1.breakpoints, isLegacyText = (t) => t !== TextTypes.headline && t !== TextTypes.paragraphs, responsiveFontSize = (t, r, n) => !isLegacyText(t) && t && r && getResponsiveFontSize(t, r, n), Text$4 = styled.p`
  ${({ theme: { colors: t, typography: r }, color: n, type: a }) => isLegacyText(a) && css$3`
      color: ${n && t[n] ? t[n] : n};
      ${a && r[a]};
    `};
  text-align: ${({ align: t }) => t && t};
  color: ${({ color: t, theme: { components: r } }) => t && r.textColors[t]};

  ${MarginsStyles}

  @media screen and (max-width: ${MOBILE_SMALL_WIDTH}) {
    ${({ type: t, size: r }) => responsiveFontSize(t, r, MOBILE_EXTRA_SMALL_WIDTH)}
  }

  @media screen and (min-width: ${MOBILE_SMALL_WIDTH}) {
    ${({ type: t, size: r }) => responsiveFontSize(t, r, MOBILE_SMALL_WIDTH)}
  }

  @media screen and (min-width: ${MOBILE_MEDIUM_WIDTH}) {
    ${({ type: t, size: r }) => responsiveFontSize(t, r, MOBILE_MEDIUM_WIDTH)}
  }

  @media screen and (min-width: ${MOBILE_WIDTH}) {
    ${({ type: t, size: r }) => responsiveFontSize(t, r, MOBILE_WIDTH)}
  }

  @media screen and (min-width: ${TABLET_WIDTH}) {
    ${({ type: t, size: r }) => responsiveFontSize(t, r, TABLET_WIDTH)}
  }

  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    ${({ type: t, size: r }) => responsiveFontSize(t, r, DESKTOP_EXTRA_SMALL_WIDTH)}
  }

  @media screen and (min-width: ${DESKTOP_SMALL_WIDTH}) {
    ${({ type: t, size: r }) => responsiveFontSize(t, r, DESKTOP_SMALL_WIDTH)}
  }

  @media screen and (min-width: ${DESKTOP_WIDTH}) {
    ${({ theme: { components: t }, type: r, size: n }) => !isLegacyText(r) && r && n && t[r][n]};
  }
`, Text$3 = ({
  children: t,
  tag: r,
  testID: n,
  type: a,
  size: s,
  ...o
}) => /* @__PURE__ */ jsx$1(Text$4, {
  type: a,
  size: s,
  "data-testid": n,
  as: getTag(a, s, r),
  ...o,
  children: t
});
var InformativeModes = /* @__PURE__ */ ((t) => (t.default = "default", t.light = "light", t.warning = "warning", t.danger = "danger", t.success = "success", t))(InformativeModes || {}), HelpButtonModes = ((t) => (t[t.default = ButtonMode.secondary] = "default", t[t.light = ButtonMode.primary] = "light", t[t.warning = ButtonMode.warning] = "warning", t[t.danger = ButtonMode.error] = "danger", t[t.success = ButtonMode.success] = "success", t))(HelpButtonModes || {});
const icons = {
  default: {
    icon: "InfoSolidXS",
    color: "default"
  },
  light: {
    icon: "InfoSolidXS",
    color: "default"
  },
  warning: {
    icon: "InfoSolidXS",
    color: "warning_strong"
  },
  danger: {
    icon: "CrossRoundedSolidXS",
    color: "error_strong"
  },
  success: {
    icon: "IconTickSolidSDark",
    color: "active"
  }
}, informativeModeStyles$2 = {
  [InformativeModes.default]: css$3`
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_color_default};
    color: ${({ theme: { components: t } }) => t.textColors.dark};
    border: ${({ theme: t, $highlight: r }) => r && `1px solid ${t.system.border.fds_sys_color_border_primary}`};
  `,
  [InformativeModes.light]: css$3`
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_color_light};
    color: ${({ theme: { components: t } }) => t.textColors.dark};
    border: ${({ theme: t, $highlight: r }) => r && `1px solid ${t.system.border.fds_sys_color_border_primary}`};
  `,
  [InformativeModes.warning]: css$3`
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_warning};
    color: ${({ theme: { components: t } }) => t.textColors.warning_strong};
    border: ${({ theme: t, $highlight: r }) => r && `1px solid ${t.system.border.fds_sys_color_border_warning}`};
  `,
  [InformativeModes.danger]: css$3`
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_error};
    color: ${({ theme: { components: t } }) => t.textColors.danger_strong};
    border: ${({ theme: t, $highlight: r }) => r && `1px solid ${t.system.border.fds_sys_color_border_error}`};
  `,
  [InformativeModes.success]: css$3`
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_success};
    color: ${({ theme: { components: t } }) => t.textColors.success_strong};
    border: ${({ theme: t, $highlight: r }) => r && `1px solid ${t.system.border.fds_sys_color_border_success}`};
  `
}, bulletModeStyles = {
  [InformativeModes.default]: css$3`
    background: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary};
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary_inverse};
  `,
  [InformativeModes.light]: css$3`
    background: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary};
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary_inverse};
  `,
  [InformativeModes.warning]: css$3`
    background: ${({ theme: { reference: t } }) => t.functional.warning_500};
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary_inverse};
  `,
  [InformativeModes.danger]: css$3`
    background: ${({ theme: { reference: t } }) => t.functional.danger_500};
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary_inverse};
  `,
  [InformativeModes.success]: css$3`
    background: ${({ theme: { reference: t } }) => t.extended.grass_500};
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary_inverse};
  `
}, Container$l = styled(FlexContainer$1)`
  ${({ $mode: t }) => informativeModeStyles$2[t]};
  padding: ${({ theme: { spacing: t } }) => t.spacing_24};
  border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_L};
  ${MarginsStyles}
`, TitleContainer$1 = styled(FlexContainer$1)`
  width: 100%;
`, BulletContainer = styled(FlexContainer$1)`
  gap: ${({ theme: { spacing: t } }) => t.spacing_16};
`, BulletIcon = styled(FlexContainer$1)`
  border-radius: ${({ theme: t }) => t.sizing.fds_borderradius_round};
  width: ${({ theme: { reference: t } }) => t.dimension_24};
  height: ${({ theme: { reference: t } }) => t.dimension_24};
  flex: none;
  ${({ $mode: t }) => bulletModeStyles[t]};
  > p {
    line-height: normal;
  }
`, CloseIcon$1 = styled.button`
  all: unset;
  cursor: pointer;
`;
styled.img`
  margin-right: ${({ theme: { spacing: t } }) => t.spacing_08};
`;
const Bullet = ({
  index: t,
  text: r,
  mode: n
}) => /* @__PURE__ */ jsxs(FlexContainer$1, {
  gap: "dimension_08",
  children: [/* @__PURE__ */ jsx$1(BulletIcon, {
    $mode: n,
    justify: "center",
    align: "center",
    children: /* @__PURE__ */ jsx$1(Text$3, {
      type: "paragraphs",
      size: "S_L_S",
      children: t
    })
  }), /* @__PURE__ */ jsx$1(Text$3, {
    size: "XS_M_M",
    type: "paragraphs",
    children: r
  })]
}), Informative = ({
  title: t,
  description: r,
  mode: n = InformativeModes.default,
  hasIcon: a,
  bullets: s,
  helpLink: o,
  noClose: c,
  highlight: l = !1,
  ...d
}) => {
  const [h, u] = useState(!0), p = () => {
    window.open(o == null ? void 0 : o.url, "_blank");
  };
  return h ? /* @__PURE__ */ jsxs(Container$l, {
    $mode: n,
    $highlight: l,
    direction: "column",
    gap: "dimension_16",
    ...d,
    children: [(t || a || !c) && /* @__PURE__ */ jsxs(TitleContainer$1, {
      justify: "space-between",
      children: [/* @__PURE__ */ jsxs(FlexContainer$1, {
        align: "center",
        gap: "dimension_16",
        children: [a && /* @__PURE__ */ jsx$1(Icon$4, {
          icon: icons[n].icon,
          color: icons[n].color,
          height: 16,
          width: 16
        }), t && /* @__PURE__ */ jsx$1(Text$3, {
          size: "M_XL_S",
          type: "paragraphs",
          children: t
        })]
      }), !c && /* @__PURE__ */ jsx$1(CloseIcon$1, {
        type: "button",
        onClick: () => u(!1),
        children: /* @__PURE__ */ jsx$1(Icon$4, {
          icon: "CrossXS",
          color: icons[n].color
        })
      })]
    }), r && /* @__PURE__ */ jsx$1(Text$3, {
      size: "S_M_L",
      type: "paragraphs",
      children: r
    }), s && /* @__PURE__ */ jsx$1(BulletContainer, {
      direction: "column",
      gap: "dimension_16",
      children: s.map((m, g) => /* @__PURE__ */ jsx$1(Bullet, {
        index: g + 1,
        text: m,
        mode: n
      }, m))
    }), (o == null ? void 0 : o.url) && (o == null ? void 0 : o.title) && /* @__PURE__ */ jsx$1(FlexContainer$1, {
      justify: "flex-end",
      children: /* @__PURE__ */ jsx$1(Buttons.Contextual, {
        onClick: p,
        label: o == null ? void 0 : o.title,
        mode: ButtonMode[HelpButtonModes[n]]
      })
    })]
  }) : null;
};
var BannerModesEnum = /* @__PURE__ */ ((t) => (t.default = "default", t.cold = "cold", t.success = "success", t.warning = "warning", t.error = "error", t.pro = "pro", t.live = "live", t.expert = "expert", t.full = "full", t))(BannerModesEnum || {}), LayoutEnum = /* @__PURE__ */ ((t) => (t.default = "default", t.embed = "embed", t.floation = "floation", t))(LayoutEnum || {}), PositionEnum = /* @__PURE__ */ ((t) => (t.horizontally = "horizontally", t.vertically = "vertically", t))(PositionEnum || {});
const buttonModes = {
  default: ButtonMode.primary,
  cold: ButtonMode.cold,
  error: ButtonMode.error,
  success: ButtonMode.success,
  warning: ButtonMode.warning,
  pro: ButtonMode.pro,
  live: ButtonMode.live,
  expert: ButtonMode.expert,
  full: ButtonMode.full
}, informativeModeStyles$1 = {
  [BannerModesEnum.default]: css$3`
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_color_default};
  `,
  [BannerModesEnum.success]: css$3`
    h3,
    p {
      color: ${({ theme: { components: t } }) => t.text.fds_c_text_success_strong};
    }
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_success};
    svg {
      path {
        fill: ${({ theme: { components: t } }) => t.text.fds_c_text_success_strong};
      }
    }
  `,
  [BannerModesEnum.cold]: css$3`
    h3,
    p {
      color: ${({ theme: { components: t } }) => t.text.fds_c_text_accent_cold};
    }
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_color_cold_background};
    svg {
      path {
        fill: ${({ theme: { components: t } }) => t.text.fds_c_text_accent_cold};
      }
    }
  `,
  [BannerModesEnum.warning]: css$3`
    h3,
    p {
      color: ${({ theme: { components: t } }) => t.text.fds_c_text_warning_strong};
    }
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_warning};
    svg {
      path {
        fill: ${({ theme: { components: t } }) => t.text.fds_c_text_warning_strong};
      }
    }
  `,
  [BannerModesEnum.error]: css$3`
    h3,
    p {
      color: ${({ theme: { components: t } }) => t.text.fds_c_text_danger_strong};
    }
    background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_error};
    svg {
      path {
        fill: ${({ theme: { components: t } }) => t.text.fds_c_text_danger_strong};
      }
    }
  `,
  [BannerModesEnum.pro]: css$3`
    background: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_pro_tertiary};
    svg {
      path {
        fill: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_pro_primary};
      }
    }
  `,
  [BannerModesEnum.live]: css$3`
    background: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_live_tertiary};
    svg {
      path {
        fill: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_live_primary};
      }
    }
  `,
  [BannerModesEnum.expert]: css$3`
    background: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_expert_tertiary};
    svg {
      path {
        fill: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_expert_primary};
      }
    }
  `,
  [BannerModesEnum.full]: css$3`
    background: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_full_tertiary};
    svg {
      path {
        fill: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_full_primary};
      }
    }
  `
}, layoutStyles = {
  [LayoutEnum.embed]: css$3`
    border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_L};
  `,
  [LayoutEnum.floation]: css$3`
    border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_L};
    margin: ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_M};
  `
}, BannerSizesStyles = {
  [Sizes$1.S]: css$3`
    padding: ${({ theme: { reference: t } }) => t.dimension_08};
    gap: ${({ theme: { reference: t } }) => t.dimension_08};
  `,
  [Sizes$1.M]: css$3`
    padding: ${({ theme: { reference: t } }) => t.dimension_16};
    gap: ${({ theme: { reference: t } }) => t.dimension_16};
  `
}, BannerContentGapStyles = {
  [PositionEnum.horizontally]: css$3`
    gap: ${({ theme: { reference: t } }) => t.dimension_16};
  `,
  [PositionEnum.vertically]: css$3`
    gap: ${({ theme: { reference: t } }) => t.dimension_08};
  `
}, ButtonsIconsStyles = {
  [PositionEnum.vertically]: css$3`
    align-self: flex-start;
  `,
  [PositionEnum.horizontally]: css$3`
    align-self: center;
  `
}, CloseIconStyles = {
  [BannerModesEnum.error]: css$3`
    svg {
      stroke: ${({ theme: { components: t } }) => t.text.fds_c_text_danger_strong};
    }
  `,
  [BannerModesEnum.success]: css$3`
    svg {
      stroke: ${({ theme: { components: t } }) => t.text.fds_c_text_success_strong};
    }
  `,
  [BannerModesEnum.warning]: css$3`
    svg {
      stroke: ${({ theme: { components: t } }) => t.text.fds_c_text_warning_strong};
    }
  `,
  [BannerModesEnum.cold]: css$3`
    svg {
      stroke: ${({ theme: { components: t } }) => t.text.fds_c_text_accent_cold};
    }
  `,
  [BannerModesEnum.default]: css$3`
    svg {
      stroke: ${({ theme: { components: t } }) => t.text.fds_c_text_dark};
    }
  `,
  [BannerModesEnum.pro]: css$3`
    svg {
      stroke: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_pro_primary};
    }
  `,
  [BannerModesEnum.live]: css$3`
    svg {
      stroke: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_live_primary};
    }
  `,
  [BannerModesEnum.expert]: css$3`
    svg {
      stroke: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_expert_primary};
    }
  `,
  [BannerModesEnum.full]: css$3`
    svg {
      stroke: ${({ theme: { system: t } }) => t.plans.fds_sys_color_plan_full_primary};
    }
  `
}, FlexContainerWrapper = styled(FlexContainer$1)`
  h3,
  p {
    color: ${({ theme: { components: t } }) => t.text.fds_c_text_dark};
  }
  ${({ theme: { components: t, system: r }, $highlight: n, $mode: a }) => n && css$3`
      border: 1px solid
        ${r.border[`fds_sys_color_border_${a}`] ? r.border[`fds_sys_color_border_${a}`] : t.messages.fds_c_messages_color_border};
    `};
  ${({ $layout: t }) => t && layoutStyles[t]};
  ${({ $mode: t }) => informativeModeStyles$1[t]};
  ${({ $size: t }) => BannerSizesStyles[t]};
`, FlexContainer = styled(FlexContainer$1)`
  width: 100%;
  ${({ $position: t }) => BannerContentGapStyles[t]};
`, FlexContainerButtonsIcon = styled(FlexContainer$1)`
  ${({ $position: t }) => ButtonsIconsStyles[t]};
  ${({ $mode: t }) => CloseIconStyles[t]};
`, ButtonsIcon = styled(Buttons.Icon)`
  padding: 0;
`, BannerIcons = {
  [BannerModesEnum.success]: /* @__PURE__ */ jsx$1(IconCircleTickSolidMXs, {
    color: IconColor.active
  }),
  [BannerModesEnum.warning]: /* @__PURE__ */ jsx$1(IconWarningAttentionSolidS, {}),
  [BannerModesEnum.error]: /* @__PURE__ */ jsx$1(IconCrossRoundedSolidMXs, {})
}, Banner = ({
  buttonLabel: t = "",
  description: r,
  hasClose: n,
  hasIcon: a,
  highlight: s = !1,
  icon: o,
  id: c,
  label: l,
  layout: d = LayoutEnum.default,
  mode: h,
  onClick: u,
  position: p,
  size: m = Sizes$1.M,
  titleSize: g = Sizes$1.S,
  ...v
}) => {
  const [y, x] = useState(!1);
  useEffect(() => {
    localStorage.getItem(`tx_banner_${c}`) !== "false" && x(!0);
  }, []);
  const _ = () => {
    localStorage.setItem(`tx_banner_${c}`, "false"), x(!1);
  };
  if (!y)
    return null;
  const $ = o || BannerIcons[h] || /* @__PURE__ */ jsx$1(IconInfoSolidMXs, {
    color: IconColor.default
  });
  return /* @__PURE__ */ jsxs(FlexContainerWrapper, {
    $highlight: s,
    $layout: d,
    $mode: h,
    $size: m,
    ...v,
    ...p !== PositionEnum.vertically && {
      align: "center"
    },
    children: [a && $ && /* @__PURE__ */ jsx$1(FlexContainer$1, {
      children: $
    }), /* @__PURE__ */ jsxs(FlexContainer, {
      justify: "space-between",
      $position: p || PositionEnum.horizontally,
      ...p === PositionEnum.vertically && {
        direction: "column",
        align: "flex-start"
      } || {
        align: "center"
      },
      children: [/* @__PURE__ */ jsxs(FlexContainer$1, {
        gap: "dimension_04",
        direction: "column",
        children: [/* @__PURE__ */ jsx$1(Text$3, {
          tag: "h3",
          type: "paragraphs",
          size: `${g}_L_S`,
          color: "dark",
          children: l
        }), r && /* @__PURE__ */ jsx$1(Text$3, {
          size: "XS_M_S",
          type: "paragraphs",
          color: "dark",
          children: r
        })]
      }), u && /* @__PURE__ */ jsx$1(Buttons.Classic, {
        onClick: u,
        label: t,
        size: "xs",
        mode: buttonModes[h]
      })]
    }), n && /* @__PURE__ */ jsx$1(FlexContainerButtonsIcon, {
      $mode: h,
      $position: p || PositionEnum.horizontally,
      children: /* @__PURE__ */ jsx$1(ButtonsIcon, {
        size: "xxs",
        icon: "CrossXS",
        mode: "empty",
        onClick: _
      })
    })]
  });
};
var NotificationModes = /* @__PURE__ */ ((t) => (t.light = "light", t.dark = "dark", t.success = "success", t.warning = "warning", t.error = "error", t))(NotificationModes || {}), NotificationTextColors = /* @__PURE__ */ ((t) => (t.light = "dark", t.dark = "light", t.success = "success_strong", t.warning = "warning_strong", t.error = "danger_strong", t))(NotificationTextColors || {}), NotificationIcons = /* @__PURE__ */ ((t) => (t.light = "IconInfoSolidSDark", t.dark = "IconInfoSolidSLight", t.success = "IconTickSolidSGreen", t.warning = "IconWarningAttentionSolidS", t.error = "IconDangerCrossSolidS", t))(NotificationIcons || {}), CloseIcons = /* @__PURE__ */ ((t) => (t.light = "IconCrossDarkM", t.dark = "IconCrossLightM", t.success = "IconCrossDarkM", t.warning = "IconCrossDarkM", t.error = "IconCrossDangerM", t))(CloseIcons || {}), CloseIconsColors = /* @__PURE__ */ ((t) => (t.light = "default", t.dark = "default", t.success = "active", t.warning = "warning", t.error = "default", t))(CloseIconsColors || {});
const informativeModeStyles = {
  [NotificationModes.error]: css$3`
    background: ${({ theme: { colors: t } }) => t.danger_200};
    color: ${({ theme: { colors: t } }) => t.danger_700};
  `,
  [NotificationModes.dark]: css$3`
    background: ${({ theme: { colors: t } }) => t.dark_500};
    color: ${({ theme: { colors: t } }) => t.white};
  `,
  [NotificationModes.light]: css$3`
    background: ${({ theme: { colors: t } }) => t.white};
    color: ${({ theme: { colors: t } }) => t.dark_500};
  `,
  [NotificationModes.success]: css$3`
    background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_fresh};
    color: ${({ theme: { components: t } }) => t.messages.fds_c_messages_success_strong};
  `,
  [NotificationModes.warning]: css$3`
    background: ${({ theme: { colors: t } }) => t.warning_200};
    color: ${({ theme: { colors: t } }) => t.warning_700};
  `
}, Container$k = styled(FlexContainer$1)`
  ${({ $mode: t }) => informativeModeStyles[t]};
  padding: ${({ theme: { spacing: t } }) => t.spacing_24};
  border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_L};
  border: ${({ theme: { components: t, system: r }, $highlight: n, $mode: a }) => n && `1px solid ${r.border[`fds_sys_color_border_${a}`] ? r.border[`fds_sys_color_border_${a}`] : t.messages.fds_c_messages_color_border}`};
  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.15));
  ${MarginsStyles};
`, TitleContainer = styled(FlexContainer$1)`
  width: 100%;
  margin-bottom: ${({ theme: t }) => t.reference.dimension_16};
  gap: ${({ theme: t }) => t.reference.dimension_16};
`, CloseIcon = styled.button`
  all: unset;
  cursor: pointer;
`, Icon$1 = styled(Icon$4).attrs(({ theme: t }) => ({
  width: t.reference.dimension_16,
  height: t.reference.dimension_16
}))``, Title = styled(Text$3)`
  flex: 1;
`, buttonMode = {
  [NotificationModes.light]: ButtonMode.primary,
  [NotificationModes.dark]: ButtonMode.secondary,
  [NotificationModes.success]: ButtonMode.success,
  [NotificationModes.warning]: ButtonMode.warning,
  [NotificationModes.error]: ButtonMode.error
}, Notification = ({
  id: t,
  title: r = "",
  description: n,
  mode: a = NotificationModes.light,
  hasIcon: s,
  buttonLabel: o = "",
  buttonOnClick: c = void 0,
  noClose: l,
  highlight: d = !1,
  ...h
}) => {
  const [u, p] = useState(!0);
  useEffect(() => {
    localStorage.getItem(`tx_notification_${t}`) !== "false" && p(!0);
  }, []);
  const m = () => {
    localStorage.setItem(`tx_notification_${t}`, "false"), p(!1);
  };
  return u ? /* @__PURE__ */ jsxs(Container$k, {
    $mode: a,
    direction: "column",
    $highlight: d,
    ...h,
    children: [(s || !l || r !== "") && /* @__PURE__ */ jsxs(TitleContainer, {
      justify: "space-between",
      children: [s && /* @__PURE__ */ jsx$1(Icon$1, {
        icon: NotificationIcons[a],
        color: "default"
      }), /* @__PURE__ */ jsx$1(Title, {
        type: "paragraphs",
        color: NotificationTextColors[a],
        size: "M_XL_S",
        children: r
      }), !l && /* @__PURE__ */ jsx$1(CloseIcon, {
        type: "button",
        onClick: m,
        children: /* @__PURE__ */ jsx$1(Icon$1, {
          icon: CloseIcons[a],
          color: CloseIconsColors[a]
        })
      })]
    }), n && /* @__PURE__ */ jsx$1(Text$3, {
      type: "paragraphs",
      color: NotificationTextColors[a],
      size: "S_M_S",
      children: n
    }), c && /* @__PURE__ */ jsx$1(FlexContainer$1, {
      justify: "flex-start",
      mt: "fds_size_16",
      children: /* @__PURE__ */ jsx$1(Buttons.Button, {
        onClick: c,
        label: o,
        size: "xs",
        mode: buttonMode[a]
      })
    })]
  }) : null;
}, mobileMediumWidth = ({ theme: { reference: t } }) => t.breakpoints.MOBILE_MEDIUM_WIDT, ToastStyled = styled.div`
  .Toastify__toast-container {
    --toast-width: 100%;
    --toast-margin-top-bottom: ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_M};
    --toast-margin-left-right: 0;

    @media screen and (max-width: ${mobileMediumWidth}) {
      --toast-margin-left-right: ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_M};
      --toast-width: calc(
        100% - ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_M} * 2
      );
    }

    margin: var(--toast-margin-top-bottom) var(--toast-margin-left-right);
    width: var(--toast-width);
    top: 0;
    padding: 0;
    max-width: 475px;
  }
  .Toastify__toast {
    border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
    box-shadow: ${({ theme: { components: t } }) => `${t.messages.fds_c_floating_message_shadow.x} ${t.messages.fds_c_floating_message_shadow.y} ${t.messages.fds_c_floating_message_shadow.blur} ${t.messages.fds_c_floating_message_shadow.spread} ${t.messages.fds_c_floating_message_shadow.color}`};

    font-family: ${({ theme: { fontFamily: t } }) => t.silka};
    padding: 0;
    .Toastify__message-container {
      gap: ${({ theme: { reference: t } }) => t.dimension_08};
      padding: ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_L};
      > div:first-child {
        width: 100%;
      }
    }
    .Toastify__header {
      display: flex;
      align-items: center;
      gap: ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_M};
      margin-bottom: ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_M};
      svg {
        width: 5%;
        fill: ${({ theme: { colors: t } }) => t.dark_500};
      }
    }
    .Toastify__crossicon {
      flex: 0 0 16px;
      svg {
        width: 100%;
      }
    }
    .Toastify__close-button {
      display: none;
    }
    .Toastify__progress-bar {
      height: ${({ theme: { sizing: t } }) => t.fds_size_08};
    }
    .Toastify__title {
      width: 90%;
    }
    .Toastify__description {
      color: ${({ theme: { colors: t } }) => t.dark_500};
    }
    &-body {
      padding: 0;
    }
    &--success {
      background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_success};
      border: ${({ isHighligth: t, theme: { system: r } }) => t ? `1px solid ${r.border.fds_sys_color_border_success}` : null};
      .Toastify__progress-bar {
        background: ${({ theme: { colors: t } }) => t.grass_500};
      }
      .Toastify__title {
        color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_success_stronger};
      }
      .Toastify__crossicon {
        svg {
          path {
            stroke: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_success_stronger};
          }
        }
      }
    }
    &--info {
      background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_color_default};
      border: ${({ isHighligth: t, theme: { components: r } }) => t ? `1px solid ${r.messages.fds_c_messages_color_border}` : null};
      .Toastify__progress-bar {
        background: ${({ theme: { colors: t } }) => t.sky_500};
      }
      .Toastify__title {
        color: ${({ theme: { colors: t } }) => t.dark_500};
      }
      .Toastify__description {
        color: ${({ theme: { colors: t } }) => t.dark_500};
      }
      .Toastify__crossicon {
        svg {
          path {
            stroke: ${({ theme: { system: t } }) => t.border.fds_sys_color_border_primary_inverse};
          }
        }
      }
    }
    &--error {
      background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_error};
      border: ${({ isHighligth: t, theme: { system: r } }) => t ? `1px solid ${r.border.fds_sys_color_border_error}` : null};
      .Toastify__progress-bar {
        background: ${({ theme: { colors: t } }) => t.danger_550};
      }
      .Toastify__title {
        color: ${({ theme: { colors: t } }) => t.danger_550};
      }
      .Toastify__description {
        color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_danger_stronger};
      }
      .Toastify__crossicon {
        svg {
          path {
            stroke: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_danger_stronger};
          }
        }
      }
    }
    &-theme--dark {
      background: ${({ theme: { reference: t } }) => t.brand.dark_500};
      border: ${({ isHighligth: t, theme: { components: r } }) => t ? `1px solid ${r.messages.fds_c_messages_color_border}` : null};
      .Toastify__progress-bar {
        background: ${({ theme: { colors: t } }) => t.grass_500};
      }
      .Toastify__description {
        color: ${({ theme: { colors: t } }) => t.white};
      }
      .Toastify__title {
        color: ${({ theme: { colors: t } }) => t.white};
      }
      .Toastify__crossicon {
        svg {
          path {
            stroke: ${({ theme: { colors: t } }) => t.white};
          }
        }
      }
    }
    &--warning {
      background: ${({ theme: { components: t } }) => t.messages.fds_c_messages_warning};
      border: ${({ isHighligth: t, theme: { system: r } }) => t ? `1px solid ${r.border.fds_sys_color_border_warning}` : null};
      .Toastify__progress-bar {
        background: ${({ theme: { colors: t } }) => t.warning_550};
      }
      .Toastify__title {
        color: ${({ theme: { colors: t } }) => t.warning_550};
      }
      .Toastify__description {
        color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_warning_stronger};
      }
      .Toastify__crossicon {
        svg {
          fill: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_warning_stronger};
          path {
            stroke: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_warning_stronger};
          }
        }
      }
    }
  }
`, Toast = ({
  isHighligth: t = !1,
  ...r
}) => /* @__PURE__ */ jsx$1(ToastStyled, {
  isHighligth: t,
  children: /* @__PURE__ */ jsx$1(ToastContainer, {
    ...r
  })
}), DarkIcon = () => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8.5",
    r: "8",
    fill: "white"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 7.5L8 12.5",
    stroke: "#3D3A62",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 4.5L8 6.5",
    stroke: "#3D3A62",
    strokeWidth: "2"
  })]
}), ErrorIcon = () => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8.5",
    r: "8",
    fill: "#FB6B62"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 11.4999L5 5.5",
    stroke: "white",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M11 5.49988L5 11.4998",
    stroke: "white",
    strokeWidth: "2"
  })]
}), InfoIcon = () => /* @__PURE__ */ jsx$1(Icon$4, {
  color: "default",
  height: 16,
  icon: "IconInfoSolidSDark",
  width: 16
}), SuccessIcon = () => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8.5",
    r: "8",
    fill: "#0FB990"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M4 7.5L7 10.5L12 5.5",
    stroke: "white",
    strokeWidth: "2"
  })]
}), WarningIcon = () => /* @__PURE__ */ jsxs("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("circle", {
    cx: "8",
    cy: "8.5",
    r: "8",
    fill: "#E1A613"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 8.5V4.5",
    stroke: "white",
    strokeWidth: "2"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8 12.5V10.5",
    stroke: "white",
    strokeWidth: "2"
  })]
}), iconByTpe = {
  [toast.TYPE.INFO]: InfoIcon,
  [toast.TYPE.SUCCESS]: SuccessIcon,
  [toast.TYPE.ERROR]: ErrorIcon,
  [toast.TYPE.WARNING]: WarningIcon,
  [toast.TYPE.DEFAULT]: DarkIcon
}, ToastLayout = ({
  title: t,
  description: r,
  closeButton: n = !0,
  showIcon: a = !0,
  type: s
}) => {
  const o = s && iconByTpe[s];
  return /* @__PURE__ */ jsxs(FlexContainer$1, {
    className: "Toastify__message-container",
    justify: "space-between",
    children: [/* @__PURE__ */ jsxs(FlexContainer$1, {
      direction: "column",
      children: [t && /* @__PURE__ */ jsxs(FlexContainer$1, {
        className: "Toastify__header",
        children: [a && o && /* @__PURE__ */ jsx$1(o, {}), /* @__PURE__ */ jsx$1(Text$3, {
          type: "paragraphs",
          color: "dark",
          align: "start",
          size: "M_XL_S",
          className: "Toastify__title",
          children: t
        })]
      }), r && /* @__PURE__ */ jsx$1(Text$3, {
        size: "S_M_L",
        type: "paragraphs",
        color: "dark",
        className: "Toastify__description",
        children: r
      })]
    }), n && /* @__PURE__ */ jsx$1(FlexContainer$1, {
      className: "Toastify__crossicon",
      children: /* @__PURE__ */ jsx$1(Icon$4, {
        icon: "IconCrossDarkM",
        color: "default",
        height: 16,
        width: 16
      })
    })]
  });
}, configuration = {
  position: toast.POSITION.TOP_CENTER,
  transition: Zoom$1,
  icon: !1
}, ToastService = {
  ...toast,
  error: ({
    description: t,
    title: r,
    closeButton: n,
    showIcon: a
  }) => toast.error(/* @__PURE__ */ jsx$1(ToastLayout, {
    title: r,
    description: t,
    closeButton: n,
    showIcon: a,
    type: toast.TYPE.ERROR
  }), configuration),
  warning: ({
    description: t,
    title: r,
    closeButton: n,
    showIcon: a
  }) => toast.warning(/* @__PURE__ */ jsx$1(ToastLayout, {
    title: r,
    description: t,
    closeButton: n,
    showIcon: a,
    type: toast.TYPE.WARNING
  }), configuration),
  info: ({
    description: t,
    title: r,
    closeButton: n,
    showIcon: a
  }) => toast.info(/* @__PURE__ */ jsx$1(ToastLayout, {
    title: r,
    description: t,
    closeButton: n,
    showIcon: a,
    type: toast.TYPE.INFO
  }), configuration),
  success: ({
    description: t,
    title: r,
    closeButton: n,
    showIcon: a
  }) => toast.success(/* @__PURE__ */ jsx$1(ToastLayout, {
    title: r,
    description: t,
    closeButton: n,
    showIcon: a,
    type: toast.TYPE.SUCCESS
  }), configuration),
  dark: ({
    description: t,
    title: r,
    closeButton: n,
    showIcon: a
  }) => toast.dark(/* @__PURE__ */ jsx$1(ToastLayout, {
    title: r,
    description: t,
    closeButton: n,
    showIcon: a,
    type: toast.TYPE.DEFAULT
  }), configuration)
}, Accordion$1 = styled(FlexContainer$1)`
  border-radius: ${({ theme: { components: t }, size: r }) => t.accordion[`fds_c_accordion_borderradius_${r}`]};
  transition: box-shadow 1.5s cubic-bezier(0, 0.8, 0.2, 1), border-color 1.5s cubic-bezier(0, 0.8, 0.2, 1);
  opacity: ${({ theme: { system: t }, isDisabled: r }) => r && t.fds_sys_disabled_opacity_S};
  ${({ isDisabled: t }) => !t && css$3`
      &:hover {
        box-shadow: ${({ theme: { system: r } }) => {
  const { x: n, y: a, blur: s, spread: o, color: c } = r.fds_sys_elevation_M;
  return `${n} ${a} ${s} ${o} ${c}`;
}};
        transition: box-shadow 0.25s cubic-bezier(0, 0, 0.2, 2),
          border-color 0.25s cubic-bezier(0, 0, 0.2, 2);
      }
    `};

  ${MarginsStyles}
`, Container$j = styled(FlexContainer$1)`
  width: 100%;
  border: ${({ theme: { system: t, components: r }, isSelected: n }) => `
      ${t.fds_sys_borderwidth_S} solid ${n ? r.accordion.fds_c_accordion_border_color_hover : r.accordion.fds_c_accordion_border_color}
    `};
  border-radius: ${({ theme: { components: t }, size: r }) => t.accordion[`fds_c_accordion_borderradius_${r}`]};
  box-shadow: ${({ theme: { system: t }, isSelected: r }) => {
  const { x: n, y: a, blur: s, spread: o, color: c } = t.fds_sys_embed_M;
  return r ? `inset ${n} ${a} ${s} ${o} ${c}` : `inset 0 0 0 ${c}`;
}};
  transition: ${({ isSelected: t }) => t ? "box-shadow 0.5s cubic-bezier(0,0,0.2,2)" : "box-shadow 1s cubic-bezier(0,0.8,0.2,1)"};
  background: ${({ theme: { components: t }, isSelected: r }) => r && t.accordion.fds_c_accordion_background_color_selected};
`, Parent = styled.button`
  all: unset;
  cursor: pointer;
  padding: ${({ theme: { components: t }, size: r }) => t.accordion[`fds_c_accordion_spacing_${r}`]};

  :disabled {
    cursor: not-allowed;
  }
`, ParentContent = styled(FlexContainer$1)`
  gap: ${({ theme: { components: t } }) => t.accordion.fds_c_accordion_spacing_S};
`, Separator$2 = styled(FlexContainer$1)`
  border-top: ${({ theme: { system: t } }) => `
      ${t.fds_sys_borderwidth_S} solid ${t.border.fds_sys_color_border_primary}
    `};
  transition: transform 1s cubic-bezier(0.8, 0, 0.2, 1);
  transform: ${({ isOpen: t }) => t ? "none" : "scaleX(0)"};
  transform-origin: left;
  opacity: ${({ isOpen: t }) => t ? "1" : "0"};
`, IconContainer$1 = styled.div`
  display: flex;
  flex: none;
  transition: transform 0.5s cubic-bezier(0.8, 0, 0.2, 1);
  transform: ${({ isOpen: t }) => t && "rotate(90deg)"};
`, Children = styled.div`
  padding: ${({ theme: { components: t }, size: r }) => t.accordion[`fds_c_accordion_spacing_${r}`]};
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  animation: fadein 1s cubic-bezier(0.8, 0, 0.2, 1);
`, Accordion = ({
  isSelected: t = !1,
  isOpened: r = !1,
  isDisabled: n = !1,
  size: a = Sizes$1.M,
  onClick: s,
  children: o,
  ...c
}) => {
  const [l, d] = useState(r), h = Children$1.toArray(o);
  return useEffect(() => {
    d(r);
  }, [r]), /* @__PURE__ */ jsx$1(Accordion$1, {
    isDisabled: n,
    size: a,
    ...c,
    children: /* @__PURE__ */ jsxs(Container$j, {
      direction: "column",
      size: a,
      isSelected: t,
      children: [/* @__PURE__ */ jsx$1(Parent, {
        onClick: () => {
          d(!l), s == null || s();
        },
        size: a,
        disabled: n,
        children: /* @__PURE__ */ jsxs(ParentContent, {
          align: "center",
          justify: "space-between",
          children: [h[0], /* @__PURE__ */ jsx$1(IconContainer$1, {
            isOpen: l,
            children: /* @__PURE__ */ jsx$1(Icon$4, {
              icon: "IconArrowRightS",
              color: "default",
              height: 16,
              width: 16
            })
          })]
        })
      }), /* @__PURE__ */ jsx$1(Separator$2, {
        isOpen: l
      }), l && /* @__PURE__ */ jsx$1(Children, {
        size: a,
        children: h[1]
      })]
    })
  });
}, defaultAvatar = "data:image/png;base64,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", Images = {
  defaultAvatar
};
var AvatarTypes = /* @__PURE__ */ ((t) => (t.dark = "dark", t.error = "error", t.warning = "warning", t.skeleton = "skeleton", t))(AvatarTypes || {});
const borderTypeStyles = {
  [AvatarTypes.dark]: css$3`
    border: ${({ theme: { components: t } }) => `${t.avatar.fds_c_avatar_borderwidth} solid ${t.avatar.fds_c_avatar_color_border}`};
  `,
  [AvatarTypes.error]: css$3`
    border: ${({ theme: { components: t } }) => `${t.avatar.fds_c_avatar_borderwidth} solid ${t.avatar.fds_c_avatar_color_border_error}`};
  `,
  [AvatarTypes.warning]: css$3`
    border: ${({ theme: { components: t } }) => `${t.avatar.fds_c_avatar_borderwidth} solid ${t.avatar.fds_c_avatar_color_border_warning}`};
  `,
  [AvatarTypes.skeleton]: css$3`
    border: ${({ theme: { components: t } }) => `${t.avatar.fds_c_avatar_borderwidth} solid ${t.avatar.fds_c_avatar_color_border}`};
  `
}, Container$i = styled.div``, AvatarImage = styled.img`
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_O};
  object-fit: cover;
  height: ${({ theme: { components: t } }) => t.avatar.fds_c_avatar_size};
  width: ${({ theme: { components: t } }) => t.avatar.fds_c_avatar_size};
  ${({ $type: t }) => borderTypeStyles[t]};
`, Avatar = ({
  url: t,
  type: r = AvatarTypes.dark
}) => /* @__PURE__ */ jsx$1(Container$i, {
  children: /* @__PURE__ */ jsx$1(AvatarImage, {
    $type: r,
    src: t || Images.defaultAvatar,
    alt: "avatar"
  })
});
var BrandMode = /* @__PURE__ */ ((t) => (t.default = "default", t.dark = "dark", t.light = "light", t.fullDark = "fullDark", t.fullLigth = "fullLigth", t))(BrandMode || {}), BrandIconColor = /* @__PURE__ */ ((t) => (t.default = "#0FB990", t.dark = "#3D3A62", t.light = "#FFFFFF", t.fullDark = "#3D3A62", t.fullLigth = "#FFFFFF", t))(BrandIconColor || {});
const BrandIcon = ({
  mode: t = BrandMode.default
}) => {
  const r = BrandIconColor[t];
  return /* @__PURE__ */ jsxs("svg", {
    width: "50",
    height: "32",
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx$1("rect", {
      x: "7.56909",
      y: "-7.62939e-06",
      width: "9.95384",
      height: "9.95384",
      transform: "rotate(45 7.56909 -7.62939e-06)",
      fill: r
    }), /* @__PURE__ */ jsx$1("rect", {
      x: "24.7732",
      y: "-7.62939e-06",
      width: "9.95384",
      height: "22.1196",
      transform: "rotate(45 24.7732 -7.62939e-06)",
      fill: r
    }), /* @__PURE__ */ jsx$1("rect", {
      x: "41.981",
      y: "-7.62939e-06",
      width: "9.95384",
      height: "34.2854",
      transform: "rotate(45 41.981 -7.62939e-06)",
      fill: r
    })]
  });
};
var BrandTextColor = /* @__PURE__ */ ((t) => (t.dark = "#3D3A62", t.light = "#FFFFFF", t.fullDark = "#3D3A62", t.fullLigth = "#FFFFFF", t))(BrandTextColor || {});
const BrandText = ({
  mode: t = BrandMode.dark
}) => {
  const r = BrandTextColor[t];
  return /* @__PURE__ */ jsxs("svg", {
    width: "184",
    height: "32",
    viewBox: "0 0 184 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M3.28669 22.3347V11.3688H0.0192871V7.29571H3.28669V2.95409L8.25494 1.92464V7.29571H14.924V11.3688H8.25494V22.469C8.25494 24.5578 9.04568 25.6021 10.6272 25.6021C11.1344 25.6021 11.6566 25.5126 12.1937 25.3336C12.7308 25.1545 13.1337 24.9755 13.4022 24.7965L13.8498 24.5279L15.3269 28.2429C13.626 29.347 11.8506 29.899 10.0005 29.899C5.52464 29.899 3.28669 27.3776 3.28669 22.3347Z",
      fill: r
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M41.3649 29.4514L49.0635 18.2169L41.3649 7.29571H46.8703L50.3615 12.3535L52.1518 15.0838C52.8381 13.9499 53.42 13.0398 53.8974 12.3535L57.3886 7.29571H62.894L55.1954 18.2169L62.894 29.4514H57.3886L54.0765 24.6174L52.1518 21.4395C51.4655 22.7226 50.824 23.7819 50.2272 24.6174L46.8703 29.4514H41.3649Z",
      fill: r
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M64.1371 18.3959C64.1371 15.1435 65.1069 12.4132 67.0464 10.205C69.0158 7.9671 71.5223 6.84812 74.5659 6.84812C75.9684 6.84812 77.2813 7.19127 78.5047 7.87758C79.758 8.56388 80.7725 9.53366 81.5483 10.7869V0H86.5166V29.4514H81.5483V26.005C80.7725 27.2582 79.7729 28.228 78.5495 28.9143C77.3261 29.5708 75.9982 29.899 74.5659 29.899C71.5223 29.899 69.0158 28.7949 67.0464 26.5868C65.1069 24.3489 64.1371 21.6186 64.1371 18.3959ZM70.9405 13.562C69.7767 14.8451 69.1949 16.4564 69.1949 18.3959C69.1949 20.3355 69.7767 21.9468 70.9405 23.2299C72.1042 24.4832 73.5962 25.1098 75.4164 25.1098C77.1769 25.1098 78.639 24.4832 79.8027 23.2299C80.9665 21.9767 81.5483 20.3653 81.5483 18.3959C81.5483 16.4564 80.9665 14.8451 79.8027 13.562C78.6688 12.2789 77.2067 11.6373 75.4164 11.6373C73.5962 11.6373 72.1042 12.2789 70.9405 13.562Z",
      fill: r
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M90.367 18.3959C90.367 15.2031 91.5158 12.4878 93.8134 10.2498C96.111 7.98202 98.8861 6.84812 102.139 6.84812C105.391 6.84812 108.166 7.98202 110.464 10.2498C112.761 12.4878 113.91 15.2031 113.91 18.3959C113.91 21.5589 112.761 24.2743 110.464 26.5421C108.166 28.78 105.391 29.899 102.139 29.899C98.8861 29.899 96.111 28.78 93.8134 26.5421C91.5158 24.2743 90.367 21.5589 90.367 18.3959ZM95.4247 18.3959C95.4247 20.2758 96.0812 21.8722 97.3941 23.1851C98.707 24.4682 100.289 25.1098 102.139 25.1098C103.989 25.1098 105.57 24.4682 106.883 23.1851C108.196 21.8722 108.852 20.2758 108.852 18.3959C108.852 16.5459 108.196 14.9644 106.883 13.6515C105.57 12.3087 103.989 11.6373 102.139 11.6373C100.289 11.6373 98.707 12.3087 97.3941 13.6515C96.0812 14.9644 95.4247 16.5459 95.4247 18.3959Z",
      fill: r
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M121.892 29.4962L114.596 7.29571H119.43L123.369 19.5597C123.548 20.0968 123.697 20.7085 123.817 21.3948C123.966 22.0811 124.07 22.648 124.13 23.0956L124.219 23.7223C124.369 22.1408 124.592 20.7682 124.891 19.6044L128.158 7.29571H133.037L136.304 19.6044C136.424 20.1117 136.543 20.7085 136.662 21.3948C136.782 22.0811 136.871 22.648 136.931 23.0956L136.976 23.7223C137.155 22.1408 137.438 20.7532 137.826 19.5597L141.765 7.29571H146.599L139.303 29.4962H134.827L131.381 17.1874L130.62 13.0696C130.411 14.7108 130.158 16.0834 129.859 17.1874L126.368 29.4962H121.892Z",
      fill: r
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M150.259 29.4514V7.29571H155.228V10.4736C156.839 8.05661 159.226 6.84812 162.389 6.84812C165.254 6.84812 167.298 7.71346 168.521 9.44414C169.744 11.145 170.356 13.5769 170.356 16.7399V29.4514H165.388V17.3665C165.388 15.3971 165.075 13.9499 164.448 13.0249C163.821 12.0998 162.628 11.6373 160.867 11.6373C159.226 11.6373 157.868 12.2192 156.794 13.3829C155.75 14.5467 155.228 16.0386 155.228 17.8588V29.4514H150.259Z",
      fill: r
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M38.1683 29.6202V16.4587C38.1683 10.5297 35.0121 7.08161 28.5334 7.08161C24.9618 7.08161 22.5946 7.83851 20.1858 8.9318L21.5563 13.0106C23.5498 12.1696 25.3771 11.623 27.8274 11.623C31.3159 11.623 33.2263 13.305 33.2263 16.3746V16.7951C31.5235 16.2484 29.8208 15.87 27.1629 15.87C22.0547 15.87 18.2755 18.2248 18.2755 23.1446V23.2287C18.2755 27.6859 21.9301 30.0827 26.0831 30.0827C29.4055 30.0827 31.6897 28.6951 33.1847 26.887V29.6202H38.1683ZM33.3093 21.5887C33.3093 24.364 30.8175 26.2562 27.4951 26.2562C25.1279 26.2562 23.2591 25.0788 23.2591 22.9764V22.8923C23.2591 20.7477 25.1279 19.4442 28.2842 19.4442C30.2361 19.4442 32.0219 19.8226 33.3093 20.3272V21.5887Z",
      fill: r
    }), /* @__PURE__ */ jsx$1("mask", {
      id: "mask0_5487_1903",
      maskUnits: "userSpaceOnUse",
      x: "176",
      y: "24",
      width: "8",
      height: "8",
      children: /* @__PURE__ */ jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M179.733 24.0561C181.724 24.0561 183.345 25.7277 183.345 27.7822C183.345 29.8367 181.724 31.5083 179.733 31.5083C177.741 31.5083 176.121 29.8367 176.121 27.7822C176.121 25.7277 177.741 24.0561 179.733 24.0561ZM179.732 24.6293C178.041 24.6293 176.676 26.0378 176.676 27.7821C176.676 29.5264 178.041 30.9349 179.732 30.9349C181.423 30.9349 182.789 29.5264 182.789 27.7821C182.789 26.0378 181.423 24.6293 179.732 24.6293ZM178.623 26.0625H180.038C180.287 26.0625 180.513 26.0927 180.68 26.1789C180.847 26.236 180.987 26.3245 181.071 26.4387C181.182 26.5529 181.234 26.6648 181.262 26.779C181.29 26.9223 181.314 27.041 181.314 27.1552C181.314 27.2694 181.29 27.4083 181.262 27.5225C181.234 27.6658 181.154 27.7855 181.071 27.8718C180.96 27.986 180.847 28.0654 180.68 28.1225C180.606 28.1483 180.521 28.1741 180.428 28.1942L181.236 29.5019H180.68L179.899 28.239H179.178V29.5019H178.623V26.0625ZM179.176 26.5192V27.7552H179.897C180.007 27.7552 180.117 27.7575 180.201 27.7284C180.284 27.6993 180.395 27.6679 180.478 27.6388C180.562 27.5817 180.623 27.5279 180.678 27.4418C180.734 27.3555 180.756 27.2335 180.756 27.1193C180.756 26.976 180.734 26.892 180.678 26.8058C180.65 26.7487 180.562 26.6927 180.478 26.6356C180.395 26.5785 180.311 26.5461 180.201 26.5461C180.09 26.5169 179.98 26.5192 179.897 26.5192H179.176Z",
        fill: "white"
      })
    }), /* @__PURE__ */ jsx$1("g", {
      mask: "url(#mask0_5487_1903)",
      children: /* @__PURE__ */ jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M176.118 31.5082H183.346V24.0561H176.118V31.5082Z",
        fill: t && BrandTextColor[t]
      })
    })]
  });
}, getIconMode = (t, r) => t === BrandMode.fullLigth && r ? BrandMode.light : t === BrandMode.fullDark && r ? BrandMode.dark : r ? BrandMode.default : BrandMode[t], Brand = ({
  withIcon: t = !0,
  withText: r = !0,
  mode: n
}) => /* @__PURE__ */ jsxs(FlexContainer$1, {
  children: [t && /* @__PURE__ */ jsx$1(FlexContainer$1, {
    mr: "fds_size_08",
    children: /* @__PURE__ */ jsx$1(BrandIcon, {
      mode: getIconMode(n, r)
    })
  }), r && /* @__PURE__ */ jsx$1(BrandText, {
    mode: n
  })]
}), Container$h = styled.div`
  display: grid;
  gap: ${({ gap: t, theme: { reference: r } }) => t && r[t]};
  column-gap: ${({ columnGap: t, theme: { reference: r } }) => t && r[t]};
  row-gap: ${({ rowGap: t, theme: { reference: r } }) => t && r[t]};
  align-items: ${({ alignContent: t }) => t};
  justify-items: ${({ justifyItems: t }) => t};
  align-content: ${({ alignItems: t }) => t};
  justify-content: ${({ justifyContent: t }) => t};
  grid-template-columns: ${({ columns: t }) => t};
  grid-template-rows: ${({ rows: t }) => t};
  grid-area: ${({ gridArea: t }) => t};
`, Grid$1 = ({
  children: t,
  columns: r,
  rows: n,
  ...a
}) => /* @__PURE__ */ jsx$1(Container$h, {
  columns: r,
  rows: n,
  ...a,
  children: t
}), Container$g = styled(Grid$1)`
  grid-gap: ${({ theme: { components: t }, spacing: r }) => t.bullets[`fds_c_bullets_spacing_${r}`]};
  max-width: ${({ maxWidth: t }) => `${t}px`};
  ${MarginsStyles};
`, BulletText = styled(Text$3)`
  width: 100%;
`, Bullets = ({
  bullets: t,
  spacing: r = Sizes$1.M,
  icon: n,
  columns: a = 1,
  maxWidth: s,
  ...o
}) => /* @__PURE__ */ jsx$1(Container$g, {
  columns: `repeat(${a},1fr)`,
  spacing: r,
  maxWidth: s,
  ...o,
  children: t.map(({
    text: c,
    extraText: l,
    buttonLabel: d,
    onClick: h
  }) => /* @__PURE__ */ jsxs(FlexContainer$1, {
    justify: "space-between",
    children: [/* @__PURE__ */ jsxs(FlexContainer$1, {
      gap: "dimension_08",
      align: "flex-start",
      children: [n && /* @__PURE__ */ jsx$1(Icon$4, {
        color: "default",
        icon: n.type,
        width: n.width,
        height: n.height
      }), /* @__PURE__ */ jsx$1(BulletText, {
        type: "paragraphs",
        color: "dark",
        size: "S_M_S",
        children: c
      })]
    }), (l || h) && /* @__PURE__ */ jsxs(FlexContainer$1, {
      gap: "dimension_08",
      align: "center",
      children: [l && /* @__PURE__ */ jsx$1(Text$3, {
        type: "paragraphs",
        color: "cold",
        size: "XS_L_S",
        children: l
      }), h && d && /* @__PURE__ */ jsx$1(Buttons.Contextual, {
        onClick: h,
        mode: "primary",
        label: d
      })]
    })]
  }, c))
});
function isObject$6(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function extend$4(t, r) {
  t === void 0 && (t = {}), r === void 0 && (r = {}), Object.keys(r).forEach((n) => {
    typeof t[n] > "u" ? t[n] = r[n] : isObject$6(r[n]) && isObject$6(t[n]) && Object.keys(r[n]).length > 0 && extend$4(t[n], r[n]);
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const t = typeof document < "u" ? document : {};
  return extend$4(t, ssrDocument), t;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function getWindow$2() {
  const t = typeof window < "u" ? window : {};
  return extend$4(t, ssrWindow), t;
}
function classesToTokens(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((r) => !!r.trim());
}
function deleteProps(t) {
  const r = t;
  Object.keys(r).forEach((n) => {
    try {
      r[n] = null;
    } catch {
    }
    try {
      delete r[n];
    } catch {
    }
  });
}
function nextTick(t, r) {
  return r === void 0 && (r = 0), setTimeout(t, r);
}
function now$1() {
  return Date.now();
}
function getComputedStyle$3(t) {
  const r = getWindow$2();
  let n;
  return r.getComputedStyle && (n = r.getComputedStyle(t, null)), !n && t.currentStyle && (n = t.currentStyle), n || (n = t.style), n;
}
function getTranslate(t, r) {
  r === void 0 && (r = "x");
  const n = getWindow$2();
  let a, s, o;
  const c = getComputedStyle$3(t);
  return n.WebKitCSSMatrix ? (s = c.transform || c.webkitTransform, s.split(",").length > 6 && (s = s.split(", ").map((l) => l.replace(",", ".")).join(", ")), o = new n.WebKitCSSMatrix(s === "none" ? "" : s)) : (o = c.MozTransform || c.OTransform || c.MsTransform || c.msTransform || c.transform || c.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), a = o.toString().split(",")), r === "x" && (n.WebKitCSSMatrix ? s = o.m41 : a.length === 16 ? s = parseFloat(a[12]) : s = parseFloat(a[4])), r === "y" && (n.WebKitCSSMatrix ? s = o.m42 : a.length === 16 ? s = parseFloat(a[13]) : s = parseFloat(a[5])), s || 0;
}
function isObject$5(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function isNode$2(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function extend$3() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), r = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const a = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (a != null && !isNode$2(a)) {
      const s = Object.keys(Object(a)).filter((o) => r.indexOf(o) < 0);
      for (let o = 0, c = s.length; o < c; o += 1) {
        const l = s[o], d = Object.getOwnPropertyDescriptor(a, l);
        d !== void 0 && d.enumerable && (isObject$5(t[l]) && isObject$5(a[l]) ? a[l].__swiper__ ? t[l] = a[l] : extend$3(t[l], a[l]) : !isObject$5(t[l]) && isObject$5(a[l]) ? (t[l] = {}, a[l].__swiper__ ? t[l] = a[l] : extend$3(t[l], a[l])) : t[l] = a[l]);
      }
    }
  }
  return t;
}
function setCSSProperty(t, r, n) {
  t.style.setProperty(r, n);
}
function animateCSSModeScroll(t) {
  let {
    swiper: r,
    targetPosition: n,
    side: a
  } = t;
  const s = getWindow$2(), o = -r.translate;
  let c = null, l;
  const d = r.params.speed;
  r.wrapperEl.style.scrollSnapType = "none", s.cancelAnimationFrame(r.cssModeFrameID);
  const h = n > o ? "next" : "prev", u = (m, g) => h === "next" && m >= g || h === "prev" && m <= g, p = () => {
    l = (/* @__PURE__ */ new Date()).getTime(), c === null && (c = l);
    const m = Math.max(Math.min((l - c) / d, 1), 0), g = 0.5 - Math.cos(m * Math.PI) / 2;
    let v = o + g * (n - o);
    if (u(v, n) && (v = n), r.wrapperEl.scrollTo({
      [a]: v
    }), u(v, n)) {
      r.wrapperEl.style.overflow = "hidden", r.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        r.wrapperEl.style.overflow = "", r.wrapperEl.scrollTo({
          [a]: v
        });
      }), s.cancelAnimationFrame(r.cssModeFrameID);
      return;
    }
    r.cssModeFrameID = s.requestAnimationFrame(p);
  };
  p();
}
function getSlideTransformEl(t) {
  return t.querySelector(".swiper-slide-transform") || t.shadowRoot && t.shadowRoot.querySelector(".swiper-slide-transform") || t;
}
function elementChildren(t, r) {
  r === void 0 && (r = "");
  const n = [...t.children];
  return t instanceof HTMLSlotElement && n.push(...t.assignedElements()), r ? n.filter((a) => a.matches(r)) : n;
}
function elementIsChildOf(t, r) {
  const n = r.contains(t);
  return !n && r instanceof HTMLSlotElement ? [...r.assignedElements()].includes(t) : n;
}
function showWarning(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function createElement(t, r) {
  r === void 0 && (r = []);
  const n = document.createElement(t);
  return n.classList.add(...Array.isArray(r) ? r : classesToTokens(r)), n;
}
function elementOffset(t) {
  const r = getWindow$2(), n = getDocument(), a = t.getBoundingClientRect(), s = n.body, o = t.clientTop || s.clientTop || 0, c = t.clientLeft || s.clientLeft || 0, l = t === r ? r.scrollY : t.scrollTop, d = t === r ? r.scrollX : t.scrollLeft;
  return {
    top: a.top + l - o,
    left: a.left + d - c
  };
}
function elementPrevAll(t, r) {
  const n = [];
  for (; t.previousElementSibling; ) {
    const a = t.previousElementSibling;
    r ? a.matches(r) && n.push(a) : n.push(a), t = a;
  }
  return n;
}
function elementNextAll(t, r) {
  const n = [];
  for (; t.nextElementSibling; ) {
    const a = t.nextElementSibling;
    r ? a.matches(r) && n.push(a) : n.push(a), t = a;
  }
  return n;
}
function elementStyle(t, r) {
  return getWindow$2().getComputedStyle(t, null).getPropertyValue(r);
}
function elementIndex(t) {
  let r = t, n;
  if (r) {
    for (n = 0; (r = r.previousSibling) !== null; )
      r.nodeType === 1 && (n += 1);
    return n;
  }
}
function elementParents(t, r) {
  const n = [];
  let a = t.parentElement;
  for (; a; )
    r ? a.matches(r) && n.push(a) : n.push(a), a = a.parentElement;
  return n;
}
function elementTransitionEnd(t, r) {
  function n(a) {
    a.target === t && (r.call(t, a), t.removeEventListener("transitionend", n));
  }
  r && t.addEventListener("transitionend", n);
}
function elementOuterSize(t, r, n) {
  const a = getWindow$2();
  return n ? t[r === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(a.getComputedStyle(t, null).getPropertyValue(r === "width" ? "margin-right" : "margin-top")) + parseFloat(a.getComputedStyle(t, null).getPropertyValue(r === "width" ? "margin-left" : "margin-bottom")) : t.offsetWidth;
}
function makeElementsArray(t) {
  return (Array.isArray(t) ? t : [t]).filter((r) => !!r);
}
function getRotateFix(t) {
  return (r) => Math.abs(r) > 0 && t.browser && t.browser.need3dFix && Math.abs(r) % 90 === 0 ? r + 1e-3 : r;
}
let support;
function calcSupport() {
  const t = getWindow$2(), r = getDocument();
  return {
    smoothScroll: r.documentElement && r.documentElement.style && "scrollBehavior" in r.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && r instanceof t.DocumentTouch)
  };
}
function getSupport() {
  return support || (support = calcSupport()), support;
}
let deviceCached;
function calcDevice(t) {
  let {
    userAgent: r
  } = t === void 0 ? {} : t;
  const n = getSupport(), a = getWindow$2(), s = a.navigator.platform, o = r || a.navigator.userAgent, c = {
    ios: !1,
    android: !1
  }, l = a.screen.width, d = a.screen.height, h = o.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = o.match(/(iPad).*OS\s([\d_]+)/);
  const p = o.match(/(iPod)(.*OS\s([\d_]+))?/), m = !u && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/), g = s === "Win32";
  let v = s === "MacIntel";
  const y = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && v && n.touch && y.indexOf(`${l}x${d}`) >= 0 && (u = o.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), v = !1), h && !g && (c.os = "android", c.android = !0), (u || m || p) && (c.os = "ios", c.ios = !0), c;
}
function getDevice(t) {
  return t === void 0 && (t = {}), deviceCached || (deviceCached = calcDevice(t)), deviceCached;
}
let browser$1;
function calcBrowser() {
  const t = getWindow$2(), r = getDevice();
  let n = !1;
  function a() {
    const l = t.navigator.userAgent.toLowerCase();
    return l.indexOf("safari") >= 0 && l.indexOf("chrome") < 0 && l.indexOf("android") < 0;
  }
  if (a()) {
    const l = String(t.navigator.userAgent);
    if (l.includes("Version/")) {
      const [d, h] = l.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      n = d < 16 || d === 16 && h < 2;
    }
  }
  const s = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), o = a(), c = o || s && r.ios;
  return {
    isSafari: n || o,
    needPerspectiveFix: n,
    need3dFix: c,
    isWebView: s
  };
}
function getBrowser() {
  return browser$1 || (browser$1 = calcBrowser()), browser$1;
}
function Resize(t) {
  let {
    swiper: r,
    on: n,
    emit: a
  } = t;
  const s = getWindow$2();
  let o = null, c = null;
  const l = () => {
    !r || r.destroyed || !r.initialized || (a("beforeResize"), a("resize"));
  }, d = () => {
    !r || r.destroyed || !r.initialized || (o = new ResizeObserver((p) => {
      c = s.requestAnimationFrame(() => {
        const {
          width: m,
          height: g
        } = r;
        let v = m, y = g;
        p.forEach((x) => {
          let {
            contentBoxSize: _,
            contentRect: $,
            target: b
          } = x;
          b && b !== r.el || (v = $ ? $.width : (_[0] || _).inlineSize, y = $ ? $.height : (_[0] || _).blockSize);
        }), (v !== m || y !== g) && l();
      });
    }), o.observe(r.el));
  }, h = () => {
    c && s.cancelAnimationFrame(c), o && o.unobserve && r.el && (o.unobserve(r.el), o = null);
  }, u = () => {
    !r || r.destroyed || !r.initialized || a("orientationchange");
  };
  n("init", () => {
    if (r.params.resizeObserver && typeof s.ResizeObserver < "u") {
      d();
      return;
    }
    s.addEventListener("resize", l), s.addEventListener("orientationchange", u);
  }), n("destroy", () => {
    h(), s.removeEventListener("resize", l), s.removeEventListener("orientationchange", u);
  });
}
function Observer(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  const o = [], c = getWindow$2(), l = function(u, p) {
    p === void 0 && (p = {});
    const m = c.MutationObserver || c.WebkitMutationObserver, g = new m((v) => {
      if (r.__preventObserver__)
        return;
      if (v.length === 1) {
        s("observerUpdate", v[0]);
        return;
      }
      const y = function() {
        s("observerUpdate", v[0]);
      };
      c.requestAnimationFrame ? c.requestAnimationFrame(y) : c.setTimeout(y, 0);
    });
    g.observe(u, {
      attributes: typeof p.attributes > "u" ? !0 : p.attributes,
      childList: r.isElement || (typeof p.childList > "u" ? !0 : p).childList,
      characterData: typeof p.characterData > "u" ? !0 : p.characterData
    }), o.push(g);
  }, d = () => {
    if (r.params.observer) {
      if (r.params.observeParents) {
        const u = elementParents(r.hostEl);
        for (let p = 0; p < u.length; p += 1)
          l(u[p]);
      }
      l(r.hostEl, {
        childList: r.params.observeSlideChildren
      }), l(r.wrapperEl, {
        attributes: !1
      });
    }
  }, h = () => {
    o.forEach((u) => {
      u.disconnect();
    }), o.splice(0, o.length);
  };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), a("init", d), a("destroy", h);
}
var eventsEmitter = {
  on(t, r, n) {
    const a = this;
    if (!a.eventsListeners || a.destroyed || typeof r != "function")
      return a;
    const s = n ? "unshift" : "push";
    return t.split(" ").forEach((o) => {
      a.eventsListeners[o] || (a.eventsListeners[o] = []), a.eventsListeners[o][s](r);
    }), a;
  },
  once(t, r, n) {
    const a = this;
    if (!a.eventsListeners || a.destroyed || typeof r != "function")
      return a;
    function s() {
      a.off(t, s), s.__emitterProxy && delete s.__emitterProxy;
      for (var o = arguments.length, c = new Array(o), l = 0; l < o; l++)
        c[l] = arguments[l];
      r.apply(a, c);
    }
    return s.__emitterProxy = r, a.on(t, s, n);
  },
  onAny(t, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function")
      return n;
    const a = r ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(t) < 0 && n.eventsAnyListeners[a](t), n;
  },
  offAny(t) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || !r.eventsAnyListeners)
      return r;
    const n = r.eventsAnyListeners.indexOf(t);
    return n >= 0 && r.eventsAnyListeners.splice(n, 1), r;
  },
  off(t, r) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || t.split(" ").forEach((a) => {
      typeof r > "u" ? n.eventsListeners[a] = [] : n.eventsListeners[a] && n.eventsListeners[a].forEach((s, o) => {
        (s === r || s.__emitterProxy && s.__emitterProxy === r) && n.eventsListeners[a].splice(o, 1);
      });
    }), n;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners)
      return t;
    let r, n, a;
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return typeof o[0] == "string" || Array.isArray(o[0]) ? (r = o[0], n = o.slice(1, o.length), a = t) : (r = o[0].events, n = o[0].data, a = o[0].context || t), n.unshift(a), (Array.isArray(r) ? r : r.split(" ")).forEach((d) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((h) => {
        h.apply(a, [d, ...n]);
      }), t.eventsListeners && t.eventsListeners[d] && t.eventsListeners[d].forEach((h) => {
        h.apply(a, n);
      });
    }), t;
  }
};
function updateSize() {
  const t = this;
  let r, n;
  const a = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? r = t.params.width : r = a.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? n = t.params.height : n = a.clientHeight, !(r === 0 && t.isHorizontal() || n === 0 && t.isVertical()) && (r = r - parseInt(elementStyle(a, "padding-left") || 0, 10) - parseInt(elementStyle(a, "padding-right") || 0, 10), n = n - parseInt(elementStyle(a, "padding-top") || 0, 10) - parseInt(elementStyle(a, "padding-bottom") || 0, 10), Number.isNaN(r) && (r = 0), Number.isNaN(n) && (n = 0), Object.assign(t, {
    width: r,
    height: n,
    size: t.isHorizontal() ? r : n
  }));
}
function updateSlides() {
  const t = this;
  function r(T, R) {
    return parseFloat(T.getPropertyValue(t.getDirectionLabel(R)) || 0);
  }
  const n = t.params, {
    wrapperEl: a,
    slidesEl: s,
    size: o,
    rtlTranslate: c,
    wrongRTL: l
  } = t, d = t.virtual && n.virtual.enabled, h = d ? t.virtual.slides.length : t.slides.length, u = elementChildren(s, `.${t.params.slideClass}, swiper-slide`), p = d ? t.virtual.slides.length : u.length;
  let m = [];
  const g = [], v = [];
  let y = n.slidesOffsetBefore;
  typeof y == "function" && (y = n.slidesOffsetBefore.call(t));
  let x = n.slidesOffsetAfter;
  typeof x == "function" && (x = n.slidesOffsetAfter.call(t));
  const _ = t.snapGrid.length, $ = t.slidesGrid.length;
  let b = n.spaceBetween, M = -y, C = 0, S = 0;
  if (typeof o > "u")
    return;
  typeof b == "string" && b.indexOf("%") >= 0 ? b = parseFloat(b.replace("%", "")) / 100 * o : typeof b == "string" && (b = parseFloat(b)), t.virtualSize = -b, u.forEach((T) => {
    c ? T.style.marginLeft = "" : T.style.marginRight = "", T.style.marginBottom = "", T.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (setCSSProperty(a, "--swiper-centered-offset-before", ""), setCSSProperty(a, "--swiper-centered-offset-after", ""));
  const A = n.grid && n.grid.rows > 1 && t.grid;
  A ? t.grid.initSlides(u) : t.grid && t.grid.unsetSlides();
  let D;
  const N = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((T) => typeof n.breakpoints[T].slidesPerView < "u").length > 0;
  for (let T = 0; T < p; T += 1) {
    D = 0;
    let R;
    if (u[T] && (R = u[T]), A && t.grid.updateSlide(T, R, u), !(u[T] && elementStyle(R, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        N && (u[T].style[t.getDirectionLabel("width")] = "");
        const F = getComputedStyle(R), z = R.style.transform, O = R.style.webkitTransform;
        if (z && (R.style.transform = "none"), O && (R.style.webkitTransform = "none"), n.roundLengths)
          D = t.isHorizontal() ? elementOuterSize(R, "width", !0) : elementOuterSize(R, "height", !0);
        else {
          const G = r(F, "width"), I = r(F, "padding-left"), k = r(F, "padding-right"), B = r(F, "margin-left"), L = r(F, "margin-right"), V = F.getPropertyValue("box-sizing");
          if (V && V === "border-box")
            D = G + B + L;
          else {
            const {
              clientWidth: U,
              offsetWidth: J
            } = R;
            D = G + I + k + B + L + (J - U);
          }
        }
        z && (R.style.transform = z), O && (R.style.webkitTransform = O), n.roundLengths && (D = Math.floor(D));
      } else
        D = (o - (n.slidesPerView - 1) * b) / n.slidesPerView, n.roundLengths && (D = Math.floor(D)), u[T] && (u[T].style[t.getDirectionLabel("width")] = `${D}px`);
      u[T] && (u[T].swiperSlideSize = D), v.push(D), n.centeredSlides ? (M = M + D / 2 + C / 2 + b, C === 0 && T !== 0 && (M = M - o / 2 - b), T === 0 && (M = M - o / 2 - b), Math.abs(M) < 1 / 1e3 && (M = 0), n.roundLengths && (M = Math.floor(M)), S % n.slidesPerGroup === 0 && m.push(M), g.push(M)) : (n.roundLengths && (M = Math.floor(M)), (S - Math.min(t.params.slidesPerGroupSkip, S)) % t.params.slidesPerGroup === 0 && m.push(M), g.push(M), M = M + D + b), t.virtualSize += D + b, C = D, S += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, o) + x, c && l && (n.effect === "slide" || n.effect === "coverflow") && (a.style.width = `${t.virtualSize + b}px`), n.setWrapperSize && (a.style[t.getDirectionLabel("width")] = `${t.virtualSize + b}px`), A && t.grid.updateWrapperSize(D, m), !n.centeredSlides) {
    const T = [];
    for (let R = 0; R < m.length; R += 1) {
      let F = m[R];
      n.roundLengths && (F = Math.floor(F)), m[R] <= t.virtualSize - o && T.push(F);
    }
    m = T, Math.floor(t.virtualSize - o) - Math.floor(m[m.length - 1]) > 1 && m.push(t.virtualSize - o);
  }
  if (d && n.loop) {
    const T = v[0] + b;
    if (n.slidesPerGroup > 1) {
      const R = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / n.slidesPerGroup), F = T * n.slidesPerGroup;
      for (let z = 0; z < R; z += 1)
        m.push(m[m.length - 1] + F);
    }
    for (let R = 0; R < t.virtual.slidesBefore + t.virtual.slidesAfter; R += 1)
      n.slidesPerGroup === 1 && m.push(m[m.length - 1] + T), g.push(g[g.length - 1] + T), t.virtualSize += T;
  }
  if (m.length === 0 && (m = [0]), b !== 0) {
    const T = t.isHorizontal() && c ? "marginLeft" : t.getDirectionLabel("marginRight");
    u.filter((R, F) => !n.cssMode || n.loop ? !0 : F !== u.length - 1).forEach((R) => {
      R.style[T] = `${b}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let T = 0;
    v.forEach((F) => {
      T += F + (b || 0);
    }), T -= b;
    const R = T - o;
    m = m.map((F) => F <= 0 ? -y : F > R ? R + x : F);
  }
  if (n.centerInsufficientSlides) {
    let T = 0;
    v.forEach((F) => {
      T += F + (b || 0);
    }), T -= b;
    const R = (n.slidesOffsetBefore || 0) + (n.slidesOffsetAfter || 0);
    if (T + R < o) {
      const F = (o - T - R) / 2;
      m.forEach((z, O) => {
        m[O] = z - F;
      }), g.forEach((z, O) => {
        g[O] = z + F;
      });
    }
  }
  if (Object.assign(t, {
    slides: u,
    snapGrid: m,
    slidesGrid: g,
    slidesSizesGrid: v
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    setCSSProperty(a, "--swiper-centered-offset-before", `${-m[0]}px`), setCSSProperty(a, "--swiper-centered-offset-after", `${t.size / 2 - v[v.length - 1] / 2}px`);
    const T = -t.snapGrid[0], R = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((F) => F + T), t.slidesGrid = t.slidesGrid.map((F) => F + R);
  }
  if (p !== h && t.emit("slidesLengthChange"), m.length !== _ && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), g.length !== $ && t.emit("slidesGridLengthChange"), n.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !d && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const T = `${n.containerModifierClass}backface-hidden`, R = t.el.classList.contains(T);
    p <= n.maxBackfaceHiddenSlides ? R || t.el.classList.add(T) : R && t.el.classList.remove(T);
  }
}
function updateAutoHeight(t) {
  const r = this, n = [], a = r.virtual && r.params.virtual.enabled;
  let s = 0, o;
  typeof t == "number" ? r.setTransition(t) : t === !0 && r.setTransition(r.params.speed);
  const c = (l) => a ? r.slides[r.getSlideIndexByData(l)] : r.slides[l];
  if (r.params.slidesPerView !== "auto" && r.params.slidesPerView > 1)
    if (r.params.centeredSlides)
      (r.visibleSlides || []).forEach((l) => {
        n.push(l);
      });
    else
      for (o = 0; o < Math.ceil(r.params.slidesPerView); o += 1) {
        const l = r.activeIndex + o;
        if (l > r.slides.length && !a)
          break;
        n.push(c(l));
      }
  else
    n.push(c(r.activeIndex));
  for (o = 0; o < n.length; o += 1)
    if (typeof n[o] < "u") {
      const l = n[o].offsetHeight;
      s = l > s ? l : s;
    }
  (s || s === 0) && (r.wrapperEl.style.height = `${s}px`);
}
function updateSlidesOffset() {
  const t = this, r = t.slides, n = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let a = 0; a < r.length; a += 1)
    r[a].swiperSlideOffset = (t.isHorizontal() ? r[a].offsetLeft : r[a].offsetTop) - n - t.cssOverflowAdjustment();
}
const toggleSlideClasses$1 = (t, r, n) => {
  r && !t.classList.contains(n) ? t.classList.add(n) : !r && t.classList.contains(n) && t.classList.remove(n);
};
function updateSlidesProgress(t) {
  t === void 0 && (t = this && this.translate || 0);
  const r = this, n = r.params, {
    slides: a,
    rtlTranslate: s,
    snapGrid: o
  } = r;
  if (a.length === 0)
    return;
  typeof a[0].swiperSlideOffset > "u" && r.updateSlidesOffset();
  let c = -t;
  s && (c = t), r.visibleSlidesIndexes = [], r.visibleSlides = [];
  let l = n.spaceBetween;
  typeof l == "string" && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * r.size : typeof l == "string" && (l = parseFloat(l));
  for (let d = 0; d < a.length; d += 1) {
    const h = a[d];
    let u = h.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (u -= a[0].swiperSlideOffset);
    const p = (c + (n.centeredSlides ? r.minTranslate() : 0) - u) / (h.swiperSlideSize + l), m = (c - o[0] + (n.centeredSlides ? r.minTranslate() : 0) - u) / (h.swiperSlideSize + l), g = -(c - u), v = g + r.slidesSizesGrid[d], y = g >= 0 && g <= r.size - r.slidesSizesGrid[d], x = g >= 0 && g < r.size - 1 || v > 1 && v <= r.size || g <= 0 && v >= r.size;
    x && (r.visibleSlides.push(h), r.visibleSlidesIndexes.push(d)), toggleSlideClasses$1(h, x, n.slideVisibleClass), toggleSlideClasses$1(h, y, n.slideFullyVisibleClass), h.progress = s ? -p : p, h.originalProgress = s ? -m : m;
  }
}
function updateProgress(t) {
  const r = this;
  if (typeof t > "u") {
    const u = r.rtlTranslate ? -1 : 1;
    t = r && r.translate && r.translate * u || 0;
  }
  const n = r.params, a = r.maxTranslate() - r.minTranslate();
  let {
    progress: s,
    isBeginning: o,
    isEnd: c,
    progressLoop: l
  } = r;
  const d = o, h = c;
  if (a === 0)
    s = 0, o = !0, c = !0;
  else {
    s = (t - r.minTranslate()) / a;
    const u = Math.abs(t - r.minTranslate()) < 1, p = Math.abs(t - r.maxTranslate()) < 1;
    o = u || s <= 0, c = p || s >= 1, u && (s = 0), p && (s = 1);
  }
  if (n.loop) {
    const u = r.getSlideIndexByData(0), p = r.getSlideIndexByData(r.slides.length - 1), m = r.slidesGrid[u], g = r.slidesGrid[p], v = r.slidesGrid[r.slidesGrid.length - 1], y = Math.abs(t);
    y >= m ? l = (y - m) / v : l = (y + v - g) / v, l > 1 && (l -= 1);
  }
  Object.assign(r, {
    progress: s,
    progressLoop: l,
    isBeginning: o,
    isEnd: c
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && r.updateSlidesProgress(t), o && !d && r.emit("reachBeginning toEdge"), c && !h && r.emit("reachEnd toEdge"), (d && !o || h && !c) && r.emit("fromEdge"), r.emit("progress", s);
}
const toggleSlideClasses = (t, r, n) => {
  r && !t.classList.contains(n) ? t.classList.add(n) : !r && t.classList.contains(n) && t.classList.remove(n);
};
function updateSlidesClasses() {
  const t = this, {
    slides: r,
    params: n,
    slidesEl: a,
    activeIndex: s
  } = t, o = t.virtual && n.virtual.enabled, c = t.grid && n.grid && n.grid.rows > 1, l = (p) => elementChildren(a, `.${n.slideClass}${p}, swiper-slide${p}`)[0];
  let d, h, u;
  if (o)
    if (n.loop) {
      let p = s - t.virtual.slidesBefore;
      p < 0 && (p = t.virtual.slides.length + p), p >= t.virtual.slides.length && (p -= t.virtual.slides.length), d = l(`[data-swiper-slide-index="${p}"]`);
    } else
      d = l(`[data-swiper-slide-index="${s}"]`);
  else
    c ? (d = r.filter((p) => p.column === s)[0], u = r.filter((p) => p.column === s + 1)[0], h = r.filter((p) => p.column === s - 1)[0]) : d = r[s];
  d && (c || (u = elementNextAll(d, `.${n.slideClass}, swiper-slide`)[0], n.loop && !u && (u = r[0]), h = elementPrevAll(d, `.${n.slideClass}, swiper-slide`)[0], n.loop && !h === 0 && (h = r[r.length - 1]))), r.forEach((p) => {
    toggleSlideClasses(p, p === d, n.slideActiveClass), toggleSlideClasses(p, p === u, n.slideNextClass), toggleSlideClasses(p, p === h, n.slidePrevClass);
  }), t.emitSlidesClasses();
}
const processLazyPreloader = (t, r) => {
  if (!t || t.destroyed || !t.params)
    return;
  const n = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, a = r.closest(n());
  if (a) {
    let s = a.querySelector(`.${t.params.lazyPreloaderClass}`);
    !s && t.isElement && (a.shadowRoot ? s = a.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      a.shadowRoot && (s = a.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), s && s.remove());
    })), s && s.remove();
  }
}, unlazy = (t, r) => {
  if (!t.slides[r])
    return;
  const n = t.slides[r].querySelector('[loading="lazy"]');
  n && n.removeAttribute("loading");
}, preload = (t) => {
  if (!t || t.destroyed || !t.params)
    return;
  let r = t.params.lazyPreloadPrevNext;
  const n = t.slides.length;
  if (!n || !r || r < 0)
    return;
  r = Math.min(r, n);
  const a = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), s = t.activeIndex;
  if (t.params.grid && t.params.grid.rows > 1) {
    const c = s, l = [c - r];
    l.push(...Array.from({
      length: r
    }).map((d, h) => c + a + h)), t.slides.forEach((d, h) => {
      l.includes(d.column) && unlazy(t, h);
    });
    return;
  }
  const o = s + a - 1;
  if (t.params.rewind || t.params.loop)
    for (let c = s - r; c <= o + r; c += 1) {
      const l = (c % n + n) % n;
      (l < s || l > o) && unlazy(t, l);
    }
  else
    for (let c = Math.max(s - r, 0); c <= Math.min(o + r, n - 1); c += 1)
      c !== s && (c > o || c < s) && unlazy(t, c);
};
function getActiveIndexByTranslate(t) {
  const {
    slidesGrid: r,
    params: n
  } = t, a = t.rtlTranslate ? t.translate : -t.translate;
  let s;
  for (let o = 0; o < r.length; o += 1)
    typeof r[o + 1] < "u" ? a >= r[o] && a < r[o + 1] - (r[o + 1] - r[o]) / 2 ? s = o : a >= r[o] && a < r[o + 1] && (s = o + 1) : a >= r[o] && (s = o);
  return n.normalizeSlideIndex && (s < 0 || typeof s > "u") && (s = 0), s;
}
function updateActiveIndex(t) {
  const r = this, n = r.rtlTranslate ? r.translate : -r.translate, {
    snapGrid: a,
    params: s,
    activeIndex: o,
    realIndex: c,
    snapIndex: l
  } = r;
  let d = t, h;
  const u = (g) => {
    let v = g - r.virtual.slidesBefore;
    return v < 0 && (v = r.virtual.slides.length + v), v >= r.virtual.slides.length && (v -= r.virtual.slides.length), v;
  };
  if (typeof d > "u" && (d = getActiveIndexByTranslate(r)), a.indexOf(n) >= 0)
    h = a.indexOf(n);
  else {
    const g = Math.min(s.slidesPerGroupSkip, d);
    h = g + Math.floor((d - g) / s.slidesPerGroup);
  }
  if (h >= a.length && (h = a.length - 1), d === o && !r.params.loop) {
    h !== l && (r.snapIndex = h, r.emit("snapIndexChange"));
    return;
  }
  if (d === o && r.params.loop && r.virtual && r.params.virtual.enabled) {
    r.realIndex = u(d);
    return;
  }
  const p = r.grid && s.grid && s.grid.rows > 1;
  let m;
  if (r.virtual && s.virtual.enabled && s.loop)
    m = u(d);
  else if (p) {
    const g = r.slides.filter((y) => y.column === d)[0];
    let v = parseInt(g.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(v) && (v = Math.max(r.slides.indexOf(g), 0)), m = Math.floor(v / s.grid.rows);
  } else if (r.slides[d]) {
    const g = r.slides[d].getAttribute("data-swiper-slide-index");
    g ? m = parseInt(g, 10) : m = d;
  } else
    m = d;
  Object.assign(r, {
    previousSnapIndex: l,
    snapIndex: h,
    previousRealIndex: c,
    realIndex: m,
    previousIndex: o,
    activeIndex: d
  }), r.initialized && preload(r), r.emit("activeIndexChange"), r.emit("snapIndexChange"), (r.initialized || r.params.runCallbacksOnInit) && (c !== m && r.emit("realIndexChange"), r.emit("slideChange"));
}
function updateClickedSlide(t, r) {
  const n = this, a = n.params;
  let s = t.closest(`.${a.slideClass}, swiper-slide`);
  !s && n.isElement && r && r.length > 1 && r.includes(t) && [...r.slice(r.indexOf(t) + 1, r.length)].forEach((l) => {
    !s && l.matches && l.matches(`.${a.slideClass}, swiper-slide`) && (s = l);
  });
  let o = !1, c;
  if (s) {
    for (let l = 0; l < n.slides.length; l += 1)
      if (n.slides[l] === s) {
        o = !0, c = l;
        break;
      }
  }
  if (s && o)
    n.clickedSlide = s, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(s.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = c;
  else {
    n.clickedSlide = void 0, n.clickedIndex = void 0;
    return;
  }
  a.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const r = this, {
    params: n,
    rtlTranslate: a,
    translate: s,
    wrapperEl: o
  } = r;
  if (n.virtualTranslate)
    return a ? -s : s;
  if (n.cssMode)
    return s;
  let c = getTranslate(o, t);
  return c += r.cssOverflowAdjustment(), a && (c = -c), c || 0;
}
function setTranslate(t, r) {
  const n = this, {
    rtlTranslate: a,
    params: s,
    wrapperEl: o,
    progress: c
  } = n;
  let l = 0, d = 0;
  const h = 0;
  n.isHorizontal() ? l = a ? -t : t : d = t, s.roundLengths && (l = Math.floor(l), d = Math.floor(d)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? l : d, s.cssMode ? o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -d : s.virtualTranslate || (n.isHorizontal() ? l -= n.cssOverflowAdjustment() : d -= n.cssOverflowAdjustment(), o.style.transform = `translate3d(${l}px, ${d}px, ${h}px)`);
  let u;
  const p = n.maxTranslate() - n.minTranslate();
  p === 0 ? u = 0 : u = (t - n.minTranslate()) / p, u !== c && n.updateProgress(t), n.emit("setTranslate", n.translate, r);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(t, r, n, a, s) {
  t === void 0 && (t = 0), r === void 0 && (r = this.params.speed), n === void 0 && (n = !0), a === void 0 && (a = !0);
  const o = this, {
    params: c,
    wrapperEl: l
  } = o;
  if (o.animating && c.preventInteractionOnTransition)
    return !1;
  const d = o.minTranslate(), h = o.maxTranslate();
  let u;
  if (a && t > d ? u = d : a && t < h ? u = h : u = t, o.updateProgress(u), c.cssMode) {
    const p = o.isHorizontal();
    if (r === 0)
      l[p ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!o.support.smoothScroll)
        return animateCSSModeScroll({
          swiper: o,
          targetPosition: -u,
          side: p ? "left" : "top"
        }), !0;
      l.scrollTo({
        [p ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return r === 0 ? (o.setTransition(0), o.setTranslate(u), n && (o.emit("beforeTransitionStart", r, s), o.emit("transitionEnd"))) : (o.setTransition(r), o.setTranslate(u), n && (o.emit("beforeTransitionStart", r, s), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(m) {
    !o || o.destroyed || m.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = !1, n && o.emit("transitionEnd"));
  }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), !0;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(t, r) {
  const n = this;
  n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${t}ms`, n.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), n.emit("setTransition", t, r);
}
function transitionEmit(t) {
  let {
    swiper: r,
    runCallbacks: n,
    direction: a,
    step: s
  } = t;
  const {
    activeIndex: o,
    previousIndex: c
  } = r;
  let l = a;
  if (l || (o > c ? l = "next" : o < c ? l = "prev" : l = "reset"), r.emit(`transition${s}`), n && o !== c) {
    if (l === "reset") {
      r.emit(`slideResetTransition${s}`);
      return;
    }
    r.emit(`slideChangeTransition${s}`), l === "next" ? r.emit(`slideNextTransition${s}`) : r.emit(`slidePrevTransition${s}`);
  }
}
function transitionStart(t, r) {
  t === void 0 && (t = !0);
  const n = this, {
    params: a
  } = n;
  a.cssMode || (a.autoHeight && n.updateAutoHeight(), transitionEmit({
    swiper: n,
    runCallbacks: t,
    direction: r,
    step: "Start"
  }));
}
function transitionEnd(t, r) {
  t === void 0 && (t = !0);
  const n = this, {
    params: a
  } = n;
  n.animating = !1, !a.cssMode && (n.setTransition(0), transitionEmit({
    swiper: n,
    runCallbacks: t,
    direction: r,
    step: "End"
  }));
}
var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(t, r, n, a, s) {
  t === void 0 && (t = 0), n === void 0 && (n = !0), typeof t == "string" && (t = parseInt(t, 10));
  const o = this;
  let c = t;
  c < 0 && (c = 0);
  const {
    params: l,
    snapGrid: d,
    slidesGrid: h,
    previousIndex: u,
    activeIndex: p,
    rtlTranslate: m,
    wrapperEl: g,
    enabled: v
  } = o;
  if (!v && !a && !s || o.destroyed || o.animating && l.preventInteractionOnTransition)
    return !1;
  typeof r > "u" && (r = o.params.speed);
  const y = Math.min(o.params.slidesPerGroupSkip, c);
  let x = y + Math.floor((c - y) / o.params.slidesPerGroup);
  x >= d.length && (x = d.length - 1);
  const _ = -d[x];
  if (l.normalizeSlideIndex)
    for (let b = 0; b < h.length; b += 1) {
      const M = -Math.floor(_ * 100), C = Math.floor(h[b] * 100), S = Math.floor(h[b + 1] * 100);
      typeof h[b + 1] < "u" ? M >= C && M < S - (S - C) / 2 ? c = b : M >= C && M < S && (c = b + 1) : M >= C && (c = b);
    }
  if (o.initialized && c !== p && (!o.allowSlideNext && (m ? _ > o.translate && _ > o.minTranslate() : _ < o.translate && _ < o.minTranslate()) || !o.allowSlidePrev && _ > o.translate && _ > o.maxTranslate() && (p || 0) !== c))
    return !1;
  c !== (u || 0) && n && o.emit("beforeSlideChangeStart"), o.updateProgress(_);
  let $;
  if (c > p ? $ = "next" : c < p ? $ = "prev" : $ = "reset", m && -_ === o.translate || !m && _ === o.translate)
    return o.updateActiveIndex(c), l.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), l.effect !== "slide" && o.setTranslate(_), $ !== "reset" && (o.transitionStart(n, $), o.transitionEnd(n, $)), !1;
  if (l.cssMode) {
    const b = o.isHorizontal(), M = m ? _ : -_;
    if (r === 0) {
      const C = o.virtual && o.params.virtual.enabled;
      C && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), C && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[b ? "scrollLeft" : "scrollTop"] = M;
      })) : g[b ? "scrollLeft" : "scrollTop"] = M, C && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = !1;
      });
    } else {
      if (!o.support.smoothScroll)
        return animateCSSModeScroll({
          swiper: o,
          targetPosition: M,
          side: b ? "left" : "top"
        }), !0;
      g.scrollTo({
        [b ? "left" : "top"]: M,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return o.setTransition(r), o.setTranslate(_), o.updateActiveIndex(c), o.updateSlidesClasses(), o.emit("beforeTransitionStart", r, a), o.transitionStart(n, $), r === 0 ? o.transitionEnd(n, $) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(M) {
    !o || o.destroyed || M.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(n, $));
  }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), !0;
}
function slideToLoop(t, r, n, a) {
  t === void 0 && (t = 0), n === void 0 && (n = !0), typeof t == "string" && (t = parseInt(t, 10));
  const s = this;
  if (s.destroyed)
    return;
  typeof r > "u" && (r = s.params.speed);
  const o = s.grid && s.params.grid && s.params.grid.rows > 1;
  let c = t;
  if (s.params.loop)
    if (s.virtual && s.params.virtual.enabled)
      c = c + s.virtual.slidesBefore;
    else {
      let l;
      if (o) {
        const m = c * s.params.grid.rows;
        l = s.slides.filter((g) => g.getAttribute("data-swiper-slide-index") * 1 === m)[0].column;
      } else
        l = s.getSlideIndexByData(c);
      const d = o ? Math.ceil(s.slides.length / s.params.grid.rows) : s.slides.length, {
        centeredSlides: h
      } = s.params;
      let u = s.params.slidesPerView;
      u === "auto" ? u = s.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(s.params.slidesPerView, 10)), h && u % 2 === 0 && (u = u + 1));
      let p = d - l < u;
      if (h && (p = p || l < Math.ceil(u / 2)), a && h && s.params.slidesPerView !== "auto" && !o && (p = !1), p) {
        const m = h ? l < s.activeIndex ? "prev" : "next" : l - s.activeIndex - 1 < s.params.slidesPerView ? "next" : "prev";
        s.loopFix({
          direction: m,
          slideTo: !0,
          activeSlideIndex: m === "next" ? l + 1 : l - d + 1,
          slideRealIndex: m === "next" ? s.realIndex : void 0
        });
      }
      if (o) {
        const m = c * s.params.grid.rows;
        c = s.slides.filter((g) => g.getAttribute("data-swiper-slide-index") * 1 === m)[0].column;
      } else
        c = s.getSlideIndexByData(c);
    }
  return requestAnimationFrame(() => {
    s.slideTo(c, r, n, a);
  }), s;
}
function slideNext(t, r, n) {
  r === void 0 && (r = !0);
  const a = this, {
    enabled: s,
    params: o,
    animating: c
  } = a;
  if (!s || a.destroyed)
    return a;
  typeof t > "u" && (t = a.params.speed);
  let l = o.slidesPerGroup;
  o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (l = Math.max(a.slidesPerViewDynamic("current", !0), 1));
  const d = a.activeIndex < o.slidesPerGroupSkip ? 1 : l, h = a.virtual && o.virtual.enabled;
  if (o.loop) {
    if (c && !h && o.loopPreventsSliding)
      return !1;
    if (a.loopFix({
      direction: "next"
    }), a._clientLeft = a.wrapperEl.clientLeft, a.activeIndex === a.slides.length - 1 && o.cssMode)
      return requestAnimationFrame(() => {
        a.slideTo(a.activeIndex + d, t, r, n);
      }), !0;
  }
  return o.rewind && a.isEnd ? a.slideTo(0, t, r, n) : a.slideTo(a.activeIndex + d, t, r, n);
}
function slidePrev(t, r, n) {
  r === void 0 && (r = !0);
  const a = this, {
    params: s,
    snapGrid: o,
    slidesGrid: c,
    rtlTranslate: l,
    enabled: d,
    animating: h
  } = a;
  if (!d || a.destroyed)
    return a;
  typeof t > "u" && (t = a.params.speed);
  const u = a.virtual && s.virtual.enabled;
  if (s.loop) {
    if (h && !u && s.loopPreventsSliding)
      return !1;
    a.loopFix({
      direction: "prev"
    }), a._clientLeft = a.wrapperEl.clientLeft;
  }
  const p = l ? a.translate : -a.translate;
  function m(_) {
    return _ < 0 ? -Math.floor(Math.abs(_)) : Math.floor(_);
  }
  const g = m(p), v = o.map((_) => m(_));
  let y = o[v.indexOf(g) - 1];
  if (typeof y > "u" && s.cssMode) {
    let _;
    o.forEach(($, b) => {
      g >= $ && (_ = b);
    }), typeof _ < "u" && (y = o[_ > 0 ? _ - 1 : _]);
  }
  let x = 0;
  if (typeof y < "u" && (x = c.indexOf(y), x < 0 && (x = a.activeIndex - 1), s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (x = x - a.slidesPerViewDynamic("previous", !0) + 1, x = Math.max(x, 0))), s.rewind && a.isBeginning) {
    const _ = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1;
    return a.slideTo(_, t, r, n);
  } else if (s.loop && a.activeIndex === 0 && s.cssMode)
    return requestAnimationFrame(() => {
      a.slideTo(x, t, r, n);
    }), !0;
  return a.slideTo(x, t, r, n);
}
function slideReset(t, r, n) {
  r === void 0 && (r = !0);
  const a = this;
  if (!a.destroyed)
    return typeof t > "u" && (t = a.params.speed), a.slideTo(a.activeIndex, t, r, n);
}
function slideToClosest(t, r, n, a) {
  r === void 0 && (r = !0), a === void 0 && (a = 0.5);
  const s = this;
  if (s.destroyed)
    return;
  typeof t > "u" && (t = s.params.speed);
  let o = s.activeIndex;
  const c = Math.min(s.params.slidesPerGroupSkip, o), l = c + Math.floor((o - c) / s.params.slidesPerGroup), d = s.rtlTranslate ? s.translate : -s.translate;
  if (d >= s.snapGrid[l]) {
    const h = s.snapGrid[l], u = s.snapGrid[l + 1];
    d - h > (u - h) * a && (o += s.params.slidesPerGroup);
  } else {
    const h = s.snapGrid[l - 1], u = s.snapGrid[l];
    d - h <= (u - h) * a && (o -= s.params.slidesPerGroup);
  }
  return o = Math.max(o, 0), o = Math.min(o, s.slidesGrid.length - 1), s.slideTo(o, t, r, n);
}
function slideToClickedSlide() {
  const t = this;
  if (t.destroyed)
    return;
  const {
    params: r,
    slidesEl: n
  } = t, a = r.slidesPerView === "auto" ? t.slidesPerViewDynamic() : r.slidesPerView;
  let s = t.clickedIndex, o;
  const c = t.isElement ? "swiper-slide" : `.${r.slideClass}`;
  if (r.loop) {
    if (t.animating)
      return;
    o = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), r.centeredSlides ? s < t.loopedSlides - a / 2 || s > t.slides.length - t.loopedSlides + a / 2 ? (t.loopFix(), s = t.getSlideIndex(elementChildren(n, `${c}[data-swiper-slide-index="${o}"]`)[0]), nextTick(() => {
      t.slideTo(s);
    })) : t.slideTo(s) : s > t.slides.length - a ? (t.loopFix(), s = t.getSlideIndex(elementChildren(n, `${c}[data-swiper-slide-index="${o}"]`)[0]), nextTick(() => {
      t.slideTo(s);
    })) : t.slideTo(s);
  } else
    t.slideTo(s);
}
var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(t) {
  const r = this, {
    params: n,
    slidesEl: a
  } = r;
  if (!n.loop || r.virtual && r.params.virtual.enabled)
    return;
  const s = () => {
    elementChildren(a, `.${n.slideClass}, swiper-slide`).forEach((p, m) => {
      p.setAttribute("data-swiper-slide-index", m);
    });
  }, o = r.grid && n.grid && n.grid.rows > 1, c = n.slidesPerGroup * (o ? n.grid.rows : 1), l = r.slides.length % c !== 0, d = o && r.slides.length % n.grid.rows !== 0, h = (u) => {
    for (let p = 0; p < u; p += 1) {
      const m = r.isElement ? createElement("swiper-slide", [n.slideBlankClass]) : createElement("div", [n.slideClass, n.slideBlankClass]);
      r.slidesEl.append(m);
    }
  };
  if (l) {
    if (n.loopAddBlankSlides) {
      const u = c - r.slides.length % c;
      h(u), r.recalcSlides(), r.updateSlides();
    } else
      showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else if (d) {
    if (n.loopAddBlankSlides) {
      const u = n.grid.rows - r.slides.length % n.grid.rows;
      h(u), r.recalcSlides(), r.updateSlides();
    } else
      showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else
    s();
  r.loopFix({
    slideRealIndex: t,
    direction: n.centeredSlides ? void 0 : "next"
  });
}
function loopFix(t) {
  let {
    slideRealIndex: r,
    slideTo: n = !0,
    direction: a,
    setTranslate: s,
    activeSlideIndex: o,
    byController: c,
    byMousewheel: l
  } = t === void 0 ? {} : t;
  const d = this;
  if (!d.params.loop)
    return;
  d.emit("beforeLoopFix");
  const {
    slides: h,
    allowSlidePrev: u,
    allowSlideNext: p,
    slidesEl: m,
    params: g
  } = d, {
    centeredSlides: v
  } = g;
  if (d.allowSlidePrev = !0, d.allowSlideNext = !0, d.virtual && g.virtual.enabled) {
    n && (!g.centeredSlides && d.snapIndex === 0 ? d.slideTo(d.virtual.slides.length, 0, !1, !0) : g.centeredSlides && d.snapIndex < g.slidesPerView ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, !1, !0) : d.snapIndex === d.snapGrid.length - 1 && d.slideTo(d.virtual.slidesBefore, 0, !1, !0)), d.allowSlidePrev = u, d.allowSlideNext = p, d.emit("loopFix");
    return;
  }
  let y = g.slidesPerView;
  y === "auto" ? y = d.slidesPerViewDynamic() : (y = Math.ceil(parseFloat(g.slidesPerView, 10)), v && y % 2 === 0 && (y = y + 1));
  const x = g.slidesPerGroupAuto ? y : g.slidesPerGroup;
  let _ = x;
  _ % x !== 0 && (_ += x - _ % x), _ += g.loopAdditionalSlides, d.loopedSlides = _;
  const $ = d.grid && g.grid && g.grid.rows > 1;
  h.length < y + _ ? showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : $ && g.grid.fill === "row" && showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const b = [], M = [];
  let C = d.activeIndex;
  typeof o > "u" ? o = d.getSlideIndex(h.filter((z) => z.classList.contains(g.slideActiveClass))[0]) : C = o;
  const S = a === "next" || !a, A = a === "prev" || !a;
  let D = 0, N = 0;
  const T = $ ? Math.ceil(h.length / g.grid.rows) : h.length, F = ($ ? h[o].column : o) + (v && typeof s > "u" ? -y / 2 + 0.5 : 0);
  if (F < _) {
    D = Math.max(_ - F, x);
    for (let z = 0; z < _ - F; z += 1) {
      const O = z - Math.floor(z / T) * T;
      if ($) {
        const G = T - O - 1;
        for (let I = h.length - 1; I >= 0; I -= 1)
          h[I].column === G && b.push(I);
      } else
        b.push(T - O - 1);
    }
  } else if (F + y > T - _) {
    N = Math.max(F - (T - _ * 2), x);
    for (let z = 0; z < N; z += 1) {
      const O = z - Math.floor(z / T) * T;
      $ ? h.forEach((G, I) => {
        G.column === O && M.push(I);
      }) : M.push(O);
    }
  }
  if (d.__preventObserver__ = !0, requestAnimationFrame(() => {
    d.__preventObserver__ = !1;
  }), A && b.forEach((z) => {
    h[z].swiperLoopMoveDOM = !0, m.prepend(h[z]), h[z].swiperLoopMoveDOM = !1;
  }), S && M.forEach((z) => {
    h[z].swiperLoopMoveDOM = !0, m.append(h[z]), h[z].swiperLoopMoveDOM = !1;
  }), d.recalcSlides(), g.slidesPerView === "auto" ? d.updateSlides() : $ && (b.length > 0 && A || M.length > 0 && S) && d.slides.forEach((z, O) => {
    d.grid.updateSlide(O, z, d.slides);
  }), g.watchSlidesProgress && d.updateSlidesOffset(), n) {
    if (b.length > 0 && A) {
      if (typeof r > "u") {
        const z = d.slidesGrid[C], G = d.slidesGrid[C + D] - z;
        l ? d.setTranslate(d.translate - G) : (d.slideTo(C + Math.ceil(D), 0, !1, !0), s && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - G, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - G));
      } else if (s) {
        const z = $ ? b.length / g.grid.rows : b.length;
        d.slideTo(d.activeIndex + z, 0, !1, !0), d.touchEventsData.currentTranslate = d.translate;
      }
    } else if (M.length > 0 && S)
      if (typeof r > "u") {
        const z = d.slidesGrid[C], G = d.slidesGrid[C - N] - z;
        l ? d.setTranslate(d.translate - G) : (d.slideTo(C - N, 0, !1, !0), s && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - G, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - G));
      } else {
        const z = $ ? M.length / g.grid.rows : M.length;
        d.slideTo(d.activeIndex - z, 0, !1, !0);
      }
  }
  if (d.allowSlidePrev = u, d.allowSlideNext = p, d.controller && d.controller.control && !c) {
    const z = {
      slideRealIndex: r,
      direction: a,
      setTranslate: s,
      activeSlideIndex: o,
      byController: !0
    };
    Array.isArray(d.controller.control) ? d.controller.control.forEach((O) => {
      !O.destroyed && O.params.loop && O.loopFix({
        ...z,
        slideTo: O.params.slidesPerView === g.slidesPerView ? n : !1
      });
    }) : d.controller.control instanceof d.constructor && d.controller.control.params.loop && d.controller.control.loopFix({
      ...z,
      slideTo: d.controller.control.params.slidesPerView === g.slidesPerView ? n : !1
    });
  }
  d.emit("loopFix");
}
function loopDestroy() {
  const t = this, {
    params: r,
    slidesEl: n
  } = t;
  if (!r.loop || t.virtual && t.params.virtual.enabled)
    return;
  t.recalcSlides();
  const a = [];
  t.slides.forEach((s) => {
    const o = typeof s.swiperSlideIndex > "u" ? s.getAttribute("data-swiper-slide-index") * 1 : s.swiperSlideIndex;
    a[o] = s;
  }), t.slides.forEach((s) => {
    s.removeAttribute("data-swiper-slide-index");
  }), a.forEach((s) => {
    n.append(s);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(t) {
  const r = this;
  if (!r.params.simulateTouch || r.params.watchOverflow && r.isLocked || r.params.cssMode)
    return;
  const n = r.params.touchEventsTarget === "container" ? r.el : r.wrapperEl;
  r.isElement && (r.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = t ? "grabbing" : "grab", r.isElement && requestAnimationFrame(() => {
    r.__preventObserver__ = !1;
  });
}
function unsetGrabCursor() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(t, r) {
  r === void 0 && (r = this);
  function n(a) {
    if (!a || a === getDocument() || a === getWindow$2())
      return null;
    a.assignedSlot && (a = a.assignedSlot);
    const s = a.closest(t);
    return !s && !a.getRootNode ? null : s || n(a.getRootNode().host);
  }
  return n(r);
}
function preventEdgeSwipe(t, r, n) {
  const a = getWindow$2(), {
    params: s
  } = t, o = s.edgeSwipeDetection, c = s.edgeSwipeThreshold;
  return o && (n <= c || n >= a.innerWidth - c) ? o === "prevent" ? (r.preventDefault(), !0) : !1 : !0;
}
function onTouchStart(t) {
  const r = this, n = getDocument();
  let a = t;
  a.originalEvent && (a = a.originalEvent);
  const s = r.touchEventsData;
  if (a.type === "pointerdown") {
    if (s.pointerId !== null && s.pointerId !== a.pointerId)
      return;
    s.pointerId = a.pointerId;
  } else
    a.type === "touchstart" && a.targetTouches.length === 1 && (s.touchId = a.targetTouches[0].identifier);
  if (a.type === "touchstart") {
    preventEdgeSwipe(r, a, a.targetTouches[0].pageX);
    return;
  }
  const {
    params: o,
    touches: c,
    enabled: l
  } = r;
  if (!l || !o.simulateTouch && a.pointerType === "mouse" || r.animating && o.preventInteractionOnTransition)
    return;
  !r.animating && o.cssMode && o.loop && r.loopFix();
  let d = a.target;
  if (o.touchEventsTarget === "wrapper" && !elementIsChildOf(d, r.wrapperEl) || "which" in a && a.which === 3 || "button" in a && a.button > 0 || s.isTouched && s.isMoved)
    return;
  const h = !!o.noSwipingClass && o.noSwipingClass !== "", u = a.composedPath ? a.composedPath() : a.path;
  h && a.target && a.target.shadowRoot && u && (d = u[0]);
  const p = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, m = !!(a.target && a.target.shadowRoot);
  if (o.noSwiping && (m ? closestElement(p, d) : d.closest(p))) {
    r.allowClick = !0;
    return;
  }
  if (o.swipeHandler && !d.closest(o.swipeHandler))
    return;
  c.currentX = a.pageX, c.currentY = a.pageY;
  const g = c.currentX, v = c.currentY;
  if (!preventEdgeSwipe(r, a, g))
    return;
  Object.assign(s, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), c.startX = g, c.startY = v, s.touchStartTime = now$1(), r.allowClick = !0, r.updateSize(), r.swipeDirection = void 0, o.threshold > 0 && (s.allowThresholdMove = !1);
  let y = !0;
  d.matches(s.focusableElements) && (y = !1, d.nodeName === "SELECT" && (s.isTouched = !1)), n.activeElement && n.activeElement.matches(s.focusableElements) && n.activeElement !== d && n.activeElement.blur();
  const x = y && r.allowTouchMove && o.touchStartPreventDefault;
  (o.touchStartForcePreventDefault || x) && !d.isContentEditable && a.preventDefault(), o.freeMode && o.freeMode.enabled && r.freeMode && r.animating && !o.cssMode && r.freeMode.onTouchStart(), r.emit("touchStart", a);
}
function onTouchMove(t) {
  const r = getDocument(), n = this, a = n.touchEventsData, {
    params: s,
    touches: o,
    rtlTranslate: c,
    enabled: l
  } = n;
  if (!l || !s.simulateTouch && t.pointerType === "mouse")
    return;
  let d = t;
  if (d.originalEvent && (d = d.originalEvent), d.type === "pointermove" && (a.touchId !== null || d.pointerId !== a.pointerId))
    return;
  let h;
  if (d.type === "touchmove") {
    if (h = [...d.changedTouches].filter((S) => S.identifier === a.touchId)[0], !h || h.identifier !== a.touchId)
      return;
  } else
    h = d;
  if (!a.isTouched) {
    a.startMoving && a.isScrolling && n.emit("touchMoveOpposite", d);
    return;
  }
  const u = h.pageX, p = h.pageY;
  if (d.preventedByNestedSwiper) {
    o.startX = u, o.startY = p;
    return;
  }
  if (!n.allowTouchMove) {
    d.target.matches(a.focusableElements) || (n.allowClick = !1), a.isTouched && (Object.assign(o, {
      startX: u,
      startY: p,
      currentX: u,
      currentY: p
    }), a.touchStartTime = now$1());
    return;
  }
  if (s.touchReleaseOnEdges && !s.loop) {
    if (n.isVertical()) {
      if (p < o.startY && n.translate <= n.maxTranslate() || p > o.startY && n.translate >= n.minTranslate()) {
        a.isTouched = !1, a.isMoved = !1;
        return;
      }
    } else if (u < o.startX && n.translate <= n.maxTranslate() || u > o.startX && n.translate >= n.minTranslate())
      return;
  }
  if (r.activeElement && d.target === r.activeElement && d.target.matches(a.focusableElements)) {
    a.isMoved = !0, n.allowClick = !1;
    return;
  }
  a.allowTouchCallbacks && n.emit("touchMove", d), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = u, o.currentY = p;
  const m = o.currentX - o.startX, g = o.currentY - o.startY;
  if (n.params.threshold && Math.sqrt(m ** 2 + g ** 2) < n.params.threshold)
    return;
  if (typeof a.isScrolling > "u") {
    let S;
    n.isHorizontal() && o.currentY === o.startY || n.isVertical() && o.currentX === o.startX ? a.isScrolling = !1 : m * m + g * g >= 25 && (S = Math.atan2(Math.abs(g), Math.abs(m)) * 180 / Math.PI, a.isScrolling = n.isHorizontal() ? S > s.touchAngle : 90 - S > s.touchAngle);
  }
  if (a.isScrolling && n.emit("touchMoveOpposite", d), typeof a.startMoving > "u" && (o.currentX !== o.startX || o.currentY !== o.startY) && (a.startMoving = !0), a.isScrolling || d.type === "touchmove" && a.preventTouchMoveFromPointerMove) {
    a.isTouched = !1;
    return;
  }
  if (!a.startMoving)
    return;
  n.allowClick = !1, !s.cssMode && d.cancelable && d.preventDefault(), s.touchMoveStopPropagation && !s.nested && d.stopPropagation();
  let v = n.isHorizontal() ? m : g, y = n.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
  s.oneWayMovement && (v = Math.abs(v) * (c ? 1 : -1), y = Math.abs(y) * (c ? 1 : -1)), o.diff = v, v *= s.touchRatio, c && (v = -v, y = -y);
  const x = n.touchesDirection;
  n.swipeDirection = v > 0 ? "prev" : "next", n.touchesDirection = y > 0 ? "prev" : "next";
  const _ = n.params.loop && !s.cssMode, $ = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
  if (!a.isMoved) {
    if (_ && $ && n.loopFix({
      direction: n.swipeDirection
    }), a.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const S = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      n.wrapperEl.dispatchEvent(S);
    }
    a.allowMomentumBounce = !1, s.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", d);
  }
  let b;
  if ((/* @__PURE__ */ new Date()).getTime(), a.isMoved && a.allowThresholdMove && x !== n.touchesDirection && _ && $ && Math.abs(v) >= 1) {
    Object.assign(o, {
      startX: u,
      startY: p,
      currentX: u,
      currentY: p,
      startTranslate: a.currentTranslate
    }), a.loopSwapReset = !0, a.startTranslate = a.currentTranslate;
    return;
  }
  n.emit("sliderMove", d), a.isMoved = !0, a.currentTranslate = v + a.startTranslate;
  let M = !0, C = s.resistanceRatio;
  if (s.touchReleaseOnEdges && (C = 0), v > 0 ? (_ && $ && !b && a.allowThresholdMove && a.currentTranslate > (s.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] - (s.slidesPerView !== "auto" && n.slides.length - s.slidesPerView >= 2 ? n.slidesSizesGrid[n.activeIndex + 1] + n.params.spaceBetween : 0) - n.params.spaceBetween : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), a.currentTranslate > n.minTranslate() && (M = !1, s.resistance && (a.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + a.startTranslate + v) ** C))) : v < 0 && (_ && $ && !b && a.allowThresholdMove && a.currentTranslate < (s.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween + (s.slidesPerView !== "auto" && n.slides.length - s.slidesPerView >= 2 ? n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween : 0) : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - (s.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(s.slidesPerView, 10)))
  }), a.currentTranslate < n.maxTranslate() && (M = !1, s.resistance && (a.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - a.startTranslate - v) ** C))), M && (d.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (a.currentTranslate = a.startTranslate), s.threshold > 0)
    if (Math.abs(v) > s.threshold || a.allowThresholdMove) {
      if (!a.allowThresholdMove) {
        a.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, a.currentTranslate = a.startTranslate, o.diff = n.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      a.currentTranslate = a.startTranslate;
      return;
    }
  !s.followFinger || s.cssMode || ((s.freeMode && s.freeMode.enabled && n.freeMode || s.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), s.freeMode && s.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(a.currentTranslate), n.setTranslate(a.currentTranslate));
}
function onTouchEnd(t) {
  const r = this, n = r.touchEventsData;
  let a = t;
  a.originalEvent && (a = a.originalEvent);
  let s;
  if (a.type === "touchend" || a.type === "touchcancel") {
    if (s = [...a.changedTouches].filter((C) => C.identifier === n.touchId)[0], !s || s.identifier !== n.touchId)
      return;
  } else {
    if (n.touchId !== null || a.pointerId !== n.pointerId)
      return;
    s = a;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(a.type) && !(["pointercancel", "contextmenu"].includes(a.type) && (r.browser.isSafari || r.browser.isWebView)))
    return;
  n.pointerId = null, n.touchId = null;
  const {
    params: c,
    touches: l,
    rtlTranslate: d,
    slidesGrid: h,
    enabled: u
  } = r;
  if (!u || !c.simulateTouch && a.pointerType === "mouse")
    return;
  if (n.allowTouchCallbacks && r.emit("touchEnd", a), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && c.grabCursor && r.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  c.grabCursor && n.isMoved && n.isTouched && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!1);
  const p = now$1(), m = p - n.touchStartTime;
  if (r.allowClick) {
    const C = a.path || a.composedPath && a.composedPath();
    r.updateClickedSlide(C && C[0] || a.target, C), r.emit("tap click", a), m < 300 && p - n.lastClickTime < 300 && r.emit("doubleTap doubleClick", a);
  }
  if (n.lastClickTime = now$1(), nextTick(() => {
    r.destroyed || (r.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !r.swipeDirection || l.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let g;
  if (c.followFinger ? g = d ? r.translate : -r.translate : g = -n.currentTranslate, c.cssMode)
    return;
  if (c.freeMode && c.freeMode.enabled) {
    r.freeMode.onTouchEnd({
      currentPos: g
    });
    return;
  }
  const v = g >= -r.maxTranslate() && !r.params.loop;
  let y = 0, x = r.slidesSizesGrid[0];
  for (let C = 0; C < h.length; C += C < c.slidesPerGroupSkip ? 1 : c.slidesPerGroup) {
    const S = C < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
    typeof h[C + S] < "u" ? (v || g >= h[C] && g < h[C + S]) && (y = C, x = h[C + S] - h[C]) : (v || g >= h[C]) && (y = C, x = h[h.length - 1] - h[h.length - 2]);
  }
  let _ = null, $ = null;
  c.rewind && (r.isBeginning ? $ = c.virtual && c.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1 : r.isEnd && (_ = 0));
  const b = (g - h[y]) / x, M = y < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
  if (m > c.longSwipesMs) {
    if (!c.longSwipes) {
      r.slideTo(r.activeIndex);
      return;
    }
    r.swipeDirection === "next" && (b >= c.longSwipesRatio ? r.slideTo(c.rewind && r.isEnd ? _ : y + M) : r.slideTo(y)), r.swipeDirection === "prev" && (b > 1 - c.longSwipesRatio ? r.slideTo(y + M) : $ !== null && b < 0 && Math.abs(b) > c.longSwipesRatio ? r.slideTo($) : r.slideTo(y));
  } else {
    if (!c.shortSwipes) {
      r.slideTo(r.activeIndex);
      return;
    }
    r.navigation && (a.target === r.navigation.nextEl || a.target === r.navigation.prevEl) ? a.target === r.navigation.nextEl ? r.slideTo(y + M) : r.slideTo(y) : (r.swipeDirection === "next" && r.slideTo(_ !== null ? _ : y + M), r.swipeDirection === "prev" && r.slideTo($ !== null ? $ : y));
  }
}
function onResize() {
  const t = this, {
    params: r,
    el: n
  } = t;
  if (n && n.offsetWidth === 0)
    return;
  r.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: a,
    allowSlidePrev: s,
    snapGrid: o
  } = t, c = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const l = c && r.loop;
  (r.slidesPerView === "auto" || r.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !l ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !c ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = s, t.allowSlideNext = a, t.params.watchOverflow && o !== t.snapGrid && t.checkOverflow();
}
function onClick(t) {
  const r = this;
  r.enabled && (r.allowClick || (r.params.preventClicks && t.preventDefault(), r.params.preventClicksPropagation && r.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function onScroll() {
  const t = this, {
    wrapperEl: r,
    rtlTranslate: n,
    enabled: a
  } = t;
  if (!a)
    return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -r.scrollLeft : t.translate = -r.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let s;
  const o = t.maxTranslate() - t.minTranslate();
  o === 0 ? s = 0 : s = (t.translate - t.minTranslate()) / o, s !== t.progress && t.updateProgress(n ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function onLoad(t) {
  const r = this;
  processLazyPreloader(r, t.target), !(r.params.cssMode || r.params.slidesPerView !== "auto" && !r.params.autoHeight) && r.update();
}
function onDocumentTouchStart() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const events = (t, r) => {
  const n = getDocument(), {
    params: a,
    el: s,
    wrapperEl: o,
    device: c
  } = t, l = !!a.nested, d = r === "on" ? "addEventListener" : "removeEventListener", h = r;
  !s || typeof s == "string" || (n[d]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: l
  }), s[d]("touchstart", t.onTouchStart, {
    passive: !1
  }), s[d]("pointerdown", t.onTouchStart, {
    passive: !1
  }), n[d]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: l
  }), n[d]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: l
  }), n[d]("touchend", t.onTouchEnd, {
    passive: !0
  }), n[d]("pointerup", t.onTouchEnd, {
    passive: !0
  }), n[d]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), n[d]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), n[d]("pointerout", t.onTouchEnd, {
    passive: !0
  }), n[d]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), n[d]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (a.preventClicks || a.preventClicksPropagation) && s[d]("click", t.onClick, !0), a.cssMode && o[d]("scroll", t.onScroll), a.updateOnWindowResize ? t[h](c.ios || c.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, !0) : t[h]("observerUpdate", onResize, !0), s[d]("load", t.onLoad, {
    capture: !0
  }));
};
function attachEvents() {
  const t = this, {
    params: r
  } = t;
  t.onTouchStart = onTouchStart.bind(t), t.onTouchMove = onTouchMove.bind(t), t.onTouchEnd = onTouchEnd.bind(t), t.onDocumentTouchStart = onDocumentTouchStart.bind(t), r.cssMode && (t.onScroll = onScroll.bind(t)), t.onClick = onClick.bind(t), t.onLoad = onLoad.bind(t), events(t, "on");
}
function detachEvents() {
  events(this, "off");
}
var events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (t, r) => t.grid && r.grid && r.grid.rows > 1;
function setBreakpoint() {
  const t = this, {
    realIndex: r,
    initialized: n,
    params: a,
    el: s
  } = t, o = a.breakpoints;
  if (!o || o && Object.keys(o).length === 0)
    return;
  const c = t.getBreakpoint(o, t.params.breakpointsBase, t.el);
  if (!c || t.currentBreakpoint === c)
    return;
  const d = (c in o ? o[c] : void 0) || t.originalParams, h = isGridEnabled(t, a), u = isGridEnabled(t, d), p = t.params.grabCursor, m = d.grabCursor, g = a.enabled;
  h && !u ? (s.classList.remove(`${a.containerModifierClass}grid`, `${a.containerModifierClass}grid-column`), t.emitContainerClasses()) : !h && u && (s.classList.add(`${a.containerModifierClass}grid`), (d.grid.fill && d.grid.fill === "column" || !d.grid.fill && a.grid.fill === "column") && s.classList.add(`${a.containerModifierClass}grid-column`), t.emitContainerClasses()), p && !m ? t.unsetGrabCursor() : !p && m && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((b) => {
    if (typeof d[b] > "u")
      return;
    const M = a[b] && a[b].enabled, C = d[b] && d[b].enabled;
    M && !C && t[b].disable(), !M && C && t[b].enable();
  });
  const v = d.direction && d.direction !== a.direction, y = a.loop && (d.slidesPerView !== a.slidesPerView || v), x = a.loop;
  v && n && t.changeDirection(), extend$3(t.params, d);
  const _ = t.params.enabled, $ = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), g && !_ ? t.disable() : !g && _ && t.enable(), t.currentBreakpoint = c, t.emit("_beforeBreakpoint", d), n && (y ? (t.loopDestroy(), t.loopCreate(r), t.updateSlides()) : !x && $ ? (t.loopCreate(r), t.updateSlides()) : x && !$ && t.loopDestroy()), t.emit("breakpoint", d);
}
function getBreakpoint(t, r, n) {
  if (r === void 0 && (r = "window"), !t || r === "container" && !n)
    return;
  let a = !1;
  const s = getWindow$2(), o = r === "window" ? s.innerHeight : n.clientHeight, c = Object.keys(t).map((l) => {
    if (typeof l == "string" && l.indexOf("@") === 0) {
      const d = parseFloat(l.substr(1));
      return {
        value: o * d,
        point: l
      };
    }
    return {
      value: l,
      point: l
    };
  });
  c.sort((l, d) => parseInt(l.value, 10) - parseInt(d.value, 10));
  for (let l = 0; l < c.length; l += 1) {
    const {
      point: d,
      value: h
    } = c[l];
    r === "window" ? s.matchMedia(`(min-width: ${h}px)`).matches && (a = d) : h <= n.clientWidth && (a = d);
  }
  return a || "max";
}
var breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(t, r) {
  const n = [];
  return t.forEach((a) => {
    typeof a == "object" ? Object.keys(a).forEach((s) => {
      a[s] && n.push(r + s);
    }) : typeof a == "string" && n.push(r + a);
  }), n;
}
function addClasses() {
  const t = this, {
    classNames: r,
    params: n,
    rtl: a,
    el: s,
    device: o
  } = t, c = prepareClasses(["initialized", n.direction, {
    "free-mode": t.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: a
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: o.android
  }, {
    ios: o.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  r.push(...c), s.classList.add(...r), t.emitContainerClasses();
}
function removeClasses() {
  const t = this, {
    el: r,
    classNames: n
  } = t;
  !r || typeof r == "string" || (r.classList.remove(...n), t.emitContainerClasses());
}
var classes = {
  addClasses,
  removeClasses
};
function checkOverflow$1() {
  const t = this, {
    isLocked: r,
    params: n
  } = t, {
    slidesOffsetBefore: a
  } = n;
  if (a) {
    const s = t.slides.length - 1, o = t.slidesGrid[s] + t.slidesSizesGrid[s] + a * 2;
    t.isLocked = t.size > o;
  } else
    t.isLocked = t.snapGrid.length === 1;
  n.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), n.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), r && r !== t.isLocked && (t.isEnd = !1), r !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var checkOverflow$1$1 = {
  checkOverflow: checkOverflow$1
}, defaults$2 = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function moduleExtendParams(t, r) {
  return function(a) {
    a === void 0 && (a = {});
    const s = Object.keys(a)[0], o = a[s];
    if (typeof o != "object" || o === null) {
      extend$3(r, a);
      return;
    }
    if (t[s] === !0 && (t[s] = {
      enabled: !0
    }), s === "navigation" && t[s] && t[s].enabled && !t[s].prevEl && !t[s].nextEl && (t[s].auto = !0), ["pagination", "scrollbar"].indexOf(s) >= 0 && t[s] && t[s].enabled && !t[s].el && (t[s].auto = !0), !(s in t && "enabled" in o)) {
      extend$3(r, a);
      return;
    }
    typeof t[s] == "object" && !("enabled" in t[s]) && (t[s].enabled = !0), t[s] || (t[s] = {
      enabled: !1
    }), extend$3(r, a);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1$1,
  classes
}, extendedDefaults = {};
class Swiper {
  constructor() {
    let r, n;
    for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++)
      s[o] = arguments[o];
    s.length === 1 && s[0].constructor && Object.prototype.toString.call(s[0]).slice(8, -1) === "Object" ? n = s[0] : [r, n] = s, n || (n = {}), n = extend$3({}, n), r && !n.el && (n.el = r);
    const c = getDocument();
    if (n.el && typeof n.el == "string" && c.querySelectorAll(n.el).length > 1) {
      const u = [];
      return c.querySelectorAll(n.el).forEach((p) => {
        const m = extend$3({}, n, {
          el: p
        });
        u.push(new Swiper(m));
      }), u;
    }
    const l = this;
    l.__swiper__ = !0, l.support = getSupport(), l.device = getDevice({
      userAgent: n.userAgent
    }), l.browser = getBrowser(), l.eventsListeners = {}, l.eventsAnyListeners = [], l.modules = [...l.__modules__], n.modules && Array.isArray(n.modules) && l.modules.push(...n.modules);
    const d = {};
    l.modules.forEach((u) => {
      u({
        params: n,
        swiper: l,
        extendParams: moduleExtendParams(n, d),
        on: l.on.bind(l),
        once: l.once.bind(l),
        off: l.off.bind(l),
        emit: l.emit.bind(l)
      });
    });
    const h = extend$3({}, defaults$2, d);
    return l.params = extend$3({}, h, extendedDefaults, n), l.originalParams = extend$3({}, l.params), l.passedParams = extend$3({}, n), l.params && l.params.on && Object.keys(l.params.on).forEach((u) => {
      l.on(u, l.params.on[u]);
    }), l.params && l.params.onAny && l.onAny(l.params.onAny), Object.assign(l, {
      enabled: l.params.enabled,
      el: r,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return l.params.direction === "horizontal";
      },
      isVertical() {
        return l.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: l.params.allowSlideNext,
      allowSlidePrev: l.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: l.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: l.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), l.emit("_swiper"), l.params.init && l.init(), l;
  }
  getDirectionLabel(r) {
    return this.isHorizontal() ? r : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[r];
  }
  getSlideIndex(r) {
    const {
      slidesEl: n,
      params: a
    } = this, s = elementChildren(n, `.${a.slideClass}, swiper-slide`), o = elementIndex(s[0]);
    return elementIndex(r) - o;
  }
  getSlideIndexByData(r) {
    return this.getSlideIndex(this.slides.filter((n) => n.getAttribute("data-swiper-slide-index") * 1 === r)[0]);
  }
  recalcSlides() {
    const r = this, {
      slidesEl: n,
      params: a
    } = r;
    r.slides = elementChildren(n, `.${a.slideClass}, swiper-slide`);
  }
  enable() {
    const r = this;
    r.enabled || (r.enabled = !0, r.params.grabCursor && r.setGrabCursor(), r.emit("enable"));
  }
  disable() {
    const r = this;
    r.enabled && (r.enabled = !1, r.params.grabCursor && r.unsetGrabCursor(), r.emit("disable"));
  }
  setProgress(r, n) {
    const a = this;
    r = Math.min(Math.max(r, 0), 1);
    const s = a.minTranslate(), c = (a.maxTranslate() - s) * r + s;
    a.translateTo(c, typeof n > "u" ? 0 : n), a.updateActiveIndex(), a.updateSlidesClasses();
  }
  emitContainerClasses() {
    const r = this;
    if (!r.params._emitClasses || !r.el)
      return;
    const n = r.el.className.split(" ").filter((a) => a.indexOf("swiper") === 0 || a.indexOf(r.params.containerModifierClass) === 0);
    r.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(r) {
    const n = this;
    return n.destroyed ? "" : r.className.split(" ").filter((a) => a.indexOf("swiper-slide") === 0 || a.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const r = this;
    if (!r.params._emitClasses || !r.el)
      return;
    const n = [];
    r.slides.forEach((a) => {
      const s = r.getSlideClasses(a);
      n.push({
        slideEl: a,
        classNames: s
      }), r.emit("_slideClass", a, s);
    }), r.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(r, n) {
    r === void 0 && (r = "current"), n === void 0 && (n = !1);
    const a = this, {
      params: s,
      slides: o,
      slidesGrid: c,
      slidesSizesGrid: l,
      size: d,
      activeIndex: h
    } = a;
    let u = 1;
    if (typeof s.slidesPerView == "number")
      return s.slidesPerView;
    if (s.centeredSlides) {
      let p = o[h] ? Math.ceil(o[h].swiperSlideSize) : 0, m;
      for (let g = h + 1; g < o.length; g += 1)
        o[g] && !m && (p += Math.ceil(o[g].swiperSlideSize), u += 1, p > d && (m = !0));
      for (let g = h - 1; g >= 0; g -= 1)
        o[g] && !m && (p += o[g].swiperSlideSize, u += 1, p > d && (m = !0));
    } else if (r === "current")
      for (let p = h + 1; p < o.length; p += 1)
        (n ? c[p] + l[p] - c[h] < d : c[p] - c[h] < d) && (u += 1);
    else
      for (let p = h - 1; p >= 0; p -= 1)
        c[h] - c[p] < d && (u += 1);
    return u;
  }
  update() {
    const r = this;
    if (!r || r.destroyed)
      return;
    const {
      snapGrid: n,
      params: a
    } = r;
    a.breakpoints && r.setBreakpoint(), [...r.el.querySelectorAll('[loading="lazy"]')].forEach((c) => {
      c.complete && processLazyPreloader(r, c);
    }), r.updateSize(), r.updateSlides(), r.updateProgress(), r.updateSlidesClasses();
    function s() {
      const c = r.rtlTranslate ? r.translate * -1 : r.translate, l = Math.min(Math.max(c, r.maxTranslate()), r.minTranslate());
      r.setTranslate(l), r.updateActiveIndex(), r.updateSlidesClasses();
    }
    let o;
    if (a.freeMode && a.freeMode.enabled && !a.cssMode)
      s(), a.autoHeight && r.updateAutoHeight();
    else {
      if ((a.slidesPerView === "auto" || a.slidesPerView > 1) && r.isEnd && !a.centeredSlides) {
        const c = r.virtual && a.virtual.enabled ? r.virtual.slides : r.slides;
        o = r.slideTo(c.length - 1, 0, !1, !0);
      } else
        o = r.slideTo(r.activeIndex, 0, !1, !0);
      o || s();
    }
    a.watchOverflow && n !== r.snapGrid && r.checkOverflow(), r.emit("update");
  }
  changeDirection(r, n) {
    n === void 0 && (n = !0);
    const a = this, s = a.params.direction;
    return r || (r = s === "horizontal" ? "vertical" : "horizontal"), r === s || r !== "horizontal" && r !== "vertical" || (a.el.classList.remove(`${a.params.containerModifierClass}${s}`), a.el.classList.add(`${a.params.containerModifierClass}${r}`), a.emitContainerClasses(), a.params.direction = r, a.slides.forEach((o) => {
      r === "vertical" ? o.style.width = "" : o.style.height = "";
    }), a.emit("changeDirection"), n && a.update()), a;
  }
  changeLanguageDirection(r) {
    const n = this;
    n.rtl && r === "rtl" || !n.rtl && r === "ltr" || (n.rtl = r === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(r) {
    const n = this;
    if (n.mounted)
      return !0;
    let a = r || n.params.el;
    if (typeof a == "string" && (a = document.querySelector(a)), !a)
      return !1;
    a.swiper = n, a.parentNode && a.parentNode.host && a.parentNode.host.nodeName === n.params.swiperElementNodeName.toUpperCase() && (n.isElement = !0);
    const s = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let c = (() => a && a.shadowRoot && a.shadowRoot.querySelector ? a.shadowRoot.querySelector(s()) : elementChildren(a, s())[0])();
    return !c && n.params.createElements && (c = createElement("div", n.params.wrapperClass), a.append(c), elementChildren(a, `.${n.params.slideClass}`).forEach((l) => {
      c.append(l);
    })), Object.assign(n, {
      el: a,
      wrapperEl: c,
      slidesEl: n.isElement && !a.parentNode.host.slideSlots ? a.parentNode.host : c,
      hostEl: n.isElement ? a.parentNode.host : a,
      mounted: !0,
      // RTL
      rtl: a.dir.toLowerCase() === "rtl" || elementStyle(a, "direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (a.dir.toLowerCase() === "rtl" || elementStyle(a, "direction") === "rtl"),
      wrongRTL: elementStyle(c, "display") === "-webkit-box"
    }), !0;
  }
  init(r) {
    const n = this;
    if (n.initialized || n.mount(r) === !1)
      return n;
    n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.loop && n.virtual && n.params.virtual.enabled ? n.slideTo(n.params.initialSlide + n.virtual.slidesBefore, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.params.loop && n.loopCreate(), n.attachEvents();
    const s = [...n.el.querySelectorAll('[loading="lazy"]')];
    return n.isElement && s.push(...n.hostEl.querySelectorAll('[loading="lazy"]')), s.forEach((o) => {
      o.complete ? processLazyPreloader(n, o) : o.addEventListener("load", (c) => {
        processLazyPreloader(n, c.target);
      });
    }), preload(n), n.initialized = !0, preload(n), n.emit("init"), n.emit("afterInit"), n;
  }
  destroy(r, n) {
    r === void 0 && (r = !0), n === void 0 && (n = !0);
    const a = this, {
      params: s,
      el: o,
      wrapperEl: c,
      slides: l
    } = a;
    return typeof a.params > "u" || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), s.loop && a.loopDestroy(), n && (a.removeClasses(), o && typeof o != "string" && o.removeAttribute("style"), c && c.removeAttribute("style"), l && l.length && l.forEach((d) => {
      d.classList.remove(s.slideVisibleClass, s.slideFullyVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass), d.removeAttribute("style"), d.removeAttribute("data-swiper-slide-index");
    })), a.emit("destroy"), Object.keys(a.eventsListeners).forEach((d) => {
      a.off(d);
    }), r !== !1 && (a.el && typeof a.el != "string" && (a.el.swiper = null), deleteProps(a)), a.destroyed = !0), null;
  }
  static extendDefaults(r) {
    extend$3(extendedDefaults, r);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults$2;
  }
  static installModule(r) {
    Swiper.prototype.__modules__ || (Swiper.prototype.__modules__ = []);
    const n = Swiper.prototype.__modules__;
    typeof r == "function" && n.indexOf(r) < 0 && n.push(r);
  }
  static use(r) {
    return Array.isArray(r) ? (r.forEach((n) => Swiper.installModule(n)), Swiper) : (Swiper.installModule(r), Swiper);
  }
}
Object.keys(prototypes).forEach((t) => {
  Object.keys(prototypes[t]).forEach((r) => {
    Swiper.prototype[r] = prototypes[t][r];
  });
});
Swiper.use([Resize, Observer]);
function Virtual(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  n({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let o;
  const c = getDocument();
  r.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const l = c.createElement("div");
  function d(v, y) {
    const x = r.params.virtual;
    if (x.cache && r.virtual.cache[y])
      return r.virtual.cache[y];
    let _;
    return x.renderSlide ? (_ = x.renderSlide.call(r, v, y), typeof _ == "string" && (l.innerHTML = _, _ = l.children[0])) : r.isElement ? _ = createElement("swiper-slide") : _ = createElement("div", r.params.slideClass), _.setAttribute("data-swiper-slide-index", y), x.renderSlide || (_.innerHTML = v), x.cache && (r.virtual.cache[y] = _), _;
  }
  function h(v, y) {
    const {
      slidesPerView: x,
      slidesPerGroup: _,
      centeredSlides: $,
      loop: b,
      initialSlide: M
    } = r.params;
    if (y && !b && M > 0)
      return;
    const {
      addSlidesBefore: C,
      addSlidesAfter: S
    } = r.params.virtual, {
      from: A,
      to: D,
      slides: N,
      slidesGrid: T,
      offset: R
    } = r.virtual;
    r.params.cssMode || r.updateActiveIndex();
    const F = r.activeIndex || 0;
    let z;
    r.rtlTranslate ? z = "right" : z = r.isHorizontal() ? "left" : "top";
    let O, G;
    $ ? (O = Math.floor(x / 2) + _ + S, G = Math.floor(x / 2) + _ + C) : (O = x + (_ - 1) + S, G = (b ? x : _) + C);
    let I = F - G, k = F + O;
    b || (I = Math.max(I, 0), k = Math.min(k, N.length - 1));
    let B = (r.slidesGrid[I] || 0) - (r.slidesGrid[0] || 0);
    b && F >= G ? (I -= G, $ || (B += r.slidesGrid[0])) : b && F < G && (I = -G, $ && (B += r.slidesGrid[0])), Object.assign(r.virtual, {
      from: I,
      to: k,
      offset: B,
      slidesGrid: r.slidesGrid,
      slidesBefore: G,
      slidesAfter: O
    });
    function L() {
      r.updateSlides(), r.updateProgress(), r.updateSlidesClasses(), s("virtualUpdate");
    }
    if (A === I && D === k && !v) {
      r.slidesGrid !== T && B !== R && r.slides.forEach((ae) => {
        ae.style[z] = `${B - Math.abs(r.cssOverflowAdjustment())}px`;
      }), r.updateProgress(), s("virtualUpdate");
      return;
    }
    if (r.params.virtual.renderExternal) {
      r.params.virtual.renderExternal.call(r, {
        offset: B,
        from: I,
        to: k,
        slides: function() {
          const ee = [];
          for (let se = I; se <= k; se += 1)
            ee.push(N[se]);
          return ee;
        }()
      }), r.params.virtual.renderExternalUpdate ? L() : s("virtualUpdate");
      return;
    }
    const V = [], U = [], J = (ae) => {
      let ee = ae;
      return ae < 0 ? ee = N.length + ae : ee >= N.length && (ee = ee - N.length), ee;
    };
    if (v)
      r.slides.filter((ae) => ae.matches(`.${r.params.slideClass}, swiper-slide`)).forEach((ae) => {
        ae.remove();
      });
    else
      for (let ae = A; ae <= D; ae += 1)
        if (ae < I || ae > k) {
          const ee = J(ae);
          r.slides.filter((se) => se.matches(`.${r.params.slideClass}[data-swiper-slide-index="${ee}"], swiper-slide[data-swiper-slide-index="${ee}"]`)).forEach((se) => {
            se.remove();
          });
        }
    const q = b ? -N.length : 0, Z = b ? N.length * 2 : N.length;
    for (let ae = q; ae < Z; ae += 1)
      if (ae >= I && ae <= k) {
        const ee = J(ae);
        typeof D > "u" || v ? U.push(ee) : (ae > D && U.push(ee), ae < A && V.push(ee));
      }
    if (U.forEach((ae) => {
      r.slidesEl.append(d(N[ae], ae));
    }), b)
      for (let ae = V.length - 1; ae >= 0; ae -= 1) {
        const ee = V[ae];
        r.slidesEl.prepend(d(N[ee], ee));
      }
    else
      V.sort((ae, ee) => ee - ae), V.forEach((ae) => {
        r.slidesEl.prepend(d(N[ae], ae));
      });
    elementChildren(r.slidesEl, ".swiper-slide, swiper-slide").forEach((ae) => {
      ae.style[z] = `${B - Math.abs(r.cssOverflowAdjustment())}px`;
    }), L();
  }
  function u(v) {
    if (typeof v == "object" && "length" in v)
      for (let y = 0; y < v.length; y += 1)
        v[y] && r.virtual.slides.push(v[y]);
    else
      r.virtual.slides.push(v);
    h(!0);
  }
  function p(v) {
    const y = r.activeIndex;
    let x = y + 1, _ = 1;
    if (Array.isArray(v)) {
      for (let $ = 0; $ < v.length; $ += 1)
        v[$] && r.virtual.slides.unshift(v[$]);
      x = y + v.length, _ = v.length;
    } else
      r.virtual.slides.unshift(v);
    if (r.params.virtual.cache) {
      const $ = r.virtual.cache, b = {};
      Object.keys($).forEach((M) => {
        const C = $[M], S = C.getAttribute("data-swiper-slide-index");
        S && C.setAttribute("data-swiper-slide-index", parseInt(S, 10) + _), b[parseInt(M, 10) + _] = C;
      }), r.virtual.cache = b;
    }
    h(!0), r.slideTo(x, 0);
  }
  function m(v) {
    if (typeof v > "u" || v === null)
      return;
    let y = r.activeIndex;
    if (Array.isArray(v))
      for (let x = v.length - 1; x >= 0; x -= 1)
        r.params.virtual.cache && (delete r.virtual.cache[v[x]], Object.keys(r.virtual.cache).forEach((_) => {
          _ > v && (r.virtual.cache[_ - 1] = r.virtual.cache[_], r.virtual.cache[_ - 1].setAttribute("data-swiper-slide-index", _ - 1), delete r.virtual.cache[_]);
        })), r.virtual.slides.splice(v[x], 1), v[x] < y && (y -= 1), y = Math.max(y, 0);
    else
      r.params.virtual.cache && (delete r.virtual.cache[v], Object.keys(r.virtual.cache).forEach((x) => {
        x > v && (r.virtual.cache[x - 1] = r.virtual.cache[x], r.virtual.cache[x - 1].setAttribute("data-swiper-slide-index", x - 1), delete r.virtual.cache[x]);
      })), r.virtual.slides.splice(v, 1), v < y && (y -= 1), y = Math.max(y, 0);
    h(!0), r.slideTo(y, 0);
  }
  function g() {
    r.virtual.slides = [], r.params.virtual.cache && (r.virtual.cache = {}), h(!0), r.slideTo(0, 0);
  }
  a("beforeInit", () => {
    if (!r.params.virtual.enabled)
      return;
    let v;
    if (typeof r.passedParams.virtual.slides > "u") {
      const y = [...r.slidesEl.children].filter((x) => x.matches(`.${r.params.slideClass}, swiper-slide`));
      y && y.length && (r.virtual.slides = [...y], v = !0, y.forEach((x, _) => {
        x.setAttribute("data-swiper-slide-index", _), r.virtual.cache[_] = x, x.remove();
      }));
    }
    v || (r.virtual.slides = r.params.virtual.slides), r.classNames.push(`${r.params.containerModifierClass}virtual`), r.params.watchSlidesProgress = !0, r.originalParams.watchSlidesProgress = !0, h(!1, !0);
  }), a("setTranslate", () => {
    r.params.virtual.enabled && (r.params.cssMode && !r._immediateVirtual ? (clearTimeout(o), o = setTimeout(() => {
      h();
    }, 100)) : h());
  }), a("init update resize", () => {
    r.params.virtual.enabled && r.params.cssMode && setCSSProperty(r.wrapperEl, "--swiper-virtual-size", `${r.virtualSize}px`);
  }), Object.assign(r.virtual, {
    appendSlide: u,
    prependSlide: p,
    removeSlide: m,
    removeAllSlides: g,
    update: h
  });
}
function Keyboard(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  const o = getDocument(), c = getWindow$2();
  r.keyboard = {
    enabled: !1
  }, n({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function l(u) {
    if (!r.enabled)
      return;
    const {
      rtlTranslate: p
    } = r;
    let m = u;
    m.originalEvent && (m = m.originalEvent);
    const g = m.keyCode || m.charCode, v = r.params.keyboard.pageUpDown, y = v && g === 33, x = v && g === 34, _ = g === 37, $ = g === 39, b = g === 38, M = g === 40;
    if (!r.allowSlideNext && (r.isHorizontal() && $ || r.isVertical() && M || x) || !r.allowSlidePrev && (r.isHorizontal() && _ || r.isVertical() && b || y))
      return !1;
    if (!(m.shiftKey || m.altKey || m.ctrlKey || m.metaKey) && !(o.activeElement && o.activeElement.nodeName && (o.activeElement.nodeName.toLowerCase() === "input" || o.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (r.params.keyboard.onlyInViewport && (y || x || _ || $ || b || M)) {
        let C = !1;
        if (elementParents(r.el, `.${r.params.slideClass}, swiper-slide`).length > 0 && elementParents(r.el, `.${r.params.slideActiveClass}`).length === 0)
          return;
        const S = r.el, A = S.clientWidth, D = S.clientHeight, N = c.innerWidth, T = c.innerHeight, R = elementOffset(S);
        p && (R.left -= S.scrollLeft);
        const F = [[R.left, R.top], [R.left + A, R.top], [R.left, R.top + D], [R.left + A, R.top + D]];
        for (let z = 0; z < F.length; z += 1) {
          const O = F[z];
          if (O[0] >= 0 && O[0] <= N && O[1] >= 0 && O[1] <= T) {
            if (O[0] === 0 && O[1] === 0)
              continue;
            C = !0;
          }
        }
        if (!C)
          return;
      }
      r.isHorizontal() ? ((y || x || _ || $) && (m.preventDefault ? m.preventDefault() : m.returnValue = !1), ((x || $) && !p || (y || _) && p) && r.slideNext(), ((y || _) && !p || (x || $) && p) && r.slidePrev()) : ((y || x || b || M) && (m.preventDefault ? m.preventDefault() : m.returnValue = !1), (x || M) && r.slideNext(), (y || b) && r.slidePrev()), s("keyPress", g);
    }
  }
  function d() {
    r.keyboard.enabled || (o.addEventListener("keydown", l), r.keyboard.enabled = !0);
  }
  function h() {
    r.keyboard.enabled && (o.removeEventListener("keydown", l), r.keyboard.enabled = !1);
  }
  a("init", () => {
    r.params.keyboard.enabled && d();
  }), a("destroy", () => {
    r.keyboard.enabled && h();
  }), Object.assign(r.keyboard, {
    enable: d,
    disable: h
  });
}
function Mousewheel(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  const o = getWindow$2();
  n({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), r.mousewheel = {
    enabled: !1
  };
  let c, l = now$1(), d;
  const h = [];
  function u(b) {
    let A = 0, D = 0, N = 0, T = 0;
    return "detail" in b && (D = b.detail), "wheelDelta" in b && (D = -b.wheelDelta / 120), "wheelDeltaY" in b && (D = -b.wheelDeltaY / 120), "wheelDeltaX" in b && (A = -b.wheelDeltaX / 120), "axis" in b && b.axis === b.HORIZONTAL_AXIS && (A = D, D = 0), N = A * 10, T = D * 10, "deltaY" in b && (T = b.deltaY), "deltaX" in b && (N = b.deltaX), b.shiftKey && !N && (N = T, T = 0), (N || T) && b.deltaMode && (b.deltaMode === 1 ? (N *= 40, T *= 40) : (N *= 800, T *= 800)), N && !A && (A = N < 1 ? -1 : 1), T && !D && (D = T < 1 ? -1 : 1), {
      spinX: A,
      spinY: D,
      pixelX: N,
      pixelY: T
    };
  }
  function p() {
    r.enabled && (r.mouseEntered = !0);
  }
  function m() {
    r.enabled && (r.mouseEntered = !1);
  }
  function g(b) {
    return r.params.mousewheel.thresholdDelta && b.delta < r.params.mousewheel.thresholdDelta || r.params.mousewheel.thresholdTime && now$1() - l < r.params.mousewheel.thresholdTime ? !1 : b.delta >= 6 && now$1() - l < 60 ? !0 : (b.direction < 0 ? (!r.isEnd || r.params.loop) && !r.animating && (r.slideNext(), s("scroll", b.raw)) : (!r.isBeginning || r.params.loop) && !r.animating && (r.slidePrev(), s("scroll", b.raw)), l = new o.Date().getTime(), !1);
  }
  function v(b) {
    const M = r.params.mousewheel;
    if (b.direction < 0) {
      if (r.isEnd && !r.params.loop && M.releaseOnEdges)
        return !0;
    } else if (r.isBeginning && !r.params.loop && M.releaseOnEdges)
      return !0;
    return !1;
  }
  function y(b) {
    let M = b, C = !0;
    if (!r.enabled || b.target.closest(`.${r.params.mousewheel.noMousewheelClass}`))
      return;
    const S = r.params.mousewheel;
    r.params.cssMode && M.preventDefault();
    let A = r.el;
    r.params.mousewheel.eventsTarget !== "container" && (A = document.querySelector(r.params.mousewheel.eventsTarget));
    const D = A && A.contains(M.target);
    if (!r.mouseEntered && !D && !S.releaseOnEdges)
      return !0;
    M.originalEvent && (M = M.originalEvent);
    let N = 0;
    const T = r.rtlTranslate ? -1 : 1, R = u(M);
    if (S.forceToAxis)
      if (r.isHorizontal())
        if (Math.abs(R.pixelX) > Math.abs(R.pixelY))
          N = -R.pixelX * T;
        else
          return !0;
      else if (Math.abs(R.pixelY) > Math.abs(R.pixelX))
        N = -R.pixelY;
      else
        return !0;
    else
      N = Math.abs(R.pixelX) > Math.abs(R.pixelY) ? -R.pixelX * T : -R.pixelY;
    if (N === 0)
      return !0;
    S.invert && (N = -N);
    let F = r.getTranslate() + N * S.sensitivity;
    if (F >= r.minTranslate() && (F = r.minTranslate()), F <= r.maxTranslate() && (F = r.maxTranslate()), C = r.params.loop ? !0 : !(F === r.minTranslate() || F === r.maxTranslate()), C && r.params.nested && M.stopPropagation(), !r.params.freeMode || !r.params.freeMode.enabled) {
      const z = {
        time: now$1(),
        delta: Math.abs(N),
        direction: Math.sign(N),
        raw: b
      };
      h.length >= 2 && h.shift();
      const O = h.length ? h[h.length - 1] : void 0;
      if (h.push(z), O ? (z.direction !== O.direction || z.delta > O.delta || z.time > O.time + 150) && g(z) : g(z), v(z))
        return !0;
    } else {
      const z = {
        time: now$1(),
        delta: Math.abs(N),
        direction: Math.sign(N)
      }, O = d && z.time < d.time + 500 && z.delta <= d.delta && z.direction === d.direction;
      if (!O) {
        d = void 0;
        let G = r.getTranslate() + N * S.sensitivity;
        const I = r.isBeginning, k = r.isEnd;
        if (G >= r.minTranslate() && (G = r.minTranslate()), G <= r.maxTranslate() && (G = r.maxTranslate()), r.setTransition(0), r.setTranslate(G), r.updateProgress(), r.updateActiveIndex(), r.updateSlidesClasses(), (!I && r.isBeginning || !k && r.isEnd) && r.updateSlidesClasses(), r.params.loop && r.loopFix({
          direction: z.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), r.params.freeMode.sticky) {
          clearTimeout(c), c = void 0, h.length >= 15 && h.shift();
          const B = h.length ? h[h.length - 1] : void 0, L = h[0];
          if (h.push(z), B && (z.delta > B.delta || z.direction !== B.direction))
            h.splice(0);
          else if (h.length >= 15 && z.time - L.time < 500 && L.delta - z.delta >= 1 && z.delta <= 6) {
            const V = N > 0 ? 0.8 : 0.2;
            d = z, h.splice(0), c = nextTick(() => {
              r.destroyed || !r.params || r.slideToClosest(r.params.speed, !0, void 0, V);
            }, 0);
          }
          c || (c = nextTick(() => {
            if (r.destroyed || !r.params)
              return;
            const V = 0.5;
            d = z, h.splice(0), r.slideToClosest(r.params.speed, !0, void 0, V);
          }, 500));
        }
        if (O || s("scroll", M), r.params.autoplay && r.params.autoplayDisableOnInteraction && r.autoplay.stop(), S.releaseOnEdges && (G === r.minTranslate() || G === r.maxTranslate()))
          return !0;
      }
    }
    return M.preventDefault ? M.preventDefault() : M.returnValue = !1, !1;
  }
  function x(b) {
    let M = r.el;
    r.params.mousewheel.eventsTarget !== "container" && (M = document.querySelector(r.params.mousewheel.eventsTarget)), M[b]("mouseenter", p), M[b]("mouseleave", m), M[b]("wheel", y);
  }
  function _() {
    return r.params.cssMode ? (r.wrapperEl.removeEventListener("wheel", y), !0) : r.mousewheel.enabled ? !1 : (x("addEventListener"), r.mousewheel.enabled = !0, !0);
  }
  function $() {
    return r.params.cssMode ? (r.wrapperEl.addEventListener(event, y), !0) : r.mousewheel.enabled ? (x("removeEventListener"), r.mousewheel.enabled = !1, !0) : !1;
  }
  a("init", () => {
    !r.params.mousewheel.enabled && r.params.cssMode && $(), r.params.mousewheel.enabled && _();
  }), a("destroy", () => {
    r.params.cssMode && _(), r.mousewheel.enabled && $();
  }), Object.assign(r.mousewheel, {
    enable: _,
    disable: $
  });
}
function createElementIfNotDefined(t, r, n, a) {
  return t.params.createElements && Object.keys(a).forEach((s) => {
    if (!n[s] && n.auto === !0) {
      let o = elementChildren(t.el, `.${a[s]}`)[0];
      o || (o = createElement("div", a[s]), o.className = a[s], t.el.append(o)), n[s] = o, r[s] = o;
    }
  }), n;
}
function Navigation$1(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  n({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), r.navigation = {
    nextEl: null,
    prevEl: null
  };
  function o(v) {
    let y;
    return v && typeof v == "string" && r.isElement && (y = r.el.querySelector(v), y) ? y : (v && (typeof v == "string" && (y = [...document.querySelectorAll(v)]), r.params.uniqueNavElements && typeof v == "string" && y && y.length > 1 && r.el.querySelectorAll(v).length === 1 ? y = r.el.querySelector(v) : y && y.length === 1 && (y = y[0])), v && !y ? v : y);
  }
  function c(v, y) {
    const x = r.params.navigation;
    v = makeElementsArray(v), v.forEach((_) => {
      _ && (_.classList[y ? "add" : "remove"](...x.disabledClass.split(" ")), _.tagName === "BUTTON" && (_.disabled = y), r.params.watchOverflow && r.enabled && _.classList[r.isLocked ? "add" : "remove"](x.lockClass));
    });
  }
  function l() {
    const {
      nextEl: v,
      prevEl: y
    } = r.navigation;
    if (r.params.loop) {
      c(y, !1), c(v, !1);
      return;
    }
    c(y, r.isBeginning && !r.params.rewind), c(v, r.isEnd && !r.params.rewind);
  }
  function d(v) {
    v.preventDefault(), !(r.isBeginning && !r.params.loop && !r.params.rewind) && (r.slidePrev(), s("navigationPrev"));
  }
  function h(v) {
    v.preventDefault(), !(r.isEnd && !r.params.loop && !r.params.rewind) && (r.slideNext(), s("navigationNext"));
  }
  function u() {
    const v = r.params.navigation;
    if (r.params.navigation = createElementIfNotDefined(r, r.originalParams.navigation, r.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(v.nextEl || v.prevEl))
      return;
    let y = o(v.nextEl), x = o(v.prevEl);
    Object.assign(r.navigation, {
      nextEl: y,
      prevEl: x
    }), y = makeElementsArray(y), x = makeElementsArray(x);
    const _ = ($, b) => {
      $ && $.addEventListener("click", b === "next" ? h : d), !r.enabled && $ && $.classList.add(...v.lockClass.split(" "));
    };
    y.forEach(($) => _($, "next")), x.forEach(($) => _($, "prev"));
  }
  function p() {
    let {
      nextEl: v,
      prevEl: y
    } = r.navigation;
    v = makeElementsArray(v), y = makeElementsArray(y);
    const x = (_, $) => {
      _.removeEventListener("click", $ === "next" ? h : d), _.classList.remove(...r.params.navigation.disabledClass.split(" "));
    };
    v.forEach((_) => x(_, "next")), y.forEach((_) => x(_, "prev"));
  }
  a("init", () => {
    r.params.navigation.enabled === !1 ? g() : (u(), l());
  }), a("toEdge fromEdge lock unlock", () => {
    l();
  }), a("destroy", () => {
    p();
  }), a("enable disable", () => {
    let {
      nextEl: v,
      prevEl: y
    } = r.navigation;
    if (v = makeElementsArray(v), y = makeElementsArray(y), r.enabled) {
      l();
      return;
    }
    [...v, ...y].filter((x) => !!x).forEach((x) => x.classList.add(r.params.navigation.lockClass));
  }), a("click", (v, y) => {
    let {
      nextEl: x,
      prevEl: _
    } = r.navigation;
    x = makeElementsArray(x), _ = makeElementsArray(_);
    const $ = y.target;
    let b = _.includes($) || x.includes($);
    if (r.isElement && !b) {
      const M = y.path || y.composedPath && y.composedPath();
      M && (b = M.find((C) => x.includes(C) || _.includes(C)));
    }
    if (r.params.navigation.hideOnClick && !b) {
      if (r.pagination && r.params.pagination && r.params.pagination.clickable && (r.pagination.el === $ || r.pagination.el.contains($)))
        return;
      let M;
      x.length ? M = x[0].classList.contains(r.params.navigation.hiddenClass) : _.length && (M = _[0].classList.contains(r.params.navigation.hiddenClass)), s(M === !0 ? "navigationShow" : "navigationHide"), [...x, ..._].filter((C) => !!C).forEach((C) => C.classList.toggle(r.params.navigation.hiddenClass));
    }
  });
  const m = () => {
    r.el.classList.remove(...r.params.navigation.navigationDisabledClass.split(" ")), u(), l();
  }, g = () => {
    r.el.classList.add(...r.params.navigation.navigationDisabledClass.split(" ")), p();
  };
  Object.assign(r.navigation, {
    enable: m,
    disable: g,
    update: l,
    init: u,
    destroy: p
  });
}
function classesToSelector(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  const o = "swiper-pagination";
  n({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (_) => _,
      formatFractionTotal: (_) => _,
      bulletClass: `${o}-bullet`,
      bulletActiveClass: `${o}-bullet-active`,
      modifierClass: `${o}-`,
      currentClass: `${o}-current`,
      totalClass: `${o}-total`,
      hiddenClass: `${o}-hidden`,
      progressbarFillClass: `${o}-progressbar-fill`,
      progressbarOppositeClass: `${o}-progressbar-opposite`,
      clickableClass: `${o}-clickable`,
      lockClass: `${o}-lock`,
      horizontalClass: `${o}-horizontal`,
      verticalClass: `${o}-vertical`,
      paginationDisabledClass: `${o}-disabled`
    }
  }), r.pagination = {
    el: null,
    bullets: []
  };
  let c, l = 0;
  function d() {
    return !r.params.pagination.el || !r.pagination.el || Array.isArray(r.pagination.el) && r.pagination.el.length === 0;
  }
  function h(_, $) {
    const {
      bulletActiveClass: b
    } = r.params.pagination;
    _ && (_ = _[`${$ === "prev" ? "previous" : "next"}ElementSibling`], _ && (_.classList.add(`${b}-${$}`), _ = _[`${$ === "prev" ? "previous" : "next"}ElementSibling`], _ && _.classList.add(`${b}-${$}-${$}`)));
  }
  function u(_) {
    const $ = _.target.closest(classesToSelector(r.params.pagination.bulletClass));
    if (!$)
      return;
    _.preventDefault();
    const b = elementIndex($) * r.params.slidesPerGroup;
    if (r.params.loop) {
      if (r.realIndex === b)
        return;
      r.slideToLoop(b);
    } else
      r.slideTo(b);
  }
  function p() {
    const _ = r.rtl, $ = r.params.pagination;
    if (d())
      return;
    let b = r.pagination.el;
    b = makeElementsArray(b);
    let M, C;
    const S = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : r.slides.length, A = r.params.loop ? Math.ceil(S / r.params.slidesPerGroup) : r.snapGrid.length;
    if (r.params.loop ? (C = r.previousRealIndex || 0, M = r.params.slidesPerGroup > 1 ? Math.floor(r.realIndex / r.params.slidesPerGroup) : r.realIndex) : typeof r.snapIndex < "u" ? (M = r.snapIndex, C = r.previousSnapIndex) : (C = r.previousIndex || 0, M = r.activeIndex || 0), $.type === "bullets" && r.pagination.bullets && r.pagination.bullets.length > 0) {
      const D = r.pagination.bullets;
      let N, T, R;
      if ($.dynamicBullets && (c = elementOuterSize(D[0], r.isHorizontal() ? "width" : "height", !0), b.forEach((F) => {
        F.style[r.isHorizontal() ? "width" : "height"] = `${c * ($.dynamicMainBullets + 4)}px`;
      }), $.dynamicMainBullets > 1 && C !== void 0 && (l += M - (C || 0), l > $.dynamicMainBullets - 1 ? l = $.dynamicMainBullets - 1 : l < 0 && (l = 0)), N = Math.max(M - l, 0), T = N + (Math.min(D.length, $.dynamicMainBullets) - 1), R = (T + N) / 2), D.forEach((F) => {
        const z = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((O) => `${$.bulletActiveClass}${O}`)].map((O) => typeof O == "string" && O.includes(" ") ? O.split(" ") : O).flat();
        F.classList.remove(...z);
      }), b.length > 1)
        D.forEach((F) => {
          const z = elementIndex(F);
          z === M ? F.classList.add(...$.bulletActiveClass.split(" ")) : r.isElement && F.setAttribute("part", "bullet"), $.dynamicBullets && (z >= N && z <= T && F.classList.add(...`${$.bulletActiveClass}-main`.split(" ")), z === N && h(F, "prev"), z === T && h(F, "next"));
        });
      else {
        const F = D[M];
        if (F && F.classList.add(...$.bulletActiveClass.split(" ")), r.isElement && D.forEach((z, O) => {
          z.setAttribute("part", O === M ? "bullet-active" : "bullet");
        }), $.dynamicBullets) {
          const z = D[N], O = D[T];
          for (let G = N; G <= T; G += 1)
            D[G] && D[G].classList.add(...`${$.bulletActiveClass}-main`.split(" "));
          h(z, "prev"), h(O, "next");
        }
      }
      if ($.dynamicBullets) {
        const F = Math.min(D.length, $.dynamicMainBullets + 4), z = (c * F - c) / 2 - R * c, O = _ ? "right" : "left";
        D.forEach((G) => {
          G.style[r.isHorizontal() ? O : "top"] = `${z}px`;
        });
      }
    }
    b.forEach((D, N) => {
      if ($.type === "fraction" && (D.querySelectorAll(classesToSelector($.currentClass)).forEach((T) => {
        T.textContent = $.formatFractionCurrent(M + 1);
      }), D.querySelectorAll(classesToSelector($.totalClass)).forEach((T) => {
        T.textContent = $.formatFractionTotal(A);
      })), $.type === "progressbar") {
        let T;
        $.progressbarOpposite ? T = r.isHorizontal() ? "vertical" : "horizontal" : T = r.isHorizontal() ? "horizontal" : "vertical";
        const R = (M + 1) / A;
        let F = 1, z = 1;
        T === "horizontal" ? F = R : z = R, D.querySelectorAll(classesToSelector($.progressbarFillClass)).forEach((O) => {
          O.style.transform = `translate3d(0,0,0) scaleX(${F}) scaleY(${z})`, O.style.transitionDuration = `${r.params.speed}ms`;
        });
      }
      $.type === "custom" && $.renderCustom ? (D.innerHTML = $.renderCustom(r, M + 1, A), N === 0 && s("paginationRender", D)) : (N === 0 && s("paginationRender", D), s("paginationUpdate", D)), r.params.watchOverflow && r.enabled && D.classList[r.isLocked ? "add" : "remove"]($.lockClass);
    });
  }
  function m() {
    const _ = r.params.pagination;
    if (d())
      return;
    const $ = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : r.grid && r.params.grid.rows > 1 ? r.slides.length / Math.ceil(r.params.grid.rows) : r.slides.length;
    let b = r.pagination.el;
    b = makeElementsArray(b);
    let M = "";
    if (_.type === "bullets") {
      let C = r.params.loop ? Math.ceil($ / r.params.slidesPerGroup) : r.snapGrid.length;
      r.params.freeMode && r.params.freeMode.enabled && C > $ && (C = $);
      for (let S = 0; S < C; S += 1)
        _.renderBullet ? M += _.renderBullet.call(r, S, _.bulletClass) : M += `<${_.bulletElement} ${r.isElement ? 'part="bullet"' : ""} class="${_.bulletClass}"></${_.bulletElement}>`;
    }
    _.type === "fraction" && (_.renderFraction ? M = _.renderFraction.call(r, _.currentClass, _.totalClass) : M = `<span class="${_.currentClass}"></span> / <span class="${_.totalClass}"></span>`), _.type === "progressbar" && (_.renderProgressbar ? M = _.renderProgressbar.call(r, _.progressbarFillClass) : M = `<span class="${_.progressbarFillClass}"></span>`), r.pagination.bullets = [], b.forEach((C) => {
      _.type !== "custom" && (C.innerHTML = M || ""), _.type === "bullets" && r.pagination.bullets.push(...C.querySelectorAll(classesToSelector(_.bulletClass)));
    }), _.type !== "custom" && s("paginationRender", b[0]);
  }
  function g() {
    r.params.pagination = createElementIfNotDefined(r, r.originalParams.pagination, r.params.pagination, {
      el: "swiper-pagination"
    });
    const _ = r.params.pagination;
    if (!_.el)
      return;
    let $;
    typeof _.el == "string" && r.isElement && ($ = r.el.querySelector(_.el)), !$ && typeof _.el == "string" && ($ = [...document.querySelectorAll(_.el)]), $ || ($ = _.el), !(!$ || $.length === 0) && (r.params.uniqueNavElements && typeof _.el == "string" && Array.isArray($) && $.length > 1 && ($ = [...r.el.querySelectorAll(_.el)], $.length > 1 && ($ = $.filter((b) => elementParents(b, ".swiper")[0] === r.el)[0])), Array.isArray($) && $.length === 1 && ($ = $[0]), Object.assign(r.pagination, {
      el: $
    }), $ = makeElementsArray($), $.forEach((b) => {
      _.type === "bullets" && _.clickable && b.classList.add(...(_.clickableClass || "").split(" ")), b.classList.add(_.modifierClass + _.type), b.classList.add(r.isHorizontal() ? _.horizontalClass : _.verticalClass), _.type === "bullets" && _.dynamicBullets && (b.classList.add(`${_.modifierClass}${_.type}-dynamic`), l = 0, _.dynamicMainBullets < 1 && (_.dynamicMainBullets = 1)), _.type === "progressbar" && _.progressbarOpposite && b.classList.add(_.progressbarOppositeClass), _.clickable && b.addEventListener("click", u), r.enabled || b.classList.add(_.lockClass);
    }));
  }
  function v() {
    const _ = r.params.pagination;
    if (d())
      return;
    let $ = r.pagination.el;
    $ && ($ = makeElementsArray($), $.forEach((b) => {
      b.classList.remove(_.hiddenClass), b.classList.remove(_.modifierClass + _.type), b.classList.remove(r.isHorizontal() ? _.horizontalClass : _.verticalClass), _.clickable && (b.classList.remove(...(_.clickableClass || "").split(" ")), b.removeEventListener("click", u));
    })), r.pagination.bullets && r.pagination.bullets.forEach((b) => b.classList.remove(..._.bulletActiveClass.split(" ")));
  }
  a("changeDirection", () => {
    if (!r.pagination || !r.pagination.el)
      return;
    const _ = r.params.pagination;
    let {
      el: $
    } = r.pagination;
    $ = makeElementsArray($), $.forEach((b) => {
      b.classList.remove(_.horizontalClass, _.verticalClass), b.classList.add(r.isHorizontal() ? _.horizontalClass : _.verticalClass);
    });
  }), a("init", () => {
    r.params.pagination.enabled === !1 ? x() : (g(), m(), p());
  }), a("activeIndexChange", () => {
    typeof r.snapIndex > "u" && p();
  }), a("snapIndexChange", () => {
    p();
  }), a("snapGridLengthChange", () => {
    m(), p();
  }), a("destroy", () => {
    v();
  }), a("enable disable", () => {
    let {
      el: _
    } = r.pagination;
    _ && (_ = makeElementsArray(_), _.forEach(($) => $.classList[r.enabled ? "remove" : "add"](r.params.pagination.lockClass)));
  }), a("lock unlock", () => {
    p();
  }), a("click", (_, $) => {
    const b = $.target, M = makeElementsArray(r.pagination.el);
    if (r.params.pagination.el && r.params.pagination.hideOnClick && M && M.length > 0 && !b.classList.contains(r.params.pagination.bulletClass)) {
      if (r.navigation && (r.navigation.nextEl && b === r.navigation.nextEl || r.navigation.prevEl && b === r.navigation.prevEl))
        return;
      const C = M[0].classList.contains(r.params.pagination.hiddenClass);
      s(C === !0 ? "paginationShow" : "paginationHide"), M.forEach((S) => S.classList.toggle(r.params.pagination.hiddenClass));
    }
  });
  const y = () => {
    r.el.classList.remove(r.params.pagination.paginationDisabledClass);
    let {
      el: _
    } = r.pagination;
    _ && (_ = makeElementsArray(_), _.forEach(($) => $.classList.remove(r.params.pagination.paginationDisabledClass))), g(), m(), p();
  }, x = () => {
    r.el.classList.add(r.params.pagination.paginationDisabledClass);
    let {
      el: _
    } = r.pagination;
    _ && (_ = makeElementsArray(_), _.forEach(($) => $.classList.add(r.params.pagination.paginationDisabledClass))), v();
  };
  Object.assign(r.pagination, {
    enable: y,
    disable: x,
    render: m,
    update: p,
    init: g,
    destroy: v
  });
}
function Scrollbar(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  const o = getDocument();
  let c = !1, l = null, d = null, h, u, p, m;
  n({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), r.scrollbar = {
    el: null,
    dragEl: null
  };
  function g() {
    if (!r.params.scrollbar.el || !r.scrollbar.el)
      return;
    const {
      scrollbar: F,
      rtlTranslate: z
    } = r, {
      dragEl: O,
      el: G
    } = F, I = r.params.scrollbar, k = r.params.loop ? r.progressLoop : r.progress;
    let B = u, L = (p - u) * k;
    z ? (L = -L, L > 0 ? (B = u - L, L = 0) : -L + u > p && (B = p + L)) : L < 0 ? (B = u + L, L = 0) : L + u > p && (B = p - L), r.isHorizontal() ? (O.style.transform = `translate3d(${L}px, 0, 0)`, O.style.width = `${B}px`) : (O.style.transform = `translate3d(0px, ${L}px, 0)`, O.style.height = `${B}px`), I.hide && (clearTimeout(l), G.style.opacity = 1, l = setTimeout(() => {
      G.style.opacity = 0, G.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function v(F) {
    !r.params.scrollbar.el || !r.scrollbar.el || (r.scrollbar.dragEl.style.transitionDuration = `${F}ms`);
  }
  function y() {
    if (!r.params.scrollbar.el || !r.scrollbar.el)
      return;
    const {
      scrollbar: F
    } = r, {
      dragEl: z,
      el: O
    } = F;
    z.style.width = "", z.style.height = "", p = r.isHorizontal() ? O.offsetWidth : O.offsetHeight, m = r.size / (r.virtualSize + r.params.slidesOffsetBefore - (r.params.centeredSlides ? r.snapGrid[0] : 0)), r.params.scrollbar.dragSize === "auto" ? u = p * m : u = parseInt(r.params.scrollbar.dragSize, 10), r.isHorizontal() ? z.style.width = `${u}px` : z.style.height = `${u}px`, m >= 1 ? O.style.display = "none" : O.style.display = "", r.params.scrollbar.hide && (O.style.opacity = 0), r.params.watchOverflow && r.enabled && F.el.classList[r.isLocked ? "add" : "remove"](r.params.scrollbar.lockClass);
  }
  function x(F) {
    return r.isHorizontal() ? F.clientX : F.clientY;
  }
  function _(F) {
    const {
      scrollbar: z,
      rtlTranslate: O
    } = r, {
      el: G
    } = z;
    let I;
    I = (x(F) - elementOffset(G)[r.isHorizontal() ? "left" : "top"] - (h !== null ? h : u / 2)) / (p - u), I = Math.max(Math.min(I, 1), 0), O && (I = 1 - I);
    const k = r.minTranslate() + (r.maxTranslate() - r.minTranslate()) * I;
    r.updateProgress(k), r.setTranslate(k), r.updateActiveIndex(), r.updateSlidesClasses();
  }
  function $(F) {
    const z = r.params.scrollbar, {
      scrollbar: O,
      wrapperEl: G
    } = r, {
      el: I,
      dragEl: k
    } = O;
    c = !0, h = F.target === k ? x(F) - F.target.getBoundingClientRect()[r.isHorizontal() ? "left" : "top"] : null, F.preventDefault(), F.stopPropagation(), G.style.transitionDuration = "100ms", k.style.transitionDuration = "100ms", _(F), clearTimeout(d), I.style.transitionDuration = "0ms", z.hide && (I.style.opacity = 1), r.params.cssMode && (r.wrapperEl.style["scroll-snap-type"] = "none"), s("scrollbarDragStart", F);
  }
  function b(F) {
    const {
      scrollbar: z,
      wrapperEl: O
    } = r, {
      el: G,
      dragEl: I
    } = z;
    c && (F.preventDefault && F.cancelable ? F.preventDefault() : F.returnValue = !1, _(F), O.style.transitionDuration = "0ms", G.style.transitionDuration = "0ms", I.style.transitionDuration = "0ms", s("scrollbarDragMove", F));
  }
  function M(F) {
    const z = r.params.scrollbar, {
      scrollbar: O,
      wrapperEl: G
    } = r, {
      el: I
    } = O;
    c && (c = !1, r.params.cssMode && (r.wrapperEl.style["scroll-snap-type"] = "", G.style.transitionDuration = ""), z.hide && (clearTimeout(d), d = nextTick(() => {
      I.style.opacity = 0, I.style.transitionDuration = "400ms";
    }, 1e3)), s("scrollbarDragEnd", F), z.snapOnRelease && r.slideToClosest());
  }
  function C(F) {
    const {
      scrollbar: z,
      params: O
    } = r, G = z.el;
    if (!G)
      return;
    const I = G, k = O.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, B = O.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!I)
      return;
    const L = F === "on" ? "addEventListener" : "removeEventListener";
    I[L]("pointerdown", $, k), o[L]("pointermove", b, k), o[L]("pointerup", M, B);
  }
  function S() {
    !r.params.scrollbar.el || !r.scrollbar.el || C("on");
  }
  function A() {
    !r.params.scrollbar.el || !r.scrollbar.el || C("off");
  }
  function D() {
    const {
      scrollbar: F,
      el: z
    } = r;
    r.params.scrollbar = createElementIfNotDefined(r, r.originalParams.scrollbar, r.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const O = r.params.scrollbar;
    if (!O.el)
      return;
    let G;
    if (typeof O.el == "string" && r.isElement && (G = r.el.querySelector(O.el)), !G && typeof O.el == "string") {
      if (G = o.querySelectorAll(O.el), !G.length)
        return;
    } else
      G || (G = O.el);
    r.params.uniqueNavElements && typeof O.el == "string" && G.length > 1 && z.querySelectorAll(O.el).length === 1 && (G = z.querySelector(O.el)), G.length > 0 && (G = G[0]), G.classList.add(r.isHorizontal() ? O.horizontalClass : O.verticalClass);
    let I;
    G && (I = G.querySelector(classesToSelector(r.params.scrollbar.dragClass)), I || (I = createElement("div", r.params.scrollbar.dragClass), G.append(I))), Object.assign(F, {
      el: G,
      dragEl: I
    }), O.draggable && S(), G && G.classList[r.enabled ? "remove" : "add"](...classesToTokens(r.params.scrollbar.lockClass));
  }
  function N() {
    const F = r.params.scrollbar, z = r.scrollbar.el;
    z && z.classList.remove(...classesToTokens(r.isHorizontal() ? F.horizontalClass : F.verticalClass)), A();
  }
  a("changeDirection", () => {
    if (!r.scrollbar || !r.scrollbar.el)
      return;
    const F = r.params.scrollbar;
    let {
      el: z
    } = r.scrollbar;
    z = makeElementsArray(z), z.forEach((O) => {
      O.classList.remove(F.horizontalClass, F.verticalClass), O.classList.add(r.isHorizontal() ? F.horizontalClass : F.verticalClass);
    });
  }), a("init", () => {
    r.params.scrollbar.enabled === !1 ? R() : (D(), y(), g());
  }), a("update resize observerUpdate lock unlock changeDirection", () => {
    y();
  }), a("setTranslate", () => {
    g();
  }), a("setTransition", (F, z) => {
    v(z);
  }), a("enable disable", () => {
    const {
      el: F
    } = r.scrollbar;
    F && F.classList[r.enabled ? "remove" : "add"](...classesToTokens(r.params.scrollbar.lockClass));
  }), a("destroy", () => {
    N();
  });
  const T = () => {
    r.el.classList.remove(...classesToTokens(r.params.scrollbar.scrollbarDisabledClass)), r.scrollbar.el && r.scrollbar.el.classList.remove(...classesToTokens(r.params.scrollbar.scrollbarDisabledClass)), D(), y(), g();
  }, R = () => {
    r.el.classList.add(...classesToTokens(r.params.scrollbar.scrollbarDisabledClass)), r.scrollbar.el && r.scrollbar.el.classList.add(...classesToTokens(r.params.scrollbar.scrollbarDisabledClass)), N();
  };
  Object.assign(r.scrollbar, {
    enable: T,
    disable: R,
    updateSize: y,
    setTranslate: g,
    init: D,
    destroy: N
  });
}
function Parallax(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    parallax: {
      enabled: !1
    }
  });
  const s = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", o = (d, h) => {
    const {
      rtl: u
    } = r, p = u ? -1 : 1, m = d.getAttribute("data-swiper-parallax") || "0";
    let g = d.getAttribute("data-swiper-parallax-x"), v = d.getAttribute("data-swiper-parallax-y");
    const y = d.getAttribute("data-swiper-parallax-scale"), x = d.getAttribute("data-swiper-parallax-opacity"), _ = d.getAttribute("data-swiper-parallax-rotate");
    if (g || v ? (g = g || "0", v = v || "0") : r.isHorizontal() ? (g = m, v = "0") : (v = m, g = "0"), g.indexOf("%") >= 0 ? g = `${parseInt(g, 10) * h * p}%` : g = `${g * h * p}px`, v.indexOf("%") >= 0 ? v = `${parseInt(v, 10) * h}%` : v = `${v * h}px`, typeof x < "u" && x !== null) {
      const b = x - (x - 1) * (1 - Math.abs(h));
      d.style.opacity = b;
    }
    let $ = `translate3d(${g}, ${v}, 0px)`;
    if (typeof y < "u" && y !== null) {
      const b = y - (y - 1) * (1 - Math.abs(h));
      $ += ` scale(${b})`;
    }
    if (_ && typeof _ < "u" && _ !== null) {
      const b = _ * h * -1;
      $ += ` rotate(${b}deg)`;
    }
    d.style.transform = $;
  }, c = () => {
    const {
      el: d,
      slides: h,
      progress: u,
      snapGrid: p,
      isElement: m
    } = r, g = elementChildren(d, s);
    r.isElement && g.push(...elementChildren(r.hostEl, s)), g.forEach((v) => {
      o(v, u);
    }), h.forEach((v, y) => {
      let x = v.progress;
      r.params.slidesPerGroup > 1 && r.params.slidesPerView !== "auto" && (x += Math.ceil(y / 2) - u * (p.length - 1)), x = Math.min(Math.max(x, -1), 1), v.querySelectorAll(`${s}, [data-swiper-parallax-rotate]`).forEach((_) => {
        o(_, x);
      });
    });
  }, l = function(d) {
    d === void 0 && (d = r.params.speed);
    const {
      el: h,
      hostEl: u
    } = r, p = [...h.querySelectorAll(s)];
    r.isElement && p.push(...u.querySelectorAll(s)), p.forEach((m) => {
      let g = parseInt(m.getAttribute("data-swiper-parallax-duration"), 10) || d;
      d === 0 && (g = 0), m.style.transitionDuration = `${g}ms`;
    });
  };
  a("beforeInit", () => {
    r.params.parallax.enabled && (r.params.watchSlidesProgress = !0, r.originalParams.watchSlidesProgress = !0);
  }), a("init", () => {
    r.params.parallax.enabled && c();
  }), a("setTranslate", () => {
    r.params.parallax.enabled && c();
  }), a("setTransition", (d, h) => {
    r.params.parallax.enabled && l(h);
  });
}
function Zoom(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s
  } = t;
  const o = getWindow$2();
  n({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), r.zoom = {
    enabled: !1
  };
  let c = 1, l = !1, d, h;
  const u = [], p = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, m = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, g = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let v = 1;
  Object.defineProperty(r.zoom, "scale", {
    get() {
      return v;
    },
    set(U) {
      if (v !== U) {
        const J = p.imageEl, q = p.slideEl;
        s("zoomChange", U, J, q);
      }
      v = U;
    }
  });
  function y() {
    if (u.length < 2)
      return 1;
    const U = u[0].pageX, J = u[0].pageY, q = u[1].pageX, Z = u[1].pageY;
    return Math.sqrt((q - U) ** 2 + (Z - J) ** 2);
  }
  function x() {
    const U = r.params.zoom, J = p.imageWrapEl.getAttribute("data-swiper-zoom") || U.maxRatio;
    if (U.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
      const q = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
      return Math.min(q, J);
    }
    return J;
  }
  function _() {
    if (u.length < 2)
      return {
        x: null,
        y: null
      };
    const U = p.imageEl.getBoundingClientRect();
    return [(u[0].pageX + (u[1].pageX - u[0].pageX) / 2 - U.x - o.scrollX) / c, (u[0].pageY + (u[1].pageY - u[0].pageY) / 2 - U.y - o.scrollY) / c];
  }
  function $() {
    return r.isElement ? "swiper-slide" : `.${r.params.slideClass}`;
  }
  function b(U) {
    const J = $();
    return !!(U.target.matches(J) || r.slides.filter((q) => q.contains(U.target)).length > 0);
  }
  function M(U) {
    const J = `.${r.params.zoom.containerClass}`;
    return !!(U.target.matches(J) || [...r.hostEl.querySelectorAll(J)].filter((q) => q.contains(U.target)).length > 0);
  }
  function C(U) {
    if (U.pointerType === "mouse" && u.splice(0, u.length), !b(U))
      return;
    const J = r.params.zoom;
    if (d = !1, h = !1, u.push(U), !(u.length < 2)) {
      if (d = !0, p.scaleStart = y(), !p.slideEl) {
        p.slideEl = U.target.closest(`.${r.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = r.slides[r.activeIndex]);
        let q = p.slideEl.querySelector(`.${J.containerClass}`);
        if (q && (q = q.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = q, q ? p.imageWrapEl = elementParents(p.imageEl, `.${J.containerClass}`)[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
          p.imageEl = void 0;
          return;
        }
        p.maxRatio = x();
      }
      if (p.imageEl) {
        const [q, Z] = _();
        p.originX = q, p.originY = Z, p.imageEl.style.transitionDuration = "0ms";
      }
      l = !0;
    }
  }
  function S(U) {
    if (!b(U))
      return;
    const J = r.params.zoom, q = r.zoom, Z = u.findIndex((ae) => ae.pointerId === U.pointerId);
    Z >= 0 && (u[Z] = U), !(u.length < 2) && (h = !0, p.scaleMove = y(), p.imageEl && (q.scale = p.scaleMove / p.scaleStart * c, q.scale > p.maxRatio && (q.scale = p.maxRatio - 1 + (q.scale - p.maxRatio + 1) ** 0.5), q.scale < J.minRatio && (q.scale = J.minRatio + 1 - (J.minRatio - q.scale + 1) ** 0.5), p.imageEl.style.transform = `translate3d(0,0,0) scale(${q.scale})`));
  }
  function A(U) {
    if (!b(U) || U.pointerType === "mouse" && U.type === "pointerout")
      return;
    const J = r.params.zoom, q = r.zoom, Z = u.findIndex((ae) => ae.pointerId === U.pointerId);
    Z >= 0 && u.splice(Z, 1), !(!d || !h) && (d = !1, h = !1, p.imageEl && (q.scale = Math.max(Math.min(q.scale, p.maxRatio), J.minRatio), p.imageEl.style.transitionDuration = `${r.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${q.scale})`, c = q.scale, l = !1, q.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${J.zoomedSlideClass}`) : q.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${J.zoomedSlideClass}`), q.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
  }
  let D;
  function N() {
    r.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function T() {
    clearTimeout(D), r.touchEventsData.preventTouchMoveFromPointerMove = !0, D = setTimeout(() => {
      N();
    });
  }
  function R(U) {
    const J = r.device;
    if (!p.imageEl || m.isTouched)
      return;
    J.android && U.cancelable && U.preventDefault(), m.isTouched = !0;
    const q = u.length > 0 ? u[0] : U;
    m.touchesStart.x = q.pageX, m.touchesStart.y = q.pageY;
  }
  function F(U) {
    if (!b(U) || !M(U))
      return;
    const J = r.zoom;
    if (!p.imageEl || !m.isTouched || !p.slideEl)
      return;
    m.isMoved || (m.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, m.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, m.startX = getTranslate(p.imageWrapEl, "x") || 0, m.startY = getTranslate(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
    const q = m.width * J.scale, Z = m.height * J.scale;
    if (m.minX = Math.min(p.slideWidth / 2 - q / 2, 0), m.maxX = -m.minX, m.minY = Math.min(p.slideHeight / 2 - Z / 2, 0), m.maxY = -m.minY, m.touchesCurrent.x = u.length > 0 ? u[0].pageX : U.pageX, m.touchesCurrent.y = u.length > 0 ? u[0].pageY : U.pageY, Math.max(Math.abs(m.touchesCurrent.x - m.touchesStart.x), Math.abs(m.touchesCurrent.y - m.touchesStart.y)) > 5 && (r.allowClick = !1), !m.isMoved && !l) {
      if (r.isHorizontal() && (Math.floor(m.minX) === Math.floor(m.startX) && m.touchesCurrent.x < m.touchesStart.x || Math.floor(m.maxX) === Math.floor(m.startX) && m.touchesCurrent.x > m.touchesStart.x)) {
        m.isTouched = !1, N();
        return;
      }
      if (!r.isHorizontal() && (Math.floor(m.minY) === Math.floor(m.startY) && m.touchesCurrent.y < m.touchesStart.y || Math.floor(m.maxY) === Math.floor(m.startY) && m.touchesCurrent.y > m.touchesStart.y)) {
        m.isTouched = !1, N();
        return;
      }
    }
    U.cancelable && U.preventDefault(), U.stopPropagation(), T(), m.isMoved = !0;
    const ee = (J.scale - c) / (p.maxRatio - r.params.zoom.minRatio), {
      originX: se,
      originY: nr
    } = p;
    m.currentX = m.touchesCurrent.x - m.touchesStart.x + m.startX + ee * (m.width - se * 2), m.currentY = m.touchesCurrent.y - m.touchesStart.y + m.startY + ee * (m.height - nr * 2), m.currentX < m.minX && (m.currentX = m.minX + 1 - (m.minX - m.currentX + 1) ** 0.8), m.currentX > m.maxX && (m.currentX = m.maxX - 1 + (m.currentX - m.maxX + 1) ** 0.8), m.currentY < m.minY && (m.currentY = m.minY + 1 - (m.minY - m.currentY + 1) ** 0.8), m.currentY > m.maxY && (m.currentY = m.maxY - 1 + (m.currentY - m.maxY + 1) ** 0.8), g.prevPositionX || (g.prevPositionX = m.touchesCurrent.x), g.prevPositionY || (g.prevPositionY = m.touchesCurrent.y), g.prevTime || (g.prevTime = Date.now()), g.x = (m.touchesCurrent.x - g.prevPositionX) / (Date.now() - g.prevTime) / 2, g.y = (m.touchesCurrent.y - g.prevPositionY) / (Date.now() - g.prevTime) / 2, Math.abs(m.touchesCurrent.x - g.prevPositionX) < 2 && (g.x = 0), Math.abs(m.touchesCurrent.y - g.prevPositionY) < 2 && (g.y = 0), g.prevPositionX = m.touchesCurrent.x, g.prevPositionY = m.touchesCurrent.y, g.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`;
  }
  function z() {
    const U = r.zoom;
    if (!p.imageEl)
      return;
    if (!m.isTouched || !m.isMoved) {
      m.isTouched = !1, m.isMoved = !1;
      return;
    }
    m.isTouched = !1, m.isMoved = !1;
    let J = 300, q = 300;
    const Z = g.x * J, ae = m.currentX + Z, ee = g.y * q, se = m.currentY + ee;
    g.x !== 0 && (J = Math.abs((ae - m.currentX) / g.x)), g.y !== 0 && (q = Math.abs((se - m.currentY) / g.y));
    const nr = Math.max(J, q);
    m.currentX = ae, m.currentY = se;
    const ce = m.width * U.scale, oe = m.height * U.scale;
    m.minX = Math.min(p.slideWidth / 2 - ce / 2, 0), m.maxX = -m.minX, m.minY = Math.min(p.slideHeight / 2 - oe / 2, 0), m.maxY = -m.minY, m.currentX = Math.max(Math.min(m.currentX, m.maxX), m.minX), m.currentY = Math.max(Math.min(m.currentY, m.maxY), m.minY), p.imageWrapEl.style.transitionDuration = `${nr}ms`, p.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`;
  }
  function O() {
    const U = r.zoom;
    p.slideEl && r.activeIndex !== r.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${r.params.zoom.zoomedSlideClass}`), U.scale = 1, c = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
  }
  function G(U) {
    const J = r.zoom, q = r.params.zoom;
    if (!p.slideEl) {
      U && U.target && (p.slideEl = U.target.closest(`.${r.params.slideClass}, swiper-slide`)), p.slideEl || (r.params.virtual && r.params.virtual.enabled && r.virtual ? p.slideEl = elementChildren(r.slidesEl, `.${r.params.slideActiveClass}`)[0] : p.slideEl = r.slides[r.activeIndex]);
      let wr = p.slideEl.querySelector(`.${q.containerClass}`);
      wr && (wr = wr.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = wr, wr ? p.imageWrapEl = elementParents(p.imageEl, `.${q.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    if (!p.imageEl || !p.imageWrapEl)
      return;
    r.params.cssMode && (r.wrapperEl.style.overflow = "hidden", r.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${q.zoomedSlideClass}`);
    let Z, ae, ee, se, nr, ce, oe, ur, ir, _r, yr, ne, pe, hr, $r, Sr, ze, cr;
    typeof m.touchesStart.x > "u" && U ? (Z = U.pageX, ae = U.pageY) : (Z = m.touchesStart.x, ae = m.touchesStart.y);
    const fr = typeof U == "number" ? U : null;
    c === 1 && fr && (Z = void 0, ae = void 0);
    const mr = x();
    J.scale = fr || mr, c = fr || mr, U && !(c === 1 && fr) ? (ze = p.slideEl.offsetWidth, cr = p.slideEl.offsetHeight, ee = elementOffset(p.slideEl).left + o.scrollX, se = elementOffset(p.slideEl).top + o.scrollY, nr = ee + ze / 2 - Z, ce = se + cr / 2 - ae, ir = p.imageEl.offsetWidth || p.imageEl.clientWidth, _r = p.imageEl.offsetHeight || p.imageEl.clientHeight, yr = ir * J.scale, ne = _r * J.scale, pe = Math.min(ze / 2 - yr / 2, 0), hr = Math.min(cr / 2 - ne / 2, 0), $r = -pe, Sr = -hr, oe = nr * J.scale, ur = ce * J.scale, oe < pe && (oe = pe), oe > $r && (oe = $r), ur < hr && (ur = hr), ur > Sr && (ur = Sr)) : (oe = 0, ur = 0), fr && J.scale === 1 && (p.originX = 0, p.originY = 0), p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${oe}px, ${ur}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${J.scale})`;
  }
  function I() {
    const U = r.zoom, J = r.params.zoom;
    if (!p.slideEl) {
      r.params.virtual && r.params.virtual.enabled && r.virtual ? p.slideEl = elementChildren(r.slidesEl, `.${r.params.slideActiveClass}`)[0] : p.slideEl = r.slides[r.activeIndex];
      let q = p.slideEl.querySelector(`.${J.containerClass}`);
      q && (q = q.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = q, q ? p.imageWrapEl = elementParents(p.imageEl, `.${J.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    !p.imageEl || !p.imageWrapEl || (r.params.cssMode && (r.wrapperEl.style.overflow = "", r.wrapperEl.style.touchAction = ""), U.scale = 1, c = 1, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${J.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0);
  }
  function k(U) {
    const J = r.zoom;
    J.scale && J.scale !== 1 ? I() : G(U);
  }
  function B() {
    const U = r.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, J = r.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: U,
      activeListenerWithCapture: J
    };
  }
  function L() {
    const U = r.zoom;
    if (U.enabled)
      return;
    U.enabled = !0;
    const {
      passiveListener: J,
      activeListenerWithCapture: q
    } = B();
    r.wrapperEl.addEventListener("pointerdown", C, J), r.wrapperEl.addEventListener("pointermove", S, q), ["pointerup", "pointercancel", "pointerout"].forEach((Z) => {
      r.wrapperEl.addEventListener(Z, A, J);
    }), r.wrapperEl.addEventListener("pointermove", F, q);
  }
  function V() {
    const U = r.zoom;
    if (!U.enabled)
      return;
    U.enabled = !1;
    const {
      passiveListener: J,
      activeListenerWithCapture: q
    } = B();
    r.wrapperEl.removeEventListener("pointerdown", C, J), r.wrapperEl.removeEventListener("pointermove", S, q), ["pointerup", "pointercancel", "pointerout"].forEach((Z) => {
      r.wrapperEl.removeEventListener(Z, A, J);
    }), r.wrapperEl.removeEventListener("pointermove", F, q);
  }
  a("init", () => {
    r.params.zoom.enabled && L();
  }), a("destroy", () => {
    V();
  }), a("touchStart", (U, J) => {
    r.zoom.enabled && R(J);
  }), a("touchEnd", (U, J) => {
    r.zoom.enabled && z();
  }), a("doubleTap", (U, J) => {
    !r.animating && r.params.zoom.enabled && r.zoom.enabled && r.params.zoom.toggle && k(J);
  }), a("transitionEnd", () => {
    r.zoom.enabled && r.params.zoom.enabled && O();
  }), a("slideChange", () => {
    r.zoom.enabled && r.params.zoom.enabled && r.params.cssMode && O();
  }), Object.assign(r.zoom, {
    enable: L,
    disable: V,
    in: G,
    out: I,
    toggle: k
  });
}
function Controller(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), r.controller = {
    control: void 0
  };
  function s(h, u) {
    const p = function() {
      let y, x, _;
      return ($, b) => {
        for (x = -1, y = $.length; y - x > 1; )
          _ = y + x >> 1, $[_] <= b ? x = _ : y = _;
        return y;
      };
    }();
    this.x = h, this.y = u, this.lastIndex = h.length - 1;
    let m, g;
    return this.interpolate = function(y) {
      return y ? (g = p(this.x, y), m = g - 1, (y - this.x[m]) * (this.y[g] - this.y[m]) / (this.x[g] - this.x[m]) + this.y[m]) : 0;
    }, this;
  }
  function o(h) {
    r.controller.spline = r.params.loop ? new s(r.slidesGrid, h.slidesGrid) : new s(r.snapGrid, h.snapGrid);
  }
  function c(h, u) {
    const p = r.controller.control;
    let m, g;
    const v = r.constructor;
    function y(x) {
      if (x.destroyed)
        return;
      const _ = r.rtlTranslate ? -r.translate : r.translate;
      r.params.controller.by === "slide" && (o(x), g = -r.controller.spline.interpolate(-_)), (!g || r.params.controller.by === "container") && (m = (x.maxTranslate() - x.minTranslate()) / (r.maxTranslate() - r.minTranslate()), (Number.isNaN(m) || !Number.isFinite(m)) && (m = 1), g = (_ - r.minTranslate()) * m + x.minTranslate()), r.params.controller.inverse && (g = x.maxTranslate() - g), x.updateProgress(g), x.setTranslate(g, r), x.updateActiveIndex(), x.updateSlidesClasses();
    }
    if (Array.isArray(p))
      for (let x = 0; x < p.length; x += 1)
        p[x] !== u && p[x] instanceof v && y(p[x]);
    else
      p instanceof v && u !== p && y(p);
  }
  function l(h, u) {
    const p = r.constructor, m = r.controller.control;
    let g;
    function v(y) {
      y.destroyed || (y.setTransition(h, r), h !== 0 && (y.transitionStart(), y.params.autoHeight && nextTick(() => {
        y.updateAutoHeight();
      }), elementTransitionEnd(y.wrapperEl, () => {
        m && y.transitionEnd();
      })));
    }
    if (Array.isArray(m))
      for (g = 0; g < m.length; g += 1)
        m[g] !== u && m[g] instanceof p && v(m[g]);
    else
      m instanceof p && u !== m && v(m);
  }
  function d() {
    r.controller.control && r.controller.spline && (r.controller.spline = void 0, delete r.controller.spline);
  }
  a("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof r.params.controller.control == "string" || r.params.controller.control instanceof HTMLElement)) {
      (typeof r.params.controller.control == "string" ? [...document.querySelectorAll(r.params.controller.control)] : [r.params.controller.control]).forEach((u) => {
        if (r.controller.control || (r.controller.control = []), u && u.swiper)
          r.controller.control.push(u.swiper);
        else if (u) {
          const p = `${r.params.eventsPrefix}init`, m = (g) => {
            r.controller.control.push(g.detail[0]), r.update(), u.removeEventListener(p, m);
          };
          u.addEventListener(p, m);
        }
      });
      return;
    }
    r.controller.control = r.params.controller.control;
  }), a("update", () => {
    d();
  }), a("resize", () => {
    d();
  }), a("observerUpdate", () => {
    d();
  }), a("setTranslate", (h, u, p) => {
    !r.controller.control || r.controller.control.destroyed || r.controller.setTranslate(u, p);
  }), a("setTransition", (h, u, p) => {
    !r.controller.control || r.controller.control.destroyed || r.controller.setTransition(u, p);
  }), Object.assign(r.controller, {
    setTranslate: c,
    setTransition: l
  });
}
function A11y(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), r.a11y = {
    clicked: !1
  };
  let s = null, o, c, l = (/* @__PURE__ */ new Date()).getTime();
  function d(k) {
    const B = s;
    B.length !== 0 && (B.innerHTML = "", B.innerHTML = k);
  }
  function h(k) {
    k === void 0 && (k = 16);
    const B = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(k).replace(/x/g, B);
  }
  function u(k) {
    k = makeElementsArray(k), k.forEach((B) => {
      B.setAttribute("tabIndex", "0");
    });
  }
  function p(k) {
    k = makeElementsArray(k), k.forEach((B) => {
      B.setAttribute("tabIndex", "-1");
    });
  }
  function m(k, B) {
    k = makeElementsArray(k), k.forEach((L) => {
      L.setAttribute("role", B);
    });
  }
  function g(k, B) {
    k = makeElementsArray(k), k.forEach((L) => {
      L.setAttribute("aria-roledescription", B);
    });
  }
  function v(k, B) {
    k = makeElementsArray(k), k.forEach((L) => {
      L.setAttribute("aria-controls", B);
    });
  }
  function y(k, B) {
    k = makeElementsArray(k), k.forEach((L) => {
      L.setAttribute("aria-label", B);
    });
  }
  function x(k, B) {
    k = makeElementsArray(k), k.forEach((L) => {
      L.setAttribute("id", B);
    });
  }
  function _(k, B) {
    k = makeElementsArray(k), k.forEach((L) => {
      L.setAttribute("aria-live", B);
    });
  }
  function $(k) {
    k = makeElementsArray(k), k.forEach((B) => {
      B.setAttribute("aria-disabled", !0);
    });
  }
  function b(k) {
    k = makeElementsArray(k), k.forEach((B) => {
      B.setAttribute("aria-disabled", !1);
    });
  }
  function M(k) {
    if (k.keyCode !== 13 && k.keyCode !== 32)
      return;
    const B = r.params.a11y, L = k.target;
    if (!(r.pagination && r.pagination.el && (L === r.pagination.el || r.pagination.el.contains(k.target)) && !k.target.matches(classesToSelector(r.params.pagination.bulletClass)))) {
      if (r.navigation && r.navigation.prevEl && r.navigation.nextEl) {
        const V = makeElementsArray(r.navigation.prevEl);
        makeElementsArray(r.navigation.nextEl).includes(L) && (r.isEnd && !r.params.loop || r.slideNext(), r.isEnd ? d(B.lastSlideMessage) : d(B.nextSlideMessage)), V.includes(L) && (r.isBeginning && !r.params.loop || r.slidePrev(), r.isBeginning ? d(B.firstSlideMessage) : d(B.prevSlideMessage));
      }
      r.pagination && L.matches(classesToSelector(r.params.pagination.bulletClass)) && L.click();
    }
  }
  function C() {
    if (r.params.loop || r.params.rewind || !r.navigation)
      return;
    const {
      nextEl: k,
      prevEl: B
    } = r.navigation;
    B && (r.isBeginning ? ($(B), p(B)) : (b(B), u(B))), k && (r.isEnd ? ($(k), p(k)) : (b(k), u(k)));
  }
  function S() {
    return r.pagination && r.pagination.bullets && r.pagination.bullets.length;
  }
  function A() {
    return S() && r.params.pagination.clickable;
  }
  function D() {
    const k = r.params.a11y;
    S() && r.pagination.bullets.forEach((B) => {
      r.params.pagination.clickable && (u(B), r.params.pagination.renderBullet || (m(B, "button"), y(B, k.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(B) + 1)))), B.matches(classesToSelector(r.params.pagination.bulletActiveClass)) ? B.setAttribute("aria-current", "true") : B.removeAttribute("aria-current");
    });
  }
  const N = (k, B, L) => {
    u(k), k.tagName !== "BUTTON" && (m(k, "button"), k.addEventListener("keydown", M)), y(k, L), v(k, B);
  }, T = (k) => {
    c && c !== k.target && !c.contains(k.target) && (o = !0), r.a11y.clicked = !0;
  }, R = () => {
    o = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        r.destroyed || (r.a11y.clicked = !1);
      });
    });
  }, F = (k) => {
    l = (/* @__PURE__ */ new Date()).getTime();
  }, z = (k) => {
    if (r.a11y.clicked || !r.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - l < 100)
      return;
    const B = k.target.closest(`.${r.params.slideClass}, swiper-slide`);
    if (!B || !r.slides.includes(B))
      return;
    c = B;
    const L = r.slides.indexOf(B) === r.activeIndex, V = r.params.watchSlidesProgress && r.visibleSlides && r.visibleSlides.includes(B);
    L || V || k.sourceCapabilities && k.sourceCapabilities.firesTouchEvents || (r.isHorizontal() ? r.el.scrollLeft = 0 : r.el.scrollTop = 0, requestAnimationFrame(() => {
      o || (r.params.loop ? r.slideToLoop(parseInt(B.getAttribute("data-swiper-slide-index")), 0) : r.slideTo(r.slides.indexOf(B), 0), o = !1);
    }));
  }, O = () => {
    const k = r.params.a11y;
    k.itemRoleDescriptionMessage && g(r.slides, k.itemRoleDescriptionMessage), k.slideRole && m(r.slides, k.slideRole);
    const B = r.slides.length;
    k.slideLabelMessage && r.slides.forEach((L, V) => {
      const U = r.params.loop ? parseInt(L.getAttribute("data-swiper-slide-index"), 10) : V, J = k.slideLabelMessage.replace(/\{\{index\}\}/, U + 1).replace(/\{\{slidesLength\}\}/, B);
      y(L, J);
    });
  }, G = () => {
    const k = r.params.a11y;
    r.el.append(s);
    const B = r.el;
    k.containerRoleDescriptionMessage && g(B, k.containerRoleDescriptionMessage), k.containerMessage && y(B, k.containerMessage);
    const L = r.wrapperEl, V = k.id || L.getAttribute("id") || `swiper-wrapper-${h(16)}`, U = r.params.autoplay && r.params.autoplay.enabled ? "off" : "polite";
    x(L, V), _(L, U), O();
    let {
      nextEl: J,
      prevEl: q
    } = r.navigation ? r.navigation : {};
    J = makeElementsArray(J), q = makeElementsArray(q), J && J.forEach((ae) => N(ae, V, k.nextSlideMessage)), q && q.forEach((ae) => N(ae, V, k.prevSlideMessage)), A() && makeElementsArray(r.pagination.el).forEach((ee) => {
      ee.addEventListener("keydown", M);
    }), getDocument().addEventListener("visibilitychange", F), r.el.addEventListener("focus", z, !0), r.el.addEventListener("focus", z, !0), r.el.addEventListener("pointerdown", T, !0), r.el.addEventListener("pointerup", R, !0);
  };
  function I() {
    s && s.remove();
    let {
      nextEl: k,
      prevEl: B
    } = r.navigation ? r.navigation : {};
    k = makeElementsArray(k), B = makeElementsArray(B), k && k.forEach((V) => V.removeEventListener("keydown", M)), B && B.forEach((V) => V.removeEventListener("keydown", M)), A() && makeElementsArray(r.pagination.el).forEach((U) => {
      U.removeEventListener("keydown", M);
    }), getDocument().removeEventListener("visibilitychange", F), r.el && typeof r.el != "string" && (r.el.removeEventListener("focus", z, !0), r.el.removeEventListener("pointerdown", T, !0), r.el.removeEventListener("pointerup", R, !0));
  }
  a("beforeInit", () => {
    s = createElement("span", r.params.a11y.notificationClass), s.setAttribute("aria-live", "assertive"), s.setAttribute("aria-atomic", "true");
  }), a("afterInit", () => {
    r.params.a11y.enabled && G();
  }), a("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    r.params.a11y.enabled && O();
  }), a("fromEdge toEdge afterInit lock unlock", () => {
    r.params.a11y.enabled && C();
  }), a("paginationUpdate", () => {
    r.params.a11y.enabled && D();
  }), a("destroy", () => {
    r.params.a11y.enabled && I();
  });
}
function History(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let s = !1, o = {};
  const c = (g) => g.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), l = (g) => {
    const v = getWindow$2();
    let y;
    g ? y = new URL(g) : y = v.location;
    const x = y.pathname.slice(1).split("/").filter((M) => M !== ""), _ = x.length, $ = x[_ - 2], b = x[_ - 1];
    return {
      key: $,
      value: b
    };
  }, d = (g, v) => {
    const y = getWindow$2();
    if (!s || !r.params.history.enabled)
      return;
    let x;
    r.params.url ? x = new URL(r.params.url) : x = y.location;
    const _ = r.virtual && r.params.virtual.enabled ? r.slidesEl.querySelector(`[data-swiper-slide-index="${v}"]`) : r.slides[v];
    let $ = c(_.getAttribute("data-history"));
    if (r.params.history.root.length > 0) {
      let M = r.params.history.root;
      M[M.length - 1] === "/" && (M = M.slice(0, M.length - 1)), $ = `${M}/${g ? `${g}/` : ""}${$}`;
    } else
      x.pathname.includes(g) || ($ = `${g ? `${g}/` : ""}${$}`);
    r.params.history.keepQuery && ($ += x.search);
    const b = y.history.state;
    b && b.value === $ || (r.params.history.replaceState ? y.history.replaceState({
      value: $
    }, null, $) : y.history.pushState({
      value: $
    }, null, $));
  }, h = (g, v, y) => {
    if (v)
      for (let x = 0, _ = r.slides.length; x < _; x += 1) {
        const $ = r.slides[x];
        if (c($.getAttribute("data-history")) === v) {
          const M = r.getSlideIndex($);
          r.slideTo(M, g, y);
        }
      }
    else
      r.slideTo(0, g, y);
  }, u = () => {
    o = l(r.params.url), h(r.params.speed, o.value, !1);
  }, p = () => {
    const g = getWindow$2();
    if (r.params.history) {
      if (!g.history || !g.history.pushState) {
        r.params.history.enabled = !1, r.params.hashNavigation.enabled = !0;
        return;
      }
      if (s = !0, o = l(r.params.url), !o.key && !o.value) {
        r.params.history.replaceState || g.addEventListener("popstate", u);
        return;
      }
      h(0, o.value, r.params.runCallbacksOnInit), r.params.history.replaceState || g.addEventListener("popstate", u);
    }
  }, m = () => {
    const g = getWindow$2();
    r.params.history.replaceState || g.removeEventListener("popstate", u);
  };
  a("init", () => {
    r.params.history.enabled && p();
  }), a("destroy", () => {
    r.params.history.enabled && m();
  }), a("transitionEnd _freeModeNoMomentumRelease", () => {
    s && d(r.params.history.key, r.activeIndex);
  }), a("slideChange", () => {
    s && r.params.cssMode && d(r.params.history.key, r.activeIndex);
  });
}
function HashNavigation(t) {
  let {
    swiper: r,
    extendParams: n,
    emit: a,
    on: s
  } = t, o = !1;
  const c = getDocument(), l = getWindow$2();
  n({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(m, g) {
        if (r.virtual && r.params.virtual.enabled) {
          const v = r.slides.filter((x) => x.getAttribute("data-hash") === g)[0];
          return v ? parseInt(v.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return r.getSlideIndex(elementChildren(r.slidesEl, `.${r.params.slideClass}[data-hash="${g}"], swiper-slide[data-hash="${g}"]`)[0]);
      }
    }
  });
  const d = () => {
    a("hashChange");
    const m = c.location.hash.replace("#", ""), g = r.virtual && r.params.virtual.enabled ? r.slidesEl.querySelector(`[data-swiper-slide-index="${r.activeIndex}"]`) : r.slides[r.activeIndex], v = g ? g.getAttribute("data-hash") : "";
    if (m !== v) {
      const y = r.params.hashNavigation.getSlideIndex(r, m);
      if (typeof y > "u" || Number.isNaN(y))
        return;
      r.slideTo(y);
    }
  }, h = () => {
    if (!o || !r.params.hashNavigation.enabled)
      return;
    const m = r.virtual && r.params.virtual.enabled ? r.slidesEl.querySelector(`[data-swiper-slide-index="${r.activeIndex}"]`) : r.slides[r.activeIndex], g = m ? m.getAttribute("data-hash") || m.getAttribute("data-history") : "";
    r.params.hashNavigation.replaceState && l.history && l.history.replaceState ? (l.history.replaceState(null, null, `#${g}` || ""), a("hashSet")) : (c.location.hash = g || "", a("hashSet"));
  }, u = () => {
    if (!r.params.hashNavigation.enabled || r.params.history && r.params.history.enabled)
      return;
    o = !0;
    const m = c.location.hash.replace("#", "");
    if (m) {
      const v = r.params.hashNavigation.getSlideIndex(r, m);
      r.slideTo(v || 0, 0, r.params.runCallbacksOnInit, !0);
    }
    r.params.hashNavigation.watchState && l.addEventListener("hashchange", d);
  }, p = () => {
    r.params.hashNavigation.watchState && l.removeEventListener("hashchange", d);
  };
  s("init", () => {
    r.params.hashNavigation.enabled && u();
  }), s("destroy", () => {
    r.params.hashNavigation.enabled && p();
  }), s("transitionEnd _freeModeNoMomentumRelease", () => {
    o && h();
  }), s("slideChange", () => {
    o && r.params.cssMode && h();
  });
}
function Autoplay(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a,
    emit: s,
    params: o
  } = t;
  r.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, n({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let c, l, d = o && o.autoplay ? o.autoplay.delay : 3e3, h = o && o.autoplay ? o.autoplay.delay : 3e3, u, p = (/* @__PURE__ */ new Date()).getTime(), m, g, v, y, x, _, $;
  function b(B) {
    !r || r.destroyed || !r.wrapperEl || B.target === r.wrapperEl && (r.wrapperEl.removeEventListener("transitionend", b), !($ || B.detail && B.detail.bySwiperTouchMove) && T());
  }
  const M = () => {
    if (r.destroyed || !r.autoplay.running)
      return;
    r.autoplay.paused ? m = !0 : m && (h = u, m = !1);
    const B = r.autoplay.paused ? u : p + h - (/* @__PURE__ */ new Date()).getTime();
    r.autoplay.timeLeft = B, s("autoplayTimeLeft", B, B / d), l = requestAnimationFrame(() => {
      M();
    });
  }, C = () => {
    let B;
    return r.virtual && r.params.virtual.enabled ? B = r.slides.filter((V) => V.classList.contains("swiper-slide-active"))[0] : B = r.slides[r.activeIndex], B ? parseInt(B.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, S = (B) => {
    if (r.destroyed || !r.autoplay.running)
      return;
    cancelAnimationFrame(l), M();
    let L = typeof B > "u" ? r.params.autoplay.delay : B;
    d = r.params.autoplay.delay, h = r.params.autoplay.delay;
    const V = C();
    !Number.isNaN(V) && V > 0 && typeof B > "u" && (L = V, d = V, h = V), u = L;
    const U = r.params.speed, J = () => {
      !r || r.destroyed || (r.params.autoplay.reverseDirection ? !r.isBeginning || r.params.loop || r.params.rewind ? (r.slidePrev(U, !0, !0), s("autoplay")) : r.params.autoplay.stopOnLastSlide || (r.slideTo(r.slides.length - 1, U, !0, !0), s("autoplay")) : !r.isEnd || r.params.loop || r.params.rewind ? (r.slideNext(U, !0, !0), s("autoplay")) : r.params.autoplay.stopOnLastSlide || (r.slideTo(0, U, !0, !0), s("autoplay")), r.params.cssMode && (p = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        S();
      })));
    };
    return L > 0 ? (clearTimeout(c), c = setTimeout(() => {
      J();
    }, L)) : requestAnimationFrame(() => {
      J();
    }), L;
  }, A = () => {
    p = (/* @__PURE__ */ new Date()).getTime(), r.autoplay.running = !0, S(), s("autoplayStart");
  }, D = () => {
    r.autoplay.running = !1, clearTimeout(c), cancelAnimationFrame(l), s("autoplayStop");
  }, N = (B, L) => {
    if (r.destroyed || !r.autoplay.running)
      return;
    clearTimeout(c), B || (_ = !0);
    const V = () => {
      s("autoplayPause"), r.params.autoplay.waitForTransition ? r.wrapperEl.addEventListener("transitionend", b) : T();
    };
    if (r.autoplay.paused = !0, L) {
      x && (u = r.params.autoplay.delay), x = !1, V();
      return;
    }
    u = (u || r.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - p), !(r.isEnd && u < 0 && !r.params.loop) && (u < 0 && (u = 0), V());
  }, T = () => {
    r.isEnd && u < 0 && !r.params.loop || r.destroyed || !r.autoplay.running || (p = (/* @__PURE__ */ new Date()).getTime(), _ ? (_ = !1, S(u)) : S(), r.autoplay.paused = !1, s("autoplayResume"));
  }, R = () => {
    if (r.destroyed || !r.autoplay.running)
      return;
    const B = getDocument();
    B.visibilityState === "hidden" && (_ = !0, N(!0)), B.visibilityState === "visible" && T();
  }, F = (B) => {
    B.pointerType === "mouse" && (_ = !0, $ = !0, !(r.animating || r.autoplay.paused) && N(!0));
  }, z = (B) => {
    B.pointerType === "mouse" && ($ = !1, r.autoplay.paused && T());
  }, O = () => {
    r.params.autoplay.pauseOnMouseEnter && (r.el.addEventListener("pointerenter", F), r.el.addEventListener("pointerleave", z));
  }, G = () => {
    r.el && typeof r.el != "string" && (r.el.removeEventListener("pointerenter", F), r.el.removeEventListener("pointerleave", z));
  }, I = () => {
    getDocument().addEventListener("visibilitychange", R);
  }, k = () => {
    getDocument().removeEventListener("visibilitychange", R);
  };
  a("init", () => {
    r.params.autoplay.enabled && (O(), I(), A());
  }), a("destroy", () => {
    G(), k(), r.autoplay.running && D();
  }), a("_freeModeStaticRelease", () => {
    (v || _) && T();
  }), a("_freeModeNoMomentumRelease", () => {
    r.params.autoplay.disableOnInteraction ? D() : N(!0, !0);
  }), a("beforeTransitionStart", (B, L, V) => {
    r.destroyed || !r.autoplay.running || (V || !r.params.autoplay.disableOnInteraction ? N(!0, !0) : D());
  }), a("sliderFirstMove", () => {
    if (!(r.destroyed || !r.autoplay.running)) {
      if (r.params.autoplay.disableOnInteraction) {
        D();
        return;
      }
      g = !0, v = !1, _ = !1, y = setTimeout(() => {
        _ = !0, v = !0, N(!0);
      }, 200);
    }
  }), a("touchEnd", () => {
    if (!(r.destroyed || !r.autoplay.running || !g)) {
      if (clearTimeout(y), clearTimeout(c), r.params.autoplay.disableOnInteraction) {
        v = !1, g = !1;
        return;
      }
      v && r.params.cssMode && T(), v = !1, g = !1;
    }
  }), a("slideChange", () => {
    r.destroyed || !r.autoplay.running || (x = !0);
  }), Object.assign(r.autoplay, {
    start: A,
    stop: D,
    pause: N,
    resume: T
  });
}
function Thumb(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let s = !1, o = !1;
  r.thumbs = {
    swiper: null
  };
  function c() {
    const h = r.thumbs.swiper;
    if (!h || h.destroyed)
      return;
    const u = h.clickedIndex, p = h.clickedSlide;
    if (p && p.classList.contains(r.params.thumbs.slideThumbActiveClass) || typeof u > "u" || u === null)
      return;
    let m;
    h.params.loop ? m = parseInt(h.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : m = u, r.params.loop ? r.slideToLoop(m) : r.slideTo(m);
  }
  function l() {
    const {
      thumbs: h
    } = r.params;
    if (s)
      return !1;
    s = !0;
    const u = r.constructor;
    if (h.swiper instanceof u)
      r.thumbs.swiper = h.swiper, Object.assign(r.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(r.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), r.thumbs.swiper.update();
    else if (isObject$5(h.swiper)) {
      const p = Object.assign({}, h.swiper);
      Object.assign(p, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), r.thumbs.swiper = new u(p), o = !0;
    }
    return r.thumbs.swiper.el.classList.add(r.params.thumbs.thumbsContainerClass), r.thumbs.swiper.on("tap", c), !0;
  }
  function d(h) {
    const u = r.thumbs.swiper;
    if (!u || u.destroyed)
      return;
    const p = u.params.slidesPerView === "auto" ? u.slidesPerViewDynamic() : u.params.slidesPerView;
    let m = 1;
    const g = r.params.thumbs.slideThumbActiveClass;
    if (r.params.slidesPerView > 1 && !r.params.centeredSlides && (m = r.params.slidesPerView), r.params.thumbs.multipleActiveThumbs || (m = 1), m = Math.floor(m), u.slides.forEach((x) => x.classList.remove(g)), u.params.loop || u.params.virtual && u.params.virtual.enabled)
      for (let x = 0; x < m; x += 1)
        elementChildren(u.slidesEl, `[data-swiper-slide-index="${r.realIndex + x}"]`).forEach((_) => {
          _.classList.add(g);
        });
    else
      for (let x = 0; x < m; x += 1)
        u.slides[r.realIndex + x] && u.slides[r.realIndex + x].classList.add(g);
    const v = r.params.thumbs.autoScrollOffset, y = v && !u.params.loop;
    if (r.realIndex !== u.realIndex || y) {
      const x = u.activeIndex;
      let _, $;
      if (u.params.loop) {
        const b = u.slides.filter((M) => M.getAttribute("data-swiper-slide-index") === `${r.realIndex}`)[0];
        _ = u.slides.indexOf(b), $ = r.activeIndex > r.previousIndex ? "next" : "prev";
      } else
        _ = r.realIndex, $ = _ > r.previousIndex ? "next" : "prev";
      y && (_ += $ === "next" ? v : -1 * v), u.visibleSlidesIndexes && u.visibleSlidesIndexes.indexOf(_) < 0 && (u.params.centeredSlides ? _ > x ? _ = _ - Math.floor(p / 2) + 1 : _ = _ + Math.floor(p / 2) - 1 : _ > x && u.params.slidesPerGroup, u.slideTo(_, h ? 0 : void 0));
    }
  }
  a("beforeInit", () => {
    const {
      thumbs: h
    } = r.params;
    if (!(!h || !h.swiper))
      if (typeof h.swiper == "string" || h.swiper instanceof HTMLElement) {
        const u = getDocument(), p = () => {
          const g = typeof h.swiper == "string" ? u.querySelector(h.swiper) : h.swiper;
          if (g && g.swiper)
            h.swiper = g.swiper, l(), d(!0);
          else if (g) {
            const v = `${r.params.eventsPrefix}init`, y = (x) => {
              h.swiper = x.detail[0], g.removeEventListener(v, y), l(), d(!0), h.swiper.update(), r.update();
            };
            g.addEventListener(v, y);
          }
          return g;
        }, m = () => {
          if (r.destroyed)
            return;
          p() || requestAnimationFrame(m);
        };
        requestAnimationFrame(m);
      } else
        l(), d(!0);
  }), a("slideChange update resize observerUpdate", () => {
    d();
  }), a("setTransition", (h, u) => {
    const p = r.thumbs.swiper;
    !p || p.destroyed || p.setTransition(u);
  }), a("beforeDestroy", () => {
    const h = r.thumbs.swiper;
    !h || h.destroyed || o && h.destroy();
  }), Object.assign(r.thumbs, {
    init: l,
    update: d
  });
}
function freeMode(t) {
  let {
    swiper: r,
    extendParams: n,
    emit: a,
    once: s
  } = t;
  n({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function o() {
    if (r.params.cssMode)
      return;
    const d = r.getTranslate();
    r.setTranslate(d), r.setTransition(0), r.touchEventsData.velocities.length = 0, r.freeMode.onTouchEnd({
      currentPos: r.rtl ? r.translate : -r.translate
    });
  }
  function c() {
    if (r.params.cssMode)
      return;
    const {
      touchEventsData: d,
      touches: h
    } = r;
    d.velocities.length === 0 && d.velocities.push({
      position: h[r.isHorizontal() ? "startX" : "startY"],
      time: d.touchStartTime
    }), d.velocities.push({
      position: h[r.isHorizontal() ? "currentX" : "currentY"],
      time: now$1()
    });
  }
  function l(d) {
    let {
      currentPos: h
    } = d;
    if (r.params.cssMode)
      return;
    const {
      params: u,
      wrapperEl: p,
      rtlTranslate: m,
      snapGrid: g,
      touchEventsData: v
    } = r, x = now$1() - v.touchStartTime;
    if (h < -r.minTranslate()) {
      r.slideTo(r.activeIndex);
      return;
    }
    if (h > -r.maxTranslate()) {
      r.slides.length < g.length ? r.slideTo(g.length - 1) : r.slideTo(r.slides.length - 1);
      return;
    }
    if (u.freeMode.momentum) {
      if (v.velocities.length > 1) {
        const D = v.velocities.pop(), N = v.velocities.pop(), T = D.position - N.position, R = D.time - N.time;
        r.velocity = T / R, r.velocity /= 2, Math.abs(r.velocity) < u.freeMode.minimumVelocity && (r.velocity = 0), (R > 150 || now$1() - D.time > 300) && (r.velocity = 0);
      } else
        r.velocity = 0;
      r.velocity *= u.freeMode.momentumVelocityRatio, v.velocities.length = 0;
      let _ = 1e3 * u.freeMode.momentumRatio;
      const $ = r.velocity * _;
      let b = r.translate + $;
      m && (b = -b);
      let M = !1, C;
      const S = Math.abs(r.velocity) * 20 * u.freeMode.momentumBounceRatio;
      let A;
      if (b < r.maxTranslate())
        u.freeMode.momentumBounce ? (b + r.maxTranslate() < -S && (b = r.maxTranslate() - S), C = r.maxTranslate(), M = !0, v.allowMomentumBounce = !0) : b = r.maxTranslate(), u.loop && u.centeredSlides && (A = !0);
      else if (b > r.minTranslate())
        u.freeMode.momentumBounce ? (b - r.minTranslate() > S && (b = r.minTranslate() + S), C = r.minTranslate(), M = !0, v.allowMomentumBounce = !0) : b = r.minTranslate(), u.loop && u.centeredSlides && (A = !0);
      else if (u.freeMode.sticky) {
        let D;
        for (let N = 0; N < g.length; N += 1)
          if (g[N] > -b) {
            D = N;
            break;
          }
        Math.abs(g[D] - b) < Math.abs(g[D - 1] - b) || r.swipeDirection === "next" ? b = g[D] : b = g[D - 1], b = -b;
      }
      if (A && s("transitionEnd", () => {
        r.loopFix();
      }), r.velocity !== 0) {
        if (m ? _ = Math.abs((-b - r.translate) / r.velocity) : _ = Math.abs((b - r.translate) / r.velocity), u.freeMode.sticky) {
          const D = Math.abs((m ? -b : b) - r.translate), N = r.slidesSizesGrid[r.activeIndex];
          D < N ? _ = u.speed : D < 2 * N ? _ = u.speed * 1.5 : _ = u.speed * 2.5;
        }
      } else if (u.freeMode.sticky) {
        r.slideToClosest();
        return;
      }
      u.freeMode.momentumBounce && M ? (r.updateProgress(C), r.setTransition(_), r.setTranslate(b), r.transitionStart(!0, r.swipeDirection), r.animating = !0, elementTransitionEnd(p, () => {
        !r || r.destroyed || !v.allowMomentumBounce || (a("momentumBounce"), r.setTransition(u.speed), setTimeout(() => {
          r.setTranslate(C), elementTransitionEnd(p, () => {
            !r || r.destroyed || r.transitionEnd();
          });
        }, 0));
      })) : r.velocity ? (a("_freeModeNoMomentumRelease"), r.updateProgress(b), r.setTransition(_), r.setTranslate(b), r.transitionStart(!0, r.swipeDirection), r.animating || (r.animating = !0, elementTransitionEnd(p, () => {
        !r || r.destroyed || r.transitionEnd();
      }))) : r.updateProgress(b), r.updateActiveIndex(), r.updateSlidesClasses();
    } else if (u.freeMode.sticky) {
      r.slideToClosest();
      return;
    } else
      u.freeMode && a("_freeModeNoMomentumRelease");
    (!u.freeMode.momentum || x >= u.longSwipesMs) && (a("_freeModeStaticRelease"), r.updateProgress(), r.updateActiveIndex(), r.updateSlidesClasses());
  }
  Object.assign(r, {
    freeMode: {
      onTouchStart: o,
      onTouchMove: c,
      onTouchEnd: l
    }
  });
}
function Grid(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let s, o, c, l;
  const d = () => {
    let y = r.params.spaceBetween;
    return typeof y == "string" && y.indexOf("%") >= 0 ? y = parseFloat(y.replace("%", "")) / 100 * r.size : typeof y == "string" && (y = parseFloat(y)), y;
  }, h = (y) => {
    const {
      slidesPerView: x
    } = r.params, {
      rows: _,
      fill: $
    } = r.params.grid, b = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : y.length;
    c = Math.floor(b / _), Math.floor(b / _) === b / _ ? s = b : s = Math.ceil(b / _) * _, x !== "auto" && $ === "row" && (s = Math.max(s, x * _)), o = s / _;
  }, u = () => {
    r.slides && r.slides.forEach((y) => {
      y.swiperSlideGridSet && (y.style.height = "", y.style[r.getDirectionLabel("margin-top")] = "");
    });
  }, p = (y, x, _) => {
    const {
      slidesPerGroup: $
    } = r.params, b = d(), {
      rows: M,
      fill: C
    } = r.params.grid, S = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : _.length;
    let A, D, N;
    if (C === "row" && $ > 1) {
      const T = Math.floor(y / ($ * M)), R = y - M * $ * T, F = T === 0 ? $ : Math.min(Math.ceil((S - T * M * $) / M), $);
      N = Math.floor(R / F), D = R - N * F + T * $, A = D + N * s / M, x.style.order = A;
    } else
      C === "column" ? (D = Math.floor(y / M), N = y - D * M, (D > c || D === c && N === M - 1) && (N += 1, N >= M && (N = 0, D += 1))) : (N = Math.floor(y / o), D = y - N * o);
    x.row = N, x.column = D, x.style.height = `calc((100% - ${(M - 1) * b}px) / ${M})`, x.style[r.getDirectionLabel("margin-top")] = N !== 0 ? b && `${b}px` : "", x.swiperSlideGridSet = !0;
  }, m = (y, x) => {
    const {
      centeredSlides: _,
      roundLengths: $
    } = r.params, b = d(), {
      rows: M
    } = r.params.grid;
    if (r.virtualSize = (y + b) * s, r.virtualSize = Math.ceil(r.virtualSize / M) - b, r.params.cssMode || (r.wrapperEl.style[r.getDirectionLabel("width")] = `${r.virtualSize + b}px`), _) {
      const C = [];
      for (let S = 0; S < x.length; S += 1) {
        let A = x[S];
        $ && (A = Math.floor(A)), x[S] < r.virtualSize + x[0] && C.push(A);
      }
      x.splice(0, x.length), x.push(...C);
    }
  }, g = () => {
    l = r.params.grid && r.params.grid.rows > 1;
  }, v = () => {
    const {
      params: y,
      el: x
    } = r, _ = y.grid && y.grid.rows > 1;
    l && !_ ? (x.classList.remove(`${y.containerModifierClass}grid`, `${y.containerModifierClass}grid-column`), c = 1, r.emitContainerClasses()) : !l && _ && (x.classList.add(`${y.containerModifierClass}grid`), y.grid.fill === "column" && x.classList.add(`${y.containerModifierClass}grid-column`), r.emitContainerClasses()), l = _;
  };
  a("init", g), a("update", v), r.grid = {
    initSlides: h,
    unsetSlides: u,
    updateSlide: p,
    updateWrapperSize: m
  };
}
function appendSlide(t) {
  const r = this, {
    params: n,
    slidesEl: a
  } = r;
  n.loop && r.loopDestroy();
  const s = (o) => {
    if (typeof o == "string") {
      const c = document.createElement("div");
      c.innerHTML = o, a.append(c.children[0]), c.innerHTML = "";
    } else
      a.append(o);
  };
  if (typeof t == "object" && "length" in t)
    for (let o = 0; o < t.length; o += 1)
      t[o] && s(t[o]);
  else
    s(t);
  r.recalcSlides(), n.loop && r.loopCreate(), (!n.observer || r.isElement) && r.update();
}
function prependSlide(t) {
  const r = this, {
    params: n,
    activeIndex: a,
    slidesEl: s
  } = r;
  n.loop && r.loopDestroy();
  let o = a + 1;
  const c = (l) => {
    if (typeof l == "string") {
      const d = document.createElement("div");
      d.innerHTML = l, s.prepend(d.children[0]), d.innerHTML = "";
    } else
      s.prepend(l);
  };
  if (typeof t == "object" && "length" in t) {
    for (let l = 0; l < t.length; l += 1)
      t[l] && c(t[l]);
    o = a + t.length;
  } else
    c(t);
  r.recalcSlides(), n.loop && r.loopCreate(), (!n.observer || r.isElement) && r.update(), r.slideTo(o, 0, !1);
}
function addSlide(t, r) {
  const n = this, {
    params: a,
    activeIndex: s,
    slidesEl: o
  } = n;
  let c = s;
  a.loop && (c -= n.loopedSlides, n.loopDestroy(), n.recalcSlides());
  const l = n.slides.length;
  if (t <= 0) {
    n.prependSlide(r);
    return;
  }
  if (t >= l) {
    n.appendSlide(r);
    return;
  }
  let d = c > t ? c + 1 : c;
  const h = [];
  for (let u = l - 1; u >= t; u -= 1) {
    const p = n.slides[u];
    p.remove(), h.unshift(p);
  }
  if (typeof r == "object" && "length" in r) {
    for (let u = 0; u < r.length; u += 1)
      r[u] && o.append(r[u]);
    d = c > t ? c + r.length : c;
  } else
    o.append(r);
  for (let u = 0; u < h.length; u += 1)
    o.append(h[u]);
  n.recalcSlides(), a.loop && n.loopCreate(), (!a.observer || n.isElement) && n.update(), a.loop ? n.slideTo(d + n.loopedSlides, 0, !1) : n.slideTo(d, 0, !1);
}
function removeSlide(t) {
  const r = this, {
    params: n,
    activeIndex: a
  } = r;
  let s = a;
  n.loop && (s -= r.loopedSlides, r.loopDestroy());
  let o = s, c;
  if (typeof t == "object" && "length" in t) {
    for (let l = 0; l < t.length; l += 1)
      c = t[l], r.slides[c] && r.slides[c].remove(), c < o && (o -= 1);
    o = Math.max(o, 0);
  } else
    c = t, r.slides[c] && r.slides[c].remove(), c < o && (o -= 1), o = Math.max(o, 0);
  r.recalcSlides(), n.loop && r.loopCreate(), (!n.observer || r.isElement) && r.update(), n.loop ? r.slideTo(o + r.loopedSlides, 0, !1) : r.slideTo(o, 0, !1);
}
function removeAllSlides() {
  const t = this, r = [];
  for (let n = 0; n < t.slides.length; n += 1)
    r.push(n);
  t.removeSlide(r);
}
function Manipulation(t) {
  let {
    swiper: r
  } = t;
  Object.assign(r, {
    appendSlide: appendSlide.bind(r),
    prependSlide: prependSlide.bind(r),
    addSlide: addSlide.bind(r),
    removeSlide: removeSlide.bind(r),
    removeAllSlides: removeAllSlides.bind(r)
  });
}
function effectInit(t) {
  const {
    effect: r,
    swiper: n,
    on: a,
    setTranslate: s,
    setTransition: o,
    overwriteParams: c,
    perspective: l,
    recreateShadows: d,
    getEffectParams: h
  } = t;
  a("beforeInit", () => {
    if (n.params.effect !== r)
      return;
    n.classNames.push(`${n.params.containerModifierClass}${r}`), l && l() && n.classNames.push(`${n.params.containerModifierClass}3d`);
    const p = c ? c() : {};
    Object.assign(n.params, p), Object.assign(n.originalParams, p);
  }), a("setTranslate", () => {
    n.params.effect === r && s();
  }), a("setTransition", (p, m) => {
    n.params.effect === r && o(m);
  }), a("transitionEnd", () => {
    if (n.params.effect === r && d) {
      if (!h || !h().slideShadows)
        return;
      n.slides.forEach((p) => {
        p.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((m) => m.remove());
      }), d();
    }
  });
  let u;
  a("virtualUpdate", () => {
    n.params.effect === r && (n.slides.length || (u = !0), requestAnimationFrame(() => {
      u && n.slides && n.slides.length && (s(), u = !1);
    }));
  });
}
function effectTarget(t, r) {
  const n = getSlideTransformEl(r);
  return n !== r && (n.style.backfaceVisibility = "hidden", n.style["-webkit-backface-visibility"] = "hidden"), n;
}
function effectVirtualTransitionEnd(t) {
  let {
    swiper: r,
    duration: n,
    transformElements: a,
    allSlides: s
  } = t;
  const {
    activeIndex: o
  } = r, c = (l) => l.parentElement ? l.parentElement : r.slides.filter((h) => h.shadowRoot && h.shadowRoot === l.parentNode)[0];
  if (r.params.virtualTranslate && n !== 0) {
    let l = !1, d;
    s ? d = a : d = a.filter((h) => {
      const u = h.classList.contains("swiper-slide-transform") ? c(h) : h;
      return r.getSlideIndex(u) === o;
    }), d.forEach((h) => {
      elementTransitionEnd(h, () => {
        if (l || !r || r.destroyed)
          return;
        l = !0, r.animating = !1;
        const u = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        r.wrapperEl.dispatchEvent(u);
      });
    });
  }
}
function EffectFade(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    fadeEffect: {
      crossFade: !1
    }
  }), effectInit({
    effect: "fade",
    swiper: r,
    on: a,
    setTranslate: () => {
      const {
        slides: c
      } = r, l = r.params.fadeEffect;
      for (let d = 0; d < c.length; d += 1) {
        const h = r.slides[d];
        let p = -h.swiperSlideOffset;
        r.params.virtualTranslate || (p -= r.translate);
        let m = 0;
        r.isHorizontal() || (m = p, p = 0);
        const g = r.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(h.progress), 0) : 1 + Math.min(Math.max(h.progress, -1), 0), v = effectTarget(l, h);
        v.style.opacity = g, v.style.transform = `translate3d(${p}px, ${m}px, 0px)`;
      }
    },
    setTransition: (c) => {
      const l = r.slides.map((d) => getSlideTransformEl(d));
      l.forEach((d) => {
        d.style.transitionDuration = `${c}ms`;
      }), effectVirtualTransitionEnd({
        swiper: r,
        duration: c,
        transformElements: l,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !r.params.cssMode
    })
  });
}
function EffectCube(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const s = (d, h, u) => {
    let p = u ? d.querySelector(".swiper-slide-shadow-left") : d.querySelector(".swiper-slide-shadow-top"), m = u ? d.querySelector(".swiper-slide-shadow-right") : d.querySelector(".swiper-slide-shadow-bottom");
    p || (p = createElement("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "left" : "top"}`.split(" ")), d.append(p)), m || (m = createElement("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "right" : "bottom"}`.split(" ")), d.append(m)), p && (p.style.opacity = Math.max(-h, 0)), m && (m.style.opacity = Math.max(h, 0));
  };
  effectInit({
    effect: "cube",
    swiper: r,
    on: a,
    setTranslate: () => {
      const {
        el: d,
        wrapperEl: h,
        slides: u,
        width: p,
        height: m,
        rtlTranslate: g,
        size: v,
        browser: y
      } = r, x = getRotateFix(r), _ = r.params.cubeEffect, $ = r.isHorizontal(), b = r.virtual && r.params.virtual.enabled;
      let M = 0, C;
      _.shadow && ($ ? (C = r.wrapperEl.querySelector(".swiper-cube-shadow"), C || (C = createElement("div", "swiper-cube-shadow"), r.wrapperEl.append(C)), C.style.height = `${p}px`) : (C = d.querySelector(".swiper-cube-shadow"), C || (C = createElement("div", "swiper-cube-shadow"), d.append(C))));
      for (let A = 0; A < u.length; A += 1) {
        const D = u[A];
        let N = A;
        b && (N = parseInt(D.getAttribute("data-swiper-slide-index"), 10));
        let T = N * 90, R = Math.floor(T / 360);
        g && (T = -T, R = Math.floor(-T / 360));
        const F = Math.max(Math.min(D.progress, 1), -1);
        let z = 0, O = 0, G = 0;
        N % 4 === 0 ? (z = -R * 4 * v, G = 0) : (N - 1) % 4 === 0 ? (z = 0, G = -R * 4 * v) : (N - 2) % 4 === 0 ? (z = v + R * 4 * v, G = v) : (N - 3) % 4 === 0 && (z = -v, G = 3 * v + v * 4 * R), g && (z = -z), $ || (O = z, z = 0);
        const I = `rotateX(${x($ ? 0 : -T)}deg) rotateY(${x($ ? T : 0)}deg) translate3d(${z}px, ${O}px, ${G}px)`;
        F <= 1 && F > -1 && (M = N * 90 + F * 90, g && (M = -N * 90 - F * 90)), D.style.transform = I, _.slideShadows && s(D, F, $);
      }
      if (h.style.transformOrigin = `50% 50% -${v / 2}px`, h.style["-webkit-transform-origin"] = `50% 50% -${v / 2}px`, _.shadow)
        if ($)
          C.style.transform = `translate3d(0px, ${p / 2 + _.shadowOffset}px, ${-p / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${_.shadowScale})`;
        else {
          const A = Math.abs(M) - Math.floor(Math.abs(M) / 90) * 90, D = 1.5 - (Math.sin(A * 2 * Math.PI / 360) / 2 + Math.cos(A * 2 * Math.PI / 360) / 2), N = _.shadowScale, T = _.shadowScale / D, R = _.shadowOffset;
          C.style.transform = `scale3d(${N}, 1, ${T}) translate3d(0px, ${m / 2 + R}px, ${-m / 2 / T}px) rotateX(-89.99deg)`;
        }
      const S = (y.isSafari || y.isWebView) && y.needPerspectiveFix ? -v / 2 : 0;
      h.style.transform = `translate3d(0px,0,${S}px) rotateX(${x(r.isHorizontal() ? 0 : M)}deg) rotateY(${x(r.isHorizontal() ? -M : 0)}deg)`, h.style.setProperty("--swiper-cube-translate-z", `${S}px`);
    },
    setTransition: (d) => {
      const {
        el: h,
        slides: u
      } = r;
      if (u.forEach((p) => {
        p.style.transitionDuration = `${d}ms`, p.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((m) => {
          m.style.transitionDuration = `${d}ms`;
        });
      }), r.params.cubeEffect.shadow && !r.isHorizontal()) {
        const p = h.querySelector(".swiper-cube-shadow");
        p && (p.style.transitionDuration = `${d}ms`);
      }
    },
    recreateShadows: () => {
      const d = r.isHorizontal();
      r.slides.forEach((h) => {
        const u = Math.max(Math.min(h.progress, 1), -1);
        s(h, u, d);
      });
    },
    getEffectParams: () => r.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function createShadow(t, r, n) {
  const a = `swiper-slide-shadow${n ? `-${n}` : ""}${t ? ` swiper-slide-shadow-${t}` : ""}`, s = getSlideTransformEl(r);
  let o = s.querySelector(`.${a.split(" ").join(".")}`);
  return o || (o = createElement("div", a.split(" ")), s.append(o)), o;
}
function EffectFlip(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const s = (d, h) => {
    let u = r.isHorizontal() ? d.querySelector(".swiper-slide-shadow-left") : d.querySelector(".swiper-slide-shadow-top"), p = r.isHorizontal() ? d.querySelector(".swiper-slide-shadow-right") : d.querySelector(".swiper-slide-shadow-bottom");
    u || (u = createShadow("flip", d, r.isHorizontal() ? "left" : "top")), p || (p = createShadow("flip", d, r.isHorizontal() ? "right" : "bottom")), u && (u.style.opacity = Math.max(-h, 0)), p && (p.style.opacity = Math.max(h, 0));
  };
  effectInit({
    effect: "flip",
    swiper: r,
    on: a,
    setTranslate: () => {
      const {
        slides: d,
        rtlTranslate: h
      } = r, u = r.params.flipEffect, p = getRotateFix(r);
      for (let m = 0; m < d.length; m += 1) {
        const g = d[m];
        let v = g.progress;
        r.params.flipEffect.limitRotation && (v = Math.max(Math.min(g.progress, 1), -1));
        const y = g.swiperSlideOffset;
        let _ = -180 * v, $ = 0, b = r.params.cssMode ? -y - r.translate : -y, M = 0;
        r.isHorizontal() ? h && (_ = -_) : (M = b, b = 0, $ = -_, _ = 0), g.style.zIndex = -Math.abs(Math.round(v)) + d.length, u.slideShadows && s(g, v);
        const C = `translate3d(${b}px, ${M}px, 0px) rotateX(${p($)}deg) rotateY(${p(_)}deg)`, S = effectTarget(u, g);
        S.style.transform = C;
      }
    },
    setTransition: (d) => {
      const h = r.slides.map((u) => getSlideTransformEl(u));
      h.forEach((u) => {
        u.style.transitionDuration = `${d}ms`, u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((p) => {
          p.style.transitionDuration = `${d}ms`;
        });
      }), effectVirtualTransitionEnd({
        swiper: r,
        duration: d,
        transformElements: h
      });
    },
    recreateShadows: () => {
      r.params.flipEffect, r.slides.forEach((d) => {
        let h = d.progress;
        r.params.flipEffect.limitRotation && (h = Math.max(Math.min(d.progress, 1), -1)), s(d, h);
      });
    },
    getEffectParams: () => r.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !r.params.cssMode
    })
  });
}
function EffectCoverflow(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), effectInit({
    effect: "coverflow",
    swiper: r,
    on: a,
    setTranslate: () => {
      const {
        width: c,
        height: l,
        slides: d,
        slidesSizesGrid: h
      } = r, u = r.params.coverflowEffect, p = r.isHorizontal(), m = r.translate, g = p ? -m + c / 2 : -m + l / 2, v = p ? u.rotate : -u.rotate, y = u.depth, x = getRotateFix(r);
      for (let _ = 0, $ = d.length; _ < $; _ += 1) {
        const b = d[_], M = h[_], C = b.swiperSlideOffset, S = (g - C - M / 2) / M, A = typeof u.modifier == "function" ? u.modifier(S) : S * u.modifier;
        let D = p ? v * A : 0, N = p ? 0 : v * A, T = -y * Math.abs(A), R = u.stretch;
        typeof R == "string" && R.indexOf("%") !== -1 && (R = parseFloat(u.stretch) / 100 * M);
        let F = p ? 0 : R * A, z = p ? R * A : 0, O = 1 - (1 - u.scale) * Math.abs(A);
        Math.abs(z) < 1e-3 && (z = 0), Math.abs(F) < 1e-3 && (F = 0), Math.abs(T) < 1e-3 && (T = 0), Math.abs(D) < 1e-3 && (D = 0), Math.abs(N) < 1e-3 && (N = 0), Math.abs(O) < 1e-3 && (O = 0);
        const G = `translate3d(${z}px,${F}px,${T}px)  rotateX(${x(N)}deg) rotateY(${x(D)}deg) scale(${O})`, I = effectTarget(u, b);
        if (I.style.transform = G, b.style.zIndex = -Math.abs(Math.round(A)) + 1, u.slideShadows) {
          let k = p ? b.querySelector(".swiper-slide-shadow-left") : b.querySelector(".swiper-slide-shadow-top"), B = p ? b.querySelector(".swiper-slide-shadow-right") : b.querySelector(".swiper-slide-shadow-bottom");
          k || (k = createShadow("coverflow", b, p ? "left" : "top")), B || (B = createShadow("coverflow", b, p ? "right" : "bottom")), k && (k.style.opacity = A > 0 ? A : 0), B && (B.style.opacity = -A > 0 ? -A : 0);
        }
      }
    },
    setTransition: (c) => {
      r.slides.map((d) => getSlideTransformEl(d)).forEach((d) => {
        d.style.transitionDuration = `${c}ms`, d.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((h) => {
          h.style.transitionDuration = `${c}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function EffectCreative(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const s = (l) => typeof l == "string" ? l : `${l}px`;
  effectInit({
    effect: "creative",
    swiper: r,
    on: a,
    setTranslate: () => {
      const {
        slides: l,
        wrapperEl: d,
        slidesSizesGrid: h
      } = r, u = r.params.creativeEffect, {
        progressMultiplier: p
      } = u, m = r.params.centeredSlides, g = getRotateFix(r);
      if (m) {
        const v = h[0] / 2 - r.params.slidesOffsetBefore || 0;
        d.style.transform = `translateX(calc(50% - ${v}px))`;
      }
      for (let v = 0; v < l.length; v += 1) {
        const y = l[v], x = y.progress, _ = Math.min(Math.max(y.progress, -u.limitProgress), u.limitProgress);
        let $ = _;
        m || ($ = Math.min(Math.max(y.originalProgress, -u.limitProgress), u.limitProgress));
        const b = y.swiperSlideOffset, M = [r.params.cssMode ? -b - r.translate : -b, 0, 0], C = [0, 0, 0];
        let S = !1;
        r.isHorizontal() || (M[1] = M[0], M[0] = 0);
        let A = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        _ < 0 ? (A = u.next, S = !0) : _ > 0 && (A = u.prev, S = !0), M.forEach((O, G) => {
          M[G] = `calc(${O}px + (${s(A.translate[G])} * ${Math.abs(_ * p)}))`;
        }), C.forEach((O, G) => {
          let I = A.rotate[G] * Math.abs(_ * p);
          C[G] = I;
        }), y.style.zIndex = -Math.abs(Math.round(x)) + l.length;
        const D = M.join(", "), N = `rotateX(${g(C[0])}deg) rotateY(${g(C[1])}deg) rotateZ(${g(C[2])}deg)`, T = $ < 0 ? `scale(${1 + (1 - A.scale) * $ * p})` : `scale(${1 - (1 - A.scale) * $ * p})`, R = $ < 0 ? 1 + (1 - A.opacity) * $ * p : 1 - (1 - A.opacity) * $ * p, F = `translate3d(${D}) ${N} ${T}`;
        if (S && A.shadow || !S) {
          let O = y.querySelector(".swiper-slide-shadow");
          if (!O && A.shadow && (O = createShadow("creative", y)), O) {
            const G = u.shadowPerProgress ? _ * (1 / u.limitProgress) : _;
            O.style.opacity = Math.min(Math.max(Math.abs(G), 0), 1);
          }
        }
        const z = effectTarget(u, y);
        z.style.transform = F, z.style.opacity = R, A.origin && (z.style.transformOrigin = A.origin);
      }
    },
    setTransition: (l) => {
      const d = r.slides.map((h) => getSlideTransformEl(h));
      d.forEach((h) => {
        h.style.transitionDuration = `${l}ms`, h.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
          u.style.transitionDuration = `${l}ms`;
        });
      }), effectVirtualTransitionEnd({
        swiper: r,
        duration: l,
        transformElements: d,
        allSlides: !0
      });
    },
    perspective: () => r.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !r.params.cssMode
    })
  });
}
function EffectCards(t) {
  let {
    swiper: r,
    extendParams: n,
    on: a
  } = t;
  n({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), effectInit({
    effect: "cards",
    swiper: r,
    on: a,
    setTranslate: () => {
      const {
        slides: c,
        activeIndex: l,
        rtlTranslate: d
      } = r, h = r.params.cardsEffect, {
        startTranslate: u,
        isTouched: p
      } = r.touchEventsData, m = d ? -r.translate : r.translate;
      for (let g = 0; g < c.length; g += 1) {
        const v = c[g], y = v.progress, x = Math.min(Math.max(y, -4), 4);
        let _ = v.swiperSlideOffset;
        r.params.centeredSlides && !r.params.cssMode && (r.wrapperEl.style.transform = `translateX(${r.minTranslate()}px)`), r.params.centeredSlides && r.params.cssMode && (_ -= c[0].swiperSlideOffset);
        let $ = r.params.cssMode ? -_ - r.translate : -_, b = 0;
        const M = -100 * Math.abs(x);
        let C = 1, S = -h.perSlideRotate * x, A = h.perSlideOffset - Math.abs(x) * 0.75;
        const D = r.virtual && r.params.virtual.enabled ? r.virtual.from + g : g, N = (D === l || D === l - 1) && x > 0 && x < 1 && (p || r.params.cssMode) && m < u, T = (D === l || D === l + 1) && x < 0 && x > -1 && (p || r.params.cssMode) && m > u;
        if (N || T) {
          const O = (1 - Math.abs((Math.abs(x) - 0.5) / 0.5)) ** 0.5;
          S += -28 * x * O, C += -0.5 * O, A += 96 * O, b = `${-25 * O * Math.abs(x)}%`;
        }
        if (x < 0 ? $ = `calc(${$}px ${d ? "-" : "+"} (${A * Math.abs(x)}%))` : x > 0 ? $ = `calc(${$}px ${d ? "-" : "+"} (-${A * Math.abs(x)}%))` : $ = `${$}px`, !r.isHorizontal()) {
          const O = b;
          b = $, $ = O;
        }
        const R = x < 0 ? `${1 + (1 - C) * x}` : `${1 - (1 - C) * x}`, F = `
        translate3d(${$}, ${b}, ${M}px)
        rotateZ(${h.rotate ? d ? -S : S : 0}deg)
        scale(${R})
      `;
        if (h.slideShadows) {
          let O = v.querySelector(".swiper-slide-shadow");
          O || (O = createShadow("cards", v)), O && (O.style.opacity = Math.min(Math.max((Math.abs(x) - 0.5) / 0.5, 0), 1));
        }
        v.style.zIndex = -Math.abs(Math.round(y)) + c.length;
        const z = effectTarget(h, v);
        z.style.transform = F;
      }
    },
    setTransition: (c) => {
      const l = r.slides.map((d) => getSlideTransformEl(d));
      l.forEach((d) => {
        d.style.transitionDuration = `${c}ms`, d.querySelectorAll(".swiper-slide-shadow").forEach((h) => {
          h.style.transitionDuration = `${c}ms`;
        });
      }), effectVirtualTransitionEnd({
        swiper: r,
        duration: c,
        transformElements: l
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !r.params.cssMode
    })
  });
}
const modules = [Virtual, Keyboard, Mousewheel, Navigation$1, Pagination, Scrollbar, Parallax, Zoom, Controller, A11y, History, HashNavigation, Autoplay, Thumb, freeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards];
Swiper.use(modules);
const paramsList = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function isObject$4(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function extend$2(t, r) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(r).filter((a) => n.indexOf(a) < 0).forEach((a) => {
    typeof t[a] > "u" ? t[a] = r[a] : isObject$4(r[a]) && isObject$4(t[a]) && Object.keys(r[a]).length > 0 ? r[a].__swiper__ ? t[a] = r[a] : extend$2(t[a], r[a]) : t[a] = r[a];
  });
}
function needsNavigation(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function needsPagination(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function needsScrollbar(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function attrToProp(t) {
  return t === void 0 && (t = ""), t.replace(/-[a-z]/g, (r) => r.toUpperCase().replace("-", ""));
}
function updateSwiper(t) {
  let {
    swiper: r,
    slides: n,
    passedParams: a,
    changedParams: s,
    nextEl: o,
    prevEl: c,
    scrollbarEl: l,
    paginationEl: d
  } = t;
  const h = s.filter((N) => N !== "children" && N !== "direction" && N !== "wrapperClass"), {
    params: u,
    pagination: p,
    navigation: m,
    scrollbar: g,
    virtual: v,
    thumbs: y
  } = r;
  let x, _, $, b, M, C, S, A;
  s.includes("thumbs") && a.thumbs && a.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (x = !0), s.includes("controller") && a.controller && a.controller.control && u.controller && !u.controller.control && (_ = !0), s.includes("pagination") && a.pagination && (a.pagination.el || d) && (u.pagination || u.pagination === !1) && p && !p.el && ($ = !0), s.includes("scrollbar") && a.scrollbar && (a.scrollbar.el || l) && (u.scrollbar || u.scrollbar === !1) && g && !g.el && (b = !0), s.includes("navigation") && a.navigation && (a.navigation.prevEl || c) && (a.navigation.nextEl || o) && (u.navigation || u.navigation === !1) && m && !m.prevEl && !m.nextEl && (M = !0);
  const D = (N) => {
    r[N] && (r[N].destroy(), N === "navigation" ? (r.isElement && (r[N].prevEl.remove(), r[N].nextEl.remove()), u[N].prevEl = void 0, u[N].nextEl = void 0, r[N].prevEl = void 0, r[N].nextEl = void 0) : (r.isElement && r[N].el.remove(), u[N].el = void 0, r[N].el = void 0));
  };
  s.includes("loop") && r.isElement && (u.loop && !a.loop ? C = !0 : !u.loop && a.loop ? S = !0 : A = !0), h.forEach((N) => {
    if (isObject$4(u[N]) && isObject$4(a[N]))
      Object.assign(u[N], a[N]), (N === "navigation" || N === "pagination" || N === "scrollbar") && "enabled" in a[N] && !a[N].enabled && D(N);
    else {
      const T = a[N];
      (T === !0 || T === !1) && (N === "navigation" || N === "pagination" || N === "scrollbar") ? T === !1 && D(N) : u[N] = a[N];
    }
  }), h.includes("controller") && !_ && r.controller && r.controller.control && u.controller && u.controller.control && (r.controller.control = u.controller.control), s.includes("children") && n && v && u.virtual.enabled ? (v.slides = n, v.update(!0)) : s.includes("virtual") && v && u.virtual.enabled && (n && (v.slides = n), v.update(!0)), s.includes("children") && n && u.loop && (A = !0), x && y.init() && y.update(!0), _ && (r.controller.control = u.controller.control), $ && (r.isElement && (!d || typeof d == "string") && (d = document.createElement("div"), d.classList.add("swiper-pagination"), d.part.add("pagination"), r.el.appendChild(d)), d && (u.pagination.el = d), p.init(), p.render(), p.update()), b && (r.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-scrollbar"), l.part.add("scrollbar"), r.el.appendChild(l)), l && (u.scrollbar.el = l), g.init(), g.updateSize(), g.setTranslate()), M && (r.isElement && ((!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-next"), o.innerHTML = r.hostEl.constructor.nextButtonSvg, o.part.add("button-next"), r.el.appendChild(o)), (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-button-prev"), c.innerHTML = r.hostEl.constructor.prevButtonSvg, c.part.add("button-prev"), r.el.appendChild(c))), o && (u.navigation.nextEl = o), c && (u.navigation.prevEl = c), m.init(), m.update()), s.includes("allowSlideNext") && (r.allowSlideNext = a.allowSlideNext), s.includes("allowSlidePrev") && (r.allowSlidePrev = a.allowSlidePrev), s.includes("direction") && r.changeDirection(a.direction, !1), (C || A) && r.loopDestroy(), (S || A) && r.loopCreate(), r.update();
}
const formatValue = (t) => {
  if (parseFloat(t) === Number(t))
    return Number(t);
  if (t === "true" || t === "")
    return !0;
  if (t === "false")
    return !1;
  if (t === "null")
    return null;
  if (t !== "undefined") {
    if (typeof t == "string" && t.includes("{") && t.includes("}") && t.includes('"')) {
      let r;
      try {
        r = JSON.parse(t);
      } catch {
        r = t;
      }
      return r;
    }
    return t;
  }
}, modulesParamsList = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
function getParams(t, r, n) {
  const a = {}, s = {};
  extend$2(a, defaults$2);
  const o = [...paramsList, "on"], c = o.map((d) => d.replace(/_/, ""));
  o.forEach((d) => {
    d = d.replace("_", ""), typeof t[d] < "u" && (s[d] = t[d]);
  });
  const l = [...t.attributes];
  return typeof r == "string" && typeof n < "u" && l.push({
    name: r,
    value: isObject$4(n) ? {
      ...n
    } : n
  }), l.forEach((d) => {
    const h = modulesParamsList.filter((u) => d.name.indexOf(`${u}-`) === 0)[0];
    if (h) {
      const u = attrToProp(h), p = attrToProp(d.name.split(`${h}-`)[1]);
      typeof s[u] > "u" && (s[u] = {}), s[u] === !0 && (s[u] = {
        enabled: !0
      }), s[u][p] = formatValue(d.value);
    } else {
      const u = attrToProp(d.name);
      if (!c.includes(u))
        return;
      const p = formatValue(d.value);
      s[u] && modulesParamsList.includes(d.name) && !isObject$4(p) ? (s[u].constructor !== Object && (s[u] = {}), s[u].enabled = !!p) : s[u] = p;
    }
  }), extend$2(a, s), a.navigation ? a.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...a.navigation !== !0 ? a.navigation : {}
  } : a.navigation === !1 && delete a.navigation, a.scrollbar ? a.scrollbar = {
    el: ".swiper-scrollbar",
    ...a.scrollbar !== !0 ? a.scrollbar : {}
  } : a.scrollbar === !1 && delete a.scrollbar, a.pagination ? a.pagination = {
    el: ".swiper-pagination",
    ...a.pagination !== !0 ? a.pagination : {}
  } : a.pagination === !1 && delete a.pagination, {
    params: a,
    passedParams: s
  };
}
const SwiperCSS = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}", SwiperSlideCSS = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class DummyHTMLElement {
}
const ClassToExtend = typeof window > "u" || typeof HTMLElement > "u" ? DummyHTMLElement : HTMLElement, arrowSvg = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `, addStyle = (t, r) => {
  if (typeof CSSStyleSheet < "u" && t.adoptedStyleSheets) {
    const n = new CSSStyleSheet();
    n.replaceSync(r), t.adoptedStyleSheets = [n];
  } else {
    const n = document.createElement("style");
    n.rel = "stylesheet", n.textContent = r, t.appendChild(n);
  }
};
class SwiperContainer extends ClassToExtend {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  static get nextButtonSvg() {
    return arrowSvg;
  }
  static get prevButtonSvg() {
    return arrowSvg.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
  }
  cssStyles() {
    return [
      SwiperCSS,
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  calcSlideSlots() {
    const r = this.slideSlots || 0, n = [...this.querySelectorAll("[slot^=slide-]")].map((a) => parseInt(a.getAttribute("slot").split("slide-")[1], 10));
    if (this.slideSlots = n.length ? Math.max(...n) + 1 : 0, !!this.rendered) {
      if (this.slideSlots > r)
        for (let a = r; a < this.slideSlots; a += 1) {
          const s = document.createElement("swiper-slide");
          s.setAttribute("part", `slide slide-${a + 1}`);
          const o = document.createElement("slot");
          o.setAttribute("name", `slide-${a + 1}`), s.appendChild(o), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(s);
        }
      else if (this.slideSlots < r) {
        const a = this.swiper.slides;
        for (let s = a.length - 1; s >= 0; s -= 1)
          s > this.slideSlots && a[s].remove();
      }
    }
  }
  render() {
    if (this.rendered)
      return;
    this.calcSlideSlots();
    let r = this.cssStyles();
    this.slideSlots > 0 && (r = r.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), r.length && addStyle(this.shadowRoot, r), this.cssLinks().forEach((a) => {
      if (this.shadowRoot.querySelector(`link[href="${a}"]`))
        return;
      const o = document.createElement("link");
      o.rel = "stylesheet", o.href = a, this.shadowRoot.appendChild(o);
    });
    const n = document.createElement("div");
    n.classList.add("swiper"), n.part = "container", n.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
      length: this.slideSlots
    }).map((a, s) => `
        <swiper-slide part="slide slide-${s}">
          <slot name="slide-${s}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${needsNavigation(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${needsPagination(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${needsScrollbar(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, this.shadowRoot.appendChild(n), this.rendered = !0;
  }
  initialize() {
    var r = this;
    if (this.initialized)
      return;
    this.initialized = !0;
    const {
      params: n,
      passedParams: a
    } = getParams(this);
    this.swiperParams = n, this.passedParams = a, delete this.swiperParams.init, this.render(), this.swiper = new Swiper(this.shadowRoot.querySelector(".swiper"), {
      ...n.virtual ? {} : {
        observer: !0
      },
      ...n,
      touchEventsTarget: "container",
      onAny: function(s) {
        s === "observerUpdate" && r.calcSlideSlots();
        const o = n.eventsPrefix ? `${n.eventsPrefix}${s.toLowerCase()}` : s.toLowerCase();
        for (var c = arguments.length, l = new Array(c > 1 ? c - 1 : 0), d = 1; d < c; d++)
          l[d - 1] = arguments[d];
        const h = new CustomEvent(o, {
          detail: l,
          bubbles: s !== "hashChange",
          cancelable: !0
        });
        r.dispatchEvent(h);
      }
    });
  }
  connectedCallback() {
    this.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || (this.swiper && this.swiper.destroy && this.swiper.destroy(), this.initialized = !1);
  }
  updateSwiperOnPropChange(r, n) {
    const {
      params: a,
      passedParams: s
    } = getParams(this, r, n);
    this.passedParams = s, this.swiperParams = a, !(this.swiper && this.swiper.params[r] === n) && updateSwiper({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [attrToProp(r)],
      ...r === "navigation" && s[r] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...r === "pagination" && s[r] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...r === "scrollbar" && s[r] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(r, n, a) {
    this.initialized && (n === "true" && a === null && (a = !1), this.updateSwiperOnPropChange(r, a));
  }
  static get observedAttributes() {
    return paramsList.filter((n) => n.includes("_")).map((n) => n.replace(/[A-Z]/g, (a) => `-${a}`).replace("_", "").toLowerCase());
  }
}
paramsList.forEach((t) => {
  t !== "init" && (t = t.replace("_", ""), Object.defineProperty(SwiperContainer.prototype, t, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[t];
    },
    set(r) {
      this.passedParams || (this.passedParams = {}), this.passedParams[t] = r, this.initialized && this.updateSwiperOnPropChange(t, r);
    }
  }));
});
class SwiperSlide extends ClassToExtend {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  render() {
    const r = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if (addStyle(this.shadowRoot, SwiperSlideCSS), this.shadowRoot.appendChild(document.createElement("slot")), r) {
      const n = document.createElement("div");
      n.classList.add("swiper-lazy-preloader"), n.part.add("preloader"), this.shadowRoot.appendChild(n);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.initialize();
  }
}
const register = () => {
  typeof window > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", SwiperContainer), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", SwiperSlide));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (t) => {
  paramsList.push(...t);
});
const Container$f = styled.div`
  swiper-container {
    width: 100%;
  }

  swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  swiper-container::part(pagination) {
    position: relative;
    margin-top: ${({ theme: { reference: t } }) => t.dimension_16};
  }
  swiper-container::part(bullet-active) {
    background: ${({ theme: { components: t }, mode: r }) => t.pagination[`fds_c_pagination_slider_${r}`]};
  }
  swiper-container::part(bullet) {
    background: ${({ theme: { components: t }, mode: r }) => t.pagination[`fds_c_pagination_slider_${r}`]};
  }
`;
register();
var CarouselModes = /* @__PURE__ */ ((t) => (t.light = "light", t.dark = "dark", t))(CarouselModes || {});
const Carousel = ({
  items: t,
  goToSlide: r = -1,
  mode: n = "dark",
  setActiveSlide: a,
  hasAutoplay: s = !1,
  autoplayDelay: o = 3e3,
  autoplayDisableOnInteraction: c = !1,
  autoplayPauseOnMouseEnter: l = !1,
  loop: d = !1
}) => {
  const h = useRef(null), [u, p] = useState(), m = (v) => {
    p(v.swiper), v.initialize(), a && v.swiper.on("activeIndexChange", (y) => a(y.activeIndex));
  };
  return useEffect(() => {
    const v = document.querySelector("swiper-container");
    v && m(v);
  }, []), useEffect(() => {
    !u && (h != null && h.current) && m(h.current);
  }, [h == null ? void 0 : h.current]), useEffect(() => {
    u && r !== -1 && r !== u.activeIndex && u.slideTo(r, 0);
  }, [u, r]), /* @__PURE__ */ jsx$1(Container$f, {
    mode: n,
    children: /* @__PURE__ */ jsx$1("swiper-container", {
      pagination: "true",
      "space-between": "16",
      ref: h,
      "pagination-clickable": "true",
      ...s && {
        "autoplay-delay": o,
        "autoplay-disable-on-interaction": c,
        "autoplay-pause-on-mouse-enter": l
      },
      loop: d,
      children: t.map((v, y) => /* @__PURE__ */ jsx$1("swiper-slide", {
        children: v
      }, y))
    })
  });
};
Carousel.defaultProps = {
  mode: "dark",
  goToSlide: -1
};
const Cell$2 = styled.button`
  all: unset;
  display: block;
  border-radius: ${({ theme: { components: t }, size: r }) => t.cells[`fds_c_tableviewcell_borderradius_${r}`]};

  &:disabled {
    opacity: ${({ theme: { system: t } }) => t.fds_sys_disabled_opacity_S};
    cursor: not-allowed;
  }
  ${MarginsStyles}

  ${({ isInteractive: t }) => t && css$3`
      cursor: pointer;
      transition: box-shadow 1.5s cubic-bezier(0, 0.8, 0.2, 1),
        border-color 1.5s cubic-bezier(0, 0.8, 0.2, 1);
      &:hover:enabled {
        box-shadow: ${({ theme: { system: r } }) => {
  const { x: n, y: a, blur: s, spread: o, color: c } = r.fds_sys_elevation_M;
  return `${n} ${a} ${s} ${o} ${c}`;
}};
        transition: box-shadow 0.25s cubic-bezier(0, 0, 0.2, 2),
          border-color 0.25s cubic-bezier(0, 0, 0.2, 2);
      }
    `}
`, Content$5 = styled(FlexContainer$1)`
  padding: ${({ theme: { components: t }, size: r }) => t.cells[`fds_c_tableviewcell_spacing_${r}`]};
  gap: ${({ theme: { components: t } }) => t.cells.fds_c_tableviewcell_gap_S};
  border: ${({ theme: { system: t, components: r }, isSelected: n, isInteractive: a }) => `
      ${t.fds_sys_borderwidth_S} solid ${n && a ? r.cells.fds_c_cells_border_color_hover : r.cells.fds_c_cells_border_color}
    `};
  border-radius: ${({ theme: { components: t }, size: r }) => t.cells[`fds_c_tableviewcell_borderradius_${r}`]};
  box-shadow: ${({ theme: { system: t }, isSelected: r, isInteractive: n }) => {
  const { x: a, y: s, blur: o, spread: c, color: l } = t.fds_sys_embed_M;
  return r && n ? `inset ${a} ${s} ${o} ${c} ${l}` : `inset 0 0 0 ${l}`;
}};
  transition: ${({ isSelected: t, isInteractive: r }) => t && r ? "box-shadow 0.5s cubic-bezier(0,0,0.2,2)" : "box-shadow 1s cubic-bezier(0,0.8,0.2,1)"};
  background: ${({ theme: { components: t }, isSelected: r, isInteractive: n }) => r && n ? t.cells.fds_c_cells_background_color_selected : t.cells.fds_c_table_cell_color_background_default};
`, Cell$1 = ({
  size: t = Sizes$1.M,
  isSelected: r = !1,
  isDisabled: n = !1,
  isInteractive: a = !0,
  hasArrow: s = !0,
  onClick: o,
  children: c,
  ...l
}) => /* @__PURE__ */ jsx$1(Cell$2, {
  type: "button",
  onClick: o,
  size: t,
  disabled: n,
  ...l,
  isInteractive: a,
  children: /* @__PURE__ */ jsxs(Content$5, {
    align: "center",
    size: t,
    isSelected: r,
    isInteractive: a,
    justify: "space-between",
    children: [c, s && /* @__PURE__ */ jsx$1(Icon$4, {
      icon: "IconArrowRightS",
      color: "default",
      height: 16,
      width: 16
    })]
  })
});
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        ({}).hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends$7.apply(null, arguments);
}
function _objectWithoutPropertiesLoose$b(t, r) {
  if (t == null)
    return {};
  var n = {};
  for (var a in t)
    if ({}.hasOwnProperty.call(t, a)) {
      if (r.indexOf(a) !== -1)
        continue;
      n[a] = t[a];
    }
  return n;
}
function _setPrototypeOf$3(t, r) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, _setPrototypeOf$3(t, r);
}
function _inheritsLoose$1(t, r) {
  t.prototype = Object.create(r.prototype), t.prototype.constructor = t, _setPrototypeOf$3(t, r);
}
var propTypes = { exports: {} }, reactIs$1 = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, a = t ? Symbol.for("react.fragment") : 60107, s = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, c = t ? Symbol.for("react.provider") : 60109, l = t ? Symbol.for("react.context") : 60110, d = t ? Symbol.for("react.async_mode") : 60111, h = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, y = t ? Symbol.for("react.block") : 60121, x = t ? Symbol.for("react.fundamental") : 60117, _ = t ? Symbol.for("react.responder") : 60118, $ = t ? Symbol.for("react.scope") : 60119;
  function b(C) {
    if (typeof C == "object" && C !== null) {
      var S = C.$$typeof;
      switch (S) {
        case r:
          switch (C = C.type, C) {
            case d:
            case h:
            case a:
            case o:
            case s:
            case p:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case l:
                case u:
                case v:
                case g:
                case c:
                  return C;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function M(C) {
    return b(C) === h;
  }
  return reactIs_production_min.AsyncMode = d, reactIs_production_min.ConcurrentMode = h, reactIs_production_min.ContextConsumer = l, reactIs_production_min.ContextProvider = c, reactIs_production_min.Element = r, reactIs_production_min.ForwardRef = u, reactIs_production_min.Fragment = a, reactIs_production_min.Lazy = v, reactIs_production_min.Memo = g, reactIs_production_min.Portal = n, reactIs_production_min.Profiler = o, reactIs_production_min.StrictMode = s, reactIs_production_min.Suspense = p, reactIs_production_min.isAsyncMode = function(C) {
    return M(C) || b(C) === d;
  }, reactIs_production_min.isConcurrentMode = M, reactIs_production_min.isContextConsumer = function(C) {
    return b(C) === l;
  }, reactIs_production_min.isContextProvider = function(C) {
    return b(C) === c;
  }, reactIs_production_min.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === r;
  }, reactIs_production_min.isForwardRef = function(C) {
    return b(C) === u;
  }, reactIs_production_min.isFragment = function(C) {
    return b(C) === a;
  }, reactIs_production_min.isLazy = function(C) {
    return b(C) === v;
  }, reactIs_production_min.isMemo = function(C) {
    return b(C) === g;
  }, reactIs_production_min.isPortal = function(C) {
    return b(C) === n;
  }, reactIs_production_min.isProfiler = function(C) {
    return b(C) === o;
  }, reactIs_production_min.isStrictMode = function(C) {
    return b(C) === s;
  }, reactIs_production_min.isSuspense = function(C) {
    return b(C) === p;
  }, reactIs_production_min.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === a || C === h || C === o || C === s || C === p || C === m || typeof C == "object" && C !== null && (C.$$typeof === v || C.$$typeof === g || C.$$typeof === c || C.$$typeof === l || C.$$typeof === u || C.$$typeof === x || C.$$typeof === _ || C.$$typeof === $ || C.$$typeof === y);
  }, reactIs_production_min.typeOf = b, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, a = t ? Symbol.for("react.fragment") : 60107, s = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, c = t ? Symbol.for("react.provider") : 60109, l = t ? Symbol.for("react.context") : 60110, d = t ? Symbol.for("react.async_mode") : 60111, h = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, y = t ? Symbol.for("react.block") : 60121, x = t ? Symbol.for("react.fundamental") : 60117, _ = t ? Symbol.for("react.responder") : 60118, $ = t ? Symbol.for("react.scope") : 60119;
    function b(ir) {
      return typeof ir == "string" || typeof ir == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ir === a || ir === h || ir === o || ir === s || ir === p || ir === m || typeof ir == "object" && ir !== null && (ir.$$typeof === v || ir.$$typeof === g || ir.$$typeof === c || ir.$$typeof === l || ir.$$typeof === u || ir.$$typeof === x || ir.$$typeof === _ || ir.$$typeof === $ || ir.$$typeof === y);
    }
    function M(ir) {
      if (typeof ir == "object" && ir !== null) {
        var _r = ir.$$typeof;
        switch (_r) {
          case r:
            var yr = ir.type;
            switch (yr) {
              case d:
              case h:
              case a:
              case o:
              case s:
              case p:
                return yr;
              default:
                var ne = yr && yr.$$typeof;
                switch (ne) {
                  case l:
                  case u:
                  case v:
                  case g:
                  case c:
                    return ne;
                  default:
                    return _r;
                }
            }
          case n:
            return _r;
        }
      }
    }
    var C = d, S = h, A = l, D = c, N = r, T = u, R = a, F = v, z = g, O = n, G = o, I = s, k = p, B = !1;
    function L(ir) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), V(ir) || M(ir) === d;
    }
    function V(ir) {
      return M(ir) === h;
    }
    function U(ir) {
      return M(ir) === l;
    }
    function J(ir) {
      return M(ir) === c;
    }
    function q(ir) {
      return typeof ir == "object" && ir !== null && ir.$$typeof === r;
    }
    function Z(ir) {
      return M(ir) === u;
    }
    function ae(ir) {
      return M(ir) === a;
    }
    function ee(ir) {
      return M(ir) === v;
    }
    function se(ir) {
      return M(ir) === g;
    }
    function nr(ir) {
      return M(ir) === n;
    }
    function ce(ir) {
      return M(ir) === o;
    }
    function oe(ir) {
      return M(ir) === s;
    }
    function ur(ir) {
      return M(ir) === p;
    }
    reactIs_development.AsyncMode = C, reactIs_development.ConcurrentMode = S, reactIs_development.ContextConsumer = A, reactIs_development.ContextProvider = D, reactIs_development.Element = N, reactIs_development.ForwardRef = T, reactIs_development.Fragment = R, reactIs_development.Lazy = F, reactIs_development.Memo = z, reactIs_development.Portal = O, reactIs_development.Profiler = G, reactIs_development.StrictMode = I, reactIs_development.Suspense = k, reactIs_development.isAsyncMode = L, reactIs_development.isConcurrentMode = V, reactIs_development.isContextConsumer = U, reactIs_development.isContextProvider = J, reactIs_development.isElement = q, reactIs_development.isForwardRef = Z, reactIs_development.isFragment = ae, reactIs_development.isLazy = ee, reactIs_development.isMemo = se, reactIs_development.isPortal = nr, reactIs_development.isProfiler = ce, reactIs_development.isStrictMode = oe, reactIs_development.isSuspense = ur, reactIs_development.isValidElementType = b, reactIs_development.typeOf = M;
  }()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min() : reactIs$1.exports = requireReactIs_development()), reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var t = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function a(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var c = {}, l = 0; l < 10; l++)
        c["_" + String.fromCharCode(l)] = l;
      var d = Object.getOwnPropertyNames(c).map(function(u) {
        return c[u];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var h = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        h[u] = u;
      }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = s() ? Object.assign : function(o, c) {
    for (var l, d = a(o), h, u = 1; u < arguments.length; u++) {
      l = Object(arguments[u]);
      for (var p in l)
        r.call(l, p) && (d[p] = l[p]);
      if (t) {
        h = t(l);
        for (var m = 0; m < h.length; m++)
          n.call(l, h[m]) && (d[h[m]] = l[h[m]]);
      }
    }
    return d;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = t, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = requireReactPropTypesSecret(), n = {}, a = requireHas();
    t = function(o) {
      var c = "Warning: " + o;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function s(o, c, l, d, h) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (a(o, u)) {
          var p;
          try {
            if (typeof o[u] != "function") {
              var m = Error(
                (d || "React class") + ": " + l + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            p = o[u](c, u, d, l, null, r);
          } catch (v) {
            p = v;
          }
          if (p && !(p instanceof Error) && t(
            (d || "React class") + ": type specification of " + l + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var g = h ? h() : "";
            t(
              "Failed " + l + " type: " + p.message + (g ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, checkPropTypes_1 = s, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var t = requireReactIs(), r = requireObjectAssign(), n = requireReactPropTypesSecret(), a = requireHas(), s = requireCheckPropTypes(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(l) {
    var d = "Warning: " + l;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return factoryWithTypeCheckers = function(l, d) {
    var h = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function p(V) {
      var U = V && (h && V[h] || V[u]);
      if (typeof U == "function")
        return U;
    }
    var m = "<<anonymous>>", g = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: $(),
      arrayOf: b,
      element: M(),
      elementType: C(),
      instanceOf: S,
      node: T(),
      objectOf: D,
      oneOf: A,
      oneOfType: N,
      shape: F,
      exact: z
    };
    function v(V, U) {
      return V === U ? V !== 0 || 1 / V === 1 / U : V !== V && U !== U;
    }
    function y(V, U) {
      this.message = V, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function x(V) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, J = 0;
      function q(ae, ee, se, nr, ce, oe, ur) {
        if (nr = nr || m, oe = oe || se, ur !== n) {
          if (d) {
            var ir = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ir.name = "Invariant Violation", ir;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var _r = nr + ":" + se;
            !U[_r] && // Avoid spamming the console because they are often not actionable except for lib authors
            J < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + oe + "` prop on `" + nr + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[_r] = !0, J++);
          }
        }
        return ee[se] == null ? ae ? ee[se] === null ? new y("The " + ce + " `" + oe + "` is marked as required " + ("in `" + nr + "`, but its value is `null`.")) : new y("The " + ce + " `" + oe + "` is marked as required in " + ("`" + nr + "`, but its value is `undefined`.")) : null : V(ee, se, nr, ce, oe);
      }
      var Z = q.bind(null, !1);
      return Z.isRequired = q.bind(null, !0), Z;
    }
    function _(V) {
      function U(J, q, Z, ae, ee, se) {
        var nr = J[q], ce = I(nr);
        if (ce !== V) {
          var oe = k(nr);
          return new y(
            "Invalid " + ae + " `" + ee + "` of type " + ("`" + oe + "` supplied to `" + Z + "`, expected ") + ("`" + V + "`."),
            { expectedType: V }
          );
        }
        return null;
      }
      return x(U);
    }
    function $() {
      return x(c);
    }
    function b(V) {
      function U(J, q, Z, ae, ee) {
        if (typeof V != "function")
          return new y("Property `" + ee + "` of component `" + Z + "` has invalid PropType notation inside arrayOf.");
        var se = J[q];
        if (!Array.isArray(se)) {
          var nr = I(se);
          return new y("Invalid " + ae + " `" + ee + "` of type " + ("`" + nr + "` supplied to `" + Z + "`, expected an array."));
        }
        for (var ce = 0; ce < se.length; ce++) {
          var oe = V(se, ce, Z, ae, ee + "[" + ce + "]", n);
          if (oe instanceof Error)
            return oe;
        }
        return null;
      }
      return x(U);
    }
    function M() {
      function V(U, J, q, Z, ae) {
        var ee = U[J];
        if (!l(ee)) {
          var se = I(ee);
          return new y("Invalid " + Z + " `" + ae + "` of type " + ("`" + se + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return x(V);
    }
    function C() {
      function V(U, J, q, Z, ae) {
        var ee = U[J];
        if (!t.isValidElementType(ee)) {
          var se = I(ee);
          return new y("Invalid " + Z + " `" + ae + "` of type " + ("`" + se + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return x(V);
    }
    function S(V) {
      function U(J, q, Z, ae, ee) {
        if (!(J[q] instanceof V)) {
          var se = V.name || m, nr = L(J[q]);
          return new y("Invalid " + ae + " `" + ee + "` of type " + ("`" + nr + "` supplied to `" + Z + "`, expected ") + ("instance of `" + se + "`."));
        }
        return null;
      }
      return x(U);
    }
    function A(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), c;
      function U(J, q, Z, ae, ee) {
        for (var se = J[q], nr = 0; nr < V.length; nr++)
          if (v(se, V[nr]))
            return null;
        var ce = JSON.stringify(V, function(ur, ir) {
          var _r = k(ir);
          return _r === "symbol" ? String(ir) : ir;
        });
        return new y("Invalid " + ae + " `" + ee + "` of value `" + String(se) + "` " + ("supplied to `" + Z + "`, expected one of " + ce + "."));
      }
      return x(U);
    }
    function D(V) {
      function U(J, q, Z, ae, ee) {
        if (typeof V != "function")
          return new y("Property `" + ee + "` of component `" + Z + "` has invalid PropType notation inside objectOf.");
        var se = J[q], nr = I(se);
        if (nr !== "object")
          return new y("Invalid " + ae + " `" + ee + "` of type " + ("`" + nr + "` supplied to `" + Z + "`, expected an object."));
        for (var ce in se)
          if (a(se, ce)) {
            var oe = V(se, ce, Z, ae, ee + "." + ce, n);
            if (oe instanceof Error)
              return oe;
          }
        return null;
      }
      return x(U);
    }
    function N(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var U = 0; U < V.length; U++) {
        var J = V[U];
        if (typeof J != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + B(J) + " at index " + U + "."
          ), c;
      }
      function q(Z, ae, ee, se, nr) {
        for (var ce = [], oe = 0; oe < V.length; oe++) {
          var ur = V[oe], ir = ur(Z, ae, ee, se, nr, n);
          if (ir == null)
            return null;
          ir.data && a(ir.data, "expectedType") && ce.push(ir.data.expectedType);
        }
        var _r = ce.length > 0 ? ", expected one of type [" + ce.join(", ") + "]" : "";
        return new y("Invalid " + se + " `" + nr + "` supplied to " + ("`" + ee + "`" + _r + "."));
      }
      return x(q);
    }
    function T() {
      function V(U, J, q, Z, ae) {
        return O(U[J]) ? null : new y("Invalid " + Z + " `" + ae + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return x(V);
    }
    function R(V, U, J, q, Z) {
      return new y(
        (V || "React class") + ": " + U + " type `" + J + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Z + "`."
      );
    }
    function F(V) {
      function U(J, q, Z, ae, ee) {
        var se = J[q], nr = I(se);
        if (nr !== "object")
          return new y("Invalid " + ae + " `" + ee + "` of type `" + nr + "` " + ("supplied to `" + Z + "`, expected `object`."));
        for (var ce in V) {
          var oe = V[ce];
          if (typeof oe != "function")
            return R(Z, ae, ee, ce, k(oe));
          var ur = oe(se, ce, Z, ae, ee + "." + ce, n);
          if (ur)
            return ur;
        }
        return null;
      }
      return x(U);
    }
    function z(V) {
      function U(J, q, Z, ae, ee) {
        var se = J[q], nr = I(se);
        if (nr !== "object")
          return new y("Invalid " + ae + " `" + ee + "` of type `" + nr + "` " + ("supplied to `" + Z + "`, expected `object`."));
        var ce = r({}, J[q], V);
        for (var oe in ce) {
          var ur = V[oe];
          if (a(V, oe) && typeof ur != "function")
            return R(Z, ae, ee, oe, k(ur));
          if (!ur)
            return new y(
              "Invalid " + ae + " `" + ee + "` key `" + oe + "` supplied to `" + Z + "`.\nBad object: " + JSON.stringify(J[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(V), null, "  ")
            );
          var ir = ur(se, oe, Z, ae, ee + "." + oe, n);
          if (ir)
            return ir;
        }
        return null;
      }
      return x(U);
    }
    function O(V) {
      switch (typeof V) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !V;
        case "object":
          if (Array.isArray(V))
            return V.every(O);
          if (V === null || l(V))
            return !0;
          var U = p(V);
          if (U) {
            var J = U.call(V), q;
            if (U !== V.entries) {
              for (; !(q = J.next()).done; )
                if (!O(q.value))
                  return !1;
            } else
              for (; !(q = J.next()).done; ) {
                var Z = q.value;
                if (Z && !O(Z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function G(V, U) {
      return V === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function I(V) {
      var U = typeof V;
      return Array.isArray(V) ? "array" : V instanceof RegExp ? "object" : G(U, V) ? "symbol" : U;
    }
    function k(V) {
      if (typeof V > "u" || V === null)
        return "" + V;
      var U = I(V);
      if (U === "object") {
        if (V instanceof Date)
          return "date";
        if (V instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function B(V) {
      var U = k(V);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function L(V) {
      return !V.constructor || !V.constructor.name ? m : V.constructor.name;
    }
    return g.checkPropTypes = s, g.resetWarningCache = s.resetWarningCache, g.PropTypes = g, g;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var t = requireReactPropTypesSecret();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, factoryWithThrowingShims = function() {
    function a(c, l, d, h, u, p) {
      if (p !== t) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    a.isRequired = a;
    function s() {
      return a;
    }
    var o = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: s,
      element: a,
      elementType: a,
      instanceOf: s,
      node: a,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return o.PropTypes = o, o;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function hasClass(t, r) {
  return t.classList ? !!r && t.classList.contains(r) : (" " + (t.className.baseVal || t.className) + " ").indexOf(" " + r + " ") !== -1;
}
function addClass(t, r) {
  t.classList ? t.classList.add(r) : hasClass(t, r) || (typeof t.className == "string" ? t.className = t.className + " " + r : t.setAttribute("class", (t.className && t.className.baseVal || "") + " " + r));
}
function replaceClassName(t, r) {
  return t.replace(new RegExp("(^|\\s)" + r + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(t, r) {
  t.classList ? t.classList.remove(r) : typeof t.className == "string" ? t.className = replaceClassName(t.className, r) : t.setAttribute("class", replaceClassName(t.className && t.className.baseVal || "", r));
}
const config$4 = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function(r) {
  return r.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ function(t) {
  _inheritsLoose$1(r, t);
  function r(a, s) {
    var o;
    o = t.call(this, a, s) || this;
    var c = s, l = c && !c.isMounting ? a.enter : a.appear, d;
    return o.appearStatus = null, a.in ? l ? (d = EXITED, o.appearStatus = ENTERING) : d = ENTERED : a.unmountOnExit || a.mountOnEnter ? d = UNMOUNTED : d = EXITED, o.state = {
      status: d
    }, o.nextCallback = null, o;
  }
  r.getDerivedStateFromProps = function(s, o) {
    var c = s.in;
    return c && o.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var n = r.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(s) {
    var o = null;
    if (s !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== ENTERING && c !== ENTERED && (o = ENTERING) : (c === ENTERING || c === ENTERED) && (o = EXITING);
    }
    this.updateStatus(!1, o);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var s = this.props.timeout, o, c, l;
    return o = c = l = s, s != null && typeof s != "number" && (o = s.exit, c = s.enter, l = s.appear !== void 0 ? s.appear : c), {
      exit: o,
      enter: c,
      appear: l
    };
  }, n.updateStatus = function(s, o) {
    if (s === void 0 && (s = !1), o !== null)
      if (this.cancelNextCallback(), o === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          c && forceReflow(c);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === EXITED && this.setState({
        status: UNMOUNTED
      });
  }, n.performEnter = function(s) {
    var o = this, c = this.props.enter, l = this.context ? this.context.isMounting : s, d = this.props.nodeRef ? [l] : [ReactDOM__default.findDOMNode(this), l], h = d[0], u = d[1], p = this.getTimeouts(), m = l ? p.appear : p.enter;
    if (!s && !c || config$4.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        o.props.onEntered(h);
      });
      return;
    }
    this.props.onEnter(h, u), this.safeSetState({
      status: ENTERING
    }, function() {
      o.props.onEntering(h, u), o.onTransitionEnd(m, function() {
        o.safeSetState({
          status: ENTERED
        }, function() {
          o.props.onEntered(h, u);
        });
      });
    });
  }, n.performExit = function() {
    var s = this, o = this.props.exit, c = this.getTimeouts(), l = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!o || config$4.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        s.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: EXITING
    }, function() {
      s.props.onExiting(l), s.onTransitionEnd(c.exit, function() {
        s.safeSetState({
          status: EXITED
        }, function() {
          s.props.onExited(l);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(s, o) {
    o = this.setNextCallback(o), this.setState(s, o);
  }, n.setNextCallback = function(s) {
    var o = this, c = !0;
    return this.nextCallback = function(l) {
      c && (c = !1, o.nextCallback = null, s(l));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(s, o) {
    this.setNextCallback(o);
    var c = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), l = s == null && !this.props.addEndListener;
    if (!c || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var d = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], h = d[0], u = d[1];
      this.props.addEndListener(h, u);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, n.render = function() {
    var s = this.state.status;
    if (s === UNMOUNTED)
      return null;
    var o = this.props, c = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var l = _objectWithoutPropertiesLoose$b(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ jsx$1(TransitionGroupContext.Provider, {
        value: null,
        children: typeof c == "function" ? c(s, l) : React__default.cloneElement(React__default.Children.only(c), l)
      })
    );
  }, r;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(t, r, n, a, s, o) {
      var c = t[r];
      return PropTypes.instanceOf(c && "ownerDocument" in c ? c.ownerDocument.defaultView.Element : Element)(t, r, n, a, s, o);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(r) {
    var n = timeoutsShape;
    r.addEndListener || (n = n.isRequired);
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++)
      s[o - 1] = arguments[o];
    return n.apply(void 0, [r].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$5() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$5,
  onEntering: noop$5,
  onEntered: noop$5,
  onExit: noop$5,
  onExiting: noop$5,
  onExited: noop$5
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
const Transition$1 = Transition;
var _addClass = function(r, n) {
  return r && n && n.split(" ").forEach(function(a) {
    return addClass(r, a);
  });
}, removeClass = function(r, n) {
  return r && n && n.split(" ").forEach(function(a) {
    return removeClass$1(r, a);
  });
}, CSSTransition = /* @__PURE__ */ function(t) {
  _inheritsLoose$1(r, t);
  function r() {
    for (var a, s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = t.call.apply(t, [this].concat(o)) || this, a.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, a.onEnter = function(l, d) {
      var h = a.resolveArguments(l, d), u = h[0], p = h[1];
      a.removeClasses(u, "exit"), a.addClass(u, p ? "appear" : "enter", "base"), a.props.onEnter && a.props.onEnter(l, d);
    }, a.onEntering = function(l, d) {
      var h = a.resolveArguments(l, d), u = h[0], p = h[1], m = p ? "appear" : "enter";
      a.addClass(u, m, "active"), a.props.onEntering && a.props.onEntering(l, d);
    }, a.onEntered = function(l, d) {
      var h = a.resolveArguments(l, d), u = h[0], p = h[1], m = p ? "appear" : "enter";
      a.removeClasses(u, m), a.addClass(u, m, "done"), a.props.onEntered && a.props.onEntered(l, d);
    }, a.onExit = function(l) {
      var d = a.resolveArguments(l), h = d[0];
      a.removeClasses(h, "appear"), a.removeClasses(h, "enter"), a.addClass(h, "exit", "base"), a.props.onExit && a.props.onExit(l);
    }, a.onExiting = function(l) {
      var d = a.resolveArguments(l), h = d[0];
      a.addClass(h, "exit", "active"), a.props.onExiting && a.props.onExiting(l);
    }, a.onExited = function(l) {
      var d = a.resolveArguments(l), h = d[0];
      a.removeClasses(h, "exit"), a.addClass(h, "exit", "done"), a.props.onExited && a.props.onExited(l);
    }, a.resolveArguments = function(l, d) {
      return a.props.nodeRef ? [a.props.nodeRef.current, l] : [l, d];
    }, a.getClassNames = function(l) {
      var d = a.props.classNames, h = typeof d == "string", u = h && d ? d + "-" : "", p = h ? "" + u + l : d[l], m = h ? p + "-active" : d[l + "Active"], g = h ? p + "-done" : d[l + "Done"];
      return {
        baseClassName: p,
        activeClassName: m,
        doneClassName: g
      };
    }, a;
  }
  var n = r.prototype;
  return n.addClass = function(s, o, c) {
    var l = this.getClassNames(o)[c + "ClassName"], d = this.getClassNames("enter"), h = d.doneClassName;
    o === "appear" && c === "done" && h && (l += " " + h), c === "active" && s && forceReflow(s), l && (this.appliedClasses[o][c] = l, _addClass(s, l));
  }, n.removeClasses = function(s, o) {
    var c = this.appliedClasses[o], l = c.base, d = c.active, h = c.done;
    this.appliedClasses[o] = {}, l && removeClass(s, l), d && removeClass(s, d), h && removeClass(s, h);
  }, n.render = function() {
    var s = this.props;
    s.classNames;
    var o = _objectWithoutPropertiesLoose$b(s, ["classNames"]);
    return /* @__PURE__ */ jsx$1(Transition$1, {
      ...o,
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    });
  }, r;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$7({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
const CSSTransition$1 = CSSTransition;
function _assertThisInitialized$4(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  height: fit-content;
  width: fit-content;
`, chipTypeStyles = {
  [ChipTypes.neutral]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
      }
    }
  `,
  [ChipTypes.neutral_shaded]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral_shaded};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
      }
    }
  `,
  [ChipTypes.neutral_line]: css$3`
    background: transparent;
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_neutral};
      }
    }
  `,
  [ChipTypes.cold]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
      }
    }
  `,
  [ChipTypes.cold_shaded]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold_shaded};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold};
      }
    }
  `,
  [ChipTypes.cold_line]: css$3`
    background: transparent;
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_cold};
      }
    }
  `,
  [ChipTypes.error]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
      }
    }
  `,
  [ChipTypes.error_shaded]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger_shaded};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
      }
    }
  `,
  [ChipTypes.error_line]: css$3`
    background: transparent;
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_danger};
      }
    }
  `,
  [ChipTypes.success]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
      }
    }
  `,
  [ChipTypes.success_line]: css$3`
    background: transparent;
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
      }
    }
  `,
  [ChipTypes.success_shaded]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success_shaded};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_success};
      }
    }
  `,
  [ChipTypes.warning]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_light};
      }
    }
  `,
  [ChipTypes.warning_shaded]: css$3`
    background: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning_shaded};
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
      }
    }
  `,
  [ChipTypes.warning_line]: css$3`
    background: transparent;
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_warning};
      }
    }
  `,
  [ChipTypes.dark_line]: css$3`
    background: transparent;
    border-color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_default};
    color: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_default};
    ${CloseButton} svg {
      path {
        stroke: ${({ theme: { components: t } }) => t.chips.fds_c_chips_color_default};
      }
    }
  `
}, Container$e = styled(FlexContainer$1)`
  width: fit-content;
  opacity: 1;
  transition: opacity 0.5s ease;
  min-height: calc(
    ${({ theme: { components: t }, size: r }) => t.chips[`fds_c_height_${r}`]} -
      ${({ theme: { components: t }, size: r }) => parseInt(t.chips[`fds_c_chips_padding_vertical_${r}`], 10) * 2}px
  );
  padding: ${({ theme: { components: t }, size: r }) => `${t.chips[`fds_c_chips_padding_vertical_${r}`]} ${t.chips[`fds_c_chips_padding_horizontal_${r}`]}`};
  gap: ${({ theme: { components: t }, size: r }) => t.chips[`fds_c_chips_gap_${r}`]};
  border: 1px solid;
  border-radius: ${({ theme: { components: t } }) => t.chips.fds_c_chip_default_radius};
  cursor: ${({ onClick: t }) => t ? "pointer" : "default"};
  ${({ type: t }) => chipTypeStyles[t]};
  span {
    ${({ theme: { components: t }, size: r }) => t.chips[`fds_c_chips_text_${r}`]};
  }
  &.exit-active {
    opacity: 0;
  }
  user-select: none;
`, CrossIcon$1 = {
  [Sizes$1.S]: "IconCrossAccentXs",
  [Sizes$1.M]: "IconCrossAccentXs",
  [Sizes$1.L]: "IconCrossAccentS"
}, Chip = ({
  type: t = ChipTypes.neutral,
  size: r = Sizes$1.S,
  children: n,
  leftIcon: a,
  rightIcon: s,
  onClick: o,
  onClose: c,
  ...l
}) => {
  const [d, h] = useState(!0);
  return /* @__PURE__ */ jsx$1(CSSTransition$1, {
    in: d,
    appear: !0,
    unmountOnExit: !0,
    timeout: 1e3,
    children: /* @__PURE__ */ jsxs(Container$e, {
      gap: "dimension_04",
      type: t,
      size: r,
      align: "center",
      justify: "center",
      onClick: o,
      ...l,
      children: [a && a, /* @__PURE__ */ jsx$1("span", {
        children: n
      }), s && s, c && /* @__PURE__ */ jsx$1(CloseButton, {
        type: "button",
        onClick: () => {
          h(!1), c == null || c();
        },
        children: /* @__PURE__ */ jsx$1(Icon$4, {
          icon: CrossIcon$1[r],
          width: 8,
          height: 8
        })
      })]
    })
  });
}, StepCircle = styled(FlexContainer$1)`
  width: ${({ theme: { reference: t } }) => t.dimension_24};
  height: ${({ theme: { reference: t } }) => t.dimension_24};
  ${({ theme: { components: t } }) => t.multistep.wizard.fds_c_wizard_step_num}
  border-radius: 50%;
  position: relative;
  background: ${({ isActive: t, isConfirmed: r, theme: { components: n } }) => t ? n.multistep.wizard.fds_c_wizard_step_color_current : r ? n.multistep.wizard.fds_c_wizard_step_color_done : n.multistep.wizard.fds_c_wizard_step_color_pending};
  color: ${({ isActive: t, isConfirmed: r, theme: { components: n } }) => !t && !r ? n.multistep.wizard.fds_c_wizard_step_color_content_dark : n.multistep.wizard.fds_c_wizard_step_color_content_light};
  z-index: 1;
`, StepsCircleContainer = styled(FlexContainer$1)`
  position: relative;
  width: 100%;
  &::before {
    content: '';
    position: absolute;
    width: 50%;
    top: ${({ theme: { reference: t } }) => t.dimension_10};
    right: 50%;
    height: ${({ theme: { reference: t } }) => t.dimension_04};
    background: ${({ isConfirmed: t, isActive: r, theme: { components: n } }) => t || r ? n.multistep.wizard.fds_c_wizard_step_color_done : n.multistep.wizard.fds_c_wizard_step_color_pending};
  }

  &::after {
    content: '';
    position: absolute;
    width: 50%;
    top: ${({ theme: { reference: t } }) => t.dimension_10};
    left: 50%;
    height: ${({ theme: { reference: t } }) => t.dimension_04};
    background: ${({ isConfirmed: t, theme: { components: r } }) => t ? r.multistep.wizard.fds_c_wizard_step_color_done : r.multistep.wizard.fds_c_wizard_step_color_pending};
  }
`, Content$4 = styled(FlexContainer$1)`
  width: 100%;
  > p {
    margin: ${({ theme: { reference: t } }) => `0 ${t.dimension_04}`};
    overflow: hidden;
    hyphens: auto;
  }
`, Steps = styled(FlexContainer$1)`
  width: 100%;
  align-items: start;
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_M};
  ${MarginsStyles}
  ${StepsCircleContainer} {
    :first-child {
      ::before {
        display: none;
      }
    }
    :last-child {
      ::after {
        display: none;
      }
    }
  }
`, Wizard = ({
  options: t = [],
  value: r,
  ...n
}) => /* @__PURE__ */ jsx$1(Steps, {
  ...n,
  justify: "center",
  align: "center",
  children: t.map(({
    label: a,
    value: s
  }) => /* @__PURE__ */ jsx$1(StepsCircleContainer, {
    direction: "column",
    isActive: s === r,
    isConfirmed: s < r,
    children: /* @__PURE__ */ jsxs(Content$4, {
      direction: "column",
      align: "center",
      gap: "dimension_16",
      children: [/* @__PURE__ */ jsx$1(StepCircle, {
        isActive: s === r,
        isConfirmed: s < r,
        justify: "center",
        align: "center",
        children: s < r ? /* @__PURE__ */ jsx$1(Icon$4, {
          icon: "IconTickCleanSDark",
          color: "light",
          width: 16,
          height: 16
        }) : s
      }), /* @__PURE__ */ jsx$1(Text$3, {
        type: "paragraphs",
        size: "XS_L_S",
        color: "dark",
        align: "center",
        children: a
      })]
    })
  }, s))
});
function __rest(t, r) {
  var n = {};
  for (var a in t)
    Object.prototype.hasOwnProperty.call(t, a) && r.indexOf(a) < 0 && (n[a] = t[a]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, a = Object.getOwnPropertySymbols(t); s < a.length; s++)
      r.indexOf(a[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, a[s]) && (n[a[s]] = t[a[s]]);
  return n;
}
var SourceType;
(function(t) {
  t.event = "event", t.props = "prop";
})(SourceType || (SourceType = {}));
function noop$4() {
}
function memoizeOnce(t) {
  var r, n = void 0;
  return function() {
    for (var a = [], s = arguments.length; s--; )
      a[s] = arguments[s];
    return r && a.length === r.length && a.every(function(o, c) {
      return o === r[c];
    }) || (r = a, n = t.apply(void 0, a)), n;
  };
}
function charIsNumber(t) {
  return !!(t || "").match(/\d/);
}
function isNil(t) {
  return t == null;
}
function isNanValue(t) {
  return typeof t == "number" && isNaN(t);
}
function isNotValidValue(t) {
  return isNil(t) || isNanValue(t) || typeof t == "number" && !isFinite(t);
}
function escapeRegExp(t) {
  return t.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function getThousandsGroupRegex(t) {
  switch (t) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function applyThousandSeparator(t, r, n) {
  var a = getThousandsGroupRegex(n), s = t.search(/[1-9]/);
  return s = s === -1 ? t.length : s, t.substring(0, s) + t.substring(s, t.length).replace(a, "$1" + r);
}
function usePersistentCallback(t) {
  var r = useRef(t);
  r.current = t;
  var n = useRef(function() {
    for (var a = [], s = arguments.length; s--; )
      a[s] = arguments[s];
    return r.current.apply(r, a);
  });
  return n.current;
}
function splitDecimal(t, r) {
  r === void 0 && (r = !0);
  var n = t[0] === "-", a = n && r;
  t = t.replace("-", "");
  var s = t.split("."), o = s[0], c = s[1] || "";
  return {
    beforeDecimal: o,
    afterDecimal: c,
    hasNegation: n,
    addNegation: a
  };
}
function fixLeadingZero(t) {
  if (!t)
    return t;
  var r = t[0] === "-";
  r && (t = t.substring(1, t.length));
  var n = t.split("."), a = n[0].replace(/^0+/, "") || "0", s = n[1] || "";
  return (r ? "-" : "") + a + (s ? "." + s : "");
}
function limitToScale(t, r, n) {
  for (var a = "", s = n ? "0" : "", o = 0; o <= r - 1; o++)
    a += t[o] || s;
  return a;
}
function repeat$1(t, r) {
  return Array(r + 1).join(t);
}
function toNumericString(t) {
  var r = t + "", n = r[0] === "-" ? "-" : "";
  n && (r = r.substring(1));
  var a = r.split(/[eE]/g), s = a[0], o = a[1];
  if (o = Number(o), !o)
    return n + s;
  s = s.replace(".", "");
  var c = 1 + o, l = s.length;
  return c < 0 ? s = "0." + repeat$1("0", Math.abs(c)) + s : c >= l ? s = s + repeat$1("0", c - l) : s = (s.substring(0, c) || "0") + "." + s.substring(c), n + s;
}
function roundToPrecision(t, r, n) {
  if (["", "-"].indexOf(t) !== -1)
    return t;
  var a = (t.indexOf(".") !== -1 || n) && r, s = splitDecimal(t), o = s.beforeDecimal, c = s.afterDecimal, l = s.hasNegation, d = parseFloat("0." + (c || "0")), h = c.length <= r ? "0." + c : d.toFixed(r), u = h.split("."), p = o.split("").reverse().reduce(function(y, x, _) {
    return y.length > _ ? (Number(y[0]) + Number(x)).toString() + y.substring(1, y.length) : x + y;
  }, u[0]), m = limitToScale(u[1] || "", r, n), g = l ? "-" : "", v = a ? "." : "";
  return "" + g + p + v + m;
}
function setCaretPosition$1(t, r) {
  if (t.value = t.value, t !== null) {
    if (t.createTextRange) {
      var n = t.createTextRange();
      return n.move("character", r), n.select(), !0;
    }
    return t.selectionStart || t.selectionStart === 0 ? (t.focus(), t.setSelectionRange(r, r), !0) : (t.focus(), !1);
  }
}
var findChangeRange = memoizeOnce(function(t, r) {
  for (var n = 0, a = 0, s = t.length, o = r.length; t[n] === r[n] && n < s; )
    n++;
  for (; t[s - 1 - a] === r[o - 1 - a] && o - a > n && s - a > n; )
    a++;
  return {
    from: {
      start: n,
      end: s - a
    },
    to: {
      start: n,
      end: o - a
    }
  };
});
function clamp(t, r, n) {
  return Math.min(Math.max(t, r), n);
}
function geInputCaretPosition(t) {
  return Math.max(t.selectionStart, t.selectionEnd);
}
function addInputMode() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function getDefaultChangeMeta(t) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: t.length
    },
    lastValue: ""
  };
}
function getMaskAtIndex(t, r) {
  return t === void 0 && (t = " "), typeof t == "string" ? t : t[r] || " ";
}
function defaultIsCharacterSame(t) {
  var r = t.currentValue, n = t.formattedValue, a = t.currentValueIndex, s = t.formattedValueIndex;
  return r[a] === n[s];
}
function getCaretPosition$2(t, r, n, a, s, o, c) {
  c === void 0 && (c = defaultIsCharacterSame);
  var l = s.findIndex(function(M) {
    return M;
  }), d = t.slice(0, l);
  !r && !n.startsWith(d) && (r = d, n = d + n, a = a + d.length);
  for (var h = n.length, u = t.length, p = {}, m = new Array(h), g = 0; g < h; g++) {
    m[g] = -1;
    for (var v = 0, y = u; v < y; v++) {
      var x = c({
        currentValue: n,
        lastValue: r,
        formattedValue: t,
        currentValueIndex: g,
        formattedValueIndex: v
      });
      if (x && p[v] !== !0) {
        m[g] = v, p[v] = !0;
        break;
      }
    }
  }
  for (var _ = a; _ < h && (m[_] === -1 || !o(n[_])); )
    _++;
  var $ = _ === h || m[_] === -1 ? u : m[_];
  for (_ = a - 1; _ > 0 && m[_] === -1; )
    _--;
  var b = _ === -1 || m[_] === -1 ? 0 : m[_] + 1;
  return b > $ ? $ : a - b < $ - a ? b : $;
}
function getCaretPosInBoundary(t, r, n, a) {
  var s = t.length;
  if (r = clamp(r, 0, s), a === "left") {
    for (; r >= 0 && !n[r]; )
      r--;
    r === -1 && (r = n.indexOf(!0));
  } else {
    for (; r <= s && !n[r]; )
      r++;
    r > s && (r = n.lastIndexOf(!0));
  }
  return r === -1 && (r = s), r;
}
function caretUnknownFormatBoundary(t) {
  for (var r = Array.from({
    length: t.length + 1
  }).map(function() {
    return !0;
  }), n = 0, a = r.length; n < a; n++)
    r[n] = !!(charIsNumber(t[n]) || charIsNumber(t[n - 1]));
  return r;
}
function useInternalValues(t, r, n, a, s, o) {
  o === void 0 && (o = noop$4);
  var c = usePersistentCallback(function(v, y) {
    var x, _;
    return isNotValidValue(v) ? (_ = "", x = "") : typeof v == "number" || y ? (_ = typeof v == "number" ? toNumericString(v) : v, x = a(_)) : (_ = s(v, void 0), x = a(_)), {
      formattedValue: x,
      numAsString: _
    };
  }), l = useState(function() {
    return c(isNil(t) ? r : t, n);
  }), d = l[0], h = l[1], u = function(v, y) {
    v.formattedValue !== d.formattedValue && h({
      formattedValue: v.formattedValue,
      numAsString: v.value
    }), o(v, y);
  }, p = t, m = n;
  isNil(t) && (p = d.numAsString, m = !0);
  var g = c(p, m);
  return useMemo(function() {
    h(g);
  }, [g.formattedValue]), [d, u];
}
function defaultRemoveFormatting(t) {
  return t.replace(/[^0-9]/g, "");
}
function defaultFormat(t) {
  return t;
}
function NumberFormatBase(t) {
  var r = t.type;
  r === void 0 && (r = "text");
  var n = t.displayType;
  n === void 0 && (n = "input");
  var a = t.customInput, s = t.renderText, o = t.getInputRef, c = t.format;
  c === void 0 && (c = defaultFormat);
  var l = t.removeFormatting;
  l === void 0 && (l = defaultRemoveFormatting);
  var d = t.defaultValue, h = t.valueIsNumericString, u = t.onValueChange, p = t.isAllowed, m = t.onChange;
  m === void 0 && (m = noop$4);
  var g = t.onKeyDown;
  g === void 0 && (g = noop$4);
  var v = t.onMouseUp;
  v === void 0 && (v = noop$4);
  var y = t.onFocus;
  y === void 0 && (y = noop$4);
  var x = t.onBlur;
  x === void 0 && (x = noop$4);
  var _ = t.value, $ = t.getCaretBoundary;
  $ === void 0 && ($ = caretUnknownFormatBoundary);
  var b = t.isValidInputCharacter;
  b === void 0 && (b = charIsNumber);
  var M = t.isCharacterSame, C = __rest(t, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), S = useInternalValues(_, d, !!h, c, l, u), A = S[0], D = A.formattedValue, N = A.numAsString, T = S[1], R = useRef({
    formattedValue: D,
    numAsString: N
  }), F = function(ne, pe) {
    R.current = {
      formattedValue: ne.formattedValue,
      numAsString: ne.value
    }, T(ne, pe);
  }, z = useState(!1), O = z[0], G = z[1], I = useRef(null), k = useRef({
    setCaretTimeout: null,
    focusTimeout: null
  });
  useEffect(function() {
    return G(!0), function() {
      clearTimeout(k.current.setCaretTimeout), clearTimeout(k.current.focusTimeout);
    };
  }, []);
  var B = c, L = function(ne, pe) {
    var hr = parseFloat(pe);
    return {
      formattedValue: ne,
      value: pe,
      floatValue: isNaN(hr) ? void 0 : hr
    };
  }, V = function(ne, pe, hr) {
    ne.selectionStart === 0 && ne.selectionEnd === ne.value.length || (setCaretPosition$1(ne, pe), k.current.setCaretTimeout = setTimeout(function() {
      ne.value === hr && ne.selectionStart !== ne.selectionEnd && setCaretPosition$1(ne, pe);
    }, 0));
  }, U = function(ne, pe, hr) {
    return getCaretPosInBoundary(ne, pe, $(ne), hr);
  }, J = function(ne, pe, hr) {
    var $r = $(pe), Sr = getCaretPosition$2(pe, D, ne, hr, $r, b, M);
    return Sr = getCaretPosInBoundary(pe, Sr, $r), Sr;
  }, q = function(ne) {
    var pe = ne.formattedValue;
    pe === void 0 && (pe = "");
    var hr = ne.input, $r = ne.setCaretPosition;
    $r === void 0 && ($r = !0);
    var Sr = ne.source, ze = ne.event, cr = ne.numAsString, fr = ne.caretPos;
    if (hr) {
      if (fr === void 0 && $r) {
        var mr = ne.inputValue || hr.value, wr = geInputCaretPosition(hr);
        hr.value = pe, fr = J(mr, pe, wr);
      }
      hr.value = pe, $r && fr !== void 0 && V(hr, fr, pe);
    }
    pe !== D && F(L(pe, cr), {
      event: ze,
      source: Sr
    });
  };
  useEffect(function() {
    var ne = R.current, pe = ne.formattedValue, hr = ne.numAsString;
    D !== pe && (D !== N || pe !== hr) && F(L(D, N), {
      event: void 0,
      source: SourceType.props
    });
  }, [D, N]);
  var Z = I.current ? geInputCaretPosition(I.current) : void 0, ae = typeof window < "u" ? useLayoutEffect : useEffect;
  ae(function() {
    var ne = I.current;
    if (D !== R.current.formattedValue && ne) {
      var pe = J(R.current.formattedValue, D, Z);
      ne.value = D, V(ne, pe, D);
    }
  }, [D]);
  var ee = function(ne, pe, hr) {
    var $r = findChangeRange(D, ne), Sr = Object.assign(Object.assign({}, $r), {
      lastValue: D
    }), ze = l(ne, Sr), cr = B(ze);
    if (ze = l(cr, void 0), p && !p(L(cr, ze))) {
      var fr = pe.target, mr = geInputCaretPosition(fr), wr = J(ne, D, mr);
      return fr.value = D, V(fr, wr, D), !1;
    }
    return q({
      formattedValue: cr,
      numAsString: ze,
      inputValue: ne,
      event: pe,
      source: hr,
      setCaretPosition: !0,
      input: pe.target
    }), !0;
  }, se = function(ne) {
    var pe = ne.target, hr = pe.value, $r = ee(hr, ne, SourceType.event);
    $r && m(ne);
  }, nr = function(ne) {
    var pe = ne.target, hr = ne.key, $r = pe.selectionStart, Sr = pe.selectionEnd, ze = pe.value;
    ze === void 0 && (ze = "");
    var cr;
    if (hr === "ArrowLeft" || hr === "Backspace" ? cr = Math.max($r - 1, 0) : hr === "ArrowRight" ? cr = Math.min($r + 1, ze.length) : hr === "Delete" && (cr = $r), cr === void 0 || $r !== Sr) {
      g(ne);
      return;
    }
    var fr = cr;
    if (hr === "ArrowLeft" || hr === "ArrowRight") {
      var mr = hr === "ArrowLeft" ? "left" : "right";
      fr = U(ze, cr, mr), fr !== cr && ne.preventDefault();
    } else
      hr === "Delete" && !b(ze[cr]) ? fr = U(ze, cr, "right") : hr === "Backspace" && !b(ze[cr]) && (fr = U(ze, cr, "left"));
    fr !== cr && V(pe, fr, ze), ne.isUnitTestRun && V(pe, fr, ze), g(ne);
  }, ce = function(ne) {
    var pe = ne.target, hr = pe.selectionStart, $r = pe.selectionEnd, Sr = pe.value;
    if (Sr === void 0 && (Sr = ""), hr === $r) {
      var ze = U(Sr, hr);
      ze !== hr && V(pe, ze, Sr);
    }
    v(ne);
  }, oe = function(ne) {
    ne.persist && ne.persist();
    var pe = ne.target;
    I.current = pe, k.current.focusTimeout = setTimeout(function() {
      var hr = pe.selectionStart, $r = pe.selectionEnd, Sr = pe.value;
      Sr === void 0 && (Sr = "");
      var ze = U(Sr, hr);
      ze !== hr && !(hr === 0 && $r === Sr.length) && V(pe, ze, Sr), y(ne);
    }, 0);
  }, ur = function(ne) {
    I.current = null, clearTimeout(k.current.focusTimeout), clearTimeout(k.current.setCaretTimeout), x(ne);
  }, ir = O && addInputMode() ? "numeric" : void 0, _r = Object.assign({
    inputMode: ir
  }, C, {
    type: r,
    value: D,
    onChange: se,
    onKeyDown: nr,
    onMouseUp: ce,
    onFocus: oe,
    onBlur: ur
  });
  if (n === "text")
    return s ? /* @__PURE__ */ jsx$1(Fragment, {
      children: s(D, C) || null
    }) : /* @__PURE__ */ jsx$1("span", {
      ...Object.assign({}, C, {
        ref: o
      }),
      children: D
    });
  if (a) {
    var yr = a;
    return /* @__PURE__ */ jsx$1(yr, {
      ...Object.assign({}, _r, {
        ref: o
      })
    });
  }
  return /* @__PURE__ */ jsx$1("input", {
    ...Object.assign({}, _r, {
      ref: o
    })
  });
}
function format$9(t, r) {
  var n = r.decimalScale, a = r.fixedDecimalScale, s = r.prefix;
  s === void 0 && (s = "");
  var o = r.suffix;
  o === void 0 && (o = "");
  var c = r.allowNegative, l = r.thousandsGroupStyle;
  if (l === void 0 && (l = "thousand"), t === "" || t === "-")
    return t;
  var d = getSeparators(r), h = d.thousandSeparator, u = d.decimalSeparator, p = n !== 0 && t.indexOf(".") !== -1 || n && a, m = splitDecimal(t, c), g = m.beforeDecimal, v = m.afterDecimal, y = m.addNegation;
  return n !== void 0 && (v = limitToScale(v, n, !!a)), h && (g = applyThousandSeparator(g, h, l)), s && (g = s + g), o && (v = v + o), y && (g = "-" + g), t = g + (p && u || "") + v, t;
}
function getSeparators(t) {
  var r = t.decimalSeparator;
  r === void 0 && (r = ".");
  var n = t.thousandSeparator, a = t.allowedDecimalSeparators;
  return n === !0 && (n = ","), a || (a = [r, "."]), {
    decimalSeparator: r,
    thousandSeparator: n,
    allowedDecimalSeparators: a
  };
}
function handleNegation(t, r) {
  t === void 0 && (t = "");
  var n = new RegExp("(-)"), a = new RegExp("(-)(.)*(-)"), s = n.test(t), o = a.test(t);
  return t = t.replace(/-/g, ""), s && !o && r && (t = "-" + t), t;
}
function getNumberRegex(t, r) {
  return new RegExp("(^-)|[0-9]|" + escapeRegExp(t), r ? "g" : void 0);
}
function isNumericString(t, r, n) {
  return t === "" ? !0 : !(r != null && r.match(/\d/)) && !(n != null && n.match(/\d/)) && typeof t == "string" && !isNaN(Number(t));
}
function removeFormatting(t, r, n) {
  var a;
  r === void 0 && (r = getDefaultChangeMeta(t));
  var s = n.allowNegative, o = n.prefix;
  o === void 0 && (o = "");
  var c = n.suffix;
  c === void 0 && (c = "");
  var l = n.decimalScale, d = r.from, h = r.to, u = h.start, p = h.end, m = getSeparators(n), g = m.allowedDecimalSeparators, v = m.decimalSeparator, y = t[p] === v;
  if (charIsNumber(t) && (t === o || t === c) && r.lastValue === "")
    return t;
  if (p - u === 1 && g.indexOf(t[u]) !== -1) {
    var x = l === 0 ? "" : v;
    t = t.substring(0, u) + x + t.substring(u + 1, t.length);
  }
  var _ = function(k, B, L) {
    var V = !1, U = !1;
    o.startsWith("-") ? V = !1 : k.startsWith("--") ? (V = !1, U = !0) : c.startsWith("-") && k.length === c.length ? V = !1 : k[0] === "-" && (V = !0);
    var J = V ? 1 : 0;
    return U && (J = 2), J && (k = k.substring(J), B -= J, L -= J), {
      value: k,
      start: B,
      end: L,
      hasNegation: V
    };
  }, $ = _(t, u, p), b = $.hasNegation;
  a = $, t = a.value, u = a.start, p = a.end;
  var M = _(r.lastValue, d.start, d.end), C = M.start, S = M.end, A = M.value, D = t.substring(u, p);
  t.length && A.length && (C > A.length - c.length || S < o.length) && !(D && c.startsWith(D)) && (t = A);
  var N = 0;
  t.startsWith(o) ? N += o.length : u < o.length && (N = u), t = t.substring(N), p -= N;
  var T = t.length, R = t.length - c.length;
  t.endsWith(c) ? T = R : (p > R || p > t.length - c.length) && (T = p), t = t.substring(0, T), t = handleNegation(b ? "-" + t : t, s), t = (t.match(getNumberRegex(v, !0)) || []).join("");
  var F = t.indexOf(v);
  t = t.replace(new RegExp(escapeRegExp(v), "g"), function(k, B) {
    return B === F ? "." : "";
  });
  var z = splitDecimal(t, s), O = z.beforeDecimal, G = z.afterDecimal, I = z.addNegation;
  return h.end - h.start < d.end - d.start && O === "" && y && !parseFloat(G) && (t = I ? "-" : ""), t;
}
function getCaretBoundary(t, r) {
  var n = r.prefix;
  n === void 0 && (n = "");
  var a = r.suffix;
  a === void 0 && (a = "");
  var s = Array.from({
    length: t.length + 1
  }).map(function() {
    return !0;
  }), o = t[0] === "-";
  s.fill(!1, 0, n.length + (o ? 1 : 0));
  var c = t.length;
  return s.fill(!1, c - a.length + 1, c + 1), s;
}
function validateAndUpdateProps(t) {
  var r = getSeparators(t), n = r.thousandSeparator, a = r.decimalSeparator, s = t.prefix;
  s === void 0 && (s = "");
  var o = t.allowNegative;
  if (o === void 0 && (o = !0), n === a)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + n + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + a + ` (default value for decimalSeparator is .)
     `);
  return s.startsWith("-") && o && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + s + `
      allowNegative: ` + o + `
    `), o = !1), Object.assign(Object.assign({}, t), {
    allowNegative: o
  });
}
function useNumericFormat(t) {
  t = validateAndUpdateProps(t), t.decimalSeparator, t.allowedDecimalSeparators, t.thousandsGroupStyle;
  var r = t.suffix, n = t.allowNegative, a = t.allowLeadingZeros, s = t.onKeyDown;
  s === void 0 && (s = noop$4);
  var o = t.onBlur;
  o === void 0 && (o = noop$4);
  var c = t.thousandSeparator, l = t.decimalScale, d = t.fixedDecimalScale, h = t.prefix;
  h === void 0 && (h = "");
  var u = t.defaultValue, p = t.value, m = t.valueIsNumericString, g = t.onValueChange, v = __rest(t, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), y = getSeparators(t), x = y.decimalSeparator, _ = y.allowedDecimalSeparators, $ = function(I) {
    return format$9(I, t);
  }, b = function(I, k) {
    return removeFormatting(I, k, t);
  }, M = isNil(p) ? u : p, C = m ?? isNumericString(M, h, r);
  isNil(p) ? isNil(u) || (C = m || typeof u == "number") : C = m || typeof p == "number";
  var S = function(I) {
    return isNotValidValue(I) ? I : (typeof I == "number" && (I = toNumericString(I)), C && typeof l == "number" ? roundToPrecision(I, l, !!d) : I);
  }, A = useInternalValues(S(p), S(u), !!C, $, b, g), D = A[0], N = D.numAsString, T = D.formattedValue, R = A[1], F = function(I) {
    var k = I.target, B = I.key, L = k.selectionStart, V = k.selectionEnd, U = k.value;
    if (U === void 0 && (U = ""), L !== V) {
      s(I);
      return;
    }
    B === "Backspace" && U[0] === "-" && L === h.length + 1 && n && setCaretPosition$1(k, 1), B === "Backspace" && U[L - 1] === x && l && d && (setCaretPosition$1(k, L - 1), I.preventDefault()), _ != null && _.includes(B) && U[L] === x && setCaretPosition$1(k, L + 1);
    var J = c === !0 ? "," : c;
    B === "Backspace" && U[L - 1] === J && setCaretPosition$1(k, L - 1), B === "Delete" && U[L] === J && setCaretPosition$1(k, L + 1), s(I);
  }, z = function(I) {
    var k = N;
    if (k.match(/\d/g) || (k = ""), a || (k = fixLeadingZero(k)), d && l && (k = roundToPrecision(k, l, d)), k !== N) {
      var B = format$9(k, t);
      R({
        formattedValue: B,
        value: k,
        floatValue: parseFloat(k)
      }, {
        event: I,
        source: SourceType.event
      });
    }
    o(I);
  }, O = function(I) {
    return I === x ? !0 : charIsNumber(I);
  }, G = function(I) {
    var k = I.currentValue, B = I.lastValue, L = I.formattedValue, V = I.currentValueIndex, U = I.formattedValueIndex, J = k[V], q = L[U], Z = findChangeRange(B, k), ae = Z.to;
    return V >= ae.start && V < ae.end && _ && _.includes(J) && q === x ? !0 : J === q;
  };
  return Object.assign(Object.assign({}, v), {
    value: T,
    valueIsNumericString: !1,
    isValidInputCharacter: O,
    isCharacterSame: G,
    onValueChange: R,
    format: $,
    removeFormatting: b,
    getCaretBoundary: function(I) {
      return getCaretBoundary(I, t);
    },
    onKeyDown: F,
    onBlur: z
  });
}
function NumericFormat(t) {
  var r = useNumericFormat(t);
  return /* @__PURE__ */ jsx$1(NumberFormatBase, {
    ...Object.assign({}, r)
  });
}
function format$1$1(t, r) {
  var n = r.format, a = r.allowEmptyFormatting, s = r.mask, o = r.patternChar;
  if (o === void 0 && (o = "#"), t === "" && !a)
    return "";
  for (var c = 0, l = n.split(""), d = 0, h = n.length; d < h; d++)
    n[d] === o && (l[d] = t[c] || getMaskAtIndex(s, c), c += 1);
  return l.join("");
}
function removeFormatting$1(t, r, n) {
  r === void 0 && (r = getDefaultChangeMeta(t));
  var a = n.format, s = n.patternChar;
  s === void 0 && (s = "#");
  var o = r.from, c = r.to, l = r.lastValue;
  l === void 0 && (l = "");
  var d = function(x) {
    return a[x] === s;
  }, h = function(x, _) {
    for (var $ = "", b = 0; b < x.length; b++)
      d(_ + b) && charIsNumber(x[b]) && ($ += x[b]);
    return $;
  }, u = function(x) {
    return x.replace(/[^0-9]/g, "");
  };
  if (!a.match(/\d/))
    return u(t);
  if (l === "" && t.length === a.length) {
    for (var p = "", m = 0; m < t.length; m++)
      if (d(m))
        charIsNumber(t[m]) && (p += t[m]);
      else if (t[m] !== a[m])
        return u(t);
    return p;
  }
  var g = l.substring(0, o.start), v = t.substring(c.start, c.end), y = l.substring(o.end);
  return "" + h(g, 0) + u(v) + h(y, o.end);
}
function getCaretBoundary$1(t, r) {
  var n = r.format, a = r.mask, s = r.patternChar;
  s === void 0 && (s = "#");
  var o = Array.from({
    length: t.length + 1
  }).map(function() {
    return !0;
  }), c = 0, l = -1, d = {};
  n.split("").forEach(function(m, g) {
    var v = void 0;
    m === s && (c++, v = getMaskAtIndex(a, c - 1), l === -1 && t[g] === v && (l = g)), d[g] = v;
  });
  for (var h = function(m) {
    return n[m] === s && t[m] !== d[m];
  }, u = 0, p = o.length; u < p; u++)
    o[u] = u === l || h(u) || h(u - 1);
  return o[n.indexOf(s)] = !0, o;
}
function validateProps(t) {
  var r = t.mask;
  if (r) {
    var n = r === "string" ? r : r.toString();
    if (n.match(/\d/g))
      throw new Error("Mask " + r + " should not contain numeric character;");
  }
}
function isNumericString$1(t, r) {
  return t === "" ? !0 : !(r != null && r.match(/\d/)) && typeof t == "string" && (!!t.match(/^\d+$/) || t === "");
}
function usePatternFormat(t) {
  t.mask, t.allowEmptyFormatting;
  var r = t.format, n = t.inputMode;
  n === void 0 && (n = "numeric");
  var a = t.onKeyDown;
  a === void 0 && (a = noop$4);
  var s = t.patternChar;
  s === void 0 && (s = "#");
  var o = t.value, c = t.defaultValue, l = t.valueIsNumericString, d = __rest(t, ["mask", "allowEmptyFormatting", "format", "inputMode", "onKeyDown", "patternChar", "value", "defaultValue", "valueIsNumericString"]);
  validateProps(t);
  var h = function(v) {
    return getCaretBoundary$1(v, t);
  }, u = function(v) {
    var y = v.key, x = v.target, _ = x.selectionStart, $ = x.selectionEnd, b = x.value;
    if (_ !== $) {
      a(v);
      return;
    }
    var M = _;
    if (y === "Backspace" || y === "Delete") {
      var C = "right";
      if (y === "Backspace") {
        for (; M > 0 && r[M - 1] !== s; )
          M--;
        C = "left";
      } else {
        for (var S = r.length; M < S && r[M] !== s; )
          M++;
        C = "right";
      }
      M = getCaretPosInBoundary(b, M, h(b), C);
    } else
      r[M] !== s && y !== "ArrowLeft" && y !== "ArrowRight" && (M = getCaretPosInBoundary(b, M + 1, h(b), "right"));
    M !== _ && setCaretPosition$1(x, M), a(v);
  }, p = isNil(o) ? c : o, m = l ?? isNumericString$1(p, r), g = Object.assign(Object.assign({}, t), {
    valueIsNumericString: m
  });
  return Object.assign(Object.assign({}, d), {
    value: o,
    defaultValue: c,
    valueIsNumericString: m,
    inputMode: n,
    format: function(v) {
      return format$1$1(v, g);
    },
    removeFormatting: function(v, y) {
      return removeFormatting$1(v, y, g);
    },
    getCaretBoundary: h,
    onKeyDown: u
  });
}
function PatternFormat(t) {
  var r = usePatternFormat(t);
  return /* @__PURE__ */ jsx$1(NumberFormatBase, {
    ...Object.assign({}, r)
  });
}
const Input$6 = styled.input`
  ${TextInputStyles}
`, InputMask$1 = styled(NumericFormat)`
  ${TextInputStyles}
`, MandatoryText = styled.p`
  ${({ theme: { components: t } }) => t.inputs.fds_c_input_mandatory_text};
  color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_secondary};
`, ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
  @keyframes shake {
    0% {
      transform: none;
    }
    25% {
      transform: translateX(-4px);
    }
    50% {
      transform: translateX(4px);
    }
    75% {
      transform: translateX(-4px);
    }
    100% {
      transform: none;
    }
  }

  cursor: ${({ $readOnly: t }) => t ? "default" : "pointer"};
  button {
    svg {
      stroke: none;
    }
  }
`, TextContainer$1 = styled.div`
  background: transparent;
  top: ${({ theme: { reference: t } }) => t.dimension_16};
  right: ${({ theme: { reference: t } }) => t.dimension_08};
  position: absolute;
  cursor: pointer;
  button {
    span {
      padding-top: ${({ theme: { system: t } }) => t.fds_sys_borderwidth_L};
      ${({ theme: { system: t } }) => t.fds_sys_S};
      font-weight: ${({ theme: { system: t } }) => t.fds_sys_weight_XL};
      color: ${({ theme: { colors: t } }) => t.sky_500};
    }
  }
`, InputContainer$1 = styled(FlexContainer$1)`
  position: relative;
  &:hover {
    ${ButtonContainer} {
      > svg {
        animation: shake 0.25s;
        animation-timing-function: ${({ theme: { system: t } }) => t.easings.fds_sys_ease_default};
      }
    }
  }
`;
var WrapModes = /* @__PURE__ */ ((t) => (t.light = "light", t.soft = "soft", t.cold = "cold", t.success = "success", t.warning = "warning", t.danger = "danger", t.fresh_gradient = "fresh_gradient", t.warm_gradient = "warm_gradient", t.cold_gradient = "cold_gradient", t))(WrapModes || {}), WrapSizes = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t.L = "L", t))(WrapSizes || {});
const wrapSizeStyles = {
  [WrapSizes.S]: css$3`
    padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_XS};
    border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_M};
  `,
  [WrapSizes.M]: css$3`
    padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
    border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
  `,
  [WrapSizes.L]: css$3`
    padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_M};
    border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
  `
}, wrapModeStyles = {
  [WrapModes.success]: css$3`
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_success};
    border-color: ${({ theme: { system: t } }) => t.border.fds_sys_color_border_success};
  `,
  [WrapModes.warning]: css$3`
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_warning};
    border-color: ${({ theme: { system: t } }) => t.border.fds_sys_color_border_warning};
  `,
  [WrapModes.danger]: css$3`
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_error};
    border-color: ${({ theme: { system: t } }) => t.border.fds_sys_color_border_error};
  `,
  [WrapModes.cold]: css$3`
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_cold};
    border-color: ${({ theme: { system: t } }) => t.accent.fds_sys_color_accent_cold};
  `,
  [WrapModes.light]: css$3`
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_primary};
    border-color: ${({ theme: { system: t } }) => t.border.fds_sys_color_border_primary};
  `,
  [WrapModes.soft]: css$3`
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_supersoft};
    border-color: ${({ theme: { system: t } }) => t.border.fds_sys_color_border_primary};
  `,
  [WrapModes.fresh_gradient]: css$3`
    background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_gradient_A};
    border-width: 0;
  `,
  [WrapModes.warm_gradient]: css$3`
    background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_gradient_C};
    border-width: 0;
  `,
  [WrapModes.cold_gradient]: css$3`
    background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_gradient_B};
    border-width: 0;
  `
}, Container$d = styled.div`
  width: ${({ fullWidth: t }) => t ? "100%" : "initial"};

  border: ${({ theme: { system: t } }) => `${t.fds_sys_borderwidth_S} solid`};
  ${({ size: t }) => t && wrapSizeStyles[t]};

  ${({ mode: t }) => t && wrapModeStyles[t]};

  ${({ hasRadius: t }) => !t && css$3`
      border-radius: 0;
    `}

  ${({ hasBorder: t }) => !t && css$3`
      border-width: 0;
    `}
`, Wrap = ({
  children: t,
  size: r,
  mode: n = WrapModes.light,
  hasBorder: a = !1,
  hasRadius: s = !0,
  fullWidth: o,
  ...c
}) => /* @__PURE__ */ jsx$1(Container$d, {
  size: r,
  mode: n,
  hasBorder: a,
  hasRadius: s,
  fullWidth: o,
  ...c,
  children: t
});
var CenteredSizes = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t.L = "L", t.XL = "XL", t))(CenteredSizes || {}), CenteredWidths = /* @__PURE__ */ ((t) => (t.S = "480px", t.M = "768px", t.L = "1200px", t))(CenteredWidths || {});
const spacingS = css$3`
  @media screen and (max-width: ${CenteredWidths.S}) {
    margin: 0 ${({ theme: { reference: t } }) => t.dimension_16};
  }
`, spacingM = css$3`
  @media screen and (max-width: ${CenteredWidths.M}) {
    margin: 0 ${({ theme: { system: t } }) => t.fds_sys_spacing_M};
  }
`, centeredSizeStyles = {
  [CenteredSizes.S]: css$3`
    max-width: ${({ theme: { reference: t } }) => t.dimension_480};
    margin: 0 ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
  `,
  [CenteredSizes.M]: css$3`
    max-width: ${CenteredWidths.M};
    margin: 0 ${({ theme: { system: t } }) => t.fds_sys_spacing_M};
    ${spacingS}
  `,
  [CenteredSizes.L]: css$3`
    max-width: ${CenteredWidths.L};
    margin: 0 ${({ theme: { system: t } }) => t.fds_sys_spacing_L};
    ${spacingM}
    ${spacingS}
  `,
  [CenteredSizes.XL]: css$3`
    margin: 0 ${({ theme: { system: t } }) => t.fds_sys_spacing_L};
    ${spacingM}
    ${spacingS}
  `
}, Content$3 = styled.div`
  width: 100%;
  min-width: 0;
  margin: 0 auto;
  ${({ size: t }) => t && centeredSizeStyles[t]};
`, Container$c = styled.div`
  display: flex;
  justify-content: center;
  height: ${({ fullHeight: t }) => t ? "100%" : "initial"};
`, Centered$1 = ({
  children: t,
  size: r,
  fullHeight: n,
  ...a
}) => /* @__PURE__ */ jsx$1(Container$c, {
  fullHeight: n,
  ...a,
  children: /* @__PURE__ */ jsx$1(Content$3, {
    size: r,
    children: t
  })
});
var SectionsRootLayout = /* @__PURE__ */ ((t) => (t.ContainerLayout = "ContainerLayout", t.NavRoot = "Nav", t.ContainerRoot = "ContainerRoot", t.LeftSidebar = "LeftSidebar", t.RightSidebar = "RightSidebar", t.ContainerContent = "ContainerContent", t.Header = "Header", t.ContentHeader = "ContentHeader", t.Content = "Content", t.ContentFooter = "ContentFooter", t.Footer = "Footer", t.CloseArea = "CloseArea", t))(SectionsRootLayout || {});
const ContainerLayout = styled.section`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  flex-grow: 1;
  overflow: hidden;

  @media screen and (max-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    &.is-block-container {
      overflow-y: hidden;
      > section#CloseArea {
        pointer-events: none;
        background-color: ${({ theme: t }) => t.reference.functional.darken_600};
        backdrop-filter: ${({ theme: { reference: t } }) => `blur(${t.dimension_08})`};
        height: 100%;
        width: 100%;
        position: absolute;
        z-index: ${({ theme: { system: t } }) => parseInt(t.zIndex.fds_sys_zindex_overlay, 10) - 1};
      }
    }
  }
`, NavRoot = styled.section`
  display: flex;
  min-height: ${({ theme: { reference: t } }) => t.dimension_48};
  max-height: ${({ theme: { reference: t } }) => t.dimension_48};
  &:empty,
  &:has(> slot:empty) {
    display: none;
  }
`, ContainerRoot$1 = styled.section`
  display: flex;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  &:not(:has(> * > #Content > *)) {
    display: none;
  }
`, LeftSidebar = styled.section`
  overflow: hidden;
  transition: transform 0.3s ease-in-out 0s;

  > div:last-child,
  > slot > div:last-child {
    background-color: ${({ theme: { colors: t } }) => t.white};
    overflow-y: auto;
  }

  @media screen and (max-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    position: fixed;
    top: 0;
    transform: translateX(-100%);
    z-index: ${({ theme: { system: t } }) => t.zIndex.fds_sys_zindex_overlay};
    &.is-open-left-sidebar {
      transform: translateX(0);
    }
  }
`, RightSidebar = styled.section`
  position: fixed;
  top: 0;
  right: 0;
  overflow: hidden;
  transition: transform 0.3s ease-in-out 0s;
  z-index: ${({ theme: { system: t } }) => t.zIndex.fds_sys_zindex_overlay};

  transform: translateX(200%);
  &.is-open-right-sidebar {
    transform: translateX(0);
  }

  > div:last-child,
  > slot > div:last-child {
    background-color: ${({ theme: { colors: t } }) => t.white};
    overflow-y: auto;
  }
`, ContainerContent = styled.section`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
`, Header$2 = styled.section`
  position: sticky;
  display: flex;
  top: 0;
  z-index: ${({ theme: { system: t } }) => t.zIndex.fds_sys_zindex_navigation};
  flex-shrink: 1;
`, HeaderContent = styled.section`
  display: flex;
  flex-shrink: 1;
`, Content$2 = styled.section`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &:empty,
  &:has(> slot:empty) {
    display: none;
  }
`, FooterContent = styled.section`
  display: flex;
  flex-shrink: 1;
`, Footer = styled.section`
  position: sticky;
  display: flex;
  bottom: 0;
  flex-shrink: 1;
  z-index: ${({ theme: { system: t } }) => t.zIndex.fds_sys_zindex_navigation};
`, RootPortals = () => /* @__PURE__ */ jsxs(ContainerLayout, {
  id: SectionsRootLayout.ContainerLayout,
  children: [/* @__PURE__ */ jsx$1(NavRoot, {
    id: SectionsRootLayout.NavRoot
  }), /* @__PURE__ */ jsxs(ContainerRoot$1, {
    id: SectionsRootLayout.ContainerRoot,
    children: [/* @__PURE__ */ jsx$1(LeftSidebar, {
      id: SectionsRootLayout.LeftSidebar
    }), /* @__PURE__ */ jsxs(ContainerContent, {
      id: SectionsRootLayout.ContainerContent,
      children: [/* @__PURE__ */ jsx$1(Header$2, {
        id: SectionsRootLayout.Header
      }), /* @__PURE__ */ jsx$1(HeaderContent, {
        id: SectionsRootLayout.ContentHeader
      }), /* @__PURE__ */ jsx$1(Content$2, {
        id: SectionsRootLayout.Content
      }), /* @__PURE__ */ jsx$1(FooterContent, {
        id: SectionsRootLayout.ContentFooter
      }), /* @__PURE__ */ jsx$1(Footer, {
        id: SectionsRootLayout.Footer
      })]
    }), /* @__PURE__ */ jsx$1(RightSidebar, {
      id: SectionsRootLayout.RightSidebar
    })]
  }), /* @__PURE__ */ jsx$1("section", {
    id: SectionsRootLayout.CloseArea
  })]
}), Layout = {
  Wrap,
  Centered: Centered$1,
  Grid: Grid$1,
  RootPortals
}, HeaderContainer = styled(FlexContainer$1)`
  button {
    color: ${({ theme: { components: t } }) => t.buttons.fds_c_button_cold};
    flex: none;
  }
`;
styled(FlexContainer$1)`
  align-items: center;
  width: 100%;
  height: auto;
`;
const Header$1 = ({
  label: t,
  contextualLabel: r = "Saber más",
  description: n,
  helpButtonUrl: a,
  onHelpButton: s
}) => {
  const o = () => {
    const c = new CustomEvent(Events.HELP_BUTTON_PRESSED, {
      detail: {
        helpButtonUrl: a
      }
    });
    dispatchEvent(c), a && (s == null || s(a));
  };
  return /* @__PURE__ */ jsxs(FlexContainer$1, {
    direction: "column",
    gap: "dimension_16",
    children: [/* @__PURE__ */ jsxs(HeaderContainer, {
      align: "flex-end",
      justify: "space-between",
      gap: "dimension_16",
      fullWidth: !0,
      children: [t && /* @__PURE__ */ jsx$1(Text$3, {
        type: "paragraphs",
        size: "S_M_S",
        color: "dark",
        children: t
      }), a && s && /* @__PURE__ */ jsx$1(Buttons.Contextual, {
        label: r,
        mode: "primary",
        onClick: o
      })]
    }), n && /* @__PURE__ */ jsx$1(Text$3, {
      type: "paragraphs",
      color: "grey",
      size: "XS_M_S",
      children: n
    })]
  });
}, Info = styled(Text$3)`
  ${css$3`
    ${({ theme: { components: t } }) => t.text.fds_c_text_styled_text};
    ${({ hasError: t, theme: { system: r } }) => t && css$3`
        color: ${r.text.fds_sys_color_text_danger_strong};
      `}
    ${({ hasWarning: t, theme: { system: r } }) => t && css$3`
        color: ${r.text.fds_sys_color_text_warning_strong};
      `}
  `}
`, InputInfo = ({
  message: t,
  ...r
}) => /* @__PURE__ */ jsx$1(Info, {
  ...r,
  children: t
}), InputLayout = ({
  label: t,
  description: r,
  contextualLabel: n,
  isMandatory: a,
  isOptional: s,
  children: o,
  onHelpButton: c,
  helpButtonUrl: l,
  errorMsg: d,
  warningMsg: h,
  hasError: u,
  hasWarning: p,
  rigthIcon: m,
  rigthButtonClick: g,
  actionLabel: v,
  actionOnClick: y,
  readOnly: x,
  ..._
}) => /* @__PURE__ */ jsxs(Layout.Grid, {
  gap: "dimension_16",
  ..._,
  children: [(t || n || r || l) && /* @__PURE__ */ jsx$1(Header$1, {
    label: t,
    contextualLabel: n,
    description: r,
    helpButtonUrl: l,
    onHelpButton: c
  }), /* @__PURE__ */ jsxs(Layout.Grid, {
    gap: "dimension_08",
    children: [s && /* @__PURE__ */ jsx$1(MandatoryText, {
      children: MandatoryLabels.OPTIONAL
    }), a && /* @__PURE__ */ jsx$1(MandatoryText, {
      children: MandatoryLabels.IS_MANDATORY
    }), /* @__PURE__ */ jsxs(InputContainer$1, {
      children: [o, v && y && !x && /* @__PURE__ */ jsx$1(TextContainer$1, {
        children: /* @__PURE__ */ jsx$1(Buttons.Tiny, {
          mode: "default",
          label: v || "",
          onClick: y
        })
      }), m && !x && /* @__PURE__ */ jsx$1(ButtonContainer, {
        children: /* @__PURE__ */ jsx$1(Buttons.Icon, {
          icon: m,
          mode: "secondary",
          onClick: g,
          size: "xxs"
        })
      }), x && /* @__PURE__ */ jsx$1(ButtonContainer, {
        $readOnly: x,
        children: /* @__PURE__ */ jsx$1(Icon$4, {
          icon: "IconPadLock",
          color: "secondary"
        })
      })]
    })]
  }), (u || p) && /* @__PURE__ */ jsx$1(InputInfo, {
    message: d || h,
    hasError: u,
    hasWarning: p
  })]
}), withInputLayout = (t) => (n) => {
  const {
    id: a,
    contextualLabel: s,
    hasError: o,
    hasWarning: c,
    onHelpButton: l,
    errorMsg: d,
    warningMsg: h,
    label: u,
    description: p,
    isMandatory: m,
    isOptional: g,
    helpButtonUrl: v,
    rigthIcon: y,
    rigthButtonClick: x,
    readOnly: _,
    className: $,
    style: b,
    actionLabel: M,
    actionOnClick: C,
    disabled: S,
    testID: A,
    ...D
  } = n;
  return /* @__PURE__ */ jsx$1(InputLayout, {
    contextualLabel: s,
    hasError: o,
    hasWarning: c,
    onHelpButton: l,
    errorMsg: d,
    warningMsg: h,
    label: u,
    description: p,
    isMandatory: m,
    isOptional: g,
    helpButtonUrl: v,
    rigthIcon: y,
    rigthButtonClick: x,
    readOnly: _,
    className: $,
    actionLabel: M,
    actionOnClick: C,
    style: b,
    children: /* @__PURE__ */ jsx$1(t, {
      ...D,
      id: a,
      hasError: o,
      "data-testid": a ?? A,
      disabled: S,
      hasWarning: c,
      readOnly: _,
      onHelpButton: l
    })
  });
}, Text$1 = ({
  value: t,
  hasError: r,
  hasWarning: n,
  onChange: a,
  readOnly: s,
  ...o
}) => /* @__PURE__ */ jsx$1(Input$6, {
  ...o,
  value: t,
  readOnly: s,
  $hasError: r,
  $hasWarning: n,
  onChange: (c) => a == null ? void 0 : a(c.target.value)
}), Text$2 = withInputLayout(Text$1), inputCardImage = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRDlEOUQ5IiBmaWxsLW9wYWNpdHk9IjAuMDEiLz4KPHJlY3Qgb3BhY2l0eT0iMC4zIiB4PSIxMCIgeT0iMTkuNSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjU5IiByeD0iNSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzg1OTVfMjk3OTIpIi8+CjxyZWN0IG9wYWNpdHk9IjAuNCIgeD0iMzAiIHk9IjEuNSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjU5IiByeD0iNSIgZmlsbD0idXJsKCNwYWludDFfcmFkaWFsXzg1OTVfMjk3OTIpIi8+CjxwYXRoIGQ9Ik00MyAzM0w0OCAzOEw1OS41IDI3LjUiIHN0cm9rZT0idXJsKCNwYWludDJfbGluZWFyXzg1OTVfMjk3OTIpIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzg1OTVfMjk3OTIiIHgxPSIxMCIgeTE9Ijc4LjUiIHgyPSIzNiIgeTI9IjI1LjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzE2N0E2MiIvPgo8c3RvcCBvZmZzZXQ9IjAuNDMyMjkyIiBzdG9wLWNvbG9yPSIjMEZCOTkwIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzBGQjk5MCIgc3RvcC1vcGFjaXR5PSIwLjEiLz4KPC9saW5lYXJHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDFfcmFkaWFsXzg1OTVfMjk3OTIiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDAgMTMpIHJvdGF0ZSg0OC41MTY1KSBzY2FsZSg2My40MDU0IDYwLjAzMjgpIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0ZGN0Y2MyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRjdGNjMiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50Ml9saW5lYXJfODU5NV8yOTc5MiIgeDE9IjQzIiB5MT0iMzIuNSIgeDI9IjYyLjUiIHkyPSIyNiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNTQ4Q0VBIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzU0OENFQSIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
var CardDirection = /* @__PURE__ */ ((t) => (t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t))(CardDirection || {});
const Container$b = styled(FlexContainer$1)`
  position: relative;
  border: ${({ theme: { system: t, components: r }, checked: n }) => `
      ${t.fds_sys_borderwidth_S} solid ${n ? r.cells.fds_c_cells_border_color_selected : r.inputs.fds_c_input_bordercolor}
    `};
  border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_L};
  padding: ${({ theme: { reference: t } }) => t.dimension_16};
  background: ${({ theme: { components: t }, checked: r }) => r && t.inputs.fds_c_input_color_selected};
  box-shadow: ${({ theme: { system: t }, checked: r }) => {
  const { x: n, y: a, blur: s, spread: o, color: c } = t.fds_sys_embed_M;
  return r && `inset ${n} ${a} ${s} ${o} ${c}`;
}};
  transition: box-shadow 1.5s cubic-bezier(0, 0.8, 0.2, 1),
    border-color 1.5s cubic-bezier(0, 0.8, 0.2, 1);

  @keyframes gradient {
    0% {
      background-position: 0% 0%;
    }

    100% {
      background-position: -100vw 0%;
    }
  }

  ${({ disabled: t, checked: r }) => t ? css$3`
          opacity: ${({ theme: { system: n } }) => n.fds_sys_disabled_opacity_S};
          cursor: not-allowed;
        ` : css$3`
          &:hover {
            box-shadow: ${({ theme: { system: n } }) => {
  const { x: a, y: s, blur: o, spread: c, color: l } = n.fds_sys_elevation_M;
  return r ? `${a} ${s} ${o} ${c} ${l}, inset ${a} ${s} ${o} ${c} ${l}` : `${a} ${s} ${o} ${c} ${l}`;
}};
            border-color: ${({ theme: { components: n } }) => n.cells.fds_c_cells_border_color_hover};
            transition: box-shadow 0.25s cubic-bezier(0, 0, 0.2, 2),
              border-color 0.25s cubic-bezier(0, 0, 0.2, 2);
          }
        `}
`, Image$2 = styled.img`
  flex-grow: 0;
  height: max-content;
  max-height: ${({ theme: { reference: t } }) => t.dimension_80};
  max-width: ${({ theme: { reference: t } }) => t.dimension_80};
`, Body = styled(FlexContainer$1)`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
`, InfoButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  position: absolute;
  top: ${({ theme: { reference: t } }) => t.dimension_08};
  left: ${({ theme: { reference: t } }) => t.dimension_08};
`, Success = styled.div`
  position: absolute;
  top: ${({ theme: { reference: t } }) => t.dimension_08};
  right: ${({ theme: { reference: t } }) => t.dimension_08};
`, IconContainer = styled(FlexContainer$1)`
  padding: ${({ theme: { reference: t } }) => t.dimension_12};
`;
styled.div`
  width: 100%;
`;
const Card = ({
  label: t,
  description: r,
  checked: n = !1,
  direction: a = CardDirection.HORIZONTAL,
  contextualLabel: s = "Saber más",
  onContextualClick: o,
  imageUrl: c,
  icon: l,
  helpButtonUrl: d,
  hideImg: h,
  rightContent: u,
  disabled: p,
  ...m
}) => {
  const g = (v) => {
    o == null || o(v);
  };
  return /* @__PURE__ */ jsxs(Container$b, {
    fullHeight: !0,
    checked: n,
    direction: a === CardDirection.VERTICAL ? "column" : "row",
    gap: l ? "dimension_16" : "dimension_08",
    align: "center",
    disabled: p,
    ...m,
    children: [!h && c ? /* @__PURE__ */ jsx$1(Image$2, {
      src: c || inputCardImage,
      alt: "card image"
    }) : l && /* @__PURE__ */ jsx$1(IconContainer, {
      align: "center",
      justify: "center",
      children: /* @__PURE__ */ jsx$1(Icon$4, {
        icon: l,
        color: "default"
      })
    }), /* @__PURE__ */ jsxs(Body, {
      direction: "column",
      gap: "dimension_08",
      children: [/* @__PURE__ */ jsxs(FlexContainer$1, {
        gap: "dimension_08",
        direction: "column",
        align: a === CardDirection.VERTICAL ? "center" : "flex-start",
        children: [t && /* @__PURE__ */ jsx$1(Text$3, {
          type: "paragraphs",
          color: "dark",
          size: "S_L_S",
          align: a === CardDirection.VERTICAL ? "center" : "left",
          children: t
        }), r && /* @__PURE__ */ jsx$1(FlexContainer$1, {
          fullWidth: !0,
          children: typeof r == "string" ? /* @__PURE__ */ jsx$1(Text$3, {
            type: "paragraphs",
            color: "dark",
            size: "XS_M_S",
            align: a === CardDirection.VERTICAL ? "center" : "left",
            children: r
          }) : r
        })]
      }), o && (a === CardDirection.HORIZONTAL ? /* @__PURE__ */ jsx$1(FlexContainer$1, {
        justify: "flex-start",
        children: /* @__PURE__ */ jsx$1(Buttons.Contextual, {
          mode: "primary",
          label: s,
          onClick: () => g(d)
        })
      }) : /* @__PURE__ */ jsx$1(InfoButton, {
        onClick: () => g(d),
        children: /* @__PURE__ */ jsx$1(Icon$4, {
          icon: "IconInfoLineSDark",
          color: "default",
          width: 16,
          height: 16
        })
      })), !!n && /* @__PURE__ */ jsx$1(Success, {
        children: /* @__PURE__ */ jsx$1(Icon$4, {
          icon: "CircleTickSolidXS",
          color: "cold",
          width: 16,
          height: 16
        })
      })]
    }), u && /* @__PURE__ */ jsx$1(FlexContainer$1, {
      justify: "flex-end",
      children: u
    })]
  });
}, Arrow = () => /* @__PURE__ */ jsxs("svg", {
  width: "15",
  height: "23",
  viewBox: "0 0 15 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx$1("path", {
    d: "M11.7109 17L6.71094 17C3.94951 17 1.71094 14.7614 1.71094 12L1.71094 1",
    stroke: "#3D3A62",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M9.78651 12.5966L13.8621 17L9.78651 21.4034",
    stroke: "#3D3A62",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}), CheckboxContainer$1 = styled.label`
  display: flex;
  flex-direction: ${({ $withInput: t }) => t ? "row" : "column"};
  gap: ${({ theme: { reference: t } }) => t.dimension_08};
  ${MarginsStyles}
  input,
  button {
    flex-shrink: 0;
  }
`, CheckBox$1 = styled.input`
  ${InputOptionStyles}
`, formatCheckbox = (t) => t === !0 || t === 1, CheckBoxWrapper = ({
  value: t,
  children: r,
  id: n,
  testID: a,
  withInput: s = !1,
  disabled: o,
  readOnly: c,
  ref: l,
  onChange: d,
  ...h
}) => {
  const u = formatCheckbox(t);
  return /* @__PURE__ */ jsxs(CheckboxContainer$1, {
    $withInput: s,
    children: [/* @__PURE__ */ jsx$1(CheckBox$1, {
      ...h,
      type: "checkbox",
      id: n,
      "data-testid": a,
      value: u.toString(),
      checked: u,
      disabled: o || c,
      $readOnly: c,
      $withInput: s,
      ref: l,
      onClick: () => d(!u)
    }), r]
  });
}, ChildrenContainer = styled(FlexContainer$1)`
  width: 100%;
  gap: ${({ theme: { system: t } }) => t.fds_sys_spacing_XS};
  margin-top: ${({ theme: { system: t } }) => t.fds_sys_spacing_XS};
  padding-left: ${({ theme: { system: t } }) => `calc(${t.fds_sys_spacing_XS} - ${t.fds_sys_borderradius_XS})`};
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  svg {
    width: ${({ theme: { system: t } }) => t.fds_sys_sizing_XS};
  }
  animation: fadein 0.5s cubic-bezier(0.8, 0, 0.2, 1);
`, ChildrenContent = styled(FlexContainer$1)`
  display: flex;
  flex-wrap: wrap;
  width: 90%;
  padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
  background-color: ${({ theme: { components: t } }) => t.inputs.fds_c_input_optional_extra_background};
  border: ${({ theme: { components: t } }) => t.inputs.fds_c_input_default_borderwidth} solid
    ${({ theme: { system: t } }) => t.border.fds_sys_color_border_primary};
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
`, CheckBox = ({
  children: t,
  label: r,
  helpButtonUrl: n,
  onHelpButton: a,
  contextualLabel: s = "Saber más",
  value: o,
  onChange: c,
  ...l
}) => /* @__PURE__ */ jsxs(Fragment, {
  children: [/* @__PURE__ */ jsx$1(CheckBoxWrapper, {
    ...l,
    onChange: (h) => {
      c(h);
    },
    withInput: !0,
    value: o,
    children: /* @__PURE__ */ jsxs(FlexContainer$1, {
      fullWidth: !0,
      gap: "dimension_08",
      children: [/* @__PURE__ */ jsx$1(Text$3, {
        type: "paragraphs",
        color: "dark",
        size: "S_M_S",
        children: r
      }), n && a && /* @__PURE__ */ jsx$1(Buttons.Contextual, {
        mode: "primary",
        label: s,
        onClick: () => a(n)
      })]
    })
  }), t && o && /* @__PURE__ */ jsxs(ChildrenContainer, {
    children: [/* @__PURE__ */ jsx$1(Arrow, {}), /* @__PURE__ */ jsx$1(ChildrenContent, {
      children: t
    })]
  })]
}), CheckboxContainer = styled.div`
  width: 100%;
  position: relative;
  ${MarginsStyles}
`, CheckBoxCard = ({
  value: t,
  onChange: r,
  id: n,
  testID: a,
  mr: s,
  mb: o,
  ml: c,
  mt: l,
  ...d
}) => /* @__PURE__ */ jsx$1(CheckboxContainer, {
  mb: o,
  mt: l,
  ml: c,
  mr: s,
  children: /* @__PURE__ */ jsx$1(CheckBoxWrapper, {
    id: n,
    "data-testid": a,
    value: t,
    onChange: r,
    ...d,
    children: /* @__PURE__ */ jsx$1(Card, {
      checked: t,
      ...d
    })
  })
}), Input$5 = styled.input`
  ${TextInputStyles}
`, TextContainer = styled.div`
  background: transparent;
  top: ${({ theme: { reference: t } }) => t.dimension_16};
  right: ${({ theme: { reference: t } }) => t.dimension_16};
  position: absolute;
  cursor: pointer;
  button {
    span {
      ${({ theme: { system: t } }) => t.fds_sys_S};
      font-weight: ${({ theme: { system: t } }) => t.fds_sys_weight_XL};
      color: ${({ theme: { colors: t } }) => t.sky_500};
    }
  }
`, Copied = ({
  value: t,
  hasError: r,
  hasWarning: n,
  onChange: a,
  disabled: s,
  readOnly: o,
  ...c
}) => {
  const l = async (d) => {
    var h;
    d.stopPropagation(), (h = navigator == null ? void 0 : navigator.clipboard) != null && h.writeText && t && await (navigator == null ? void 0 : navigator.clipboard.writeText(t));
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(Input$5, {
      ...c,
      value: t,
      $hasError: r,
      $hasWarning: n,
      onChange: (d) => a == null ? void 0 : a(d.target.value),
      disabled: s || o,
      readOnly: o
    }), !o && /* @__PURE__ */ jsx$1(TextContainer, {
      hasError: r,
      hasWarning: n,
      children: /* @__PURE__ */ jsx$1(Buttons.Tiny, {
        mode: "default",
        label: "Copiar",
        onClick: l
      })
    })]
  });
}, Copied$1 = withInputLayout(Copied);
var formatOption = /* @__PURE__ */ ((t) => (t.EURO = "EURO", t.PESOS = "PESOS", t.PERCENTAGE = "PERCENTAGE", t))(formatOption || {});
const currencyOptions = {
  EURO: {
    thousandSeparator: ".",
    suffix: " €",
    decimalSeparator: ",",
    displayType: "input",
    decimalScale: 2
  },
  PESOS: {
    thousandSeparator: ",",
    prefix: "$",
    decimalSeparator: ".",
    displayType: "input",
    decimalScale: 2
  },
  PERCENTAGE: {
    thousandSeparator: ",",
    suffix: " %",
    decimalSeparator: ".",
    displayType: "input",
    decimalScale: 2
  }
}, Currency = ({
  formatType: t = formatOption.EURO,
  value: r,
  hasError: n,
  hasWarning: a,
  onChange: s,
  ...o
}) => /* @__PURE__ */ jsx$1(InputMask$1, {
  ...o,
  ...currencyOptions[t],
  type: "text",
  value: r,
  $hasError: n,
  $hasWarning: a,
  displayType: "input",
  valueIsNumericString: !0,
  onValueChange: (c) => s == null ? void 0 : s(c.value)
}), Currency$1 = withInputLayout(Currency);
function _typeof$m(t) {
  "@babel/helpers - typeof";
  return _typeof$m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof$m(t);
}
function toInteger(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var r = Number(t);
  return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
}
function requiredArgs(t, r) {
  if (r.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + r.length + " present");
}
function toDate$1(t) {
  requiredArgs(1, arguments);
  var r = Object.prototype.toString.call(t);
  return t instanceof Date || _typeof$m(t) === "object" && r === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || r === "[object Number]" ? new Date(t) : ((typeof t == "string" || r === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function addDays(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r);
  return isNaN(a) ? /* @__PURE__ */ new Date(NaN) : (a && n.setDate(n.getDate() + a), n);
}
function addMonths(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r);
  if (isNaN(a))
    return /* @__PURE__ */ new Date(NaN);
  if (!a)
    return n;
  var s = n.getDate(), o = new Date(n.getTime());
  o.setMonth(n.getMonth() + a + 1, 0);
  var c = o.getDate();
  return s >= c ? o : (n.setFullYear(o.getFullYear(), o.getMonth(), s), n);
}
function addMilliseconds(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t).getTime(), a = toInteger(r);
  return new Date(n + a);
}
var MILLISECONDS_IN_HOUR = 36e5;
function addHours(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addMilliseconds(t, n * MILLISECONDS_IN_HOUR);
}
var defaultOptions$1 = {};
function getDefaultOptions() {
  return defaultOptions$1;
}
function startOfWeek(t, r) {
  var n, a, s, o, c, l, d, h;
  requiredArgs(1, arguments);
  var u = getDefaultOptions(), p = toInteger((n = (a = (s = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (c = r.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : u.weekStartsOn) !== null && a !== void 0 ? a : (d = u.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = toDate$1(t), g = m.getDay(), v = (g < p ? 7 : 0) + g - p;
  return m.setDate(m.getDate() - v), m.setHours(0, 0, 0, 0), m;
}
function startOfISOWeek(t) {
  return requiredArgs(1, arguments), startOfWeek(t, {
    weekStartsOn: 1
  });
}
function getISOWeekYear(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  var s = startOfISOWeek(a), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  var c = startOfISOWeek(o);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= c.getTime() ? n : n - 1;
}
function startOfISOWeekYear(t) {
  requiredArgs(1, arguments);
  var r = getISOWeekYear(t), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0);
  var a = startOfISOWeek(n);
  return a;
}
function getTimezoneOffsetInMilliseconds(t) {
  var r = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return r.setUTCFullYear(t.getFullYear()), t.getTime() - r.getTime();
}
function startOfDay(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t);
  return r.setHours(0, 0, 0, 0), r;
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function differenceInCalendarDays(t, r) {
  requiredArgs(2, arguments);
  var n = startOfDay(t), a = startOfDay(r), s = n.getTime() - getTimezoneOffsetInMilliseconds(n), o = a.getTime() - getTimezoneOffsetInMilliseconds(a);
  return Math.round((s - o) / MILLISECONDS_IN_DAY$1);
}
var MILLISECONDS_IN_MINUTE = 6e4;
function addMinutes(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addMilliseconds(t, n * MILLISECONDS_IN_MINUTE);
}
function addQuarters(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r), a = n * 3;
  return addMonths(t, a);
}
function addWeeks(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r), a = n * 7;
  return addDays(t, a);
}
function addYears(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addMonths(t, n * 12);
}
function max$5(t) {
  requiredArgs(1, arguments);
  var r;
  if (t && typeof t.forEach == "function")
    r = t;
  else if (_typeof$m(t) === "object" && t !== null)
    r = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return r.forEach(function(a) {
    var s = toDate$1(a);
    (n === void 0 || n < s || isNaN(Number(s))) && (n = s);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function min$5(t) {
  requiredArgs(1, arguments);
  var r;
  if (t && typeof t.forEach == "function")
    r = t;
  else if (_typeof$m(t) === "object" && t !== null)
    r = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return r.forEach(function(a) {
    var s = toDate$1(a);
    (n === void 0 || n > s || isNaN(s.getDate())) && (n = s);
  }), n || /* @__PURE__ */ new Date(NaN);
}
var millisecondsInMinute = 6e4, millisecondsInHour = 36e5, millisecondsInSecond = 1e3;
function isSameDay(t, r) {
  requiredArgs(2, arguments);
  var n = startOfDay(t), a = startOfDay(r);
  return n.getTime() === a.getTime();
}
function isDate$2(t) {
  return requiredArgs(1, arguments), t instanceof Date || _typeof$m(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function isValid$3(t) {
  if (requiredArgs(1, arguments), !isDate$2(t) && typeof t != "number")
    return !1;
  var r = toDate$1(t);
  return !isNaN(Number(r));
}
function differenceInCalendarMonths(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toDate$1(r), s = n.getFullYear() - a.getFullYear(), o = n.getMonth() - a.getMonth();
  return s * 12 + o;
}
function getQuarter(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = Math.floor(r.getMonth() / 3) + 1;
  return n;
}
function differenceInCalendarYears(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toDate$1(r);
  return n.getFullYear() - a.getFullYear();
}
function endOfDay(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t);
  return r.setHours(23, 59, 59, 999), r;
}
function endOfMonth(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function startOfQuarter(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getMonth(), a = n - n % 3;
  return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
}
function startOfMonth(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function endOfYear(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getFullYear();
  return r.setFullYear(n + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function startOfYear(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(r.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function subMilliseconds(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addMilliseconds(t, -n);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getTime();
  r.setUTCMonth(0, 1), r.setUTCHours(0, 0, 0, 0);
  var a = r.getTime(), s = n - a;
  return Math.floor(s / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(t) {
  requiredArgs(1, arguments);
  var r = 1, n = toDate$1(t), a = n.getUTCDay(), s = (a < r ? 7 : 0) + a - r;
  return n.setUTCDate(n.getUTCDate() - s), n.setUTCHours(0, 0, 0, 0), n;
}
function getUTCISOWeekYear(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var s = startOfUTCISOWeek(a), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var c = startOfUTCISOWeek(o);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= c.getTime() ? n : n - 1;
}
function startOfUTCISOWeekYear(t) {
  requiredArgs(1, arguments);
  var r = getUTCISOWeekYear(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = startOfUTCISOWeek(n);
  return a;
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function getUTCISOWeek(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = startOfUTCISOWeek(r).getTime() - startOfUTCISOWeekYear(r).getTime();
  return Math.round(n / MILLISECONDS_IN_WEEK$2) + 1;
}
function startOfUTCWeek(t, r) {
  var n, a, s, o, c, l, d, h;
  requiredArgs(1, arguments);
  var u = getDefaultOptions(), p = toInteger((n = (a = (s = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (c = r.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : u.weekStartsOn) !== null && a !== void 0 ? a : (d = u.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = toDate$1(t), g = m.getUTCDay(), v = (g < p ? 7 : 0) + g - p;
  return m.setUTCDate(m.getUTCDate() - v), m.setUTCHours(0, 0, 0, 0), m;
}
function getUTCWeekYear(t, r) {
  var n, a, s, o, c, l, d, h;
  requiredArgs(1, arguments);
  var u = toDate$1(t), p = u.getUTCFullYear(), m = getDefaultOptions(), g = toInteger((n = (a = (s = (o = r == null ? void 0 : r.firstWeekContainsDate) !== null && o !== void 0 ? o : r == null || (c = r.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : m.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = m.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(p + 1, 0, g), v.setUTCHours(0, 0, 0, 0);
  var y = startOfUTCWeek(v, r), x = /* @__PURE__ */ new Date(0);
  x.setUTCFullYear(p, 0, g), x.setUTCHours(0, 0, 0, 0);
  var _ = startOfUTCWeek(x, r);
  return u.getTime() >= y.getTime() ? p + 1 : u.getTime() >= _.getTime() ? p : p - 1;
}
function startOfUTCWeekYear(t, r) {
  var n, a, s, o, c, l, d, h;
  requiredArgs(1, arguments);
  var u = getDefaultOptions(), p = toInteger((n = (a = (s = (o = r == null ? void 0 : r.firstWeekContainsDate) !== null && o !== void 0 ? o : r == null || (c = r.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : u.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = u.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), m = getUTCWeekYear(t, r), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(m, 0, p), g.setUTCHours(0, 0, 0, 0);
  var v = startOfUTCWeek(g, r);
  return v;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCWeek(t, r) {
  requiredArgs(1, arguments);
  var n = toDate$1(t), a = startOfUTCWeek(n, r).getTime() - startOfUTCWeekYear(n, r).getTime();
  return Math.round(a / MILLISECONDS_IN_WEEK$1) + 1;
}
function addLeadingZeros(t, r) {
  for (var n = t < 0 ? "-" : "", a = Math.abs(t).toString(); a.length < r; )
    a = "0" + a;
  return n + a;
}
var formatters$2 = {
  // Year
  y: function(r, n) {
    var a = r.getUTCFullYear(), s = a > 0 ? a : 1 - a;
    return addLeadingZeros(n === "yy" ? s % 100 : s, n.length);
  },
  // Month
  M: function(r, n) {
    var a = r.getUTCMonth();
    return n === "M" ? String(a + 1) : addLeadingZeros(a + 1, 2);
  },
  // Day of the month
  d: function(r, n) {
    return addLeadingZeros(r.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(r, n) {
    var a = r.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(r, n) {
    return addLeadingZeros(r.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(r, n) {
    return addLeadingZeros(r.getUTCHours(), n.length);
  },
  // Minute
  m: function(r, n) {
    return addLeadingZeros(r.getUTCMinutes(), n.length);
  },
  // Second
  s: function(r, n) {
    return addLeadingZeros(r.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(r, n) {
    var a = n.length, s = r.getUTCMilliseconds(), o = Math.floor(s * Math.pow(10, a - 3));
    return addLeadingZeros(o, n.length);
  }
};
const formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, formatters = {
  // Era
  G: function(r, n, a) {
    var s = r.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(r, n, a) {
    if (n === "yo") {
      var s = r.getUTCFullYear(), o = s > 0 ? s : 1 - s;
      return a.ordinalNumber(o, {
        unit: "year"
      });
    }
    return formatters$3.y(r, n);
  },
  // Local week-numbering year
  Y: function(r, n, a, s) {
    var o = getUTCWeekYear(r, s), c = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var l = c % 100;
      return addLeadingZeros(l, 2);
    }
    return n === "Yo" ? a.ordinalNumber(c, {
      unit: "year"
    }) : addLeadingZeros(c, n.length);
  },
  // ISO week-numbering year
  R: function(r, n) {
    var a = getUTCISOWeekYear(r);
    return addLeadingZeros(a, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, n) {
    var a = r.getUTCFullYear();
    return addLeadingZeros(a, n.length);
  },
  // Quarter
  Q: function(r, n, a) {
    var s = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(s);
      case "QQ":
        return addLeadingZeros(s, 2);
      case "Qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, n, a) {
    var s = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(s);
      case "qq":
        return addLeadingZeros(s, 2);
      case "qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, n, a) {
    var s = r.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return formatters$3.M(r, n);
      case "Mo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(r, n, a) {
    var s = r.getUTCMonth();
    switch (n) {
      case "L":
        return String(s + 1);
      case "LL":
        return addLeadingZeros(s + 1, 2);
      case "Lo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(r, n, a, s) {
    var o = getUTCWeek(r, s);
    return n === "wo" ? a.ordinalNumber(o, {
      unit: "week"
    }) : addLeadingZeros(o, n.length);
  },
  // ISO week of year
  I: function(r, n, a) {
    var s = getUTCISOWeek(r);
    return n === "Io" ? a.ordinalNumber(s, {
      unit: "week"
    }) : addLeadingZeros(s, n.length);
  },
  // Day of the month
  d: function(r, n, a) {
    return n === "do" ? a.ordinalNumber(r.getUTCDate(), {
      unit: "date"
    }) : formatters$3.d(r, n);
  },
  // Day of year
  D: function(r, n, a) {
    var s = getUTCDayOfYear(r);
    return n === "Do" ? a.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : addLeadingZeros(s, n.length);
  },
  // Day of week
  E: function(r, n, a) {
    var s = r.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, n, a, s) {
    var o = r.getUTCDay(), c = (o - s.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(c);
      case "ee":
        return addLeadingZeros(c, 2);
      case "eo":
        return a.ordinalNumber(c, {
          unit: "day"
        });
      case "eee":
        return a.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, n, a, s) {
    var o = r.getUTCDay(), c = (o - s.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(c);
      case "cc":
        return addLeadingZeros(c, n.length);
      case "co":
        return a.ordinalNumber(c, {
          unit: "day"
        });
      case "ccc":
        return a.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, n, a) {
    var s = r.getUTCDay(), o = s === 0 ? 7 : s;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return addLeadingZeros(o, n.length);
      case "io":
        return a.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, n, a) {
    var s = r.getUTCHours(), o = s / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, n, a) {
    var s = r.getUTCHours(), o;
    switch (s === 12 ? o = dayPeriodEnum.noon : s === 0 ? o = dayPeriodEnum.midnight : o = s / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, n, a) {
    var s = r.getUTCHours(), o;
    switch (s >= 17 ? o = dayPeriodEnum.evening : s >= 12 ? o = dayPeriodEnum.afternoon : s >= 4 ? o = dayPeriodEnum.morning : o = dayPeriodEnum.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, n, a) {
    if (n === "ho") {
      var s = r.getUTCHours() % 12;
      return s === 0 && (s = 12), a.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return formatters$3.h(r, n);
  },
  // Hour [0-23]
  H: function(r, n, a) {
    return n === "Ho" ? a.ordinalNumber(r.getUTCHours(), {
      unit: "hour"
    }) : formatters$3.H(r, n);
  },
  // Hour [0-11]
  K: function(r, n, a) {
    var s = r.getUTCHours() % 12;
    return n === "Ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : addLeadingZeros(s, n.length);
  },
  // Hour [1-24]
  k: function(r, n, a) {
    var s = r.getUTCHours();
    return s === 0 && (s = 24), n === "ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : addLeadingZeros(s, n.length);
  },
  // Minute
  m: function(r, n, a) {
    return n === "mo" ? a.ordinalNumber(r.getUTCMinutes(), {
      unit: "minute"
    }) : formatters$3.m(r, n);
  },
  // Second
  s: function(r, n, a) {
    return n === "so" ? a.ordinalNumber(r.getUTCSeconds(), {
      unit: "second"
    }) : formatters$3.s(r, n);
  },
  // Fraction of second
  S: function(r, n) {
    return formatters$3.S(r, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, n, a, s) {
    var o = s._originalDate || r, c = o.getTimezoneOffset();
    if (c === 0)
      return "Z";
    switch (n) {
      case "X":
        return formatTimezoneWithOptionalMinutes(c);
      case "XXXX":
      case "XX":
        return formatTimezone(c);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(c, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, n, a, s) {
    var o = s._originalDate || r, c = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return formatTimezoneWithOptionalMinutes(c);
      case "xxxx":
      case "xx":
        return formatTimezone(c);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(c, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, n, a, s) {
    var o = s._originalDate || r, c = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(c, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(c, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, n, a, s) {
    var o = s._originalDate || r, c = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(c, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(c, ":");
    }
  },
  // Seconds timestamp
  t: function(r, n, a, s) {
    var o = s._originalDate || r, c = Math.floor(o.getTime() / 1e3);
    return addLeadingZeros(c, n.length);
  },
  // Milliseconds timestamp
  T: function(r, n, a, s) {
    var o = s._originalDate || r, c = o.getTime();
    return addLeadingZeros(c, n.length);
  }
};
function formatTimezoneShort(t, r) {
  var n = t > 0 ? "-" : "+", a = Math.abs(t), s = Math.floor(a / 60), o = a % 60;
  if (o === 0)
    return n + String(s);
  var c = r || "";
  return n + String(s) + c + addLeadingZeros(o, 2);
}
function formatTimezoneWithOptionalMinutes(t, r) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + addLeadingZeros(Math.abs(t) / 60, 2);
  }
  return formatTimezone(t, r);
}
function formatTimezone(t, r) {
  var n = r || "", a = t > 0 ? "-" : "+", s = Math.abs(t), o = addLeadingZeros(Math.floor(s / 60), 2), c = addLeadingZeros(s % 60, 2);
  return a + o + n + c;
}
const formatters$1 = formatters;
var dateLongFormatter = function(r, n) {
  switch (r) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, timeLongFormatter = function(r, n) {
  switch (r) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, dateTimeLongFormatter = function(r, n) {
  var a = r.match(/(P+)(p+)?/) || [], s = a[1], o = a[2];
  if (!o)
    return dateLongFormatter(r, n);
  var c;
  switch (s) {
    case "P":
      c = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      c = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      c = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      c = n.dateTime({
        width: "full"
      });
      break;
  }
  return c.replace("{{date}}", dateLongFormatter(s, n)).replace("{{time}}", timeLongFormatter(o, n));
}, longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ["D", "DD"], protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(t) {
  return protectedDayOfYearTokens.indexOf(t) !== -1;
}
function isProtectedWeekYearToken(t) {
  return protectedWeekYearTokens.indexOf(t) !== -1;
}
function throwProtectedError(t, r, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(r, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(r, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(r, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(r, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, formatDistance$2 = function(r, n, a) {
  var s, o = formatDistanceLocale$1[r];
  return typeof o == "string" ? s = o : n === 1 ? s = o.one : s = o.other.replace("{{count}}", n.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + s : s + " ago" : s;
};
const formatDistance$3 = formatDistance$2;
function buildFormatLongFn(t) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = r.width ? String(r.width) : t.defaultWidth, a = t.formats[n] || t.formats[t.defaultWidth];
    return a;
  };
}
var dateFormats$1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
const formatLong$3 = formatLong$2;
var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, formatRelative$2 = function(r, n, a, s) {
  return formatRelativeLocale$1[r];
};
const formatRelative$3 = formatRelative$2;
function buildLocalizeFn(t) {
  return function(r, n) {
    var a = n != null && n.context ? String(n.context) : "standalone", s;
    if (a === "formatting" && t.formattingValues) {
      var o = t.defaultFormattingWidth || t.defaultWidth, c = n != null && n.width ? String(n.width) : o;
      s = t.formattingValues[c] || t.formattingValues[o];
    } else {
      var l = t.defaultWidth, d = n != null && n.width ? String(n.width) : t.defaultWidth;
      s = t.values[d] || t.values[l];
    }
    var h = t.argumentCallback ? t.argumentCallback(r) : r;
    return s[h];
  };
}
var eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ordinalNumber$1 = function(r, n) {
  var a = Number(r), s = a % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: function(r) {
      return r - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
const localize$3 = localize$2;
function buildMatchFn(t) {
  return function(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.width, s = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], o = r.match(s);
    if (!o)
      return null;
    var c = o[0], l = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], d = Array.isArray(l) ? findIndex(l, function(p) {
      return p.test(c);
    }) : findKey(l, function(p) {
      return p.test(c);
    }), h;
    h = t.valueCallback ? t.valueCallback(d) : d, h = n.valueCallback ? n.valueCallback(h) : h;
    var u = r.slice(c.length);
    return {
      value: h,
      rest: u
    };
  };
}
function findKey(t, r) {
  for (var n in t)
    if (t.hasOwnProperty(n) && r(t[n]))
      return n;
}
function findIndex(t, r) {
  for (var n = 0; n < t.length; n++)
    if (r(t[n]))
      return n;
}
function buildMatchPatternFn(t) {
  return function(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.match(t.matchPattern);
    if (!a)
      return null;
    var s = a[0], o = r.match(t.parsePattern);
    if (!o)
      return null;
    var c = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    var l = r.slice(s.length);
    return {
      value: c,
      rest: l
    };
  };
}
var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i, parseOrdinalNumberPattern$1 = /\d+/i, matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
}, matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, match$3 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function(r) {
      return parseInt(r, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: function(r) {
      return r + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
const match$4 = match$3;
var locale$2 = {
  code: "en-US",
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$4,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const defaultLocale = locale$2;
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp$1 = /^'([^]*?)'?$/, doubleQuoteRegExp$1 = /''/g, unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format$8(t, r, n) {
  var a, s, o, c, l, d, h, u, p, m, g, v, y, x, _, $, b, M;
  requiredArgs(2, arguments);
  var C = String(r), S = getDefaultOptions(), A = (a = (s = n == null ? void 0 : n.locale) !== null && s !== void 0 ? s : S.locale) !== null && a !== void 0 ? a : defaultLocale, D = toInteger((o = (c = (l = (d = n == null ? void 0 : n.firstWeekContainsDate) !== null && d !== void 0 ? d : n == null || (h = n.locale) === null || h === void 0 || (u = h.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && l !== void 0 ? l : S.firstWeekContainsDate) !== null && c !== void 0 ? c : (p = S.locale) === null || p === void 0 || (m = p.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var N = toInteger((g = (v = (y = (x = n == null ? void 0 : n.weekStartsOn) !== null && x !== void 0 ? x : n == null || (_ = n.locale) === null || _ === void 0 || ($ = _.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && y !== void 0 ? y : S.weekStartsOn) !== null && v !== void 0 ? v : (b = S.locale) === null || b === void 0 || (M = b.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(N >= 0 && N <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!A.localize)
    throw new RangeError("locale must contain localize property");
  if (!A.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var T = toDate$1(t);
  if (!isValid$3(T))
    throw new RangeError("Invalid time value");
  var R = getTimezoneOffsetInMilliseconds(T), F = subMilliseconds(T, R), z = {
    firstWeekContainsDate: D,
    weekStartsOn: N,
    locale: A,
    _originalDate: T
  }, O = C.match(longFormattingTokensRegExp$1).map(function(G) {
    var I = G[0];
    if (I === "p" || I === "P") {
      var k = longFormatters$1[I];
      return k(G, A.formatLong);
    }
    return G;
  }).join("").match(formattingTokensRegExp$1).map(function(G) {
    if (G === "''")
      return "'";
    var I = G[0];
    if (I === "'")
      return cleanEscapedString$1(G);
    var k = formatters$1[I];
    if (k)
      return !(n != null && n.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(G) && throwProtectedError(G, r, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(G) && throwProtectedError(G, r, String(t)), k(F, G, A.localize, z);
    if (I.match(unescapedLatinCharacterRegExp$1))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + I + "`");
    return G;
  }).join("");
  return O;
}
function cleanEscapedString$1(t) {
  var r = t.match(escapedStringRegExp$1);
  return r ? r[1].replace(doubleQuoteRegExp$1, "'") : t;
}
function assign$2(t, r) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  return t;
}
function getDate(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getDate();
  return n;
}
function getDay(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getDay();
  return n;
}
function getDaysInMonth$1(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getFullYear(), a = r.getMonth(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(n, a + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function getHours(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getHours();
  return n;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getISOWeek(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = startOfISOWeek(r).getTime() - startOfISOWeekYear(r).getTime();
  return Math.round(n / MILLISECONDS_IN_WEEK) + 1;
}
function getMinutes(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getMinutes();
  return n;
}
function getMonth(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getMonth();
  return n;
}
function getSeconds(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getSeconds();
  return n;
}
function getTime(t) {
  requiredArgs(1, arguments);
  var r = toDate$1(t), n = r.getTime();
  return n;
}
function getYear(t) {
  return requiredArgs(1, arguments), toDate$1(t).getFullYear();
}
function isAfter$1(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toDate$1(r);
  return n.getTime() > a.getTime();
}
function isBefore$1(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toDate$1(r);
  return n.getTime() < a.getTime();
}
function isEqual$2(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toDate$1(r);
  return n.getTime() === a.getTime();
}
function _arrayLikeToArray$o(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _unsupportedIterableToArray$o(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$o(t, r);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray$o(t, r) : void 0;
  }
}
function _createForOfIteratorHelper(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = _unsupportedIterableToArray$o(t)) || r && t && typeof t.length == "number") {
      n && (t = n);
      var a = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return a >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[a++]
          };
        },
        e: function(h) {
          throw h;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, c = !0, l = !1;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var h = n.next();
      return c = h.done, h;
    },
    e: function(h) {
      l = !0, o = h;
    },
    f: function() {
      try {
        c || n.return == null || n.return();
      } finally {
        if (l)
          throw o;
      }
    }
  };
}
function _inherits$3(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), r && _setPrototypeOf$3(t, r);
}
function _getPrototypeOf$3(t) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _getPrototypeOf$3(t);
}
function _isNativeReflectConstruct$6() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$6 = function() {
    return !!t;
  })();
}
function _possibleConstructorReturn$3(t, r) {
  if (r && (_typeof$m(r) == "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(t);
}
function _createSuper$5(t) {
  var r = _isNativeReflectConstruct$6();
  return function() {
    var n, a = _getPrototypeOf$3(t);
    if (r) {
      var s = _getPrototypeOf$3(this).constructor;
      n = Reflect.construct(a, arguments, s);
    } else
      n = a.apply(this, arguments);
    return _possibleConstructorReturn$3(this, n);
  };
}
function _classCallCheck$b(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function toPrimitive$1(t, r) {
  if (_typeof$m(t) != "object" || !t)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(t, r || "default");
    if (_typeof$m(a) != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
function toPropertyKey$1(t) {
  var r = toPrimitive$1(t, "string");
  return _typeof$m(r) == "symbol" ? r : r + "";
}
function _defineProperties$a(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, toPropertyKey$1(a.key), a);
  }
}
function _createClass$b(t, r, n) {
  return r && _defineProperties$a(t.prototype, r), n && _defineProperties$a(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function _defineProperty$e(t, r, n) {
  return (r = toPropertyKey$1(r)) in t ? Object.defineProperty(t, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = n, t;
}
var TIMEZONE_UNIT_PRIORITY = 10, Setter = /* @__PURE__ */ function() {
  function t() {
    _classCallCheck$b(this, t), _defineProperty$e(this, "priority", void 0), _defineProperty$e(this, "subPriority", 0);
  }
  return _createClass$b(t, [{
    key: "validate",
    value: function(n, a) {
      return !0;
    }
  }]), t;
}(), ValueSetter = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n(a, s, o, c, l) {
    var d;
    return _classCallCheck$b(this, n), d = r.call(this), d.value = a, d.validateValue = s, d.setValue = o, d.priority = c, l && (d.subPriority = l), d;
  }
  return _createClass$b(n, [{
    key: "validate",
    value: function(s, o) {
      return this.validateValue(s, this.value, o);
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return this.setValue(s, o, this.value, c);
    }
  }]), n;
}(Setter), DateToSystemTimezoneSetter = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", TIMEZONE_UNIT_PRIORITY), _defineProperty$e(_assertThisInitialized$4(a), "subPriority", -1), a;
  }
  return _createClass$b(n, [{
    key: "set",
    value: function(s, o) {
      if (o.timestampIsSet)
        return s;
      var c = /* @__PURE__ */ new Date(0);
      return c.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), c.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), c;
    }
  }]), n;
}(Setter), Parser$1 = /* @__PURE__ */ function() {
  function t() {
    _classCallCheck$b(this, t), _defineProperty$e(this, "incompatibleTokens", void 0), _defineProperty$e(this, "priority", void 0), _defineProperty$e(this, "subPriority", void 0);
  }
  return _createClass$b(t, [{
    key: "run",
    value: function(n, a, s, o) {
      var c = this.parse(n, a, s, o);
      return c ? {
        setter: new ValueSetter(c.value, this.validate, this.set, this.priority, this.subPriority),
        rest: c.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, a, s) {
      return !0;
    }
  }]), t;
}(), EraParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 140), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "G":
        case "GG":
        case "GGG":
          return c.era(s, {
            width: "abbreviated"
          }) || c.era(s, {
            width: "narrow"
          });
        case "GGGGG":
          return c.era(s, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return c.era(s, {
            width: "wide"
          }) || c.era(s, {
            width: "abbreviated"
          }) || c.era(s, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return o.era = c, s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(t, r) {
  return t && {
    value: r(t.value),
    rest: t.rest
  };
}
function parseNumericPattern(t, r) {
  var n = r.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: r.slice(n[0].length)
  } : null;
}
function parseTimezonePattern(t, r) {
  var n = r.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  var a = n[1] === "+" ? 1 : -1, s = n[2] ? parseInt(n[2], 10) : 0, o = n[3] ? parseInt(n[3], 10) : 0, c = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: a * (s * millisecondsInHour + o * millisecondsInMinute + c * millisecondsInSecond),
    rest: r.slice(n[0].length)
  };
}
function parseAnyDigitsSigned(t) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, t);
}
function parseNDigits(t, r) {
  switch (t) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, r);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, r);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, r);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, r);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + t + "}"), r);
  }
}
function parseNDigitsSigned(t, r) {
  switch (t) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, r);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, r);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, r);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, r);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + t + "}"), r);
  }
}
function dayPeriodEnumToHours(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(t, r) {
  var n = r > 0, a = n ? r : 1 - r, s;
  if (a <= 50)
    s = t || 100;
  else {
    var o = a + 50, c = Math.floor(o / 100) * 100, l = t >= o % 100;
    s = t + c - (l ? 100 : 0);
  }
  return n ? s : 1 - s;
}
function isLeapYearIndex$1(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var YearParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 130), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      var l = function(h) {
        return {
          year: h,
          isTwoDigitYear: o === "yy"
        };
      };
      switch (o) {
        case "y":
          return mapValue(parseNDigits(4, s), l);
        case "yo":
          return mapValue(c.ordinalNumber(s, {
            unit: "year"
          }), l);
        default:
          return mapValue(parseNDigits(o.length, s), l);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      var l = s.getUTCFullYear();
      if (c.isTwoDigitYear) {
        var d = normalizeTwoDigitYear(c.year, l);
        return s.setUTCFullYear(d, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
      }
      var h = !("era" in o) || o.era === 1 ? c.year : 1 - c.year;
      return s.setUTCFullYear(h, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), LocalWeekYearParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 130), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      var l = function(h) {
        return {
          year: h,
          isTwoDigitYear: o === "YY"
        };
      };
      switch (o) {
        case "Y":
          return mapValue(parseNDigits(4, s), l);
        case "Yo":
          return mapValue(c.ordinalNumber(s, {
            unit: "year"
          }), l);
        default:
          return mapValue(parseNDigits(o.length, s), l);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(s, o, c, l) {
      var d = getUTCWeekYear(s, l);
      if (c.isTwoDigitYear) {
        var h = normalizeTwoDigitYear(c.year, d);
        return s.setUTCFullYear(h, 0, l.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), startOfUTCWeek(s, l);
      }
      var u = !("era" in o) || o.era === 1 ? c.year : 1 - c.year;
      return s.setUTCFullYear(u, 0, l.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), startOfUTCWeek(s, l);
    }
  }]), n;
}(Parser$1), ISOWeekYearParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 130), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o) {
      return parseNDigitsSigned(o === "R" ? 4 : o.length, s);
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      var l = /* @__PURE__ */ new Date(0);
      return l.setUTCFullYear(c, 0, 4), l.setUTCHours(0, 0, 0, 0), startOfUTCISOWeek(l);
    }
  }]), n;
}(Parser$1), ExtendedYearParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 130), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o) {
      return parseNDigitsSigned(o === "u" ? 4 : o.length, s);
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), QuarterParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 120), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "Q":
        case "QQ":
          return parseNDigits(o.length, s);
        case "Qo":
          return c.ordinalNumber(s, {
            unit: "quarter"
          });
        case "QQQ":
          return c.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return c.quarter(s, {
            width: "wide",
            context: "formatting"
          }) || c.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCMonth((c - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), StandAloneQuarterParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 120), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "q":
        case "qq":
          return parseNDigits(o.length, s);
        case "qo":
          return c.ordinalNumber(s, {
            unit: "quarter"
          });
        case "qqq":
          return c.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return c.quarter(s, {
            width: "wide",
            context: "standalone"
          }) || c.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCMonth((c - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), MonthParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), _defineProperty$e(_assertThisInitialized$4(a), "priority", 110), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      var l = function(h) {
        return h - 1;
      };
      switch (o) {
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, s), l);
        case "MM":
          return mapValue(parseNDigits(2, s), l);
        case "Mo":
          return mapValue(c.ordinalNumber(s, {
            unit: "month"
          }), l);
        case "MMM":
          return c.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return c.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return c.month(s, {
            width: "wide",
            context: "formatting"
          }) || c.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.month(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCMonth(c, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), StandAloneMonthParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 110), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      var l = function(h) {
        return h - 1;
      };
      switch (o) {
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, s), l);
        case "LL":
          return mapValue(parseNDigits(2, s), l);
        case "Lo":
          return mapValue(c.ordinalNumber(s, {
            unit: "month"
          }), l);
        case "LLL":
          return c.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return c.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return c.month(s, {
            width: "wide",
            context: "standalone"
          }) || c.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.month(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCMonth(c, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1);
function setUTCWeek(t, r, n) {
  requiredArgs(2, arguments);
  var a = toDate$1(t), s = toInteger(r), o = getUTCWeek(a, n) - s;
  return a.setUTCDate(a.getUTCDate() - o * 7), a;
}
var LocalWeekParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 100), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "w":
          return parseNumericPattern(numericPatterns.week, s);
        case "wo":
          return c.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(s, o, c, l) {
      return startOfUTCWeek(setUTCWeek(s, c, l), l);
    }
  }]), n;
}(Parser$1);
function setUTCISOWeek(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r), s = getUTCISOWeek(n) - a;
  return n.setUTCDate(n.getUTCDate() - s * 7), n;
}
var ISOWeekParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 100), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "I":
          return parseNumericPattern(numericPatterns.week, s);
        case "Io":
          return c.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return startOfUTCISOWeek(setUTCISOWeek(s, c));
    }
  }]), n;
}(Parser$1), DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DateParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 90), _defineProperty$e(_assertThisInitialized$4(a), "subPriority", 1), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "d":
          return parseNumericPattern(numericPatterns.date, s);
        case "do":
          return c.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      var c = s.getUTCFullYear(), l = isLeapYearIndex$1(c), d = s.getUTCMonth();
      return l ? o >= 1 && o <= DAYS_IN_MONTH_LEAP_YEAR[d] : o >= 1 && o <= DAYS_IN_MONTH[d];
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCDate(c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), DayOfYearParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 90), _defineProperty$e(_assertThisInitialized$4(a), "subpriority", 1), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, s);
        case "Do":
          return c.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      var c = s.getUTCFullYear(), l = isLeapYearIndex$1(c);
      return l ? o >= 1 && o <= 366 : o >= 1 && o <= 365;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCMonth(0, c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1);
function setUTCDay(t, r, n) {
  var a, s, o, c, l, d, h, u;
  requiredArgs(2, arguments);
  var p = getDefaultOptions(), m = toInteger((a = (s = (o = (c = n == null ? void 0 : n.weekStartsOn) !== null && c !== void 0 ? c : n == null || (l = n.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && o !== void 0 ? o : p.weekStartsOn) !== null && s !== void 0 ? s : (h = p.locale) === null || h === void 0 || (u = h.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = toDate$1(t), v = toInteger(r), y = g.getUTCDay(), x = v % 7, _ = (x + 7) % 7, $ = (_ < m ? 7 : 0) + v - y;
  return g.setUTCDate(g.getUTCDate() + $), g;
}
var DayParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 90), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "E":
        case "EE":
        case "EEE":
          return c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(s, o, c, l) {
      return s = setUTCDay(s, c, l), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), LocalDayParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 90), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c, l) {
      var d = function(u) {
        var p = Math.floor((u - 1) / 7) * 7;
        return (u + l.weekStartsOn + 6) % 7 + p;
      };
      switch (o) {
        case "e":
        case "ee":
          return mapValue(parseNDigits(o.length, s), d);
        case "eo":
          return mapValue(c.ordinalNumber(s, {
            unit: "day"
          }), d);
        case "eee":
          return c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(s, o, c, l) {
      return s = setUTCDay(s, c, l), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), StandAloneLocalDayParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 90), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c, l) {
      var d = function(u) {
        var p = Math.floor((u - 1) / 7) * 7;
        return (u + l.weekStartsOn + 6) % 7 + p;
      };
      switch (o) {
        case "c":
        case "cc":
          return mapValue(parseNDigits(o.length, s), d);
        case "co":
          return mapValue(c.ordinalNumber(s, {
            unit: "day"
          }), d);
        case "ccc":
          return c.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return c.day(s, {
            width: "wide",
            context: "standalone"
          }) || c.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(s, o, c, l) {
      return s = setUTCDay(s, c, l), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1);
function setUTCISODay(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  n % 7 === 0 && (n = n - 7);
  var a = 1, s = toDate$1(t), o = s.getUTCDay(), c = n % 7, l = (c + 7) % 7, d = (l < a ? 7 : 0) + n - o;
  return s.setUTCDate(s.getUTCDate() + d), s;
}
var ISODayParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 90), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      var l = function(h) {
        return h === 0 ? 7 : h;
      };
      switch (o) {
        case "i":
        case "ii":
          return parseNDigits(o.length, s);
        case "io":
          return c.ordinalNumber(s, {
            unit: "day"
          });
        case "iii":
          return mapValue(c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiii":
          return mapValue(c.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiiii":
          return mapValue(c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiii":
        default:
          return mapValue(c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), l);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 1 && o <= 7;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s = setUTCISODay(s, c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), AMPMParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 80), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "a":
        case "aa":
        case "aaa":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCHours(dayPeriodEnumToHours(c), 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), AMPMMidnightParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 80), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "b":
        case "bb":
        case "bbb":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCHours(dayPeriodEnumToHours(c), 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), DayPeriodParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 80), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "B":
        case "BB":
        case "BBB":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCHours(dayPeriodEnumToHours(c), 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), Hour1to12Parser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 70), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, s);
        case "ho":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 1 && o <= 12;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      var l = s.getUTCHours() >= 12;
      return l && c < 12 ? s.setUTCHours(c + 12, 0, 0, 0) : !l && c === 12 ? s.setUTCHours(0, 0, 0, 0) : s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), Hour0to23Parser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 70), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, s);
        case "Ho":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 23;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), Hour0To11Parser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 70), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, s);
        case "Ko":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      var l = s.getUTCHours() >= 12;
      return l && c < 12 ? s.setUTCHours(c + 12, 0, 0, 0) : s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), Hour1To24Parser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 70), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, s);
        case "ko":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 1 && o <= 24;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      var l = c <= 24 ? c % 24 : c;
      return s.setUTCHours(l, 0, 0, 0), s;
    }
  }]), n;
}(Parser$1), MinuteParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 60), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, s);
        case "mo":
          return c.ordinalNumber(s, {
            unit: "minute"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCMinutes(c, 0, 0), s;
    }
  }]), n;
}(Parser$1), SecondParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 50), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o, c) {
      switch (o) {
        case "s":
          return parseNumericPattern(numericPatterns.second, s);
        case "so":
          return c.ordinalNumber(s, {
            unit: "second"
          });
        default:
          return parseNDigits(o.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCSeconds(c, 0), s;
    }
  }]), n;
}(Parser$1), FractionOfSecondParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 30), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o) {
      var c = function(d) {
        return Math.floor(d * Math.pow(10, -o.length + 3));
      };
      return mapValue(parseNDigits(o.length, s), c);
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return s.setUTCMilliseconds(c), s;
    }
  }]), n;
}(Parser$1), ISOTimezoneWithZParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 10), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o) {
      switch (o) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, s);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, s);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, s);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, s);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return o.timestampIsSet ? s : new Date(s.getTime() - c);
    }
  }]), n;
}(Parser$1), ISOTimezoneParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 10), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s, o) {
      switch (o) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, s);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, s);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, s);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, s);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return o.timestampIsSet ? s : new Date(s.getTime() - c);
    }
  }]), n;
}(Parser$1), TimestampSecondsParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 40), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", "*"), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s) {
      return parseAnyDigitsSigned(s);
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return [new Date(c * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Parser$1), TimestampMillisecondsParser = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n() {
    var a;
    _classCallCheck$b(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return a = r.call.apply(r, [this].concat(o)), _defineProperty$e(_assertThisInitialized$4(a), "priority", 20), _defineProperty$e(_assertThisInitialized$4(a), "incompatibleTokens", "*"), a;
  }
  return _createClass$b(n, [{
    key: "parse",
    value: function(s) {
      return parseAnyDigitsSigned(s);
    }
  }, {
    key: "set",
    value: function(s, o, c) {
      return [new Date(c), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Parser$1), parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
}, formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp = /^'([^]*?)'?$/, doubleQuoteRegExp = /''/g, notWhitespaceRegExp = /\S/, unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse$5(t, r, n, a) {
  var s, o, c, l, d, h, u, p, m, g, v, y, x, _, $, b, M, C;
  requiredArgs(3, arguments);
  var S = String(t), A = String(r), D = getDefaultOptions(), N = (s = (o = a == null ? void 0 : a.locale) !== null && o !== void 0 ? o : D.locale) !== null && s !== void 0 ? s : defaultLocale;
  if (!N.match)
    throw new RangeError("locale must contain match property");
  var T = toInteger((c = (l = (d = (h = a == null ? void 0 : a.firstWeekContainsDate) !== null && h !== void 0 ? h : a == null || (u = a.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && d !== void 0 ? d : D.firstWeekContainsDate) !== null && l !== void 0 ? l : (m = D.locale) === null || m === void 0 || (g = m.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && c !== void 0 ? c : 1);
  if (!(T >= 1 && T <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var R = toInteger((v = (y = (x = (_ = a == null ? void 0 : a.weekStartsOn) !== null && _ !== void 0 ? _ : a == null || ($ = a.locale) === null || $ === void 0 || (b = $.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && x !== void 0 ? x : D.weekStartsOn) !== null && y !== void 0 ? y : (M = D.locale) === null || M === void 0 || (C = M.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(R >= 0 && R <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (A === "")
    return S === "" ? toDate$1(n) : /* @__PURE__ */ new Date(NaN);
  var F = {
    firstWeekContainsDate: T,
    weekStartsOn: R,
    locale: N
  }, z = [new DateToSystemTimezoneSetter()], O = A.match(longFormattingTokensRegExp).map(function(nr) {
    var ce = nr[0];
    if (ce in longFormatters$1) {
      var oe = longFormatters$1[ce];
      return oe(nr, N.formatLong);
    }
    return nr;
  }).join("").match(formattingTokensRegExp), G = [], I = _createForOfIteratorHelper(O), k;
  try {
    var B = function() {
      var ce = k.value;
      !(a != null && a.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(ce) && throwProtectedError(ce, A, t), !(a != null && a.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(ce) && throwProtectedError(ce, A, t);
      var oe = ce[0], ur = parsers[oe];
      if (ur) {
        var ir = ur.incompatibleTokens;
        if (Array.isArray(ir)) {
          var _r = G.find(function(ne) {
            return ir.includes(ne.token) || ne.token === oe;
          });
          if (_r)
            throw new RangeError("The format string mustn't contain `".concat(_r.fullToken, "` and `").concat(ce, "` at the same time"));
        } else if (ur.incompatibleTokens === "*" && G.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(ce, "` and any other token at the same time"));
        G.push({
          token: oe,
          fullToken: ce
        });
        var yr = ur.run(S, ce, N.match, F);
        if (!yr)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        z.push(yr.setter), S = yr.rest;
      } else {
        if (oe.match(unescapedLatinCharacterRegExp))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + oe + "`");
        if (ce === "''" ? ce = "'" : oe === "'" && (ce = cleanEscapedString(ce)), S.indexOf(ce) === 0)
          S = S.slice(ce.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (I.s(); !(k = I.n()).done; ) {
      var L = B();
      if (_typeof$m(L) === "object")
        return L.v;
    }
  } catch (nr) {
    I.e(nr);
  } finally {
    I.f();
  }
  if (S.length > 0 && notWhitespaceRegExp.test(S))
    return /* @__PURE__ */ new Date(NaN);
  var V = z.map(function(nr) {
    return nr.priority;
  }).sort(function(nr, ce) {
    return ce - nr;
  }).filter(function(nr, ce, oe) {
    return oe.indexOf(nr) === ce;
  }).map(function(nr) {
    return z.filter(function(ce) {
      return ce.priority === nr;
    }).sort(function(ce, oe) {
      return oe.subPriority - ce.subPriority;
    });
  }).map(function(nr) {
    return nr[0];
  }), U = toDate$1(n);
  if (isNaN(U.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var J = subMilliseconds(U, getTimezoneOffsetInMilliseconds(U)), q = {}, Z = _createForOfIteratorHelper(V), ae;
  try {
    for (Z.s(); !(ae = Z.n()).done; ) {
      var ee = ae.value;
      if (!ee.validate(J, F))
        return /* @__PURE__ */ new Date(NaN);
      var se = ee.set(J, q, F);
      Array.isArray(se) ? (J = se[0], assign$2(q, se[1])) : J = se;
    }
  } catch (nr) {
    Z.e(nr);
  } finally {
    Z.f();
  }
  return J;
}
function cleanEscapedString(t) {
  return t.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function isSameMonth(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toDate$1(r);
  return n.getFullYear() === a.getFullYear() && n.getMonth() === a.getMonth();
}
function isSameQuarter(t, r) {
  requiredArgs(2, arguments);
  var n = startOfQuarter(t), a = startOfQuarter(r);
  return n.getTime() === a.getTime();
}
function isSameYear(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toDate$1(r);
  return n.getFullYear() === a.getFullYear();
}
function isWithinInterval(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t).getTime(), a = toDate$1(r.start).getTime(), s = toDate$1(r.end).getTime();
  if (!(a <= s))
    throw new RangeError("Invalid interval");
  return n >= a && n <= s;
}
function subDays(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addDays(t, -n);
}
function parseISO(t, r) {
  var n;
  requiredArgs(1, arguments);
  var a = toInteger((n = r == null ? void 0 : r.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = splitDateString(t), o;
  if (s.date) {
    var c = parseYear(s.date, a);
    o = parseDate(c.restDateString, c.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var l = o.getTime(), d = 0, h;
  if (s.time && (d = parseTime(s.time), isNaN(d)))
    return /* @__PURE__ */ new Date(NaN);
  if (s.timezone) {
    if (h = parseTimezone(s.timezone), isNaN(h))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(l + d), p = /* @__PURE__ */ new Date(0);
    return p.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), p.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), p;
  }
  return new Date(l + d + h);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(t) {
  var r = {}, n = t.split(patterns.dateTimeDelimiter), a;
  if (n.length > 2)
    return r;
  if (/:/.test(n[0]) ? a = n[0] : (r.date = n[0], a = n[1], patterns.timeZoneDelimiter.test(r.date) && (r.date = t.split(patterns.timeZoneDelimiter)[0], a = t.substr(r.date.length, t.length))), a) {
    var s = patterns.timezone.exec(a);
    s ? (r.time = a.replace(s[1], ""), r.timezone = s[1]) : r.time = a;
  }
  return r;
}
function parseYear(t, r) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"), a = t.match(n);
  if (!a)
    return {
      year: NaN,
      restDateString: ""
    };
  var s = a[1] ? parseInt(a[1]) : null, o = a[2] ? parseInt(a[2]) : null;
  return {
    year: o === null ? s : o * 100,
    restDateString: t.slice((a[1] || a[2]).length)
  };
}
function parseDate(t, r) {
  if (r === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t.match(dateRegex);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var a = !!n[4], s = parseDateUnit(n[1]), o = parseDateUnit(n[2]) - 1, c = parseDateUnit(n[3]), l = parseDateUnit(n[4]), d = parseDateUnit(n[5]) - 1;
  if (a)
    return validateWeekDate(r, l, d) ? dayOfISOWeekYear(r, l, d) : /* @__PURE__ */ new Date(NaN);
  var h = /* @__PURE__ */ new Date(0);
  return !validateDate(r, o, c) || !validateDayOfYearDate(r, s) ? /* @__PURE__ */ new Date(NaN) : (h.setUTCFullYear(r, o, Math.max(s, c)), h);
}
function parseDateUnit(t) {
  return t ? parseInt(t) : 1;
}
function parseTime(t) {
  var r = t.match(timeRegex);
  if (!r)
    return NaN;
  var n = parseTimeUnit(r[1]), a = parseTimeUnit(r[2]), s = parseTimeUnit(r[3]);
  return validateTime(n, a, s) ? n * millisecondsInHour + a * millisecondsInMinute + s * 1e3 : NaN;
}
function parseTimeUnit(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function parseTimezone(t) {
  if (t === "Z")
    return 0;
  var r = t.match(timezoneRegex);
  if (!r)
    return 0;
  var n = r[1] === "+" ? -1 : 1, a = parseInt(r[2]), s = r[3] && parseInt(r[3]) || 0;
  return validateTimezone(a, s) ? n * (a * millisecondsInHour + s * millisecondsInMinute) : NaN;
}
function dayOfISOWeekYear(t, r, n) {
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  var s = a.getUTCDay() || 7, o = (r - 1) * 7 + n + 1 - s;
  return a.setUTCDate(a.getUTCDate() + o), a;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function validateDate(t, r, n) {
  return r >= 0 && r <= 11 && n >= 1 && n <= (daysInMonths[r] || (isLeapYearIndex(t) ? 29 : 28));
}
function validateDayOfYearDate(t, r) {
  return r >= 1 && r <= (isLeapYearIndex(t) ? 366 : 365);
}
function validateWeekDate(t, r, n) {
  return r >= 1 && r <= 53 && n >= 0 && n <= 6;
}
function validateTime(t, r, n) {
  return t === 24 ? r === 0 && n === 0 : n >= 0 && n < 60 && r >= 0 && r < 60 && t >= 0 && t < 25;
}
function validateTimezone(t, r) {
  return r >= 0 && r <= 59;
}
function setMonth$1(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r), s = n.getFullYear(), o = n.getDate(), c = /* @__PURE__ */ new Date(0);
  c.setFullYear(s, a, 15), c.setHours(0, 0, 0, 0);
  var l = getDaysInMonth$1(c);
  return n.setMonth(a, Math.min(o, l)), n;
}
function set$3(t, r) {
  if (requiredArgs(2, arguments), _typeof$m(r) !== "object" || r === null)
    throw new RangeError("values parameter must be an object");
  var n = toDate$1(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.year != null && n.setFullYear(r.year), r.month != null && (n = setMonth$1(n, r.month)), r.date != null && n.setDate(toInteger(r.date)), r.hours != null && n.setHours(toInteger(r.hours)), r.minutes != null && n.setMinutes(toInteger(r.minutes)), r.seconds != null && n.setSeconds(toInteger(r.seconds)), r.milliseconds != null && n.setMilliseconds(toInteger(r.milliseconds)), n);
}
function setHours(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r);
  return n.setHours(a), n;
}
function setMinutes(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r);
  return n.setMinutes(a), n;
}
function setQuarter(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r), s = Math.floor(n.getMonth() / 3) + 1, o = a - s;
  return setMonth$1(n, n.getMonth() + o * 3);
}
function setSeconds(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r);
  return n.setSeconds(a), n;
}
function setYear(t, r) {
  requiredArgs(2, arguments);
  var n = toDate$1(t), a = toInteger(r);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(a), n);
}
function subMonths(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addMonths(t, -n);
}
function subQuarters(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addQuarters(t, -n);
}
function subWeeks(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addWeeks(t, -n);
}
function subYears(t, r) {
  requiredArgs(2, arguments);
  var n = toInteger(r);
  return addYears(t, -n);
}
const DateFormat = styled(PatternFormat)`
  ${TextInputStyles}
`;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, formatDistance = function(r, n, a) {
  var s, o = formatDistanceLocale[r];
  return typeof o == "string" ? s = o : n === 1 ? s = o.one : s = o.other.replace("{{count}}", n.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "en " + s : "hace " + s : s;
};
const formatDistance$1 = formatDistance;
var dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, dateTimeFormats = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, formatRelative = function(r, n, a, s) {
  return n.getUTCHours() !== 1 ? formatRelativeLocalePlural[r] : formatRelativeLocale[r];
};
const formatRelative$1 = formatRelative;
var eraValues = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, monthValues = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, dayValues = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, ordinalNumber = function(r, n) {
  var a = Number(r);
  return a + "º";
}, localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function(r) {
      return Number(r) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const localize$1 = localize;
var matchOrdinalNumberPattern = /^(\d+)(º)?/i, parseOrdinalNumberPattern = /\d+/i, matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, matchMonthPatterns = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, parseMonthPatterns = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function(r) {
      return parseInt(r, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function(r) {
      return r + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const match$2 = match$1;
var locale$1 = {
  code: "es",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$2,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const es = locale$1, reactDatepicker = "";
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var r = {}.hasOwnProperty;
    function n() {
      for (var o = "", c = 0; c < arguments.length; c++) {
        var l = arguments[c];
        l && (o = s(o, a(l)));
      }
      return o;
    }
    function a(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var c = "";
      for (var l in o)
        r.call(o, l) && o[l] && (c = s(c, l));
      return c;
    }
    function s(o, c) {
      return c ? o ? o + " " + c : o + c : o;
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames$1 = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
function _inheritsLoose(t, r) {
  t.prototype = Object.create(r.prototype), t.prototype.constructor = t, _setPrototypeOf$2(t, r);
}
function _setPrototypeOf$2(t, r) {
  return _setPrototypeOf$2 = Object.setPrototypeOf || function(a, s) {
    return a.__proto__ = s, a;
  }, _setPrototypeOf$2(t, r);
}
function _objectWithoutPropertiesLoose$a(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function _assertThisInitialized$3(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function isNodeFound(t, r, n) {
  return t === r ? !0 : t.correspondingElement ? t.correspondingElement.classList.contains(n) : t.classList.contains(n);
}
function findHighest(t, r, n) {
  if (t === r)
    return !0;
  for (; t.parentNode || t.host; ) {
    if (t.parentNode && isNodeFound(t, r, n))
      return !0;
    t = t.parentNode || t.host;
  }
  return t;
}
function clickedScrollbar(t) {
  return document.documentElement.clientWidth <= t.clientX || document.documentElement.clientHeight <= t.clientY;
}
var testPassiveEventSupport = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var r = !1, n = Object.defineProperty({}, "passive", {
      get: function() {
        r = !0;
      }
    }), a = function() {
    };
    return window.addEventListener("testPassiveEventSupport", a, n), window.removeEventListener("testPassiveEventSupport", a, n), r;
  }
};
function autoInc(t) {
  return t === void 0 && (t = 0), function() {
    return ++t;
  };
}
var uid = autoInc(), passiveEventSupport, handlersMap = {}, enabledInstances = {}, touchEvents = ["touchstart", "touchmove"], IGNORE_CLASS_NAME = "ignore-react-onclickoutside";
function getEventHandlerOptions(t, r) {
  var n = {}, a = touchEvents.indexOf(r) !== -1;
  return a && passiveEventSupport && (n.passive = !t.props.preventDefault), n;
}
function onClickOutsideHOC(t, r) {
  var n, a, s = t.displayName || t.name || "Component";
  return a = n = /* @__PURE__ */ function(o) {
    _inheritsLoose(c, o);
    function c(d) {
      var h;
      return h = o.call(this, d) || this, h.__outsideClickHandler = function(u) {
        if (typeof h.__clickOutsideHandlerProp == "function") {
          h.__clickOutsideHandlerProp(u);
          return;
        }
        var p = h.getInstance();
        if (typeof p.props.handleClickOutside == "function") {
          p.props.handleClickOutside(u);
          return;
        }
        if (typeof p.handleClickOutside == "function") {
          p.handleClickOutside(u);
          return;
        }
        throw new Error("WrappedComponent: " + s + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, h.__getComponentNode = function() {
        var u = h.getInstance();
        return r && typeof r.setClickOutsideRef == "function" ? r.setClickOutsideRef()(u) : typeof u.setClickOutsideRef == "function" ? u.setClickOutsideRef() : findDOMNode(u);
      }, h.enableOnClickOutside = function() {
        if (!(typeof document > "u" || enabledInstances[h._uid])) {
          typeof passiveEventSupport > "u" && (passiveEventSupport = testPassiveEventSupport()), enabledInstances[h._uid] = !0;
          var u = h.props.eventTypes;
          u.forEach || (u = [u]), handlersMap[h._uid] = function(p) {
            if (h.componentNode !== null && !(h.initTimeStamp > p.timeStamp) && (h.props.preventDefault && p.preventDefault(), h.props.stopPropagation && p.stopPropagation(), !(h.props.excludeScrollbar && clickedScrollbar(p)))) {
              var m = p.composed && p.composedPath && p.composedPath().shift() || p.target;
              findHighest(m, h.componentNode, h.props.outsideClickIgnoreClass) === document && h.__outsideClickHandler(p);
            }
          }, u.forEach(function(p) {
            document.addEventListener(p, handlersMap[h._uid], getEventHandlerOptions(_assertThisInitialized$3(h), p));
          });
        }
      }, h.disableOnClickOutside = function() {
        delete enabledInstances[h._uid];
        var u = handlersMap[h._uid];
        if (u && typeof document < "u") {
          var p = h.props.eventTypes;
          p.forEach || (p = [p]), p.forEach(function(m) {
            return document.removeEventListener(m, u, getEventHandlerOptions(_assertThisInitialized$3(h), m));
          }), delete handlersMap[h._uid];
        }
      }, h.getRef = function(u) {
        return h.instanceRef = u;
      }, h._uid = uid(), h.initTimeStamp = performance.now(), h;
    }
    var l = c.prototype;
    return l.getInstance = function() {
      if (t.prototype && !t.prototype.isReactComponent)
        return this;
      var h = this.instanceRef;
      return h.getInstance ? h.getInstance() : h;
    }, l.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var h = this.getInstance();
        if (r && typeof r.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = r.handleClickOutside(h), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + s + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, l.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, l.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, l.render = function() {
      var h = this.props;
      h.excludeScrollbar;
      var u = _objectWithoutPropertiesLoose$a(h, ["excludeScrollbar"]);
      return t.prototype && t.prototype.isReactComponent ? u.ref = this.getRef : u.wrappedRef = this.getRef, u.disableOnClickOutside = this.disableOnClickOutside, u.enableOnClickOutside = this.enableOnClickOutside, createElement$1(t, u);
    }, c;
  }(Component), n.displayName = "OnClickOutside(" + s + ")", n.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: r && r.excludeScrollbar || !1,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: !1,
    stopPropagation: !1
  }, n.getClass = function() {
    return t.getClass ? t.getClass() : t;
  }, a;
}
var ManagerReferenceNodeContext = React.createContext(), ManagerReferenceNodeSetterContext = React.createContext();
function Manager(t) {
  var r = t.children, n = React.useState(null), a = n[0], s = n[1], o = React.useRef(!1);
  React.useEffect(function() {
    return function() {
      o.current = !0;
    };
  }, []);
  var c = React.useCallback(function(l) {
    o.current || s(l);
  }, []);
  return /* @__PURE__ */ jsx$1(ManagerReferenceNodeContext.Provider, {
    value: a,
    children: /* @__PURE__ */ jsx$1(ManagerReferenceNodeSetterContext.Provider, {
      value: c,
      children: r
    })
  });
}
var unwrapArray = function(r) {
  return Array.isArray(r) ? r[0] : r;
}, safeInvoke = function(r) {
  if (typeof r == "function") {
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      a[s - 1] = arguments[s];
    return r.apply(void 0, a);
  }
}, setRef = function(r, n) {
  if (typeof r == "function")
    return safeInvoke(r, n);
  r != null && (r.current = n);
}, fromEntries = function(r) {
  return r.reduce(function(n, a) {
    var s = a[0], o = a[1];
    return n[s] = o, n;
  }, {});
}, useIsomorphicLayoutEffect = typeof window < "u" && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect, top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(t, r) {
  return t.concat([r + "-" + start, r + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(t, r) {
  return t.concat([r, r + "-" + start, r + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName$1(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function getWindow$1(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var r = t.ownerDocument;
    return r && r.defaultView || window;
  }
  return t;
}
function isElement$1(t) {
  var r = getWindow$1(t).Element;
  return t instanceof r || t instanceof Element;
}
function isHTMLElement$1(t) {
  var r = getWindow$1(t).HTMLElement;
  return t instanceof r || t instanceof HTMLElement;
}
function isShadowRoot$1(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var r = getWindow$1(t).ShadowRoot;
  return t instanceof r || t instanceof ShadowRoot;
}
function applyStyles(t) {
  var r = t.state;
  Object.keys(r.elements).forEach(function(n) {
    var a = r.styles[n] || {}, s = r.attributes[n] || {}, o = r.elements[n];
    !isHTMLElement$1(o) || !getNodeName$1(o) || (Object.assign(o.style, a), Object.keys(s).forEach(function(c) {
      var l = s[c];
      l === !1 ? o.removeAttribute(c) : o.setAttribute(c, l === !0 ? "" : l);
    }));
  });
}
function effect$2(t) {
  var r = t.state, n = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow), function() {
    Object.keys(r.elements).forEach(function(a) {
      var s = r.elements[a], o = r.attributes[a] || {}, c = Object.keys(r.styles.hasOwnProperty(a) ? r.styles[a] : n[a]), l = c.reduce(function(d, h) {
        return d[h] = "", d;
      }, {});
      !isHTMLElement$1(s) || !getNodeName$1(s) || (Object.assign(s.style, l), Object.keys(o).forEach(function(d) {
        s.removeAttribute(d);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(t) {
  return t.split("-")[0];
}
var max$4 = Math.max, min$4 = Math.min, round$4 = Math.round;
function getUAString() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect$1(t, r, n) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  var a = t.getBoundingClientRect(), s = 1, o = 1;
  r && isHTMLElement$1(t) && (s = t.offsetWidth > 0 && round$4(a.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && round$4(a.height) / t.offsetHeight || 1);
  var c = isElement$1(t) ? getWindow$1(t) : window, l = c.visualViewport, d = !isLayoutViewport() && n, h = (a.left + (d && l ? l.offsetLeft : 0)) / s, u = (a.top + (d && l ? l.offsetTop : 0)) / o, p = a.width / s, m = a.height / o;
  return {
    width: p,
    height: m,
    top: u,
    right: h + p,
    bottom: u + m,
    left: h,
    x: h,
    y: u
  };
}
function getLayoutRect(t) {
  var r = getBoundingClientRect$1(t), n = t.offsetWidth, a = t.offsetHeight;
  return Math.abs(r.width - n) <= 1 && (n = r.width), Math.abs(r.height - a) <= 1 && (a = r.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: a
  };
}
function contains$2(t, r) {
  var n = r.getRootNode && r.getRootNode();
  if (t.contains(r))
    return !0;
  if (n && isShadowRoot$1(n)) {
    var a = r;
    do {
      if (a && t.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function getComputedStyle$2(t) {
  return getWindow$1(t).getComputedStyle(t);
}
function isTableElement(t) {
  return ["table", "td", "th"].indexOf(getNodeName$1(t)) >= 0;
}
function getDocumentElement$1(t) {
  return ((isElement$1(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function getParentNode$1(t) {
  return getNodeName$1(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (isShadowRoot$1(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement$1(t)
  );
}
function getTrueOffsetParent(t) {
  return !isHTMLElement$1(t) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$2(t).position === "fixed" ? null : t.offsetParent;
}
function getContainingBlock(t) {
  var r = /firefox/i.test(getUAString()), n = /Trident/i.test(getUAString());
  if (n && isHTMLElement$1(t)) {
    var a = getComputedStyle$2(t);
    if (a.position === "fixed")
      return null;
  }
  var s = getParentNode$1(t);
  for (isShadowRoot$1(s) && (s = s.host); isHTMLElement$1(s) && ["html", "body"].indexOf(getNodeName$1(s)) < 0; ) {
    var o = getComputedStyle$2(s);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || r && o.willChange === "filter" || r && o.filter && o.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function getOffsetParent(t) {
  for (var r = getWindow$1(t), n = getTrueOffsetParent(t); n && isTableElement(n) && getComputedStyle$2(n).position === "static"; )
    n = getTrueOffsetParent(n);
  return n && (getNodeName$1(n) === "html" || getNodeName$1(n) === "body" && getComputedStyle$2(n).position === "static") ? r : n || getContainingBlock(t) || r;
}
function getMainAxisFromPlacement(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function within(t, r, n) {
  return max$4(t, min$4(r, n));
}
function withinMaxClamp(t, r, n) {
  var a = within(t, r, n);
  return a > n ? n : a;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(t) {
  return Object.assign({}, getFreshSideObject(), t);
}
function expandToHashMap(t, r) {
  return r.reduce(function(n, a) {
    return n[a] = t, n;
  }, {});
}
var toPaddingObject = function(r, n) {
  return r = typeof r == "function" ? r(Object.assign({}, n.rects, {
    placement: n.placement
  })) : r, mergePaddingObject(typeof r != "number" ? r : expandToHashMap(r, basePlacements));
};
function arrow(t) {
  var r, n = t.state, a = t.name, s = t.options, o = n.elements.arrow, c = n.modifiersData.popperOffsets, l = getBasePlacement(n.placement), d = getMainAxisFromPlacement(l), h = [left, right].indexOf(l) >= 0, u = h ? "height" : "width";
  if (!(!o || !c)) {
    var p = toPaddingObject(s.padding, n), m = getLayoutRect(o), g = d === "y" ? top : left, v = d === "y" ? bottom : right, y = n.rects.reference[u] + n.rects.reference[d] - c[d] - n.rects.popper[u], x = c[d] - n.rects.reference[d], _ = getOffsetParent(o), $ = _ ? d === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, b = y / 2 - x / 2, M = p[g], C = $ - m[u] - p[v], S = $ / 2 - m[u] / 2 + b, A = within(M, S, C), D = d;
    n.modifiersData[a] = (r = {}, r[D] = A, r.centerOffset = A - S, r);
  }
}
function effect$1(t) {
  var r = t.state, n = t.options, a = n.element, s = a === void 0 ? "[data-popper-arrow]" : a;
  s != null && (typeof s == "string" && (s = r.elements.popper.querySelector(s), !s) || contains$2(r.elements.popper, s) && (r.elements.arrow = s));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(t) {
  return t.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(t, r) {
  var n = t.x, a = t.y, s = r.devicePixelRatio || 1;
  return {
    x: round$4(n * s) / s || 0,
    y: round$4(a * s) / s || 0
  };
}
function mapToStyles(t) {
  var r, n = t.popper, a = t.popperRect, s = t.placement, o = t.variation, c = t.offsets, l = t.position, d = t.gpuAcceleration, h = t.adaptive, u = t.roundOffsets, p = t.isFixed, m = c.x, g = m === void 0 ? 0 : m, v = c.y, y = v === void 0 ? 0 : v, x = typeof u == "function" ? u({
    x: g,
    y
  }) : {
    x: g,
    y
  };
  g = x.x, y = x.y;
  var _ = c.hasOwnProperty("x"), $ = c.hasOwnProperty("y"), b = left, M = top, C = window;
  if (h) {
    var S = getOffsetParent(n), A = "clientHeight", D = "clientWidth";
    if (S === getWindow$1(n) && (S = getDocumentElement$1(n), getComputedStyle$2(S).position !== "static" && l === "absolute" && (A = "scrollHeight", D = "scrollWidth")), S = S, s === top || (s === left || s === right) && o === end) {
      M = bottom;
      var N = p && S === C && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        S[A]
      );
      y -= N - a.height, y *= d ? 1 : -1;
    }
    if (s === left || (s === top || s === bottom) && o === end) {
      b = right;
      var T = p && S === C && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        S[D]
      );
      g -= T - a.width, g *= d ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: l
  }, h && unsetSides), F = u === !0 ? roundOffsetsByDPR({
    x: g,
    y
  }, getWindow$1(n)) : {
    x: g,
    y
  };
  if (g = F.x, y = F.y, d) {
    var z;
    return Object.assign({}, R, (z = {}, z[M] = $ ? "0" : "", z[b] = _ ? "0" : "", z.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + y + "px)" : "translate3d(" + g + "px, " + y + "px, 0)", z));
  }
  return Object.assign({}, R, (r = {}, r[M] = $ ? y + "px" : "", r[b] = _ ? g + "px" : "", r.transform = "", r));
}
function computeStyles(t) {
  var r = t.state, n = t.options, a = n.gpuAcceleration, s = a === void 0 ? !0 : a, o = n.adaptive, c = o === void 0 ? !0 : o, l = n.roundOffsets, d = l === void 0 ? !0 : l, h = {
    placement: getBasePlacement(r.placement),
    variation: getVariation(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: s,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, mapToStyles(Object.assign({}, h, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: c,
    roundOffsets: d
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, mapToStyles(Object.assign({}, h, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: d
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(t) {
  var r = t.state, n = t.instance, a = t.options, s = a.scroll, o = s === void 0 ? !0 : s, c = a.resize, l = c === void 0 ? !0 : c, d = getWindow$1(r.elements.popper), h = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return o && h.forEach(function(u) {
    u.addEventListener("scroll", n.update, passive);
  }), l && d.addEventListener("resize", n.update, passive), function() {
    o && h.forEach(function(u) {
      u.removeEventListener("scroll", n.update, passive);
    }), l && d.removeEventListener("resize", n.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect,
  data: {}
};
var hash$2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(t) {
  return t.replace(/left|right|bottom|top/g, function(r) {
    return hash$2[r];
  });
}
var hash$1 = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(t) {
  return t.replace(/start|end/g, function(r) {
    return hash$1[r];
  });
}
function getWindowScroll(t) {
  var r = getWindow$1(t), n = r.pageXOffset, a = r.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function getWindowScrollBarX(t) {
  return getBoundingClientRect$1(getDocumentElement$1(t)).left + getWindowScroll(t).scrollLeft;
}
function getViewportRect(t, r) {
  var n = getWindow$1(t), a = getDocumentElement$1(t), s = n.visualViewport, o = a.clientWidth, c = a.clientHeight, l = 0, d = 0;
  if (s) {
    o = s.width, c = s.height;
    var h = isLayoutViewport();
    (h || !h && r === "fixed") && (l = s.offsetLeft, d = s.offsetTop);
  }
  return {
    width: o,
    height: c,
    x: l + getWindowScrollBarX(t),
    y: d
  };
}
function getDocumentRect(t) {
  var r, n = getDocumentElement$1(t), a = getWindowScroll(t), s = (r = t.ownerDocument) == null ? void 0 : r.body, o = max$4(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), c = max$4(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), l = -a.scrollLeft + getWindowScrollBarX(t), d = -a.scrollTop;
  return getComputedStyle$2(s || n).direction === "rtl" && (l += max$4(n.clientWidth, s ? s.clientWidth : 0) - o), {
    width: o,
    height: c,
    x: l,
    y: d
  };
}
function isScrollParent(t) {
  var r = getComputedStyle$2(t), n = r.overflow, a = r.overflowX, s = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + a);
}
function getScrollParent$1(t) {
  return ["html", "body", "#document"].indexOf(getNodeName$1(t)) >= 0 ? t.ownerDocument.body : isHTMLElement$1(t) && isScrollParent(t) ? t : getScrollParent$1(getParentNode$1(t));
}
function listScrollParents(t, r) {
  var n;
  r === void 0 && (r = []);
  var a = getScrollParent$1(t), s = a === ((n = t.ownerDocument) == null ? void 0 : n.body), o = getWindow$1(a), c = s ? [o].concat(o.visualViewport || [], isScrollParent(a) ? a : []) : a, l = r.concat(c);
  return s ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(listScrollParents(getParentNode$1(c)))
  );
}
function rectToClientRect$1(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function getInnerBoundingClientRect(t, r) {
  var n = getBoundingClientRect$1(t, !1, r === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function getClientRectFromMixedType(t, r, n) {
  return r === viewport ? rectToClientRect$1(getViewportRect(t, n)) : isElement$1(r) ? getInnerBoundingClientRect(r, n) : rectToClientRect$1(getDocumentRect(getDocumentElement$1(t)));
}
function getClippingParents(t) {
  var r = listScrollParents(getParentNode$1(t)), n = ["absolute", "fixed"].indexOf(getComputedStyle$2(t).position) >= 0, a = n && isHTMLElement$1(t) ? getOffsetParent(t) : t;
  return isElement$1(a) ? r.filter(function(s) {
    return isElement$1(s) && contains$2(s, a) && getNodeName$1(s) !== "body";
  }) : [];
}
function getClippingRect(t, r, n, a) {
  var s = r === "clippingParents" ? getClippingParents(t) : [].concat(r), o = [].concat(s, [n]), c = o[0], l = o.reduce(function(d, h) {
    var u = getClientRectFromMixedType(t, h, a);
    return d.top = max$4(u.top, d.top), d.right = min$4(u.right, d.right), d.bottom = min$4(u.bottom, d.bottom), d.left = max$4(u.left, d.left), d;
  }, getClientRectFromMixedType(t, c, a));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function computeOffsets(t) {
  var r = t.reference, n = t.element, a = t.placement, s = a ? getBasePlacement(a) : null, o = a ? getVariation(a) : null, c = r.x + r.width / 2 - n.width / 2, l = r.y + r.height / 2 - n.height / 2, d;
  switch (s) {
    case top:
      d = {
        x: c,
        y: r.y - n.height
      };
      break;
    case bottom:
      d = {
        x: c,
        y: r.y + r.height
      };
      break;
    case right:
      d = {
        x: r.x + r.width,
        y: l
      };
      break;
    case left:
      d = {
        x: r.x - n.width,
        y: l
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  var h = s ? getMainAxisFromPlacement(s) : null;
  if (h != null) {
    var u = h === "y" ? "height" : "width";
    switch (o) {
      case start:
        d[h] = d[h] - (r[u] / 2 - n[u] / 2);
        break;
      case end:
        d[h] = d[h] + (r[u] / 2 - n[u] / 2);
        break;
    }
  }
  return d;
}
function detectOverflow(t, r) {
  r === void 0 && (r = {});
  var n = r, a = n.placement, s = a === void 0 ? t.placement : a, o = n.strategy, c = o === void 0 ? t.strategy : o, l = n.boundary, d = l === void 0 ? clippingParents : l, h = n.rootBoundary, u = h === void 0 ? viewport : h, p = n.elementContext, m = p === void 0 ? popper : p, g = n.altBoundary, v = g === void 0 ? !1 : g, y = n.padding, x = y === void 0 ? 0 : y, _ = mergePaddingObject(typeof x != "number" ? x : expandToHashMap(x, basePlacements)), $ = m === popper ? reference : popper, b = t.rects.popper, M = t.elements[v ? $ : m], C = getClippingRect(isElement$1(M) ? M : M.contextElement || getDocumentElement$1(t.elements.popper), d, u, c), S = getBoundingClientRect$1(t.elements.reference), A = computeOffsets({
    reference: S,
    element: b,
    strategy: "absolute",
    placement: s
  }), D = rectToClientRect$1(Object.assign({}, b, A)), N = m === popper ? D : S, T = {
    top: C.top - N.top + _.top,
    bottom: N.bottom - C.bottom + _.bottom,
    left: C.left - N.left + _.left,
    right: N.right - C.right + _.right
  }, R = t.modifiersData.offset;
  if (m === popper && R) {
    var F = R[s];
    Object.keys(T).forEach(function(z) {
      var O = [right, bottom].indexOf(z) >= 0 ? 1 : -1, G = [top, bottom].indexOf(z) >= 0 ? "y" : "x";
      T[z] += F[G] * O;
    });
  }
  return T;
}
function computeAutoPlacement(t, r) {
  r === void 0 && (r = {});
  var n = r, a = n.placement, s = n.boundary, o = n.rootBoundary, c = n.padding, l = n.flipVariations, d = n.allowedAutoPlacements, h = d === void 0 ? placements : d, u = getVariation(a), p = u ? l ? variationPlacements : variationPlacements.filter(function(v) {
    return getVariation(v) === u;
  }) : basePlacements, m = p.filter(function(v) {
    return h.indexOf(v) >= 0;
  });
  m.length === 0 && (m = p);
  var g = m.reduce(function(v, y) {
    return v[y] = detectOverflow(t, {
      placement: y,
      boundary: s,
      rootBoundary: o,
      padding: c
    })[getBasePlacement(y)], v;
  }, {});
  return Object.keys(g).sort(function(v, y) {
    return g[v] - g[y];
  });
}
function getExpandedFallbackPlacements(t) {
  if (getBasePlacement(t) === auto)
    return [];
  var r = getOppositePlacement(t);
  return [getOppositeVariationPlacement(t), r, getOppositeVariationPlacement(r)];
}
function flip(t) {
  var r = t.state, n = t.options, a = t.name;
  if (!r.modifiersData[a]._skip) {
    for (var s = n.mainAxis, o = s === void 0 ? !0 : s, c = n.altAxis, l = c === void 0 ? !0 : c, d = n.fallbackPlacements, h = n.padding, u = n.boundary, p = n.rootBoundary, m = n.altBoundary, g = n.flipVariations, v = g === void 0 ? !0 : g, y = n.allowedAutoPlacements, x = r.options.placement, _ = getBasePlacement(x), $ = _ === x, b = d || ($ || !v ? [getOppositePlacement(x)] : getExpandedFallbackPlacements(x)), M = [x].concat(b).reduce(function(Z, ae) {
      return Z.concat(getBasePlacement(ae) === auto ? computeAutoPlacement(r, {
        placement: ae,
        boundary: u,
        rootBoundary: p,
        padding: h,
        flipVariations: v,
        allowedAutoPlacements: y
      }) : ae);
    }, []), C = r.rects.reference, S = r.rects.popper, A = /* @__PURE__ */ new Map(), D = !0, N = M[0], T = 0; T < M.length; T++) {
      var R = M[T], F = getBasePlacement(R), z = getVariation(R) === start, O = [top, bottom].indexOf(F) >= 0, G = O ? "width" : "height", I = detectOverflow(r, {
        placement: R,
        boundary: u,
        rootBoundary: p,
        altBoundary: m,
        padding: h
      }), k = O ? z ? right : left : z ? bottom : top;
      C[G] > S[G] && (k = getOppositePlacement(k));
      var B = getOppositePlacement(k), L = [];
      if (o && L.push(I[F] <= 0), l && L.push(I[k] <= 0, I[B] <= 0), L.every(function(Z) {
        return Z;
      })) {
        N = R, D = !1;
        break;
      }
      A.set(R, L);
    }
    if (D)
      for (var V = v ? 3 : 1, U = function(ae) {
        var ee = M.find(function(se) {
          var nr = A.get(se);
          if (nr)
            return nr.slice(0, ae).every(function(ce) {
              return ce;
            });
        });
        if (ee)
          return N = ee, "break";
      }, J = V; J > 0; J--) {
        var q = U(J);
        if (q === "break")
          break;
      }
    r.placement !== N && (r.modifiersData[a]._skip = !0, r.placement = N, r.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(t, r, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - r.height - n.y,
    right: t.right - r.width + n.x,
    bottom: t.bottom - r.height + n.y,
    left: t.left - r.width - n.x
  };
}
function isAnySideFullyClipped(t) {
  return [top, right, bottom, left].some(function(r) {
    return t[r] >= 0;
  });
}
function hide(t) {
  var r = t.state, n = t.name, a = r.rects.reference, s = r.rects.popper, o = r.modifiersData.preventOverflow, c = detectOverflow(r, {
    elementContext: "reference"
  }), l = detectOverflow(r, {
    altBoundary: !0
  }), d = getSideOffsets(c, a), h = getSideOffsets(l, s, o), u = isAnySideFullyClipped(d), p = isAnySideFullyClipped(h);
  r.modifiersData[n] = {
    referenceClippingOffsets: d,
    popperEscapeOffsets: h,
    isReferenceHidden: u,
    hasPopperEscaped: p
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": p
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(t, r, n) {
  var a = getBasePlacement(t), s = [left, top].indexOf(a) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, r, {
    placement: t
  })) : n, c = o[0], l = o[1];
  return c = c || 0, l = (l || 0) * s, [left, right].indexOf(a) >= 0 ? {
    x: l,
    y: c
  } : {
    x: c,
    y: l
  };
}
function offset$1(t) {
  var r = t.state, n = t.options, a = t.name, s = n.offset, o = s === void 0 ? [0, 0] : s, c = placements.reduce(function(u, p) {
    return u[p] = distanceAndSkiddingToXY(p, r.rects, o), u;
  }, {}), l = c[r.placement], d = l.x, h = l.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += d, r.modifiersData.popperOffsets.y += h), r.modifiersData[a] = c;
}
const offset$2 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset$1
};
function popperOffsets(t) {
  var r = t.state, n = t.name;
  r.modifiersData[n] = computeOffsets({
    reference: r.rects.reference,
    element: r.rects.popper,
    strategy: "absolute",
    placement: r.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(t) {
  return t === "x" ? "y" : "x";
}
function preventOverflow(t) {
  var r = t.state, n = t.options, a = t.name, s = n.mainAxis, o = s === void 0 ? !0 : s, c = n.altAxis, l = c === void 0 ? !1 : c, d = n.boundary, h = n.rootBoundary, u = n.altBoundary, p = n.padding, m = n.tether, g = m === void 0 ? !0 : m, v = n.tetherOffset, y = v === void 0 ? 0 : v, x = detectOverflow(r, {
    boundary: d,
    rootBoundary: h,
    padding: p,
    altBoundary: u
  }), _ = getBasePlacement(r.placement), $ = getVariation(r.placement), b = !$, M = getMainAxisFromPlacement(_), C = getAltAxis(M), S = r.modifiersData.popperOffsets, A = r.rects.reference, D = r.rects.popper, N = typeof y == "function" ? y(Object.assign({}, r.rects, {
    placement: r.placement
  })) : y, T = typeof N == "number" ? {
    mainAxis: N,
    altAxis: N
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, N), R = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, F = {
    x: 0,
    y: 0
  };
  if (S) {
    if (o) {
      var z, O = M === "y" ? top : left, G = M === "y" ? bottom : right, I = M === "y" ? "height" : "width", k = S[M], B = k + x[O], L = k - x[G], V = g ? -D[I] / 2 : 0, U = $ === start ? A[I] : D[I], J = $ === start ? -D[I] : -A[I], q = r.elements.arrow, Z = g && q ? getLayoutRect(q) : {
        width: 0,
        height: 0
      }, ae = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : getFreshSideObject(), ee = ae[O], se = ae[G], nr = within(0, A[I], Z[I]), ce = b ? A[I] / 2 - V - nr - ee - T.mainAxis : U - nr - ee - T.mainAxis, oe = b ? -A[I] / 2 + V + nr + se + T.mainAxis : J + nr + se + T.mainAxis, ur = r.elements.arrow && getOffsetParent(r.elements.arrow), ir = ur ? M === "y" ? ur.clientTop || 0 : ur.clientLeft || 0 : 0, _r = (z = R == null ? void 0 : R[M]) != null ? z : 0, yr = k + ce - _r - ir, ne = k + oe - _r, pe = within(g ? min$4(B, yr) : B, k, g ? max$4(L, ne) : L);
      S[M] = pe, F[M] = pe - k;
    }
    if (l) {
      var hr, $r = M === "x" ? top : left, Sr = M === "x" ? bottom : right, ze = S[C], cr = C === "y" ? "height" : "width", fr = ze + x[$r], mr = ze - x[Sr], wr = [top, left].indexOf(_) !== -1, Nr = (hr = R == null ? void 0 : R[C]) != null ? hr : 0, xr = wr ? fr : ze - A[cr] - D[cr] - Nr + T.altAxis, Er = wr ? ze + A[cr] + D[cr] - Nr - T.altAxis : mr, Ir = g && wr ? withinMaxClamp(xr, ze, Er) : within(g ? xr : fr, ze, g ? Er : mr);
      S[C] = Ir, F[C] = Ir - ze;
    }
    r.modifiersData[a] = F;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function getNodeScroll(t) {
  return t === getWindow$1(t) || !isHTMLElement$1(t) ? getWindowScroll(t) : getHTMLElementScroll(t);
}
function isElementScaled(t) {
  var r = t.getBoundingClientRect(), n = round$4(r.width) / t.offsetWidth || 1, a = round$4(r.height) / t.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function getCompositeRect(t, r, n) {
  n === void 0 && (n = !1);
  var a = isHTMLElement$1(r), s = isHTMLElement$1(r) && isElementScaled(r), o = getDocumentElement$1(r), c = getBoundingClientRect$1(t, s, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((getNodeName$1(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(o)) && (l = getNodeScroll(r)), isHTMLElement$1(r) ? (d = getBoundingClientRect$1(r, !0), d.x += r.clientLeft, d.y += r.clientTop) : o && (d.x = getWindowScrollBarX(o))), {
    x: c.left + l.scrollLeft - d.x,
    y: c.top + l.scrollTop - d.y,
    width: c.width,
    height: c.height
  };
}
function order(t) {
  var r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  t.forEach(function(o) {
    r.set(o.name, o);
  });
  function s(o) {
    n.add(o.name);
    var c = [].concat(o.requires || [], o.requiresIfExists || []);
    c.forEach(function(l) {
      if (!n.has(l)) {
        var d = r.get(l);
        d && s(d);
      }
    }), a.push(o);
  }
  return t.forEach(function(o) {
    n.has(o.name) || s(o);
  }), a;
}
function orderModifiers(t) {
  var r = order(t);
  return modifierPhases.reduce(function(n, a) {
    return n.concat(r.filter(function(s) {
      return s.phase === a;
    }));
  }, []);
}
function debounce$1(t) {
  var r;
  return function() {
    return r || (r = new Promise(function(n) {
      Promise.resolve().then(function() {
        r = void 0, n(t());
      });
    })), r;
  };
}
function mergeByName(t) {
  var r = t.reduce(function(n, a) {
    var s = n[a.name];
    return n[a.name] = s ? Object.assign({}, s, a, {
      options: Object.assign({}, s.options, a.options),
      data: Object.assign({}, s.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(r).map(function(n) {
    return r[n];
  });
}
var DEFAULT_OPTIONS$1 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return !r.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function popperGenerator(t) {
  t === void 0 && (t = {});
  var r = t, n = r.defaultModifiers, a = n === void 0 ? [] : n, s = r.defaultOptions, o = s === void 0 ? DEFAULT_OPTIONS$1 : s;
  return function(l, d, h) {
    h === void 0 && (h = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS$1, o),
      modifiersData: {},
      elements: {
        reference: l,
        popper: d
      },
      attributes: {},
      styles: {}
    }, p = [], m = !1, g = {
      state: u,
      setOptions: function(_) {
        var $ = typeof _ == "function" ? _(u.options) : _;
        y(), u.options = Object.assign({}, o, u.options, $), u.scrollParents = {
          reference: isElement$1(l) ? listScrollParents(l) : l.contextElement ? listScrollParents(l.contextElement) : [],
          popper: listScrollParents(d)
        };
        var b = orderModifiers(mergeByName([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = b.filter(function(M) {
          return M.enabled;
        }), v(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var _ = u.elements, $ = _.reference, b = _.popper;
          if (areValidElements($, b)) {
            u.rects = {
              reference: getCompositeRect($, getOffsetParent(b), u.options.strategy === "fixed"),
              popper: getLayoutRect(b)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(T) {
              return u.modifiersData[T.name] = Object.assign({}, T.data);
            });
            for (var M = 0; M < u.orderedModifiers.length; M++) {
              if (u.reset === !0) {
                u.reset = !1, M = -1;
                continue;
              }
              var C = u.orderedModifiers[M], S = C.fn, A = C.options, D = A === void 0 ? {} : A, N = C.name;
              typeof S == "function" && (u = S({
                state: u,
                options: D,
                name: N,
                instance: g
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function() {
        return new Promise(function(x) {
          g.forceUpdate(), x(u);
        });
      }),
      destroy: function() {
        y(), m = !0;
      }
    };
    if (!areValidElements(l, d))
      return g;
    g.setOptions(h).then(function(x) {
      !m && h.onFirstUpdate && h.onFirstUpdate(x);
    });
    function v() {
      u.orderedModifiers.forEach(function(x) {
        var _ = x.name, $ = x.options, b = $ === void 0 ? {} : $, M = x.effect;
        if (typeof M == "function") {
          var C = M({
            state: u,
            name: _,
            instance: g,
            options: b
          }), S = function() {
          };
          p.push(C || S);
        }
      });
    }
    function y() {
      p.forEach(function(x) {
        return x();
      }), p = [];
    }
    return g;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$2, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
}), hasElementType = typeof Element < "u", hasMap = typeof Map == "function", hasSet = typeof Set == "function", hasArrayBuffer = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function equal$2(t, r) {
  if (t === r)
    return !0;
  if (t && r && typeof t == "object" && typeof r == "object") {
    if (t.constructor !== r.constructor)
      return !1;
    var n, a, s;
    if (Array.isArray(t)) {
      if (n = t.length, n != r.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (!equal$2(t[a], r[a]))
          return !1;
      return !0;
    }
    var o;
    if (hasMap && t instanceof Map && r instanceof Map) {
      if (t.size !== r.size)
        return !1;
      for (o = t.entries(); !(a = o.next()).done; )
        if (!r.has(a.value[0]))
          return !1;
      for (o = t.entries(); !(a = o.next()).done; )
        if (!equal$2(a.value[1], r.get(a.value[0])))
          return !1;
      return !0;
    }
    if (hasSet && t instanceof Set && r instanceof Set) {
      if (t.size !== r.size)
        return !1;
      for (o = t.entries(); !(a = o.next()).done; )
        if (!r.has(a.value[0]))
          return !1;
      return !0;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(t) && ArrayBuffer.isView(r)) {
      if (n = t.length, n != r.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (t[a] !== r[a])
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === r.source && t.flags === r.flags;
    if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof r.valueOf == "function")
      return t.valueOf() === r.valueOf();
    if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof r.toString == "function")
      return t.toString() === r.toString();
    if (s = Object.keys(t), n = s.length, n !== Object.keys(r).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, s[a]))
        return !1;
    if (hasElementType && t instanceof Element)
      return !1;
    for (a = n; a-- !== 0; )
      if (!((s[a] === "_owner" || s[a] === "__v" || s[a] === "__o") && t.$$typeof) && !equal$2(t[s[a]], r[s[a]]))
        return !1;
    return !0;
  }
  return t !== t && r !== r;
}
var reactFastCompare = function(r, n) {
  try {
    return equal$2(r, n);
  } catch (a) {
    if ((a.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw a;
  }
};
const isEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare);
var EMPTY_MODIFIERS$1 = [], usePopper = function(r, n, a) {
  a === void 0 && (a = {});
  var s = React.useRef(null), o = {
    onFirstUpdate: a.onFirstUpdate,
    placement: a.placement || "bottom",
    strategy: a.strategy || "absolute",
    modifiers: a.modifiers || EMPTY_MODIFIERS$1
  }, c = React.useState({
    styles: {
      popper: {
        position: o.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), l = c[0], d = c[1], h = React.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(g) {
        var v = g.state, y = Object.keys(v.elements);
        ReactDOM.flushSync(function() {
          d({
            styles: fromEntries(y.map(function(x) {
              return [x, v.styles[x] || {}];
            })),
            attributes: fromEntries(y.map(function(x) {
              return [x, v.attributes[x]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), u = React.useMemo(function() {
    var m = {
      onFirstUpdate: o.onFirstUpdate,
      placement: o.placement,
      strategy: o.strategy,
      modifiers: [].concat(o.modifiers, [h, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return isEqual$1(s.current, m) ? s.current || m : (s.current = m, m);
  }, [o.onFirstUpdate, o.placement, o.strategy, o.modifiers, h]), p = React.useRef();
  return useIsomorphicLayoutEffect(function() {
    p.current && p.current.setOptions(u);
  }, [u]), useIsomorphicLayoutEffect(function() {
    if (!(r == null || n == null)) {
      var m = a.createPopper || createPopper, g = m(r, n, u);
      return p.current = g, function() {
        g.destroy(), p.current = null;
      };
    }
  }, [r, n, a.createPopper]), {
    state: p.current ? p.current.state : null,
    styles: l.styles,
    attributes: l.attributes,
    update: p.current ? p.current.update : null,
    forceUpdate: p.current ? p.current.forceUpdate : null
  };
}, NOOP = function() {
}, NOOP_PROMISE = function() {
  return Promise.resolve(null);
}, EMPTY_MODIFIERS = [];
function Popper(t) {
  var r = t.placement, n = r === void 0 ? "bottom" : r, a = t.strategy, s = a === void 0 ? "absolute" : a, o = t.modifiers, c = o === void 0 ? EMPTY_MODIFIERS : o, l = t.referenceElement, d = t.onFirstUpdate, h = t.innerRef, u = t.children, p = React.useContext(ManagerReferenceNodeContext), m = React.useState(null), g = m[0], v = m[1], y = React.useState(null), x = y[0], _ = y[1];
  React.useEffect(function() {
    setRef(h, g);
  }, [h, g]);
  var $ = React.useMemo(function() {
    return {
      placement: n,
      strategy: s,
      onFirstUpdate: d,
      modifiers: [].concat(c, [{
        name: "arrow",
        enabled: x != null,
        options: {
          element: x
        }
      }])
    };
  }, [n, s, d, c, x]), b = usePopper(l || p, g, $), M = b.state, C = b.styles, S = b.forceUpdate, A = b.update, D = React.useMemo(function() {
    return {
      ref: v,
      style: C.popper,
      placement: M ? M.placement : n,
      hasPopperEscaped: M && M.modifiersData.hide ? M.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: M && M.modifiersData.hide ? M.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: C.arrow,
        ref: _
      },
      forceUpdate: S || NOOP,
      update: A || NOOP_PROMISE
    };
  }, [v, _, n, M, C, A, S]);
  return unwrapArray(u)(D);
}
var warning_1, hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning)
    return warning_1;
  hasRequiredWarning = 1;
  var t = process.env.NODE_ENV !== "production", r = function() {
  };
  if (t) {
    var n = function(s, o) {
      var c = arguments.length;
      o = new Array(c > 1 ? c - 1 : 0);
      for (var l = 1; l < c; l++)
        o[l - 1] = arguments[l];
      var d = 0, h = "Warning: " + s.replace(/%s/g, function() {
        return o[d++];
      });
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {
      }
    };
    r = function(a, s, o) {
      var c = arguments.length;
      o = new Array(c > 2 ? c - 2 : 0);
      for (var l = 2; l < c; l++)
        o[l - 2] = arguments[l];
      if (s === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      a || n.apply(null, [s].concat(o));
    };
  }
  return warning_1 = r, warning_1;
}
var warningExports = requireWarning();
const warning = /* @__PURE__ */ getDefaultExportFromCjs(warningExports);
function Reference(t) {
  var r = t.children, n = t.innerRef, a = React.useContext(ManagerReferenceNodeSetterContext), s = React.useCallback(function(o) {
    setRef(n, o), safeInvoke(a, o);
  }, [n, a]);
  return React.useEffect(function() {
    return function() {
      return setRef(n, null);
    };
  }, []), React.useEffect(function() {
    warning(!!a, "`Reference` should not be used outside of a `Manager` component.");
  }, [a]), unwrapArray(r)({
    ref: s
  });
}
function le(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function de(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? le(Object(n), !0).forEach(function(a) {
      ye(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : le(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function ue(t) {
  return ue = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ue(t);
}
function he(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function me(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, _e$1(a.key), a);
  }
}
function fe(t, r, n) {
  return r && me(t.prototype, r), n && me(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function ye(t, r, n) {
  return (r = _e$1(r)) in t ? Object.defineProperty(t, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = n, t;
}
function ve() {
  return ve = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, ve.apply(this, arguments);
}
function De(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), r && ke(t, r);
}
function ge(t) {
  return ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ge(t);
}
function ke(t, r) {
  return ke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, ke(t, r);
}
function we(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function be(t) {
  var r = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, a = ge(t);
    if (r) {
      var s = ge(this).constructor;
      n = Reflect.construct(a, arguments, s);
    } else
      n = a.apply(this, arguments);
    return function(o, c) {
      if (c && (typeof c == "object" || typeof c == "function"))
        return c;
      if (c !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return we(o);
    }(this, n);
  };
}
function Se(t) {
  return function(r) {
    if (Array.isArray(r))
      return Ce(r);
  }(t) || function(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
      return Array.from(r);
  }(t) || function(r, n) {
    if (r) {
      if (typeof r == "string")
        return Ce(r, n);
      var a = Object.prototype.toString.call(r).slice(8, -1);
      if (a === "Object" && r.constructor && (a = r.constructor.name), a === "Map" || a === "Set")
        return Array.from(r);
      if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
        return Ce(r, n);
    }
  }(t) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ce(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _e$1(t) {
  var r = function(n, a) {
    if (typeof n != "object" || n === null)
      return n;
    var s = n[Symbol.toPrimitive];
    if (s !== void 0) {
      var o = s.call(n, a || "default");
      if (typeof o != "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (a === "string" ? String : Number)(n);
  }(t, "string");
  return typeof r == "symbol" ? r : String(r);
}
var Me = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    default:
      return r.date({
        width: "full"
      });
  }
}, Pe = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    default:
      return r.time({
        width: "full"
      });
  }
}, Ee = {
  p: Pe,
  P: function(t, r) {
    var n, a = t.match(/(P+)(p+)?/) || [], s = a[1], o = a[2];
    if (!o)
      return Me(t, r);
    switch (s) {
      case "P":
        n = r.dateTime({
          width: "short"
        });
        break;
      case "PP":
        n = r.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        n = r.dateTime({
          width: "long"
        });
        break;
      default:
        n = r.dateTime({
          width: "full"
        });
    }
    return n.replace("{{date}}", Me(s, r)).replace("{{time}}", Pe(o, r));
  }
}, Ne = 12, xe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ye(t) {
  var r = t ? typeof t == "string" || t instanceof String ? parseISO(t) : toDate$1(t) : /* @__PURE__ */ new Date();
  return Te(r) ? r : null;
}
function Te(t, r) {
  return r = r || /* @__PURE__ */ new Date("1/1/1000"), isValid$3(t) && !isBefore$1(t, r);
}
function Ie(t, r, n) {
  if (n === "en")
    return format$8(t, r, {
      awareOfUnicodeTokens: !0
    });
  var a = Ge(n);
  return n && !a && console.warn('A locale object was not found for the provided string ["'.concat(n, '"].')), !a && $e() && Ge($e()) && (a = Ge($e())), format$8(t, r, {
    locale: a || null,
    awareOfUnicodeTokens: !0
  });
}
function Oe(t, r) {
  var n = r.dateFormat, a = r.locale;
  return t && Ie(t, Array.isArray(n) ? n[0] : n, a) || "";
}
function Re(t, r) {
  var n = r.hour, a = n === void 0 ? 0 : n, s = r.minute, o = s === void 0 ? 0 : s, c = r.second;
  return setHours(setMinutes(setSeconds(t, c === void 0 ? 0 : c), o), a);
}
function Le(t, r, n) {
  var a = Ge(r || $e());
  return startOfWeek(t, {
    locale: a,
    weekStartsOn: n
  });
}
function Fe(t) {
  return startOfMonth(t);
}
function Ae(t) {
  return startOfYear(t);
}
function We(t) {
  return startOfQuarter(t);
}
function Ke() {
  return startOfDay(Ye());
}
function Be(t, r) {
  return t && r ? isSameYear(t, r) : !t && !r;
}
function Qe(t, r) {
  return t && r ? isSameMonth(t, r) : !t && !r;
}
function He(t, r) {
  return t && r ? isSameQuarter(t, r) : !t && !r;
}
function je(t, r) {
  return t && r ? isSameDay(t, r) : !t && !r;
}
function Ve(t, r) {
  return t && r ? isEqual$2(t, r) : !t && !r;
}
function qe(t, r, n) {
  var a, s = startOfDay(r), o = endOfDay(n);
  try {
    a = isWithinInterval(t, {
      start: s,
      end: o
    });
  } catch {
    a = !1;
  }
  return a;
}
function $e() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function Ge(t) {
  if (typeof t == "string") {
    var r = typeof window < "u" ? window : globalThis;
    return r.__localeData__ ? r.__localeData__[t] : null;
  }
  return t;
}
function Je(t, r) {
  return Ie(setMonth$1(Ye(), t), "LLLL", r);
}
function Xe(t, r) {
  return Ie(setMonth$1(Ye(), t), "LLL", r);
}
function Ze(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, a = r.maxDate, s = r.excludeDates, o = r.excludeDateIntervals, c = r.includeDates, l = r.includeDateIntervals, d = r.filterDate;
  return it(t, {
    minDate: n,
    maxDate: a
  }) || s && s.some(function(h) {
    return je(t, h);
  }) || o && o.some(function(h) {
    var u = h.start, p = h.end;
    return isWithinInterval(t, {
      start: u,
      end: p
    });
  }) || c && !c.some(function(h) {
    return je(t, h);
  }) || l && !l.some(function(h) {
    var u = h.start, p = h.end;
    return isWithinInterval(t, {
      start: u,
      end: p
    });
  }) || d && !d(Ye(t)) || !1;
}
function et(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.excludeDates, a = r.excludeDateIntervals;
  return a && a.length > 0 ? a.some(function(s) {
    var o = s.start, c = s.end;
    return isWithinInterval(t, {
      start: o,
      end: c
    });
  }) : n && n.some(function(s) {
    return je(t, s);
  }) || !1;
}
function tt(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, a = r.maxDate, s = r.excludeDates, o = r.includeDates, c = r.filterDate;
  return it(t, {
    minDate: startOfMonth(n),
    maxDate: endOfMonth(a)
  }) || s && s.some(function(l) {
    return Qe(t, l);
  }) || o && !o.some(function(l) {
    return Qe(t, l);
  }) || c && !c(Ye(t)) || !1;
}
function rt(t, r, n, a) {
  var s = getYear(t), o = getMonth(t), c = getYear(r), l = getMonth(r), d = getYear(a);
  return s === c && s === d ? o <= n && n <= l : s < c ? d === s && o <= n || d === c && l >= n || d < c && d > s : void 0;
}
function nt(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, a = r.maxDate, s = r.excludeDates, o = r.includeDates, c = r.filterDate;
  return it(t, {
    minDate: n,
    maxDate: a
  }) || s && s.some(function(l) {
    return He(t, l);
  }) || o && !o.some(function(l) {
    return He(t, l);
  }) || c && !c(Ye(t)) || !1;
}
function ot(t, r, n) {
  if (!isValid$3(r) || !isValid$3(n))
    return !1;
  var a = getYear(r), s = getYear(n);
  return a <= t && s >= t;
}
function at(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, a = r.maxDate, s = r.excludeDates, o = r.includeDates, c = r.filterDate, l = new Date(t, 0, 1);
  return it(l, {
    minDate: startOfYear(n),
    maxDate: endOfYear(a)
  }) || s && s.some(function(d) {
    return Be(l, d);
  }) || o && !o.some(function(d) {
    return Be(l, d);
  }) || c && !c(Ye(l)) || !1;
}
function st(t, r, n, a) {
  var s = getYear(t), o = getQuarter(t), c = getYear(r), l = getQuarter(r), d = getYear(a);
  return s === c && s === d ? o <= n && n <= l : s < c ? d === s && o <= n || d === c && l >= n || d < c && d > s : void 0;
}
function it(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, a = r.maxDate;
  return n && differenceInCalendarDays(t, n) < 0 || a && differenceInCalendarDays(t, a) > 0;
}
function pt(t, r) {
  return r.some(function(n) {
    return getHours(n) === getHours(t) && getMinutes(n) === getMinutes(t);
  });
}
function ct(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.excludeTimes, a = r.includeTimes, s = r.filterTime;
  return n && pt(t, n) || a && !pt(t, a) || s && !s(t) || !1;
}
function lt(t, r) {
  var n = r.minTime, a = r.maxTime;
  if (!n || !a)
    throw new Error("Both minTime and maxTime props required");
  var s, o = Ye(), c = setHours(setMinutes(o, getMinutes(t)), getHours(t)), l = setHours(setMinutes(o, getMinutes(n)), getHours(n)), d = setHours(setMinutes(o, getMinutes(a)), getHours(a));
  try {
    s = !isWithinInterval(c, {
      start: l,
      end: d
    });
  } catch {
    s = !1;
  }
  return s;
}
function dt(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, a = r.includeDates, s = subMonths(t, 1);
  return n && differenceInCalendarMonths(n, s) > 0 || a && a.every(function(o) {
    return differenceInCalendarMonths(o, s) > 0;
  }) || !1;
}
function ut(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.maxDate, a = r.includeDates, s = addMonths(t, 1);
  return n && differenceInCalendarMonths(s, n) > 0 || a && a.every(function(o) {
    return differenceInCalendarMonths(s, o) > 0;
  }) || !1;
}
function ht(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.minDate, a = r.includeDates, s = subYears(t, 1);
  return n && differenceInCalendarYears(n, s) > 0 || a && a.every(function(o) {
    return differenceInCalendarYears(o, s) > 0;
  }) || !1;
}
function mt(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.maxDate, a = r.includeDates, s = addYears(t, 1);
  return n && differenceInCalendarYears(s, n) > 0 || a && a.every(function(o) {
    return differenceInCalendarYears(s, o) > 0;
  }) || !1;
}
function ft(t) {
  var r = t.minDate, n = t.includeDates;
  if (n && r) {
    var a = n.filter(function(s) {
      return differenceInCalendarDays(s, r) >= 0;
    });
    return min$5(a);
  }
  return n ? min$5(n) : r;
}
function yt(t) {
  var r = t.maxDate, n = t.includeDates;
  if (n && r) {
    var a = n.filter(function(s) {
      return differenceInCalendarDays(s, r) <= 0;
    });
    return max$5(a);
  }
  return n ? max$5(n) : r;
}
function vt() {
  for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", n = /* @__PURE__ */ new Map(), a = 0, s = t.length; a < s; a++) {
    var o = t[a];
    if (isDate$2(o)) {
      var c = Ie(o, "MM.dd.yyyy"), l = n.get(c) || [];
      l.includes(r) || (l.push(r), n.set(c, l));
    } else if (ue(o) === "object") {
      var d = Object.keys(o), h = d[0], u = o[d[0]];
      if (typeof h == "string" && u.constructor === Array)
        for (var p = 0, m = u.length; p < m; p++) {
          var g = Ie(u[p], "MM.dd.yyyy"), v = n.get(g) || [];
          v.includes(h) || (v.push(h), n.set(g, v));
        }
    }
  }
  return n;
}
function Dt() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", n = /* @__PURE__ */ new Map();
  return t.forEach(function(a) {
    var s = a.date, o = a.holidayName;
    if (isDate$2(s)) {
      var c = Ie(s, "MM.dd.yyyy"), l = n.get(c) || {};
      if (!("className" in l) || l.className !== r || (d = l.holidayNames, h = [o], d.length !== h.length || !d.every(function(p, m) {
        return p === h[m];
      }))) {
        var d, h;
        l.className = r;
        var u = l.holidayNames;
        l.holidayNames = u ? [].concat(Se(u), [o]) : [o], n.set(c, l);
      }
    }
  }), n;
}
function gt(t, r, n, a, s) {
  for (var o = s.length, c = [], l = 0; l < o; l++) {
    var d = addMinutes(addHours(t, getHours(s[l])), getMinutes(s[l])), h = addMinutes(t, (n + 1) * a);
    isAfter$1(d, r) && isBefore$1(d, h) && c.push(s[l]);
  }
  return c;
}
function kt(t) {
  return t < 10 ? "0".concat(t) : "".concat(t);
}
function wt(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ne, n = Math.ceil(getYear(t) / r) * r;
  return {
    startPeriod: n - (r - 1),
    endPeriod: n
  };
}
function bt(t) {
  var r = t.getSeconds(), n = t.getMilliseconds();
  return toDate$1(t.getTime() - 1e3 * r - n);
}
function St(t, r, n, a) {
  for (var s = [], o = 0; o < 2 * r + 1; o++) {
    var c = t + r - o, l = !0;
    n && (l = getYear(n) <= c), a && l && (l = getYear(a) >= c), l && s.push(c);
  }
  return s;
}
var Ct = onClickOutsideHOC(function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    he(this, n), ye(we(s = r.call(this, a)), "renderOptions", function() {
      var d = s.props.year, h = s.state.yearsList.map(function(m) {
        return /* @__PURE__ */ jsxs("div", {
          className: d === m ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
          onClick: s.onChange.bind(we(s), m),
          "aria-selected": d === m ? "true" : void 0,
          children: [d === m ? /* @__PURE__ */ jsx$1("span", {
            className: "react-datepicker__year-option--selected",
            children: "✓"
          }) : "", m]
        }, m);
      }), u = s.props.minDate ? getYear(s.props.minDate) : null, p = s.props.maxDate ? getYear(s.props.maxDate) : null;
      return p && s.state.yearsList.find(function(m) {
        return m === p;
      }) || h.unshift(/* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__year-option",
        onClick: s.incrementYears,
        children: /* @__PURE__ */ jsx$1("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
        })
      }, "upcoming")), u && s.state.yearsList.find(function(m) {
        return m === u;
      }) || h.push(/* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__year-option",
        onClick: s.decrementYears,
        children: /* @__PURE__ */ jsx$1("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
        })
      }, "previous")), h;
    }), ye(we(s), "onChange", function(d) {
      s.props.onChange(d);
    }), ye(we(s), "handleClickOutside", function() {
      s.props.onCancel();
    }), ye(we(s), "shiftYears", function(d) {
      var h = s.state.yearsList.map(function(u) {
        return u + d;
      });
      s.setState({
        yearsList: h
      });
    }), ye(we(s), "incrementYears", function() {
      return s.shiftYears(1);
    }), ye(we(s), "decrementYears", function() {
      return s.shiftYears(-1);
    });
    var o = a.yearDropdownItemNumber, c = a.scrollableYearDropdown, l = o || (c ? 10 : 5);
    return s.state = {
      yearsList: St(s.props.year, l, s.props.minDate, s.props.maxDate)
    }, s.dropdownRef = createRef(), s;
  }
  return fe(n, [{
    key: "componentDidMount",
    value: function() {
      var a = this.dropdownRef.current;
      if (a) {
        var s = a.children ? Array.from(a.children) : null, o = s ? s.find(function(c) {
          return c.ariaSelected;
        }) : null;
        a.scrollTop = o ? o.offsetTop + (o.clientHeight - a.clientHeight) / 2 : (a.scrollHeight - a.clientHeight) / 2;
      }
    }
  }, {
    key: "render",
    value: function() {
      var a = classNames$1({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return /* @__PURE__ */ jsx$1("div", {
        className: a,
        ref: this.dropdownRef,
        children: this.renderOptions()
      });
    }
  }]), n;
}()), _t = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "state", {
      dropdownVisible: !1
    }), ye(we(a), "renderSelectOptions", function() {
      for (var l = a.props.minDate ? getYear(a.props.minDate) : 1900, d = a.props.maxDate ? getYear(a.props.maxDate) : 2100, h = [], u = l; u <= d; u++)
        h.push(/* @__PURE__ */ jsx$1("option", {
          value: u,
          children: u
        }, u));
      return h;
    }), ye(we(a), "onSelectChange", function(l) {
      a.onChange(l.target.value);
    }), ye(we(a), "renderSelectMode", function() {
      return /* @__PURE__ */ jsx$1("select", {
        value: a.props.year,
        className: "react-datepicker__year-select",
        onChange: a.onSelectChange,
        children: a.renderSelectOptions()
      });
    }), ye(we(a), "renderReadView", function(l) {
      return /* @__PURE__ */ jsxs("div", {
        style: {
          visibility: l ? "visible" : "hidden"
        },
        className: "react-datepicker__year-read-view",
        onClick: function(d) {
          return a.toggleDropdown(d);
        },
        children: [/* @__PURE__ */ jsx$1("span", {
          className: "react-datepicker__year-read-view--down-arrow"
        }), /* @__PURE__ */ jsx$1("span", {
          className: "react-datepicker__year-read-view--selected-year",
          children: a.props.year
        })]
      }, "read");
    }), ye(we(a), "renderDropdown", function() {
      return /* @__PURE__ */ jsx$1(Ct, {
        year: a.props.year,
        onChange: a.onChange,
        onCancel: a.toggleDropdown,
        minDate: a.props.minDate,
        maxDate: a.props.maxDate,
        scrollableYearDropdown: a.props.scrollableYearDropdown,
        yearDropdownItemNumber: a.props.yearDropdownItemNumber
      }, "dropdown");
    }), ye(we(a), "renderScrollMode", function() {
      var l = a.state.dropdownVisible, d = [a.renderReadView(!l)];
      return l && d.unshift(a.renderDropdown()), d;
    }), ye(we(a), "onChange", function(l) {
      a.toggleDropdown(), l !== a.props.year && a.props.onChange(l);
    }), ye(we(a), "toggleDropdown", function(l) {
      a.setState({
        dropdownVisible: !a.state.dropdownVisible
      }, function() {
        a.props.adjustDateOnChange && a.handleYearChange(a.props.date, l);
      });
    }), ye(we(a), "handleYearChange", function(l, d) {
      a.onSelect(l, d), a.setOpen();
    }), ye(we(a), "onSelect", function(l, d) {
      a.props.onSelect && a.props.onSelect(l, d);
    }), ye(we(a), "setOpen", function() {
      a.props.setOpen && a.props.setOpen(!0);
    }), a;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      var a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode();
          break;
        case "select":
          a = this.renderSelectMode();
      }
      return /* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode),
        children: a
      });
    }
  }]), n;
}(), Mt = onClickOutsideHOC(function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "isSelectedMonth", function(l) {
      return a.props.month === l;
    }), ye(we(a), "renderOptions", function() {
      return a.props.monthNames.map(function(l, d) {
        return /* @__PURE__ */ jsxs("div", {
          className: a.isSelectedMonth(d) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
          onClick: a.onChange.bind(we(a), d),
          "aria-selected": a.isSelectedMonth(d) ? "true" : void 0,
          children: [a.isSelectedMonth(d) ? /* @__PURE__ */ jsx$1("span", {
            className: "react-datepicker__month-option--selected",
            children: "✓"
          }) : "", l]
        }, l);
      });
    }), ye(we(a), "onChange", function(l) {
      return a.props.onChange(l);
    }), ye(we(a), "handleClickOutside", function() {
      return a.props.onCancel();
    }), a;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__month-dropdown",
        children: this.renderOptions()
      });
    }
  }]), n;
}()), Pt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "state", {
      dropdownVisible: !1
    }), ye(we(a), "renderSelectOptions", function(l) {
      return l.map(function(d, h) {
        return /* @__PURE__ */ jsx$1("option", {
          value: h,
          children: d
        }, h);
      });
    }), ye(we(a), "renderSelectMode", function(l) {
      return /* @__PURE__ */ jsx$1("select", {
        value: a.props.month,
        className: "react-datepicker__month-select",
        onChange: function(d) {
          return a.onChange(d.target.value);
        },
        children: a.renderSelectOptions(l)
      });
    }), ye(we(a), "renderReadView", function(l, d) {
      return /* @__PURE__ */ jsxs("div", {
        style: {
          visibility: l ? "visible" : "hidden"
        },
        className: "react-datepicker__month-read-view",
        onClick: a.toggleDropdown,
        children: [/* @__PURE__ */ jsx$1("span", {
          className: "react-datepicker__month-read-view--down-arrow"
        }), /* @__PURE__ */ jsx$1("span", {
          className: "react-datepicker__month-read-view--selected-month",
          children: d[a.props.month]
        })]
      }, "read");
    }), ye(we(a), "renderDropdown", function(l) {
      return /* @__PURE__ */ jsx$1(Mt, {
        month: a.props.month,
        monthNames: l,
        onChange: a.onChange,
        onCancel: a.toggleDropdown
      }, "dropdown");
    }), ye(we(a), "renderScrollMode", function(l) {
      var d = a.state.dropdownVisible, h = [a.renderReadView(!d, l)];
      return d && h.unshift(a.renderDropdown(l)), h;
    }), ye(we(a), "onChange", function(l) {
      a.toggleDropdown(), l !== a.props.month && a.props.onChange(l);
    }), ye(we(a), "toggleDropdown", function() {
      return a.setState({
        dropdownVisible: !a.state.dropdownVisible
      });
    }), a;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      var a, s = this, o = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(c) {
        return Xe(c, s.props.locale);
      } : function(c) {
        return Je(c, s.props.locale);
      });
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode(o);
          break;
        case "select":
          a = this.renderSelectMode(o);
      }
      return /* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode),
        children: a
      });
    }
  }]), n;
}();
function Et(t, r) {
  for (var n = [], a = Fe(t), s = Fe(r); !isAfter$1(a, s); )
    n.push(Ye(a)), a = addMonths(a, 1);
  return n;
}
var Nt = onClickOutsideHOC(function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    return he(this, n), ye(we(s = r.call(this, a)), "renderOptions", function() {
      return s.state.monthYearsList.map(function(o) {
        var c = getTime(o), l = Be(s.props.date, o) && Qe(s.props.date, o);
        return /* @__PURE__ */ jsxs("div", {
          className: l ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
          onClick: s.onChange.bind(we(s), c),
          "aria-selected": l ? "true" : void 0,
          children: [l ? /* @__PURE__ */ jsx$1("span", {
            className: "react-datepicker__month-year-option--selected",
            children: "✓"
          }) : "", Ie(o, s.props.dateFormat, s.props.locale)]
        }, c);
      });
    }), ye(we(s), "onChange", function(o) {
      return s.props.onChange(o);
    }), ye(we(s), "handleClickOutside", function() {
      s.props.onCancel();
    }), s.state = {
      monthYearsList: Et(s.props.minDate, s.props.maxDate)
    }, s;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      var a = classNames$1({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return /* @__PURE__ */ jsx$1("div", {
        className: a,
        children: this.renderOptions()
      });
    }
  }]), n;
}()), xt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "state", {
      dropdownVisible: !1
    }), ye(we(a), "renderSelectOptions", function() {
      for (var l = Fe(a.props.minDate), d = Fe(a.props.maxDate), h = []; !isAfter$1(l, d); ) {
        var u = getTime(l);
        h.push(/* @__PURE__ */ jsx$1("option", {
          value: u,
          children: Ie(l, a.props.dateFormat, a.props.locale)
        }, u)), l = addMonths(l, 1);
      }
      return h;
    }), ye(we(a), "onSelectChange", function(l) {
      a.onChange(l.target.value);
    }), ye(we(a), "renderSelectMode", function() {
      return /* @__PURE__ */ jsx$1("select", {
        value: getTime(Fe(a.props.date)),
        className: "react-datepicker__month-year-select",
        onChange: a.onSelectChange,
        children: a.renderSelectOptions()
      });
    }), ye(we(a), "renderReadView", function(l) {
      var d = Ie(a.props.date, a.props.dateFormat, a.props.locale);
      return /* @__PURE__ */ jsxs("div", {
        style: {
          visibility: l ? "visible" : "hidden"
        },
        className: "react-datepicker__month-year-read-view",
        onClick: function(h) {
          return a.toggleDropdown(h);
        },
        children: [/* @__PURE__ */ jsx$1("span", {
          className: "react-datepicker__month-year-read-view--down-arrow"
        }), /* @__PURE__ */ jsx$1("span", {
          className: "react-datepicker__month-year-read-view--selected-month-year",
          children: d
        })]
      }, "read");
    }), ye(we(a), "renderDropdown", function() {
      return /* @__PURE__ */ jsx$1(Nt, {
        date: a.props.date,
        dateFormat: a.props.dateFormat,
        onChange: a.onChange,
        onCancel: a.toggleDropdown,
        minDate: a.props.minDate,
        maxDate: a.props.maxDate,
        scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
        locale: a.props.locale
      }, "dropdown");
    }), ye(we(a), "renderScrollMode", function() {
      var l = a.state.dropdownVisible, d = [a.renderReadView(!l)];
      return l && d.unshift(a.renderDropdown()), d;
    }), ye(we(a), "onChange", function(l) {
      a.toggleDropdown();
      var d = Ye(parseInt(l));
      Be(a.props.date, d) && Qe(a.props.date, d) || a.props.onChange(d);
    }), ye(we(a), "toggleDropdown", function() {
      return a.setState({
        dropdownVisible: !a.state.dropdownVisible
      });
    }), a;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      var a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode();
          break;
        case "select":
          a = this.renderSelectMode();
      }
      return /* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode),
        children: a
      });
    }
  }]), n;
}(), Yt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "dayEl", React__default.createRef()), ye(we(a), "handleClick", function(l) {
      !a.isDisabled() && a.props.onClick && a.props.onClick(l);
    }), ye(we(a), "handleMouseEnter", function(l) {
      !a.isDisabled() && a.props.onMouseEnter && a.props.onMouseEnter(l);
    }), ye(we(a), "handleOnKeyDown", function(l) {
      l.key === " " && (l.preventDefault(), l.key = "Enter"), a.props.handleOnKeyDown(l);
    }), ye(we(a), "isSameDay", function(l) {
      return je(a.props.day, l);
    }), ye(we(a), "isKeyboardSelected", function() {
      return !a.props.disabledKeyboardNavigation && !(a.isSameDay(a.props.selected) || a.isSameWeek(a.props.selected)) && (a.isSameDay(a.props.preSelection) || a.isSameWeek(a.props.preSelection));
    }), ye(we(a), "isDisabled", function() {
      return Ze(a.props.day, a.props);
    }), ye(we(a), "isExcluded", function() {
      return et(a.props.day, a.props);
    }), ye(we(a), "isStartOfWeek", function() {
      return je(a.props.day, Le(a.props.day, a.props.locale, a.props.calendarStartDay));
    }), ye(we(a), "isSameWeek", function(l) {
      return a.props.showWeekPicker && je(l, Le(a.props.day, a.props.locale, a.props.calendarStartDay));
    }), ye(we(a), "getHighLightedClass", function() {
      var l = a.props, d = l.day, h = l.highlightDates;
      if (!h)
        return !1;
      var u = Ie(d, "MM.dd.yyyy");
      return h.get(u);
    }), ye(we(a), "getHolidaysClass", function() {
      var l = a.props, d = l.day, h = l.holidays;
      if (!h)
        return !1;
      var u = Ie(d, "MM.dd.yyyy");
      return h.has(u) ? [h.get(u).className] : void 0;
    }), ye(we(a), "isInRange", function() {
      var l = a.props, d = l.day, h = l.startDate, u = l.endDate;
      return !(!h || !u) && qe(d, h, u);
    }), ye(we(a), "isInSelectingRange", function() {
      var l, d = a.props, h = d.day, u = d.selectsStart, p = d.selectsEnd, m = d.selectsRange, g = d.selectsDisabledDaysInRange, v = d.startDate, y = d.endDate, x = (l = a.props.selectingDate) !== null && l !== void 0 ? l : a.props.preSelection;
      return !(!(u || p || m) || !x || !g && a.isDisabled()) && (u && y && (isBefore$1(x, y) || Ve(x, y)) ? qe(h, x, y) : (p && v && (isAfter$1(x, v) || Ve(x, v)) || !(!m || !v || y || !isAfter$1(x, v) && !Ve(x, v))) && qe(h, v, x));
    }), ye(we(a), "isSelectingRangeStart", function() {
      var l;
      if (!a.isInSelectingRange())
        return !1;
      var d = a.props, h = d.day, u = d.startDate, p = d.selectsStart, m = (l = a.props.selectingDate) !== null && l !== void 0 ? l : a.props.preSelection;
      return je(h, p ? m : u);
    }), ye(we(a), "isSelectingRangeEnd", function() {
      var l;
      if (!a.isInSelectingRange())
        return !1;
      var d = a.props, h = d.day, u = d.endDate, p = d.selectsEnd, m = d.selectsRange, g = (l = a.props.selectingDate) !== null && l !== void 0 ? l : a.props.preSelection;
      return je(h, p || m ? g : u);
    }), ye(we(a), "isRangeStart", function() {
      var l = a.props, d = l.day, h = l.startDate, u = l.endDate;
      return !(!h || !u) && je(h, d);
    }), ye(we(a), "isRangeEnd", function() {
      var l = a.props, d = l.day, h = l.startDate, u = l.endDate;
      return !(!h || !u) && je(u, d);
    }), ye(we(a), "isWeekend", function() {
      var l = getDay(a.props.day);
      return l === 0 || l === 6;
    }), ye(we(a), "isAfterMonth", function() {
      return a.props.month !== void 0 && (a.props.month + 1) % 12 === getMonth(a.props.day);
    }), ye(we(a), "isBeforeMonth", function() {
      return a.props.month !== void 0 && (getMonth(a.props.day) + 1) % 12 === a.props.month;
    }), ye(we(a), "isCurrentDay", function() {
      return a.isSameDay(Ye());
    }), ye(we(a), "isSelected", function() {
      return a.isSameDay(a.props.selected) || a.isSameWeek(a.props.selected);
    }), ye(we(a), "getClassNames", function(l) {
      var d, h = a.props.dayClassName ? a.props.dayClassName(l) : void 0;
      return classNames$1("react-datepicker__day", h, "react-datepicker__day--" + Ie(a.props.day, "ddd", d), {
        "react-datepicker__day--disabled": a.isDisabled(),
        "react-datepicker__day--excluded": a.isExcluded(),
        "react-datepicker__day--selected": a.isSelected(),
        "react-datepicker__day--keyboard-selected": a.isKeyboardSelected(),
        "react-datepicker__day--range-start": a.isRangeStart(),
        "react-datepicker__day--range-end": a.isRangeEnd(),
        "react-datepicker__day--in-range": a.isInRange(),
        "react-datepicker__day--in-selecting-range": a.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": a.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": a.isSelectingRangeEnd(),
        "react-datepicker__day--today": a.isCurrentDay(),
        "react-datepicker__day--weekend": a.isWeekend(),
        "react-datepicker__day--outside-month": a.isAfterMonth() || a.isBeforeMonth()
      }, a.getHighLightedClass("react-datepicker__day--highlighted"), a.getHolidaysClass());
    }), ye(we(a), "getAriaLabel", function() {
      var l = a.props, d = l.day, h = l.ariaLabelPrefixWhenEnabled, u = h === void 0 ? "Choose" : h, p = l.ariaLabelPrefixWhenDisabled, m = p === void 0 ? "Not available" : p, g = a.isDisabled() || a.isExcluded() ? m : u;
      return "".concat(g, " ").concat(Ie(d, "PPPP", a.props.locale));
    }), ye(we(a), "getTitle", function() {
      var l = a.props, d = l.day, h = l.holidays, u = h === void 0 ? /* @__PURE__ */ new Map() : h, p = Ie(d, "MM.dd.yyyy");
      return u.has(p) && u.get(p).holidayNames.length > 0 ? u.get(p).holidayNames.join(", ") : "";
    }), ye(we(a), "getTabIndex", function(l, d) {
      var h = l || a.props.selected, u = d || a.props.preSelection;
      return (!a.props.showWeekPicker || !a.props.showWeekNumber && a.isStartOfWeek()) && (a.isKeyboardSelected() || a.isSameDay(h) && je(u, h)) ? 0 : -1;
    }), ye(we(a), "handleFocusDay", function() {
      var l, d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = !1;
      a.getTabIndex() === 0 && !d.isInputFocused && a.isSameDay(a.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (h = !0), a.props.inline && !a.props.shouldFocusDayInline && (h = !1), a.props.containerRef && a.props.containerRef.current && a.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (h = !0), a.props.monthShowsDuplicateDaysEnd && a.isAfterMonth() && (h = !1), a.props.monthShowsDuplicateDaysStart && a.isBeforeMonth() && (h = !1)), h && ((l = a.dayEl.current) === null || l === void 0 || l.focus({
        preventScroll: !0
      }));
    }), ye(we(a), "renderDayContents", function() {
      return a.props.monthShowsDuplicateDaysEnd && a.isAfterMonth() || a.props.monthShowsDuplicateDaysStart && a.isBeforeMonth() ? null : a.props.renderDayContents ? a.props.renderDayContents(getDate(a.props.day), a.props.day) : getDate(a.props.day);
    }), ye(we(a), "render", function() {
      return /* @__PURE__ */ jsxs("div", {
        ref: a.dayEl,
        className: a.getClassNames(a.props.day),
        onKeyDown: a.handleOnKeyDown,
        onClick: a.handleClick,
        onMouseEnter: a.handleMouseEnter,
        tabIndex: a.getTabIndex(),
        "aria-label": a.getAriaLabel(),
        role: "option",
        title: a.getTitle(),
        "aria-disabled": a.isDisabled(),
        "aria-current": a.isCurrentDay() ? "date" : void 0,
        "aria-selected": a.isSelected() || a.isInRange(),
        children: [a.renderDayContents(), a.getTitle() !== "" && /* @__PURE__ */ jsx$1("span", {
          className: "holiday-overlay",
          children: a.getTitle()
        })]
      });
    }), a;
  }
  return fe(n, [{
    key: "componentDidMount",
    value: function() {
      this.handleFocusDay();
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      this.handleFocusDay(a);
    }
  }]), n;
}(), Tt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "weekNumberEl", React__default.createRef()), ye(we(a), "handleClick", function(l) {
      a.props.onClick && a.props.onClick(l);
    }), ye(we(a), "handleOnKeyDown", function(l) {
      l.key === " " && (l.preventDefault(), l.key = "Enter"), a.props.handleOnKeyDown(l);
    }), ye(we(a), "isKeyboardSelected", function() {
      return !a.props.disabledKeyboardNavigation && !je(a.props.date, a.props.selected) && je(a.props.date, a.props.preSelection);
    }), ye(we(a), "getTabIndex", function() {
      return a.props.showWeekPicker && a.props.showWeekNumber && (a.isKeyboardSelected() || je(a.props.date, a.props.selected) && je(a.props.preSelection, a.props.selected)) ? 0 : -1;
    }), ye(we(a), "handleFocusWeekNumber", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = !1;
      a.getTabIndex() === 0 && !l.isInputFocused && je(a.props.date, a.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (d = !0), a.props.inline && !a.props.shouldFocusDayInline && (d = !1), a.props.containerRef && a.props.containerRef.current && a.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (d = !0)), d && a.weekNumberEl.current && a.weekNumberEl.current.focus({
        preventScroll: !0
      });
    }), a;
  }
  return fe(n, [{
    key: "componentDidMount",
    value: function() {
      this.handleFocusWeekNumber();
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      this.handleFocusWeekNumber(a);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, s = a.weekNumber, o = a.ariaLabelPrefix, c = o === void 0 ? "week " : o, l = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!a.onClick,
        "react-datepicker__week-number--selected": je(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ jsx$1("div", {
        ref: this.weekNumberEl,
        className: classNames$1(l),
        "aria-label": "".concat(c, " ").concat(this.props.weekNumber),
        onClick: this.handleClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: this.getTabIndex(),
        children: s
      });
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        ariaLabelPrefix: "week "
      };
    }
  }]), n;
}(), It = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "handleDayClick", function(l, d) {
      a.props.onDayClick && a.props.onDayClick(l, d);
    }), ye(we(a), "handleDayMouseEnter", function(l) {
      a.props.onDayMouseEnter && a.props.onDayMouseEnter(l);
    }), ye(we(a), "handleWeekClick", function(l, d, h) {
      if (typeof a.props.onWeekSelect == "function" && a.props.onWeekSelect(l, d, h), a.props.showWeekPicker) {
        var u = Le(l, a.props.locale, a.props.calendarStartDay);
        a.handleDayClick(u, h);
      }
      a.props.shouldCloseOnSelect && a.props.setOpen(!1);
    }), ye(we(a), "formatWeekNumber", function(l) {
      return a.props.formatWeekNumber ? a.props.formatWeekNumber(l) : function(d, h) {
        var u = h && Ge(h) || $e() && Ge($e());
        return getISOWeek(d, u ? {
          locale: u
        } : null);
      }(l);
    }), ye(we(a), "renderDays", function() {
      var l = Le(a.props.day, a.props.locale, a.props.calendarStartDay), d = [], h = a.formatWeekNumber(l);
      if (a.props.showWeekNumber) {
        var u = a.props.onWeekSelect || a.props.showWeekPicker ? a.handleWeekClick.bind(we(a), l, h) : void 0;
        d.push(/* @__PURE__ */ jsx$1(Tt, {
          weekNumber: h,
          date: l,
          onClick: u,
          selected: a.props.selected,
          preSelection: a.props.preSelection,
          ariaLabelPrefix: a.props.ariaLabelPrefix,
          showWeekPicker: a.props.showWeekPicker,
          showWeekNumber: a.props.showWeekNumber,
          disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
          handleOnKeyDown: a.props.handleOnKeyDown,
          isInputFocused: a.props.isInputFocused,
          containerRef: a.props.containerRef
        }, "W"));
      }
      return d.concat([0, 1, 2, 3, 4, 5, 6].map(function(p) {
        var m = addDays(l, p);
        return /* @__PURE__ */ jsx$1(Yt, {
          ariaLabelPrefixWhenEnabled: a.props.chooseDayAriaLabelPrefix,
          ariaLabelPrefixWhenDisabled: a.props.disabledDayAriaLabelPrefix,
          day: m,
          month: a.props.month,
          onClick: a.handleDayClick.bind(we(a), m),
          onMouseEnter: a.handleDayMouseEnter.bind(we(a), m),
          minDate: a.props.minDate,
          maxDate: a.props.maxDate,
          excludeDates: a.props.excludeDates,
          excludeDateIntervals: a.props.excludeDateIntervals,
          includeDates: a.props.includeDates,
          includeDateIntervals: a.props.includeDateIntervals,
          highlightDates: a.props.highlightDates,
          holidays: a.props.holidays,
          selectingDate: a.props.selectingDate,
          filterDate: a.props.filterDate,
          preSelection: a.props.preSelection,
          selected: a.props.selected,
          selectsStart: a.props.selectsStart,
          selectsEnd: a.props.selectsEnd,
          selectsRange: a.props.selectsRange,
          showWeekPicker: a.props.showWeekPicker,
          showWeekNumber: a.props.showWeekNumber,
          selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
          startDate: a.props.startDate,
          endDate: a.props.endDate,
          dayClassName: a.props.dayClassName,
          renderDayContents: a.props.renderDayContents,
          disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
          handleOnKeyDown: a.props.handleOnKeyDown,
          isInputFocused: a.props.isInputFocused,
          containerRef: a.props.containerRef,
          inline: a.props.inline,
          shouldFocusDayInline: a.props.shouldFocusDayInline,
          monthShowsDuplicateDaysEnd: a.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: a.props.monthShowsDuplicateDaysStart,
          locale: a.props.locale
        }, m.valueOf());
      }));
    }), ye(we(a), "startOfWeek", function() {
      return Le(a.props.day, a.props.locale, a.props.calendarStartDay);
    }), ye(we(a), "isKeyboardSelected", function() {
      return !a.props.disabledKeyboardNavigation && !je(a.startOfWeek(), a.props.selected) && je(a.startOfWeek(), a.props.preSelection);
    }), a;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      var a = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": je(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ jsx$1("div", {
        className: classNames$1(a),
        children: this.renderDays()
      });
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        shouldCloseOnSelect: !0
      };
    }
  }]), n;
}(), Ot = "two_columns", Rt = "three_columns", Lt = "four_columns", Ft = ye(ye(ye({}, Ot, {
  grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]],
  verticalNavigationOffset: 2
}), Rt, {
  grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]],
  verticalNavigationOffset: 3
}), Lt, {
  grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]],
  verticalNavigationOffset: 4
});
function At(t, r) {
  return t ? Lt : r ? Ot : Rt;
}
var Wt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "MONTH_REFS", Se(Array(12)).map(function() {
      return React__default.createRef();
    })), ye(we(a), "QUARTER_REFS", Se(Array(4)).map(function() {
      return React__default.createRef();
    })), ye(we(a), "isDisabled", function(l) {
      return Ze(l, a.props);
    }), ye(we(a), "isExcluded", function(l) {
      return et(l, a.props);
    }), ye(we(a), "handleDayClick", function(l, d) {
      a.props.onDayClick && a.props.onDayClick(l, d, a.props.orderInDisplay);
    }), ye(we(a), "handleDayMouseEnter", function(l) {
      a.props.onDayMouseEnter && a.props.onDayMouseEnter(l);
    }), ye(we(a), "handleMouseLeave", function() {
      a.props.onMouseLeave && a.props.onMouseLeave();
    }), ye(we(a), "isRangeStartMonth", function(l) {
      var d = a.props, h = d.day, u = d.startDate, p = d.endDate;
      return !(!u || !p) && Qe(setMonth$1(h, l), u);
    }), ye(we(a), "isRangeStartQuarter", function(l) {
      var d = a.props, h = d.day, u = d.startDate, p = d.endDate;
      return !(!u || !p) && He(setQuarter(h, l), u);
    }), ye(we(a), "isRangeEndMonth", function(l) {
      var d = a.props, h = d.day, u = d.startDate, p = d.endDate;
      return !(!u || !p) && Qe(setMonth$1(h, l), p);
    }), ye(we(a), "isRangeEndQuarter", function(l) {
      var d = a.props, h = d.day, u = d.startDate, p = d.endDate;
      return !(!u || !p) && He(setQuarter(h, l), p);
    }), ye(we(a), "isInSelectingRangeMonth", function(l) {
      var d, h = a.props, u = h.day, p = h.selectsStart, m = h.selectsEnd, g = h.selectsRange, v = h.startDate, y = h.endDate, x = (d = a.props.selectingDate) !== null && d !== void 0 ? d : a.props.preSelection;
      return !(!(p || m || g) || !x) && (p && y ? rt(x, y, l, u) : (m && v || !(!g || !v || y)) && rt(v, x, l, u));
    }), ye(we(a), "isSelectingMonthRangeStart", function(l) {
      var d;
      if (!a.isInSelectingRangeMonth(l))
        return !1;
      var h = a.props, u = h.day, p = h.startDate, m = h.selectsStart, g = setMonth$1(u, l), v = (d = a.props.selectingDate) !== null && d !== void 0 ? d : a.props.preSelection;
      return Qe(g, m ? v : p);
    }), ye(we(a), "isSelectingMonthRangeEnd", function(l) {
      var d;
      if (!a.isInSelectingRangeMonth(l))
        return !1;
      var h = a.props, u = h.day, p = h.endDate, m = h.selectsEnd, g = h.selectsRange, v = setMonth$1(u, l), y = (d = a.props.selectingDate) !== null && d !== void 0 ? d : a.props.preSelection;
      return Qe(v, m || g ? y : p);
    }), ye(we(a), "isInSelectingRangeQuarter", function(l) {
      var d, h = a.props, u = h.day, p = h.selectsStart, m = h.selectsEnd, g = h.selectsRange, v = h.startDate, y = h.endDate, x = (d = a.props.selectingDate) !== null && d !== void 0 ? d : a.props.preSelection;
      return !(!(p || m || g) || !x) && (p && y ? st(x, y, l, u) : (m && v || !(!g || !v || y)) && st(v, x, l, u));
    }), ye(we(a), "isWeekInMonth", function(l) {
      var d = a.props.day, h = addDays(l, 6);
      return Qe(l, d) || Qe(h, d);
    }), ye(we(a), "isCurrentMonth", function(l, d) {
      return getYear(l) === getYear(Ye()) && d === getMonth(Ye());
    }), ye(we(a), "isCurrentQuarter", function(l, d) {
      return getYear(l) === getYear(Ye()) && d === getQuarter(Ye());
    }), ye(we(a), "isSelectedMonth", function(l, d, h) {
      return getMonth(h) === d && getYear(l) === getYear(h);
    }), ye(we(a), "isSelectedQuarter", function(l, d, h) {
      return getQuarter(l) === d && getYear(l) === getYear(h);
    }), ye(we(a), "renderWeeks", function() {
      for (var l = [], d = a.props.fixedHeight, h = 0, u = !1, p = Le(Fe(a.props.day), a.props.locale, a.props.calendarStartDay); l.push(/* @__PURE__ */ jsx$1(It, {
        ariaLabelPrefix: a.props.weekAriaLabelPrefix,
        chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
        day: p,
        month: getMonth(a.props.day),
        onDayClick: a.handleDayClick,
        onDayMouseEnter: a.handleDayMouseEnter,
        onWeekSelect: a.props.onWeekSelect,
        formatWeekNumber: a.props.formatWeekNumber,
        locale: a.props.locale,
        minDate: a.props.minDate,
        maxDate: a.props.maxDate,
        excludeDates: a.props.excludeDates,
        excludeDateIntervals: a.props.excludeDateIntervals,
        includeDates: a.props.includeDates,
        includeDateIntervals: a.props.includeDateIntervals,
        inline: a.props.inline,
        shouldFocusDayInline: a.props.shouldFocusDayInline,
        highlightDates: a.props.highlightDates,
        holidays: a.props.holidays,
        selectingDate: a.props.selectingDate,
        filterDate: a.props.filterDate,
        preSelection: a.props.preSelection,
        selected: a.props.selected,
        selectsStart: a.props.selectsStart,
        selectsEnd: a.props.selectsEnd,
        selectsRange: a.props.selectsRange,
        selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
        showWeekNumber: a.props.showWeekNumbers,
        showWeekPicker: a.props.showWeekPicker,
        startDate: a.props.startDate,
        endDate: a.props.endDate,
        dayClassName: a.props.dayClassName,
        setOpen: a.props.setOpen,
        shouldCloseOnSelect: a.props.shouldCloseOnSelect,
        disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
        renderDayContents: a.props.renderDayContents,
        handleOnKeyDown: a.props.handleOnKeyDown,
        isInputFocused: a.props.isInputFocused,
        containerRef: a.props.containerRef,
        calendarStartDay: a.props.calendarStartDay,
        monthShowsDuplicateDaysEnd: a.props.monthShowsDuplicateDaysEnd,
        monthShowsDuplicateDaysStart: a.props.monthShowsDuplicateDaysStart
      }, h)), !u; ) {
        h++, p = addWeeks(p, 1);
        var m = d && h >= 6, g = !d && !a.isWeekInMonth(p);
        if (m || g) {
          if (!a.props.peekNextMonth)
            break;
          u = !0;
        }
      }
      return l;
    }), ye(we(a), "onMonthClick", function(l, d) {
      a.handleDayClick(Fe(setMonth$1(a.props.day, d)), l);
    }), ye(we(a), "onMonthMouseEnter", function(l) {
      a.handleDayMouseEnter(Fe(setMonth$1(a.props.day, l)));
    }), ye(we(a), "handleMonthNavigation", function(l, d) {
      a.isDisabled(d) || a.isExcluded(d) || (a.props.setPreSelection(d), a.MONTH_REFS[l].current && a.MONTH_REFS[l].current.focus());
    }), ye(we(a), "onMonthKeyDown", function(l, d) {
      var h = a.props, u = h.selected, p = h.preSelection, m = h.disabledKeyboardNavigation, g = h.showTwoColumnMonthYearPicker, v = h.showFourColumnMonthYearPicker, y = h.setPreSelection, x = l.key;
      if (x !== "Tab" && l.preventDefault(), !m) {
        var _ = At(v, g), $ = Ft[_].verticalNavigationOffset, b = Ft[_].grid;
        switch (x) {
          case "Enter":
            a.onMonthClick(l, d), y(u);
            break;
          case "ArrowRight":
            a.handleMonthNavigation(d === 11 ? 0 : d + 1, addMonths(p, 1));
            break;
          case "ArrowLeft":
            a.handleMonthNavigation(d === 0 ? 11 : d - 1, subMonths(p, 1));
            break;
          case "ArrowUp":
            a.handleMonthNavigation(b[0].includes(d) ? d + 12 - $ : d - $, subMonths(p, $));
            break;
          case "ArrowDown":
            a.handleMonthNavigation(b[b.length - 1].includes(d) ? d - 12 + $ : d + $, addMonths(p, $));
        }
      }
    }), ye(we(a), "onQuarterClick", function(l, d) {
      a.handleDayClick(We(setQuarter(a.props.day, d)), l);
    }), ye(we(a), "onQuarterMouseEnter", function(l) {
      a.handleDayMouseEnter(We(setQuarter(a.props.day, l)));
    }), ye(we(a), "handleQuarterNavigation", function(l, d) {
      a.isDisabled(d) || a.isExcluded(d) || (a.props.setPreSelection(d), a.QUARTER_REFS[l - 1].current && a.QUARTER_REFS[l - 1].current.focus());
    }), ye(we(a), "onQuarterKeyDown", function(l, d) {
      var h = l.key;
      if (!a.props.disabledKeyboardNavigation)
        switch (h) {
          case "Enter":
            a.onQuarterClick(l, d), a.props.setPreSelection(a.props.selected);
            break;
          case "ArrowRight":
            a.handleQuarterNavigation(d === 4 ? 1 : d + 1, addQuarters(a.props.preSelection, 1));
            break;
          case "ArrowLeft":
            a.handleQuarterNavigation(d === 1 ? 4 : d - 1, subQuarters(a.props.preSelection, 1));
        }
    }), ye(we(a), "getMonthClassNames", function(l) {
      var d = a.props, h = d.day, u = d.startDate, p = d.endDate, m = d.selected, g = d.minDate, v = d.maxDate, y = d.preSelection, x = d.monthClassName, _ = d.excludeDates, $ = d.includeDates, b = x ? x(setMonth$1(h, l)) : void 0, M = setMonth$1(h, l);
      return classNames$1("react-datepicker__month-text", "react-datepicker__month-".concat(l), b, {
        "react-datepicker__month-text--disabled": (g || v || _ || $) && tt(M, a.props),
        "react-datepicker__month-text--selected": a.isSelectedMonth(h, l, m),
        "react-datepicker__month-text--keyboard-selected": !a.props.disabledKeyboardNavigation && getMonth(y) === l,
        "react-datepicker__month-text--in-selecting-range": a.isInSelectingRangeMonth(l),
        "react-datepicker__month-text--in-range": rt(u, p, l, h),
        "react-datepicker__month-text--range-start": a.isRangeStartMonth(l),
        "react-datepicker__month-text--range-end": a.isRangeEndMonth(l),
        "react-datepicker__month-text--selecting-range-start": a.isSelectingMonthRangeStart(l),
        "react-datepicker__month-text--selecting-range-end": a.isSelectingMonthRangeEnd(l),
        "react-datepicker__month-text--today": a.isCurrentMonth(h, l)
      });
    }), ye(we(a), "getTabIndex", function(l) {
      var d = getMonth(a.props.preSelection);
      return a.props.disabledKeyboardNavigation || l !== d ? "-1" : "0";
    }), ye(we(a), "getQuarterTabIndex", function(l) {
      var d = getQuarter(a.props.preSelection);
      return a.props.disabledKeyboardNavigation || l !== d ? "-1" : "0";
    }), ye(we(a), "getAriaLabel", function(l) {
      var d = a.props, h = d.chooseDayAriaLabelPrefix, u = h === void 0 ? "Choose" : h, p = d.disabledDayAriaLabelPrefix, m = p === void 0 ? "Not available" : p, g = d.day, v = setMonth$1(g, l), y = a.isDisabled(v) || a.isExcluded(v) ? m : u;
      return "".concat(y, " ").concat(Ie(v, "MMMM yyyy"));
    }), ye(we(a), "getQuarterClassNames", function(l) {
      var d = a.props, h = d.day, u = d.startDate, p = d.endDate, m = d.selected, g = d.minDate, v = d.maxDate, y = d.preSelection, x = d.disabledKeyboardNavigation;
      return classNames$1("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(l), {
        "react-datepicker__quarter-text--disabled": (g || v) && nt(setQuarter(h, l), a.props),
        "react-datepicker__quarter-text--selected": a.isSelectedQuarter(h, l, m),
        "react-datepicker__quarter-text--keyboard-selected": !x && getQuarter(y) === l,
        "react-datepicker__quarter-text--in-selecting-range": a.isInSelectingRangeQuarter(l),
        "react-datepicker__quarter-text--in-range": st(u, p, l, h),
        "react-datepicker__quarter-text--range-start": a.isRangeStartQuarter(l),
        "react-datepicker__quarter-text--range-end": a.isRangeEndQuarter(l)
      });
    }), ye(we(a), "getMonthContent", function(l) {
      var d = a.props, h = d.showFullMonthYearPicker, u = d.renderMonthContent, p = d.locale, m = d.day, g = Xe(l, p), v = Je(l, p);
      return u ? u(l, g, v, m) : h ? v : g;
    }), ye(we(a), "getQuarterContent", function(l) {
      var d = a.props, h = d.renderQuarterContent, u = function(p, m) {
        return Ie(setQuarter(Ye(), p), "QQQ", m);
      }(l, d.locale);
      return h ? h(l, u) : u;
    }), ye(we(a), "renderMonths", function() {
      var l = a.props, d = l.showTwoColumnMonthYearPicker, h = l.showFourColumnMonthYearPicker, u = l.day, p = l.selected;
      return Ft[At(h, d)].grid.map(function(m, g) {
        return /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__month-wrapper",
          children: m.map(function(v, y) {
            return /* @__PURE__ */ jsx$1("div", {
              ref: a.MONTH_REFS[v],
              onClick: function(x) {
                a.onMonthClick(x, v);
              },
              onKeyDown: function(x) {
                a.onMonthKeyDown(x, v);
              },
              onMouseEnter: function() {
                return a.onMonthMouseEnter(v);
              },
              tabIndex: a.getTabIndex(v),
              className: a.getMonthClassNames(v),
              role: "option",
              "aria-label": a.getAriaLabel(v),
              "aria-current": a.isCurrentMonth(u, v) ? "date" : void 0,
              "aria-selected": a.isSelectedMonth(u, v, p),
              children: a.getMonthContent(v)
            }, y);
          })
        }, g);
      });
    }), ye(we(a), "renderQuarters", function() {
      var l = a.props, d = l.day, h = l.selected;
      return /* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__quarter-wrapper",
        children: [1, 2, 3, 4].map(function(u, p) {
          return /* @__PURE__ */ jsx$1("div", {
            ref: a.QUARTER_REFS[p],
            role: "option",
            onClick: function(m) {
              a.onQuarterClick(m, u);
            },
            onKeyDown: function(m) {
              a.onQuarterKeyDown(m, u);
            },
            onMouseEnter: function() {
              return a.onQuarterMouseEnter(u);
            },
            className: a.getQuarterClassNames(u),
            "aria-selected": a.isSelectedQuarter(d, u, h),
            tabIndex: a.getQuarterTabIndex(u),
            "aria-current": a.isCurrentQuarter(d, u) ? "date" : void 0,
            children: a.getQuarterContent(u)
          }, p);
        })
      });
    }), ye(we(a), "getClassNames", function() {
      var l = a.props, d = l.selectingDate, h = l.selectsStart, u = l.selectsEnd, p = l.showMonthYearPicker, m = l.showQuarterYearPicker, g = l.showWeekPicker;
      return classNames$1("react-datepicker__month", {
        "react-datepicker__month--selecting-range": d && (h || u)
      }, {
        "react-datepicker__monthPicker": p
      }, {
        "react-datepicker__quarterPicker": m
      }, {
        "react-datepicker__weekPicker": g
      });
    }), a;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      var a = this.props, s = a.showMonthYearPicker, o = a.showQuarterYearPicker, c = a.day, l = a.ariaLabelPrefix, d = l === void 0 ? "month " : l;
      return /* @__PURE__ */ jsx$1("div", {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        "aria-label": "".concat(d, " ").concat(Ie(c, "yyyy-MM")),
        role: "listbox",
        children: s ? this.renderMonths() : o ? this.renderQuarters() : this.renderWeeks()
      });
    }
  }]), n;
}(), Kt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    var a;
    he(this, n);
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return ye(we(a = r.call.apply(r, [this].concat(o))), "state", {
      height: null
    }), ye(we(a), "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        a.list && (a.list.scrollTop = a.centerLi && n.calcCenterPosition(a.props.monthRef ? a.props.monthRef.clientHeight - a.header.clientHeight : a.list.clientHeight, a.centerLi));
      });
    }), ye(we(a), "handleClick", function(l) {
      (a.props.minTime || a.props.maxTime) && lt(l, a.props) || (a.props.excludeTimes || a.props.includeTimes || a.props.filterTime) && ct(l, a.props) || a.props.onChange(l);
    }), ye(we(a), "isSelectedTime", function(l) {
      return a.props.selected && (d = a.props.selected, h = l, bt(d).getTime() === bt(h).getTime());
      var d, h;
    }), ye(we(a), "isDisabledTime", function(l) {
      return (a.props.minTime || a.props.maxTime) && lt(l, a.props) || (a.props.excludeTimes || a.props.includeTimes || a.props.filterTime) && ct(l, a.props);
    }), ye(we(a), "liClasses", function(l) {
      var d = ["react-datepicker__time-list-item", a.props.timeClassName ? a.props.timeClassName(l) : void 0];
      return a.isSelectedTime(l) && d.push("react-datepicker__time-list-item--selected"), a.isDisabledTime(l) && d.push("react-datepicker__time-list-item--disabled"), a.props.injectTimes && (60 * getHours(l) + getMinutes(l)) % a.props.intervals != 0 && d.push("react-datepicker__time-list-item--injected"), d.join(" ");
    }), ye(we(a), "handleOnKeyDown", function(l, d) {
      l.key === " " && (l.preventDefault(), l.key = "Enter"), l.key !== "ArrowUp" && l.key !== "ArrowLeft" || !l.target.previousSibling || (l.preventDefault(), l.target.previousSibling.focus()), l.key !== "ArrowDown" && l.key !== "ArrowRight" || !l.target.nextSibling || (l.preventDefault(), l.target.nextSibling.focus()), l.key === "Enter" && a.handleClick(d), a.props.handleOnKeyDown(l);
    }), ye(we(a), "renderTimes", function() {
      for (var l = [], d = a.props.format ? a.props.format : "p", h = a.props.intervals, u = a.props.selected || a.props.openToDate || Ye(), p = startOfDay(u), m = a.props.injectTimes && a.props.injectTimes.sort(function(b, M) {
        return b - M;
      }), g = 60 * function(b) {
        var M = new Date(b.getFullYear(), b.getMonth(), b.getDate()), C = new Date(b.getFullYear(), b.getMonth(), b.getDate(), 24);
        return Math.round((+C - +M) / 36e5);
      }(u), v = g / h, y = 0; y < v; y++) {
        var x = addMinutes(p, y * h);
        if (l.push(x), m) {
          var _ = gt(p, x, y, h, m);
          l = l.concat(_);
        }
      }
      var $ = l.reduce(function(b, M) {
        return M.getTime() <= u.getTime() ? M : b;
      }, l[0]);
      return l.map(function(b, M) {
        return /* @__PURE__ */ jsx$1("li", {
          onClick: a.handleClick.bind(we(a), b),
          className: a.liClasses(b),
          ref: function(C) {
            b === $ && (a.centerLi = C);
          },
          onKeyDown: function(C) {
            a.handleOnKeyDown(C, b);
          },
          tabIndex: b === $ ? 0 : -1,
          role: "option",
          "aria-selected": a.isSelectedTime(b) ? "true" : void 0,
          "aria-disabled": a.isDisabledTime(b) ? "true" : void 0,
          children: Ie(b, d, a.props.locale)
        }, M);
      });
    }), a;
  }
  return fe(n, [{
    key: "componentDidMount",
    value: function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }
  }, {
    key: "render",
    value: function() {
      var a = this, s = this.state.height;
      return /* @__PURE__ */ jsxs("div", {
        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : ""),
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
          ref: function(o) {
            a.header = o;
          },
          children: /* @__PURE__ */ jsx$1("div", {
            className: "react-datepicker-time__header",
            children: this.props.timeCaption
          })
        }), /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__time",
          children: /* @__PURE__ */ jsx$1("div", {
            className: "react-datepicker__time-box",
            children: /* @__PURE__ */ jsx$1("ul", {
              className: "react-datepicker__time-list",
              ref: function(o) {
                a.list = o;
              },
              style: s ? {
                height: s
              } : {},
              role: "listbox",
              "aria-label": this.props.timeCaption,
              children: this.renderTimes()
            })
          })
        })]
      });
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        intervals: 30,
        onTimeChange: function() {
        },
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]), n;
}();
ye(Kt, "calcCenterPosition", function(t, r) {
  return r.offsetTop - (t / 2 - r.clientHeight / 2);
});
var Bt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    return he(this, n), ye(we(s = r.call(this, a)), "YEAR_REFS", Se(Array(s.props.yearItemNumber)).map(function() {
      return React__default.createRef();
    })), ye(we(s), "isDisabled", function(o) {
      return Ze(o, s.props);
    }), ye(we(s), "isExcluded", function(o) {
      return et(o, s.props);
    }), ye(we(s), "selectingDate", function() {
      var o;
      return (o = s.props.selectingDate) !== null && o !== void 0 ? o : s.props.preSelection;
    }), ye(we(s), "updateFocusOnPaginate", function(o) {
      var c = (function() {
        this.YEAR_REFS[o].current.focus();
      }).bind(we(s));
      window.requestAnimationFrame(c);
    }), ye(we(s), "handleYearClick", function(o, c) {
      s.props.onDayClick && s.props.onDayClick(o, c);
    }), ye(we(s), "handleYearNavigation", function(o, c) {
      var l = s.props, d = l.date, h = l.yearItemNumber, u = wt(d, h).startPeriod;
      s.isDisabled(c) || s.isExcluded(c) || (s.props.setPreSelection(c), o - u == -1 ? s.updateFocusOnPaginate(h - 1) : o - u === h ? s.updateFocusOnPaginate(0) : s.YEAR_REFS[o - u].current.focus());
    }), ye(we(s), "isSameDay", function(o, c) {
      return je(o, c);
    }), ye(we(s), "isCurrentYear", function(o) {
      return o === getYear(Ye());
    }), ye(we(s), "isRangeStart", function(o) {
      return s.props.startDate && s.props.endDate && Be(setYear(Ye(), o), s.props.startDate);
    }), ye(we(s), "isRangeEnd", function(o) {
      return s.props.startDate && s.props.endDate && Be(setYear(Ye(), o), s.props.endDate);
    }), ye(we(s), "isInRange", function(o) {
      return ot(o, s.props.startDate, s.props.endDate);
    }), ye(we(s), "isInSelectingRange", function(o) {
      var c = s.props, l = c.selectsStart, d = c.selectsEnd, h = c.selectsRange, u = c.startDate, p = c.endDate;
      return !(!(l || d || h) || !s.selectingDate()) && (l && p ? ot(o, s.selectingDate(), p) : (d && u || !(!h || !u || p)) && ot(o, u, s.selectingDate()));
    }), ye(we(s), "isSelectingRangeStart", function(o) {
      if (!s.isInSelectingRange(o))
        return !1;
      var c = s.props, l = c.startDate, d = c.selectsStart, h = setYear(Ye(), o);
      return Be(h, d ? s.selectingDate() : l);
    }), ye(we(s), "isSelectingRangeEnd", function(o) {
      if (!s.isInSelectingRange(o))
        return !1;
      var c = s.props, l = c.endDate, d = c.selectsEnd, h = c.selectsRange, u = setYear(Ye(), o);
      return Be(u, d || h ? s.selectingDate() : l);
    }), ye(we(s), "isKeyboardSelected", function(o) {
      var c = Ae(setYear(s.props.date, o));
      return !s.props.disabledKeyboardNavigation && !s.props.inline && !je(c, Ae(s.props.selected)) && je(c, Ae(s.props.preSelection));
    }), ye(we(s), "onYearClick", function(o, c) {
      var l = s.props.date;
      s.handleYearClick(Ae(setYear(l, c)), o);
    }), ye(we(s), "onYearKeyDown", function(o, c) {
      var l = o.key;
      if (!s.props.disabledKeyboardNavigation)
        switch (l) {
          case "Enter":
            s.onYearClick(o, c), s.props.setPreSelection(s.props.selected);
            break;
          case "ArrowRight":
            s.handleYearNavigation(c + 1, addYears(s.props.preSelection, 1));
            break;
          case "ArrowLeft":
            s.handleYearNavigation(c - 1, subYears(s.props.preSelection, 1));
        }
    }), ye(we(s), "getYearClassNames", function(o) {
      var c = s.props, l = c.minDate, d = c.maxDate, h = c.selected, u = c.excludeDates, p = c.includeDates, m = c.filterDate;
      return classNames$1("react-datepicker__year-text", {
        "react-datepicker__year-text--selected": o === getYear(h),
        "react-datepicker__year-text--disabled": (l || d || u || p || m) && at(o, s.props),
        "react-datepicker__year-text--keyboard-selected": s.isKeyboardSelected(o),
        "react-datepicker__year-text--range-start": s.isRangeStart(o),
        "react-datepicker__year-text--range-end": s.isRangeEnd(o),
        "react-datepicker__year-text--in-range": s.isInRange(o),
        "react-datepicker__year-text--in-selecting-range": s.isInSelectingRange(o),
        "react-datepicker__year-text--selecting-range-start": s.isSelectingRangeStart(o),
        "react-datepicker__year-text--selecting-range-end": s.isSelectingRangeEnd(o),
        "react-datepicker__year-text--today": s.isCurrentYear(o)
      });
    }), ye(we(s), "getYearTabIndex", function(o) {
      return s.props.disabledKeyboardNavigation ? "-1" : o === getYear(s.props.preSelection) ? "0" : "-1";
    }), ye(we(s), "getYearContainerClassNames", function() {
      var o = s.props, c = o.selectingDate, l = o.selectsStart, d = o.selectsEnd, h = o.selectsRange;
      return classNames$1("react-datepicker__year", {
        "react-datepicker__year--selecting-range": c && (l || d || h)
      });
    }), ye(we(s), "getYearContent", function(o) {
      return s.props.renderYearContent ? s.props.renderYearContent(o) : o;
    }), s;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      for (var a = this, s = [], o = this.props, c = o.date, l = o.yearItemNumber, d = o.onYearMouseEnter, h = o.onYearMouseLeave, u = wt(c, l), p = u.startPeriod, m = u.endPeriod, g = function(y) {
        s.push(/* @__PURE__ */ jsx$1("div", {
          ref: a.YEAR_REFS[y - p],
          onClick: function(x) {
            a.onYearClick(x, y);
          },
          onKeyDown: function(x) {
            a.onYearKeyDown(x, y);
          },
          tabIndex: a.getYearTabIndex(y),
          className: a.getYearClassNames(y),
          onMouseEnter: function(x) {
            return d(x, y);
          },
          onMouseLeave: function(x) {
            return h(x, y);
          },
          "aria-current": a.isCurrentYear(y) ? "date" : void 0,
          children: a.getYearContent(y)
        }, y));
      }, v = p; v <= m; v++)
        g(v);
      return /* @__PURE__ */ jsx$1("div", {
        className: this.getYearContainerClassNames(),
        children: /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__year-wrapper",
          onMouseLeave: this.props.clearSelectingDate,
          children: s
        })
      });
    }
  }]), n;
}(), Qt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    return he(this, n), ye(we(s = r.call(this, a)), "onTimeChange", function(o) {
      s.setState({
        time: o
      });
      var c = s.props.date, l = c instanceof Date && !isNaN(c) ? c : /* @__PURE__ */ new Date();
      l.setHours(o.split(":")[0]), l.setMinutes(o.split(":")[1]), s.props.onChange(l);
    }), ye(we(s), "renderTimeInput", function() {
      var o = s.state.time, c = s.props, l = c.date, d = c.timeString, h = c.customTimeInput;
      return h ? React__default.cloneElement(h, {
        date: l,
        value: o,
        onChange: s.onTimeChange
      }) : /* @__PURE__ */ jsx$1("input", {
        type: "time",
        className: "react-datepicker-time__input",
        placeholder: "Time",
        name: "time-input",
        required: !0,
        value: o,
        onChange: function(u) {
          s.onTimeChange(u.target.value || d);
        }
      });
    }), s.state = {
      time: s.props.timeString
    }, s;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ jsxs("div", {
        className: "react-datepicker__input-time-container",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker-time__caption",
          children: this.props.timeInputLabel
        }), /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker-time__input-container",
          children: /* @__PURE__ */ jsx$1("div", {
            className: "react-datepicker-time__input",
            children: this.renderTimeInput()
          })
        })]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, s) {
      return a.timeString !== s.time ? {
        time: a.timeString
      } : null;
    }
  }]), n;
}();
function Ht(t) {
  var r = t.className, n = t.children, a = t.showPopperArrow, s = t.arrowProps, o = s === void 0 ? {} : s;
  return /* @__PURE__ */ jsxs("div", {
    className: r,
    children: [a && /* @__PURE__ */ jsx$1("div", {
      ...ve({
        className: "react-datepicker__triangle"
      }, o)
    }), n]
  });
}
var jt = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], Vt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    return he(this, n), ye(we(s = r.call(this, a)), "handleClickOutside", function(o) {
      s.props.onClickOutside(o);
    }), ye(we(s), "setClickOutsideRef", function() {
      return s.containerRef.current;
    }), ye(we(s), "handleDropdownFocus", function(o) {
      (function() {
        var c = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return jt.some(function(l) {
          return c.indexOf(l) >= 0;
        });
      })(o.target) && s.props.onDropdownFocus();
    }), ye(we(s), "getDateInView", function() {
      var o = s.props, c = o.preSelection, l = o.selected, d = o.openToDate, h = ft(s.props), u = yt(s.props), p = Ye(), m = d || l || c;
      return m || (h && isBefore$1(p, h) ? h : u && isAfter$1(p, u) ? u : p);
    }), ye(we(s), "increaseMonth", function() {
      s.setState(function(o) {
        var c = o.date;
        return {
          date: addMonths(c, 1)
        };
      }, function() {
        return s.handleMonthChange(s.state.date);
      });
    }), ye(we(s), "decreaseMonth", function() {
      s.setState(function(o) {
        var c = o.date;
        return {
          date: subMonths(c, 1)
        };
      }, function() {
        return s.handleMonthChange(s.state.date);
      });
    }), ye(we(s), "handleDayClick", function(o, c, l) {
      s.props.onSelect(o, c, l), s.props.setPreSelection && s.props.setPreSelection(o);
    }), ye(we(s), "handleDayMouseEnter", function(o) {
      s.setState({
        selectingDate: o
      }), s.props.onDayMouseEnter && s.props.onDayMouseEnter(o);
    }), ye(we(s), "handleMonthMouseLeave", function() {
      s.setState({
        selectingDate: null
      }), s.props.onMonthMouseLeave && s.props.onMonthMouseLeave();
    }), ye(we(s), "handleYearMouseEnter", function(o, c) {
      s.setState({
        selectingDate: setYear(Ye(), c)
      }), s.props.onYearMouseEnter && s.props.onYearMouseEnter(o, c);
    }), ye(we(s), "handleYearMouseLeave", function(o, c) {
      s.props.onYearMouseLeave && s.props.onYearMouseLeave(o, c);
    }), ye(we(s), "handleYearChange", function(o) {
      s.props.onYearChange && (s.props.onYearChange(o), s.setState({
        isRenderAriaLiveMessage: !0
      })), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(o), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(o);
    }), ye(we(s), "handleMonthChange", function(o) {
      s.handleCustomMonthChange(o), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(o), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(o);
    }), ye(we(s), "handleCustomMonthChange", function(o) {
      s.props.onMonthChange && (s.props.onMonthChange(o), s.setState({
        isRenderAriaLiveMessage: !0
      }));
    }), ye(we(s), "handleMonthYearChange", function(o) {
      s.handleYearChange(o), s.handleMonthChange(o);
    }), ye(we(s), "changeYear", function(o) {
      s.setState(function(c) {
        var l = c.date;
        return {
          date: setYear(l, o)
        };
      }, function() {
        return s.handleYearChange(s.state.date);
      });
    }), ye(we(s), "changeMonth", function(o) {
      s.setState(function(c) {
        var l = c.date;
        return {
          date: setMonth$1(l, o)
        };
      }, function() {
        return s.handleMonthChange(s.state.date);
      });
    }), ye(we(s), "changeMonthYear", function(o) {
      s.setState(function(c) {
        var l = c.date;
        return {
          date: setYear(setMonth$1(l, getMonth(o)), getYear(o))
        };
      }, function() {
        return s.handleMonthYearChange(s.state.date);
      });
    }), ye(we(s), "header", function() {
      var o = Le(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s.state.date, s.props.locale, s.props.calendarStartDay), c = [];
      return s.props.showWeekNumbers && c.push(/* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__day-name",
        children: s.props.weekLabel || "#"
      }, "W")), c.concat([0, 1, 2, 3, 4, 5, 6].map(function(l) {
        var d = addDays(o, l), h = s.formatWeekday(d, s.props.locale), u = s.props.weekDayClassName ? s.props.weekDayClassName(d) : void 0;
        return /* @__PURE__ */ jsx$1("div", {
          className: classNames$1("react-datepicker__day-name", u),
          children: h
        }, l);
      }));
    }), ye(we(s), "formatWeekday", function(o, c) {
      return s.props.formatWeekDay ? function(l, d, h) {
        return d(Ie(l, "EEEE", h));
      }(o, s.props.formatWeekDay, c) : s.props.useWeekdaysShort ? function(l, d) {
        return Ie(l, "EEE", d);
      }(o, c) : function(l, d) {
        return Ie(l, "EEEEEE", d);
      }(o, c);
    }), ye(we(s), "decreaseYear", function() {
      s.setState(function(o) {
        var c = o.date;
        return {
          date: subYears(c, s.props.showYearPicker ? s.props.yearItemNumber : 1)
        };
      }, function() {
        return s.handleYearChange(s.state.date);
      });
    }), ye(we(s), "clearSelectingDate", function() {
      s.setState({
        selectingDate: null
      });
    }), ye(we(s), "renderPreviousButton", function() {
      if (!s.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case s.props.showMonthYearPicker:
            o = ht(s.state.date, s.props);
            break;
          case s.props.showYearPicker:
            o = function(_) {
              var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = $.minDate, M = $.yearItemNumber, C = M === void 0 ? Ne : M, S = wt(Ae(subYears(_, C)), C).endPeriod, A = b && getYear(b);
              return A && A > S || !1;
            }(s.state.date, s.props);
            break;
          default:
            o = dt(s.state.date, s.props);
        }
        if ((s.props.forceShowMonthNavigation || s.props.showDisabledMonthNavigation || !o) && !s.props.showTimeSelectOnly) {
          var c = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], l = s.decreaseMonth;
          (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (l = s.decreaseYear), o && s.props.showDisabledMonthNavigation && (c.push("react-datepicker__navigation--previous--disabled"), l = null);
          var d = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, h = s.props, u = h.previousMonthButtonLabel, p = h.previousYearButtonLabel, m = s.props, g = m.previousMonthAriaLabel, v = g === void 0 ? typeof u == "string" ? u : "Previous Month" : g, y = m.previousYearAriaLabel, x = y === void 0 ? typeof p == "string" ? p : "Previous Year" : y;
          return /* @__PURE__ */ jsx$1("button", {
            type: "button",
            className: c.join(" "),
            onClick: l,
            onKeyDown: s.props.handleOnKeyDown,
            "aria-label": d ? x : v,
            children: /* @__PURE__ */ jsx$1("span", {
              className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" "),
              children: d ? s.props.previousYearButtonLabel : s.props.previousMonthButtonLabel
            })
          });
        }
      }
    }), ye(we(s), "increaseYear", function() {
      s.setState(function(o) {
        var c = o.date;
        return {
          date: addYears(c, s.props.showYearPicker ? s.props.yearItemNumber : 1)
        };
      }, function() {
        return s.handleYearChange(s.state.date);
      });
    }), ye(we(s), "renderNextButton", function() {
      if (!s.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case s.props.showMonthYearPicker:
            o = mt(s.state.date, s.props);
            break;
          case s.props.showYearPicker:
            o = function(_) {
              var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = $.maxDate, M = $.yearItemNumber, C = M === void 0 ? Ne : M, S = wt(addYears(_, C), C).startPeriod, A = b && getYear(b);
              return A && A < S || !1;
            }(s.state.date, s.props);
            break;
          default:
            o = ut(s.state.date, s.props);
        }
        if ((s.props.forceShowMonthNavigation || s.props.showDisabledMonthNavigation || !o) && !s.props.showTimeSelectOnly) {
          var c = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          s.props.showTimeSelect && c.push("react-datepicker__navigation--next--with-time"), s.props.todayButton && c.push("react-datepicker__navigation--next--with-today-button");
          var l = s.increaseMonth;
          (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (l = s.increaseYear), o && s.props.showDisabledMonthNavigation && (c.push("react-datepicker__navigation--next--disabled"), l = null);
          var d = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, h = s.props, u = h.nextMonthButtonLabel, p = h.nextYearButtonLabel, m = s.props, g = m.nextMonthAriaLabel, v = g === void 0 ? typeof u == "string" ? u : "Next Month" : g, y = m.nextYearAriaLabel, x = y === void 0 ? typeof p == "string" ? p : "Next Year" : y;
          return /* @__PURE__ */ jsx$1("button", {
            type: "button",
            className: c.join(" "),
            onClick: l,
            onKeyDown: s.props.handleOnKeyDown,
            "aria-label": d ? x : v,
            children: /* @__PURE__ */ jsx$1("span", {
              className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" "),
              children: d ? s.props.nextYearButtonLabel : s.props.nextMonthButtonLabel
            })
          });
        }
      }
    }), ye(we(s), "renderCurrentMonth", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s.state.date, c = ["react-datepicker__current-month"];
      return s.props.showYearDropdown && c.push("react-datepicker__current-month--hasYearDropdown"), s.props.showMonthDropdown && c.push("react-datepicker__current-month--hasMonthDropdown"), s.props.showMonthYearDropdown && c.push("react-datepicker__current-month--hasMonthYearDropdown"), /* @__PURE__ */ jsx$1("div", {
        className: c.join(" "),
        children: Ie(o, s.props.dateFormat, s.props.locale)
      });
    }), ye(we(s), "renderYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (s.props.showYearDropdown && !o)
        return React__default.createElement(_t, {
          adjustDateOnChange: s.props.adjustDateOnChange,
          date: s.state.date,
          onSelect: s.props.onSelect,
          setOpen: s.props.setOpen,
          dropdownMode: s.props.dropdownMode,
          onChange: s.changeYear,
          minDate: s.props.minDate,
          maxDate: s.props.maxDate,
          year: getYear(s.state.date),
          scrollableYearDropdown: s.props.scrollableYearDropdown,
          yearDropdownItemNumber: s.props.yearDropdownItemNumber
        });
    }), ye(we(s), "renderMonthDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (s.props.showMonthDropdown && !o)
        return /* @__PURE__ */ jsx$1(Pt, {
          dropdownMode: s.props.dropdownMode,
          locale: s.props.locale,
          onChange: s.changeMonth,
          month: getMonth(s.state.date),
          useShortMonthInDropdown: s.props.useShortMonthInDropdown
        });
    }), ye(we(s), "renderMonthYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (s.props.showMonthYearDropdown && !o)
        return React__default.createElement(xt, {
          dropdownMode: s.props.dropdownMode,
          locale: s.props.locale,
          dateFormat: s.props.dateFormat,
          onChange: s.changeMonthYear,
          minDate: s.props.minDate,
          maxDate: s.props.maxDate,
          date: s.state.date,
          scrollableMonthYearDropdown: s.props.scrollableMonthYearDropdown
        });
    }), ye(we(s), "handleTodayButtonClick", function(o) {
      s.props.onSelect(Ke(), o), s.props.setPreSelection && s.props.setPreSelection(Ke());
    }), ye(we(s), "renderTodayButton", function() {
      if (s.props.todayButton && !s.props.showTimeSelectOnly)
        return /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__today-button",
          onClick: function(o) {
            return s.handleTodayButtonClick(o);
          },
          children: s.props.todayButton
        });
    }), ye(we(s), "renderDefaultHeader", function(o) {
      var c = o.monthDate, l = o.i;
      return /* @__PURE__ */ jsxs("div", {
        className: "react-datepicker__header ".concat(s.props.showTimeSelect ? "react-datepicker__header--has-time-select" : ""),
        children: [s.renderCurrentMonth(c), /* @__PURE__ */ jsxs("div", {
          className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(s.props.dropdownMode),
          onFocus: s.handleDropdownFocus,
          children: [s.renderMonthDropdown(l !== 0), s.renderMonthYearDropdown(l !== 0), s.renderYearDropdown(l !== 0)]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__day-names",
          children: s.header(c)
        })]
      });
    }), ye(we(s), "renderCustomHeader", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = o.monthDate, l = o.i;
      if (s.props.showTimeSelect && !s.state.monthContainer || s.props.showTimeSelectOnly)
        return null;
      var d = dt(s.state.date, s.props), h = ut(s.state.date, s.props), u = ht(s.state.date, s.props), p = mt(s.state.date, s.props), m = !s.props.showMonthYearPicker && !s.props.showQuarterYearPicker && !s.props.showYearPicker;
      return /* @__PURE__ */ jsxs("div", {
        className: "react-datepicker__header react-datepicker__header--custom",
        onFocus: s.props.onDropdownFocus,
        children: [s.props.renderCustomHeader(de(de({}, s.state), {}, {
          customHeaderCount: l,
          monthDate: c,
          changeMonth: s.changeMonth,
          changeYear: s.changeYear,
          decreaseMonth: s.decreaseMonth,
          increaseMonth: s.increaseMonth,
          decreaseYear: s.decreaseYear,
          increaseYear: s.increaseYear,
          prevMonthButtonDisabled: d,
          nextMonthButtonDisabled: h,
          prevYearButtonDisabled: u,
          nextYearButtonDisabled: p
        })), m && /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__day-names",
          children: s.header(c)
        })]
      });
    }), ye(we(s), "renderYearHeader", function() {
      var o = s.state.date, c = s.props, l = c.showYearPicker, d = wt(o, c.yearItemNumber), h = d.startPeriod, u = d.endPeriod;
      return /* @__PURE__ */ jsx$1("div", {
        className: "react-datepicker__header react-datepicker-year-header",
        children: l ? "".concat(h, " - ").concat(u) : getYear(o)
      });
    }), ye(we(s), "renderHeader", function(o) {
      switch (!0) {
        case s.props.renderCustomHeader !== void 0:
          return s.renderCustomHeader(o);
        case (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker):
          return s.renderYearHeader(o);
        default:
          return s.renderDefaultHeader(o);
      }
    }), ye(we(s), "renderMonths", function() {
      var o;
      if (!s.props.showTimeSelectOnly && !s.props.showYearPicker) {
        for (var c = [], l = s.props.showPreviousMonths ? s.props.monthsShown - 1 : 0, d = subMonths(s.state.date, l), h = (o = s.props.monthSelectedIn) !== null && o !== void 0 ? o : l, u = 0; u < s.props.monthsShown; ++u) {
          var p = addMonths(d, u - h + l), m = "month-".concat(u), g = u < s.props.monthsShown - 1, v = u > 0;
          c.push(/* @__PURE__ */ jsxs("div", {
            ref: function(y) {
              s.monthContainer = y;
            },
            className: "react-datepicker__month-container",
            children: [s.renderHeader({
              monthDate: p,
              i: u
            }), /* @__PURE__ */ jsx$1(Wt, {
              chooseDayAriaLabelPrefix: s.props.chooseDayAriaLabelPrefix,
              disabledDayAriaLabelPrefix: s.props.disabledDayAriaLabelPrefix,
              weekAriaLabelPrefix: s.props.weekAriaLabelPrefix,
              ariaLabelPrefix: s.props.monthAriaLabelPrefix,
              onChange: s.changeMonthYear,
              day: p,
              dayClassName: s.props.dayClassName,
              calendarStartDay: s.props.calendarStartDay,
              monthClassName: s.props.monthClassName,
              onDayClick: s.handleDayClick,
              handleOnKeyDown: s.props.handleOnDayKeyDown,
              onDayMouseEnter: s.handleDayMouseEnter,
              onMouseLeave: s.handleMonthMouseLeave,
              onWeekSelect: s.props.onWeekSelect,
              orderInDisplay: u,
              formatWeekNumber: s.props.formatWeekNumber,
              locale: s.props.locale,
              minDate: s.props.minDate,
              maxDate: s.props.maxDate,
              excludeDates: s.props.excludeDates,
              excludeDateIntervals: s.props.excludeDateIntervals,
              highlightDates: s.props.highlightDates,
              holidays: s.props.holidays,
              selectingDate: s.state.selectingDate,
              includeDates: s.props.includeDates,
              includeDateIntervals: s.props.includeDateIntervals,
              inline: s.props.inline,
              shouldFocusDayInline: s.props.shouldFocusDayInline,
              fixedHeight: s.props.fixedHeight,
              filterDate: s.props.filterDate,
              preSelection: s.props.preSelection,
              setPreSelection: s.props.setPreSelection,
              selected: s.props.selected,
              selectsStart: s.props.selectsStart,
              selectsEnd: s.props.selectsEnd,
              selectsRange: s.props.selectsRange,
              selectsDisabledDaysInRange: s.props.selectsDisabledDaysInRange,
              showWeekNumbers: s.props.showWeekNumbers,
              startDate: s.props.startDate,
              endDate: s.props.endDate,
              peekNextMonth: s.props.peekNextMonth,
              setOpen: s.props.setOpen,
              shouldCloseOnSelect: s.props.shouldCloseOnSelect,
              renderDayContents: s.props.renderDayContents,
              renderMonthContent: s.props.renderMonthContent,
              renderQuarterContent: s.props.renderQuarterContent,
              renderYearContent: s.props.renderYearContent,
              disabledKeyboardNavigation: s.props.disabledKeyboardNavigation,
              showMonthYearPicker: s.props.showMonthYearPicker,
              showFullMonthYearPicker: s.props.showFullMonthYearPicker,
              showTwoColumnMonthYearPicker: s.props.showTwoColumnMonthYearPicker,
              showFourColumnMonthYearPicker: s.props.showFourColumnMonthYearPicker,
              showYearPicker: s.props.showYearPicker,
              showQuarterYearPicker: s.props.showQuarterYearPicker,
              showWeekPicker: s.props.showWeekPicker,
              isInputFocused: s.props.isInputFocused,
              containerRef: s.containerRef,
              monthShowsDuplicateDaysEnd: g,
              monthShowsDuplicateDaysStart: v
            })]
          }, m));
        }
        return c;
      }
    }), ye(we(s), "renderYears", function() {
      if (!s.props.showTimeSelectOnly)
        return s.props.showYearPicker ? /* @__PURE__ */ jsxs("div", {
          className: "react-datepicker__year--container",
          children: [s.renderHeader(), /* @__PURE__ */ jsx$1(Bt, {
            ...ve({
              onDayClick: s.handleDayClick,
              selectingDate: s.state.selectingDate,
              clearSelectingDate: s.clearSelectingDate,
              date: s.state.date
            }, s.props, {
              onYearMouseEnter: s.handleYearMouseEnter,
              onYearMouseLeave: s.handleYearMouseLeave
            })
          })]
        }) : void 0;
    }), ye(we(s), "renderTimeSection", function() {
      if (s.props.showTimeSelect && (s.state.monthContainer || s.props.showTimeSelectOnly))
        return /* @__PURE__ */ jsx$1(Kt, {
          selected: s.props.selected,
          openToDate: s.props.openToDate,
          onChange: s.props.onTimeChange,
          timeClassName: s.props.timeClassName,
          format: s.props.timeFormat,
          includeTimes: s.props.includeTimes,
          intervals: s.props.timeIntervals,
          minTime: s.props.minTime,
          maxTime: s.props.maxTime,
          excludeTimes: s.props.excludeTimes,
          filterTime: s.props.filterTime,
          timeCaption: s.props.timeCaption,
          todayButton: s.props.todayButton,
          showMonthDropdown: s.props.showMonthDropdown,
          showMonthYearDropdown: s.props.showMonthYearDropdown,
          showYearDropdown: s.props.showYearDropdown,
          withPortal: s.props.withPortal,
          monthRef: s.state.monthContainer,
          injectTimes: s.props.injectTimes,
          locale: s.props.locale,
          handleOnKeyDown: s.props.handleOnKeyDown,
          showTimeSelectOnly: s.props.showTimeSelectOnly
        });
    }), ye(we(s), "renderInputTimeSection", function() {
      var o = new Date(s.props.selected), c = Te(o) && s.props.selected ? "".concat(kt(o.getHours()), ":").concat(kt(o.getMinutes())) : "";
      if (s.props.showTimeInput)
        return /* @__PURE__ */ jsx$1(Qt, {
          date: o,
          timeString: c,
          timeInputLabel: s.props.timeInputLabel,
          onChange: s.props.onTimeChange,
          customTimeInput: s.props.customTimeInput
        });
    }), ye(we(s), "renderAriaLiveRegion", function() {
      var o, c = wt(s.state.date, s.props.yearItemNumber), l = c.startPeriod, d = c.endPeriod;
      return o = s.props.showYearPicker ? "".concat(l, " - ").concat(d) : s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? getYear(s.state.date) : "".concat(Je(getMonth(s.state.date), s.props.locale), " ").concat(getYear(s.state.date)), /* @__PURE__ */ jsx$1("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live",
        children: s.state.isRenderAriaLiveMessage && o
      });
    }), ye(we(s), "renderChildren", function() {
      if (s.props.children)
        return /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__children-container",
          children: s.props.children
        });
    }), s.containerRef = React__default.createRef(), s.state = {
      date: s.getDateInView(),
      selectingDate: null,
      monthContainer: null,
      isRenderAriaLiveMessage: !1
    }, s;
  }
  return fe(n, [{
    key: "componentDidMount",
    value: function() {
      var a = this;
      this.props.showTimeSelect && (this.assignMonthContainer = void a.setState({
        monthContainer: a.monthContainer
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var s = this;
      if (!this.props.preSelection || je(this.props.preSelection, a.preSelection) && this.props.monthSelectedIn === a.monthSelectedIn)
        this.props.openToDate && !je(this.props.openToDate, a.openToDate) && this.setState({
          date: this.props.openToDate
        });
      else {
        var o = !Qe(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return o && s.handleCustomMonthChange(s.state.date);
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props.container || Ht;
      return React__default.createElement("div", {
        style: {
          display: "contents"
        },
        ref: this.containerRef
      }, React__default.createElement(a, {
        className: classNames$1("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        }),
        showPopperArrow: this.props.showPopperArrow,
        arrowProps: this.props.arrowProps
      }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        onDropdownFocus: function() {
        },
        monthsShown: 1,
        forceShowMonthNavigation: !1,
        timeCaption: "Time",
        previousYearButtonLabel: "Previous Year",
        nextYearButtonLabel: "Next Year",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month",
        customTimeInput: null,
        yearItemNumber: Ne
      };
    }
  }]), n;
}(), qt = function(t) {
  var r = t.icon, n = t.className, a = n === void 0 ? "" : n, s = t.onClick, o = "react-datepicker__calendar-icon";
  return React__default.isValidElement(r) ? React__default.cloneElement(r, {
    className: "".concat(r.props.className || "", " ").concat(o, " ").concat(a),
    onClick: function(c) {
      typeof r.props.onClick == "function" && r.props.onClick(c), typeof s == "function" && s(c);
    }
  }) : typeof r == "string" ? /* @__PURE__ */ jsx$1("i", {
    className: "".concat(o, " ").concat(r, " ").concat(a),
    "aria-hidden": "true",
    onClick: s
  }) : /* @__PURE__ */ jsx$1("svg", {
    className: "".concat(o, " ").concat(a),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    onClick: s,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    })
  });
}, Ut = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    return he(this, n), (s = r.call(this, a)).el = document.createElement("div"), s;
  }
  return fe(n, [{
    key: "componentDidMount",
    value: function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.portalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function() {
      return ReactDOM__default.createPortal(this.props.children, this.el);
    }
  }]), n;
}(), zt = function(t) {
  return !t.disabled && t.tabIndex !== -1;
}, $t = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    return he(this, n), ye(we(s = r.call(this, a)), "getTabChildren", function() {
      return Array.prototype.slice.call(s.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(zt);
    }), ye(we(s), "handleFocusStart", function() {
      var o = s.getTabChildren();
      o && o.length > 1 && o[o.length - 1].focus();
    }), ye(we(s), "handleFocusEnd", function() {
      var o = s.getTabChildren();
      o && o.length > 1 && o[0].focus();
    }), s.tabLoopRef = React__default.createRef(), s;
  }
  return fe(n, [{
    key: "render",
    value: function() {
      return this.props.enableTabLoop ? /* @__PURE__ */ jsxs("div", {
        className: "react-datepicker__tab-loop",
        ref: this.tabLoopRef,
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__tab-loop__start",
          tabIndex: "0",
          onFocus: this.handleFocusStart
        }), this.props.children, /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__tab-loop__end",
          tabIndex: "0",
          onFocus: this.handleFocusEnd
        })]
      }) : this.props.children;
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        enableTabLoop: !0
      };
    }
  }]), n;
}(), Gt = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n() {
    return he(this, n), r.apply(this, arguments);
  }
  return fe(n, [{
    key: "render",
    value: function() {
      var a, s = this.props, o = s.className, c = s.wrapperClassName, l = s.hidePopper, d = s.popperComponent, h = s.popperModifiers, u = s.popperPlacement, p = s.popperProps, m = s.targetComponent, g = s.enableTabLoop, v = s.popperOnKeyDown, y = s.portalId, x = s.portalHost;
      if (!l) {
        var _ = classNames$1("react-datepicker-popper", o);
        a = React__default.createElement(Popper, ve({
          modifiers: h,
          placement: u
        }, p), function(b) {
          var M = b.ref, C = b.style, S = b.placement, A = b.arrowProps;
          return React__default.createElement($t, {
            enableTabLoop: g
          }, /* @__PURE__ */ jsx$1("div", {
            ref: M,
            style: C,
            className: _,
            "data-placement": S,
            onKeyDown: v,
            children: React__default.cloneElement(d, {
              arrowProps: A
            })
          }));
        });
      }
      this.props.popperContainer && (a = React__default.createElement(this.props.popperContainer, {}, a)), y && !l && (a = /* @__PURE__ */ jsx$1(Ut, {
        portalId: y,
        portalHost: x,
        children: a
      }));
      var $ = classNames$1("react-datepicker-wrapper", c);
      return React__default.createElement(Manager, {
        className: "react-datepicker-manager"
      }, React__default.createElement(Reference, null, function(b) {
        var M = b.ref;
        return /* @__PURE__ */ jsx$1("div", {
          ref: M,
          className: $,
          children: m
        });
      }), a);
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        hidePopper: !0,
        popperModifiers: [],
        popperProps: {},
        popperPlacement: "bottom-start"
      };
    }
  }]), n;
}(), Jt = "react-datepicker-ignore-onclickoutside", Xt = onClickOutsideHOC(Vt), Zt = "Date input not valid.", er = function(t) {
  De(n, React__default.Component);
  var r = be(n);
  function n(a) {
    var s;
    return he(this, n), ye(we(s = r.call(this, a)), "getPreSelection", function() {
      return s.props.openToDate ? s.props.openToDate : s.props.selectsEnd && s.props.startDate ? s.props.startDate : s.props.selectsStart && s.props.endDate ? s.props.endDate : Ye();
    }), ye(we(s), "modifyHolidays", function() {
      var o;
      return (o = s.props.holidays) === null || o === void 0 ? void 0 : o.reduce(function(c, l) {
        var d = new Date(l.date);
        return isValid$3(d) ? [].concat(Se(c), [de(de({}, l), {}, {
          date: d
        })]) : c;
      }, []);
    }), ye(we(s), "calcInitialState", function() {
      var o, c = s.getPreSelection(), l = ft(s.props), d = yt(s.props), h = l && isBefore$1(c, startOfDay(l)) ? l : d && isAfter$1(c, endOfDay(d)) ? d : c;
      return {
        open: s.props.startOpen || !1,
        preventFocus: !1,
        preSelection: (o = s.props.selectsRange ? s.props.startDate : s.props.selected) !== null && o !== void 0 ? o : h,
        highlightDates: vt(s.props.highlightDates),
        focused: !1,
        shouldFocusDayInline: !1,
        isRenderAriaLiveMessage: !1
      };
    }), ye(we(s), "clearPreventFocusTimeout", function() {
      s.preventFocusTimeout && clearTimeout(s.preventFocusTimeout);
    }), ye(we(s), "setFocus", function() {
      s.input && s.input.focus && s.input.focus({
        preventScroll: !0
      });
    }), ye(we(s), "setBlur", function() {
      s.input && s.input.blur && s.input.blur(), s.cancelFocusInput();
    }), ye(we(s), "setOpen", function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      s.setState({
        open: o,
        preSelection: o && s.state.open ? s.state.preSelection : s.calcInitialState().preSelection,
        lastPreSelectChange: rr
      }, function() {
        o || s.setState(function(l) {
          return {
            focused: !!c && l.focused
          };
        }, function() {
          !c && s.setBlur(), s.setState({
            inputValue: null
          });
        });
      });
    }), ye(we(s), "inputOk", function() {
      return isDate$2(s.state.preSelection);
    }), ye(we(s), "isCalendarOpen", function() {
      return s.props.open === void 0 ? s.state.open && !s.props.disabled && !s.props.readOnly : s.props.open;
    }), ye(we(s), "handleFocus", function(o) {
      s.state.preventFocus || (s.props.onFocus(o), s.props.preventOpenOnFocus || s.props.readOnly || s.setOpen(!0)), s.setState({
        focused: !0
      });
    }), ye(we(s), "sendFocusBackToInput", function() {
      s.preventFocusTimeout && s.clearPreventFocusTimeout(), s.setState({
        preventFocus: !0
      }, function() {
        s.preventFocusTimeout = setTimeout(function() {
          s.setFocus(), s.setState({
            preventFocus: !1
          });
        });
      });
    }), ye(we(s), "cancelFocusInput", function() {
      clearTimeout(s.inputFocusTimeout), s.inputFocusTimeout = null;
    }), ye(we(s), "deferFocusInput", function() {
      s.cancelFocusInput(), s.inputFocusTimeout = setTimeout(function() {
        return s.setFocus();
      }, 1);
    }), ye(we(s), "handleDropdownFocus", function() {
      s.cancelFocusInput();
    }), ye(we(s), "handleBlur", function(o) {
      (!s.state.open || s.props.withPortal || s.props.showTimeInput) && s.props.onBlur(o), s.setState({
        focused: !1
      });
    }), ye(we(s), "handleCalendarClickOutside", function(o) {
      s.props.inline || s.setOpen(!1), s.props.onClickOutside(o), s.props.withPortal && o.preventDefault();
    }), ye(we(s), "handleChange", function() {
      for (var o = arguments.length, c = new Array(o), l = 0; l < o; l++)
        c[l] = arguments[l];
      var d = c[0];
      if (!s.props.onChangeRaw || (s.props.onChangeRaw.apply(we(s), c), typeof d.isDefaultPrevented == "function" && !d.isDefaultPrevented())) {
        s.setState({
          inputValue: d.target.value,
          lastPreSelectChange: tr
        });
        var h, u, p, m, g, v, y, x, _ = (h = d.target.value, u = s.props.dateFormat, p = s.props.locale, m = s.props.strictParsing, g = s.props.minDate, v = null, y = Ge(p) || Ge($e()), x = !0, Array.isArray(u) ? (u.forEach(function($) {
          var b = parse$5(h, $, /* @__PURE__ */ new Date(), {
            locale: y
          });
          m && (x = Te(b, g) && h === Ie(b, $, p)), Te(b, g) && x && (v = b);
        }), v) : (v = parse$5(h, u, /* @__PURE__ */ new Date(), {
          locale: y
        }), m ? x = Te(v) && h === Ie(v, u, p) : Te(v) || (u = u.match(xe).map(function($) {
          var b = $[0];
          return b === "p" || b === "P" ? y ? (0, Ee[b])($, y.formatLong) : b : $;
        }).join(""), h.length > 0 && (v = parse$5(h, u.slice(0, h.length), /* @__PURE__ */ new Date())), Te(v) || (v = new Date(h))), Te(v) && x ? v : null));
        s.props.showTimeSelectOnly && s.props.selected && _ && !je(_, s.props.selected) && (_ = set$3(s.props.selected, {
          hours: getHours(_),
          minutes: getMinutes(_),
          seconds: getSeconds(_)
        })), !_ && d.target.value || (s.props.showWeekPicker && (_ = Le(_, s.props.locale, s.props.calendarStartDay)), s.setSelected(_, d, !0));
      }
    }), ye(we(s), "handleSelect", function(o, c, l) {
      if (s.props.shouldCloseOnSelect && !s.props.showTimeSelect && s.sendFocusBackToInput(), s.props.onChangeRaw && s.props.onChangeRaw(c), s.props.showWeekPicker && (o = Le(o, s.props.locale, s.props.calendarStartDay)), s.setSelected(o, c, !1, l), s.props.showDateSelect && s.setState({
        isRenderAriaLiveMessage: !0
      }), !s.props.shouldCloseOnSelect || s.props.showTimeSelect)
        s.setPreSelection(o);
      else if (!s.props.inline) {
        s.props.selectsRange || s.setOpen(!1);
        var d = s.props, h = d.startDate, u = d.endDate;
        !h || u || isBefore$1(o, h) || s.setOpen(!1);
      }
    }), ye(we(s), "setSelected", function(o, c, l, d) {
      var h = o;
      if (s.props.showYearPicker) {
        if (h !== null && at(getYear(h), s.props))
          return;
      } else if (s.props.showMonthYearPicker) {
        if (h !== null && tt(h, s.props))
          return;
      } else if (h !== null && Ze(h, s.props))
        return;
      var u = s.props, p = u.onChange, m = u.selectsRange, g = u.startDate, v = u.endDate;
      if (!Ve(s.props.selected, h) || s.props.allowSameDay || m)
        if (h !== null && (!s.props.selected || l && (s.props.showTimeSelect || s.props.showTimeSelectOnly || s.props.showTimeInput) || (h = Re(h, {
          hour: getHours(s.props.selected),
          minute: getMinutes(s.props.selected),
          second: getSeconds(s.props.selected)
        })), s.props.inline || s.setState({
          preSelection: h
        }), s.props.focusSelectedMonth || s.setState({
          monthSelectedIn: d
        })), m) {
          var y = g && !v, x = g && v;
          !g && !v ? p([h, null], c) : y && (isBefore$1(h, g) ? p([h, null], c) : p([g, h], c)), x && p([h, null], c);
        } else
          p(h, c);
      l || (s.props.onSelect(h, c), s.setState({
        inputValue: null
      }));
    }), ye(we(s), "setPreSelection", function(o) {
      var c = s.props.minDate !== void 0, l = s.props.maxDate !== void 0, d = !0;
      if (o) {
        s.props.showWeekPicker && (o = Le(o, s.props.locale, s.props.calendarStartDay));
        var h = startOfDay(o);
        if (c && l)
          d = qe(o, s.props.minDate, s.props.maxDate);
        else if (c) {
          var u = startOfDay(s.props.minDate);
          d = isAfter$1(o, u) || Ve(h, u);
        } else if (l) {
          var p = endOfDay(s.props.maxDate);
          d = isBefore$1(o, p) || Ve(h, p);
        }
      }
      d && s.setState({
        preSelection: o
      });
    }), ye(we(s), "toggleCalendar", function() {
      s.setOpen(!s.state.open);
    }), ye(we(s), "handleTimeChange", function(o) {
      var c = s.props.selected ? s.props.selected : s.getPreSelection(), l = s.props.selected ? o : Re(c, {
        hour: getHours(o),
        minute: getMinutes(o)
      });
      s.setState({
        preSelection: l
      }), s.props.onChange(l), s.props.shouldCloseOnSelect && (s.sendFocusBackToInput(), s.setOpen(!1)), s.props.showTimeInput && s.setOpen(!0), (s.props.showTimeSelectOnly || s.props.showTimeSelect) && s.setState({
        isRenderAriaLiveMessage: !0
      }), s.setState({
        inputValue: null
      });
    }), ye(we(s), "onInputClick", function() {
      s.props.disabled || s.props.readOnly || s.setOpen(!0), s.props.onInputClick();
    }), ye(we(s), "onInputKeyDown", function(o) {
      s.props.onKeyDown(o);
      var c = o.key;
      if (s.state.open || s.props.inline || s.props.preventOpenOnFocus) {
        if (s.state.open) {
          if (c === "ArrowDown" || c === "ArrowUp") {
            o.preventDefault();
            var l = s.props.showWeekPicker && s.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', d = s.calendar.componentNode && s.calendar.componentNode.querySelector(l);
            return void (d && d.focus({
              preventScroll: !0
            }));
          }
          var h = Ye(s.state.preSelection);
          c === "Enter" ? (o.preventDefault(), s.inputOk() && s.state.lastPreSelectChange === rr ? (s.handleSelect(h, o), !s.props.shouldCloseOnSelect && s.setPreSelection(h)) : s.setOpen(!1)) : c === "Escape" ? (o.preventDefault(), s.sendFocusBackToInput(), s.setOpen(!1)) : c === "Tab" && s.setOpen(!1), s.inputOk() || s.props.onInputError({
            code: 1,
            msg: Zt
          });
        }
      } else
        c !== "ArrowDown" && c !== "ArrowUp" && c !== "Enter" || s.onInputClick();
    }), ye(we(s), "onPortalKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), s.setState({
        preventFocus: !0
      }, function() {
        s.setOpen(!1), setTimeout(function() {
          s.setFocus(), s.setState({
            preventFocus: !1
          });
        });
      }));
    }), ye(we(s), "onDayKeyDown", function(o) {
      s.props.onKeyDown(o);
      var c = o.key, l = Ye(s.state.preSelection);
      if (c === "Enter")
        o.preventDefault(), s.handleSelect(l, o), !s.props.shouldCloseOnSelect && s.setPreSelection(l);
      else if (c === "Escape")
        o.preventDefault(), s.setOpen(!1), s.inputOk() || s.props.onInputError({
          code: 1,
          msg: Zt
        });
      else if (!s.props.disabledKeyboardNavigation) {
        var d;
        switch (c) {
          case "ArrowLeft":
            d = s.props.showWeekPicker ? subWeeks(l, 1) : subDays(l, 1);
            break;
          case "ArrowRight":
            d = s.props.showWeekPicker ? addWeeks(l, 1) : addDays(l, 1);
            break;
          case "ArrowUp":
            d = subWeeks(l, 1);
            break;
          case "ArrowDown":
            d = addWeeks(l, 1);
            break;
          case "PageUp":
            d = subMonths(l, 1);
            break;
          case "PageDown":
            d = addMonths(l, 1);
            break;
          case "Home":
            d = subYears(l, 1);
            break;
          case "End":
            d = addYears(l, 1);
            break;
          default:
            d = null;
        }
        if (!d)
          return void (s.props.onInputError && s.props.onInputError({
            code: 1,
            msg: Zt
          }));
        if (o.preventDefault(), s.setState({
          lastPreSelectChange: rr
        }), s.props.adjustDateOnChange && s.setSelected(d), s.setPreSelection(d), s.props.inline) {
          var h = getMonth(l), u = getMonth(d), p = getYear(l), m = getYear(d);
          h !== u || p !== m ? s.setState({
            shouldFocusDayInline: !0
          }) : s.setState({
            shouldFocusDayInline: !1
          });
        }
      }
    }), ye(we(s), "onPopperKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), s.sendFocusBackToInput());
    }), ye(we(s), "onClearClick", function(o) {
      o && o.preventDefault && o.preventDefault(), s.sendFocusBackToInput(), s.props.selectsRange ? s.props.onChange([null, null], o) : s.props.onChange(null, o), s.setState({
        inputValue: null
      });
    }), ye(we(s), "clear", function() {
      s.onClearClick();
    }), ye(we(s), "onScroll", function(o) {
      typeof s.props.closeOnScroll == "boolean" && s.props.closeOnScroll ? o.target !== document && o.target !== document.documentElement && o.target !== document.body || s.setOpen(!1) : typeof s.props.closeOnScroll == "function" && s.props.closeOnScroll(o) && s.setOpen(!1);
    }), ye(we(s), "renderCalendar", function() {
      return s.props.inline || s.isCalendarOpen() ? /* @__PURE__ */ jsx$1(Xt, {
        ref: function(o) {
          s.calendar = o;
        },
        locale: s.props.locale,
        calendarStartDay: s.props.calendarStartDay,
        chooseDayAriaLabelPrefix: s.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: s.props.disabledDayAriaLabelPrefix,
        weekAriaLabelPrefix: s.props.weekAriaLabelPrefix,
        monthAriaLabelPrefix: s.props.monthAriaLabelPrefix,
        adjustDateOnChange: s.props.adjustDateOnChange,
        setOpen: s.setOpen,
        shouldCloseOnSelect: s.props.shouldCloseOnSelect,
        dateFormat: s.props.dateFormatCalendar,
        useWeekdaysShort: s.props.useWeekdaysShort,
        formatWeekDay: s.props.formatWeekDay,
        dropdownMode: s.props.dropdownMode,
        selected: s.props.selected,
        preSelection: s.state.preSelection,
        onSelect: s.handleSelect,
        onWeekSelect: s.props.onWeekSelect,
        openToDate: s.props.openToDate,
        minDate: s.props.minDate,
        maxDate: s.props.maxDate,
        selectsStart: s.props.selectsStart,
        selectsEnd: s.props.selectsEnd,
        selectsRange: s.props.selectsRange,
        startDate: s.props.startDate,
        endDate: s.props.endDate,
        excludeDates: s.props.excludeDates,
        excludeDateIntervals: s.props.excludeDateIntervals,
        filterDate: s.props.filterDate,
        onClickOutside: s.handleCalendarClickOutside,
        formatWeekNumber: s.props.formatWeekNumber,
        highlightDates: s.state.highlightDates,
        holidays: Dt(s.modifyHolidays()),
        includeDates: s.props.includeDates,
        includeDateIntervals: s.props.includeDateIntervals,
        includeTimes: s.props.includeTimes,
        injectTimes: s.props.injectTimes,
        inline: s.props.inline,
        shouldFocusDayInline: s.state.shouldFocusDayInline,
        peekNextMonth: s.props.peekNextMonth,
        showMonthDropdown: s.props.showMonthDropdown,
        showPreviousMonths: s.props.showPreviousMonths,
        useShortMonthInDropdown: s.props.useShortMonthInDropdown,
        showMonthYearDropdown: s.props.showMonthYearDropdown,
        showWeekNumbers: s.props.showWeekNumbers,
        showYearDropdown: s.props.showYearDropdown,
        withPortal: s.props.withPortal,
        forceShowMonthNavigation: s.props.forceShowMonthNavigation,
        showDisabledMonthNavigation: s.props.showDisabledMonthNavigation,
        scrollableYearDropdown: s.props.scrollableYearDropdown,
        scrollableMonthYearDropdown: s.props.scrollableMonthYearDropdown,
        todayButton: s.props.todayButton,
        weekLabel: s.props.weekLabel,
        outsideClickIgnoreClass: Jt,
        fixedHeight: s.props.fixedHeight,
        monthsShown: s.props.monthsShown,
        monthSelectedIn: s.state.monthSelectedIn,
        onDropdownFocus: s.handleDropdownFocus,
        onMonthChange: s.props.onMonthChange,
        onYearChange: s.props.onYearChange,
        dayClassName: s.props.dayClassName,
        weekDayClassName: s.props.weekDayClassName,
        monthClassName: s.props.monthClassName,
        timeClassName: s.props.timeClassName,
        showDateSelect: s.props.showDateSelect,
        showTimeSelect: s.props.showTimeSelect,
        showTimeSelectOnly: s.props.showTimeSelectOnly,
        onTimeChange: s.handleTimeChange,
        timeFormat: s.props.timeFormat,
        timeIntervals: s.props.timeIntervals,
        minTime: s.props.minTime,
        maxTime: s.props.maxTime,
        excludeTimes: s.props.excludeTimes,
        filterTime: s.props.filterTime,
        timeCaption: s.props.timeCaption,
        className: s.props.calendarClassName,
        container: s.props.calendarContainer,
        yearItemNumber: s.props.yearItemNumber,
        yearDropdownItemNumber: s.props.yearDropdownItemNumber,
        previousMonthAriaLabel: s.props.previousMonthAriaLabel,
        previousMonthButtonLabel: s.props.previousMonthButtonLabel,
        nextMonthAriaLabel: s.props.nextMonthAriaLabel,
        nextMonthButtonLabel: s.props.nextMonthButtonLabel,
        previousYearAriaLabel: s.props.previousYearAriaLabel,
        previousYearButtonLabel: s.props.previousYearButtonLabel,
        nextYearAriaLabel: s.props.nextYearAriaLabel,
        nextYearButtonLabel: s.props.nextYearButtonLabel,
        timeInputLabel: s.props.timeInputLabel,
        disabledKeyboardNavigation: s.props.disabledKeyboardNavigation,
        renderCustomHeader: s.props.renderCustomHeader,
        popperProps: s.props.popperProps,
        renderDayContents: s.props.renderDayContents,
        renderMonthContent: s.props.renderMonthContent,
        renderQuarterContent: s.props.renderQuarterContent,
        renderYearContent: s.props.renderYearContent,
        onDayMouseEnter: s.props.onDayMouseEnter,
        onMonthMouseLeave: s.props.onMonthMouseLeave,
        onYearMouseEnter: s.props.onYearMouseEnter,
        onYearMouseLeave: s.props.onYearMouseLeave,
        selectsDisabledDaysInRange: s.props.selectsDisabledDaysInRange,
        showTimeInput: s.props.showTimeInput,
        showMonthYearPicker: s.props.showMonthYearPicker,
        showFullMonthYearPicker: s.props.showFullMonthYearPicker,
        showTwoColumnMonthYearPicker: s.props.showTwoColumnMonthYearPicker,
        showFourColumnMonthYearPicker: s.props.showFourColumnMonthYearPicker,
        showYearPicker: s.props.showYearPicker,
        showQuarterYearPicker: s.props.showQuarterYearPicker,
        showWeekPicker: s.props.showWeekPicker,
        showPopperArrow: s.props.showPopperArrow,
        excludeScrollbar: s.props.excludeScrollbar,
        handleOnKeyDown: s.props.onKeyDown,
        handleOnDayKeyDown: s.onDayKeyDown,
        isInputFocused: s.state.focused,
        customTimeInput: s.props.customTimeInput,
        setPreSelection: s.setPreSelection,
        children: s.props.children
      }) : null;
    }), ye(we(s), "renderAriaLiveRegion", function() {
      var o, c = s.props, l = c.dateFormat, d = c.locale, h = s.props.showTimeInput || s.props.showTimeSelect ? "PPPPp" : "PPPP";
      return o = s.props.selectsRange ? "Selected start date: ".concat(Oe(s.props.startDate, {
        dateFormat: h,
        locale: d
      }), ". ").concat(s.props.endDate ? "End date: " + Oe(s.props.endDate, {
        dateFormat: h,
        locale: d
      }) : "") : s.props.showTimeSelectOnly ? "Selected time: ".concat(Oe(s.props.selected, {
        dateFormat: l,
        locale: d
      })) : s.props.showYearPicker ? "Selected year: ".concat(Oe(s.props.selected, {
        dateFormat: "yyyy",
        locale: d
      })) : s.props.showMonthYearPicker ? "Selected month: ".concat(Oe(s.props.selected, {
        dateFormat: "MMMM yyyy",
        locale: d
      })) : s.props.showQuarterYearPicker ? "Selected quarter: ".concat(Oe(s.props.selected, {
        dateFormat: "yyyy, QQQ",
        locale: d
      })) : "Selected date: ".concat(Oe(s.props.selected, {
        dateFormat: h,
        locale: d
      })), /* @__PURE__ */ jsx$1("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live",
        children: o
      });
    }), ye(we(s), "renderDateInput", function() {
      var o, c = classNames$1(s.props.className, ye({}, Jt, s.state.open)), l = s.props.customInput || /* @__PURE__ */ jsx$1("input", {
        type: "text"
      }), d = s.props.customInputRef || "ref", h = typeof s.props.value == "string" ? s.props.value : typeof s.state.inputValue == "string" ? s.state.inputValue : s.props.selectsRange ? function(u, p, m) {
        if (!u)
          return "";
        var g = Oe(u, m), v = p ? Oe(p, m) : "";
        return "".concat(g, " - ").concat(v);
      }(s.props.startDate, s.props.endDate, s.props) : Oe(s.props.selected, s.props);
      return React__default.cloneElement(l, (ye(ye(ye(ye(ye(ye(ye(ye(ye(ye(o = {}, d, function(u) {
        s.input = u;
      }), "value", h), "onBlur", s.handleBlur), "onChange", s.handleChange), "onClick", s.onInputClick), "onFocus", s.handleFocus), "onKeyDown", s.onInputKeyDown), "id", s.props.id), "name", s.props.name), "form", s.props.form), ye(ye(ye(ye(ye(ye(ye(ye(ye(ye(o, "autoFocus", s.props.autoFocus), "placeholder", s.props.placeholderText), "disabled", s.props.disabled), "autoComplete", s.props.autoComplete), "className", classNames$1(l.props.className, c)), "title", s.props.title), "readOnly", s.props.readOnly), "required", s.props.required), "tabIndex", s.props.tabIndex), "aria-describedby", s.props.ariaDescribedBy), ye(ye(ye(o, "aria-invalid", s.props.ariaInvalid), "aria-labelledby", s.props.ariaLabelledBy), "aria-required", s.props.ariaRequired)));
    }), ye(we(s), "renderClearButton", function() {
      var o = s.props, c = o.isClearable, l = o.disabled, d = o.selected, h = o.startDate, u = o.endDate, p = o.clearButtonTitle, m = o.clearButtonClassName, g = m === void 0 ? "" : m, v = o.ariaLabelClose, y = v === void 0 ? "Close" : v;
      return !c || d == null && h == null && u == null ? null : /* @__PURE__ */ jsx$1("button", {
        type: "button",
        className: classNames$1("react-datepicker__close-icon", g, {
          "react-datepicker__close-icon--disabled": l
        }),
        disabled: l,
        "aria-label": y,
        onClick: s.onClearClick,
        title: p,
        tabIndex: -1
      });
    }), s.state = s.calcInitialState(), s.preventFocusTimeout = null, s;
  }
  return fe(n, [{
    key: "componentDidMount",
    value: function() {
      window.addEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a, s) {
      var o, c;
      a.inline && (o = a.selected, c = this.props.selected, o && c ? getMonth(o) !== getMonth(c) || getYear(o) !== getYear(c) : o !== c) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && a.monthsShown !== this.props.monthsShown && this.setState({
        monthSelectedIn: 0
      }), a.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: vt(this.props.highlightDates)
      }), s.focused || Ve(a.selected, this.props.selected) || this.setState({
        inputValue: null
      }), s.open !== this.state.open && (s.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), s.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "renderInputContainer",
    value: function() {
      var a = this.props, s = a.showIcon, o = a.icon, c = a.calendarIconClassname, l = a.toggleCalendarOnIconClick, d = this.state.open;
      return /* @__PURE__ */ jsxs("div", {
        className: "react-datepicker__input-container".concat(s ? " react-datepicker__view-calendar-icon" : ""),
        children: [s && React__default.createElement(qt, ve({
          icon: o,
          className: "".concat(c, " ").concat(d && "react-datepicker-ignore-onclickoutside")
        }, l ? {
          onClick: this.toggleCalendar
        } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton()]
      });
    }
  }, {
    key: "render",
    value: function() {
      var a = this.renderCalendar();
      if (this.props.inline)
        return a;
      if (this.props.withPortal) {
        var s = this.state.open ? React__default.createElement($t, {
          enableTabLoop: this.props.enableTabLoop
        }, /* @__PURE__ */ jsx$1("div", {
          className: "react-datepicker__portal",
          tabIndex: -1,
          onKeyDown: this.onPortalKeyDown,
          children: a
        })) : null;
        return this.state.open && this.props.portalId && (s = /* @__PURE__ */ jsx$1(Ut, {
          portalId: this.props.portalId,
          portalHost: this.props.portalHost,
          children: s
        })), /* @__PURE__ */ jsxs("div", {
          children: [this.renderInputContainer(), s]
        });
      }
      return /* @__PURE__ */ jsx$1(Gt, {
        className: this.props.popperClassName,
        wrapperClassName: this.props.wrapperClassName,
        hidePopper: !this.isCalendarOpen(),
        portalId: this.props.portalId,
        portalHost: this.props.portalHost,
        popperModifiers: this.props.popperModifiers,
        targetComponent: this.renderInputContainer(),
        popperContainer: this.props.popperContainer,
        popperComponent: a,
        popperPlacement: this.props.popperPlacement,
        popperProps: this.props.popperProps,
        popperOnKeyDown: this.onPopperKeyDown,
        enableTabLoop: this.props.enableTabLoop
      });
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        allowSameDay: !1,
        dateFormat: "MM/dd/yyyy",
        dateFormatCalendar: "LLLL yyyy",
        onChange: function() {
        },
        disabled: !1,
        disabledKeyboardNavigation: !1,
        dropdownMode: "scroll",
        onFocus: function() {
        },
        onBlur: function() {
        },
        onKeyDown: function() {
        },
        onInputClick: function() {
        },
        onSelect: function() {
        },
        onClickOutside: function() {
        },
        onMonthChange: function() {
        },
        onCalendarOpen: function() {
        },
        onCalendarClose: function() {
        },
        preventOpenOnFocus: !1,
        onYearChange: function() {
        },
        onInputError: function() {
        },
        monthsShown: 1,
        readOnly: !1,
        withPortal: !1,
        selectsDisabledDaysInRange: !1,
        shouldCloseOnSelect: !0,
        showTimeSelect: !1,
        showTimeInput: !1,
        showPreviousMonths: !1,
        showMonthYearPicker: !1,
        showFullMonthYearPicker: !1,
        showTwoColumnMonthYearPicker: !1,
        showFourColumnMonthYearPicker: !1,
        showYearPicker: !1,
        showQuarterYearPicker: !1,
        showWeekPicker: !1,
        strictParsing: !1,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthAriaLabel: "Previous Month",
        previousMonthButtonLabel: "Previous Month",
        nextMonthAriaLabel: "Next Month",
        nextMonthButtonLabel: "Next Month",
        previousYearAriaLabel: "Previous Year",
        previousYearButtonLabel: "Previous Year",
        nextYearAriaLabel: "Next Year",
        nextYearButtonLabel: "Next Year",
        timeInputLabel: "Time",
        enableTabLoop: !0,
        yearItemNumber: Ne,
        focusSelectedMonth: !1,
        showPopperArrow: !0,
        excludeScrollbar: !0,
        customTimeInput: null,
        calendarStartDay: void 0,
        toggleCalendarOnIconClick: !1
      };
    }
  }]), n;
}(), tr = "input", rr = "navigate";
const DatePickerWrapperStyles = createGlobalStyle`
  .react-datepicker {
    font-family: ${({ theme: { fontFamily: t } }) => t.silka};
    display: flex;
    justify-content: center;
    border: none;
    padding: 0;
    margin: 0;
    &__header {
      border-bottom: none;
      background: none;
      padding: 0;
    }
    &__month {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0;
    }
    &__week{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${({ theme: { reference: t } }) => t.dimension_08};
    }
    &__day {
      ${({ theme: { system: t } }) => t.fds_sys_M};
      height: 30px;
      width: 30px;
      font-weight: ${({ theme: { system: t } }) => t.fds_sys_weight_L};
      &:hover {
        background-color:  ${({ theme: { colors: t } }) => t.dark_500};
        color: white;
        border-radius: 50%;
      }
      &-names {
        display: flex;
        align-items: center;
        justify-content: center;
        ${({ theme: { system: t } }) => t.fds_sys_M};
        gap: ${({ theme: { reference: t } }) => t.dimension_08};
        font-weight: ${({ theme: { system: t } }) => t.fds_sys_weight_L};
        margin-bottom: 0px;
      }
      &-name {
        width: 30px;
        height: 30px;
        color:  ${({ theme: { colors: t } }) => t.dark_500};
        font-size: ${({ theme: { reference: t } }) => t.dimension_16};
        font-family:  ${({ theme: { reference: t } }) => t.Silka};
        font-weight: ${({ theme: { reference: t } }) => t.weight_700};
      }
      &--selected {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ theme: { colors: t } }) => t.dark_500};
        border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_O};
        &:hover {
          background-color:  ${({ theme: { colors: t } }) => t.dark_500};
          border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_O};
        }
      }
      &--keyboard-selected {
        background-color: transparent;
        color: black;
      }
      &--outside-month {
        color:  ${({ theme: { colors: t } }) => t.moon_500};
      }
    }
  }`, DatePickerCustom = ({
  date: t,
  onChangeDate: r,
  onClose: n
}) => /* @__PURE__ */ jsxs(Fragment, {
  children: [/* @__PURE__ */ jsx$1(er, {
    locale: es,
    selected: t,
    onChange: r,
    withPortal: !0,
    showYearDropdown: !0,
    dropdownMode: "scroll",
    fixedHeight: !0,
    inline: !0,
    renderCustomHeader: ({
      date: a,
      monthDate: s,
      decreaseYear: o,
      increaseYear: c,
      decreaseMonth: l,
      increaseMonth: d,
      prevYearButtonDisabled: h,
      nextYearButtonDisabled: u,
      prevMonthButtonDisabled: p,
      nextMonthButtonDisabled: m
    }) => /* @__PURE__ */ jsxs(FlexContainer$1, {
      className: "custom-header",
      direction: "column",
      children: [/* @__PURE__ */ jsxs(FlexContainer$1, {
        align: "center",
        justify: "space-between",
        mb: "fds_size_24",
        children: [/* @__PURE__ */ jsx$1(Text$3, {
          type: "paragraphs",
          color: "cold",
          size: "XL_M_S",
          align: "center",
          ml: "fds_size_08",
          children: `${t.getDate()} ${t.toLocaleString("default", {
            month: "short"
          })} ${t.getFullYear()}`
        }), /* @__PURE__ */ jsx$1(Buttons.Icon, {
          icon: "IconCrossDarkM",
          mode: "secondary",
          onClick: n,
          size: "xxs"
        })]
      }), /* @__PURE__ */ jsxs(FlexContainer$1, {
        align: "center",
        justify: "space-between",
        mb: "fds_size_24",
        children: [/* @__PURE__ */ jsxs(FlexContainer$1, {
          align: "center",
          gap: "dimension_04",
          className: "year-selector",
          children: [/* @__PURE__ */ jsx$1(Buttons.Icon, {
            icon: "IconArrowLeftM",
            onClick: o,
            disabled: h,
            size: "xxs",
            color: "dark_500",
            className: "button-selector"
          }), /* @__PURE__ */ jsx$1(Text$3, {
            type: "paragraphs",
            color: "dark",
            size: "M_L_S",
            children: a.getFullYear()
          }), /* @__PURE__ */ jsx$1(Buttons.Icon, {
            icon: "IconArrowRightM",
            onClick: c,
            disabled: u,
            size: "xxs",
            color: "dark_500",
            className: "button-selector right"
          })]
        }), /* @__PURE__ */ jsxs(FlexContainer$1, {
          align: "center",
          gap: "dimension_04",
          className: "year-selector",
          children: [/* @__PURE__ */ jsx$1(Buttons.Icon, {
            icon: "IconArrowLeftM",
            onClick: l,
            disabled: p,
            size: "xxs",
            color: "dark_500",
            className: "button-selector"
          }), /* @__PURE__ */ jsx$1(Text$3, {
            type: "paragraphs",
            color: "dark",
            size: "M_L_S",
            children: s.toLocaleString("es-ES", {
              month: "long"
            })
          }), /* @__PURE__ */ jsx$1(Buttons.Icon, {
            icon: "IconArrowRightM",
            onClick: d,
            disabled: m,
            size: "xxs",
            color: "dark_500",
            className: "button-selector right"
          })]
        })]
      })]
    })
  }), /* @__PURE__ */ jsx$1(DatePickerWrapperStyles, {})]
}), ModalContainer$1 = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_M};
  top: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme: { system: t } }) => t.zIndex.fds_sys_zindex_overlay};
  ${({ theme: { components: t } }) => t.modals.fds_c_modals_background};
  background: ${({ theme: { reference: t } }) => t.functional.darken_600};
  backdrop-filter: ${({ theme: { components: t } }) => `blur(${t.modals.fds_c_modals_background["background-blur"]})`};
  display: flex;
  align-items: center;
  justify-content: center;
`, ModalContent = styled.div`
  position: relative;
  background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_primary};
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_M};
  gap: ${({ theme: { system: t } }) => t.fds_sys_spacing_M};
  @media screen and (max-width: ${({ theme: { reference: t } }) => t.breakpoints.MOBILE_WIDTH}) {
    min-width: auto;
    max-width: 90%;
  }
`, Modal$2 = ({
  children: t,
  width: r = 308,
  height: n = 300,
  ...a
}) => /* @__PURE__ */ jsx$1(ModalContainer$1, {
  ...a,
  children: /* @__PURE__ */ jsx$1(ModalContent, {
    width: r,
    height: n,
    children: t
  })
}), InputDateWrapper = ({
  value: t,
  hasError: r,
  hasWarning: n,
  onBlur: a,
  onChange: s,
  ...o
}) => /* @__PURE__ */ jsx$1(DateFormat, {
  ...o,
  format: "##/##/####",
  mask: ["_", "_", "_", "_", "_", "_", "_", "_"],
  placeholder: "DD/MM/YYYY",
  value: t,
  type: "text",
  $hasError: r,
  $hasWarning: n,
  onValueChange: (c) => s(c),
  onBlur: a
}), DateLayout = withInputLayout(InputDateWrapper), InputDate = ({
  hasError: t,
  onChange: r,
  ...n
}) => {
  const [a, s] = useState(!1), [o, c] = useState(!1), [l, d] = useState(/* @__PURE__ */ new Date()), [h, u] = useState(), p = (v) => {
    d(v), u(format$8(v, "ddMMyyyy")), s(!a), r(format$8(v, "ddMMyyyy"));
  }, m = (v) => {
    const {
      formattedValue: y
    } = v, x = y ? parse$5(y, "dd/MM/yyyy", /* @__PURE__ */ new Date()) : /* @__PURE__ */ new Date();
    u(y), d(isValid$3(x) ? x : /* @__PURE__ */ new Date()), r(y);
  };
  return useEffect(() => {
    u(n == null ? void 0 : n.value);
  }, [n == null ? void 0 : n.value]), /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(DateLayout, {
      ...n,
      value: h,
      onChange: m,
      onBlur: (v) => {
        c(!isValid$3(parse$5(v.target.value, "dd/MM/yyyy", /* @__PURE__ */ new Date())));
      },
      hasError: t || o,
      rigthIcon: "IconDateCalendar",
      rigthButtonClick: () => s(!a)
    }), a && /* @__PURE__ */ jsx$1(Modal$2, {
      children: /* @__PURE__ */ jsx$1(DatePickerCustom, {
        date: l,
        onChangeDate: p,
        onClose: () => s(!1)
      })
    })]
  });
}, Decimal = ({
  value: t,
  hasError: r,
  hasWarning: n,
  readOnly: a,
  onChange: s
}) => /* @__PURE__ */ jsx$1(InputMask$1, {
  type: "text",
  displayType: "input",
  value: t,
  onValueChange: (o) => s == null ? void 0 : s(o.value),
  valueIsNumericString: !0,
  decimalSeparator: ",",
  decimalScale: 2,
  readOnly: a,
  $hasError: r,
  $hasWarning: n
}), Decimal$1 = withInputLayout(Decimal), formatToUpperCase = (t) => (t == null ? void 0 : t.toUpperCase()) ?? t, formatToLowerCase = (t) => t == null ? void 0 : t.toLowerCase();
var reactInputMask = { exports: {} }, reactInputMask_production_min = { exports: {} }, browser, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser)
    return browser;
  hasRequiredBrowser = 1;
  var t = function(r, n, a, s, o, c, l, d) {
    if (process.env.NODE_ENV !== "production" && n === void 0)
      throw new Error("invariant requires an error message argument");
    if (!r) {
      var h;
      if (n === void 0)
        h = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var u = [a, s, o, c, l, d], p = 0;
        h = new Error(
          n.replace(/%s/g, function() {
            return u[p++];
          })
        ), h.name = "Invariant Violation";
      }
      throw h.framesToPop = 1, h;
    }
  };
  return browser = t, browser;
}
var hasRequiredReactInputMask_production_min;
function requireReactInputMask_production_min() {
  if (hasRequiredReactInputMask_production_min)
    return reactInputMask_production_min.exports;
  hasRequiredReactInputMask_production_min = 1;
  function t(C) {
    return C && typeof C == "object" && "default" in C ? C.default : C;
  }
  var r = React__default, n = t(r), a = ReactDOM__default, s = t(requireBrowser());
  function o() {
    return (o = Object.assign || function(C) {
      for (var S = 1; S < arguments.length; S++) {
        var A = arguments[S];
        for (var D in A)
          Object.prototype.hasOwnProperty.call(A, D) && (C[D] = A[D]);
      }
      return C;
    }).apply(this, arguments);
  }
  function c(C, S) {
    C.prototype = Object.create(S.prototype), C.prototype.constructor = C, function(A, D) {
      for (var N = Object.getOwnPropertyNames(D), T = 0; T < N.length; T++) {
        var R = N[T], F = Object.getOwnPropertyDescriptor(D, R);
        F && F.configurable && A[R] === void 0 && Object.defineProperty(A, R, F);
      }
    }(C, S);
  }
  function l(C, S) {
    if (C == null)
      return {};
    var A, D, N = {}, T = Object.keys(C);
    for (D = 0; D < T.length; D++)
      A = T[D], S.indexOf(A) >= 0 || (N[A] = C[A]);
    return N;
  }
  function d(C) {
    return requestAnimationFrame(C);
  }
  function h(C) {
    cancelAnimationFrame(C);
  }
  function u(C) {
    var S = C.ownerDocument;
    return S.hasFocus() && S.activeElement === C;
  }
  function p(C) {
    return C == null ? void 0 : C.ownerDocument;
  }
  function m(C) {
    var S = function(A) {
      var D;
      return (D = p(A)) == null ? void 0 : D.defaultView;
    }(C);
    return !!S && C instanceof S.HTMLElement;
  }
  function g(C) {
    return r.useCallback(function() {
      var S = C.current, A = typeof window < "u" && m(S);
      if (!S || !A)
        return null;
      if (S.nodeName !== "INPUT" && (S = S.querySelector("input")), !S)
        throw new Error("react-input-mask: inputComponent doesn't contain input node");
      return S;
    }, [C]);
  }
  function v(C, S) {
    var A, D, N, T, R = r.useRef({ start: null, end: null }), F = g(C), z = r.useCallback(function() {
      return function(V) {
        var U = V.selectionStart, J = V.selectionEnd;
        return { start: U, end: J, length: J - U };
      }(F());
    }, [F]), O = r.useCallback(function() {
      return R.current;
    }, []), G = r.useCallback(function(V) {
      var U = F();
      U && u(U) && (function(J, q, Z) {
        Z === void 0 && (Z = q), J.setSelectionRange(q, Z);
      }(U, V.start, V.end), R.current = z());
    }, [F, z]), I = r.useCallback(function() {
      R.current = z();
    }, [z]), k = (A = I, D = r.useRef(null), N = r.useCallback(function() {
      D.current === null && function V() {
        A(), D.current = d(V);
      }();
    }, [A]), T = r.useCallback(function() {
      h(D.current), D.current = null;
    }, []), r.useEffect(function() {
      D.current && (T(), N());
    }, [N, T]), r.useEffect(h, []), [N, T]), B = k[0], L = k[1];
    return r.useLayoutEffect(function() {
      if (S) {
        var V = F();
        return V.addEventListener("focus", B), V.addEventListener("blur", L), u(V) && B(), function() {
          V.removeEventListener("focus", B), V.removeEventListener("blur", L), L();
        };
      }
    }), { getSelection: z, getLastSelection: O, setSelection: G };
  }
  function y(C, S) {
    var A = r.useRef(), D = v(A, S), N = D.getSelection, T = D.getLastSelection, R = D.setSelection, F = function(I, k) {
      var B = g(I), L = r.useRef(k);
      return { getValue: r.useCallback(function() {
        return B().value;
      }, [B]), getLastValue: r.useCallback(function() {
        return L.current;
      }, []), setValue: r.useCallback(function(V) {
        L.current = V;
        var U = B();
        U && (U.value = V);
      }, [B]) };
    }(A, C), z = F.getValue, O = F.getLastValue, G = F.setValue;
    return { inputRef: A, getInputState: function() {
      return { value: z(), selection: N() };
    }, getLastInputState: function() {
      return { value: O(), selection: T() };
    }, setInputState: function(I) {
      var k = I.value, B = I.selection;
      G(k), R(B);
    } };
  }
  requireWarning();
  var x = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"], _ = { 9: /[0-9]/, a: /[A-Za-z]/, "*": /[A-Za-z0-9]/ }, $ = function(C) {
    var S = this;
    this.isCharacterAllowedAtPosition = function(A, D) {
      var N = S.maskOptions.maskPlaceholder;
      return !!S.isCharacterFillingPosition(A, D) || !!N && N[D] === A;
    }, this.isCharacterFillingPosition = function(A, D) {
      var N = S.maskOptions.mask;
      if (!A || D >= N.length)
        return !1;
      if (!S.isPositionEditable(D))
        return N[D] === A;
      var T = N[D];
      return new RegExp(T).test(A);
    }, this.isPositionEditable = function(A) {
      var D = S.maskOptions, N = D.mask, T = D.permanents;
      return A < N.length && T.indexOf(A) === -1;
    }, this.isValueEmpty = function(A) {
      return A.split("").every(function(D, N) {
        return !S.isPositionEditable(N) || !S.isCharacterFillingPosition(D, N);
      });
    }, this.isValueFilled = function(A) {
      return S.getFilledLength(A) === S.maskOptions.lastEditablePosition + 1;
    }, this.getDefaultSelectionForValue = function(A) {
      var D = S.getFilledLength(A), N = S.getRightEditablePosition(D);
      return { start: N, end: N };
    }, this.getFilledLength = function(A) {
      return function(D, N) {
        for (var T = D.length - 1; T >= 0; T--)
          if (N(D[T], T))
            return T;
        return -1;
      }(A.split(""), function(D, N) {
        return S.isPositionEditable(N) && S.isCharacterFillingPosition(D, N);
      }) + 1;
    }, this.getStringFillingLengthAtPosition = function(A, D) {
      return A.split("").reduce(function(N, T) {
        return S.insertCharacterAtPosition(N, T, N.length);
      }, function(N, T) {
        T === void 0 && (T = 1);
        for (var R = "", F = 0; F < T; F++)
          R += N;
        return R;
      }(" ", D)).length - D;
    }, this.getLeftEditablePosition = function(A) {
      for (var D = A; D >= 0; D--)
        if (S.isPositionEditable(D))
          return D;
      return null;
    }, this.getRightEditablePosition = function(A) {
      for (var D = S.maskOptions.mask, N = A; N < D.length; N++)
        if (S.isPositionEditable(N))
          return N;
      return null;
    }, this.formatValue = function(A) {
      var D = S.maskOptions, N = D.maskPlaceholder, T = D.mask;
      if (!N) {
        for (A = S.insertStringAtPosition("", A, 0); A.length < T.length && !S.isPositionEditable(A.length); )
          A += T[A.length];
        return A;
      }
      return S.insertStringAtPosition(N, A, 0);
    }, this.clearRange = function(A, D, N) {
      if (!N)
        return A;
      var T = D + N, R = S.maskOptions, F = R.maskPlaceholder, z = R.mask, O = A.split("").map(function(G, I) {
        var k = S.isPositionEditable(I);
        return !F && I >= T && !k ? "" : I < D || I >= T ? G : k ? F ? F[I] : "" : z[I];
      }).join("");
      return S.formatValue(O);
    }, this.insertCharacterAtPosition = function(A, D, N) {
      var T = S.maskOptions, R = T.mask, F = T.maskPlaceholder;
      if (N >= R.length)
        return A;
      var z = S.isCharacterAllowedAtPosition(D, N), O = S.isPositionEditable(N), G = S.getRightEditablePosition(N), I = F && G ? D === F[G] : null, k = A.slice(0, N);
      return !z && O || (A = k + (z ? D : R[N])), z || O || I || (A = S.insertCharacterAtPosition(A, D, N + 1)), A;
    }, this.insertStringAtPosition = function(A, D, N) {
      var T = S.maskOptions, R = T.mask, F = T.maskPlaceholder;
      if (!D || N >= R.length)
        return A;
      var z = D.split(""), O = S.isValueFilled(A) || !!F, G = A.slice(N);
      return A = z.reduce(function(I, k) {
        return S.insertCharacterAtPosition(I, k, I.length);
      }, A.slice(0, N)), O ? A += G.slice(A.length - N) : S.isValueFilled(A) ? A += R.slice(A.length).join("") : A = G.split("").filter(function(I, k) {
        return S.isPositionEditable(N + k);
      }).reduce(function(I, k) {
        var B = S.getRightEditablePosition(I.length);
        return B === null ? I : (S.isPositionEditable(I.length) || (I += R.slice(I.length, B).join("")), S.insertCharacterAtPosition(I, k, I.length));
      }, A), A;
    }, this.processChange = function(A, D) {
      var N = S.maskOptions, T = N.mask, R = N.prefix, F = N.lastEditablePosition, z = A.value, O = A.selection, G = D.value, I = D.selection, k = z, B = "", L = 0, V = 0, U = Math.min(I.start, O.start);
      return O.end > I.start ? (B = k.slice(I.start, O.end), V = (L = S.getStringFillingLengthAtPosition(B, U)) ? I.length : 0) : k.length < G.length && (V = G.length - k.length), k = G, V && (V === 1 && !I.length && (U = I.start === O.start ? S.getRightEditablePosition(O.start) : S.getLeftEditablePosition(O.start)), k = S.clearRange(k, U, V)), k = S.insertStringAtPosition(k, B, U), (U += L) >= T.length ? U = T.length : U < R.length && !L ? U = R.length : U >= R.length && U < F && L && (U = S.getRightEditablePosition(U)), { value: k = S.formatValue(k), enteredString: B, selection: { start: U, end: U } };
    }, this.maskOptions = function(A) {
      var D = A.mask, N = A.maskPlaceholder, T = [];
      if (!D)
        return { maskPlaceholder: null, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
      if (typeof D == "string") {
        var R = !1, F = "";
        D.split("").forEach(function(G) {
          R || G !== "\\" ? (!R && _[G] || T.push(F.length), F += G, R = !1) : R = !0;
        }), D = F.split("").map(function(G, I) {
          return T.indexOf(I) === -1 ? _[G] : G;
        });
      } else
        D.forEach(function(G, I) {
          typeof G == "string" && T.push(I);
        });
      N && (N = N.length === 1 ? D.map(function(G, I) {
        return T.indexOf(I) !== -1 ? G : N;
      }) : N.split(""), T.forEach(function(G) {
        N[G] = D[G];
      }), N = N.join(""));
      for (var z = T.filter(function(G, I) {
        return G === I;
      }).map(function(G) {
        return D[G];
      }).join(""), O = D.length - 1; T.indexOf(O) !== -1; )
        O--;
      return { maskPlaceholder: N, prefix: z, mask: D, lastEditablePosition: O, permanents: T };
    }(C);
  }, b = function(C) {
    function S() {
      return C.apply(this, arguments) || this;
    }
    return c(S, C), S.prototype.render = function() {
      var A = this.props, D = A.children, N = l(A, ["children"]);
      return n.cloneElement(D, N);
    }, S;
  }(n.Component), M = r.forwardRef(function(C, S) {
    var A = C.alwaysShowMask, D = C.children, N = C.mask, T = C.maskPlaceholder, R = C.beforeMaskedStateChange, F = l(C, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);
    (function(ir) {
      var _r = ir.mask, yr = ir.maskPlaceholder;
      _r && yr && yr.length !== 1 && yr.length !== _r.length && s(!1);
    })(C);
    var z, O, G = new $({ mask: N, maskPlaceholder: T }), I = !!N, k = !F.disabled && !F.readOnly, B = C.value !== null && C.value !== void 0, L = (z = I, O = r.useRef(), r.useEffect(function() {
      O.current = z;
    }), O.current), V = y(function(ir) {
      return "" + ir;
    }((B ? C.value : C.defaultValue) || ""), I), U = V.inputRef, J = V.getInputState, q = V.setInputState, Z = V.getLastInputState, ae = g(U);
    if (I && B) {
      var ee = ae(), se = ee && u(ee) || A || C.value ? G.formatValue(C.value) : C.value;
      R && (se = R({ nextState: { value: se, selection: { start: null, end: null } } }).value), q(o({}, Z(), { value: se }));
    }
    var nr = Z(), ce = nr.selection, oe = nr.value;
    r.useLayoutEffect(function() {
      if (I) {
        var ir = u(ae()), _r = ce, yr = J(), ne = o({}, yr);
        if (!B) {
          var pe = yr.value, hr = G.formatValue(pe), $r = G.isValueEmpty(hr);
          !$r || ir || A ? ne.value = hr : $r && !ir && (ne.value = "");
        }
        ir && !L ? ne.selection = G.getDefaultSelectionForValue(ne.value) : B && ir && _r && _r.start !== null && _r.end !== null && (ne.selection = _r), R && (ne = R({ currentState: yr, nextState: ne })), q(ne);
      }
    });
    var ur = o({}, F, { onFocus: function(ir) {
      U.current = ir.target;
      var _r = J().value;
      if (I && !G.isValueFilled(_r)) {
        var yr = G.formatValue(_r), ne = G.getDefaultSelectionForValue(yr), pe = { value: yr, selection: ne };
        R && (yr = (pe = R({ currentState: J(), nextState: pe })).value, ne = pe.selection), q(pe), yr !== _r && C.onChange && C.onChange(ir), d(function() {
          q(Z());
        });
      }
      C.onFocus && C.onFocus(ir);
    }, onBlur: function(ir) {
      var _r = J().value, yr = Z().value;
      if (I && !A && G.isValueEmpty(yr)) {
        var ne = "", pe = { value: ne, selection: { start: null, end: null } };
        R && (ne = (pe = R({ currentState: J(), nextState: pe })).value), q(pe), ne !== _r && C.onChange && C.onChange(ir);
      }
      C.onBlur && C.onBlur(ir);
    }, onChange: I && k ? function(ir) {
      var _r = J(), yr = Z(), ne = G.processChange(_r, yr);
      R && (ne = R({ currentState: _r, previousState: yr, nextState: ne })), q(ne), C.onChange && C.onChange(ir);
    } : C.onChange, onMouseDown: I && k ? function(ir) {
      var _r = ae(), yr = J().value, ne = p(_r);
      if (!u(_r) && !G.isValueFilled(yr)) {
        var pe = ir.clientX, hr = ir.clientY, $r = (/* @__PURE__ */ new Date()).getTime();
        ne.addEventListener("mouseup", function Sr(ze) {
          if (ne.removeEventListener("mouseup", Sr), u(_r)) {
            var cr = Math.abs(ze.clientX - pe), fr = Math.abs(ze.clientY - hr), mr = Math.max(cr, fr), wr = (/* @__PURE__ */ new Date()).getTime() - $r;
            if (mr <= 10 && wr <= 200 || mr <= 5 && wr <= 300) {
              var Nr = Z(), xr = o({}, Nr, { selection: G.getDefaultSelectionForValue(Nr.value) });
              q(xr);
            }
          }
        });
      }
      C.onMouseDown && C.onMouseDown(ir);
    } : C.onMouseDown, ref: function(ir) {
      U.current = a.findDOMNode(ir), function(_r) {
        return typeof _r == "function";
      }(S) ? S(ir) : S !== null && typeof S == "object" && (S.current = ir);
    }, value: I && B ? oe : C.value });
    return D ? (function(ir, _r) {
      x.filter(function(yr) {
        return _r.props[yr] != null && _r.props[yr] !== ir[yr];
      }).length && s(!1);
    }(C, D), n.createElement(b, ur, D)) : n.createElement("input", ur);
  });
  return M.displayName = "InputMask", M.defaultProps = { alwaysShowMask: !1, maskPlaceholder: "_" }, reactInputMask_production_min.exports = M, reactInputMask_production_min.exports;
}
var reactInputMask_development, hasRequiredReactInputMask_development;
function requireReactInputMask_development() {
  if (hasRequiredReactInputMask_development)
    return reactInputMask_development;
  hasRequiredReactInputMask_development = 1;
  function t(J) {
    return J && typeof J == "object" && "default" in J ? J.default : J;
  }
  var r = React__default, n = t(r), a = ReactDOM__default, s = t(propTypesExports), o = t(requireBrowser()), c = t(requireWarning());
  function l(J, q) {
    for (var Z = Object.getOwnPropertyNames(q), ae = 0; ae < Z.length; ae++) {
      var ee = Z[ae], se = Object.getOwnPropertyDescriptor(q, ee);
      se && se.configurable && J[ee] === void 0 && Object.defineProperty(J, ee, se);
    }
    return J;
  }
  function d() {
    return d = Object.assign || function(J) {
      for (var q = 1; q < arguments.length; q++) {
        var Z = arguments[q];
        for (var ae in Z)
          Object.prototype.hasOwnProperty.call(Z, ae) && (J[ae] = Z[ae]);
      }
      return J;
    }, d.apply(this, arguments);
  }
  function h(J, q) {
    J.prototype = Object.create(q.prototype), J.prototype.constructor = J, l(J, q);
  }
  function u(J, q) {
    if (J == null)
      return {};
    var Z = {}, ae = Object.keys(J), ee, se;
    for (se = 0; se < ae.length; se++)
      ee = ae[se], !(q.indexOf(ee) >= 0) && (Z[ee] = J[ee]);
    return Z;
  }
  function p(J) {
    return requestAnimationFrame(J);
  }
  function m(J) {
    cancelAnimationFrame(J);
  }
  function g(J, q, Z) {
    Z === void 0 && (Z = q), J.setSelectionRange(q, Z);
  }
  function v(J) {
    var q = J.selectionStart, Z = J.selectionEnd;
    return {
      start: q,
      end: Z,
      length: Z - q
    };
  }
  function y(J) {
    var q = J.ownerDocument;
    return q.hasFocus() && q.activeElement === J;
  }
  function x(J) {
    return J == null ? void 0 : J.ownerDocument;
  }
  function _(J) {
    var q;
    return (q = x(J)) == null ? void 0 : q.defaultView;
  }
  function $(J) {
    var q = _(J);
    return !!q && J instanceof q.HTMLElement;
  }
  function b(J) {
    return typeof J == "function";
  }
  function M(J, q) {
    for (var Z = J.length - 1; Z >= 0; Z--) {
      var ae = J[Z];
      if (q(ae, Z))
        return Z;
    }
    return -1;
  }
  function C(J, q) {
    q === void 0 && (q = 1);
    for (var Z = "", ae = 0; ae < q; ae++)
      Z += J;
    return Z;
  }
  function S(J) {
    return "" + J;
  }
  function A(J) {
    return r.useCallback(function() {
      var q = J.current, Z = typeof window < "u" && $(q);
      if (!q || !Z)
        return null;
      if (q.nodeName !== "INPUT" && (q = q.querySelector("input")), !q)
        throw new Error("react-input-mask: inputComponent doesn't contain input node");
      return q;
    }, [J]);
  }
  function D(J) {
    var q = r.useRef(null), Z = r.useCallback(function() {
      if (q.current !== null)
        return;
      function ee() {
        J(), q.current = p(ee);
      }
      ee();
    }, [J]), ae = r.useCallback(function() {
      m(q.current), q.current = null;
    }, []);
    return r.useEffect(function() {
      q.current && (ae(), Z());
    }, [Z, ae]), r.useEffect(m, []), [Z, ae];
  }
  function N(J, q) {
    var Z = r.useRef({
      start: null,
      end: null
    }), ae = A(J), ee = r.useCallback(function() {
      var _r = ae();
      return v(_r);
    }, [ae]), se = r.useCallback(function() {
      return Z.current;
    }, []), nr = r.useCallback(function(_r) {
      var yr = ae();
      !yr || !y(yr) || (g(yr, _r.start, _r.end), Z.current = ee());
    }, [ae, ee]), ce = r.useCallback(function() {
      Z.current = ee();
    }, [ee]), oe = D(ce), ur = oe[0], ir = oe[1];
    return r.useLayoutEffect(function() {
      if (q) {
        var _r = ae();
        return _r.addEventListener("focus", ur), _r.addEventListener("blur", ir), y(_r) && ur(), function() {
          _r.removeEventListener("focus", ur), _r.removeEventListener("blur", ir), ir();
        };
      }
    }), {
      getSelection: ee,
      getLastSelection: se,
      setSelection: nr
    };
  }
  function T(J, q) {
    var Z = A(J), ae = r.useRef(q), ee = r.useCallback(function() {
      var ce = Z();
      return ce.value;
    }, [Z]), se = r.useCallback(function() {
      return ae.current;
    }, []), nr = r.useCallback(function(ce) {
      ae.current = ce;
      var oe = Z();
      oe && (oe.value = ce);
    }, [Z]);
    return {
      getValue: ee,
      getLastValue: se,
      setValue: nr
    };
  }
  function R(J, q) {
    var Z = r.useRef(), ae = N(Z, q), ee = ae.getSelection, se = ae.getLastSelection, nr = ae.setSelection, ce = T(Z, J), oe = ce.getValue, ur = ce.getLastValue, ir = ce.setValue;
    function _r() {
      return {
        value: ur(),
        selection: se()
      };
    }
    function yr() {
      return {
        value: oe(),
        selection: ee()
      };
    }
    function ne(pe) {
      var hr = pe.value, $r = pe.selection;
      ir(hr), nr($r);
    }
    return {
      inputRef: Z,
      getInputState: yr,
      getLastInputState: _r,
      setInputState: ne
    };
  }
  function F(J) {
    var q = r.useRef();
    return r.useEffect(function() {
      q.current = J;
    }), q.current;
  }
  var z = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"], O = {
    9: /[0-9]/,
    a: /[A-Za-z]/,
    "*": /[A-Za-z0-9]/
  };
  function G(J) {
    process.env.NODE_ENV !== "production" && c(!J.maxLength || !J.mask, "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.");
  }
  function I(J) {
    var q = J.mask, Z = J.maskPlaceholder;
    !q || !Z || Z.length === 1 || Z.length === q.length || (process.env.NODE_ENV !== "production" ? o(!1, `react-input-mask: maskPlaceholder should either be a single character or have the same length as the mask:
` + ("mask: " + q + `
`) + ("maskPlaceholder: " + Z)) : o(!1));
  }
  function k(J, q) {
    var Z = z.filter(function(ae) {
      return q.props[ae] != null && q.props[ae] !== J[ae];
    });
    Z.length && (process.env.NODE_ENV !== "production" ? o(!1, "react-input-mask: the following props should be passed to the InputMask component, not to children: " + Z.join(",")) : o(!1));
  }
  function B(J) {
    var q = J.mask, Z = J.maskPlaceholder, ae = [];
    if (!q)
      return {
        maskPlaceholder: null,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    if (typeof q == "string") {
      var ee = !1, se = "";
      q.split("").forEach(function(oe) {
        !ee && oe === "\\" ? ee = !0 : ((ee || !O[oe]) && ae.push(se.length), se += oe, ee = !1);
      }), q = se.split("").map(function(oe, ur) {
        return ae.indexOf(ur) === -1 ? O[oe] : oe;
      });
    } else
      q.forEach(function(oe, ur) {
        typeof oe == "string" && ae.push(ur);
      });
    Z && (Z.length === 1 ? Z = q.map(function(oe, ur) {
      return ae.indexOf(ur) !== -1 ? oe : Z;
    }) : Z = Z.split(""), ae.forEach(function(oe) {
      Z[oe] = q[oe];
    }), Z = Z.join(""));
    for (var nr = ae.filter(function(oe, ur) {
      return oe === ur;
    }).map(function(oe) {
      return q[oe];
    }).join(""), ce = q.length - 1; ae.indexOf(ce) !== -1; )
      ce--;
    return {
      maskPlaceholder: Z,
      prefix: nr,
      mask: q,
      lastEditablePosition: ce,
      permanents: ae
    };
  }
  var L = function(q) {
    var Z = this;
    this.isCharacterAllowedAtPosition = function(ae, ee) {
      var se = Z.maskOptions.maskPlaceholder;
      return Z.isCharacterFillingPosition(ae, ee) ? !0 : se ? se[ee] === ae : !1;
    }, this.isCharacterFillingPosition = function(ae, ee) {
      var se = Z.maskOptions.mask;
      if (!ae || ee >= se.length)
        return !1;
      if (!Z.isPositionEditable(ee))
        return se[ee] === ae;
      var nr = se[ee];
      return new RegExp(nr).test(ae);
    }, this.isPositionEditable = function(ae) {
      var ee = Z.maskOptions, se = ee.mask, nr = ee.permanents;
      return ae < se.length && nr.indexOf(ae) === -1;
    }, this.isValueEmpty = function(ae) {
      return ae.split("").every(function(ee, se) {
        return !Z.isPositionEditable(se) || !Z.isCharacterFillingPosition(ee, se);
      });
    }, this.isValueFilled = function(ae) {
      return Z.getFilledLength(ae) === Z.maskOptions.lastEditablePosition + 1;
    }, this.getDefaultSelectionForValue = function(ae) {
      var ee = Z.getFilledLength(ae), se = Z.getRightEditablePosition(ee);
      return {
        start: se,
        end: se
      };
    }, this.getFilledLength = function(ae) {
      var ee = ae.split(""), se = M(ee, function(nr, ce) {
        return Z.isPositionEditable(ce) && Z.isCharacterFillingPosition(nr, ce);
      });
      return se + 1;
    }, this.getStringFillingLengthAtPosition = function(ae, ee) {
      var se = ae.split(""), nr = se.reduce(function(ce, oe) {
        return Z.insertCharacterAtPosition(ce, oe, ce.length);
      }, C(" ", ee));
      return nr.length - ee;
    }, this.getLeftEditablePosition = function(ae) {
      for (var ee = ae; ee >= 0; ee--)
        if (Z.isPositionEditable(ee))
          return ee;
      return null;
    }, this.getRightEditablePosition = function(ae) {
      for (var ee = Z.maskOptions.mask, se = ae; se < ee.length; se++)
        if (Z.isPositionEditable(se))
          return se;
      return null;
    }, this.formatValue = function(ae) {
      var ee = Z.maskOptions, se = ee.maskPlaceholder, nr = ee.mask;
      if (!se) {
        for (ae = Z.insertStringAtPosition("", ae, 0); ae.length < nr.length && !Z.isPositionEditable(ae.length); )
          ae += nr[ae.length];
        return ae;
      }
      return Z.insertStringAtPosition(se, ae, 0);
    }, this.clearRange = function(ae, ee, se) {
      if (!se)
        return ae;
      var nr = ee + se, ce = Z.maskOptions, oe = ce.maskPlaceholder, ur = ce.mask, ir = ae.split("").map(function(_r, yr) {
        var ne = Z.isPositionEditable(yr);
        return !oe && yr >= nr && !ne ? "" : yr < ee || yr >= nr ? _r : ne ? oe ? oe[yr] : "" : ur[yr];
      }).join("");
      return Z.formatValue(ir);
    }, this.insertCharacterAtPosition = function(ae, ee, se) {
      var nr = Z.maskOptions, ce = nr.mask, oe = nr.maskPlaceholder;
      if (se >= ce.length)
        return ae;
      var ur = Z.isCharacterAllowedAtPosition(ee, se), ir = Z.isPositionEditable(se), _r = Z.getRightEditablePosition(se), yr = oe && _r ? ee === oe[_r] : null, ne = ae.slice(0, se);
      if (ur || !ir) {
        var pe = ur ? ee : ce[se];
        ae = ne + pe;
      }
      return !ur && !ir && !yr && (ae = Z.insertCharacterAtPosition(ae, ee, se + 1)), ae;
    }, this.insertStringAtPosition = function(ae, ee, se) {
      var nr = Z.maskOptions, ce = nr.mask, oe = nr.maskPlaceholder;
      if (!ee || se >= ce.length)
        return ae;
      var ur = ee.split(""), ir = Z.isValueFilled(ae) || !!oe, _r = ae.slice(se);
      if (ae = ur.reduce(function(ne, pe) {
        return Z.insertCharacterAtPosition(ne, pe, ne.length);
      }, ae.slice(0, se)), ir)
        ae += _r.slice(ae.length - se);
      else if (Z.isValueFilled(ae))
        ae += ce.slice(ae.length).join("");
      else {
        var yr = _r.split("").filter(function(ne, pe) {
          return Z.isPositionEditable(se + pe);
        });
        ae = yr.reduce(function(ne, pe) {
          var hr = Z.getRightEditablePosition(ne.length);
          return hr === null ? ne : (Z.isPositionEditable(ne.length) || (ne += ce.slice(ne.length, hr).join("")), Z.insertCharacterAtPosition(ne, pe, ne.length));
        }, ae);
      }
      return ae;
    }, this.processChange = function(ae, ee) {
      var se = Z.maskOptions, nr = se.mask, ce = se.prefix, oe = se.lastEditablePosition, ur = ae.value, ir = ae.selection, _r = ee.value, yr = ee.selection, ne = ur, pe = "", hr = 0, $r = 0, Sr = Math.min(yr.start, ir.start);
      if (ir.end > yr.start ? (pe = ne.slice(yr.start, ir.end), hr = Z.getStringFillingLengthAtPosition(pe, Sr), hr ? $r = yr.length : $r = 0) : ne.length < _r.length && ($r = _r.length - ne.length), ne = _r, $r) {
        if ($r === 1 && !yr.length) {
          var ze = yr.start === ir.start;
          Sr = ze ? Z.getRightEditablePosition(ir.start) : Z.getLeftEditablePosition(ir.start);
        }
        ne = Z.clearRange(ne, Sr, $r);
      }
      return ne = Z.insertStringAtPosition(ne, pe, Sr), Sr += hr, Sr >= nr.length ? Sr = nr.length : Sr < ce.length && !hr ? Sr = ce.length : Sr >= ce.length && Sr < oe && hr && (Sr = Z.getRightEditablePosition(Sr)), ne = Z.formatValue(ne), {
        value: ne,
        enteredString: pe,
        selection: {
          start: Sr,
          end: Sr
        }
      };
    }, this.maskOptions = B(q);
  }, V = /* @__PURE__ */ function(J) {
    h(q, J);
    function q() {
      return J.apply(this, arguments) || this;
    }
    var Z = q.prototype;
    return Z.render = function() {
      var ee = this.props, se = ee.children, nr = u(ee, ["children"]);
      return n.cloneElement(se, nr);
    }, q;
  }(n.Component), U = r.forwardRef(function(q, Z) {
    var ae = q.alwaysShowMask, ee = q.children, se = q.mask, nr = q.maskPlaceholder, ce = q.beforeMaskedStateChange, oe = u(q, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);
    G(q), I(q);
    var ur = new L({
      mask: se,
      maskPlaceholder: nr
    }), ir = !!se, _r = !oe.disabled && !oe.readOnly, yr = q.value !== null && q.value !== void 0, ne = F(ir), pe = S((yr ? q.value : q.defaultValue) || ""), hr = R(pe, ir), $r = hr.inputRef, Sr = hr.getInputState, ze = hr.setInputState, cr = hr.getLastInputState, fr = A($r);
    function mr(en) {
      var zr = Sr(), Jr = cr(), H = ur.processChange(zr, Jr);
      ce && (H = ce({
        currentState: zr,
        previousState: Jr,
        nextState: H
      })), ze(H), q.onChange && q.onChange(en);
    }
    function wr(en) {
      $r.current = en.target;
      var zr = Sr().value;
      if (ir && !ur.isValueFilled(zr)) {
        var Jr = ur.formatValue(zr), H = ur.getDefaultSelectionForValue(Jr), dr = {
          value: Jr,
          selection: H
        };
        ce && (dr = ce({
          currentState: Sr(),
          nextState: dr
        }), Jr = dr.value, H = dr.selection), ze(dr), Jr !== zr && q.onChange && q.onChange(en), p(function() {
          ze(cr());
        });
      }
      q.onFocus && q.onFocus(en);
    }
    function Nr(en) {
      var zr = Sr().value, Jr = cr().value;
      if (ir && !ae && ur.isValueEmpty(Jr)) {
        var H = "", dr = {
          value: H,
          selection: {
            start: null,
            end: null
          }
        };
        ce && (dr = ce({
          currentState: Sr(),
          nextState: dr
        }), H = dr.value), ze(dr), H !== zr && q.onChange && q.onChange(en);
      }
      q.onBlur && q.onBlur(en);
    }
    function xr(en) {
      var zr = fr(), Jr = Sr(), H = Jr.value, dr = x(zr);
      if (!y(zr) && !ur.isValueFilled(H)) {
        var Ar = en.clientX, jr = en.clientY, Vr = (/* @__PURE__ */ new Date()).getTime(), Zr = function pn(gr) {
          if (dr.removeEventListener("mouseup", pn), !!y(zr)) {
            var Cr = Math.abs(gr.clientX - Ar), Pr = Math.abs(gr.clientY - jr), Tr = Math.max(Cr, Pr), Xr = (/* @__PURE__ */ new Date()).getTime() - Vr;
            if (Tr <= 10 && Xr <= 200 || Tr <= 5 && Xr <= 300) {
              var rn = cr(), un = ur.getDefaultSelectionForValue(rn.value), ln = d({}, rn, {
                selection: un
              });
              ze(ln);
            }
          }
        };
        dr.addEventListener("mouseup", Zr);
      }
      q.onMouseDown && q.onMouseDown(en);
    }
    if (ir && yr) {
      var Er = fr(), Ir = Er && y(Er), Rr = Ir || ae || q.value ? ur.formatValue(q.value) : q.value;
      ce && (Rr = ce({
        nextState: {
          value: Rr,
          selection: {
            start: null,
            end: null
          }
        }
      }).value), ze(d({}, cr(), {
        value: Rr
      }));
    }
    var Yr = cr(), Qr = Yr.selection, nn = Yr.value;
    r.useLayoutEffect(function() {
      if (ir) {
        var en = fr(), zr = y(en), Jr = Qr, H = Sr(), dr = d({}, H);
        if (!yr) {
          var Ar = H.value, jr = ur.formatValue(Ar), Vr = ur.isValueEmpty(jr), Zr = !Vr || zr || ae;
          Zr ? dr.value = jr : Vr && !zr && (dr.value = "");
        }
        zr && !ne ? dr.selection = ur.getDefaultSelectionForValue(dr.value) : yr && zr && Jr && Jr.start !== null && Jr.end !== null && (dr.selection = Jr), ce && (dr = ce({
          currentState: H,
          nextState: dr
        })), ze(dr);
      }
    });
    var on = d({}, oe, {
      onFocus: wr,
      onBlur: Nr,
      onChange: ir && _r ? mr : q.onChange,
      onMouseDown: ir && _r ? xr : q.onMouseDown,
      ref: function(zr) {
        $r.current = a.findDOMNode(zr), b(Z) ? Z(zr) : Z !== null && typeof Z == "object" && (Z.current = zr);
      },
      value: ir && yr ? nn : q.value
    });
    return ee ? (k(q, ee), n.createElement(V, on, ee)) : n.createElement("input", on);
  });
  return U.displayName = "InputMask", U.defaultProps = {
    alwaysShowMask: !1,
    maskPlaceholder: "_"
  }, U.propTypes = {
    alwaysShowMask: s.bool,
    beforeMaskedStateChange: s.func,
    children: s.element,
    mask: s.oneOfType([s.string, s.arrayOf(s.oneOfType([s.string, s.instanceOf(RegExp)]))]),
    maskPlaceholder: s.string,
    onFocus: s.func,
    onBlur: s.func,
    onChange: s.func,
    onMouseDown: s.func
  }, reactInputMask_development = U, reactInputMask_development;
}
process.env.NODE_ENV === "production" ? reactInputMask.exports = requireReactInputMask_production_min() : reactInputMask.exports = requireReactInputMask_development();
var reactInputMaskExports = reactInputMask.exports;
const InputMask = /* @__PURE__ */ getDefaultExportFromCjs(reactInputMaskExports), IbanInput = styled(InputMask)`
  ${TextInputStyles};
`, Iban = ({
  value: t,
  hasError: r,
  hasWarning: n,
  onChange: a,
  readOnly: s
}) => {
  const o = /[a-zA-Z]/, c = /\d/, l = /[a-zA-Z0-9]/, d = /^[a-zA-Z0-9]?$/, h = [o, o, c, c], u = [" ", l, l, l, l], p = [" ", l, l, l, d], m = [" ", d, d, d, d], g = [...h, ...u, ...u, ...p, ...m, ...m, ...m, ...m];
  return /* @__PURE__ */ jsx$1(IbanInput, {
    mask: g,
    maskPlaceholder: "",
    onChange: (y) => {
      const {
        value: x
      } = y.target, _ = formatToUpperCase(x);
      a == null || a(_);
    },
    value: t,
    readOnly: s,
    $hasError: r,
    $hasWarning: n
  });
}, Iban$1 = withInputLayout(Iban), PasswordInput = ({
  value: t,
  hasError: r,
  hasWarning: n,
  readOnly: a,
  onChange: s,
  ...o
}) => /* @__PURE__ */ jsx$1(Input$6, {
  ...o,
  value: t,
  readOnly: a,
  $hasError: r,
  $hasWarning: n,
  onChange: (c) => s == null ? void 0 : s(c.target.value)
}), PasswordLayout = withInputLayout(PasswordInput), Password = ({
  type: t,
  ...r
}) => {
  const [n, a] = useState(!1);
  return /* @__PURE__ */ jsx$1(PasswordLayout, {
    ...r,
    type: n ? "text" : t,
    rigthIcon: n ? "IconShowPassword" : "IconHidePassword",
    rigthButtonClick: () => a(!n)
  });
}, Percentage = ({
  value: t,
  hasError: r,
  hasWarning: n,
  onChange: a,
  ...s
}) => /* @__PURE__ */ jsx$1(InputMask$1, {
  ...s,
  ...currencyOptions.PERCENTAGE,
  type: "text",
  value: t,
  $hasError: r,
  $hasWarning: n,
  displayType: "input",
  onValueChange: (o) => a == null ? void 0 : a(o.value)
}), Percentage$1 = withInputLayout(Percentage), metadata$1 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function edit(t, r, n) {
  switch (n) {
    case "Backspace":
      r > 0 && (t = t.slice(0, r - 1) + t.slice(r), r--);
      break;
    case "Delete":
      t = t.slice(0, r) + t.slice(r + 1);
      break;
  }
  return {
    value: t,
    caret: r
  };
}
function parse$4(t, r, n) {
  for (var a = {}, s = "", o = 0, c = 0; c < t.length; ) {
    var l = n(t[c], s, a);
    l !== void 0 && (s += l, r !== void 0 && (r === c ? o = s.length - 1 : r > c && (o = s.length))), c++;
  }
  r === void 0 && (o = s.length);
  var d = {
    value: s,
    caret: o
  };
  return d;
}
function _createForOfIteratorHelperLoose$d(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$n(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$n(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$n(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$n(t, r);
  }
}
function _arrayLikeToArray$n(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function count_occurences(t, r) {
  for (var n = 0, a = _createForOfIteratorHelperLoose$d(r.split("")), s; !(s = a()).done; ) {
    var o = s.value;
    o === t && n++;
  }
  return n;
}
function closeBraces(t, r) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", s = t.length, o = count_occurences("(", t), c = count_occurences(")", t), l = o - c; l > 0 && s < r.length; )
    t += r[s].replace(n, a), r[s] === ")" && l--, s++;
  return t;
}
function _createForOfIteratorHelperLoose$c(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$m(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$m(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$m(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$m(t, r);
  }
}
function _arrayLikeToArray$m(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function template_formatter(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", n = arguments.length > 2 ? arguments[2] : void 0;
  if (!t)
    return function(s) {
      return {
        text: s
      };
    };
  var a = count_occurences(r, t);
  return function(s) {
    if (!s)
      return {
        text: "",
        template: t
      };
    for (var o = 0, c = "", l = _createForOfIteratorHelperLoose$c(t.split("")), d; !(d = l()).done; ) {
      var h = d.value;
      if (h !== r) {
        c += h;
        continue;
      }
      if (c += s[o], o++, o === s.length && s.length < a)
        break;
    }
    return n && (c = closeBraces(c, t)), {
      text: c,
      template: t
    };
  };
}
function format$7(t, r, n) {
  typeof n == "string" && (n = template_formatter(n));
  var a = n(t) || {}, s = a.text, o = a.template;
  if (s === void 0 && (s = t), o)
    if (r === void 0)
      r = s.length;
    else {
      for (var c = 0, l = !1, d = -1; c < s.length && c < o.length; ) {
        if (s[c] !== o[c]) {
          if (r === 0) {
            l = !0, r = c;
            break;
          }
          d = c, r--;
        }
        c++;
      }
      l || (r = d + 1);
    }
  return {
    text: s,
    caret: r
  };
}
function isReadOnly(t) {
  return t.hasAttribute("readonly");
}
function getSelection(t) {
  if (t.selectionStart !== t.selectionEnd)
    return {
      start: t.selectionStart,
      end: t.selectionEnd
    };
}
var Keys = {
  Backspace: 8,
  Delete: 46
};
function getOperation(t) {
  switch (t.keyCode) {
    case Keys.Backspace:
      return "Backspace";
    case Keys.Delete:
      return "Delete";
  }
}
function getCaretPosition$1(t) {
  return t.selectionStart;
}
function setCaretPosition(t, r) {
  r !== void 0 && (isAndroid() ? setTimeout(function() {
    return t.setSelectionRange(r, r);
  }, 0) : t.setSelectionRange(r, r));
}
function isAndroid() {
  if (typeof navigator < "u")
    return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
}
var ANDROID_USER_AGENT_REG_EXP = /Android/i;
function onChange(t, r, n, a, s) {
  formatInputText(r, n, a, void 0, s);
}
function onKeyDown(t, r, n, a, s) {
  if (!isReadOnly(r)) {
    var o = getOperation(t);
    switch (o) {
      case "Delete":
      case "Backspace":
        t.preventDefault();
        var c = getSelection(r);
        return c ? (eraseSelection(r, c), formatInputText(r, n, a, void 0, s)) : formatInputText(r, n, a, o, s);
    }
  }
}
function eraseSelection(t, r) {
  var n = t.value;
  n = n.slice(0, r.start) + n.slice(r.end), t.value = n, setCaretPosition(t, r.start);
}
function formatInputText(t, r, n, a, s) {
  var o = parse$4(t.value, getCaretPosition$1(t), r), c = o.value, l = o.caret;
  if (a) {
    var d = edit(c, l, a);
    c = d.value, l = d.caret;
  }
  var h = format$7(c, l, n), u = h.text;
  l = h.caret, t.value = u, setCaretPosition(t, l), s(c);
}
var _excluded$f = ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"];
function _objectWithoutProperties$a(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$9(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$9(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function Input$3(t, r) {
  var n = t.value, a = t.parse, s = t.format, o = t.inputComponent, c = t.onChange, l = t.onKeyDown, d = _objectWithoutProperties$a(t, _excluded$f), h = useRef(), u = useCallback(function(g) {
    h.current = g, r && (typeof r == "function" ? r(g) : r.current = g);
  }, [r]), p = useCallback(function(g) {
    return onChange(g, h.current, a, s, c);
  }, [h, a, s, c]), m = useCallback(function(g) {
    if (l && l(g), !g.defaultPrevented)
      return onKeyDown(g, h.current, a, s, c);
  }, [h, a, s, c, l]);
  return /* @__PURE__ */ jsx$1(o, {
    ...d,
    ref: u,
    value: s(isEmptyValue(n) ? "" : n).text,
    onKeyDown: m,
    onChange: p
  });
}
Input$3 = /* @__PURE__ */ React__default.forwardRef(Input$3);
Input$3.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: PropTypes.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: PropTypes.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: PropTypes.elementType.isRequired,
  // `<input/>` `type` attribute.
  type: PropTypes.string.isRequired,
  // Is parsed from <input/> text.
  value: PropTypes.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: PropTypes.func.isRequired,
  // Passthrough
  onKeyDown: PropTypes.func,
  onCut: PropTypes.func,
  onPaste: PropTypes.func
};
Input$3.defaultProps = {
  // Renders `<input/>` by default.
  inputComponent: "input",
  // `<input/>` `type` attribute.
  type: "text"
};
const Input$4 = Input$3;
function isEmptyValue(t) {
  return t == null;
}
function _typeof$l(t) {
  "@babel/helpers - typeof";
  return _typeof$l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof$l(t);
}
function _defineProperties$9(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$a(t, r, n) {
  return r && _defineProperties$9(t.prototype, r), n && _defineProperties$9(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function _classCallCheck$a(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _inherits$2(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), r && _setPrototypeOf$1(t, r);
}
function _createSuper$4(t) {
  var r = _isNativeReflectConstruct$5();
  return function() {
    var a = _getPrototypeOf$2(t), s;
    if (r) {
      var o = _getPrototypeOf$2(this).constructor;
      s = Reflect.construct(a, arguments, o);
    } else
      s = a.apply(this, arguments);
    return _possibleConstructorReturn$2(this, s);
  };
}
function _possibleConstructorReturn$2(t, r) {
  if (r && (_typeof$l(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(t);
}
function _assertThisInitialized$2(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _wrapNativeSuper(t) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function(a) {
    if (a === null || !_isNativeFunction(a))
      return a;
    if (typeof a != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof r < "u") {
      if (r.has(a))
        return r.get(a);
      r.set(a, s);
    }
    function s() {
      return _construct(a, arguments, _getPrototypeOf$2(this).constructor);
    }
    return s.prototype = Object.create(a.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf$1(s, a);
  }, _wrapNativeSuper(t);
}
function _construct(t, r, n) {
  return _isNativeReflectConstruct$5() ? _construct = Reflect.construct : _construct = function(s, o, c) {
    var l = [null];
    l.push.apply(l, o);
    var d = Function.bind.apply(s, l), h = new d();
    return c && _setPrototypeOf$1(h, c.prototype), h;
  }, _construct.apply(null, arguments);
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _isNativeFunction(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function _setPrototypeOf$1(t, r) {
  return _setPrototypeOf$1 = Object.setPrototypeOf || function(a, s) {
    return a.__proto__ = s, a;
  }, _setPrototypeOf$1(t, r);
}
function _getPrototypeOf$2(t) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _getPrototypeOf$2(t);
}
var ParseError = /* @__PURE__ */ function(t) {
  _inherits$2(n, t);
  var r = _createSuper$4(n);
  function n(a) {
    var s;
    return _classCallCheck$a(this, n), s = r.call(this, a), Object.setPrototypeOf(_assertThisInitialized$2(s), n.prototype), s.name = s.constructor.name, s;
  }
  return _createClass$a(n);
}(/* @__PURE__ */ _wrapNativeSuper(Error)), MIN_LENGTH_FOR_NSN = 2, MAX_LENGTH_FOR_NSN = 17, MAX_LENGTH_COUNTRY_CODE = 3, VALID_DIGITS = "0-9０-９٠-٩۰-۹", DASHES = "-‐-―−ー－", SLASHES = "／/", DOTS = "．.", WHITESPACE = "  ­​⁠　", BRACKETS = "()（）［］\\[\\]", TILDES = "~⁓∼～", VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES), PLUS_CHARS = "+＋";
function compare$2(t, r) {
  t = t.split("-"), r = r.split("-");
  for (var n = t[0].split("."), a = r[0].split("."), s = 0; s < 3; s++) {
    var o = Number(n[s]), c = Number(a[s]);
    if (o > c)
      return 1;
    if (c > o)
      return -1;
    if (!isNaN(o) && isNaN(c))
      return 1;
    if (isNaN(o) && !isNaN(c))
      return -1;
  }
  return t[1] && r[1] ? t[1] > r[1] ? 1 : t[1] < r[1] ? -1 : 0 : !t[1] && r[1] ? 1 : t[1] && !r[1] ? -1 : 0;
}
var objectConstructor = {}.constructor;
function isObject$3(t) {
  return t != null && t.constructor === objectConstructor;
}
function _typeof$k(t) {
  "@babel/helpers - typeof";
  return _typeof$k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof$k(t);
}
function _classCallCheck$9(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$9(t, r, n) {
  return r && _defineProperties$8(t.prototype, r), n && _defineProperties$8(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var V3 = "1.2.0", V4 = "1.7.35", DEFAULT_EXT_PREFIX = " ext. ", CALLING_CODE_REG_EXP = /^\d+$/, Metadata = /* @__PURE__ */ function() {
  function t(r) {
    _classCallCheck$9(this, t), validateMetadata(r), this.metadata = r, setVersion.call(this, r);
  }
  return _createClass$9(t, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var a = this.countryCallingCodes()[n];
        if (a && a.length === 1 && a[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, a) {
      if (n && CALLING_CODE_REG_EXP.test(n) && (a = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(n), this);
      } else if (a) {
        if (!this.hasCallingCode(a))
          throw new Error("Unknown calling code: ".concat(a));
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(a), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var a = this.countryCallingCodes()[n];
      if (a)
        return a.length === 1 && a[0].length === 3 ? void 0 : a;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var a = this.getCountryCodesForCallingCode(n);
      if (a)
        return a[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var a = this.getCountryCodeForCallingCode(n);
      if (a)
        return this.getCountryMetadata(a);
      if (this.nonGeographic()) {
        var s = this.nonGeographic()[n];
        if (s)
          return s;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), t;
}(), NumberingPlan = /* @__PURE__ */ function() {
  function t(r, n) {
    _classCallCheck$9(this, t), this.globalMetadataObject = n, this.metadata = r, setVersion.call(this, n.metadata);
  }
  return _createClass$9(t, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, a = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return a.map(function(s) {
        return new Format(s, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && getType(this.types(), n))
        return new Type(getType(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? DEFAULT_EXT_PREFIX : this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]), t;
}(), Format = /* @__PURE__ */ function() {
  function t(r, n) {
    _classCallCheck$9(this, t), this._format = r, this.metadata = n;
  }
  return _createClass$9(t, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), t;
}(), FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/, Type = /* @__PURE__ */ function() {
  function t(r, n) {
    _classCallCheck$9(this, t), this.type = r, this.metadata = n;
  }
  return _createClass$9(t, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), t;
}();
function getType(t, r) {
  switch (r) {
    case "FIXED_LINE":
      return t[0];
    case "MOBILE":
      return t[1];
    case "TOLL_FREE":
      return t[2];
    case "PREMIUM_RATE":
      return t[3];
    case "PERSONAL_NUMBER":
      return t[4];
    case "VOICEMAIL":
      return t[5];
    case "UAN":
      return t[6];
    case "PAGER":
      return t[7];
    case "VOIP":
      return t[8];
    case "SHARED_COST":
      return t[9];
  }
}
function validateMetadata(t) {
  if (!t)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!isObject$3(t) || !isObject$3(t.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject$3(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + typeOf$3(t) + ": " + t, "."));
}
var typeOf$3 = function(r) {
  return _typeof$k(r);
};
function getCountryCallingCode(t, r) {
  if (r = new Metadata(r), r.hasCountry(t))
    return r.country(t).countryCallingCode();
  throw new Error("Unknown country: ".concat(t));
}
function isSupportedCountry(t, r) {
  return r.countries.hasOwnProperty(t);
}
function setVersion(t) {
  var r = t.version;
  typeof r == "number" ? (this.v1 = r === 1, this.v2 = r === 2, this.v3 = r === 3, this.v4 = r === 4) : r ? compare$2(r, V3) === -1 ? this.v2 = !0 : compare$2(r, V4) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var RFC3966_EXTN_PREFIX = ";ext=", getExtensionDigitsPattern = function(r) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(r, "})");
};
function createExtensionPattern(t) {
  var r = "20", n = "15", a = "9", s = "6", o = "[  \\t,]*", c = "[:\\.．]?[  \\t,-]*", l = "#?", d = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", h = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", p = "[  \\t]*", m = "(?:,{2}|;)", g = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(r), v = o + d + c + getExtensionDigitsPattern(r) + l, y = o + h + c + getExtensionDigitsPattern(a) + l, x = u + getExtensionDigitsPattern(s) + "#", _ = p + m + c + getExtensionDigitsPattern(n) + l, $ = p + "(?:,)+" + c + getExtensionDigitsPattern(a) + l;
  return g + "|" + v + "|" + y + "|" + x + "|" + _ + "|" + $;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}", VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*", VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i"), VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?", VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(t) {
  return t.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(t);
}
function isViablePhoneNumberStart(t) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(t);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(t) {
  var r = t.search(EXTN_PATTERN);
  if (r < 0)
    return {};
  for (var n = t.slice(0, r), a = t.match(EXTN_PATTERN), s = 1; s < a.length; ) {
    if (a[s])
      return {
        number: n,
        ext: a[s]
      };
    s++;
  }
}
function _createForOfIteratorHelperLoose$b(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$l(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$l(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$l(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$l(t, r);
  }
}
function _arrayLikeToArray$l(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
var DIGITS = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(t) {
  return DIGITS[t];
}
function parseDigits(t) {
  for (var r = "", n = _createForOfIteratorHelperLoose$b(t.split("")), a; !(a = n()).done; ) {
    var s = a.value, o = parseDigit(s);
    o && (r += o);
  }
  return r;
}
function _createForOfIteratorHelperLoose$a(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$k(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$k(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$k(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$k(t, r);
  }
}
function _arrayLikeToArray$k(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function parseIncompletePhoneNumber(t) {
  for (var r = "", n = _createForOfIteratorHelperLoose$a(t.split("")), a; !(a = n()).done; ) {
    var s = a.value;
    r += parsePhoneNumberCharacter(s, r) || "";
  }
  return r;
}
function parsePhoneNumberCharacter(t, r, n) {
  if (t === "+") {
    if (r) {
      typeof n == "function" && n("end");
      return;
    }
    return "+";
  }
  return parseDigit(t);
}
function _createForOfIteratorHelperLoose$9(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$j(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$j(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$j(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$j(t, r);
  }
}
function _arrayLikeToArray$j(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function mergeArrays(t, r) {
  for (var n = t.slice(), a = _createForOfIteratorHelperLoose$9(r), s; !(s = a()).done; ) {
    var o = s.value;
    t.indexOf(o) < 0 && n.push(o);
  }
  return n.sort(function(c, l) {
    return c - l;
  });
}
function checkNumberLength(t, r) {
  return checkNumberLengthForType(t, void 0, r);
}
function checkNumberLengthForType(t, r, n) {
  var a = n.type(r), s = a && a.possibleLengths() || n.possibleLengths();
  if (!s)
    return "IS_POSSIBLE";
  if (r === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return checkNumberLengthForType(t, "MOBILE", n);
    var o = n.type("MOBILE");
    o && (s = mergeArrays(s, o.possibleLengths()));
  } else if (r && !a)
    return "INVALID_LENGTH";
  var c = t.length, l = s[0];
  return l === c ? "IS_POSSIBLE" : l > c ? "TOO_SHORT" : s[s.length - 1] < c ? "TOO_LONG" : s.indexOf(c, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(t, r, n) {
  if (r === void 0 && (r = {}), n = new Metadata(n), r.v2) {
    if (!t.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(t.countryCallingCode);
  } else {
    if (!t.phone)
      return !1;
    if (t.country) {
      if (!n.hasCountry(t.country))
        throw new Error("Unknown country: ".concat(t.country));
      n.country(t.country);
    } else {
      if (!t.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(t.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return isPossibleNumber(t.phone || t.nationalNumber, n);
  if (t.countryCallingCode && n.isNonGeographicCallingCode(t.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function isPossibleNumber(t, r) {
  switch (checkNumberLength(t, r)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function matchesEntirely(t, r) {
  return t = t || "", new RegExp("^(?:" + r + ")$").test(t);
}
function _createForOfIteratorHelperLoose$8(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$i(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$i(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$i(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$i(t, r);
  }
}
function _arrayLikeToArray$i(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(t, r, n) {
  if (r = r || {}, !(!t.country && !t.countryCallingCode)) {
    n = new Metadata(n), n.selectNumberingPlan(t.country, t.countryCallingCode);
    var a = r.v2 ? t.nationalNumber : t.phone;
    if (matchesEntirely(a, n.nationalNumberPattern())) {
      if (isNumberTypeEqualTo(a, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || isNumberTypeEqualTo(a, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var s = _createForOfIteratorHelperLoose$8(NON_FIXED_LINE_PHONE_TYPES), o; !(o = s()).done; ) {
        var c = o.value;
        if (isNumberTypeEqualTo(a, c, n))
          return c;
      }
    }
  }
}
function isNumberTypeEqualTo(t, r, n) {
  return r = n.type(r), !r || !r.pattern() || r.possibleLengths() && r.possibleLengths().indexOf(t.length) < 0 ? !1 : matchesEntirely(t, r.pattern());
}
function isValidNumber(t, r, n) {
  if (r = r || {}, n = new Metadata(n), n.selectNumberingPlan(t.country, t.countryCallingCode), n.hasTypes())
    return getNumberType(t, r, n.metadata) !== void 0;
  var a = r.v2 ? t.nationalNumber : t.phone;
  return matchesEntirely(a, n.nationalNumberPattern());
}
function getPossibleCountriesForNumber(t, r, n) {
  var a = new Metadata(n), s = a.getCountryCodesForCallingCode(t);
  return s ? s.filter(function(o) {
    return couldNationalNumberBelongToCountry(r, o, n);
  }) : [];
}
function couldNationalNumberBelongToCountry(t, r, n) {
  var a = new Metadata(n);
  return a.selectNumberingPlan(r), a.numberingPlan.possibleLengths().indexOf(t.length) >= 0;
}
function applyInternationalSeparatorStyle(t) {
  return t.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(t, r, n) {
  var a = n.useInternationalFormat, s = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var o = t.replace(new RegExp(r.pattern()), a ? r.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    s && r.nationalPrefixFormattingRule() ? r.format().replace(FIRST_GROUP_PATTERN, r.nationalPrefixFormattingRule()) : r.format()
  ));
  return a ? applyInternationalSeparatorStyle(o) : o;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(t, r, n) {
  var a = new Metadata(n);
  if (a.selectNumberingPlan(t, r), a.defaultIDDPrefix())
    return a.defaultIDDPrefix();
  if (SINGLE_IDD_PREFIX_REG_EXP.test(a.IDDPrefix()))
    return a.IDDPrefix();
}
function formatRFC3966(t) {
  var r = t.number, n = t.ext;
  if (!r)
    return "";
  if (r[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(r).concat(n ? ";ext=" + n : "");
}
function _createForOfIteratorHelperLoose$7(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$h(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$h(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$h(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$h(t, r);
  }
}
function _arrayLikeToArray$h(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function ownKeys$g(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$g(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$g(Object(n), !0).forEach(function(a) {
      _defineProperty$d(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$g(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$d(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
var DEFAULT_OPTIONS = {
  formatExtension: function(r, n, a) {
    return "".concat(r).concat(a.ext()).concat(n);
  }
};
function formatNumber(t, r, n, a) {
  if (n ? n = _objectSpread$g(_objectSpread$g({}, DEFAULT_OPTIONS), n) : n = DEFAULT_OPTIONS, a = new Metadata(a), t.country && t.country !== "001") {
    if (!a.hasCountry(t.country))
      throw new Error("Unknown country: ".concat(t.country));
    a.country(t.country);
  } else if (t.countryCallingCode)
    a.selectNumberingPlan(t.countryCallingCode);
  else
    return t.phone || "";
  var s = a.countryCallingCode(), o = n.v2 ? t.nationalNumber : t.phone, c;
  switch (r) {
    case "NATIONAL":
      return o ? (c = formatNationalNumber$1(o, t.carrierCode, "NATIONAL", a, n), addExtension(c, t.ext, a, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (c = formatNationalNumber$1(o, null, "INTERNATIONAL", a, n), c = "+".concat(s, " ").concat(c), addExtension(c, t.ext, a, n.formatExtension)) : "+".concat(s);
    case "E.164":
      return "+".concat(s).concat(o);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(s).concat(o),
        ext: t.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var l = formatIDD(o, t.carrierCode, s, n.fromCountry, a);
      return addExtension(l, t.ext, a, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(r, '"'));
  }
}
function formatNationalNumber$1(t, r, n, a, s) {
  var o = chooseFormatForNumber(a.formats(), t);
  return o ? formatNationalNumberUsingFormat(t, o, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && s && s.nationalPrefix === !1),
    carrierCode: r,
    metadata: a
  }) : t;
}
function chooseFormatForNumber(t, r) {
  for (var n = _createForOfIteratorHelperLoose$7(t), a; !(a = n()).done; ) {
    var s = a.value;
    if (s.leadingDigitsPatterns().length > 0) {
      var o = s.leadingDigitsPatterns()[s.leadingDigitsPatterns().length - 1];
      if (r.search(o) !== 0)
        continue;
    }
    if (matchesEntirely(r, s.pattern()))
      return s;
  }
}
function addExtension(t, r, n, a) {
  return r ? a(t, r, n) : t;
}
function formatIDD(t, r, n, a, s) {
  var o = getCountryCallingCode(a, s.metadata);
  if (o === n) {
    var c = formatNationalNumber$1(t, r, "NATIONAL", s);
    return n === "1" ? n + " " + c : c;
  }
  var l = getIddPrefix(a, void 0, s.metadata);
  if (l)
    return "".concat(l, " ").concat(n, " ").concat(formatNationalNumber$1(t, null, "INTERNATIONAL", s));
}
function ownKeys$f(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$f(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$f(Object(n), !0).forEach(function(a) {
      _defineProperty$c(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$f(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$c(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function _classCallCheck$8(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$8(t, r, n) {
  return r && _defineProperties$7(t.prototype, r), n && _defineProperties$7(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function t(r, n, a) {
    if (_classCallCheck$8(this, t), !r)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!a)
      throw new TypeError("`metadata` not passed");
    var s = getCountryAndCountryCallingCode(r, a), o = s.country, c = s.countryCallingCode;
    this.country = o, this.countryCallingCode = c, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return a;
    };
  }
  return _createClass$8(t, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return isPossiblePhoneNumber(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return isValidNumber(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Metadata(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return getNumberType(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, a) {
      return formatNumber(this, n, a ? _objectSpread$f(_objectSpread$f({}, a), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), t;
}(), isCountryCode = function(r) {
  return /^[A-Z]{2}$/.test(r);
};
function getCountryAndCountryCallingCode(t, r) {
  var n, a, s = new Metadata(r);
  return isCountryCode(t) ? (n = t, s.selectNumberingPlan(n), a = s.countryCallingCode()) : a = t, {
    country: n,
    countryCallingCode: a
  };
}
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(t, r, n, a) {
  if (r) {
    var s = new Metadata(a);
    s.selectNumberingPlan(r, n);
    var o = new RegExp(s.IDDPrefix());
    if (t.search(o) === 0) {
      t = t.slice(t.match(o)[0].length);
      var c = t.match(CAPTURING_DIGIT_PATTERN);
      if (!(c && c[1] != null && c[1].length > 0 && c[1] === "0"))
        return t;
    }
  }
}
function extractNationalNumberFromPossiblyIncompleteNumber(t, r) {
  if (t && r.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + r.numberingPlan.nationalPrefixForParsing() + ")"), a = n.exec(t);
    if (a) {
      var s, o, c = a.length - 1, l = c > 0 && a[c];
      if (r.nationalPrefixTransformRule() && l)
        s = t.replace(n, r.nationalPrefixTransformRule()), c > 1 && (o = a[1]);
      else {
        var d = a[0];
        s = t.slice(d.length), l && (o = a[1]);
      }
      var h;
      if (l) {
        var u = t.indexOf(a[1]), p = t.slice(0, u);
        p === r.numberingPlan.nationalPrefix() && (h = r.numberingPlan.nationalPrefix());
      } else
        h = a[0];
      return {
        nationalNumber: s,
        nationalPrefix: h,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: t
  };
}
function extractNationalNumber(t, r) {
  var n = extractNationalNumberFromPossiblyIncompleteNumber(t, r), a = n.carrierCode, s = n.nationalNumber;
  if (s !== t) {
    if (!shouldHaveExtractedNationalPrefix(t, s, r))
      return {
        nationalNumber: t
      };
    if (r.possibleLengths() && !isPossibleIncompleteNationalNumber(s, r))
      return {
        nationalNumber: t
      };
  }
  return {
    nationalNumber: s,
    carrierCode: a
  };
}
function shouldHaveExtractedNationalPrefix(t, r, n) {
  return !(matchesEntirely(t, n.nationalNumberPattern()) && !matchesEntirely(r, n.nationalNumberPattern()));
}
function isPossibleIncompleteNationalNumber(t, r) {
  switch (checkNumberLength(t, r)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(t, r, n, a) {
  var s = r ? getCountryCallingCode(r, a) : n;
  if (t.indexOf(s) === 0) {
    a = new Metadata(a), a.selectNumberingPlan(r, n);
    var o = t.slice(s.length), c = extractNationalNumber(o, a), l = c.nationalNumber, d = extractNationalNumber(t, a), h = d.nationalNumber;
    if (!matchesEntirely(h, a.nationalNumberPattern()) && matchesEntirely(l, a.nationalNumberPattern()) || checkNumberLength(h, a) === "TOO_LONG")
      return {
        countryCallingCode: s,
        number: o
      };
  }
  return {
    number: t
  };
}
function extractCountryCallingCode(t, r, n, a) {
  if (!t)
    return {};
  var s;
  if (t[0] !== "+") {
    var o = stripIddPrefix(t, r, n, a);
    if (o && o !== t)
      s = !0, t = "+" + o;
    else {
      if (r || n) {
        var c = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(t, r, n, a), l = c.countryCallingCode, d = c.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: t
      };
    }
  }
  if (t[1] === "0")
    return {};
  a = new Metadata(a);
  for (var h = 2; h - 1 <= MAX_LENGTH_COUNTRY_CODE && h <= t.length; ) {
    var u = t.slice(1, h);
    if (a.hasCallingCode(u))
      return a.selectNumberingPlan(u), {
        countryCallingCodeSource: s ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: t.slice(h)
      };
    h++;
  }
  return {};
}
function _createForOfIteratorHelperLoose$6(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$g(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$g(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$g(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$g(t, r);
  }
}
function _arrayLikeToArray$g(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function getCountryByNationalNumber(t, r) {
  var n = r.countries, a = r.defaultCountry, s = r.metadata;
  s = new Metadata(s);
  for (var o = [], c = _createForOfIteratorHelperLoose$6(n), l; !(l = c()).done; ) {
    var d = l.value;
    if (s.country(d), s.leadingDigits()) {
      if (t && t.search(s.leadingDigits()) === 0)
        return d;
    } else if (getNumberType({
      phone: t,
      country: d
    }, void 0, s.metadata))
      if (a) {
        if (d === a)
          return d;
        o.push(d);
      } else
        return d;
  }
  if (o.length > 0)
    return o[0];
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = !1;
function getCountryByCallingCode(t, r) {
  var n = r.nationalNumber, a = r.defaultCountry, s = r.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE && s.isNonGeographicCallingCode(t))
    return "001";
  var o = s.getCountryCodesForCallingCode(t);
  if (o)
    return o.length === 1 ? o[0] : getCountryByNationalNumber(n, {
      countries: o,
      defaultCountry: a,
      metadata: s.metadata
    });
}
var PLUS_SIGN = "+", RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?", RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")", RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$", RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g"), ALPHANUM_ = VALID_DIGITS, RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*", VALID_ALPHA_ = "a-zA-Z", RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*", RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$", RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g"), RFC3966_PREFIX_ = "tel:", RFC3966_PHONE_CONTEXT_ = ";phone-context=", RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(t) {
  var r = t.indexOf(RFC3966_PHONE_CONTEXT_);
  if (r < 0)
    return null;
  var n = r + RFC3966_PHONE_CONTEXT_.length;
  if (n >= t.length)
    return "";
  var a = t.indexOf(";", n);
  return a >= 0 ? t.substring(n, a) : t.substring(n);
}
function isPhoneContextValid(t) {
  return t === null ? !0 : t.length === 0 ? !1 : RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(t) || RFC3966_DOMAINNAME_PATTERN_.test(t);
}
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(t, r) {
  var n = r.extractFormattedPhoneNumber, a = extractPhoneContext(t);
  if (!isPhoneContextValid(a))
    throw new ParseError("NOT_A_NUMBER");
  var s;
  if (a === null)
    s = n(t) || "";
  else {
    s = "", a.charAt(0) === PLUS_SIGN && (s += a);
    var o = t.indexOf(RFC3966_PREFIX_), c;
    o >= 0 ? c = o + RFC3966_PREFIX_.length : c = 0;
    var l = t.indexOf(RFC3966_PHONE_CONTEXT_);
    s += t.substring(c, l);
  }
  var d = s.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (d > 0 && (s = s.substring(0, d)), s !== "")
    return s;
}
var MAX_INPUT_STRING_LENGTH = 250, PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]"), AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse$3(t, r, n) {
  if (r = r || {}, n = new Metadata(n), r.defaultCountry && !n.hasCountry(r.defaultCountry))
    throw r.v2 ? new ParseError("INVALID_COUNTRY") : new Error("Unknown country: ".concat(r.defaultCountry));
  var a = parseInput(t, r.v2, r.extract), s = a.number, o = a.ext, c = a.error;
  if (!s) {
    if (r.v2)
      throw c === "TOO_SHORT" ? new ParseError("TOO_SHORT") : new ParseError("NOT_A_NUMBER");
    return {};
  }
  var l = parsePhoneNumber$3(s, r.defaultCountry, r.defaultCallingCode, n), d = l.country, h = l.nationalNumber, u = l.countryCallingCode, p = l.countryCallingCodeSource, m = l.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (r.v2)
      throw new ParseError("INVALID_COUNTRY");
    return {};
  }
  if (!h || h.length < MIN_LENGTH_FOR_NSN) {
    if (r.v2)
      throw new ParseError("TOO_SHORT");
    return {};
  }
  if (h.length > MAX_LENGTH_FOR_NSN) {
    if (r.v2)
      throw new ParseError("TOO_LONG");
    return {};
  }
  if (r.v2) {
    var g = new PhoneNumber(u, h, n.metadata);
    return d && (g.country = d), m && (g.carrierCode = m), o && (g.ext = o), g.__countryCallingCodeSource = p, g;
  }
  var v = (r.extended ? n.hasSelectedNumberingPlan() : d) ? matchesEntirely(h, n.nationalNumberPattern()) : !1;
  return r.extended ? {
    country: d,
    countryCallingCode: u,
    carrierCode: m,
    valid: v,
    possible: v ? !0 : !!(r.extended === !0 && n.possibleLengths() && isPossibleNumber(h, n)),
    phone: h,
    ext: o
  } : v ? result(d, h, o) : {};
}
function _extractFormattedPhoneNumber(t, r, n) {
  if (t) {
    if (t.length > MAX_INPUT_STRING_LENGTH) {
      if (n)
        throw new ParseError("TOO_LONG");
      return;
    }
    if (r === !1)
      return t;
    var a = t.search(PHONE_NUMBER_START_PATTERN);
    if (!(a < 0))
      return t.slice(a).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
  }
}
function parseInput(t, r, n) {
  var a = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(t, {
    extractFormattedPhoneNumber: function(c) {
      return _extractFormattedPhoneNumber(c, n, r);
    }
  });
  if (!a)
    return {};
  if (!isViablePhoneNumber(a))
    return isViablePhoneNumberStart(a) ? {
      error: "TOO_SHORT"
    } : {};
  var s = extractExtension(a);
  return s.ext ? s : {
    number: a
  };
}
function result(t, r, n) {
  var a = {
    country: t,
    phone: r
  };
  return n && (a.ext = n), a;
}
function parsePhoneNumber$3(t, r, n, a) {
  var s = extractCountryCallingCode(parseIncompletePhoneNumber(t), r, n, a.metadata), o = s.countryCallingCodeSource, c = s.countryCallingCode, l = s.number, d;
  if (c)
    a.selectNumberingPlan(c);
  else if (l && (r || n))
    a.selectNumberingPlan(r, n), r && (d = r), c = n || getCountryCallingCode(r, a.metadata);
  else
    return {};
  if (!l)
    return {
      countryCallingCodeSource: o,
      countryCallingCode: c
    };
  var h = extractNationalNumber(parseIncompletePhoneNumber(l), a), u = h.nationalNumber, p = h.carrierCode, m = getCountryByCallingCode(c, {
    nationalNumber: u,
    defaultCountry: r,
    metadata: a
  });
  return m && (d = m, m === "001" || a.country(d)), {
    country: d,
    countryCallingCode: c,
    countryCallingCodeSource: o,
    nationalNumber: u,
    carrierCode: p
  };
}
function ownKeys$e(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$e(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$e(Object(n), !0).forEach(function(a) {
      _defineProperty$b(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$e(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$b(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function parsePhoneNumberWithError(t, r, n) {
  return parse$3(t, _objectSpread$e(_objectSpread$e({}, r), {}, {
    v2: !0
  }), n);
}
function ownKeys$d(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$d(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$d(Object(n), !0).forEach(function(a) {
      _defineProperty$a(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$d(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$a(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function _slicedToArray$7(t, r) {
  return _arrayWithHoles$7(t) || _iterableToArrayLimit$7(t, r) || _unsupportedIterableToArray$f(t, r) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$f(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$f(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$f(t, r);
  }
}
function _arrayLikeToArray$f(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _iterableToArrayLimit$7(t, r) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a = [], s = !0, o = !1, c, l;
    try {
      for (n = n.call(t); !(s = (c = n.next()).done) && (a.push(c.value), !(r && a.length === r)); s = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function _arrayWithHoles$7(t) {
  if (Array.isArray(t))
    return t;
}
function normalizeArguments(t) {
  var r = Array.prototype.slice.call(t), n = _slicedToArray$7(r, 4), a = n[0], s = n[1], o = n[2], c = n[3], l, d, h;
  if (typeof a == "string")
    l = a;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!s || typeof s == "string")
    c ? (d = o, h = c) : (d = void 0, h = o), s && (d = _objectSpread$d({
      defaultCountry: s
    }, d));
  else if (isObject$3(s))
    o ? (d = s, h = o) : h = s;
  else
    throw new Error("Invalid second argument: ".concat(s));
  return {
    text: l,
    options: d,
    metadata: h
  };
}
function ownKeys$c(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$c(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$c(Object(n), !0).forEach(function(a) {
      _defineProperty$9(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$c(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$9(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function parsePhoneNumber$2(t, r, n) {
  r && r.defaultCountry && !isSupportedCountry(r.defaultCountry, n) && (r = _objectSpread$c(_objectSpread$c({}, r), {}, {
    defaultCountry: void 0
  }));
  try {
    return parsePhoneNumberWithError(t, r, n);
  } catch (a) {
    if (!(a instanceof ParseError))
      throw a;
  }
}
function parsePhoneNumber$1() {
  var t = normalizeArguments(arguments), r = t.text, n = t.options, a = t.metadata;
  return parsePhoneNumber$2(r, n, a);
}
function ownKeys$b(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$b(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$b(Object(n), !0).forEach(function(a) {
      _defineProperty$8(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$b(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$8(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function isValidPhoneNumber$1() {
  var t = normalizeArguments(arguments), r = t.text, n = t.options, a = t.metadata;
  n = _objectSpread$b(_objectSpread$b({}, n), {}, {
    extract: !1
  });
  var s = parsePhoneNumber$2(r, n, a);
  return s && s.isValid() || !1;
}
function _classCallCheck$7(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$7(t, r, n) {
  return r && _defineProperties$6(t.prototype, r), n && _defineProperties$6(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var AsYouTypeState = /* @__PURE__ */ function() {
  function t(r) {
    var n = r.onCountryChange, a = r.onCallingCodeChange;
    _classCallCheck$7(this, t), this.onCountryChange = n, this.onCallingCodeChange = a;
  }
  return _createClass$7(t, [{
    key: "reset",
    value: function(n) {
      var a = n.country, s = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(a, s);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var a = 0, s = Object.keys(n); a < s.length; a++) {
        var o = s[a];
        this[o] = n[o];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, a) {
      this.setCountry(n), this.setCallingCode(a);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, a) {
      this.international = !0, this.initCountryAndCallingCode(n, a);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), t;
}();
function _createForOfIteratorHelperLoose$5(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$e(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$e(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$e(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$e(t, r);
  }
}
function _arrayLikeToArray$e(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
var DIGIT_PLACEHOLDER = "x", DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
function repeat(t, r) {
  if (r < 1)
    return "";
  for (var n = ""; r > 1; )
    r & 1 && (n += t), r >>= 1, t += t;
  return n + t;
}
function cutAndStripNonPairedParens(t, r) {
  return t[r] === ")" && r++, stripNonPairedParens(t.slice(0, r));
}
function stripNonPairedParens(t) {
  for (var r = [], n = 0; n < t.length; )
    t[n] === "(" ? r.push(n) : t[n] === ")" && r.pop(), n++;
  var a = 0, s = "";
  r.push(t.length);
  for (var o = 0, c = r; o < c.length; o++) {
    var l = c[o];
    s += t.slice(a, l), a = l + 1;
  }
  return s;
}
function populateTemplateWithDigits(t, r, n) {
  for (var a = _createForOfIteratorHelperLoose$5(n.split("")), s; !(s = a()).done; ) {
    var o = s.value;
    if (t.slice(r + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0)
      return;
    r = t.search(DIGIT_PLACEHOLDER_MATCHER), t = t.replace(DIGIT_PLACEHOLDER_MATCHER, o);
  }
  return [t, r];
}
function formatCompleteNumber(t, r, n) {
  var a = n.metadata, s = n.shouldTryNationalPrefixFormattingRule, o = n.getSeparatorAfterNationalPrefix, c = new RegExp("^(?:".concat(r.pattern(), ")$"));
  if (c.test(t.nationalSignificantNumber))
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(t, r, {
      metadata: a,
      shouldTryNationalPrefixFormattingRule: s,
      getSeparatorAfterNationalPrefix: o
    });
}
function canFormatCompleteNumber(t, r) {
  return checkNumberLength(t, r) === "IS_POSSIBLE";
}
function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(t, r, n) {
  var a = n.metadata, s = n.shouldTryNationalPrefixFormattingRule, o = n.getSeparatorAfterNationalPrefix;
  if (t.nationalSignificantNumber, t.international, t.nationalPrefix, t.carrierCode, s(r)) {
    var c = formatNationalNumber(t, r, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: o,
      metadata: a
    });
    if (c)
      return c;
  }
  return formatNationalNumber(t, r, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: o,
    metadata: a
  });
}
function formatNationalNumber(t, r, n) {
  var a = n.metadata, s = n.useNationalPrefixFormattingRule, o = n.getSeparatorAfterNationalPrefix, c = formatNationalNumberUsingFormat(t.nationalSignificantNumber, r, {
    carrierCode: t.carrierCode,
    useInternationalFormat: t.international,
    withNationalPrefix: s,
    metadata: a
  });
  if (s || (t.nationalPrefix ? c = t.nationalPrefix + o(r) + c : t.complexPrefixBeforeNationalSignificantNumber && (c = t.complexPrefixBeforeNationalSignificantNumber + " " + c)), isValidFormattedNationalNumber(c, t))
    return c;
}
function isValidFormattedNationalNumber(t, r) {
  return parseDigits(t) === r.getNationalDigits();
}
function _classCallCheck$6(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$6(t, r, n) {
  return r && _defineProperties$5(t.prototype, r), n && _defineProperties$5(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var PatternParser = /* @__PURE__ */ function() {
  function t() {
    _classCallCheck$6(this, t);
  }
  return _createClass$6(t, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var a = this.context[0], s = a.branches, o = a.instructions;
      if (s)
        return {
          op: "|",
          args: s.concat([expandSingleElementArray(o)])
        };
      if (o.length === 0)
        throw new Error("Pattern is required");
      return o.length === 1 ? o[0] : o;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var a = n.match(OPERATOR);
      if (!a) {
        if (ILLEGAL_CHARACTER_REGEXP.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var s = a[1], o = n.slice(0, a.index), c = n.slice(a.index + s.length);
      switch (s) {
        case "(?:":
          o && this.parsePattern(o), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (o && this.parsePattern(o), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var l = this.getContext(), d = l.branches;
          d.push(expandSingleElementArray(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: d
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (o && this.parsePattern(o), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          o && this.parsePattern(o), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: parseOneOfSet(o)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(s));
      }
      c && this.parsePattern(c);
    }
  }]), t;
}();
function parseOneOfSet(t) {
  for (var r = [], n = 0; n < t.length; ) {
    if (t[n] === "-") {
      if (n === 0 || n === t.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(t));
      for (var a = t[n - 1].charCodeAt(0) + 1, s = t[n + 1].charCodeAt(0) - 1, o = a; o <= s; )
        r.push(String.fromCharCode(o)), o++;
    } else
      r.push(t[n]);
    n++;
  }
  return r;
}
var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/, OPERATOR = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function expandSingleElementArray(t) {
  return t.length === 1 ? t[0] : t;
}
function _createForOfIteratorHelperLoose$4(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$d(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$d(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$d(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$d(t, r);
  }
}
function _arrayLikeToArray$d(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _classCallCheck$5(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$5(t, r, n) {
  return r && _defineProperties$4(t.prototype, r), n && _defineProperties$4(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var PatternMatcher = /* @__PURE__ */ function() {
  function t(r) {
    _classCallCheck$5(this, t), this.matchTree = new PatternParser().parse(r);
  }
  return _createClass$5(t, [{
    key: "match",
    value: function(n) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = a.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var o = _match(n.split(""), this.matchTree, !0);
      if (o && o.match && delete o.matchedChars, !(o && o.overflow && !s))
        return o;
    }
  }]), t;
}();
function _match(t, r, n) {
  if (typeof r == "string") {
    var a = t.join("");
    return r.indexOf(a) === 0 ? t.length === r.length ? {
      match: !0,
      matchedChars: t
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : a.indexOf(r) === 0 ? n && t.length > r.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: t.slice(0, r.length)
    } : void 0;
  }
  if (Array.isArray(r)) {
    for (var s = t.slice(), o = 0; o < r.length; ) {
      var c = r[o], l = _match(s, c, n && o === r.length - 1);
      if (l) {
        if (l.overflow)
          return l;
        if (l.match) {
          if (s = s.slice(l.matchedChars.length), s.length === 0)
            return o === r.length - 1 ? {
              match: !0,
              matchedChars: t
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (l.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(l, null, 2)));
        }
      } else
        return;
      o++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: t.slice(0, t.length - s.length)
    };
  }
  switch (r.op) {
    case "|":
      for (var d, h = _createForOfIteratorHelperLoose$4(r.args), u; !(u = h()).done; ) {
        var p = u.value, m = _match(t, p, n);
        if (m) {
          if (m.overflow)
            return m;
          if (m.match)
            return {
              match: !0,
              matchedChars: m.matchedChars
            };
          if (m.partialMatch)
            d = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(m, null, 2)));
        }
      }
      return d ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var g = _createForOfIteratorHelperLoose$4(r.args), v; !(v = g()).done; ) {
        var y = v.value;
        if (t[0] === y)
          return t.length === 1 ? {
            match: !0,
            matchedChars: t
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [y]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(r));
  }
}
function _createForOfIteratorHelperLoose$3(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$c(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$c(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$c(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$c(t, r);
  }
}
function _arrayLikeToArray$c(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _classCallCheck$4(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$4(t, r, n) {
  return r && _defineProperties$3(t.prototype, r), n && _defineProperties$3(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var DUMMY_DIGIT = "9", LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15, LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH), NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/, CREATE_CHARACTER_CLASS_PATTERN = function() {
  return /\[([^\[\]])*\]/g;
}, CREATE_STANDALONE_DIGIT_PATTERN = function() {
  return /\d(?=[^,}][^,}])/g;
}, NON_ALTERING_FORMAT_REG_EXP = new RegExp("[" + VALID_PUNCTUATION + "]*\\$1[" + VALID_PUNCTUATION + "]*(\\$\\d[" + VALID_PUNCTUATION + "]*)*$"), MIN_LEADING_DIGITS_LENGTH = 3, AsYouTypeFormatter = /* @__PURE__ */ function() {
  function t(r) {
    r.state;
    var n = r.metadata;
    _classCallCheck$4(this, t), this.metadata = n, this.resetFormat();
  }
  return _createClass$4(t, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, a) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), a.nationalSignificantNumber && this.narrowDownMatchingFormats(a)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, a) {
      var s = this;
      if (canFormatCompleteNumber(a.nationalSignificantNumber, this.metadata))
        for (var o = _createForOfIteratorHelperLoose$3(this.matchingFormats), c; !(c = o()).done; ) {
          var l = c.value, d = formatCompleteNumber(a, l, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(u) {
              return s.shouldTryNationalPrefixFormattingRule(u, {
                international: a.international,
                nationalPrefix: a.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(u) {
              return s.getSeparatorAfterNationalPrefix(u);
            }
          });
          if (d)
            return this.resetFormat(), this.chosenFormat = l, this.setNationalNumberTemplate(d.replace(/\d/g, DIGIT_PLACEHOLDER), a), this.populatedNationalNumberTemplate = d, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER), d;
        }
      return this.formatNationalNumberWithNextDigits(n, a);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, a) {
      var s = this.chosenFormat, o = this.chooseFormat(a);
      if (o)
        return o === s ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(a.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var a = this, s = n.nationalSignificantNumber, o = n.nationalPrefix, c = n.international, l = s, d = l.length - MIN_LEADING_DIGITS_LENGTH;
      d < 0 && (d = 0), this.matchingFormats = this.matchingFormats.filter(function(h) {
        return a.formatSuits(h, c, o) && a.formatMatches(h, l, d);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, a, s) {
      return !(s && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !a && !s && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, a, s) {
      var o = n.leadingDigitsPatterns().length;
      if (o === 0)
        return !0;
      s = Math.min(s, o - 1);
      var c = n.leadingDigitsPatterns()[s];
      if (a.length < MIN_LEADING_DIGITS_LENGTH)
        try {
          return new PatternMatcher(c).match(a, {
            allowOverflow: !0
          }) !== void 0;
        } catch (l) {
          return console.error(l), !0;
        }
      return new RegExp("^(".concat(c, ")")).test(a);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, a) {
      return a ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var a = this, s = function() {
        var h = c.value;
        return a.chosenFormat === h ? "break" : NON_ALTERING_FORMAT_REG_EXP.test(a.getFormatFormat(h, n.international)) ? a.createTemplateForFormat(h, n) ? (a.chosenFormat = h, "break") : (a.matchingFormats = a.matchingFormats.filter(function(u) {
          return u !== h;
        }), "continue") : "continue";
      }, o = _createForOfIteratorHelperLoose$3(this.matchingFormats.slice()), c; !(c = o()).done; ) {
        var l = s();
        if (l === "break")
          break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, a) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var s = this.getTemplateForFormat(n, a);
        if (s)
          return this.setNationalNumberTemplate(s, a), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, a) {
      var s = n.IDDPrefix, o = n.missingPlus;
      return s ? a && a.spacing === !1 ? s : s + " " : o ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var a = -1, s = 0, o = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; s < o.length + n.getDigitsWithoutInternationalPrefix().length; )
          a = this.template.indexOf(DIGIT_PLACEHOLDER, a + 1), s++;
        return cutAndStripNonPairedParens(this.template, a + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, a) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, a.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(a).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, a.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, a) {
      var s = a.nationalSignificantNumber, o = a.international, c = a.nationalPrefix, l = a.complexPrefixBeforeNationalSignificantNumber, d = n.pattern();
      d = d.replace(CREATE_CHARACTER_CLASS_PATTERN(), "\\d").replace(CREATE_STANDALONE_DIGIT_PATTERN(), "\\d");
      var h = LONGEST_DUMMY_PHONE_NUMBER.match(d)[0];
      if (!(s.length > h.length)) {
        var u = new RegExp("^" + d + "$"), p = s.replace(/\d/g, DUMMY_DIGIT);
        u.test(p) && (h = p);
        var m = this.getFormatFormat(n, o), g;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: o,
          nationalPrefix: c
        })) {
          var v = m.replace(FIRST_GROUP_PATTERN, n.nationalPrefixFormattingRule());
          if (parseDigits(n.nationalPrefixFormattingRule()) === (c || "") + parseDigits("$1") && (m = v, g = !0, c))
            for (var y = c.length; y > 0; )
              m = m.replace(/\d/, DIGIT_PLACEHOLDER), y--;
        }
        var x = h.replace(new RegExp(d), m).replace(new RegExp(DUMMY_DIGIT, "g"), DIGIT_PLACEHOLDER);
        return g || (l ? x = repeat(DIGIT_PLACEHOLDER, l.length) + " " + x : c && (x = repeat(DIGIT_PLACEHOLDER, c.length) + this.getSeparatorAfterNationalPrefix(n) + x)), o && (x = applyInternationalSeparatorStyle(x)), x;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var a = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!a) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = a[0], this.populatedNationalNumberTemplatePosition = a[1], cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, a) {
      var s = a.international, o = a.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var c = n.usesNationalPrefix();
        if (c && o || !c && !s)
          return !0;
      }
    }
  }]), t;
}();
function _slicedToArray$6(t, r) {
  return _arrayWithHoles$6(t) || _iterableToArrayLimit$6(t, r) || _unsupportedIterableToArray$b(t, r) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$b(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$b(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$b(t, r);
  }
}
function _arrayLikeToArray$b(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _iterableToArrayLimit$6(t, r) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a = [], s = !0, o = !1, c, l;
    try {
      for (n = n.call(t); !(s = (c = n.next()).done) && (a.push(c.value), !(r && a.length === r)); s = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function _arrayWithHoles$6(t) {
  if (Array.isArray(t))
    return t;
}
function _classCallCheck$3(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$3(t, r, n) {
  return r && _defineProperties$2(t.prototype, r), n && _defineProperties$2(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = "[" + VALID_PUNCTUATION + VALID_DIGITS + "]+", VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp("^" + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$", "i"), VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + PLUS_CHARS + "][" + VALID_PUNCTUATION + VALID_DIGITS + "]*|[" + VALID_PUNCTUATION + VALID_DIGITS + "]+)", AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp("[^" + VALID_PUNCTUATION + VALID_DIGITS + "]+.*$"), COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/, AsYouTypeParser = /* @__PURE__ */ function() {
  function t(r) {
    var n = r.defaultCountry, a = r.defaultCallingCode, s = r.metadata, o = r.onNationalSignificantNumberChange;
    _classCallCheck$3(this, t), this.defaultCountry = n, this.defaultCallingCode = a, this.metadata = s, this.onNationalSignificantNumberChange = o;
  }
  return _createClass$3(t, [{
    key: "input",
    value: function(n, a) {
      var s = extractFormattedDigitsAndPlus(n), o = _slicedToArray$6(s, 2), c = o[0], l = o[1], d = parseDigits(c), h;
      return l && (a.digits || (a.startInternationalNumber(), d || (h = !0))), d && this.inputDigits(d, a), {
        digits: d,
        justLeadingPlus: h
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, a) {
      var s = a.digits, o = s.length < 3 && s.length + n.length >= 3;
      if (a.appendDigits(n), o && this.extractIddPrefix(a), this.isWaitingForCountryCallingCode(a)) {
        if (!this.extractCountryCallingCode(a))
          return;
      } else
        a.appendNationalSignificantNumberDigits(n);
      a.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(a.getNationalDigits(), function(c) {
        return a.update(c);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var a = n.international, s = n.callingCode;
      return a && !s;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var a = extractCountryCallingCode("+" + n.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), s = a.countryCallingCode, o = a.number;
      if (s)
        return n.setCallingCode(s), n.update({
          nationalSignificantNumber: o
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var a = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = a && COMPLEX_NATIONAL_PREFIX.test(a);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, a) {
      if (this.hasSelectedNumberingPlan) {
        var s = extractNationalNumberFromPossiblyIncompleteNumber(n, this.metadata), o = s.nationalPrefix, c = s.nationalNumber, l = s.carrierCode;
        if (c !== n)
          return this.onExtractedNationalNumber(o, l, c, n, a), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, a, s) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, s);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var o = extractNationalNumberFromPossiblyIncompleteNumber(n, this.metadata), c = o.nationalPrefix, l = o.nationalNumber, d = o.carrierCode;
        if (l !== a)
          return this.onExtractedNationalNumber(c, d, l, n, s), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, a, s, o, c) {
      var l, d, h = o.lastIndexOf(s);
      if (h >= 0 && h === o.length - s.length) {
        d = !0;
        var u = o.slice(0, h);
        u !== n && (l = u);
      }
      c({
        nationalPrefix: n,
        carrierCode: a,
        nationalSignificantNumber: s,
        nationalSignificantNumberMatchesInput: d,
        complexPrefixBeforeNationalSignificantNumber: l
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(a) {
        return n.update(a);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var a = n.international, s = n.IDDPrefix, o = n.digits;
      if (n.nationalSignificantNumber, !(a || s)) {
        var c = stripIddPrefix(o, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (c !== void 0 && c !== o)
          return n.update({
            IDDPrefix: o.slice(0, o.length - c.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var a = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(n.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), s = a.countryCallingCode;
        if (a.number, s)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: s
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, a) {
      var s = a.country, o = a.callingCode;
      n.startInternationalNumber(s, o), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(a) {
        return n.update(a);
      });
    }
  }]), t;
}();
function extractFormattedPhoneNumber(t) {
  var r = t.search(VALID_FORMATTED_PHONE_NUMBER_PART);
  if (!(r < 0)) {
    t = t.slice(r);
    var n;
    return t[0] === "+" && (n = !0, t = t.slice(1)), t = t.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ""), n && (t = "+" + t), t;
  }
}
function _extractFormattedDigitsAndPlus(t) {
  var r = extractFormattedPhoneNumber(t) || "";
  return r[0] === "+" ? [r.slice(1), !0] : [r];
}
function extractFormattedDigitsAndPlus(t) {
  var r = _extractFormattedDigitsAndPlus(t), n = _slicedToArray$6(r, 2), a = n[0], s = n[1];
  return VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(a) || (a = ""), [a, s];
}
function _slicedToArray$5(t, r) {
  return _arrayWithHoles$5(t) || _iterableToArrayLimit$5(t, r) || _unsupportedIterableToArray$a(t, r) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$a(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$a(t, r);
  }
}
function _arrayLikeToArray$a(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _iterableToArrayLimit$5(t, r) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a = [], s = !0, o = !1, c, l;
    try {
      for (n = n.call(t); !(s = (c = n.next()).done) && (a.push(c.value), !(r && a.length === r)); s = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function _arrayWithHoles$5(t) {
  if (Array.isArray(t))
    return t;
}
function _classCallCheck$2(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function _createClass$2(t, r, n) {
  return r && _defineProperties$1(t.prototype, r), n && _defineProperties$1(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var AsYouType = /* @__PURE__ */ function() {
  function t(r, n) {
    _classCallCheck$2(this, t), this.metadata = new Metadata(n);
    var a = this.getCountryAndCallingCode(r), s = _slicedToArray$5(a, 2), o = s[0], c = s[1];
    this.defaultCountry = o, this.defaultCallingCode = c, this.reset();
  }
  return _createClass$2(t, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var a, s;
      return n && (isObject$3(n) ? (a = n.defaultCountry, s = n.defaultCallingCode) : a = n), a && !this.metadata.hasCountry(a) && (a = void 0), [a, s];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var a = this.parser.input(n, this.state), s = a.digits, o = a.justLeadingPlus;
      if (o)
        this.formattedOutput = "+";
      else if (s) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var c;
        if (this.metadata.hasSelectedNumberingPlan() && (c = this.formatter.format(s, this.state)), c === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var l = this.state.getNationalDigits();
          l && (c = this.formatter.format(l, this.state));
        }
        this.formattedOutput = c ? this.getFullNumber(c) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new AsYouTypeState({
        onCountryChange: function(s) {
          n.country = s;
        },
        onCallingCodeChange: function(s, o) {
          n.metadata.selectNumberingPlan(o, s), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var a = this;
      if (this.isInternational()) {
        var s = function(l) {
          return a.formatter.getInternationalPrefixBeforeCountryCallingCode(a.state, {
            spacing: !!l
          }) + l;
        }, o = this.state.callingCode;
        return s(o ? n ? "".concat(o, " ").concat(n) : o : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, a = n.nationalSignificantNumber, s = n.complexPrefixBeforeNationalSignificantNumber, o = n.nationalPrefix, c = a, l = s || o;
      return l && (c = l + c), c;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(n ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, a = this.metadata.getCountryCodesForCallingCode(n);
      return a && a.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, a = n.digits, s = n.callingCode, o = n.country, c = n.nationalSignificantNumber;
      if (a) {
        if (this.isInternational())
          return s ? "+" + s + c : "+" + a;
        if (o || s) {
          var l = o ? this.metadata.countryCallingCode() : s;
          return "+" + l + c;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, a = n.nationalSignificantNumber, s = n.carrierCode, o = n.callingCode, c = this._getCountry();
      if (a && !(!c && !o)) {
        if (c && c === this.defaultCountry) {
          var l = new Metadata(this.metadata.metadata);
          l.selectNumberingPlan(c);
          var d = l.numberingPlan.callingCode(), h = this.metadata.getCountryCodesForCallingCode(d);
          if (h.length > 1) {
            var u = getCountryByNationalNumber(a, {
              countries: h,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            u && (c = u);
          }
        }
        var p = new PhoneNumber(c || o, a, this.metadata.metadata);
        return s && (p.carrierCode = s), p;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), t;
}();
function getCountries(t) {
  return new Metadata(t).getCountries();
}
function formatIncompletePhoneNumber(t, r, n) {
  return n || (n = r, r = void 0), new AsYouType(r, n).input(t);
}
function getInputValuePrefix(t) {
  var r = t.country, n = t.international, a = t.withCountryCallingCode, s = t.metadata;
  return r && n && !a ? "+".concat(getCountryCallingCode(r, s)) : "";
}
function removeInputValuePrefix(t, r) {
  return r && (t = t.slice(r.length), t[0] === " " && (t = t.slice(1))), t;
}
function parsePhoneNumberCharacter_(t, r, n) {
  if (!(n && n.ignoreRest)) {
    var a = function(o) {
      if (n)
        switch (o) {
          case "end":
            n.ignoreRest = !0;
            break;
        }
    };
    return parsePhoneNumberCharacter(t, r, a);
  }
}
function useInputKeyDownHandler(t) {
  var r = t.onKeyDown, n = t.international;
  return useCallback(function(a) {
    if (a.keyCode === BACKSPACE_KEY_CODE && n && a.target instanceof HTMLInputElement && getCaretPosition(a.target) === AFTER_LEADING_PLUS_CARET_POSITION) {
      a.preventDefault();
      return;
    }
    r && r(a);
  }, [r, n]);
}
var BACKSPACE_KEY_CODE = 8;
function getCaretPosition(t) {
  return t.selectionStart;
}
var AFTER_LEADING_PLUS_CARET_POSITION = 1, _excluded$e = ["onKeyDown", "country", "international", "withCountryCallingCode", "metadata"];
function _objectWithoutProperties$9(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$8(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$8(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function createInput$1(t) {
  function r(n, a) {
    var s = n.onKeyDown, o = n.country, c = n.international, l = n.withCountryCallingCode, d = n.metadata, h = d === void 0 ? t : d, u = _objectWithoutProperties$9(n, _excluded$e), p = useCallback(function(g) {
      var v = new AsYouType(o, h), y = getInputValuePrefix({
        country: o,
        international: c,
        withCountryCallingCode: l,
        metadata: h
      }), x = v.input(y + g), _ = v.getTemplate();
      return y && (x = removeInputValuePrefix(x, y), _ && (_ = removeInputValuePrefix(_, y))), {
        text: x,
        template: _
      };
    }, [o, h]), m = useInputKeyDownHandler({
      onKeyDown: s,
      international: c
    });
    return /* @__PURE__ */ jsx$1(Input$4, {
      ...u,
      ref: a,
      parse: parsePhoneNumberCharacter_,
      format: p,
      onKeyDown: m
    });
  }
  return r = /* @__PURE__ */ React__default.forwardRef(r), r.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: PropTypes.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: PropTypes.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes.string,
    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes.bool,
    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: PropTypes.bool,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object
  }, r;
}
const InputSmart = createInput$1();
var _excluded$d = ["value", "onChange", "onKeyDown", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"];
function _objectWithoutProperties$8(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$7(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$7(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function createInput(t) {
  function r(n, a) {
    var s = n.value, o = n.onChange, c = n.onKeyDown, l = n.country, d = n.international, h = n.withCountryCallingCode, u = n.metadata, p = u === void 0 ? t : u, m = n.inputComponent, g = m === void 0 ? "input" : m, v = _objectWithoutProperties$8(n, _excluded$d), y = getInputValuePrefix({
      country: l,
      international: d,
      withCountryCallingCode: h,
      metadata: p
    }), x = useCallback(function($) {
      var b = parseIncompletePhoneNumber($.target.value);
      if (b === s) {
        var M = format$6(y, b, l, p);
        M.indexOf($.target.value) === 0 && (b = b.slice(0, -1));
      }
      o(b);
    }, [y, s, o, l, p]), _ = useInputKeyDownHandler({
      onKeyDown: c,
      international: d
    });
    return /* @__PURE__ */ jsx$1(g, {
      ...v,
      ref: a,
      value: format$6(y, s, l, p),
      onChange: x,
      onKeyDown: _
    });
  }
  return r = /* @__PURE__ */ React__default.forwardRef(r), r.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: PropTypes.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: PropTypes.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes.string,
    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes.bool,
    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: PropTypes.bool,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object,
    /**
     * The `<input/>` component.
     */
    inputComponent: PropTypes.elementType
  }, r;
}
const InputBasic$1 = createInput();
function format$6(t, r, n, a) {
  return removeInputValuePrefix(formatIncompletePhoneNumber(t + r, n, a), t);
}
function getCountryFlag(t) {
  return getRegionalIndicatorSymbol(t[0]) + getRegionalIndicatorSymbol(t[1]);
}
function getRegionalIndicatorSymbol(t) {
  return String.fromCodePoint(127462 - 65 + t.toUpperCase().charCodeAt(0));
}
var _excluded$c = ["value", "onChange", "options", "disabled", "readOnly"], _excluded2$4 = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];
function _createForOfIteratorHelperLoose$2(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$9(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[a++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$9(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$9(t, r);
  }
}
function _arrayLikeToArray$9(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _objectWithoutProperties$7(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$6(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$6(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function CountrySelect(t) {
  var r = t.value, n = t.onChange, a = t.options, s = t.disabled, o = t.readOnly, c = _objectWithoutProperties$7(t, _excluded$c), l = useCallback(function(d) {
    var h = d.target.value;
    n(h === "ZZ" ? void 0 : h);
  }, [n]);
  return useMemo(function() {
    return getSelectedOption(a, r);
  }, [a, r]), /* @__PURE__ */ jsx$1("select", {
    ...c,
    disabled: s || o,
    readOnly: o,
    value: r || "ZZ",
    onChange: l,
    children: a.map(function(d) {
      var h = d.value, u = d.label, p = d.divider;
      return /* @__PURE__ */ jsx$1("option", {
        value: p ? "|" : h || "ZZ",
        disabled: !!p,
        style: p ? DIVIDER_STYLE : void 0,
        children: u
      }, p ? "|" : h || "ZZ");
    })
  });
}
CountrySelect.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: PropTypes.string,
  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: PropTypes.func.isRequired,
  // `<select/>` options.
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    divider: PropTypes.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
};
var DIVIDER_STYLE = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function CountrySelectWithIcon(t) {
  var r = t.value, n = t.options, a = t.className, s = t.iconComponent;
  t.getIconAspectRatio;
  var o = t.arrowComponent, c = o === void 0 ? DefaultArrowComponent : o, l = t.unicodeFlags, d = _objectWithoutProperties$7(t, _excluded2$4), h = useMemo(function() {
    return getSelectedOption(n, r);
  }, [n, r]);
  return /* @__PURE__ */ jsxs("div", {
    className: "PhoneInputCountry",
    children: [/* @__PURE__ */ jsx$1(CountrySelect, {
      ...d,
      value: r,
      options: n,
      className: classNames$1("PhoneInputCountrySelect", a)
    }), l && r && /* @__PURE__ */ jsx$1("div", {
      className: "PhoneInputCountryIconUnicode",
      children: getCountryFlag(r)
    }), !(l && r) && /* @__PURE__ */ jsx$1(s, {
      "aria-hidden": !0,
      country: r,
      label: h && h.label,
      aspectRatio: l ? 1 : void 0
    }), /* @__PURE__ */ jsx$1(c, {})]
  });
}
CountrySelectWithIcon.propTypes = {
  // Country flag component.
  iconComponent: PropTypes.elementType,
  // Select arrow component.
  arrowComponent: PropTypes.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: PropTypes.bool
};
function DefaultArrowComponent() {
  return /* @__PURE__ */ jsx$1("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}
function getSelectedOption(t, r) {
  for (var n = _createForOfIteratorHelperLoose$2(t), a; !(a = n()).done; ) {
    var s = a.value;
    if (!s.divider && s.value === r)
      return s;
  }
}
var _excluded$b = ["country", "countryName", "flags", "flagUrl"];
function _objectWithoutProperties$6(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$5(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$5(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function FlagComponent(t) {
  var r = t.country, n = t.countryName, a = t.flags, s = t.flagUrl, o = _objectWithoutProperties$6(t, _excluded$b);
  return a && a[r] ? a[r]({
    title: n
  }) : /* @__PURE__ */ jsx$1("img", {
    ...o,
    alt: n,
    role: n ? void 0 : "presentation",
    src: s.replace("{XX}", r).replace("{xx}", r.toLowerCase())
  });
}
FlagComponent.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: PropTypes.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: PropTypes.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: PropTypes.objectOf(PropTypes.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: PropTypes.string.isRequired
};
var _excluded$a = ["aspectRatio"], _excluded2$3 = ["title"], _excluded3$1 = ["title"];
function _objectWithoutProperties$5(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$4(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$4(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function InternationalIcon(t) {
  var r = t.aspectRatio, n = _objectWithoutProperties$5(t, _excluded$a);
  return r === 1 ? /* @__PURE__ */ jsx$1(InternationalIcon1x1, {
    ...n
  }) : /* @__PURE__ */ jsx$1(InternationalIcon3x2, {
    ...n
  });
}
InternationalIcon.propTypes = {
  title: PropTypes.string.isRequired,
  aspectRatio: PropTypes.number
};
function InternationalIcon3x2(t) {
  var r = t.title, n = _objectWithoutProperties$5(t, _excluded2$3);
  return /* @__PURE__ */ jsxs("svg", {
    ...n,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50",
    children: [/* @__PURE__ */ jsx$1("title", {
      children: r
    }), /* @__PURE__ */ jsxs("g", {
      className: "PhoneInputInternationalIconGlobe",
      stroke: "currentColor",
      fill: "none",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      children: [/* @__PURE__ */ jsx$1("path", {
        strokeLinecap: "round",
        d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
      }), /* @__PURE__ */ jsx$1("line", {
        x1: "26",
        y1: "25",
        x2: "74",
        y2: "25"
      }), /* @__PURE__ */ jsx$1("line", {
        x1: "50",
        y1: "1",
        x2: "50",
        y2: "49"
      }), /* @__PURE__ */ jsx$1("path", {
        strokeLinecap: "round",
        d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
      }), /* @__PURE__ */ jsx$1("path", {
        strokeLinecap: "round",
        d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
      })]
    }), /* @__PURE__ */ jsx$1("path", {
      className: "PhoneInputInternationalIconPhone",
      stroke: "none",
      fill: "currentColor",
      d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
    })]
  });
}
InternationalIcon3x2.propTypes = {
  title: PropTypes.string.isRequired
};
function InternationalIcon1x1(t) {
  var r = t.title, n = _objectWithoutProperties$5(t, _excluded3$1);
  return /* @__PURE__ */ jsxs("svg", {
    ...n,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    children: [/* @__PURE__ */ jsx$1("title", {
      children: r
    }), /* @__PURE__ */ jsxs("g", {
      className: "PhoneInputInternationalIconGlobe",
      stroke: "currentColor",
      fill: "none",
      strokeWidth: "2",
      strokeLinecap: "round",
      children: [/* @__PURE__ */ jsx$1("path", {
        d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
      }), /* @__PURE__ */ jsx$1("path", {
        d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
      }), /* @__PURE__ */ jsx$1("line", {
        x1: "27.8",
        y1: "0.85",
        x2: "27.8",
        y2: "34.61"
      }), /* @__PURE__ */ jsx$1("line", {
        x1: "15.2",
        y1: "22.23",
        x2: "49.15",
        y2: "22.23"
      })]
    }), /* @__PURE__ */ jsx$1("path", {
      className: "PhoneInputInternationalIconPhone",
      stroke: "transparent",
      fill: "currentColor",
      d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
    })]
  });
}
InternationalIcon1x1.propTypes = {
  title: PropTypes.string.isRequired
};
function isE164Number(t) {
  if (t.length < 2 || t[0] !== "+")
    return !1;
  for (var r = 1; r < t.length; ) {
    var n = t.charCodeAt(r);
    if (!(n >= 48 && n <= 57))
      return !1;
    r++;
  }
  return !0;
}
function validateE164Number(t) {
  isE164Number(t) || console.error("[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got", t);
}
function _createForOfIteratorHelperLoose$1(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$8(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$8(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$8(t, r);
  }
}
function _arrayLikeToArray$8(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function sortCountryOptions(t, r) {
  if (!r)
    return t;
  for (var n = [], a = [], s = n, o = function() {
    var h = l.value;
    if (h === "|")
      s.push({
        divider: !0
      });
    else if (h === "..." || h === "…")
      s = a;
    else {
      var u;
      h === "🌐" ? u = void 0 : u = h;
      var p = t.indexOf(t.filter(function(g) {
        return g.value === u;
      })[0]), m = t[p];
      t.splice(p, 1), s.push(m);
    }
  }, c = _createForOfIteratorHelperLoose$1(r), l; !(l = c()).done; )
    o();
  return n.concat(t).concat(a);
}
function getSupportedCountryOptions(t, r) {
  if (t && (t = t.filter(function(n) {
    switch (n) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return isCountrySupportedWithError(n, r);
    }
  }), t.length > 0))
    return t;
}
function isCountrySupportedWithError(t, r) {
  return isSupportedCountry(t, r) ? !0 : (console.error("Country not found: ".concat(t)), !1);
}
function getSupportedCountries(t, r) {
  return t && (t = t.filter(function(n) {
    return isCountrySupportedWithError(n, r);
  }), t.length === 0 && (t = void 0)), t;
}
var _excluded$9 = ["country", "label", "aspectRatio"];
function _objectWithoutProperties$4(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$3(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$3(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function createCountryIconComponent(t) {
  var r = t.flags, n = t.flagUrl, a = t.flagComponent, s = t.internationalIcon;
  function o(c) {
    var l = c.country, d = c.label, h = c.aspectRatio, u = _objectWithoutProperties$4(c, _excluded$9), p = s === InternationalIcon ? h : void 0;
    return /* @__PURE__ */ jsx$1("div", {
      ...u,
      className: classNames$1("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": p === 1,
        "PhoneInputCountryIcon--border": l
      }),
      children: l ? /* @__PURE__ */ jsx$1(a, {
        country: l,
        countryName: d,
        flags: r,
        flagUrl: n,
        className: "PhoneInputCountryIconImg"
      }) : /* @__PURE__ */ jsx$1(s, {
        title: d,
        aspectRatio: p,
        className: "PhoneInputCountryIconImg"
      })
    });
  }
  return o.propTypes = {
    country: PropTypes.string,
    label: PropTypes.string.isRequired,
    aspectRatio: PropTypes.number
  }, o;
}
createCountryIconComponent({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: FlagComponent,
  internationalIcon: InternationalIcon
});
function _createForOfIteratorHelperLoose(t, r) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _unsupportedIterableToArray$7(t)) || r && t && typeof t.length == "number") {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$7(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$7(t, r);
  }
}
function _arrayLikeToArray$7(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function setRefsValue(t, r) {
  for (var n = _createForOfIteratorHelperLoose(t), a; !(a = n()).done; ) {
    var s = a.value;
    s && setRefValue(s, r);
  }
}
function setRefValue(t, r) {
  typeof t == "function" ? t(r) : t.current = r;
}
var metadata = PropTypes.shape({
  country_calling_codes: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired
}), labels = PropTypes.objectOf(PropTypes.string);
function getInternationalPhoneNumberPrefix(t, r) {
  var n = "+" + getCountryCallingCode(t, r);
  return n;
}
function getPreSelectedCountry(t) {
  var r = t.value, n = t.phoneNumber, a = t.defaultCountry, s = t.getAnyCountry, o = t.countries, c = t.required, l = t.metadata, d;
  return n && n.country ? d = n.country : a && (!r || couldNumberBelongToCountry(r, a, l)) && (d = a), o && o.indexOf(d) < 0 && (d = void 0), !d && c && o && o.length > 0 && (d = s()), d;
}
function getCountrySelectOptions(t) {
  var r = t.countries, n = t.countryNames, a = t.addInternationalOption, s = t.compareStringsLocales, o = t.compareStrings;
  o || (o = compareStrings);
  var c = r.map(function(l) {
    return {
      value: l,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: n[l] || l
    };
  });
  return c.sort(function(l, d) {
    return o(l.label, d.label, s);
  }), a && c.unshift({
    label: n.ZZ
  }), c;
}
function parsePhoneNumber(t, r) {
  return parsePhoneNumber$1(t || "", r);
}
function generateNationalNumberDigits(t) {
  return t.formatNational().replace(/\D/g, "");
}
function getPhoneDigitsForNewCountry(t, r) {
  var n = r.prevCountry, a = r.newCountry, s = r.metadata, o = r.useNationalFormat;
  if (n === a)
    return t;
  if (!t)
    return o ? "" : a ? getInternationalPhoneNumberPrefix(a, s) : "";
  if (a) {
    if (t[0] === "+") {
      if (o)
        return t.indexOf("+" + getCountryCallingCode(a, s)) === 0 ? stripCountryCallingCode(t, a, s) : "";
      if (n) {
        var c = getInternationalPhoneNumberPrefix(a, s);
        return t.indexOf(c) === 0 ? t : c;
      } else {
        var l = getInternationalPhoneNumberPrefix(a, s);
        return t.indexOf(l) === 0 ? t : l;
      }
    }
  } else if (t[0] !== "+")
    return e164(t, n, s) || "";
  return t;
}
function e164(t, r, n) {
  if (t) {
    if (t[0] === "+") {
      if (t === "+")
        return;
      var a = new AsYouType(r, n);
      return a.input(t), a.getNumberValue();
    }
    if (r) {
      var s = getNationalSignificantNumberDigits(t, r, n);
      return "+".concat(getCountryCallingCode(r, n)).concat(s || "");
    }
  }
}
function trimNumber(t, r, n) {
  var a = getNationalSignificantNumberDigits(t, r, n);
  if (a) {
    var s = a.length - getMaxNumberLength(r, n);
    if (s > 0)
      return t.slice(0, t.length - s);
  }
  return t;
}
function getMaxNumberLength(t, r) {
  return r = new Metadata(r), r.selectNumberingPlan(t), r.numberingPlan.possibleLengths()[r.numberingPlan.possibleLengths().length - 1];
}
function getCountryForPartialE164Number(t, r) {
  var n = r.country, a = r.countries, s = r.defaultCountry, o = r.latestCountrySelectedByUser, c = r.required, l = r.metadata;
  if (t === "+")
    return n;
  var d = getCountryFromPossiblyIncompleteInternationalPhoneNumber(t, l);
  if (d)
    return !a || a.indexOf(d) >= 0 ? d : void 0;
  if (n) {
    if (couldNumberBelongToCountry(t, n, l)) {
      if (o && couldNumberBelongToCountry(t, o, l))
        return o;
      if (s && couldNumberBelongToCountry(t, s, l))
        return s;
      if (!c)
        return;
    } else if (!c)
      return;
  }
  return n;
}
function onPhoneDigitsChange(t, r) {
  var n = r.prevPhoneDigits, a = r.country, s = r.defaultCountry, o = r.latestCountrySelectedByUser, c = r.countryRequired, l = r.getAnyCountry, d = r.countries, h = r.international, u = r.limitMaxLength, p = r.countryCallingCodeEditable, m = r.metadata;
  if (h && p === !1 && a) {
    var g = getInternationalPhoneNumberPrefix(a, m);
    if (t.indexOf(g) !== 0) {
      var v, y = t && t[0] !== "+";
      return y ? (t = g + t, v = e164(t, a, m)) : t = g, {
        phoneDigits: t,
        value: v,
        country: a
      };
    }
  }
  h === !1 && a && t && t[0] === "+" && (t = convertInternationalPhoneDigitsToNational(t, a, m)), t && a && u && (t = trimNumber(t, a, m)), t && t[0] !== "+" && (!a || h) && (t = "+" + t), !t && n && n[0] === "+" && (h ? a = void 0 : a = s), t === "+" && n && n[0] === "+" && n.length > 1 && (a = void 0);
  var x;
  return t && (t[0] === "+" && (t === "+" || a && getInternationalPhoneNumberPrefix(a, m).indexOf(t) === 0) ? x = void 0 : x = e164(t, a, m)), x && (a = getCountryForPartialE164Number(x, {
    country: a,
    countries: d,
    defaultCountry: s,
    latestCountrySelectedByUser: o,
    // `countryRequired` flag is not passed here.
    // Instead, it's explicitly checked a bit later in the code.
    required: !1,
    metadata: m
  }), h === !1 && a && t && t[0] === "+" && (t = convertInternationalPhoneDigitsToNational(t, a, m), x = e164(t, a, m))), !a && c && (a = s || l()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: t,
    country: a,
    value: x
  };
}
function convertInternationalPhoneDigitsToNational(t, r, n) {
  if (t.indexOf(getInternationalPhoneNumberPrefix(r, n)) === 0) {
    var a = new AsYouType(r, n);
    a.input(t);
    var s = a.getNumber();
    return s ? s.formatNational().replace(/\D/g, "") : "";
  } else
    return t.replace(/\D/g, "");
}
function getCountryFromPossiblyIncompleteInternationalPhoneNumber(t, r) {
  var n = new AsYouType(null, r);
  return n.input(t), n.getCountry();
}
function compareStrings(t, r, n) {
  return String.prototype.localeCompare ? t.localeCompare(r, n) : t < r ? -1 : t > r ? 1 : 0;
}
function stripCountryCallingCode(t, r, n) {
  if (r) {
    var a = "+" + getCountryCallingCode(r, n);
    if (t.length < a.length) {
      if (a.indexOf(t) === 0)
        return "";
    } else if (t.indexOf(a) === 0)
      return t.slice(a.length);
  }
  for (var s = 0, o = Object.keys(n.country_calling_codes); s < o.length; s++) {
    var c = o[s];
    if (t.indexOf(c) === 1)
      return t.slice(1 + c.length);
  }
  return "";
}
function getNationalSignificantNumberDigits(t, r, n) {
  var a = new AsYouType(r, n);
  a.input(t);
  var s = a.getNumber();
  return s && s.nationalNumber;
}
function couldNumberBelongToCountry(t, r, n) {
  for (var a = getInternationalPhoneNumberPrefix(r, n), s = 0; s < t.length && s < a.length; ) {
    if (t[s] !== a[s])
      return !1;
    s++;
  }
  return !0;
}
function getInitialPhoneDigits(t) {
  var r = t.value, n = t.phoneNumber, a = t.defaultCountry, s = t.international, o = t.useNationalFormat, c = t.metadata;
  return (s === !1 || o) && n && n.country ? generateNationalNumberDigits(n) : !r && s && a ? getInternationalPhoneNumberPrefix(a, c) : r;
}
function _typeof$j(t) {
  "@babel/helpers - typeof";
  return _typeof$j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof$j(t);
}
function ownKeys$a(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$a(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$a(Object(n), !0).forEach(function(a) {
      _defineProperty$7(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$a(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$7(t, r, n) {
  return r = _toPropertyKey$1(r), r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function _toPropertyKey$1(t) {
  var r = _toPrimitive$1(t, "string");
  return _typeof$j(r) == "symbol" ? r : r + "";
}
function _toPrimitive$1(t, r) {
  if (_typeof$j(t) != "object" || !t)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(t, r || "default");
    if (_typeof$j(a) != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
function getPhoneInputWithCountryStateUpdateFromNewProps(t, r, n) {
  var a = t.metadata, s = t.countries, o = t.defaultCountry, c = t.value, l = t.reset, d = t.international, h = t.displayInitialValueAsLocalNumber, u = t.initialValueFormat, p = r.defaultCountry, m = r.value, g = r.reset;
  n.country;
  var v = n.value, y = n.hasUserSelectedACountry, x = n.latestCountrySelectedByUser, _ = function(R) {
    return getInitialPhoneDigits(_objectSpread$a(_objectSpread$a({}, R), {}, {
      international: d,
      useNationalFormat: h || u === "national",
      metadata: a
    }));
  };
  if (l !== g)
    return {
      phoneDigits: _({
        value: void 0,
        defaultCountry: o
      }),
      value: void 0,
      country: o,
      latestCountrySelectedByUser: void 0,
      hasUserSelectedACountry: void 0
    };
  if (o !== p) {
    var $ = !o || isCountrySupportedWithError(o, a), b = (
      // By default, "no value has been entered" means `value` is `undefined`.
      !v || // When `international` is `true`, and some country has been pre-selected,
      // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
      // so in case of `international` being `true`, "the user hasn't entered anything" situation
      // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
      d && v === _({
        value: void 0,
        defaultCountry: p
      })
    ), M = !c && b;
    if (!y && $ && M)
      return {
        country: o,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: _({
          value: void 0,
          defaultCountry: o
        }),
        // `value` is `undefined` and it stays so.
        value: void 0
      };
  }
  if (!valuesAreEqual(c, m) && !valuesAreEqual(c, v)) {
    var C, S;
    if (c) {
      c && validateE164Number(c), C = parsePhoneNumber(c, a);
      var A = getSupportedCountries(s, a);
      C && C.country ? (!A || A.indexOf(C.country) >= 0) && (S = C.country) : (S = getCountryForPartialE164Number(c, {
        country: void 0,
        countries: A,
        metadata: a
      }), S || o && c.indexOf(getInternationalPhoneNumberPrefix(o, a)) === 0 && (S = o));
    }
    var D;
    if (c) {
      if (x) {
        var N = S ? x === S : couldNumberBelongToCountry(c, x, a);
        N ? S || (S = x) : D = {
          latestCountrySelectedByUser: void 0
        };
      }
    } else
      D = {
        latestCountrySelectedByUser: void 0,
        hasUserSelectedACountry: void 0
      };
    return _objectSpread$a(_objectSpread$a({}, D), {}, {
      phoneDigits: _({
        phoneNumber: C,
        value: c,
        defaultCountry: o
      }),
      value: c,
      country: c ? S : o
    });
  }
}
function valuesAreEqual(t, r) {
  return t === null && (t = void 0), r === null && (r = void 0), t === r;
}
var _excluded$8 = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "containerComponentProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];
function _typeof$i(t) {
  "@babel/helpers - typeof";
  return _typeof$i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof$i(t);
}
function ownKeys$9(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$9(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$9(Object(n), !0).forEach(function(a) {
      _defineProperty$6(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$9(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _objectWithoutProperties$3(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$2(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$2(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function _classCallCheck$1(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, _toPropertyKey(a.key), a);
  }
}
function _createClass$1(t, r, n) {
  return r && _defineProperties(t.prototype, r), n && _defineProperties(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function _callSuper(t, r, n) {
  return r = _getPrototypeOf$1(r), _possibleConstructorReturn$1(t, _isNativeReflectConstruct$4() ? Reflect.construct(r, n || [], _getPrototypeOf$1(t).constructor) : r.apply(t, n));
}
function _possibleConstructorReturn$1(t, r) {
  if (r && (_typeof$i(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t);
}
function _assertThisInitialized$1(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _isNativeReflectConstruct$4() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$4 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1(t) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _getPrototypeOf$1(t);
}
function _inherits$1(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), r && _setPrototypeOf(t, r);
}
function _setPrototypeOf(t, r) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, s) {
    return a.__proto__ = s, a;
  }, _setPrototypeOf(t, r);
}
function _defineProperty$6(t, r, n) {
  return r = _toPropertyKey(r), r in t ? Object.defineProperty(t, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = n, t;
}
function _toPropertyKey(t) {
  var r = _toPrimitive(t, "string");
  return _typeof$i(r) == "symbol" ? r : r + "";
}
function _toPrimitive(t, r) {
  if (_typeof$i(t) != "object" || !t)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(t, r || "default");
    if (_typeof$i(a) != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
var PhoneNumberInput_ = /* @__PURE__ */ function(t) {
  function r(n) {
    var a;
    _classCallCheck$1(this, r), a = _callSuper(this, r, [n]), _defineProperty$6(a, "setInputRef", function(x) {
      setRefsValue([a.props.inputRef, a.inputRef], x);
    }), _defineProperty$6(a, "isCountrySupportedWithError", function(x) {
      var _ = a.props.metadata;
      return isCountrySupportedWithError(x, _);
    }), _defineProperty$6(a, "onCountryChange", function(x) {
      var _ = a.props, $ = _.international, b = _.metadata, M = _.onChange, C = _.focusInputOnCountrySelection, S = a.state, A = S.phoneDigits, D = S.country, N = getPhoneDigitsForNewCountry(A, {
        prevCountry: D,
        newCountry: x,
        metadata: b,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !$
      }), T = e164(N, x, b);
      C && a.inputRef.current.focus(), a.setState({
        country: x,
        latestCountrySelectedByUser: x,
        hasUserSelectedACountry: !0,
        phoneDigits: N,
        value: T
      }, function() {
        M(T);
      });
    }), _defineProperty$6(a, "onChange", function(x) {
      var _ = a.props, $ = _.defaultCountry, b = _.onChange, M = _.addInternationalOption, C = _.international, S = _.limitMaxLength, A = _.countryCallingCodeEditable, D = _.metadata, N = a.state, T = N.countries, R = N.phoneDigits, F = N.country, z = N.latestCountrySelectedByUser, O = onPhoneDigitsChange(x, {
        prevPhoneDigits: R,
        country: F,
        countryRequired: !M,
        defaultCountry: $,
        latestCountrySelectedByUser: z,
        getAnyCountry: function() {
          return a.getFirstSupportedCountry({
            countries: T
          });
        },
        countries: T,
        international: C,
        limitMaxLength: S,
        countryCallingCodeEditable: A,
        metadata: D
      }), G = O.phoneDigits, I = O.country, k = O.value, B = {
        phoneDigits: G,
        value: k,
        country: I
      };
      z && k && !couldNumberBelongToCountry(k, z, D) && (B.latestCountrySelectedByUser = void 0), A === !1 && !k && G === a.state.phoneDigits && (B.forceRerender = {}), a.setState(
        B,
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        function() {
          return b(k);
        }
      );
    }), _defineProperty$6(a, "_onFocus", function() {
      return a.setState({
        isFocused: !0
      });
    }), _defineProperty$6(a, "_onBlur", function() {
      return a.setState({
        isFocused: !1
      });
    }), _defineProperty$6(a, "onFocus", function(x) {
      a._onFocus();
      var _ = a.props.onFocus;
      _ && _(x);
    }), _defineProperty$6(a, "onBlur", function(x) {
      var _ = a.props.onBlur;
      a._onBlur(), _ && _(x);
    }), _defineProperty$6(a, "onCountryFocus", function(x) {
      a._onFocus();
      var _ = a.props.countrySelectProps;
      if (_) {
        var $ = _.onFocus;
        $ && $(x);
      }
    }), _defineProperty$6(a, "onCountryBlur", function(x) {
      a._onBlur();
      var _ = a.props.countrySelectProps;
      if (_) {
        var $ = _.onBlur;
        $ && $(x);
      }
    }), a.inputRef = /* @__PURE__ */ React__default.createRef();
    var s = a.props, o = s.value;
    s.labels;
    var c = s.international, l = s.addInternationalOption, d = s.displayInitialValueAsLocalNumber, h = s.initialValueFormat, u = s.metadata, p = a.props, m = p.defaultCountry, g = p.countries;
    m && (a.isCountrySupportedWithError(m) || (m = void 0)), o && validateE164Number(o), g = getSupportedCountries(g, u);
    var v = parsePhoneNumber(o, u);
    a.CountryIcon = createCountryIconComponent(a.props);
    var y = getPreSelectedCountry({
      value: o,
      phoneNumber: v,
      defaultCountry: m,
      required: !l,
      countries: g || getCountries(u),
      getAnyCountry: function() {
        return a.getFirstSupportedCountry({
          countries: g
        });
      },
      metadata: u
    });
    return a.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: a.props,
      // The country selected.
      country: y,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: g,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: getInitialPhoneDigits({
        value: o,
        phoneNumber: v,
        defaultCountry: m,
        international: c,
        useNationalFormat: d || h === "national",
        metadata: u
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: o
    }, a;
  }
  return _inherits$1(r, t), _createClass$1(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props.onCountryChange, s = this.props.defaultCountry, o = this.state.country;
      a && (s && (this.isCountrySupportedWithError(s) || (s = void 0)), o !== s && a(o));
    }
  }, {
    key: "componentDidUpdate",
    value: function(a, s) {
      var o = this.props.onCountryChange, c = this.state.country;
      o && c !== s.country && o(c);
    }
  }, {
    key: "getCountrySelectOptions",
    value: function(a) {
      var s = a.countries, o = this.props, c = o.international, l = o.countryCallingCodeEditable, d = o.countryOptionsOrder, h = o.addInternationalOption, u = o.labels, p = o.locales, m = o.metadata;
      return this.useMemoCountrySelectOptions(function() {
        return sortCountryOptions(getCountrySelectOptions({
          countries: s || getCountries(m),
          countryNames: u,
          addInternationalOption: c && l === !1 ? !1 : h,
          compareStringsLocales: p
          // compareStrings
        }), getSupportedCountryOptions(d, m));
      }, [s, d, h, u, m]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function(a, s) {
      return (!this.countrySelectOptionsMemoDependencies || !areEqualArrays(s, this.countrySelectOptionsMemoDependencies)) && (this.countrySelectOptionsMemo = a(), this.countrySelectOptionsMemoDependencies = s), this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function(a) {
      var s = a.countries, o = this.getCountrySelectOptions({
        countries: s
      });
      return o[0].value;
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, s = a.name, o = a.disabled, c = a.readOnly, l = a.autoComplete, d = a.style, h = a.className;
      a.inputRef;
      var u = a.inputComponent, p = a.numberInputProps, m = a.smartCaret, g = a.countrySelectComponent, v = a.countrySelectProps, y = a.containerComponent, x = a.containerComponentProps;
      a.defaultCountry, a.countries, a.countryOptionsOrder;
      var _ = a.labels;
      a.flags, a.flagComponent, a.flagUrl, a.addInternationalOption, a.internationalIcon, a.displayInitialValueAsLocalNumber, a.initialValueFormat, a.onCountryChange, a.limitMaxLength, a.countryCallingCodeEditable, a.focusInputOnCountrySelection, a.reset;
      var $ = a.metadata, b = a.international;
      a.locales;
      var M = _objectWithoutProperties$3(a, _excluded$8), C = this.state, S = C.country, A = C.countries, D = C.phoneDigits, N = C.isFocused, T = m ? InputSmart : InputBasic$1, R = this.getCountrySelectOptions({
        countries: A
      });
      return /* @__PURE__ */ jsxs(y, {
        style: d,
        className: classNames$1(h, "PhoneInput", {
          "PhoneInput--focus": N,
          "PhoneInput--disabled": o,
          "PhoneInput--readOnly": c
        }),
        ...x,
        children: [/* @__PURE__ */ jsx$1(g, {
          name: s ? "".concat(s, "Country") : void 0,
          "aria-label": _.country,
          ...v,
          value: S,
          options: R,
          onChange: this.onCountryChange,
          onFocus: this.onCountryFocus,
          onBlur: this.onCountryBlur,
          disabled: o || v && v.disabled,
          readOnly: c || v && v.readOnly,
          iconComponent: this.CountryIcon
        }), /* @__PURE__ */ jsx$1(T, {
          ref: this.setInputRef,
          type: "tel",
          autoComplete: l,
          ...p,
          ...M,
          international: b ? !0 : void 0,
          withCountryCallingCode: b ? !0 : void 0,
          name: s,
          metadata: $,
          country: S,
          value: D || "",
          onChange: this.onChange,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          disabled: o,
          readOnly: c,
          inputComponent: u,
          className: classNames$1("PhoneInputInput", p && p.className, M.className)
        })]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: (
      // `state` holds previous props as `props`, and also:
      // * `country` — The currently selected country, e.g. `"RU"`.
      // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
      // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
      // (and a couple of other less significant properties)
      function(a, s) {
        return _objectSpread$9({
          // Emulate `prevProps` via `state.props`.
          props: a
        }, getPhoneInputWithCountryStateUpdateFromNewProps(a, s.props, s));
      }
    )
  }]);
}(React__default.PureComponent), PhoneNumberInput = /* @__PURE__ */ React__default.forwardRef(function(t, r) {
  return /* @__PURE__ */ jsx$1(PhoneNumberInput_, {
    ...withDefaultProps(t),
    inputRef: r
  });
});
PhoneNumberInput.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: PropTypes.string,
  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: PropTypes.bool,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: PropTypes.bool,
  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: PropTypes.string,
  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: PropTypes.oneOf(["national"]),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: PropTypes.bool,
  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: PropTypes.string,
  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: PropTypes.arrayOf(PropTypes.string),
  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels,
  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */
  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: PropTypes.string,
  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: PropTypes.objectOf(PropTypes.elementType),
  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: PropTypes.elementType,
  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: PropTypes.bool,
  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: PropTypes.elementType,
  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: PropTypes.arrayOf(PropTypes.string),
  /**
   * `<Phone/>` component CSS style object.
   */
  style: PropTypes.object,
  /**
   * `<Phone/>` component CSS class.
   */
  className: PropTypes.string,
  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: PropTypes.elementType,
  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: PropTypes.object,
  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: PropTypes.elementType,
  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: PropTypes.object,
  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: PropTypes.elementType,
  /**
   * Wrapping `<div/>` component props.
   */
  containerComponentProps: PropTypes.object,
  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: PropTypes.bool,
  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */
  international: PropTypes.bool,
  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: PropTypes.bool,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: PropTypes.bool,
  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata,
  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: PropTypes.func,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: PropTypes.bool
};
var defaultProps$2 = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: "tel",
  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: CountrySelectWithIcon,
  /**
   * Flag icon component.
   */
  flagComponent: FlagComponent,
  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: InternationalIcon,
  /**
   * Phone number `<input/>` component.
   */
  inputComponent: "input",
  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: "div",
  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: PropTypes.any,
  /**
   *
   */
  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: !0,
  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: !0,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: !0,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: !0
};
function withDefaultProps(t) {
  t = _objectSpread$9({}, t);
  for (var r in defaultProps$2)
    t[r] === void 0 && (t[r] = defaultProps$2[r]);
  return t;
}
const PhoneInput$2 = PhoneNumberInput;
function areEqualArrays(t, r) {
  if (t.length !== r.length)
    return !1;
  for (var n = 0; n < t.length; ) {
    if (t[n] !== r[n])
      return !1;
    n++;
  }
  return !0;
}
const defaultLabels = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AB: "Abkhazia",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  OS: "South Ossetia",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
var _excluded$7 = ["metadata", "labels"];
function _objectWithoutProperties$2(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose$1(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose$1(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
function createPhoneInput(t) {
  var r = /* @__PURE__ */ React__default.forwardRef(function(n, a) {
    var s = n.metadata, o = s === void 0 ? t : s, c = n.labels, l = c === void 0 ? defaultLabels : c, d = _objectWithoutProperties$2(n, _excluded$7);
    return /* @__PURE__ */ jsx$1(PhoneInput$2, {
      ...d,
      ref: a,
      metadata: o,
      labels: l
    });
  });
  return r.propTypes = {
    metadata,
    labels
  }, r;
}
createPhoneInput();
function call(t, r) {
  var n = Array.prototype.slice.call(r);
  return n.push(metadata$1), t.apply(this, n);
}
const PhoneInput$1 = createPhoneInput(metadata$1);
function isValidPhoneNumber() {
  return call(isValidPhoneNumber$1, arguments);
}
const style = "", Input$2 = styled(PhoneInput$1)`
  ${TextInputStyles}
  width: 100%;
  .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
  input {
    width: 100%;
    border: none;
    outline: none;
    color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary};
    ${({ theme: { components: t } }) => t.inputs.fds_c_input_content};
    ${({ $hasError: t, theme: { system: r } }) => t && css$3`
        background-color: ${r.background.fds_sys_color_background_error};
        color: ${r.text.fds_sys_color_text_danger_stronger};
      `};
    ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
        background-color: ${r.background.fds_sys_color_background_warning};
        color: ${r.text.fds_sys_color_text_warning_stronger};
      `};
    ::placeholder {
      ${({ theme: { components: t } }) => t.inputs.fds_c_input_content};
      color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_placeholder};
      ${({ $hasError: t, theme: { system: r } }) => t && css$3`
          color: ${r.text.fds_sys_color_text_danger_stronger};
          opacity: ${r.fds_sys_disabled_opacity_S};
        `}
      ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
          color: ${r.text.fds_sys_color_text_warning_stronger};
          opacity: ${r.fds_sys_disabled_opacity_S};
        `}
    }
  }
`, PhoneInput = ({
  value: t,
  defaultCountry: r = "ES",
  onChange: n,
  hasWarning: a,
  ...s
}) => {
  const o = (l) => !!(l && (l == null ? void 0 : l.length) > 0 && !isValidPhoneNumber(l, r));
  return /* @__PURE__ */ jsx$1(Input$2, {
    ...s,
    onChange: (l) => {
      n(l, o(l));
    },
    defaultCountry: r,
    flagUrl: "https://flagcdn.com/{xx}.svg",
    value: t,
    $hasError: o(t),
    $hasWarning: a
  });
}, Phone = withInputLayout(PhoneInput), RadioContainer = styled.label`
  width: 100%;
  display: flex;
  gap: ${({ theme: { reference: t } }) => t.dimension_08};
  flex-direction: ${({ $withInput: t }) => t ? "row" : "column"};
  ${MarginsStyles}
`, Radio$1 = styled.input`
  border-radius: 50%;
  flex: none;
  ${InputOptionStyles}
`;
function convertToType$1(t, r) {
  return t && t.constructor(r);
}
const Radio = ({
  id: t,
  value: r,
  children: n,
  options: a,
  name: s,
  selected: o,
  testID: c,
  disabled: l,
  readOnly: d,
  withInput: h = !1,
  onChange: u,
  ref: p,
  ...m
}) => {
  const g = (v) => {
    var _;
    const y = (_ = a == null ? void 0 : a.find(($) => $.value === v)) == null ? void 0 : _.value, x = convertToType$1(y, v);
    u(x);
  };
  return /* @__PURE__ */ jsxs(RadioContainer, {
    ...m,
    $withInput: h,
    children: [/* @__PURE__ */ jsx$1(Radio$1, {
      type: "radio",
      ref: p,
      id: t,
      "data-testid": c,
      value: r,
      name: s,
      disabled: l || d,
      checked: o === r,
      $readOnly: d,
      $withInput: h,
      onChange: () => g(r)
    }), n]
  });
};
var RadioCardLayout = /* @__PURE__ */ ((t) => (t.GRID = "grid", t.LIST = "list", t))(RadioCardLayout || {});
const Container$a = styled.div`
  container-name: cards;
  container-type: inline-size;
  width: 100%;
`, RadioGroupStyled$1 = styled(Layout.Grid)`
  ${MarginsStyles}
  width: 100%;
  grid-auto-rows: 1fr;
`, styles = "", RadioCard = ({
  onChange: t,
  id: r,
  value: n,
  options: a,
  testID: s,
  name: o,
  ref: c,
  layout: l = RadioCardLayout.GRID,
  onHelpButton: d,
  ...h
}) => /* @__PURE__ */ jsx$1(Container$a, {
  children: /* @__PURE__ */ jsx$1(RadioGroupStyled$1, {
    "data-testid": s,
    ref: c,
    gap: "dimension_16",
    "data-options": l === RadioCardLayout.GRID && (a == null ? void 0 : a.length) || 1,
    className: "radio-card-group",
    ...h,
    children: a == null ? void 0 : a.map(({
      value: u,
      imageUrl: p,
      onContextualClick: m,
      ...g
    }, v) => /* @__PURE__ */ createElement$1(Radio, {
      ...h,
      key: r,
      id: r,
      options: a,
      testID: `${r}-${v}`,
      checked: u === n,
      name: o,
      value: u,
      onChange: t,
      onHelpButton: d
    }, /* @__PURE__ */ jsx$1(Card, {
      ...g,
      checked: u === n,
      value: u,
      imageUrl: p,
      ...m && {
        onContextualClick: m
      }
    })))
  })
}), RadioCard$1 = withInputLayout(RadioCard), RadioGroupStyled = styled(FlexContainer$1)`
  ${MarginsStyles}
  > div {
    display: flex;
    align-items: center;
    ${({ $hasBorder: t, theme: { reference: r } }) => t && css$3`
        padding-bottom: ${r.dimension_20};
        border-bottom: 1px solid rgb(232, 235, 242);
      `};
  }
`, RadioOptionContainer = styled.div``, RadioExtended = ({
  options: t,
  value: r,
  contextualLabel: n = "Saber más",
  onHelpButton: a,
  testID: s,
  className: o,
  hasBorder: c = !1,
  ...l
}) => /* @__PURE__ */ jsx$1(RadioGroupStyled, {
  "data-testid": s,
  $hasBorder: c,
  direction: "column",
  gap: "dimension_20",
  children: t == null ? void 0 : t.map(({
    value: d,
    label: h,
    name: u,
    helpButtonUrl: p
  }) => /* @__PURE__ */ jsx$1(RadioOptionContainer, {
    className: o,
    children: /* @__PURE__ */ jsx$1(Radio, {
      ...l,
      withInput: !0,
      value: d,
      selected: r,
      options: t,
      name: u,
      children: /* @__PURE__ */ jsxs(FlexContainer$1, {
        fullWidth: !0,
        gap: "dimension_08",
        children: [/* @__PURE__ */ jsx$1(Text$3, {
          type: "paragraphs",
          color: "dark",
          size: "S_M_S",
          children: h
        }), p && a && /* @__PURE__ */ jsx$1(Buttons.Contextual, {
          mode: "primary",
          label: n,
          onClick: () => a(p)
        })]
      })
    })
  }, u))
}), RadioExtended$1 = withInputLayout(RadioExtended);
var engine = {}, constants$4 = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    SCOPE_ORIGINAL: () => s
  });
  const s = "ORIGINAL";
})(constants$4);
var core = {}, cjs$1 = {}, mainAny = {}, configReadonly = {}, config$3 = {};
Object.defineProperty(config$3, "__esModule", {
  value: !0
});
config$3.DEFAULT_CONFIG = void 0;
var DEFAULT_CONFIG = {
  // minimum relative difference between two compared values,
  // used by all comparison functions
  epsilon: 1e-12,
  // type of default matrix output. Choose 'matrix' (default) or 'array'
  matrix: "Matrix",
  // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
  number: "number",
  // number of significant digits in BigNumbers
  precision: 64,
  // predictable output type of functions. When true, output type depends only
  // on the input types. When false (default), output type can vary depending
  // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
  // predictable is false, and returns `NaN` when true.
  predictable: !1,
  // random seed for seeded pseudo random number generation
  // null = randomly seed
  randomSeed: null
};
config$3.DEFAULT_CONFIG = DEFAULT_CONFIG;
var config$2 = {}, object = {}, is = {};
Object.defineProperty(is, "__esModule", {
  value: !0
});
is.isNumber = isNumber$1;
is.isBigNumber = isBigNumber;
is.isComplex = isComplex;
is.isFraction = isFraction;
is.isUnit = isUnit;
is.isString = isString$1;
is.isMatrix = isMatrix;
is.isCollection = isCollection;
is.isDenseMatrix = isDenseMatrix;
is.isSparseMatrix = isSparseMatrix;
is.isRange = isRange;
is.isIndex = isIndex;
is.isBoolean = isBoolean;
is.isResultSet = isResultSet;
is.isHelp = isHelp;
is.isFunction = isFunction$1;
is.isDate = isDate$1;
is.isRegExp = isRegExp;
is.isObject = isObject$2;
is.isNull = isNull;
is.isUndefined = isUndefined$1;
is.isAccessorNode = isAccessorNode;
is.isArrayNode = isArrayNode;
is.isAssignmentNode = isAssignmentNode;
is.isBlockNode = isBlockNode;
is.isConditionalNode = isConditionalNode;
is.isConstantNode = isConstantNode;
is.isFunctionAssignmentNode = isFunctionAssignmentNode;
is.isFunctionNode = isFunctionNode;
is.isIndexNode = isIndexNode;
is.isNode = isNode$1;
is.isObjectNode = isObjectNode;
is.isOperatorNode = isOperatorNode;
is.isParenthesisNode = isParenthesisNode;
is.isRangeNode = isRangeNode;
is.isSymbolNode = isSymbolNode;
is.isChain = isChain;
is.typeOf = typeOf$2;
is.isArray = void 0;
function _typeof$h(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$h = function(n) {
    return typeof n;
  } : _typeof$h = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$h(t);
}
function isNumber$1(t) {
  return typeof t == "number";
}
function isBigNumber(t) {
  return t && t.constructor.prototype.isBigNumber === !0 || !1;
}
function isComplex(t) {
  return t && _typeof$h(t) === "object" && Object.getPrototypeOf(t).isComplex === !0 || !1;
}
function isFraction(t) {
  return t && _typeof$h(t) === "object" && Object.getPrototypeOf(t).isFraction === !0 || !1;
}
function isUnit(t) {
  return t && t.constructor.prototype.isUnit === !0 || !1;
}
function isString$1(t) {
  return typeof t == "string";
}
var isArray$2 = Array.isArray;
is.isArray = isArray$2;
function isMatrix(t) {
  return t && t.constructor.prototype.isMatrix === !0 || !1;
}
function isCollection(t) {
  return Array.isArray(t) || isMatrix(t);
}
function isDenseMatrix(t) {
  return t && t.isDenseMatrix && t.constructor.prototype.isMatrix === !0 || !1;
}
function isSparseMatrix(t) {
  return t && t.isSparseMatrix && t.constructor.prototype.isMatrix === !0 || !1;
}
function isRange(t) {
  return t && t.constructor.prototype.isRange === !0 || !1;
}
function isIndex(t) {
  return t && t.constructor.prototype.isIndex === !0 || !1;
}
function isBoolean(t) {
  return typeof t == "boolean";
}
function isResultSet(t) {
  return t && t.constructor.prototype.isResultSet === !0 || !1;
}
function isHelp(t) {
  return t && t.constructor.prototype.isHelp === !0 || !1;
}
function isFunction$1(t) {
  return typeof t == "function";
}
function isDate$1(t) {
  return t instanceof Date;
}
function isRegExp(t) {
  return t instanceof RegExp;
}
function isObject$2(t) {
  return !!(t && _typeof$h(t) === "object" && t.constructor === Object && !isComplex(t) && !isFraction(t));
}
function isNull(t) {
  return t === null;
}
function isUndefined$1(t) {
  return t === void 0;
}
function isAccessorNode(t) {
  return t && t.isAccessorNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isArrayNode(t) {
  return t && t.isArrayNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isAssignmentNode(t) {
  return t && t.isAssignmentNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isBlockNode(t) {
  return t && t.isBlockNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isConditionalNode(t) {
  return t && t.isConditionalNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isConstantNode(t) {
  return t && t.isConstantNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isFunctionAssignmentNode(t) {
  return t && t.isFunctionAssignmentNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isFunctionNode(t) {
  return t && t.isFunctionNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isIndexNode(t) {
  return t && t.isIndexNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isNode$1(t) {
  return t && t.isNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isObjectNode(t) {
  return t && t.isObjectNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isOperatorNode(t) {
  return t && t.isOperatorNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isParenthesisNode(t) {
  return t && t.isParenthesisNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isRangeNode(t) {
  return t && t.isRangeNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isSymbolNode(t) {
  return t && t.isSymbolNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function isChain(t) {
  return t && t.constructor.prototype.isChain === !0 || !1;
}
function typeOf$2(t) {
  var r = _typeof$h(t);
  return r === "object" ? t === null ? "null" : Array.isArray(t) ? "Array" : t instanceof Date ? "Date" : t instanceof RegExp ? "RegExp" : isBigNumber(t) ? "BigNumber" : isComplex(t) ? "Complex" : isFraction(t) ? "Fraction" : isMatrix(t) ? "Matrix" : isUnit(t) ? "Unit" : isIndex(t) ? "Index" : isRange(t) ? "Range" : isResultSet(t) ? "ResultSet" : isNode$1(t) ? t.type : isChain(t) ? "Chain" : isHelp(t) ? "Help" : "Object" : r === "function" ? "Function" : r;
}
Object.defineProperty(object, "__esModule", {
  value: !0
});
object.clone = clone$4;
object.mapObject = mapObject;
object.extend = extend$1;
object.deepExtend = deepExtend$1;
object.deepStrictEqual = deepStrictEqual;
object.deepFlatten = deepFlatten;
object.canDefineProperty = canDefineProperty;
object.lazy = lazy;
object.traverse = traverse;
object.hasOwnProperty = hasOwnProperty$1;
object.isLegacyFactory = isLegacyFactory;
object.get = get$3;
object.set = set$2;
object.pick = pick;
object.pickShallow = pickShallow;
object.values = values;
var _is$1o = is;
function _typeof$g(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$g = function(n) {
    return typeof n;
  } : _typeof$g = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$g(t);
}
function clone$4(t) {
  var r = _typeof$g(t);
  if (r === "number" || r === "string" || r === "boolean" || t === null || t === void 0)
    return t;
  if (typeof t.clone == "function")
    return t.clone();
  if (Array.isArray(t))
    return t.map(function(n) {
      return clone$4(n);
    });
  if (t instanceof Date)
    return new Date(t.valueOf());
  if ((0, _is$1o.isBigNumber)(t))
    return t;
  if (t instanceof RegExp)
    throw new TypeError("Cannot clone " + t);
  return mapObject(t, clone$4);
}
function mapObject(t, r) {
  var n = {};
  for (var a in t)
    hasOwnProperty$1(t, a) && (n[a] = r(t[a]));
  return n;
}
function extend$1(t, r) {
  for (var n in r)
    hasOwnProperty$1(r, n) && (t[n] = r[n]);
  return t;
}
function deepExtend$1(t, r) {
  if (Array.isArray(r))
    throw new TypeError("Arrays are not supported by deepExtend");
  for (var n in r)
    if (hasOwnProperty$1(r, n) && !(n in Object.prototype) && !(n in Function.prototype))
      if (r[n] && r[n].constructor === Object)
        t[n] === void 0 && (t[n] = {}), t[n] && t[n].constructor === Object ? deepExtend$1(t[n], r[n]) : t[n] = r[n];
      else {
        if (Array.isArray(r[n]))
          throw new TypeError("Arrays are not supported by deepExtend");
        t[n] = r[n];
      }
  return t;
}
function deepStrictEqual(t, r) {
  var n, a, s;
  if (Array.isArray(t)) {
    if (!Array.isArray(r) || t.length !== r.length)
      return !1;
    for (a = 0, s = t.length; a < s; a++)
      if (!deepStrictEqual(t[a], r[a]))
        return !1;
    return !0;
  } else {
    if (typeof t == "function")
      return t === r;
    if (t instanceof Object) {
      if (Array.isArray(r) || !(r instanceof Object))
        return !1;
      for (n in t)
        if (!(n in r) || !deepStrictEqual(t[n], r[n]))
          return !1;
      for (n in r)
        if (!(n in t) || !deepStrictEqual(t[n], r[n]))
          return !1;
      return !0;
    } else
      return t === r;
  }
}
function deepFlatten(t) {
  var r = {};
  return _deepFlatten(t, r), r;
}
function _deepFlatten(t, r) {
  for (var n in t)
    if (hasOwnProperty$1(t, n)) {
      var a = t[n];
      _typeof$g(a) === "object" && a !== null ? _deepFlatten(a, r) : r[n] = a;
    }
}
function canDefineProperty() {
  try {
    if (Object.defineProperty)
      return Object.defineProperty({}, "x", {
        get: function() {
        }
      }), !0;
  } catch {
  }
  return !1;
}
function lazy(t, r, n) {
  var a = !0, s;
  Object.defineProperty(t, r, {
    get: function() {
      return a && (s = n(), a = !1), s;
    },
    set: function(c) {
      s = c, a = !1;
    },
    configurable: !0,
    enumerable: !0
  });
}
function traverse(t, r) {
  if (r && typeof r == "string")
    return traverse(t, r.split("."));
  var n = t;
  if (r)
    for (var a = 0; a < r.length; a++) {
      var s = r[a];
      s in n || (n[s] = {}), n = n[s];
    }
  return n;
}
function hasOwnProperty$1(t, r) {
  return t && Object.hasOwnProperty.call(t, r);
}
function isLegacyFactory(t) {
  return t && typeof t.factory == "function";
}
function get$3(t, r) {
  if (typeof r == "string")
    return isPath(r) ? get$3(t, r.split(".")) : t[r];
  for (var n = t, a = 0; a < r.length; a++) {
    var s = r[a];
    n = n ? n[s] : void 0;
  }
  return n;
}
function set$2(t, r, n) {
  if (typeof r == "string")
    return isPath(r) ? set$2(t, r.split("."), n) : (t[r] = n, t);
  for (var a = t, s = 0; s < r.length - 1; s++) {
    var o = r[s];
    a[o] === void 0 && (a[o] = {}), a = a[o];
  }
  if (r.length > 0) {
    var c = r[r.length - 1];
    a[c] = n;
  }
  return t;
}
function pick(t, r, n) {
  for (var a = {}, s = 0; s < r.length; s++) {
    var o = r[s], c = get$3(t, o);
    c !== void 0 && set$2(a, o, n ? n(c, o) : c);
  }
  return a;
}
function pickShallow(t, r) {
  for (var n = {}, a = 0; a < r.length; a++) {
    var s = r[a], o = t[s];
    o !== void 0 && (n[s] = o);
  }
  return n;
}
function values(t) {
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
function isPath(t) {
  return t.indexOf(".") !== -1;
}
Object.defineProperty(config$2, "__esModule", {
  value: !0
});
config$2.configFactory = configFactory;
config$2.NUMBER_OPTIONS = config$2.MATRIX_OPTIONS = void 0;
var _object$C = object, _config2$2 = config$3, MATRIX_OPTIONS = ["Matrix", "Array"];
config$2.MATRIX_OPTIONS = MATRIX_OPTIONS;
var NUMBER_OPTIONS = ["number", "BigNumber", "Fraction"];
config$2.NUMBER_OPTIONS = NUMBER_OPTIONS;
function configFactory(t, r) {
  function n(a) {
    if (a) {
      var s = (0, _object$C.mapObject)(t, _object$C.clone);
      validateOption(a, "matrix", MATRIX_OPTIONS), validateOption(a, "number", NUMBER_OPTIONS), (0, _object$C.deepExtend)(t, a);
      var o = (0, _object$C.mapObject)(t, _object$C.clone), c = (0, _object$C.mapObject)(a, _object$C.clone);
      return r("config", o, s, c), o;
    } else
      return (0, _object$C.mapObject)(t, _object$C.clone);
  }
  return n.MATRIX_OPTIONS = MATRIX_OPTIONS, n.NUMBER_OPTIONS = NUMBER_OPTIONS, Object.keys(_config2$2.DEFAULT_CONFIG).forEach(function(a) {
    Object.defineProperty(n, a, {
      get: function() {
        return t[a];
      },
      enumerable: !0,
      configurable: !0
    });
  }), n;
}
function contains$1(t, r) {
  return t.indexOf(r) !== -1;
}
function validateOption(t, r, n) {
  t[r] !== void 0 && !contains$1(n, t[r]) && console.warn('Warning: Unknown value "' + t[r] + '" for configuration option "' + r + '". Available options: ' + n.map(function(a) {
    return JSON.stringify(a);
  }).join(", ") + ".");
}
Object.defineProperty(configReadonly, "__esModule", {
  value: !0
});
configReadonly.config = void 0;
var _config$2 = config$3, _config2$1 = config$2;
function _extends$6() {
  return _extends$6 = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends$6.apply(this, arguments);
}
var config$1 = function(r) {
  if (r)
    throw new Error(`The global config is readonly. 
Please create a mathjs instance if you want to change the default configuration. 
Example:

  import { create, all } from 'mathjs';
  const mathjs = create(all);
  mathjs.config({ number: 'BigNumber' });
`);
  return Object.freeze(_config$2.DEFAULT_CONFIG);
};
configReadonly.config = config$1;
_extends$6(config$1, _config$2.DEFAULT_CONFIG, {
  MATRIX_OPTIONS: _config2$1.MATRIX_OPTIONS,
  NUMBER_OPTIONS: _config2$1.NUMBER_OPTIONS
});
var pureFunctionsAny_generated = {}, factoriesAny = {}, typed$1 = {}, typedFunction = { exports: {} };
(function(t, r) {
  (function(n, a) {
    t.exports = a();
  })(commonjsGlobal, function() {
    function n() {
      return !0;
    }
    function a() {
      return !1;
    }
    function s() {
    }
    function o() {
      var c = [
        { name: "number", test: function(ze) {
          return typeof ze == "number";
        } },
        { name: "string", test: function(ze) {
          return typeof ze == "string";
        } },
        { name: "boolean", test: function(ze) {
          return typeof ze == "boolean";
        } },
        { name: "Function", test: function(ze) {
          return typeof ze == "function";
        } },
        { name: "Array", test: Array.isArray },
        { name: "Date", test: function(ze) {
          return ze instanceof Date;
        } },
        { name: "RegExp", test: function(ze) {
          return ze instanceof RegExp;
        } },
        { name: "Object", test: function(ze) {
          return typeof ze == "object" && ze !== null && ze.constructor === Object;
        } },
        { name: "null", test: function(ze) {
          return ze === null;
        } },
        { name: "undefined", test: function(ze) {
          return ze === void 0;
        } }
      ], l = {
        name: "any",
        test: n
      }, d = [], h = [], u = {
        types: c,
        conversions: h,
        ignore: d
      };
      function p(ze) {
        var cr = ne(u.types, function(mr) {
          return mr.name === ze;
        });
        if (cr)
          return cr;
        if (ze === "any")
          return l;
        var fr = ne(u.types, function(mr) {
          return mr.name.toLowerCase() === ze.toLowerCase();
        });
        throw new TypeError('Unknown type "' + ze + '"' + (fr ? '. Did you mean "' + fr.name + '"?' : ""));
      }
      function m(ze) {
        return ze === l ? 999 : u.types.indexOf(ze);
      }
      function g(ze) {
        var cr = ne(u.types, function(fr) {
          return fr.test(ze);
        });
        if (cr)
          return cr.name;
        throw new TypeError("Value has unknown type. Value: " + ze);
      }
      function v(ze, cr) {
        if (!ze.signatures)
          throw new TypeError("Function is no typed-function");
        var fr;
        if (typeof cr == "string") {
          fr = cr.split(",");
          for (var mr = 0; mr < fr.length; mr++)
            fr[mr] = fr[mr].trim();
        } else if (Array.isArray(cr))
          fr = cr;
        else
          throw new TypeError("String array or a comma separated string expected");
        var wr = fr.join(","), Nr = ze.signatures[wr];
        if (Nr)
          return Nr;
        throw new TypeError("Signature not found (signature: " + (ze.name || "unnamed") + "(" + fr.join(", ") + "))");
      }
      function y(ze, cr) {
        var fr = g(ze);
        if (cr === fr)
          return ze;
        for (var mr = 0; mr < u.conversions.length; mr++) {
          var wr = u.conversions[mr];
          if (wr.from === fr && wr.to === cr)
            return wr.convert(ze);
        }
        throw new Error("Cannot convert from " + fr + " to " + cr);
      }
      function x(ze) {
        return ze.map(function(cr) {
          var fr = cr.types.map(N);
          return (cr.restParam ? "..." : "") + fr.join("|");
        }).join(",");
      }
      function _(ze, cr) {
        var fr = ze.indexOf("...") === 0, mr = fr ? ze.length > 3 ? ze.slice(3) : "any" : ze, wr = mr.split("|").map(ee).filter(se).filter(ae), Nr = k(cr, wr), xr = wr.map(function(Ir) {
          var Rr = p(Ir);
          return {
            name: Ir,
            typeIndex: m(Rr),
            test: Rr.test,
            conversion: null,
            conversionIndex: -1
          };
        }), Er = Nr.map(function(Ir) {
          var Rr = p(Ir.from);
          return {
            name: Ir.from,
            typeIndex: m(Rr),
            test: Rr.test,
            conversion: Ir,
            conversionIndex: cr.indexOf(Ir)
          };
        });
        return {
          types: xr.concat(Er),
          restParam: fr
        };
      }
      function $(ze, cr, fr) {
        var mr = [];
        return ze.trim() !== "" && (mr = ze.split(",").map(ee).map(function(wr, Nr, xr) {
          var Er = _(wr, fr);
          if (Er.restParam && Nr !== xr.length - 1)
            throw new SyntaxError('Unexpected rest parameter "' + wr + '": only allowed for the last parameter');
          return Er;
        })), mr.some(ce) ? null : {
          params: mr,
          fn: cr
        };
      }
      function b(ze) {
        var cr = ur(ze);
        return cr ? cr.restParam : !1;
      }
      function M(ze) {
        return ze.types.some(function(cr) {
          return cr.conversion != null;
        });
      }
      function C(ze) {
        if (!ze || ze.types.length === 0)
          return n;
        if (ze.types.length === 1)
          return p(ze.types[0].name).test;
        if (ze.types.length === 2) {
          var cr = p(ze.types[0].name).test, fr = p(ze.types[1].name).test;
          return function(Nr) {
            return cr(Nr) || fr(Nr);
          };
        } else {
          var mr = ze.types.map(function(wr) {
            return p(wr.name).test;
          });
          return function(Nr) {
            for (var xr = 0; xr < mr.length; xr++)
              if (mr[xr](Nr))
                return !0;
            return !1;
          };
        }
      }
      function S(ze) {
        var cr, fr, mr;
        if (b(ze)) {
          cr = oe(ze).map(C);
          var wr = cr.length, Nr = C(ur(ze)), xr = function(Er) {
            for (var Ir = wr; Ir < Er.length; Ir++)
              if (!Nr(Er[Ir]))
                return !1;
            return !0;
          };
          return function(Ir) {
            for (var Rr = 0; Rr < cr.length; Rr++)
              if (!cr[Rr](Ir[Rr]))
                return !1;
            return xr(Ir) && Ir.length >= wr + 1;
          };
        } else
          return ze.length === 0 ? function(Ir) {
            return Ir.length === 0;
          } : ze.length === 1 ? (fr = C(ze[0]), function(Ir) {
            return fr(Ir[0]) && Ir.length === 1;
          }) : ze.length === 2 ? (fr = C(ze[0]), mr = C(ze[1]), function(Ir) {
            return fr(Ir[0]) && mr(Ir[1]) && Ir.length === 2;
          }) : (cr = ze.map(C), function(Ir) {
            for (var Rr = 0; Rr < cr.length; Rr++)
              if (!cr[Rr](Ir[Rr]))
                return !1;
            return Ir.length === cr.length;
          });
      }
      function A(ze, cr) {
        return cr < ze.params.length ? ze.params[cr] : b(ze.params) ? ur(ze.params) : null;
      }
      function D(ze, cr, fr) {
        var mr = A(ze, cr), wr = mr ? fr ? mr.types.filter(T) : mr.types : [];
        return wr.map(N);
      }
      function N(ze) {
        return ze.name;
      }
      function T(ze) {
        return ze.conversion === null || ze.conversion === void 0;
      }
      function R(ze, cr) {
        var fr = pe(hr(ze, function(mr) {
          return D(mr, cr, !1);
        }));
        return fr.indexOf("any") !== -1 ? ["any"] : fr;
      }
      function F(ze, cr, fr) {
        var mr, wr, Nr = ze || "unnamed", xr = fr, Er;
        for (Er = 0; Er < cr.length; Er++) {
          var Ir = xr.filter(function(nn) {
            var on = C(A(nn, Er));
            return (Er < nn.params.length || b(nn.params)) && on(cr[Er]);
          });
          if (Ir.length === 0) {
            if (wr = R(xr, Er), wr.length > 0) {
              var Rr = g(cr[Er]);
              return mr = new TypeError("Unexpected type of argument in function " + Nr + " (expected: " + wr.join(" or ") + ", actual: " + Rr + ", index: " + Er + ")"), mr.data = {
                category: "wrongType",
                fn: Nr,
                index: Er,
                actual: Rr,
                expected: wr
              }, mr;
            }
          } else
            xr = Ir;
        }
        var Yr = xr.map(function(nn) {
          return b(nn.params) ? 1 / 0 : nn.params.length;
        });
        if (cr.length < Math.min.apply(null, Yr))
          return wr = R(xr, Er), mr = new TypeError("Too few arguments in function " + Nr + " (expected: " + wr.join(" or ") + ", index: " + cr.length + ")"), mr.data = {
            category: "tooFewArgs",
            fn: Nr,
            index: cr.length,
            expected: wr
          }, mr;
        var Qr = Math.max.apply(null, Yr);
        return cr.length > Qr ? (mr = new TypeError("Too many arguments in function " + Nr + " (expected: " + Qr + ", actual: " + cr.length + ")"), mr.data = {
          category: "tooManyArgs",
          fn: Nr,
          index: cr.length,
          expectedLength: Qr
        }, mr) : (mr = new TypeError('Arguments of type "' + cr.join(", ") + '" do not match any of the defined signatures of function ' + Nr + "."), mr.data = {
          category: "mismatch",
          actual: cr.map(g)
        }, mr);
      }
      function z(ze) {
        for (var cr = 999, fr = 0; fr < ze.types.length; fr++)
          T(ze.types[fr]) && (cr = Math.min(cr, ze.types[fr].typeIndex));
        return cr;
      }
      function O(ze) {
        for (var cr = 999, fr = 0; fr < ze.types.length; fr++)
          T(ze.types[fr]) || (cr = Math.min(cr, ze.types[fr].conversionIndex));
        return cr;
      }
      function G(ze, cr) {
        var fr;
        return fr = ze.restParam - cr.restParam, fr !== 0 || (fr = M(ze) - M(cr), fr !== 0) || (fr = z(ze) - z(cr), fr !== 0) ? fr : O(ze) - O(cr);
      }
      function I(ze, cr) {
        var fr = Math.min(ze.params.length, cr.params.length), mr, wr;
        if (wr = ze.params.some(M) - cr.params.some(M), wr !== 0)
          return wr;
        for (mr = 0; mr < fr; mr++)
          if (wr = M(ze.params[mr]) - M(cr.params[mr]), wr !== 0)
            return wr;
        for (mr = 0; mr < fr; mr++)
          if (wr = G(ze.params[mr], cr.params[mr]), wr !== 0)
            return wr;
        return ze.params.length - cr.params.length;
      }
      function k(ze, cr) {
        var fr = {};
        return ze.forEach(function(mr) {
          cr.indexOf(mr.from) === -1 && cr.indexOf(mr.to) !== -1 && !fr[mr.from] && (fr[mr.from] = mr);
        }), Object.keys(fr).map(function(mr) {
          return fr[mr];
        });
      }
      function B(ze, cr) {
        var fr = cr;
        if (ze.some(M)) {
          var mr = b(ze), wr = ze.map(L);
          fr = function() {
            for (var Ir = [], Rr = mr ? arguments.length - 1 : arguments.length, Yr = 0; Yr < Rr; Yr++)
              Ir[Yr] = wr[Yr](arguments[Yr]);
            return mr && (Ir[Rr] = arguments[Rr].map(wr[Rr])), cr.apply(this, Ir);
          };
        }
        var Nr = fr;
        if (b(ze)) {
          var xr = ze.length - 1;
          Nr = function() {
            return fr.apply(
              this,
              ir(arguments, 0, xr).concat([ir(arguments, xr)])
            );
          };
        }
        return Nr;
      }
      function L(ze) {
        var cr, fr, mr, wr, Nr = [], xr = [];
        switch (ze.types.forEach(function(Er) {
          Er.conversion && (Nr.push(p(Er.conversion.from).test), xr.push(Er.conversion.convert));
        }), xr.length) {
          case 0:
            return function(Ir) {
              return Ir;
            };
          case 1:
            return cr = Nr[0], mr = xr[0], function(Ir) {
              return cr(Ir) ? mr(Ir) : Ir;
            };
          case 2:
            return cr = Nr[0], fr = Nr[1], mr = xr[0], wr = xr[1], function(Ir) {
              return cr(Ir) ? mr(Ir) : fr(Ir) ? wr(Ir) : Ir;
            };
          default:
            return function(Ir) {
              for (var Rr = 0; Rr < xr.length; Rr++)
                if (Nr[Rr](Ir))
                  return xr[Rr](Ir);
              return Ir;
            };
        }
      }
      function V(ze) {
        var cr = {};
        return ze.forEach(function(fr) {
          fr.params.some(M) || U(fr.params, !0).forEach(function(mr) {
            cr[x(mr)] = fr.fn;
          });
        }), cr;
      }
      function U(ze, cr) {
        function fr(mr, wr, Nr) {
          if (wr < mr.length) {
            var xr = mr[wr], Er = cr ? xr.types.filter(T) : xr.types, Ir;
            if (xr.restParam) {
              var Rr = Er.filter(T);
              Ir = Rr.length < Er.length ? [Rr, Er] : [Er];
            } else
              Ir = Er.map(function(Qr) {
                return [Qr];
              });
            return hr(Ir, function(Qr) {
              return fr(mr, wr + 1, Nr.concat([Qr]));
            });
          } else {
            var Yr = Nr.map(function(Qr, nn) {
              return {
                types: Qr,
                restParam: nn === mr.length - 1 && b(mr)
              };
            });
            return [Yr];
          }
        }
        return fr(ze, 0, []);
      }
      function J(ze, cr) {
        for (var fr = Math.max(ze.params.length, cr.params.length), mr = 0; mr < fr; mr++) {
          var wr = D(ze, mr, !0), Nr = D(cr, mr, !0);
          if (!yr(wr, Nr))
            return !1;
        }
        var xr = ze.params.length, Er = cr.params.length, Ir = b(ze.params), Rr = b(cr.params);
        return Ir ? Rr ? xr === Er : Er >= xr : Rr ? xr >= Er : xr === Er;
      }
      function q(ze, cr) {
        if (Object.keys(cr).length === 0)
          throw new SyntaxError("No signatures provided");
        var fr = [];
        Object.keys(cr).map(function(Br) {
          return $(Br, cr[Br], u.conversions);
        }).filter(nr).forEach(function(Br) {
          var W = ne(fr, function(Y) {
            return J(Y, Br);
          });
          if (W)
            throw new TypeError('Conflicting signatures "' + x(W.params) + '" and "' + x(Br.params) + '".');
          fr.push(Br);
        });
        var mr = hr(fr, function(Br) {
          var W = Br ? U(Br.params, !1) : [];
          return W.map(function(Y) {
            return {
              params: Y,
              fn: Br.fn
            };
          });
        }).filter(nr);
        mr.sort(I);
        var wr = mr[0] && mr[0].params.length <= 2 && !b(mr[0].params), Nr = mr[1] && mr[1].params.length <= 2 && !b(mr[1].params), xr = mr[2] && mr[2].params.length <= 2 && !b(mr[2].params), Er = mr[3] && mr[3].params.length <= 2 && !b(mr[3].params), Ir = mr[4] && mr[4].params.length <= 2 && !b(mr[4].params), Rr = mr[5] && mr[5].params.length <= 2 && !b(mr[5].params), Yr = wr && Nr && xr && Er && Ir && Rr, Qr = mr.map(function(Br) {
          return S(Br.params);
        }), nn = wr ? C(mr[0].params[0]) : a, on = Nr ? C(mr[1].params[0]) : a, en = xr ? C(mr[2].params[0]) : a, zr = Er ? C(mr[3].params[0]) : a, Jr = Ir ? C(mr[4].params[0]) : a, H = Rr ? C(mr[5].params[0]) : a, dr = wr ? C(mr[0].params[1]) : a, Ar = Nr ? C(mr[1].params[1]) : a, jr = xr ? C(mr[2].params[1]) : a, Vr = Er ? C(mr[3].params[1]) : a, Zr = Ir ? C(mr[4].params[1]) : a, pn = Rr ? C(mr[5].params[1]) : a, gr = mr.map(function(Br) {
          return B(Br.params, Br.fn);
        }), Cr = wr ? gr[0] : s, Pr = Nr ? gr[1] : s, Tr = xr ? gr[2] : s, Xr = Er ? gr[3] : s, rn = Ir ? gr[4] : s, un = Rr ? gr[5] : s, ln = wr ? mr[0].params.length : -1, bn = Nr ? mr[1].params.length : -1, $n = xr ? mr[2].params.length : -1, An = Er ? mr[3].params.length : -1, Nn = Ir ? mr[4].params.length : -1, Pn = Rr ? mr[5].params.length : -1, Tn = Yr ? 6 : 0, pr = mr.length, Lr = function() {
          for (var W = Tn; W < pr; W++)
            if (Qr[W](arguments))
              return gr[W].apply(this, arguments);
          return u.onMismatch(ze, arguments, mr);
        }, Fr = function Br(W, Y) {
          return arguments.length === ln && nn(W) && dr(Y) ? Cr.apply(Br, arguments) : arguments.length === bn && on(W) && Ar(Y) ? Pr.apply(Br, arguments) : arguments.length === $n && en(W) && jr(Y) ? Tr.apply(Br, arguments) : arguments.length === An && zr(W) && Vr(Y) ? Xr.apply(Br, arguments) : arguments.length === Nn && Jr(W) && Zr(Y) ? rn.apply(Br, arguments) : arguments.length === Pn && H(W) && pn(Y) ? un.apply(Br, arguments) : Lr.apply(Br, arguments);
        };
        try {
          Object.defineProperty(Fr, "name", { value: ze });
        } catch {
        }
        return Fr.signatures = V(mr), Fr;
      }
      function Z(ze, cr, fr) {
        throw F(ze, cr, fr);
      }
      function ae(ze) {
        return u.ignore.indexOf(ze) === -1;
      }
      function ee(ze) {
        return ze.trim();
      }
      function se(ze) {
        return !!ze;
      }
      function nr(ze) {
        return ze !== null;
      }
      function ce(ze) {
        return ze.types.length === 0;
      }
      function oe(ze) {
        return ze.slice(0, ze.length - 1);
      }
      function ur(ze) {
        return ze[ze.length - 1];
      }
      function ir(ze, cr, fr) {
        return Array.prototype.slice.call(ze, cr, fr);
      }
      function _r(ze, cr) {
        return ze.indexOf(cr) !== -1;
      }
      function yr(ze, cr) {
        for (var fr = 0; fr < ze.length; fr++)
          if (_r(cr, ze[fr]))
            return !0;
        return !1;
      }
      function ne(ze, cr) {
        for (var fr = 0; fr < ze.length; fr++)
          if (cr(ze[fr]))
            return ze[fr];
      }
      function pe(ze) {
        for (var cr = {}, fr = 0; fr < ze.length; fr++)
          cr[ze[fr]] = !0;
        return Object.keys(cr);
      }
      function hr(ze, cr) {
        return Array.prototype.concat.apply([], ze.map(cr));
      }
      function $r(ze) {
        for (var cr = "", fr = 0; fr < ze.length; fr++) {
          var mr = ze[fr];
          if ((typeof mr.signatures == "object" || typeof mr.signature == "string") && mr.name !== "") {
            if (cr === "")
              cr = mr.name;
            else if (cr !== mr.name) {
              var wr = new Error("Function names do not match (expected: " + cr + ", actual: " + mr.name + ")");
              throw wr.data = {
                actual: mr.name,
                expected: cr
              }, wr;
            }
          }
        }
        return cr;
      }
      function Sr(ze) {
        var cr, fr = {};
        function mr(Er, Ir) {
          if (fr.hasOwnProperty(Er) && Ir !== fr[Er])
            throw cr = new Error('Signature "' + Er + '" is defined twice'), cr.data = { signature: Er }, cr;
        }
        for (var wr = 0; wr < ze.length; wr++) {
          var Nr = ze[wr];
          if (typeof Nr.signatures == "object")
            for (var xr in Nr.signatures)
              Nr.signatures.hasOwnProperty(xr) && (mr(xr, Nr.signatures[xr]), fr[xr] = Nr.signatures[xr]);
          else if (typeof Nr.signature == "string")
            mr(Nr.signature, Nr), fr[Nr.signature] = Nr;
          else
            throw cr = new TypeError("Function is no typed-function (index: " + wr + ")"), cr.data = { index: wr }, cr;
        }
        return fr;
      }
      return u = q("typed", {
        "string, Object": q,
        Object: function(ze) {
          var cr = [];
          for (var fr in ze)
            ze.hasOwnProperty(fr) && cr.push(ze[fr]);
          var mr = $r(cr);
          return q(mr, ze);
        },
        "...Function": function(ze) {
          return q($r(ze), Sr(ze));
        },
        "string, ...Function": function(ze, cr) {
          return q(ze, Sr(cr));
        }
      }), u.create = o, u.types = c, u.conversions = h, u.ignore = d, u.onMismatch = Z, u.throwMismatchError = Z, u.createError = F, u.convert = y, u.find = v, u.addType = function(ze, cr) {
        if (!ze || typeof ze.name != "string" || typeof ze.test != "function")
          throw new TypeError("Object with properties {name: string, test: function} expected");
        if (cr !== !1) {
          for (var fr = 0; fr < u.types.length; fr++)
            if (u.types[fr].name === "Object") {
              u.types.splice(fr, 0, ze);
              return;
            }
        }
        u.types.push(ze);
      }, u.addConversion = function(ze) {
        if (!ze || typeof ze.from != "string" || typeof ze.to != "string" || typeof ze.convert != "function")
          throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
        u.conversions.push(ze);
      }, u;
    }
    return o();
  });
})(typedFunction);
var typedFunctionExports = typedFunction.exports, number$3 = {};
Object.defineProperty(number$3, "__esModule", {
  value: !0
});
number$3.isInteger = isInteger$2;
number$3.format = format$5;
number$3.splitNumber = splitNumber;
number$3.toEngineering = toEngineering$1;
number$3.toFixed = toFixed$1;
number$3.toExponential = toExponential$1;
number$3.toPrecision = toPrecision;
number$3.roundDigits = roundDigits;
number$3.digits = digits;
number$3.nearlyEqual = nearlyEqual$2;
number$3.tanh = number$3.sinh = number$3.cosh = number$3.atanh = number$3.asinh = number$3.acosh = number$3.DBL_EPSILON = number$3.expm1 = number$3.cbrt = number$3.log1p = number$3.log10 = number$3.log2 = number$3.sign = void 0;
var _is$1n = is;
function isInteger$2(t) {
  return typeof t == "boolean" ? !0 : isFinite(t) ? t === Math.round(t) : !1;
}
var sign$3 = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
};
number$3.sign = sign$3;
var log2$2 = Math.log2 || function(r) {
  return Math.log(r) / Math.LN2;
};
number$3.log2 = log2$2;
var log10$2 = Math.log10 || function(r) {
  return Math.log(r) / Math.LN10;
};
number$3.log10 = log10$2;
var log1p$2 = Math.log1p || function(t) {
  return Math.log(t + 1);
};
number$3.log1p = log1p$2;
var cbrt$2 = Math.cbrt || function(r) {
  if (r === 0)
    return r;
  var n = r < 0, a;
  return n && (r = -r), isFinite(r) ? (a = Math.exp(Math.log(r) / 3), a = (r / (a * a) + 2 * a) / 3) : a = r, n ? -a : a;
};
number$3.cbrt = cbrt$2;
var expm1$2 = Math.expm1 || function(r) {
  return r >= 2e-4 || r <= -2e-4 ? Math.exp(r) - 1 : r + r * r / 2 + r * r * r / 6;
};
number$3.expm1 = expm1$2;
function format$5(t, r) {
  if (typeof r == "function")
    return r(t);
  if (t === 1 / 0)
    return "Infinity";
  if (t === -1 / 0)
    return "-Infinity";
  if (isNaN(t))
    return "NaN";
  var n = "auto", a;
  switch (r && (r.notation && (n = r.notation), (0, _is$1n.isNumber)(r) ? a = r : (0, _is$1n.isNumber)(r.precision) && (a = r.precision)), n) {
    case "fixed":
      return toFixed$1(t, a);
    case "exponential":
      return toExponential$1(t, a);
    case "engineering":
      return toEngineering$1(t, a);
    case "auto":
      return toPrecision(t, a, r && r).replace(/((\.\d*?)(0+))($|e)/, function() {
        var s = arguments[2], o = arguments[4];
        return s !== "." ? s + o : o;
      });
    default:
      throw new Error('Unknown notation "' + n + '". Choose "auto", "exponential", or "fixed".');
  }
}
function splitNumber(t) {
  var r = String(t).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!r)
    throw new SyntaxError("Invalid number " + t);
  var n = r[1], a = r[2], s = parseFloat(r[4] || "0"), o = a.indexOf(".");
  s += o !== -1 ? o - 1 : a.length - 1;
  var c = a.replace(".", "").replace(/^0*/, function(l) {
    return s -= l.length, "";
  }).replace(/0*$/, "").split("").map(function(l) {
    return parseInt(l);
  });
  return c.length === 0 && (c.push(0), s++), {
    sign: n,
    coefficients: c,
    exponent: s
  };
}
function toEngineering$1(t, r) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var n = splitNumber(t), a = roundDigits(n, r), s = a.exponent, o = a.coefficients, c = s % 3 === 0 ? s : s < 0 ? s - 3 - s % 3 : s - s % 3;
  if ((0, _is$1n.isNumber)(r))
    for (; r > o.length || s - c + 1 > o.length; )
      o.push(0);
  else
    for (var l = Math.abs(s - c) - (o.length - 1), d = 0; d < l; d++)
      o.push(0);
  for (var h = Math.abs(s - c), u = 1; h > 0; )
    u++, h--;
  var p = o.slice(u).join(""), m = (0, _is$1n.isNumber)(r) && p.length || p.match(/[1-9]/) ? "." + p : "", g = o.slice(0, u).join("") + m + "e" + (s >= 0 ? "+" : "") + c.toString();
  return a.sign + g;
}
function toFixed$1(t, r) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var n = splitNumber(t), a = typeof r == "number" ? roundDigits(n, n.exponent + 1 + r) : n, s = a.coefficients, o = a.exponent + 1, c = o + (r || 0);
  return s.length < c && (s = s.concat(zeros$2(c - s.length))), o < 0 && (s = zeros$2(-o + 1).concat(s), o = 1), o < s.length && s.splice(o, 0, o === 0 ? "0." : "."), a.sign + s.join("");
}
function toExponential$1(t, r) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var n = splitNumber(t), a = r ? roundDigits(n, r) : n, s = a.coefficients, o = a.exponent;
  s.length < r && (s = s.concat(zeros$2(r - s.length)));
  var c = s.shift();
  return a.sign + c + (s.length > 0 ? "." + s.join("") : "") + "e" + (o >= 0 ? "+" : "") + o;
}
function toPrecision(t, r, n) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var a = n && n.lowerExp !== void 0 ? n.lowerExp : -3, s = n && n.upperExp !== void 0 ? n.upperExp : 5, o = splitNumber(t), c = r ? roundDigits(o, r) : o;
  if (c.exponent < a || c.exponent >= s)
    return toExponential$1(t, r);
  var l = c.coefficients, d = c.exponent;
  l.length < r && (l = l.concat(zeros$2(r - l.length))), l = l.concat(zeros$2(d - l.length + 1 + (l.length < r ? r - l.length : 0))), l = zeros$2(-d).concat(l);
  var h = d > 0 ? d : 0;
  return h < l.length - 1 && l.splice(h + 1, 0, "."), c.sign + l.join("");
}
function roundDigits(t, r) {
  for (var n = {
    sign: t.sign,
    coefficients: t.coefficients,
    exponent: t.exponent
  }, a = n.coefficients; r <= 0; )
    a.unshift(0), n.exponent++, r++;
  if (a.length > r) {
    var s = a.splice(r, a.length - r);
    if (s[0] >= 5) {
      var o = r - 1;
      for (a[o]++; a[o] === 10; )
        a.pop(), o === 0 && (a.unshift(0), n.exponent++, o++), o--, a[o]++;
    }
  }
  return n;
}
function zeros$2(t) {
  for (var r = [], n = 0; n < t; n++)
    r.push(0);
  return r;
}
function digits(t) {
  return t.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
var DBL_EPSILON = Number.EPSILON || 2220446049250313e-31;
number$3.DBL_EPSILON = DBL_EPSILON;
function nearlyEqual$2(t, r, n) {
  if (n == null)
    return t === r;
  if (t === r)
    return !0;
  if (isNaN(t) || isNaN(r))
    return !1;
  if (isFinite(t) && isFinite(r)) {
    var a = Math.abs(t - r);
    return a < DBL_EPSILON ? !0 : a <= Math.max(Math.abs(t), Math.abs(r)) * n;
  }
  return !1;
}
var acosh$2 = Math.acosh || function(t) {
  return Math.log(Math.sqrt(t * t - 1) + t);
};
number$3.acosh = acosh$2;
var asinh$2 = Math.asinh || function(t) {
  return Math.log(Math.sqrt(t * t + 1) + t);
};
number$3.asinh = asinh$2;
var atanh$2 = Math.atanh || function(t) {
  return Math.log((1 + t) / (1 - t)) / 2;
};
number$3.atanh = atanh$2;
var cosh$2 = Math.cosh || function(t) {
  return (Math.exp(t) + Math.exp(-t)) / 2;
};
number$3.cosh = cosh$2;
var sinh$2 = Math.sinh || function(t) {
  return (Math.exp(t) - Math.exp(-t)) / 2;
};
number$3.sinh = sinh$2;
var tanh$2 = Math.tanh || function(t) {
  var r = Math.exp(2 * t);
  return (r - 1) / (r + 1);
};
number$3.tanh = tanh$2;
var factory$1 = {}, array = {}, string$2 = {}, formatter = {};
Object.defineProperty(formatter, "__esModule", {
  value: !0
});
formatter.format = format$4;
formatter.toEngineering = toEngineering;
formatter.toExponential = toExponential;
formatter.toFixed = toFixed;
function format$4(t, r) {
  if (typeof r == "function")
    return r(t);
  if (!t.isFinite())
    return t.isNaN() ? "NaN" : t.gt(0) ? "Infinity" : "-Infinity";
  var n = "auto", a;
  switch (r !== void 0 && (r.notation && (n = r.notation), typeof r == "number" ? a = r : r.precision && (a = r.precision)), n) {
    case "fixed":
      return toFixed(t, a);
    case "exponential":
      return toExponential(t, a);
    case "engineering":
      return toEngineering(t, a);
    case "auto": {
      var s = r && r.lowerExp !== void 0 ? r.lowerExp : -3, o = r && r.upperExp !== void 0 ? r.upperExp : 5;
      if (t.isZero())
        return "0";
      var c, l = t.toSignificantDigits(a), d = l.e;
      return d >= s && d < o ? c = l.toFixed() : c = toExponential(t, a), c.replace(/((\.\d*?)(0+))($|e)/, function() {
        var h = arguments[2], u = arguments[4];
        return h !== "." ? h + u : u;
      });
    }
    default:
      throw new Error('Unknown notation "' + n + '". Choose "auto", "exponential", or "fixed".');
  }
}
function toEngineering(t, r) {
  var n = t.e, a = n % 3 === 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3, s = t.mul(Math.pow(10, -a)), o = s.toPrecision(r);
  return o.indexOf("e") !== -1 && (o = s.toString()), o + "e" + (n >= 0 ? "+" : "") + a.toString();
}
function toExponential(t, r) {
  return r !== void 0 ? t.toExponential(r - 1) : t.toExponential();
}
function toFixed(t, r) {
  return t.toFixed(r);
}
Object.defineProperty(string$2, "__esModule", {
  value: !0
});
string$2.endsWith = endsWith;
string$2.format = format$3;
string$2.stringify = stringify$2;
string$2.escape = escape$1;
string$2.compareText = compareText$2;
var _is$1m = is, _number$I = number$3, _formatter = formatter;
function _typeof$f(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$f = function(n) {
    return typeof n;
  } : _typeof$f = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$f(t);
}
function endsWith(t, r) {
  var n = t.length - r.length, a = t.length;
  return t.substring(n, a) === r;
}
function format$3(t, r) {
  if (typeof t == "number")
    return (0, _number$I.format)(t, r);
  if ((0, _is$1m.isBigNumber)(t))
    return (0, _formatter.format)(t, r);
  if (looksLikeFraction(t))
    return !r || r.fraction !== "decimal" ? t.s * t.n + "/" + t.d : t.toString();
  if (Array.isArray(t))
    return formatArray(t, r);
  if ((0, _is$1m.isString)(t))
    return '"' + t + '"';
  if (typeof t == "function")
    return t.syntax ? String(t.syntax) : "function";
  if (t && _typeof$f(t) === "object") {
    if (typeof t.format == "function")
      return t.format(r);
    if (t && t.toString(r) !== {}.toString())
      return t.toString(r);
    var n = Object.keys(t).map(function(a) {
      return '"' + a + '": ' + format$3(t[a], r);
    });
    return "{" + n.join(", ") + "}";
  }
  return String(t);
}
function stringify$2(t) {
  for (var r = String(t), n = "", a = 0; a < r.length; ) {
    var s = r.charAt(a);
    s === "\\" ? (n += s, a++, s = r.charAt(a), (s === "" || '"\\/bfnrtu'.indexOf(s) === -1) && (n += "\\"), n += s) : s === '"' ? n += '\\"' : n += s, a++;
  }
  return '"' + n + '"';
}
function escape$1(t) {
  var r = String(t);
  return r = r.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), r;
}
function formatArray(t, r) {
  if (Array.isArray(t)) {
    for (var n = "[", a = t.length, s = 0; s < a; s++)
      s !== 0 && (n += ", "), n += formatArray(t[s], r);
    return n += "]", n;
  } else
    return format$3(t, r);
}
function looksLikeFraction(t) {
  return t && _typeof$f(t) === "object" && typeof t.s == "number" && typeof t.n == "number" && typeof t.d == "number" || !1;
}
function compareText$2(t, r) {
  if (!(0, _is$1m.isString)(t))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, _is$1m.typeOf)(t) + ", index: 0)");
  if (!(0, _is$1m.isString)(r))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, _is$1m.typeOf)(r) + ", index: 1)");
  return t === r ? 0 : t > r ? 1 : -1;
}
var DimensionError$1 = {};
Object.defineProperty(DimensionError$1, "__esModule", {
  value: !0
});
DimensionError$1.DimensionError = DimensionError;
function DimensionError(t, r, n) {
  if (!(this instanceof DimensionError))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = t, this.expected = r, this.relation = n, this.message = "Dimension mismatch (" + (Array.isArray(t) ? "[" + t.join(", ") + "]" : t) + " " + (this.relation || "!=") + " " + (Array.isArray(r) ? "[" + r.join(", ") + "]" : r) + ")", this.stack = new Error().stack;
}
DimensionError.prototype = new RangeError();
DimensionError.prototype.constructor = RangeError;
DimensionError.prototype.name = "DimensionError";
DimensionError.prototype.isDimensionError = !0;
var IndexError$1 = {};
Object.defineProperty(IndexError$1, "__esModule", {
  value: !0
});
IndexError$1.IndexError = IndexError;
function IndexError(t, r, n) {
  if (!(this instanceof IndexError))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.index = t, arguments.length < 3 ? (this.min = 0, this.max = r) : (this.min = r, this.max = n), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
IndexError.prototype = new RangeError();
IndexError.prototype.constructor = RangeError;
IndexError.prototype.name = "IndexError";
IndexError.prototype.isIndexError = !0;
Object.defineProperty(array, "__esModule", {
  value: !0
});
array.arraySize = arraySize;
array.validate = validate$1;
array.validateIndex = validateIndex;
array.resize = resize$2;
array.reshape = reshape$2;
array.squeeze = squeeze$2;
array.unsqueeze = unsqueeze;
array.flatten = flatten$3;
array.map = map$3;
array.forEach = forEach$2;
array.filter = filter$2;
array.filterRegExp = filterRegExp;
array.join = join;
array.identify = identify;
array.generalize = generalize;
array.getArrayDataType = getArrayDataType;
array.last = last;
array.initial = initial;
array.contains = contains;
var _number$H = number$3, _is$1l = is, _string$q = string$2, _DimensionError$h = DimensionError$1, _IndexError$5 = IndexError$1;
function arraySize(t) {
  for (var r = []; Array.isArray(t); )
    r.push(t.length), t = t[0];
  return r;
}
function _validate(t, r, n) {
  var a, s = t.length;
  if (s !== r[n])
    throw new _DimensionError$h.DimensionError(s, r[n]);
  if (n < r.length - 1) {
    var o = n + 1;
    for (a = 0; a < s; a++) {
      var c = t[a];
      if (!Array.isArray(c))
        throw new _DimensionError$h.DimensionError(r.length - 1, r.length, "<");
      _validate(t[a], r, o);
    }
  } else
    for (a = 0; a < s; a++)
      if (Array.isArray(t[a]))
        throw new _DimensionError$h.DimensionError(r.length + 1, r.length, ">");
}
function validate$1(t, r) {
  var n = r.length === 0;
  if (n) {
    if (Array.isArray(t))
      throw new _DimensionError$h.DimensionError(t.length, 0);
  } else
    _validate(t, r, 0);
}
function validateIndex(t, r) {
  if (!(0, _is$1l.isNumber)(t) || !(0, _number$H.isInteger)(t))
    throw new TypeError("Index must be an integer (value: " + t + ")");
  if (t < 0 || typeof r == "number" && t >= r)
    throw new _IndexError$5.IndexError(t, r);
}
function resize$2(t, r, n) {
  if (!Array.isArray(t) || !Array.isArray(r))
    throw new TypeError("Array expected");
  if (r.length === 0)
    throw new Error("Resizing to scalar is not supported");
  r.forEach(function(s) {
    if (!(0, _is$1l.isNumber)(s) || !(0, _number$H.isInteger)(s) || s < 0)
      throw new TypeError("Invalid size, must contain positive integers (size: " + (0, _string$q.format)(r) + ")");
  });
  var a = n !== void 0 ? n : 0;
  return _resize$1(t, r, 0, a), t;
}
function _resize$1(t, r, n, a) {
  var s, o, c = t.length, l = r[n], d = Math.min(c, l);
  if (t.length = l, n < r.length - 1) {
    var h = n + 1;
    for (s = 0; s < d; s++)
      o = t[s], Array.isArray(o) || (o = [o], t[s] = o), _resize$1(o, r, h, a);
    for (s = d; s < l; s++)
      o = [], t[s] = o, _resize$1(o, r, h, a);
  } else {
    for (s = 0; s < d; s++)
      for (; Array.isArray(t[s]); )
        t[s] = t[s][0];
    for (s = d; s < l; s++)
      t[s] = a;
  }
}
function reshape$2(t, r) {
  var n = flatten$3(t), a;
  function s(l) {
    return l.reduce(function(d, h) {
      return d * h;
    });
  }
  if (!Array.isArray(t) || !Array.isArray(r))
    throw new TypeError("Array expected");
  if (r.length === 0)
    throw new _DimensionError$h.DimensionError(0, s(arraySize(t)), "!=");
  for (var o = 1, c = 0; c < r.length; c++)
    o *= r[c];
  if (n.length !== o)
    throw new _DimensionError$h.DimensionError(s(r), s(arraySize(t)), "!=");
  try {
    a = _reshape$1(n, r);
  } catch (l) {
    throw l instanceof _DimensionError$h.DimensionError ? new _DimensionError$h.DimensionError(s(r), s(arraySize(t)), "!=") : l;
  }
  return a;
}
function _reshape$1(t, r) {
  for (var n = t, a, s = r.length - 1; s > 0; s--) {
    var o = r[s];
    a = [];
    for (var c = n.length / o, l = 0; l < c; l++)
      a.push(n.slice(l * o, (l + 1) * o));
    n = a;
  }
  return n;
}
function squeeze$2(t, r) {
  for (var n = r || arraySize(t); Array.isArray(t) && t.length === 1; )
    t = t[0], n.shift();
  for (var a = n.length; n[a - 1] === 1; )
    a--;
  return a < n.length && (t = _squeeze$1(t, a, 0), n.length = a), t;
}
function _squeeze$1(t, r, n) {
  var a, s;
  if (n < r) {
    var o = n + 1;
    for (a = 0, s = t.length; a < s; a++)
      t[a] = _squeeze$1(t[a], r, o);
  } else
    for (; Array.isArray(t); )
      t = t[0];
  return t;
}
function unsqueeze(t, r, n, a) {
  var s = a || arraySize(t);
  if (n)
    for (var o = 0; o < n; o++)
      t = [t], s.unshift(1);
  for (t = _unsqueeze(t, r, 0); s.length < r; )
    s.push(1);
  return t;
}
function _unsqueeze(t, r, n) {
  var a, s;
  if (Array.isArray(t)) {
    var o = n + 1;
    for (a = 0, s = t.length; a < s; a++)
      t[a] = _unsqueeze(t[a], r, o);
  } else
    for (var c = n; c < r; c++)
      t = [t];
  return t;
}
function flatten$3(t) {
  if (!Array.isArray(t))
    return t;
  var r = [];
  return t.forEach(function n(a) {
    Array.isArray(a) ? a.forEach(n) : r.push(a);
  }), r;
}
function map$3(t, r) {
  return Array.prototype.map.call(t, r);
}
function forEach$2(t, r) {
  Array.prototype.forEach.call(t, r);
}
function filter$2(t, r) {
  if (arraySize(t).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(t, r);
}
function filterRegExp(t, r) {
  if (arraySize(t).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(t, function(n) {
    return r.test(n);
  });
}
function join(t, r) {
  return Array.prototype.join.call(t, r);
}
function identify(t) {
  if (!Array.isArray(t))
    throw new TypeError("Array input expected");
  if (t.length === 0)
    return t;
  var r = [], n = 0;
  r[0] = {
    value: t[0],
    identifier: 0
  };
  for (var a = 1; a < t.length; a++)
    t[a] === t[a - 1] ? n++ : n = 0, r.push({
      value: t[a],
      identifier: n
    });
  return r;
}
function generalize(t) {
  if (!Array.isArray(t))
    throw new TypeError("Array input expected");
  if (t.length === 0)
    return t;
  for (var r = [], n = 0; n < t.length; n++)
    r.push(t[n].value);
  return r;
}
function getArrayDataType(t, r) {
  for (var n, a = 0, s = 0; s < t.length; s++) {
    var o = t[s], c = Array.isArray(o);
    if (s === 0 && c && (a = o.length), c && o.length !== a)
      return;
    var l = c ? getArrayDataType(o, r) : r(o);
    if (n === void 0)
      n = l;
    else if (n !== l)
      return "mixed";
  }
  return n;
}
function last(t) {
  return t[t.length - 1];
}
function initial(t) {
  return t.slice(0, t.length - 1);
}
function contains(t, r) {
  return t.indexOf(r) !== -1;
}
Object.defineProperty(factory$1, "__esModule", {
  value: !0
});
factory$1.factory = factory;
factory$1.sortFactories = sortFactories;
factory$1.create = create$2;
factory$1.isFactory = isFactory;
factory$1.assertDependencies = assertDependencies;
factory$1.isOptionalDependency = isOptionalDependency;
factory$1.stripOptionalNotation = stripOptionalNotation;
var _array$U = array, _object$B = object;
function factory(t, r, n, a) {
  function s(o) {
    var c = (0, _object$B.pickShallow)(o, r.map(stripOptionalNotation));
    return assertDependencies(t, r, o), n(c);
  }
  return s.isFactory = !0, s.fn = t, s.dependencies = r.slice().sort(), a && (s.meta = a), s;
}
function sortFactories(t) {
  var r = {};
  t.forEach(function(o) {
    r[o.fn] = o;
  });
  function n(o, c) {
    return !!(isFactory(o) && ((0, _array$U.contains)(o.dependencies, c.fn || c.name) || o.dependencies.some(function(l) {
      return n(r[l], c);
    })));
  }
  var a = [];
  function s(o) {
    for (var c = 0; c < a.length && !n(a[c], o); )
      c++;
    a.splice(c, 0, o);
  }
  return t.filter(isFactory).forEach(s), t.filter(function(o) {
    return !isFactory(o);
  }).forEach(s), a;
}
function create$2(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return sortFactories(t).forEach(function(n) {
    return n(r);
  }), r;
}
function isFactory(t) {
  return typeof t == "function" && typeof t.fn == "string" && Array.isArray(t.dependencies);
}
function assertDependencies(t, r, n) {
  var a = r.filter(function(o) {
    return !isOptionalDependency(o);
  }).every(function(o) {
    return n[o] !== void 0;
  });
  if (!a) {
    var s = r.filter(function(o) {
      return n[o] === void 0;
    });
    throw new Error('Cannot create function "'.concat(t, '", ') + "some dependencies are missing: ".concat(s.map(function(o) {
      return '"'.concat(o, '"');
    }).join(", "), "."));
  }
}
function isOptionalDependency(t) {
  return t && t[0] === "?";
}
function stripOptionalNotation(t) {
  return t && t[0] === "?" ? t.slice(1) : t;
}
Object.defineProperty(typed$1, "__esModule", {
  value: !0
});
typed$1.createTyped = void 0;
var _is$1k = is, _typedFunction = _interopRequireDefault$9(typedFunctionExports), _number$G = number$3, _factory$4s = factory$1;
function _interopRequireDefault$9(t) {
  return t && t.__esModule ? t : { default: t };
}
var _createTyped2 = function() {
  return _createTyped2 = _typedFunction.default.create, _typedFunction.default;
}, dependencies$4o = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], createTyped = /* @__PURE__ */ (0, _factory$4s.factory)("typed", dependencies$4o, function(r) {
  var n = r.BigNumber, a = r.Complex, s = r.DenseMatrix, o = r.Fraction, c = _createTyped2();
  return c.types = [
    {
      name: "number",
      test: _is$1k.isNumber
    },
    {
      name: "Complex",
      test: _is$1k.isComplex
    },
    {
      name: "BigNumber",
      test: _is$1k.isBigNumber
    },
    {
      name: "Fraction",
      test: _is$1k.isFraction
    },
    {
      name: "Unit",
      test: _is$1k.isUnit
    },
    {
      name: "string",
      test: _is$1k.isString
    },
    {
      name: "Chain",
      test: _is$1k.isChain
    },
    {
      name: "Array",
      test: _is$1k.isArray
    },
    {
      name: "Matrix",
      test: _is$1k.isMatrix
    },
    {
      name: "DenseMatrix",
      test: _is$1k.isDenseMatrix
    },
    {
      name: "SparseMatrix",
      test: _is$1k.isSparseMatrix
    },
    {
      name: "Range",
      test: _is$1k.isRange
    },
    {
      name: "Index",
      test: _is$1k.isIndex
    },
    {
      name: "boolean",
      test: _is$1k.isBoolean
    },
    {
      name: "ResultSet",
      test: _is$1k.isResultSet
    },
    {
      name: "Help",
      test: _is$1k.isHelp
    },
    {
      name: "function",
      test: _is$1k.isFunction
    },
    {
      name: "Date",
      test: _is$1k.isDate
    },
    {
      name: "RegExp",
      test: _is$1k.isRegExp
    },
    {
      name: "null",
      test: _is$1k.isNull
    },
    {
      name: "undefined",
      test: _is$1k.isUndefined
    },
    {
      name: "AccessorNode",
      test: _is$1k.isAccessorNode
    },
    {
      name: "ArrayNode",
      test: _is$1k.isArrayNode
    },
    {
      name: "AssignmentNode",
      test: _is$1k.isAssignmentNode
    },
    {
      name: "BlockNode",
      test: _is$1k.isBlockNode
    },
    {
      name: "ConditionalNode",
      test: _is$1k.isConditionalNode
    },
    {
      name: "ConstantNode",
      test: _is$1k.isConstantNode
    },
    {
      name: "FunctionNode",
      test: _is$1k.isFunctionNode
    },
    {
      name: "FunctionAssignmentNode",
      test: _is$1k.isFunctionAssignmentNode
    },
    {
      name: "IndexNode",
      test: _is$1k.isIndexNode
    },
    {
      name: "Node",
      test: _is$1k.isNode
    },
    {
      name: "ObjectNode",
      test: _is$1k.isObjectNode
    },
    {
      name: "OperatorNode",
      test: _is$1k.isOperatorNode
    },
    {
      name: "ParenthesisNode",
      test: _is$1k.isParenthesisNode
    },
    {
      name: "RangeNode",
      test: _is$1k.isRangeNode
    },
    {
      name: "SymbolNode",
      test: _is$1k.isSymbolNode
    },
    {
      name: "Object",
      test: _is$1k.isObject
    }
    // order 'Object' last, it matches on other classes too
  ], c.conversions = [{
    from: "number",
    to: "BigNumber",
    convert: function(d) {
      if (n || throwNoBignumber(d), (0, _number$G.digits)(d) > 15)
        throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + d + "). Use function bignumber(x) to convert to BigNumber.");
      return new n(d);
    }
  }, {
    from: "number",
    to: "Complex",
    convert: function(d) {
      return a || throwNoComplex(d), new a(d, 0);
    }
  }, {
    from: "number",
    to: "string",
    convert: function(d) {
      return d + "";
    }
  }, {
    from: "BigNumber",
    to: "Complex",
    convert: function(d) {
      return a || throwNoComplex(d), new a(d.toNumber(), 0);
    }
  }, {
    from: "Fraction",
    to: "BigNumber",
    convert: function(d) {
      throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
    }
  }, {
    from: "Fraction",
    to: "Complex",
    convert: function(d) {
      return a || throwNoComplex(d), new a(d.valueOf(), 0);
    }
  }, {
    from: "number",
    to: "Fraction",
    convert: function(d) {
      o || throwNoFraction(d);
      var h = new o(d);
      if (h.valueOf() !== d)
        throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + d + "). Use function fraction(x) to convert to Fraction.");
      return h;
    }
  }, {
    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
    //  from: 'Fraction',
    //  to: 'number',
    //  convert: function (x) {
    //    return x.valueOf()
    //  }
    // }, {
    from: "string",
    to: "number",
    convert: function(d) {
      var h = Number(d);
      if (isNaN(h))
        throw new Error('Cannot convert "' + d + '" to a number');
      return h;
    }
  }, {
    from: "string",
    to: "BigNumber",
    convert: function(d) {
      n || throwNoBignumber(d);
      try {
        return new n(d);
      } catch {
        throw new Error('Cannot convert "' + d + '" to BigNumber');
      }
    }
  }, {
    from: "string",
    to: "Fraction",
    convert: function(d) {
      o || throwNoFraction(d);
      try {
        return new o(d);
      } catch {
        throw new Error('Cannot convert "' + d + '" to Fraction');
      }
    }
  }, {
    from: "string",
    to: "Complex",
    convert: function(d) {
      a || throwNoComplex(d);
      try {
        return new a(d);
      } catch {
        throw new Error('Cannot convert "' + d + '" to Complex');
      }
    }
  }, {
    from: "boolean",
    to: "number",
    convert: function(d) {
      return +d;
    }
  }, {
    from: "boolean",
    to: "BigNumber",
    convert: function(d) {
      return n || throwNoBignumber(d), new n(+d);
    }
  }, {
    from: "boolean",
    to: "Fraction",
    convert: function(d) {
      return o || throwNoFraction(d), new o(+d);
    }
  }, {
    from: "boolean",
    to: "string",
    convert: function(d) {
      return String(d);
    }
  }, {
    from: "Array",
    to: "Matrix",
    convert: function(d) {
      return s || throwNoMatrix(), new s(d);
    }
  }, {
    from: "Matrix",
    to: "Array",
    convert: function(d) {
      return d.valueOf();
    }
  }], c;
});
typed$1.createTyped = createTyped;
function throwNoBignumber(t) {
  throw new Error("Cannot convert value ".concat(t, " into a BigNumber: no class 'BigNumber' provided"));
}
function throwNoComplex(t) {
  throw new Error("Cannot convert value ".concat(t, " into a Complex number: no class 'Complex' provided"));
}
function throwNoMatrix() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function throwNoFraction(t) {
  throw new Error("Cannot convert value ".concat(t, " into a Fraction, no class 'Fraction' provided."));
}
var ResultSet = {};
Object.defineProperty(ResultSet, "__esModule", {
  value: !0
});
ResultSet.createResultSet = void 0;
var _factory$4r = factory$1, name$4n = "ResultSet", dependencies$4n = [], createResultSet = /* @__PURE__ */ (0, _factory$4r.factory)(name$4n, dependencies$4n, function() {
  function t(r) {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
    this.entries = r || [];
  }
  return t.prototype.type = "ResultSet", t.prototype.isResultSet = !0, t.prototype.valueOf = function() {
    return this.entries;
  }, t.prototype.toString = function() {
    return "[" + this.entries.join(", ") + "]";
  }, t.prototype.toJSON = function() {
    return {
      mathjs: "ResultSet",
      entries: this.entries
    };
  }, t.fromJSON = function(r) {
    return new t(r.entries);
  }, t;
}, {
  isClass: !0
});
ResultSet.createResultSet = createResultSet;
var BigNumber = {}, decimal$1 = { exports: {} };
(function(t) {
  (function(r) {
    /*!
     *  decimal.js v10.4.3
     *  An arbitrary-precision Decimal type for JavaScript.
     *  https://github.com/MikeMcl/decimal.js
     *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
     *  MIT Licence
     */
    var n = 9e15, a = 1e9, s = "0123456789abcdef", o = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", c = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", l = {
      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed at run-time using the `Decimal.config` method.
      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,
      // 1 to MAX_DIGITS
      // The rounding mode used when rounding to `precision`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,
      // 0 to 8
      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP         0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN  6 The IEEE 754 remainder function.
      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
      //
      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
      // division (9) are commonly used for the modulus operation. The other rounding modes can also
      // be used, but they may not give useful results.
      modulo: 1,
      // 0 to 9
      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,
      // 0 to -EXP_LIMIT
      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos: 21,
      // 0 to EXP_LIMIT
      // The minimum exponent value, beneath which underflow to zero occurs.
      // JavaScript numbers: -324  (5e-324)
      minE: -n,
      // -1 to -EXP_LIMIT
      // The maximum exponent value, above which overflow to Infinity occurs.
      // JavaScript numbers: 308  (1.7976931348623157e+308)
      maxE: n,
      // 1 to EXP_LIMIT
      // Whether to use cryptographically-secure random number generation, if available.
      crypto: !1
      // true/false
    }, d, h, u, p, m = !0, g = "[DecimalError] ", v = g + "Invalid argument: ", y = g + "Precision limit exceeded", x = g + "crypto unavailable", _ = "[object Decimal]", $ = Math.floor, b = Math.pow, M = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, C = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, S = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, A = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, D = 1e7, N = 7, T = 9007199254740991, R = o.length - 1, F = c.length - 1, z = { toStringTag: _ };
    z.absoluteValue = z.abs = function() {
      var W = new this.constructor(this);
      return W.s < 0 && (W.s = 1), V(W);
    }, z.ceil = function() {
      return V(new this.constructor(this), this.e + 1, 2);
    }, z.clampedTo = z.clamp = function(W, Y) {
      var X, K = this, te = K.constructor;
      if (W = new te(W), Y = new te(Y), !W.s || !Y.s)
        return new te(NaN);
      if (W.gt(Y))
        throw Error(v + Y);
      return X = K.cmp(W), X < 0 ? W : K.cmp(Y) > 0 ? Y : new te(K);
    }, z.comparedTo = z.cmp = function(W) {
      var Y, X, K, te, ie = this, lr = ie.d, vr = (W = new ie.constructor(W)).d, Mr = ie.s, br = W.s;
      if (!lr || !vr)
        return !Mr || !br ? NaN : Mr !== br ? Mr : lr === vr ? 0 : !lr ^ Mr < 0 ? 1 : -1;
      if (!lr[0] || !vr[0])
        return lr[0] ? Mr : vr[0] ? -br : 0;
      if (Mr !== br)
        return Mr;
      if (ie.e !== W.e)
        return ie.e > W.e ^ Mr < 0 ? 1 : -1;
      for (K = lr.length, te = vr.length, Y = 0, X = K < te ? K : te; Y < X; ++Y)
        if (lr[Y] !== vr[Y])
          return lr[Y] > vr[Y] ^ Mr < 0 ? 1 : -1;
      return K === te ? 0 : K > te ^ Mr < 0 ? 1 : -1;
    }, z.cosine = z.cos = function() {
      var W, Y, X = this, K = X.constructor;
      return X.d ? X.d[0] ? (W = K.precision, Y = K.rounding, K.precision = W + Math.max(X.e, X.sd()) + N, K.rounding = 1, X = B(K, $r(K, X)), K.precision = W, K.rounding = Y, V(p == 2 || p == 3 ? X.neg() : X, W, Y, !0)) : new K(1) : new K(NaN);
    }, z.cubeRoot = z.cbrt = function() {
      var W, Y, X, K, te, ie, lr, vr, Mr, br, Dr = this, Or = Dr.constructor;
      if (!Dr.isFinite() || Dr.isZero())
        return new Or(Dr);
      for (m = !1, ie = Dr.s * b(Dr.s * Dr, 1 / 3), !ie || Math.abs(ie) == 1 / 0 ? (X = O(Dr.d), W = Dr.e, (ie = (W - X.length + 1) % 3) && (X += ie == 1 || ie == -2 ? "0" : "00"), ie = b(X, 1 / 3), W = $((W + 1) / 3) - (W % 3 == (W < 0 ? -1 : 2)), ie == 1 / 0 ? X = "5e" + W : (X = ie.toExponential(), X = X.slice(0, X.indexOf("e") + 1) + W), K = new Or(X), K.s = Dr.s) : K = new Or(ie.toString()), lr = (W = Or.precision) + 3; ; )
        if (vr = K, Mr = vr.times(vr).times(vr), br = Mr.plus(Dr), K = L(br.plus(Dr).times(vr), br.plus(Mr), lr + 2, 1), O(vr.d).slice(0, lr) === (X = O(K.d)).slice(0, lr))
          if (X = X.slice(lr - 3, lr + 1), X == "9999" || !te && X == "4999") {
            if (!te && (V(vr, W + 1, 0), vr.times(vr).times(vr).eq(Dr))) {
              K = vr;
              break;
            }
            lr += 4, te = 1;
          } else {
            (!+X || !+X.slice(1) && X.charAt(0) == "5") && (V(K, W + 1, 1), Y = !K.times(K).times(K).eq(Dr));
            break;
          }
      return m = !0, V(K, W, Or.rounding, Y);
    }, z.decimalPlaces = z.dp = function() {
      var W, Y = this.d, X = NaN;
      if (Y) {
        if (W = Y.length - 1, X = (W - $(this.e / N)) * N, W = Y[W], W)
          for (; W % 10 == 0; W /= 10)
            X--;
        X < 0 && (X = 0);
      }
      return X;
    }, z.dividedBy = z.div = function(W) {
      return L(this, new this.constructor(W));
    }, z.dividedToIntegerBy = z.divToInt = function(W) {
      var Y = this, X = Y.constructor;
      return V(L(Y, new X(W), 0, 1, 1), X.precision, X.rounding);
    }, z.equals = z.eq = function(W) {
      return this.cmp(W) === 0;
    }, z.floor = function() {
      return V(new this.constructor(this), this.e + 1, 3);
    }, z.greaterThan = z.gt = function(W) {
      return this.cmp(W) > 0;
    }, z.greaterThanOrEqualTo = z.gte = function(W) {
      var Y = this.cmp(W);
      return Y == 1 || Y === 0;
    }, z.hyperbolicCosine = z.cosh = function() {
      var W, Y, X, K, te, ie = this, lr = ie.constructor, vr = new lr(1);
      if (!ie.isFinite())
        return new lr(ie.s ? 1 / 0 : NaN);
      if (ie.isZero())
        return vr;
      X = lr.precision, K = lr.rounding, lr.precision = X + Math.max(ie.e, ie.sd()) + 4, lr.rounding = 1, te = ie.d.length, te < 32 ? (W = Math.ceil(te / 3), Y = (1 / hr(4, W)).toString()) : (W = 16, Y = "2.3283064365386962890625e-10"), ie = pe(lr, 1, ie.times(Y), new lr(1), !0);
      for (var Mr, br = W, Dr = new lr(8); br--; )
        Mr = ie.times(ie), ie = vr.minus(Mr.times(Dr.minus(Mr.times(Dr))));
      return V(ie, lr.precision = X, lr.rounding = K, !0);
    }, z.hyperbolicSine = z.sinh = function() {
      var W, Y, X, K, te = this, ie = te.constructor;
      if (!te.isFinite() || te.isZero())
        return new ie(te);
      if (Y = ie.precision, X = ie.rounding, ie.precision = Y + Math.max(te.e, te.sd()) + 4, ie.rounding = 1, K = te.d.length, K < 3)
        te = pe(ie, 2, te, te, !0);
      else {
        W = 1.4 * Math.sqrt(K), W = W > 16 ? 16 : W | 0, te = te.times(1 / hr(5, W)), te = pe(ie, 2, te, te, !0);
        for (var lr, vr = new ie(5), Mr = new ie(16), br = new ie(20); W--; )
          lr = te.times(te), te = te.times(vr.plus(lr.times(Mr.times(lr).plus(br))));
      }
      return ie.precision = Y, ie.rounding = X, V(te, Y, X, !0);
    }, z.hyperbolicTangent = z.tanh = function() {
      var W, Y, X = this, K = X.constructor;
      return X.isFinite() ? X.isZero() ? new K(X) : (W = K.precision, Y = K.rounding, K.precision = W + 7, K.rounding = 1, L(X.sinh(), X.cosh(), K.precision = W, K.rounding = Y)) : new K(X.s);
    }, z.inverseCosine = z.acos = function() {
      var W, Y = this, X = Y.constructor, K = Y.abs().cmp(1), te = X.precision, ie = X.rounding;
      return K !== -1 ? K === 0 ? Y.isNeg() ? Z(X, te, ie) : new X(0) : new X(NaN) : Y.isZero() ? Z(X, te + 4, ie).times(0.5) : (X.precision = te + 6, X.rounding = 1, Y = Y.asin(), W = Z(X, te + 4, ie).times(0.5), X.precision = te, X.rounding = ie, W.minus(Y));
    }, z.inverseHyperbolicCosine = z.acosh = function() {
      var W, Y, X = this, K = X.constructor;
      return X.lte(1) ? new K(X.eq(1) ? 0 : NaN) : X.isFinite() ? (W = K.precision, Y = K.rounding, K.precision = W + Math.max(Math.abs(X.e), X.sd()) + 4, K.rounding = 1, m = !1, X = X.times(X).minus(1).sqrt().plus(X), m = !0, K.precision = W, K.rounding = Y, X.ln()) : new K(X);
    }, z.inverseHyperbolicSine = z.asinh = function() {
      var W, Y, X = this, K = X.constructor;
      return !X.isFinite() || X.isZero() ? new K(X) : (W = K.precision, Y = K.rounding, K.precision = W + 2 * Math.max(Math.abs(X.e), X.sd()) + 6, K.rounding = 1, m = !1, X = X.times(X).plus(1).sqrt().plus(X), m = !0, K.precision = W, K.rounding = Y, X.ln());
    }, z.inverseHyperbolicTangent = z.atanh = function() {
      var W, Y, X, K, te = this, ie = te.constructor;
      return te.isFinite() ? te.e >= 0 ? new ie(te.abs().eq(1) ? te.s / 0 : te.isZero() ? te : NaN) : (W = ie.precision, Y = ie.rounding, K = te.sd(), Math.max(K, W) < 2 * -te.e - 1 ? V(new ie(te), W, Y, !0) : (ie.precision = X = K - te.e, te = L(te.plus(1), new ie(1).minus(te), X + W, 1), ie.precision = W + 4, ie.rounding = 1, te = te.ln(), ie.precision = W, ie.rounding = Y, te.times(0.5))) : new ie(NaN);
    }, z.inverseSine = z.asin = function() {
      var W, Y, X, K, te = this, ie = te.constructor;
      return te.isZero() ? new ie(te) : (Y = te.abs().cmp(1), X = ie.precision, K = ie.rounding, Y !== -1 ? Y === 0 ? (W = Z(ie, X + 4, K).times(0.5), W.s = te.s, W) : new ie(NaN) : (ie.precision = X + 6, ie.rounding = 1, te = te.div(new ie(1).minus(te.times(te)).sqrt().plus(1)).atan(), ie.precision = X, ie.rounding = K, te.times(2)));
    }, z.inverseTangent = z.atan = function() {
      var W, Y, X, K, te, ie, lr, vr, Mr, br = this, Dr = br.constructor, Or = Dr.precision, kr = Dr.rounding;
      if (br.isFinite()) {
        if (br.isZero())
          return new Dr(br);
        if (br.abs().eq(1) && Or + 4 <= F)
          return lr = Z(Dr, Or + 4, kr).times(0.25), lr.s = br.s, lr;
      } else {
        if (!br.s)
          return new Dr(NaN);
        if (Or + 4 <= F)
          return lr = Z(Dr, Or + 4, kr).times(0.5), lr.s = br.s, lr;
      }
      for (Dr.precision = vr = Or + 10, Dr.rounding = 1, X = Math.min(28, vr / N + 2 | 0), W = X; W; --W)
        br = br.div(br.times(br).plus(1).sqrt().plus(1));
      for (m = !1, Y = Math.ceil(vr / N), K = 1, Mr = br.times(br), lr = new Dr(br), te = br; W !== -1; )
        if (te = te.times(Mr), ie = lr.minus(te.div(K += 2)), te = te.times(Mr), lr = ie.plus(te.div(K += 2)), lr.d[Y] !== void 0)
          for (W = Y; lr.d[W] === ie.d[W] && W--; )
            ;
      return X && (lr = lr.times(2 << X - 1)), m = !0, V(lr, Dr.precision = Or, Dr.rounding = kr, !0);
    }, z.isFinite = function() {
      return !!this.d;
    }, z.isInteger = z.isInt = function() {
      return !!this.d && $(this.e / N) > this.d.length - 2;
    }, z.isNaN = function() {
      return !this.s;
    }, z.isNegative = z.isNeg = function() {
      return this.s < 0;
    }, z.isPositive = z.isPos = function() {
      return this.s > 0;
    }, z.isZero = function() {
      return !!this.d && this.d[0] === 0;
    }, z.lessThan = z.lt = function(W) {
      return this.cmp(W) < 0;
    }, z.lessThanOrEqualTo = z.lte = function(W) {
      return this.cmp(W) < 1;
    }, z.logarithm = z.log = function(W) {
      var Y, X, K, te, ie, lr, vr, Mr, br = this, Dr = br.constructor, Or = Dr.precision, kr = Dr.rounding, Gr = 5;
      if (W == null)
        W = new Dr(10), Y = !0;
      else {
        if (W = new Dr(W), X = W.d, W.s < 0 || !X || !X[0] || W.eq(1))
          return new Dr(NaN);
        Y = W.eq(10);
      }
      if (X = br.d, br.s < 0 || !X || !X[0] || br.eq(1))
        return new Dr(X && !X[0] ? -1 / 0 : br.s != 1 ? NaN : X ? 0 : 1 / 0);
      if (Y)
        if (X.length > 1)
          ie = !0;
        else {
          for (te = X[0]; te % 10 === 0; )
            te /= 10;
          ie = te !== 1;
        }
      if (m = !1, vr = Or + Gr, lr = ur(br, vr), K = Y ? q(Dr, vr + 10) : ur(W, vr), Mr = L(lr, K, vr, 1), I(Mr.d, te = Or, kr))
        do
          if (vr += 10, lr = ur(br, vr), K = Y ? q(Dr, vr + 10) : ur(W, vr), Mr = L(lr, K, vr, 1), !ie) {
            +O(Mr.d).slice(te + 1, te + 15) + 1 == 1e14 && (Mr = V(Mr, Or + 1, 0));
            break;
          }
        while (I(Mr.d, te += 10, kr));
      return m = !0, V(Mr, Or, kr);
    }, z.minus = z.sub = function(W) {
      var Y, X, K, te, ie, lr, vr, Mr, br, Dr, Or, kr, Gr = this, tn = Gr.constructor;
      if (W = new tn(W), !Gr.d || !W.d)
        return !Gr.s || !W.s ? W = new tn(NaN) : Gr.d ? W.s = -W.s : W = new tn(W.d || Gr.s !== W.s ? Gr : NaN), W;
      if (Gr.s != W.s)
        return W.s = -W.s, Gr.plus(W);
      if (br = Gr.d, kr = W.d, vr = tn.precision, Mr = tn.rounding, !br[0] || !kr[0]) {
        if (kr[0])
          W.s = -W.s;
        else if (br[0])
          W = new tn(Gr);
        else
          return new tn(Mr === 3 ? -0 : 0);
        return m ? V(W, vr, Mr) : W;
      }
      if (X = $(W.e / N), Dr = $(Gr.e / N), br = br.slice(), ie = Dr - X, ie) {
        for (Or = ie < 0, Or ? (Y = br, ie = -ie, lr = kr.length) : (Y = kr, X = Dr, lr = br.length), K = Math.max(Math.ceil(vr / N), lr) + 2, ie > K && (ie = K, Y.length = 1), Y.reverse(), K = ie; K--; )
          Y.push(0);
        Y.reverse();
      } else {
        for (K = br.length, lr = kr.length, Or = K < lr, Or && (lr = K), K = 0; K < lr; K++)
          if (br[K] != kr[K]) {
            Or = br[K] < kr[K];
            break;
          }
        ie = 0;
      }
      for (Or && (Y = br, br = kr, kr = Y, W.s = -W.s), lr = br.length, K = kr.length - lr; K > 0; --K)
        br[lr++] = 0;
      for (K = kr.length; K > ie; ) {
        if (br[--K] < kr[K]) {
          for (te = K; te && br[--te] === 0; )
            br[te] = D - 1;
          --br[te], br[K] += D;
        }
        br[K] -= kr[K];
      }
      for (; br[--lr] === 0; )
        br.pop();
      for (; br[0] === 0; br.shift())
        --X;
      return br[0] ? (W.d = br, W.e = J(br, X), m ? V(W, vr, Mr) : W) : new tn(Mr === 3 ? -0 : 0);
    }, z.modulo = z.mod = function(W) {
      var Y, X = this, K = X.constructor;
      return W = new K(W), !X.d || !W.s || W.d && !W.d[0] ? new K(NaN) : !W.d || X.d && !X.d[0] ? V(new K(X), K.precision, K.rounding) : (m = !1, K.modulo == 9 ? (Y = L(X, W.abs(), 0, 3, 1), Y.s *= W.s) : Y = L(X, W, 0, K.modulo, 1), Y = Y.times(W), m = !0, X.minus(Y));
    }, z.naturalExponential = z.exp = function() {
      return oe(this);
    }, z.naturalLogarithm = z.ln = function() {
      return ur(this);
    }, z.negated = z.neg = function() {
      var W = new this.constructor(this);
      return W.s = -W.s, V(W);
    }, z.plus = z.add = function(W) {
      var Y, X, K, te, ie, lr, vr, Mr, br, Dr, Or = this, kr = Or.constructor;
      if (W = new kr(W), !Or.d || !W.d)
        return !Or.s || !W.s ? W = new kr(NaN) : Or.d || (W = new kr(W.d || Or.s === W.s ? Or : NaN)), W;
      if (Or.s != W.s)
        return W.s = -W.s, Or.minus(W);
      if (br = Or.d, Dr = W.d, vr = kr.precision, Mr = kr.rounding, !br[0] || !Dr[0])
        return Dr[0] || (W = new kr(Or)), m ? V(W, vr, Mr) : W;
      if (ie = $(Or.e / N), K = $(W.e / N), br = br.slice(), te = ie - K, te) {
        for (te < 0 ? (X = br, te = -te, lr = Dr.length) : (X = Dr, K = ie, lr = br.length), ie = Math.ceil(vr / N), lr = ie > lr ? ie + 1 : lr + 1, te > lr && (te = lr, X.length = 1), X.reverse(); te--; )
          X.push(0);
        X.reverse();
      }
      for (lr = br.length, te = Dr.length, lr - te < 0 && (te = lr, X = Dr, Dr = br, br = X), Y = 0; te; )
        Y = (br[--te] = br[te] + Dr[te] + Y) / D | 0, br[te] %= D;
      for (Y && (br.unshift(Y), ++K), lr = br.length; br[--lr] == 0; )
        br.pop();
      return W.d = br, W.e = J(br, K), m ? V(W, vr, Mr) : W;
    }, z.precision = z.sd = function(W) {
      var Y, X = this;
      if (W !== void 0 && W !== !!W && W !== 1 && W !== 0)
        throw Error(v + W);
      return X.d ? (Y = ae(X.d), W && X.e + 1 > Y && (Y = X.e + 1)) : Y = NaN, Y;
    }, z.round = function() {
      var W = this, Y = W.constructor;
      return V(new Y(W), W.e + 1, Y.rounding);
    }, z.sine = z.sin = function() {
      var W, Y, X = this, K = X.constructor;
      return X.isFinite() ? X.isZero() ? new K(X) : (W = K.precision, Y = K.rounding, K.precision = W + Math.max(X.e, X.sd()) + N, K.rounding = 1, X = ne(K, $r(K, X)), K.precision = W, K.rounding = Y, V(p > 2 ? X.neg() : X, W, Y, !0)) : new K(NaN);
    }, z.squareRoot = z.sqrt = function() {
      var W, Y, X, K, te, ie, lr = this, vr = lr.d, Mr = lr.e, br = lr.s, Dr = lr.constructor;
      if (br !== 1 || !vr || !vr[0])
        return new Dr(!br || br < 0 && (!vr || vr[0]) ? NaN : vr ? lr : 1 / 0);
      for (m = !1, br = Math.sqrt(+lr), br == 0 || br == 1 / 0 ? (Y = O(vr), (Y.length + Mr) % 2 == 0 && (Y += "0"), br = Math.sqrt(Y), Mr = $((Mr + 1) / 2) - (Mr < 0 || Mr % 2), br == 1 / 0 ? Y = "5e" + Mr : (Y = br.toExponential(), Y = Y.slice(0, Y.indexOf("e") + 1) + Mr), K = new Dr(Y)) : K = new Dr(br.toString()), X = (Mr = Dr.precision) + 3; ; )
        if (ie = K, K = ie.plus(L(lr, ie, X + 2, 1)).times(0.5), O(ie.d).slice(0, X) === (Y = O(K.d)).slice(0, X))
          if (Y = Y.slice(X - 3, X + 1), Y == "9999" || !te && Y == "4999") {
            if (!te && (V(ie, Mr + 1, 0), ie.times(ie).eq(lr))) {
              K = ie;
              break;
            }
            X += 4, te = 1;
          } else {
            (!+Y || !+Y.slice(1) && Y.charAt(0) == "5") && (V(K, Mr + 1, 1), W = !K.times(K).eq(lr));
            break;
          }
      return m = !0, V(K, Mr, Dr.rounding, W);
    }, z.tangent = z.tan = function() {
      var W, Y, X = this, K = X.constructor;
      return X.isFinite() ? X.isZero() ? new K(X) : (W = K.precision, Y = K.rounding, K.precision = W + 10, K.rounding = 1, X = X.sin(), X.s = 1, X = L(X, new K(1).minus(X.times(X)).sqrt(), W + 10, 0), K.precision = W, K.rounding = Y, V(p == 2 || p == 4 ? X.neg() : X, W, Y, !0)) : new K(NaN);
    }, z.times = z.mul = function(W) {
      var Y, X, K, te, ie, lr, vr, Mr, br, Dr = this, Or = Dr.constructor, kr = Dr.d, Gr = (W = new Or(W)).d;
      if (W.s *= Dr.s, !kr || !kr[0] || !Gr || !Gr[0])
        return new Or(!W.s || kr && !kr[0] && !Gr || Gr && !Gr[0] && !kr ? NaN : !kr || !Gr ? W.s / 0 : W.s * 0);
      for (X = $(Dr.e / N) + $(W.e / N), Mr = kr.length, br = Gr.length, Mr < br && (ie = kr, kr = Gr, Gr = ie, lr = Mr, Mr = br, br = lr), ie = [], lr = Mr + br, K = lr; K--; )
        ie.push(0);
      for (K = br; --K >= 0; ) {
        for (Y = 0, te = Mr + K; te > K; )
          vr = ie[te] + Gr[K] * kr[te - K - 1] + Y, ie[te--] = vr % D | 0, Y = vr / D | 0;
        ie[te] = (ie[te] + Y) % D | 0;
      }
      for (; !ie[--lr]; )
        ie.pop();
      return Y ? ++X : ie.shift(), W.d = ie, W.e = J(ie, X), m ? V(W, Or.precision, Or.rounding) : W;
    }, z.toBinary = function(W, Y) {
      return Sr(this, 2, W, Y);
    }, z.toDecimalPlaces = z.toDP = function(W, Y) {
      var X = this, K = X.constructor;
      return X = new K(X), W === void 0 ? X : (G(W, 0, a), Y === void 0 ? Y = K.rounding : G(Y, 0, 8), V(X, W + X.e + 1, Y));
    }, z.toExponential = function(W, Y) {
      var X, K = this, te = K.constructor;
      return W === void 0 ? X = U(K, !0) : (G(W, 0, a), Y === void 0 ? Y = te.rounding : G(Y, 0, 8), K = V(new te(K), W + 1, Y), X = U(K, !0, W + 1)), K.isNeg() && !K.isZero() ? "-" + X : X;
    }, z.toFixed = function(W, Y) {
      var X, K, te = this, ie = te.constructor;
      return W === void 0 ? X = U(te) : (G(W, 0, a), Y === void 0 ? Y = ie.rounding : G(Y, 0, 8), K = V(new ie(te), W + te.e + 1, Y), X = U(K, !1, W + K.e + 1)), te.isNeg() && !te.isZero() ? "-" + X : X;
    }, z.toFraction = function(W) {
      var Y, X, K, te, ie, lr, vr, Mr, br, Dr, Or, kr, Gr = this, tn = Gr.d, Wr = Gr.constructor;
      if (!tn)
        return new Wr(Gr);
      if (br = X = new Wr(1), K = Mr = new Wr(0), Y = new Wr(K), ie = Y.e = ae(tn) - Gr.e - 1, lr = ie % N, Y.d[0] = b(10, lr < 0 ? N + lr : lr), W == null)
        W = ie > 0 ? Y : br;
      else {
        if (vr = new Wr(W), !vr.isInt() || vr.lt(br))
          throw Error(v + vr);
        W = vr.gt(Y) ? ie > 0 ? Y : br : vr;
      }
      for (m = !1, vr = new Wr(O(tn)), Dr = Wr.precision, Wr.precision = ie = tn.length * N * 2; Or = L(vr, Y, 0, 1, 1), te = X.plus(Or.times(K)), te.cmp(W) != 1; )
        X = K, K = te, te = br, br = Mr.plus(Or.times(te)), Mr = te, te = Y, Y = vr.minus(Or.times(te)), vr = te;
      return te = L(W.minus(X), K, 0, 1, 1), Mr = Mr.plus(te.times(br)), X = X.plus(te.times(K)), Mr.s = br.s = Gr.s, kr = L(br, K, ie, 1).minus(Gr).abs().cmp(L(Mr, X, ie, 1).minus(Gr).abs()) < 1 ? [br, K] : [Mr, X], Wr.precision = Dr, m = !0, kr;
    }, z.toHexadecimal = z.toHex = function(W, Y) {
      return Sr(this, 16, W, Y);
    }, z.toNearest = function(W, Y) {
      var X = this, K = X.constructor;
      if (X = new K(X), W == null) {
        if (!X.d)
          return X;
        W = new K(1), Y = K.rounding;
      } else {
        if (W = new K(W), Y === void 0 ? Y = K.rounding : G(Y, 0, 8), !X.d)
          return W.s ? X : W;
        if (!W.d)
          return W.s && (W.s = X.s), W;
      }
      return W.d[0] ? (m = !1, X = L(X, W, 0, Y, 1).times(W), m = !0, V(X)) : (W.s = X.s, X = W), X;
    }, z.toNumber = function() {
      return +this;
    }, z.toOctal = function(W, Y) {
      return Sr(this, 8, W, Y);
    }, z.toPower = z.pow = function(W) {
      var Y, X, K, te, ie, lr, vr = this, Mr = vr.constructor, br = +(W = new Mr(W));
      if (!vr.d || !W.d || !vr.d[0] || !W.d[0])
        return new Mr(b(+vr, br));
      if (vr = new Mr(vr), vr.eq(1))
        return vr;
      if (K = Mr.precision, ie = Mr.rounding, W.eq(1))
        return V(vr, K, ie);
      if (Y = $(W.e / N), Y >= W.d.length - 1 && (X = br < 0 ? -br : br) <= T)
        return te = se(Mr, vr, X, K), W.s < 0 ? new Mr(1).div(te) : V(te, K, ie);
      if (lr = vr.s, lr < 0) {
        if (Y < W.d.length - 1)
          return new Mr(NaN);
        if (W.d[Y] & 1 || (lr = 1), vr.e == 0 && vr.d[0] == 1 && vr.d.length == 1)
          return vr.s = lr, vr;
      }
      return X = b(+vr, br), Y = X == 0 || !isFinite(X) ? $(br * (Math.log("0." + O(vr.d)) / Math.LN10 + vr.e + 1)) : new Mr(X + "").e, Y > Mr.maxE + 1 || Y < Mr.minE - 1 ? new Mr(Y > 0 ? lr / 0 : 0) : (m = !1, Mr.rounding = vr.s = 1, X = Math.min(12, (Y + "").length), te = oe(W.times(ur(vr, K + X)), K), te.d && (te = V(te, K + 5, 1), I(te.d, K, ie) && (Y = K + 10, te = V(oe(W.times(ur(vr, Y + X)), Y), Y + 5, 1), +O(te.d).slice(K + 1, K + 15) + 1 == 1e14 && (te = V(te, K + 1, 0)))), te.s = lr, m = !0, Mr.rounding = ie, V(te, K, ie));
    }, z.toPrecision = function(W, Y) {
      var X, K = this, te = K.constructor;
      return W === void 0 ? X = U(K, K.e <= te.toExpNeg || K.e >= te.toExpPos) : (G(W, 1, a), Y === void 0 ? Y = te.rounding : G(Y, 0, 8), K = V(new te(K), W, Y), X = U(K, W <= K.e || K.e <= te.toExpNeg, W)), K.isNeg() && !K.isZero() ? "-" + X : X;
    }, z.toSignificantDigits = z.toSD = function(W, Y) {
      var X = this, K = X.constructor;
      return W === void 0 ? (W = K.precision, Y = K.rounding) : (G(W, 1, a), Y === void 0 ? Y = K.rounding : G(Y, 0, 8)), V(new K(X), W, Y);
    }, z.toString = function() {
      var W = this, Y = W.constructor, X = U(W, W.e <= Y.toExpNeg || W.e >= Y.toExpPos);
      return W.isNeg() && !W.isZero() ? "-" + X : X;
    }, z.truncated = z.trunc = function() {
      return V(new this.constructor(this), this.e + 1, 1);
    }, z.valueOf = z.toJSON = function() {
      var W = this, Y = W.constructor, X = U(W, W.e <= Y.toExpNeg || W.e >= Y.toExpPos);
      return W.isNeg() ? "-" + X : X;
    };
    function O(W) {
      var Y, X, K, te = W.length - 1, ie = "", lr = W[0];
      if (te > 0) {
        for (ie += lr, Y = 1; Y < te; Y++)
          K = W[Y] + "", X = N - K.length, X && (ie += ee(X)), ie += K;
        lr = W[Y], K = lr + "", X = N - K.length, X && (ie += ee(X));
      } else if (lr === 0)
        return "0";
      for (; lr % 10 === 0; )
        lr /= 10;
      return ie + lr;
    }
    function G(W, Y, X) {
      if (W !== ~~W || W < Y || W > X)
        throw Error(v + W);
    }
    function I(W, Y, X, K) {
      var te, ie, lr, vr;
      for (ie = W[0]; ie >= 10; ie /= 10)
        --Y;
      return --Y < 0 ? (Y += N, te = 0) : (te = Math.ceil((Y + 1) / N), Y %= N), ie = b(10, N - Y), vr = W[te] % ie | 0, K == null ? Y < 3 ? (Y == 0 ? vr = vr / 100 | 0 : Y == 1 && (vr = vr / 10 | 0), lr = X < 4 && vr == 99999 || X > 3 && vr == 49999 || vr == 5e4 || vr == 0) : lr = (X < 4 && vr + 1 == ie || X > 3 && vr + 1 == ie / 2) && (W[te + 1] / ie / 100 | 0) == b(10, Y - 2) - 1 || (vr == ie / 2 || vr == 0) && (W[te + 1] / ie / 100 | 0) == 0 : Y < 4 ? (Y == 0 ? vr = vr / 1e3 | 0 : Y == 1 ? vr = vr / 100 | 0 : Y == 2 && (vr = vr / 10 | 0), lr = (K || X < 4) && vr == 9999 || !K && X > 3 && vr == 4999) : lr = ((K || X < 4) && vr + 1 == ie || !K && X > 3 && vr + 1 == ie / 2) && (W[te + 1] / ie / 1e3 | 0) == b(10, Y - 3) - 1, lr;
    }
    function k(W, Y, X) {
      for (var K, te = [0], ie, lr = 0, vr = W.length; lr < vr; ) {
        for (ie = te.length; ie--; )
          te[ie] *= Y;
        for (te[0] += s.indexOf(W.charAt(lr++)), K = 0; K < te.length; K++)
          te[K] > X - 1 && (te[K + 1] === void 0 && (te[K + 1] = 0), te[K + 1] += te[K] / X | 0, te[K] %= X);
      }
      return te.reverse();
    }
    function B(W, Y) {
      var X, K, te;
      if (Y.isZero())
        return Y;
      K = Y.d.length, K < 32 ? (X = Math.ceil(K / 3), te = (1 / hr(4, X)).toString()) : (X = 16, te = "2.3283064365386962890625e-10"), W.precision += X, Y = pe(W, 1, Y.times(te), new W(1));
      for (var ie = X; ie--; ) {
        var lr = Y.times(Y);
        Y = lr.times(lr).minus(lr).times(8).plus(1);
      }
      return W.precision -= X, Y;
    }
    var L = function() {
      function W(K, te, ie) {
        var lr, vr = 0, Mr = K.length;
        for (K = K.slice(); Mr--; )
          lr = K[Mr] * te + vr, K[Mr] = lr % ie | 0, vr = lr / ie | 0;
        return vr && K.unshift(vr), K;
      }
      function Y(K, te, ie, lr) {
        var vr, Mr;
        if (ie != lr)
          Mr = ie > lr ? 1 : -1;
        else
          for (vr = Mr = 0; vr < ie; vr++)
            if (K[vr] != te[vr]) {
              Mr = K[vr] > te[vr] ? 1 : -1;
              break;
            }
        return Mr;
      }
      function X(K, te, ie, lr) {
        for (var vr = 0; ie--; )
          K[ie] -= vr, vr = K[ie] < te[ie] ? 1 : 0, K[ie] = vr * lr + K[ie] - te[ie];
        for (; !K[0] && K.length > 1; )
          K.shift();
      }
      return function(K, te, ie, lr, vr, Mr) {
        var br, Dr, Or, kr, Gr, tn, Wr, yn, sn, cn, Kr, dn, On, xn, Gn, In, Dn, kn, fn, wn, Ln = K.constructor, jn = K.s == te.s ? 1 : -1, mn = K.d, an = te.d;
        if (!mn || !mn[0] || !an || !an[0])
          return new Ln(
            // Return NaN if either NaN, or both Infinity or 0.
            !K.s || !te.s || (mn ? an && mn[0] == an[0] : !an) ? NaN : (
              // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
              mn && mn[0] == 0 || !an ? jn * 0 : jn / 0
            )
          );
        for (Mr ? (Gr = 1, Dr = K.e - te.e) : (Mr = D, Gr = N, Dr = $(K.e / Gr) - $(te.e / Gr)), fn = an.length, Dn = mn.length, sn = new Ln(jn), cn = sn.d = [], Or = 0; an[Or] == (mn[Or] || 0); Or++)
          ;
        if (an[Or] > (mn[Or] || 0) && Dr--, ie == null ? (xn = ie = Ln.precision, lr = Ln.rounding) : vr ? xn = ie + (K.e - te.e) + 1 : xn = ie, xn < 0)
          cn.push(1), tn = !0;
        else {
          if (xn = xn / Gr + 2 | 0, Or = 0, fn == 1) {
            for (kr = 0, an = an[0], xn++; (Or < Dn || kr) && xn--; Or++)
              Gn = kr * Mr + (mn[Or] || 0), cn[Or] = Gn / an | 0, kr = Gn % an | 0;
            tn = kr || Or < Dn;
          } else {
            for (kr = Mr / (an[0] + 1) | 0, kr > 1 && (an = W(an, kr, Mr), mn = W(mn, kr, Mr), fn = an.length, Dn = mn.length), In = fn, Kr = mn.slice(0, fn), dn = Kr.length; dn < fn; )
              Kr[dn++] = 0;
            wn = an.slice(), wn.unshift(0), kn = an[0], an[1] >= Mr / 2 && ++kn;
            do
              kr = 0, br = Y(an, Kr, fn, dn), br < 0 ? (On = Kr[0], fn != dn && (On = On * Mr + (Kr[1] || 0)), kr = On / kn | 0, kr > 1 ? (kr >= Mr && (kr = Mr - 1), Wr = W(an, kr, Mr), yn = Wr.length, dn = Kr.length, br = Y(Wr, Kr, yn, dn), br == 1 && (kr--, X(Wr, fn < yn ? wn : an, yn, Mr))) : (kr == 0 && (br = kr = 1), Wr = an.slice()), yn = Wr.length, yn < dn && Wr.unshift(0), X(Kr, Wr, dn, Mr), br == -1 && (dn = Kr.length, br = Y(an, Kr, fn, dn), br < 1 && (kr++, X(Kr, fn < dn ? wn : an, dn, Mr))), dn = Kr.length) : br === 0 && (kr++, Kr = [0]), cn[Or++] = kr, br && Kr[0] ? Kr[dn++] = mn[In] || 0 : (Kr = [mn[In]], dn = 1);
            while ((In++ < Dn || Kr[0] !== void 0) && xn--);
            tn = Kr[0] !== void 0;
          }
          cn[0] || cn.shift();
        }
        if (Gr == 1)
          sn.e = Dr, h = tn;
        else {
          for (Or = 1, kr = cn[0]; kr >= 10; kr /= 10)
            Or++;
          sn.e = Or + Dr * Gr - 1, V(sn, vr ? ie + sn.e + 1 : ie, lr, tn);
        }
        return sn;
      };
    }();
    function V(W, Y, X, K) {
      var te, ie, lr, vr, Mr, br, Dr, Or, kr, Gr = W.constructor;
      e:
        if (Y != null) {
          if (Or = W.d, !Or)
            return W;
          for (te = 1, vr = Or[0]; vr >= 10; vr /= 10)
            te++;
          if (ie = Y - te, ie < 0)
            ie += N, lr = Y, Dr = Or[kr = 0], Mr = Dr / b(10, te - lr - 1) % 10 | 0;
          else if (kr = Math.ceil((ie + 1) / N), vr = Or.length, kr >= vr)
            if (K) {
              for (; vr++ <= kr; )
                Or.push(0);
              Dr = Mr = 0, te = 1, ie %= N, lr = ie - N + 1;
            } else
              break e;
          else {
            for (Dr = vr = Or[kr], te = 1; vr >= 10; vr /= 10)
              te++;
            ie %= N, lr = ie - N + te, Mr = lr < 0 ? 0 : Dr / b(10, te - lr - 1) % 10 | 0;
          }
          if (K = K || Y < 0 || Or[kr + 1] !== void 0 || (lr < 0 ? Dr : Dr % b(10, te - lr - 1)), br = X < 4 ? (Mr || K) && (X == 0 || X == (W.s < 0 ? 3 : 2)) : Mr > 5 || Mr == 5 && (X == 4 || K || X == 6 && // Check whether the digit to the left of the rounding digit is odd.
          (ie > 0 ? lr > 0 ? Dr / b(10, te - lr) : 0 : Or[kr - 1]) % 10 & 1 || X == (W.s < 0 ? 8 : 7)), Y < 1 || !Or[0])
            return Or.length = 0, br ? (Y -= W.e + 1, Or[0] = b(10, (N - Y % N) % N), W.e = -Y || 0) : Or[0] = W.e = 0, W;
          if (ie == 0 ? (Or.length = kr, vr = 1, kr--) : (Or.length = kr + 1, vr = b(10, N - ie), Or[kr] = lr > 0 ? (Dr / b(10, te - lr) % b(10, lr) | 0) * vr : 0), br)
            for (; ; )
              if (kr == 0) {
                for (ie = 1, lr = Or[0]; lr >= 10; lr /= 10)
                  ie++;
                for (lr = Or[0] += vr, vr = 1; lr >= 10; lr /= 10)
                  vr++;
                ie != vr && (W.e++, Or[0] == D && (Or[0] = 1));
                break;
              } else {
                if (Or[kr] += vr, Or[kr] != D)
                  break;
                Or[kr--] = 0, vr = 1;
              }
          for (ie = Or.length; Or[--ie] === 0; )
            Or.pop();
        }
      return m && (W.e > Gr.maxE ? (W.d = null, W.e = NaN) : W.e < Gr.minE && (W.e = 0, W.d = [0])), W;
    }
    function U(W, Y, X) {
      if (!W.isFinite())
        return ir(W);
      var K, te = W.e, ie = O(W.d), lr = ie.length;
      return Y ? (X && (K = X - lr) > 0 ? ie = ie.charAt(0) + "." + ie.slice(1) + ee(K) : lr > 1 && (ie = ie.charAt(0) + "." + ie.slice(1)), ie = ie + (W.e < 0 ? "e" : "e+") + W.e) : te < 0 ? (ie = "0." + ee(-te - 1) + ie, X && (K = X - lr) > 0 && (ie += ee(K))) : te >= lr ? (ie += ee(te + 1 - lr), X && (K = X - te - 1) > 0 && (ie = ie + "." + ee(K))) : ((K = te + 1) < lr && (ie = ie.slice(0, K) + "." + ie.slice(K)), X && (K = X - lr) > 0 && (te + 1 === lr && (ie += "."), ie += ee(K))), ie;
    }
    function J(W, Y) {
      var X = W[0];
      for (Y *= N; X >= 10; X /= 10)
        Y++;
      return Y;
    }
    function q(W, Y, X) {
      if (Y > R)
        throw m = !0, X && (W.precision = X), Error(y);
      return V(new W(o), Y, 1, !0);
    }
    function Z(W, Y, X) {
      if (Y > F)
        throw Error(y);
      return V(new W(c), Y, X, !0);
    }
    function ae(W) {
      var Y = W.length - 1, X = Y * N + 1;
      if (Y = W[Y], Y) {
        for (; Y % 10 == 0; Y /= 10)
          X--;
        for (Y = W[0]; Y >= 10; Y /= 10)
          X++;
      }
      return X;
    }
    function ee(W) {
      for (var Y = ""; W--; )
        Y += "0";
      return Y;
    }
    function se(W, Y, X, K) {
      var te, ie = new W(1), lr = Math.ceil(K / N + 4);
      for (m = !1; ; ) {
        if (X % 2 && (ie = ie.times(Y), ze(ie.d, lr) && (te = !0)), X = $(X / 2), X === 0) {
          X = ie.d.length - 1, te && ie.d[X] === 0 && ++ie.d[X];
          break;
        }
        Y = Y.times(Y), ze(Y.d, lr);
      }
      return m = !0, ie;
    }
    function nr(W) {
      return W.d[W.d.length - 1] & 1;
    }
    function ce(W, Y, X) {
      for (var K, te = new W(Y[0]), ie = 0; ++ie < Y.length; )
        if (K = new W(Y[ie]), K.s)
          te[X](K) && (te = K);
        else {
          te = K;
          break;
        }
      return te;
    }
    function oe(W, Y) {
      var X, K, te, ie, lr, vr, Mr, br = 0, Dr = 0, Or = 0, kr = W.constructor, Gr = kr.rounding, tn = kr.precision;
      if (!W.d || !W.d[0] || W.e > 17)
        return new kr(W.d ? W.d[0] ? W.s < 0 ? 0 : 1 / 0 : 1 : W.s ? W.s < 0 ? 0 : W : 0 / 0);
      for (Y == null ? (m = !1, Mr = tn) : Mr = Y, vr = new kr(0.03125); W.e > -2; )
        W = W.times(vr), Or += 5;
      for (K = Math.log(b(2, Or)) / Math.LN10 * 2 + 5 | 0, Mr += K, X = ie = lr = new kr(1), kr.precision = Mr; ; ) {
        if (ie = V(ie.times(W), Mr, 1), X = X.times(++Dr), vr = lr.plus(L(ie, X, Mr, 1)), O(vr.d).slice(0, Mr) === O(lr.d).slice(0, Mr)) {
          for (te = Or; te--; )
            lr = V(lr.times(lr), Mr, 1);
          if (Y == null)
            if (br < 3 && I(lr.d, Mr - K, Gr, br))
              kr.precision = Mr += 10, X = ie = vr = new kr(1), Dr = 0, br++;
            else
              return V(lr, kr.precision = tn, Gr, m = !0);
          else
            return kr.precision = tn, lr;
        }
        lr = vr;
      }
    }
    function ur(W, Y) {
      var X, K, te, ie, lr, vr, Mr, br, Dr, Or, kr, Gr = 1, tn = 10, Wr = W, yn = Wr.d, sn = Wr.constructor, cn = sn.rounding, Kr = sn.precision;
      if (Wr.s < 0 || !yn || !yn[0] || !Wr.e && yn[0] == 1 && yn.length == 1)
        return new sn(yn && !yn[0] ? -1 / 0 : Wr.s != 1 ? NaN : yn ? 0 : Wr);
      if (Y == null ? (m = !1, Dr = Kr) : Dr = Y, sn.precision = Dr += tn, X = O(yn), K = X.charAt(0), Math.abs(ie = Wr.e) < 15e14) {
        for (; K < 7 && K != 1 || K == 1 && X.charAt(1) > 3; )
          Wr = Wr.times(W), X = O(Wr.d), K = X.charAt(0), Gr++;
        ie = Wr.e, K > 1 ? (Wr = new sn("0." + X), ie++) : Wr = new sn(K + "." + X.slice(1));
      } else
        return br = q(sn, Dr + 2, Kr).times(ie + ""), Wr = ur(new sn(K + "." + X.slice(1)), Dr - tn).plus(br), sn.precision = Kr, Y == null ? V(Wr, Kr, cn, m = !0) : Wr;
      for (Or = Wr, Mr = lr = Wr = L(Wr.minus(1), Wr.plus(1), Dr, 1), kr = V(Wr.times(Wr), Dr, 1), te = 3; ; ) {
        if (lr = V(lr.times(kr), Dr, 1), br = Mr.plus(L(lr, new sn(te), Dr, 1)), O(br.d).slice(0, Dr) === O(Mr.d).slice(0, Dr))
          if (Mr = Mr.times(2), ie !== 0 && (Mr = Mr.plus(q(sn, Dr + 2, Kr).times(ie + ""))), Mr = L(Mr, new sn(Gr), Dr, 1), Y == null)
            if (I(Mr.d, Dr - tn, cn, vr))
              sn.precision = Dr += tn, br = lr = Wr = L(Or.minus(1), Or.plus(1), Dr, 1), kr = V(Wr.times(Wr), Dr, 1), te = vr = 1;
            else
              return V(Mr, sn.precision = Kr, cn, m = !0);
          else
            return sn.precision = Kr, Mr;
        Mr = br, te += 2;
      }
    }
    function ir(W) {
      return String(W.s * W.s / 0);
    }
    function _r(W, Y) {
      var X, K, te;
      for ((X = Y.indexOf(".")) > -1 && (Y = Y.replace(".", "")), (K = Y.search(/e/i)) > 0 ? (X < 0 && (X = K), X += +Y.slice(K + 1), Y = Y.substring(0, K)) : X < 0 && (X = Y.length), K = 0; Y.charCodeAt(K) === 48; K++)
        ;
      for (te = Y.length; Y.charCodeAt(te - 1) === 48; --te)
        ;
      if (Y = Y.slice(K, te), Y) {
        if (te -= K, W.e = X = X - K - 1, W.d = [], K = (X + 1) % N, X < 0 && (K += N), K < te) {
          for (K && W.d.push(+Y.slice(0, K)), te -= N; K < te; )
            W.d.push(+Y.slice(K, K += N));
          Y = Y.slice(K), K = N - Y.length;
        } else
          K -= te;
        for (; K--; )
          Y += "0";
        W.d.push(+Y), m && (W.e > W.constructor.maxE ? (W.d = null, W.e = NaN) : W.e < W.constructor.minE && (W.e = 0, W.d = [0]));
      } else
        W.e = 0, W.d = [0];
      return W;
    }
    function yr(W, Y) {
      var X, K, te, ie, lr, vr, Mr, br, Dr;
      if (Y.indexOf("_") > -1) {
        if (Y = Y.replace(/(\d)_(?=\d)/g, "$1"), A.test(Y))
          return _r(W, Y);
      } else if (Y === "Infinity" || Y === "NaN")
        return +Y || (W.s = NaN), W.e = NaN, W.d = null, W;
      if (C.test(Y))
        X = 16, Y = Y.toLowerCase();
      else if (M.test(Y))
        X = 2;
      else if (S.test(Y))
        X = 8;
      else
        throw Error(v + Y);
      for (ie = Y.search(/p/i), ie > 0 ? (Mr = +Y.slice(ie + 1), Y = Y.substring(2, ie)) : Y = Y.slice(2), ie = Y.indexOf("."), lr = ie >= 0, K = W.constructor, lr && (Y = Y.replace(".", ""), vr = Y.length, ie = vr - ie, te = se(K, new K(X), ie, ie * 2)), br = k(Y, X, D), Dr = br.length - 1, ie = Dr; br[ie] === 0; --ie)
        br.pop();
      return ie < 0 ? new K(W.s * 0) : (W.e = J(br, Dr), W.d = br, m = !1, lr && (W = L(W, te, vr * 4)), Mr && (W = W.times(Math.abs(Mr) < 54 ? b(2, Mr) : d.pow(2, Mr))), m = !0, W);
    }
    function ne(W, Y) {
      var X, K = Y.d.length;
      if (K < 3)
        return Y.isZero() ? Y : pe(W, 2, Y, Y);
      X = 1.4 * Math.sqrt(K), X = X > 16 ? 16 : X | 0, Y = Y.times(1 / hr(5, X)), Y = pe(W, 2, Y, Y);
      for (var te, ie = new W(5), lr = new W(16), vr = new W(20); X--; )
        te = Y.times(Y), Y = Y.times(ie.plus(te.times(lr.times(te).minus(vr))));
      return Y;
    }
    function pe(W, Y, X, K, te) {
      var ie, lr, vr, Mr, br = W.precision, Dr = Math.ceil(br / N);
      for (m = !1, Mr = X.times(X), vr = new W(K); ; ) {
        if (lr = L(vr.times(Mr), new W(Y++ * Y++), br, 1), vr = te ? K.plus(lr) : K.minus(lr), K = L(lr.times(Mr), new W(Y++ * Y++), br, 1), lr = vr.plus(K), lr.d[Dr] !== void 0) {
          for (ie = Dr; lr.d[ie] === vr.d[ie] && ie--; )
            ;
          if (ie == -1)
            break;
        }
        ie = vr, vr = K, K = lr, lr = ie;
      }
      return m = !0, lr.d.length = Dr + 1, lr;
    }
    function hr(W, Y) {
      for (var X = W; --Y; )
        X *= W;
      return X;
    }
    function $r(W, Y) {
      var X, K = Y.s < 0, te = Z(W, W.precision, 1), ie = te.times(0.5);
      if (Y = Y.abs(), Y.lte(ie))
        return p = K ? 4 : 1, Y;
      if (X = Y.divToInt(te), X.isZero())
        p = K ? 3 : 2;
      else {
        if (Y = Y.minus(X.times(te)), Y.lte(ie))
          return p = nr(X) ? K ? 2 : 3 : K ? 4 : 1, Y;
        p = nr(X) ? K ? 1 : 4 : K ? 3 : 2;
      }
      return Y.minus(te).abs();
    }
    function Sr(W, Y, X, K) {
      var te, ie, lr, vr, Mr, br, Dr, Or, kr, Gr = W.constructor, tn = X !== void 0;
      if (tn ? (G(X, 1, a), K === void 0 ? K = Gr.rounding : G(K, 0, 8)) : (X = Gr.precision, K = Gr.rounding), !W.isFinite())
        Dr = ir(W);
      else {
        for (Dr = U(W), lr = Dr.indexOf("."), tn ? (te = 2, Y == 16 ? X = X * 4 - 3 : Y == 8 && (X = X * 3 - 2)) : te = Y, lr >= 0 && (Dr = Dr.replace(".", ""), kr = new Gr(1), kr.e = Dr.length - lr, kr.d = k(U(kr), 10, te), kr.e = kr.d.length), Or = k(Dr, 10, te), ie = Mr = Or.length; Or[--Mr] == 0; )
          Or.pop();
        if (!Or[0])
          Dr = tn ? "0p+0" : "0";
        else {
          if (lr < 0 ? ie-- : (W = new Gr(W), W.d = Or, W.e = ie, W = L(W, kr, X, K, 0, te), Or = W.d, ie = W.e, br = h), lr = Or[X], vr = te / 2, br = br || Or[X + 1] !== void 0, br = K < 4 ? (lr !== void 0 || br) && (K === 0 || K === (W.s < 0 ? 3 : 2)) : lr > vr || lr === vr && (K === 4 || br || K === 6 && Or[X - 1] & 1 || K === (W.s < 0 ? 8 : 7)), Or.length = X, br)
            for (; ++Or[--X] > te - 1; )
              Or[X] = 0, X || (++ie, Or.unshift(1));
          for (Mr = Or.length; !Or[Mr - 1]; --Mr)
            ;
          for (lr = 0, Dr = ""; lr < Mr; lr++)
            Dr += s.charAt(Or[lr]);
          if (tn) {
            if (Mr > 1)
              if (Y == 16 || Y == 8) {
                for (lr = Y == 16 ? 4 : 3, --Mr; Mr % lr; Mr++)
                  Dr += "0";
                for (Or = k(Dr, te, Y), Mr = Or.length; !Or[Mr - 1]; --Mr)
                  ;
                for (lr = 1, Dr = "1."; lr < Mr; lr++)
                  Dr += s.charAt(Or[lr]);
              } else
                Dr = Dr.charAt(0) + "." + Dr.slice(1);
            Dr = Dr + (ie < 0 ? "p" : "p+") + ie;
          } else if (ie < 0) {
            for (; ++ie; )
              Dr = "0" + Dr;
            Dr = "0." + Dr;
          } else if (++ie > Mr)
            for (ie -= Mr; ie--; )
              Dr += "0";
          else
            ie < Mr && (Dr = Dr.slice(0, ie) + "." + Dr.slice(ie));
        }
        Dr = (Y == 16 ? "0x" : Y == 2 ? "0b" : Y == 8 ? "0o" : "") + Dr;
      }
      return W.s < 0 ? "-" + Dr : Dr;
    }
    function ze(W, Y) {
      if (W.length > Y)
        return W.length = Y, !0;
    }
    function cr(W) {
      return new this(W).abs();
    }
    function fr(W) {
      return new this(W).acos();
    }
    function mr(W) {
      return new this(W).acosh();
    }
    function wr(W, Y) {
      return new this(W).plus(Y);
    }
    function Nr(W) {
      return new this(W).asin();
    }
    function xr(W) {
      return new this(W).asinh();
    }
    function Er(W) {
      return new this(W).atan();
    }
    function Ir(W) {
      return new this(W).atanh();
    }
    function Rr(W, Y) {
      W = new this(W), Y = new this(Y);
      var X, K = this.precision, te = this.rounding, ie = K + 4;
      return !W.s || !Y.s ? X = new this(NaN) : !W.d && !Y.d ? (X = Z(this, ie, 1).times(Y.s > 0 ? 0.25 : 0.75), X.s = W.s) : !Y.d || W.isZero() ? (X = Y.s < 0 ? Z(this, K, te) : new this(0), X.s = W.s) : !W.d || Y.isZero() ? (X = Z(this, ie, 1).times(0.5), X.s = W.s) : Y.s < 0 ? (this.precision = ie, this.rounding = 1, X = this.atan(L(W, Y, ie, 1)), Y = Z(this, ie, 1), this.precision = K, this.rounding = te, X = W.s < 0 ? X.minus(Y) : X.plus(Y)) : X = this.atan(L(W, Y, ie, 1)), X;
    }
    function Yr(W) {
      return new this(W).cbrt();
    }
    function Qr(W) {
      return V(W = new this(W), W.e + 1, 2);
    }
    function nn(W, Y, X) {
      return new this(W).clamp(Y, X);
    }
    function on(W) {
      if (!W || typeof W != "object")
        throw Error(g + "Object expected");
      var Y, X, K, te = W.defaults === !0, ie = [
        "precision",
        1,
        a,
        "rounding",
        0,
        8,
        "toExpNeg",
        -n,
        0,
        "toExpPos",
        0,
        n,
        "maxE",
        0,
        n,
        "minE",
        -n,
        0,
        "modulo",
        0,
        9
      ];
      for (Y = 0; Y < ie.length; Y += 3)
        if (X = ie[Y], te && (this[X] = l[X]), (K = W[X]) !== void 0)
          if ($(K) === K && K >= ie[Y + 1] && K <= ie[Y + 2])
            this[X] = K;
          else
            throw Error(v + X + ": " + K);
      if (X = "crypto", te && (this[X] = l[X]), (K = W[X]) !== void 0)
        if (K === !0 || K === !1 || K === 0 || K === 1)
          if (K)
            if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
              this[X] = !0;
            else
              throw Error(x);
          else
            this[X] = !1;
        else
          throw Error(v + X + ": " + K);
      return this;
    }
    function en(W) {
      return new this(W).cos();
    }
    function zr(W) {
      return new this(W).cosh();
    }
    function Jr(W) {
      var Y, X, K;
      function te(ie) {
        var lr, vr, Mr, br = this;
        if (!(br instanceof te))
          return new te(ie);
        if (br.constructor = te, Vr(ie)) {
          br.s = ie.s, m ? !ie.d || ie.e > te.maxE ? (br.e = NaN, br.d = null) : ie.e < te.minE ? (br.e = 0, br.d = [0]) : (br.e = ie.e, br.d = ie.d.slice()) : (br.e = ie.e, br.d = ie.d ? ie.d.slice() : ie.d);
          return;
        }
        if (Mr = typeof ie, Mr === "number") {
          if (ie === 0) {
            br.s = 1 / ie < 0 ? -1 : 1, br.e = 0, br.d = [0];
            return;
          }
          if (ie < 0 ? (ie = -ie, br.s = -1) : br.s = 1, ie === ~~ie && ie < 1e7) {
            for (lr = 0, vr = ie; vr >= 10; vr /= 10)
              lr++;
            m ? lr > te.maxE ? (br.e = NaN, br.d = null) : lr < te.minE ? (br.e = 0, br.d = [0]) : (br.e = lr, br.d = [ie]) : (br.e = lr, br.d = [ie]);
            return;
          } else if (ie * 0 !== 0) {
            ie || (br.s = NaN), br.e = NaN, br.d = null;
            return;
          }
          return _r(br, ie.toString());
        } else if (Mr !== "string")
          throw Error(v + ie);
        return (vr = ie.charCodeAt(0)) === 45 ? (ie = ie.slice(1), br.s = -1) : (vr === 43 && (ie = ie.slice(1)), br.s = 1), A.test(ie) ? _r(br, ie) : yr(br, ie);
      }
      if (te.prototype = z, te.ROUND_UP = 0, te.ROUND_DOWN = 1, te.ROUND_CEIL = 2, te.ROUND_FLOOR = 3, te.ROUND_HALF_UP = 4, te.ROUND_HALF_DOWN = 5, te.ROUND_HALF_EVEN = 6, te.ROUND_HALF_CEIL = 7, te.ROUND_HALF_FLOOR = 8, te.EUCLID = 9, te.config = te.set = on, te.clone = Jr, te.isDecimal = Vr, te.abs = cr, te.acos = fr, te.acosh = mr, te.add = wr, te.asin = Nr, te.asinh = xr, te.atan = Er, te.atanh = Ir, te.atan2 = Rr, te.cbrt = Yr, te.ceil = Qr, te.clamp = nn, te.cos = en, te.cosh = zr, te.div = H, te.exp = dr, te.floor = Ar, te.hypot = jr, te.ln = Zr, te.log = pn, te.log10 = Cr, te.log2 = gr, te.max = Pr, te.min = Tr, te.mod = Xr, te.mul = rn, te.pow = un, te.random = ln, te.round = bn, te.sign = $n, te.sin = An, te.sinh = Nn, te.sqrt = Pn, te.sub = Tn, te.sum = pr, te.tan = Lr, te.tanh = Fr, te.trunc = Br, W === void 0 && (W = {}), W && W.defaults !== !0)
        for (K = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], Y = 0; Y < K.length; )
          W.hasOwnProperty(X = K[Y++]) || (W[X] = this[X]);
      return te.config(W), te;
    }
    function H(W, Y) {
      return new this(W).div(Y);
    }
    function dr(W) {
      return new this(W).exp();
    }
    function Ar(W) {
      return V(W = new this(W), W.e + 1, 3);
    }
    function jr() {
      var W, Y, X = new this(0);
      for (m = !1, W = 0; W < arguments.length; )
        if (Y = new this(arguments[W++]), Y.d)
          X.d && (X = X.plus(Y.times(Y)));
        else {
          if (Y.s)
            return m = !0, new this(1 / 0);
          X = Y;
        }
      return m = !0, X.sqrt();
    }
    function Vr(W) {
      return W instanceof d || W && W.toStringTag === _ || !1;
    }
    function Zr(W) {
      return new this(W).ln();
    }
    function pn(W, Y) {
      return new this(W).log(Y);
    }
    function gr(W) {
      return new this(W).log(2);
    }
    function Cr(W) {
      return new this(W).log(10);
    }
    function Pr() {
      return ce(this, arguments, "lt");
    }
    function Tr() {
      return ce(this, arguments, "gt");
    }
    function Xr(W, Y) {
      return new this(W).mod(Y);
    }
    function rn(W, Y) {
      return new this(W).mul(Y);
    }
    function un(W, Y) {
      return new this(W).pow(Y);
    }
    function ln(W) {
      var Y, X, K, te, ie = 0, lr = new this(1), vr = [];
      if (W === void 0 ? W = this.precision : G(W, 1, a), K = Math.ceil(W / N), this.crypto)
        if (crypto.getRandomValues)
          for (Y = crypto.getRandomValues(new Uint32Array(K)); ie < K; )
            te = Y[ie], te >= 429e7 ? Y[ie] = crypto.getRandomValues(new Uint32Array(1))[0] : vr[ie++] = te % 1e7;
        else if (crypto.randomBytes) {
          for (Y = crypto.randomBytes(K *= 4); ie < K; )
            te = Y[ie] + (Y[ie + 1] << 8) + (Y[ie + 2] << 16) + ((Y[ie + 3] & 127) << 24), te >= 214e7 ? crypto.randomBytes(4).copy(Y, ie) : (vr.push(te % 1e7), ie += 4);
          ie = K / 4;
        } else
          throw Error(x);
      else
        for (; ie < K; )
          vr[ie++] = Math.random() * 1e7 | 0;
      for (K = vr[--ie], W %= N, K && W && (te = b(10, N - W), vr[ie] = (K / te | 0) * te); vr[ie] === 0; ie--)
        vr.pop();
      if (ie < 0)
        X = 0, vr = [0];
      else {
        for (X = -1; vr[0] === 0; X -= N)
          vr.shift();
        for (K = 1, te = vr[0]; te >= 10; te /= 10)
          K++;
        K < N && (X -= N - K);
      }
      return lr.e = X, lr.d = vr, lr;
    }
    function bn(W) {
      return V(W = new this(W), W.e + 1, this.rounding);
    }
    function $n(W) {
      return W = new this(W), W.d ? W.d[0] ? W.s : 0 * W.s : W.s || NaN;
    }
    function An(W) {
      return new this(W).sin();
    }
    function Nn(W) {
      return new this(W).sinh();
    }
    function Pn(W) {
      return new this(W).sqrt();
    }
    function Tn(W, Y) {
      return new this(W).sub(Y);
    }
    function pr() {
      var W = 0, Y = arguments, X = new this(Y[W]);
      for (m = !1; X.s && ++W < Y.length; )
        X = X.plus(Y[W]);
      return m = !0, V(X, this.precision, this.rounding);
    }
    function Lr(W) {
      return new this(W).tan();
    }
    function Fr(W) {
      return new this(W).tanh();
    }
    function Br(W) {
      return V(W = new this(W), W.e + 1, 1);
    }
    d = Jr(l), d.prototype.constructor = d, d.default = d.Decimal = d, o = new d(o), c = new d(c), t.exports ? (typeof Symbol == "function" && typeof Symbol.iterator == "symbol" && (z[Symbol.for("nodejs.util.inspect.custom")] = z.toString, z[Symbol.toStringTag] = "Decimal"), t.exports = d) : (r || (r = typeof self < "u" && self && self.self == self ? self : window), u = r.Decimal, d.noConflict = function() {
      return r.Decimal = u, d;
    }, r.Decimal = d);
  })(commonjsGlobal);
})(decimal$1);
var decimalExports = decimal$1.exports;
Object.defineProperty(BigNumber, "__esModule", {
  value: !0
});
BigNumber.createBigNumberClass = void 0;
var _decimal$2 = _interopRequireDefault$8(decimalExports), _factory$4q = factory$1;
function _interopRequireDefault$8(t) {
  return t && t.__esModule ? t : { default: t };
}
var name$4m = "BigNumber", dependencies$4m = ["?on", "config"], createBigNumberClass = /* @__PURE__ */ (0, _factory$4q.factory)(name$4m, dependencies$4m, function(t) {
  var r = t.on, n = t.config, a = 9, s = _decimal$2.default.clone({
    precision: n.precision,
    modulo: a
  });
  return s.prototype.type = "BigNumber", s.prototype.isBigNumber = !0, s.prototype.toJSON = function() {
    return {
      mathjs: "BigNumber",
      value: this.toString()
    };
  }, s.fromJSON = function(o) {
    return new s(o.value);
  }, r && r("config", function(o, c) {
    o.precision !== c.precision && s.config({
      precision: o.precision
    });
  }), s;
}, {
  isClass: !0
});
BigNumber.createBigNumberClass = createBigNumberClass;
var Complex = {}, complex$3 = { exports: {} };
/**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
(function(t, r) {
  (function(n) {
    var a = Math.cosh || function(p) {
      return Math.abs(p) < 1e-9 ? 1 - p : (Math.exp(p) + Math.exp(-p)) * 0.5;
    }, s = Math.sinh || function(p) {
      return Math.abs(p) < 1e-9 ? p : (Math.exp(p) - Math.exp(-p)) * 0.5;
    }, o = function(p) {
      var m = Math.PI / 4;
      if (-m > p || p > m)
        return Math.cos(p) - 1;
      var g = p * p;
      return g * (g * (g * (g * (g * (g * (g * (g / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
    }, c = function(p, m) {
      var g = Math.abs(p), v = Math.abs(m);
      return g < 3e3 && v < 3e3 ? Math.sqrt(g * g + v * v) : (g < v ? (g = v, v = p / m) : v = m / p, g * Math.sqrt(1 + v * v));
    }, l = function() {
      throw SyntaxError("Invalid Param");
    };
    function d(p, m) {
      var g = Math.abs(p), v = Math.abs(m);
      return p === 0 ? Math.log(v) : m === 0 ? Math.log(g) : g < 3e3 && v < 3e3 ? Math.log(p * p + m * m) * 0.5 : (p = p / 2, m = m / 2, 0.5 * Math.log(p * p + m * m) + Math.LN2);
    }
    var h = function(p, m) {
      var g = { re: 0, im: 0 };
      if (p == null)
        g.re = g.im = 0;
      else if (m !== void 0)
        g.re = p, g.im = m;
      else
        switch (typeof p) {
          case "object":
            if ("im" in p && "re" in p)
              g.re = p.re, g.im = p.im;
            else if ("abs" in p && "arg" in p) {
              if (!Number.isFinite(p.abs) && Number.isFinite(p.arg))
                return u.INFINITY;
              g.re = p.abs * Math.cos(p.arg), g.im = p.abs * Math.sin(p.arg);
            } else if ("r" in p && "phi" in p) {
              if (!Number.isFinite(p.r) && Number.isFinite(p.phi))
                return u.INFINITY;
              g.re = p.r * Math.cos(p.phi), g.im = p.r * Math.sin(p.phi);
            } else
              p.length === 2 ? (g.re = p[0], g.im = p[1]) : l();
            break;
          case "string":
            g.im = /* void */
            g.re = 0;
            var v = p.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), y = 1, x = 0;
            v === null && l();
            for (var _ = 0; _ < v.length; _++) {
              var $ = v[_];
              $ === " " || $ === "	" || $ === `
` || ($ === "+" ? y++ : $ === "-" ? x++ : $ === "i" || $ === "I" ? (y + x === 0 && l(), v[_ + 1] !== " " && !isNaN(v[_ + 1]) ? (g.im += parseFloat((x % 2 ? "-" : "") + v[_ + 1]), _++) : g.im += parseFloat((x % 2 ? "-" : "") + "1"), y = x = 0) : ((y + x === 0 || isNaN($)) && l(), v[_ + 1] === "i" || v[_ + 1] === "I" ? (g.im += parseFloat((x % 2 ? "-" : "") + $), _++) : g.re += parseFloat((x % 2 ? "-" : "") + $), y = x = 0));
            }
            y + x > 0 && l();
            break;
          case "number":
            g.im = 0, g.re = p;
            break;
          default:
            l();
        }
      return isNaN(g.re) || isNaN(g.im), g;
    };
    function u(p, m) {
      if (!(this instanceof u))
        return new u(p, m);
      var g = h(p, m);
      this.re = g.re, this.im = g.im;
    }
    u.prototype = {
      re: 0,
      im: 0,
      /**
       * Calculates the sign of a complex number, which is a normalized complex
       *
       * @returns {Complex}
       */
      sign: function() {
        var p = this.abs();
        return new u(
          this.re / p,
          this.im / p
        );
      },
      /**
       * Adds two complex numbers
       *
       * @returns {Complex}
       */
      add: function(p, m) {
        var g = new u(p, m);
        return this.isInfinite() && g.isInfinite() ? u.NAN : this.isInfinite() || g.isInfinite() ? u.INFINITY : new u(
          this.re + g.re,
          this.im + g.im
        );
      },
      /**
       * Subtracts two complex numbers
       *
       * @returns {Complex}
       */
      sub: function(p, m) {
        var g = new u(p, m);
        return this.isInfinite() && g.isInfinite() ? u.NAN : this.isInfinite() || g.isInfinite() ? u.INFINITY : new u(
          this.re - g.re,
          this.im - g.im
        );
      },
      /**
       * Multiplies two complex numbers
       *
       * @returns {Complex}
       */
      mul: function(p, m) {
        var g = new u(p, m);
        return this.isInfinite() && g.isZero() || this.isZero() && g.isInfinite() ? u.NAN : this.isInfinite() || g.isInfinite() ? u.INFINITY : g.im === 0 && this.im === 0 ? new u(this.re * g.re, 0) : new u(
          this.re * g.re - this.im * g.im,
          this.re * g.im + this.im * g.re
        );
      },
      /**
       * Divides two complex numbers
       *
       * @returns {Complex}
       */
      div: function(p, m) {
        var g = new u(p, m);
        if (this.isZero() && g.isZero() || this.isInfinite() && g.isInfinite())
          return u.NAN;
        if (this.isInfinite() || g.isZero())
          return u.INFINITY;
        if (this.isZero() || g.isInfinite())
          return u.ZERO;
        p = this.re, m = this.im;
        var v = g.re, y = g.im, x, _;
        return y === 0 ? new u(p / v, m / v) : Math.abs(v) < Math.abs(y) ? (_ = v / y, x = v * _ + y, new u(
          (p * _ + m) / x,
          (m * _ - p) / x
        )) : (_ = y / v, x = y * _ + v, new u(
          (p + m * _) / x,
          (m - p * _) / x
        ));
      },
      /**
       * Calculate the power of two complex numbers
       *
       * @returns {Complex}
       */
      pow: function(p, m) {
        var g = new u(p, m);
        if (p = this.re, m = this.im, g.isZero())
          return u.ONE;
        if (g.im === 0) {
          if (m === 0 && p > 0)
            return new u(Math.pow(p, g.re), 0);
          if (p === 0)
            switch ((g.re % 4 + 4) % 4) {
              case 0:
                return new u(Math.pow(m, g.re), 0);
              case 1:
                return new u(0, Math.pow(m, g.re));
              case 2:
                return new u(-Math.pow(m, g.re), 0);
              case 3:
                return new u(0, -Math.pow(m, g.re));
            }
        }
        if (p === 0 && m === 0 && g.re > 0 && g.im >= 0)
          return u.ZERO;
        var v = Math.atan2(m, p), y = d(p, m);
        return p = Math.exp(g.re * y - g.im * v), m = g.im * y + g.re * v, new u(
          p * Math.cos(m),
          p * Math.sin(m)
        );
      },
      /**
       * Calculate the complex square root
       *
       * @returns {Complex}
       */
      sqrt: function() {
        var p = this.re, m = this.im, g = this.abs(), v, y;
        if (p >= 0) {
          if (m === 0)
            return new u(Math.sqrt(p), 0);
          v = 0.5 * Math.sqrt(2 * (g + p));
        } else
          v = Math.abs(m) / Math.sqrt(2 * (g - p));
        return p <= 0 ? y = 0.5 * Math.sqrt(2 * (g - p)) : y = Math.abs(m) / Math.sqrt(2 * (g + p)), new u(v, m < 0 ? -y : y);
      },
      /**
       * Calculate the complex exponent
       *
       * @returns {Complex}
       */
      exp: function() {
        var p = Math.exp(this.re);
        return this.im, new u(
          p * Math.cos(this.im),
          p * Math.sin(this.im)
        );
      },
      /**
       * Calculate the complex exponent and subtracts one.
       *
       * This may be more accurate than `Complex(x).exp().sub(1)` if
       * `x` is small.
       *
       * @returns {Complex}
       */
      expm1: function() {
        var p = this.re, m = this.im;
        return new u(
          Math.expm1(p) * Math.cos(m) + o(m),
          Math.exp(p) * Math.sin(m)
        );
      },
      /**
       * Calculate the natural log
       *
       * @returns {Complex}
       */
      log: function() {
        var p = this.re, m = this.im;
        return new u(
          d(p, m),
          Math.atan2(m, p)
        );
      },
      /**
       * Calculate the magnitude of the complex number
       *
       * @returns {number}
       */
      abs: function() {
        return c(this.re, this.im);
      },
      /**
       * Calculate the angle of the complex number
       *
       * @returns {number}
       */
      arg: function() {
        return Math.atan2(this.im, this.re);
      },
      /**
       * Calculate the sine of the complex number
       *
       * @returns {Complex}
       */
      sin: function() {
        var p = this.re, m = this.im;
        return new u(
          Math.sin(p) * a(m),
          Math.cos(p) * s(m)
        );
      },
      /**
       * Calculate the cosine
       *
       * @returns {Complex}
       */
      cos: function() {
        var p = this.re, m = this.im;
        return new u(
          Math.cos(p) * a(m),
          -Math.sin(p) * s(m)
        );
      },
      /**
       * Calculate the tangent
       *
       * @returns {Complex}
       */
      tan: function() {
        var p = 2 * this.re, m = 2 * this.im, g = Math.cos(p) + a(m);
        return new u(
          Math.sin(p) / g,
          s(m) / g
        );
      },
      /**
       * Calculate the cotangent
       *
       * @returns {Complex}
       */
      cot: function() {
        var p = 2 * this.re, m = 2 * this.im, g = Math.cos(p) - a(m);
        return new u(
          -Math.sin(p) / g,
          s(m) / g
        );
      },
      /**
       * Calculate the secant
       *
       * @returns {Complex}
       */
      sec: function() {
        var p = this.re, m = this.im, g = 0.5 * a(2 * m) + 0.5 * Math.cos(2 * p);
        return new u(
          Math.cos(p) * a(m) / g,
          Math.sin(p) * s(m) / g
        );
      },
      /**
       * Calculate the cosecans
       *
       * @returns {Complex}
       */
      csc: function() {
        var p = this.re, m = this.im, g = 0.5 * a(2 * m) - 0.5 * Math.cos(2 * p);
        return new u(
          Math.sin(p) * a(m) / g,
          -Math.cos(p) * s(m) / g
        );
      },
      /**
       * Calculate the complex arcus sinus
       *
       * @returns {Complex}
       */
      asin: function() {
        var p = this.re, m = this.im, g = new u(
          m * m - p * p + 1,
          -2 * p * m
        ).sqrt(), v = new u(
          g.re - m,
          g.im + p
        ).log();
        return new u(v.im, -v.re);
      },
      /**
       * Calculate the complex arcus cosinus
       *
       * @returns {Complex}
       */
      acos: function() {
        var p = this.re, m = this.im, g = new u(
          m * m - p * p + 1,
          -2 * p * m
        ).sqrt(), v = new u(
          g.re - m,
          g.im + p
        ).log();
        return new u(Math.PI / 2 - v.im, v.re);
      },
      /**
       * Calculate the complex arcus tangent
       *
       * @returns {Complex}
       */
      atan: function() {
        var p = this.re, m = this.im;
        if (p === 0) {
          if (m === 1)
            return new u(0, 1 / 0);
          if (m === -1)
            return new u(0, -1 / 0);
        }
        var g = p * p + (1 - m) * (1 - m), v = new u(
          (1 - m * m - p * p) / g,
          -2 * p / g
        ).log();
        return new u(-0.5 * v.im, 0.5 * v.re);
      },
      /**
       * Calculate the complex arcus cotangent
       *
       * @returns {Complex}
       */
      acot: function() {
        var p = this.re, m = this.im;
        if (m === 0)
          return new u(Math.atan2(1, p), 0);
        var g = p * p + m * m;
        return g !== 0 ? new u(
          p / g,
          -m / g
        ).atan() : new u(
          p !== 0 ? p / 0 : 0,
          m !== 0 ? -m / 0 : 0
        ).atan();
      },
      /**
       * Calculate the complex arcus secant
       *
       * @returns {Complex}
       */
      asec: function() {
        var p = this.re, m = this.im;
        if (p === 0 && m === 0)
          return new u(0, 1 / 0);
        var g = p * p + m * m;
        return g !== 0 ? new u(
          p / g,
          -m / g
        ).acos() : new u(
          p !== 0 ? p / 0 : 0,
          m !== 0 ? -m / 0 : 0
        ).acos();
      },
      /**
       * Calculate the complex arcus cosecans
       *
       * @returns {Complex}
       */
      acsc: function() {
        var p = this.re, m = this.im;
        if (p === 0 && m === 0)
          return new u(Math.PI / 2, 1 / 0);
        var g = p * p + m * m;
        return g !== 0 ? new u(
          p / g,
          -m / g
        ).asin() : new u(
          p !== 0 ? p / 0 : 0,
          m !== 0 ? -m / 0 : 0
        ).asin();
      },
      /**
       * Calculate the complex sinh
       *
       * @returns {Complex}
       */
      sinh: function() {
        var p = this.re, m = this.im;
        return new u(
          s(p) * Math.cos(m),
          a(p) * Math.sin(m)
        );
      },
      /**
       * Calculate the complex cosh
       *
       * @returns {Complex}
       */
      cosh: function() {
        var p = this.re, m = this.im;
        return new u(
          a(p) * Math.cos(m),
          s(p) * Math.sin(m)
        );
      },
      /**
       * Calculate the complex tanh
       *
       * @returns {Complex}
       */
      tanh: function() {
        var p = 2 * this.re, m = 2 * this.im, g = a(p) + Math.cos(m);
        return new u(
          s(p) / g,
          Math.sin(m) / g
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      coth: function() {
        var p = 2 * this.re, m = 2 * this.im, g = a(p) - Math.cos(m);
        return new u(
          s(p) / g,
          -Math.sin(m) / g
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      csch: function() {
        var p = this.re, m = this.im, g = Math.cos(2 * m) - a(2 * p);
        return new u(
          -2 * s(p) * Math.cos(m) / g,
          2 * a(p) * Math.sin(m) / g
        );
      },
      /**
       * Calculate the complex sech
       *
       * @returns {Complex}
       */
      sech: function() {
        var p = this.re, m = this.im, g = Math.cos(2 * m) + a(2 * p);
        return new u(
          2 * a(p) * Math.cos(m) / g,
          -2 * s(p) * Math.sin(m) / g
        );
      },
      /**
       * Calculate the complex asinh
       *
       * @returns {Complex}
       */
      asinh: function() {
        var p = this.im;
        this.im = -this.re, this.re = p;
        var m = this.asin();
        return this.re = -this.im, this.im = p, p = m.re, m.re = -m.im, m.im = p, m;
      },
      /**
       * Calculate the complex acosh
       *
       * @returns {Complex}
       */
      acosh: function() {
        var p = this.acos();
        if (p.im <= 0) {
          var m = p.re;
          p.re = -p.im, p.im = m;
        } else {
          var m = p.im;
          p.im = -p.re, p.re = m;
        }
        return p;
      },
      /**
       * Calculate the complex atanh
       *
       * @returns {Complex}
       */
      atanh: function() {
        var p = this.re, m = this.im, g = p > 1 && m === 0, v = 1 - p, y = 1 + p, x = v * v + m * m, _ = x !== 0 ? new u(
          (y * v - m * m) / x,
          (m * v + y * m) / x
        ) : new u(
          p !== -1 ? p / 0 : 0,
          m !== 0 ? m / 0 : 0
        ), $ = _.re;
        return _.re = d(_.re, _.im) / 2, _.im = Math.atan2(_.im, $) / 2, g && (_.im = -_.im), _;
      },
      /**
       * Calculate the complex acoth
       *
       * @returns {Complex}
       */
      acoth: function() {
        var p = this.re, m = this.im;
        if (p === 0 && m === 0)
          return new u(0, Math.PI / 2);
        var g = p * p + m * m;
        return g !== 0 ? new u(
          p / g,
          -m / g
        ).atanh() : new u(
          p !== 0 ? p / 0 : 0,
          m !== 0 ? -m / 0 : 0
        ).atanh();
      },
      /**
       * Calculate the complex acsch
       *
       * @returns {Complex}
       */
      acsch: function() {
        var p = this.re, m = this.im;
        if (m === 0)
          return new u(
            p !== 0 ? Math.log(p + Math.sqrt(p * p + 1)) : 1 / 0,
            0
          );
        var g = p * p + m * m;
        return g !== 0 ? new u(
          p / g,
          -m / g
        ).asinh() : new u(
          p !== 0 ? p / 0 : 0,
          m !== 0 ? -m / 0 : 0
        ).asinh();
      },
      /**
       * Calculate the complex asech
       *
       * @returns {Complex}
       */
      asech: function() {
        var p = this.re, m = this.im;
        if (this.isZero())
          return u.INFINITY;
        var g = p * p + m * m;
        return g !== 0 ? new u(
          p / g,
          -m / g
        ).acosh() : new u(
          p !== 0 ? p / 0 : 0,
          m !== 0 ? -m / 0 : 0
        ).acosh();
      },
      /**
       * Calculate the complex inverse 1/z
       *
       * @returns {Complex}
       */
      inverse: function() {
        if (this.isZero())
          return u.INFINITY;
        if (this.isInfinite())
          return u.ZERO;
        var p = this.re, m = this.im, g = p * p + m * m;
        return new u(p / g, -m / g);
      },
      /**
       * Returns the complex conjugate
       *
       * @returns {Complex}
       */
      conjugate: function() {
        return new u(this.re, -this.im);
      },
      /**
       * Gets the negated complex number
       *
       * @returns {Complex}
       */
      neg: function() {
        return new u(-this.re, -this.im);
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      ceil: function(p) {
        return p = Math.pow(10, p || 0), new u(
          Math.ceil(this.re * p) / p,
          Math.ceil(this.im * p) / p
        );
      },
      /**
       * Floors the actual complex number
       *
       * @returns {Complex}
       */
      floor: function(p) {
        return p = Math.pow(10, p || 0), new u(
          Math.floor(this.re * p) / p,
          Math.floor(this.im * p) / p
        );
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      round: function(p) {
        return p = Math.pow(10, p || 0), new u(
          Math.round(this.re * p) / p,
          Math.round(this.im * p) / p
        );
      },
      /**
       * Compares two complex numbers
       *
       * **Note:** new Complex(Infinity).equals(Infinity) === false
       *
       * @returns {boolean}
       */
      equals: function(p, m) {
        var g = new u(p, m);
        return Math.abs(g.re - this.re) <= u.EPSILON && Math.abs(g.im - this.im) <= u.EPSILON;
      },
      /**
       * Clones the actual object
       *
       * @returns {Complex}
       */
      clone: function() {
        return new u(this.re, this.im);
      },
      /**
       * Gets a string of the actual complex number
       *
       * @returns {string}
       */
      toString: function() {
        var p = this.re, m = this.im, g = "";
        return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(p) < u.EPSILON && (p = 0), Math.abs(m) < u.EPSILON && (m = 0), m === 0 ? g + p : (p !== 0 ? (g += p, g += " ", m < 0 ? (m = -m, g += "-") : g += "+", g += " ") : m < 0 && (m = -m, g += "-"), m !== 1 && (g += m), g + "i"));
      },
      /**
       * Returns the actual number as a vector
       *
       * @returns {Array}
       */
      toVector: function() {
        return [this.re, this.im];
      },
      /**
       * Returns the actual real value of the current object
       *
       * @returns {number|null}
       */
      valueOf: function() {
        return this.im === 0 ? this.re : null;
      },
      /**
       * Determines whether a complex number is not on the Riemann sphere.
       *
       * @returns {boolean}
       */
      isNaN: function() {
        return isNaN(this.re) || isNaN(this.im);
      },
      /**
       * Determines whether or not a complex number is at the zero pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isZero: function() {
        return this.im === 0 && this.re === 0;
      },
      /**
       * Determines whether a complex number is not at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isFinite: function() {
        return isFinite(this.re) && isFinite(this.im);
      },
      /**
       * Determines whether or not a complex number is at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isInfinite: function() {
        return !(this.isNaN() || this.isFinite());
      }
    }, u.ZERO = new u(0, 0), u.ONE = new u(1, 0), u.I = new u(0, 1), u.PI = new u(Math.PI, 0), u.E = new u(Math.E, 0), u.INFINITY = new u(1 / 0, 1 / 0), u.NAN = new u(NaN, NaN), u.EPSILON = 1e-15, Object.defineProperty(u, "__esModule", { value: !0 }), u.default = u, u.Complex = u, t.exports = u;
  })();
})(complex$3);
var complexExports = complex$3.exports;
Object.defineProperty(Complex, "__esModule", {
  value: !0
});
Complex.createComplexClass = void 0;
var _complex$2 = _interopRequireDefault$7(complexExports), _number$F = number$3, _is$1j = is, _factory$4p = factory$1;
function _interopRequireDefault$7(t) {
  return t && t.__esModule ? t : { default: t };
}
function _typeof$e(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$e = function(n) {
    return typeof n;
  } : _typeof$e = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$e(t);
}
var name$4l = "Complex", dependencies$4l = [], createComplexClass = /* @__PURE__ */ (0, _factory$4p.factory)(name$4l, dependencies$4l, function() {
  return _complex$2.default.prototype.type = "Complex", _complex$2.default.prototype.isComplex = !0, _complex$2.default.prototype.toJSON = function() {
    return {
      mathjs: "Complex",
      re: this.re,
      im: this.im
    };
  }, _complex$2.default.prototype.toPolar = function() {
    return {
      r: this.abs(),
      phi: this.arg()
    };
  }, _complex$2.default.prototype.format = function(t) {
    var r = "", n = this.im, a = this.re, s = (0, _number$F.format)(this.re, t), o = (0, _number$F.format)(this.im, t), c = (0, _is$1j.isNumber)(t) ? t : t ? t.precision : null;
    if (c !== null) {
      var l = Math.pow(10, -c);
      Math.abs(a / n) < l && (a = 0), Math.abs(n / a) < l && (n = 0);
    }
    return n === 0 ? r = s : a === 0 ? n === 1 ? r = "i" : n === -1 ? r = "-i" : r = o + "i" : n < 0 ? n === -1 ? r = s + " - i" : r = s + " - " + o.substring(1) + "i" : n === 1 ? r = s + " + i" : r = s + " + " + o + "i", r;
  }, _complex$2.default.fromPolar = function(t) {
    switch (arguments.length) {
      case 1: {
        var r = arguments[0];
        if (_typeof$e(r) === "object")
          return (0, _complex$2.default)(r);
        throw new TypeError("Input has to be an object with r and phi keys.");
      }
      case 2: {
        var n = arguments[0], a = arguments[1];
        if ((0, _is$1j.isNumber)(n)) {
          if ((0, _is$1j.isUnit)(a) && a.hasBase("ANGLE") && (a = a.toNumber("rad")), (0, _is$1j.isNumber)(a))
            return new _complex$2.default({
              r: n,
              phi: a
            });
          throw new TypeError("Phi is not a number nor an angle unit.");
        } else
          throw new TypeError("Radius r is not a number.");
      }
      default:
        throw new SyntaxError("Wrong number of arguments in function fromPolar");
    }
  }, _complex$2.default.prototype.valueOf = _complex$2.default.prototype.toString, _complex$2.default.fromJSON = function(t) {
    return new _complex$2.default(t);
  }, _complex$2.default.compare = function(t, r) {
    return t.re > r.re ? 1 : t.re < r.re ? -1 : t.im > r.im ? 1 : t.im < r.im ? -1 : 0;
  }, _complex$2.default;
}, {
  isClass: !0
});
Complex.createComplexClass = createComplexClass;
var Fraction = {}, fraction$2 = { exports: {} };
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
(function(t, r) {
  (function(n) {
    var a = 2e3, s = {
      s: 1,
      n: 0,
      d: 1
    };
    function o(_, $) {
      if (isNaN(_ = parseInt(_, 10)))
        throw y();
      return _ * $;
    }
    function c(_, $) {
      if ($ === 0)
        throw v();
      var b = Object.create(g.prototype);
      b.s = _ < 0 ? -1 : 1, _ = _ < 0 ? -_ : _;
      var M = m(_, $);
      return b.n = _ / M, b.d = $ / M, b;
    }
    function l(_) {
      for (var $ = {}, b = _, M = 2, C = 4; C <= b; ) {
        for (; b % M === 0; )
          b /= M, $[M] = ($[M] || 0) + 1;
        C += 1 + 2 * M++;
      }
      return b !== _ ? b > 1 && ($[b] = ($[b] || 0) + 1) : $[_] = ($[_] || 0) + 1, $;
    }
    var d = function(_, $) {
      var b = 0, M = 1, C = 1, S = 0, A = 0, D = 0, N = 1, T = 1, R = 0, F = 1, z = 1, O = 1, G = 1e7, I;
      if (_ != null)
        if ($ !== void 0) {
          if (b = _, M = $, C = b * M, b % 1 !== 0 || M % 1 !== 0)
            throw x();
        } else
          switch (typeof _) {
            case "object": {
              if ("d" in _ && "n" in _)
                b = _.n, M = _.d, "s" in _ && (b *= _.s);
              else if (0 in _)
                b = _[0], 1 in _ && (M = _[1]);
              else
                throw y();
              C = b * M;
              break;
            }
            case "number": {
              if (_ < 0 && (C = _, _ = -_), _ % 1 === 0)
                b = _;
              else if (_ > 0) {
                for (_ >= 1 && (T = Math.pow(10, Math.floor(1 + Math.log(_) / Math.LN10)), _ /= T); F <= G && O <= G; )
                  if (I = (R + z) / (F + O), _ === I) {
                    F + O <= G ? (b = R + z, M = F + O) : O > F ? (b = z, M = O) : (b = R, M = F);
                    break;
                  } else
                    _ > I ? (R += z, F += O) : (z += R, O += F), F > G ? (b = z, M = O) : (b = R, M = F);
                b *= T;
              } else
                (isNaN(_) || isNaN($)) && (M = b = NaN);
              break;
            }
            case "string": {
              if (F = _.match(/\d+|./g), F === null)
                throw y();
              if (F[R] === "-" ? (C = -1, R++) : F[R] === "+" && R++, F.length === R + 1 ? A = o(F[R++], C) : F[R + 1] === "." || F[R] === "." ? (F[R] !== "." && (S = o(F[R++], C)), R++, (R + 1 === F.length || F[R + 1] === "(" && F[R + 3] === ")" || F[R + 1] === "'" && F[R + 3] === "'") && (A = o(F[R], C), N = Math.pow(10, F[R].length), R++), (F[R] === "(" && F[R + 2] === ")" || F[R] === "'" && F[R + 2] === "'") && (D = o(F[R + 1], C), T = Math.pow(10, F[R + 1].length) - 1, R += 3)) : F[R + 1] === "/" || F[R + 1] === ":" ? (A = o(F[R], C), N = o(F[R + 2], 1), R += 3) : F[R + 3] === "/" && F[R + 1] === " " && (S = o(F[R], C), A = o(F[R + 2], C), N = o(F[R + 4], 1), R += 5), F.length <= R) {
                M = N * T, C = /* void */
                b = D + M * S + T * A;
                break;
              }
            }
            default:
              throw y();
          }
      if (M === 0)
        throw v();
      s.s = C < 0 ? -1 : 1, s.n = Math.abs(b), s.d = Math.abs(M);
    };
    function h(_, $, b) {
      for (var M = 1; $ > 0; _ = _ * _ % b, $ >>= 1)
        $ & 1 && (M = M * _ % b);
      return M;
    }
    function u(_, $) {
      for (; $ % 2 === 0; $ /= 2)
        ;
      for (; $ % 5 === 0; $ /= 5)
        ;
      if ($ === 1)
        return 0;
      for (var b = 10 % $, M = 1; b !== 1; M++)
        if (b = b * 10 % $, M > a)
          return 0;
      return M;
    }
    function p(_, $, b) {
      for (var M = 1, C = h(10, b, $), S = 0; S < 300; S++) {
        if (M === C)
          return S;
        M = M * 10 % $, C = C * 10 % $;
      }
      return 0;
    }
    function m(_, $) {
      if (!_)
        return $;
      if (!$)
        return _;
      for (; ; ) {
        if (_ %= $, !_)
          return $;
        if ($ %= _, !$)
          return _;
      }
    }
    function g(_, $) {
      if (d(_, $), this instanceof g)
        _ = m(s.d, s.n), this.s = s.s, this.n = s.n / _, this.d = s.d / _;
      else
        return c(s.s * s.n, s.d);
    }
    var v = function() {
      return new Error("Division by Zero");
    }, y = function() {
      return new Error("Invalid argument");
    }, x = function() {
      return new Error("Parameters must be integer");
    };
    g.prototype = {
      s: 1,
      n: 0,
      d: 1,
      /**
       * Calculates the absolute value
       *
       * Ex: new Fraction(-4).abs() => 4
       **/
      abs: function() {
        return c(this.n, this.d);
      },
      /**
       * Inverts the sign of the current fraction
       *
       * Ex: new Fraction(-4).neg() => 4
       **/
      neg: function() {
        return c(-this.s * this.n, this.d);
      },
      /**
       * Adds two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
       **/
      add: function(_, $) {
        return d(_, $), c(
          this.s * this.n * s.d + s.s * this.d * s.n,
          this.d * s.d
        );
      },
      /**
       * Subtracts two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
       **/
      sub: function(_, $) {
        return d(_, $), c(
          this.s * this.n * s.d - s.s * this.d * s.n,
          this.d * s.d
        );
      },
      /**
       * Multiplies two rational numbers
       *
       * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
       **/
      mul: function(_, $) {
        return d(_, $), c(
          this.s * s.s * this.n * s.n,
          this.d * s.d
        );
      },
      /**
       * Divides two rational numbers
       *
       * Ex: new Fraction("-17.(345)").inverse().div(3)
       **/
      div: function(_, $) {
        return d(_, $), c(
          this.s * s.s * this.n * s.d,
          this.d * s.n
        );
      },
      /**
       * Clones the actual object
       *
       * Ex: new Fraction("-17.(345)").clone()
       **/
      clone: function() {
        return c(this.s * this.n, this.d);
      },
      /**
       * Calculates the modulo of two rational numbers - a more precise fmod
       *
       * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
       **/
      mod: function(_, $) {
        if (isNaN(this.n) || isNaN(this.d))
          return new g(NaN);
        if (_ === void 0)
          return c(this.s * this.n % this.d, 1);
        if (d(_, $), s.n === 0 && this.d === 0)
          throw v();
        return c(
          this.s * (s.d * this.n) % (s.n * this.d),
          s.d * this.d
        );
      },
      /**
       * Calculates the fractional gcd of two rational numbers
       *
       * Ex: new Fraction(5,8).gcd(3,7) => 1/56
       */
      gcd: function(_, $) {
        return d(_, $), c(m(s.n, this.n) * m(s.d, this.d), s.d * this.d);
      },
      /**
       * Calculates the fractional lcm of two rational numbers
       *
       * Ex: new Fraction(5,8).lcm(3,7) => 15
       */
      lcm: function(_, $) {
        return d(_, $), s.n === 0 && this.n === 0 ? c(0, 1) : c(s.n * this.n, m(s.n, this.n) * m(s.d, this.d));
      },
      /**
       * Calculates the ceil of a rational number
       *
       * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
       **/
      ceil: function(_) {
        return _ = Math.pow(10, _ || 0), isNaN(this.n) || isNaN(this.d) ? new g(NaN) : c(Math.ceil(_ * this.s * this.n / this.d), _);
      },
      /**
       * Calculates the floor of a rational number
       *
       * Ex: new Fraction('4.(3)').floor() => (4 / 1)
       **/
      floor: function(_) {
        return _ = Math.pow(10, _ || 0), isNaN(this.n) || isNaN(this.d) ? new g(NaN) : c(Math.floor(_ * this.s * this.n / this.d), _);
      },
      /**
       * Rounds a rational numbers
       *
       * Ex: new Fraction('4.(3)').round() => (4 / 1)
       **/
      round: function(_) {
        return _ = Math.pow(10, _ || 0), isNaN(this.n) || isNaN(this.d) ? new g(NaN) : c(Math.round(_ * this.s * this.n / this.d), _);
      },
      /**
       * Rounds a rational number to a multiple of another rational number
       *
       * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
       **/
      roundTo: function(_, $) {
        return d(_, $), c(this.s * Math.round(this.n * s.d / (this.d * s.n)) * s.n, s.d);
      },
      /**
       * Gets the inverse of the fraction, means numerator and denominator are exchanged
       *
       * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
       **/
      inverse: function() {
        return c(this.s * this.d, this.n);
      },
      /**
       * Calculates the fraction to some rational exponent, if possible
       *
       * Ex: new Fraction(-1,2).pow(-3) => -8
       */
      pow: function(_, $) {
        if (d(_, $), s.d === 1)
          return s.s < 0 ? c(Math.pow(this.s * this.d, s.n), Math.pow(this.n, s.n)) : c(Math.pow(this.s * this.n, s.n), Math.pow(this.d, s.n));
        if (this.s < 0)
          return null;
        var b = l(this.n), M = l(this.d), C = 1, S = 1;
        for (var A in b)
          if (A !== "1") {
            if (A === "0") {
              C = 0;
              break;
            }
            if (b[A] *= s.n, b[A] % s.d === 0)
              b[A] /= s.d;
            else
              return null;
            C *= Math.pow(A, b[A]);
          }
        for (var A in M)
          if (A !== "1") {
            if (M[A] *= s.n, M[A] % s.d === 0)
              M[A] /= s.d;
            else
              return null;
            S *= Math.pow(A, M[A]);
          }
        return s.s < 0 ? c(S, C) : c(C, S);
      },
      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      equals: function(_, $) {
        return d(_, $), this.s * this.n * s.d === s.s * s.n * this.d;
      },
      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      compare: function(_, $) {
        d(_, $);
        var b = this.s * this.n * s.d - s.s * s.n * this.d;
        return (0 < b) - (b < 0);
      },
      simplify: function(_) {
        if (isNaN(this.n) || isNaN(this.d))
          return this;
        _ = _ || 1e-3;
        for (var $ = this.abs(), b = $.toContinued(), M = 1; M < b.length; M++) {
          for (var C = c(b[M - 1], 1), S = M - 2; S >= 0; S--)
            C = C.inverse().add(b[S]);
          if (Math.abs(C.sub($).valueOf()) < _)
            return C.mul(this.s);
        }
        return this;
      },
      /**
       * Check if two rational numbers are divisible
       *
       * Ex: new Fraction(19.6).divisible(1.5);
       */
      divisible: function(_, $) {
        return d(_, $), !(!(s.n * this.d) || this.n * s.d % (s.n * this.d));
      },
      /**
       * Returns a decimal representation of the fraction
       *
       * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
       **/
      valueOf: function() {
        return this.s * this.n / this.d;
      },
      /**
       * Returns a string-fraction representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
       **/
      toFraction: function(_) {
        var $, b = "", M = this.n, C = this.d;
        return this.s < 0 && (b += "-"), C === 1 ? b += M : (_ && ($ = Math.floor(M / C)) > 0 && (b += $, b += " ", M %= C), b += M, b += "/", b += C), b;
      },
      /**
       * Returns a latex representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
       **/
      toLatex: function(_) {
        var $, b = "", M = this.n, C = this.d;
        return this.s < 0 && (b += "-"), C === 1 ? b += M : (_ && ($ = Math.floor(M / C)) > 0 && (b += $, M %= C), b += "\\frac{", b += M, b += "}{", b += C, b += "}"), b;
      },
      /**
       * Returns an array of continued fraction elements
       *
       * Ex: new Fraction("7/8").toContinued() => [0,1,7]
       */
      toContinued: function() {
        var _, $ = this.n, b = this.d, M = [];
        if (isNaN($) || isNaN(b))
          return M;
        do
          M.push(Math.floor($ / b)), _ = $ % b, $ = b, b = _;
        while ($ !== 1);
        return M;
      },
      /**
       * Creates a string representation of a fraction with all digits
       *
       * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
       **/
      toString: function(_) {
        var $ = this.n, b = this.d;
        if (isNaN($) || isNaN(b))
          return "NaN";
        _ = _ || 15;
        var M = u($, b), C = p($, b, M), S = this.s < 0 ? "-" : "";
        if (S += $ / b | 0, $ %= b, $ *= 10, $ && (S += "."), M) {
          for (var A = C; A--; )
            S += $ / b | 0, $ %= b, $ *= 10;
          S += "(";
          for (var A = M; A--; )
            S += $ / b | 0, $ %= b, $ *= 10;
          S += ")";
        } else
          for (var A = _; $ && A--; )
            S += $ / b | 0, $ %= b, $ *= 10;
        return S;
      }
    }, Object.defineProperty(r, "__esModule", { value: !0 }), r.default = g, t.exports = g;
  })();
})(fraction$2, fraction$2.exports);
var fractionExports = fraction$2.exports;
Object.defineProperty(Fraction, "__esModule", {
  value: !0
});
Fraction.createFractionClass = void 0;
var _fraction$1 = _interopRequireDefault$6(fractionExports), _factory$4o = factory$1;
function _interopRequireDefault$6(t) {
  return t && t.__esModule ? t : { default: t };
}
var name$4k = "Fraction", dependencies$4k = [], createFractionClass = /* @__PURE__ */ (0, _factory$4o.factory)(name$4k, dependencies$4k, function() {
  return _fraction$1.default.prototype.type = "Fraction", _fraction$1.default.prototype.isFraction = !0, _fraction$1.default.prototype.toJSON = function() {
    return {
      mathjs: "Fraction",
      n: this.s * this.n,
      d: this.d
    };
  }, _fraction$1.default.fromJSON = function(t) {
    return new _fraction$1.default(t);
  }, _fraction$1.default;
}, {
  isClass: !0
});
Fraction.createFractionClass = createFractionClass;
var Range = {};
Object.defineProperty(Range, "__esModule", {
  value: !0
});
Range.createRangeClass = void 0;
var _is$1i = is, _number$E = number$3, _factory$4n = factory$1, name$4j = "Range", dependencies$4j = [], createRangeClass = /* @__PURE__ */ (0, _factory$4n.factory)(name$4j, dependencies$4j, function() {
  function t(r, n, a) {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
    var s = r != null, o = n != null, c = a != null;
    if (s) {
      if ((0, _is$1i.isBigNumber)(r))
        r = r.toNumber();
      else if (typeof r != "number")
        throw new TypeError("Parameter start must be a number");
    }
    if (o) {
      if ((0, _is$1i.isBigNumber)(n))
        n = n.toNumber();
      else if (typeof n != "number")
        throw new TypeError("Parameter end must be a number");
    }
    if (c) {
      if ((0, _is$1i.isBigNumber)(a))
        a = a.toNumber();
      else if (typeof a != "number")
        throw new TypeError("Parameter step must be a number");
    }
    this.start = s ? parseFloat(r) : 0, this.end = o ? parseFloat(n) : 0, this.step = c ? parseFloat(a) : 1;
  }
  return t.prototype.type = "Range", t.prototype.isRange = !0, t.parse = function(r) {
    if (typeof r != "string")
      return null;
    var n = r.split(":"), a = n.map(function(o) {
      return parseFloat(o);
    }), s = a.some(function(o) {
      return isNaN(o);
    });
    if (s)
      return null;
    switch (a.length) {
      case 2:
        return new t(a[0], a[1]);
      case 3:
        return new t(a[0], a[2], a[1]);
      default:
        return null;
    }
  }, t.prototype.clone = function() {
    return new t(this.start, this.end, this.step);
  }, t.prototype.size = function() {
    var r = 0, n = this.start, a = this.step, s = this.end, o = s - n;
    return (0, _number$E.sign)(a) === (0, _number$E.sign)(o) ? r = Math.ceil(o / a) : o === 0 && (r = 0), isNaN(r) && (r = 0), [r];
  }, t.prototype.min = function() {
    var r = this.size()[0];
    if (r > 0)
      return this.step > 0 ? this.start : this.start + (r - 1) * this.step;
  }, t.prototype.max = function() {
    var r = this.size()[0];
    if (r > 0)
      return this.step > 0 ? this.start + (r - 1) * this.step : this.start;
  }, t.prototype.forEach = function(r) {
    var n = this.start, a = this.step, s = this.end, o = 0;
    if (a > 0)
      for (; n < s; )
        r(n, [o], this), n += a, o++;
    else if (a < 0)
      for (; n > s; )
        r(n, [o], this), n += a, o++;
  }, t.prototype.map = function(r) {
    var n = [];
    return this.forEach(function(a, s, o) {
      n[s[0]] = r(a, s, o);
    }), n;
  }, t.prototype.toArray = function() {
    var r = [];
    return this.forEach(function(n, a) {
      r[a[0]] = n;
    }), r;
  }, t.prototype.valueOf = function() {
    return this.toArray();
  }, t.prototype.format = function(r) {
    var n = (0, _number$E.format)(this.start, r);
    return this.step !== 1 && (n += ":" + (0, _number$E.format)(this.step, r)), n += ":" + (0, _number$E.format)(this.end, r), n;
  }, t.prototype.toString = function() {
    return this.format();
  }, t.prototype.toJSON = function() {
    return {
      mathjs: "Range",
      start: this.start,
      end: this.end,
      step: this.step
    };
  }, t.fromJSON = function(r) {
    return new t(r.start, r.end, r.step);
  }, t;
}, {
  isClass: !0
});
Range.createRangeClass = createRangeClass;
var Matrix = {};
Object.defineProperty(Matrix, "__esModule", {
  value: !0
});
Matrix.createMatrixClass = void 0;
var _factory$4m = factory$1, name$4i = "Matrix", dependencies$4i = [], createMatrixClass = /* @__PURE__ */ (0, _factory$4m.factory)(name$4i, dependencies$4i, function() {
  function t() {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  return t.prototype.type = "Matrix", t.prototype.isMatrix = !0, t.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, t.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, t.prototype.create = function(r, n) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, t.prototype.subset = function(r, n, a) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, t.prototype.get = function(r) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, t.prototype.set = function(r, n, a) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, t.prototype.resize = function(r, n) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, t.prototype.reshape = function(r, n) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, t.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, t.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, t.prototype.map = function(r, n) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, t.prototype.forEach = function(r) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, t.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, t.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, t.prototype.format = function(r) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, t.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, t;
}, {
  isClass: !0
});
Matrix.createMatrixClass = createMatrixClass;
var DenseMatrix = {};
Object.defineProperty(DenseMatrix, "__esModule", {
  value: !0
});
DenseMatrix.createDenseMatrixClass = void 0;
var _is$1h = is, _array$T = array, _string$p = string$2, _number$D = number$3, _object$A = object, _DimensionError$g = DimensionError$1, _factory$4l = factory$1, name$4h = "DenseMatrix", dependencies$4h = ["Matrix"], createDenseMatrixClass = /* @__PURE__ */ (0, _factory$4l.factory)(name$4h, dependencies$4h, function(t) {
  var r = t.Matrix;
  function n(u, p) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (p && !(0, _is$1h.isString)(p))
      throw new Error("Invalid datatype: " + p);
    if ((0, _is$1h.isMatrix)(u))
      u.type === "DenseMatrix" ? (this._data = (0, _object$A.clone)(u._data), this._size = (0, _object$A.clone)(u._size), this._datatype = p || u._datatype) : (this._data = u.toArray(), this._size = u.size(), this._datatype = p || u._datatype);
    else if (u && (0, _is$1h.isArray)(u.data) && (0, _is$1h.isArray)(u.size))
      this._data = u.data, this._size = u.size, (0, _array$T.validate)(this._data, this._size), this._datatype = p || u.datatype;
    else if ((0, _is$1h.isArray)(u))
      this._data = h(u), this._size = (0, _array$T.arraySize)(this._data), (0, _array$T.validate)(this._data, this._size), this._datatype = p;
    else {
      if (u)
        throw new TypeError("Unsupported type of data (" + (0, _is$1h.typeOf)(u) + ")");
      this._data = [], this._size = [0], this._datatype = p;
    }
  }
  n.prototype = new r(), n.prototype.createDenseMatrix = function(u, p) {
    return new n(u, p);
  }, n.prototype.type = "DenseMatrix", n.prototype.isDenseMatrix = !0, n.prototype.getDataType = function() {
    return (0, _array$T.getArrayDataType)(this._data, _is$1h.typeOf);
  }, n.prototype.storage = function() {
    return "dense";
  }, n.prototype.datatype = function() {
    return this._datatype;
  }, n.prototype.create = function(u, p) {
    return new n(u, p);
  }, n.prototype.subset = function(u, p, m) {
    switch (arguments.length) {
      case 1:
        return a(this, u);
      case 2:
      case 3:
        return o(this, u, p, m);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.get = function(u) {
    if (!(0, _is$1h.isArray)(u))
      throw new TypeError("Array expected");
    if (u.length !== this._size.length)
      throw new _DimensionError$g.DimensionError(u.length, this._size.length);
    for (var p = 0; p < u.length; p++)
      (0, _array$T.validateIndex)(u[p], this._size[p]);
    for (var m = this._data, g = 0, v = u.length; g < v; g++) {
      var y = u[g];
      (0, _array$T.validateIndex)(y, m.length), m = m[y];
    }
    return m;
  }, n.prototype.set = function(u, p, m) {
    if (!(0, _is$1h.isArray)(u))
      throw new TypeError("Array expected");
    if (u.length < this._size.length)
      throw new _DimensionError$g.DimensionError(u.length, this._size.length, "<");
    var g, v, y, x = u.map(function($) {
      return $ + 1;
    });
    d(this, x, m);
    var _ = this._data;
    for (g = 0, v = u.length - 1; g < v; g++)
      y = u[g], (0, _array$T.validateIndex)(y, _.length), _ = _[y];
    return y = u[u.length - 1], (0, _array$T.validateIndex)(y, _.length), _[y] = p, this;
  };
  function a(u, p) {
    if (!(0, _is$1h.isIndex)(p))
      throw new TypeError("Invalid index");
    var m = p.isScalar();
    if (m)
      return u.get(p.min());
    var g = p.size();
    if (g.length !== u._size.length)
      throw new _DimensionError$g.DimensionError(g.length, u._size.length);
    for (var v = p.min(), y = p.max(), x = 0, _ = u._size.length; x < _; x++)
      (0, _array$T.validateIndex)(v[x], u._size[x]), (0, _array$T.validateIndex)(y[x], u._size[x]);
    return new n(s(u._data, p, g.length, 0), u._datatype);
  }
  function s(u, p, m, g) {
    var v = g === m - 1, y = p.dimension(g);
    return v ? y.map(function(x) {
      return (0, _array$T.validateIndex)(x, u.length), u[x];
    }).valueOf() : y.map(function(x) {
      (0, _array$T.validateIndex)(x, u.length);
      var _ = u[x];
      return s(_, p, m, g + 1);
    }).valueOf();
  }
  function o(u, p, m, g) {
    if (!p || p.isIndex !== !0)
      throw new TypeError("Invalid index");
    var v = p.size(), y = p.isScalar(), x;
    if ((0, _is$1h.isMatrix)(m) ? (x = m.size(), m = m.valueOf()) : x = (0, _array$T.arraySize)(m), y) {
      if (x.length !== 0)
        throw new TypeError("Scalar expected");
      u.set(p.min(), m, g);
    } else {
      if (v.length < u._size.length)
        throw new _DimensionError$g.DimensionError(v.length, u._size.length, "<");
      if (x.length < v.length) {
        for (var _ = 0, $ = 0; v[_] === 1 && x[_] === 1; )
          _++;
        for (; v[_] === 1; )
          $++, _++;
        m = (0, _array$T.unsqueeze)(m, v.length, $, x);
      }
      if (!(0, _object$A.deepStrictEqual)(v, x))
        throw new _DimensionError$g.DimensionError(v, x, ">");
      var b = p.max().map(function(S) {
        return S + 1;
      });
      d(u, b, g);
      var M = v.length, C = 0;
      c(u._data, p, m, M, C);
    }
    return u;
  }
  function c(u, p, m, g, v) {
    var y = v === g - 1, x = p.dimension(v);
    y ? x.forEach(function(_, $) {
      (0, _array$T.validateIndex)(_), u[_] = m[$[0]];
    }) : x.forEach(function(_, $) {
      (0, _array$T.validateIndex)(_), c(u[_], p, m[$[0]], g, v + 1);
    });
  }
  n.prototype.resize = function(u, p, m) {
    if (!(0, _is$1h.isCollection)(u))
      throw new TypeError("Array or Matrix expected");
    var g = u.valueOf().map(function(y) {
      return Array.isArray(y) && y.length === 1 ? y[0] : y;
    }), v = m ? this.clone() : this;
    return l(v, g, p);
  };
  function l(u, p, m) {
    if (p.length === 0) {
      for (var g = u._data; (0, _is$1h.isArray)(g); )
        g = g[0];
      return g;
    }
    return u._size = p.slice(0), u._data = (0, _array$T.resize)(u._data, u._size, m), u;
  }
  n.prototype.reshape = function(u, p) {
    var m = p ? this.clone() : this;
    return m._data = (0, _array$T.reshape)(m._data, u), m._size = u.slice(0), m;
  };
  function d(u, p, m) {
    for (var g = u._size.slice(0), v = !1; g.length < p.length; )
      g.push(0), v = !0;
    for (var y = 0, x = p.length; y < x; y++)
      p[y] > g[y] && (g[y] = p[y], v = !0);
    v && l(u, g, m);
  }
  n.prototype.clone = function() {
    var u = new n({
      data: (0, _object$A.clone)(this._data),
      size: (0, _object$A.clone)(this._size),
      datatype: this._datatype
    });
    return u;
  }, n.prototype.size = function() {
    return this._size.slice(0);
  }, n.prototype.map = function(u) {
    var p = this, m = function y(x, _) {
      return (0, _is$1h.isArray)(x) ? x.map(function($, b) {
        return y($, _.concat(b));
      }) : u(x, _, p);
    }, g = m(this._data, []), v = this._datatype !== void 0 ? (0, _array$T.getArrayDataType)(g, _is$1h.typeOf) : void 0;
    return new n(g, v);
  }, n.prototype.forEach = function(u) {
    var p = this, m = function g(v, y) {
      (0, _is$1h.isArray)(v) ? v.forEach(function(x, _) {
        g(x, y.concat(_));
      }) : u(v, y, p);
    };
    m(this._data, []);
  }, n.prototype.toArray = function() {
    return (0, _object$A.clone)(this._data);
  }, n.prototype.valueOf = function() {
    return this._data;
  }, n.prototype.format = function(u) {
    return (0, _string$p.format)(this._data, u);
  }, n.prototype.toString = function() {
    return (0, _string$p.format)(this._data);
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "DenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, n.prototype.diagonal = function(u) {
    if (u) {
      if ((0, _is$1h.isBigNumber)(u) && (u = u.toNumber()), !(0, _is$1h.isNumber)(u) || !(0, _number$D.isInteger)(u))
        throw new TypeError("The parameter k must be an integer number");
    } else
      u = 0;
    for (var p = u > 0 ? u : 0, m = u < 0 ? -u : 0, g = this._size[0], v = this._size[1], y = Math.min(g - m, v - p), x = [], _ = 0; _ < y; _++)
      x[_] = this._data[_ + m][_ + p];
    return new n({
      data: x,
      size: [y],
      datatype: this._datatype
    });
  }, n.diagonal = function(u, p, m, g) {
    if (!(0, _is$1h.isArray)(u))
      throw new TypeError("Array expected, size parameter");
    if (u.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (u = u.map(function(A) {
      if ((0, _is$1h.isBigNumber)(A) && (A = A.toNumber()), !(0, _is$1h.isNumber)(A) || !(0, _number$D.isInteger)(A) || A < 1)
        throw new Error("Size values must be positive integers");
      return A;
    }), m) {
      if ((0, _is$1h.isBigNumber)(m) && (m = m.toNumber()), !(0, _is$1h.isNumber)(m) || !(0, _number$D.isInteger)(m))
        throw new TypeError("The parameter k must be an integer number");
    } else
      m = 0;
    var v = m > 0 ? m : 0, y = m < 0 ? -m : 0, x = u[0], _ = u[1], $ = Math.min(x - y, _ - v), b;
    if ((0, _is$1h.isArray)(p)) {
      if (p.length !== $)
        throw new Error("Invalid value array length");
      b = function(D) {
        return p[D];
      };
    } else if ((0, _is$1h.isMatrix)(p)) {
      var M = p.size();
      if (M.length !== 1 || M[0] !== $)
        throw new Error("Invalid matrix length");
      b = function(D) {
        return p.get([D]);
      };
    } else
      b = function() {
        return p;
      };
    g || (g = (0, _is$1h.isBigNumber)(b(0)) ? b(0).mul(0) : 0);
    var C = [];
    if (u.length > 0) {
      C = (0, _array$T.resize)(C, u, g);
      for (var S = 0; S < $; S++)
        C[S + y][S + v] = b(S);
    }
    return new n({
      data: C,
      size: [x, _]
    });
  }, n.fromJSON = function(u) {
    return new n(u);
  }, n.prototype.swapRows = function(u, p) {
    if (!(0, _is$1h.isNumber)(u) || !(0, _number$D.isInteger)(u) || !(0, _is$1h.isNumber)(p) || !(0, _number$D.isInteger)(p))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return (0, _array$T.validateIndex)(u, this._size[0]), (0, _array$T.validateIndex)(p, this._size[0]), n._swapRows(u, p, this._data), this;
  }, n._swapRows = function(u, p, m) {
    var g = m[u];
    m[u] = m[p], m[p] = g;
  };
  function h(u) {
    for (var p = 0, m = u.length; p < m; p++) {
      var g = u[p];
      (0, _is$1h.isArray)(g) ? u[p] = h(g) : g && g.isMatrix === !0 && (u[p] = h(g.valueOf()));
    }
    return u;
  }
  return n;
}, {
  isClass: !0
});
DenseMatrix.createDenseMatrixClass = createDenseMatrixClass;
var clone$3 = {};
Object.defineProperty(clone$3, "__esModule", {
  value: !0
});
clone$3.createClone = void 0;
var _object$z = object, _factory$4k = factory$1, name$4g = "clone", dependencies$4g = ["typed"], createClone = /* @__PURE__ */ (0, _factory$4k.factory)(name$4g, dependencies$4g, function(t) {
  var r = t.typed;
  return r(name$4g, {
    any: _object$z.clone
  });
});
clone$3.createClone = createClone;
var isInteger$1 = {}, collection$1 = {};
Object.defineProperty(collection$1, "__esModule", {
  value: !0
});
collection$1.containsCollections = containsCollections;
collection$1.deepForEach = deepForEach;
collection$1.deepMap = deepMap;
collection$1.reduce = reduce;
collection$1.scatter = scatter;
var _is$1g = is, _IndexError$4 = IndexError$1, _array$S = array;
function containsCollections(t) {
  for (var r = 0; r < t.length; r++)
    if ((0, _is$1g.isCollection)(t[r]))
      return !0;
  return !1;
}
function deepForEach(t, r) {
  (0, _is$1g.isMatrix)(t) && (t = t.valueOf());
  for (var n = 0, a = t.length; n < a; n++) {
    var s = t[n];
    Array.isArray(s) ? deepForEach(s, r) : r(s);
  }
}
function deepMap(t, r, n) {
  return t && typeof t.map == "function" ? t.map(function(a) {
    return deepMap(a, r);
  }) : r(t);
}
function reduce(t, r, n) {
  var a = Array.isArray(t) ? (0, _array$S.arraySize)(t) : t.size();
  if (r < 0 || r >= a.length)
    throw new _IndexError$4.IndexError(r, a.length);
  return (0, _is$1g.isMatrix)(t) ? t.create(_reduce(t.valueOf(), r, n)) : _reduce(t, r, n);
}
function _reduce(t, r, n) {
  var a, s, o, c;
  if (r <= 0)
    if (Array.isArray(t[0])) {
      for (c = _switch$1(t), s = [], a = 0; a < c.length; a++)
        s[a] = _reduce(c[a], r - 1, n);
      return s;
    } else {
      for (o = t[0], a = 1; a < t.length; a++)
        o = n(o, t[a]);
      return o;
    }
  else {
    for (s = [], a = 0; a < t.length; a++)
      s[a] = _reduce(t[a], r - 1, n);
    return s;
  }
}
function _switch$1(t) {
  var r = t.length, n = t[0].length, a, s, o = [];
  for (s = 0; s < n; s++) {
    var c = [];
    for (a = 0; a < r; a++)
      c.push(t[a][s]);
    o.push(c);
  }
  return o;
}
function scatter(t, r, n, a, s, o, c, l, d, h, u) {
  var p = t._values, m = t._index, g = t._ptr, v, y, x, _;
  if (a)
    for (y = g[r], x = g[r + 1], v = y; v < x; v++)
      _ = m[v], n[_] !== o ? (n[_] = o, c.push(_), h ? (a[_] = d ? l(p[v], u) : l(u, p[v]), s[_] = o) : a[_] = p[v]) : (a[_] = d ? l(p[v], a[_]) : l(a[_], p[v]), s[_] = o);
  else
    for (y = g[r], x = g[r + 1], v = y; v < x; v++)
      _ = m[v], n[_] !== o ? (n[_] = o, c.push(_)) : s[_] = o;
}
Object.defineProperty(isInteger$1, "__esModule", {
  value: !0
});
isInteger$1.createIsInteger = void 0;
var _collection$1c = collection$1, _number$C = number$3, _factory$4j = factory$1, name$4f = "isInteger", dependencies$4f = ["typed"], createIsInteger = /* @__PURE__ */ (0, _factory$4j.factory)(name$4f, dependencies$4f, function(t) {
  var r = t.typed;
  return r(name$4f, {
    number: _number$C.isInteger,
    // TODO: what to do with isInteger(add(0.1, 0.2))  ?
    BigNumber: function(a) {
      return a.isInt();
    },
    Fraction: function(a) {
      return a.d === 1 && isFinite(a.n);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$1c.deepMap)(a, this);
    }
  });
});
isInteger$1.createIsInteger = createIsInteger;
var isNegative$1 = {}, number$2 = {}, arithmetic$1 = {};
Object.defineProperty(arithmetic$1, "__esModule", {
  value: !0
});
arithmetic$1.absNumber = absNumber;
arithmetic$1.addNumber = addNumber;
arithmetic$1.subtractNumber = subtractNumber;
arithmetic$1.multiplyNumber = multiplyNumber;
arithmetic$1.divideNumber = divideNumber;
arithmetic$1.unaryMinusNumber = unaryMinusNumber;
arithmetic$1.unaryPlusNumber = unaryPlusNumber;
arithmetic$1.cbrtNumber = cbrtNumber;
arithmetic$1.ceilNumber = ceilNumber;
arithmetic$1.cubeNumber = cubeNumber;
arithmetic$1.expNumber = expNumber;
arithmetic$1.expm1Number = expm1Number;
arithmetic$1.fixNumber = fixNumber;
arithmetic$1.floorNumber = floorNumber;
arithmetic$1.gcdNumber = gcdNumber;
arithmetic$1.lcmNumber = lcmNumber;
arithmetic$1.logNumber = logNumber;
arithmetic$1.log10Number = log10Number;
arithmetic$1.log2Number = log2Number;
arithmetic$1.log1pNumber = log1pNumber;
arithmetic$1.modNumber = modNumber;
arithmetic$1.nthRootNumber = nthRootNumber;
arithmetic$1.signNumber = signNumber;
arithmetic$1.sqrtNumber = sqrtNumber;
arithmetic$1.squareNumber = squareNumber;
arithmetic$1.xgcdNumber = xgcdNumber;
arithmetic$1.powNumber = powNumber;
arithmetic$1.roundNumber = roundNumber;
arithmetic$1.normNumber = normNumber;
var _number$B = number$3, n1$4 = "number", n2$3 = "number, number";
function absNumber(t) {
  return Math.abs(t);
}
absNumber.signature = n1$4;
function addNumber(t, r) {
  return t + r;
}
addNumber.signature = n2$3;
function subtractNumber(t, r) {
  return t - r;
}
subtractNumber.signature = n2$3;
function multiplyNumber(t, r) {
  return t * r;
}
multiplyNumber.signature = n2$3;
function divideNumber(t, r) {
  return t / r;
}
divideNumber.signature = n2$3;
function unaryMinusNumber(t) {
  return -t;
}
unaryMinusNumber.signature = n1$4;
function unaryPlusNumber(t) {
  return t;
}
unaryPlusNumber.signature = n1$4;
function cbrtNumber(t) {
  return (0, _number$B.cbrt)(t);
}
cbrtNumber.signature = n1$4;
function ceilNumber(t) {
  return Math.ceil(t);
}
ceilNumber.signature = n1$4;
function cubeNumber(t) {
  return t * t * t;
}
cubeNumber.signature = n1$4;
function expNumber(t) {
  return Math.exp(t);
}
expNumber.signature = n1$4;
function expm1Number(t) {
  return (0, _number$B.expm1)(t);
}
expm1Number.signature = n1$4;
function fixNumber(t) {
  return t > 0 ? Math.floor(t) : Math.ceil(t);
}
fixNumber.signature = n1$4;
function floorNumber(t) {
  return Math.floor(t);
}
floorNumber.signature = n1$4;
function gcdNumber(t, r) {
  if (!(0, _number$B.isInteger)(t) || !(0, _number$B.isInteger)(r))
    throw new Error("Parameters in function gcd must be integer numbers");
  for (var n; r !== 0; )
    n = t % r, t = r, r = n;
  return t < 0 ? -t : t;
}
gcdNumber.signature = n2$3;
function lcmNumber(t, r) {
  if (!(0, _number$B.isInteger)(t) || !(0, _number$B.isInteger)(r))
    throw new Error("Parameters in function lcm must be integer numbers");
  if (t === 0 || r === 0)
    return 0;
  for (var n, a = t * r; r !== 0; )
    n = r, r = t % n, t = n;
  return Math.abs(a / t);
}
lcmNumber.signature = n2$3;
function logNumber(t) {
  return Math.log(t);
}
logNumber.signature = n1$4;
function log10Number(t) {
  return (0, _number$B.log10)(t);
}
log10Number.signature = n1$4;
function log2Number(t) {
  return (0, _number$B.log2)(t);
}
log2Number.signature = n1$4;
function log1pNumber(t) {
  return (0, _number$B.log1p)(t);
}
log1pNumber.signature = n1$4;
function modNumber(t, r) {
  if (r > 0)
    return t - r * Math.floor(t / r);
  if (r === 0)
    return t;
  throw new Error("Cannot calculate mod for a negative divisor");
}
modNumber.signature = n2$3;
function nthRootNumber(t, r) {
  var n = r < 0;
  if (n && (r = -r), r === 0)
    throw new Error("Root must be non-zero");
  if (t < 0 && Math.abs(r) % 2 !== 1)
    throw new Error("Root must be odd when a is negative.");
  if (t === 0)
    return n ? 1 / 0 : 0;
  if (!isFinite(t))
    return n ? 0 : t;
  var a = Math.pow(Math.abs(t), 1 / r);
  return a = t < 0 ? -a : a, n ? 1 / a : a;
}
nthRootNumber.signature = n2$3;
function signNumber(t) {
  return (0, _number$B.sign)(t);
}
signNumber.signature = n1$4;
function sqrtNumber(t) {
  return Math.sqrt(t);
}
sqrtNumber.signature = n1$4;
function squareNumber(t) {
  return t * t;
}
squareNumber.signature = n1$4;
function xgcdNumber(t, r) {
  var n, a, s, o = 0, c = 1, l = 1, d = 0;
  if (!(0, _number$B.isInteger)(t) || !(0, _number$B.isInteger)(r))
    throw new Error("Parameters in function xgcd must be integer numbers");
  for (; r; )
    a = Math.floor(t / r), s = t - a * r, n = o, o = c - a * o, c = n, n = l, l = d - a * l, d = n, t = r, r = s;
  var h;
  return t < 0 ? h = [-t, -c, -d] : h = [t, t ? c : 0, d], h;
}
xgcdNumber.signature = n2$3;
function powNumber(t, r) {
  return t * t < 1 && r === 1 / 0 || t * t > 1 && r === -1 / 0 ? 0 : Math.pow(t, r);
}
powNumber.signature = n2$3;
function roundNumber(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return parseFloat((0, _number$B.toFixed)(t, r));
}
roundNumber.signature = n2$3;
function normNumber(t) {
  return Math.abs(t);
}
normNumber.signature = n1$4;
var bitwise$2 = {};
Object.defineProperty(bitwise$2, "__esModule", {
  value: !0
});
bitwise$2.bitAndNumber = bitAndNumber;
bitwise$2.bitNotNumber = bitNotNumber;
bitwise$2.bitOrNumber = bitOrNumber;
bitwise$2.bitXorNumber = bitXorNumber;
bitwise$2.leftShiftNumber = leftShiftNumber;
bitwise$2.rightArithShiftNumber = rightArithShiftNumber;
bitwise$2.rightLogShiftNumber = rightLogShiftNumber;
var _number$A = number$3, n1$3 = "number", n2$2 = "number, number";
function bitAndNumber(t, r) {
  if (!(0, _number$A.isInteger)(t) || !(0, _number$A.isInteger)(r))
    throw new Error("Integers expected in function bitAnd");
  return t & r;
}
bitAndNumber.signature = n2$2;
function bitNotNumber(t) {
  if (!(0, _number$A.isInteger)(t))
    throw new Error("Integer expected in function bitNot");
  return ~t;
}
bitNotNumber.signature = n1$3;
function bitOrNumber(t, r) {
  if (!(0, _number$A.isInteger)(t) || !(0, _number$A.isInteger)(r))
    throw new Error("Integers expected in function bitOr");
  return t | r;
}
bitOrNumber.signature = n2$2;
function bitXorNumber(t, r) {
  if (!(0, _number$A.isInteger)(t) || !(0, _number$A.isInteger)(r))
    throw new Error("Integers expected in function bitXor");
  return t ^ r;
}
bitXorNumber.signature = n2$2;
function leftShiftNumber(t, r) {
  if (!(0, _number$A.isInteger)(t) || !(0, _number$A.isInteger)(r))
    throw new Error("Integers expected in function leftShift");
  return t << r;
}
leftShiftNumber.signature = n2$2;
function rightArithShiftNumber(t, r) {
  if (!(0, _number$A.isInteger)(t) || !(0, _number$A.isInteger)(r))
    throw new Error("Integers expected in function rightArithShift");
  return t >> r;
}
rightArithShiftNumber.signature = n2$2;
function rightLogShiftNumber(t, r) {
  if (!(0, _number$A.isInteger)(t) || !(0, _number$A.isInteger)(r))
    throw new Error("Integers expected in function rightLogShift");
  return t >>> r;
}
rightLogShiftNumber.signature = n2$2;
var combinations$2 = {}, product$1 = {};
Object.defineProperty(product$1, "__esModule", {
  value: !0
});
product$1.product = product;
function product(t, r) {
  if (r < t)
    return 1;
  if (r === t)
    return r;
  var n = r + t >> 1;
  return product(t, n) * product(n + 1, r);
}
Object.defineProperty(combinations$2, "__esModule", {
  value: !0
});
combinations$2.combinationsNumber = combinationsNumber;
var _number$z = number$3, _product$3 = product$1;
function combinationsNumber(t, r) {
  if (!(0, _number$z.isInteger)(t) || t < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (!(0, _number$z.isInteger)(r) || r < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (r > t)
    throw new TypeError("k must be less than or equal to n");
  var n = t - r, a;
  return r < n ? (a = (0, _product$3.product)(n + 1, t), a / (0, _product$3.product)(1, r)) : (a = (0, _product$3.product)(r + 1, t), a / (0, _product$3.product)(1, n));
}
combinationsNumber.signature = "number, number";
var constants$3 = {};
Object.defineProperty(constants$3, "__esModule", {
  value: !0
});
constants$3.phi = constants$3.e = constants$3.tau = constants$3.pi = void 0;
var pi$1 = Math.PI;
constants$3.pi = pi$1;
var tau$1 = 2 * Math.PI;
constants$3.tau = tau$1;
var e$1 = Math.E;
constants$3.e = e$1;
var phi$1 = 1.618033988749895;
constants$3.phi = phi$1;
var logical$1 = {};
Object.defineProperty(logical$1, "__esModule", {
  value: !0
});
logical$1.notNumber = notNumber;
logical$1.orNumber = orNumber;
logical$1.xorNumber = xorNumber;
logical$1.andNumber = andNumber;
var n1$2 = "number", n2$1 = "number, number";
function notNumber(t) {
  return !t;
}
notNumber.signature = n1$2;
function orNumber(t, r) {
  return !!(t || r);
}
orNumber.signature = n2$1;
function xorNumber(t, r) {
  return !!t != !!r;
}
xorNumber.signature = n2$1;
function andNumber(t, r) {
  return !!(t && r);
}
andNumber.signature = n2$1;
var relational$1 = {}, probability = {};
Object.defineProperty(probability, "__esModule", {
  value: !0
});
probability.gammaNumber = gammaNumber;
probability.gammaP = probability.gammaG = void 0;
var _number$y = number$3, _product$2 = product$1;
function gammaNumber(t) {
  var r;
  if ((0, _number$y.isInteger)(t))
    return t <= 0 ? isFinite(t) ? 1 / 0 : NaN : t > 171 ? 1 / 0 : (0, _product$2.product)(1, t - 1);
  if (t < 0.5)
    return Math.PI / (Math.sin(Math.PI * t) * gammaNumber(1 - t));
  if (t >= 171.35)
    return 1 / 0;
  if (t > 85) {
    var n = t * t, a = n * t, s = a * t, o = s * t;
    return Math.sqrt(2 * Math.PI / t) * Math.pow(t / Math.E, t) * (1 + 1 / (12 * t) + 1 / (288 * n) - 139 / (51840 * a) - 571 / (2488320 * s) + 163879 / (209018880 * o) + 5246819 / (75246796800 * o * t));
  }
  --t, r = gammaP[0];
  for (var c = 1; c < gammaP.length; ++c)
    r += gammaP[c] / (t + c);
  var l = t + gammaG + 0.5;
  return Math.sqrt(2 * Math.PI) * Math.pow(l, t + 0.5) * Math.exp(-l) * r;
}
gammaNumber.signature = "number";
var gammaG = 4.7421875;
probability.gammaG = gammaG;
var gammaP = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22];
probability.gammaP = gammaP;
var trigonometry = {};
Object.defineProperty(trigonometry, "__esModule", {
  value: !0
});
trigonometry.acosNumber = acosNumber;
trigonometry.acoshNumber = acoshNumber;
trigonometry.acotNumber = acotNumber;
trigonometry.acothNumber = acothNumber;
trigonometry.acscNumber = acscNumber;
trigonometry.acschNumber = acschNumber;
trigonometry.asecNumber = asecNumber;
trigonometry.asechNumber = asechNumber;
trigonometry.asinNumber = asinNumber;
trigonometry.asinhNumber = asinhNumber;
trigonometry.atanNumber = atanNumber;
trigonometry.atan2Number = atan2Number;
trigonometry.atanhNumber = atanhNumber;
trigonometry.cosNumber = cosNumber;
trigonometry.coshNumber = coshNumber;
trigonometry.cotNumber = cotNumber;
trigonometry.cothNumber = cothNumber;
trigonometry.cscNumber = cscNumber;
trigonometry.cschNumber = cschNumber;
trigonometry.secNumber = secNumber;
trigonometry.sechNumber = sechNumber;
trigonometry.sinNumber = sinNumber;
trigonometry.sinhNumber = sinhNumber;
trigonometry.tanNumber = tanNumber;
trigonometry.tanhNumber = tanhNumber;
var _number$x = number$3, n1$1 = "number", n2 = "number, number";
function acosNumber(t) {
  return Math.acos(t);
}
acosNumber.signature = n1$1;
function acoshNumber(t) {
  return (0, _number$x.acosh)(t);
}
acoshNumber.signature = n1$1;
function acotNumber(t) {
  return Math.atan(1 / t);
}
acotNumber.signature = n1$1;
function acothNumber(t) {
  return isFinite(t) ? (Math.log((t + 1) / t) + Math.log(t / (t - 1))) / 2 : 0;
}
acothNumber.signature = n1$1;
function acscNumber(t) {
  return Math.asin(1 / t);
}
acscNumber.signature = n1$1;
function acschNumber(t) {
  var r = 1 / t;
  return Math.log(r + Math.sqrt(r * r + 1));
}
acschNumber.signature = n1$1;
function asecNumber(t) {
  return Math.acos(1 / t);
}
asecNumber.signature = n1$1;
function asechNumber(t) {
  var r = 1 / t, n = Math.sqrt(r * r - 1);
  return Math.log(n + r);
}
asechNumber.signature = n1$1;
function asinNumber(t) {
  return Math.asin(t);
}
asinNumber.signature = n1$1;
function asinhNumber(t) {
  return (0, _number$x.asinh)(t);
}
asinhNumber.signature = n1$1;
function atanNumber(t) {
  return Math.atan(t);
}
atanNumber.signature = n1$1;
function atan2Number(t, r) {
  return Math.atan2(t, r);
}
atan2Number.signature = n2;
function atanhNumber(t) {
  return (0, _number$x.atanh)(t);
}
atanhNumber.signature = n1$1;
function cosNumber(t) {
  return Math.cos(t);
}
cosNumber.signature = n1$1;
function coshNumber(t) {
  return (0, _number$x.cosh)(t);
}
coshNumber.signature = n1$1;
function cotNumber(t) {
  return 1 / Math.tan(t);
}
cotNumber.signature = n1$1;
function cothNumber(t) {
  var r = Math.exp(2 * t);
  return (r + 1) / (r - 1);
}
cothNumber.signature = n1$1;
function cscNumber(t) {
  return 1 / Math.sin(t);
}
cscNumber.signature = n1$1;
function cschNumber(t) {
  return t === 0 ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(t) - Math.exp(-t))) * (0, _number$x.sign)(t);
}
cschNumber.signature = n1$1;
function secNumber(t) {
  return 1 / Math.cos(t);
}
secNumber.signature = n1$1;
function sechNumber(t) {
  return 2 / (Math.exp(t) + Math.exp(-t));
}
sechNumber.signature = n1$1;
function sinNumber(t) {
  return Math.sin(t);
}
sinNumber.signature = n1$1;
function sinhNumber(t) {
  return (0, _number$x.sinh)(t);
}
sinhNumber.signature = n1$1;
function tanNumber(t) {
  return Math.tan(t);
}
tanNumber.signature = n1$1;
function tanhNumber(t) {
  return (0, _number$x.tanh)(t);
}
tanhNumber.signature = n1$1;
var utils$7 = {};
Object.defineProperty(utils$7, "__esModule", {
  value: !0
});
utils$7.isIntegerNumber = isIntegerNumber;
utils$7.isNegativeNumber = isNegativeNumber;
utils$7.isPositiveNumber = isPositiveNumber;
utils$7.isZeroNumber = isZeroNumber;
utils$7.isNaNNumber = isNaNNumber;
var _number$w = number$3, n1 = "number";
function isIntegerNumber(t) {
  return (0, _number$w.isInteger)(t);
}
isIntegerNumber.signature = n1;
function isNegativeNumber(t) {
  return t < 0;
}
isNegativeNumber.signature = n1;
function isPositiveNumber(t) {
  return t > 0;
}
isPositiveNumber.signature = n1;
function isZeroNumber(t) {
  return t === 0;
}
isZeroNumber.signature = n1;
function isNaNNumber(t) {
  return Number.isNaN(t);
}
isNaNNumber.signature = n1;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = arithmetic$1;
  Object.keys(r).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === r[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return r[u];
      }
    });
  });
  var n = bitwise$2;
  Object.keys(n).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === n[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return n[u];
      }
    });
  });
  var a = combinations$2;
  Object.keys(a).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === a[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return a[u];
      }
    });
  });
  var s = constants$3;
  Object.keys(s).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === s[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return s[u];
      }
    });
  });
  var o = logical$1;
  Object.keys(o).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === o[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return o[u];
      }
    });
  });
  var c = relational$1;
  Object.keys(c).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === c[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return c[u];
      }
    });
  });
  var l = probability;
  Object.keys(l).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === l[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return l[u];
      }
    });
  });
  var d = trigonometry;
  Object.keys(d).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === d[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return d[u];
      }
    });
  });
  var h = utils$7;
  Object.keys(h).forEach(function(u) {
    u === "default" || u === "__esModule" || u in t && t[u] === h[u] || Object.defineProperty(t, u, {
      enumerable: !0,
      get: function() {
        return h[u];
      }
    });
  });
})(number$2);
Object.defineProperty(isNegative$1, "__esModule", {
  value: !0
});
isNegative$1.createIsNegative = void 0;
var _collection$1b = collection$1, _factory$4i = factory$1, _index$T = number$2, name$4e = "isNegative", dependencies$4e = ["typed"], createIsNegative = /* @__PURE__ */ (0, _factory$4i.factory)(name$4e, dependencies$4e, function(t) {
  var r = t.typed;
  return r(name$4e, {
    number: _index$T.isNegativeNumber,
    BigNumber: function(a) {
      return a.isNeg() && !a.isZero() && !a.isNaN();
    },
    Fraction: function(a) {
      return a.s < 0;
    },
    Unit: function(a) {
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$1b.deepMap)(a, this);
    }
  });
});
isNegative$1.createIsNegative = createIsNegative;
var isNumeric$1 = {};
Object.defineProperty(isNumeric$1, "__esModule", {
  value: !0
});
isNumeric$1.createIsNumeric = void 0;
var _collection$1a = collection$1, _factory$4h = factory$1, name$4d = "isNumeric", dependencies$4d = ["typed"], createIsNumeric = /* @__PURE__ */ (0, _factory$4h.factory)(name$4d, dependencies$4d, function(t) {
  var r = t.typed;
  return r(name$4d, {
    "number | BigNumber | Fraction | boolean": function() {
      return !0;
    },
    "Complex | Unit | string | null | undefined | Node": function() {
      return !1;
    },
    "Array | Matrix": function(a) {
      return (0, _collection$1a.deepMap)(a, this);
    }
  });
});
isNumeric$1.createIsNumeric = createIsNumeric;
var hasNumericValue$1 = {};
Object.defineProperty(hasNumericValue$1, "__esModule", {
  value: !0
});
hasNumericValue$1.createHasNumericValue = void 0;
var _factory$4g = factory$1, name$4c = "hasNumericValue", dependencies$4c = ["typed", "isNumeric"], createHasNumericValue = /* @__PURE__ */ (0, _factory$4g.factory)(name$4c, dependencies$4c, function(t) {
  var r = t.typed, n = t.isNumeric;
  return r(name$4c, {
    string: function(s) {
      return s.trim().length > 0 && !isNaN(Number(s));
    },
    any: function(s) {
      return n(s);
    }
  });
});
hasNumericValue$1.createHasNumericValue = createHasNumericValue;
var isPositive$1 = {};
Object.defineProperty(isPositive$1, "__esModule", {
  value: !0
});
isPositive$1.createIsPositive = void 0;
var _collection$19 = collection$1, _factory$4f = factory$1, _index$S = number$2, name$4b = "isPositive", dependencies$4b = ["typed"], createIsPositive = /* @__PURE__ */ (0, _factory$4f.factory)(name$4b, dependencies$4b, function(t) {
  var r = t.typed;
  return r(name$4b, {
    number: _index$S.isPositiveNumber,
    BigNumber: function(a) {
      return !a.isNeg() && !a.isZero() && !a.isNaN();
    },
    Fraction: function(a) {
      return a.s > 0 && a.n > 0;
    },
    Unit: function(a) {
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$19.deepMap)(a, this);
    }
  });
});
isPositive$1.createIsPositive = createIsPositive;
var isZero$1 = {};
Object.defineProperty(isZero$1, "__esModule", {
  value: !0
});
isZero$1.createIsZero = void 0;
var _collection$18 = collection$1, _factory$4e = factory$1, _index$R = number$2, name$4a = "isZero", dependencies$4a = ["typed"], createIsZero = /* @__PURE__ */ (0, _factory$4e.factory)(name$4a, dependencies$4a, function(t) {
  var r = t.typed;
  return r(name$4a, {
    number: _index$R.isZeroNumber,
    BigNumber: function(a) {
      return a.isZero();
    },
    Complex: function(a) {
      return a.re === 0 && a.im === 0;
    },
    Fraction: function(a) {
      return a.d === 1 && a.n === 0;
    },
    Unit: function(a) {
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$18.deepMap)(a, this);
    }
  });
});
isZero$1.createIsZero = createIsZero;
var _isNaN$2 = {};
Object.defineProperty(_isNaN$2, "__esModule", {
  value: !0
});
_isNaN$2.createIsNaN = void 0;
var _collection$17 = collection$1, _factory$4d = factory$1, _index$Q = number$2, name$49 = "isNaN", dependencies$49 = ["typed"], createIsNaN = /* @__PURE__ */ (0, _factory$4d.factory)(name$49, dependencies$49, function(t) {
  var r = t.typed;
  return r(name$49, {
    number: _index$Q.isNaNNumber,
    BigNumber: function(a) {
      return a.isNaN();
    },
    Fraction: function(a) {
      return !1;
    },
    Complex: function(a) {
      return a.isNaN();
    },
    Unit: function(a) {
      return Number.isNaN(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$17.deepMap)(a, Number.isNaN);
    }
  });
});
_isNaN$2.createIsNaN = createIsNaN;
var typeOf$1 = {};
Object.defineProperty(typeOf$1, "__esModule", {
  value: !0
});
typeOf$1.createTypeOf = void 0;
var _factory$4c = factory$1, _is$1f = is, name$48 = "typeOf", dependencies$48 = ["typed"], createTypeOf = /* @__PURE__ */ (0, _factory$4c.factory)(name$48, dependencies$48, function(t) {
  var r = t.typed;
  return r(name$48, {
    any: _is$1f.typeOf
  });
});
typeOf$1.createTypeOf = createTypeOf;
var equalScalar = {}, nearlyEqual$1 = {};
Object.defineProperty(nearlyEqual$1, "__esModule", {
  value: !0
});
nearlyEqual$1.nearlyEqual = nearlyEqual;
function nearlyEqual(t, r, n) {
  if (n == null)
    return t.eq(r);
  if (t.eq(r))
    return !0;
  if (t.isNaN() || r.isNaN())
    return !1;
  if (t.isFinite() && r.isFinite()) {
    var a = t.minus(r).abs();
    if (a.isZero())
      return !0;
    var s = t.constructor.max(t.abs(), r.abs());
    return a.lte(s.times(n));
  }
  return !1;
}
var complex$2 = {};
Object.defineProperty(complex$2, "__esModule", {
  value: !0
});
complex$2.complexEquals = complexEquals;
var _number$v = number$3;
function complexEquals(t, r, n) {
  return (0, _number$v.nearlyEqual)(t.re, r.re, n) && (0, _number$v.nearlyEqual)(t.im, r.im, n);
}
Object.defineProperty(equalScalar, "__esModule", {
  value: !0
});
equalScalar.createEqualScalarNumber = equalScalar.createEqualScalar = void 0;
var _nearlyEqual$7 = nearlyEqual$1, _number$u = number$3, _factory$4b = factory$1, _complex$1 = complex$2, name$47 = "equalScalar", dependencies$47 = ["typed", "config"], createEqualScalar = /* @__PURE__ */ (0, _factory$4b.factory)(name$47, dependencies$47, function(t) {
  var r = t.typed, n = t.config;
  return r(name$47, {
    "boolean, boolean": function(s, o) {
      return s === o;
    },
    "number, number": function(s, o) {
      return (0, _number$u.nearlyEqual)(s, o, n.epsilon);
    },
    "BigNumber, BigNumber": function(s, o) {
      return s.eq(o) || (0, _nearlyEqual$7.nearlyEqual)(s, o, n.epsilon);
    },
    "Fraction, Fraction": function(s, o) {
      return s.equals(o);
    },
    "Complex, Complex": function(s, o) {
      return (0, _complex$1.complexEquals)(s, o, n.epsilon);
    },
    "Unit, Unit": function(s, o) {
      if (!s.equalBase(o))
        throw new Error("Cannot compare units with different base");
      return this(s.value, o.value);
    }
  });
});
equalScalar.createEqualScalar = createEqualScalar;
var createEqualScalarNumber = (0, _factory$4b.factory)(name$47, ["typed", "config"], function(t) {
  var r = t.typed, n = t.config;
  return r(name$47, {
    "number, number": function(s, o) {
      return (0, _number$u.nearlyEqual)(s, o, n.epsilon);
    }
  });
});
equalScalar.createEqualScalarNumber = createEqualScalarNumber;
var SparseMatrix = {};
Object.defineProperty(SparseMatrix, "__esModule", {
  value: !0
});
SparseMatrix.createSparseMatrixClass = void 0;
var _is$1e = is, _number$t = number$3, _string$o = string$2, _object$y = object, _array$R = array, _factory$4a = factory$1, _DimensionError$f = DimensionError$1, name$46 = "SparseMatrix", dependencies$46 = ["typed", "equalScalar", "Matrix"], createSparseMatrixClass = /* @__PURE__ */ (0, _factory$4a.factory)(name$46, dependencies$46, function(t) {
  var r = t.typed, n = t.equalScalar, a = t.Matrix;
  function s(y, x) {
    if (!(this instanceof s))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (x && !(0, _is$1e.isString)(x))
      throw new Error("Invalid datatype: " + x);
    if ((0, _is$1e.isMatrix)(y))
      o(this, y, x);
    else if (y && (0, _is$1e.isArray)(y.index) && (0, _is$1e.isArray)(y.ptr) && (0, _is$1e.isArray)(y.size))
      this._values = y.values, this._index = y.index, this._ptr = y.ptr, this._size = y.size, this._datatype = x || y.datatype;
    else if ((0, _is$1e.isArray)(y))
      c(this, y, x);
    else {
      if (y)
        throw new TypeError("Unsupported type of data (" + (0, _is$1e.typeOf)(y) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = x;
    }
  }
  function o(y, x, _) {
    x.type === "SparseMatrix" ? (y._values = x._values ? (0, _object$y.clone)(x._values) : void 0, y._index = (0, _object$y.clone)(x._index), y._ptr = (0, _object$y.clone)(x._ptr), y._size = (0, _object$y.clone)(x._size), y._datatype = _ || x._datatype) : c(y, x.valueOf(), _ || x._datatype);
  }
  function c(y, x, _) {
    y._values = [], y._index = [], y._ptr = [], y._datatype = _;
    var $ = x.length, b = 0, M = n, C = 0;
    if ((0, _is$1e.isString)(_) && (M = r.find(n, [_, _]) || n, C = r.convert(0, _)), $ > 0) {
      var S = 0;
      do {
        y._ptr.push(y._index.length);
        for (var A = 0; A < $; A++) {
          var D = x[A];
          if ((0, _is$1e.isArray)(D)) {
            if (S === 0 && b < D.length && (b = D.length), S < D.length) {
              var N = D[S];
              M(N, C) || (y._values.push(N), y._index.push(A));
            }
          } else
            S === 0 && b < 1 && (b = 1), M(D, C) || (y._values.push(D), y._index.push(A));
        }
        S++;
      } while (S < b);
    }
    y._ptr.push(y._index.length), y._size = [$, b];
  }
  s.prototype = new a(), s.prototype.createSparseMatrix = function(y, x) {
    return new s(y, x);
  }, s.prototype.type = "SparseMatrix", s.prototype.isSparseMatrix = !0, s.prototype.getDataType = function() {
    return (0, _array$R.getArrayDataType)(this._values, _is$1e.typeOf);
  }, s.prototype.storage = function() {
    return "sparse";
  }, s.prototype.datatype = function() {
    return this._datatype;
  }, s.prototype.create = function(y, x) {
    return new s(y, x);
  }, s.prototype.density = function() {
    var y = this._size[0], x = this._size[1];
    return y !== 0 && x !== 0 ? this._index.length / (y * x) : 0;
  }, s.prototype.subset = function(y, x, _) {
    if (!this._values)
      throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return l(this, y);
      case 2:
      case 3:
        return d(this, y, x, _);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  };
  function l(y, x) {
    if (!(0, _is$1e.isIndex)(x))
      throw new TypeError("Invalid index");
    var _ = x.isScalar();
    if (_)
      return y.get(x.min());
    var $ = x.size();
    if ($.length !== y._size.length)
      throw new _DimensionError$f.DimensionError($.length, y._size.length);
    var b, M, C, S, A = x.min(), D = x.max();
    for (b = 0, M = y._size.length; b < M; b++)
      (0, _array$R.validateIndex)(A[b], y._size[b]), (0, _array$R.validateIndex)(D[b], y._size[b]);
    var N = y._values, T = y._index, R = y._ptr, F = x.dimension(0), z = x.dimension(1), O = [], G = [];
    F.forEach(function(L, V) {
      G[L] = V[0], O[L] = !0;
    });
    var I = N ? [] : void 0, k = [], B = [];
    return z.forEach(function(L) {
      for (B.push(k.length), C = R[L], S = R[L + 1]; C < S; C++)
        b = T[C], O[b] === !0 && (k.push(G[b]), I && I.push(N[C]));
    }), B.push(k.length), new s({
      values: I,
      index: k,
      ptr: B,
      size: $,
      datatype: y._datatype
    });
  }
  function d(y, x, _, $) {
    if (!x || x.isIndex !== !0)
      throw new TypeError("Invalid index");
    var b = x.size(), M = x.isScalar(), C;
    if ((0, _is$1e.isMatrix)(_) ? (C = _.size(), _ = _.toArray()) : C = (0, _array$R.arraySize)(_), M) {
      if (C.length !== 0)
        throw new TypeError("Scalar expected");
      y.set(x.min(), _, $);
    } else {
      if (b.length !== 1 && b.length !== 2)
        throw new _DimensionError$f.DimensionError(b.length, y._size.length, "<");
      if (C.length < b.length) {
        for (var S = 0, A = 0; b[S] === 1 && C[S] === 1; )
          S++;
        for (; b[S] === 1; )
          A++, S++;
        _ = (0, _array$R.unsqueeze)(_, b.length, A, C);
      }
      if (!(0, _object$y.deepStrictEqual)(b, C))
        throw new _DimensionError$f.DimensionError(b, C, ">");
      for (var D = x.min()[0], N = x.min()[1], T = C[0], R = C[1], F = 0; F < T; F++)
        for (var z = 0; z < R; z++) {
          var O = _[F][z];
          y.set([F + D, z + N], O, $);
        }
    }
    return y;
  }
  s.prototype.get = function(y) {
    if (!(0, _is$1e.isArray)(y))
      throw new TypeError("Array expected");
    if (y.length !== this._size.length)
      throw new _DimensionError$f.DimensionError(y.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke get on a Pattern only matrix");
    var x = y[0], _ = y[1];
    (0, _array$R.validateIndex)(x, this._size[0]), (0, _array$R.validateIndex)(_, this._size[1]);
    var $ = h(x, this._ptr[_], this._ptr[_ + 1], this._index);
    return $ < this._ptr[_ + 1] && this._index[$] === x ? this._values[$] : 0;
  }, s.prototype.set = function(y, x, _) {
    if (!(0, _is$1e.isArray)(y))
      throw new TypeError("Array expected");
    if (y.length !== this._size.length)
      throw new _DimensionError$f.DimensionError(y.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke set on a Pattern only matrix");
    var $ = y[0], b = y[1], M = this._size[0], C = this._size[1], S = n, A = 0;
    (0, _is$1e.isString)(this._datatype) && (S = r.find(n, [this._datatype, this._datatype]) || n, A = r.convert(0, this._datatype)), ($ > M - 1 || b > C - 1) && (m(this, Math.max($ + 1, M), Math.max(b + 1, C), _), M = this._size[0], C = this._size[1]), (0, _array$R.validateIndex)($, M), (0, _array$R.validateIndex)(b, C);
    var D = h($, this._ptr[b], this._ptr[b + 1], this._index);
    return D < this._ptr[b + 1] && this._index[D] === $ ? S(x, A) ? u(D, b, this._values, this._index, this._ptr) : this._values[D] = x : p(D, $, b, x, this._values, this._index, this._ptr), this;
  };
  function h(y, x, _, $) {
    if (_ - x === 0)
      return _;
    for (var b = x; b < _; b++)
      if ($[b] === y)
        return b;
    return x;
  }
  function u(y, x, _, $, b) {
    _.splice(y, 1), $.splice(y, 1);
    for (var M = x + 1; M < b.length; M++)
      b[M]--;
  }
  function p(y, x, _, $, b, M, C) {
    b.splice(y, 0, $), M.splice(y, 0, x);
    for (var S = _ + 1; S < C.length; S++)
      C[S]++;
  }
  s.prototype.resize = function(y, x, _) {
    if (!(0, _is$1e.isCollection)(y))
      throw new TypeError("Array or Matrix expected");
    var $ = y.valueOf().map(function(M) {
      return Array.isArray(M) && M.length === 1 ? M[0] : M;
    });
    if ($.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    $.forEach(function(M) {
      if (!(0, _is$1e.isNumber)(M) || !(0, _number$t.isInteger)(M) || M < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + (0, _string$o.format)($) + ")");
    });
    var b = _ ? this.clone() : this;
    return m(b, $[0], $[1], x);
  };
  function m(y, x, _, $) {
    var b = $ || 0, M = n, C = 0;
    (0, _is$1e.isString)(y._datatype) && (M = r.find(n, [y._datatype, y._datatype]) || n, C = r.convert(0, y._datatype), b = r.convert(b, y._datatype));
    var S = !M(b, C), A = y._size[0], D = y._size[1], N, T, R;
    if (_ > D) {
      for (T = D; T < _; T++)
        if (y._ptr[T] = y._values.length, S)
          for (N = 0; N < A; N++)
            y._values.push(b), y._index.push(N);
      y._ptr[_] = y._values.length;
    } else
      _ < D && (y._ptr.splice(_ + 1, D - _), y._values.splice(y._ptr[_], y._values.length), y._index.splice(y._ptr[_], y._index.length));
    if (D = _, x > A) {
      if (S) {
        var F = 0;
        for (T = 0; T < D; T++) {
          y._ptr[T] = y._ptr[T] + F, R = y._ptr[T + 1] + F;
          var z = 0;
          for (N = A; N < x; N++, z++)
            y._values.splice(R + z, 0, b), y._index.splice(R + z, 0, N), F++;
        }
        y._ptr[D] = y._values.length;
      }
    } else if (x < A) {
      var O = 0;
      for (T = 0; T < D; T++) {
        y._ptr[T] = y._ptr[T] - O;
        var G = y._ptr[T], I = y._ptr[T + 1] - O;
        for (R = G; R < I; R++)
          N = y._index[R], N > x - 1 && (y._values.splice(R, 1), y._index.splice(R, 1), O++);
      }
      y._ptr[T] = y._values.length;
    }
    return y._size[0] = x, y._size[1] = _, y;
  }
  s.prototype.reshape = function(y, x) {
    if (!(0, _is$1e.isArray)(y))
      throw new TypeError("Array expected");
    if (y.length !== 2)
      throw new Error("Sparse matrices can only be reshaped in two dimensions");
    if (y.forEach(function(k) {
      if (!(0, _is$1e.isNumber)(k) || !(0, _number$t.isInteger)(k) || k < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + (0, _string$o.format)(y) + ")");
    }), this._size[0] * this._size[1] !== y[0] * y[1])
      throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var _ = x ? this.clone() : this;
    if (this._size[0] === y[0] && this._size[1] === y[1])
      return _;
    for (var $ = [], b = 0; b < _._ptr.length; b++)
      for (var M = 0; M < _._ptr[b + 1] - _._ptr[b]; M++)
        $.push(b);
    for (var C = _._values.slice(), S = _._index.slice(), A = 0; A < _._index.length; A++) {
      var D = S[A], N = $[A], T = D * _._size[1] + N;
      $[A] = T % y[1], S[A] = Math.floor(T / y[1]);
    }
    _._values.length = 0, _._index.length = 0, _._ptr.length = y[1] + 1, _._size = y.slice();
    for (var R = 0; R < _._ptr.length; R++)
      _._ptr[R] = 0;
    for (var F = 0; F < C.length; F++) {
      var z = S[F], O = $[F], G = C[F], I = h(z, _._ptr[O], _._ptr[O + 1], _._index);
      p(I, z, O, G, _._values, _._index, _._ptr);
    }
    return _;
  }, s.prototype.clone = function() {
    var y = new s({
      values: this._values ? (0, _object$y.clone)(this._values) : void 0,
      index: (0, _object$y.clone)(this._index),
      ptr: (0, _object$y.clone)(this._ptr),
      size: (0, _object$y.clone)(this._size),
      datatype: this._datatype
    });
    return y;
  }, s.prototype.size = function() {
    return this._size.slice(0);
  }, s.prototype.map = function(y, x) {
    if (!this._values)
      throw new Error("Cannot invoke map on a Pattern only matrix");
    var _ = this, $ = this._size[0], b = this._size[1], M = function(S, A, D) {
      return y(S, [A, D], _);
    };
    return g(this, 0, $ - 1, 0, b - 1, M, x);
  };
  function g(y, x, _, $, b, M, C) {
    var S = [], A = [], D = [], N = n, T = 0;
    (0, _is$1e.isString)(y._datatype) && (N = r.find(n, [y._datatype, y._datatype]) || n, T = r.convert(0, y._datatype));
    for (var R = function(q, Z, ae) {
      q = M(q, Z, ae), N(q, T) || (S.push(q), A.push(Z));
    }, F = $; F <= b; F++) {
      D.push(S.length);
      var z = y._ptr[F], O = y._ptr[F + 1];
      if (C)
        for (var G = z; G < O; G++) {
          var I = y._index[G];
          I >= x && I <= _ && R(y._values[G], I - x, F - $);
        }
      else {
        for (var k = {}, B = z; B < O; B++) {
          var L = y._index[B];
          k[L] = y._values[B];
        }
        for (var V = x; V <= _; V++) {
          var U = V in k ? k[V] : 0;
          R(U, V - x, F - $);
        }
      }
    }
    return D.push(S.length), new s({
      values: S,
      index: A,
      ptr: D,
      size: [_ - x + 1, b - $ + 1]
    });
  }
  s.prototype.forEach = function(y, x) {
    if (!this._values)
      throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var _ = this, $ = this._size[0], b = this._size[1], M = 0; M < b; M++) {
      var C = this._ptr[M], S = this._ptr[M + 1];
      if (x)
        for (var A = C; A < S; A++) {
          var D = this._index[A];
          y(this._values[A], [D, M], _);
        }
      else {
        for (var N = {}, T = C; T < S; T++) {
          var R = this._index[T];
          N[R] = this._values[T];
        }
        for (var F = 0; F < $; F++) {
          var z = F in N ? N[F] : 0;
          y(z, [F, M], _);
        }
      }
    }
  }, s.prototype.toArray = function() {
    return v(this._values, this._index, this._ptr, this._size, !0);
  }, s.prototype.valueOf = function() {
    return v(this._values, this._index, this._ptr, this._size, !1);
  };
  function v(y, x, _, $, b) {
    var M = $[0], C = $[1], S = [], A, D;
    for (A = 0; A < M; A++)
      for (S[A] = [], D = 0; D < C; D++)
        S[A][D] = 0;
    for (D = 0; D < C; D++)
      for (var N = _[D], T = _[D + 1], R = N; R < T; R++)
        A = x[R], S[A][D] = y ? b ? (0, _object$y.clone)(y[R]) : y[R] : 1;
    return S;
  }
  return s.prototype.format = function(y) {
    for (var x = this._size[0], _ = this._size[1], $ = this.density(), b = "Sparse Matrix [" + (0, _string$o.format)(x, y) + " x " + (0, _string$o.format)(_, y) + "] density: " + (0, _string$o.format)($, y) + `
`, M = 0; M < _; M++)
      for (var C = this._ptr[M], S = this._ptr[M + 1], A = C; A < S; A++) {
        var D = this._index[A];
        b += `
    (` + (0, _string$o.format)(D, y) + ", " + (0, _string$o.format)(M, y) + ") ==> " + (this._values ? (0, _string$o.format)(this._values[A], y) : "X");
      }
    return b;
  }, s.prototype.toString = function() {
    return (0, _string$o.format)(this.toArray());
  }, s.prototype.toJSON = function() {
    return {
      mathjs: "SparseMatrix",
      values: this._values,
      index: this._index,
      ptr: this._ptr,
      size: this._size,
      datatype: this._datatype
    };
  }, s.prototype.diagonal = function(y) {
    if (y) {
      if ((0, _is$1e.isBigNumber)(y) && (y = y.toNumber()), !(0, _is$1e.isNumber)(y) || !(0, _number$t.isInteger)(y))
        throw new TypeError("The parameter k must be an integer number");
    } else
      y = 0;
    var x = y > 0 ? y : 0, _ = y < 0 ? -y : 0, $ = this._size[0], b = this._size[1], M = Math.min($ - _, b - x), C = [], S = [], A = [];
    A[0] = 0;
    for (var D = x; D < b && C.length < M; D++)
      for (var N = this._ptr[D], T = this._ptr[D + 1], R = N; R < T; R++) {
        var F = this._index[R];
        if (F === D - x + _) {
          C.push(this._values[R]), S[C.length - 1] = F - _;
          break;
        }
      }
    return A.push(C.length), new s({
      values: C,
      index: S,
      ptr: A,
      size: [M, 1]
    });
  }, s.fromJSON = function(y) {
    return new s(y);
  }, s.diagonal = function(y, x, _, $, b) {
    if (!(0, _is$1e.isArray)(y))
      throw new TypeError("Array expected, size parameter");
    if (y.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (y = y.map(function(L) {
      if ((0, _is$1e.isBigNumber)(L) && (L = L.toNumber()), !(0, _is$1e.isNumber)(L) || !(0, _number$t.isInteger)(L) || L < 1)
        throw new Error("Size values must be positive integers");
      return L;
    }), _) {
      if ((0, _is$1e.isBigNumber)(_) && (_ = _.toNumber()), !(0, _is$1e.isNumber)(_) || !(0, _number$t.isInteger)(_))
        throw new TypeError("The parameter k must be an integer number");
    } else
      _ = 0;
    var M = n, C = 0;
    (0, _is$1e.isString)(b) && (M = r.find(n, [b, b]) || n, C = r.convert(0, b));
    var S = _ > 0 ? _ : 0, A = _ < 0 ? -_ : 0, D = y[0], N = y[1], T = Math.min(D - A, N - S), R;
    if ((0, _is$1e.isArray)(x)) {
      if (x.length !== T)
        throw new Error("Invalid value array length");
      R = function(V) {
        return x[V];
      };
    } else if ((0, _is$1e.isMatrix)(x)) {
      var F = x.size();
      if (F.length !== 1 || F[0] !== T)
        throw new Error("Invalid matrix length");
      R = function(V) {
        return x.get([V]);
      };
    } else
      R = function() {
        return x;
      };
    for (var z = [], O = [], G = [], I = 0; I < N; I++) {
      G.push(z.length);
      var k = I - S;
      if (k >= 0 && k < T) {
        var B = R(k);
        M(B, C) || (O.push(k + A), z.push(B));
      }
    }
    return G.push(z.length), new s({
      values: z,
      index: O,
      ptr: G,
      size: [D, N]
    });
  }, s.prototype.swapRows = function(y, x) {
    if (!(0, _is$1e.isNumber)(y) || !(0, _number$t.isInteger)(y) || !(0, _is$1e.isNumber)(x) || !(0, _number$t.isInteger)(x))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return (0, _array$R.validateIndex)(y, this._size[0]), (0, _array$R.validateIndex)(x, this._size[0]), s._swapRows(y, x, this._size[1], this._values, this._index, this._ptr), this;
  }, s._forEachRow = function(y, x, _, $, b) {
    for (var M = $[y], C = $[y + 1], S = M; S < C; S++)
      b(_[S], x[S]);
  }, s._swapRows = function(y, x, _, $, b, M) {
    for (var C = 0; C < _; C++) {
      var S = M[C], A = M[C + 1], D = h(y, S, A, b), N = h(x, S, A, b);
      if (D < A && N < A && b[D] === y && b[N] === x) {
        if ($) {
          var T = $[D];
          $[D] = $[N], $[N] = T;
        }
        continue;
      }
      if (D < A && b[D] === y && (N >= A || b[N] !== x)) {
        var R = $ ? $[D] : void 0;
        b.splice(N, 0, x), $ && $.splice(N, 0, R), b.splice(N <= D ? D + 1 : D, 1), $ && $.splice(N <= D ? D + 1 : D, 1);
        continue;
      }
      if (N < A && b[N] === x && (D >= A || b[D] !== y)) {
        var F = $ ? $[N] : void 0;
        b.splice(D, 0, y), $ && $.splice(D, 0, F), b.splice(D <= N ? N + 1 : N, 1), $ && $.splice(D <= N ? N + 1 : N, 1);
      }
    }
  }, s;
}, {
  isClass: !0
});
SparseMatrix.createSparseMatrixClass = createSparseMatrixClass;
var number$1 = {};
Object.defineProperty(number$1, "__esModule", {
  value: !0
});
number$1.createNumber = void 0;
var _factory$49 = factory$1, _collection$16 = collection$1, name$45 = "number", dependencies$45 = ["typed"], createNumber = /* @__PURE__ */ (0, _factory$49.factory)(name$45, dependencies$45, function(t) {
  var r = t.typed, n = r("number", {
    "": function() {
      return 0;
    },
    number: function(s) {
      return s;
    },
    string: function(s) {
      if (s === "NaN")
        return NaN;
      var o = Number(s);
      if (isNaN(o))
        throw new SyntaxError('String "' + s + '" is no valid number');
      if (["0b", "0o", "0x"].includes(s.substring(0, 2))) {
        if (o > Math.pow(2, 32) - 1)
          throw new SyntaxError('String "'.concat(s, '" is out of range'));
        o & 2147483648 && (o = -1 * ~(o - 1));
      }
      return o;
    },
    BigNumber: function(s) {
      return s.toNumber();
    },
    Fraction: function(s) {
      return s.valueOf();
    },
    Unit: function(s) {
      throw new Error("Second argument with valueless unit expected");
    },
    null: function(s) {
      return 0;
    },
    "Unit, string | Unit": function(s, o) {
      return s.toNumber(o);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$16.deepMap)(s, this);
    }
  });
  return n.fromJSON = function(a) {
    return parseFloat(a.value);
  }, n;
});
number$1.createNumber = createNumber;
var string$1 = {};
Object.defineProperty(string$1, "__esModule", {
  value: !0
});
string$1.createString = void 0;
var _factory$48 = factory$1, _collection$15 = collection$1, _number$s = number$3, name$44 = "string", dependencies$44 = ["typed"], createString = /* @__PURE__ */ (0, _factory$48.factory)(name$44, dependencies$44, function(t) {
  var r = t.typed;
  return r(name$44, {
    "": function() {
      return "";
    },
    number: _number$s.format,
    null: function(a) {
      return "null";
    },
    boolean: function(a) {
      return a + "";
    },
    string: function(a) {
      return a;
    },
    "Array | Matrix": function(a) {
      return (0, _collection$15.deepMap)(a, this);
    },
    any: function(a) {
      return String(a);
    }
  });
});
string$1.createString = createString;
var boolean$1 = {};
Object.defineProperty(boolean$1, "__esModule", {
  value: !0
});
boolean$1.createBoolean = void 0;
var _factory$47 = factory$1, _collection$14 = collection$1, name$43 = "boolean", dependencies$43 = ["typed"], createBoolean = /* @__PURE__ */ (0, _factory$47.factory)(name$43, dependencies$43, function(t) {
  var r = t.typed;
  return r(name$43, {
    "": function() {
      return !1;
    },
    boolean: function(a) {
      return a;
    },
    number: function(a) {
      return !!a;
    },
    null: function(a) {
      return !1;
    },
    BigNumber: function(a) {
      return !a.isZero();
    },
    string: function(a) {
      var s = a.toLowerCase();
      if (s === "true")
        return !0;
      if (s === "false")
        return !1;
      var o = Number(a);
      if (a !== "" && !isNaN(o))
        return !!o;
      throw new Error('Cannot convert "' + a + '" to a boolean');
    },
    "Array | Matrix": function(a) {
      return (0, _collection$14.deepMap)(a, this);
    }
  });
});
boolean$1.createBoolean = createBoolean;
var bignumber$1 = {};
Object.defineProperty(bignumber$1, "__esModule", {
  value: !0
});
bignumber$1.createBignumber = void 0;
var _factory$46 = factory$1, _collection$13 = collection$1, name$42 = "bignumber", dependencies$42 = ["typed", "BigNumber"], createBignumber = /* @__PURE__ */ (0, _factory$46.factory)(name$42, dependencies$42, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r("bignumber", {
    "": function() {
      return new n(0);
    },
    number: function(s) {
      return new n(s + "");
    },
    string: function(s) {
      return new n(s);
    },
    BigNumber: function(s) {
      return s;
    },
    Fraction: function(s) {
      return new n(s.n).div(s.d).times(s.s);
    },
    null: function(s) {
      return new n(0);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$13.deepMap)(s, this);
    }
  });
});
bignumber$1.createBignumber = createBignumber;
var complex$1 = {};
Object.defineProperty(complex$1, "__esModule", {
  value: !0
});
complex$1.createComplex = void 0;
var _factory$45 = factory$1, _collection$12 = collection$1, name$41 = "complex", dependencies$41 = ["typed", "Complex"], createComplex = /* @__PURE__ */ (0, _factory$45.factory)(name$41, dependencies$41, function(t) {
  var r = t.typed, n = t.Complex;
  return r("complex", {
    "": function() {
      return n.ZERO;
    },
    number: function(s) {
      return new n(s, 0);
    },
    "number, number": function(s, o) {
      return new n(s, o);
    },
    // TODO: this signature should be redundant
    "BigNumber, BigNumber": function(s, o) {
      return new n(s.toNumber(), o.toNumber());
    },
    Fraction: function(s) {
      return new n(s.valueOf(), 0);
    },
    Complex: function(s) {
      return s.clone();
    },
    string: function(s) {
      return n(s);
    },
    null: function(s) {
      return n(0);
    },
    Object: function(s) {
      if ("re" in s && "im" in s)
        return new n(s.re, s.im);
      if ("r" in s && "phi" in s || "abs" in s && "arg" in s)
        return new n(s);
      throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
    },
    "Array | Matrix": function(s) {
      return (0, _collection$12.deepMap)(s, this);
    }
  });
});
complex$1.createComplex = createComplex;
var fraction$1 = {};
Object.defineProperty(fraction$1, "__esModule", {
  value: !0
});
fraction$1.createFraction = void 0;
var _factory$44 = factory$1, _collection$11 = collection$1, name$40 = "fraction", dependencies$40 = ["typed", "Fraction"], createFraction = /* @__PURE__ */ (0, _factory$44.factory)(name$40, dependencies$40, function(t) {
  var r = t.typed, n = t.Fraction;
  return r("fraction", {
    number: function(s) {
      if (!isFinite(s) || isNaN(s))
        throw new Error(s + " cannot be represented as a fraction");
      return new n(s);
    },
    string: function(s) {
      return new n(s);
    },
    "number, number": function(s, o) {
      return new n(s, o);
    },
    null: function(s) {
      return new n(0);
    },
    BigNumber: function(s) {
      return new n(s.toString());
    },
    Fraction: function(s) {
      return s;
    },
    Object: function(s) {
      return new n(s);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$11.deepMap)(s, this);
    }
  });
});
fraction$1.createFraction = createFraction;
var matrix$2 = {};
Object.defineProperty(matrix$2, "__esModule", {
  value: !0
});
matrix$2.createMatrix = void 0;
var _factory$43 = factory$1, name$3$ = "matrix", dependencies$3$ = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], createMatrix = /* @__PURE__ */ (0, _factory$43.factory)(name$3$, dependencies$3$, function(t) {
  var r = t.typed;
  t.Matrix;
  var n = t.DenseMatrix, a = t.SparseMatrix;
  return r(name$3$, {
    "": function() {
      return s([]);
    },
    string: function(c) {
      return s([], c);
    },
    "string, string": function(c, l) {
      return s([], c, l);
    },
    Array: function(c) {
      return s(c);
    },
    Matrix: function(c) {
      return s(c, c.storage());
    },
    "Array | Matrix, string": s,
    "Array | Matrix, string, string": s
  });
  function s(o, c, l) {
    if (c === "dense" || c === "default" || c === void 0)
      return new n(o, l);
    if (c === "sparse")
      return new a(o, l);
    throw new TypeError("Unknown matrix type " + JSON.stringify(c) + ".");
  }
});
matrix$2.createMatrix = createMatrix;
var splitUnit$1 = {};
Object.defineProperty(splitUnit$1, "__esModule", {
  value: !0
});
splitUnit$1.createSplitUnit = void 0;
var _factory$42 = factory$1, name$3_ = "splitUnit", dependencies$3_ = ["typed"], createSplitUnit = /* @__PURE__ */ (0, _factory$42.factory)(name$3_, dependencies$3_, function(t) {
  var r = t.typed;
  return r(name$3_, {
    "Unit, Array": function(a, s) {
      return a.splitUnit(s);
    }
  });
});
splitUnit$1.createSplitUnit = createSplitUnit;
var unaryMinus$1 = {};
Object.defineProperty(unaryMinus$1, "__esModule", {
  value: !0
});
unaryMinus$1.createUnaryMinus = void 0;
var _factory$41 = factory$1, _collection$10 = collection$1, _index$P = number$2, name$3Z = "unaryMinus", dependencies$3Z = ["typed"], createUnaryMinus = /* @__PURE__ */ (0, _factory$41.factory)(name$3Z, dependencies$3Z, function(t) {
  var r = t.typed;
  return r(name$3Z, {
    number: _index$P.unaryMinusNumber,
    Complex: function(a) {
      return a.neg();
    },
    BigNumber: function(a) {
      return a.neg();
    },
    Fraction: function(a) {
      return a.neg();
    },
    Unit: function(a) {
      var s = a.clone();
      return s.value = this(a.value), s;
    },
    "Array | Matrix": function(a) {
      return (0, _collection$10.deepMap)(a, this, !0);
    }
    // TODO: add support for string
  });
});
unaryMinus$1.createUnaryMinus = createUnaryMinus;
var unaryPlus$1 = {};
Object.defineProperty(unaryPlus$1, "__esModule", {
  value: !0
});
unaryPlus$1.createUnaryPlus = void 0;
var _factory$40 = factory$1, _collection$$ = collection$1, _index$O = number$2, name$3Y = "unaryPlus", dependencies$3Y = ["typed", "config", "BigNumber"], createUnaryPlus = /* @__PURE__ */ (0, _factory$40.factory)(name$3Y, dependencies$3Y, function(t) {
  var r = t.typed, n = t.config, a = t.BigNumber;
  return r(name$3Y, {
    number: _index$O.unaryPlusNumber,
    Complex: function(o) {
      return o;
    },
    BigNumber: function(o) {
      return o;
    },
    Fraction: function(o) {
      return o;
    },
    Unit: function(o) {
      return o.clone();
    },
    "Array | Matrix": function(o) {
      return (0, _collection$$.deepMap)(o, this, !0);
    },
    "boolean | string": function(o) {
      return n.number === "BigNumber" ? new a(+o) : +o;
    }
  });
});
unaryPlus$1.createUnaryPlus = createUnaryPlus;
var abs$3 = {};
Object.defineProperty(abs$3, "__esModule", {
  value: !0
});
abs$3.createAbs = void 0;
var _factory$3$ = factory$1, _collection$_ = collection$1, _index$N = number$2, name$3X = "abs", dependencies$3X = ["typed"], createAbs = /* @__PURE__ */ (0, _factory$3$.factory)(name$3X, dependencies$3X, function(t) {
  var r = t.typed;
  return r(name$3X, {
    number: _index$N.absNumber,
    Complex: function(a) {
      return a.abs();
    },
    BigNumber: function(a) {
      return a.abs();
    },
    Fraction: function(a) {
      return a.abs();
    },
    "Array | Matrix": function(a) {
      return (0, _collection$_.deepMap)(a, this, !0);
    },
    Unit: function(a) {
      return a.abs();
    }
  });
});
abs$3.createAbs = createAbs;
var apply = {};
Object.defineProperty(apply, "__esModule", {
  value: !0
});
apply.createApply = void 0;
var _factory$3_ = factory$1, _array$Q = array, _is$1d = is, _IndexError$3 = IndexError$1, name$3W = "apply", dependencies$3W = ["typed", "isInteger"], createApply = /* @__PURE__ */ (0, _factory$3_.factory)(name$3W, dependencies$3W, function(t) {
  var r = t.typed, n = t.isInteger;
  return r(name$3W, {
    "Array | Matrix, number | BigNumber, function": function(s, o, c) {
      if (!n(o))
        throw new TypeError("Integer number expected for dimension");
      var l = Array.isArray(s) ? (0, _array$Q.arraySize)(s) : s.size();
      if (o < 0 || o >= l.length)
        throw new _IndexError$3.IndexError(o, l.length);
      return (0, _is$1d.isMatrix)(s) ? s.create(_apply$1(s.valueOf(), o, c)) : _apply$1(s, o, c);
    }
  });
});
apply.createApply = createApply;
function _apply$1(t, r, n) {
  var a, s, o;
  if (r <= 0)
    if (Array.isArray(t[0])) {
      for (o = _switch(t), s = [], a = 0; a < o.length; a++)
        s[a] = _apply$1(o[a], r - 1, n);
      return s;
    } else
      return n(t);
  else {
    for (s = [], a = 0; a < t.length; a++)
      s[a] = _apply$1(t[a], r - 1, n);
    return s;
  }
}
function _switch(t) {
  var r = t.length, n = t[0].length, a, s, o = [];
  for (s = 0; s < n; s++) {
    var c = [];
    for (a = 0; a < r; a++)
      c.push(t[a][s]);
    o.push(c);
  }
  return o;
}
var addScalar = {};
Object.defineProperty(addScalar, "__esModule", {
  value: !0
});
addScalar.createAddScalar = void 0;
var _factory$3Z = factory$1, _index$M = number$2, name$3V = "addScalar", dependencies$3V = ["typed"], createAddScalar = /* @__PURE__ */ (0, _factory$3Z.factory)(name$3V, dependencies$3V, function(t) {
  var r = t.typed;
  return r(name$3V, {
    "number, number": _index$M.addNumber,
    "Complex, Complex": function(a, s) {
      return a.add(s);
    },
    "BigNumber, BigNumber": function(a, s) {
      return a.plus(s);
    },
    "Fraction, Fraction": function(a, s) {
      return a.add(s);
    },
    "Unit, Unit": function(a, s) {
      if (a.value === null || a.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (s.value === null || s.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!a.equalBase(s))
        throw new Error("Units do not match");
      var o = a.clone();
      return o.value = this(o.value, s.value), o.fixPrefix = !1, o;
    }
  });
});
addScalar.createAddScalar = createAddScalar;
var cbrt$1 = {};
Object.defineProperty(cbrt$1, "__esModule", {
  value: !0
});
cbrt$1.createCbrt = void 0;
var _factory$3Y = factory$1, _is$1c = is, _collection$Z = collection$1, _index$L = number$2, name$3U = "cbrt", dependencies$3U = ["config", "typed", "isNegative", "unaryMinus", "matrix", "Complex", "BigNumber", "Fraction"], createCbrt = /* @__PURE__ */ (0, _factory$3Y.factory)(name$3U, dependencies$3U, function(t) {
  var r = t.config, n = t.typed, a = t.isNegative, s = t.unaryMinus, o = t.matrix, c = t.Complex, l = t.BigNumber, d = t.Fraction;
  return n(name$3U, {
    number: _index$L.cbrtNumber,
    // note: signature 'number, boolean' is also supported,
    //       created by typed as it knows how to convert number to Complex
    Complex: h,
    "Complex, boolean": h,
    BigNumber: function(m) {
      return m.cbrt();
    },
    Unit: u,
    "Array | Matrix": function(m) {
      return (0, _collection$Z.deepMap)(m, this, !0);
    }
  });
  function h(p, m) {
    var g = p.arg() / 3, v = p.abs(), y = new c((0, _index$L.cbrtNumber)(v), 0).mul(new c(0, g).exp());
    if (m) {
      var x = [y, new c((0, _index$L.cbrtNumber)(v), 0).mul(new c(0, g + Math.PI * 2 / 3).exp()), new c((0, _index$L.cbrtNumber)(v), 0).mul(new c(0, g - Math.PI * 2 / 3).exp())];
      return r.matrix === "Array" ? x : o(x);
    } else
      return y;
  }
  function u(p) {
    if (p.value && (0, _is$1c.isComplex)(p.value)) {
      var m = p.clone();
      return m.value = 1, m = m.pow(1 / 3), m.value = h(p.value), m;
    } else {
      var g = a(p.value);
      g && (p.value = s(p.value));
      var v;
      (0, _is$1c.isBigNumber)(p.value) ? v = new l(1).div(3) : (0, _is$1c.isFraction)(p.value) ? v = new d(1, 3) : v = 1 / 3;
      var y = p.pow(v);
      return g && (y.value = s(y.value)), y;
    }
  }
});
cbrt$1.createCbrt = createCbrt;
var ceil$1 = {}, algorithm11 = {};
Object.defineProperty(algorithm11, "__esModule", {
  value: !0
});
algorithm11.createAlgorithm11 = void 0;
var _factory$3X = factory$1, name$3T = "algorithm11", dependencies$3T = ["typed", "equalScalar"], createAlgorithm11 = /* @__PURE__ */ (0, _factory$3X.factory)(name$3T, dependencies$3T, function(t) {
  var r = t.typed, n = t.equalScalar;
  return function(s, o, c, l) {
    var d = s._values, h = s._index, u = s._ptr, p = s._size, m = s._datatype;
    if (!d)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var g = p[0], v = p[1], y, x = n, _ = 0, $ = c;
    typeof m == "string" && (y = m, x = r.find(n, [y, y]), _ = r.convert(0, y), o = r.convert(o, y), $ = r.find(c, [y, y]));
    for (var b = [], M = [], C = [], S = 0; S < v; S++) {
      C[S] = M.length;
      for (var A = u[S], D = u[S + 1], N = A; N < D; N++) {
        var T = h[N], R = l ? $(o, d[N]) : $(d[N], o);
        x(R, _) || (M.push(T), b.push(R));
      }
    }
    return C[v] = M.length, s.createSparseMatrix({
      values: b,
      index: M,
      ptr: C,
      size: [g, v],
      datatype: y
    });
  };
});
algorithm11.createAlgorithm11 = createAlgorithm11;
var algorithm14 = {};
Object.defineProperty(algorithm14, "__esModule", {
  value: !0
});
algorithm14.createAlgorithm14 = void 0;
var _factory$3W = factory$1, _object$x = object, name$3S = "algorithm14", dependencies$3S = ["typed"], createAlgorithm14 = /* @__PURE__ */ (0, _factory$3W.factory)(name$3S, dependencies$3S, function(t) {
  var r = t.typed;
  return function(s, o, c, l) {
    var d = s._data, h = s._size, u = s._datatype, p, m = c;
    typeof u == "string" && (p = u, o = r.convert(o, p), m = r.find(c, [p, p]));
    var g = h.length > 0 ? n(m, 0, h, h[0], d, o, l) : [];
    return s.createDenseMatrix({
      data: g,
      size: (0, _object$x.clone)(h),
      datatype: p
    });
  };
  function n(a, s, o, c, l, d, h) {
    var u = [];
    if (s === o.length - 1)
      for (var p = 0; p < c; p++)
        u[p] = h ? a(d, l[p]) : a(l[p], d);
    else
      for (var m = 0; m < c; m++)
        u[m] = n(a, s + 1, o, o[s + 1], l[m], d, h);
    return u;
  }
});
algorithm14.createAlgorithm14 = createAlgorithm14;
Object.defineProperty(ceil$1, "__esModule", {
  value: !0
});
ceil$1.createCeil = void 0;
var _decimal$1 = _interopRequireDefault$5(decimalExports), _factory$3V = factory$1, _collection$Y = collection$1, _number$r = number$3, _nearlyEqual$6 = nearlyEqual$1, _index$K = number$2, _algorithm$x = algorithm11, _algorithm2$w = algorithm14;
function _interopRequireDefault$5(t) {
  return t && t.__esModule ? t : { default: t };
}
function _slicedToArray$4(t, r) {
  return _arrayWithHoles$4(t) || _iterableToArrayLimit$4(t, r) || _unsupportedIterableToArray$6(t, r) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$6(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$6(t, r);
  }
}
function _arrayLikeToArray$6(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _iterableToArrayLimit$4(t, r) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], a = !0, s = !1, o = void 0;
    try {
      for (var c = t[Symbol.iterator](), l; !(a = (l = c.next()).done) && (n.push(l.value), !(r && n.length === r)); a = !0)
        ;
    } catch (d) {
      s = !0, o = d;
    } finally {
      try {
        !a && c.return != null && c.return();
      } finally {
        if (s)
          throw o;
      }
    }
    return n;
  }
}
function _arrayWithHoles$4(t) {
  if (Array.isArray(t))
    return t;
}
var name$3R = "ceil", dependencies$3R = ["typed", "config", "round", "matrix", "equalScalar"], createCeil = /* @__PURE__ */ (0, _factory$3V.factory)(name$3R, dependencies$3R, function(t) {
  var r = t.typed, n = t.config, a = t.round, s = t.matrix, o = t.equalScalar, c = (0, _algorithm$x.createAlgorithm11)({
    typed: r,
    equalScalar: o
  }), l = (0, _algorithm2$w.createAlgorithm14)({
    typed: r
  });
  return r("ceil", {
    number: function(h) {
      return (0, _number$r.nearlyEqual)(h, a(h), n.epsilon) ? a(h) : (0, _index$K.ceilNumber)(h);
    },
    "number, number": function(h, u) {
      if ((0, _number$r.nearlyEqual)(h, a(h, u), n.epsilon))
        return a(h, u);
      var p = "".concat(h, "e").split("e"), m = _slicedToArray$4(p, 2), g = m[0], v = m[1], y = Math.ceil(Number("".concat(g, "e").concat(Number(v) + u))), x = "".concat(y, "e").split("e"), _ = _slicedToArray$4(x, 2);
      return g = _[0], v = _[1], Number("".concat(g, "e").concat(Number(v) - u));
    },
    Complex: function(h) {
      return h.ceil();
    },
    "Complex, number": function(h, u) {
      return h.ceil(u);
    },
    BigNumber: function(h) {
      return (0, _nearlyEqual$6.nearlyEqual)(h, a(h), n.epsilon) ? a(h) : h.ceil();
    },
    "BigNumber, BigNumber": function(h, u) {
      return (0, _nearlyEqual$6.nearlyEqual)(h, a(h, u), n.epsilon) ? a(h, u) : h.toDecimalPlaces(u.toNumber(), _decimal$1.default.ROUND_CEIL);
    },
    Fraction: function(h) {
      return h.ceil();
    },
    "Fraction, number": function(h, u) {
      return h.ceil(u);
    },
    "Array | Matrix": function(h) {
      return (0, _collection$Y.deepMap)(h, this, !0);
    },
    "Array | Matrix, number": function(h, u) {
      var p = this;
      return (0, _collection$Y.deepMap)(h, function(m) {
        return p(m, u);
      }, !0);
    },
    "SparseMatrix, number | BigNumber": function(h, u) {
      return c(h, u, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(h, u) {
      return l(h, u, this, !1);
    },
    "number | Complex | BigNumber, Array": function(h, u) {
      return l(s(u), h, this, !0).valueOf();
    }
  });
});
ceil$1.createCeil = createCeil;
var cube$1 = {};
Object.defineProperty(cube$1, "__esModule", {
  value: !0
});
cube$1.createCube = void 0;
var _factory$3U = factory$1, _collection$X = collection$1, _index$J = number$2, name$3Q = "cube", dependencies$3Q = ["typed"], createCube = /* @__PURE__ */ (0, _factory$3U.factory)(name$3Q, dependencies$3Q, function(t) {
  var r = t.typed;
  return r(name$3Q, {
    number: _index$J.cubeNumber,
    Complex: function(a) {
      return a.mul(a).mul(a);
    },
    BigNumber: function(a) {
      return a.times(a).times(a);
    },
    Fraction: function(a) {
      return a.pow(3);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$X.deepMap)(a, this, !0);
    },
    Unit: function(a) {
      return a.pow(3);
    }
  });
});
cube$1.createCube = createCube;
var exp$1 = {};
Object.defineProperty(exp$1, "__esModule", {
  value: !0
});
exp$1.createExp = void 0;
var _factory$3T = factory$1, _collection$W = collection$1, _index$I = number$2, name$3P = "exp", dependencies$3P = ["typed"], createExp = /* @__PURE__ */ (0, _factory$3T.factory)(name$3P, dependencies$3P, function(t) {
  var r = t.typed;
  return r(name$3P, {
    number: _index$I.expNumber,
    Complex: function(a) {
      return a.exp();
    },
    BigNumber: function(a) {
      return a.exp();
    },
    "Array | Matrix": function(a) {
      return (0, _collection$W.deepMap)(a, this);
    }
  });
});
exp$1.createExp = createExp;
var expm1$1 = {};
Object.defineProperty(expm1$1, "__esModule", {
  value: !0
});
expm1$1.createExpm1 = void 0;
var _factory$3S = factory$1, _collection$V = collection$1, _index$H = number$2, name$3O = "expm1", dependencies$3O = ["typed", "Complex"], createExpm1 = /* @__PURE__ */ (0, _factory$3S.factory)(name$3O, dependencies$3O, function(t) {
  var r = t.typed, n = t.Complex;
  return r(name$3O, {
    number: _index$H.expm1Number,
    Complex: function(s) {
      var o = Math.exp(s.re);
      return new n(o * Math.cos(s.im) - 1, o * Math.sin(s.im));
    },
    BigNumber: function(s) {
      return s.exp().minus(1);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$V.deepMap)(s, this);
    }
  });
});
expm1$1.createExpm1 = createExpm1;
var fix$1 = {};
Object.defineProperty(fix$1, "__esModule", {
  value: !0
});
fix$1.createFix = void 0;
var _factory$3R = factory$1, _collection$U = collection$1, _algorithm$w = algorithm14, name$3N = "fix", dependencies$3N = ["typed", "Complex", "matrix", "ceil", "floor"], createFix = /* @__PURE__ */ (0, _factory$3R.factory)(name$3N, dependencies$3N, function(t) {
  var r = t.typed, n = t.Complex, a = t.matrix, s = t.ceil, o = t.floor, c = (0, _algorithm$w.createAlgorithm14)({
    typed: r
  });
  return r("fix", {
    number: function(d) {
      return d > 0 ? o(d) : s(d);
    },
    "number, number | BigNumber": function(d, h) {
      return d > 0 ? o(d, h) : s(d, h);
    },
    Complex: function(d) {
      return new n(d.re > 0 ? Math.floor(d.re) : Math.ceil(d.re), d.im > 0 ? Math.floor(d.im) : Math.ceil(d.im));
    },
    "Complex, number | BigNumber": function(d, h) {
      return new n(d.re > 0 ? o(d.re, h) : s(d.re, h), d.im > 0 ? o(d.im, h) : s(d.im, h));
    },
    BigNumber: function(d) {
      return d.isNegative() ? s(d) : o(d);
    },
    "BigNumber, number | BigNumber": function(d, h) {
      return d.isNegative() ? s(d, h) : o(d, h);
    },
    Fraction: function(d) {
      return d.s < 0 ? d.ceil() : d.floor();
    },
    "Fraction, number | BigNumber": function(d, h) {
      return d.s < 0 ? d.ceil(h) : d.floor(h);
    },
    "Array | Matrix": function(d) {
      return (0, _collection$U.deepMap)(d, this, !0);
    },
    "Array | Matrix, number | BigNumber": function(d, h) {
      var u = this;
      return (0, _collection$U.deepMap)(d, function(p) {
        return u(p, h);
      }, !0);
    },
    "number | Complex | BigNumber, Array": function(d, h) {
      return c(a(h), d, this, !0).valueOf();
    }
  });
});
fix$1.createFix = createFix;
var floor$2 = {};
Object.defineProperty(floor$2, "__esModule", {
  value: !0
});
floor$2.createFloor = void 0;
var _decimal = _interopRequireDefault$4(decimalExports), _factory$3Q = factory$1, _collection$T = collection$1, _number$q = number$3, _nearlyEqual$5 = nearlyEqual$1, _algorithm$v = algorithm11, _algorithm2$v = algorithm14;
function _interopRequireDefault$4(t) {
  return t && t.__esModule ? t : { default: t };
}
function _slicedToArray$3(t, r) {
  return _arrayWithHoles$3(t) || _iterableToArrayLimit$3(t, r) || _unsupportedIterableToArray$5(t, r) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$5(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$5(t, r);
  }
}
function _arrayLikeToArray$5(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _iterableToArrayLimit$3(t, r) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], a = !0, s = !1, o = void 0;
    try {
      for (var c = t[Symbol.iterator](), l; !(a = (l = c.next()).done) && (n.push(l.value), !(r && n.length === r)); a = !0)
        ;
    } catch (d) {
      s = !0, o = d;
    } finally {
      try {
        !a && c.return != null && c.return();
      } finally {
        if (s)
          throw o;
      }
    }
    return n;
  }
}
function _arrayWithHoles$3(t) {
  if (Array.isArray(t))
    return t;
}
var name$3M = "floor", dependencies$3M = ["typed", "config", "round", "matrix", "equalScalar"], createFloor = /* @__PURE__ */ (0, _factory$3Q.factory)(name$3M, dependencies$3M, function(t) {
  var r = t.typed, n = t.config, a = t.round, s = t.matrix, o = t.equalScalar, c = (0, _algorithm$v.createAlgorithm11)({
    typed: r,
    equalScalar: o
  }), l = (0, _algorithm2$v.createAlgorithm14)({
    typed: r
  });
  return r("floor", {
    number: function(h) {
      return (0, _number$q.nearlyEqual)(h, a(h), n.epsilon) ? a(h) : Math.floor(h);
    },
    "number, number": function(h, u) {
      if ((0, _number$q.nearlyEqual)(h, a(h, u), n.epsilon))
        return a(h, u);
      var p = "".concat(h, "e").split("e"), m = _slicedToArray$3(p, 2), g = m[0], v = m[1], y = Math.floor(Number("".concat(g, "e").concat(Number(v) + u))), x = "".concat(y, "e").split("e"), _ = _slicedToArray$3(x, 2);
      return g = _[0], v = _[1], Number("".concat(g, "e").concat(Number(v) - u));
    },
    Complex: function(h) {
      return h.floor();
    },
    "Complex, number": function(h, u) {
      return h.floor(u);
    },
    BigNumber: function(h) {
      return (0, _nearlyEqual$5.nearlyEqual)(h, a(h), n.epsilon) ? a(h) : h.floor();
    },
    "BigNumber, BigNumber": function(h, u) {
      return (0, _nearlyEqual$5.nearlyEqual)(h, a(h, u), n.epsilon) ? a(h, u) : h.toDecimalPlaces(u.toNumber(), _decimal.default.ROUND_FLOOR);
    },
    Fraction: function(h) {
      return h.floor();
    },
    "Fraction, number": function(h, u) {
      return h.floor(u);
    },
    "Array | Matrix": function(h) {
      return (0, _collection$T.deepMap)(h, this, !0);
    },
    "Array | Matrix, number": function(h, u) {
      var p = this;
      return (0, _collection$T.deepMap)(h, function(m) {
        return p(m, u);
      }, !0);
    },
    "SparseMatrix, number | BigNumber": function(h, u) {
      return c(h, u, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(h, u) {
      return l(h, u, this, !1);
    },
    "number | Complex | BigNumber, Array": function(h, u) {
      return l(s(u), h, this, !0).valueOf();
    }
  });
});
floor$2.createFloor = createFloor;
var gcd$1 = {}, algorithm01 = {};
Object.defineProperty(algorithm01, "__esModule", {
  value: !0
});
algorithm01.createAlgorithm01 = void 0;
var _factory$3P = factory$1, _DimensionError$e = DimensionError$1, name$3L = "algorithm01", dependencies$3L = ["typed"], createAlgorithm01 = /* @__PURE__ */ (0, _factory$3P.factory)(name$3L, dependencies$3L, function(t) {
  var r = t.typed;
  return function(a, s, o, c) {
    var l = a._data, d = a._size, h = a._datatype, u = s._values, p = s._index, m = s._ptr, g = s._size, v = s._datatype;
    if (d.length !== g.length)
      throw new _DimensionError$e.DimensionError(d.length, g.length);
    if (d[0] !== g[0] || d[1] !== g[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + d + ") must match Matrix B (" + g + ")");
    if (!u)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var y = d[0], x = d[1], _ = typeof h == "string" && h === v ? h : void 0, $ = _ ? r.find(o, [_, _]) : o, b, M, C = [];
    for (b = 0; b < y; b++)
      C[b] = [];
    var S = [], A = [];
    for (M = 0; M < x; M++) {
      for (var D = M + 1, N = m[M], T = m[M + 1], R = N; R < T; R++)
        b = p[R], S[b] = c ? $(u[R], l[b][M]) : $(l[b][M], u[R]), A[b] = D;
      for (b = 0; b < y; b++)
        A[b] === D ? C[b][M] = S[b] : C[b][M] = l[b][M];
    }
    return a.createDenseMatrix({
      data: C,
      size: [y, x],
      datatype: _
    });
  };
});
algorithm01.createAlgorithm01 = createAlgorithm01;
var algorithm04 = {};
Object.defineProperty(algorithm04, "__esModule", {
  value: !0
});
algorithm04.createAlgorithm04 = void 0;
var _factory$3O = factory$1, _DimensionError$d = DimensionError$1, name$3K = "algorithm04", dependencies$3K = ["typed", "equalScalar"], createAlgorithm04 = /* @__PURE__ */ (0, _factory$3O.factory)(name$3K, dependencies$3K, function(t) {
  var r = t.typed, n = t.equalScalar;
  return function(s, o, c) {
    var l = s._values, d = s._index, h = s._ptr, u = s._size, p = s._datatype, m = o._values, g = o._index, v = o._ptr, y = o._size, x = o._datatype;
    if (u.length !== y.length)
      throw new _DimensionError$d.DimensionError(u.length, y.length);
    if (u[0] !== y[0] || u[1] !== y[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + y + ")");
    var _ = u[0], $ = u[1], b, M = n, C = 0, S = c;
    typeof p == "string" && p === x && (b = p, M = r.find(n, [b, b]), C = r.convert(0, b), S = r.find(c, [b, b]));
    var A = l && m ? [] : void 0, D = [], N = [], T = l && m ? [] : void 0, R = l && m ? [] : void 0, F = [], z = [], O, G, I, k, B;
    for (G = 0; G < $; G++) {
      N[G] = D.length;
      var L = G + 1;
      for (k = h[G], B = h[G + 1], I = k; I < B; I++)
        O = d[I], D.push(O), F[O] = L, T && (T[O] = l[I]);
      for (k = v[G], B = v[G + 1], I = k; I < B; I++)
        if (O = g[I], F[O] === L) {
          if (T) {
            var V = S(T[O], m[I]);
            M(V, C) ? F[O] = null : T[O] = V;
          }
        } else
          D.push(O), z[O] = L, R && (R[O] = m[I]);
      if (T && R)
        for (I = N[G]; I < D.length; )
          O = D[I], F[O] === L ? (A[I] = T[O], I++) : z[O] === L ? (A[I] = R[O], I++) : D.splice(I, 1);
    }
    return N[$] = D.length, s.createSparseMatrix({
      values: A,
      index: D,
      ptr: N,
      size: [_, $],
      datatype: b
    });
  };
});
algorithm04.createAlgorithm04 = createAlgorithm04;
var algorithm10 = {};
Object.defineProperty(algorithm10, "__esModule", {
  value: !0
});
algorithm10.createAlgorithm10 = void 0;
var _factory$3N = factory$1, name$3J = "algorithm10", dependencies$3J = ["typed", "DenseMatrix"], createAlgorithm10 = /* @__PURE__ */ (0, _factory$3N.factory)(name$3J, dependencies$3J, function(t) {
  var r = t.typed, n = t.DenseMatrix;
  return function(s, o, c, l) {
    var d = s._values, h = s._index, u = s._ptr, p = s._size, m = s._datatype;
    if (!d)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var g = p[0], v = p[1], y, x = c;
    typeof m == "string" && (y = m, o = r.convert(o, y), x = r.find(c, [y, y]));
    for (var _ = [], $ = [], b = [], M = 0; M < v; M++) {
      for (var C = M + 1, S = u[M], A = u[M + 1], D = S; D < A; D++) {
        var N = h[D];
        $[N] = d[D], b[N] = C;
      }
      for (var T = 0; T < g; T++)
        M === 0 && (_[T] = []), b[T] === C ? _[T][M] = l ? x(o, $[T]) : x($[T], o) : _[T][M] = o;
    }
    return new n({
      data: _,
      size: [g, v],
      datatype: y
    });
  };
});
algorithm10.createAlgorithm10 = createAlgorithm10;
var algorithm13 = {};
Object.defineProperty(algorithm13, "__esModule", {
  value: !0
});
algorithm13.createAlgorithm13 = void 0;
var _factory$3M = factory$1, _DimensionError$c = DimensionError$1, name$3I = "algorithm13", dependencies$3I = ["typed"], createAlgorithm13 = /* @__PURE__ */ (0, _factory$3M.factory)(name$3I, dependencies$3I, function(t) {
  var r = t.typed;
  return function(s, o, c) {
    var l = s._data, d = s._size, h = s._datatype, u = o._data, p = o._size, m = o._datatype, g = [];
    if (d.length !== p.length)
      throw new _DimensionError$c.DimensionError(d.length, p.length);
    for (var v = 0; v < d.length; v++) {
      if (d[v] !== p[v])
        throw new RangeError("Dimension mismatch. Matrix A (" + d + ") must match Matrix B (" + p + ")");
      g[v] = d[v];
    }
    var y, x = c;
    typeof h == "string" && h === m && (y = h, x = r.find(c, [y, y]));
    var _ = g.length > 0 ? n(x, 0, g, g[0], l, u) : [];
    return s.createDenseMatrix({
      data: _,
      size: g,
      datatype: y
    });
  };
  function n(a, s, o, c, l, d) {
    var h = [];
    if (s === o.length - 1)
      for (var u = 0; u < c; u++)
        h[u] = a(l[u], d[u]);
    else
      for (var p = 0; p < c; p++)
        h[p] = n(a, s + 1, o, o[s + 1], l[p], d[p]);
    return h;
  }
});
algorithm13.createAlgorithm13 = createAlgorithm13;
Object.defineProperty(gcd$1, "__esModule", {
  value: !0
});
gcd$1.createGcd = void 0;
var _factory$3L = factory$1, _algorithm$u = algorithm01, _algorithm2$u = algorithm04, _algorithm3$q = algorithm10, _algorithm4$p = algorithm13, _algorithm5$p = algorithm14, _index$G = number$2, name$3H = "gcd", dependencies$3H = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix"], createGcd = /* @__PURE__ */ (0, _factory$3L.factory)(name$3H, dependencies$3H, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.BigNumber, o = t.DenseMatrix, c = (0, _algorithm$u.createAlgorithm01)({
    typed: r
  }), l = (0, _algorithm2$u.createAlgorithm04)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm3$q.createAlgorithm10)({
    typed: r,
    DenseMatrix: o
  }), h = (0, _algorithm4$p.createAlgorithm13)({
    typed: r
  }), u = (0, _algorithm5$p.createAlgorithm14)({
    typed: r
  });
  return r(name$3H, {
    "number, number": _index$G.gcdNumber,
    "BigNumber, BigNumber": p,
    "Fraction, Fraction": function(g, v) {
      return g.gcd(v);
    },
    "SparseMatrix, SparseMatrix": function(g, v) {
      return l(g, v, this);
    },
    "SparseMatrix, DenseMatrix": function(g, v) {
      return c(v, g, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(g, v) {
      return c(g, v, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(g, v) {
      return h(g, v, this);
    },
    "Array, Array": function(g, v) {
      return this(n(g), n(v)).valueOf();
    },
    "Array, Matrix": function(g, v) {
      return this(n(g), v);
    },
    "Matrix, Array": function(g, v) {
      return this(g, n(v));
    },
    "SparseMatrix, number | BigNumber": function(g, v) {
      return d(g, v, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(g, v) {
      return u(g, v, this, !1);
    },
    "number | BigNumber, SparseMatrix": function(g, v) {
      return d(v, g, this, !0);
    },
    "number | BigNumber, DenseMatrix": function(g, v) {
      return u(v, g, this, !0);
    },
    "Array, number | BigNumber": function(g, v) {
      return u(n(g), v, this, !1).valueOf();
    },
    "number | BigNumber, Array": function(g, v) {
      return u(n(v), g, this, !0).valueOf();
    },
    // TODO: need a smarter notation here
    "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function(g, v, y) {
      for (var x = this(g, v), _ = 0; _ < y.length; _++)
        x = this(x, y[_]);
      return x;
    }
  });
  function p(m, g) {
    if (!m.isInt() || !g.isInt())
      throw new Error("Parameters in function gcd must be integer numbers");
    for (var v = new s(0); !g.isZero(); ) {
      var y = m.mod(g);
      m = g, g = y;
    }
    return m.lt(v) ? m.neg() : m;
  }
});
gcd$1.createGcd = createGcd;
var lcm$1 = {}, algorithm02 = {};
Object.defineProperty(algorithm02, "__esModule", {
  value: !0
});
algorithm02.createAlgorithm02 = void 0;
var _factory$3K = factory$1, _DimensionError$b = DimensionError$1, name$3G = "algorithm02", dependencies$3G = ["typed", "equalScalar"], createAlgorithm02 = /* @__PURE__ */ (0, _factory$3K.factory)(name$3G, dependencies$3G, function(t) {
  var r = t.typed, n = t.equalScalar;
  return function(s, o, c, l) {
    var d = s._data, h = s._size, u = s._datatype, p = o._values, m = o._index, g = o._ptr, v = o._size, y = o._datatype;
    if (h.length !== v.length)
      throw new _DimensionError$b.DimensionError(h.length, v.length);
    if (h[0] !== v[0] || h[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + h + ") must match Matrix B (" + v + ")");
    if (!p)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var x = h[0], _ = h[1], $, b = n, M = 0, C = c;
    typeof u == "string" && u === y && ($ = u, b = r.find(n, [$, $]), M = r.convert(0, $), C = r.find(c, [$, $]));
    for (var S = [], A = [], D = [], N = 0; N < _; N++) {
      D[N] = A.length;
      for (var T = g[N], R = g[N + 1], F = T; F < R; F++) {
        var z = m[F], O = l ? C(p[F], d[z][N]) : C(d[z][N], p[F]);
        b(O, M) || (A.push(z), S.push(O));
      }
    }
    return D[_] = A.length, o.createSparseMatrix({
      values: S,
      index: A,
      ptr: D,
      size: [x, _],
      datatype: $
    });
  };
});
algorithm02.createAlgorithm02 = createAlgorithm02;
var algorithm06 = {};
Object.defineProperty(algorithm06, "__esModule", {
  value: !0
});
algorithm06.createAlgorithm06 = void 0;
var _factory$3J = factory$1, _DimensionError$a = DimensionError$1, _collection$S = collection$1, name$3F = "algorithm06", dependencies$3F = ["typed", "equalScalar"], createAlgorithm06 = /* @__PURE__ */ (0, _factory$3J.factory)(name$3F, dependencies$3F, function(t) {
  var r = t.typed, n = t.equalScalar;
  return function(s, o, c) {
    var l = s._values, d = s._size, h = s._datatype, u = o._values, p = o._size, m = o._datatype;
    if (d.length !== p.length)
      throw new _DimensionError$a.DimensionError(d.length, p.length);
    if (d[0] !== p[0] || d[1] !== p[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + d + ") must match Matrix B (" + p + ")");
    var g = d[0], v = d[1], y, x = n, _ = 0, $ = c;
    typeof h == "string" && h === m && (y = h, x = r.find(n, [y, y]), _ = r.convert(0, y), $ = r.find(c, [y, y]));
    for (var b = l && u ? [] : void 0, M = [], C = [], S = b ? [] : void 0, A = [], D = [], N = 0; N < v; N++) {
      C[N] = M.length;
      var T = N + 1;
      if ((0, _collection$S.scatter)(s, N, A, S, D, T, M, $), (0, _collection$S.scatter)(o, N, A, S, D, T, M, $), S)
        for (var R = C[N]; R < M.length; ) {
          var F = M[R];
          if (D[F] === T) {
            var z = S[F];
            x(z, _) ? M.splice(R, 1) : (b.push(z), R++);
          } else
            M.splice(R, 1);
        }
      else
        for (var O = C[N]; O < M.length; ) {
          var G = M[O];
          D[G] !== T ? M.splice(O, 1) : O++;
        }
    }
    return C[v] = M.length, s.createSparseMatrix({
      values: b,
      index: M,
      ptr: C,
      size: [g, v],
      datatype: y
    });
  };
});
algorithm06.createAlgorithm06 = createAlgorithm06;
Object.defineProperty(lcm$1, "__esModule", {
  value: !0
});
lcm$1.createLcm = void 0;
var _factory$3I = factory$1, _algorithm$t = algorithm02, _algorithm2$t = algorithm06, _algorithm3$p = algorithm11, _algorithm4$o = algorithm13, _algorithm5$o = algorithm14, _index$F = number$2, name$3E = "lcm", dependencies$3E = ["typed", "matrix", "equalScalar"], createLcm = /* @__PURE__ */ (0, _factory$3I.factory)(name$3E, dependencies$3E, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = (0, _algorithm$t.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), o = (0, _algorithm2$t.createAlgorithm06)({
    typed: r,
    equalScalar: a
  }), c = (0, _algorithm3$p.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm4$o.createAlgorithm13)({
    typed: r
  }), d = (0, _algorithm5$o.createAlgorithm14)({
    typed: r
  });
  return r(name$3E, {
    "number, number": _index$F.lcmNumber,
    "BigNumber, BigNumber": h,
    "Fraction, Fraction": function(p, m) {
      return p.lcm(m);
    },
    "SparseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, this);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return s(m, p, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return s(p, m, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return l(p, m, this);
    },
    "Array, Array": function(p, m) {
      return this(n(p), n(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(n(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, n(m));
    },
    "SparseMatrix, number | BigNumber": function(p, m) {
      return c(p, m, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(p, m) {
      return d(p, m, this, !1);
    },
    "number | BigNumber, SparseMatrix": function(p, m) {
      return c(m, p, this, !0);
    },
    "number | BigNumber, DenseMatrix": function(p, m) {
      return d(m, p, this, !0);
    },
    "Array, number | BigNumber": function(p, m) {
      return d(n(p), m, this, !1).valueOf();
    },
    "number | BigNumber, Array": function(p, m) {
      return d(n(m), p, this, !0).valueOf();
    },
    // TODO: need a smarter notation here
    "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function(p, m, g) {
      for (var v = this(p, m), y = 0; y < g.length; y++)
        v = this(v, g[y]);
      return v;
    }
  });
  function h(u, p) {
    if (!u.isInt() || !p.isInt())
      throw new Error("Parameters in function lcm must be integer numbers");
    if (u.isZero())
      return u;
    if (p.isZero())
      return p;
    for (var m = u.times(p); !p.isZero(); ) {
      var g = p;
      p = u.mod(g), u = g;
    }
    return m.div(u).abs();
  }
});
lcm$1.createLcm = createLcm;
var log10$1 = {};
Object.defineProperty(log10$1, "__esModule", {
  value: !0
});
log10$1.createLog10 = void 0;
var _factory$3H = factory$1, _collection$R = collection$1, _index$E = number$2, name$3D = "log10", dependencies$3D = ["typed", "config", "Complex"], createLog10 = /* @__PURE__ */ (0, _factory$3H.factory)(name$3D, dependencies$3D, function(t) {
  var r = t.typed, n = t.config, a = t.Complex;
  return r(name$3D, {
    number: function(o) {
      return o >= 0 || n.predictable ? (0, _index$E.log10Number)(o) : new a(o, 0).log().div(Math.LN10);
    },
    Complex: function(o) {
      return new a(o).log().div(Math.LN10);
    },
    BigNumber: function(o) {
      return !o.isNegative() || n.predictable ? o.log() : new a(o.toNumber(), 0).log().div(Math.LN10);
    },
    "Array | Matrix": function(o) {
      return (0, _collection$R.deepMap)(o, this);
    }
  });
});
log10$1.createLog10 = createLog10;
var log2$1 = {};
Object.defineProperty(log2$1, "__esModule", {
  value: !0
});
log2$1.createLog2 = void 0;
var _factory$3G = factory$1, _collection$Q = collection$1, _index$D = number$2, name$3C = "log2", dependencies$3C = ["typed", "config", "Complex"], createLog2 = /* @__PURE__ */ (0, _factory$3G.factory)(name$3C, dependencies$3C, function(t) {
  var r = t.typed, n = t.config, a = t.Complex;
  return r(name$3C, {
    number: function(c) {
      return c >= 0 || n.predictable ? (0, _index$D.log2Number)(c) : s(new a(c, 0));
    },
    Complex: s,
    BigNumber: function(c) {
      return !c.isNegative() || n.predictable ? c.log(2) : s(new a(c.toNumber(), 0));
    },
    "Array | Matrix": function(c) {
      return (0, _collection$Q.deepMap)(c, this);
    }
  });
  function s(o) {
    var c = Math.sqrt(o.re * o.re + o.im * o.im);
    return new a(Math.log2 ? Math.log2(c) : Math.log(c) / Math.LN2, Math.atan2(o.im, o.re) / Math.LN2);
  }
});
log2$1.createLog2 = createLog2;
var mod$3 = {}, algorithm03 = {};
Object.defineProperty(algorithm03, "__esModule", {
  value: !0
});
algorithm03.createAlgorithm03 = void 0;
var _factory$3F = factory$1, _DimensionError$9 = DimensionError$1, name$3B = "algorithm03", dependencies$3B = ["typed"], createAlgorithm03 = /* @__PURE__ */ (0, _factory$3F.factory)(name$3B, dependencies$3B, function(t) {
  var r = t.typed;
  return function(a, s, o, c) {
    var l = a._data, d = a._size, h = a._datatype, u = s._values, p = s._index, m = s._ptr, g = s._size, v = s._datatype;
    if (d.length !== g.length)
      throw new _DimensionError$9.DimensionError(d.length, g.length);
    if (d[0] !== g[0] || d[1] !== g[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + d + ") must match Matrix B (" + g + ")");
    if (!u)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var y = d[0], x = d[1], _, $ = 0, b = o;
    typeof h == "string" && h === v && (_ = h, $ = r.convert(0, _), b = r.find(o, [_, _]));
    for (var M = [], C = 0; C < y; C++)
      M[C] = [];
    for (var S = [], A = [], D = 0; D < x; D++) {
      for (var N = D + 1, T = m[D], R = m[D + 1], F = T; F < R; F++) {
        var z = p[F];
        S[z] = c ? b(u[F], l[z][D]) : b(l[z][D], u[F]), A[z] = N;
      }
      for (var O = 0; O < y; O++)
        A[O] === N ? M[O][D] = S[O] : M[O][D] = c ? b($, l[O][D]) : b(l[O][D], $);
    }
    return a.createDenseMatrix({
      data: M,
      size: [y, x],
      datatype: _
    });
  };
});
algorithm03.createAlgorithm03 = createAlgorithm03;
var algorithm05 = {};
Object.defineProperty(algorithm05, "__esModule", {
  value: !0
});
algorithm05.createAlgorithm05 = void 0;
var _factory$3E = factory$1, _DimensionError$8 = DimensionError$1, name$3A = "algorithm05", dependencies$3A = ["typed", "equalScalar"], createAlgorithm05 = /* @__PURE__ */ (0, _factory$3E.factory)(name$3A, dependencies$3A, function(t) {
  var r = t.typed, n = t.equalScalar;
  return function(s, o, c) {
    var l = s._values, d = s._index, h = s._ptr, u = s._size, p = s._datatype, m = o._values, g = o._index, v = o._ptr, y = o._size, x = o._datatype;
    if (u.length !== y.length)
      throw new _DimensionError$8.DimensionError(u.length, y.length);
    if (u[0] !== y[0] || u[1] !== y[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + y + ")");
    var _ = u[0], $ = u[1], b, M = n, C = 0, S = c;
    typeof p == "string" && p === x && (b = p, M = r.find(n, [b, b]), C = r.convert(0, b), S = r.find(c, [b, b]));
    var A = l && m ? [] : void 0, D = [], N = [], T = A ? [] : void 0, R = A ? [] : void 0, F = [], z = [], O, G, I, k;
    for (G = 0; G < $; G++) {
      N[G] = D.length;
      var B = G + 1;
      for (I = h[G], k = h[G + 1]; I < k; I++)
        O = d[I], D.push(O), F[O] = B, T && (T[O] = l[I]);
      for (I = v[G], k = v[G + 1]; I < k; I++)
        O = g[I], F[O] !== B && D.push(O), z[O] = B, R && (R[O] = m[I]);
      if (A)
        for (I = N[G]; I < D.length; ) {
          O = D[I];
          var L = F[O], V = z[O];
          if (L === B || V === B) {
            var U = L === B ? T[O] : C, J = V === B ? R[O] : C, q = S(U, J);
            M(q, C) ? D.splice(I, 1) : (A.push(q), I++);
          }
        }
    }
    return N[$] = D.length, s.createSparseMatrix({
      values: A,
      index: D,
      ptr: N,
      size: [_, $],
      datatype: b
    });
  };
});
algorithm05.createAlgorithm05 = createAlgorithm05;
var algorithm12 = {};
Object.defineProperty(algorithm12, "__esModule", {
  value: !0
});
algorithm12.createAlgorithm12 = void 0;
var _factory$3D = factory$1, name$3z = "algorithm12", dependencies$3z = ["typed", "DenseMatrix"], createAlgorithm12 = /* @__PURE__ */ (0, _factory$3D.factory)(name$3z, dependencies$3z, function(t) {
  var r = t.typed, n = t.DenseMatrix;
  return function(s, o, c, l) {
    var d = s._values, h = s._index, u = s._ptr, p = s._size, m = s._datatype;
    if (!d)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var g = p[0], v = p[1], y, x = c;
    typeof m == "string" && (y = m, o = r.convert(o, y), x = r.find(c, [y, y]));
    for (var _ = [], $ = [], b = [], M = 0; M < v; M++) {
      for (var C = M + 1, S = u[M], A = u[M + 1], D = S; D < A; D++) {
        var N = h[D];
        $[N] = d[D], b[N] = C;
      }
      for (var T = 0; T < g; T++)
        M === 0 && (_[T] = []), b[T] === C ? _[T][M] = l ? x(o, $[T]) : x($[T], o) : _[T][M] = l ? x(o, 0) : x(0, o);
    }
    return new n({
      data: _,
      size: [g, v],
      datatype: y
    });
  };
});
algorithm12.createAlgorithm12 = createAlgorithm12;
Object.defineProperty(mod$3, "__esModule", {
  value: !0
});
mod$3.createMod = void 0;
var _factory$3C = factory$1, _algorithm$s = algorithm02, _algorithm2$s = algorithm03, _algorithm3$o = algorithm05, _algorithm4$n = algorithm11, _algorithm5$n = algorithm12, _algorithm6$8 = algorithm13, _algorithm7$5 = algorithm14, _index$C = number$2, name$3y = "mod", dependencies$3y = ["typed", "matrix", "equalScalar", "DenseMatrix"], createMod = /* @__PURE__ */ (0, _factory$3C.factory)(name$3y, dependencies$3y, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.DenseMatrix, o = (0, _algorithm$s.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), c = (0, _algorithm2$s.createAlgorithm03)({
    typed: r
  }), l = (0, _algorithm3$o.createAlgorithm05)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm4$n.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), h = (0, _algorithm5$n.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), u = (0, _algorithm6$8.createAlgorithm13)({
    typed: r
  }), p = (0, _algorithm7$5.createAlgorithm14)({
    typed: r
  });
  return r(name$3y, {
    "number, number": _index$C.modNumber,
    "BigNumber, BigNumber": function(g, v) {
      if (v.isNeg())
        throw new Error("Cannot calculate mod for a negative divisor");
      return v.isZero() ? g : g.mod(v);
    },
    "Fraction, Fraction": function(g, v) {
      if (v.compare(0) < 0)
        throw new Error("Cannot calculate mod for a negative divisor");
      return g.compare(0) >= 0 ? g.mod(v) : g.mod(v).add(v).mod(v);
    },
    "SparseMatrix, SparseMatrix": function(g, v) {
      return l(g, v, this, !1);
    },
    "SparseMatrix, DenseMatrix": function(g, v) {
      return o(v, g, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(g, v) {
      return c(g, v, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(g, v) {
      return u(g, v, this);
    },
    "Array, Array": function(g, v) {
      return this(n(g), n(v)).valueOf();
    },
    "Array, Matrix": function(g, v) {
      return this(n(g), v);
    },
    "Matrix, Array": function(g, v) {
      return this(g, n(v));
    },
    "SparseMatrix, any": function(g, v) {
      return d(g, v, this, !1);
    },
    "DenseMatrix, any": function(g, v) {
      return p(g, v, this, !1);
    },
    "any, SparseMatrix": function(g, v) {
      return h(v, g, this, !0);
    },
    "any, DenseMatrix": function(g, v) {
      return p(v, g, this, !0);
    },
    "Array, any": function(g, v) {
      return p(n(g), v, this, !1).valueOf();
    },
    "any, Array": function(g, v) {
      return p(n(v), g, this, !0).valueOf();
    }
  });
});
mod$3.createMod = createMod;
var multiplyScalar = {};
Object.defineProperty(multiplyScalar, "__esModule", {
  value: !0
});
multiplyScalar.createMultiplyScalar = void 0;
var _factory$3B = factory$1, _index$B = number$2, name$3x = "multiplyScalar", dependencies$3x = ["typed"], createMultiplyScalar = /* @__PURE__ */ (0, _factory$3B.factory)(name$3x, dependencies$3x, function(t) {
  var r = t.typed;
  return r("multiplyScalar", {
    "number, number": _index$B.multiplyNumber,
    "Complex, Complex": function(a, s) {
      return a.mul(s);
    },
    "BigNumber, BigNumber": function(a, s) {
      return a.times(s);
    },
    "Fraction, Fraction": function(a, s) {
      return a.mul(s);
    },
    "number | Fraction | BigNumber | Complex, Unit": function(a, s) {
      var o = s.clone();
      return o.value = o.value === null ? o._normalize(a) : this(o.value, a), o;
    },
    "Unit, number | Fraction | BigNumber | Complex": function(a, s) {
      var o = a.clone();
      return o.value = o.value === null ? o._normalize(s) : this(o.value, s), o;
    },
    "Unit, Unit": function(a, s) {
      return a.multiply(s);
    }
  });
});
multiplyScalar.createMultiplyScalar = createMultiplyScalar;
var multiply$1 = {};
Object.defineProperty(multiply$1, "__esModule", {
  value: !0
});
multiply$1.createMultiply = void 0;
var _factory$3A = factory$1, _is$1b = is, _object$w = object, _array$P = array, _algorithm$r = algorithm11, _algorithm2$r = algorithm14, name$3w = "multiply", dependencies$3w = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], createMultiply = /* @__PURE__ */ (0, _factory$3A.factory)(name$3w, dependencies$3w, function(t) {
  var r = t.typed, n = t.matrix, a = t.addScalar, s = t.multiplyScalar, o = t.equalScalar, c = t.dot, l = (0, _algorithm$r.createAlgorithm11)({
    typed: r,
    equalScalar: o
  }), d = (0, _algorithm2$r.createAlgorithm14)({
    typed: r
  });
  function h(C, S) {
    switch (C.length) {
      case 1:
        switch (S.length) {
          case 1:
            if (C[0] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (C[0] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Vector length (" + C[0] + ") must match Matrix rows (" + S[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + S.length + " dimensions)");
        }
        break;
      case 2:
        switch (S.length) {
          case 1:
            if (C[1] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + C[1] + ") must match Vector length (" + S[0] + ")");
            break;
          case 2:
            if (C[1] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + C[1] + ") must match Matrix B rows (" + S[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + S.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + C.length + " dimensions)");
    }
  }
  function u(C, S, A) {
    if (A === 0)
      throw new Error("Cannot multiply two empty vectors");
    return c(C, S);
  }
  function p(C, S) {
    if (S.storage() !== "dense")
      throw new Error("Support for SparseMatrix not implemented");
    return m(C, S);
  }
  function m(C, S) {
    var A = C._data, D = C._size, N = C._datatype, T = S._data, R = S._size, F = S._datatype, z = D[0], O = R[1], G, I = a, k = s;
    N && F && N === F && typeof N == "string" && (G = N, I = r.find(a, [G, G]), k = r.find(s, [G, G]));
    for (var B = [], L = 0; L < O; L++) {
      for (var V = k(A[0], T[0][L]), U = 1; U < z; U++)
        V = I(V, k(A[U], T[U][L]));
      B[L] = V;
    }
    return C.createDenseMatrix({
      data: B,
      size: [O],
      datatype: G
    });
  }
  var g = r("_multiplyMatrixVector", {
    "DenseMatrix, any": y,
    "SparseMatrix, any": $
  }), v = r("_multiplyMatrixMatrix", {
    "DenseMatrix, DenseMatrix": x,
    "DenseMatrix, SparseMatrix": _,
    "SparseMatrix, DenseMatrix": b,
    "SparseMatrix, SparseMatrix": M
  });
  function y(C, S) {
    var A = C._data, D = C._size, N = C._datatype, T = S._data, R = S._datatype, F = D[0], z = D[1], O, G = a, I = s;
    N && R && N === R && typeof N == "string" && (O = N, G = r.find(a, [O, O]), I = r.find(s, [O, O]));
    for (var k = [], B = 0; B < F; B++) {
      for (var L = A[B], V = I(L[0], T[0]), U = 1; U < z; U++)
        V = G(V, I(L[U], T[U]));
      k[B] = V;
    }
    return C.createDenseMatrix({
      data: k,
      size: [F],
      datatype: O
    });
  }
  function x(C, S) {
    var A = C._data, D = C._size, N = C._datatype, T = S._data, R = S._size, F = S._datatype, z = D[0], O = D[1], G = R[1], I, k = a, B = s;
    N && F && N === F && typeof N == "string" && (I = N, k = r.find(a, [I, I]), B = r.find(s, [I, I]));
    for (var L = [], V = 0; V < z; V++) {
      var U = A[V];
      L[V] = [];
      for (var J = 0; J < G; J++) {
        for (var q = B(U[0], T[0][J]), Z = 1; Z < O; Z++)
          q = k(q, B(U[Z], T[Z][J]));
        L[V][J] = q;
      }
    }
    return C.createDenseMatrix({
      data: L,
      size: [z, G],
      datatype: I
    });
  }
  function _(C, S) {
    var A = C._data, D = C._size, N = C._datatype, T = S._values, R = S._index, F = S._ptr, z = S._size, O = S._datatype;
    if (!T)
      throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var G = D[0], I = z[1], k, B = a, L = s, V = o, U = 0;
    N && O && N === O && typeof N == "string" && (k = N, B = r.find(a, [k, k]), L = r.find(s, [k, k]), V = r.find(o, [k, k]), U = r.convert(0, k));
    for (var J = [], q = [], Z = [], ae = S.createSparseMatrix({
      values: J,
      index: q,
      ptr: Z,
      size: [G, I],
      datatype: k
    }), ee = 0; ee < I; ee++) {
      Z[ee] = q.length;
      var se = F[ee], nr = F[ee + 1];
      if (nr > se)
        for (var ce = 0, oe = 0; oe < G; oe++) {
          for (var ur = oe + 1, ir = void 0, _r = se; _r < nr; _r++) {
            var yr = R[_r];
            ce !== ur ? (ir = L(A[oe][yr], T[_r]), ce = ur) : ir = B(ir, L(A[oe][yr], T[_r]));
          }
          ce === ur && !V(ir, U) && (q.push(oe), J.push(ir));
        }
    }
    return Z[I] = q.length, ae;
  }
  function $(C, S) {
    var A = C._values, D = C._index, N = C._ptr, T = C._datatype;
    if (!A)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var R = S._data, F = S._datatype, z = C._size[0], O = S._size[0], G = [], I = [], k = [], B, L = a, V = s, U = o, J = 0;
    T && F && T === F && typeof T == "string" && (B = T, L = r.find(a, [B, B]), V = r.find(s, [B, B]), U = r.find(o, [B, B]), J = r.convert(0, B));
    var q = [], Z = [];
    k[0] = 0;
    for (var ae = 0; ae < O; ae++) {
      var ee = R[ae];
      if (!U(ee, J))
        for (var se = N[ae], nr = N[ae + 1], ce = se; ce < nr; ce++) {
          var oe = D[ce];
          Z[oe] ? q[oe] = L(q[oe], V(ee, A[ce])) : (Z[oe] = !0, I.push(oe), q[oe] = V(ee, A[ce]));
        }
    }
    for (var ur = I.length, ir = 0; ir < ur; ir++) {
      var _r = I[ir];
      G[ir] = q[_r];
    }
    return k[1] = I.length, C.createSparseMatrix({
      values: G,
      index: I,
      ptr: k,
      size: [z, 1],
      datatype: B
    });
  }
  function b(C, S) {
    var A = C._values, D = C._index, N = C._ptr, T = C._datatype;
    if (!A)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var R = S._data, F = S._datatype, z = C._size[0], O = S._size[0], G = S._size[1], I, k = a, B = s, L = o, V = 0;
    T && F && T === F && typeof T == "string" && (I = T, k = r.find(a, [I, I]), B = r.find(s, [I, I]), L = r.find(o, [I, I]), V = r.convert(0, I));
    for (var U = [], J = [], q = [], Z = C.createSparseMatrix({
      values: U,
      index: J,
      ptr: q,
      size: [z, G],
      datatype: I
    }), ae = [], ee = [], se = 0; se < G; se++) {
      q[se] = J.length;
      for (var nr = se + 1, ce = 0; ce < O; ce++) {
        var oe = R[ce][se];
        if (!L(oe, V))
          for (var ur = N[ce], ir = N[ce + 1], _r = ur; _r < ir; _r++) {
            var yr = D[_r];
            ee[yr] !== nr ? (ee[yr] = nr, J.push(yr), ae[yr] = B(oe, A[_r])) : ae[yr] = k(ae[yr], B(oe, A[_r]));
          }
      }
      for (var ne = q[se], pe = J.length, hr = ne; hr < pe; hr++) {
        var $r = J[hr];
        U[hr] = ae[$r];
      }
    }
    return q[G] = J.length, Z;
  }
  function M(C, S) {
    var A = C._values, D = C._index, N = C._ptr, T = C._datatype, R = S._values, F = S._index, z = S._ptr, O = S._datatype, G = C._size[0], I = S._size[1], k = A && R, B, L = a, V = s;
    T && O && T === O && typeof T == "string" && (B = T, L = r.find(a, [B, B]), V = r.find(s, [B, B]));
    for (var U = k ? [] : void 0, J = [], q = [], Z = C.createSparseMatrix({
      values: U,
      index: J,
      ptr: q,
      size: [G, I],
      datatype: B
    }), ae = k ? [] : void 0, ee = [], se, nr, ce, oe, ur, ir, _r, yr, ne = 0; ne < I; ne++) {
      q[ne] = J.length;
      var pe = ne + 1;
      for (ur = z[ne], ir = z[ne + 1], oe = ur; oe < ir; oe++)
        if (yr = F[oe], k)
          for (nr = N[yr], ce = N[yr + 1], se = nr; se < ce; se++)
            _r = D[se], ee[_r] !== pe ? (ee[_r] = pe, J.push(_r), ae[_r] = V(R[oe], A[se])) : ae[_r] = L(ae[_r], V(R[oe], A[se]));
        else
          for (nr = N[yr], ce = N[yr + 1], se = nr; se < ce; se++)
            _r = D[se], ee[_r] !== pe && (ee[_r] = pe, J.push(_r));
      if (k)
        for (var hr = q[ne], $r = J.length, Sr = hr; Sr < $r; Sr++) {
          var ze = J[Sr];
          U[Sr] = ae[ze];
        }
    }
    return q[I] = J.length, Z;
  }
  return r(name$3w, (0, _object$w.extend)({
    // we extend the signatures of multiplyScalar with signatures dealing with matrices
    "Array, Array": function(S, A) {
      h((0, _array$P.arraySize)(S), (0, _array$P.arraySize)(A));
      var D = this(n(S), n(A));
      return (0, _is$1b.isMatrix)(D) ? D.valueOf() : D;
    },
    "Matrix, Matrix": function(S, A) {
      var D = S.size(), N = A.size();
      return h(D, N), D.length === 1 ? N.length === 1 ? u(S, A, D[0]) : p(S, A) : N.length === 1 ? g(S, A) : v(S, A);
    },
    "Matrix, Array": function(S, A) {
      return this(S, n(A));
    },
    "Array, Matrix": function(S, A) {
      return this(n(S, A.storage()), A);
    },
    "SparseMatrix, any": function(S, A) {
      return l(S, A, s, !1);
    },
    "DenseMatrix, any": function(S, A) {
      return d(S, A, s, !1);
    },
    "any, SparseMatrix": function(S, A) {
      return l(A, S, s, !0);
    },
    "any, DenseMatrix": function(S, A) {
      return d(A, S, s, !0);
    },
    "Array, any": function(S, A) {
      return d(n(S), A, s, !1).valueOf();
    },
    "any, Array": function(S, A) {
      return d(n(A), S, s, !0).valueOf();
    },
    "any, any": s,
    "any, any, ...any": function(S, A, D) {
      for (var N = this(S, A), T = 0; T < D.length; T++)
        N = this(N, D[T]);
      return N;
    }
  }, s.signatures));
});
multiply$1.createMultiply = createMultiply;
var nthRoot$1 = {};
Object.defineProperty(nthRoot$1, "__esModule", {
  value: !0
});
nthRoot$1.createNthRootNumber = nthRoot$1.createNthRoot = void 0;
var _factory$3z = factory$1, _algorithm$q = algorithm01, _algorithm2$q = algorithm02, _algorithm3$n = algorithm06, _algorithm4$m = algorithm11, _algorithm5$m = algorithm13, _algorithm6$7 = algorithm14, _index$A = number$2, name$3v = "nthRoot", dependencies$3v = ["typed", "matrix", "equalScalar", "BigNumber"], createNthRoot = /* @__PURE__ */ (0, _factory$3z.factory)(name$3v, dependencies$3v, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.BigNumber, o = (0, _algorithm$q.createAlgorithm01)({
    typed: r
  }), c = (0, _algorithm2$q.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm3$n.createAlgorithm06)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm4$m.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), h = (0, _algorithm5$m.createAlgorithm13)({
    typed: r
  }), u = (0, _algorithm6$7.createAlgorithm14)({
    typed: r
  }), p = "Complex number not supported in function nthRoot. Use nthRoots instead.";
  return r(name$3v, {
    number: function(v) {
      return (0, _index$A.nthRootNumber)(v, 2);
    },
    "number, number": _index$A.nthRootNumber,
    BigNumber: function(v) {
      return m(v, new s(2));
    },
    Complex: function(v) {
      throw new Error(p);
    },
    "Complex, number": function(v, y) {
      throw new Error(p);
    },
    "BigNumber, BigNumber": m,
    "Array | Matrix": function(v) {
      return this(v, 2);
    },
    "SparseMatrix, SparseMatrix": function(v, y) {
      if (y.density() === 1)
        return l(v, y, this);
      throw new Error("Root must be non-zero");
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return c(y, v, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      if (y.density() === 1)
        return o(v, y, this, !1);
      throw new Error("Root must be non-zero");
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return h(v, y, this);
    },
    "Array, Array": function(v, y) {
      return this(n(v), n(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(n(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, n(y));
    },
    "SparseMatrix, number | BigNumber": function(v, y) {
      return d(v, y, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(v, y) {
      return u(v, y, this, !1);
    },
    "number | BigNumber, SparseMatrix": function(v, y) {
      if (y.density() === 1)
        return d(y, v, this, !0);
      throw new Error("Root must be non-zero");
    },
    "number | BigNumber, DenseMatrix": function(v, y) {
      return u(y, v, this, !0);
    },
    "Array, number | BigNumber": function(v, y) {
      return this(n(v), y).valueOf();
    },
    "number | BigNumber, Array": function(v, y) {
      return this(v, n(y)).valueOf();
    }
  });
  function m(g, v) {
    var y = s.precision, x = s.clone({
      precision: y + 2
    }), _ = new s(0), $ = new x(1), b = v.isNegative();
    if (b && (v = v.neg()), v.isZero())
      throw new Error("Root must be non-zero");
    if (g.isNegative() && !v.abs().mod(2).equals(1))
      throw new Error("Root must be odd when a is negative.");
    if (g.isZero())
      return b ? new x(1 / 0) : 0;
    if (!g.isFinite())
      return b ? _ : g;
    var M = g.abs().pow($.div(v));
    return M = g.isNeg() ? M.neg() : M, new s((b ? $.div(M) : M).toPrecision(y));
  }
});
nthRoot$1.createNthRoot = createNthRoot;
var createNthRootNumber = /* @__PURE__ */ (0, _factory$3z.factory)(name$3v, ["typed"], function(t) {
  var r = t.typed;
  return r(name$3v, {
    number: _index$A.nthRootNumber,
    "number, number": _index$A.nthRootNumber
  });
});
nthRoot$1.createNthRootNumber = createNthRootNumber;
var sign$2 = {};
Object.defineProperty(sign$2, "__esModule", {
  value: !0
});
sign$2.createSign = void 0;
var _factory$3y = factory$1, _collection$P = collection$1, _index$z = number$2, name$3u = "sign", dependencies$3u = ["typed", "BigNumber", "Fraction", "complex"], createSign = /* @__PURE__ */ (0, _factory$3y.factory)(name$3u, dependencies$3u, function(t) {
  var r = t.typed, n = t.BigNumber, a = t.complex, s = t.Fraction;
  return r(name$3u, {
    number: _index$z.signNumber,
    Complex: function(c) {
      return c.im === 0 ? a((0, _index$z.signNumber)(c.re)) : c.sign();
    },
    BigNumber: function(c) {
      return new n(c.cmp(0));
    },
    Fraction: function(c) {
      return new s(c.s, 1);
    },
    "Array | Matrix": function(c) {
      return (0, _collection$P.deepMap)(c, this, !0);
    },
    Unit: function(c) {
      return this(c.value);
    }
  });
});
sign$2.createSign = createSign;
var sqrt$1 = {};
Object.defineProperty(sqrt$1, "__esModule", {
  value: !0
});
sqrt$1.createSqrt = void 0;
var _factory$3x = factory$1, _collection$O = collection$1, name$3t = "sqrt", dependencies$3t = ["config", "typed", "Complex"], createSqrt = /* @__PURE__ */ (0, _factory$3x.factory)(name$3t, dependencies$3t, function(t) {
  var r = t.config, n = t.typed, a = t.Complex;
  return n("sqrt", {
    number: s,
    Complex: function(c) {
      return c.sqrt();
    },
    BigNumber: function(c) {
      return !c.isNegative() || r.predictable ? c.sqrt() : s(c.toNumber());
    },
    "Array | Matrix": function(c) {
      return (0, _collection$O.deepMap)(c, this, !0);
    },
    Unit: function(c) {
      return c.pow(0.5);
    }
  });
  function s(o) {
    return isNaN(o) ? NaN : o >= 0 || r.predictable ? Math.sqrt(o) : new a(o, 0).sqrt();
  }
});
sqrt$1.createSqrt = createSqrt;
var square$1 = {};
Object.defineProperty(square$1, "__esModule", {
  value: !0
});
square$1.createSquare = void 0;
var _factory$3w = factory$1, _collection$N = collection$1, _index$y = number$2, name$3s = "square", dependencies$3s = ["typed"], createSquare = /* @__PURE__ */ (0, _factory$3w.factory)(name$3s, dependencies$3s, function(t) {
  var r = t.typed;
  return r(name$3s, {
    number: _index$y.squareNumber,
    Complex: function(a) {
      return a.mul(a);
    },
    BigNumber: function(a) {
      return a.times(a);
    },
    Fraction: function(a) {
      return a.mul(a);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$N.deepMap)(a, this, !0);
    },
    Unit: function(a) {
      return a.pow(2);
    }
  });
});
square$1.createSquare = createSquare;
var subtract$3 = {};
Object.defineProperty(subtract$3, "__esModule", {
  value: !0
});
subtract$3.createSubtract = void 0;
var _factory$3v = factory$1, _DimensionError$7 = DimensionError$1, _algorithm$p = algorithm01, _algorithm2$p = algorithm03, _algorithm3$m = algorithm05, _algorithm4$l = algorithm10, _algorithm5$l = algorithm13, _algorithm6$6 = algorithm14, name$3r = "subtract", dependencies$3r = ["typed", "matrix", "equalScalar", "addScalar", "unaryMinus", "DenseMatrix"], createSubtract = /* @__PURE__ */ (0, _factory$3v.factory)(name$3r, dependencies$3r, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.addScalar, o = t.unaryMinus, c = t.DenseMatrix, l = (0, _algorithm$p.createAlgorithm01)({
    typed: r
  }), d = (0, _algorithm2$p.createAlgorithm03)({
    typed: r
  }), h = (0, _algorithm3$m.createAlgorithm05)({
    typed: r,
    equalScalar: a
  }), u = (0, _algorithm4$l.createAlgorithm10)({
    typed: r,
    DenseMatrix: c
  }), p = (0, _algorithm5$l.createAlgorithm13)({
    typed: r
  }), m = (0, _algorithm6$6.createAlgorithm14)({
    typed: r
  });
  return r(name$3r, {
    "number, number": function(v, y) {
      return v - y;
    },
    "Complex, Complex": function(v, y) {
      return v.sub(y);
    },
    "BigNumber, BigNumber": function(v, y) {
      return v.minus(y);
    },
    "Fraction, Fraction": function(v, y) {
      return v.sub(y);
    },
    "Unit, Unit": function(v, y) {
      if (v.value === null)
        throw new Error("Parameter x contains a unit with undefined value");
      if (y.value === null)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!v.equalBase(y))
        throw new Error("Units do not match");
      var x = v.clone();
      return x.value = this(x.value, y.value), x.fixPrefix = !1, x;
    },
    "SparseMatrix, SparseMatrix": function(v, y) {
      return checkEqualDimensions(v, y), h(v, y, this);
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return checkEqualDimensions(v, y), d(y, v, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      return checkEqualDimensions(v, y), l(v, y, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return checkEqualDimensions(v, y), p(v, y, this);
    },
    "Array, Array": function(v, y) {
      return this(n(v), n(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(n(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, n(y));
    },
    "SparseMatrix, any": function(v, y) {
      return u(v, o(y), s);
    },
    "DenseMatrix, any": function(v, y) {
      return m(v, y, this);
    },
    "any, SparseMatrix": function(v, y) {
      return u(y, v, this, !0);
    },
    "any, DenseMatrix": function(v, y) {
      return m(y, v, this, !0);
    },
    "Array, any": function(v, y) {
      return m(n(v), y, this, !1).valueOf();
    },
    "any, Array": function(v, y) {
      return m(n(y), v, this, !0).valueOf();
    }
  });
});
subtract$3.createSubtract = createSubtract;
function checkEqualDimensions(t, r) {
  var n = t.size(), a = r.size();
  if (n.length !== a.length)
    throw new _DimensionError$7.DimensionError(n.length, a.length);
}
var xgcd$1 = {};
Object.defineProperty(xgcd$1, "__esModule", {
  value: !0
});
xgcd$1.createXgcd = void 0;
var _factory$3u = factory$1, _index$x = number$2, name$3q = "xgcd", dependencies$3q = ["typed", "config", "matrix", "BigNumber"], createXgcd = /* @__PURE__ */ (0, _factory$3u.factory)(name$3q, dependencies$3q, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.BigNumber;
  return r(name$3q, {
    "number, number": function(l, d) {
      var h = (0, _index$x.xgcdNumber)(l, d);
      return n.matrix === "Array" ? h : a(h);
    },
    "BigNumber, BigNumber": o
    // TODO: implement support for Fraction
  });
  function o(c, l) {
    var d, h, u, p = new s(0), m = new s(1), g = p, v = m, y = m, x = p;
    if (!c.isInt() || !l.isInt())
      throw new Error("Parameters in function xgcd must be integer numbers");
    for (; !l.isZero(); )
      h = c.div(l).floor(), u = c.mod(l), d = g, g = v.minus(h.times(g)), v = d, d = y, y = x.minus(h.times(y)), x = d, c = l, l = u;
    var _;
    return c.lt(p) ? _ = [c.neg(), v.neg(), x.neg()] : _ = [c, c.isZero() ? 0 : v, x], n.matrix === "Array" ? _ : a(_);
  }
});
xgcd$1.createXgcd = createXgcd;
var dotMultiply$1 = {}, algorithm09 = {};
Object.defineProperty(algorithm09, "__esModule", {
  value: !0
});
algorithm09.createAlgorithm09 = void 0;
var _factory$3t = factory$1, _DimensionError$6 = DimensionError$1, name$3p = "algorithm09", dependencies$3p = ["typed", "equalScalar"], createAlgorithm09 = /* @__PURE__ */ (0, _factory$3t.factory)(name$3p, dependencies$3p, function(t) {
  var r = t.typed, n = t.equalScalar;
  return function(s, o, c) {
    var l = s._values, d = s._index, h = s._ptr, u = s._size, p = s._datatype, m = o._values, g = o._index, v = o._ptr, y = o._size, x = o._datatype;
    if (u.length !== y.length)
      throw new _DimensionError$6.DimensionError(u.length, y.length);
    if (u[0] !== y[0] || u[1] !== y[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + y + ")");
    var _ = u[0], $ = u[1], b, M = n, C = 0, S = c;
    typeof p == "string" && p === x && (b = p, M = r.find(n, [b, b]), C = r.convert(0, b), S = r.find(c, [b, b]));
    var A = l && m ? [] : void 0, D = [], N = [], T = A ? [] : void 0, R = [], F, z, O, G, I;
    for (z = 0; z < $; z++) {
      N[z] = D.length;
      var k = z + 1;
      if (T)
        for (G = v[z], I = v[z + 1], O = G; O < I; O++)
          F = g[O], R[F] = k, T[F] = m[O];
      for (G = h[z], I = h[z + 1], O = G; O < I; O++)
        if (F = d[O], T) {
          var B = R[F] === k ? T[F] : C, L = S(l[O], B);
          M(L, C) || (D.push(F), A.push(L));
        } else
          D.push(F);
    }
    return N[$] = D.length, s.createSparseMatrix({
      values: A,
      index: D,
      ptr: N,
      size: [_, $],
      datatype: b
    });
  };
});
algorithm09.createAlgorithm09 = createAlgorithm09;
Object.defineProperty(dotMultiply$1, "__esModule", {
  value: !0
});
dotMultiply$1.createDotMultiply = void 0;
var _factory$3s = factory$1, _algorithm$o = algorithm02, _algorithm2$o = algorithm09, _algorithm3$l = algorithm11, _algorithm4$k = algorithm13, _algorithm5$k = algorithm14, name$3o = "dotMultiply", dependencies$3o = ["typed", "matrix", "equalScalar", "multiplyScalar"], createDotMultiply = /* @__PURE__ */ (0, _factory$3s.factory)(name$3o, dependencies$3o, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.multiplyScalar, o = (0, _algorithm$o.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), c = (0, _algorithm2$o.createAlgorithm09)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm3$l.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm4$k.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm5$k.createAlgorithm14)({
    typed: r
  });
  return r(name$3o, {
    "any, any": s,
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, s, !1);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, s, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, s, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, s);
    },
    "Array, Array": function(p, m) {
      return this(n(p), n(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(n(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, n(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, s, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, s, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, s, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, s, !0);
    },
    "Array, any": function(p, m) {
      return h(n(p), m, s, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(n(m), p, s, !0).valueOf();
    }
  });
});
dotMultiply$1.createDotMultiply = createDotMultiply;
var bitAnd$1 = {}, bitwise$1 = {};
Object.defineProperty(bitwise$1, "__esModule", {
  value: !0
});
bitwise$1.bitAndBigNumber = bitAndBigNumber;
bitwise$1.bitNotBigNumber = bitNotBigNumber;
bitwise$1.bitOrBigNumber = bitOrBigNumber;
bitwise$1.bitwise = bitwise;
bitwise$1.bitXor = bitXor$2;
bitwise$1.leftShiftBigNumber = leftShiftBigNumber;
bitwise$1.rightArithShiftBigNumber = rightArithShiftBigNumber;
function bitAndBigNumber(t, r) {
  if (t.isFinite() && !t.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function bitAnd");
  var n = t.constructor;
  if (t.isNaN() || r.isNaN())
    return new n(NaN);
  if (t.isZero() || r.eq(-1) || t.eq(r))
    return t;
  if (r.isZero() || t.eq(-1))
    return r;
  if (!t.isFinite() || !r.isFinite()) {
    if (!t.isFinite() && !r.isFinite())
      return t.isNegative() === r.isNegative() ? t : new n(0);
    if (!t.isFinite())
      return r.isNegative() ? t : t.isNegative() ? new n(0) : r;
    if (!r.isFinite())
      return t.isNegative() ? r : r.isNegative() ? new n(0) : t;
  }
  return bitwise(t, r, function(a, s) {
    return a & s;
  });
}
function bitNotBigNumber(t) {
  if (t.isFinite() && !t.isInteger())
    throw new Error("Integer expected in function bitNot");
  var r = t.constructor, n = r.precision;
  r.config({
    precision: 1e9
  });
  var a = t.plus(new r(1));
  return a.s = -a.s || null, r.config({
    precision: n
  }), a;
}
function bitOrBigNumber(t, r) {
  if (t.isFinite() && !t.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function bitOr");
  var n = t.constructor;
  if (t.isNaN() || r.isNaN())
    return new n(NaN);
  var a = new n(-1);
  return t.isZero() || r.eq(a) || t.eq(r) ? r : r.isZero() || t.eq(a) ? t : !t.isFinite() || !r.isFinite() ? !t.isFinite() && !t.isNegative() && r.isNegative() || t.isNegative() && !r.isNegative() && !r.isFinite() ? a : t.isNegative() && r.isNegative() ? t.isFinite() ? t : r : t.isFinite() ? r : t : bitwise(t, r, function(s, o) {
    return s | o;
  });
}
function bitwise(t, r, n) {
  var a = t.constructor, s, o, c = +(t.s < 0), l = +(r.s < 0);
  if (c) {
    s = decCoefficientToBinaryString(bitNotBigNumber(t));
    for (var d = 0; d < s.length; ++d)
      s[d] ^= 1;
  } else
    s = decCoefficientToBinaryString(t);
  if (l) {
    o = decCoefficientToBinaryString(bitNotBigNumber(r));
    for (var h = 0; h < o.length; ++h)
      o[h] ^= 1;
  } else
    o = decCoefficientToBinaryString(r);
  var u, p, m;
  s.length <= o.length ? (u = s, p = o, m = c) : (u = o, p = s, m = l);
  var g = u.length, v = p.length, y = n(c, l) ^ 1, x = new a(y ^ 1), _ = new a(1), $ = new a(2), b = a.precision;
  for (a.config({
    precision: 1e9
  }); g > 0; )
    n(u[--g], p[--v]) === y && (x = x.plus(_)), _ = _.times($);
  for (; v > 0; )
    n(m, p[--v]) === y && (x = x.plus(_)), _ = _.times($);
  return a.config({
    precision: b
  }), y === 0 && (x.s = -x.s), x;
}
function decCoefficientToBinaryString(t) {
  for (var r = t.d, n = r[0] + "", a = 1; a < r.length; ++a) {
    for (var s = r[a] + "", o = 7 - s.length; o--; )
      s = "0" + s;
    n += s;
  }
  for (var c = n.length; n.charAt(c) === "0"; )
    c--;
  var l = t.e, d = n.slice(0, c + 1 || 1), h = d.length;
  if (l > 0)
    if (++l > h)
      for (l -= h; l--; )
        d += "0";
    else
      l < h && (d = d.slice(0, l) + "." + d.slice(l));
  for (var u = [0], p = 0; p < d.length; ) {
    for (var m = u.length; m--; )
      u[m] *= 10;
    u[0] += parseInt(d.charAt(p++));
    for (var g = 0; g < u.length; ++g)
      u[g] > 1 && ((u[g + 1] === null || u[g + 1] === void 0) && (u[g + 1] = 0), u[g + 1] += u[g] >> 1, u[g] &= 1);
  }
  return u.reverse();
}
function bitXor$2(t, r) {
  if (t.isFinite() && !t.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function bitXor");
  var n = t.constructor;
  if (t.isNaN() || r.isNaN())
    return new n(NaN);
  if (t.isZero())
    return r;
  if (r.isZero())
    return t;
  if (t.eq(r))
    return new n(0);
  var a = new n(-1);
  return t.eq(a) ? bitNotBigNumber(r) : r.eq(a) ? bitNotBigNumber(t) : !t.isFinite() || !r.isFinite() ? !t.isFinite() && !r.isFinite() ? a : new n(t.isNegative() === r.isNegative() ? 1 / 0 : -1 / 0) : bitwise(t, r, function(s, o) {
    return s ^ o;
  });
}
function leftShiftBigNumber(t, r) {
  if (t.isFinite() && !t.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function leftShift");
  var n = t.constructor;
  return t.isNaN() || r.isNaN() || r.isNegative() && !r.isZero() ? new n(NaN) : t.isZero() || r.isZero() ? t : !t.isFinite() && !r.isFinite() ? new n(NaN) : r.lt(55) ? t.times(Math.pow(2, r.toNumber()) + "") : t.times(new n(2).pow(r));
}
function rightArithShiftBigNumber(t, r) {
  if (t.isFinite() && !t.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function rightArithShift");
  var n = t.constructor;
  return t.isNaN() || r.isNaN() || r.isNegative() && !r.isZero() ? new n(NaN) : t.isZero() || r.isZero() ? t : r.isFinite() ? r.lt(55) ? t.div(Math.pow(2, r.toNumber()) + "").floor() : t.div(new n(2).pow(r)).floor() : t.isNegative() ? new n(-1) : t.isFinite() ? new n(0) : new n(NaN);
}
Object.defineProperty(bitAnd$1, "__esModule", {
  value: !0
});
bitAnd$1.createBitAnd = void 0;
var _bitwise$5 = bitwise$1, _algorithm$n = algorithm02, _algorithm2$n = algorithm11, _algorithm3$k = algorithm13, _algorithm4$j = algorithm14, _algorithm5$j = algorithm06, _factory$3r = factory$1, _index$w = number$2, name$3n = "bitAnd", dependencies$3n = ["typed", "matrix", "equalScalar"], createBitAnd = /* @__PURE__ */ (0, _factory$3r.factory)(name$3n, dependencies$3n, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = (0, _algorithm$n.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), o = (0, _algorithm5$j.createAlgorithm06)({
    typed: r,
    equalScalar: a
  }), c = (0, _algorithm2$n.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm3$k.createAlgorithm13)({
    typed: r
  }), d = (0, _algorithm4$j.createAlgorithm14)({
    typed: r
  });
  return r(name$3n, {
    "number, number": _index$w.bitAndNumber,
    "BigNumber, BigNumber": _bitwise$5.bitAndBigNumber,
    "SparseMatrix, SparseMatrix": function(u, p) {
      return o(u, p, this, !1);
    },
    "SparseMatrix, DenseMatrix": function(u, p) {
      return s(p, u, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(u, p) {
      return s(u, p, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(u, p) {
      return l(u, p, this);
    },
    "Array, Array": function(u, p) {
      return this(n(u), n(p)).valueOf();
    },
    "Array, Matrix": function(u, p) {
      return this(n(u), p);
    },
    "Matrix, Array": function(u, p) {
      return this(u, n(p));
    },
    "SparseMatrix, any": function(u, p) {
      return c(u, p, this, !1);
    },
    "DenseMatrix, any": function(u, p) {
      return d(u, p, this, !1);
    },
    "any, SparseMatrix": function(u, p) {
      return c(p, u, this, !0);
    },
    "any, DenseMatrix": function(u, p) {
      return d(p, u, this, !0);
    },
    "Array, any": function(u, p) {
      return d(n(u), p, this, !1).valueOf();
    },
    "any, Array": function(u, p) {
      return d(n(p), u, this, !0).valueOf();
    }
  });
});
bitAnd$1.createBitAnd = createBitAnd;
var bitNot$1 = {};
Object.defineProperty(bitNot$1, "__esModule", {
  value: !0
});
bitNot$1.createBitNot = void 0;
var _bitwise$4 = bitwise$1, _collection$M = collection$1, _factory$3q = factory$1, _index$v = number$2, name$3m = "bitNot", dependencies$3m = ["typed"], createBitNot = /* @__PURE__ */ (0, _factory$3q.factory)(name$3m, dependencies$3m, function(t) {
  var r = t.typed;
  return r(name$3m, {
    number: _index$v.bitNotNumber,
    BigNumber: _bitwise$4.bitNotBigNumber,
    "Array | Matrix": function(a) {
      return (0, _collection$M.deepMap)(a, this);
    }
  });
});
bitNot$1.createBitNot = createBitNot;
var bitOr$1 = {};
Object.defineProperty(bitOr$1, "__esModule", {
  value: !0
});
bitOr$1.createBitOr = void 0;
var _bitwise$3 = bitwise$1, _factory$3p = factory$1, _algorithm$m = algorithm14, _algorithm2$m = algorithm13, _algorithm3$j = algorithm10, _algorithm4$i = algorithm04, _algorithm5$i = algorithm01, _index$u = number$2, name$3l = "bitOr", dependencies$3l = ["typed", "matrix", "equalScalar", "DenseMatrix"], createBitOr = /* @__PURE__ */ (0, _factory$3p.factory)(name$3l, dependencies$3l, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.DenseMatrix, o = (0, _algorithm5$i.createAlgorithm01)({
    typed: r
  }), c = (0, _algorithm4$i.createAlgorithm04)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm3$j.createAlgorithm10)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm2$m.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm$m.createAlgorithm14)({
    typed: r
  });
  return r(name$3l, {
    "number, number": _index$u.bitOrNumber,
    "BigNumber, BigNumber": _bitwise$3.bitOrBigNumber,
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, this);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, this);
    },
    "Array, Array": function(p, m) {
      return this(n(p), n(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(n(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, n(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, this, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, this, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, this, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, this, !0);
    },
    "Array, any": function(p, m) {
      return h(n(p), m, this, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(n(m), p, this, !0).valueOf();
    }
  });
});
bitOr$1.createBitOr = createBitOr;
var bitXor$1 = {}, algorithm07 = {};
Object.defineProperty(algorithm07, "__esModule", {
  value: !0
});
algorithm07.createAlgorithm07 = void 0;
var _factory$3o = factory$1, _DimensionError$5 = DimensionError$1, name$3k = "algorithm07", dependencies$3k = ["typed", "DenseMatrix"], createAlgorithm07 = /* @__PURE__ */ (0, _factory$3o.factory)(name$3k, dependencies$3k, function(t) {
  var r = t.typed, n = t.DenseMatrix;
  return function(o, c, l) {
    var d = o._size, h = o._datatype, u = c._size, p = c._datatype;
    if (d.length !== u.length)
      throw new _DimensionError$5.DimensionError(d.length, u.length);
    if (d[0] !== u[0] || d[1] !== u[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + d + ") must match Matrix B (" + u + ")");
    var m = d[0], g = d[1], v, y = 0, x = l;
    typeof h == "string" && h === p && (v = h, y = r.convert(0, v), x = r.find(l, [v, v]));
    var _, $, b = [];
    for (_ = 0; _ < m; _++)
      b[_] = [];
    var M = [], C = [], S = [], A = [];
    for ($ = 0; $ < g; $++) {
      var D = $ + 1;
      for (a(o, $, S, M, D), a(c, $, A, C, D), _ = 0; _ < m; _++) {
        var N = S[_] === D ? M[_] : y, T = A[_] === D ? C[_] : y;
        b[_][$] = x(N, T);
      }
    }
    return new n({
      data: b,
      size: [m, g],
      datatype: v
    });
  };
  function a(s, o, c, l, d) {
    for (var h = s._values, u = s._index, p = s._ptr, m = p[o], g = p[o + 1]; m < g; m++) {
      var v = u[m];
      c[v] = d, l[v] = h[m];
    }
  }
});
algorithm07.createAlgorithm07 = createAlgorithm07;
Object.defineProperty(bitXor$1, "__esModule", {
  value: !0
});
bitXor$1.createBitXor = void 0;
var _bitwise$2 = bitwise$1, _algorithm$l = algorithm03, _algorithm2$l = algorithm07, _algorithm3$i = algorithm12, _algorithm4$h = algorithm13, _algorithm5$h = algorithm14, _factory$3n = factory$1, _index$t = number$2, name$3j = "bitXor", dependencies$3j = ["typed", "matrix", "DenseMatrix"], createBitXor = /* @__PURE__ */ (0, _factory$3n.factory)(name$3j, dependencies$3j, function(t) {
  var r = t.typed, n = t.matrix, a = t.DenseMatrix, s = (0, _algorithm$l.createAlgorithm03)({
    typed: r
  }), o = (0, _algorithm2$l.createAlgorithm07)({
    typed: r,
    DenseMatrix: a
  }), c = (0, _algorithm3$i.createAlgorithm12)({
    typed: r,
    DenseMatrix: a
  }), l = (0, _algorithm4$h.createAlgorithm13)({
    typed: r
  }), d = (0, _algorithm5$h.createAlgorithm14)({
    typed: r
  });
  return r(name$3j, {
    "number, number": _index$t.bitXorNumber,
    "BigNumber, BigNumber": _bitwise$2.bitXor,
    "SparseMatrix, SparseMatrix": function(u, p) {
      return o(u, p, this);
    },
    "SparseMatrix, DenseMatrix": function(u, p) {
      return s(p, u, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(u, p) {
      return s(u, p, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(u, p) {
      return l(u, p, this);
    },
    "Array, Array": function(u, p) {
      return this(n(u), n(p)).valueOf();
    },
    "Array, Matrix": function(u, p) {
      return this(n(u), p);
    },
    "Matrix, Array": function(u, p) {
      return this(u, n(p));
    },
    "SparseMatrix, any": function(u, p) {
      return c(u, p, this, !1);
    },
    "DenseMatrix, any": function(u, p) {
      return d(u, p, this, !1);
    },
    "any, SparseMatrix": function(u, p) {
      return c(p, u, this, !0);
    },
    "any, DenseMatrix": function(u, p) {
      return d(p, u, this, !0);
    },
    "Array, any": function(u, p) {
      return d(n(u), p, this, !1).valueOf();
    },
    "any, Array": function(u, p) {
      return d(n(p), u, this, !0).valueOf();
    }
  });
});
bitXor$1.createBitXor = createBitXor;
var arg$1 = {};
Object.defineProperty(arg$1, "__esModule", {
  value: !0
});
arg$1.createArg = void 0;
var _factory$3m = factory$1, _collection$L = collection$1, name$3i = "arg", dependencies$3i = ["typed"], createArg = /* @__PURE__ */ (0, _factory$3m.factory)(name$3i, dependencies$3i, function(t) {
  var r = t.typed;
  return r(name$3i, {
    number: function(a) {
      return Math.atan2(0, a);
    },
    BigNumber: function(a) {
      return a.constructor.atan2(0, a);
    },
    Complex: function(a) {
      return a.arg();
    },
    // TODO: implement BigNumber support for function arg
    "Array | Matrix": function(a) {
      return (0, _collection$L.deepMap)(a, this);
    }
  });
});
arg$1.createArg = createArg;
var conj$1 = {};
Object.defineProperty(conj$1, "__esModule", {
  value: !0
});
conj$1.createConj = void 0;
var _factory$3l = factory$1, _collection$K = collection$1, name$3h = "conj", dependencies$3h = ["typed"], createConj = /* @__PURE__ */ (0, _factory$3l.factory)(name$3h, dependencies$3h, function(t) {
  var r = t.typed;
  return r(name$3h, {
    number: function(a) {
      return a;
    },
    BigNumber: function(a) {
      return a;
    },
    Complex: function(a) {
      return a.conjugate();
    },
    "Array | Matrix": function(a) {
      return (0, _collection$K.deepMap)(a, this);
    }
  });
});
conj$1.createConj = createConj;
var im$1 = {};
Object.defineProperty(im$1, "__esModule", {
  value: !0
});
im$1.createIm = void 0;
var _factory$3k = factory$1, _collection$J = collection$1, name$3g = "im", dependencies$3g = ["typed"], createIm = /* @__PURE__ */ (0, _factory$3k.factory)(name$3g, dependencies$3g, function(t) {
  var r = t.typed;
  return r(name$3g, {
    number: function(a) {
      return 0;
    },
    BigNumber: function(a) {
      return a.mul(0);
    },
    Complex: function(a) {
      return a.im;
    },
    "Array | Matrix": function(a) {
      return (0, _collection$J.deepMap)(a, this);
    }
  });
});
im$1.createIm = createIm;
var re$1 = {};
Object.defineProperty(re$1, "__esModule", {
  value: !0
});
re$1.createRe = void 0;
var _factory$3j = factory$1, _collection$I = collection$1, name$3f = "re", dependencies$3f = ["typed"], createRe = /* @__PURE__ */ (0, _factory$3j.factory)(name$3f, dependencies$3f, function(t) {
  var r = t.typed;
  return r(name$3f, {
    number: function(a) {
      return a;
    },
    BigNumber: function(a) {
      return a;
    },
    Complex: function(a) {
      return a.re;
    },
    "Array | Matrix": function(a) {
      return (0, _collection$I.deepMap)(a, this);
    }
  });
});
re$1.createRe = createRe;
var not$1 = {};
Object.defineProperty(not$1, "__esModule", {
  value: !0
});
not$1.createNot = void 0;
var _collection$H = collection$1, _factory$3i = factory$1, _index$s = number$2, name$3e = "not", dependencies$3e = ["typed"], createNot = /* @__PURE__ */ (0, _factory$3i.factory)(name$3e, dependencies$3e, function(t) {
  var r = t.typed;
  return r(name$3e, {
    number: _index$s.notNumber,
    Complex: function(a) {
      return a.re === 0 && a.im === 0;
    },
    BigNumber: function(a) {
      return a.isZero() || a.isNaN();
    },
    Unit: function(a) {
      return a.value !== null ? this(a.value) : !0;
    },
    "Array | Matrix": function(a) {
      return (0, _collection$H.deepMap)(a, this);
    }
  });
});
not$1.createNot = createNot;
var or$1 = {};
Object.defineProperty(or$1, "__esModule", {
  value: !0
});
or$1.createOr = void 0;
var _algorithm$k = algorithm03, _algorithm2$k = algorithm12, _algorithm3$h = algorithm13, _algorithm4$g = algorithm14, _algorithm5$g = algorithm05, _factory$3h = factory$1, _index$r = number$2, name$3d = "or", dependencies$3d = ["typed", "matrix", "equalScalar", "DenseMatrix"], createOr = /* @__PURE__ */ (0, _factory$3h.factory)(name$3d, dependencies$3d, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.DenseMatrix, o = (0, _algorithm$k.createAlgorithm03)({
    typed: r
  }), c = (0, _algorithm5$g.createAlgorithm05)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm2$k.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm3$h.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm4$g.createAlgorithm14)({
    typed: r
  });
  return r(name$3d, {
    "number, number": _index$r.orNumber,
    "Complex, Complex": function(p, m) {
      return p.re !== 0 || p.im !== 0 || m.re !== 0 || m.im !== 0;
    },
    "BigNumber, BigNumber": function(p, m) {
      return !p.isZero() && !p.isNaN() || !m.isZero() && !m.isNaN();
    },
    "Unit, Unit": function(p, m) {
      return this(p.value || 0, m.value || 0);
    },
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, this);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, this);
    },
    "Array, Array": function(p, m) {
      return this(n(p), n(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(n(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, n(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, this, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, this, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, this, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, this, !0);
    },
    "Array, any": function(p, m) {
      return h(n(p), m, this, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(n(m), p, this, !0).valueOf();
    }
  });
});
or$1.createOr = createOr;
var xor$1 = {};
Object.defineProperty(xor$1, "__esModule", {
  value: !0
});
xor$1.createXor = void 0;
var _algorithm$j = algorithm03, _algorithm2$j = algorithm07, _algorithm3$g = algorithm12, _algorithm4$f = algorithm13, _algorithm5$f = algorithm14, _factory$3g = factory$1, _index$q = number$2, name$3c = "xor", dependencies$3c = ["typed", "matrix", "DenseMatrix"], createXor = /* @__PURE__ */ (0, _factory$3g.factory)(name$3c, dependencies$3c, function(t) {
  var r = t.typed, n = t.matrix, a = t.DenseMatrix, s = (0, _algorithm$j.createAlgorithm03)({
    typed: r
  }), o = (0, _algorithm2$j.createAlgorithm07)({
    typed: r,
    DenseMatrix: a
  }), c = (0, _algorithm3$g.createAlgorithm12)({
    typed: r,
    DenseMatrix: a
  }), l = (0, _algorithm4$f.createAlgorithm13)({
    typed: r
  }), d = (0, _algorithm5$f.createAlgorithm14)({
    typed: r
  });
  return r(name$3c, {
    "number, number": _index$q.xorNumber,
    "Complex, Complex": function(u, p) {
      return (u.re !== 0 || u.im !== 0) != (p.re !== 0 || p.im !== 0);
    },
    "BigNumber, BigNumber": function(u, p) {
      return (!u.isZero() && !u.isNaN()) != (!p.isZero() && !p.isNaN());
    },
    "Unit, Unit": function(u, p) {
      return this(u.value || 0, p.value || 0);
    },
    "SparseMatrix, SparseMatrix": function(u, p) {
      return o(u, p, this);
    },
    "SparseMatrix, DenseMatrix": function(u, p) {
      return s(p, u, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(u, p) {
      return s(u, p, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(u, p) {
      return l(u, p, this);
    },
    "Array, Array": function(u, p) {
      return this(n(u), n(p)).valueOf();
    },
    "Array, Matrix": function(u, p) {
      return this(n(u), p);
    },
    "Matrix, Array": function(u, p) {
      return this(u, n(p));
    },
    "SparseMatrix, any": function(u, p) {
      return c(u, p, this, !1);
    },
    "DenseMatrix, any": function(u, p) {
      return d(u, p, this, !1);
    },
    "any, SparseMatrix": function(u, p) {
      return c(p, u, this, !0);
    },
    "any, DenseMatrix": function(u, p) {
      return d(p, u, this, !0);
    },
    "Array, any": function(u, p) {
      return d(n(u), p, this, !1).valueOf();
    },
    "any, Array": function(u, p) {
      return d(n(p), u, this, !0).valueOf();
    }
  });
});
xor$1.createXor = createXor;
var concat$1 = {};
Object.defineProperty(concat$1, "__esModule", {
  value: !0
});
concat$1.createConcat = void 0;
var _is$1a = is, _object$v = object, _array$O = array, _IndexError$2 = IndexError$1, _DimensionError$4 = DimensionError$1, _factory$3f = factory$1, name$3b = "concat", dependencies$3b = ["typed", "matrix", "isInteger"], createConcat = /* @__PURE__ */ (0, _factory$3f.factory)(name$3b, dependencies$3b, function(t) {
  var r = t.typed, n = t.matrix, a = t.isInteger;
  return r(name$3b, {
    // TODO: change signature to '...Array | Matrix, dim?' when supported
    "...Array | Matrix | number | BigNumber": function(o) {
      var c, l = o.length, d = -1, h, u = !1, p = [];
      for (c = 0; c < l; c++) {
        var m = o[c];
        if ((0, _is$1a.isMatrix)(m) && (u = !0), (0, _is$1a.isNumber)(m) || (0, _is$1a.isBigNumber)(m)) {
          if (c !== l - 1)
            throw new Error("Dimension must be specified as last argument");
          if (h = d, d = m.valueOf(), !a(d))
            throw new TypeError("Integer number expected for dimension");
          if (d < 0 || c > 0 && d > h)
            throw new _IndexError$2.IndexError(d, h + 1);
        } else {
          var g = (0, _object$v.clone)(m).valueOf(), v = (0, _array$O.arraySize)(g);
          if (p[c] = g, h = d, d = v.length - 1, c > 0 && d !== h)
            throw new _DimensionError$4.DimensionError(h + 1, d + 1);
        }
      }
      if (p.length === 0)
        throw new SyntaxError("At least one matrix expected");
      for (var y = p.shift(); p.length; )
        y = _concat$2(y, p.shift(), d, 0);
      return u ? n(y) : y;
    },
    "...string": function(o) {
      return o.join("");
    }
  });
});
concat$1.createConcat = createConcat;
function _concat$2(t, r, n, a) {
  if (a < n) {
    if (t.length !== r.length)
      throw new _DimensionError$4.DimensionError(t.length, r.length);
    for (var s = [], o = 0; o < t.length; o++)
      s[o] = _concat$2(t[o], r[o], n, a + 1);
    return s;
  } else
    return t.concat(r);
}
var column$2 = {};
Object.defineProperty(column$2, "__esModule", {
  value: !0
});
column$2.createColumn = void 0;
var _factory$3e = factory$1, _object$u = object, _array$N = array, name$3a = "column", dependencies$3a = ["typed", "Index", "matrix", "range"], createColumn = /* @__PURE__ */ (0, _factory$3e.factory)(name$3a, dependencies$3a, function(t) {
  var r = t.typed, n = t.Index, a = t.matrix, s = t.range;
  return r(name$3a, {
    "Matrix, number": o,
    "Array, number": function(l, d) {
      return o(a((0, _object$u.clone)(l)), d).valueOf();
    }
  });
  function o(c, l) {
    if (c.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    (0, _array$N.validateIndex)(l, c.size()[1]);
    var d = s(0, c.size()[0]), h = new n(d, l);
    return c.subset(h);
  }
});
column$2.createColumn = createColumn;
var cross$1 = {};
Object.defineProperty(cross$1, "__esModule", {
  value: !0
});
cross$1.createCross = void 0;
var _array$M = array, _factory$3d = factory$1, name$39 = "cross", dependencies$39 = ["typed", "matrix", "subtract", "multiply"], createCross = /* @__PURE__ */ (0, _factory$3d.factory)(name$39, dependencies$39, function(t) {
  var r = t.typed, n = t.matrix, a = t.subtract, s = t.multiply;
  return r(name$39, {
    "Matrix, Matrix": function(l, d) {
      return n(o(l.toArray(), d.toArray()));
    },
    "Matrix, Array": function(l, d) {
      return n(o(l.toArray(), d));
    },
    "Array, Matrix": function(l, d) {
      return n(o(l, d.toArray()));
    },
    "Array, Array": o
  });
  function o(c, l) {
    var d = Math.max((0, _array$M.arraySize)(c).length, (0, _array$M.arraySize)(l).length);
    c = (0, _array$M.squeeze)(c), l = (0, _array$M.squeeze)(l);
    var h = (0, _array$M.arraySize)(c), u = (0, _array$M.arraySize)(l);
    if (h.length !== 1 || u.length !== 1 || h[0] !== 3 || u[0] !== 3)
      throw new RangeError("Vectors with length 3 expected (Size A = [" + h.join(", ") + "], B = [" + u.join(", ") + "])");
    var p = [a(s(c[1], l[2]), s(c[2], l[1])), a(s(c[2], l[0]), s(c[0], l[2])), a(s(c[0], l[1]), s(c[1], l[0]))];
    return d > 1 ? [p] : p;
  }
});
cross$1.createCross = createCross;
var diag$1 = {};
Object.defineProperty(diag$1, "__esModule", {
  value: !0
});
diag$1.createDiag = void 0;
var _is$19 = is, _array$L = array, _number$p = number$3, _factory$3c = factory$1, name$38 = "diag", dependencies$38 = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], createDiag = /* @__PURE__ */ (0, _factory$3c.factory)(name$38, dependencies$38, function(t) {
  var r = t.typed, n = t.matrix, a = t.DenseMatrix, s = t.SparseMatrix;
  return r(name$38, {
    // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
    Array: function(h) {
      return o(h, 0, (0, _array$L.arraySize)(h), null);
    },
    "Array, number": function(h, u) {
      return o(h, u, (0, _array$L.arraySize)(h), null);
    },
    "Array, BigNumber": function(h, u) {
      return o(h, u.toNumber(), (0, _array$L.arraySize)(h), null);
    },
    "Array, string": function(h, u) {
      return o(h, 0, (0, _array$L.arraySize)(h), u);
    },
    "Array, number, string": function(h, u, p) {
      return o(h, u, (0, _array$L.arraySize)(h), p);
    },
    "Array, BigNumber, string": function(h, u, p) {
      return o(h, u.toNumber(), (0, _array$L.arraySize)(h), p);
    },
    Matrix: function(h) {
      return o(h, 0, h.size(), h.storage());
    },
    "Matrix, number": function(h, u) {
      return o(h, u, h.size(), h.storage());
    },
    "Matrix, BigNumber": function(h, u) {
      return o(h, u.toNumber(), h.size(), h.storage());
    },
    "Matrix, string": function(h, u) {
      return o(h, 0, h.size(), u);
    },
    "Matrix, number, string": function(h, u, p) {
      return o(h, u, h.size(), p);
    },
    "Matrix, BigNumber, string": function(h, u, p) {
      return o(h, u.toNumber(), h.size(), p);
    }
  });
  function o(d, h, u, p) {
    if (!(0, _number$p.isInteger)(h))
      throw new TypeError("Second parameter in function diag must be an integer");
    var m = h > 0 ? h : 0, g = h < 0 ? -h : 0;
    switch (u.length) {
      case 1:
        return c(d, h, p, u[0], g, m);
      case 2:
        return l(d, h, p, u, g, m);
    }
    throw new RangeError("Matrix for function diag must be 2 dimensional");
  }
  function c(d, h, u, p, m, g) {
    var v = [p + m, p + g];
    if (u && u !== "sparse" && u !== "dense")
      throw new TypeError("Unknown matrix type ".concat(u, '"'));
    var y = u === "sparse" ? s.diagonal(v, d, h) : a.diagonal(v, d, h);
    return u !== null ? y : y.valueOf();
  }
  function l(d, h, u, p, m, g) {
    if ((0, _is$19.isMatrix)(d)) {
      var v = d.diagonal(h);
      return u !== null ? u !== v.storage() ? n(v, u) : v : v.valueOf();
    }
    for (var y = Math.min(p[0] - m, p[1] - g), x = [], _ = 0; _ < y; _++)
      x[_] = d[_ + m][_ + g];
    return u !== null ? n(x) : x;
  }
});
diag$1.createDiag = createDiag;
var filter$1 = {}, _function$9 = {}, lruQueue$1 = {};
Object.defineProperty(lruQueue$1, "__esModule", {
  value: !0
});
lruQueue$1.lruQueue = lruQueue;
function lruQueue(t) {
  var r = 0, n = 1, a = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null), o = 0, c = function(d) {
    var h = s[d];
    if (h && (delete a[h], delete s[d], --r, n === h)) {
      if (!r) {
        o = 0, n = 1;
        return;
      }
      for (; !hasOwnProperty.call(a, ++n); )
        ;
    }
  };
  return t = Math.abs(t), {
    hit: function(d) {
      var h = s[d], u = ++o;
      if (a[u] = d, s[d] = u, !h)
        return ++r, r <= t ? void 0 : (d = a[n], c(d), d);
      if (delete a[h], n === h)
        for (; !hasOwnProperty.call(a, ++n); )
          ;
    },
    delete: c,
    clear: function() {
      r = o = 0, n = 1, a = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
    }
  };
}
Object.defineProperty(_function$9, "__esModule", {
  value: !0
});
_function$9.memoize = memoize$1;
_function$9.memoizeCompare = memoizeCompare;
_function$9.maxArgumentCount = maxArgumentCount;
var _lruQueue = lruQueue$1;
function _typeof$d(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$d = function(n) {
    return typeof n;
  } : _typeof$d = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$d(t);
}
function memoize$1(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.hasher, a = r.limit;
  return a = a ?? Number.POSITIVE_INFINITY, n = n ?? JSON.stringify, function s() {
    _typeof$d(s.cache) !== "object" && (s.cache = {
      values: /* @__PURE__ */ new Map(),
      lru: (0, _lruQueue.lruQueue)(a || Number.POSITIVE_INFINITY)
    });
    for (var o = [], c = 0; c < arguments.length; c++)
      o[c] = arguments[c];
    var l = n(o);
    if (s.cache.values.has(l))
      return s.cache.lru.hit(l), s.cache.values.get(l);
    var d = t.apply(t, o);
    return s.cache.values.set(l, d), s.cache.values.delete(s.cache.lru.hit(l)), d;
  };
}
function memoizeCompare(t, r) {
  var n = function a() {
    for (var s = [], o = 0; o < arguments.length; o++)
      s[o] = arguments[o];
    for (var c = 0; c < a.cache.length; c++) {
      var l = a.cache[c];
      if (r(s, l.args))
        return l.res;
    }
    var d = t.apply(t, s);
    return a.cache.unshift({
      args: s,
      res: d
    }), d;
  };
  return n.cache = [], n;
}
function maxArgumentCount(t) {
  return Object.keys(t.signatures || {}).reduce(function(r, n) {
    var a = (n.match(/,/g) || []).length + 1;
    return Math.max(r, a);
  }, -1);
}
Object.defineProperty(filter$1, "__esModule", {
  value: !0
});
filter$1.createFilter = void 0;
var _array$K = array, _function$8 = _function$9, _factory$3b = factory$1, name$37 = "filter", dependencies$37 = ["typed"], createFilter$1 = /* @__PURE__ */ (0, _factory$3b.factory)(name$37, dependencies$37, function(t) {
  var r = t.typed;
  return r("filter", {
    "Array, function": _filterCallback,
    "Matrix, function": function(a, s) {
      return a.create(_filterCallback(a.toArray(), s));
    },
    "Array, RegExp": _array$K.filterRegExp,
    "Matrix, RegExp": function(a, s) {
      return a.create((0, _array$K.filterRegExp)(a.toArray(), s));
    }
  });
});
filter$1.createFilter = createFilter$1;
function _filterCallback(t, r) {
  var n = (0, _function$8.maxArgumentCount)(r);
  return (0, _array$K.filter)(t, function(a, s, o) {
    return n === 1 ? r(a) : n === 2 ? r(a, [s]) : r(a, [s], o);
  });
}
var flatten$2 = {};
Object.defineProperty(flatten$2, "__esModule", {
  value: !0
});
flatten$2.createFlatten = void 0;
var _object$t = object, _array$J = array, _factory$3a = factory$1, name$36 = "flatten", dependencies$36 = ["typed", "matrix"], createFlatten = /* @__PURE__ */ (0, _factory$3a.factory)(name$36, dependencies$36, function(t) {
  var r = t.typed, n = t.matrix;
  return r(name$36, {
    Array: function(s) {
      return (0, _array$J.flatten)((0, _object$t.clone)(s));
    },
    Matrix: function(s) {
      var o = (0, _array$J.flatten)((0, _object$t.clone)(s.toArray()));
      return n(o);
    }
  });
});
flatten$2.createFlatten = createFlatten;
var forEach$1 = {};
Object.defineProperty(forEach$1, "__esModule", {
  value: !0
});
forEach$1.createForEach = void 0;
var _function$7 = _function$9, _array$I = array, _factory$39 = factory$1, name$35 = "forEach", dependencies$35 = ["typed"], createForEach = /* @__PURE__ */ (0, _factory$39.factory)(name$35, dependencies$35, function(t) {
  var r = t.typed;
  return r(name$35, {
    "Array, function": _forEach$1,
    "Matrix, function": function(a, s) {
      return a.forEach(s);
    }
  });
});
forEach$1.createForEach = createForEach;
function _forEach$1(t, r) {
  var n = (0, _function$7.maxArgumentCount)(r), a = function s(o, c) {
    Array.isArray(o) ? (0, _array$I.forEach)(o, function(l, d) {
      s(l, c.concat(d));
    }) : n === 1 ? r(o) : n === 2 ? r(o, c) : r(o, c, t);
  };
  a(t, []);
}
var getMatrixDataType$1 = {};
Object.defineProperty(getMatrixDataType$1, "__esModule", {
  value: !0
});
getMatrixDataType$1.createGetMatrixDataType = void 0;
var _factory$38 = factory$1, _array$H = array, _is$18 = is, name$34 = "getMatrixDataType", dependencies$34 = ["typed"], createGetMatrixDataType = /* @__PURE__ */ (0, _factory$38.factory)(name$34, dependencies$34, function(t) {
  var r = t.typed;
  return r(name$34, {
    Array: function(a) {
      return (0, _array$H.getArrayDataType)(a, _is$18.typeOf);
    },
    Matrix: function(a) {
      return a.getDataType();
    }
  });
});
getMatrixDataType$1.createGetMatrixDataType = createGetMatrixDataType;
var identity$1 = {};
Object.defineProperty(identity$1, "__esModule", {
  value: !0
});
identity$1.createIdentity = void 0;
var _is$17 = is, _array$G = array, _number$o = number$3, _factory$37 = factory$1, name$33 = "identity", dependencies$33 = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], createIdentity = /* @__PURE__ */ (0, _factory$37.factory)(name$33, dependencies$33, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.BigNumber, o = t.DenseMatrix, c = t.SparseMatrix;
  return r(name$33, {
    "": function() {
      return n.matrix === "Matrix" ? a([]) : [];
    },
    string: function(u) {
      return a(u);
    },
    "number | BigNumber": function(u) {
      return d(u, u, n.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, string": function(u, p) {
      return d(u, u, p);
    },
    "number | BigNumber, number | BigNumber": function(u, p) {
      return d(u, p, n.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, number | BigNumber, string": function(u, p, m) {
      return d(u, p, m);
    },
    Array: function(u) {
      return l(u);
    },
    "Array, string": function(u, p) {
      return l(u, p);
    },
    Matrix: function(u) {
      return l(u.valueOf(), u.storage());
    },
    "Matrix, string": function(u, p) {
      return l(u.valueOf(), p);
    }
  });
  function l(h, u) {
    switch (h.length) {
      case 0:
        return u ? a(u) : [];
      case 1:
        return d(h[0], h[0], u);
      case 2:
        return d(h[0], h[1], u);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function d(h, u, p) {
    var m = (0, _is$17.isBigNumber)(h) || (0, _is$17.isBigNumber)(u) ? s : null;
    if ((0, _is$17.isBigNumber)(h) && (h = h.toNumber()), (0, _is$17.isBigNumber)(u) && (u = u.toNumber()), !(0, _number$o.isInteger)(h) || h < 1)
      throw new Error("Parameters in function identity must be positive integers");
    if (!(0, _number$o.isInteger)(u) || u < 1)
      throw new Error("Parameters in function identity must be positive integers");
    var g = m ? new s(1) : 1, v = m ? new m(0) : 0, y = [h, u];
    if (p) {
      if (p === "sparse")
        return c.diagonal(y, g, 0, v);
      if (p === "dense")
        return o.diagonal(y, g, 0, v);
      throw new TypeError('Unknown matrix type "'.concat(p, '"'));
    }
    for (var x = (0, _array$G.resize)([], y, v), _ = h < u ? h : u, $ = 0; $ < _; $++)
      x[$][$] = g;
    return x;
  }
});
identity$1.createIdentity = createIdentity;
var kron$1 = {};
Object.defineProperty(kron$1, "__esModule", {
  value: !0
});
kron$1.createKron = void 0;
var _array$F = array, _factory$36 = factory$1, name$32 = "kron", dependencies$32 = ["typed", "matrix", "multiplyScalar"], createKron = /* @__PURE__ */ (0, _factory$36.factory)(name$32, dependencies$32, function(t) {
  var r = t.typed, n = t.matrix, a = t.multiplyScalar;
  return r(name$32, {
    "Matrix, Matrix": function(c, l) {
      return n(s(c.toArray(), l.toArray()));
    },
    "Matrix, Array": function(c, l) {
      return n(s(c.toArray(), l));
    },
    "Array, Matrix": function(c, l) {
      return n(s(c, l.toArray()));
    },
    "Array, Array": s
  });
  function s(o, c) {
    if ((0, _array$F.arraySize)(o).length === 1 && (o = [o]), (0, _array$F.arraySize)(c).length === 1 && (c = [c]), (0, _array$F.arraySize)(o).length > 2 || (0, _array$F.arraySize)(c).length > 2)
      throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(o.length) + ", y = " + JSON.stringify(c.length) + ")");
    var l = [], d = [];
    return o.map(function(h) {
      return c.map(function(u) {
        return d = [], l.push(d), h.map(function(p) {
          return u.map(function(m) {
            return d.push(a(p, m));
          });
        });
      });
    }) && l;
  }
});
kron$1.createKron = createKron;
var map$2 = {};
Object.defineProperty(map$2, "__esModule", {
  value: !0
});
map$2.createMap = void 0;
var _function$6 = _function$9, _factory$35 = factory$1, name$31 = "map", dependencies$31 = ["typed"], createMap = /* @__PURE__ */ (0, _factory$35.factory)(name$31, dependencies$31, function(t) {
  var r = t.typed;
  return r(name$31, {
    "Array, function": _map$2,
    "Matrix, function": function(a, s) {
      return a.map(s);
    }
  });
});
map$2.createMap = createMap;
function _map$2(t, r) {
  var n = (0, _function$6.maxArgumentCount)(r), a = function s(o, c) {
    return Array.isArray(o) ? o.map(function(l, d) {
      return s(l, c.concat(d));
    }) : n === 1 ? r(o) : n === 2 ? r(o, c) : r(o, c, t);
  };
  return a(t, []);
}
var diff$2 = {};
Object.defineProperty(diff$2, "__esModule", {
  value: !0
});
diff$2.createDiff = void 0;
var _factory$34 = factory$1, _number$n = number$3, _is$16 = is, name$30 = "diff", dependencies$30 = ["typed", "matrix", "subtract", "number"], createDiff = /* @__PURE__ */ (0, _factory$34.factory)(name$30, dependencies$30, function(t) {
  var r = t.typed, n = t.matrix, a = t.subtract, s = t.number;
  return r(name$30, {
    "Array | Matrix": function(u) {
      return (0, _is$16.isMatrix)(u) ? n(c(u.toArray())) : c(u);
    },
    "Array | Matrix, number": function(u, p) {
      if (!(0, _number$n.isInteger)(p))
        throw new RangeError("Dimension must be a whole number");
      return (0, _is$16.isMatrix)(u) ? n(o(u.toArray(), p)) : o(u, p);
    },
    "Array | Matrix, BigNumber": function(u, p) {
      return this(u, s(p));
    }
  });
  function o(h, u) {
    if ((0, _is$16.isMatrix)(h) && (h = h.toArray()), !Array.isArray(h))
      throw RangeError("Array/Matrix does not have that many dimensions");
    if (u > 0) {
      var p = [];
      return h.forEach(function(m) {
        p.push(o(m, u - 1));
      }), p;
    } else {
      if (u === 0)
        return c(h);
      throw RangeError("Cannot have negative dimension");
    }
  }
  function c(h) {
    var u = [], p = h.length;
    if (p < 2)
      return h;
    for (var m = 1; m < p; m++)
      u.push(l(h[m - 1], h[m]));
    return u;
  }
  function l(h, u) {
    (0, _is$16.isMatrix)(h) && (h = h.toArray()), (0, _is$16.isMatrix)(u) && (u = u.toArray());
    var p = Array.isArray(h), m = Array.isArray(u);
    if (p && m)
      return d(h, u);
    if (!p && !m)
      return a(u, h);
    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
  }
  function d(h, u) {
    if (h.length !== u.length)
      throw RangeError("Not all sub-arrays have the same length");
    for (var p = [], m = h.length, g = 0; g < m; g++)
      p.push(l(h[g], u[g]));
    return p;
  }
});
diff$2.createDiff = createDiff;
var ones$1 = {};
Object.defineProperty(ones$1, "__esModule", {
  value: !0
});
ones$1.createOnes = void 0;
var _is$15 = is, _number$m = number$3, _array$E = array, _factory$33 = factory$1, name$2$ = "ones", dependencies$2$ = ["typed", "config", "matrix", "BigNumber"], createOnes = /* @__PURE__ */ (0, _factory$33.factory)(name$2$, dependencies$2$, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.BigNumber;
  return r("ones", {
    "": function() {
      return n.matrix === "Array" ? o([]) : o([], "default");
    },
    // math.ones(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(h) {
      var u = h[h.length - 1];
      if (typeof u == "string") {
        var p = h.pop();
        return o(h, p);
      } else
        return n.matrix === "Array" ? o(h) : o(h, "default");
    },
    Array: o,
    Matrix: function(h) {
      var u = h.storage();
      return o(h.valueOf(), u);
    },
    "Array | Matrix, string": function(h, u) {
      return o(h.valueOf(), u);
    }
  });
  function o(d, h) {
    var u = c(d), p = u ? new s(1) : 1;
    if (l(d), h) {
      var m = a(h);
      return d.length > 0 ? m.resize(d, p) : m;
    } else {
      var g = [];
      return d.length > 0 ? (0, _array$E.resize)(g, d, p) : g;
    }
  }
  function c(d) {
    var h = !1;
    return d.forEach(function(u, p, m) {
      (0, _is$15.isBigNumber)(u) && (h = !0, m[p] = u.toNumber());
    }), h;
  }
  function l(d) {
    d.forEach(function(h) {
      if (typeof h != "number" || !(0, _number$m.isInteger)(h) || h < 0)
        throw new Error("Parameters in function ones must be positive integers");
    });
  }
});
ones$1.createOnes = createOnes;
var range$1 = {}, noop$3 = {};
Object.defineProperty(noop$3, "__esModule", {
  value: !0
});
noop$3.noBignumber = noBignumber;
noop$3.noFraction = noFraction;
noop$3.noMatrix = noMatrix;
noop$3.noIndex = noIndex;
noop$3.noSubset = noSubset;
function noBignumber() {
  throw new Error('No "bignumber" implementation available');
}
function noFraction() {
  throw new Error('No "fraction" implementation available');
}
function noMatrix() {
  throw new Error('No "matrix" implementation available');
}
function noIndex() {
  throw new Error('No "index" implementation available');
}
function noSubset() {
  throw new Error('No "matrix" implementation available');
}
Object.defineProperty(range$1, "__esModule", {
  value: !0
});
range$1.createRange = void 0;
var _factory$32 = factory$1, _noop$3 = noop$3, name$2_ = "range", dependencies$2_ = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq"], createRange = /* @__PURE__ */ (0, _factory$32.factory)(name$2_, dependencies$2_, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.bignumber, o = t.smaller, c = t.smallerEq, l = t.larger, d = t.largerEq;
  return r(name$2_, {
    // TODO: simplify signatures when typed-function supports default values and optional arguments
    // TODO: a number or boolean should not be converted to string here
    string: u,
    "string, boolean": u,
    "number, number": function(_, $) {
      return h(p(_, $, 1));
    },
    "number, number, number": function(_, $, b) {
      return h(p(_, $, b));
    },
    "number, number, boolean": function(_, $, b) {
      return h(b ? m(_, $, 1) : p(_, $, 1));
    },
    "number, number, number, boolean": function(_, $, b, M) {
      return h(M ? m(_, $, b) : p(_, $, b));
    },
    "BigNumber, BigNumber": function(_, $) {
      var b = _.constructor;
      return h(g(_, $, new b(1)));
    },
    "BigNumber, BigNumber, BigNumber": function(_, $, b) {
      return h(g(_, $, b));
    },
    "BigNumber, BigNumber, boolean": function(_, $, b) {
      var M = _.constructor;
      return h(b ? v(_, $, new M(1)) : g(_, $, new M(1)));
    },
    "BigNumber, BigNumber, BigNumber, boolean": function(_, $, b, M) {
      return h(M ? v(_, $, b) : g(_, $, b));
    }
  });
  function h(x) {
    return n.matrix === "Matrix" ? a ? a(x) : (0, _noop$3.noMatrix)() : x;
  }
  function u(x, _) {
    var $ = y(x);
    if (!$)
      throw new SyntaxError('String "' + x + '" is no valid range');
    var b;
    return n.number === "BigNumber" ? (s === void 0 && (0, _noop$3.noBignumber)(), b = _ ? v : g, h(b(s($.start), s($.end), s($.step)))) : (b = _ ? m : p, h(b($.start, $.end, $.step)));
  }
  function p(x, _, $) {
    var b = [], M = x;
    if ($ > 0)
      for (; o(M, _); )
        b.push(M), M += $;
    else if ($ < 0)
      for (; l(M, _); )
        b.push(M), M += $;
    return b;
  }
  function m(x, _, $) {
    var b = [], M = x;
    if ($ > 0)
      for (; c(M, _); )
        b.push(M), M += $;
    else if ($ < 0)
      for (; d(M, _); )
        b.push(M), M += $;
    return b;
  }
  function g(x, _, $) {
    var b = s(0), M = [], C = x;
    if ($.gt(b))
      for (; o(C, _); )
        M.push(C), C = C.plus($);
    else if ($.lt(b))
      for (; l(C, _); )
        M.push(C), C = C.plus($);
    return M;
  }
  function v(x, _, $) {
    var b = s(0), M = [], C = x;
    if ($.gt(b))
      for (; c(C, _); )
        M.push(C), C = C.plus($);
    else if ($.lt(b))
      for (; d(C, _); )
        M.push(C), C = C.plus($);
    return M;
  }
  function y(x) {
    var _ = x.split(":"), $ = _.map(function(M) {
      return Number(M);
    }), b = $.some(function(M) {
      return isNaN(M);
    });
    if (b)
      return null;
    switch ($.length) {
      case 2:
        return {
          start: $[0],
          end: $[1],
          step: 1
        };
      case 3:
        return {
          start: $[0],
          end: $[2],
          step: $[1]
        };
      default:
        return null;
    }
  }
});
range$1.createRange = createRange;
var reshape$1 = {};
Object.defineProperty(reshape$1, "__esModule", {
  value: !0
});
reshape$1.createReshape = void 0;
var _array$D = array, _factory$31 = factory$1, name$2Z = "reshape", dependencies$2Z = ["typed", "isInteger", "matrix"], createReshape = /* @__PURE__ */ (0, _factory$31.factory)(name$2Z, dependencies$2Z, function(t) {
  var r = t.typed, n = t.isInteger, a = t.matrix;
  return r(name$2Z, {
    "Matrix, Array": function(o, c) {
      return o.reshape ? o.reshape(c) : a((0, _array$D.reshape)(o.valueOf(), c));
    },
    "Array, Array": function(o, c) {
      return c.forEach(function(l) {
        if (!n(l))
          throw new TypeError("Invalid size for dimension: " + l);
      }), (0, _array$D.reshape)(o, c);
    }
  });
});
reshape$1.createReshape = createReshape;
var resize$1 = {}, ArgumentsError$1 = {};
Object.defineProperty(ArgumentsError$1, "__esModule", {
  value: !0
});
ArgumentsError$1.ArgumentsError = ArgumentsError;
function ArgumentsError(t, r, n, a) {
  if (!(this instanceof ArgumentsError))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.fn = t, this.count = r, this.min = n, this.max = a, this.message = "Wrong number of arguments in function " + t + " (" + r + " provided, " + n + (a != null ? "-" + a : "") + " expected)", this.stack = new Error().stack;
}
ArgumentsError.prototype = new Error();
ArgumentsError.prototype.constructor = Error;
ArgumentsError.prototype.name = "ArgumentsError";
ArgumentsError.prototype.isArgumentsError = !0;
Object.defineProperty(resize$1, "__esModule", {
  value: !0
});
resize$1.createResize = void 0;
var _is$14 = is, _DimensionError$3 = DimensionError$1, _ArgumentsError$2 = ArgumentsError$1, _number$l = number$3, _string$n = string$2, _object$s = object, _array$C = array, _factory$30 = factory$1, name$2Y = "resize", dependencies$2Y = ["config", "matrix"], createResize = /* @__PURE__ */ (0, _factory$30.factory)(name$2Y, dependencies$2Y, function(t) {
  var r = t.config, n = t.matrix;
  return function(o, c, l) {
    if (arguments.length !== 2 && arguments.length !== 3)
      throw new _ArgumentsError$2.ArgumentsError("resize", arguments.length, 2, 3);
    if ((0, _is$14.isMatrix)(c) && (c = c.valueOf()), (0, _is$14.isBigNumber)(c[0]) && (c = c.map(function(u) {
      return (0, _is$14.isBigNumber)(u) ? u.toNumber() : u;
    })), (0, _is$14.isMatrix)(o))
      return o.resize(c, l, !0);
    if (typeof o == "string")
      return a(o, c, l);
    var d = Array.isArray(o) ? !1 : r.matrix !== "Array";
    if (c.length === 0) {
      for (; Array.isArray(o); )
        o = o[0];
      return (0, _object$s.clone)(o);
    } else {
      Array.isArray(o) || (o = [o]), o = (0, _object$s.clone)(o);
      var h = (0, _array$C.resize)(o, c, l);
      return d ? n(h) : h;
    }
  };
  function a(s, o, c) {
    if (c !== void 0) {
      if (typeof c != "string" || c.length !== 1)
        throw new TypeError("Single character expected as defaultValue");
    } else
      c = " ";
    if (o.length !== 1)
      throw new _DimensionError$3.DimensionError(o.length, 1);
    var l = o[0];
    if (typeof l != "number" || !(0, _number$l.isInteger)(l))
      throw new TypeError("Invalid size, must contain positive integers (size: " + (0, _string$n.format)(o) + ")");
    if (s.length > l)
      return s.substring(0, l);
    if (s.length < l) {
      for (var d = s, h = 0, u = l - s.length; h < u; h++)
        d += c;
      return d;
    } else
      return s;
  }
});
resize$1.createResize = createResize;
var rotate$1 = {};
Object.defineProperty(rotate$1, "__esModule", {
  value: !0
});
rotate$1.createRotate = void 0;
var _factory$2$ = factory$1, _array$B = array, name$2X = "rotate", dependencies$2X = ["typed", "multiply", "rotationMatrix"], createRotate = /* @__PURE__ */ (0, _factory$2$.factory)(name$2X, dependencies$2X, function(t) {
  var r = t.typed, n = t.multiply, a = t.rotationMatrix;
  return r(name$2X, {
    "Array , number | BigNumber | Complex | Unit": function(c, l) {
      s(c, 2);
      var d = n(a(l), c);
      return d.toArray();
    },
    "Matrix , number | BigNumber | Complex | Unit": function(c, l) {
      return s(c, 2), n(a(l), c);
    },
    "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(c, l, d) {
      s(c, 3);
      var h = n(a(l, d), c);
      return h;
    },
    "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(c, l, d) {
      return s(c, 3), n(a(l, d), c);
    }
  });
  function s(o, c) {
    var l = Array.isArray(o) ? (0, _array$B.arraySize)(o) : o.size();
    if (l.length > 2)
      throw new RangeError("Vector must be of dimensions 1x".concat(c));
    if (l.length === 2 && l[1] !== 1)
      throw new RangeError("Vector must be of dimensions 1x".concat(c));
    if (l[0] !== c)
      throw new RangeError("Vector must be of dimensions 1x".concat(c));
  }
});
rotate$1.createRotate = createRotate;
var rotationMatrix$1 = {};
Object.defineProperty(rotationMatrix$1, "__esModule", {
  value: !0
});
rotationMatrix$1.createRotationMatrix = void 0;
var _is$13 = is, _factory$2_ = factory$1, name$2W = "rotationMatrix", dependencies$2W = ["typed", "config", "multiplyScalar", "addScalar", "unaryMinus", "norm", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix", "cos", "sin"], createRotationMatrix = /* @__PURE__ */ (0, _factory$2_.factory)(name$2W, dependencies$2W, function(t) {
  var r = t.typed, n = t.config, a = t.multiplyScalar, s = t.addScalar, o = t.unaryMinus, c = t.norm, l = t.BigNumber, d = t.matrix, h = t.DenseMatrix, u = t.SparseMatrix, p = t.cos, m = t.sin;
  return r(name$2W, {
    "": function() {
      return n.matrix === "Matrix" ? d([]) : [];
    },
    string: function(b) {
      return d(b);
    },
    "number | BigNumber | Complex | Unit": function(b) {
      return g(b, n.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber | Complex | Unit, string": function(b, M) {
      return g(b, M);
    },
    "number | BigNumber | Complex | Unit, Array": function(b, M) {
      var C = d(M);
      return v(C), _(b, C, void 0);
    },
    "number | BigNumber | Complex | Unit, Matrix": function(b, M) {
      v(M);
      var C = M.storage() || (n.matrix === "Matrix" ? "dense" : void 0);
      return _(b, M, C);
    },
    "number | BigNumber | Complex | Unit, Array, string": function(b, M, C) {
      var S = d(M);
      return v(S), _(b, S, C);
    },
    "number | BigNumber | Complex | Unit, Matrix, string": function(b, M, C) {
      return v(M), _(b, M, C);
    }
  });
  function g($, b) {
    var M = (0, _is$13.isBigNumber)($), C = M ? new l(-1) : -1, S = p($), A = m($), D = [[S, a(C, A)], [A, S]];
    return x(D, b);
  }
  function v($) {
    var b = $.size();
    if (b.length < 1 || b[0] !== 3)
      throw new RangeError("Vector must be of dimensions 1x3");
  }
  function y($) {
    return $.reduce(function(b, M) {
      return a(b, M);
    });
  }
  function x($, b) {
    if (b) {
      if (b === "sparse")
        return new u($);
      if (b === "dense")
        return new h($);
      throw new TypeError('Unknown matrix type "'.concat(b, '"'));
    }
    return $;
  }
  function _($, b, M) {
    var C = c(b);
    if (C === 0)
      throw new RangeError("Rotation around zero vector");
    var S = (0, _is$13.isBigNumber)($) ? l : null, A = S ? new S(1) : 1, D = S ? new S(-1) : -1, N = S ? new S(b.get([0]) / C) : b.get([0]) / C, T = S ? new S(b.get([1]) / C) : b.get([1]) / C, R = S ? new S(b.get([2]) / C) : b.get([2]) / C, F = p($), z = s(A, o(F)), O = m($), G = s(F, y([N, N, z])), I = s(y([N, T, z]), y([D, R, O])), k = s(y([N, R, z]), y([T, O])), B = s(y([N, T, z]), y([R, O])), L = s(F, y([T, T, z])), V = s(y([T, R, z]), y([D, N, O])), U = s(y([N, R, z]), y([D, T, O])), J = s(y([T, R, z]), y([N, O])), q = s(F, y([R, R, z])), Z = [[G, I, k], [B, L, V], [U, J, q]];
    return x(Z, M);
  }
});
rotationMatrix$1.createRotationMatrix = createRotationMatrix;
var row$1 = {};
Object.defineProperty(row$1, "__esModule", {
  value: !0
});
row$1.createRow = void 0;
var _factory$2Z = factory$1, _object$r = object, _array$A = array, name$2V = "row", dependencies$2V = ["typed", "Index", "matrix", "range"], createRow = /* @__PURE__ */ (0, _factory$2Z.factory)(name$2V, dependencies$2V, function(t) {
  var r = t.typed, n = t.Index, a = t.matrix, s = t.range;
  return r(name$2V, {
    "Matrix, number": o,
    "Array, number": function(l, d) {
      return o(a((0, _object$r.clone)(l)), d).valueOf();
    }
  });
  function o(c, l) {
    if (c.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    (0, _array$A.validateIndex)(l, c.size()[0]);
    var d = s(0, c.size()[1]), h = new n(l, d);
    return c.subset(h);
  }
});
row$1.createRow = createRow;
var size$1 = {};
Object.defineProperty(size$1, "__esModule", {
  value: !0
});
size$1.createSize = void 0;
var _array$z = array, _factory$2Y = factory$1, _noop$2 = noop$3, name$2U = "size", dependencies$2U = ["typed", "config", "?matrix"], createSize = /* @__PURE__ */ (0, _factory$2Y.factory)(name$2U, dependencies$2U, function(t) {
  var r = t.typed, n = t.config, a = t.matrix;
  return r(name$2U, {
    Matrix: function(o) {
      return o.create(o.size());
    },
    Array: _array$z.arraySize,
    string: function(o) {
      return n.matrix === "Array" ? [o.length] : a([o.length]);
    },
    "number | Complex | BigNumber | Unit | boolean | null": function(o) {
      return n.matrix === "Array" ? [] : a ? a([]) : (0, _noop$2.noMatrix)();
    }
  });
});
size$1.createSize = createSize;
var squeeze$1 = {};
Object.defineProperty(squeeze$1, "__esModule", {
  value: !0
});
squeeze$1.createSqueeze = void 0;
var _object$q = object, _array$y = array, _factory$2X = factory$1, name$2T = "squeeze", dependencies$2T = ["typed", "matrix"], createSqueeze = /* @__PURE__ */ (0, _factory$2X.factory)(name$2T, dependencies$2T, function(t) {
  var r = t.typed, n = t.matrix;
  return r(name$2T, {
    Array: function(s) {
      return (0, _array$y.squeeze)((0, _object$q.clone)(s));
    },
    Matrix: function(s) {
      var o = (0, _array$y.squeeze)(s.toArray());
      return Array.isArray(o) ? n(o) : o;
    },
    any: function(s) {
      return (0, _object$q.clone)(s);
    }
  });
});
squeeze$1.createSqueeze = createSqueeze;
var subset$1 = {}, customs = {};
Object.defineProperty(customs, "__esModule", {
  value: !0
});
customs.getSafeProperty = getSafeProperty;
customs.setSafeProperty = setSafeProperty;
customs.isSafeProperty = isSafeProperty;
customs.validateSafeMethod = validateSafeMethod;
customs.isSafeMethod = isSafeMethod;
customs.isPlainObject = isPlainObject;
var _object$p = object;
function _typeof$c(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$c = function(n) {
    return typeof n;
  } : _typeof$c = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$c(t);
}
function getSafeProperty(t, r) {
  if (isPlainObject(t) && isSafeProperty(t, r))
    return t[r];
  throw typeof t[r] == "function" && isSafeMethod(t, r) ? new Error('Cannot access method "' + r + '" as a property') : new Error('No access to property "' + r + '"');
}
function setSafeProperty(t, r, n) {
  if (isPlainObject(t) && isSafeProperty(t, r))
    return t[r] = n, n;
  throw new Error('No access to property "' + r + '"');
}
function isSafeProperty(t, r) {
  return !t || _typeof$c(t) !== "object" ? !1 : (0, _object$p.hasOwnProperty)(safeNativeProperties, r) ? !0 : !(r in Object.prototype || r in Function.prototype);
}
function validateSafeMethod(t, r) {
  if (!isSafeMethod(t, r))
    throw new Error('No access to method "' + r + '"');
}
function isSafeMethod(t, r) {
  return t == null || typeof t[r] != "function" || (0, _object$p.hasOwnProperty)(t, r) && Object.getPrototypeOf && r in Object.getPrototypeOf(t) ? !1 : (0, _object$p.hasOwnProperty)(safeNativeMethods, r) ? !0 : !(r in Object.prototype || r in Function.prototype);
}
function isPlainObject(t) {
  return _typeof$c(t) === "object" && t && t.constructor === Object;
}
var safeNativeProperties = {
  length: !0,
  name: !0
}, safeNativeMethods = {
  toString: !0,
  valueOf: !0,
  toLocaleString: !0
};
Object.defineProperty(subset$1, "__esModule", {
  value: !0
});
subset$1.createSubset = void 0;
var _is$12 = is, _object$o = object, _array$x = array, _customs$d = customs, _DimensionError$2 = DimensionError$1, _factory$2W = factory$1, name$2S = "subset", dependencies$2S = ["typed", "matrix"], createSubset = /* @__PURE__ */ (0, _factory$2W.factory)(name$2S, dependencies$2S, function(t) {
  var r = t.typed, n = t.matrix;
  return r(name$2S, {
    // get subset
    "Array, Index": function(s, o) {
      var c = n(s), l = c.subset(o);
      return o.isScalar() ? l : l.valueOf();
    },
    "Matrix, Index": function(s, o) {
      return s.subset(o);
    },
    "Object, Index": _getObjectProperty,
    "string, Index": _getSubstring,
    // set subset
    "Array, Index, any": function(s, o, c) {
      return n((0, _object$o.clone)(s)).subset(o, c, void 0).valueOf();
    },
    "Array, Index, any, any": function(s, o, c, l) {
      return n((0, _object$o.clone)(s)).subset(o, c, l).valueOf();
    },
    "Matrix, Index, any": function(s, o, c) {
      return s.clone().subset(o, c);
    },
    "Matrix, Index, any, any": function(s, o, c, l) {
      return s.clone().subset(o, c, l);
    },
    "string, Index, string": _setSubstring,
    "string, Index, string, string": _setSubstring,
    "Object, Index, any": _setObjectProperty
  });
});
subset$1.createSubset = createSubset;
function _getSubstring(t, r) {
  if (!(0, _is$12.isIndex)(r))
    throw new TypeError("Index expected");
  if (r.size().length !== 1)
    throw new _DimensionError$2.DimensionError(r.size().length, 1);
  var n = t.length;
  (0, _array$x.validateIndex)(r.min()[0], n), (0, _array$x.validateIndex)(r.max()[0], n);
  var a = r.dimension(0), s = "";
  return a.forEach(function(o) {
    s += t.charAt(o);
  }), s;
}
function _setSubstring(t, r, n, a) {
  if (!r || r.isIndex !== !0)
    throw new TypeError("Index expected");
  if (r.size().length !== 1)
    throw new _DimensionError$2.DimensionError(r.size().length, 1);
  if (a !== void 0) {
    if (typeof a != "string" || a.length !== 1)
      throw new TypeError("Single character expected as defaultValue");
  } else
    a = " ";
  var s = r.dimension(0), o = s.size()[0];
  if (o !== n.length)
    throw new _DimensionError$2.DimensionError(s.size()[0], n.length);
  var c = t.length;
  (0, _array$x.validateIndex)(r.min()[0]), (0, _array$x.validateIndex)(r.max()[0]);
  for (var l = [], d = 0; d < c; d++)
    l[d] = t.charAt(d);
  if (s.forEach(function(p, m) {
    l[p] = n.charAt(m[0]);
  }), l.length > c)
    for (var h = c - 1, u = l.length; h < u; h++)
      l[h] || (l[h] = a);
  return l.join("");
}
function _getObjectProperty(t, r) {
  if (r.size().length !== 1)
    throw new _DimensionError$2.DimensionError(r.size(), 1);
  var n = r.dimension(0);
  if (typeof n != "string")
    throw new TypeError("String expected as index to retrieve an object property");
  return (0, _customs$d.getSafeProperty)(t, n);
}
function _setObjectProperty(t, r, n) {
  if (r.size().length !== 1)
    throw new _DimensionError$2.DimensionError(r.size(), 1);
  var a = r.dimension(0);
  if (typeof a != "string")
    throw new TypeError("String expected as index to retrieve an object property");
  var s = (0, _object$o.clone)(t);
  return (0, _customs$d.setSafeProperty)(s, a, n), s;
}
var transpose$1 = {};
Object.defineProperty(transpose$1, "__esModule", {
  value: !0
});
transpose$1.createTranspose = void 0;
var _object$n = object, _string$m = string$2, _factory$2V = factory$1, name$2R = "transpose", dependencies$2R = ["typed", "matrix"], createTranspose = /* @__PURE__ */ (0, _factory$2V.factory)(name$2R, dependencies$2R, function(t) {
  var r = t.typed, n = t.matrix;
  return r("transpose", {
    Array: function(c) {
      return this(n(c)).valueOf();
    },
    Matrix: function(c) {
      var l = c.size(), d;
      switch (l.length) {
        case 1:
          d = c.clone();
          break;
        case 2:
          {
            var h = l[0], u = l[1];
            if (u === 0)
              throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + (0, _string$m.format)(l) + ")");
            switch (c.storage()) {
              case "dense":
                d = a(c, h, u);
                break;
              case "sparse":
                d = s(c, h, u);
                break;
            }
          }
          break;
        default:
          throw new RangeError("Matrix must be a vector or two dimensional (size: " + (0, _string$m.format)(this._size) + ")");
      }
      return d;
    },
    // scalars
    any: function(c) {
      return (0, _object$n.clone)(c);
    }
  });
  function a(o, c, l) {
    for (var d = o._data, h = [], u, p = 0; p < l; p++) {
      u = h[p] = [];
      for (var m = 0; m < c; m++)
        u[m] = (0, _object$n.clone)(d[m][p]);
    }
    return o.createDenseMatrix({
      data: h,
      size: [l, c],
      datatype: o._datatype
    });
  }
  function s(o, c, l) {
    for (var d = o._values, h = o._index, u = o._ptr, p = d ? [] : void 0, m = [], g = [], v = [], y = 0; y < c; y++)
      v[y] = 0;
    var x, _, $;
    for (x = 0, _ = h.length; x < _; x++)
      v[h[x]]++;
    for (var b = 0, M = 0; M < c; M++)
      g.push(b), b += v[M], v[M] = g[M];
    for (g.push(b), $ = 0; $ < l; $++)
      for (var C = u[$], S = u[$ + 1], A = C; A < S; A++) {
        var D = v[h[A]]++;
        m[D] = $, d && (p[D] = (0, _object$n.clone)(d[A]));
      }
    return o.createSparseMatrix({
      values: p,
      index: m,
      ptr: g,
      size: [l, c],
      datatype: o._datatype
    });
  }
});
transpose$1.createTranspose = createTranspose;
var ctranspose$1 = {};
Object.defineProperty(ctranspose$1, "__esModule", {
  value: !0
});
ctranspose$1.createCtranspose = void 0;
var _factory$2U = factory$1, name$2Q = "ctranspose", dependencies$2Q = ["typed", "transpose", "conj"], createCtranspose = /* @__PURE__ */ (0, _factory$2U.factory)(name$2Q, dependencies$2Q, function(t) {
  var r = t.typed, n = t.transpose, a = t.conj;
  return r(name$2Q, {
    any: function(o) {
      return a(n(o));
    }
  });
});
ctranspose$1.createCtranspose = createCtranspose;
var zeros$1 = {};
Object.defineProperty(zeros$1, "__esModule", {
  value: !0
});
zeros$1.createZeros = void 0;
var _is$11 = is, _number$k = number$3, _array$w = array, _factory$2T = factory$1, name$2P = "zeros", dependencies$2P = ["typed", "config", "matrix", "BigNumber"], createZeros = /* @__PURE__ */ (0, _factory$2T.factory)(name$2P, dependencies$2P, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.BigNumber;
  return r(name$2P, {
    "": function() {
      return n.matrix === "Array" ? o([]) : o([], "default");
    },
    // math.zeros(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(h) {
      var u = h[h.length - 1];
      if (typeof u == "string") {
        var p = h.pop();
        return o(h, p);
      } else
        return n.matrix === "Array" ? o(h) : o(h, "default");
    },
    Array: o,
    Matrix: function(h) {
      var u = h.storage();
      return o(h.valueOf(), u);
    },
    "Array | Matrix, string": function(h, u) {
      return o(h.valueOf(), u);
    }
  });
  function o(d, h) {
    var u = c(d), p = u ? new s(0) : 0;
    if (l(d), h) {
      var m = a(h);
      return d.length > 0 ? m.resize(d, p) : m;
    } else {
      var g = [];
      return d.length > 0 ? (0, _array$w.resize)(g, d, p) : g;
    }
  }
  function c(d) {
    var h = !1;
    return d.forEach(function(u, p, m) {
      (0, _is$11.isBigNumber)(u) && (h = !0, m[p] = u.toNumber());
    }), h;
  }
  function l(d) {
    d.forEach(function(h) {
      if (typeof h != "number" || !(0, _number$k.isInteger)(h) || h < 0)
        throw new Error("Parameters in function zeros must be positive integers");
    });
  }
});
zeros$1.createZeros = createZeros;
var erf$1 = {};
Object.defineProperty(erf$1, "__esModule", {
  value: !0
});
erf$1.createErf = void 0;
var _collection$G = collection$1, _number$j = number$3, _factory$2S = factory$1, name$2O = "erf", dependencies$2O = ["typed"], createErf = /* @__PURE__ */ (0, _factory$2S.factory)(name$2O, dependencies$2O, function(t) {
  var r = t.typed;
  return r("name", {
    number: function(c) {
      var l = Math.abs(c);
      return l >= MAX_NUM ? (0, _number$j.sign)(c) : l <= THRESH ? (0, _number$j.sign)(c) * n(l) : l <= 4 ? (0, _number$j.sign)(c) * (1 - a(l)) : (0, _number$j.sign)(c) * (1 - s(l));
    },
    "Array | Matrix": function(c) {
      return (0, _collection$G.deepMap)(c, this);
    }
    // TODO: For complex numbers, use the approximation for the Faddeeva function
    //  from "More Efficient Computation of the Complex Error Function" (AMS)
  });
  function n(o) {
    var c = o * o, l = P[0][4] * c, d = c, h;
    for (h = 0; h < 3; h += 1)
      l = (l + P[0][h]) * c, d = (d + Q[0][h]) * c;
    return o * (l + P[0][3]) / (d + Q[0][3]);
  }
  function a(o) {
    var c = P[1][8] * o, l = o, d;
    for (d = 0; d < 7; d += 1)
      c = (c + P[1][d]) * o, l = (l + Q[1][d]) * o;
    var h = (c + P[1][7]) / (l + Q[1][7]), u = parseInt(o * 16) / 16, p = (o - u) * (o + u);
    return Math.exp(-u * u) * Math.exp(-p) * h;
  }
  function s(o) {
    var c = 1 / (o * o), l = P[2][5] * c, d = c, h;
    for (h = 0; h < 4; h += 1)
      l = (l + P[2][h]) * c, d = (d + Q[2][h]) * c;
    var u = c * (l + P[2][4]) / (d + Q[2][4]);
    u = (SQRPI - u) / o, c = parseInt(o * 16) / 16;
    var p = (o - c) * (o + c);
    return Math.exp(-c * c) * Math.exp(-p) * u;
  }
});
erf$1.createErf = createErf;
var THRESH = 0.46875, SQRPI = 0.5641895835477563, P = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Q = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], MAX_NUM = Math.pow(2, 53), mode$1 = {};
Object.defineProperty(mode$1, "__esModule", {
  value: !0
});
mode$1.createMode = void 0;
var _array$v = array, _factory$2R = factory$1, name$2N = "mode", dependencies$2N = ["typed", "isNaN", "isNumeric"], createMode = /* @__PURE__ */ (0, _factory$2R.factory)(name$2N, dependencies$2N, function(t) {
  var r = t.typed, n = t.isNaN, a = t.isNumeric;
  return r(name$2N, {
    "Array | Matrix": s,
    "...": function(c) {
      return s(c);
    }
  });
  function s(o) {
    o = (0, _array$v.flatten)(o.valueOf());
    var c = o.length;
    if (c === 0)
      throw new Error("Cannot calculate mode of an empty array");
    for (var l = {}, d = [], h = 0, u = 0; u < o.length; u++) {
      var p = o[u];
      if (a(p) && n(p))
        throw new Error("Cannot calculate mode of an array containing NaN values");
      p in l || (l[p] = 0), l[p]++, l[p] === h ? d.push(p) : l[p] > h && (h = l[p], d = [p]);
    }
    return d;
  }
});
mode$1.createMode = createMode;
var prod$1 = {}, improveErrorMessage$1 = {};
Object.defineProperty(improveErrorMessage$1, "__esModule", {
  value: !0
});
improveErrorMessage$1.improveErrorMessage = improveErrorMessage;
var _is$10 = is;
function improveErrorMessage(t, r, n) {
  var a;
  return String(t).indexOf("Unexpected type") !== -1 ? (a = arguments.length > 2 ? " (type: " + (0, _is$10.typeOf)(n) + ", value: " + JSON.stringify(n) + ")" : " (type: " + t.data.actual + ")", new TypeError("Cannot calculate " + r + ", unexpected type of argument" + a)) : String(t).indexOf("complex numbers") !== -1 ? (a = arguments.length > 2 ? " (type: " + (0, _is$10.typeOf)(n) + ", value: " + JSON.stringify(n) + ")" : "", new TypeError("Cannot calculate " + r + ", no ordering relation is defined for complex numbers" + a)) : t;
}
Object.defineProperty(prod$1, "__esModule", {
  value: !0
});
prod$1.createProd = void 0;
var _collection$F = collection$1, _factory$2Q = factory$1, _improveErrorMessage$7 = improveErrorMessage$1, name$2M = "prod", dependencies$2M = ["typed", "config", "multiplyScalar", "numeric"], createProd = /* @__PURE__ */ (0, _factory$2Q.factory)(name$2M, dependencies$2M, function(t) {
  var r = t.typed, n = t.config, a = t.multiplyScalar, s = t.numeric;
  return r(name$2M, {
    // prod([a, b, c, d, ...])
    "Array | Matrix": o,
    // prod([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(l, d) {
      throw new Error("prod(A, dim) is not yet supported");
    },
    // prod(a, b, c, d, ...)
    "...": function(l) {
      return o(l);
    }
  });
  function o(c) {
    var l;
    if ((0, _collection$F.deepForEach)(c, function(d) {
      try {
        l = l === void 0 ? d : a(l, d);
      } catch (h) {
        throw (0, _improveErrorMessage$7.improveErrorMessage)(h, "prod", d);
      }
    }), typeof l == "string" && (l = s(l, n.number)), l === void 0)
      throw new Error("Cannot calculate prod of an empty array");
    return l;
  }
});
prod$1.createProd = createProd;
var format$2 = {};
Object.defineProperty(format$2, "__esModule", {
  value: !0
});
format$2.createFormat = void 0;
var _string$l = string$2, _factory$2P = factory$1, name$2L = "format", dependencies$2L = ["typed"], createFormat = /* @__PURE__ */ (0, _factory$2P.factory)(name$2L, dependencies$2L, function(t) {
  var r = t.typed;
  return r(name$2L, {
    any: _string$l.format,
    "any, Object | function | number": _string$l.format
  });
});
format$2.createFormat = createFormat;
var bin$1 = {}, baseUtils = {};
Object.defineProperty(baseUtils, "__esModule", {
  value: !0
});
baseUtils.createBaseFormatterFactory = createBaseFormatterFactory;
var _factory$2O = factory$1, _number$i = number$3;
function baseFormatter(t) {
  var r = {
    2: "0b",
    8: "0o",
    16: "0x"
  }, n = r[t];
  return function(a) {
    if (a > Math.pow(2, 31) - 1 || a < -Math.pow(2, 31))
      throw new Error("Value must be in range [-2^31, 2^31-1]");
    if (!(0, _number$i.isInteger)(a))
      throw new Error("Value must be an integer");
    return a < 0 && (a = a + Math.pow(2, 32)), "".concat(n).concat(a.toString(t));
  };
}
var dependencies$2K = ["typed"];
function createBaseFormatterFactory(t, r) {
  return (0, _factory$2O.factory)(t, dependencies$2K, function(n) {
    var a = n.typed;
    return a(t, {
      number: baseFormatter(r)
    });
  });
}
Object.defineProperty(bin$1, "__esModule", {
  value: !0
});
bin$1.createBin = void 0;
var _baseUtils$2 = baseUtils, createBin = (0, _baseUtils$2.createBaseFormatterFactory)("bin", 2);
bin$1.createBin = createBin;
var oct$1 = {};
Object.defineProperty(oct$1, "__esModule", {
  value: !0
});
oct$1.createOct = void 0;
var _baseUtils$1 = baseUtils, createOct = (0, _baseUtils$1.createBaseFormatterFactory)("oct", 8);
oct$1.createOct = createOct;
var hex$1 = {};
Object.defineProperty(hex$1, "__esModule", {
  value: !0
});
hex$1.createHex = void 0;
var _baseUtils = baseUtils, createHex = (0, _baseUtils.createBaseFormatterFactory)("hex", 16);
hex$1.createHex = createHex;
var print = {};
Object.defineProperty(print, "__esModule", {
  value: !0
});
print.createPrint = void 0;
var _string$k = string$2, _is$$ = is, _factory$2N = factory$1, name$2K = "print", dependencies$2J = ["typed"], createPrint = /* @__PURE__ */ (0, _factory$2N.factory)(name$2K, dependencies$2J, function(t) {
  var r = t.typed;
  return r(name$2K, {
    // note: Matrix will be converted automatically to an Array
    "string, Object | Array": _print,
    "string, Object | Array, number | Object": _print
  });
});
print.createPrint = createPrint;
function _print(t, r, n) {
  return t.replace(/\$([\w.]+)/g, function(a, s) {
    for (var o = s.split("."), c = r[o.shift()]; o.length && c !== void 0; ) {
      var l = o.shift();
      c = l ? c[l] : c + ".";
    }
    return c !== void 0 ? (0, _is$$.isString)(c) ? c : (0, _string$k.format)(c, n) : a;
  });
}
var to$2 = {};
Object.defineProperty(to$2, "__esModule", {
  value: !0
});
to$2.createTo = void 0;
var _factory$2M = factory$1, _algorithm$i = algorithm13, _algorithm2$i = algorithm14, name$2J = "to", dependencies$2I = ["typed", "matrix"], createTo = /* @__PURE__ */ (0, _factory$2M.factory)(name$2J, dependencies$2I, function(t) {
  var r = t.typed, n = t.matrix, a = (0, _algorithm$i.createAlgorithm13)({
    typed: r
  }), s = (0, _algorithm2$i.createAlgorithm14)({
    typed: r
  });
  return r(name$2J, {
    "Unit, Unit | string": function(c, l) {
      return c.to(l);
    },
    "Matrix, Matrix": function(c, l) {
      return a(c, l, this);
    },
    "Array, Array": function(c, l) {
      return this(n(c), n(l)).valueOf();
    },
    "Array, Matrix": function(c, l) {
      return this(n(c), l);
    },
    "Matrix, Array": function(c, l) {
      return this(c, n(l));
    },
    "Matrix, any": function(c, l) {
      return s(c, l, this, !1);
    },
    "any, Matrix": function(c, l) {
      return s(l, c, this, !0);
    },
    "Array, any": function(c, l) {
      return s(n(c), l, this, !1).valueOf();
    },
    "any, Array": function(c, l) {
      return s(n(l), c, this, !0).valueOf();
    }
  });
});
to$2.createTo = createTo;
var isPrime$1 = {};
Object.defineProperty(isPrime$1, "__esModule", {
  value: !0
});
isPrime$1.createIsPrime = void 0;
var _collection$E = collection$1, _factory$2L = factory$1, name$2I = "isPrime", dependencies$2H = ["typed"], createIsPrime = /* @__PURE__ */ (0, _factory$2L.factory)(name$2I, dependencies$2H, function(t) {
  var r = t.typed;
  return r(name$2I, {
    number: function(a) {
      if (a * 0 !== 0)
        return !1;
      if (a <= 3)
        return a > 1;
      if (a % 2 === 0 || a % 3 === 0)
        return !1;
      for (var s = 5; s * s <= a; s += 6)
        if (a % s === 0 || a % (s + 2) === 0)
          return !1;
      return !0;
    },
    BigNumber: function(a) {
      if (a.toNumber() * 0 !== 0)
        return !1;
      if (a.lte(3))
        return a.gt(1);
      if (a.mod(2).eq(0) || a.mod(3).eq(0))
        return !1;
      for (var s = 5; a.gte(s * s); s += 6)
        if (a.mod(s).eq(0) || a.mod(s + 2).eq(0))
          return !1;
      return !0;
    },
    "Array | Matrix": function(a) {
      return (0, _collection$E.deepMap)(a, this);
    }
  });
});
isPrime$1.createIsPrime = createIsPrime;
var numeric$1 = {};
Object.defineProperty(numeric$1, "__esModule", {
  value: !0
});
numeric$1.createNumeric = void 0;
var _is$_ = is, _factory$2K = factory$1, _noop$1 = noop$3, name$2H = "numeric", dependencies$2G = ["number", "?bignumber", "?fraction"], createNumeric = /* @__PURE__ */ (0, _factory$2K.factory)(name$2H, dependencies$2G, function(t) {
  var r = t.number, n = t.bignumber, a = t.fraction, s = {
    string: !0,
    number: !0,
    BigNumber: !0,
    Fraction: !0
  }, o = {
    number: function(l) {
      return r(l);
    },
    BigNumber: n ? function(c) {
      return n(c);
    } : _noop$1.noBignumber,
    Fraction: a ? function(c) {
      return a(c);
    } : _noop$1.noFraction
  };
  return function(l, d) {
    var h = (0, _is$_.typeOf)(l);
    if (!(h in s))
      throw new TypeError("Cannot convert " + l + ' of type "' + h + '"; valid input types are ' + Object.keys(s).join(", "));
    if (!(d in o))
      throw new TypeError("Cannot convert " + l + ' to type "' + d + '"; valid output types are ' + Object.keys(o).join(", "));
    return d === h ? l : o[d](l);
  };
});
numeric$1.createNumeric = createNumeric;
var divideScalar = {};
Object.defineProperty(divideScalar, "__esModule", {
  value: !0
});
divideScalar.createDivideScalar = void 0;
var _factory$2J = factory$1, _is$Z = is, name$2G = "divideScalar", dependencies$2F = ["typed", "numeric"], createDivideScalar = /* @__PURE__ */ (0, _factory$2J.factory)(name$2G, dependencies$2F, function(t) {
  var r = t.typed, n = t.numeric;
  return r(name$2G, {
    "number, number": function(s, o) {
      return s / o;
    },
    "Complex, Complex": function(s, o) {
      return s.div(o);
    },
    "BigNumber, BigNumber": function(s, o) {
      return s.div(o);
    },
    "Fraction, Fraction": function(s, o) {
      return s.div(o);
    },
    "Unit, number | Fraction | BigNumber": function(s, o) {
      var c = s.clone(), l = n(1, (0, _is$Z.typeOf)(o));
      return c.value = this(c.value === null ? c._normalize(l) : c.value, o), c;
    },
    "number | Fraction | BigNumber, Unit": function(s, o) {
      var c = o.clone();
      c = c.pow(-1);
      var l = n(1, (0, _is$Z.typeOf)(s));
      return c.value = this(s, o.value === null ? o._normalize(l) : o.value), c;
    },
    "Unit, Unit": function(s, o) {
      return s.divide(o);
    }
  });
});
divideScalar.createDivideScalar = createDivideScalar;
var pow$1 = {};
Object.defineProperty(pow$1, "__esModule", {
  value: !0
});
pow$1.createPow = void 0;
var _factory$2I = factory$1, _number$h = number$3, _array$u = array, _index$p = number$2, name$2F = "pow", dependencies$2E = ["typed", "config", "identity", "multiply", "matrix", "fraction", "number", "Complex"], createPow = /* @__PURE__ */ (0, _factory$2I.factory)(name$2F, dependencies$2E, function(t) {
  var r = t.typed, n = t.config, a = t.identity, s = t.multiply, o = t.matrix, c = t.number, l = t.fraction, d = t.Complex;
  return r(name$2F, {
    "number, number": h,
    "Complex, Complex": function(g, v) {
      return g.pow(v);
    },
    "BigNumber, BigNumber": function(g, v) {
      return v.isInteger() || g >= 0 || n.predictable ? g.pow(v) : new d(g.toNumber(), 0).pow(v.toNumber(), 0);
    },
    "Fraction, Fraction": function(g, v) {
      if (v.d !== 1) {
        if (n.predictable)
          throw new Error("Function pow does not support non-integer exponents for fractions.");
        return h(g.valueOf(), v.valueOf());
      } else
        return g.pow(v);
    },
    "Array, number": u,
    "Array, BigNumber": function(g, v) {
      return u(g, v.toNumber());
    },
    "Matrix, number": p,
    "Matrix, BigNumber": function(g, v) {
      return p(g, v.toNumber());
    },
    "Unit, number | BigNumber": function(g, v) {
      return g.pow(v);
    }
  });
  function h(m, g) {
    if (n.predictable && !(0, _number$h.isInteger)(g) && m < 0)
      try {
        var v = l(g), y = c(v);
        if ((g === y || Math.abs((g - y) / g) < 1e-14) && v.d % 2 === 1)
          return (v.n % 2 === 0 ? 1 : -1) * Math.pow(-m, g);
      } catch {
      }
    return n.predictable && (m < -1 && g === 1 / 0 || m > -1 && m < 0 && g === -1 / 0) ? NaN : (0, _number$h.isInteger)(g) || m >= 0 || n.predictable ? (0, _index$p.powNumber)(m, g) : m * m < 1 && g === 1 / 0 || m * m > 1 && g === -1 / 0 ? 0 : new d(m, 0).pow(g, 0);
  }
  function u(m, g) {
    if (!(0, _number$h.isInteger)(g) || g < 0)
      throw new TypeError("For A^b, b must be a positive integer (value is " + g + ")");
    var v = (0, _array$u.arraySize)(m);
    if (v.length !== 2)
      throw new Error("For A^b, A must be 2 dimensional (A has " + v.length + " dimensions)");
    if (v[0] !== v[1])
      throw new Error("For A^b, A must be square (size is " + v[0] + "x" + v[1] + ")");
    for (var y = a(v[0]).valueOf(), x = m; g >= 1; )
      (g & 1) === 1 && (y = s(x, y)), g >>= 1, x = s(x, x);
    return y;
  }
  function p(m, g) {
    return o(u(m.valueOf(), g));
  }
});
pow$1.createPow = createPow;
var round$3 = {};
Object.defineProperty(round$3, "__esModule", {
  value: !0
});
round$3.createRoundNumber = round$3.createRound = void 0;
var _factory$2H = factory$1, _collection$D = collection$1, _number$g = number$3, _algorithm$h = algorithm11, _algorithm2$h = algorithm12, _algorithm3$f = algorithm14, _index$o = number$2;
function ownKeys$8(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$8(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$8(Object(n), !0).forEach(function(a) {
      _defineProperty$5(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$8(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$5(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
var NO_INT = "Number of decimals in function round must be an integer", name$2E = "round", dependencies$2D = ["typed", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], createRound = /* @__PURE__ */ (0, _factory$2H.factory)(name$2E, dependencies$2D, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.zeros, o = t.BigNumber, c = t.DenseMatrix, l = (0, _algorithm$h.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm2$h.createAlgorithm12)({
    typed: r,
    DenseMatrix: c
  }), h = (0, _algorithm3$f.createAlgorithm14)({
    typed: r
  });
  return r(name$2E, _objectSpread$8(_objectSpread$8({}, roundNumberSignatures), {}, {
    Complex: function(p) {
      return p.round();
    },
    "Complex, number": function(p, m) {
      if (m % 1)
        throw new TypeError(NO_INT);
      return p.round(m);
    },
    "Complex, BigNumber": function(p, m) {
      if (!m.isInteger())
        throw new TypeError(NO_INT);
      var g = m.toNumber();
      return p.round(g);
    },
    "number, BigNumber": function(p, m) {
      if (!m.isInteger())
        throw new TypeError(NO_INT);
      return new o(p).toDecimalPlaces(m.toNumber());
    },
    BigNumber: function(p) {
      return p.toDecimalPlaces(0);
    },
    "BigNumber, BigNumber": function(p, m) {
      if (!m.isInteger())
        throw new TypeError(NO_INT);
      return p.toDecimalPlaces(m.toNumber());
    },
    Fraction: function(p) {
      return p.round();
    },
    "Fraction, number": function(p, m) {
      if (m % 1)
        throw new TypeError(NO_INT);
      return p.round(m);
    },
    "Array | Matrix": function(p) {
      return (0, _collection$D.deepMap)(p, this, !0);
    },
    "SparseMatrix, number | BigNumber": function(p, m) {
      return l(p, m, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(p, m) {
      return h(p, m, this, !1);
    },
    "number | Complex | BigNumber, SparseMatrix": function(p, m) {
      return a(p, 0) ? s(m.size(), m.storage()) : d(m, p, this, !0);
    },
    "number | Complex | BigNumber, DenseMatrix": function(p, m) {
      return a(p, 0) ? s(m.size(), m.storage()) : h(m, p, this, !0);
    },
    "Array, number | BigNumber": function(p, m) {
      return h(n(p), m, this, !1).valueOf();
    },
    "number | Complex | BigNumber, Array": function(p, m) {
      return h(n(m), p, this, !0).valueOf();
    }
  }));
});
round$3.createRound = createRound;
var roundNumberSignatures = {
  number: _index$o.roundNumber,
  "number, number": function(r, n) {
    if (!(0, _number$g.isInteger)(n))
      throw new TypeError(NO_INT);
    if (n < 0 || n > 15)
      throw new Error("Number of decimals in function round must be in te range of 0-15");
    return (0, _index$o.roundNumber)(r, n);
  }
}, createRoundNumber = /* @__PURE__ */ (0, _factory$2H.factory)(name$2E, ["typed"], function(t) {
  var r = t.typed;
  return r(name$2E, roundNumberSignatures);
});
round$3.createRoundNumber = createRoundNumber;
var log$1 = {};
Object.defineProperty(log$1, "__esModule", {
  value: !0
});
log$1.createLog = void 0;
var _factory$2G = factory$1, _collection$C = collection$1, _index$n = number$2, name$2D = "log", dependencies$2C = ["config", "typed", "divideScalar", "Complex"], createLog = /* @__PURE__ */ (0, _factory$2G.factory)(name$2D, dependencies$2C, function(t) {
  var r = t.typed, n = t.config, a = t.divideScalar, s = t.Complex;
  return r(name$2D, {
    number: function(c) {
      return c >= 0 || n.predictable ? (0, _index$n.logNumber)(c) : new s(c, 0).log();
    },
    Complex: function(c) {
      return c.log();
    },
    BigNumber: function(c) {
      return !c.isNegative() || n.predictable ? c.ln() : new s(c.toNumber(), 0).log();
    },
    "Array | Matrix": function(c) {
      return (0, _collection$C.deepMap)(c, this);
    },
    "any, any": function(c, l) {
      return a(this(c), this(l));
    }
  });
});
log$1.createLog = createLog;
var log1p$1 = {};
Object.defineProperty(log1p$1, "__esModule", {
  value: !0
});
log1p$1.createLog1p = void 0;
var _factory$2F = factory$1, _collection$B = collection$1, _number$f = number$3, name$2C = "log1p", dependencies$2B = ["typed", "config", "divideScalar", "log", "Complex"], createLog1p = /* @__PURE__ */ (0, _factory$2F.factory)(name$2C, dependencies$2B, function(t) {
  var r = t.typed, n = t.config, a = t.divideScalar, s = t.log, o = t.Complex;
  return r(name$2C, {
    number: function(d) {
      return d >= -1 || n.predictable ? (0, _number$f.log1p)(d) : c(new o(d, 0));
    },
    Complex: c,
    BigNumber: function(d) {
      var h = d.plus(1);
      return !h.isNegative() || n.predictable ? h.ln() : c(new o(d.toNumber(), 0));
    },
    "Array | Matrix": function(d) {
      return (0, _collection$B.deepMap)(d, this);
    },
    "any, any": function(d, h) {
      return a(this(d), s(h));
    }
  });
  function c(l) {
    var d = l.re + 1;
    return new o(Math.log(Math.sqrt(d * d + l.im * l.im)), Math.atan2(l.im, d));
  }
});
log1p$1.createLog1p = createLog1p;
var nthRoots$1 = {};
Object.defineProperty(nthRoots$1, "__esModule", {
  value: !0
});
nthRoots$1.createNthRoots = void 0;
var _factory$2E = factory$1, name$2B = "nthRoots", dependencies$2A = ["config", "typed", "divideScalar", "Complex"], createNthRoots = /* @__PURE__ */ (0, _factory$2E.factory)(name$2B, dependencies$2A, function(t) {
  var r = t.typed;
  t.config, t.divideScalar;
  var n = t.Complex, a = [function(c) {
    return new n(c, 0);
  }, function(c) {
    return new n(0, c);
  }, function(c) {
    return new n(-c, 0);
  }, function(c) {
    return new n(0, -c);
  }];
  function s(o, c) {
    if (c < 0)
      throw new Error("Root must be greater than zero");
    if (c === 0)
      throw new Error("Root must be non-zero");
    if (c % 1 !== 0)
      throw new Error("Root must be an integer");
    if (o === 0 || o.abs() === 0)
      return [new n(0, 0)];
    var l = typeof o == "number", d;
    (l || o.re === 0 || o.im === 0) && (l ? d = 2 * +(o < 0) : o.im === 0 ? d = 2 * +(o.re < 0) : d = 2 * +(o.im < 0) + 1);
    for (var h = o.arg(), u = o.abs(), p = [], m = Math.pow(u, 1 / c), g = 0; g < c; g++) {
      var v = (d + 4 * g) / c;
      if (v === Math.round(v)) {
        p.push(a[v % 4](m));
        continue;
      }
      p.push(new n({
        r: m,
        phi: (h + 2 * Math.PI * g) / c
      }));
    }
    return p;
  }
  return r(name$2B, {
    Complex: function(c) {
      return s(c, 2);
    },
    "Complex, number": s
  });
});
nthRoots$1.createNthRoots = createNthRoots;
var dotPow$1 = {};
Object.defineProperty(dotPow$1, "__esModule", {
  value: !0
});
dotPow$1.createDotPow = void 0;
var _factory$2D = factory$1, _algorithm$g = algorithm03, _algorithm2$g = algorithm07, _algorithm3$e = algorithm11, _algorithm4$e = algorithm12, _algorithm5$e = algorithm13, _algorithm6$5 = algorithm14, name$2A = "dotPow", dependencies$2z = ["typed", "equalScalar", "matrix", "pow", "DenseMatrix"], createDotPow = /* @__PURE__ */ (0, _factory$2D.factory)(name$2A, dependencies$2z, function(t) {
  var r = t.typed, n = t.equalScalar, a = t.matrix, s = t.pow, o = t.DenseMatrix, c = (0, _algorithm$g.createAlgorithm03)({
    typed: r
  }), l = (0, _algorithm2$g.createAlgorithm07)({
    typed: r,
    DenseMatrix: o
  }), d = (0, _algorithm3$e.createAlgorithm11)({
    typed: r,
    equalScalar: n
  }), h = (0, _algorithm4$e.createAlgorithm12)({
    typed: r,
    DenseMatrix: o
  }), u = (0, _algorithm5$e.createAlgorithm13)({
    typed: r
  }), p = (0, _algorithm6$5.createAlgorithm14)({
    typed: r
  });
  return r(name$2A, {
    "any, any": s,
    "SparseMatrix, SparseMatrix": function(g, v) {
      return l(g, v, s, !1);
    },
    "SparseMatrix, DenseMatrix": function(g, v) {
      return c(v, g, s, !0);
    },
    "DenseMatrix, SparseMatrix": function(g, v) {
      return c(g, v, s, !1);
    },
    "DenseMatrix, DenseMatrix": function(g, v) {
      return u(g, v, s);
    },
    "Array, Array": function(g, v) {
      return this(a(g), a(v)).valueOf();
    },
    "Array, Matrix": function(g, v) {
      return this(a(g), v);
    },
    "Matrix, Array": function(g, v) {
      return this(g, a(v));
    },
    "SparseMatrix, any": function(g, v) {
      return d(g, v, this, !1);
    },
    "DenseMatrix, any": function(g, v) {
      return p(g, v, this, !1);
    },
    "any, SparseMatrix": function(g, v) {
      return h(v, g, this, !0);
    },
    "any, DenseMatrix": function(g, v) {
      return p(v, g, this, !0);
    },
    "Array, any": function(g, v) {
      return p(a(g), v, this, !1).valueOf();
    },
    "any, Array": function(g, v) {
      return p(a(v), g, this, !0).valueOf();
    }
  });
});
dotPow$1.createDotPow = createDotPow;
var dotDivide$1 = {};
Object.defineProperty(dotDivide$1, "__esModule", {
  value: !0
});
dotDivide$1.createDotDivide = void 0;
var _factory$2C = factory$1, _algorithm$f = algorithm02, _algorithm2$f = algorithm03, _algorithm3$d = algorithm07, _algorithm4$d = algorithm11, _algorithm5$d = algorithm12, _algorithm6$4 = algorithm13, _algorithm7$4 = algorithm14, name$2z = "dotDivide", dependencies$2y = ["typed", "matrix", "equalScalar", "divideScalar", "DenseMatrix"], createDotDivide = /* @__PURE__ */ (0, _factory$2C.factory)(name$2z, dependencies$2y, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.divideScalar, o = t.DenseMatrix, c = (0, _algorithm$f.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm2$f.createAlgorithm03)({
    typed: r
  }), d = (0, _algorithm3$d.createAlgorithm07)({
    typed: r,
    DenseMatrix: o
  }), h = (0, _algorithm4$d.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), u = (0, _algorithm5$d.createAlgorithm12)({
    typed: r,
    DenseMatrix: o
  }), p = (0, _algorithm6$4.createAlgorithm13)({
    typed: r
  }), m = (0, _algorithm7$4.createAlgorithm14)({
    typed: r
  });
  return r(name$2z, {
    "any, any": s,
    "SparseMatrix, SparseMatrix": function(v, y) {
      return d(v, y, s, !1);
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return c(y, v, s, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      return l(v, y, s, !1);
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return p(v, y, s);
    },
    "Array, Array": function(v, y) {
      return this(n(v), n(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(n(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, n(y));
    },
    "SparseMatrix, any": function(v, y) {
      return h(v, y, s, !1);
    },
    "DenseMatrix, any": function(v, y) {
      return m(v, y, s, !1);
    },
    "any, SparseMatrix": function(v, y) {
      return u(y, v, s, !0);
    },
    "any, DenseMatrix": function(v, y) {
      return m(y, v, s, !0);
    },
    "Array, any": function(v, y) {
      return m(n(v), y, s, !1).valueOf();
    },
    "any, Array": function(v, y) {
      return m(n(y), v, s, !0).valueOf();
    }
  });
});
dotDivide$1.createDotDivide = createDotDivide;
var lsolve$1 = {}, solveValidation = {};
Object.defineProperty(solveValidation, "__esModule", {
  value: !0
});
solveValidation.createSolveValidation = createSolveValidation;
var _is$Y = is, _array$t = array, _string$j = string$2;
function createSolveValidation(t) {
  var r = t.DenseMatrix;
  return function(a, s, o) {
    var c = a.size();
    if (c.length !== 2)
      throw new RangeError("Matrix must be two dimensional (size: " + (0, _string$j.format)(c) + ")");
    var l = c[0], d = c[1];
    if (l !== d)
      throw new RangeError("Matrix must be square (size: " + (0, _string$j.format)(c) + ")");
    var h = [];
    if ((0, _is$Y.isMatrix)(s)) {
      var u = s.size(), p = s._data;
      if (u.length === 1) {
        if (u[0] !== l)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var m = 0; m < l; m++)
          h[m] = [p[m]];
        return new r({
          data: h,
          size: [l, 1],
          datatype: s._datatype
        });
      }
      if (u.length === 2) {
        if (u[0] !== l || u[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if ((0, _is$Y.isDenseMatrix)(s)) {
          if (o) {
            h = [];
            for (var g = 0; g < l; g++)
              h[g] = [p[g][0]];
            return new r({
              data: h,
              size: [l, 1],
              datatype: s._datatype
            });
          }
          return s;
        }
        if ((0, _is$Y.isSparseMatrix)(s)) {
          for (var v = 0; v < l; v++)
            h[v] = [0];
          for (var y = s._values, x = s._index, _ = s._ptr, $ = _[1], b = _[0]; b < $; b++) {
            var M = x[b];
            h[M][0] = y[b];
          }
          return new r({
            data: h,
            size: [l, 1],
            datatype: s._datatype
          });
        }
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if ((0, _is$Y.isArray)(s)) {
      var C = (0, _array$t.arraySize)(s);
      if (C.length === 1) {
        if (C[0] !== l)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var S = 0; S < l; S++)
          h[S] = [s[S]];
        return new r({
          data: h,
          size: [l, 1]
        });
      }
      if (C.length === 2) {
        if (C[0] !== l || C[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var A = 0; A < l; A++)
          h[A] = [s[A][0]];
        return new r({
          data: h,
          size: [l, 1]
        });
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
Object.defineProperty(lsolve$1, "__esModule", {
  value: !0
});
lsolve$1.createLsolve = void 0;
var _factory$2B = factory$1, _solveValidation$4 = solveValidation, name$2y = "lsolve", dependencies$2x = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtract", "equalScalar", "DenseMatrix"], createLsolve = /* @__PURE__ */ (0, _factory$2B.factory)(name$2y, dependencies$2x, function(t) {
  var r = t.typed, n = t.matrix, a = t.divideScalar, s = t.multiplyScalar, o = t.subtract, c = t.equalScalar, l = t.DenseMatrix, d = (0, _solveValidation$4.createSolveValidation)({
    DenseMatrix: l
  });
  return r(name$2y, {
    "SparseMatrix, Array | Matrix": function(m, g) {
      return u(m, g);
    },
    "DenseMatrix, Array | Matrix": function(m, g) {
      return h(m, g);
    },
    "Array, Array | Matrix": function(m, g) {
      var v = n(m), y = h(v, g);
      return y.valueOf();
    }
  });
  function h(p, m) {
    m = d(p, m, !0);
    for (var g = m._data, v = p._size[0], y = p._size[1], x = [], _ = p._data, $ = 0; $ < y; $++) {
      var b = g[$][0] || 0, M = void 0;
      if (c(b, 0))
        M = 0;
      else {
        var C = _[$][$];
        if (c(C, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        M = a(b, C);
        for (var S = $ + 1; S < v; S++)
          g[S] = [o(g[S][0] || 0, s(M, _[S][$]))];
      }
      x[$] = [M];
    }
    return new l({
      data: x,
      size: [v, 1]
    });
  }
  function u(p, m) {
    m = d(p, m, !0);
    for (var g = m._data, v = p._size[0], y = p._size[1], x = p._values, _ = p._index, $ = p._ptr, b = [], M = 0; M < y; M++) {
      var C = g[M][0] || 0;
      if (c(C, 0))
        b[M] = [0];
      else {
        for (var S = 0, A = [], D = [], N = $[M], T = $[M + 1], R = N; R < T; R++) {
          var F = _[R];
          F === M ? S = x[R] : F > M && (A.push(x[R]), D.push(F));
        }
        if (c(S, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var z = a(C, S), O = 0, G = D.length; O < G; O++) {
          var I = D[O];
          g[I] = [o(g[I][0] || 0, s(z, A[O]))];
        }
        b[M] = [z];
      }
    }
    return new l({
      data: b,
      size: [v, 1]
    });
  }
});
lsolve$1.createLsolve = createLsolve;
var usolve$1 = {};
Object.defineProperty(usolve$1, "__esModule", {
  value: !0
});
usolve$1.createUsolve = void 0;
var _factory$2A = factory$1, _solveValidation$3 = solveValidation, name$2x = "usolve", dependencies$2w = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtract", "equalScalar", "DenseMatrix"], createUsolve = /* @__PURE__ */ (0, _factory$2A.factory)(name$2x, dependencies$2w, function(t) {
  var r = t.typed, n = t.matrix, a = t.divideScalar, s = t.multiplyScalar, o = t.subtract, c = t.equalScalar, l = t.DenseMatrix, d = (0, _solveValidation$3.createSolveValidation)({
    DenseMatrix: l
  });
  return r(name$2x, {
    "SparseMatrix, Array | Matrix": function(m, g) {
      return u(m, g);
    },
    "DenseMatrix, Array | Matrix": function(m, g) {
      return h(m, g);
    },
    "Array, Array | Matrix": function(m, g) {
      var v = n(m), y = h(v, g);
      return y.valueOf();
    }
  });
  function h(p, m) {
    m = d(p, m, !0);
    for (var g = m._data, v = p._size[0], y = p._size[1], x = [], _ = p._data, $ = y - 1; $ >= 0; $--) {
      var b = g[$][0] || 0, M = void 0;
      if (c(b, 0))
        M = 0;
      else {
        var C = _[$][$];
        if (c(C, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        M = a(b, C);
        for (var S = $ - 1; S >= 0; S--)
          g[S] = [o(g[S][0] || 0, s(M, _[S][$]))];
      }
      x[$] = [M];
    }
    return new l({
      data: x,
      size: [v, 1]
    });
  }
  function u(p, m) {
    m = d(p, m, !0);
    for (var g = m._data, v = p._size[0], y = p._size[1], x = p._values, _ = p._index, $ = p._ptr, b = [], M = y - 1; M >= 0; M--) {
      var C = g[M][0] || 0;
      if (c(C, 0))
        b[M] = [0];
      else {
        for (var S = 0, A = [], D = [], N = $[M], T = $[M + 1], R = T - 1; R >= N; R--) {
          var F = _[R];
          F === M ? S = x[R] : F < M && (A.push(x[R]), D.push(F));
        }
        if (c(S, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var z = a(C, S), O = 0, G = D.length; O < G; O++) {
          var I = D[O];
          g[I] = [o(g[I][0], s(z, A[O]))];
        }
        b[M] = [z];
      }
    }
    return new l({
      data: b,
      size: [v, 1]
    });
  }
});
usolve$1.createUsolve = createUsolve;
var lsolveAll$1 = {};
Object.defineProperty(lsolveAll$1, "__esModule", {
  value: !0
});
lsolveAll$1.createLsolveAll = void 0;
var _factory$2z = factory$1, _solveValidation$2 = solveValidation;
function _toConsumableArray$5(t) {
  return _arrayWithoutHoles$5(t) || _iterableToArray$5(t) || _unsupportedIterableToArray$4(t) || _nonIterableSpread$5();
}
function _nonIterableSpread$5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$4(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$4(t, r);
  }
}
function _iterableToArray$5(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function _arrayWithoutHoles$5(t) {
  if (Array.isArray(t))
    return _arrayLikeToArray$4(t);
}
function _arrayLikeToArray$4(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
var name$2w = "lsolveAll", dependencies$2v = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtract", "equalScalar", "DenseMatrix"], createLsolveAll = /* @__PURE__ */ (0, _factory$2z.factory)(name$2w, dependencies$2v, function(t) {
  var r = t.typed, n = t.matrix, a = t.divideScalar, s = t.multiplyScalar, o = t.subtract, c = t.equalScalar, l = t.DenseMatrix, d = (0, _solveValidation$2.createSolveValidation)({
    DenseMatrix: l
  });
  return r(name$2w, {
    "SparseMatrix, Array | Matrix": function(m, g) {
      return u(m, g);
    },
    "DenseMatrix, Array | Matrix": function(m, g) {
      return h(m, g);
    },
    "Array, Array | Matrix": function(m, g) {
      var v = n(m), y = h(v, g);
      return y.map(function(x) {
        return x.valueOf();
      });
    }
  });
  function h(p, m) {
    for (var g = [d(p, m, !0)._data.map(function(D) {
      return D[0];
    })], v = p._data, y = p._size[0], x = p._size[1], _ = 0; _ < x; _++)
      for (var $ = g.length, b = 0; b < $; b++) {
        var M = g[b];
        if (c(v[_][_], 0))
          if (c(M[_], 0)) {
            if (b === 0) {
              var S = _toConsumableArray$5(M);
              S[_] = 1;
              for (var A = _ + 1; A < x; A++)
                S[A] = o(S[A], v[A][_]);
              g.push(S);
            }
          } else {
            if (b === 0)
              return [];
            g.splice(b, 1), b -= 1, $ -= 1;
          }
        else {
          M[_] = a(M[_], v[_][_]);
          for (var C = _ + 1; C < x; C++)
            M[C] = o(M[C], s(M[_], v[C][_]));
        }
      }
    return g.map(function(D) {
      return new l({
        data: D.map(function(N) {
          return [N];
        }),
        size: [y, 1]
      });
    });
  }
  function u(p, m) {
    for (var g = [d(p, m, !0)._data.map(function(U) {
      return U[0];
    })], v = p._size[0], y = p._size[1], x = p._values, _ = p._index, $ = p._ptr, b = 0; b < y; b++)
      for (var M = g.length, C = 0; C < M; C++) {
        for (var S = g[C], A = [], D = [], N = $[b], T = $[b + 1], R = 0, F = N; F < T; F++) {
          var z = _[F];
          z === b ? R = x[F] : z > b && (A.push(x[F]), D.push(z));
        }
        if (c(R, 0))
          if (c(S[b], 0)) {
            if (C === 0) {
              var k = _toConsumableArray$5(S);
              k[b] = 1;
              for (var B = 0, L = D.length; B < L; B++) {
                var V = D[B];
                k[V] = o(k[V], A[B]);
              }
              g.push(k);
            }
          } else {
            if (C === 0)
              return [];
            g.splice(C, 1), C -= 1, M -= 1;
          }
        else {
          S[b] = a(S[b], R);
          for (var O = 0, G = D.length; O < G; O++) {
            var I = D[O];
            S[I] = o(S[I], s(S[b], A[O]));
          }
        }
      }
    return g.map(function(U) {
      return new l({
        data: U.map(function(J) {
          return [J];
        }),
        size: [v, 1]
      });
    });
  }
});
lsolveAll$1.createLsolveAll = createLsolveAll;
var usolveAll$1 = {};
Object.defineProperty(usolveAll$1, "__esModule", {
  value: !0
});
usolveAll$1.createUsolveAll = void 0;
var _factory$2y = factory$1, _solveValidation$1 = solveValidation;
function _toConsumableArray$4(t) {
  return _arrayWithoutHoles$4(t) || _iterableToArray$4(t) || _unsupportedIterableToArray$3(t) || _nonIterableSpread$4();
}
function _nonIterableSpread$4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$3(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$3(t, r);
  }
}
function _iterableToArray$4(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function _arrayWithoutHoles$4(t) {
  if (Array.isArray(t))
    return _arrayLikeToArray$3(t);
}
function _arrayLikeToArray$3(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
var name$2v = "usolveAll", dependencies$2u = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtract", "equalScalar", "DenseMatrix"], createUsolveAll = /* @__PURE__ */ (0, _factory$2y.factory)(name$2v, dependencies$2u, function(t) {
  var r = t.typed, n = t.matrix, a = t.divideScalar, s = t.multiplyScalar, o = t.subtract, c = t.equalScalar, l = t.DenseMatrix, d = (0, _solveValidation$1.createSolveValidation)({
    DenseMatrix: l
  });
  return r(name$2v, {
    "SparseMatrix, Array | Matrix": function(m, g) {
      return u(m, g);
    },
    "DenseMatrix, Array | Matrix": function(m, g) {
      return h(m, g);
    },
    "Array, Array | Matrix": function(m, g) {
      var v = n(m), y = h(v, g);
      return y.map(function(x) {
        return x.valueOf();
      });
    }
  });
  function h(p, m) {
    for (var g = [d(p, m, !0)._data.map(function(D) {
      return D[0];
    })], v = p._data, y = p._size[0], x = p._size[1], _ = x - 1; _ >= 0; _--)
      for (var $ = g.length, b = 0; b < $; b++) {
        var M = g[b];
        if (c(v[_][_], 0))
          if (c(M[_], 0)) {
            if (b === 0) {
              var S = _toConsumableArray$4(M);
              S[_] = 1;
              for (var A = _ - 1; A >= 0; A--)
                S[A] = o(S[A], v[A][_]);
              g.push(S);
            }
          } else {
            if (b === 0)
              return [];
            g.splice(b, 1), b -= 1, $ -= 1;
          }
        else {
          M[_] = a(M[_], v[_][_]);
          for (var C = _ - 1; C >= 0; C--)
            M[C] = o(M[C], s(M[_], v[C][_]));
        }
      }
    return g.map(function(D) {
      return new l({
        data: D.map(function(N) {
          return [N];
        }),
        size: [y, 1]
      });
    });
  }
  function u(p, m) {
    for (var g = [d(p, m, !0)._data.map(function(U) {
      return U[0];
    })], v = p._size[0], y = p._size[1], x = p._values, _ = p._index, $ = p._ptr, b = y - 1; b >= 0; b--)
      for (var M = g.length, C = 0; C < M; C++) {
        for (var S = g[C], A = [], D = [], N = $[b], T = $[b + 1], R = 0, F = T - 1; F >= N; F--) {
          var z = _[F];
          z === b ? R = x[F] : z < b && (A.push(x[F]), D.push(z));
        }
        if (c(R, 0))
          if (c(S[b], 0)) {
            if (C === 0) {
              var k = _toConsumableArray$4(S);
              k[b] = 1;
              for (var B = 0, L = D.length; B < L; B++) {
                var V = D[B];
                k[V] = o(k[V], A[B]);
              }
              g.push(k);
            }
          } else {
            if (C === 0)
              return [];
            g.splice(C, 1), C -= 1, M -= 1;
          }
        else {
          S[b] = a(S[b], R);
          for (var O = 0, G = D.length; O < G; O++) {
            var I = D[O];
            S[I] = o(S[I], s(S[b], A[O]));
          }
        }
      }
    return g.map(function(U) {
      return new l({
        data: U.map(function(J) {
          return [J];
        }),
        size: [v, 1]
      });
    });
  }
});
usolveAll$1.createUsolveAll = createUsolveAll;
var leftShift$1 = {}, algorithm08 = {};
Object.defineProperty(algorithm08, "__esModule", {
  value: !0
});
algorithm08.createAlgorithm08 = void 0;
var _factory$2x = factory$1, _DimensionError$1 = DimensionError$1, name$2u = "algorithm08", dependencies$2t = ["typed", "equalScalar"], createAlgorithm08 = /* @__PURE__ */ (0, _factory$2x.factory)(name$2u, dependencies$2t, function(t) {
  var r = t.typed, n = t.equalScalar;
  return function(s, o, c) {
    var l = s._values, d = s._index, h = s._ptr, u = s._size, p = s._datatype, m = o._values, g = o._index, v = o._ptr, y = o._size, x = o._datatype;
    if (u.length !== y.length)
      throw new _DimensionError$1.DimensionError(u.length, y.length);
    if (u[0] !== y[0] || u[1] !== y[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + y + ")");
    if (!l || !m)
      throw new Error("Cannot perform operation on Pattern Sparse Matrices");
    var _ = u[0], $ = u[1], b, M = n, C = 0, S = c;
    typeof p == "string" && p === x && (b = p, M = r.find(n, [b, b]), C = r.convert(0, b), S = r.find(c, [b, b]));
    for (var A = [], D = [], N = [], T = [], R = [], F, z, O, G, I = 0; I < $; I++) {
      N[I] = D.length;
      var k = I + 1;
      for (z = h[I], O = h[I + 1], F = z; F < O; F++)
        G = d[F], R[G] = k, T[G] = l[F], D.push(G);
      for (z = v[I], O = v[I + 1], F = z; F < O; F++)
        G = g[F], R[G] === k && (T[G] = S(T[G], m[F]));
      for (F = N[I]; F < D.length; ) {
        G = D[F];
        var B = T[G];
        M(B, C) ? D.splice(F, 1) : (A.push(B), F++);
      }
    }
    return N[$] = D.length, s.createSparseMatrix({
      values: A,
      index: D,
      ptr: N,
      size: [_, $],
      datatype: b
    });
  };
});
algorithm08.createAlgorithm08 = createAlgorithm08;
Object.defineProperty(leftShift$1, "__esModule", {
  value: !0
});
leftShift$1.createLeftShift = void 0;
var _algorithm$e = algorithm02, _algorithm2$e = algorithm11, _algorithm3$c = algorithm13, _algorithm4$c = algorithm14, _algorithm5$c = algorithm01, _algorithm6$3 = algorithm10, _algorithm7$3 = algorithm08, _factory$2w = factory$1, _index$m = number$2, _bitwise$1 = bitwise$1, name$2t = "leftShift", dependencies$2s = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix"], createLeftShift = /* @__PURE__ */ (0, _factory$2w.factory)(name$2t, dependencies$2s, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.zeros, o = t.DenseMatrix, c = (0, _algorithm5$c.createAlgorithm01)({
    typed: r
  }), l = (0, _algorithm$e.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm7$3.createAlgorithm08)({
    typed: r,
    equalScalar: a
  }), h = (0, _algorithm6$3.createAlgorithm10)({
    typed: r,
    DenseMatrix: o
  }), u = (0, _algorithm2$e.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), p = (0, _algorithm3$c.createAlgorithm13)({
    typed: r
  }), m = (0, _algorithm4$c.createAlgorithm14)({
    typed: r
  });
  return r(name$2t, {
    "number, number": _index$m.leftShiftNumber,
    "BigNumber, BigNumber": _bitwise$1.leftShiftBigNumber,
    "SparseMatrix, SparseMatrix": function(v, y) {
      return d(v, y, this, !1);
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return l(y, v, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      return c(v, y, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return p(v, y, this);
    },
    "Array, Array": function(v, y) {
      return this(n(v), n(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(n(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, n(y));
    },
    "SparseMatrix, number | BigNumber": function(v, y) {
      return a(y, 0) ? v.clone() : u(v, y, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(v, y) {
      return a(y, 0) ? v.clone() : m(v, y, this, !1);
    },
    "number | BigNumber, SparseMatrix": function(v, y) {
      return a(v, 0) ? s(y.size(), y.storage()) : h(y, v, this, !0);
    },
    "number | BigNumber, DenseMatrix": function(v, y) {
      return a(v, 0) ? s(y.size(), y.storage()) : m(y, v, this, !0);
    },
    "Array, number | BigNumber": function(v, y) {
      return this(n(v), y).valueOf();
    },
    "number | BigNumber, Array": function(v, y) {
      return this(v, n(y)).valueOf();
    }
  });
});
leftShift$1.createLeftShift = createLeftShift;
var rightArithShift$1 = {};
Object.defineProperty(rightArithShift$1, "__esModule", {
  value: !0
});
rightArithShift$1.createRightArithShift = void 0;
var _bitwise = bitwise$1, _algorithm$d = algorithm02, _algorithm2$d = algorithm11, _algorithm3$b = algorithm13, _algorithm4$b = algorithm14, _algorithm5$b = algorithm01, _algorithm6$2 = algorithm10, _algorithm7$2 = algorithm08, _factory$2v = factory$1, _index$l = number$2, name$2s = "rightArithShift", dependencies$2r = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix"], createRightArithShift = /* @__PURE__ */ (0, _factory$2v.factory)(name$2s, dependencies$2r, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.zeros, o = t.DenseMatrix, c = (0, _algorithm5$b.createAlgorithm01)({
    typed: r
  }), l = (0, _algorithm$d.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm7$2.createAlgorithm08)({
    typed: r,
    equalScalar: a
  }), h = (0, _algorithm6$2.createAlgorithm10)({
    typed: r,
    DenseMatrix: o
  }), u = (0, _algorithm2$d.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), p = (0, _algorithm3$b.createAlgorithm13)({
    typed: r
  }), m = (0, _algorithm4$b.createAlgorithm14)({
    typed: r
  });
  return r(name$2s, {
    "number, number": _index$l.rightArithShiftNumber,
    "BigNumber, BigNumber": _bitwise.rightArithShiftBigNumber,
    "SparseMatrix, SparseMatrix": function(v, y) {
      return d(v, y, this, !1);
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return l(y, v, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      return c(v, y, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return p(v, y, this);
    },
    "Array, Array": function(v, y) {
      return this(n(v), n(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(n(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, n(y));
    },
    "SparseMatrix, number | BigNumber": function(v, y) {
      return a(y, 0) ? v.clone() : u(v, y, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(v, y) {
      return a(y, 0) ? v.clone() : m(v, y, this, !1);
    },
    "number | BigNumber, SparseMatrix": function(v, y) {
      return a(v, 0) ? s(y.size(), y.storage()) : h(y, v, this, !0);
    },
    "number | BigNumber, DenseMatrix": function(v, y) {
      return a(v, 0) ? s(y.size(), y.storage()) : m(y, v, this, !0);
    },
    "Array, number | BigNumber": function(v, y) {
      return this(n(v), y).valueOf();
    },
    "number | BigNumber, Array": function(v, y) {
      return this(v, n(y)).valueOf();
    }
  });
});
rightArithShift$1.createRightArithShift = createRightArithShift;
var rightLogShift$1 = {};
Object.defineProperty(rightLogShift$1, "__esModule", {
  value: !0
});
rightLogShift$1.createRightLogShift = void 0;
var _algorithm$c = algorithm02, _algorithm2$c = algorithm11, _algorithm3$a = algorithm13, _algorithm4$a = algorithm14, _algorithm5$a = algorithm01, _algorithm6$1 = algorithm10, _algorithm7$1 = algorithm08, _factory$2u = factory$1, _index$k = number$2, name$2r = "rightLogShift", dependencies$2q = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix"], createRightLogShift = /* @__PURE__ */ (0, _factory$2u.factory)(name$2r, dependencies$2q, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.zeros, o = t.DenseMatrix, c = (0, _algorithm5$a.createAlgorithm01)({
    typed: r
  }), l = (0, _algorithm$c.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm7$1.createAlgorithm08)({
    typed: r,
    equalScalar: a
  }), h = (0, _algorithm6$1.createAlgorithm10)({
    typed: r,
    DenseMatrix: o
  }), u = (0, _algorithm2$c.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), p = (0, _algorithm3$a.createAlgorithm13)({
    typed: r
  }), m = (0, _algorithm4$a.createAlgorithm14)({
    typed: r
  });
  return r(name$2r, {
    "number, number": _index$k.rightLogShiftNumber,
    // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
    "SparseMatrix, SparseMatrix": function(v, y) {
      return d(v, y, this, !1);
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return l(y, v, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      return c(v, y, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return p(v, y, this);
    },
    "Array, Array": function(v, y) {
      return this(n(v), n(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(n(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, n(y));
    },
    "SparseMatrix, number | BigNumber": function(v, y) {
      return a(y, 0) ? v.clone() : u(v, y, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(v, y) {
      return a(y, 0) ? v.clone() : m(v, y, this, !1);
    },
    "number | BigNumber, SparseMatrix": function(v, y) {
      return a(v, 0) ? s(y.size(), y.storage()) : h(y, v, this, !0);
    },
    "number | BigNumber, DenseMatrix": function(v, y) {
      return a(v, 0) ? s(y.size(), y.storage()) : m(y, v, this, !0);
    },
    "Array, number | BigNumber": function(v, y) {
      return this(n(v), y).valueOf();
    },
    "number | BigNumber, Array": function(v, y) {
      return this(v, n(y)).valueOf();
    }
  });
});
rightLogShift$1.createRightLogShift = createRightLogShift;
var and$1 = {};
Object.defineProperty(and$1, "__esModule", {
  value: !0
});
and$1.createAnd = void 0;
var _algorithm$b = algorithm02, _algorithm2$b = algorithm11, _algorithm3$9 = algorithm13, _algorithm4$9 = algorithm14, _algorithm5$9 = algorithm06, _factory$2t = factory$1, _index$j = number$2, name$2q = "and", dependencies$2p = ["typed", "matrix", "equalScalar", "zeros", "not"], createAnd = /* @__PURE__ */ (0, _factory$2t.factory)(name$2q, dependencies$2p, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.zeros, o = t.not, c = (0, _algorithm$b.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm5$9.createAlgorithm06)({
    typed: r,
    equalScalar: a
  }), d = (0, _algorithm2$b.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), h = (0, _algorithm3$9.createAlgorithm13)({
    typed: r
  }), u = (0, _algorithm4$9.createAlgorithm14)({
    typed: r
  });
  return r(name$2q, {
    "number, number": _index$j.andNumber,
    "Complex, Complex": function(m, g) {
      return (m.re !== 0 || m.im !== 0) && (g.re !== 0 || g.im !== 0);
    },
    "BigNumber, BigNumber": function(m, g) {
      return !m.isZero() && !g.isZero() && !m.isNaN() && !g.isNaN();
    },
    "Unit, Unit": function(m, g) {
      return this(m.value || 0, g.value || 0);
    },
    "SparseMatrix, SparseMatrix": function(m, g) {
      return l(m, g, this, !1);
    },
    "SparseMatrix, DenseMatrix": function(m, g) {
      return c(g, m, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(m, g) {
      return c(m, g, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(m, g) {
      return h(m, g, this);
    },
    "Array, Array": function(m, g) {
      return this(n(m), n(g)).valueOf();
    },
    "Array, Matrix": function(m, g) {
      return this(n(m), g);
    },
    "Matrix, Array": function(m, g) {
      return this(m, n(g));
    },
    "SparseMatrix, any": function(m, g) {
      return o(g) ? s(m.size(), m.storage()) : d(m, g, this, !1);
    },
    "DenseMatrix, any": function(m, g) {
      return o(g) ? s(m.size(), m.storage()) : u(m, g, this, !1);
    },
    "any, SparseMatrix": function(m, g) {
      return o(m) ? s(m.size(), m.storage()) : d(g, m, this, !0);
    },
    "any, DenseMatrix": function(m, g) {
      return o(m) ? s(m.size(), m.storage()) : u(g, m, this, !0);
    },
    "Array, any": function(m, g) {
      return this(n(m), g).valueOf();
    },
    "any, Array": function(m, g) {
      return this(m, n(g)).valueOf();
    }
  });
});
and$1.createAnd = createAnd;
var compare$1 = {};
Object.defineProperty(compare$1, "__esModule", {
  value: !0
});
compare$1.createCompareNumber = compare$1.createCompare = void 0;
var _nearlyEqual$4 = nearlyEqual$1, _number$e = number$3, _factory$2s = factory$1, _algorithm$a = algorithm03, _algorithm2$a = algorithm12, _algorithm3$8 = algorithm14, _algorithm4$8 = algorithm13, _algorithm5$8 = algorithm05, name$2p = "compare", dependencies$2o = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix"], createCompare = /* @__PURE__ */ (0, _factory$2s.factory)(name$2p, dependencies$2o, function(t) {
  var r = t.typed, n = t.config, a = t.equalScalar, s = t.matrix, o = t.BigNumber, c = t.Fraction, l = t.DenseMatrix, d = (0, _algorithm$a.createAlgorithm03)({
    typed: r
  }), h = (0, _algorithm5$8.createAlgorithm05)({
    typed: r,
    equalScalar: a
  }), u = (0, _algorithm2$a.createAlgorithm12)({
    typed: r,
    DenseMatrix: l
  }), p = (0, _algorithm4$8.createAlgorithm13)({
    typed: r
  }), m = (0, _algorithm3$8.createAlgorithm14)({
    typed: r
  });
  return r(name$2p, {
    "boolean, boolean": function(v, y) {
      return v === y ? 0 : v > y ? 1 : -1;
    },
    "number, number": function(v, y) {
      return (0, _number$e.nearlyEqual)(v, y, n.epsilon) ? 0 : v > y ? 1 : -1;
    },
    "BigNumber, BigNumber": function(v, y) {
      return (0, _nearlyEqual$4.nearlyEqual)(v, y, n.epsilon) ? new o(0) : new o(v.cmp(y));
    },
    "Fraction, Fraction": function(v, y) {
      return new c(v.compare(y));
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(v, y) {
      if (!v.equalBase(y))
        throw new Error("Cannot compare units with different base");
      return this(v.value, y.value);
    },
    "SparseMatrix, SparseMatrix": function(v, y) {
      return h(v, y, this);
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return d(y, v, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      return d(v, y, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return p(v, y, this);
    },
    "Array, Array": function(v, y) {
      return this(s(v), s(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(s(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, s(y));
    },
    "SparseMatrix, any": function(v, y) {
      return u(v, y, this, !1);
    },
    "DenseMatrix, any": function(v, y) {
      return m(v, y, this, !1);
    },
    "any, SparseMatrix": function(v, y) {
      return u(y, v, this, !0);
    },
    "any, DenseMatrix": function(v, y) {
      return m(y, v, this, !0);
    },
    "Array, any": function(v, y) {
      return m(s(v), y, this, !1).valueOf();
    },
    "any, Array": function(v, y) {
      return m(s(y), v, this, !0).valueOf();
    }
  });
});
compare$1.createCompare = createCompare;
var createCompareNumber = /* @__PURE__ */ (0, _factory$2s.factory)(name$2p, ["typed", "config"], function(t) {
  var r = t.typed, n = t.config;
  return r(name$2p, {
    "number, number": function(s, o) {
      return (0, _number$e.nearlyEqual)(s, o, n.epsilon) ? 0 : s > o ? 1 : -1;
    }
  });
});
compare$1.createCompareNumber = createCompareNumber;
var compareNatural$1 = {}, naturalSort = function t(r, n) {
  var a = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, s = /(^[ ]*|[ ]*$)/g, o = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, c = /^0x[0-9a-f]+$/i, l = /^0/, d = function(b) {
    return t.insensitive && ("" + b).toLowerCase() || "" + b;
  }, h = d(r).replace(s, "") || "", u = d(n).replace(s, "") || "", p = h.replace(a, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), m = u.replace(a, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), g = parseInt(h.match(c), 16) || p.length !== 1 && h.match(o) && Date.parse(h), v = parseInt(u.match(c), 16) || g && u.match(o) && Date.parse(u) || null, y, x;
  if (v) {
    if (g < v)
      return -1;
    if (g > v)
      return 1;
  }
  for (var _ = 0, $ = Math.max(p.length, m.length); _ < $; _++) {
    if (y = !(p[_] || "").match(l) && parseFloat(p[_]) || p[_] || 0, x = !(m[_] || "").match(l) && parseFloat(m[_]) || m[_] || 0, isNaN(y) !== isNaN(x))
      return isNaN(y) ? 1 : -1;
    if (typeof y != typeof x && (y += "", x += ""), y < x)
      return -1;
    if (y > x)
      return 1;
  }
  return 0;
};
Object.defineProperty(compareNatural$1, "__esModule", {
  value: !0
});
compareNatural$1.createCompareNatural = void 0;
var _javascriptNaturalSort = _interopRequireDefault$3(naturalSort), _is$X = is, _factory$2r = factory$1;
function _interopRequireDefault$3(t) {
  return t && t.__esModule ? t : { default: t };
}
var name$2o = "compareNatural", dependencies$2n = ["typed", "compare"], createCompareNatural = /* @__PURE__ */ (0, _factory$2r.factory)(name$2o, dependencies$2n, function(t) {
  var r = t.typed, n = t.compare, a = n.signatures["boolean,boolean"];
  return r(name$2o, {
    "any, any": function(d, h) {
      var u = (0, _is$X.typeOf)(d), p = (0, _is$X.typeOf)(h), m;
      if ((u === "number" || u === "BigNumber" || u === "Fraction") && (p === "number" || p === "BigNumber" || p === "Fraction"))
        return m = n(d, h), m.toString() !== "0" ? m > 0 ? 1 : -1 : (0, _javascriptNaturalSort.default)(u, p);
      if (u === "Array" || u === "Matrix" || p === "Array" || p === "Matrix")
        return m = s(this, d, h), m !== 0 ? m : (0, _javascriptNaturalSort.default)(u, p);
      if (u !== p)
        return (0, _javascriptNaturalSort.default)(u, p);
      if (u === "Complex")
        return compareComplexNumbers(d, h);
      if (u === "Unit")
        return d.equalBase(h) ? this(d.value, h.value) : o(this, d.formatUnits(), h.formatUnits());
      if (u === "boolean")
        return a(d, h);
      if (u === "string")
        return (0, _javascriptNaturalSort.default)(d, h);
      if (u === "Object")
        return c(this, d, h);
      if (u === "null" || u === "undefined")
        return 0;
      throw new TypeError('Unsupported type of value "' + u + '"');
    }
  });
  function s(l, d, h) {
    return (0, _is$X.isSparseMatrix)(d) && (0, _is$X.isSparseMatrix)(h) ? o(l, d.toJSON().values, h.toJSON().values) : (0, _is$X.isSparseMatrix)(d) ? s(l, d.toArray(), h) : (0, _is$X.isSparseMatrix)(h) ? s(l, d, h.toArray()) : (0, _is$X.isDenseMatrix)(d) ? s(l, d.toJSON().data, h) : (0, _is$X.isDenseMatrix)(h) ? s(l, d, h.toJSON().data) : Array.isArray(d) ? Array.isArray(h) ? o(l, d, h) : s(l, d, [h]) : s(l, [d], h);
  }
  function o(l, d, h) {
    for (var u = 0, p = Math.min(d.length, h.length); u < p; u++) {
      var m = l(d[u], h[u]);
      if (m !== 0)
        return m;
    }
    return d.length > h.length ? 1 : d.length < h.length ? -1 : 0;
  }
  function c(l, d, h) {
    var u = Object.keys(d), p = Object.keys(h);
    u.sort(_javascriptNaturalSort.default), p.sort(_javascriptNaturalSort.default);
    var m = o(l, u, p);
    if (m !== 0)
      return m;
    for (var g = 0; g < u.length; g++) {
      var v = l(d[u[g]], h[p[g]]);
      if (v !== 0)
        return v;
    }
    return 0;
  }
});
compareNatural$1.createCompareNatural = createCompareNatural;
function compareComplexNumbers(t, r) {
  return t.re > r.re ? 1 : t.re < r.re ? -1 : t.im > r.im ? 1 : t.im < r.im ? -1 : 0;
}
var compareText$1 = {};
Object.defineProperty(compareText$1, "__esModule", {
  value: !0
});
compareText$1.createCompareTextNumber = compareText$1.createCompareText = void 0;
var _string$i = string$2, _factory$2q = factory$1, _algorithm$9 = algorithm14, _algorithm2$9 = algorithm13, name$2n = "compareText", dependencies$2m = ["typed", "matrix"], createCompareText = /* @__PURE__ */ (0, _factory$2q.factory)(name$2n, dependencies$2m, function(t) {
  var r = t.typed, n = t.matrix, a = (0, _algorithm2$9.createAlgorithm13)({
    typed: r
  }), s = (0, _algorithm$9.createAlgorithm14)({
    typed: r
  });
  return r(name$2n, {
    "any, any": _string$i.compareText,
    "DenseMatrix, DenseMatrix": function(c, l) {
      return a(c, l, _string$i.compareText);
    },
    "Array, Array": function(c, l) {
      return this(n(c), n(l)).valueOf();
    },
    "Array, Matrix": function(c, l) {
      return this(n(c), l);
    },
    "Matrix, Array": function(c, l) {
      return this(c, n(l));
    },
    "DenseMatrix, any": function(c, l) {
      return s(c, l, _string$i.compareText, !1);
    },
    "any, DenseMatrix": function(c, l) {
      return s(l, c, _string$i.compareText, !0);
    },
    "Array, any": function(c, l) {
      return s(n(c), l, _string$i.compareText, !1).valueOf();
    },
    "any, Array": function(c, l) {
      return s(n(l), c, _string$i.compareText, !0).valueOf();
    }
  });
});
compareText$1.createCompareText = createCompareText;
var createCompareTextNumber = /* @__PURE__ */ (0, _factory$2q.factory)(name$2n, ["typed"], function(t) {
  var r = t.typed;
  return r(name$2n, {
    "any, any": _string$i.compareText
  });
});
compareText$1.createCompareTextNumber = createCompareTextNumber;
var equal$1 = {};
Object.defineProperty(equal$1, "__esModule", {
  value: !0
});
equal$1.createEqualNumber = equal$1.createEqual = void 0;
var _factory$2p = factory$1, _algorithm$8 = algorithm03, _algorithm2$8 = algorithm07, _algorithm3$7 = algorithm12, _algorithm4$7 = algorithm13, _algorithm5$7 = algorithm14, name$2m = "equal", dependencies$2l = ["typed", "matrix", "equalScalar", "DenseMatrix"], createEqual = /* @__PURE__ */ (0, _factory$2p.factory)(name$2m, dependencies$2l, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.DenseMatrix, o = (0, _algorithm$8.createAlgorithm03)({
    typed: r
  }), c = (0, _algorithm2$8.createAlgorithm07)({
    typed: r,
    DenseMatrix: s
  }), l = (0, _algorithm3$7.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm4$7.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm5$7.createAlgorithm14)({
    typed: r
  });
  return r(name$2m, {
    "any, any": function(p, m) {
      return p === null ? m === null : m === null ? p === null : p === void 0 ? m === void 0 : m === void 0 ? p === void 0 : a(p, m);
    },
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, a);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, a, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, a, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, a);
    },
    "Array, Array": function(p, m) {
      return this(n(p), n(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(n(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, n(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, a, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, a, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, a, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, a, !0);
    },
    "Array, any": function(p, m) {
      return h(n(p), m, a, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(n(m), p, a, !0).valueOf();
    }
  });
});
equal$1.createEqual = createEqual;
var createEqualNumber = (0, _factory$2p.factory)(name$2m, ["typed", "equalScalar"], function(t) {
  var r = t.typed, n = t.equalScalar;
  return r(name$2m, {
    "any, any": function(s, o) {
      return s === null ? o === null : o === null ? s === null : s === void 0 ? o === void 0 : o === void 0 ? s === void 0 : n(s, o);
    }
  });
});
equal$1.createEqualNumber = createEqualNumber;
var equalText$1 = {};
Object.defineProperty(equalText$1, "__esModule", {
  value: !0
});
equalText$1.createEqualText = void 0;
var _factory$2o = factory$1, name$2l = "equalText", dependencies$2k = ["typed", "compareText", "isZero"], createEqualText = /* @__PURE__ */ (0, _factory$2o.factory)(name$2l, dependencies$2k, function(t) {
  var r = t.typed, n = t.compareText, a = t.isZero;
  return r(name$2l, {
    "any, any": function(o, c) {
      return a(n(o, c));
    }
  });
});
equalText$1.createEqualText = createEqualText;
var smaller$1 = {};
Object.defineProperty(smaller$1, "__esModule", {
  value: !0
});
smaller$1.createSmallerNumber = smaller$1.createSmaller = void 0;
var _nearlyEqual$3 = nearlyEqual$1, _number$d = number$3, _factory$2n = factory$1, _algorithm$7 = algorithm03, _algorithm2$7 = algorithm07, _algorithm3$6 = algorithm12, _algorithm4$6 = algorithm14, _algorithm5$6 = algorithm13, name$2k = "smaller", dependencies$2j = ["typed", "config", "matrix", "DenseMatrix"], createSmaller = /* @__PURE__ */ (0, _factory$2n.factory)(name$2k, dependencies$2j, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.DenseMatrix, o = (0, _algorithm$7.createAlgorithm03)({
    typed: r
  }), c = (0, _algorithm2$7.createAlgorithm07)({
    typed: r,
    DenseMatrix: s
  }), l = (0, _algorithm3$6.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm5$6.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm4$6.createAlgorithm14)({
    typed: r
  });
  return r(name$2k, {
    "boolean, boolean": function(p, m) {
      return p < m;
    },
    "number, number": function(p, m) {
      return p < m && !(0, _number$d.nearlyEqual)(p, m, n.epsilon);
    },
    "BigNumber, BigNumber": function(p, m) {
      return p.lt(m) && !(0, _nearlyEqual$3.nearlyEqual)(p, m, n.epsilon);
    },
    "Fraction, Fraction": function(p, m) {
      return p.compare(m) === -1;
    },
    "Complex, Complex": function(p, m) {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(p, m) {
      if (!p.equalBase(m))
        throw new Error("Cannot compare units with different base");
      return this(p.value, m.value);
    },
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, this);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, this);
    },
    "Array, Array": function(p, m) {
      return this(a(p), a(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(a(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, a(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, this, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, this, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, this, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, this, !0);
    },
    "Array, any": function(p, m) {
      return h(a(p), m, this, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(a(m), p, this, !0).valueOf();
    }
  });
});
smaller$1.createSmaller = createSmaller;
var createSmallerNumber = /* @__PURE__ */ (0, _factory$2n.factory)(name$2k, ["typed", "config"], function(t) {
  var r = t.typed, n = t.config;
  return r(name$2k, {
    "number, number": function(s, o) {
      return s < o && !(0, _number$d.nearlyEqual)(s, o, n.epsilon);
    }
  });
});
smaller$1.createSmallerNumber = createSmallerNumber;
var smallerEq$1 = {};
Object.defineProperty(smallerEq$1, "__esModule", {
  value: !0
});
smallerEq$1.createSmallerEqNumber = smallerEq$1.createSmallerEq = void 0;
var _nearlyEqual$2 = nearlyEqual$1, _number$c = number$3, _factory$2m = factory$1, _algorithm$6 = algorithm03, _algorithm2$6 = algorithm07, _algorithm3$5 = algorithm12, _algorithm4$5 = algorithm14, _algorithm5$5 = algorithm13, name$2j = "smallerEq", dependencies$2i = ["typed", "config", "matrix", "DenseMatrix"], createSmallerEq = /* @__PURE__ */ (0, _factory$2m.factory)(name$2j, dependencies$2i, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.DenseMatrix, o = (0, _algorithm$6.createAlgorithm03)({
    typed: r
  }), c = (0, _algorithm2$6.createAlgorithm07)({
    typed: r,
    DenseMatrix: s
  }), l = (0, _algorithm3$5.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm5$5.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm4$5.createAlgorithm14)({
    typed: r
  });
  return r(name$2j, {
    "boolean, boolean": function(p, m) {
      return p <= m;
    },
    "number, number": function(p, m) {
      return p <= m || (0, _number$c.nearlyEqual)(p, m, n.epsilon);
    },
    "BigNumber, BigNumber": function(p, m) {
      return p.lte(m) || (0, _nearlyEqual$2.nearlyEqual)(p, m, n.epsilon);
    },
    "Fraction, Fraction": function(p, m) {
      return p.compare(m) !== 1;
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(p, m) {
      if (!p.equalBase(m))
        throw new Error("Cannot compare units with different base");
      return this(p.value, m.value);
    },
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, this);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, this);
    },
    "Array, Array": function(p, m) {
      return this(a(p), a(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(a(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, a(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, this, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, this, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, this, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, this, !0);
    },
    "Array, any": function(p, m) {
      return h(a(p), m, this, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(a(m), p, this, !0).valueOf();
    }
  });
});
smallerEq$1.createSmallerEq = createSmallerEq;
var createSmallerEqNumber = /* @__PURE__ */ (0, _factory$2m.factory)(name$2j, ["typed", "config"], function(t) {
  var r = t.typed, n = t.config;
  return r(name$2j, {
    "number, number": function(s, o) {
      return s <= o || (0, _number$c.nearlyEqual)(s, o, n.epsilon);
    }
  });
});
smallerEq$1.createSmallerEqNumber = createSmallerEqNumber;
var larger$1 = {};
Object.defineProperty(larger$1, "__esModule", {
  value: !0
});
larger$1.createLargerNumber = larger$1.createLarger = void 0;
var _nearlyEqual$1 = nearlyEqual$1, _number$b = number$3, _factory$2l = factory$1, _algorithm$5 = algorithm03, _algorithm2$5 = algorithm07, _algorithm3$4 = algorithm12, _algorithm4$4 = algorithm14, _algorithm5$4 = algorithm13, name$2i = "larger", dependencies$2h = ["typed", "config", "matrix", "DenseMatrix"], createLarger = /* @__PURE__ */ (0, _factory$2l.factory)(name$2i, dependencies$2h, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.DenseMatrix, o = (0, _algorithm$5.createAlgorithm03)({
    typed: r
  }), c = (0, _algorithm2$5.createAlgorithm07)({
    typed: r,
    DenseMatrix: s
  }), l = (0, _algorithm3$4.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm5$4.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm4$4.createAlgorithm14)({
    typed: r
  });
  return r(name$2i, {
    "boolean, boolean": function(p, m) {
      return p > m;
    },
    "number, number": function(p, m) {
      return p > m && !(0, _number$b.nearlyEqual)(p, m, n.epsilon);
    },
    "BigNumber, BigNumber": function(p, m) {
      return p.gt(m) && !(0, _nearlyEqual$1.nearlyEqual)(p, m, n.epsilon);
    },
    "Fraction, Fraction": function(p, m) {
      return p.compare(m) === 1;
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(p, m) {
      if (!p.equalBase(m))
        throw new Error("Cannot compare units with different base");
      return this(p.value, m.value);
    },
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, this);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, this);
    },
    "Array, Array": function(p, m) {
      return this(a(p), a(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(a(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, a(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, this, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, this, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, this, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, this, !0);
    },
    "Array, any": function(p, m) {
      return h(a(p), m, this, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(a(m), p, this, !0).valueOf();
    }
  });
});
larger$1.createLarger = createLarger;
var createLargerNumber = /* @__PURE__ */ (0, _factory$2l.factory)(name$2i, ["typed", "config"], function(t) {
  var r = t.typed, n = t.config;
  return r(name$2i, {
    "number, number": function(s, o) {
      return s > o && !(0, _number$b.nearlyEqual)(s, o, n.epsilon);
    }
  });
});
larger$1.createLargerNumber = createLargerNumber;
var largerEq$1 = {};
Object.defineProperty(largerEq$1, "__esModule", {
  value: !0
});
largerEq$1.createLargerEqNumber = largerEq$1.createLargerEq = void 0;
var _nearlyEqual = nearlyEqual$1, _number$a = number$3, _factory$2k = factory$1, _algorithm$4 = algorithm03, _algorithm2$4 = algorithm07, _algorithm3$3 = algorithm12, _algorithm4$3 = algorithm14, _algorithm5$3 = algorithm13, name$2h = "largerEq", dependencies$2g = ["typed", "config", "matrix", "DenseMatrix"], createLargerEq = /* @__PURE__ */ (0, _factory$2k.factory)(name$2h, dependencies$2g, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.DenseMatrix, o = (0, _algorithm$4.createAlgorithm03)({
    typed: r
  }), c = (0, _algorithm2$4.createAlgorithm07)({
    typed: r,
    DenseMatrix: s
  }), l = (0, _algorithm3$3.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm5$3.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm4$3.createAlgorithm14)({
    typed: r
  });
  return r(name$2h, {
    "boolean, boolean": function(p, m) {
      return p >= m;
    },
    "number, number": function(p, m) {
      return p >= m || (0, _number$a.nearlyEqual)(p, m, n.epsilon);
    },
    "BigNumber, BigNumber": function(p, m) {
      return p.gte(m) || (0, _nearlyEqual.nearlyEqual)(p, m, n.epsilon);
    },
    "Fraction, Fraction": function(p, m) {
      return p.compare(m) !== -1;
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(p, m) {
      if (!p.equalBase(m))
        throw new Error("Cannot compare units with different base");
      return this(p.value, m.value);
    },
    "SparseMatrix, SparseMatrix": function(p, m) {
      return c(p, m, this);
    },
    "SparseMatrix, DenseMatrix": function(p, m) {
      return o(m, p, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(p, m) {
      return o(p, m, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(p, m) {
      return d(p, m, this);
    },
    "Array, Array": function(p, m) {
      return this(a(p), a(m)).valueOf();
    },
    "Array, Matrix": function(p, m) {
      return this(a(p), m);
    },
    "Matrix, Array": function(p, m) {
      return this(p, a(m));
    },
    "SparseMatrix, any": function(p, m) {
      return l(p, m, this, !1);
    },
    "DenseMatrix, any": function(p, m) {
      return h(p, m, this, !1);
    },
    "any, SparseMatrix": function(p, m) {
      return l(m, p, this, !0);
    },
    "any, DenseMatrix": function(p, m) {
      return h(m, p, this, !0);
    },
    "Array, any": function(p, m) {
      return h(a(p), m, this, !1).valueOf();
    },
    "any, Array": function(p, m) {
      return h(a(m), p, this, !0).valueOf();
    }
  });
});
largerEq$1.createLargerEq = createLargerEq;
var createLargerEqNumber = /* @__PURE__ */ (0, _factory$2k.factory)(name$2h, ["typed", "config"], function(t) {
  var r = t.typed, n = t.config;
  return r(name$2h, {
    "number, number": function(s, o) {
      return s >= o || (0, _number$a.nearlyEqual)(s, o, n.epsilon);
    }
  });
});
largerEq$1.createLargerEqNumber = createLargerEqNumber;
var deepEqual$1 = {};
Object.defineProperty(deepEqual$1, "__esModule", {
  value: !0
});
deepEqual$1.createDeepEqual = void 0;
var _factory$2j = factory$1, name$2g = "deepEqual", dependencies$2f = ["typed", "equal"], createDeepEqual = /* @__PURE__ */ (0, _factory$2j.factory)(name$2g, dependencies$2f, function(t) {
  var r = t.typed, n = t.equal;
  return r(name$2g, {
    "any, any": function(o, c) {
      return a(o.valueOf(), c.valueOf());
    }
  });
  function a(s, o) {
    if (Array.isArray(s))
      if (Array.isArray(o)) {
        var c = s.length;
        if (c !== o.length)
          return !1;
        for (var l = 0; l < c; l++)
          if (!a(s[l], o[l]))
            return !1;
        return !0;
      } else
        return !1;
    else
      return Array.isArray(o) ? !1 : n(s, o);
  }
});
deepEqual$1.createDeepEqual = createDeepEqual;
var unequal$1 = {};
Object.defineProperty(unequal$1, "__esModule", {
  value: !0
});
unequal$1.createUnequalNumber = unequal$1.createUnequal = void 0;
var _factory$2i = factory$1, _algorithm$3 = algorithm03, _algorithm2$3 = algorithm07, _algorithm3$2 = algorithm12, _algorithm4$2 = algorithm14, _algorithm5$2 = algorithm13, name$2f = "unequal", dependencies$2e = ["typed", "config", "equalScalar", "matrix", "DenseMatrix"], createUnequal = /* @__PURE__ */ (0, _factory$2i.factory)(name$2f, dependencies$2e, function(t) {
  var r = t.typed;
  t.config;
  var n = t.equalScalar, a = t.matrix, s = t.DenseMatrix, o = (0, _algorithm$3.createAlgorithm03)({
    typed: r
  }), c = (0, _algorithm2$3.createAlgorithm07)({
    typed: r,
    DenseMatrix: s
  }), l = (0, _algorithm3$2.createAlgorithm12)({
    typed: r,
    DenseMatrix: s
  }), d = (0, _algorithm5$2.createAlgorithm13)({
    typed: r
  }), h = (0, _algorithm4$2.createAlgorithm14)({
    typed: r
  });
  return r("unequal", {
    "any, any": function(m, g) {
      return m === null ? g !== null : g === null ? m !== null : m === void 0 ? g !== void 0 : g === void 0 ? m !== void 0 : u(m, g);
    },
    "SparseMatrix, SparseMatrix": function(m, g) {
      return c(m, g, u);
    },
    "SparseMatrix, DenseMatrix": function(m, g) {
      return o(g, m, u, !0);
    },
    "DenseMatrix, SparseMatrix": function(m, g) {
      return o(m, g, u, !1);
    },
    "DenseMatrix, DenseMatrix": function(m, g) {
      return d(m, g, u);
    },
    "Array, Array": function(m, g) {
      return this(a(m), a(g)).valueOf();
    },
    "Array, Matrix": function(m, g) {
      return this(a(m), g);
    },
    "Matrix, Array": function(m, g) {
      return this(m, a(g));
    },
    "SparseMatrix, any": function(m, g) {
      return l(m, g, u, !1);
    },
    "DenseMatrix, any": function(m, g) {
      return h(m, g, u, !1);
    },
    "any, SparseMatrix": function(m, g) {
      return l(g, m, u, !0);
    },
    "any, DenseMatrix": function(m, g) {
      return h(g, m, u, !0);
    },
    "Array, any": function(m, g) {
      return h(a(m), g, u, !1).valueOf();
    },
    "any, Array": function(m, g) {
      return h(a(g), m, u, !0).valueOf();
    }
  });
  function u(p, m) {
    return !n(p, m);
  }
});
unequal$1.createUnequal = createUnequal;
var createUnequalNumber = (0, _factory$2i.factory)(name$2f, ["typed", "equalScalar"], function(t) {
  var r = t.typed, n = t.equalScalar;
  return r(name$2f, {
    "any, any": function(s, o) {
      return s === null ? o !== null : o === null ? s !== null : s === void 0 ? o !== void 0 : o === void 0 ? s !== void 0 : !n(s, o);
    }
  });
});
unequal$1.createUnequalNumber = createUnequalNumber;
var partitionSelect$1 = {};
Object.defineProperty(partitionSelect$1, "__esModule", {
  value: !0
});
partitionSelect$1.createPartitionSelect = void 0;
var _is$W = is, _number$9 = number$3, _factory$2h = factory$1, name$2e = "partitionSelect", dependencies$2d = ["typed", "isNumeric", "isNaN", "compare"], createPartitionSelect = /* @__PURE__ */ (0, _factory$2h.factory)(name$2e, dependencies$2d, function(t) {
  var r = t.typed, n = t.isNumeric, a = t.isNaN, s = t.compare, o = s, c = function(u, p) {
    return -s(u, p);
  };
  return r(name$2e, {
    "Array | Matrix, number": function(u, p) {
      return l(u, p, o);
    },
    "Array | Matrix, number, string": function(u, p, m) {
      if (m === "asc")
        return l(u, p, o);
      if (m === "desc")
        return l(u, p, c);
      throw new Error('Compare string must be "asc" or "desc"');
    },
    "Array | Matrix, number, function": l
  });
  function l(h, u, p) {
    if (!(0, _number$9.isInteger)(u) || u < 0)
      throw new Error("k must be a non-negative integer");
    if ((0, _is$W.isMatrix)(h)) {
      var m = h.size();
      if (m.length > 1)
        throw new Error("Only one dimensional matrices supported");
      return d(h.valueOf(), u, p);
    }
    if (Array.isArray(h))
      return d(h, u, p);
  }
  function d(h, u, p) {
    if (u >= h.length)
      throw new Error("k out of bounds");
    for (var m = 0; m < h.length; m++)
      if (n(h[m]) && a(h[m]))
        return h[m];
    for (var g = 0, v = h.length - 1; g < v; ) {
      for (var y = g, x = v, _ = h[Math.floor(Math.random() * (v - g + 1)) + g]; y < x; )
        if (p(h[y], _) >= 0) {
          var $ = h[x];
          h[x] = h[y], h[y] = $, --x;
        } else
          ++y;
      p(h[y], _) > 0 && --y, u <= y ? v = y : g = y + 1;
    }
    return h[u];
  }
});
partitionSelect$1.createPartitionSelect = createPartitionSelect;
var sort$1 = {};
Object.defineProperty(sort$1, "__esModule", {
  value: !0
});
sort$1.createSort = void 0;
var _array$s = array, _factory$2g = factory$1, name$2d = "sort", dependencies$2c = ["typed", "matrix", "compare", "compareNatural"], createSort = /* @__PURE__ */ (0, _factory$2g.factory)(name$2d, dependencies$2c, function(t) {
  var r = t.typed, n = t.matrix, a = t.compare, s = t.compareNatural, o = a, c = function(p, m) {
    return -a(p, m);
  };
  return r(name$2d, {
    Array: function(p) {
      return d(p), p.sort(o);
    },
    Matrix: function(p) {
      return h(p), n(p.toArray().sort(o), p.storage());
    },
    "Array, function": function(p, m) {
      return d(p), p.sort(m);
    },
    "Matrix, function": function(p, m) {
      return h(p), n(p.toArray().sort(m), p.storage());
    },
    "Array, string": function(p, m) {
      return d(p), p.sort(l(m));
    },
    "Matrix, string": function(p, m) {
      return h(p), n(p.toArray().sort(l(m)), p.storage());
    }
  });
  function l(u) {
    if (u === "asc")
      return o;
    if (u === "desc")
      return c;
    if (u === "natural")
      return s;
    throw new Error('String "asc", "desc", or "natural" expected');
  }
  function d(u) {
    if ((0, _array$s.arraySize)(u).length !== 1)
      throw new Error("One dimensional array expected");
  }
  function h(u) {
    if (u.size().length !== 1)
      throw new Error("One dimensional matrix expected");
  }
});
sort$1.createSort = createSort;
var max$3 = {};
Object.defineProperty(max$3, "__esModule", {
  value: !0
});
max$3.createMax = void 0;
var _collection$A = collection$1, _factory$2f = factory$1, _improveErrorMessage$6 = improveErrorMessage$1, name$2c = "max", dependencies$2b = ["typed", "config", "numeric", "larger"], createMax = /* @__PURE__ */ (0, _factory$2f.factory)(name$2c, dependencies$2b, function(t) {
  var r = t.typed, n = t.config, a = t.numeric, s = t.larger;
  return r(name$2c, {
    // max([a, b, c, d, ...])
    "Array | Matrix": c,
    // max([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(d, h) {
      return (0, _collection$A.reduce)(d, h.valueOf(), o);
    },
    // max(a, b, c, d, ...)
    "...": function(d) {
      if ((0, _collection$A.containsCollections)(d))
        throw new TypeError("Scalar values expected in function max");
      return c(d);
    }
  });
  function o(l, d) {
    try {
      return s(l, d) ? l : d;
    } catch (h) {
      throw (0, _improveErrorMessage$6.improveErrorMessage)(h, "max", d);
    }
  }
  function c(l) {
    var d;
    if ((0, _collection$A.deepForEach)(l, function(h) {
      try {
        isNaN(h) && typeof h == "number" ? d = NaN : (d === void 0 || s(h, d)) && (d = h);
      } catch (u) {
        throw (0, _improveErrorMessage$6.improveErrorMessage)(u, "max", h);
      }
    }), d === void 0)
      throw new Error("Cannot calculate max of an empty array");
    return typeof d == "string" && (d = a(d, n.number)), d;
  }
});
max$3.createMax = createMax;
var min$3 = {};
Object.defineProperty(min$3, "__esModule", {
  value: !0
});
min$3.createMin = void 0;
var _collection$z = collection$1, _factory$2e = factory$1, _improveErrorMessage$5 = improveErrorMessage$1, name$2b = "min", dependencies$2a = ["typed", "config", "numeric", "smaller"], createMin = /* @__PURE__ */ (0, _factory$2e.factory)(name$2b, dependencies$2a, function(t) {
  var r = t.typed, n = t.config, a = t.numeric, s = t.smaller;
  return r(name$2b, {
    // min([a, b, c, d, ...])
    "Array | Matrix": c,
    // min([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(d, h) {
      return (0, _collection$z.reduce)(d, h.valueOf(), o);
    },
    // min(a, b, c, d, ...)
    "...": function(d) {
      if ((0, _collection$z.containsCollections)(d))
        throw new TypeError("Scalar values expected in function min");
      return c(d);
    }
  });
  function o(l, d) {
    try {
      return s(l, d) ? l : d;
    } catch (h) {
      throw (0, _improveErrorMessage$5.improveErrorMessage)(h, "min", d);
    }
  }
  function c(l) {
    var d;
    if ((0, _collection$z.deepForEach)(l, function(h) {
      try {
        isNaN(h) && typeof h == "number" ? d = NaN : (d === void 0 || s(h, d)) && (d = h);
      } catch (u) {
        throw (0, _improveErrorMessage$5.improveErrorMessage)(u, "min", h);
      }
    }), d === void 0)
      throw new Error("Cannot calculate min of an empty array");
    return typeof d == "string" && (d = a(d, n.number)), d;
  }
});
min$3.createMin = createMin;
var ImmutableDenseMatrix = {};
Object.defineProperty(ImmutableDenseMatrix, "__esModule", {
  value: !0
});
ImmutableDenseMatrix.createImmutableDenseMatrixClass = void 0;
var _is$V = is, _object$m = object, _factory$2d = factory$1, name$2a = "ImmutableDenseMatrix", dependencies$29 = ["smaller", "DenseMatrix"], createImmutableDenseMatrixClass = /* @__PURE__ */ (0, _factory$2d.factory)(name$2a, dependencies$29, function(t) {
  var r = t.smaller, n = t.DenseMatrix;
  function a(s, o) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (o && !(0, _is$V.isString)(o))
      throw new Error("Invalid datatype: " + o);
    if ((0, _is$V.isMatrix)(s) || (0, _is$V.isArray)(s)) {
      var c = new n(s, o);
      this._data = c._data, this._size = c._size, this._datatype = c._datatype, this._min = null, this._max = null;
    } else if (s && (0, _is$V.isArray)(s.data) && (0, _is$V.isArray)(s.size))
      this._data = s.data, this._size = s.size, this._datatype = s.datatype, this._min = typeof s.min < "u" ? s.min : null, this._max = typeof s.max < "u" ? s.max : null;
    else {
      if (s)
        throw new TypeError("Unsupported type of data (" + (0, _is$V.typeOf)(s) + ")");
      this._data = [], this._size = [0], this._datatype = o, this._min = null, this._max = null;
    }
  }
  return a.prototype = new n(), a.prototype.type = "ImmutableDenseMatrix", a.prototype.isImmutableDenseMatrix = !0, a.prototype.subset = function(s) {
    switch (arguments.length) {
      case 1: {
        var o = n.prototype.subset.call(this, s);
        return (0, _is$V.isMatrix)(o) ? new a({
          data: o._data,
          size: o._size,
          datatype: o._datatype
        }) : o;
      }
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, a.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, a.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, a.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, a.prototype.clone = function() {
    return new a({
      data: (0, _object$m.clone)(this._data),
      size: (0, _object$m.clone)(this._size),
      datatype: this._datatype
    });
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "ImmutableDenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, a.fromJSON = function(s) {
    return new a(s);
  }, a.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, a.prototype.min = function() {
    if (this._min === null) {
      var s = null;
      this.forEach(function(o) {
        (s === null || r(o, s)) && (s = o);
      }), this._min = s !== null ? s : void 0;
    }
    return this._min;
  }, a.prototype.max = function() {
    if (this._max === null) {
      var s = null;
      this.forEach(function(o) {
        (s === null || r(s, o)) && (s = o);
      }), this._max = s !== null ? s : void 0;
    }
    return this._max;
  }, a;
}, {
  isClass: !0
});
ImmutableDenseMatrix.createImmutableDenseMatrixClass = createImmutableDenseMatrixClass;
var MatrixIndex = {};
Object.defineProperty(MatrixIndex, "__esModule", {
  value: !0
});
MatrixIndex.createIndexClass = void 0;
var _is$U = is, _object$l = object, _number$8 = number$3, _factory$2c = factory$1, name$29 = "Index", dependencies$28 = ["ImmutableDenseMatrix"], createIndexClass = /* @__PURE__ */ (0, _factory$2c.factory)(name$29, dependencies$28, function(t) {
  var r = t.ImmutableDenseMatrix;
  function n(s) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._isScalar = !0;
    for (var o = 0, c = arguments.length; o < c; o++) {
      var l = arguments[o];
      if ((0, _is$U.isRange)(l))
        this._dimensions.push(l), this._isScalar = !1;
      else if (Array.isArray(l) || (0, _is$U.isMatrix)(l)) {
        var d = a(l.valueOf());
        this._dimensions.push(d);
        var h = d.size();
        (h.length !== 1 || h[0] !== 1) && (this._isScalar = !1);
      } else if (typeof l == "number")
        this._dimensions.push(a([l]));
      else if (typeof l == "string")
        this._dimensions.push(l);
      else
        throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
    }
  }
  n.prototype.type = "Index", n.prototype.isIndex = !0;
  function a(s) {
    for (var o = 0, c = s.length; o < c; o++)
      if (typeof s[o] != "number" || !(0, _number$8.isInteger)(s[o]))
        throw new TypeError("Index parameters must be positive integer numbers");
    return new r(s);
  }
  return n.prototype.clone = function() {
    var s = new n();
    return s._dimensions = (0, _object$l.clone)(this._dimensions), s._isScalar = this._isScalar, s;
  }, n.create = function(s) {
    var o = new n();
    return n.apply(o, s), o;
  }, n.prototype.size = function() {
    for (var s = [], o = 0, c = this._dimensions.length; o < c; o++) {
      var l = this._dimensions[o];
      s[o] = typeof l == "string" ? 1 : l.size()[0];
    }
    return s;
  }, n.prototype.max = function() {
    for (var s = [], o = 0, c = this._dimensions.length; o < c; o++) {
      var l = this._dimensions[o];
      s[o] = typeof l == "string" ? l : l.max();
    }
    return s;
  }, n.prototype.min = function() {
    for (var s = [], o = 0, c = this._dimensions.length; o < c; o++) {
      var l = this._dimensions[o];
      s[o] = typeof l == "string" ? l : l.min();
    }
    return s;
  }, n.prototype.forEach = function(s) {
    for (var o = 0, c = this._dimensions.length; o < c; o++)
      s(this._dimensions[o], o, this);
  }, n.prototype.dimension = function(s) {
    return this._dimensions[s] || null;
  }, n.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && typeof this._dimensions[0] == "string";
  }, n.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, n.prototype.isScalar = function() {
    return this._isScalar;
  }, n.prototype.toArray = function() {
    for (var s = [], o = 0, c = this._dimensions.length; o < c; o++) {
      var l = this._dimensions[o];
      s.push(typeof l == "string" ? l : l.toArray());
    }
    return s;
  }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
    for (var s = [], o = 0, c = this._dimensions.length; o < c; o++) {
      var l = this._dimensions[o];
      typeof l == "string" ? s.push(JSON.stringify(l)) : s.push(l.toString());
    }
    return "[" + s.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "Index",
      dimensions: this._dimensions
    };
  }, n.fromJSON = function(s) {
    return n.create(s.dimensions);
  }, n;
}, {
  isClass: !0
});
MatrixIndex.createIndexClass = createIndexClass;
var FibonacciHeap = {};
Object.defineProperty(FibonacciHeap, "__esModule", {
  value: !0
});
FibonacciHeap.createFibonacciHeapClass = void 0;
var _factory$2b = factory$1, name$28 = "FibonacciHeap", dependencies$27 = ["smaller", "larger"], createFibonacciHeapClass = /* @__PURE__ */ (0, _factory$2b.factory)(name$28, dependencies$27, function(t) {
  var r = t.smaller, n = t.larger, a = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function s() {
    if (!(this instanceof s))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  s.prototype.type = "FibonacciHeap", s.prototype.isFibonacciHeap = !0, s.prototype.insert = function(u, p) {
    var m = {
      key: u,
      value: p,
      degree: 0
    };
    if (this._minimum) {
      var g = this._minimum;
      m.left = g, m.right = g.right, g.right = m, m.right.left = m, r(u, g.key) && (this._minimum = m);
    } else
      m.left = m, m.right = m, this._minimum = m;
    return this._size++, m;
  }, s.prototype.size = function() {
    return this._size;
  }, s.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, s.prototype.isEmpty = function() {
    return this._size === 0;
  }, s.prototype.extractMinimum = function() {
    var u = this._minimum;
    if (u === null)
      return u;
    for (var p = this._minimum, m = u.degree, g = u.child; m > 0; ) {
      var v = g.right;
      g.left.right = g.right, g.right.left = g.left, g.left = p, g.right = p.right, p.right = g, g.right.left = g, g.parent = null, g = v, m--;
    }
    return u.left.right = u.right, u.right.left = u.left, u === u.right ? p = null : (p = u.right, p = h(p, this._size)), this._size--, this._minimum = p, u;
  }, s.prototype.remove = function(u) {
    this._minimum = o(this._minimum, u, -1), this.extractMinimum();
  };
  function o(u, p, m) {
    p.key = m;
    var g = p.parent;
    return g && r(p.key, g.key) && (c(u, p, g), l(u, g)), r(p.key, u.key) && (u = p), u;
  }
  function c(u, p, m) {
    p.left.right = p.right, p.right.left = p.left, m.degree--, m.child === p && (m.child = p.right), m.degree === 0 && (m.child = null), p.left = u, p.right = u.right, u.right = p, p.right.left = p, p.parent = null, p.mark = !1;
  }
  function l(u, p) {
    var m = p.parent;
    m && (p.mark ? (c(u, p, m), l(m)) : p.mark = !0);
  }
  var d = function(p, m) {
    p.left.right = p.right, p.right.left = p.left, p.parent = m, m.child ? (p.left = m.child, p.right = m.child.right, m.child.right = p, p.right.left = p) : (m.child = p, p.right = p, p.left = p), m.degree++, p.mark = !1;
  };
  function h(u, p) {
    var m = Math.floor(Math.log(p) * a) + 1, g = new Array(m), v = 0, y = u;
    if (y)
      for (v++, y = y.right; y !== u; )
        v++, y = y.right;
    for (var x; v > 0; ) {
      for (var _ = y.degree, $ = y.right; x = g[_], !!x; ) {
        if (n(y.key, x.key)) {
          var b = x;
          x = y, y = b;
        }
        d(x, y), g[_] = null, _++;
      }
      g[_] = y, y = $, v--;
    }
    u = null;
    for (var M = 0; M < m; M++)
      x = g[M], x && (u ? (x.left.right = x.right, x.right.left = x.left, x.left = u, x.right = u.right, u.right = x, x.right.left = x, r(x.key, u.key) && (u = x)) : u = x);
    return u;
  }
  return s;
}, {
  isClass: !0
});
FibonacciHeap.createFibonacciHeapClass = createFibonacciHeapClass;
var Spa = {};
Object.defineProperty(Spa, "__esModule", {
  value: !0
});
Spa.createSpaClass = void 0;
var _factory$2a = factory$1, name$27 = "Spa", dependencies$26 = ["addScalar", "equalScalar", "FibonacciHeap"], createSpaClass = /* @__PURE__ */ (0, _factory$2a.factory)(name$27, dependencies$26, function(t) {
  var r = t.addScalar, n = t.equalScalar, a = t.FibonacciHeap;
  function s() {
    if (!(this instanceof s))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new a();
  }
  return s.prototype.type = "Spa", s.prototype.isSpa = !0, s.prototype.set = function(o, c) {
    if (this._values[o])
      this._values[o].value = c;
    else {
      var l = this._heap.insert(o, c);
      this._values[o] = l;
    }
  }, s.prototype.get = function(o) {
    var c = this._values[o];
    return c ? c.value : 0;
  }, s.prototype.accumulate = function(o, c) {
    var l = this._values[o];
    l ? l.value = r(l.value, c) : (l = this._heap.insert(o, c), this._values[o] = l);
  }, s.prototype.forEach = function(o, c, l) {
    var d = this._heap, h = this._values, u = [], p = d.extractMinimum();
    for (p && u.push(p); p && p.key <= c; )
      p.key >= o && (n(p.value, 0) || l(p.key, p.value, this)), p = d.extractMinimum(), p && u.push(p);
    for (var m = 0; m < u.length; m++) {
      var g = u[m];
      p = d.insert(g.key, g.value), h[p.key] = p;
    }
  }, s.prototype.swap = function(o, c) {
    var l = this._values[o], d = this._values[c];
    if (!l && d)
      l = this._heap.insert(o, d.value), this._heap.remove(d), this._values[o] = l, this._values[c] = void 0;
    else if (l && !d)
      d = this._heap.insert(c, l.value), this._heap.remove(l), this._values[c] = d, this._values[o] = void 0;
    else if (l && d) {
      var h = l.value;
      l.value = d.value, d.value = h;
    }
  }, s;
}, {
  isClass: !0
});
Spa.createSpaClass = createSpaClass;
var Unit = {}, constants$2 = {};
Object.defineProperty(constants$2, "__esModule", {
  value: !0
});
constants$2.createBigNumberTau = constants$2.createBigNumberPi = constants$2.createBigNumberPhi = constants$2.createBigNumberE = void 0;
var _function$5 = _function$9, createBigNumberE = (0, _function$5.memoize)(function(t) {
  return new t(1).exp();
}, {
  hasher
});
constants$2.createBigNumberE = createBigNumberE;
var createBigNumberPhi = (0, _function$5.memoize)(function(t) {
  return new t(1).plus(new t(5).sqrt()).div(2);
}, {
  hasher
});
constants$2.createBigNumberPhi = createBigNumberPhi;
var createBigNumberPi = (0, _function$5.memoize)(function(t) {
  return t.acos(-1);
}, {
  hasher
});
constants$2.createBigNumberPi = createBigNumberPi;
var createBigNumberTau = (0, _function$5.memoize)(function(t) {
  return createBigNumberPi(t).times(2);
}, {
  hasher
});
constants$2.createBigNumberTau = createBigNumberTau;
function hasher(t) {
  return t[0].precision;
}
Object.defineProperty(Unit, "__esModule", {
  value: !0
});
Unit.createUnitClass = void 0;
var _is$T = is, _factory$29 = factory$1, _function$4 = _function$9, _string$h = string$2, _object$k = object, _constants$1 = constants$2;
function _typeof$b(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$b = function(n) {
    return typeof n;
  } : _typeof$b = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$b(t);
}
function _extends$5() {
  return _extends$5 = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends$5.apply(this, arguments);
}
function ownKeys$7(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$7(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$7(Object(n), !0).forEach(function(a) {
      _defineProperty$4(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$7(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$4(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
var name$26 = "Unit", dependencies$25 = ["?on", "config", "addScalar", "subtract", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "number", "Complex", "BigNumber", "Fraction"], createUnitClass = /* @__PURE__ */ (0, _factory$29.factory)(name$26, dependencies$25, function(t) {
  var r = t.on, n = t.config, a = t.addScalar, s = t.subtract, o = t.multiplyScalar, c = t.divideScalar, l = t.pow, d = t.abs, h = t.fix, u = t.round, p = t.equal, m = t.isNumeric, g = t.format, v = t.number, y = t.Complex, x = t.BigNumber, _ = t.Fraction, $ = v;
  function b(ne, pe) {
    if (!(this instanceof b))
      throw new Error("Constructor must be called with the new operator");
    if (!(ne == null || m(ne) || (0, _is$T.isComplex)(ne)))
      throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (pe !== void 0 && (typeof pe != "string" || pe === ""))
      throw new TypeError("Second parameter in Unit constructor must be a string");
    if (pe !== void 0) {
      var hr = b.parse(pe);
      this.units = hr.units, this.dimensions = hr.dimensions;
    } else {
      this.units = [{
        unit: J,
        prefix: k.NONE,
        // link to a list with supported prefixes
        power: 0
      }], this.dimensions = [];
      for (var $r = 0; $r < B.length; $r++)
        this.dimensions[$r] = 0;
    }
    this.value = ne != null ? this._normalize(ne) : null, this.fixPrefix = !1, this.skipAutomaticSimplification = !0;
  }
  b.prototype.type = "Unit", b.prototype.isUnit = !0;
  var M, C, S;
  function A() {
    for (; S === " " || S === "	"; )
      T();
  }
  function D(ne) {
    return ne >= "0" && ne <= "9" || ne === ".";
  }
  function N(ne) {
    return ne >= "0" && ne <= "9";
  }
  function T() {
    C++, S = M.charAt(C);
  }
  function R(ne) {
    C = ne, S = M.charAt(C);
  }
  function F() {
    var ne = "", pe = C;
    if (S === "+" ? T() : S === "-" && (ne += S, T()), !D(S))
      return R(pe), null;
    if (S === ".") {
      if (ne += S, T(), !N(S))
        return R(pe), null;
    } else {
      for (; N(S); )
        ne += S, T();
      S === "." && (ne += S, T());
    }
    for (; N(S); )
      ne += S, T();
    if (S === "E" || S === "e") {
      var hr = "", $r = C;
      if (hr += S, T(), (S === "+" || S === "-") && (hr += S, T()), !N(S))
        return R($r), ne;
      for (ne = ne + hr; N(S); )
        ne += S, T();
    }
    return ne;
  }
  function z() {
    for (var ne = ""; N(S) || b.isValidAlpha(S); )
      ne += S, T();
    var pe = ne.charAt(0);
    return b.isValidAlpha(pe) ? ne : null;
  }
  function O(ne) {
    return S === ne ? (T(), ne) : null;
  }
  b.parse = function(ne, pe) {
    if (pe = pe || {}, M = ne, C = -1, S = "", typeof M != "string")
      throw new TypeError("Invalid argument in Unit.parse, string expected");
    var hr = new b();
    hr.units = [];
    var $r = 1, Sr = !1;
    T(), A();
    var ze = F(), cr = null;
    if (ze) {
      if (n.number === "BigNumber")
        cr = new x(ze);
      else if (n.number === "Fraction")
        try {
          cr = new _(ze);
        } catch {
          cr = parseFloat(ze);
        }
      else
        cr = parseFloat(ze);
      A(), O("*") ? ($r = 1, Sr = !0) : O("/") && ($r = -1, Sr = !0);
    }
    for (var fr = [], mr = 1; ; ) {
      for (A(); S === "("; )
        fr.push($r), mr *= $r, $r = 1, T(), A();
      var wr = void 0;
      if (S) {
        var Nr = S;
        if (wr = z(), wr === null)
          throw new SyntaxError('Unexpected "' + Nr + '" in "' + M + '" at index ' + C.toString());
      } else
        break;
      var xr = G(wr);
      if (xr === null)
        throw new SyntaxError('Unit "' + wr + '" not found.');
      var Er = $r * mr;
      if (A(), O("^")) {
        A();
        var Ir = F();
        if (Ir === null)
          throw new SyntaxError('In "' + ne + '", "^" must be followed by a floating-point number');
        Er *= Ir;
      }
      hr.units.push({
        unit: xr.unit,
        prefix: xr.prefix,
        power: Er
      });
      for (var Rr = 0; Rr < B.length; Rr++)
        hr.dimensions[Rr] += (xr.unit.dimensions[Rr] || 0) * Er;
      for (A(); S === ")"; ) {
        if (fr.length === 0)
          throw new SyntaxError('Unmatched ")" in "' + M + '" at index ' + C.toString());
        mr /= fr.pop(), T(), A();
      }
      if (Sr = !1, O("*") ? ($r = 1, Sr = !0) : O("/") ? ($r = -1, Sr = !0) : $r = 1, xr.unit.base) {
        var Yr = xr.unit.base.key;
        ee.auto[Yr] = {
          unit: xr.unit,
          prefix: xr.prefix
        };
      }
    }
    if (A(), S)
      throw new SyntaxError('Could not parse: "' + ne + '"');
    if (Sr)
      throw new SyntaxError('Trailing characters: "' + ne + '"');
    if (fr.length !== 0)
      throw new SyntaxError('Unmatched "(" in "' + M + '"');
    if (hr.units.length === 0 && !pe.allowNoUnits)
      throw new SyntaxError('"' + ne + '" contains no units');
    return hr.value = cr !== void 0 ? hr._normalize(cr) : null, hr;
  }, b.prototype.clone = function() {
    var ne = new b();
    ne.fixPrefix = this.fixPrefix, ne.skipAutomaticSimplification = this.skipAutomaticSimplification, ne.value = (0, _object$k.clone)(this.value), ne.dimensions = this.dimensions.slice(0), ne.units = [];
    for (var pe = 0; pe < this.units.length; pe++) {
      ne.units[pe] = {};
      for (var hr in this.units[pe])
        (0, _object$k.hasOwnProperty)(this.units[pe], hr) && (ne.units[pe][hr] = this.units[pe][hr]);
    }
    return ne;
  }, b.prototype._isDerived = function() {
    return this.units.length === 0 ? !1 : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, b.prototype._normalize = function(ne) {
    var pe, hr, $r, Sr, ze;
    if (ne == null || this.units.length === 0)
      return ne;
    if (this._isDerived()) {
      var cr = ne;
      ze = b._getNumberConverter((0, _is$T.typeOf)(ne));
      for (var fr = 0; fr < this.units.length; fr++)
        pe = ze(this.units[fr].unit.value), Sr = ze(this.units[fr].prefix.value), $r = ze(this.units[fr].power), cr = o(cr, l(o(pe, Sr), $r));
      return cr;
    } else
      return ze = b._getNumberConverter((0, _is$T.typeOf)(ne)), pe = ze(this.units[0].unit.value), hr = ze(this.units[0].unit.offset), Sr = ze(this.units[0].prefix.value), o(a(ne, hr), o(pe, Sr));
  }, b.prototype._denormalize = function(ne, pe) {
    var hr, $r, Sr, ze, cr;
    if (ne == null || this.units.length === 0)
      return ne;
    if (this._isDerived()) {
      var fr = ne;
      cr = b._getNumberConverter((0, _is$T.typeOf)(ne));
      for (var mr = 0; mr < this.units.length; mr++)
        hr = cr(this.units[mr].unit.value), ze = cr(this.units[mr].prefix.value), Sr = cr(this.units[mr].power), fr = c(fr, l(o(hr, ze), Sr));
      return fr;
    } else
      return cr = b._getNumberConverter((0, _is$T.typeOf)(ne)), hr = cr(this.units[0].unit.value), ze = cr(this.units[0].prefix.value), $r = cr(this.units[0].unit.offset), pe == null ? s(c(c(ne, hr), ze), $r) : s(c(c(ne, hr), pe), $r);
  };
  var G = (0, _function$4.memoize)(function(ne) {
    if ((0, _object$k.hasOwnProperty)(q, ne)) {
      var pe = q[ne], hr = pe.prefixes[""];
      return {
        unit: pe,
        prefix: hr
      };
    }
    for (var $r in q)
      if ((0, _object$k.hasOwnProperty)(q, $r) && (0, _string$h.endsWith)(ne, $r)) {
        var Sr = q[$r], ze = ne.length - $r.length, cr = ne.substring(0, ze), fr = (0, _object$k.hasOwnProperty)(Sr.prefixes, cr) ? Sr.prefixes[cr] : void 0;
        if (fr !== void 0)
          return {
            unit: Sr,
            prefix: fr
          };
      }
    return null;
  }, {
    hasher: function(pe) {
      return pe[0];
    },
    limit: 100
  });
  b.isValuelessUnit = function(ne) {
    return G(ne) !== null;
  }, b.prototype.hasBase = function(ne) {
    if (typeof ne == "string" && (ne = L[ne]), !ne)
      return !1;
    for (var pe = 0; pe < B.length; pe++)
      if (Math.abs((this.dimensions[pe] || 0) - (ne.dimensions[pe] || 0)) > 1e-12)
        return !1;
    return !0;
  }, b.prototype.equalBase = function(ne) {
    for (var pe = 0; pe < B.length; pe++)
      if (Math.abs((this.dimensions[pe] || 0) - (ne.dimensions[pe] || 0)) > 1e-12)
        return !1;
    return !0;
  }, b.prototype.equals = function(ne) {
    return this.equalBase(ne) && p(this.value, ne.value);
  }, b.prototype.multiply = function(ne) {
    for (var pe = this.clone(), hr = 0; hr < B.length; hr++)
      pe.dimensions[hr] = (this.dimensions[hr] || 0) + (ne.dimensions[hr] || 0);
    for (var $r = 0; $r < ne.units.length; $r++) {
      var Sr = _objectSpread$7({}, ne.units[$r]);
      pe.units.push(Sr);
    }
    if (this.value !== null || ne.value !== null) {
      var ze = this.value === null ? this._normalize(1) : this.value, cr = ne.value === null ? ne._normalize(1) : ne.value;
      pe.value = o(ze, cr);
    } else
      pe.value = null;
    return pe.skipAutomaticSimplification = !1, I(pe);
  }, b.prototype.divide = function(ne) {
    for (var pe = this.clone(), hr = 0; hr < B.length; hr++)
      pe.dimensions[hr] = (this.dimensions[hr] || 0) - (ne.dimensions[hr] || 0);
    for (var $r = 0; $r < ne.units.length; $r++) {
      var Sr = _objectSpread$7(_objectSpread$7({}, ne.units[$r]), {}, {
        power: -ne.units[$r].power
      });
      pe.units.push(Sr);
    }
    if (this.value !== null || ne.value !== null) {
      var ze = this.value === null ? this._normalize(1) : this.value, cr = ne.value === null ? ne._normalize(1) : ne.value;
      pe.value = c(ze, cr);
    } else
      pe.value = null;
    return pe.skipAutomaticSimplification = !1, I(pe);
  }, b.prototype.pow = function(ne) {
    for (var pe = this.clone(), hr = 0; hr < B.length; hr++)
      pe.dimensions[hr] = (this.dimensions[hr] || 0) * ne;
    for (var $r = 0; $r < pe.units.length; $r++)
      pe.units[$r].power *= ne;
    return pe.value !== null ? pe.value = l(pe.value, ne) : pe.value = null, pe.skipAutomaticSimplification = !1, I(pe);
  };
  function I(ne) {
    return ne.equalBase(L.NONE) && ne.value !== null && !n.predictable ? ne.value : ne;
  }
  b.prototype.abs = function() {
    var ne = this.clone();
    ne.value = ne.value !== null ? d(ne.value) : null;
    for (var pe in ne.units)
      (ne.units[pe].unit.name === "VA" || ne.units[pe].unit.name === "VAR") && (ne.units[pe].unit = q.W);
    return ne;
  }, b.prototype.to = function(ne) {
    var pe, hr = this.value === null ? this._normalize(1) : this.value;
    if (typeof ne == "string") {
      if (pe = b.parse(ne), !this.equalBase(pe))
        throw new Error("Units do not match ('".concat(pe.toString(), "' != '").concat(this.toString(), "')"));
      if (pe.value !== null)
        throw new Error("Cannot convert to a unit with a value");
      return pe.value = (0, _object$k.clone)(hr), pe.fixPrefix = !0, pe.skipAutomaticSimplification = !0, pe;
    } else if ((0, _is$T.isUnit)(ne)) {
      if (!this.equalBase(ne))
        throw new Error("Units do not match ('".concat(ne.toString(), "' != '").concat(this.toString(), "')"));
      if (ne.value !== null)
        throw new Error("Cannot convert to a unit with a value");
      return pe = ne.clone(), pe.value = (0, _object$k.clone)(hr), pe.fixPrefix = !0, pe.skipAutomaticSimplification = !0, pe;
    } else
      throw new Error("String or Unit expected as parameter");
  }, b.prototype.toNumber = function(ne) {
    return $(this.toNumeric(ne));
  }, b.prototype.toNumeric = function(ne) {
    var pe;
    return ne ? pe = this.to(ne) : pe = this.clone(), pe._isDerived() || pe.units.length === 0 ? pe._denormalize(pe.value) : pe._denormalize(pe.value, pe.units[0].prefix.value);
  }, b.prototype.toString = function() {
    return this.format();
  }, b.prototype.toJSON = function() {
    return {
      mathjs: "Unit",
      value: this._denormalize(this.value),
      unit: this.formatUnits(),
      fixPrefix: this.fixPrefix
    };
  }, b.fromJSON = function(ne) {
    var pe = new b(ne.value, ne.unit);
    return pe.fixPrefix = ne.fixPrefix || !1, pe;
  }, b.prototype.valueOf = b.prototype.toString, b.prototype.simplify = function() {
    var ne = this.clone(), pe = [], hr;
    for (var $r in se)
      if ((0, _object$k.hasOwnProperty)(se, $r) && ne.hasBase(L[$r])) {
        hr = $r;
        break;
      }
    if (hr === "NONE")
      ne.units = [];
    else {
      var Sr;
      if (hr && (0, _object$k.hasOwnProperty)(se, hr) && (Sr = se[hr]), Sr)
        ne.units = [{
          unit: Sr.unit,
          prefix: Sr.prefix,
          power: 1
        }];
      else {
        for (var ze = !1, cr = 0; cr < B.length; cr++) {
          var fr = B[cr];
          Math.abs(ne.dimensions[cr] || 0) > 1e-12 && ((0, _object$k.hasOwnProperty)(se, fr) ? pe.push({
            unit: se[fr].unit,
            prefix: se[fr].prefix,
            power: ne.dimensions[cr] || 0
          }) : ze = !0);
        }
        pe.length < ne.units.length && !ze && (ne.units = pe);
      }
    }
    return ne;
  }, b.prototype.toSI = function() {
    for (var ne = this.clone(), pe = [], hr = 0; hr < B.length; hr++) {
      var $r = B[hr];
      if (Math.abs(ne.dimensions[hr] || 0) > 1e-12)
        if ((0, _object$k.hasOwnProperty)(ee.si, $r))
          pe.push({
            unit: ee.si[$r].unit,
            prefix: ee.si[$r].prefix,
            power: ne.dimensions[hr] || 0
          });
        else
          throw new Error("Cannot express custom unit " + $r + " in SI units");
    }
    return ne.units = pe, ne.fixPrefix = !0, ne.skipAutomaticSimplification = !0, ne;
  }, b.prototype.formatUnits = function() {
    for (var ne = "", pe = "", hr = 0, $r = 0, Sr = 0; Sr < this.units.length; Sr++)
      this.units[Sr].power > 0 ? (hr++, ne += " " + this.units[Sr].prefix.name + this.units[Sr].unit.name, Math.abs(this.units[Sr].power - 1) > 1e-15 && (ne += "^" + this.units[Sr].power)) : this.units[Sr].power < 0 && $r++;
    if ($r > 0)
      for (var ze = 0; ze < this.units.length; ze++)
        this.units[ze].power < 0 && (hr > 0 ? (pe += " " + this.units[ze].prefix.name + this.units[ze].unit.name, Math.abs(this.units[ze].power + 1) > 1e-15 && (pe += "^" + -this.units[ze].power)) : (pe += " " + this.units[ze].prefix.name + this.units[ze].unit.name, pe += "^" + this.units[ze].power));
    ne = ne.substr(1), pe = pe.substr(1), hr > 1 && $r > 0 && (ne = "(" + ne + ")"), $r > 1 && hr > 0 && (pe = "(" + pe + ")");
    var cr = ne;
    return hr > 0 && $r > 0 && (cr += " / "), cr += pe, cr;
  }, b.prototype.format = function(ne) {
    var pe = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(), hr = !1;
    typeof pe.value < "u" && pe.value !== null && (0, _is$T.isComplex)(pe.value) && (hr = Math.abs(pe.value.re) < 1e-14);
    for (var $r in pe.units)
      (0, _object$k.hasOwnProperty)(pe.units, $r) && pe.units[$r].unit && (pe.units[$r].unit.name === "VA" && hr ? pe.units[$r].unit = q.VAR : pe.units[$r].unit.name === "VAR" && !hr && (pe.units[$r].unit = q.VA));
    pe.units.length === 1 && !pe.fixPrefix && Math.abs(pe.units[0].power - Math.round(pe.units[0].power)) < 1e-14 && (pe.units[0].prefix = pe._bestPrefix());
    var Sr = pe._denormalize(pe.value), ze = pe.value !== null ? g(Sr, ne || {}) : "", cr = pe.formatUnits();
    return pe.value && (0, _is$T.isComplex)(pe.value) && (ze = "(" + ze + ")"), cr.length > 0 && ze.length > 0 && (ze += " "), ze += cr, ze;
  }, b.prototype._bestPrefix = function() {
    if (this.units.length !== 1)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var ne = this.value !== null ? d(this.value) : 0, pe = d(this.units[0].unit.value), hr = this.units[0].prefix;
    if (ne === 0)
      return hr;
    var $r = this.units[0].power, Sr = Math.log(ne / Math.pow(hr.value * pe, $r)) / Math.LN10 - 1.2;
    if (Sr > -2.200001 && Sr < 1.800001)
      return hr;
    Sr = Math.abs(Sr);
    var ze = this.units[0].unit.prefixes;
    for (var cr in ze)
      if ((0, _object$k.hasOwnProperty)(ze, cr)) {
        var fr = ze[cr];
        if (fr.scientific) {
          var mr = Math.abs(Math.log(ne / Math.pow(fr.value * pe, $r)) / Math.LN10 - 1.2);
          (mr < Sr || mr === Sr && fr.name.length < hr.name.length) && (hr = fr, Sr = mr);
        }
      }
    return hr;
  }, b.prototype.splitUnit = function(ne) {
    for (var pe = this.clone(), hr = [], $r = 0; $r < ne.length && (pe = pe.to(ne[$r]), $r !== ne.length - 1); $r++) {
      var Sr = pe.toNumeric(), ze = u(Sr), cr = void 0, fr = p(ze, Sr);
      fr ? cr = ze : cr = h(pe.toNumeric());
      var mr = new b(cr, ne[$r].toString());
      hr.push(mr), pe = s(pe, mr);
    }
    for (var wr = 0, Nr = 0; Nr < hr.length; Nr++)
      wr = a(wr, hr[Nr].value);
    return p(wr, this.value) && (pe.value = 0), hr.push(pe), hr;
  };
  var k = {
    NONE: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      }
    },
    SHORT: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 10,
        scientific: !1
      },
      h: {
        name: "h",
        value: 100,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.1,
        scientific: !1
      },
      c: {
        name: "c",
        value: 0.01,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-3,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-6,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-9,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-12,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-15,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-18,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-21,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-24,
        scientific: !0
      }
    },
    LONG: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      deca: {
        name: "deca",
        value: 10,
        scientific: !1
      },
      hecto: {
        name: "hecto",
        value: 100,
        scientific: !1
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      },
      deci: {
        name: "deci",
        value: 0.1,
        scientific: !1
      },
      centi: {
        name: "centi",
        value: 0.01,
        scientific: !1
      },
      milli: {
        name: "milli",
        value: 1e-3,
        scientific: !0
      },
      micro: {
        name: "micro",
        value: 1e-6,
        scientific: !0
      },
      nano: {
        name: "nano",
        value: 1e-9,
        scientific: !0
      },
      pico: {
        name: "pico",
        value: 1e-12,
        scientific: !0
      },
      femto: {
        name: "femto",
        value: 1e-15,
        scientific: !0
      },
      atto: {
        name: "atto",
        value: 1e-18,
        scientific: !0
      },
      zepto: {
        name: "zepto",
        value: 1e-21,
        scientific: !0
      },
      yocto: {
        name: "yocto",
        value: 1e-24,
        scientific: !0
      }
    },
    SQUARED: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 100,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e4,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e6,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e12,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e18,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e24,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e30,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e36,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e42,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e48,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.01,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-4,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-6,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-12,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-18,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-24,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-30,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-36,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-42,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-48,
        scientific: !0
      }
    },
    CUBIC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 1e3,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e6,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e9,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e18,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e27,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e36,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e45,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e54,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e63,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e72,
        scientific: !0
      },
      d: {
        name: "d",
        value: 1e-3,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-6,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-9,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-18,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-27,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-36,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-45,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-54,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-63,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-72,
        scientific: !0
      }
    },
    BINARY_SHORT_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_SHORT_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      Ki: {
        name: "Ki",
        value: 1024,
        scientific: !0
      },
      Mi: {
        name: "Mi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      Gi: {
        name: "Gi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      Ti: {
        name: "Ti",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      Pi: {
        name: "Pi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      Ei: {
        name: "Ei",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      Zi: {
        name: "Zi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      Yi: {
        name: "Yi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BINARY_LONG_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_LONG_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kibi: {
        name: "kibi",
        value: 1024,
        scientific: !0
      },
      mebi: {
        name: "mebi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      gibi: {
        name: "gibi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      tebi: {
        name: "tebi",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      pebi: {
        name: "pebi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      exi: {
        name: "exi",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      zebi: {
        name: "zebi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      yobi: {
        name: "yobi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BTU: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      MM: {
        name: "MM",
        value: 1e6,
        scientific: !0
      }
    }
  };
  k.SHORTLONG = _extends$5({}, k.SHORT, k.LONG), k.BINARY_SHORT = _extends$5({}, k.BINARY_SHORT_SI, k.BINARY_SHORT_IEC), k.BINARY_LONG = _extends$5({}, k.BINARY_LONG_SI, k.BINARY_LONG_IEC);
  var B = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], L = {
    NONE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    MASS: {
      dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    LENGTH: {
      dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
    },
    TIME: {
      dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
    },
    CURRENT: {
      dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    TEMPERATURE: {
      dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
    },
    LUMINOUS_INTENSITY: {
      dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
    },
    AMOUNT_OF_SUBSTANCE: {
      dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
    },
    FORCE: {
      dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
    },
    SURFACE: {
      dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
    },
    VOLUME: {
      dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
    },
    ENERGY: {
      dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
    },
    POWER: {
      dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
    },
    PRESSURE: {
      dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CHARGE: {
      dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CAPACITANCE: {
      dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_POTENTIAL: {
      dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_RESISTANCE: {
      dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_INDUCTANCE: {
      dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CONDUCTANCE: {
      dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX: {
      dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX_DENSITY: {
      dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
    },
    FREQUENCY: {
      dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
    },
    ANGLE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
    },
    BIT: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
    }
  };
  for (var V in L)
    (0, _object$k.hasOwnProperty)(L, V) && (L[V].key = V);
  var U = {}, J = {
    name: "",
    base: U,
    value: 1,
    offset: 0,
    dimensions: B.map(function(ne) {
      return 0;
    })
  }, q = {
    // length
    meter: {
      name: "meter",
      base: L.LENGTH,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    inch: {
      name: "inch",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.0254,
      offset: 0
    },
    foot: {
      name: "foot",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.3048,
      offset: 0
    },
    yard: {
      name: "yard",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.9144,
      offset: 0
    },
    mile: {
      name: "mile",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 1609.344,
      offset: 0
    },
    link: {
      name: "link",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.201168,
      offset: 0
    },
    rod: {
      name: "rod",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 5.0292,
      offset: 0
    },
    chain: {
      name: "chain",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 20.1168,
      offset: 0
    },
    angstrom: {
      name: "angstrom",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 1e-10,
      offset: 0
    },
    m: {
      name: "m",
      base: L.LENGTH,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    in: {
      name: "in",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.0254,
      offset: 0
    },
    ft: {
      name: "ft",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.3048,
      offset: 0
    },
    yd: {
      name: "yd",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.9144,
      offset: 0
    },
    mi: {
      name: "mi",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 1609.344,
      offset: 0
    },
    li: {
      name: "li",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 0.201168,
      offset: 0
    },
    rd: {
      name: "rd",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 5.02921,
      offset: 0
    },
    ch: {
      name: "ch",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 20.1168,
      offset: 0
    },
    mil: {
      name: "mil",
      base: L.LENGTH,
      prefixes: k.NONE,
      value: 254e-7,
      offset: 0
    },
    // 1/1000 inch
    // Surface
    m2: {
      name: "m2",
      base: L.SURFACE,
      prefixes: k.SQUARED,
      value: 1,
      offset: 0
    },
    sqin: {
      name: "sqin",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 64516e-8,
      offset: 0
    },
    // 645.16 mm2
    sqft: {
      name: "sqft",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 0.09290304,
      offset: 0
    },
    // 0.09290304 m2
    sqyd: {
      name: "sqyd",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 0.83612736,
      offset: 0
    },
    // 0.83612736 m2
    sqmi: {
      name: "sqmi",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 2589988110336e-6,
      offset: 0
    },
    // 2.589988110336 km2
    sqrd: {
      name: "sqrd",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 25.29295,
      offset: 0
    },
    // 25.29295 m2
    sqch: {
      name: "sqch",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 404.6873,
      offset: 0
    },
    // 404.6873 m2
    sqmil: {
      name: "sqmil",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 64516e-14,
      offset: 0
    },
    // 6.4516 * 10^-10 m2
    acre: {
      name: "acre",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 4046.86,
      offset: 0
    },
    // 4046.86 m2
    hectare: {
      name: "hectare",
      base: L.SURFACE,
      prefixes: k.NONE,
      value: 1e4,
      offset: 0
    },
    // 10000 m2
    // Volume
    m3: {
      name: "m3",
      base: L.VOLUME,
      prefixes: k.CUBIC,
      value: 1,
      offset: 0
    },
    L: {
      name: "L",
      base: L.VOLUME,
      prefixes: k.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    l: {
      name: "l",
      base: L.VOLUME,
      prefixes: k.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    litre: {
      name: "litre",
      base: L.VOLUME,
      prefixes: k.LONG,
      value: 1e-3,
      offset: 0
    },
    cuin: {
      name: "cuin",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 16387064e-12,
      offset: 0
    },
    // 1.6387064e-5 m3
    cuft: {
      name: "cuft",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 0.028316846592,
      offset: 0
    },
    // 28.316 846 592 L
    cuyd: {
      name: "cuyd",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 0.764554857984,
      offset: 0
    },
    // 764.554 857 984 L
    teaspoon: {
      name: "teaspoon",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 5e-6,
      offset: 0
    },
    // 5 mL
    tablespoon: {
      name: "tablespoon",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 15e-6,
      offset: 0
    },
    // 15 mL
    // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
    drop: {
      name: "drop",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    gtt: {
      name: "gtt",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    // Liquid volume
    minim: {
      name: "minim",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 6161152e-14,
      offset: 0
    },
    // 0.06161152 mL
    fluiddram: {
      name: "fluiddram",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 36966911e-13,
      offset: 0
    },
    // 3.696691 mL
    fluidounce: {
      name: "fluidounce",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 2957353e-11,
      offset: 0
    },
    // 29.57353 mL
    gill: {
      name: "gill",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 1182941e-10,
      offset: 0
    },
    // 118.2941 mL
    cc: {
      name: "cc",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 1e-6,
      offset: 0
    },
    // 1e-6 L
    cup: {
      name: "cup",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 2365882e-10,
      offset: 0
    },
    // 236.5882 mL
    pint: {
      name: "pint",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 4731765e-10,
      offset: 0
    },
    // 473.1765 mL
    quart: {
      name: "quart",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 9463529e-10,
      offset: 0
    },
    // 946.3529 mL
    gallon: {
      name: "gallon",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 3785412e-9,
      offset: 0
    },
    // 3.785412 L
    beerbarrel: {
      name: "beerbarrel",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 0.1173478,
      offset: 0
    },
    // 117.3478 L
    oilbarrel: {
      name: "oilbarrel",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 0.1589873,
      offset: 0
    },
    // 158.9873 L
    hogshead: {
      name: "hogshead",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 0.238481,
      offset: 0
    },
    // 238.4810 L
    // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
    fldr: {
      name: "fldr",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 36966911e-13,
      offset: 0
    },
    // 3.696691 mL
    floz: {
      name: "floz",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 2957353e-11,
      offset: 0
    },
    // 29.57353 mL
    gi: {
      name: "gi",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 1182941e-10,
      offset: 0
    },
    // 118.2941 mL
    cp: {
      name: "cp",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 2365882e-10,
      offset: 0
    },
    // 236.5882 mL
    pt: {
      name: "pt",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 4731765e-10,
      offset: 0
    },
    // 473.1765 mL
    qt: {
      name: "qt",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 9463529e-10,
      offset: 0
    },
    // 946.3529 mL
    gal: {
      name: "gal",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 3785412e-9,
      offset: 0
    },
    // 3.785412 L
    bbl: {
      name: "bbl",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 0.1173478,
      offset: 0
    },
    // 117.3478 L
    obl: {
      name: "obl",
      base: L.VOLUME,
      prefixes: k.NONE,
      value: 0.1589873,
      offset: 0
    },
    // 158.9873 L
    // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
    // Mass
    g: {
      name: "g",
      base: L.MASS,
      prefixes: k.SHORT,
      value: 1e-3,
      offset: 0
    },
    gram: {
      name: "gram",
      base: L.MASS,
      prefixes: k.LONG,
      value: 1e-3,
      offset: 0
    },
    ton: {
      name: "ton",
      base: L.MASS,
      prefixes: k.SHORT,
      value: 907.18474,
      offset: 0
    },
    t: {
      name: "t",
      base: L.MASS,
      prefixes: k.SHORT,
      value: 1e3,
      offset: 0
    },
    tonne: {
      name: "tonne",
      base: L.MASS,
      prefixes: k.LONG,
      value: 1e3,
      offset: 0
    },
    grain: {
      name: "grain",
      base: L.MASS,
      prefixes: k.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dram: {
      name: "dram",
      base: L.MASS,
      prefixes: k.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    ounce: {
      name: "ounce",
      base: L.MASS,
      prefixes: k.NONE,
      value: 0.028349523125,
      offset: 0
    },
    poundmass: {
      name: "poundmass",
      base: L.MASS,
      prefixes: k.NONE,
      value: 0.45359237,
      offset: 0
    },
    hundredweight: {
      name: "hundredweight",
      base: L.MASS,
      prefixes: k.NONE,
      value: 45.359237,
      offset: 0
    },
    stick: {
      name: "stick",
      base: L.MASS,
      prefixes: k.NONE,
      value: 0.115,
      offset: 0
    },
    stone: {
      name: "stone",
      base: L.MASS,
      prefixes: k.NONE,
      value: 6.35029318,
      offset: 0
    },
    gr: {
      name: "gr",
      base: L.MASS,
      prefixes: k.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dr: {
      name: "dr",
      base: L.MASS,
      prefixes: k.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    oz: {
      name: "oz",
      base: L.MASS,
      prefixes: k.NONE,
      value: 0.028349523125,
      offset: 0
    },
    lbm: {
      name: "lbm",
      base: L.MASS,
      prefixes: k.NONE,
      value: 0.45359237,
      offset: 0
    },
    cwt: {
      name: "cwt",
      base: L.MASS,
      prefixes: k.NONE,
      value: 45.359237,
      offset: 0
    },
    // Time
    s: {
      name: "s",
      base: L.TIME,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    min: {
      name: "min",
      base: L.TIME,
      prefixes: k.NONE,
      value: 60,
      offset: 0
    },
    h: {
      name: "h",
      base: L.TIME,
      prefixes: k.NONE,
      value: 3600,
      offset: 0
    },
    second: {
      name: "second",
      base: L.TIME,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    sec: {
      name: "sec",
      base: L.TIME,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    minute: {
      name: "minute",
      base: L.TIME,
      prefixes: k.NONE,
      value: 60,
      offset: 0
    },
    hour: {
      name: "hour",
      base: L.TIME,
      prefixes: k.NONE,
      value: 3600,
      offset: 0
    },
    day: {
      name: "day",
      base: L.TIME,
      prefixes: k.NONE,
      value: 86400,
      offset: 0
    },
    week: {
      name: "week",
      base: L.TIME,
      prefixes: k.NONE,
      value: 7 * 86400,
      offset: 0
    },
    month: {
      name: "month",
      base: L.TIME,
      prefixes: k.NONE,
      value: 2629800,
      // 1/12th of Julian year
      offset: 0
    },
    year: {
      name: "year",
      base: L.TIME,
      prefixes: k.NONE,
      value: 31557600,
      // Julian year
      offset: 0
    },
    decade: {
      name: "decade",
      base: L.TIME,
      prefixes: k.NONE,
      value: 315576e3,
      // Julian decade
      offset: 0
    },
    century: {
      name: "century",
      base: L.TIME,
      prefixes: k.NONE,
      value: 315576e4,
      // Julian century
      offset: 0
    },
    millennium: {
      name: "millennium",
      base: L.TIME,
      prefixes: k.NONE,
      value: 315576e5,
      // Julian millennium
      offset: 0
    },
    // Frequency
    hertz: {
      name: "Hertz",
      base: L.FREQUENCY,
      prefixes: k.LONG,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    Hz: {
      name: "Hz",
      base: L.FREQUENCY,
      prefixes: k.SHORT,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    // Angle
    rad: {
      name: "rad",
      base: L.ANGLE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    radian: {
      name: "radian",
      base: L.ANGLE,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
    deg: {
      name: "deg",
      base: L.ANGLE,
      prefixes: k.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    degree: {
      name: "degree",
      base: L.ANGLE,
      prefixes: k.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
    grad: {
      name: "grad",
      base: L.ANGLE,
      prefixes: k.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    gradian: {
      name: "gradian",
      base: L.ANGLE,
      prefixes: k.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
    cycle: {
      name: "cycle",
      base: L.ANGLE,
      prefixes: k.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
    arcsec: {
      name: "arcsec",
      base: L.ANGLE,
      prefixes: k.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
    arcmin: {
      name: "arcmin",
      base: L.ANGLE,
      prefixes: k.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // Electric current
    A: {
      name: "A",
      base: L.CURRENT,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    ampere: {
      name: "ampere",
      base: L.CURRENT,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    // Temperature
    // K(C) = °C + 273.15
    // K(F) = (°F + 459.67) / 1.8
    // K(R) = °R / 1.8
    K: {
      name: "K",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1,
      offset: 0
    },
    degC: {
      name: "degC",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1,
      offset: 273.15
    },
    degF: {
      name: "degF",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1 / 1.8,
      offset: 459.67
    },
    degR: {
      name: "degR",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1 / 1.8,
      offset: 0
    },
    kelvin: {
      name: "kelvin",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1,
      offset: 0
    },
    celsius: {
      name: "celsius",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1,
      offset: 273.15
    },
    fahrenheit: {
      name: "fahrenheit",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1 / 1.8,
      offset: 459.67
    },
    rankine: {
      name: "rankine",
      base: L.TEMPERATURE,
      prefixes: k.NONE,
      value: 1 / 1.8,
      offset: 0
    },
    // amount of substance
    mol: {
      name: "mol",
      base: L.AMOUNT_OF_SUBSTANCE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    mole: {
      name: "mole",
      base: L.AMOUNT_OF_SUBSTANCE,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    // luminous intensity
    cd: {
      name: "cd",
      base: L.LUMINOUS_INTENSITY,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    candela: {
      name: "candela",
      base: L.LUMINOUS_INTENSITY,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    // TODO: units STERADIAN
    // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // Force
    N: {
      name: "N",
      base: L.FORCE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    newton: {
      name: "newton",
      base: L.FORCE,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    dyn: {
      name: "dyn",
      base: L.FORCE,
      prefixes: k.SHORT,
      value: 1e-5,
      offset: 0
    },
    dyne: {
      name: "dyne",
      base: L.FORCE,
      prefixes: k.LONG,
      value: 1e-5,
      offset: 0
    },
    lbf: {
      name: "lbf",
      base: L.FORCE,
      prefixes: k.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    poundforce: {
      name: "poundforce",
      base: L.FORCE,
      prefixes: k.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    kip: {
      name: "kip",
      base: L.FORCE,
      prefixes: k.LONG,
      value: 4448.2216,
      offset: 0
    },
    kilogramforce: {
      name: "kilogramforce",
      base: L.FORCE,
      prefixes: k.NONE,
      value: 9.80665,
      offset: 0
    },
    // Energy
    J: {
      name: "J",
      base: L.ENERGY,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    joule: {
      name: "joule",
      base: L.ENERGY,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    erg: {
      name: "erg",
      base: L.ENERGY,
      prefixes: k.NONE,
      value: 1e-7,
      offset: 0
    },
    Wh: {
      name: "Wh",
      base: L.ENERGY,
      prefixes: k.SHORT,
      value: 3600,
      offset: 0
    },
    BTU: {
      name: "BTU",
      base: L.ENERGY,
      prefixes: k.BTU,
      value: 1055.05585262,
      offset: 0
    },
    eV: {
      name: "eV",
      base: L.ENERGY,
      prefixes: k.SHORT,
      value: 1602176565e-28,
      offset: 0
    },
    electronvolt: {
      name: "electronvolt",
      base: L.ENERGY,
      prefixes: k.LONG,
      value: 1602176565e-28,
      offset: 0
    },
    // Power
    W: {
      name: "W",
      base: L.POWER,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    watt: {
      name: "watt",
      base: L.POWER,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    hp: {
      name: "hp",
      base: L.POWER,
      prefixes: k.NONE,
      value: 745.6998715386,
      offset: 0
    },
    // Electrical power units
    VAR: {
      name: "VAR",
      base: L.POWER,
      prefixes: k.SHORT,
      value: y.I,
      offset: 0
    },
    VA: {
      name: "VA",
      base: L.POWER,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Pressure
    Pa: {
      name: "Pa",
      base: L.PRESSURE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    psi: {
      name: "psi",
      base: L.PRESSURE,
      prefixes: k.NONE,
      value: 6894.75729276459,
      offset: 0
    },
    atm: {
      name: "atm",
      base: L.PRESSURE,
      prefixes: k.NONE,
      value: 101325,
      offset: 0
    },
    bar: {
      name: "bar",
      base: L.PRESSURE,
      prefixes: k.SHORTLONG,
      value: 1e5,
      offset: 0
    },
    torr: {
      name: "torr",
      base: L.PRESSURE,
      prefixes: k.NONE,
      value: 133.322,
      offset: 0
    },
    mmHg: {
      name: "mmHg",
      base: L.PRESSURE,
      prefixes: k.NONE,
      value: 133.322,
      offset: 0
    },
    mmH2O: {
      name: "mmH2O",
      base: L.PRESSURE,
      prefixes: k.NONE,
      value: 9.80665,
      offset: 0
    },
    cmH2O: {
      name: "cmH2O",
      base: L.PRESSURE,
      prefixes: k.NONE,
      value: 98.0665,
      offset: 0
    },
    // Electric charge
    coulomb: {
      name: "coulomb",
      base: L.ELECTRIC_CHARGE,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    C: {
      name: "C",
      base: L.ELECTRIC_CHARGE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Electric capacitance
    farad: {
      name: "farad",
      base: L.ELECTRIC_CAPACITANCE,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    F: {
      name: "F",
      base: L.ELECTRIC_CAPACITANCE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Electric potential
    volt: {
      name: "volt",
      base: L.ELECTRIC_POTENTIAL,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    V: {
      name: "V",
      base: L.ELECTRIC_POTENTIAL,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Electric resistance
    ohm: {
      name: "ohm",
      base: L.ELECTRIC_RESISTANCE,
      prefixes: k.SHORTLONG,
      // Both Mohm and megaohm are acceptable
      value: 1,
      offset: 0
    },
    /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */
    // Electric inductance
    henry: {
      name: "henry",
      base: L.ELECTRIC_INDUCTANCE,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    H: {
      name: "H",
      base: L.ELECTRIC_INDUCTANCE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Electric conductance
    siemens: {
      name: "siemens",
      base: L.ELECTRIC_CONDUCTANCE,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    S: {
      name: "S",
      base: L.ELECTRIC_CONDUCTANCE,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux
    weber: {
      name: "weber",
      base: L.MAGNETIC_FLUX,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    Wb: {
      name: "Wb",
      base: L.MAGNETIC_FLUX,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux density
    tesla: {
      name: "tesla",
      base: L.MAGNETIC_FLUX_DENSITY,
      prefixes: k.LONG,
      value: 1,
      offset: 0
    },
    T: {
      name: "T",
      base: L.MAGNETIC_FLUX_DENSITY,
      prefixes: k.SHORT,
      value: 1,
      offset: 0
    },
    // Binary
    b: {
      name: "b",
      base: L.BIT,
      prefixes: k.BINARY_SHORT,
      value: 1,
      offset: 0
    },
    bits: {
      name: "bits",
      base: L.BIT,
      prefixes: k.BINARY_LONG,
      value: 1,
      offset: 0
    },
    B: {
      name: "B",
      base: L.BIT,
      prefixes: k.BINARY_SHORT,
      value: 8,
      offset: 0
    },
    bytes: {
      name: "bytes",
      base: L.BIT,
      prefixes: k.BINARY_LONG,
      value: 8,
      offset: 0
    }
  }, Z = {
    meters: "meter",
    inches: "inch",
    feet: "foot",
    yards: "yard",
    miles: "mile",
    links: "link",
    rods: "rod",
    chains: "chain",
    angstroms: "angstrom",
    lt: "l",
    litres: "litre",
    liter: "litre",
    liters: "litre",
    teaspoons: "teaspoon",
    tablespoons: "tablespoon",
    minims: "minim",
    fluiddrams: "fluiddram",
    fluidounces: "fluidounce",
    gills: "gill",
    cups: "cup",
    pints: "pint",
    quarts: "quart",
    gallons: "gallon",
    beerbarrels: "beerbarrel",
    oilbarrels: "oilbarrel",
    hogsheads: "hogshead",
    gtts: "gtt",
    grams: "gram",
    tons: "ton",
    tonnes: "tonne",
    grains: "grain",
    drams: "dram",
    ounces: "ounce",
    poundmasses: "poundmass",
    hundredweights: "hundredweight",
    sticks: "stick",
    lb: "lbm",
    lbs: "lbm",
    kips: "kip",
    kgf: "kilogramforce",
    acres: "acre",
    hectares: "hectare",
    sqfeet: "sqft",
    sqyard: "sqyd",
    sqmile: "sqmi",
    sqmiles: "sqmi",
    mmhg: "mmHg",
    mmh2o: "mmH2O",
    cmh2o: "cmH2O",
    seconds: "second",
    secs: "second",
    minutes: "minute",
    mins: "minute",
    hours: "hour",
    hr: "hour",
    hrs: "hour",
    days: "day",
    weeks: "week",
    months: "month",
    years: "year",
    decades: "decade",
    centuries: "century",
    millennia: "millennium",
    hertz: "hertz",
    radians: "radian",
    degrees: "degree",
    gradians: "gradian",
    cycles: "cycle",
    arcsecond: "arcsec",
    arcseconds: "arcsec",
    arcminute: "arcmin",
    arcminutes: "arcmin",
    BTUs: "BTU",
    watts: "watt",
    joules: "joule",
    amperes: "ampere",
    coulombs: "coulomb",
    volts: "volt",
    ohms: "ohm",
    farads: "farad",
    webers: "weber",
    teslas: "tesla",
    electronvolts: "electronvolt",
    moles: "mole",
    bit: "bits",
    byte: "bytes"
  };
  function ae(ne) {
    if (ne.number === "BigNumber") {
      var pe = (0, _constants$1.createBigNumberPi)(x);
      q.rad.value = new x(1), q.deg.value = pe.div(180), q.grad.value = pe.div(200), q.cycle.value = pe.times(2), q.arcsec.value = pe.div(648e3), q.arcmin.value = pe.div(10800);
    } else
      q.rad.value = 1, q.deg.value = Math.PI / 180, q.grad.value = Math.PI / 200, q.cycle.value = Math.PI * 2, q.arcsec.value = Math.PI / 648e3, q.arcmin.value = Math.PI / 10800;
    q.radian.value = q.rad.value, q.degree.value = q.deg.value, q.gradian.value = q.grad.value;
  }
  ae(n), r && r("config", function(ne, pe) {
    ne.number !== pe.number && ae(ne);
  });
  var ee = {
    si: {
      // Base units
      NONE: {
        unit: J,
        prefix: k.NONE[""]
      },
      LENGTH: {
        unit: q.m,
        prefix: k.SHORT[""]
      },
      MASS: {
        unit: q.g,
        prefix: k.SHORT.k
      },
      TIME: {
        unit: q.s,
        prefix: k.SHORT[""]
      },
      CURRENT: {
        unit: q.A,
        prefix: k.SHORT[""]
      },
      TEMPERATURE: {
        unit: q.K,
        prefix: k.SHORT[""]
      },
      LUMINOUS_INTENSITY: {
        unit: q.cd,
        prefix: k.SHORT[""]
      },
      AMOUNT_OF_SUBSTANCE: {
        unit: q.mol,
        prefix: k.SHORT[""]
      },
      ANGLE: {
        unit: q.rad,
        prefix: k.SHORT[""]
      },
      BIT: {
        unit: q.bits,
        prefix: k.SHORT[""]
      },
      // Derived units
      FORCE: {
        unit: q.N,
        prefix: k.SHORT[""]
      },
      ENERGY: {
        unit: q.J,
        prefix: k.SHORT[""]
      },
      POWER: {
        unit: q.W,
        prefix: k.SHORT[""]
      },
      PRESSURE: {
        unit: q.Pa,
        prefix: k.SHORT[""]
      },
      ELECTRIC_CHARGE: {
        unit: q.C,
        prefix: k.SHORT[""]
      },
      ELECTRIC_CAPACITANCE: {
        unit: q.F,
        prefix: k.SHORT[""]
      },
      ELECTRIC_POTENTIAL: {
        unit: q.V,
        prefix: k.SHORT[""]
      },
      ELECTRIC_RESISTANCE: {
        unit: q.ohm,
        prefix: k.SHORT[""]
      },
      ELECTRIC_INDUCTANCE: {
        unit: q.H,
        prefix: k.SHORT[""]
      },
      ELECTRIC_CONDUCTANCE: {
        unit: q.S,
        prefix: k.SHORT[""]
      },
      MAGNETIC_FLUX: {
        unit: q.Wb,
        prefix: k.SHORT[""]
      },
      MAGNETIC_FLUX_DENSITY: {
        unit: q.T,
        prefix: k.SHORT[""]
      },
      FREQUENCY: {
        unit: q.Hz,
        prefix: k.SHORT[""]
      }
    }
  };
  ee.cgs = JSON.parse(JSON.stringify(ee.si)), ee.cgs.LENGTH = {
    unit: q.m,
    prefix: k.SHORT.c
  }, ee.cgs.MASS = {
    unit: q.g,
    prefix: k.SHORT[""]
  }, ee.cgs.FORCE = {
    unit: q.dyn,
    prefix: k.SHORT[""]
  }, ee.cgs.ENERGY = {
    unit: q.erg,
    prefix: k.NONE[""]
  }, ee.us = JSON.parse(JSON.stringify(ee.si)), ee.us.LENGTH = {
    unit: q.ft,
    prefix: k.NONE[""]
  }, ee.us.MASS = {
    unit: q.lbm,
    prefix: k.NONE[""]
  }, ee.us.TEMPERATURE = {
    unit: q.degF,
    prefix: k.NONE[""]
  }, ee.us.FORCE = {
    unit: q.lbf,
    prefix: k.NONE[""]
  }, ee.us.ENERGY = {
    unit: q.BTU,
    prefix: k.BTU[""]
  }, ee.us.POWER = {
    unit: q.hp,
    prefix: k.NONE[""]
  }, ee.us.PRESSURE = {
    unit: q.psi,
    prefix: k.NONE[""]
  }, ee.auto = JSON.parse(JSON.stringify(ee.si));
  var se = ee.auto;
  b.setUnitSystem = function(ne) {
    if ((0, _object$k.hasOwnProperty)(ee, ne))
      se = ee[ne];
    else
      throw new Error("Unit system " + ne + " does not exist. Choices are: " + Object.keys(ee).join(", "));
  }, b.getUnitSystem = function() {
    for (var ne in ee)
      if ((0, _object$k.hasOwnProperty)(ee, ne) && ee[ne] === se)
        return ne;
  }, b.typeConverters = {
    BigNumber: function(pe) {
      return new x(pe + "");
    },
    Fraction: function(pe) {
      return new _(pe);
    },
    Complex: function(pe) {
      return pe;
    },
    number: function(pe) {
      return pe;
    }
  }, b._getNumberConverter = function(ne) {
    if (!b.typeConverters[ne])
      throw new TypeError('Unsupported type "' + ne + '"');
    return b.typeConverters[ne];
  };
  for (var nr in q)
    if ((0, _object$k.hasOwnProperty)(q, nr)) {
      var ce = q[nr];
      ce.dimensions = ce.base.dimensions;
    }
  for (var oe in Z)
    if ((0, _object$k.hasOwnProperty)(Z, oe)) {
      var ur = q[Z[oe]], ir = {};
      for (var _r in ur)
        (0, _object$k.hasOwnProperty)(ur, _r) && (ir[_r] = ur[_r]);
      ir.name = oe, q[oe] = ir;
    }
  b.isValidAlpha = function(pe) {
    return /^[a-zA-Z]$/.test(pe);
  };
  function yr(ne) {
    for (var pe = 0; pe < ne.length; pe++) {
      if (S = ne.charAt(pe), pe === 0 && !b.isValidAlpha(S))
        throw new Error('Invalid unit name (must begin with alpha character): "' + ne + '"');
      if (pe > 0 && !(b.isValidAlpha(S) || N(S)))
        throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + ne + '"');
    }
  }
  return b.createUnit = function(ne, pe) {
    if (_typeof$b(ne) !== "object")
      throw new TypeError("createUnit expects first parameter to be of type 'Object'");
    if (pe && pe.override) {
      for (var hr in ne)
        if ((0, _object$k.hasOwnProperty)(ne, hr) && b.deleteUnit(hr), ne[hr].aliases)
          for (var $r = 0; $r < ne[hr].aliases.length; $r++)
            b.deleteUnit(ne[hr].aliases[$r]);
    }
    var Sr;
    for (var ze in ne)
      (0, _object$k.hasOwnProperty)(ne, ze) && (Sr = b.createUnitSingle(ze, ne[ze]));
    return Sr;
  }, b.createUnitSingle = function(ne, pe, hr) {
    if ((typeof pe > "u" || pe === null) && (pe = {}), typeof ne != "string")
      throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if ((0, _object$k.hasOwnProperty)(q, ne))
      throw new Error('Cannot create unit "' + ne + '": a unit with that name already exists');
    yr(ne);
    var $r = null, Sr = [], ze = 0, cr, fr, mr;
    if (pe && pe.type === "Unit")
      $r = pe.clone();
    else if (typeof pe == "string")
      pe !== "" && (cr = pe);
    else if (_typeof$b(pe) === "object")
      cr = pe.definition, fr = pe.prefixes, ze = pe.offset, mr = pe.baseName, pe.aliases && (Sr = pe.aliases.valueOf());
    else
      throw new TypeError('Cannot create unit "' + ne + '" from "' + pe.toString() + '": expecting "string" or "Unit" or "Object"');
    if (Sr) {
      for (var wr = 0; wr < Sr.length; wr++)
        if ((0, _object$k.hasOwnProperty)(q, Sr[wr]))
          throw new Error('Cannot create alias "' + Sr[wr] + '": a unit with that name already exists');
    }
    if (cr && typeof cr == "string" && !$r)
      try {
        $r = b.parse(cr, {
          allowNoUnits: !0
        });
      } catch (dr) {
        throw dr.message = 'Could not create unit "' + ne + '" from "' + cr + '": ' + dr.message, dr;
      }
    else
      cr && cr.type === "Unit" && ($r = cr.clone());
    Sr = Sr || [], ze = ze || 0, fr && fr.toUpperCase ? fr = k[fr.toUpperCase()] || k.NONE : fr = k.NONE;
    var Nr = {};
    if ($r) {
      Nr = {
        name: ne,
        value: $r.value,
        dimensions: $r.dimensions.slice(0),
        prefixes: fr,
        offset: ze
      };
      var Rr = !1;
      for (var Yr in L)
        if ((0, _object$k.hasOwnProperty)(L, Yr)) {
          for (var Qr = !0, nn = 0; nn < B.length; nn++)
            if (Math.abs((Nr.dimensions[nn] || 0) - (L[Yr].dimensions[nn] || 0)) > 1e-12) {
              Qr = !1;
              break;
            }
          if (Qr) {
            Rr = !0, Nr.base = L[Yr];
            break;
          }
        }
      if (!Rr) {
        mr = mr || ne + "_STUFF";
        var on = {
          dimensions: $r.dimensions.slice(0)
        };
        on.key = mr, L[mr] = on, se[mr] = {
          unit: Nr,
          prefix: k.NONE[""]
        }, Nr.base = L[mr];
      }
    } else {
      if (mr = mr || ne + "_STUFF", B.indexOf(mr) >= 0)
        throw new Error('Cannot create new base unit "' + ne + '": a base unit with that name already exists (and cannot be overridden)');
      B.push(mr);
      for (var xr in L)
        (0, _object$k.hasOwnProperty)(L, xr) && (L[xr].dimensions[B.length - 1] = 0);
      for (var Er = {
        dimensions: []
      }, Ir = 0; Ir < B.length; Ir++)
        Er.dimensions[Ir] = 0;
      Er.dimensions[B.length - 1] = 1, Er.key = mr, L[mr] = Er, Nr = {
        name: ne,
        value: 1,
        dimensions: L[mr].dimensions.slice(0),
        prefixes: fr,
        offset: ze,
        base: L[mr]
      }, se[mr] = {
        unit: Nr,
        prefix: k.NONE[""]
      };
    }
    b.UNITS[ne] = Nr;
    for (var en = 0; en < Sr.length; en++) {
      var zr = Sr[en], Jr = {};
      for (var H in Nr)
        (0, _object$k.hasOwnProperty)(Nr, H) && (Jr[H] = Nr[H]);
      Jr.name = zr, b.UNITS[zr] = Jr;
    }
    return delete G.cache, new b(null, ne);
  }, b.deleteUnit = function(ne) {
    delete b.UNITS[ne];
  }, b.PREFIXES = k, b.BASE_DIMENSIONS = B, b.BASE_UNITS = L, b.UNIT_SYSTEMS = ee, b.UNITS = q, b;
}, {
  isClass: !0
});
Unit.createUnitClass = createUnitClass;
var unit$1 = {};
Object.defineProperty(unit$1, "__esModule", {
  value: !0
});
unit$1.createUnitFunction = void 0;
var _factory$28 = factory$1, _collection$y = collection$1, name$25 = "unit", dependencies$24 = ["typed", "Unit"], createUnitFunction = /* @__PURE__ */ (0, _factory$28.factory)(name$25, dependencies$24, function(t) {
  var r = t.typed, n = t.Unit;
  return r(name$25, {
    Unit: function(s) {
      return s.clone();
    },
    string: function(s) {
      return n.isValuelessUnit(s) ? new n(null, s) : n.parse(s, {
        allowNoUnits: !0
      });
    },
    "number | BigNumber | Fraction | Complex, string": function(s, o) {
      return new n(s, o);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$y.deepMap)(s, this);
    }
  });
});
unit$1.createUnitFunction = createUnitFunction;
var sparse$1 = {};
Object.defineProperty(sparse$1, "__esModule", {
  value: !0
});
sparse$1.createSparse = void 0;
var _factory$27 = factory$1, name$24 = "sparse", dependencies$23 = ["typed", "SparseMatrix"], createSparse = /* @__PURE__ */ (0, _factory$27.factory)(name$24, dependencies$23, function(t) {
  var r = t.typed, n = t.SparseMatrix;
  return r(name$24, {
    "": function() {
      return new n([]);
    },
    string: function(s) {
      return new n([], s);
    },
    "Array | Matrix": function(s) {
      return new n(s);
    },
    "Array | Matrix, string": function(s, o) {
      return new n(s, o);
    }
  });
});
sparse$1.createSparse = createSparse;
var createUnit$1 = {};
Object.defineProperty(createUnit$1, "__esModule", {
  value: !0
});
createUnit$1.createCreateUnit = void 0;
var _factory$26 = factory$1, name$23 = "createUnit", dependencies$22 = ["typed", "Unit"], createCreateUnit = /* @__PURE__ */ (0, _factory$26.factory)(name$23, dependencies$22, function(t) {
  var r = t.typed, n = t.Unit;
  return r(name$23, {
    // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
    "Object, Object": function(s, o) {
      return n.createUnit(s, o);
    },
    // Same as above but without the options.
    Object: function(s) {
      return n.createUnit(s, {});
    },
    // Shortcut method for creating one unit.
    "string, Unit | string | Object, Object": function(s, o, c) {
      var l = {};
      return l[s] = o, n.createUnit(l, c);
    },
    // Same as above but without the options.
    "string, Unit | string | Object": function(s, o) {
      var c = {};
      return c[s] = o, n.createUnit(c, {});
    },
    // Without a definition, creates a base unit.
    string: function(s) {
      var o = {};
      return o[s] = {}, n.createUnit(o, {});
    }
  });
});
createUnit$1.createCreateUnit = createCreateUnit;
var acos$1 = {};
Object.defineProperty(acos$1, "__esModule", {
  value: !0
});
acos$1.createAcos = void 0;
var _factory$25 = factory$1, _collection$x = collection$1, name$22 = "acos", dependencies$21 = ["typed", "config", "Complex"], createAcos = /* @__PURE__ */ (0, _factory$25.factory)(name$22, dependencies$21, function(t) {
  var r = t.typed, n = t.config, a = t.Complex;
  return r(name$22, {
    number: function(o) {
      return o >= -1 && o <= 1 || n.predictable ? Math.acos(o) : new a(o, 0).acos();
    },
    Complex: function(o) {
      return o.acos();
    },
    BigNumber: function(o) {
      return o.acos();
    },
    "Array | Matrix": function(o) {
      return (0, _collection$x.deepMap)(o, this);
    }
  });
});
acos$1.createAcos = createAcos;
var acosh$1 = {};
Object.defineProperty(acosh$1, "__esModule", {
  value: !0
});
acosh$1.createAcosh = void 0;
var _factory$24 = factory$1, _collection$w = collection$1, _index$i = number$2, name$21 = "acosh", dependencies$20 = ["typed", "config", "Complex"], createAcosh = /* @__PURE__ */ (0, _factory$24.factory)(name$21, dependencies$20, function(t) {
  var r = t.typed, n = t.config, a = t.Complex;
  return r(name$21, {
    number: function(o) {
      return o >= 1 || n.predictable ? (0, _index$i.acoshNumber)(o) : o <= -1 ? new a(Math.log(Math.sqrt(o * o - 1) - o), Math.PI) : new a(o, 0).acosh();
    },
    Complex: function(o) {
      return o.acosh();
    },
    BigNumber: function(o) {
      return o.acosh();
    },
    "Array | Matrix": function(o) {
      return (0, _collection$w.deepMap)(o, this);
    }
  });
});
acosh$1.createAcosh = createAcosh;
var acot$1 = {};
Object.defineProperty(acot$1, "__esModule", {
  value: !0
});
acot$1.createAcot = void 0;
var _factory$23 = factory$1, _collection$v = collection$1, _index$h = number$2, name$20 = "acot", dependencies$1$ = ["typed", "BigNumber"], createAcot = /* @__PURE__ */ (0, _factory$23.factory)(name$20, dependencies$1$, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$20, {
    number: _index$h.acotNumber,
    Complex: function(s) {
      return s.acot();
    },
    BigNumber: function(s) {
      return new n(1).div(s).atan();
    },
    "Array | Matrix": function(s) {
      return (0, _collection$v.deepMap)(s, this);
    }
  });
});
acot$1.createAcot = createAcot;
var acoth$1 = {};
Object.defineProperty(acoth$1, "__esModule", {
  value: !0
});
acoth$1.createAcoth = void 0;
var _factory$22 = factory$1, _collection$u = collection$1, _index$g = number$2, name$1$ = "acoth", dependencies$1_ = ["typed", "config", "Complex", "BigNumber"], createAcoth = /* @__PURE__ */ (0, _factory$22.factory)(name$1$, dependencies$1_, function(t) {
  var r = t.typed, n = t.config, a = t.Complex, s = t.BigNumber;
  return r(name$1$, {
    number: function(c) {
      return c >= 1 || c <= -1 || n.predictable ? (0, _index$g.acothNumber)(c) : new a(c, 0).acoth();
    },
    Complex: function(c) {
      return c.acoth();
    },
    BigNumber: function(c) {
      return new s(1).div(c).atanh();
    },
    "Array | Matrix": function(c) {
      return (0, _collection$u.deepMap)(c, this);
    }
  });
});
acoth$1.createAcoth = createAcoth;
var acsc$1 = {};
Object.defineProperty(acsc$1, "__esModule", {
  value: !0
});
acsc$1.createAcsc = void 0;
var _factory$21 = factory$1, _collection$t = collection$1, _index$f = number$2, name$1_ = "acsc", dependencies$1Z = ["typed", "config", "Complex", "BigNumber"], createAcsc = /* @__PURE__ */ (0, _factory$21.factory)(name$1_, dependencies$1Z, function(t) {
  var r = t.typed, n = t.config, a = t.Complex, s = t.BigNumber;
  return r(name$1_, {
    number: function(c) {
      return c <= -1 || c >= 1 || n.predictable ? (0, _index$f.acscNumber)(c) : new a(c, 0).acsc();
    },
    Complex: function(c) {
      return c.acsc();
    },
    BigNumber: function(c) {
      return new s(1).div(c).asin();
    },
    "Array | Matrix": function(c) {
      return (0, _collection$t.deepMap)(c, this);
    }
  });
});
acsc$1.createAcsc = createAcsc;
var acsch$1 = {};
Object.defineProperty(acsch$1, "__esModule", {
  value: !0
});
acsch$1.createAcsch = void 0;
var _factory$20 = factory$1, _collection$s = collection$1, _index$e = number$2, name$1Z = "acsch", dependencies$1Y = ["typed", "BigNumber"], createAcsch = /* @__PURE__ */ (0, _factory$20.factory)(name$1Z, dependencies$1Y, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$1Z, {
    number: _index$e.acschNumber,
    Complex: function(s) {
      return s.acsch();
    },
    BigNumber: function(s) {
      return new n(1).div(s).asinh();
    },
    "Array | Matrix": function(s) {
      return (0, _collection$s.deepMap)(s, this);
    }
  });
});
acsch$1.createAcsch = createAcsch;
var asec$1 = {};
Object.defineProperty(asec$1, "__esModule", {
  value: !0
});
asec$1.createAsec = void 0;
var _factory$1$ = factory$1, _collection$r = collection$1, _index$d = number$2, name$1Y = "asec", dependencies$1X = ["typed", "config", "Complex", "BigNumber"], createAsec = /* @__PURE__ */ (0, _factory$1$.factory)(name$1Y, dependencies$1X, function(t) {
  var r = t.typed, n = t.config, a = t.Complex, s = t.BigNumber;
  return r(name$1Y, {
    number: function(c) {
      return c <= -1 || c >= 1 || n.predictable ? (0, _index$d.asecNumber)(c) : new a(c, 0).asec();
    },
    Complex: function(c) {
      return c.asec();
    },
    BigNumber: function(c) {
      return new s(1).div(c).acos();
    },
    "Array | Matrix": function(c) {
      return (0, _collection$r.deepMap)(c, this);
    }
  });
});
asec$1.createAsec = createAsec;
var asech$1 = {};
Object.defineProperty(asech$1, "__esModule", {
  value: !0
});
asech$1.createAsech = void 0;
var _factory$1_ = factory$1, _collection$q = collection$1, _index$c = number$2, name$1X = "asech", dependencies$1W = ["typed", "config", "Complex", "BigNumber"], createAsech = /* @__PURE__ */ (0, _factory$1_.factory)(name$1X, dependencies$1W, function(t) {
  var r = t.typed, n = t.config, a = t.Complex, s = t.BigNumber;
  return r(name$1X, {
    number: function(c) {
      if (c <= 1 && c >= -1 || n.predictable) {
        var l = 1 / c;
        if (l > 0 || n.predictable)
          return (0, _index$c.asechNumber)(c);
        var d = Math.sqrt(l * l - 1);
        return new a(Math.log(d - l), Math.PI);
      }
      return new a(c, 0).asech();
    },
    Complex: function(c) {
      return c.asech();
    },
    BigNumber: function(c) {
      return new s(1).div(c).acosh();
    },
    "Array | Matrix": function(c) {
      return (0, _collection$q.deepMap)(c, this);
    }
  });
});
asech$1.createAsech = createAsech;
var asin$1 = {};
Object.defineProperty(asin$1, "__esModule", {
  value: !0
});
asin$1.createAsin = void 0;
var _factory$1Z = factory$1, _collection$p = collection$1, name$1W = "asin", dependencies$1V = ["typed", "config", "Complex"], createAsin = /* @__PURE__ */ (0, _factory$1Z.factory)(name$1W, dependencies$1V, function(t) {
  var r = t.typed, n = t.config, a = t.Complex;
  return r(name$1W, {
    number: function(o) {
      return o >= -1 && o <= 1 || n.predictable ? Math.asin(o) : new a(o, 0).asin();
    },
    Complex: function(o) {
      return o.asin();
    },
    BigNumber: function(o) {
      return o.asin();
    },
    "Array | Matrix": function(o) {
      return (0, _collection$p.deepMap)(o, this, !0);
    }
  });
});
asin$1.createAsin = createAsin;
var asinh$1 = {};
Object.defineProperty(asinh$1, "__esModule", {
  value: !0
});
asinh$1.createAsinh = void 0;
var _factory$1Y = factory$1, _collection$o = collection$1, _index$b = number$2, name$1V = "asinh", dependencies$1U = ["typed"], createAsinh = /* @__PURE__ */ (0, _factory$1Y.factory)(name$1V, dependencies$1U, function(t) {
  var r = t.typed;
  return r("asinh", {
    number: _index$b.asinhNumber,
    Complex: function(a) {
      return a.asinh();
    },
    BigNumber: function(a) {
      return a.asinh();
    },
    "Array | Matrix": function(a) {
      return (0, _collection$o.deepMap)(a, this, !0);
    }
  });
});
asinh$1.createAsinh = createAsinh;
var atan$1 = {};
Object.defineProperty(atan$1, "__esModule", {
  value: !0
});
atan$1.createAtan = void 0;
var _factory$1X = factory$1, _collection$n = collection$1, name$1U = "atan", dependencies$1T = ["typed"], createAtan = /* @__PURE__ */ (0, _factory$1X.factory)(name$1U, dependencies$1T, function(t) {
  var r = t.typed;
  return r("atan", {
    number: function(a) {
      return Math.atan(a);
    },
    Complex: function(a) {
      return a.atan();
    },
    BigNumber: function(a) {
      return a.atan();
    },
    "Array | Matrix": function(a) {
      return (0, _collection$n.deepMap)(a, this, !0);
    }
  });
});
atan$1.createAtan = createAtan;
var atan2$1 = {};
Object.defineProperty(atan2$1, "__esModule", {
  value: !0
});
atan2$1.createAtan2 = void 0;
var _factory$1W = factory$1, _algorithm$2 = algorithm02, _algorithm2$2 = algorithm03, _algorithm3$1 = algorithm09, _algorithm4$1 = algorithm11, _algorithm5$1 = algorithm12, _algorithm6 = algorithm13, _algorithm7 = algorithm14, name$1T = "atan2", dependencies$1S = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix"], createAtan2 = /* @__PURE__ */ (0, _factory$1W.factory)(name$1T, dependencies$1S, function(t) {
  var r = t.typed, n = t.matrix, a = t.equalScalar, s = t.BigNumber, o = t.DenseMatrix, c = (0, _algorithm$2.createAlgorithm02)({
    typed: r,
    equalScalar: a
  }), l = (0, _algorithm2$2.createAlgorithm03)({
    typed: r
  }), d = (0, _algorithm3$1.createAlgorithm09)({
    typed: r,
    equalScalar: a
  }), h = (0, _algorithm4$1.createAlgorithm11)({
    typed: r,
    equalScalar: a
  }), u = (0, _algorithm5$1.createAlgorithm12)({
    typed: r,
    DenseMatrix: o
  }), p = (0, _algorithm6.createAlgorithm13)({
    typed: r
  }), m = (0, _algorithm7.createAlgorithm14)({
    typed: r
  });
  return r(name$1T, {
    "number, number": Math.atan2,
    // Complex numbers doesn't seem to have a reasonable implementation of
    // atan2(). Even Matlab removed the support, after they only calculated
    // the atan only on base of the real part of the numbers and ignored the imaginary.
    "BigNumber, BigNumber": function(v, y) {
      return s.atan2(v, y);
    },
    "SparseMatrix, SparseMatrix": function(v, y) {
      return d(v, y, this, !1);
    },
    "SparseMatrix, DenseMatrix": function(v, y) {
      return c(y, v, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(v, y) {
      return l(v, y, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(v, y) {
      return p(v, y, this);
    },
    "Array, Array": function(v, y) {
      return this(n(v), n(y)).valueOf();
    },
    "Array, Matrix": function(v, y) {
      return this(n(v), y);
    },
    "Matrix, Array": function(v, y) {
      return this(v, n(y));
    },
    "SparseMatrix, number | BigNumber": function(v, y) {
      return h(v, y, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(v, y) {
      return m(v, y, this, !1);
    },
    "number | BigNumber, SparseMatrix": function(v, y) {
      return u(y, v, this, !0);
    },
    "number | BigNumber, DenseMatrix": function(v, y) {
      return m(y, v, this, !0);
    },
    "Array, number | BigNumber": function(v, y) {
      return m(n(v), y, this, !1).valueOf();
    },
    "number | BigNumber, Array": function(v, y) {
      return m(n(y), v, this, !0).valueOf();
    }
  });
});
atan2$1.createAtan2 = createAtan2;
var atanh$1 = {};
Object.defineProperty(atanh$1, "__esModule", {
  value: !0
});
atanh$1.createAtanh = void 0;
var _factory$1V = factory$1, _collection$m = collection$1, _index$a = number$2, name$1S = "atanh", dependencies$1R = ["typed", "config", "Complex"], createAtanh = /* @__PURE__ */ (0, _factory$1V.factory)(name$1S, dependencies$1R, function(t) {
  var r = t.typed, n = t.config, a = t.Complex;
  return r(name$1S, {
    number: function(o) {
      return o <= 1 && o >= -1 || n.predictable ? (0, _index$a.atanhNumber)(o) : new a(o, 0).atanh();
    },
    Complex: function(o) {
      return o.atanh();
    },
    BigNumber: function(o) {
      return o.atanh();
    },
    "Array | Matrix": function(o) {
      return (0, _collection$m.deepMap)(o, this, !0);
    }
  });
});
atanh$1.createAtanh = createAtanh;
var cos$1 = {};
Object.defineProperty(cos$1, "__esModule", {
  value: !0
});
cos$1.createCos = void 0;
var _factory$1U = factory$1, _collection$l = collection$1, name$1R = "cos", dependencies$1Q = ["typed"], createCos = /* @__PURE__ */ (0, _factory$1U.factory)(name$1R, dependencies$1Q, function(t) {
  var r = t.typed;
  return r(name$1R, {
    number: Math.cos,
    Complex: function(a) {
      return a.cos();
    },
    BigNumber: function(a) {
      return a.cos();
    },
    Unit: function(a) {
      if (!a.hasBase(a.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function cos is no angle");
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$l.deepMap)(a, this);
    }
  });
});
cos$1.createCos = createCos;
var cosh$1 = {};
Object.defineProperty(cosh$1, "__esModule", {
  value: !0
});
cosh$1.createCosh = void 0;
var _factory$1T = factory$1, _collection$k = collection$1, _number$7 = number$3, name$1Q = "cosh", dependencies$1P = ["typed"], createCosh = /* @__PURE__ */ (0, _factory$1T.factory)(name$1Q, dependencies$1P, function(t) {
  var r = t.typed;
  return r(name$1Q, {
    number: _number$7.cosh,
    Complex: function(a) {
      return a.cosh();
    },
    BigNumber: function(a) {
      return a.cosh();
    },
    Unit: function(a) {
      if (!a.hasBase(a.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function cosh is no angle");
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$k.deepMap)(a, this);
    }
  });
});
cosh$1.createCosh = createCosh;
var cot$1 = {};
Object.defineProperty(cot$1, "__esModule", {
  value: !0
});
cot$1.createCot = void 0;
var _factory$1S = factory$1, _collection$j = collection$1, _index$9 = number$2, name$1P = "cot", dependencies$1O = ["typed", "BigNumber"], createCot = /* @__PURE__ */ (0, _factory$1S.factory)(name$1P, dependencies$1O, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$1P, {
    number: _index$9.cotNumber,
    Complex: function(s) {
      return s.cot();
    },
    BigNumber: function(s) {
      return new n(1).div(s.tan());
    },
    Unit: function(s) {
      if (!s.hasBase(s.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function cot is no angle");
      return this(s.value);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$j.deepMap)(s, this);
    }
  });
});
cot$1.createCot = createCot;
var coth$1 = {};
Object.defineProperty(coth$1, "__esModule", {
  value: !0
});
coth$1.createCoth = void 0;
var _factory$1R = factory$1, _collection$i = collection$1, _index$8 = number$2, name$1O = "coth", dependencies$1N = ["typed", "BigNumber"], createCoth = /* @__PURE__ */ (0, _factory$1R.factory)(name$1O, dependencies$1N, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$1O, {
    number: _index$8.cothNumber,
    Complex: function(s) {
      return s.coth();
    },
    BigNumber: function(s) {
      return new n(1).div(s.tanh());
    },
    Unit: function(s) {
      if (!s.hasBase(s.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function coth is no angle");
      return this(s.value);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$i.deepMap)(s, this);
    }
  });
});
coth$1.createCoth = createCoth;
var csc$1 = {};
Object.defineProperty(csc$1, "__esModule", {
  value: !0
});
csc$1.createCsc = void 0;
var _factory$1Q = factory$1, _collection$h = collection$1, _index$7 = number$2, name$1N = "csc", dependencies$1M = ["typed", "BigNumber"], createCsc = /* @__PURE__ */ (0, _factory$1Q.factory)(name$1N, dependencies$1M, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$1N, {
    number: _index$7.cscNumber,
    Complex: function(s) {
      return s.csc();
    },
    BigNumber: function(s) {
      return new n(1).div(s.sin());
    },
    Unit: function(s) {
      if (!s.hasBase(s.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function csc is no angle");
      return this(s.value);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$h.deepMap)(s, this);
    }
  });
});
csc$1.createCsc = createCsc;
var csch$1 = {};
Object.defineProperty(csch$1, "__esModule", {
  value: !0
});
csch$1.createCsch = void 0;
var _factory$1P = factory$1, _collection$g = collection$1, _index$6 = number$2, name$1M = "csch", dependencies$1L = ["typed", "BigNumber"], createCsch = /* @__PURE__ */ (0, _factory$1P.factory)(name$1M, dependencies$1L, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$1M, {
    number: _index$6.cschNumber,
    Complex: function(s) {
      return s.csch();
    },
    BigNumber: function(s) {
      return new n(1).div(s.sinh());
    },
    Unit: function(s) {
      if (!s.hasBase(s.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function csch is no angle");
      return this(s.value);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$g.deepMap)(s, this);
    }
  });
});
csch$1.createCsch = createCsch;
var sec$1 = {};
Object.defineProperty(sec$1, "__esModule", {
  value: !0
});
sec$1.createSec = void 0;
var _factory$1O = factory$1, _collection$f = collection$1, _index$5 = number$2, name$1L = "sec", dependencies$1K = ["typed", "BigNumber"], createSec = /* @__PURE__ */ (0, _factory$1O.factory)(name$1L, dependencies$1K, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$1L, {
    number: _index$5.secNumber,
    Complex: function(s) {
      return s.sec();
    },
    BigNumber: function(s) {
      return new n(1).div(s.cos());
    },
    Unit: function(s) {
      if (!s.hasBase(s.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function sec is no angle");
      return this(s.value);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$f.deepMap)(s, this);
    }
  });
});
sec$1.createSec = createSec;
var sech$1 = {};
Object.defineProperty(sech$1, "__esModule", {
  value: !0
});
sech$1.createSech = void 0;
var _factory$1N = factory$1, _collection$e = collection$1, _index$4 = number$2, name$1K = "sech", dependencies$1J = ["typed", "BigNumber"], createSech = /* @__PURE__ */ (0, _factory$1N.factory)(name$1K, dependencies$1J, function(t) {
  var r = t.typed, n = t.BigNumber;
  return r(name$1K, {
    number: _index$4.sechNumber,
    Complex: function(s) {
      return s.sech();
    },
    BigNumber: function(s) {
      return new n(1).div(s.cosh());
    },
    Unit: function(s) {
      if (!s.hasBase(s.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function sech is no angle");
      return this(s.value);
    },
    "Array | Matrix": function(s) {
      return (0, _collection$e.deepMap)(s, this);
    }
  });
});
sech$1.createSech = createSech;
var sin$1 = {};
Object.defineProperty(sin$1, "__esModule", {
  value: !0
});
sin$1.createSin = void 0;
var _factory$1M = factory$1, _collection$d = collection$1, name$1J = "sin", dependencies$1I = ["typed"], createSin = /* @__PURE__ */ (0, _factory$1M.factory)(name$1J, dependencies$1I, function(t) {
  var r = t.typed;
  return r(name$1J, {
    number: Math.sin,
    Complex: function(a) {
      return a.sin();
    },
    BigNumber: function(a) {
      return a.sin();
    },
    Unit: function(a) {
      if (!a.hasBase(a.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function sin is no angle");
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$d.deepMap)(a, this, !0);
    }
  });
});
sin$1.createSin = createSin;
var sinh$1 = {};
Object.defineProperty(sinh$1, "__esModule", {
  value: !0
});
sinh$1.createSinh = void 0;
var _factory$1L = factory$1, _collection$c = collection$1, _index$3 = number$2, name$1I = "sinh", dependencies$1H = ["typed"], createSinh = /* @__PURE__ */ (0, _factory$1L.factory)(name$1I, dependencies$1H, function(t) {
  var r = t.typed;
  return r(name$1I, {
    number: _index$3.sinhNumber,
    Complex: function(a) {
      return a.sinh();
    },
    BigNumber: function(a) {
      return a.sinh();
    },
    Unit: function(a) {
      if (!a.hasBase(a.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function sinh is no angle");
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$c.deepMap)(a, this, !0);
    }
  });
});
sinh$1.createSinh = createSinh;
var tan$1 = {};
Object.defineProperty(tan$1, "__esModule", {
  value: !0
});
tan$1.createTan = void 0;
var _factory$1K = factory$1, _collection$b = collection$1, name$1H = "tan", dependencies$1G = ["typed"], createTan = /* @__PURE__ */ (0, _factory$1K.factory)(name$1H, dependencies$1G, function(t) {
  var r = t.typed;
  return r(name$1H, {
    number: Math.tan,
    Complex: function(a) {
      return a.tan();
    },
    BigNumber: function(a) {
      return a.tan();
    },
    Unit: function(a) {
      if (!a.hasBase(a.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function tan is no angle");
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$b.deepMap)(a, this, !0);
    }
  });
});
tan$1.createTan = createTan;
var tanh$1 = {};
Object.defineProperty(tanh$1, "__esModule", {
  value: !0
});
tanh$1.createTanh = void 0;
var _factory$1J = factory$1, _collection$a = collection$1, _number$6 = number$3, name$1G = "tanh", dependencies$1F = ["typed"], createTanh = /* @__PURE__ */ (0, _factory$1J.factory)(name$1G, dependencies$1F, function(t) {
  var r = t.typed;
  return r("tanh", {
    number: _number$6.tanh,
    Complex: function(a) {
      return a.tanh();
    },
    BigNumber: function(a) {
      return a.tanh();
    },
    Unit: function(a) {
      if (!a.hasBase(a.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function tanh is no angle");
      return this(a.value);
    },
    "Array | Matrix": function(a) {
      return (0, _collection$a.deepMap)(a, this, !0);
    }
  });
});
tanh$1.createTanh = createTanh;
var setCartesian$1 = {};
Object.defineProperty(setCartesian$1, "__esModule", {
  value: !0
});
setCartesian$1.createSetCartesian = void 0;
var _array$r = array, _factory$1I = factory$1, name$1F = "setCartesian", dependencies$1E = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetCartesian = /* @__PURE__ */ (0, _factory$1I.factory)(name$1F, dependencies$1E, function(t) {
  var r = t.typed, n = t.size, a = t.subset, s = t.compareNatural, o = t.Index, c = t.DenseMatrix;
  return r(name$1F, {
    "Array | Matrix, Array | Matrix": function(d, h) {
      var u = [];
      if (a(n(d), new o(0)) !== 0 && a(n(h), new o(0)) !== 0) {
        var p = (0, _array$r.flatten)(Array.isArray(d) ? d : d.toArray()).sort(s), m = (0, _array$r.flatten)(Array.isArray(h) ? h : h.toArray()).sort(s);
        u = [];
        for (var g = 0; g < p.length; g++)
          for (var v = 0; v < m.length; v++)
            u.push([p[g], m[v]]);
      }
      return Array.isArray(d) && Array.isArray(h) ? u : new c(u);
    }
  });
});
setCartesian$1.createSetCartesian = createSetCartesian;
var setDifference$1 = {};
Object.defineProperty(setDifference$1, "__esModule", {
  value: !0
});
setDifference$1.createSetDifference = void 0;
var _array$q = array, _factory$1H = factory$1, name$1E = "setDifference", dependencies$1D = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDifference = /* @__PURE__ */ (0, _factory$1H.factory)(name$1E, dependencies$1D, function(t) {
  var r = t.typed, n = t.size, a = t.subset, s = t.compareNatural, o = t.Index, c = t.DenseMatrix;
  return r(name$1E, {
    "Array | Matrix, Array | Matrix": function(d, h) {
      var u;
      if (a(n(d), new o(0)) === 0)
        u = [];
      else {
        if (a(n(h), new o(0)) === 0)
          return (0, _array$q.flatten)(d.toArray());
        var p = (0, _array$q.identify)((0, _array$q.flatten)(Array.isArray(d) ? d : d.toArray()).sort(s)), m = (0, _array$q.identify)((0, _array$q.flatten)(Array.isArray(h) ? h : h.toArray()).sort(s));
        u = [];
        for (var g, v = 0; v < p.length; v++) {
          g = !1;
          for (var y = 0; y < m.length; y++)
            if (s(p[v].value, m[y].value) === 0 && p[v].identifier === m[y].identifier) {
              g = !0;
              break;
            }
          g || u.push(p[v]);
        }
      }
      return Array.isArray(d) && Array.isArray(h) ? (0, _array$q.generalize)(u) : new c((0, _array$q.generalize)(u));
    }
  });
});
setDifference$1.createSetDifference = createSetDifference;
var setDistinct$1 = {};
Object.defineProperty(setDistinct$1, "__esModule", {
  value: !0
});
setDistinct$1.createSetDistinct = void 0;
var _array$p = array, _factory$1G = factory$1, name$1D = "setDistinct", dependencies$1C = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDistinct = /* @__PURE__ */ (0, _factory$1G.factory)(name$1D, dependencies$1C, function(t) {
  var r = t.typed, n = t.size, a = t.subset, s = t.compareNatural, o = t.Index, c = t.DenseMatrix;
  return r(name$1D, {
    "Array | Matrix": function(d) {
      var h;
      if (a(n(d), new o(0)) === 0)
        h = [];
      else {
        var u = (0, _array$p.flatten)(Array.isArray(d) ? d : d.toArray()).sort(s);
        h = [], h.push(u[0]);
        for (var p = 1; p < u.length; p++)
          s(u[p], u[p - 1]) !== 0 && h.push(u[p]);
      }
      return Array.isArray(d) ? h : new c(h);
    }
  });
});
setDistinct$1.createSetDistinct = createSetDistinct;
var setIntersect$1 = {};
Object.defineProperty(setIntersect$1, "__esModule", {
  value: !0
});
setIntersect$1.createSetIntersect = void 0;
var _array$o = array, _factory$1F = factory$1, name$1C = "setIntersect", dependencies$1B = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetIntersect = /* @__PURE__ */ (0, _factory$1F.factory)(name$1C, dependencies$1B, function(t) {
  var r = t.typed, n = t.size, a = t.subset, s = t.compareNatural, o = t.Index, c = t.DenseMatrix;
  return r(name$1C, {
    "Array | Matrix, Array | Matrix": function(d, h) {
      var u;
      if (a(n(d), new o(0)) === 0 || a(n(h), new o(0)) === 0)
        u = [];
      else {
        var p = (0, _array$o.identify)((0, _array$o.flatten)(Array.isArray(d) ? d : d.toArray()).sort(s)), m = (0, _array$o.identify)((0, _array$o.flatten)(Array.isArray(h) ? h : h.toArray()).sort(s));
        u = [];
        for (var g = 0; g < p.length; g++)
          for (var v = 0; v < m.length; v++)
            if (s(p[g].value, m[v].value) === 0 && p[g].identifier === m[v].identifier) {
              u.push(p[g]);
              break;
            }
      }
      return Array.isArray(d) && Array.isArray(h) ? (0, _array$o.generalize)(u) : new c((0, _array$o.generalize)(u));
    }
  });
});
setIntersect$1.createSetIntersect = createSetIntersect;
var setIsSubset$1 = {};
Object.defineProperty(setIsSubset$1, "__esModule", {
  value: !0
});
setIsSubset$1.createSetIsSubset = void 0;
var _array$n = array, _factory$1E = factory$1, name$1B = "setIsSubset", dependencies$1A = ["typed", "size", "subset", "compareNatural", "Index"], createSetIsSubset = /* @__PURE__ */ (0, _factory$1E.factory)(name$1B, dependencies$1A, function(t) {
  var r = t.typed, n = t.size, a = t.subset, s = t.compareNatural, o = t.Index;
  return r(name$1B, {
    "Array | Matrix, Array | Matrix": function(l, d) {
      if (a(n(l), new o(0)) === 0)
        return !0;
      if (a(n(d), new o(0)) === 0)
        return !1;
      for (var h = (0, _array$n.identify)((0, _array$n.flatten)(Array.isArray(l) ? l : l.toArray()).sort(s)), u = (0, _array$n.identify)((0, _array$n.flatten)(Array.isArray(d) ? d : d.toArray()).sort(s)), p, m = 0; m < h.length; m++) {
        p = !1;
        for (var g = 0; g < u.length; g++)
          if (s(h[m].value, u[g].value) === 0 && h[m].identifier === u[g].identifier) {
            p = !0;
            break;
          }
        if (p === !1)
          return !1;
      }
      return !0;
    }
  });
});
setIsSubset$1.createSetIsSubset = createSetIsSubset;
var setMultiplicity$1 = {};
Object.defineProperty(setMultiplicity$1, "__esModule", {
  value: !0
});
setMultiplicity$1.createSetMultiplicity = void 0;
var _array$m = array, _factory$1D = factory$1, name$1A = "setMultiplicity", dependencies$1z = ["typed", "size", "subset", "compareNatural", "Index"], createSetMultiplicity = /* @__PURE__ */ (0, _factory$1D.factory)(name$1A, dependencies$1z, function(t) {
  var r = t.typed, n = t.size, a = t.subset, s = t.compareNatural, o = t.Index;
  return r(name$1A, {
    "number | BigNumber | Fraction | Complex, Array | Matrix": function(l, d) {
      if (a(n(d), new o(0)) === 0)
        return 0;
      for (var h = (0, _array$m.flatten)(Array.isArray(d) ? d : d.toArray()), u = 0, p = 0; p < h.length; p++)
        s(h[p], l) === 0 && u++;
      return u;
    }
  });
});
setMultiplicity$1.createSetMultiplicity = createSetMultiplicity;
var setPowerset$1 = {};
Object.defineProperty(setPowerset$1, "__esModule", {
  value: !0
});
setPowerset$1.createSetPowerset = void 0;
var _array$l = array, _factory$1C = factory$1, name$1z = "setPowerset", dependencies$1y = ["typed", "size", "subset", "compareNatural", "Index"], createSetPowerset = /* @__PURE__ */ (0, _factory$1C.factory)(name$1z, dependencies$1y, function(t) {
  var r = t.typed, n = t.size, a = t.subset, s = t.compareNatural, o = t.Index;
  return r(name$1z, {
    "Array | Matrix": function(h) {
      if (a(n(h), new o(0)) === 0)
        return [];
      for (var u = (0, _array$l.flatten)(Array.isArray(h) ? h : h.toArray()).sort(s), p = [], m = 0; m.toString(2).length <= u.length; )
        p.push(c(u, m.toString(2).split("").reverse())), m++;
      return l(p);
    }
  });
  function c(d, h) {
    for (var u = [], p = 0; p < h.length; p++)
      h[p] === "1" && u.push(d[p]);
    return u;
  }
  function l(d) {
    for (var h = [], u = d.length - 1; u > 0; u--)
      for (var p = 0; p < u; p++)
        d[p].length > d[p + 1].length && (h = d[p], d[p] = d[p + 1], d[p + 1] = h);
    return d;
  }
});
setPowerset$1.createSetPowerset = createSetPowerset;
var setSize$1 = {};
Object.defineProperty(setSize$1, "__esModule", {
  value: !0
});
setSize$1.createSetSize = void 0;
var _array$k = array, _factory$1B = factory$1, name$1y = "setSize", dependencies$1x = ["typed", "compareNatural"], createSetSize = /* @__PURE__ */ (0, _factory$1B.factory)(name$1y, dependencies$1x, function(t) {
  var r = t.typed, n = t.compareNatural;
  return r(name$1y, {
    "Array | Matrix": function(s) {
      return Array.isArray(s) ? (0, _array$k.flatten)(s).length : (0, _array$k.flatten)(s.toArray()).length;
    },
    "Array | Matrix, boolean": function(s, o) {
      if (o === !1 || s.length === 0)
        return Array.isArray(s) ? (0, _array$k.flatten)(s).length : (0, _array$k.flatten)(s.toArray()).length;
      for (var c = (0, _array$k.flatten)(Array.isArray(s) ? s : s.toArray()).sort(n), l = 1, d = 1; d < c.length; d++)
        n(c[d], c[d - 1]) !== 0 && l++;
      return l;
    }
  });
});
setSize$1.createSetSize = createSetSize;
var setSymDifference$1 = {};
Object.defineProperty(setSymDifference$1, "__esModule", {
  value: !0
});
setSymDifference$1.createSetSymDifference = void 0;
var _array$j = array, _factory$1A = factory$1, name$1x = "setSymDifference", dependencies$1w = ["typed", "size", "concat", "subset", "setDifference", "Index"], createSetSymDifference = /* @__PURE__ */ (0, _factory$1A.factory)(name$1x, dependencies$1w, function(t) {
  var r = t.typed, n = t.size, a = t.concat, s = t.subset, o = t.setDifference, c = t.Index;
  return r(name$1x, {
    "Array | Matrix, Array | Matrix": function(d, h) {
      if (s(n(d), new c(0)) === 0)
        return (0, _array$j.flatten)(h);
      if (s(n(h), new c(0)) === 0)
        return (0, _array$j.flatten)(d);
      var u = (0, _array$j.flatten)(d), p = (0, _array$j.flatten)(h);
      return a(o(u, p), o(p, u));
    }
  });
});
setSymDifference$1.createSetSymDifference = createSetSymDifference;
var setUnion$1 = {};
Object.defineProperty(setUnion$1, "__esModule", {
  value: !0
});
setUnion$1.createSetUnion = void 0;
var _array$i = array, _factory$1z = factory$1, name$1w = "setUnion", dependencies$1v = ["typed", "size", "concat", "subset", "setIntersect", "setSymDifference", "Index"], createSetUnion = /* @__PURE__ */ (0, _factory$1z.factory)(name$1w, dependencies$1v, function(t) {
  var r = t.typed, n = t.size, a = t.concat, s = t.subset, o = t.setIntersect, c = t.setSymDifference, l = t.Index;
  return r(name$1w, {
    "Array | Matrix, Array | Matrix": function(h, u) {
      if (s(n(h), new l(0)) === 0)
        return (0, _array$i.flatten)(u);
      if (s(n(u), new l(0)) === 0)
        return (0, _array$i.flatten)(h);
      var p = (0, _array$i.flatten)(h), m = (0, _array$i.flatten)(u);
      return a(c(p, m), o(p, m));
    }
  });
});
setUnion$1.createSetUnion = createSetUnion;
var add$3 = {};
Object.defineProperty(add$3, "__esModule", {
  value: !0
});
add$3.createAdd = void 0;
var _factory$1y = factory$1, _object$j = object, _algorithm$1 = algorithm01, _algorithm2$1 = algorithm04, _algorithm3 = algorithm10, _algorithm4 = algorithm13, _algorithm5 = algorithm14, name$1v = "add", dependencies$1u = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix"], createAdd = /* @__PURE__ */ (0, _factory$1y.factory)(name$1v, dependencies$1u, function(t) {
  var r = t.typed, n = t.matrix, a = t.addScalar, s = t.equalScalar, o = t.DenseMatrix;
  t.SparseMatrix;
  var c = (0, _algorithm$1.createAlgorithm01)({
    typed: r
  }), l = (0, _algorithm2$1.createAlgorithm04)({
    typed: r,
    equalScalar: s
  }), d = (0, _algorithm3.createAlgorithm10)({
    typed: r,
    DenseMatrix: o
  }), h = (0, _algorithm4.createAlgorithm13)({
    typed: r
  }), u = (0, _algorithm5.createAlgorithm14)({
    typed: r
  });
  return r(name$1v, (0, _object$j.extend)({
    // we extend the signatures of addScalar with signatures dealing with matrices
    "DenseMatrix, DenseMatrix": function(m, g) {
      return h(m, g, a);
    },
    "DenseMatrix, SparseMatrix": function(m, g) {
      return c(m, g, a, !1);
    },
    "SparseMatrix, DenseMatrix": function(m, g) {
      return c(g, m, a, !0);
    },
    "SparseMatrix, SparseMatrix": function(m, g) {
      return l(m, g, a);
    },
    "Array, Array": function(m, g) {
      return this(n(m), n(g)).valueOf();
    },
    "Array, Matrix": function(m, g) {
      return this(n(m), g);
    },
    "Matrix, Array": function(m, g) {
      return this(m, n(g));
    },
    "DenseMatrix, any": function(m, g) {
      return u(m, g, a, !1);
    },
    "SparseMatrix, any": function(m, g) {
      return d(m, g, a, !1);
    },
    "any, DenseMatrix": function(m, g) {
      return u(g, m, a, !0);
    },
    "any, SparseMatrix": function(m, g) {
      return d(g, m, a, !0);
    },
    "Array, any": function(m, g) {
      return u(n(m), g, a, !1).valueOf();
    },
    "any, Array": function(m, g) {
      return u(n(g), m, a, !0).valueOf();
    },
    "any, any": a,
    "any, any, ...any": function(m, g, v) {
      for (var y = this(m, g), x = 0; x < v.length; x++)
        y = this(y, v[x]);
      return y;
    }
  }, a.signatures));
});
add$3.createAdd = createAdd;
var hypot$1 = {};
Object.defineProperty(hypot$1, "__esModule", {
  value: !0
});
hypot$1.createHypot = void 0;
var _factory$1x = factory$1, _array$h = array, name$1u = "hypot", dependencies$1t = ["typed", "abs", "addScalar", "divideScalar", "multiplyScalar", "sqrt", "smaller", "isPositive"], createHypot = /* @__PURE__ */ (0, _factory$1x.factory)(name$1u, dependencies$1t, function(t) {
  var r = t.typed, n = t.abs, a = t.addScalar, s = t.divideScalar, o = t.multiplyScalar, c = t.sqrt, l = t.smaller, d = t.isPositive;
  return r(name$1u, {
    "... number | BigNumber": h,
    Array: function(p) {
      return this.apply(this, (0, _array$h.flatten)(p));
    },
    Matrix: function(p) {
      return this.apply(this, (0, _array$h.flatten)(p.toArray()));
    }
  });
  function h(u) {
    for (var p = 0, m = 0, g = 0; g < u.length; g++) {
      var v = n(u[g]);
      l(m, v) ? (p = o(p, o(s(m, v), s(m, v))), p = a(p, 1), m = v) : p = a(p, d(v) ? o(s(v, m), s(v, m)) : v);
    }
    return o(m, c(p));
  }
});
hypot$1.createHypot = createHypot;
var norm$1 = {};
Object.defineProperty(norm$1, "__esModule", {
  value: !0
});
norm$1.createNorm = void 0;
var _factory$1w = factory$1, name$1t = "norm", dependencies$1s = ["typed", "abs", "add", "pow", "conj", "sqrt", "multiply", "equalScalar", "larger", "smaller", "matrix", "ctranspose", "eigs"], createNorm = /* @__PURE__ */ (0, _factory$1w.factory)(name$1t, dependencies$1s, function(t) {
  var r = t.typed, n = t.abs, a = t.add, s = t.pow, o = t.conj, c = t.sqrt, l = t.multiply, d = t.equalScalar, h = t.larger, u = t.smaller, p = t.matrix, m = t.ctranspose, g = t.eigs;
  return r(name$1t, {
    number: Math.abs,
    Complex: function(D) {
      return D.abs();
    },
    BigNumber: function(D) {
      return D.abs();
    },
    boolean: function(D) {
      return Math.abs(D);
    },
    Array: function(D) {
      return S(p(D), 2);
    },
    Matrix: function(D) {
      return S(D, 2);
    },
    "number | Complex | BigNumber | boolean, number | BigNumber | string": function(D) {
      return this(D);
    },
    "Array, number | BigNumber | string": function(D, N) {
      return S(p(D), N);
    },
    "Matrix, number | BigNumber | string": function(D, N) {
      return S(D, N);
    }
  });
  function v(A) {
    var D = 0;
    return A.forEach(function(N) {
      var T = n(N);
      h(T, D) && (D = T);
    }, !0), D;
  }
  function y(A) {
    var D;
    return A.forEach(function(N) {
      var T = n(N);
      (!D || u(T, D)) && (D = T);
    }, !0), D || 0;
  }
  function x(A, D) {
    if (D === Number.POSITIVE_INFINITY || D === "inf")
      return v(A);
    if (D === Number.NEGATIVE_INFINITY || D === "-inf")
      return y(A);
    if (D === "fro")
      return S(A, 2);
    if (typeof D == "number" && !isNaN(D)) {
      if (!d(D, 0)) {
        var N = 0;
        return A.forEach(function(T) {
          N = a(s(n(T), D), N);
        }, !0), s(N, 1 / D);
      }
      return Number.POSITIVE_INFINITY;
    }
    throw new Error("Unsupported parameter value");
  }
  function _(A) {
    var D = 0;
    return A.forEach(function(N, T) {
      D = a(D, l(N, o(N)));
    }), n(c(D));
  }
  function $(A) {
    var D = [], N = 0;
    return A.forEach(function(T, R) {
      var F = R[1], z = a(D[F] || 0, n(T));
      h(z, N) && (N = z), D[F] = z;
    }, !0), N;
  }
  function b(A) {
    var D = A.size();
    if (D[0] !== D[1])
      throw new RangeError("Invalid matrix dimensions");
    var N = m(A), T = l(N, A), R = g(T).values, F = R.get([R.size()[0] - 1]);
    return n(c(F));
  }
  function M(A) {
    var D = [], N = 0;
    return A.forEach(function(T, R) {
      var F = R[0], z = a(D[F] || 0, n(T));
      h(z, N) && (N = z), D[F] = z;
    }, !0), N;
  }
  function C(A, D) {
    if (D === 1)
      return $(A);
    if (D === Number.POSITIVE_INFINITY || D === "inf")
      return M(A);
    if (D === "fro")
      return _(A);
    if (D === 2)
      return b(A);
    throw new Error("Unsupported parameter value " + D);
  }
  function S(A, D) {
    var N = A.size();
    if (N.length === 1)
      return x(A, D);
    if (N.length === 2) {
      if (N[0] && N[1])
        return C(A, D);
      throw new RangeError("Invalid matrix dimensions");
    }
  }
});
norm$1.createNorm = createNorm;
var dot$1 = {};
Object.defineProperty(dot$1, "__esModule", {
  value: !0
});
dot$1.createDot = void 0;
var _factory$1v = factory$1, _is$S = is, name$1s = "dot", dependencies$1r = ["typed", "addScalar", "multiplyScalar", "conj", "size"], createDot = /* @__PURE__ */ (0, _factory$1v.factory)(name$1s, dependencies$1r, function(t) {
  var r = t.typed, n = t.addScalar, a = t.multiplyScalar, s = t.conj, o = t.size;
  return r(name$1s, {
    "Array | DenseMatrix, Array | DenseMatrix": l,
    "SparseMatrix, SparseMatrix": d
  });
  function c(u, p) {
    var m = h(u), g = h(p), v, y;
    if (m.length === 1)
      v = m[0];
    else if (m.length === 2 && m[1] === 1)
      v = m[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + m.join(", ") + ")");
    if (g.length === 1)
      y = g[0];
    else if (g.length === 2 && g[1] === 1)
      y = g[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + g.join(", ") + ")");
    if (v !== y)
      throw new RangeError("Vectors must have equal length (" + v + " != " + y + ")");
    if (v === 0)
      throw new RangeError("Cannot calculate the dot product of empty vectors");
    return v;
  }
  function l(u, p) {
    var m = c(u, p), g = (0, _is$S.isMatrix)(u) ? u._data : u, v = (0, _is$S.isMatrix)(u) ? u._datatype : void 0, y = (0, _is$S.isMatrix)(p) ? p._data : p, x = (0, _is$S.isMatrix)(p) ? p._datatype : void 0, _ = h(u).length === 2, $ = h(p).length === 2, b = n, M = a;
    if (v && x && v === x && typeof v == "string") {
      var C = v;
      b = r.find(n, [C, C]), M = r.find(a, [C, C]);
    }
    if (!_ && !$) {
      for (var S = M(s(g[0]), y[0]), A = 1; A < m; A++)
        S = b(S, M(s(g[A]), y[A]));
      return S;
    }
    if (!_ && $) {
      for (var D = M(s(g[0]), y[0][0]), N = 1; N < m; N++)
        D = b(D, M(s(g[N]), y[N][0]));
      return D;
    }
    if (_ && !$) {
      for (var T = M(s(g[0][0]), y[0]), R = 1; R < m; R++)
        T = b(T, M(s(g[R][0]), y[R]));
      return T;
    }
    if (_ && $) {
      for (var F = M(s(g[0][0]), y[0][0]), z = 1; z < m; z++)
        F = b(F, M(s(g[z][0]), y[z][0]));
      return F;
    }
  }
  function d(u, p) {
    c(u, p);
    for (var m = u._index, g = u._values, v = p._index, y = p._values, x = 0, _ = n, $ = a, b = 0, M = 0; b < m.length && M < v.length; ) {
      var C = m[b], S = v[M];
      if (C < S) {
        b++;
        continue;
      }
      if (C > S) {
        M++;
        continue;
      }
      C === S && (x = _(x, $(g[b], y[M])), b++, M++);
    }
    return x;
  }
  function h(u) {
    return (0, _is$S.isMatrix)(u) ? u.size() : o(u);
  }
});
dot$1.createDot = createDot;
var trace$1 = {};
Object.defineProperty(trace$1, "__esModule", {
  value: !0
});
trace$1.createTrace = void 0;
var _object$i = object, _string$g = string$2, _factory$1u = factory$1, name$1r = "trace", dependencies$1q = ["typed", "matrix", "add"], createTrace = /* @__PURE__ */ (0, _factory$1u.factory)(name$1r, dependencies$1q, function(t) {
  var r = t.typed, n = t.matrix, a = t.add;
  return r("trace", {
    Array: function(l) {
      return s(n(l));
    },
    SparseMatrix: o,
    DenseMatrix: s,
    any: _object$i.clone
  });
  function s(c) {
    var l = c._size, d = c._data;
    switch (l.length) {
      case 1:
        if (l[0] === 1)
          return (0, _object$i.clone)(d[0]);
        throw new RangeError("Matrix must be square (size: " + (0, _string$g.format)(l) + ")");
      case 2: {
        var h = l[0], u = l[1];
        if (h === u) {
          for (var p = 0, m = 0; m < h; m++)
            p = a(p, d[m][m]);
          return p;
        } else
          throw new RangeError("Matrix must be square (size: " + (0, _string$g.format)(l) + ")");
      }
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + (0, _string$g.format)(l) + ")");
    }
  }
  function o(c) {
    var l = c._values, d = c._index, h = c._ptr, u = c._size, p = u[0], m = u[1];
    if (p === m) {
      var g = 0;
      if (l.length > 0)
        for (var v = 0; v < m; v++)
          for (var y = h[v], x = h[v + 1], _ = y; _ < x; _++) {
            var $ = d[_];
            if ($ === v) {
              g = a(g, l[_]);
              break;
            }
            if ($ > v)
              break;
          }
      return g;
    }
    throw new RangeError("Matrix must be square (size: " + (0, _string$g.format)(u) + ")");
  }
});
trace$1.createTrace = createTrace;
var _function$3 = {};
Object.defineProperty(_function$3, "__esModule", {
  value: !0
});
_function$3.createIndex = void 0;
var _factory$1t = factory$1, _is$R = is, name$1q = "index", dependencies$1p = ["typed", "Index"], createIndex = /* @__PURE__ */ (0, _factory$1t.factory)(name$1q, dependencies$1p, function(t) {
  var r = t.typed, n = t.Index;
  return r(name$1q, {
    "...number | string | BigNumber | Range | Array | Matrix": function(s) {
      var o = s.map(function(l) {
        return (0, _is$R.isBigNumber)(l) ? l.toNumber() : Array.isArray(l) || (0, _is$R.isMatrix)(l) ? l.map(function(d) {
          return (0, _is$R.isBigNumber)(d) ? d.toNumber() : d;
        }) : l;
      }), c = new n();
      return n.apply(c, o), c;
    }
  });
});
_function$3.createIndex = createIndex;
var Node$1 = {}, keywords$1 = {};
Object.defineProperty(keywords$1, "__esModule", {
  value: !0
});
keywords$1.keywords = void 0;
var keywords = {
  end: !0
};
keywords$1.keywords = keywords;
Object.defineProperty(Node$1, "__esModule", {
  value: !0
});
Node$1.createNode = void 0;
var _is$Q = is, _keywords$1 = keywords$1, _object$h = object, _factory$1s = factory$1;
function _typeof$a(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$a = function(n) {
    return typeof n;
  } : _typeof$a = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$a(t);
}
var name$1p = "Node", dependencies$1o = ["mathWithTransform"], createNode = /* @__PURE__ */ (0, _factory$1s.factory)(name$1p, dependencies$1o, function(t) {
  var r = t.mathWithTransform;
  function n() {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  n.prototype.evaluate = function(s) {
    return this.compile().evaluate(s);
  }, n.prototype.type = "Node", n.prototype.isNode = !0, n.prototype.comment = "", n.prototype.compile = function() {
    var s = this._compile(r, {}), o = {}, c = null;
    function l(d) {
      var h = d || {};
      return a(h), s(h, o, c);
    }
    return {
      evaluate: l
    };
  }, n.prototype._compile = function(s, o) {
    throw new Error("Method _compile should be implemented by type " + this.type);
  }, n.prototype.forEach = function(s) {
    throw new Error("Cannot run forEach on a Node interface");
  }, n.prototype.map = function(s) {
    throw new Error("Cannot run map on a Node interface");
  }, n.prototype._ifNode = function(s) {
    if (!(0, _is$Q.isNode)(s))
      throw new TypeError("Callback function must return a Node");
    return s;
  }, n.prototype.traverse = function(s) {
    s(this, null, null);
    function o(c, l) {
      c.forEach(function(d, h, u) {
        l(d, h, u), o(d, l);
      });
    }
    o(this, s);
  }, n.prototype.transform = function(s) {
    function o(c, l, d) {
      var h = s(c, l, d);
      return h !== c ? h : c.map(o);
    }
    return o(this, null, null);
  }, n.prototype.filter = function(s) {
    var o = [];
    return this.traverse(function(c, l, d) {
      s(c, l, d) && o.push(c);
    }), o;
  }, n.prototype.clone = function() {
    throw new Error("Cannot clone a Node interface");
  }, n.prototype.cloneDeep = function() {
    return this.map(function(s) {
      return s.cloneDeep();
    });
  }, n.prototype.equals = function(s) {
    return s ? (0, _object$h.deepStrictEqual)(this, s) : !1;
  }, n.prototype.toString = function(s) {
    var o;
    if (s && _typeof$a(s) === "object")
      switch (_typeof$a(s.handler)) {
        case "object":
        case "undefined":
          break;
        case "function":
          o = s.handler(this, s);
          break;
        default:
          throw new TypeError("Object or function expected as callback");
      }
    return typeof o < "u" ? o : this._toString(s);
  }, n.prototype.toJSON = function() {
    throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
  }, n.prototype.toHTML = function(s) {
    var o;
    if (s && _typeof$a(s) === "object")
      switch (_typeof$a(s.handler)) {
        case "object":
        case "undefined":
          break;
        case "function":
          o = s.handler(this, s);
          break;
        default:
          throw new TypeError("Object or function expected as callback");
      }
    return typeof o < "u" ? o : this.toHTML(s);
  }, n.prototype._toString = function() {
    throw new Error("_toString not implemented for " + this.type);
  }, n.prototype.toTex = function(s) {
    var o;
    if (s && _typeof$a(s) === "object")
      switch (_typeof$a(s.handler)) {
        case "object":
        case "undefined":
          break;
        case "function":
          o = s.handler(this, s);
          break;
        default:
          throw new TypeError("Object or function expected as callback");
      }
    return typeof o < "u" ? o : this._toTex(s);
  }, n.prototype._toTex = function(s) {
    throw new Error("_toTex not implemented for " + this.type);
  }, n.prototype.getIdentifier = function() {
    return this.type;
  }, n.prototype.getContent = function() {
    return this;
  };
  function a(s) {
    for (var o in s)
      if ((0, _object$h.hasOwnProperty)(s, o) && o in _keywords$1.keywords)
        throw new Error('Scope contains an illegal symbol, "' + o + '" is a reserved keyword');
  }
  return n;
}, {
  isClass: !0,
  isNode: !0
});
Node$1.createNode = createNode;
var AccessorNode = {}, access = {}, errorTransform$1 = {};
Object.defineProperty(errorTransform$1, "__esModule", {
  value: !0
});
errorTransform$1.errorTransform = errorTransform;
var _IndexError$1 = IndexError$1;
function errorTransform(t) {
  return t && t.isIndexError ? new _IndexError$1.IndexError(t.index + 1, t.min + 1, t.max !== void 0 ? t.max + 1 : void 0) : t;
}
Object.defineProperty(access, "__esModule", {
  value: !0
});
access.accessFactory = accessFactory;
var _errorTransform$d = errorTransform$1, _customs$c = customs;
function _typeof$9(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$9 = function(n) {
    return typeof n;
  } : _typeof$9 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$9(t);
}
function accessFactory(t) {
  var r = t.subset;
  return function(a, s) {
    try {
      if (Array.isArray(a))
        return r(a, s);
      if (a && typeof a.subset == "function")
        return a.subset(s);
      if (typeof a == "string")
        return r(a, s);
      if (_typeof$9(a) === "object") {
        if (!s.isObjectProperty())
          throw new TypeError("Cannot apply a numeric index as object property");
        return (0, _customs$c.getSafeProperty)(a, s.getObjectProperty());
      } else
        throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (o) {
      throw (0, _errorTransform$d.errorTransform)(o);
    }
  };
}
Object.defineProperty(AccessorNode, "__esModule", {
  value: !0
});
AccessorNode.createAccessorNode = void 0;
var _is$P = is, _customs$b = customs, _factory$1r = factory$1, _access$1 = access, name$1o = "AccessorNode", dependencies$1n = ["subset", "Node"], createAccessorNode = /* @__PURE__ */ (0, _factory$1r.factory)(name$1o, dependencies$1n, function(t) {
  var r = t.subset, n = t.Node, a = (0, _access$1.accessFactory)({
    subset: r
  });
  function s(c, l) {
    if (!(this instanceof s))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!(0, _is$P.isNode)(c))
      throw new TypeError('Node expected for parameter "object"');
    if (!(0, _is$P.isIndexNode)(l))
      throw new TypeError('IndexNode expected for parameter "index"');
    this.object = c || null, this.index = l, Object.defineProperty(this, "name", {
      get: (function() {
        return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
      }).bind(this),
      set: function() {
        throw new Error("Cannot assign a new name, name is read-only");
      }
    });
  }
  s.prototype = new n(), s.prototype.type = "AccessorNode", s.prototype.isAccessorNode = !0, s.prototype._compile = function(c, l) {
    var d = this.object._compile(c, l), h = this.index._compile(c, l);
    if (this.index.isObjectProperty()) {
      var u = this.index.getObjectProperty();
      return function(m, g, v) {
        return (0, _customs$b.getSafeProperty)(d(m, g, v), u);
      };
    } else
      return function(m, g, v) {
        var y = d(m, g, v), x = h(m, g, y);
        return a(y, x);
      };
  }, s.prototype.forEach = function(c) {
    c(this.object, "object", this), c(this.index, "index", this);
  }, s.prototype.map = function(c) {
    return new s(this._ifNode(c(this.object, "object", this)), this._ifNode(c(this.index, "index", this)));
  }, s.prototype.clone = function() {
    return new s(this.object, this.index);
  }, s.prototype._toString = function(c) {
    var l = this.object.toString(c);
    return o(this.object) && (l = "(" + l + ")"), l + this.index.toString(c);
  }, s.prototype.toHTML = function(c) {
    var l = this.object.toHTML(c);
    return o(this.object) && (l = '<span class="math-parenthesis math-round-parenthesis">(</span>' + l + '<span class="math-parenthesis math-round-parenthesis">)</span>'), l + this.index.toHTML(c);
  }, s.prototype._toTex = function(c) {
    var l = this.object.toTex(c);
    return o(this.object) && (l = "\\left(' + object + '\\right)"), l + this.index.toTex(c);
  }, s.prototype.toJSON = function() {
    return {
      mathjs: "AccessorNode",
      object: this.object,
      index: this.index
    };
  }, s.fromJSON = function(c) {
    return new s(c.object, c.index);
  };
  function o(c) {
    return !((0, _is$P.isAccessorNode)(c) || (0, _is$P.isArrayNode)(c) || (0, _is$P.isConstantNode)(c) || (0, _is$P.isFunctionNode)(c) || (0, _is$P.isObjectNode)(c) || (0, _is$P.isParenthesisNode)(c) || (0, _is$P.isSymbolNode)(c));
  }
  return s;
}, {
  isClass: !0,
  isNode: !0
});
AccessorNode.createAccessorNode = createAccessorNode;
var ArrayNode = {};
Object.defineProperty(ArrayNode, "__esModule", {
  value: !0
});
ArrayNode.createArrayNode = void 0;
var _is$O = is, _array$g = array, _factory$1q = factory$1, name$1n = "ArrayNode", dependencies$1m = ["Node"], createArrayNode = /* @__PURE__ */ (0, _factory$1q.factory)(name$1n, dependencies$1m, function(t) {
  var r = t.Node;
  function n(a) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (this.items = a || [], !Array.isArray(this.items) || !this.items.every(_is$O.isNode))
      throw new TypeError("Array containing Nodes expected");
  }
  return n.prototype = new r(), n.prototype.type = "ArrayNode", n.prototype.isArrayNode = !0, n.prototype._compile = function(a, s) {
    var o = (0, _array$g.map)(this.items, function(d) {
      return d._compile(a, s);
    }), c = a.config.matrix !== "Array";
    if (c) {
      var l = a.matrix;
      return function(h, u, p) {
        return l((0, _array$g.map)(o, function(m) {
          return m(h, u, p);
        }));
      };
    } else
      return function(h, u, p) {
        return (0, _array$g.map)(o, function(m) {
          return m(h, u, p);
        });
      };
  }, n.prototype.forEach = function(a) {
    for (var s = 0; s < this.items.length; s++) {
      var o = this.items[s];
      a(o, "items[" + s + "]", this);
    }
  }, n.prototype.map = function(a) {
    for (var s = [], o = 0; o < this.items.length; o++)
      s[o] = this._ifNode(a(this.items[o], "items[" + o + "]", this));
    return new n(s);
  }, n.prototype.clone = function() {
    return new n(this.items.slice(0));
  }, n.prototype._toString = function(a) {
    var s = this.items.map(function(o) {
      return o.toString(a);
    });
    return "[" + s.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ArrayNode",
      items: this.items
    };
  }, n.fromJSON = function(a) {
    return new n(a.items);
  }, n.prototype.toHTML = function(a) {
    var s = this.items.map(function(o) {
      return o.toHTML(a);
    });
    return '<span class="math-parenthesis math-square-parenthesis">[</span>' + s.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
  }, n.prototype._toTex = function(a) {
    var s = "\\begin{bmatrix}";
    return this.items.forEach(function(o) {
      o.items ? s += o.items.map(function(c) {
        return c.toTex(a);
      }).join("&") : s += o.toTex(a), s += "\\\\";
    }), s += "\\end{bmatrix}", s;
  }, n;
}, {
  isClass: !0,
  isNode: !0
});
ArrayNode.createArrayNode = createArrayNode;
var AssignmentNode = {}, assign$1 = {};
Object.defineProperty(assign$1, "__esModule", {
  value: !0
});
assign$1.assignFactory = assignFactory;
var _errorTransform$c = errorTransform$1, _customs$a = customs;
function _typeof$8(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$8 = function(n) {
    return typeof n;
  } : _typeof$8 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$8(t);
}
function assignFactory(t) {
  var r = t.subset, n = t.matrix;
  return function(s, o, c) {
    try {
      if (Array.isArray(s))
        return n(s).subset(o, c).valueOf();
      if (s && typeof s.subset == "function")
        return s.subset(o, c);
      if (typeof s == "string")
        return r(s, o, c);
      if (_typeof$8(s) === "object") {
        if (!o.isObjectProperty())
          throw TypeError("Cannot apply a numeric index as object property");
        return (0, _customs$a.setSafeProperty)(s, o.getObjectProperty(), c), s;
      } else
        throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (l) {
      throw (0, _errorTransform$c.errorTransform)(l);
    }
  };
}
var operators = {};
Object.defineProperty(operators, "__esModule", {
  value: !0
});
operators.getPrecedence = getPrecedence;
operators.getAssociativity = getAssociativity;
operators.isAssociativeWith = isAssociativeWith;
operators.properties = void 0;
var _object$g = object, properties = [{
  // assignment
  AssignmentNode: {},
  FunctionAssignmentNode: {}
}, {
  // conditional expression
  ConditionalNode: {
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // conditionals don't need parentheses in LaTeX because
    // they are 2 dimensional
  }
}, {
  // logical or
  "OperatorNode:or": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical xor
  "OperatorNode:xor": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical and
  "OperatorNode:and": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise or
  "OperatorNode:bitOr": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise xor
  "OperatorNode:bitXor": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise and
  "OperatorNode:bitAnd": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // relational operators
  "OperatorNode:equal": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:unequal": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smaller": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:larger": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smallerEq": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:largerEq": {
    associativity: "left",
    associativeWith: []
  },
  RelationalNode: {
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitshift operators
  "OperatorNode:leftShift": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightArithShift": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightLogShift": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // unit conversion
  "OperatorNode:to": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // range
  RangeNode: {}
}, {
  // addition, subtraction
  "OperatorNode:add": {
    associativity: "left",
    associativeWith: ["OperatorNode:add", "OperatorNode:subtract"]
  },
  "OperatorNode:subtract": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // multiply, divide, modulus
  "OperatorNode:multiply": {
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
  },
  "OperatorNode:divide": {
    associativity: "left",
    associativeWith: [],
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // fractions don't require parentheses because
    // they're 2 dimensional, so parens aren't needed
    // in LaTeX
  },
  "OperatorNode:dotMultiply": {
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"]
  },
  "OperatorNode:dotDivide": {
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:mod": {
    associativity: "left",
    associativeWith: []
  }
}, {
  // unary prefix operators
  "OperatorNode:unaryPlus": {
    associativity: "right"
  },
  "OperatorNode:unaryMinus": {
    associativity: "right"
  },
  "OperatorNode:bitNot": {
    associativity: "right"
  },
  "OperatorNode:not": {
    associativity: "right"
  }
}, {
  // exponentiation
  "OperatorNode:pow": {
    associativity: "right",
    associativeWith: [],
    latexRightParens: !1
    // the exponent doesn't need parentheses in
    // LaTeX because it's 2 dimensional
    // (it's on top)
  },
  "OperatorNode:dotPow": {
    associativity: "right",
    associativeWith: []
  }
}, {
  // factorial
  "OperatorNode:factorial": {
    associativity: "left"
  }
}, {
  // matrix transpose
  "OperatorNode:transpose": {
    associativity: "left"
  }
}];
operators.properties = properties;
function getPrecedence(t, r) {
  var n = t;
  r !== "keep" && (n = t.getContent());
  for (var a = n.getIdentifier(), s = 0; s < properties.length; s++)
    if (a in properties[s])
      return s;
  return null;
}
function getAssociativity(t, r) {
  var n = t;
  r !== "keep" && (n = t.getContent());
  var a = n.getIdentifier(), s = getPrecedence(n, r);
  if (s === null)
    return null;
  var o = properties[s][a];
  if ((0, _object$g.hasOwnProperty)(o, "associativity")) {
    if (o.associativity === "left")
      return "left";
    if (o.associativity === "right")
      return "right";
    throw Error("'" + a + "' has the invalid associativity '" + o.associativity + "'.");
  }
  return null;
}
function isAssociativeWith(t, r, n) {
  var a = n !== "keep" ? t.getContent() : t, s = n !== "keep" ? t.getContent() : r, o = a.getIdentifier(), c = s.getIdentifier(), l = getPrecedence(a, n);
  if (l === null)
    return null;
  var d = properties[l][o];
  if ((0, _object$g.hasOwnProperty)(d, "associativeWith") && d.associativeWith instanceof Array) {
    for (var h = 0; h < d.associativeWith.length; h++)
      if (d.associativeWith[h] === c)
        return !0;
    return !1;
  }
  return null;
}
Object.defineProperty(AssignmentNode, "__esModule", {
  value: !0
});
AssignmentNode.createAssignmentNode = void 0;
var _is$N = is, _customs$9 = customs, _factory$1p = factory$1, _access = access, _assign = assign$1, _operators$5 = operators, name$1m = "AssignmentNode", dependencies$1l = [
  "subset",
  "?matrix",
  // FIXME: should not be needed at all, should be handled by subset
  "Node"
], createAssignmentNode = /* @__PURE__ */ (0, _factory$1p.factory)(name$1m, dependencies$1l, function(t) {
  var r = t.subset, n = t.matrix, a = t.Node, s = (0, _access.accessFactory)({
    subset: r
  }), o = (0, _assign.assignFactory)({
    subset: r,
    matrix: n
  });
  function c(d, h, u) {
    if (!(this instanceof c))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (this.object = d, this.index = u ? h : null, this.value = u || h, !(0, _is$N.isSymbolNode)(d) && !(0, _is$N.isAccessorNode)(d))
      throw new TypeError('SymbolNode or AccessorNode expected as "object"');
    if ((0, _is$N.isSymbolNode)(d) && d.name === "end")
      throw new Error('Cannot assign to symbol "end"');
    if (this.index && !(0, _is$N.isIndexNode)(this.index))
      throw new TypeError('IndexNode expected as "index"');
    if (!(0, _is$N.isNode)(this.value))
      throw new TypeError('Node expected as "value"');
    Object.defineProperty(this, "name", {
      get: (function() {
        return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
      }).bind(this),
      set: function() {
        throw new Error("Cannot assign a new name, name is read-only");
      }
    });
  }
  c.prototype = new a(), c.prototype.type = "AssignmentNode", c.prototype.isAssignmentNode = !0, c.prototype._compile = function(d, h) {
    var u = this.object._compile(d, h), p = this.index ? this.index._compile(d, h) : null, m = this.value._compile(d, h), g = this.object.name;
    if (this.index)
      if (this.index.isObjectProperty()) {
        var v = this.index.getObjectProperty();
        return function(b, M, C) {
          var S = u(b, M, C), A = m(b, M, C);
          return (0, _customs$9.setSafeProperty)(S, v, A);
        };
      } else {
        if ((0, _is$N.isSymbolNode)(this.object))
          return function(b, M, C) {
            var S = u(b, M, C), A = m(b, M, C), D = p(b, M, S);
            return (0, _customs$9.setSafeProperty)(b, g, o(S, D, A)), A;
          };
        var y = this.object.object._compile(d, h);
        if (this.object.index.isObjectProperty()) {
          var x = this.object.index.getObjectProperty();
          return function(b, M, C) {
            var S = y(b, M, C), A = (0, _customs$9.getSafeProperty)(S, x), D = p(b, M, A), N = m(b, M, C);
            return (0, _customs$9.setSafeProperty)(S, x, o(A, D, N)), N;
          };
        } else {
          var _ = this.object.index._compile(d, h);
          return function(b, M, C) {
            var S = y(b, M, C), A = _(b, M, S), D = s(S, A), N = p(b, M, D), T = m(b, M, C);
            return o(S, A, o(D, N, T)), T;
          };
        }
      }
    else {
      if (!(0, _is$N.isSymbolNode)(this.object))
        throw new TypeError("SymbolNode expected as object");
      return function(b, M, C) {
        return (0, _customs$9.setSafeProperty)(b, g, m(b, M, C));
      };
    }
  }, c.prototype.forEach = function(d) {
    d(this.object, "object", this), this.index && d(this.index, "index", this), d(this.value, "value", this);
  }, c.prototype.map = function(d) {
    var h = this._ifNode(d(this.object, "object", this)), u = this.index ? this._ifNode(d(this.index, "index", this)) : null, p = this._ifNode(d(this.value, "value", this));
    return new c(h, u, p);
  }, c.prototype.clone = function() {
    return new c(this.object, this.index, this.value);
  };
  function l(d, h) {
    h || (h = "keep");
    var u = (0, _operators$5.getPrecedence)(d, h), p = (0, _operators$5.getPrecedence)(d.value, h);
    return h === "all" || p !== null && p <= u;
  }
  return c.prototype._toString = function(d) {
    var h = this.object.toString(d), u = this.index ? this.index.toString(d) : "", p = this.value.toString(d);
    return l(this, d && d.parenthesis) && (p = "(" + p + ")"), h + u + " = " + p;
  }, c.prototype.toJSON = function() {
    return {
      mathjs: "AssignmentNode",
      object: this.object,
      index: this.index,
      value: this.value
    };
  }, c.fromJSON = function(d) {
    return new c(d.object, d.index, d.value);
  }, c.prototype.toHTML = function(d) {
    var h = this.object.toHTML(d), u = this.index ? this.index.toHTML(d) : "", p = this.value.toHTML(d);
    return l(this, d && d.parenthesis) && (p = '<span class="math-paranthesis math-round-parenthesis">(</span>' + p + '<span class="math-paranthesis math-round-parenthesis">)</span>'), h + u + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + p;
  }, c.prototype._toTex = function(d) {
    var h = this.object.toTex(d), u = this.index ? this.index.toTex(d) : "", p = this.value.toTex(d);
    return l(this, d && d.parenthesis) && (p = "\\left(".concat(p, "\\right)")), h + u + ":=" + p;
  }, c;
}, {
  isClass: !0,
  isNode: !0
});
AssignmentNode.createAssignmentNode = createAssignmentNode;
var BlockNode = {};
Object.defineProperty(BlockNode, "__esModule", {
  value: !0
});
BlockNode.createBlockNode = void 0;
var _is$M = is, _array$f = array, _factory$1o = factory$1, name$1l = "BlockNode", dependencies$1k = ["ResultSet", "Node"], createBlockNode = /* @__PURE__ */ (0, _factory$1o.factory)(name$1l, dependencies$1k, function(t) {
  var r = t.ResultSet, n = t.Node;
  function a(s) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!Array.isArray(s))
      throw new Error("Array expected");
    this.blocks = s.map(function(o) {
      var c = o && o.node, l = o && o.visible !== void 0 ? o.visible : !0;
      if (!(0, _is$M.isNode)(c))
        throw new TypeError('Property "node" must be a Node');
      if (typeof l != "boolean")
        throw new TypeError('Property "visible" must be a boolean');
      return {
        node: c,
        visible: l
      };
    });
  }
  return a.prototype = new n(), a.prototype.type = "BlockNode", a.prototype.isBlockNode = !0, a.prototype._compile = function(s, o) {
    var c = (0, _array$f.map)(this.blocks, function(l) {
      return {
        evaluate: l.node._compile(s, o),
        visible: l.visible
      };
    });
    return function(d, h, u) {
      var p = [];
      return (0, _array$f.forEach)(c, function(g) {
        var v = g.evaluate(d, h, u);
        g.visible && p.push(v);
      }), new r(p);
    };
  }, a.prototype.forEach = function(s) {
    for (var o = 0; o < this.blocks.length; o++)
      s(this.blocks[o].node, "blocks[" + o + "].node", this);
  }, a.prototype.map = function(s) {
    for (var o = [], c = 0; c < this.blocks.length; c++) {
      var l = this.blocks[c], d = this._ifNode(s(l.node, "blocks[" + c + "].node", this));
      o[c] = {
        node: d,
        visible: l.visible
      };
    }
    return new a(o);
  }, a.prototype.clone = function() {
    var s = this.blocks.map(function(o) {
      return {
        node: o.node,
        visible: o.visible
      };
    });
    return new a(s);
  }, a.prototype._toString = function(s) {
    return this.blocks.map(function(o) {
      return o.node.toString(s) + (o.visible ? "" : ";");
    }).join(`
`);
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "BlockNode",
      blocks: this.blocks
    };
  }, a.fromJSON = function(s) {
    return new a(s.blocks);
  }, a.prototype.toHTML = function(s) {
    return this.blocks.map(function(o) {
      return o.node.toHTML(s) + (o.visible ? "" : '<span class="math-separator">;</span>');
    }).join('<span class="math-separator"><br /></span>');
  }, a.prototype._toTex = function(s) {
    return this.blocks.map(function(o) {
      return o.node.toTex(s) + (o.visible ? "" : ";");
    }).join(`\\;\\;
`);
  }, a;
}, {
  isClass: !0,
  isNode: !0
});
BlockNode.createBlockNode = createBlockNode;
var ConditionalNode = {};
Object.defineProperty(ConditionalNode, "__esModule", {
  value: !0
});
ConditionalNode.createConditionalNode = void 0;
var _is$L = is, _factory$1n = factory$1, _operators$4 = operators, name$1k = "ConditionalNode", dependencies$1j = ["Node"], createConditionalNode = /* @__PURE__ */ (0, _factory$1n.factory)(name$1k, dependencies$1j, function(t) {
  var r = t.Node;
  function n(s, o, c) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!(0, _is$L.isNode)(s))
      throw new TypeError("Parameter condition must be a Node");
    if (!(0, _is$L.isNode)(o))
      throw new TypeError("Parameter trueExpr must be a Node");
    if (!(0, _is$L.isNode)(c))
      throw new TypeError("Parameter falseExpr must be a Node");
    this.condition = s, this.trueExpr = o, this.falseExpr = c;
  }
  n.prototype = new r(), n.prototype.type = "ConditionalNode", n.prototype.isConditionalNode = !0, n.prototype._compile = function(s, o) {
    var c = this.condition._compile(s, o), l = this.trueExpr._compile(s, o), d = this.falseExpr._compile(s, o);
    return function(u, p, m) {
      return a(c(u, p, m)) ? l(u, p, m) : d(u, p, m);
    };
  }, n.prototype.forEach = function(s) {
    s(this.condition, "condition", this), s(this.trueExpr, "trueExpr", this), s(this.falseExpr, "falseExpr", this);
  }, n.prototype.map = function(s) {
    return new n(this._ifNode(s(this.condition, "condition", this)), this._ifNode(s(this.trueExpr, "trueExpr", this)), this._ifNode(s(this.falseExpr, "falseExpr", this)));
  }, n.prototype.clone = function() {
    return new n(this.condition, this.trueExpr, this.falseExpr);
  }, n.prototype._toString = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = (0, _operators$4.getPrecedence)(this, o), l = this.condition.toString(s), d = (0, _operators$4.getPrecedence)(this.condition, o);
    (o === "all" || this.condition.type === "OperatorNode" || d !== null && d <= c) && (l = "(" + l + ")");
    var h = this.trueExpr.toString(s), u = (0, _operators$4.getPrecedence)(this.trueExpr, o);
    (o === "all" || this.trueExpr.type === "OperatorNode" || u !== null && u <= c) && (h = "(" + h + ")");
    var p = this.falseExpr.toString(s), m = (0, _operators$4.getPrecedence)(this.falseExpr, o);
    return (o === "all" || this.falseExpr.type === "OperatorNode" || m !== null && m <= c) && (p = "(" + p + ")"), l + " ? " + h + " : " + p;
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ConditionalNode",
      condition: this.condition,
      trueExpr: this.trueExpr,
      falseExpr: this.falseExpr
    };
  }, n.fromJSON = function(s) {
    return new n(s.condition, s.trueExpr, s.falseExpr);
  }, n.prototype.toHTML = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = (0, _operators$4.getPrecedence)(this, o), l = this.condition.toHTML(s), d = (0, _operators$4.getPrecedence)(this.condition, o);
    (o === "all" || this.condition.type === "OperatorNode" || d !== null && d <= c) && (l = '<span class="math-parenthesis math-round-parenthesis">(</span>' + l + '<span class="math-parenthesis math-round-parenthesis">)</span>');
    var h = this.trueExpr.toHTML(s), u = (0, _operators$4.getPrecedence)(this.trueExpr, o);
    (o === "all" || this.trueExpr.type === "OperatorNode" || u !== null && u <= c) && (h = '<span class="math-parenthesis math-round-parenthesis">(</span>' + h + '<span class="math-parenthesis math-round-parenthesis">)</span>');
    var p = this.falseExpr.toHTML(s), m = (0, _operators$4.getPrecedence)(this.falseExpr, o);
    return (o === "all" || this.falseExpr.type === "OperatorNode" || m !== null && m <= c) && (p = '<span class="math-parenthesis math-round-parenthesis">(</span>' + p + '<span class="math-parenthesis math-round-parenthesis">)</span>'), l + '<span class="math-operator math-conditional-operator">?</span>' + h + '<span class="math-operator math-conditional-operator">:</span>' + p;
  }, n.prototype._toTex = function(s) {
    return "\\begin{cases} {" + this.trueExpr.toTex(s) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(s) + "}\\\\{" + this.falseExpr.toTex(s) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
  };
  function a(s) {
    if (typeof s == "number" || typeof s == "boolean" || typeof s == "string")
      return !!s;
    if (s) {
      if ((0, _is$L.isBigNumber)(s))
        return !s.isZero();
      if ((0, _is$L.isComplex)(s))
        return !!(s.re || s.im);
      if ((0, _is$L.isUnit)(s))
        return !!s.value;
    }
    if (s == null)
      return !1;
    throw new TypeError('Unsupported type of condition "' + (0, _is$L.typeOf)(s) + '"');
  }
  return n;
}, {
  isClass: !0,
  isNode: !0
});
ConditionalNode.createConditionalNode = createConditionalNode;
var ConstantNode = {}, latex = {}, _extends$4 = Object.assign || function(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r];
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
  }
  return t;
}, defaultEscapes = {
  "{": "\\{",
  "}": "\\}",
  "\\": "\\textbackslash{}",
  "#": "\\#",
  $: "\\$",
  "%": "\\%",
  "&": "\\&",
  "^": "\\textasciicircum{}",
  _: "\\_",
  "~": "\\textasciitilde{}"
}, formatEscapes = {
  "–": "\\--",
  "—": "\\---",
  " ": "~",
  "	": "\\qquad{}",
  "\r\n": "\\newline{}",
  "\n": "\\newline{}"
}, defaultEscapeMapFn = function(r, n) {
  return _extends$4({}, r, n);
}, dist$1 = function(t) {
  for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.preserveFormatting, a = n === void 0 ? !1 : n, s = r.escapeMapFn, o = s === void 0 ? defaultEscapeMapFn : s, c = String(t), l = "", d = o(_extends$4({}, defaultEscapes), a ? _extends$4({}, formatEscapes) : {}), h = Object.keys(d), u = function() {
    var m = !1;
    h.forEach(function(g, v) {
      m || c.length >= g.length && c.slice(0, g.length) === g && (l += d[h[v]], c = c.slice(g.length, c.length), m = !0);
    }), m || (l += c.slice(0, 1), c = c.slice(1, c.length));
  }; c; )
    u();
  return l;
};
Object.defineProperty(latex, "__esModule", {
  value: !0
});
latex.escapeLatex = escapeLatex;
latex.toSymbol = toSymbol;
latex.defaultTemplate = latex.latexFunctions = latex.latexOperators = latex.latexSymbols = void 0;
var _escapeLatex = _interopRequireDefault$2(dist$1), _object$f = object;
function _interopRequireDefault$2(t) {
  return t && t.__esModule ? t : { default: t };
}
var latexSymbols = {
  // GREEK LETTERS
  Alpha: "A",
  alpha: "\\alpha",
  Beta: "B",
  beta: "\\beta",
  Gamma: "\\Gamma",
  gamma: "\\gamma",
  Delta: "\\Delta",
  delta: "\\delta",
  Epsilon: "E",
  epsilon: "\\epsilon",
  varepsilon: "\\varepsilon",
  Zeta: "Z",
  zeta: "\\zeta",
  Eta: "H",
  eta: "\\eta",
  Theta: "\\Theta",
  theta: "\\theta",
  vartheta: "\\vartheta",
  Iota: "I",
  iota: "\\iota",
  Kappa: "K",
  kappa: "\\kappa",
  varkappa: "\\varkappa",
  Lambda: "\\Lambda",
  lambda: "\\lambda",
  Mu: "M",
  mu: "\\mu",
  Nu: "N",
  nu: "\\nu",
  Xi: "\\Xi",
  xi: "\\xi",
  Omicron: "O",
  omicron: "o",
  Pi: "\\Pi",
  pi: "\\pi",
  varpi: "\\varpi",
  Rho: "P",
  rho: "\\rho",
  varrho: "\\varrho",
  Sigma: "\\Sigma",
  sigma: "\\sigma",
  varsigma: "\\varsigma",
  Tau: "T",
  tau: "\\tau",
  Upsilon: "\\Upsilon",
  upsilon: "\\upsilon",
  Phi: "\\Phi",
  phi: "\\phi",
  varphi: "\\varphi",
  Chi: "X",
  chi: "\\chi",
  Psi: "\\Psi",
  psi: "\\psi",
  Omega: "\\Omega",
  omega: "\\omega",
  // logic
  true: "\\mathrm{True}",
  false: "\\mathrm{False}",
  // other
  i: "i",
  // TODO use \i ??
  inf: "\\infty",
  Inf: "\\infty",
  infinity: "\\infty",
  Infinity: "\\infty",
  oo: "\\infty",
  lim: "\\lim",
  undefined: "\\mathbf{?}"
};
latex.latexSymbols = latexSymbols;
var latexOperators = {
  transpose: "^\\top",
  ctranspose: "^H",
  factorial: "!",
  pow: "^",
  dotPow: ".^\\wedge",
  // TODO find ideal solution
  unaryPlus: "+",
  unaryMinus: "-",
  bitNot: "\\~",
  // TODO find ideal solution
  not: "\\neg",
  multiply: "\\cdot",
  divide: "\\frac",
  // TODO how to handle that properly?
  dotMultiply: ".\\cdot",
  // TODO find ideal solution
  dotDivide: ".:",
  // TODO find ideal solution
  mod: "\\mod",
  add: "+",
  subtract: "-",
  to: "\\rightarrow",
  leftShift: "<<",
  rightArithShift: ">>",
  rightLogShift: ">>>",
  equal: "=",
  unequal: "\\neq",
  smaller: "<",
  larger: ">",
  smallerEq: "\\leq",
  largerEq: "\\geq",
  bitAnd: "\\&",
  bitXor: "\\underline{|}",
  bitOr: "|",
  and: "\\wedge",
  xor: "\\veebar",
  or: "\\vee"
};
latex.latexOperators = latexOperators;
var latexFunctions = {
  // arithmetic
  abs: {
    1: "\\left|${args[0]}\\right|"
  },
  add: {
    2: "\\left(${args[0]}".concat(latexOperators.add, "${args[1]}\\right)")
  },
  cbrt: {
    1: "\\sqrt[3]{${args[0]}}"
  },
  ceil: {
    1: "\\left\\lceil${args[0]}\\right\\rceil"
  },
  cube: {
    1: "\\left(${args[0]}\\right)^3"
  },
  divide: {
    2: "\\frac{${args[0]}}{${args[1]}}"
  },
  dotDivide: {
    2: "\\left(${args[0]}".concat(latexOperators.dotDivide, "${args[1]}\\right)")
  },
  dotMultiply: {
    2: "\\left(${args[0]}".concat(latexOperators.dotMultiply, "${args[1]}\\right)")
  },
  dotPow: {
    2: "\\left(${args[0]}".concat(latexOperators.dotPow, "${args[1]}\\right)")
  },
  exp: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  expm1: "\\left(e".concat(latexOperators.pow, "{${args[0]}}-1\\right)"),
  fix: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  floor: {
    1: "\\left\\lfloor${args[0]}\\right\\rfloor"
  },
  gcd: "\\gcd\\left(${args}\\right)",
  hypot: "\\hypot\\left(${args}\\right)",
  log: {
    1: "\\ln\\left(${args[0]}\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
  },
  log10: {
    1: "\\log_{10}\\left(${args[0]}\\right)"
  },
  log1p: {
    1: "\\ln\\left(${args[0]}+1\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
  },
  log2: "\\log_{2}\\left(${args[0]}\\right)",
  mod: {
    2: "\\left(${args[0]}".concat(latexOperators.mod, "${args[1]}\\right)")
  },
  multiply: {
    2: "\\left(${args[0]}".concat(latexOperators.multiply, "${args[1]}\\right)")
  },
  norm: {
    1: "\\left\\|${args[0]}\\right\\|",
    2: void 0
    // use default template
  },
  nthRoot: {
    2: "\\sqrt[${args[1]}]{${args[0]}}"
  },
  nthRoots: {
    2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
  },
  pow: {
    2: "\\left(${args[0]}\\right)".concat(latexOperators.pow, "{${args[1]}}")
  },
  round: {
    1: "\\left\\lfloor${args[0]}\\right\\rceil",
    2: void 0
    // use default template
  },
  sign: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  sqrt: {
    1: "\\sqrt{${args[0]}}"
  },
  square: {
    1: "\\left(${args[0]}\\right)^2"
  },
  subtract: {
    2: "\\left(${args[0]}".concat(latexOperators.subtract, "${args[1]}\\right)")
  },
  unaryMinus: {
    1: "".concat(latexOperators.unaryMinus, "\\left(${args[0]}\\right)")
  },
  unaryPlus: {
    1: "".concat(latexOperators.unaryPlus, "\\left(${args[0]}\\right)")
  },
  // bitwise
  bitAnd: {
    2: "\\left(${args[0]}".concat(latexOperators.bitAnd, "${args[1]}\\right)")
  },
  bitNot: {
    1: latexOperators.bitNot + "\\left(${args[0]}\\right)"
  },
  bitOr: {
    2: "\\left(${args[0]}".concat(latexOperators.bitOr, "${args[1]}\\right)")
  },
  bitXor: {
    2: "\\left(${args[0]}".concat(latexOperators.bitXor, "${args[1]}\\right)")
  },
  leftShift: {
    2: "\\left(${args[0]}".concat(latexOperators.leftShift, "${args[1]}\\right)")
  },
  rightArithShift: {
    2: "\\left(${args[0]}".concat(latexOperators.rightArithShift, "${args[1]}\\right)")
  },
  rightLogShift: {
    2: "\\left(${args[0]}".concat(latexOperators.rightLogShift, "${args[1]}\\right)")
  },
  // combinatorics
  bellNumbers: {
    1: "\\mathrm{B}_{${args[0]}}"
  },
  catalan: {
    1: "\\mathrm{C}_{${args[0]}}"
  },
  stirlingS2: {
    2: "\\mathrm{S}\\left(${args}\\right)"
  },
  // complex
  arg: {
    1: "\\arg\\left(${args[0]}\\right)"
  },
  conj: {
    1: "\\left(${args[0]}\\right)^*"
  },
  im: {
    1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  re: {
    1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  // logical
  and: {
    2: "\\left(${args[0]}".concat(latexOperators.and, "${args[1]}\\right)")
  },
  not: {
    1: latexOperators.not + "\\left(${args[0]}\\right)"
  },
  or: {
    2: "\\left(${args[0]}".concat(latexOperators.or, "${args[1]}\\right)")
  },
  xor: {
    2: "\\left(${args[0]}".concat(latexOperators.xor, "${args[1]}\\right)")
  },
  // matrix
  cross: {
    2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
  },
  ctranspose: {
    1: "\\left(${args[0]}\\right)".concat(latexOperators.ctranspose)
  },
  det: {
    1: "\\det\\left(${args[0]}\\right)"
  },
  dot: {
    2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
  },
  expm: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  inv: {
    1: "\\left(${args[0]}\\right)^{-1}"
  },
  sqrtm: {
    1: "{${args[0]}}".concat(latexOperators.pow, "{\\frac{1}{2}}")
  },
  trace: {
    1: "\\mathrm{tr}\\left(${args[0]}\\right)"
  },
  transpose: {
    1: "\\left(${args[0]}\\right)".concat(latexOperators.transpose)
  },
  // probability
  combinations: {
    2: "\\binom{${args[0]}}{${args[1]}}"
  },
  combinationsWithRep: {
    2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
  },
  factorial: {
    1: "\\left(${args[0]}\\right)".concat(latexOperators.factorial)
  },
  gamma: {
    1: "\\Gamma\\left(${args[0]}\\right)"
  },
  // relational
  equal: {
    2: "\\left(${args[0]}".concat(latexOperators.equal, "${args[1]}\\right)")
  },
  larger: {
    2: "\\left(${args[0]}".concat(latexOperators.larger, "${args[1]}\\right)")
  },
  largerEq: {
    2: "\\left(${args[0]}".concat(latexOperators.largerEq, "${args[1]}\\right)")
  },
  smaller: {
    2: "\\left(${args[0]}".concat(latexOperators.smaller, "${args[1]}\\right)")
  },
  smallerEq: {
    2: "\\left(${args[0]}".concat(latexOperators.smallerEq, "${args[1]}\\right)")
  },
  unequal: {
    2: "\\left(${args[0]}".concat(latexOperators.unequal, "${args[1]}\\right)")
  },
  // special
  erf: {
    1: "erf\\left(${args[0]}\\right)"
  },
  // statistics
  max: "\\max\\left(${args}\\right)",
  min: "\\min\\left(${args}\\right)",
  variance: "\\mathrm{Var}\\left(${args}\\right)",
  // trigonometry
  acos: {
    1: "\\cos^{-1}\\left(${args[0]}\\right)"
  },
  acosh: {
    1: "\\cosh^{-1}\\left(${args[0]}\\right)"
  },
  acot: {
    1: "\\cot^{-1}\\left(${args[0]}\\right)"
  },
  acoth: {
    1: "\\coth^{-1}\\left(${args[0]}\\right)"
  },
  acsc: {
    1: "\\csc^{-1}\\left(${args[0]}\\right)"
  },
  acsch: {
    1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
  },
  asec: {
    1: "\\sec^{-1}\\left(${args[0]}\\right)"
  },
  asech: {
    1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
  },
  asin: {
    1: "\\sin^{-1}\\left(${args[0]}\\right)"
  },
  asinh: {
    1: "\\sinh^{-1}\\left(${args[0]}\\right)"
  },
  atan: {
    1: "\\tan^{-1}\\left(${args[0]}\\right)"
  },
  atan2: {
    2: "\\mathrm{atan2}\\left(${args}\\right)"
  },
  atanh: {
    1: "\\tanh^{-1}\\left(${args[0]}\\right)"
  },
  cos: {
    1: "\\cos\\left(${args[0]}\\right)"
  },
  cosh: {
    1: "\\cosh\\left(${args[0]}\\right)"
  },
  cot: {
    1: "\\cot\\left(${args[0]}\\right)"
  },
  coth: {
    1: "\\coth\\left(${args[0]}\\right)"
  },
  csc: {
    1: "\\csc\\left(${args[0]}\\right)"
  },
  csch: {
    1: "\\mathrm{csch}\\left(${args[0]}\\right)"
  },
  sec: {
    1: "\\sec\\left(${args[0]}\\right)"
  },
  sech: {
    1: "\\mathrm{sech}\\left(${args[0]}\\right)"
  },
  sin: {
    1: "\\sin\\left(${args[0]}\\right)"
  },
  sinh: {
    1: "\\sinh\\left(${args[0]}\\right)"
  },
  tan: {
    1: "\\tan\\left(${args[0]}\\right)"
  },
  tanh: {
    1: "\\tanh\\left(${args[0]}\\right)"
  },
  // unit
  to: {
    2: "\\left(${args[0]}".concat(latexOperators.to, "${args[1]}\\right)")
  },
  // utils
  numeric: function(r, n) {
    return r.args[0].toTex();
  },
  // type
  number: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  },
  string: {
    0: '\\mathtt{""}',
    1: "\\mathrm{string}\\left(${args[0]}\\right)"
  },
  bignumber: {
    0: "0",
    1: "\\left(${args[0]}\\right)"
  },
  complex: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)+".concat(latexSymbols.i, "\\cdot\\left(${args[1]}\\right)\\right)")
  },
  matrix: {
    0: "\\begin{bmatrix}\\end{bmatrix}",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(${args[0]}\\right)"
  },
  sparse: {
    0: "\\begin{bsparse}\\end{bsparse}",
    1: "\\left(${args[0]}\\right)"
  },
  unit: {
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  }
};
latex.latexFunctions = latexFunctions;
var defaultTemplate = "\\mathrm{${name}}\\left(${args}\\right)";
latex.defaultTemplate = defaultTemplate;
var latexUnits = {
  deg: "^\\circ"
};
function escapeLatex(t) {
  return (0, _escapeLatex.default)(t, {
    preserveFormatting: !0
  });
}
function toSymbol(t, r) {
  return r = typeof r > "u" ? !1 : r, r ? (0, _object$f.hasOwnProperty)(latexUnits, t) ? latexUnits[t] : "\\mathrm{" + escapeLatex(t) + "}" : (0, _object$f.hasOwnProperty)(latexSymbols, t) ? latexSymbols[t] : escapeLatex(t);
}
Object.defineProperty(ConstantNode, "__esModule", {
  value: !0
});
ConstantNode.createConstantNode = void 0;
var _string$f = string$2, _is$K = is, _latex$5 = latex, _factory$1m = factory$1, name$1j = "ConstantNode", dependencies$1i = ["Node"], createConstantNode = /* @__PURE__ */ (0, _factory$1m.factory)(name$1j, dependencies$1i, function(t) {
  var r = t.Node;
  function n(a) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    this.value = a;
  }
  return n.prototype = new r(), n.prototype.type = "ConstantNode", n.prototype.isConstantNode = !0, n.prototype._compile = function(a, s) {
    var o = this.value;
    return function() {
      return o;
    };
  }, n.prototype.forEach = function(a) {
  }, n.prototype.map = function(a) {
    return this.clone();
  }, n.prototype.clone = function() {
    return new n(this.value);
  }, n.prototype._toString = function(a) {
    return (0, _string$f.format)(this.value, a);
  }, n.prototype.toHTML = function(a) {
    var s = this._toString(a);
    switch ((0, _is$K.typeOf)(this.value)) {
      case "number":
      case "BigNumber":
      case "Fraction":
        return '<span class="math-number">' + s + "</span>";
      case "string":
        return '<span class="math-string">' + s + "</span>";
      case "boolean":
        return '<span class="math-boolean">' + s + "</span>";
      case "null":
        return '<span class="math-null-symbol">' + s + "</span>";
      case "undefined":
        return '<span class="math-undefined">' + s + "</span>";
      default:
        return '<span class="math-symbol">' + s + "</span>";
    }
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ConstantNode",
      value: this.value
    };
  }, n.fromJSON = function(a) {
    return new n(a.value);
  }, n.prototype._toTex = function(a) {
    var s = this._toString(a);
    switch ((0, _is$K.typeOf)(this.value)) {
      case "string":
        return "\\mathtt{" + (0, _latex$5.escapeLatex)(s) + "}";
      case "number":
      case "BigNumber":
        {
          if (!isFinite(this.value))
            return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
          var o = s.toLowerCase().indexOf("e");
          if (o !== -1)
            return s.substring(0, o) + "\\cdot10^{" + s.substring(o + 1) + "}";
        }
        return s;
      case "Fraction":
        return this.value.toLatex();
      default:
        return s;
    }
  }, n;
}, {
  isClass: !0,
  isNode: !0
});
ConstantNode.createConstantNode = createConstantNode;
var FunctionAssignmentNode = {};
Object.defineProperty(FunctionAssignmentNode, "__esModule", {
  value: !0
});
FunctionAssignmentNode.createFunctionAssignmentNode = void 0;
var _is$J = is, _keywords = keywords$1, _string$e = string$2, _array$e = array, _latex$4 = latex, _operators$3 = operators, _customs$8 = customs, _factory$1l = factory$1, name$1i = "FunctionAssignmentNode", dependencies$1h = ["typed", "Node"], createFunctionAssignmentNode = /* @__PURE__ */ (0, _factory$1l.factory)(name$1i, dependencies$1h, function(t) {
  var r = t.typed, n = t.Node;
  function a(o, c, l) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (typeof o != "string")
      throw new TypeError('String expected for parameter "name"');
    if (!Array.isArray(c))
      throw new TypeError('Array containing strings or objects expected for parameter "params"');
    if (!(0, _is$J.isNode)(l))
      throw new TypeError('Node expected for parameter "expr"');
    if (o in _keywords.keywords)
      throw new Error('Illegal function name, "' + o + '" is a reserved keyword');
    this.name = o, this.params = c.map(function(d) {
      return d && d.name || d;
    }), this.types = c.map(function(d) {
      return d && d.type || "any";
    }), this.expr = l;
  }
  a.prototype = new n(), a.prototype.type = "FunctionAssignmentNode", a.prototype.isFunctionAssignmentNode = !0, a.prototype._compile = function(o, c) {
    var l = Object.create(c);
    (0, _array$e.forEach)(this.params, function(g) {
      l[g] = !0;
    });
    var d = this.expr._compile(o, l), h = this.name, u = this.params, p = (0, _array$e.join)(this.types, ","), m = h + "(" + (0, _array$e.join)(this.params, ", ") + ")";
    return function(v, y, x) {
      var _ = {};
      _[p] = function() {
        for (var b = Object.create(y), M = 0; M < u.length; M++)
          b[u[M]] = arguments[M];
        return d(v, b, x);
      };
      var $ = r(h, _);
      return $.syntax = m, (0, _customs$8.setSafeProperty)(v, h, $), $;
    };
  }, a.prototype.forEach = function(o) {
    o(this.expr, "expr", this);
  }, a.prototype.map = function(o) {
    var c = this._ifNode(o(this.expr, "expr", this));
    return new a(this.name, this.params.slice(0), c);
  }, a.prototype.clone = function() {
    return new a(this.name, this.params.slice(0), this.expr);
  };
  function s(o, c) {
    var l = (0, _operators$3.getPrecedence)(o, c), d = (0, _operators$3.getPrecedence)(o.expr, c);
    return c === "all" || d !== null && d <= l;
  }
  return a.prototype._toString = function(o) {
    var c = o && o.parenthesis ? o.parenthesis : "keep", l = this.expr.toString(o);
    return s(this, c) && (l = "(" + l + ")"), this.name + "(" + this.params.join(", ") + ") = " + l;
  }, a.prototype.toJSON = function() {
    var o = this.types;
    return {
      mathjs: "FunctionAssignmentNode",
      name: this.name,
      params: this.params.map(function(c, l) {
        return {
          name: c,
          type: o[l]
        };
      }),
      expr: this.expr
    };
  }, a.fromJSON = function(o) {
    return new a(o.name, o.params, o.expr);
  }, a.prototype.toHTML = function(o) {
    for (var c = o && o.parenthesis ? o.parenthesis : "keep", l = [], d = 0; d < this.params.length; d++)
      l.push('<span class="math-symbol math-parameter">' + (0, _string$e.escape)(this.params[d]) + "</span>");
    var h = this.expr.toHTML(o);
    return s(this, c) && (h = '<span class="math-parenthesis math-round-parenthesis">(</span>' + h + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + (0, _string$e.escape)(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + l.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + h;
  }, a.prototype._toTex = function(o) {
    var c = o && o.parenthesis ? o.parenthesis : "keep", l = this.expr.toTex(o);
    return s(this, c) && (l = "\\left(".concat(l, "\\right)")), "\\mathrm{" + this.name + "}\\left(" + this.params.map(_latex$4.toSymbol).join(",") + "\\right):=" + l;
  }, a;
}, {
  isClass: !0,
  isNode: !0
});
FunctionAssignmentNode.createFunctionAssignmentNode = createFunctionAssignmentNode;
var IndexNode = {};
Object.defineProperty(IndexNode, "__esModule", {
  value: !0
});
IndexNode.createIndexNode = void 0;
var _is$I = is, _array$d = array, _string$d = string$2, _factory$1k = factory$1, _customs$7 = customs;
function _toConsumableArray$3(t) {
  return _arrayWithoutHoles$3(t) || _iterableToArray$3(t) || _unsupportedIterableToArray$2(t) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$2(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$2(t, r);
  }
}
function _iterableToArray$3(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function _arrayWithoutHoles$3(t) {
  if (Array.isArray(t))
    return _arrayLikeToArray$2(t);
}
function _arrayLikeToArray$2(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
var name$1h = "IndexNode", dependencies$1g = ["Range", "Node", "size"], createIndexNode = /* @__PURE__ */ (0, _factory$1k.factory)(name$1h, dependencies$1g, function(t) {
  var r = t.Range, n = t.Node, a = t.size;
  function s(c, l) {
    if (!(this instanceof s))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (this.dimensions = c, this.dotNotation = l || !1, !Array.isArray(c) || !c.every(_is$I.isNode))
      throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
    if (this.dotNotation && !this.isObjectProperty())
      throw new Error("dotNotation only applicable for object properties");
  }
  s.prototype = new n(), s.prototype.type = "IndexNode", s.prototype.isIndexNode = !0, s.prototype._compile = function(c, l) {
    var d = (0, _array$d.map)(this.dimensions, function(u, p) {
      if ((0, _is$I.isRangeNode)(u))
        if (u.needsEnd()) {
          var m = Object.create(l);
          m.end = !0;
          var g = u.start._compile(c, m), v = u.end._compile(c, m), y = u.step ? u.step._compile(c, m) : function() {
            return 1;
          };
          return function(A, D, N) {
            var T = a(N).valueOf(), R = Object.create(D);
            return R.end = T[p], o(g(A, R, N), v(A, R, N), y(A, R, N));
          };
        } else {
          var x = u.start._compile(c, l), _ = u.end._compile(c, l), $ = u.step ? u.step._compile(c, l) : function() {
            return 1;
          };
          return function(A, D, N) {
            return o(x(A, D, N), _(A, D, N), $(A, D, N));
          };
        }
      else if ((0, _is$I.isSymbolNode)(u) && u.name === "end") {
        var b = Object.create(l);
        b.end = !0;
        var M = u._compile(c, b);
        return function(A, D, N) {
          var T = a(N).valueOf(), R = Object.create(D);
          return R.end = T[p], M(A, R, N);
        };
      } else {
        var C = u._compile(c, l);
        return function(A, D, N) {
          return C(A, D, N);
        };
      }
    }), h = (0, _customs$7.getSafeProperty)(c, "index");
    return function(p, m, g) {
      var v = (0, _array$d.map)(d, function(y) {
        return y(p, m, g);
      });
      return h.apply(void 0, _toConsumableArray$3(v));
    };
  }, s.prototype.forEach = function(c) {
    for (var l = 0; l < this.dimensions.length; l++)
      c(this.dimensions[l], "dimensions[" + l + "]", this);
  }, s.prototype.map = function(c) {
    for (var l = [], d = 0; d < this.dimensions.length; d++)
      l[d] = this._ifNode(c(this.dimensions[d], "dimensions[" + d + "]", this));
    return new s(l, this.dotNotation);
  }, s.prototype.clone = function() {
    return new s(this.dimensions.slice(0), this.dotNotation);
  }, s.prototype.isObjectProperty = function() {
    return this.dimensions.length === 1 && (0, _is$I.isConstantNode)(this.dimensions[0]) && typeof this.dimensions[0].value == "string";
  }, s.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this.dimensions[0].value : null;
  }, s.prototype._toString = function(c) {
    return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
  }, s.prototype.toJSON = function() {
    return {
      mathjs: "IndexNode",
      dimensions: this.dimensions,
      dotNotation: this.dotNotation
    };
  }, s.fromJSON = function(c) {
    return new s(c.dimensions, c.dotNotation);
  }, s.prototype.toHTML = function(c) {
    for (var l = [], d = 0; d < this.dimensions.length; d++)
      l[d] = this.dimensions[d].toHTML();
    return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + (0, _string$d.escape)(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + l.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
  }, s.prototype._toTex = function(c) {
    var l = this.dimensions.map(function(d) {
      return d.toTex(c);
    });
    return this.dotNotation ? "." + this.getObjectProperty() : "_{" + l.join(",") + "}";
  };
  function o(c, l, d) {
    return new r((0, _is$I.isBigNumber)(c) ? c.toNumber() : c, (0, _is$I.isBigNumber)(l) ? l.toNumber() : l, (0, _is$I.isBigNumber)(d) ? d.toNumber() : d);
  }
  return s;
}, {
  isClass: !0,
  isNode: !0
});
IndexNode.createIndexNode = createIndexNode;
var ObjectNode = {};
Object.defineProperty(ObjectNode, "__esModule", {
  value: !0
});
ObjectNode.createObjectNode = void 0;
var _is$H = is, _string$c = string$2, _customs$6 = customs, _object$e = object, _factory$1j = factory$1;
function _typeof$7(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$7 = function(n) {
    return typeof n;
  } : _typeof$7 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$7(t);
}
var name$1g = "ObjectNode", dependencies$1f = ["Node"], createObjectNode = /* @__PURE__ */ (0, _factory$1j.factory)(name$1g, dependencies$1f, function(t) {
  var r = t.Node;
  function n(a) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (this.properties = a || {}, a && (_typeof$7(a) !== "object" || !Object.keys(a).every(function(s) {
      return (0, _is$H.isNode)(a[s]);
    })))
      throw new TypeError("Object containing Nodes expected");
  }
  return n.prototype = new r(), n.prototype.type = "ObjectNode", n.prototype.isObjectNode = !0, n.prototype._compile = function(a, s) {
    var o = {};
    for (var c in this.properties)
      if ((0, _object$e.hasOwnProperty)(this.properties, c)) {
        var l = (0, _string$c.stringify)(c), d = JSON.parse(l);
        if (!(0, _customs$6.isSafeProperty)(this.properties, d))
          throw new Error('No access to property "' + d + '"');
        o[d] = this.properties[c]._compile(a, s);
      }
    return function(u, p, m) {
      var g = {};
      for (var v in o)
        (0, _object$e.hasOwnProperty)(o, v) && (g[v] = o[v](u, p, m));
      return g;
    };
  }, n.prototype.forEach = function(a) {
    for (var s in this.properties)
      (0, _object$e.hasOwnProperty)(this.properties, s) && a(this.properties[s], "properties[" + (0, _string$c.stringify)(s) + "]", this);
  }, n.prototype.map = function(a) {
    var s = {};
    for (var o in this.properties)
      (0, _object$e.hasOwnProperty)(this.properties, o) && (s[o] = this._ifNode(a(this.properties[o], "properties[" + (0, _string$c.stringify)(o) + "]", this)));
    return new n(s);
  }, n.prototype.clone = function() {
    var a = {};
    for (var s in this.properties)
      (0, _object$e.hasOwnProperty)(this.properties, s) && (a[s] = this.properties[s]);
    return new n(a);
  }, n.prototype._toString = function(a) {
    var s = [];
    for (var o in this.properties)
      (0, _object$e.hasOwnProperty)(this.properties, o) && s.push((0, _string$c.stringify)(o) + ": " + this.properties[o].toString(a));
    return "{" + s.join(", ") + "}";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ObjectNode",
      properties: this.properties
    };
  }, n.fromJSON = function(a) {
    return new n(a.properties);
  }, n.prototype.toHTML = function(a) {
    var s = [];
    for (var o in this.properties)
      (0, _object$e.hasOwnProperty)(this.properties, o) && s.push('<span class="math-symbol math-property">' + (0, _string$c.escape)(o) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[o].toHTML(a));
    return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + s.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
  }, n.prototype._toTex = function(a) {
    var s = [];
    for (var o in this.properties)
      (0, _object$e.hasOwnProperty)(this.properties, o) && s.push("\\mathbf{" + o + ":} & " + this.properties[o].toTex(a) + "\\\\");
    return "\\left\\{\\begin{array}{ll}".concat(s.join(`
`), "\\end{array}\\right\\}");
  }, n;
}, {
  isClass: !0,
  isNode: !0
});
ObjectNode.createObjectNode = createObjectNode;
var OperatorNode = {};
Object.defineProperty(OperatorNode, "__esModule", {
  value: !0
});
OperatorNode.createOperatorNode = void 0;
var _is$G = is, _array$c = array, _string$b = string$2, _customs$5 = customs, _operators$2 = operators, _latex$3 = latex, _factory$1i = factory$1, name$1f = "OperatorNode", dependencies$1e = ["Node"], createOperatorNode = /* @__PURE__ */ (0, _factory$1i.factory)(name$1f, dependencies$1e, function(t) {
  var r = t.Node;
  function n(s, o, c, l) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (typeof s != "string")
      throw new TypeError('string expected for parameter "op"');
    if (typeof o != "string")
      throw new TypeError('string expected for parameter "fn"');
    if (!Array.isArray(c) || !c.every(_is$G.isNode))
      throw new TypeError('Array containing Nodes expected for parameter "args"');
    this.implicit = l === !0, this.op = s, this.fn = o, this.args = c || [];
  }
  n.prototype = new r(), n.prototype.type = "OperatorNode", n.prototype.isOperatorNode = !0, n.prototype._compile = function(s, o) {
    if (typeof this.fn != "string" || !(0, _customs$5.isSafeMethod)(s, this.fn))
      throw s[this.fn] ? new Error('No access to function "' + this.fn + '"') : new Error("Function " + this.fn + ' missing in provided namespace "math"');
    var c = (0, _customs$5.getSafeProperty)(s, this.fn), l = (0, _array$c.map)(this.args, function(p) {
      return p._compile(s, o);
    });
    if (l.length === 1) {
      var d = l[0];
      return function(m, g, v) {
        return c(d(m, g, v));
      };
    } else if (l.length === 2) {
      var h = l[0], u = l[1];
      return function(m, g, v) {
        return c(h(m, g, v), u(m, g, v));
      };
    } else
      return function(m, g, v) {
        return c.apply(null, (0, _array$c.map)(l, function(y) {
          return y(m, g, v);
        }));
      };
  }, n.prototype.forEach = function(s) {
    for (var o = 0; o < this.args.length; o++)
      s(this.args[o], "args[" + o + "]", this);
  }, n.prototype.map = function(s) {
    for (var o = [], c = 0; c < this.args.length; c++)
      o[c] = this._ifNode(s(this.args[c], "args[" + c + "]", this));
    return new n(this.op, this.fn, o, this.implicit);
  }, n.prototype.clone = function() {
    return new n(this.op, this.fn, this.args.slice(0), this.implicit);
  }, n.prototype.isUnary = function() {
    return this.args.length === 1;
  }, n.prototype.isBinary = function() {
    return this.args.length === 2;
  };
  function a(s, o, c, l, d) {
    var h = (0, _operators$2.getPrecedence)(s, o), u = (0, _operators$2.getAssociativity)(s, o);
    if (o === "all" || l.length > 2 && s.getIdentifier() !== "OperatorNode:add" && s.getIdentifier() !== "OperatorNode:multiply")
      return l.map(function(D) {
        switch (D.getContent().type) {
          case "ArrayNode":
          case "ConstantNode":
          case "SymbolNode":
          case "ParenthesisNode":
            return !1;
          default:
            return !0;
        }
      });
    var p;
    switch (l.length) {
      case 0:
        p = [];
        break;
      case 1:
        {
          var m = (0, _operators$2.getPrecedence)(l[0], o);
          if (d && m !== null) {
            var g, v;
            if (o === "keep" ? (g = l[0].getIdentifier(), v = s.getIdentifier()) : (g = l[0].getContent().getIdentifier(), v = s.getContent().getIdentifier()), _operators$2.properties[h][v].latexLeftParens === !1) {
              p = [!1];
              break;
            }
            if (_operators$2.properties[m][g].latexParens === !1) {
              p = [!1];
              break;
            }
          }
          if (m === null) {
            p = [!1];
            break;
          }
          if (m <= h) {
            p = [!0];
            break;
          }
          p = [!1];
        }
        break;
      case 2:
        {
          var y, x = (0, _operators$2.getPrecedence)(l[0], o), _ = (0, _operators$2.isAssociativeWith)(s, l[0], o);
          x === null ? y = !1 : x === h && u === "right" && !_ || x < h ? y = !0 : y = !1;
          var $, b = (0, _operators$2.getPrecedence)(l[1], o), M = (0, _operators$2.isAssociativeWith)(s, l[1], o);
          if (b === null ? $ = !1 : b === h && u === "left" && !M || b < h ? $ = !0 : $ = !1, d) {
            var C, S, A;
            o === "keep" ? (C = s.getIdentifier(), S = s.args[0].getIdentifier(), A = s.args[1].getIdentifier()) : (C = s.getContent().getIdentifier(), S = s.args[0].getContent().getIdentifier(), A = s.args[1].getContent().getIdentifier()), x !== null && (_operators$2.properties[h][C].latexLeftParens === !1 && (y = !1), _operators$2.properties[x][S].latexParens === !1 && (y = !1)), b !== null && (_operators$2.properties[h][C].latexRightParens === !1 && ($ = !1), _operators$2.properties[b][A].latexParens === !1 && ($ = !1));
          }
          p = [y, $];
        }
        break;
      default:
        (s.getIdentifier() === "OperatorNode:add" || s.getIdentifier() === "OperatorNode:multiply") && (p = l.map(function(D) {
          var N = (0, _operators$2.getPrecedence)(D, o), T = (0, _operators$2.isAssociativeWith)(s, D, o), R = (0, _operators$2.getAssociativity)(D, o);
          return N === null ? !1 : h === N && u === R && !T ? !0 : N < h;
        }));
        break;
    }
    return l.length >= 2 && s.getIdentifier() === "OperatorNode:multiply" && s.implicit && o === "auto" && c === "hide" && (p = l.map(function(D, N) {
      var T = D.getIdentifier() === "ParenthesisNode";
      return !!(p[N] || T);
    })), p;
  }
  return n.prototype._toString = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = s && s.implicit ? s.implicit : "hide", l = this.args, d = a(this, o, c, l, !1);
    if (l.length === 1) {
      var h = (0, _operators$2.getAssociativity)(this, o), u = l[0].toString(s);
      d[0] && (u = "(" + u + ")");
      var p = /[a-zA-Z]+/.test(this.op);
      return h === "right" ? this.op + (p ? " " : "") + u : h === "left" ? u + (p ? " " : "") + this.op : u + this.op;
    } else if (l.length === 2) {
      var m = l[0].toString(s), g = l[1].toString(s);
      return d[0] && (m = "(" + m + ")"), d[1] && (g = "(" + g + ")"), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? m + " " + g : m + " " + this.op + " " + g;
    } else if (l.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
      var v = l.map(function(y, x) {
        return y = y.toString(s), d[x] && (y = "(" + y + ")"), y;
      });
      return this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? v.join(" ") : v.join(" " + this.op + " ");
    } else
      return this.fn + "(" + this.args.join(", ") + ")";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "OperatorNode",
      op: this.op,
      fn: this.fn,
      args: this.args,
      implicit: this.implicit
    };
  }, n.fromJSON = function(s) {
    return new n(s.op, s.fn, s.args, s.implicit);
  }, n.prototype.toHTML = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = s && s.implicit ? s.implicit : "hide", l = this.args, d = a(this, o, c, l, !1);
    if (l.length === 1) {
      var h = (0, _operators$2.getAssociativity)(this, o), u = l[0].toHTML(s);
      return d[0] && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>'), h === "right" ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + (0, _string$b.escape)(this.op) + "</span>" + u : u + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + (0, _string$b.escape)(this.op) + "</span>";
    } else if (l.length === 2) {
      var p = l[0].toHTML(s), m = l[1].toHTML(s);
      return d[0] && (p = '<span class="math-parenthesis math-round-parenthesis">(</span>' + p + '<span class="math-parenthesis math-round-parenthesis">)</span>'), d[1] && (m = '<span class="math-parenthesis math-round-parenthesis">(</span>' + m + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? p + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + m : p + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, _string$b.escape)(this.op) + "</span>" + m;
    } else {
      var g = l.map(function(v, y) {
        return v = v.toHTML(s), d[y] && (v = '<span class="math-parenthesis math-round-parenthesis">(</span>' + v + '<span class="math-parenthesis math-round-parenthesis">)</span>'), v;
      });
      return l.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply") ? this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? g.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : g.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, _string$b.escape)(this.op) + "</span>") : '<span class="math-function">' + (0, _string$b.escape)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + g.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
  }, n.prototype._toTex = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = s && s.implicit ? s.implicit : "hide", l = this.args, d = a(this, o, c, l, !0), h = _latex$3.latexOperators[this.fn];
    if (h = typeof h > "u" ? this.op : h, l.length === 1) {
      var u = (0, _operators$2.getAssociativity)(this, o), p = l[0].toTex(s);
      return d[0] && (p = "\\left(".concat(p, "\\right)")), u === "right" ? h + p : p + h;
    } else if (l.length === 2) {
      var m = l[0], g = m.toTex(s);
      d[0] && (g = "\\left(".concat(g, "\\right)"));
      var v = l[1], y = v.toTex(s);
      d[1] && (y = "\\left(".concat(y, "\\right)"));
      var x;
      switch (o === "keep" ? x = m.getIdentifier() : x = m.getContent().getIdentifier(), this.getIdentifier()) {
        case "OperatorNode:divide":
          return h + "{" + g + "}{" + y + "}";
        case "OperatorNode:pow":
          switch (g = "{" + g + "}", y = "{" + y + "}", x) {
            case "ConditionalNode":
            case "OperatorNode:divide":
              g = "\\left(".concat(g, "\\right)");
          }
          break;
        case "OperatorNode:multiply":
          if (this.implicit && c === "hide")
            return g + "~" + y;
      }
      return g + h + y;
    } else if (l.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
      var _ = l.map(function($, b) {
        return $ = $.toTex(s), d[b] && ($ = "\\left(".concat($, "\\right)")), $;
      });
      return this.getIdentifier() === "OperatorNode:multiply" && this.implicit ? _.join("~") : _.join(h);
    } else
      return "\\mathrm{" + this.fn + "}\\left(" + l.map(function($) {
        return $.toTex(s);
      }).join(",") + "\\right)";
  }, n.prototype.getIdentifier = function() {
    return this.type + ":" + this.fn;
  }, n;
}, {
  isClass: !0,
  isNode: !0
});
OperatorNode.createOperatorNode = createOperatorNode;
var ParenthesisNode = {};
Object.defineProperty(ParenthesisNode, "__esModule", {
  value: !0
});
ParenthesisNode.createParenthesisNode = void 0;
var _is$F = is, _factory$1h = factory$1, name$1e = "ParenthesisNode", dependencies$1d = ["Node"], createParenthesisNode = /* @__PURE__ */ (0, _factory$1h.factory)(name$1e, dependencies$1d, function(t) {
  var r = t.Node;
  function n(a) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!(0, _is$F.isNode)(a))
      throw new TypeError('Node expected for parameter "content"');
    this.content = a;
  }
  return n.prototype = new r(), n.prototype.type = "ParenthesisNode", n.prototype.isParenthesisNode = !0, n.prototype._compile = function(a, s) {
    return this.content._compile(a, s);
  }, n.prototype.getContent = function() {
    return this.content.getContent();
  }, n.prototype.forEach = function(a) {
    a(this.content, "content", this);
  }, n.prototype.map = function(a) {
    var s = a(this.content, "content", this);
    return new n(s);
  }, n.prototype.clone = function() {
    return new n(this.content);
  }, n.prototype._toString = function(a) {
    return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? "(" + this.content.toString(a) + ")" : this.content.toString(a);
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ParenthesisNode",
      content: this.content
    };
  }, n.fromJSON = function(a) {
    return new n(a.content);
  }, n.prototype.toHTML = function(a) {
    return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(a) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(a);
  }, n.prototype._toTex = function(a) {
    return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? "\\left(".concat(this.content.toTex(a), "\\right)") : this.content.toTex(a);
  }, n;
}, {
  isClass: !0,
  isNode: !0
});
ParenthesisNode.createParenthesisNode = createParenthesisNode;
var RangeNode = {};
Object.defineProperty(RangeNode, "__esModule", {
  value: !0
});
RangeNode.createRangeNode = void 0;
var _is$E = is, _factory$1g = factory$1, _operators$1 = operators, name$1d = "RangeNode", dependencies$1c = ["Node"], createRangeNode = /* @__PURE__ */ (0, _factory$1g.factory)(name$1d, dependencies$1c, function(t) {
  var r = t.Node;
  function n(s, o, c) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!(0, _is$E.isNode)(s))
      throw new TypeError("Node expected");
    if (!(0, _is$E.isNode)(o))
      throw new TypeError("Node expected");
    if (c && !(0, _is$E.isNode)(c))
      throw new TypeError("Node expected");
    if (arguments.length > 3)
      throw new Error("Too many arguments");
    this.start = s, this.end = o, this.step = c || null;
  }
  n.prototype = new r(), n.prototype.type = "RangeNode", n.prototype.isRangeNode = !0, n.prototype.needsEnd = function() {
    var s = this.filter(function(o) {
      return (0, _is$E.isSymbolNode)(o) && o.name === "end";
    });
    return s.length > 0;
  }, n.prototype._compile = function(s, o) {
    var c = s.range, l = this.start._compile(s, o), d = this.end._compile(s, o);
    if (this.step) {
      var h = this.step._compile(s, o);
      return function(p, m, g) {
        return c(l(p, m, g), d(p, m, g), h(p, m, g));
      };
    } else
      return function(p, m, g) {
        return c(l(p, m, g), d(p, m, g));
      };
  }, n.prototype.forEach = function(s) {
    s(this.start, "start", this), s(this.end, "end", this), this.step && s(this.step, "step", this);
  }, n.prototype.map = function(s) {
    return new n(this._ifNode(s(this.start, "start", this)), this._ifNode(s(this.end, "end", this)), this.step && this._ifNode(s(this.step, "step", this)));
  }, n.prototype.clone = function() {
    return new n(this.start, this.end, this.step && this.step);
  };
  function a(s, o) {
    var c = (0, _operators$1.getPrecedence)(s, o), l = {}, d = (0, _operators$1.getPrecedence)(s.start, o);
    if (l.start = d !== null && d <= c || o === "all", s.step) {
      var h = (0, _operators$1.getPrecedence)(s.step, o);
      l.step = h !== null && h <= c || o === "all";
    }
    var u = (0, _operators$1.getPrecedence)(s.end, o);
    return l.end = u !== null && u <= c || o === "all", l;
  }
  return n.prototype._toString = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = a(this, o), l, d = this.start.toString(s);
    if (c.start && (d = "(" + d + ")"), l = d, this.step) {
      var h = this.step.toString(s);
      c.step && (h = "(" + h + ")"), l += ":" + h;
    }
    var u = this.end.toString(s);
    return c.end && (u = "(" + u + ")"), l += ":" + u, l;
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "RangeNode",
      start: this.start,
      end: this.end,
      step: this.step
    };
  }, n.fromJSON = function(s) {
    return new n(s.start, s.end, s.step);
  }, n.prototype.toHTML = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = a(this, o), l, d = this.start.toHTML(s);
    if (c.start && (d = '<span class="math-parenthesis math-round-parenthesis">(</span>' + d + '<span class="math-parenthesis math-round-parenthesis">)</span>'), l = d, this.step) {
      var h = this.step.toHTML(s);
      c.step && (h = '<span class="math-parenthesis math-round-parenthesis">(</span>' + h + '<span class="math-parenthesis math-round-parenthesis">)</span>'), l += '<span class="math-operator math-range-operator">:</span>' + h;
    }
    var u = this.end.toHTML(s);
    return c.end && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>'), l += '<span class="math-operator math-range-operator">:</span>' + u, l;
  }, n.prototype._toTex = function(s) {
    var o = s && s.parenthesis ? s.parenthesis : "keep", c = a(this, o), l = this.start.toTex(s);
    if (c.start && (l = "\\left(".concat(l, "\\right)")), this.step) {
      var d = this.step.toTex(s);
      c.step && (d = "\\left(".concat(d, "\\right)")), l += ":" + d;
    }
    var h = this.end.toTex(s);
    return c.end && (h = "\\left(".concat(h, "\\right)")), l += ":" + h, l;
  }, n;
}, {
  isClass: !0,
  isNode: !0
});
RangeNode.createRangeNode = createRangeNode;
var RelationalNode = {};
Object.defineProperty(RelationalNode, "__esModule", {
  value: !0
});
RelationalNode.createRelationalNode = void 0;
var _operators = operators, _string$a = string$2, _customs$4 = customs, _latex$2 = latex, _factory$1f = factory$1, name$1c = "RelationalNode", dependencies$1b = ["Node"], createRelationalNode = /* @__PURE__ */ (0, _factory$1f.factory)(name$1c, dependencies$1b, function(t) {
  var r = t.Node;
  function n(a, s) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!Array.isArray(a))
      throw new TypeError("Parameter conditionals must be an array");
    if (!Array.isArray(s))
      throw new TypeError("Parameter params must be an array");
    if (a.length !== s.length - 1)
      throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
    this.conditionals = a, this.params = s;
  }
  return n.prototype = new r(), n.prototype.type = "RelationalNode", n.prototype.isRelationalNode = !0, n.prototype._compile = function(a, s) {
    var o = this, c = this.params.map(function(l) {
      return l._compile(a, s);
    });
    return function(d, h, u) {
      for (var p, m = c[0](d, h, u), g = 0; g < o.conditionals.length; g++) {
        p = m, m = c[g + 1](d, h, u);
        var v = (0, _customs$4.getSafeProperty)(a, o.conditionals[g]);
        if (!v(p, m))
          return !1;
      }
      return !0;
    };
  }, n.prototype.forEach = function(a) {
    var s = this;
    this.params.forEach(function(o, c) {
      return a(o, "params[" + c + "]", s);
    }, this);
  }, n.prototype.map = function(a) {
    var s = this;
    return new n(this.conditionals.slice(), this.params.map(function(o, c) {
      return s._ifNode(a(o, "params[" + c + "]", s));
    }, this));
  }, n.prototype.clone = function() {
    return new n(this.conditionals, this.params);
  }, n.prototype._toString = function(a) {
    for (var s = a && a.parenthesis ? a.parenthesis : "keep", o = (0, _operators.getPrecedence)(this, s), c = this.params.map(function(u, p) {
      var m = (0, _operators.getPrecedence)(u, s);
      return s === "all" || m !== null && m <= o ? "(" + u.toString(a) + ")" : u.toString(a);
    }), l = {
      equal: "==",
      unequal: "!=",
      smaller: "<",
      larger: ">",
      smallerEq: "<=",
      largerEq: ">="
    }, d = c[0], h = 0; h < this.conditionals.length; h++)
      d += " " + l[this.conditionals[h]] + " " + c[h + 1];
    return d;
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "RelationalNode",
      conditionals: this.conditionals,
      params: this.params
    };
  }, n.fromJSON = function(a) {
    return new n(a.conditionals, a.params);
  }, n.prototype.toHTML = function(a) {
    for (var s = a && a.parenthesis ? a.parenthesis : "keep", o = (0, _operators.getPrecedence)(this, s), c = this.params.map(function(u, p) {
      var m = (0, _operators.getPrecedence)(u, s);
      return s === "all" || m !== null && m <= o ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + u.toHTML(a) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : u.toHTML(a);
    }), l = {
      equal: "==",
      unequal: "!=",
      smaller: "<",
      larger: ">",
      smallerEq: "<=",
      largerEq: ">="
    }, d = c[0], h = 0; h < this.conditionals.length; h++)
      d += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + (0, _string$a.escape)(l[this.conditionals[h]]) + "</span>" + c[h + 1];
    return d;
  }, n.prototype._toTex = function(a) {
    for (var s = a && a.parenthesis ? a.parenthesis : "keep", o = (0, _operators.getPrecedence)(this, s), c = this.params.map(function(h, u) {
      var p = (0, _operators.getPrecedence)(h, s);
      return s === "all" || p !== null && p <= o ? "\\left(" + h.toTex(a) + "\right)" : h.toTex(a);
    }), l = c[0], d = 0; d < this.conditionals.length; d++)
      l += _latex$2.latexOperators[this.conditionals[d]] + c[d + 1];
    return l;
  }, n;
}, {
  isClass: !0,
  isNode: !0
});
RelationalNode.createRelationalNode = createRelationalNode;
var SymbolNode = {};
Object.defineProperty(SymbolNode, "__esModule", {
  value: !0
});
SymbolNode.createSymbolNode = void 0;
var _string$9 = string$2, _customs$3 = customs, _factory$1e = factory$1, _latex$1 = latex, name$1b = "SymbolNode", dependencies$1a = ["math", "?Unit", "Node"], createSymbolNode = /* @__PURE__ */ (0, _factory$1e.factory)(name$1b, dependencies$1a, function(t) {
  var r = t.math, n = t.Unit, a = t.Node;
  function s(l) {
    return n ? n.isValuelessUnit(l) : !1;
  }
  function o(l) {
    if (!(this instanceof o))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (typeof l != "string")
      throw new TypeError('String expected for parameter "name"');
    this.name = l;
  }
  o.prototype = new a(), o.prototype.type = "SymbolNode", o.prototype.isSymbolNode = !0, o.prototype._compile = function(l, d) {
    var h = this.name;
    if (d[h] === !0)
      return function(p, m, g) {
        return m[h];
      };
    if (h in l)
      return function(p, m, g) {
        return h in p ? (0, _customs$3.getSafeProperty)(p, h) : (0, _customs$3.getSafeProperty)(l, h);
      };
    var u = s(h);
    return function(p, m, g) {
      return h in p ? (0, _customs$3.getSafeProperty)(p, h) : u ? new n(null, h) : c(h);
    };
  }, o.prototype.forEach = function(l) {
  }, o.prototype.map = function(l) {
    return this.clone();
  };
  function c(l) {
    throw new Error("Undefined symbol " + l);
  }
  return o.prototype.clone = function() {
    return new o(this.name);
  }, o.prototype._toString = function(l) {
    return this.name;
  }, o.prototype.toHTML = function(l) {
    var d = (0, _string$9.escape)(this.name);
    return d === "true" || d === "false" ? '<span class="math-symbol math-boolean">' + d + "</span>" : d === "i" ? '<span class="math-symbol math-imaginary-symbol">' + d + "</span>" : d === "Infinity" ? '<span class="math-symbol math-infinity-symbol">' + d + "</span>" : d === "NaN" ? '<span class="math-symbol math-nan-symbol">' + d + "</span>" : d === "null" ? '<span class="math-symbol math-null-symbol">' + d + "</span>" : d === "undefined" ? '<span class="math-symbol math-undefined-symbol">' + d + "</span>" : '<span class="math-symbol">' + d + "</span>";
  }, o.prototype.toJSON = function() {
    return {
      mathjs: "SymbolNode",
      name: this.name
    };
  }, o.fromJSON = function(l) {
    return new o(l.name);
  }, o.prototype._toTex = function(l) {
    var d = !1;
    typeof r[this.name] > "u" && s(this.name) && (d = !0);
    var h = (0, _latex$1.toSymbol)(this.name, d);
    return h[0] === "\\" ? h : " " + h;
  }, o;
}, {
  isClass: !0,
  isNode: !0
});
SymbolNode.createSymbolNode = createSymbolNode;
var FunctionNode = {};
Object.defineProperty(FunctionNode, "__esModule", {
  value: !0
});
FunctionNode.createFunctionNode = void 0;
var _is$D = is, _string$8 = string$2, _object$d = object, _array$b = array, _customs$2 = customs, _factory$1d = factory$1, _latex = latex;
function _typeof$6(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(n) {
    return typeof n;
  } : _typeof$6 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$6(t);
}
function _extends$3() {
  return _extends$3 = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends$3.apply(this, arguments);
}
var name$1a = "FunctionNode", dependencies$19 = ["math", "Node", "SymbolNode"], createFunctionNode = /* @__PURE__ */ (0, _factory$1d.factory)(name$1a, dependencies$19, function(t) {
  var r = t.math, n = t.Node, a = t.SymbolNode;
  function s(d, h) {
    if (!(this instanceof s))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (typeof d == "string" && (d = new a(d)), !(0, _is$D.isNode)(d))
      throw new TypeError('Node expected as parameter "fn"');
    if (!Array.isArray(h) || !h.every(_is$D.isNode))
      throw new TypeError('Array containing Nodes expected for parameter "args"');
    this.fn = d, this.args = h || [], Object.defineProperty(this, "name", {
      get: (function() {
        return this.fn.name || "";
      }).bind(this),
      set: function() {
        throw new Error("Cannot assign a new name, name is read-only");
      }
    });
  }
  s.prototype = new n(), s.prototype.type = "FunctionNode", s.prototype.isFunctionNode = !0, s.prototype._compile = function(d, h) {
    if (!(this instanceof s))
      throw new TypeError("No valid FunctionNode");
    var u = (0, _array$b.map)(this.args, function(A) {
      return A._compile(d, h);
    });
    if ((0, _is$D.isSymbolNode)(this.fn)) {
      var p = this.fn.name, m = p in d ? (0, _customs$2.getSafeProperty)(d, p) : void 0, g = typeof m == "function" && m.rawArgs === !0;
      if (g) {
        var v = this.args;
        return function(D, N, T) {
          return (p in D ? (0, _customs$2.getSafeProperty)(D, p) : m)(v, d, _extends$3({}, D, N));
        };
      } else if (u.length === 1) {
        var y = u[0];
        return function(D, N, T) {
          return (p in D ? (0, _customs$2.getSafeProperty)(D, p) : m)(y(D, N, T));
        };
      } else if (u.length === 2) {
        var x = u[0], _ = u[1];
        return function(D, N, T) {
          return (p in D ? (0, _customs$2.getSafeProperty)(D, p) : m)(x(D, N, T), _(D, N, T));
        };
      } else
        return function(D, N, T) {
          return (p in D ? (0, _customs$2.getSafeProperty)(D, p) : m).apply(null, (0, _array$b.map)(u, function(R) {
            return R(D, N, T);
          }));
        };
    } else if ((0, _is$D.isAccessorNode)(this.fn) && (0, _is$D.isIndexNode)(this.fn.index) && this.fn.index.isObjectProperty()) {
      var $ = this.fn.object._compile(d, h), b = this.fn.index.getObjectProperty(), M = this.args;
      return function(D, N, T) {
        var R = $(D, N, T);
        (0, _customs$2.validateSafeMethod)(R, b);
        var F = R[b] && R[b].rawArgs;
        return F ? R[b](M, d, _extends$3({}, D, N)) : R[b].apply(R, (0, _array$b.map)(u, function(z) {
          return z(D, N, T);
        }));
      };
    } else {
      var C = this.fn._compile(d, h), S = this.args;
      return function(D, N, T) {
        var R = C(D, N, T), F = R && R.rawArgs;
        return F ? R(S, d, _extends$3({}, D, N)) : R.apply(R, (0, _array$b.map)(u, function(z) {
          return z(D, N, T);
        }));
      };
    }
  }, s.prototype.forEach = function(d) {
    d(this.fn, "fn", this);
    for (var h = 0; h < this.args.length; h++)
      d(this.args[h], "args[" + h + "]", this);
  }, s.prototype.map = function(d) {
    for (var h = this._ifNode(d(this.fn, "fn", this)), u = [], p = 0; p < this.args.length; p++)
      u[p] = this._ifNode(d(this.args[p], "args[" + p + "]", this));
    return new s(h, u);
  }, s.prototype.clone = function() {
    return new s(this.fn, this.args.slice(0));
  };
  var o = s.prototype.toString;
  s.prototype.toString = function(d) {
    var h, u = this.fn.toString(d);
    return d && _typeof$6(d.handler) === "object" && (0, _object$d.hasOwnProperty)(d.handler, u) && (h = d.handler[u](this, d)), typeof h < "u" ? h : o.call(this, d);
  }, s.prototype._toString = function(d) {
    var h = this.args.map(function(p) {
      return p.toString(d);
    }), u = (0, _is$D.isFunctionAssignmentNode)(this.fn) ? "(" + this.fn.toString(d) + ")" : this.fn.toString(d);
    return u + "(" + h.join(", ") + ")";
  }, s.prototype.toJSON = function() {
    return {
      mathjs: "FunctionNode",
      fn: this.fn,
      args: this.args
    };
  }, s.fromJSON = function(d) {
    return new s(d.fn, d.args);
  }, s.prototype.toHTML = function(d) {
    var h = this.args.map(function(u) {
      return u.toHTML(d);
    });
    return '<span class="math-function">' + (0, _string$8.escape)(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + h.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
  };
  function c(d, h, u) {
    for (var p = "", m = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, g = 0, v; (v = m.exec(d)) !== null; )
      if (p += d.substring(g, v.index), g = v.index, v[0] === "$$")
        p += "$", g++;
      else {
        g += v[0].length;
        var y = h[v[1]];
        if (!y)
          throw new ReferenceError("Template: Property " + v[1] + " does not exist.");
        if (v[2] === void 0)
          switch (_typeof$6(y)) {
            case "string":
              p += y;
              break;
            case "object":
              if ((0, _is$D.isNode)(y))
                p += y.toTex(u);
              else if (Array.isArray(y))
                p += y.map(function(x, _) {
                  if ((0, _is$D.isNode)(x))
                    return x.toTex(u);
                  throw new TypeError("Template: " + v[1] + "[" + _ + "] is not a Node.");
                }).join(",");
              else
                throw new TypeError("Template: " + v[1] + " has to be a Node, String or array of Nodes");
              break;
            default:
              throw new TypeError("Template: " + v[1] + " has to be a Node, String or array of Nodes");
          }
        else if ((0, _is$D.isNode)(y[v[2]] && y[v[2]]))
          p += y[v[2]].toTex(u);
        else
          throw new TypeError("Template: " + v[1] + "[" + v[2] + "] is not a Node.");
      }
    return p += d.slice(g), p;
  }
  var l = s.prototype.toTex;
  return s.prototype.toTex = function(d) {
    var h;
    return d && _typeof$6(d.handler) === "object" && (0, _object$d.hasOwnProperty)(d.handler, this.name) && (h = d.handler[this.name](this, d)), typeof h < "u" ? h : l.call(this, d);
  }, s.prototype._toTex = function(d) {
    var h = this.args.map(function(m) {
      return m.toTex(d);
    }), u;
    _latex.latexFunctions[this.name] && (u = _latex.latexFunctions[this.name]), r[this.name] && (typeof r[this.name].toTex == "function" || _typeof$6(r[this.name].toTex) === "object" || typeof r[this.name].toTex == "string") && (u = r[this.name].toTex);
    var p;
    switch (_typeof$6(u)) {
      case "function":
        p = u(this, d);
        break;
      case "string":
        p = c(u, this, d);
        break;
      case "object":
        switch (_typeof$6(u[h.length])) {
          case "function":
            p = u[h.length](this, d);
            break;
          case "string":
            p = c(u[h.length], this, d);
            break;
        }
    }
    return typeof p < "u" ? p : c(_latex.defaultTemplate, this, d);
  }, s.prototype.getIdentifier = function() {
    return this.type + ":" + this.name;
  }, s;
}, {
  isClass: !0,
  isNode: !0
});
FunctionNode.createFunctionNode = createFunctionNode;
var parse$2 = {};
Object.defineProperty(parse$2, "__esModule", {
  value: !0
});
parse$2.createParse = void 0;
var _factory$1c = factory$1, _is$C = is, _collection$9 = collection$1, _object$c = object;
function _extends$2() {
  return _extends$2 = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends$2.apply(this, arguments);
}
var name$19 = "parse", dependencies$18 = ["typed", "numeric", "config", "AccessorNode", "ArrayNode", "AssignmentNode", "BlockNode", "ConditionalNode", "ConstantNode", "FunctionAssignmentNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "RangeNode", "RelationalNode", "SymbolNode"], createParse = /* @__PURE__ */ (0, _factory$1c.factory)(name$19, dependencies$18, function(t) {
  var r = t.typed, n = t.numeric, a = t.config, s = t.AccessorNode, o = t.ArrayNode, c = t.AssignmentNode, l = t.BlockNode, d = t.ConditionalNode, h = t.ConstantNode, u = t.FunctionAssignmentNode, p = t.FunctionNode, m = t.IndexNode, g = t.ObjectNode, v = t.OperatorNode, y = t.ParenthesisNode, x = t.RangeNode, _ = t.RelationalNode, $ = t.SymbolNode, b = r(name$19, {
    string: function(dr) {
      return V(dr, {});
    },
    "Array | Matrix": function(dr) {
      return M(dr, {});
    },
    "string, Object": function(dr, Ar) {
      var jr = Ar.nodes !== void 0 ? Ar.nodes : {};
      return V(dr, jr);
    },
    "Array | Matrix, Object": M
  });
  function M(H) {
    var dr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ar = dr.nodes !== void 0 ? dr.nodes : {};
    return (0, _collection$9.deepMap)(H, function(jr) {
      if (typeof jr != "string")
        throw new TypeError("String expected");
      return V(jr, Ar);
    });
  }
  var C = {
    NULL: 0,
    DELIMITER: 1,
    NUMBER: 2,
    SYMBOL: 3,
    UNKNOWN: 4
  }, S = {
    ",": !0,
    "(": !0,
    ")": !0,
    "[": !0,
    "]": !0,
    "{": !0,
    "}": !0,
    '"': !0,
    "'": !0,
    ";": !0,
    "+": !0,
    "-": !0,
    "*": !0,
    ".*": !0,
    "/": !0,
    "./": !0,
    "%": !0,
    "^": !0,
    ".^": !0,
    "~": !0,
    "!": !0,
    "&": !0,
    "|": !0,
    "^|": !0,
    "=": !0,
    ":": !0,
    "?": !0,
    "==": !0,
    "!=": !0,
    "<": !0,
    ">": !0,
    "<=": !0,
    ">=": !0,
    "<<": !0,
    ">>": !0,
    ">>>": !0
  }, A = {
    mod: !0,
    to: !0,
    in: !0,
    and: !0,
    xor: !0,
    or: !0,
    not: !0
  }, D = {
    true: !0,
    false: !1,
    null: null,
    undefined: void 0
  }, N = ["NaN", "Infinity"];
  function T() {
    return {
      extraNodes: {},
      // current extra nodes, must be careful not to mutate
      expression: "",
      // current expression
      comment: "",
      // last parsed comment
      index: 0,
      // current index in expr
      token: "",
      // current token
      tokenType: C.NULL,
      // type of the token
      nestingLevel: 0,
      // level of nesting inside parameters, used to ignore newline characters
      conditionalLevel: null
      // when a conditional is being parsed, the level of the conditional is stored here
    };
  }
  function R(H, dr) {
    return H.expression.substr(H.index, dr);
  }
  function F(H) {
    return R(H, 1);
  }
  function z(H) {
    H.index++;
  }
  function O(H) {
    return H.expression.charAt(H.index - 1);
  }
  function G(H) {
    return H.expression.charAt(H.index + 1);
  }
  function I(H) {
    for (H.tokenType = C.NULL, H.token = "", H.comment = ""; b.isWhitespace(F(H), H.nestingLevel); )
      z(H);
    if (F(H) === "#")
      for (; F(H) !== `
` && F(H) !== ""; )
        H.comment += F(H), z(H);
    if (F(H) === "") {
      H.tokenType = C.DELIMITER;
      return;
    }
    if (F(H) === `
` && !H.nestingLevel) {
      H.tokenType = C.DELIMITER, H.token = F(H), z(H);
      return;
    }
    var dr = F(H), Ar = R(H, 2), jr = R(H, 3);
    if (jr.length === 3 && S[jr]) {
      H.tokenType = C.DELIMITER, H.token = jr, z(H), z(H), z(H);
      return;
    }
    if (Ar.length === 2 && S[Ar]) {
      H.tokenType = C.DELIMITER, H.token = Ar, z(H), z(H);
      return;
    }
    if (S[dr]) {
      H.tokenType = C.DELIMITER, H.token = dr, z(H);
      return;
    }
    if (b.isDigitDot(dr)) {
      H.tokenType = C.NUMBER;
      var Vr = R(H, 2);
      if (Vr === "0b" || Vr === "0o" || Vr === "0x") {
        for (H.token += F(H), z(H), H.token += F(H), z(H); b.isHexDigit(F(H)); )
          H.token += F(H), z(H);
        return;
      }
      if (F(H) === ".")
        H.token += F(H), z(H), b.isDigit(F(H)) || (H.tokenType = C.DELIMITER);
      else {
        for (; b.isDigit(F(H)); )
          H.token += F(H), z(H);
        b.isDecimalMark(F(H), G(H)) && (H.token += F(H), z(H));
      }
      for (; b.isDigit(F(H)); )
        H.token += F(H), z(H);
      if (F(H) === "E" || F(H) === "e") {
        if (b.isDigit(G(H)) || G(H) === "-" || G(H) === "+") {
          if (H.token += F(H), z(H), (F(H) === "+" || F(H) === "-") && (H.token += F(H), z(H)), !b.isDigit(F(H)))
            throw zr(H, 'Digit expected, got "' + F(H) + '"');
          for (; b.isDigit(F(H)); )
            H.token += F(H), z(H);
          if (b.isDecimalMark(F(H), G(H)))
            throw zr(H, 'Digit expected, got "' + F(H) + '"');
        } else if (G(H) === ".")
          throw z(H), zr(H, 'Digit expected, got "' + F(H) + '"');
      }
      return;
    }
    if (b.isAlpha(F(H), O(H), G(H))) {
      for (; b.isAlpha(F(H), O(H), G(H)) || b.isDigit(F(H)); )
        H.token += F(H), z(H);
      (0, _object$c.hasOwnProperty)(A, H.token) ? H.tokenType = C.DELIMITER : H.tokenType = C.SYMBOL;
      return;
    }
    for (H.tokenType = C.UNKNOWN; F(H) !== ""; )
      H.token += F(H), z(H);
    throw zr(H, 'Syntax error in part "' + H.token + '"');
  }
  function k(H) {
    do
      I(H);
    while (H.token === `
`);
  }
  function B(H) {
    H.nestingLevel++;
  }
  function L(H) {
    H.nestingLevel--;
  }
  b.isAlpha = function(dr, Ar, jr) {
    return b.isValidLatinOrGreek(dr) || b.isValidMathSymbol(dr, jr) || b.isValidMathSymbol(Ar, dr);
  }, b.isValidLatinOrGreek = function(dr) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(dr);
  }, b.isValidMathSymbol = function(dr, Ar) {
    return /^[\uD835]$/.test(dr) && /^[\uDC00-\uDFFF]$/.test(Ar) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(Ar);
  }, b.isWhitespace = function(dr, Ar) {
    return dr === " " || dr === "	" || dr === `
` && Ar > 0;
  }, b.isDecimalMark = function(dr, Ar) {
    return dr === "." && Ar !== "/" && Ar !== "*" && Ar !== "^";
  }, b.isDigitDot = function(dr) {
    return dr >= "0" && dr <= "9" || dr === ".";
  }, b.isDigit = function(dr) {
    return dr >= "0" && dr <= "9";
  }, b.isHexDigit = function(dr) {
    return dr >= "0" && dr <= "9" || dr >= "a" && dr <= "f" || dr >= "A" && dr <= "F";
  };
  function V(H, dr) {
    var Ar = T();
    _extends$2(Ar, {
      expression: H,
      extraNodes: dr
    }), I(Ar);
    var jr = U(Ar);
    if (Ar.token !== "")
      throw Ar.tokenType === C.DELIMITER ? Jr(Ar, "Unexpected operator " + Ar.token) : zr(Ar, 'Unexpected part "' + Ar.token + '"');
    return jr;
  }
  function U(H) {
    var dr, Ar = [], jr;
    for (H.token !== "" && H.token !== `
` && H.token !== ";" && (dr = J(H), dr.comment = H.comment); H.token === `
` || H.token === ";"; )
      Ar.length === 0 && dr && (jr = H.token !== ";", Ar.push({
        node: dr,
        visible: jr
      })), I(H), H.token !== `
` && H.token !== ";" && H.token !== "" && (dr = J(H), dr.comment = H.comment, jr = H.token !== ";", Ar.push({
        node: dr,
        visible: jr
      }));
    return Ar.length > 0 ? new l(Ar) : (dr || (dr = new h(void 0), dr.comment = H.comment), dr);
  }
  function J(H) {
    var dr, Ar, jr, Vr, Zr = q(H);
    if (H.token === "=") {
      if ((0, _is$C.isSymbolNode)(Zr))
        return dr = Zr.name, k(H), jr = J(H), new c(new $(dr), jr);
      if ((0, _is$C.isAccessorNode)(Zr))
        return k(H), jr = J(H), new c(Zr.object, Zr.index, jr);
      if ((0, _is$C.isFunctionNode)(Zr) && (0, _is$C.isSymbolNode)(Zr.fn) && (Vr = !0, Ar = [], dr = Zr.name, Zr.args.forEach(function(pn, gr) {
        (0, _is$C.isSymbolNode)(pn) ? Ar[gr] = pn.name : Vr = !1;
      }), Vr))
        return k(H), jr = J(H), new u(dr, Ar, jr);
      throw zr(H, "Invalid left hand side of assignment operator =");
    }
    return Zr;
  }
  function q(H) {
    for (var dr = Z(H); H.token === "?"; ) {
      var Ar = H.conditionalLevel;
      H.conditionalLevel = H.nestingLevel, k(H);
      var jr = dr, Vr = J(H);
      if (H.token !== ":")
        throw zr(H, "False part of conditional expression expected");
      H.conditionalLevel = null, k(H);
      var Zr = J(H);
      dr = new d(jr, Vr, Zr), H.conditionalLevel = Ar;
    }
    return dr;
  }
  function Z(H) {
    for (var dr = ae(H); H.token === "or"; )
      k(H), dr = new v("or", "or", [dr, ae(H)]);
    return dr;
  }
  function ae(H) {
    for (var dr = ee(H); H.token === "xor"; )
      k(H), dr = new v("xor", "xor", [dr, ee(H)]);
    return dr;
  }
  function ee(H) {
    for (var dr = se(H); H.token === "and"; )
      k(H), dr = new v("and", "and", [dr, se(H)]);
    return dr;
  }
  function se(H) {
    for (var dr = nr(H); H.token === "|"; )
      k(H), dr = new v("|", "bitOr", [dr, nr(H)]);
    return dr;
  }
  function nr(H) {
    for (var dr = ce(H); H.token === "^|"; )
      k(H), dr = new v("^|", "bitXor", [dr, ce(H)]);
    return dr;
  }
  function ce(H) {
    for (var dr = oe(H); H.token === "&"; )
      k(H), dr = new v("&", "bitAnd", [dr, oe(H)]);
    return dr;
  }
  function oe(H) {
    for (var dr = [ur(H)], Ar = [], jr = {
      "==": "equal",
      "!=": "unequal",
      "<": "smaller",
      ">": "larger",
      "<=": "smallerEq",
      ">=": "largerEq"
    }; (0, _object$c.hasOwnProperty)(jr, H.token); ) {
      var Vr = {
        name: H.token,
        fn: jr[H.token]
      };
      Ar.push(Vr), k(H), dr.push(ur(H));
    }
    return dr.length === 1 ? dr[0] : dr.length === 2 ? new v(Ar[0].name, Ar[0].fn, dr) : new _(Ar.map(function(Zr) {
      return Zr.fn;
    }), dr);
  }
  function ur(H) {
    var dr, Ar, jr, Vr;
    dr = ir(H);
    for (var Zr = {
      "<<": "leftShift",
      ">>": "rightArithShift",
      ">>>": "rightLogShift"
    }; (0, _object$c.hasOwnProperty)(Zr, H.token); )
      Ar = H.token, jr = Zr[Ar], k(H), Vr = [dr, ir(H)], dr = new v(Ar, jr, Vr);
    return dr;
  }
  function ir(H) {
    var dr, Ar, jr, Vr;
    dr = _r(H);
    for (var Zr = {
      to: "to",
      in: "to"
      // alias of 'to'
    }; (0, _object$c.hasOwnProperty)(Zr, H.token); )
      Ar = H.token, jr = Zr[Ar], k(H), Ar === "in" && H.token === "" ? dr = new v("*", "multiply", [dr, new $("in")], !0) : (Vr = [dr, _r(H)], dr = new v(Ar, jr, Vr));
    return dr;
  }
  function _r(H) {
    var dr, Ar = [];
    if (H.token === ":" ? dr = new h(1) : dr = yr(H), H.token === ":" && H.conditionalLevel !== H.nestingLevel) {
      for (Ar.push(dr); H.token === ":" && Ar.length < 3; )
        k(H), H.token === ")" || H.token === "]" || H.token === "," || H.token === "" ? Ar.push(new $("end")) : Ar.push(yr(H));
      Ar.length === 3 ? dr = new x(Ar[0], Ar[2], Ar[1]) : dr = new x(Ar[0], Ar[1]);
    }
    return dr;
  }
  function yr(H) {
    var dr, Ar, jr, Vr;
    dr = ne(H);
    for (var Zr = {
      "+": "add",
      "-": "subtract"
    }; (0, _object$c.hasOwnProperty)(Zr, H.token); )
      Ar = H.token, jr = Zr[Ar], k(H), Vr = [dr, ne(H)], dr = new v(Ar, jr, Vr);
    return dr;
  }
  function ne(H) {
    var dr, Ar, jr, Vr;
    dr = pe(H), Ar = dr;
    for (var Zr = {
      "*": "multiply",
      ".*": "dotMultiply",
      "/": "divide",
      "./": "dotDivide",
      "%": "mod",
      mod: "mod"
    }; (0, _object$c.hasOwnProperty)(Zr, H.token); )
      jr = H.token, Vr = Zr[jr], k(H), Ar = pe(H), dr = new v(jr, Vr, [dr, Ar]);
    return dr;
  }
  function pe(H) {
    var dr, Ar;
    for (dr = hr(H), Ar = dr; H.tokenType === C.SYMBOL || H.token === "in" && (0, _is$C.isConstantNode)(dr) || H.tokenType === C.NUMBER && !(0, _is$C.isConstantNode)(Ar) && (!(0, _is$C.isOperatorNode)(Ar) || Ar.op === "!") || H.token === "("; )
      Ar = hr(H), dr = new v(
        "*",
        "multiply",
        [dr, Ar],
        !0
        /* implicit */
      );
    return dr;
  }
  function hr(H) {
    for (var dr = $r(H), Ar = dr, jr = []; H.token === "/" && (0, _is$C.isConstantNode)(Ar); )
      if (jr.push(_extends$2({}, H)), k(H), H.tokenType === C.NUMBER)
        if (jr.push(_extends$2({}, H)), k(H), H.tokenType === C.SYMBOL || H.token === "(")
          _extends$2(H, jr.pop()), jr.pop(), Ar = $r(H), dr = new v("/", "divide", [dr, Ar]);
        else {
          jr.pop(), _extends$2(H, jr.pop());
          break;
        }
      else {
        _extends$2(H, jr.pop());
        break;
      }
    return dr;
  }
  function $r(H) {
    var dr, Ar, jr, Vr = {
      "-": "unaryMinus",
      "+": "unaryPlus",
      "~": "bitNot",
      not: "not"
    };
    return (0, _object$c.hasOwnProperty)(Vr, H.token) ? (jr = Vr[H.token], dr = H.token, k(H), Ar = [$r(H)], new v(dr, jr, Ar)) : Sr(H);
  }
  function Sr(H) {
    var dr, Ar, jr, Vr;
    return dr = ze(H), (H.token === "^" || H.token === ".^") && (Ar = H.token, jr = Ar === "^" ? "pow" : "dotPow", k(H), Vr = [dr, $r(H)], dr = new v(Ar, jr, Vr)), dr;
  }
  function ze(H) {
    var dr, Ar, jr, Vr;
    dr = cr(H);
    for (var Zr = {
      "!": "factorial",
      "'": "ctranspose"
    }; (0, _object$c.hasOwnProperty)(Zr, H.token); )
      Ar = H.token, jr = Zr[Ar], I(H), Vr = [dr], dr = new v(Ar, jr, Vr), dr = mr(H, dr);
    return dr;
  }
  function cr(H) {
    var dr = [];
    if (H.tokenType === C.SYMBOL && (0, _object$c.hasOwnProperty)(H.extraNodes, H.token)) {
      var Ar = H.extraNodes[H.token];
      if (I(H), H.token === "(") {
        if (dr = [], B(H), I(H), H.token !== ")")
          for (dr.push(J(H)); H.token === ","; )
            I(H), dr.push(J(H));
        if (H.token !== ")")
          throw zr(H, "Parenthesis ) expected");
        L(H), I(H);
      }
      return new Ar(dr);
    }
    return fr(H);
  }
  function fr(H) {
    var dr, Ar;
    return H.tokenType === C.SYMBOL || H.tokenType === C.DELIMITER && H.token in A ? (Ar = H.token, I(H), (0, _object$c.hasOwnProperty)(D, Ar) ? dr = new h(D[Ar]) : N.indexOf(Ar) !== -1 ? dr = new h(n(Ar, "number")) : dr = new $(Ar), dr = mr(H, dr), dr) : wr(H);
  }
  function mr(H, dr, Ar) {
    for (var jr; (H.token === "(" || H.token === "[" || H.token === ".") && (!Ar || Ar.indexOf(H.token) !== -1); )
      if (jr = [], H.token === "(")
        if ((0, _is$C.isSymbolNode)(dr) || (0, _is$C.isAccessorNode)(dr)) {
          if (B(H), I(H), H.token !== ")")
            for (jr.push(J(H)); H.token === ","; )
              I(H), jr.push(J(H));
          if (H.token !== ")")
            throw zr(H, "Parenthesis ) expected");
          L(H), I(H), dr = new p(dr, jr);
        } else
          return dr;
      else if (H.token === "[") {
        if (B(H), I(H), H.token !== "]")
          for (jr.push(J(H)); H.token === ","; )
            I(H), jr.push(J(H));
        if (H.token !== "]")
          throw zr(H, "Parenthesis ] expected");
        L(H), I(H), dr = new s(dr, new m(jr));
      } else {
        if (I(H), H.tokenType !== C.SYMBOL)
          throw zr(H, "Property name expected after dot");
        jr.push(new h(H.token)), I(H);
        var Vr = !0;
        dr = new s(dr, new m(jr, Vr));
      }
    return dr;
  }
  function wr(H) {
    var dr, Ar;
    return H.token === '"' ? (Ar = Nr(H), dr = new h(Ar), dr = mr(H, dr), dr) : xr(H);
  }
  function Nr(H) {
    for (var dr = ""; F(H) !== "" && F(H) !== '"'; )
      F(H) === "\\" && (dr += F(H), z(H)), dr += F(H), z(H);
    if (I(H), H.token !== '"')
      throw zr(H, 'End of string " expected');
    return I(H), JSON.parse('"' + dr + '"');
  }
  function xr(H) {
    var dr, Ar;
    return H.token === "'" ? (Ar = Er(H), dr = new h(Ar), dr = mr(H, dr), dr) : Ir(H);
  }
  function Er(H) {
    for (var dr = ""; F(H) !== "" && F(H) !== "'"; )
      F(H) === "\\" && (dr += F(H), z(H)), dr += F(H), z(H);
    if (I(H), H.token !== "'")
      throw zr(H, "End of string ' expected");
    return I(H), JSON.parse('"' + dr + '"');
  }
  function Ir(H) {
    var dr, Ar, jr, Vr;
    if (H.token === "[") {
      if (B(H), I(H), H.token !== "]") {
        var Zr = Rr(H);
        if (H.token === ";") {
          for (jr = 1, Ar = [Zr]; H.token === ";"; )
            I(H), Ar[jr] = Rr(H), jr++;
          if (H.token !== "]")
            throw zr(H, "End of matrix ] expected");
          L(H), I(H), Vr = Ar[0].items.length;
          for (var pn = 1; pn < jr; pn++)
            if (Ar[pn].items.length !== Vr)
              throw Jr(H, "Column dimensions mismatch (" + Ar[pn].items.length + " !== " + Vr + ")");
          dr = new o(Ar);
        } else {
          if (H.token !== "]")
            throw zr(H, "End of matrix ] expected");
          L(H), I(H), dr = Zr;
        }
      } else
        L(H), I(H), dr = new o([]);
      return mr(H, dr);
    }
    return Yr(H);
  }
  function Rr(H) {
    for (var dr = [J(H)], Ar = 1; H.token === ","; )
      I(H), dr[Ar] = J(H), Ar++;
    return new o(dr);
  }
  function Yr(H) {
    if (H.token === "{") {
      B(H);
      var dr, Ar = {};
      do
        if (I(H), H.token !== "}") {
          if (H.token === '"')
            dr = Nr(H);
          else if (H.token === "'")
            dr = Er(H);
          else if (H.tokenType === C.SYMBOL || H.tokenType === C.DELIMITER && H.token in A)
            dr = H.token, I(H);
          else
            throw zr(H, "Symbol or string expected as object key");
          if (H.token !== ":")
            throw zr(H, "Colon : expected after object key");
          I(H), Ar[dr] = J(H);
        }
      while (H.token === ",");
      if (H.token !== "}")
        throw zr(H, "Comma , or bracket } expected after object value");
      L(H), I(H);
      var jr = new g(Ar);
      return jr = mr(H, jr), jr;
    }
    return Qr(H);
  }
  function Qr(H) {
    var dr;
    return H.tokenType === C.NUMBER ? (dr = H.token, I(H), new h(n(dr, a.number))) : nn(H);
  }
  function nn(H) {
    var dr;
    if (H.token === "(") {
      if (B(H), I(H), dr = J(H), H.token !== ")")
        throw zr(H, "Parenthesis ) expected");
      return L(H), I(H), dr = new y(dr), dr = mr(H, dr), dr;
    }
    return on(H);
  }
  function on(H) {
    throw H.token === "" ? zr(H, "Unexpected end of expression") : zr(H, "Value expected");
  }
  function en(H) {
    return H.index - H.token.length + 1;
  }
  function zr(H, dr) {
    var Ar = en(H), jr = new SyntaxError(dr + " (char " + Ar + ")");
    return jr.char = Ar, jr;
  }
  function Jr(H, dr) {
    var Ar = en(H), jr = new SyntaxError(dr + " (char " + Ar + ")");
    return jr.char = Ar, jr;
  }
  return b;
});
parse$2.createParse = createParse;
var compile$1 = {};
Object.defineProperty(compile$1, "__esModule", {
  value: !0
});
compile$1.createCompile = void 0;
var _collection$8 = collection$1, _factory$1b = factory$1, name$18 = "compile", dependencies$17 = ["typed", "parse"], createCompile = /* @__PURE__ */ (0, _factory$1b.factory)(name$18, dependencies$17, function(t) {
  var r = t.typed, n = t.parse;
  return r(name$18, {
    string: function(s) {
      return n(s).compile();
    },
    "Array | Matrix": function(s) {
      return (0, _collection$8.deepMap)(s, function(o) {
        return n(o).compile();
      });
    }
  });
});
compile$1.createCompile = createCompile;
var evaluate$2 = {};
Object.defineProperty(evaluate$2, "__esModule", {
  value: !0
});
evaluate$2.createEvaluate = void 0;
var _collection$7 = collection$1, _factory$1a = factory$1, name$17 = "evaluate", dependencies$16 = ["typed", "parse"], createEvaluate = /* @__PURE__ */ (0, _factory$1a.factory)(name$17, dependencies$16, function(t) {
  var r = t.typed, n = t.parse;
  return r(name$17, {
    string: function(s) {
      var o = {};
      return n(s).compile().evaluate(o);
    },
    "string, Object": function(s, o) {
      return n(s).compile().evaluate(o);
    },
    "Array | Matrix": function(s) {
      var o = {};
      return (0, _collection$7.deepMap)(s, function(c) {
        return n(c).compile().evaluate(o);
      });
    },
    "Array | Matrix, Object": function(s, o) {
      return (0, _collection$7.deepMap)(s, function(c) {
        return n(c).compile().evaluate(o);
      });
    }
  });
});
evaluate$2.createEvaluate = createEvaluate;
var Parser = {};
Object.defineProperty(Parser, "__esModule", {
  value: !0
});
Parser.createParserClass = void 0;
var _factory$19 = factory$1, _object$b = object, _customs$1 = customs, name$16 = "Parser", dependencies$15 = ["parse"], createParserClass = /* @__PURE__ */ (0, _factory$19.factory)(name$16, dependencies$15, function(t) {
  var r = t.parse;
  function n() {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    this.scope = {};
  }
  return n.prototype.type = "Parser", n.prototype.isParser = !0, n.prototype.evaluate = function(a) {
    return r(a).compile().evaluate(this.scope);
  }, n.prototype.get = function(a) {
    return a in this.scope ? (0, _customs$1.getSafeProperty)(this.scope, a) : void 0;
  }, n.prototype.getAll = function() {
    return (0, _object$b.extend)({}, this.scope);
  }, n.prototype.set = function(a, s) {
    return (0, _customs$1.setSafeProperty)(this.scope, a, s);
  }, n.prototype.remove = function(a) {
    delete this.scope[a];
  }, n.prototype.clear = function() {
    for (var a in this.scope)
      (0, _object$b.hasOwnProperty)(this.scope, a) && delete this.scope[a];
  }, n;
}, {
  isClass: !0
});
Parser.createParserClass = createParserClass;
var parser = {};
Object.defineProperty(parser, "__esModule", {
  value: !0
});
parser.createParser = void 0;
var _factory$18 = factory$1, name$15 = "parser", dependencies$14 = ["typed", "Parser"], createParser = /* @__PURE__ */ (0, _factory$18.factory)(name$15, dependencies$14, function(t) {
  var r = t.typed, n = t.Parser;
  return r(name$15, {
    "": function() {
      return new n();
    }
  });
});
parser.createParser = createParser;
var lup$1 = {};
Object.defineProperty(lup$1, "__esModule", {
  value: !0
});
lup$1.createLup = void 0;
var _object$a = object, _factory$17 = factory$1, name$14 = "lup", dependencies$13 = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtract", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], createLup = /* @__PURE__ */ (0, _factory$17.factory)(name$14, dependencies$13, function(t) {
  var r = t.typed, n = t.matrix, a = t.abs, s = t.addScalar, o = t.divideScalar, c = t.multiplyScalar, l = t.subtract, d = t.larger, h = t.equalScalar, u = t.unaryMinus, p = t.DenseMatrix, m = t.SparseMatrix, g = t.Spa;
  return r(name$14, {
    DenseMatrix: function(_) {
      return v(_);
    },
    SparseMatrix: function(_) {
      return y(_);
    },
    Array: function(_) {
      var $ = n(_), b = v($);
      return {
        L: b.L.valueOf(),
        U: b.U.valueOf(),
        p: b.p
      };
    }
  });
  function v(x) {
    var _ = x._size[0], $ = x._size[1], b = Math.min(_, $), M = (0, _object$a.clone)(x._data), C = [], S = [_, b], A = [], D = [b, $], N, T, R, F = [];
    for (N = 0; N < _; N++)
      F[N] = N;
    for (T = 0; T < $; T++) {
      if (T > 0)
        for (N = 0; N < _; N++) {
          var z = Math.min(N, T), O = 0;
          for (R = 0; R < z; R++)
            O = s(O, c(M[N][R], M[R][T]));
          M[N][T] = l(M[N][T], O);
        }
      var G = T, I = 0, k = 0;
      for (N = T; N < _; N++) {
        var B = M[N][T], L = a(B);
        d(L, I) && (G = N, I = L, k = B);
      }
      if (T !== G && (F[T] = [F[G], F[G] = F[T]][0], p._swapRows(T, G, M)), T < _)
        for (N = T + 1; N < _; N++) {
          var V = M[N][T];
          h(V, 0) || (M[N][T] = o(M[N][T], k));
        }
    }
    for (T = 0; T < $; T++)
      for (N = 0; N < _; N++) {
        if (T === 0 && (N < $ && (A[N] = []), C[N] = []), N < T) {
          N < $ && (A[N][T] = M[N][T]), T < _ && (C[N][T] = 0);
          continue;
        }
        if (N === T) {
          N < $ && (A[N][T] = M[N][T]), T < _ && (C[N][T] = 1);
          continue;
        }
        N < $ && (A[N][T] = 0), T < _ && (C[N][T] = M[N][T]);
      }
    var U = new p({
      data: C,
      size: S
    }), J = new p({
      data: A,
      size: D
    }), q = [];
    for (N = 0, b = F.length; N < b; N++)
      q[F[N]] = N;
    return {
      L: U,
      U: J,
      p: q,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
  function y(x) {
    var _ = x._size[0], $ = x._size[1], b = Math.min(_, $), M = x._values, C = x._index, S = x._ptr, A = [], D = [], N = [], T = [_, b], R = [], F = [], z = [], O = [b, $], G, I, k, B = [], L = [];
    for (G = 0; G < _; G++)
      B[G] = G, L[G] = G;
    var V = function(q, Z) {
      var ae = L[q], ee = L[Z];
      B[ae] = Z, B[ee] = q, L[q] = ee, L[Z] = ae;
    }, U = function() {
      var q = new g();
      I < _ && (N.push(A.length), A.push(1), D.push(I)), z.push(R.length);
      var Z = S[I], ae = S[I + 1];
      for (k = Z; k < ae; k++)
        G = C[k], q.set(B[G], M[k]);
      I > 0 && q.forEach(0, I - 1, function(ce, oe) {
        m._forEachRow(ce, A, D, N, function(ur, ir) {
          ur > ce && q.accumulate(ur, u(c(ir, oe)));
        });
      });
      var ee = I, se = q.get(I), nr = a(se);
      q.forEach(I + 1, _ - 1, function(ce, oe) {
        var ur = a(oe);
        d(ur, nr) && (ee = ce, nr = ur, se = oe);
      }), I !== ee && (m._swapRows(I, ee, T[1], A, D, N), m._swapRows(I, ee, O[1], R, F, z), q.swap(I, ee), V(I, ee)), q.forEach(0, _ - 1, function(ce, oe) {
        ce <= I ? (R.push(oe), F.push(ce)) : (oe = o(oe, se), h(oe, 0) || (A.push(oe), D.push(ce)));
      });
    };
    for (I = 0; I < $; I++)
      U();
    return z.push(R.length), N.push(A.length), {
      L: new m({
        values: A,
        index: D,
        ptr: N,
        size: T
      }),
      U: new m({
        values: R,
        index: F,
        ptr: z,
        size: O
      }),
      p: B,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
});
lup$1.createLup = createLup;
var qr$1 = {};
Object.defineProperty(qr$1, "__esModule", {
  value: !0
});
qr$1.createQr = void 0;
var _factory$16 = factory$1;
function _extends$1() {
  return _extends$1 = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends$1.apply(this, arguments);
}
var name$13 = "qr", dependencies$12 = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtract", "complex"], createQr = /* @__PURE__ */ (0, _factory$16.factory)(name$13, dependencies$12, function(t) {
  var r = t.typed, n = t.matrix, a = t.zeros, s = t.identity, o = t.isZero, c = t.equal, l = t.sign, d = t.sqrt, h = t.conj, u = t.unaryMinus, p = t.addScalar, m = t.divideScalar, g = t.multiplyScalar, v = t.subtract, y = t.complex;
  return _extends$1(r(name$13, {
    DenseMatrix: function(M) {
      return _(M);
    },
    SparseMatrix: function(M) {
      return $();
    },
    Array: function(M) {
      var C = n(M), S = _(C);
      return {
        Q: S.Q.valueOf(),
        R: S.R.valueOf()
      };
    }
  }), {
    _denseQRimpl: x
  });
  function x(b) {
    var M = b._size[0], C = b._size[1], S = s([M], "dense"), A = S._data, D = b.clone(), N = D._data, T, R, F, z = a([M], "");
    for (F = 0; F < Math.min(C, M); ++F) {
      var O = N[F][F], G = u(c(O, 0) ? 1 : l(O)), I = h(G), k = 0;
      for (T = F; T < M; T++)
        k = p(k, g(N[T][F], h(N[T][F])));
      var B = g(G, d(k));
      if (!o(B)) {
        var L = v(O, B);
        for (z[F] = 1, T = F + 1; T < M; T++)
          z[T] = m(N[T][F], L);
        var V = u(h(m(L, B))), U = void 0;
        for (R = F; R < C; R++) {
          for (U = 0, T = F; T < M; T++)
            U = p(U, g(h(z[T]), N[T][R]));
          for (U = g(U, V), T = F; T < M; T++)
            N[T][R] = g(v(N[T][R], g(z[T], U)), I);
        }
        for (T = 0; T < M; T++) {
          for (U = 0, R = F; R < M; R++)
            U = p(U, g(A[T][R], z[R]));
          for (U = g(U, V), R = F; R < M; ++R)
            A[T][R] = m(v(A[T][R], g(U, h(z[R]))), I);
        }
      }
    }
    return {
      Q: S,
      R: D,
      toString: function() {
        return "Q: " + this.Q.toString() + `
R: ` + this.R.toString();
      }
    };
  }
  function _(b) {
    var M = x(b), C = M.R._data;
    if (b._data.length > 0)
      for (var S = C[0][0].type === "Complex" ? y(0) : 0, A = 0; A < C.length; ++A)
        for (var D = 0; D < A && D < (C[0] || []).length; ++D)
          C[A][D] = S;
    return M;
  }
  function $(b) {
    throw new Error("qr not implemented for sparse matrices yet");
  }
});
qr$1.createQr = createQr;
var slu$1 = {}, csSqr = {}, csPermute$1 = {};
Object.defineProperty(csPermute$1, "__esModule", {
  value: !0
});
csPermute$1.csPermute = csPermute;
function csPermute(t, r, n, a) {
  for (var s = t._values, o = t._index, c = t._ptr, l = t._size, d = t._datatype, h = l[0], u = l[1], p = a && t._values ? [] : null, m = [], g = [], v = 0, y = 0; y < u; y++) {
    g[y] = v;
    for (var x = n ? n[y] : y, _ = c[x], $ = c[x + 1], b = _; b < $; b++) {
      var M = r ? r[o[b]] : o[b];
      m[v] = M, p && (p[v] = s[b]), v++;
    }
  }
  return g[u] = v, t.createSparseMatrix({
    values: p,
    index: m,
    ptr: g,
    size: [h, u],
    datatype: d
  });
}
var csPost$1 = {}, csTdfs$1 = {};
Object.defineProperty(csTdfs$1, "__esModule", {
  value: !0
});
csTdfs$1.csTdfs = csTdfs;
function csTdfs(t, r, n, a, s, o, c) {
  var l = 0;
  for (n[c] = t; l >= 0; ) {
    var d = n[c + l], h = n[a + d];
    h === -1 ? (l--, o[r++] = d) : (n[a + d] = n[s + h], ++l, n[c + l] = h);
  }
  return r;
}
Object.defineProperty(csPost$1, "__esModule", {
  value: !0
});
csPost$1.csPost = csPost;
var _csTdfs$1 = csTdfs$1;
function csPost(t, r) {
  if (!t)
    return null;
  var n = 0, a, s = [], o = [], c = 0, l = r, d = 2 * r;
  for (a = 0; a < r; a++)
    o[c + a] = -1;
  for (a = r - 1; a >= 0; a--)
    t[a] !== -1 && (o[l + a] = o[c + t[a]], o[c + t[a]] = a);
  for (a = 0; a < r; a++)
    t[a] === -1 && (n = (0, _csTdfs$1.csTdfs)(a, n, o, c, l, s, d));
  return s;
}
var csEtree$1 = {};
Object.defineProperty(csEtree$1, "__esModule", {
  value: !0
});
csEtree$1.csEtree = csEtree;
function csEtree(t, r) {
  if (!t)
    return null;
  var n = t._index, a = t._ptr, s = t._size, o = s[0], c = s[1], l = [], d = [], h = 0, u = c, p, m;
  if (r)
    for (p = 0; p < o; p++)
      d[u + p] = -1;
  for (var g = 0; g < c; g++) {
    l[g] = -1, d[h + g] = -1;
    for (var v = a[g], y = a[g + 1], x = v; x < y; x++) {
      var _ = n[x];
      for (p = r ? d[u + _] : _; p !== -1 && p < g; p = m)
        m = d[h + p], d[h + p] = g, m === -1 && (l[p] = g);
      r && (d[u + _] = g);
    }
  }
  return l;
}
var csAmd = {}, csFkeep$1 = {};
Object.defineProperty(csFkeep$1, "__esModule", {
  value: !0
});
csFkeep$1.csFkeep = csFkeep;
function csFkeep(t, r, n) {
  for (var a = t._values, s = t._index, o = t._ptr, c = t._size, l = c[1], d = 0, h = 0; h < l; h++) {
    var u = o[h];
    for (o[h] = d; u < o[h + 1]; u++)
      r(s[u], h, a ? a[u] : 1, n) && (s[d] = s[u], a && (a[d] = a[u]), d++);
  }
  return o[l] = d, s.splice(d, s.length - d), a && a.splice(d, a.length - d), d;
}
var csFlip$1 = {};
Object.defineProperty(csFlip$1, "__esModule", {
  value: !0
});
csFlip$1.csFlip = csFlip;
function csFlip(t) {
  return -t - 2;
}
Object.defineProperty(csAmd, "__esModule", {
  value: !0
});
csAmd.createCsAmd = void 0;
var _factory$15 = factory$1, _csFkeep = csFkeep$1, _csFlip$2 = csFlip$1, _csTdfs = csTdfs$1, name$12 = "csAmd", dependencies$11 = ["add", "multiply", "transpose"], createCsAmd = /* @__PURE__ */ (0, _factory$15.factory)(name$12, dependencies$11, function(t) {
  var r = t.add, n = t.multiply, a = t.transpose;
  return function(u, p) {
    if (!p || u <= 0 || u > 3)
      return null;
    var m = p._size, g = m[0], v = m[1], y = 0, x = Math.max(16, 10 * Math.sqrt(v));
    x = Math.min(v - 2, x);
    var _ = s(u, p, g, v, x);
    (0, _csFkeep.csFkeep)(_, d, null);
    for (var $ = _._index, b = _._ptr, M = b[v], C = [], S = [], A = 0, D = v + 1, N = 2 * (v + 1), T = 3 * (v + 1), R = 4 * (v + 1), F = 5 * (v + 1), z = 6 * (v + 1), O = 7 * (v + 1), G = C, I = o(v, b, S, A, T, G, N, O, D, z, R, F), k = c(v, b, S, F, R, z, x, D, T, G, N), B = 0, L, V, U, J, q, Z, ae, ee, se, nr, ce, oe, ur, ir, _r, yr; k < v; ) {
      for (U = -1; B < v && (U = S[T + B]) === -1; B++)
        ;
      S[N + U] !== -1 && (G[S[N + U]] = -1), S[T + B] = S[N + U];
      var ne = S[R + U], pe = S[D + U];
      k += pe;
      var hr = 0;
      S[D + U] = -pe;
      var $r = b[U], Sr = ne === 0 ? $r : M, ze = Sr;
      for (J = 1; J <= ne + 1; J++) {
        for (J > ne ? (Z = U, ae = $r, ee = S[A + U] - ne) : (Z = $[$r++], ae = b[Z], ee = S[A + Z]), q = 1; q <= ee; q++)
          L = $[ae++], !((se = S[D + L]) <= 0) && (hr += se, S[D + L] = -se, $[ze++] = L, S[N + L] !== -1 && (G[S[N + L]] = G[L]), G[L] !== -1 ? S[N + G[L]] = S[N + L] : S[T + S[F + L]] = S[N + L]);
        Z !== U && (b[Z] = (0, _csFlip$2.csFlip)(U), S[z + Z] = 0);
      }
      for (ne !== 0 && (M = ze), S[F + U] = hr, b[U] = Sr, S[A + U] = ze - Sr, S[R + U] = -2, I = l(I, y, S, z, v), nr = Sr; nr < ze; nr++)
        if (L = $[nr], !((ce = S[R + L]) <= 0)) {
          se = -S[D + L];
          var cr = I - se;
          for ($r = b[L], oe = b[L] + ce - 1; $r <= oe; $r++)
            Z = $[$r], S[z + Z] >= I ? S[z + Z] -= se : S[z + Z] !== 0 && (S[z + Z] = S[F + Z] + cr);
        }
      for (nr = Sr; nr < ze; nr++) {
        for (L = $[nr], oe = b[L], ur = oe + S[R + L] - 1, ir = oe, _r = 0, yr = 0, $r = oe; $r <= ur; $r++)
          if (Z = $[$r], S[z + Z] !== 0) {
            var fr = S[z + Z] - I;
            fr > 0 ? (yr += fr, $[ir++] = Z, _r += Z) : (b[Z] = (0, _csFlip$2.csFlip)(U), S[z + Z] = 0);
          }
        S[R + L] = ir - oe + 1;
        var mr = ir, wr = oe + S[A + L];
        for ($r = ur + 1; $r < wr; $r++) {
          V = $[$r];
          var Nr = S[D + V];
          Nr <= 0 || (yr += Nr, $[ir++] = V, _r += V);
        }
        yr === 0 ? (b[L] = (0, _csFlip$2.csFlip)(U), se = -S[D + L], hr -= se, pe += se, k += se, S[D + L] = 0, S[R + L] = -1) : (S[F + L] = Math.min(S[F + L], yr), $[ir] = $[mr], $[mr] = $[oe], $[oe] = U, S[A + L] = ir - oe + 1, _r = (_r < 0 ? -_r : _r) % v, S[N + L] = S[O + _r], S[O + _r] = L, G[L] = _r);
      }
      for (S[F + U] = hr, y = Math.max(y, hr), I = l(I + y, y, S, z, v), nr = Sr; nr < ze; nr++)
        if (L = $[nr], !(S[D + L] >= 0))
          for (_r = G[L], L = S[O + _r], S[O + _r] = -1; L !== -1 && S[N + L] !== -1; L = S[N + L], I++) {
            for (ee = S[A + L], ce = S[R + L], $r = b[L] + 1; $r <= b[L] + ee - 1; $r++)
              S[z + $[$r]] = I;
            var xr = L;
            for (V = S[N + L]; V !== -1; ) {
              var Er = S[A + V] === ee && S[R + V] === ce;
              for ($r = b[V] + 1; Er && $r <= b[V] + ee - 1; $r++)
                S[z + $[$r]] !== I && (Er = 0);
              Er ? (b[V] = (0, _csFlip$2.csFlip)(L), S[D + L] += S[D + V], S[D + V] = 0, S[R + V] = -1, V = S[N + V], S[N + xr] = V) : (xr = V, V = S[N + V]);
            }
          }
      for ($r = Sr, nr = Sr; nr < ze; nr++)
        L = $[nr], !((se = -S[D + L]) <= 0) && (S[D + L] = se, yr = S[F + L] + hr - se, yr = Math.min(yr, v - k - se), S[T + yr] !== -1 && (G[S[T + yr]] = L), S[N + L] = S[T + yr], G[L] = -1, S[T + yr] = L, B = Math.min(B, yr), S[F + L] = yr, $[$r++] = L);
      S[D + U] = pe, (S[A + U] = $r - Sr) === 0 && (b[U] = -1, S[z + U] = 0), ne !== 0 && (M = $r);
    }
    for (L = 0; L < v; L++)
      b[L] = (0, _csFlip$2.csFlip)(b[L]);
    for (V = 0; V <= v; V++)
      S[T + V] = -1;
    for (V = v; V >= 0; V--)
      S[D + V] > 0 || (S[N + V] = S[T + b[V]], S[T + b[V]] = V);
    for (Z = v; Z >= 0; Z--)
      S[D + Z] <= 0 || b[Z] !== -1 && (S[N + Z] = S[T + b[Z]], S[T + b[Z]] = Z);
    for (U = 0, L = 0; L <= v; L++)
      b[L] === -1 && (U = (0, _csTdfs.csTdfs)(L, U, S, T, N, C, z));
    return C.splice(C.length - 1, 1), C;
  };
  function s(h, u, p, m, g) {
    var v = a(u);
    if (h === 1 && m === p)
      return r(u, v);
    if (h === 2) {
      for (var y = v._index, x = v._ptr, _ = 0, $ = 0; $ < p; $++) {
        var b = x[$];
        if (x[$] = _, !(x[$ + 1] - b > g))
          for (var M = x[$ + 1]; b < M; b++)
            y[_++] = y[b];
      }
      return x[p] = _, u = a(v), n(v, u);
    }
    return n(v, u);
  }
  function o(h, u, p, m, g, v, y, x, _, $, b, M) {
    for (var C = 0; C < h; C++)
      p[m + C] = u[C + 1] - u[C];
    p[m + h] = 0;
    for (var S = 0; S <= h; S++)
      p[g + S] = -1, v[S] = -1, p[y + S] = -1, p[x + S] = -1, p[_ + S] = 1, p[$ + S] = 1, p[b + S] = 0, p[M + S] = p[m + S];
    var A = l(0, 0, p, $, h);
    return p[b + h] = -2, u[h] = -1, p[$ + h] = 0, A;
  }
  function c(h, u, p, m, g, v, y, x, _, $, b) {
    for (var M = 0, C = 0; C < h; C++) {
      var S = p[m + C];
      if (S === 0)
        p[g + C] = -2, M++, u[C] = -1, p[v + C] = 0;
      else if (S > y)
        p[x + C] = 0, p[g + C] = -1, M++, u[C] = (0, _csFlip$2.csFlip)(h), p[x + h]++;
      else {
        var A = p[_ + S];
        A !== -1 && ($[A] = C), p[b + C] = p[_ + S], p[_ + S] = C;
      }
    }
    return M;
  }
  function l(h, u, p, m, g) {
    if (h < 2 || h + u < 0) {
      for (var v = 0; v < g; v++)
        p[m + v] !== 0 && (p[m + v] = 1);
      h = 2;
    }
    return h;
  }
  function d(h, u) {
    return h !== u;
  }
});
csAmd.createCsAmd = createCsAmd;
var csCounts = {}, csLeaf$1 = {};
Object.defineProperty(csLeaf$1, "__esModule", {
  value: !0
});
csLeaf$1.csLeaf = csLeaf;
function csLeaf(t, r, n, a, s, o, c) {
  var l, d, h = 0, u;
  if (t <= r || n[a + r] <= n[s + t])
    return -1;
  n[s + t] = n[a + r];
  var p = n[o + t];
  if (n[o + t] = r, p === -1)
    h = 1, u = t;
  else {
    for (h = 2, u = p; u !== n[c + u]; u = n[c + u])
      ;
    for (l = p; l !== u; l = d)
      d = n[c + l], n[c + l] = u;
  }
  return {
    jleaf: h,
    q: u
  };
}
Object.defineProperty(csCounts, "__esModule", {
  value: !0
});
csCounts.createCsCounts = void 0;
var _factory$14 = factory$1, _csLeaf = csLeaf$1, name$11 = "csCounts", dependencies$10 = ["transpose"], createCsCounts = /* @__PURE__ */ (0, _factory$14.factory)(name$11, dependencies$10, function(t) {
  var r = t.transpose;
  return function(n, a, s, o) {
    if (!n || !a || !s)
      return null;
    var c = n._size, l = c[0], d = c[1], h, u, p, m, g, v, y, x = 4 * d + (o ? d + l + 1 : 0), _ = [], $ = 0, b = d, M = 2 * d, C = 3 * d, S = 4 * d, A = 5 * d + 1;
    for (p = 0; p < x; p++)
      _[p] = -1;
    var D = [], N = r(n), T = N._index, R = N._ptr;
    for (p = 0; p < d; p++)
      for (u = s[p], D[u] = _[C + u] === -1 ? 1 : 0; u !== -1 && _[C + u] === -1; u = a[u])
        _[C + u] = p;
    if (o) {
      for (p = 0; p < d; p++)
        _[s[p]] = p;
      for (h = 0; h < l; h++) {
        for (p = d, v = R[h], y = R[h + 1], g = v; g < y; g++)
          p = Math.min(p, _[T[g]]);
        _[A + h] = _[S + p], _[S + p] = h;
      }
    }
    for (h = 0; h < d; h++)
      _[$ + h] = h;
    for (p = 0; p < d; p++) {
      for (u = s[p], a[u] !== -1 && D[a[u]]--, m = o ? _[S + p] : u; m !== -1; m = o ? _[A + m] : -1)
        for (g = R[m]; g < R[m + 1]; g++) {
          h = T[g];
          var F = (0, _csLeaf.csLeaf)(h, u, _, C, b, M, $);
          F.jleaf >= 1 && D[u]++, F.jleaf === 2 && D[F.q]--;
        }
      a[u] !== -1 && (_[$ + u] = a[u]);
    }
    for (u = 0; u < d; u++)
      a[u] !== -1 && (D[a[u]] += D[u]);
    return D;
  };
});
csCounts.createCsCounts = createCsCounts;
Object.defineProperty(csSqr, "__esModule", {
  value: !0
});
csSqr.createCsSqr = void 0;
var _csPermute = csPermute$1, _csPost = csPost$1, _csEtree = csEtree$1, _csAmd = csAmd, _csCounts = csCounts, _factory$13 = factory$1, name$10 = "csSqr", dependencies$$ = ["add", "multiply", "transpose"], createCsSqr = /* @__PURE__ */ (0, _factory$13.factory)(name$10, dependencies$$, function(t) {
  var r = t.add, n = t.multiply, a = t.transpose, s = (0, _csAmd.createCsAmd)({
    add: r,
    multiply: n,
    transpose: a
  }), o = (0, _csCounts.createCsCounts)({
    transpose: a
  });
  return function(d, h, u) {
    var p = h._ptr, m = h._size, g = m[1], v, y = {};
    if (y.q = s(d, h), d && !y.q)
      return null;
    if (u) {
      var x = d ? (0, _csPermute.csPermute)(h, null, y.q, 0) : h;
      y.parent = (0, _csEtree.csEtree)(x, 1);
      var _ = (0, _csPost.csPost)(y.parent, g);
      if (y.cp = o(x, y.parent, _, 1), x && y.parent && y.cp && c(x, y))
        for (y.unz = 0, v = 0; v < g; v++)
          y.unz += y.cp[v];
    } else
      y.unz = 4 * p[g] + g, y.lnz = y.unz;
    return y;
  };
  function c(l, d) {
    var h = l._ptr, u = l._index, p = l._size, m = p[0], g = p[1];
    d.pinv = [], d.leftmost = [];
    var v = d.parent, y = d.pinv, x = d.leftmost, _ = [], $ = 0, b = m, M = m + g, C = m + 2 * g, S, A, D, N, T;
    for (A = 0; A < g; A++)
      _[b + A] = -1, _[M + A] = -1, _[C + A] = 0;
    for (S = 0; S < m; S++)
      x[S] = -1;
    for (A = g - 1; A >= 0; A--)
      for (N = h[A], T = h[A + 1], D = N; D < T; D++)
        x[u[D]] = A;
    for (S = m - 1; S >= 0; S--)
      y[S] = -1, A = x[S], A !== -1 && (_[C + A]++ === 0 && (_[M + A] = S), _[$ + S] = _[b + A], _[b + A] = S);
    for (d.lnz = 0, d.m2 = m, A = 0; A < g; A++)
      if (S = _[b + A], d.lnz++, S < 0 && (S = d.m2++), y[S] = A, !(--C[A] <= 0)) {
        d.lnz += _[C + A];
        var R = v[A];
        R !== -1 && (_[C + R] === 0 && (_[M + R] = _[M + A]), _[$ + _[M + A]] = _[b + R], _[b + R] = _[$ + S], _[C + R] += _[C + A]);
      }
    for (S = 0; S < m; S++)
      y[S] < 0 && (y[S] = A++);
    return !0;
  }
});
csSqr.createCsSqr = createCsSqr;
var csLu = {}, csSpsolve = {}, csReach$1 = {}, csMarked$1 = {};
Object.defineProperty(csMarked$1, "__esModule", {
  value: !0
});
csMarked$1.csMarked = csMarked;
function csMarked(t, r) {
  return t[r] < 0;
}
var csMark$1 = {};
Object.defineProperty(csMark$1, "__esModule", {
  value: !0
});
csMark$1.csMark = csMark;
var _csFlip$1 = csFlip$1;
function csMark(t, r) {
  t[r] = (0, _csFlip$1.csFlip)(t[r]);
}
var csDfs$1 = {}, csUnflip$1 = {};
Object.defineProperty(csUnflip$1, "__esModule", {
  value: !0
});
csUnflip$1.csUnflip = csUnflip;
var _csFlip = csFlip$1;
function csUnflip(t) {
  return t < 0 ? (0, _csFlip.csFlip)(t) : t;
}
Object.defineProperty(csDfs$1, "__esModule", {
  value: !0
});
csDfs$1.csDfs = csDfs;
var _csMarked$1 = csMarked$1, _csMark$1 = csMark$1, _csUnflip = csUnflip$1;
function csDfs(t, r, n, a, s) {
  var o = r._index, c = r._ptr, l = r._size, d = l[1], h, u, p, m = 0;
  for (a[0] = t; m >= 0; ) {
    t = a[m];
    var g = s ? s[t] : t;
    (0, _csMarked$1.csMarked)(c, t) || ((0, _csMark$1.csMark)(c, t), a[d + m] = g < 0 ? 0 : (0, _csUnflip.csUnflip)(c[g]));
    var v = 1;
    for (u = a[d + m], p = g < 0 ? 0 : (0, _csUnflip.csUnflip)(c[g + 1]); u < p; u++)
      if (h = o[u], !(0, _csMarked$1.csMarked)(c, h)) {
        a[d + m] = u, a[++m] = h, v = 0;
        break;
      }
    v && (m--, a[--n] = t);
  }
  return n;
}
Object.defineProperty(csReach$1, "__esModule", {
  value: !0
});
csReach$1.csReach = csReach;
var _csMarked = csMarked$1, _csMark = csMark$1, _csDfs = csDfs$1;
function csReach(t, r, n, a, s) {
  var o = t._ptr, c = t._size, l = r._index, d = r._ptr, h = c[1], u, p, m, g = h;
  for (p = d[n], m = d[n + 1], u = p; u < m; u++) {
    var v = l[u];
    (0, _csMarked.csMarked)(o, v) || (g = (0, _csDfs.csDfs)(v, t, g, a, s));
  }
  for (u = g; u < h; u++)
    (0, _csMark.csMark)(o, a[u]);
  return g;
}
Object.defineProperty(csSpsolve, "__esModule", {
  value: !0
});
csSpsolve.createCsSpsolve = void 0;
var _csReach = csReach$1, _factory$12 = factory$1, name$$ = "csSpsolve", dependencies$_ = ["divideScalar", "multiply", "subtract"], createCsSpsolve = /* @__PURE__ */ (0, _factory$12.factory)(name$$, dependencies$_, function(t) {
  var r = t.divideScalar, n = t.multiply, a = t.subtract;
  return function(o, c, l, d, h, u, p) {
    var m = o._values, g = o._index, v = o._ptr, y = o._size, x = y[1], _ = c._values, $ = c._index, b = c._ptr, M, C, S, A, D = (0, _csReach.csReach)(o, c, l, d, u);
    for (M = D; M < x; M++)
      h[d[M]] = 0;
    for (C = b[l], S = b[l + 1], M = C; M < S; M++)
      h[$[M]] = _[M];
    for (var N = D; N < x; N++) {
      var T = d[N], R = u ? u[T] : T;
      if (!(R < 0))
        for (C = v[R], S = v[R + 1], h[T] = r(h[T], m[p ? C : S - 1]), M = p ? C + 1 : C, A = p ? S : S - 1; M < A; M++) {
          var F = g[M];
          h[F] = a(h[F], n(m[M], h[T]));
        }
    }
    return D;
  };
});
csSpsolve.createCsSpsolve = createCsSpsolve;
Object.defineProperty(csLu, "__esModule", {
  value: !0
});
csLu.createCsLu = void 0;
var _factory$11 = factory$1, _csSpsolve = csSpsolve, name$_ = "csLu", dependencies$Z = ["abs", "divideScalar", "multiply", "subtract", "larger", "largerEq", "SparseMatrix"], createCsLu = /* @__PURE__ */ (0, _factory$11.factory)(name$_, dependencies$Z, function(t) {
  var r = t.abs, n = t.divideScalar, a = t.multiply, s = t.subtract, o = t.larger, c = t.largerEq, l = t.SparseMatrix, d = (0, _csSpsolve.createCsSpsolve)({
    divideScalar: n,
    multiply: a,
    subtract: s
  });
  return function(u, p, m) {
    if (!u)
      return null;
    var g = u._size, v = g[1], y, x = 100, _ = 100;
    p && (y = p.q, x = p.lnz || x, _ = p.unz || _);
    var $ = [], b = [], M = [], C = new l({
      values: $,
      index: b,
      ptr: M,
      size: [v, v]
    }), S = [], A = [], D = [], N = new l({
      values: S,
      index: A,
      ptr: D,
      size: [v, v]
    }), T = [], R, F, z = [], O = [];
    for (R = 0; R < v; R++)
      z[R] = 0, T[R] = -1, M[R + 1] = 0;
    x = 0, _ = 0;
    for (var G = 0; G < v; G++) {
      M[G] = x, D[G] = _;
      var I = y ? y[G] : G, k = d(C, u, I, O, z, T, 1), B = -1, L = -1;
      for (F = k; F < v; F++)
        if (R = O[F], T[R] < 0) {
          var V = r(z[R]);
          o(V, L) && (L = V, B = R);
        } else
          A[_] = T[R], S[_++] = z[R];
      if (B === -1 || L <= 0)
        return null;
      T[I] < 0 && c(r(z[I]), a(L, m)) && (B = I);
      var U = z[B];
      for (A[_] = G, S[_++] = U, T[B] = G, b[x] = B, $[x++] = 1, F = k; F < v; F++)
        R = O[F], T[R] < 0 && (b[x] = R, $[x++] = n(z[R], U)), z[R] = 0;
    }
    for (M[v] = x, D[v] = _, F = 0; F < x; F++)
      b[F] = T[b[F]];
    return $.splice(x, $.length - x), b.splice(x, b.length - x), S.splice(_, S.length - _), A.splice(_, A.length - _), {
      L: C,
      U: N,
      pinv: T
    };
  };
});
csLu.createCsLu = createCsLu;
Object.defineProperty(slu$1, "__esModule", {
  value: !0
});
slu$1.createSlu = void 0;
var _number$5 = number$3, _factory$10 = factory$1, _csSqr = csSqr, _csLu = csLu, name$Z = "slu", dependencies$Y = ["typed", "abs", "add", "multiply", "transpose", "divideScalar", "subtract", "larger", "largerEq", "SparseMatrix"], createSlu = /* @__PURE__ */ (0, _factory$10.factory)(name$Z, dependencies$Y, function(t) {
  var r = t.typed, n = t.abs, a = t.add, s = t.multiply, o = t.transpose, c = t.divideScalar, l = t.subtract, d = t.larger, h = t.largerEq, u = t.SparseMatrix, p = (0, _csSqr.createCsSqr)({
    add: a,
    multiply: s,
    transpose: o
  }), m = (0, _csLu.createCsLu)({
    abs: n,
    divideScalar: c,
    multiply: s,
    subtract: l,
    larger: d,
    largerEq: h,
    SparseMatrix: u
  });
  return r(name$Z, {
    "SparseMatrix, number, number": function(v, y, x) {
      if (!(0, _number$5.isInteger)(y) || y < 0 || y > 3)
        throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
      if (x < 0 || x > 1)
        throw new Error("Partial pivoting threshold must be a number from 0 to 1");
      var _ = p(y, v, !1), $ = m(v, _, x);
      return {
        L: $.L,
        U: $.U,
        p: $.pinv,
        q: _.q,
        toString: function() {
          return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : "") + `
`;
        }
      };
    }
  });
});
slu$1.createSlu = createSlu;
var lusolve$1 = {}, csIpvec$1 = {};
Object.defineProperty(csIpvec$1, "__esModule", {
  value: !0
});
csIpvec$1.csIpvec = csIpvec;
function csIpvec(t, r) {
  var n, a = r.length, s = [];
  if (t)
    for (n = 0; n < a; n++)
      s[t[n]] = r[n];
  else
    for (n = 0; n < a; n++)
      s[n] = r[n];
  return s;
}
Object.defineProperty(lusolve$1, "__esModule", {
  value: !0
});
lusolve$1.createLusolve = void 0;
var _is$B = is, _factory$$ = factory$1, _solveValidation = solveValidation, _csIpvec = csIpvec$1, name$Y = "lusolve", dependencies$X = ["typed", "matrix", "lup", "slu", "usolve", "lsolve", "DenseMatrix"], createLusolve = /* @__PURE__ */ (0, _factory$$.factory)(name$Y, dependencies$X, function(t) {
  var r = t.typed, n = t.matrix, a = t.lup, s = t.slu, o = t.usolve, c = t.lsolve, l = t.DenseMatrix, d = (0, _solveValidation.createSolveValidation)({
    DenseMatrix: l
  });
  return r(name$Y, {
    "Array, Array | Matrix": function(m, g) {
      m = n(m);
      var v = a(m), y = u(v.L, v.U, v.p, null, g);
      return y.valueOf();
    },
    "DenseMatrix, Array | Matrix": function(m, g) {
      var v = a(m);
      return u(v.L, v.U, v.p, null, g);
    },
    "SparseMatrix, Array | Matrix": function(m, g) {
      var v = a(m);
      return u(v.L, v.U, v.p, null, g);
    },
    "SparseMatrix, Array | Matrix, number, number": function(m, g, v, y) {
      var x = s(m, v, y);
      return u(x.L, x.U, x.p, x.q, g);
    },
    "Object, Array | Matrix": function(m, g) {
      return u(m.L, m.U, m.p, m.q, g);
    }
  });
  function h(p) {
    if ((0, _is$B.isMatrix)(p))
      return p;
    if ((0, _is$B.isArray)(p))
      return n(p);
    throw new TypeError("Invalid Matrix LU decomposition");
  }
  function u(p, m, g, v, y) {
    p = h(p), m = h(m), g && (y = d(p, y, !0), y._data = (0, _csIpvec.csIpvec)(g, y._data));
    var x = c(p, y), _ = o(m, x);
    return v && (_._data = (0, _csIpvec.csIpvec)(v, _._data)), _;
  }
});
lusolve$1.createLusolve = createLusolve;
var Help = {};
Object.defineProperty(Help, "__esModule", {
  value: !0
});
Help.createHelpClass = void 0;
var _is$A = is, _object$9 = object, _string$7 = string$2, _factory$_ = factory$1, name$X = "Help", dependencies$W = ["parse"], createHelpClass = /* @__PURE__ */ (0, _factory$_.factory)(name$X, dependencies$W, function(t) {
  var r = t.parse;
  function n(a) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!a)
      throw new Error('Argument "doc" missing');
    this.doc = a;
  }
  return n.prototype.type = "Help", n.prototype.isHelp = !0, n.prototype.toString = function() {
    var a = this.doc || {}, s = `
`;
    if (a.name && (s += "Name: " + a.name + `

`), a.category && (s += "Category: " + a.category + `

`), a.description && (s += `Description:
    ` + a.description + `

`), a.syntax && (s += `Syntax:
    ` + a.syntax.join(`
    `) + `

`), a.examples) {
      s += `Examples:
`;
      for (var o = {}, c = 0; c < a.examples.length; c++) {
        var l = a.examples[c];
        s += "    " + l + `
`;
        var d = void 0;
        try {
          d = r(l).compile().evaluate(o);
        } catch (h) {
          d = h;
        }
        d !== void 0 && !(0, _is$A.isHelp)(d) && (s += "        " + (0, _string$7.format)(d, {
          precision: 14
        }) + `
`);
      }
      s += `
`;
    }
    return a.seealso && a.seealso.length && (s += "See also: " + a.seealso.join(", ") + `
`), s;
  }, n.prototype.toJSON = function() {
    var a = (0, _object$9.clone)(this.doc);
    return a.mathjs = "Help", a;
  }, n.fromJSON = function(a) {
    var s = {};
    return Object.keys(a).filter(function(o) {
      return o !== "mathjs";
    }).forEach(function(o) {
      s[o] = a[o];
    }), new n(s);
  }, n.prototype.valueOf = n.prototype.toString, n;
}, {
  isClass: !0
});
Help.createHelpClass = createHelpClass;
var Chain = {};
Object.defineProperty(Chain, "__esModule", {
  value: !0
});
Chain.createChainClass = void 0;
var _is$z = is, _string$6 = string$2, _object$8 = object, _factory$Z = factory$1, name$W = "Chain", dependencies$V = ["?on", "math"], createChainClass = /* @__PURE__ */ (0, _factory$Z.factory)(name$W, dependencies$V, function(t) {
  var r = t.on, n = t.math;
  function a(d) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    (0, _is$z.isChain)(d) ? this.value = d.value : this.value = d;
  }
  a.prototype.type = "Chain", a.prototype.isChain = !0, a.prototype.done = function() {
    return this.value;
  }, a.prototype.valueOf = function() {
    return this.value;
  }, a.prototype.toString = function() {
    return (0, _string$6.format)(this.value);
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "Chain",
      value: this.value
    };
  }, a.fromJSON = function(d) {
    return new a(d.value);
  };
  function s(d, h) {
    typeof h == "function" && (a.prototype[d] = c(h));
  }
  function o(d, h) {
    (0, _object$8.lazy)(a.prototype, d, function() {
      var p = h();
      if (typeof p == "function")
        return c(p);
    });
  }
  function c(d) {
    return function() {
      for (var h = [this.value], u = 0; u < arguments.length; u++)
        h[u + 1] = arguments[u];
      return new a(d.apply(d, h));
    };
  }
  a.createProxy = function(d, h) {
    if (typeof d == "string")
      s(d, h);
    else {
      var u = function(g) {
        (0, _object$8.hasOwnProperty)(d, g) && l[g] === void 0 && o(g, function() {
          return d[g];
        });
      };
      for (var p in d)
        u(p);
    }
  };
  var l = {
    expression: !0,
    docs: !0,
    type: !0,
    classes: !0,
    json: !0,
    error: !0,
    isChain: !0
    // conflicts with the property isChain of a Chain instance
  };
  return a.createProxy(n), r && r("import", function(d, h, u) {
    u || o(d, h);
  }), a;
}, {
  isClass: !0
});
Chain.createChainClass = createChainClass;
var help$1 = {}, embeddedDocs$1 = {}, bignumber = {};
Object.defineProperty(bignumber, "__esModule", {
  value: !0
});
bignumber.bignumberDocs = void 0;
var bignumberDocs = {
  name: "bignumber",
  category: "Construction",
  syntax: ["bignumber(x)"],
  description: "Create a big number from a number or string.",
  examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"],
  seealso: ["boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
};
bignumber.bignumberDocs = bignumberDocs;
var typeOf = {};
Object.defineProperty(typeOf, "__esModule", {
  value: !0
});
typeOf.typeOfDocs = void 0;
var typeOfDocs = {
  name: "typeOf",
  category: "Utils",
  syntax: ["typeOf(x)"],
  description: "Get the type of a variable.",
  examples: ["typeOf(3.5)", "typeOf(2 - 4i)", "typeOf(45 deg)", 'typeOf("hello world")'],
  seealso: ["getMatrixDataType"]
};
typeOf.typeOfDocs = typeOfDocs;
var isZero = {};
Object.defineProperty(isZero, "__esModule", {
  value: !0
});
isZero.isZeroDocs = void 0;
var isZeroDocs = {
  name: "isZero",
  category: "Utils",
  syntax: ["isZero(x)"],
  description: "Test whether a value is zero.",
  examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"]
};
isZero.isZeroDocs = isZeroDocs;
var isPrime = {};
Object.defineProperty(isPrime, "__esModule", {
  value: !0
});
isPrime.isPrimeDocs = void 0;
var isPrimeDocs = {
  name: "isPrime",
  category: "Utils",
  syntax: ["isPrime(x)"],
  description: "Test whether a value is prime: has no divisors other than itself and one.",
  examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
};
isPrime.isPrimeDocs = isPrimeDocs;
var isPositive = {};
Object.defineProperty(isPositive, "__esModule", {
  value: !0
});
isPositive.isPositiveDocs = void 0;
var isPositiveDocs = {
  name: "isPositive",
  category: "Utils",
  syntax: ["isPositive(x)"],
  description: "Test whether a value is positive: larger than zero.",
  examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
};
isPositive.isPositiveDocs = isPositiveDocs;
var isNumeric = {};
Object.defineProperty(isNumeric, "__esModule", {
  value: !0
});
isNumeric.isNumericDocs = void 0;
var isNumericDocs = {
  name: "isNumeric",
  category: "Utils",
  syntax: ["isNumeric(x)"],
  description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
  examples: ["isNumeric(2)", 'isNumeric("2")', 'hasNumericValue("2")', "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "hasNumericValue"]
};
isNumeric.isNumericDocs = isNumericDocs;
var hasNumericValue = {};
Object.defineProperty(hasNumericValue, "__esModule", {
  value: !0
});
hasNumericValue.hasNumericValueDocs = void 0;
var hasNumericValueDocs = {
  name: "hasNumericValue",
  category: "Utils",
  syntax: ["hasNumericValue(x)"],
  description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
  examples: ["hasNumericValue(2)", 'hasNumericValue("2")', 'isNumeric("2")', "hasNumericValue(0)", "hasNumericValue(bignumber(500))", "hasNumericValue(fraction(0.125))", "hasNumericValue(2 + 3i)", 'hasNumericValue([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "isNumeric"]
};
hasNumericValue.hasNumericValueDocs = hasNumericValueDocs;
var isNegative = {};
Object.defineProperty(isNegative, "__esModule", {
  value: !0
});
isNegative.isNegativeDocs = void 0;
var isNegativeDocs = {
  name: "isNegative",
  category: "Utils",
  syntax: ["isNegative(x)"],
  description: "Test whether a value is negative: smaller than zero.",
  examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isPositive", "isZero"]
};
isNegative.isNegativeDocs = isNegativeDocs;
var isInteger = {};
Object.defineProperty(isInteger, "__esModule", {
  value: !0
});
isInteger.isIntegerDocs = void 0;
var isIntegerDocs = {
  name: "isInteger",
  category: "Utils",
  syntax: ["isInteger(x)"],
  description: "Test whether a value is an integer number.",
  examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
};
isInteger.isIntegerDocs = isIntegerDocs;
var _isNaN$1 = {};
Object.defineProperty(_isNaN$1, "__esModule", {
  value: !0
});
_isNaN$1.isNaNDocs = void 0;
var isNaNDocs = {
  name: "isNaN",
  category: "Utils",
  syntax: ["isNaN(x)"],
  description: "Test whether a value is NaN (not a number)",
  examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
};
_isNaN$1.isNaNDocs = isNaNDocs;
var format$1 = {};
Object.defineProperty(format$1, "__esModule", {
  value: !0
});
format$1.formatDocs = void 0;
var formatDocs = {
  name: "format",
  category: "Utils",
  syntax: ["format(value)", "format(value, precision)"],
  description: "Format a value of any type as string.",
  examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"],
  seealso: ["print"]
};
format$1.formatDocs = formatDocs;
var bin = {};
Object.defineProperty(bin, "__esModule", {
  value: !0
});
bin.binDocs = void 0;
var binDocs = {
  name: "bin",
  category: "Utils",
  syntax: ["bin(value)"],
  description: "Format a number as binary",
  examples: ["bin(2)"],
  seealso: ["oct", "hex"]
};
bin.binDocs = binDocs;
var oct = {};
Object.defineProperty(oct, "__esModule", {
  value: !0
});
oct.octDocs = void 0;
var octDocs = {
  name: "oct",
  category: "Utils",
  syntax: ["oct(value)"],
  description: "Format a number as octal",
  examples: ["oct(56)"],
  seealso: ["bin", "hex"]
};
oct.octDocs = octDocs;
var hex = {};
Object.defineProperty(hex, "__esModule", {
  value: !0
});
hex.hexDocs = void 0;
var hexDocs = {
  name: "hex",
  category: "Utils",
  syntax: ["hex(value)"],
  description: "Format a number as hexadecimal",
  examples: ["hex(240)"],
  seealso: ["bin", "oct"]
};
hex.hexDocs = hexDocs;
var clone$2 = {};
Object.defineProperty(clone$2, "__esModule", {
  value: !0
});
clone$2.cloneDocs = void 0;
var cloneDocs = {
  name: "clone",
  category: "Utils",
  syntax: ["clone(x)"],
  description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
  examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'],
  seealso: []
};
clone$2.cloneDocs = cloneDocs;
var to$1 = {};
Object.defineProperty(to$1, "__esModule", {
  value: !0
});
to$1.toDocs = void 0;
var toDocs = {
  name: "to",
  category: "Units",
  syntax: ["x to unit", "to(x, unit)"],
  description: "Change the unit of a value.",
  examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"],
  seealso: []
};
to$1.toDocs = toDocs;
var tanh = {};
Object.defineProperty(tanh, "__esModule", {
  value: !0
});
tanh.tanhDocs = void 0;
var tanhDocs = {
  name: "tanh",
  category: "Trigonometry",
  syntax: ["tanh(x)"],
  description: "Compute the hyperbolic tangent of x in radians.",
  examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"],
  seealso: ["sinh", "cosh"]
};
tanh.tanhDocs = tanhDocs;
var tan = {};
Object.defineProperty(tan, "__esModule", {
  value: !0
});
tan.tanDocs = void 0;
var tanDocs = {
  name: "tan",
  category: "Trigonometry",
  syntax: ["tan(x)"],
  description: "Compute the tangent of x in radians.",
  examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"],
  seealso: ["atan", "sin", "cos"]
};
tan.tanDocs = tanDocs;
var sinh = {};
Object.defineProperty(sinh, "__esModule", {
  value: !0
});
sinh.sinhDocs = void 0;
var sinhDocs = {
  name: "sinh",
  category: "Trigonometry",
  syntax: ["sinh(x)"],
  description: "Compute the hyperbolic sine of x in radians.",
  examples: ["sinh(0.5)"],
  seealso: ["cosh", "tanh"]
};
sinh.sinhDocs = sinhDocs;
var sech = {};
Object.defineProperty(sech, "__esModule", {
  value: !0
});
sech.sechDocs = void 0;
var sechDocs = {
  name: "sech",
  category: "Trigonometry",
  syntax: ["sech(x)"],
  description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
  examples: ["sech(2)", "1 / cosh(2)"],
  seealso: ["coth", "csch", "cosh"]
};
sech.sechDocs = sechDocs;
var sec = {};
Object.defineProperty(sec, "__esModule", {
  value: !0
});
sec.secDocs = void 0;
var secDocs = {
  name: "sec",
  category: "Trigonometry",
  syntax: ["sec(x)"],
  description: "Compute the secant of x in radians. Defined as 1/cos(x)",
  examples: ["sec(2)", "1 / cos(2)"],
  seealso: ["cot", "csc", "cos"]
};
sec.secDocs = secDocs;
var csch = {};
Object.defineProperty(csch, "__esModule", {
  value: !0
});
csch.cschDocs = void 0;
var cschDocs = {
  name: "csch",
  category: "Trigonometry",
  syntax: ["csch(x)"],
  description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
  examples: ["csch(2)", "1 / sinh(2)"],
  seealso: ["sech", "coth", "sinh"]
};
csch.cschDocs = cschDocs;
var csc = {};
Object.defineProperty(csc, "__esModule", {
  value: !0
});
csc.cscDocs = void 0;
var cscDocs = {
  name: "csc",
  category: "Trigonometry",
  syntax: ["csc(x)"],
  description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
  examples: ["csc(2)", "1 / sin(2)"],
  seealso: ["sec", "cot", "sin"]
};
csc.cscDocs = cscDocs;
var coth = {};
Object.defineProperty(coth, "__esModule", {
  value: !0
});
coth.cothDocs = void 0;
var cothDocs = {
  name: "coth",
  category: "Trigonometry",
  syntax: ["coth(x)"],
  description: "Compute the hyperbolic cotangent of x in radians.",
  examples: ["coth(2)", "1 / tanh(2)"],
  seealso: ["sech", "csch", "tanh"]
};
coth.cothDocs = cothDocs;
var cot = {};
Object.defineProperty(cot, "__esModule", {
  value: !0
});
cot.cotDocs = void 0;
var cotDocs = {
  name: "cot",
  category: "Trigonometry",
  syntax: ["cot(x)"],
  description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
  examples: ["cot(2)", "1 / tan(2)"],
  seealso: ["sec", "csc", "tan"]
};
cot.cotDocs = cotDocs;
var cosh = {};
Object.defineProperty(cosh, "__esModule", {
  value: !0
});
cosh.coshDocs = void 0;
var coshDocs = {
  name: "cosh",
  category: "Trigonometry",
  syntax: ["cosh(x)"],
  description: "Compute the hyperbolic cosine of x in radians.",
  examples: ["cosh(0.5)"],
  seealso: ["sinh", "tanh", "coth"]
};
cosh.coshDocs = coshDocs;
var cos = {};
Object.defineProperty(cos, "__esModule", {
  value: !0
});
cos.cosDocs = void 0;
var cosDocs = {
  name: "cos",
  category: "Trigonometry",
  syntax: ["cos(x)"],
  description: "Compute the cosine of x in radians.",
  examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["acos", "sin", "tan"]
};
cos.cosDocs = cosDocs;
var atan2 = {};
Object.defineProperty(atan2, "__esModule", {
  value: !0
});
atan2.atan2Docs = void 0;
var atan2Docs = {
  name: "atan2",
  category: "Trigonometry",
  syntax: ["atan2(y, x)"],
  description: "Computes the principal value of the arc tangent of y/x in radians.",
  examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"],
  seealso: ["sin", "cos", "tan"]
};
atan2.atan2Docs = atan2Docs;
var atanh = {};
Object.defineProperty(atanh, "__esModule", {
  value: !0
});
atanh.atanhDocs = void 0;
var atanhDocs = {
  name: "atanh",
  category: "Trigonometry",
  syntax: ["atanh(x)"],
  description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
  examples: ["atanh(0.5)"],
  seealso: ["acosh", "asinh"]
};
atanh.atanhDocs = atanhDocs;
var atan = {};
Object.defineProperty(atan, "__esModule", {
  value: !0
});
atan.atanDocs = void 0;
var atanDocs = {
  name: "atan",
  category: "Trigonometry",
  syntax: ["atan(x)"],
  description: "Compute the inverse tangent of a value in radians.",
  examples: ["atan(0.5)", "atan(tan(0.5))"],
  seealso: ["tan", "acos", "asin"]
};
atan.atanDocs = atanDocs;
var asinh = {};
Object.defineProperty(asinh, "__esModule", {
  value: !0
});
asinh.asinhDocs = void 0;
var asinhDocs = {
  name: "asinh",
  category: "Trigonometry",
  syntax: ["asinh(x)"],
  description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
  examples: ["asinh(0.5)"],
  seealso: ["acosh", "atanh"]
};
asinh.asinhDocs = asinhDocs;
var asin = {};
Object.defineProperty(asin, "__esModule", {
  value: !0
});
asin.asinDocs = void 0;
var asinDocs = {
  name: "asin",
  category: "Trigonometry",
  syntax: ["asin(x)"],
  description: "Compute the inverse sine of a value in radians.",
  examples: ["asin(0.5)", "asin(sin(0.5))"],
  seealso: ["sin", "acos", "atan"]
};
asin.asinDocs = asinDocs;
var asech = {};
Object.defineProperty(asech, "__esModule", {
  value: !0
});
asech.asechDocs = void 0;
var asechDocs = {
  name: "asech",
  category: "Trigonometry",
  syntax: ["asech(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asech(0.5)"],
  seealso: ["acsch", "acoth"]
};
asech.asechDocs = asechDocs;
var asec = {};
Object.defineProperty(asec, "__esModule", {
  value: !0
});
asec.asecDocs = void 0;
var asecDocs = {
  name: "asec",
  category: "Trigonometry",
  syntax: ["asec(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"],
  seealso: ["acos", "acot", "acsc"]
};
asec.asecDocs = asecDocs;
var acsch = {};
Object.defineProperty(acsch, "__esModule", {
  value: !0
});
acsch.acschDocs = void 0;
var acschDocs = {
  name: "acsch",
  category: "Trigonometry",
  syntax: ["acsch(x)"],
  description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
  examples: ["acsch(0.5)"],
  seealso: ["asech", "acoth"]
};
acsch.acschDocs = acschDocs;
var acsc = {};
Object.defineProperty(acsc, "__esModule", {
  value: !0
});
acsc.acscDocs = void 0;
var acscDocs = {
  name: "acsc",
  category: "Trigonometry",
  syntax: ["acsc(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acsc(2)", "acsc(csc(0.5))", "acsc(0.5)"],
  seealso: ["csc", "asin", "asec"]
};
acsc.acscDocs = acscDocs;
var acoth = {};
Object.defineProperty(acoth, "__esModule", {
  value: !0
});
acoth.acothDocs = void 0;
var acothDocs = {
  name: "acoth",
  category: "Trigonometry",
  syntax: ["acoth(x)"],
  description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
  examples: ["acoth(2)", "acoth(0.5)"],
  seealso: ["acsch", "asech"]
};
acoth.acothDocs = acothDocs;
var acot = {};
Object.defineProperty(acot, "__esModule", {
  value: !0
});
acot.acotDocs = void 0;
var acotDocs = {
  name: "acot",
  category: "Trigonometry",
  syntax: ["acot(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"],
  seealso: ["cot", "atan"]
};
acot.acotDocs = acotDocs;
var acosh = {};
Object.defineProperty(acosh, "__esModule", {
  value: !0
});
acosh.acoshDocs = void 0;
var acoshDocs = {
  name: "acosh",
  category: "Trigonometry",
  syntax: ["acosh(x)"],
  description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
  examples: ["acosh(1.5)"],
  seealso: ["cosh", "asinh", "atanh"]
};
acosh.acoshDocs = acoshDocs;
var acos = {};
Object.defineProperty(acos, "__esModule", {
  value: !0
});
acos.acosDocs = void 0;
var acosDocs = {
  name: "acos",
  category: "Trigonometry",
  syntax: ["acos(x)"],
  description: "Compute the inverse cosine of a value in radians.",
  examples: ["acos(0.5)", "acos(cos(2.3))"],
  seealso: ["cos", "atan", "asin"]
};
acos.acosDocs = acosDocs;
var sum$1 = {};
Object.defineProperty(sum$1, "__esModule", {
  value: !0
});
sum$1.sumDocs = void 0;
var sumDocs = {
  name: "sum",
  category: "Statistics",
  syntax: ["sum(a, b, c, ...)", "sum(A)"],
  description: "Compute the sum of all values.",
  examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"],
  seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"]
};
sum$1.sumDocs = sumDocs;
var std$1 = {};
Object.defineProperty(std$1, "__esModule", {
  value: !0
});
std$1.stdDocs = void 0;
var stdDocs = {
  name: "std",
  category: "Statistics",
  syntax: ["std(a, b, c, ...)", "std(A)", "std(A, normalization)"],
  description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "prod", "sum", "variance"]
};
std$1.stdDocs = stdDocs;
var quantileSeq$1 = {};
Object.defineProperty(quantileSeq$1, "__esModule", {
  value: !0
});
quantileSeq$1.quantileSeqDocs = void 0;
var quantileSeqDocs = {
  name: "quantileSeq",
  category: "Statistics",
  syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"],
  description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`,
  examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"],
  seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "variance"]
};
quantileSeq$1.quantileSeqDocs = quantileSeqDocs;
var prod = {};
Object.defineProperty(prod, "__esModule", {
  value: !0
});
prod.prodDocs = void 0;
var prodDocs = {
  name: "prod",
  category: "Statistics",
  syntax: ["prod(a, b, c, ...)", "prod(A)"],
  description: "Compute the product of all values.",
  examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"],
  seealso: ["max", "mean", "min", "median", "min", "std", "sum", "variance"]
};
prod.prodDocs = prodDocs;
var mode = {};
Object.defineProperty(mode, "__esModule", {
  value: !0
});
mode.modeDocs = void 0;
var modeDocs = {
  name: "mode",
  category: "Statistics",
  syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"],
  description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
  examples: ["mode(2, 1, 4, 3, 1)", "mode([1, 2.7, 3.2, 4, 2.7])", "mode(1, 4, 6, 1, 6)"],
  seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "variance"]
};
mode.modeDocs = modeDocs;
var min$2 = {};
Object.defineProperty(min$2, "__esModule", {
  value: !0
});
min$2.minDocs = void 0;
var minDocs = {
  name: "min",
  category: "Statistics",
  syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dim)"],
  description: "Compute the minimum value of a list of values.",
  examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["max", "mean", "median", "prod", "std", "sum", "variance"]
};
min$2.minDocs = minDocs;
var median$1 = {};
Object.defineProperty(median$1, "__esModule", {
  value: !0
});
median$1.medianDocs = void 0;
var medianDocs = {
  name: "median",
  category: "Statistics",
  syntax: ["median(a, b, c, ...)", "median(A)"],
  description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
  examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"],
  seealso: ["max", "mean", "min", "prod", "std", "sum", "variance", "quantileSeq"]
};
median$1.medianDocs = medianDocs;
var mean$1 = {};
Object.defineProperty(mean$1, "__esModule", {
  value: !0
});
mean$1.meanDocs = void 0;
var meanDocs = {
  name: "mean",
  category: "Statistics",
  syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dim)"],
  description: "Compute the arithmetic mean of a list of values.",
  examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"],
  seealso: ["max", "median", "min", "prod", "std", "sum", "variance"]
};
mean$1.meanDocs = meanDocs;
var max$2 = {};
Object.defineProperty(max$2, "__esModule", {
  value: !0
});
max$2.maxDocs = void 0;
var maxDocs = {
  name: "max",
  category: "Statistics",
  syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dim)"],
  description: "Compute the maximum value of a list of values.",
  examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["mean", "median", "min", "prod", "std", "sum", "variance"]
};
max$2.maxDocs = maxDocs;
var mad$1 = {};
Object.defineProperty(mad$1, "__esModule", {
  value: !0
});
mad$1.madDocs = void 0;
var madDocs = {
  name: "mad",
  category: "Statistics",
  syntax: ["mad(a, b, c, ...)", "mad(A)"],
  description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
  examples: ["mad(10, 20, 30)", "mad([1, 2, 3])"],
  seealso: ["mean", "median", "std", "abs"]
};
mad$1.madDocs = madDocs;
var erf = {};
Object.defineProperty(erf, "__esModule", {
  value: !0
});
erf.erfDocs = void 0;
var erfDocs = {
  name: "erf",
  category: "Special",
  syntax: ["erf(x)"],
  description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
  examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"],
  seealso: []
};
erf.erfDocs = erfDocs;
var setUnion = {};
Object.defineProperty(setUnion, "__esModule", {
  value: !0
});
setUnion.setUnionDocs = void 0;
var setUnionDocs = {
  name: "setUnion",
  category: "Set",
  syntax: ["setUnion(set1, set2)"],
  description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setUnion([1, 2, 3, 4], [3, 4, 5, 6])", "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setIntersect", "setDifference"]
};
setUnion.setUnionDocs = setUnionDocs;
var setSymDifference = {};
Object.defineProperty(setSymDifference, "__esModule", {
  value: !0
});
setSymDifference.setSymDifferenceDocs = void 0;
var setSymDifferenceDocs = {
  name: "setSymDifference",
  category: "Set",
  syntax: ["setSymDifference(set1, set2)"],
  description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
};
setSymDifference.setSymDifferenceDocs = setSymDifferenceDocs;
var setSize = {};
Object.defineProperty(setSize, "__esModule", {
  value: !0
});
setSize.setSizeDocs = void 0;
var setSizeDocs = {
  name: "setSize",
  category: "Set",
  syntax: ["setSize(set)", "setSize(set, unique)"],
  description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
  examples: ["setSize([1, 2, 2, 4])", "setSize([1, 2, 2, 4], true)"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
};
setSize.setSizeDocs = setSizeDocs;
var setPowerset = {};
Object.defineProperty(setPowerset, "__esModule", {
  value: !0
});
setPowerset.setPowersetDocs = void 0;
var setPowersetDocs = {
  name: "setPowerset",
  category: "Set",
  syntax: ["setPowerset(set)"],
  description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setPowerset([1, 2, 3])"],
  seealso: ["setCartesian"]
};
setPowerset.setPowersetDocs = setPowersetDocs;
var setMultiplicity = {};
Object.defineProperty(setMultiplicity, "__esModule", {
  value: !0
});
setMultiplicity.setMultiplicityDocs = void 0;
var setMultiplicityDocs = {
  name: "setMultiplicity",
  category: "Set",
  syntax: ["setMultiplicity(element, set)"],
  description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setMultiplicity(1, [1, 2, 2, 4])", "setMultiplicity(2, [1, 2, 2, 4])"],
  seealso: ["setDistinct", "setSize"]
};
setMultiplicity.setMultiplicityDocs = setMultiplicityDocs;
var setIsSubset = {};
Object.defineProperty(setIsSubset, "__esModule", {
  value: !0
});
setIsSubset.setIsSubsetDocs = void 0;
var setIsSubsetDocs = {
  name: "setIsSubset",
  category: "Set",
  syntax: ["setIsSubset(set1, set2)"],
  description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIsSubset([1, 2], [3, 4, 5, 6])", "setIsSubset([3, 4], [3, 4, 5, 6])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
};
setIsSubset.setIsSubsetDocs = setIsSubsetDocs;
var setIntersect = {};
Object.defineProperty(setIntersect, "__esModule", {
  value: !0
});
setIntersect.setIntersectDocs = void 0;
var setIntersectDocs = {
  name: "setIntersect",
  category: "Set",
  syntax: ["setIntersect(set1, set2)"],
  description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])", "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setDifference"]
};
setIntersect.setIntersectDocs = setIntersectDocs;
var setDistinct = {};
Object.defineProperty(setDistinct, "__esModule", {
  value: !0
});
setDistinct.setDistinctDocs = void 0;
var setDistinctDocs = {
  name: "setDistinct",
  category: "Set",
  syntax: ["setDistinct(set)"],
  description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setDistinct([1, 1, 1, 2, 2, 3])"],
  seealso: ["setMultiplicity"]
};
setDistinct.setDistinctDocs = setDistinctDocs;
var setDifference = {};
Object.defineProperty(setDifference, "__esModule", {
  value: !0
});
setDifference.setDifferenceDocs = void 0;
var setDifferenceDocs = {
  name: "setDifference",
  category: "Set",
  syntax: ["setDifference(set1, set2)"],
  description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setSymDifference"]
};
setDifference.setDifferenceDocs = setDifferenceDocs;
var setCartesian = {};
Object.defineProperty(setCartesian, "__esModule", {
  value: !0
});
setCartesian.setCartesianDocs = void 0;
var setCartesianDocs = {
  name: "setCartesian",
  category: "Set",
  syntax: ["setCartesian(set1, set2)"],
  description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setCartesian([1, 2], [3, 4])"],
  seealso: ["setUnion", "setIntersect", "setDifference", "setPowerset"]
};
setCartesian.setCartesianDocs = setCartesianDocs;
var unequal = {};
Object.defineProperty(unequal, "__esModule", {
  value: !0
});
unequal.unequalDocs = void 0;
var unequalDocs = {
  name: "unequal",
  category: "Relational",
  syntax: ["x != y", "unequal(x, y)"],
  description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
  examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"],
  seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"]
};
unequal.unequalDocs = unequalDocs;
var smallerEq = {};
Object.defineProperty(smallerEq, "__esModule", {
  value: !0
});
smallerEq.smallerEqDocs = void 0;
var smallerEqDocs = {
  name: "smallerEq",
  category: "Relational",
  syntax: ["x <= y", "smallerEq(x, y)"],
  description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
  examples: ["2 <= 1+1", "2 < 1+1", "a = 3.2", "b = 6-2.8", "(a <= b)"],
  seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"]
};
smallerEq.smallerEqDocs = smallerEqDocs;
var smaller = {};
Object.defineProperty(smaller, "__esModule", {
  value: !0
});
smaller.smallerDocs = void 0;
var smallerDocs = {
  name: "smaller",
  category: "Relational",
  syntax: ["x < y", "smaller(x, y)"],
  description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
  examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"],
  seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"]
};
smaller.smallerDocs = smallerDocs;
var largerEq = {};
Object.defineProperty(largerEq, "__esModule", {
  value: !0
});
largerEq.largerEqDocs = void 0;
var largerEqDocs = {
  name: "largerEq",
  category: "Relational",
  syntax: ["x >= y", "largerEq(x, y)"],
  description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
  examples: ["2 >= 1+1", "2 > 1+1", "a = 3.2", "b = 6-2.8", "(a >= b)"],
  seealso: ["equal", "unequal", "smallerEq", "smaller", "compare"]
};
largerEq.largerEqDocs = largerEqDocs;
var larger = {};
Object.defineProperty(larger, "__esModule", {
  value: !0
});
larger.largerDocs = void 0;
var largerDocs = {
  name: "larger",
  category: "Relational",
  syntax: ["x > y", "larger(x, y)"],
  description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
  examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"]
};
larger.largerDocs = largerDocs;
var equalText = {};
Object.defineProperty(equalText, "__esModule", {
  value: !0
});
equalText.equalTextDocs = void 0;
var equalTextDocs = {
  name: "equalText",
  category: "Relational",
  syntax: ["equalText(x, y)"],
  description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
  examples: ['equalText("Hello", "Hello")', 'equalText("a", "A")', 'equal("2e3", "2000")', 'equalText("2e3", "2000")', 'equalText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural", "compareText", "equal"]
};
equalText.equalTextDocs = equalTextDocs;
var equal = {};
Object.defineProperty(equal, "__esModule", {
  value: !0
});
equal.equalDocs = void 0;
var equalDocs = {
  name: "equal",
  category: "Relational",
  syntax: ["x == y", "equal(x, y)"],
  description: "Check equality of two values. Returns true if the values are equal, and false if not.",
  examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"],
  seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual", "equalText"]
};
equal.equalDocs = equalDocs;
var deepEqual = {};
Object.defineProperty(deepEqual, "__esModule", {
  value: !0
});
deepEqual.deepEqualDocs = void 0;
var deepEqualDocs = {
  name: "deepEqual",
  category: "Relational",
  syntax: ["deepEqual(x, y)"],
  description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
  examples: ["deepEqual([1,3,4], [1,3,4])", "deepEqual([1,3,4], [1,3])"],
  seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"]
};
deepEqual.deepEqualDocs = deepEqualDocs;
var compareText = {};
Object.defineProperty(compareText, "__esModule", {
  value: !0
});
compareText.compareTextDocs = void 0;
var compareTextDocs = {
  name: "compareText",
  category: "Relational",
  syntax: ["compareText(x, y)"],
  description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ['compareText("B", "A")', 'compareText("A", "B")', 'compareText("A", "A")', 'compareText("2", "10")', 'compare("2", "10")', "compare(2, 10)", 'compareNatural("2", "10")', 'compareText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural"]
};
compareText.compareTextDocs = compareTextDocs;
var compareNatural = {};
Object.defineProperty(compareNatural, "__esModule", {
  value: !0
});
compareNatural.compareNaturalDocs = void 0;
var compareNaturalDocs = {
  name: "compareNatural",
  category: "Relational",
  syntax: ["compareNatural(x, y)"],
  description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compareNatural(2, 3)", "compareNatural(3, 2)", "compareNatural(2, 2)", "compareNatural(5cm, 40mm)", 'compareNatural("2", "10")', "compareNatural(2 + 3i, 2 + 4i)", "compareNatural([1, 2, 4], [1, 2, 3])", "compareNatural([1, 5], [1, 2, 3])", "compareNatural([1, 2], [1, 2])", "compareNatural({a: 2}, {a: 4})"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare", "compareText"]
};
compareNatural.compareNaturalDocs = compareNaturalDocs;
var compare = {};
Object.defineProperty(compare, "__esModule", {
  value: !0
});
compare.compareDocs = void 0;
var compareDocs = {
  name: "compare",
  category: "Relational",
  syntax: ["compare(x, y)"],
  description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compareNatural", "compareText"]
};
compare.compareDocs = compareDocs;
var randomInt$1 = {};
Object.defineProperty(randomInt$1, "__esModule", {
  value: !0
});
randomInt$1.randomIntDocs = void 0;
var randomIntDocs = {
  name: "randomInt",
  category: "Probability",
  syntax: ["randomInt(max)", "randomInt(min, max)", "randomInt(size)", "randomInt(size, max)", "randomInt(size, min, max)"],
  description: "Return a random integer number",
  examples: ["randomInt(10, 20)", "randomInt([2, 3], 10)"],
  seealso: ["pickRandom", "random"]
};
randomInt$1.randomIntDocs = randomIntDocs;
var random$1 = {};
Object.defineProperty(random$1, "__esModule", {
  value: !0
});
random$1.randomDocs = void 0;
var randomDocs = {
  name: "random",
  category: "Probability",
  syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"],
  description: "Return a random number.",
  examples: ["random()", "random(10, 20)", "random([2, 3])"],
  seealso: ["pickRandom", "randomInt"]
};
random$1.randomDocs = randomDocs;
var pickRandom$1 = {};
Object.defineProperty(pickRandom$1, "__esModule", {
  value: !0
});
pickRandom$1.pickRandomDocs = void 0;
var pickRandomDocs = {
  name: "pickRandom",
  category: "Probability",
  syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"],
  description: "Pick a random entry from a given array.",
  examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"],
  seealso: ["random", "randomInt"]
};
pickRandom$1.pickRandomDocs = pickRandomDocs;
var permutations$1 = {};
Object.defineProperty(permutations$1, "__esModule", {
  value: !0
});
permutations$1.permutationsDocs = void 0;
var permutationsDocs = {
  name: "permutations",
  category: "Probability",
  syntax: ["permutations(n)", "permutations(n, k)"],
  description: "Compute the number of permutations of n items taken k at a time",
  examples: ["permutations(5)", "permutations(5, 3)"],
  seealso: ["combinations", "combinationsWithRep", "factorial"]
};
permutations$1.permutationsDocs = permutationsDocs;
var multinomial$1 = {};
Object.defineProperty(multinomial$1, "__esModule", {
  value: !0
});
multinomial$1.multinomialDocs = void 0;
var multinomialDocs = {
  name: "multinomial",
  category: "Probability",
  syntax: ["multinomial(A)"],
  description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
  examples: ["multinomial([1, 2, 1])"],
  seealso: ["combinations", "factorial"]
};
multinomial$1.multinomialDocs = multinomialDocs;
var kldivergence$1 = {};
Object.defineProperty(kldivergence$1, "__esModule", {
  value: !0
});
kldivergence$1.kldivergenceDocs = void 0;
var kldivergenceDocs = {
  name: "kldivergence",
  category: "Probability",
  syntax: ["kldivergence(x, y)"],
  description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
  examples: ["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"],
  seealso: []
};
kldivergence$1.kldivergenceDocs = kldivergenceDocs;
var gamma$1 = {};
Object.defineProperty(gamma$1, "__esModule", {
  value: !0
});
gamma$1.gammaDocs = void 0;
var gammaDocs = {
  name: "gamma",
  category: "Probability",
  syntax: ["gamma(n)"],
  description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
  examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"],
  seealso: ["factorial"]
};
gamma$1.gammaDocs = gammaDocs;
var factorial$1 = {};
Object.defineProperty(factorial$1, "__esModule", {
  value: !0
});
factorial$1.factorialDocs = void 0;
var factorialDocs = {
  name: "factorial",
  category: "Probability",
  syntax: ["n!", "factorial(n)"],
  description: "Compute the factorial of a value",
  examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"],
  seealso: ["combinations", "combinationsWithRep", "permutations", "gamma"]
};
factorial$1.factorialDocs = factorialDocs;
var combinations$1 = {};
Object.defineProperty(combinations$1, "__esModule", {
  value: !0
});
combinations$1.combinationsDocs = void 0;
var combinationsDocs = {
  name: "combinations",
  category: "Probability",
  syntax: ["combinations(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time",
  examples: ["combinations(7, 5)"],
  seealso: ["combinationsWithRep", "permutations", "factorial"]
};
combinations$1.combinationsDocs = combinationsDocs;
var combinationsWithRep$1 = {};
Object.defineProperty(combinationsWithRep$1, "__esModule", {
  value: !0
});
combinationsWithRep$1.combinationsWithRepDocs = void 0;
var combinationsWithRepDocs = {
  name: "combinationsWithRep",
  category: "Probability",
  syntax: ["combinationsWithRep(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time with replacements.",
  examples: ["combinationsWithRep(7, 5)"],
  seealso: ["combinations", "permutations", "factorial"]
};
combinationsWithRep$1.combinationsWithRepDocs = combinationsWithRepDocs;
var zeros = {};
Object.defineProperty(zeros, "__esModule", {
  value: !0
});
zeros.zerosDocs = void 0;
var zerosDocs = {
  name: "zeros",
  category: "Matrix",
  syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])"],
  description: "Create a matrix containing zeros.",
  examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"]
};
zeros.zerosDocs = zerosDocs;
var transpose = {};
Object.defineProperty(transpose, "__esModule", {
  value: !0
});
transpose.transposeDocs = void 0;
var transposeDocs = {
  name: "transpose",
  category: "Matrix",
  syntax: ["x'", "transpose(x)"],
  description: "Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
};
transpose.transposeDocs = transposeDocs;
var trace = {};
Object.defineProperty(trace, "__esModule", {
  value: !0
});
trace.traceDocs = void 0;
var traceDocs = {
  name: "trace",
  category: "Matrix",
  syntax: ["trace(A)"],
  description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
  examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"]
};
trace.traceDocs = traceDocs;
var subset = {};
Object.defineProperty(subset, "__esModule", {
  value: !0
});
subset.subsetDocs = void 0;
var subsetDocs = {
  name: "subset",
  category: "Matrix",
  syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"],
  description: "Get or set a subset of a matrix or string. Indexes are one-based. Both the ranges lower-bound and upper-bound are included.",
  examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"]
};
subset.subsetDocs = subsetDocs;
var squeeze = {};
Object.defineProperty(squeeze, "__esModule", {
  value: !0
});
squeeze.squeezeDocs = void 0;
var squeezeDocs = {
  name: "squeeze",
  category: "Matrix",
  syntax: ["squeeze(x)"],
  description: "Remove inner and outer singleton dimensions from a matrix.",
  examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"]
};
squeeze.squeezeDocs = squeezeDocs;
var sort = {};
Object.defineProperty(sort, "__esModule", {
  value: !0
});
sort.sortDocs = void 0;
var sortDocs = {
  name: "sort",
  category: "Matrix",
  syntax: ["sort(x)", "sort(x, compare)"],
  description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
  examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"])', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)', 'sort(["10", "1", "2"], "natural")'],
  seealso: ["map", "filter", "forEach"]
};
sort.sortDocs = sortDocs;
var size = {};
Object.defineProperty(size, "__esModule", {
  value: !0
});
size.sizeDocs = void 0;
var sizeDocs = {
  name: "size",
  category: "Matrix",
  syntax: ["size(x)"],
  description: "Calculate the size of a matrix.",
  examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"]
};
size.sizeDocs = sizeDocs;
var diff$1 = {};
Object.defineProperty(diff$1, "__esModule", {
  value: !0
});
diff$1.diffDocs = void 0;
var diffDocs = {
  name: "diff",
  category: "Matrix",
  syntax: ["diff(arr)", "diff(arr, dim)"],
  description: ["Create a new matrix or array with the difference of the passed matrix or array.", "Dim parameter is optional and used to indicant the dimension of the array/matrix to apply the difference", "If no dimension parameter is passed it is assumed as dimension 0", "Dimension is zero-based in javascript and one-based in the parser", "Arrays must be 'rectangular' meaning arrays like [1, 2]", "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"],
  examples: ["diff([1, 2, 4, 7, 0])", "diff([1, 2, 4, 7, 0], 0)", "diff(matrix([1, 2, 4, 7, 0]))", "diff([[1, 2], [3, 4]])", "diff([[1, 2], [3, 4]], 0)", "diff([[1, 2], [3, 4]], 1)", "diff([[1, 2], [3, 4]], bignumber(1))", "diff(matrix([[1, 2], [3, 4]]), 1)", "diff([[1, 2], matrix([3, 4])], 1)"],
  seealso: ["subtract", "partitionSelect"]
};
diff$1.diffDocs = diffDocs;
var reshape = {};
Object.defineProperty(reshape, "__esModule", {
  value: !0
});
reshape.reshapeDocs = void 0;
var reshapeDocs = {
  name: "reshape",
  category: "Matrix",
  syntax: ["reshape(x, sizes)"],
  description: "Reshape a multi dimensional array to fit the specified dimensions.",
  examples: ["reshape([1, 2, 3, 4, 5, 6], [2, 3])", "reshape([[1, 2], [3, 4]], [1, 4])", "reshape([[1, 2], [3, 4]], [4])"],
  seealso: ["size", "squeeze", "resize"]
};
reshape.reshapeDocs = reshapeDocs;
var resize = {};
Object.defineProperty(resize, "__esModule", {
  value: !0
});
resize.resizeDocs = void 0;
var resizeDocs = {
  name: "resize",
  category: "Matrix",
  syntax: ["resize(x, size)", "resize(x, size, defaultValue)"],
  description: "Resize a matrix.",
  examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'],
  seealso: ["size", "subset", "squeeze", "reshape"]
};
resize.resizeDocs = resizeDocs;
var range = {};
Object.defineProperty(range, "__esModule", {
  value: !0
});
range.rangeDocs = void 0;
var rangeDocs = {
  name: "range",
  category: "Type",
  syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"],
  description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
  examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
};
range.rangeDocs = rangeDocs;
var partitionSelect = {};
Object.defineProperty(partitionSelect, "__esModule", {
  value: !0
});
partitionSelect.partitionSelectDocs = void 0;
var partitionSelectDocs = {
  name: "partitionSelect",
  category: "Matrix",
  syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"],
  description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
  examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1)'],
  seealso: ["sort"]
};
partitionSelect.partitionSelectDocs = partitionSelectDocs;
var ones = {};
Object.defineProperty(ones, "__esModule", {
  value: !0
});
ones.onesDocs = void 0;
var onesDocs = {
  name: "ones",
  category: "Matrix",
  syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])"],
  description: "Create a matrix containing ones.",
  examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
};
ones.onesDocs = onesDocs;
var map$1 = {};
Object.defineProperty(map$1, "__esModule", {
  value: !0
});
map$1.mapDocs = void 0;
var mapDocs = {
  name: "map",
  category: "Matrix",
  syntax: ["map(x, callback)"],
  description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
  examples: ["map([1, 2, 3], square)"],
  seealso: ["filter", "forEach"]
};
map$1.mapDocs = mapDocs;
var kron = {};
Object.defineProperty(kron, "__esModule", {
  value: !0
});
kron.kronDocs = void 0;
var kronDocs = {
  name: "kron",
  category: "Matrix",
  syntax: ["kron(x, y)"],
  description: "Calculates the kronecker product of 2 matrices or vectors.",
  examples: ["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])", "kron([1,1], [2,3,4])"],
  seealso: ["multiply", "dot", "cross"]
};
kron.kronDocs = kronDocs;
var inv$1 = {};
Object.defineProperty(inv$1, "__esModule", {
  value: !0
});
inv$1.invDocs = void 0;
var invDocs = {
  name: "inv",
  category: "Matrix",
  syntax: ["inv(x)"],
  description: "Calculate the inverse of a matrix",
  examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"],
  seealso: ["concat", "det", "diag", "identity", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
};
inv$1.invDocs = invDocs;
var forEach = {};
Object.defineProperty(forEach, "__esModule", {
  value: !0
});
forEach.forEachDocs = void 0;
var forEachDocs = {
  name: "forEach",
  category: "Matrix",
  syntax: ["forEach(x, callback)"],
  description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
  examples: ["forEach([1, 2, 3], function(val) { console.log(val) })"],
  seealso: ["map", "sort", "filter"]
};
forEach.forEachDocs = forEachDocs;
var flatten$1 = {};
Object.defineProperty(flatten$1, "__esModule", {
  value: !0
});
flatten$1.flattenDocs = void 0;
var flattenDocs = {
  name: "flatten",
  category: "Matrix",
  syntax: ["flatten(x)"],
  description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"],
  seealso: ["concat", "resize", "size", "squeeze"]
};
flatten$1.flattenDocs = flattenDocs;
var filter = {};
Object.defineProperty(filter, "__esModule", {
  value: !0
});
filter.filterDocs = void 0;
var filterDocs = {
  name: "filter",
  category: "Matrix",
  syntax: ["filter(x, test)"],
  description: "Filter items in a matrix.",
  examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"],
  seealso: ["sort", "map", "forEach"]
};
filter.filterDocs = filterDocs;
var identity = {};
Object.defineProperty(identity, "__esModule", {
  value: !0
});
identity.identityDocs = void 0;
var identityDocs = {
  name: "identity",
  category: "Matrix",
  syntax: ["identity(n)", "identity(m, n)", "identity([m, n])"],
  description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
  examples: ["identity(3)", "identity(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "identity(size(a))"],
  seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
};
identity.identityDocs = identityDocs;
var getMatrixDataType = {};
Object.defineProperty(getMatrixDataType, "__esModule", {
  value: !0
});
getMatrixDataType.getMatrixDataTypeDocs = void 0;
var getMatrixDataTypeDocs = {
  name: "getMatrixDataType",
  category: "Matrix",
  syntax: ["getMatrixDataType(x)"],
  description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
  examples: ["getMatrixDataType([1, 2, 3])", "getMatrixDataType([[5 cm], [2 inch]])", 'getMatrixDataType([1, "text"])', "getMatrixDataType([1, bignumber(4)])"],
  seealso: ["matrix", "sparse", "typeOf"]
};
getMatrixDataType.getMatrixDataTypeDocs = getMatrixDataTypeDocs;
var dot = {};
Object.defineProperty(dot, "__esModule", {
  value: !0
});
dot.dotDocs = void 0;
var dotDocs = {
  name: "dot",
  category: "Matrix",
  syntax: ["dot(A, B)", "A * B"],
  description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
  examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"],
  seealso: ["multiply", "cross"]
};
dot.dotDocs = dotDocs;
var diag = {};
Object.defineProperty(diag, "__esModule", {
  value: !0
});
diag.diagDocs = void 0;
var diagDocs = {
  name: "diag",
  category: "Matrix",
  syntax: ["diag(x)", "diag(x, k)"],
  description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
  examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"],
  seealso: ["concat", "det", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
};
diag.diagDocs = diagDocs;
var det$1 = {};
Object.defineProperty(det$1, "__esModule", {
  value: !0
});
det$1.detDocs = void 0;
var detDocs = {
  name: "det",
  category: "Matrix",
  syntax: ["det(x)"],
  description: "Calculate the determinant of a matrix",
  examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"],
  seealso: ["concat", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
};
det$1.detDocs = detDocs;
var ctranspose = {};
Object.defineProperty(ctranspose, "__esModule", {
  value: !0
});
ctranspose.ctransposeDocs = void 0;
var ctransposeDocs = {
  name: "ctranspose",
  category: "Matrix",
  syntax: ["x'", "ctranspose(x)"],
  description: "Complex Conjugate and Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "ctranspose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
};
ctranspose.ctransposeDocs = ctransposeDocs;
var cross = {};
Object.defineProperty(cross, "__esModule", {
  value: !0
});
cross.crossDocs = void 0;
var crossDocs = {
  name: "cross",
  category: "Matrix",
  syntax: ["cross(A, B)"],
  description: "Calculate the cross product for two vectors in three dimensional space.",
  examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"],
  seealso: ["multiply", "dot"]
};
cross.crossDocs = crossDocs;
var concat = {};
Object.defineProperty(concat, "__esModule", {
  value: !0
});
concat.concatDocs = void 0;
var concatDocs = {
  name: "concat",
  category: "Matrix",
  syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"],
  description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
  examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"],
  seealso: ["det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
};
concat.concatDocs = concatDocs;
var xor = {};
Object.defineProperty(xor, "__esModule", {
  value: !0
});
xor.xorDocs = void 0;
var xorDocs = {
  name: "xor",
  category: "Logical",
  syntax: ["x xor y", "xor(x, y)"],
  description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
  examples: ["true xor false", "false xor false", "true xor true", "0 xor 4"],
  seealso: ["not", "and", "or"]
};
xor.xorDocs = xorDocs;
var or = {};
Object.defineProperty(or, "__esModule", {
  value: !0
});
or.orDocs = void 0;
var orDocs = {
  name: "or",
  category: "Logical",
  syntax: ["x or y", "or(x, y)"],
  description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
  examples: ["true or false", "false or false", "0 or 4"],
  seealso: ["not", "and", "xor"]
};
or.orDocs = orDocs;
var not = {};
Object.defineProperty(not, "__esModule", {
  value: !0
});
not.notDocs = void 0;
var notDocs = {
  name: "not",
  category: "Logical",
  syntax: ["not x", "not(x)"],
  description: "Logical not. Flips the boolean value of given argument.",
  examples: ["not true", "not false", "not 2", "not 0"],
  seealso: ["and", "or", "xor"]
};
not.notDocs = notDocs;
var and = {};
Object.defineProperty(and, "__esModule", {
  value: !0
});
and.andDocs = void 0;
var andDocs = {
  name: "and",
  category: "Logical",
  syntax: ["x and y", "and(x, y)"],
  description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
  examples: ["true and false", "true and true", "2 and 4"],
  seealso: ["not", "or", "xor"]
};
and.andDocs = andDocs;
var intersect$1 = {};
Object.defineProperty(intersect$1, "__esModule", {
  value: !0
});
intersect$1.intersectDocs = void 0;
var intersectDocs = {
  name: "intersect",
  category: "Geometry",
  syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"],
  description: "Computes the intersection point of lines and/or planes.",
  examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"],
  seealso: []
};
intersect$1.intersectDocs = intersectDocs;
var distance$1 = {};
Object.defineProperty(distance$1, "__esModule", {
  value: !0
});
distance$1.distanceDocs = void 0;
var distanceDocs = {
  name: "distance",
  category: "Geometry",
  syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2]])"],
  description: "Calculates the Euclidean distance between two points.",
  examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"],
  seealso: []
};
distance$1.distanceDocs = distanceDocs;
var help = {};
Object.defineProperty(help, "__esModule", {
  value: !0
});
help.helpDocs = void 0;
var helpDocs = {
  name: "help",
  category: "Expression",
  syntax: ["help(object)", "help(string)"],
  description: "Display documentation on a function or data type.",
  examples: ["help(sqrt)", 'help("complex")'],
  seealso: []
};
help.helpDocs = helpDocs;
var evaluate$1 = {};
Object.defineProperty(evaluate$1, "__esModule", {
  value: !0
});
evaluate$1.evaluateDocs = void 0;
var evaluateDocs = {
  name: "evaluate",
  category: "Expression",
  syntax: ["evaluate(expression)", "evaluate([expr1, expr2, expr3, ...])"],
  description: "Evaluate an expression or an array with expressions.",
  examples: ['evaluate("2 + 3")', 'evaluate("sqrt(" + 4 + ")")'],
  seealso: []
};
evaluate$1.evaluateDocs = evaluateDocs;
var im = {};
Object.defineProperty(im, "__esModule", {
  value: !0
});
im.imDocs = void 0;
var imDocs = {
  name: "im",
  category: "Complex",
  syntax: ["im(x)"],
  description: "Get the imaginary part of a complex number.",
  examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"],
  seealso: ["re", "conj", "abs", "arg"]
};
im.imDocs = imDocs;
var re = {};
Object.defineProperty(re, "__esModule", {
  value: !0
});
re.reDocs = void 0;
var reDocs = {
  name: "re",
  category: "Complex",
  syntax: ["re(x)"],
  description: "Get the real part of a complex number.",
  examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"],
  seealso: ["im", "conj", "abs", "arg"]
};
re.reDocs = reDocs;
var conj = {};
Object.defineProperty(conj, "__esModule", {
  value: !0
});
conj.conjDocs = void 0;
var conjDocs = {
  name: "conj",
  category: "Complex",
  syntax: ["conj(x)"],
  description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
  examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"],
  seealso: ["re", "im", "abs", "arg"]
};
conj.conjDocs = conjDocs;
var arg = {};
Object.defineProperty(arg, "__esModule", {
  value: !0
});
arg.argDocs = void 0;
var argDocs = {
  name: "arg",
  category: "Complex",
  syntax: ["arg(x)"],
  description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
  examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"],
  seealso: ["re", "im", "conj", "abs"]
};
arg.argDocs = argDocs;
var typed = {};
Object.defineProperty(typed, "__esModule", {
  value: !0
});
typed.typedDocs = void 0;
var typedDocs = {
  name: "typed",
  category: "Core",
  syntax: ["typed(signatures)", "typed(name, signatures)"],
  description: "Create a typed function.",
  examples: ['double = typed({ "number, number": f(x)=x+x })', "double(2)", 'double("hello")'],
  seealso: []
};
typed.typedDocs = typedDocs;
var _import$3 = {};
Object.defineProperty(_import$3, "__esModule", {
  value: !0
});
_import$3.importDocs = void 0;
var importDocs = {
  name: "import",
  category: "Core",
  syntax: ["import(functions)", "import(functions, options)"],
  description: "Import functions or constants from an object.",
  examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"],
  seealso: []
};
_import$3.importDocs = importDocs;
var config = {};
Object.defineProperty(config, "__esModule", {
  value: !0
});
config.configDocs = void 0;
var configDocs = {
  name: "config",
  category: "Core",
  syntax: ["config()", "config(options)"],
  description: "Get configuration or change configuration.",
  examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"],
  seealso: []
};
config.configDocs = configDocs;
var stirlingS2$1 = {};
Object.defineProperty(stirlingS2$1, "__esModule", {
  value: !0
});
stirlingS2$1.stirlingS2Docs = void 0;
var stirlingS2Docs = {
  name: "stirlingS2",
  category: "Combinatorics",
  syntax: ["stirlingS2(n, k)"],
  description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
  examples: ["stirlingS2(5, 3)"],
  seealso: ["bellNumbers"]
};
stirlingS2$1.stirlingS2Docs = stirlingS2Docs;
var composition$1 = {};
Object.defineProperty(composition$1, "__esModule", {
  value: !0
});
composition$1.compositionDocs = void 0;
var compositionDocs = {
  name: "composition",
  category: "Combinatorics",
  syntax: ["composition(n, k)"],
  description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
  examples: ["composition(5, 3)"],
  seealso: ["combinations"]
};
composition$1.compositionDocs = compositionDocs;
var catalan$1 = {};
Object.defineProperty(catalan$1, "__esModule", {
  value: !0
});
catalan$1.catalanDocs = void 0;
var catalanDocs = {
  name: "catalan",
  category: "Combinatorics",
  syntax: ["catalan(n)"],
  description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["catalan(3)", "catalan(8)"],
  seealso: ["bellNumbers"]
};
catalan$1.catalanDocs = catalanDocs;
var bellNumbers$1 = {};
Object.defineProperty(bellNumbers$1, "__esModule", {
  value: !0
});
bellNumbers$1.bellNumbersDocs = void 0;
var bellNumbersDocs = {
  name: "bellNumbers",
  category: "Combinatorics",
  syntax: ["bellNumbers(n)"],
  description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["bellNumbers(3)", "bellNumbers(8)"],
  seealso: ["stirlingS2"]
};
bellNumbers$1.bellNumbersDocs = bellNumbersDocs;
var rightLogShift = {};
Object.defineProperty(rightLogShift, "__esModule", {
  value: !0
});
rightLogShift.rightLogShiftDocs = void 0;
var rightLogShiftDocs = {
  name: "rightLogShift",
  category: "Bitwise",
  syntax: ["x >>> y", "rightLogShift(x, y)"],
  description: "Bitwise right logical shift of a value x by y number of bits.",
  examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"]
};
rightLogShift.rightLogShiftDocs = rightLogShiftDocs;
var rightArithShift = {};
Object.defineProperty(rightArithShift, "__esModule", {
  value: !0
});
rightArithShift.rightArithShiftDocs = void 0;
var rightArithShiftDocs = {
  name: "rightArithShift",
  category: "Bitwise",
  syntax: ["x >> y", "rightArithShift(x, y)"],
  description: "Bitwise right arithmetic shift of a value x by y number of bits.",
  examples: ["8 >> 1", "4 << 1", "-12 >> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"]
};
rightArithShift.rightArithShiftDocs = rightArithShiftDocs;
var leftShift = {};
Object.defineProperty(leftShift, "__esModule", {
  value: !0
});
leftShift.leftShiftDocs = void 0;
var leftShiftDocs = {
  name: "leftShift",
  category: "Bitwise",
  syntax: ["x << y", "leftShift(x, y)"],
  description: "Bitwise left logical shift of a value x by y number of bits.",
  examples: ["4 << 1", "8 >> 1"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"]
};
leftShift.leftShiftDocs = leftShiftDocs;
var bitXor = {};
Object.defineProperty(bitXor, "__esModule", {
  value: !0
});
bitXor.bitXorDocs = void 0;
var bitXorDocs = {
  name: "bitXor",
  category: "Bitwise",
  syntax: ["bitXor(x, y)"],
  description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
  examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"],
  seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"]
};
bitXor.bitXorDocs = bitXorDocs;
var bitOr = {};
Object.defineProperty(bitOr, "__esModule", {
  value: !0
});
bitOr.bitOrDocs = void 0;
var bitOrDocs = {
  name: "bitOr",
  category: "Bitwise",
  syntax: ["x | y", "bitOr(x, y)"],
  description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
  examples: ["5 | 3", "bitOr([1, 2, 3], 4)"],
  seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
};
bitOr.bitOrDocs = bitOrDocs;
var bitNot = {};
Object.defineProperty(bitNot, "__esModule", {
  value: !0
});
bitNot.bitNotDocs = void 0;
var bitNotDocs = {
  name: "bitNot",
  category: "Bitwise",
  syntax: ["~x", "bitNot(x)"],
  description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
  examples: ["~1", "~2", "bitNot([2, -3, 4])"],
  seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
};
bitNot.bitNotDocs = bitNotDocs;
var bitAnd = {};
Object.defineProperty(bitAnd, "__esModule", {
  value: !0
});
bitAnd.bitAndDocs = void 0;
var bitAndDocs = {
  name: "bitAnd",
  category: "Bitwise",
  syntax: ["x & y", "bitAnd(x, y)"],
  description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
  examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"],
  seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
};
bitAnd.bitAndDocs = bitAndDocs;
var xgcd = {};
Object.defineProperty(xgcd, "__esModule", {
  value: !0
});
xgcd.xgcdDocs = void 0;
var xgcdDocs = {
  name: "xgcd",
  category: "Arithmetic",
  syntax: ["xgcd(a, b)"],
  description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
  examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"],
  seealso: ["gcd", "lcm"]
};
xgcd.xgcdDocs = xgcdDocs;
var unaryPlus = {};
Object.defineProperty(unaryPlus, "__esModule", {
  value: !0
});
unaryPlus.unaryPlusDocs = void 0;
var unaryPlusDocs = {
  name: "unaryPlus",
  category: "Operators",
  syntax: ["+x", "unaryPlus(x)"],
  description: "Converts booleans and strings to numbers.",
  examples: ["+true", '+"2"'],
  seealso: ["add", "subtract", "unaryMinus"]
};
unaryPlus.unaryPlusDocs = unaryPlusDocs;
var unaryMinus = {};
Object.defineProperty(unaryMinus, "__esModule", {
  value: !0
});
unaryMinus.unaryMinusDocs = void 0;
var unaryMinusDocs = {
  name: "unaryMinus",
  category: "Operators",
  syntax: ["-x", "unaryMinus(x)"],
  description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
  examples: ["-4.5", "-(-5.6)", '-"22"'],
  seealso: ["add", "subtract", "unaryPlus"]
};
unaryMinus.unaryMinusDocs = unaryMinusDocs;
var square = {};
Object.defineProperty(square, "__esModule", {
  value: !0
});
square.squareDocs = void 0;
var squareDocs = {
  name: "square",
  category: "Arithmetic",
  syntax: ["square(x)"],
  description: "Compute the square of a value. The square of x is x * x.",
  examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"],
  seealso: ["multiply", "pow", "sqrt", "cube"]
};
square.squareDocs = squareDocs;
var sqrtm$1 = {};
Object.defineProperty(sqrtm$1, "__esModule", {
  value: !0
});
sqrtm$1.sqrtmDocs = void 0;
var sqrtmDocs = {
  name: "sqrtm",
  category: "Arithmetic",
  syntax: ["sqrtm(x)"],
  description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
  examples: ["sqrtm([[1, 2], [3, 4]])"],
  seealso: ["sqrt", "abs", "square", "multiply"]
};
sqrtm$1.sqrtmDocs = sqrtmDocs;
var sqrt = {};
Object.defineProperty(sqrt, "__esModule", {
  value: !0
});
sqrt.sqrtDocs = void 0;
var sqrtDocs = {
  name: "sqrt",
  category: "Arithmetic",
  syntax: ["sqrt(x)"],
  description: "Compute the square root value. If x = y * y, then y is the square root of x.",
  examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"],
  seealso: ["square", "sqrtm", "multiply", "nthRoot", "nthRoots", "pow"]
};
sqrt.sqrtDocs = sqrtDocs;
var sign$1 = {};
Object.defineProperty(sign$1, "__esModule", {
  value: !0
});
sign$1.signDocs = void 0;
var signDocs = {
  name: "sign",
  category: "Arithmetic",
  syntax: ["sign(x)"],
  description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
  examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"],
  seealso: ["abs"]
};
sign$1.signDocs = signDocs;
var round$2 = {};
Object.defineProperty(round$2, "__esModule", {
  value: !0
});
round$2.roundDocs = void 0;
var roundDocs = {
  name: "round",
  category: "Arithmetic",
  syntax: ["round(x)", "round(x, n)"],
  description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
  examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)"],
  seealso: ["ceil", "floor", "fix"]
};
round$2.roundDocs = roundDocs;
var pow = {};
Object.defineProperty(pow, "__esModule", {
  value: !0
});
pow.powDocs = void 0;
var powDocs = {
  name: "pow",
  category: "Operators",
  syntax: ["x ^ y", "pow(x, y)"],
  description: "Calculates the power of x to y, x^y.",
  examples: ["2^3", "2*2*2", "1 + e ^ (pi * i)"],
  seealso: ["multiply", "nthRoot", "nthRoots", "sqrt"]
};
pow.powDocs = powDocs;
var nthRoots = {};
Object.defineProperty(nthRoots, "__esModule", {
  value: !0
});
nthRoots.nthRootsDocs = void 0;
var nthRootsDocs = {
  name: "nthRoots",
  category: "Arithmetic",
  syntax: ["nthRoots(A)", "nthRoots(A, root)"],
  description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
  examples: ["nthRoots(1)", "nthRoots(1, 3)"],
  seealso: ["sqrt", "pow", "nthRoot"]
};
nthRoots.nthRootsDocs = nthRootsDocs;
var nthRoot = {};
Object.defineProperty(nthRoot, "__esModule", {
  value: !0
});
nthRoot.nthRootDocs = void 0;
var nthRootDocs = {
  name: "nthRoot",
  category: "Arithmetic",
  syntax: ["nthRoot(a)", "nthRoot(a, root)"],
  description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
  examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"],
  seealso: ["nthRoots", "pow", "sqrt"]
};
nthRoot.nthRootDocs = nthRootDocs;
var norm = {};
Object.defineProperty(norm, "__esModule", {
  value: !0
});
norm.normDocs = void 0;
var normDocs = {
  name: "norm",
  category: "Arithmetic",
  syntax: ["norm(x)", "norm(x, p)"],
  description: "Calculate the norm of a number, vector or matrix.",
  examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i)", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")']
};
norm.normDocs = normDocs;
var multiply = {};
Object.defineProperty(multiply, "__esModule", {
  value: !0
});
multiply.multiplyDocs = void 0;
var multiplyDocs = {
  name: "multiply",
  category: "Operators",
  syntax: ["x * y", "multiply(x, y)"],
  description: "multiply two values.",
  examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"],
  seealso: ["divide"]
};
multiply.multiplyDocs = multiplyDocs;
var mod$2 = {};
Object.defineProperty(mod$2, "__esModule", {
  value: !0
});
mod$2.modDocs = void 0;
var modDocs = {
  name: "mod",
  category: "Operators",
  syntax: ["x % y", "x mod y", "mod(x, y)"],
  description: "Calculates the modulus, the remainder of an integer division.",
  examples: ["7 % 3", "11 % 2", "10 mod 4", "isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"],
  seealso: ["divide"]
};
mod$2.modDocs = modDocs;
var log10 = {};
Object.defineProperty(log10, "__esModule", {
  value: !0
});
log10.log10Docs = void 0;
var log10Docs = {
  name: "log10",
  category: "Arithmetic",
  syntax: ["log10(x)"],
  description: "Compute the 10-base logarithm of a value.",
  examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"],
  seealso: ["exp", "log"]
};
log10.log10Docs = log10Docs;
var log1p = {};
Object.defineProperty(log1p, "__esModule", {
  value: !0
});
log1p.log1pDocs = void 0;
var log1pDocs = {
  name: "log1p",
  category: "Arithmetic",
  syntax: ["log1p(x)", "log1p(x, base)"],
  description: "Calculate the logarithm of a `value+1`",
  examples: ["log1p(2.5)", "exp(log1p(1.4))", "pow(10, 4)", "log1p(9999, 10)", "log1p(9999) / log(10)"],
  seealso: ["exp", "log", "log2", "log10"]
};
log1p.log1pDocs = log1pDocs;
var log2 = {};
Object.defineProperty(log2, "__esModule", {
  value: !0
});
log2.log2Docs = void 0;
var log2Docs = {
  name: "log2",
  category: "Arithmetic",
  syntax: ["log2(x)"],
  description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
  examples: ["log2(0.03125)", "log2(16)", "log2(16) / log2(2)", "pow(2, 4)"],
  seealso: ["exp", "log1p", "log", "log10"]
};
log2.log2Docs = log2Docs;
var log = {};
Object.defineProperty(log, "__esModule", {
  value: !0
});
log.logDocs = void 0;
var logDocs = {
  name: "log",
  category: "Arithmetic",
  syntax: ["log(x)", "log(x, base)"],
  description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
  examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"],
  seealso: ["exp", "log1p", "log2", "log10"]
};
log.logDocs = logDocs;
var lcm = {};
Object.defineProperty(lcm, "__esModule", {
  value: !0
});
lcm.lcmDocs = void 0;
var lcmDocs = {
  name: "lcm",
  category: "Arithmetic",
  syntax: ["lcm(x, y)"],
  description: "Compute the least common multiple.",
  examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"],
  seealso: ["gcd"]
};
lcm.lcmDocs = lcmDocs;
var hypot = {};
Object.defineProperty(hypot, "__esModule", {
  value: !0
});
hypot.hypotDocs = void 0;
var hypotDocs = {
  name: "hypot",
  category: "Arithmetic",
  syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"],
  description: "Calculate the hypotenusa of a list with values. ",
  examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"],
  seealso: ["abs", "norm"]
};
hypot.hypotDocs = hypotDocs;
var gcd = {};
Object.defineProperty(gcd, "__esModule", {
  value: !0
});
gcd.gcdDocs = void 0;
var gcdDocs = {
  name: "gcd",
  category: "Arithmetic",
  syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"],
  description: "Compute the greatest common divisor.",
  examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"],
  seealso: ["lcm", "xgcd"]
};
gcd.gcdDocs = gcdDocs;
var floor$1 = {};
Object.defineProperty(floor$1, "__esModule", {
  value: !0
});
floor$1.floorDocs = void 0;
var floorDocs = {
  name: "floor",
  category: "Arithmetic",
  syntax: ["floor(x)"],
  description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
  examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)"],
  seealso: ["ceil", "fix", "round"]
};
floor$1.floorDocs = floorDocs;
var fix = {};
Object.defineProperty(fix, "__esModule", {
  value: !0
});
fix.fixDocs = void 0;
var fixDocs = {
  name: "fix",
  category: "Arithmetic",
  syntax: ["fix(x)"],
  description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
  examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)"],
  seealso: ["ceil", "floor", "round"]
};
fix.fixDocs = fixDocs;
var expm1 = {};
Object.defineProperty(expm1, "__esModule", {
  value: !0
});
expm1.expm1Docs = void 0;
var expm1Docs = {
  name: "expm1",
  category: "Arithmetic",
  syntax: ["expm1(x)"],
  description: "Calculate the value of subtracting 1 from the exponential value.",
  examples: ["expm1(2)", "pow(e, 2) - 1", "log(expm1(2) + 1)"],
  seealso: ["exp", "pow", "log"]
};
expm1.expm1Docs = expm1Docs;
var expm$1 = {};
Object.defineProperty(expm$1, "__esModule", {
  value: !0
});
expm$1.expmDocs = void 0;
var expmDocs = {
  name: "expm",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
  examples: ["expm([[0,2],[0,0]])"],
  seealso: ["exp"]
};
expm$1.expmDocs = expmDocs;
var eigs$1 = {};
Object.defineProperty(eigs$1, "__esModule", {
  value: !0
});
eigs$1.eigsDocs = void 0;
var eigsDocs = {
  name: "eigs",
  category: "Matrix",
  syntax: ["eigs(x)"],
  description: "Calculate the eigenvalues and eigenvectors of a real symmetric matrix",
  examples: ["eigs([[5, 2.3], [2.3, 1]])"],
  seealso: ["inv"]
};
eigs$1.eigsDocs = eigsDocs;
var exp = {};
Object.defineProperty(exp, "__esModule", {
  value: !0
});
exp.expDocs = void 0;
var expDocs = {
  name: "exp",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Calculate the exponent of a value.",
  examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"],
  seealso: ["expm", "expm1", "pow", "log"]
};
exp.expDocs = expDocs;
var dotMultiply = {};
Object.defineProperty(dotMultiply, "__esModule", {
  value: !0
});
dotMultiply.dotMultiplyDocs = void 0;
var dotMultiplyDocs = {
  name: "dotMultiply",
  category: "Operators",
  syntax: ["x .* y", "dotMultiply(x, y)"],
  description: "Multiply two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"],
  seealso: ["multiply", "divide", "dotDivide"]
};
dotMultiply.dotMultiplyDocs = dotMultiplyDocs;
var dotDivide = {};
Object.defineProperty(dotDivide, "__esModule", {
  value: !0
});
dotDivide.dotDivideDocs = void 0;
var dotDivideDocs = {
  name: "dotDivide",
  category: "Operators",
  syntax: ["x ./ y", "dotDivide(x, y)"],
  description: "Divide two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"],
  seealso: ["multiply", "dotMultiply", "divide"]
};
dotDivide.dotDivideDocs = dotDivideDocs;
var divide$1 = {};
Object.defineProperty(divide$1, "__esModule", {
  value: !0
});
divide$1.divideDocs = void 0;
var divideDocs = {
  name: "divide",
  category: "Operators",
  syntax: ["x / y", "divide(x, y)"],
  description: "Divide two values.",
  examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"],
  seealso: ["multiply"]
};
divide$1.divideDocs = divideDocs;
var cube = {};
Object.defineProperty(cube, "__esModule", {
  value: !0
});
cube.cubeDocs = void 0;
var cubeDocs = {
  name: "cube",
  category: "Arithmetic",
  syntax: ["cube(x)"],
  description: "Compute the cube of a value. The cube of x is x * x * x.",
  examples: ["cube(2)", "2^3", "2 * 2 * 2"],
  seealso: ["multiply", "square", "pow"]
};
cube.cubeDocs = cubeDocs;
var ceil = {};
Object.defineProperty(ceil, "__esModule", {
  value: !0
});
ceil.ceilDocs = void 0;
var ceilDocs = {
  name: "ceil",
  category: "Arithmetic",
  syntax: ["ceil(x)"],
  description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
  examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)"],
  seealso: ["floor", "fix", "round"]
};
ceil.ceilDocs = ceilDocs;
var cbrt = {};
Object.defineProperty(cbrt, "__esModule", {
  value: !0
});
cbrt.cbrtDocs = void 0;
var cbrtDocs = {
  name: "cbrt",
  category: "Arithmetic",
  syntax: ["cbrt(x)", "cbrt(x, allRoots)"],
  description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
  examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"],
  seealso: ["square", "sqrt", "cube", "multiply"]
};
cbrt.cbrtDocs = cbrtDocs;
var add$2 = {};
Object.defineProperty(add$2, "__esModule", {
  value: !0
});
add$2.addDocs = void 0;
var addDocs = {
  name: "add",
  category: "Operators",
  syntax: ["x + y", "add(x, y)"],
  description: "Add two values.",
  examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'],
  seealso: ["subtract"]
};
add$2.addDocs = addDocs;
var abs$2 = {};
Object.defineProperty(abs$2, "__esModule", {
  value: !0
});
abs$2.absDocs = void 0;
var absDocs = {
  name: "abs",
  category: "Arithmetic",
  syntax: ["abs(x)"],
  description: "Compute the absolute value.",
  examples: ["abs(3.5)", "abs(-4.2)"],
  seealso: ["sign"]
};
abs$2.absDocs = absDocs;
var qr = {};
Object.defineProperty(qr, "__esModule", {
  value: !0
});
qr.qrDocs = void 0;
var qrDocs = {
  name: "qr",
  category: "Algebra",
  syntax: ["qr(A)"],
  description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
  examples: ["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"],
  seealso: ["lup", "slu", "matrix"]
};
qr.qrDocs = qrDocs;
var usolve = {};
Object.defineProperty(usolve, "__esModule", {
  value: !0
});
usolve.usolveDocs = void 0;
var usolveDocs = {
  name: "usolve",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolveAll", "lup", "lusolve", "lsolve", "matrix", "sparse"]
};
usolve.usolveDocs = usolveDocs;
var usolveAll = {};
Object.defineProperty(usolveAll, "__esModule", {
  value: !0
});
usolveAll.usolveAllDocs = void 0;
var usolveAllDocs = {
  name: "usolveAll",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolve", "lup", "lusolve", "lsolve", "matrix", "sparse"]
};
usolveAll.usolveAllDocs = usolveAllDocs;
var slu = {};
Object.defineProperty(slu, "__esModule", {
  value: !0
});
slu.sluDocs = void 0;
var sluDocs = {
  name: "slu",
  category: "Algebra",
  syntax: ["slu(A, order, threshold)"],
  description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
  examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup", "qr"]
};
slu.sluDocs = sluDocs;
var rationalize$1 = {};
Object.defineProperty(rationalize$1, "__esModule", {
  value: !0
});
rationalize$1.rationalizeDocs = void 0;
var rationalizeDocs = {
  name: "rationalize",
  category: "Algebra",
  syntax: ["rationalize(expr)", "rationalize(expr, scope)", "rationalize(expr, scope, detailed)"],
  description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
  examples: ['rationalize("2x/y - y/(x+1)")', 'rationalize("2x/y - y/(x+1)", true)'],
  seealso: ["simplify"]
};
rationalize$1.rationalizeDocs = rationalizeDocs;
var simplify$1 = {};
Object.defineProperty(simplify$1, "__esModule", {
  value: !0
});
simplify$1.simplifyDocs = void 0;
var simplifyDocs = {
  name: "simplify",
  category: "Algebra",
  syntax: ["simplify(expr)", "simplify(expr, rules)"],
  description: "Simplify an expression tree.",
  examples: ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', "simplified = simplify(f)", "simplified.evaluate({x: 2})"],
  seealso: ["derivative", "parse", "evaluate"]
};
simplify$1.simplifyDocs = simplifyDocs;
var lup = {};
Object.defineProperty(lup, "__esModule", {
  value: !0
});
lup.lupDocs = void 0;
var lupDocs = {
  name: "lup",
  category: "Algebra",
  syntax: ["lup(m)"],
  description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
  examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu", "qr"]
};
lup.lupDocs = lupDocs;
var lsolve = {};
Object.defineProperty(lsolve, "__esModule", {
  value: !0
});
lsolve.lsolveDocs = void 0;
var lsolveDocs = {
  name: "lsolve",
  category: "Algebra",
  syntax: ["x=lsolve(L, b)"],
  description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolveAll", "lup", "lusolve", "usolve", "matrix", "sparse"]
};
lsolve.lsolveDocs = lsolveDocs;
var lsolveAll = {};
Object.defineProperty(lsolveAll, "__esModule", {
  value: !0
});
lsolveAll.lsolveAllDocs = void 0;
var lsolveAllDocs = {
  name: "lsolveAll",
  category: "Algebra",
  syntax: ["x=lsolveAll(L, b)"],
  description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolve", "lup", "lusolve", "usolve", "matrix", "sparse"]
};
lsolveAll.lsolveAllDocs = lsolveAllDocs;
var derivative$1 = {};
Object.defineProperty(derivative$1, "__esModule", {
  value: !0
});
derivative$1.derivativeDocs = void 0;
var derivativeDocs = {
  name: "derivative",
  category: "Algebra",
  syntax: ["derivative(expr, variable)", "derivative(expr, variable, {simplify: boolean})"],
  description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
  examples: ['derivative("2x^3", "x")', 'derivative("2x^3", "x", {simplify: false})', 'derivative("2x^2 + 3x + 4", "x")', 'derivative("sin(2x)", "x")', 'f = parse("x^2 + x")', 'x = parse("x")', "df = derivative(f, x)", "df.evaluate({x: 3})"],
  seealso: ["simplify", "parse", "evaluate"]
};
derivative$1.derivativeDocs = derivativeDocs;
var version$3 = {};
Object.defineProperty(version$3, "__esModule", {
  value: !0
});
version$3.versionDocs = void 0;
var versionDocs = {
  name: "version",
  category: "Constants",
  syntax: ["version"],
  description: "A string with the version number of math.js",
  examples: ["version"],
  seealso: []
};
version$3.versionDocs = versionDocs;
var _true$1 = {};
Object.defineProperty(_true$1, "__esModule", {
  value: !0
});
_true$1.trueDocs = void 0;
var trueDocs = {
  name: "true",
  category: "Constants",
  syntax: ["true"],
  description: "Boolean value true",
  examples: ["true"],
  seealso: ["false"]
};
_true$1.trueDocs = trueDocs;
var tau = {};
Object.defineProperty(tau, "__esModule", {
  value: !0
});
tau.tauDocs = void 0;
var tauDocs = {
  name: "tau",
  category: "Constants",
  syntax: ["tau"],
  description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
  examples: ["tau", "2 * pi"],
  seealso: ["pi"]
};
tau.tauDocs = tauDocs;
var SQRT2 = {};
Object.defineProperty(SQRT2, "__esModule", {
  value: !0
});
SQRT2.SQRT2Docs = void 0;
var SQRT2Docs = {
  name: "SQRT2",
  category: "Constants",
  syntax: ["SQRT2"],
  description: "Returns the square root of 2, approximately equal to 1.414",
  examples: ["SQRT2", "sqrt(2)"],
  seealso: []
};
SQRT2.SQRT2Docs = SQRT2Docs;
var SQRT1_2 = {};
Object.defineProperty(SQRT1_2, "__esModule", {
  value: !0
});
SQRT1_2.SQRT12Docs = void 0;
var SQRT12Docs = {
  name: "SQRT1_2",
  category: "Constants",
  syntax: ["SQRT1_2"],
  description: "Returns the square root of 1/2, approximately equal to 0.707",
  examples: ["SQRT1_2", "sqrt(1/2)"],
  seealso: []
};
SQRT1_2.SQRT12Docs = SQRT12Docs;
var phi = {};
Object.defineProperty(phi, "__esModule", {
  value: !0
});
phi.phiDocs = void 0;
var phiDocs = {
  name: "phi",
  category: "Constants",
  syntax: ["phi"],
  description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
  examples: ["phi"],
  seealso: []
};
phi.phiDocs = phiDocs;
var pi = {};
Object.defineProperty(pi, "__esModule", {
  value: !0
});
pi.piDocs = void 0;
var piDocs = {
  name: "pi",
  category: "Constants",
  syntax: ["pi"],
  description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
  examples: ["pi", "sin(pi/2)"],
  seealso: ["tau"]
};
pi.piDocs = piDocs;
var _null$1 = {};
Object.defineProperty(_null$1, "__esModule", {
  value: !0
});
_null$1.nullDocs = void 0;
var nullDocs = {
  name: "null",
  category: "Constants",
  syntax: ["null"],
  description: "Value null",
  examples: ["null"],
  seealso: ["true", "false"]
};
_null$1.nullDocs = nullDocs;
var _NaN$1 = {};
Object.defineProperty(_NaN$1, "__esModule", {
  value: !0
});
_NaN$1.NaNDocs = void 0;
var NaNDocs = {
  name: "NaN",
  category: "Constants",
  syntax: ["NaN"],
  description: "Not a number",
  examples: ["NaN", "0 / 0"],
  seealso: []
};
_NaN$1.NaNDocs = NaNDocs;
var LOG10E = {};
Object.defineProperty(LOG10E, "__esModule", {
  value: !0
});
LOG10E.LOG10EDocs = void 0;
var LOG10EDocs = {
  name: "LOG10E",
  category: "Constants",
  syntax: ["LOG10E"],
  description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
  examples: ["LOG10E", "log(e, 10)"],
  seealso: []
};
LOG10E.LOG10EDocs = LOG10EDocs;
var LOG2E = {};
Object.defineProperty(LOG2E, "__esModule", {
  value: !0
});
LOG2E.LOG2EDocs = void 0;
var LOG2EDocs = {
  name: "LOG2E",
  category: "Constants",
  syntax: ["LOG2E"],
  description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
  examples: ["LOG2E", "log(e, 2)"],
  seealso: []
};
LOG2E.LOG2EDocs = LOG2EDocs;
var LN10 = {};
Object.defineProperty(LN10, "__esModule", {
  value: !0
});
LN10.LN10Docs = void 0;
var LN10Docs = {
  name: "LN10",
  category: "Constants",
  syntax: ["LN10"],
  description: "Returns the natural logarithm of 10, approximately equal to 2.302",
  examples: ["LN10", "log(10)"],
  seealso: []
};
LN10.LN10Docs = LN10Docs;
var LN2 = {};
Object.defineProperty(LN2, "__esModule", {
  value: !0
});
LN2.LN2Docs = void 0;
var LN2Docs = {
  name: "LN2",
  category: "Constants",
  syntax: ["LN2"],
  description: "Returns the natural logarithm of 2, approximately equal to 0.693",
  examples: ["LN2", "log(2)"],
  seealso: []
};
LN2.LN2Docs = LN2Docs;
var _Infinity$1 = {};
Object.defineProperty(_Infinity$1, "__esModule", {
  value: !0
});
_Infinity$1.InfinityDocs = void 0;
var InfinityDocs = {
  name: "Infinity",
  category: "Constants",
  syntax: ["Infinity"],
  description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
  examples: ["Infinity", "1 / 0"],
  seealso: []
};
_Infinity$1.InfinityDocs = InfinityDocs;
var i$2 = {};
Object.defineProperty(i$2, "__esModule", {
  value: !0
});
i$2.iDocs = void 0;
var iDocs = {
  name: "i",
  category: "Constants",
  syntax: ["i"],
  description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
  examples: ["i", "i * i", "sqrt(-1)"],
  seealso: []
};
i$2.iDocs = iDocs;
var _false$1 = {};
Object.defineProperty(_false$1, "__esModule", {
  value: !0
});
_false$1.falseDocs = void 0;
var falseDocs = {
  name: "false",
  category: "Constants",
  syntax: ["false"],
  description: "Boolean value false",
  examples: ["false"],
  seealso: ["true"]
};
_false$1.falseDocs = falseDocs;
var e = {};
Object.defineProperty(e, "__esModule", {
  value: !0
});
e.eDocs = void 0;
var eDocs = {
  name: "e",
  category: "Constants",
  syntax: ["e"],
  description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
  examples: ["e", "e ^ 2", "exp(2)", "log(e)"],
  seealso: ["exp"]
};
e.eDocs = eDocs;
var unit = {};
Object.defineProperty(unit, "__esModule", {
  value: !0
});
unit.unitDocs = void 0;
var unitDocs = {
  name: "unit",
  category: "Construction",
  syntax: ["value unit", "unit(value, unit)", "unit(string)"],
  description: "Create a unit.",
  examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"]
};
unit.unitDocs = unitDocs;
var string = {};
Object.defineProperty(string, "__esModule", {
  value: !0
});
string.stringDocs = void 0;
var stringDocs = {
  name: "string",
  category: "Construction",
  syntax: ['"text"', "string(x)"],
  description: "Create a string or convert a value to a string",
  examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"]
};
string.stringDocs = stringDocs;
var splitUnit = {};
Object.defineProperty(splitUnit, "__esModule", {
  value: !0
});
splitUnit.splitUnitDocs = void 0;
var splitUnitDocs = {
  name: "splitUnit",
  category: "Construction",
  syntax: ["splitUnit(unit: Unit, parts: Unit[])"],
  description: "Split a unit in an array of units whose sum is equal to the original unit.",
  examples: ['splitUnit(1 m, ["feet", "inch"])'],
  seealso: ["unit", "createUnit"]
};
splitUnit.splitUnitDocs = splitUnitDocs;
var sparse = {};
Object.defineProperty(sparse, "__esModule", {
  value: !0
});
sparse.sparseDocs = void 0;
var sparseDocs = {
  name: "sparse",
  category: "Construction",
  syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'],
  description: "Create a sparse matrix.",
  examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"]
};
sparse.sparseDocs = sparseDocs;
var number = {};
Object.defineProperty(number, "__esModule", {
  value: !0
});
number.numberDocs = void 0;
var numberDocs = {
  name: "number",
  category: "Construction",
  syntax: ["x", "number(x)", "number(unit, valuelessUnit)"],
  description: "Create a number or convert a string or boolean into a number.",
  examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number(unit("52cm"), "m")'],
  seealso: ["bignumber", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
};
number.numberDocs = numberDocs;
var matrix$1 = {};
Object.defineProperty(matrix$1, "__esModule", {
  value: !0
});
matrix$1.matrixDocs = void 0;
var matrixDocs = {
  name: "matrix",
  category: "Construction",
  syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"],
  description: "Create a matrix.",
  examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"]
};
matrix$1.matrixDocs = matrixDocs;
var construction = {};
Object.defineProperty(construction, "__esModule", {
  value: !0
});
construction.indexDocs = void 0;
var indexDocs = {
  name: "index",
  category: "Construction",
  syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"],
  description: "Create an index to get or replace a subset of a matrix",
  examples: ["[]", "[1, 2, 3]", "A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[0:2, 0:2] = ones(2, 2)"],
  seealso: ["bignumber", "boolean", "complex", "matrix,", "number", "range", "string", "unit"]
};
construction.indexDocs = indexDocs;
var fraction = {};
Object.defineProperty(fraction, "__esModule", {
  value: !0
});
fraction.fractionDocs = void 0;
var fractionDocs = {
  name: "fraction",
  category: "Construction",
  syntax: ["fraction(num)", "fraction(num,den)"],
  description: "Create a fraction from a number or from a numerator and denominator.",
  examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"]
};
fraction.fractionDocs = fractionDocs;
var createUnit = {};
Object.defineProperty(createUnit, "__esModule", {
  value: !0
});
createUnit.createUnitDocs = void 0;
var createUnitDocs = {
  name: "createUnit",
  category: "Construction",
  syntax: ["createUnit(definitions)", "createUnit(name, definition)"],
  description: "Create a user-defined unit and register it with the Unit type.",
  examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'],
  seealso: ["unit", "splitUnit"]
};
createUnit.createUnitDocs = createUnitDocs;
var complex = {};
Object.defineProperty(complex, "__esModule", {
  value: !0
});
complex.complexDocs = void 0;
var complexDocs = {
  name: "complex",
  category: "Construction",
  syntax: ["complex()", "complex(re, im)", "complex(string)"],
  description: "Create a complex number.",
  examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'],
  seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"]
};
complex.complexDocs = complexDocs;
var boolean = {};
Object.defineProperty(boolean, "__esModule", {
  value: !0
});
boolean.booleanDocs = void 0;
var booleanDocs = {
  name: "boolean",
  category: "Construction",
  syntax: ["x", "boolean(x)"],
  description: "Convert a string or number into a boolean.",
  examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"],
  seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"]
};
boolean.booleanDocs = booleanDocs;
var dotPow = {};
Object.defineProperty(dotPow, "__esModule", {
  value: !0
});
dotPow.dotPowDocs = void 0;
var dotPowDocs = {
  name: "dotPow",
  category: "Operators",
  syntax: ["x .^ y", "dotPow(x, y)"],
  description: "Calculates the power of x to y element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"],
  seealso: ["pow"]
};
dotPow.dotPowDocs = dotPowDocs;
var lusolve = {};
Object.defineProperty(lusolve, "__esModule", {
  value: !0
});
lusolve.lusolveDocs = void 0;
var lusolveDocs = {
  name: "lusolve",
  category: "Algebra",
  syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"],
  description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"],
  seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"]
};
lusolve.lusolveDocs = lusolveDocs;
var subtract$2 = {};
Object.defineProperty(subtract$2, "__esModule", {
  value: !0
});
subtract$2.subtractDocs = void 0;
var subtractDocs = {
  name: "subtract",
  category: "Operators",
  syntax: ["x - y", "subtract(x, y)"],
  description: "subtract two values.",
  examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"],
  seealso: ["add"]
};
subtract$2.subtractDocs = subtractDocs;
var variance$1 = {};
Object.defineProperty(variance$1, "__esModule", {
  value: !0
});
variance$1.varianceDocs = void 0;
var varianceDocs = {
  name: "variance",
  category: "Statistics",
  syntax: ["variance(a, b, c, ...)", "variance(A)", "variance(A, normalization)"],
  description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["variance(2, 4, 6)", "variance([2, 4, 6, 8])", 'variance([2, 4, 6, 8], "uncorrected")', 'variance([2, 4, 6, 8], "biased")', "variance([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
};
variance$1.varianceDocs = varianceDocs;
var sin = {};
Object.defineProperty(sin, "__esModule", {
  value: !0
});
sin.sinDocs = void 0;
var sinDocs = {
  name: "sin",
  category: "Trigonometry",
  syntax: ["sin(x)"],
  description: "Compute the sine of x in radians.",
  examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["asin", "cos", "tan"]
};
sin.sinDocs = sinDocs;
var numeric = {};
Object.defineProperty(numeric, "__esModule", {
  value: !0
});
numeric.numericDocs = void 0;
var numericDocs = {
  name: "numeric",
  category: "Utils",
  syntax: ["numeric(x)"],
  description: "Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.",
  examples: ['numeric("4")', 'numeric("4", "number")', 'numeric("4", "BigNumber")', 'numeric("4", "Fraction)', 'numeric(4, "Fraction")', 'numeric(fraction(2, 5), "number)'],
  seealso: ["number", "fraction", "bignumber", "string", "format"]
};
numeric.numericDocs = numericDocs;
var column$1 = {};
Object.defineProperty(column$1, "__esModule", {
  value: !0
});
column$1.columnDocs = void 0;
var columnDocs = {
  name: "column",
  category: "Matrix",
  syntax: ["column(x, index)"],
  description: "Return a column from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "column(A, 1)", "column(A, 2)"],
  seealso: ["row"]
};
column$1.columnDocs = columnDocs;
var row = {};
Object.defineProperty(row, "__esModule", {
  value: !0
});
row.rowDocs = void 0;
var rowDocs = {
  name: "row",
  category: "Matrix",
  syntax: ["row(x, index)"],
  description: "Return a row from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "row(A, 1)", "row(A, 2)"],
  seealso: ["column"]
};
row.rowDocs = rowDocs;
var rotationMatrix = {};
Object.defineProperty(rotationMatrix, "__esModule", {
  value: !0
});
rotationMatrix.rotationMatrixDocs = void 0;
var rotationMatrixDocs = {
  name: "rotationMatrix",
  category: "Matrix",
  syntax: ["rotationMatrix(theta)", "rotationMatrix(theta, v)", "rotationMatrix(theta, v, format)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotationMatrix(pi / 2)", 'rotationMatrix(unit("45deg"), [0, 0, 1])', 'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'],
  seealso: ["cos", "sin"]
};
rotationMatrix.rotationMatrixDocs = rotationMatrixDocs;
var rotate = {};
Object.defineProperty(rotate, "__esModule", {
  value: !0
});
rotate.rotateDocs = void 0;
var rotateDocs = {
  name: "rotate",
  category: "Matrix",
  syntax: ["rotate(w, theta)", "rotate(w, theta, v)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotate([1, 0], math.pi / 2)", 'rotate(matrix([1, 0]), unit("35deg"))', 'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])', 'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'],
  seealso: ["matrix", "rotationMatrix"]
};
rotate.rotateDocs = rotateDocs;
Object.defineProperty(embeddedDocs$1, "__esModule", {
  value: !0
});
embeddedDocs$1.embeddedDocs = void 0;
var _bignumber = bignumber, _typeOf = typeOf, _isZero = isZero, _isPrime = isPrime, _isPositive = isPositive, _isNumeric = isNumeric, _hasNumericValue = hasNumericValue, _isNegative = isNegative, _isInteger = isInteger, _isNaN = _isNaN$1, _format = format$1, _bin = bin, _oct = oct, _hex = hex, _clone = clone$2, _to = to$1, _tanh = tanh, _tan = tan, _sinh = sinh, _sech = sech, _sec = sec, _csch = csch, _csc = csc, _coth = coth, _cot = cot, _cosh = cosh, _cos = cos, _atan = atan2, _atanh = atanh, _atan2 = atan, _asinh = asinh, _asin = asin, _asech = asech, _asec = asec, _acsch = acsch, _acsc = acsc, _acoth = acoth, _acot = acot, _acosh = acosh, _acos = acos, _sum$1 = sum$1, _std$1 = std$1, _quantileSeq = quantileSeq$1, _prod = prod, _mode = mode, _min$1 = min$2, _median = median$1, _mean$1 = mean$1, _max$1 = max$2, _mad = mad$1, _erf = erf, _setUnion = setUnion, _setSymDifference = setSymDifference, _setSize = setSize, _setPowerset = setPowerset, _setMultiplicity = setMultiplicity, _setIsSubset = setIsSubset, _setIntersect = setIntersect, _setDistinct = setDistinct, _setDifference = setDifference, _setCartesian = setCartesian, _unequal = unequal, _smallerEq = smallerEq, _smaller = smaller, _largerEq = largerEq, _larger = larger, _equalText = equalText, _equal = equal, _deepEqual = deepEqual, _compareText = compareText, _compareNatural = compareNatural, _compare = compare, _randomInt = randomInt$1, _random = random$1, _pickRandom = pickRandom$1, _permutations = permutations$1, _multinomial = multinomial$1, _kldivergence = kldivergence$1, _gamma = gamma$1, _factorial = factorial$1, _combinations$1 = combinations$1, _combinationsWithRep = combinationsWithRep$1, _zeros = zeros, _transpose = transpose, _trace = trace, _subset$1 = subset, _squeeze = squeeze, _sort = sort, _size = size, _diff$1 = diff$1, _reshape = reshape, _resize = resize, _range$1 = range, _partitionSelect = partitionSelect, _ones = ones, _map$1 = map$1, _kron = kron, _inv = inv$1, _forEach = forEach, _flatten = flatten$1, _filter$1 = filter, _identity = identity, _getMatrixDataType = getMatrixDataType, _dot = dot, _diag = diag, _det = det$1, _ctranspose = ctranspose, _cross = cross, _concat$1 = concat, _xor = xor, _or = or, _not = not, _and = and, _intersect = intersect$1, _distance = distance$1, _help = help, _evaluate = evaluate$1, _im = im, _re = re, _conj = conj, _arg = arg, _typed = typed, _import$2 = _import$3, _config$1 = config, _stirlingS = stirlingS2$1, _composition = composition$1, _catalan = catalan$1, _bellNumbers = bellNumbers$1, _rightLogShift = rightLogShift, _rightArithShift = rightArithShift, _leftShift = leftShift, _bitXor = bitXor, _bitOr = bitOr, _bitNot = bitNot, _bitAnd = bitAnd, _xgcd = xgcd, _unaryPlus = unaryPlus, _unaryMinus = unaryMinus, _square = square, _sqrtm = sqrtm$1, _sqrt = sqrt, _sign = sign$1, _round = round$2, _pow = pow, _nthRoots = nthRoots, _nthRoot = nthRoot, _norm = norm, _multiply = multiply, _mod = mod$2, _log = log10, _log1p = log1p, _log2 = log2, _log3 = log, _lcm = lcm, _hypot = hypot, _gcd = gcd, _floor = floor$1, _fix = fix, _expm = expm1, _expm2 = expm$1, _eigs = eigs$1, _exp = exp, _dotMultiply = dotMultiply, _dotDivide = dotDivide, _divide = divide$1, _cube = cube, _ceil = ceil, _cbrt = cbrt, _add = add$2, _abs = abs$2, _qr = qr, _usolve = usolve, _usolveAll = usolveAll, _slu = slu, _rationalize = rationalize$1, _simplify = simplify$1, _lup = lup, _lsolve = lsolve, _lsolveAll = lsolveAll, _derivative = derivative$1, _version$1 = version$3, _true = _true$1, _tau = tau, _SQRT = SQRT2, _SQRT1_ = SQRT1_2, _phi = phi, _pi = pi, _null = _null$1, _NaN = _NaN$1, _LOG10E = LOG10E, _LOG2E = LOG2E, _LN = LN10, _LN2 = LN2, _Infinity = _Infinity$1, _i = i$2, _false = _false$1, _e = e, _unit = unit, _string$5 = string, _splitUnit = splitUnit, _sparse = sparse, _number$4 = number, _matrix = matrix$1, _index$2 = construction, _fraction = fraction, _createUnit = createUnit, _complex = complex, _boolean = boolean, _dotPow = dotPow, _lusolve = lusolve, _subtract = subtract$2, _variance$1 = variance$1, _sin = sin, _numeric = numeric, _column$1 = column$1, _row$1 = row, _rotationMatrix = rotationMatrix, _rotate = rotate, embeddedDocs = {
  // construction functions
  bignumber: _bignumber.bignumberDocs,
  boolean: _boolean.booleanDocs,
  complex: _complex.complexDocs,
  createUnit: _createUnit.createUnitDocs,
  fraction: _fraction.fractionDocs,
  index: _index$2.indexDocs,
  matrix: _matrix.matrixDocs,
  number: _number$4.numberDocs,
  sparse: _sparse.sparseDocs,
  splitUnit: _splitUnit.splitUnitDocs,
  string: _string$5.stringDocs,
  unit: _unit.unitDocs,
  // constants
  e: _e.eDocs,
  E: _e.eDocs,
  false: _false.falseDocs,
  i: _i.iDocs,
  Infinity: _Infinity.InfinityDocs,
  LN2: _LN2.LN2Docs,
  LN10: _LN.LN10Docs,
  LOG2E: _LOG2E.LOG2EDocs,
  LOG10E: _LOG10E.LOG10EDocs,
  NaN: _NaN.NaNDocs,
  null: _null.nullDocs,
  pi: _pi.piDocs,
  PI: _pi.piDocs,
  phi: _phi.phiDocs,
  SQRT1_2: _SQRT1_.SQRT12Docs,
  SQRT2: _SQRT.SQRT2Docs,
  tau: _tau.tauDocs,
  true: _true.trueDocs,
  version: _version$1.versionDocs,
  // physical constants
  // TODO: more detailed docs for physical constants
  speedOfLight: {
    description: "Speed of light in vacuum",
    examples: ["speedOfLight"]
  },
  gravitationConstant: {
    description: "Newtonian constant of gravitation",
    examples: ["gravitationConstant"]
  },
  planckConstant: {
    description: "Planck constant",
    examples: ["planckConstant"]
  },
  reducedPlanckConstant: {
    description: "Reduced Planck constant",
    examples: ["reducedPlanckConstant"]
  },
  magneticConstant: {
    description: "Magnetic constant (vacuum permeability)",
    examples: ["magneticConstant"]
  },
  electricConstant: {
    description: "Electric constant (vacuum permeability)",
    examples: ["electricConstant"]
  },
  vacuumImpedance: {
    description: "Characteristic impedance of vacuum",
    examples: ["vacuumImpedance"]
  },
  coulomb: {
    description: "Coulomb's constant",
    examples: ["coulomb"]
  },
  elementaryCharge: {
    description: "Elementary charge",
    examples: ["elementaryCharge"]
  },
  bohrMagneton: {
    description: "Borh magneton",
    examples: ["bohrMagneton"]
  },
  conductanceQuantum: {
    description: "Conductance quantum",
    examples: ["conductanceQuantum"]
  },
  inverseConductanceQuantum: {
    description: "Inverse conductance quantum",
    examples: ["inverseConductanceQuantum"]
  },
  // josephson: {description: 'Josephson constant', examples: ['josephson']},
  magneticFluxQuantum: {
    description: "Magnetic flux quantum",
    examples: ["magneticFluxQuantum"]
  },
  nuclearMagneton: {
    description: "Nuclear magneton",
    examples: ["nuclearMagneton"]
  },
  klitzing: {
    description: "Von Klitzing constant",
    examples: ["klitzing"]
  },
  bohrRadius: {
    description: "Borh radius",
    examples: ["bohrRadius"]
  },
  classicalElectronRadius: {
    description: "Classical electron radius",
    examples: ["classicalElectronRadius"]
  },
  electronMass: {
    description: "Electron mass",
    examples: ["electronMass"]
  },
  fermiCoupling: {
    description: "Fermi coupling constant",
    examples: ["fermiCoupling"]
  },
  fineStructure: {
    description: "Fine-structure constant",
    examples: ["fineStructure"]
  },
  hartreeEnergy: {
    description: "Hartree energy",
    examples: ["hartreeEnergy"]
  },
  protonMass: {
    description: "Proton mass",
    examples: ["protonMass"]
  },
  deuteronMass: {
    description: "Deuteron Mass",
    examples: ["deuteronMass"]
  },
  neutronMass: {
    description: "Neutron mass",
    examples: ["neutronMass"]
  },
  quantumOfCirculation: {
    description: "Quantum of circulation",
    examples: ["quantumOfCirculation"]
  },
  rydberg: {
    description: "Rydberg constant",
    examples: ["rydberg"]
  },
  thomsonCrossSection: {
    description: "Thomson cross section",
    examples: ["thomsonCrossSection"]
  },
  weakMixingAngle: {
    description: "Weak mixing angle",
    examples: ["weakMixingAngle"]
  },
  efimovFactor: {
    description: "Efimov factor",
    examples: ["efimovFactor"]
  },
  atomicMass: {
    description: "Atomic mass constant",
    examples: ["atomicMass"]
  },
  avogadro: {
    description: "Avogadro's number",
    examples: ["avogadro"]
  },
  boltzmann: {
    description: "Boltzmann constant",
    examples: ["boltzmann"]
  },
  faraday: {
    description: "Faraday constant",
    examples: ["faraday"]
  },
  firstRadiation: {
    description: "First radiation constant",
    examples: ["firstRadiation"]
  },
  loschmidt: {
    description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
    examples: ["loschmidt"]
  },
  gasConstant: {
    description: "Gas constant",
    examples: ["gasConstant"]
  },
  molarPlanckConstant: {
    description: "Molar Planck constant",
    examples: ["molarPlanckConstant"]
  },
  molarVolume: {
    description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
    examples: ["molarVolume"]
  },
  sackurTetrode: {
    description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
    examples: ["sackurTetrode"]
  },
  secondRadiation: {
    description: "Second radiation constant",
    examples: ["secondRadiation"]
  },
  stefanBoltzmann: {
    description: "Stefan-Boltzmann constant",
    examples: ["stefanBoltzmann"]
  },
  wienDisplacement: {
    description: "Wien displacement law constant",
    examples: ["wienDisplacement"]
  },
  // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
  molarMass: {
    description: "Molar mass constant",
    examples: ["molarMass"]
  },
  molarMassC12: {
    description: "Molar mass constant of carbon-12",
    examples: ["molarMassC12"]
  },
  gravity: {
    description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
    examples: ["gravity"]
  },
  planckLength: {
    description: "Planck length",
    examples: ["planckLength"]
  },
  planckMass: {
    description: "Planck mass",
    examples: ["planckMass"]
  },
  planckTime: {
    description: "Planck time",
    examples: ["planckTime"]
  },
  planckCharge: {
    description: "Planck charge",
    examples: ["planckCharge"]
  },
  planckTemperature: {
    description: "Planck temperature",
    examples: ["planckTemperature"]
  },
  // functions - algebra
  derivative: _derivative.derivativeDocs,
  lsolve: _lsolve.lsolveDocs,
  lsolveAll: _lsolveAll.lsolveAllDocs,
  lup: _lup.lupDocs,
  lusolve: _lusolve.lusolveDocs,
  simplify: _simplify.simplifyDocs,
  rationalize: _rationalize.rationalizeDocs,
  slu: _slu.sluDocs,
  usolve: _usolve.usolveDocs,
  usolveAll: _usolveAll.usolveAllDocs,
  qr: _qr.qrDocs,
  // functions - arithmetic
  abs: _abs.absDocs,
  add: _add.addDocs,
  cbrt: _cbrt.cbrtDocs,
  ceil: _ceil.ceilDocs,
  cube: _cube.cubeDocs,
  divide: _divide.divideDocs,
  dotDivide: _dotDivide.dotDivideDocs,
  dotMultiply: _dotMultiply.dotMultiplyDocs,
  dotPow: _dotPow.dotPowDocs,
  exp: _exp.expDocs,
  expm: _expm2.expmDocs,
  expm1: _expm.expm1Docs,
  fix: _fix.fixDocs,
  floor: _floor.floorDocs,
  gcd: _gcd.gcdDocs,
  hypot: _hypot.hypotDocs,
  lcm: _lcm.lcmDocs,
  log: _log3.logDocs,
  log2: _log2.log2Docs,
  log1p: _log1p.log1pDocs,
  log10: _log.log10Docs,
  mod: _mod.modDocs,
  multiply: _multiply.multiplyDocs,
  norm: _norm.normDocs,
  nthRoot: _nthRoot.nthRootDocs,
  nthRoots: _nthRoots.nthRootsDocs,
  pow: _pow.powDocs,
  round: _round.roundDocs,
  sign: _sign.signDocs,
  sqrt: _sqrt.sqrtDocs,
  sqrtm: _sqrtm.sqrtmDocs,
  square: _square.squareDocs,
  subtract: _subtract.subtractDocs,
  unaryMinus: _unaryMinus.unaryMinusDocs,
  unaryPlus: _unaryPlus.unaryPlusDocs,
  xgcd: _xgcd.xgcdDocs,
  // functions - bitwise
  bitAnd: _bitAnd.bitAndDocs,
  bitNot: _bitNot.bitNotDocs,
  bitOr: _bitOr.bitOrDocs,
  bitXor: _bitXor.bitXorDocs,
  leftShift: _leftShift.leftShiftDocs,
  rightArithShift: _rightArithShift.rightArithShiftDocs,
  rightLogShift: _rightLogShift.rightLogShiftDocs,
  // functions - combinatorics
  bellNumbers: _bellNumbers.bellNumbersDocs,
  catalan: _catalan.catalanDocs,
  composition: _composition.compositionDocs,
  stirlingS2: _stirlingS.stirlingS2Docs,
  // functions - core
  config: _config$1.configDocs,
  import: _import$2.importDocs,
  typed: _typed.typedDocs,
  // functions - complex
  arg: _arg.argDocs,
  conj: _conj.conjDocs,
  re: _re.reDocs,
  im: _im.imDocs,
  // functions - expression
  evaluate: _evaluate.evaluateDocs,
  help: _help.helpDocs,
  // functions - geometry
  distance: _distance.distanceDocs,
  intersect: _intersect.intersectDocs,
  // functions - logical
  and: _and.andDocs,
  not: _not.notDocs,
  or: _or.orDocs,
  xor: _xor.xorDocs,
  // functions - matrix
  concat: _concat$1.concatDocs,
  cross: _cross.crossDocs,
  column: _column$1.columnDocs,
  ctranspose: _ctranspose.ctransposeDocs,
  det: _det.detDocs,
  diag: _diag.diagDocs,
  diff: _diff$1.diffDocs,
  dot: _dot.dotDocs,
  getMatrixDataType: _getMatrixDataType.getMatrixDataTypeDocs,
  identity: _identity.identityDocs,
  filter: _filter$1.filterDocs,
  flatten: _flatten.flattenDocs,
  forEach: _forEach.forEachDocs,
  inv: _inv.invDocs,
  eigs: _eigs.eigsDocs,
  kron: _kron.kronDocs,
  map: _map$1.mapDocs,
  ones: _ones.onesDocs,
  partitionSelect: _partitionSelect.partitionSelectDocs,
  range: _range$1.rangeDocs,
  resize: _resize.resizeDocs,
  reshape: _reshape.reshapeDocs,
  rotate: _rotate.rotateDocs,
  rotationMatrix: _rotationMatrix.rotationMatrixDocs,
  row: _row$1.rowDocs,
  size: _size.sizeDocs,
  sort: _sort.sortDocs,
  squeeze: _squeeze.squeezeDocs,
  subset: _subset$1.subsetDocs,
  trace: _trace.traceDocs,
  transpose: _transpose.transposeDocs,
  zeros: _zeros.zerosDocs,
  // functions - probability
  combinations: _combinations$1.combinationsDocs,
  combinationsWithRep: _combinationsWithRep.combinationsWithRepDocs,
  // distribution: distributionDocs,
  factorial: _factorial.factorialDocs,
  gamma: _gamma.gammaDocs,
  kldivergence: _kldivergence.kldivergenceDocs,
  multinomial: _multinomial.multinomialDocs,
  permutations: _permutations.permutationsDocs,
  pickRandom: _pickRandom.pickRandomDocs,
  random: _random.randomDocs,
  randomInt: _randomInt.randomIntDocs,
  // functions - relational
  compare: _compare.compareDocs,
  compareNatural: _compareNatural.compareNaturalDocs,
  compareText: _compareText.compareTextDocs,
  deepEqual: _deepEqual.deepEqualDocs,
  equal: _equal.equalDocs,
  equalText: _equalText.equalTextDocs,
  larger: _larger.largerDocs,
  largerEq: _largerEq.largerEqDocs,
  smaller: _smaller.smallerDocs,
  smallerEq: _smallerEq.smallerEqDocs,
  unequal: _unequal.unequalDocs,
  // functions - set
  setCartesian: _setCartesian.setCartesianDocs,
  setDifference: _setDifference.setDifferenceDocs,
  setDistinct: _setDistinct.setDistinctDocs,
  setIntersect: _setIntersect.setIntersectDocs,
  setIsSubset: _setIsSubset.setIsSubsetDocs,
  setMultiplicity: _setMultiplicity.setMultiplicityDocs,
  setPowerset: _setPowerset.setPowersetDocs,
  setSize: _setSize.setSizeDocs,
  setSymDifference: _setSymDifference.setSymDifferenceDocs,
  setUnion: _setUnion.setUnionDocs,
  // functions - special
  erf: _erf.erfDocs,
  // functions - statistics
  mad: _mad.madDocs,
  max: _max$1.maxDocs,
  mean: _mean$1.meanDocs,
  median: _median.medianDocs,
  min: _min$1.minDocs,
  mode: _mode.modeDocs,
  prod: _prod.prodDocs,
  quantileSeq: _quantileSeq.quantileSeqDocs,
  std: _std$1.stdDocs,
  sum: _sum$1.sumDocs,
  variance: _variance$1.varianceDocs,
  // functions - trigonometry
  acos: _acos.acosDocs,
  acosh: _acosh.acoshDocs,
  acot: _acot.acotDocs,
  acoth: _acoth.acothDocs,
  acsc: _acsc.acscDocs,
  acsch: _acsch.acschDocs,
  asec: _asec.asecDocs,
  asech: _asech.asechDocs,
  asin: _asin.asinDocs,
  asinh: _asinh.asinhDocs,
  atan: _atan2.atanDocs,
  atanh: _atanh.atanhDocs,
  atan2: _atan.atan2Docs,
  cos: _cos.cosDocs,
  cosh: _cosh.coshDocs,
  cot: _cot.cotDocs,
  coth: _coth.cothDocs,
  csc: _csc.cscDocs,
  csch: _csch.cschDocs,
  sec: _sec.secDocs,
  sech: _sech.sechDocs,
  sin: _sin.sinDocs,
  sinh: _sinh.sinhDocs,
  tan: _tan.tanDocs,
  tanh: _tanh.tanhDocs,
  // functions - units
  to: _to.toDocs,
  // functions - utils
  clone: _clone.cloneDocs,
  format: _format.formatDocs,
  bin: _bin.binDocs,
  oct: _oct.octDocs,
  hex: _hex.hexDocs,
  isNaN: _isNaN.isNaNDocs,
  isInteger: _isInteger.isIntegerDocs,
  isNegative: _isNegative.isNegativeDocs,
  isNumeric: _isNumeric.isNumericDocs,
  hasNumericValue: _hasNumericValue.hasNumericValueDocs,
  isPositive: _isPositive.isPositiveDocs,
  isPrime: _isPrime.isPrimeDocs,
  isZero: _isZero.isZeroDocs,
  // print: printDocs // TODO: add documentation for print as soon as the parser supports objects.
  typeOf: _typeOf.typeOfDocs,
  numeric: _numeric.numericDocs
};
embeddedDocs$1.embeddedDocs = embeddedDocs;
Object.defineProperty(help$1, "__esModule", {
  value: !0
});
help$1.createHelp = void 0;
var _factory$Y = factory$1, _customs = customs, _embeddedDocs = embeddedDocs$1, _object$7 = object, name$V = "help", dependencies$U = ["typed", "mathWithTransform", "Help"], createHelp = /* @__PURE__ */ (0, _factory$Y.factory)(name$V, dependencies$U, function(t) {
  var r = t.typed, n = t.mathWithTransform, a = t.Help;
  return r(name$V, {
    any: function(o) {
      var c, l = o;
      if (typeof o != "string") {
        for (c in n)
          if ((0, _object$7.hasOwnProperty)(n, c) && o === n[c]) {
            l = c;
            break;
          }
      }
      var d = (0, _customs.getSafeProperty)(_embeddedDocs.embeddedDocs, l);
      if (!d) {
        var h = typeof l == "function" ? l.name : l;
        throw new Error('No documentation found on "' + h + '"');
      }
      return new a(d);
    }
  });
});
help$1.createHelp = createHelp;
var chain = {};
Object.defineProperty(chain, "__esModule", {
  value: !0
});
chain.createChain = void 0;
var _factory$X = factory$1, name$U = "chain", dependencies$T = ["typed", "Chain"], createChain = /* @__PURE__ */ (0, _factory$X.factory)(name$U, dependencies$T, function(t) {
  var r = t.typed, n = t.Chain;
  return r(name$U, {
    "": function() {
      return new n();
    },
    any: function(s) {
      return new n(s);
    }
  });
});
chain.createChain = createChain;
var det = {};
Object.defineProperty(det, "__esModule", {
  value: !0
});
det.createDet = void 0;
var _is$y = is, _object$6 = object, _string$4 = string$2, _factory$W = factory$1, name$T = "det", dependencies$S = ["typed", "matrix", "subtract", "multiply", "unaryMinus", "lup"], createDet = /* @__PURE__ */ (0, _factory$W.factory)(name$T, dependencies$S, function(t) {
  var r = t.typed, n = t.matrix, a = t.subtract, s = t.multiply, o = t.unaryMinus, c = t.lup;
  return r(name$T, {
    any: function(h) {
      return (0, _object$6.clone)(h);
    },
    "Array | Matrix": function(h) {
      var u;
      switch ((0, _is$y.isMatrix)(h) ? u = h.size() : Array.isArray(h) ? (h = n(h), u = h.size()) : u = [], u.length) {
        case 0:
          return (0, _object$6.clone)(h);
        case 1:
          if (u[0] === 1)
            return (0, _object$6.clone)(h.valueOf()[0]);
          throw new RangeError("Matrix must be square (size: " + (0, _string$4.format)(u) + ")");
        case 2: {
          var p = u[0], m = u[1];
          if (p === m)
            return l(h.clone().valueOf(), p);
          throw new RangeError("Matrix must be square (size: " + (0, _string$4.format)(u) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + (0, _string$4.format)(u) + ")");
      }
    }
  });
  function l(d, h, u) {
    if (h === 1)
      return (0, _object$6.clone)(d[0][0]);
    if (h === 2)
      return a(s(d[0][0], d[1][1]), s(d[1][0], d[0][1]));
    for (var p = c(d), m = p.U[0][0], g = 1; g < h; g++)
      m = s(m, p.U[g][g]);
    for (var v = 0, y = 0, x = []; ; ) {
      for (; x[y]; )
        y++;
      if (y >= h)
        break;
      for (var _ = y, $ = 0; !x[p.p[_]]; )
        x[p.p[_]] = !0, _ = p.p[_], $++;
      $ % 2 === 0 && v++;
    }
    return v % 2 === 0 ? m : o(m);
  }
});
det.createDet = createDet;
var inv = {};
Object.defineProperty(inv, "__esModule", {
  value: !0
});
inv.createInv = void 0;
var _is$x = is, _array$a = array, _factory$V = factory$1, _string$3 = string$2, name$S = "inv", dependencies$R = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], createInv = /* @__PURE__ */ (0, _factory$V.factory)(name$S, dependencies$R, function(t) {
  var r = t.typed, n = t.matrix, a = t.divideScalar, s = t.addScalar, o = t.multiply, c = t.unaryMinus, l = t.det, d = t.identity, h = t.abs;
  return r(name$S, {
    "Array | Matrix": function(m) {
      var g = (0, _is$x.isMatrix)(m) ? m.size() : (0, _array$a.arraySize)(m);
      switch (g.length) {
        case 1:
          if (g[0] === 1)
            return (0, _is$x.isMatrix)(m) ? n([a(1, m.valueOf()[0])]) : [a(1, m[0])];
          throw new RangeError("Matrix must be square (size: " + (0, _string$3.format)(g) + ")");
        case 2: {
          var v = g[0], y = g[1];
          if (v === y)
            return (0, _is$x.isMatrix)(m) ? n(u(m.valueOf(), v, y), m.storage()) : u(m, v, y);
          throw new RangeError("Matrix must be square (size: " + (0, _string$3.format)(g) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + (0, _string$3.format)(g) + ")");
      }
    },
    any: function(m) {
      return a(1, m);
    }
  });
  function u(p, m, g) {
    var v, y, x, _, $;
    if (m === 1) {
      if (_ = p[0][0], _ === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[a(1, _)]];
    } else if (m === 2) {
      var b = l(p);
      if (b === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[a(p[1][1], b), a(c(p[0][1]), b)], [a(c(p[1][0]), b), a(p[0][0], b)]];
    } else {
      var M = p.concat();
      for (v = 0; v < m; v++)
        M[v] = M[v].concat();
      for (var C = d(m).valueOf(), S = 0; S < g; S++) {
        var A = h(M[S][S]), D = S;
        for (v = S + 1; v < m; )
          h(M[v][S]) > A && (A = h(M[v][S]), D = v), v++;
        if (A === 0)
          throw Error("Cannot calculate inverse, determinant is zero");
        v = D, v !== S && ($ = M[S], M[S] = M[v], M[v] = $, $ = C[S], C[S] = C[v], C[v] = $);
        var N = M[S], T = C[S];
        for (v = 0; v < m; v++) {
          var R = M[v], F = C[v];
          if (v !== S) {
            if (R[S] !== 0) {
              for (x = a(c(R[S]), N[S]), y = S; y < g; y++)
                R[y] = s(R[y], o(x, N[y]));
              for (y = 0; y < g; y++)
                F[y] = s(F[y], o(x, T[y]));
            }
          } else {
            for (x = N[S], y = S; y < g; y++)
              R[y] = a(R[y], x);
            for (y = 0; y < g; y++)
              F[y] = a(F[y], x);
          }
        }
      }
      return C;
    }
  }
});
inv.createInv = createInv;
var eigs = {};
Object.defineProperty(eigs, "__esModule", {
  value: !0
});
eigs.createEigs = void 0;
var _object$5 = object, _factory$U = factory$1, _string$2 = string$2, name$R = "eigs", dependencies$Q = ["config", "typed", "matrix", "addScalar", "equal", "subtract", "abs", "atan", "cos", "sin", "multiplyScalar", "inv", "bignumber", "multiply", "add"], createEigs = /* @__PURE__ */ (0, _factory$U.factory)(name$R, dependencies$Q, function(t) {
  var r = t.config, n = t.typed, a = t.matrix, s = t.addScalar, o = t.subtract, c = t.equal, l = t.abs, d = t.atan, h = t.cos, u = t.sin, p = t.multiplyScalar, m = t.inv, g = t.bignumber, v = t.multiply, y = t.add;
  return n("eigs", {
    Array: function(G) {
      var I = a(G), k = I.size();
      if (k.length !== 2 || k[0] !== k[1])
        throw new RangeError("Matrix must be square (size: " + (0, _string$2.format)(k) + ")");
      var B = _(I, k[0]);
      return {
        values: B[0],
        vectors: B[1]
      };
    },
    Matrix: function(G) {
      var I = G.size();
      if (I.length !== 2 || I[0] !== I[1])
        throw new RangeError("Matrix must be square (size: " + (0, _string$2.format)(I) + ")");
      var k = _(G, I[0]);
      return {
        values: a(k[0]),
        vectors: a(k[1])
      };
    }
  });
  function x(O, G) {
    for (var I = 0; I < G; I++)
      for (var k = I; k < G; k++)
        if (!c(O[I][k], O[k][I]))
          throw new TypeError("Input matrix is not symmetric");
  }
  function _(O, G) {
    var I = O.datatype();
    if (I === void 0 && (I = O.getDataType()), I !== "number" && I !== "BigNumber" && I !== "Fraction")
      throw I === "mixed" ? new TypeError("Mixed matrix element type is not supported") : new TypeError("Matrix element type not supported (" + I + ")");
    if (x(O.toArray(), G), I === "number")
      return $(O.toArray());
    if (I === "Fraction") {
      for (var k = O.toArray(), B = 0; B < G; B++)
        for (var L = B; L < G; L++)
          k[B][L] = k[B][L].valueOf(), k[L][B] = k[B][L];
      return $(O.toArray());
    } else if (I === "BigNumber")
      return b(O.toArray());
  }
  function $(O) {
    for (var G = O.length, I = Math.abs(r.epsilon / G), k, B = new Array(G), L = 0; L < G; L++)
      B[L] = z(G, 0), B[L][L] = 1;
    for (var V = T(O); Math.abs(V[1]) >= Math.abs(I); ) {
      var U = V[0][0], J = V[0][1];
      k = M(O[U][U], O[J][J], O[U][J]), O = N(O, k, U, J), B = S(B, k, U, J), V = T(O);
    }
    for (var q = z(G, 0), Z = 0; Z < G; Z++)
      q[Z] = O[Z][Z];
    return F((0, _object$5.clone)(q), (0, _object$5.clone)(B));
  }
  function b(O) {
    for (var G = O.length, I = l(r.epsilon / G), k, B = new Array(G), L = 0; L < G; L++)
      B[L] = z(G, 0), B[L][L] = 1;
    for (var V = R(O); l(V[1]) >= l(I); ) {
      var U = V[0][0], J = V[0][1];
      k = C(O[U][U], O[J][J], O[U][J]), O = D(O, k, U, J), B = A(B, k, U, J), V = R(O);
    }
    for (var q = z(G, 0), Z = 0; Z < G; Z++)
      q[Z] = O[Z][Z];
    return F((0, _object$5.clone)(q), (0, _object$5.clone)(B));
  }
  function M(O, G, I) {
    var k = G - O;
    return Math.abs(k) <= r.epsilon ? Math.PI / 4 : 0.5 * Math.atan(2 * I / (G - O));
  }
  function C(O, G, I) {
    var k = o(G, O);
    return l(k) <= r.epsilon ? g(-1).acos().div(4) : p(0.5, d(v(2, I, m(k))));
  }
  function S(O, G, I, k) {
    for (var B = O.length, L = Math.cos(G), V = Math.sin(G), U = z(B, 0), J = z(B, 0), q = 0; q < B; q++)
      U[q] = L * O[q][I] - V * O[q][k], J[q] = V * O[q][I] + L * O[q][k];
    for (var Z = 0; Z < B; Z++)
      O[Z][I] = U[Z], O[Z][k] = J[Z];
    return O;
  }
  function A(O, G, I, k) {
    for (var B = O.length, L = h(G), V = u(G), U = z(B, g(0)), J = z(B, g(0)), q = 0; q < B; q++)
      U[q] = o(p(L, O[q][I]), p(V, O[q][k])), J[q] = s(p(V, O[q][I]), p(L, O[q][k]));
    for (var Z = 0; Z < B; Z++)
      O[Z][I] = U[Z], O[Z][k] = J[Z];
    return O;
  }
  function D(O, G, I, k) {
    for (var B = O.length, L = g(h(G)), V = g(u(G)), U = p(L, L), J = p(V, V), q = z(B, g(0)), Z = z(B, g(0)), ae = v(g(2), L, V, O[I][k]), ee = s(o(p(U, O[I][I]), ae), p(J, O[k][k])), se = y(p(J, O[I][I]), ae, p(U, O[k][k])), nr = 0; nr < B; nr++)
      q[nr] = o(p(L, O[I][nr]), p(V, O[k][nr])), Z[nr] = s(p(V, O[I][nr]), p(L, O[k][nr]));
    O[I][I] = ee, O[k][k] = se, O[I][k] = g(0), O[k][I] = g(0);
    for (var ce = 0; ce < B; ce++)
      ce !== I && ce !== k && (O[I][ce] = q[ce], O[ce][I] = q[ce], O[k][ce] = Z[ce], O[ce][k] = Z[ce]);
    return O;
  }
  function N(O, G, I, k) {
    for (var B = O.length, L = Math.cos(G), V = Math.sin(G), U = L * L, J = V * V, q = z(B, 0), Z = z(B, 0), ae = U * O[I][I] - 2 * L * V * O[I][k] + J * O[k][k], ee = J * O[I][I] + 2 * L * V * O[I][k] + U * O[k][k], se = 0; se < B; se++)
      q[se] = L * O[I][se] - V * O[k][se], Z[se] = V * O[I][se] + L * O[k][se];
    O[I][I] = ae, O[k][k] = ee, O[I][k] = 0, O[k][I] = 0;
    for (var nr = 0; nr < B; nr++)
      nr !== I && nr !== k && (O[I][nr] = q[nr], O[nr][I] = q[nr], O[k][nr] = Z[nr], O[nr][k] = Z[nr]);
    return O;
  }
  function T(O) {
    for (var G = O.length, I = 0, k = [0, 1], B = 0; B < G; B++)
      for (var L = B + 1; L < G; L++)
        Math.abs(I) < Math.abs(O[B][L]) && (I = Math.abs(O[B][L]), k = [B, L]);
    return [k, I];
  }
  function R(O) {
    for (var G = O.length, I = 0, k = [0, 1], B = 0; B < G; B++)
      for (var L = B + 1; L < G; L++)
        l(I) < l(O[B][L]) && (I = l(O[B][L]), k = [B, L]);
    return [k, I];
  }
  function F(O, G) {
    for (var I = O.length, k = Array(I), B = Array(I), L = 0; L < I; L++)
      B[L] = Array(I);
    for (var V = 0; V < I; V++) {
      for (var U = 0, J = O[0], q = 0; q < O.length; q++)
        O[q] < J && (U = q, J = O[U]);
      k[V] = O.splice(U, 1)[0];
      for (var Z = 0; Z < I; Z++)
        B[Z][V] = G[Z][U], G[Z].splice(U, 1);
    }
    return [(0, _object$5.clone)(k), (0, _object$5.clone)(B)];
  }
  function z(O, G) {
    for (var I = new Array(O), k = 0; k < O; k++)
      I[k] = G;
    return I;
  }
});
eigs.createEigs = createEigs;
var expm = {};
Object.defineProperty(expm, "__esModule", {
  value: !0
});
expm.createExpm = void 0;
var _is$w = is, _string$1 = string$2, _factory$T = factory$1, name$Q = "expm", dependencies$P = ["typed", "abs", "add", "identity", "inv", "multiply"], createExpm = /* @__PURE__ */ (0, _factory$T.factory)(name$Q, dependencies$P, function(t) {
  var r = t.typed, n = t.abs, a = t.add, s = t.identity, o = t.inv, c = t.multiply;
  return r(name$Q, {
    Matrix: function(p) {
      var m = p.size();
      if (m.length !== 2 || m[0] !== m[1])
        throw new RangeError("Matrix must be square (size: " + (0, _string$1.format)(m) + ")");
      for (var g = m[0], v = 1e-15, y = l(p), x = d(y, v), _ = x.q, $ = x.j, b = c(p, Math.pow(2, -$)), M = s(g), C = s(g), S = 1, A = b, D = -1, N = 1; N <= _; N++)
        N > 1 && (A = c(A, b), D = -D), S = S * (_ - N + 1) / ((2 * _ - N + 1) * N), M = a(M, c(S, A)), C = a(C, c(S * D, A));
      for (var T = c(o(C), M), R = 0; R < $; R++)
        T = c(T, T);
      return (0, _is$w.isSparseMatrix)(p) ? p.createSparseMatrix(T) : T;
    }
  });
  function l(u) {
    for (var p = u.size()[0], m = 0, g = 0; g < p; g++) {
      for (var v = 0, y = 0; y < p; y++)
        v += n(u.get([g, y]));
      m = Math.max(v, m);
    }
    return m;
  }
  function d(u, p) {
    for (var m = 30, g = 0; g < m; g++)
      for (var v = 0; v <= g; v++) {
        var y = g - v;
        if (h(u, v, y) < p)
          return {
            q: v,
            j: y
          };
      }
    throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
  }
  function h(u, p, m) {
    for (var g = 1, v = 2; v <= p; v++)
      g *= v;
    for (var y = g, x = p + 1; x <= 2 * p; x++)
      y *= x;
    var _ = y * (2 * p + 1);
    return 8 * Math.pow(u / Math.pow(2, m), 2 * p) * g * g / (y * _);
  }
});
expm.createExpm = createExpm;
var sqrtm = {};
Object.defineProperty(sqrtm, "__esModule", {
  value: !0
});
sqrtm.createSqrtm = void 0;
var _is$v = is, _string = string$2, _array$9 = array, _factory$S = factory$1, name$P = "sqrtm", dependencies$O = ["typed", "abs", "add", "multiply", "sqrt", "subtract", "inv", "size", "max", "identity"], createSqrtm = /* @__PURE__ */ (0, _factory$S.factory)(name$P, dependencies$O, function(t) {
  var r = t.typed, n = t.abs, a = t.add, s = t.multiply, o = t.sqrt, c = t.subtract, l = t.inv, d = t.size, h = t.max, u = t.identity, p = 1e3, m = 1e-6;
  function g(v) {
    var y, x = 0, _ = v, $ = u(d(v));
    do {
      var b = _;
      if (_ = s(0.5, a(b, l($))), $ = s(0.5, a($, l(b))), y = h(n(c(_, b))), y > m && ++x > p)
        throw new Error("computing square root of matrix: iterative method could not converge");
    } while (y > m);
    return _;
  }
  return r(name$P, {
    "Array | Matrix": function(y) {
      var x = (0, _is$v.isMatrix)(y) ? y.size() : (0, _array$9.arraySize)(y);
      switch (x.length) {
        case 1:
          if (x[0] === 1)
            return o(y);
          throw new RangeError("Matrix must be square (size: " + (0, _string.format)(x) + ")");
        case 2: {
          var _ = x[0], $ = x[1];
          if (_ === $)
            return g(y);
          throw new RangeError("Matrix must be square (size: " + (0, _string.format)(x) + ")");
        }
        default:
          throw new RangeError("Matrix must be at most two dimensional (size: " + (0, _string.format)(x) + ")");
      }
    }
  });
});
sqrtm.createSqrtm = createSqrtm;
var divide = {};
Object.defineProperty(divide, "__esModule", {
  value: !0
});
divide.createDivide = void 0;
var _factory$R = factory$1, _object$4 = object, _algorithm = algorithm11, _algorithm2 = algorithm14, name$O = "divide", dependencies$N = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], createDivide = /* @__PURE__ */ (0, _factory$R.factory)(name$O, dependencies$N, function(t) {
  var r = t.typed, n = t.matrix, a = t.multiply, s = t.equalScalar, o = t.divideScalar, c = t.inv, l = (0, _algorithm.createAlgorithm11)({
    typed: r,
    equalScalar: s
  }), d = (0, _algorithm2.createAlgorithm14)({
    typed: r
  });
  return r("divide", (0, _object$4.extend)({
    // we extend the signatures of divideScalar with signatures dealing with matrices
    "Array | Matrix, Array | Matrix": function(u, p) {
      return a(u, c(p));
    },
    "DenseMatrix, any": function(u, p) {
      return d(u, p, o, !1);
    },
    "SparseMatrix, any": function(u, p) {
      return l(u, p, o, !1);
    },
    "Array, any": function(u, p) {
      return d(n(u), p, o, !1).valueOf();
    },
    "any, Array | Matrix": function(u, p) {
      return a(u, c(p));
    }
  }, o.signatures));
});
divide.createDivide = createDivide;
var distance = {};
Object.defineProperty(distance, "__esModule", {
  value: !0
});
distance.createDistance = void 0;
var _is$u = is, _factory$Q = factory$1, name$N = "distance", dependencies$M = ["typed", "addScalar", "subtract", "divideScalar", "multiplyScalar", "unaryMinus", "sqrt", "abs"], createDistance = /* @__PURE__ */ (0, _factory$Q.factory)(name$N, dependencies$M, function(t) {
  var r = t.typed, n = t.addScalar, a = t.subtract, s = t.multiplyScalar, o = t.divideScalar, c = t.unaryMinus, l = t.sqrt, d = t.abs;
  return r(name$N, {
    "Array, Array, Array": function(C, S, A) {
      if (C.length === 2 && S.length === 2 && A.length === 2) {
        if (!u(C))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!u(S))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
        if (!u(A))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
        var D = o(a(A[1], A[0]), a(S[1], S[0])), N = s(s(D, D), S[0]), T = c(s(D, S[0])), R = C[1];
        return x(C[0], C[1], N, T, R);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object, Object": function(C, S, A) {
      if (Object.keys(C).length === 2 && Object.keys(S).length === 2 && Object.keys(A).length === 2) {
        if (!u(C))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!u(S))
          throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
        if (!u(A))
          throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
        if ("pointX" in C && "pointY" in C && "lineOnePtX" in S && "lineOnePtY" in S && "lineTwoPtX" in A && "lineTwoPtY" in A) {
          var D = o(a(A.lineTwoPtY, A.lineTwoPtX), a(S.lineOnePtY, S.lineOnePtX)), N = s(s(D, D), S.lineOnePtX), T = c(s(D, S.lineOnePtX)), R = C.pointX;
          return x(C.pointX, C.pointY, N, T, R);
        } else
          throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Array, Array": function(C, S) {
      if (C.length === 2 && S.length === 3) {
        if (!u(C))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!p(S))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        return x(C[0], C[1], S[0], S[1], S[2]);
      } else if (C.length === 3 && S.length === 6) {
        if (!p(C))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!g(S))
          throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
        return _(C[0], C[1], C[2], S[0], S[1], S[2], S[3], S[4], S[5]);
      } else if (C.length === S.length && C.length > 0) {
        if (!m(C))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        if (!m(S))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        return $(C, S);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object": function(C, S) {
      if (Object.keys(C).length === 2 && Object.keys(S).length === 3) {
        if (!u(C))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!p(S))
          throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
        if ("pointX" in C && "pointY" in C && "xCoeffLine" in S && "yCoeffLine" in S && "constant" in S)
          return x(C.pointX, C.pointY, S.xCoeffLine, S.yCoeffLine, S.constant);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(C).length === 3 && Object.keys(S).length === 6) {
        if (!p(C))
          throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
        if (!g(S))
          throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
        if ("pointX" in C && "pointY" in C && "x0" in S && "y0" in S && "z0" in S && "a" in S && "b" in S && "c" in S)
          return _(C.pointX, C.pointY, C.pointZ, S.x0, S.y0, S.z0, S.a, S.b, S.c);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(C).length === 2 && Object.keys(S).length === 2) {
        if (!u(C))
          throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
        if (!u(S))
          throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
        if ("pointOneX" in C && "pointOneY" in C && "pointTwoX" in S && "pointTwoY" in S)
          return $([C.pointOneX, C.pointOneY], [S.pointTwoX, S.pointTwoY]);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(C).length === 3 && Object.keys(S).length === 3) {
        if (!p(C))
          throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
        if (!p(S))
          throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
        if ("pointOneX" in C && "pointOneY" in C && "pointOneZ" in C && "pointTwoX" in S && "pointTwoY" in S && "pointTwoZ" in S)
          return $([C.pointOneX, C.pointOneY, C.pointOneZ], [S.pointTwoX, S.pointTwoY, S.pointTwoZ]);
        throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    Array: function(C) {
      if (!y(C))
        throw new TypeError("Incorrect array format entered for pairwise distance calculation");
      return b(C);
    }
  });
  function h(M) {
    return typeof M == "number" || (0, _is$u.isBigNumber)(M);
  }
  function u(M) {
    return M.constructor !== Array && (M = v(M)), h(M[0]) && h(M[1]);
  }
  function p(M) {
    return M.constructor !== Array && (M = v(M)), h(M[0]) && h(M[1]) && h(M[2]);
  }
  function m(M) {
    return Array.isArray(M) || (M = v(M)), M.every(h);
  }
  function g(M) {
    return M.constructor !== Array && (M = v(M)), h(M[0]) && h(M[1]) && h(M[2]) && h(M[3]) && h(M[4]) && h(M[5]);
  }
  function v(M) {
    for (var C = Object.keys(M), S = [], A = 0; A < C.length; A++)
      S.push(M[C[A]]);
    return S;
  }
  function y(M) {
    if (M[0].length === 2 && h(M[0][0]) && h(M[0][1])) {
      if (M.some(function(C) {
        return C.length !== 2 || !h(C[0]) || !h(C[1]);
      }))
        return !1;
    } else if (M[0].length === 3 && h(M[0][0]) && h(M[0][1]) && h(M[0][2])) {
      if (M.some(function(C) {
        return C.length !== 3 || !h(C[0]) || !h(C[1]) || !h(C[2]);
      }))
        return !1;
    } else
      return !1;
    return !0;
  }
  function x(M, C, S, A, D) {
    var N = d(n(n(s(S, M), s(A, C)), D)), T = l(n(s(S, S), s(A, A)));
    return o(N, T);
  }
  function _(M, C, S, A, D, N, T, R, F) {
    var z = [a(s(a(D, C), F), s(a(N, S), R)), a(s(a(N, S), T), s(a(A, M), F)), a(s(a(A, M), R), s(a(D, C), T))];
    z = l(n(n(s(z[0], z[0]), s(z[1], z[1])), s(z[2], z[2])));
    var O = l(n(n(s(T, T), s(R, R)), s(F, F)));
    return o(z, O);
  }
  function $(M, C) {
    for (var S = M.length, A = 0, D = 0, N = 0; N < S; N++)
      D = a(M[N], C[N]), A = n(s(D, D), A);
    return l(A);
  }
  function b(M) {
    for (var C = [], S = [], A = [], D = 0; D < M.length - 1; D++)
      for (var N = D + 1; N < M.length; N++)
        M[0].length === 2 ? (S = [M[D][0], M[D][1]], A = [M[N][0], M[N][1]]) : M[0].length === 3 && (S = [M[D][0], M[D][1], M[D][2]], A = [M[N][0], M[N][1], M[N][2]]), C.push($(S, A));
    return C;
  }
});
distance.createDistance = createDistance;
var intersect = {};
Object.defineProperty(intersect, "__esModule", {
  value: !0
});
intersect.createIntersect = void 0;
var _is$t = is, _factory$P = factory$1, name$M = "intersect", dependencies$L = ["typed", "config", "abs", "add", "addScalar", "matrix", "multiply", "multiplyScalar", "divideScalar", "subtract", "smaller", "equalScalar"], createIntersect = /* @__PURE__ */ (0, _factory$P.factory)(name$M, dependencies$L, function(t) {
  var r = t.typed, n = t.config, a = t.abs, s = t.add, o = t.addScalar, c = t.matrix, l = t.multiply, d = t.multiplyScalar, h = t.divideScalar, u = t.subtract, p = t.smaller, m = t.equalScalar;
  return r("intersect", {
    "Array, Array, Array": function(S, A, D) {
      if (!y(S))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!y(A))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      if (!x(D))
        throw new TypeError("Array with 4 numbers expected as third argument");
      return M(S[0], S[1], S[2], A[0], A[1], A[2], D[0], D[1], D[2], D[3]);
    },
    "Array, Array, Array, Array": function(S, A, D, N) {
      if (S.length === 2) {
        if (!v(S))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!v(A))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
        if (!v(D))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
        if (!v(N))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
        return _(S, A, D, N);
      } else if (S.length === 3) {
        if (!y(S))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!y(A))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        if (!y(D))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
        if (!y(N))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
        return b(S[0], S[1], S[2], A[0], A[1], A[2], D[0], D[1], D[2], N[0], N[1], N[2]);
      } else
        throw new TypeError("Arrays with two or thee dimensional points expected");
    },
    "Matrix, Matrix, Matrix": function(S, A, D) {
      return c(this(S.valueOf(), A.valueOf(), D.valueOf()));
    },
    "Matrix, Matrix, Matrix, Matrix": function(S, A, D, N) {
      return c(this(S.valueOf(), A.valueOf(), D.valueOf(), N.valueOf()));
    }
  });
  function g(C) {
    return typeof C == "number" || (0, _is$t.isBigNumber)(C);
  }
  function v(C) {
    return C.length === 2 && g(C[0]) && g(C[1]);
  }
  function y(C) {
    return C.length === 3 && g(C[0]) && g(C[1]) && g(C[2]);
  }
  function x(C) {
    return C.length === 4 && g(C[0]) && g(C[1]) && g(C[2]) && g(C[3]);
  }
  function _(C, S, A, D) {
    var N = C, T = A, R = u(N, S), F = u(T, D), z = u(d(R[0], F[1]), d(F[0], R[1]));
    if (p(a(z), n.epsilon))
      return null;
    var O = d(F[0], N[1]), G = d(F[1], N[0]), I = d(F[0], T[1]), k = d(F[1], T[0]), B = h(o(u(u(O, G), I), k), z);
    return s(l(R, B), N);
  }
  function $(C, S, A, D, N, T, R, F, z, O, G, I) {
    var k = d(u(C, S), u(A, D)), B = d(u(N, T), u(R, F)), L = d(u(z, O), u(G, I));
    return o(o(k, B), L);
  }
  function b(C, S, A, D, N, T, R, F, z, O, G, I) {
    var k = $(C, R, O, R, S, F, G, F, A, z, I, z), B = $(O, R, D, C, G, F, N, S, I, z, T, A), L = $(C, R, D, C, S, F, N, S, A, z, T, A), V = $(O, R, O, R, G, F, G, F, I, z, I, z), U = $(D, C, D, C, N, S, N, S, T, A, T, A), J = h(u(d(k, B), d(L, V)), u(d(U, V), d(B, B))), q = h(o(k, d(J, B)), V), Z = o(C, d(J, u(D, C))), ae = o(S, d(J, u(N, S))), ee = o(A, d(J, u(T, A))), se = o(R, d(q, u(O, R))), nr = o(F, d(q, u(G, F))), ce = o(z, d(q, u(I, z)));
    return m(Z, se) && m(ae, nr) && m(ee, ce) ? [Z, ae, ee] : null;
  }
  function M(C, S, A, D, N, T, R, F, z, O) {
    var G = d(C, R), I = d(D, R), k = d(S, F), B = d(N, F), L = d(A, z), V = d(T, z), U = h(u(u(u(O, G), k), L), u(u(u(o(o(I, B), V), G), k), L)), J = o(C, d(U, u(D, C))), q = o(S, d(U, u(N, S))), Z = o(A, d(U, u(T, A)));
    return [J, q, Z];
  }
});
intersect.createIntersect = createIntersect;
var sum = {};
Object.defineProperty(sum, "__esModule", {
  value: !0
});
sum.createSum = void 0;
var _collection$6 = collection$1, _factory$O = factory$1, _improveErrorMessage$4 = improveErrorMessage$1, name$L = "sum", dependencies$K = ["typed", "config", "add", "numeric"], createSum = /* @__PURE__ */ (0, _factory$O.factory)(name$L, dependencies$K, function(t) {
  var r = t.typed, n = t.config, a = t.add, s = t.numeric;
  return r(name$L, {
    // sum([a, b, c, d, ...])
    "Array | Matrix": o,
    // sum([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": c,
    // sum(a, b, c, d, ...)
    "...": function(d) {
      if ((0, _collection$6.containsCollections)(d))
        throw new TypeError("Scalar values expected in function sum");
      return o(d);
    }
  });
  function o(l) {
    var d;
    return (0, _collection$6.deepForEach)(l, function(h) {
      try {
        d = d === void 0 ? h : a(d, h);
      } catch (u) {
        throw (0, _improveErrorMessage$4.improveErrorMessage)(u, "sum", h);
      }
    }), d === void 0 && (d = s(0, n.number)), typeof d == "string" && (d = s(d, n.number)), d;
  }
  function c(l, d) {
    try {
      var h = (0, _collection$6.reduce)(l, d, a);
      return h;
    } catch (u) {
      throw (0, _improveErrorMessage$4.improveErrorMessage)(u, "sum");
    }
  }
});
sum.createSum = createSum;
var mean = {};
Object.defineProperty(mean, "__esModule", {
  value: !0
});
mean.createMean = void 0;
var _collection$5 = collection$1, _array$8 = array, _factory$N = factory$1, _improveErrorMessage$3 = improveErrorMessage$1, name$K = "mean", dependencies$J = ["typed", "add", "divide"], createMean = /* @__PURE__ */ (0, _factory$N.factory)(name$K, dependencies$J, function(t) {
  var r = t.typed, n = t.add, a = t.divide;
  return r(name$K, {
    // mean([a, b, c, d, ...])
    "Array | Matrix": o,
    // mean([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": s,
    // mean(a, b, c, d, ...)
    "...": function(l) {
      if ((0, _collection$5.containsCollections)(l))
        throw new TypeError("Scalar values expected in function mean");
      return o(l);
    }
  });
  function s(c, l) {
    try {
      var d = (0, _collection$5.reduce)(c, l, n), h = Array.isArray(c) ? (0, _array$8.arraySize)(c) : c.size();
      return a(d, h[l]);
    } catch (u) {
      throw (0, _improveErrorMessage$3.improveErrorMessage)(u, "mean");
    }
  }
  function o(c) {
    var l, d = 0;
    if ((0, _collection$5.deepForEach)(c, function(h) {
      try {
        l = l === void 0 ? h : n(l, h), d++;
      } catch (u) {
        throw (0, _improveErrorMessage$3.improveErrorMessage)(u, "mean", h);
      }
    }), d === 0)
      throw new Error("Cannot calculate the mean of an empty array");
    return a(l, d);
  }
});
mean.createMean = createMean;
var median = {};
Object.defineProperty(median, "__esModule", {
  value: !0
});
median.createMedian = void 0;
var _collection$4 = collection$1, _array$7 = array, _factory$M = factory$1, _improveErrorMessage$2 = improveErrorMessage$1, name$J = "median", dependencies$I = ["typed", "add", "divide", "compare", "partitionSelect"], createMedian = /* @__PURE__ */ (0, _factory$M.factory)(name$J, dependencies$I, function(t) {
  var r = t.typed, n = t.add, a = t.divide, s = t.compare, o = t.partitionSelect;
  function c(h) {
    try {
      h = (0, _array$7.flatten)(h.valueOf());
      var u = h.length;
      if (u === 0)
        throw new Error("Cannot calculate median of an empty array");
      if (u % 2 === 0) {
        for (var p = u / 2 - 1, m = o(h, p + 1), g = h[p], v = 0; v < p; ++v)
          s(h[v], g) > 0 && (g = h[v]);
        return d(g, m);
      } else {
        var y = o(h, (u - 1) / 2);
        return l(y);
      }
    } catch (x) {
      throw (0, _improveErrorMessage$2.improveErrorMessage)(x, "median");
    }
  }
  var l = r({
    "number | BigNumber | Complex | Unit": function(u) {
      return u;
    }
  }), d = r({
    "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(u, p) {
      return a(n(u, p), 2);
    }
  });
  return r(name$J, {
    // median([a, b, c, d, ...])
    "Array | Matrix": c,
    // median([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(u, p) {
      throw new Error("median(A, dim) is not yet supported");
    },
    // median(a, b, c, d, ...)
    "...": function(u) {
      if ((0, _collection$4.containsCollections)(u))
        throw new TypeError("Scalar values expected in function median");
      return c(u);
    }
  });
});
median.createMedian = createMedian;
var mad = {};
Object.defineProperty(mad, "__esModule", {
  value: !0
});
mad.createMad = void 0;
var _array$6 = array, _factory$L = factory$1, _improveErrorMessage$1 = improveErrorMessage$1, name$I = "mad", dependencies$H = ["typed", "abs", "map", "median", "subtract"], createMad = /* @__PURE__ */ (0, _factory$L.factory)(name$I, dependencies$H, function(t) {
  var r = t.typed, n = t.abs, a = t.map, s = t.median, o = t.subtract;
  return r(name$I, {
    // mad([a, b, c, d, ...])
    "Array | Matrix": c,
    // mad(a, b, c, d, ...)
    "...": function(d) {
      return c(d);
    }
  });
  function c(l) {
    if (l = (0, _array$6.flatten)(l.valueOf()), l.length === 0)
      throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
    try {
      var d = s(l);
      return s(a(l, function(h) {
        return n(o(h, d));
      }));
    } catch (h) {
      throw h instanceof TypeError && h.message.indexOf("median") !== -1 ? new TypeError(h.message.replace("median", "mad")) : (0, _improveErrorMessage$1.improveErrorMessage)(h, "mad");
    }
  }
});
mad.createMad = createMad;
var variance = {};
Object.defineProperty(variance, "__esModule", {
  value: !0
});
variance.createVariance = void 0;
var _collection$3 = collection$1, _is$s = is, _factory$K = factory$1, _improveErrorMessage = improveErrorMessage$1, DEFAULT_NORMALIZATION = "unbiased", name$H = "variance", dependencies$G = ["typed", "add", "subtract", "multiply", "divide", "apply", "isNaN"], createVariance = /* @__PURE__ */ (0, _factory$K.factory)(name$H, dependencies$G, function(t) {
  var r = t.typed, n = t.add, a = t.subtract, s = t.multiply, o = t.divide, c = t.apply, l = t.isNaN;
  return r(name$H, {
    // variance([a, b, c, d, ...])
    "Array | Matrix": function(p) {
      return d(p, DEFAULT_NORMALIZATION);
    },
    // variance([a, b, c, d, ...], normalization)
    "Array | Matrix, string": d,
    // variance([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": function(p, m) {
      return h(p, m, DEFAULT_NORMALIZATION);
    },
    // variance([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": h,
    // variance(a, b, c, d, ...)
    "...": function(p) {
      return d(p, DEFAULT_NORMALIZATION);
    }
  });
  function d(u, p) {
    var m, g = 0;
    if (u.length === 0)
      throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
    if ((0, _collection$3.deepForEach)(u, function(x) {
      try {
        m = m === void 0 ? x : n(m, x), g++;
      } catch (_) {
        throw (0, _improveErrorMessage.improveErrorMessage)(_, "variance", x);
      }
    }), g === 0)
      throw new Error("Cannot calculate variance of an empty array");
    var v = o(m, g);
    if (m = void 0, (0, _collection$3.deepForEach)(u, function(x) {
      var _ = a(x, v);
      m = m === void 0 ? s(_, _) : n(m, s(_, _));
    }), l(m))
      return m;
    switch (p) {
      case "uncorrected":
        return o(m, g);
      case "biased":
        return o(m, g + 1);
      case "unbiased": {
        var y = (0, _is$s.isBigNumber)(m) ? m.mul(0) : 0;
        return g === 1 ? y : o(m, g - 1);
      }
      default:
        throw new Error('Unknown normalization "' + p + '". Choose "unbiased" (default), "uncorrected", or "biased".');
    }
  }
  function h(u, p, m) {
    try {
      if (u.length === 0)
        throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
      return c(u, p, function(g) {
        return d(g, m);
      });
    } catch (g) {
      throw (0, _improveErrorMessage.improveErrorMessage)(g, "variance");
    }
  }
});
variance.createVariance = createVariance;
var quantileSeq = {};
Object.defineProperty(quantileSeq, "__esModule", {
  value: !0
});
quantileSeq.createQuantileSeq = void 0;
var _is$r = is, _number$3 = number$3, _array$5 = array, _factory$J = factory$1, name$G = "quantileSeq", dependencies$F = ["typed", "add", "multiply", "partitionSelect", "compare"], createQuantileSeq = /* @__PURE__ */ (0, _factory$J.factory)(name$G, dependencies$F, function(t) {
  var r = t.typed, n = t.add, a = t.multiply, s = t.partitionSelect, o = t.compare;
  function c(h, u, p) {
    var m, g, v;
    if (arguments.length < 2 || arguments.length > 3)
      throw new SyntaxError("Function quantileSeq requires two or three parameters");
    if ((0, _is$r.isCollection)(h)) {
      if (p = p || !1, typeof p == "boolean") {
        if (g = h.valueOf(), (0, _is$r.isNumber)(u)) {
          if (u < 0)
            throw new Error("N/prob must be non-negative");
          if (u <= 1)
            return l(g, u, p);
          if (u > 1) {
            if (!(0, _number$3.isInteger)(u))
              throw new Error("N must be a positive integer");
            var y = u + 1;
            m = new Array(u);
            for (var x = 0; x < u; )
              m[x] = l(g, ++x / y, p);
            return m;
          }
        }
        if ((0, _is$r.isBigNumber)(u)) {
          var _ = u.constructor;
          if (u.isNegative())
            throw new Error("N/prob must be non-negative");
          if (v = new _(1), u.lte(v))
            return new _(l(g, u, p));
          if (u.gt(v)) {
            if (!u.isInteger())
              throw new Error("N must be a positive integer");
            var $ = u.toNumber();
            if ($ > 4294967295)
              throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
            var b = new _($ + 1);
            m = new Array($);
            for (var M = 0; M < $; )
              m[M] = new _(l(g, new _(++M).div(b), p));
            return m;
          }
        }
        if (Array.isArray(u)) {
          m = new Array(u.length);
          for (var C = 0; C < m.length; ++C) {
            var S = u[C];
            if ((0, _is$r.isNumber)(S)) {
              if (S < 0 || S > 1)
                throw new Error("Probability must be between 0 and 1, inclusive");
            } else if ((0, _is$r.isBigNumber)(S)) {
              if (v = new S.constructor(1), S.isNegative() || S.gt(v))
                throw new Error("Probability must be between 0 and 1, inclusive");
            } else
              throw new TypeError("Unexpected type of argument in function quantileSeq");
            m[C] = l(g, S, p);
          }
          return m;
        }
        throw new TypeError("Unexpected type of argument in function quantileSeq");
      }
      throw new TypeError("Unexpected type of argument in function quantileSeq");
    }
    throw new TypeError("Unexpected type of argument in function quantileSeq");
  }
  function l(h, u, p) {
    var m = (0, _array$5.flatten)(h), g = m.length;
    if (g === 0)
      throw new Error("Cannot calculate quantile of an empty sequence");
    if ((0, _is$r.isNumber)(u)) {
      var v = u * (g - 1), y = v % 1;
      if (y === 0) {
        var x = p ? m[v] : s(m, v);
        return d(x), x;
      }
      var _ = Math.floor(v), $, b;
      if (p)
        $ = m[_], b = m[_ + 1];
      else {
        b = s(m, _ + 1), $ = m[_];
        for (var M = 0; M < _; ++M)
          o(m[M], $) > 0 && ($ = m[M]);
      }
      return d($), d(b), n(a($, 1 - y), a(b, y));
    }
    var C = u.times(g - 1);
    if (C.isInteger()) {
      C = C.toNumber();
      var S = p ? m[C] : s(m, C);
      return d(S), S;
    }
    var A = C.floor(), D = C.minus(A), N = A.toNumber(), T, R;
    if (p)
      T = m[N], R = m[N + 1];
    else {
      R = s(m, N + 1), T = m[N];
      for (var F = 0; F < N; ++F)
        o(m[F], T) > 0 && (T = m[F]);
    }
    d(T), d(R);
    var z = new D.constructor(1);
    return n(a(T, z.minus(D)), a(R, D));
  }
  var d = r({
    "number | BigNumber | Unit": function(u) {
      return u;
    }
  });
  return c;
});
quantileSeq.createQuantileSeq = createQuantileSeq;
var std = {};
Object.defineProperty(std, "__esModule", {
  value: !0
});
std.createStd = void 0;
var _factory$I = factory$1, name$F = "std", dependencies$E = ["typed", "sqrt", "variance"], createStd = /* @__PURE__ */ (0, _factory$I.factory)(name$F, dependencies$E, function(t) {
  var r = t.typed, n = t.sqrt, a = t.variance;
  return r(name$F, {
    // std([a, b, c, d, ...])
    "Array | Matrix": s,
    // std([a, b, c, d, ...], normalization)
    "Array | Matrix, string": s,
    // std([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": s,
    // std([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": s,
    // std(a, b, c, d, ...)
    "...": function(c) {
      return s(c);
    }
  });
  function s(o, c) {
    if (o.length === 0)
      throw new SyntaxError("Function std requires one or more parameters (0 provided)");
    try {
      return n(a.apply(null, arguments));
    } catch (l) {
      throw l instanceof TypeError && l.message.indexOf(" variance") !== -1 ? new TypeError(l.message.replace(" variance", " std")) : l;
    }
  }
});
std.createStd = createStd;
var combinations = {};
Object.defineProperty(combinations, "__esModule", {
  value: !0
});
combinations.createCombinations = void 0;
var _factory$H = factory$1, _combinations = combinations$2, name$E = "combinations", dependencies$D = ["typed"], createCombinations = /* @__PURE__ */ (0, _factory$H.factory)(name$E, dependencies$D, function(t) {
  var r = t.typed;
  return r(name$E, {
    "number, number": _combinations.combinationsNumber,
    "BigNumber, BigNumber": function(a, s) {
      var o = a.constructor, c, l, d = a.minus(s), h = new o(1);
      if (!isPositiveInteger$2(a) || !isPositiveInteger$2(s))
        throw new TypeError("Positive integer value expected in function combinations");
      if (s.gt(a))
        throw new TypeError("k must be less than n in function combinations");
      if (c = h, s.lt(d))
        for (l = h; l.lte(d); l = l.plus(h))
          c = c.times(s.plus(l)).dividedBy(l);
      else
        for (l = h; l.lte(s); l = l.plus(h))
          c = c.times(d.plus(l)).dividedBy(l);
      return c;
    }
    // TODO: implement support for collection in combinations
  });
});
combinations.createCombinations = createCombinations;
function isPositiveInteger$2(t) {
  return t.isInteger() && t.gte(0);
}
var combinationsWithRep = {};
Object.defineProperty(combinationsWithRep, "__esModule", {
  value: !0
});
combinationsWithRep.createCombinationsWithRep = void 0;
var _factory$G = factory$1, _number$2 = number$3, _product$1 = product$1, name$D = "combinationsWithRep", dependencies$C = ["typed"], createCombinationsWithRep = /* @__PURE__ */ (0, _factory$G.factory)(name$D, dependencies$C, function(t) {
  var r = t.typed;
  return r(name$D, {
    "number, number": function(a, s) {
      if (!(0, _number$2.isInteger)(a) || a < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (!(0, _number$2.isInteger)(s) || s < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (a < 1)
        throw new TypeError("k must be less than or equal to n + k - 1");
      if (s < a - 1) {
        var o = (0, _product$1.product)(a, a + s - 1);
        return o / (0, _product$1.product)(1, s);
      }
      var c = (0, _product$1.product)(s + 1, a + s - 1);
      return c / (0, _product$1.product)(1, a - 1);
    },
    "BigNumber, BigNumber": function(a, s) {
      var o = a.constructor, c, l, d = new o(1), h = a.minus(d);
      if (!isPositiveInteger$1(a) || !isPositiveInteger$1(s))
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (a.lt(d))
        throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
      if (c = d, s.lt(h))
        for (l = d; l.lte(h); l = l.plus(d))
          c = c.times(s.plus(l)).dividedBy(l);
      else
        for (l = d; l.lte(s); l = l.plus(d))
          c = c.times(h.plus(l)).dividedBy(l);
      return c;
    }
  });
});
combinationsWithRep.createCombinationsWithRep = createCombinationsWithRep;
function isPositiveInteger$1(t) {
  return t.isInteger() && t.gte(0);
}
var gamma = {};
Object.defineProperty(gamma, "__esModule", {
  value: !0
});
gamma.createGamma = void 0;
var _collection$2 = collection$1, _factory$F = factory$1, _index$1 = number$2, name$C = "gamma", dependencies$B = ["typed", "config", "multiplyScalar", "pow", "BigNumber", "Complex"], createGamma = /* @__PURE__ */ (0, _factory$F.factory)(name$C, dependencies$B, function(t) {
  var r = t.typed, n = t.config, a = t.multiplyScalar, s = t.pow, o = t.BigNumber, c = t.Complex;
  return r(name$C, {
    number: _index$1.gammaNumber,
    Complex: function(h) {
      if (h.im === 0)
        return this(h.re);
      h = new c(h.re - 1, h.im);
      for (var u = new c(_index$1.gammaP[0], 0), p = 1; p < _index$1.gammaP.length; ++p) {
        var m = h.re + p, g = m * m + h.im * h.im;
        g !== 0 ? (u.re += _index$1.gammaP[p] * m / g, u.im += -(_index$1.gammaP[p] * h.im) / g) : u.re = _index$1.gammaP[p] < 0 ? -1 / 0 : 1 / 0;
      }
      var v = new c(h.re + _index$1.gammaG + 0.5, h.im), y = Math.sqrt(2 * Math.PI);
      h.re += 0.5;
      var x = s(v, h);
      x.im === 0 ? x.re *= y : (x.re === 0 || (x.re *= y), x.im *= y);
      var _ = Math.exp(-v.re);
      return v.re = _ * Math.cos(-v.im), v.im = _ * Math.sin(-v.im), a(a(x, v), u);
    },
    BigNumber: function(h) {
      if (h.isInteger())
        return h.isNegative() || h.isZero() ? new o(1 / 0) : l(h.minus(1));
      if (!h.isFinite())
        return new o(h.isNegative() ? NaN : 1 / 0);
      throw new Error("Integer BigNumber expected");
    },
    "Array | Matrix": function(h) {
      return (0, _collection$2.deepMap)(h, this);
    }
  });
  function l(d) {
    if (d < 8)
      return new o([1, 1, 2, 6, 24, 120, 720, 5040][d]);
    var h = n.precision + (Math.log(d.toNumber()) | 0), u = o.clone({
      precision: h
    });
    if (d % 2 === 1)
      return d.times(l(new o(d - 1)));
    for (var p = d, m = new u(d), g = d.toNumber(); p > 2; )
      p -= 2, g += p, m = m.times(g);
    return new o(m.toPrecision(o.precision));
  }
});
gamma.createGamma = createGamma;
var factorial = {};
Object.defineProperty(factorial, "__esModule", {
  value: !0
});
factorial.createFactorial = void 0;
var _collection$1 = collection$1, _factory$E = factory$1, name$B = "factorial", dependencies$A = ["typed", "gamma"], createFactorial = /* @__PURE__ */ (0, _factory$E.factory)(name$B, dependencies$A, function(t) {
  var r = t.typed, n = t.gamma;
  return r(name$B, {
    number: function(s) {
      if (s < 0)
        throw new Error("Value must be non-negative");
      return n(s + 1);
    },
    BigNumber: function(s) {
      if (s.isNegative())
        throw new Error("Value must be non-negative");
      return n(s.plus(1));
    },
    "Array | Matrix": function(s) {
      return (0, _collection$1.deepMap)(s, this);
    }
  });
});
factorial.createFactorial = createFactorial;
var kldivergence = {};
Object.defineProperty(kldivergence, "__esModule", {
  value: !0
});
kldivergence.createKldivergence = void 0;
var _factory$D = factory$1, name$A = "kldivergence", dependencies$z = ["typed", "matrix", "divide", "sum", "multiply", "dotDivide", "log", "isNumeric"], createKldivergence = /* @__PURE__ */ (0, _factory$D.factory)(name$A, dependencies$z, function(t) {
  var r = t.typed, n = t.matrix, a = t.divide, s = t.sum, o = t.multiply, c = t.dotDivide, l = t.log, d = t.isNumeric;
  return r(name$A, {
    "Array, Array": function(p, m) {
      return h(n(p), n(m));
    },
    "Matrix, Array": function(p, m) {
      return h(p, n(m));
    },
    "Array, Matrix": function(p, m) {
      return h(n(p), m);
    },
    "Matrix, Matrix": function(p, m) {
      return h(p, m);
    }
  });
  function h(u, p) {
    var m = p.size().length, g = u.size().length;
    if (m > 1)
      throw new Error("first object must be one dimensional");
    if (g > 1)
      throw new Error("second object must be one dimensional");
    if (m !== g)
      throw new Error("Length of two vectors must be equal");
    var v = s(u);
    if (v === 0)
      throw new Error("Sum of elements in first object must be non zero");
    var y = s(p);
    if (y === 0)
      throw new Error("Sum of elements in second object must be non zero");
    var x = a(u, s(u)), _ = a(p, s(p)), $ = s(o(x, l(c(x, _))));
    return d($) ? $ : Number.NaN;
  }
});
kldivergence.createKldivergence = createKldivergence;
var multinomial = {};
Object.defineProperty(multinomial, "__esModule", {
  value: !0
});
multinomial.createMultinomial = void 0;
var _collection = collection$1, _factory$C = factory$1, name$z = "multinomial", dependencies$y = ["typed", "add", "divide", "multiply", "factorial", "isInteger", "isPositive"], createMultinomial = /* @__PURE__ */ (0, _factory$C.factory)(name$z, dependencies$y, function(t) {
  var r = t.typed, n = t.add, a = t.divide, s = t.multiply, o = t.factorial, c = t.isInteger, l = t.isPositive;
  return r(name$z, {
    "Array | Matrix": function(h) {
      var u = 0, p = 1;
      return (0, _collection.deepForEach)(h, function(m) {
        if (!c(m) || !l(m))
          throw new TypeError("Positive integer value expected in function multinomial");
        u = n(u, m), p = s(p, o(m));
      }), a(o(u), p);
    }
  });
});
multinomial.createMultinomial = createMultinomial;
var permutations = {};
Object.defineProperty(permutations, "__esModule", {
  value: !0
});
permutations.createPermutations = void 0;
var _number$1 = number$3, _product = product$1, _factory$B = factory$1, name$y = "permutations", dependencies$x = ["typed", "factorial"], createPermutations = /* @__PURE__ */ (0, _factory$B.factory)(name$y, dependencies$x, function(t) {
  var r = t.typed, n = t.factorial;
  return r(name$y, {
    "number | BigNumber": n,
    "number, number": function(s, o) {
      if (!(0, _number$1.isInteger)(s) || s < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (!(0, _number$1.isInteger)(o) || o < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (o > s)
        throw new TypeError("second argument k must be less than or equal to first argument n");
      return (0, _product.product)(s - o + 1, s);
    },
    "BigNumber, BigNumber": function(s, o) {
      var c, l;
      if (!isPositiveInteger(s) || !isPositiveInteger(o))
        throw new TypeError("Positive integer value expected in function permutations");
      if (o.gt(s))
        throw new TypeError("second argument k must be less than or equal to first argument n");
      var d = s.mul(0).add(1);
      for (c = d, l = s.minus(o).plus(1); l.lte(s); l = l.plus(1))
        c = c.times(l);
      return c;
    }
    // TODO: implement support for collection in permutations
  });
});
permutations.createPermutations = createPermutations;
function isPositiveInteger(t) {
  return t.isInteger() && t.gte(0);
}
var pickRandom = {}, seededRNG = {}, alea$1 = { exports: {} };
alea$1.exports;
(function(t) {
  (function(r, n, a) {
    function s(d) {
      var h = this, u = l();
      h.next = function() {
        var p = 2091639 * h.s0 + h.c * 23283064365386963e-26;
        return h.s0 = h.s1, h.s1 = h.s2, h.s2 = p - (h.c = p | 0);
      }, h.c = 1, h.s0 = u(" "), h.s1 = u(" "), h.s2 = u(" "), h.s0 -= u(d), h.s0 < 0 && (h.s0 += 1), h.s1 -= u(d), h.s1 < 0 && (h.s1 += 1), h.s2 -= u(d), h.s2 < 0 && (h.s2 += 1), u = null;
    }
    function o(d, h) {
      return h.c = d.c, h.s0 = d.s0, h.s1 = d.s1, h.s2 = d.s2, h;
    }
    function c(d, h) {
      var u = new s(d), p = h && h.state, m = u.next;
      return m.int32 = function() {
        return u.next() * 4294967296 | 0;
      }, m.double = function() {
        return m() + (m() * 2097152 | 0) * 11102230246251565e-32;
      }, m.quick = m, p && (typeof p == "object" && o(p, u), m.state = function() {
        return o(u, {});
      }), m;
    }
    function l() {
      var d = 4022871197, h = function(u) {
        u = String(u);
        for (var p = 0; p < u.length; p++) {
          d += u.charCodeAt(p);
          var m = 0.02519603282416938 * d;
          d = m >>> 0, m -= d, m *= d, d = m >>> 0, m -= d, d += m * 4294967296;
        }
        return (d >>> 0) * 23283064365386963e-26;
      };
      return h;
    }
    n && n.exports ? n.exports = c : a && a.amd ? a(function() {
      return c;
    }) : this.alea = c;
  })(
    commonjsGlobal,
    t,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(alea$1);
var aleaExports = alea$1.exports, xor128$1 = { exports: {} };
xor128$1.exports;
(function(t) {
  (function(r, n, a) {
    function s(l) {
      var d = this, h = "";
      d.x = 0, d.y = 0, d.z = 0, d.w = 0, d.next = function() {
        var p = d.x ^ d.x << 11;
        return d.x = d.y, d.y = d.z, d.z = d.w, d.w ^= d.w >>> 19 ^ p ^ p >>> 8;
      }, l === (l | 0) ? d.x = l : h += l;
      for (var u = 0; u < h.length + 64; u++)
        d.x ^= h.charCodeAt(u) | 0, d.next();
    }
    function o(l, d) {
      return d.x = l.x, d.y = l.y, d.z = l.z, d.w = l.w, d;
    }
    function c(l, d) {
      var h = new s(l), u = d && d.state, p = function() {
        return (h.next() >>> 0) / 4294967296;
      };
      return p.double = function() {
        do
          var m = h.next() >>> 11, g = (h.next() >>> 0) / 4294967296, v = (m + g) / (1 << 21);
        while (v === 0);
        return v;
      }, p.int32 = h.next, p.quick = p, u && (typeof u == "object" && o(u, h), p.state = function() {
        return o(h, {});
      }), p;
    }
    n && n.exports ? n.exports = c : a && a.amd ? a(function() {
      return c;
    }) : this.xor128 = c;
  })(
    commonjsGlobal,
    t,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(xor128$1);
var xor128Exports = xor128$1.exports, xorwow$1 = { exports: {} };
xorwow$1.exports;
(function(t) {
  (function(r, n, a) {
    function s(l) {
      var d = this, h = "";
      d.next = function() {
        var p = d.x ^ d.x >>> 2;
        return d.x = d.y, d.y = d.z, d.z = d.w, d.w = d.v, (d.d = d.d + 362437 | 0) + (d.v = d.v ^ d.v << 4 ^ (p ^ p << 1)) | 0;
      }, d.x = 0, d.y = 0, d.z = 0, d.w = 0, d.v = 0, l === (l | 0) ? d.x = l : h += l;
      for (var u = 0; u < h.length + 64; u++)
        d.x ^= h.charCodeAt(u) | 0, u == h.length && (d.d = d.x << 10 ^ d.x >>> 4), d.next();
    }
    function o(l, d) {
      return d.x = l.x, d.y = l.y, d.z = l.z, d.w = l.w, d.v = l.v, d.d = l.d, d;
    }
    function c(l, d) {
      var h = new s(l), u = d && d.state, p = function() {
        return (h.next() >>> 0) / 4294967296;
      };
      return p.double = function() {
        do
          var m = h.next() >>> 11, g = (h.next() >>> 0) / 4294967296, v = (m + g) / (1 << 21);
        while (v === 0);
        return v;
      }, p.int32 = h.next, p.quick = p, u && (typeof u == "object" && o(u, h), p.state = function() {
        return o(h, {});
      }), p;
    }
    n && n.exports ? n.exports = c : a && a.amd ? a(function() {
      return c;
    }) : this.xorwow = c;
  })(
    commonjsGlobal,
    t,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(xorwow$1);
var xorwowExports = xorwow$1.exports, xorshift7$1 = { exports: {} };
xorshift7$1.exports;
(function(t) {
  (function(r, n, a) {
    function s(l) {
      var d = this;
      d.next = function() {
        var u = d.x, p = d.i, m, g;
        return m = u[p], m ^= m >>> 7, g = m ^ m << 24, m = u[p + 1 & 7], g ^= m ^ m >>> 10, m = u[p + 3 & 7], g ^= m ^ m >>> 3, m = u[p + 4 & 7], g ^= m ^ m << 7, m = u[p + 7 & 7], m = m ^ m << 13, g ^= m ^ m << 9, u[p] = g, d.i = p + 1 & 7, g;
      };
      function h(u, p) {
        var m, g = [];
        if (p === (p | 0))
          g[0] = p;
        else
          for (p = "" + p, m = 0; m < p.length; ++m)
            g[m & 7] = g[m & 7] << 15 ^ p.charCodeAt(m) + g[m + 1 & 7] << 13;
        for (; g.length < 8; )
          g.push(0);
        for (m = 0; m < 8 && g[m] === 0; ++m)
          ;
        for (m == 8 ? g[7] = -1 : g[m], u.x = g, u.i = 0, m = 256; m > 0; --m)
          u.next();
      }
      h(d, l);
    }
    function o(l, d) {
      return d.x = l.x.slice(), d.i = l.i, d;
    }
    function c(l, d) {
      l == null && (l = +/* @__PURE__ */ new Date());
      var h = new s(l), u = d && d.state, p = function() {
        return (h.next() >>> 0) / 4294967296;
      };
      return p.double = function() {
        do
          var m = h.next() >>> 11, g = (h.next() >>> 0) / 4294967296, v = (m + g) / (1 << 21);
        while (v === 0);
        return v;
      }, p.int32 = h.next, p.quick = p, u && (u.x && o(u, h), p.state = function() {
        return o(h, {});
      }), p;
    }
    n && n.exports ? n.exports = c : a && a.amd ? a(function() {
      return c;
    }) : this.xorshift7 = c;
  })(
    commonjsGlobal,
    t,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(xorshift7$1);
var xorshift7Exports = xorshift7$1.exports, xor4096$1 = { exports: {} };
xor4096$1.exports;
(function(t) {
  (function(r, n, a) {
    function s(l) {
      var d = this;
      d.next = function() {
        var u = d.w, p = d.X, m = d.i, g, v;
        return d.w = u = u + 1640531527 | 0, v = p[m + 34 & 127], g = p[m = m + 1 & 127], v ^= v << 13, g ^= g << 17, v ^= v >>> 15, g ^= g >>> 12, v = p[m] = v ^ g, d.i = m, v + (u ^ u >>> 16) | 0;
      };
      function h(u, p) {
        var m, g, v, y, x, _ = [], $ = 128;
        for (p === (p | 0) ? (g = p, p = null) : (p = p + "\0", g = 0, $ = Math.max($, p.length)), v = 0, y = -32; y < $; ++y)
          p && (g ^= p.charCodeAt((y + 32) % p.length)), y === 0 && (x = g), g ^= g << 10, g ^= g >>> 15, g ^= g << 4, g ^= g >>> 13, y >= 0 && (x = x + 1640531527 | 0, m = _[y & 127] ^= g + x, v = m == 0 ? v + 1 : 0);
        for (v >= 128 && (_[(p && p.length || 0) & 127] = -1), v = 127, y = 4 * 128; y > 0; --y)
          g = _[v + 34 & 127], m = _[v = v + 1 & 127], g ^= g << 13, m ^= m << 17, g ^= g >>> 15, m ^= m >>> 12, _[v] = g ^ m;
        u.w = x, u.X = _, u.i = v;
      }
      h(d, l);
    }
    function o(l, d) {
      return d.i = l.i, d.w = l.w, d.X = l.X.slice(), d;
    }
    function c(l, d) {
      l == null && (l = +/* @__PURE__ */ new Date());
      var h = new s(l), u = d && d.state, p = function() {
        return (h.next() >>> 0) / 4294967296;
      };
      return p.double = function() {
        do
          var m = h.next() >>> 11, g = (h.next() >>> 0) / 4294967296, v = (m + g) / (1 << 21);
        while (v === 0);
        return v;
      }, p.int32 = h.next, p.quick = p, u && (u.X && o(u, h), p.state = function() {
        return o(h, {});
      }), p;
    }
    n && n.exports ? n.exports = c : a && a.amd ? a(function() {
      return c;
    }) : this.xor4096 = c;
  })(
    commonjsGlobal,
    // window object or global
    t,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(xor4096$1);
var xor4096Exports = xor4096$1.exports, tychei$1 = { exports: {} };
tychei$1.exports;
(function(t) {
  (function(r, n, a) {
    function s(l) {
      var d = this, h = "";
      d.next = function() {
        var p = d.b, m = d.c, g = d.d, v = d.a;
        return p = p << 25 ^ p >>> 7 ^ m, m = m - g | 0, g = g << 24 ^ g >>> 8 ^ v, v = v - p | 0, d.b = p = p << 20 ^ p >>> 12 ^ m, d.c = m = m - g | 0, d.d = g << 16 ^ m >>> 16 ^ v, d.a = v - p | 0;
      }, d.a = 0, d.b = 0, d.c = -1640531527, d.d = 1367130551, l === Math.floor(l) ? (d.a = l / 4294967296 | 0, d.b = l | 0) : h += l;
      for (var u = 0; u < h.length + 20; u++)
        d.b ^= h.charCodeAt(u) | 0, d.next();
    }
    function o(l, d) {
      return d.a = l.a, d.b = l.b, d.c = l.c, d.d = l.d, d;
    }
    function c(l, d) {
      var h = new s(l), u = d && d.state, p = function() {
        return (h.next() >>> 0) / 4294967296;
      };
      return p.double = function() {
        do
          var m = h.next() >>> 11, g = (h.next() >>> 0) / 4294967296, v = (m + g) / (1 << 21);
        while (v === 0);
        return v;
      }, p.int32 = h.next, p.quick = p, u && (typeof u == "object" && o(u, h), p.state = function() {
        return o(h, {});
      }), p;
    }
    n && n.exports ? n.exports = c : a && a.amd ? a(function() {
      return c;
    }) : this.tychei = c;
  })(
    commonjsGlobal,
    t,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(tychei$1);
var tycheiExports = tychei$1.exports, seedrandom$1 = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(t) {
  (function(r, n, a) {
    var s = 256, o = 6, c = 52, l = "random", d = a.pow(s, o), h = a.pow(2, c), u = h * 2, p = s - 1, m;
    function g(M, C, S) {
      var A = [];
      C = C == !0 ? { entropy: !0 } : C || {};
      var D = _(x(
        C.entropy ? [M, b(n)] : M ?? $(),
        3
      ), A), N = new v(A), T = function() {
        for (var R = N.g(o), F = d, z = 0; R < h; )
          R = (R + z) * s, F *= s, z = N.g(1);
        for (; R >= u; )
          R /= 2, F /= 2, z >>>= 1;
        return (R + z) / F;
      };
      return T.int32 = function() {
        return N.g(4) | 0;
      }, T.quick = function() {
        return N.g(4) / 4294967296;
      }, T.double = T, _(b(N.S), n), (C.pass || S || function(R, F, z, O) {
        return O && (O.S && y(O, N), R.state = function() {
          return y(N, {});
        }), z ? (a[l] = R, F) : R;
      })(
        T,
        D,
        "global" in C ? C.global : this == a,
        C.state
      );
    }
    function v(M) {
      var C, S = M.length, A = this, D = 0, N = A.i = A.j = 0, T = A.S = [];
      for (S || (M = [S++]); D < s; )
        T[D] = D++;
      for (D = 0; D < s; D++)
        T[D] = T[N = p & N + M[D % S] + (C = T[D])], T[N] = C;
      (A.g = function(R) {
        for (var F, z = 0, O = A.i, G = A.j, I = A.S; R--; )
          F = I[O = p & O + 1], z = z * s + I[p & (I[O] = I[G = p & G + F]) + (I[G] = F)];
        return A.i = O, A.j = G, z;
      })(s);
    }
    function y(M, C) {
      return C.i = M.i, C.j = M.j, C.S = M.S.slice(), C;
    }
    function x(M, C) {
      var S = [], A = typeof M, D;
      if (C && A == "object")
        for (D in M)
          try {
            S.push(x(M[D], C - 1));
          } catch {
          }
      return S.length ? S : A == "string" ? M : M + "\0";
    }
    function _(M, C) {
      for (var S = M + "", A, D = 0; D < S.length; )
        C[p & D] = p & (A ^= C[p & D] * 19) + S.charCodeAt(D++);
      return b(C);
    }
    function $() {
      try {
        var M;
        return m && (M = m.randomBytes) ? M = M(s) : (M = new Uint8Array(s), (r.crypto || r.msCrypto).getRandomValues(M)), b(M);
      } catch {
        var C = r.navigator, S = C && C.plugins;
        return [+/* @__PURE__ */ new Date(), r, S, r.screen, b(n)];
      }
    }
    function b(M) {
      return String.fromCharCode.apply(0, M);
    }
    if (_(a.random(), n), t.exports) {
      t.exports = g;
      try {
        m = require$$0$1;
      } catch {
      }
    } else
      a["seed" + l] = g;
  })(
    // global: `self` in browsers (including strict mode and web workers),
    // otherwise `this` in Node and other environments
    typeof self < "u" ? self : commonjsGlobal,
    [],
    // pool: entropy pool starts empty
    Math
    // math: package containing random, pow, and seedrandom
  );
})(seedrandom$1);
var seedrandomExports = seedrandom$1.exports, alea = aleaExports, xor128 = xor128Exports, xorwow = xorwowExports, xorshift7 = xorshift7Exports, xor4096 = xor4096Exports, tychei = tycheiExports, sr = seedrandomExports;
sr.alea = alea;
sr.xor128 = xor128;
sr.xorwow = xorwow;
sr.xorshift7 = xorshift7;
sr.xor4096 = xor4096;
sr.tychei = tychei;
var seedrandom = sr;
Object.defineProperty(seededRNG, "__esModule", {
  value: !0
});
seededRNG.createRng = createRng;
var _seedrandom = _interopRequireDefault$1(seedrandom);
function _interopRequireDefault$1(t) {
  return t && t.__esModule ? t : { default: t };
}
var singletonRandom = /* @__PURE__ */ (0, _seedrandom.default)(Date.now());
function createRng(t) {
  var r;
  function n(s) {
    r = s === null ? singletonRandom : (0, _seedrandom.default)(String(s));
  }
  n(t);
  function a() {
    return r();
  }
  return a;
}
Object.defineProperty(pickRandom, "__esModule", {
  value: !0
});
pickRandom.createPickRandom = void 0;
var _array$4 = array, _factory$A = factory$1, _is$q = is, _seededRNG$2 = seededRNG, name$x = "pickRandom", dependencies$w = ["typed", "config", "?on"], createPickRandom = /* @__PURE__ */ (0, _factory$A.factory)(name$x, dependencies$w, function(t) {
  var r = t.typed, n = t.config, a = t.on, s = (0, _seededRNG$2.createRng)(n.randomSeed);
  return a && a("config", function(c, l) {
    c.randomSeed !== l.randomSeed && (s = (0, _seededRNG$2.createRng)(c.randomSeed));
  }), r({
    "Array | Matrix": function(l) {
      return o(l, {});
    },
    "Array | Matrix, Object": function(l, d) {
      return o(l, d);
    },
    "Array | Matrix, number": function(l, d) {
      return o(l, {
        number: d
      });
    },
    "Array | Matrix, Array | Matrix": function(l, d) {
      return o(l, {
        weights: d
      });
    },
    "Array | Matrix, Array | Matrix, number": function(l, d, h) {
      return o(l, {
        number: h,
        weights: d
      });
    },
    "Array | Matrix, number, Array | Matrix": function(l, d, h) {
      return o(l, {
        number: d,
        weights: h
      });
    }
  });
  function o(c, l) {
    var d = l.number, h = l.weights, u = l.elementWise, p = u === void 0 ? !0 : u, m = typeof d > "u";
    m && (d = 1);
    var g = (0, _is$q.isMatrix)(c) ? c.create : (0, _is$q.isMatrix)(h) ? h.create : null;
    c = c.valueOf(), h && (h = h.valueOf()), p === !0 && (c = (0, _array$4.flatten)(c), h = (0, _array$4.flatten)(h));
    var v = 0;
    if (typeof h < "u") {
      if (h.length !== c.length)
        throw new Error("Weights must have the same length as possibles");
      for (var y = 0, x = h.length; y < x; y++) {
        if (!(0, _is$q.isNumber)(h[y]) || h[y] < 0)
          throw new Error("Weights must be an array of positive numbers");
        v += h[y];
      }
    }
    for (var _ = c.length, $ = [], b; $.length < d; ) {
      if (typeof h > "u")
        b = c[Math.floor(s() * _)];
      else
        for (var M = s() * v, C = 0, S = c.length; C < S; C++)
          if (M -= h[C], M < 0) {
            b = c[C];
            break;
          }
      $.push(b);
    }
    return m ? $[0] : g ? g($) : $;
  }
});
pickRandom.createPickRandom = createPickRandom;
var random = {}, randomMatrix$1 = {};
Object.defineProperty(randomMatrix$1, "__esModule", {
  value: !0
});
randomMatrix$1.randomMatrix = randomMatrix;
function randomMatrix(t, r) {
  var n = [];
  if (t = t.slice(0), t.length > 1)
    for (var a = 0, s = t.shift(); a < s; a++)
      n.push(randomMatrix(t, r));
  else
    for (var o = 0, c = t.shift(); o < c; o++)
      n.push(r());
  return n;
}
Object.defineProperty(random, "__esModule", {
  value: !0
});
random.createRandomNumber = random.createRandom = void 0;
var _factory$z = factory$1, _is$p = is, _seededRNG$1 = seededRNG, _randomMatrix2 = randomMatrix$1, name$w = "random", dependencies$v = ["typed", "config", "?on"], createRandom = /* @__PURE__ */ (0, _factory$z.factory)(name$w, dependencies$v, function(t) {
  var r = t.typed, n = t.config, a = t.on, s = (0, _seededRNG$1.createRng)(n.randomSeed);
  return a && a("config", function(l, d) {
    l.randomSeed !== d.randomSeed && (s = (0, _seededRNG$1.createRng)(l.randomSeed));
  }), r(name$w, {
    "": function() {
      return c(0, 1);
    },
    number: function(d) {
      return c(0, d);
    },
    "number, number": function(d, h) {
      return c(d, h);
    },
    "Array | Matrix": function(d) {
      return o(d, 0, 1);
    },
    "Array | Matrix, number": function(d, h) {
      return o(d, 0, h);
    },
    "Array | Matrix, number, number": function(d, h, u) {
      return o(d, h, u);
    }
  });
  function o(l, d, h) {
    var u = (0, _randomMatrix2.randomMatrix)(l.valueOf(), function() {
      return c(d, h);
    });
    return (0, _is$p.isMatrix)(l) ? l.create(u) : u;
  }
  function c(l, d) {
    return l + s() * (d - l);
  }
});
random.createRandom = createRandom;
var createRandomNumber = /* @__PURE__ */ (0, _factory$z.factory)(name$w, ["typed", "config", "?on"], function(t) {
  var r = t.typed, n = t.config, a = t.on;
  t.matrix;
  var s = (0, _seededRNG$1.createRng)(n.randomSeed);
  return a && a("config", function(c, l) {
    c.randomSeed !== l.randomSeed && (s = (0, _seededRNG$1.createRng)(c.randomSeed));
  }), r(name$w, {
    "": function() {
      return o(0, 1);
    },
    number: function(l) {
      return o(0, l);
    },
    "number, number": function(l, d) {
      return o(l, d);
    }
  });
  function o(c, l) {
    return c + s() * (l - c);
  }
});
random.createRandomNumber = createRandomNumber;
var randomInt = {};
Object.defineProperty(randomInt, "__esModule", {
  value: !0
});
randomInt.createRandomInt = void 0;
var _factory$y = factory$1, _randomMatrix = randomMatrix$1, _seededRNG = seededRNG, _is$o = is, name$v = "randomInt", dependencies$u = ["typed", "config", "?on"], createRandomInt = /* @__PURE__ */ (0, _factory$y.factory)(name$v, dependencies$u, function(t) {
  var r = t.typed, n = t.config, a = t.on, s = (0, _seededRNG.createRng)(n.randomSeed);
  return a && a("config", function(l, d) {
    l.randomSeed !== d.randomSeed && (s = (0, _seededRNG.createRng)(l.randomSeed));
  }), r(name$v, {
    "": function() {
      return c(0, 1);
    },
    number: function(d) {
      return c(0, d);
    },
    "number, number": function(d, h) {
      return c(d, h);
    },
    "Array | Matrix": function(d) {
      return o(d, 0, 1);
    },
    "Array | Matrix, number": function(d, h) {
      return o(d, 0, h);
    },
    "Array | Matrix, number, number": function(d, h, u) {
      return o(d, h, u);
    }
  });
  function o(l, d, h) {
    var u = (0, _randomMatrix.randomMatrix)(l.valueOf(), function() {
      return c(d, h);
    });
    return (0, _is$o.isMatrix)(l) ? l.create(u) : u;
  }
  function c(l, d) {
    return Math.floor(l + s() * (d - l));
  }
});
randomInt.createRandomInt = createRandomInt;
var stirlingS2 = {};
Object.defineProperty(stirlingS2, "__esModule", {
  value: !0
});
stirlingS2.createStirlingS2 = void 0;
var _factory$x = factory$1, name$u = "stirlingS2", dependencies$t = ["typed", "addScalar", "subtract", "multiplyScalar", "divideScalar", "pow", "factorial", "combinations", "isNegative", "isInteger", "larger"], createStirlingS2 = /* @__PURE__ */ (0, _factory$x.factory)(name$u, dependencies$t, function(t) {
  var r = t.typed, n = t.addScalar, a = t.subtract, s = t.multiplyScalar, o = t.divideScalar, c = t.pow, l = t.factorial, d = t.combinations, h = t.isNegative, u = t.isInteger, p = t.larger;
  return r(name$u, {
    "number | BigNumber, number | BigNumber": function(g, v) {
      if (!u(g) || h(g) || !u(v) || h(v))
        throw new TypeError("Non-negative integer value expected in function stirlingS2");
      if (p(v, g))
        throw new TypeError("k must be less than or equal to n in function stirlingS2");
      for (var y = l(v), x = 0, _ = 0; _ <= v; _++) {
        var $ = c(-1, a(v, _)), b = d(v, _), M = c(_, g);
        x = n(x, s(s(b, M), $));
      }
      return o(x, y);
    }
  });
});
stirlingS2.createStirlingS2 = createStirlingS2;
var bellNumbers = {};
Object.defineProperty(bellNumbers, "__esModule", {
  value: !0
});
bellNumbers.createBellNumbers = void 0;
var _factory$w = factory$1, name$t = "bellNumbers", dependencies$s = ["typed", "addScalar", "isNegative", "isInteger", "stirlingS2"], createBellNumbers = /* @__PURE__ */ (0, _factory$w.factory)(name$t, dependencies$s, function(t) {
  var r = t.typed, n = t.addScalar, a = t.isNegative, s = t.isInteger, o = t.stirlingS2;
  return r(name$t, {
    "number | BigNumber": function(l) {
      if (!s(l) || a(l))
        throw new TypeError("Non-negative integer value expected in function bellNumbers");
      for (var d = 0, h = 0; h <= l; h++)
        d = n(d, o(l, h));
      return d;
    }
  });
});
bellNumbers.createBellNumbers = createBellNumbers;
var catalan = {};
Object.defineProperty(catalan, "__esModule", {
  value: !0
});
catalan.createCatalan = void 0;
var _factory$v = factory$1, name$s = "catalan", dependencies$r = ["typed", "addScalar", "divideScalar", "multiplyScalar", "combinations", "isNegative", "isInteger"], createCatalan = /* @__PURE__ */ (0, _factory$v.factory)(name$s, dependencies$r, function(t) {
  var r = t.typed, n = t.addScalar, a = t.divideScalar, s = t.multiplyScalar, o = t.combinations, c = t.isNegative, l = t.isInteger;
  return r(name$s, {
    "number | BigNumber": function(h) {
      if (!l(h) || c(h))
        throw new TypeError("Non-negative integer value expected in function catalan");
      return a(o(s(h, 2), h), n(h, 1));
    }
  });
});
catalan.createCatalan = createCatalan;
var composition = {};
Object.defineProperty(composition, "__esModule", {
  value: !0
});
composition.createComposition = void 0;
var _factory$u = factory$1, name$r = "composition", dependencies$q = ["typed", "addScalar", "combinations", "isNegative", "isPositive", "isInteger", "larger"], createComposition = /* @__PURE__ */ (0, _factory$u.factory)(name$r, dependencies$q, function(t) {
  var r = t.typed, n = t.addScalar, a = t.combinations, s = t.isPositive;
  t.isNegative;
  var o = t.isInteger, c = t.larger;
  return r(name$r, {
    "number | BigNumber, number | BigNumber": function(d, h) {
      if (!o(d) || !s(d) || !o(h) || !s(h))
        throw new TypeError("Positive integer value expected in function composition");
      if (c(h, d))
        throw new TypeError("k must be less than or equal to n in function composition");
      return a(n(d, -1), n(h, -1));
    }
  });
});
composition.createComposition = createComposition;
var simplify = {}, util = {};
Object.defineProperty(util, "__esModule", {
  value: !0
});
util.createUtil = void 0;
var _is$n = is, _factory$t = factory$1, _object$3 = object, name$q = "simplifyUtil", dependencies$p = ["FunctionNode", "OperatorNode", "SymbolNode"], createUtil = /* @__PURE__ */ (0, _factory$t.factory)(name$q, dependencies$p, function(t) {
  var r = t.FunctionNode, n = t.OperatorNode, a = t.SymbolNode, s = {
    add: !0,
    multiply: !0
  }, o = {
    add: !0,
    multiply: !0
  };
  function c(g, v) {
    if (!(0, _is$n.isOperatorNode)(g))
      return !0;
    var y = g.fn.toString();
    return v && (0, _object$3.hasOwnProperty)(v, y) && (0, _object$3.hasOwnProperty)(v[y], "commutative") ? v[y].commutative : s[y] || !1;
  }
  function l(g, v) {
    if (!(0, _is$n.isOperatorNode)(g))
      return !1;
    var y = g.fn.toString();
    return v && (0, _object$3.hasOwnProperty)(v, y) && (0, _object$3.hasOwnProperty)(v[y], "associative") ? v[y].associative : o[y] || !1;
  }
  function d(g) {
    if (!g.args || g.args.length === 0)
      return g;
    g.args = h(g);
    for (var v = 0; v < g.args.length; v++)
      d(g.args[v]);
  }
  function h(g) {
    var v, y = [], x = function _($) {
      for (var b = 0; b < $.args.length; b++) {
        var M = $.args[b];
        (0, _is$n.isOperatorNode)(M) && v === M.op ? _(M) : y.push(M);
      }
    };
    return l(g) ? (v = g.op, x(g), y) : g.args;
  }
  function u(g) {
    if (!(!g.args || g.args.length === 0)) {
      for (var v = m(g), y = g.args.length, x = 0; x < y; x++)
        u(g.args[x]);
      if (y > 2 && l(g)) {
        for (var _ = g.args.pop(); g.args.length > 0; )
          _ = v([g.args.pop(), _]);
        g.args = _.args;
      }
    }
  }
  function p(g) {
    if (!(!g.args || g.args.length === 0)) {
      for (var v = m(g), y = g.args.length, x = 0; x < y; x++)
        p(g.args[x]);
      if (y > 2 && l(g)) {
        for (var _ = g.args.shift(); g.args.length > 0; )
          _ = v([_, g.args.shift()]);
        g.args = _.args;
      }
    }
  }
  function m(g) {
    return (0, _is$n.isOperatorNode)(g) ? function(v) {
      try {
        return new n(g.op, g.fn, v, g.implicit);
      } catch (y) {
        return console.error(y), [];
      }
    } : function(v) {
      return new r(new a(g.name), v);
    };
  }
  return {
    createMakeNodeFunction: m,
    isCommutative: c,
    isAssociative: l,
    flatten: d,
    allChildren: h,
    unflattenr: u,
    unflattenl: p
  };
});
util.createUtil = createUtil;
var simplifyCore = {};
Object.defineProperty(simplifyCore, "__esModule", {
  value: !0
});
simplifyCore.createSimplifyCore = void 0;
var _is$m = is, _factory$s = factory$1, name$p = "simplifyCore", dependencies$o = ["equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "ConstantNode", "OperatorNode", "FunctionNode", "ParenthesisNode"], createSimplifyCore = /* @__PURE__ */ (0, _factory$s.factory)(name$p, dependencies$o, function(t) {
  var r = t.equal, n = t.isZero, a = t.add, s = t.subtract, o = t.multiply, c = t.divide, l = t.pow, d = t.ConstantNode, h = t.OperatorNode, u = t.FunctionNode, p = t.ParenthesisNode, m = new d(0), g = new d(1);
  function v(y) {
    if ((0, _is$m.isOperatorNode)(y) && y.isUnary()) {
      var x = v(y.args[0]);
      if (y.op === "+")
        return x;
      if (y.op === "-") {
        if ((0, _is$m.isOperatorNode)(x)) {
          if (x.isUnary() && x.op === "-")
            return x.args[0];
          if (x.isBinary() && x.fn === "subtract")
            return new h("-", "subtract", [x.args[1], x.args[0]]);
        }
        return new h(y.op, y.fn, [x]);
      }
    } else if ((0, _is$m.isOperatorNode)(y) && y.isBinary()) {
      var _ = v(y.args[0]), $ = v(y.args[1]);
      if (y.op === "+") {
        if ((0, _is$m.isConstantNode)(_)) {
          if (n(_.value))
            return $;
          if ((0, _is$m.isConstantNode)($))
            return new d(a(_.value, $.value));
        }
        return (0, _is$m.isConstantNode)($) && n($.value) ? _ : (0, _is$m.isOperatorNode)($) && $.isUnary() && $.op === "-" ? new h("-", "subtract", [_, $.args[0]]) : new h(y.op, y.fn, $ ? [_, $] : [_]);
      } else if (y.op === "-") {
        if ((0, _is$m.isConstantNode)(_) && $) {
          if ((0, _is$m.isConstantNode)($))
            return new d(s(_.value, $.value));
          if (n(_.value))
            return new h("-", "unaryMinus", [$]);
        }
        if (y.fn === "subtract")
          return (0, _is$m.isConstantNode)($) && n($.value) ? _ : (0, _is$m.isOperatorNode)($) && $.isUnary() && $.op === "-" ? v(new h("+", "add", [_, $.args[0]])) : new h(y.op, y.fn, [_, $]);
      } else if (y.op === "*") {
        if ((0, _is$m.isConstantNode)(_)) {
          if (n(_.value))
            return m;
          if (r(_.value, 1))
            return $;
          if ((0, _is$m.isConstantNode)($))
            return new d(o(_.value, $.value));
        }
        if ((0, _is$m.isConstantNode)($)) {
          if (n($.value))
            return m;
          if (r($.value, 1))
            return _;
          if ((0, _is$m.isOperatorNode)(_) && _.isBinary() && _.op === y.op) {
            var b = _.args[0];
            if ((0, _is$m.isConstantNode)(b)) {
              var M = new d(o(b.value, $.value));
              return new h(y.op, y.fn, [M, _.args[1]], y.implicit);
            }
          }
          return new h(y.op, y.fn, [$, _], y.implicit);
        }
        return new h(y.op, y.fn, [_, $], y.implicit);
      } else if (y.op === "/") {
        if ((0, _is$m.isConstantNode)(_)) {
          if (n(_.value))
            return m;
          if ((0, _is$m.isConstantNode)($) && (r($.value, 1) || r($.value, 2) || r($.value, 4)))
            return new d(c(_.value, $.value));
        }
        return new h(y.op, y.fn, [_, $]);
      } else if (y.op === "^") {
        if ((0, _is$m.isConstantNode)($)) {
          if (n($.value))
            return g;
          if (r($.value, 1))
            return _;
          if ((0, _is$m.isConstantNode)(_))
            return new d(l(_.value, $.value));
          if ((0, _is$m.isOperatorNode)(_) && _.isBinary() && _.op === "^") {
            var C = _.args[1];
            if ((0, _is$m.isConstantNode)(C))
              return new h(y.op, y.fn, [_.args[0], new d(o(C.value, $.value))]);
          }
        }
        return new h(y.op, y.fn, [_, $]);
      }
    } else if ((0, _is$m.isParenthesisNode)(y)) {
      var S = v(y.content);
      return (0, _is$m.isParenthesisNode)(S) || (0, _is$m.isSymbolNode)(S) || (0, _is$m.isConstantNode)(S) ? S : new p(S);
    } else if ((0, _is$m.isFunctionNode)(y)) {
      var A = y.args.map(v).map(function(D) {
        return (0, _is$m.isParenthesisNode)(D) ? D.content : D;
      });
      return new u(v(y.fn), A);
    }
    return y;
  }
  return v;
});
simplifyCore.createSimplifyCore = createSimplifyCore;
var simplifyConstant = {};
Object.defineProperty(simplifyConstant, "__esModule", {
  value: !0
});
simplifyConstant.createSimplifyConstant = void 0;
var _is$l = is, _factory$r = factory$1, _util$1 = util, _noop = noop$3, name$o = "simplifyConstant", dependencies$n = ["typed", "config", "mathWithTransform", "?fraction", "?bignumber", "ConstantNode", "OperatorNode", "FunctionNode", "SymbolNode"], createSimplifyConstant = /* @__PURE__ */ (0, _factory$r.factory)(name$o, dependencies$n, function(t) {
  var r = t.typed, n = t.config, a = t.mathWithTransform, s = t.fraction, o = t.bignumber, c = t.ConstantNode, l = t.OperatorNode, d = t.FunctionNode, h = t.SymbolNode, u = (0, _util$1.createUtil)({
    FunctionNode: d,
    OperatorNode: l,
    SymbolNode: h
  }), p = u.isCommutative, m = u.isAssociative, g = u.allChildren, v = u.createMakeNodeFunction;
  function y(D, N) {
    var T = A(D, N);
    return (0, _is$l.isNode)(T) ? T : _(T);
  }
  function x(D, N, T) {
    try {
      return b(a[D].apply(null, N), T);
    } catch {
      return N = N.map(function(F) {
        return (0, _is$l.isFraction)(F) ? F.valueOf() : F;
      }), b(a[D].apply(null, N), T);
    }
  }
  var _ = r({
    Fraction: C,
    number: function(N) {
      return N < 0 ? M(new c(-N)) : new c(N);
    },
    BigNumber: function(N) {
      return N < 0 ? M(new c(-N)) : new c(N);
    },
    Complex: function(N) {
      throw new Error("Cannot convert Complex number to Node");
    }
  });
  function $(D, N) {
    var T = N && N.exactFractions !== !1;
    if (T && isFinite(D) && s) {
      var R = s(D), F = N && typeof N.fractionsLimit == "number" ? N.fractionsLimit : 1 / 0;
      if (R.valueOf() === D && R.n < F && R.d < F)
        return R;
    }
    return D;
  }
  var b = r({
    "string, Object": function(N, T) {
      if (n.number === "BigNumber")
        return o === void 0 && (0, _noop.noBignumber)(), o(N);
      if (n.number === "Fraction")
        return s === void 0 && (0, _noop.noFraction)(), s(N);
      var R = parseFloat(N);
      return $(R, T);
    },
    "Fraction, Object": function(N, T) {
      return N;
    },
    // we don't need options here
    "BigNumber, Object": function(N, T) {
      return N;
    },
    // we don't need options here
    "number, Object": function(N, T) {
      return $(N, T);
    },
    "Complex, Object": function(N, T) {
      return N.im !== 0 ? N : $(N.re, T);
    }
  });
  function M(D) {
    return new l("-", "unaryMinus", [D]);
  }
  function C(D) {
    var N, T = D.s * D.n;
    return T < 0 ? N = new l("-", "unaryMinus", [new c(-T)]) : N = new c(T), D.d === 1 ? N : new l("/", "divide", [N, new c(D.d)]);
  }
  function S(D, N, T, R) {
    return N.reduce(function(F, z) {
      if (!(0, _is$l.isNode)(F) && !(0, _is$l.isNode)(z)) {
        try {
          return x(D, [F, z], R);
        } catch {
        }
        F = _(F), z = _(z);
      } else
        (0, _is$l.isNode)(F) ? (0, _is$l.isNode)(z) || (z = _(z)) : F = _(F);
      return T([F, z]);
    });
  }
  function A(D, N) {
    switch (D.type) {
      case "SymbolNode":
        return D;
      case "ConstantNode":
        return typeof D.value == "number" || !isNaN(D.value) ? b(D.value, N) : D;
      case "FunctionNode":
        if (a[D.name] && a[D.name].rawArgs)
          return D;
        {
          var T = ["add", "multiply"];
          if (T.indexOf(D.name) === -1) {
            var R = D.args.map(function(L) {
              return A(L, N);
            });
            if (!R.some(_is$l.isNode))
              try {
                return x(D.name, R, N);
              } catch {
              }
            return R = R.map(function(L) {
              return (0, _is$l.isNode)(L) ? L : _(L);
            }), new d(D.name, R);
          }
        }
      case "OperatorNode": {
        var F = D.fn.toString(), z, O, G = v(D);
        if ((0, _is$l.isOperatorNode)(D) && D.isUnary())
          z = [A(D.args[0], N)], (0, _is$l.isNode)(z[0]) ? O = G(z) : O = x(F, z, N);
        else if (m(D))
          if (z = g(D), z = z.map(function(L) {
            return A(L, N);
          }), p(F)) {
            for (var I = [], k = [], B = 0; B < z.length; B++)
              (0, _is$l.isNode)(z[B]) ? k.push(z[B]) : I.push(z[B]);
            I.length > 1 ? (O = S(F, I, G, N), k.unshift(O), O = S(F, k, G, N)) : O = S(F, z, G, N);
          } else
            O = S(F, z, G, N);
        else
          z = D.args.map(function(L) {
            return A(L, N);
          }), O = S(F, z, G, N);
        return O;
      }
      case "ParenthesisNode":
        return A(D.content, N);
      case "AccessorNode":
      case "ArrayNode":
      case "AssignmentNode":
      case "BlockNode":
      case "FunctionAssignmentNode":
      case "IndexNode":
      case "ObjectNode":
      case "RangeNode":
      case "ConditionalNode":
      default:
        throw new Error("Unimplemented node type in simplifyConstant: ".concat(D.type));
    }
  }
  return y;
});
simplifyConstant.createSimplifyConstant = createSimplifyConstant;
var resolve = {};
Object.defineProperty(resolve, "__esModule", {
  value: !0
});
resolve.createResolve = void 0;
var _is$k = is, _factory$q = factory$1, name$n = "resolve", dependencies$m = ["parse", "FunctionNode", "OperatorNode", "ParenthesisNode"], createResolve = /* @__PURE__ */ (0, _factory$q.factory)(name$n, dependencies$m, function(t) {
  var r = t.parse, n = t.FunctionNode, a = t.OperatorNode, s = t.ParenthesisNode;
  function o(c, l) {
    if (!l)
      return c;
    if ((0, _is$k.isSymbolNode)(c)) {
      var d = l[c.name];
      if ((0, _is$k.isNode)(d))
        return o(d, l);
      if (typeof d == "number")
        return r(String(d));
    } else if ((0, _is$k.isOperatorNode)(c)) {
      var h = c.args.map(function(p) {
        return o(p, l);
      });
      return new a(c.op, c.fn, h, c.implicit);
    } else {
      if ((0, _is$k.isParenthesisNode)(c))
        return new s(o(c.content, l));
      if ((0, _is$k.isFunctionNode)(c)) {
        var u = c.args.map(function(p) {
          return o(p, l);
        });
        return new n(c.name, u);
      }
    }
    return c;
  }
  return o;
});
resolve.createResolve = createResolve;
Object.defineProperty(simplify, "__esModule", {
  value: !0
});
simplify.createSimplify = void 0;
var _is$j = is, _factory$p = factory$1, _util = util, _simplifyCore$1 = simplifyCore, _simplifyConstant$1 = simplifyConstant, _resolve = resolve, _object$2 = object;
function _typeof$5(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(n) {
    return typeof n;
  } : _typeof$5 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$5(t);
}
var name$m = "simplify", dependencies$l = ["config", "typed", "parse", "add", "subtract", "multiply", "divide", "pow", "isZero", "equal", "?fraction", "?bignumber", "mathWithTransform", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createSimplify = /* @__PURE__ */ (0, _factory$p.factory)(name$m, dependencies$l, function(t) {
  var r = t.config, n = t.typed, a = t.parse, s = t.add, o = t.subtract, c = t.multiply, l = t.divide, d = t.pow, h = t.isZero, u = t.equal, p = t.fraction, m = t.bignumber, g = t.mathWithTransform, v = t.ConstantNode, y = t.FunctionNode, x = t.OperatorNode, _ = t.ParenthesisNode, $ = t.SymbolNode, b = (0, _simplifyConstant$1.createSimplifyConstant)({
    typed: n,
    config: r,
    mathWithTransform: g,
    fraction: p,
    bignumber: m,
    ConstantNode: v,
    OperatorNode: x,
    FunctionNode: y,
    SymbolNode: $
  }), M = (0, _simplifyCore$1.createSimplifyCore)({
    equal: u,
    isZero: h,
    add: s,
    subtract: o,
    multiply: c,
    divide: l,
    pow: d,
    ConstantNode: v,
    OperatorNode: x,
    FunctionNode: y,
    ParenthesisNode: _
  }), C = (0, _resolve.createResolve)({
    parse: a,
    FunctionNode: y,
    OperatorNode: x,
    ParenthesisNode: _
  }), S = (0, _util.createUtil)({
    FunctionNode: y,
    OperatorNode: x,
    SymbolNode: $
  }), A = S.isCommutative, D = S.isAssociative, N = S.flatten, T = S.unflattenr, R = S.unflattenl, F = S.createMakeNodeFunction, z = n("simplify", {
    string: function(se) {
      return this(a(se), this.rules, {}, {});
    },
    "string, Object": function(se, nr) {
      return this(a(se), this.rules, nr, {});
    },
    "string, Object, Object": function(se, nr, ce) {
      return this(a(se), this.rules, nr, ce);
    },
    "string, Array": function(se, nr) {
      return this(a(se), nr, {}, {});
    },
    "string, Array, Object": function(se, nr, ce) {
      return this(a(se), nr, ce, {});
    },
    "string, Array, Object, Object": function(se, nr, ce, oe) {
      return this(a(se), nr, ce, oe);
    },
    "Node, Object": function(se, nr) {
      return this(se, this.rules, nr, {});
    },
    "Node, Object, Object": function(se, nr, ce) {
      return this(se, this.rules, nr, ce);
    },
    Node: function(se) {
      return this(se, this.rules, {}, {});
    },
    "Node, Array": function(se, nr) {
      return this(se, nr, {}, {});
    },
    "Node, Array, Object": function(se, nr, ce) {
      return this(se, nr, ce, {});
    },
    "Node, Array, Object, Object": function(se, nr, ce, oe) {
      nr = I(nr);
      var ur = C(se, ce);
      ur = O(ur);
      for (var ir = {}, _r = ur.toString({
        parenthesis: "all"
      }); !ir[_r]; ) {
        ir[_r] = !0, k = 0;
        for (var yr = 0; yr < nr.length; yr++)
          typeof nr[yr] == "function" ? ur = nr[yr](ur, oe) : (N(ur), ur = L(ur, nr[yr])), R(ur);
        _r = ur.toString({
          parenthesis: "all"
        });
      }
      return ur;
    }
  });
  z.simplifyCore = M, z.resolve = C;
  function O(ee) {
    return ee.transform(function(se, nr, ce) {
      return (0, _is$j.isParenthesisNode)(se) ? O(se.content) : se;
    });
  }
  var G = {
    true: !0,
    false: !0,
    e: !0,
    i: !0,
    Infinity: !0,
    LN2: !0,
    LN10: !0,
    LOG2E: !0,
    LOG10E: !0,
    NaN: !0,
    phi: !0,
    pi: !0,
    SQRT1_2: !0,
    SQRT2: !0,
    tau: !0
    // null: false,
    // undefined: false,
    // version: false,
  };
  z.rules = [
    M,
    // { l: 'n+0', r: 'n' },     // simplifyCore
    // { l: 'n^0', r: '1' },     // simplifyCore
    // { l: '0*n', r: '0' },     // simplifyCore
    // { l: 'n/n', r: '1'},      // simplifyCore
    // { l: 'n^1', r: 'n' },     // simplifyCore
    // { l: '+n1', r:'n1' },     // simplifyCore
    // { l: 'n--n1', r:'n+n1' }, // simplifyCore
    {
      l: "log(e)",
      r: "1"
    },
    // temporary rules
    {
      l: "n-n1",
      r: "n+-n1"
    },
    // temporarily replace 'subtract' so we can further flatten the 'add' operator
    {
      l: "-(c*v)",
      r: "(-c) * v"
    },
    // make non-constant terms positive
    {
      l: "-v",
      r: "(-1) * v"
    },
    {
      l: "n/n1^n2",
      r: "n*n1^-n2"
    },
    // temporarily replace 'divide' so we can further flatten the 'multiply' operator
    {
      l: "n/n1",
      r: "n*n1^-1"
    },
    // expand nested exponentiation
    {
      l: "(n ^ n1) ^ n2",
      r: "n ^ (n1 * n2)"
    },
    // collect like factors
    {
      l: "n*n",
      r: "n^2"
    },
    {
      l: "n * n^n1",
      r: "n^(n1+1)"
    },
    {
      l: "n^n1 * n^n2",
      r: "n^(n1+n2)"
    },
    // collect like terms
    {
      l: "n+n",
      r: "2*n"
    },
    {
      l: "n+-n",
      r: "0"
    },
    {
      l: "n1*n2 + n2",
      r: "(n1+1)*n2"
    },
    {
      l: "n1*n3 + n2*n3",
      r: "(n1+n2)*n3"
    },
    // remove parenthesis in the case of negating a quantitiy
    {
      l: "n1 + -1 * (n2 + n3)",
      r: "n1 + -1 * n2 + -1 * n3"
    },
    b,
    {
      l: "(-n)*n1",
      r: "-(n*n1)"
    },
    // make factors positive (and undo 'make non-constant terms positive')
    // ordering of constants
    {
      l: "c+v",
      r: "v+c",
      context: {
        add: {
          commutative: !1
        }
      }
    },
    {
      l: "v*c",
      r: "c*v",
      context: {
        multiply: {
          commutative: !1
        }
      }
    },
    // undo temporary rules
    // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
    {
      l: "n+-n1",
      r: "n-n1"
    },
    // undo replace 'subtract'
    {
      l: "n*(n1^-1)",
      r: "n/n1"
    },
    // undo replace 'divide'
    {
      l: "n*n1^-n2",
      r: "n/n1^n2"
    },
    {
      l: "n1^-1",
      r: "1/n1"
    },
    {
      l: "n*(n1/n2)",
      r: "(n*n1)/n2"
    },
    // '*' before '/'
    {
      l: "n-(n1+n2)",
      r: "n-n1-n2"
    },
    // '-' before '+'
    // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
    // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
    {
      l: "1*n",
      r: "n"
    },
    // this pattern can be produced by simplifyConstant
    {
      l: "n1/(n2/n3)",
      r: "(n1*n3)/n2"
    }
  ];
  function I(ee) {
    for (var se = [], nr = 0; nr < ee.length; nr++) {
      var ce = ee[nr], oe = void 0, ur = _typeof$5(ce);
      switch (ur) {
        case "string": {
          var ir = ce.split("->");
          if (ir.length === 2)
            ce = {
              l: ir[0],
              r: ir[1]
            };
          else
            throw SyntaxError("Could not parse rule: " + ce);
        }
        case "object":
          if (oe = {
            l: O(a(ce.l)),
            r: O(a(ce.r))
          }, ce.context && (oe.evaluate = ce.context), ce.evaluate && (oe.evaluate = a(ce.evaluate)), D(oe.l)) {
            var _r = F(oe.l), yr = B();
            oe.expanded = {}, oe.expanded.l = _r([oe.l.clone(), yr]), N(oe.expanded.l), T(oe.expanded.l), oe.expanded.r = _r([oe.r, yr]);
          }
          break;
        case "function":
          oe = ce;
          break;
        default:
          throw TypeError("Unsupported type of rule: " + ur);
      }
      se.push(oe);
    }
    return se;
  }
  var k = 0;
  function B() {
    return new $("_p" + k++);
  }
  var L = n("applyRule", {
    "Node, Object": function(se, nr) {
      var ce = se;
      if (ce instanceof x || ce instanceof y) {
        if (ce.args)
          for (var oe = 0; oe < ce.args.length; oe++)
            ce.args[oe] = L(ce.args[oe], nr);
      } else
        ce instanceof _ && ce.content && (ce.content = L(ce.content, nr));
      var ur = nr.r, ir = Z(nr.l, ce)[0];
      if (!ir && nr.expanded && (ur = nr.expanded.r, ir = Z(nr.expanded.l, ce)[0]), ir) {
        var _r = ce.implicit;
        ce = ur.clone(), _r && "implicit" in ur && (ce.implicit = !0), ce = ce.transform(function(yr) {
          return yr.isSymbolNode && (0, _object$2.hasOwnProperty)(ir.placeholders, yr.name) ? ir.placeholders[yr.name].clone() : yr;
        });
      }
      return ce;
    }
  });
  function V(ee, se) {
    var nr = [], ce, oe, ur = F(ee);
    if (A(ee, se))
      for (var ir = 0; ir < ee.args.length; ir++)
        oe = ee.args.slice(0), oe.splice(ir, 1), ce = oe.length === 1 ? oe[0] : ur(oe), nr.push(ur([ee.args[ir], ce]));
    else
      oe = ee.args.slice(1), ce = oe.length === 1 ? oe[0] : ur(oe), nr.push(ur([ee.args[0], ce]));
    return nr;
  }
  function U(ee, se) {
    var nr = {
      placeholders: {}
    };
    if (!ee.placeholders && !se.placeholders)
      return nr;
    if (ee.placeholders) {
      if (!se.placeholders)
        return ee;
    } else
      return se;
    for (var ce in ee.placeholders)
      if ((0, _object$2.hasOwnProperty)(ee.placeholders, ce) && (nr.placeholders[ce] = ee.placeholders[ce], (0, _object$2.hasOwnProperty)(se.placeholders, ce) && !ae(ee.placeholders[ce], se.placeholders[ce])))
        return null;
    for (var oe in se.placeholders)
      (0, _object$2.hasOwnProperty)(se.placeholders, oe) && (nr.placeholders[oe] = se.placeholders[oe]);
    return nr;
  }
  function J(ee, se) {
    var nr = [];
    if (ee.length === 0 || se.length === 0)
      return nr;
    for (var ce, oe = 0; oe < ee.length; oe++)
      for (var ur = 0; ur < se.length; ur++)
        ce = U(ee[oe], se[ur]), ce && nr.push(ce);
    return nr;
  }
  function q(ee) {
    if (ee.length === 0)
      return ee;
    for (var se = ee.reduce(J), nr = [], ce = {}, oe = 0; oe < se.length; oe++) {
      var ur = JSON.stringify(se[oe]);
      ce[ur] || (ce[ur] = !0, nr.push(se[oe]));
    }
    return nr;
  }
  function Z(ee, se, nr) {
    var ce = [{
      placeholders: {}
    }];
    if (ee instanceof x && se instanceof x || ee instanceof y && se instanceof y) {
      if (ee instanceof x) {
        if (ee.op !== se.op || ee.fn !== se.fn)
          return [];
      } else if (ee instanceof y && ee.name !== se.name)
        return [];
      if (se.args.length === 1 && ee.args.length === 1 || !D(se) || nr) {
        for (var oe = [], ur = 0; ur < ee.args.length; ur++) {
          var ir = Z(ee.args[ur], se.args[ur]);
          if (ir.length === 0)
            return [];
          oe.push(ir);
        }
        ce = q(oe);
      } else if (se.args.length >= 2 && ee.args.length === 2) {
        for (var _r = V(se, ee.context), yr = [], ne = 0; ne < _r.length; ne++) {
          var pe = Z(ee, _r[ne], !0);
          yr = yr.concat(pe);
        }
        return yr;
      } else {
        if (ee.args.length > 2)
          throw Error("Unexpected non-binary associative function: " + ee.toString());
        return [];
      }
    } else if (ee instanceof $) {
      if (ee.name.length === 0)
        throw new Error("Symbol in rule has 0 length...!?");
      if (G[ee.name]) {
        if (ee.name !== se.name)
          return [];
      } else if (ee.name[0] === "n" || ee.name.substring(0, 2) === "_p")
        ce[0].placeholders[ee.name] = se;
      else if (ee.name[0] === "v")
        if (!(0, _is$j.isConstantNode)(se))
          ce[0].placeholders[ee.name] = se;
        else
          return [];
      else if (ee.name[0] === "c")
        if (se instanceof v)
          ce[0].placeholders[ee.name] = se;
        else
          return [];
      else
        throw new Error("Invalid symbol in rule: " + ee.name);
    } else if (ee instanceof v) {
      if (!u(ee.value, se.value))
        return [];
    } else
      return [];
    return ce;
  }
  function ae(ee, se) {
    if (ee instanceof v && se instanceof v) {
      if (!u(ee.value, se.value))
        return !1;
    } else if (ee instanceof $ && se instanceof $) {
      if (ee.name !== se.name)
        return !1;
    } else if (ee instanceof x && se instanceof x || ee instanceof y && se instanceof y) {
      if (ee instanceof x) {
        if (ee.op !== se.op || ee.fn !== se.fn)
          return !1;
      } else if (ee instanceof y && ee.name !== se.name)
        return !1;
      if (ee.args.length !== se.args.length)
        return !1;
      for (var nr = 0; nr < ee.args.length; nr++)
        if (!ae(ee.args[nr], se.args[nr]))
          return !1;
    } else
      return !1;
    return !0;
  }
  return z;
});
simplify.createSimplify = createSimplify;
var derivative = {};
Object.defineProperty(derivative, "__esModule", {
  value: !0
});
derivative.createDerivative = void 0;
var _is$i = is, _factory$o = factory$1, name$l = "derivative", dependencies$k = ["typed", "config", "parse", "simplify", "equal", "isZero", "numeric", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createDerivative = /* @__PURE__ */ (0, _factory$o.factory)(name$l, dependencies$k, function(t) {
  var r = t.typed, n = t.config, a = t.parse, s = t.simplify, o = t.equal, c = t.isZero, l = t.numeric, d = t.ConstantNode, h = t.FunctionNode, u = t.OperatorNode, p = t.ParenthesisNode, m = t.SymbolNode, g = r("derivative", {
    "Node, SymbolNode, Object": function(M, C, S) {
      var A = {};
      y(A, M, C.name);
      var D = x(M, A);
      return S.simplify ? s(D) : D;
    },
    "Node, SymbolNode": function(M, C) {
      return this(M, C, {
        simplify: !0
      });
    },
    "string, SymbolNode": function(M, C) {
      return this(a(M), C);
    },
    "string, SymbolNode, Object": function(M, C, S) {
      return this(a(M), C, S);
    },
    "string, string": function(M, C) {
      return this(a(M), a(C));
    },
    "string, string, Object": function(M, C, S) {
      return this(a(M), a(C), S);
    },
    "Node, string": function(M, C) {
      return this(M, a(C));
    },
    "Node, string, Object": function(M, C, S) {
      return this(M, a(C), S);
    }
    // TODO: replace the 8 signatures above with 4 as soon as typed-function supports optional arguments
    /* TODO: implement and test syntax with order of derivatives -> implement as an option {order: number}
    'Node, SymbolNode, ConstantNode': function (expr, variable, {order}) {
      let res = expr
      for (let i = 0; i < order; i++) {
        let constNodes = {}
        constTag(constNodes, expr, variable.name)
        res = _derivative(res, constNodes)
      }
      return res
    }
    */
  });
  g._simplify = !0, g.toTex = function(b) {
    return v.apply(null, b.args);
  };
  var v = r("_derivTex", {
    "Node, SymbolNode": function(M, C) {
      return (0, _is$i.isConstantNode)(M) && (0, _is$i.typeOf)(M.value) === "string" ? v(a(M.value).toString(), C.toString(), 1) : v(M.toString(), C.toString(), 1);
    },
    "Node, ConstantNode": function(M, C) {
      if ((0, _is$i.typeOf)(C.value) === "string")
        return v(M, a(C.value));
      throw new Error("The second parameter to 'derivative' is a non-string constant");
    },
    "Node, SymbolNode, ConstantNode": function(M, C, S) {
      return v(M.toString(), C.name, S.value);
    },
    "string, string, number": function(M, C, S) {
      var A;
      return S === 1 ? A = "{d\\over d" + C + "}" : A = "{d^{" + S + "}\\over d" + C + "^{" + S + "}}", A + "\\left[".concat(M, "\\right]");
    }
  }), y = r("constTag", {
    "Object, ConstantNode, string": function(M, C) {
      return M[C] = !0, !0;
    },
    "Object, SymbolNode, string": function(M, C, S) {
      return C.name !== S ? (M[C] = !0, !0) : !1;
    },
    "Object, ParenthesisNode, string": function(M, C, S) {
      return y(M, C.content, S);
    },
    "Object, FunctionAssignmentNode, string": function(M, C, S) {
      return C.params.indexOf(S) === -1 ? (M[C] = !0, !0) : y(M, C.expr, S);
    },
    "Object, FunctionNode | OperatorNode, string": function(M, C, S) {
      if (C.args.length > 0) {
        for (var A = y(M, C.args[0], S), D = 1; D < C.args.length; ++D)
          A = y(M, C.args[D], S) && A;
        if (A)
          return M[C] = !0, !0;
      }
      return !1;
    }
  }), x = r("_derivative", {
    "ConstantNode, Object": function(M) {
      return $(0);
    },
    "SymbolNode, Object": function(M, C) {
      return C[M] !== void 0 ? $(0) : $(1);
    },
    "ParenthesisNode, Object": function(M, C) {
      return new p(x(M.content, C));
    },
    "FunctionAssignmentNode, Object": function(M, C) {
      return C[M] !== void 0 ? $(0) : x(M.expr, C);
    },
    "FunctionNode, Object": function(M, C) {
      if (M.args.length !== 1 && _(M), C[M] !== void 0)
        return $(0);
      var S = M.args[0], A, D = !1, N = !1, T;
      switch (M.name) {
        case "cbrt":
          D = !0, T = new u("*", "multiply", [$(3), new u("^", "pow", [S, new u("/", "divide", [$(2), $(3)])])]);
          break;
        case "sqrt":
        case "nthRoot":
          if (M.args.length === 1)
            D = !0, T = new u("*", "multiply", [$(2), new h("sqrt", [S])]);
          else if (M.args.length === 2)
            return A = new u("/", "divide", [$(1), M.args[1]]), C[A] = C[M.args[1]], x(new u("^", "pow", [S, A]), C);
          break;
        case "log10":
          A = $(10);
        case "log":
          if (!A && M.args.length === 1)
            T = S.clone(), D = !0;
          else if (M.args.length === 1 && A || M.args.length === 2 && C[M.args[1]] !== void 0)
            T = new u("*", "multiply", [S.clone(), new h("log", [A || M.args[1]])]), D = !0;
          else if (M.args.length === 2)
            return x(new u("/", "divide", [new h("log", [S]), new h("log", [M.args[1]])]), C);
          break;
        case "pow":
          return C[A] = C[M.args[1]], x(new u("^", "pow", [S, M.args[1]]), C);
        case "exp":
          T = new h("exp", [S.clone()]);
          break;
        case "sin":
          T = new h("cos", [S.clone()]);
          break;
        case "cos":
          T = new u("-", "unaryMinus", [new h("sin", [S.clone()])]);
          break;
        case "tan":
          T = new u("^", "pow", [new h("sec", [S.clone()]), $(2)]);
          break;
        case "sec":
          T = new u("*", "multiply", [M, new h("tan", [S.clone()])]);
          break;
        case "csc":
          N = !0, T = new u("*", "multiply", [M, new h("cot", [S.clone()])]);
          break;
        case "cot":
          N = !0, T = new u("^", "pow", [new h("csc", [S.clone()]), $(2)]);
          break;
        case "asin":
          D = !0, T = new h("sqrt", [new u("-", "subtract", [$(1), new u("^", "pow", [S.clone(), $(2)])])]);
          break;
        case "acos":
          D = !0, N = !0, T = new h("sqrt", [new u("-", "subtract", [$(1), new u("^", "pow", [S.clone(), $(2)])])]);
          break;
        case "atan":
          D = !0, T = new u("+", "add", [new u("^", "pow", [S.clone(), $(2)]), $(1)]);
          break;
        case "asec":
          D = !0, T = new u("*", "multiply", [new h("abs", [S.clone()]), new h("sqrt", [new u("-", "subtract", [new u("^", "pow", [S.clone(), $(2)]), $(1)])])]);
          break;
        case "acsc":
          D = !0, N = !0, T = new u("*", "multiply", [new h("abs", [S.clone()]), new h("sqrt", [new u("-", "subtract", [new u("^", "pow", [S.clone(), $(2)]), $(1)])])]);
          break;
        case "acot":
          D = !0, N = !0, T = new u("+", "add", [new u("^", "pow", [S.clone(), $(2)]), $(1)]);
          break;
        case "sinh":
          T = new h("cosh", [S.clone()]);
          break;
        case "cosh":
          T = new h("sinh", [S.clone()]);
          break;
        case "tanh":
          T = new u("^", "pow", [new h("sech", [S.clone()]), $(2)]);
          break;
        case "sech":
          N = !0, T = new u("*", "multiply", [M, new h("tanh", [S.clone()])]);
          break;
        case "csch":
          N = !0, T = new u("*", "multiply", [M, new h("coth", [S.clone()])]);
          break;
        case "coth":
          N = !0, T = new u("^", "pow", [new h("csch", [S.clone()]), $(2)]);
          break;
        case "asinh":
          D = !0, T = new h("sqrt", [new u("+", "add", [new u("^", "pow", [S.clone(), $(2)]), $(1)])]);
          break;
        case "acosh":
          D = !0, T = new h("sqrt", [new u("-", "subtract", [new u("^", "pow", [S.clone(), $(2)]), $(1)])]);
          break;
        case "atanh":
          D = !0, T = new u("-", "subtract", [$(1), new u("^", "pow", [S.clone(), $(2)])]);
          break;
        case "asech":
          D = !0, N = !0, T = new u("*", "multiply", [S.clone(), new h("sqrt", [new u("-", "subtract", [$(1), new u("^", "pow", [S.clone(), $(2)])])])]);
          break;
        case "acsch":
          D = !0, N = !0, T = new u("*", "multiply", [new h("abs", [S.clone()]), new h("sqrt", [new u("+", "add", [new u("^", "pow", [S.clone(), $(2)]), $(1)])])]);
          break;
        case "acoth":
          D = !0, N = !0, T = new u("-", "subtract", [$(1), new u("^", "pow", [S.clone(), $(2)])]);
          break;
        case "abs":
          T = new u("/", "divide", [new h(new m("abs"), [S.clone()]), S.clone()]);
          break;
        case "gamma":
        default:
          throw new Error('Function "' + M.name + '" is not supported by derivative, or a wrong number of arguments is passed');
      }
      var R, F;
      D ? (R = "/", F = "divide") : (R = "*", F = "multiply");
      var z = x(S, C);
      return N && (z = new u("-", "unaryMinus", [z])), new u(R, F, [z, T]);
    },
    "OperatorNode, Object": function(M, C) {
      if (C[M] !== void 0)
        return $(0);
      if (M.op === "+")
        return new u(M.op, M.fn, M.args.map(function(G) {
          return x(G, C);
        }));
      if (M.op === "-") {
        if (M.isUnary())
          return new u(M.op, M.fn, [x(M.args[0], C)]);
        if (M.isBinary())
          return new u(M.op, M.fn, [x(M.args[0], C), x(M.args[1], C)]);
      }
      if (M.op === "*") {
        var S = M.args.filter(function(G) {
          return C[G] !== void 0;
        });
        if (S.length > 0) {
          var A = M.args.filter(function(G) {
            return C[G] === void 0;
          }), D = A.length === 1 ? A[0] : new u("*", "multiply", A), N = S.concat(x(D, C));
          return new u("*", "multiply", N);
        }
        return new u("+", "add", M.args.map(function(G) {
          return new u("*", "multiply", M.args.map(function(I) {
            return I === G ? x(I, C) : I.clone();
          }));
        }));
      }
      if (M.op === "/" && M.isBinary()) {
        var T = M.args[0], R = M.args[1];
        return C[R] !== void 0 ? new u("/", "divide", [x(T, C), R]) : C[T] !== void 0 ? new u("*", "multiply", [new u("-", "unaryMinus", [T]), new u("/", "divide", [x(R, C), new u("^", "pow", [R.clone(), $(2)])])]) : new u("/", "divide", [new u("-", "subtract", [new u("*", "multiply", [x(T, C), R.clone()]), new u("*", "multiply", [T.clone(), x(R, C)])]), new u("^", "pow", [R.clone(), $(2)])]);
      }
      if (M.op === "^" && M.isBinary()) {
        var F = M.args[0], z = M.args[1];
        if (C[F] !== void 0)
          return (0, _is$i.isConstantNode)(F) && (c(F.value) || o(F.value, 1)) ? $(0) : new u("*", "multiply", [M, new u("*", "multiply", [new h("log", [F.clone()]), x(z.clone(), C)])]);
        if (C[z] !== void 0) {
          if ((0, _is$i.isConstantNode)(z)) {
            if (c(z.value))
              return $(0);
            if (o(z.value, 1))
              return x(F, C);
          }
          var O = new u("^", "pow", [F.clone(), new u("-", "subtract", [z, $(1)])]);
          return new u("*", "multiply", [z.clone(), new u("*", "multiply", [x(F, C), O])]);
        }
        return new u("*", "multiply", [new u("^", "pow", [F.clone(), z.clone()]), new u("+", "add", [new u("*", "multiply", [x(F, C), new u("/", "divide", [z.clone(), F.clone()])]), new u("*", "multiply", [x(z, C), new h("log", [F.clone()])])])]);
      }
      throw new Error('Operator "' + M.op + '" is not supported by derivative, or a wrong number of arguments is passed');
    }
  });
  function _(b) {
    if (!((b.name === "log" || b.name === "nthRoot" || b.name === "pow") && b.args.length === 2)) {
      for (var M = 0; M < b.args.length; ++M)
        b.args[M] = $(0);
      throw b.compile().evaluate(), new Error("Expected TypeError, but none found");
    }
  }
  function $(b, M) {
    return new d(l(b, M || n.number));
  }
  return g;
});
derivative.createDerivative = createDerivative;
var rationalize = {};
Object.defineProperty(rationalize, "__esModule", {
  value: !0
});
rationalize.createRationalize = void 0;
var _number = number$3, _factory$n = factory$1, _simplifyConstant = simplifyConstant, _simplifyCore = simplifyCore, name$k = "rationalize", dependencies$j = ["config", "typed", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "parse", "simplify", "?bignumber", "?fraction", "mathWithTransform", "ConstantNode", "OperatorNode", "FunctionNode", "SymbolNode", "ParenthesisNode"], createRationalize = /* @__PURE__ */ (0, _factory$n.factory)(name$k, dependencies$j, function(t) {
  var r = t.config, n = t.typed, a = t.equal, s = t.isZero, o = t.add, c = t.subtract, l = t.multiply, d = t.divide, h = t.pow, u = t.parse, p = t.simplify, m = t.fraction, g = t.bignumber, v = t.mathWithTransform, y = t.ConstantNode, x = t.OperatorNode, _ = t.FunctionNode, $ = t.SymbolNode, b = t.ParenthesisNode, M = (0, _simplifyConstant.createSimplifyConstant)({
    typed: n,
    config: r,
    mathWithTransform: v,
    fraction: m,
    bignumber: g,
    ConstantNode: y,
    OperatorNode: x,
    FunctionNode: _,
    SymbolNode: $
  }), C = (0, _simplifyCore.createSimplifyCore)({
    equal: a,
    isZero: s,
    add: o,
    subtract: c,
    multiply: l,
    divide: d,
    pow: h,
    ConstantNode: y,
    OperatorNode: x,
    FunctionNode: _,
    ParenthesisNode: b
  });
  return n(name$k, {
    string: function(R) {
      return this(u(R), {}, !1);
    },
    "string, boolean": function(R, F) {
      return this(u(R), {}, F);
    },
    "string, Object": function(R, F) {
      return this(u(R), F, !1);
    },
    "string, Object, boolean": function(R, F, z) {
      return this(u(R), F, z);
    },
    Node: function(R) {
      return this(R, {}, !1);
    },
    "Node, boolean": function(R, F) {
      return this(R, {}, F);
    },
    "Node, Object": function(R, F) {
      return this(R, F, !1);
    },
    "Node, Object, boolean": function(R, F, z) {
      var O = A(), G = S(R, F, !0, O.firstRules), I = G.variables.length;
      if (R = G.expression, I >= 1) {
        R = D(R);
        var k, B, L = !0, V = !1;
        R = p(R, O.firstRules, {}, {
          exactFractions: !1
        });
        for (var U; B = L ? O.distrDivRules : O.sucDivRules, R = p(R, B), L = !L, U = R.toString(), U !== k; )
          V = !0, k = U;
        V && (R = p(R, O.firstRulesAgain, {}, {
          exactFractions: !1
        })), R = p(R, O.finalRules, {}, {
          exactFractions: !1
        });
      }
      var J = [], q = {};
      return R.type === "OperatorNode" && R.isBinary() && R.op === "/" ? (I === 1 && (R.args[0] = N(R.args[0], J), R.args[1] = N(R.args[1])), z && (q.numerator = R.args[0], q.denominator = R.args[1])) : (I === 1 && (R = N(R, J)), z && (q.numerator = R, q.denominator = null)), z ? (q.coefficients = J, q.variables = G.variables, q.expression = R, q) : R;
    }
    // ^^^^^^^ end of rationalize ^^^^^^^^
  });
  function S(T, R, F, z) {
    var O = [], G = p(T, z, R, {
      exactFractions: !1
    });
    F = !!F;
    var I = "+-*" + (F ? "/" : "");
    B(G);
    var k = {};
    return k.expression = G, k.variables = O, k;
    function B(L) {
      var V = L.type;
      if (V === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (V === "OperatorNode")
        if (L.op === "^") {
          if (L.args[1].type !== "ConstantNode" || !(0, _number.isInteger)(parseFloat(L.args[1].value)))
            throw new Error("There is a non-integer exponent");
          B(L.args[0]);
        } else {
          if (I.indexOf(L.op) === -1)
            throw new Error("Operator " + L.op + " invalid in polynomial expression");
          for (var U = 0; U < L.args.length; U++)
            B(L.args[U]);
        }
      else if (V === "SymbolNode") {
        var J = L.name, q = O.indexOf(J);
        q === -1 && O.push(J);
      } else if (V === "ParenthesisNode")
        B(L.content);
      else if (V !== "ConstantNode")
        throw new Error("type " + V + " is not allowed in polynomial expression");
    }
  }
  function A() {
    var T = [
      C,
      // sCore
      {
        l: "n+n",
        r: "2*n"
      },
      {
        l: "n+-n",
        r: "0"
      },
      M,
      // sConstant
      {
        l: "n*(n1^-1)",
        r: "n/n1"
      },
      {
        l: "n*n1^-n2",
        r: "n/n1^n2"
      },
      {
        l: "n1^-1",
        r: "1/n1"
      },
      {
        l: "n*(n1/n2)",
        r: "(n*n1)/n2"
      },
      {
        l: "1*n",
        r: "n"
      }
    ], R = [
      {
        l: "(-n1)/(-n2)",
        r: "n1/n2"
      },
      // Unary division
      {
        l: "(-n1)*(-n2)",
        r: "n1*n2"
      },
      // Unary multiplication
      {
        l: "n1--n2",
        r: "n1+n2"
      },
      // '--' elimination
      {
        l: "n1-n2",
        r: "n1+(-n2)"
      },
      // Subtraction turn into add with un�ry minus
      {
        l: "(n1+n2)*n3",
        r: "(n1*n3 + n2*n3)"
      },
      // Distributive 1
      {
        l: "n1*(n2+n3)",
        r: "(n1*n2+n1*n3)"
      },
      // Distributive 2
      {
        l: "c1*n + c2*n",
        r: "(c1+c2)*n"
      },
      // Joining constants
      {
        l: "c1*n + n",
        r: "(c1+1)*n"
      },
      // Joining constants
      {
        l: "c1*n - c2*n",
        r: "(c1-c2)*n"
      },
      // Joining constants
      {
        l: "c1*n - n",
        r: "(c1-1)*n"
      },
      // Joining constants
      {
        l: "v/c",
        r: "(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "v/-c",
        r: "-(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "-v*-c",
        r: "c*v"
      },
      // Inversion constant and variable 1
      {
        l: "-v*c",
        r: "-c*v"
      },
      // Inversion constant and variable 2
      {
        l: "v*-c",
        r: "-c*v"
      },
      // Inversion constant and variable 3
      {
        l: "v*c",
        r: "c*v"
      },
      // Inversion constant and variable 4
      {
        l: "-(-n1*n2)",
        r: "(n1*n2)"
      },
      // Unary propagation
      {
        l: "-(n1*n2)",
        r: "(-n1*n2)"
      },
      // Unary propagation
      {
        l: "-(-n1+n2)",
        r: "(n1-n2)"
      },
      // Unary propagation
      {
        l: "-(n1+n2)",
        r: "(-n1-n2)"
      },
      // Unary propagation
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      },
      // Power to Power
      {
        l: "-(-n1/n2)",
        r: "(n1/n2)"
      },
      // Division and Unary
      {
        l: "-(n1/n2)",
        r: "(-n1/n2)"
      }
    ], F = [
      {
        l: "(n1/n2 + n3/n4)",
        r: "((n1*n4 + n3*n2)/(n2*n4))"
      },
      // Sum of fractions
      {
        l: "(n1/n2 + n3)",
        r: "((n1 + n3*n2)/n2)"
      },
      // Sum fraction with number 1
      {
        l: "(n1 + n2/n3)",
        r: "((n1*n3 + n2)/n3)"
      }
    ], z = [
      {
        l: "(n1/(n2/n3))",
        r: "((n1*n3)/n2)"
      },
      // Division simplification
      {
        l: "(n1/n2/n3)",
        r: "(n1/(n2*n3))"
      }
    ], O = {};
    return O.firstRules = T.concat(R, z), O.distrDivRules = F, O.sucDivRules = z, O.firstRulesAgain = T.concat(R), O.finalRules = [
      C,
      // simplify.rules[0]
      {
        l: "n*-n",
        r: "-n^2"
      },
      // Joining multiply with power 1
      {
        l: "n*n",
        r: "n^2"
      },
      // Joining multiply with power 2
      M,
      // simplify.rules[14] old 3rd index in oldRules
      {
        l: "n*-n^n1",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 3
      {
        l: "n*n^n1",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 4
      {
        l: "n^n1*-n^n2",
        r: "-n^(n1+n2)"
      },
      // Joining multiply with power 5
      {
        l: "n^n1*n^n2",
        r: "n^(n1+n2)"
      },
      // Joining multiply with power 6
      {
        l: "n^n1*-n",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 7
      {
        l: "n^n1*n",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/-n",
        r: "-n^(n1-1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/n",
        r: "n^(n1-1)"
      },
      // Joining division with power 1
      {
        l: "n/-n^n1",
        r: "-n^(1-n1)"
      },
      // Joining division with power 2
      {
        l: "n/n^n1",
        r: "n^(1-n1)"
      },
      // Joining division with power 3
      {
        l: "n^n1/-n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 4
      {
        l: "n^n1/n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 5
      {
        l: "n1+(-n2*n3)",
        r: "n1-n2*n3"
      },
      // Solving useless parenthesis 1
      {
        l: "v*(-c)",
        r: "-c*v"
      },
      // Solving useless unary 2
      {
        l: "n1+-n2",
        r: "n1-n2"
      },
      // Solving +- together (new!)
      {
        l: "v*c",
        r: "c*v"
      },
      // inversion constant with variable
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      }
      // Power to Power
    ], O;
  }
  function D(T, R, F) {
    var z = T.type, O = arguments.length > 1;
    if (z === "OperatorNode" && T.isBinary()) {
      var G = !1, I;
      if (T.op === "^" && (T.args[0].type === "ParenthesisNode" || T.args[0].type === "OperatorNode") && T.args[1].type === "ConstantNode" && (I = parseFloat(T.args[1].value), G = I >= 2 && (0, _number.isInteger)(I)), G) {
        if (I > 2) {
          var k = T.args[0], B = new x("^", "pow", [T.args[0].cloneDeep(), new y(I - 1)]);
          T = new x("*", "multiply", [k, B]);
        } else
          T = new x("*", "multiply", [T.args[0], T.args[0].cloneDeep()]);
        O && (F === "content" ? R.content = T : R.args[F] = T);
      }
    }
    if (z === "ParenthesisNode")
      D(T.content, T, "content");
    else if (z !== "ConstantNode" && z !== "SymbolNode")
      for (var L = 0; L < T.args.length; L++)
        D(T.args[L], T, L);
    if (!O)
      return T;
  }
  function N(T, R) {
    R === void 0 && (R = []), R[0] = 0;
    var F = {};
    F.cte = 1, F.oper = "+", F.fire = "";
    var z = 0, O = "";
    J(T, null, F), z = R.length - 1;
    for (var G = !0, I, k = z; k >= 0; k--)
      if (R[k] !== 0) {
        var B = new y(G ? R[k] : Math.abs(R[k])), L = R[k] < 0 ? "-" : "+";
        if (k > 0) {
          var V = new $(O);
          if (k > 1) {
            var U = new y(k);
            V = new x("^", "pow", [V, U]);
          }
          R[k] === -1 && G ? B = new x("-", "unaryMinus", [V]) : Math.abs(R[k]) === 1 ? B = V : B = new x("*", "multiply", [B, V]);
        }
        G ? I = B : L === "+" ? I = new x("+", "add", [I, B]) : I = new x("-", "subtract", [I, B]), G = !1;
      }
    if (G)
      return new y(0);
    return I;
    function J(q, Z, ae) {
      var ee = q.type;
      if (ee === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (ee === "OperatorNode") {
        if ("+-*^".indexOf(q.op) === -1)
          throw new Error("Operator " + q.op + " invalid");
        if (Z !== null) {
          if ((q.fn === "unaryMinus" || q.fn === "pow") && Z.fn !== "add" && Z.fn !== "subtract" && Z.fn !== "multiply")
            throw new Error("Invalid " + q.op + " placing");
          if ((q.fn === "subtract" || q.fn === "add" || q.fn === "multiply") && Z.fn !== "add" && Z.fn !== "subtract")
            throw new Error("Invalid " + q.op + " placing");
          if ((q.fn === "subtract" || q.fn === "add" || q.fn === "unaryMinus") && ae.noFil !== 0)
            throw new Error("Invalid " + q.op + " placing");
        }
        (q.op === "^" || q.op === "*") && (ae.fire = q.op);
        for (var se = 0; se < q.args.length; se++)
          q.fn === "unaryMinus" && (ae.oper = "-"), (q.op === "+" || q.fn === "subtract") && (ae.fire = "", ae.cte = 1, ae.oper = se === 0 ? "+" : q.op), ae.noFil = se, J(q.args[se], q, ae);
      } else if (ee === "SymbolNode") {
        if (q.name !== O && O !== "")
          throw new Error("There is more than one variable");
        if (O = q.name, Z === null) {
          R[1] = 1;
          return;
        }
        if (Z.op === "^" && ae.noFil !== 0)
          throw new Error("In power the variable should be the first parameter");
        if (Z.op === "*" && ae.noFil !== 1)
          throw new Error("In multiply the variable should be the second parameter");
        (ae.fire === "" || ae.fire === "*") && (z < 1 && (R[1] = 0), R[1] += ae.cte * (ae.oper === "+" ? 1 : -1), z = Math.max(1, z));
      } else if (ee === "ConstantNode") {
        var nr = parseFloat(q.value);
        if (Z === null) {
          R[0] = nr;
          return;
        }
        if (Z.op === "^") {
          if (ae.noFil !== 1)
            throw new Error("Constant cannot be powered");
          if (!(0, _number.isInteger)(nr) || nr <= 0)
            throw new Error("Non-integer exponent is not allowed");
          for (var ce = z + 1; ce < nr; ce++)
            R[ce] = 0;
          nr > z && (R[nr] = 0), R[nr] += ae.cte * (ae.oper === "+" ? 1 : -1), z = Math.max(nr, z);
          return;
        }
        ae.cte = nr, ae.fire === "" && (R[0] += ae.cte * (ae.oper === "+" ? 1 : -1));
      } else
        throw new Error("Type " + ee + " is not allowed");
    }
  }
});
rationalize.createRationalize = createRationalize;
var reviver = {};
Object.defineProperty(reviver, "__esModule", {
  value: !0
});
reviver.createReviver = void 0;
var _factory$m = factory$1, name$j = "reviver", dependencies$i = ["classes"], createReviver = /* @__PURE__ */ (0, _factory$m.factory)(name$j, dependencies$i, function(t) {
  var r = t.classes;
  return function(a, s) {
    var o = r[s && s.mathjs];
    return o && typeof o.fromJSON == "function" ? o.fromJSON(s) : s;
  };
});
reviver.createReviver = createReviver;
var replacer = {};
Object.defineProperty(replacer, "__esModule", {
  value: !0
});
replacer.createReplacer = void 0;
var _factory$l = factory$1, name$i = "replacer", dependencies$h = [], createReplacer = /* @__PURE__ */ (0, _factory$l.factory)(name$i, dependencies$h, function() {
  return function(r, n) {
    return typeof n == "number" && (!isFinite(n) || isNaN(n)) ? {
      mathjs: "number",
      value: String(n)
    } : n;
  };
});
replacer.createReplacer = createReplacer;
var constants$1 = {}, version$2 = {};
Object.defineProperty(version$2, "__esModule", {
  value: !0
});
version$2.version = void 0;
var version$1 = "8.1.1";
version$2.version = version$1;
Object.defineProperty(constants$1, "__esModule", {
  value: !0
});
constants$1.createVersion = constants$1.createUppercaseE = constants$1.createUppercasePi = constants$1.createI = constants$1.createSQRT2 = constants$1.createSQRT1_2 = constants$1.createLOG10E = constants$1.createLOG2E = constants$1.createLN10 = constants$1.createLN2 = constants$1.createPhi = constants$1.createE = constants$1.createTau = constants$1.createPi = constants$1.createNaN = constants$1.createInfinity = constants$1.createNull = constants$1.createFalse = constants$1.createTrue = void 0;
var _factory$k = factory$1, _version = version$2, _constants = constants$2, _index = number$2, createTrue = /* @__PURE__ */ (0, _factory$k.factory)("true", [], function() {
  return !0;
});
constants$1.createTrue = createTrue;
var createFalse = /* @__PURE__ */ (0, _factory$k.factory)("false", [], function() {
  return !1;
});
constants$1.createFalse = createFalse;
var createNull = /* @__PURE__ */ (0, _factory$k.factory)("null", [], function() {
  return null;
});
constants$1.createNull = createNull;
var createInfinity = /* @__PURE__ */ recreateFactory("Infinity", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? new n(1 / 0) : 1 / 0;
});
constants$1.createInfinity = createInfinity;
var createNaN = /* @__PURE__ */ recreateFactory("NaN", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? new n(NaN) : NaN;
});
constants$1.createNaN = createNaN;
var createPi = /* @__PURE__ */ recreateFactory("pi", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? (0, _constants.createBigNumberPi)(n) : _index.pi;
});
constants$1.createPi = createPi;
var createTau = /* @__PURE__ */ recreateFactory("tau", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? (0, _constants.createBigNumberTau)(n) : _index.tau;
});
constants$1.createTau = createTau;
var createE = /* @__PURE__ */ recreateFactory("e", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? (0, _constants.createBigNumberE)(n) : _index.e;
});
constants$1.createE = createE;
var createPhi = /* @__PURE__ */ recreateFactory("phi", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? (0, _constants.createBigNumberPhi)(n) : _index.phi;
});
constants$1.createPhi = createPhi;
var createLN2 = /* @__PURE__ */ recreateFactory("LN2", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? new n(2).ln() : Math.LN2;
});
constants$1.createLN2 = createLN2;
var createLN10 = /* @__PURE__ */ recreateFactory("LN10", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? new n(10).ln() : Math.LN10;
});
constants$1.createLN10 = createLN10;
var createLOG2E = /* @__PURE__ */ recreateFactory("LOG2E", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? new n(1).div(new n(2).ln()) : Math.LOG2E;
});
constants$1.createLOG2E = createLOG2E;
var createLOG10E = /* @__PURE__ */ recreateFactory("LOG10E", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? new n(1).div(new n(10).ln()) : Math.LOG10E;
});
constants$1.createLOG10E = createLOG10E;
var createSQRT1_2 = /* @__PURE__ */ recreateFactory(
  // eslint-disable-line camelcase
  "SQRT1_2",
  ["config", "?BigNumber"],
  function(t) {
    var r = t.config, n = t.BigNumber;
    return r.number === "BigNumber" ? new n("0.5").sqrt() : Math.SQRT1_2;
  }
);
constants$1.createSQRT1_2 = createSQRT1_2;
var createSQRT2 = /* @__PURE__ */ recreateFactory("SQRT2", ["config", "?BigNumber"], function(t) {
  var r = t.config, n = t.BigNumber;
  return r.number === "BigNumber" ? new n(2).sqrt() : Math.SQRT2;
});
constants$1.createSQRT2 = createSQRT2;
var createI = /* @__PURE__ */ recreateFactory("i", ["Complex"], function(t) {
  var r = t.Complex;
  return r.I;
});
constants$1.createI = createI;
var createUppercasePi = /* @__PURE__ */ (0, _factory$k.factory)("PI", ["pi"], function(t) {
  var r = t.pi;
  return r;
});
constants$1.createUppercasePi = createUppercasePi;
var createUppercaseE = /* @__PURE__ */ (0, _factory$k.factory)("E", ["e"], function(t) {
  var r = t.e;
  return r;
});
constants$1.createUppercaseE = createUppercaseE;
var createVersion = /* @__PURE__ */ (0, _factory$k.factory)("version", [], function() {
  return _version.version;
});
constants$1.createVersion = createVersion;
function recreateFactory(t, r, n) {
  return (0, _factory$k.factory)(t, r, n, {
    recreateOnConfigChange: !0
  });
}
var physicalConstants = {};
Object.defineProperty(physicalConstants, "__esModule", {
  value: !0
});
physicalConstants.createPlanckTemperature = physicalConstants.createPlanckCharge = physicalConstants.createPlanckTime = physicalConstants.createPlanckMass = physicalConstants.createPlanckLength = physicalConstants.createGravity = physicalConstants.createMolarMassC12 = physicalConstants.createMolarMass = physicalConstants.createWienDisplacement = physicalConstants.createStefanBoltzmann = physicalConstants.createSecondRadiation = physicalConstants.createSackurTetrode = physicalConstants.createMolarVolume = physicalConstants.createMolarPlanckConstant = physicalConstants.createGasConstant = physicalConstants.createLoschmidt = physicalConstants.createFirstRadiation = physicalConstants.createFaraday = physicalConstants.createBoltzmann = physicalConstants.createAvogadro = physicalConstants.createAtomicMass = physicalConstants.createEfimovFactor = physicalConstants.createWeakMixingAngle = physicalConstants.createThomsonCrossSection = physicalConstants.createRydberg = physicalConstants.createQuantumOfCirculation = physicalConstants.createNeutronMass = physicalConstants.createDeuteronMass = physicalConstants.createProtonMass = physicalConstants.createHartreeEnergy = physicalConstants.createFineStructure = physicalConstants.createFermiCoupling = physicalConstants.createElectronMass = physicalConstants.createClassicalElectronRadius = physicalConstants.createBohrRadius = physicalConstants.createJosephson = physicalConstants.createKlitzing = physicalConstants.createNuclearMagneton = physicalConstants.createMagneticFluxQuantum = physicalConstants.createInverseConductanceQuantum = physicalConstants.createConductanceQuantum = physicalConstants.createBohrMagneton = physicalConstants.createElementaryCharge = physicalConstants.createCoulomb = physicalConstants.createVacuumImpedance = physicalConstants.createElectricConstant = physicalConstants.createMagneticConstant = physicalConstants.createReducedPlanckConstant = physicalConstants.createPlanckConstant = physicalConstants.createGravitationConstant = physicalConstants.createSpeedOfLight = void 0;
var _factory$j = factory$1, createSpeedOfLight = /* @__PURE__ */ unitFactory("speedOfLight", "299792458", "m s^-1");
physicalConstants.createSpeedOfLight = createSpeedOfLight;
var createGravitationConstant = /* @__PURE__ */ unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2");
physicalConstants.createGravitationConstant = createGravitationConstant;
var createPlanckConstant = /* @__PURE__ */ unitFactory("planckConstant", "6.62607015e-34", "J s");
physicalConstants.createPlanckConstant = createPlanckConstant;
var createReducedPlanckConstant = /* @__PURE__ */ unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s");
physicalConstants.createReducedPlanckConstant = createReducedPlanckConstant;
var createMagneticConstant = /* @__PURE__ */ unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2");
physicalConstants.createMagneticConstant = createMagneticConstant;
var createElectricConstant = /* @__PURE__ */ unitFactory("electricConstant", "8.8541878128e-12", "F m^-1");
physicalConstants.createElectricConstant = createElectricConstant;
var createVacuumImpedance = /* @__PURE__ */ unitFactory("vacuumImpedance", "376.730313667", "ohm");
physicalConstants.createVacuumImpedance = createVacuumImpedance;
var createCoulomb = /* @__PURE__ */ unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2");
physicalConstants.createCoulomb = createCoulomb;
var createElementaryCharge = /* @__PURE__ */ unitFactory("elementaryCharge", "1.602176634e-19", "C");
physicalConstants.createElementaryCharge = createElementaryCharge;
var createBohrMagneton = /* @__PURE__ */ unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1");
physicalConstants.createBohrMagneton = createBohrMagneton;
var createConductanceQuantum = /* @__PURE__ */ unitFactory("conductanceQuantum", "7.748091729863649e-5", "S");
physicalConstants.createConductanceQuantum = createConductanceQuantum;
var createInverseConductanceQuantum = /* @__PURE__ */ unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm");
physicalConstants.createInverseConductanceQuantum = createInverseConductanceQuantum;
var createMagneticFluxQuantum = /* @__PURE__ */ unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb");
physicalConstants.createMagneticFluxQuantum = createMagneticFluxQuantum;
var createNuclearMagneton = /* @__PURE__ */ unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1");
physicalConstants.createNuclearMagneton = createNuclearMagneton;
var createKlitzing = /* @__PURE__ */ unitFactory("klitzing", "25812.807459304513", "ohm");
physicalConstants.createKlitzing = createKlitzing;
var createJosephson = /* @__PURE__ */ unitFactory("josephson", "4.835978484169836e14 Hz V", "Hz V^-1");
physicalConstants.createJosephson = createJosephson;
var createBohrRadius = /* @__PURE__ */ unitFactory("bohrRadius", "5.29177210903e-11", "m");
physicalConstants.createBohrRadius = createBohrRadius;
var createClassicalElectronRadius = /* @__PURE__ */ unitFactory("classicalElectronRadius", "2.8179403262e-15", "m");
physicalConstants.createClassicalElectronRadius = createClassicalElectronRadius;
var createElectronMass = /* @__PURE__ */ unitFactory("electronMass", "9.1093837015e-31", "kg");
physicalConstants.createElectronMass = createElectronMass;
var createFermiCoupling = /* @__PURE__ */ unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2");
physicalConstants.createFermiCoupling = createFermiCoupling;
var createFineStructure = numberFactory("fineStructure", 0.0072973525693);
physicalConstants.createFineStructure = createFineStructure;
var createHartreeEnergy = /* @__PURE__ */ unitFactory("hartreeEnergy", "4.3597447222071e-18", "J");
physicalConstants.createHartreeEnergy = createHartreeEnergy;
var createProtonMass = /* @__PURE__ */ unitFactory("protonMass", "1.67262192369e-27", "kg");
physicalConstants.createProtonMass = createProtonMass;
var createDeuteronMass = /* @__PURE__ */ unitFactory("deuteronMass", "3.3435830926e-27", "kg");
physicalConstants.createDeuteronMass = createDeuteronMass;
var createNeutronMass = /* @__PURE__ */ unitFactory("neutronMass", "1.6749271613e-27", "kg");
physicalConstants.createNeutronMass = createNeutronMass;
var createQuantumOfCirculation = /* @__PURE__ */ unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1");
physicalConstants.createQuantumOfCirculation = createQuantumOfCirculation;
var createRydberg = /* @__PURE__ */ unitFactory("rydberg", "10973731.568160", "m^-1");
physicalConstants.createRydberg = createRydberg;
var createThomsonCrossSection = /* @__PURE__ */ unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2");
physicalConstants.createThomsonCrossSection = createThomsonCrossSection;
var createWeakMixingAngle = numberFactory("weakMixingAngle", 0.2229);
physicalConstants.createWeakMixingAngle = createWeakMixingAngle;
var createEfimovFactor = numberFactory("efimovFactor", 22.7);
physicalConstants.createEfimovFactor = createEfimovFactor;
var createAtomicMass = /* @__PURE__ */ unitFactory("atomicMass", "1.66053906660e-27", "kg");
physicalConstants.createAtomicMass = createAtomicMass;
var createAvogadro = /* @__PURE__ */ unitFactory("avogadro", "6.02214076e23", "mol^-1");
physicalConstants.createAvogadro = createAvogadro;
var createBoltzmann = /* @__PURE__ */ unitFactory("boltzmann", "1.380649e-23", "J K^-1");
physicalConstants.createBoltzmann = createBoltzmann;
var createFaraday = /* @__PURE__ */ unitFactory("faraday", "96485.33212331001", "C mol^-1");
physicalConstants.createFaraday = createFaraday;
var createFirstRadiation = /* @__PURE__ */ unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2");
physicalConstants.createFirstRadiation = createFirstRadiation;
var createLoschmidt = /* @__PURE__ */ unitFactory("loschmidt", "2.686780111798444e25", "m^-3");
physicalConstants.createLoschmidt = createLoschmidt;
var createGasConstant = /* @__PURE__ */ unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1");
physicalConstants.createGasConstant = createGasConstant;
var createMolarPlanckConstant = /* @__PURE__ */ unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1");
physicalConstants.createMolarPlanckConstant = createMolarPlanckConstant;
var createMolarVolume = /* @__PURE__ */ unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1");
physicalConstants.createMolarVolume = createMolarVolume;
var createSackurTetrode = numberFactory("sackurTetrode", -1.16487052358);
physicalConstants.createSackurTetrode = createSackurTetrode;
var createSecondRadiation = /* @__PURE__ */ unitFactory("secondRadiation", "0.014387768775039337", "m K");
physicalConstants.createSecondRadiation = createSecondRadiation;
var createStefanBoltzmann = /* @__PURE__ */ unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4");
physicalConstants.createStefanBoltzmann = createStefanBoltzmann;
var createWienDisplacement = /* @__PURE__ */ unitFactory("wienDisplacement", "2.897771955e-3", "m K");
physicalConstants.createWienDisplacement = createWienDisplacement;
var createMolarMass = /* @__PURE__ */ unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1");
physicalConstants.createMolarMass = createMolarMass;
var createMolarMassC12 = /* @__PURE__ */ unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1");
physicalConstants.createMolarMassC12 = createMolarMassC12;
var createGravity = /* @__PURE__ */ unitFactory("gravity", "9.80665", "m s^-2");
physicalConstants.createGravity = createGravity;
var createPlanckLength = /* @__PURE__ */ unitFactory("planckLength", "1.616255e-35", "m");
physicalConstants.createPlanckLength = createPlanckLength;
var createPlanckMass = /* @__PURE__ */ unitFactory("planckMass", "2.176435e-8", "kg");
physicalConstants.createPlanckMass = createPlanckMass;
var createPlanckTime = /* @__PURE__ */ unitFactory("planckTime", "5.391245e-44", "s");
physicalConstants.createPlanckTime = createPlanckTime;
var createPlanckCharge = /* @__PURE__ */ unitFactory("planckCharge", "1.87554603778e-18", "C");
physicalConstants.createPlanckCharge = createPlanckCharge;
var createPlanckTemperature = /* @__PURE__ */ unitFactory("planckTemperature", "1.416785e+32", "K");
physicalConstants.createPlanckTemperature = createPlanckTemperature;
function unitFactory(t, r, n) {
  var a = ["config", "Unit", "BigNumber"];
  return (0, _factory$j.factory)(t, a, function(s) {
    var o = s.config, c = s.Unit, l = s.BigNumber, d = o.number === "BigNumber" ? new l(r) : parseFloat(r), h = new c(d, n);
    return h.fixPrefix = !0, h;
  });
}
function numberFactory(t, r) {
  var n = ["config", "BigNumber"];
  return (0, _factory$j.factory)(t, n, function(a) {
    var s = a.config, o = a.BigNumber;
    return s.number === "BigNumber" ? new o(r) : r;
  });
}
var apply_transform = {};
Object.defineProperty(apply_transform, "__esModule", {
  value: !0
});
apply_transform.createApplyTransform = void 0;
var _errorTransform$b = errorTransform$1, _factory$i = factory$1, _apply = apply, _is$h = is, name$h = "apply", dependencies$g = ["typed", "isInteger"], createApplyTransform = /* @__PURE__ */ (0, _factory$i.factory)(name$h, dependencies$g, function(t) {
  var r = t.typed, n = t.isInteger, a = (0, _apply.createApply)({
    typed: r,
    isInteger: n
  });
  return r("apply", {
    "...any": function(o) {
      var c = o[1];
      (0, _is$h.isNumber)(c) ? o[1] = c - 1 : (0, _is$h.isBigNumber)(c) && (o[1] = c.minus(1));
      try {
        return a.apply(null, o);
      } catch (l) {
        throw (0, _errorTransform$b.errorTransform)(l);
      }
    }
  });
}, {
  isTransformFunction: !0
});
apply_transform.createApplyTransform = createApplyTransform;
var column_transform = {};
Object.defineProperty(column_transform, "__esModule", {
  value: !0
});
column_transform.createColumnTransform = void 0;
var _errorTransform$a = errorTransform$1, _factory$h = factory$1, _column = column$2, _is$g = is, name$g = "column", dependencies$f = ["typed", "Index", "matrix", "range"], createColumnTransform = /* @__PURE__ */ (0, _factory$h.factory)(name$g, dependencies$f, function(t) {
  var r = t.typed, n = t.Index, a = t.matrix, s = t.range, o = (0, _column.createColumn)({
    typed: r,
    Index: n,
    matrix: a,
    range: s
  });
  return r("column", {
    "...any": function(l) {
      var d = l.length - 1, h = l[d];
      (0, _is$g.isNumber)(h) && (l[d] = h - 1);
      try {
        return o.apply(null, l);
      } catch (u) {
        throw (0, _errorTransform$a.errorTransform)(u);
      }
    }
  });
}, {
  isTransformFunction: !0
});
column_transform.createColumnTransform = createColumnTransform;
var filter_transform = {}, compileInlineExpression$1 = {};
Object.defineProperty(compileInlineExpression$1, "__esModule", {
  value: !0
});
compileInlineExpression$1.compileInlineExpression = compileInlineExpression;
var _is$f = is;
function compileInlineExpression(t, r, n) {
  var a = t.filter(function(l) {
    return (0, _is$f.isSymbolNode)(l) && !(l.name in r) && !(l.name in n);
  })[0];
  if (!a)
    throw new Error('No undefined variable found in inline expression "' + t + '"');
  var s = a.name, o = Object.create(n), c = t.compile();
  return function(d) {
    return o[s] = d, c.evaluate(o);
  };
}
Object.defineProperty(filter_transform, "__esModule", {
  value: !0
});
filter_transform.createFilterTransform = void 0;
var _is$e = is, _array$3 = array, _function$2 = _function$9, _compileInlineExpression$2 = compileInlineExpression$1, _factory$g = factory$1, name$f = "filter", dependencies$e = ["typed"], createFilterTransform = /* @__PURE__ */ (0, _factory$g.factory)(name$f, dependencies$e, function(t) {
  var r = t.typed;
  function n(s, o, c) {
    var l, d;
    return s[0] && (l = s[0].compile().evaluate(c)), s[1] && ((0, _is$e.isSymbolNode)(s[1]) || (0, _is$e.isFunctionAssignmentNode)(s[1]) ? d = s[1].compile().evaluate(c) : d = (0, _compileInlineExpression$2.compileInlineExpression)(s[1], o, c)), a(l, d);
  }
  n.rawArgs = !0;
  var a = r("filter", {
    "Array, function": _filter,
    "Matrix, function": function(o, c) {
      return o.create(_filter(o.toArray(), c));
    },
    "Array, RegExp": _array$3.filterRegExp,
    "Matrix, RegExp": function(o, c) {
      return o.create((0, _array$3.filterRegExp)(o.toArray(), c));
    }
  });
  return n;
}, {
  isTransformFunction: !0
});
filter_transform.createFilterTransform = createFilterTransform;
function _filter(t, r) {
  var n = (0, _function$2.maxArgumentCount)(r);
  return (0, _array$3.filter)(t, function(a, s, o) {
    return n === 1 ? r(a) : n === 2 ? r(a, [s + 1]) : r(a, [s + 1], o);
  });
}
var forEach_transform = {};
Object.defineProperty(forEach_transform, "__esModule", {
  value: !0
});
forEach_transform.createForEachTransform = void 0;
var _is$d = is, _function$1 = _function$9, _array$2 = array, _factory$f = factory$1, _compileInlineExpression$1 = compileInlineExpression$1, name$e = "forEach", dependencies$d = ["typed"], createForEachTransform = /* @__PURE__ */ (0, _factory$f.factory)(name$e, dependencies$d, function(t) {
  var r = t.typed;
  function n(s, o, c) {
    var l, d;
    return s[0] && (l = s[0].compile().evaluate(c)), s[1] && ((0, _is$d.isSymbolNode)(s[1]) || (0, _is$d.isFunctionAssignmentNode)(s[1]) ? d = s[1].compile().evaluate(c) : d = (0, _compileInlineExpression$1.compileInlineExpression)(s[1], o, c)), a(l, d);
  }
  n.rawArgs = !0;
  var a = r("forEach", {
    "Array | Matrix, function": function(o, c) {
      var l = (0, _function$1.maxArgumentCount)(c), d = function h(u, p) {
        Array.isArray(u) ? (0, _array$2.forEach)(u, function(m, g) {
          h(m, p.concat(g + 1));
        }) : l === 1 ? c(u) : l === 2 ? c(u, p) : c(u, p, o);
      };
      d(o.valueOf(), []);
    }
  });
  return n;
}, {
  isTransformFunction: !0
});
forEach_transform.createForEachTransform = createForEachTransform;
var index_transform = {};
Object.defineProperty(index_transform, "__esModule", {
  value: !0
});
index_transform.createIndexTransform = void 0;
var _is$c = is, _factory$e = factory$1, name$d = "index", dependencies$c = ["Index"], createIndexTransform = /* @__PURE__ */ (0, _factory$e.factory)(name$d, dependencies$c, function(t) {
  var r = t.Index;
  return function() {
    for (var a = [], s = 0, o = arguments.length; s < o; s++) {
      var c = arguments[s];
      if ((0, _is$c.isRange)(c))
        c.start--, c.end -= c.step > 0 ? 0 : 2;
      else if (c && c.isSet === !0)
        c = c.map(function(d) {
          return d - 1;
        });
      else if ((0, _is$c.isArray)(c) || (0, _is$c.isMatrix)(c))
        c = c.map(function(d) {
          return d - 1;
        });
      else if ((0, _is$c.isNumber)(c))
        c--;
      else if ((0, _is$c.isBigNumber)(c))
        c = c.toNumber() - 1;
      else if (typeof c != "string")
        throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
      a[s] = c;
    }
    var l = new r();
    return r.apply(l, a), l;
  };
}, {
  isTransformFunction: !0
});
index_transform.createIndexTransform = createIndexTransform;
var map_transform = {};
Object.defineProperty(map_transform, "__esModule", {
  value: !0
});
map_transform.createMapTransform = void 0;
var _is$b = is, _function = _function$9, _array$1 = array, _factory$d = factory$1, _compileInlineExpression = compileInlineExpression$1, name$c = "map", dependencies$b = ["typed"], createMapTransform = /* @__PURE__ */ (0, _factory$d.factory)(name$c, dependencies$b, function(t) {
  var r = t.typed;
  function n(s, o, c) {
    var l, d;
    return s[0] && (l = s[0].compile().evaluate(c)), s[1] && ((0, _is$b.isSymbolNode)(s[1]) || (0, _is$b.isFunctionAssignmentNode)(s[1]) ? d = s[1].compile().evaluate(c) : d = (0, _compileInlineExpression.compileInlineExpression)(s[1], o, c)), a(l, d);
  }
  n.rawArgs = !0;
  var a = r("map", {
    "Array, function": function(o, c) {
      return _map(o, c, o);
    },
    "Matrix, function": function(o, c) {
      return o.create(_map(o.valueOf(), c, o));
    }
  });
  return n;
}, {
  isTransformFunction: !0
});
map_transform.createMapTransform = createMapTransform;
function _map(t, r, n) {
  var a = (0, _function.maxArgumentCount)(r);
  function s(o, c) {
    return Array.isArray(o) ? (0, _array$1.map)(o, function(l, d) {
      return s(l, c.concat(d + 1));
    }) : a === 1 ? r(o) : a === 2 ? r(o, c) : r(o, c, n);
  }
  return s(t, []);
}
var max_transform = {};
Object.defineProperty(max_transform, "__esModule", {
  value: !0
});
max_transform.createMaxTransform = void 0;
var _is$a = is, _factory$c = factory$1, _errorTransform$9 = errorTransform$1, _max = max$3, name$b = "max", dependencies$a = ["typed", "config", "numeric", "larger"], createMaxTransform = /* @__PURE__ */ (0, _factory$c.factory)(name$b, dependencies$a, function(t) {
  var r = t.typed, n = t.config, a = t.numeric, s = t.larger, o = (0, _max.createMax)({
    typed: r,
    config: n,
    numeric: a,
    larger: s
  });
  return r("max", {
    "...any": function(l) {
      if (l.length === 2 && (0, _is$a.isCollection)(l[0])) {
        var d = l[1];
        (0, _is$a.isNumber)(d) ? l[1] = d - 1 : (0, _is$a.isBigNumber)(d) && (l[1] = d.minus(1));
      }
      try {
        return o.apply(null, l);
      } catch (h) {
        throw (0, _errorTransform$9.errorTransform)(h);
      }
    }
  });
}, {
  isTransformFunction: !0
});
max_transform.createMaxTransform = createMaxTransform;
var mean_transform = {};
Object.defineProperty(mean_transform, "__esModule", {
  value: !0
});
mean_transform.createMeanTransform = void 0;
var _is$9 = is, _factory$b = factory$1, _errorTransform$8 = errorTransform$1, _mean = mean, name$a = "mean", dependencies$9 = ["typed", "add", "divide"], createMeanTransform = /* @__PURE__ */ (0, _factory$b.factory)(name$a, dependencies$9, function(t) {
  var r = t.typed, n = t.add, a = t.divide, s = (0, _mean.createMean)({
    typed: r,
    add: n,
    divide: a
  });
  return r("mean", {
    "...any": function(c) {
      if (c.length === 2 && (0, _is$9.isCollection)(c[0])) {
        var l = c[1];
        (0, _is$9.isNumber)(l) ? c[1] = l - 1 : (0, _is$9.isBigNumber)(l) && (c[1] = l.minus(1));
      }
      try {
        return s.apply(null, c);
      } catch (d) {
        throw (0, _errorTransform$8.errorTransform)(d);
      }
    }
  });
}, {
  isTransformFunction: !0
});
mean_transform.createMeanTransform = createMeanTransform;
var min_transform = {};
Object.defineProperty(min_transform, "__esModule", {
  value: !0
});
min_transform.createMinTransform = void 0;
var _is$8 = is, _factory$a = factory$1, _errorTransform$7 = errorTransform$1, _min = min$3, name$9 = "min", dependencies$8 = ["typed", "config", "numeric", "smaller"], createMinTransform = /* @__PURE__ */ (0, _factory$a.factory)(name$9, dependencies$8, function(t) {
  var r = t.typed, n = t.config, a = t.numeric, s = t.smaller, o = (0, _min.createMin)({
    typed: r,
    config: n,
    numeric: a,
    smaller: s
  });
  return r("min", {
    "...any": function(l) {
      if (l.length === 2 && (0, _is$8.isCollection)(l[0])) {
        var d = l[1];
        (0, _is$8.isNumber)(d) ? l[1] = d - 1 : (0, _is$8.isBigNumber)(d) && (l[1] = d.minus(1));
      }
      try {
        return o.apply(null, l);
      } catch (h) {
        throw (0, _errorTransform$7.errorTransform)(h);
      }
    }
  });
}, {
  isTransformFunction: !0
});
min_transform.createMinTransform = createMinTransform;
var range_transform = {};
Object.defineProperty(range_transform, "__esModule", {
  value: !0
});
range_transform.createRangeTransform = void 0;
var _factory$9 = factory$1, _range = range$1, name$8 = "range", dependencies$7 = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq"], createRangeTransform = /* @__PURE__ */ (0, _factory$9.factory)(name$8, dependencies$7, function(t) {
  var r = t.typed, n = t.config, a = t.matrix, s = t.bignumber, o = t.smaller, c = t.smallerEq, l = t.larger, d = t.largerEq, h = (0, _range.createRange)({
    typed: r,
    config: n,
    matrix: a,
    bignumber: s,
    smaller: o,
    smallerEq: c,
    larger: l,
    largerEq: d
  });
  return r("range", {
    "...any": function(p) {
      var m = p.length - 1, g = p[m];
      return typeof g != "boolean" && p.push(!0), h.apply(null, p);
    }
  });
}, {
  isTransformFunction: !0
});
range_transform.createRangeTransform = createRangeTransform;
var row_transform = {};
Object.defineProperty(row_transform, "__esModule", {
  value: !0
});
row_transform.createRowTransform = void 0;
var _factory$8 = factory$1, _row = row$1, _errorTransform$6 = errorTransform$1, _is$7 = is, name$7 = "row", dependencies$6 = ["typed", "Index", "matrix", "range"], createRowTransform = /* @__PURE__ */ (0, _factory$8.factory)(name$7, dependencies$6, function(t) {
  var r = t.typed, n = t.Index, a = t.matrix, s = t.range, o = (0, _row.createRow)({
    typed: r,
    Index: n,
    matrix: a,
    range: s
  });
  return r("row", {
    "...any": function(l) {
      var d = l.length - 1, h = l[d];
      (0, _is$7.isNumber)(h) && (l[d] = h - 1);
      try {
        return o.apply(null, l);
      } catch (u) {
        throw (0, _errorTransform$6.errorTransform)(u);
      }
    }
  });
}, {
  isTransformFunction: !0
});
row_transform.createRowTransform = createRowTransform;
var subset_transform = {};
Object.defineProperty(subset_transform, "__esModule", {
  value: !0
});
subset_transform.createSubsetTransform = void 0;
var _factory$7 = factory$1, _errorTransform$5 = errorTransform$1, _subset = subset$1, name$6 = "subset", dependencies$5 = ["typed", "matrix"], createSubsetTransform = /* @__PURE__ */ (0, _factory$7.factory)(name$6, dependencies$5, function(t) {
  var r = t.typed, n = t.matrix, a = (0, _subset.createSubset)({
    typed: r,
    matrix: n
  });
  return r("subset", {
    "...any": function(o) {
      try {
        return a.apply(null, o);
      } catch (c) {
        throw (0, _errorTransform$5.errorTransform)(c);
      }
    }
  });
}, {
  isTransformFunction: !0
});
subset_transform.createSubsetTransform = createSubsetTransform;
var concat_transform = {};
Object.defineProperty(concat_transform, "__esModule", {
  value: !0
});
concat_transform.createConcatTransform = void 0;
var _is$6 = is, _errorTransform$4 = errorTransform$1, _factory$6 = factory$1, _concat = concat$1, name$5 = "concat", dependencies$4 = ["typed", "matrix", "isInteger"], createConcatTransform = /* @__PURE__ */ (0, _factory$6.factory)(name$5, dependencies$4, function(t) {
  var r = t.typed, n = t.matrix, a = t.isInteger, s = (0, _concat.createConcat)({
    typed: r,
    matrix: n,
    isInteger: a
  });
  return r("concat", {
    "...any": function(c) {
      var l = c.length - 1, d = c[l];
      (0, _is$6.isNumber)(d) ? c[l] = d - 1 : (0, _is$6.isBigNumber)(d) && (c[l] = d.minus(1));
      try {
        return s.apply(null, c);
      } catch (h) {
        throw (0, _errorTransform$4.errorTransform)(h);
      }
    }
  });
}, {
  isTransformFunction: !0
});
concat_transform.createConcatTransform = createConcatTransform;
var diff_transform = {};
Object.defineProperty(diff_transform, "__esModule", {
  value: !0
});
diff_transform.createDiffTransform = void 0;
var _is$5 = is, _factory$5 = factory$1, _errorTransform$3 = errorTransform$1, _diff = diff$2, name$4 = "diff", dependencies$3 = ["typed", "matrix", "subtract", "number", "bignumber"], createDiffTransform = /* @__PURE__ */ (0, _factory$5.factory)(name$4, dependencies$3, function(t) {
  var r = t.typed, n = t.matrix, a = t.subtract, s = t.number, o = t.bignumber, c = (0, _diff.createDiff)({
    typed: r,
    matrix: n,
    subtract: a,
    number: s,
    bignumber: o
  });
  return r(name$4, {
    "...any": function(d) {
      if (d.length === 2 && (0, _is$5.isCollection)(d[0])) {
        var h = d[1];
        (0, _is$5.isNumber)(h) ? d[1] = h - 1 : (0, _is$5.isBigNumber)(h) && (d[1] = h.minus(1));
      }
      try {
        return c.apply(null, d);
      } catch (u) {
        throw (0, _errorTransform$3.errorTransform)(u);
      }
    }
  });
}, {
  isTransformFunction: !0
});
diff_transform.createDiffTransform = createDiffTransform;
var std_transform = {};
Object.defineProperty(std_transform, "__esModule", {
  value: !0
});
std_transform.createStdTransform = void 0;
var _factory$4 = factory$1, _std = std, _is$4 = is, _errorTransform$2 = errorTransform$1, name$3 = "std", dependencies$2 = ["typed", "sqrt", "variance"], createStdTransform = /* @__PURE__ */ (0, _factory$4.factory)(name$3, dependencies$2, function(t) {
  var r = t.typed, n = t.sqrt, a = t.variance, s = (0, _std.createStd)({
    typed: r,
    sqrt: n,
    variance: a
  });
  return r("std", {
    "...any": function(c) {
      if (c.length >= 2 && (0, _is$4.isCollection)(c[0])) {
        var l = c[1];
        (0, _is$4.isNumber)(l) ? c[1] = l - 1 : (0, _is$4.isBigNumber)(l) && (c[1] = l.minus(1));
      }
      try {
        return s.apply(null, c);
      } catch (d) {
        throw (0, _errorTransform$2.errorTransform)(d);
      }
    }
  });
}, {
  isTransformFunction: !0
});
std_transform.createStdTransform = createStdTransform;
var sum_transform = {};
Object.defineProperty(sum_transform, "__esModule", {
  value: !0
});
sum_transform.createSumTransform = void 0;
var _is$3 = is, _factory$3 = factory$1, _errorTransform$1 = errorTransform$1, _sum = sum, name$2 = "sum", dependencies$1 = ["typed", "config", "add", "numeric"], createSumTransform = /* @__PURE__ */ (0, _factory$3.factory)(name$2, dependencies$1, function(t) {
  var r = t.typed, n = t.config, a = t.add, s = t.numeric, o = (0, _sum.createSum)({
    typed: r,
    config: n,
    add: a,
    numeric: s
  });
  return r(name$2, {
    "...any": function(l) {
      if (l.length === 2 && (0, _is$3.isCollection)(l[0])) {
        var d = l[1];
        (0, _is$3.isNumber)(d) ? l[1] = d - 1 : (0, _is$3.isBigNumber)(d) && (l[1] = d.minus(1));
      }
      try {
        return o.apply(null, l);
      } catch (h) {
        throw (0, _errorTransform$1.errorTransform)(h);
      }
    }
  });
}, {
  isTransformFunction: !0
});
sum_transform.createSumTransform = createSumTransform;
var variance_transform = {};
Object.defineProperty(variance_transform, "__esModule", {
  value: !0
});
variance_transform.createVarianceTransform = void 0;
var _factory$2 = factory$1, _is$2 = is, _errorTransform = errorTransform$1, _variance = variance, name$1 = "variance", dependencies = ["typed", "add", "subtract", "multiply", "divide", "apply", "isNaN"], createVarianceTransform = /* @__PURE__ */ (0, _factory$2.factory)(name$1, dependencies, function(t) {
  var r = t.typed, n = t.add, a = t.subtract, s = t.multiply, o = t.divide, c = t.apply, l = t.isNaN, d = (0, _variance.createVariance)({
    typed: r,
    add: n,
    subtract: a,
    multiply: s,
    divide: o,
    apply: c,
    isNaN: l
  });
  return r(name$1, {
    "...any": function(u) {
      if (u.length >= 2 && (0, _is$2.isCollection)(u[0])) {
        var p = u[1];
        (0, _is$2.isNumber)(p) ? u[1] = p - 1 : (0, _is$2.isBigNumber)(p) && (u[1] = p.minus(1));
      }
      try {
        return d.apply(null, u);
      } catch (m) {
        throw (0, _errorTransform.errorTransform)(m);
      }
    }
  });
}, {
  isTransformFunction: !0
});
variance_transform.createVarianceTransform = createVarianceTransform;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "createTyped", {
    enumerable: !0,
    get: function() {
      return r.createTyped;
    }
  }), Object.defineProperty(t, "createResultSet", {
    enumerable: !0,
    get: function() {
      return n.createResultSet;
    }
  }), Object.defineProperty(t, "createBigNumberClass", {
    enumerable: !0,
    get: function() {
      return a.createBigNumberClass;
    }
  }), Object.defineProperty(t, "createComplexClass", {
    enumerable: !0,
    get: function() {
      return s.createComplexClass;
    }
  }), Object.defineProperty(t, "createFractionClass", {
    enumerable: !0,
    get: function() {
      return o.createFractionClass;
    }
  }), Object.defineProperty(t, "createRangeClass", {
    enumerable: !0,
    get: function() {
      return c.createRangeClass;
    }
  }), Object.defineProperty(t, "createMatrixClass", {
    enumerable: !0,
    get: function() {
      return l.createMatrixClass;
    }
  }), Object.defineProperty(t, "createDenseMatrixClass", {
    enumerable: !0,
    get: function() {
      return d.createDenseMatrixClass;
    }
  }), Object.defineProperty(t, "createClone", {
    enumerable: !0,
    get: function() {
      return h.createClone;
    }
  }), Object.defineProperty(t, "createIsInteger", {
    enumerable: !0,
    get: function() {
      return u.createIsInteger;
    }
  }), Object.defineProperty(t, "createIsNegative", {
    enumerable: !0,
    get: function() {
      return p.createIsNegative;
    }
  }), Object.defineProperty(t, "createIsNumeric", {
    enumerable: !0,
    get: function() {
      return m.createIsNumeric;
    }
  }), Object.defineProperty(t, "createHasNumericValue", {
    enumerable: !0,
    get: function() {
      return g.createHasNumericValue;
    }
  }), Object.defineProperty(t, "createIsPositive", {
    enumerable: !0,
    get: function() {
      return v.createIsPositive;
    }
  }), Object.defineProperty(t, "createIsZero", {
    enumerable: !0,
    get: function() {
      return y.createIsZero;
    }
  }), Object.defineProperty(t, "createIsNaN", {
    enumerable: !0,
    get: function() {
      return x.createIsNaN;
    }
  }), Object.defineProperty(t, "createTypeOf", {
    enumerable: !0,
    get: function() {
      return _.createTypeOf;
    }
  }), Object.defineProperty(t, "createEqualScalar", {
    enumerable: !0,
    get: function() {
      return $.createEqualScalar;
    }
  }), Object.defineProperty(t, "createSparseMatrixClass", {
    enumerable: !0,
    get: function() {
      return b.createSparseMatrixClass;
    }
  }), Object.defineProperty(t, "createNumber", {
    enumerable: !0,
    get: function() {
      return M.createNumber;
    }
  }), Object.defineProperty(t, "createString", {
    enumerable: !0,
    get: function() {
      return C.createString;
    }
  }), Object.defineProperty(t, "createBoolean", {
    enumerable: !0,
    get: function() {
      return S.createBoolean;
    }
  }), Object.defineProperty(t, "createBignumber", {
    enumerable: !0,
    get: function() {
      return A.createBignumber;
    }
  }), Object.defineProperty(t, "createComplex", {
    enumerable: !0,
    get: function() {
      return D.createComplex;
    }
  }), Object.defineProperty(t, "createFraction", {
    enumerable: !0,
    get: function() {
      return N.createFraction;
    }
  }), Object.defineProperty(t, "createMatrix", {
    enumerable: !0,
    get: function() {
      return T.createMatrix;
    }
  }), Object.defineProperty(t, "createSplitUnit", {
    enumerable: !0,
    get: function() {
      return R.createSplitUnit;
    }
  }), Object.defineProperty(t, "createUnaryMinus", {
    enumerable: !0,
    get: function() {
      return F.createUnaryMinus;
    }
  }), Object.defineProperty(t, "createUnaryPlus", {
    enumerable: !0,
    get: function() {
      return z.createUnaryPlus;
    }
  }), Object.defineProperty(t, "createAbs", {
    enumerable: !0,
    get: function() {
      return O.createAbs;
    }
  }), Object.defineProperty(t, "createApply", {
    enumerable: !0,
    get: function() {
      return G.createApply;
    }
  }), Object.defineProperty(t, "createAddScalar", {
    enumerable: !0,
    get: function() {
      return I.createAddScalar;
    }
  }), Object.defineProperty(t, "createCbrt", {
    enumerable: !0,
    get: function() {
      return k.createCbrt;
    }
  }), Object.defineProperty(t, "createCeil", {
    enumerable: !0,
    get: function() {
      return B.createCeil;
    }
  }), Object.defineProperty(t, "createCube", {
    enumerable: !0,
    get: function() {
      return L.createCube;
    }
  }), Object.defineProperty(t, "createExp", {
    enumerable: !0,
    get: function() {
      return V.createExp;
    }
  }), Object.defineProperty(t, "createExpm1", {
    enumerable: !0,
    get: function() {
      return U.createExpm1;
    }
  }), Object.defineProperty(t, "createFix", {
    enumerable: !0,
    get: function() {
      return J.createFix;
    }
  }), Object.defineProperty(t, "createFloor", {
    enumerable: !0,
    get: function() {
      return q.createFloor;
    }
  }), Object.defineProperty(t, "createGcd", {
    enumerable: !0,
    get: function() {
      return Z.createGcd;
    }
  }), Object.defineProperty(t, "createLcm", {
    enumerable: !0,
    get: function() {
      return ae.createLcm;
    }
  }), Object.defineProperty(t, "createLog10", {
    enumerable: !0,
    get: function() {
      return ee.createLog10;
    }
  }), Object.defineProperty(t, "createLog2", {
    enumerable: !0,
    get: function() {
      return se.createLog2;
    }
  }), Object.defineProperty(t, "createMod", {
    enumerable: !0,
    get: function() {
      return nr.createMod;
    }
  }), Object.defineProperty(t, "createMultiplyScalar", {
    enumerable: !0,
    get: function() {
      return ce.createMultiplyScalar;
    }
  }), Object.defineProperty(t, "createMultiply", {
    enumerable: !0,
    get: function() {
      return oe.createMultiply;
    }
  }), Object.defineProperty(t, "createNthRoot", {
    enumerable: !0,
    get: function() {
      return ur.createNthRoot;
    }
  }), Object.defineProperty(t, "createSign", {
    enumerable: !0,
    get: function() {
      return ir.createSign;
    }
  }), Object.defineProperty(t, "createSqrt", {
    enumerable: !0,
    get: function() {
      return _r.createSqrt;
    }
  }), Object.defineProperty(t, "createSquare", {
    enumerable: !0,
    get: function() {
      return yr.createSquare;
    }
  }), Object.defineProperty(t, "createSubtract", {
    enumerable: !0,
    get: function() {
      return ne.createSubtract;
    }
  }), Object.defineProperty(t, "createXgcd", {
    enumerable: !0,
    get: function() {
      return pe.createXgcd;
    }
  }), Object.defineProperty(t, "createDotMultiply", {
    enumerable: !0,
    get: function() {
      return hr.createDotMultiply;
    }
  }), Object.defineProperty(t, "createBitAnd", {
    enumerable: !0,
    get: function() {
      return $r.createBitAnd;
    }
  }), Object.defineProperty(t, "createBitNot", {
    enumerable: !0,
    get: function() {
      return Sr.createBitNot;
    }
  }), Object.defineProperty(t, "createBitOr", {
    enumerable: !0,
    get: function() {
      return ze.createBitOr;
    }
  }), Object.defineProperty(t, "createBitXor", {
    enumerable: !0,
    get: function() {
      return cr.createBitXor;
    }
  }), Object.defineProperty(t, "createArg", {
    enumerable: !0,
    get: function() {
      return fr.createArg;
    }
  }), Object.defineProperty(t, "createConj", {
    enumerable: !0,
    get: function() {
      return mr.createConj;
    }
  }), Object.defineProperty(t, "createIm", {
    enumerable: !0,
    get: function() {
      return wr.createIm;
    }
  }), Object.defineProperty(t, "createRe", {
    enumerable: !0,
    get: function() {
      return Nr.createRe;
    }
  }), Object.defineProperty(t, "createNot", {
    enumerable: !0,
    get: function() {
      return xr.createNot;
    }
  }), Object.defineProperty(t, "createOr", {
    enumerable: !0,
    get: function() {
      return Er.createOr;
    }
  }), Object.defineProperty(t, "createXor", {
    enumerable: !0,
    get: function() {
      return Ir.createXor;
    }
  }), Object.defineProperty(t, "createConcat", {
    enumerable: !0,
    get: function() {
      return Rr.createConcat;
    }
  }), Object.defineProperty(t, "createColumn", {
    enumerable: !0,
    get: function() {
      return Yr.createColumn;
    }
  }), Object.defineProperty(t, "createCross", {
    enumerable: !0,
    get: function() {
      return Qr.createCross;
    }
  }), Object.defineProperty(t, "createDiag", {
    enumerable: !0,
    get: function() {
      return nn.createDiag;
    }
  }), Object.defineProperty(t, "createFilter", {
    enumerable: !0,
    get: function() {
      return on.createFilter;
    }
  }), Object.defineProperty(t, "createFlatten", {
    enumerable: !0,
    get: function() {
      return en.createFlatten;
    }
  }), Object.defineProperty(t, "createForEach", {
    enumerable: !0,
    get: function() {
      return zr.createForEach;
    }
  }), Object.defineProperty(t, "createGetMatrixDataType", {
    enumerable: !0,
    get: function() {
      return Jr.createGetMatrixDataType;
    }
  }), Object.defineProperty(t, "createIdentity", {
    enumerable: !0,
    get: function() {
      return H.createIdentity;
    }
  }), Object.defineProperty(t, "createKron", {
    enumerable: !0,
    get: function() {
      return dr.createKron;
    }
  }), Object.defineProperty(t, "createMap", {
    enumerable: !0,
    get: function() {
      return Ar.createMap;
    }
  }), Object.defineProperty(t, "createDiff", {
    enumerable: !0,
    get: function() {
      return jr.createDiff;
    }
  }), Object.defineProperty(t, "createOnes", {
    enumerable: !0,
    get: function() {
      return Vr.createOnes;
    }
  }), Object.defineProperty(t, "createRange", {
    enumerable: !0,
    get: function() {
      return Zr.createRange;
    }
  }), Object.defineProperty(t, "createReshape", {
    enumerable: !0,
    get: function() {
      return pn.createReshape;
    }
  }), Object.defineProperty(t, "createResize", {
    enumerable: !0,
    get: function() {
      return gr.createResize;
    }
  }), Object.defineProperty(t, "createRotate", {
    enumerable: !0,
    get: function() {
      return Cr.createRotate;
    }
  }), Object.defineProperty(t, "createRotationMatrix", {
    enumerable: !0,
    get: function() {
      return Pr.createRotationMatrix;
    }
  }), Object.defineProperty(t, "createRow", {
    enumerable: !0,
    get: function() {
      return Tr.createRow;
    }
  }), Object.defineProperty(t, "createSize", {
    enumerable: !0,
    get: function() {
      return Xr.createSize;
    }
  }), Object.defineProperty(t, "createSqueeze", {
    enumerable: !0,
    get: function() {
      return rn.createSqueeze;
    }
  }), Object.defineProperty(t, "createSubset", {
    enumerable: !0,
    get: function() {
      return un.createSubset;
    }
  }), Object.defineProperty(t, "createTranspose", {
    enumerable: !0,
    get: function() {
      return ln.createTranspose;
    }
  }), Object.defineProperty(t, "createCtranspose", {
    enumerable: !0,
    get: function() {
      return bn.createCtranspose;
    }
  }), Object.defineProperty(t, "createZeros", {
    enumerable: !0,
    get: function() {
      return $n.createZeros;
    }
  }), Object.defineProperty(t, "createErf", {
    enumerable: !0,
    get: function() {
      return An.createErf;
    }
  }), Object.defineProperty(t, "createMode", {
    enumerable: !0,
    get: function() {
      return Nn.createMode;
    }
  }), Object.defineProperty(t, "createProd", {
    enumerable: !0,
    get: function() {
      return Pn.createProd;
    }
  }), Object.defineProperty(t, "createFormat", {
    enumerable: !0,
    get: function() {
      return Tn.createFormat;
    }
  }), Object.defineProperty(t, "createBin", {
    enumerable: !0,
    get: function() {
      return pr.createBin;
    }
  }), Object.defineProperty(t, "createOct", {
    enumerable: !0,
    get: function() {
      return Lr.createOct;
    }
  }), Object.defineProperty(t, "createHex", {
    enumerable: !0,
    get: function() {
      return Fr.createHex;
    }
  }), Object.defineProperty(t, "createPrint", {
    enumerable: !0,
    get: function() {
      return Br.createPrint;
    }
  }), Object.defineProperty(t, "createTo", {
    enumerable: !0,
    get: function() {
      return W.createTo;
    }
  }), Object.defineProperty(t, "createIsPrime", {
    enumerable: !0,
    get: function() {
      return Y.createIsPrime;
    }
  }), Object.defineProperty(t, "createNumeric", {
    enumerable: !0,
    get: function() {
      return X.createNumeric;
    }
  }), Object.defineProperty(t, "createDivideScalar", {
    enumerable: !0,
    get: function() {
      return K.createDivideScalar;
    }
  }), Object.defineProperty(t, "createPow", {
    enumerable: !0,
    get: function() {
      return te.createPow;
    }
  }), Object.defineProperty(t, "createRound", {
    enumerable: !0,
    get: function() {
      return ie.createRound;
    }
  }), Object.defineProperty(t, "createLog", {
    enumerable: !0,
    get: function() {
      return lr.createLog;
    }
  }), Object.defineProperty(t, "createLog1p", {
    enumerable: !0,
    get: function() {
      return vr.createLog1p;
    }
  }), Object.defineProperty(t, "createNthRoots", {
    enumerable: !0,
    get: function() {
      return Mr.createNthRoots;
    }
  }), Object.defineProperty(t, "createDotPow", {
    enumerable: !0,
    get: function() {
      return br.createDotPow;
    }
  }), Object.defineProperty(t, "createDotDivide", {
    enumerable: !0,
    get: function() {
      return Dr.createDotDivide;
    }
  }), Object.defineProperty(t, "createLsolve", {
    enumerable: !0,
    get: function() {
      return Or.createLsolve;
    }
  }), Object.defineProperty(t, "createUsolve", {
    enumerable: !0,
    get: function() {
      return kr.createUsolve;
    }
  }), Object.defineProperty(t, "createLsolveAll", {
    enumerable: !0,
    get: function() {
      return Gr.createLsolveAll;
    }
  }), Object.defineProperty(t, "createUsolveAll", {
    enumerable: !0,
    get: function() {
      return tn.createUsolveAll;
    }
  }), Object.defineProperty(t, "createLeftShift", {
    enumerable: !0,
    get: function() {
      return Wr.createLeftShift;
    }
  }), Object.defineProperty(t, "createRightArithShift", {
    enumerable: !0,
    get: function() {
      return yn.createRightArithShift;
    }
  }), Object.defineProperty(t, "createRightLogShift", {
    enumerable: !0,
    get: function() {
      return sn.createRightLogShift;
    }
  }), Object.defineProperty(t, "createAnd", {
    enumerable: !0,
    get: function() {
      return cn.createAnd;
    }
  }), Object.defineProperty(t, "createCompare", {
    enumerable: !0,
    get: function() {
      return Kr.createCompare;
    }
  }), Object.defineProperty(t, "createCompareNatural", {
    enumerable: !0,
    get: function() {
      return dn.createCompareNatural;
    }
  }), Object.defineProperty(t, "createCompareText", {
    enumerable: !0,
    get: function() {
      return On.createCompareText;
    }
  }), Object.defineProperty(t, "createEqual", {
    enumerable: !0,
    get: function() {
      return xn.createEqual;
    }
  }), Object.defineProperty(t, "createEqualText", {
    enumerable: !0,
    get: function() {
      return Gn.createEqualText;
    }
  }), Object.defineProperty(t, "createSmaller", {
    enumerable: !0,
    get: function() {
      return In.createSmaller;
    }
  }), Object.defineProperty(t, "createSmallerEq", {
    enumerable: !0,
    get: function() {
      return Dn.createSmallerEq;
    }
  }), Object.defineProperty(t, "createLarger", {
    enumerable: !0,
    get: function() {
      return kn.createLarger;
    }
  }), Object.defineProperty(t, "createLargerEq", {
    enumerable: !0,
    get: function() {
      return fn.createLargerEq;
    }
  }), Object.defineProperty(t, "createDeepEqual", {
    enumerable: !0,
    get: function() {
      return wn.createDeepEqual;
    }
  }), Object.defineProperty(t, "createUnequal", {
    enumerable: !0,
    get: function() {
      return Ln.createUnequal;
    }
  }), Object.defineProperty(t, "createPartitionSelect", {
    enumerable: !0,
    get: function() {
      return jn.createPartitionSelect;
    }
  }), Object.defineProperty(t, "createSort", {
    enumerable: !0,
    get: function() {
      return mn.createSort;
    }
  }), Object.defineProperty(t, "createMax", {
    enumerable: !0,
    get: function() {
      return an.createMax;
    }
  }), Object.defineProperty(t, "createMin", {
    enumerable: !0,
    get: function() {
      return $a.createMin;
    }
  }), Object.defineProperty(t, "createImmutableDenseMatrixClass", {
    enumerable: !0,
    get: function() {
      return xa.createImmutableDenseMatrixClass;
    }
  }), Object.defineProperty(t, "createIndexClass", {
    enumerable: !0,
    get: function() {
      return wa.createIndexClass;
    }
  }), Object.defineProperty(t, "createFibonacciHeapClass", {
    enumerable: !0,
    get: function() {
      return Mn.createFibonacciHeapClass;
    }
  }), Object.defineProperty(t, "createSpaClass", {
    enumerable: !0,
    get: function() {
      return Kn.createSpaClass;
    }
  }), Object.defineProperty(t, "createUnitClass", {
    enumerable: !0,
    get: function() {
      return Ma.createUnitClass;
    }
  }), Object.defineProperty(t, "createUnitFunction", {
    enumerable: !0,
    get: function() {
      return qn.createUnitFunction;
    }
  }), Object.defineProperty(t, "createSparse", {
    enumerable: !0,
    get: function() {
      return Cn.createSparse;
    }
  }), Object.defineProperty(t, "createCreateUnit", {
    enumerable: !0,
    get: function() {
      return ea.createCreateUnit;
    }
  }), Object.defineProperty(t, "createAcos", {
    enumerable: !0,
    get: function() {
      return _n.createAcos;
    }
  }), Object.defineProperty(t, "createAcosh", {
    enumerable: !0,
    get: function() {
      return Ca.createAcosh;
    }
  }), Object.defineProperty(t, "createAcot", {
    enumerable: !0,
    get: function() {
      return Sa.createAcot;
    }
  }), Object.defineProperty(t, "createAcoth", {
    enumerable: !0,
    get: function() {
      return Da.createAcoth;
    }
  }), Object.defineProperty(t, "createAcsc", {
    enumerable: !0,
    get: function() {
      return Na.createAcsc;
    }
  }), Object.defineProperty(t, "createAcsch", {
    enumerable: !0,
    get: function() {
      return Aa.createAcsch;
    }
  }), Object.defineProperty(t, "createAsec", {
    enumerable: !0,
    get: function() {
      return Pa.createAsec;
    }
  }), Object.defineProperty(t, "createAsech", {
    enumerable: !0,
    get: function() {
      return Rn.createAsech;
    }
  }), Object.defineProperty(t, "createAsin", {
    enumerable: !0,
    get: function() {
      return Ea.createAsin;
    }
  }), Object.defineProperty(t, "createAsinh", {
    enumerable: !0,
    get: function() {
      return Ta.createAsinh;
    }
  }), Object.defineProperty(t, "createAtan", {
    enumerable: !0,
    get: function() {
      return En.createAtan;
    }
  }), Object.defineProperty(t, "createAtan2", {
    enumerable: !0,
    get: function() {
      return Oa.createAtan2;
    }
  }), Object.defineProperty(t, "createAtanh", {
    enumerable: !0,
    get: function() {
      return Hn.createAtanh;
    }
  }), Object.defineProperty(t, "createCos", {
    enumerable: !0,
    get: function() {
      return Zn.createCos;
    }
  }), Object.defineProperty(t, "createCosh", {
    enumerable: !0,
    get: function() {
      return Sn.createCosh;
    }
  }), Object.defineProperty(t, "createCot", {
    enumerable: !0,
    get: function() {
      return Ia.createCot;
    }
  }), Object.defineProperty(t, "createCoth", {
    enumerable: !0,
    get: function() {
      return ka.createCoth;
    }
  }), Object.defineProperty(t, "createCsc", {
    enumerable: !0,
    get: function() {
      return ta.createCsc;
    }
  }), Object.defineProperty(t, "createCsch", {
    enumerable: !0,
    get: function() {
      return ra.createCsch;
    }
  }), Object.defineProperty(t, "createSec", {
    enumerable: !0,
    get: function() {
      return La.createSec;
    }
  }), Object.defineProperty(t, "createSech", {
    enumerable: !0,
    get: function() {
      return ja.createSech;
    }
  }), Object.defineProperty(t, "createSin", {
    enumerable: !0,
    get: function() {
      return Ra.createSin;
    }
  }), Object.defineProperty(t, "createSinh", {
    enumerable: !0,
    get: function() {
      return Fa.createSinh;
    }
  }), Object.defineProperty(t, "createTan", {
    enumerable: !0,
    get: function() {
      return na.createTan;
    }
  }), Object.defineProperty(t, "createTanh", {
    enumerable: !0,
    get: function() {
      return Wn.createTanh;
    }
  }), Object.defineProperty(t, "createSetCartesian", {
    enumerable: !0,
    get: function() {
      return Ba.createSetCartesian;
    }
  }), Object.defineProperty(t, "createSetDifference", {
    enumerable: !0,
    get: function() {
      return Ga.createSetDifference;
    }
  }), Object.defineProperty(t, "createSetDistinct", {
    enumerable: !0,
    get: function() {
      return za.createSetDistinct;
    }
  }), Object.defineProperty(t, "createSetIntersect", {
    enumerable: !0,
    get: function() {
      return Yn.createSetIntersect;
    }
  }), Object.defineProperty(t, "createSetIsSubset", {
    enumerable: !0,
    get: function() {
      return Fn.createSetIsSubset;
    }
  }), Object.defineProperty(t, "createSetMultiplicity", {
    enumerable: !0,
    get: function() {
      return Va.createSetMultiplicity;
    }
  }), Object.defineProperty(t, "createSetPowerset", {
    enumerable: !0,
    get: function() {
      return aa.createSetPowerset;
    }
  }), Object.defineProperty(t, "createSetSize", {
    enumerable: !0,
    get: function() {
      return Wa.createSetSize;
    }
  }), Object.defineProperty(t, "createSetSymDifference", {
    enumerable: !0,
    get: function() {
      return Ua.createSetSymDifference;
    }
  }), Object.defineProperty(t, "createSetUnion", {
    enumerable: !0,
    get: function() {
      return qa.createSetUnion;
    }
  }), Object.defineProperty(t, "createAdd", {
    enumerable: !0,
    get: function() {
      return Ha.createAdd;
    }
  }), Object.defineProperty(t, "createHypot", {
    enumerable: !0,
    get: function() {
      return Za.createHypot;
    }
  }), Object.defineProperty(t, "createNorm", {
    enumerable: !0,
    get: function() {
      return Ya.createNorm;
    }
  }), Object.defineProperty(t, "createDot", {
    enumerable: !0,
    get: function() {
      return ia.createDot;
    }
  }), Object.defineProperty(t, "createTrace", {
    enumerable: !0,
    get: function() {
      return Un.createTrace;
    }
  }), Object.defineProperty(t, "createIndex", {
    enumerable: !0,
    get: function() {
      return Xa.createIndex;
    }
  }), Object.defineProperty(t, "createNode", {
    enumerable: !0,
    get: function() {
      return sa.createNode;
    }
  }), Object.defineProperty(t, "createAccessorNode", {
    enumerable: !0,
    get: function() {
      return gn.createAccessorNode;
    }
  }), Object.defineProperty(t, "createArrayNode", {
    enumerable: !0,
    get: function() {
      return Qa.createArrayNode;
    }
  }), Object.defineProperty(t, "createAssignmentNode", {
    enumerable: !0,
    get: function() {
      return Xn.createAssignmentNode;
    }
  }), Object.defineProperty(t, "createBlockNode", {
    enumerable: !0,
    get: function() {
      return Ja.createBlockNode;
    }
  }), Object.defineProperty(t, "createConditionalNode", {
    enumerable: !0,
    get: function() {
      return Ka.createConditionalNode;
    }
  }), Object.defineProperty(t, "createConstantNode", {
    enumerable: !0,
    get: function() {
      return zn.createConstantNode;
    }
  }), Object.defineProperty(t, "createFunctionAssignmentNode", {
    enumerable: !0,
    get: function() {
      return oa.createFunctionAssignmentNode;
    }
  }), Object.defineProperty(t, "createIndexNode", {
    enumerable: !0,
    get: function() {
      return ei.createIndexNode;
    }
  }), Object.defineProperty(t, "createObjectNode", {
    enumerable: !0,
    get: function() {
      return ca.createObjectNode;
    }
  }), Object.defineProperty(t, "createOperatorNode", {
    enumerable: !0,
    get: function() {
      return da.createOperatorNode;
    }
  }), Object.defineProperty(t, "createParenthesisNode", {
    enumerable: !0,
    get: function() {
      return ti.createParenthesisNode;
    }
  }), Object.defineProperty(t, "createRangeNode", {
    enumerable: !0,
    get: function() {
      return la.createRangeNode;
    }
  }), Object.defineProperty(t, "createRelationalNode", {
    enumerable: !0,
    get: function() {
      return ri.createRelationalNode;
    }
  }), Object.defineProperty(t, "createSymbolNode", {
    enumerable: !0,
    get: function() {
      return ni.createSymbolNode;
    }
  }), Object.defineProperty(t, "createFunctionNode", {
    enumerable: !0,
    get: function() {
      return ai.createFunctionNode;
    }
  }), Object.defineProperty(t, "createParse", {
    enumerable: !0,
    get: function() {
      return hn.createParse;
    }
  }), Object.defineProperty(t, "createCompile", {
    enumerable: !0,
    get: function() {
      return ii.createCompile;
    }
  }), Object.defineProperty(t, "createEvaluate", {
    enumerable: !0,
    get: function() {
      return ua.createEvaluate;
    }
  }), Object.defineProperty(t, "createParserClass", {
    enumerable: !0,
    get: function() {
      return si.createParserClass;
    }
  }), Object.defineProperty(t, "createParser", {
    enumerable: !0,
    get: function() {
      return pa.createParser;
    }
  }), Object.defineProperty(t, "createLup", {
    enumerable: !0,
    get: function() {
      return oi.createLup;
    }
  }), Object.defineProperty(t, "createQr", {
    enumerable: !0,
    get: function() {
      return Qn.createQr;
    }
  }), Object.defineProperty(t, "createSlu", {
    enumerable: !0,
    get: function() {
      return fa.createSlu;
    }
  }), Object.defineProperty(t, "createLusolve", {
    enumerable: !0,
    get: function() {
      return ha.createLusolve;
    }
  }), Object.defineProperty(t, "createHelpClass", {
    enumerable: !0,
    get: function() {
      return ci.createHelpClass;
    }
  }), Object.defineProperty(t, "createChainClass", {
    enumerable: !0,
    get: function() {
      return ma.createChainClass;
    }
  }), Object.defineProperty(t, "createHelp", {
    enumerable: !0,
    get: function() {
      return di.createHelp;
    }
  }), Object.defineProperty(t, "createChain", {
    enumerable: !0,
    get: function() {
      return li.createChain;
    }
  }), Object.defineProperty(t, "createDet", {
    enumerable: !0,
    get: function() {
      return Jn.createDet;
    }
  }), Object.defineProperty(t, "createInv", {
    enumerable: !0,
    get: function() {
      return ga.createInv;
    }
  }), Object.defineProperty(t, "createEigs", {
    enumerable: !0,
    get: function() {
      return ui.createEigs;
    }
  }), Object.defineProperty(t, "createExpm", {
    enumerable: !0,
    get: function() {
      return fi.createExpm;
    }
  }), Object.defineProperty(t, "createSqrtm", {
    enumerable: !0,
    get: function() {
      return hi.createSqrtm;
    }
  }), Object.defineProperty(t, "createDivide", {
    enumerable: !0,
    get: function() {
      return Vn.createDivide;
    }
  }), Object.defineProperty(t, "createDistance", {
    enumerable: !0,
    get: function() {
      return mi.createDistance;
    }
  }), Object.defineProperty(t, "createIntersect", {
    enumerable: !0,
    get: function() {
      return Bn.createIntersect;
    }
  }), Object.defineProperty(t, "createSum", {
    enumerable: !0,
    get: function() {
      return gi.createSum;
    }
  }), Object.defineProperty(t, "createMean", {
    enumerable: !0,
    get: function() {
      return va.createMean;
    }
  }), Object.defineProperty(t, "createMedian", {
    enumerable: !0,
    get: function() {
      return vi.createMedian;
    }
  }), Object.defineProperty(t, "createMad", {
    enumerable: !0,
    get: function() {
      return yi.createMad;
    }
  }), Object.defineProperty(t, "createVariance", {
    enumerable: !0,
    get: function() {
      return bi.createVariance;
    }
  }), Object.defineProperty(t, "createQuantileSeq", {
    enumerable: !0,
    get: function() {
      return Hr.createQuantileSeq;
    }
  }), Object.defineProperty(t, "createStd", {
    enumerable: !0,
    get: function() {
      return $i.createStd;
    }
  }), Object.defineProperty(t, "createCombinations", {
    enumerable: !0,
    get: function() {
      return ya.createCombinations;
    }
  }), Object.defineProperty(t, "createCombinationsWithRep", {
    enumerable: !0,
    get: function() {
      return xi.createCombinationsWithRep;
    }
  }), Object.defineProperty(t, "createGamma", {
    enumerable: !0,
    get: function() {
      return wi.createGamma;
    }
  }), Object.defineProperty(t, "createFactorial", {
    enumerable: !0,
    get: function() {
      return Mi.createFactorial;
    }
  }), Object.defineProperty(t, "createKldivergence", {
    enumerable: !0,
    get: function() {
      return Ci.createKldivergence;
    }
  }), Object.defineProperty(t, "createMultinomial", {
    enumerable: !0,
    get: function() {
      return Si.createMultinomial;
    }
  }), Object.defineProperty(t, "createPermutations", {
    enumerable: !0,
    get: function() {
      return Di.createPermutations;
    }
  }), Object.defineProperty(t, "createPickRandom", {
    enumerable: !0,
    get: function() {
      return Ni.createPickRandom;
    }
  }), Object.defineProperty(t, "createRandom", {
    enumerable: !0,
    get: function() {
      return Ai.createRandom;
    }
  }), Object.defineProperty(t, "createRandomInt", {
    enumerable: !0,
    get: function() {
      return Pi.createRandomInt;
    }
  }), Object.defineProperty(t, "createStirlingS2", {
    enumerable: !0,
    get: function() {
      return Ei.createStirlingS2;
    }
  }), Object.defineProperty(t, "createBellNumbers", {
    enumerable: !0,
    get: function() {
      return Ti.createBellNumbers;
    }
  }), Object.defineProperty(t, "createCatalan", {
    enumerable: !0,
    get: function() {
      return Oi.createCatalan;
    }
  }), Object.defineProperty(t, "createComposition", {
    enumerable: !0,
    get: function() {
      return Ii.createComposition;
    }
  }), Object.defineProperty(t, "createSimplify", {
    enumerable: !0,
    get: function() {
      return ki.createSimplify;
    }
  }), Object.defineProperty(t, "createDerivative", {
    enumerable: !0,
    get: function() {
      return Li.createDerivative;
    }
  }), Object.defineProperty(t, "createRationalize", {
    enumerable: !0,
    get: function() {
      return ji.createRationalize;
    }
  }), Object.defineProperty(t, "createReviver", {
    enumerable: !0,
    get: function() {
      return Ri.createReviver;
    }
  }), Object.defineProperty(t, "createReplacer", {
    enumerable: !0,
    get: function() {
      return Fi.createReplacer;
    }
  }), Object.defineProperty(t, "createE", {
    enumerable: !0,
    get: function() {
      return vn.createE;
    }
  }), Object.defineProperty(t, "createUppercaseE", {
    enumerable: !0,
    get: function() {
      return vn.createUppercaseE;
    }
  }), Object.defineProperty(t, "createFalse", {
    enumerable: !0,
    get: function() {
      return vn.createFalse;
    }
  }), Object.defineProperty(t, "createI", {
    enumerable: !0,
    get: function() {
      return vn.createI;
    }
  }), Object.defineProperty(t, "createInfinity", {
    enumerable: !0,
    get: function() {
      return vn.createInfinity;
    }
  }), Object.defineProperty(t, "createLN10", {
    enumerable: !0,
    get: function() {
      return vn.createLN10;
    }
  }), Object.defineProperty(t, "createLN2", {
    enumerable: !0,
    get: function() {
      return vn.createLN2;
    }
  }), Object.defineProperty(t, "createLOG10E", {
    enumerable: !0,
    get: function() {
      return vn.createLOG10E;
    }
  }), Object.defineProperty(t, "createLOG2E", {
    enumerable: !0,
    get: function() {
      return vn.createLOG2E;
    }
  }), Object.defineProperty(t, "createNaN", {
    enumerable: !0,
    get: function() {
      return vn.createNaN;
    }
  }), Object.defineProperty(t, "createNull", {
    enumerable: !0,
    get: function() {
      return vn.createNull;
    }
  }), Object.defineProperty(t, "createPhi", {
    enumerable: !0,
    get: function() {
      return vn.createPhi;
    }
  }), Object.defineProperty(t, "createPi", {
    enumerable: !0,
    get: function() {
      return vn.createPi;
    }
  }), Object.defineProperty(t, "createUppercasePi", {
    enumerable: !0,
    get: function() {
      return vn.createUppercasePi;
    }
  }), Object.defineProperty(t, "createSQRT1_2", {
    enumerable: !0,
    get: function() {
      return vn.createSQRT1_2;
    }
  }), Object.defineProperty(t, "createSQRT2", {
    enumerable: !0,
    get: function() {
      return vn.createSQRT2;
    }
  }), Object.defineProperty(t, "createTau", {
    enumerable: !0,
    get: function() {
      return vn.createTau;
    }
  }), Object.defineProperty(t, "createTrue", {
    enumerable: !0,
    get: function() {
      return vn.createTrue;
    }
  }), Object.defineProperty(t, "createVersion", {
    enumerable: !0,
    get: function() {
      return vn.createVersion;
    }
  }), Object.defineProperty(t, "createAtomicMass", {
    enumerable: !0,
    get: function() {
      return Ur.createAtomicMass;
    }
  }), Object.defineProperty(t, "createAvogadro", {
    enumerable: !0,
    get: function() {
      return Ur.createAvogadro;
    }
  }), Object.defineProperty(t, "createBohrMagneton", {
    enumerable: !0,
    get: function() {
      return Ur.createBohrMagneton;
    }
  }), Object.defineProperty(t, "createBohrRadius", {
    enumerable: !0,
    get: function() {
      return Ur.createBohrRadius;
    }
  }), Object.defineProperty(t, "createBoltzmann", {
    enumerable: !0,
    get: function() {
      return Ur.createBoltzmann;
    }
  }), Object.defineProperty(t, "createClassicalElectronRadius", {
    enumerable: !0,
    get: function() {
      return Ur.createClassicalElectronRadius;
    }
  }), Object.defineProperty(t, "createConductanceQuantum", {
    enumerable: !0,
    get: function() {
      return Ur.createConductanceQuantum;
    }
  }), Object.defineProperty(t, "createCoulomb", {
    enumerable: !0,
    get: function() {
      return Ur.createCoulomb;
    }
  }), Object.defineProperty(t, "createDeuteronMass", {
    enumerable: !0,
    get: function() {
      return Ur.createDeuteronMass;
    }
  }), Object.defineProperty(t, "createEfimovFactor", {
    enumerable: !0,
    get: function() {
      return Ur.createEfimovFactor;
    }
  }), Object.defineProperty(t, "createElectricConstant", {
    enumerable: !0,
    get: function() {
      return Ur.createElectricConstant;
    }
  }), Object.defineProperty(t, "createElectronMass", {
    enumerable: !0,
    get: function() {
      return Ur.createElectronMass;
    }
  }), Object.defineProperty(t, "createElementaryCharge", {
    enumerable: !0,
    get: function() {
      return Ur.createElementaryCharge;
    }
  }), Object.defineProperty(t, "createFaraday", {
    enumerable: !0,
    get: function() {
      return Ur.createFaraday;
    }
  }), Object.defineProperty(t, "createFermiCoupling", {
    enumerable: !0,
    get: function() {
      return Ur.createFermiCoupling;
    }
  }), Object.defineProperty(t, "createFineStructure", {
    enumerable: !0,
    get: function() {
      return Ur.createFineStructure;
    }
  }), Object.defineProperty(t, "createFirstRadiation", {
    enumerable: !0,
    get: function() {
      return Ur.createFirstRadiation;
    }
  }), Object.defineProperty(t, "createGasConstant", {
    enumerable: !0,
    get: function() {
      return Ur.createGasConstant;
    }
  }), Object.defineProperty(t, "createGravitationConstant", {
    enumerable: !0,
    get: function() {
      return Ur.createGravitationConstant;
    }
  }), Object.defineProperty(t, "createGravity", {
    enumerable: !0,
    get: function() {
      return Ur.createGravity;
    }
  }), Object.defineProperty(t, "createHartreeEnergy", {
    enumerable: !0,
    get: function() {
      return Ur.createHartreeEnergy;
    }
  }), Object.defineProperty(t, "createInverseConductanceQuantum", {
    enumerable: !0,
    get: function() {
      return Ur.createInverseConductanceQuantum;
    }
  }), Object.defineProperty(t, "createKlitzing", {
    enumerable: !0,
    get: function() {
      return Ur.createKlitzing;
    }
  }), Object.defineProperty(t, "createLoschmidt", {
    enumerable: !0,
    get: function() {
      return Ur.createLoschmidt;
    }
  }), Object.defineProperty(t, "createMagneticConstant", {
    enumerable: !0,
    get: function() {
      return Ur.createMagneticConstant;
    }
  }), Object.defineProperty(t, "createMagneticFluxQuantum", {
    enumerable: !0,
    get: function() {
      return Ur.createMagneticFluxQuantum;
    }
  }), Object.defineProperty(t, "createMolarMass", {
    enumerable: !0,
    get: function() {
      return Ur.createMolarMass;
    }
  }), Object.defineProperty(t, "createMolarMassC12", {
    enumerable: !0,
    get: function() {
      return Ur.createMolarMassC12;
    }
  }), Object.defineProperty(t, "createMolarPlanckConstant", {
    enumerable: !0,
    get: function() {
      return Ur.createMolarPlanckConstant;
    }
  }), Object.defineProperty(t, "createMolarVolume", {
    enumerable: !0,
    get: function() {
      return Ur.createMolarVolume;
    }
  }), Object.defineProperty(t, "createNeutronMass", {
    enumerable: !0,
    get: function() {
      return Ur.createNeutronMass;
    }
  }), Object.defineProperty(t, "createNuclearMagneton", {
    enumerable: !0,
    get: function() {
      return Ur.createNuclearMagneton;
    }
  }), Object.defineProperty(t, "createPlanckCharge", {
    enumerable: !0,
    get: function() {
      return Ur.createPlanckCharge;
    }
  }), Object.defineProperty(t, "createPlanckConstant", {
    enumerable: !0,
    get: function() {
      return Ur.createPlanckConstant;
    }
  }), Object.defineProperty(t, "createPlanckLength", {
    enumerable: !0,
    get: function() {
      return Ur.createPlanckLength;
    }
  }), Object.defineProperty(t, "createPlanckMass", {
    enumerable: !0,
    get: function() {
      return Ur.createPlanckMass;
    }
  }), Object.defineProperty(t, "createPlanckTemperature", {
    enumerable: !0,
    get: function() {
      return Ur.createPlanckTemperature;
    }
  }), Object.defineProperty(t, "createPlanckTime", {
    enumerable: !0,
    get: function() {
      return Ur.createPlanckTime;
    }
  }), Object.defineProperty(t, "createProtonMass", {
    enumerable: !0,
    get: function() {
      return Ur.createProtonMass;
    }
  }), Object.defineProperty(t, "createQuantumOfCirculation", {
    enumerable: !0,
    get: function() {
      return Ur.createQuantumOfCirculation;
    }
  }), Object.defineProperty(t, "createReducedPlanckConstant", {
    enumerable: !0,
    get: function() {
      return Ur.createReducedPlanckConstant;
    }
  }), Object.defineProperty(t, "createRydberg", {
    enumerable: !0,
    get: function() {
      return Ur.createRydberg;
    }
  }), Object.defineProperty(t, "createSackurTetrode", {
    enumerable: !0,
    get: function() {
      return Ur.createSackurTetrode;
    }
  }), Object.defineProperty(t, "createSecondRadiation", {
    enumerable: !0,
    get: function() {
      return Ur.createSecondRadiation;
    }
  }), Object.defineProperty(t, "createSpeedOfLight", {
    enumerable: !0,
    get: function() {
      return Ur.createSpeedOfLight;
    }
  }), Object.defineProperty(t, "createStefanBoltzmann", {
    enumerable: !0,
    get: function() {
      return Ur.createStefanBoltzmann;
    }
  }), Object.defineProperty(t, "createThomsonCrossSection", {
    enumerable: !0,
    get: function() {
      return Ur.createThomsonCrossSection;
    }
  }), Object.defineProperty(t, "createVacuumImpedance", {
    enumerable: !0,
    get: function() {
      return Ur.createVacuumImpedance;
    }
  }), Object.defineProperty(t, "createWeakMixingAngle", {
    enumerable: !0,
    get: function() {
      return Ur.createWeakMixingAngle;
    }
  }), Object.defineProperty(t, "createWienDisplacement", {
    enumerable: !0,
    get: function() {
      return Ur.createWienDisplacement;
    }
  }), Object.defineProperty(t, "createApplyTransform", {
    enumerable: !0,
    get: function() {
      return Bi.createApplyTransform;
    }
  }), Object.defineProperty(t, "createColumnTransform", {
    enumerable: !0,
    get: function() {
      return Gi.createColumnTransform;
    }
  }), Object.defineProperty(t, "createFilterTransform", {
    enumerable: !0,
    get: function() {
      return zi.createFilterTransform;
    }
  }), Object.defineProperty(t, "createForEachTransform", {
    enumerable: !0,
    get: function() {
      return Vi.createForEachTransform;
    }
  }), Object.defineProperty(t, "createIndexTransform", {
    enumerable: !0,
    get: function() {
      return Wi.createIndexTransform;
    }
  }), Object.defineProperty(t, "createMapTransform", {
    enumerable: !0,
    get: function() {
      return _a.createMapTransform;
    }
  }), Object.defineProperty(t, "createMaxTransform", {
    enumerable: !0,
    get: function() {
      return ba.createMaxTransform;
    }
  }), Object.defineProperty(t, "createMeanTransform", {
    enumerable: !0,
    get: function() {
      return Ui.createMeanTransform;
    }
  }), Object.defineProperty(t, "createMinTransform", {
    enumerable: !0,
    get: function() {
      return qi.createMinTransform;
    }
  }), Object.defineProperty(t, "createRangeTransform", {
    enumerable: !0,
    get: function() {
      return Hi.createRangeTransform;
    }
  }), Object.defineProperty(t, "createRowTransform", {
    enumerable: !0,
    get: function() {
      return Zi.createRowTransform;
    }
  }), Object.defineProperty(t, "createSubsetTransform", {
    enumerable: !0,
    get: function() {
      return Yi.createSubsetTransform;
    }
  }), Object.defineProperty(t, "createConcatTransform", {
    enumerable: !0,
    get: function() {
      return Xi.createConcatTransform;
    }
  }), Object.defineProperty(t, "createDiffTransform", {
    enumerable: !0,
    get: function() {
      return Qi.createDiffTransform;
    }
  }), Object.defineProperty(t, "createStdTransform", {
    enumerable: !0,
    get: function() {
      return Ji.createStdTransform;
    }
  }), Object.defineProperty(t, "createSumTransform", {
    enumerable: !0,
    get: function() {
      return Ki.createSumTransform;
    }
  }), Object.defineProperty(t, "createVarianceTransform", {
    enumerable: !0,
    get: function() {
      return ts.createVarianceTransform;
    }
  });
  var r = typed$1, n = ResultSet, a = BigNumber, s = Complex, o = Fraction, c = Range, l = Matrix, d = DenseMatrix, h = clone$3, u = isInteger$1, p = isNegative$1, m = isNumeric$1, g = hasNumericValue$1, v = isPositive$1, y = isZero$1, x = _isNaN$2, _ = typeOf$1, $ = equalScalar, b = SparseMatrix, M = number$1, C = string$1, S = boolean$1, A = bignumber$1, D = complex$1, N = fraction$1, T = matrix$2, R = splitUnit$1, F = unaryMinus$1, z = unaryPlus$1, O = abs$3, G = apply, I = addScalar, k = cbrt$1, B = ceil$1, L = cube$1, V = exp$1, U = expm1$1, J = fix$1, q = floor$2, Z = gcd$1, ae = lcm$1, ee = log10$1, se = log2$1, nr = mod$3, ce = multiplyScalar, oe = multiply$1, ur = nthRoot$1, ir = sign$2, _r = sqrt$1, yr = square$1, ne = subtract$3, pe = xgcd$1, hr = dotMultiply$1, $r = bitAnd$1, Sr = bitNot$1, ze = bitOr$1, cr = bitXor$1, fr = arg$1, mr = conj$1, wr = im$1, Nr = re$1, xr = not$1, Er = or$1, Ir = xor$1, Rr = concat$1, Yr = column$2, Qr = cross$1, nn = diag$1, on = filter$1, en = flatten$2, zr = forEach$1, Jr = getMatrixDataType$1, H = identity$1, dr = kron$1, Ar = map$2, jr = diff$2, Vr = ones$1, Zr = range$1, pn = reshape$1, gr = resize$1, Cr = rotate$1, Pr = rotationMatrix$1, Tr = row$1, Xr = size$1, rn = squeeze$1, un = subset$1, ln = transpose$1, bn = ctranspose$1, $n = zeros$1, An = erf$1, Nn = mode$1, Pn = prod$1, Tn = format$2, pr = bin$1, Lr = oct$1, Fr = hex$1, Br = print, W = to$2, Y = isPrime$1, X = numeric$1, K = divideScalar, te = pow$1, ie = round$3, lr = log$1, vr = log1p$1, Mr = nthRoots$1, br = dotPow$1, Dr = dotDivide$1, Or = lsolve$1, kr = usolve$1, Gr = lsolveAll$1, tn = usolveAll$1, Wr = leftShift$1, yn = rightArithShift$1, sn = rightLogShift$1, cn = and$1, Kr = compare$1, dn = compareNatural$1, On = compareText$1, xn = equal$1, Gn = equalText$1, In = smaller$1, Dn = smallerEq$1, kn = larger$1, fn = largerEq$1, wn = deepEqual$1, Ln = unequal$1, jn = partitionSelect$1, mn = sort$1, an = max$3, $a = min$3, xa = ImmutableDenseMatrix, wa = MatrixIndex, Mn = FibonacciHeap, Kn = Spa, Ma = Unit, qn = unit$1, Cn = sparse$1, ea = createUnit$1, _n = acos$1, Ca = acosh$1, Sa = acot$1, Da = acoth$1, Na = acsc$1, Aa = acsch$1, Pa = asec$1, Rn = asech$1, Ea = asin$1, Ta = asinh$1, En = atan$1, Oa = atan2$1, Hn = atanh$1, Zn = cos$1, Sn = cosh$1, Ia = cot$1, ka = coth$1, ta = csc$1, ra = csch$1, La = sec$1, ja = sech$1, Ra = sin$1, Fa = sinh$1, na = tan$1, Wn = tanh$1, Ba = setCartesian$1, Ga = setDifference$1, za = setDistinct$1, Yn = setIntersect$1, Fn = setIsSubset$1, Va = setMultiplicity$1, aa = setPowerset$1, Wa = setSize$1, Ua = setSymDifference$1, qa = setUnion$1, Ha = add$3, Za = hypot$1, Ya = norm$1, ia = dot$1, Un = trace$1, Xa = _function$3, sa = Node$1, gn = AccessorNode, Qa = ArrayNode, Xn = AssignmentNode, Ja = BlockNode, Ka = ConditionalNode, zn = ConstantNode, oa = FunctionAssignmentNode, ei = IndexNode, ca = ObjectNode, da = OperatorNode, ti = ParenthesisNode, la = RangeNode, ri = RelationalNode, ni = SymbolNode, ai = FunctionNode, hn = parse$2, ii = compile$1, ua = evaluate$2, si = Parser, pa = parser, oi = lup$1, Qn = qr$1, fa = slu$1, ha = lusolve$1, ci = Help, ma = Chain, di = help$1, li = chain, Jn = det, ga = inv, ui = eigs, fi = expm, hi = sqrtm, Vn = divide, mi = distance, Bn = intersect, gi = sum, va = mean, vi = median, yi = mad, bi = variance, Hr = quantileSeq, $i = std, ya = combinations, xi = combinationsWithRep, wi = gamma, Mi = factorial, Ci = kldivergence, Si = multinomial, Di = permutations, Ni = pickRandom, Ai = random, Pi = randomInt, Ei = stirlingS2, Ti = bellNumbers, Oi = catalan, Ii = composition, ki = simplify, Li = derivative, ji = rationalize, Ri = reviver, Fi = replacer, vn = constants$1, Ur = physicalConstants, Bi = apply_transform, Gi = column_transform, zi = filter_transform, Vi = forEach_transform, Wi = index_transform, _a = map_transform, ba = max_transform, Ui = mean_transform, qi = min_transform, Hi = range_transform, Zi = row_transform, Yi = subset_transform, Xi = concat_transform, Qi = diff_transform, Ji = std_transform, Ki = sum_transform, ts = variance_transform;
})(factoriesAny);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.matrix = t.SparseMatrix = t.isNegative = t.SQRT2 = t.random = t.combinationsWithRep = t.sin = t.csc = t.cos = t.asinh = t.acsch = t.acosh = t.bin = t.mode = t.getMatrixDataType = t.conj = t.sqrt = t.log2 = t.exp = t.addScalar = t.unaryMinus = t.fraction = t.string = t.typeOf = t.hasNumericValue = t.clone = t.LN2 = t.randomInt = t.pickRandom = t.combinations = t.tanh = t.sinh = t.sech = t.csch = t.coth = t.cosh = t.atanh = t.atan = t.asin = t.asec = t.acsc = t.acot = t.acos = t.isPrime = t.print = t.oct = t.format = t.erf = t.map = t.forEach = t.filter = t.not = t.im = t.arg = t.bitNot = t.square = t.sign = t.multiplyScalar = t.log10 = t.expm1 = t.cube = t.apply = t.unaryPlus = t.splitUnit = t.complex = t.boolean = t.number = t.equalScalar = t.isNaN = t.isPositive = t.isNumeric = t.isInteger = t.typed = t.phi = t.DenseMatrix = t.version = t.LOG2E = t._Infinity = t.e = t.Fraction = t.weakMixingAngle = t.sackurTetrode = t.fineStructure = t.efimovFactor = t.tau = t.SQRT1_2 = t.pi = t._NaN = t.LOG10E = t.LN10 = t.i = t.replacer = t.Matrix = t.BigNumber = t._true = t._null = t._false = t.Range = t.Complex = t.ResultSet = void 0, t.setUnion = t.Spa = t.lsolveAll = t.lsolve = t.nthRoots = t.divideScalar = t.xor = t.setIsSubset = t.deepEqual = t.ctranspose = t.column = t.fix = t.setSymDifference = t.setCartesian = t.max = t.equal = t.prod = t.row = t.range = t.cross = t.subtract = t.ceil = t.permutations = t.factorial = t.sum = t.index = t.setPowerset = t.setDistinct = t.cot = t.min = t.sort = t.smallerEq = t.and = t.numeric = t.transpose = t.kron = t.bitOr = t.lcm = t.bignumber = t.gamma = t.quantileSeq = t.trace = t.setSize = t.setMultiplicity = t.setIntersect = t.setDifference = t.tan = t.asech = t.Index = t.partitionSelect = t.largerEq = t.equalText = t.compareNatural = t.rightArithShift = t.dotPow = t.pow = t.to = t.squeeze = t.resize = t.flatten = t.re = t.dotMultiply = t.multiply = t.floor = t.abs = t.isZero = t.composition = t.dot = t.add = t.sec = t.atan2 = t.acoth = t.sparse = t.FibonacciHeap = t.ImmutableDenseMatrix = t.unequal = t.larger = t.smaller = t.compareText = t.compare = t.rightLogShift = t.leftShift = t.round = t.hex = t.zeros = t.subset = t.size = t.reshape = t.ones = t.identity = t.diag = t.concat = t.or = t.bitXor = t.bitAnd = t.xgcd = t.nthRoot = t.mod = t.gcd = t.cbrt = void 0, t.planckConstant = t.gasConstant = t.unit = t.rydberg = t.magneticFluxQuantum = t.coulomb = t.mad = t.rotate = t.thomsonCrossSection = t.planckTime = t.molarVolume = t.inverseConductanceQuantum = t.elementaryCharge = t.bohrRadius = t.median = t.rotationMatrix = t.wienDisplacement = t.speedOfLight = t.quantumOfCirculation = t.planckMass = t.nuclearMagneton = t.molarMassC12 = t.loschmidt = t.gravity = t.fermiCoupling = t.electricConstant = t.classicalElectronRadius = t.avogadro = t.multinomial = t.sqrtm = t.lusolve = t.norm = t.usolve = t.vacuumImpedance = t.stefanBoltzmann = t.secondRadiation = t.reducedPlanckConstant = t.protonMass = t.planckTemperature = t.planckLength = t.planckCharge = t.neutronMass = t.molarPlanckConstant = t.molarMass = t.magneticConstant = t.klitzing = t.hartreeEnergy = t.gravitationConstant = t.firstRadiation = t.faraday = t.electronMass = t.deuteronMass = t.conductanceQuantum = t.boltzmann = t.bohrMagneton = t.atomicMass = t.std = t.intersect = t.eigs = t.createUnit = t.Unit = t.log1p = t.bellNumbers = t.kldivergence = t.variance = t.mean = t.divide = t.expm = t.inv = t.qr = t.hypot = t.usolveAll = t.dotDivide = t.log = t.diff = t.catalan = t.stirlingS2 = t.distance = t.det = t.slu = t.lup = void 0;
  var r = configReadonly, n = factoriesAny, a = /* @__PURE__ */ (0, n.createResultSet)({});
  t.ResultSet = a;
  var s = /* @__PURE__ */ (0, n.createComplexClass)({});
  t.Complex = s;
  var o = /* @__PURE__ */ (0, n.createRangeClass)({});
  t.Range = o;
  var c = /* @__PURE__ */ (0, n.createFalse)({});
  t._false = c;
  var l = /* @__PURE__ */ (0, n.createNull)({});
  t._null = l;
  var d = /* @__PURE__ */ (0, n.createTrue)({});
  t._true = d;
  var h = /* @__PURE__ */ (0, n.createBigNumberClass)({
    config: r.config
  });
  t.BigNumber = h;
  var u = /* @__PURE__ */ (0, n.createMatrixClass)({});
  t.Matrix = u;
  var p = /* @__PURE__ */ (0, n.createReplacer)({});
  t.replacer = p;
  var m = /* @__PURE__ */ (0, n.createI)({
    Complex: s
  });
  t.i = m;
  var g = /* @__PURE__ */ (0, n.createLN10)({
    BigNumber: h,
    config: r.config
  });
  t.LN10 = g;
  var v = /* @__PURE__ */ (0, n.createLOG10E)({
    BigNumber: h,
    config: r.config
  });
  t.LOG10E = v;
  var y = /* @__PURE__ */ (0, n.createNaN)({
    BigNumber: h,
    config: r.config
  });
  t._NaN = y;
  var x = /* @__PURE__ */ (0, n.createPi)({
    BigNumber: h,
    config: r.config
  });
  t.pi = x;
  var _ = /* @__PURE__ */ (0, n.createSQRT1_2)({
    BigNumber: h,
    config: r.config
  });
  t.SQRT1_2 = _;
  var $ = /* @__PURE__ */ (0, n.createTau)({
    BigNumber: h,
    config: r.config
  });
  t.tau = $;
  var b = /* @__PURE__ */ (0, n.createEfimovFactor)({
    BigNumber: h,
    config: r.config
  });
  t.efimovFactor = b;
  var M = /* @__PURE__ */ (0, n.createFineStructure)({
    BigNumber: h,
    config: r.config
  });
  t.fineStructure = M;
  var C = /* @__PURE__ */ (0, n.createSackurTetrode)({
    BigNumber: h,
    config: r.config
  });
  t.sackurTetrode = C;
  var S = /* @__PURE__ */ (0, n.createWeakMixingAngle)({
    BigNumber: h,
    config: r.config
  });
  t.weakMixingAngle = S;
  var A = /* @__PURE__ */ (0, n.createFractionClass)({});
  t.Fraction = A;
  var D = /* @__PURE__ */ (0, n.createE)({
    BigNumber: h,
    config: r.config
  });
  t.e = D;
  var N = /* @__PURE__ */ (0, n.createInfinity)({
    BigNumber: h,
    config: r.config
  });
  t._Infinity = N;
  var T = /* @__PURE__ */ (0, n.createLOG2E)({
    BigNumber: h,
    config: r.config
  });
  t.LOG2E = T;
  var R = /* @__PURE__ */ (0, n.createVersion)({});
  t.version = R;
  var F = /* @__PURE__ */ (0, n.createDenseMatrixClass)({
    Matrix: u
  });
  t.DenseMatrix = F;
  var z = /* @__PURE__ */ (0, n.createPhi)({
    BigNumber: h,
    config: r.config
  });
  t.phi = z;
  var O = /* @__PURE__ */ (0, n.createTyped)({
    BigNumber: h,
    Complex: s,
    DenseMatrix: F,
    Fraction: A
  });
  t.typed = O;
  var G = /* @__PURE__ */ (0, n.createIsInteger)({
    typed: O
  });
  t.isInteger = G;
  var I = /* @__PURE__ */ (0, n.createIsNumeric)({
    typed: O
  });
  t.isNumeric = I;
  var k = /* @__PURE__ */ (0, n.createIsPositive)({
    typed: O
  });
  t.isPositive = k;
  var B = /* @__PURE__ */ (0, n.createIsNaN)({
    typed: O
  });
  t.isNaN = B;
  var L = /* @__PURE__ */ (0, n.createEqualScalar)({
    config: r.config,
    typed: O
  });
  t.equalScalar = L;
  var V = /* @__PURE__ */ (0, n.createNumber)({
    typed: O
  });
  t.number = V;
  var U = /* @__PURE__ */ (0, n.createBoolean)({
    typed: O
  });
  t.boolean = U;
  var J = /* @__PURE__ */ (0, n.createComplex)({
    Complex: s,
    typed: O
  });
  t.complex = J;
  var q = /* @__PURE__ */ (0, n.createSplitUnit)({
    typed: O
  });
  t.splitUnit = q;
  var Z = /* @__PURE__ */ (0, n.createUnaryPlus)({
    BigNumber: h,
    config: r.config,
    typed: O
  });
  t.unaryPlus = Z;
  var ae = /* @__PURE__ */ (0, n.createApply)({
    isInteger: G,
    typed: O
  });
  t.apply = ae;
  var ee = /* @__PURE__ */ (0, n.createCube)({
    typed: O
  });
  t.cube = ee;
  var se = /* @__PURE__ */ (0, n.createExpm1)({
    Complex: s,
    typed: O
  });
  t.expm1 = se;
  var nr = /* @__PURE__ */ (0, n.createLog10)({
    Complex: s,
    config: r.config,
    typed: O
  });
  t.log10 = nr;
  var ce = /* @__PURE__ */ (0, n.createMultiplyScalar)({
    typed: O
  });
  t.multiplyScalar = ce;
  var oe = /* @__PURE__ */ (0, n.createSign)({
    BigNumber: h,
    Fraction: A,
    complex: J,
    typed: O
  });
  t.sign = oe;
  var ur = /* @__PURE__ */ (0, n.createSquare)({
    typed: O
  });
  t.square = ur;
  var ir = /* @__PURE__ */ (0, n.createBitNot)({
    typed: O
  });
  t.bitNot = ir;
  var _r = /* @__PURE__ */ (0, n.createArg)({
    typed: O
  });
  t.arg = _r;
  var yr = /* @__PURE__ */ (0, n.createIm)({
    typed: O
  });
  t.im = yr;
  var ne = /* @__PURE__ */ (0, n.createNot)({
    typed: O
  });
  t.not = ne;
  var pe = /* @__PURE__ */ (0, n.createFilter)({
    typed: O
  });
  t.filter = pe;
  var hr = /* @__PURE__ */ (0, n.createForEach)({
    typed: O
  });
  t.forEach = hr;
  var $r = /* @__PURE__ */ (0, n.createMap)({
    typed: O
  });
  t.map = $r;
  var Sr = /* @__PURE__ */ (0, n.createErf)({
    typed: O
  });
  t.erf = Sr;
  var ze = /* @__PURE__ */ (0, n.createFormat)({
    typed: O
  });
  t.format = ze;
  var cr = /* @__PURE__ */ (0, n.createOct)({
    typed: O
  });
  t.oct = cr;
  var fr = /* @__PURE__ */ (0, n.createPrint)({
    typed: O
  });
  t.print = fr;
  var mr = /* @__PURE__ */ (0, n.createIsPrime)({
    typed: O
  });
  t.isPrime = mr;
  var wr = /* @__PURE__ */ (0, n.createAcos)({
    Complex: s,
    config: r.config,
    typed: O
  });
  t.acos = wr;
  var Nr = /* @__PURE__ */ (0, n.createAcot)({
    BigNumber: h,
    typed: O
  });
  t.acot = Nr;
  var xr = /* @__PURE__ */ (0, n.createAcsc)({
    BigNumber: h,
    Complex: s,
    config: r.config,
    typed: O
  });
  t.acsc = xr;
  var Er = /* @__PURE__ */ (0, n.createAsec)({
    BigNumber: h,
    Complex: s,
    config: r.config,
    typed: O
  });
  t.asec = Er;
  var Ir = /* @__PURE__ */ (0, n.createAsin)({
    Complex: s,
    config: r.config,
    typed: O
  });
  t.asin = Ir;
  var Rr = /* @__PURE__ */ (0, n.createAtan)({
    typed: O
  });
  t.atan = Rr;
  var Yr = /* @__PURE__ */ (0, n.createAtanh)({
    Complex: s,
    config: r.config,
    typed: O
  });
  t.atanh = Yr;
  var Qr = /* @__PURE__ */ (0, n.createCosh)({
    typed: O
  });
  t.cosh = Qr;
  var nn = /* @__PURE__ */ (0, n.createCoth)({
    BigNumber: h,
    typed: O
  });
  t.coth = nn;
  var on = /* @__PURE__ */ (0, n.createCsch)({
    BigNumber: h,
    typed: O
  });
  t.csch = on;
  var en = /* @__PURE__ */ (0, n.createSech)({
    BigNumber: h,
    typed: O
  });
  t.sech = en;
  var zr = /* @__PURE__ */ (0, n.createSinh)({
    typed: O
  });
  t.sinh = zr;
  var Jr = /* @__PURE__ */ (0, n.createTanh)({
    typed: O
  });
  t.tanh = Jr;
  var H = /* @__PURE__ */ (0, n.createCombinations)({
    typed: O
  });
  t.combinations = H;
  var dr = /* @__PURE__ */ (0, n.createPickRandom)({
    config: r.config,
    typed: O
  });
  t.pickRandom = dr;
  var Ar = /* @__PURE__ */ (0, n.createRandomInt)({
    config: r.config,
    typed: O
  });
  t.randomInt = Ar;
  var jr = /* @__PURE__ */ (0, n.createLN2)({
    BigNumber: h,
    config: r.config
  });
  t.LN2 = jr;
  var Vr = /* @__PURE__ */ (0, n.createClone)({
    typed: O
  });
  t.clone = Vr;
  var Zr = /* @__PURE__ */ (0, n.createHasNumericValue)({
    isNumeric: I,
    typed: O
  });
  t.hasNumericValue = Zr;
  var pn = /* @__PURE__ */ (0, n.createTypeOf)({
    typed: O
  });
  t.typeOf = pn;
  var gr = /* @__PURE__ */ (0, n.createString)({
    typed: O
  });
  t.string = gr;
  var Cr = /* @__PURE__ */ (0, n.createFraction)({
    Fraction: A,
    typed: O
  });
  t.fraction = Cr;
  var Pr = /* @__PURE__ */ (0, n.createUnaryMinus)({
    typed: O
  });
  t.unaryMinus = Pr;
  var Tr = /* @__PURE__ */ (0, n.createAddScalar)({
    typed: O
  });
  t.addScalar = Tr;
  var Xr = /* @__PURE__ */ (0, n.createExp)({
    typed: O
  });
  t.exp = Xr;
  var rn = /* @__PURE__ */ (0, n.createLog2)({
    Complex: s,
    config: r.config,
    typed: O
  });
  t.log2 = rn;
  var un = /* @__PURE__ */ (0, n.createSqrt)({
    Complex: s,
    config: r.config,
    typed: O
  });
  t.sqrt = un;
  var ln = /* @__PURE__ */ (0, n.createConj)({
    typed: O
  });
  t.conj = ln;
  var bn = /* @__PURE__ */ (0, n.createGetMatrixDataType)({
    typed: O
  });
  t.getMatrixDataType = bn;
  var $n = /* @__PURE__ */ (0, n.createMode)({
    isNaN: B,
    isNumeric: I,
    typed: O
  });
  t.mode = $n;
  var An = /* @__PURE__ */ (0, n.createBin)({
    typed: O
  });
  t.bin = An;
  var Nn = /* @__PURE__ */ (0, n.createAcosh)({
    Complex: s,
    config: r.config,
    typed: O
  });
  t.acosh = Nn;
  var Pn = /* @__PURE__ */ (0, n.createAcsch)({
    BigNumber: h,
    typed: O
  });
  t.acsch = Pn;
  var Tn = /* @__PURE__ */ (0, n.createAsinh)({
    typed: O
  });
  t.asinh = Tn;
  var pr = /* @__PURE__ */ (0, n.createCos)({
    typed: O
  });
  t.cos = pr;
  var Lr = /* @__PURE__ */ (0, n.createCsc)({
    BigNumber: h,
    typed: O
  });
  t.csc = Lr;
  var Fr = /* @__PURE__ */ (0, n.createSin)({
    typed: O
  });
  t.sin = Fr;
  var Br = /* @__PURE__ */ (0, n.createCombinationsWithRep)({
    typed: O
  });
  t.combinationsWithRep = Br;
  var W = /* @__PURE__ */ (0, n.createRandom)({
    config: r.config,
    typed: O
  });
  t.random = W;
  var Y = /* @__PURE__ */ (0, n.createSQRT2)({
    BigNumber: h,
    config: r.config
  });
  t.SQRT2 = Y;
  var X = /* @__PURE__ */ (0, n.createIsNegative)({
    typed: O
  });
  t.isNegative = X;
  var K = /* @__PURE__ */ (0, n.createSparseMatrixClass)({
    Matrix: u,
    equalScalar: L,
    typed: O
  });
  t.SparseMatrix = K;
  var te = /* @__PURE__ */ (0, n.createMatrix)({
    DenseMatrix: F,
    Matrix: u,
    SparseMatrix: K,
    typed: O
  });
  t.matrix = te;
  var ie = /* @__PURE__ */ (0, n.createCbrt)({
    BigNumber: h,
    Complex: s,
    Fraction: A,
    config: r.config,
    isNegative: X,
    matrix: te,
    typed: O,
    unaryMinus: Pr
  });
  t.cbrt = ie;
  var lr = /* @__PURE__ */ (0, n.createGcd)({
    BigNumber: h,
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.gcd = lr;
  var vr = /* @__PURE__ */ (0, n.createMod)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.mod = vr;
  var Mr = /* @__PURE__ */ (0, n.createNthRoot)({
    BigNumber: h,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.nthRoot = Mr;
  var br = /* @__PURE__ */ (0, n.createXgcd)({
    BigNumber: h,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.xgcd = br;
  var Dr = /* @__PURE__ */ (0, n.createBitAnd)({
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.bitAnd = Dr;
  var Or = /* @__PURE__ */ (0, n.createBitXor)({
    DenseMatrix: F,
    matrix: te,
    typed: O
  });
  t.bitXor = Or;
  var kr = /* @__PURE__ */ (0, n.createOr)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.or = kr;
  var Gr = /* @__PURE__ */ (0, n.createConcat)({
    isInteger: G,
    matrix: te,
    typed: O
  });
  t.concat = Gr;
  var tn = /* @__PURE__ */ (0, n.createDiag)({
    DenseMatrix: F,
    SparseMatrix: K,
    matrix: te,
    typed: O
  });
  t.diag = tn;
  var Wr = /* @__PURE__ */ (0, n.createIdentity)({
    BigNumber: h,
    DenseMatrix: F,
    SparseMatrix: K,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.identity = Wr;
  var yn = /* @__PURE__ */ (0, n.createOnes)({
    BigNumber: h,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.ones = yn;
  var sn = /* @__PURE__ */ (0, n.createReshape)({
    isInteger: G,
    matrix: te,
    typed: O
  });
  t.reshape = sn;
  var cn = /* @__PURE__ */ (0, n.createSize)({
    matrix: te,
    config: r.config,
    typed: O
  });
  t.size = cn;
  var Kr = /* @__PURE__ */ (0, n.createSubset)({
    matrix: te,
    typed: O
  });
  t.subset = Kr;
  var dn = /* @__PURE__ */ (0, n.createZeros)({
    BigNumber: h,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.zeros = dn;
  var On = /* @__PURE__ */ (0, n.createHex)({
    typed: O
  });
  t.hex = On;
  var xn = /* @__PURE__ */ (0, n.createRound)({
    BigNumber: h,
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O,
    zeros: dn
  });
  t.round = xn;
  var Gn = /* @__PURE__ */ (0, n.createLeftShift)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O,
    zeros: dn
  });
  t.leftShift = Gn;
  var In = /* @__PURE__ */ (0, n.createRightLogShift)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O,
    zeros: dn
  });
  t.rightLogShift = In;
  var Dn = /* @__PURE__ */ (0, n.createCompare)({
    BigNumber: h,
    DenseMatrix: F,
    Fraction: A,
    config: r.config,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.compare = Dn;
  var kn = /* @__PURE__ */ (0, n.createCompareText)({
    matrix: te,
    typed: O
  });
  t.compareText = kn;
  var fn = /* @__PURE__ */ (0, n.createSmaller)({
    DenseMatrix: F,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.smaller = fn;
  var wn = /* @__PURE__ */ (0, n.createLarger)({
    DenseMatrix: F,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.larger = wn;
  var Ln = /* @__PURE__ */ (0, n.createUnequal)({
    DenseMatrix: F,
    config: r.config,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.unequal = Ln;
  var jn = /* @__PURE__ */ (0, n.createImmutableDenseMatrixClass)({
    DenseMatrix: F,
    smaller: fn
  });
  t.ImmutableDenseMatrix = jn;
  var mn = /* @__PURE__ */ (0, n.createFibonacciHeapClass)({
    larger: wn,
    smaller: fn
  });
  t.FibonacciHeap = mn;
  var an = /* @__PURE__ */ (0, n.createSparse)({
    SparseMatrix: K,
    typed: O
  });
  t.sparse = an;
  var $a = /* @__PURE__ */ (0, n.createAcoth)({
    BigNumber: h,
    Complex: s,
    config: r.config,
    typed: O
  });
  t.acoth = $a;
  var xa = /* @__PURE__ */ (0, n.createAtan2)({
    BigNumber: h,
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.atan2 = xa;
  var wa = /* @__PURE__ */ (0, n.createSec)({
    BigNumber: h,
    typed: O
  });
  t.sec = wa;
  var Mn = /* @__PURE__ */ (0, n.createAdd)({
    DenseMatrix: F,
    SparseMatrix: K,
    addScalar: Tr,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.add = Mn;
  var Kn = /* @__PURE__ */ (0, n.createDot)({
    addScalar: Tr,
    conj: ln,
    multiplyScalar: ce,
    size: cn,
    typed: O
  });
  t.dot = Kn;
  var Ma = /* @__PURE__ */ (0, n.createComposition)({
    addScalar: Tr,
    combinations: H,
    isInteger: G,
    isNegative: X,
    isPositive: k,
    larger: wn,
    typed: O
  });
  t.composition = Ma;
  var qn = /* @__PURE__ */ (0, n.createIsZero)({
    typed: O
  });
  t.isZero = qn;
  var Cn = /* @__PURE__ */ (0, n.createAbs)({
    typed: O
  });
  t.abs = Cn;
  var ea = /* @__PURE__ */ (0, n.createFloor)({
    config: r.config,
    equalScalar: L,
    matrix: te,
    round: xn,
    typed: O
  });
  t.floor = ea;
  var _n = /* @__PURE__ */ (0, n.createMultiply)({
    addScalar: Tr,
    dot: Kn,
    equalScalar: L,
    matrix: te,
    multiplyScalar: ce,
    typed: O
  });
  t.multiply = _n;
  var Ca = /* @__PURE__ */ (0, n.createDotMultiply)({
    equalScalar: L,
    matrix: te,
    multiplyScalar: ce,
    typed: O
  });
  t.dotMultiply = Ca;
  var Sa = /* @__PURE__ */ (0, n.createRe)({
    typed: O
  });
  t.re = Sa;
  var Da = /* @__PURE__ */ (0, n.createFlatten)({
    matrix: te,
    typed: O
  });
  t.flatten = Da;
  var Na = /* @__PURE__ */ (0, n.createResize)({
    config: r.config,
    matrix: te
  });
  t.resize = Na;
  var Aa = /* @__PURE__ */ (0, n.createSqueeze)({
    matrix: te,
    typed: O
  });
  t.squeeze = Aa;
  var Pa = /* @__PURE__ */ (0, n.createTo)({
    matrix: te,
    typed: O
  });
  t.to = Pa;
  var Rn = /* @__PURE__ */ (0, n.createPow)({
    Complex: s,
    config: r.config,
    fraction: Cr,
    identity: Wr,
    matrix: te,
    multiply: _n,
    number: V,
    typed: O
  });
  t.pow = Rn;
  var Ea = /* @__PURE__ */ (0, n.createDotPow)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    pow: Rn,
    typed: O
  });
  t.dotPow = Ea;
  var Ta = /* @__PURE__ */ (0, n.createRightArithShift)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O,
    zeros: dn
  });
  t.rightArithShift = Ta;
  var En = /* @__PURE__ */ (0, n.createCompareNatural)({
    compare: Dn,
    typed: O
  });
  t.compareNatural = En;
  var Oa = /* @__PURE__ */ (0, n.createEqualText)({
    compareText: kn,
    isZero: qn,
    typed: O
  });
  t.equalText = Oa;
  var Hn = /* @__PURE__ */ (0, n.createLargerEq)({
    DenseMatrix: F,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.largerEq = Hn;
  var Zn = /* @__PURE__ */ (0, n.createPartitionSelect)({
    compare: Dn,
    isNaN: B,
    isNumeric: I,
    typed: O
  });
  t.partitionSelect = Zn;
  var Sn = /* @__PURE__ */ (0, n.createIndexClass)({
    ImmutableDenseMatrix: jn
  });
  t.Index = Sn;
  var Ia = /* @__PURE__ */ (0, n.createAsech)({
    BigNumber: h,
    Complex: s,
    config: r.config,
    typed: O
  });
  t.asech = Ia;
  var ka = /* @__PURE__ */ (0, n.createTan)({
    typed: O
  });
  t.tan = ka;
  var ta = /* @__PURE__ */ (0, n.createSetDifference)({
    DenseMatrix: F,
    Index: Sn,
    compareNatural: En,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setDifference = ta;
  var ra = /* @__PURE__ */ (0, n.createSetIntersect)({
    DenseMatrix: F,
    Index: Sn,
    compareNatural: En,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setIntersect = ra;
  var La = /* @__PURE__ */ (0, n.createSetMultiplicity)({
    Index: Sn,
    compareNatural: En,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setMultiplicity = La;
  var ja = /* @__PURE__ */ (0, n.createSetSize)({
    compareNatural: En,
    typed: O
  });
  t.setSize = ja;
  var Ra = /* @__PURE__ */ (0, n.createTrace)({
    add: Mn,
    matrix: te,
    typed: O
  });
  t.trace = Ra;
  var Fa = /* @__PURE__ */ (0, n.createQuantileSeq)({
    add: Mn,
    compare: Dn,
    multiply: _n,
    partitionSelect: Zn,
    typed: O
  });
  t.quantileSeq = Fa;
  var na = /* @__PURE__ */ (0, n.createGamma)({
    BigNumber: h,
    Complex: s,
    config: r.config,
    multiplyScalar: ce,
    pow: Rn,
    typed: O
  });
  t.gamma = na;
  var Wn = /* @__PURE__ */ (0, n.createBignumber)({
    BigNumber: h,
    typed: O
  });
  t.bignumber = Wn;
  var Ba = /* @__PURE__ */ (0, n.createLcm)({
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.lcm = Ba;
  var Ga = /* @__PURE__ */ (0, n.createBitOr)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.bitOr = Ga;
  var za = /* @__PURE__ */ (0, n.createKron)({
    matrix: te,
    multiplyScalar: ce,
    typed: O
  });
  t.kron = za;
  var Yn = /* @__PURE__ */ (0, n.createTranspose)({
    matrix: te,
    typed: O
  });
  t.transpose = Yn;
  var Fn = /* @__PURE__ */ (0, n.createNumeric)({
    bignumber: Wn,
    fraction: Cr,
    number: V
  });
  t.numeric = Fn;
  var Va = /* @__PURE__ */ (0, n.createAnd)({
    equalScalar: L,
    matrix: te,
    not: ne,
    typed: O,
    zeros: dn
  });
  t.and = Va;
  var aa = /* @__PURE__ */ (0, n.createSmallerEq)({
    DenseMatrix: F,
    config: r.config,
    matrix: te,
    typed: O
  });
  t.smallerEq = aa;
  var Wa = /* @__PURE__ */ (0, n.createSort)({
    compare: Dn,
    compareNatural: En,
    matrix: te,
    typed: O
  });
  t.sort = Wa;
  var Ua = /* @__PURE__ */ (0, n.createMin)({
    config: r.config,
    numeric: Fn,
    smaller: fn,
    typed: O
  });
  t.min = Ua;
  var qa = /* @__PURE__ */ (0, n.createCot)({
    BigNumber: h,
    typed: O
  });
  t.cot = qa;
  var Ha = /* @__PURE__ */ (0, n.createSetDistinct)({
    DenseMatrix: F,
    Index: Sn,
    compareNatural: En,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setDistinct = Ha;
  var Za = /* @__PURE__ */ (0, n.createSetPowerset)({
    Index: Sn,
    compareNatural: En,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setPowerset = Za;
  var Ya = /* @__PURE__ */ (0, n.createIndex)({
    Index: Sn,
    typed: O
  });
  t.index = Ya;
  var ia = /* @__PURE__ */ (0, n.createSum)({
    add: Mn,
    config: r.config,
    numeric: Fn,
    typed: O
  });
  t.sum = ia;
  var Un = /* @__PURE__ */ (0, n.createFactorial)({
    gamma: na,
    typed: O
  });
  t.factorial = Un;
  var Xa = /* @__PURE__ */ (0, n.createPermutations)({
    factorial: Un,
    typed: O
  });
  t.permutations = Xa;
  var sa = /* @__PURE__ */ (0, n.createCeil)({
    config: r.config,
    equalScalar: L,
    matrix: te,
    round: xn,
    typed: O
  });
  t.ceil = sa;
  var gn = /* @__PURE__ */ (0, n.createSubtract)({
    DenseMatrix: F,
    addScalar: Tr,
    equalScalar: L,
    matrix: te,
    typed: O,
    unaryMinus: Pr
  });
  t.subtract = gn;
  var Qa = /* @__PURE__ */ (0, n.createCross)({
    matrix: te,
    multiply: _n,
    subtract: gn,
    typed: O
  });
  t.cross = Qa;
  var Xn = /* @__PURE__ */ (0, n.createRange)({
    bignumber: Wn,
    matrix: te,
    config: r.config,
    larger: wn,
    largerEq: Hn,
    smaller: fn,
    smallerEq: aa,
    typed: O
  });
  t.range = Xn;
  var Ja = /* @__PURE__ */ (0, n.createRow)({
    Index: Sn,
    matrix: te,
    range: Xn,
    typed: O
  });
  t.row = Ja;
  var Ka = /* @__PURE__ */ (0, n.createProd)({
    config: r.config,
    multiplyScalar: ce,
    numeric: Fn,
    typed: O
  });
  t.prod = Ka;
  var zn = /* @__PURE__ */ (0, n.createEqual)({
    DenseMatrix: F,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.equal = zn;
  var oa = /* @__PURE__ */ (0, n.createMax)({
    config: r.config,
    larger: wn,
    numeric: Fn,
    typed: O
  });
  t.max = oa;
  var ei = /* @__PURE__ */ (0, n.createSetCartesian)({
    DenseMatrix: F,
    Index: Sn,
    compareNatural: En,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setCartesian = ei;
  var ca = /* @__PURE__ */ (0, n.createSetSymDifference)({
    Index: Sn,
    concat: Gr,
    setDifference: ta,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setSymDifference = ca;
  var da = /* @__PURE__ */ (0, n.createFix)({
    Complex: s,
    ceil: sa,
    floor: ea,
    matrix: te,
    typed: O
  });
  t.fix = da;
  var ti = /* @__PURE__ */ (0, n.createColumn)({
    Index: Sn,
    matrix: te,
    range: Xn,
    typed: O
  });
  t.column = ti;
  var la = /* @__PURE__ */ (0, n.createCtranspose)({
    conj: ln,
    transpose: Yn,
    typed: O
  });
  t.ctranspose = la;
  var ri = /* @__PURE__ */ (0, n.createDeepEqual)({
    equal: zn,
    typed: O
  });
  t.deepEqual = ri;
  var ni = /* @__PURE__ */ (0, n.createSetIsSubset)({
    Index: Sn,
    compareNatural: En,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setIsSubset = ni;
  var ai = /* @__PURE__ */ (0, n.createXor)({
    DenseMatrix: F,
    matrix: te,
    typed: O
  });
  t.xor = ai;
  var hn = /* @__PURE__ */ (0, n.createDivideScalar)({
    numeric: Fn,
    typed: O
  });
  t.divideScalar = hn;
  var ii = /* @__PURE__ */ (0, n.createNthRoots)({
    Complex: s,
    config: r.config,
    divideScalar: hn,
    typed: O
  });
  t.nthRoots = ii;
  var ua = /* @__PURE__ */ (0, n.createLsolve)({
    DenseMatrix: F,
    divideScalar: hn,
    equalScalar: L,
    matrix: te,
    multiplyScalar: ce,
    subtract: gn,
    typed: O
  });
  t.lsolve = ua;
  var si = /* @__PURE__ */ (0, n.createLsolveAll)({
    DenseMatrix: F,
    divideScalar: hn,
    equalScalar: L,
    matrix: te,
    multiplyScalar: ce,
    subtract: gn,
    typed: O
  });
  t.lsolveAll = si;
  var pa = /* @__PURE__ */ (0, n.createSpaClass)({
    FibonacciHeap: mn,
    addScalar: Tr,
    equalScalar: L
  });
  t.Spa = pa;
  var oi = /* @__PURE__ */ (0, n.createSetUnion)({
    Index: Sn,
    concat: Gr,
    setIntersect: ra,
    setSymDifference: ca,
    size: cn,
    subset: Kr,
    typed: O
  });
  t.setUnion = oi;
  var Qn = /* @__PURE__ */ (0, n.createLup)({
    DenseMatrix: F,
    Spa: pa,
    SparseMatrix: K,
    abs: Cn,
    addScalar: Tr,
    divideScalar: hn,
    equalScalar: L,
    larger: wn,
    matrix: te,
    multiplyScalar: ce,
    subtract: gn,
    typed: O,
    unaryMinus: Pr
  });
  t.lup = Qn;
  var fa = /* @__PURE__ */ (0, n.createSlu)({
    SparseMatrix: K,
    abs: Cn,
    add: Mn,
    divideScalar: hn,
    larger: wn,
    largerEq: Hn,
    multiply: _n,
    subtract: gn,
    transpose: Yn,
    typed: O
  });
  t.slu = fa;
  var ha = /* @__PURE__ */ (0, n.createDet)({
    lup: Qn,
    matrix: te,
    multiply: _n,
    subtract: gn,
    typed: O,
    unaryMinus: Pr
  });
  t.det = ha;
  var ci = /* @__PURE__ */ (0, n.createDistance)({
    abs: Cn,
    addScalar: Tr,
    divideScalar: hn,
    multiplyScalar: ce,
    sqrt: un,
    subtract: gn,
    typed: O,
    unaryMinus: Pr
  });
  t.distance = ci;
  var ma = /* @__PURE__ */ (0, n.createStirlingS2)({
    addScalar: Tr,
    combinations: H,
    divideScalar: hn,
    factorial: Un,
    isInteger: G,
    isNegative: X,
    larger: wn,
    multiplyScalar: ce,
    pow: Rn,
    subtract: gn,
    typed: O
  });
  t.stirlingS2 = ma;
  var di = /* @__PURE__ */ (0, n.createCatalan)({
    addScalar: Tr,
    combinations: H,
    divideScalar: hn,
    isInteger: G,
    isNegative: X,
    multiplyScalar: ce,
    typed: O
  });
  t.catalan = di;
  var li = /* @__PURE__ */ (0, n.createDiff)({
    matrix: te,
    number: V,
    subtract: gn,
    typed: O
  });
  t.diff = li;
  var Jn = /* @__PURE__ */ (0, n.createLog)({
    Complex: s,
    config: r.config,
    divideScalar: hn,
    typed: O
  });
  t.log = Jn;
  var ga = /* @__PURE__ */ (0, n.createDotDivide)({
    DenseMatrix: F,
    divideScalar: hn,
    equalScalar: L,
    matrix: te,
    typed: O
  });
  t.dotDivide = ga;
  var ui = /* @__PURE__ */ (0, n.createUsolveAll)({
    DenseMatrix: F,
    divideScalar: hn,
    equalScalar: L,
    matrix: te,
    multiplyScalar: ce,
    subtract: gn,
    typed: O
  });
  t.usolveAll = ui;
  var fi = /* @__PURE__ */ (0, n.createHypot)({
    abs: Cn,
    addScalar: Tr,
    divideScalar: hn,
    isPositive: k,
    multiplyScalar: ce,
    smaller: fn,
    sqrt: un,
    typed: O
  });
  t.hypot = fi;
  var hi = /* @__PURE__ */ (0, n.createQr)({
    addScalar: Tr,
    complex: J,
    conj: ln,
    divideScalar: hn,
    equal: zn,
    identity: Wr,
    isZero: qn,
    matrix: te,
    multiplyScalar: ce,
    sign: oe,
    sqrt: un,
    subtract: gn,
    typed: O,
    unaryMinus: Pr,
    zeros: dn
  });
  t.qr = hi;
  var Vn = /* @__PURE__ */ (0, n.createInv)({
    abs: Cn,
    addScalar: Tr,
    det: ha,
    divideScalar: hn,
    identity: Wr,
    matrix: te,
    multiply: _n,
    typed: O,
    unaryMinus: Pr
  });
  t.inv = Vn;
  var mi = /* @__PURE__ */ (0, n.createExpm)({
    abs: Cn,
    add: Mn,
    identity: Wr,
    inv: Vn,
    multiply: _n,
    typed: O
  });
  t.expm = mi;
  var Bn = /* @__PURE__ */ (0, n.createDivide)({
    divideScalar: hn,
    equalScalar: L,
    inv: Vn,
    matrix: te,
    multiply: _n,
    typed: O
  });
  t.divide = Bn;
  var gi = /* @__PURE__ */ (0, n.createMean)({
    add: Mn,
    divide: Bn,
    typed: O
  });
  t.mean = gi;
  var va = /* @__PURE__ */ (0, n.createVariance)({
    add: Mn,
    apply: ae,
    divide: Bn,
    isNaN: B,
    multiply: _n,
    subtract: gn,
    typed: O
  });
  t.variance = va;
  var vi = /* @__PURE__ */ (0, n.createKldivergence)({
    divide: Bn,
    dotDivide: ga,
    isNumeric: I,
    log: Jn,
    matrix: te,
    multiply: _n,
    sum: ia,
    typed: O
  });
  t.kldivergence = vi;
  var yi = /* @__PURE__ */ (0, n.createBellNumbers)({
    addScalar: Tr,
    isInteger: G,
    isNegative: X,
    stirlingS2: ma,
    typed: O
  });
  t.bellNumbers = yi;
  var bi = /* @__PURE__ */ (0, n.createLog1p)({
    Complex: s,
    config: r.config,
    divideScalar: hn,
    log: Jn,
    typed: O
  });
  t.log1p = bi;
  var Hr = /* @__PURE__ */ (0, n.createUnitClass)({
    BigNumber: h,
    Complex: s,
    Fraction: A,
    abs: Cn,
    addScalar: Tr,
    config: r.config,
    divideScalar: hn,
    equal: zn,
    fix: da,
    format: ze,
    isNumeric: I,
    multiplyScalar: ce,
    number: V,
    pow: Rn,
    round: xn,
    subtract: gn
  });
  t.Unit = Hr;
  var $i = /* @__PURE__ */ (0, n.createCreateUnit)({
    Unit: Hr,
    typed: O
  });
  t.createUnit = $i;
  var ya = /* @__PURE__ */ (0, n.createEigs)({
    abs: Cn,
    add: Mn,
    addScalar: Tr,
    atan: Rr,
    bignumber: Wn,
    config: r.config,
    cos: pr,
    equal: zn,
    inv: Vn,
    matrix: te,
    multiply: _n,
    multiplyScalar: ce,
    sin: Fr,
    subtract: gn,
    typed: O
  });
  t.eigs = ya;
  var xi = /* @__PURE__ */ (0, n.createIntersect)({
    abs: Cn,
    add: Mn,
    addScalar: Tr,
    config: r.config,
    divideScalar: hn,
    equalScalar: L,
    matrix: te,
    multiply: _n,
    multiplyScalar: ce,
    smaller: fn,
    subtract: gn,
    typed: O
  });
  t.intersect = xi;
  var wi = /* @__PURE__ */ (0, n.createStd)({
    sqrt: un,
    typed: O,
    variance: va
  });
  t.std = wi;
  var Mi = /* @__PURE__ */ (0, n.createAtomicMass)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.atomicMass = Mi;
  var Ci = /* @__PURE__ */ (0, n.createBohrMagneton)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.bohrMagneton = Ci;
  var Si = /* @__PURE__ */ (0, n.createBoltzmann)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.boltzmann = Si;
  var Di = /* @__PURE__ */ (0, n.createConductanceQuantum)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.conductanceQuantum = Di;
  var Ni = /* @__PURE__ */ (0, n.createDeuteronMass)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.deuteronMass = Ni;
  var Ai = /* @__PURE__ */ (0, n.createElectronMass)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.electronMass = Ai;
  var Pi = /* @__PURE__ */ (0, n.createFaraday)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.faraday = Pi;
  var Ei = /* @__PURE__ */ (0, n.createFirstRadiation)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.firstRadiation = Ei;
  var Ti = /* @__PURE__ */ (0, n.createGravitationConstant)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.gravitationConstant = Ti;
  var Oi = /* @__PURE__ */ (0, n.createHartreeEnergy)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.hartreeEnergy = Oi;
  var Ii = /* @__PURE__ */ (0, n.createKlitzing)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.klitzing = Ii;
  var ki = /* @__PURE__ */ (0, n.createMagneticConstant)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.magneticConstant = ki;
  var Li = /* @__PURE__ */ (0, n.createMolarMass)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.molarMass = Li;
  var ji = /* @__PURE__ */ (0, n.createMolarPlanckConstant)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.molarPlanckConstant = ji;
  var Ri = /* @__PURE__ */ (0, n.createNeutronMass)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.neutronMass = Ri;
  var Fi = /* @__PURE__ */ (0, n.createPlanckCharge)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.planckCharge = Fi;
  var vn = /* @__PURE__ */ (0, n.createPlanckLength)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.planckLength = vn;
  var Ur = /* @__PURE__ */ (0, n.createPlanckTemperature)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.planckTemperature = Ur;
  var Bi = /* @__PURE__ */ (0, n.createProtonMass)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.protonMass = Bi;
  var Gi = /* @__PURE__ */ (0, n.createReducedPlanckConstant)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.reducedPlanckConstant = Gi;
  var zi = /* @__PURE__ */ (0, n.createSecondRadiation)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.secondRadiation = zi;
  var Vi = /* @__PURE__ */ (0, n.createStefanBoltzmann)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.stefanBoltzmann = Vi;
  var Wi = /* @__PURE__ */ (0, n.createVacuumImpedance)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.vacuumImpedance = Wi;
  var _a = /* @__PURE__ */ (0, n.createUsolve)({
    DenseMatrix: F,
    divideScalar: hn,
    equalScalar: L,
    matrix: te,
    multiplyScalar: ce,
    subtract: gn,
    typed: O
  });
  t.usolve = _a;
  var ba = /* @__PURE__ */ (0, n.createNorm)({
    abs: Cn,
    add: Mn,
    conj: ln,
    ctranspose: la,
    eigs: ya,
    equalScalar: L,
    larger: wn,
    matrix: te,
    multiply: _n,
    pow: Rn,
    smaller: fn,
    sqrt: un,
    typed: O
  });
  t.norm = ba;
  var Ui = /* @__PURE__ */ (0, n.createLusolve)({
    DenseMatrix: F,
    lsolve: ua,
    lup: Qn,
    matrix: te,
    slu: fa,
    typed: O,
    usolve: _a
  });
  t.lusolve = Ui;
  var qi = /* @__PURE__ */ (0, n.createSqrtm)({
    abs: Cn,
    add: Mn,
    identity: Wr,
    inv: Vn,
    max: oa,
    multiply: _n,
    size: cn,
    sqrt: un,
    subtract: gn,
    typed: O
  });
  t.sqrtm = qi;
  var Hi = /* @__PURE__ */ (0, n.createMultinomial)({
    add: Mn,
    divide: Bn,
    factorial: Un,
    isInteger: G,
    isPositive: k,
    multiply: _n,
    typed: O
  });
  t.multinomial = Hi;
  var Zi = /* @__PURE__ */ (0, n.createAvogadro)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.avogadro = Zi;
  var Yi = /* @__PURE__ */ (0, n.createClassicalElectronRadius)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.classicalElectronRadius = Yi;
  var Xi = /* @__PURE__ */ (0, n.createElectricConstant)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.electricConstant = Xi;
  var Qi = /* @__PURE__ */ (0, n.createFermiCoupling)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.fermiCoupling = Qi;
  var Ji = /* @__PURE__ */ (0, n.createGravity)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.gravity = Ji;
  var Ki = /* @__PURE__ */ (0, n.createLoschmidt)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.loschmidt = Ki;
  var ts = /* @__PURE__ */ (0, n.createMolarMassC12)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.molarMassC12 = ts;
  var Ue = /* @__PURE__ */ (0, n.createNuclearMagneton)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.nuclearMagneton = Ue;
  var ss = /* @__PURE__ */ (0, n.createPlanckMass)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.planckMass = ss;
  var os = /* @__PURE__ */ (0, n.createQuantumOfCirculation)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.quantumOfCirculation = os;
  var cs = /* @__PURE__ */ (0, n.createSpeedOfLight)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.speedOfLight = cs;
  var ds = /* @__PURE__ */ (0, n.createWienDisplacement)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.wienDisplacement = ds;
  var rs = /* @__PURE__ */ (0, n.createRotationMatrix)({
    BigNumber: h,
    DenseMatrix: F,
    SparseMatrix: K,
    addScalar: Tr,
    config: r.config,
    cos: pr,
    matrix: te,
    multiplyScalar: ce,
    norm: ba,
    sin: Fr,
    typed: O,
    unaryMinus: Pr
  });
  t.rotationMatrix = rs;
  var ns = /* @__PURE__ */ (0, n.createMedian)({
    add: Mn,
    compare: Dn,
    divide: Bn,
    partitionSelect: Zn,
    typed: O
  });
  t.median = ns;
  var ls = /* @__PURE__ */ (0, n.createBohrRadius)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.bohrRadius = ls;
  var us = /* @__PURE__ */ (0, n.createElementaryCharge)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.elementaryCharge = us;
  var ps = /* @__PURE__ */ (0, n.createInverseConductanceQuantum)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.inverseConductanceQuantum = ps;
  var fs = /* @__PURE__ */ (0, n.createMolarVolume)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.molarVolume = fs;
  var hs = /* @__PURE__ */ (0, n.createPlanckTime)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.planckTime = hs;
  var ms = /* @__PURE__ */ (0, n.createThomsonCrossSection)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.thomsonCrossSection = ms;
  var gs = /* @__PURE__ */ (0, n.createRotate)({
    multiply: _n,
    rotationMatrix: rs,
    typed: O
  });
  t.rotate = gs;
  var vs = /* @__PURE__ */ (0, n.createMad)({
    abs: Cn,
    map: $r,
    median: ns,
    subtract: gn,
    typed: O
  });
  t.mad = vs;
  var ys = /* @__PURE__ */ (0, n.createCoulomb)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.coulomb = ys;
  var _s = /* @__PURE__ */ (0, n.createMagneticFluxQuantum)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.magneticFluxQuantum = _s;
  var bs = /* @__PURE__ */ (0, n.createRydberg)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.rydberg = bs;
  var $s = /* @__PURE__ */ (0, n.createUnitFunction)({
    Unit: Hr,
    typed: O
  });
  t.unit = $s;
  var xs = /* @__PURE__ */ (0, n.createGasConstant)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.gasConstant = xs;
  var ws = /* @__PURE__ */ (0, n.createPlanckConstant)({
    BigNumber: h,
    Unit: Hr,
    config: r.config
  });
  t.planckConstant = ws;
})(pureFunctionsAny_generated);
var impureFunctionsAny_generated = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "docs", {
    enumerable: !0,
    get: function() {
      return s.embeddedDocs;
    }
  }), t.derivative = t.parser = t.rationalize = t.simplify = t.compile = t.help = t.Parser = t.Help = t.evaluate = t.parse = t.FunctionNode = t.SymbolNode = t.AssignmentNode = t.IndexNode = t.AccessorNode = t.chain = t.FunctionAssignmentNode = t.RangeNode = t.OperatorNode = t.ConditionalNode = t.reviver = t.Chain = t.RelationalNode = t.ParenthesisNode = t.ObjectNode = t.ConstantNode = t.BlockNode = t.ArrayNode = t.Node = void 0;
  var r = configReadonly, n = factoriesAny, a = pureFunctionsAny_generated, s = embeddedDocs$1;
  function o() {
    return o = Object.assign || function(J) {
      for (var q = 1; q < arguments.length; q++) {
        var Z = arguments[q];
        for (var ae in Z)
          Object.prototype.hasOwnProperty.call(Z, ae) && (J[ae] = Z[ae]);
      }
      return J;
    }, o.apply(this, arguments);
  }
  var c = {}, l = {}, d = {}, h = (0, n.createNode)({
    mathWithTransform: l
  });
  t.Node = h;
  var u = (0, n.createArrayNode)({
    Node: h
  });
  t.ArrayNode = u;
  var p = (0, n.createBlockNode)({
    Node: h,
    ResultSet: a.ResultSet
  });
  t.BlockNode = p;
  var m = (0, n.createConstantNode)({
    Node: h
  });
  t.ConstantNode = m;
  var g = (0, n.createObjectNode)({
    Node: h
  });
  t.ObjectNode = g;
  var v = (0, n.createParenthesisNode)({
    Node: h
  });
  t.ParenthesisNode = v;
  var y = (0, n.createRelationalNode)({
    Node: h
  });
  t.RelationalNode = y;
  var x = (0, n.createChainClass)({
    math: c
  });
  t.Chain = x;
  var _ = (0, n.createReviver)({
    classes: d
  });
  t.reviver = _;
  var $ = (0, n.createConditionalNode)({
    Node: h
  });
  t.ConditionalNode = $;
  var b = (0, n.createOperatorNode)({
    Node: h
  });
  t.OperatorNode = b;
  var M = (0, n.createRangeNode)({
    Node: h
  });
  t.RangeNode = M;
  var C = (0, n.createFunctionAssignmentNode)({
    Node: h,
    typed: a.typed
  });
  t.FunctionAssignmentNode = C;
  var S = (0, n.createChain)({
    Chain: x,
    typed: a.typed
  });
  t.chain = S;
  var A = (0, n.createAccessorNode)({
    Node: h,
    subset: a.subset
  });
  t.AccessorNode = A;
  var D = (0, n.createIndexNode)({
    Node: h,
    Range: a.Range,
    size: a.size
  });
  t.IndexNode = D;
  var N = (0, n.createAssignmentNode)({
    matrix: a.matrix,
    Node: h,
    subset: a.subset
  });
  t.AssignmentNode = N;
  var T = (0, n.createSymbolNode)({
    Unit: a.Unit,
    Node: h,
    math: c
  });
  t.SymbolNode = T;
  var R = (0, n.createFunctionNode)({
    Node: h,
    SymbolNode: T,
    math: c
  });
  t.FunctionNode = R;
  var F = (0, n.createParse)({
    AccessorNode: A,
    ArrayNode: u,
    AssignmentNode: N,
    BlockNode: p,
    ConditionalNode: $,
    ConstantNode: m,
    FunctionAssignmentNode: C,
    FunctionNode: R,
    IndexNode: D,
    ObjectNode: g,
    OperatorNode: b,
    ParenthesisNode: v,
    RangeNode: M,
    RelationalNode: y,
    SymbolNode: T,
    config: r.config,
    numeric: a.numeric,
    typed: a.typed
  });
  t.parse = F;
  var z = (0, n.createEvaluate)({
    parse: F,
    typed: a.typed
  });
  t.evaluate = z;
  var O = (0, n.createHelpClass)({
    parse: F
  });
  t.Help = O;
  var G = (0, n.createParserClass)({
    parse: F
  });
  t.Parser = G;
  var I = (0, n.createHelp)({
    Help: O,
    mathWithTransform: l,
    typed: a.typed
  });
  t.help = I;
  var k = (0, n.createCompile)({
    parse: F,
    typed: a.typed
  });
  t.compile = k;
  var B = (0, n.createSimplify)({
    bignumber: a.bignumber,
    fraction: a.fraction,
    ConstantNode: m,
    FunctionNode: R,
    OperatorNode: b,
    ParenthesisNode: v,
    SymbolNode: T,
    add: a.add,
    config: r.config,
    divide: a.divide,
    equal: a.equal,
    isZero: a.isZero,
    mathWithTransform: l,
    multiply: a.multiply,
    parse: F,
    pow: a.pow,
    subtract: a.subtract,
    typed: a.typed
  });
  t.simplify = B;
  var L = (0, n.createRationalize)({
    bignumber: a.bignumber,
    fraction: a.fraction,
    ConstantNode: m,
    FunctionNode: R,
    OperatorNode: b,
    ParenthesisNode: v,
    SymbolNode: T,
    add: a.add,
    config: r.config,
    divide: a.divide,
    equal: a.equal,
    isZero: a.isZero,
    mathWithTransform: l,
    multiply: a.multiply,
    parse: F,
    pow: a.pow,
    simplify: B,
    subtract: a.subtract,
    typed: a.typed
  });
  t.rationalize = L;
  var V = (0, n.createParser)({
    Parser: G,
    typed: a.typed
  });
  t.parser = V;
  var U = (0, n.createDerivative)({
    ConstantNode: m,
    FunctionNode: R,
    OperatorNode: b,
    ParenthesisNode: v,
    SymbolNode: T,
    config: r.config,
    equal: a.equal,
    isZero: a.isZero,
    numeric: a.numeric,
    parse: F,
    simplify: B,
    typed: a.typed
  });
  t.derivative = U, o(c, {
    reviver: _,
    false: a._false,
    null: a._null,
    true: a._true,
    replacer: a.replacer,
    i: a.i,
    LN10: a.LN10,
    LOG10E: a.LOG10E,
    NaN: a._NaN,
    pi: a.pi,
    SQRT1_2: a.SQRT1_2,
    tau: a.tau,
    efimovFactor: a.efimovFactor,
    fineStructure: a.fineStructure,
    sackurTetrode: a.sackurTetrode,
    weakMixingAngle: a.weakMixingAngle,
    e: a.e,
    Infinity: a._Infinity,
    LOG2E: a.LOG2E,
    PI: a.pi,
    version: a.version,
    E: a.e,
    phi: a.phi,
    typed: a.typed,
    isInteger: a.isInteger,
    isNumeric: a.isNumeric,
    isPositive: a.isPositive,
    isNaN: a.isNaN,
    equalScalar: a.equalScalar,
    number: a.number,
    boolean: a.boolean,
    complex: a.complex,
    splitUnit: a.splitUnit,
    unaryPlus: a.unaryPlus,
    apply: a.apply,
    cube: a.cube,
    expm1: a.expm1,
    log10: a.log10,
    multiplyScalar: a.multiplyScalar,
    sign: a.sign,
    square: a.square,
    bitNot: a.bitNot,
    arg: a.arg,
    im: a.im,
    not: a.not,
    filter: a.filter,
    forEach: a.forEach,
    map: a.map,
    erf: a.erf,
    format: a.format,
    oct: a.oct,
    print: a.print,
    isPrime: a.isPrime,
    acos: a.acos,
    acot: a.acot,
    acsc: a.acsc,
    asec: a.asec,
    asin: a.asin,
    atan: a.atan,
    atanh: a.atanh,
    cosh: a.cosh,
    coth: a.coth,
    csch: a.csch,
    sech: a.sech,
    sinh: a.sinh,
    tanh: a.tanh,
    chain: S,
    combinations: a.combinations,
    pickRandom: a.pickRandom,
    randomInt: a.randomInt,
    LN2: a.LN2,
    clone: a.clone,
    hasNumericValue: a.hasNumericValue,
    typeOf: a.typeOf,
    string: a.string,
    fraction: a.fraction,
    unaryMinus: a.unaryMinus,
    addScalar: a.addScalar,
    exp: a.exp,
    log2: a.log2,
    sqrt: a.sqrt,
    conj: a.conj,
    getMatrixDataType: a.getMatrixDataType,
    mode: a.mode,
    bin: a.bin,
    acosh: a.acosh,
    acsch: a.acsch,
    asinh: a.asinh,
    cos: a.cos,
    csc: a.csc,
    sin: a.sin,
    combinationsWithRep: a.combinationsWithRep,
    random: a.random,
    SQRT2: a.SQRT2,
    isNegative: a.isNegative,
    matrix: a.matrix,
    cbrt: a.cbrt,
    gcd: a.gcd,
    mod: a.mod,
    nthRoot: a.nthRoot,
    xgcd: a.xgcd,
    bitAnd: a.bitAnd,
    bitXor: a.bitXor,
    or: a.or,
    concat: a.concat,
    diag: a.diag,
    identity: a.identity,
    ones: a.ones,
    reshape: a.reshape,
    size: a.size,
    subset: a.subset,
    zeros: a.zeros,
    hex: a.hex,
    round: a.round,
    leftShift: a.leftShift,
    rightLogShift: a.rightLogShift,
    compare: a.compare,
    compareText: a.compareText,
    smaller: a.smaller,
    larger: a.larger,
    unequal: a.unequal,
    sparse: a.sparse,
    acoth: a.acoth,
    atan2: a.atan2,
    sec: a.sec,
    add: a.add,
    dot: a.dot,
    composition: a.composition,
    isZero: a.isZero,
    abs: a.abs,
    floor: a.floor,
    multiply: a.multiply,
    dotMultiply: a.dotMultiply,
    re: a.re,
    flatten: a.flatten,
    resize: a.resize,
    squeeze: a.squeeze,
    to: a.to,
    pow: a.pow,
    dotPow: a.dotPow,
    rightArithShift: a.rightArithShift,
    compareNatural: a.compareNatural,
    equalText: a.equalText,
    largerEq: a.largerEq,
    partitionSelect: a.partitionSelect,
    asech: a.asech,
    tan: a.tan,
    setDifference: a.setDifference,
    setIntersect: a.setIntersect,
    setMultiplicity: a.setMultiplicity,
    setSize: a.setSize,
    trace: a.trace,
    quantileSeq: a.quantileSeq,
    gamma: a.gamma,
    bignumber: a.bignumber,
    lcm: a.lcm,
    bitOr: a.bitOr,
    kron: a.kron,
    transpose: a.transpose,
    numeric: a.numeric,
    and: a.and,
    smallerEq: a.smallerEq,
    sort: a.sort,
    min: a.min,
    cot: a.cot,
    setDistinct: a.setDistinct,
    setPowerset: a.setPowerset,
    index: a.index,
    sum: a.sum,
    factorial: a.factorial,
    permutations: a.permutations,
    ceil: a.ceil,
    subtract: a.subtract,
    cross: a.cross,
    range: a.range,
    row: a.row,
    prod: a.prod,
    equal: a.equal,
    max: a.max,
    setCartesian: a.setCartesian,
    setSymDifference: a.setSymDifference,
    fix: a.fix,
    column: a.column,
    ctranspose: a.ctranspose,
    deepEqual: a.deepEqual,
    setIsSubset: a.setIsSubset,
    xor: a.xor,
    divideScalar: a.divideScalar,
    nthRoots: a.nthRoots,
    lsolve: a.lsolve,
    lsolveAll: a.lsolveAll,
    setUnion: a.setUnion,
    lup: a.lup,
    slu: a.slu,
    det: a.det,
    distance: a.distance,
    stirlingS2: a.stirlingS2,
    catalan: a.catalan,
    diff: a.diff,
    log: a.log,
    dotDivide: a.dotDivide,
    usolveAll: a.usolveAll,
    hypot: a.hypot,
    qr: a.qr,
    inv: a.inv,
    expm: a.expm,
    divide: a.divide,
    mean: a.mean,
    variance: a.variance,
    kldivergence: a.kldivergence,
    bellNumbers: a.bellNumbers,
    log1p: a.log1p,
    createUnit: a.createUnit,
    eigs: a.eigs,
    intersect: a.intersect,
    std: a.std,
    atomicMass: a.atomicMass,
    bohrMagneton: a.bohrMagneton,
    boltzmann: a.boltzmann,
    conductanceQuantum: a.conductanceQuantum,
    deuteronMass: a.deuteronMass,
    electronMass: a.electronMass,
    faraday: a.faraday,
    firstRadiation: a.firstRadiation,
    gravitationConstant: a.gravitationConstant,
    hartreeEnergy: a.hartreeEnergy,
    klitzing: a.klitzing,
    magneticConstant: a.magneticConstant,
    molarMass: a.molarMass,
    molarPlanckConstant: a.molarPlanckConstant,
    neutronMass: a.neutronMass,
    planckCharge: a.planckCharge,
    planckLength: a.planckLength,
    planckTemperature: a.planckTemperature,
    protonMass: a.protonMass,
    reducedPlanckConstant: a.reducedPlanckConstant,
    secondRadiation: a.secondRadiation,
    stefanBoltzmann: a.stefanBoltzmann,
    vacuumImpedance: a.vacuumImpedance,
    usolve: a.usolve,
    norm: a.norm,
    lusolve: a.lusolve,
    sqrtm: a.sqrtm,
    multinomial: a.multinomial,
    avogadro: a.avogadro,
    classicalElectronRadius: a.classicalElectronRadius,
    electricConstant: a.electricConstant,
    fermiCoupling: a.fermiCoupling,
    gravity: a.gravity,
    loschmidt: a.loschmidt,
    molarMassC12: a.molarMassC12,
    nuclearMagneton: a.nuclearMagneton,
    planckMass: a.planckMass,
    quantumOfCirculation: a.quantumOfCirculation,
    speedOfLight: a.speedOfLight,
    wienDisplacement: a.wienDisplacement,
    rotationMatrix: a.rotationMatrix,
    median: a.median,
    bohrRadius: a.bohrRadius,
    elementaryCharge: a.elementaryCharge,
    inverseConductanceQuantum: a.inverseConductanceQuantum,
    molarVolume: a.molarVolume,
    planckTime: a.planckTime,
    thomsonCrossSection: a.thomsonCrossSection,
    rotate: a.rotate,
    parse: F,
    evaluate: z,
    mad: a.mad,
    coulomb: a.coulomb,
    magneticFluxQuantum: a.magneticFluxQuantum,
    rydberg: a.rydberg,
    unit: a.unit,
    help: I,
    gasConstant: a.gasConstant,
    compile: k,
    simplify: B,
    rationalize: L,
    parser: V,
    planckConstant: a.planckConstant,
    derivative: U,
    config: r.config
  }), o(l, c, {
    apply: (0, n.createApplyTransform)({
      isInteger: a.isInteger,
      typed: a.typed
    }),
    filter: (0, n.createFilterTransform)({
      typed: a.typed
    }),
    map: (0, n.createMapTransform)({
      typed: a.typed
    }),
    forEach: (0, n.createForEachTransform)({
      typed: a.typed
    }),
    subset: (0, n.createSubsetTransform)({
      matrix: a.matrix,
      typed: a.typed
    }),
    index: (0, n.createIndexTransform)({
      Index: a.Index
    }),
    concat: (0, n.createConcatTransform)({
      isInteger: a.isInteger,
      matrix: a.matrix,
      typed: a.typed
    }),
    max: (0, n.createMaxTransform)({
      config: r.config,
      larger: a.larger,
      numeric: a.numeric,
      typed: a.typed
    }),
    min: (0, n.createMinTransform)({
      config: r.config,
      numeric: a.numeric,
      smaller: a.smaller,
      typed: a.typed
    }),
    sum: (0, n.createSumTransform)({
      add: a.add,
      config: r.config,
      numeric: a.numeric,
      typed: a.typed
    }),
    column: (0, n.createColumnTransform)({
      Index: a.Index,
      matrix: a.matrix,
      range: a.range,
      typed: a.typed
    }),
    range: (0, n.createRangeTransform)({
      bignumber: a.bignumber,
      matrix: a.matrix,
      config: r.config,
      larger: a.larger,
      largerEq: a.largerEq,
      smaller: a.smaller,
      smallerEq: a.smallerEq,
      typed: a.typed
    }),
    diff: (0, n.createDiffTransform)({
      bignumber: a.bignumber,
      matrix: a.matrix,
      number: a.number,
      subtract: a.subtract,
      typed: a.typed
    }),
    row: (0, n.createRowTransform)({
      Index: a.Index,
      matrix: a.matrix,
      range: a.range,
      typed: a.typed
    }),
    mean: (0, n.createMeanTransform)({
      add: a.add,
      divide: a.divide,
      typed: a.typed
    }),
    variance: (0, n.createVarianceTransform)({
      add: a.add,
      apply: a.apply,
      divide: a.divide,
      isNaN: a.isNaN,
      multiply: a.multiply,
      subtract: a.subtract,
      typed: a.typed
    }),
    std: (0, n.createStdTransform)({
      sqrt: a.sqrt,
      typed: a.typed,
      variance: a.variance
    })
  }), o(d, {
    ResultSet: a.ResultSet,
    Complex: a.Complex,
    Range: a.Range,
    Node: h,
    ArrayNode: u,
    BlockNode: p,
    ConstantNode: m,
    ObjectNode: g,
    ParenthesisNode: v,
    RelationalNode: y,
    Chain: x,
    BigNumber: a.BigNumber,
    Matrix: a.Matrix,
    ConditionalNode: $,
    OperatorNode: b,
    Fraction: a.Fraction,
    RangeNode: M,
    DenseMatrix: a.DenseMatrix,
    FunctionAssignmentNode: C,
    SparseMatrix: a.SparseMatrix,
    ImmutableDenseMatrix: a.ImmutableDenseMatrix,
    FibonacciHeap: a.FibonacciHeap,
    AccessorNode: A,
    IndexNode: D,
    Index: a.Index,
    AssignmentNode: N,
    Spa: a.Spa,
    Unit: a.Unit,
    SymbolNode: T,
    FunctionNode: R,
    Help: O,
    Parser: G
  }), x.createProxy(c);
})(impureFunctionsAny_generated);
var typeChecks = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "isAccessorNode", {
    enumerable: !0,
    get: function() {
      return r.isAccessorNode;
    }
  }), Object.defineProperty(t, "isArray", {
    enumerable: !0,
    get: function() {
      return r.isArray;
    }
  }), Object.defineProperty(t, "isArrayNode", {
    enumerable: !0,
    get: function() {
      return r.isArrayNode;
    }
  }), Object.defineProperty(t, "isAssignmentNode", {
    enumerable: !0,
    get: function() {
      return r.isAssignmentNode;
    }
  }), Object.defineProperty(t, "isBigNumber", {
    enumerable: !0,
    get: function() {
      return r.isBigNumber;
    }
  }), Object.defineProperty(t, "isBlockNode", {
    enumerable: !0,
    get: function() {
      return r.isBlockNode;
    }
  }), Object.defineProperty(t, "isBoolean", {
    enumerable: !0,
    get: function() {
      return r.isBoolean;
    }
  }), Object.defineProperty(t, "isChain", {
    enumerable: !0,
    get: function() {
      return r.isChain;
    }
  }), Object.defineProperty(t, "isCollection", {
    enumerable: !0,
    get: function() {
      return r.isCollection;
    }
  }), Object.defineProperty(t, "isComplex", {
    enumerable: !0,
    get: function() {
      return r.isComplex;
    }
  }), Object.defineProperty(t, "isConditionalNode", {
    enumerable: !0,
    get: function() {
      return r.isConditionalNode;
    }
  }), Object.defineProperty(t, "isConstantNode", {
    enumerable: !0,
    get: function() {
      return r.isConstantNode;
    }
  }), Object.defineProperty(t, "isDate", {
    enumerable: !0,
    get: function() {
      return r.isDate;
    }
  }), Object.defineProperty(t, "isDenseMatrix", {
    enumerable: !0,
    get: function() {
      return r.isDenseMatrix;
    }
  }), Object.defineProperty(t, "isFraction", {
    enumerable: !0,
    get: function() {
      return r.isFraction;
    }
  }), Object.defineProperty(t, "isFunction", {
    enumerable: !0,
    get: function() {
      return r.isFunction;
    }
  }), Object.defineProperty(t, "isFunctionAssignmentNode", {
    enumerable: !0,
    get: function() {
      return r.isFunctionAssignmentNode;
    }
  }), Object.defineProperty(t, "isFunctionNode", {
    enumerable: !0,
    get: function() {
      return r.isFunctionNode;
    }
  }), Object.defineProperty(t, "isHelp", {
    enumerable: !0,
    get: function() {
      return r.isHelp;
    }
  }), Object.defineProperty(t, "isIndex", {
    enumerable: !0,
    get: function() {
      return r.isIndex;
    }
  }), Object.defineProperty(t, "isIndexNode", {
    enumerable: !0,
    get: function() {
      return r.isIndexNode;
    }
  }), Object.defineProperty(t, "isMatrix", {
    enumerable: !0,
    get: function() {
      return r.isMatrix;
    }
  }), Object.defineProperty(t, "isNode", {
    enumerable: !0,
    get: function() {
      return r.isNode;
    }
  }), Object.defineProperty(t, "isNull", {
    enumerable: !0,
    get: function() {
      return r.isNull;
    }
  }), Object.defineProperty(t, "isNumber", {
    enumerable: !0,
    get: function() {
      return r.isNumber;
    }
  }), Object.defineProperty(t, "isString", {
    enumerable: !0,
    get: function() {
      return r.isString;
    }
  }), Object.defineProperty(t, "isUndefined", {
    enumerable: !0,
    get: function() {
      return r.isUndefined;
    }
  }), Object.defineProperty(t, "isObject", {
    enumerable: !0,
    get: function() {
      return r.isObject;
    }
  }), Object.defineProperty(t, "isObjectNode", {
    enumerable: !0,
    get: function() {
      return r.isObjectNode;
    }
  }), Object.defineProperty(t, "isOperatorNode", {
    enumerable: !0,
    get: function() {
      return r.isOperatorNode;
    }
  }), Object.defineProperty(t, "isParenthesisNode", {
    enumerable: !0,
    get: function() {
      return r.isParenthesisNode;
    }
  }), Object.defineProperty(t, "isRange", {
    enumerable: !0,
    get: function() {
      return r.isRange;
    }
  }), Object.defineProperty(t, "isRangeNode", {
    enumerable: !0,
    get: function() {
      return r.isRangeNode;
    }
  }), Object.defineProperty(t, "isRegExp", {
    enumerable: !0,
    get: function() {
      return r.isRegExp;
    }
  }), Object.defineProperty(t, "isResultSet", {
    enumerable: !0,
    get: function() {
      return r.isResultSet;
    }
  }), Object.defineProperty(t, "isSparseMatrix", {
    enumerable: !0,
    get: function() {
      return r.isSparseMatrix;
    }
  }), Object.defineProperty(t, "isSymbolNode", {
    enumerable: !0,
    get: function() {
      return r.isSymbolNode;
    }
  }), Object.defineProperty(t, "isUnit", {
    enumerable: !0,
    get: function() {
      return r.isUnit;
    }
  });
  var r = is;
})(typeChecks);
var dependenciesAny_generated = {}, dependenciesTyped_generated = {}, dependenciesBigNumberClass_generated = {};
Object.defineProperty(dependenciesBigNumberClass_generated, "__esModule", {
  value: !0
});
dependenciesBigNumberClass_generated.BigNumberDependencies = void 0;
var _factoriesAny$58 = factoriesAny, BigNumberDependencies = {
  createBigNumberClass: _factoriesAny$58.createBigNumberClass
};
dependenciesBigNumberClass_generated.BigNumberDependencies = BigNumberDependencies;
var dependenciesComplexClass_generated = {};
Object.defineProperty(dependenciesComplexClass_generated, "__esModule", {
  value: !0
});
dependenciesComplexClass_generated.ComplexDependencies = void 0;
var _factoriesAny$57 = factoriesAny, ComplexDependencies = {
  createComplexClass: _factoriesAny$57.createComplexClass
};
dependenciesComplexClass_generated.ComplexDependencies = ComplexDependencies;
var dependenciesDenseMatrixClass_generated = {}, dependenciesMatrixClass_generated = {};
Object.defineProperty(dependenciesMatrixClass_generated, "__esModule", {
  value: !0
});
dependenciesMatrixClass_generated.MatrixDependencies = void 0;
var _factoriesAny$56 = factoriesAny, MatrixDependencies = {
  createMatrixClass: _factoriesAny$56.createMatrixClass
};
dependenciesMatrixClass_generated.MatrixDependencies = MatrixDependencies;
Object.defineProperty(dependenciesDenseMatrixClass_generated, "__esModule", {
  value: !0
});
dependenciesDenseMatrixClass_generated.DenseMatrixDependencies = void 0;
var _dependenciesMatrixClassGenerated$2 = dependenciesMatrixClass_generated, _factoriesAny$55 = factoriesAny, DenseMatrixDependencies = {
  MatrixDependencies: _dependenciesMatrixClassGenerated$2.MatrixDependencies,
  createDenseMatrixClass: _factoriesAny$55.createDenseMatrixClass
};
dependenciesDenseMatrixClass_generated.DenseMatrixDependencies = DenseMatrixDependencies;
var dependenciesFractionClass_generated = {};
Object.defineProperty(dependenciesFractionClass_generated, "__esModule", {
  value: !0
});
dependenciesFractionClass_generated.FractionDependencies = void 0;
var _factoriesAny$54 = factoriesAny, FractionDependencies = {
  createFractionClass: _factoriesAny$54.createFractionClass
};
dependenciesFractionClass_generated.FractionDependencies = FractionDependencies;
Object.defineProperty(dependenciesTyped_generated, "__esModule", {
  value: !0
});
dependenciesTyped_generated.typedDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1q = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$m = dependenciesComplexClass_generated, _dependenciesDenseMatrixClassGenerated$B = dependenciesDenseMatrixClass_generated, _dependenciesFractionClassGenerated$5 = dependenciesFractionClass_generated, _factoriesAny$53 = factoriesAny, typedDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1q.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$m.ComplexDependencies,
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$B.DenseMatrixDependencies,
  FractionDependencies: _dependenciesFractionClassGenerated$5.FractionDependencies,
  createTyped: _factoriesAny$53.createTyped
};
dependenciesTyped_generated.typedDependencies = typedDependencies;
var dependenciesResultSet_generated = {};
Object.defineProperty(dependenciesResultSet_generated, "__esModule", {
  value: !0
});
dependenciesResultSet_generated.ResultSetDependencies = void 0;
var _factoriesAny$52 = factoriesAny, ResultSetDependencies = {
  createResultSet: _factoriesAny$52.createResultSet
};
dependenciesResultSet_generated.ResultSetDependencies = ResultSetDependencies;
var dependenciesRangeClass_generated = {};
Object.defineProperty(dependenciesRangeClass_generated, "__esModule", {
  value: !0
});
dependenciesRangeClass_generated.RangeDependencies = void 0;
var _factoriesAny$51 = factoriesAny, RangeDependencies = {
  createRangeClass: _factoriesAny$51.createRangeClass
};
dependenciesRangeClass_generated.RangeDependencies = RangeDependencies;
var dependenciesClone_generated = {};
Object.defineProperty(dependenciesClone_generated, "__esModule", {
  value: !0
});
dependenciesClone_generated.cloneDependencies = void 0;
var _dependenciesTypedGenerated$3v = dependenciesTyped_generated, _factoriesAny$50 = factoriesAny, cloneDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3v.typedDependencies,
  createClone: _factoriesAny$50.createClone
};
dependenciesClone_generated.cloneDependencies = cloneDependencies;
var dependenciesIsInteger_generated = {};
Object.defineProperty(dependenciesIsInteger_generated, "__esModule", {
  value: !0
});
dependenciesIsInteger_generated.isIntegerDependencies = void 0;
var _dependenciesTypedGenerated$3u = dependenciesTyped_generated, _factoriesAny$4$ = factoriesAny, isIntegerDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3u.typedDependencies,
  createIsInteger: _factoriesAny$4$.createIsInteger
};
dependenciesIsInteger_generated.isIntegerDependencies = isIntegerDependencies;
var dependenciesIsNegative_generated = {};
Object.defineProperty(dependenciesIsNegative_generated, "__esModule", {
  value: !0
});
dependenciesIsNegative_generated.isNegativeDependencies = void 0;
var _dependenciesTypedGenerated$3t = dependenciesTyped_generated, _factoriesAny$4_ = factoriesAny, isNegativeDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3t.typedDependencies,
  createIsNegative: _factoriesAny$4_.createIsNegative
};
dependenciesIsNegative_generated.isNegativeDependencies = isNegativeDependencies;
var dependenciesIsNumeric_generated = {};
Object.defineProperty(dependenciesIsNumeric_generated, "__esModule", {
  value: !0
});
dependenciesIsNumeric_generated.isNumericDependencies = void 0;
var _dependenciesTypedGenerated$3s = dependenciesTyped_generated, _factoriesAny$4Z = factoriesAny, isNumericDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3s.typedDependencies,
  createIsNumeric: _factoriesAny$4Z.createIsNumeric
};
dependenciesIsNumeric_generated.isNumericDependencies = isNumericDependencies;
var dependenciesHasNumericValue_generated = {};
Object.defineProperty(dependenciesHasNumericValue_generated, "__esModule", {
  value: !0
});
dependenciesHasNumericValue_generated.hasNumericValueDependencies = void 0;
var _dependenciesIsNumericGenerated$4 = dependenciesIsNumeric_generated, _dependenciesTypedGenerated$3r = dependenciesTyped_generated, _factoriesAny$4Y = factoriesAny, hasNumericValueDependencies = {
  isNumericDependencies: _dependenciesIsNumericGenerated$4.isNumericDependencies,
  typedDependencies: _dependenciesTypedGenerated$3r.typedDependencies,
  createHasNumericValue: _factoriesAny$4Y.createHasNumericValue
};
dependenciesHasNumericValue_generated.hasNumericValueDependencies = hasNumericValueDependencies;
var dependenciesIsPositive_generated = {};
Object.defineProperty(dependenciesIsPositive_generated, "__esModule", {
  value: !0
});
dependenciesIsPositive_generated.isPositiveDependencies = void 0;
var _dependenciesTypedGenerated$3q = dependenciesTyped_generated, _factoriesAny$4X = factoriesAny, isPositiveDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3q.typedDependencies,
  createIsPositive: _factoriesAny$4X.createIsPositive
};
dependenciesIsPositive_generated.isPositiveDependencies = isPositiveDependencies;
var dependenciesIsZero_generated = {};
Object.defineProperty(dependenciesIsZero_generated, "__esModule", {
  value: !0
});
dependenciesIsZero_generated.isZeroDependencies = void 0;
var _dependenciesTypedGenerated$3p = dependenciesTyped_generated, _factoriesAny$4W = factoriesAny, isZeroDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3p.typedDependencies,
  createIsZero: _factoriesAny$4W.createIsZero
};
dependenciesIsZero_generated.isZeroDependencies = isZeroDependencies;
var dependenciesIsNaN_generated = {};
Object.defineProperty(dependenciesIsNaN_generated, "__esModule", {
  value: !0
});
dependenciesIsNaN_generated.isNaNDependencies = void 0;
var _dependenciesTypedGenerated$3o = dependenciesTyped_generated, _factoriesAny$4V = factoriesAny, isNaNDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3o.typedDependencies,
  createIsNaN: _factoriesAny$4V.createIsNaN
};
dependenciesIsNaN_generated.isNaNDependencies = isNaNDependencies;
var dependenciesTypeOf_generated = {};
Object.defineProperty(dependenciesTypeOf_generated, "__esModule", {
  value: !0
});
dependenciesTypeOf_generated.typeOfDependencies = void 0;
var _dependenciesTypedGenerated$3n = dependenciesTyped_generated, _factoriesAny$4U = factoriesAny, typeOfDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3n.typedDependencies,
  createTypeOf: _factoriesAny$4U.createTypeOf
};
dependenciesTypeOf_generated.typeOfDependencies = typeOfDependencies;
var dependenciesEqualScalar_generated = {};
Object.defineProperty(dependenciesEqualScalar_generated, "__esModule", {
  value: !0
});
dependenciesEqualScalar_generated.equalScalarDependencies = void 0;
var _dependenciesTypedGenerated$3m = dependenciesTyped_generated, _factoriesAny$4T = factoriesAny, equalScalarDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3m.typedDependencies,
  createEqualScalar: _factoriesAny$4T.createEqualScalar
};
dependenciesEqualScalar_generated.equalScalarDependencies = equalScalarDependencies;
var dependenciesSparseMatrixClass_generated = {};
Object.defineProperty(dependenciesSparseMatrixClass_generated, "__esModule", {
  value: !0
});
dependenciesSparseMatrixClass_generated.SparseMatrixDependencies = void 0;
var _dependenciesMatrixClassGenerated$1 = dependenciesMatrixClass_generated, _dependenciesEqualScalarGenerated$x = dependenciesEqualScalar_generated, _dependenciesTypedGenerated$3l = dependenciesTyped_generated, _factoriesAny$4S = factoriesAny, SparseMatrixDependencies = {
  MatrixDependencies: _dependenciesMatrixClassGenerated$1.MatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$x.equalScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated$3l.typedDependencies,
  createSparseMatrixClass: _factoriesAny$4S.createSparseMatrixClass
};
dependenciesSparseMatrixClass_generated.SparseMatrixDependencies = SparseMatrixDependencies;
var dependenciesNumber_generated = {};
Object.defineProperty(dependenciesNumber_generated, "__esModule", {
  value: !0
});
dependenciesNumber_generated.numberDependencies = void 0;
var _dependenciesTypedGenerated$3k = dependenciesTyped_generated, _factoriesAny$4R = factoriesAny, numberDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3k.typedDependencies,
  createNumber: _factoriesAny$4R.createNumber
};
dependenciesNumber_generated.numberDependencies = numberDependencies;
var dependenciesString_generated = {};
Object.defineProperty(dependenciesString_generated, "__esModule", {
  value: !0
});
dependenciesString_generated.stringDependencies = void 0;
var _dependenciesTypedGenerated$3j = dependenciesTyped_generated, _factoriesAny$4Q = factoriesAny, stringDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3j.typedDependencies,
  createString: _factoriesAny$4Q.createString
};
dependenciesString_generated.stringDependencies = stringDependencies;
var dependenciesBoolean_generated = {};
Object.defineProperty(dependenciesBoolean_generated, "__esModule", {
  value: !0
});
dependenciesBoolean_generated.booleanDependencies = void 0;
var _dependenciesTypedGenerated$3i = dependenciesTyped_generated, _factoriesAny$4P = factoriesAny, booleanDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3i.typedDependencies,
  createBoolean: _factoriesAny$4P.createBoolean
};
dependenciesBoolean_generated.booleanDependencies = booleanDependencies;
var dependenciesBignumber_generated = {};
Object.defineProperty(dependenciesBignumber_generated, "__esModule", {
  value: !0
});
dependenciesBignumber_generated.bignumberDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1p = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$3h = dependenciesTyped_generated, _factoriesAny$4O = factoriesAny, bignumberDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1p.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$3h.typedDependencies,
  createBignumber: _factoriesAny$4O.createBignumber
};
dependenciesBignumber_generated.bignumberDependencies = bignumberDependencies;
var dependenciesComplex_generated = {};
Object.defineProperty(dependenciesComplex_generated, "__esModule", {
  value: !0
});
dependenciesComplex_generated.complexDependencies = void 0;
var _dependenciesComplexClassGenerated$l = dependenciesComplexClass_generated, _dependenciesTypedGenerated$3g = dependenciesTyped_generated, _factoriesAny$4N = factoriesAny, complexDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$l.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$3g.typedDependencies,
  createComplex: _factoriesAny$4N.createComplex
};
dependenciesComplex_generated.complexDependencies = complexDependencies;
var dependenciesFraction_generated = {};
Object.defineProperty(dependenciesFraction_generated, "__esModule", {
  value: !0
});
dependenciesFraction_generated.fractionDependencies = void 0;
var _dependenciesFractionClassGenerated$4 = dependenciesFractionClass_generated, _dependenciesTypedGenerated$3f = dependenciesTyped_generated, _factoriesAny$4M = factoriesAny, fractionDependencies = {
  FractionDependencies: _dependenciesFractionClassGenerated$4.FractionDependencies,
  typedDependencies: _dependenciesTypedGenerated$3f.typedDependencies,
  createFraction: _factoriesAny$4M.createFraction
};
dependenciesFraction_generated.fractionDependencies = fractionDependencies;
var dependenciesMatrix_generated = {};
Object.defineProperty(dependenciesMatrix_generated, "__esModule", {
  value: !0
});
dependenciesMatrix_generated.matrixDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$A = dependenciesDenseMatrixClass_generated, _dependenciesMatrixClassGenerated = dependenciesMatrixClass_generated, _dependenciesSparseMatrixClassGenerated$7 = dependenciesSparseMatrixClass_generated, _dependenciesTypedGenerated$3e = dependenciesTyped_generated, _factoriesAny$4L = factoriesAny, matrixDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$A.DenseMatrixDependencies,
  MatrixDependencies: _dependenciesMatrixClassGenerated.MatrixDependencies,
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated$7.SparseMatrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$3e.typedDependencies,
  createMatrix: _factoriesAny$4L.createMatrix
};
dependenciesMatrix_generated.matrixDependencies = matrixDependencies;
var dependenciesSplitUnit_generated = {};
Object.defineProperty(dependenciesSplitUnit_generated, "__esModule", {
  value: !0
});
dependenciesSplitUnit_generated.splitUnitDependencies = void 0;
var _dependenciesTypedGenerated$3d = dependenciesTyped_generated, _factoriesAny$4K = factoriesAny, splitUnitDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3d.typedDependencies,
  createSplitUnit: _factoriesAny$4K.createSplitUnit
};
dependenciesSplitUnit_generated.splitUnitDependencies = splitUnitDependencies;
var dependenciesUnaryMinus_generated = {};
Object.defineProperty(dependenciesUnaryMinus_generated, "__esModule", {
  value: !0
});
dependenciesUnaryMinus_generated.unaryMinusDependencies = void 0;
var _dependenciesTypedGenerated$3c = dependenciesTyped_generated, _factoriesAny$4J = factoriesAny, unaryMinusDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3c.typedDependencies,
  createUnaryMinus: _factoriesAny$4J.createUnaryMinus
};
dependenciesUnaryMinus_generated.unaryMinusDependencies = unaryMinusDependencies;
var dependenciesUnaryPlus_generated = {};
Object.defineProperty(dependenciesUnaryPlus_generated, "__esModule", {
  value: !0
});
dependenciesUnaryPlus_generated.unaryPlusDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1o = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$3b = dependenciesTyped_generated, _factoriesAny$4I = factoriesAny, unaryPlusDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1o.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$3b.typedDependencies,
  createUnaryPlus: _factoriesAny$4I.createUnaryPlus
};
dependenciesUnaryPlus_generated.unaryPlusDependencies = unaryPlusDependencies;
var dependenciesAbs_generated = {};
Object.defineProperty(dependenciesAbs_generated, "__esModule", {
  value: !0
});
dependenciesAbs_generated.absDependencies = void 0;
var _dependenciesTypedGenerated$3a = dependenciesTyped_generated, _factoriesAny$4H = factoriesAny, absDependencies = {
  typedDependencies: _dependenciesTypedGenerated$3a.typedDependencies,
  createAbs: _factoriesAny$4H.createAbs
};
dependenciesAbs_generated.absDependencies = absDependencies;
var dependenciesApply_generated = {};
Object.defineProperty(dependenciesApply_generated, "__esModule", {
  value: !0
});
dependenciesApply_generated.applyDependencies = void 0;
var _dependenciesIsIntegerGenerated$9 = dependenciesIsInteger_generated, _dependenciesTypedGenerated$39 = dependenciesTyped_generated, _factoriesAny$4G = factoriesAny, applyDependencies = {
  isIntegerDependencies: _dependenciesIsIntegerGenerated$9.isIntegerDependencies,
  typedDependencies: _dependenciesTypedGenerated$39.typedDependencies,
  createApply: _factoriesAny$4G.createApply
};
dependenciesApply_generated.applyDependencies = applyDependencies;
var dependenciesAddScalar_generated = {};
Object.defineProperty(dependenciesAddScalar_generated, "__esModule", {
  value: !0
});
dependenciesAddScalar_generated.addScalarDependencies = void 0;
var _dependenciesTypedGenerated$38 = dependenciesTyped_generated, _factoriesAny$4F = factoriesAny, addScalarDependencies = {
  typedDependencies: _dependenciesTypedGenerated$38.typedDependencies,
  createAddScalar: _factoriesAny$4F.createAddScalar
};
dependenciesAddScalar_generated.addScalarDependencies = addScalarDependencies;
var dependenciesCbrt_generated = {};
Object.defineProperty(dependenciesCbrt_generated, "__esModule", {
  value: !0
});
dependenciesCbrt_generated.cbrtDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1n = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$k = dependenciesComplexClass_generated, _dependenciesFractionClassGenerated$3 = dependenciesFractionClass_generated, _dependenciesIsNegativeGenerated$4 = dependenciesIsNegative_generated, _dependenciesMatrixGenerated$1d = dependenciesMatrix_generated, _dependenciesTypedGenerated$37 = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated$7 = dependenciesUnaryMinus_generated, _factoriesAny$4E = factoriesAny, cbrtDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1n.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$k.ComplexDependencies,
  FractionDependencies: _dependenciesFractionClassGenerated$3.FractionDependencies,
  isNegativeDependencies: _dependenciesIsNegativeGenerated$4.isNegativeDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$1d.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$37.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated$7.unaryMinusDependencies,
  createCbrt: _factoriesAny$4E.createCbrt
};
dependenciesCbrt_generated.cbrtDependencies = cbrtDependencies;
var dependenciesCeil_generated = {}, dependenciesRound_generated = {}, dependenciesZeros_generated = {};
Object.defineProperty(dependenciesZeros_generated, "__esModule", {
  value: !0
});
dependenciesZeros_generated.zerosDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1m = dependenciesBigNumberClass_generated, _dependenciesMatrixGenerated$1c = dependenciesMatrix_generated, _dependenciesTypedGenerated$36 = dependenciesTyped_generated, _factoriesAny$4D = factoriesAny, zerosDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1m.BigNumberDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$1c.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$36.typedDependencies,
  createZeros: _factoriesAny$4D.createZeros
};
dependenciesZeros_generated.zerosDependencies = zerosDependencies;
Object.defineProperty(dependenciesRound_generated, "__esModule", {
  value: !0
});
dependenciesRound_generated.roundDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1l = dependenciesBigNumberClass_generated, _dependenciesDenseMatrixClassGenerated$z = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$w = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$1b = dependenciesMatrix_generated, _dependenciesTypedGenerated$35 = dependenciesTyped_generated, _dependenciesZerosGenerated$5 = dependenciesZeros_generated, _factoriesAny$4C = factoriesAny, roundDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1l.BigNumberDependencies,
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$z.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$w.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$1b.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$35.typedDependencies,
  zerosDependencies: _dependenciesZerosGenerated$5.zerosDependencies,
  createRound: _factoriesAny$4C.createRound
};
dependenciesRound_generated.roundDependencies = roundDependencies;
Object.defineProperty(dependenciesCeil_generated, "__esModule", {
  value: !0
});
dependenciesCeil_generated.ceilDependencies = void 0;
var _dependenciesEqualScalarGenerated$v = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$1a = dependenciesMatrix_generated, _dependenciesRoundGenerated$2 = dependenciesRound_generated, _dependenciesTypedGenerated$34 = dependenciesTyped_generated, _factoriesAny$4B = factoriesAny, ceilDependencies = {
  equalScalarDependencies: _dependenciesEqualScalarGenerated$v.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$1a.matrixDependencies,
  roundDependencies: _dependenciesRoundGenerated$2.roundDependencies,
  typedDependencies: _dependenciesTypedGenerated$34.typedDependencies,
  createCeil: _factoriesAny$4B.createCeil
};
dependenciesCeil_generated.ceilDependencies = ceilDependencies;
var dependenciesCube_generated = {};
Object.defineProperty(dependenciesCube_generated, "__esModule", {
  value: !0
});
dependenciesCube_generated.cubeDependencies = void 0;
var _dependenciesTypedGenerated$33 = dependenciesTyped_generated, _factoriesAny$4A = factoriesAny, cubeDependencies = {
  typedDependencies: _dependenciesTypedGenerated$33.typedDependencies,
  createCube: _factoriesAny$4A.createCube
};
dependenciesCube_generated.cubeDependencies = cubeDependencies;
var dependenciesExp_generated = {};
Object.defineProperty(dependenciesExp_generated, "__esModule", {
  value: !0
});
dependenciesExp_generated.expDependencies = void 0;
var _dependenciesTypedGenerated$32 = dependenciesTyped_generated, _factoriesAny$4z = factoriesAny, expDependencies = {
  typedDependencies: _dependenciesTypedGenerated$32.typedDependencies,
  createExp: _factoriesAny$4z.createExp
};
dependenciesExp_generated.expDependencies = expDependencies;
var dependenciesExpm1_generated = {};
Object.defineProperty(dependenciesExpm1_generated, "__esModule", {
  value: !0
});
dependenciesExpm1_generated.expm1Dependencies = void 0;
var _dependenciesComplexClassGenerated$j = dependenciesComplexClass_generated, _dependenciesTypedGenerated$31 = dependenciesTyped_generated, _factoriesAny$4y = factoriesAny, expm1Dependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$j.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$31.typedDependencies,
  createExpm1: _factoriesAny$4y.createExpm1
};
dependenciesExpm1_generated.expm1Dependencies = expm1Dependencies;
var dependenciesFix_generated = {}, dependenciesFloor_generated = {};
Object.defineProperty(dependenciesFloor_generated, "__esModule", {
  value: !0
});
dependenciesFloor_generated.floorDependencies = void 0;
var _dependenciesEqualScalarGenerated$u = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$19 = dependenciesMatrix_generated, _dependenciesRoundGenerated$1 = dependenciesRound_generated, _dependenciesTypedGenerated$30 = dependenciesTyped_generated, _factoriesAny$4x = factoriesAny, floorDependencies = {
  equalScalarDependencies: _dependenciesEqualScalarGenerated$u.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$19.matrixDependencies,
  roundDependencies: _dependenciesRoundGenerated$1.roundDependencies,
  typedDependencies: _dependenciesTypedGenerated$30.typedDependencies,
  createFloor: _factoriesAny$4x.createFloor
};
dependenciesFloor_generated.floorDependencies = floorDependencies;
Object.defineProperty(dependenciesFix_generated, "__esModule", {
  value: !0
});
dependenciesFix_generated.fixDependencies = void 0;
var _dependenciesComplexClassGenerated$i = dependenciesComplexClass_generated, _dependenciesCeilGenerated = dependenciesCeil_generated, _dependenciesFloorGenerated = dependenciesFloor_generated, _dependenciesMatrixGenerated$18 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2$ = dependenciesTyped_generated, _factoriesAny$4w = factoriesAny, fixDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$i.ComplexDependencies,
  ceilDependencies: _dependenciesCeilGenerated.ceilDependencies,
  floorDependencies: _dependenciesFloorGenerated.floorDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$18.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2$.typedDependencies,
  createFix: _factoriesAny$4w.createFix
};
dependenciesFix_generated.fixDependencies = fixDependencies;
var dependenciesGcd_generated = {};
Object.defineProperty(dependenciesGcd_generated, "__esModule", {
  value: !0
});
dependenciesGcd_generated.gcdDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1k = dependenciesBigNumberClass_generated, _dependenciesDenseMatrixClassGenerated$y = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$t = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$17 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2_ = dependenciesTyped_generated, _factoriesAny$4v = factoriesAny, gcdDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1k.BigNumberDependencies,
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$y.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$t.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$17.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2_.typedDependencies,
  createGcd: _factoriesAny$4v.createGcd
};
dependenciesGcd_generated.gcdDependencies = gcdDependencies;
var dependenciesLcm_generated = {};
Object.defineProperty(dependenciesLcm_generated, "__esModule", {
  value: !0
});
dependenciesLcm_generated.lcmDependencies = void 0;
var _dependenciesEqualScalarGenerated$s = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$16 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2Z = dependenciesTyped_generated, _factoriesAny$4u = factoriesAny, lcmDependencies = {
  equalScalarDependencies: _dependenciesEqualScalarGenerated$s.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$16.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2Z.typedDependencies,
  createLcm: _factoriesAny$4u.createLcm
};
dependenciesLcm_generated.lcmDependencies = lcmDependencies;
var dependenciesLog10_generated = {};
Object.defineProperty(dependenciesLog10_generated, "__esModule", {
  value: !0
});
dependenciesLog10_generated.log10Dependencies = void 0;
var _dependenciesComplexClassGenerated$h = dependenciesComplexClass_generated, _dependenciesTypedGenerated$2Y = dependenciesTyped_generated, _factoriesAny$4t = factoriesAny, log10Dependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$h.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$2Y.typedDependencies,
  createLog10: _factoriesAny$4t.createLog10
};
dependenciesLog10_generated.log10Dependencies = log10Dependencies;
var dependenciesLog2_generated = {};
Object.defineProperty(dependenciesLog2_generated, "__esModule", {
  value: !0
});
dependenciesLog2_generated.log2Dependencies = void 0;
var _dependenciesComplexClassGenerated$g = dependenciesComplexClass_generated, _dependenciesTypedGenerated$2X = dependenciesTyped_generated, _factoriesAny$4s = factoriesAny, log2Dependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$g.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$2X.typedDependencies,
  createLog2: _factoriesAny$4s.createLog2
};
dependenciesLog2_generated.log2Dependencies = log2Dependencies;
var dependenciesMod_generated = {};
Object.defineProperty(dependenciesMod_generated, "__esModule", {
  value: !0
});
dependenciesMod_generated.modDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$x = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$r = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$15 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2W = dependenciesTyped_generated, _factoriesAny$4r = factoriesAny, modDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$x.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$r.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$15.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2W.typedDependencies,
  createMod: _factoriesAny$4r.createMod
};
dependenciesMod_generated.modDependencies = modDependencies;
var dependenciesMultiplyScalar_generated = {};
Object.defineProperty(dependenciesMultiplyScalar_generated, "__esModule", {
  value: !0
});
dependenciesMultiplyScalar_generated.multiplyScalarDependencies = void 0;
var _dependenciesTypedGenerated$2V = dependenciesTyped_generated, _factoriesAny$4q = factoriesAny, multiplyScalarDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2V.typedDependencies,
  createMultiplyScalar: _factoriesAny$4q.createMultiplyScalar
};
dependenciesMultiplyScalar_generated.multiplyScalarDependencies = multiplyScalarDependencies;
var dependenciesMultiply_generated = {}, dependenciesDot_generated = {}, dependenciesConj_generated = {};
Object.defineProperty(dependenciesConj_generated, "__esModule", {
  value: !0
});
dependenciesConj_generated.conjDependencies = void 0;
var _dependenciesTypedGenerated$2U = dependenciesTyped_generated, _factoriesAny$4p = factoriesAny, conjDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2U.typedDependencies,
  createConj: _factoriesAny$4p.createConj
};
dependenciesConj_generated.conjDependencies = conjDependencies;
var dependenciesSize_generated = {};
Object.defineProperty(dependenciesSize_generated, "__esModule", {
  value: !0
});
dependenciesSize_generated.sizeDependencies = void 0;
var _dependenciesMatrixGenerated$14 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2T = dependenciesTyped_generated, _factoriesAny$4o = factoriesAny, sizeDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$14.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2T.typedDependencies,
  createSize: _factoriesAny$4o.createSize
};
dependenciesSize_generated.sizeDependencies = sizeDependencies;
Object.defineProperty(dependenciesDot_generated, "__esModule", {
  value: !0
});
dependenciesDot_generated.dotDependencies = void 0;
var _dependenciesAddScalarGenerated$h = dependenciesAddScalar_generated, _dependenciesConjGenerated$3 = dependenciesConj_generated, _dependenciesMultiplyScalarGenerated$j = dependenciesMultiplyScalar_generated, _dependenciesSizeGenerated$b = dependenciesSize_generated, _dependenciesTypedGenerated$2S = dependenciesTyped_generated, _factoriesAny$4n = factoriesAny, dotDependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated$h.addScalarDependencies,
  conjDependencies: _dependenciesConjGenerated$3.conjDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$j.multiplyScalarDependencies,
  sizeDependencies: _dependenciesSizeGenerated$b.sizeDependencies,
  typedDependencies: _dependenciesTypedGenerated$2S.typedDependencies,
  createDot: _factoriesAny$4n.createDot
};
dependenciesDot_generated.dotDependencies = dotDependencies;
Object.defineProperty(dependenciesMultiply_generated, "__esModule", {
  value: !0
});
dependenciesMultiply_generated.multiplyDependencies = void 0;
var _dependenciesAddScalarGenerated$g = dependenciesAddScalar_generated, _dependenciesDotGenerated = dependenciesDot_generated, _dependenciesEqualScalarGenerated$q = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$13 = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$i = dependenciesMultiplyScalar_generated, _dependenciesTypedGenerated$2R = dependenciesTyped_generated, _factoriesAny$4m = factoriesAny, multiplyDependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated$g.addScalarDependencies,
  dotDependencies: _dependenciesDotGenerated.dotDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$q.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$13.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$i.multiplyScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated$2R.typedDependencies,
  createMultiply: _factoriesAny$4m.createMultiply
};
dependenciesMultiply_generated.multiplyDependencies = multiplyDependencies;
var dependenciesNthRoot_generated = {};
Object.defineProperty(dependenciesNthRoot_generated, "__esModule", {
  value: !0
});
dependenciesNthRoot_generated.nthRootDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1j = dependenciesBigNumberClass_generated, _dependenciesEqualScalarGenerated$p = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$12 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2Q = dependenciesTyped_generated, _factoriesAny$4l = factoriesAny, nthRootDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1j.BigNumberDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$p.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$12.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2Q.typedDependencies,
  createNthRoot: _factoriesAny$4l.createNthRoot
};
dependenciesNthRoot_generated.nthRootDependencies = nthRootDependencies;
var dependenciesSign_generated = {};
Object.defineProperty(dependenciesSign_generated, "__esModule", {
  value: !0
});
dependenciesSign_generated.signDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1i = dependenciesBigNumberClass_generated, _dependenciesFractionClassGenerated$2 = dependenciesFractionClass_generated, _dependenciesComplexGenerated$1 = dependenciesComplex_generated, _dependenciesTypedGenerated$2P = dependenciesTyped_generated, _factoriesAny$4k = factoriesAny, signDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1i.BigNumberDependencies,
  FractionDependencies: _dependenciesFractionClassGenerated$2.FractionDependencies,
  complexDependencies: _dependenciesComplexGenerated$1.complexDependencies,
  typedDependencies: _dependenciesTypedGenerated$2P.typedDependencies,
  createSign: _factoriesAny$4k.createSign
};
dependenciesSign_generated.signDependencies = signDependencies;
var dependenciesSqrt_generated = {};
Object.defineProperty(dependenciesSqrt_generated, "__esModule", {
  value: !0
});
dependenciesSqrt_generated.sqrtDependencies = void 0;
var _dependenciesComplexClassGenerated$f = dependenciesComplexClass_generated, _dependenciesTypedGenerated$2O = dependenciesTyped_generated, _factoriesAny$4j = factoriesAny, sqrtDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$f.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$2O.typedDependencies,
  createSqrt: _factoriesAny$4j.createSqrt
};
dependenciesSqrt_generated.sqrtDependencies = sqrtDependencies;
var dependenciesSquare_generated = {};
Object.defineProperty(dependenciesSquare_generated, "__esModule", {
  value: !0
});
dependenciesSquare_generated.squareDependencies = void 0;
var _dependenciesTypedGenerated$2N = dependenciesTyped_generated, _factoriesAny$4i = factoriesAny, squareDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2N.typedDependencies,
  createSquare: _factoriesAny$4i.createSquare
};
dependenciesSquare_generated.squareDependencies = squareDependencies;
var dependenciesSubtract_generated = {};
Object.defineProperty(dependenciesSubtract_generated, "__esModule", {
  value: !0
});
dependenciesSubtract_generated.subtractDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$w = dependenciesDenseMatrixClass_generated, _dependenciesAddScalarGenerated$f = dependenciesAddScalar_generated, _dependenciesEqualScalarGenerated$o = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$11 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2M = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated$6 = dependenciesUnaryMinus_generated, _factoriesAny$4h = factoriesAny, subtractDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$w.DenseMatrixDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$f.addScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$o.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$11.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2M.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated$6.unaryMinusDependencies,
  createSubtract: _factoriesAny$4h.createSubtract
};
dependenciesSubtract_generated.subtractDependencies = subtractDependencies;
var dependenciesXgcd_generated = {};
Object.defineProperty(dependenciesXgcd_generated, "__esModule", {
  value: !0
});
dependenciesXgcd_generated.xgcdDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1h = dependenciesBigNumberClass_generated, _dependenciesMatrixGenerated$10 = dependenciesMatrix_generated, _dependenciesTypedGenerated$2L = dependenciesTyped_generated, _factoriesAny$4g = factoriesAny, xgcdDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1h.BigNumberDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$10.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2L.typedDependencies,
  createXgcd: _factoriesAny$4g.createXgcd
};
dependenciesXgcd_generated.xgcdDependencies = xgcdDependencies;
var dependenciesDotMultiply_generated = {};
Object.defineProperty(dependenciesDotMultiply_generated, "__esModule", {
  value: !0
});
dependenciesDotMultiply_generated.dotMultiplyDependencies = void 0;
var _dependenciesEqualScalarGenerated$n = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$$ = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$h = dependenciesMultiplyScalar_generated, _dependenciesTypedGenerated$2K = dependenciesTyped_generated, _factoriesAny$4f = factoriesAny, dotMultiplyDependencies = {
  equalScalarDependencies: _dependenciesEqualScalarGenerated$n.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$$.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$h.multiplyScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated$2K.typedDependencies,
  createDotMultiply: _factoriesAny$4f.createDotMultiply
};
dependenciesDotMultiply_generated.dotMultiplyDependencies = dotMultiplyDependencies;
var dependenciesBitAnd_generated = {};
Object.defineProperty(dependenciesBitAnd_generated, "__esModule", {
  value: !0
});
dependenciesBitAnd_generated.bitAndDependencies = void 0;
var _dependenciesEqualScalarGenerated$m = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$_ = dependenciesMatrix_generated, _dependenciesTypedGenerated$2J = dependenciesTyped_generated, _factoriesAny$4e = factoriesAny, bitAndDependencies = {
  equalScalarDependencies: _dependenciesEqualScalarGenerated$m.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$_.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2J.typedDependencies,
  createBitAnd: _factoriesAny$4e.createBitAnd
};
dependenciesBitAnd_generated.bitAndDependencies = bitAndDependencies;
var dependenciesBitNot_generated = {};
Object.defineProperty(dependenciesBitNot_generated, "__esModule", {
  value: !0
});
dependenciesBitNot_generated.bitNotDependencies = void 0;
var _dependenciesTypedGenerated$2I = dependenciesTyped_generated, _factoriesAny$4d = factoriesAny, bitNotDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2I.typedDependencies,
  createBitNot: _factoriesAny$4d.createBitNot
};
dependenciesBitNot_generated.bitNotDependencies = bitNotDependencies;
var dependenciesBitOr_generated = {};
Object.defineProperty(dependenciesBitOr_generated, "__esModule", {
  value: !0
});
dependenciesBitOr_generated.bitOrDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$v = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$l = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$Z = dependenciesMatrix_generated, _dependenciesTypedGenerated$2H = dependenciesTyped_generated, _factoriesAny$4c = factoriesAny, bitOrDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$v.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$l.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$Z.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2H.typedDependencies,
  createBitOr: _factoriesAny$4c.createBitOr
};
dependenciesBitOr_generated.bitOrDependencies = bitOrDependencies;
var dependenciesBitXor_generated = {};
Object.defineProperty(dependenciesBitXor_generated, "__esModule", {
  value: !0
});
dependenciesBitXor_generated.bitXorDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$u = dependenciesDenseMatrixClass_generated, _dependenciesMatrixGenerated$Y = dependenciesMatrix_generated, _dependenciesTypedGenerated$2G = dependenciesTyped_generated, _factoriesAny$4b = factoriesAny, bitXorDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$u.DenseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$Y.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2G.typedDependencies,
  createBitXor: _factoriesAny$4b.createBitXor
};
dependenciesBitXor_generated.bitXorDependencies = bitXorDependencies;
var dependenciesArg_generated = {};
Object.defineProperty(dependenciesArg_generated, "__esModule", {
  value: !0
});
dependenciesArg_generated.argDependencies = void 0;
var _dependenciesTypedGenerated$2F = dependenciesTyped_generated, _factoriesAny$4a = factoriesAny, argDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2F.typedDependencies,
  createArg: _factoriesAny$4a.createArg
};
dependenciesArg_generated.argDependencies = argDependencies;
var dependenciesIm_generated = {};
Object.defineProperty(dependenciesIm_generated, "__esModule", {
  value: !0
});
dependenciesIm_generated.imDependencies = void 0;
var _dependenciesTypedGenerated$2E = dependenciesTyped_generated, _factoriesAny$49 = factoriesAny, imDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2E.typedDependencies,
  createIm: _factoriesAny$49.createIm
};
dependenciesIm_generated.imDependencies = imDependencies;
var dependenciesRe_generated = {};
Object.defineProperty(dependenciesRe_generated, "__esModule", {
  value: !0
});
dependenciesRe_generated.reDependencies = void 0;
var _dependenciesTypedGenerated$2D = dependenciesTyped_generated, _factoriesAny$48 = factoriesAny, reDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2D.typedDependencies,
  createRe: _factoriesAny$48.createRe
};
dependenciesRe_generated.reDependencies = reDependencies;
var dependenciesNot_generated = {};
Object.defineProperty(dependenciesNot_generated, "__esModule", {
  value: !0
});
dependenciesNot_generated.notDependencies = void 0;
var _dependenciesTypedGenerated$2C = dependenciesTyped_generated, _factoriesAny$47 = factoriesAny, notDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2C.typedDependencies,
  createNot: _factoriesAny$47.createNot
};
dependenciesNot_generated.notDependencies = notDependencies;
var dependenciesOr_generated = {};
Object.defineProperty(dependenciesOr_generated, "__esModule", {
  value: !0
});
dependenciesOr_generated.orDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$t = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$k = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$X = dependenciesMatrix_generated, _dependenciesTypedGenerated$2B = dependenciesTyped_generated, _factoriesAny$46 = factoriesAny, orDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$t.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$k.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$X.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2B.typedDependencies,
  createOr: _factoriesAny$46.createOr
};
dependenciesOr_generated.orDependencies = orDependencies;
var dependenciesXor_generated = {};
Object.defineProperty(dependenciesXor_generated, "__esModule", {
  value: !0
});
dependenciesXor_generated.xorDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$s = dependenciesDenseMatrixClass_generated, _dependenciesMatrixGenerated$W = dependenciesMatrix_generated, _dependenciesTypedGenerated$2A = dependenciesTyped_generated, _factoriesAny$45 = factoriesAny, xorDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$s.DenseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$W.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2A.typedDependencies,
  createXor: _factoriesAny$45.createXor
};
dependenciesXor_generated.xorDependencies = xorDependencies;
var dependenciesConcat_generated = {};
Object.defineProperty(dependenciesConcat_generated, "__esModule", {
  value: !0
});
dependenciesConcat_generated.concatDependencies = void 0;
var _dependenciesIsIntegerGenerated$8 = dependenciesIsInteger_generated, _dependenciesMatrixGenerated$V = dependenciesMatrix_generated, _dependenciesTypedGenerated$2z = dependenciesTyped_generated, _factoriesAny$44 = factoriesAny, concatDependencies = {
  isIntegerDependencies: _dependenciesIsIntegerGenerated$8.isIntegerDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$V.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2z.typedDependencies,
  createConcat: _factoriesAny$44.createConcat
};
dependenciesConcat_generated.concatDependencies = concatDependencies;
var dependenciesColumn_generated = {}, dependenciesIndexClass_generated = {}, dependenciesImmutableDenseMatrixClass_generated = {}, dependenciesSmaller_generated = {};
Object.defineProperty(dependenciesSmaller_generated, "__esModule", {
  value: !0
});
dependenciesSmaller_generated.smallerDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$r = dependenciesDenseMatrixClass_generated, _dependenciesMatrixGenerated$U = dependenciesMatrix_generated, _dependenciesTypedGenerated$2y = dependenciesTyped_generated, _factoriesAny$43 = factoriesAny, smallerDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$r.DenseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$U.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2y.typedDependencies,
  createSmaller: _factoriesAny$43.createSmaller
};
dependenciesSmaller_generated.smallerDependencies = smallerDependencies;
Object.defineProperty(dependenciesImmutableDenseMatrixClass_generated, "__esModule", {
  value: !0
});
dependenciesImmutableDenseMatrixClass_generated.ImmutableDenseMatrixDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$q = dependenciesDenseMatrixClass_generated, _dependenciesSmallerGenerated$8 = dependenciesSmaller_generated, _factoriesAny$42 = factoriesAny, ImmutableDenseMatrixDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$q.DenseMatrixDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$8.smallerDependencies,
  createImmutableDenseMatrixClass: _factoriesAny$42.createImmutableDenseMatrixClass
};
dependenciesImmutableDenseMatrixClass_generated.ImmutableDenseMatrixDependencies = ImmutableDenseMatrixDependencies;
Object.defineProperty(dependenciesIndexClass_generated, "__esModule", {
  value: !0
});
dependenciesIndexClass_generated.IndexDependencies = void 0;
var _dependenciesImmutableDenseMatrixClassGenerated = dependenciesImmutableDenseMatrixClass_generated, _factoriesAny$41 = factoriesAny, IndexDependencies = {
  ImmutableDenseMatrixDependencies: _dependenciesImmutableDenseMatrixClassGenerated.ImmutableDenseMatrixDependencies,
  createIndexClass: _factoriesAny$41.createIndexClass
};
dependenciesIndexClass_generated.IndexDependencies = IndexDependencies;
var dependenciesRange_generated = {}, dependenciesLarger_generated = {};
Object.defineProperty(dependenciesLarger_generated, "__esModule", {
  value: !0
});
dependenciesLarger_generated.largerDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$p = dependenciesDenseMatrixClass_generated, _dependenciesMatrixGenerated$T = dependenciesMatrix_generated, _dependenciesTypedGenerated$2x = dependenciesTyped_generated, _factoriesAny$40 = factoriesAny, largerDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$p.DenseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$T.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2x.typedDependencies,
  createLarger: _factoriesAny$40.createLarger
};
dependenciesLarger_generated.largerDependencies = largerDependencies;
var dependenciesLargerEq_generated = {};
Object.defineProperty(dependenciesLargerEq_generated, "__esModule", {
  value: !0
});
dependenciesLargerEq_generated.largerEqDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$o = dependenciesDenseMatrixClass_generated, _dependenciesMatrixGenerated$S = dependenciesMatrix_generated, _dependenciesTypedGenerated$2w = dependenciesTyped_generated, _factoriesAny$3$ = factoriesAny, largerEqDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$o.DenseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$S.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2w.typedDependencies,
  createLargerEq: _factoriesAny$3$.createLargerEq
};
dependenciesLargerEq_generated.largerEqDependencies = largerEqDependencies;
var dependenciesSmallerEq_generated = {};
Object.defineProperty(dependenciesSmallerEq_generated, "__esModule", {
  value: !0
});
dependenciesSmallerEq_generated.smallerEqDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$n = dependenciesDenseMatrixClass_generated, _dependenciesMatrixGenerated$R = dependenciesMatrix_generated, _dependenciesTypedGenerated$2v = dependenciesTyped_generated, _factoriesAny$3_ = factoriesAny, smallerEqDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$n.DenseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$R.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2v.typedDependencies,
  createSmallerEq: _factoriesAny$3_.createSmallerEq
};
dependenciesSmallerEq_generated.smallerEqDependencies = smallerEqDependencies;
Object.defineProperty(dependenciesRange_generated, "__esModule", {
  value: !0
});
dependenciesRange_generated.rangeDependencies = void 0;
var _dependenciesBignumberGenerated$6 = dependenciesBignumber_generated, _dependenciesMatrixGenerated$Q = dependenciesMatrix_generated, _dependenciesLargerGenerated$9 = dependenciesLarger_generated, _dependenciesLargerEqGenerated$2 = dependenciesLargerEq_generated, _dependenciesSmallerGenerated$7 = dependenciesSmaller_generated, _dependenciesSmallerEqGenerated$1 = dependenciesSmallerEq_generated, _dependenciesTypedGenerated$2u = dependenciesTyped_generated, _factoriesAny$3Z = factoriesAny, rangeDependencies = {
  bignumberDependencies: _dependenciesBignumberGenerated$6.bignumberDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$Q.matrixDependencies,
  largerDependencies: _dependenciesLargerGenerated$9.largerDependencies,
  largerEqDependencies: _dependenciesLargerEqGenerated$2.largerEqDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$7.smallerDependencies,
  smallerEqDependencies: _dependenciesSmallerEqGenerated$1.smallerEqDependencies,
  typedDependencies: _dependenciesTypedGenerated$2u.typedDependencies,
  createRange: _factoriesAny$3Z.createRange
};
dependenciesRange_generated.rangeDependencies = rangeDependencies;
Object.defineProperty(dependenciesColumn_generated, "__esModule", {
  value: !0
});
dependenciesColumn_generated.columnDependencies = void 0;
var _dependenciesIndexClassGenerated$e = dependenciesIndexClass_generated, _dependenciesMatrixGenerated$P = dependenciesMatrix_generated, _dependenciesRangeGenerated$3 = dependenciesRange_generated, _dependenciesTypedGenerated$2t = dependenciesTyped_generated, _factoriesAny$3Y = factoriesAny, columnDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$e.IndexDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$P.matrixDependencies,
  rangeDependencies: _dependenciesRangeGenerated$3.rangeDependencies,
  typedDependencies: _dependenciesTypedGenerated$2t.typedDependencies,
  createColumn: _factoriesAny$3Y.createColumn
};
dependenciesColumn_generated.columnDependencies = columnDependencies;
var dependenciesCross_generated = {};
Object.defineProperty(dependenciesCross_generated, "__esModule", {
  value: !0
});
dependenciesCross_generated.crossDependencies = void 0;
var _dependenciesMatrixGenerated$O = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$i = dependenciesMultiply_generated, _dependenciesSubtractGenerated$l = dependenciesSubtract_generated, _dependenciesTypedGenerated$2s = dependenciesTyped_generated, _factoriesAny$3X = factoriesAny, crossDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$O.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$i.multiplyDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$l.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$2s.typedDependencies,
  createCross: _factoriesAny$3X.createCross
};
dependenciesCross_generated.crossDependencies = crossDependencies;
var dependenciesDiag_generated = {};
Object.defineProperty(dependenciesDiag_generated, "__esModule", {
  value: !0
});
dependenciesDiag_generated.diagDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$m = dependenciesDenseMatrixClass_generated, _dependenciesSparseMatrixClassGenerated$6 = dependenciesSparseMatrixClass_generated, _dependenciesMatrixGenerated$N = dependenciesMatrix_generated, _dependenciesTypedGenerated$2r = dependenciesTyped_generated, _factoriesAny$3W = factoriesAny, diagDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$m.DenseMatrixDependencies,
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated$6.SparseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$N.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2r.typedDependencies,
  createDiag: _factoriesAny$3W.createDiag
};
dependenciesDiag_generated.diagDependencies = diagDependencies;
var dependenciesFilter_generated = {};
Object.defineProperty(dependenciesFilter_generated, "__esModule", {
  value: !0
});
dependenciesFilter_generated.filterDependencies = void 0;
var _dependenciesTypedGenerated$2q = dependenciesTyped_generated, _factoriesAny$3V = factoriesAny, filterDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2q.typedDependencies,
  createFilter: _factoriesAny$3V.createFilter
};
dependenciesFilter_generated.filterDependencies = filterDependencies;
var dependenciesFlatten_generated = {};
Object.defineProperty(dependenciesFlatten_generated, "__esModule", {
  value: !0
});
dependenciesFlatten_generated.flattenDependencies = void 0;
var _dependenciesMatrixGenerated$M = dependenciesMatrix_generated, _dependenciesTypedGenerated$2p = dependenciesTyped_generated, _factoriesAny$3U = factoriesAny, flattenDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$M.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2p.typedDependencies,
  createFlatten: _factoriesAny$3U.createFlatten
};
dependenciesFlatten_generated.flattenDependencies = flattenDependencies;
var dependenciesForEach_generated = {};
Object.defineProperty(dependenciesForEach_generated, "__esModule", {
  value: !0
});
dependenciesForEach_generated.forEachDependencies = void 0;
var _dependenciesTypedGenerated$2o = dependenciesTyped_generated, _factoriesAny$3T = factoriesAny, forEachDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2o.typedDependencies,
  createForEach: _factoriesAny$3T.createForEach
};
dependenciesForEach_generated.forEachDependencies = forEachDependencies;
var dependenciesGetMatrixDataType_generated = {};
Object.defineProperty(dependenciesGetMatrixDataType_generated, "__esModule", {
  value: !0
});
dependenciesGetMatrixDataType_generated.getMatrixDataTypeDependencies = void 0;
var _dependenciesTypedGenerated$2n = dependenciesTyped_generated, _factoriesAny$3S = factoriesAny, getMatrixDataTypeDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2n.typedDependencies,
  createGetMatrixDataType: _factoriesAny$3S.createGetMatrixDataType
};
dependenciesGetMatrixDataType_generated.getMatrixDataTypeDependencies = getMatrixDataTypeDependencies;
var dependenciesIdentity_generated = {};
Object.defineProperty(dependenciesIdentity_generated, "__esModule", {
  value: !0
});
dependenciesIdentity_generated.identityDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1g = dependenciesBigNumberClass_generated, _dependenciesDenseMatrixClassGenerated$l = dependenciesDenseMatrixClass_generated, _dependenciesSparseMatrixClassGenerated$5 = dependenciesSparseMatrixClass_generated, _dependenciesMatrixGenerated$L = dependenciesMatrix_generated, _dependenciesTypedGenerated$2m = dependenciesTyped_generated, _factoriesAny$3R = factoriesAny, identityDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1g.BigNumberDependencies,
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$l.DenseMatrixDependencies,
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated$5.SparseMatrixDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$L.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2m.typedDependencies,
  createIdentity: _factoriesAny$3R.createIdentity
};
dependenciesIdentity_generated.identityDependencies = identityDependencies;
var dependenciesKron_generated = {};
Object.defineProperty(dependenciesKron_generated, "__esModule", {
  value: !0
});
dependenciesKron_generated.kronDependencies = void 0;
var _dependenciesMatrixGenerated$K = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$g = dependenciesMultiplyScalar_generated, _dependenciesTypedGenerated$2l = dependenciesTyped_generated, _factoriesAny$3Q = factoriesAny, kronDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$K.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$g.multiplyScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated$2l.typedDependencies,
  createKron: _factoriesAny$3Q.createKron
};
dependenciesKron_generated.kronDependencies = kronDependencies;
var dependenciesMap_generated = {};
Object.defineProperty(dependenciesMap_generated, "__esModule", {
  value: !0
});
dependenciesMap_generated.mapDependencies = void 0;
var _dependenciesTypedGenerated$2k = dependenciesTyped_generated, _factoriesAny$3P = factoriesAny, mapDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2k.typedDependencies,
  createMap: _factoriesAny$3P.createMap
};
dependenciesMap_generated.mapDependencies = mapDependencies;
var dependenciesDiff_generated = {};
Object.defineProperty(dependenciesDiff_generated, "__esModule", {
  value: !0
});
dependenciesDiff_generated.diffDependencies = void 0;
var _dependenciesMatrixGenerated$J = dependenciesMatrix_generated, _dependenciesNumberGenerated$4 = dependenciesNumber_generated, _dependenciesSubtractGenerated$k = dependenciesSubtract_generated, _dependenciesTypedGenerated$2j = dependenciesTyped_generated, _factoriesAny$3O = factoriesAny, diffDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$J.matrixDependencies,
  numberDependencies: _dependenciesNumberGenerated$4.numberDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$k.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$2j.typedDependencies,
  createDiff: _factoriesAny$3O.createDiff
};
dependenciesDiff_generated.diffDependencies = diffDependencies;
var dependenciesOnes_generated = {};
Object.defineProperty(dependenciesOnes_generated, "__esModule", {
  value: !0
});
dependenciesOnes_generated.onesDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1f = dependenciesBigNumberClass_generated, _dependenciesMatrixGenerated$I = dependenciesMatrix_generated, _dependenciesTypedGenerated$2i = dependenciesTyped_generated, _factoriesAny$3N = factoriesAny, onesDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1f.BigNumberDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$I.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2i.typedDependencies,
  createOnes: _factoriesAny$3N.createOnes
};
dependenciesOnes_generated.onesDependencies = onesDependencies;
var dependenciesReshape_generated = {};
Object.defineProperty(dependenciesReshape_generated, "__esModule", {
  value: !0
});
dependenciesReshape_generated.reshapeDependencies = void 0;
var _dependenciesIsIntegerGenerated$7 = dependenciesIsInteger_generated, _dependenciesMatrixGenerated$H = dependenciesMatrix_generated, _dependenciesTypedGenerated$2h = dependenciesTyped_generated, _factoriesAny$3M = factoriesAny, reshapeDependencies = {
  isIntegerDependencies: _dependenciesIsIntegerGenerated$7.isIntegerDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$H.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2h.typedDependencies,
  createReshape: _factoriesAny$3M.createReshape
};
dependenciesReshape_generated.reshapeDependencies = reshapeDependencies;
var dependenciesResize_generated = {};
Object.defineProperty(dependenciesResize_generated, "__esModule", {
  value: !0
});
dependenciesResize_generated.resizeDependencies = void 0;
var _dependenciesMatrixGenerated$G = dependenciesMatrix_generated, _factoriesAny$3L = factoriesAny, resizeDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$G.matrixDependencies,
  createResize: _factoriesAny$3L.createResize
};
dependenciesResize_generated.resizeDependencies = resizeDependencies;
var dependenciesRotate_generated = {}, dependenciesRotationMatrix_generated = {}, dependenciesCos_generated = {};
Object.defineProperty(dependenciesCos_generated, "__esModule", {
  value: !0
});
dependenciesCos_generated.cosDependencies = void 0;
var _dependenciesTypedGenerated$2g = dependenciesTyped_generated, _factoriesAny$3K = factoriesAny, cosDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2g.typedDependencies,
  createCos: _factoriesAny$3K.createCos
};
dependenciesCos_generated.cosDependencies = cosDependencies;
var dependenciesNorm_generated = {}, dependenciesAdd_generated = {};
Object.defineProperty(dependenciesAdd_generated, "__esModule", {
  value: !0
});
dependenciesAdd_generated.addDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$k = dependenciesDenseMatrixClass_generated, _dependenciesSparseMatrixClassGenerated$4 = dependenciesSparseMatrixClass_generated, _dependenciesAddScalarGenerated$e = dependenciesAddScalar_generated, _dependenciesEqualScalarGenerated$j = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$F = dependenciesMatrix_generated, _dependenciesTypedGenerated$2f = dependenciesTyped_generated, _factoriesAny$3J = factoriesAny, addDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$k.DenseMatrixDependencies,
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated$4.SparseMatrixDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$e.addScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$j.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$F.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2f.typedDependencies,
  createAdd: _factoriesAny$3J.createAdd
};
dependenciesAdd_generated.addDependencies = addDependencies;
var dependenciesCtranspose_generated = {}, dependenciesTranspose_generated = {};
Object.defineProperty(dependenciesTranspose_generated, "__esModule", {
  value: !0
});
dependenciesTranspose_generated.transposeDependencies = void 0;
var _dependenciesMatrixGenerated$E = dependenciesMatrix_generated, _dependenciesTypedGenerated$2e = dependenciesTyped_generated, _factoriesAny$3I = factoriesAny, transposeDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$E.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2e.typedDependencies,
  createTranspose: _factoriesAny$3I.createTranspose
};
dependenciesTranspose_generated.transposeDependencies = transposeDependencies;
Object.defineProperty(dependenciesCtranspose_generated, "__esModule", {
  value: !0
});
dependenciesCtranspose_generated.ctransposeDependencies = void 0;
var _dependenciesConjGenerated$2 = dependenciesConj_generated, _dependenciesTransposeGenerated$1 = dependenciesTranspose_generated, _dependenciesTypedGenerated$2d = dependenciesTyped_generated, _factoriesAny$3H = factoriesAny, ctransposeDependencies = {
  conjDependencies: _dependenciesConjGenerated$2.conjDependencies,
  transposeDependencies: _dependenciesTransposeGenerated$1.transposeDependencies,
  typedDependencies: _dependenciesTypedGenerated$2d.typedDependencies,
  createCtranspose: _factoriesAny$3H.createCtranspose
};
dependenciesCtranspose_generated.ctransposeDependencies = ctransposeDependencies;
var dependenciesEigs_generated = {}, dependenciesAtan_generated = {};
Object.defineProperty(dependenciesAtan_generated, "__esModule", {
  value: !0
});
dependenciesAtan_generated.atanDependencies = void 0;
var _dependenciesTypedGenerated$2c = dependenciesTyped_generated, _factoriesAny$3G = factoriesAny, atanDependencies = {
  typedDependencies: _dependenciesTypedGenerated$2c.typedDependencies,
  createAtan: _factoriesAny$3G.createAtan
};
dependenciesAtan_generated.atanDependencies = atanDependencies;
var dependenciesEqual_generated = {};
Object.defineProperty(dependenciesEqual_generated, "__esModule", {
  value: !0
});
dependenciesEqual_generated.equalDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$j = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$i = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$D = dependenciesMatrix_generated, _dependenciesTypedGenerated$2b = dependenciesTyped_generated, _factoriesAny$3F = factoriesAny, equalDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$j.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$i.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$D.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$2b.typedDependencies,
  createEqual: _factoriesAny$3F.createEqual
};
dependenciesEqual_generated.equalDependencies = equalDependencies;
var dependenciesInv_generated = {}, dependenciesDet_generated = {}, dependenciesLup_generated = {}, dependenciesSpaClass_generated = {}, dependenciesFibonacciHeapClass_generated = {};
Object.defineProperty(dependenciesFibonacciHeapClass_generated, "__esModule", {
  value: !0
});
dependenciesFibonacciHeapClass_generated.FibonacciHeapDependencies = void 0;
var _dependenciesLargerGenerated$8 = dependenciesLarger_generated, _dependenciesSmallerGenerated$6 = dependenciesSmaller_generated, _factoriesAny$3E = factoriesAny, FibonacciHeapDependencies = {
  largerDependencies: _dependenciesLargerGenerated$8.largerDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$6.smallerDependencies,
  createFibonacciHeapClass: _factoriesAny$3E.createFibonacciHeapClass
};
dependenciesFibonacciHeapClass_generated.FibonacciHeapDependencies = FibonacciHeapDependencies;
Object.defineProperty(dependenciesSpaClass_generated, "__esModule", {
  value: !0
});
dependenciesSpaClass_generated.SpaDependencies = void 0;
var _dependenciesFibonacciHeapClassGenerated = dependenciesFibonacciHeapClass_generated, _dependenciesAddScalarGenerated$d = dependenciesAddScalar_generated, _dependenciesEqualScalarGenerated$h = dependenciesEqualScalar_generated, _factoriesAny$3D = factoriesAny, SpaDependencies = {
  FibonacciHeapDependencies: _dependenciesFibonacciHeapClassGenerated.FibonacciHeapDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$d.addScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$h.equalScalarDependencies,
  createSpaClass: _factoriesAny$3D.createSpaClass
};
dependenciesSpaClass_generated.SpaDependencies = SpaDependencies;
var dependenciesDivideScalar_generated = {}, dependenciesNumeric_generated = {};
Object.defineProperty(dependenciesNumeric_generated, "__esModule", {
  value: !0
});
dependenciesNumeric_generated.numericDependencies = void 0;
var _dependenciesBignumberGenerated$5 = dependenciesBignumber_generated, _dependenciesFractionGenerated$3 = dependenciesFraction_generated, _dependenciesNumberGenerated$3 = dependenciesNumber_generated, _factoriesAny$3C = factoriesAny, numericDependencies = {
  bignumberDependencies: _dependenciesBignumberGenerated$5.bignumberDependencies,
  fractionDependencies: _dependenciesFractionGenerated$3.fractionDependencies,
  numberDependencies: _dependenciesNumberGenerated$3.numberDependencies,
  createNumeric: _factoriesAny$3C.createNumeric
};
dependenciesNumeric_generated.numericDependencies = numericDependencies;
Object.defineProperty(dependenciesDivideScalar_generated, "__esModule", {
  value: !0
});
dependenciesDivideScalar_generated.divideScalarDependencies = void 0;
var _dependenciesNumericGenerated$9 = dependenciesNumeric_generated, _dependenciesTypedGenerated$2a = dependenciesTyped_generated, _factoriesAny$3B = factoriesAny, divideScalarDependencies = {
  numericDependencies: _dependenciesNumericGenerated$9.numericDependencies,
  typedDependencies: _dependenciesTypedGenerated$2a.typedDependencies,
  createDivideScalar: _factoriesAny$3B.createDivideScalar
};
dependenciesDivideScalar_generated.divideScalarDependencies = divideScalarDependencies;
Object.defineProperty(dependenciesLup_generated, "__esModule", {
  value: !0
});
dependenciesLup_generated.lupDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$i = dependenciesDenseMatrixClass_generated, _dependenciesSpaClassGenerated = dependenciesSpaClass_generated, _dependenciesSparseMatrixClassGenerated$3 = dependenciesSparseMatrixClass_generated, _dependenciesAbsGenerated$b = dependenciesAbs_generated, _dependenciesAddScalarGenerated$c = dependenciesAddScalar_generated, _dependenciesDivideScalarGenerated$i = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated$g = dependenciesEqualScalar_generated, _dependenciesLargerGenerated$7 = dependenciesLarger_generated, _dependenciesMatrixGenerated$C = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$f = dependenciesMultiplyScalar_generated, _dependenciesSubtractGenerated$j = dependenciesSubtract_generated, _dependenciesTypedGenerated$29 = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated$5 = dependenciesUnaryMinus_generated, _factoriesAny$3A = factoriesAny, lupDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$i.DenseMatrixDependencies,
  SpaDependencies: _dependenciesSpaClassGenerated.SpaDependencies,
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated$3.SparseMatrixDependencies,
  absDependencies: _dependenciesAbsGenerated$b.absDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$c.addScalarDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$i.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$g.equalScalarDependencies,
  largerDependencies: _dependenciesLargerGenerated$7.largerDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$C.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$f.multiplyScalarDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$j.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$29.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated$5.unaryMinusDependencies,
  createLup: _factoriesAny$3A.createLup
};
dependenciesLup_generated.lupDependencies = lupDependencies;
Object.defineProperty(dependenciesDet_generated, "__esModule", {
  value: !0
});
dependenciesDet_generated.detDependencies = void 0;
var _dependenciesLupGenerated$1 = dependenciesLup_generated, _dependenciesMatrixGenerated$B = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$h = dependenciesMultiply_generated, _dependenciesSubtractGenerated$i = dependenciesSubtract_generated, _dependenciesTypedGenerated$28 = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated$4 = dependenciesUnaryMinus_generated, _factoriesAny$3z = factoriesAny, detDependencies = {
  lupDependencies: _dependenciesLupGenerated$1.lupDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$B.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$h.multiplyDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$i.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$28.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated$4.unaryMinusDependencies,
  createDet: _factoriesAny$3z.createDet
};
dependenciesDet_generated.detDependencies = detDependencies;
Object.defineProperty(dependenciesInv_generated, "__esModule", {
  value: !0
});
dependenciesInv_generated.invDependencies = void 0;
var _dependenciesAbsGenerated$a = dependenciesAbs_generated, _dependenciesAddScalarGenerated$b = dependenciesAddScalar_generated, _dependenciesDetGenerated = dependenciesDet_generated, _dependenciesDivideScalarGenerated$h = dependenciesDivideScalar_generated, _dependenciesIdentityGenerated$4 = dependenciesIdentity_generated, _dependenciesMatrixGenerated$A = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$g = dependenciesMultiply_generated, _dependenciesTypedGenerated$27 = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated$3 = dependenciesUnaryMinus_generated, _factoriesAny$3y = factoriesAny, invDependencies = {
  absDependencies: _dependenciesAbsGenerated$a.absDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$b.addScalarDependencies,
  detDependencies: _dependenciesDetGenerated.detDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$h.divideScalarDependencies,
  identityDependencies: _dependenciesIdentityGenerated$4.identityDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$A.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$g.multiplyDependencies,
  typedDependencies: _dependenciesTypedGenerated$27.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated$3.unaryMinusDependencies,
  createInv: _factoriesAny$3y.createInv
};
dependenciesInv_generated.invDependencies = invDependencies;
var dependenciesSin_generated = {};
Object.defineProperty(dependenciesSin_generated, "__esModule", {
  value: !0
});
dependenciesSin_generated.sinDependencies = void 0;
var _dependenciesTypedGenerated$26 = dependenciesTyped_generated, _factoriesAny$3x = factoriesAny, sinDependencies = {
  typedDependencies: _dependenciesTypedGenerated$26.typedDependencies,
  createSin: _factoriesAny$3x.createSin
};
dependenciesSin_generated.sinDependencies = sinDependencies;
Object.defineProperty(dependenciesEigs_generated, "__esModule", {
  value: !0
});
dependenciesEigs_generated.eigsDependencies = void 0;
var _dependenciesAbsGenerated$9 = dependenciesAbs_generated, _dependenciesAddGenerated$h = dependenciesAdd_generated, _dependenciesAddScalarGenerated$a = dependenciesAddScalar_generated, _dependenciesAtanGenerated = dependenciesAtan_generated, _dependenciesBignumberGenerated$4 = dependenciesBignumber_generated, _dependenciesCosGenerated$1 = dependenciesCos_generated, _dependenciesEqualGenerated$6 = dependenciesEqual_generated, _dependenciesInvGenerated$3 = dependenciesInv_generated, _dependenciesMatrixGenerated$z = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$f = dependenciesMultiply_generated, _dependenciesMultiplyScalarGenerated$e = dependenciesMultiplyScalar_generated, _dependenciesSinGenerated$1 = dependenciesSin_generated, _dependenciesSubtractGenerated$h = dependenciesSubtract_generated, _dependenciesTypedGenerated$25 = dependenciesTyped_generated, _factoriesAny$3w = factoriesAny, eigsDependencies = {
  absDependencies: _dependenciesAbsGenerated$9.absDependencies,
  addDependencies: _dependenciesAddGenerated$h.addDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$a.addScalarDependencies,
  atanDependencies: _dependenciesAtanGenerated.atanDependencies,
  bignumberDependencies: _dependenciesBignumberGenerated$4.bignumberDependencies,
  cosDependencies: _dependenciesCosGenerated$1.cosDependencies,
  equalDependencies: _dependenciesEqualGenerated$6.equalDependencies,
  invDependencies: _dependenciesInvGenerated$3.invDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$z.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$f.multiplyDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$e.multiplyScalarDependencies,
  sinDependencies: _dependenciesSinGenerated$1.sinDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$h.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$25.typedDependencies,
  createEigs: _factoriesAny$3w.createEigs
};
dependenciesEigs_generated.eigsDependencies = eigsDependencies;
var dependenciesPow_generated = {};
Object.defineProperty(dependenciesPow_generated, "__esModule", {
  value: !0
});
dependenciesPow_generated.powDependencies = void 0;
var _dependenciesComplexClassGenerated$e = dependenciesComplexClass_generated, _dependenciesFractionGenerated$2 = dependenciesFraction_generated, _dependenciesIdentityGenerated$3 = dependenciesIdentity_generated, _dependenciesMatrixGenerated$y = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$e = dependenciesMultiply_generated, _dependenciesNumberGenerated$2 = dependenciesNumber_generated, _dependenciesTypedGenerated$24 = dependenciesTyped_generated, _factoriesAny$3v = factoriesAny, powDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$e.ComplexDependencies,
  fractionDependencies: _dependenciesFractionGenerated$2.fractionDependencies,
  identityDependencies: _dependenciesIdentityGenerated$3.identityDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$y.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$e.multiplyDependencies,
  numberDependencies: _dependenciesNumberGenerated$2.numberDependencies,
  typedDependencies: _dependenciesTypedGenerated$24.typedDependencies,
  createPow: _factoriesAny$3v.createPow
};
dependenciesPow_generated.powDependencies = powDependencies;
Object.defineProperty(dependenciesNorm_generated, "__esModule", {
  value: !0
});
dependenciesNorm_generated.normDependencies = void 0;
var _dependenciesAbsGenerated$8 = dependenciesAbs_generated, _dependenciesAddGenerated$g = dependenciesAdd_generated, _dependenciesConjGenerated$1 = dependenciesConj_generated, _dependenciesCtransposeGenerated = dependenciesCtranspose_generated, _dependenciesEigsGenerated = dependenciesEigs_generated, _dependenciesEqualScalarGenerated$f = dependenciesEqualScalar_generated, _dependenciesLargerGenerated$6 = dependenciesLarger_generated, _dependenciesMatrixGenerated$x = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$d = dependenciesMultiply_generated, _dependenciesPowGenerated$6 = dependenciesPow_generated, _dependenciesSmallerGenerated$5 = dependenciesSmaller_generated, _dependenciesSqrtGenerated$6 = dependenciesSqrt_generated, _dependenciesTypedGenerated$23 = dependenciesTyped_generated, _factoriesAny$3u = factoriesAny, normDependencies = {
  absDependencies: _dependenciesAbsGenerated$8.absDependencies,
  addDependencies: _dependenciesAddGenerated$g.addDependencies,
  conjDependencies: _dependenciesConjGenerated$1.conjDependencies,
  ctransposeDependencies: _dependenciesCtransposeGenerated.ctransposeDependencies,
  eigsDependencies: _dependenciesEigsGenerated.eigsDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$f.equalScalarDependencies,
  largerDependencies: _dependenciesLargerGenerated$6.largerDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$x.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$d.multiplyDependencies,
  powDependencies: _dependenciesPowGenerated$6.powDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$5.smallerDependencies,
  sqrtDependencies: _dependenciesSqrtGenerated$6.sqrtDependencies,
  typedDependencies: _dependenciesTypedGenerated$23.typedDependencies,
  createNorm: _factoriesAny$3u.createNorm
};
dependenciesNorm_generated.normDependencies = normDependencies;
Object.defineProperty(dependenciesRotationMatrix_generated, "__esModule", {
  value: !0
});
dependenciesRotationMatrix_generated.rotationMatrixDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1e = dependenciesBigNumberClass_generated, _dependenciesDenseMatrixClassGenerated$h = dependenciesDenseMatrixClass_generated, _dependenciesSparseMatrixClassGenerated$2 = dependenciesSparseMatrixClass_generated, _dependenciesAddScalarGenerated$9 = dependenciesAddScalar_generated, _dependenciesCosGenerated = dependenciesCos_generated, _dependenciesMatrixGenerated$w = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$d = dependenciesMultiplyScalar_generated, _dependenciesNormGenerated = dependenciesNorm_generated, _dependenciesSinGenerated = dependenciesSin_generated, _dependenciesTypedGenerated$22 = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated$2 = dependenciesUnaryMinus_generated, _factoriesAny$3t = factoriesAny, rotationMatrixDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1e.BigNumberDependencies,
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$h.DenseMatrixDependencies,
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated$2.SparseMatrixDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$9.addScalarDependencies,
  cosDependencies: _dependenciesCosGenerated.cosDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$w.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$d.multiplyScalarDependencies,
  normDependencies: _dependenciesNormGenerated.normDependencies,
  sinDependencies: _dependenciesSinGenerated.sinDependencies,
  typedDependencies: _dependenciesTypedGenerated$22.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated$2.unaryMinusDependencies,
  createRotationMatrix: _factoriesAny$3t.createRotationMatrix
};
dependenciesRotationMatrix_generated.rotationMatrixDependencies = rotationMatrixDependencies;
Object.defineProperty(dependenciesRotate_generated, "__esModule", {
  value: !0
});
dependenciesRotate_generated.rotateDependencies = void 0;
var _dependenciesMultiplyGenerated$c = dependenciesMultiply_generated, _dependenciesRotationMatrixGenerated = dependenciesRotationMatrix_generated, _dependenciesTypedGenerated$21 = dependenciesTyped_generated, _factoriesAny$3s = factoriesAny, rotateDependencies = {
  multiplyDependencies: _dependenciesMultiplyGenerated$c.multiplyDependencies,
  rotationMatrixDependencies: _dependenciesRotationMatrixGenerated.rotationMatrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$21.typedDependencies,
  createRotate: _factoriesAny$3s.createRotate
};
dependenciesRotate_generated.rotateDependencies = rotateDependencies;
var dependenciesRow_generated = {};
Object.defineProperty(dependenciesRow_generated, "__esModule", {
  value: !0
});
dependenciesRow_generated.rowDependencies = void 0;
var _dependenciesIndexClassGenerated$d = dependenciesIndexClass_generated, _dependenciesMatrixGenerated$v = dependenciesMatrix_generated, _dependenciesRangeGenerated$2 = dependenciesRange_generated, _dependenciesTypedGenerated$20 = dependenciesTyped_generated, _factoriesAny$3r = factoriesAny, rowDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$d.IndexDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$v.matrixDependencies,
  rangeDependencies: _dependenciesRangeGenerated$2.rangeDependencies,
  typedDependencies: _dependenciesTypedGenerated$20.typedDependencies,
  createRow: _factoriesAny$3r.createRow
};
dependenciesRow_generated.rowDependencies = rowDependencies;
var dependenciesSqueeze_generated = {};
Object.defineProperty(dependenciesSqueeze_generated, "__esModule", {
  value: !0
});
dependenciesSqueeze_generated.squeezeDependencies = void 0;
var _dependenciesMatrixGenerated$u = dependenciesMatrix_generated, _dependenciesTypedGenerated$1$ = dependenciesTyped_generated, _factoriesAny$3q = factoriesAny, squeezeDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$u.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1$.typedDependencies,
  createSqueeze: _factoriesAny$3q.createSqueeze
};
dependenciesSqueeze_generated.squeezeDependencies = squeezeDependencies;
var dependenciesSubset_generated = {};
Object.defineProperty(dependenciesSubset_generated, "__esModule", {
  value: !0
});
dependenciesSubset_generated.subsetDependencies = void 0;
var _dependenciesMatrixGenerated$t = dependenciesMatrix_generated, _dependenciesTypedGenerated$1_ = dependenciesTyped_generated, _factoriesAny$3p = factoriesAny, subsetDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$t.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1_.typedDependencies,
  createSubset: _factoriesAny$3p.createSubset
};
dependenciesSubset_generated.subsetDependencies = subsetDependencies;
var dependenciesErf_generated = {};
Object.defineProperty(dependenciesErf_generated, "__esModule", {
  value: !0
});
dependenciesErf_generated.erfDependencies = void 0;
var _dependenciesTypedGenerated$1Z = dependenciesTyped_generated, _factoriesAny$3o = factoriesAny, erfDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1Z.typedDependencies,
  createErf: _factoriesAny$3o.createErf
};
dependenciesErf_generated.erfDependencies = erfDependencies;
var dependenciesMode_generated = {};
Object.defineProperty(dependenciesMode_generated, "__esModule", {
  value: !0
});
dependenciesMode_generated.modeDependencies = void 0;
var _dependenciesIsNaNGenerated$3 = dependenciesIsNaN_generated, _dependenciesIsNumericGenerated$3 = dependenciesIsNumeric_generated, _dependenciesTypedGenerated$1Y = dependenciesTyped_generated, _factoriesAny$3n = factoriesAny, modeDependencies = {
  isNaNDependencies: _dependenciesIsNaNGenerated$3.isNaNDependencies,
  isNumericDependencies: _dependenciesIsNumericGenerated$3.isNumericDependencies,
  typedDependencies: _dependenciesTypedGenerated$1Y.typedDependencies,
  createMode: _factoriesAny$3n.createMode
};
dependenciesMode_generated.modeDependencies = modeDependencies;
var dependenciesProd_generated = {};
Object.defineProperty(dependenciesProd_generated, "__esModule", {
  value: !0
});
dependenciesProd_generated.prodDependencies = void 0;
var _dependenciesMultiplyScalarGenerated$c = dependenciesMultiplyScalar_generated, _dependenciesNumericGenerated$8 = dependenciesNumeric_generated, _dependenciesTypedGenerated$1X = dependenciesTyped_generated, _factoriesAny$3m = factoriesAny, prodDependencies = {
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$c.multiplyScalarDependencies,
  numericDependencies: _dependenciesNumericGenerated$8.numericDependencies,
  typedDependencies: _dependenciesTypedGenerated$1X.typedDependencies,
  createProd: _factoriesAny$3m.createProd
};
dependenciesProd_generated.prodDependencies = prodDependencies;
var dependenciesFormat_generated = {};
Object.defineProperty(dependenciesFormat_generated, "__esModule", {
  value: !0
});
dependenciesFormat_generated.formatDependencies = void 0;
var _dependenciesTypedGenerated$1W = dependenciesTyped_generated, _factoriesAny$3l = factoriesAny, formatDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1W.typedDependencies,
  createFormat: _factoriesAny$3l.createFormat
};
dependenciesFormat_generated.formatDependencies = formatDependencies;
var dependenciesBin_generated = {};
Object.defineProperty(dependenciesBin_generated, "__esModule", {
  value: !0
});
dependenciesBin_generated.binDependencies = void 0;
var _dependenciesTypedGenerated$1V = dependenciesTyped_generated, _factoriesAny$3k = factoriesAny, binDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1V.typedDependencies,
  createBin: _factoriesAny$3k.createBin
};
dependenciesBin_generated.binDependencies = binDependencies;
var dependenciesOct_generated = {};
Object.defineProperty(dependenciesOct_generated, "__esModule", {
  value: !0
});
dependenciesOct_generated.octDependencies = void 0;
var _dependenciesTypedGenerated$1U = dependenciesTyped_generated, _factoriesAny$3j = factoriesAny, octDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1U.typedDependencies,
  createOct: _factoriesAny$3j.createOct
};
dependenciesOct_generated.octDependencies = octDependencies;
var dependenciesHex_generated = {};
Object.defineProperty(dependenciesHex_generated, "__esModule", {
  value: !0
});
dependenciesHex_generated.hexDependencies = void 0;
var _dependenciesTypedGenerated$1T = dependenciesTyped_generated, _factoriesAny$3i = factoriesAny, hexDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1T.typedDependencies,
  createHex: _factoriesAny$3i.createHex
};
dependenciesHex_generated.hexDependencies = hexDependencies;
var dependenciesPrint_generated = {};
Object.defineProperty(dependenciesPrint_generated, "__esModule", {
  value: !0
});
dependenciesPrint_generated.printDependencies = void 0;
var _dependenciesTypedGenerated$1S = dependenciesTyped_generated, _factoriesAny$3h = factoriesAny, printDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1S.typedDependencies,
  createPrint: _factoriesAny$3h.createPrint
};
dependenciesPrint_generated.printDependencies = printDependencies;
var dependenciesTo_generated = {};
Object.defineProperty(dependenciesTo_generated, "__esModule", {
  value: !0
});
dependenciesTo_generated.toDependencies = void 0;
var _dependenciesMatrixGenerated$s = dependenciesMatrix_generated, _dependenciesTypedGenerated$1R = dependenciesTyped_generated, _factoriesAny$3g = factoriesAny, toDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$s.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1R.typedDependencies,
  createTo: _factoriesAny$3g.createTo
};
dependenciesTo_generated.toDependencies = toDependencies;
var dependenciesIsPrime_generated = {};
Object.defineProperty(dependenciesIsPrime_generated, "__esModule", {
  value: !0
});
dependenciesIsPrime_generated.isPrimeDependencies = void 0;
var _dependenciesTypedGenerated$1Q = dependenciesTyped_generated, _factoriesAny$3f = factoriesAny, isPrimeDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1Q.typedDependencies,
  createIsPrime: _factoriesAny$3f.createIsPrime
};
dependenciesIsPrime_generated.isPrimeDependencies = isPrimeDependencies;
var dependenciesLog_generated = {};
Object.defineProperty(dependenciesLog_generated, "__esModule", {
  value: !0
});
dependenciesLog_generated.logDependencies = void 0;
var _dependenciesComplexClassGenerated$d = dependenciesComplexClass_generated, _dependenciesDivideScalarGenerated$g = dependenciesDivideScalar_generated, _dependenciesTypedGenerated$1P = dependenciesTyped_generated, _factoriesAny$3e = factoriesAny, logDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$d.ComplexDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$g.divideScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated$1P.typedDependencies,
  createLog: _factoriesAny$3e.createLog
};
dependenciesLog_generated.logDependencies = logDependencies;
var dependenciesLog1p_generated = {};
Object.defineProperty(dependenciesLog1p_generated, "__esModule", {
  value: !0
});
dependenciesLog1p_generated.log1pDependencies = void 0;
var _dependenciesComplexClassGenerated$c = dependenciesComplexClass_generated, _dependenciesDivideScalarGenerated$f = dependenciesDivideScalar_generated, _dependenciesLogGenerated$1 = dependenciesLog_generated, _dependenciesTypedGenerated$1O = dependenciesTyped_generated, _factoriesAny$3d = factoriesAny, log1pDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$c.ComplexDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$f.divideScalarDependencies,
  logDependencies: _dependenciesLogGenerated$1.logDependencies,
  typedDependencies: _dependenciesTypedGenerated$1O.typedDependencies,
  createLog1p: _factoriesAny$3d.createLog1p
};
dependenciesLog1p_generated.log1pDependencies = log1pDependencies;
var dependenciesNthRoots_generated = {};
Object.defineProperty(dependenciesNthRoots_generated, "__esModule", {
  value: !0
});
dependenciesNthRoots_generated.nthRootsDependencies = void 0;
var _dependenciesComplexClassGenerated$b = dependenciesComplexClass_generated, _dependenciesDivideScalarGenerated$e = dependenciesDivideScalar_generated, _dependenciesTypedGenerated$1N = dependenciesTyped_generated, _factoriesAny$3c = factoriesAny, nthRootsDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$b.ComplexDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$e.divideScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated$1N.typedDependencies,
  createNthRoots: _factoriesAny$3c.createNthRoots
};
dependenciesNthRoots_generated.nthRootsDependencies = nthRootsDependencies;
var dependenciesDotPow_generated = {};
Object.defineProperty(dependenciesDotPow_generated, "__esModule", {
  value: !0
});
dependenciesDotPow_generated.dotPowDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$g = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$e = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$r = dependenciesMatrix_generated, _dependenciesPowGenerated$5 = dependenciesPow_generated, _dependenciesTypedGenerated$1M = dependenciesTyped_generated, _factoriesAny$3b = factoriesAny, dotPowDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$g.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$e.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$r.matrixDependencies,
  powDependencies: _dependenciesPowGenerated$5.powDependencies,
  typedDependencies: _dependenciesTypedGenerated$1M.typedDependencies,
  createDotPow: _factoriesAny$3b.createDotPow
};
dependenciesDotPow_generated.dotPowDependencies = dotPowDependencies;
var dependenciesDotDivide_generated = {};
Object.defineProperty(dependenciesDotDivide_generated, "__esModule", {
  value: !0
});
dependenciesDotDivide_generated.dotDivideDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$f = dependenciesDenseMatrixClass_generated, _dependenciesDivideScalarGenerated$d = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated$d = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$q = dependenciesMatrix_generated, _dependenciesTypedGenerated$1L = dependenciesTyped_generated, _factoriesAny$3a = factoriesAny, dotDivideDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$f.DenseMatrixDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$d.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$d.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$q.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1L.typedDependencies,
  createDotDivide: _factoriesAny$3a.createDotDivide
};
dependenciesDotDivide_generated.dotDivideDependencies = dotDivideDependencies;
var dependenciesLsolve_generated = {};
Object.defineProperty(dependenciesLsolve_generated, "__esModule", {
  value: !0
});
dependenciesLsolve_generated.lsolveDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$e = dependenciesDenseMatrixClass_generated, _dependenciesDivideScalarGenerated$c = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated$c = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$p = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$b = dependenciesMultiplyScalar_generated, _dependenciesSubtractGenerated$g = dependenciesSubtract_generated, _dependenciesTypedGenerated$1K = dependenciesTyped_generated, _factoriesAny$39 = factoriesAny, lsolveDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$e.DenseMatrixDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$c.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$c.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$p.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$b.multiplyScalarDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$g.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$1K.typedDependencies,
  createLsolve: _factoriesAny$39.createLsolve
};
dependenciesLsolve_generated.lsolveDependencies = lsolveDependencies;
var dependenciesUsolve_generated = {};
Object.defineProperty(dependenciesUsolve_generated, "__esModule", {
  value: !0
});
dependenciesUsolve_generated.usolveDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$d = dependenciesDenseMatrixClass_generated, _dependenciesDivideScalarGenerated$b = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated$b = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$o = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$a = dependenciesMultiplyScalar_generated, _dependenciesSubtractGenerated$f = dependenciesSubtract_generated, _dependenciesTypedGenerated$1J = dependenciesTyped_generated, _factoriesAny$38 = factoriesAny, usolveDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$d.DenseMatrixDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$b.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$b.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$o.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$a.multiplyScalarDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$f.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$1J.typedDependencies,
  createUsolve: _factoriesAny$38.createUsolve
};
dependenciesUsolve_generated.usolveDependencies = usolveDependencies;
var dependenciesLsolveAll_generated = {};
Object.defineProperty(dependenciesLsolveAll_generated, "__esModule", {
  value: !0
});
dependenciesLsolveAll_generated.lsolveAllDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$c = dependenciesDenseMatrixClass_generated, _dependenciesDivideScalarGenerated$a = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated$a = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$n = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$9 = dependenciesMultiplyScalar_generated, _dependenciesSubtractGenerated$e = dependenciesSubtract_generated, _dependenciesTypedGenerated$1I = dependenciesTyped_generated, _factoriesAny$37 = factoriesAny, lsolveAllDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$c.DenseMatrixDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$a.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$a.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$n.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$9.multiplyScalarDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$e.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$1I.typedDependencies,
  createLsolveAll: _factoriesAny$37.createLsolveAll
};
dependenciesLsolveAll_generated.lsolveAllDependencies = lsolveAllDependencies;
var dependenciesUsolveAll_generated = {};
Object.defineProperty(dependenciesUsolveAll_generated, "__esModule", {
  value: !0
});
dependenciesUsolveAll_generated.usolveAllDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$b = dependenciesDenseMatrixClass_generated, _dependenciesDivideScalarGenerated$9 = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated$9 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$m = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$8 = dependenciesMultiplyScalar_generated, _dependenciesSubtractGenerated$d = dependenciesSubtract_generated, _dependenciesTypedGenerated$1H = dependenciesTyped_generated, _factoriesAny$36 = factoriesAny, usolveAllDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$b.DenseMatrixDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$9.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$9.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$m.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$8.multiplyScalarDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$d.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$1H.typedDependencies,
  createUsolveAll: _factoriesAny$36.createUsolveAll
};
dependenciesUsolveAll_generated.usolveAllDependencies = usolveAllDependencies;
var dependenciesLeftShift_generated = {};
Object.defineProperty(dependenciesLeftShift_generated, "__esModule", {
  value: !0
});
dependenciesLeftShift_generated.leftShiftDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$a = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$8 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$l = dependenciesMatrix_generated, _dependenciesTypedGenerated$1G = dependenciesTyped_generated, _dependenciesZerosGenerated$4 = dependenciesZeros_generated, _factoriesAny$35 = factoriesAny, leftShiftDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$a.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$8.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$l.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1G.typedDependencies,
  zerosDependencies: _dependenciesZerosGenerated$4.zerosDependencies,
  createLeftShift: _factoriesAny$35.createLeftShift
};
dependenciesLeftShift_generated.leftShiftDependencies = leftShiftDependencies;
var dependenciesRightArithShift_generated = {};
Object.defineProperty(dependenciesRightArithShift_generated, "__esModule", {
  value: !0
});
dependenciesRightArithShift_generated.rightArithShiftDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$9 = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$7 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$k = dependenciesMatrix_generated, _dependenciesTypedGenerated$1F = dependenciesTyped_generated, _dependenciesZerosGenerated$3 = dependenciesZeros_generated, _factoriesAny$34 = factoriesAny, rightArithShiftDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$9.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$7.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$k.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1F.typedDependencies,
  zerosDependencies: _dependenciesZerosGenerated$3.zerosDependencies,
  createRightArithShift: _factoriesAny$34.createRightArithShift
};
dependenciesRightArithShift_generated.rightArithShiftDependencies = rightArithShiftDependencies;
var dependenciesRightLogShift_generated = {};
Object.defineProperty(dependenciesRightLogShift_generated, "__esModule", {
  value: !0
});
dependenciesRightLogShift_generated.rightLogShiftDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$8 = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$6 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$j = dependenciesMatrix_generated, _dependenciesTypedGenerated$1E = dependenciesTyped_generated, _dependenciesZerosGenerated$2 = dependenciesZeros_generated, _factoriesAny$33 = factoriesAny, rightLogShiftDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$8.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$6.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$j.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1E.typedDependencies,
  zerosDependencies: _dependenciesZerosGenerated$2.zerosDependencies,
  createRightLogShift: _factoriesAny$33.createRightLogShift
};
dependenciesRightLogShift_generated.rightLogShiftDependencies = rightLogShiftDependencies;
var dependenciesAnd_generated = {};
Object.defineProperty(dependenciesAnd_generated, "__esModule", {
  value: !0
});
dependenciesAnd_generated.andDependencies = void 0;
var _dependenciesEqualScalarGenerated$5 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$i = dependenciesMatrix_generated, _dependenciesNotGenerated = dependenciesNot_generated, _dependenciesTypedGenerated$1D = dependenciesTyped_generated, _dependenciesZerosGenerated$1 = dependenciesZeros_generated, _factoriesAny$32 = factoriesAny, andDependencies = {
  equalScalarDependencies: _dependenciesEqualScalarGenerated$5.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$i.matrixDependencies,
  notDependencies: _dependenciesNotGenerated.notDependencies,
  typedDependencies: _dependenciesTypedGenerated$1D.typedDependencies,
  zerosDependencies: _dependenciesZerosGenerated$1.zerosDependencies,
  createAnd: _factoriesAny$32.createAnd
};
dependenciesAnd_generated.andDependencies = andDependencies;
var dependenciesCompare_generated = {};
Object.defineProperty(dependenciesCompare_generated, "__esModule", {
  value: !0
});
dependenciesCompare_generated.compareDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1d = dependenciesBigNumberClass_generated, _dependenciesDenseMatrixClassGenerated$7 = dependenciesDenseMatrixClass_generated, _dependenciesFractionClassGenerated$1 = dependenciesFractionClass_generated, _dependenciesEqualScalarGenerated$4 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$h = dependenciesMatrix_generated, _dependenciesTypedGenerated$1C = dependenciesTyped_generated, _factoriesAny$31 = factoriesAny, compareDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1d.BigNumberDependencies,
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$7.DenseMatrixDependencies,
  FractionDependencies: _dependenciesFractionClassGenerated$1.FractionDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$4.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$h.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1C.typedDependencies,
  createCompare: _factoriesAny$31.createCompare
};
dependenciesCompare_generated.compareDependencies = compareDependencies;
var dependenciesCompareNatural_generated = {};
Object.defineProperty(dependenciesCompareNatural_generated, "__esModule", {
  value: !0
});
dependenciesCompareNatural_generated.compareNaturalDependencies = void 0;
var _dependenciesCompareGenerated$4 = dependenciesCompare_generated, _dependenciesTypedGenerated$1B = dependenciesTyped_generated, _factoriesAny$30 = factoriesAny, compareNaturalDependencies = {
  compareDependencies: _dependenciesCompareGenerated$4.compareDependencies,
  typedDependencies: _dependenciesTypedGenerated$1B.typedDependencies,
  createCompareNatural: _factoriesAny$30.createCompareNatural
};
dependenciesCompareNatural_generated.compareNaturalDependencies = compareNaturalDependencies;
var dependenciesCompareText_generated = {};
Object.defineProperty(dependenciesCompareText_generated, "__esModule", {
  value: !0
});
dependenciesCompareText_generated.compareTextDependencies = void 0;
var _dependenciesMatrixGenerated$g = dependenciesMatrix_generated, _dependenciesTypedGenerated$1A = dependenciesTyped_generated, _factoriesAny$2$ = factoriesAny, compareTextDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$g.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1A.typedDependencies,
  createCompareText: _factoriesAny$2$.createCompareText
};
dependenciesCompareText_generated.compareTextDependencies = compareTextDependencies;
var dependenciesEqualText_generated = {};
Object.defineProperty(dependenciesEqualText_generated, "__esModule", {
  value: !0
});
dependenciesEqualText_generated.equalTextDependencies = void 0;
var _dependenciesCompareTextGenerated = dependenciesCompareText_generated, _dependenciesIsZeroGenerated$4 = dependenciesIsZero_generated, _dependenciesTypedGenerated$1z = dependenciesTyped_generated, _factoriesAny$2_ = factoriesAny, equalTextDependencies = {
  compareTextDependencies: _dependenciesCompareTextGenerated.compareTextDependencies,
  isZeroDependencies: _dependenciesIsZeroGenerated$4.isZeroDependencies,
  typedDependencies: _dependenciesTypedGenerated$1z.typedDependencies,
  createEqualText: _factoriesAny$2_.createEqualText
};
dependenciesEqualText_generated.equalTextDependencies = equalTextDependencies;
var dependenciesDeepEqual_generated = {};
Object.defineProperty(dependenciesDeepEqual_generated, "__esModule", {
  value: !0
});
dependenciesDeepEqual_generated.deepEqualDependencies = void 0;
var _dependenciesEqualGenerated$5 = dependenciesEqual_generated, _dependenciesTypedGenerated$1y = dependenciesTyped_generated, _factoriesAny$2Z = factoriesAny, deepEqualDependencies = {
  equalDependencies: _dependenciesEqualGenerated$5.equalDependencies,
  typedDependencies: _dependenciesTypedGenerated$1y.typedDependencies,
  createDeepEqual: _factoriesAny$2Z.createDeepEqual
};
dependenciesDeepEqual_generated.deepEqualDependencies = deepEqualDependencies;
var dependenciesUnequal_generated = {};
Object.defineProperty(dependenciesUnequal_generated, "__esModule", {
  value: !0
});
dependenciesUnequal_generated.unequalDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$6 = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$3 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$f = dependenciesMatrix_generated, _dependenciesTypedGenerated$1x = dependenciesTyped_generated, _factoriesAny$2Y = factoriesAny, unequalDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$6.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$3.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$f.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1x.typedDependencies,
  createUnequal: _factoriesAny$2Y.createUnequal
};
dependenciesUnequal_generated.unequalDependencies = unequalDependencies;
var dependenciesPartitionSelect_generated = {};
Object.defineProperty(dependenciesPartitionSelect_generated, "__esModule", {
  value: !0
});
dependenciesPartitionSelect_generated.partitionSelectDependencies = void 0;
var _dependenciesCompareGenerated$3 = dependenciesCompare_generated, _dependenciesIsNaNGenerated$2 = dependenciesIsNaN_generated, _dependenciesIsNumericGenerated$2 = dependenciesIsNumeric_generated, _dependenciesTypedGenerated$1w = dependenciesTyped_generated, _factoriesAny$2X = factoriesAny, partitionSelectDependencies = {
  compareDependencies: _dependenciesCompareGenerated$3.compareDependencies,
  isNaNDependencies: _dependenciesIsNaNGenerated$2.isNaNDependencies,
  isNumericDependencies: _dependenciesIsNumericGenerated$2.isNumericDependencies,
  typedDependencies: _dependenciesTypedGenerated$1w.typedDependencies,
  createPartitionSelect: _factoriesAny$2X.createPartitionSelect
};
dependenciesPartitionSelect_generated.partitionSelectDependencies = partitionSelectDependencies;
var dependenciesSort_generated = {};
Object.defineProperty(dependenciesSort_generated, "__esModule", {
  value: !0
});
dependenciesSort_generated.sortDependencies = void 0;
var _dependenciesCompareGenerated$2 = dependenciesCompare_generated, _dependenciesCompareNaturalGenerated$8 = dependenciesCompareNatural_generated, _dependenciesMatrixGenerated$e = dependenciesMatrix_generated, _dependenciesTypedGenerated$1v = dependenciesTyped_generated, _factoriesAny$2W = factoriesAny, sortDependencies = {
  compareDependencies: _dependenciesCompareGenerated$2.compareDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$8.compareNaturalDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$e.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1v.typedDependencies,
  createSort: _factoriesAny$2W.createSort
};
dependenciesSort_generated.sortDependencies = sortDependencies;
var dependenciesMax_generated = {};
Object.defineProperty(dependenciesMax_generated, "__esModule", {
  value: !0
});
dependenciesMax_generated.maxDependencies = void 0;
var _dependenciesLargerGenerated$5 = dependenciesLarger_generated, _dependenciesNumericGenerated$7 = dependenciesNumeric_generated, _dependenciesTypedGenerated$1u = dependenciesTyped_generated, _factoriesAny$2V = factoriesAny, maxDependencies = {
  largerDependencies: _dependenciesLargerGenerated$5.largerDependencies,
  numericDependencies: _dependenciesNumericGenerated$7.numericDependencies,
  typedDependencies: _dependenciesTypedGenerated$1u.typedDependencies,
  createMax: _factoriesAny$2V.createMax
};
dependenciesMax_generated.maxDependencies = maxDependencies;
var dependenciesMin_generated = {};
Object.defineProperty(dependenciesMin_generated, "__esModule", {
  value: !0
});
dependenciesMin_generated.minDependencies = void 0;
var _dependenciesNumericGenerated$6 = dependenciesNumeric_generated, _dependenciesSmallerGenerated$4 = dependenciesSmaller_generated, _dependenciesTypedGenerated$1t = dependenciesTyped_generated, _factoriesAny$2U = factoriesAny, minDependencies = {
  numericDependencies: _dependenciesNumericGenerated$6.numericDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$4.smallerDependencies,
  typedDependencies: _dependenciesTypedGenerated$1t.typedDependencies,
  createMin: _factoriesAny$2U.createMin
};
dependenciesMin_generated.minDependencies = minDependencies;
var dependenciesUnitClass_generated = {};
Object.defineProperty(dependenciesUnitClass_generated, "__esModule", {
  value: !0
});
dependenciesUnitClass_generated.UnitDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1c = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$a = dependenciesComplexClass_generated, _dependenciesFractionClassGenerated = dependenciesFractionClass_generated, _dependenciesAbsGenerated$7 = dependenciesAbs_generated, _dependenciesAddScalarGenerated$8 = dependenciesAddScalar_generated, _dependenciesDivideScalarGenerated$8 = dependenciesDivideScalar_generated, _dependenciesEqualGenerated$4 = dependenciesEqual_generated, _dependenciesFixGenerated = dependenciesFix_generated, _dependenciesFormatGenerated = dependenciesFormat_generated, _dependenciesIsNumericGenerated$1 = dependenciesIsNumeric_generated, _dependenciesMultiplyScalarGenerated$7 = dependenciesMultiplyScalar_generated, _dependenciesNumberGenerated$1 = dependenciesNumber_generated, _dependenciesPowGenerated$4 = dependenciesPow_generated, _dependenciesRoundGenerated = dependenciesRound_generated, _dependenciesSubtractGenerated$c = dependenciesSubtract_generated, _factoriesAny$2T = factoriesAny, UnitDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1c.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$a.ComplexDependencies,
  FractionDependencies: _dependenciesFractionClassGenerated.FractionDependencies,
  absDependencies: _dependenciesAbsGenerated$7.absDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$8.addScalarDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$8.divideScalarDependencies,
  equalDependencies: _dependenciesEqualGenerated$4.equalDependencies,
  fixDependencies: _dependenciesFixGenerated.fixDependencies,
  formatDependencies: _dependenciesFormatGenerated.formatDependencies,
  isNumericDependencies: _dependenciesIsNumericGenerated$1.isNumericDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$7.multiplyScalarDependencies,
  numberDependencies: _dependenciesNumberGenerated$1.numberDependencies,
  powDependencies: _dependenciesPowGenerated$4.powDependencies,
  roundDependencies: _dependenciesRoundGenerated.roundDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$c.subtractDependencies,
  createUnitClass: _factoriesAny$2T.createUnitClass
};
dependenciesUnitClass_generated.UnitDependencies = UnitDependencies;
var dependenciesUnitFunction_generated = {};
Object.defineProperty(dependenciesUnitFunction_generated, "__esModule", {
  value: !0
});
dependenciesUnitFunction_generated.unitDependencies = void 0;
var _dependenciesUnitClassGenerated$M = dependenciesUnitClass_generated, _dependenciesTypedGenerated$1s = dependenciesTyped_generated, _factoriesAny$2S = factoriesAny, unitDependencies = {
  UnitDependencies: _dependenciesUnitClassGenerated$M.UnitDependencies,
  typedDependencies: _dependenciesTypedGenerated$1s.typedDependencies,
  createUnitFunction: _factoriesAny$2S.createUnitFunction
};
dependenciesUnitFunction_generated.unitDependencies = unitDependencies;
var dependenciesSparse_generated = {};
Object.defineProperty(dependenciesSparse_generated, "__esModule", {
  value: !0
});
dependenciesSparse_generated.sparseDependencies = void 0;
var _dependenciesSparseMatrixClassGenerated$1 = dependenciesSparseMatrixClass_generated, _dependenciesTypedGenerated$1r = dependenciesTyped_generated, _factoriesAny$2R = factoriesAny, sparseDependencies = {
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated$1.SparseMatrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1r.typedDependencies,
  createSparse: _factoriesAny$2R.createSparse
};
dependenciesSparse_generated.sparseDependencies = sparseDependencies;
var dependenciesCreateUnit_generated = {};
Object.defineProperty(dependenciesCreateUnit_generated, "__esModule", {
  value: !0
});
dependenciesCreateUnit_generated.createUnitDependencies = void 0;
var _dependenciesUnitClassGenerated$L = dependenciesUnitClass_generated, _dependenciesTypedGenerated$1q = dependenciesTyped_generated, _factoriesAny$2Q = factoriesAny, createUnitDependencies = {
  UnitDependencies: _dependenciesUnitClassGenerated$L.UnitDependencies,
  typedDependencies: _dependenciesTypedGenerated$1q.typedDependencies,
  createCreateUnit: _factoriesAny$2Q.createCreateUnit
};
dependenciesCreateUnit_generated.createUnitDependencies = createUnitDependencies;
var dependenciesAcos_generated = {};
Object.defineProperty(dependenciesAcos_generated, "__esModule", {
  value: !0
});
dependenciesAcos_generated.acosDependencies = void 0;
var _dependenciesComplexClassGenerated$9 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1p = dependenciesTyped_generated, _factoriesAny$2P = factoriesAny, acosDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$9.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1p.typedDependencies,
  createAcos: _factoriesAny$2P.createAcos
};
dependenciesAcos_generated.acosDependencies = acosDependencies;
var dependenciesAcosh_generated = {};
Object.defineProperty(dependenciesAcosh_generated, "__esModule", {
  value: !0
});
dependenciesAcosh_generated.acoshDependencies = void 0;
var _dependenciesComplexClassGenerated$8 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1o = dependenciesTyped_generated, _factoriesAny$2O = factoriesAny, acoshDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$8.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1o.typedDependencies,
  createAcosh: _factoriesAny$2O.createAcosh
};
dependenciesAcosh_generated.acoshDependencies = acoshDependencies;
var dependenciesAcot_generated = {};
Object.defineProperty(dependenciesAcot_generated, "__esModule", {
  value: !0
});
dependenciesAcot_generated.acotDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1b = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$1n = dependenciesTyped_generated, _factoriesAny$2N = factoriesAny, acotDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1b.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$1n.typedDependencies,
  createAcot: _factoriesAny$2N.createAcot
};
dependenciesAcot_generated.acotDependencies = acotDependencies;
var dependenciesAcoth_generated = {};
Object.defineProperty(dependenciesAcoth_generated, "__esModule", {
  value: !0
});
dependenciesAcoth_generated.acothDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1a = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$7 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1m = dependenciesTyped_generated, _factoriesAny$2M = factoriesAny, acothDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1a.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$7.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1m.typedDependencies,
  createAcoth: _factoriesAny$2M.createAcoth
};
dependenciesAcoth_generated.acothDependencies = acothDependencies;
var dependenciesAcsc_generated = {};
Object.defineProperty(dependenciesAcsc_generated, "__esModule", {
  value: !0
});
dependenciesAcsc_generated.acscDependencies = void 0;
var _dependenciesBigNumberClassGenerated$19 = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$6 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1l = dependenciesTyped_generated, _factoriesAny$2L = factoriesAny, acscDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$19.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$6.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1l.typedDependencies,
  createAcsc: _factoriesAny$2L.createAcsc
};
dependenciesAcsc_generated.acscDependencies = acscDependencies;
var dependenciesAcsch_generated = {};
Object.defineProperty(dependenciesAcsch_generated, "__esModule", {
  value: !0
});
dependenciesAcsch_generated.acschDependencies = void 0;
var _dependenciesBigNumberClassGenerated$18 = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$1k = dependenciesTyped_generated, _factoriesAny$2K = factoriesAny, acschDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$18.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$1k.typedDependencies,
  createAcsch: _factoriesAny$2K.createAcsch
};
dependenciesAcsch_generated.acschDependencies = acschDependencies;
var dependenciesAsec_generated = {};
Object.defineProperty(dependenciesAsec_generated, "__esModule", {
  value: !0
});
dependenciesAsec_generated.asecDependencies = void 0;
var _dependenciesBigNumberClassGenerated$17 = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$5 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1j = dependenciesTyped_generated, _factoriesAny$2J = factoriesAny, asecDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$17.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$5.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1j.typedDependencies,
  createAsec: _factoriesAny$2J.createAsec
};
dependenciesAsec_generated.asecDependencies = asecDependencies;
var dependenciesAsech_generated = {};
Object.defineProperty(dependenciesAsech_generated, "__esModule", {
  value: !0
});
dependenciesAsech_generated.asechDependencies = void 0;
var _dependenciesBigNumberClassGenerated$16 = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$4 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1i = dependenciesTyped_generated, _factoriesAny$2I = factoriesAny, asechDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$16.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$4.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1i.typedDependencies,
  createAsech: _factoriesAny$2I.createAsech
};
dependenciesAsech_generated.asechDependencies = asechDependencies;
var dependenciesAsin_generated = {};
Object.defineProperty(dependenciesAsin_generated, "__esModule", {
  value: !0
});
dependenciesAsin_generated.asinDependencies = void 0;
var _dependenciesComplexClassGenerated$3 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1h = dependenciesTyped_generated, _factoriesAny$2H = factoriesAny, asinDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$3.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1h.typedDependencies,
  createAsin: _factoriesAny$2H.createAsin
};
dependenciesAsin_generated.asinDependencies = asinDependencies;
var dependenciesAsinh_generated = {};
Object.defineProperty(dependenciesAsinh_generated, "__esModule", {
  value: !0
});
dependenciesAsinh_generated.asinhDependencies = void 0;
var _dependenciesTypedGenerated$1g = dependenciesTyped_generated, _factoriesAny$2G = factoriesAny, asinhDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1g.typedDependencies,
  createAsinh: _factoriesAny$2G.createAsinh
};
dependenciesAsinh_generated.asinhDependencies = asinhDependencies;
var dependenciesAtan2_generated = {};
Object.defineProperty(dependenciesAtan2_generated, "__esModule", {
  value: !0
});
dependenciesAtan2_generated.atan2Dependencies = void 0;
var _dependenciesBigNumberClassGenerated$15 = dependenciesBigNumberClass_generated, _dependenciesDenseMatrixClassGenerated$5 = dependenciesDenseMatrixClass_generated, _dependenciesEqualScalarGenerated$2 = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$d = dependenciesMatrix_generated, _dependenciesTypedGenerated$1f = dependenciesTyped_generated, _factoriesAny$2F = factoriesAny, atan2Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$15.BigNumberDependencies,
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$5.DenseMatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$2.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$d.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$1f.typedDependencies,
  createAtan2: _factoriesAny$2F.createAtan2
};
dependenciesAtan2_generated.atan2Dependencies = atan2Dependencies;
var dependenciesAtanh_generated = {};
Object.defineProperty(dependenciesAtanh_generated, "__esModule", {
  value: !0
});
dependenciesAtanh_generated.atanhDependencies = void 0;
var _dependenciesComplexClassGenerated$2 = dependenciesComplexClass_generated, _dependenciesTypedGenerated$1e = dependenciesTyped_generated, _factoriesAny$2E = factoriesAny, atanhDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated$2.ComplexDependencies,
  typedDependencies: _dependenciesTypedGenerated$1e.typedDependencies,
  createAtanh: _factoriesAny$2E.createAtanh
};
dependenciesAtanh_generated.atanhDependencies = atanhDependencies;
var dependenciesCosh_generated = {};
Object.defineProperty(dependenciesCosh_generated, "__esModule", {
  value: !0
});
dependenciesCosh_generated.coshDependencies = void 0;
var _dependenciesTypedGenerated$1d = dependenciesTyped_generated, _factoriesAny$2D = factoriesAny, coshDependencies = {
  typedDependencies: _dependenciesTypedGenerated$1d.typedDependencies,
  createCosh: _factoriesAny$2D.createCosh
};
dependenciesCosh_generated.coshDependencies = coshDependencies;
var dependenciesCot_generated = {};
Object.defineProperty(dependenciesCot_generated, "__esModule", {
  value: !0
});
dependenciesCot_generated.cotDependencies = void 0;
var _dependenciesBigNumberClassGenerated$14 = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$1c = dependenciesTyped_generated, _factoriesAny$2C = factoriesAny, cotDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$14.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$1c.typedDependencies,
  createCot: _factoriesAny$2C.createCot
};
dependenciesCot_generated.cotDependencies = cotDependencies;
var dependenciesCoth_generated = {};
Object.defineProperty(dependenciesCoth_generated, "__esModule", {
  value: !0
});
dependenciesCoth_generated.cothDependencies = void 0;
var _dependenciesBigNumberClassGenerated$13 = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$1b = dependenciesTyped_generated, _factoriesAny$2B = factoriesAny, cothDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$13.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$1b.typedDependencies,
  createCoth: _factoriesAny$2B.createCoth
};
dependenciesCoth_generated.cothDependencies = cothDependencies;
var dependenciesCsc_generated = {};
Object.defineProperty(dependenciesCsc_generated, "__esModule", {
  value: !0
});
dependenciesCsc_generated.cscDependencies = void 0;
var _dependenciesBigNumberClassGenerated$12 = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$1a = dependenciesTyped_generated, _factoriesAny$2A = factoriesAny, cscDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$12.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$1a.typedDependencies,
  createCsc: _factoriesAny$2A.createCsc
};
dependenciesCsc_generated.cscDependencies = cscDependencies;
var dependenciesCsch_generated = {};
Object.defineProperty(dependenciesCsch_generated, "__esModule", {
  value: !0
});
dependenciesCsch_generated.cschDependencies = void 0;
var _dependenciesBigNumberClassGenerated$11 = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$19 = dependenciesTyped_generated, _factoriesAny$2z = factoriesAny, cschDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$11.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$19.typedDependencies,
  createCsch: _factoriesAny$2z.createCsch
};
dependenciesCsch_generated.cschDependencies = cschDependencies;
var dependenciesSec_generated = {};
Object.defineProperty(dependenciesSec_generated, "__esModule", {
  value: !0
});
dependenciesSec_generated.secDependencies = void 0;
var _dependenciesBigNumberClassGenerated$10 = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$18 = dependenciesTyped_generated, _factoriesAny$2y = factoriesAny, secDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$10.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$18.typedDependencies,
  createSec: _factoriesAny$2y.createSec
};
dependenciesSec_generated.secDependencies = secDependencies;
var dependenciesSech_generated = {};
Object.defineProperty(dependenciesSech_generated, "__esModule", {
  value: !0
});
dependenciesSech_generated.sechDependencies = void 0;
var _dependenciesBigNumberClassGenerated$$ = dependenciesBigNumberClass_generated, _dependenciesTypedGenerated$17 = dependenciesTyped_generated, _factoriesAny$2x = factoriesAny, sechDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$$.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated$17.typedDependencies,
  createSech: _factoriesAny$2x.createSech
};
dependenciesSech_generated.sechDependencies = sechDependencies;
var dependenciesSinh_generated = {};
Object.defineProperty(dependenciesSinh_generated, "__esModule", {
  value: !0
});
dependenciesSinh_generated.sinhDependencies = void 0;
var _dependenciesTypedGenerated$16 = dependenciesTyped_generated, _factoriesAny$2w = factoriesAny, sinhDependencies = {
  typedDependencies: _dependenciesTypedGenerated$16.typedDependencies,
  createSinh: _factoriesAny$2w.createSinh
};
dependenciesSinh_generated.sinhDependencies = sinhDependencies;
var dependenciesTan_generated = {};
Object.defineProperty(dependenciesTan_generated, "__esModule", {
  value: !0
});
dependenciesTan_generated.tanDependencies = void 0;
var _dependenciesTypedGenerated$15 = dependenciesTyped_generated, _factoriesAny$2v = factoriesAny, tanDependencies = {
  typedDependencies: _dependenciesTypedGenerated$15.typedDependencies,
  createTan: _factoriesAny$2v.createTan
};
dependenciesTan_generated.tanDependencies = tanDependencies;
var dependenciesTanh_generated = {};
Object.defineProperty(dependenciesTanh_generated, "__esModule", {
  value: !0
});
dependenciesTanh_generated.tanhDependencies = void 0;
var _dependenciesTypedGenerated$14 = dependenciesTyped_generated, _factoriesAny$2u = factoriesAny, tanhDependencies = {
  typedDependencies: _dependenciesTypedGenerated$14.typedDependencies,
  createTanh: _factoriesAny$2u.createTanh
};
dependenciesTanh_generated.tanhDependencies = tanhDependencies;
var dependenciesSetCartesian_generated = {};
Object.defineProperty(dependenciesSetCartesian_generated, "__esModule", {
  value: !0
});
dependenciesSetCartesian_generated.setCartesianDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$4 = dependenciesDenseMatrixClass_generated, _dependenciesIndexClassGenerated$c = dependenciesIndexClass_generated, _dependenciesCompareNaturalGenerated$7 = dependenciesCompareNatural_generated, _dependenciesSizeGenerated$a = dependenciesSize_generated, _dependenciesSubsetGenerated$a = dependenciesSubset_generated, _dependenciesTypedGenerated$13 = dependenciesTyped_generated, _factoriesAny$2t = factoriesAny, setCartesianDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$4.DenseMatrixDependencies,
  IndexDependencies: _dependenciesIndexClassGenerated$c.IndexDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$7.compareNaturalDependencies,
  sizeDependencies: _dependenciesSizeGenerated$a.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$a.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$13.typedDependencies,
  createSetCartesian: _factoriesAny$2t.createSetCartesian
};
dependenciesSetCartesian_generated.setCartesianDependencies = setCartesianDependencies;
var dependenciesSetDifference_generated = {};
Object.defineProperty(dependenciesSetDifference_generated, "__esModule", {
  value: !0
});
dependenciesSetDifference_generated.setDifferenceDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$3 = dependenciesDenseMatrixClass_generated, _dependenciesIndexClassGenerated$b = dependenciesIndexClass_generated, _dependenciesCompareNaturalGenerated$6 = dependenciesCompareNatural_generated, _dependenciesSizeGenerated$9 = dependenciesSize_generated, _dependenciesSubsetGenerated$9 = dependenciesSubset_generated, _dependenciesTypedGenerated$12 = dependenciesTyped_generated, _factoriesAny$2s = factoriesAny, setDifferenceDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$3.DenseMatrixDependencies,
  IndexDependencies: _dependenciesIndexClassGenerated$b.IndexDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$6.compareNaturalDependencies,
  sizeDependencies: _dependenciesSizeGenerated$9.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$9.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$12.typedDependencies,
  createSetDifference: _factoriesAny$2s.createSetDifference
};
dependenciesSetDifference_generated.setDifferenceDependencies = setDifferenceDependencies;
var dependenciesSetDistinct_generated = {};
Object.defineProperty(dependenciesSetDistinct_generated, "__esModule", {
  value: !0
});
dependenciesSetDistinct_generated.setDistinctDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$2 = dependenciesDenseMatrixClass_generated, _dependenciesIndexClassGenerated$a = dependenciesIndexClass_generated, _dependenciesCompareNaturalGenerated$5 = dependenciesCompareNatural_generated, _dependenciesSizeGenerated$8 = dependenciesSize_generated, _dependenciesSubsetGenerated$8 = dependenciesSubset_generated, _dependenciesTypedGenerated$11 = dependenciesTyped_generated, _factoriesAny$2r = factoriesAny, setDistinctDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$2.DenseMatrixDependencies,
  IndexDependencies: _dependenciesIndexClassGenerated$a.IndexDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$5.compareNaturalDependencies,
  sizeDependencies: _dependenciesSizeGenerated$8.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$8.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$11.typedDependencies,
  createSetDistinct: _factoriesAny$2r.createSetDistinct
};
dependenciesSetDistinct_generated.setDistinctDependencies = setDistinctDependencies;
var dependenciesSetIntersect_generated = {};
Object.defineProperty(dependenciesSetIntersect_generated, "__esModule", {
  value: !0
});
dependenciesSetIntersect_generated.setIntersectDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated$1 = dependenciesDenseMatrixClass_generated, _dependenciesIndexClassGenerated$9 = dependenciesIndexClass_generated, _dependenciesCompareNaturalGenerated$4 = dependenciesCompareNatural_generated, _dependenciesSizeGenerated$7 = dependenciesSize_generated, _dependenciesSubsetGenerated$7 = dependenciesSubset_generated, _dependenciesTypedGenerated$10 = dependenciesTyped_generated, _factoriesAny$2q = factoriesAny, setIntersectDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated$1.DenseMatrixDependencies,
  IndexDependencies: _dependenciesIndexClassGenerated$9.IndexDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$4.compareNaturalDependencies,
  sizeDependencies: _dependenciesSizeGenerated$7.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$7.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$10.typedDependencies,
  createSetIntersect: _factoriesAny$2q.createSetIntersect
};
dependenciesSetIntersect_generated.setIntersectDependencies = setIntersectDependencies;
var dependenciesSetIsSubset_generated = {};
Object.defineProperty(dependenciesSetIsSubset_generated, "__esModule", {
  value: !0
});
dependenciesSetIsSubset_generated.setIsSubsetDependencies = void 0;
var _dependenciesIndexClassGenerated$8 = dependenciesIndexClass_generated, _dependenciesCompareNaturalGenerated$3 = dependenciesCompareNatural_generated, _dependenciesSizeGenerated$6 = dependenciesSize_generated, _dependenciesSubsetGenerated$6 = dependenciesSubset_generated, _dependenciesTypedGenerated$$ = dependenciesTyped_generated, _factoriesAny$2p = factoriesAny, setIsSubsetDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$8.IndexDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$3.compareNaturalDependencies,
  sizeDependencies: _dependenciesSizeGenerated$6.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$6.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$$.typedDependencies,
  createSetIsSubset: _factoriesAny$2p.createSetIsSubset
};
dependenciesSetIsSubset_generated.setIsSubsetDependencies = setIsSubsetDependencies;
var dependenciesSetMultiplicity_generated = {};
Object.defineProperty(dependenciesSetMultiplicity_generated, "__esModule", {
  value: !0
});
dependenciesSetMultiplicity_generated.setMultiplicityDependencies = void 0;
var _dependenciesIndexClassGenerated$7 = dependenciesIndexClass_generated, _dependenciesCompareNaturalGenerated$2 = dependenciesCompareNatural_generated, _dependenciesSizeGenerated$5 = dependenciesSize_generated, _dependenciesSubsetGenerated$5 = dependenciesSubset_generated, _dependenciesTypedGenerated$_ = dependenciesTyped_generated, _factoriesAny$2o = factoriesAny, setMultiplicityDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$7.IndexDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$2.compareNaturalDependencies,
  sizeDependencies: _dependenciesSizeGenerated$5.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$5.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$_.typedDependencies,
  createSetMultiplicity: _factoriesAny$2o.createSetMultiplicity
};
dependenciesSetMultiplicity_generated.setMultiplicityDependencies = setMultiplicityDependencies;
var dependenciesSetPowerset_generated = {};
Object.defineProperty(dependenciesSetPowerset_generated, "__esModule", {
  value: !0
});
dependenciesSetPowerset_generated.setPowersetDependencies = void 0;
var _dependenciesIndexClassGenerated$6 = dependenciesIndexClass_generated, _dependenciesCompareNaturalGenerated$1 = dependenciesCompareNatural_generated, _dependenciesSizeGenerated$4 = dependenciesSize_generated, _dependenciesSubsetGenerated$4 = dependenciesSubset_generated, _dependenciesTypedGenerated$Z = dependenciesTyped_generated, _factoriesAny$2n = factoriesAny, setPowersetDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$6.IndexDependencies,
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated$1.compareNaturalDependencies,
  sizeDependencies: _dependenciesSizeGenerated$4.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$4.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$Z.typedDependencies,
  createSetPowerset: _factoriesAny$2n.createSetPowerset
};
dependenciesSetPowerset_generated.setPowersetDependencies = setPowersetDependencies;
var dependenciesSetSize_generated = {};
Object.defineProperty(dependenciesSetSize_generated, "__esModule", {
  value: !0
});
dependenciesSetSize_generated.setSizeDependencies = void 0;
var _dependenciesCompareNaturalGenerated = dependenciesCompareNatural_generated, _dependenciesTypedGenerated$Y = dependenciesTyped_generated, _factoriesAny$2m = factoriesAny, setSizeDependencies = {
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated.compareNaturalDependencies,
  typedDependencies: _dependenciesTypedGenerated$Y.typedDependencies,
  createSetSize: _factoriesAny$2m.createSetSize
};
dependenciesSetSize_generated.setSizeDependencies = setSizeDependencies;
var dependenciesSetSymDifference_generated = {};
Object.defineProperty(dependenciesSetSymDifference_generated, "__esModule", {
  value: !0
});
dependenciesSetSymDifference_generated.setSymDifferenceDependencies = void 0;
var _dependenciesIndexClassGenerated$5 = dependenciesIndexClass_generated, _dependenciesConcatGenerated$1 = dependenciesConcat_generated, _dependenciesSetDifferenceGenerated = dependenciesSetDifference_generated, _dependenciesSizeGenerated$3 = dependenciesSize_generated, _dependenciesSubsetGenerated$3 = dependenciesSubset_generated, _dependenciesTypedGenerated$X = dependenciesTyped_generated, _factoriesAny$2l = factoriesAny, setSymDifferenceDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$5.IndexDependencies,
  concatDependencies: _dependenciesConcatGenerated$1.concatDependencies,
  setDifferenceDependencies: _dependenciesSetDifferenceGenerated.setDifferenceDependencies,
  sizeDependencies: _dependenciesSizeGenerated$3.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$3.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$X.typedDependencies,
  createSetSymDifference: _factoriesAny$2l.createSetSymDifference
};
dependenciesSetSymDifference_generated.setSymDifferenceDependencies = setSymDifferenceDependencies;
var dependenciesSetUnion_generated = {};
Object.defineProperty(dependenciesSetUnion_generated, "__esModule", {
  value: !0
});
dependenciesSetUnion_generated.setUnionDependencies = void 0;
var _dependenciesIndexClassGenerated$4 = dependenciesIndexClass_generated, _dependenciesConcatGenerated = dependenciesConcat_generated, _dependenciesSetIntersectGenerated = dependenciesSetIntersect_generated, _dependenciesSetSymDifferenceGenerated = dependenciesSetSymDifference_generated, _dependenciesSizeGenerated$2 = dependenciesSize_generated, _dependenciesSubsetGenerated$2 = dependenciesSubset_generated, _dependenciesTypedGenerated$W = dependenciesTyped_generated, _factoriesAny$2k = factoriesAny, setUnionDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$4.IndexDependencies,
  concatDependencies: _dependenciesConcatGenerated.concatDependencies,
  setIntersectDependencies: _dependenciesSetIntersectGenerated.setIntersectDependencies,
  setSymDifferenceDependencies: _dependenciesSetSymDifferenceGenerated.setSymDifferenceDependencies,
  sizeDependencies: _dependenciesSizeGenerated$2.sizeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$2.subsetDependencies,
  typedDependencies: _dependenciesTypedGenerated$W.typedDependencies,
  createSetUnion: _factoriesAny$2k.createSetUnion
};
dependenciesSetUnion_generated.setUnionDependencies = setUnionDependencies;
var dependenciesHypot_generated = {};
Object.defineProperty(dependenciesHypot_generated, "__esModule", {
  value: !0
});
dependenciesHypot_generated.hypotDependencies = void 0;
var _dependenciesAbsGenerated$6 = dependenciesAbs_generated, _dependenciesAddScalarGenerated$7 = dependenciesAddScalar_generated, _dependenciesDivideScalarGenerated$7 = dependenciesDivideScalar_generated, _dependenciesIsPositiveGenerated$2 = dependenciesIsPositive_generated, _dependenciesMultiplyScalarGenerated$6 = dependenciesMultiplyScalar_generated, _dependenciesSmallerGenerated$3 = dependenciesSmaller_generated, _dependenciesSqrtGenerated$5 = dependenciesSqrt_generated, _dependenciesTypedGenerated$V = dependenciesTyped_generated, _factoriesAny$2j = factoriesAny, hypotDependencies = {
  absDependencies: _dependenciesAbsGenerated$6.absDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$7.addScalarDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$7.divideScalarDependencies,
  isPositiveDependencies: _dependenciesIsPositiveGenerated$2.isPositiveDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$6.multiplyScalarDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$3.smallerDependencies,
  sqrtDependencies: _dependenciesSqrtGenerated$5.sqrtDependencies,
  typedDependencies: _dependenciesTypedGenerated$V.typedDependencies,
  createHypot: _factoriesAny$2j.createHypot
};
dependenciesHypot_generated.hypotDependencies = hypotDependencies;
var dependenciesTrace_generated = {};
Object.defineProperty(dependenciesTrace_generated, "__esModule", {
  value: !0
});
dependenciesTrace_generated.traceDependencies = void 0;
var _dependenciesAddGenerated$f = dependenciesAdd_generated, _dependenciesMatrixGenerated$c = dependenciesMatrix_generated, _dependenciesTypedGenerated$U = dependenciesTyped_generated, _factoriesAny$2i = factoriesAny, traceDependencies = {
  addDependencies: _dependenciesAddGenerated$f.addDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$c.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$U.typedDependencies,
  createTrace: _factoriesAny$2i.createTrace
};
dependenciesTrace_generated.traceDependencies = traceDependencies;
var dependenciesIndex_generated = {};
Object.defineProperty(dependenciesIndex_generated, "__esModule", {
  value: !0
});
dependenciesIndex_generated.indexDependencies = void 0;
var _dependenciesIndexClassGenerated$3 = dependenciesIndexClass_generated, _dependenciesTypedGenerated$T = dependenciesTyped_generated, _factoriesAny$2h = factoriesAny, indexDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$3.IndexDependencies,
  typedDependencies: _dependenciesTypedGenerated$T.typedDependencies,
  createIndex: _factoriesAny$2h.createIndex
};
dependenciesIndex_generated.indexDependencies = indexDependencies;
var dependenciesNode_generated = {};
Object.defineProperty(dependenciesNode_generated, "__esModule", {
  value: !0
});
dependenciesNode_generated.NodeDependencies = void 0;
var _factoriesAny$2g = factoriesAny, NodeDependencies = {
  createNode: _factoriesAny$2g.createNode
};
dependenciesNode_generated.NodeDependencies = NodeDependencies;
var dependenciesAccessorNode_generated = {};
Object.defineProperty(dependenciesAccessorNode_generated, "__esModule", {
  value: !0
});
dependenciesAccessorNode_generated.AccessorNodeDependencies = void 0;
var _dependenciesNodeGenerated$e = dependenciesNode_generated, _dependenciesSubsetGenerated$1 = dependenciesSubset_generated, _factoriesAny$2f = factoriesAny, AccessorNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$e.NodeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated$1.subsetDependencies,
  createAccessorNode: _factoriesAny$2f.createAccessorNode
};
dependenciesAccessorNode_generated.AccessorNodeDependencies = AccessorNodeDependencies;
var dependenciesArrayNode_generated = {};
Object.defineProperty(dependenciesArrayNode_generated, "__esModule", {
  value: !0
});
dependenciesArrayNode_generated.ArrayNodeDependencies = void 0;
var _dependenciesNodeGenerated$d = dependenciesNode_generated, _factoriesAny$2e = factoriesAny, ArrayNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$d.NodeDependencies,
  createArrayNode: _factoriesAny$2e.createArrayNode
};
dependenciesArrayNode_generated.ArrayNodeDependencies = ArrayNodeDependencies;
var dependenciesAssignmentNode_generated = {};
Object.defineProperty(dependenciesAssignmentNode_generated, "__esModule", {
  value: !0
});
dependenciesAssignmentNode_generated.AssignmentNodeDependencies = void 0;
var _dependenciesMatrixGenerated$b = dependenciesMatrix_generated, _dependenciesNodeGenerated$c = dependenciesNode_generated, _dependenciesSubsetGenerated = dependenciesSubset_generated, _factoriesAny$2d = factoriesAny, AssignmentNodeDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$b.matrixDependencies,
  NodeDependencies: _dependenciesNodeGenerated$c.NodeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated.subsetDependencies,
  createAssignmentNode: _factoriesAny$2d.createAssignmentNode
};
dependenciesAssignmentNode_generated.AssignmentNodeDependencies = AssignmentNodeDependencies;
var dependenciesBlockNode_generated = {};
Object.defineProperty(dependenciesBlockNode_generated, "__esModule", {
  value: !0
});
dependenciesBlockNode_generated.BlockNodeDependencies = void 0;
var _dependenciesNodeGenerated$b = dependenciesNode_generated, _dependenciesResultSetGenerated = dependenciesResultSet_generated, _factoriesAny$2c = factoriesAny, BlockNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$b.NodeDependencies,
  ResultSetDependencies: _dependenciesResultSetGenerated.ResultSetDependencies,
  createBlockNode: _factoriesAny$2c.createBlockNode
};
dependenciesBlockNode_generated.BlockNodeDependencies = BlockNodeDependencies;
var dependenciesConditionalNode_generated = {};
Object.defineProperty(dependenciesConditionalNode_generated, "__esModule", {
  value: !0
});
dependenciesConditionalNode_generated.ConditionalNodeDependencies = void 0;
var _dependenciesNodeGenerated$a = dependenciesNode_generated, _factoriesAny$2b = factoriesAny, ConditionalNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$a.NodeDependencies,
  createConditionalNode: _factoriesAny$2b.createConditionalNode
};
dependenciesConditionalNode_generated.ConditionalNodeDependencies = ConditionalNodeDependencies;
var dependenciesConstantNode_generated = {};
Object.defineProperty(dependenciesConstantNode_generated, "__esModule", {
  value: !0
});
dependenciesConstantNode_generated.ConstantNodeDependencies = void 0;
var _dependenciesNodeGenerated$9 = dependenciesNode_generated, _factoriesAny$2a = factoriesAny, ConstantNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$9.NodeDependencies,
  createConstantNode: _factoriesAny$2a.createConstantNode
};
dependenciesConstantNode_generated.ConstantNodeDependencies = ConstantNodeDependencies;
var dependenciesFunctionAssignmentNode_generated = {};
Object.defineProperty(dependenciesFunctionAssignmentNode_generated, "__esModule", {
  value: !0
});
dependenciesFunctionAssignmentNode_generated.FunctionAssignmentNodeDependencies = void 0;
var _dependenciesNodeGenerated$8 = dependenciesNode_generated, _dependenciesTypedGenerated$S = dependenciesTyped_generated, _factoriesAny$29 = factoriesAny, FunctionAssignmentNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$8.NodeDependencies,
  typedDependencies: _dependenciesTypedGenerated$S.typedDependencies,
  createFunctionAssignmentNode: _factoriesAny$29.createFunctionAssignmentNode
};
dependenciesFunctionAssignmentNode_generated.FunctionAssignmentNodeDependencies = FunctionAssignmentNodeDependencies;
var dependenciesIndexNode_generated = {};
Object.defineProperty(dependenciesIndexNode_generated, "__esModule", {
  value: !0
});
dependenciesIndexNode_generated.IndexNodeDependencies = void 0;
var _dependenciesNodeGenerated$7 = dependenciesNode_generated, _dependenciesRangeClassGenerated = dependenciesRangeClass_generated, _dependenciesSizeGenerated$1 = dependenciesSize_generated, _factoriesAny$28 = factoriesAny, IndexNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$7.NodeDependencies,
  RangeDependencies: _dependenciesRangeClassGenerated.RangeDependencies,
  sizeDependencies: _dependenciesSizeGenerated$1.sizeDependencies,
  createIndexNode: _factoriesAny$28.createIndexNode
};
dependenciesIndexNode_generated.IndexNodeDependencies = IndexNodeDependencies;
var dependenciesObjectNode_generated = {};
Object.defineProperty(dependenciesObjectNode_generated, "__esModule", {
  value: !0
});
dependenciesObjectNode_generated.ObjectNodeDependencies = void 0;
var _dependenciesNodeGenerated$6 = dependenciesNode_generated, _factoriesAny$27 = factoriesAny, ObjectNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$6.NodeDependencies,
  createObjectNode: _factoriesAny$27.createObjectNode
};
dependenciesObjectNode_generated.ObjectNodeDependencies = ObjectNodeDependencies;
var dependenciesOperatorNode_generated = {};
Object.defineProperty(dependenciesOperatorNode_generated, "__esModule", {
  value: !0
});
dependenciesOperatorNode_generated.OperatorNodeDependencies = void 0;
var _dependenciesNodeGenerated$5 = dependenciesNode_generated, _factoriesAny$26 = factoriesAny, OperatorNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$5.NodeDependencies,
  createOperatorNode: _factoriesAny$26.createOperatorNode
};
dependenciesOperatorNode_generated.OperatorNodeDependencies = OperatorNodeDependencies;
var dependenciesParenthesisNode_generated = {};
Object.defineProperty(dependenciesParenthesisNode_generated, "__esModule", {
  value: !0
});
dependenciesParenthesisNode_generated.ParenthesisNodeDependencies = void 0;
var _dependenciesNodeGenerated$4 = dependenciesNode_generated, _factoriesAny$25 = factoriesAny, ParenthesisNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$4.NodeDependencies,
  createParenthesisNode: _factoriesAny$25.createParenthesisNode
};
dependenciesParenthesisNode_generated.ParenthesisNodeDependencies = ParenthesisNodeDependencies;
var dependenciesRangeNode_generated = {};
Object.defineProperty(dependenciesRangeNode_generated, "__esModule", {
  value: !0
});
dependenciesRangeNode_generated.RangeNodeDependencies = void 0;
var _dependenciesNodeGenerated$3 = dependenciesNode_generated, _factoriesAny$24 = factoriesAny, RangeNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$3.NodeDependencies,
  createRangeNode: _factoriesAny$24.createRangeNode
};
dependenciesRangeNode_generated.RangeNodeDependencies = RangeNodeDependencies;
var dependenciesRelationalNode_generated = {};
Object.defineProperty(dependenciesRelationalNode_generated, "__esModule", {
  value: !0
});
dependenciesRelationalNode_generated.RelationalNodeDependencies = void 0;
var _dependenciesNodeGenerated$2 = dependenciesNode_generated, _factoriesAny$23 = factoriesAny, RelationalNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated$2.NodeDependencies,
  createRelationalNode: _factoriesAny$23.createRelationalNode
};
dependenciesRelationalNode_generated.RelationalNodeDependencies = RelationalNodeDependencies;
var dependenciesSymbolNode_generated = {};
Object.defineProperty(dependenciesSymbolNode_generated, "__esModule", {
  value: !0
});
dependenciesSymbolNode_generated.SymbolNodeDependencies = void 0;
var _dependenciesUnitClassGenerated$K = dependenciesUnitClass_generated, _dependenciesNodeGenerated$1 = dependenciesNode_generated, _factoriesAny$22 = factoriesAny, SymbolNodeDependencies = {
  UnitDependencies: _dependenciesUnitClassGenerated$K.UnitDependencies,
  NodeDependencies: _dependenciesNodeGenerated$1.NodeDependencies,
  createSymbolNode: _factoriesAny$22.createSymbolNode
};
dependenciesSymbolNode_generated.SymbolNodeDependencies = SymbolNodeDependencies;
var dependenciesFunctionNode_generated = {};
Object.defineProperty(dependenciesFunctionNode_generated, "__esModule", {
  value: !0
});
dependenciesFunctionNode_generated.FunctionNodeDependencies = void 0;
var _dependenciesNodeGenerated = dependenciesNode_generated, _dependenciesSymbolNodeGenerated$4 = dependenciesSymbolNode_generated, _factoriesAny$21 = factoriesAny, FunctionNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  SymbolNodeDependencies: _dependenciesSymbolNodeGenerated$4.SymbolNodeDependencies,
  createFunctionNode: _factoriesAny$21.createFunctionNode
};
dependenciesFunctionNode_generated.FunctionNodeDependencies = FunctionNodeDependencies;
var dependenciesParse_generated = {};
Object.defineProperty(dependenciesParse_generated, "__esModule", {
  value: !0
});
dependenciesParse_generated.parseDependencies = void 0;
var _dependenciesAccessorNodeGenerated = dependenciesAccessorNode_generated, _dependenciesArrayNodeGenerated = dependenciesArrayNode_generated, _dependenciesAssignmentNodeGenerated = dependenciesAssignmentNode_generated, _dependenciesBlockNodeGenerated = dependenciesBlockNode_generated, _dependenciesConditionalNodeGenerated = dependenciesConditionalNode_generated, _dependenciesConstantNodeGenerated$3 = dependenciesConstantNode_generated, _dependenciesFunctionAssignmentNodeGenerated = dependenciesFunctionAssignmentNode_generated, _dependenciesFunctionNodeGenerated$3 = dependenciesFunctionNode_generated, _dependenciesIndexNodeGenerated = dependenciesIndexNode_generated, _dependenciesObjectNodeGenerated = dependenciesObjectNode_generated, _dependenciesOperatorNodeGenerated$3 = dependenciesOperatorNode_generated, _dependenciesParenthesisNodeGenerated$3 = dependenciesParenthesisNode_generated, _dependenciesRangeNodeGenerated = dependenciesRangeNode_generated, _dependenciesRelationalNodeGenerated = dependenciesRelationalNode_generated, _dependenciesSymbolNodeGenerated$3 = dependenciesSymbolNode_generated, _dependenciesNumericGenerated$5 = dependenciesNumeric_generated, _dependenciesTypedGenerated$R = dependenciesTyped_generated, _factoriesAny$20 = factoriesAny, parseDependencies = {
  AccessorNodeDependencies: _dependenciesAccessorNodeGenerated.AccessorNodeDependencies,
  ArrayNodeDependencies: _dependenciesArrayNodeGenerated.ArrayNodeDependencies,
  AssignmentNodeDependencies: _dependenciesAssignmentNodeGenerated.AssignmentNodeDependencies,
  BlockNodeDependencies: _dependenciesBlockNodeGenerated.BlockNodeDependencies,
  ConditionalNodeDependencies: _dependenciesConditionalNodeGenerated.ConditionalNodeDependencies,
  ConstantNodeDependencies: _dependenciesConstantNodeGenerated$3.ConstantNodeDependencies,
  FunctionAssignmentNodeDependencies: _dependenciesFunctionAssignmentNodeGenerated.FunctionAssignmentNodeDependencies,
  FunctionNodeDependencies: _dependenciesFunctionNodeGenerated$3.FunctionNodeDependencies,
  IndexNodeDependencies: _dependenciesIndexNodeGenerated.IndexNodeDependencies,
  ObjectNodeDependencies: _dependenciesObjectNodeGenerated.ObjectNodeDependencies,
  OperatorNodeDependencies: _dependenciesOperatorNodeGenerated$3.OperatorNodeDependencies,
  ParenthesisNodeDependencies: _dependenciesParenthesisNodeGenerated$3.ParenthesisNodeDependencies,
  RangeNodeDependencies: _dependenciesRangeNodeGenerated.RangeNodeDependencies,
  RelationalNodeDependencies: _dependenciesRelationalNodeGenerated.RelationalNodeDependencies,
  SymbolNodeDependencies: _dependenciesSymbolNodeGenerated$3.SymbolNodeDependencies,
  numericDependencies: _dependenciesNumericGenerated$5.numericDependencies,
  typedDependencies: _dependenciesTypedGenerated$R.typedDependencies,
  createParse: _factoriesAny$20.createParse
};
dependenciesParse_generated.parseDependencies = parseDependencies;
var dependenciesCompile_generated = {};
Object.defineProperty(dependenciesCompile_generated, "__esModule", {
  value: !0
});
dependenciesCompile_generated.compileDependencies = void 0;
var _dependenciesParseGenerated$6 = dependenciesParse_generated, _dependenciesTypedGenerated$Q = dependenciesTyped_generated, _factoriesAny$1$ = factoriesAny, compileDependencies = {
  parseDependencies: _dependenciesParseGenerated$6.parseDependencies,
  typedDependencies: _dependenciesTypedGenerated$Q.typedDependencies,
  createCompile: _factoriesAny$1$.createCompile
};
dependenciesCompile_generated.compileDependencies = compileDependencies;
var dependenciesEvaluate_generated = {};
Object.defineProperty(dependenciesEvaluate_generated, "__esModule", {
  value: !0
});
dependenciesEvaluate_generated.evaluateDependencies = void 0;
var _dependenciesParseGenerated$5 = dependenciesParse_generated, _dependenciesTypedGenerated$P = dependenciesTyped_generated, _factoriesAny$1_ = factoriesAny, evaluateDependencies = {
  parseDependencies: _dependenciesParseGenerated$5.parseDependencies,
  typedDependencies: _dependenciesTypedGenerated$P.typedDependencies,
  createEvaluate: _factoriesAny$1_.createEvaluate
};
dependenciesEvaluate_generated.evaluateDependencies = evaluateDependencies;
var dependenciesParserClass_generated = {};
Object.defineProperty(dependenciesParserClass_generated, "__esModule", {
  value: !0
});
dependenciesParserClass_generated.ParserDependencies = void 0;
var _dependenciesParseGenerated$4 = dependenciesParse_generated, _factoriesAny$1Z = factoriesAny, ParserDependencies = {
  parseDependencies: _dependenciesParseGenerated$4.parseDependencies,
  createParserClass: _factoriesAny$1Z.createParserClass
};
dependenciesParserClass_generated.ParserDependencies = ParserDependencies;
var dependenciesParser_generated = {};
Object.defineProperty(dependenciesParser_generated, "__esModule", {
  value: !0
});
dependenciesParser_generated.parserDependencies = void 0;
var _dependenciesParserClassGenerated = dependenciesParserClass_generated, _dependenciesTypedGenerated$O = dependenciesTyped_generated, _factoriesAny$1Y = factoriesAny, parserDependencies = {
  ParserDependencies: _dependenciesParserClassGenerated.ParserDependencies,
  typedDependencies: _dependenciesTypedGenerated$O.typedDependencies,
  createParser: _factoriesAny$1Y.createParser
};
dependenciesParser_generated.parserDependencies = parserDependencies;
var dependenciesQr_generated = {};
Object.defineProperty(dependenciesQr_generated, "__esModule", {
  value: !0
});
dependenciesQr_generated.qrDependencies = void 0;
var _dependenciesAddScalarGenerated$6 = dependenciesAddScalar_generated, _dependenciesComplexGenerated = dependenciesComplex_generated, _dependenciesConjGenerated = dependenciesConj_generated, _dependenciesDivideScalarGenerated$6 = dependenciesDivideScalar_generated, _dependenciesEqualGenerated$3 = dependenciesEqual_generated, _dependenciesIdentityGenerated$2 = dependenciesIdentity_generated, _dependenciesIsZeroGenerated$3 = dependenciesIsZero_generated, _dependenciesMatrixGenerated$a = dependenciesMatrix_generated, _dependenciesMultiplyScalarGenerated$5 = dependenciesMultiplyScalar_generated, _dependenciesSignGenerated = dependenciesSign_generated, _dependenciesSqrtGenerated$4 = dependenciesSqrt_generated, _dependenciesSubtractGenerated$b = dependenciesSubtract_generated, _dependenciesTypedGenerated$N = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated$1 = dependenciesUnaryMinus_generated, _dependenciesZerosGenerated = dependenciesZeros_generated, _factoriesAny$1X = factoriesAny, qrDependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated$6.addScalarDependencies,
  complexDependencies: _dependenciesComplexGenerated.complexDependencies,
  conjDependencies: _dependenciesConjGenerated.conjDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$6.divideScalarDependencies,
  equalDependencies: _dependenciesEqualGenerated$3.equalDependencies,
  identityDependencies: _dependenciesIdentityGenerated$2.identityDependencies,
  isZeroDependencies: _dependenciesIsZeroGenerated$3.isZeroDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$a.matrixDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$5.multiplyScalarDependencies,
  signDependencies: _dependenciesSignGenerated.signDependencies,
  sqrtDependencies: _dependenciesSqrtGenerated$4.sqrtDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$b.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$N.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated$1.unaryMinusDependencies,
  zerosDependencies: _dependenciesZerosGenerated.zerosDependencies,
  createQr: _factoriesAny$1X.createQr
};
dependenciesQr_generated.qrDependencies = qrDependencies;
var dependenciesSlu_generated = {};
Object.defineProperty(dependenciesSlu_generated, "__esModule", {
  value: !0
});
dependenciesSlu_generated.sluDependencies = void 0;
var _dependenciesSparseMatrixClassGenerated = dependenciesSparseMatrixClass_generated, _dependenciesAbsGenerated$5 = dependenciesAbs_generated, _dependenciesAddGenerated$e = dependenciesAdd_generated, _dependenciesDivideScalarGenerated$5 = dependenciesDivideScalar_generated, _dependenciesLargerGenerated$4 = dependenciesLarger_generated, _dependenciesLargerEqGenerated$1 = dependenciesLargerEq_generated, _dependenciesMultiplyGenerated$b = dependenciesMultiply_generated, _dependenciesSubtractGenerated$a = dependenciesSubtract_generated, _dependenciesTransposeGenerated = dependenciesTranspose_generated, _dependenciesTypedGenerated$M = dependenciesTyped_generated, _factoriesAny$1W = factoriesAny, sluDependencies = {
  SparseMatrixDependencies: _dependenciesSparseMatrixClassGenerated.SparseMatrixDependencies,
  absDependencies: _dependenciesAbsGenerated$5.absDependencies,
  addDependencies: _dependenciesAddGenerated$e.addDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$5.divideScalarDependencies,
  largerDependencies: _dependenciesLargerGenerated$4.largerDependencies,
  largerEqDependencies: _dependenciesLargerEqGenerated$1.largerEqDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$b.multiplyDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$a.subtractDependencies,
  transposeDependencies: _dependenciesTransposeGenerated.transposeDependencies,
  typedDependencies: _dependenciesTypedGenerated$M.typedDependencies,
  createSlu: _factoriesAny$1W.createSlu
};
dependenciesSlu_generated.sluDependencies = sluDependencies;
var dependenciesLusolve_generated = {};
Object.defineProperty(dependenciesLusolve_generated, "__esModule", {
  value: !0
});
dependenciesLusolve_generated.lusolveDependencies = void 0;
var _dependenciesDenseMatrixClassGenerated = dependenciesDenseMatrixClass_generated, _dependenciesLsolveGenerated = dependenciesLsolve_generated, _dependenciesLupGenerated = dependenciesLup_generated, _dependenciesMatrixGenerated$9 = dependenciesMatrix_generated, _dependenciesSluGenerated = dependenciesSlu_generated, _dependenciesTypedGenerated$L = dependenciesTyped_generated, _dependenciesUsolveGenerated = dependenciesUsolve_generated, _factoriesAny$1V = factoriesAny, lusolveDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated.DenseMatrixDependencies,
  lsolveDependencies: _dependenciesLsolveGenerated.lsolveDependencies,
  lupDependencies: _dependenciesLupGenerated.lupDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$9.matrixDependencies,
  sluDependencies: _dependenciesSluGenerated.sluDependencies,
  typedDependencies: _dependenciesTypedGenerated$L.typedDependencies,
  usolveDependencies: _dependenciesUsolveGenerated.usolveDependencies,
  createLusolve: _factoriesAny$1V.createLusolve
};
dependenciesLusolve_generated.lusolveDependencies = lusolveDependencies;
var dependenciesHelpClass_generated = {};
Object.defineProperty(dependenciesHelpClass_generated, "__esModule", {
  value: !0
});
dependenciesHelpClass_generated.HelpDependencies = void 0;
var _dependenciesParseGenerated$3 = dependenciesParse_generated, _factoriesAny$1U = factoriesAny, HelpDependencies = {
  parseDependencies: _dependenciesParseGenerated$3.parseDependencies,
  createHelpClass: _factoriesAny$1U.createHelpClass
};
dependenciesHelpClass_generated.HelpDependencies = HelpDependencies;
var dependenciesChainClass_generated = {};
Object.defineProperty(dependenciesChainClass_generated, "__esModule", {
  value: !0
});
dependenciesChainClass_generated.ChainDependencies = void 0;
var _factoriesAny$1T = factoriesAny, ChainDependencies = {
  createChainClass: _factoriesAny$1T.createChainClass
};
dependenciesChainClass_generated.ChainDependencies = ChainDependencies;
var dependenciesHelp_generated = {};
Object.defineProperty(dependenciesHelp_generated, "__esModule", {
  value: !0
});
dependenciesHelp_generated.helpDependencies = void 0;
var _dependenciesHelpClassGenerated = dependenciesHelpClass_generated, _dependenciesTypedGenerated$K = dependenciesTyped_generated, _factoriesAny$1S = factoriesAny, helpDependencies = {
  HelpDependencies: _dependenciesHelpClassGenerated.HelpDependencies,
  typedDependencies: _dependenciesTypedGenerated$K.typedDependencies,
  createHelp: _factoriesAny$1S.createHelp
};
dependenciesHelp_generated.helpDependencies = helpDependencies;
var dependenciesChain_generated = {};
Object.defineProperty(dependenciesChain_generated, "__esModule", {
  value: !0
});
dependenciesChain_generated.chainDependencies = void 0;
var _dependenciesChainClassGenerated = dependenciesChainClass_generated, _dependenciesTypedGenerated$J = dependenciesTyped_generated, _factoriesAny$1R = factoriesAny, chainDependencies = {
  ChainDependencies: _dependenciesChainClassGenerated.ChainDependencies,
  typedDependencies: _dependenciesTypedGenerated$J.typedDependencies,
  createChain: _factoriesAny$1R.createChain
};
dependenciesChain_generated.chainDependencies = chainDependencies;
var dependenciesExpm_generated = {};
Object.defineProperty(dependenciesExpm_generated, "__esModule", {
  value: !0
});
dependenciesExpm_generated.expmDependencies = void 0;
var _dependenciesAbsGenerated$4 = dependenciesAbs_generated, _dependenciesAddGenerated$d = dependenciesAdd_generated, _dependenciesIdentityGenerated$1 = dependenciesIdentity_generated, _dependenciesInvGenerated$2 = dependenciesInv_generated, _dependenciesMultiplyGenerated$a = dependenciesMultiply_generated, _dependenciesTypedGenerated$I = dependenciesTyped_generated, _factoriesAny$1Q = factoriesAny, expmDependencies = {
  absDependencies: _dependenciesAbsGenerated$4.absDependencies,
  addDependencies: _dependenciesAddGenerated$d.addDependencies,
  identityDependencies: _dependenciesIdentityGenerated$1.identityDependencies,
  invDependencies: _dependenciesInvGenerated$2.invDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$a.multiplyDependencies,
  typedDependencies: _dependenciesTypedGenerated$I.typedDependencies,
  createExpm: _factoriesAny$1Q.createExpm
};
dependenciesExpm_generated.expmDependencies = expmDependencies;
var dependenciesSqrtm_generated = {};
Object.defineProperty(dependenciesSqrtm_generated, "__esModule", {
  value: !0
});
dependenciesSqrtm_generated.sqrtmDependencies = void 0;
var _dependenciesAbsGenerated$3 = dependenciesAbs_generated, _dependenciesAddGenerated$c = dependenciesAdd_generated, _dependenciesIdentityGenerated = dependenciesIdentity_generated, _dependenciesInvGenerated$1 = dependenciesInv_generated, _dependenciesMaxGenerated = dependenciesMax_generated, _dependenciesMultiplyGenerated$9 = dependenciesMultiply_generated, _dependenciesSizeGenerated = dependenciesSize_generated, _dependenciesSqrtGenerated$3 = dependenciesSqrt_generated, _dependenciesSubtractGenerated$9 = dependenciesSubtract_generated, _dependenciesTypedGenerated$H = dependenciesTyped_generated, _factoriesAny$1P = factoriesAny, sqrtmDependencies = {
  absDependencies: _dependenciesAbsGenerated$3.absDependencies,
  addDependencies: _dependenciesAddGenerated$c.addDependencies,
  identityDependencies: _dependenciesIdentityGenerated.identityDependencies,
  invDependencies: _dependenciesInvGenerated$1.invDependencies,
  maxDependencies: _dependenciesMaxGenerated.maxDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$9.multiplyDependencies,
  sizeDependencies: _dependenciesSizeGenerated.sizeDependencies,
  sqrtDependencies: _dependenciesSqrtGenerated$3.sqrtDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$9.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$H.typedDependencies,
  createSqrtm: _factoriesAny$1P.createSqrtm
};
dependenciesSqrtm_generated.sqrtmDependencies = sqrtmDependencies;
var dependenciesDivide_generated = {};
Object.defineProperty(dependenciesDivide_generated, "__esModule", {
  value: !0
});
dependenciesDivide_generated.divideDependencies = void 0;
var _dependenciesDivideScalarGenerated$4 = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated$1 = dependenciesEqualScalar_generated, _dependenciesInvGenerated = dependenciesInv_generated, _dependenciesMatrixGenerated$8 = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$8 = dependenciesMultiply_generated, _dependenciesTypedGenerated$G = dependenciesTyped_generated, _factoriesAny$1O = factoriesAny, divideDependencies = {
  divideScalarDependencies: _dependenciesDivideScalarGenerated$4.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated$1.equalScalarDependencies,
  invDependencies: _dependenciesInvGenerated.invDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$8.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$8.multiplyDependencies,
  typedDependencies: _dependenciesTypedGenerated$G.typedDependencies,
  createDivide: _factoriesAny$1O.createDivide
};
dependenciesDivide_generated.divideDependencies = divideDependencies;
var dependenciesDistance_generated = {};
Object.defineProperty(dependenciesDistance_generated, "__esModule", {
  value: !0
});
dependenciesDistance_generated.distanceDependencies = void 0;
var _dependenciesAbsGenerated$2 = dependenciesAbs_generated, _dependenciesAddScalarGenerated$5 = dependenciesAddScalar_generated, _dependenciesDivideScalarGenerated$3 = dependenciesDivideScalar_generated, _dependenciesMultiplyScalarGenerated$4 = dependenciesMultiplyScalar_generated, _dependenciesSqrtGenerated$2 = dependenciesSqrt_generated, _dependenciesSubtractGenerated$8 = dependenciesSubtract_generated, _dependenciesTypedGenerated$F = dependenciesTyped_generated, _dependenciesUnaryMinusGenerated = dependenciesUnaryMinus_generated, _factoriesAny$1N = factoriesAny, distanceDependencies = {
  absDependencies: _dependenciesAbsGenerated$2.absDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$5.addScalarDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$3.divideScalarDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$4.multiplyScalarDependencies,
  sqrtDependencies: _dependenciesSqrtGenerated$2.sqrtDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$8.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$F.typedDependencies,
  unaryMinusDependencies: _dependenciesUnaryMinusGenerated.unaryMinusDependencies,
  createDistance: _factoriesAny$1N.createDistance
};
dependenciesDistance_generated.distanceDependencies = distanceDependencies;
var dependenciesIntersect_generated = {};
Object.defineProperty(dependenciesIntersect_generated, "__esModule", {
  value: !0
});
dependenciesIntersect_generated.intersectDependencies = void 0;
var _dependenciesAbsGenerated$1 = dependenciesAbs_generated, _dependenciesAddGenerated$b = dependenciesAdd_generated, _dependenciesAddScalarGenerated$4 = dependenciesAddScalar_generated, _dependenciesDivideScalarGenerated$2 = dependenciesDivideScalar_generated, _dependenciesEqualScalarGenerated = dependenciesEqualScalar_generated, _dependenciesMatrixGenerated$7 = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$7 = dependenciesMultiply_generated, _dependenciesMultiplyScalarGenerated$3 = dependenciesMultiplyScalar_generated, _dependenciesSmallerGenerated$2 = dependenciesSmaller_generated, _dependenciesSubtractGenerated$7 = dependenciesSubtract_generated, _dependenciesTypedGenerated$E = dependenciesTyped_generated, _factoriesAny$1M = factoriesAny, intersectDependencies = {
  absDependencies: _dependenciesAbsGenerated$1.absDependencies,
  addDependencies: _dependenciesAddGenerated$b.addDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated$4.addScalarDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$2.divideScalarDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated.equalScalarDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$7.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$7.multiplyDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$3.multiplyScalarDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$2.smallerDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$7.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$E.typedDependencies,
  createIntersect: _factoriesAny$1M.createIntersect
};
dependenciesIntersect_generated.intersectDependencies = intersectDependencies;
var dependenciesSum_generated = {};
Object.defineProperty(dependenciesSum_generated, "__esModule", {
  value: !0
});
dependenciesSum_generated.sumDependencies = void 0;
var _dependenciesAddGenerated$a = dependenciesAdd_generated, _dependenciesNumericGenerated$4 = dependenciesNumeric_generated, _dependenciesTypedGenerated$D = dependenciesTyped_generated, _factoriesAny$1L = factoriesAny, sumDependencies = {
  addDependencies: _dependenciesAddGenerated$a.addDependencies,
  numericDependencies: _dependenciesNumericGenerated$4.numericDependencies,
  typedDependencies: _dependenciesTypedGenerated$D.typedDependencies,
  createSum: _factoriesAny$1L.createSum
};
dependenciesSum_generated.sumDependencies = sumDependencies;
var dependenciesMean_generated = {};
Object.defineProperty(dependenciesMean_generated, "__esModule", {
  value: !0
});
dependenciesMean_generated.meanDependencies = void 0;
var _dependenciesAddGenerated$9 = dependenciesAdd_generated, _dependenciesDivideGenerated$8 = dependenciesDivide_generated, _dependenciesTypedGenerated$C = dependenciesTyped_generated, _factoriesAny$1K = factoriesAny, meanDependencies = {
  addDependencies: _dependenciesAddGenerated$9.addDependencies,
  divideDependencies: _dependenciesDivideGenerated$8.divideDependencies,
  typedDependencies: _dependenciesTypedGenerated$C.typedDependencies,
  createMean: _factoriesAny$1K.createMean
};
dependenciesMean_generated.meanDependencies = meanDependencies;
var dependenciesMedian_generated = {};
Object.defineProperty(dependenciesMedian_generated, "__esModule", {
  value: !0
});
dependenciesMedian_generated.medianDependencies = void 0;
var _dependenciesAddGenerated$8 = dependenciesAdd_generated, _dependenciesCompareGenerated$1 = dependenciesCompare_generated, _dependenciesDivideGenerated$7 = dependenciesDivide_generated, _dependenciesPartitionSelectGenerated$1 = dependenciesPartitionSelect_generated, _dependenciesTypedGenerated$B = dependenciesTyped_generated, _factoriesAny$1J = factoriesAny, medianDependencies = {
  addDependencies: _dependenciesAddGenerated$8.addDependencies,
  compareDependencies: _dependenciesCompareGenerated$1.compareDependencies,
  divideDependencies: _dependenciesDivideGenerated$7.divideDependencies,
  partitionSelectDependencies: _dependenciesPartitionSelectGenerated$1.partitionSelectDependencies,
  typedDependencies: _dependenciesTypedGenerated$B.typedDependencies,
  createMedian: _factoriesAny$1J.createMedian
};
dependenciesMedian_generated.medianDependencies = medianDependencies;
var dependenciesMad_generated = {};
Object.defineProperty(dependenciesMad_generated, "__esModule", {
  value: !0
});
dependenciesMad_generated.madDependencies = void 0;
var _dependenciesAbsGenerated = dependenciesAbs_generated, _dependenciesMapGenerated = dependenciesMap_generated, _dependenciesMedianGenerated = dependenciesMedian_generated, _dependenciesSubtractGenerated$6 = dependenciesSubtract_generated, _dependenciesTypedGenerated$A = dependenciesTyped_generated, _factoriesAny$1I = factoriesAny, madDependencies = {
  absDependencies: _dependenciesAbsGenerated.absDependencies,
  mapDependencies: _dependenciesMapGenerated.mapDependencies,
  medianDependencies: _dependenciesMedianGenerated.medianDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$6.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$A.typedDependencies,
  createMad: _factoriesAny$1I.createMad
};
dependenciesMad_generated.madDependencies = madDependencies;
var dependenciesVariance_generated = {};
Object.defineProperty(dependenciesVariance_generated, "__esModule", {
  value: !0
});
dependenciesVariance_generated.varianceDependencies = void 0;
var _dependenciesAddGenerated$7 = dependenciesAdd_generated, _dependenciesApplyGenerated$1 = dependenciesApply_generated, _dependenciesDivideGenerated$6 = dependenciesDivide_generated, _dependenciesIsNaNGenerated$1 = dependenciesIsNaN_generated, _dependenciesMultiplyGenerated$6 = dependenciesMultiply_generated, _dependenciesSubtractGenerated$5 = dependenciesSubtract_generated, _dependenciesTypedGenerated$z = dependenciesTyped_generated, _factoriesAny$1H = factoriesAny, varianceDependencies = {
  addDependencies: _dependenciesAddGenerated$7.addDependencies,
  applyDependencies: _dependenciesApplyGenerated$1.applyDependencies,
  divideDependencies: _dependenciesDivideGenerated$6.divideDependencies,
  isNaNDependencies: _dependenciesIsNaNGenerated$1.isNaNDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$6.multiplyDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$5.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$z.typedDependencies,
  createVariance: _factoriesAny$1H.createVariance
};
dependenciesVariance_generated.varianceDependencies = varianceDependencies;
var dependenciesQuantileSeq_generated = {};
Object.defineProperty(dependenciesQuantileSeq_generated, "__esModule", {
  value: !0
});
dependenciesQuantileSeq_generated.quantileSeqDependencies = void 0;
var _dependenciesAddGenerated$6 = dependenciesAdd_generated, _dependenciesCompareGenerated = dependenciesCompare_generated, _dependenciesMultiplyGenerated$5 = dependenciesMultiply_generated, _dependenciesPartitionSelectGenerated = dependenciesPartitionSelect_generated, _dependenciesTypedGenerated$y = dependenciesTyped_generated, _factoriesAny$1G = factoriesAny, quantileSeqDependencies = {
  addDependencies: _dependenciesAddGenerated$6.addDependencies,
  compareDependencies: _dependenciesCompareGenerated.compareDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$5.multiplyDependencies,
  partitionSelectDependencies: _dependenciesPartitionSelectGenerated.partitionSelectDependencies,
  typedDependencies: _dependenciesTypedGenerated$y.typedDependencies,
  createQuantileSeq: _factoriesAny$1G.createQuantileSeq
};
dependenciesQuantileSeq_generated.quantileSeqDependencies = quantileSeqDependencies;
var dependenciesStd_generated = {};
Object.defineProperty(dependenciesStd_generated, "__esModule", {
  value: !0
});
dependenciesStd_generated.stdDependencies = void 0;
var _dependenciesSqrtGenerated$1 = dependenciesSqrt_generated, _dependenciesTypedGenerated$x = dependenciesTyped_generated, _dependenciesVarianceGenerated$1 = dependenciesVariance_generated, _factoriesAny$1F = factoriesAny, stdDependencies = {
  sqrtDependencies: _dependenciesSqrtGenerated$1.sqrtDependencies,
  typedDependencies: _dependenciesTypedGenerated$x.typedDependencies,
  varianceDependencies: _dependenciesVarianceGenerated$1.varianceDependencies,
  createStd: _factoriesAny$1F.createStd
};
dependenciesStd_generated.stdDependencies = stdDependencies;
var dependenciesCombinations_generated = {};
Object.defineProperty(dependenciesCombinations_generated, "__esModule", {
  value: !0
});
dependenciesCombinations_generated.combinationsDependencies = void 0;
var _dependenciesTypedGenerated$w = dependenciesTyped_generated, _factoriesAny$1E = factoriesAny, combinationsDependencies = {
  typedDependencies: _dependenciesTypedGenerated$w.typedDependencies,
  createCombinations: _factoriesAny$1E.createCombinations
};
dependenciesCombinations_generated.combinationsDependencies = combinationsDependencies;
var dependenciesCombinationsWithRep_generated = {};
Object.defineProperty(dependenciesCombinationsWithRep_generated, "__esModule", {
  value: !0
});
dependenciesCombinationsWithRep_generated.combinationsWithRepDependencies = void 0;
var _dependenciesTypedGenerated$v = dependenciesTyped_generated, _factoriesAny$1D = factoriesAny, combinationsWithRepDependencies = {
  typedDependencies: _dependenciesTypedGenerated$v.typedDependencies,
  createCombinationsWithRep: _factoriesAny$1D.createCombinationsWithRep
};
dependenciesCombinationsWithRep_generated.combinationsWithRepDependencies = combinationsWithRepDependencies;
var dependenciesGamma_generated = {};
Object.defineProperty(dependenciesGamma_generated, "__esModule", {
  value: !0
});
dependenciesGamma_generated.gammaDependencies = void 0;
var _dependenciesBigNumberClassGenerated$_ = dependenciesBigNumberClass_generated, _dependenciesComplexClassGenerated$1 = dependenciesComplexClass_generated, _dependenciesMultiplyScalarGenerated$2 = dependenciesMultiplyScalar_generated, _dependenciesPowGenerated$3 = dependenciesPow_generated, _dependenciesTypedGenerated$u = dependenciesTyped_generated, _factoriesAny$1C = factoriesAny, gammaDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$_.BigNumberDependencies,
  ComplexDependencies: _dependenciesComplexClassGenerated$1.ComplexDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$2.multiplyScalarDependencies,
  powDependencies: _dependenciesPowGenerated$3.powDependencies,
  typedDependencies: _dependenciesTypedGenerated$u.typedDependencies,
  createGamma: _factoriesAny$1C.createGamma
};
dependenciesGamma_generated.gammaDependencies = gammaDependencies;
var dependenciesFactorial_generated = {};
Object.defineProperty(dependenciesFactorial_generated, "__esModule", {
  value: !0
});
dependenciesFactorial_generated.factorialDependencies = void 0;
var _dependenciesGammaGenerated = dependenciesGamma_generated, _dependenciesTypedGenerated$t = dependenciesTyped_generated, _factoriesAny$1B = factoriesAny, factorialDependencies = {
  gammaDependencies: _dependenciesGammaGenerated.gammaDependencies,
  typedDependencies: _dependenciesTypedGenerated$t.typedDependencies,
  createFactorial: _factoriesAny$1B.createFactorial
};
dependenciesFactorial_generated.factorialDependencies = factorialDependencies;
var dependenciesKldivergence_generated = {};
Object.defineProperty(dependenciesKldivergence_generated, "__esModule", {
  value: !0
});
dependenciesKldivergence_generated.kldivergenceDependencies = void 0;
var _dependenciesDivideGenerated$5 = dependenciesDivide_generated, _dependenciesDotDivideGenerated = dependenciesDotDivide_generated, _dependenciesIsNumericGenerated = dependenciesIsNumeric_generated, _dependenciesLogGenerated = dependenciesLog_generated, _dependenciesMatrixGenerated$6 = dependenciesMatrix_generated, _dependenciesMultiplyGenerated$4 = dependenciesMultiply_generated, _dependenciesSumGenerated = dependenciesSum_generated, _dependenciesTypedGenerated$s = dependenciesTyped_generated, _factoriesAny$1A = factoriesAny, kldivergenceDependencies = {
  divideDependencies: _dependenciesDivideGenerated$5.divideDependencies,
  dotDivideDependencies: _dependenciesDotDivideGenerated.dotDivideDependencies,
  isNumericDependencies: _dependenciesIsNumericGenerated.isNumericDependencies,
  logDependencies: _dependenciesLogGenerated.logDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$6.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$4.multiplyDependencies,
  sumDependencies: _dependenciesSumGenerated.sumDependencies,
  typedDependencies: _dependenciesTypedGenerated$s.typedDependencies,
  createKldivergence: _factoriesAny$1A.createKldivergence
};
dependenciesKldivergence_generated.kldivergenceDependencies = kldivergenceDependencies;
var dependenciesMultinomial_generated = {};
Object.defineProperty(dependenciesMultinomial_generated, "__esModule", {
  value: !0
});
dependenciesMultinomial_generated.multinomialDependencies = void 0;
var _dependenciesAddGenerated$5 = dependenciesAdd_generated, _dependenciesDivideGenerated$4 = dependenciesDivide_generated, _dependenciesFactorialGenerated$2 = dependenciesFactorial_generated, _dependenciesIsIntegerGenerated$6 = dependenciesIsInteger_generated, _dependenciesIsPositiveGenerated$1 = dependenciesIsPositive_generated, _dependenciesMultiplyGenerated$3 = dependenciesMultiply_generated, _dependenciesTypedGenerated$r = dependenciesTyped_generated, _factoriesAny$1z = factoriesAny, multinomialDependencies = {
  addDependencies: _dependenciesAddGenerated$5.addDependencies,
  divideDependencies: _dependenciesDivideGenerated$4.divideDependencies,
  factorialDependencies: _dependenciesFactorialGenerated$2.factorialDependencies,
  isIntegerDependencies: _dependenciesIsIntegerGenerated$6.isIntegerDependencies,
  isPositiveDependencies: _dependenciesIsPositiveGenerated$1.isPositiveDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$3.multiplyDependencies,
  typedDependencies: _dependenciesTypedGenerated$r.typedDependencies,
  createMultinomial: _factoriesAny$1z.createMultinomial
};
dependenciesMultinomial_generated.multinomialDependencies = multinomialDependencies;
var dependenciesPermutations_generated = {};
Object.defineProperty(dependenciesPermutations_generated, "__esModule", {
  value: !0
});
dependenciesPermutations_generated.permutationsDependencies = void 0;
var _dependenciesFactorialGenerated$1 = dependenciesFactorial_generated, _dependenciesTypedGenerated$q = dependenciesTyped_generated, _factoriesAny$1y = factoriesAny, permutationsDependencies = {
  factorialDependencies: _dependenciesFactorialGenerated$1.factorialDependencies,
  typedDependencies: _dependenciesTypedGenerated$q.typedDependencies,
  createPermutations: _factoriesAny$1y.createPermutations
};
dependenciesPermutations_generated.permutationsDependencies = permutationsDependencies;
var dependenciesPickRandom_generated = {};
Object.defineProperty(dependenciesPickRandom_generated, "__esModule", {
  value: !0
});
dependenciesPickRandom_generated.pickRandomDependencies = void 0;
var _dependenciesTypedGenerated$p = dependenciesTyped_generated, _factoriesAny$1x = factoriesAny, pickRandomDependencies = {
  typedDependencies: _dependenciesTypedGenerated$p.typedDependencies,
  createPickRandom: _factoriesAny$1x.createPickRandom
};
dependenciesPickRandom_generated.pickRandomDependencies = pickRandomDependencies;
var dependenciesRandom_generated = {};
Object.defineProperty(dependenciesRandom_generated, "__esModule", {
  value: !0
});
dependenciesRandom_generated.randomDependencies = void 0;
var _dependenciesTypedGenerated$o = dependenciesTyped_generated, _factoriesAny$1w = factoriesAny, randomDependencies = {
  typedDependencies: _dependenciesTypedGenerated$o.typedDependencies,
  createRandom: _factoriesAny$1w.createRandom
};
dependenciesRandom_generated.randomDependencies = randomDependencies;
var dependenciesRandomInt_generated = {};
Object.defineProperty(dependenciesRandomInt_generated, "__esModule", {
  value: !0
});
dependenciesRandomInt_generated.randomIntDependencies = void 0;
var _dependenciesTypedGenerated$n = dependenciesTyped_generated, _factoriesAny$1v = factoriesAny, randomIntDependencies = {
  typedDependencies: _dependenciesTypedGenerated$n.typedDependencies,
  createRandomInt: _factoriesAny$1v.createRandomInt
};
dependenciesRandomInt_generated.randomIntDependencies = randomIntDependencies;
var dependenciesStirlingS2_generated = {};
Object.defineProperty(dependenciesStirlingS2_generated, "__esModule", {
  value: !0
});
dependenciesStirlingS2_generated.stirlingS2Dependencies = void 0;
var _dependenciesAddScalarGenerated$3 = dependenciesAddScalar_generated, _dependenciesCombinationsGenerated$2 = dependenciesCombinations_generated, _dependenciesDivideScalarGenerated$1 = dependenciesDivideScalar_generated, _dependenciesFactorialGenerated = dependenciesFactorial_generated, _dependenciesIsIntegerGenerated$5 = dependenciesIsInteger_generated, _dependenciesIsNegativeGenerated$3 = dependenciesIsNegative_generated, _dependenciesLargerGenerated$3 = dependenciesLarger_generated, _dependenciesMultiplyScalarGenerated$1 = dependenciesMultiplyScalar_generated, _dependenciesPowGenerated$2 = dependenciesPow_generated, _dependenciesSubtractGenerated$4 = dependenciesSubtract_generated, _dependenciesTypedGenerated$m = dependenciesTyped_generated, _factoriesAny$1u = factoriesAny, stirlingS2Dependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated$3.addScalarDependencies,
  combinationsDependencies: _dependenciesCombinationsGenerated$2.combinationsDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated$1.divideScalarDependencies,
  factorialDependencies: _dependenciesFactorialGenerated.factorialDependencies,
  isIntegerDependencies: _dependenciesIsIntegerGenerated$5.isIntegerDependencies,
  isNegativeDependencies: _dependenciesIsNegativeGenerated$3.isNegativeDependencies,
  largerDependencies: _dependenciesLargerGenerated$3.largerDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated$1.multiplyScalarDependencies,
  powDependencies: _dependenciesPowGenerated$2.powDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$4.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$m.typedDependencies,
  createStirlingS2: _factoriesAny$1u.createStirlingS2
};
dependenciesStirlingS2_generated.stirlingS2Dependencies = stirlingS2Dependencies;
var dependenciesBellNumbers_generated = {};
Object.defineProperty(dependenciesBellNumbers_generated, "__esModule", {
  value: !0
});
dependenciesBellNumbers_generated.bellNumbersDependencies = void 0;
var _dependenciesAddScalarGenerated$2 = dependenciesAddScalar_generated, _dependenciesIsIntegerGenerated$4 = dependenciesIsInteger_generated, _dependenciesIsNegativeGenerated$2 = dependenciesIsNegative_generated, _dependenciesStirlingS2Generated = dependenciesStirlingS2_generated, _dependenciesTypedGenerated$l = dependenciesTyped_generated, _factoriesAny$1t = factoriesAny, bellNumbersDependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated$2.addScalarDependencies,
  isIntegerDependencies: _dependenciesIsIntegerGenerated$4.isIntegerDependencies,
  isNegativeDependencies: _dependenciesIsNegativeGenerated$2.isNegativeDependencies,
  stirlingS2Dependencies: _dependenciesStirlingS2Generated.stirlingS2Dependencies,
  typedDependencies: _dependenciesTypedGenerated$l.typedDependencies,
  createBellNumbers: _factoriesAny$1t.createBellNumbers
};
dependenciesBellNumbers_generated.bellNumbersDependencies = bellNumbersDependencies;
var dependenciesCatalan_generated = {};
Object.defineProperty(dependenciesCatalan_generated, "__esModule", {
  value: !0
});
dependenciesCatalan_generated.catalanDependencies = void 0;
var _dependenciesAddScalarGenerated$1 = dependenciesAddScalar_generated, _dependenciesCombinationsGenerated$1 = dependenciesCombinations_generated, _dependenciesDivideScalarGenerated = dependenciesDivideScalar_generated, _dependenciesIsIntegerGenerated$3 = dependenciesIsInteger_generated, _dependenciesIsNegativeGenerated$1 = dependenciesIsNegative_generated, _dependenciesMultiplyScalarGenerated = dependenciesMultiplyScalar_generated, _dependenciesTypedGenerated$k = dependenciesTyped_generated, _factoriesAny$1s = factoriesAny, catalanDependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated$1.addScalarDependencies,
  combinationsDependencies: _dependenciesCombinationsGenerated$1.combinationsDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated.divideScalarDependencies,
  isIntegerDependencies: _dependenciesIsIntegerGenerated$3.isIntegerDependencies,
  isNegativeDependencies: _dependenciesIsNegativeGenerated$1.isNegativeDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated.multiplyScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated$k.typedDependencies,
  createCatalan: _factoriesAny$1s.createCatalan
};
dependenciesCatalan_generated.catalanDependencies = catalanDependencies;
var dependenciesComposition_generated = {};
Object.defineProperty(dependenciesComposition_generated, "__esModule", {
  value: !0
});
dependenciesComposition_generated.compositionDependencies = void 0;
var _dependenciesAddScalarGenerated = dependenciesAddScalar_generated, _dependenciesCombinationsGenerated = dependenciesCombinations_generated, _dependenciesIsIntegerGenerated$2 = dependenciesIsInteger_generated, _dependenciesIsNegativeGenerated = dependenciesIsNegative_generated, _dependenciesIsPositiveGenerated = dependenciesIsPositive_generated, _dependenciesLargerGenerated$2 = dependenciesLarger_generated, _dependenciesTypedGenerated$j = dependenciesTyped_generated, _factoriesAny$1r = factoriesAny, compositionDependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated.addScalarDependencies,
  combinationsDependencies: _dependenciesCombinationsGenerated.combinationsDependencies,
  isIntegerDependencies: _dependenciesIsIntegerGenerated$2.isIntegerDependencies,
  isNegativeDependencies: _dependenciesIsNegativeGenerated.isNegativeDependencies,
  isPositiveDependencies: _dependenciesIsPositiveGenerated.isPositiveDependencies,
  largerDependencies: _dependenciesLargerGenerated$2.largerDependencies,
  typedDependencies: _dependenciesTypedGenerated$j.typedDependencies,
  createComposition: _factoriesAny$1r.createComposition
};
dependenciesComposition_generated.compositionDependencies = compositionDependencies;
var dependenciesSimplify_generated = {};
Object.defineProperty(dependenciesSimplify_generated, "__esModule", {
  value: !0
});
dependenciesSimplify_generated.simplifyDependencies = void 0;
var _dependenciesBignumberGenerated$3 = dependenciesBignumber_generated, _dependenciesFractionGenerated$1 = dependenciesFraction_generated, _dependenciesConstantNodeGenerated$2 = dependenciesConstantNode_generated, _dependenciesFunctionNodeGenerated$2 = dependenciesFunctionNode_generated, _dependenciesOperatorNodeGenerated$2 = dependenciesOperatorNode_generated, _dependenciesParenthesisNodeGenerated$2 = dependenciesParenthesisNode_generated, _dependenciesSymbolNodeGenerated$2 = dependenciesSymbolNode_generated, _dependenciesAddGenerated$4 = dependenciesAdd_generated, _dependenciesDivideGenerated$3 = dependenciesDivide_generated, _dependenciesEqualGenerated$2 = dependenciesEqual_generated, _dependenciesIsZeroGenerated$2 = dependenciesIsZero_generated, _dependenciesMultiplyGenerated$2 = dependenciesMultiply_generated, _dependenciesParseGenerated$2 = dependenciesParse_generated, _dependenciesPowGenerated$1 = dependenciesPow_generated, _dependenciesSubtractGenerated$3 = dependenciesSubtract_generated, _dependenciesTypedGenerated$i = dependenciesTyped_generated, _factoriesAny$1q = factoriesAny, simplifyDependencies = {
  bignumberDependencies: _dependenciesBignumberGenerated$3.bignumberDependencies,
  fractionDependencies: _dependenciesFractionGenerated$1.fractionDependencies,
  ConstantNodeDependencies: _dependenciesConstantNodeGenerated$2.ConstantNodeDependencies,
  FunctionNodeDependencies: _dependenciesFunctionNodeGenerated$2.FunctionNodeDependencies,
  OperatorNodeDependencies: _dependenciesOperatorNodeGenerated$2.OperatorNodeDependencies,
  ParenthesisNodeDependencies: _dependenciesParenthesisNodeGenerated$2.ParenthesisNodeDependencies,
  SymbolNodeDependencies: _dependenciesSymbolNodeGenerated$2.SymbolNodeDependencies,
  addDependencies: _dependenciesAddGenerated$4.addDependencies,
  divideDependencies: _dependenciesDivideGenerated$3.divideDependencies,
  equalDependencies: _dependenciesEqualGenerated$2.equalDependencies,
  isZeroDependencies: _dependenciesIsZeroGenerated$2.isZeroDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$2.multiplyDependencies,
  parseDependencies: _dependenciesParseGenerated$2.parseDependencies,
  powDependencies: _dependenciesPowGenerated$1.powDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$3.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$i.typedDependencies,
  createSimplify: _factoriesAny$1q.createSimplify
};
dependenciesSimplify_generated.simplifyDependencies = simplifyDependencies;
var dependenciesDerivative_generated = {};
Object.defineProperty(dependenciesDerivative_generated, "__esModule", {
  value: !0
});
dependenciesDerivative_generated.derivativeDependencies = void 0;
var _dependenciesConstantNodeGenerated$1 = dependenciesConstantNode_generated, _dependenciesFunctionNodeGenerated$1 = dependenciesFunctionNode_generated, _dependenciesOperatorNodeGenerated$1 = dependenciesOperatorNode_generated, _dependenciesParenthesisNodeGenerated$1 = dependenciesParenthesisNode_generated, _dependenciesSymbolNodeGenerated$1 = dependenciesSymbolNode_generated, _dependenciesEqualGenerated$1 = dependenciesEqual_generated, _dependenciesIsZeroGenerated$1 = dependenciesIsZero_generated, _dependenciesNumericGenerated$3 = dependenciesNumeric_generated, _dependenciesParseGenerated$1 = dependenciesParse_generated, _dependenciesSimplifyGenerated$1 = dependenciesSimplify_generated, _dependenciesTypedGenerated$h = dependenciesTyped_generated, _factoriesAny$1p = factoriesAny, derivativeDependencies = {
  ConstantNodeDependencies: _dependenciesConstantNodeGenerated$1.ConstantNodeDependencies,
  FunctionNodeDependencies: _dependenciesFunctionNodeGenerated$1.FunctionNodeDependencies,
  OperatorNodeDependencies: _dependenciesOperatorNodeGenerated$1.OperatorNodeDependencies,
  ParenthesisNodeDependencies: _dependenciesParenthesisNodeGenerated$1.ParenthesisNodeDependencies,
  SymbolNodeDependencies: _dependenciesSymbolNodeGenerated$1.SymbolNodeDependencies,
  equalDependencies: _dependenciesEqualGenerated$1.equalDependencies,
  isZeroDependencies: _dependenciesIsZeroGenerated$1.isZeroDependencies,
  numericDependencies: _dependenciesNumericGenerated$3.numericDependencies,
  parseDependencies: _dependenciesParseGenerated$1.parseDependencies,
  simplifyDependencies: _dependenciesSimplifyGenerated$1.simplifyDependencies,
  typedDependencies: _dependenciesTypedGenerated$h.typedDependencies,
  createDerivative: _factoriesAny$1p.createDerivative
};
dependenciesDerivative_generated.derivativeDependencies = derivativeDependencies;
var dependenciesRationalize_generated = {};
Object.defineProperty(dependenciesRationalize_generated, "__esModule", {
  value: !0
});
dependenciesRationalize_generated.rationalizeDependencies = void 0;
var _dependenciesBignumberGenerated$2 = dependenciesBignumber_generated, _dependenciesFractionGenerated = dependenciesFraction_generated, _dependenciesConstantNodeGenerated = dependenciesConstantNode_generated, _dependenciesFunctionNodeGenerated = dependenciesFunctionNode_generated, _dependenciesOperatorNodeGenerated = dependenciesOperatorNode_generated, _dependenciesParenthesisNodeGenerated = dependenciesParenthesisNode_generated, _dependenciesSymbolNodeGenerated = dependenciesSymbolNode_generated, _dependenciesAddGenerated$3 = dependenciesAdd_generated, _dependenciesDivideGenerated$2 = dependenciesDivide_generated, _dependenciesEqualGenerated = dependenciesEqual_generated, _dependenciesIsZeroGenerated = dependenciesIsZero_generated, _dependenciesMultiplyGenerated$1 = dependenciesMultiply_generated, _dependenciesParseGenerated = dependenciesParse_generated, _dependenciesPowGenerated = dependenciesPow_generated, _dependenciesSimplifyGenerated = dependenciesSimplify_generated, _dependenciesSubtractGenerated$2 = dependenciesSubtract_generated, _dependenciesTypedGenerated$g = dependenciesTyped_generated, _factoriesAny$1o = factoriesAny, rationalizeDependencies = {
  bignumberDependencies: _dependenciesBignumberGenerated$2.bignumberDependencies,
  fractionDependencies: _dependenciesFractionGenerated.fractionDependencies,
  ConstantNodeDependencies: _dependenciesConstantNodeGenerated.ConstantNodeDependencies,
  FunctionNodeDependencies: _dependenciesFunctionNodeGenerated.FunctionNodeDependencies,
  OperatorNodeDependencies: _dependenciesOperatorNodeGenerated.OperatorNodeDependencies,
  ParenthesisNodeDependencies: _dependenciesParenthesisNodeGenerated.ParenthesisNodeDependencies,
  SymbolNodeDependencies: _dependenciesSymbolNodeGenerated.SymbolNodeDependencies,
  addDependencies: _dependenciesAddGenerated$3.addDependencies,
  divideDependencies: _dependenciesDivideGenerated$2.divideDependencies,
  equalDependencies: _dependenciesEqualGenerated.equalDependencies,
  isZeroDependencies: _dependenciesIsZeroGenerated.isZeroDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated$1.multiplyDependencies,
  parseDependencies: _dependenciesParseGenerated.parseDependencies,
  powDependencies: _dependenciesPowGenerated.powDependencies,
  simplifyDependencies: _dependenciesSimplifyGenerated.simplifyDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$2.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$g.typedDependencies,
  createRationalize: _factoriesAny$1o.createRationalize
};
dependenciesRationalize_generated.rationalizeDependencies = rationalizeDependencies;
var dependenciesReviver_generated = {};
Object.defineProperty(dependenciesReviver_generated, "__esModule", {
  value: !0
});
dependenciesReviver_generated.reviverDependencies = void 0;
var _factoriesAny$1n = factoriesAny, reviverDependencies = {
  createReviver: _factoriesAny$1n.createReviver
};
dependenciesReviver_generated.reviverDependencies = reviverDependencies;
var dependenciesReplacer_generated = {};
Object.defineProperty(dependenciesReplacer_generated, "__esModule", {
  value: !0
});
dependenciesReplacer_generated.replacerDependencies = void 0;
var _factoriesAny$1m = factoriesAny, replacerDependencies = {
  createReplacer: _factoriesAny$1m.createReplacer
};
dependenciesReplacer_generated.replacerDependencies = replacerDependencies;
var dependenciesE_generated = {};
Object.defineProperty(dependenciesE_generated, "__esModule", {
  value: !0
});
dependenciesE_generated.eDependencies = void 0;
var _dependenciesBigNumberClassGenerated$Z = dependenciesBigNumberClass_generated, _factoriesAny$1l = factoriesAny, eDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$Z.BigNumberDependencies,
  createE: _factoriesAny$1l.createE
};
dependenciesE_generated.eDependencies = eDependencies;
var dependenciesUppercaseE_generated = {};
Object.defineProperty(dependenciesUppercaseE_generated, "__esModule", {
  value: !0
});
dependenciesUppercaseE_generated.EDependencies = void 0;
var _dependenciesEGenerated = dependenciesE_generated, _factoriesAny$1k = factoriesAny, EDependencies = {
  eDependencies: _dependenciesEGenerated.eDependencies,
  createUppercaseE: _factoriesAny$1k.createUppercaseE
};
dependenciesUppercaseE_generated.EDependencies = EDependencies;
var dependenciesFalse_generated = {};
Object.defineProperty(dependenciesFalse_generated, "__esModule", {
  value: !0
});
dependenciesFalse_generated.falseDependencies = void 0;
var _factoriesAny$1j = factoriesAny, falseDependencies = {
  createFalse: _factoriesAny$1j.createFalse
};
dependenciesFalse_generated.falseDependencies = falseDependencies;
var dependenciesI_generated = {};
Object.defineProperty(dependenciesI_generated, "__esModule", {
  value: !0
});
dependenciesI_generated.iDependencies = void 0;
var _dependenciesComplexClassGenerated = dependenciesComplexClass_generated, _factoriesAny$1i = factoriesAny, iDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated.ComplexDependencies,
  createI: _factoriesAny$1i.createI
};
dependenciesI_generated.iDependencies = iDependencies;
var dependenciesInfinity_generated = {};
Object.defineProperty(dependenciesInfinity_generated, "__esModule", {
  value: !0
});
dependenciesInfinity_generated.InfinityDependencies = void 0;
var _dependenciesBigNumberClassGenerated$Y = dependenciesBigNumberClass_generated, _factoriesAny$1h = factoriesAny, InfinityDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$Y.BigNumberDependencies,
  createInfinity: _factoriesAny$1h.createInfinity
};
dependenciesInfinity_generated.InfinityDependencies = InfinityDependencies;
var dependenciesLN10_generated = {};
Object.defineProperty(dependenciesLN10_generated, "__esModule", {
  value: !0
});
dependenciesLN10_generated.LN10Dependencies = void 0;
var _dependenciesBigNumberClassGenerated$X = dependenciesBigNumberClass_generated, _factoriesAny$1g = factoriesAny, LN10Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$X.BigNumberDependencies,
  createLN10: _factoriesAny$1g.createLN10
};
dependenciesLN10_generated.LN10Dependencies = LN10Dependencies;
var dependenciesLN2_generated = {};
Object.defineProperty(dependenciesLN2_generated, "__esModule", {
  value: !0
});
dependenciesLN2_generated.LN2Dependencies = void 0;
var _dependenciesBigNumberClassGenerated$W = dependenciesBigNumberClass_generated, _factoriesAny$1f = factoriesAny, LN2Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$W.BigNumberDependencies,
  createLN2: _factoriesAny$1f.createLN2
};
dependenciesLN2_generated.LN2Dependencies = LN2Dependencies;
var dependenciesLOG10E_generated = {};
Object.defineProperty(dependenciesLOG10E_generated, "__esModule", {
  value: !0
});
dependenciesLOG10E_generated.LOG10EDependencies = void 0;
var _dependenciesBigNumberClassGenerated$V = dependenciesBigNumberClass_generated, _factoriesAny$1e = factoriesAny, LOG10EDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$V.BigNumberDependencies,
  createLOG10E: _factoriesAny$1e.createLOG10E
};
dependenciesLOG10E_generated.LOG10EDependencies = LOG10EDependencies;
var dependenciesLOG2E_generated = {};
Object.defineProperty(dependenciesLOG2E_generated, "__esModule", {
  value: !0
});
dependenciesLOG2E_generated.LOG2EDependencies = void 0;
var _dependenciesBigNumberClassGenerated$U = dependenciesBigNumberClass_generated, _factoriesAny$1d = factoriesAny, LOG2EDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$U.BigNumberDependencies,
  createLOG2E: _factoriesAny$1d.createLOG2E
};
dependenciesLOG2E_generated.LOG2EDependencies = LOG2EDependencies;
var dependenciesNaN_generated = {};
Object.defineProperty(dependenciesNaN_generated, "__esModule", {
  value: !0
});
dependenciesNaN_generated.NaNDependencies = void 0;
var _dependenciesBigNumberClassGenerated$T = dependenciesBigNumberClass_generated, _factoriesAny$1c = factoriesAny, NaNDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$T.BigNumberDependencies,
  createNaN: _factoriesAny$1c.createNaN
};
dependenciesNaN_generated.NaNDependencies = NaNDependencies;
var dependenciesNull_generated = {};
Object.defineProperty(dependenciesNull_generated, "__esModule", {
  value: !0
});
dependenciesNull_generated.nullDependencies = void 0;
var _factoriesAny$1b = factoriesAny, nullDependencies = {
  createNull: _factoriesAny$1b.createNull
};
dependenciesNull_generated.nullDependencies = nullDependencies;
var dependenciesPhi_generated = {};
Object.defineProperty(dependenciesPhi_generated, "__esModule", {
  value: !0
});
dependenciesPhi_generated.phiDependencies = void 0;
var _dependenciesBigNumberClassGenerated$S = dependenciesBigNumberClass_generated, _factoriesAny$1a = factoriesAny, phiDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$S.BigNumberDependencies,
  createPhi: _factoriesAny$1a.createPhi
};
dependenciesPhi_generated.phiDependencies = phiDependencies;
var dependenciesPi_generated = {};
Object.defineProperty(dependenciesPi_generated, "__esModule", {
  value: !0
});
dependenciesPi_generated.piDependencies = void 0;
var _dependenciesBigNumberClassGenerated$R = dependenciesBigNumberClass_generated, _factoriesAny$19 = factoriesAny, piDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$R.BigNumberDependencies,
  createPi: _factoriesAny$19.createPi
};
dependenciesPi_generated.piDependencies = piDependencies;
var dependenciesUppercasePi_generated = {};
Object.defineProperty(dependenciesUppercasePi_generated, "__esModule", {
  value: !0
});
dependenciesUppercasePi_generated.PIDependencies = void 0;
var _dependenciesPiGenerated = dependenciesPi_generated, _factoriesAny$18 = factoriesAny, PIDependencies = {
  piDependencies: _dependenciesPiGenerated.piDependencies,
  createUppercasePi: _factoriesAny$18.createUppercasePi
};
dependenciesUppercasePi_generated.PIDependencies = PIDependencies;
var dependenciesSQRT1_2_generated = {};
Object.defineProperty(dependenciesSQRT1_2_generated, "__esModule", {
  value: !0
});
dependenciesSQRT1_2_generated.SQRT1_2Dependencies = void 0;
var _dependenciesBigNumberClassGenerated$Q = dependenciesBigNumberClass_generated, _factoriesAny$17 = factoriesAny, SQRT1_2Dependencies = {
  // eslint-disable-line camelcase
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$Q.BigNumberDependencies,
  createSQRT1_2: _factoriesAny$17.createSQRT1_2
};
dependenciesSQRT1_2_generated.SQRT1_2Dependencies = SQRT1_2Dependencies;
var dependenciesSQRT2_generated = {};
Object.defineProperty(dependenciesSQRT2_generated, "__esModule", {
  value: !0
});
dependenciesSQRT2_generated.SQRT2Dependencies = void 0;
var _dependenciesBigNumberClassGenerated$P = dependenciesBigNumberClass_generated, _factoriesAny$16 = factoriesAny, SQRT2Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$P.BigNumberDependencies,
  createSQRT2: _factoriesAny$16.createSQRT2
};
dependenciesSQRT2_generated.SQRT2Dependencies = SQRT2Dependencies;
var dependenciesTau_generated = {};
Object.defineProperty(dependenciesTau_generated, "__esModule", {
  value: !0
});
dependenciesTau_generated.tauDependencies = void 0;
var _dependenciesBigNumberClassGenerated$O = dependenciesBigNumberClass_generated, _factoriesAny$15 = factoriesAny, tauDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$O.BigNumberDependencies,
  createTau: _factoriesAny$15.createTau
};
dependenciesTau_generated.tauDependencies = tauDependencies;
var dependenciesTrue_generated = {};
Object.defineProperty(dependenciesTrue_generated, "__esModule", {
  value: !0
});
dependenciesTrue_generated.trueDependencies = void 0;
var _factoriesAny$14 = factoriesAny, trueDependencies = {
  createTrue: _factoriesAny$14.createTrue
};
dependenciesTrue_generated.trueDependencies = trueDependencies;
var dependenciesVersion_generated = {};
Object.defineProperty(dependenciesVersion_generated, "__esModule", {
  value: !0
});
dependenciesVersion_generated.versionDependencies = void 0;
var _factoriesAny$13 = factoriesAny, versionDependencies = {
  createVersion: _factoriesAny$13.createVersion
};
dependenciesVersion_generated.versionDependencies = versionDependencies;
var dependenciesAtomicMass_generated = {};
Object.defineProperty(dependenciesAtomicMass_generated, "__esModule", {
  value: !0
});
dependenciesAtomicMass_generated.atomicMassDependencies = void 0;
var _dependenciesBigNumberClassGenerated$N = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$J = dependenciesUnitClass_generated, _factoriesAny$12 = factoriesAny, atomicMassDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$N.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$J.UnitDependencies,
  createAtomicMass: _factoriesAny$12.createAtomicMass
};
dependenciesAtomicMass_generated.atomicMassDependencies = atomicMassDependencies;
var dependenciesAvogadro_generated = {};
Object.defineProperty(dependenciesAvogadro_generated, "__esModule", {
  value: !0
});
dependenciesAvogadro_generated.avogadroDependencies = void 0;
var _dependenciesBigNumberClassGenerated$M = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$I = dependenciesUnitClass_generated, _factoriesAny$11 = factoriesAny, avogadroDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$M.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$I.UnitDependencies,
  createAvogadro: _factoriesAny$11.createAvogadro
};
dependenciesAvogadro_generated.avogadroDependencies = avogadroDependencies;
var dependenciesBohrMagneton_generated = {};
Object.defineProperty(dependenciesBohrMagneton_generated, "__esModule", {
  value: !0
});
dependenciesBohrMagneton_generated.bohrMagnetonDependencies = void 0;
var _dependenciesBigNumberClassGenerated$L = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$H = dependenciesUnitClass_generated, _factoriesAny$10 = factoriesAny, bohrMagnetonDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$L.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$H.UnitDependencies,
  createBohrMagneton: _factoriesAny$10.createBohrMagneton
};
dependenciesBohrMagneton_generated.bohrMagnetonDependencies = bohrMagnetonDependencies;
var dependenciesBohrRadius_generated = {};
Object.defineProperty(dependenciesBohrRadius_generated, "__esModule", {
  value: !0
});
dependenciesBohrRadius_generated.bohrRadiusDependencies = void 0;
var _dependenciesBigNumberClassGenerated$K = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$G = dependenciesUnitClass_generated, _factoriesAny$$ = factoriesAny, bohrRadiusDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$K.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$G.UnitDependencies,
  createBohrRadius: _factoriesAny$$.createBohrRadius
};
dependenciesBohrRadius_generated.bohrRadiusDependencies = bohrRadiusDependencies;
var dependenciesBoltzmann_generated = {};
Object.defineProperty(dependenciesBoltzmann_generated, "__esModule", {
  value: !0
});
dependenciesBoltzmann_generated.boltzmannDependencies = void 0;
var _dependenciesBigNumberClassGenerated$J = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$F = dependenciesUnitClass_generated, _factoriesAny$_ = factoriesAny, boltzmannDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$J.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$F.UnitDependencies,
  createBoltzmann: _factoriesAny$_.createBoltzmann
};
dependenciesBoltzmann_generated.boltzmannDependencies = boltzmannDependencies;
var dependenciesClassicalElectronRadius_generated = {};
Object.defineProperty(dependenciesClassicalElectronRadius_generated, "__esModule", {
  value: !0
});
dependenciesClassicalElectronRadius_generated.classicalElectronRadiusDependencies = void 0;
var _dependenciesBigNumberClassGenerated$I = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$E = dependenciesUnitClass_generated, _factoriesAny$Z = factoriesAny, classicalElectronRadiusDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$I.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$E.UnitDependencies,
  createClassicalElectronRadius: _factoriesAny$Z.createClassicalElectronRadius
};
dependenciesClassicalElectronRadius_generated.classicalElectronRadiusDependencies = classicalElectronRadiusDependencies;
var dependenciesConductanceQuantum_generated = {};
Object.defineProperty(dependenciesConductanceQuantum_generated, "__esModule", {
  value: !0
});
dependenciesConductanceQuantum_generated.conductanceQuantumDependencies = void 0;
var _dependenciesBigNumberClassGenerated$H = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$D = dependenciesUnitClass_generated, _factoriesAny$Y = factoriesAny, conductanceQuantumDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$H.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$D.UnitDependencies,
  createConductanceQuantum: _factoriesAny$Y.createConductanceQuantum
};
dependenciesConductanceQuantum_generated.conductanceQuantumDependencies = conductanceQuantumDependencies;
var dependenciesCoulomb_generated = {};
Object.defineProperty(dependenciesCoulomb_generated, "__esModule", {
  value: !0
});
dependenciesCoulomb_generated.coulombDependencies = void 0;
var _dependenciesBigNumberClassGenerated$G = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$C = dependenciesUnitClass_generated, _factoriesAny$X = factoriesAny, coulombDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$G.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$C.UnitDependencies,
  createCoulomb: _factoriesAny$X.createCoulomb
};
dependenciesCoulomb_generated.coulombDependencies = coulombDependencies;
var dependenciesDeuteronMass_generated = {};
Object.defineProperty(dependenciesDeuteronMass_generated, "__esModule", {
  value: !0
});
dependenciesDeuteronMass_generated.deuteronMassDependencies = void 0;
var _dependenciesBigNumberClassGenerated$F = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$B = dependenciesUnitClass_generated, _factoriesAny$W = factoriesAny, deuteronMassDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$F.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$B.UnitDependencies,
  createDeuteronMass: _factoriesAny$W.createDeuteronMass
};
dependenciesDeuteronMass_generated.deuteronMassDependencies = deuteronMassDependencies;
var dependenciesEfimovFactor_generated = {};
Object.defineProperty(dependenciesEfimovFactor_generated, "__esModule", {
  value: !0
});
dependenciesEfimovFactor_generated.efimovFactorDependencies = void 0;
var _dependenciesBigNumberClassGenerated$E = dependenciesBigNumberClass_generated, _factoriesAny$V = factoriesAny, efimovFactorDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$E.BigNumberDependencies,
  createEfimovFactor: _factoriesAny$V.createEfimovFactor
};
dependenciesEfimovFactor_generated.efimovFactorDependencies = efimovFactorDependencies;
var dependenciesElectricConstant_generated = {};
Object.defineProperty(dependenciesElectricConstant_generated, "__esModule", {
  value: !0
});
dependenciesElectricConstant_generated.electricConstantDependencies = void 0;
var _dependenciesBigNumberClassGenerated$D = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$A = dependenciesUnitClass_generated, _factoriesAny$U = factoriesAny, electricConstantDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$D.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$A.UnitDependencies,
  createElectricConstant: _factoriesAny$U.createElectricConstant
};
dependenciesElectricConstant_generated.electricConstantDependencies = electricConstantDependencies;
var dependenciesElectronMass_generated = {};
Object.defineProperty(dependenciesElectronMass_generated, "__esModule", {
  value: !0
});
dependenciesElectronMass_generated.electronMassDependencies = void 0;
var _dependenciesBigNumberClassGenerated$C = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$z = dependenciesUnitClass_generated, _factoriesAny$T = factoriesAny, electronMassDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$C.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$z.UnitDependencies,
  createElectronMass: _factoriesAny$T.createElectronMass
};
dependenciesElectronMass_generated.electronMassDependencies = electronMassDependencies;
var dependenciesElementaryCharge_generated = {};
Object.defineProperty(dependenciesElementaryCharge_generated, "__esModule", {
  value: !0
});
dependenciesElementaryCharge_generated.elementaryChargeDependencies = void 0;
var _dependenciesBigNumberClassGenerated$B = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$y = dependenciesUnitClass_generated, _factoriesAny$S = factoriesAny, elementaryChargeDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$B.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$y.UnitDependencies,
  createElementaryCharge: _factoriesAny$S.createElementaryCharge
};
dependenciesElementaryCharge_generated.elementaryChargeDependencies = elementaryChargeDependencies;
var dependenciesFaraday_generated = {};
Object.defineProperty(dependenciesFaraday_generated, "__esModule", {
  value: !0
});
dependenciesFaraday_generated.faradayDependencies = void 0;
var _dependenciesBigNumberClassGenerated$A = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$x = dependenciesUnitClass_generated, _factoriesAny$R = factoriesAny, faradayDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$A.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$x.UnitDependencies,
  createFaraday: _factoriesAny$R.createFaraday
};
dependenciesFaraday_generated.faradayDependencies = faradayDependencies;
var dependenciesFermiCoupling_generated = {};
Object.defineProperty(dependenciesFermiCoupling_generated, "__esModule", {
  value: !0
});
dependenciesFermiCoupling_generated.fermiCouplingDependencies = void 0;
var _dependenciesBigNumberClassGenerated$z = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$w = dependenciesUnitClass_generated, _factoriesAny$Q = factoriesAny, fermiCouplingDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$z.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$w.UnitDependencies,
  createFermiCoupling: _factoriesAny$Q.createFermiCoupling
};
dependenciesFermiCoupling_generated.fermiCouplingDependencies = fermiCouplingDependencies;
var dependenciesFineStructure_generated = {};
Object.defineProperty(dependenciesFineStructure_generated, "__esModule", {
  value: !0
});
dependenciesFineStructure_generated.fineStructureDependencies = void 0;
var _dependenciesBigNumberClassGenerated$y = dependenciesBigNumberClass_generated, _factoriesAny$P = factoriesAny, fineStructureDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$y.BigNumberDependencies,
  createFineStructure: _factoriesAny$P.createFineStructure
};
dependenciesFineStructure_generated.fineStructureDependencies = fineStructureDependencies;
var dependenciesFirstRadiation_generated = {};
Object.defineProperty(dependenciesFirstRadiation_generated, "__esModule", {
  value: !0
});
dependenciesFirstRadiation_generated.firstRadiationDependencies = void 0;
var _dependenciesBigNumberClassGenerated$x = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$v = dependenciesUnitClass_generated, _factoriesAny$O = factoriesAny, firstRadiationDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$x.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$v.UnitDependencies,
  createFirstRadiation: _factoriesAny$O.createFirstRadiation
};
dependenciesFirstRadiation_generated.firstRadiationDependencies = firstRadiationDependencies;
var dependenciesGasConstant_generated = {};
Object.defineProperty(dependenciesGasConstant_generated, "__esModule", {
  value: !0
});
dependenciesGasConstant_generated.gasConstantDependencies = void 0;
var _dependenciesBigNumberClassGenerated$w = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$u = dependenciesUnitClass_generated, _factoriesAny$N = factoriesAny, gasConstantDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$w.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$u.UnitDependencies,
  createGasConstant: _factoriesAny$N.createGasConstant
};
dependenciesGasConstant_generated.gasConstantDependencies = gasConstantDependencies;
var dependenciesGravitationConstant_generated = {};
Object.defineProperty(dependenciesGravitationConstant_generated, "__esModule", {
  value: !0
});
dependenciesGravitationConstant_generated.gravitationConstantDependencies = void 0;
var _dependenciesBigNumberClassGenerated$v = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$t = dependenciesUnitClass_generated, _factoriesAny$M = factoriesAny, gravitationConstantDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$v.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$t.UnitDependencies,
  createGravitationConstant: _factoriesAny$M.createGravitationConstant
};
dependenciesGravitationConstant_generated.gravitationConstantDependencies = gravitationConstantDependencies;
var dependenciesGravity_generated = {};
Object.defineProperty(dependenciesGravity_generated, "__esModule", {
  value: !0
});
dependenciesGravity_generated.gravityDependencies = void 0;
var _dependenciesBigNumberClassGenerated$u = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$s = dependenciesUnitClass_generated, _factoriesAny$L = factoriesAny, gravityDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$u.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$s.UnitDependencies,
  createGravity: _factoriesAny$L.createGravity
};
dependenciesGravity_generated.gravityDependencies = gravityDependencies;
var dependenciesHartreeEnergy_generated = {};
Object.defineProperty(dependenciesHartreeEnergy_generated, "__esModule", {
  value: !0
});
dependenciesHartreeEnergy_generated.hartreeEnergyDependencies = void 0;
var _dependenciesBigNumberClassGenerated$t = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$r = dependenciesUnitClass_generated, _factoriesAny$K = factoriesAny, hartreeEnergyDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$t.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$r.UnitDependencies,
  createHartreeEnergy: _factoriesAny$K.createHartreeEnergy
};
dependenciesHartreeEnergy_generated.hartreeEnergyDependencies = hartreeEnergyDependencies;
var dependenciesInverseConductanceQuantum_generated = {};
Object.defineProperty(dependenciesInverseConductanceQuantum_generated, "__esModule", {
  value: !0
});
dependenciesInverseConductanceQuantum_generated.inverseConductanceQuantumDependencies = void 0;
var _dependenciesBigNumberClassGenerated$s = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$q = dependenciesUnitClass_generated, _factoriesAny$J = factoriesAny, inverseConductanceQuantumDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$s.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$q.UnitDependencies,
  createInverseConductanceQuantum: _factoriesAny$J.createInverseConductanceQuantum
};
dependenciesInverseConductanceQuantum_generated.inverseConductanceQuantumDependencies = inverseConductanceQuantumDependencies;
var dependenciesKlitzing_generated = {};
Object.defineProperty(dependenciesKlitzing_generated, "__esModule", {
  value: !0
});
dependenciesKlitzing_generated.klitzingDependencies = void 0;
var _dependenciesBigNumberClassGenerated$r = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$p = dependenciesUnitClass_generated, _factoriesAny$I = factoriesAny, klitzingDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$r.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$p.UnitDependencies,
  createKlitzing: _factoriesAny$I.createKlitzing
};
dependenciesKlitzing_generated.klitzingDependencies = klitzingDependencies;
var dependenciesLoschmidt_generated = {};
Object.defineProperty(dependenciesLoschmidt_generated, "__esModule", {
  value: !0
});
dependenciesLoschmidt_generated.loschmidtDependencies = void 0;
var _dependenciesBigNumberClassGenerated$q = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$o = dependenciesUnitClass_generated, _factoriesAny$H = factoriesAny, loschmidtDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$q.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$o.UnitDependencies,
  createLoschmidt: _factoriesAny$H.createLoschmidt
};
dependenciesLoschmidt_generated.loschmidtDependencies = loschmidtDependencies;
var dependenciesMagneticConstant_generated = {};
Object.defineProperty(dependenciesMagneticConstant_generated, "__esModule", {
  value: !0
});
dependenciesMagneticConstant_generated.magneticConstantDependencies = void 0;
var _dependenciesBigNumberClassGenerated$p = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$n = dependenciesUnitClass_generated, _factoriesAny$G = factoriesAny, magneticConstantDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$p.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$n.UnitDependencies,
  createMagneticConstant: _factoriesAny$G.createMagneticConstant
};
dependenciesMagneticConstant_generated.magneticConstantDependencies = magneticConstantDependencies;
var dependenciesMagneticFluxQuantum_generated = {};
Object.defineProperty(dependenciesMagneticFluxQuantum_generated, "__esModule", {
  value: !0
});
dependenciesMagneticFluxQuantum_generated.magneticFluxQuantumDependencies = void 0;
var _dependenciesBigNumberClassGenerated$o = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$m = dependenciesUnitClass_generated, _factoriesAny$F = factoriesAny, magneticFluxQuantumDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$o.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$m.UnitDependencies,
  createMagneticFluxQuantum: _factoriesAny$F.createMagneticFluxQuantum
};
dependenciesMagneticFluxQuantum_generated.magneticFluxQuantumDependencies = magneticFluxQuantumDependencies;
var dependenciesMolarMass_generated = {};
Object.defineProperty(dependenciesMolarMass_generated, "__esModule", {
  value: !0
});
dependenciesMolarMass_generated.molarMassDependencies = void 0;
var _dependenciesBigNumberClassGenerated$n = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$l = dependenciesUnitClass_generated, _factoriesAny$E = factoriesAny, molarMassDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$n.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$l.UnitDependencies,
  createMolarMass: _factoriesAny$E.createMolarMass
};
dependenciesMolarMass_generated.molarMassDependencies = molarMassDependencies;
var dependenciesMolarMassC12_generated = {};
Object.defineProperty(dependenciesMolarMassC12_generated, "__esModule", {
  value: !0
});
dependenciesMolarMassC12_generated.molarMassC12Dependencies = void 0;
var _dependenciesBigNumberClassGenerated$m = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$k = dependenciesUnitClass_generated, _factoriesAny$D = factoriesAny, molarMassC12Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$m.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$k.UnitDependencies,
  createMolarMassC12: _factoriesAny$D.createMolarMassC12
};
dependenciesMolarMassC12_generated.molarMassC12Dependencies = molarMassC12Dependencies;
var dependenciesMolarPlanckConstant_generated = {};
Object.defineProperty(dependenciesMolarPlanckConstant_generated, "__esModule", {
  value: !0
});
dependenciesMolarPlanckConstant_generated.molarPlanckConstantDependencies = void 0;
var _dependenciesBigNumberClassGenerated$l = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$j = dependenciesUnitClass_generated, _factoriesAny$C = factoriesAny, molarPlanckConstantDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$l.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$j.UnitDependencies,
  createMolarPlanckConstant: _factoriesAny$C.createMolarPlanckConstant
};
dependenciesMolarPlanckConstant_generated.molarPlanckConstantDependencies = molarPlanckConstantDependencies;
var dependenciesMolarVolume_generated = {};
Object.defineProperty(dependenciesMolarVolume_generated, "__esModule", {
  value: !0
});
dependenciesMolarVolume_generated.molarVolumeDependencies = void 0;
var _dependenciesBigNumberClassGenerated$k = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$i = dependenciesUnitClass_generated, _factoriesAny$B = factoriesAny, molarVolumeDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$k.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$i.UnitDependencies,
  createMolarVolume: _factoriesAny$B.createMolarVolume
};
dependenciesMolarVolume_generated.molarVolumeDependencies = molarVolumeDependencies;
var dependenciesNeutronMass_generated = {};
Object.defineProperty(dependenciesNeutronMass_generated, "__esModule", {
  value: !0
});
dependenciesNeutronMass_generated.neutronMassDependencies = void 0;
var _dependenciesBigNumberClassGenerated$j = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$h = dependenciesUnitClass_generated, _factoriesAny$A = factoriesAny, neutronMassDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$j.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$h.UnitDependencies,
  createNeutronMass: _factoriesAny$A.createNeutronMass
};
dependenciesNeutronMass_generated.neutronMassDependencies = neutronMassDependencies;
var dependenciesNuclearMagneton_generated = {};
Object.defineProperty(dependenciesNuclearMagneton_generated, "__esModule", {
  value: !0
});
dependenciesNuclearMagneton_generated.nuclearMagnetonDependencies = void 0;
var _dependenciesBigNumberClassGenerated$i = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$g = dependenciesUnitClass_generated, _factoriesAny$z = factoriesAny, nuclearMagnetonDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$i.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$g.UnitDependencies,
  createNuclearMagneton: _factoriesAny$z.createNuclearMagneton
};
dependenciesNuclearMagneton_generated.nuclearMagnetonDependencies = nuclearMagnetonDependencies;
var dependenciesPlanckCharge_generated = {};
Object.defineProperty(dependenciesPlanckCharge_generated, "__esModule", {
  value: !0
});
dependenciesPlanckCharge_generated.planckChargeDependencies = void 0;
var _dependenciesBigNumberClassGenerated$h = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$f = dependenciesUnitClass_generated, _factoriesAny$y = factoriesAny, planckChargeDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$h.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$f.UnitDependencies,
  createPlanckCharge: _factoriesAny$y.createPlanckCharge
};
dependenciesPlanckCharge_generated.planckChargeDependencies = planckChargeDependencies;
var dependenciesPlanckConstant_generated = {};
Object.defineProperty(dependenciesPlanckConstant_generated, "__esModule", {
  value: !0
});
dependenciesPlanckConstant_generated.planckConstantDependencies = void 0;
var _dependenciesBigNumberClassGenerated$g = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$e = dependenciesUnitClass_generated, _factoriesAny$x = factoriesAny, planckConstantDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$g.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$e.UnitDependencies,
  createPlanckConstant: _factoriesAny$x.createPlanckConstant
};
dependenciesPlanckConstant_generated.planckConstantDependencies = planckConstantDependencies;
var dependenciesPlanckLength_generated = {};
Object.defineProperty(dependenciesPlanckLength_generated, "__esModule", {
  value: !0
});
dependenciesPlanckLength_generated.planckLengthDependencies = void 0;
var _dependenciesBigNumberClassGenerated$f = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$d = dependenciesUnitClass_generated, _factoriesAny$w = factoriesAny, planckLengthDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$f.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$d.UnitDependencies,
  createPlanckLength: _factoriesAny$w.createPlanckLength
};
dependenciesPlanckLength_generated.planckLengthDependencies = planckLengthDependencies;
var dependenciesPlanckMass_generated = {};
Object.defineProperty(dependenciesPlanckMass_generated, "__esModule", {
  value: !0
});
dependenciesPlanckMass_generated.planckMassDependencies = void 0;
var _dependenciesBigNumberClassGenerated$e = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$c = dependenciesUnitClass_generated, _factoriesAny$v = factoriesAny, planckMassDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$e.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$c.UnitDependencies,
  createPlanckMass: _factoriesAny$v.createPlanckMass
};
dependenciesPlanckMass_generated.planckMassDependencies = planckMassDependencies;
var dependenciesPlanckTemperature_generated = {};
Object.defineProperty(dependenciesPlanckTemperature_generated, "__esModule", {
  value: !0
});
dependenciesPlanckTemperature_generated.planckTemperatureDependencies = void 0;
var _dependenciesBigNumberClassGenerated$d = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$b = dependenciesUnitClass_generated, _factoriesAny$u = factoriesAny, planckTemperatureDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$d.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$b.UnitDependencies,
  createPlanckTemperature: _factoriesAny$u.createPlanckTemperature
};
dependenciesPlanckTemperature_generated.planckTemperatureDependencies = planckTemperatureDependencies;
var dependenciesPlanckTime_generated = {};
Object.defineProperty(dependenciesPlanckTime_generated, "__esModule", {
  value: !0
});
dependenciesPlanckTime_generated.planckTimeDependencies = void 0;
var _dependenciesBigNumberClassGenerated$c = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$a = dependenciesUnitClass_generated, _factoriesAny$t = factoriesAny, planckTimeDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$c.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$a.UnitDependencies,
  createPlanckTime: _factoriesAny$t.createPlanckTime
};
dependenciesPlanckTime_generated.planckTimeDependencies = planckTimeDependencies;
var dependenciesProtonMass_generated = {};
Object.defineProperty(dependenciesProtonMass_generated, "__esModule", {
  value: !0
});
dependenciesProtonMass_generated.protonMassDependencies = void 0;
var _dependenciesBigNumberClassGenerated$b = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$9 = dependenciesUnitClass_generated, _factoriesAny$s = factoriesAny, protonMassDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$b.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$9.UnitDependencies,
  createProtonMass: _factoriesAny$s.createProtonMass
};
dependenciesProtonMass_generated.protonMassDependencies = protonMassDependencies;
var dependenciesQuantumOfCirculation_generated = {};
Object.defineProperty(dependenciesQuantumOfCirculation_generated, "__esModule", {
  value: !0
});
dependenciesQuantumOfCirculation_generated.quantumOfCirculationDependencies = void 0;
var _dependenciesBigNumberClassGenerated$a = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$8 = dependenciesUnitClass_generated, _factoriesAny$r = factoriesAny, quantumOfCirculationDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$a.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$8.UnitDependencies,
  createQuantumOfCirculation: _factoriesAny$r.createQuantumOfCirculation
};
dependenciesQuantumOfCirculation_generated.quantumOfCirculationDependencies = quantumOfCirculationDependencies;
var dependenciesReducedPlanckConstant_generated = {};
Object.defineProperty(dependenciesReducedPlanckConstant_generated, "__esModule", {
  value: !0
});
dependenciesReducedPlanckConstant_generated.reducedPlanckConstantDependencies = void 0;
var _dependenciesBigNumberClassGenerated$9 = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$7 = dependenciesUnitClass_generated, _factoriesAny$q = factoriesAny, reducedPlanckConstantDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$9.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$7.UnitDependencies,
  createReducedPlanckConstant: _factoriesAny$q.createReducedPlanckConstant
};
dependenciesReducedPlanckConstant_generated.reducedPlanckConstantDependencies = reducedPlanckConstantDependencies;
var dependenciesRydberg_generated = {};
Object.defineProperty(dependenciesRydberg_generated, "__esModule", {
  value: !0
});
dependenciesRydberg_generated.rydbergDependencies = void 0;
var _dependenciesBigNumberClassGenerated$8 = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$6 = dependenciesUnitClass_generated, _factoriesAny$p = factoriesAny, rydbergDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$8.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$6.UnitDependencies,
  createRydberg: _factoriesAny$p.createRydberg
};
dependenciesRydberg_generated.rydbergDependencies = rydbergDependencies;
var dependenciesSackurTetrode_generated = {};
Object.defineProperty(dependenciesSackurTetrode_generated, "__esModule", {
  value: !0
});
dependenciesSackurTetrode_generated.sackurTetrodeDependencies = void 0;
var _dependenciesBigNumberClassGenerated$7 = dependenciesBigNumberClass_generated, _factoriesAny$o = factoriesAny, sackurTetrodeDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$7.BigNumberDependencies,
  createSackurTetrode: _factoriesAny$o.createSackurTetrode
};
dependenciesSackurTetrode_generated.sackurTetrodeDependencies = sackurTetrodeDependencies;
var dependenciesSecondRadiation_generated = {};
Object.defineProperty(dependenciesSecondRadiation_generated, "__esModule", {
  value: !0
});
dependenciesSecondRadiation_generated.secondRadiationDependencies = void 0;
var _dependenciesBigNumberClassGenerated$6 = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$5 = dependenciesUnitClass_generated, _factoriesAny$n = factoriesAny, secondRadiationDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$6.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$5.UnitDependencies,
  createSecondRadiation: _factoriesAny$n.createSecondRadiation
};
dependenciesSecondRadiation_generated.secondRadiationDependencies = secondRadiationDependencies;
var dependenciesSpeedOfLight_generated = {};
Object.defineProperty(dependenciesSpeedOfLight_generated, "__esModule", {
  value: !0
});
dependenciesSpeedOfLight_generated.speedOfLightDependencies = void 0;
var _dependenciesBigNumberClassGenerated$5 = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$4 = dependenciesUnitClass_generated, _factoriesAny$m = factoriesAny, speedOfLightDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$5.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$4.UnitDependencies,
  createSpeedOfLight: _factoriesAny$m.createSpeedOfLight
};
dependenciesSpeedOfLight_generated.speedOfLightDependencies = speedOfLightDependencies;
var dependenciesStefanBoltzmann_generated = {};
Object.defineProperty(dependenciesStefanBoltzmann_generated, "__esModule", {
  value: !0
});
dependenciesStefanBoltzmann_generated.stefanBoltzmannDependencies = void 0;
var _dependenciesBigNumberClassGenerated$4 = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$3 = dependenciesUnitClass_generated, _factoriesAny$l = factoriesAny, stefanBoltzmannDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$4.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$3.UnitDependencies,
  createStefanBoltzmann: _factoriesAny$l.createStefanBoltzmann
};
dependenciesStefanBoltzmann_generated.stefanBoltzmannDependencies = stefanBoltzmannDependencies;
var dependenciesThomsonCrossSection_generated = {};
Object.defineProperty(dependenciesThomsonCrossSection_generated, "__esModule", {
  value: !0
});
dependenciesThomsonCrossSection_generated.thomsonCrossSectionDependencies = void 0;
var _dependenciesBigNumberClassGenerated$3 = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$2 = dependenciesUnitClass_generated, _factoriesAny$k = factoriesAny, thomsonCrossSectionDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$3.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$2.UnitDependencies,
  createThomsonCrossSection: _factoriesAny$k.createThomsonCrossSection
};
dependenciesThomsonCrossSection_generated.thomsonCrossSectionDependencies = thomsonCrossSectionDependencies;
var dependenciesVacuumImpedance_generated = {};
Object.defineProperty(dependenciesVacuumImpedance_generated, "__esModule", {
  value: !0
});
dependenciesVacuumImpedance_generated.vacuumImpedanceDependencies = void 0;
var _dependenciesBigNumberClassGenerated$2 = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated$1 = dependenciesUnitClass_generated, _factoriesAny$j = factoriesAny, vacuumImpedanceDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$2.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated$1.UnitDependencies,
  createVacuumImpedance: _factoriesAny$j.createVacuumImpedance
};
dependenciesVacuumImpedance_generated.vacuumImpedanceDependencies = vacuumImpedanceDependencies;
var dependenciesWeakMixingAngle_generated = {};
Object.defineProperty(dependenciesWeakMixingAngle_generated, "__esModule", {
  value: !0
});
dependenciesWeakMixingAngle_generated.weakMixingAngleDependencies = void 0;
var _dependenciesBigNumberClassGenerated$1 = dependenciesBigNumberClass_generated, _factoriesAny$i = factoriesAny, weakMixingAngleDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated$1.BigNumberDependencies,
  createWeakMixingAngle: _factoriesAny$i.createWeakMixingAngle
};
dependenciesWeakMixingAngle_generated.weakMixingAngleDependencies = weakMixingAngleDependencies;
var dependenciesWienDisplacement_generated = {};
Object.defineProperty(dependenciesWienDisplacement_generated, "__esModule", {
  value: !0
});
dependenciesWienDisplacement_generated.wienDisplacementDependencies = void 0;
var _dependenciesBigNumberClassGenerated = dependenciesBigNumberClass_generated, _dependenciesUnitClassGenerated = dependenciesUnitClass_generated, _factoriesAny$h = factoriesAny, wienDisplacementDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated.UnitDependencies,
  createWienDisplacement: _factoriesAny$h.createWienDisplacement
};
dependenciesWienDisplacement_generated.wienDisplacementDependencies = wienDisplacementDependencies;
var dependenciesApplyTransform_generated = {};
Object.defineProperty(dependenciesApplyTransform_generated, "__esModule", {
  value: !0
});
dependenciesApplyTransform_generated.applyTransformDependencies = void 0;
var _dependenciesIsIntegerGenerated$1 = dependenciesIsInteger_generated, _dependenciesTypedGenerated$f = dependenciesTyped_generated, _factoriesAny$g = factoriesAny, applyTransformDependencies = {
  isIntegerDependencies: _dependenciesIsIntegerGenerated$1.isIntegerDependencies,
  typedDependencies: _dependenciesTypedGenerated$f.typedDependencies,
  createApplyTransform: _factoriesAny$g.createApplyTransform
};
dependenciesApplyTransform_generated.applyTransformDependencies = applyTransformDependencies;
var dependenciesColumnTransform_generated = {};
Object.defineProperty(dependenciesColumnTransform_generated, "__esModule", {
  value: !0
});
dependenciesColumnTransform_generated.columnTransformDependencies = void 0;
var _dependenciesIndexClassGenerated$2 = dependenciesIndexClass_generated, _dependenciesMatrixGenerated$5 = dependenciesMatrix_generated, _dependenciesRangeGenerated$1 = dependenciesRange_generated, _dependenciesTypedGenerated$e = dependenciesTyped_generated, _factoriesAny$f = factoriesAny, columnTransformDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$2.IndexDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$5.matrixDependencies,
  rangeDependencies: _dependenciesRangeGenerated$1.rangeDependencies,
  typedDependencies: _dependenciesTypedGenerated$e.typedDependencies,
  createColumnTransform: _factoriesAny$f.createColumnTransform
};
dependenciesColumnTransform_generated.columnTransformDependencies = columnTransformDependencies;
var dependenciesFilterTransform_generated = {};
Object.defineProperty(dependenciesFilterTransform_generated, "__esModule", {
  value: !0
});
dependenciesFilterTransform_generated.filterTransformDependencies = void 0;
var _dependenciesTypedGenerated$d = dependenciesTyped_generated, _factoriesAny$e = factoriesAny, filterTransformDependencies = {
  typedDependencies: _dependenciesTypedGenerated$d.typedDependencies,
  createFilterTransform: _factoriesAny$e.createFilterTransform
};
dependenciesFilterTransform_generated.filterTransformDependencies = filterTransformDependencies;
var dependenciesForEachTransform_generated = {};
Object.defineProperty(dependenciesForEachTransform_generated, "__esModule", {
  value: !0
});
dependenciesForEachTransform_generated.forEachTransformDependencies = void 0;
var _dependenciesTypedGenerated$c = dependenciesTyped_generated, _factoriesAny$d = factoriesAny, forEachTransformDependencies = {
  typedDependencies: _dependenciesTypedGenerated$c.typedDependencies,
  createForEachTransform: _factoriesAny$d.createForEachTransform
};
dependenciesForEachTransform_generated.forEachTransformDependencies = forEachTransformDependencies;
var dependenciesIndexTransform_generated = {};
Object.defineProperty(dependenciesIndexTransform_generated, "__esModule", {
  value: !0
});
dependenciesIndexTransform_generated.indexTransformDependencies = void 0;
var _dependenciesIndexClassGenerated$1 = dependenciesIndexClass_generated, _factoriesAny$c = factoriesAny, indexTransformDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated$1.IndexDependencies,
  createIndexTransform: _factoriesAny$c.createIndexTransform
};
dependenciesIndexTransform_generated.indexTransformDependencies = indexTransformDependencies;
var dependenciesMapTransform_generated = {};
Object.defineProperty(dependenciesMapTransform_generated, "__esModule", {
  value: !0
});
dependenciesMapTransform_generated.mapTransformDependencies = void 0;
var _dependenciesTypedGenerated$b = dependenciesTyped_generated, _factoriesAny$b = factoriesAny, mapTransformDependencies = {
  typedDependencies: _dependenciesTypedGenerated$b.typedDependencies,
  createMapTransform: _factoriesAny$b.createMapTransform
};
dependenciesMapTransform_generated.mapTransformDependencies = mapTransformDependencies;
var dependenciesMaxTransform_generated = {};
Object.defineProperty(dependenciesMaxTransform_generated, "__esModule", {
  value: !0
});
dependenciesMaxTransform_generated.maxTransformDependencies = void 0;
var _dependenciesLargerGenerated$1 = dependenciesLarger_generated, _dependenciesNumericGenerated$2 = dependenciesNumeric_generated, _dependenciesTypedGenerated$a = dependenciesTyped_generated, _factoriesAny$a = factoriesAny, maxTransformDependencies = {
  largerDependencies: _dependenciesLargerGenerated$1.largerDependencies,
  numericDependencies: _dependenciesNumericGenerated$2.numericDependencies,
  typedDependencies: _dependenciesTypedGenerated$a.typedDependencies,
  createMaxTransform: _factoriesAny$a.createMaxTransform
};
dependenciesMaxTransform_generated.maxTransformDependencies = maxTransformDependencies;
var dependenciesMeanTransform_generated = {};
Object.defineProperty(dependenciesMeanTransform_generated, "__esModule", {
  value: !0
});
dependenciesMeanTransform_generated.meanTransformDependencies = void 0;
var _dependenciesAddGenerated$2 = dependenciesAdd_generated, _dependenciesDivideGenerated$1 = dependenciesDivide_generated, _dependenciesTypedGenerated$9 = dependenciesTyped_generated, _factoriesAny$9 = factoriesAny, meanTransformDependencies = {
  addDependencies: _dependenciesAddGenerated$2.addDependencies,
  divideDependencies: _dependenciesDivideGenerated$1.divideDependencies,
  typedDependencies: _dependenciesTypedGenerated$9.typedDependencies,
  createMeanTransform: _factoriesAny$9.createMeanTransform
};
dependenciesMeanTransform_generated.meanTransformDependencies = meanTransformDependencies;
var dependenciesMinTransform_generated = {};
Object.defineProperty(dependenciesMinTransform_generated, "__esModule", {
  value: !0
});
dependenciesMinTransform_generated.minTransformDependencies = void 0;
var _dependenciesNumericGenerated$1 = dependenciesNumeric_generated, _dependenciesSmallerGenerated$1 = dependenciesSmaller_generated, _dependenciesTypedGenerated$8 = dependenciesTyped_generated, _factoriesAny$8 = factoriesAny, minTransformDependencies = {
  numericDependencies: _dependenciesNumericGenerated$1.numericDependencies,
  smallerDependencies: _dependenciesSmallerGenerated$1.smallerDependencies,
  typedDependencies: _dependenciesTypedGenerated$8.typedDependencies,
  createMinTransform: _factoriesAny$8.createMinTransform
};
dependenciesMinTransform_generated.minTransformDependencies = minTransformDependencies;
var dependenciesRangeTransform_generated = {};
Object.defineProperty(dependenciesRangeTransform_generated, "__esModule", {
  value: !0
});
dependenciesRangeTransform_generated.rangeTransformDependencies = void 0;
var _dependenciesBignumberGenerated$1 = dependenciesBignumber_generated, _dependenciesMatrixGenerated$4 = dependenciesMatrix_generated, _dependenciesLargerGenerated = dependenciesLarger_generated, _dependenciesLargerEqGenerated = dependenciesLargerEq_generated, _dependenciesSmallerGenerated = dependenciesSmaller_generated, _dependenciesSmallerEqGenerated = dependenciesSmallerEq_generated, _dependenciesTypedGenerated$7 = dependenciesTyped_generated, _factoriesAny$7 = factoriesAny, rangeTransformDependencies = {
  bignumberDependencies: _dependenciesBignumberGenerated$1.bignumberDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$4.matrixDependencies,
  largerDependencies: _dependenciesLargerGenerated.largerDependencies,
  largerEqDependencies: _dependenciesLargerEqGenerated.largerEqDependencies,
  smallerDependencies: _dependenciesSmallerGenerated.smallerDependencies,
  smallerEqDependencies: _dependenciesSmallerEqGenerated.smallerEqDependencies,
  typedDependencies: _dependenciesTypedGenerated$7.typedDependencies,
  createRangeTransform: _factoriesAny$7.createRangeTransform
};
dependenciesRangeTransform_generated.rangeTransformDependencies = rangeTransformDependencies;
var dependenciesRowTransform_generated = {};
Object.defineProperty(dependenciesRowTransform_generated, "__esModule", {
  value: !0
});
dependenciesRowTransform_generated.rowTransformDependencies = void 0;
var _dependenciesIndexClassGenerated = dependenciesIndexClass_generated, _dependenciesMatrixGenerated$3 = dependenciesMatrix_generated, _dependenciesRangeGenerated = dependenciesRange_generated, _dependenciesTypedGenerated$6 = dependenciesTyped_generated, _factoriesAny$6 = factoriesAny, rowTransformDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated.IndexDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$3.matrixDependencies,
  rangeDependencies: _dependenciesRangeGenerated.rangeDependencies,
  typedDependencies: _dependenciesTypedGenerated$6.typedDependencies,
  createRowTransform: _factoriesAny$6.createRowTransform
};
dependenciesRowTransform_generated.rowTransformDependencies = rowTransformDependencies;
var dependenciesSubsetTransform_generated = {};
Object.defineProperty(dependenciesSubsetTransform_generated, "__esModule", {
  value: !0
});
dependenciesSubsetTransform_generated.subsetTransformDependencies = void 0;
var _dependenciesMatrixGenerated$2 = dependenciesMatrix_generated, _dependenciesTypedGenerated$5 = dependenciesTyped_generated, _factoriesAny$5 = factoriesAny, subsetTransformDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated$2.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$5.typedDependencies,
  createSubsetTransform: _factoriesAny$5.createSubsetTransform
};
dependenciesSubsetTransform_generated.subsetTransformDependencies = subsetTransformDependencies;
var dependenciesConcatTransform_generated = {};
Object.defineProperty(dependenciesConcatTransform_generated, "__esModule", {
  value: !0
});
dependenciesConcatTransform_generated.concatTransformDependencies = void 0;
var _dependenciesIsIntegerGenerated = dependenciesIsInteger_generated, _dependenciesMatrixGenerated$1 = dependenciesMatrix_generated, _dependenciesTypedGenerated$4 = dependenciesTyped_generated, _factoriesAny$4 = factoriesAny, concatTransformDependencies = {
  isIntegerDependencies: _dependenciesIsIntegerGenerated.isIntegerDependencies,
  matrixDependencies: _dependenciesMatrixGenerated$1.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated$4.typedDependencies,
  createConcatTransform: _factoriesAny$4.createConcatTransform
};
dependenciesConcatTransform_generated.concatTransformDependencies = concatTransformDependencies;
var dependenciesDiffTransform_generated = {};
Object.defineProperty(dependenciesDiffTransform_generated, "__esModule", {
  value: !0
});
dependenciesDiffTransform_generated.diffTransformDependencies = void 0;
var _dependenciesBignumberGenerated = dependenciesBignumber_generated, _dependenciesMatrixGenerated = dependenciesMatrix_generated, _dependenciesNumberGenerated = dependenciesNumber_generated, _dependenciesSubtractGenerated$1 = dependenciesSubtract_generated, _dependenciesTypedGenerated$3 = dependenciesTyped_generated, _factoriesAny$3 = factoriesAny, diffTransformDependencies = {
  bignumberDependencies: _dependenciesBignumberGenerated.bignumberDependencies,
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  numberDependencies: _dependenciesNumberGenerated.numberDependencies,
  subtractDependencies: _dependenciesSubtractGenerated$1.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated$3.typedDependencies,
  createDiffTransform: _factoriesAny$3.createDiffTransform
};
dependenciesDiffTransform_generated.diffTransformDependencies = diffTransformDependencies;
var dependenciesStdTransform_generated = {};
Object.defineProperty(dependenciesStdTransform_generated, "__esModule", {
  value: !0
});
dependenciesStdTransform_generated.stdTransformDependencies = void 0;
var _dependenciesSqrtGenerated = dependenciesSqrt_generated, _dependenciesTypedGenerated$2 = dependenciesTyped_generated, _dependenciesVarianceGenerated = dependenciesVariance_generated, _factoriesAny$2 = factoriesAny, stdTransformDependencies = {
  sqrtDependencies: _dependenciesSqrtGenerated.sqrtDependencies,
  typedDependencies: _dependenciesTypedGenerated$2.typedDependencies,
  varianceDependencies: _dependenciesVarianceGenerated.varianceDependencies,
  createStdTransform: _factoriesAny$2.createStdTransform
};
dependenciesStdTransform_generated.stdTransformDependencies = stdTransformDependencies;
var dependenciesSumTransform_generated = {};
Object.defineProperty(dependenciesSumTransform_generated, "__esModule", {
  value: !0
});
dependenciesSumTransform_generated.sumTransformDependencies = void 0;
var _dependenciesAddGenerated$1 = dependenciesAdd_generated, _dependenciesNumericGenerated = dependenciesNumeric_generated, _dependenciesTypedGenerated$1 = dependenciesTyped_generated, _factoriesAny$1 = factoriesAny, sumTransformDependencies = {
  addDependencies: _dependenciesAddGenerated$1.addDependencies,
  numericDependencies: _dependenciesNumericGenerated.numericDependencies,
  typedDependencies: _dependenciesTypedGenerated$1.typedDependencies,
  createSumTransform: _factoriesAny$1.createSumTransform
};
dependenciesSumTransform_generated.sumTransformDependencies = sumTransformDependencies;
var dependenciesVarianceTransform_generated = {};
Object.defineProperty(dependenciesVarianceTransform_generated, "__esModule", {
  value: !0
});
dependenciesVarianceTransform_generated.varianceTransformDependencies = void 0;
var _dependenciesAddGenerated = dependenciesAdd_generated, _dependenciesApplyGenerated = dependenciesApply_generated, _dependenciesDivideGenerated = dependenciesDivide_generated, _dependenciesIsNaNGenerated = dependenciesIsNaN_generated, _dependenciesMultiplyGenerated = dependenciesMultiply_generated, _dependenciesSubtractGenerated = dependenciesSubtract_generated, _dependenciesTypedGenerated = dependenciesTyped_generated, _factoriesAny = factoriesAny, varianceTransformDependencies = {
  addDependencies: _dependenciesAddGenerated.addDependencies,
  applyDependencies: _dependenciesApplyGenerated.applyDependencies,
  divideDependencies: _dependenciesDivideGenerated.divideDependencies,
  isNaNDependencies: _dependenciesIsNaNGenerated.isNaNDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated.multiplyDependencies,
  subtractDependencies: _dependenciesSubtractGenerated.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createVarianceTransform: _factoriesAny.createVarianceTransform
};
dependenciesVarianceTransform_generated.varianceTransformDependencies = varianceTransformDependencies;
var allFactoriesAny = {};
function _typeof$4(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(n) {
    return typeof n;
  } : _typeof$4 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$4(t);
}
Object.defineProperty(allFactoriesAny, "__esModule", {
  value: !0
});
allFactoriesAny.all = void 0;
var allFactories = _interopRequireWildcard$1(factoriesAny);
function _getRequireWildcardCache$1() {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap();
  return _getRequireWildcardCache$1 = function() {
    return t;
  }, t;
}
function _interopRequireWildcard$1(t) {
  if (t && t.__esModule)
    return t;
  if (t === null || _typeof$4(t) !== "object" && typeof t != "function")
    return { default: t };
  var r = _getRequireWildcardCache$1();
  if (r && r.has(t))
    return r.get(t);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (Object.prototype.hasOwnProperty.call(t, s)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, s) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, s, o) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
var all = allFactories;
allFactoriesAny.all = all;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "typedDependencies", {
    enumerable: !0,
    get: function() {
      return r.typedDependencies;
    }
  }), Object.defineProperty(t, "ResultSetDependencies", {
    enumerable: !0,
    get: function() {
      return n.ResultSetDependencies;
    }
  }), Object.defineProperty(t, "BigNumberDependencies", {
    enumerable: !0,
    get: function() {
      return a.BigNumberDependencies;
    }
  }), Object.defineProperty(t, "ComplexDependencies", {
    enumerable: !0,
    get: function() {
      return s.ComplexDependencies;
    }
  }), Object.defineProperty(t, "FractionDependencies", {
    enumerable: !0,
    get: function() {
      return o.FractionDependencies;
    }
  }), Object.defineProperty(t, "RangeDependencies", {
    enumerable: !0,
    get: function() {
      return c.RangeDependencies;
    }
  }), Object.defineProperty(t, "MatrixDependencies", {
    enumerable: !0,
    get: function() {
      return l.MatrixDependencies;
    }
  }), Object.defineProperty(t, "DenseMatrixDependencies", {
    enumerable: !0,
    get: function() {
      return d.DenseMatrixDependencies;
    }
  }), Object.defineProperty(t, "cloneDependencies", {
    enumerable: !0,
    get: function() {
      return h.cloneDependencies;
    }
  }), Object.defineProperty(t, "isIntegerDependencies", {
    enumerable: !0,
    get: function() {
      return u.isIntegerDependencies;
    }
  }), Object.defineProperty(t, "isNegativeDependencies", {
    enumerable: !0,
    get: function() {
      return p.isNegativeDependencies;
    }
  }), Object.defineProperty(t, "isNumericDependencies", {
    enumerable: !0,
    get: function() {
      return m.isNumericDependencies;
    }
  }), Object.defineProperty(t, "hasNumericValueDependencies", {
    enumerable: !0,
    get: function() {
      return g.hasNumericValueDependencies;
    }
  }), Object.defineProperty(t, "isPositiveDependencies", {
    enumerable: !0,
    get: function() {
      return v.isPositiveDependencies;
    }
  }), Object.defineProperty(t, "isZeroDependencies", {
    enumerable: !0,
    get: function() {
      return y.isZeroDependencies;
    }
  }), Object.defineProperty(t, "isNaNDependencies", {
    enumerable: !0,
    get: function() {
      return x.isNaNDependencies;
    }
  }), Object.defineProperty(t, "typeOfDependencies", {
    enumerable: !0,
    get: function() {
      return _.typeOfDependencies;
    }
  }), Object.defineProperty(t, "equalScalarDependencies", {
    enumerable: !0,
    get: function() {
      return $.equalScalarDependencies;
    }
  }), Object.defineProperty(t, "SparseMatrixDependencies", {
    enumerable: !0,
    get: function() {
      return b.SparseMatrixDependencies;
    }
  }), Object.defineProperty(t, "numberDependencies", {
    enumerable: !0,
    get: function() {
      return M.numberDependencies;
    }
  }), Object.defineProperty(t, "stringDependencies", {
    enumerable: !0,
    get: function() {
      return C.stringDependencies;
    }
  }), Object.defineProperty(t, "booleanDependencies", {
    enumerable: !0,
    get: function() {
      return S.booleanDependencies;
    }
  }), Object.defineProperty(t, "bignumberDependencies", {
    enumerable: !0,
    get: function() {
      return A.bignumberDependencies;
    }
  }), Object.defineProperty(t, "complexDependencies", {
    enumerable: !0,
    get: function() {
      return D.complexDependencies;
    }
  }), Object.defineProperty(t, "fractionDependencies", {
    enumerable: !0,
    get: function() {
      return N.fractionDependencies;
    }
  }), Object.defineProperty(t, "matrixDependencies", {
    enumerable: !0,
    get: function() {
      return T.matrixDependencies;
    }
  }), Object.defineProperty(t, "splitUnitDependencies", {
    enumerable: !0,
    get: function() {
      return R.splitUnitDependencies;
    }
  }), Object.defineProperty(t, "unaryMinusDependencies", {
    enumerable: !0,
    get: function() {
      return F.unaryMinusDependencies;
    }
  }), Object.defineProperty(t, "unaryPlusDependencies", {
    enumerable: !0,
    get: function() {
      return z.unaryPlusDependencies;
    }
  }), Object.defineProperty(t, "absDependencies", {
    enumerable: !0,
    get: function() {
      return O.absDependencies;
    }
  }), Object.defineProperty(t, "applyDependencies", {
    enumerable: !0,
    get: function() {
      return G.applyDependencies;
    }
  }), Object.defineProperty(t, "addScalarDependencies", {
    enumerable: !0,
    get: function() {
      return I.addScalarDependencies;
    }
  }), Object.defineProperty(t, "cbrtDependencies", {
    enumerable: !0,
    get: function() {
      return k.cbrtDependencies;
    }
  }), Object.defineProperty(t, "ceilDependencies", {
    enumerable: !0,
    get: function() {
      return B.ceilDependencies;
    }
  }), Object.defineProperty(t, "cubeDependencies", {
    enumerable: !0,
    get: function() {
      return L.cubeDependencies;
    }
  }), Object.defineProperty(t, "expDependencies", {
    enumerable: !0,
    get: function() {
      return V.expDependencies;
    }
  }), Object.defineProperty(t, "expm1Dependencies", {
    enumerable: !0,
    get: function() {
      return U.expm1Dependencies;
    }
  }), Object.defineProperty(t, "fixDependencies", {
    enumerable: !0,
    get: function() {
      return J.fixDependencies;
    }
  }), Object.defineProperty(t, "floorDependencies", {
    enumerable: !0,
    get: function() {
      return q.floorDependencies;
    }
  }), Object.defineProperty(t, "gcdDependencies", {
    enumerable: !0,
    get: function() {
      return Z.gcdDependencies;
    }
  }), Object.defineProperty(t, "lcmDependencies", {
    enumerable: !0,
    get: function() {
      return ae.lcmDependencies;
    }
  }), Object.defineProperty(t, "log10Dependencies", {
    enumerable: !0,
    get: function() {
      return ee.log10Dependencies;
    }
  }), Object.defineProperty(t, "log2Dependencies", {
    enumerable: !0,
    get: function() {
      return se.log2Dependencies;
    }
  }), Object.defineProperty(t, "modDependencies", {
    enumerable: !0,
    get: function() {
      return nr.modDependencies;
    }
  }), Object.defineProperty(t, "multiplyScalarDependencies", {
    enumerable: !0,
    get: function() {
      return ce.multiplyScalarDependencies;
    }
  }), Object.defineProperty(t, "multiplyDependencies", {
    enumerable: !0,
    get: function() {
      return oe.multiplyDependencies;
    }
  }), Object.defineProperty(t, "nthRootDependencies", {
    enumerable: !0,
    get: function() {
      return ur.nthRootDependencies;
    }
  }), Object.defineProperty(t, "signDependencies", {
    enumerable: !0,
    get: function() {
      return ir.signDependencies;
    }
  }), Object.defineProperty(t, "sqrtDependencies", {
    enumerable: !0,
    get: function() {
      return _r.sqrtDependencies;
    }
  }), Object.defineProperty(t, "squareDependencies", {
    enumerable: !0,
    get: function() {
      return yr.squareDependencies;
    }
  }), Object.defineProperty(t, "subtractDependencies", {
    enumerable: !0,
    get: function() {
      return ne.subtractDependencies;
    }
  }), Object.defineProperty(t, "xgcdDependencies", {
    enumerable: !0,
    get: function() {
      return pe.xgcdDependencies;
    }
  }), Object.defineProperty(t, "dotMultiplyDependencies", {
    enumerable: !0,
    get: function() {
      return hr.dotMultiplyDependencies;
    }
  }), Object.defineProperty(t, "bitAndDependencies", {
    enumerable: !0,
    get: function() {
      return $r.bitAndDependencies;
    }
  }), Object.defineProperty(t, "bitNotDependencies", {
    enumerable: !0,
    get: function() {
      return Sr.bitNotDependencies;
    }
  }), Object.defineProperty(t, "bitOrDependencies", {
    enumerable: !0,
    get: function() {
      return ze.bitOrDependencies;
    }
  }), Object.defineProperty(t, "bitXorDependencies", {
    enumerable: !0,
    get: function() {
      return cr.bitXorDependencies;
    }
  }), Object.defineProperty(t, "argDependencies", {
    enumerable: !0,
    get: function() {
      return fr.argDependencies;
    }
  }), Object.defineProperty(t, "conjDependencies", {
    enumerable: !0,
    get: function() {
      return mr.conjDependencies;
    }
  }), Object.defineProperty(t, "imDependencies", {
    enumerable: !0,
    get: function() {
      return wr.imDependencies;
    }
  }), Object.defineProperty(t, "reDependencies", {
    enumerable: !0,
    get: function() {
      return Nr.reDependencies;
    }
  }), Object.defineProperty(t, "notDependencies", {
    enumerable: !0,
    get: function() {
      return xr.notDependencies;
    }
  }), Object.defineProperty(t, "orDependencies", {
    enumerable: !0,
    get: function() {
      return Er.orDependencies;
    }
  }), Object.defineProperty(t, "xorDependencies", {
    enumerable: !0,
    get: function() {
      return Ir.xorDependencies;
    }
  }), Object.defineProperty(t, "concatDependencies", {
    enumerable: !0,
    get: function() {
      return Rr.concatDependencies;
    }
  }), Object.defineProperty(t, "columnDependencies", {
    enumerable: !0,
    get: function() {
      return Yr.columnDependencies;
    }
  }), Object.defineProperty(t, "crossDependencies", {
    enumerable: !0,
    get: function() {
      return Qr.crossDependencies;
    }
  }), Object.defineProperty(t, "diagDependencies", {
    enumerable: !0,
    get: function() {
      return nn.diagDependencies;
    }
  }), Object.defineProperty(t, "filterDependencies", {
    enumerable: !0,
    get: function() {
      return on.filterDependencies;
    }
  }), Object.defineProperty(t, "flattenDependencies", {
    enumerable: !0,
    get: function() {
      return en.flattenDependencies;
    }
  }), Object.defineProperty(t, "forEachDependencies", {
    enumerable: !0,
    get: function() {
      return zr.forEachDependencies;
    }
  }), Object.defineProperty(t, "getMatrixDataTypeDependencies", {
    enumerable: !0,
    get: function() {
      return Jr.getMatrixDataTypeDependencies;
    }
  }), Object.defineProperty(t, "identityDependencies", {
    enumerable: !0,
    get: function() {
      return H.identityDependencies;
    }
  }), Object.defineProperty(t, "kronDependencies", {
    enumerable: !0,
    get: function() {
      return dr.kronDependencies;
    }
  }), Object.defineProperty(t, "mapDependencies", {
    enumerable: !0,
    get: function() {
      return Ar.mapDependencies;
    }
  }), Object.defineProperty(t, "diffDependencies", {
    enumerable: !0,
    get: function() {
      return jr.diffDependencies;
    }
  }), Object.defineProperty(t, "onesDependencies", {
    enumerable: !0,
    get: function() {
      return Vr.onesDependencies;
    }
  }), Object.defineProperty(t, "rangeDependencies", {
    enumerable: !0,
    get: function() {
      return Zr.rangeDependencies;
    }
  }), Object.defineProperty(t, "reshapeDependencies", {
    enumerable: !0,
    get: function() {
      return pn.reshapeDependencies;
    }
  }), Object.defineProperty(t, "resizeDependencies", {
    enumerable: !0,
    get: function() {
      return gr.resizeDependencies;
    }
  }), Object.defineProperty(t, "rotateDependencies", {
    enumerable: !0,
    get: function() {
      return Cr.rotateDependencies;
    }
  }), Object.defineProperty(t, "rotationMatrixDependencies", {
    enumerable: !0,
    get: function() {
      return Pr.rotationMatrixDependencies;
    }
  }), Object.defineProperty(t, "rowDependencies", {
    enumerable: !0,
    get: function() {
      return Tr.rowDependencies;
    }
  }), Object.defineProperty(t, "sizeDependencies", {
    enumerable: !0,
    get: function() {
      return Xr.sizeDependencies;
    }
  }), Object.defineProperty(t, "squeezeDependencies", {
    enumerable: !0,
    get: function() {
      return rn.squeezeDependencies;
    }
  }), Object.defineProperty(t, "subsetDependencies", {
    enumerable: !0,
    get: function() {
      return un.subsetDependencies;
    }
  }), Object.defineProperty(t, "transposeDependencies", {
    enumerable: !0,
    get: function() {
      return ln.transposeDependencies;
    }
  }), Object.defineProperty(t, "ctransposeDependencies", {
    enumerable: !0,
    get: function() {
      return bn.ctransposeDependencies;
    }
  }), Object.defineProperty(t, "zerosDependencies", {
    enumerable: !0,
    get: function() {
      return $n.zerosDependencies;
    }
  }), Object.defineProperty(t, "erfDependencies", {
    enumerable: !0,
    get: function() {
      return An.erfDependencies;
    }
  }), Object.defineProperty(t, "modeDependencies", {
    enumerable: !0,
    get: function() {
      return Nn.modeDependencies;
    }
  }), Object.defineProperty(t, "prodDependencies", {
    enumerable: !0,
    get: function() {
      return Pn.prodDependencies;
    }
  }), Object.defineProperty(t, "formatDependencies", {
    enumerable: !0,
    get: function() {
      return Tn.formatDependencies;
    }
  }), Object.defineProperty(t, "binDependencies", {
    enumerable: !0,
    get: function() {
      return pr.binDependencies;
    }
  }), Object.defineProperty(t, "octDependencies", {
    enumerable: !0,
    get: function() {
      return Lr.octDependencies;
    }
  }), Object.defineProperty(t, "hexDependencies", {
    enumerable: !0,
    get: function() {
      return Fr.hexDependencies;
    }
  }), Object.defineProperty(t, "printDependencies", {
    enumerable: !0,
    get: function() {
      return Br.printDependencies;
    }
  }), Object.defineProperty(t, "toDependencies", {
    enumerable: !0,
    get: function() {
      return W.toDependencies;
    }
  }), Object.defineProperty(t, "isPrimeDependencies", {
    enumerable: !0,
    get: function() {
      return Y.isPrimeDependencies;
    }
  }), Object.defineProperty(t, "numericDependencies", {
    enumerable: !0,
    get: function() {
      return X.numericDependencies;
    }
  }), Object.defineProperty(t, "divideScalarDependencies", {
    enumerable: !0,
    get: function() {
      return K.divideScalarDependencies;
    }
  }), Object.defineProperty(t, "powDependencies", {
    enumerable: !0,
    get: function() {
      return te.powDependencies;
    }
  }), Object.defineProperty(t, "roundDependencies", {
    enumerable: !0,
    get: function() {
      return ie.roundDependencies;
    }
  }), Object.defineProperty(t, "logDependencies", {
    enumerable: !0,
    get: function() {
      return lr.logDependencies;
    }
  }), Object.defineProperty(t, "log1pDependencies", {
    enumerable: !0,
    get: function() {
      return vr.log1pDependencies;
    }
  }), Object.defineProperty(t, "nthRootsDependencies", {
    enumerable: !0,
    get: function() {
      return Mr.nthRootsDependencies;
    }
  }), Object.defineProperty(t, "dotPowDependencies", {
    enumerable: !0,
    get: function() {
      return br.dotPowDependencies;
    }
  }), Object.defineProperty(t, "dotDivideDependencies", {
    enumerable: !0,
    get: function() {
      return Dr.dotDivideDependencies;
    }
  }), Object.defineProperty(t, "lsolveDependencies", {
    enumerable: !0,
    get: function() {
      return Or.lsolveDependencies;
    }
  }), Object.defineProperty(t, "usolveDependencies", {
    enumerable: !0,
    get: function() {
      return kr.usolveDependencies;
    }
  }), Object.defineProperty(t, "lsolveAllDependencies", {
    enumerable: !0,
    get: function() {
      return Gr.lsolveAllDependencies;
    }
  }), Object.defineProperty(t, "usolveAllDependencies", {
    enumerable: !0,
    get: function() {
      return tn.usolveAllDependencies;
    }
  }), Object.defineProperty(t, "leftShiftDependencies", {
    enumerable: !0,
    get: function() {
      return Wr.leftShiftDependencies;
    }
  }), Object.defineProperty(t, "rightArithShiftDependencies", {
    enumerable: !0,
    get: function() {
      return yn.rightArithShiftDependencies;
    }
  }), Object.defineProperty(t, "rightLogShiftDependencies", {
    enumerable: !0,
    get: function() {
      return sn.rightLogShiftDependencies;
    }
  }), Object.defineProperty(t, "andDependencies", {
    enumerable: !0,
    get: function() {
      return cn.andDependencies;
    }
  }), Object.defineProperty(t, "compareDependencies", {
    enumerable: !0,
    get: function() {
      return Kr.compareDependencies;
    }
  }), Object.defineProperty(t, "compareNaturalDependencies", {
    enumerable: !0,
    get: function() {
      return dn.compareNaturalDependencies;
    }
  }), Object.defineProperty(t, "compareTextDependencies", {
    enumerable: !0,
    get: function() {
      return On.compareTextDependencies;
    }
  }), Object.defineProperty(t, "equalDependencies", {
    enumerable: !0,
    get: function() {
      return xn.equalDependencies;
    }
  }), Object.defineProperty(t, "equalTextDependencies", {
    enumerable: !0,
    get: function() {
      return Gn.equalTextDependencies;
    }
  }), Object.defineProperty(t, "smallerDependencies", {
    enumerable: !0,
    get: function() {
      return In.smallerDependencies;
    }
  }), Object.defineProperty(t, "smallerEqDependencies", {
    enumerable: !0,
    get: function() {
      return Dn.smallerEqDependencies;
    }
  }), Object.defineProperty(t, "largerDependencies", {
    enumerable: !0,
    get: function() {
      return kn.largerDependencies;
    }
  }), Object.defineProperty(t, "largerEqDependencies", {
    enumerable: !0,
    get: function() {
      return fn.largerEqDependencies;
    }
  }), Object.defineProperty(t, "deepEqualDependencies", {
    enumerable: !0,
    get: function() {
      return wn.deepEqualDependencies;
    }
  }), Object.defineProperty(t, "unequalDependencies", {
    enumerable: !0,
    get: function() {
      return Ln.unequalDependencies;
    }
  }), Object.defineProperty(t, "partitionSelectDependencies", {
    enumerable: !0,
    get: function() {
      return jn.partitionSelectDependencies;
    }
  }), Object.defineProperty(t, "sortDependencies", {
    enumerable: !0,
    get: function() {
      return mn.sortDependencies;
    }
  }), Object.defineProperty(t, "maxDependencies", {
    enumerable: !0,
    get: function() {
      return an.maxDependencies;
    }
  }), Object.defineProperty(t, "minDependencies", {
    enumerable: !0,
    get: function() {
      return $a.minDependencies;
    }
  }), Object.defineProperty(t, "ImmutableDenseMatrixDependencies", {
    enumerable: !0,
    get: function() {
      return xa.ImmutableDenseMatrixDependencies;
    }
  }), Object.defineProperty(t, "IndexDependencies", {
    enumerable: !0,
    get: function() {
      return wa.IndexDependencies;
    }
  }), Object.defineProperty(t, "FibonacciHeapDependencies", {
    enumerable: !0,
    get: function() {
      return Mn.FibonacciHeapDependencies;
    }
  }), Object.defineProperty(t, "SpaDependencies", {
    enumerable: !0,
    get: function() {
      return Kn.SpaDependencies;
    }
  }), Object.defineProperty(t, "UnitDependencies", {
    enumerable: !0,
    get: function() {
      return Ma.UnitDependencies;
    }
  }), Object.defineProperty(t, "unitDependencies", {
    enumerable: !0,
    get: function() {
      return qn.unitDependencies;
    }
  }), Object.defineProperty(t, "sparseDependencies", {
    enumerable: !0,
    get: function() {
      return Cn.sparseDependencies;
    }
  }), Object.defineProperty(t, "createUnitDependencies", {
    enumerable: !0,
    get: function() {
      return ea.createUnitDependencies;
    }
  }), Object.defineProperty(t, "acosDependencies", {
    enumerable: !0,
    get: function() {
      return _n.acosDependencies;
    }
  }), Object.defineProperty(t, "acoshDependencies", {
    enumerable: !0,
    get: function() {
      return Ca.acoshDependencies;
    }
  }), Object.defineProperty(t, "acotDependencies", {
    enumerable: !0,
    get: function() {
      return Sa.acotDependencies;
    }
  }), Object.defineProperty(t, "acothDependencies", {
    enumerable: !0,
    get: function() {
      return Da.acothDependencies;
    }
  }), Object.defineProperty(t, "acscDependencies", {
    enumerable: !0,
    get: function() {
      return Na.acscDependencies;
    }
  }), Object.defineProperty(t, "acschDependencies", {
    enumerable: !0,
    get: function() {
      return Aa.acschDependencies;
    }
  }), Object.defineProperty(t, "asecDependencies", {
    enumerable: !0,
    get: function() {
      return Pa.asecDependencies;
    }
  }), Object.defineProperty(t, "asechDependencies", {
    enumerable: !0,
    get: function() {
      return Rn.asechDependencies;
    }
  }), Object.defineProperty(t, "asinDependencies", {
    enumerable: !0,
    get: function() {
      return Ea.asinDependencies;
    }
  }), Object.defineProperty(t, "asinhDependencies", {
    enumerable: !0,
    get: function() {
      return Ta.asinhDependencies;
    }
  }), Object.defineProperty(t, "atanDependencies", {
    enumerable: !0,
    get: function() {
      return En.atanDependencies;
    }
  }), Object.defineProperty(t, "atan2Dependencies", {
    enumerable: !0,
    get: function() {
      return Oa.atan2Dependencies;
    }
  }), Object.defineProperty(t, "atanhDependencies", {
    enumerable: !0,
    get: function() {
      return Hn.atanhDependencies;
    }
  }), Object.defineProperty(t, "cosDependencies", {
    enumerable: !0,
    get: function() {
      return Zn.cosDependencies;
    }
  }), Object.defineProperty(t, "coshDependencies", {
    enumerable: !0,
    get: function() {
      return Sn.coshDependencies;
    }
  }), Object.defineProperty(t, "cotDependencies", {
    enumerable: !0,
    get: function() {
      return Ia.cotDependencies;
    }
  }), Object.defineProperty(t, "cothDependencies", {
    enumerable: !0,
    get: function() {
      return ka.cothDependencies;
    }
  }), Object.defineProperty(t, "cscDependencies", {
    enumerable: !0,
    get: function() {
      return ta.cscDependencies;
    }
  }), Object.defineProperty(t, "cschDependencies", {
    enumerable: !0,
    get: function() {
      return ra.cschDependencies;
    }
  }), Object.defineProperty(t, "secDependencies", {
    enumerable: !0,
    get: function() {
      return La.secDependencies;
    }
  }), Object.defineProperty(t, "sechDependencies", {
    enumerable: !0,
    get: function() {
      return ja.sechDependencies;
    }
  }), Object.defineProperty(t, "sinDependencies", {
    enumerable: !0,
    get: function() {
      return Ra.sinDependencies;
    }
  }), Object.defineProperty(t, "sinhDependencies", {
    enumerable: !0,
    get: function() {
      return Fa.sinhDependencies;
    }
  }), Object.defineProperty(t, "tanDependencies", {
    enumerable: !0,
    get: function() {
      return na.tanDependencies;
    }
  }), Object.defineProperty(t, "tanhDependencies", {
    enumerable: !0,
    get: function() {
      return Wn.tanhDependencies;
    }
  }), Object.defineProperty(t, "setCartesianDependencies", {
    enumerable: !0,
    get: function() {
      return Ba.setCartesianDependencies;
    }
  }), Object.defineProperty(t, "setDifferenceDependencies", {
    enumerable: !0,
    get: function() {
      return Ga.setDifferenceDependencies;
    }
  }), Object.defineProperty(t, "setDistinctDependencies", {
    enumerable: !0,
    get: function() {
      return za.setDistinctDependencies;
    }
  }), Object.defineProperty(t, "setIntersectDependencies", {
    enumerable: !0,
    get: function() {
      return Yn.setIntersectDependencies;
    }
  }), Object.defineProperty(t, "setIsSubsetDependencies", {
    enumerable: !0,
    get: function() {
      return Fn.setIsSubsetDependencies;
    }
  }), Object.defineProperty(t, "setMultiplicityDependencies", {
    enumerable: !0,
    get: function() {
      return Va.setMultiplicityDependencies;
    }
  }), Object.defineProperty(t, "setPowersetDependencies", {
    enumerable: !0,
    get: function() {
      return aa.setPowersetDependencies;
    }
  }), Object.defineProperty(t, "setSizeDependencies", {
    enumerable: !0,
    get: function() {
      return Wa.setSizeDependencies;
    }
  }), Object.defineProperty(t, "setSymDifferenceDependencies", {
    enumerable: !0,
    get: function() {
      return Ua.setSymDifferenceDependencies;
    }
  }), Object.defineProperty(t, "setUnionDependencies", {
    enumerable: !0,
    get: function() {
      return qa.setUnionDependencies;
    }
  }), Object.defineProperty(t, "addDependencies", {
    enumerable: !0,
    get: function() {
      return Ha.addDependencies;
    }
  }), Object.defineProperty(t, "hypotDependencies", {
    enumerable: !0,
    get: function() {
      return Za.hypotDependencies;
    }
  }), Object.defineProperty(t, "normDependencies", {
    enumerable: !0,
    get: function() {
      return Ya.normDependencies;
    }
  }), Object.defineProperty(t, "dotDependencies", {
    enumerable: !0,
    get: function() {
      return ia.dotDependencies;
    }
  }), Object.defineProperty(t, "traceDependencies", {
    enumerable: !0,
    get: function() {
      return Un.traceDependencies;
    }
  }), Object.defineProperty(t, "indexDependencies", {
    enumerable: !0,
    get: function() {
      return Xa.indexDependencies;
    }
  }), Object.defineProperty(t, "NodeDependencies", {
    enumerable: !0,
    get: function() {
      return sa.NodeDependencies;
    }
  }), Object.defineProperty(t, "AccessorNodeDependencies", {
    enumerable: !0,
    get: function() {
      return gn.AccessorNodeDependencies;
    }
  }), Object.defineProperty(t, "ArrayNodeDependencies", {
    enumerable: !0,
    get: function() {
      return Qa.ArrayNodeDependencies;
    }
  }), Object.defineProperty(t, "AssignmentNodeDependencies", {
    enumerable: !0,
    get: function() {
      return Xn.AssignmentNodeDependencies;
    }
  }), Object.defineProperty(t, "BlockNodeDependencies", {
    enumerable: !0,
    get: function() {
      return Ja.BlockNodeDependencies;
    }
  }), Object.defineProperty(t, "ConditionalNodeDependencies", {
    enumerable: !0,
    get: function() {
      return Ka.ConditionalNodeDependencies;
    }
  }), Object.defineProperty(t, "ConstantNodeDependencies", {
    enumerable: !0,
    get: function() {
      return zn.ConstantNodeDependencies;
    }
  }), Object.defineProperty(t, "FunctionAssignmentNodeDependencies", {
    enumerable: !0,
    get: function() {
      return oa.FunctionAssignmentNodeDependencies;
    }
  }), Object.defineProperty(t, "IndexNodeDependencies", {
    enumerable: !0,
    get: function() {
      return ei.IndexNodeDependencies;
    }
  }), Object.defineProperty(t, "ObjectNodeDependencies", {
    enumerable: !0,
    get: function() {
      return ca.ObjectNodeDependencies;
    }
  }), Object.defineProperty(t, "OperatorNodeDependencies", {
    enumerable: !0,
    get: function() {
      return da.OperatorNodeDependencies;
    }
  }), Object.defineProperty(t, "ParenthesisNodeDependencies", {
    enumerable: !0,
    get: function() {
      return ti.ParenthesisNodeDependencies;
    }
  }), Object.defineProperty(t, "RangeNodeDependencies", {
    enumerable: !0,
    get: function() {
      return la.RangeNodeDependencies;
    }
  }), Object.defineProperty(t, "RelationalNodeDependencies", {
    enumerable: !0,
    get: function() {
      return ri.RelationalNodeDependencies;
    }
  }), Object.defineProperty(t, "SymbolNodeDependencies", {
    enumerable: !0,
    get: function() {
      return ni.SymbolNodeDependencies;
    }
  }), Object.defineProperty(t, "FunctionNodeDependencies", {
    enumerable: !0,
    get: function() {
      return ai.FunctionNodeDependencies;
    }
  }), Object.defineProperty(t, "parseDependencies", {
    enumerable: !0,
    get: function() {
      return hn.parseDependencies;
    }
  }), Object.defineProperty(t, "compileDependencies", {
    enumerable: !0,
    get: function() {
      return ii.compileDependencies;
    }
  }), Object.defineProperty(t, "evaluateDependencies", {
    enumerable: !0,
    get: function() {
      return ua.evaluateDependencies;
    }
  }), Object.defineProperty(t, "ParserDependencies", {
    enumerable: !0,
    get: function() {
      return si.ParserDependencies;
    }
  }), Object.defineProperty(t, "parserDependencies", {
    enumerable: !0,
    get: function() {
      return pa.parserDependencies;
    }
  }), Object.defineProperty(t, "lupDependencies", {
    enumerable: !0,
    get: function() {
      return oi.lupDependencies;
    }
  }), Object.defineProperty(t, "qrDependencies", {
    enumerable: !0,
    get: function() {
      return Qn.qrDependencies;
    }
  }), Object.defineProperty(t, "sluDependencies", {
    enumerable: !0,
    get: function() {
      return fa.sluDependencies;
    }
  }), Object.defineProperty(t, "lusolveDependencies", {
    enumerable: !0,
    get: function() {
      return ha.lusolveDependencies;
    }
  }), Object.defineProperty(t, "HelpDependencies", {
    enumerable: !0,
    get: function() {
      return ci.HelpDependencies;
    }
  }), Object.defineProperty(t, "ChainDependencies", {
    enumerable: !0,
    get: function() {
      return ma.ChainDependencies;
    }
  }), Object.defineProperty(t, "helpDependencies", {
    enumerable: !0,
    get: function() {
      return di.helpDependencies;
    }
  }), Object.defineProperty(t, "chainDependencies", {
    enumerable: !0,
    get: function() {
      return li.chainDependencies;
    }
  }), Object.defineProperty(t, "detDependencies", {
    enumerable: !0,
    get: function() {
      return Jn.detDependencies;
    }
  }), Object.defineProperty(t, "invDependencies", {
    enumerable: !0,
    get: function() {
      return ga.invDependencies;
    }
  }), Object.defineProperty(t, "eigsDependencies", {
    enumerable: !0,
    get: function() {
      return ui.eigsDependencies;
    }
  }), Object.defineProperty(t, "expmDependencies", {
    enumerable: !0,
    get: function() {
      return fi.expmDependencies;
    }
  }), Object.defineProperty(t, "sqrtmDependencies", {
    enumerable: !0,
    get: function() {
      return hi.sqrtmDependencies;
    }
  }), Object.defineProperty(t, "divideDependencies", {
    enumerable: !0,
    get: function() {
      return Vn.divideDependencies;
    }
  }), Object.defineProperty(t, "distanceDependencies", {
    enumerable: !0,
    get: function() {
      return mi.distanceDependencies;
    }
  }), Object.defineProperty(t, "intersectDependencies", {
    enumerable: !0,
    get: function() {
      return Bn.intersectDependencies;
    }
  }), Object.defineProperty(t, "sumDependencies", {
    enumerable: !0,
    get: function() {
      return gi.sumDependencies;
    }
  }), Object.defineProperty(t, "meanDependencies", {
    enumerable: !0,
    get: function() {
      return va.meanDependencies;
    }
  }), Object.defineProperty(t, "medianDependencies", {
    enumerable: !0,
    get: function() {
      return vi.medianDependencies;
    }
  }), Object.defineProperty(t, "madDependencies", {
    enumerable: !0,
    get: function() {
      return yi.madDependencies;
    }
  }), Object.defineProperty(t, "varianceDependencies", {
    enumerable: !0,
    get: function() {
      return bi.varianceDependencies;
    }
  }), Object.defineProperty(t, "quantileSeqDependencies", {
    enumerable: !0,
    get: function() {
      return Hr.quantileSeqDependencies;
    }
  }), Object.defineProperty(t, "stdDependencies", {
    enumerable: !0,
    get: function() {
      return $i.stdDependencies;
    }
  }), Object.defineProperty(t, "combinationsDependencies", {
    enumerable: !0,
    get: function() {
      return ya.combinationsDependencies;
    }
  }), Object.defineProperty(t, "combinationsWithRepDependencies", {
    enumerable: !0,
    get: function() {
      return xi.combinationsWithRepDependencies;
    }
  }), Object.defineProperty(t, "gammaDependencies", {
    enumerable: !0,
    get: function() {
      return wi.gammaDependencies;
    }
  }), Object.defineProperty(t, "factorialDependencies", {
    enumerable: !0,
    get: function() {
      return Mi.factorialDependencies;
    }
  }), Object.defineProperty(t, "kldivergenceDependencies", {
    enumerable: !0,
    get: function() {
      return Ci.kldivergenceDependencies;
    }
  }), Object.defineProperty(t, "multinomialDependencies", {
    enumerable: !0,
    get: function() {
      return Si.multinomialDependencies;
    }
  }), Object.defineProperty(t, "permutationsDependencies", {
    enumerable: !0,
    get: function() {
      return Di.permutationsDependencies;
    }
  }), Object.defineProperty(t, "pickRandomDependencies", {
    enumerable: !0,
    get: function() {
      return Ni.pickRandomDependencies;
    }
  }), Object.defineProperty(t, "randomDependencies", {
    enumerable: !0,
    get: function() {
      return Ai.randomDependencies;
    }
  }), Object.defineProperty(t, "randomIntDependencies", {
    enumerable: !0,
    get: function() {
      return Pi.randomIntDependencies;
    }
  }), Object.defineProperty(t, "stirlingS2Dependencies", {
    enumerable: !0,
    get: function() {
      return Ei.stirlingS2Dependencies;
    }
  }), Object.defineProperty(t, "bellNumbersDependencies", {
    enumerable: !0,
    get: function() {
      return Ti.bellNumbersDependencies;
    }
  }), Object.defineProperty(t, "catalanDependencies", {
    enumerable: !0,
    get: function() {
      return Oi.catalanDependencies;
    }
  }), Object.defineProperty(t, "compositionDependencies", {
    enumerable: !0,
    get: function() {
      return Ii.compositionDependencies;
    }
  }), Object.defineProperty(t, "simplifyDependencies", {
    enumerable: !0,
    get: function() {
      return ki.simplifyDependencies;
    }
  }), Object.defineProperty(t, "derivativeDependencies", {
    enumerable: !0,
    get: function() {
      return Li.derivativeDependencies;
    }
  }), Object.defineProperty(t, "rationalizeDependencies", {
    enumerable: !0,
    get: function() {
      return ji.rationalizeDependencies;
    }
  }), Object.defineProperty(t, "reviverDependencies", {
    enumerable: !0,
    get: function() {
      return Ri.reviverDependencies;
    }
  }), Object.defineProperty(t, "replacerDependencies", {
    enumerable: !0,
    get: function() {
      return Fi.replacerDependencies;
    }
  }), Object.defineProperty(t, "eDependencies", {
    enumerable: !0,
    get: function() {
      return vn.eDependencies;
    }
  }), Object.defineProperty(t, "EDependencies", {
    enumerable: !0,
    get: function() {
      return Ur.EDependencies;
    }
  }), Object.defineProperty(t, "falseDependencies", {
    enumerable: !0,
    get: function() {
      return Bi.falseDependencies;
    }
  }), Object.defineProperty(t, "iDependencies", {
    enumerable: !0,
    get: function() {
      return Gi.iDependencies;
    }
  }), Object.defineProperty(t, "InfinityDependencies", {
    enumerable: !0,
    get: function() {
      return zi.InfinityDependencies;
    }
  }), Object.defineProperty(t, "LN10Dependencies", {
    enumerable: !0,
    get: function() {
      return Vi.LN10Dependencies;
    }
  }), Object.defineProperty(t, "LN2Dependencies", {
    enumerable: !0,
    get: function() {
      return Wi.LN2Dependencies;
    }
  }), Object.defineProperty(t, "LOG10EDependencies", {
    enumerable: !0,
    get: function() {
      return _a.LOG10EDependencies;
    }
  }), Object.defineProperty(t, "LOG2EDependencies", {
    enumerable: !0,
    get: function() {
      return ba.LOG2EDependencies;
    }
  }), Object.defineProperty(t, "NaNDependencies", {
    enumerable: !0,
    get: function() {
      return Ui.NaNDependencies;
    }
  }), Object.defineProperty(t, "nullDependencies", {
    enumerable: !0,
    get: function() {
      return qi.nullDependencies;
    }
  }), Object.defineProperty(t, "phiDependencies", {
    enumerable: !0,
    get: function() {
      return Hi.phiDependencies;
    }
  }), Object.defineProperty(t, "piDependencies", {
    enumerable: !0,
    get: function() {
      return Zi.piDependencies;
    }
  }), Object.defineProperty(t, "PIDependencies", {
    enumerable: !0,
    get: function() {
      return Yi.PIDependencies;
    }
  }), Object.defineProperty(t, "SQRT1_2Dependencies", {
    enumerable: !0,
    get: function() {
      return Xi.SQRT1_2Dependencies;
    }
  }), Object.defineProperty(t, "SQRT2Dependencies", {
    enumerable: !0,
    get: function() {
      return Qi.SQRT2Dependencies;
    }
  }), Object.defineProperty(t, "tauDependencies", {
    enumerable: !0,
    get: function() {
      return Ji.tauDependencies;
    }
  }), Object.defineProperty(t, "trueDependencies", {
    enumerable: !0,
    get: function() {
      return Ki.trueDependencies;
    }
  }), Object.defineProperty(t, "versionDependencies", {
    enumerable: !0,
    get: function() {
      return ts.versionDependencies;
    }
  }), Object.defineProperty(t, "atomicMassDependencies", {
    enumerable: !0,
    get: function() {
      return Ue.atomicMassDependencies;
    }
  }), Object.defineProperty(t, "avogadroDependencies", {
    enumerable: !0,
    get: function() {
      return ss.avogadroDependencies;
    }
  }), Object.defineProperty(t, "bohrMagnetonDependencies", {
    enumerable: !0,
    get: function() {
      return os.bohrMagnetonDependencies;
    }
  }), Object.defineProperty(t, "bohrRadiusDependencies", {
    enumerable: !0,
    get: function() {
      return cs.bohrRadiusDependencies;
    }
  }), Object.defineProperty(t, "boltzmannDependencies", {
    enumerable: !0,
    get: function() {
      return ds.boltzmannDependencies;
    }
  }), Object.defineProperty(t, "classicalElectronRadiusDependencies", {
    enumerable: !0,
    get: function() {
      return rs.classicalElectronRadiusDependencies;
    }
  }), Object.defineProperty(t, "conductanceQuantumDependencies", {
    enumerable: !0,
    get: function() {
      return ns.conductanceQuantumDependencies;
    }
  }), Object.defineProperty(t, "coulombDependencies", {
    enumerable: !0,
    get: function() {
      return ls.coulombDependencies;
    }
  }), Object.defineProperty(t, "deuteronMassDependencies", {
    enumerable: !0,
    get: function() {
      return us.deuteronMassDependencies;
    }
  }), Object.defineProperty(t, "efimovFactorDependencies", {
    enumerable: !0,
    get: function() {
      return ps.efimovFactorDependencies;
    }
  }), Object.defineProperty(t, "electricConstantDependencies", {
    enumerable: !0,
    get: function() {
      return fs.electricConstantDependencies;
    }
  }), Object.defineProperty(t, "electronMassDependencies", {
    enumerable: !0,
    get: function() {
      return hs.electronMassDependencies;
    }
  }), Object.defineProperty(t, "elementaryChargeDependencies", {
    enumerable: !0,
    get: function() {
      return ms.elementaryChargeDependencies;
    }
  }), Object.defineProperty(t, "faradayDependencies", {
    enumerable: !0,
    get: function() {
      return gs.faradayDependencies;
    }
  }), Object.defineProperty(t, "fermiCouplingDependencies", {
    enumerable: !0,
    get: function() {
      return vs.fermiCouplingDependencies;
    }
  }), Object.defineProperty(t, "fineStructureDependencies", {
    enumerable: !0,
    get: function() {
      return ys.fineStructureDependencies;
    }
  }), Object.defineProperty(t, "firstRadiationDependencies", {
    enumerable: !0,
    get: function() {
      return _s.firstRadiationDependencies;
    }
  }), Object.defineProperty(t, "gasConstantDependencies", {
    enumerable: !0,
    get: function() {
      return bs.gasConstantDependencies;
    }
  }), Object.defineProperty(t, "gravitationConstantDependencies", {
    enumerable: !0,
    get: function() {
      return $s.gravitationConstantDependencies;
    }
  }), Object.defineProperty(t, "gravityDependencies", {
    enumerable: !0,
    get: function() {
      return xs.gravityDependencies;
    }
  }), Object.defineProperty(t, "hartreeEnergyDependencies", {
    enumerable: !0,
    get: function() {
      return ws.hartreeEnergyDependencies;
    }
  }), Object.defineProperty(t, "inverseConductanceQuantumDependencies", {
    enumerable: !0,
    get: function() {
      return Ms.inverseConductanceQuantumDependencies;
    }
  }), Object.defineProperty(t, "klitzingDependencies", {
    enumerable: !0,
    get: function() {
      return Cs.klitzingDependencies;
    }
  }), Object.defineProperty(t, "loschmidtDependencies", {
    enumerable: !0,
    get: function() {
      return Ss.loschmidtDependencies;
    }
  }), Object.defineProperty(t, "magneticConstantDependencies", {
    enumerable: !0,
    get: function() {
      return Ds.magneticConstantDependencies;
    }
  }), Object.defineProperty(t, "magneticFluxQuantumDependencies", {
    enumerable: !0,
    get: function() {
      return Ns.magneticFluxQuantumDependencies;
    }
  }), Object.defineProperty(t, "molarMassDependencies", {
    enumerable: !0,
    get: function() {
      return As.molarMassDependencies;
    }
  }), Object.defineProperty(t, "molarMassC12Dependencies", {
    enumerable: !0,
    get: function() {
      return Ps.molarMassC12Dependencies;
    }
  }), Object.defineProperty(t, "molarPlanckConstantDependencies", {
    enumerable: !0,
    get: function() {
      return Es.molarPlanckConstantDependencies;
    }
  }), Object.defineProperty(t, "molarVolumeDependencies", {
    enumerable: !0,
    get: function() {
      return Ts.molarVolumeDependencies;
    }
  }), Object.defineProperty(t, "neutronMassDependencies", {
    enumerable: !0,
    get: function() {
      return Os.neutronMassDependencies;
    }
  }), Object.defineProperty(t, "nuclearMagnetonDependencies", {
    enumerable: !0,
    get: function() {
      return Is.nuclearMagnetonDependencies;
    }
  }), Object.defineProperty(t, "planckChargeDependencies", {
    enumerable: !0,
    get: function() {
      return ks.planckChargeDependencies;
    }
  }), Object.defineProperty(t, "planckConstantDependencies", {
    enumerable: !0,
    get: function() {
      return Ls.planckConstantDependencies;
    }
  }), Object.defineProperty(t, "planckLengthDependencies", {
    enumerable: !0,
    get: function() {
      return js.planckLengthDependencies;
    }
  }), Object.defineProperty(t, "planckMassDependencies", {
    enumerable: !0,
    get: function() {
      return Rs.planckMassDependencies;
    }
  }), Object.defineProperty(t, "planckTemperatureDependencies", {
    enumerable: !0,
    get: function() {
      return Fs.planckTemperatureDependencies;
    }
  }), Object.defineProperty(t, "planckTimeDependencies", {
    enumerable: !0,
    get: function() {
      return Bs.planckTimeDependencies;
    }
  }), Object.defineProperty(t, "protonMassDependencies", {
    enumerable: !0,
    get: function() {
      return Gs.protonMassDependencies;
    }
  }), Object.defineProperty(t, "quantumOfCirculationDependencies", {
    enumerable: !0,
    get: function() {
      return zs.quantumOfCirculationDependencies;
    }
  }), Object.defineProperty(t, "reducedPlanckConstantDependencies", {
    enumerable: !0,
    get: function() {
      return Vs.reducedPlanckConstantDependencies;
    }
  }), Object.defineProperty(t, "rydbergDependencies", {
    enumerable: !0,
    get: function() {
      return Ws.rydbergDependencies;
    }
  }), Object.defineProperty(t, "sackurTetrodeDependencies", {
    enumerable: !0,
    get: function() {
      return Us.sackurTetrodeDependencies;
    }
  }), Object.defineProperty(t, "secondRadiationDependencies", {
    enumerable: !0,
    get: function() {
      return qs.secondRadiationDependencies;
    }
  }), Object.defineProperty(t, "speedOfLightDependencies", {
    enumerable: !0,
    get: function() {
      return Hs.speedOfLightDependencies;
    }
  }), Object.defineProperty(t, "stefanBoltzmannDependencies", {
    enumerable: !0,
    get: function() {
      return Zs.stefanBoltzmannDependencies;
    }
  }), Object.defineProperty(t, "thomsonCrossSectionDependencies", {
    enumerable: !0,
    get: function() {
      return Ys.thomsonCrossSectionDependencies;
    }
  }), Object.defineProperty(t, "vacuumImpedanceDependencies", {
    enumerable: !0,
    get: function() {
      return Xs.vacuumImpedanceDependencies;
    }
  }), Object.defineProperty(t, "weakMixingAngleDependencies", {
    enumerable: !0,
    get: function() {
      return Qs.weakMixingAngleDependencies;
    }
  }), Object.defineProperty(t, "wienDisplacementDependencies", {
    enumerable: !0,
    get: function() {
      return Js.wienDisplacementDependencies;
    }
  }), Object.defineProperty(t, "applyTransformDependencies", {
    enumerable: !0,
    get: function() {
      return Ks.applyTransformDependencies;
    }
  }), Object.defineProperty(t, "columnTransformDependencies", {
    enumerable: !0,
    get: function() {
      return eo.columnTransformDependencies;
    }
  }), Object.defineProperty(t, "filterTransformDependencies", {
    enumerable: !0,
    get: function() {
      return ro.filterTransformDependencies;
    }
  }), Object.defineProperty(t, "forEachTransformDependencies", {
    enumerable: !0,
    get: function() {
      return no.forEachTransformDependencies;
    }
  }), Object.defineProperty(t, "indexTransformDependencies", {
    enumerable: !0,
    get: function() {
      return ao.indexTransformDependencies;
    }
  }), Object.defineProperty(t, "mapTransformDependencies", {
    enumerable: !0,
    get: function() {
      return io.mapTransformDependencies;
    }
  }), Object.defineProperty(t, "maxTransformDependencies", {
    enumerable: !0,
    get: function() {
      return so.maxTransformDependencies;
    }
  }), Object.defineProperty(t, "meanTransformDependencies", {
    enumerable: !0,
    get: function() {
      return oo.meanTransformDependencies;
    }
  }), Object.defineProperty(t, "minTransformDependencies", {
    enumerable: !0,
    get: function() {
      return co.minTransformDependencies;
    }
  }), Object.defineProperty(t, "rangeTransformDependencies", {
    enumerable: !0,
    get: function() {
      return lo.rangeTransformDependencies;
    }
  }), Object.defineProperty(t, "rowTransformDependencies", {
    enumerable: !0,
    get: function() {
      return uo.rowTransformDependencies;
    }
  }), Object.defineProperty(t, "subsetTransformDependencies", {
    enumerable: !0,
    get: function() {
      return po.subsetTransformDependencies;
    }
  }), Object.defineProperty(t, "concatTransformDependencies", {
    enumerable: !0,
    get: function() {
      return fo.concatTransformDependencies;
    }
  }), Object.defineProperty(t, "diffTransformDependencies", {
    enumerable: !0,
    get: function() {
      return ho.diffTransformDependencies;
    }
  }), Object.defineProperty(t, "stdTransformDependencies", {
    enumerable: !0,
    get: function() {
      return mo.stdTransformDependencies;
    }
  }), Object.defineProperty(t, "sumTransformDependencies", {
    enumerable: !0,
    get: function() {
      return go.sumTransformDependencies;
    }
  }), Object.defineProperty(t, "varianceTransformDependencies", {
    enumerable: !0,
    get: function() {
      return vo.varianceTransformDependencies;
    }
  }), Object.defineProperty(t, "all", {
    enumerable: !0,
    get: function() {
      return yo.all;
    }
  });
  var r = dependenciesTyped_generated, n = dependenciesResultSet_generated, a = dependenciesBigNumberClass_generated, s = dependenciesComplexClass_generated, o = dependenciesFractionClass_generated, c = dependenciesRangeClass_generated, l = dependenciesMatrixClass_generated, d = dependenciesDenseMatrixClass_generated, h = dependenciesClone_generated, u = dependenciesIsInteger_generated, p = dependenciesIsNegative_generated, m = dependenciesIsNumeric_generated, g = dependenciesHasNumericValue_generated, v = dependenciesIsPositive_generated, y = dependenciesIsZero_generated, x = dependenciesIsNaN_generated, _ = dependenciesTypeOf_generated, $ = dependenciesEqualScalar_generated, b = dependenciesSparseMatrixClass_generated, M = dependenciesNumber_generated, C = dependenciesString_generated, S = dependenciesBoolean_generated, A = dependenciesBignumber_generated, D = dependenciesComplex_generated, N = dependenciesFraction_generated, T = dependenciesMatrix_generated, R = dependenciesSplitUnit_generated, F = dependenciesUnaryMinus_generated, z = dependenciesUnaryPlus_generated, O = dependenciesAbs_generated, G = dependenciesApply_generated, I = dependenciesAddScalar_generated, k = dependenciesCbrt_generated, B = dependenciesCeil_generated, L = dependenciesCube_generated, V = dependenciesExp_generated, U = dependenciesExpm1_generated, J = dependenciesFix_generated, q = dependenciesFloor_generated, Z = dependenciesGcd_generated, ae = dependenciesLcm_generated, ee = dependenciesLog10_generated, se = dependenciesLog2_generated, nr = dependenciesMod_generated, ce = dependenciesMultiplyScalar_generated, oe = dependenciesMultiply_generated, ur = dependenciesNthRoot_generated, ir = dependenciesSign_generated, _r = dependenciesSqrt_generated, yr = dependenciesSquare_generated, ne = dependenciesSubtract_generated, pe = dependenciesXgcd_generated, hr = dependenciesDotMultiply_generated, $r = dependenciesBitAnd_generated, Sr = dependenciesBitNot_generated, ze = dependenciesBitOr_generated, cr = dependenciesBitXor_generated, fr = dependenciesArg_generated, mr = dependenciesConj_generated, wr = dependenciesIm_generated, Nr = dependenciesRe_generated, xr = dependenciesNot_generated, Er = dependenciesOr_generated, Ir = dependenciesXor_generated, Rr = dependenciesConcat_generated, Yr = dependenciesColumn_generated, Qr = dependenciesCross_generated, nn = dependenciesDiag_generated, on = dependenciesFilter_generated, en = dependenciesFlatten_generated, zr = dependenciesForEach_generated, Jr = dependenciesGetMatrixDataType_generated, H = dependenciesIdentity_generated, dr = dependenciesKron_generated, Ar = dependenciesMap_generated, jr = dependenciesDiff_generated, Vr = dependenciesOnes_generated, Zr = dependenciesRange_generated, pn = dependenciesReshape_generated, gr = dependenciesResize_generated, Cr = dependenciesRotate_generated, Pr = dependenciesRotationMatrix_generated, Tr = dependenciesRow_generated, Xr = dependenciesSize_generated, rn = dependenciesSqueeze_generated, un = dependenciesSubset_generated, ln = dependenciesTranspose_generated, bn = dependenciesCtranspose_generated, $n = dependenciesZeros_generated, An = dependenciesErf_generated, Nn = dependenciesMode_generated, Pn = dependenciesProd_generated, Tn = dependenciesFormat_generated, pr = dependenciesBin_generated, Lr = dependenciesOct_generated, Fr = dependenciesHex_generated, Br = dependenciesPrint_generated, W = dependenciesTo_generated, Y = dependenciesIsPrime_generated, X = dependenciesNumeric_generated, K = dependenciesDivideScalar_generated, te = dependenciesPow_generated, ie = dependenciesRound_generated, lr = dependenciesLog_generated, vr = dependenciesLog1p_generated, Mr = dependenciesNthRoots_generated, br = dependenciesDotPow_generated, Dr = dependenciesDotDivide_generated, Or = dependenciesLsolve_generated, kr = dependenciesUsolve_generated, Gr = dependenciesLsolveAll_generated, tn = dependenciesUsolveAll_generated, Wr = dependenciesLeftShift_generated, yn = dependenciesRightArithShift_generated, sn = dependenciesRightLogShift_generated, cn = dependenciesAnd_generated, Kr = dependenciesCompare_generated, dn = dependenciesCompareNatural_generated, On = dependenciesCompareText_generated, xn = dependenciesEqual_generated, Gn = dependenciesEqualText_generated, In = dependenciesSmaller_generated, Dn = dependenciesSmallerEq_generated, kn = dependenciesLarger_generated, fn = dependenciesLargerEq_generated, wn = dependenciesDeepEqual_generated, Ln = dependenciesUnequal_generated, jn = dependenciesPartitionSelect_generated, mn = dependenciesSort_generated, an = dependenciesMax_generated, $a = dependenciesMin_generated, xa = dependenciesImmutableDenseMatrixClass_generated, wa = dependenciesIndexClass_generated, Mn = dependenciesFibonacciHeapClass_generated, Kn = dependenciesSpaClass_generated, Ma = dependenciesUnitClass_generated, qn = dependenciesUnitFunction_generated, Cn = dependenciesSparse_generated, ea = dependenciesCreateUnit_generated, _n = dependenciesAcos_generated, Ca = dependenciesAcosh_generated, Sa = dependenciesAcot_generated, Da = dependenciesAcoth_generated, Na = dependenciesAcsc_generated, Aa = dependenciesAcsch_generated, Pa = dependenciesAsec_generated, Rn = dependenciesAsech_generated, Ea = dependenciesAsin_generated, Ta = dependenciesAsinh_generated, En = dependenciesAtan_generated, Oa = dependenciesAtan2_generated, Hn = dependenciesAtanh_generated, Zn = dependenciesCos_generated, Sn = dependenciesCosh_generated, Ia = dependenciesCot_generated, ka = dependenciesCoth_generated, ta = dependenciesCsc_generated, ra = dependenciesCsch_generated, La = dependenciesSec_generated, ja = dependenciesSech_generated, Ra = dependenciesSin_generated, Fa = dependenciesSinh_generated, na = dependenciesTan_generated, Wn = dependenciesTanh_generated, Ba = dependenciesSetCartesian_generated, Ga = dependenciesSetDifference_generated, za = dependenciesSetDistinct_generated, Yn = dependenciesSetIntersect_generated, Fn = dependenciesSetIsSubset_generated, Va = dependenciesSetMultiplicity_generated, aa = dependenciesSetPowerset_generated, Wa = dependenciesSetSize_generated, Ua = dependenciesSetSymDifference_generated, qa = dependenciesSetUnion_generated, Ha = dependenciesAdd_generated, Za = dependenciesHypot_generated, Ya = dependenciesNorm_generated, ia = dependenciesDot_generated, Un = dependenciesTrace_generated, Xa = dependenciesIndex_generated, sa = dependenciesNode_generated, gn = dependenciesAccessorNode_generated, Qa = dependenciesArrayNode_generated, Xn = dependenciesAssignmentNode_generated, Ja = dependenciesBlockNode_generated, Ka = dependenciesConditionalNode_generated, zn = dependenciesConstantNode_generated, oa = dependenciesFunctionAssignmentNode_generated, ei = dependenciesIndexNode_generated, ca = dependenciesObjectNode_generated, da = dependenciesOperatorNode_generated, ti = dependenciesParenthesisNode_generated, la = dependenciesRangeNode_generated, ri = dependenciesRelationalNode_generated, ni = dependenciesSymbolNode_generated, ai = dependenciesFunctionNode_generated, hn = dependenciesParse_generated, ii = dependenciesCompile_generated, ua = dependenciesEvaluate_generated, si = dependenciesParserClass_generated, pa = dependenciesParser_generated, oi = dependenciesLup_generated, Qn = dependenciesQr_generated, fa = dependenciesSlu_generated, ha = dependenciesLusolve_generated, ci = dependenciesHelpClass_generated, ma = dependenciesChainClass_generated, di = dependenciesHelp_generated, li = dependenciesChain_generated, Jn = dependenciesDet_generated, ga = dependenciesInv_generated, ui = dependenciesEigs_generated, fi = dependenciesExpm_generated, hi = dependenciesSqrtm_generated, Vn = dependenciesDivide_generated, mi = dependenciesDistance_generated, Bn = dependenciesIntersect_generated, gi = dependenciesSum_generated, va = dependenciesMean_generated, vi = dependenciesMedian_generated, yi = dependenciesMad_generated, bi = dependenciesVariance_generated, Hr = dependenciesQuantileSeq_generated, $i = dependenciesStd_generated, ya = dependenciesCombinations_generated, xi = dependenciesCombinationsWithRep_generated, wi = dependenciesGamma_generated, Mi = dependenciesFactorial_generated, Ci = dependenciesKldivergence_generated, Si = dependenciesMultinomial_generated, Di = dependenciesPermutations_generated, Ni = dependenciesPickRandom_generated, Ai = dependenciesRandom_generated, Pi = dependenciesRandomInt_generated, Ei = dependenciesStirlingS2_generated, Ti = dependenciesBellNumbers_generated, Oi = dependenciesCatalan_generated, Ii = dependenciesComposition_generated, ki = dependenciesSimplify_generated, Li = dependenciesDerivative_generated, ji = dependenciesRationalize_generated, Ri = dependenciesReviver_generated, Fi = dependenciesReplacer_generated, vn = dependenciesE_generated, Ur = dependenciesUppercaseE_generated, Bi = dependenciesFalse_generated, Gi = dependenciesI_generated, zi = dependenciesInfinity_generated, Vi = dependenciesLN10_generated, Wi = dependenciesLN2_generated, _a = dependenciesLOG10E_generated, ba = dependenciesLOG2E_generated, Ui = dependenciesNaN_generated, qi = dependenciesNull_generated, Hi = dependenciesPhi_generated, Zi = dependenciesPi_generated, Yi = dependenciesUppercasePi_generated, Xi = dependenciesSQRT1_2_generated, Qi = dependenciesSQRT2_generated, Ji = dependenciesTau_generated, Ki = dependenciesTrue_generated, ts = dependenciesVersion_generated, Ue = dependenciesAtomicMass_generated, ss = dependenciesAvogadro_generated, os = dependenciesBohrMagneton_generated, cs = dependenciesBohrRadius_generated, ds = dependenciesBoltzmann_generated, rs = dependenciesClassicalElectronRadius_generated, ns = dependenciesConductanceQuantum_generated, ls = dependenciesCoulomb_generated, us = dependenciesDeuteronMass_generated, ps = dependenciesEfimovFactor_generated, fs = dependenciesElectricConstant_generated, hs = dependenciesElectronMass_generated, ms = dependenciesElementaryCharge_generated, gs = dependenciesFaraday_generated, vs = dependenciesFermiCoupling_generated, ys = dependenciesFineStructure_generated, _s = dependenciesFirstRadiation_generated, bs = dependenciesGasConstant_generated, $s = dependenciesGravitationConstant_generated, xs = dependenciesGravity_generated, ws = dependenciesHartreeEnergy_generated, Ms = dependenciesInverseConductanceQuantum_generated, Cs = dependenciesKlitzing_generated, Ss = dependenciesLoschmidt_generated, Ds = dependenciesMagneticConstant_generated, Ns = dependenciesMagneticFluxQuantum_generated, As = dependenciesMolarMass_generated, Ps = dependenciesMolarMassC12_generated, Es = dependenciesMolarPlanckConstant_generated, Ts = dependenciesMolarVolume_generated, Os = dependenciesNeutronMass_generated, Is = dependenciesNuclearMagneton_generated, ks = dependenciesPlanckCharge_generated, Ls = dependenciesPlanckConstant_generated, js = dependenciesPlanckLength_generated, Rs = dependenciesPlanckMass_generated, Fs = dependenciesPlanckTemperature_generated, Bs = dependenciesPlanckTime_generated, Gs = dependenciesProtonMass_generated, zs = dependenciesQuantumOfCirculation_generated, Vs = dependenciesReducedPlanckConstant_generated, Ws = dependenciesRydberg_generated, Us = dependenciesSackurTetrode_generated, qs = dependenciesSecondRadiation_generated, Hs = dependenciesSpeedOfLight_generated, Zs = dependenciesStefanBoltzmann_generated, Ys = dependenciesThomsonCrossSection_generated, Xs = dependenciesVacuumImpedance_generated, Qs = dependenciesWeakMixingAngle_generated, Js = dependenciesWienDisplacement_generated, Ks = dependenciesApplyTransform_generated, eo = dependenciesColumnTransform_generated, ro = dependenciesFilterTransform_generated, no = dependenciesForEachTransform_generated, ao = dependenciesIndexTransform_generated, io = dependenciesMapTransform_generated, so = dependenciesMaxTransform_generated, oo = dependenciesMeanTransform_generated, co = dependenciesMinTransform_generated, lo = dependenciesRangeTransform_generated, uo = dependenciesRowTransform_generated, po = dependenciesSubsetTransform_generated, fo = dependenciesConcatTransform_generated, ho = dependenciesDiffTransform_generated, mo = dependenciesStdTransform_generated, go = dependenciesSumTransform_generated, vo = dependenciesVarianceTransform_generated, yo = allFactoriesAny;
})(dependenciesAny_generated);
var create$1 = {};
Number.isFinite = Number.isFinite || function(t) {
  return typeof t == "number" && isFinite(t);
};
Number.isNaN = Number.isNaN || function(t) {
  return t !== t;
};
var emitter$1 = {}, tinyEmitter = { exports: {} };
function E() {
}
E.prototype = {
  on: function(t, r, n) {
    var a = this.e || (this.e = {});
    return (a[t] || (a[t] = [])).push({
      fn: r,
      ctx: n
    }), this;
  },
  once: function(t, r, n) {
    var a = this;
    function s() {
      a.off(t, s), r.apply(n, arguments);
    }
    return s._ = r, this.on(t, s, n);
  },
  emit: function(t) {
    var r = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[t] || []).slice(), a = 0, s = n.length;
    for (a; a < s; a++)
      n[a].fn.apply(n[a].ctx, r);
    return this;
  },
  off: function(t, r) {
    var n = this.e || (this.e = {}), a = n[t], s = [];
    if (a && r)
      for (var o = 0, c = a.length; o < c; o++)
        a[o].fn !== r && a[o].fn._ !== r && s.push(a[o]);
    return s.length ? n[t] = s : delete n[t], this;
  }
};
tinyEmitter.exports = E;
tinyEmitter.exports.TinyEmitter = E;
var tinyEmitterExports = tinyEmitter.exports;
Object.defineProperty(emitter$1, "__esModule", {
  value: !0
});
emitter$1.mixin = mixin;
var _tinyEmitter = _interopRequireDefault(tinyEmitterExports);
function _interopRequireDefault(t) {
  return t && t.__esModule ? t : { default: t };
}
function mixin(t) {
  var r = new _tinyEmitter.default();
  return t.on = r.on.bind(r), t.off = r.off.bind(r), t.once = r.once.bind(r), t.emit = r.emit.bind(r), t;
}
var _import$1 = {};
Object.defineProperty(_import$1, "__esModule", {
  value: !0
});
_import$1.importFactory = importFactory;
var _is$1 = is, _factory$1 = factory$1, _object$1 = object, _array = array, _ArgumentsError$1 = ArgumentsError$1;
function _defineProperty$3(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function _typeof$3(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(n) {
    return typeof n;
  } : _typeof$3 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$3(t);
}
function importFactory(t, r, n, a) {
  function s(_, $) {
    var b = arguments.length;
    if (b !== 1 && b !== 2)
      throw new _ArgumentsError$1.ArgumentsError("import", b, 1, 2);
    $ || ($ = {});
    function M(D, N, T) {
      if (Array.isArray(N))
        N.forEach(function(z) {
          return M(D, z);
        });
      else if (_typeof$3(N) === "object")
        for (var R in N)
          (0, _object$1.hasOwnProperty)(N, R) && M(D, N[R], R);
      else if ((0, _factory$1.isFactory)(N) || T !== void 0) {
        var F = (0, _factory$1.isFactory)(N) ? y(N) ? N.fn + ".transform" : (
          // TODO: this is ugly
          N.fn
        ) : T;
        if ((0, _object$1.hasOwnProperty)(D, F) && D[F] !== N && !$.silent)
          throw new Error('Cannot import "' + F + '" twice');
        D[F] = N;
      } else if (!$.silent)
        throw new TypeError("Factory, Object, or Array expected");
    }
    var C = {};
    M(C, _);
    for (var S in C)
      if ((0, _object$1.hasOwnProperty)(C, S)) {
        var A = C[S];
        if ((0, _factory$1.isFactory)(A))
          h(A, $);
        else if (u(A))
          o(S, A, $);
        else if (!$.silent)
          throw new TypeError("Factory, Object, or Array expected");
      }
  }
  function o(_, $, b) {
    if (b.wrap && typeof $ == "function" && ($ = d($)), m($) && ($ = t(_, _defineProperty$3({}, $.signature, $))), p(n[_]) && p($)) {
      b.override ? $ = t(_, $.signatures) : $ = t(n[_], $), n[_] = $, delete a[_], c(_, $), n.emit("import", _, function() {
        return $;
      });
      return;
    }
    if (n[_] === void 0 || b.override) {
      n[_] = $, delete a[_], c(_, $), n.emit("import", _, function() {
        return $;
      });
      return;
    }
    if (!b.silent)
      throw new Error('Cannot import "' + _ + '": already exists');
  }
  function c(_, $) {
    $ && typeof $.transform == "function" ? (n.expression.transform[_] = $.transform, g(_) && (n.expression.mathWithTransform[_] = $.transform)) : (delete n.expression.transform[_], g(_) && (n.expression.mathWithTransform[_] = $));
  }
  function l(_) {
    delete n.expression.transform[_], g(_) ? n.expression.mathWithTransform[_] = n[_] : delete n.expression.mathWithTransform[_];
  }
  function d(_) {
    var $ = function() {
      for (var M = [], C = 0, S = arguments.length; C < S; C++) {
        var A = arguments[C];
        M[C] = A && A.valueOf();
      }
      return _.apply(n, M);
    };
    return _.transform && ($.transform = _.transform), $;
  }
  function h(_, $) {
    var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _.fn;
    if ((0, _array.contains)(b, "."))
      throw new Error("Factory name should not contain a nested path. Name: " + JSON.stringify(b));
    var M = y(_) ? n.expression.transform : n, C = b in n.expression.transform, S = (0, _object$1.hasOwnProperty)(M, b) ? M[b] : void 0, A = function() {
      var N = {};
      _.dependencies.map(_factory$1.stripOptionalNotation).forEach(function(R) {
        if ((0, _array.contains)(R, "."))
          throw new Error("Factory dependency should not contain a nested path. Name: " + JSON.stringify(R));
        R === "math" ? N.math = n : R === "mathWithTransform" ? N.mathWithTransform = n.expression.mathWithTransform : R === "classes" ? N.classes = n : N[R] = n[R];
      });
      var T = /* @__PURE__ */ _(N);
      if (T && typeof T.transform == "function")
        throw new Error('Transforms cannot be attached to factory functions. Please create a separate function for it with exports.path="expression.transform"');
      if (S === void 0 || $.override)
        return T;
      if (p(S) && p(T))
        return t(S, T);
      if ($.silent)
        return S;
      throw new Error('Cannot import "' + b + '": already exists');
    };
    !_.meta || _.meta.lazy !== !1 ? ((0, _object$1.lazy)(M, b, A), S && C ? l(b) : (y(_) || v(_)) && (0, _object$1.lazy)(n.expression.mathWithTransform, b, function() {
      return M[b];
    })) : (M[b] = A(), S && C ? l(b) : (y(_) || v(_)) && (0, _object$1.lazy)(n.expression.mathWithTransform, b, function() {
      return M[b];
    })), a[b] = _, n.emit("import", b, A);
  }
  function u(_) {
    return typeof _ == "function" || typeof _ == "number" || typeof _ == "string" || typeof _ == "boolean" || _ === null || (0, _is$1.isUnit)(_) || (0, _is$1.isComplex)(_) || (0, _is$1.isBigNumber)(_) || (0, _is$1.isFraction)(_) || (0, _is$1.isMatrix)(_) || Array.isArray(_);
  }
  function p(_) {
    return typeof _ == "function" && _typeof$3(_.signatures) === "object";
  }
  function m(_) {
    return typeof _ == "function" && typeof _.signature == "string";
  }
  function g(_) {
    return !(0, _object$1.hasOwnProperty)(x, _);
  }
  function v(_) {
    return _.fn.indexOf(".") === -1 && // FIXME: make checking on path redundant, check on meta data instead
    !(0, _object$1.hasOwnProperty)(x, _.fn) && (!_.meta || !_.meta.isClass);
  }
  function y(_) {
    return _ !== void 0 && _.meta !== void 0 && _.meta.isTransformFunction === !0 || !1;
  }
  var x = {
    expression: !0,
    type: !0,
    docs: !0,
    error: !0,
    json: !0,
    chain: !0
    // chain method not supported. Note that there is a unit chain too.
  };
  return s;
}
function _typeof$2(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(n) {
    return typeof n;
  } : _typeof$2 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$2(t);
}
Object.defineProperty(create$1, "__esModule", {
  value: !0
});
create$1.create = create;
var _object = object, emitter = _interopRequireWildcard(emitter$1), _import = _import$1, _config = config$2, _factory = factory$1, _is = is, _ArgumentsError = ArgumentsError$1, _DimensionError = DimensionError$1, _IndexError = IndexError$1, _config2 = config$3;
function _getRequireWildcardCache() {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap();
  return _getRequireWildcardCache = function() {
    return t;
  }, t;
}
function _interopRequireWildcard(t) {
  if (t && t.__esModule)
    return t;
  if (t === null || _typeof$2(t) !== "object" && typeof t != "function")
    return { default: t };
  var r = _getRequireWildcardCache();
  if (r && r.has(t))
    return r.get(t);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (Object.prototype.hasOwnProperty.call(t, s)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, s) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, s, o) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
function _extends() {
  return _extends = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends.apply(this, arguments);
}
function create(t, r) {
  var n = _extends({}, _config2.DEFAULT_CONFIG, r);
  if (typeof Object.create != "function")
    throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
  var a = emitter.mixin({
    // only here for backward compatibility for legacy factory functions
    isNumber: _is.isNumber,
    isComplex: _is.isComplex,
    isBigNumber: _is.isBigNumber,
    isFraction: _is.isFraction,
    isUnit: _is.isUnit,
    isString: _is.isString,
    isArray: _is.isArray,
    isMatrix: _is.isMatrix,
    isCollection: _is.isCollection,
    isDenseMatrix: _is.isDenseMatrix,
    isSparseMatrix: _is.isSparseMatrix,
    isRange: _is.isRange,
    isIndex: _is.isIndex,
    isBoolean: _is.isBoolean,
    isResultSet: _is.isResultSet,
    isHelp: _is.isHelp,
    isFunction: _is.isFunction,
    isDate: _is.isDate,
    isRegExp: _is.isRegExp,
    isObject: _is.isObject,
    isNull: _is.isNull,
    isUndefined: _is.isUndefined,
    isAccessorNode: _is.isAccessorNode,
    isArrayNode: _is.isArrayNode,
    isAssignmentNode: _is.isAssignmentNode,
    isBlockNode: _is.isBlockNode,
    isConditionalNode: _is.isConditionalNode,
    isConstantNode: _is.isConstantNode,
    isFunctionAssignmentNode: _is.isFunctionAssignmentNode,
    isFunctionNode: _is.isFunctionNode,
    isIndexNode: _is.isIndexNode,
    isNode: _is.isNode,
    isObjectNode: _is.isObjectNode,
    isOperatorNode: _is.isOperatorNode,
    isParenthesisNode: _is.isParenthesisNode,
    isRangeNode: _is.isRangeNode,
    isSymbolNode: _is.isSymbolNode,
    isChain: _is.isChain
  });
  a.config = (0, _config.configFactory)(n, a.emit), a.expression = {
    transform: {},
    mathWithTransform: {
      config: a.config
    }
  };
  var s = [], o = [];
  function c(u) {
    if ((0, _factory.isFactory)(u))
      return u(a);
    var p = u[Object.keys(u)[0]];
    if ((0, _factory.isFactory)(p))
      return p(a);
    if (!(0, _object.isLegacyFactory)(u))
      throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", u), new Error("Factory object with properties `type`, `name`, and `factory` expected");
    var m = s.indexOf(u), g;
    return m === -1 ? (u.math === !0 ? g = u.factory(a.type, n, c, a.typed, a) : g = u.factory(a.type, n, c, a.typed), s.push(u), o.push(g)) : g = o[m], g;
  }
  var l = {};
  function d() {
    for (var u = arguments.length, p = new Array(u), m = 0; m < u; m++)
      p[m] = arguments[m];
    return a.typed.apply(a.typed, p);
  }
  var h = (0, _import.importFactory)(d, c, a, l);
  return a.import = h, a.on("config", function() {
    (0, _object.values)(l).forEach(function(u) {
      u && u.meta && u.meta.recreateOnConfigChange && h(u, {
        override: !0
      });
    });
  }), a.create = create.bind(null, t), a.factory = _factory.factory, a.import((0, _object.values)((0, _object.deepFlatten)(t))), a.ArgumentsError = _ArgumentsError.ArgumentsError, a.DimensionError = _DimensionError.DimensionError, a.IndexError = _IndexError.IndexError, a;
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = {
    config: !0,
    IndexError: !0,
    DimensionError: !0,
    ArgumentsError: !0,
    create: !0,
    factory: !0
  };
  Object.defineProperty(t, "config", {
    enumerable: !0,
    get: function() {
      return n.config;
    }
  }), Object.defineProperty(t, "IndexError", {
    enumerable: !0,
    get: function() {
      return c.IndexError;
    }
  }), Object.defineProperty(t, "DimensionError", {
    enumerable: !0,
    get: function() {
      return l.DimensionError;
    }
  }), Object.defineProperty(t, "ArgumentsError", {
    enumerable: !0,
    get: function() {
      return d.ArgumentsError;
    }
  }), Object.defineProperty(t, "create", {
    enumerable: !0,
    get: function() {
      return p.create;
    }
  }), Object.defineProperty(t, "factory", {
    enumerable: !0,
    get: function() {
      return m.factory;
    }
  });
  var n = configReadonly, a = pureFunctionsAny_generated;
  Object.keys(a).forEach(function(g) {
    g === "default" || g === "__esModule" || Object.prototype.hasOwnProperty.call(r, g) || g in t && t[g] === a[g] || Object.defineProperty(t, g, {
      enumerable: !0,
      get: function() {
        return a[g];
      }
    });
  });
  var s = impureFunctionsAny_generated;
  Object.keys(s).forEach(function(g) {
    g === "default" || g === "__esModule" || Object.prototype.hasOwnProperty.call(r, g) || g in t && t[g] === s[g] || Object.defineProperty(t, g, {
      enumerable: !0,
      get: function() {
        return s[g];
      }
    });
  });
  var o = typeChecks;
  Object.keys(o).forEach(function(g) {
    g === "default" || g === "__esModule" || Object.prototype.hasOwnProperty.call(r, g) || g in t && t[g] === o[g] || Object.defineProperty(t, g, {
      enumerable: !0,
      get: function() {
        return o[g];
      }
    });
  });
  var c = IndexError$1, l = DimensionError$1, d = ArgumentsError$1, h = dependenciesAny_generated;
  Object.keys(h).forEach(function(g) {
    g === "default" || g === "__esModule" || Object.prototype.hasOwnProperty.call(r, g) || g in t && t[g] === h[g] || Object.defineProperty(t, g, {
      enumerable: !0,
      get: function() {
        return h[g];
      }
    });
  });
  var u = factoriesAny;
  Object.keys(u).forEach(function(g) {
    g === "default" || g === "__esModule" || Object.prototype.hasOwnProperty.call(r, g) || g in t && t[g] === u[g] || Object.defineProperty(t, g, {
      enumerable: !0,
      get: function() {
        return u[g];
      }
    });
  });
  var p = create$1, m = factory$1;
})(mainAny);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = mainAny;
  Object.keys(r).forEach(function(n) {
    n === "default" || n === "__esModule" || n in t && t[n] === r[n] || Object.defineProperty(t, n, {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  });
})(cjs$1);
var utils$6 = {};
(function(t) {
  var r = Object.defineProperty, n = (O) => r(O, "__esModule", { value: !0 }), a = (O, G) => {
    n(O);
    for (var I in G)
      r(O, I, { get: G[I], enumerable: !0 });
  };
  a(t, {
    FIELD_ID_PREFIX: () => s,
    FIELD_ID_REGEXP: () => o,
    FIELD_ID_SUFFIX: () => c,
    INPUT_ID_PREFIX: () => l,
    INPUT_ID_REGEXP: () => d,
    QUESTION_ID_PREFIX: () => h,
    QUESTION_ID_REGEXP: () => u,
    REQUIREMENT_ID_PREFIX: () => p,
    SUBQUESTION_ID_PREFIX: () => m,
    SUBQUESTION_ID_REGEXP: () => g,
    SYMBOL_REGEX: () => M,
    USER_ID_PREFIX: () => v,
    USER_ID_REGEXP: () => y,
    XML_ID_PREFIX: () => $,
    XML_ID_REGEXP: () => b,
    YAYOYAKI_ID_PREFIX: () => x,
    YAYOYAKI_ID_REGEXP: () => _,
    createError: () => C,
    findAllParamsExpression: () => R,
    findQuestions: () => N,
    findQuestionsAndSubquestions: () => F,
    findSubquestions: () => T,
    hashValue: () => z,
    isEmpty: () => A,
    isObject: () => S,
    roundNumber: () => D
  });
  const s = "F", o = /(F[0-9]+C[0-9]+[A-Z]?)/g, c = "C", l = "I", d = /(I[0-9]+)/g, h = "Q", u = /(Q[0-9]+)/g, p = "R", m = "S", g = /(S[0-9]+)/g, v = "U", y = /(U[0-9]+)/g, x = "Y", _ = /(Y[0-9]+)/g, $ = "X", b = /(X[0-9]+)/g, M = /(F[0-9]+C[0-9]+[A-Z]?)|(U[0-9]+)|(I[0-9]+)|(Q[0-9]+)|(S[0-9]+)|(Y[0-9]+)|(X[0-9]+)|(M[0-9]+)|(O[0-9]+)/g;
  function C(O) {
    const G = `Error: ${JSON.stringify(O)}`;
    return new Error(G);
  }
  const S = (O) => typeof O == "object" && O !== null;
  function A(O) {
    return !!(!O || O === "0" || typeof O == "string" && O.match(/^[0][.][0]{2,}/));
  }
  function D(O, G = 2, I = !1) {
    const k = Math.round(O + `e+${G + 10}`) + `e-${G + 10}`, B = Math.round(Number(k) + `e+${G}`) + `e-${G}`, L = Number(B);
    if (typeof O == "number" && Number.isNaN(L))
      return 0;
    if (I && Math.abs(O) % 1 === 0.5) {
      const V = Math.floor(O + `e+${G + 10}`) + `e-${G + 10}`, U = Math.floor(Number(V) + `e+${G}`) + `e-${G}`;
      return Number(U);
    }
    return L;
  }
  function N(O) {
    return O.match(u);
  }
  function T(O) {
    return O.match(g);
  }
  function R(O) {
    let G = F(O);
    const I = O.match(_);
    I && I.length > 0 && (G = G.concat(I));
    const k = O.match(o);
    k && k.length > 0 && (G = G.concat(k));
    const B = O.match(d);
    return B && B.length > 0 && (G = G.concat(B)), G;
  }
  function F(O) {
    let G = [];
    const I = N(O);
    I && I.length > 0 && (G = G.concat(I));
    const k = T(O);
    return k && k.length > 0 && (G = G.concat(k)), Array.from(new Set(G));
  }
  const z = (O) => {
    let G = 0;
    if (!O || O.length == 0)
      return G;
    for (let I = 0; I < O.length; I++) {
      const k = O.charCodeAt(I);
      G = (G << 5) - G + k, G = G & G;
    }
    return G;
  };
})(utils$6);
var arithmetic = {}, math = {};
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(t) {
  hookCallback = t;
}
function isArray$1(t) {
  return t instanceof Array || Object.prototype.toString.call(t) === "[object Array]";
}
function isObject$1(t) {
  return t != null && Object.prototype.toString.call(t) === "[object Object]";
}
function hasOwnProp(t, r) {
  return Object.prototype.hasOwnProperty.call(t, r);
}
function isObjectEmpty(t) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(t).length === 0;
  var r;
  for (r in t)
    if (hasOwnProp(t, r))
      return !1;
  return !0;
}
function isUndefined(t) {
  return t === void 0;
}
function isNumber(t) {
  return typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]";
}
function isDate(t) {
  return t instanceof Date || Object.prototype.toString.call(t) === "[object Date]";
}
function map(t, r) {
  var n = [], a, s = t.length;
  for (a = 0; a < s; ++a)
    n.push(r(t[a], a));
  return n;
}
function extend(t, r) {
  for (var n in r)
    hasOwnProp(r, n) && (t[n] = r[n]);
  return hasOwnProp(r, "toString") && (t.toString = r.toString), hasOwnProp(r, "valueOf") && (t.valueOf = r.valueOf), t;
}
function createUTC(t, r, n, a) {
  return createLocalOrUTC(t, r, n, a, !0).utc();
}
function defaultParsingFlags() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function getParsingFlags(t) {
  return t._pf == null && (t._pf = defaultParsingFlags()), t._pf;
}
var some;
Array.prototype.some ? some = Array.prototype.some : some = function(t) {
  var r = Object(this), n = r.length >>> 0, a;
  for (a = 0; a < n; a++)
    if (a in r && t.call(this, r[a], a, r))
      return !0;
  return !1;
};
function isValid(t) {
  var r = null, n = !1, a = t._d && !isNaN(t._d.getTime());
  if (a && (r = getParsingFlags(t), n = some.call(r.parsedDateParts, function(s) {
    return s != null;
  }), a = r.overflow < 0 && !r.empty && !r.invalidEra && !r.invalidMonth && !r.invalidWeekday && !r.weekdayMismatch && !r.nullInput && !r.invalidFormat && !r.userInvalidated && (!r.meridiem || r.meridiem && n), t._strict && (a = a && r.charsLeftOver === 0 && r.unusedTokens.length === 0 && r.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(t))
    t._isValid = a;
  else
    return a;
  return t._isValid;
}
function createInvalid(t) {
  var r = createUTC(NaN);
  return t != null ? extend(getParsingFlags(r), t) : getParsingFlags(r).userInvalidated = !0, r;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = !1;
function copyConfig(t, r) {
  var n, a, s, o = momentProperties.length;
  if (isUndefined(r._isAMomentObject) || (t._isAMomentObject = r._isAMomentObject), isUndefined(r._i) || (t._i = r._i), isUndefined(r._f) || (t._f = r._f), isUndefined(r._l) || (t._l = r._l), isUndefined(r._strict) || (t._strict = r._strict), isUndefined(r._tzm) || (t._tzm = r._tzm), isUndefined(r._isUTC) || (t._isUTC = r._isUTC), isUndefined(r._offset) || (t._offset = r._offset), isUndefined(r._pf) || (t._pf = getParsingFlags(r)), isUndefined(r._locale) || (t._locale = r._locale), o > 0)
    for (n = 0; n < o; n++)
      a = momentProperties[n], s = r[a], isUndefined(s) || (t[a] = s);
  return t;
}
function Moment(t) {
  copyConfig(this, t), this._d = new Date(t._d != null ? t._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), updateInProgress === !1 && (updateInProgress = !0, hooks.updateOffset(this), updateInProgress = !1);
}
function isMoment(t) {
  return t instanceof Moment || t != null && t._isAMomentObject != null;
}
function warn(t) {
  hooks.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + t);
}
function deprecate(t, r) {
  var n = !0;
  return extend(function() {
    if (hooks.deprecationHandler != null && hooks.deprecationHandler(null, t), n) {
      var a = [], s, o, c, l = arguments.length;
      for (o = 0; o < l; o++) {
        if (s = "", typeof arguments[o] == "object") {
          s += `
[` + o + "] ";
          for (c in arguments[0])
            hasOwnProp(arguments[0], c) && (s += c + ": " + arguments[0][c] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[o];
        a.push(s);
      }
      warn(
        t + `
Arguments: ` + Array.prototype.slice.call(a).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return r.apply(this, arguments);
  }, r);
}
var deprecations = {};
function deprecateSimple(t, r) {
  hooks.deprecationHandler != null && hooks.deprecationHandler(t, r), deprecations[t] || (warn(r), deprecations[t] = !0);
}
hooks.suppressDeprecationWarnings = !1;
hooks.deprecationHandler = null;
function isFunction(t) {
  return typeof Function < "u" && t instanceof Function || Object.prototype.toString.call(t) === "[object Function]";
}
function set(t) {
  var r, n;
  for (n in t)
    hasOwnProp(t, n) && (r = t[n], isFunction(r) ? this[n] = r : this["_" + n] = r);
  this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(t, r) {
  var n = extend({}, t), a;
  for (a in r)
    hasOwnProp(r, a) && (isObject$1(t[a]) && isObject$1(r[a]) ? (n[a] = {}, extend(n[a], t[a]), extend(n[a], r[a])) : r[a] != null ? n[a] = r[a] : delete n[a]);
  for (a in t)
    hasOwnProp(t, a) && !hasOwnProp(r, a) && isObject$1(t[a]) && (n[a] = extend({}, n[a]));
  return n;
}
function Locale(t) {
  t != null && this.set(t);
}
var keys;
Object.keys ? keys = Object.keys : keys = function(t) {
  var r, n = [];
  for (r in t)
    hasOwnProp(t, r) && n.push(r);
  return n;
};
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(t, r, n) {
  var a = this._calendar[t] || this._calendar.sameElse;
  return isFunction(a) ? a.call(r, n) : a;
}
function zeroFill(t, r, n) {
  var a = "" + Math.abs(t), s = r - a.length, o = t >= 0;
  return (o ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + a;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(t, r, n, a) {
  var s = a;
  typeof a == "string" && (s = function() {
    return this[a]();
  }), t && (formatTokenFunctions[t] = s), r && (formatTokenFunctions[r[0]] = function() {
    return zeroFill(s.apply(this, arguments), r[1], r[2]);
  }), n && (formatTokenFunctions[n] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      t
    );
  });
}
function removeFormattingTokens(t) {
  return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
}
function makeFormatFunction(t) {
  var r = t.match(formattingTokens), n, a;
  for (n = 0, a = r.length; n < a; n++)
    formatTokenFunctions[r[n]] ? r[n] = formatTokenFunctions[r[n]] : r[n] = removeFormattingTokens(r[n]);
  return function(s) {
    var o = "", c;
    for (c = 0; c < a; c++)
      o += isFunction(r[c]) ? r[c].call(s, t) : r[c];
    return o;
  };
}
function formatMoment(t, r) {
  return t.isValid() ? (r = expandFormat(r, t.localeData()), formatFunctions[r] = formatFunctions[r] || makeFormatFunction(r), formatFunctions[r](t)) : t.localeData().invalidDate();
}
function expandFormat(t, r) {
  var n = 5;
  function a(s) {
    return r.longDateFormat(s) || s;
  }
  for (localFormattingTokens.lastIndex = 0; n >= 0 && localFormattingTokens.test(t); )
    t = t.replace(
      localFormattingTokens,
      a
    ), localFormattingTokens.lastIndex = 0, n -= 1;
  return t;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(t) {
  var r = this._longDateFormat[t], n = this._longDateFormat[t.toUpperCase()];
  return r || !n ? r : (this._longDateFormat[t] = n.match(formattingTokens).map(function(a) {
    return a === "MMMM" || a === "MM" || a === "DD" || a === "dddd" ? a.slice(1) : a;
  }).join(""), this._longDateFormat[t]);
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(t) {
  return this._ordinal.replace("%d", t);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(t, r, n, a) {
  var s = this._relativeTime[n];
  return isFunction(s) ? s(t, r, n, a) : s.replace(/%d/i, t);
}
function pastFuture(t, r) {
  var n = this._relativeTime[t > 0 ? "future" : "past"];
  return isFunction(n) ? n(r) : n.replace(/%s/i, r);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(t) {
  return typeof t == "string" ? aliases[t] || aliases[t.toLowerCase()] : void 0;
}
function normalizeObjectUnits(t) {
  var r = {}, n, a;
  for (a in t)
    hasOwnProp(t, a) && (n = normalizeUnits(a), n && (r[n] = t[a]));
  return r;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(t) {
  var r = [], n;
  for (n in t)
    hasOwnProp(t, n) && r.push({ unit: n, priority: priorities[n] });
  return r.sort(function(a, s) {
    return a.priority - s.priority;
  }), r;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(t, r, n) {
  regexes[t] = isFunction(r) ? r : function(a, s) {
    return a && n ? n : r;
  };
}
function getParseRegexForToken(t, r) {
  return hasOwnProp(regexes, t) ? regexes[t](r._strict, r._locale) : new RegExp(unescapeFormat(t));
}
function unescapeFormat(t) {
  return regexEscape$1(
    t.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(r, n, a, s, o) {
        return n || a || s || o;
      }
    )
  );
}
function regexEscape$1(t) {
  return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(t) {
  return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
}
function toInt(t) {
  var r = +t, n = 0;
  return r !== 0 && isFinite(r) && (n = absFloor(r)), n;
}
var tokens = {};
function addParseToken(t, r) {
  var n, a = r, s;
  for (typeof t == "string" && (t = [t]), isNumber(r) && (a = function(o, c) {
    c[r] = toInt(o);
  }), s = t.length, n = 0; n < s; n++)
    tokens[t[n]] = a;
}
function addWeekParseToken(t, r) {
  addParseToken(t, function(n, a, s, o) {
    s._w = s._w || {}, r(n, s._w, s, o);
  });
}
function addTimeToArrayFromToken(t, r, n) {
  r != null && hasOwnProp(tokens, t) && tokens[t](r, n._a, n, t);
}
function isLeapYear(t) {
  return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var t = this.year();
  return t <= 9999 ? zeroFill(t, 4) : "+" + t;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, !0], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(t, r) {
  r[YEAR] = t.length === 2 ? hooks.parseTwoDigitYear(t) : toInt(t);
});
addParseToken("YY", function(t, r) {
  r[YEAR] = hooks.parseTwoDigitYear(t);
});
addParseToken("Y", function(t, r) {
  r[YEAR] = parseInt(t, 10);
});
function daysInYear(t) {
  return isLeapYear(t) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(t) {
  return toInt(t) + (toInt(t) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", !0);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(t, r) {
  return function(n) {
    return n != null ? (set$1(this, t, n), hooks.updateOffset(this, r), this) : get$1(this, t);
  };
}
function get$1(t, r) {
  if (!t.isValid())
    return NaN;
  var n = t._d, a = t._isUTC;
  switch (r) {
    case "Milliseconds":
      return a ? n.getUTCMilliseconds() : n.getMilliseconds();
    case "Seconds":
      return a ? n.getUTCSeconds() : n.getSeconds();
    case "Minutes":
      return a ? n.getUTCMinutes() : n.getMinutes();
    case "Hours":
      return a ? n.getUTCHours() : n.getHours();
    case "Date":
      return a ? n.getUTCDate() : n.getDate();
    case "Day":
      return a ? n.getUTCDay() : n.getDay();
    case "Month":
      return a ? n.getUTCMonth() : n.getMonth();
    case "FullYear":
      return a ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function set$1(t, r, n) {
  var a, s, o, c, l;
  if (!(!t.isValid() || isNaN(n))) {
    switch (a = t._d, s = t._isUTC, r) {
      case "Milliseconds":
        return void (s ? a.setUTCMilliseconds(n) : a.setMilliseconds(n));
      case "Seconds":
        return void (s ? a.setUTCSeconds(n) : a.setSeconds(n));
      case "Minutes":
        return void (s ? a.setUTCMinutes(n) : a.setMinutes(n));
      case "Hours":
        return void (s ? a.setUTCHours(n) : a.setHours(n));
      case "Date":
        return void (s ? a.setUTCDate(n) : a.setDate(n));
      case "FullYear":
        break;
      default:
        return;
    }
    o = n, c = t.month(), l = t.date(), l = l === 29 && c === 1 && !isLeapYear(o) ? 28 : l, s ? a.setUTCFullYear(o, c, l) : a.setFullYear(o, c, l);
  }
}
function stringGet(t) {
  return t = normalizeUnits(t), isFunction(this[t]) ? this[t]() : this;
}
function stringSet(t, r) {
  if (typeof t == "object") {
    t = normalizeObjectUnits(t);
    var n = getPrioritizedUnits(t), a, s = n.length;
    for (a = 0; a < s; a++)
      this[n[a].unit](t[n[a].unit]);
  } else if (t = normalizeUnits(t), isFunction(this[t]))
    return this[t](r);
  return this;
}
function mod(t, r) {
  return (t % r + r) % r;
}
var indexOf;
Array.prototype.indexOf ? indexOf = Array.prototype.indexOf : indexOf = function(t) {
  var r;
  for (r = 0; r < this.length; ++r)
    if (this[r] === t)
      return r;
  return -1;
};
function daysInMonth(t, r) {
  if (isNaN(t) || isNaN(r))
    return NaN;
  var n = mod(r, 12);
  return t += (r - n) / 12, n === 1 ? isLeapYear(t) ? 29 : 28 : 31 - n % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(t) {
  return this.localeData().monthsShort(this, t);
});
addFormatToken("MMMM", 0, 0, function(t) {
  return this.localeData().months(this, t);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(t, r) {
  return r.monthsShortRegex(t);
});
addRegexToken("MMMM", function(t, r) {
  return r.monthsRegex(t);
});
addParseToken(["M", "MM"], function(t, r) {
  r[MONTH] = toInt(t) - 1;
});
addParseToken(["MMM", "MMMM"], function(t, r, n, a) {
  var s = n._locale.monthsParse(t, a, n._strict);
  s != null ? r[MONTH] = s : getParsingFlags(n).invalidMonth = t;
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(t, r) {
  return t ? isArray$1(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(r) ? "format" : "standalone"][t.month()] : isArray$1(this._months) ? this._months : this._months.standalone;
}
function localeMonthsShort(t, r) {
  return t ? isArray$1(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(r) ? "format" : "standalone"][t.month()] : isArray$1(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function handleStrictParse(t, r, n) {
  var a, s, o, c = t.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], a = 0; a < 12; ++a)
      o = createUTC([2e3, a]), this._shortMonthsParse[a] = this.monthsShort(
        o,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[a] = this.months(o, "").toLocaleLowerCase();
  return n ? r === "MMM" ? (s = indexOf.call(this._shortMonthsParse, c), s !== -1 ? s : null) : (s = indexOf.call(this._longMonthsParse, c), s !== -1 ? s : null) : r === "MMM" ? (s = indexOf.call(this._shortMonthsParse, c), s !== -1 ? s : (s = indexOf.call(this._longMonthsParse, c), s !== -1 ? s : null)) : (s = indexOf.call(this._longMonthsParse, c), s !== -1 ? s : (s = indexOf.call(this._shortMonthsParse, c), s !== -1 ? s : null));
}
function localeMonthsParse(t, r, n) {
  var a, s, o;
  if (this._monthsParseExact)
    return handleStrictParse.call(this, t, r, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), a = 0; a < 12; a++) {
    if (s = createUTC([2e3, a]), n && !this._longMonthsParse[a] && (this._longMonthsParse[a] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[a] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[a] && (o = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[a] = new RegExp(o.replace(".", ""), "i")), n && r === "MMMM" && this._longMonthsParse[a].test(t))
      return a;
    if (n && r === "MMM" && this._shortMonthsParse[a].test(t))
      return a;
    if (!n && this._monthsParse[a].test(t))
      return a;
  }
}
function setMonth(t, r) {
  if (!t.isValid())
    return t;
  if (typeof r == "string") {
    if (/^\d+$/.test(r))
      r = toInt(r);
    else if (r = t.localeData().monthsParse(r), !isNumber(r))
      return t;
  }
  var n = r, a = t.date();
  return a = a < 29 ? a : Math.min(a, daysInMonth(t.year(), n)), t._isUTC ? t._d.setUTCMonth(n, a) : t._d.setMonth(n, a), t;
}
function getSetMonth(t) {
  return t != null ? (setMonth(this, t), hooks.updateOffset(this, !0), this) : get$1(this, "Month");
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(t) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (hasOwnProp(this, "_monthsShortRegex") || (this._monthsShortRegex = defaultMonthsShortRegex), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function monthsRegex(t) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (hasOwnProp(this, "_monthsRegex") || (this._monthsRegex = defaultMonthsRegex), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
}
function computeMonthsParse() {
  function t(d, h) {
    return h.length - d.length;
  }
  var r = [], n = [], a = [], s, o, c, l;
  for (s = 0; s < 12; s++)
    o = createUTC([2e3, s]), c = regexEscape$1(this.monthsShort(o, "")), l = regexEscape$1(this.months(o, "")), r.push(c), n.push(l), a.push(l), a.push(c);
  r.sort(t), n.sort(t), a.sort(t), this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function createDate(t, r, n, a, s, o, c) {
  var l;
  return t < 100 && t >= 0 ? (l = new Date(t + 400, r, n, a, s, o, c), isFinite(l.getFullYear()) && l.setFullYear(t)) : l = new Date(t, r, n, a, s, o, c), l;
}
function createUTCDate(t) {
  var r, n;
  return t < 100 && t >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = t + 400, r = new Date(Date.UTC.apply(null, n)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(t)) : r = new Date(Date.UTC.apply(null, arguments)), r;
}
function firstWeekOffset(t, r, n) {
  var a = 7 + r - n, s = (7 + createUTCDate(t, 0, a).getUTCDay() - r) % 7;
  return -s + a - 1;
}
function dayOfYearFromWeeks(t, r, n, a, s) {
  var o = (7 + n - a) % 7, c = firstWeekOffset(t, a, s), l = 1 + 7 * (r - 1) + o + c, d, h;
  return l <= 0 ? (d = t - 1, h = daysInYear(d) + l) : l > daysInYear(t) ? (d = t + 1, h = l - daysInYear(t)) : (d = t, h = l), {
    year: d,
    dayOfYear: h
  };
}
function weekOfYear(t, r, n) {
  var a = firstWeekOffset(t.year(), r, n), s = Math.floor((t.dayOfYear() - a - 1) / 7) + 1, o, c;
  return s < 1 ? (c = t.year() - 1, o = s + weeksInYear(c, r, n)) : s > weeksInYear(t.year(), r, n) ? (o = s - weeksInYear(t.year(), r, n), c = t.year() + 1) : (c = t.year(), o = s), {
    week: o,
    year: c
  };
}
function weeksInYear(t, r, n) {
  var a = firstWeekOffset(t, r, n), s = firstWeekOffset(t + 1, r, n);
  return (daysInYear(t) - a + s) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(t, r, n, a) {
    r[a.substr(0, 1)] = toInt(t);
  }
);
function localeWeek(t) {
  return weekOfYear(t, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(t) {
  var r = this.localeData().week(this);
  return t == null ? r : this.add((t - r) * 7, "d");
}
function getSetISOWeek(t) {
  var r = weekOfYear(this, 1, 4).week;
  return t == null ? r : this.add((t - r) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(t) {
  return this.localeData().weekdaysMin(this, t);
});
addFormatToken("ddd", 0, 0, function(t) {
  return this.localeData().weekdaysShort(this, t);
});
addFormatToken("dddd", 0, 0, function(t) {
  return this.localeData().weekdays(this, t);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(t, r) {
  return r.weekdaysMinRegex(t);
});
addRegexToken("ddd", function(t, r) {
  return r.weekdaysShortRegex(t);
});
addRegexToken("dddd", function(t, r) {
  return r.weekdaysRegex(t);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(t, r, n, a) {
  var s = n._locale.weekdaysParse(t, a, n._strict);
  s != null ? r.d = s : getParsingFlags(n).invalidWeekday = t;
});
addWeekParseToken(["d", "e", "E"], function(t, r, n, a) {
  r[a] = toInt(t);
});
function parseWeekday(t, r) {
  return typeof t != "string" ? t : isNaN(t) ? (t = r.weekdaysParse(t), typeof t == "number" ? t : null) : parseInt(t, 10);
}
function parseIsoWeekday(t, r) {
  return typeof t == "string" ? r.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t;
}
function shiftWeekdays(t, r) {
  return t.slice(r, 7).concat(t.slice(0, r));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(t, r) {
  var n = isArray$1(this._weekdays) ? this._weekdays : this._weekdays[t && t !== !0 && this._weekdays.isFormat.test(r) ? "format" : "standalone"];
  return t === !0 ? shiftWeekdays(n, this._week.dow) : t ? n[t.day()] : n;
}
function localeWeekdaysShort(t) {
  return t === !0 ? shiftWeekdays(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(t) {
  return t === !0 ? shiftWeekdays(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
}
function handleStrictParse$1(t, r, n) {
  var a, s, o, c = t.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], a = 0; a < 7; ++a)
      o = createUTC([2e3, 1]).day(a), this._minWeekdaysParse[a] = this.weekdaysMin(
        o,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[a] = this.weekdaysShort(
        o,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[a] = this.weekdays(o, "").toLocaleLowerCase();
  return n ? r === "dddd" ? (s = indexOf.call(this._weekdaysParse, c), s !== -1 ? s : null) : r === "ddd" ? (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1 ? s : null) : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 ? s : null) : r === "dddd" ? (s = indexOf.call(this._weekdaysParse, c), s !== -1 || (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1) ? s : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 ? s : null)) : r === "ddd" ? (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1 || (s = indexOf.call(this._weekdaysParse, c), s !== -1) ? s : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 ? s : null)) : (s = indexOf.call(this._minWeekdaysParse, c), s !== -1 || (s = indexOf.call(this._weekdaysParse, c), s !== -1) ? s : (s = indexOf.call(this._shortWeekdaysParse, c), s !== -1 ? s : null));
}
function localeWeekdaysParse(t, r, n) {
  var a, s, o;
  if (this._weekdaysParseExact)
    return handleStrictParse$1.call(this, t, r, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), a = 0; a < 7; a++) {
    if (s = createUTC([2e3, 1]).day(a), n && !this._fullWeekdaysParse[a] && (this._fullWeekdaysParse[a] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[a] || (o = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[a] = new RegExp(o.replace(".", ""), "i")), n && r === "dddd" && this._fullWeekdaysParse[a].test(t))
      return a;
    if (n && r === "ddd" && this._shortWeekdaysParse[a].test(t))
      return a;
    if (n && r === "dd" && this._minWeekdaysParse[a].test(t))
      return a;
    if (!n && this._weekdaysParse[a].test(t))
      return a;
  }
}
function getSetDayOfWeek(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var r = get$1(this, "Day");
  return t != null ? (t = parseWeekday(t, this.localeData()), this.add(t - r, "d")) : r;
}
function getSetLocaleDayOfWeek(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var r = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return t == null ? r : this.add(t - r, "d");
}
function getSetISODayOfWeek(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    var r = parseIsoWeekday(t, this.localeData());
    return this.day(this.day() % 7 ? r : r - 7);
  } else
    return this.day() || 7;
}
function weekdaysRegex(t) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (hasOwnProp(this, "_weekdaysRegex") || (this._weekdaysRegex = defaultWeekdaysRegex), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function weekdaysShortRegex(t) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (hasOwnProp(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = defaultWeekdaysShortRegex), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function weekdaysMinRegex(t) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (hasOwnProp(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = defaultWeekdaysMinRegex), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function computeWeekdaysParse() {
  function t(u, p) {
    return p.length - u.length;
  }
  var r = [], n = [], a = [], s = [], o, c, l, d, h;
  for (o = 0; o < 7; o++)
    c = createUTC([2e3, 1]).day(o), l = regexEscape$1(this.weekdaysMin(c, "")), d = regexEscape$1(this.weekdaysShort(c, "")), h = regexEscape$1(this.weekdays(c, "")), r.push(l), n.push(d), a.push(h), s.push(l), s.push(d), s.push(h);
  r.sort(t), n.sort(t), a.sort(t), s.sort(t), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(t, r) {
  addFormatToken(t, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      r
    );
  });
}
meridiem("a", !0);
meridiem("A", !1);
function matchMeridiem(t, r) {
  return r._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(t, r, n) {
  var a = toInt(t);
  r[HOUR] = a === 24 ? 0 : a;
});
addParseToken(["a", "A"], function(t, r, n) {
  n._isPm = n._locale.isPM(t), n._meridiem = t;
});
addParseToken(["h", "hh"], function(t, r, n) {
  r[HOUR] = toInt(t), getParsingFlags(n).bigHour = !0;
});
addParseToken("hmm", function(t, r, n) {
  var a = t.length - 2;
  r[HOUR] = toInt(t.substr(0, a)), r[MINUTE] = toInt(t.substr(a)), getParsingFlags(n).bigHour = !0;
});
addParseToken("hmmss", function(t, r, n) {
  var a = t.length - 4, s = t.length - 2;
  r[HOUR] = toInt(t.substr(0, a)), r[MINUTE] = toInt(t.substr(a, 2)), r[SECOND] = toInt(t.substr(s)), getParsingFlags(n).bigHour = !0;
});
addParseToken("Hmm", function(t, r, n) {
  var a = t.length - 2;
  r[HOUR] = toInt(t.substr(0, a)), r[MINUTE] = toInt(t.substr(a));
});
addParseToken("Hmmss", function(t, r, n) {
  var a = t.length - 4, s = t.length - 2;
  r[HOUR] = toInt(t.substr(0, a)), r[MINUTE] = toInt(t.substr(a, 2)), r[SECOND] = toInt(t.substr(s));
});
function localeIsPM(t) {
  return (t + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", !0);
function localeMeridiem(t, r, n) {
  return t > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
}, locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(t, r) {
  var n, a = Math.min(t.length, r.length);
  for (n = 0; n < a; n += 1)
    if (t[n] !== r[n])
      return n;
  return a;
}
function normalizeLocale(t) {
  return t && t.toLowerCase().replace("_", "-");
}
function chooseLocale(t) {
  for (var r = 0, n, a, s, o; r < t.length; ) {
    for (o = normalizeLocale(t[r]).split("-"), n = o.length, a = normalizeLocale(t[r + 1]), a = a ? a.split("-") : null; n > 0; ) {
      if (s = loadLocale(o.slice(0, n).join("-")), s)
        return s;
      if (a && a.length >= n && commonPrefix(o, a) >= n - 1)
        break;
      n--;
    }
    r++;
  }
  return globalLocale;
}
function isLocaleNameSane(t) {
  return !!(t && t.match("^[^/\\\\]*$"));
}
function loadLocale(t) {
  var r = null, n;
  if (locales[t] === void 0 && typeof module < "u" && module && module.exports && isLocaleNameSane(t))
    try {
      r = globalLocale._abbr, n = require, n("./locale/" + t), getSetGlobalLocale(r);
    } catch {
      locales[t] = null;
    }
  return locales[t];
}
function getSetGlobalLocale(t, r) {
  var n;
  return t && (isUndefined(r) ? n = getLocale(t) : n = defineLocale(t, r), n ? globalLocale = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + t + " not found. Did you forget to load it?"
  )), globalLocale._abbr;
}
function defineLocale(t, r) {
  if (r !== null) {
    var n, a = baseConfig;
    if (r.abbr = t, locales[t] != null)
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), a = locales[t]._config;
    else if (r.parentLocale != null)
      if (locales[r.parentLocale] != null)
        a = locales[r.parentLocale]._config;
      else if (n = loadLocale(r.parentLocale), n != null)
        a = n._config;
      else
        return localeFamilies[r.parentLocale] || (localeFamilies[r.parentLocale] = []), localeFamilies[r.parentLocale].push({
          name: t,
          config: r
        }), null;
    return locales[t] = new Locale(mergeConfigs(a, r)), localeFamilies[t] && localeFamilies[t].forEach(function(s) {
      defineLocale(s.name, s.config);
    }), getSetGlobalLocale(t), locales[t];
  } else
    return delete locales[t], null;
}
function updateLocale(t, r) {
  if (r != null) {
    var n, a, s = baseConfig;
    locales[t] != null && locales[t].parentLocale != null ? locales[t].set(mergeConfigs(locales[t]._config, r)) : (a = loadLocale(t), a != null && (s = a._config), r = mergeConfigs(s, r), a == null && (r.abbr = t), n = new Locale(r), n.parentLocale = locales[t], locales[t] = n), getSetGlobalLocale(t);
  } else
    locales[t] != null && (locales[t].parentLocale != null ? (locales[t] = locales[t].parentLocale, t === getSetGlobalLocale() && getSetGlobalLocale(t)) : locales[t] != null && delete locales[t]);
  return locales[t];
}
function getLocale(t) {
  var r;
  if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t)
    return globalLocale;
  if (!isArray$1(t)) {
    if (r = loadLocale(t), r)
      return r;
    t = [t];
  }
  return chooseLocale(t);
}
function listLocales() {
  return keys(locales);
}
function checkOverflow(t) {
  var r, n = t._a;
  return n && getParsingFlags(t).overflow === -2 && (r = n[MONTH] < 0 || n[MONTH] > 11 ? MONTH : n[DATE] < 1 || n[DATE] > daysInMonth(n[YEAR], n[MONTH]) ? DATE : n[HOUR] < 0 || n[HOUR] > 24 || n[HOUR] === 24 && (n[MINUTE] !== 0 || n[SECOND] !== 0 || n[MILLISECOND] !== 0) ? HOUR : n[MINUTE] < 0 || n[MINUTE] > 59 ? MINUTE : n[SECOND] < 0 || n[SECOND] > 59 ? SECOND : n[MILLISECOND] < 0 || n[MILLISECOND] > 999 ? MILLISECOND : -1, getParsingFlags(t)._overflowDayOfYear && (r < YEAR || r > DATE) && (r = DATE), getParsingFlags(t)._overflowWeeks && r === -1 && (r = WEEK), getParsingFlags(t)._overflowWeekday && r === -1 && (r = WEEKDAY), getParsingFlags(t).overflow = r), t;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(t) {
  var r, n, a = t._i, s = extendedIsoRegex.exec(a) || basicIsoRegex.exec(a), o, c, l, d, h = isoDates.length, u = isoTimes.length;
  if (s) {
    for (getParsingFlags(t).iso = !0, r = 0, n = h; r < n; r++)
      if (isoDates[r][1].exec(s[1])) {
        c = isoDates[r][0], o = isoDates[r][2] !== !1;
        break;
      }
    if (c == null) {
      t._isValid = !1;
      return;
    }
    if (s[3]) {
      for (r = 0, n = u; r < n; r++)
        if (isoTimes[r][1].exec(s[3])) {
          l = (s[2] || " ") + isoTimes[r][0];
          break;
        }
      if (l == null) {
        t._isValid = !1;
        return;
      }
    }
    if (!o && l != null) {
      t._isValid = !1;
      return;
    }
    if (s[4])
      if (tzRegex.exec(s[4]))
        d = "Z";
      else {
        t._isValid = !1;
        return;
      }
    t._f = c + (l || "") + (d || ""), configFromStringAndFormat(t);
  } else
    t._isValid = !1;
}
function extractFromRFC2822Strings(t, r, n, a, s, o) {
  var c = [
    untruncateYear(t),
    defaultLocaleMonthsShort.indexOf(r),
    parseInt(n, 10),
    parseInt(a, 10),
    parseInt(s, 10)
  ];
  return o && c.push(parseInt(o, 10)), c;
}
function untruncateYear(t) {
  var r = parseInt(t, 10);
  return r <= 49 ? 2e3 + r : r <= 999 ? 1900 + r : r;
}
function preprocessRFC2822(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(t, r, n) {
  if (t) {
    var a = defaultLocaleWeekdaysShort.indexOf(t), s = new Date(
      r[0],
      r[1],
      r[2]
    ).getDay();
    if (a !== s)
      return getParsingFlags(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function calculateOffset(t, r, n) {
  if (t)
    return obsOffsets[t];
  if (r)
    return 0;
  var a = parseInt(n, 10), s = a % 100, o = (a - s) / 100;
  return o * 60 + s;
}
function configFromRFC2822(t) {
  var r = rfc2822.exec(preprocessRFC2822(t._i)), n;
  if (r) {
    if (n = extractFromRFC2822Strings(
      r[4],
      r[3],
      r[2],
      r[5],
      r[6],
      r[7]
    ), !checkWeekday(r[1], n, t))
      return;
    t._a = n, t._tzm = calculateOffset(r[8], r[9], r[10]), t._d = createUTCDate.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), getParsingFlags(t).rfc2822 = !0;
  } else
    t._isValid = !1;
}
function configFromString(t) {
  var r = aspNetJsonRegex.exec(t._i);
  if (r !== null) {
    t._d = /* @__PURE__ */ new Date(+r[1]);
    return;
  }
  if (configFromISO(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  if (configFromRFC2822(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  t._strict ? t._isValid = !1 : hooks.createFromInputFallback(t);
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(t) {
    t._d = /* @__PURE__ */ new Date(t._i + (t._useUTC ? " UTC" : ""));
  }
);
function defaults$1(t, r, n) {
  return t ?? r ?? n;
}
function currentDateArray(t) {
  var r = new Date(hooks.now());
  return t._useUTC ? [
    r.getUTCFullYear(),
    r.getUTCMonth(),
    r.getUTCDate()
  ] : [r.getFullYear(), r.getMonth(), r.getDate()];
}
function configFromArray(t) {
  var r, n, a = [], s, o, c;
  if (!t._d) {
    for (s = currentDateArray(t), t._w && t._a[DATE] == null && t._a[MONTH] == null && dayOfYearFromWeekInfo(t), t._dayOfYear != null && (c = defaults$1(t._a[YEAR], s[YEAR]), (t._dayOfYear > daysInYear(c) || t._dayOfYear === 0) && (getParsingFlags(t)._overflowDayOfYear = !0), n = createUTCDate(c, 0, t._dayOfYear), t._a[MONTH] = n.getUTCMonth(), t._a[DATE] = n.getUTCDate()), r = 0; r < 3 && t._a[r] == null; ++r)
      t._a[r] = a[r] = s[r];
    for (; r < 7; r++)
      t._a[r] = a[r] = t._a[r] == null ? r === 2 ? 1 : 0 : t._a[r];
    t._a[HOUR] === 24 && t._a[MINUTE] === 0 && t._a[SECOND] === 0 && t._a[MILLISECOND] === 0 && (t._nextDay = !0, t._a[HOUR] = 0), t._d = (t._useUTC ? createUTCDate : createDate).apply(
      null,
      a
    ), o = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), t._tzm != null && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[HOUR] = 24), t._w && typeof t._w.d < "u" && t._w.d !== o && (getParsingFlags(t).weekdayMismatch = !0);
  }
}
function dayOfYearFromWeekInfo(t) {
  var r, n, a, s, o, c, l, d, h;
  r = t._w, r.GG != null || r.W != null || r.E != null ? (o = 1, c = 4, n = defaults$1(
    r.GG,
    t._a[YEAR],
    weekOfYear(createLocal(), 1, 4).year
  ), a = defaults$1(r.W, 1), s = defaults$1(r.E, 1), (s < 1 || s > 7) && (d = !0)) : (o = t._locale._week.dow, c = t._locale._week.doy, h = weekOfYear(createLocal(), o, c), n = defaults$1(r.gg, t._a[YEAR], h.year), a = defaults$1(r.w, h.week), r.d != null ? (s = r.d, (s < 0 || s > 6) && (d = !0)) : r.e != null ? (s = r.e + o, (r.e < 0 || r.e > 6) && (d = !0)) : s = o), a < 1 || a > weeksInYear(n, o, c) ? getParsingFlags(t)._overflowWeeks = !0 : d != null ? getParsingFlags(t)._overflowWeekday = !0 : (l = dayOfYearFromWeeks(n, a, s, o, c), t._a[YEAR] = l.year, t._dayOfYear = l.dayOfYear);
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(t) {
  if (t._f === hooks.ISO_8601) {
    configFromISO(t);
    return;
  }
  if (t._f === hooks.RFC_2822) {
    configFromRFC2822(t);
    return;
  }
  t._a = [], getParsingFlags(t).empty = !0;
  var r = "" + t._i, n, a, s, o, c, l = r.length, d = 0, h, u;
  for (s = expandFormat(t._f, t._locale).match(formattingTokens) || [], u = s.length, n = 0; n < u; n++)
    o = s[n], a = (r.match(getParseRegexForToken(o, t)) || [])[0], a && (c = r.substr(0, r.indexOf(a)), c.length > 0 && getParsingFlags(t).unusedInput.push(c), r = r.slice(
      r.indexOf(a) + a.length
    ), d += a.length), formatTokenFunctions[o] ? (a ? getParsingFlags(t).empty = !1 : getParsingFlags(t).unusedTokens.push(o), addTimeToArrayFromToken(o, a, t)) : t._strict && !a && getParsingFlags(t).unusedTokens.push(o);
  getParsingFlags(t).charsLeftOver = l - d, r.length > 0 && getParsingFlags(t).unusedInput.push(r), t._a[HOUR] <= 12 && getParsingFlags(t).bigHour === !0 && t._a[HOUR] > 0 && (getParsingFlags(t).bigHour = void 0), getParsingFlags(t).parsedDateParts = t._a.slice(0), getParsingFlags(t).meridiem = t._meridiem, t._a[HOUR] = meridiemFixWrap(
    t._locale,
    t._a[HOUR],
    t._meridiem
  ), h = getParsingFlags(t).era, h !== null && (t._a[YEAR] = t._locale.erasConvertYear(h, t._a[YEAR])), configFromArray(t), checkOverflow(t);
}
function meridiemFixWrap(t, r, n) {
  var a;
  return n == null ? r : t.meridiemHour != null ? t.meridiemHour(r, n) : (t.isPM != null && (a = t.isPM(n), a && r < 12 && (r += 12), !a && r === 12 && (r = 0)), r);
}
function configFromStringAndArray(t) {
  var r, n, a, s, o, c, l = !1, d = t._f.length;
  if (d === 0) {
    getParsingFlags(t).invalidFormat = !0, t._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < d; s++)
    o = 0, c = !1, r = copyConfig({}, t), t._useUTC != null && (r._useUTC = t._useUTC), r._f = t._f[s], configFromStringAndFormat(r), isValid(r) && (c = !0), o += getParsingFlags(r).charsLeftOver, o += getParsingFlags(r).unusedTokens.length * 10, getParsingFlags(r).score = o, l ? o < a && (a = o, n = r) : (a == null || o < a || c) && (a = o, n = r, c && (l = !0));
  extend(t, n || r);
}
function configFromObject(t) {
  if (!t._d) {
    var r = normalizeObjectUnits(t._i), n = r.day === void 0 ? r.date : r.day;
    t._a = map(
      [r.year, r.month, n, r.hour, r.minute, r.second, r.millisecond],
      function(a) {
        return a && parseInt(a, 10);
      }
    ), configFromArray(t);
  }
}
function createFromConfig(t) {
  var r = new Moment(checkOverflow(prepareConfig(t)));
  return r._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
}
function prepareConfig(t) {
  var r = t._i, n = t._f;
  return t._locale = t._locale || getLocale(t._l), r === null || n === void 0 && r === "" ? createInvalid({ nullInput: !0 }) : (typeof r == "string" && (t._i = r = t._locale.preparse(r)), isMoment(r) ? new Moment(checkOverflow(r)) : (isDate(r) ? t._d = r : isArray$1(n) ? configFromStringAndArray(t) : n ? configFromStringAndFormat(t) : configFromInput(t), isValid(t) || (t._d = null), t));
}
function configFromInput(t) {
  var r = t._i;
  isUndefined(r) ? t._d = new Date(hooks.now()) : isDate(r) ? t._d = new Date(r.valueOf()) : typeof r == "string" ? configFromString(t) : isArray$1(r) ? (t._a = map(r.slice(0), function(n) {
    return parseInt(n, 10);
  }), configFromArray(t)) : isObject$1(r) ? configFromObject(t) : isNumber(r) ? t._d = new Date(r) : hooks.createFromInputFallback(t);
}
function createLocalOrUTC(t, r, n, a, s) {
  var o = {};
  return (r === !0 || r === !1) && (a = r, r = void 0), (n === !0 || n === !1) && (a = n, n = void 0), (isObject$1(t) && isObjectEmpty(t) || isArray$1(t) && t.length === 0) && (t = void 0), o._isAMomentObject = !0, o._useUTC = o._isUTC = s, o._l = n, o._i = t, o._f = r, o._strict = a, createFromConfig(o);
}
function createLocal(t, r, n, a) {
  return createLocalOrUTC(t, r, n, a, !1);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = createLocal.apply(null, arguments);
    return this.isValid() && t.isValid() ? t < this ? this : t : createInvalid();
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = createLocal.apply(null, arguments);
    return this.isValid() && t.isValid() ? t > this ? this : t : createInvalid();
  }
);
function pickBy(t, r) {
  var n, a;
  if (r.length === 1 && isArray$1(r[0]) && (r = r[0]), !r.length)
    return createLocal();
  for (n = r[0], a = 1; a < r.length; ++a)
    (!r[a].isValid() || r[a][t](n)) && (n = r[a]);
  return n;
}
function min$1() {
  var t = [].slice.call(arguments, 0);
  return pickBy("isBefore", t);
}
function max$1() {
  var t = [].slice.call(arguments, 0);
  return pickBy("isAfter", t);
}
var now = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(t) {
  var r, n = !1, a, s = ordering.length;
  for (r in t)
    if (hasOwnProp(t, r) && !(indexOf.call(ordering, r) !== -1 && (t[r] == null || !isNaN(t[r]))))
      return !1;
  for (a = 0; a < s; ++a)
    if (t[ordering[a]]) {
      if (n)
        return !1;
      parseFloat(t[ordering[a]]) !== toInt(t[ordering[a]]) && (n = !0);
    }
  return !0;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(t) {
  var r = normalizeObjectUnits(t), n = r.year || 0, a = r.quarter || 0, s = r.month || 0, o = r.week || r.isoWeek || 0, c = r.day || 0, l = r.hour || 0, d = r.minute || 0, h = r.second || 0, u = r.millisecond || 0;
  this._isValid = isDurationValid(r), this._milliseconds = +u + h * 1e3 + // 1000
  d * 6e4 + // 1000 * 60
  l * 1e3 * 60 * 60, this._days = +c + o * 7, this._months = +s + a * 3 + n * 12, this._data = {}, this._locale = getLocale(), this._bubble();
}
function isDuration(t) {
  return t instanceof Duration;
}
function absRound(t) {
  return t < 0 ? Math.round(-1 * t) * -1 : Math.round(t);
}
function compareArrays(t, r, n) {
  var a = Math.min(t.length, r.length), s = Math.abs(t.length - r.length), o = 0, c;
  for (c = 0; c < a; c++)
    (n && t[c] !== r[c] || !n && toInt(t[c]) !== toInt(r[c])) && o++;
  return o + s;
}
function offset(t, r) {
  addFormatToken(t, 0, 0, function() {
    var n = this.utcOffset(), a = "+";
    return n < 0 && (n = -n, a = "-"), a + zeroFill(~~(n / 60), 2) + r + zeroFill(~~n % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(t, r, n) {
  n._useUTC = !0, n._tzm = offsetFromString(matchShortOffset, t);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(t, r) {
  var n = (r || "").match(t), a, s, o;
  return n === null ? null : (a = n[n.length - 1] || [], s = (a + "").match(chunkOffset) || ["-", 0, 0], o = +(s[1] * 60) + toInt(s[2]), o === 0 ? 0 : s[0] === "+" ? o : -o);
}
function cloneWithOffset(t, r) {
  var n, a;
  return r._isUTC ? (n = r.clone(), a = (isMoment(t) || isDate(t) ? t.valueOf() : createLocal(t).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + a), hooks.updateOffset(n, !1), n) : createLocal(t).local();
}
function getDateOffset(t) {
  return -Math.round(t._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(t, r, n) {
  var a = this._offset || 0, s;
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    if (typeof t == "string") {
      if (t = offsetFromString(matchShortOffset, t), t === null)
        return this;
    } else
      Math.abs(t) < 16 && !n && (t = t * 60);
    return !this._isUTC && r && (s = getDateOffset(this)), this._offset = t, this._isUTC = !0, s != null && this.add(s, "m"), a !== t && (!r || this._changeInProgress ? addSubtract(
      this,
      createDuration(t - a, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, hooks.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? a : getDateOffset(this);
}
function getSetZone(t, r) {
  return t != null ? (typeof t != "string" && (t = -t), this.utcOffset(t, r), this) : -this.utcOffset();
}
function setOffsetToUTC(t) {
  return this.utcOffset(0, t);
}
function setOffsetToLocal(t) {
  return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(getDateOffset(this), "m")), this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var t = offsetFromString(matchOffset, this._i);
    t != null ? this.utcOffset(t) : this.utcOffset(0, !0);
  }
  return this;
}
function hasAlignedHourOffset(t) {
  return this.isValid() ? (t = t ? createLocal(t).utcOffset() : 0, (this.utcOffset() - t) % 60 === 0) : !1;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted))
    return this._isDSTShifted;
  var t = {}, r;
  return copyConfig(t, this), t = prepareConfig(t), t._a ? (r = t._isUTC ? createUTC(t._a) : createLocal(t._a), this._isDSTShifted = this.isValid() && compareArrays(t._a, r.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : !1;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : !1;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(t, r) {
  var n = t, a = null, s, o, c;
  return isDuration(t) ? n = {
    ms: t._milliseconds,
    d: t._days,
    M: t._months
  } : isNumber(t) || !isNaN(+t) ? (n = {}, r ? n[r] = +t : n.milliseconds = +t) : (a = aspNetRegex.exec(t)) ? (s = a[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: toInt(a[DATE]) * s,
    h: toInt(a[HOUR]) * s,
    m: toInt(a[MINUTE]) * s,
    s: toInt(a[SECOND]) * s,
    ms: toInt(absRound(a[MILLISECOND] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (a = isoRegex.exec(t)) ? (s = a[1] === "-" ? -1 : 1, n = {
    y: parseIso(a[2], s),
    M: parseIso(a[3], s),
    w: parseIso(a[4], s),
    d: parseIso(a[5], s),
    h: parseIso(a[6], s),
    m: parseIso(a[7], s),
    s: parseIso(a[8], s)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (c = momentsDifference(
    createLocal(n.from),
    createLocal(n.to)
  ), n = {}, n.ms = c.milliseconds, n.M = c.months), o = new Duration(n), isDuration(t) && hasOwnProp(t, "_locale") && (o._locale = t._locale), isDuration(t) && hasOwnProp(t, "_isValid") && (o._isValid = t._isValid), o;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(t, r) {
  var n = t && parseFloat(t.replace(",", "."));
  return (isNaN(n) ? 0 : n) * r;
}
function positiveMomentsDifference(t, r) {
  var n = {};
  return n.months = r.month() - t.month() + (r.year() - t.year()) * 12, t.clone().add(n.months, "M").isAfter(r) && --n.months, n.milliseconds = +r - +t.clone().add(n.months, "M"), n;
}
function momentsDifference(t, r) {
  var n;
  return t.isValid() && r.isValid() ? (r = cloneWithOffset(r, t), t.isBefore(r) ? n = positiveMomentsDifference(t, r) : (n = positiveMomentsDifference(r, t), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function createAdder(t, r) {
  return function(n, a) {
    var s, o;
    return a !== null && !isNaN(+a) && (deprecateSimple(
      r,
      "moment()." + r + "(period, number) is deprecated. Please use moment()." + r + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), o = n, n = a, a = o), s = createDuration(n, a), addSubtract(this, s, t), this;
  };
}
function addSubtract(t, r, n, a) {
  var s = r._milliseconds, o = absRound(r._days), c = absRound(r._months);
  t.isValid() && (a = a ?? !0, c && setMonth(t, get$1(t, "Month") + c * n), o && set$1(t, "Date", get$1(t, "Date") + o * n), s && t._d.setTime(t._d.valueOf() + s * n), a && hooks.updateOffset(t, o || c));
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString(t) {
  return typeof t == "string" || t instanceof String;
}
function isMomentInput(t) {
  return isMoment(t) || isDate(t) || isString(t) || isNumber(t) || isNumberOrStringArray(t) || isMomentInputObject(t) || t === null || t === void 0;
}
function isMomentInputObject(t) {
  var r = isObject$1(t) && !isObjectEmpty(t), n = !1, a = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, o, c = a.length;
  for (s = 0; s < c; s += 1)
    o = a[s], n = n || hasOwnProp(t, o);
  return r && n;
}
function isNumberOrStringArray(t) {
  var r = isArray$1(t), n = !1;
  return r && (n = t.filter(function(a) {
    return !isNumber(a) && isString(t);
  }).length === 0), r && n;
}
function isCalendarSpec(t) {
  var r = isObject$1(t) && !isObjectEmpty(t), n = !1, a = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, o;
  for (s = 0; s < a.length; s += 1)
    o = a[s], n = n || hasOwnProp(t, o);
  return r && n;
}
function getCalendarFormat(t, r) {
  var n = t.diff(r, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(t, r) {
  arguments.length === 1 && (arguments[0] ? isMomentInput(arguments[0]) ? (t = arguments[0], r = void 0) : isCalendarSpec(arguments[0]) && (r = arguments[0], t = void 0) : (t = void 0, r = void 0));
  var n = t || createLocal(), a = cloneWithOffset(n, this).startOf("day"), s = hooks.calendarFormat(this, a) || "sameElse", o = r && (isFunction(r[s]) ? r[s].call(this, n) : r[s]);
  return this.format(
    o || this.localeData().calendar(s, this, createLocal(n))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(t, r) {
  var n = isMoment(t) ? t : createLocal(t);
  return this.isValid() && n.isValid() ? (r = normalizeUnits(r) || "millisecond", r === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(r).valueOf()) : !1;
}
function isBefore(t, r) {
  var n = isMoment(t) ? t : createLocal(t);
  return this.isValid() && n.isValid() ? (r = normalizeUnits(r) || "millisecond", r === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(r).valueOf() < n.valueOf()) : !1;
}
function isBetween(t, r, n, a) {
  var s = isMoment(t) ? t : createLocal(t), o = isMoment(r) ? r : createLocal(r);
  return this.isValid() && s.isValid() && o.isValid() ? (a = a || "()", (a[0] === "(" ? this.isAfter(s, n) : !this.isBefore(s, n)) && (a[1] === ")" ? this.isBefore(o, n) : !this.isAfter(o, n))) : !1;
}
function isSame(t, r) {
  var n = isMoment(t) ? t : createLocal(t), a;
  return this.isValid() && n.isValid() ? (r = normalizeUnits(r) || "millisecond", r === "millisecond" ? this.valueOf() === n.valueOf() : (a = n.valueOf(), this.clone().startOf(r).valueOf() <= a && a <= this.clone().endOf(r).valueOf())) : !1;
}
function isSameOrAfter(t, r) {
  return this.isSame(t, r) || this.isAfter(t, r);
}
function isSameOrBefore(t, r) {
  return this.isSame(t, r) || this.isBefore(t, r);
}
function diff(t, r, n) {
  var a, s, o;
  if (!this.isValid())
    return NaN;
  if (a = cloneWithOffset(t, this), !a.isValid())
    return NaN;
  switch (s = (a.utcOffset() - this.utcOffset()) * 6e4, r = normalizeUnits(r), r) {
    case "year":
      o = monthDiff(this, a) / 12;
      break;
    case "month":
      o = monthDiff(this, a);
      break;
    case "quarter":
      o = monthDiff(this, a) / 3;
      break;
    case "second":
      o = (this - a) / 1e3;
      break;
    case "minute":
      o = (this - a) / 6e4;
      break;
    case "hour":
      o = (this - a) / 36e5;
      break;
    case "day":
      o = (this - a - s) / 864e5;
      break;
    case "week":
      o = (this - a - s) / 6048e5;
      break;
    default:
      o = this - a;
  }
  return n ? o : absFloor(o);
}
function monthDiff(t, r) {
  if (t.date() < r.date())
    return -monthDiff(r, t);
  var n = (r.year() - t.year()) * 12 + (r.month() - t.month()), a = t.clone().add(n, "months"), s, o;
  return r - a < 0 ? (s = t.clone().add(n - 1, "months"), o = (r - a) / (a - s)) : (s = t.clone().add(n + 1, "months"), o = (r - a) / (s - a)), -(n + o) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(t) {
  if (!this.isValid())
    return null;
  var r = t !== !0, n = r ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? formatMoment(
    n,
    r ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : isFunction(Date.prototype.toISOString) ? r ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(n, "Z")) : formatMoment(
    n,
    r ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var t = "moment", r = "", n, a, s, o;
  return this.isLocal() || (t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", r = "Z"), n = "[" + t + '("]', a = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", o = r + '[")]', this.format(n + a + s + o);
}
function format(t) {
  t || (t = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat);
  var r = formatMoment(this, t);
  return this.localeData().postformat(r);
}
function from$1(t, r) {
  return this.isValid() && (isMoment(t) && t.isValid() || createLocal(t).isValid()) ? createDuration({ to: this, from: t }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function fromNow(t) {
  return this.from(createLocal(), t);
}
function to(t, r) {
  return this.isValid() && (isMoment(t) && t.isValid() || createLocal(t).isValid()) ? createDuration({ from: this, to: t }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function toNow(t) {
  return this.to(createLocal(), t);
}
function locale(t) {
  var r;
  return t === void 0 ? this._locale._abbr : (r = getLocale(t), r != null && (this._locale = r), this);
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(t) {
    return t === void 0 ? this.localeData() : this.locale(t);
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(t, r) {
  return (t % r + r) % r;
}
function localStartOfDate(t, r, n) {
  return t < 100 && t >= 0 ? new Date(t + 400, r, n) - MS_PER_400_YEARS : new Date(t, r, n).valueOf();
}
function utcStartOfDate(t, r, n) {
  return t < 100 && t >= 0 ? Date.UTC(t + 400, r, n) - MS_PER_400_YEARS : Date.UTC(t, r, n);
}
function startOf(t) {
  var r, n;
  if (t = normalizeUnits(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? utcStartOfDate : localStartOfDate, t) {
    case "year":
      r = n(this.year(), 0, 1);
      break;
    case "quarter":
      r = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      r = n(this.year(), this.month(), 1);
      break;
    case "week":
      r = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      r = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      r = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      r = this._d.valueOf(), r -= mod$1(
        r + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      r = this._d.valueOf(), r -= mod$1(r, MS_PER_MINUTE);
      break;
    case "second":
      r = this._d.valueOf(), r -= mod$1(r, MS_PER_SECOND);
      break;
  }
  return this._d.setTime(r), hooks.updateOffset(this, !0), this;
}
function endOf(t) {
  var r, n;
  if (t = normalizeUnits(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? utcStartOfDate : localStartOfDate, t) {
    case "year":
      r = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      r = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      r = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      r = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      r = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      r = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      r = this._d.valueOf(), r += MS_PER_HOUR - mod$1(
        r + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      r = this._d.valueOf(), r += MS_PER_MINUTE - mod$1(r, MS_PER_MINUTE) - 1;
      break;
    case "second":
      r = this._d.valueOf(), r += MS_PER_SECOND - mod$1(r, MS_PER_SECOND) - 1;
      break;
  }
  return this._d.setTime(r), hooks.updateOffset(this, !0), this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray$1() {
  var t = this;
  return [
    t.year(),
    t.month(),
    t.date(),
    t.hour(),
    t.minute(),
    t.second(),
    t.millisecond()
  ];
}
function toObject() {
  var t = this;
  return {
    years: t.year(),
    months: t.month(),
    date: t.date(),
    hours: t.hours(),
    minutes: t.minutes(),
    seconds: t.seconds(),
    milliseconds: t.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(t, r, n, a) {
    var s = n._locale.erasParse(t, a, n._strict);
    s ? getParsingFlags(n).era = s : getParsingFlags(n).invalidEra = t;
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(t, r, n, a) {
  var s;
  n._locale._eraYearOrdinalRegex && (s = t.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? r[YEAR] = n._locale.eraYearOrdinalParse(t, s) : r[YEAR] = parseInt(t, 10);
});
function localeEras(t, r) {
  var n, a, s, o = this._eras || getLocale("en")._eras;
  for (n = 0, a = o.length; n < a; ++n) {
    switch (typeof o[n].since) {
      case "string":
        s = hooks(o[n].since).startOf("day"), o[n].since = s.valueOf();
        break;
    }
    switch (typeof o[n].until) {
      case "undefined":
        o[n].until = 1 / 0;
        break;
      case "string":
        s = hooks(o[n].until).startOf("day").valueOf(), o[n].until = s.valueOf();
        break;
    }
  }
  return o;
}
function localeErasParse(t, r, n) {
  var a, s, o = this.eras(), c, l, d;
  for (t = t.toUpperCase(), a = 0, s = o.length; a < s; ++a)
    if (c = o[a].name.toUpperCase(), l = o[a].abbr.toUpperCase(), d = o[a].narrow.toUpperCase(), n)
      switch (r) {
        case "N":
        case "NN":
        case "NNN":
          if (l === t)
            return o[a];
          break;
        case "NNNN":
          if (c === t)
            return o[a];
          break;
        case "NNNNN":
          if (d === t)
            return o[a];
          break;
      }
    else if ([c, l, d].indexOf(t) >= 0)
      return o[a];
}
function localeErasConvertYear(t, r) {
  var n = t.since <= t.until ? 1 : -1;
  return r === void 0 ? hooks(t.since).year() : hooks(t.since).year() + (r - t.offset) * n;
}
function getEraName() {
  var t, r, n, a = this.localeData().eras();
  for (t = 0, r = a.length; t < r; ++t)
    if (n = this.clone().startOf("day").valueOf(), a[t].since <= n && n <= a[t].until || a[t].until <= n && n <= a[t].since)
      return a[t].name;
  return "";
}
function getEraNarrow() {
  var t, r, n, a = this.localeData().eras();
  for (t = 0, r = a.length; t < r; ++t)
    if (n = this.clone().startOf("day").valueOf(), a[t].since <= n && n <= a[t].until || a[t].until <= n && n <= a[t].since)
      return a[t].narrow;
  return "";
}
function getEraAbbr() {
  var t, r, n, a = this.localeData().eras();
  for (t = 0, r = a.length; t < r; ++t)
    if (n = this.clone().startOf("day").valueOf(), a[t].since <= n && n <= a[t].until || a[t].until <= n && n <= a[t].since)
      return a[t].abbr;
  return "";
}
function getEraYear() {
  var t, r, n, a, s = this.localeData().eras();
  for (t = 0, r = s.length; t < r; ++t)
    if (n = s[t].since <= s[t].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), s[t].since <= a && a <= s[t].until || s[t].until <= a && a <= s[t].since)
      return (this.year() - hooks(s[t].since).year()) * n + s[t].offset;
  return this.year();
}
function erasNameRegex(t) {
  return hasOwnProp(this, "_erasNameRegex") || computeErasParse.call(this), t ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(t) {
  return hasOwnProp(this, "_erasAbbrRegex") || computeErasParse.call(this), t ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(t) {
  return hasOwnProp(this, "_erasNarrowRegex") || computeErasParse.call(this), t ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(t, r) {
  return r.erasAbbrRegex(t);
}
function matchEraName(t, r) {
  return r.erasNameRegex(t);
}
function matchEraNarrow(t, r) {
  return r.erasNarrowRegex(t);
}
function matchEraYearOrdinal(t, r) {
  return r._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var t = [], r = [], n = [], a = [], s, o, c, l, d, h = this.eras();
  for (s = 0, o = h.length; s < o; ++s)
    c = regexEscape$1(h[s].name), l = regexEscape$1(h[s].abbr), d = regexEscape$1(h[s].narrow), r.push(c), t.push(l), n.push(d), a.push(c), a.push(l), a.push(d);
  this._erasRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(t, r) {
  addFormatToken(0, [t, t.length], 0, r);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(t, r, n, a) {
    r[a.substr(0, 2)] = toInt(t);
  }
);
addWeekParseToken(["gg", "GG"], function(t, r, n, a) {
  r[a] = hooks.parseTwoDigitYear(t);
});
function getSetWeekYear(t) {
  return getSetWeekYearHelper.call(
    this,
    t,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(t) {
  return getSetWeekYearHelper.call(
    this,
    t,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var t = this.localeData()._week;
  return weeksInYear(this.year(), t.dow, t.doy);
}
function getWeeksInWeekYear() {
  var t = this.localeData()._week;
  return weeksInYear(this.weekYear(), t.dow, t.doy);
}
function getSetWeekYearHelper(t, r, n, a, s) {
  var o;
  return t == null ? weekOfYear(this, a, s).year : (o = weeksInYear(t, a, s), r > o && (r = o), setWeekAll.call(this, t, r, n, a, s));
}
function setWeekAll(t, r, n, a, s) {
  var o = dayOfYearFromWeeks(t, r, n, a, s), c = createUTCDate(o.year, 0, o.dayOfYear);
  return this.year(c.getUTCFullYear()), this.month(c.getUTCMonth()), this.date(c.getUTCDate()), this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(t, r) {
  r[MONTH] = (toInt(t) - 1) * 3;
});
function getSetQuarter(t) {
  return t == null ? Math.ceil((this.month() + 1) / 3) : this.month((t - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(t, r) {
  return t ? r._dayOfMonthOrdinalParse || r._ordinalParse : r._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(t, r) {
  r[DATE] = toInt(t.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", !0);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(t, r, n) {
  n._dayOfYear = toInt(t);
});
function getSetDayOfYear(t) {
  var r = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return t == null ? r : this.add(t - r, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", !1);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", !1);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token$1, getSetMillisecond;
for (token$1 = "SSSS"; token$1.length <= 9; token$1 += "S")
  addRegexToken(token$1, matchUnsigned);
function parseMs(t, r) {
  r[MILLISECOND] = toInt(("0." + t) * 1e3);
}
for (token$1 = "S"; token$1.length <= 9; token$1 += "S")
  addParseToken(token$1, parseMs);
getSetMillisecond = makeGetSet("Milliseconds", !1);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from$1;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray$1;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
typeof Symbol < "u" && Symbol.for != null && (proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(t) {
  return createLocal(t * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(t) {
  return t;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1$1(t, r, n, a) {
  var s = getLocale(), o = createUTC().set(a, r);
  return s[n](o, t);
}
function listMonthsImpl(t, r, n) {
  if (isNumber(t) && (r = t, t = void 0), t = t || "", r != null)
    return get$1$1(t, r, n, "month");
  var a, s = [];
  for (a = 0; a < 12; a++)
    s[a] = get$1$1(t, a, n, "month");
  return s;
}
function listWeekdaysImpl(t, r, n, a) {
  typeof t == "boolean" ? (isNumber(r) && (n = r, r = void 0), r = r || "") : (r = t, n = r, t = !1, isNumber(r) && (n = r, r = void 0), r = r || "");
  var s = getLocale(), o = t ? s._week.dow : 0, c, l = [];
  if (n != null)
    return get$1$1(r, (n + o) % 7, a, "day");
  for (c = 0; c < 7; c++)
    l[c] = get$1$1(r, (c + o) % 7, a, "day");
  return l;
}
function listMonths(t, r) {
  return listMonthsImpl(t, r, "months");
}
function listMonthsShort(t, r) {
  return listMonthsImpl(t, r, "monthsShort");
}
function listWeekdays(t, r, n) {
  return listWeekdaysImpl(t, r, n, "weekdays");
}
function listWeekdaysShort(t, r, n) {
  return listWeekdaysImpl(t, r, n, "weekdaysShort");
}
function listWeekdaysMin(t, r, n) {
  return listWeekdaysImpl(t, r, n, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(t) {
    var r = t % 10, n = toInt(t % 100 / 10) === 1 ? "th" : r === 1 ? "st" : r === 2 ? "nd" : r === 3 ? "rd" : "th";
    return t + n;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs$1() {
  var t = this._data;
  return this._milliseconds = mathAbs(this._milliseconds), this._days = mathAbs(this._days), this._months = mathAbs(this._months), t.milliseconds = mathAbs(t.milliseconds), t.seconds = mathAbs(t.seconds), t.minutes = mathAbs(t.minutes), t.hours = mathAbs(t.hours), t.months = mathAbs(t.months), t.years = mathAbs(t.years), this;
}
function addSubtract$1(t, r, n, a) {
  var s = createDuration(r, n);
  return t._milliseconds += a * s._milliseconds, t._days += a * s._days, t._months += a * s._months, t._bubble();
}
function add$1(t, r) {
  return addSubtract$1(this, t, r, 1);
}
function subtract$1(t, r) {
  return addSubtract$1(this, t, r, -1);
}
function absCeil(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function bubble() {
  var t = this._milliseconds, r = this._days, n = this._months, a = this._data, s, o, c, l, d;
  return t >= 0 && r >= 0 && n >= 0 || t <= 0 && r <= 0 && n <= 0 || (t += absCeil(monthsToDays(n) + r) * 864e5, r = 0, n = 0), a.milliseconds = t % 1e3, s = absFloor(t / 1e3), a.seconds = s % 60, o = absFloor(s / 60), a.minutes = o % 60, c = absFloor(o / 60), a.hours = c % 24, r += absFloor(c / 24), d = absFloor(daysToMonths(r)), n += d, r -= absCeil(monthsToDays(d)), l = absFloor(n / 12), n %= 12, a.days = r, a.months = n, a.years = l, this;
}
function daysToMonths(t) {
  return t * 4800 / 146097;
}
function monthsToDays(t) {
  return t * 146097 / 4800;
}
function as(t) {
  if (!this.isValid())
    return NaN;
  var r, n, a = this._milliseconds;
  if (t = normalizeUnits(t), t === "month" || t === "quarter" || t === "year")
    switch (r = this._days + a / 864e5, n = this._months + daysToMonths(r), t) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (r = this._days + Math.round(monthsToDays(this._months)), t) {
      case "week":
        return r / 7 + a / 6048e5;
      case "day":
        return r + a / 864e5;
      case "hour":
        return r * 24 + a / 36e5;
      case "minute":
        return r * 1440 + a / 6e4;
      case "second":
        return r * 86400 + a / 1e3;
      case "millisecond":
        return Math.floor(r * 864e5) + a;
      default:
        throw new Error("Unknown unit " + t);
    }
}
function makeAs(t) {
  return function() {
    return this.as(t);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2(t) {
  return t = normalizeUnits(t), this.isValid() ? this[t + "s"]() : NaN;
}
function makeGetter(t) {
  return function() {
    return this.isValid() ? this._data[t] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round$1 = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(t, r, n, a, s) {
  return s.relativeTime(r || 1, !!n, t, a);
}
function relativeTime$1(t, r, n, a) {
  var s = createDuration(t).abs(), o = round$1(s.as("s")), c = round$1(s.as("m")), l = round$1(s.as("h")), d = round$1(s.as("d")), h = round$1(s.as("M")), u = round$1(s.as("w")), p = round$1(s.as("y")), m = o <= n.ss && ["s", o] || o < n.s && ["ss", o] || c <= 1 && ["m"] || c < n.m && ["mm", c] || l <= 1 && ["h"] || l < n.h && ["hh", l] || d <= 1 && ["d"] || d < n.d && ["dd", d];
  return n.w != null && (m = m || u <= 1 && ["w"] || u < n.w && ["ww", u]), m = m || h <= 1 && ["M"] || h < n.M && ["MM", h] || p <= 1 && ["y"] || ["yy", p], m[2] = r, m[3] = +t > 0, m[4] = a, substituteTimeAgo.apply(null, m);
}
function getSetRelativeTimeRounding(t) {
  return t === void 0 ? round$1 : typeof t == "function" ? (round$1 = t, !0) : !1;
}
function getSetRelativeTimeThreshold(t, r) {
  return thresholds[t] === void 0 ? !1 : r === void 0 ? thresholds[t] : (thresholds[t] = r, t === "s" && (thresholds.ss = r - 1), !0);
}
function humanize(t, r) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, a = thresholds, s, o;
  return typeof t == "object" && (r = t, t = !1), typeof t == "boolean" && (n = t), typeof r == "object" && (a = Object.assign({}, thresholds, r), r.s != null && r.ss == null && (a.ss = r.s - 1)), s = this.localeData(), o = relativeTime$1(this, !n, a, s), n && (o = s.pastFuture(+this, o)), s.postformat(o);
}
var abs$1$1 = Math.abs;
function sign(t) {
  return (t > 0) - (t < 0) || +t;
}
function toISOString$1() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = abs$1$1(this._milliseconds) / 1e3, r = abs$1$1(this._days), n = abs$1$1(this._months), a, s, o, c, l = this.asSeconds(), d, h, u, p;
  return l ? (a = absFloor(t / 60), s = absFloor(a / 60), t %= 60, a %= 60, o = absFloor(n / 12), n %= 12, c = t ? t.toFixed(3).replace(/\.?0+$/, "") : "", d = l < 0 ? "-" : "", h = sign(this._months) !== sign(l) ? "-" : "", u = sign(this._days) !== sign(l) ? "-" : "", p = sign(this._milliseconds) !== sign(l) ? "-" : "", d + "P" + (o ? h + o + "Y" : "") + (n ? h + n + "M" : "") + (r ? u + r + "D" : "") + (s || a || t ? "T" : "") + (s ? p + s + "H" : "") + (a ? p + a + "M" : "") + (t ? p + c + "S" : "")) : "P0D";
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs$1;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(t, r, n) {
  n._d = new Date(parseFloat(t) * 1e3);
});
addParseToken("x", function(t, r, n) {
  n._d = new Date(toInt(t));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min$1;
hooks.max = max$1;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const moment = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hooks
}, Symbol.toStringTag, { value: "Module" })), require$$2 = /* @__PURE__ */ getAugmentedNamespace(moment);
var mathFunctionError = {}, dist = {}, application = {}, useCase$1 = {}, useCase = {}, domain = {}, error$1 = {}, error = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    TaxDownError: () => s
  });
  class s extends Error {
    constructor(c, l, d, h, u, p) {
      super(l.value), this.name = c.value, this.status = d.value, this.internalCode = h.value, this.logLevel = u.value, this.context = p == null ? void 0 : p.value;
    }
  }
})(error);
var name = {}, stringValueObject = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    StringValueObject: () => s
  });
  class s {
    constructor(c) {
      this.value = c;
    }
  }
})(stringValueObject);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    ErrorName: () => m
  });
  var p = u(stringValueObject);
  class m extends p.StringValueObject {
    constructor(v) {
      if (!/^[a-z][A-Za-z]*$/.test(v))
        throw new Error("ErrorName value must be in camelCase");
      super(v);
    }
  }
})(name);
var status = {}, numberValueObject = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    NumberValueObject: () => s
  });
  class s {
    constructor(c) {
      this.value = c;
    }
  }
})(numberValueObject);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    ErrorStatus: () => m
  });
  var p = u(numberValueObject);
  class m extends p.NumberValueObject {
    constructor(v) {
      if (100 > v || v > 599)
        throw new Error("ErrorStatus value must be between 100 and 599");
      super(v);
    }
  }
})(status);
var message = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    ErrorMessage: () => m
  });
  var p = u(stringValueObject);
  class m extends p.StringValueObject {
  }
})(message);
var internalCode = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    ErrorInternalCode: () => m
  });
  var p = u(numberValueObject);
  class m extends p.NumberValueObject {
    constructor(v) {
      if (1e3 > v || v > 9999)
        throw new Error("ErrorInternalCode value must be between 1000 and 9999");
      super(v);
    }
  }
})(internalCode);
var context = {}, objectValueObject = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    ObjectValueObject: () => s
  });
  class s {
    constructor(c) {
      this.value = c;
    }
    toString() {
      return JSON.stringify(this.value);
    }
  }
})(objectValueObject);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    ErrorContext: () => m
  });
  var p = u(objectValueObject);
  class m extends p.ObjectValueObject {
  }
})(context);
var logLevel$1 = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    ErrorLogLevel: () => m
  });
  var p = u(stringValueObject);
  class m extends p.StringValueObject {
    constructor(v) {
      super(v);
    }
  }
})(logLevel$1);
var implementation = {}, validationTaxDownError = {}, errorCode = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    ErrorCode: () => s
  });
  var s;
  (function(o) {
    o[o.ValidationTaxDownError = 1e3] = "ValidationTaxDownError";
  })(s || (s = {}));
})(errorCode);
var logLevel = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    LogLevel: () => s
  });
  var s;
  (function(o) {
    o.ERROR = "error", o.WARN = "warn", o.INFO = "info", o.DEBUG = "debug";
  })(s || (s = {}));
})(logLevel);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (M) => n(M, "__esModule", { value: !0 }), d = (M, C) => {
    l(M);
    for (var S in C)
      n(M, S, { get: C[S], enumerable: !0 });
  }, h = (M, C, S) => {
    if (C && typeof C == "object" || typeof C == "function")
      for (let A of s(C))
        !c.call(M, A) && A !== "default" && n(M, A, { get: () => C[A], enumerable: !(S = a(C, A)) || S.enumerable });
    return M;
  }, u = (M) => h(l(n(M != null ? r(o(M)) : {}, "default", M && M.__esModule && "default" in M ? { get: () => M.default, enumerable: !0 } : { value: M, enumerable: !0 })), M);
  d(t, {
    ValidationTaxDownError: () => b
  });
  var p = u(internalCode), m = u(name), g = u(message), v = u(status), y = u(logLevel$1), x = u(error), _ = u(errorCode), $ = u(logLevel);
  class b extends x.TaxDownError {
    constructor(C) {
      const S = "validationException";
      super(new m.ErrorName(S), new g.ErrorMessage(C), new v.ErrorStatus(422), new p.ErrorInternalCode(_.ErrorCode[S]), new y.ErrorLogLevel($.LogLevel.WARN));
    }
  }
})(validationTaxDownError);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    ErrorCode: () => m.ErrorCode,
    ValidationTaxDownError: () => p.ValidationTaxDownError
  });
  var p = u(validationTaxDownError), m = u(errorCode);
})(implementation);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = ($) => n($, "__esModule", { value: !0 }), d = ($, b) => {
    l($);
    for (var M in b)
      n($, M, { get: b[M], enumerable: !0 });
  }, h = ($, b, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let C of s(b))
        !c.call($, C) && C !== "default" && n($, C, { get: () => b[C], enumerable: !(M = a(b, C)) || M.enumerable });
    return $;
  }, u = ($) => h(l(n($ != null ? r(o($)) : {}, "default", $ && $.__esModule && "default" in $ ? { get: () => $.default, enumerable: !0 } : { value: $, enumerable: !0 })), $);
  d(t, {
    ErrorContext: () => x.ErrorContext,
    ErrorInternalCode: () => y.ErrorInternalCode,
    ErrorLogLevel: () => _.ErrorLogLevel,
    ErrorMessage: () => v.ErrorMessage,
    ErrorName: () => m.ErrorName,
    ErrorStatus: () => g.ErrorStatus,
    TaxDownError: () => p.TaxDownError
  });
  var p = u(error), m = u(name), g = u(status), v = u(message), y = u(internalCode), x = u(context), _ = u(logLevel$1);
  h(t, u(implementation));
})(error$1);
var event$2 = {}, eventBusAsync = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(eventBusAsync);
var eventId = {}, getRandomValues$1, rnds8$1 = new Uint8Array(16);
function rng$1() {
  if (!getRandomValues$1 && (getRandomValues$1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$1))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$1(rnds8$1);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(t) {
  return typeof t == "string" && REGEX.test(t);
}
var byteToHex$1 = [];
for (var i$1 = 0; i$1 < 256; ++i$1)
  byteToHex$1.push((i$1 + 256).toString(16).substr(1));
function stringify$1(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (byteToHex$1[t[r + 0]] + byteToHex$1[t[r + 1]] + byteToHex$1[t[r + 2]] + byteToHex$1[t[r + 3]] + "-" + byteToHex$1[t[r + 4]] + byteToHex$1[t[r + 5]] + "-" + byteToHex$1[t[r + 6]] + byteToHex$1[t[r + 7]] + "-" + byteToHex$1[t[r + 8]] + byteToHex$1[t[r + 9]] + "-" + byteToHex$1[t[r + 10]] + byteToHex$1[t[r + 11]] + byteToHex$1[t[r + 12]] + byteToHex$1[t[r + 13]] + byteToHex$1[t[r + 14]] + byteToHex$1[t[r + 15]]).toLowerCase();
  if (!validate(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
var _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1(t, r, n) {
  var a = r && n || 0, s = r || new Array(16);
  t = t || {};
  var o = t.node || _nodeId, c = t.clockseq !== void 0 ? t.clockseq : _clockseq;
  if (o == null || c == null) {
    var l = t.random || (t.rng || rng$1)();
    o == null && (o = _nodeId = [l[0] | 1, l[1], l[2], l[3], l[4], l[5]]), c == null && (c = _clockseq = (l[6] << 8 | l[7]) & 16383);
  }
  var d = t.msecs !== void 0 ? t.msecs : Date.now(), h = t.nsecs !== void 0 ? t.nsecs : _lastNSecs + 1, u = d - _lastMSecs + (h - _lastNSecs) / 1e4;
  if (u < 0 && t.clockseq === void 0 && (c = c + 1 & 16383), (u < 0 || d > _lastMSecs) && t.nsecs === void 0 && (h = 0), h >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = d, _lastNSecs = h, _clockseq = c, d += 122192928e5;
  var p = ((d & 268435455) * 1e4 + h) % 4294967296;
  s[a++] = p >>> 24 & 255, s[a++] = p >>> 16 & 255, s[a++] = p >>> 8 & 255, s[a++] = p & 255;
  var m = d / 4294967296 * 1e4 & 268435455;
  s[a++] = m >>> 8 & 255, s[a++] = m & 255, s[a++] = m >>> 24 & 15 | 16, s[a++] = m >>> 16 & 255, s[a++] = c >>> 8 | 128, s[a++] = c & 255;
  for (var g = 0; g < 6; ++g)
    s[a + g] = o[g];
  return r || stringify$1(s);
}
function parse$1(t) {
  if (!validate(t))
    throw TypeError("Invalid UUID");
  var r, n = new Uint8Array(16);
  return n[0] = (r = parseInt(t.slice(0, 8), 16)) >>> 24, n[1] = r >>> 16 & 255, n[2] = r >>> 8 & 255, n[3] = r & 255, n[4] = (r = parseInt(t.slice(9, 13), 16)) >>> 8, n[5] = r & 255, n[6] = (r = parseInt(t.slice(14, 18), 16)) >>> 8, n[7] = r & 255, n[8] = (r = parseInt(t.slice(19, 23), 16)) >>> 8, n[9] = r & 255, n[10] = (r = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = r / 4294967296 & 255, n[12] = r >>> 24 & 255, n[13] = r >>> 16 & 255, n[14] = r >>> 8 & 255, n[15] = r & 255, n;
}
function stringToBytes(t) {
  t = unescape(encodeURIComponent(t));
  for (var r = [], n = 0; n < t.length; ++n)
    r.push(t.charCodeAt(n));
  return r;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(t, r, n) {
  function a(s, o, c, l) {
    if (typeof s == "string" && (s = stringToBytes(s)), typeof o == "string" && (o = parse$1(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var d = new Uint8Array(16 + s.length);
    if (d.set(o), d.set(s, o.length), d = n(d), d[6] = d[6] & 15 | r, d[8] = d[8] & 63 | 128, c) {
      l = l || 0;
      for (var h = 0; h < 16; ++h)
        c[l + h] = d[h];
      return c;
    }
    return stringify$1(d);
  }
  try {
    a.name = t;
  } catch {
  }
  return a.DNS = DNS, a.URL = URL$1, a;
}
function md5(t) {
  if (typeof t == "string") {
    var r = unescape(encodeURIComponent(t));
    t = new Uint8Array(r.length);
    for (var n = 0; n < r.length; ++n)
      t[n] = r.charCodeAt(n);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(t), t.length * 8));
}
function md5ToHexEncodedArray(t) {
  for (var r = [], n = t.length * 32, a = "0123456789abcdef", s = 0; s < n; s += 8) {
    var o = t[s >> 5] >>> s % 32 & 255, c = parseInt(a.charAt(o >>> 4 & 15) + a.charAt(o & 15), 16);
    r.push(c);
  }
  return r;
}
function getOutputLength(t) {
  return (t + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(t, r) {
  t[r >> 5] |= 128 << r % 32, t[getOutputLength(r) - 1] = r;
  for (var n = 1732584193, a = -271733879, s = -1732584194, o = 271733878, c = 0; c < t.length; c += 16) {
    var l = n, d = a, h = s, u = o;
    n = md5ff(n, a, s, o, t[c], 7, -680876936), o = md5ff(o, n, a, s, t[c + 1], 12, -389564586), s = md5ff(s, o, n, a, t[c + 2], 17, 606105819), a = md5ff(a, s, o, n, t[c + 3], 22, -1044525330), n = md5ff(n, a, s, o, t[c + 4], 7, -176418897), o = md5ff(o, n, a, s, t[c + 5], 12, 1200080426), s = md5ff(s, o, n, a, t[c + 6], 17, -1473231341), a = md5ff(a, s, o, n, t[c + 7], 22, -45705983), n = md5ff(n, a, s, o, t[c + 8], 7, 1770035416), o = md5ff(o, n, a, s, t[c + 9], 12, -1958414417), s = md5ff(s, o, n, a, t[c + 10], 17, -42063), a = md5ff(a, s, o, n, t[c + 11], 22, -1990404162), n = md5ff(n, a, s, o, t[c + 12], 7, 1804603682), o = md5ff(o, n, a, s, t[c + 13], 12, -40341101), s = md5ff(s, o, n, a, t[c + 14], 17, -1502002290), a = md5ff(a, s, o, n, t[c + 15], 22, 1236535329), n = md5gg(n, a, s, o, t[c + 1], 5, -165796510), o = md5gg(o, n, a, s, t[c + 6], 9, -1069501632), s = md5gg(s, o, n, a, t[c + 11], 14, 643717713), a = md5gg(a, s, o, n, t[c], 20, -373897302), n = md5gg(n, a, s, o, t[c + 5], 5, -701558691), o = md5gg(o, n, a, s, t[c + 10], 9, 38016083), s = md5gg(s, o, n, a, t[c + 15], 14, -660478335), a = md5gg(a, s, o, n, t[c + 4], 20, -405537848), n = md5gg(n, a, s, o, t[c + 9], 5, 568446438), o = md5gg(o, n, a, s, t[c + 14], 9, -1019803690), s = md5gg(s, o, n, a, t[c + 3], 14, -187363961), a = md5gg(a, s, o, n, t[c + 8], 20, 1163531501), n = md5gg(n, a, s, o, t[c + 13], 5, -1444681467), o = md5gg(o, n, a, s, t[c + 2], 9, -51403784), s = md5gg(s, o, n, a, t[c + 7], 14, 1735328473), a = md5gg(a, s, o, n, t[c + 12], 20, -1926607734), n = md5hh(n, a, s, o, t[c + 5], 4, -378558), o = md5hh(o, n, a, s, t[c + 8], 11, -2022574463), s = md5hh(s, o, n, a, t[c + 11], 16, 1839030562), a = md5hh(a, s, o, n, t[c + 14], 23, -35309556), n = md5hh(n, a, s, o, t[c + 1], 4, -1530992060), o = md5hh(o, n, a, s, t[c + 4], 11, 1272893353), s = md5hh(s, o, n, a, t[c + 7], 16, -155497632), a = md5hh(a, s, o, n, t[c + 10], 23, -1094730640), n = md5hh(n, a, s, o, t[c + 13], 4, 681279174), o = md5hh(o, n, a, s, t[c], 11, -358537222), s = md5hh(s, o, n, a, t[c + 3], 16, -722521979), a = md5hh(a, s, o, n, t[c + 6], 23, 76029189), n = md5hh(n, a, s, o, t[c + 9], 4, -640364487), o = md5hh(o, n, a, s, t[c + 12], 11, -421815835), s = md5hh(s, o, n, a, t[c + 15], 16, 530742520), a = md5hh(a, s, o, n, t[c + 2], 23, -995338651), n = md5ii(n, a, s, o, t[c], 6, -198630844), o = md5ii(o, n, a, s, t[c + 7], 10, 1126891415), s = md5ii(s, o, n, a, t[c + 14], 15, -1416354905), a = md5ii(a, s, o, n, t[c + 5], 21, -57434055), n = md5ii(n, a, s, o, t[c + 12], 6, 1700485571), o = md5ii(o, n, a, s, t[c + 3], 10, -1894986606), s = md5ii(s, o, n, a, t[c + 10], 15, -1051523), a = md5ii(a, s, o, n, t[c + 1], 21, -2054922799), n = md5ii(n, a, s, o, t[c + 8], 6, 1873313359), o = md5ii(o, n, a, s, t[c + 15], 10, -30611744), s = md5ii(s, o, n, a, t[c + 6], 15, -1560198380), a = md5ii(a, s, o, n, t[c + 13], 21, 1309151649), n = md5ii(n, a, s, o, t[c + 4], 6, -145523070), o = md5ii(o, n, a, s, t[c + 11], 10, -1120210379), s = md5ii(s, o, n, a, t[c + 2], 15, 718787259), a = md5ii(a, s, o, n, t[c + 9], 21, -343485551), n = safeAdd(n, l), a = safeAdd(a, d), s = safeAdd(s, h), o = safeAdd(o, u);
  }
  return [n, a, s, o];
}
function bytesToWords(t) {
  if (t.length === 0)
    return [];
  for (var r = t.length * 8, n = new Uint32Array(getOutputLength(r)), a = 0; a < r; a += 8)
    n[a >> 5] |= (t[a / 8] & 255) << a % 32;
  return n;
}
function safeAdd(t, r) {
  var n = (t & 65535) + (r & 65535), a = (t >> 16) + (r >> 16) + (n >> 16);
  return a << 16 | n & 65535;
}
function bitRotateLeft(t, r) {
  return t << r | t >>> 32 - r;
}
function md5cmn(t, r, n, a, s, o) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(r, t), safeAdd(a, o)), s), n);
}
function md5ff(t, r, n, a, s, o, c) {
  return md5cmn(r & n | ~r & a, t, r, s, o, c);
}
function md5gg(t, r, n, a, s, o, c) {
  return md5cmn(r & a | n & ~a, t, r, s, o, c);
}
function md5hh(t, r, n, a, s, o, c) {
  return md5cmn(r ^ n ^ a, t, r, s, o, c);
}
function md5ii(t, r, n, a, s, o, c) {
  return md5cmn(n ^ (r | ~a), t, r, s, o, c);
}
var v3 = v35("v3", 48, md5);
const v3$1 = v3;
function v4$1(t, r, n) {
  t = t || {};
  var a = t.random || (t.rng || rng$1)();
  if (a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, r) {
    n = n || 0;
    for (var s = 0; s < 16; ++s)
      r[n + s] = a[s];
    return r;
  }
  return stringify$1(a);
}
function f(t, r, n, a) {
  switch (t) {
    case 0:
      return r & n ^ ~r & a;
    case 1:
      return r ^ n ^ a;
    case 2:
      return r & n ^ r & a ^ n & a;
    case 3:
      return r ^ n ^ a;
  }
}
function ROTL(t, r) {
  return t << r | t >>> 32 - r;
}
function sha1(t) {
  var r = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var a = unescape(encodeURIComponent(t));
    t = [];
    for (var s = 0; s < a.length; ++s)
      t.push(a.charCodeAt(s));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var o = t.length / 4 + 2, c = Math.ceil(o / 16), l = new Array(c), d = 0; d < c; ++d) {
    for (var h = new Uint32Array(16), u = 0; u < 16; ++u)
      h[u] = t[d * 64 + u * 4] << 24 | t[d * 64 + u * 4 + 1] << 16 | t[d * 64 + u * 4 + 2] << 8 | t[d * 64 + u * 4 + 3];
    l[d] = h;
  }
  l[c - 1][14] = (t.length - 1) * 8 / Math.pow(2, 32), l[c - 1][14] = Math.floor(l[c - 1][14]), l[c - 1][15] = (t.length - 1) * 8 & 4294967295;
  for (var p = 0; p < c; ++p) {
    for (var m = new Uint32Array(80), g = 0; g < 16; ++g)
      m[g] = l[p][g];
    for (var v = 16; v < 80; ++v)
      m[v] = ROTL(m[v - 3] ^ m[v - 8] ^ m[v - 14] ^ m[v - 16], 1);
    for (var y = n[0], x = n[1], _ = n[2], $ = n[3], b = n[4], M = 0; M < 80; ++M) {
      var C = Math.floor(M / 20), S = ROTL(y, 5) + f(C, x, _, $) + b + r[C] + m[M] >>> 0;
      b = $, $ = _, _ = ROTL(x, 30) >>> 0, x = y, y = S;
    }
    n[0] = n[0] + y >>> 0, n[1] = n[1] + x >>> 0, n[2] = n[2] + _ >>> 0, n[3] = n[3] + $ >>> 0, n[4] = n[4] + b >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, n[0] & 255, n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, n[1] & 255, n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, n[2] & 255, n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, n[3] & 255, n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, n[4] & 255];
}
var v5 = v35("v5", 80, sha1);
const v5$1 = v5, nil = "00000000-0000-0000-0000-000000000000";
function version(t) {
  if (!validate(t))
    throw TypeError("Invalid UUID");
  return parseInt(t.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil,
  parse: parse$1,
  stringify: stringify$1,
  v1,
  v3: v3$1,
  v4: v4$1,
  v5: v5$1,
  validate,
  version
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser);
var uuid = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
    l(v);
    for (var x in y)
      n(v, x, { get: y[x], enumerable: !0 });
  }, h = (v, y, x) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let _ of s(y))
        !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
    return v;
  }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
  d(t, {
    Uuid: () => g
  });
  var p = u(require$$0), m = u(validationTaxDownError);
  class g {
    constructor(y) {
      this.ensureIsValidUuid(y), this.value = y;
    }
    static create(y) {
      return new g(y || (0, p.v4)());
    }
    ensureIsValidUuid(y) {
      if (!(0, p.validate)(y))
        throw new m.ValidationTaxDownError(`${this.constructor.name} does not allow the value ${y}`);
    }
  }
})(uuid);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
    l(v);
    for (var x in y)
      n(v, x, { get: y[x], enumerable: !0 });
  }, h = (v, y, x) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let _ of s(y))
        !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
    return v;
  }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
  d(t, {
    EventId: () => g
  });
  var p = u(require$$0), m = u(uuid);
  class g extends m.Uuid {
    constructor(y = (0, p.v4)()) {
      if (!(0, p.validate)(y) || (0, p.version)(y) !== 4)
        throw new Error(`Incorrect format identifier value:${y} (must be uuid v4)`);
      super(y);
    }
  }
})(eventId);
var eventType = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    EventType: () => m
  });
  var p = u(stringValueObject);
  class m extends p.StringValueObject {
  }
})(eventType);
var event$1 = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(event$1);
var domainEvent = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    DomainEvent: () => m
  });
  var p = u(eventId);
  class m {
    constructor(v, y, x, _) {
      this.aggregateId = v, this.type = y, this.id = x || new p.EventId(), this.timestamp = _ || /* @__PURE__ */ new Date();
    }
    getAttributes() {
      return {};
    }
  }
})(domainEvent);
var integrationEvent = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    IntegrationEvent: () => m
  });
  var p = u(eventId);
  class m {
    constructor(v, y, x, _) {
      this.aggregateId = v, this.type = y, this.id = x || new p.EventId(), this.timestamp = _ || /* @__PURE__ */ new Date();
    }
    getAttributes() {
      return {};
    }
  }
})(integrationEvent);
var aggregateRoot = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    AggregateRoot: () => s
  });
  class s {
    constructor() {
      this.domainEventQueue = [];
    }
    clearDomainEvents() {
      this.domainEventQueue = [];
    }
    domainEvents() {
      const c = this.domainEventQueue.slice();
      return this.clearDomainEvents(), c;
    }
    registerDomainEvent(c) {
      this.domainEventQueue.push(c);
    }
  }
})(aggregateRoot);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = ($) => n($, "__esModule", { value: !0 }), d = ($, b) => {
    l($);
    for (var M in b)
      n($, M, { get: b[M], enumerable: !0 });
  }, h = ($, b, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let C of s(b))
        !c.call($, C) && C !== "default" && n($, C, { get: () => b[C], enumerable: !(M = a(b, C)) || M.enumerable });
    return $;
  }, u = ($) => h(l(n($ != null ? r(o($)) : {}, "default", $ && $.__esModule && "default" in $ ? { get: () => $.default, enumerable: !0 } : { value: $, enumerable: !0 })), $);
  d(t, {
    AggregateRoot: () => _.AggregateRoot,
    DomainEvent: () => y.DomainEvent,
    Event: () => v.Event,
    EventAttributesDTO: () => v.EventAttributesDTO,
    EventBusAsync: () => p.EventBusAsync,
    EventDTO: () => v.EventDTO,
    EventId: () => m.EventId,
    EventType: () => g.EventType,
    IntegrationEvent: () => x.IntegrationEvent
  });
  var p = u(eventBusAsync), m = u(eventId), g = u(eventType), v = u(event$1), y = u(domainEvent), x = u(integrationEvent), _ = u(aggregateRoot);
})(event$2);
var mapper$1 = {}, mapper = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(mapper);
var profile = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(profile);
var types$1 = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(types$1);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (u) => n(u, "__esModule", { value: !0 }), d = (u, p, m) => {
    if (p && typeof p == "object" || typeof p == "function")
      for (let g of s(p))
        !c.call(u, g) && g !== "default" && n(u, g, { get: () => p[g], enumerable: !(m = a(p, g)) || m.enumerable });
    return u;
  }, h = (u) => d(l(n(u != null ? r(o(u)) : {}, "default", u && u.__esModule && "default" in u ? { get: () => u.default, enumerable: !0 } : { value: u, enumerable: !0 })), u);
  l(t), d(t, h(mapper)), d(t, h(profile)), d(t, h(types$1));
})(mapper$1);
var logger = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(logger);
var loggerDecorator = {};
(function(t) {
  var r = Object.defineProperty, n = (h) => r(h, "__esModule", { value: !0 }), a = (h, u) => {
    n(h);
    for (var p in u)
      r(h, p, { get: u[p], enumerable: !0 });
  };
  a(t, {
    LoggerClass: () => d,
    LoggerMethod: () => l
  });
  const s = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm, o = /([^\s,]+)/g;
  function c(h) {
    const u = h.toString().replace(s, "");
    let p = u.slice(u.indexOf("(") + 1, u.indexOf(")")).match(o);
    return p === null && (p = []), p;
  }
  function l(h) {
    return (u, p) => {
      const m = p.value;
      return p.value = function(...g) {
        var v;
        const y = c(m), x = {
          method: u,
          args: {}
        };
        for (const $ in g) {
          const b = `${u}-${y[$]}`;
          x.args[b] = JSON.stringify(g[$]);
        }
        return (v = this.logger) == null || v.log(h, x), m.apply(this, g);
      }, p;
    };
  }
  function d(h) {
    const u = h != null && h.level ? h.level : "debug";
    return function(p) {
      if (!(h != null && h.environments) || h.environments.includes(process.env.STAGE)) {
        for (const m of Reflect.ownKeys(p.prototype))
          if (!(h != null && h.blacklist) || !h.blacklist.includes(m)) {
            let g = Reflect.getOwnPropertyDescriptor(p.prototype, m);
            g && (g = l(u)(m, g), Reflect.defineProperty(p.prototype, m, g));
          }
      }
    };
  }
})(loggerDecorator);
var money = {}, currency_min = { exports: {} };
(function(t, r) {
  (function(n, a) {
    t.exports = a();
  })(commonjsGlobal, function() {
    function n(l, d) {
      if (!(this instanceof n))
        return new n(l, d);
      d = Object.assign({}, s, d);
      var h = Math.pow(10, d.precision);
      this.intValue = l = a(l, d), this.value = l / h, d.increment = d.increment || 1 / h, d.groups = d.useVedic ? c : o, this.s = d, this.p = h;
    }
    function a(l, d) {
      var h = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : !0, u = d.decimal, p = d.errorOnInvalid, m = d.fromCents, g = Math.pow(10, d.precision), v = l instanceof n;
      if (v && m)
        return l.intValue;
      if (typeof l == "number" || v)
        u = v ? l.value : l;
      else if (typeof l == "string")
        p = new RegExp("[^-\\d" + u + "]", "g"), u = new RegExp("\\" + u, "g"), u = (u = l.replace(/\((.*)\)/, "-$1").replace(p, "").replace(u, ".")) || 0;
      else {
        if (p)
          throw Error("Invalid Input");
        u = 0;
      }
      return m || (u = (u * g).toFixed(4)), h ? Math.round(u) : u;
    }
    var s = { symbol: "$", separator: ",", decimal: ".", errorOnInvalid: !1, precision: 2, pattern: "!#", negativePattern: "-!#", format: function(l, d) {
      var h = d.pattern, u = d.negativePattern, p = d.symbol, m = d.separator, g = d.decimal;
      d = d.groups;
      var v = ("" + l).replace(/^-/, "").split("."), y = v[0];
      return v = v[1], (0 <= l.value ? h : u).replace("!", p).replace("#", y.replace(d, "$1" + m) + (v ? g + v : ""));
    }, fromCents: !1 }, o = /(\d)(?=(\d{3})+\b)/g, c = /(\d)(?=(\d\d)+\d\b)/g;
    return n.prototype = { add: function(l) {
      var d = this.s, h = this.p;
      return n((this.intValue + a(l, d)) / (d.fromCents ? 1 : h), d);
    }, subtract: function(l) {
      var d = this.s, h = this.p;
      return n((this.intValue - a(l, d)) / (d.fromCents ? 1 : h), d);
    }, multiply: function(l) {
      var d = this.s;
      return n(this.intValue * l / (d.fromCents ? 1 : Math.pow(10, d.precision)), d);
    }, divide: function(l) {
      var d = this.s;
      return n(this.intValue / a(l, d, !1), d);
    }, distribute: function(l) {
      var d = this.intValue, h = this.p, u = this.s, p = [], m = Math[0 <= d ? "floor" : "ceil"](d / l), g = Math.abs(d - m * l);
      for (h = u.fromCents ? 1 : h; l !== 0; l--) {
        var v = n(m / h, u);
        0 < g-- && (v = v[0 <= d ? "add" : "subtract"](1 / h)), p.push(v);
      }
      return p;
    }, dollars: function() {
      return ~~this.value;
    }, cents: function() {
      return ~~(this.intValue % this.p);
    }, format: function(l) {
      var d = this.s;
      return typeof l == "function" ? l(this, d) : d.format(this, Object.assign({}, d, l));
    }, toString: function() {
      var l = this.s, d = l.increment;
      return (Math.round(this.intValue / this.p / d) * d).toFixed(l.precision);
    }, toJSON: function() {
      return this.value;
    } }, n;
  });
})(currency_min);
var currency_minExports = currency_min.exports;
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    Money: () => m
  });
  var p = u(currency_minExports);
  class m {
    constructor(v) {
      this.value = v;
    }
    static fromCents(v) {
      return new m((0, p.default)(v / 100));
    }
    static fromEuros(v) {
      return new m((0, p.default)(v));
    }
    add(v) {
      return new m(this.value.add(v.value));
    }
    subtract(v) {
      return new m(this.value.subtract(v.value));
    }
    multiply(v) {
      return new m(this.value.multiply(v));
    }
    euros() {
      return this.value.value;
    }
    cents() {
      return this.value.intValue;
    }
  }
})(money);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    LogLevel: () => p.LogLevel,
    Logger: () => m.Logger,
    LoggerClass: () => g.LoggerClass,
    LoggerMethod: () => g.LoggerMethod,
    Money: () => $.Money,
    NumberValueObject: () => y.NumberValueObject,
    ObjectValueObject: () => x.ObjectValueObject,
    StringValueObject: () => _.StringValueObject,
    Uuid: () => v.Uuid
  }), h(t, u(error$1)), h(t, u(event$2)), h(t, u(mapper$1));
  var p = u(logLevel), m = u(logger), g = u(loggerDecorator), v = u(uuid), y = u(numberValueObject), x = u(objectValueObject), _ = u(stringValueObject), $ = u(money);
})(domain);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    UseCase: () => m
  });
  var p = u(domain);
  class m {
    constructor(v, y) {
      this.logger = v, this.validator = y;
    }
    async execute(v) {
      return this.validateRequest(v), await this.run(v);
    }
    validateRequest(v) {
      if (!this.validator)
        return;
      const y = this.validator.validate(v);
      if (!y.valid)
        throw new p.ValidationTaxDownError(`Error input validation: ${y.errorMessage}`);
    }
  }
})(useCase);
var validator = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(validator);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    UseCase: () => p.UseCase,
    Validator: () => m.Validator,
    ValidatorResult: () => m.ValidatorResult
  });
  var p = u(useCase), m = u(validator);
})(useCase$1);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (u) => n(u, "__esModule", { value: !0 }), d = (u, p, m) => {
    if (p && typeof p == "object" || typeof p == "function")
      for (let g of s(p))
        !c.call(u, g) && g !== "default" && n(u, g, { get: () => p[g], enumerable: !(m = a(p, g)) || m.enumerable });
    return u;
  }, h = (u) => d(l(n(u != null ? r(o(u)) : {}, "default", u && u.__esModule && "default" in u ? { get: () => u.default, enumerable: !0 } : { value: u, enumerable: !0 })), u);
  l(t), d(t, h(useCase$1));
})(application);
var infrastructure = {}, baseController = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    BaseController: () => s
  });
  class s {
    constructor(c) {
      this.logger = c, this.loggerResponse = !0;
    }
    handlerException(c, l) {
      throw this.logger.error(c, l), c;
    }
  }
})(baseController);
var genericController = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    GenericController: () => s
  });
  class s {
    constructor(c) {
      this.logger = c, this.loggerResponse = !0;
    }
    handlerException(c, l) {
      throw this.logger.error(c, l), c;
    }
  }
})(genericController);
var serviceResponse = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(serviceResponse);
var serviceResponseItem = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(serviceResponseItem);
var httpManager = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(httpManager);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (x) => n(x, "__esModule", { value: !0 }), d = (x, _) => {
    l(x);
    for (var $ in _)
      n(x, $, { get: _[$], enumerable: !0 });
  }, h = (x, _, $) => {
    if (_ && typeof _ == "object" || typeof _ == "function")
      for (let b of s(_))
        !c.call(x, b) && b !== "default" && n(x, b, { get: () => _[b], enumerable: !($ = a(_, b)) || $.enumerable });
    return x;
  }, u = (x) => h(l(n(x != null ? r(o(x)) : {}, "default", x && x.__esModule && "default" in x ? { get: () => x.default, enumerable: !0 } : { value: x, enumerable: !0 })), x);
  d(t, {
    BaseController: () => p.BaseController,
    GenericController: () => m.GenericController,
    HttpManager: () => y.HttpManager,
    HttpManagerBody: () => y.HttpManagerBody,
    HttpManagerHeaders: () => y.HttpManagerHeaders,
    HttpManagerOptions: () => y.HttpManagerOptions,
    ServiceResponse: () => g.ServiceResponse,
    ServiceResponseItem: () => v.ServiceResponseItem
  });
  var p = u(baseController), m = u(genericController), g = u(serviceResponse), v = u(serviceResponseItem), y = u(httpManager);
})(infrastructure);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (u) => n(u, "__esModule", { value: !0 }), d = (u, p, m) => {
    if (p && typeof p == "object" || typeof p == "function")
      for (let g of s(p))
        !c.call(u, g) && g !== "default" && n(u, g, { get: () => p[g], enumerable: !(m = a(p, g)) || m.enumerable });
    return u;
  }, h = (u) => d(l(n(u != null ? r(o(u)) : {}, "default", u && u.__esModule && "default" in u ? { get: () => u.default, enumerable: !0 } : { value: u, enumerable: !0 })), u);
  l(t), d(t, h(application)), d(t, h(domain)), d(t, h(infrastructure));
})(dist);
var errors = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    Errors: () => s
  });
  var s;
  (function(o) {
    o[o.mathError = 2e3] = "mathError", o[o.mathFunctionError = 2001] = "mathFunctionError", o[o.mathEvaluateError = 2002] = "mathEvaluateError", o[o.modelError = 3e3] = "modelError", o[o.modelSingleOptionTypeInvalid = 3001] = "modelSingleOptionTypeInvalid";
  })(s || (s = {}));
})(errors);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
    l(v);
    for (var x in y)
      n(v, x, { get: y[x], enumerable: !0 });
  }, h = (v, y, x) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let _ of s(y))
        !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
    return v;
  }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
  d(t, {
    MathFunctionError: () => g
  });
  var p = u(dist), m = u(errors);
  class g extends p.TaxDownError {
    constructor(y) {
      const x = "mathFunctionError";
      super(new p.ErrorName(x), new p.ErrorMessage(y), new p.ErrorStatus(500), new p.ErrorInternalCode(m.Errors[x]), new p.ErrorLogLevel(p.LogLevel.WARN));
    }
  }
})(mathFunctionError);
var utils$5 = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (G) => n(G, "__esModule", { value: !0 }), d = (G, I) => {
    l(G);
    for (var k in I)
      n(G, k, { get: I[k], enumerable: !0 });
  }, h = (G, I, k) => {
    if (I && typeof I == "object" || typeof I == "function")
      for (let B of s(I))
        !c.call(G, B) && B !== "default" && n(G, B, { get: () => I[B], enumerable: !(k = a(I, B)) || k.enumerable });
    return G;
  }, u = (G) => h(l(n(G != null ? r(o(G)) : {}, "default", G && G.__esModule && "default" in G ? { get: () => G.default, enumerable: !0 } : { value: G, enumerable: !0 })), G);
  d(t, {
    ARG: () => m,
    evalArgs: () => g,
    fillingValue: () => v,
    getCountValue: () => y,
    isArrayLengthGreaterOne: () => _,
    isCondition: () => x,
    operate: () => F,
    operateMatrices: () => R,
    operateMatricesOneToMany: () => z,
    operateMatrix: () => A,
    sanitizeNumber: () => b,
    sanitizeString: () => C,
    simplify: () => O,
    uppercaseString: () => S
  });
  var p = u(mathFunctionError);
  const m = {
    MATRIX: {
      BOOLEAN: [!1],
      STRING: [""],
      NUMBER: [0]
    },
    SCALAR: {
      BOOLEAN: !1,
      STRING: "",
      NUMBER: 0
    }
  }, g = (G, I, k, B) => G.map((L, V) => {
    if (I[L.name] !== void 0 || L.fn || L.value || L.content) {
      const U = L.compile().evaluate(I);
      if (Array.isArray(U))
        return U.map((J) => J === void 0 ? k : J);
      if (U !== void 0)
        return U;
    }
    return V === 0 || B === void 0 ? k : B;
  }), v = (G) => Array.isArray(G) && G.every((k) => typeof k == "string") || typeof G == "string" ? m.SCALAR.STRING : m.SCALAR.NUMBER, y = (G, I) => Number.isInteger(G) && G !== 0 ? G : typeof I == "string" && (Number.isNaN(parseInt(G)) || G === 0) ? I.length : parseInt(G), x = (G) => Array.isArray(G) ? !G.every((I) => I === !1) : G === !0, _ = (G) => Array.isArray(G) && G.length > 1, $ = (G) => typeof G != "number" ? typeof G == "boolean" ? G ? 1 : m.SCALAR.NUMBER : Number.isNaN(parseFloat(G)) ? m.SCALAR.NUMBER : parseFloat(G) : G, b = (G, I = 1) => Array.isArray(G) && G.length >= I ? G.map((k) => Array.isArray(k) ? b(k) : $(k)) : I > 1 ? Array.isArray(G) ? G.concat(new Array(I - G.length).fill(0)).map((L) => $(L)) : [G].concat(new Array(I - G.length).fill(0)).map((B) => $(B)) : $(G), M = (G) => typeof G != "string" ? m.SCALAR.STRING : G, C = (G) => Array.isArray(G) ? G.map((I) => M(I)) : M(G), S = (G) => Array.isArray(G) ? G.map((I) => I.toUpperCase()) : G.toUpperCase(), A = (G, I, k = null) => {
    if (!Array.isArray(I))
      return k == null ? [G(I)] : [G(I, k)];
    if (k && Array.isArray(k)) {
      const V = `Function ${G.name}. Expected value but found matrix as argument: [${k}]`;
      throw new p.MathFunctionError(V);
    }
    const B = I.length || 1, L = new Array(B);
    for (let V = 0; V < B; V += 1)
      k == null ? L[V] = G(I[V]) : L[V] = G(I[V], k);
    return L;
  }, D = (G, I, k) => I === void 0 && k === void 0 ? 0 : I === void 0 ? k : k === void 0 ? I : G(I, k), N = (G, I) => {
    const k = I.map((V) => Array.isArray(V) ? V : [V]), B = k[0].length, L = new Array(B);
    for (let V = 0; V < k.length; V += 1)
      if (k[V].length !== B) {
        const U = `Function ${G.name}. Multiple matrices with different sizes; [${k[0]}] = ${B},  [${k[V]}] = ${k[V].length}`;
        throw new p.MathFunctionError(U);
      }
    for (let V = 0; V < B; V += 1) {
      const U = [];
      for (let J = 0; J < k.length; J += 1)
        U.push(k[J][V]);
      L[V] = G(...U);
    }
    return L;
  }, T = (G, I, k) => !Array.isArray(I) && !Array.isArray(k) ? [D(G, I, k)] : !Array.isArray(I) && Array.isArray(k) ? A(G, k, I) : Array.isArray(I) && !Array.isArray(k) ? A(G, I, k) : Array.isArray(I) && k.length === 1 ? A(G, I, k[0]) : I.length === 1 && !Array.isArray(k) ? A(G, k, I[0]) : N(G, [I, k]), R = (G, ...I) => {
    const k = I.filter((B) => B !== void 0);
    return k && Array.isArray(k) && k.length !== 0 ? k.length === 1 ? A(G, k[0]) : k.length === 2 ? T(G, k[0], k[1]) : N(G, k) : [G()];
  }, F = (G, ...I) => {
    const k = R(G, ...I);
    return I.some((L) => Array.isArray(L)) ? k : k[0];
  }, z = (G, I, k, B) => {
    if (!Array.isArray(B)) {
      const L = `Function ${G.name}. Operand 2 is not a matrix ${B}`;
      throw new p.MathFunctionError(L);
    }
    return B.map((L) => I(k, L));
  }, O = (G) => Array.isArray(G) && G.length === 1 ? G[0] : G;
})(utils$5);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (gr) => n(gr, "__esModule", { value: !0 }), d = (gr, Cr) => {
    l(gr);
    for (var Pr in Cr)
      n(gr, Pr, { get: Cr[Pr], enumerable: !0 });
  }, h = (gr, Cr, Pr) => {
    if (Cr && typeof Cr == "object" || typeof Cr == "function")
      for (let Tr of s(Cr))
        !c.call(gr, Tr) && Tr !== "default" && n(gr, Tr, { get: () => Cr[Tr], enumerable: !(Pr = a(Cr, Tr)) || Pr.enumerable });
    return gr;
  }, u = (gr) => h(l(n(gr != null ? r(o(gr)) : {}, "default", gr && gr.__esModule && "default" in gr ? { get: () => gr.default, enumerable: !0 } : { value: gr, enumerable: !0 })), gr);
  d(t, {
    addFunction: () => _,
    appendMatrixFunction: () => $,
    buildMatrixTextFunction: () => b,
    calculateGravamenFunction: () => C,
    concatenateFunction: () => S,
    containTextFunction: () => I,
    dateCalculateDaysFunction: () => N,
    dateHumanizeFunction: () => A,
    dateReverseFunction: () => D,
    divideFunction: () => T,
    elementMatrixFunction: () => R,
    emptyFunction: () => F,
    equalFunction: () => z,
    equalTextFunction: () => O,
    floorFunction: () => G,
    ifThenFunction: () => B,
    includeEqualTextFunction: () => U,
    includeTextFunction: () => V,
    indexFirstTextValueFunction: () => H,
    indexFunction: () => dr,
    indexMaximumFunction: () => Ar,
    indexMinimumFunction: () => jr,
    indexSumFunction: () => Vr,
    largerEqFunction: () => ae,
    largerFunction: () => Z,
    leftNumberFunction: () => ee,
    leftTextFunction: () => se,
    logicFunction: () => oe,
    matchNumberFunction: () => en,
    matchTextFunction: () => zr,
    maximumFunction: () => ur,
    minimumFunction: () => ir,
    modeFunction: () => yr,
    multiplyFunction: () => _r,
    notContainTextFunction: () => k,
    notEmptyFunction: () => ne,
    notIncludeEqualTextFunction: () => q,
    notIncludeTextFunction: () => J,
    parseNameFunction: () => Sr,
    percentageFunction: () => ze,
    positionFunction: () => Zr,
    removeEmptiesFunction: () => cr,
    removeTextFunction: () => fr,
    removeTextsFunction: () => mr,
    rightNumberFunction: () => wr,
    rightTextFunction: () => Nr,
    roundFunction: () => xr,
    roundIntegerFunction: () => Er,
    sanitizeFunction: () => Jr,
    smallerEqFunction: () => ce,
    smallerFunction: () => nr,
    subtractFunction: () => Ir,
    summatoryMatrixFunction: () => Rr,
    unequalFunction: () => Yr,
    unequalTextFunction: () => nn,
    unequalTextLegacyFunction: () => Qr,
    uniqueFunction: () => pn
  });
  var p = u(cjs$1), m = u(require$$2), g = u(utils$6), v = u(mathFunctionError), y = u(utils$5);
  const x = (0, p.create)(p.all), _ = (...gr) => {
    const Cr = (0, y.sanitizeNumber)(gr, 2);
    return x.add(...Cr);
  }, $ = (gr, Cr, Pr) => {
    let Tr = [];
    return (0, g.isEmpty)(Cr) ? Tr.push(gr) : Array.isArray(Cr) ? Tr = Tr.concat(Cr) : Tr.push(Cr), (0, g.isEmpty)(Pr) ? Tr.push(gr) : Array.isArray(Pr) ? Tr = Tr.concat(Pr) : Tr.push(Pr), Tr;
  }, b = (gr) => {
    if (typeof gr != "string")
      throw new v.MathFunctionError(`Function buildMatrixText. value error type: ${typeof gr}`);
    const Cr = gr.split(",");
    return (0, y.sanitizeString)(Cr);
  }, M = function(gr, Cr) {
    return Math.trunc(gr * Math.pow(10, Cr)) / Math.pow(10, Cr);
  }, C = (gr, Cr, Pr, Tr, Xr = g.roundNumber, rn = !1, un = !1) => {
    let ln = 0, bn = Cr;
    for (let $n = 1; $n < Pr.length; $n += 1) {
      const An = Pr[$n] - Pr[$n - 1], Nn = rn ? M(An, 2) : An, Pn = Tr[$n - 1];
      bn - Nn >= 0 ? (ln += Nn * Pn, ln = un ? (0, g.roundNumber)(ln) : ln) : ln += (0, g.roundNumber)(bn * Pn), bn = (0, g.roundNumber)(Math.max(bn - Nn, 0));
    }
    return bn > 0 && (ln += (0, g.roundNumber)(bn * Tr[Tr.length - 1])), Xr(ln);
  }, S = (...gr) => (0, y.sanitizeString)(gr).reduce((Pr, Tr) => `${Pr}${Tr}`, y.ARG.SCALAR.STRING), A = (gr) => {
    if (gr) {
      if (gr && (typeof gr != "string" || gr.length !== 8))
        throw new v.MathFunctionError(`Function dateHumanize. Unknown date format: ${gr}`);
    } else
      return y.ARG.SCALAR.STRING;
    return `${gr.substring(0, 2)}/${gr.substring(2, 4)}/${gr.substring(4, 8)}`;
  }, D = (gr) => {
    if (gr) {
      if (gr && (typeof gr != "string" || gr.length !== 8))
        throw new v.MathFunctionError(`Function dateReverse. Unknown date format: ${gr}`);
    } else
      return y.ARG.SCALAR.STRING;
    return `${gr.substring(6, 8)}${gr.substring(4, 6)}${gr.substring(0, 4)}`;
  }, N = (gr, Cr) => {
    if (!gr || !Cr)
      return 0;
    const Pr = (0, m.default)(gr, "DDMMYYYY"), Xr = (0, m.default)(Cr, "DDMMYYYY").diff(Pr, "days");
    if (Xr < 0)
      throw new v.MathFunctionError(`Function dateCalculateDays. First date ${gr} is greater than second date ${Cr}`);
    return Xr + 1;
  }, T = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return Tr ? Pr / Tr : Pr;
  }, R = (gr, Cr, Pr) => Cr ? Array.isArray(Cr) ? Pr < 1 || Pr > Cr.length || !Cr[Pr - 1] ? gr : gr + Cr[Pr - 1] : Pr === 1 ? gr + Cr : gr : gr, F = (gr) => gr === void 0 ? !0 : typeof gr != "string" || gr === "", z = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return Pr === Tr;
  }, O = (gr, Cr) => {
    const Pr = (0, y.sanitizeString)(gr), Tr = (0, y.sanitizeString)(Cr);
    return Pr === Tr;
  }, G = (gr) => {
    const Cr = (0, y.sanitizeNumber)(gr);
    return x.floor(Cr);
  }, I = (gr, Cr) => {
    const Pr = (0, y.uppercaseString)((0, y.sanitizeString)(gr)), Tr = (0, y.uppercaseString)((0, y.sanitizeString)(Cr));
    if (Array.isArray(Pr) && Array.isArray(Tr)) {
      if (Pr.length !== Tr.length)
        throw new v.MathFunctionError("Function containText. Arrays must have the same length");
      return Pr.map((Xr, rn) => Xr.includes(Tr[rn]));
    }
    return Array.isArray(Pr) ? Pr.map((Xr) => Xr.includes(Tr)) : Array.isArray(Tr) ? Tr.map((Xr) => Pr.includes(Xr)) : Pr.includes(Tr);
  }, k = (gr, Cr) => !I(gr, Cr), B = (gr, Cr) => gr ? Cr : void 0, L = (gr, Cr, Pr) => {
    if (!Array.isArray(Cr))
      throw new v.MathFunctionError(`Function include error, value ${JSON.stringify(Cr)} is not an array`);
    if (!Array.isArray(gr)) {
      let rn = Cr.length;
      for (; rn--; )
        if (Pr(gr, Cr[rn]))
          return !0;
      return !1;
    }
    const Tr = new Set(gr), Xr = /* @__PURE__ */ new Set();
    return Array.from(Tr).map((rn) => {
      let un = Cr.length;
      for (; un--; )
        if (Pr(rn, Cr[un]))
          return Xr.add(rn), !0;
      return !1;
    }), gr.map((rn) => Xr.has(rn));
  }, V = (gr, Cr) => L(gr, Cr, I), U = (gr, Cr) => {
    if (!Array.isArray(Cr))
      throw new v.MathFunctionError(`Function include error, value ${JSON.stringify(Cr)} is not an array`);
    const Pr = new Set(Cr.map((Tr) => JSON.stringify((0, y.uppercaseString)((0, y.sanitizeString)(Tr)))));
    if (!Array.isArray(gr)) {
      const Tr = (0, y.uppercaseString)((0, y.sanitizeString)(gr));
      return Pr.has(JSON.stringify(Tr));
    }
    return gr.map((Tr) => Pr.has(JSON.stringify((0, y.uppercaseString)((0, y.sanitizeString)(Tr)))));
  }, J = (gr, Cr) => {
    const Pr = V(gr, Cr);
    return Array.isArray(Pr) ? Pr.map((Tr) => !Tr) : !Pr;
  }, q = (gr, Cr) => {
    const Pr = U(gr, Cr);
    return Array.isArray(Pr) ? Pr.map((Tr) => !Tr) : !Pr;
  }, Z = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return x.larger(Pr, Tr);
  }, ae = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return x.largerEq(Pr, Tr);
  }, ee = (gr, Cr) => {
    const Pr = (0, y.sanitizeString)(gr), Tr = (0, y.getCountValue)(Cr, Pr), Xr = parseInt(Pr.substring(0, Tr), 10);
    return Number.isNaN(Xr) ? 0 : Xr;
  }, se = (gr, Cr) => {
    const Pr = (0, y.sanitizeString)(gr), Tr = (0, y.getCountValue)(Cr, Pr);
    return Pr.substring(0, Tr);
  }, nr = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return x.smaller(Pr, Tr);
  }, ce = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return x.smallerEq(Pr, Tr);
  }, oe = (gr, ...Cr) => gr === "and" ? Cr.reduce((Pr, Tr) => Array.isArray(Tr) && !Array.isArray(Pr) ? x.and(Tr, Pr) : x.and(Pr, Tr)) : Cr.reduce((Pr, Tr) => Array.isArray(Tr) && !Array.isArray(Pr) ? x.or(Tr, Pr) : x.or(Pr, Tr)), ur = (...gr) => {
    const Cr = (0, y.sanitizeNumber)(gr, 2);
    return Number(Math.max(...Cr));
  }, ir = (...gr) => {
    const Cr = (0, y.sanitizeNumber)(gr, 2);
    return Number(Math.min(...Cr));
  }, _r = (...gr) => {
    const Cr = (0, y.sanitizeNumber)(gr, 2);
    return x.multiply(...Cr);
  }, yr = (gr) => {
    if (!Array.isArray(gr))
      return gr;
    const Cr = {}, Pr = {};
    gr.forEach((Xr) => {
      if (!Cr[Xr]) {
        Cr[Xr] = 1, Pr[Xr] = Xr;
        return;
      }
      Cr[Xr] += 1;
    });
    const Tr = Object.keys(Cr).sort((Xr, rn) => Cr[rn] - Cr[Xr])[0];
    return Pr[Tr];
  }, ne = (gr) => !F(gr), pe = (gr, Cr, Pr, Tr = "") => {
    const rn = `${gr.pop()}${Cr}${Tr}`;
    return rn.length > Pr ? Tr.trim() : pe(gr, Cr, Pr, rn);
  }, hr = " ", $r = 15, Sr = (gr) => {
    if (gr && typeof gr != "string")
      throw new v.MathFunctionError(`Function parseName. Text is not a string '${gr}'`);
    if (!gr)
      return "";
    const Cr = gr.trim().split(hr);
    return Cr.length <= 3 ? Cr[Cr.length - 1].substring(0, $r).trim() : (Cr.splice(0, 2), Cr[Cr.length - 1].length > $r ? Cr[Cr.length - 1].substring(0, $r) : pe(Cr, hr, $r));
  }, ze = (gr, Cr) => {
    const Pr = parseFloat(gr), Tr = parseFloat(Cr);
    if (Number.isNaN(Pr))
      throw new v.MathFunctionError(`Function percentage. Value is not a number '${gr}'`);
    if (Number.isNaN(Tr))
      throw new v.MathFunctionError(`Function percentage. Divisor is not a number '${Cr}'`);
    return (0, g.roundNumber)(Math.floor(1e4 * (Pr / Tr)) / 100);
  }, cr = (gr) => {
    if (!Array.isArray(gr))
      throw new v.MathFunctionError(`Function removeEmptiesFunction. ${gr} should be matrix`);
    return gr.filter((Cr) => ne(Cr));
  }, fr = (gr, Cr) => {
    if (!Cr || typeof Cr != "string")
      throw new v.MathFunctionError(`Function removeTextFunction. Text is not a string '${Cr}'`);
    if (gr && typeof gr != "string")
      throw new v.MathFunctionError(`Function removeTextFunction. Value is not a string '${gr}'`);
    return gr ? gr.replace(Cr, "").trim() : "";
  }, mr = (gr, Cr) => {
    if (!Array.isArray(gr))
      throw new v.MathFunctionError(`Function removeTextsFunction. Values '${gr}' should be matrix`);
    if (gr.find((Pr) => typeof Pr != "string"))
      throw new v.MathFunctionError(`Function removeTextsFunction. Values '${gr}' should be matrix of strings`);
    return gr.map((Pr) => fr(Pr, Cr));
  }, wr = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.getCountValue)(Cr, Pr), Xr = parseInt(`${Pr}`.slice(-Tr), 10);
    return Number.isNaN(Xr) ? y.ARG.SCALAR.NUMBER : Xr;
  }, Nr = (gr, Cr) => {
    const Pr = (0, y.sanitizeString)(gr), Tr = (0, y.getCountValue)(Cr, Pr);
    return Pr.slice(-Tr);
  }, xr = (gr) => {
    const Cr = (0, y.sanitizeNumber)(gr);
    return (0, g.roundNumber)(Cr);
  }, Er = (gr) => {
    const Cr = (0, y.sanitizeNumber)(gr);
    return (0, g.roundNumber)(Cr, 0, !0);
  }, Ir = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return Tr ? Pr - Tr : Pr;
  }, Rr = (gr) => {
    const Cr = (0, y.sanitizeNumber)(gr);
    return Array.isArray(gr) ? (0, g.roundNumber)(x.sum(Cr)) : gr;
  }, Yr = (gr, Cr) => {
    const Pr = (0, y.sanitizeNumber)(gr), Tr = (0, y.sanitizeNumber)(Cr);
    return Pr !== Tr;
  }, Qr = (gr, Cr) => {
    const Pr = (0, y.sanitizeString)(gr), Tr = (0, y.sanitizeString)(Cr);
    return !x.equalText(Pr, Tr);
  }, nn = (gr, Cr) => {
    const Pr = (0, y.sanitizeString)(gr), Tr = (0, y.sanitizeString)(Cr);
    return Pr !== Tr;
  }, on = (gr, Cr, Pr) => {
    if (Array.isArray(Cr) && Cr.length !== 1)
      throw new v.MathFunctionError(`Function match error, value ${JSON.stringify(Cr)} is of invalid length ${Cr.length}`);
    const Tr = Array.isArray(Cr) ? Cr[0] : Cr;
    if (!Array.isArray(gr))
      return Pr(gr, Tr) ? [1] : [0];
    const Xr = gr.reduce((rn, un, ln) => (Pr(un, Tr) && rn.push(ln + 1), rn), []);
    return Xr.length === 0 ? [0] : Xr;
  }, en = (gr, Cr) => on(gr, Cr, z), zr = (gr, Cr) => on(gr, Cr, O), Jr = (gr) => {
    const Cr = typeof gr;
    if (Cr !== "string" && Cr !== "undefined" && gr !== null)
      throw new v.MathFunctionError(`Function sanitizeFunction. Invalid value type: ${Cr}`);
    return (0, y.sanitizeString)(gr).trim().replace(/\s\s+/g, " ");
  }, H = (gr, Cr) => {
    const Tr = dr(gr, Cr)[0];
    return (0, y.sanitizeString)(Tr).trim().replace(/\s\s+/g, " ");
  }, dr = (gr, Cr) => {
    if (!Array.isArray(Cr))
      throw new v.MathFunctionError(`Function indexFunction. Invalid indexes: ${Cr} should be matrix`);
    if (!Array.isArray(gr)) {
      if (Cr.length !== 1) {
        const Pr = JSON.stringify(Cr);
        throw new v.MathFunctionError(`Function indexFunction. Invalid indexes: ${Pr} for given value ${gr}`);
      }
      return Cr[0] === 1 ? [gr] : [];
    }
    return Cr.map((Pr) => {
      if (Pr > gr.length) {
        const Tr = JSON.stringify(gr);
        throw new v.MathFunctionError(`Function indexFunction. Invalid index: ${Pr} for element: ${Tr} of length ${gr.length}`);
      }
      return Pr === 0 ? void 0 : gr[Pr - 1];
    });
  }, Ar = (gr, Cr) => {
    const Pr = dr(gr, Cr);
    return ur(...Pr);
  }, jr = (gr, Cr) => {
    const Pr = dr(gr, Cr);
    return Pr.length === 1 ? (0, y.sanitizeNumber)(Pr[0]) : ir(...Pr);
  }, Vr = (gr, Cr) => {
    const Pr = dr(gr, Cr);
    return _(...Pr);
  }, Zr = (gr) => {
    if (!Array.isArray(gr))
      throw new v.MathFunctionError(`Function positionFunction. ${gr} should be matrix`);
    return gr.map((Cr, Pr) => Pr + 1);
  }, pn = (gr) => {
    if (!Array.isArray(gr))
      throw new v.MathFunctionError(`Function uniqueFunction. ${gr} should be matrix`);
    return [...new Set(gr)];
  };
})(math);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    ARITHMETIC_FUNCTIONS: () => g,
    ARITHMETIC_FUNCTION_TRANSLATE: () => m,
    default: () => $
  });
  var p = u(math);
  const m = {
    SUMA: "add",
    DIVISION: "divide",
    MULTIPLICACION: "multiply",
    RESTA: "subtract"
  }, g = Object.values(m), v = p.addFunction, y = p.divideFunction, x = p.multiplyFunction, _ = p.subtractFunction;
  var $ = {
    add: v,
    divide: y,
    multiply: x,
    subtract: _
  };
})(arithmetic);
var logical = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (_) => n(_, "__esModule", { value: !0 }), d = (_, $) => {
    l(_);
    for (var b in $)
      n(_, b, { get: $[b], enumerable: !0 });
  }, h = (_, $, b) => {
    if ($ && typeof $ == "object" || typeof $ == "function")
      for (let M of s($))
        !c.call(_, M) && M !== "default" && n(_, M, { get: () => $[M], enumerable: !(b = a($, M)) || b.enumerable });
    return _;
  }, u = (_) => h(l(n(_ != null ? r(o(_)) : {}, "default", _ && _.__esModule && "default" in _ ? { get: () => _.default, enumerable: !0 } : { value: _, enumerable: !0 })), _);
  d(t, {
    LOGICAL_FUNCTIONS: () => g,
    LOGICAL_FUNCTION_TRANSLATE: () => m,
    default: () => x
  });
  var p = u(math);
  const m = {
    AND: "and",
    OR: "or"
  }, g = Object.values(m);
  var x = {
    and: (..._) => (0, p.logicFunction)("and", ..._),
    or: (..._) => (0, p.logicFunction)("or", ..._)
  };
})(logical);
var matrices = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (oe) => n(oe, "__esModule", { value: !0 }), d = (oe, ur) => {
    l(oe);
    for (var ir in ur)
      n(oe, ir, { get: ur[ir], enumerable: !0 });
  }, h = (oe, ur, ir) => {
    if (ur && typeof ur == "object" || typeof ur == "function")
      for (let _r of s(ur))
        !c.call(oe, _r) && _r !== "default" && n(oe, _r, { get: () => ur[_r], enumerable: !(ir = a(ur, _r)) || ir.enumerable });
    return oe;
  }, u = (oe) => h(l(n(oe != null ? r(o(oe)) : {}, "default", oe && oe.__esModule && "default" in oe ? { get: () => oe.default, enumerable: !0 } : { value: oe, enumerable: !0 })), oe);
  d(t, {
    MATRICES_FUNCTIONS: () => y,
    MATRICES_FUNCTION_TRANSLATE: () => v,
    default: () => ce
  });
  var p = u(mathFunctionError), m = u(math), g = u(utils$5);
  const v = {
    "CALCULA DIAS MATRICES": "dateCalculateDaysMatrices",
    "CONCATENAR MATRICES": "concatenateMatrices",
    "CONTIENE TEXTO MATRICES": "containTextMatrices",
    "DISTINTO MATRICES": "unequalMatrices",
    "DISTINTO TEXTO MATRICES": "unequalTextMatrices",
    "DIVISION MATRICES": "divideMatrices",
    "IGUAL MATRICES": "equalMatrices",
    "INCLUYE MISMO TEXTO MATRICES": "includeEqualTextMatrices",
    "INCLUYE TEXTO MATRICES": "includeTextMatrices",
    "INDEX MATRICES": "indexOfMatrices",
    "INDEX PRIMER TEXTO MATRICES": "indexFirstTextValueMatrices",
    "INDEX MAXIMO MATRICES": "indexMaximumMatrices",
    "INDEX MINIMO MATRICES": "indexMinimumMatrices",
    "INDEX SUMA MATRICES": "indexSumMatrices",
    "MATCH NUMERO MATRICES": "matchNumberMatrices",
    "MATCH TEXTO MATRICES": "matchTextMatrices",
    "MAXIMO MATRICES": "maximumMatrices",
    "MAYOR MATRICES": "largerMatrices",
    "MAYOR O IGUAL MATRICES": "largerEqMatrices",
    "MENOR MATRICES": "smallerMatrices",
    "MENOR O IGUAL MATRICES": "smallerEqMatrices",
    "MINIMO MATRICES": "minimumMatrices",
    "MISMO TEXTO MATRICES": "equalTextMatrices",
    "MULTIPLICACION MATRICES": "multiplyMatrices",
    "NO CONTIENE TEXTO MATRICES": "notContainTextMatrices",
    "NO INCLUYE MISMO TEXTO MATRICES": "notIncludeEqualTextMatrices",
    "NO INCLUYE TEXTO MATRICES": "notIncludeTextMatrices",
    "RESTA MATRICES": "subtractMatrices",
    "SUMA MATRICES": "addMatrices"
  }, y = Object.values(v), x = (...oe) => (0, g.operateMatrices)(m.addFunction, ...oe), _ = (...oe) => (0, g.operateMatrices)(m.concatenateFunction, ...oe), $ = (...oe) => (0, g.operateMatrices)(m.containTextFunction, ...oe), b = (...oe) => (0, g.operateMatrices)(m.dateCalculateDaysFunction, ...oe), M = (...oe) => (0, g.operateMatrices)(m.divideFunction, ...oe), C = (...oe) => (0, g.operateMatrices)(m.equalFunction, ...oe), S = (...oe) => (0, g.operateMatrices)(m.equalTextFunction, ...oe), A = m.includeEqualTextFunction, D = m.includeTextFunction, N = (oe, ur) => (0, g.operateMatricesOneToMany)(N, m.indexFirstTextValueFunction, oe, ur), T = (oe, ur) => {
    if (!Array.isArray(ur)) {
      const ir = `Function indexOfMatrices. Operand 2 is not a matrix ${ur}`;
      throw new p.MathFunctionError(ir);
    }
    return ur.forEach((ir, _r) => {
      if (!Array.isArray(ir)) {
        const yr = `Function indexOfMatrices. Operand 2 at position ${_r} is not a matrix ${ir}`;
        throw new p.MathFunctionError(yr);
      }
    }), (0, g.operateMatricesOneToMany)(T, m.indexFunction, oe, ur);
  }, R = (oe, ur) => (0, g.operateMatricesOneToMany)(R, m.indexMaximumFunction, oe, ur), F = (oe, ur) => (0, g.operateMatricesOneToMany)(F, m.indexMinimumFunction, oe, ur), z = (oe, ur) => (0, g.operateMatricesOneToMany)(z, m.indexSumFunction, oe, ur), O = (...oe) => (0, g.operateMatrices)(m.largerFunction, ...oe), G = (...oe) => (0, g.operateMatrices)(m.largerEqFunction, ...oe), I = (oe, ur) => (0, g.operateMatricesOneToMany)(I, m.matchNumberFunction, oe, ur), k = (oe, ur) => (0, g.operateMatricesOneToMany)(k, m.matchTextFunction, oe, ur), B = (...oe) => (0, g.operateMatrices)(m.smallerFunction, ...oe), L = (...oe) => (0, g.operateMatrices)(m.smallerEqFunction, ...oe), V = (...oe) => (0, g.operateMatrices)(m.maximumFunction, ...oe), U = (...oe) => (0, g.operateMatrices)(m.minimumFunction, ...oe), J = (...oe) => (0, g.operateMatrices)(m.multiplyFunction, ...oe), q = (...oe) => (0, g.operateMatrices)(m.notContainTextFunction, ...oe), Z = m.notIncludeEqualTextFunction, ae = m.notIncludeTextFunction;
  var ce = {
    addMatrices: x,
    concatenateMatrices: _,
    containTextMatrices: $,
    dateCalculateDaysMatrices: b,
    divideMatrices: M,
    equalMatrices: C,
    equalTextMatrices: S,
    includeEqualTextMatrices: A,
    includeTextMatrices: D,
    indexFirstTextValueMatrices: N,
    indexOfMatrices: T,
    indexMaximumMatrices: R,
    indexMinimumMatrices: F,
    indexSumMatrices: z,
    largerEqMatrices: G,
    largerMatrices: O,
    matchNumberMatrices: I,
    matchTextMatrices: k,
    maximumMatrices: V,
    minimumMatrices: U,
    multiplyMatrices: J,
    notContainTextMatrices: q,
    notIncludeEqualTextMatrices: Z,
    notIncludeTextMatrices: ae,
    smallerEqMatrices: L,
    smallerMatrices: B,
    subtractMatrices: (...oe) => (0, g.operateMatrices)(m.subtractFunction, ...oe),
    unequalMatrices: (...oe) => (0, g.operateMatrices)(m.unequalFunction, ...oe),
    unequalTextMatrices: (...oe) => (0, g.operateMatrices)(m.unequalTextFunction, ...oe)
  };
})(matrices);
var matrix = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (xr) => n(xr, "__esModule", { value: !0 }), d = (xr, Er) => {
    l(xr);
    for (var Ir in Er)
      n(xr, Ir, { get: Er[Ir], enumerable: !0 });
  }, h = (xr, Er, Ir) => {
    if (Er && typeof Er == "object" || typeof Er == "function")
      for (let Rr of s(Er))
        !c.call(xr, Rr) && Rr !== "default" && n(xr, Rr, { get: () => Er[Rr], enumerable: !(Ir = a(Er, Rr)) || Ir.enumerable });
    return xr;
  }, u = (xr) => h(l(n(xr != null ? r(o(xr)) : {}, "default", xr && xr.__esModule && "default" in xr ? { get: () => xr.default, enumerable: !0 } : { value: xr, enumerable: !0 })), xr);
  d(t, {
    MATRIX_FUNCTIONS: () => v,
    MATRIX_FUNCTION_TRANSLATE: () => g,
    default: () => Nr
  });
  var p = u(math), m = u(utils$5);
  const g = {
    "AJUSTA MATRIZ": "adjustMatrix",
    "AÑADE NUMERO MATRIZ": "appendMatrixNumber",
    "AÑADE TEXTO MATRIZ": "appendMatrixText",
    "CALCULA DIAS MATRIZ": "dateCalculateDaysMatrix",
    "CAMBIAR FECHA MATRIZ": "dateReverseMatrix",
    "CONCATENAR MATRIZ": "concatenateMatrix",
    "CORTAR APELLIDOS MATRIZ": "parseNameMatrix",
    "CONTIENE TEXTO MATRIZ": "containTextMatrix",
    "CREA MATRIZ NUMEROS": "buildMatrixNumber",
    "DERECHA MATRIZ": "rightNumberMatrix",
    "DERECHA NUMERO MATRIZ": "rightNumberMatrix",
    "DERECHA TEXTO MATRIZ": "rightTextMatrix",
    "DISTINTO MATRIZ": "unequalMatrix",
    "DISTINTO TEXTO MATRIZ": "unequalTextMatrix",
    "DIVISION MATRIZ": "divideMatrix",
    "ELIMINAR DUPLICADOS MATRIZ": "uniqueMatrix",
    "ELIMINAR VACÍOS MATRIZ": "removeEmptiesMatrix",
    "FECHA XML MATRIZ": "dateHumanizeMatrix",
    "IGUAL MATRIZ": "equalMatrix",
    "INDEX MATRIZ": "indexOfMatrix",
    "INDEX PRIMER TEXTO MATRIZ": "indexFirstTextValueMatrix",
    "INDEX MAXIMO MATRIZ": "indexMaximumMatrix",
    "INDEX MINIMO MATRIZ": "indexMinimumMatrix",
    "INDEX SUMA MATRIZ": "indexSumMatrix",
    "IZQUIERDA MATRIZ": "leftNumberMatrix",
    "IZQUIERDA NUMERO MATRIZ": "leftNumberMatrix",
    "IZQUIERDA TEXTO MATRIZ": "leftTextMatrix",
    "MATCH NUMERO MATRIZ": "matchNumberMatrix",
    "MATCH TEXTO MATRIZ": "matchTextMatrix",
    "MAXIMO MATRIZ": "maximumMatrix",
    "MAYOR MATRIZ": "largerMatrix",
    "MAYOR O IGUAL MATRIZ": "largerEqMatrix",
    "MENOR MATRIZ": "smallerMatrix",
    "MENOR O IGUAL MATRIZ": "smallerEqMatrix",
    "MINIMO MATRIZ": "minimumMatrix",
    "MISMO TEXTO MATRIZ": "equalTextMatrix",
    "MULTIPLICACION MATRIZ": "multiplyMatrix",
    "NO CONTIENE TEXTO MATRIZ": "notContainTextMatrix",
    "NO VACÍO MATRIZ": "notEmptyMatrix",
    "REDONDEA MATRIZ": "roundMatrix",
    "REDONDEA ENTERO MATRIZ": "roundIntegerMatrix",
    "RESTA MATRIZ": "subtractMatrix",
    "POSICION MATRIZ": "positionMatrix",
    "SANITIZAR MATRIZ": "sanitizeMatrix",
    "SUMA MATRIZ": "addMatrix",
    "TRUNCAR ENTERO MATRIZ": "floorMatrix",
    "VACÍO MATRIZ": "emptyMatrix",
    "ELIMINAR TEXTO MATRIZ": "removeTextsMatrix"
  }, v = Object.values(g), y = (...xr) => (0, m.operateMatrix)(p.addFunction, ...xr), x = (xr, Er) => {
    const Ir = Array.isArray(xr) ? xr : [xr], Rr = Array.isArray(Er) ? Er : [Er];
    if (!Array.isArray(Ir)) {
      const Qr = new Array(Rr.length);
      return Qr.fill((0, m.fillingValue)(Ir)), Qr[0] = Ir, Qr;
    }
    if (!Array.isArray(Rr))
      return [Ir[0]];
    const Yr = Rr.length - Ir.length;
    if (Yr > 0) {
      const Qr = (0, m.fillingValue)(Ir[0]);
      return Ir.concat(new Array(Yr).fill(Qr));
    }
    return Ir.slice(0, Rr.length);
  }, _ = (...xr) => (0, p.appendMatrixFunction)(m.ARG.SCALAR.NUMBER, ...xr), $ = (...xr) => (0, p.appendMatrixFunction)(m.ARG.SCALAR.STRING, ...xr), b = (xr) => Array.isArray(xr) ? xr : [xr], M = (...xr) => (0, m.operateMatrix)(p.concatenateFunction, ...xr), C = (...xr) => (0, m.operateMatrix)(p.containTextFunction, ...xr), S = (...xr) => (0, m.operateMatrix)(p.dateCalculateDaysFunction, ...xr), A = (...xr) => (0, m.operateMatrix)(p.dateHumanizeFunction, ...xr), D = (...xr) => (0, m.operateMatrix)(p.dateReverseFunction, ...xr), N = (...xr) => (0, m.operateMatrix)(p.divideFunction, ...xr), T = (...xr) => (0, m.operateMatrix)(p.equalFunction, ...xr), R = (...xr) => (0, m.operateMatrix)(p.equalTextFunction, ...xr), F = (...xr) => (0, m.operateMatrix)(p.emptyFunction, ...xr), z = (...xr) => (0, m.operateMatrix)(p.floorFunction, ...xr), O = p.indexFirstTextValueFunction, G = p.indexFunction, I = p.indexMaximumFunction, k = p.indexMinimumFunction, B = p.indexSumFunction, L = (...xr) => (0, m.operateMatrix)(p.largerFunction, ...xr), V = (...xr) => (0, m.operateMatrix)(p.largerEqFunction, ...xr), U = (...xr) => (0, m.operateMatrix)(p.leftNumberFunction, ...xr), J = (...xr) => (0, m.operateMatrix)(p.leftTextFunction, ...xr), q = p.matchNumberFunction, Z = p.matchTextFunction, ae = (...xr) => (0, m.operateMatrix)(p.maximumFunction, ...xr), ee = (...xr) => (0, m.operateMatrix)(p.minimumFunction, ...xr), se = (...xr) => (0, m.operateMatrix)(p.multiplyFunction, ...xr), nr = (...xr) => (0, m.operateMatrix)(p.notContainTextFunction, ...xr), ce = (...xr) => (0, m.operateMatrix)(p.notEmptyFunction, ...xr), oe = (...xr) => (0, m.operateMatrix)(p.parseNameFunction, ...xr), ur = p.positionFunction, ir = p.removeEmptiesFunction, _r = (...xr) => (0, m.operateMatrix)(p.rightNumberFunction, ...xr), yr = (...xr) => (0, m.operateMatrix)(p.rightTextFunction, ...xr), ne = (...xr) => (0, m.operateMatrix)(p.roundFunction, ...xr), pe = (...xr) => (0, m.operateMatrix)(p.roundIntegerFunction, ...xr), hr = (...xr) => (0, m.operateMatrix)(p.smallerFunction, ...xr), $r = (...xr) => (0, m.operateMatrix)(p.sanitizeFunction, ...xr), Sr = (...xr) => (0, m.operateMatrix)(p.smallerEqFunction, ...xr), ze = (...xr) => (0, m.operateMatrix)(p.subtractFunction, ...xr), cr = (...xr) => (0, m.operateMatrix)(p.unequalFunction, ...xr), fr = (...xr) => (0, m.operateMatrix)(p.unequalTextFunction, ...xr), mr = p.uniqueFunction, wr = p.removeTextsFunction;
  var Nr = {
    addMatrix: y,
    adjustMatrix: x,
    appendMatrixNumber: _,
    appendMatrixText: $,
    buildMatrixNumber: b,
    concatenateMatrix: M,
    containTextMatrix: C,
    dateCalculateDaysMatrix: S,
    dateHumanizeMatrix: A,
    dateReverseMatrix: D,
    divideMatrix: N,
    emptyMatrix: F,
    equalMatrix: T,
    equalTextMatrix: R,
    floorMatrix: z,
    indexFirstTextValueMatrix: O,
    indexOfMatrix: G,
    indexMaximumMatrix: I,
    indexMinimumMatrix: k,
    indexSumMatrix: B,
    largerEqMatrix: V,
    largerMatrix: L,
    leftNumberMatrix: U,
    leftTextMatrix: J,
    matchNumberMatrix: q,
    matchTextMatrix: Z,
    maximumMatrix: ae,
    minimumMatrix: ee,
    multiplyMatrix: se,
    notContainTextMatrix: nr,
    notEmptyMatrix: ce,
    parseNameMatrix: oe,
    removeEmptiesMatrix: ir,
    rightNumberMatrix: _r,
    rightTextMatrix: yr,
    roundMatrix: ne,
    roundIntegerMatrix: pe,
    positionMatrix: ur,
    sanitizeMatrix: $r,
    smallerEqMatrix: Sr,
    smallerMatrix: hr,
    subtractMatrix: ze,
    unequalMatrix: cr,
    unequalTextMatrix: fr,
    uniqueMatrix: mr,
    removeTextsMatrix: wr
  };
})(matrix);
var relational = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (Z) => n(Z, "__esModule", { value: !0 }), d = (Z, ae) => {
    l(Z);
    for (var ee in ae)
      n(Z, ee, { get: ae[ee], enumerable: !0 });
  }, h = (Z, ae, ee) => {
    if (ae && typeof ae == "object" || typeof ae == "function")
      for (let se of s(ae))
        !c.call(Z, se) && se !== "default" && n(Z, se, { get: () => ae[se], enumerable: !(ee = a(ae, se)) || ee.enumerable });
    return Z;
  }, u = (Z) => h(l(n(Z != null ? r(o(Z)) : {}, "default", Z && Z.__esModule && "default" in Z ? { get: () => Z.default, enumerable: !0 } : { value: Z, enumerable: !0 })), Z);
  d(t, {
    RELATIONAL_FUNCTIONS: () => x,
    RELATIONAL_FUNCTION_TRANSLATE: () => y,
    default: () => q
  });
  var p = u(constants$4), m = u(mathFunctionError), g = u(math), v = u(utils$5);
  const y = {
    "CONTIENE TEXTO": "containText",
    DISTINTO: "unequal",
    "DISTINTO TEXTO": "unequalText",
    IGUAL: "equal",
    "MISMO TEXTO": "equalText",
    MAYOR: "larger",
    "MAYOR O IGUAL": "largerEq",
    MENOR: "smaller",
    "MENOR O IGUAL": "smallerEq",
    "NO AUMENTA TAMAÑO MATRIZ": "hasNotMatrixLargerSizeChanged",
    "NO DISMINUYE TAMAÑO MATRIZ": "hasNotMatrixSmallerSizeChanged",
    "NO MODIFICA VALOR NUMERO": "hasNotValueChangedNumber",
    "NO HA MODIFICADO NUMERO": "hasNotChangedNumber",
    "NO MODIFICA VALOR TEXTO": "hasNotValueChangedText",
    "NO HA MODIFICADO TEXTO": "hasNotChangedText",
    "NO CONTIENE TEXTO": "notContainText",
    "NO MODIFICA NUMERO MATRIZ": "hasNotChangedNumberMatrix",
    "NO MODIFICA TEXTO MATRIZ": "hasNotChangedTextMatrix"
  }, x = Object.values(y), _ = g.containTextFunction, $ = (Z, ae) => {
    if ((0, v.isArrayLengthGreaterOne)(Z) || (0, v.isArrayLengthGreaterOne)(ae))
      return (0, v.operate)(g.equalFunction, Z, ae);
    const ee = (0, g.equalFunction)((0, v.simplify)(Z), (0, v.simplify)(ae));
    return [Z, ae].some((nr) => Array.isArray(nr)) ? [ee] : ee;
  }, b = (Z, ae) => {
    if ((0, v.isArrayLengthGreaterOne)(Z) || (0, v.isArrayLengthGreaterOne)(ae))
      return (0, v.operate)(g.equalTextFunction, Z, ae);
    const ee = (0, g.equalTextFunction)((0, v.simplify)(Z), (0, v.simplify)(ae));
    return [Z, ae].some((nr) => Array.isArray(nr)) ? [ee] : ee;
  }, M = (Z, ae, ee, se, nr) => {
    const ce = ee[p.SCOPE_ORIGINAL] || {}, [oe] = (0, v.evalArgs)(Z, ee, nr, [nr]), [ur] = (0, v.evalArgs)(Z, ce, nr, [nr]), ir = (0, v.simplify)(oe), _r = (0, v.simplify)(ur);
    if ((ir == null ? void 0 : ir.length) !== (_r == null ? void 0 : _r.length))
      return !1;
    const yr = (0, v.operate)(se, ir, _r);
    return Array.isArray(yr) ? yr.every((ne) => ne === !0) : yr;
  }, C = (Z, ae, ee, se, nr) => {
    const ce = ee[p.SCOPE_ORIGINAL] || {}, [oe] = (0, v.evalArgs)(Z, ee, nr, [nr]), [ur] = (0, v.evalArgs)(Z, ce, nr, [nr]);
    let ir = (0, v.simplify)(oe), _r = (0, v.simplify)(ur);
    const yr = Math.min(ir == null ? void 0 : ir.length, _r == null ? void 0 : _r.length), pe = Math.max(ir == null ? void 0 : ir.length, _r == null ? void 0 : _r.length) - yr;
    ir = ir == null ? void 0 : ir.slice(0, yr), _r = _r == null ? void 0 : _r.slice(0, yr);
    const hr = (0, v.operate)(se, ir, _r);
    return hr.push(...Array(pe).fill(!1)), hr;
  }, S = (Z, ae, ee, se, nr) => {
    const ce = ee[p.SCOPE_ORIGINAL] || {}, [oe, ur] = (0, v.evalArgs)(Z, ee, nr, [nr]);
    if (!Array.isArray(ur) || ur.length !== 2)
      throw new m.MathFunctionError(`Functions hasNotValueChanged requires an array of changes of length 2 actual: ${ur}`);
    const [ir] = (0, v.evalArgs)(Z, ce, nr, [nr]), _r = (0, v.simplify)(oe), yr = (0, v.simplify)(ir), ne = (0, v.operate)(se, yr, ur[0]), pe = (0, v.operate)(se, _r, ur[1]);
    return Array.isArray(pe) ? Array.isArray(ne) ? pe.every((hr, $r) => !ne[$r] || hr === !1) : ne === !1 || pe.every((hr) => hr === !1) : Array.isArray(ne) ? pe === !1 || ne.every((hr) => hr === !1) : ne === !1 || pe === !1;
  }, A = (Z, ae, ee) => M(Z, ae, ee, $, v.ARG.SCALAR.NUMBER);
  A.rawArgs = !0;
  const D = (Z, ae, ee) => M(Z, ae, ee, b, v.ARG.SCALAR.STRING);
  D.rawArgs = !0;
  const N = (Z, ae, ee) => S(Z, ae, ee, $, v.ARG.SCALAR.NUMBER);
  N.rawArgs = !0;
  const T = (Z, ae, ee) => S(Z, ae, ee, b, v.ARG.SCALAR.STRING);
  T.rawArgs = !0;
  const R = (Z, ae, ee) => C(Z, ae, ee, $, v.ARG.MATRIX.NUMBER);
  R.rawArgs = !0;
  const F = (Z, ae, ee) => C(Z, ae, ee, b, v.ARG.MATRIX.STRING);
  F.rawArgs = !0;
  const z = (Z, ae, ee) => {
    const se = ee[p.SCOPE_ORIGINAL] || {}, [nr] = (0, v.evalArgs)(Z, ee), [ce] = (0, v.evalArgs)(Z, se), oe = Array.isArray(nr) ? nr : [nr], ur = Array.isArray(ce) ? ce : [ce];
    return ce === void 0 && oe.length === 1 && oe[0] !== void 0 ? oe[0] === v.ARG.SCALAR.STRING || oe[0] === v.ARG.SCALAR.NUMBER : V(oe.length, ur.length);
  };
  z.rawArgs = !0;
  const O = (Z, ae, ee) => {
    const se = ee[p.SCOPE_ORIGINAL] || {}, [nr] = (0, v.evalArgs)(Z, ee), [ce] = (0, v.evalArgs)(Z, se), oe = Array.isArray(nr) ? nr : [nr], ur = Array.isArray(ce) ? ce : [ce];
    return nr === void 0 && ur.length === 1 && ur[0] !== void 0 ? ur[0] === v.ARG.SCALAR.STRING || ur[0] === v.ARG.SCALAR.NUMBER : k(oe.length, ur.length);
  };
  O.rawArgs = !0;
  const G = (Z, ae, ee) => {
    const [se, ...nr] = Z.slice(), [ce] = (0, v.evalArgs)([se], ee, v.ARG.MATRIX.BOOLEAN);
    if (!(0, v.isCondition)(ce))
      return Array.isArray(ce) ? (0, v.operateMatrices)(g.ifThenFunction, ce) : (0, g.ifThenFunction)(ce);
    const oe = (0, v.evalArgs)(nr, ee, v.ARG.SCALAR.NUMBER, v.ARG.MATRIX.NUMBER);
    return Array.isArray(ce) ? (0, v.operateMatrices)(g.ifThenFunction, ce, ...oe) : (0, g.ifThenFunction)(ce, oe[0]);
  };
  G.rawArgs = !0;
  const I = g.largerFunction, k = g.largerEqFunction, B = g.notContainTextFunction, L = g.smallerFunction, V = g.smallerEqFunction;
  var q = {
    containText: _,
    equal: $,
    equalText: b,
    hasNotChangedNumber: A,
    hasNotValueChangedNumber: N,
    hasNotChangedText: D,
    hasNotValueChangedText: T,
    hasNotMatrixLargerSizeChanged: z,
    hasNotMatrixSmallerSizeChanged: O,
    hasNotChangedNumberMatrix: R,
    hasNotChangedTextMatrix: F,
    ifThen: G,
    larger: I,
    largerEq: k,
    notContainText: B,
    smaller: L,
    smallerEq: V,
    unequal: (Z, ae) => {
      if ((0, v.isArrayLengthGreaterOne)(Z) || (0, v.isArrayLengthGreaterOne)(ae))
        return (0, v.operate)(g.unequalFunction, Z, ae);
      const ee = (0, g.unequalFunction)((0, v.simplify)(Z), (0, v.simplify)(ae));
      return [Z, ae].some((nr) => Array.isArray(nr)) ? [ee] : ee;
    },
    unequalText: (Z, ae) => {
      if (Array.isArray(Z) || Array.isArray(ae))
        return (0, g.unequalTextLegacyFunction)(Z, ae);
      const ee = (0, g.unequalTextFunction)((0, v.simplify)(Z), (0, v.simplify)(ae));
      return [Z, ae].some((nr) => Array.isArray(nr)) ? [ee] : ee;
    }
  };
})(relational);
var scalar = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (ce) => n(ce, "__esModule", { value: !0 }), d = (ce, oe) => {
    l(ce);
    for (var ur in oe)
      n(ce, ur, { get: oe[ur], enumerable: !0 });
  }, h = (ce, oe, ur) => {
    if (oe && typeof oe == "object" || typeof oe == "function")
      for (let ir of s(oe))
        !c.call(ce, ir) && ir !== "default" && n(ce, ir, { get: () => oe[ir], enumerable: !(ur = a(oe, ir)) || ur.enumerable });
    return ce;
  }, u = (ce) => h(l(n(ce != null ? r(o(ce)) : {}, "default", ce && ce.__esModule && "default" in ce ? { get: () => ce.default, enumerable: !0 } : { value: ce, enumerable: !0 })), ce);
  d(t, {
    SCALAR_FUNCTIONS: () => y,
    SCALAR_FUNCTION_TRANSLATE: () => v,
    default: () => nr
  });
  var p = u(mathFunctionError), m = u(math), g = u(utils$5);
  const v = {
    "CALCULA DIAS": "dateCalculateDays",
    "CALCULA GRAVAMEN": "calculateGravamen",
    "CALCULA GRAVAMEN REDONDEO": "calculateGravamenRound",
    "CALCULA GRAVAMEN MX": "calculateGravamenRoundInteger",
    "CAMBIAR FECHA": "dateReverse",
    "CONSTRUIR TEXTO MATRIZ": "buildMatrixText",
    CONCATENAR: "concatenate",
    "CORTAR APELLIDOS": "parseName",
    "DERECHA NUMERO": "rightNumber",
    DERECHA: "rightNumber",
    "DERECHA TEXTO": "rightText",
    "ELIGE NUMERO MATRIZ": "elementMatrixNumber",
    "ELIGE TEXTO MATRIZ": "elementMatrixText",
    "FECHA XML": "dateHumanize",
    "IZQUIERDA NUMERO": "leftNumber",
    "IZQUIERDA TEXTO": "leftText",
    IZQUIERDA: "leftNumber",
    MAXIMO: "maximum",
    MINIMO: "minimum",
    "MAYOR OCURRENCIA MATRIZ": "mode",
    "NO VACÍO": "notEmpty",
    PORCENTAJE: "percentage",
    REDONDEA: "round",
    "REDONDEA ENTERO": "roundInteger",
    SANITIZAR: "sanitize",
    "SUMA ELEMENTOS MATRIZ": "summatoryMatrix",
    "TRUNCAR ENTERO": "floor",
    VACÍO: "empty"
  }, y = Object.values(v), x = (ce, oe, ur, ir, _r, yr) => {
    const [ne, pe, hr] = (0, g.evalArgs)(ce, ur, g.ARG.SCALAR.STRING, g.ARG.MATRIX.STRING), $r = parseFloat(ne || 0);
    if (Number.isNaN($r))
      throw new p.MathFunctionError(`Function calculateGravamen. X is not a number '${ne}'`);
    const Sr = pe.split(",").map((cr) => {
      const fr = parseFloat(cr);
      if (Number.isNaN(fr))
        throw new p.MathFunctionError(`Function calculateGravamen. Y element is not a number '${cr}'`);
      return fr;
    }), ze = hr.split(",").map((cr) => {
      const fr = parseFloat(cr) / 100;
      if (Number.isNaN(fr))
        throw new p.MathFunctionError(`Function calculateGravamen. Z element is not a number '${cr}'`);
      return fr;
    });
    if (Sr.length !== ze.length)
      throw new p.MathFunctionError(`Function calculateGravamen. Different array lengths: Y = ${Sr.length}, Z = ${ze.length}`);
    return (0, m.calculateGravamenFunction)(oe, $r, Sr, ze, ir, _r, yr);
  }, _ = (ce, oe, ur) => x(ce, oe, ur, m.roundFunction);
  _.rawArgs = !0;
  const $ = (ce, oe, ur) => x(ce, oe, ur, m.roundFunction, !1, !0);
  $.rawArgs = !0;
  const b = (ce, oe, ur) => x(ce, oe, ur, m.roundIntegerFunction, !0, !0);
  b.rawArgs = !0;
  const M = m.buildMatrixTextFunction, C = m.concatenateFunction, S = m.dateHumanizeFunction, A = m.dateReverseFunction, D = m.dateCalculateDaysFunction, N = (ce, oe) => {
    const ur = (0, g.sanitizeNumber)(ce);
    return (0, m.elementMatrixFunction)(g.ARG.SCALAR.NUMBER, ur, oe);
  }, T = (ce, oe) => {
    const ur = (0, g.sanitizeString)(ce);
    return (0, m.elementMatrixFunction)(g.ARG.SCALAR.STRING, ur, oe);
  }, R = m.emptyFunction, F = m.floorFunction, z = m.leftNumberFunction, O = m.leftTextFunction, G = m.logicFunction, I = m.maximumFunction, k = m.minimumFunction, B = m.modeFunction, L = m.notEmptyFunction, V = m.parseNameFunction, U = m.percentageFunction, J = m.rightNumberFunction, q = m.rightTextFunction, Z = m.roundFunction, ae = m.roundIntegerFunction, ee = m.sanitizeFunction, se = m.summatoryMatrixFunction;
  var nr = {
    buildMatrixText: M,
    calculateGravamen: _,
    calculateGravamenRound: $,
    calculateGravamenRoundInteger: b,
    concatenate: C,
    dateCalculateDays: D,
    dateHumanize: S,
    dateReverse: A,
    elementMatrixNumber: N,
    elementMatrixText: T,
    empty: R,
    floor: F,
    leftNumber: z,
    leftText: O,
    logic: G,
    maximum: I,
    minimum: k,
    mode: B,
    notEmpty: L,
    parseName: V,
    percentage: U,
    rightNumber: J,
    rightText: q,
    round: Z,
    roundInteger: ae,
    sanitize: ee,
    summatoryMatrix: se
  };
})(scalar);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getOwnPropertySymbols, c = Object.getPrototypeOf, l = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable, h = (I, k, B) => k in I ? n(I, k, { enumerable: !0, configurable: !0, writable: !0, value: B }) : I[k] = B, u = (I, k) => {
    for (var B in k || (k = {}))
      l.call(k, B) && h(I, B, k[B]);
    if (o)
      for (var B of o(k))
        d.call(k, B) && h(I, B, k[B]);
    return I;
  }, p = (I) => n(I, "__esModule", { value: !0 }), m = (I, k) => {
    p(I);
    for (var B in k)
      n(I, B, { get: k[B], enumerable: !0 });
  }, g = (I, k, B) => {
    if (k && typeof k == "object" || typeof k == "function")
      for (let L of s(k))
        !l.call(I, L) && L !== "default" && n(I, L, { get: () => k[L], enumerable: !(B = a(k, L)) || B.enumerable });
    return I;
  }, v = (I) => g(p(n(I != null ? r(c(I)) : {}, "default", I && I.__esModule && "default" in I ? { get: () => I.default, enumerable: !0 } : { value: I, enumerable: !0 })), I);
  m(t, {
    getParserValidKeys: () => G,
    isCustomFunction: () => O,
    taxdownMath: () => T,
    taxdownMathParser: () => F,
    translateFunction: () => z
  });
  var y = v(cjs$1), x = v(utils$6), _ = v(arithmetic), $ = v(logical), b = v(matrices), M = v(matrix), C = v(relational), S = v(scalar);
  const A = u(u(u(u(u(u({}, _.ARITHMETIC_FUNCTION_TRANSLATE), $.LOGICAL_FUNCTION_TRANSLATE), b.MATRICES_FUNCTION_TRANSLATE), M.MATRIX_FUNCTION_TRANSLATE), C.RELATIONAL_FUNCTION_TRANSLATE), S.SCALAR_FUNCTION_TRANSLATE), D = [
    ...Object.values(_.default).map((I) => I.name),
    ...Object.values($.default).map((I) => I.name),
    ...Object.values(b.default).map((I) => I.name),
    ...Object.values(M.default).map((I) => I.name),
    ...Object.values(C.default).map((I) => I.name),
    ...Object.values(S.default).map((I) => I.name)
  ], N = (0, y.create)(y.all);
  N.import(_.default, { override: !0 }), N.import($.default, { override: !0 }), N.import(b.default, {}), N.import(M.default, {}), N.import(C.default, { override: !0 }), N.import(S.default, { override: !0 });
  const T = () => N, R = (I, k) => {
    Object.keys(k).forEach((B) => {
      I.set(B, k[B]);
    });
  }, F = (I) => {
    const k = N.parser();
    return (0, x.isObject)(I) && R(k, I), k;
  }, z = (I) => A[I], O = (I) => D.includes(I), G = (I) => {
    const k = I.getAll();
    return Object.keys(k).forEach((B) => {
      (0, x.isEmpty)(k[B]) && delete k[B];
    }), k;
  };
})(core);
var expression = {}, build = {}, commutative$1 = {}, utils$4 = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    concatMultipleOperands: () => s
  });
  const s = (...o) => o.reduce((l, d) => d != null && d !== "" ? l.concat(d) : l, []);
})(utils$4);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (M) => n(M, "__esModule", { value: !0 }), d = (M, C) => {
    l(M);
    for (var S in C)
      n(M, S, { get: C[S], enumerable: !0 });
  }, h = (M, C, S) => {
    if (C && typeof C == "object" || typeof C == "function")
      for (let A of s(C))
        !c.call(M, A) && A !== "default" && n(M, A, { get: () => C[A], enumerable: !(S = a(C, A)) || S.enumerable });
    return M;
  }, u = (M) => h(l(n(M != null ? r(o(M)) : {}, "default", M && M.__esModule && "default" in M ? { get: () => M.default, enumerable: !0 } : { value: M, enumerable: !0 })), M);
  d(t, {
    buildCommutativeExpression: () => b,
    getNonCommutativeOperandExpression: () => $,
    isCommutative: () => _
  });
  var p = u(mathFunctionError), m = u(utils$4);
  const g = [
    "addMatrices",
    "addMatrix",
    "concatenate",
    "empty",
    "equalMatrices",
    "equalTextMatrices",
    "largerEqMatrices",
    "largerMatrices",
    "maximum",
    "maximumMatrices",
    "maximumMatrix",
    "minimum",
    "minimumMatrices",
    "minimumMatrix",
    "multiplyMatrices",
    "multiplyMatrix",
    "smallerEqMatrices",
    "smallerMatrices",
    "summatoryMatrix",
    "unequalMatrices",
    "unequalTextMatrices"
  ], v = {
    divideMatrices: "multiplyMatrices",
    divideMatrix: "multiplyMatrix",
    subtractMatrices: "addMatrices",
    subtractMatrix: "addMatrix"
  }, y = Object.keys(v), x = g.concat(y), _ = (M) => x.includes(M), $ = (M, C) => C.length > 1 ? `${M}(${C.join(", ")})` : C, b = (M, C, S) => {
    if (!_(M))
      throw new p.MathFunctionError(`Function ${M}. Not a commutative function`);
    if (g.includes(M)) {
      const F = (0, m.concatMultipleOperands)(C, S);
      return `${M}(${F.join(", ")})`;
    }
    const A = (0, m.concatMultipleOperands)(C), D = (0, m.concatMultipleOperands)(S), N = v[M], T = $(N, A), R = $(N, D);
    return R ? `${M}(${T}, ${R})` : `${M}(${T})`;
  };
})(commutative$1);
var double$1 = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (y) => n(y, "__esModule", { value: !0 }), d = (y, x) => {
    l(y);
    for (var _ in x)
      n(y, _, { get: x[_], enumerable: !0 });
  }, h = (y, x, _) => {
    if (x && typeof x == "object" || typeof x == "function")
      for (let $ of s(x))
        !c.call(y, $) && $ !== "default" && n(y, $, { get: () => x[$], enumerable: !(_ = a(x, $)) || _.enumerable });
    return y;
  }, u = (y) => h(l(n(y != null ? r(o(y)) : {}, "default", y && y.__esModule && "default" in y ? { get: () => y.default, enumerable: !0 } : { value: y, enumerable: !0 })), y);
  d(t, {
    buildDoubleExpression: () => v,
    isDoubleExpression: () => g
  });
  var p = u(mathFunctionError);
  const m = [
    "adjustMatrix",
    "appendMatrixNumber",
    "appendMatrixText",
    "concatenate",
    "concatenateMatrices",
    "concatenateMatrix",
    "containText",
    "containTextMatrices",
    "containTextMatrix",
    "dateCalculateDays",
    "dateCalculateDaysMatrices",
    "dateCalculateDaysMatrix",
    "elementMatrixNumber",
    "elementMatrixText",
    "equalMatrix",
    "equalText",
    "equalTextMatrix",
    "hasNotValueChangedNumber",
    "hasNotValueChangedText",
    "includeEqualTextMatrices",
    "includeTextMatrices",
    "indexOfMatrices",
    "indexOfMatrix",
    "indexFirstTextValueMatrix",
    "indexFirstTextValueMatrices",
    "indexMaximumMatrix",
    "indexMaximumMatrices",
    "indexMinimumMatrix",
    "indexMinimumMatrices",
    "indexSumMatrix",
    "indexSumMatrices",
    "largerEqMatrix",
    "largerMatrix",
    "largerMatrix",
    "leftNumber",
    "leftNumberMatrix",
    "leftText",
    "leftTextMatrix",
    "matchNumberMatrices",
    "matchNumberMatrix",
    "matchTextMatrices",
    "matchTextMatrix",
    "notEqualMatrix",
    "notContainText",
    "notContainTextMatrices",
    "notContainTextMatrix",
    "notIncludeEqualTextMatrices",
    "notIncludeTextMatrices",
    "percentage",
    "rightNumber",
    "rightNumberMatrix",
    "rightText",
    "rightTextMatrix",
    "smallerEqMatrices",
    "smallerEqMatrix",
    "smallerMatrices",
    "smallerMatrix",
    "unequalMatrix",
    "unequalText",
    "unequalTextMatrix",
    "removeTextsMatrix"
  ], g = (y) => m.includes(y), v = (y, x = [], _ = []) => {
    if (!g(y))
      throw new p.MathFunctionError(`Function ${y}. Not a double function`);
    if (x.length > 1 || _.length > 1) {
      const M = `Function ${y}. Double operator with invalid operands size: 1=${x.length}, 2=${_.length}`;
      throw new p.MathFunctionError(M);
    }
    const [$] = x, [b] = _;
    if ($ === void 0) {
      const M = `Invalid first operand for ${y}: 1=${$}, 2=${b}`;
      throw new p.MathFunctionError(M);
    }
    if (b === void 0) {
      const M = `Invalid second operand for ${y}: 1=${$}, 2=${b}`;
      throw new p.MathFunctionError(M);
    }
    return `${y}(${$}, ${b})`;
  };
})(double$1);
var commutative = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (S) => n(S, "__esModule", { value: !0 }), d = (S, A) => {
    l(S);
    for (var D in A)
      n(S, D, { get: A[D], enumerable: !0 });
  }, h = (S, A, D) => {
    if (A && typeof A == "object" || typeof A == "function")
      for (let N of s(A))
        !c.call(S, N) && N !== "default" && n(S, N, { get: () => A[N], enumerable: !(D = a(A, N)) || D.enumerable });
    return S;
  }, u = (S) => h(l(n(S != null ? r(o(S)) : {}, "default", S && S.__esModule && "default" in S ? { get: () => S.default, enumerable: !0 } : { value: S, enumerable: !0 })), S);
  d(t, {
    buildCommutativeOperatorExpression: () => C,
    isCommutativeOperator: () => b
  });
  var p = u(mathFunctionError), m = u(utils$4);
  const g = {
    add: "+",
    and: "and",
    or: "or",
    multiply: "*"
  }, v = {
    divide: "/",
    subtract: "-"
  }, y = {
    divide: g.multiply,
    subtract: g.add
  }, x = Object.keys(g), _ = Object.keys(v), $ = x.concat(_), b = (S) => $.includes(S), M = (S, A) => {
    const D = A.join(` ${S} `);
    return A.length === 1 ? `${D}` : `(${D})`;
  }, C = (S, A, D) => {
    if (!b(S))
      throw new p.MathFunctionError(`Function ${S}. Not a commutative function`);
    if (x.includes(S)) {
      const G = g[S], I = (0, m.concatMultipleOperands)(A, D), k = I.join(` ${G} `);
      return I.length === 1 ? `${k}` : `(${k})`;
    }
    const N = v[S], T = (0, m.concatMultipleOperands)(A), R = (0, m.concatMultipleOperands)(D), F = y[S], z = M(F, T), O = M(F, R);
    return O ? `(${z} ${N} ${O})` : `(${z})`;
  };
})(commutative);
var double = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (x) => n(x, "__esModule", { value: !0 }), d = (x, _) => {
    l(x);
    for (var $ in _)
      n(x, $, { get: _[$], enumerable: !0 });
  }, h = (x, _, $) => {
    if (_ && typeof _ == "object" || typeof _ == "function")
      for (let b of s(_))
        !c.call(x, b) && b !== "default" && n(x, b, { get: () => _[b], enumerable: !($ = a(_, b)) || $.enumerable });
    return x;
  }, u = (x) => h(l(n(x != null ? r(o(x)) : {}, "default", x && x.__esModule && "default" in x ? { get: () => x.default, enumerable: !0 } : { value: x, enumerable: !0 })), x);
  d(t, {
    buildDoubleOperatorExpression: () => y,
    isDoubleOperator: () => v
  });
  var p = u(mathFunctionError);
  const m = {
    equal: "==",
    larger: ">",
    largerEq: ">=",
    smaller: "<",
    smallerEq: "<=",
    unequal: "!="
  }, g = Object.keys(m), v = (x) => g.includes(x), y = (x, _ = [], $ = []) => {
    if (!v(x))
      throw new p.MathFunctionError(`Function ${x}. Not a double operator function`);
    const [b] = _, [M] = $;
    if (b === void 0) {
      const S = `Invalid operands for ${x}: 1=${b}, 2=${M}`;
      throw new p.MathFunctionError(S);
    }
    const C = m[x];
    return M === void 0 ? `(${b} ${C} 0)` : `(${b} ${C} ${M})`;
  };
})(double);
var single = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (y) => n(y, "__esModule", { value: !0 }), d = (y, x) => {
    l(y);
    for (var _ in x)
      n(y, _, { get: x[_], enumerable: !0 });
  }, h = (y, x, _) => {
    if (x && typeof x == "object" || typeof x == "function")
      for (let $ of s(x))
        !c.call(y, $) && $ !== "default" && n(y, $, { get: () => x[$], enumerable: !(_ = a(x, $)) || _.enumerable });
    return y;
  }, u = (y) => h(l(n(y != null ? r(o(y)) : {}, "default", y && y.__esModule && "default" in y ? { get: () => y.default, enumerable: !0 } : { value: y, enumerable: !0 })), y);
  d(t, {
    buildSingleExpression: () => v,
    isSingleExpression: () => g
  });
  var p = u(mathFunctionError);
  const m = [
    "buildMatrixNumber",
    "buildMatrixText",
    "dateHumanize",
    "dateHumanizeMatrix",
    "dateReverse",
    "dateReverseMatrix",
    "emptyMatrix",
    "floor",
    "floorMatrix",
    "hasNotMatrixLargerSizeChanged",
    "hasNotMatrixSmallerSizeChanged",
    "hasNotChangedNumber",
    "hasNotChangedText",
    "hasNotChangedNumberMatrix",
    "hasNotChangedTextMatrix",
    "mode",
    "notEmpty",
    "notEmptyMatrix",
    "parseName",
    "parseNameMatrix",
    "removeEmptiesMatrix",
    "round",
    "roundInteger",
    "roundMatrix",
    "roundIntegerMatrix",
    "positionMatrix",
    "sanitize",
    "sanitizeMatrix",
    "uniqueMatrix"
  ], g = (y) => m.includes(y), v = (y, x = [], _ = []) => {
    if (!g(y))
      throw new p.MathFunctionError(`Function ${y}. Not a single function`);
    const [$] = x;
    if ($ === void 0 || x.length !== 1) {
      const b = `Invalid operands for single operand function ${y}: 1=${x}`;
      throw new p.MathFunctionError(b);
    }
    if (_.length !== 0) {
      const b = `Invalid operands 2 for single operand function ${y}. There is a second operand: 1=${$}, 2=${_}`;
      throw new p.MathFunctionError(b);
    }
    return `${y}(${$})`;
  };
})(single);
var triple = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (y) => n(y, "__esModule", { value: !0 }), d = (y, x) => {
    l(y);
    for (var _ in x)
      n(y, _, { get: x[_], enumerable: !0 });
  }, h = (y, x, _) => {
    if (x && typeof x == "object" || typeof x == "function")
      for (let $ of s(x))
        !c.call(y, $) && $ !== "default" && n(y, $, { get: () => x[$], enumerable: !(_ = a(x, $)) || _.enumerable });
    return y;
  }, u = (y) => h(l(n(y != null ? r(o(y)) : {}, "default", y && y.__esModule && "default" in y ? { get: () => y.default, enumerable: !0 } : { value: y, enumerable: !0 })), y);
  d(t, {
    buildTripleExpression: () => v,
    isTripleExpression: () => g
  });
  var p = u(mathFunctionError);
  const m = [
    "calculateGravamen",
    "calculateGravamenRound",
    "calculateGravamenRoundInteger"
  ], g = (y) => m.includes(y), v = (y, x, _) => {
    if (!g(y))
      throw new p.MathFunctionError(`Function ${y}. Not a triple function`);
    const [$, b] = x, [M] = _;
    if ($ === void 0 || b === void 0 || M === void 0) {
      const C = `Invalid operands for ${y}: 1=${$}, 2=${b}, 3=${M}`;
      throw new p.MathFunctionError(C);
    }
    return `${y}(${$}, ${b}, ${M})`;
  };
})(triple);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (C) => n(C, "__esModule", { value: !0 }), d = (C, S) => {
    l(C);
    for (var A in S)
      n(C, A, { get: S[A], enumerable: !0 });
  }, h = (C, S, A) => {
    if (S && typeof S == "object" || typeof S == "function")
      for (let D of s(S))
        !c.call(C, D) && D !== "default" && n(C, D, { get: () => S[D], enumerable: !(A = a(S, D)) || A.enumerable });
    return C;
  }, u = (C) => h(l(n(C != null ? r(o(C)) : {}, "default", C && C.__esModule && "default" in C ? { get: () => C.default, enumerable: !0 } : { value: C, enumerable: !0 })), C);
  d(t, {
    buildExpression: () => M
  });
  var p = u(core), m = u(mathFunctionError), g = u(commutative$1), v = u(double$1), y = u(commutative), x = u(double), _ = u(single), $ = u(triple);
  const b = (C, S, A) => {
    if ((0, y.isCommutativeOperator)(C))
      return (0, y.buildCommutativeOperatorExpression)(C, S, A);
    if ((0, x.isDoubleOperator)(C))
      return (0, x.buildDoubleOperatorExpression)(C, S, A);
    if ((0, _.isSingleExpression)(C))
      return (0, _.buildSingleExpression)(C, S, A);
    if ((0, v.isDoubleExpression)(C))
      return (0, v.buildDoubleExpression)(C, S, A);
    if ((0, $.isTripleExpression)(C))
      return (0, $.buildTripleExpression)(C, S, A);
    if ((0, g.isCommutative)(C))
      return (0, g.buildCommutativeExpression)(C, S, A);
    throw new m.MathFunctionError(`Unknown RITA operation ${C}`);
  }, M = (C, S, A, D = []) => {
    const N = (0, p.translateFunction)(C);
    if (!N)
      throw new m.MathFunctionError(`Unknown airtable operation ${C}`);
    const T = b(N, S, A);
    return D.length === 1 ? `ifThen(${D}, ${T})` : T;
  };
})(build);
var evaluate = {}, mathEvaluateError = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
    l(v);
    for (var x in y)
      n(v, x, { get: y[x], enumerable: !0 });
  }, h = (v, y, x) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let _ of s(y))
        !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
    return v;
  }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
  d(t, {
    MathEvaluateError: () => g
  });
  var p = u(dist), m = u(errors);
  class g extends p.TaxDownError {
    constructor(y) {
      const x = "mathEvaluateError";
      super(new p.ErrorName(x), new p.ErrorMessage(y), new p.ErrorStatus(500), new p.ErrorInternalCode(m.Errors[x]), new p.ErrorLogLevel(p.LogLevel.WARN));
    }
  }
})(mathEvaluateError);
var utils$3 = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    evaluateExpressionError: () => $,
    scopeWithMissingSymbols: () => _
  });
  var p = u(constants$4), m = u(core), g = u(utils$6), v = u(mathEvaluateError);
  function y(b, M) {
    const C = b.match(M);
    return C === null ? [] : C;
  }
  const x = (b, M) => {
    if (typeof b != "object" || b === null)
      throw new v.MathEvaluateError(`Invalid scope: ${b} for expression: ${M}`);
    const C = y(M, g.SYMBOL_REGEX), S = {};
    for (const A of C)
      S[A] = b[A];
    return S;
  }, _ = (b, M) => {
    const C = x(b, M);
    if (b[p.SCOPE_ORIGINAL]) {
      const S = x(b[p.SCOPE_ORIGINAL], M);
      C[p.SCOPE_ORIGINAL] = S;
    }
    return C;
  }, $ = (b, M, C) => {
    const S = (0, m.taxdownMathParser)(), A = (0, g.findAllParamsExpression)(M);
    let D = "";
    for (let N = 0; N < A.length; N += 1) {
      const T = S.get(A[N]);
      T !== void 0 && (Array.isArray(T) ? D = M.split(A[N]).join(`[${T}]`) : D = M.split(A[N]).join(` ${T} `));
    }
    return {
      id: C,
      error: b.toString(),
      originalExpression: M.toString(),
      expression: D
    };
  };
})(utils$3);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = ($) => n($, "__esModule", { value: !0 }), d = ($, b) => {
    l($);
    for (var M in b)
      n($, M, { get: b[M], enumerable: !0 });
  }, h = ($, b, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let C of s(b))
        !c.call($, C) && C !== "default" && n($, C, { get: () => b[C], enumerable: !(M = a(b, C)) || M.enumerable });
    return $;
  }, u = ($) => h(l(n($ != null ? r(o($)) : {}, "default", $ && $.__esModule && "default" in $ ? { get: () => $.default, enumerable: !0 } : { value: $, enumerable: !0 })), $);
  d(t, {
    evaluate: () => x,
    evaluateAndSave: () => _
  });
  var p = u(core), m = u(utils$6), g = u(mathEvaluateError), v = u(utils$3);
  function y($) {
    return typeof $ == "number" ? (0, m.roundNumber)($, 2) : $;
  }
  const x = ($, b, M) => {
    try {
      const C = (0, v.scopeWithMissingSymbols)($, b), S = (0, p.taxdownMath)().compile(b).evaluate(C);
      return Array.isArray(S) ? S.map((A) => y(A)) : y(S);
    } catch (C) {
      const S = (0, v.evaluateExpressionError)(C, b, M);
      throw new g.MathEvaluateError(JSON.stringify(S));
    }
  }, _ = ($, b, M) => {
    const C = $.getAll(), S = x(C, b, M);
    return S !== void 0 && $.set(M, S), S;
  };
})(evaluate);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (g) => n(g, "__esModule", { value: !0 }), d = (g, v) => {
    l(g);
    for (var y in v)
      n(g, y, { get: v[y], enumerable: !0 });
  }, h = (g, v, y) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let x of s(v))
        !c.call(g, x) && x !== "default" && n(g, x, { get: () => v[x], enumerable: !(y = a(v, x)) || y.enumerable });
    return g;
  }, u = (g) => h(l(n(g != null ? r(o(g)) : {}, "default", g && g.__esModule && "default" in g ? { get: () => g.default, enumerable: !0 } : { value: g, enumerable: !0 })), g);
  d(t, {
    buildExpression: () => p.buildExpression,
    evaluate: () => m.evaluate,
    evaluateAndSave: () => m.evaluateAndSave
  });
  var p = u(build), m = u(evaluate);
})(expression);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
    l(v);
    for (var x in y)
      n(v, x, { get: y[x], enumerable: !0 });
  }, h = (v, y, x) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let _ of s(y))
        !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
    return v;
  }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
  d(t, {
    SCOPE_ORIGINAL: () => p.SCOPE_ORIGINAL,
    core: () => m,
    expression: () => g
  });
  var p = u(constants$4), m = u(core), g = u(expression);
})(engine);
var model = {}, collection = {}, singleOption = {}, modelSingleOptionTypeInvalid = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
    l(v);
    for (var x in y)
      n(v, x, { get: y[x], enumerable: !0 });
  }, h = (v, y, x) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let _ of s(y))
        !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
    return v;
  }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
  d(t, {
    ModelSingleOptionTypeInvalid: () => g
  });
  var p = u(dist), m = u(errors);
  class g extends p.TaxDownError {
    constructor(y) {
      const x = "modelSingleOptionTypeInvalid";
      super(new p.ErrorName(x), new p.ErrorMessage("The optionsType for a singleOption is invalid"), new p.ErrorStatus(422), new p.ErrorInternalCode(m.Errors[x]), new p.ErrorLogLevel(p.LogLevel.ERROR), new p.ErrorContext({ optionsType: y }));
    }
  }
})(modelSingleOptionTypeInvalid);
var validations$2 = {}, utils$2 = {}, nif_nie = {}, nie = {}, definition$1 = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    ValidationTypes: () => s
  });
  var s;
  (function(o) {
    o.CADASTER_NUMBER = "Cadaster_number", o.CHECKBOX = "Checkbox", o.CIF = "CIF", o.DATE = "Date", o.DECIMAL = "Decimal", o.INTEGER = "Integer", o.NIE = "NIE", o.NIF = "NIF", o.NIF_NIE = "NIF_NIE", o.NIF_NIE_CIF = "NIF_NIE_CIF", o.SINGLEOPTION = "Singleoption", o.TEXT = "Text", o.STRICT_TEXT = "StrictText", o.ADDRESS = "Address";
  })(s || (s = {}));
})(definition$1);
var hasRequiredNie;
function requireNie() {
  return hasRequiredNie || (hasRequiredNie = 1, function(t) {
    var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (O) => n(O, "__esModule", { value: !0 }), d = (O, G) => {
      l(O);
      for (var I in G)
        n(O, I, { get: G[I], enumerable: !0 });
    }, h = (O, G, I) => {
      if (G && typeof G == "object" || typeof G == "function")
        for (let k of s(G))
          !c.call(O, k) && k !== "default" && n(O, k, { get: () => G[k], enumerable: !(I = a(G, k)) || I.enumerable });
      return O;
    }, u = (O) => h(l(n(O != null ? r(o(O)) : {}, "default", O && O.__esModule && "default" in O ? { get: () => O.default, enumerable: !0 } : { value: O, enumerable: !0 })), O);
    d(t, {
      default: () => z
    });
    var p = u(requireUtils()), m = u(requireValidations()), g = u(definition$1);
    const v = "", y = g.ValidationTypes.NIE, x = "string", _ = /[^A-Z0-9]+/g, $ = /^[XYZ]{1}[0-9]{7}[A-Z]{1}$/, b = "TRWAGMYFPDXBNJZSQVHLCKET", M = () => v, C = (O) => typeof O === x && O.length !== 0, S = (O) => O === "X" ? "0" : O === "Y" ? "1" : "2", A = (O) => {
      if ((0, p.regexTest)(O, $)) {
        const G = O.substr(0, 1), I = S(G) + O.substr(1, O.length - 2), k = O.substr(O.length - 1, 1), B = parseInt(I) % 23;
        if (b.substring(B, B + 1) === k.toUpperCase())
          return !0;
      }
      return !1;
    }, D = (O, G, I = !1) => {
      const { required: k = !1 } = G || {};
      return !k && O === v ? "" : C(O) ? A(O) ? "" : (0, m.validationRegexMessage)({ NAME: y, value: O }, I) : (0, m.validationInvalidMessage)({ NAME: y, value: O }, I);
    };
    var z = {
      NAME: y,
      getDefaultValue: M,
      message: (O, G, I = !0) => O || G || I ? D(O, G, I) : "invalid_nie",
      sanitize: (O) => !O || typeof O !== x ? v : O.toUpperCase().replace(_, ""),
      validate: (O, G) => D(O, G) === ""
    };
  }(nie)), nie;
}
var nif = {}, hasRequiredNif;
function requireNif() {
  return hasRequiredNif || (hasRequiredNif = 1, function(t) {
    var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (z) => n(z, "__esModule", { value: !0 }), d = (z, O) => {
      l(z);
      for (var G in O)
        n(z, G, { get: O[G], enumerable: !0 });
    }, h = (z, O, G) => {
      if (O && typeof O == "object" || typeof O == "function")
        for (let I of s(O))
          !c.call(z, I) && I !== "default" && n(z, I, { get: () => O[I], enumerable: !(G = a(O, I)) || G.enumerable });
      return z;
    }, u = (z) => h(l(n(z != null ? r(o(z)) : {}, "default", z && z.__esModule && "default" in z ? { get: () => z.default, enumerable: !0 } : { value: z, enumerable: !0 })), z);
    d(t, {
      default: () => F
    });
    var p = u(requireUtils()), m = u(requireValidations()), g = u(definition$1);
    const v = "", y = g.ValidationTypes.NIF, x = "string", _ = /[^A-Za-z0-9]+/g, $ = /^[LKlk0-9]{8}[A-Za-z]{1}$/, b = "TRWAGMYFPDXBNJZSQVHLCKET", M = () => v, C = (z) => typeof z === x && z.length !== 0, S = (z) => {
      if ((0, p.regexTest)(z, $)) {
        const O = z.charAt(0), G = isNaN(O) ? z.substr(1, z.length - 2) : z.substr(0, z.length - 1), I = z.substr(z.length - 1, 1), k = G % 23;
        if (b.substring(k, k + 1) === I.toUpperCase())
          return !0;
      }
      return !1;
    }, A = (z, O, G = !1) => {
      const { required: I = !1 } = O || {};
      return !I && z === v ? "" : C(z) ? S(z) ? "" : (0, m.validationRegexMessage)({ NAME: y, value: z }, G) : (0, m.validationInvalidMessage)({ NAME: y, value: z }, G);
    };
    var F = {
      NAME: y,
      getDefaultValue: M,
      message: (z, O, G = !0) => z || O || G ? A(z, O, G) : "invalid_nif",
      sanitize: (z) => !z || typeof z !== x ? v : z.toUpperCase().replace(_, ""),
      validate: (z, O) => A(z, O) === ""
    };
  }(nif)), nif;
}
var hasRequiredNif_nie;
function requireNif_nie() {
  return hasRequiredNif_nie || (hasRequiredNif_nie = 1, function(t) {
    var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
      l(v);
      for (var x in y)
        n(v, x, { get: y[x], enumerable: !0 });
    }, h = (v, y, x) => {
      if (y && typeof y == "object" || typeof y == "function")
        for (let _ of s(y))
          !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
      return v;
    }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
    d(t, {
      determineDocumentType: () => g
    });
    var p = u(requireNie()), m = u(requireNif());
    const g = (v) => {
      const x = v.replace(/\s+/g, "").charAt(0);
      return /^[XYZ]/i.test(x) ? p.default.NAME : m.default.NAME;
    };
  }(nif_nie)), nif_nie;
}
var hasRequiredUtils;
function requireUtils() {
  return hasRequiredUtils || (hasRequiredUtils = 1, function(t) {
    var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
      l(v);
      for (var x in y)
        n(v, x, { get: y[x], enumerable: !0 });
    }, h = (v, y, x) => {
      if (y && typeof y == "object" || typeof y == "function")
        for (let _ of s(y))
          !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
      return v;
    }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
    d(t, {
      formatDate: () => g,
      isUndefined: () => m,
      regexTest: () => p
    }), h(t, u(requireNif_nie()));
    const p = (v, y) => {
      const x = y.test(v);
      return y.lastIndex = 0, x;
    }, m = (v) => typeof v > "u", g = (v) => typeof v != "string" || v.length !== 8 ? "" : `${v.slice(4, 8)}-${v.slice(2, 4)}-${v.slice(0, 2)}`;
  }(utils$2)), utils$2;
}
var hasRequiredValidations;
function requireValidations() {
  return hasRequiredValidations || (hasRequiredValidations = 1, function(t) {
    var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (G) => n(G, "__esModule", { value: !0 }), d = (G, I) => {
      l(G);
      for (var k in I)
        n(G, k, { get: I[k], enumerable: !0 });
    }, h = (G, I, k) => {
      if (I && typeof I == "object" || typeof I == "function")
        for (let B of s(I))
          !c.call(G, B) && B !== "default" && n(G, B, { get: () => I[B], enumerable: !(k = a(I, B)) || k.enumerable });
      return G;
    }, u = (G) => h(l(n(G != null ? r(o(G)) : {}, "default", G && G.__esModule && "default" in G ? { get: () => G.default, enumerable: !0 } : { value: G, enumerable: !0 })), G);
    d(t, {
      validationDate: () => _,
      validationInvalidMessage: () => M,
      validationLength: () => x,
      validationLengthMessage: () => D,
      validationMax: () => y,
      validationMaxDate: () => b,
      validationMaxDateMessage: () => O,
      validationMaxMessage: () => A,
      validationMin: () => v,
      validationMinDate: () => $,
      validationMinDateMessage: () => z,
      validationMinMessage: () => S,
      validationOptionInvalidMessage: () => R,
      validationOptionsMessage: () => F,
      validationRegexMessage: () => T,
      validationRequired: () => g,
      validationRequiredMessage: () => C,
      validationTextLengthMessage: () => N
    });
    var p = u(require$$2), m = u(requireUtils());
    const g = (G, I) => G !== I, v = (G, I) => (0, m.isUndefined)(I) ? !0 : G >= I, y = (G, I) => (0, m.isUndefined)(I) ? !0 : G <= I, x = (G, I) => I ? G.length <= I : !0, _ = (G) => (0, p.default)((0, m.formatDate)(G), !0).isValid(), $ = (G, I) => {
      const k = (0, p.default)((0, m.formatDate)(G)), B = (0, p.default)((0, m.formatDate)(I));
      return !k.isBefore(B);
    }, b = (G, I) => {
      const k = (0, p.default)((0, m.formatDate)(G)), B = (0, p.default)((0, m.formatDate)(I));
      return !k.isAfter(B);
    }, M = ({ NAME: G, value: I }, k = !0) => k ? `Invalid ${G}: value=${I}, type=${typeof I}` : "invalid_field", C = ({ NAME: G, value: I }, k = !0) => k ? `Invalid ${G}. Field are required: value=${I}, type=${typeof I}` : "invalid_required", S = ({ NAME: G, value: I, min: k }, B = !0) => B ? `Invalid ${G}. ${I} smaller than ${k}: value=${I}, type=${typeof I}` : "invalid_min", A = ({ NAME: G, value: I, max: k }, B = !0) => B ? `Invalid ${G}. ${I} greater than ${k} : value=${I}, type=${typeof I}` : "invalid_max", D = ({ NAME: G, value: I }, k = !0) => k ? `Invalid ${G}. Unexpected length: value=${I}, type=${typeof I}, length=${I.length}` : "invalid_length", N = ({ NAME: G, value: I, length: k }, B = !0) => B ? `Invalid ${G}. Length ${I.length} is greater than expected ${k} : value=${I}, type=${typeof I}` : "invalid_text_length", T = ({ NAME: G, value: I }, k = !0) => k ? `Invalid ${G}. Does not validate regular expression: value=${I}, length=${I.length}, type=${typeof I}` : "invalid_regex", R = ({ value: G, options: I }, k = !0) => {
      const B = I.map((L) => `value=${L}, type=${typeof L}`).join(". ");
      return k ? `There is no option that matches: value=${G}, type=${typeof G}. Valid options: ${B}` : "invalid_singleoption";
    }, F = (G = !0) => G ? "There are no valid options for this yayoyaki" : "invalid_singleoption", z = ({ NAME: G, value: I, min: k }, B = !0) => B ? `Invalid ${G}. ${I} smaller than ${k}: value=${I}, type=${typeof I}` : "invalid_min_date", O = ({ NAME: G, value: I, max: k }, B = !0) => B ? `Invalid ${G}. ${I} greater than ${k}: value=${I}, type=${typeof I}` : "invalid_max_date";
  }(validations$2)), validations$2;
}
var primitive = {}, strictText = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (R) => n(R, "__esModule", { value: !0 }), d = (R, F) => {
    l(R);
    for (var z in F)
      n(R, z, { get: F[z], enumerable: !0 });
  }, h = (R, F, z) => {
    if (F && typeof F == "object" || typeof F == "function")
      for (let O of s(F))
        !c.call(R, O) && O !== "default" && n(R, O, { get: () => F[O], enumerable: !(z = a(F, O)) || z.enumerable });
    return R;
  }, u = (R) => h(l(n(R != null ? r(o(R)) : {}, "default", R && R.__esModule && "default" in R ? { get: () => R.default, enumerable: !0 } : { value: R, enumerable: !0 })), R);
  d(t, {
    default: () => T
  });
  var p = u(requireValidations()), m = u(definition$1);
  const g = "", v = m.ValidationTypes.STRICT_TEXT, y = "string", x = /^[a-zA-ZÑñÁáÉéÍíÓóÚúÀàÈèÌìÒòÙùÄãËëÏïÖöÜüÇç\s.\-_:,'()]+$/, _ = /[^a-zA-ZÑñÁáÉéÍíÓóÚúÀàÈèÌìÒòÙùÄãËëÏïÖöÜüÇç\s.\-_:,'()]+/g, $ = (R) => {
    const F = new RegExp(_);
    return (R.replace(F, "") || "").replace(/\s\s+/g, " ").trim().toUpperCase();
  }, b = () => g, M = (R) => typeof R === y && x.test(R), C = (R, F, z = !1) => {
    const { required: O = !1, length: G } = F || {};
    return !O && R === g ? "" : M(R) ? O && !(0, p.validationRequired)(R, g) ? (0, p.validationRequiredMessage)({ NAME: v, value: R }, z) : (0, p.validationLength)(R, G) ? "" : (0, p.validationTextLengthMessage)({ NAME: v, value: R, length: G }, z) : (0, p.validationInvalidMessage)({ NAME: v, value: R }, z);
  };
  var T = {
    NAME: v,
    getDefaultValue: b,
    message: (R, F, z = !0) => R || F || z ? C(R, F, z) : "invalid_strict_text",
    sanitize: (R) => typeof R !== y ? g : $(R),
    validate: (R, F) => C(R, F) === ""
  };
})(strictText);
var address = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (R) => n(R, "__esModule", { value: !0 }), d = (R, F) => {
    l(R);
    for (var z in F)
      n(R, z, { get: F[z], enumerable: !0 });
  }, h = (R, F, z) => {
    if (F && typeof F == "object" || typeof F == "function")
      for (let O of s(F))
        !c.call(R, O) && O !== "default" && n(R, O, { get: () => F[O], enumerable: !(z = a(F, O)) || z.enumerable });
    return R;
  }, u = (R) => h(l(n(R != null ? r(o(R)) : {}, "default", R && R.__esModule && "default" in R ? { get: () => R.default, enumerable: !0 } : { value: R, enumerable: !0 })), R);
  d(t, {
    default: () => T
  });
  var p = u(requireValidations()), m = u(definition$1);
  const g = "", v = m.ValidationTypes.ADDRESS, y = "string", x = /^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚúÀàÈèÌìÒòÙùÄãËëÏïÖöÜüÇç\s.\-_:,'()]+$/, _ = /[^a-zA-Z0-9ÑñÁáÉéÍíÓóÚúÀàÈèÌìÒòÙùÄãËëÏïÖöÜüÇç\s.\-_:,'()]+/g, $ = (R) => {
    const F = new RegExp(_);
    return (R.replace(F, "") || "").toUpperCase();
  }, b = () => g, M = (R, F, z = !0) => R || F || z ? A(R, F, z) : "invalid_address", C = (R) => typeof R === y && x.test(R), S = (R) => typeof R !== y ? g : $(R), A = (R, F, z = !1) => {
    const { required: O = !1, length: G } = F || {};
    return !O && R === g ? "" : C(R) ? O && !(0, p.validationRequired)(R, g) ? (0, p.validationRequiredMessage)({ NAME: v, value: R }, z) : (0, p.validationLength)(R, G) ? "" : (0, p.validationTextLengthMessage)({ NAME: v, value: R, length: G }, z) : (0, p.validationInvalidMessage)({ NAME: v, value: R }, z);
  };
  var T = {
    NAME: v,
    getDefaultValue: b,
    message: M,
    sanitize: S,
    validate: (R, F) => A(R, F) === ""
  };
})(address);
var cadasterNumber = {}, cadaster = {};
(function(t) {
  var r = Object.defineProperty, n = (o) => r(o, "__esModule", { value: !0 }), a = (o, c) => {
    n(o);
    for (var l in c)
      r(o, l, { get: c[l], enumerable: !0 });
  };
  a(t, {
    validationCadasterNumber: () => s
  });
  function s(o) {
    var c = [13, 15, 12, 5, 4, 17, 9, 21, 3, 7, 1], l = "MQWERTYUIOPASDFGHJKLBZX";
    if (o == null || o.length !== 20)
      return !1;
    o = o.toUpperCase();
    var d = (o.substring(0, 7) + o.substring(14, 18)).toUpperCase(), h = (o.substring(7, 14) + o.substring(14, 18)).toUpperCase(), u = [d, h], p = "";
    return u.forEach(function(m) {
      var g = 0;
      m.split("").forEach(function(v, y) {
        let x = v;
        v >= "A" && v <= "N" ? x = v.charCodeAt() - 64 : v === "Ñ" ? x = 15 : v > "N" && (x = v.charCodeAt() - 63), g = (g + x * c[y]) % 23;
      }), p += l.charAt(g);
    }), p === o.substring(18, 20);
  }
})(cadaster);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (T) => n(T, "__esModule", { value: !0 }), d = (T, R) => {
    l(T);
    for (var F in R)
      n(T, F, { get: R[F], enumerable: !0 });
  }, h = (T, R, F) => {
    if (R && typeof R == "object" || typeof R == "function")
      for (let z of s(R))
        !c.call(T, z) && z !== "default" && n(T, z, { get: () => R[z], enumerable: !(F = a(R, z)) || F.enumerable });
    return T;
  }, u = (T) => h(l(n(T != null ? r(o(T)) : {}, "default", T && T.__esModule && "default" in T ? { get: () => T.default, enumerable: !0 } : { value: T, enumerable: !0 })), T);
  d(t, {
    default: () => N
  });
  var p = u(cadaster), m = u(requireValidations()), g = u(definition$1);
  const v = "", y = g.ValidationTypes.CADASTER_NUMBER, x = "string", _ = /[^A-Z0-9]+/g, $ = () => v, b = (T) => typeof T === x && T.length !== 0, M = (T, R, F = !1) => {
    const { required: z = !1 } = R || {};
    return !z && T === v ? "" : z && !(0, m.validationRequired)(T, v) ? (0, m.validationRequiredMessage)({ NAME: y, value: T }, F) : b(T) ? (0, p.validationCadasterNumber)(T) ? "" : (0, m.validationRegexMessage)({ NAME: y, value: T }, F) : (0, m.validationInvalidMessage)({ NAME: y, value: T }, F);
  };
  var N = {
    NAME: y,
    getDefaultValue: $,
    message: (T, R, F = !0) => T || R || F ? M(T, R, F) : "invalid_cadaster_number",
    sanitize: (T) => !T || typeof T !== x ? v : T.toUpperCase().replace(_, ""),
    validate: (T, R) => M(T, R) === ""
  };
})(cadasterNumber);
var checkbox = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (D) => n(D, "__esModule", { value: !0 }), d = (D, N) => {
    l(D);
    for (var T in N)
      n(D, T, { get: N[T], enumerable: !0 });
  }, h = (D, N, T) => {
    if (N && typeof N == "object" || typeof N == "function")
      for (let R of s(N))
        !c.call(D, R) && R !== "default" && n(D, R, { get: () => N[R], enumerable: !(T = a(N, R)) || T.enumerable });
    return D;
  }, u = (D) => h(l(n(D != null ? r(o(D)) : {}, "default", D && D.__esModule && "default" in D ? { get: () => D.default, enumerable: !0 } : { value: D, enumerable: !0 })), D);
  d(t, {
    default: () => A
  });
  var p = u(requireValidations()), m = u(definition$1);
  const g = 0, v = m.ValidationTypes.CHECKBOX, y = "number", x = () => g, _ = (D) => typeof D === y, $ = (D, N, T = !1) => {
    const { required: R = !1 } = N || {};
    return !R && D === g || _(D) ? "" : (0, p.validationInvalidMessage)({ NAME: v, value: D }, T);
  };
  var A = {
    NAME: v,
    getDefaultValue: x,
    message: (D, N, T = !0) => D || N || T ? $(D, N, T) : "invalid_checkbox",
    sanitize: (D) => {
      if (typeof D === y)
        return D;
      if (typeof D == "string") {
        const N = parseInt(D);
        return Number.isNaN(N) ? g : N;
      }
      return g;
    },
    validate: (D, N) => $(D, N) === ""
  };
})(checkbox);
var cif = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (R) => n(R, "__esModule", { value: !0 }), d = (R, F) => {
    l(R);
    for (var z in F)
      n(R, z, { get: F[z], enumerable: !0 });
  }, h = (R, F, z) => {
    if (F && typeof F == "object" || typeof F == "function")
      for (let O of s(F))
        !c.call(R, O) && O !== "default" && n(R, O, { get: () => F[O], enumerable: !(z = a(F, O)) || z.enumerable });
    return R;
  }, u = (R) => h(l(n(R != null ? r(o(R)) : {}, "default", R && R.__esModule && "default" in R ? { get: () => R.default, enumerable: !0 } : { value: R, enumerable: !0 })), R);
  d(t, {
    default: () => T
  });
  var p = u(requireUtils()), m = u(requireValidations()), g = u(definition$1);
  const v = "", y = g.ValidationTypes.CIF, x = "string", _ = /[^ABCDEFGHJNPQRSUVW0-9]+/g, $ = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/, b = () => v, M = (R) => typeof R === x && R.length !== 0, C = (R, F, z = !1) => {
    const { required: O = !1 } = F || {};
    return !O && R === v ? "" : M(R) ? (0, p.regexTest)(R, $) ? "" : (0, m.validationRegexMessage)({ NAME: y, value: R }, z) : (0, m.validationInvalidMessage)({ NAME: y, value: R }, z);
  };
  var T = {
    NAME: y,
    getDefaultValue: b,
    message: (R, F, z = !0) => R || F || z ? C(R, F, z) : "invalid_cif",
    sanitize: (R) => !R || typeof R !== x ? v : R.toUpperCase().replace(_, ""),
    validate: (R, F) => C(R, F) === ""
  };
})(cif);
var date = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (N) => n(N, "__esModule", { value: !0 }), d = (N, T) => {
    l(N);
    for (var R in T)
      n(N, R, { get: T[R], enumerable: !0 });
  }, h = (N, T, R) => {
    if (T && typeof T == "object" || typeof T == "function")
      for (let F of s(T))
        !c.call(N, F) && F !== "default" && n(N, F, { get: () => T[F], enumerable: !(R = a(T, F)) || R.enumerable });
    return N;
  }, u = (N) => h(l(n(N != null ? r(o(N)) : {}, "default", N && N.__esModule && "default" in N ? { get: () => N.default, enumerable: !0 } : { value: N, enumerable: !0 })), N);
  d(t, {
    default: () => D
  });
  var p = u(requireValidations()), m = u(definition$1);
  const g = "", v = m.ValidationTypes.DATE, y = "string", x = /[^0-9]+/g, _ = () => g, $ = (N) => typeof N === y && N.length !== 0, b = (N, T, R = !1) => {
    const { required: F = !1, min: z, max: O } = T || {};
    return !F && N === g ? "" : $(N) ? F && !(0, p.validationRequired)(N, g) ? (0, p.validationRequiredMessage)({ NAME: v, value: N }, R) : (0, p.validationDate)(N) ? (0, p.validationMinDate)(N, z) ? (0, p.validationMaxDate)(N, O) ? "" : (0, p.validationMaxDateMessage)({ NAME: v, value: N, max: O }, R) : (0, p.validationMinDateMessage)({ NAME: v, value: N, min: z }, R) : (0, p.validationRegexMessage)({ NAME: v, value: N }, R) : (0, p.validationInvalidMessage)({ NAME: v, value: N }, R);
  };
  var D = {
    NAME: v,
    getDefaultValue: _,
    message: (N, T, R = !0) => N || T || R ? b(N, T, R) : "invalid_date",
    sanitize: (N) => $(N) ? N.toUpperCase().replace(x, "") : g,
    validate: (N, T) => b(N, T) === ""
  };
})(date);
var decimal = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (T) => n(T, "__esModule", { value: !0 }), d = (T, R) => {
    l(T);
    for (var F in R)
      n(T, F, { get: R[F], enumerable: !0 });
  }, h = (T, R, F) => {
    if (R && typeof R == "object" || typeof R == "function")
      for (let z of s(R))
        !c.call(T, z) && z !== "default" && n(T, z, { get: () => R[z], enumerable: !(F = a(R, z)) || F.enumerable });
    return T;
  }, u = (T) => h(l(n(T != null ? r(o(T)) : {}, "default", T && T.__esModule && "default" in T ? { get: () => T.default, enumerable: !0 } : { value: T, enumerable: !0 })), T);
  d(t, {
    default: () => N
  });
  var p = u(requireValidations()), m = u(definition$1);
  const g = 0, v = m.ValidationTypes.DECIMAL, y = "number", x = /[,\s]+/g, _ = () => g, $ = (T) => {
    const R = T.replace(/,/g, ".").replace(x, ""), F = R.lastIndexOf("."), O = R.substring(0, F).replace(/\./g, "") + R.substring(F);
    return Number(O);
  }, b = (T) => typeof T === y ? parseFloat(T.toFixed(2)) === T : !1, M = (T, R, F = !1) => {
    const { required: z = !1, min: O, max: G } = R || {};
    return !z && T === g ? "" : b(T) ? z && !(0, p.validationRequired)(T, g) ? (0, p.validationRequiredMessage)({ NAME: v, value: T }, F) : (0, p.validationMin)(T, O) ? (0, p.validationMax)(T, G) ? "" : (0, p.validationMaxMessage)({ NAME: v, value: T, max: G }, F) : (0, p.validationMinMessage)({ NAME: v, value: T, min: O }, F) : (0, p.validationInvalidMessage)({ NAME: v, value: T }, F);
  };
  var N = {
    NAME: v,
    getDefaultValue: _,
    message: (T, R, F = !0) => T || R || F ? M(T, R, F) : "invalid_decimal",
    sanitize: (T) => {
      if (typeof T === y)
        return parseFloat(T.toFixed(2));
      if (typeof T == "string") {
        const R = $(T);
        return Number.isNaN(R) ? g : parseFloat(R.toFixed(2));
      }
      return g;
    },
    validate: (T, R) => M(T, R) === ""
  };
})(decimal);
var integer = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (A) => n(A, "__esModule", { value: !0 }), d = (A, D) => {
    l(A);
    for (var N in D)
      n(A, N, { get: D[N], enumerable: !0 });
  }, h = (A, D, N) => {
    if (D && typeof D == "object" || typeof D == "function")
      for (let T of s(D))
        !c.call(A, T) && T !== "default" && n(A, T, { get: () => D[T], enumerable: !(N = a(D, T)) || N.enumerable });
    return A;
  }, u = (A) => h(l(n(A != null ? r(o(A)) : {}, "default", A && A.__esModule && "default" in A ? { get: () => A.default, enumerable: !0 } : { value: A, enumerable: !0 })), A);
  d(t, {
    default: () => S
  });
  var p = u(requireValidations());
  const m = 0, g = "Integer", v = "number", y = () => m, x = (A) => typeof A === v ? parseFloat(A.toString()) === parseInt(A.toString()) : !1, _ = (A, D, N = !1) => {
    const { required: T = !1, min: R, max: F } = D || {};
    return !T && A === m ? "" : x(A) ? T && !(0, p.validationRequired)(A, m) ? (0, p.validationRequiredMessage)({ NAME: g, value: A }, N) : (0, p.validationMin)(A, R) ? (0, p.validationMax)(A, F) ? "" : (0, p.validationMaxMessage)({ NAME: g, value: A, max: F }, N) : (0, p.validationMinMessage)({ NAME: g, value: A, min: R }, N) : (0, p.validationInvalidMessage)({ NAME: g, value: A }, N);
  };
  var S = {
    NAME: g,
    getDefaultValue: y,
    message: (A, D, N = !0) => A || D || N ? _(A, D, N) : "invalid_integer",
    sanitize: (A) => {
      if (typeof A === v)
        return parseInt(A.toString());
      if (typeof A == "string") {
        const D = parseInt(A);
        return Number.isNaN(D) ? m : D;
      }
      return m;
    },
    validate: (A, D) => _(A, D) === ""
  };
})(integer);
var nifNie = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (D) => n(D, "__esModule", { value: !0 }), d = (D, N) => {
    l(D);
    for (var T in N)
      n(D, T, { get: N[T], enumerable: !0 });
  }, h = (D, N, T) => {
    if (N && typeof N == "object" || typeof N == "function")
      for (let R of s(N))
        !c.call(D, R) && R !== "default" && n(D, R, { get: () => N[R], enumerable: !(T = a(N, R)) || T.enumerable });
    return D;
  }, u = (D) => h(l(n(D != null ? r(o(D)) : {}, "default", D && D.__esModule && "default" in D ? { get: () => D.default, enumerable: !0 } : { value: D, enumerable: !0 })), D);
  d(t, {
    default: () => A
  });
  var p = u(requireNie()), m = u(requireNif()), g = u(definition$1);
  const v = "", y = g.ValidationTypes.NIF_NIE, x = "string", _ = () => v, $ = (D, N, T = !0) => D || N || T ? M(D, N, T) : "invalid_nif_nie", b = (D) => typeof D !== x ? v : D.toUpperCase(), M = (D, N, T = !1) => T ? `${m.default.message(D, N, T)}. ${p.default.message(D, N, T)}` : "invalid_nif_nie";
  var A = {
    NAME: y,
    getDefaultValue: _,
    message: $,
    sanitize: b,
    validate: (D, N) => m.default.validate(D, N) || p.default.validate(D, N)
  };
})(nifNie);
var nifNieCif = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (N) => n(N, "__esModule", { value: !0 }), d = (N, T) => {
    l(N);
    for (var R in T)
      n(N, R, { get: T[R], enumerable: !0 });
  }, h = (N, T, R) => {
    if (T && typeof T == "object" || typeof T == "function")
      for (let F of s(T))
        !c.call(N, F) && F !== "default" && n(N, F, { get: () => T[F], enumerable: !(R = a(T, F)) || R.enumerable });
    return N;
  }, u = (N) => h(l(n(N != null ? r(o(N)) : {}, "default", N && N.__esModule && "default" in N ? { get: () => N.default, enumerable: !0 } : { value: N, enumerable: !0 })), N);
  d(t, {
    default: () => D
  });
  var p = u(cif), m = u(requireNie()), g = u(requireNif()), v = u(definition$1);
  const y = "", x = v.ValidationTypes.NIF_NIE_CIF, _ = "string", $ = () => y, b = (N, T, R = !0) => N || T || R ? C(N, T, R) : "invalid_nif_nie_cif", M = (N) => typeof N !== _ ? y : N.toUpperCase(), C = (N, T, R = !1) => R ? `${g.default.message(N, T, R)}. ${m.default.message(N, T, R)}. ${p.default.message(N, T, R)}` : "invalid_nif_nie_cif";
  var D = {
    NAME: x,
    getDefaultValue: $,
    message: b,
    sanitize: M,
    validate: (N, T) => g.default.validate(N, T) || m.default.validate(N, T) || p.default.validate(N, T)
  };
})(nifNieCif);
var text = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (D) => n(D, "__esModule", { value: !0 }), d = (D, N) => {
    l(D);
    for (var T in N)
      n(D, T, { get: N[T], enumerable: !0 });
  }, h = (D, N, T) => {
    if (N && typeof N == "object" || typeof N == "function")
      for (let R of s(N))
        !c.call(D, R) && R !== "default" && n(D, R, { get: () => N[R], enumerable: !(T = a(N, R)) || T.enumerable });
    return D;
  }, u = (D) => h(l(n(D != null ? r(o(D)) : {}, "default", D && D.__esModule && "default" in D ? { get: () => D.default, enumerable: !0 } : { value: D, enumerable: !0 })), D);
  d(t, {
    default: () => A
  });
  var p = u(requireValidations()), m = u(definition$1);
  const g = "", v = m.ValidationTypes.TEXT, y = "string", x = () => g, _ = (D) => typeof D === y, $ = (D, N, T = !1) => {
    const { required: R = !1, length: F } = N || {};
    return !R && D === g ? "" : _(D) ? R && !(0, p.validationRequired)(D, g) ? (0, p.validationRequiredMessage)({ NAME: v, value: D }, T) : (0, p.validationLength)(D, F) ? "" : (0, p.validationTextLengthMessage)({ NAME: v, value: D, length: F }, T) : (0, p.validationInvalidMessage)({ NAME: v, value: D }, T);
  };
  var A = {
    NAME: v,
    getDefaultValue: x,
    message: (D, N, T = !0) => D || N || T ? $(D, N, T) : "invalid_text",
    sanitize: (D) => !D || typeof D !== y ? g : D,
    validate: (D, N) => $(D, N) === ""
  };
})(text);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (T) => n(T, "__esModule", { value: !0 }), d = (T, R) => {
    l(T);
    for (var F in R)
      n(T, F, { get: R[F], enumerable: !0 });
  }, h = (T, R, F) => {
    if (R && typeof R == "object" || typeof R == "function")
      for (let z of s(R))
        !c.call(T, z) && z !== "default" && n(T, z, { get: () => R[z], enumerable: !(F = a(R, z)) || F.enumerable });
    return T;
  }, u = (T) => h(l(n(T != null ? r(o(T)) : {}, "default", T && T.__esModule && "default" in T ? { get: () => T.default, enumerable: !0 } : { value: T, enumerable: !0 })), T);
  d(t, {
    default: () => N
  });
  var p = u(strictText), m = u(address), g = u(cadasterNumber), v = u(checkbox), y = u(cif), x = u(date), _ = u(decimal), $ = u(integer), b = u(requireNie()), M = u(requireNif()), C = u(nifNie), S = u(nifNieCif), A = u(text), N = {
    Cadaster_number: g.default,
    Checkbox: v.default,
    CIF: y.default,
    Date: x.default,
    Decimal: _.default,
    Integer: $.default,
    NIE: b.default,
    NIF: M.default,
    NIF_NIE: C.default,
    NIF_NIE_CIF: S.default,
    Text: A.default,
    StrictText: p.default,
    Address: m.default
  };
})(primitive);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (N) => n(N, "__esModule", { value: !0 }), d = (N, T) => {
    l(N);
    for (var R in T)
      n(N, R, { get: T[R], enumerable: !0 });
  }, h = (N, T, R) => {
    if (T && typeof T == "object" || typeof T == "function")
      for (let F of s(T))
        !c.call(N, F) && F !== "default" && n(N, F, { get: () => T[F], enumerable: !(R = a(T, F)) || R.enumerable });
    return N;
  }, u = (N) => h(l(n(N != null ? r(o(N)) : {}, "default", N && N.__esModule && "default" in N ? { get: () => N.default, enumerable: !0 } : { value: N, enumerable: !0 })), N);
  d(t, {
    default: () => D
  });
  var p = u(modelSingleOptionTypeInvalid), m = u(requireValidations()), g = u(definition$1), v = u(primitive);
  const y = null, x = g.ValidationTypes.SINGLEOPTION, _ = () => y, $ = (N, T) => !T || !Array.isArray(T) ? !1 : T.includes(N), b = (N, T, R = !1) => {
    const { options: F, required: z } = T || {};
    return !z && N === y ? "" : z && !(0, m.validationRequired)(N, y) ? (0, m.validationRequiredMessage)({ NAME: x, value: N }, R) : !F || !Array.isArray(F) ? (0, m.validationOptionsMessage)(R) : $(N, F) ? "" : (0, m.validationOptionInvalidMessage)({ value: N, options: F }, R);
  };
  var D = {
    NAME: x,
    getDefaultValue: _,
    message: (N, T, R = !0) => N || T || R ? b(N, T, R) : "invalid_singleoption",
    sanitize: (N, T) => {
      const { options: R, optionsType: F } = T || {};
      if (!F || !v.default[F])
        throw new p.ModelSingleOptionTypeInvalid(F);
      const z = v.default[F].sanitize(N);
      return $(z, R) ? z : y;
    },
    validate: (N, T) => b(N, T) === ""
  };
})(singleOption);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (v) => n(v, "__esModule", { value: !0 }), d = (v, y) => {
    l(v);
    for (var x in y)
      n(v, x, { get: y[x], enumerable: !0 });
  }, h = (v, y, x) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let _ of s(y))
        !c.call(v, _) && _ !== "default" && n(v, _, { get: () => y[_], enumerable: !(x = a(y, _)) || x.enumerable });
    return v;
  }, u = (v) => h(l(n(v != null ? r(o(v)) : {}, "default", v && v.__esModule && "default" in v ? { get: () => v.default, enumerable: !0 } : { value: v, enumerable: !0 })), v);
  d(t, {
    default: () => g
  });
  var p = u(singleOption), g = {
    Singleoption: p.default
  };
})(collection);
var definition = {};
(function(t) {
  var r = Object.defineProperty, n = (a) => r(a, "__esModule", { value: !0 });
  n(t);
})(definition);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getOwnPropertySymbols, c = Object.getPrototypeOf, l = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable, h = ($, b, M) => b in $ ? n($, b, { enumerable: !0, configurable: !0, writable: !0, value: M }) : $[b] = M, u = ($, b) => {
    for (var M in b || (b = {}))
      l.call(b, M) && h($, M, b[M]);
    if (o)
      for (var M of o(b))
        d.call(b, M) && h($, M, b[M]);
    return $;
  }, p = ($) => n($, "__esModule", { value: !0 }), m = ($, b) => {
    p($);
    for (var M in b)
      n($, M, { get: b[M], enumerable: !0 });
  }, g = ($, b, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let C of s(b))
        !l.call($, C) && C !== "default" && n($, C, { get: () => b[C], enumerable: !(M = a(b, C)) || M.enumerable });
    return $;
  }, v = ($) => g(p(n($ != null ? r(c($)) : {}, "default", $ && $.__esModule && "default" in $ ? { get: () => $.default, enumerable: !0 } : { value: $, enumerable: !0 })), $);
  m(t, {
    TYPES: () => _
  });
  var y = v(collection), x = v(primitive);
  g(t, v(definition)), g(t, v(requireUtils()));
  const _ = u(u({}, y.default), x.default);
})(model);
var services = {}, i18n = {}, _typeof$1 = { exports: {} };
(function(t) {
  function r(n) {
    "@babel/helpers - typeof";
    return t.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(_typeof$1);
var _typeofExports = _typeof$1.exports, classCallCheck = { exports: {} };
(function(t) {
  function r(n, a) {
    if (!(n instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(classCallCheck);
var classCallCheckExports = classCallCheck.exports, createClass = { exports: {} }, toPropertyKey = { exports: {} }, toPrimitive = { exports: {} };
(function(t) {
  var r = _typeofExports.default;
  function n(a, s) {
    if (r(a) != "object" || !a)
      return a;
    var o = a[Symbol.toPrimitive];
    if (o !== void 0) {
      var c = o.call(a, s || "default");
      if (r(c) != "object")
        return c;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (s === "string" ? String : Number)(a);
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})(toPrimitive);
var toPrimitiveExports = toPrimitive.exports;
(function(t) {
  var r = _typeofExports.default, n = toPrimitiveExports;
  function a(s) {
    var o = n(s, "string");
    return r(o) == "symbol" ? o : o + "";
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})(toPropertyKey);
var toPropertyKeyExports = toPropertyKey.exports;
(function(t) {
  var r = toPropertyKeyExports;
  function n(s, o) {
    for (var c = 0; c < o.length; c++) {
      var l = o[c];
      l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(s, r(l.key), l);
    }
  }
  function a(s, o, c) {
    return o && n(s.prototype, o), c && n(s, c), Object.defineProperty(s, "prototype", {
      writable: !1
    }), s;
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})(createClass);
var createClassExports = createClass.exports, assertThisInitialized = { exports: {} };
(function(t) {
  function r(n) {
    if (n === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(assertThisInitialized);
var assertThisInitializedExports = assertThisInitialized.exports, inherits = { exports: {} }, setPrototypeOf = { exports: {} };
(function(t) {
  function r(n, a) {
    return t.exports = r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, o) {
      return s.__proto__ = o, s;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n, a);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(setPrototypeOf);
var setPrototypeOfExports = setPrototypeOf.exports;
(function(t) {
  var r = setPrototypeOfExports;
  function n(a, s) {
    if (typeof s != "function" && s !== null)
      throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(s && s.prototype, {
      constructor: {
        value: a,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(a, "prototype", {
      writable: !1
    }), s && r(a, s);
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})(inherits);
var inheritsExports = inherits.exports, possibleConstructorReturn = { exports: {} };
(function(t) {
  var r = _typeofExports.default, n = assertThisInitializedExports;
  function a(s, o) {
    if (o && (r(o) == "object" || typeof o == "function"))
      return o;
    if (o !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return n(s);
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})(possibleConstructorReturn);
var possibleConstructorReturnExports = possibleConstructorReturn.exports, getPrototypeOf = { exports: {} };
(function(t) {
  function r(n) {
    return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
      return a.__proto__ || Object.getPrototypeOf(a);
    }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(getPrototypeOf);
var getPrototypeOfExports = getPrototypeOf.exports, defineProperty = { exports: {} };
(function(t) {
  var r = toPropertyKeyExports;
  function n(a, s, o) {
    return (s = r(s)) in a ? Object.defineProperty(a, s, {
      value: o,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : a[s] = o, a;
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})(defineProperty);
var definePropertyExports = defineProperty.exports, toArray = { exports: {} }, arrayWithHoles = { exports: {} };
(function(t) {
  function r(n) {
    if (Array.isArray(n))
      return n;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(arrayWithHoles);
var arrayWithHolesExports = arrayWithHoles.exports, iterableToArray = { exports: {} };
(function(t) {
  function r(n) {
    if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
      return Array.from(n);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(iterableToArray);
var iterableToArrayExports = iterableToArray.exports, unsupportedIterableToArray = { exports: {} }, arrayLikeToArray = { exports: {} };
(function(t) {
  function r(n, a) {
    (a == null || a > n.length) && (a = n.length);
    for (var s = 0, o = Array(a); s < a; s++)
      o[s] = n[s];
    return o;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(arrayLikeToArray);
var arrayLikeToArrayExports = arrayLikeToArray.exports;
(function(t) {
  var r = arrayLikeToArrayExports;
  function n(a, s) {
    if (a) {
      if (typeof a == "string")
        return r(a, s);
      var o = {}.toString.call(a).slice(8, -1);
      return o === "Object" && a.constructor && (o = a.constructor.name), o === "Map" || o === "Set" ? Array.from(a) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? r(a, s) : void 0;
    }
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})(unsupportedIterableToArray);
var unsupportedIterableToArrayExports = unsupportedIterableToArray.exports, nonIterableRest = { exports: {} };
(function(t) {
  function r() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(nonIterableRest);
var nonIterableRestExports = nonIterableRest.exports;
(function(t) {
  var r = arrayWithHolesExports, n = iterableToArrayExports, a = unsupportedIterableToArrayExports, s = nonIterableRestExports;
  function o(c) {
    return r(c) || n(c) || a(c) || s();
  }
  t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
})(toArray);
var toArrayExports = toArray.exports, _typeof = _typeofExports, _classCallCheck = classCallCheckExports, _createClass = createClassExports, _assertThisInitialized = assertThisInitializedExports, _inherits = inheritsExports, _possibleConstructorReturn = possibleConstructorReturnExports, _getPrototypeOf = getPrototypeOfExports, _defineProperty$2 = definePropertyExports, _toArray = toArrayExports;
function _interopDefaultLegacy(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var _typeof__default = /* @__PURE__ */ _interopDefaultLegacy(_typeof), _classCallCheck__default = /* @__PURE__ */ _interopDefaultLegacy(_classCallCheck), _createClass__default = /* @__PURE__ */ _interopDefaultLegacy(_createClass), _assertThisInitialized__default = /* @__PURE__ */ _interopDefaultLegacy(_assertThisInitialized), _inherits__default = /* @__PURE__ */ _interopDefaultLegacy(_inherits), _possibleConstructorReturn__default = /* @__PURE__ */ _interopDefaultLegacy(_possibleConstructorReturn), _getPrototypeOf__default = /* @__PURE__ */ _interopDefaultLegacy(_getPrototypeOf), _defineProperty__default = /* @__PURE__ */ _interopDefaultLegacy(_defineProperty$2), _toArray__default = /* @__PURE__ */ _interopDefaultLegacy(_toArray);
function ownKeys$3(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$2(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(n), !0).forEach(function(a) {
      _defineProperty__default.default(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$3(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
var consoleLogger = {
  type: "logger",
  log: function(r) {
    this.output("log", r);
  },
  warn: function(r) {
    this.output("warn", r);
  },
  error: function(r) {
    this.output("error", r);
  },
  output: function(r, n) {
    console && console[r] && console[r].apply(console, n);
  }
}, Logger = function() {
  function t(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck__default.default(this, t), this.init(r, n);
  }
  return _createClass__default.default(t, [{
    key: "init",
    value: function(n) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = a.prefix || "i18next:", this.logger = n || consoleLogger, this.options = a, this.debug = a.debug;
    }
  }, {
    key: "setDebug",
    value: function(n) {
      this.debug = n;
    }
  }, {
    key: "log",
    value: function() {
      for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
        a[s] = arguments[s];
      return this.forward(a, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
        a[s] = arguments[s];
      return this.forward(a, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
        a[s] = arguments[s];
      return this.forward(a, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
        a[s] = arguments[s];
      return this.forward(a, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(n, a, s, o) {
      return o && !this.debug ? null : (typeof n[0] == "string" && (n[0] = "".concat(s).concat(this.prefix, " ").concat(n[0])), this.logger[a](n));
    }
  }, {
    key: "create",
    value: function(n) {
      return new t(this.logger, _objectSpread$2(_objectSpread$2({}, {
        prefix: "".concat(this.prefix, ":").concat(n, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function(n) {
      return n = n || this.options, n.prefix = n.prefix || this.prefix, new t(this.logger, n);
    }
  }]), t;
}(), baseLogger = new Logger(), EventEmitter = function() {
  function t() {
    _classCallCheck__default.default(this, t), this.observers = {};
  }
  return _createClass__default.default(t, [{
    key: "on",
    value: function(n, a) {
      var s = this;
      return n.split(" ").forEach(function(o) {
        s.observers[o] = s.observers[o] || [], s.observers[o].push(a);
      }), this;
    }
  }, {
    key: "off",
    value: function(n, a) {
      if (this.observers[n]) {
        if (!a) {
          delete this.observers[n];
          return;
        }
        this.observers[n] = this.observers[n].filter(function(s) {
          return s !== a;
        });
      }
    }
  }, {
    key: "emit",
    value: function(n) {
      for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++)
        s[o - 1] = arguments[o];
      if (this.observers[n]) {
        var c = [].concat(this.observers[n]);
        c.forEach(function(d) {
          d.apply(void 0, s);
        });
      }
      if (this.observers["*"]) {
        var l = [].concat(this.observers["*"]);
        l.forEach(function(d) {
          d.apply(d, [n].concat(s));
        });
      }
    }
  }]), t;
}();
function defer$1() {
  var t, r, n = new Promise(function(a, s) {
    t = a, r = s;
  });
  return n.resolve = t, n.reject = r, n;
}
function makeString$1(t) {
  return t == null ? "" : "" + t;
}
function copy$1(t, r, n) {
  t.forEach(function(a) {
    r[a] && (n[a] = r[a]);
  });
}
function getLastOfPath$1(t, r, n) {
  function a(l) {
    return l && l.indexOf("###") > -1 ? l.replace(/###/g, ".") : l;
  }
  function s() {
    return !t || typeof t == "string";
  }
  for (var o = typeof r != "string" ? [].concat(r) : r.split("."); o.length > 1; ) {
    if (s())
      return {};
    var c = a(o.shift());
    !t[c] && n && (t[c] = new n()), Object.prototype.hasOwnProperty.call(t, c) ? t = t[c] : t = {};
  }
  return s() ? {} : {
    obj: t,
    k: a(o.shift())
  };
}
function setPath$1(t, r, n) {
  var a = getLastOfPath$1(t, r, Object), s = a.obj, o = a.k;
  s[o] = n;
}
function pushPath$1(t, r, n, a) {
  var s = getLastOfPath$1(t, r, Object), o = s.obj, c = s.k;
  o[c] = o[c] || [], a && (o[c] = o[c].concat(n)), a || o[c].push(n);
}
function getPath$1(t, r) {
  var n = getLastOfPath$1(t, r), a = n.obj, s = n.k;
  if (a)
    return a[s];
}
function getPathWithDefaults(t, r, n) {
  var a = getPath$1(t, n);
  return a !== void 0 ? a : getPath$1(r, n);
}
function deepExtend(t, r, n) {
  for (var a in r)
    a !== "__proto__" && a !== "constructor" && (a in t ? typeof t[a] == "string" || t[a] instanceof String || typeof r[a] == "string" || r[a] instanceof String ? n && (t[a] = r[a]) : deepExtend(t[a], r[a], n) : t[a] = r[a]);
  return t;
}
function regexEscape(t) {
  return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function escape(t) {
  return typeof t == "string" ? t.replace(/[&<>"'\/]/g, function(r) {
    return _entityMap[r];
  }) : t;
}
var isIE10 = typeof window < "u" && window.navigator && typeof window.navigator.userAgentData > "u" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, chars = [" ", ",", "?", "!", ";"];
function looksLikeObjectPath(t, r, n) {
  r = r || "", n = n || "";
  var a = chars.filter(function(l) {
    return r.indexOf(l) < 0 && n.indexOf(l) < 0;
  });
  if (a.length === 0)
    return !0;
  var s = new RegExp("(".concat(a.map(function(l) {
    return l === "?" ? "\\?" : l;
  }).join("|"), ")")), o = !s.test(t);
  if (!o) {
    var c = t.indexOf(n);
    c > 0 && !s.test(t.substring(0, c)) && (o = !0);
  }
  return o;
}
function ownKeys$1$1(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$1$1(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$1$1(Object(n), !0).forEach(function(a) {
      _defineProperty__default.default(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$1$1(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function() {
    var a = _getPrototypeOf__default.default(t), s;
    if (r) {
      var o = _getPrototypeOf__default.default(this).constructor;
      s = Reflect.construct(a, arguments, o);
    } else
      s = a.apply(this, arguments);
    return _possibleConstructorReturn__default.default(this, s);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function deepFind(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (t) {
    if (t[r])
      return t[r];
    for (var a = r.split(n), s = t, o = 0; o < a.length; ++o) {
      if (!s || typeof s[a[o]] == "string" && o + 1 < a.length)
        return;
      if (s[a[o]] === void 0) {
        for (var c = 2, l = a.slice(o, o + c).join(n), d = s[l]; d === void 0 && a.length > o + c; )
          c++, l = a.slice(o, o + c).join(n), d = s[l];
        if (d === void 0)
          return;
        if (d === null)
          return null;
        if (r.endsWith(l)) {
          if (typeof d == "string")
            return d;
          if (l && typeof d[l] == "string")
            return d[l];
        }
        var h = a.slice(o + c).join(n);
        return h ? deepFind(d, h, n) : void 0;
      }
      s = s[a[o]];
    }
    return s;
  }
}
var ResourceStore = function(t) {
  _inherits__default.default(n, t);
  var r = _createSuper(n);
  function n(a) {
    var s, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return _classCallCheck__default.default(this, n), s = r.call(this), isIE10 && EventEmitter.call(_assertThisInitialized__default.default(s)), s.data = a || {}, s.options = o, s.options.keySeparator === void 0 && (s.options.keySeparator = "."), s.options.ignoreJSONStructure === void 0 && (s.options.ignoreJSONStructure = !0), s;
  }
  return _createClass__default.default(n, [{
    key: "addNamespaces",
    value: function(s) {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }
  }, {
    key: "removeNamespaces",
    value: function(s) {
      var o = this.options.ns.indexOf(s);
      o > -1 && this.options.ns.splice(o, 1);
    }
  }, {
    key: "getResource",
    value: function(s, o, c) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, d = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator, h = l.ignoreJSONStructure !== void 0 ? l.ignoreJSONStructure : this.options.ignoreJSONStructure, u = [s, o];
      c && typeof c != "string" && (u = u.concat(c)), c && typeof c == "string" && (u = u.concat(d ? c.split(d) : c)), s.indexOf(".") > -1 && (u = s.split("."));
      var p = getPath$1(this.data, u);
      return p || !h || typeof c != "string" ? p : deepFind(this.data && this.data[s] && this.data[s][o], c, d);
    }
  }, {
    key: "addResource",
    value: function(s, o, c, l) {
      var d = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, h = this.options.keySeparator;
      h === void 0 && (h = ".");
      var u = [s, o];
      c && (u = u.concat(h ? c.split(h) : c)), s.indexOf(".") > -1 && (u = s.split("."), l = o, o = u[1]), this.addNamespaces(o), setPath$1(this.data, u, l), d.silent || this.emit("added", s, o, c, l);
    }
  }, {
    key: "addResources",
    value: function(s, o, c) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var d in c)
        (typeof c[d] == "string" || Object.prototype.toString.apply(c[d]) === "[object Array]") && this.addResource(s, o, d, c[d], {
          silent: !0
        });
      l.silent || this.emit("added", s, o, c);
    }
  }, {
    key: "addResourceBundle",
    value: function(s, o, c, l, d) {
      var h = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, u = [s, o];
      s.indexOf(".") > -1 && (u = s.split("."), l = c, c = o, o = u[1]), this.addNamespaces(o);
      var p = getPath$1(this.data, u) || {};
      l ? deepExtend(p, c, d) : p = _objectSpread$1$1(_objectSpread$1$1({}, p), c), setPath$1(this.data, u, p), h.silent || this.emit("added", s, o, c);
    }
  }, {
    key: "removeResourceBundle",
    value: function(s, o) {
      this.hasResourceBundle(s, o) && delete this.data[s][o], this.removeNamespaces(o), this.emit("removed", s, o);
    }
  }, {
    key: "hasResourceBundle",
    value: function(s, o) {
      return this.getResource(s, o) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(s, o) {
      return o || (o = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? _objectSpread$1$1(_objectSpread$1$1({}, {}), this.getResource(s, o)) : this.getResource(s, o);
    }
  }, {
    key: "getDataByLanguage",
    value: function(s) {
      return this.data[s];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function(s) {
      var o = this.getDataByLanguage(s), c = o && Object.keys(o) || [];
      return !!c.find(function(l) {
        return o[l] && Object.keys(o[l]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), n;
}(EventEmitter), postProcessor = {
  processors: {},
  addPostProcessor: function(r) {
    this.processors[r.name] = r;
  },
  handle: function(r, n, a, s, o) {
    var c = this;
    return r.forEach(function(l) {
      c.processors[l] && (n = c.processors[l].process(n, a, s, o));
    }), n;
  }
};
function ownKeys$2$1(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$2$1(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$2$1(Object(n), !0).forEach(function(a) {
      _defineProperty__default.default(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$2$1(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _createSuper$1(t) {
  var r = _isNativeReflectConstruct$1();
  return function() {
    var a = _getPrototypeOf__default.default(t), s;
    if (r) {
      var o = _getPrototypeOf__default.default(this).constructor;
      s = Reflect.construct(a, arguments, o);
    } else
      s = a.apply(this, arguments);
    return _possibleConstructorReturn__default.default(this, s);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var checkedLoadedFor = {}, Translator = function(t) {
  _inherits__default.default(n, t);
  var r = _createSuper$1(n);
  function n(a) {
    var s, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return _classCallCheck__default.default(this, n), s = r.call(this), isIE10 && EventEmitter.call(_assertThisInitialized__default.default(s)), copy$1(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], a, _assertThisInitialized__default.default(s)), s.options = o, s.options.keySeparator === void 0 && (s.options.keySeparator = "."), s.logger = baseLogger.create("translator"), s;
  }
  return _createClass__default.default(n, [{
    key: "changeLanguage",
    value: function(s) {
      s && (this.language = s);
    }
  }, {
    key: "exists",
    value: function(s) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (s == null)
        return !1;
      var c = this.resolve(s, o);
      return c && c.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(s, o) {
      var c = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
      c === void 0 && (c = ":");
      var l = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, d = o.ns || this.options.defaultNS || [], h = c && s.indexOf(c) > -1, u = !this.options.userDefinedKeySeparator && !o.keySeparator && !this.options.userDefinedNsSeparator && !o.nsSeparator && !looksLikeObjectPath(s, c, l);
      if (h && !u) {
        var p = s.match(this.interpolator.nestingRegexp);
        if (p && p.length > 0)
          return {
            key: s,
            namespaces: d
          };
        var m = s.split(c);
        (c !== l || c === l && this.options.ns.indexOf(m[0]) > -1) && (d = m.shift()), s = m.join(l);
      }
      return typeof d == "string" && (d = [d]), {
        key: s,
        namespaces: d
      };
    }
  }, {
    key: "translate",
    value: function(s, o, c) {
      var l = this;
      if (_typeof__default.default(o) !== "object" && this.options.overloadTranslationOptionHandler && (o = this.options.overloadTranslationOptionHandler(arguments)), o || (o = {}), s == null)
        return "";
      Array.isArray(s) || (s = [String(s)]);
      var d = o.returnDetails !== void 0 ? o.returnDetails : this.options.returnDetails, h = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, u = this.extractFromKey(s[s.length - 1], o), p = u.key, m = u.namespaces, g = m[m.length - 1], v = o.lng || this.language, y = o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (v && v.toLowerCase() === "cimode") {
        if (y) {
          var x = o.nsSeparator || this.options.nsSeparator;
          return d ? (_.res = "".concat(g).concat(x).concat(p), _) : "".concat(g).concat(x).concat(p);
        }
        return d ? (_.res = p, _) : p;
      }
      var _ = this.resolve(s, o), $ = _ && _.res, b = _ && _.usedKey || p, M = _ && _.exactUsedKey || p, C = Object.prototype.toString.apply($), S = ["[object Number]", "[object Function]", "[object RegExp]"], A = o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays, D = !this.i18nFormat || this.i18nFormat.handleAsObject, N = typeof $ != "string" && typeof $ != "boolean" && typeof $ != "number";
      if (D && $ && N && S.indexOf(C) < 0 && !(typeof A == "string" && C === "[object Array]")) {
        if (!o.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          var T = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(b, $, _objectSpread$2$1(_objectSpread$2$1({}, o), {}, {
            ns: m
          })) : "key '".concat(p, " (").concat(this.language, ")' returned an object instead of string.");
          return d ? (_.res = T, _) : T;
        }
        if (h) {
          var R = C === "[object Array]", F = R ? [] : {}, z = R ? M : b;
          for (var O in $)
            if (Object.prototype.hasOwnProperty.call($, O)) {
              var G = "".concat(z).concat(h).concat(O);
              F[O] = this.translate(G, _objectSpread$2$1(_objectSpread$2$1({}, o), {
                joinArrays: !1,
                ns: m
              })), F[O] === G && (F[O] = $[O]);
            }
          $ = F;
        }
      } else if (D && typeof A == "string" && C === "[object Array]")
        $ = $.join(A), $ && ($ = this.extendTranslation($, s, o, c));
      else {
        var I = !1, k = !1, B = o.count !== void 0 && typeof o.count != "string", L = n.hasDefaultValue(o), V = B ? this.pluralResolver.getSuffix(v, o.count, o) : "", U = o["defaultValue".concat(V)] || o.defaultValue;
        !this.isValidLookup($) && L && (I = !0, $ = U), this.isValidLookup($) || (k = !0, $ = p);
        var J = o.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey, q = J && k ? void 0 : $, Z = L && U !== $ && this.options.updateMissing;
        if (k || I || Z) {
          if (this.logger.log(Z ? "updateKey" : "missingKey", v, g, p, Z ? U : $), h) {
            var ae = this.resolve(p, _objectSpread$2$1(_objectSpread$2$1({}, o), {}, {
              keySeparator: !1
            }));
            ae && ae.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var ee = [], se = this.languageUtils.getFallbackCodes(this.options.fallbackLng, o.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && se && se[0])
            for (var nr = 0; nr < se.length; nr++)
              ee.push(se[nr]);
          else
            this.options.saveMissingTo === "all" ? ee = this.languageUtils.toResolveHierarchy(o.lng || this.language) : ee.push(o.lng || this.language);
          var ce = function(ur, ir, _r) {
            var yr = L && _r !== $ ? _r : q;
            l.options.missingKeyHandler ? l.options.missingKeyHandler(ur, g, ir, yr, Z, o) : l.backendConnector && l.backendConnector.saveMissing && l.backendConnector.saveMissing(ur, g, ir, yr, Z, o), l.emit("missingKey", ur, g, ir, $);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && B ? ee.forEach(function(oe) {
            l.pluralResolver.getSuffixes(oe, o).forEach(function(ur) {
              ce([oe], p + ur, o["defaultValue".concat(ur)] || U);
            });
          }) : ce(ee, p, U));
        }
        $ = this.extendTranslation($, s, o, _, c), k && $ === p && this.options.appendNamespaceToMissingKey && ($ = "".concat(g, ":").concat(p)), (k || I) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? $ = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(g, ":").concat(p) : p, I ? $ : void 0) : $ = this.options.parseMissingKeyHandler($));
      }
      return d ? (_.res = $, _) : $;
    }
  }, {
    key: "extendTranslation",
    value: function(s, o, c, l, d) {
      var h = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        s = this.i18nFormat.parse(s, _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), c), l.usedLng, l.usedNS, l.usedKey, {
          resolved: l
        });
      else if (!c.skipInterpolation) {
        c.interpolation && this.interpolator.init(_objectSpread$2$1(_objectSpread$2$1({}, c), {
          interpolation: _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation), c.interpolation)
        }));
        var u = typeof s == "string" && (c && c.interpolation && c.interpolation.skipOnVariables !== void 0 ? c.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables), p;
        if (u) {
          var m = s.match(this.interpolator.nestingRegexp);
          p = m && m.length;
        }
        var g = c.replace && typeof c.replace != "string" ? c.replace : c;
        if (this.options.interpolation.defaultVariables && (g = _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), g)), s = this.interpolator.interpolate(s, g, c.lng || this.language, c), u) {
          var v = s.match(this.interpolator.nestingRegexp), y = v && v.length;
          p < y && (c.nest = !1);
        }
        c.nest !== !1 && (s = this.interpolator.nest(s, function() {
          for (var $ = arguments.length, b = new Array($), M = 0; M < $; M++)
            b[M] = arguments[M];
          return d && d[0] === b[0] && !c.context ? (h.logger.warn("It seems you are nesting recursively key: ".concat(b[0], " in key: ").concat(o[0])), null) : h.translate.apply(h, b.concat([o]));
        }, c)), c.interpolation && this.interpolator.reset();
      }
      var x = c.postProcess || this.options.postProcess, _ = typeof x == "string" ? [x] : x;
      return s != null && _ && _.length && c.applyPostProcessor !== !1 && (s = postProcessor.handle(_, s, o, this.options && this.options.postProcessPassResolved ? _objectSpread$2$1({
        i18nResolved: l
      }, c) : c, this)), s;
    }
  }, {
    key: "resolve",
    value: function(s) {
      var o = this, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l, d, h, u, p;
      return typeof s == "string" && (s = [s]), s.forEach(function(m) {
        if (!o.isValidLookup(l)) {
          var g = o.extractFromKey(m, c), v = g.key;
          d = v;
          var y = g.namespaces;
          o.options.fallbackNS && (y = y.concat(o.options.fallbackNS));
          var x = c.count !== void 0 && typeof c.count != "string", _ = x && !c.ordinal && c.count === 0 && o.pluralResolver.shouldUseIntlApi(), $ = c.context !== void 0 && (typeof c.context == "string" || typeof c.context == "number") && c.context !== "", b = c.lngs ? c.lngs : o.languageUtils.toResolveHierarchy(c.lng || o.language, c.fallbackLng);
          y.forEach(function(M) {
            o.isValidLookup(l) || (p = M, !checkedLoadedFor["".concat(b[0], "-").concat(M)] && o.utils && o.utils.hasLoadedNamespace && !o.utils.hasLoadedNamespace(p) && (checkedLoadedFor["".concat(b[0], "-").concat(M)] = !0, o.logger.warn('key "'.concat(d, '" for languages "').concat(b.join(", "), `" won't get resolved as namespace "`).concat(p, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), b.forEach(function(C) {
              if (!o.isValidLookup(l)) {
                u = C;
                var S = [v];
                if (o.i18nFormat && o.i18nFormat.addLookupKeys)
                  o.i18nFormat.addLookupKeys(S, v, C, M, c);
                else {
                  var A;
                  x && (A = o.pluralResolver.getSuffix(C, c.count, c));
                  var D = "".concat(o.options.pluralSeparator, "zero");
                  if (x && (S.push(v + A), _ && S.push(v + D)), $) {
                    var N = "".concat(v).concat(o.options.contextSeparator).concat(c.context);
                    S.push(N), x && (S.push(N + A), _ && S.push(N + D));
                  }
                }
                for (var T; T = S.pop(); )
                  o.isValidLookup(l) || (h = T, l = o.getResource(C, M, T, c));
              }
            }));
          });
        }
      }), {
        res: l,
        usedKey: d,
        exactUsedKey: h,
        usedLng: u,
        usedNS: p
      };
    }
  }, {
    key: "isValidLookup",
    value: function(s) {
      return s !== void 0 && !(!this.options.returnNull && s === null) && !(!this.options.returnEmptyString && s === "");
    }
  }, {
    key: "getResource",
    value: function(s, o, c) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(s, o, c, l) : this.resourceStore.getResource(s, o, c, l);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(s) {
      var o = "defaultValue";
      for (var c in s)
        if (Object.prototype.hasOwnProperty.call(s, c) && o === c.substring(0, o.length) && s[c] !== void 0)
          return !0;
      return !1;
    }
  }]), n;
}(EventEmitter);
function capitalize(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
var LanguageUtil = function() {
  function t(r) {
    _classCallCheck__default.default(this, t), this.options = r, this.supportedLngs = this.options.supportedLngs || !1, this.logger = baseLogger.create("languageUtils");
  }
  return _createClass__default.default(t, [{
    key: "getScriptPartFromCode",
    value: function(n) {
      if (!n || n.indexOf("-") < 0)
        return null;
      var a = n.split("-");
      return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(n) {
      if (!n || n.indexOf("-") < 0)
        return n;
      var a = n.split("-");
      return this.formatLanguageCode(a[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(n) {
      if (typeof n == "string" && n.indexOf("-") > -1) {
        var a = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], s = n.split("-");
        return this.options.lowerCaseLng ? s = s.map(function(o) {
          return o.toLowerCase();
        }) : s.length === 2 ? (s[0] = s[0].toLowerCase(), s[1] = s[1].toUpperCase(), a.indexOf(s[1].toLowerCase()) > -1 && (s[1] = capitalize(s[1].toLowerCase()))) : s.length === 3 && (s[0] = s[0].toLowerCase(), s[1].length === 2 && (s[1] = s[1].toUpperCase()), s[0] !== "sgn" && s[2].length === 2 && (s[2] = s[2].toUpperCase()), a.indexOf(s[1].toLowerCase()) > -1 && (s[1] = capitalize(s[1].toLowerCase())), a.indexOf(s[2].toLowerCase()) > -1 && (s[2] = capitalize(s[2].toLowerCase()))), s.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? n.toLowerCase() : n;
    }
  }, {
    key: "isSupportedCode",
    value: function(n) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (n = this.getLanguagePartFromCode(n)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(n) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(n) {
      var a = this;
      if (!n)
        return null;
      var s;
      return n.forEach(function(o) {
        if (!s) {
          var c = a.formatLanguageCode(o);
          (!a.options.supportedLngs || a.isSupportedCode(c)) && (s = c);
        }
      }), !s && this.options.supportedLngs && n.forEach(function(o) {
        if (!s) {
          var c = a.getLanguagePartFromCode(o);
          if (a.isSupportedCode(c))
            return s = c;
          s = a.options.supportedLngs.find(function(l) {
            if (l.indexOf(c) === 0)
              return l;
          });
        }
      }), s || (s = this.getFallbackCodes(this.options.fallbackLng)[0]), s;
    }
  }, {
    key: "getFallbackCodes",
    value: function(n, a) {
      if (!n)
        return [];
      if (typeof n == "function" && (n = n(a)), typeof n == "string" && (n = [n]), Object.prototype.toString.apply(n) === "[object Array]")
        return n;
      if (!a)
        return n.default || [];
      var s = n[a];
      return s || (s = n[this.getScriptPartFromCode(a)]), s || (s = n[this.formatLanguageCode(a)]), s || (s = n[this.getLanguagePartFromCode(a)]), s || (s = n.default), s || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(n, a) {
      var s = this, o = this.getFallbackCodes(a || this.options.fallbackLng || [], n), c = [], l = function(h) {
        h && (s.isSupportedCode(h) ? c.push(h) : s.logger.warn("rejecting language code not found in supportedLngs: ".concat(h)));
      };
      return typeof n == "string" && n.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && l(this.formatLanguageCode(n)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && l(this.getScriptPartFromCode(n)), this.options.load !== "currentOnly" && l(this.getLanguagePartFromCode(n))) : typeof n == "string" && l(this.formatLanguageCode(n)), o.forEach(function(d) {
        c.indexOf(d) < 0 && l(s.formatLanguageCode(d));
      }), c;
    }
  }]), t;
}(), sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], _rulesPluralsTypes = {
  1: function(r) {
    return +(r > 1);
  },
  2: function(r) {
    return +(r != 1);
  },
  3: function(r) {
    return 0;
  },
  4: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  5: function(r) {
    return r == 0 ? 0 : r == 1 ? 1 : r == 2 ? 2 : r % 100 >= 3 && r % 100 <= 10 ? 3 : r % 100 >= 11 ? 4 : 5;
  },
  6: function(r) {
    return r == 1 ? 0 : r >= 2 && r <= 4 ? 1 : 2;
  },
  7: function(r) {
    return r == 1 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  8: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r != 8 && r != 11 ? 2 : 3;
  },
  9: function(r) {
    return +(r >= 2);
  },
  10: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r < 7 ? 2 : r < 11 ? 3 : 4;
  },
  11: function(r) {
    return r == 1 || r == 11 ? 0 : r == 2 || r == 12 ? 1 : r > 2 && r < 20 ? 2 : 3;
  },
  12: function(r) {
    return +(r % 10 != 1 || r % 100 == 11);
  },
  13: function(r) {
    return +(r !== 0);
  },
  14: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r == 3 ? 2 : 3;
  },
  15: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  16: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r !== 0 ? 1 : 2;
  },
  17: function(r) {
    return r == 1 || r % 10 == 1 && r % 100 != 11 ? 0 : 1;
  },
  18: function(r) {
    return r == 0 ? 0 : r == 1 ? 1 : 2;
  },
  19: function(r) {
    return r == 1 ? 0 : r == 0 || r % 100 > 1 && r % 100 < 11 ? 1 : r % 100 > 10 && r % 100 < 20 ? 2 : 3;
  },
  20: function(r) {
    return r == 1 ? 0 : r == 0 || r % 100 > 0 && r % 100 < 20 ? 1 : 2;
  },
  21: function(r) {
    return r % 100 == 1 ? 1 : r % 100 == 2 ? 2 : r % 100 == 3 || r % 100 == 4 ? 3 : 0;
  },
  22: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : (r < 0 || r > 10) && r % 10 == 0 ? 2 : 3;
  }
}, deprecatedJsonVersions = ["v1", "v2", "v3"], suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var t = {};
  return sets.forEach(function(r) {
    r.lngs.forEach(function(n) {
      t[n] = {
        numbers: r.nr,
        plurals: _rulesPluralsTypes[r.fc]
      };
    });
  }), t;
}
var PluralResolver = function() {
  function t(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck__default.default(this, t), this.languageUtils = r, this.options = n, this.logger = baseLogger.create("pluralResolver"), (!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = createRules();
  }
  return _createClass__default.default(t, [{
    key: "addRule",
    value: function(n, a) {
      this.rules[n] = a;
    }
  }, {
    key: "getRule",
    value: function(n) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi())
        try {
          return new Intl.PluralRules(n, {
            type: a.ordinal ? "ordinal" : "cardinal"
          });
        } catch {
          return;
        }
      return this.rules[n] || this.rules[this.languageUtils.getLanguagePartFromCode(n)];
    }
  }, {
    key: "needsPlural",
    value: function(n) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = this.getRule(n, a);
      return this.shouldUseIntlApi() ? s && s.resolvedOptions().pluralCategories.length > 1 : s && s.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(n, a) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(n, s).map(function(o) {
        return "".concat(a).concat(o);
      });
    }
  }, {
    key: "getSuffixes",
    value: function(n) {
      var a = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = this.getRule(n, s);
      return o ? this.shouldUseIntlApi() ? o.resolvedOptions().pluralCategories.sort(function(c, l) {
        return suffixesOrder[c] - suffixesOrder[l];
      }).map(function(c) {
        return "".concat(a.options.prepend).concat(c);
      }) : o.numbers.map(function(c) {
        return a.getSuffix(n, c, s);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(n, a) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = this.getRule(n, s);
      return o ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(o.select(a)) : this.getSuffixRetroCompatible(o, a) : (this.logger.warn("no plural rule found for: ".concat(n)), "");
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function(n, a) {
      var s = this, o = n.noAbs ? n.plurals(a) : n.plurals(Math.abs(a)), c = n.numbers[o];
      this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 && (c === 2 ? c = "plural" : c === 1 && (c = ""));
      var l = function() {
        return s.options.prepend && c.toString() ? s.options.prepend + c.toString() : c.toString();
      };
      return this.options.compatibilityJSON === "v1" ? c === 1 ? "" : typeof c == "number" ? "_plural_".concat(c.toString()) : l() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 ? l() : this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]), t;
}();
function ownKeys$3$1(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$3(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$3$1(Object(n), !0).forEach(function(a) {
      _defineProperty__default.default(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$3$1(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
var Interpolator = function() {
  function t() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck__default.default(this, t), this.logger = baseLogger.create("interpolator"), this.options = r, this.format = r.interpolation && r.interpolation.format || function(n) {
      return n;
    }, this.init(r);
  }
  return _createClass__default.default(t, [{
    key: "init",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      n.interpolation || (n.interpolation = {
        escapeValue: !0
      });
      var a = n.interpolation;
      this.escape = a.escape !== void 0 ? a.escape : escape, this.escapeValue = a.escapeValue !== void 0 ? a.escapeValue : !0, this.useRawValueToEscape = a.useRawValueToEscape !== void 0 ? a.useRawValueToEscape : !1, this.prefix = a.prefix ? regexEscape(a.prefix) : a.prefixEscaped || "{{", this.suffix = a.suffix ? regexEscape(a.suffix) : a.suffixEscaped || "}}", this.formatSeparator = a.formatSeparator ? a.formatSeparator : a.formatSeparator || ",", this.unescapePrefix = a.unescapeSuffix ? "" : a.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : a.unescapeSuffix || "", this.nestingPrefix = a.nestingPrefix ? regexEscape(a.nestingPrefix) : a.nestingPrefixEscaped || regexEscape("$t("), this.nestingSuffix = a.nestingSuffix ? regexEscape(a.nestingSuffix) : a.nestingSuffixEscaped || regexEscape(")"), this.nestingOptionsSeparator = a.nestingOptionsSeparator ? a.nestingOptionsSeparator : a.nestingOptionsSeparator || ",", this.maxReplaces = a.maxReplaces ? a.maxReplaces : 1e3, this.alwaysFormat = a.alwaysFormat !== void 0 ? a.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var n = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(n, "g");
      var a = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(a, "g");
      var s = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(s, "g");
    }
  }, {
    key: "interpolate",
    value: function(n, a, s, o) {
      var c = this, l, d, h, u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function p(x) {
        return x.replace(/\$/g, "$$$$");
      }
      var m = function(_) {
        if (_.indexOf(c.formatSeparator) < 0) {
          var $ = getPathWithDefaults(a, u, _);
          return c.alwaysFormat ? c.format($, void 0, s, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, o), a), {}, {
            interpolationkey: _
          })) : $;
        }
        var b = _.split(c.formatSeparator), M = b.shift().trim(), C = b.join(c.formatSeparator).trim();
        return c.format(getPathWithDefaults(a, u, M), C, s, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, o), a), {}, {
          interpolationkey: M
        }));
      };
      this.resetRegExp();
      var g = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, v = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, y = [{
        regex: this.regexpUnescape,
        safeValue: function(_) {
          return p(_);
        }
      }, {
        regex: this.regexp,
        safeValue: function(_) {
          return c.escapeValue ? p(c.escape(_)) : p(_);
        }
      }];
      return y.forEach(function(x) {
        for (h = 0; l = x.regex.exec(n); ) {
          var _ = l[1].trim();
          if (d = m(_), d === void 0)
            if (typeof g == "function") {
              var $ = g(n, l, o);
              d = typeof $ == "string" ? $ : "";
            } else if (o && o.hasOwnProperty(_))
              d = "";
            else if (v) {
              d = l[0];
              continue;
            } else
              c.logger.warn("missed to pass in variable ".concat(_, " for interpolating ").concat(n)), d = "";
          else
            typeof d != "string" && !c.useRawValueToEscape && (d = makeString$1(d));
          var b = x.safeValue(d);
          if (n = n.replace(l[0], b), v ? (x.regex.lastIndex += d.length, x.regex.lastIndex -= l[0].length) : x.regex.lastIndex = 0, h++, h >= c.maxReplaces)
            break;
        }
      }), n;
    }
  }, {
    key: "nest",
    value: function(n, a) {
      var s = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, c, l, d = _objectSpread$3({}, o);
      d.applyPostProcessor = !1, delete d.defaultValue;
      function h(g, v) {
        var y = this.nestingOptionsSeparator;
        if (g.indexOf(y) < 0)
          return g;
        var x = g.split(new RegExp("".concat(y, "[ ]*{"))), _ = "{".concat(x[1]);
        g = x[0], _ = this.interpolate(_, d);
        var $ = _.match(/'/g), b = _.match(/"/g);
        ($ && $.length % 2 === 0 && !b || b.length % 2 !== 0) && (_ = _.replace(/'/g, '"'));
        try {
          d = JSON.parse(_), v && (d = _objectSpread$3(_objectSpread$3({}, v), d));
        } catch (M) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(g), M), "".concat(g).concat(y).concat(_);
        }
        return delete d.defaultValue, g;
      }
      for (; c = this.nestingRegexp.exec(n); ) {
        var u = [], p = !1;
        if (c[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(c[1])) {
          var m = c[1].split(this.formatSeparator).map(function(g) {
            return g.trim();
          });
          c[1] = m.shift(), u = m, p = !0;
        }
        if (l = a(h.call(this, c[1].trim(), d), d), l && c[0] === n && typeof l != "string")
          return l;
        typeof l != "string" && (l = makeString$1(l)), l || (this.logger.warn("missed to resolve ".concat(c[1], " for nesting ").concat(n)), l = ""), p && (l = u.reduce(function(g, v) {
          return s.format(g, v, o.lng, _objectSpread$3(_objectSpread$3({}, o), {}, {
            interpolationkey: c[1].trim()
          }));
        }, l.trim())), n = n.replace(c[0], l), this.regexp.lastIndex = 0;
      }
      return n;
    }
  }]), t;
}();
function ownKeys$4(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$4(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$4(Object(n), !0).forEach(function(a) {
      _defineProperty__default.default(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$4(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function parseFormatStr(t) {
  var r = t.toLowerCase().trim(), n = {};
  if (t.indexOf("(") > -1) {
    var a = t.split("(");
    r = a[0].toLowerCase().trim();
    var s = a[1].substring(0, a[1].length - 1);
    if (r === "currency" && s.indexOf(":") < 0)
      n.currency || (n.currency = s.trim());
    else if (r === "relativetime" && s.indexOf(":") < 0)
      n.range || (n.range = s.trim());
    else {
      var o = s.split(";");
      o.forEach(function(c) {
        if (c) {
          var l = c.split(":"), d = _toArray__default.default(l), h = d[0], u = d.slice(1), p = u.join(":").trim().replace(/^'+|'+$/g, "");
          n[h.trim()] || (n[h.trim()] = p), p === "false" && (n[h.trim()] = !1), p === "true" && (n[h.trim()] = !0), isNaN(p) || (n[h.trim()] = parseInt(p, 10));
        }
      });
    }
  }
  return {
    formatName: r,
    formatOptions: n
  };
}
function createCachedFormatter(t) {
  var r = {};
  return function(a, s, o) {
    var c = s + JSON.stringify(o), l = r[c];
    return l || (l = t(s, o), r[c] = l), l(a);
  };
}
var Formatter = function() {
  function t() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck__default.default(this, t), this.logger = baseLogger.create("formatter"), this.options = r, this.formats = {
      number: createCachedFormatter(function(n, a) {
        var s = new Intl.NumberFormat(n, a);
        return function(o) {
          return s.format(o);
        };
      }),
      currency: createCachedFormatter(function(n, a) {
        var s = new Intl.NumberFormat(n, _objectSpread$4(_objectSpread$4({}, a), {}, {
          style: "currency"
        }));
        return function(o) {
          return s.format(o);
        };
      }),
      datetime: createCachedFormatter(function(n, a) {
        var s = new Intl.DateTimeFormat(n, _objectSpread$4({}, a));
        return function(o) {
          return s.format(o);
        };
      }),
      relativetime: createCachedFormatter(function(n, a) {
        var s = new Intl.RelativeTimeFormat(n, _objectSpread$4({}, a));
        return function(o) {
          return s.format(o, a.range || "day");
        };
      }),
      list: createCachedFormatter(function(n, a) {
        var s = new Intl.ListFormat(n, _objectSpread$4({}, a));
        return function(o) {
          return s.format(o);
        };
      })
    }, this.init(r);
  }
  return _createClass__default.default(t, [{
    key: "init",
    value: function(n) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, s = a.interpolation;
      this.formatSeparator = s.formatSeparator ? s.formatSeparator : s.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function(n, a) {
      this.formats[n.toLowerCase().trim()] = a;
    }
  }, {
    key: "addCached",
    value: function(n, a) {
      this.formats[n.toLowerCase().trim()] = createCachedFormatter(a);
    }
  }, {
    key: "format",
    value: function(n, a, s, o) {
      var c = this, l = a.split(this.formatSeparator), d = l.reduce(function(h, u) {
        var p = parseFormatStr(u), m = p.formatName, g = p.formatOptions;
        if (c.formats[m]) {
          var v = h;
          try {
            var y = o && o.formatParams && o.formatParams[o.interpolationkey] || {}, x = y.locale || y.lng || o.locale || o.lng || s;
            v = c.formats[m](h, x, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, g), o), y));
          } catch (_) {
            c.logger.warn(_);
          }
          return v;
        } else
          c.logger.warn("there was no format function for ".concat(m));
        return h;
      }, n);
      return d;
    }
  }]), t;
}();
function ownKeys$5(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$5(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$5(Object(n), !0).forEach(function(a) {
      _defineProperty__default.default(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$5(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _createSuper$2(t) {
  var r = _isNativeReflectConstruct$2();
  return function() {
    var a = _getPrototypeOf__default.default(t), s;
    if (r) {
      var o = _getPrototypeOf__default.default(this).constructor;
      s = Reflect.construct(a, arguments, o);
    } else
      s = a.apply(this, arguments);
    return _possibleConstructorReturn__default.default(this, s);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function removePending(t, r) {
  t.pending[r] !== void 0 && (delete t.pending[r], t.pendingCount--);
}
var Connector = function(t) {
  _inherits__default.default(n, t);
  var r = _createSuper$2(n);
  function n(a, s, o) {
    var c, l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return _classCallCheck__default.default(this, n), c = r.call(this), isIE10 && EventEmitter.call(_assertThisInitialized__default.default(c)), c.backend = a, c.store = s, c.services = o, c.languageUtils = o.languageUtils, c.options = l, c.logger = baseLogger.create("backendConnector"), c.waitingReads = [], c.maxParallelReads = l.maxParallelReads || 10, c.readingCalls = 0, c.maxRetries = l.maxRetries >= 0 ? l.maxRetries : 5, c.retryTimeout = l.retryTimeout >= 1 ? l.retryTimeout : 350, c.state = {}, c.queue = [], c.backend && c.backend.init && c.backend.init(o, l.backend, l), c;
  }
  return _createClass__default.default(n, [{
    key: "queueLoad",
    value: function(s, o, c, l) {
      var d = this, h = {}, u = {}, p = {}, m = {};
      return s.forEach(function(g) {
        var v = !0;
        o.forEach(function(y) {
          var x = "".concat(g, "|").concat(y);
          !c.reload && d.store.hasResourceBundle(g, y) ? d.state[x] = 2 : d.state[x] < 0 || (d.state[x] === 1 ? u[x] === void 0 && (u[x] = !0) : (d.state[x] = 1, v = !1, u[x] === void 0 && (u[x] = !0), h[x] === void 0 && (h[x] = !0), m[y] === void 0 && (m[y] = !0)));
        }), v || (p[g] = !0);
      }), (Object.keys(h).length || Object.keys(u).length) && this.queue.push({
        pending: u,
        pendingCount: Object.keys(u).length,
        loaded: {},
        errors: [],
        callback: l
      }), {
        toLoad: Object.keys(h),
        pending: Object.keys(u),
        toLoadLanguages: Object.keys(p),
        toLoadNamespaces: Object.keys(m)
      };
    }
  }, {
    key: "loaded",
    value: function(s, o, c) {
      var l = s.split("|"), d = l[0], h = l[1];
      o && this.emit("failedLoading", d, h, o), c && this.store.addResourceBundle(d, h, c), this.state[s] = o ? -1 : 2;
      var u = {};
      this.queue.forEach(function(p) {
        pushPath$1(p.loaded, [d], h), removePending(p, s), o && p.errors.push(o), p.pendingCount === 0 && !p.done && (Object.keys(p.loaded).forEach(function(m) {
          u[m] || (u[m] = {});
          var g = p.loaded[m];
          g.length && g.forEach(function(v) {
            u[m][v] === void 0 && (u[m][v] = !0);
          });
        }), p.done = !0, p.errors.length ? p.callback(p.errors) : p.callback());
      }), this.emit("loaded", u), this.queue = this.queue.filter(function(p) {
        return !p.done;
      });
    }
  }, {
    key: "read",
    value: function(s, o, c) {
      var l = this, d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, u = arguments.length > 5 ? arguments[5] : void 0;
      if (!s.length)
        return u(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: s,
          ns: o,
          fcName: c,
          tried: d,
          wait: h,
          callback: u
        });
        return;
      }
      return this.readingCalls++, this.backend[c](s, o, function(p, m) {
        if (l.readingCalls--, l.waitingReads.length > 0) {
          var g = l.waitingReads.shift();
          l.read(g.lng, g.ns, g.fcName, g.tried, g.wait, g.callback);
        }
        if (p && m && d < l.maxRetries) {
          setTimeout(function() {
            l.read.call(l, s, o, c, d + 1, h * 2, u);
          }, h);
          return;
        }
        u(p, m);
      });
    }
  }, {
    key: "prepareLoading",
    value: function(s, o) {
      var c = this, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, d = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), d && d();
      typeof s == "string" && (s = this.languageUtils.toResolveHierarchy(s)), typeof o == "string" && (o = [o]);
      var h = this.queueLoad(s, o, l, d);
      if (!h.toLoad.length)
        return h.pending.length || d(), null;
      h.toLoad.forEach(function(u) {
        c.loadOne(u);
      });
    }
  }, {
    key: "load",
    value: function(s, o, c) {
      this.prepareLoading(s, o, {}, c);
    }
  }, {
    key: "reload",
    value: function(s, o, c) {
      this.prepareLoading(s, o, {
        reload: !0
      }, c);
    }
  }, {
    key: "loadOne",
    value: function(s) {
      var o = this, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", l = s.split("|"), d = l[0], h = l[1];
      this.read(d, h, "read", void 0, void 0, function(u, p) {
        u && o.logger.warn("".concat(c, "loading namespace ").concat(h, " for language ").concat(d, " failed"), u), !u && p && o.logger.log("".concat(c, "loaded namespace ").concat(h, " for language ").concat(d), p), o.loaded(s, u, p);
      });
    }
  }, {
    key: "saveMissing",
    value: function(s, o, c, l, d) {
      var h = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(o)) {
        this.logger.warn('did not save key "'.concat(c, '" as the namespace "').concat(o, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      c == null || c === "" || (this.backend && this.backend.create && this.backend.create(s, o, c, l, null, _objectSpread$5(_objectSpread$5({}, h), {}, {
        isUpdate: d
      })), !(!s || !s[0]) && this.store.addResource(s[0], o, c, l));
    }
  }]), n;
}(EventEmitter);
function get() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(r) {
      var n = {};
      if (_typeof__default.default(r[1]) === "object" && (n = r[1]), typeof r[1] == "string" && (n.defaultValue = r[1]), typeof r[2] == "string" && (n.tDescription = r[2]), _typeof__default.default(r[2]) === "object" || _typeof__default.default(r[3]) === "object") {
        var a = r[3] || r[2];
        Object.keys(a).forEach(function(s) {
          n[s] = a[s];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: function(r, n, a, s) {
        return r;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function transformOptions(t) {
  return typeof t.ns == "string" && (t.ns = [t.ns]), typeof t.fallbackLng == "string" && (t.fallbackLng = [t.fallbackLng]), typeof t.fallbackNS == "string" && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t;
}
function ownKeys$6(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$6(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$6(Object(n), !0).forEach(function(a) {
      _defineProperty__default.default(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$6(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _createSuper$3(t) {
  var r = _isNativeReflectConstruct$3();
  return function() {
    var a = _getPrototypeOf__default.default(t), s;
    if (r) {
      var o = _getPrototypeOf__default.default(this).constructor;
      s = Reflect.construct(a, arguments, o);
    } else
      s = a.apply(this, arguments);
    return _possibleConstructorReturn__default.default(this, s);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function noop$2() {
}
function bindMemberFunctions(t) {
  var r = Object.getOwnPropertyNames(Object.getPrototypeOf(t));
  r.forEach(function(n) {
    typeof t[n] == "function" && (t[n] = t[n].bind(t));
  });
}
var I18n = function(t) {
  _inherits__default.default(n, t);
  var r = _createSuper$3(n);
  function n() {
    var a, s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
    if (_classCallCheck__default.default(this, n), a = r.call(this), isIE10 && EventEmitter.call(_assertThisInitialized__default.default(a)), a.options = transformOptions(s), a.services = {}, a.logger = baseLogger, a.modules = {
      external: []
    }, bindMemberFunctions(_assertThisInitialized__default.default(a)), o && !a.isInitialized && !s.isClone) {
      if (!a.options.initImmediate)
        return a.init(s, o), _possibleConstructorReturn__default.default(a, _assertThisInitialized__default.default(a));
      setTimeout(function() {
        a.init(s, o);
      }, 0);
    }
    return a;
  }
  return _createClass__default.default(n, [{
    key: "init",
    value: function() {
      var s = this, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = arguments.length > 1 ? arguments[1] : void 0;
      typeof o == "function" && (c = o, o = {}), !o.defaultNS && o.defaultNS !== !1 && o.ns && (typeof o.ns == "string" ? o.defaultNS = o.ns : o.ns.indexOf("translation") < 0 && (o.defaultNS = o.ns[0]));
      var l = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, l), this.options), transformOptions(o)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = _objectSpread$6(_objectSpread$6({}, l.interpolation), this.options.interpolation)), o.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = o.keySeparator), o.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = o.nsSeparator);
      function d(_) {
        return _ ? typeof _ == "function" ? new _() : _ : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? baseLogger.init(d(this.modules.logger), this.options) : baseLogger.init(null, this.options);
        var h;
        this.modules.formatter ? h = this.modules.formatter : typeof Intl < "u" && (h = Formatter);
        var u = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var p = this.services;
        p.logger = baseLogger, p.resourceStore = this.store, p.languageUtils = u, p.pluralResolver = new PluralResolver(u, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), h && (!this.options.interpolation.format || this.options.interpolation.format === l.interpolation.format) && (p.formatter = d(h), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new Interpolator(this.options), p.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, p.backendConnector = new Connector(d(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(_) {
          for (var $ = arguments.length, b = new Array($ > 1 ? $ - 1 : 0), M = 1; M < $; M++)
            b[M - 1] = arguments[M];
          s.emit.apply(s, [_].concat(b));
        }), this.modules.languageDetector && (p.languageDetector = d(this.modules.languageDetector), p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = d(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new Translator(this.services, this.options), this.translator.on("*", function(_) {
          for (var $ = arguments.length, b = new Array($ > 1 ? $ - 1 : 0), M = 1; M < $; M++)
            b[M - 1] = arguments[M];
          s.emit.apply(s, [_].concat(b));
        }), this.modules.external.forEach(function(_) {
          _.init && _.init(s);
        });
      }
      if (this.format = this.options.interpolation.format, c || (c = noop$2), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var m = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        m.length > 0 && m[0] !== "dev" && (this.options.lng = m[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var g = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      g.forEach(function(_) {
        s[_] = function() {
          var $;
          return ($ = s.store)[_].apply($, arguments);
        };
      });
      var v = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      v.forEach(function(_) {
        s[_] = function() {
          var $;
          return ($ = s.store)[_].apply($, arguments), s;
        };
      });
      var y = defer$1(), x = function() {
        var $ = function(M, C) {
          s.isInitialized && !s.initializedStoreOnce && s.logger.warn("init: i18next is already initialized. You should call init just once!"), s.isInitialized = !0, s.options.isClone || s.logger.log("initialized", s.options), s.emit("initialized", s.options), y.resolve(C), c(M, C);
        };
        if (s.languages && s.options.compatibilityAPI !== "v1" && !s.isInitialized)
          return $(null, s.t.bind(s));
        s.changeLanguage(s.options.lng, $);
      };
      return this.options.resources || !this.options.initImmediate ? x() : setTimeout(x, 0), y;
    }
  }, {
    key: "loadResources",
    value: function(s) {
      var o = this, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$2, l = c, d = typeof s == "string" ? s : this.language;
      if (typeof s == "function" && (l = s), !this.options.resources || this.options.partialBundledLanguages) {
        if (d && d.toLowerCase() === "cimode")
          return l();
        var h = [], u = function(g) {
          if (g) {
            var v = o.services.languageUtils.toResolveHierarchy(g);
            v.forEach(function(y) {
              h.indexOf(y) < 0 && h.push(y);
            });
          }
        };
        if (d)
          u(d);
        else {
          var p = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          p.forEach(function(m) {
            return u(m);
          });
        }
        this.options.preload && this.options.preload.forEach(function(m) {
          return u(m);
        }), this.services.backendConnector.load(h, this.options.ns, function(m) {
          !m && !o.resolvedLanguage && o.language && o.setResolvedLanguage(o.language), l(m);
        });
      } else
        l(null);
    }
  }, {
    key: "reloadResources",
    value: function(s, o, c) {
      var l = defer$1();
      return s || (s = this.languages), o || (o = this.options.ns), c || (c = noop$2), this.services.backendConnector.reload(s, o, function(d) {
        l.resolve(), c(d);
      }), l;
    }
  }, {
    key: "use",
    value: function(s) {
      if (!s)
        throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!s.type)
        throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return s.type === "backend" && (this.modules.backend = s), (s.type === "logger" || s.log && s.warn && s.error) && (this.modules.logger = s), s.type === "languageDetector" && (this.modules.languageDetector = s), s.type === "i18nFormat" && (this.modules.i18nFormat = s), s.type === "postProcessor" && postProcessor.addPostProcessor(s), s.type === "formatter" && (this.modules.formatter = s), s.type === "3rdParty" && this.modules.external.push(s), this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function(s) {
      if (!(!s || !this.languages) && !(["cimode", "dev"].indexOf(s) > -1))
        for (var o = 0; o < this.languages.length; o++) {
          var c = this.languages[o];
          if (!(["cimode", "dev"].indexOf(c) > -1) && this.store.hasLanguageSomeTranslations(c)) {
            this.resolvedLanguage = c;
            break;
          }
        }
    }
  }, {
    key: "changeLanguage",
    value: function(s, o) {
      var c = this;
      this.isLanguageChangingTo = s;
      var l = defer$1();
      this.emit("languageChanging", s);
      var d = function(m) {
        c.language = m, c.languages = c.services.languageUtils.toResolveHierarchy(m), c.resolvedLanguage = void 0, c.setResolvedLanguage(m);
      }, h = function(m, g) {
        g ? (d(g), c.translator.changeLanguage(g), c.isLanguageChangingTo = void 0, c.emit("languageChanged", g), c.logger.log("languageChanged", g)) : c.isLanguageChangingTo = void 0, l.resolve(function() {
          return c.t.apply(c, arguments);
        }), o && o(m, function() {
          return c.t.apply(c, arguments);
        });
      }, u = function(m) {
        !s && !m && c.services.languageDetector && (m = []);
        var g = typeof m == "string" ? m : c.services.languageUtils.getBestMatchFromCodes(m);
        g && (c.language || d(g), c.translator.language || c.translator.changeLanguage(g), c.services.languageDetector && c.services.languageDetector.cacheUserLanguage(g)), c.loadResources(g, function(v) {
          h(v, g);
        });
      };
      return !s && this.services.languageDetector && !this.services.languageDetector.async ? u(this.services.languageDetector.detect()) : !s && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(u) : u(s), l;
    }
  }, {
    key: "getFixedT",
    value: function(s, o, c) {
      var l = this, d = function h(u, p) {
        var m;
        if (_typeof__default.default(p) !== "object") {
          for (var g = arguments.length, v = new Array(g > 2 ? g - 2 : 0), y = 2; y < g; y++)
            v[y - 2] = arguments[y];
          m = l.options.overloadTranslationOptionHandler([u, p].concat(v));
        } else
          m = _objectSpread$6({}, p);
        m.lng = m.lng || h.lng, m.lngs = m.lngs || h.lngs, m.ns = m.ns || h.ns, m.keyPrefix = m.keyPrefix || c || h.keyPrefix;
        var x = l.options.keySeparator || ".", _ = m.keyPrefix ? "".concat(m.keyPrefix).concat(x).concat(u) : u;
        return l.t(_, m);
      };
      return typeof s == "string" ? d.lng = s : d.lngs = s, d.ns = o, d.keyPrefix = c, d;
    }
  }, {
    key: "t",
    value: function() {
      var s;
      return this.translator && (s = this.translator).translate.apply(s, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var s;
      return this.translator && (s = this.translator).exists.apply(s, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(s) {
      this.options.defaultNS = s;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(s) {
      var o = this, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var l = this.resolvedLanguage || this.languages[0], d = this.options ? this.options.fallbackLng : !1, h = this.languages[this.languages.length - 1];
      if (l.toLowerCase() === "cimode")
        return !0;
      var u = function(g, v) {
        var y = o.services.backendConnector.state["".concat(g, "|").concat(v)];
        return y === -1 || y === 2;
      };
      if (c.precheck) {
        var p = c.precheck(this, u);
        if (p !== void 0)
          return p;
      }
      return !!(this.hasResourceBundle(l, s) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || u(l, s) && (!d || u(h, s)));
    }
  }, {
    key: "loadNamespaces",
    value: function(s, o) {
      var c = this, l = defer$1();
      return this.options.ns ? (typeof s == "string" && (s = [s]), s.forEach(function(d) {
        c.options.ns.indexOf(d) < 0 && c.options.ns.push(d);
      }), this.loadResources(function(d) {
        l.resolve(), o && o(d);
      }), l) : (o && o(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(s, o) {
      var c = defer$1();
      typeof s == "string" && (s = [s]);
      var l = this.options.preload || [], d = s.filter(function(h) {
        return l.indexOf(h) < 0;
      });
      return d.length ? (this.options.preload = l.concat(d), this.loadResources(function(h) {
        c.resolve(), o && o(h);
      }), c) : (o && o(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(s) {
      if (s || (s = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !s)
        return "rtl";
      var o = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
      return o.indexOf(this.services.languageUtils.getLanguagePartFromCode(s)) > -1 || s.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var s = this, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$2, l = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), o), {
        isClone: !0
      }), d = new n(l);
      (o.debug !== void 0 || o.prefix !== void 0) && (d.logger = d.logger.clone(o));
      var h = ["store", "services", "language"];
      return h.forEach(function(u) {
        d[u] = s[u];
      }), d.services = _objectSpread$6({}, this.services), d.services.utils = {
        hasLoadedNamespace: d.hasLoadedNamespace.bind(d)
      }, d.translator = new Translator(d.services, d.options), d.translator.on("*", function(u) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
          m[g - 1] = arguments[g];
        d.emit.apply(d, [u].concat(m));
      }), d.init(l, c), d.translator.options = d.options, d.translator.backendConnector.services.utils = {
        hasLoadedNamespace: d.hasLoadedNamespace.bind(d)
      }, d;
    }
  }, {
    key: "toJSON",
    value: function() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]), n;
}(EventEmitter);
_defineProperty__default.default(I18n, "createInstance", function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
  return new I18n(t, r);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var i18next = instance, cjs = { exports: {} }, utils$1 = {};
Object.defineProperty(utils$1, "__esModule", {
  value: !0
});
utils$1.debounce = debounce;
utils$1.defaults = defaults;
utils$1.defer = defer;
utils$1.getPath = getPath;
utils$1.interpolate = interpolate;
utils$1.isMissingOption = isMissingOption;
utils$1.optionExist = optionExist;
utils$1.pushPath = pushPath;
utils$1.setPath = setPath;
var arr = [], each = arr.forEach, slice$1 = arr.slice;
function defaults(t) {
  return each.call(slice$1.call(arguments, 1), function(r) {
    if (r)
      for (var n in r)
        t[n] === void 0 && (t[n] = r[n]);
  }), t;
}
function debounce(t, r, n) {
  var a;
  return function() {
    var s = this, o = arguments, c = function() {
      a = null, n || t.apply(s, o);
    }, l = n && !a;
    clearTimeout(a), a = setTimeout(c, r), l && t.apply(s, o);
  };
}
function getLastOfPath(t, r, n) {
  function a(c) {
    return c && c.indexOf("###") > -1 ? c.replace(/###/g, ".") : c;
  }
  for (var s = typeof r != "string" ? [].concat(r) : r.split("."); s.length > 1; ) {
    if (!t)
      return {};
    var o = a(s.shift());
    !t[o] && n && (t[o] = new n()), t = t[o];
  }
  return t ? {
    obj: t,
    k: a(s.shift())
  } : {};
}
function setPath(t, r, n) {
  var a = getLastOfPath(t, r, Object), s = a.obj, o = a.k;
  s[o] = n;
}
function pushPath(t, r, n, a) {
  var s = getLastOfPath(t, r, Object), o = s.obj, c = s.k;
  o[c] = o[c] || [], a && (o[c] = o[c].concat(n)), a || o[c].push(n);
}
function getPath(t, r) {
  var n = getLastOfPath(t, r), a = n.obj, s = n.k;
  if (a)
    return a[s];
}
var regexp = new RegExp("{{(.+?)}}", "g");
function makeString(t) {
  return t == null ? "" : "" + t;
}
function interpolate(t, r, n) {
  var a, s;
  function o(c) {
    return c.replace(/\$/g, "$$$$");
  }
  for (; a = regexp.exec(t); )
    s = a[1].trim(), typeof s != "string" && (s = makeString(s)), s || (s = ""), s = o(s), t = t.replace(a[0], r[s] || s), regexp.lastIndex = 0;
  return t;
}
function isMissingOption(t, r) {
  return r.reduce(function(n, a) {
    if (n)
      return n;
    if (!t || !t[a] || typeof t[a] != "string" || !t[a].toLowerCase() === a.toLowerCase()) {
      var s = 'i18next-locize-backend :: got "'.concat(t[a], '" in options for ').concat(a, " which is invalid.");
      return console.warn(s), s;
    }
    return !1;
  }, !1);
}
function optionExist(t, r) {
  return !isMissingOption(t, r);
}
function defer() {
  var t, r, n = new Promise(function(a, s) {
    t = a, r = s;
  });
  return n.resolve = t, n.reject = r, n;
}
var request = { exports: {} };
function commonjsRequire(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var getFetch = { exports: {} }, browserPonyfill = { exports: {} }, hasRequiredBrowserPonyfill;
function requireBrowserPonyfill() {
  return hasRequiredBrowserPonyfill || (hasRequiredBrowserPonyfill = 1, function(t, r) {
    var n = typeof self < "u" ? self : commonjsGlobal, a = function() {
      function o() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }
      return o.prototype = n, new o();
    }();
    (function(o) {
      (function(c) {
        var l = {
          searchParams: "URLSearchParams" in o,
          iterable: "Symbol" in o && "iterator" in Symbol,
          blob: "FileReader" in o && "Blob" in o && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in o,
          arrayBuffer: "ArrayBuffer" in o
        };
        function d(O) {
          return O && DataView.prototype.isPrototypeOf(O);
        }
        if (l.arrayBuffer)
          var h = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], u = ArrayBuffer.isView || function(O) {
            return O && h.indexOf(Object.prototype.toString.call(O)) > -1;
          };
        function p(O) {
          if (typeof O != "string" && (O = String(O)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(O))
            throw new TypeError("Invalid character in header field name");
          return O.toLowerCase();
        }
        function m(O) {
          return typeof O != "string" && (O = String(O)), O;
        }
        function g(O) {
          var G = {
            next: function() {
              var I = O.shift();
              return { done: I === void 0, value: I };
            }
          };
          return l.iterable && (G[Symbol.iterator] = function() {
            return G;
          }), G;
        }
        function v(O) {
          this.map = {}, O instanceof v ? O.forEach(function(G, I) {
            this.append(I, G);
          }, this) : Array.isArray(O) ? O.forEach(function(G) {
            this.append(G[0], G[1]);
          }, this) : O && Object.getOwnPropertyNames(O).forEach(function(G) {
            this.append(G, O[G]);
          }, this);
        }
        v.prototype.append = function(O, G) {
          O = p(O), G = m(G);
          var I = this.map[O];
          this.map[O] = I ? I + ", " + G : G;
        }, v.prototype.delete = function(O) {
          delete this.map[p(O)];
        }, v.prototype.get = function(O) {
          return O = p(O), this.has(O) ? this.map[O] : null;
        }, v.prototype.has = function(O) {
          return this.map.hasOwnProperty(p(O));
        }, v.prototype.set = function(O, G) {
          this.map[p(O)] = m(G);
        }, v.prototype.forEach = function(O, G) {
          for (var I in this.map)
            this.map.hasOwnProperty(I) && O.call(G, this.map[I], I, this);
        }, v.prototype.keys = function() {
          var O = [];
          return this.forEach(function(G, I) {
            O.push(I);
          }), g(O);
        }, v.prototype.values = function() {
          var O = [];
          return this.forEach(function(G) {
            O.push(G);
          }), g(O);
        }, v.prototype.entries = function() {
          var O = [];
          return this.forEach(function(G, I) {
            O.push([I, G]);
          }), g(O);
        }, l.iterable && (v.prototype[Symbol.iterator] = v.prototype.entries);
        function y(O) {
          if (O.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          O.bodyUsed = !0;
        }
        function x(O) {
          return new Promise(function(G, I) {
            O.onload = function() {
              G(O.result);
            }, O.onerror = function() {
              I(O.error);
            };
          });
        }
        function _(O) {
          var G = new FileReader(), I = x(G);
          return G.readAsArrayBuffer(O), I;
        }
        function $(O) {
          var G = new FileReader(), I = x(G);
          return G.readAsText(O), I;
        }
        function b(O) {
          for (var G = new Uint8Array(O), I = new Array(G.length), k = 0; k < G.length; k++)
            I[k] = String.fromCharCode(G[k]);
          return I.join("");
        }
        function M(O) {
          if (O.slice)
            return O.slice(0);
          var G = new Uint8Array(O.byteLength);
          return G.set(new Uint8Array(O)), G.buffer;
        }
        function C() {
          return this.bodyUsed = !1, this._initBody = function(O) {
            this._bodyInit = O, O ? typeof O == "string" ? this._bodyText = O : l.blob && Blob.prototype.isPrototypeOf(O) ? this._bodyBlob = O : l.formData && FormData.prototype.isPrototypeOf(O) ? this._bodyFormData = O : l.searchParams && URLSearchParams.prototype.isPrototypeOf(O) ? this._bodyText = O.toString() : l.arrayBuffer && l.blob && d(O) ? (this._bodyArrayBuffer = M(O.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : l.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(O) || u(O)) ? this._bodyArrayBuffer = M(O) : this._bodyText = O = Object.prototype.toString.call(O) : this._bodyText = "", this.headers.get("content-type") || (typeof O == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : l.searchParams && URLSearchParams.prototype.isPrototypeOf(O) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, l.blob && (this.blob = function() {
            var O = y(this);
            if (O)
              return O;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            return this._bodyArrayBuffer ? y(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(_);
          }), this.text = function() {
            var O = y(this);
            if (O)
              return O;
            if (this._bodyBlob)
              return $(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(b(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, l.formData && (this.formData = function() {
            return this.text().then(N);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var S = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function A(O) {
          var G = O.toUpperCase();
          return S.indexOf(G) > -1 ? G : O;
        }
        function D(O, G) {
          G = G || {};
          var I = G.body;
          if (O instanceof D) {
            if (O.bodyUsed)
              throw new TypeError("Already read");
            this.url = O.url, this.credentials = O.credentials, G.headers || (this.headers = new v(O.headers)), this.method = O.method, this.mode = O.mode, this.signal = O.signal, !I && O._bodyInit != null && (I = O._bodyInit, O.bodyUsed = !0);
          } else
            this.url = String(O);
          if (this.credentials = G.credentials || this.credentials || "same-origin", (G.headers || !this.headers) && (this.headers = new v(G.headers)), this.method = A(G.method || this.method || "GET"), this.mode = G.mode || this.mode || null, this.signal = G.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && I)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(I);
        }
        D.prototype.clone = function() {
          return new D(this, { body: this._bodyInit });
        };
        function N(O) {
          var G = new FormData();
          return O.trim().split("&").forEach(function(I) {
            if (I) {
              var k = I.split("="), B = k.shift().replace(/\+/g, " "), L = k.join("=").replace(/\+/g, " ");
              G.append(decodeURIComponent(B), decodeURIComponent(L));
            }
          }), G;
        }
        function T(O) {
          var G = new v(), I = O.replace(/\r?\n[\t ]+/g, " ");
          return I.split(/\r?\n/).forEach(function(k) {
            var B = k.split(":"), L = B.shift().trim();
            if (L) {
              var V = B.join(":").trim();
              G.append(L, V);
            }
          }), G;
        }
        C.call(D.prototype);
        function R(O, G) {
          G || (G = {}), this.type = "default", this.status = G.status === void 0 ? 200 : G.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in G ? G.statusText : "OK", this.headers = new v(G.headers), this.url = G.url || "", this._initBody(O);
        }
        C.call(R.prototype), R.prototype.clone = function() {
          return new R(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new v(this.headers),
            url: this.url
          });
        }, R.error = function() {
          var O = new R(null, { status: 0, statusText: "" });
          return O.type = "error", O;
        };
        var F = [301, 302, 303, 307, 308];
        R.redirect = function(O, G) {
          if (F.indexOf(G) === -1)
            throw new RangeError("Invalid status code");
          return new R(null, { status: G, headers: { location: O } });
        }, c.DOMException = o.DOMException;
        try {
          new c.DOMException();
        } catch {
          c.DOMException = function(G, I) {
            this.message = G, this.name = I;
            var k = Error(G);
            this.stack = k.stack;
          }, c.DOMException.prototype = Object.create(Error.prototype), c.DOMException.prototype.constructor = c.DOMException;
        }
        function z(O, G) {
          return new Promise(function(I, k) {
            var B = new D(O, G);
            if (B.signal && B.signal.aborted)
              return k(new c.DOMException("Aborted", "AbortError"));
            var L = new XMLHttpRequest();
            function V() {
              L.abort();
            }
            L.onload = function() {
              var U = {
                status: L.status,
                statusText: L.statusText,
                headers: T(L.getAllResponseHeaders() || "")
              };
              U.url = "responseURL" in L ? L.responseURL : U.headers.get("X-Request-URL");
              var J = "response" in L ? L.response : L.responseText;
              I(new R(J, U));
            }, L.onerror = function() {
              k(new TypeError("Network request failed"));
            }, L.ontimeout = function() {
              k(new TypeError("Network request failed"));
            }, L.onabort = function() {
              k(new c.DOMException("Aborted", "AbortError"));
            }, L.open(B.method, B.url, !0), B.credentials === "include" ? L.withCredentials = !0 : B.credentials === "omit" && (L.withCredentials = !1), "responseType" in L && l.blob && (L.responseType = "blob"), B.headers.forEach(function(U, J) {
              L.setRequestHeader(J, U);
            }), B.signal && (B.signal.addEventListener("abort", V), L.onreadystatechange = function() {
              L.readyState === 4 && B.signal.removeEventListener("abort", V);
            }), L.send(typeof B._bodyInit > "u" ? null : B._bodyInit);
          });
        }
        return z.polyfill = !0, o.fetch || (o.fetch = z, o.Headers = v, o.Request = D, o.Response = R), c.Headers = v, c.Request = D, c.Response = R, c.fetch = z, Object.defineProperty(c, "__esModule", { value: !0 }), c;
      })({});
    })(a), a.fetch.ponyfill = !0, delete a.fetch.polyfill;
    var s = a;
    r = s.fetch, r.default = s.fetch, r.fetch = s.fetch, r.Headers = s.Headers, r.Request = s.Request, r.Response = s.Response, t.exports = r;
  }(browserPonyfill, browserPonyfill.exports)), browserPonyfill.exports;
}
(function(t, r) {
  var n;
  if (typeof fetch == "function" && (typeof commonjsGlobal < "u" && commonjsGlobal.fetch ? n = commonjsGlobal.fetch : typeof window < "u" && window.fetch ? n = window.fetch : n = fetch), typeof commonjsRequire < "u" && (typeof window > "u" || typeof window.document > "u")) {
    var a = n || requireBrowserPonyfill();
    a.default && (a = a.default), r.default = a, t.exports = r.default;
  }
})(getFetch, getFetch.exports);
var getFetchExports = getFetch.exports;
(function(t, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = void 0;
  var n = s(getFetchExports);
  function a(g) {
    if (typeof WeakMap != "function")
      return null;
    var v = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap();
    return (a = function(_) {
      return _ ? y : v;
    })(g);
  }
  function s(g, v) {
    if (!v && g && g.__esModule)
      return g;
    if (g === null || o(g) !== "object" && typeof g != "function")
      return { default: g };
    var y = a(v);
    if (y && y.has(g))
      return y.get(g);
    var x = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var $ in g)
      if ($ !== "default" && Object.prototype.hasOwnProperty.call(g, $)) {
        var b = _ ? Object.getOwnPropertyDescriptor(g, $) : null;
        b && (b.get || b.set) ? Object.defineProperty(x, $, b) : x[$] = g[$];
      }
    return x.default = g, y && y.set(g, x), x;
  }
  function o(g) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
      return typeof v;
    } : function(v) {
      return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
    }, o(g);
  }
  var c;
  typeof fetch == "function" && (typeof commonjsGlobal < "u" && commonjsGlobal.fetch ? c = commonjsGlobal.fetch : typeof window < "u" && window.fetch ? c = window.fetch : c = fetch);
  var l;
  (typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : o(XMLHttpRequest)) === "object") && (typeof commonjsGlobal < "u" && commonjsGlobal.XMLHttpRequest ? l = commonjsGlobal.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && (l = window.XMLHttpRequest));
  var d;
  typeof ActiveXObject == "function" && (typeof commonjsGlobal < "u" && commonjsGlobal.ActiveXObject ? d = commonjsGlobal.ActiveXObject : typeof window < "u" && window.ActiveXObject && (d = window.ActiveXObject)), !c && n && !l && !d && (c = n.default || n), typeof c != "function" && (c = void 0);
  var h = function(v, y, x, _) {
    var $ = {};
    v.authorize && v.apiKey && ($.Authorization = v.apiKey), (x || v.setContentTypeJSON) && ($["Content-Type"] = "application/json"), c(y, {
      method: x ? "POST" : "GET",
      body: x ? JSON.stringify(x) : void 0,
      headers: $
    }).then(function(b) {
      var M = b.headers && b.headers.get("x-cache") === "Error from cloudfront";
      if (!b.ok)
        return _(b.statusText || "Error", {
          status: b.status,
          resourceNotExisting: M
        });
      b.text().then(function(C) {
        _(null, {
          status: b.status,
          data: C,
          resourceNotExisting: M
        });
      }).catch(_);
    }).catch(_);
  }, u = function(v, y, x, _) {
    try {
      var $;
      l ? $ = new l() : $ = new d("MSXML2.XMLHTTP.3.0"), $.open(x ? "POST" : "GET", y, 1), v.crossDomain || $.setRequestHeader("X-Requested-With", "XMLHttpRequest"), v.authorize && v.apiKey && $.setRequestHeader("Authorization", v.apiKey), (x || v.setContentTypeJSON) && $.setRequestHeader("Content-Type", "application/json"), $.onreadystatechange = function() {
        var b = $.getResponseHeader("x-cache") === "Error from cloudfront";
        $.readyState > 3 && _($.status >= 400 ? $.statusText : null, {
          status: $.status,
          data: $.responseText,
          resourceNotExisting: b
        });
      }, $.send(JSON.stringify(x));
    } catch (b) {
      console && console.log(b);
    }
  }, p = function(v, y, x, _) {
    if (typeof x == "function" && (_ = x, x = void 0), _ = _ || function() {
    }, c)
      return h(v, y, x, _);
    if (typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : o(XMLHttpRequest)) === "object" || typeof ActiveXObject == "function")
      return u(v, y, x, _);
    _(new Error("No fetch and no xhr implementation found!"));
  }, m = p;
  r.default = m, t.exports = r.default;
})(request, request.exports);
var requestExports = request.exports;
(function(t, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = void 0;
  var n = utils$1, a = s(requestExports);
  function s(v) {
    return v && v.__esModule ? v : { default: v };
  }
  function o(v, y) {
    if (!(v instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  function c(v, y) {
    for (var x = 0; x < y.length; x++) {
      var _ = y[x];
      _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(v, _.key, _);
    }
  }
  function l(v, y, x) {
    return y && c(v.prototype, y), x && c(v, x), Object.defineProperty(v, "prototype", { writable: !1 }), v;
  }
  var d = function() {
    return {
      loadPath: "https://api.locize.app/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
      privatePath: "https://api.locize.app/private/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
      getLanguagesPath: "https://api.locize.app/languages/{{projectId}}",
      addPath: "https://api.locize.app/missing/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
      updatePath: "https://api.locize.app/update/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
      referenceLng: "en",
      crossDomain: !0,
      setContentTypeJSON: !1,
      version: "latest",
      private: !1,
      translatedPercentageThreshold: 0.9,
      failLoadingOnEmptyJSON: !1,
      allowedAddOrUpdateHosts: ["localhost"],
      onSaved: !1,
      reloadInterval: typeof window < "u" ? !1 : 60 * 60 * 1e3,
      checkForProjectTimeout: 3 * 1e3,
      storageExpiration: 60 * 60 * 1e3,
      writeDebounce: 5 * 1e3
    };
  }, h;
  try {
    h = typeof window < "u" && window.localStorage !== null;
    var u = "notExistingLocizeProject";
    window.localStorage.setItem(u, "foo"), window.localStorage.removeItem(u);
  } catch {
    h = !1;
  }
  function p(v) {
    var y = function() {
    }, x = function() {
    };
    return h ? (y = function($) {
      window.localStorage.setItem("notExistingLocizeProject_".concat($), Date.now());
    }, x = function($) {
      var b = window.localStorage.getItem("notExistingLocizeProject_".concat($));
      return b ? Date.now() - b > v ? (window.localStorage.removeItem("notExistingLocizeProject_".concat($)), !1) : !0 : !1;
    }) : typeof document < "u" && (y = function($) {
      var b = /* @__PURE__ */ new Date();
      b.setTime(b.getTime() + v);
      var M = "; expires=".concat(b.toGMTString()), C = "notExistingLocizeProject_".concat($);
      try {
        document.cookie = "".concat(C, "=").concat(Date.now()).concat(M, ";path=/");
      } catch {
      }
    }, x = function($) {
      var b = "notExistingLocizeProject_".concat($), M = "".concat(b, "=");
      try {
        for (var C = document.cookie.split(";"), S = 0; S < C.length; S++) {
          for (var A = C[S]; A.charAt(0) === " "; )
            A = A.substring(1, A.length);
          if (A.indexOf(M) === 0)
            return !0;
        }
      } catch {
      }
      return !1;
    }), {
      setProjectNotExisting: y,
      isProjectNotExisting: x
    };
  }
  var m = function() {
    function v(y) {
      var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, $ = arguments.length > 3 ? arguments[3] : void 0;
      o(this, v), this.services = y, this.options = x, this.allOptions = _, this.type = "backend", y && y.projectId ? this.init(null, y, _, x) : this.init(y, x, _, $);
    }
    return l(v, [{
      key: "init",
      value: function(x) {
        var _ = this, $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, M = arguments.length > 3 ? arguments[3] : void 0;
        !$.referenceLng && b.fallbackLng && Array.isArray(b.fallbackLng) && b.fallbackLng[0] !== "dev" && ($.referenceLng = b.fallbackLng[0]), this.services = x;
        var C = d(), S = (0, n.defaults)($, this.options || {});
        S.reloadInterval && S.reloadInterval < 5 * 60 * 1e3 && (console.warn("Your configured reloadInterval option is to low."), S.reloadInterval = C.reloadInterval), this.options = (0, n.defaults)($, this.options || {}, C), this.allOptions = b, this.somethingLoaded = !1, this.isProjectNotExisting = !1, this.storage = p(this.options.storageExpiration), this.options.pull && console.warn('The pull API was removed use "private: true" option instead: https://docs.locize.com/integration/api#fetch-private-namespace-resources');
        var A = typeof window < "u" && window.location && window.location.hostname;
        A ? (this.isAddOrUpdateAllowed = typeof this.options.allowedAddOrUpdateHosts == "function" ? this.options.allowedAddOrUpdateHosts(A) : this.options.allowedAddOrUpdateHosts.indexOf(A) > -1, x && x.logger && (b.saveMissing || b.updateMissing) && (this.isAddOrUpdateAllowed ? A !== "localhost" && x.logger.warn('locize-backend: you are using the save or update missings feature from this host "'.concat(A, `".
Make sure you will not use it in production!
https://docs.locize.com/guides-tips-and-tricks/going-production`)) : x.logger.warn(typeof this.options.allowedAddOrUpdateHosts == "function" ? 'locize-backend: will not save or update missings because allowedAddOrUpdateHosts returned false for the host "'.concat(A, '".') : 'locize-backend: will not save or update missings because the host "'.concat(A, '" was not in the list of allowedAddOrUpdateHosts: ').concat(this.options.allowedAddOrUpdateHosts.join(", "), " (matches need to be exact).")))) : this.isAddOrUpdateAllowed = !0, typeof M == "function" && this.getOptions(function(D, N, T) {
          if (D)
            return M(D);
          _.options.referenceLng = $.referenceLng || N.referenceLng || _.options.referenceLng, M(null, N, T);
        }), this.queuedWrites = {
          pending: {}
        }, this.debouncedProcess = (0, n.debounce)(this.process, this.options.writeDebounce), this.interval && clearInterval(this.interval), this.options.reloadInterval && this.options.projectId && (this.interval = setInterval(function() {
          return _.reload();
        }, this.options.reloadInterval));
      }
    }, {
      key: "reload",
      value: function() {
        var x = this, _ = this.services || {
          logger: console
        }, $ = _.backendConnector, b = _.languageUtils, M = _.logger;
        if ($) {
          var C = $.language;
          if (!(C && C.toLowerCase() === "cimode")) {
            var S = [], A = function(N) {
              var T = b.toResolveHierarchy(N);
              T.forEach(function(R) {
                S.indexOf(R) < 0 && S.push(R);
              });
            };
            A(C), this.allOptions.preload && this.allOptions.preload.forEach(function(D) {
              return A(D);
            }), S.forEach(function(D) {
              x.allOptions.ns.forEach(function(N) {
                $.read(D, N, "read", null, null, function(T, R) {
                  T && M.warn("loading namespace ".concat(N, " for language ").concat(D, " failed"), T), !T && R && M.log("loaded namespace ".concat(N, " for language ").concat(D), R), $.loaded("".concat(D, "|").concat(N), T, R);
                });
              });
            });
          }
        }
      }
    }, {
      key: "getLanguages",
      value: function(x) {
        var _ = this, $;
        x || ($ = (0, n.defer)(), x = function(S, A) {
          if (S)
            return $.reject(S);
          $.resolve(A);
        });
        var b = (0, n.isMissingOption)(this.options, ["projectId"]);
        if (b)
          return x(new Error(b));
        var M = (0, n.interpolate)(this.options.getLanguagesPath, {
          projectId: this.options.projectId
        });
        if (!this.isProjectNotExisting && this.storage.isProjectNotExisting(this.options.projectId) && (this.isProjectNotExisting = !0), this.isProjectNotExisting)
          return x(new Error("locize project ".concat(this.options.projectId, " does not exist!")));
        if (this.getLanguagesCalls = this.getLanguagesCalls || [], this.getLanguagesCalls.push(x), !(this.getLanguagesCalls.length > 1))
          return this.loadUrl({}, M, function(C, S, A) {
            if (!_.somethingLoaded && A && A.resourceNotExisting) {
              _.isProjectNotExisting = !0, _.storage.setProjectNotExisting(_.options.projectId);
              var D = new Error("locize project ".concat(_.options.projectId, " does not exist!")), N = _.getLanguagesCalls;
              return _.getLanguagesCalls = [], N.forEach(function(F) {
                return F(D);
              });
            }
            if (S) {
              var T = Object.keys(S).reduce(function(F, z) {
                var O = S[z];
                return O.isReferenceLanguage && (F = z), F;
              }, "");
              T && _.options.referenceLng !== T && (_.options.referenceLng = T);
            }
            _.somethingLoaded = !0;
            var R = _.getLanguagesCalls;
            _.getLanguagesCalls = [], R.forEach(function(F) {
              return F(C, S);
            });
          }), $;
      }
    }, {
      key: "getOptions",
      value: function(x) {
        var _ = this, $;
        return x || ($ = (0, n.defer)(), x = function(M, C) {
          if (M)
            return $.reject(M);
          $.resolve(C);
        }), this.getLanguages(function(b, M) {
          if (b)
            return x(b);
          var C = Object.keys(M);
          if (!C.length)
            return x(new Error("was unable to load languages via API"));
          var S = C.reduce(function(D, N) {
            var T = M[N];
            return T.translated[_.options.version] && T.translated[_.options.version] >= _.options.translatedPercentageThreshold && D.push(N), D;
          }, []), A = C.reduce(function(D, N) {
            return N.indexOf("-") > -1 ? !0 : D;
          }, !1);
          x(null, {
            fallbackLng: _.options.referenceLng,
            referenceLng: _.options.referenceLng,
            supportedLngs: S,
            load: A ? "all" : "languageOnly"
          }, M);
        }), $;
      }
    }, {
      key: "checkIfProjectExists",
      value: function(x) {
        var _ = this, $ = this.services || {
          logger: console
        }, b = $.logger;
        if (this.somethingLoaded) {
          x && x(null);
          return;
        }
        if (this.alreadyRequestedCheckIfProjectExists) {
          setTimeout(function() {
            return _.checkIfProjectExists(x);
          }, this.options.checkForProjectTimeout);
          return;
        }
        this.alreadyRequestedCheckIfProjectExists = !0, this.getLanguages(function(M) {
          M && M.message && M.message.indexOf("does not exist") > 0 && b && b.error(M.message), x && x(M);
        });
      }
    }, {
      key: "read",
      value: function(x, _, $) {
        var b = this, M = this.services || {
          logger: console
        }, C = M.logger, S, A = {};
        if (this.options.private) {
          var D = (0, n.isMissingOption)(this.options, ["projectId", "version", "apiKey"]);
          if (D)
            return $(new Error(D), !1);
          S = (0, n.interpolate)(this.options.privatePath, {
            lng: x,
            ns: _,
            projectId: this.options.projectId,
            version: this.options.version
          }), A = {
            authorize: !0
          };
        } else {
          var N = (0, n.isMissingOption)(this.options, ["projectId", "version"]);
          if (N)
            return $(new Error(N), !1);
          S = (0, n.interpolate)(this.options.loadPath, {
            lng: x,
            ns: _,
            projectId: this.options.projectId,
            version: this.options.version
          });
        }
        if (!this.isProjectNotExisting && this.storage.isProjectNotExisting(this.options.projectId) && (this.isProjectNotExisting = !0), this.isProjectNotExisting) {
          var T = new Error("locize project ".concat(this.options.projectId, " does not exist!"));
          C && C.error(T.message), $ && $(T);
          return;
        }
        this.loadUrl(A, S, function(R, F, z) {
          b.somethingLoaded || (z && z.resourceNotExisting ? setTimeout(function() {
            return b.checkIfProjectExists();
          }, b.options.checkForProjectTimeout) : b.somethingLoaded = !0), $(R, F);
        });
      }
    }, {
      key: "loadUrl",
      value: function(x, _, $, b) {
        var M = this;
        x = (0, n.defaults)(x, this.options), typeof $ == "function" && (b = $, $ = void 0), b = b || function() {
        }, (0, a.default)(x, _, $, function(C, S) {
          var A = S && S.resourceNotExisting;
          if (S && (S.status === 408 || S.status === 400))
            return b("failed loading " + _, !0, {
              resourceNotExisting: A
            });
          if (S && (S.status >= 500 && S.status < 600 || !S.status))
            return b("failed loading " + _, !0, {
              resourceNotExisting: A
            });
          if (S && S.status >= 400 && S.status < 500)
            return b("failed loading " + _, !1, {
              resourceNotExisting: A
            });
          if (!S && C && C.message && C.message.indexOf("Failed to fetch") > -1)
            return b("failed loading " + _, !0, {
              resourceNotExisting: A
            });
          if (C)
            return b(C, !1);
          var D, N;
          try {
            D = JSON.parse(S.data);
          } catch {
            N = "failed parsing " + _ + " to json";
          }
          if (N)
            return b(N, !1);
          if (M.options.failLoadingOnEmptyJSON && !Object.keys(D).length)
            return b("loaded result empty for " + _, !1, {
              resourceNotExisting: A
            });
          b(null, D, {
            resourceNotExisting: A
          });
        });
      }
    }, {
      key: "create",
      value: function(x, _, $, b, M, C) {
        var S = this;
        M || (M = function() {
        }), this.checkIfProjectExists(function(A) {
          if (A)
            return M(A);
          var D = (0, n.isMissingOption)(S.options, ["projectId", "version", "apiKey", "referenceLng"]);
          if (D)
            return M(new Error(D));
          if (!S.isAddOrUpdateAllowed)
            return M("host is not allowed to create key.");
          typeof x == "string" && (x = [x]), x.filter(function(N) {
            return N === S.options.referenceLng;
          }).length < 1 && S.services && S.services.logger && S.services.logger.warn('locize-backend: will not save missings because the reference language "'.concat(S.options.referenceLng, '" was not in the list of to save languages: ').concat(x.join(", "), " (open your site in the reference language to save missings).")), x.forEach(function(N) {
            N === S.options.referenceLng && S.queue.call(S, S.options.referenceLng, _, $, b, M, C);
          });
        });
      }
    }, {
      key: "update",
      value: function(x, _, $, b, M, C) {
        var S = this;
        M || (M = function() {
        }), this.checkIfProjectExists(function(A) {
          if (A)
            return M(A);
          var D = (0, n.isMissingOption)(S.options, ["projectId", "version", "apiKey", "referenceLng"]);
          if (D)
            return M(new Error(D));
          if (!S.isAddOrUpdateAllowed)
            return M("host is not allowed to update key.");
          C || (C = {}), typeof x == "string" && (x = [x]), C.isUpdate = !0, x.forEach(function(N) {
            N === S.options.referenceLng && S.queue.call(S, S.options.referenceLng, _, $, b, M, C);
          });
        });
      }
    }, {
      key: "writePage",
      value: function(x, _, $, b) {
        var M = (0, n.interpolate)(this.options.addPath, {
          lng: x,
          ns: _,
          projectId: this.options.projectId,
          version: this.options.version
        }), C = (0, n.interpolate)(this.options.updatePath, {
          lng: x,
          ns: _,
          projectId: this.options.projectId,
          version: this.options.version
        }), S = !1, A = !1, D = {}, N = {};
        $.forEach(function(F) {
          var z = F.options && F.options.tDescription ? {
            value: F.fallbackValue || "",
            context: {
              text: F.options.tDescription
            }
          } : F.fallbackValue || "";
          F.options && F.options.isUpdate ? (A || (A = !0), N[F.key] = z) : (S || (S = !0), D[F.key] = z);
        });
        var T = 0;
        S && T++, A && T++;
        var R = function(z) {
          T--, T || b(z);
        };
        T || R(), S && (0, a.default)((0, n.defaults)({
          authorize: !0
        }, this.options), M, D, R), A && (0, a.default)((0, n.defaults)({
          authorize: !0
        }, this.options), C, N, R);
      }
    }, {
      key: "write",
      value: function(x, _) {
        var $ = this, b = (0, n.getPath)(this.queuedWrites, ["locks", x, _]);
        if (!b) {
          var M = (0, n.getPath)(this.queuedWrites, [x, _]);
          (0, n.setPath)(this.queuedWrites, [x, _], []);
          var C = 1e3, S = M.filter(function(A) {
            return A.callback;
          }).map(function(A) {
            return A.callback;
          });
          M.length && function() {
            (0, n.setPath)($.queuedWrites, ["locks", x, _], !0);
            var A = function() {
              (0, n.setPath)($.queuedWrites, ["locks", x, _], !1), S.forEach(function(F) {
                return F();
              }), $.options.onSaved && $.options.onSaved(x, _), $.debouncedProcess(x, _);
            }, D = M.length / C, N = 0, T = M.splice(0, C);
            for ($.writePage(x, _, T, function() {
              N++, N >= D && A();
            }); T.length === C; )
              T = M.splice(0, C), T.length && $.writePage(x, _, T, function() {
                N++, N >= D && A();
              });
          }();
        }
      }
    }, {
      key: "process",
      value: function() {
        var x = this;
        Object.keys(this.queuedWrites).forEach(function(_) {
          _ !== "locks" && Object.keys(x.queuedWrites[_]).forEach(function($) {
            var b = x.queuedWrites[_][$];
            b.length && x.write(_, $);
          });
        });
      }
    }, {
      key: "queue",
      value: function(x, _, $, b, M, C) {
        (0, n.pushPath)(this.queuedWrites, [x, _], {
          key: $,
          fallbackValue: b || "",
          callback: M,
          options: C
        }), this.debouncedProcess();
      }
    }]), v;
  }();
  m.type = "backend";
  var g = m;
  r.default = g, t.exports = r.default;
})(cjs, cjs.exports);
var cjsExports = cjs.exports;
const I18N_DEFAULT_LANGUAGE = "es", LOCIZE_API_KEY = process.env.LOCIZE_API_KEY, LOCIZE_PROJECT_ID = "cec3c358-6406-4a73-ad17-06ef70d79f57";
var constants = Object.freeze({
  I18N_DEFAULT_LANGUAGE,
  LOCIZE_API_KEY,
  LOCIZE_PROJECT_ID
});
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (D) => n(D, "__esModule", { value: !0 }), d = (D, N) => {
    l(D);
    for (var T in N)
      n(D, T, { get: N[T], enumerable: !0 });
  }, h = (D, N, T) => {
    if (N && typeof N == "object" || typeof N == "function")
      for (let R of s(N))
        !c.call(D, R) && R !== "default" && n(D, R, { get: () => N[R], enumerable: !(T = a(N, R)) || T.enumerable });
    return D;
  }, u = (D) => h(l(n(D != null ? r(o(D)) : {}, "default", D && D.__esModule && "default" in D ? { get: () => D.default, enumerable: !0 } : { value: D, enumerable: !0 })), D), p = (D, N, T) => new Promise((R, F) => {
    var z = (I) => {
      try {
        G(T.next(I));
      } catch (k) {
        F(k);
      }
    }, O = (I) => {
      try {
        G(T.throw(I));
      } catch (k) {
        F(k);
      }
    }, G = (I) => I.done ? R(I.value) : Promise.resolve(I.value).then(z, O);
    G((T = T.apply(D, N)).next());
  });
  d(t, {
    default: () => A
  });
  var m = u(i18next), g = u(cjsExports), v = u(require$$2), y = u(constants), x = u(requireUtils());
  const _ = y.I18N_DEFAULT_LANGUAGE, $ = {
    projectId: y.LOCIZE_PROJECT_ID,
    apiKey: y.LOCIZE_API_KEY,
    referenceLng: _,
    reloadInterval: !1
  }, b = m.createInstance();
  function M() {
    return p(this, null, function* () {
      yield b.use(g.default).init({
        lng: _,
        fallbackLng: !1,
        ns: ["common"],
        defaultNS: "common",
        saveMissing: !0,
        backend: $,
        interpolation: {
          format: function(D, N) {
            if (N.includes("date")) {
              const T = N.split("|")[1];
              return (0, v.default)((0, x.formatDate)(D)).format(T);
            }
            return D;
          }
        }
      });
    });
  }
  var A = {
    setLocale: (D) => p(void 0, null, function* () {
      return yield b.changeLanguage(D);
    }),
    translate: (D, N) => p(void 0, null, function* () {
      return b.isInitialized || (yield M()), b.t(D, N);
    })
  };
})(i18n);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (m) => n(m, "__esModule", { value: !0 }), d = (m, g) => {
    l(m);
    for (var v in g)
      n(m, v, { get: g[v], enumerable: !0 });
  }, h = (m, g, v) => {
    if (g && typeof g == "object" || typeof g == "function")
      for (let y of s(g))
        !c.call(m, y) && y !== "default" && n(m, y, { get: () => g[y], enumerable: !(v = a(g, y)) || v.enumerable });
    return m;
  }, u = (m) => h(l(n(m != null ? r(o(m)) : {}, "default", m && m.__esModule && "default" in m ? { get: () => m.default, enumerable: !0 } : { value: m, enumerable: !0 })), m);
  d(t, {
    i18n: () => p.default
  });
  var p = u(i18n);
})(services);
var validations$1 = {}, aeatAmount = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $
  });
  var p = u(requireUtils());
  const m = "string", g = /^(?:\d{1,3}(?:\.\d{1,3})*|\d+)(?:,\d{1,2})?$/, v = (b) => typeof b === m;
  var $ = {
    message: () => "invalid_field",
    validate: (b) => v(b) ? (0, p.regexTest)(b, g) : !1
  };
})(aeatAmount);
var aeatAppCode = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $
  });
  var p = u(requireUtils());
  const m = "string", g = /\b[a-zA-Z0-9]{4}\b/, v = (b) => typeof b === m;
  var $ = {
    message: () => "invalid_aeat_app_code",
    validate: (b) => v(b) ? (0, p.regexTest)(b, g) : !1
  };
})(aeatAppCode);
var aeatAppPin = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $
  });
  var p = u(requireUtils());
  const m = "string", g = /\b[a-zA-Z0-9]{3}\b/, v = (b) => typeof b === m;
  var $ = {
    message: () => "invalid_aeat_app_pin",
    validate: (b) => v(b) ? (0, p.regexTest)(b, g) : !1
  };
})(aeatAppPin);
var aeatReferenceNumber = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $
  });
  var p = u(requireUtils());
  const m = "string", g = /\b[a-zA-Z0-9]{6}\b/, v = (b) => typeof b === m;
  var $ = {
    message: () => "invalid_aeat_reference_number",
    validate: (b) => v(b) ? (0, p.regexTest)(b, g) : !1
  };
})(aeatReferenceNumber);
var email = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $
  });
  var p = u(requireUtils());
  const m = "string", g = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, v = (b) => typeof b === m;
  var $ = {
    message: () => "invalid_email",
    validate: (b) => v(b) ? (0, p.regexTest)(b, g) : !1
  };
})(email);
var emailValidationCode = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $
  });
  var p = u(requireUtils());
  const m = "string", g = /\b[0-9]{6}\b/, v = (b) => typeof b === m;
  var $ = {
    message: () => "invalid_email_validation_code",
    validate: (b) => v(b) ? (0, p.regexTest)(b, g) : !1
  };
})(emailValidationCode);
var iban$1 = {}, iban = {};
(function(t) {
  (function(r, n) {
    typeof t.nodeName != "string" ? n(t) : n(r.IBAN = {});
  })(commonjsGlobal, function(r) {
    Array.prototype.map || (Array.prototype.map = function(v) {
      if (this === void 0 || this === null)
        throw new TypeError();
      var y = Object(this), x = y.length >>> 0;
      if (typeof v != "function")
        throw new TypeError();
      for (var _ = new Array(x), $ = arguments.length >= 2 ? arguments[1] : void 0, b = 0; b < x; b++)
        b in y && (_[b] = v.call($, y[b], b, y));
      return _;
    });
    var n = "A".charCodeAt(0), a = "Z".charCodeAt(0);
    function s(v) {
      return v = v.toUpperCase(), v = v.substr(4) + v.substr(0, 4), v.split("").map(function(y) {
        var x = y.charCodeAt(0);
        return x >= n && x <= a ? x - n + 10 : y;
      }).join("");
    }
    function o(v) {
      for (var y = v, x; y.length > 2; )
        x = y.slice(0, 9), y = parseInt(x, 10) % 97 + y.slice(x.length);
      return parseInt(y, 10) % 97;
    }
    function c(v) {
      var y = v.match(/(.{3})/g).map(function(x) {
        var _, $ = x.slice(0, 1), b = parseInt(x.slice(1), 10);
        switch ($) {
          case "A":
            _ = "0-9A-Za-z";
            break;
          case "B":
            _ = "0-9A-Z";
            break;
          case "C":
            _ = "A-Za-z";
            break;
          case "F":
            _ = "0-9";
            break;
          case "L":
            _ = "a-z";
            break;
          case "U":
            _ = "A-Z";
            break;
          case "W":
            _ = "0-9a-z";
            break;
        }
        return "([" + _ + "]{" + b + "})";
      });
      return new RegExp("^" + y.join("") + "$");
    }
    function l(v) {
      return v.replace(p, "").toUpperCase();
    }
    function d(v, y, x, _) {
      this.countryCode = v, this.length = y, this.structure = x, this.example = _;
    }
    d.prototype._regex = function() {
      return this._cachedRegex || (this._cachedRegex = c(this.structure));
    }, d.prototype.isValid = function(v) {
      return this.length == v.length && this.countryCode === v.slice(0, 2) && this._regex().test(v.slice(4)) && o(s(v)) == 1;
    }, d.prototype.toBBAN = function(v, y) {
      return this._regex().exec(v.slice(4)).slice(1).join(y);
    }, d.prototype.fromBBAN = function(v) {
      if (!this.isValidBBAN(v))
        throw new Error("Invalid BBAN");
      var y = o(s(this.countryCode + "00" + v)), x = ("0" + (98 - y)).slice(-2);
      return this.countryCode + x + v;
    }, d.prototype.isValidBBAN = function(v) {
      return this.length - 4 == v.length && this._regex().test(v);
    };
    var h = {};
    function u(v) {
      h[v.countryCode] = v;
    }
    u(new d("AD", 24, "F04F04A12", "AD1200012030200359100100")), u(new d("AE", 23, "F03F16", "AE070331234567890123456")), u(new d("AL", 28, "F08A16", "AL47212110090000000235698741")), u(new d("AT", 20, "F05F11", "AT611904300234573201")), u(new d("AZ", 28, "U04A20", "AZ21NABZ00000000137010001944")), u(new d("BA", 20, "F03F03F08F02", "BA391290079401028494")), u(new d("BE", 16, "F03F07F02", "BE68539007547034")), u(new d("BG", 22, "U04F04F02A08", "BG80BNBG96611020345678")), u(new d("BH", 22, "U04A14", "BH67BMAG00001299123456")), u(new d("BR", 29, "F08F05F10U01A01", "BR9700360305000010009795493P1")), u(new d("BY", 28, "A04F04A16", "BY13NBRB3600900000002Z00AB00")), u(new d("CH", 21, "F05A12", "CH9300762011623852957")), u(new d("CR", 22, "F04F14", "CR72012300000171549015")), u(new d("CY", 28, "F03F05A16", "CY17002001280000001200527600")), u(new d("CZ", 24, "F04F06F10", "CZ6508000000192000145399")), u(new d("DE", 22, "F08F10", "DE89370400440532013000")), u(new d("DK", 18, "F04F09F01", "DK5000400440116243")), u(new d("DO", 28, "U04F20", "DO28BAGR00000001212453611324")), u(new d("EE", 20, "F02F02F11F01", "EE382200221020145685")), u(new d("EG", 29, "F04F04F17", "EG800002000156789012345180002")), u(new d("ES", 24, "F04F04F01F01F10", "ES9121000418450200051332")), u(new d("FI", 18, "F06F07F01", "FI2112345600000785")), u(new d("FO", 18, "F04F09F01", "FO6264600001631634")), u(new d("FR", 27, "F05F05A11F02", "FR1420041010050500013M02606")), u(new d("GB", 22, "U04F06F08", "GB29NWBK60161331926819")), u(new d("GE", 22, "U02F16", "GE29NB0000000101904917")), u(new d("GI", 23, "U04A15", "GI75NWBK000000007099453")), u(new d("GL", 18, "F04F09F01", "GL8964710001000206")), u(new d("GR", 27, "F03F04A16", "GR1601101250000000012300695")), u(new d("GT", 28, "A04A20", "GT82TRAJ01020000001210029690")), u(new d("HR", 21, "F07F10", "HR1210010051863000160")), u(new d("HU", 28, "F03F04F01F15F01", "HU42117730161111101800000000")), u(new d("IE", 22, "U04F06F08", "IE29AIBK93115212345678")), u(new d("IL", 23, "F03F03F13", "IL620108000000099999999")), u(new d("IS", 26, "F04F02F06F10", "IS140159260076545510730339")), u(new d("IT", 27, "U01F05F05A12", "IT60X0542811101000000123456")), u(new d("IQ", 23, "U04F03A12", "IQ98NBIQ850123456789012")), u(new d("JO", 30, "A04F22", "JO15AAAA1234567890123456789012")), u(new d("KW", 30, "U04A22", "KW81CBKU0000000000001234560101")), u(new d("KZ", 20, "F03A13", "KZ86125KZT5004100100")), u(new d("LB", 28, "F04A20", "LB62099900000001001901229114")), u(new d("LC", 32, "U04F24", "LC07HEMM000100010012001200013015")), u(new d("LI", 21, "F05A12", "LI21088100002324013AA")), u(new d("LT", 20, "F05F11", "LT121000011101001000")), u(new d("LU", 20, "F03A13", "LU280019400644750000")), u(new d("LV", 21, "U04A13", "LV80BANK0000435195001")), u(new d("MC", 27, "F05F05A11F02", "MC5811222000010123456789030")), u(new d("MD", 24, "U02A18", "MD24AG000225100013104168")), u(new d("ME", 22, "F03F13F02", "ME25505000012345678951")), u(new d("MK", 19, "F03A10F02", "MK07250120000058984")), u(new d("MR", 27, "F05F05F11F02", "MR1300020001010000123456753")), u(new d("MT", 31, "U04F05A18", "MT84MALT011000012345MTLCAST001S")), u(new d("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR")), u(new d("NL", 18, "U04F10", "NL91ABNA0417164300")), u(new d("NO", 15, "F04F06F01", "NO9386011117947")), u(new d("PK", 24, "U04A16", "PK36SCBL0000001123456702")), u(new d("PL", 28, "F08F16", "PL61109010140000071219812874")), u(new d("PS", 29, "U04A21", "PS92PALS000000000400123456702")), u(new d("PT", 25, "F04F04F11F02", "PT50000201231234567890154")), u(new d("QA", 29, "U04A21", "QA30AAAA123456789012345678901")), u(new d("RO", 24, "U04A16", "RO49AAAA1B31007593840000")), u(new d("RS", 22, "F03F13F02", "RS35260005601001611379")), u(new d("SA", 24, "F02A18", "SA0380000000608010167519")), u(new d("SC", 31, "U04F04F16U03", "SC18SSCB11010000000000001497USD")), u(new d("SE", 24, "F03F16F01", "SE4550000000058398257466")), u(new d("SI", 19, "F05F08F02", "SI56263300012039086")), u(new d("SK", 24, "F04F06F10", "SK3112000000198742637541")), u(new d("SM", 27, "U01F05F05A12", "SM86U0322509800000000270100")), u(new d("ST", 25, "F08F11F02", "ST68000100010051845310112")), u(new d("SV", 28, "U04F20", "SV62CENR00000000000000700025")), u(new d("TL", 23, "F03F14F02", "TL380080012345678910157")), u(new d("TN", 24, "F02F03F13F02", "TN5910006035183598478831")), u(new d("TR", 26, "F05F01A16", "TR330006100519786457841326")), u(new d("UA", 29, "F25", "UA511234567890123456789012345")), u(new d("VA", 22, "F18", "VA59001123000012345678")), u(new d("VG", 24, "U04F16", "VG96VPVG0000012345678901")), u(new d("XK", 20, "F04F10F02", "XK051212012345678906")), u(new d("AO", 25, "F21", "AO69123456789012345678901")), u(new d("BF", 27, "F23", "BF2312345678901234567890123")), u(new d("BI", 16, "F12", "BI41123456789012")), u(new d("BJ", 28, "F24", "BJ39123456789012345678901234")), u(new d("CI", 28, "U02F22", "CI70CI1234567890123456789012")), u(new d("CM", 27, "F23", "CM9012345678901234567890123")), u(new d("CV", 25, "F21", "CV30123456789012345678901")), u(new d("DZ", 24, "F20", "DZ8612345678901234567890")), u(new d("IR", 26, "F22", "IR861234568790123456789012")), u(new d("MG", 27, "F23", "MG1812345678901234567890123")), u(new d("ML", 28, "U01F23", "ML15A12345678901234567890123")), u(new d("MZ", 25, "F21", "MZ25123456789012345678901")), u(new d("SN", 28, "U01F23", "SN52A12345678901234567890123")), u(new d("GF", 27, "F05F05A11F02", "GF121234512345123456789AB13")), u(new d("GP", 27, "F05F05A11F02", "GP791234512345123456789AB13")), u(new d("MQ", 27, "F05F05A11F02", "MQ221234512345123456789AB13")), u(new d("RE", 27, "F05F05A11F02", "RE131234512345123456789AB13")), u(new d("PF", 27, "F05F05A11F02", "PF281234512345123456789AB13")), u(new d("TF", 27, "F05F05A11F02", "TF891234512345123456789AB13")), u(new d("YT", 27, "F05F05A11F02", "YT021234512345123456789AB13")), u(new d("NC", 27, "F05F05A11F02", "NC551234512345123456789AB13")), u(new d("BL", 27, "F05F05A11F02", "BL391234512345123456789AB13")), u(new d("MF", 27, "F05F05A11F02", "MF551234512345123456789AB13")), u(new d("PM", 27, "F05F05A11F02", "PM071234512345123456789AB13")), u(new d("WF", 27, "F05F05A11F02", "WF621234512345123456789AB13"));
    var p = /[^a-zA-Z0-9]/g, m = /(.{4})(?!$)/g;
    function g(v) {
      return typeof v == "string" || v instanceof String;
    }
    r.isValid = function(v) {
      if (!g(v))
        return !1;
      v = l(v);
      var y = h[v.slice(0, 2)];
      return !!y && y.isValid(v);
    }, r.toBBAN = function(v, y) {
      typeof y > "u" && (y = " "), v = l(v);
      var x = h[v.slice(0, 2)];
      if (!x)
        throw new Error("No country with code " + v.slice(0, 2));
      return x.toBBAN(v, y);
    }, r.fromBBAN = function(v, y) {
      var x = h[v];
      if (!x)
        throw new Error("No country with code " + v);
      return x.fromBBAN(l(y));
    }, r.isValidBBAN = function(v, y) {
      if (!g(y))
        return !1;
      var x = h[v];
      return x && x.isValidBBAN(l(y));
    }, r.printFormat = function(v, y) {
      return typeof y > "u" && (y = " "), l(v).replace(m, "$1" + y);
    }, r.electronicFormat = l, r.countries = h;
  });
})(iban);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = ($) => n($, "__esModule", { value: !0 }), d = ($, b) => {
    l($);
    for (var M in b)
      n($, M, { get: b[M], enumerable: !0 });
  }, h = ($, b, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let C of s(b))
        !c.call($, C) && C !== "default" && n($, C, { get: () => b[C], enumerable: !(M = a(b, C)) || M.enumerable });
    return $;
  }, u = ($) => h(l(n($ != null ? r(o($)) : {}, "default", $ && $.__esModule && "default" in $ ? { get: () => $.default, enumerable: !0 } : { value: $, enumerable: !0 })), $);
  d(t, {
    default: () => _
  });
  var p = u(iban);
  const m = "string", g = ($) => typeof $ === m;
  var _ = {
    message: () => "invalid_iban",
    validate: ($) => g($) ? p.default.isValid($) : !1
  };
})(iban$1);
var nieSupportNumber = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $
  });
  var p = u(requireUtils());
  const m = "string", g = /^[E,C][0-9]{8}$/, v = (b) => typeof b === m;
  var $ = {
    message: () => "invalid_nie_support_number",
    validate: (b) => v(b) ? (0, p.regexTest)(b, g) : !1
  };
})(nieSupportNumber);
var password = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (C) => n(C, "__esModule", { value: !0 }), d = (C, S) => {
    l(C);
    for (var A in S)
      n(C, A, { get: S[A], enumerable: !0 });
  }, h = (C, S, A) => {
    if (S && typeof S == "object" || typeof S == "function")
      for (let D of s(S))
        !c.call(C, D) && D !== "default" && n(C, D, { get: () => S[D], enumerable: !(A = a(S, D)) || A.enumerable });
    return C;
  }, u = (C) => h(l(n(C != null ? r(o(C)) : {}, "default", C && C.__esModule && "default" in C ? { get: () => C.default, enumerable: !0 } : { value: C, enumerable: !0 })), C);
  d(t, {
    default: () => M
  });
  var p = u(requireUtils());
  const y = {
    strong: {
      message: () => "password_strong",
      regexp: /^.*(?=.{10,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/
    },
    medium: {
      message: () => "password_medium",
      regexp: /^.*(?=.{8,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/
    },
    low: {
      message: () => "password_low",
      regexp: /^.*(?=.{6,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/
    }
  };
  var M = {
    validate: (C) => (0, p.regexTest)(C, y.low.regexp),
    message: () => "invalid_password",
    passwordLevel: (C) => {
      let S;
      for (const A of Object.values(y))
        if ((0, p.regexTest)(C, A.regexp)) {
          S = A;
          break;
        }
      return S ? S.message() : y.low.message();
    }
  };
})(password);
var regex = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = ($) => n($, "__esModule", { value: !0 }), d = ($, b) => {
    l($);
    for (var M in b)
      n($, M, { get: b[M], enumerable: !0 });
  }, h = ($, b, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let C of s(b))
        !c.call($, C) && C !== "default" && n($, C, { get: () => b[C], enumerable: !(M = a(b, C)) || M.enumerable });
    return $;
  }, u = ($) => h(l(n($ != null ? r(o($)) : {}, "default", $ && $.__esModule && "default" in $ ? { get: () => $.default, enumerable: !0 } : { value: $, enumerable: !0 })), $);
  d(t, {
    default: () => _
  });
  var p = u(requireUtils());
  const m = "string", g = ($) => typeof $ === m;
  var _ = {
    message: () => "invalid_field",
    validate: ($, { regex: b } = {}) => g($) ? (0, p.regexTest)($, new RegExp(b)) : !1
  };
})(regex);
var required = {};
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = ($) => n($, "__esModule", { value: !0 }), d = ($, b) => {
    l($);
    for (var M in b)
      n($, M, { get: b[M], enumerable: !0 });
  }, h = ($, b, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let C of s(b))
        !c.call($, C) && C !== "default" && n($, C, { get: () => b[C], enumerable: !(M = a(b, C)) || M.enumerable });
    return $;
  }, u = ($) => h(l(n($ != null ? r(o($)) : {}, "default", $ && $.__esModule && "default" in $ ? { get: () => $.default, enumerable: !0 } : { value: $, enumerable: !0 })), $);
  d(t, {
    default: () => _
  });
  var p = u(requireUtils());
  const m = /([^\s])/g, g = ($) => !(typeof $ > "u" || $ === null);
  var _ = {
    message: () => "invalid_required",
    validate: ($, { required: b = !0 } = {}) => b ? g($) ? (0, p.regexTest)($, m) : !1 : !0
  };
})(required);
var rfc = {}, utils = {};
(function(t) {
  var r = Object.defineProperty, n = (b) => r(b, "__esModule", { value: !0 }), a = (b, M) => {
    n(b);
    for (var C in M)
      r(b, C, { get: M[C], enumerable: !0 });
  };
  a(t, {
    calculateHomoClaveAndDigitalVerify: () => v,
    calculateQuotient: () => g,
    equivalencesLetters: () => h,
    equivalencesOne: () => l,
    equivalencesTwo: () => d,
    formatTextRFC: () => y,
    getHomoclave: () => _,
    inconvenientWords: () => c,
    isVowel: () => $,
    names: () => o,
    removeInconvenientWords: () => x,
    removeNames: () => m,
    removeWords: () => p,
    toRemoveWords: () => s,
    vowelWithAccent: () => u
  });
  const s = [
    " PARA ",
    " AND ",
    " CON ",
    " DEL ",
    " LAS ",
    " LOS ",
    " MAC ",
    " POR ",
    " SUS ",
    " THE ",
    " VAN ",
    " VON ",
    " AL ",
    " DE ",
    " EL ",
    " EN ",
    " LA ",
    " MC ",
    " MI ",
    " OF ",
    " A ",
    " E ",
    " Y "
  ], o = [" MARIA ", " JOSE ", " MA. ", " MA ", " J. ", " J ", " MARÍA "], c = [
    "BUEI",
    "BUEY",
    "CACA",
    "CACO",
    "CAGA",
    "CAGO",
    "CAKA",
    "CAKO",
    "COGE",
    "COJA",
    "COJE",
    "COJI",
    "COJO",
    "CULO",
    "FETO",
    "GUEY",
    "JOTO",
    "KACA",
    "KACO",
    "KAGA",
    "KAGO",
    "KOGE",
    "KOJO",
    "KAKA",
    "KULO",
    "MAME",
    "MAMO",
    "MEAR",
    "MEAS",
    "MEON",
    "MION",
    "MOCO",
    "MULA",
    "PEDA",
    "PEDO",
    "PENE",
    "PUTA",
    "PUTO",
    "QULO",
    "RATA",
    "RUIN"
  ], l = {
    0: "00",
    C: "13",
    P: "27",
    1: "01",
    D: "14",
    Q: "28",
    2: "02",
    E: "15",
    R: "29",
    3: "03",
    F: "16",
    S: "32",
    4: "04",
    G: "17",
    T: "33",
    5: "05",
    H: "18",
    U: "34",
    6: "06",
    I: "19",
    V: "35",
    7: "07",
    J: "21",
    W: "36",
    8: "08",
    K: "22",
    X: "37",
    9: "09",
    L: "23",
    Y: "38",
    "&": "10",
    M: "24",
    Z: "39",
    A: "11",
    N: "25",
    Ñ: "40",
    B: "12",
    O: "26"
  }, d = {
    0: "1",
    17: "I",
    1: "2",
    18: "J",
    2: "3",
    19: "K",
    3: "4",
    20: "L",
    4: "5",
    21: "M",
    5: "6",
    22: "N",
    6: "7",
    23: "P",
    7: "8",
    24: "Q",
    8: "9",
    25: "R",
    9: "A",
    26: "S",
    10: "B",
    27: "T",
    11: "C",
    28: "U",
    12: "D",
    13: "E",
    14: "F",
    15: "G",
    16: "H",
    29: "V",
    30: "W",
    31: "X",
    32: "Y",
    33: "Z"
  }, h = {
    0: "00",
    1: "01",
    2: "02",
    3: "03",
    4: "04",
    5: "05",
    6: "06",
    7: "07",
    8: "08",
    9: "09",
    A: "10",
    B: "11",
    C: "12",
    D: "13",
    E: "14",
    F: "15",
    G: "16",
    H: "17",
    I: "18",
    J: "19",
    K: "20",
    L: "21",
    M: "22",
    N: "23",
    O: "25",
    P: "26",
    Q: "27",
    R: "28",
    S: "29",
    T: "30",
    U: "31",
    V: "32",
    W: "33",
    X: "34",
    Y: "35",
    Z: "36",
    Ñ: "38",
    BLANCO: "37",
    "&": "24"
  }, u = {
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U"
  };
  function p(b) {
    b = ` ${b}`;
    for (let M = 0; M < s.length; M++)
      b = b.replace(new RegExp(s[M], "gi"), " ");
    return b.trim();
  }
  function m(b) {
    b = ` ${b}`;
    for (let M = 0; M < o.length; M++)
      b = b.replace(new RegExp(o[M], "gi"), " ");
    return p(b.trim());
  }
  function g(b, M) {
    let C = 0;
    b.forEach((T) => {
      const R = T[1];
      C += parseInt(T) * parseInt(R);
    }), C += parseInt(M[0][1]) * parseInt(M[0][1]);
    const S = C % 1e3, A = Math.floor(S / 34), D = S % 34;
    return d[A] + d[D];
  }
  function v(b) {
    const M = [];
    for (let D = 0; D < b.length; D++) {
      const N = b[D], T = l[N], R = D === 0 ? `0${T}` : N.includes(" ") ? "00" : T;
      R && M.push(R);
    }
    const C = [], S = M.join("").substring(1);
    for (let D = 0; D < S.length - 1; D++)
      C.push(S[D] + S[D + 1]);
    return g(C, M);
  }
  function y(b) {
    return b.toUpperCase().replace(/Á|É|Í|Ó|Ú/g, (M) => u[M]);
  }
  function x(b) {
    const M = b.split(" ");
    for (let C = 0; C < M.length; C++)
      c.includes(M[C]) && (M[C] = `${M[C].slice(0, -1)}X`);
    return M.join(" ");
  }
  function _(b) {
    let M = 0;
    for (let S = 0; S < b.length; S++) {
      const A = b[S], D = h[A], N = 13 - S;
      M += parseInt(D) * N;
    }
    const C = M % 11;
    if (C === 0)
      return "0";
    if (C > 0) {
      const S = Math.abs(C - 11);
      return S === 10 ? "A" : S.toString();
    }
  }
  function $(b) {
    return "AEIOU".includes(b);
  }
})(utils);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (b) => n(b, "__esModule", { value: !0 }), d = (b, M) => {
    l(b);
    for (var C in M)
      n(b, C, { get: M[C], enumerable: !0 });
  }, h = (b, M, C) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let S of s(M))
        !c.call(b, S) && S !== "default" && n(b, S, { get: () => M[S], enumerable: !(C = a(M, S)) || C.enumerable });
    return b;
  }, u = (b) => h(l(n(b != null ? r(o(b)) : {}, "default", b && b.__esModule && "default" in b ? { get: () => b.default, enumerable: !0 } : { value: b, enumerable: !0 })), b);
  d(t, {
    default: () => $,
    generateRfc: () => x
  });
  var p = u(utils);
  const m = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/, g = (b, M = !0) => !!b.match(m), v = () => "invalid_rfc", y = (b) => {
    const M = b.toUpperCase();
    return g(M);
  };
  function x(b, M, C, S) {
    const A = b, D = M, N = C;
    b = (0, p.removeNames)(b), M = (0, p.removeWords)(M), C = (0, p.removeWords)(C);
    const T = M.substring(0, 1);
    let R = "";
    for (let U = 1; U < M.length; U++)
      if ((0, p.isVowel)(M.charAt(U))) {
        R = M.charAt(U);
        break;
      }
    const F = (0, p.calculateHomoClaveAndDigitalVerify)(`${(0, p.formatTextRFC)(D)} ${(0, p.formatTextRFC)(N)} ${(0, p.formatTextRFC)(A)}`), z = C ? C.substring(0, 1) : b.substring(0, 2), O = b.substring(0, 1), G = C ? `${z}${O}` : `${z}`, I = S.substring(8, 10), k = S.substring(3, 5).substring(0, 2), B = S.substring(0, 2), L = `${(0, p.removeInconvenientWords)(`${T}${R}${G}`)}${I}${k}${B}${F}`, V = (0, p.getHomoclave)(L);
    return `${L}${V}`;
  }
  var $ = {
    validate: y,
    message: v,
    generateRfc: x
  };
})(rfc);
(function(t) {
  var r = Object.create, n = Object.defineProperty, a = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (A) => n(A, "__esModule", { value: !0 }), d = (A, D) => {
    l(A);
    for (var N in D)
      n(A, N, { get: D[N], enumerable: !0 });
  }, h = (A, D, N) => {
    if (D && typeof D == "object" || typeof D == "function")
      for (let T of s(D))
        !c.call(A, T) && T !== "default" && n(A, T, { get: () => D[T], enumerable: !(N = a(D, T)) || N.enumerable });
    return A;
  }, u = (A) => h(l(n(A != null ? r(o(A)) : {}, "default", A && A.__esModule && "default" in A ? { get: () => A.default, enumerable: !0 } : { value: A, enumerable: !0 })), A);
  d(t, {
    AeatAmount: () => p.default,
    AeatAppCode: () => m.default,
    AeatAppPin: () => g.default,
    AeatReferenceNumber: () => v.default,
    Email: () => y.default,
    EmailValidationCode: () => x.default,
    Iban: () => _.default,
    NieSupportNumber: () => $.default,
    Password: () => b.default,
    Regex: () => M.default,
    Required: () => C.default,
    Rfc: () => S.default
  });
  var p = u(aeatAmount), m = u(aeatAppCode), g = u(aeatAppPin), v = u(aeatReferenceNumber), y = u(email), x = u(emailValidationCode), _ = u(iban$1), $ = u(nieSupportNumber), b = u(password), M = u(regex), C = u(required), S = u(rfc);
})(validations$1);
const index$2 = /* @__PURE__ */ getDefaultExportFromCjs(validations$1), validations = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: index$2
}, [validations$1]);
var InputFormTypes = /* @__PURE__ */ ((t) => (t.AMOUNT_DOLLAR_MXN = "amount_dollar_MXN", t.AMOUNT_EURO = "amount_euro", t.BANNER_ALERT = "banner_alert", t.BANNER_ERROR = "banner_error", t.BANNER_INFO = "banner_info", t.BANNER_SUCCESS = "banner_success", t.BANNER_WARNING = "banner_warning", t.CADASTER = "cadaster", t.CHECKBOX = "checkbox", t.CHECKBOXCARD = "checkboxCard", t.CIF = "cif", t.COUNTER_DAY = "counter_day", t.DATE = "date", t.DECIMAL = "decimal", t.DROPDOWN = "dropdown", t.EMAIL = "email", t.IBAN = "iban", t.INTEGER = "integer", t.LABEL_BOLD = "label_bold", t.LABEL_TITLE = "label_title", t.NIE = "nie", t.NIF = "nif", t.NIF_NIE = "nif_nie", t.NIF_NIE_CIF = "nif_nie_cif", t.PASSWORD = "password", t.PERCENTAGE = "percentage", t.RADIO = "radio", t.RADIOCARD = "radioCard", t.TEXT = "text", t.WIZARD = "wizard", t.RFC_FISICA = "rfc_fisica", t.RFC_MORAL = "rfc_moral", t.RFC_FISICAL_MORAL = "rfc_fisical_moral", t.ADDRESS = "Address", t.YES_NO_RADIO = "yes_no_radio", t.FILE = "file", t.TEXT_AREA = "comment", t))(InputFormTypes || {});
const parseNumber = (t) => {
  const r = parseInt(t, 10);
  return Number.isNaN(r) ? t : r;
};
function convertToType(t, r) {
  return t && t.constructor(r);
}
const parseIntlNumber = (t) => {
  try {
    const r = parseFloat(
      t.toString().replace(",", ".").replace(/[.](?=.*[.])/g, "").replace(/[. ,](\d\d\d\D|\d\d\d$)/g, "$1")
    );
    return Number.isNaN(r) ? t : r;
  } catch {
    return t;
  }
}, removeSpaces = (t) => t ? t.split(" ").join("") : "", validationParsers = {
  [InputFormTypes.EMAIL]: (t) => removeSpaces(formatToLowerCase(t)),
  [InputFormTypes.NIE]: (t) => removeSpaces(formatToUpperCase(t)),
  [InputFormTypes.NIF]: (t) => removeSpaces(formatToUpperCase(t)),
  [InputFormTypes.NIF_NIE]: (t) => removeSpaces(formatToUpperCase(t)),
  [InputFormTypes.NIF_NIE_CIF]: (t) => removeSpaces(formatToUpperCase(t)),
  [InputFormTypes.CIF]: (t) => removeSpaces(formatToUpperCase(t)),
  [InputFormTypes.TEXT]: (t) => formatToUpperCase(t),
  [InputFormTypes.CADASTER]: (t) => removeSpaces(formatToUpperCase(t)),
  [InputFormTypes.AMOUNT_EURO]: (t) => parseIntlNumber(t),
  [InputFormTypes.AMOUNT_DOLLAR_MXN]: (t) => parseIntlNumber(t),
  [InputFormTypes.CHECKBOX]: (t) => t ? 1 : 0,
  [InputFormTypes.CHECKBOXCARD]: (t) => t ? 1 : 0,
  [InputFormTypes.DATE]: (t) => t && t.replace(/-|\//g, ""),
  [InputFormTypes.DECIMAL]: (t) => parseIntlNumber(t),
  [InputFormTypes.PERCENTAGE]: (t) => parseIntlNumber(t),
  [InputFormTypes.INTEGER]: (t) => parseNumber(t),
  [InputFormTypes.IBAN]: (t) => t.replace(/ /g, ""),
  [InputFormTypes.ADDRESS]: (t) => model.TYPES[InputFormTypes.ADDRESS].sanitize(t)
};
function ownKeys$2(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread2(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(n), !0).forEach(function(a) {
      _defineProperty$e(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$2(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _arrayWithHoles$2(t) {
  if (Array.isArray(t))
    return t;
}
function _iterableToArrayLimit$2(t, r) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a, s, o, c, l = [], d = !0, h = !1;
    try {
      if (o = (n = n.call(t)).next, r === 0) {
        if (Object(n) !== n)
          return;
        d = !1;
      } else
        for (; !(d = (a = o.call(n)).done) && (l.push(a.value), l.length !== r); d = !0)
          ;
    } catch (u) {
      h = !0, s = u;
    } finally {
      try {
        if (!d && n.return != null && (c = n.return(), Object(c) !== c))
          return;
      } finally {
        if (h)
          throw s;
      }
    }
    return l;
  }
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$2(t, r) {
  return _arrayWithHoles$2(t) || _iterableToArrayLimit$2(t, r) || _unsupportedIterableToArray$o(t, r) || _nonIterableRest$2();
}
function _objectWithoutProperties$1(t, r) {
  if (t == null)
    return {};
  var n, a, s = _objectWithoutPropertiesLoose$b(t, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      n = o[a], r.indexOf(n) === -1 && {}.propertyIsEnumerable.call(t, n) && (s[n] = t[n]);
  }
  return s;
}
var _excluded$6 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(t) {
  var r = t.defaultInputValue, n = r === void 0 ? "" : r, a = t.defaultMenuIsOpen, s = a === void 0 ? !1 : a, o = t.defaultValue, c = o === void 0 ? null : o, l = t.inputValue, d = t.menuIsOpen, h = t.onChange, u = t.onInputChange, p = t.onMenuClose, m = t.onMenuOpen, g = t.value, v = _objectWithoutProperties$1(t, _excluded$6), y = useState(l !== void 0 ? l : n), x = _slicedToArray$2(y, 2), _ = x[0], $ = x[1], b = useState(d !== void 0 ? d : s), M = _slicedToArray$2(b, 2), C = M[0], S = M[1], A = useState(g !== void 0 ? g : c), D = _slicedToArray$2(A, 2), N = D[0], T = D[1], R = useCallback(function(B, L) {
    typeof h == "function" && h(B, L), T(B);
  }, [h]), F = useCallback(function(B, L) {
    var V;
    typeof u == "function" && (V = u(B, L)), $(V !== void 0 ? V : B);
  }, [u]), z = useCallback(function() {
    typeof m == "function" && m(), S(!0);
  }, [m]), O = useCallback(function() {
    typeof p == "function" && p(), S(!1);
  }, [p]), G = l !== void 0 ? l : _, I = d !== void 0 ? d : C, k = g !== void 0 ? g : N;
  return _objectSpread2(_objectSpread2({}, v), {}, {
    inputValue: G,
    menuIsOpen: I,
    onChange: R,
    onInputChange: F,
    onMenuClose: O,
    onMenuOpen: z,
    value: k
  });
}
function _arrayWithoutHoles$2(t) {
  if (Array.isArray(t))
    return _arrayLikeToArray$o(t);
}
function _iterableToArray$2(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray$2(t) {
  return _arrayWithoutHoles$2(t) || _iterableToArray$2(t) || _unsupportedIterableToArray$o(t) || _nonIterableSpread$2();
}
var isDevelopment$2 = !1;
function sheetForTag(t) {
  if (t.sheet)
    return t.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === t)
      return document.styleSheets[r];
}
function createStyleElement(t) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", t.key), t.nonce !== void 0 && r.setAttribute("nonce", t.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var StyleSheet = /* @__PURE__ */ function() {
  function t(n) {
    var a = this;
    this._insertTag = function(s) {
      var o;
      a.tags.length === 0 ? a.insertionPoint ? o = a.insertionPoint.nextSibling : a.prepend ? o = a.container.firstChild : o = a.before : o = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(s, o), a.tags.push(s);
    }, this.isSpeedy = n.speedy === void 0 ? !isDevelopment$2 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = t.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var s = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = sheetForTag(s);
      try {
        o.insertRule(a, o.cssRules.length);
      } catch {
      }
    } else
      s.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      var s;
      return (s = a.parentNode) == null ? void 0 : s.removeChild(a);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign = Object.assign;
function hash(t, r) {
  return charat(t, 0) ^ 45 ? (((r << 2 ^ charat(t, 0)) << 2 ^ charat(t, 1)) << 2 ^ charat(t, 2)) << 2 ^ charat(t, 3) : 0;
}
function trim(t) {
  return t.trim();
}
function match(t, r) {
  return (t = r.exec(t)) ? t[0] : t;
}
function replace(t, r, n) {
  return t.replace(r, n);
}
function indexof(t, r) {
  return t.indexOf(r);
}
function charat(t, r) {
  return t.charCodeAt(r) | 0;
}
function substr(t, r, n) {
  return t.slice(r, n);
}
function strlen(t) {
  return t.length;
}
function sizeof(t) {
  return t.length;
}
function append(t, r) {
  return r.push(t), t;
}
function combine(t, r) {
  return t.map(r).join("");
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(t, r, n, a, s, o, c) {
  return { value: t, root: r, parent: n, type: a, props: s, children: o, line, column, length: c, return: "" };
}
function copy(t, r) {
  return assign(node("", null, null, "", null, null, 0), t, { length: -t.length }, r);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(t, r) {
  return substr(characters, t, r);
}
function token(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(t) {
  return line = column = 1, length = strlen(characters = t), position = 0, [];
}
function dealloc(t) {
  return characters = "", t;
}
function delimit(t) {
  return trim(slice(position - 1, delimiter(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function whitespace(t) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(t) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(t, r) {
  for (; --r && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(t, caret() + (r < 6 && peek() == 32 && next() == 32));
}
function delimiter(t) {
  for (; next(); )
    switch (character) {
      case t:
        return position;
      case 34:
      case 39:
        t !== 34 && t !== 39 && delimiter(character);
        break;
      case 40:
        t === 41 && delimiter(t);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(t, r) {
  for (; next() && t + character !== 47 + 10; )
    if (t + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(r, position - 1) + "*" + from(t === 47 ? t : next());
}
function identifier(t) {
  for (; !token(peek()); )
    next();
  return slice(t, position);
}
function compile(t) {
  return dealloc(parse("", null, null, null, [""], t = alloc(t), 0, [0], t));
}
function parse(t, r, n, a, s, o, c, l, d) {
  for (var h = 0, u = 0, p = c, m = 0, g = 0, v = 0, y = 1, x = 1, _ = 1, $ = 0, b = "", M = s, C = o, S = a, A = b; x; )
    switch (v = $, $ = next()) {
      case 40:
        if (v != 108 && charat(A, p - 1) == 58) {
          indexof(A += replace(delimit($), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += delimit($);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += whitespace(v);
        break;
      case 92:
        A += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), r, n), d);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * y:
        l[h++] = strlen(A) * _;
      case 125 * y:
      case 59:
      case 0:
        switch ($) {
          case 0:
          case 125:
            x = 0;
          case 59 + u:
            _ == -1 && (A = replace(A, /\f/g, "")), g > 0 && strlen(A) - p && append(g > 32 ? declaration(A + ";", a, n, p - 1) : declaration(replace(A, " ", "") + ";", a, n, p - 2), d);
            break;
          case 59:
            A += ";";
          default:
            if (append(S = ruleset(A, r, n, h, u, s, l, b, M = [], C = [], p), o), $ === 123)
              if (u === 0)
                parse(A, r, S, S, M, o, p, l, C);
              else
                switch (m === 99 && charat(A, 3) === 110 ? 100 : m) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(t, S, S, a && append(ruleset(t, S, S, 0, 0, s, l, b, s, M = [], p), C), s, C, p, l, a ? M : C);
                    break;
                  default:
                    parse(A, S, S, S, [""], C, 0, l, C);
                }
        }
        h = u = g = 0, y = _ = 1, b = A = "", p = c;
        break;
      case 58:
        p = 1 + strlen(A), g = v;
      default:
        if (y < 1) {
          if ($ == 123)
            --y;
          else if ($ == 125 && y++ == 0 && prev() == 125)
            continue;
        }
        switch (A += from($), $ * y) {
          case 38:
            _ = u > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            l[h++] = (strlen(A) - 1) * _, _ = 1;
            break;
          case 64:
            peek() === 45 && (A += delimit(next())), m = peek(), u = p = strlen(b = A += identifier(caret())), $++;
            break;
          case 45:
            v === 45 && strlen(A) == 2 && (y = 0);
        }
    }
  return o;
}
function ruleset(t, r, n, a, s, o, c, l, d, h, u) {
  for (var p = s - 1, m = s === 0 ? o : [""], g = sizeof(m), v = 0, y = 0, x = 0; v < a; ++v)
    for (var _ = 0, $ = substr(t, p + 1, p = abs(y = c[v])), b = t; _ < g; ++_)
      (b = trim(y > 0 ? m[_] + " " + $ : replace($, /&\f/g, m[_]))) && (d[x++] = b);
  return node(t, r, n, s === 0 ? RULESET : l, d, h, u);
}
function comment(t, r, n) {
  return node(t, r, n, COMMENT, from(char()), substr(t, 2, -2), 0);
}
function declaration(t, r, n, a) {
  return node(t, r, n, DECLARATION, substr(t, 0, a), substr(t, a + 1, -1), a);
}
function serialize(t, r) {
  for (var n = "", a = sizeof(t), s = 0; s < a; s++)
    n += r(t[s], s, t, r) || "";
  return n;
}
function stringify(t, r, n, a) {
  switch (t.type) {
    case LAYER:
      if (t.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return t.return = t.return || t.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return t.return = t.value + "{" + serialize(t.children, a) + "}";
    case RULESET:
      t.value = t.props.join(",");
  }
  return strlen(n = serialize(t.children, a)) ? t.return = t.value + "{" + n + "}" : "";
}
function middleware(t) {
  var r = sizeof(t);
  return function(n, a, s, o) {
    for (var c = "", l = 0; l < r; l++)
      c += t[l](n, a, s, o) || "";
    return c;
  };
}
function rulesheet(t) {
  return function(r) {
    r.root || (r = r.return) && t(r);
  };
}
function memoize(t) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = t(n)), r[n];
  };
}
var identifierWithPointTracking = function(r, n, a) {
  for (var s = 0, o = 0; s = o, o = peek(), s === 38 && o === 12 && (n[a] = 1), !token(o); )
    next();
  return slice(r, position);
}, toRules = function(r, n) {
  var a = -1, s = 44;
  do
    switch (token(s)) {
      case 0:
        s === 38 && peek() === 12 && (n[a] = 1), r[a] += identifierWithPointTracking(position - 1, n, a);
        break;
      case 2:
        r[a] += delimit(s);
        break;
      case 4:
        if (s === 44) {
          r[++a] = peek() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += from(s);
    }
  while (s = next());
  return r;
}, getRules = function(r, n) {
  return dealloc(toRules(alloc(r), n));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, s = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !fixedElements.get(a)) && !s) {
      fixedElements.set(r, !0);
      for (var o = [], c = getRules(n, o), l = a.props, d = 0, h = 0; d < c.length; d++)
        for (var u = 0; u < l.length; u++, h++)
          r.props[h] = o[d] ? c[d].replace(/&\f/g, l[u]) : l[u] + " " + c[d];
    }
  }
}, removeLabel = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function prefix(t, r) {
  switch (hash(t, r)) {
    case 5103:
      return WEBKIT + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + t + MOZ + t + MS + t + t;
    case 6828:
    case 4268:
      return WEBKIT + t + MS + t + t;
    case 6165:
      return WEBKIT + t + MS + "flex-" + t + t;
    case 5187:
      return WEBKIT + t + replace(t, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + t;
    case 5443:
      return WEBKIT + t + MS + "flex-item-" + replace(t, /flex-|-self/, "") + t;
    case 4675:
      return WEBKIT + t + MS + "flex-line-pack" + replace(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return WEBKIT + t + MS + replace(t, "shrink", "negative") + t;
    case 5292:
      return WEBKIT + t + MS + replace(t, "basis", "preferred-size") + t;
    case 6060:
      return WEBKIT + "box-" + replace(t, "-grow", "") + WEBKIT + t + MS + replace(t, "grow", "positive") + t;
    case 4554:
      return WEBKIT + replace(t, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + t;
    case 6187:
      return replace(replace(replace(t, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return replace(t, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(t, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(t, /(.+)-inline(.+)/, WEBKIT + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(t) - 1 - r > 6)
        switch (charat(t, r + 1)) {
          case 109:
            if (charat(t, r + 4) !== 45)
              break;
          case 102:
            return replace(t, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(t, r + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~indexof(t, "stretch") ? prefix(replace(t, "stretch", "fill-available"), r) + t : t;
        }
      break;
    case 4949:
      if (charat(t, r + 1) !== 115)
        break;
    case 6444:
      switch (charat(t, strlen(t) - 3 - (~indexof(t, "!important") && 10))) {
        case 107:
          return replace(t, ":", ":" + WEBKIT) + t;
        case 101:
          return replace(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(t, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (charat(t, r + 11)) {
        case 114:
          return WEBKIT + t + MS + replace(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return WEBKIT + t + MS + replace(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return WEBKIT + t + MS + replace(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return WEBKIT + t + MS + t + t;
  }
  return t;
}
var prefixer = function(r, n, a, s) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case DECLARATION:
        r.return = prefix(r.value, r.length);
        break;
      case KEYFRAMES:
        return serialize([copy(r, {
          value: replace(r.value, "@", "@" + WEBKIT)
        })], s);
      case RULESET:
        if (r.length)
          return combine(r.props, function(o) {
            switch (match(o, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return serialize([copy(r, {
                  props: [replace(o, /:(read-\w+)/, ":" + MOZ + "$1")]
                })], s);
              case "::placeholder":
                return serialize([copy(r, {
                  props: [replace(o, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                }), copy(r, {
                  props: [replace(o, /:(plac\w+)/, ":" + MOZ + "$1")]
                }), copy(r, {
                  props: [replace(o, /:(plac\w+)/, MS + "input-$1")]
                })], s);
            }
            return "";
          });
    }
}, defaultStylisPlugins = [prefixer], createCache = function(r) {
  var n = r.key;
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(y) {
      var x = y.getAttribute("data-emotion");
      x.indexOf(" ") !== -1 && (document.head.appendChild(y), y.setAttribute("data-s", ""));
    });
  }
  var s = r.stylisPlugins || defaultStylisPlugins, o = {}, c, l = [];
  c = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(y) {
      for (var x = y.getAttribute("data-emotion").split(" "), _ = 1; _ < x.length; _++)
        o[x[_]] = !0;
      l.push(y);
    }
  );
  var d, h = [compat, removeLabel];
  {
    var u, p = [stringify, rulesheet(function(y) {
      u.insert(y);
    })], m = middleware(h.concat(s, p)), g = function(x) {
      return serialize(compile(x), m);
    };
    d = function(x, _, $, b) {
      u = $, g(x ? x + "{" + _.styles + "}" : _.styles), b && (v.inserted[_.name] = !0);
    };
  }
  var v = {
    key: n,
    sheet: new StyleSheet({
      key: n,
      container: c,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: o,
    registered: {},
    insert: d
  };
  return v.sheet.hydrate(l), v;
}, reactIs = requireReactIs(), FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = !0;
function getRegisteredStyles(t, r, n) {
  var a = "";
  return n.split(" ").forEach(function(s) {
    t[s] !== void 0 ? r.push(t[s] + ";") : a += s + " ";
  }), a;
}
var registerStyles = function(r, n, a) {
  var s = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === !1) && r.registered[s] === void 0 && (r.registered[s] = n.styles);
}, insertStyles = function(r, n, a) {
  registerStyles(r, n, a);
  var s = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var o = n;
    do
      r.insert(n === o ? "." + s : "", o, r.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function murmur2(t) {
  for (var r = 0, n, a = 0, s = t.length; s >= 4; ++a, s -= 4)
    n = t.charCodeAt(a) & 255 | (t.charCodeAt(++a) & 255) << 8 | (t.charCodeAt(++a) & 255) << 16 | (t.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (s) {
    case 3:
      r ^= (t.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (t.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= t.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, isDevelopment$1 = !1, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(r) {
  return r.charCodeAt(1) === 45;
}, isProcessableValue = function(r) {
  return r != null && typeof r != "boolean";
}, processStyleName = /* @__PURE__ */ memoize(function(t) {
  return isCustomProperty(t) ? t : t.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(animationRegex, function(a, s, o) {
          return cursor = {
            name: s,
            styles: o,
            next: cursor
          }, s;
        });
  }
  return unitlessKeys[r] !== 1 && !isCustomProperty(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(t, r, n) {
  if (n == null)
    return "";
  var a = n;
  if (a.__emotion_styles !== void 0)
    return a;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var s = n;
      if (s.anim === 1)
        return cursor = {
          name: s.name,
          styles: s.styles,
          next: cursor
        }, s.name;
      var o = n;
      if (o.styles !== void 0) {
        var c = o.next;
        if (c !== void 0)
          for (; c !== void 0; )
            cursor = {
              name: c.name,
              styles: c.styles,
              next: cursor
            }, c = c.next;
        var l = o.styles + ";";
        return l;
      }
      return createStringFromObject(t, r, n);
    }
    case "function": {
      if (t !== void 0) {
        var d = cursor, h = n(t);
        return cursor = d, handleInterpolation(t, r, h);
      }
      break;
    }
  }
  var u = n;
  if (r == null)
    return u;
  var p = r[u];
  return p !== void 0 ? p : u;
}
function createStringFromObject(t, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var s = 0; s < n.length; s++)
      a += handleInterpolation(t, r, n[s]) + ";";
  else
    for (var o in n) {
      var c = n[o];
      if (typeof c != "object") {
        var l = c;
        r != null && r[l] !== void 0 ? a += o + "{" + r[l] + "}" : isProcessableValue(l) && (a += processStyleName(o) + ":" + processStyleValue(o, l) + ";");
      } else {
        if (o === "NO_COMPONENT_SELECTOR" && isDevelopment$1)
          throw new Error(noComponentSelectorMessage);
        if (Array.isArray(c) && typeof c[0] == "string" && (r == null || r[c[0]] === void 0))
          for (var d = 0; d < c.length; d++)
            isProcessableValue(c[d]) && (a += processStyleName(o) + ":" + processStyleValue(o, c[d]) + ";");
        else {
          var h = handleInterpolation(t, r, c);
          switch (o) {
            case "animation":
            case "animationName": {
              a += processStyleName(o) + ":" + h + ";";
              break;
            }
            default:
              a += o + "{" + h + "}";
          }
        }
      }
    }
  return a;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g, cursor;
function serializeStyles(t, r, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var a = !0, s = "";
  cursor = void 0;
  var o = t[0];
  if (o == null || o.raw === void 0)
    a = !1, s += handleInterpolation(n, r, o);
  else {
    var c = o;
    s += c[0];
  }
  for (var l = 1; l < t.length; l++)
    if (s += handleInterpolation(n, r, t[l]), a) {
      var d = o;
      s += d[l];
    }
  labelPattern.lastIndex = 0;
  for (var h = "", u; (u = labelPattern.exec(s)) !== null; )
    h += "-" + u[1];
  var p = murmur2(s) + h;
  return {
    name: p,
    styles: s,
    next: cursor
  };
}
var syncFallback = function(r) {
  return r();
}, useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, isDevelopment = !1, EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function(r) {
  return /* @__PURE__ */ forwardRef(function(n, a) {
    var s = useContext(EmotionCacheContext);
    return r(n, s, a);
  });
}, ThemeContext = /* @__PURE__ */ React.createContext({}), hasOwn = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function(r, n) {
  var a = {};
  for (var s in n)
    hasOwn.call(n, s) && (a[s] = n[s]);
  return a[typePropName] = r, a;
}, Insertion = function(r) {
  var n = r.cache, a = r.serialized, s = r.isStringTag;
  return registerStyles(n, a, s), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(n, a, s);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(
  /* <any, any> */
  function(t, r, n) {
    var a = t.css;
    typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
    var s = t[typePropName], o = [a], c = "";
    typeof t.className == "string" ? c = getRegisteredStyles(r.registered, o, t.className) : t.className != null && (c = t.className + " ");
    var l = serializeStyles(o, void 0, React.useContext(ThemeContext));
    c += r.key + "-" + l.name;
    var d = {};
    for (var h in t)
      hasOwn.call(t, h) && h !== "css" && h !== typePropName && !isDevelopment && (d[h] = t[h]);
    return d.className = c, n && (d.ref = n), /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1(Insertion, {
        cache: r,
        serialized: l,
        isStringTag: typeof s == "string"
      }), /* @__PURE__ */ jsx$1(s, {
        ...d
      })]
    });
  }
), Emotion$1 = Emotion, jsx = function(r, n) {
  var a = arguments;
  if (n == null || !hasOwn.call(n, "css"))
    return React.createElement.apply(void 0, a);
  var s = a.length, o = new Array(s);
  o[0] = Emotion$1, o[1] = createEmotionProps(r, n);
  for (var c = 2; c < s; c++)
    o[c] = a[c];
  return React.createElement.apply(null, o);
};
function css$2() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return serializeStyles(r);
}
var keyframes = function() {
  var r = css$2.apply(void 0, arguments), n = "animation-" + r.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + r.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
function _taggedTemplateLiteral(t, r) {
  return r || (r = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}
const min = Math.min, max = Math.max, round = Math.round, floor = Math.floor, createCoords = (t) => ({
  x: t,
  y: t
});
function rectToClientRect(t) {
  const {
    x: r,
    y: n,
    width: a,
    height: s
  } = t;
  return {
    width: a,
    height: s,
    top: n,
    left: r,
    right: r + a,
    bottom: n + s,
    x: r,
    y: n
  };
}
function getNodeName(t) {
  return isNode(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function getWindow(t) {
  var r;
  return (t == null || (r = t.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function getDocumentElement(t) {
  var r;
  return (r = (isNode(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : r.documentElement;
}
function isNode(t) {
  return t instanceof Node || t instanceof getWindow(t).Node;
}
function isElement(t) {
  return t instanceof Element || t instanceof getWindow(t).Element;
}
function isHTMLElement(t) {
  return t instanceof HTMLElement || t instanceof getWindow(t).HTMLElement;
}
function isShadowRoot(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof getWindow(t).ShadowRoot;
}
function isOverflowElement(t) {
  const {
    overflow: r,
    overflowX: n,
    overflowY: a,
    display: s
  } = getComputedStyle$1(t);
  return /auto|scroll|overlay|hidden|clip/.test(r + a + n) && !["inline", "contents"].includes(s);
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(t) {
  return ["html", "body", "#document"].includes(getNodeName(t));
}
function getComputedStyle$1(t) {
  return getWindow(t).getComputedStyle(t);
}
function getParentNode(t) {
  if (getNodeName(t) === "html")
    return t;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    isShadowRoot(t) && t.host || // Fallback.
    getDocumentElement(t)
  );
  return isShadowRoot(r) ? r.host : r;
}
function getNearestOverflowAncestor(t) {
  const r = getParentNode(t);
  return isLastTraversableNode(r) ? t.ownerDocument ? t.ownerDocument.body : t.body : isHTMLElement(r) && isOverflowElement(r) ? r : getNearestOverflowAncestor(r);
}
function getOverflowAncestors(t, r, n) {
  var a;
  r === void 0 && (r = []), n === void 0 && (n = !0);
  const s = getNearestOverflowAncestor(t), o = s === ((a = t.ownerDocument) == null ? void 0 : a.body), c = getWindow(s);
  if (o) {
    const l = getFrameElement(c);
    return r.concat(c, c.visualViewport || [], isOverflowElement(s) ? s : [], l && n ? getOverflowAncestors(l) : []);
  }
  return r.concat(s, getOverflowAncestors(s, [], n));
}
function getFrameElement(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function getCssDimensions(t) {
  const r = getComputedStyle$1(t);
  let n = parseFloat(r.width) || 0, a = parseFloat(r.height) || 0;
  const s = isHTMLElement(t), o = s ? t.offsetWidth : n, c = s ? t.offsetHeight : a, l = round(n) !== o || round(a) !== c;
  return l && (n = o, a = c), {
    width: n,
    height: a,
    $: l
  };
}
function unwrapElement(t) {
  return isElement(t) ? t : t.contextElement;
}
function getScale(t) {
  const r = unwrapElement(t);
  if (!isHTMLElement(r))
    return createCoords(1);
  const n = r.getBoundingClientRect(), {
    width: a,
    height: s,
    $: o
  } = getCssDimensions(r);
  let c = (o ? round(n.width) : n.width) / a, l = (o ? round(n.height) : n.height) / s;
  return (!c || !Number.isFinite(c)) && (c = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: c,
    y: l
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(t) {
  const r = getWindow(t);
  return !isWebKit() || !r.visualViewport ? noOffsets : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(t, r, n) {
  return r === void 0 && (r = !1), !n || r && n !== getWindow(t) ? !1 : r;
}
function getBoundingClientRect(t, r, n, a) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  const s = t.getBoundingClientRect(), o = unwrapElement(t);
  let c = createCoords(1);
  r && (a ? isElement(a) && (c = getScale(a)) : c = getScale(t));
  const l = shouldAddVisualOffsets(o, n, a) ? getVisualOffsets(o) : createCoords(0);
  let d = (s.left + l.x) / c.x, h = (s.top + l.y) / c.y, u = s.width / c.x, p = s.height / c.y;
  if (o) {
    const m = getWindow(o), g = a && isElement(a) ? getWindow(a) : a;
    let v = m, y = getFrameElement(v);
    for (; y && a && g !== v; ) {
      const x = getScale(y), _ = y.getBoundingClientRect(), $ = getComputedStyle$1(y), b = _.left + (y.clientLeft + parseFloat($.paddingLeft)) * x.x, M = _.top + (y.clientTop + parseFloat($.paddingTop)) * x.y;
      d *= x.x, h *= x.y, u *= x.x, p *= x.y, d += b, h += M, v = getWindow(y), y = getFrameElement(v);
    }
  }
  return rectToClientRect({
    width: u,
    height: p,
    x: d,
    y: h
  });
}
function observeMove(t, r) {
  let n = null, a;
  const s = getDocumentElement(t);
  function o() {
    var l;
    clearTimeout(a), (l = n) == null || l.disconnect(), n = null;
  }
  function c(l, d) {
    l === void 0 && (l = !1), d === void 0 && (d = 1), o();
    const {
      left: h,
      top: u,
      width: p,
      height: m
    } = t.getBoundingClientRect();
    if (l || r(), !p || !m)
      return;
    const g = floor(u), v = floor(s.clientWidth - (h + p)), y = floor(s.clientHeight - (u + m)), x = floor(h), $ = {
      rootMargin: -g + "px " + -v + "px " + -y + "px " + -x + "px",
      threshold: max(0, min(1, d)) || 1
    };
    let b = !0;
    function M(C) {
      const S = C[0].intersectionRatio;
      if (S !== d) {
        if (!b)
          return c();
        S ? c(!1, S) : a = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(M, {
        ...$,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(M, $);
    }
    n.observe(t);
  }
  return c(!0), o;
}
function autoUpdate(t, r, n, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: o = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = a, h = unwrapElement(t), u = s || o ? [...h ? getOverflowAncestors(h) : [], ...getOverflowAncestors(r)] : [];
  u.forEach((_) => {
    s && _.addEventListener("scroll", n, {
      passive: !0
    }), o && _.addEventListener("resize", n);
  });
  const p = h && l ? observeMove(h, n) : null;
  let m = -1, g = null;
  c && (g = new ResizeObserver((_) => {
    let [$] = _;
    $ && $.target === h && g && (g.unobserve(r), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var b;
      (b = g) == null || b.observe(r);
    })), n();
  }), h && !d && g.observe(h), g.observe(r));
  let v, y = d ? getBoundingClientRect(t) : null;
  d && x();
  function x() {
    const _ = getBoundingClientRect(t);
    y && (_.x !== y.x || _.y !== y.y || _.width !== y.width || _.height !== y.height) && n(), y = _, v = requestAnimationFrame(x);
  }
  return n(), () => {
    var _;
    u.forEach(($) => {
      s && $.removeEventListener("scroll", n), o && $.removeEventListener("resize", n);
    }), p == null || p(), (_ = g) == null || _.disconnect(), g = null, d && cancelAnimationFrame(v);
  };
}
var index$1 = useLayoutEffect, _excluded$4 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], noop$1 = function() {
};
function applyPrefixToName(t, r) {
  return r ? r[0] === "-" ? t + r : t + "__" + r : t;
}
function classNames(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    a[s - 2] = arguments[s];
  var o = [].concat(a);
  if (r && t)
    for (var c in r)
      r.hasOwnProperty(c) && r[c] && o.push("".concat(applyPrefixToName(t, c)));
  return o.filter(function(l) {
    return l;
  }).map(function(l) {
    return String(l).trim();
  }).join(" ");
}
var cleanValue = function(r) {
  return isArray(r) ? r.filter(Boolean) : _typeof$m(r) === "object" && r !== null ? [r] : [];
}, cleanCommonProps = function(r) {
  r.className, r.clearValue, r.cx, r.getStyles, r.getClassNames, r.getValue, r.hasValue, r.isMulti, r.isRtl, r.options, r.selectOption, r.selectProps, r.setValue, r.theme;
  var n = _objectWithoutProperties$1(r, _excluded$4);
  return _objectSpread2({}, n);
}, getStyleProps = function(r, n, a) {
  var s = r.cx, o = r.getStyles, c = r.getClassNames, l = r.className;
  return {
    css: o(n, r),
    className: s(a ?? {}, c(n, r), l)
  };
};
function isDocumentElement(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function normalizedHeight(t) {
  return isDocumentElement(t) ? window.innerHeight : t.clientHeight;
}
function getScrollTop(t) {
  return isDocumentElement(t) ? window.pageYOffset : t.scrollTop;
}
function scrollTo(t, r) {
  if (isDocumentElement(t)) {
    window.scrollTo(0, r);
    return;
  }
  t.scrollTop = r;
}
function getScrollParent(t) {
  var r = getComputedStyle(t), n = r.position === "absolute", a = /(auto|scroll)/;
  if (r.position === "fixed")
    return document.documentElement;
  for (var s = t; s = s.parentElement; )
    if (r = getComputedStyle(s), !(n && r.position === "static") && a.test(r.overflow + r.overflowY + r.overflowX))
      return s;
  return document.documentElement;
}
function easeOutCubic(t, r, n, a) {
  return n * ((t = t / a - 1) * t * t + 1) + r;
}
function animatedScrollTo(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop$1, s = getScrollTop(t), o = r - s, c = 10, l = 0;
  function d() {
    l += c;
    var h = easeOutCubic(l, s, o, n);
    scrollTo(t, h), l < n ? window.requestAnimationFrame(d) : a(t);
  }
  d();
}
function scrollIntoView(t, r) {
  var n = t.getBoundingClientRect(), a = r.getBoundingClientRect(), s = r.offsetHeight / 3;
  a.bottom + s > n.bottom ? scrollTo(t, Math.min(r.offsetTop + r.clientHeight - t.offsetHeight + s, t.scrollHeight)) : a.top - s < n.top && scrollTo(t, Math.max(r.offsetTop - s, 0));
}
function getBoundingClientObj(t) {
  var r = t.getBoundingClientRect();
  return {
    bottom: r.bottom,
    height: r.height,
    left: r.left,
    right: r.right,
    top: r.top,
    width: r.width
  };
}
function isTouchCapable() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var passiveOptionAccessed = !1, options = {
  get passive() {
    return passiveOptionAccessed = !0;
  }
}, w = typeof window < "u" ? window : {};
w.addEventListener && w.removeEventListener && (w.addEventListener("p", noop$1, options), w.removeEventListener("p", noop$1, !1));
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(t) {
  return t != null;
}
function isArray(t) {
  return Array.isArray(t);
}
function valueTernary(t, r, n) {
  return t ? r : n;
}
function singleValueAsValue(t) {
  return t;
}
function multiValueAsValue(t) {
  return t;
}
var removeProps = function(r) {
  for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    a[s - 1] = arguments[s];
  var o = Object.entries(r).filter(function(c) {
    var l = _slicedToArray$2(c, 1), d = l[0];
    return !a.includes(d);
  });
  return o.reduce(function(c, l) {
    var d = _slicedToArray$2(l, 2), h = d[0], u = d[1];
    return c[h] = u, c;
  }, {});
}, _excluded$3 = ["children", "innerProps"], _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(t) {
  var r = t.maxHeight, n = t.menuEl, a = t.minHeight, s = t.placement, o = t.shouldScroll, c = t.isFixedPosition, l = t.controlHeight, d = getScrollParent(n), h = {
    placement: "bottom",
    maxHeight: r
  };
  if (!n || !n.offsetParent)
    return h;
  var u = d.getBoundingClientRect(), p = u.height, m = n.getBoundingClientRect(), g = m.bottom, v = m.height, y = m.top, x = n.offsetParent.getBoundingClientRect(), _ = x.top, $ = c ? window.innerHeight : normalizedHeight(d), b = getScrollTop(d), M = parseInt(getComputedStyle(n).marginBottom, 10), C = parseInt(getComputedStyle(n).marginTop, 10), S = _ - C, A = $ - y, D = S + b, N = p - b - y, T = g - $ + b + M, R = b + y - C, F = 160;
  switch (s) {
    case "auto":
    case "bottom":
      if (A >= v)
        return {
          placement: "bottom",
          maxHeight: r
        };
      if (N >= v && !c)
        return o && animatedScrollTo(d, T, F), {
          placement: "bottom",
          maxHeight: r
        };
      if (!c && N >= a || c && A >= a) {
        o && animatedScrollTo(d, T, F);
        var z = c ? A - M : N - M;
        return {
          placement: "bottom",
          maxHeight: z
        };
      }
      if (s === "auto" || c) {
        var O = r, G = c ? S : D;
        return G >= a && (O = Math.min(G - M - l, r)), {
          placement: "top",
          maxHeight: O
        };
      }
      if (s === "bottom")
        return o && scrollTo(d, T), {
          placement: "bottom",
          maxHeight: r
        };
      break;
    case "top":
      if (S >= v)
        return {
          placement: "top",
          maxHeight: r
        };
      if (D >= v && !c)
        return o && animatedScrollTo(d, R, F), {
          placement: "top",
          maxHeight: r
        };
      if (!c && D >= a || c && S >= a) {
        var I = r;
        return (!c && D >= a || c && S >= a) && (I = c ? S - C : D - C), o && animatedScrollTo(d, R, F), {
          placement: "top",
          maxHeight: I
        };
      }
      return {
        placement: "bottom",
        maxHeight: r
      };
    default:
      throw new Error('Invalid placement provided "'.concat(s, '".'));
  }
  return h;
}
function alignToControl(t) {
  var r = {
    bottom: "top",
    top: "bottom"
  };
  return t ? r[t] : "bottom";
}
var coercePlacement = function(r) {
  return r === "auto" ? "bottom" : r;
}, menuCSS = function(r, n) {
  var a, s = r.placement, o = r.theme, c = o.borderRadius, l = o.spacing, d = o.colors;
  return _objectSpread2((a = {
    label: "menu"
  }, _defineProperty$e(a, alignToControl(s), "100%"), _defineProperty$e(a, "position", "absolute"), _defineProperty$e(a, "width", "100%"), _defineProperty$e(a, "zIndex", 1), a), n ? {} : {
    backgroundColor: d.neutral0,
    borderRadius: c,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: l.menuGutter,
    marginTop: l.menuGutter
  });
}, PortalPlacementContext = /* @__PURE__ */ createContext(null), MenuPlacer = function(r) {
  var n = r.children, a = r.minMenuHeight, s = r.maxMenuHeight, o = r.menuPlacement, c = r.menuPosition, l = r.menuShouldScrollIntoView, d = r.theme, h = useContext(PortalPlacementContext) || {}, u = h.setPortalPlacement, p = useRef(null), m = useState(s), g = _slicedToArray$2(m, 2), v = g[0], y = g[1], x = useState(null), _ = _slicedToArray$2(x, 2), $ = _[0], b = _[1], M = d.spacing.controlHeight;
  return index$1(function() {
    var C = p.current;
    if (C) {
      var S = c === "fixed", A = l && !S, D = getMenuPlacement({
        maxHeight: s,
        menuEl: C,
        minHeight: a,
        placement: o,
        shouldScroll: A,
        isFixedPosition: S,
        controlHeight: M
      });
      y(D.maxHeight), b(D.placement), u == null || u(D.placement);
    }
  }, [s, o, c, l, a, u, M]), n({
    ref: p,
    placerProps: _objectSpread2(_objectSpread2({}, r), {}, {
      placement: $ || coercePlacement(o),
      maxHeight: v
    })
  });
}, Menu = function(r) {
  var n = r.children, a = r.innerRef, s = r.innerProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "menu", {
    menu: !0
  }), {
    ref: a
  }, s), n);
}, Menu$1 = Menu, menuListCSS = function(r, n) {
  var a = r.maxHeight, s = r.theme.spacing.baseUnit;
  return _objectSpread2({
    maxHeight: a,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: s,
    paddingTop: s
  });
}, MenuList = function(r) {
  var n = r.children, a = r.innerProps, s = r.innerRef, o = r.isMulti;
  return jsx("div", _extends$7({}, getStyleProps(r, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": o
  }), {
    ref: s
  }, a), n);
}, noticeCSS = function(r, n) {
  var a = r.theme, s = a.spacing.baseUnit, o = a.colors;
  return _objectSpread2({
    textAlign: "center"
  }, n ? {} : {
    color: o.neutral40,
    padding: "".concat(s * 2, "px ").concat(s * 3, "px")
  });
}, noOptionsMessageCSS = noticeCSS, loadingMessageCSS = noticeCSS, NoOptionsMessage = function(r) {
  var n = r.children, a = n === void 0 ? "No options" : n, s = r.innerProps, o = _objectWithoutProperties$1(r, _excluded$3);
  return jsx("div", _extends$7({}, getStyleProps(_objectSpread2(_objectSpread2({}, o), {}, {
    children: a,
    innerProps: s
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), s), a);
}, LoadingMessage = function(r) {
  var n = r.children, a = n === void 0 ? "Loading..." : n, s = r.innerProps, o = _objectWithoutProperties$1(r, _excluded2$1);
  return jsx("div", _extends$7({}, getStyleProps(_objectSpread2(_objectSpread2({}, o), {}, {
    children: a,
    innerProps: s
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), s), a);
}, menuPortalCSS = function(r) {
  var n = r.rect, a = r.offset, s = r.position;
  return {
    left: n.left,
    position: s,
    top: a,
    width: n.width,
    zIndex: 1
  };
}, MenuPortal = function(r) {
  var n = r.appendTo, a = r.children, s = r.controlElement, o = r.innerProps, c = r.menuPlacement, l = r.menuPosition, d = useRef(null), h = useRef(null), u = useState(coercePlacement(c)), p = _slicedToArray$2(u, 2), m = p[0], g = p[1], v = useMemo(function() {
    return {
      setPortalPlacement: g
    };
  }, []), y = useState(null), x = _slicedToArray$2(y, 2), _ = x[0], $ = x[1], b = useCallback(function() {
    if (s) {
      var A = getBoundingClientObj(s), D = l === "fixed" ? 0 : window.pageYOffset, N = A[m] + D;
      (N !== (_ == null ? void 0 : _.offset) || A.left !== (_ == null ? void 0 : _.rect.left) || A.width !== (_ == null ? void 0 : _.rect.width)) && $({
        offset: N,
        rect: A
      });
    }
  }, [s, l, m, _ == null ? void 0 : _.offset, _ == null ? void 0 : _.rect.left, _ == null ? void 0 : _.rect.width]);
  index$1(function() {
    b();
  }, [b]);
  var M = useCallback(function() {
    typeof h.current == "function" && (h.current(), h.current = null), s && d.current && (h.current = autoUpdate(s, d.current, b, {
      elementResize: "ResizeObserver" in window
    }));
  }, [s, b]);
  index$1(function() {
    M();
  }, [M]);
  var C = useCallback(function(A) {
    d.current = A, M();
  }, [M]);
  if (!n && l !== "fixed" || !_)
    return null;
  var S = jsx("div", _extends$7({
    ref: C
  }, getStyleProps(_objectSpread2(_objectSpread2({}, r), {}, {
    offset: _.offset,
    position: l,
    rect: _.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), o), a);
  return jsx(PortalPlacementContext.Provider, {
    value: v
  }, n ? /* @__PURE__ */ createPortal(S, n) : S);
}, containerCSS = function(r) {
  var n = r.isDisabled, a = r.isRtl;
  return {
    label: "container",
    direction: a ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, SelectContainer = function(r) {
  var n = r.children, a = r.innerProps, s = r.isDisabled, o = r.isRtl;
  return jsx("div", _extends$7({}, getStyleProps(r, "container", {
    "--is-disabled": s,
    "--is-rtl": o
  }), a), n);
}, valueContainerCSS = function(r, n) {
  var a = r.theme.spacing, s = r.isMulti, o = r.hasValue, c = r.selectProps.controlShouldRenderValue;
  return _objectSpread2({
    alignItems: "center",
    display: s && o && c ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(a.baseUnit / 2, "px ").concat(a.baseUnit * 2, "px")
  });
}, ValueContainer = function(r) {
  var n = r.children, a = r.innerProps, s = r.isMulti, o = r.hasValue;
  return jsx("div", _extends$7({}, getStyleProps(r, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": s,
    "value-container--has-value": o
  }), a), n);
}, indicatorsContainerCSS = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, IndicatorsContainer = function(r) {
  var n = r.children, a = r.innerProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "indicatorsContainer", {
    indicators: !0
  }), a), n);
}, _templateObject, _excluded$2 = ["size"], _excluded2$2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
}, Svg = function(r) {
  var n = r.size, a = _objectWithoutProperties$1(r, _excluded$2);
  return jsx("svg", _extends$7({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, a));
}, CrossIcon = function(r) {
  return jsx(Svg, _extends$7({
    size: 20
  }, r), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, DownChevron = function(r) {
  return jsx(Svg, _extends$7({
    size: 20
  }, r), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, baseCSS = function(r, n) {
  var a = r.isFocused, s = r.theme, o = s.spacing.baseUnit, c = s.colors;
  return _objectSpread2({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: a ? c.neutral60 : c.neutral20,
    padding: o * 2,
    ":hover": {
      color: a ? c.neutral80 : c.neutral40
    }
  });
}, dropdownIndicatorCSS = baseCSS, DropdownIndicator = function(r) {
  var n = r.children, a = r.innerProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), a), n || jsx(DownChevron, null));
}, clearIndicatorCSS = baseCSS, ClearIndicator = function(r) {
  var n = r.children, a = r.innerProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), a), n || jsx(CrossIcon, null));
}, indicatorSeparatorCSS = function(r, n) {
  var a = r.isDisabled, s = r.theme, o = s.spacing.baseUnit, c = s.colors;
  return _objectSpread2({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: a ? c.neutral10 : c.neutral20,
    marginBottom: o * 2,
    marginTop: o * 2
  });
}, IndicatorSeparator = function(r) {
  var n = r.innerProps;
  return jsx("span", _extends$7({}, n, getStyleProps(r, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), loadingIndicatorCSS = function(r, n) {
  var a = r.isFocused, s = r.size, o = r.theme, c = o.colors, l = o.spacing.baseUnit;
  return _objectSpread2({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: s,
    lineHeight: 1,
    marginRight: s,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: a ? c.neutral60 : c.neutral20,
    padding: l * 2
  });
}, LoadingDot = function(r) {
  var n = r.delay, a = r.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: a ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, LoadingIndicator = function(r) {
  var n = r.innerProps, a = r.isRtl, s = r.size, o = s === void 0 ? 4 : s, c = _objectWithoutProperties$1(r, _excluded2$2);
  return jsx("div", _extends$7({}, getStyleProps(_objectSpread2(_objectSpread2({}, c), {}, {
    innerProps: n,
    isRtl: a,
    size: o
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), jsx(LoadingDot, {
    delay: 0,
    offset: a
  }), jsx(LoadingDot, {
    delay: 160,
    offset: !0
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !a
  }));
}, css$1 = function(r, n) {
  var a = r.isDisabled, s = r.isFocused, o = r.theme, c = o.colors, l = o.borderRadius, d = o.spacing;
  return _objectSpread2({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: d.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: a ? c.neutral5 : c.neutral0,
    borderColor: a ? c.neutral10 : s ? c.primary : c.neutral20,
    borderRadius: l,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: s ? "0 0 0 1px ".concat(c.primary) : void 0,
    "&:hover": {
      borderColor: s ? c.primary : c.neutral30
    }
  });
}, Control = function(r) {
  var n = r.children, a = r.isDisabled, s = r.isFocused, o = r.innerRef, c = r.innerProps, l = r.menuIsOpen;
  return jsx("div", _extends$7({
    ref: o
  }, getStyleProps(r, "control", {
    control: !0,
    "control--is-disabled": a,
    "control--is-focused": s,
    "control--menu-is-open": l
  }), c, {
    "aria-disabled": a || void 0
  }), n);
}, Control$1 = Control, _excluded$1$1 = ["data"], groupCSS = function(r, n) {
  var a = r.theme.spacing;
  return n ? {} : {
    paddingBottom: a.baseUnit * 2,
    paddingTop: a.baseUnit * 2
  };
}, Group = function(r) {
  var n = r.children, a = r.cx, s = r.getStyles, o = r.getClassNames, c = r.Heading, l = r.headingProps, d = r.innerProps, h = r.label, u = r.theme, p = r.selectProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "group", {
    group: !0
  }), d), jsx(c, _extends$7({}, l, {
    selectProps: p,
    theme: u,
    getStyles: s,
    getClassNames: o,
    cx: a
  }), h), jsx("div", null, n));
}, groupHeadingCSS = function(r, n) {
  var a = r.theme, s = a.colors, o = a.spacing;
  return _objectSpread2({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: s.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: o.baseUnit * 3,
    paddingRight: o.baseUnit * 3,
    textTransform: "uppercase"
  });
}, GroupHeading = function(r) {
  var n = cleanCommonProps(r);
  n.data;
  var a = _objectWithoutProperties$1(n, _excluded$1$1);
  return jsx("div", _extends$7({}, getStyleProps(r, "groupHeading", {
    "group-heading": !0
  }), a));
}, Group$1 = Group, _excluded$5 = ["innerRef", "isDisabled", "isHidden", "inputClassName"], inputCSS = function(r, n) {
  var a = r.isDisabled, s = r.value, o = r.theme, c = o.spacing, l = o.colors;
  return _objectSpread2(_objectSpread2({
    visibility: a ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: s ? "translateZ(0)" : ""
  }, containerStyle$1), n ? {} : {
    margin: c.baseUnit / 2,
    paddingBottom: c.baseUnit / 2,
    paddingTop: c.baseUnit / 2,
    color: l.neutral80
  });
}, spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, containerStyle$1 = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
}, inputStyle = function(r) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: r ? 0 : 1,
    width: "100%"
  }, spacingStyle);
}, Input = function(r) {
  var n = r.cx, a = r.value, s = cleanCommonProps(r), o = s.innerRef, c = s.isDisabled, l = s.isHidden, d = s.inputClassName, h = _objectWithoutProperties$1(s, _excluded$5);
  return jsx("div", _extends$7({}, getStyleProps(r, "input", {
    "input-container": !0
  }), {
    "data-value": a || ""
  }), jsx("input", _extends$7({
    className: n({
      input: !0
    }, d),
    ref: o,
    style: inputStyle(l),
    disabled: c
  }, h)));
}, Input$1 = Input, multiValueCSS = function(r, n) {
  var a = r.theme, s = a.spacing, o = a.borderRadius, c = a.colors;
  return _objectSpread2({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: c.neutral10,
    borderRadius: o / 2,
    margin: s.baseUnit / 2
  });
}, multiValueLabelCSS = function(r, n) {
  var a = r.theme, s = a.borderRadius, o = a.colors, c = r.cropWithEllipsis;
  return _objectSpread2({
    overflow: "hidden",
    textOverflow: c || c === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: s / 2,
    color: o.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, multiValueRemoveCSS = function(r, n) {
  var a = r.theme, s = a.spacing, o = a.borderRadius, c = a.colors, l = r.isFocused;
  return _objectSpread2({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: o / 2,
    backgroundColor: l ? c.dangerLight : void 0,
    paddingLeft: s.baseUnit,
    paddingRight: s.baseUnit,
    ":hover": {
      backgroundColor: c.dangerLight,
      color: c.danger
    }
  });
}, MultiValueGeneric = function(r) {
  var n = r.children, a = r.innerProps;
  return jsx("div", a, n);
}, MultiValueContainer = MultiValueGeneric, MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(t) {
  var r = t.children, n = t.innerProps;
  return jsx("div", _extends$7({
    role: "button"
  }, n), r || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function(r) {
  var n = r.children, a = r.components, s = r.data, o = r.innerProps, c = r.isDisabled, l = r.removeProps, d = r.selectProps, h = a.Container, u = a.Label, p = a.Remove;
  return jsx(h, {
    data: s,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(r, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": c
    })), o),
    selectProps: d
  }, jsx(u, {
    data: s,
    innerProps: _objectSpread2({}, getStyleProps(r, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: d
  }, n), jsx(p, {
    data: s,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(r, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, l),
    selectProps: d
  }));
}, MultiValue$1 = MultiValue, optionCSS = function(r, n) {
  var a = r.isDisabled, s = r.isFocused, o = r.isSelected, c = r.theme, l = c.spacing, d = c.colors;
  return _objectSpread2({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: o ? d.primary : s ? d.primary25 : "transparent",
    color: a ? d.neutral20 : o ? d.neutral0 : "inherit",
    padding: "".concat(l.baseUnit * 2, "px ").concat(l.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: a ? void 0 : o ? d.primary : d.primary50
    }
  });
}, Option = function(r) {
  var n = r.children, a = r.isDisabled, s = r.isFocused, o = r.isSelected, c = r.innerRef, l = r.innerProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "option", {
    option: !0,
    "option--is-disabled": a,
    "option--is-focused": s,
    "option--is-selected": o
  }), {
    ref: c,
    "aria-disabled": a
  }, l), n);
}, Option$1 = Option, placeholderCSS = function(r, n) {
  var a = r.theme, s = a.spacing, o = a.colors;
  return _objectSpread2({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: o.neutral50,
    marginLeft: s.baseUnit / 2,
    marginRight: s.baseUnit / 2
  });
}, Placeholder = function(r) {
  var n = r.children, a = r.innerProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "placeholder", {
    placeholder: !0
  }), a), n);
}, Placeholder$1 = Placeholder, css = function(r, n) {
  var a = r.isDisabled, s = r.theme, o = s.spacing, c = s.colors;
  return _objectSpread2({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: a ? c.neutral40 : c.neutral80,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, SingleValue = function(r) {
  var n = r.children, a = r.isDisabled, s = r.innerProps;
  return jsx("div", _extends$7({}, getStyleProps(r, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": a
  }), s), n);
}, SingleValue$1 = SingleValue, components = {
  ClearIndicator,
  Control: Control$1,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group: Group$1,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator,
  Menu: Menu$1,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer
}, defaultComponents = function(r) {
  return _objectSpread2(_objectSpread2({}, components), r.components);
}, safeIsNaN = Number.isNaN || function(r) {
  return typeof r == "number" && r !== r;
};
function isEqual(t, r) {
  return !!(t === r || safeIsNaN(t) && safeIsNaN(r));
}
function areInputsEqual(t, r) {
  if (t.length !== r.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!isEqual(t[n], r[n]))
      return !1;
  return !0;
}
function memoizeOne(t, r) {
  r === void 0 && (r = areInputsEqual);
  var n = null;
  function a() {
    for (var s = [], o = 0; o < arguments.length; o++)
      s[o] = arguments[o];
    if (n && n.lastThis === this && r(s, n.lastArgs))
      return n.lastResult;
    var c = t.apply(this, s);
    return n = {
      lastResult: c,
      lastArgs: s,
      lastThis: this
    }, c;
  }
  return a.clear = function() {
    n = null;
  }, a;
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}, A11yText = function(r) {
  return jsx("span", _extends$7({
    css: _ref
  }, r));
}, A11yText$1 = A11yText, defaultAriaLiveMessages = {
  guidance: function(r) {
    var n = r.isSearchable, a = r.isMulti, s = r.tabSelectsValue, o = r.context, c = r.isInitialFocus;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(s ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return c ? "".concat(r["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(a ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(r) {
    var n = r.action, a = r.label, s = a === void 0 ? "" : a, o = r.labels, c = r.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(s, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");
      case "select-option":
        return c ? "option ".concat(s, " is disabled. Select another option.") : "option ".concat(s, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(r) {
    var n = r.context, a = r.focused, s = r.options, o = r.label, c = o === void 0 ? "" : o, l = r.selectValue, d = r.isDisabled, h = r.isSelected, u = r.isAppleDevice, p = function(y, x) {
      return y && y.length ? "".concat(y.indexOf(x) + 1, " of ").concat(y.length) : "";
    };
    if (n === "value" && l)
      return "value ".concat(c, " focused, ").concat(p(l, a), ".");
    if (n === "menu" && u) {
      var m = d ? " disabled" : "", g = "".concat(h ? " selected" : "").concat(m);
      return "".concat(c).concat(g, ", ").concat(p(s, a), ".");
    }
    return "";
  },
  onFilter: function(r) {
    var n = r.inputValue, a = r.resultsMessage;
    return "".concat(a).concat(n ? " for search term " + n : "", ".");
  }
}, LiveRegion = function(r) {
  var n = r.ariaSelection, a = r.focusedOption, s = r.focusedValue, o = r.focusableOptions, c = r.isFocused, l = r.selectValue, d = r.selectProps, h = r.id, u = r.isAppleDevice, p = d.ariaLiveMessages, m = d.getOptionLabel, g = d.inputValue, v = d.isMulti, y = d.isOptionDisabled, x = d.isSearchable, _ = d.menuIsOpen, $ = d.options, b = d.screenReaderStatus, M = d.tabSelectsValue, C = d.isLoading, S = d["aria-label"], A = d["aria-live"], D = useMemo(function() {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), p || {});
  }, [p]), N = useMemo(function() {
    var G = "";
    if (n && D.onChange) {
      var I = n.option, k = n.options, B = n.removedValue, L = n.removedValues, V = n.value, U = function(nr) {
        return Array.isArray(nr) ? null : nr;
      }, J = B || I || U(V), q = J ? m(J) : "", Z = k || L || void 0, ae = Z ? Z.map(m) : [], ee = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: J && y(J, l),
        label: q,
        labels: ae
      }, n);
      G = D.onChange(ee);
    }
    return G;
  }, [n, D, y, l, m]), T = useMemo(function() {
    var G = "", I = a || s, k = !!(a && l && l.includes(a));
    if (I && D.onFocus) {
      var B = {
        focused: I,
        label: m(I),
        isDisabled: y(I, l),
        isSelected: k,
        options: o,
        context: I === a ? "menu" : "value",
        selectValue: l,
        isAppleDevice: u
      };
      G = D.onFocus(B);
    }
    return G;
  }, [a, s, m, y, D, o, l, u]), R = useMemo(function() {
    var G = "";
    if (_ && $.length && !C && D.onFilter) {
      var I = b({
        count: o.length
      });
      G = D.onFilter({
        inputValue: g,
        resultsMessage: I
      });
    }
    return G;
  }, [o, g, _, D, $, b, C]), F = (n == null ? void 0 : n.action) === "initial-input-focus", z = useMemo(function() {
    var G = "";
    if (D.guidance) {
      var I = s ? "value" : _ ? "menu" : "input";
      G = D.guidance({
        "aria-label": S,
        context: I,
        isDisabled: a && y(a, l),
        isMulti: v,
        isSearchable: x,
        tabSelectsValue: M,
        isInitialFocus: F
      });
    }
    return G;
  }, [S, a, s, v, y, x, _, D, l, M, F]), O = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, N), jsx("span", {
    id: "aria-focused"
  }, T), jsx("span", {
    id: "aria-results"
  }, R), jsx("span", {
    id: "aria-guidance"
  }, z));
  return jsx(Fragment$1, null, jsx(A11yText$1, {
    id: h
  }, F && O), jsx(A11yText$1, {
    "aria-live": A,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, c && !F && O));
}, LiveRegion$1 = LiveRegion, diacritics = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], anyDiacritic = new RegExp("[" + diacritics.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++)
  for (var diacritic = diacritics[i], j = 0; j < diacritic.letters.length; j++)
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
var stripDiacritics = function(r) {
  return r.replace(anyDiacritic, function(n) {
    return diacriticToBase[n];
  });
}, memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics), trimString = function(r) {
  return r.replace(/^\s+|\s+$/g, "");
}, defaultStringify = function(r) {
  return "".concat(r.label, " ").concat(r.value);
}, createFilter = function(r) {
  return function(n, a) {
    if (n.data.__isNew__)
      return !0;
    var s = _objectSpread2({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: defaultStringify,
      trim: !0,
      matchFrom: "any"
    }, r), o = s.ignoreCase, c = s.ignoreAccents, l = s.stringify, d = s.trim, h = s.matchFrom, u = d ? trimString(a) : a, p = d ? trimString(l(n)) : l(n);
    return o && (u = u.toLowerCase(), p = p.toLowerCase()), c && (u = memoizedStripDiacriticsForInput(u), p = stripDiacritics(p)), h === "start" ? p.substr(0, u.length) === u : p.indexOf(u) > -1;
  };
}, _excluded$1 = ["innerRef"];
function DummyInput(t) {
  var r = t.innerRef, n = _objectWithoutProperties$1(t, _excluded$1), a = removeProps(n, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends$7({
    ref: r
  }, a, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var cancelScroll = function(r) {
  r.cancelable && r.preventDefault(), r.stopPropagation();
};
function useScrollCapture(t) {
  var r = t.isEnabled, n = t.onBottomArrive, a = t.onBottomLeave, s = t.onTopArrive, o = t.onTopLeave, c = useRef(!1), l = useRef(!1), d = useRef(0), h = useRef(null), u = useCallback(function(x, _) {
    if (h.current !== null) {
      var $ = h.current, b = $.scrollTop, M = $.scrollHeight, C = $.clientHeight, S = h.current, A = _ > 0, D = M - C - b, N = !1;
      D > _ && c.current && (a && a(x), c.current = !1), A && l.current && (o && o(x), l.current = !1), A && _ > D ? (n && !c.current && n(x), S.scrollTop = M, N = !0, c.current = !0) : !A && -_ > b && (s && !l.current && s(x), S.scrollTop = 0, N = !0, l.current = !0), N && cancelScroll(x);
    }
  }, [n, a, s, o]), p = useCallback(function(x) {
    u(x, x.deltaY);
  }, [u]), m = useCallback(function(x) {
    d.current = x.changedTouches[0].clientY;
  }, []), g = useCallback(function(x) {
    var _ = d.current - x.changedTouches[0].clientY;
    u(x, _);
  }, [u]), v = useCallback(function(x) {
    if (x) {
      var _ = supportsPassiveEvents ? {
        passive: !1
      } : !1;
      x.addEventListener("wheel", p, _), x.addEventListener("touchstart", m, _), x.addEventListener("touchmove", g, _);
    }
  }, [g, m, p]), y = useCallback(function(x) {
    x && (x.removeEventListener("wheel", p, !1), x.removeEventListener("touchstart", m, !1), x.removeEventListener("touchmove", g, !1));
  }, [g, m, p]);
  return useEffect(function() {
    if (r) {
      var x = h.current;
      return v(x), function() {
        y(x);
      };
    }
  }, [r, v, y]), function(x) {
    h.current = x;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"], LOCK_STYLES = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(t) {
  t.preventDefault();
}
function allowTouchMove(t) {
  t.stopPropagation();
}
function preventInertiaScroll() {
  var t = this.scrollTop, r = this.scrollHeight, n = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : n === r && (this.scrollTop = t - 1);
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), activeScrollLocks = 0, listenerOptions = {
  capture: !1,
  passive: !1
};
function useScrollLock(t) {
  var r = t.isEnabled, n = t.accountForScrollbars, a = n === void 0 ? !0 : n, s = useRef({}), o = useRef(null), c = useCallback(function(d) {
    if (canUseDOM) {
      var h = document.body, u = h && h.style;
      if (a && STYLE_KEYS.forEach(function(v) {
        var y = u && u[v];
        s.current[v] = y;
      }), a && activeScrollLocks < 1) {
        var p = parseInt(s.current.paddingRight, 10) || 0, m = document.body ? document.body.clientWidth : 0, g = window.innerWidth - m + p || 0;
        Object.keys(LOCK_STYLES).forEach(function(v) {
          var y = LOCK_STYLES[v];
          u && (u[v] = y);
        }), u && (u.paddingRight = "".concat(g, "px"));
      }
      h && isTouchDevice() && (h.addEventListener("touchmove", preventTouchMove, listenerOptions), d && (d.addEventListener("touchstart", preventInertiaScroll, listenerOptions), d.addEventListener("touchmove", allowTouchMove, listenerOptions))), activeScrollLocks += 1;
    }
  }, [a]), l = useCallback(function(d) {
    if (canUseDOM) {
      var h = document.body, u = h && h.style;
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0), a && activeScrollLocks < 1 && STYLE_KEYS.forEach(function(p) {
        var m = s.current[p];
        u && (u[p] = m);
      }), h && isTouchDevice() && (h.removeEventListener("touchmove", preventTouchMove, listenerOptions), d && (d.removeEventListener("touchstart", preventInertiaScroll, listenerOptions), d.removeEventListener("touchmove", allowTouchMove, listenerOptions)));
    }
  }, [a]);
  return useEffect(function() {
    if (r) {
      var d = o.current;
      return c(d), function() {
        l(d);
      };
    }
  }, [r, c, l]), function(d) {
    o.current = d;
  };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function(r) {
  var n = r.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function ScrollManager(t) {
  var r = t.children, n = t.lockEnabled, a = t.captureEnabled, s = a === void 0 ? !0 : a, o = t.onBottomArrive, c = t.onBottomLeave, l = t.onTopArrive, d = t.onTopLeave, h = useScrollCapture({
    isEnabled: s,
    onBottomArrive: o,
    onBottomLeave: c,
    onTopArrive: l,
    onTopLeave: d
  }), u = useScrollLock({
    isEnabled: n
  }), p = function(g) {
    h(g), u(g);
  };
  return jsx(Fragment$1, null, n && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), r(p));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}, RequiredInput = function(r) {
  var n = r.name, a = r.onFocus;
  return jsx("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: a,
    css: _ref2,
    value: "",
    onChange: function() {
    }
  });
}, RequiredInput$1 = RequiredInput;
function testPlatform(t) {
  var r;
  return typeof window < "u" && window.navigator != null ? t.test(((r = window.navigator.userAgentData) === null || r === void 0 ? void 0 : r.platform) || window.navigator.platform) : !1;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}
var formatGroupLabel = function(r) {
  return r.label;
}, getOptionLabel$1 = function(r) {
  return r.label;
}, getOptionValue$1 = function(r) {
  return r.value;
}, isOptionDisabled = function(r) {
  return !!r.isDisabled;
}, defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css,
  valueContainer: valueContainerCSS
}, colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, borderRadius = 4, baseUnit = 4, controlHeight = 38, menuGutter = baseUnit * 2, spacing = {
  baseUnit,
  controlHeight,
  menuGutter
}, defaultTheme = {
  borderRadius,
  colors,
  spacing
}, defaultProps$1 = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(r) {
    var n = r.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function toCategorizedOption(t, r, n, a) {
  var s = _isOptionDisabled(t, r, n), o = _isOptionSelected(t, r, n), c = getOptionLabel(t, r), l = getOptionValue(t, r);
  return {
    type: "option",
    data: r,
    isDisabled: s,
    isSelected: o,
    label: c,
    value: l,
    index: a
  };
}
function buildCategorizedOptions(t, r) {
  return t.options.map(function(n, a) {
    if ("options" in n) {
      var s = n.options.map(function(c, l) {
        return toCategorizedOption(t, c, r, l);
      }).filter(function(c) {
        return isFocusable(t, c);
      });
      return s.length > 0 ? {
        type: "group",
        data: n,
        options: s,
        index: a
      } : void 0;
    }
    var o = toCategorizedOption(t, n, r, a);
    return isFocusable(t, o) ? o : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(t) {
  return t.reduce(function(r, n) {
    return n.type === "group" ? r.push.apply(r, _toConsumableArray$2(n.options.map(function(a) {
      return a.data;
    }))) : r.push(n.data), r;
  }, []);
}
function buildFocusableOptionsWithIds(t, r) {
  return t.reduce(function(n, a) {
    return a.type === "group" ? n.push.apply(n, _toConsumableArray$2(a.options.map(function(s) {
      return {
        data: s.data,
        id: "".concat(r, "-").concat(a.index, "-").concat(s.index)
      };
    }))) : n.push({
      data: a.data,
      id: "".concat(r, "-").concat(a.index)
    }), n;
  }, []);
}
function buildFocusableOptions(t, r) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(t, r));
}
function isFocusable(t, r) {
  var n = t.inputValue, a = n === void 0 ? "" : n, s = r.data, o = r.isSelected, c = r.label, l = r.value;
  return (!shouldHideSelectedOptions(t) || !o) && _filterOption(t, {
    label: c,
    value: l,
    data: s
  }, a);
}
function getNextFocusedValue(t, r) {
  var n = t.focusedValue, a = t.selectValue, s = a.indexOf(n);
  if (s > -1) {
    var o = r.indexOf(n);
    if (o > -1)
      return n;
    if (s < r.length)
      return r[s];
  }
  return null;
}
function getNextFocusedOption(t, r) {
  var n = t.focusedOption;
  return n && r.indexOf(n) > -1 ? n : r[0];
}
var getFocusedOptionId = function(r, n) {
  var a, s = (a = r.find(function(o) {
    return o.data === n;
  })) === null || a === void 0 ? void 0 : a.id;
  return s || null;
}, getOptionLabel = function(r, n) {
  return r.getOptionLabel(n);
}, getOptionValue = function(r, n) {
  return r.getOptionValue(n);
};
function _isOptionDisabled(t, r, n) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(r, n) : !1;
}
function _isOptionSelected(t, r, n) {
  if (n.indexOf(r) > -1)
    return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(r, n);
  var a = getOptionValue(t, r);
  return n.some(function(s) {
    return getOptionValue(t, s) === a;
  });
}
function _filterOption(t, r, n) {
  return t.filterOption ? t.filterOption(r, n) : !0;
}
var shouldHideSelectedOptions = function(r) {
  var n = r.hideSelectedOptions, a = r.isMulti;
  return n === void 0 ? a : n;
}, instanceId = 1, Select$2 = /* @__PURE__ */ function(t) {
  _inherits$3(n, t);
  var r = _createSuper$5(n);
  function n(a) {
    var s;
    if (_classCallCheck$b(this, n), s = r.call(this, a), s.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, s.blockOptionHover = !1, s.isComposing = !1, s.commonProps = void 0, s.initialTouchX = 0, s.initialTouchY = 0, s.openAfterFocus = !1, s.scrollToFocusedOptionOnUpdate = !1, s.userIsDragging = void 0, s.isAppleDevice = isAppleDevice(), s.controlRef = null, s.getControlRef = function(d) {
      s.controlRef = d;
    }, s.focusedOptionRef = null, s.getFocusedOptionRef = function(d) {
      s.focusedOptionRef = d;
    }, s.menuListRef = null, s.getMenuListRef = function(d) {
      s.menuListRef = d;
    }, s.inputRef = null, s.getInputRef = function(d) {
      s.inputRef = d;
    }, s.focus = s.focusInput, s.blur = s.blurInput, s.onChange = function(d, h) {
      var u = s.props, p = u.onChange, m = u.name;
      h.name = m, s.ariaOnChange(d, h), p(d, h);
    }, s.setValue = function(d, h, u) {
      var p = s.props, m = p.closeMenuOnSelect, g = p.isMulti, v = p.inputValue;
      s.onInputChange("", {
        action: "set-value",
        prevInputValue: v
      }), m && (s.setState({
        inputIsHiddenAfterUpdate: !g
      }), s.onMenuClose()), s.setState({
        clearFocusValueOnUpdate: !0
      }), s.onChange(d, {
        action: h,
        option: u
      });
    }, s.selectOption = function(d) {
      var h = s.props, u = h.blurInputOnSelect, p = h.isMulti, m = h.name, g = s.state.selectValue, v = p && s.isOptionSelected(d, g), y = s.isOptionDisabled(d, g);
      if (v) {
        var x = s.getOptionValue(d);
        s.setValue(g.filter(function(_) {
          return s.getOptionValue(_) !== x;
        }), "deselect-option", d);
      } else if (!y)
        p ? s.setValue([].concat(_toConsumableArray$2(g), [d]), "select-option", d) : s.setValue(d, "select-option");
      else {
        s.ariaOnChange(d, {
          action: "select-option",
          option: d,
          name: m
        });
        return;
      }
      u && s.blurInput();
    }, s.removeValue = function(d) {
      var h = s.props.isMulti, u = s.state.selectValue, p = s.getOptionValue(d), m = u.filter(function(v) {
        return s.getOptionValue(v) !== p;
      }), g = valueTernary(h, m, m[0] || null);
      s.onChange(g, {
        action: "remove-value",
        removedValue: d
      }), s.focusInput();
    }, s.clearValue = function() {
      var d = s.state.selectValue;
      s.onChange(valueTernary(s.props.isMulti, [], null), {
        action: "clear",
        removedValues: d
      });
    }, s.popValue = function() {
      var d = s.props.isMulti, h = s.state.selectValue, u = h[h.length - 1], p = h.slice(0, h.length - 1), m = valueTernary(d, p, p[0] || null);
      s.onChange(m, {
        action: "pop-value",
        removedValue: u
      });
    }, s.getFocusedOptionId = function(d) {
      return getFocusedOptionId(s.state.focusableOptionsWithIds, d);
    }, s.getFocusableOptionsWithIds = function() {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(s.props, s.state.selectValue), s.getElementId("option"));
    }, s.getValue = function() {
      return s.state.selectValue;
    }, s.cx = function() {
      for (var d = arguments.length, h = new Array(d), u = 0; u < d; u++)
        h[u] = arguments[u];
      return classNames.apply(void 0, [s.props.classNamePrefix].concat(h));
    }, s.getOptionLabel = function(d) {
      return getOptionLabel(s.props, d);
    }, s.getOptionValue = function(d) {
      return getOptionValue(s.props, d);
    }, s.getStyles = function(d, h) {
      var u = s.props.unstyled, p = defaultStyles[d](h, u);
      p.boxSizing = "border-box";
      var m = s.props.styles[d];
      return m ? m(p, h) : p;
    }, s.getClassNames = function(d, h) {
      var u, p;
      return (u = (p = s.props.classNames)[d]) === null || u === void 0 ? void 0 : u.call(p, h);
    }, s.getElementId = function(d) {
      return "".concat(s.state.instancePrefix, "-").concat(d);
    }, s.getComponents = function() {
      return defaultComponents(s.props);
    }, s.buildCategorizedOptions = function() {
      return buildCategorizedOptions(s.props, s.state.selectValue);
    }, s.getCategorizedOptions = function() {
      return s.props.menuIsOpen ? s.buildCategorizedOptions() : [];
    }, s.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(s.buildCategorizedOptions());
    }, s.getFocusableOptions = function() {
      return s.props.menuIsOpen ? s.buildFocusableOptions() : [];
    }, s.ariaOnChange = function(d, h) {
      s.setState({
        ariaSelection: _objectSpread2({
          value: d
        }, h)
      });
    }, s.onMenuMouseDown = function(d) {
      d.button === 0 && (d.stopPropagation(), d.preventDefault(), s.focusInput());
    }, s.onMenuMouseMove = function(d) {
      s.blockOptionHover = !1;
    }, s.onControlMouseDown = function(d) {
      if (!d.defaultPrevented) {
        var h = s.props.openMenuOnClick;
        s.state.isFocused ? s.props.menuIsOpen ? d.target.tagName !== "INPUT" && d.target.tagName !== "TEXTAREA" && s.onMenuClose() : h && s.openMenu("first") : (h && (s.openAfterFocus = !0), s.focusInput()), d.target.tagName !== "INPUT" && d.target.tagName !== "TEXTAREA" && d.preventDefault();
      }
    }, s.onDropdownIndicatorMouseDown = function(d) {
      if (!(d && d.type === "mousedown" && d.button !== 0) && !s.props.isDisabled) {
        var h = s.props, u = h.isMulti, p = h.menuIsOpen;
        s.focusInput(), p ? (s.setState({
          inputIsHiddenAfterUpdate: !u
        }), s.onMenuClose()) : s.openMenu("first"), d.preventDefault();
      }
    }, s.onClearIndicatorMouseDown = function(d) {
      d && d.type === "mousedown" && d.button !== 0 || (s.clearValue(), d.preventDefault(), s.openAfterFocus = !1, d.type === "touchend" ? s.focusInput() : setTimeout(function() {
        return s.focusInput();
      }));
    }, s.onScroll = function(d) {
      typeof s.props.closeMenuOnScroll == "boolean" ? d.target instanceof HTMLElement && isDocumentElement(d.target) && s.props.onMenuClose() : typeof s.props.closeMenuOnScroll == "function" && s.props.closeMenuOnScroll(d) && s.props.onMenuClose();
    }, s.onCompositionStart = function() {
      s.isComposing = !0;
    }, s.onCompositionEnd = function() {
      s.isComposing = !1;
    }, s.onTouchStart = function(d) {
      var h = d.touches, u = h && h.item(0);
      u && (s.initialTouchX = u.clientX, s.initialTouchY = u.clientY, s.userIsDragging = !1);
    }, s.onTouchMove = function(d) {
      var h = d.touches, u = h && h.item(0);
      if (u) {
        var p = Math.abs(u.clientX - s.initialTouchX), m = Math.abs(u.clientY - s.initialTouchY), g = 5;
        s.userIsDragging = p > g || m > g;
      }
    }, s.onTouchEnd = function(d) {
      s.userIsDragging || (s.controlRef && !s.controlRef.contains(d.target) && s.menuListRef && !s.menuListRef.contains(d.target) && s.blurInput(), s.initialTouchX = 0, s.initialTouchY = 0);
    }, s.onControlTouchEnd = function(d) {
      s.userIsDragging || s.onControlMouseDown(d);
    }, s.onClearIndicatorTouchEnd = function(d) {
      s.userIsDragging || s.onClearIndicatorMouseDown(d);
    }, s.onDropdownIndicatorTouchEnd = function(d) {
      s.userIsDragging || s.onDropdownIndicatorMouseDown(d);
    }, s.handleInputChange = function(d) {
      var h = s.props.inputValue, u = d.currentTarget.value;
      s.setState({
        inputIsHiddenAfterUpdate: !1
      }), s.onInputChange(u, {
        action: "input-change",
        prevInputValue: h
      }), s.props.menuIsOpen || s.onMenuOpen();
    }, s.onInputFocus = function(d) {
      s.props.onFocus && s.props.onFocus(d), s.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (s.openAfterFocus || s.props.openMenuOnFocus) && s.openMenu("first"), s.openAfterFocus = !1;
    }, s.onInputBlur = function(d) {
      var h = s.props.inputValue;
      if (s.menuListRef && s.menuListRef.contains(document.activeElement)) {
        s.inputRef.focus();
        return;
      }
      s.props.onBlur && s.props.onBlur(d), s.onInputChange("", {
        action: "input-blur",
        prevInputValue: h
      }), s.onMenuClose(), s.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, s.onOptionHover = function(d) {
      if (!(s.blockOptionHover || s.state.focusedOption === d)) {
        var h = s.getFocusableOptions(), u = h.indexOf(d);
        s.setState({
          focusedOption: d,
          focusedOptionId: u > -1 ? s.getFocusedOptionId(d) : null
        });
      }
    }, s.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(s.props);
    }, s.onValueInputFocus = function(d) {
      d.preventDefault(), d.stopPropagation(), s.focus();
    }, s.onKeyDown = function(d) {
      var h = s.props, u = h.isMulti, p = h.backspaceRemovesValue, m = h.escapeClearsValue, g = h.inputValue, v = h.isClearable, y = h.isDisabled, x = h.menuIsOpen, _ = h.onKeyDown, $ = h.tabSelectsValue, b = h.openMenuOnFocus, M = s.state, C = M.focusedOption, S = M.focusedValue, A = M.selectValue;
      if (!y && !(typeof _ == "function" && (_(d), d.defaultPrevented))) {
        switch (s.blockOptionHover = !0, d.key) {
          case "ArrowLeft":
            if (!u || g)
              return;
            s.focusValue("previous");
            break;
          case "ArrowRight":
            if (!u || g)
              return;
            s.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (g)
              return;
            if (S)
              s.removeValue(S);
            else {
              if (!p)
                return;
              u ? s.popValue() : v && s.clearValue();
            }
            break;
          case "Tab":
            if (s.isComposing || d.shiftKey || !x || !$ || !C || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            b && s.isOptionSelected(C, A))
              return;
            s.selectOption(C);
            break;
          case "Enter":
            if (d.keyCode === 229)
              break;
            if (x) {
              if (!C || s.isComposing)
                return;
              s.selectOption(C);
              break;
            }
            return;
          case "Escape":
            x ? (s.setState({
              inputIsHiddenAfterUpdate: !1
            }), s.onInputChange("", {
              action: "menu-close",
              prevInputValue: g
            }), s.onMenuClose()) : v && m && s.clearValue();
            break;
          case " ":
            if (g)
              return;
            if (!x) {
              s.openMenu("first");
              break;
            }
            if (!C)
              return;
            s.selectOption(C);
            break;
          case "ArrowUp":
            x ? s.focusOption("up") : s.openMenu("last");
            break;
          case "ArrowDown":
            x ? s.focusOption("down") : s.openMenu("first");
            break;
          case "PageUp":
            if (!x)
              return;
            s.focusOption("pageup");
            break;
          case "PageDown":
            if (!x)
              return;
            s.focusOption("pagedown");
            break;
          case "Home":
            if (!x)
              return;
            s.focusOption("first");
            break;
          case "End":
            if (!x)
              return;
            s.focusOption("last");
            break;
          default:
            return;
        }
        d.preventDefault();
      }
    }, s.state.instancePrefix = "react-select-" + (s.props.instanceId || ++instanceId), s.state.selectValue = cleanValue(a.value), a.menuIsOpen && s.state.selectValue.length) {
      var o = s.getFocusableOptionsWithIds(), c = s.buildFocusableOptions(), l = c.indexOf(s.state.selectValue[0]);
      s.state.focusableOptionsWithIds = o, s.state.focusedOption = c[l], s.state.focusedOptionId = getFocusedOptionId(o, c[l]);
    }
    return s;
  }
  return _createClass$b(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(s) {
      var o = this.props, c = o.isDisabled, l = o.menuIsOpen, d = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (d && !c && s.isDisabled || // ensure focus is on the Input when the menu opens
      d && l && !s.menuIsOpen) && this.focusInput(), d && c && !s.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !d && !c && s.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (scrollIntoView(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(s, o) {
      this.props.onInputChange(s, o);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(s) {
      var o = this, c = this.state, l = c.selectValue, d = c.isFocused, h = this.buildFocusableOptions(), u = s === "first" ? 0 : h.length - 1;
      if (!this.props.isMulti) {
        var p = h.indexOf(l[0]);
        p > -1 && (u = p);
      }
      this.scrollToFocusedOptionOnUpdate = !(d && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: h[u],
        focusedOptionId: this.getFocusedOptionId(h[u])
      }, function() {
        return o.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(s) {
      var o = this.state, c = o.selectValue, l = o.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var d = c.indexOf(l);
        l || (d = -1);
        var h = c.length - 1, u = -1;
        if (c.length) {
          switch (s) {
            case "previous":
              d === 0 ? u = 0 : d === -1 ? u = h : u = d - 1;
              break;
            case "next":
              d > -1 && d < h && (u = d + 1);
              break;
          }
          this.setState({
            inputIsHidden: u !== -1,
            focusedValue: c[u]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", o = this.props.pageSize, c = this.state.focusedOption, l = this.getFocusableOptions();
      if (l.length) {
        var d = 0, h = l.indexOf(c);
        c || (h = -1), s === "up" ? d = h > 0 ? h - 1 : l.length - 1 : s === "down" ? d = (h + 1) % l.length : s === "pageup" ? (d = h - o, d < 0 && (d = 0)) : s === "pagedown" ? (d = h + o, d > l.length - 1 && (d = l.length - 1)) : s === "last" && (d = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: l[d],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(l[d])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(defaultTheme) : _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme) : defaultTheme;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var s = this.clearValue, o = this.cx, c = this.getStyles, l = this.getClassNames, d = this.getValue, h = this.selectOption, u = this.setValue, p = this.props, m = p.isMulti, g = p.isRtl, v = p.options, y = this.hasValue();
      return {
        clearValue: s,
        cx: o,
        getStyles: c,
        getClassNames: l,
        getValue: d,
        hasValue: y,
        isMulti: m,
        isRtl: g,
        options: v,
        selectOption: h,
        selectProps: p,
        setValue: u,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var s = this.state.selectValue;
      return s.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var s = this.props, o = s.isClearable, c = s.isMulti;
      return o === void 0 ? c : o;
    }
  }, {
    key: "isOptionDisabled",
    value: function(s, o) {
      return _isOptionDisabled(this.props, s, o);
    }
  }, {
    key: "isOptionSelected",
    value: function(s, o) {
      return _isOptionSelected(this.props, s, o);
    }
  }, {
    key: "filterOption",
    value: function(s, o) {
      return _filterOption(this.props, s, o);
    }
  }, {
    key: "formatOptionLabel",
    value: function(s, o) {
      if (typeof this.props.formatOptionLabel == "function") {
        var c = this.props.inputValue, l = this.state.selectValue;
        return this.props.formatOptionLabel(s, {
          context: o,
          inputValue: c,
          selectValue: l
        });
      } else
        return this.getOptionLabel(s);
    }
  }, {
    key: "formatGroupLabel",
    value: function(s) {
      return this.props.formatGroupLabel(s);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var s = this.props, o = s.isDisabled, c = s.isSearchable, l = s.inputId, d = s.inputValue, h = s.tabIndex, u = s.form, p = s.menuIsOpen, m = s.required, g = this.getComponents(), v = g.Input, y = this.state, x = y.inputIsHidden, _ = y.ariaSelection, $ = this.commonProps, b = l || this.getElementId("input"), M = _objectSpread2(_objectSpread2(_objectSpread2({
          "aria-autocomplete": "list",
          "aria-expanded": p,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": m,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, p && {
          "aria-controls": this.getElementId("listbox")
        }), !c && {
          "aria-readonly": !0
        }), this.hasValue() ? (_ == null ? void 0 : _.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return c ? /* @__PURE__ */ jsx$1(v, {
          ...$,
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: b,
          innerRef: this.getInputRef,
          isDisabled: o,
          isHidden: x,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: h,
          form: u,
          type: "text",
          value: d,
          ...M
        }) : /* @__PURE__ */ jsx$1(DummyInput, {
          id: b,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop$1,
          onFocus: this.onInputFocus,
          disabled: o,
          tabIndex: h,
          inputMode: "none",
          form: u,
          value: "",
          ...M
        });
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var s = this, o = this.getComponents(), c = o.MultiValue, l = o.MultiValueContainer, d = o.MultiValueLabel, h = o.MultiValueRemove, u = o.SingleValue, p = o.Placeholder, m = this.commonProps, g = this.props, v = g.controlShouldRenderValue, y = g.isDisabled, x = g.isMulti, _ = g.inputValue, $ = g.placeholder, b = this.state, M = b.selectValue, C = b.focusedValue, S = b.isFocused;
      if (!this.hasValue() || !v)
        return _ ? null : /* @__PURE__ */ createElement$1(p, {
          ...m,
          key: "placeholder",
          isDisabled: y,
          isFocused: S,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }, $);
      if (x)
        return M.map(function(D, N) {
          var T = D === C, R = "".concat(s.getOptionLabel(D), "-").concat(s.getOptionValue(D));
          return /* @__PURE__ */ createElement$1(c, {
            ...m,
            components: {
              Container: l,
              Label: d,
              Remove: h
            },
            isFocused: T,
            isDisabled: y,
            key: R,
            index: N,
            removeProps: {
              onClick: function() {
                return s.removeValue(D);
              },
              onTouchEnd: function() {
                return s.removeValue(D);
              },
              onMouseDown: function(z) {
                z.preventDefault();
              }
            },
            data: D
          }, s.formatOptionLabel(D, "value"));
        });
      if (_)
        return null;
      var A = M[0];
      return /* @__PURE__ */ jsx$1(u, {
        ...m,
        data: A,
        isDisabled: y,
        children: this.formatOptionLabel(A, "value")
      });
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var s = this.getComponents(), o = s.ClearIndicator, c = this.commonProps, l = this.props, d = l.isDisabled, h = l.isLoading, u = this.state.isFocused;
      if (!this.isClearable() || !o || d || !this.hasValue() || h)
        return null;
      var p = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(o, {
        ...c,
        innerProps: p,
        isFocused: u
      });
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var s = this.getComponents(), o = s.LoadingIndicator, c = this.commonProps, l = this.props, d = l.isDisabled, h = l.isLoading, u = this.state.isFocused;
      if (!o || !h)
        return null;
      var p = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(o, {
        ...c,
        innerProps: p,
        isDisabled: d,
        isFocused: u
      });
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var s = this.getComponents(), o = s.DropdownIndicator, c = s.IndicatorSeparator;
      if (!o || !c)
        return null;
      var l = this.commonProps, d = this.props.isDisabled, h = this.state.isFocused;
      return /* @__PURE__ */ jsx$1(c, {
        ...l,
        isDisabled: d,
        isFocused: h
      });
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var s = this.getComponents(), o = s.DropdownIndicator;
      if (!o)
        return null;
      var c = this.commonProps, l = this.props.isDisabled, d = this.state.isFocused, h = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(o, {
        ...c,
        innerProps: h,
        isDisabled: l,
        isFocused: d
      });
    }
  }, {
    key: "renderMenu",
    value: function() {
      var s = this, o = this.getComponents(), c = o.Group, l = o.GroupHeading, d = o.Menu, h = o.MenuList, u = o.MenuPortal, p = o.LoadingMessage, m = o.NoOptionsMessage, g = o.Option, v = this.commonProps, y = this.state.focusedOption, x = this.props, _ = x.captureMenuScroll, $ = x.inputValue, b = x.isLoading, M = x.loadingMessage, C = x.minMenuHeight, S = x.maxMenuHeight, A = x.menuIsOpen, D = x.menuPlacement, N = x.menuPosition, T = x.menuPortalTarget, R = x.menuShouldBlockScroll, F = x.menuShouldScrollIntoView, z = x.noOptionsMessage, O = x.onMenuScrollToTop, G = x.onMenuScrollToBottom;
      if (!A)
        return null;
      var I = function(q, Z) {
        var ae = q.type, ee = q.data, se = q.isDisabled, nr = q.isSelected, ce = q.label, oe = q.value, ur = y === ee, ir = se ? void 0 : function() {
          return s.onOptionHover(ee);
        }, _r = se ? void 0 : function() {
          return s.selectOption(ee);
        }, yr = "".concat(s.getElementId("option"), "-").concat(Z), ne = {
          id: yr,
          onClick: _r,
          onMouseMove: ir,
          onMouseOver: ir,
          tabIndex: -1,
          role: "option",
          "aria-selected": s.isAppleDevice ? void 0 : nr
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ createElement$1(g, {
          ...v,
          innerProps: ne,
          data: ee,
          isDisabled: se,
          isSelected: nr,
          key: yr,
          label: ce,
          type: ae,
          value: oe,
          isFocused: ur,
          innerRef: ur ? s.getFocusedOptionRef : void 0
        }, s.formatOptionLabel(q.data, "menu"));
      }, k;
      if (this.hasOptions())
        k = this.getCategorizedOptions().map(function(J) {
          if (J.type === "group") {
            var q = J.data, Z = J.options, ae = J.index, ee = "".concat(s.getElementId("group"), "-").concat(ae), se = "".concat(ee, "-heading");
            return /* @__PURE__ */ createElement$1(c, {
              ...v,
              key: ee,
              data: q,
              options: Z,
              Heading: l,
              headingProps: {
                id: se,
                data: J.data
              },
              label: s.formatGroupLabel(J.data)
            }, J.options.map(function(nr) {
              return I(nr, "".concat(ae, "-").concat(nr.index));
            }));
          } else if (J.type === "option")
            return I(J, "".concat(J.index));
        });
      else if (b) {
        var B = M({
          inputValue: $
        });
        if (B === null)
          return null;
        k = /* @__PURE__ */ jsx$1(p, {
          ...v,
          children: B
        });
      } else {
        var L = z({
          inputValue: $
        });
        if (L === null)
          return null;
        k = /* @__PURE__ */ jsx$1(m, {
          ...v,
          children: L
        });
      }
      var V = {
        minMenuHeight: C,
        maxMenuHeight: S,
        menuPlacement: D,
        menuPosition: N,
        menuShouldScrollIntoView: F
      }, U = /* @__PURE__ */ jsx$1(MenuPlacer, {
        ...v,
        ...V,
        children: function(J) {
          var q = J.ref, Z = J.placerProps, ae = Z.placement, ee = Z.maxHeight;
          return /* @__PURE__ */ jsx$1(d, {
            ...v,
            ...V,
            innerRef: q,
            innerProps: {
              onMouseDown: s.onMenuMouseDown,
              onMouseMove: s.onMenuMouseMove
            },
            isLoading: b,
            placement: ae,
            children: /* @__PURE__ */ jsx$1(ScrollManager, {
              captureEnabled: _,
              onTopArrive: O,
              onBottomArrive: G,
              lockEnabled: R,
              children: function(se) {
                return /* @__PURE__ */ jsx$1(h, {
                  ...v,
                  innerRef: function(ce) {
                    s.getMenuListRef(ce), se(ce);
                  },
                  innerProps: {
                    role: "listbox",
                    "aria-multiselectable": v.isMulti,
                    id: s.getElementId("listbox")
                  },
                  isLoading: b,
                  maxHeight: ee,
                  focusedOption: y,
                  children: k
                });
              }
            })
          });
        }
      });
      return T || N === "fixed" ? /* @__PURE__ */ jsx$1(u, {
        ...v,
        appendTo: T,
        controlElement: this.controlRef,
        menuPlacement: D,
        menuPosition: N,
        children: U
      }) : U;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var s = this, o = this.props, c = o.delimiter, l = o.isDisabled, d = o.isMulti, h = o.name, u = o.required, p = this.state.selectValue;
      if (u && !this.hasValue() && !l)
        return /* @__PURE__ */ jsx$1(RequiredInput$1, {
          name: h,
          onFocus: this.onValueInputFocus
        });
      if (!(!h || l))
        if (d)
          if (c) {
            var m = p.map(function(y) {
              return s.getOptionValue(y);
            }).join(c);
            return /* @__PURE__ */ jsx$1("input", {
              name: h,
              type: "hidden",
              value: m
            });
          } else {
            var g = p.length > 0 ? p.map(function(y, x) {
              return /* @__PURE__ */ jsx$1("input", {
                name: h,
                type: "hidden",
                value: s.getOptionValue(y)
              }, "i-".concat(x));
            }) : /* @__PURE__ */ jsx$1("input", {
              name: h,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ jsx$1("div", {
              children: g
            });
          }
        else {
          var v = p[0] ? this.getOptionValue(p[0]) : "";
          return /* @__PURE__ */ jsx$1("input", {
            name: h,
            type: "hidden",
            value: v
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var s = this.commonProps, o = this.state, c = o.ariaSelection, l = o.focusedOption, d = o.focusedValue, h = o.isFocused, u = o.selectValue, p = this.getFocusableOptions();
      return /* @__PURE__ */ jsx$1(LiveRegion$1, {
        ...s,
        id: this.getElementId("live-region"),
        ariaSelection: c,
        focusedOption: l,
        focusedValue: d,
        isFocused: h,
        selectValue: u,
        focusableOptions: p,
        isAppleDevice: this.isAppleDevice
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.getComponents(), o = s.Control, c = s.IndicatorsContainer, l = s.SelectContainer, d = s.ValueContainer, h = this.props, u = h.className, p = h.id, m = h.isDisabled, g = h.menuIsOpen, v = this.state.isFocused, y = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ jsxs(l, {
        ...y,
        className: u,
        innerProps: {
          id: p,
          onKeyDown: this.onKeyDown
        },
        isDisabled: m,
        isFocused: v,
        children: [this.renderLiveRegion(), /* @__PURE__ */ jsxs(o, {
          ...y,
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: m,
          isFocused: v,
          menuIsOpen: g,
          children: [/* @__PURE__ */ jsxs(d, {
            ...y,
            isDisabled: m,
            children: [this.renderPlaceholderOrValue(), this.renderInput()]
          }), /* @__PURE__ */ jsxs(c, {
            ...y,
            isDisabled: m,
            children: [this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator()]
          })]
        }), this.renderMenu(), this.renderFormField()]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(s, o) {
      var c = o.prevProps, l = o.clearFocusValueOnUpdate, d = o.inputIsHiddenAfterUpdate, h = o.ariaSelection, u = o.isFocused, p = o.prevWasFocused, m = o.instancePrefix, g = s.options, v = s.value, y = s.menuIsOpen, x = s.inputValue, _ = s.isMulti, $ = cleanValue(v), b = {};
      if (c && (v !== c.value || g !== c.options || y !== c.menuIsOpen || x !== c.inputValue)) {
        var M = y ? buildFocusableOptions(s, $) : [], C = y ? buildFocusableOptionsWithIds(buildCategorizedOptions(s, $), "".concat(m, "-option")) : [], S = l ? getNextFocusedValue(o, $) : null, A = getNextFocusedOption(o, M), D = getFocusedOptionId(C, A);
        b = {
          selectValue: $,
          focusedOption: A,
          focusedOptionId: D,
          focusableOptionsWithIds: C,
          focusedValue: S,
          clearFocusValueOnUpdate: !1
        };
      }
      var N = d != null && s !== c ? {
        inputIsHidden: d,
        inputIsHiddenAfterUpdate: void 0
      } : {}, T = h, R = u && p;
      return u && !R && (T = {
        value: valueTernary(_, $, $[0] || null),
        options: $,
        action: "initial-input-focus"
      }, R = !p), (h == null ? void 0 : h.action) === "initial-input-focus" && (T = null), _objectSpread2(_objectSpread2(_objectSpread2({}, b), N), {}, {
        prevProps: s,
        ariaSelection: T,
        prevWasFocused: R
      });
    }
  }]), n;
}(Component);
Select$2.defaultProps = defaultProps$1;
var StateManagedSelect = /* @__PURE__ */ forwardRef(function(t, r) {
  var n = useStateManager(t);
  return /* @__PURE__ */ jsx$1(Select$2, {
    ref: r,
    ...n
  });
}), StateManagedSelect$1 = StateManagedSelect;
const CustomSelect = styled(StateManagedSelect$1)`
  ${({ theme: { fontFamily: t } }) => t.silka};
  width: 100%;
  .taxdown-select__control {
    ${inputBaseStyles};
    padding: ${({ theme: { reference: t } }) => t.dimension_12};
    :hover {
      border-color: ${({ theme: { components: t } }) => t.inputs.fds_c_input_bordercolor};
      border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
      border-width: ${({ theme: { components: t } }) => t.inputs.fds_c_input_default_borderwidth};
      ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
          border-color: ${r.border.fds_sys_color_border_warning};
        `};
      ${({ $hasError: t, theme: { system: r } }) => t && css$3`
          border-color: ${r.border.fds_sys_color_border_error};
        `};
    }
    &.taxdown-select__control--is-focused {
      ${({ $hasWarning: t, $hasError: r, theme: { system: n } }) => t && !r && css$3`
          border-color: ${n.global.fds_sys_color_transparent};
        `};
      background: ${({ theme: { components: t } }) => t.inputs.fds_c_input_color_background_focus};
    }
    .taxdown-select__input-container {
      padding: 0;
      margin: 0;
    }
    ${({ readOnly: t }) => t && css$3`
        padding: ${({ theme: { system: r } }) => r.fds_sys_spacing_S};
        color: ${({ theme: { system: r } }) => r.text.fds_sys_color_text_placeholder};
        background: ${({ theme: { colors: r } }) => r.moon_100};
        pointer-events: none;
        &.taxdown-select__control {
          .taxdown-select__indicators {
            display: none;
          }
        }
      `};

    &.taxdown-select__control--is-disabled {
      padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
      border: 1px solid ${({ theme: { components: t } }) => t.inputs.fds_c_input_bordercolor};
      color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_placeholder};
      background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_primary};
      cursor: not-allowed;
      opacity: 0.38;
      pointer-events: auto;
      .taxdown-select__indicators {
        display: none;
      }
    }
    &.taxdown-select__control--is-focused {
      box-shadow: none;
      :hover {
        border-color: ${({ theme: { system: t } }) => t.global.fds_sys_color_transparent};
        border-color: ${({ theme: { components: t } }) => t.inputs.fds_c_input_bordercolor};
        border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
        border-width: ${({ theme: { components: t } }) => t.inputs.fds_c_input_default_borderwidth};
        ${({ $hasWarning: t, theme: { system: r, components: n } }) => t && css$3`
            box-shadow: ${() => {
  const { x: a, y: s, blur: o, spread: c, color: l } = n.inputs.fds_c_input_focus_warning;
  return `inset ${a} ${s} ${o} ${c} ${l}`;
}};
            border-color: ${r.border.fds_sys_color_border_warning};
          `};
        ${({ $hasError: t, theme: { system: r, components: n } }) => t && css$3`
            box-shadow: ${() => {
  const { x: a, y: s, blur: o, spread: c, color: l } = n.inputs.fds_c_input_focus_error;
  return `inset ${a} ${s} ${o} ${c} ${l}`;
}};
            border-color: ${r.border.fds_sys_color_border_error};
          `};
        ${({ $hasError: t, $hasWarning: r, readOnly: n, theme: { components: a } }) => !t && !r && !n && css$3`
            background: ${a.inputs.fds_c_input_color_background_focus};
          `};
      }
    }
    &.taxdown-select__control--menu-is-open {
      box-shadow: ${({ theme: { system: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.fds_sys_embed_M;
  return `inset ${r} ${n} ${a} ${s} ${o}`;
}};
      :hover {
        border-color: ${({ theme: { components: t } }) => t.inputs.fds_c_input_bordercolor};
        border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
        border-width: ${({ theme: { components: t } }) => t.inputs.fds_c_input_default_borderwidth};
        ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
            border-color: ${r.border.fds_sys_color_border_warning};
          `};
        ${({ $hasError: t, theme: { system: r } }) => t && css$3`
            border-color: ${r.border.fds_sys_color_border_error};
          `};
      }
      &.taxdown-select__control--is-focused {
        ${({ $hasWarning: t, $hasError: r, theme: { system: n } }) => !t && !r && css$3`
            border-color: ${n.global.fds_sys_color_transparent};
          `};
      }
      .taxdown-select__indicators {
        transform: rotate(180deg);
      }
      ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
          border-color: ${r.border.fds_sys_color_border_warning};
        `};
      ${({ $hasError: t, theme: { system: r } }) => t && css$3`
          border-color: ${r.border.fds_sys_color_border_error};
        `};
    }

    .taxdown-select__value-container {
      padding: 0px;
      ${({ theme: { components: t } }) => t.inputs.fds_c_input_content};
      outline: none;
      .taxdown-select__single-value {
        color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_primary};
        ${({ $hasError: t, theme: { system: r } }) => t && css$3`
            color: ${r.text.fds_sys_color_text_danger_stronger};
          `};
        ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
            color: ${r.text.fds_sys_color_text_warning_stronger};
          `};
      }

      .taxdown-select__placeholder {
        color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_placeholder};
        ${({ theme: { components: t } }) => t.inputs.fds_c_input_content};
        outline: none;
        ${({ $hasError: t, theme: { system: r } }) => t && css$3`
            color: ${r.text.fds_sys_color_text_danger_stronger};
            opacity: ${r.fds_sys_disabled_opacity_S};
          `}
        ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
            color: ${r.text.fds_sys_color_text_warning_stronger};
            opacity: ${r.fds_sys_disabled_opacity_S};
          `}
      }
    }
    ${({ $hasError: t, theme: { system: r } }) => t && css$3`
        background-color: ${r.background.fds_sys_color_background_error};
        border: 1px solid ${r.border.fds_sys_color_border_error};
        color: ${r.text.fds_sys_color_text_danger_stronger};
      `};
    ${({ $hasWarning: t, theme: { system: r } }) => t && css$3`
        background-color: ${r.background.fds_sys_color_background_warning};
        border: 1px solid ${r.border.fds_sys_color_border_warning};
        color: ${r.text.fds_sys_color_text_warning_stronger};
      `};
  }
  .taxdown-select__indicators {
    transition: transform 0.3s ease-in-out 0s;
    .taxdown-select__indicator-separator {
      display: none;
    }
    .taxdown-select__dropdown-indicator {
      padding: 0px;
      svg {
        width: 24px;
        height: 24px;
        fill: ${({ theme: { colors: t } }) => t.dark_500};
      }
    }
    .taxdown-select__clear-indicator {
      padding: 0px;
      svg {
        width: 24px;
        height: 24px;
        fill: ${({ theme: { colors: t } }) => t.dark_500};
      }
      z-index: 10;
      cursor: pointer;
    }
  }
  .taxdown-select__menu {
    background: ${({ theme: { reference: t } }) => t.neutral.white};
    border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
    border-width: 0px;
    display: block;
    z-index: ${({ theme: { system: t } }) => t.zIndex.fds_sys_zindex_overlay};
    box-shadow: ${({ theme: { system: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.fds_sys_elevation_L;
  return `${r} ${n} ${a} ${s} ${o}`;
}};
    .taxdown-select__menu-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_XS};
      gap: ${({ theme: { system: t } }) => t.fds_sys_spacing_XS};
      .taxdown-select__option {
        ${({ theme: { system: t } }) => t.fds_sys_S};
        line-height: ${({ theme: { system: t } }) => t.fds_sys_lineheight_S};
        color: ${({ theme: { system: t } }) => t.accent.fds_sys_color_accent_cold};
      }
      .taxdown-select__option--is-focused {
        background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_secondary};
        border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_S};
      }
      .taxdown-select__option--is-selected {
        background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_cold};
        border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_S};
      }
    }
  }
`;
styled.p`
  ${({ theme: { components: t } }) => t.inputs.fds_c_input_mandatory_text};
  color: ${({ theme: { system: t } }) => t.text.fds_sys_color_text_secondary};
  margin-bottom: ${({ theme: { sizing: t } }) => t.fds_size_08};
`;
const DEFAULT_SELECT_PLACEHOLDER = "Selecciona", Select = ({
  value: t,
  options: r,
  hasError: n,
  hasWarning: a,
  disabled: s,
  readOnly: o,
  menuPortalTarget: c,
  onChange: l,
  ...d
}) => {
  const h = useMemo(() => {
    if (Array.isArray(t)) {
      const m = t;
      return r == null ? void 0 : r.filter((v) => m == null ? void 0 : m.includes(v.value));
    }
    return t === "" ? null : r == null ? void 0 : r.find((m) => m.value == t);
  }, [t, r]), u = (m) => {
    const {
      value: g
    } = m;
    return convertToType(g === void 0 ? null : g, g);
  };
  return /* @__PURE__ */ jsx$1(CustomSelect, {
    ...d,
    value: h,
    options: r,
    classNamePrefix: "taxdown-select",
    $hasError: n,
    $hasWarning: a,
    isDisabled: s,
    readOnly: o,
    menuPortalTarget: c,
    placeholder: DEFAULT_SELECT_PLACEHOLDER,
    onChange: (m, g) => {
      if ((g == null ? void 0 : g.action) === "clear") {
        const y = Array.isArray(m) ? [] : null;
        l == null || l(y, g);
        return;
      }
      const v = Array.isArray(m) ? m.map((y) => u(y)) : u(m);
      l == null || l(v, g);
    }
  });
}, Select$1 = withInputLayout(Select);
var SwitcherSize = /* @__PURE__ */ ((t) => (t.S = "small", t.M = "medium", t))(SwitcherSize || {});
const containerStyle = {
  [SwitcherSize.S]: css$3`
    height: ${({ theme: { system: t } }) => t.fds_sys_sizing_XS};
    width: ${({ theme: { system: t } }) => t.fds_sys_sizing_M};
  `,
  [SwitcherSize.M]: css$3`
    height: ${({ theme: { system: t } }) => t.fds_sys_sizing_S};
    width: ${({ theme: { system: t } }) => t.fds_sys_sizing_L};
  `
}, togglerStyle = {
  [SwitcherSize.S]: css$3`
    height: ${({ theme: { reference: t } }) => t.dimension_12};
    width: ${({ theme: { reference: t } }) => t.dimension_12};
    left: ${({ theme: { reference: t } }) => t.dimension_02};
    bottom: ${({ theme: { reference: t } }) => t.dimension_02};
  `,
  [SwitcherSize.M]: css$3`
    height: ${({ theme: { reference: t } }) => t.dimension_16};
    width: ${({ theme: { reference: t } }) => t.dimension_16};
    left: ${({ theme: { reference: t } }) => t.dimension_04};
    bottom: ${({ theme: { reference: t } }) => t.dimension_04};
  `
}, disabledMode = css$3`
  opacity: ${({ theme: { system: t } }) => t.fds_sys_disabled_opacity_XS};
  cursor: 'default';
`, Container$9 = styled.div`
  position: relative;
  display: inline-block;
  ${({ size: t }) => containerStyle[t && SwitcherSize[t] || SwitcherSize.M]};
`, Slider = styled.span`
  position: absolute;
  cursor: pointer;
  ${({ size: t }) => containerStyle[t && SwitcherSize[t] || SwitcherSize.M]};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({
  theme: {
    components: { inputs: t }
  },
  active: r
}) => r ? t.fds_c_input_switch_background_on : t.fds_c_input_switch_background_off};
  transition: 0.4s;
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_O};
  box-shadow: ${({ theme: { system: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.fds_sys_elevation_S;
  return `inset ${r} ${n} ${a} ${s} ${o}`;
}};

  ${({ readOnly: t }) => t && disabledMode}

  &:before {
    position: absolute;
    content: '';
    background-color: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_primary};
    transition: 0.4s;
    border-radius: 50%;
    ${({ size: t }) => togglerStyle[t && SwitcherSize[t] || SwitcherSize.M]};
    transform: translateX(
      ${({ active: t, theme: { reference: r } }) => t ? r.dimension_16 : 0}
    );
  }
`, Switcher = ({
  size: t,
  value: r,
  onChange: n,
  readOnly: a,
  ...s
}) => /* @__PURE__ */ jsx$1(Container$9, {
  size: t,
  children: /* @__PURE__ */ jsx$1(CheckBoxWrapper, {
    ...s,
    value: r,
    onChange: (c) => {
      n(c);
    },
    readOnly: a,
    children: /* @__PURE__ */ jsx$1(Slider, {
      size: t,
      active: r,
      readOnly: a
    })
  })
}), Container$8 = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  ::after {
    content: '${({ $lengthText: t }) => t}';
    position: absolute;
    right: 0;
    bottom: ${({ theme: { reference: t } }) => `-${t.dimension_18}`};
    ${({ theme: { components: t } }) => t.paragraphs.XS_M_S};
    color: ${({ theme: { reference: t }, $hasError: r }) => r ? t.functional.danger_500 : t.neutral.moon_800};
  }
`, TextArea$2 = styled.textarea`
  ${TextInputStyles}
  resize: vertical;
`, TextArea = ({
  value: t,
  hasError: r,
  hasWarning: n,
  onChange: a,
  validations: s,
  ...o
}) => /* @__PURE__ */ jsx$1(Container$8, {
  ...(s == null ? void 0 : s.length) && {
    $lengthText: `${(t == null ? void 0 : t.length) || 0}/${s == null ? void 0 : s.length}`
  },
  $hasError: r,
  children: /* @__PURE__ */ jsx$1(TextArea$2, {
    ...o,
    $hasError: r,
    $hasWarning: n,
    value: t,
    onChange: (c) => a(c.target.value)
  })
}), TextArea$1 = withInputLayout(TextArea), YesNoRadioGroup = (t) => /* @__PURE__ */ jsx$1(RadioExtended$1, {
  ...t,
  options: [{
    label: "Sí",
    value: 1
  }, {
    label: "No",
    value: 0
  }]
});
function __awaiter(t, r, n, a) {
  function s(o) {
    return o instanceof n ? o : new n(function(c) {
      c(o);
    });
  }
  return new (n || (n = Promise))(function(o, c) {
    function l(u) {
      try {
        h(a.next(u));
      } catch (p) {
        c(p);
      }
    }
    function d(u) {
      try {
        h(a.throw(u));
      } catch (p) {
        c(p);
      }
    }
    function h(u) {
      u.done ? o(u.value) : s(u.value).then(l, d);
    }
    h((a = a.apply(t, r || [])).next());
  });
}
function __generator(t, r) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, a, s, o, c;
  return c = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function l(h) {
    return function(u) {
      return d([h, u]);
    };
  }
  function d(h) {
    if (a)
      throw new TypeError("Generator is already executing.");
    for (; c && (c = 0, h[0] && (n = 0)), n; )
      try {
        if (a = 1, s && (o = h[0] & 2 ? s.return : h[0] ? s.throw || ((o = s.return) && o.call(s), 0) : s.next) && !(o = o.call(s, h[1])).done)
          return o;
        switch (s = 0, o && (h = [h[0] & 2, o.value]), h[0]) {
          case 0:
          case 1:
            o = h;
            break;
          case 4:
            return n.label++, { value: h[1], done: !1 };
          case 5:
            n.label++, s = h[1], h = [0];
            continue;
          case 7:
            h = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              n = 0;
              continue;
            }
            if (h[0] === 3 && (!o || h[1] > o[0] && h[1] < o[3])) {
              n.label = h[1];
              break;
            }
            if (h[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = h;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(h);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        h = r.call(t, n);
      } catch (u) {
        h = [6, u], s = 0;
      } finally {
        a = o = 0;
      }
    if (h[0] & 5)
      throw h[1];
    return { value: h[0] ? h[1] : void 0, done: !0 };
  }
}
function __read(t, r) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var a = n.call(t), s, o = [], c;
  try {
    for (; (r === void 0 || r-- > 0) && !(s = a.next()).done; )
      o.push(s.value);
  } catch (l) {
    c = { error: l };
  } finally {
    try {
      s && !s.done && (n = a.return) && n.call(a);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return o;
}
function __spreadArray(t, r, n) {
  if (n || arguments.length === 2)
    for (var a = 0, s = r.length, o; a < s; a++)
      (o || !(a in r)) && (o || (o = Array.prototype.slice.call(r, 0, a)), o[a] = r[a]);
  return t.concat(o || Array.prototype.slice.call(r));
}
typeof SuppressedError == "function" && SuppressedError;
var COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function toFileWithPath(t, r) {
  var n = withMimeType(t);
  if (typeof n.path != "string") {
    var a = t.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: typeof r == "string" ? r : typeof a == "string" && a.length > 0 ? a : t.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return n;
}
function withMimeType(t) {
  var r = t.name, n = r && r.lastIndexOf(".") !== -1;
  if (n && !t.type) {
    var a = r.split(".").pop().toLowerCase(), s = COMMON_MIME_TYPES.get(a);
    s && Object.defineProperty(t, "type", {
      value: s,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
var FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function fromEvent(t) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(r) {
      return isObject(t) && isDataTransfer(t.dataTransfer) ? [2, getDataTransferFiles(t.dataTransfer, t.type)] : isChangeEvt(t) ? [2, getInputFiles(t)] : Array.isArray(t) && t.every(function(n) {
        return "getFile" in n && typeof n.getFile == "function";
      }) ? [2, getFsHandleFiles(t)] : [2, []];
    });
  });
}
function isDataTransfer(t) {
  return isObject(t);
}
function isChangeEvt(t) {
  return isObject(t) && isObject(t.target);
}
function isObject(t) {
  return typeof t == "object" && t !== null;
}
function getInputFiles(t) {
  return fromList(t.target.files).map(function(r) {
    return toFileWithPath(r);
  });
}
function getFsHandleFiles(t) {
  return __awaiter(this, void 0, void 0, function() {
    var r;
    return __generator(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all(t.map(function(a) {
            return a.getFile();
          }))];
        case 1:
          return r = n.sent(), [2, r.map(function(a) {
            return toFileWithPath(a);
          })];
      }
    });
  });
}
function getDataTransferFiles(t, r) {
  return __awaiter(this, void 0, void 0, function() {
    var n, a;
    return __generator(this, function(s) {
      switch (s.label) {
        case 0:
          return t.items ? (n = fromList(t.items).filter(function(o) {
            return o.kind === "file";
          }), r !== "drop" ? [2, n] : [4, Promise.all(n.map(toFilePromises))]) : [3, 2];
        case 1:
          return a = s.sent(), [2, noIgnoredFiles(flatten(a))];
        case 2:
          return [2, noIgnoredFiles(fromList(t.files).map(function(o) {
            return toFileWithPath(o);
          }))];
      }
    });
  });
}
function noIgnoredFiles(t) {
  return t.filter(function(r) {
    return FILES_TO_IGNORE.indexOf(r.name) === -1;
  });
}
function fromList(t) {
  if (t === null)
    return [];
  for (var r = [], n = 0; n < t.length; n++) {
    var a = t[n];
    r.push(a);
  }
  return r;
}
function toFilePromises(t) {
  if (typeof t.webkitGetAsEntry != "function")
    return fromDataTransferItem(t);
  var r = t.webkitGetAsEntry();
  return r && r.isDirectory ? fromDirEntry(r) : fromDataTransferItem(t);
}
function flatten(t) {
  return t.reduce(function(r, n) {
    return __spreadArray(__spreadArray([], __read(r), !1), __read(Array.isArray(n) ? flatten(n) : [n]), !1);
  }, []);
}
function fromDataTransferItem(t) {
  var r = t.getAsFile();
  if (!r)
    return Promise.reject("".concat(t, " is not a File"));
  var n = toFileWithPath(r);
  return Promise.resolve(n);
}
function fromEntry(t) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(r) {
      return [2, t.isDirectory ? fromDirEntry(t) : fromFileEntry(t)];
    });
  });
}
function fromDirEntry(t) {
  var r = t.createReader();
  return new Promise(function(n, a) {
    var s = [];
    function o() {
      var c = this;
      r.readEntries(function(l) {
        return __awaiter(c, void 0, void 0, function() {
          var d, h, u;
          return __generator(this, function(p) {
            switch (p.label) {
              case 0:
                if (l.length)
                  return [3, 5];
                p.label = 1;
              case 1:
                return p.trys.push([1, 3, , 4]), [4, Promise.all(s)];
              case 2:
                return d = p.sent(), n(d), [3, 4];
              case 3:
                return h = p.sent(), a(h), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                u = Promise.all(l.map(fromEntry)), s.push(u), o(), p.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(l) {
        a(l);
      });
    }
    o();
  });
}
function fromFileEntry(t) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(r) {
      return [2, new Promise(function(n, a) {
        t.file(function(s) {
          var o = toFileWithPath(s, t.fullPath);
          n(o);
        }, function(s) {
          a(s);
        });
      })];
    });
  });
}
var _default = function(t, r) {
  if (t && r) {
    var n = Array.isArray(r) ? r : r.split(","), a = t.name || "", s = (t.type || "").toLowerCase(), o = s.replace(/\/.*$/, "");
    return n.some(function(c) {
      var l = c.trim().toLowerCase();
      return l.charAt(0) === "." ? a.toLowerCase().endsWith(l) : l.endsWith("/*") ? o === l.replace(/\/.*$/, "") : s === l;
    });
  }
  return !0;
};
function _toConsumableArray$1(t) {
  return _arrayWithoutHoles$1(t) || _iterableToArray$1(t) || _unsupportedIterableToArray$1(t) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function _arrayWithoutHoles$1(t) {
  if (Array.isArray(t))
    return _arrayLikeToArray$1(t);
}
function ownKeys$1(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread$1(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(n), !0).forEach(function(a) {
      _defineProperty$1(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys$1(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty$1(t, r, n) {
  return r in t ? Object.defineProperty(t, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = n, t;
}
function _slicedToArray$1(t, r) {
  return _arrayWithHoles$1(t) || _iterableToArrayLimit$1(t, r) || _unsupportedIterableToArray$1(t, r) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray$1(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$1(t, r);
  }
}
function _arrayLikeToArray$1(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _iterableToArrayLimit$1(t, r) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a = [], s = !0, o = !1, c, l;
    try {
      for (n = n.call(t); !(s = (c = n.next()).done) && (a.push(c.value), !(r && a.length === r)); s = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function _arrayWithHoles$1(t) {
  if (Array.isArray(t))
    return t;
}
var FILE_INVALID_TYPE = "file-invalid-type", FILE_TOO_LARGE = "file-too-large", FILE_TOO_SMALL = "file-too-small", TOO_MANY_FILES = "too-many-files", ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}, getInvalidTypeRejectionErr = function(r) {
  r = Array.isArray(r) && r.length === 1 ? r[0] : r;
  var n = Array.isArray(r) ? "one of ".concat(r.join(", ")) : r;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(n)
  };
}, getTooLargeRejectionErr = function(r) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, getTooSmallRejectionErr = function(r) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(t, r) {
  var n = t.type === "application/x-moz-file" || _default(t, r);
  return [n, n ? null : getInvalidTypeRejectionErr(r)];
}
function fileMatchSize(t, r, n) {
  if (isDefined(t.size))
    if (isDefined(r) && isDefined(n)) {
      if (t.size > n)
        return [!1, getTooLargeRejectionErr(n)];
      if (t.size < r)
        return [!1, getTooSmallRejectionErr(r)];
    } else {
      if (isDefined(r) && t.size < r)
        return [!1, getTooSmallRejectionErr(r)];
      if (isDefined(n) && t.size > n)
        return [!1, getTooLargeRejectionErr(n)];
    }
  return [!0, null];
}
function isDefined(t) {
  return t != null;
}
function allFilesAccepted(t) {
  var r = t.files, n = t.accept, a = t.minSize, s = t.maxSize, o = t.multiple, c = t.maxFiles, l = t.validator;
  return !o && r.length > 1 || o && c >= 1 && r.length > c ? !1 : r.every(function(d) {
    var h = fileAccepted(d, n), u = _slicedToArray$1(h, 1), p = u[0], m = fileMatchSize(d, a, s), g = _slicedToArray$1(m, 1), v = g[0], y = l ? l(d) : null;
    return p && v && !y;
  });
}
function isPropagationStopped(t) {
  return typeof t.isPropagationStopped == "function" ? t.isPropagationStopped() : typeof t.cancelBubble < "u" ? t.cancelBubble : !1;
}
function isEvtWithFiles(t) {
  return t.dataTransfer ? Array.prototype.some.call(t.dataTransfer.types, function(r) {
    return r === "Files" || r === "application/x-moz-file";
  }) : !!t.target && !!t.target.files;
}
function onDocumentDragOver(t) {
  t.preventDefault();
}
function isIe(t) {
  return t.indexOf("MSIE") !== -1 || t.indexOf("Trident/") !== -1;
}
function isEdge(t) {
  return t.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(t) || isEdge(t);
}
function composeEventHandlers() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return function(a) {
    for (var s = arguments.length, o = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
      o[c - 1] = arguments[c];
    return r.some(function(l) {
      return !isPropagationStopped(a) && l && l.apply(void 0, [a].concat(o)), isPropagationStopped(a);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(t) {
  if (isDefined(t)) {
    var r = Object.entries(t).filter(function(n) {
      var a = _slicedToArray$1(n, 2), s = a[0], o = a[1], c = !0;
      return isMIMEType(s) || (console.warn('Skipped "'.concat(s, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), c = !1), (!Array.isArray(o) || !o.every(isExt)) && (console.warn('Skipped "'.concat(s, '" because an invalid file extension was provided.')), c = !1), c;
    }).reduce(function(n, a) {
      var s = _slicedToArray$1(a, 2), o = s[0], c = s[1];
      return _objectSpread$1(_objectSpread$1({}, n), {}, _defineProperty$1({}, o, c));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: r
    }];
  }
  return t;
}
function acceptPropAsAcceptAttr(t) {
  if (isDefined(t))
    return Object.entries(t).reduce(function(r, n) {
      var a = _slicedToArray$1(n, 2), s = a[0], o = a[1];
      return [].concat(_toConsumableArray$1(r), [s], _toConsumableArray$1(o));
    }, []).filter(function(r) {
      return isMIMEType(r) || isExt(r);
    }).join(",");
}
function isAbort(t) {
  return t instanceof DOMException && (t.name === "AbortError" || t.code === t.ABORT_ERR);
}
function isSecurityError(t) {
  return t instanceof DOMException && (t.name === "SecurityError" || t.code === t.SECURITY_ERR);
}
function isMIMEType(t) {
  return t === "audio/*" || t === "video/*" || t === "image/*" || t === "text/*" || /\w+\/[-+.\w]+/g.test(t);
}
function isExt(t) {
  return /^.*\.[\w]+$/.test(t);
}
var _excluded = ["children"], _excluded2 = ["open"], _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(t) {
  return _arrayWithoutHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function _arrayWithoutHoles(t) {
  if (Array.isArray(t))
    return _arrayLikeToArray(t);
}
function _slicedToArray(t, r) {
  return _arrayWithHoles(t) || _iterableToArrayLimit(t, r) || _unsupportedIterableToArray(t, r) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(t, r) {
  if (t) {
    if (typeof t == "string")
      return _arrayLikeToArray(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray(t, r);
  }
}
function _arrayLikeToArray(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = new Array(r); n < r; n++)
    a[n] = t[n];
  return a;
}
function _iterableToArrayLimit(t, r) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a = [], s = !0, o = !1, c, l;
    try {
      for (n = n.call(t); !(s = (c = n.next()).done) && (a.push(c.value), !(r && a.length === r)); s = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function _arrayWithHoles(t) {
  if (Array.isArray(t))
    return t;
}
function ownKeys(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys(Object(n), !0).forEach(function(a) {
      _defineProperty(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _defineProperty(t, r, n) {
  return r in t ? Object.defineProperty(t, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = n, t;
}
function _objectWithoutProperties(t, r) {
  if (t == null)
    return {};
  var n = _objectWithoutPropertiesLoose(t, r), a, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (s = 0; s < o.length; s++)
      a = o[s], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function _objectWithoutPropertiesLoose(t, r) {
  if (t == null)
    return {};
  var n = {}, a = Object.keys(t), s, o;
  for (o = 0; o < a.length; o++)
    s = a[o], !(r.indexOf(s) >= 0) && (n[s] = t[s]);
  return n;
}
var Dropzone = /* @__PURE__ */ forwardRef(function(t, r) {
  var n = t.children, a = _objectWithoutProperties(t, _excluded), s = useDropzone(a), o = s.open, c = _objectWithoutProperties(s, _excluded2);
  return useImperativeHandle(r, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ jsx$1(Fragment$1, {
    children: n(_objectSpread(_objectSpread({}, c), {}, {
      open: o
    }))
  });
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: !1,
  getFilesFromEvent: fromEvent,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = _objectSpread(_objectSpread({}, defaultProps), t), n = r.accept, a = r.disabled, s = r.getFilesFromEvent, o = r.maxSize, c = r.minSize, l = r.multiple, d = r.maxFiles, h = r.onDragEnter, u = r.onDragLeave, p = r.onDragOver, m = r.onDrop, g = r.onDropAccepted, v = r.onDropRejected, y = r.onFileDialogCancel, x = r.onFileDialogOpen, _ = r.useFsAccessApi, $ = r.autoFocus, b = r.preventDropOnDocument, M = r.noClick, C = r.noKeyboard, S = r.noDrag, A = r.noDragEventsBubbling, D = r.onError, N = r.validator, T = useMemo(function() {
    return acceptPropAsAcceptAttr(n);
  }, [n]), R = useMemo(function() {
    return pickerOptionsFromAccept(n);
  }, [n]), F = useMemo(function() {
    return typeof x == "function" ? x : noop;
  }, [x]), z = useMemo(function() {
    return typeof y == "function" ? y : noop;
  }, [y]), O = useRef(null), G = useRef(null), I = useReducer(reducer, initialState), k = _slicedToArray(I, 2), B = k[0], L = k[1], V = B.isFocused, U = B.isFileDialogActive, J = useRef(typeof window < "u" && window.isSecureContext && _ && canUseFileSystemAccessAPI()), q = function() {
    !J.current && U && setTimeout(function() {
      if (G.current) {
        var Nr = G.current.files;
        Nr.length || (L({
          type: "closeDialog"
        }), z());
      }
    }, 300);
  };
  useEffect(function() {
    return window.addEventListener("focus", q, !1), function() {
      window.removeEventListener("focus", q, !1);
    };
  }, [G, U, z, J]);
  var Z = useRef([]), ae = function(Nr) {
    O.current && O.current.contains(Nr.target) || (Nr.preventDefault(), Z.current = []);
  };
  useEffect(function() {
    return b && (document.addEventListener("dragover", onDocumentDragOver, !1), document.addEventListener("drop", ae, !1)), function() {
      b && (document.removeEventListener("dragover", onDocumentDragOver), document.removeEventListener("drop", ae));
    };
  }, [O, b]), useEffect(function() {
    return !a && $ && O.current && O.current.focus(), function() {
    };
  }, [O, $, a]);
  var ee = useCallback(function(wr) {
    D ? D(wr) : console.error(wr);
  }, [D]), se = useCallback(function(wr) {
    wr.preventDefault(), wr.persist(), ze(wr), Z.current = [].concat(_toConsumableArray(Z.current), [wr.target]), isEvtWithFiles(wr) && Promise.resolve(s(wr)).then(function(Nr) {
      if (!(isPropagationStopped(wr) && !A)) {
        var xr = Nr.length, Er = xr > 0 && allFilesAccepted({
          files: Nr,
          accept: T,
          minSize: c,
          maxSize: o,
          multiple: l,
          maxFiles: d,
          validator: N
        }), Ir = xr > 0 && !Er;
        L({
          isDragAccept: Er,
          isDragReject: Ir,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), h && h(wr);
      }
    }).catch(function(Nr) {
      return ee(Nr);
    });
  }, [s, h, ee, A, T, c, o, l, d, N]), nr = useCallback(function(wr) {
    wr.preventDefault(), wr.persist(), ze(wr);
    var Nr = isEvtWithFiles(wr);
    if (Nr && wr.dataTransfer)
      try {
        wr.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Nr && p && p(wr), !1;
  }, [p, A]), ce = useCallback(function(wr) {
    wr.preventDefault(), wr.persist(), ze(wr);
    var Nr = Z.current.filter(function(Er) {
      return O.current && O.current.contains(Er);
    }), xr = Nr.indexOf(wr.target);
    xr !== -1 && Nr.splice(xr, 1), Z.current = Nr, !(Nr.length > 0) && (L({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), isEvtWithFiles(wr) && u && u(wr));
  }, [O, u, A]), oe = useCallback(function(wr, Nr) {
    var xr = [], Er = [];
    wr.forEach(function(Ir) {
      var Rr = fileAccepted(Ir, T), Yr = _slicedToArray(Rr, 2), Qr = Yr[0], nn = Yr[1], on = fileMatchSize(Ir, c, o), en = _slicedToArray(on, 2), zr = en[0], Jr = en[1], H = N ? N(Ir) : null;
      if (Qr && zr && !H)
        xr.push(Ir);
      else {
        var dr = [nn, Jr];
        H && (dr = dr.concat(H)), Er.push({
          file: Ir,
          errors: dr.filter(function(Ar) {
            return Ar;
          })
        });
      }
    }), (!l && xr.length > 1 || l && d >= 1 && xr.length > d) && (xr.forEach(function(Ir) {
      Er.push({
        file: Ir,
        errors: [TOO_MANY_FILES_REJECTION]
      });
    }), xr.splice(0)), L({
      acceptedFiles: xr,
      fileRejections: Er,
      type: "setFiles"
    }), m && m(xr, Er, Nr), Er.length > 0 && v && v(Er, Nr), xr.length > 0 && g && g(xr, Nr);
  }, [L, l, T, c, o, d, m, g, v, N]), ur = useCallback(function(wr) {
    wr.preventDefault(), wr.persist(), ze(wr), Z.current = [], isEvtWithFiles(wr) && Promise.resolve(s(wr)).then(function(Nr) {
      isPropagationStopped(wr) && !A || oe(Nr, wr);
    }).catch(function(Nr) {
      return ee(Nr);
    }), L({
      type: "reset"
    });
  }, [s, oe, ee, A]), ir = useCallback(function() {
    if (J.current) {
      L({
        type: "openDialog"
      }), F();
      var wr = {
        multiple: l,
        types: R
      };
      window.showOpenFilePicker(wr).then(function(Nr) {
        return s(Nr);
      }).then(function(Nr) {
        oe(Nr, null), L({
          type: "closeDialog"
        });
      }).catch(function(Nr) {
        isAbort(Nr) ? (z(Nr), L({
          type: "closeDialog"
        })) : isSecurityError(Nr) ? (J.current = !1, G.current ? (G.current.value = null, G.current.click()) : ee(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ee(Nr);
      });
      return;
    }
    G.current && (L({
      type: "openDialog"
    }), F(), G.current.value = null, G.current.click());
  }, [L, F, z, _, oe, ee, R, l]), _r = useCallback(function(wr) {
    !O.current || !O.current.isEqualNode(wr.target) || (wr.key === " " || wr.key === "Enter" || wr.keyCode === 32 || wr.keyCode === 13) && (wr.preventDefault(), ir());
  }, [O, ir]), yr = useCallback(function() {
    L({
      type: "focus"
    });
  }, []), ne = useCallback(function() {
    L({
      type: "blur"
    });
  }, []), pe = useCallback(function() {
    M || (isIeOrEdge() ? setTimeout(ir, 0) : ir());
  }, [M, ir]), hr = function(Nr) {
    return a ? null : Nr;
  }, $r = function(Nr) {
    return C ? null : hr(Nr);
  }, Sr = function(Nr) {
    return S ? null : hr(Nr);
  }, ze = function(Nr) {
    A && Nr.stopPropagation();
  }, cr = useMemo(function() {
    return function() {
      var wr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Nr = wr.refKey, xr = Nr === void 0 ? "ref" : Nr, Er = wr.role, Ir = wr.onKeyDown, Rr = wr.onFocus, Yr = wr.onBlur, Qr = wr.onClick, nn = wr.onDragEnter, on = wr.onDragOver, en = wr.onDragLeave, zr = wr.onDrop, Jr = _objectWithoutProperties(wr, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: $r(composeEventHandlers(Ir, _r)),
        onFocus: $r(composeEventHandlers(Rr, yr)),
        onBlur: $r(composeEventHandlers(Yr, ne)),
        onClick: hr(composeEventHandlers(Qr, pe)),
        onDragEnter: Sr(composeEventHandlers(nn, se)),
        onDragOver: Sr(composeEventHandlers(on, nr)),
        onDragLeave: Sr(composeEventHandlers(en, ce)),
        onDrop: Sr(composeEventHandlers(zr, ur)),
        role: typeof Er == "string" && Er !== "" ? Er : "presentation"
      }, xr, O), !a && !C ? {
        tabIndex: 0
      } : {}), Jr);
    };
  }, [O, _r, yr, ne, pe, se, nr, ce, ur, C, S, a]), fr = useCallback(function(wr) {
    wr.stopPropagation();
  }, []), mr = useMemo(function() {
    return function() {
      var wr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Nr = wr.refKey, xr = Nr === void 0 ? "ref" : Nr, Er = wr.onChange, Ir = wr.onClick, Rr = _objectWithoutProperties(wr, _excluded4), Yr = _defineProperty({
        accept: T,
        multiple: l,
        type: "file",
        style: {
          display: "none"
        },
        onChange: hr(composeEventHandlers(Er, ur)),
        onClick: hr(composeEventHandlers(Ir, fr)),
        tabIndex: -1
      }, xr, G);
      return _objectSpread(_objectSpread({}, Yr), Rr);
    };
  }, [G, n, l, ur, a]);
  return _objectSpread(_objectSpread({}, B), {}, {
    isFocused: V && !a,
    getRootProps: cr,
    getInputProps: mr,
    rootRef: O,
    inputRef: G,
    open: hr(ir)
  });
}
function reducer(t, r) {
  switch (r.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, t), {}, {
        isFocused: !0
      });
    case "blur":
      return _objectSpread(_objectSpread({}, t), {}, {
        isFocused: !1
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, t), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, t), {}, {
        isDragActive: r.isDragActive,
        isDragAccept: r.isDragAccept,
        isDragReject: r.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, t), {}, {
        acceptedFiles: r.acceptedFiles,
        fileRejections: r.fileRejections
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return t;
  }
}
function noop() {
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let t = 0; t < 256; ++t)
  byteToHex.push((t + 256).toString(16).slice(1));
function unsafeStringify(t, r = 0) {
  return byteToHex[t[r + 0]] + byteToHex[t[r + 1]] + byteToHex[t[r + 2]] + byteToHex[t[r + 3]] + "-" + byteToHex[t[r + 4]] + byteToHex[t[r + 5]] + "-" + byteToHex[t[r + 6]] + byteToHex[t[r + 7]] + "-" + byteToHex[t[r + 8]] + byteToHex[t[r + 9]] + "-" + byteToHex[t[r + 10]] + byteToHex[t[r + 11]] + byteToHex[t[r + 12]] + byteToHex[t[r + 13]] + byteToHex[t[r + 14]] + byteToHex[t[r + 15]];
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(t, r, n) {
  if (native.randomUUID && !r && !t)
    return native.randomUUID();
  t = t || {};
  const a = t.random || (t.rng || rng)();
  if (a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, r) {
    n = n || 0;
    for (let s = 0; s < 16; ++s)
      r[n + s] = a[s];
    return r;
  }
  return unsafeStringify(a);
}
const isMobile = () => {
  const t = navigator.userAgent || navigator.vendor, r = /android/i.test(t), n = matchMedia(
    `screen and (max-width: ${piccoloTheme.reference.breakpoints.MOBILE_WIDTH})`
  );
  return r || n.matches;
}, progressCircle = components$1.utils.progress_circle, ProgressBarCircle = ({
  filled: t = 0,
  baseColor: r = progressCircle.fds_c_circle_color_unfilled,
  filledColor: n = progressCircle.fds_c_circle_color_filled
}) => {
  const a = 41 * ((100 - t) / 100);
  return /* @__PURE__ */ jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "rotate(-90deg)"
    },
    children: [/* @__PURE__ */ jsx$1("circle", {
      id: "base",
      cx: "8",
      cy: "8",
      r: "6.5",
      fill: "transparent",
      stroke: r,
      strokeWidth: "3"
    }), /* @__PURE__ */ jsx$1("circle", {
      id: "base",
      cx: "8",
      cy: "8",
      r: "6.5",
      fill: "transparent",
      stroke: n,
      strokeDasharray: "41",
      strokeDashoffset: a,
      strokeWidth: "3"
    })]
  });
}, RichRow$1 = styled(FlexContainer$1)`
  width: 100%;
`, Container$7 = styled(FlexContainer$1)`
  gap: ${({ theme: { components: t }, $gap: r }) => t.cells[`fds_c_tableviewcell_gap_${r}`]};
`, RichRow = ({
  gap: t = Gap.S,
  startText: r,
  startIcon: n,
  endText: a,
  progress: s,
  endIcons: o
}) => /* @__PURE__ */ jsxs(RichRow$1, {
  justify: "space-between",
  align: "center",
  children: [/* @__PURE__ */ jsxs(Container$7, {
    align: "center",
    $gap: t,
    children: [n && n, r]
  }), (a || o || s !== void 0 && s > 0) && /* @__PURE__ */ jsxs(Container$7, {
    align: "center",
    $gap: Gap.S,
    children: [a && a, s !== void 0 && s > 0 && /* @__PURE__ */ jsx$1(ProgressBarCircle, {
      filled: s
    }), o && o.map((c, l) => /* @__PURE__ */ jsx$1(FlexContainer$1, {
      children: c
    }, `icon_${l + 1}`))]
  })]
}), DropZone = styled.div`
  width: 100%;
`, ContainerStyle = {
  default: css$3`
    border: 1px dashed ${({ theme: { system: t } }) => t.border.fds_sys_color_border_primary};
    background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_primary};
  `,
  success: css$3`
    border: 1px solid ${({ theme: { system: t } }) => t.border.fds_sys_color_border_success};
    background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_success};
  `,
  error: css$3`
    border: 1px solid ${({ theme: { system: t } }) => t.border.fds_sys_color_border_error};
    background: ${({ theme: { system: t } }) => t.background.fds_sys_color_background_error};
  `
}, ContainerDropZone = styled(FlexContainer$1)`
  height: ${({ theme: { reference: t } }) => t.dimension_112};
  padding: ${({ theme: { components: t } }) => t.inputs.fds_c_input_uploader_padding};
  gap: ${({ theme: { components: t } }) => t.inputs.fds_c_input_uploader_gap};
  background-color: ${({ theme: { components: t } }) => t.inputs.fds_c_input_uploader_background};
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_L};
  border-width: ${({ theme: { system: t } }) => t.fds_sys_borderwidth_S};

  user-select: none;

  ${({ $status: t }) => ContainerStyle[t]}

  @media screen and (max-width: ${CenteredWidths.S}) {
    height: ${({ theme: { reference: t } }) => t.dimension_80};
    > svg {
      display: none;
    }
    > p {
      max-width: 55%;
    }
  }
`, DivIcon = styled.div`
  cursor: pointer;
  display: flex;
`, Text = styled(Text$3)`
  max-width: ${({ theme: { reference: t } }) => t.dimension_240};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;

  @media screen and (max-width: ${CenteredWidths.S}) {
    max-width: ${({ theme: { sizing: t } }) => t.fds_size_160};
  }
`, Cell = styled(Cell$1)`
  width: 100%;
`;
styled(RichRow)`
  button > div {
    background-color: red;
  }
`;
var StatusUploader = /* @__PURE__ */ ((t) => (t.default = "default", t.error = "error", t.success = "success", t))(StatusUploader || {});
const UPLOADER_STATUS = {
  [StatusUploader.default]: {
    icon: "IconUpload",
    iconColor: "idle",
    label: "Arrastra aquí el documento o selecciona el archivo",
    labelMobile: "Selecciona el archivo",
    labelColor: "grey"
  },
  [StatusUploader.success]: {
    icon: "IconUploadDrop",
    iconColor: "active",
    label: "Suelta aquí el documento",
    labelMobile: "Suelta aquí el documento",
    labelColor: "grass_700"
  },
  [StatusUploader.error]: {
    icon: "IconUpload",
    iconColor: "error",
    label: "Arrastra aquí el documento o selecciona el archivo",
    labelMobile: "Selecciona el archivo",
    labelColor: "danger_strong",
    color: "danger_strong"
  }
}, FILE_STATUS = {
  success: {
    label: "",
    color: "grey"
  },
  error: {
    label: "Error en la subida",
    color: "danger_strong"
  },
  loading: {
    label: "En proceso",
    color: "success_strong"
  }
}, renderStartText = (t) => {
  const {
    isLoading: r,
    isError: n,
    file: a
  } = t;
  let {
    color: s
  } = FILE_STATUS.loading;
  return r && (s = FILE_STATUS.success.color), n && (s = FILE_STATUS.error.color), /* @__PURE__ */ jsx$1(Text, {
    type: "paragraphs",
    color: s,
    size: "S_L_S",
    children: a.name
  });
}, renderEndText = (t) => {
  const {
    isLoading: r,
    isError: n
  } = t;
  let a = "success";
  return r && (a = "loading"), n && (a = "error"), /* @__PURE__ */ jsx$1(Text$3, {
    type: "paragraphs",
    size: "XS_L_S",
    color: FILE_STATUS[a].color,
    children: FILE_STATUS[a].label
  });
}, renderStartIcon = (t) => {
  if (t.isError)
    return /* @__PURE__ */ jsx$1(Icon$4, {
      color: "default",
      icon: "IconDangerAttentionSolidS",
      height: 16,
      width: 16
    });
  if (t.isUploaded)
    return /* @__PURE__ */ jsx$1(Icon$4, {
      color: "default",
      icon: "IconTickSolidSGreen",
      height: 16,
      width: 16
    });
}, renderEndIcons = (t, r) => [/* @__PURE__ */ jsx$1(DivIcon, {
  onClick: () => r(t),
  children: /* @__PURE__ */ jsx$1(Icon$4, {
    color: "default",
    icon: "IconCrossDangerM",
    height: 16,
    width: 16
  })
})], Uploader = ({
  onChange: t,
  onDelete: r,
  value: n = [],
  acceptedFormats: a,
  maxSize: s = 2,
  labelFiles: o = "",
  maxFiles: c,
  validations: l,
  hasError: d,
  ...h
}) => {
  const u = (l == null ? void 0 : l.maxFiles) ?? c, p = (l == null ? void 0 : l.maxSize) ?? s, m = (l == null ? void 0 : l.acceptedFormats) ?? a, [g, v] = useState({
    format: [],
    size: [],
    count: [],
    hasErrors: !1
  }), y = isMobile();
  useEffect(() => {
    g.hasErrors && v({
      format: [],
      size: [],
      count: [],
      hasErrors: !1
    });
  }, [n.length]);
  const x = (T) => {
    r == null || r(T);
  }, _ = (T) => {
    const R = T.reduce((F, z) => (z.errors.forEach((O) => {
      O.code === ErrorCode.FileInvalidType && (F.format.push(z.file.name), F.hasErrors = !0), O.code === ErrorCode.FileTooLarge && (F.size.push(z.file.name), F.hasErrors = !0), O.code === ErrorCode.TooManyFiles && (F.count.push(z.file.name), F.hasErrors = !0);
    }), F), {
      format: [],
      size: [],
      count: [],
      hasErrors: !1
    });
    v(R);
  }, $ = (T) => {
    const R = [];
    return T.format.length > 0 && R.push(`Los ficheros '${T.format.join(", ")}' no tienen un formato válido.`), T.size.length > 0 && R.push(`Los ficheros '${T.size.join(", ")}' tienen un tamaño superior a ${p}MB.`), T.count.length > 0 && R.push(`Has superado el número máximo de ficheros permitidos (${u}).`), d && R.push("El campo es obligatorio"), R;
  }, b = useCallback((T, R) => {
    if (R.length > 0 && _(R), R.length === 0 && g.hasErrors && v({
      format: [],
      size: [],
      count: [],
      hasErrors: !1
    }), T.length > 0) {
      if (u && T.length + n.length > u) {
        v((F) => ({
          ...F,
          count: [...F.count, ...T.map((z) => z.name)],
          hasErrors: !0
        }));
        return;
      }
      t == null || t([...n, ...T.map((F) => ({
        file: F,
        isError: !1,
        isLoading: !1,
        isUploaded: !1,
        internalId: v4()
      }))]);
    }
  }, [n, u]), {
    getRootProps: M,
    getInputProps: C,
    isDragActive: S,
    isDragReject: A,
    open: D
  } = useDropzone({
    onDrop: b,
    minSize: 0,
    maxSize: p * 1048576,
    accept: m,
    noClick: !0,
    maxFiles: u && u - n.length
  }), N = S ? A ? StatusUploader.error : StatusUploader.success : g.hasErrors || d ? StatusUploader.error : StatusUploader.default;
  return /* @__PURE__ */ jsx$1(InputLayout, {
    ...h,
    children: /* @__PURE__ */ jsxs(FlexContainer$1, {
      fullWidth: !0,
      gap: "dimension_12",
      direction: "column",
      children: [/* @__PURE__ */ jsxs(DropZone, {
        ...M(),
        onClick: D,
        children: [/* @__PURE__ */ jsx$1("input", {
          ...C()
        }), /* @__PURE__ */ jsxs(ContainerDropZone, {
          $status: N,
          align: "center",
          justify: "center",
          children: [/* @__PURE__ */ jsx$1(Icon$4, {
            icon: UPLOADER_STATUS[N].icon,
            color: UPLOADER_STATUS[N].iconColor
          }), /* @__PURE__ */ jsx$1(Text$3, {
            color: UPLOADER_STATUS[N].labelColor,
            type: "paragraphs",
            size: "S_M_L",
            children: y ? UPLOADER_STATUS[N].labelMobile : UPLOADER_STATUS[N].label
          })]
        })]
      }), (g.hasErrors || d) && $(g).map((T) => /* @__PURE__ */ jsx$1(InputInfo, {
        message: T,
        hasError: !0
      }, T)), n.length > 0 && /* @__PURE__ */ jsxs(Fragment, {
        children: [o && /* @__PURE__ */ jsx$1(Text$3, {
          type: "paragraphs",
          color: "dark",
          size: "S_M_S",
          mt: "fds_size_16",
          mb: "fds_size_08",
          children: o
        }), n.map((T) => /* @__PURE__ */ jsx$1(Cell, {
          size: "M",
          hasArrow: !1,
          isInteractive: !1,
          children: /* @__PURE__ */ jsx$1(RichRow, {
            startIcon: renderStartIcon(T),
            startText: renderStartText(T),
            endText: renderEndText(T),
            endIcons: renderEndIcons(T, x),
            ...T.isLoading && !T.isError && {
              progress: 75
            }
          })
        }, T.internalId))]
      })]
    })
  });
}, componentsMap = {
  [InputFormTypes.AMOUNT_EURO]: {
    Component: Currency$1,
    props: { type: InputFormTypes.AMOUNT_EURO, formatType: formatOption.EURO }
  },
  [InputFormTypes.AMOUNT_DOLLAR_MXN]: {
    Component: Currency$1,
    props: { type: InputFormTypes.AMOUNT_EURO, formatType: formatOption.PESOS }
  },
  [InputFormTypes.PERCENTAGE]: { Component: Percentage$1 },
  [InputFormTypes.CADASTER]: {
    Component: Text$2,
    props: { type: InputFormTypes.TEXT, subType: InputFormTypes.CADASTER }
  },
  [InputFormTypes.CHECKBOX]: { Component: CheckBox },
  [InputFormTypes.CIF]: {
    Component: Text$2,
    validations: { cif: !0 },
    props: { type: InputFormTypes.TEXT, subType: InputFormTypes.CIF }
  },
  [InputFormTypes.DATE]: { Component: InputDate },
  [InputFormTypes.DECIMAL]: { Component: Decimal$1 },
  [InputFormTypes.DROPDOWN]: { Component: Select$1 },
  [InputFormTypes.EMAIL]: { Component: Text$2 },
  [InputFormTypes.IBAN]: { Component: Iban$1 },
  [InputFormTypes.INTEGER]: { Component: Text$2 },
  [InputFormTypes.NIE]: {
    Component: Text$2,
    validations: { nie: !0 },
    props: { type: InputFormTypes.TEXT, subType: InputFormTypes.NIE }
  },
  [InputFormTypes.NIF_NIE_CIF]: {
    Component: Text$2,
    validations: { nif_nie_cif: !0 },
    props: { type: InputFormTypes.TEXT, subType: InputFormTypes.NIF_NIE_CIF }
  },
  [InputFormTypes.NIF_NIE]: {
    Component: Text$2,
    validations: { nif_nie: !0 },
    props: { type: InputFormTypes.TEXT, subType: InputFormTypes.NIF_NIE }
  },
  [InputFormTypes.NIF]: {
    Component: Text$2,
    validations: { nif: !0 },
    props: { type: InputFormTypes.TEXT, subType: InputFormTypes.NIF }
  },
  [InputFormTypes.PASSWORD]: {
    Component: Password,
    props: { type: InputFormTypes.PASSWORD }
  },
  [InputFormTypes.RADIO]: { Component: RadioExtended$1 },
  [InputFormTypes.RFC_FISICA]: {
    Component: Text$2,
    validations: { required: !0 },
    props: { type: InputFormTypes.TEXT, validationType: "Rfc" }
  },
  [InputFormTypes.RFC_MORAL]: {
    Component: Text$2,
    validations: { required: !0 },
    props: { type: InputFormTypes.TEXT, validationType: "Rfc" }
  },
  [InputFormTypes.RFC_FISICAL_MORAL]: {
    Component: Text$2,
    validations: { required: !0 },
    props: { type: InputFormTypes.TEXT, validationType: "Rfc" }
  },
  [InputFormTypes.TEXT]: { Component: Text$2, props: { subType: InputFormTypes.TEXT } },
  [InputFormTypes.RADIOCARD]: { Component: RadioCard$1 },
  [InputFormTypes.CHECKBOXCARD]: { Component: CheckBoxCard },
  [InputFormTypes.BANNER_WARNING]: {
    Component: Banner,
    props: { type: InputFormTypes.BANNER_WARNING, mode: "warning", layout: "embed" }
  },
  [InputFormTypes.BANNER_ERROR]: {
    Component: Banner,
    props: { type: InputFormTypes.BANNER_ERROR, mode: "error", layout: "embed" }
  },
  [InputFormTypes.BANNER_ALERT]: {
    Component: Banner,
    props: { type: InputFormTypes.BANNER_ALERT, layout: "embed" }
  },
  [InputFormTypes.BANNER_SUCCESS]: {
    Component: Banner,
    props: { type: InputFormTypes.BANNER_SUCCESS, mode: "success", layout: "embed" }
  },
  [InputFormTypes.BANNER_INFO]: {
    Component: Banner,
    props: { type: InputFormTypes.BANNER_INFO, layout: "embed" }
  },
  [InputFormTypes.WIZARD]: { Component: Wizard },
  [InputFormTypes.YES_NO_RADIO]: { Component: YesNoRadioGroup },
  [InputFormTypes.FILE]: { Component: Uploader },
  [InputFormTypes.TEXT_AREA]: { Component: TextArea$1 }
}, InputBasic = ({
  inputForm: t,
  value: r,
  hasWarning: n,
  onChange: a,
  errorMsg: s,
  ...o
}) => {
  var $;
  const [c, l] = useState(), [d, h] = useState(!1), [u, p] = useState(""), m = (b, M) => {
    const C = {
      ...model.TYPES,
      ...validations
    };
    if (M && C[M])
      return C[M];
    const S = Object.keys(C).find((A) => A.toLowerCase().startsWith(b.toLowerCase()));
    return S ? C[S] : null;
  }, g = (b) => {
    const M = validationParsers[t.type];
    return M ? M(b) : b;
  }, v = async (b) => {
    var S;
    let M = !0;
    const C = g(b);
    if ((S = t == null ? void 0 : t.validations) != null && S.required) {
      const A = m(t.type, t == null ? void 0 : t.validationType);
      if (M = A == null ? void 0 : A.validate(C, t.validations), !M) {
        const D = await services.i18n.translate(A == null ? void 0 : A.message(C, t == null ? void 0 : t.validations, !1), {
          ...t == null ? void 0 : t.validations
        });
        p(s || D);
      }
      h(!M);
    }
    a == null || a(C, M);
  }, y = (b) => {
    const M = g(b);
    l(M.toString());
  }, {
    Component: x,
    props: _ = {}
  } = componentsMap[t.type];
  return useEffect(() => {
    l(r);
  }, [r]), useEffect(() => {
    let b;
    return (r || c) && (b = setTimeout(() => v(c), 800)), () => clearTimeout(b);
  }, [c]), /* @__PURE__ */ jsx$1(x, {
    ..._,
    ...t,
    hasError: d,
    errorMsg: u,
    value: c,
    $hasError: d,
    $hasWarning: n,
    onChange: (b) => y(b),
    isMandatory: ($ = t == null ? void 0 : t.validations) == null ? void 0 : $.required,
    ...o
  });
}, InputFile = ({
  inputForm: t,
  value: r,
  hasWarning: n,
  onChange: a,
  ...s
}) => {
  var g;
  const [o, c] = useState(), [l, d] = useState(!1), h = async (v) => {
    var x;
    let y = !0;
    (x = t == null ? void 0 : t.validations) != null && x.required && Array.isArray(v) && (y = v.length > 0, d(!y)), a == null || a(v, y);
  }, u = (v) => {
    c(v);
  }, {
    Component: p,
    props: m = {}
  } = componentsMap[t.type];
  return useEffect(() => {
    c(r);
  }, [r]), useEffect(() => {
    let v;
    return (r || o || r != null && r.length) && (v = setTimeout(() => h(o), 800)), () => clearTimeout(v);
  }, [o]), /* @__PURE__ */ jsx$1(p, {
    ...m,
    ...t,
    hasError: l,
    value: o,
    $hasError: l,
    $hasWarning: n,
    onChange: (v) => u(v),
    isMandatory: (g = t == null ? void 0 : t.validations) == null ? void 0 : g.required,
    ...s
  });
}, InputByType = {
  [InputFormTypes.FILE]: InputFile
}, InputForm = ({
  inputForm: t,
  ...r
}) => {
  const n = InputByType[t.type] || InputBasic;
  return /* @__PURE__ */ jsx$1(n, {
    inputForm: t,
    ...r
  });
}, Inputs = {
  Text: Text$2,
  Card,
  CheckBoxWrapper,
  CheckBox,
  Copied: Copied$1,
  Currency: Currency$1,
  Date: InputDate,
  Decimal: Decimal$1,
  Iban: Iban$1,
  InputForm,
  Password,
  Percentage: Percentage$1,
  Phone,
  Radio,
  RadioExtended: RadioExtended$1,
  Select: Select$1,
  Switcher,
  TextArea: TextArea$1,
  Uploader,
  RadioCard: RadioCard$1,
  CheckBoxCard,
  YesNoRadioGroup,
  Wizard
}, createRootElement = (t) => {
  const r = document.createElement("div");
  return r.setAttribute("id", t), r;
}, addRootElement = (t) => {
  var n, a;
  const r = (a = (n = document == null ? void 0 : document.body) == null ? void 0 : n.lastElementChild) == null ? void 0 : a.nextElementSibling;
  document.body.insertBefore(t, r);
}, usePortal = (t, r) => {
  const n = useRef();
  return useEffect(
    function() {
      const o = document.getElementById(t), c = o || createRootElement(t);
      return o || addRootElement(c), o !== n.current && (c == null || c.append(n.current)), r && r.split(" ").forEach((d) => {
        c == null || c.classList.add(d);
      }), function() {
        var d;
        (d = n == null ? void 0 : n.current) == null || d.remove(), Object.values(SectionsRootLayout).includes(t) ? o && r && r.split(" ").forEach((u) => {
          c == null || c.classList.remove(u);
        }) : c != null && c.childElementCount || c == null || c.remove();
      };
    },
    [t, r]
  ), (() => {
    if (!n.current) {
      const s = document.getElementById(`${t}-slot`);
      s && s.remove(), n.current = document.createElement("slot"), n.current.id = `${t}-slot`;
    }
    return n.current;
  })();
}, Portal = ({
  id: t = "root",
  children: r,
  className: n
}) => {
  const a = usePortal(t, n);
  return a ? createPortal(r, a) : null;
}, Bar = styled.div`
  height: ${({ theme: { components: t } }) => t.utils.progress_line.fds_c_progressbar_height};
  width: 100%;
  background-color: ${({ theme: { components: t }, baseColor: r }) => r || t.utils.progress_line.fds_c_progress_color_tofill};
  border-radius: 5px;
  overflow: hidden;
`, Filled = styled.div`
  height: 100%;
  width: ${({ filled: t }) => t}%;
  background-color: ${({ theme: { components: t }, filledColor: r }) => r || t.utils.progress_line.fds_c_progress_color_filled};
  transition: width 0.5s ease-in-out;
`, ProgressBar = ({
  filled: t = 0,
  filledColor: r = "",
  baseColor: n = ""
}) => /* @__PURE__ */ jsx$1(FlexContainer$1, {
  children: /* @__PURE__ */ jsx$1(Bar, {
    baseColor: n,
    children: /* @__PURE__ */ jsx$1(Filled, {
      filled: t,
      filledColor: r
    })
  })
}), SeparatorText = styled(Text$3)`
  padding: ${({ theme: { spacing: t } }) => `0 ${t.spacing_32}`};
`, Container$6 = styled.div`
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $direction: t }) => t === LayoutDirection.VERTICAL ? css$3`
          flex-direction: column;
          height: 100%;
        ` : css$3`
          width: 100%;
        `}

  ${MarginsStyles}
  ::before,
  ::after {
    content: '';
    display: flex;
    ${({ $direction: t }) => t === LayoutDirection.HORIZONTAL ? css$3`
            border-top: 1px solid
              ${({ theme: { system: r } }) => r.border.fds_sys_color_border_primary};
          ` : css$3`
            border-left: 1px solid
              ${({ theme: { system: r } }) => r.border.fds_sys_color_border_primary};
          `}

    border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_XS};
    flex: 1 1 auto;
  }
`, Separator$1 = ({
  content: t,
  direction: r = LayoutDirection.HORIZONTAL,
  ...n
}) => /* @__PURE__ */ jsx$1(Container$6, {
  ...n,
  $direction: r,
  children: t && /* @__PURE__ */ jsx$1(SeparatorText, {
    tag: "span",
    type: "paragraphs",
    size: "S_L_L",
    color: "dark",
    children: t
  })
}), Sidebar$1 = styled(FlexContainer$1)`
  padding: ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
  width: 100%;
  gap: ${({ theme: { system: t } }) => t.fds_sys_spacing_S};
`, Sidebar = ({
  children: t
}) => /* @__PURE__ */ jsx$1(Sidebar$1, {
  direction: "column",
  children: t
});
var SpinnerSizes = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t.L = "L", t))(SpinnerSizes || {}), SpinnerModes = /* @__PURE__ */ ((t) => (t.primary = "primary", t.secondary = "secondary", t))(SpinnerModes || {});
const SpinnerColorByMode = {
  primary: components$1.loaders.fds_c_spinner_color_primary,
  secondary: components$1.loaders.fds_c_spinner_color_secondary
}, spin = keyframes$1`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`, spinnerSizeStyles = {
  [SpinnerSizes.S]: css$3`
    svg {
      width: ${({ theme: { system: t } }) => t.fds_sys_sizing_XS};
      height: ${({ theme: { system: t } }) => t.fds_sys_sizing_XS};
    }
  `,
  [SpinnerSizes.M]: css$3`
    svg {
      width: ${({ theme: { system: t } }) => t.fds_sys_sizing_M};
      height: ${({ theme: { system: t } }) => t.fds_sys_sizing_M};
    }
  `,
  [SpinnerSizes.L]: css$3`
    svg {
      width: ${({ theme: { system: t } }) => t.fds_sys_sizing_XXL};
      height: ${({ theme: { system: t } }) => t.fds_sys_sizing_XXL};
    }
  `
}, Container$5 = styled(FlexContainer$1)`
  height: 100%;
`, Spinner$1 = styled.div`
  ${({ size: t }) => spinnerSizeStyles[t]}
  svg {
    animation: ${spin} 0.8s linear infinite;
    transform-origin: center;
  }
`, Spinner = ({
  size: t,
  align: r,
  justify: n,
  mode: a = "primary",
  ...s
}) => /* @__PURE__ */ jsx$1(Container$5, {
  align: r,
  justify: n,
  ...s,
  children: /* @__PURE__ */ jsx$1(Spinner$1, {
    size: t,
    children: /* @__PURE__ */ jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      height: "64",
      width: "64",
      viewBox: "0 0 600 600",
      children: [/* @__PURE__ */ jsxs("defs", {
        children: [/* @__PURE__ */ jsxs("linearGradient", {
          id: "Gradient1",
          gradientTransform: "rotate(90)",
          children: [/* @__PURE__ */ jsx$1("stop", {
            offset: "0%",
            stopColor: SpinnerColorByMode[a]
          }), /* @__PURE__ */ jsx$1("stop", {
            offset: "100%",
            stopColor: SpinnerColorByMode[a]
          })]
        }), /* @__PURE__ */ jsxs("linearGradient", {
          id: "Gradient2",
          gradientTransform: "rotate(90)",
          children: [/* @__PURE__ */ jsx$1("stop", {
            offset: "20%",
            stopColor: "transparent"
          }), /* @__PURE__ */ jsx$1("stop", {
            offset: "80%",
            stopColor: SpinnerColorByMode[a]
          })]
        }), /* @__PURE__ */ jsx$1("pattern", {
          id: "Pattern",
          x: "0",
          y: "0",
          width: "900",
          height: "900",
          patternUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ jsxs("g", {
            transform: "rotate(0, 300, 300)",
            children: [/* @__PURE__ */ jsx$1("rect", {
              shapeRendering: "crispEdges",
              x: "0",
              y: "0",
              width: "300",
              height: "600",
              fill: "url(#Gradient1)"
            }), /* @__PURE__ */ jsx$1("rect", {
              shapeRendering: "crispEdges",
              x: "300",
              y: "0",
              width: "300",
              height: "600",
              fill: "url(#Gradient2)"
            })]
          })
        })]
      }), /* @__PURE__ */ jsx$1("path", {
        id: "arc5",
        style: {
          stroke: "url(#Pattern)"
        },
        fill: "transparent",
        strokeWidth: "60",
        d: "M 364 58 A 250 250 0 1 1 235 58"
      })]
    })
  })
});
var StackDirection = /* @__PURE__ */ ((t) => (t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t))(StackDirection || {});
const Container$4 = styled(FlexContainer$1).attrs({
  direction: "column"
})`
  ${MarginsStyles};
`, StackItem = styled(FlexContainer$1).attrs(({ $direction: t }) => ({
  direction: t === StackDirection.VERTICAL ? "column" : "row"
}))`
  gap: ${({ theme: t }) => t.system.fds_sys_spacing_XXS};
  padding: ${({ theme: t }) => `${t.system.fds_sys_spacing_XS} 0`};
  border-bottom: ${({ $separator: t, theme: r }) => t && `${r.system.fds_sys_borderwidth_S} solid ${r.system.border.fds_sys_color_border_primary}`};
`, StackItemLabel = styled(Text$3)`
  flex: 1;
`;
function Stack({
  values: t,
  direction: r,
  separator: n = !1,
  ...a
}) {
  const s = typeof t == "object" ? Object.entries(t) : [];
  return /* @__PURE__ */ jsx$1(Container$4, {
    ...a,
    children: s.map(([o, c]) => /* @__PURE__ */ jsxs(StackItem, {
      $direction: r,
      $separator: n,
      children: [/* @__PURE__ */ jsx$1(StackItemLabel, {
        type: "paragraphs",
        color: "dark",
        size: "XS_S_S",
        children: o
      }), /* @__PURE__ */ jsx$1(StackItemLabel, {
        type: "paragraphs",
        color: "dark",
        size: "XS_S_S",
        children: c
      })]
    }, o))
  });
}
const SubCell$1 = styled.button`
  all: unset;
  display: block;
  width: ${({ theme: { components: t } }) => `calc(100% - ${t.cells.fds_c_tableviewcell_spacing_S} - ${t.cells.fds_c_tableviewcell_spacing_S})`};
  cursor: pointer;
  background: ${({ theme: { components: t }, isSelected: r }) => r && t.cells.fds_c_subcell_background_color_selected};
  padding: ${({ theme: { components: t } }) => t.cells.fds_c_tableviewcell_spacing_S};
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_M};
  transition: transform 0.5s cubic-bezier(0.8, 0, 0.2, 1.5),
    background-color 0.5s cubic-bezier(0.8, 0, 0.2, 1.5);

  &:hover:enabled {
    background: ${({ theme: { components: t } }) => t.cells.fds_c_subcell_subitem_background_color_hover};
    transform: ${({ theme: { components: t } }) => `translateX(${t.cells.fds_c_cells_subitem_hover_translate})`};
    transition: transform 0.25s cubic-bezier(0, 0, 0.2, 1),
      background-color 0.25s cubic-bezier(0, 0, 0.2, 1);
  }

  &:disabled {
    opacity: ${({ theme: { system: t } }) => t.fds_sys_disabled_opacity_S};
    cursor: not-allowed;
  }
`, Container$3 = styled(FlexContainer$1)`
  gap: ${({ theme: { components: t } }) => t.cells.fds_c_tableviewcell_gap_S};
`, SubCell = ({
  isDisabled: t = !1,
  isSelected: r = !1,
  onClick: n,
  children: a,
  ...s
}) => /* @__PURE__ */ jsx$1(SubCell$1, {
  type: "button",
  isSelected: r,
  disabled: t,
  onClick: n,
  ...s,
  children: /* @__PURE__ */ jsxs(Container$3, {
    align: "center",
    justify: "space-between",
    children: [a, /* @__PURE__ */ jsx$1(Icon$4, {
      icon: "IconArrowRightS",
      color: "default",
      height: 16,
      width: 16
    })]
  })
});
var TabsColors = /* @__PURE__ */ ((t) => (t.light = "light", t.default = "default", t))(TabsColors || {}), TabsSizes = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t))(TabsSizes || {});
const tabsColorsStyle = {
  [TabsColors.default]: css$3`
    background: ${({ theme: { components: t } }) => t.tabs.fds_c_tabs_color_background_default};
  `,
  [TabsColors.light]: css$3`
    background: ${({ theme: { components: t } }) => t.tabs.fds_c_tabs_color_background_light};
  `
}, tabSizesStyle = {
  [TabsSizes.S]: css$3`
    padding: ${({ theme: { components: t } }) => t.tabs.fds_c_tabs_spacing_S};
  `,
  [TabsSizes.M]: css$3`
    padding: ${({ theme: { components: t } }) => t.tabs.fds_c_tabs_spacing_M};
  `
}, tabSizesLabelStyle = {
  [TabsSizes.S]: "XS_L_S",
  [TabsSizes.M]: "S_L_S"
}, tabTextColor = "dark", Container$2 = styled(FlexContainer$1)`
  ${({ color: t }) => t && tabsColorsStyle[t]};
  border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_round};
  ${MarginsStyles};
`, Label = styled(Text$3).attrs(({ $size: t }) => ({
  type: TextTypes.paragraphs,
  color: tabTextColor,
  size: tabSizesLabelStyle[t]
}))``, Tab = styled(FlexContainer$1).attrs({
  align: "center",
  justify: "center"
})`
  ${({ $selected: t }) => t && css$3`
      background-color: ${({ theme: { components: r } }) => r.tabs.fds_c_tabs_color_background_dark};

      ${Label} {
        color: ${({ theme: { colors: r } }) => r.white};
      }
    `}
  ${({ $size: t }) => tabSizesStyle[t]};
  border-radius: ${({ theme: { sizing: t } }) => t.fds_borderradius_round};
  width: 100%;
  cursor: pointer;
`, Tabs = ({
  tabs: t,
  color: r = TabsColors.default,
  size: n = TabsSizes.M,
  selectedTab: a,
  onTabClick: s,
  ...o
}) => /* @__PURE__ */ jsx$1(Container$2, {
  color: r,
  ...o,
  children: t.map((c) => /* @__PURE__ */ jsx$1(Tab, {
    $size: n,
    $selected: a === c.id,
    onClick: () => s == null ? void 0 : s(c.id),
    children: /* @__PURE__ */ jsx$1(Label, {
      $size: n,
      children: c.label
    })
  }, c.id))
});
var ModalTypes = /* @__PURE__ */ ((t) => (t.centered = "centered", t.bottom = "bottom", t.contentDriven = "contentDriven", t))(ModalTypes || {}), ModalStyle = /* @__PURE__ */ ((t) => (t.default = "default", t.error = "error", t.warning = "warning", t.success = "success", t))(ModalStyle || {});
const ModalStyles = {
  default: {
    primaryButton: "primary",
    secondaryButton: "secondary",
    subtitle: "cold"
  },
  error: {
    primaryButton: "primary",
    secondaryButton: "error_light",
    subtitle: "danger_strong"
  },
  warning: {
    primaryButton: "primary",
    secondaryButton: "warning_light",
    subtitle: "warning_strong"
  },
  success: {
    primaryButton: "primary",
    secondaryButton: "success_light",
    subtitle: "success_strong"
  }
}, ModalBackground = styled.div`
  @keyframes modal_entrance_bg {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100dvw;

  background-color: ${({ theme: t }) => t.reference.functional.darken_600};
  backdrop-filter: blur(2px);
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: ${({ theme: t }) => t.system.fds_sys_spacing_S};
  @media screen and (max-width: ${({ theme: { reference: t } }) => t.breakpoints.MOBILE_WIDTH}) {
    padding: ${({ theme: t }) => t.system.fds_sys_spacing_XS};
  }
  animation: modal_entrance_bg 0.25s linear;
`, Section = styled.section`
  @keyframes modal_entrance_content {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    25% {
      opacity: 0;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
  max-height: 100%;
  max-width: 100%;
  animation: modal_entrance_content 1s cubic-bezier(0.8, 0, 0.2, 1.4);
`, modalTypes = {
  [ModalTypes.centered]: css$3`
    > button {
      position: absolute;
      z-index: 1001;
      top: 0;
      right: 0;
    }
  `,
  [ModalTypes.bottom]: css$3`
    position: fixed;
    bottom: 0;
    left: 0;
    max-width: 100dvw;
    width: 100%;
    max-height: 80dvh;
    box-sizing: border-box;
    border-radius: 0;
    padding-top: ${({ theme: t }) => t.system.fds_sys_spacing_M};
    border-top-right-radius: ${({ theme: t }) => t.system.fds_sys_borderradius_XL};
    border-top-left-radius: ${({ theme: t }) => t.system.fds_sys_borderradius_XL};
  `,
  [ModalTypes.contentDriven]: css$3`
    padding-top: 0;
    > button {
      position: absolute;
      z-index: 1001;
      top: 0;
      right: 0;
    }
  `
}, ModalContainer = styled(FlexContainer$1)`
  z-index: 1000;
  position: relative;
  background-color: ${({ theme: t }) => t.system.background.fds_sys_color_background_primary};
  border-radius: ${({ theme: t }) => t.system.fds_sys_borderradius_L};
  max-height: 100%;
  max-width: ${({ theme: t, maxSize: r }) => t.components.modals[`fds_c_modal_centered_minwidth_${r}`]};
  overflow-y: auto;
  overflow-x: hidden;
  ${({ mode: t }) => modalTypes[t]}
`, Content$1 = styled(FlexContainer$1)`
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 ${({ theme: t }) => t.system.fds_sys_spacing_S};
  max-height: 80dvh;
  padding-top: ${({ theme: t }) => t.system.fds_sys_spacing_M};
  > p:last-of-type {
    padding-bottom: ${({ theme: t }) => t.system.fds_sys_spacing_S};
  }
  ${({ mode: t }) => t === ModalTypes.contentDriven && { padding: 0 }};
  ${({ mode: t }) => t === ModalTypes.bottom && { paddingTop: 0 }};
`, ContentChildren = styled(FlexContainer$1)`
  box-sizing: border-box;
  padding-bottom: ${({ theme: t }) => t.system.fds_sys_spacing_S};
  ${({ mode: t }) => t === ModalTypes.contentDriven && { paddingBottom: 0 }}
`, ButtonsPanel = styled(FlexContainer$1)`
  gap: ${({ theme: t }) => t.components.buttons.fds_c_button_sticky_gap};
  box-sizing: border-box;
  padding: ${({ theme: t }) => t.system.fds_sys_spacing_S};
  padding-top: ${({ theme: t }) => t.system.fds_sys_spacing_XS};
  ${({ mode: t }) => t === ModalTypes.bottom && { width: "auto" }}
  align-items: center;
  & > label {
    justify-content: center;
  }
`, Separator = styled.div`
  width: 100%;
  border-top: ${({ theme: t }) => t.system.fds_sys_borderwidth_S} solid;
  border-color: ${({ theme: t }) => t.reference.neutral.moon_500};
`, SeparatorMobile = styled.div`
  margin-bottom: ${({ theme: t }) => t.system.fds_sys_sizing_M};
  width: ${({ theme: t }) => t.components.modals.fds_c_dragger_width};
  border-top: ${({ theme: t }) => t.components.modals.fds_c_modal_bottom_dragger_border_width}
    solid;
  border-color: ${({ theme: t }) => t.components.modals.fds_c_modal_bottom_dragger_color};
`, renderButton = (t, r, n, a) => n ? /* @__PURE__ */ jsx$1(Buttons.Tiny, {
  iconStart: t.icon,
  label: t.label,
  onClick: t.onClick || a,
  mode: r,
  disabled: t.disabled
}) : "label" in t ? /* @__PURE__ */ jsx$1(Buttons.Classic, {
  iconStart: t.icon,
  label: t.label,
  onClick: t.onClick || a,
  mode: r,
  size: "m",
  disabled: t.disabled
}) : /* @__PURE__ */ jsx$1(Buttons.Icon, {
  size: "m",
  icon: t.icon,
  onClick: t.onClick || a,
  mode: r,
  disabled: t.disabled
}), PanelButtons = ({
  modalMode: t,
  modalType: r = ModalStyle.default,
  buttonsAlign: n,
  buttonsInline: a = !1,
  secondaryButton: s,
  primaryButton: o,
  checkboxMemo: c,
  checkboxValue: l,
  onChangeCheckbox: d,
  isMobile: h,
  handleOnClose: u
}) => {
  var p, m;
  return /* @__PURE__ */ jsxs(ButtonsPanel, {
    id: "modal-nav",
    direction: t !== ModalTypes.bottom && !c && !a ? "row" : "column",
    fullWidth: !0,
    justify: n || "space-between",
    mode: t,
    children: [c && /* @__PURE__ */ jsx$1(Inputs.CheckBox, {
      onChange: (g) => d == null ? void 0 : d(g),
      value: l,
      label: c.checkboxLabel
    }), s && renderButton(s, ((p = ModalStyles == null ? void 0 : ModalStyles[r]) == null ? void 0 : p.secondaryButton) || ButtonMode.secondary, h || a, u), o && renderButton(o, ((m = ModalStyles == null ? void 0 : ModalStyles[r]) == null ? void 0 : m.primaryButton) || ButtonMode.primary, !1, u)]
  });
}, showImages = (t, r, n = "100%") => /* @__PURE__ */ jsxs(Fragment, {
  children: [t && /* @__PURE__ */ jsx$1("img", {
    src: t,
    alt: "pictogram",
    width: n
  }), r && /* @__PURE__ */ jsx$1(Icon$4, {
    icon: r,
    color: "default"
  })]
}), hasContent = (t, r, n, a, s, o) => t || r || n || a || s || o, Modal$1 = ({
  type: t = ModalStyle.default,
  icon: r,
  urlImage: n,
  maxUrlSize: a,
  title: s,
  subtitle: o,
  description: c,
  primaryButton: l,
  secondaryButton: d,
  buttonsAlign: h,
  buttonsInline: u,
  externalButton: p,
  onClose: m,
  hasClose: g = !0,
  hasCloseOverlay: v,
  mode: y = ModalTypes.centered,
  children: x,
  maxSize: _ = Sizes$1.S,
  checkboxMemo: $,
  className: b
}) => {
  const M = isMobile(), C = () => {
    m == null || m();
  }, [S, A] = useState(!1);
  useEffect(() => {
    $ != null && $.checkboxId && localStorage.getItem(`tx_modal_${$ == null ? void 0 : $.checkboxId}`) === "true" && (m == null || m());
  }, [$]), useEffect(() => {
    const R = (F) => {
      (g || v) && m && F.key === "Escape" && (m == null || m());
    };
    return document.addEventListener("keydown", R), () => {
      document.removeEventListener("keydown", R);
    };
  }, []);
  const D = (R) => {
    A(R), localStorage.setItem(`tx_modal_${$ == null ? void 0 : $.checkboxId}`, R.toString());
  }, N = !M && y === ModalTypes.bottom ? ModalTypes.centered : y;
  return /* @__PURE__ */ jsx$1(ModalBackground, {
    ...(g || v) && {
      onClick: C
    },
    className: b,
    children: /* @__PURE__ */ jsx$1(Section, {
      onClick: (R) => R.stopPropagation(),
      children: /* @__PURE__ */ jsxs(FlexContainer$1, {
        direction: "column",
        gap: "dimension_16",
        children: [/* @__PURE__ */ jsxs(ModalContainer, {
          direction: "column",
          align: "center",
          fullWidth: !0,
          mode: N,
          maxSize: _,
          children: [N === ModalTypes.bottom && /* @__PURE__ */ jsx$1(SeparatorMobile, {
            onClick: C
          }), g && /* @__PURE__ */ jsx$1(Buttons.Icon, {
            icon: "IconCrossS",
            onClick: C,
            size: "l",
            mode: "empty"
          }), hasContent(r, n, s, o, c, x) && /* @__PURE__ */ jsxs(Content$1, {
            id: "modal-info",
            direction: "column",
            align: "center",
            gap: "dimension_08",
            fullWidth: !0,
            mode: N,
            children: [(n || r) && /* @__PURE__ */ jsx$1(FlexContainer$1, {
              mb: "fds_size_16",
              children: showImages(n, r, a)
            }), s && /* @__PURE__ */ jsx$1(Text$3, {
              type: "headline",
              size: "XS_L_S",
              color: "dark",
              align: "center",
              children: s
            }), o && /* @__PURE__ */ jsx$1(Text$3, {
              type: "paragraphs",
              size: "M_L_S",
              color: ModalStyles[t].subtitle,
              align: "center",
              children: o
            }), c && /* @__PURE__ */ jsx$1(Text$3, {
              type: "paragraphs",
              size: "XS_M_S",
              color: "grey",
              align: "center",
              children: c
            }), x && /* @__PURE__ */ jsx$1(ContentChildren, {
              direction: "column",
              fullWidth: !0,
              mode: N,
              children: x
            })]
          }), N !== ModalTypes.centered && /* @__PURE__ */ jsx$1(Separator, {}), ($ || l || d) && /* @__PURE__ */ jsx$1(PanelButtons, {
            primaryButton: l,
            secondaryButton: d,
            buttonsAlign: h,
            buttonsInline: u,
            checkboxMemo: $,
            checkboxValue: S,
            onChangeCheckbox: D,
            modalMode: N,
            isMobile: M,
            handleOnClose: C,
            modalType: t
          })]
        }), p && "label" in p && /* @__PURE__ */ jsx$1(Buttons.Tiny, {
          onClick: p.onClick,
          label: p.label,
          mode: "light"
        })]
      })
    })
  });
}, Bottom = ({
  ...t
}) => /* @__PURE__ */ jsx$1(Modal$1, {
  mode: ModalTypes.bottom,
  ...t
}), Centered = ({
  ...t
}) => /* @__PURE__ */ jsx$1(Modal$1, {
  mode: ModalTypes.centered,
  ...t
}), ContentDriven = ({
  ...t
}) => /* @__PURE__ */ jsx$1(Modal$1, {
  mode: ModalTypes.contentDriven,
  ...t
}), Modals = {
  Bottom,
  Centered,
  ContentDriven
};
var Position = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t.left = "left", t.right = "right", t))(Position || {});
const TooltipPosition = {
  [Position.top]: css$3`
    bottom: 100%;
    margin: 0 auto;
    transform: translateY(-10%);
  `,
  [Position.left]: css$3`
    top: 50%;
    transform: translateX(-110%) translateY(-50%);
  `,
  [Position.bottom]: css$3`
    top: 100%;
    margin: 0 auto;
    transform: translateY(10%);
  `,
  [Position.right]: css$3`
    left: 100%;
    top: 50%;
    transform: translateX(10%) translateY(-50%);
  `
}, TooltipBeforePosition = {
  [Position.top]: css$3`
    top: 100%;
    border-top-color: ${({ theme: { colors: t } }) => t.white};
  `,
  [Position.left]: css$3`
    left: 100%;
    top: 50%;
    transform: translateY(-50%) rotate(180deg);
    border-right-color: ${({ theme: { colors: t } }) => t.white};
  `,
  [Position.bottom]: css$3`
    bottom: 100%;
    border-bottom-color: ${({ theme: { colors: t } }) => t.white};
  `,
  [Position.right]: css$3`
    left: 0;
    top: 50%;
    transform: translate(-100%, -50%) rotate(180deg);
    border-left-color: ${({ theme: { colors: t } }) => t.white};
  `
}, Container$1 = styled(Layout.Grid)`
  opacity: 0;
  pointer-events: none;
  position: absolute;
  width: ${({ theme: { components: t }, size: r }) => t.message[`fds_c_tooltip_size_${r}`]};
  background-color: ${({ theme: { colors: t } }) => t.white};
  padding: ${({ theme: { components: t } }) => t.messages.fds_c_messages_spacing_M};
  border-radius: ${({ theme: { system: t } }) => t.fds_sys_borderradius_S};
  filter: ${({ theme: { components: t } }) => {
  const { x: r, y: n, blur: a, color: s } = t.messages.fds_c_tooltip_shadow;
  return `
      drop-shadow(${r} ${n} ${a} ${s});
    `;
}};
  transition: opacity 0.5s cubic-bezier(0, 0, 0.5, 1);

  ${({ position: t }) => t && TooltipPosition[t]};

  :before {
    content: ' ';
    left: 50%;
    border: 8px solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    transform: translateX(-50%);
    ${({ position: t }) => t && TooltipBeforePosition[t]};
  }

  :after {
    content: ' ';
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    ${({ position: t }) => css$3`
        ${t}: 10%
      `}
  }
`, Button = styled(Buttons.Contextual)`
  width: fit-content;
`, Wrapper = styled.div`
  display: inline-block;
  position: relative;

  :hover {
    ${Container$1} {
      pointer-events: all;
      opacity: 1;
      transition: opacity 0.5s cubic-bezier(0, 0, 0.5, 1);
    }
  }
`, Tooltip = ({
  title: t,
  position: r = "top",
  size: n = "S",
  description: a,
  buttonLabel: s,
  onClick: o,
  children: c,
  ...l
}) => /* @__PURE__ */ jsxs(Wrapper, {
  ...l,
  children: [c, /* @__PURE__ */ jsxs(Container$1, {
    size: n,
    gap: "dimension_16",
    position: r,
    role: "tooltip",
    children: [/* @__PURE__ */ jsxs(Layout.Grid, {
      gap: "dimension_08",
      children: [/* @__PURE__ */ jsx$1(Text$3, {
        type: "paragraphs",
        color: "dark",
        size: "XS_XL_S",
        children: t
      }), a && /* @__PURE__ */ jsx$1(Text$3, {
        type: "paragraphs",
        color: "dark",
        size: "XS_M_S",
        children: a
      })]
    }), s && o && /* @__PURE__ */ jsx$1(Button, {
      label: s,
      mode: "primary",
      onClick: o
    })]
  })]
}), Header = styled(FlexContainer$1)`
  > svg {
    flex-shrink: 0;
  }
`, Faq = styled(Buttons.Tiny)`
  justify-content: start;
  width: auto;
  > span {
    width: 100%;
    display: inline-block;
    text-align: start;
    word-wrap: normal;
    word-break: normal;
  }
`, Doubts = ({
  size: t,
  isOpened: r,
  headerLabel: n,
  headerIcon: a = "IconInfoLineSDark",
  listDoubts: s
}) => /* @__PURE__ */ jsxs(Accordion, {
  size: t,
  isOpened: r,
  children: [/* @__PURE__ */ jsxs(Header, {
    align: "center",
    gap: "dimension_08",
    children: [/* @__PURE__ */ jsx$1(Icon$4, {
      icon: a,
      color: "default"
    }), /* @__PURE__ */ jsx$1(Text$3, {
      color: "dark",
      size: "S_M_S",
      type: "paragraphs",
      align: "center",
      children: n
    })]
  }), /* @__PURE__ */ jsx$1(Layout.Grid, {
    gap: "dimension_16",
    children: s == null ? void 0 : s.map((o) => /* @__PURE__ */ jsxs(FlexContainer$1, {
      gap: "dimension_04",
      fullWidth: !0,
      children: [/* @__PURE__ */ jsx$1(Icon$4, {
        icon: "IconArrowRightS",
        color: "default"
      }), /* @__PURE__ */ jsx$1(Faq, {
        hasHoverUnderline: !1,
        label: o.label,
        onClick: () => o.action()
      })]
    }, o.label))
  })]
}), delay = (t) => new Promise((r) => {
  setTimeout(() => {
    r();
  }, t);
}), isBlockContainer = () => {
  var t;
  return ((t = document.querySelector(`#${SectionsRootLayout.ContainerLayout}`)) == null ? void 0 : t.classList.contains("is-block-container")) || !1;
}, closeBlockContainer = () => {
  var t;
  (t = document.querySelector(`#${SectionsRootLayout.ContainerLayout}`)) == null || t.classList.remove("is-block-container");
}, openBlockContainer = () => {
  var t;
  (t = document.querySelector(`#${SectionsRootLayout.ContainerLayout}`)) == null || t.classList.add("is-block-container");
}, toggleBlockContainer = () => {
  isBlockContainer() ? closeBlockContainer() : openBlockContainer();
}, isOpenRightSidebar = () => {
  var t;
  return ((t = document.querySelector(`#${SectionsRootLayout.RightSidebar}`)) == null ? void 0 : t.classList.contains("is-open-right-sidebar")) || !1;
}, openRightSidebar = () => {
  var t;
  (t = document.querySelector(`#${SectionsRootLayout.RightSidebar}`)) == null || t.classList.add("is-open-right-sidebar"), openBlockContainer();
}, closeRightSidebar = () => {
  const t = document.querySelector(`#${SectionsRootLayout.RightSidebar}`);
  return t == null || t.classList.remove("is-open-right-sidebar"), closeBlockContainer(), delay(300);
}, toggleRightSidebar = () => {
  isOpenRightSidebar() ? closeRightSidebar() : openRightSidebar();
}, isOpenLeftSidebar = () => {
  var t;
  return ((t = document.querySelector(`#${SectionsRootLayout.LeftSidebar}`)) == null ? void 0 : t.classList.contains("is-open-left-sidebar")) || !1;
}, openLeftSidebar = () => {
  var t;
  (t = document.querySelector(`#${SectionsRootLayout.LeftSidebar}`)) == null || t.classList.add("is-open-left-sidebar"), openBlockContainer();
}, closeLeftSidebar = () => {
  var t;
  (t = document.querySelector(`#${SectionsRootLayout.LeftSidebar}`)) == null || t.classList.remove("is-open-left-sidebar"), closeBlockContainer();
}, toggleLeftSidebar = () => {
  isOpenLeftSidebar() ? closeLeftSidebar() : openLeftSidebar();
}, LayoutContext = createContext({}), LayoutProvider = ({
  children: t
}) => {
  const [r, n] = useState({
    comp: null,
    maxSize: Sizes$1.M
  }), a = async ({
    comp: c,
    maxSize: l
  }) => {
    var d, h;
    (d = r == null ? void 0 : r.comp) != null && d.key && (c == null ? void 0 : c.key) !== ((h = r.comp) == null ? void 0 : h.key) && await closeRightSidebar(), n({
      comp: c,
      maxSize: l
    }), openRightSidebar();
  }, s = async () => {
    await closeRightSidebar(), n({
      comp: null,
      maxSize: Sizes$1.S
    });
  }, o = useMemo(() => ({
    stateRightSidebar: r,
    showRightSidebar: a,
    hideRightSidebar: s
  }), [r]);
  return /* @__PURE__ */ jsxs(LayoutContext.Provider, {
    value: o,
    children: [t, /* @__PURE__ */ jsx$1(RightSideBarPortal, {
      maxSize: r.maxSize,
      children: r.comp
    })]
  });
}, ContainerRoot = styled(Portal)`
  ${({ hasBorder: t }) => t && css$3`
      margin: ${({ theme: r }) => r.reference.dimension_16};
      margin-top: 0;
      ${({ theme: { components: r } }) => r.navigation.fds_c_sidebar_floating_styles};
      border-style: solid;
      @media screen and (max-width: ${({ theme: { mediaQueries: r } }) => r.mobile_width}) {
        margin: 0;
        border: none;
        border-radius: 0;
      }
    `};
`, LeftSide = styled(Portal)`
  ${({ theme: { components: t } }) => t.navigation.fds_c_sidebar_left};
  border-left-style: solid;
  border-right-style: solid;

  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  @media screen and (max-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    > div:last-child {
      max-width: ${({ theme: t, maxSize: r }) => t.components.navigation[`fds_c_sidebar_max_width_${r}`]};
    }
    border: none;
    height: 100%;
  }

  @media screen and (min-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    max-width: ${({ theme: t, maxSize: r }) => t.components.navigation[`fds_c_sidebar_max_width_${r}`]};
    border-left: 0;
  }
`, RightSide = styled(Portal)`
  display: flex;
  width: 100%;

  ${({ theme: { components: t } }) => t.navigation.fds_c_sidebar_floating_styles};
  box-shadow: ${({ theme: { components: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.navigation.fds_c_sidebar_floating_styles["box-shadow"];
  return `${r} ${n} ${a} ${s} ${o}`;
}};
  border-style: solid;

  @media screen and (max-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    border: none;
    margin: 0;
    height: 100%;
    box-shadow: none;
    border-radius: 0;
    > div:last-child {
      max-width: ${({ theme: t, maxSize: r }) => t.components.navigation[`fds_c_sidebar_max_width_${r}`]};
    }
  }

  @media screen and (min-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    margin: ${({ theme: { components: t } }) => t.navigation.fds_c_sidebar_floating_spacing};
    height: ${({ theme: { components: t } }) => `calc(100% - ${parseInt(t.navigation.fds_c_sidebar_floating_spacing, 10) * 2}px)`};
    max-width: ${({ theme: t, maxSize: r }) => t.components.navigation[`fds_c_sidebar_max_width_${r}`]};
  }
`, CloseLeftSide = styled.div`
  display: none;
  -webkit-tap-highlight-color: transparent;
  @media screen and (max-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    cursor: pointer;
    display: flex;
    flex-grow: 1;
    height: 100%;
    margin: ${({ theme: t }) => t.components.navigation.fds_c_sidebar_close_spacing};
  }
`, CloseRightSide = styled.div`
  display: none;
  -webkit-tap-highlight-color: transparent;
  @media screen and (min-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 0;
    margin: ${({ theme: t }) => t.components.navigation.fds_c_sidebar_close_spacing};
    > svg:last-of-type {
      display: none;
    }
  }

  @media screen and (max-width: ${({ theme: { mediaQueries: t } }) => t.mobile_width}) {
    display: flex;
    cursor: pointer;
    flex-direction: row-reverse;
    flex-grow: 1;
    height: 100%;
    margin: ${({ theme: t }) => t.components.navigation.fds_c_sidebar_close_spacing};
    > svg:first-of-type {
      display: none;
    }
  }
`, ContainerRootPortal = ({
  children: t,
  className: r,
  hasBorder: n
}) => /* @__PURE__ */ jsx$1(ContainerRoot, {
  id: SectionsRootLayout.ContainerRoot,
  className: r,
  hasBorder: n,
  children: t
}), ContainerContentPortal = ({
  children: t,
  className: r
}) => /* @__PURE__ */ jsx$1(Portal, {
  id: SectionsRootLayout.ContainerContent,
  className: r,
  children: t
}), NavPortal = ({
  children: t,
  className: r
}) => /* @__PURE__ */ jsx$1(Portal, {
  id: SectionsRootLayout.NavRoot,
  className: r,
  children: t
}), LeftSideBarPortal = ({
  children: t,
  className: r,
  maxSize: n,
  onClose: a
}) => /* @__PURE__ */ jsxs(LeftSide, {
  id: SectionsRootLayout.LeftSidebar,
  className: r,
  maxSize: n,
  children: [/* @__PURE__ */ jsx$1(CloseLeftSide, {
    onClick: () => {
      closeLeftSidebar(), a == null || a();
    },
    children: /* @__PURE__ */ jsx$1(Icon$4, {
      icon: "CrossS",
      color: "light"
    })
  }), t]
}), RightSideBarPortal = ({
  children: t,
  className: r,
  maxSize: n,
  onClose: a
}) => {
  const {
    hideRightSidebar: s
  } = useContext(LayoutContext), o = () => {
    s(), a == null || a();
  };
  return /* @__PURE__ */ jsxs(RightSide, {
    id: SectionsRootLayout.RightSidebar,
    className: r,
    maxSize: n,
    children: [/* @__PURE__ */ jsxs(CloseRightSide, {
      onClick: o,
      children: [/* @__PURE__ */ jsx$1(Icon$4, {
        icon: "CrossRoundedSolidS",
        color: "default"
      }), /* @__PURE__ */ jsx$1(Icon$4, {
        icon: "CrossS",
        color: "light"
      })]
    }), t]
  });
}, HeaderPortal = ({
  children: t,
  className: r
}) => /* @__PURE__ */ jsx$1(Portal, {
  id: SectionsRootLayout.Header,
  className: r,
  children: t
}), ContentHeaderPortal = ({
  children: t,
  className: r
}) => /* @__PURE__ */ jsx$1(Portal, {
  id: SectionsRootLayout.ContentHeader,
  className: r,
  children: t
}), ContentPortal = ({
  children: t,
  className: r
}) => /* @__PURE__ */ jsx$1(Portal, {
  id: SectionsRootLayout.Content,
  className: r,
  children: t
}), ContentFooterPortal = ({
  children: t,
  className: r
}) => /* @__PURE__ */ jsx$1(Portal, {
  id: SectionsRootLayout.ContentFooter,
  className: r,
  children: t
}), FooterPortal = ({
  children: t,
  className: r
}) => /* @__PURE__ */ jsx$1(Portal, {
  id: SectionsRootLayout.Footer,
  className: r,
  children: t
}), index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ContainerContentPortal,
  ContainerRootPortal,
  ContentFooterPortal,
  ContentHeaderPortal,
  ContentPortal,
  FooterPortal,
  HeaderPortal,
  LeftSideBarPortal,
  NavPortal,
  RightSideBarPortal
}, Symbol.toStringTag, { value: "Module" })), KamiInput = ({
  id: t,
  inputForm: r,
  customComponentsMap: n,
  onChange: a,
  onHelpButton: s
}) => {
  const [o, c] = useState(r.value), l = {
    ...componentsMap,
    ...n
  }[r.type];
  if (!l)
    throw new Error(`Not exist component for type: ${r.type}`);
  const {
    Component: d,
    props: h
  } = l, u = [InputFormTypes.ADDRESS], p = useMemo(() => u.includes(r == null ? void 0 : r.validationType), [r == null ? void 0 : r.validationType]);
  useEffect(() => {
    (!p || p && !o) && c(r.value);
  }, [r.value]);
  const m = (g) => {
    const v = validationParsers[r.type], y = validationParsers[r.validationType || ""], x = v ? v(g) : g, _ = y ? y(g) : g;
    c(x), a(p ? _ : x);
  };
  return /* @__PURE__ */ jsx$1(d, {
    ...r,
    ...h,
    id: t,
    testID: t,
    value: o,
    errorMsg: r.error ?? "",
    hasError: !!r.error,
    onChange: m,
    onHelpButton: s
  });
}, InputContainer = styled.div`
  position: relative;
`, ReadOnlyView = styled.div`
  position: absolute;
  width: 100%;
  height: 75%;
  bottom: 0;
  z-index: ${({
  theme: {
    system: t
  }
}) => t.zIndex.fds_sys_zindex_highlighted};
`, KamiForm = ({
  kamiInputs: t,
  readOnly: r,
  customComponentsMap: n,
  onReadOnly: a,
  onUpdate: s,
  onHelpButton: o = (c) => window.open(c, "_blank")
}) => {
  const c = (l) => (d) => {
    t[l].setValue(d), s == null || s(t);
  };
  return /* @__PURE__ */ jsx$1(FlexContainer$1, {
    direction: "column",
    gap: "dimension_16",
    children: t.map((l, d) => {
      const h = l.getRenderForm(), u = l.getId();
      return h ? /* @__PURE__ */ jsxs(InputContainer, {
        children: [r && /* @__PURE__ */ jsx$1(ReadOnlyView, {
          "data-testid": "readOnlyLayer",
          onClick: a
        }), /* @__PURE__ */ jsx$1(KamiInput, {
          id: u,
          customComponentsMap: n,
          inputForm: h,
          onChange: c(d),
          onHelpButton: o
        })]
      }, u) : null;
    })
  });
};
var BottomNavTypes = /* @__PURE__ */ ((t) => (t.default = "default", t.info = "info", t.warning = "warning", t))(BottomNavTypes || {});
const types = {
  [BottomNavTypes.default]: css$3`
    background-color: ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_notice_default_background};
    p {
      display: none;
    }
  `,
  [BottomNavTypes.info]: css$3`
    background-color: ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_notice_info_background};
    ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_notice_info_text};
  `,
  [BottomNavTypes.warning]: css$3`
    background-color: ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_notice_warning_background};
    ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_notice_warning_text};
  `
}, verticalStyles = css$3`
  margin-left: 0;
  width: 100%;
`, Classic = styled(Buttons.Classic)`
  box-shadow: ${({ theme: { components: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.navigation.fds_c_bottomnav_button_shadow_dark;
  return `${r} ${n} ${a} ${s} ${o}`;
}};
  margin-left: auto;
  ${({ $direction: t }) => t === LayoutDirection.VERTICAL && verticalStyles}
`, LeftPart = styled(FlexContainer$1)`
  position: relative;
`, Icon = styled(Buttons.Icon)`
  box-shadow: ${({ theme: { components: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.navigation.fds_c_bottomnav_button_shadow_dark;
  return `${r} ${n} ${a} ${s} ${o}`;
}};
  margin-right: auto;
  transition: all 0.4s ${({ theme: { system: t } }) => t.easings.fds_sys_ease_default};
`, Tiny = styled(Buttons.Tiny)`
  padding-left: ${({ theme: { reference: t } }) => t.dimension_08};
  margin-right: auto;
  transition: all 0.4s ${({ theme: { system: t } }) => t.easings.fds_sys_ease_default};
  ${({ $direction: t }) => t === LayoutDirection.VERTICAL && css$3`
      margin-right: 0;
    `}
`, Message = styled.p`
  position: absolute;
  left: ${({ theme: { reference: t } }) => t.dimension_48};
  width: 100%;
  ${({ $type: t }) => types[t]};
  padding: ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_spacing};
  background-color: transparent;
  transition: all 0.4s ${({ theme: { system: t } }) => t.easings.fds_sys_ease_default};
  opacity: 0;
  z-index: -1;
`, containerStyles = css$3`
  border-radius: ${({ theme: { components: t }, $direction: r }) => r === LayoutDirection.VERTICAL ? `${t.navigation.fds_c_bottomnav_content["border-radius"]} ${t.navigation.fds_c_bottomnav_content["border-radius"]} 0 0` : t.navigation.fds_c_bottomnav_content["border-radius"]};
  border-color: ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_content["border-color"]};
  border-width: ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_content["border-width"]};
  box-shadow: ${({ theme: { components: t } }) => {
  const { x: r, y: n, blur: a, spread: s, color: o } = t.navigation.fds_c_bottomnav_content["box-shadow"];
  return `${r} ${n} ${a} ${s} ${o}`;
}};
  backdrop-filter: ${({ theme: { components: t } }) => `blur(${t.navigation.fds_c_bottomnav_content["background-blur"]})`};
  padding: ${({ theme: { components: t, reference: r }, $direction: n }) => n === LayoutDirection.VERTICAL ? `${r.dimension_16}` : `${t.navigation.fds_c_bottomnav_content["vertical-padding"]} ${t.navigation.fds_c_bottomnav_content["horizontal-padding"]}`};
  max-width: ${({ theme: { components: t } }) => t.navigation.fds_c_bottomnav_wrapper["max-width"]};
  width: 100%;
  transition: background-color 0.4s
    ${({ theme: { system: t } }) => t.easings.fds_sys_ease_default};
`, Container = styled(FlexContainer$1)`
  flex-direction: column;
  align-items: flex-start;
  overflow: clip;
  ${containerStyles}
  ${({ $type: t, $hasMessage: r }) => r && css$3`
      :has(${Classic}:hover) {
        ${types[t]};
      }
    `}
  ${({ $background: t }) => t && css$3`
      background-color: ${({ theme: { components: r } }) => r.navigation.fds_c_bottomnav_notice_default_background};
    `}
`, Content = styled(FlexContainer$1)`
  justify-content: center;
  align-items: center;
  gap: ${({ theme: { reference: t } }) => t.dimension_16};
  align-self: stretch;
  min-height: ${({ theme: { reference: t } }) => t.dimension_40};
  flex-direction: ${({ $direction: t }) => t === LayoutDirection.VERTICAL ? "column" : "row"};
  width: 100%;
  ${({ $hasMessage: t }) => t && css$3`
      ${LeftPart} {
        position: relative;
        transition: transform 0.4s ${({ theme: { system: r } }) => r.easings.fds_sys_ease_default};
      }
      ${LeftPart}:has(~ ${Classic}:hover) > ${Message} {
        left: 0;
        opacity: 1;
      }
      ${LeftPart}:has(~ ${Classic}:hover) > ${Icon},
      ${LeftPart}:has(~ ${Classic}:hover) > ${Tiny} {
        transform: translate(${({ theme: { reference: r } }) => `-${r.dimension_48}`}, 0);
        opacity: 0;
      }
    `}
`, BottomNav = ({
  type: t = BottomNavTypes.default,
  message: r,
  forwardButton: n,
  textButton: a,
  iconButton: s,
  direction: o,
  hasBackground: c
}) => /* @__PURE__ */ jsx$1(Container, {
  $type: t,
  $hasMessage: !!r,
  $direction: o,
  $background: c,
  children: /* @__PURE__ */ jsxs(Content, {
    fullHeight: !0,
    fullWidth: !0,
    $hasMessage: !!r,
    $direction: o,
    children: [(r || s || a) && /* @__PURE__ */ jsxs(LeftPart, {
      align: "center",
      justify: "center",
      fullWidth: !0,
      children: [s && /* @__PURE__ */ jsx$1(Icon, {
        size: "m",
        icon: "IconArrowLeftM",
        mode: "light",
        onClick: s.onClick,
        disabled: s.disabled,
        testID: s.testID,
        id: s.id
      }), a && /* @__PURE__ */ jsx$1(Tiny, {
        mode: "default",
        label: a.label,
        onClick: a.onClick,
        disabled: a.disabled,
        testID: a.testID,
        id: a.id,
        $direction: o
      }), r && /* @__PURE__ */ jsx$1(Message, {
        $type: t,
        children: r
      })]
    }), n && /* @__PURE__ */ jsx$1(Classic, {
      size: "m",
      mode: "primary",
      label: n.label,
      onClick: n.onClick,
      disabled: n.disabled,
      testID: n.testID,
      id: n.id,
      $direction: o
    })]
  })
}), Navigation = {
  BottomNav
};
var IllustrationsStates = /* @__PURE__ */ ((t) => (t.DOC_CORRECT = "states/doc_correct", t.DOC_NOT_ALLOWED = "states/doc_not_allowed", t.INSPECT_ERROR = "states/inspect_error", t.INSPECT_WARNING = "states/inspect_warning", t))(IllustrationsStates || {}), IllustrationsDefault = /* @__PURE__ */ ((t) => (t["7P"] = "default/7p", t.ABACUS = "default/abacus", t.ADD_CIRCLE = "default/add_circle", t.ADD_DOC = "default/add_doc", t.ADD_SHIELD = "default/add_shield", t.AIRDROP = "default/airdrop", t.ASCENDANT = "default/ascendant", t.BALANCE = "default/balance", t.BECKHAM = "default/beckham", t.BITCOIN = "default/bitcoin", t.BOOK = "default/book", t.BRIEFCASE = "default/briefcase", t.BRIEFCASE_SIGNAL = "default/briefcase_signal", t.BUS = "default/bus", t.CACTUS = "default/cactus", t.CALENDAR = "default/calendar", t.CALL_CENTER = "default/call_center", t.CAR_COVERED = "default/car_covered", t.CERTIFICATE = "default/certificate", t.CHAT = "default/chat", t.CHAT_24H = "default/chat_24h", t.CHAT_NOW = "default/chat_now", t.COUPLE = "default/couple", t.COW = "default/cow", t.DESCENDANT = "default/descendant", t.DISTRIBUTE = "default/distribute", t.DONE = "default/done", t.FACE = "default/face", t.FISH = "default/fish", t.FRACTIONS = "default/fractions", t.GRAPH_BARS = "default/graph_bars", t.GRAPH_CURVES = "default/graph_curves", t.GRAVE = "default/grave", t.HEART = "default/heart", t.HOUSE = "default/house", t.INCOMING_DATA = "default/incoming_data", t.INFORMATION = "default/information", t.INSIDE_PERSON = "default/inside_person", t.INSPECT = "default/inspect", t.INSPECT_4 = "default/inspect_4", t.ITP_IVIMA = "default/itp_ivima", t.JOIN_DIAGONAL = "default/join_diagonal", t.JOIN_HORIZONTAL = "default/join_horizontal", t.JOIN_VERTICAL = "default/join_vertical", t.KEEP = "default/keep", t.KEY_MOTION = "default/key_motion", t.KEYS = "default/keys", t.LOCK = "default/lock", t.MAIL = "default/mail", t.MONEY = "default/money", t.MONEY_BEHIND = "default/money_behind", t.OPEN_MAIL = "default/open_mail", t.OUTGOING_DATA = "default/outgoing_data", t.PAIS_VASCO_NAVARRA = "default/pais_vasco_navarra", t.PEOPLE_IN_DOC = "default/people_in_doc", t.PERCENTAGE = "default/percentage", t.PERCENTAGE_PART = "default/percentage_part", t.PERSON = "default/person", t.PIN = "default/pin", t.PIN_MONEY = "default/pin_money", t.POINT = "default/point", t.PRIZE = "default/prize", t.REFRESH = "default/refresh", t.SAFE = "default/safe", t.SCAN = "default/scan", t.SCHOOL_SUPPLIES = "default/school_supplies", t.SEARCH = "default/search", t.SEND_EMAIL = "default/send_email", t.SETTINGS = "default/settings", t.SHIELD = "default/shield", t.TIME = "default/time", t.TOGETHER = "default/together", t.UMBRELLA = "default/umbrella", t.UP_AND_DOWN = "default/up_and_down", t.WALKING_STICK = "default/walking_stick", t.WALKING_STICKS = "default/walking_sticks", t.WATCHING = "default/watching", t.WHEELCHAIR = "default/wheelchair", t.WORKER_CARD = "default/Worker_card", t.WRITE = "default/write", t))(IllustrationsDefault || {}), IllustrationSizes = /* @__PURE__ */ ((t) => (t.S = "_s.png", t.M = "_m.png", t.L = "_l.png", t))(IllustrationSizes || {});
const Image$1 = styled.img`
  max-width: ${({ $maxWidth: t, theme: { reference: r } }) => t && r[t]};
  max-height: ${({ $maxHeight: t, theme: { reference: r } }) => t && r[t]};
`, Illustration = ({
  maxWidth: t,
  maxHeight: r,
  illustration: n,
  size: a = Sizes$1.S
}) => {
  const s = IllustrationsDefault[n] || IllustrationsStates[n];
  return /* @__PURE__ */ jsx$1(Image$1, {
    $maxWidth: t,
    $maxHeight: r,
    src: `${ILLUSTRATION_DOMAIN}${s}${IllustrationSizes[a]}`,
    alt: n
  });
};
var lottie$1 = { exports: {} };
(function(module, exports) {
  typeof document < "u" && typeof navigator < "u" && function(t, r) {
    module.exports = r();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(r) {
      _useWebWorker = !!r;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(r) {
      locationHref = r;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(t) {
      return document.createElement(t);
    }
    function extendPrototype(t, r) {
      var n, a = t.length, s;
      for (n = 0; n < a; n += 1) {
        s = t[n].prototype;
        for (var o in s)
          Object.prototype.hasOwnProperty.call(s, o) && (r.prototype[o] = s[o]);
      }
    }
    function getDescriptor(t, r) {
      return Object.getOwnPropertyDescriptor(t, r);
    }
    function createProxyFunction(t) {
      function r() {
      }
      return r.prototype = t, r;
    }
    var audioControllerFactory = function() {
      function t(r) {
        this.audios = [], this.audioFactory = r, this._volume = 1, this._isMuted = !1;
      }
      return t.prototype = {
        addAudio: function(n) {
          this.audios.push(n);
        },
        pause: function() {
          var n, a = this.audios.length;
          for (n = 0; n < a; n += 1)
            this.audios[n].pause();
        },
        resume: function() {
          var n, a = this.audios.length;
          for (n = 0; n < a; n += 1)
            this.audios[n].resume();
        },
        setRate: function(n) {
          var a, s = this.audios.length;
          for (a = 0; a < s; a += 1)
            this.audios[a].setRate(n);
        },
        createAudio: function(n) {
          return this.audioFactory ? this.audioFactory(n) : window.Howl ? new window.Howl({
            src: [n]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(n) {
          this.audioFactory = n;
        },
        setVolume: function(n) {
          this._volume = n, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var n, a = this.audios.length;
          for (n = 0; n < a; n += 1)
            this.audios[n].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new t();
      };
    }(), createTypedArray = function() {
      function t(n, a) {
        var s = 0, o = [], c;
        switch (n) {
          case "int16":
          case "uint8c":
            c = 1;
            break;
          default:
            c = 1.1;
            break;
        }
        for (s = 0; s < a; s += 1)
          o.push(c);
        return o;
      }
      function r(n, a) {
        return n === "float32" ? new Float32Array(a) : n === "int16" ? new Int16Array(a) : n === "uint8c" ? new Uint8ClampedArray(a) : t(n, a);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? r : t;
    }();
    function createSizedArray(t) {
      return Array.apply(null, {
        length: t
      });
    }
    function _typeof$6(t) {
      "@babel/helpers - typeof";
      return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$6(t);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var t = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], r, n = t.length;
      for (r = 0; r < n; r += 1)
        BMMath[t[r]] = Math[t[r]];
    })(), BMMath.random = Math.random, BMMath.abs = function(t) {
      var r = _typeof$6(t);
      if (r === "object" && t.length) {
        var n = createSizedArray(t.length), a, s = t.length;
        for (a = 0; a < s; a += 1)
          n[a] = Math.abs(t[a]);
        return n;
      }
      return Math.abs(t);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(t) {
      t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(t, r, n, a) {
      this.type = t, this.currentTime = r, this.totalTime = n, this.direction = a < 0 ? -1 : 1;
    }
    function BMCompleteEvent(t, r) {
      this.type = t, this.direction = r < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(t, r, n, a) {
      this.type = t, this.currentLoop = n, this.totalLoops = r, this.direction = a < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(t, r, n) {
      this.type = t, this.firstFrame = r, this.totalFrames = n;
    }
    function BMDestroyEvent(t, r) {
      this.type = t, this.target = r;
    }
    function BMRenderFrameErrorEvent(t, r) {
      this.type = "renderFrameError", this.nativeError = t, this.currentTime = r;
    }
    function BMConfigErrorEvent(t) {
      this.type = "configError", this.nativeError = t;
    }
    var createElementID = function() {
      var t = 0;
      return function() {
        return t += 1, idPrefix$1 + "__lottie_element_" + t;
      };
    }();
    function HSVtoRGB(t, r, n) {
      var a, s, o, c, l, d, h, u;
      switch (c = Math.floor(t * 6), l = t * 6 - c, d = n * (1 - r), h = n * (1 - l * r), u = n * (1 - (1 - l) * r), c % 6) {
        case 0:
          a = n, s = u, o = d;
          break;
        case 1:
          a = h, s = n, o = d;
          break;
        case 2:
          a = d, s = n, o = u;
          break;
        case 3:
          a = d, s = h, o = n;
          break;
        case 4:
          a = u, s = d, o = n;
          break;
        case 5:
          a = n, s = d, o = h;
          break;
      }
      return [a, s, o];
    }
    function RGBtoHSV(t, r, n) {
      var a = Math.max(t, r, n), s = Math.min(t, r, n), o = a - s, c, l = a === 0 ? 0 : o / a, d = a / 255;
      switch (a) {
        case s:
          c = 0;
          break;
        case t:
          c = r - n + o * (r < n ? 6 : 0), c /= 6 * o;
          break;
        case r:
          c = n - t + o * 2, c /= 6 * o;
          break;
        case n:
          c = t - r + o * 4, c /= 6 * o;
          break;
      }
      return [c, l, d];
    }
    function addSaturationToRGB(t, r) {
      var n = RGBtoHSV(t[0] * 255, t[1] * 255, t[2] * 255);
      return n[1] += r, n[1] > 1 ? n[1] = 1 : n[1] <= 0 && (n[1] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addBrightnessToRGB(t, r) {
      var n = RGBtoHSV(t[0] * 255, t[1] * 255, t[2] * 255);
      return n[2] += r, n[2] > 1 ? n[2] = 1 : n[2] < 0 && (n[2] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addHueToRGB(t, r) {
      var n = RGBtoHSV(t[0] * 255, t[1] * 255, t[2] * 255);
      return n[0] += r / 360, n[0] > 1 ? n[0] -= 1 : n[0] < 0 && (n[0] += 1), HSVtoRGB(n[0], n[1], n[2]);
    }
    var rgbToHex = function() {
      var t = [], r, n;
      for (r = 0; r < 256; r += 1)
        n = r.toString(16), t[r] = n.length === 1 ? "0" + n : n;
      return function(a, s, o) {
        return a < 0 && (a = 0), s < 0 && (s = 0), o < 0 && (o = 0), "#" + t[a] + t[s] + t[o];
      };
    }(), setSubframeEnabled = function(r) {
      subframeEnabled = !!r;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(r) {
      expressionsPlugin = r;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(r) {
      expressionsInterfaces = r;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(r) {
      defaultCurveSegments = r;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(r) {
      idPrefix$1 = r;
    };
    function createNS(t) {
      return document.createElementNS(svgNS, t);
    }
    function _typeof$5(t) {
      "@babel/helpers - typeof";
      return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$5(t);
    }
    var dataManager = function() {
      var t = 1, r = [], n, a, s = {
        onmessage: function() {
        },
        postMessage: function(g) {
          n({
            data: g
          });
        }
      }, o = {
        postMessage: function(g) {
          s.onmessage({
            data: g
          });
        }
      };
      function c(m) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var g = new Blob(["var _workerSelf = self; self.onmessage = ", m.toString()], {
            type: "text/javascript"
          }), v = URL.createObjectURL(g);
          return new Worker(v);
        }
        return n = m, s;
      }
      function l() {
        a || (a = c(function(g) {
          function v() {
            function x(G, I) {
              var k, B, L = G.length, V, U, J, q;
              for (B = 0; B < L; B += 1)
                if (k = G[B], "ks" in k && !k.completed) {
                  if (k.completed = !0, k.hasMask) {
                    var Z = k.masksProperties;
                    for (U = Z.length, V = 0; V < U; V += 1)
                      if (Z[V].pt.k.i)
                        C(Z[V].pt.k);
                      else
                        for (q = Z[V].pt.k.length, J = 0; J < q; J += 1)
                          Z[V].pt.k[J].s && C(Z[V].pt.k[J].s[0]), Z[V].pt.k[J].e && C(Z[V].pt.k[J].e[0]);
                  }
                  k.ty === 0 ? (k.layers = b(k.refId, I), x(k.layers, I)) : k.ty === 4 ? M(k.shapes) : k.ty === 5 && z(k);
                }
            }
            function _(G, I) {
              if (G) {
                var k = 0, B = G.length;
                for (k = 0; k < B; k += 1)
                  G[k].t === 1 && (G[k].data.layers = b(G[k].data.refId, I), x(G[k].data.layers, I));
              }
            }
            function $(G, I) {
              for (var k = 0, B = I.length; k < B; ) {
                if (I[k].id === G)
                  return I[k];
                k += 1;
              }
              return null;
            }
            function b(G, I) {
              var k = $(G, I);
              return k ? k.layers.__used ? JSON.parse(JSON.stringify(k.layers)) : (k.layers.__used = !0, k.layers) : null;
            }
            function M(G) {
              var I, k = G.length, B, L;
              for (I = k - 1; I >= 0; I -= 1)
                if (G[I].ty === "sh")
                  if (G[I].ks.k.i)
                    C(G[I].ks.k);
                  else
                    for (L = G[I].ks.k.length, B = 0; B < L; B += 1)
                      G[I].ks.k[B].s && C(G[I].ks.k[B].s[0]), G[I].ks.k[B].e && C(G[I].ks.k[B].e[0]);
                else
                  G[I].ty === "gr" && M(G[I].it);
            }
            function C(G) {
              var I, k = G.i.length;
              for (I = 0; I < k; I += 1)
                G.i[I][0] += G.v[I][0], G.i[I][1] += G.v[I][1], G.o[I][0] += G.v[I][0], G.o[I][1] += G.v[I][1];
            }
            function S(G, I) {
              var k = I ? I.split(".") : [100, 100, 100];
              return G[0] > k[0] ? !0 : k[0] > G[0] ? !1 : G[1] > k[1] ? !0 : k[1] > G[1] ? !1 : G[2] > k[2] ? !0 : k[2] > G[2] ? !1 : null;
            }
            var A = function() {
              var G = [4, 4, 14];
              function I(B) {
                var L = B.t.d;
                B.t.d = {
                  k: [{
                    s: L,
                    t: 0
                  }]
                };
              }
              function k(B) {
                var L, V = B.length;
                for (L = 0; L < V; L += 1)
                  B[L].ty === 5 && I(B[L]);
              }
              return function(B) {
                if (S(G, B.v) && (k(B.layers), B.assets)) {
                  var L, V = B.assets.length;
                  for (L = 0; L < V; L += 1)
                    B.assets[L].layers && k(B.assets[L].layers);
                }
              };
            }(), D = function() {
              var G = [4, 7, 99];
              return function(I) {
                if (I.chars && !S(G, I.v)) {
                  var k, B = I.chars.length;
                  for (k = 0; k < B; k += 1) {
                    var L = I.chars[k];
                    L.data && L.data.shapes && (M(L.data.shapes), L.data.ip = 0, L.data.op = 99999, L.data.st = 0, L.data.sr = 1, L.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, I.chars[k].t || (L.data.shapes.push({
                      ty: "no"
                    }), L.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), N = function() {
              var G = [5, 7, 15];
              function I(B) {
                var L = B.t.p;
                typeof L.a == "number" && (L.a = {
                  a: 0,
                  k: L.a
                }), typeof L.p == "number" && (L.p = {
                  a: 0,
                  k: L.p
                }), typeof L.r == "number" && (L.r = {
                  a: 0,
                  k: L.r
                });
              }
              function k(B) {
                var L, V = B.length;
                for (L = 0; L < V; L += 1)
                  B[L].ty === 5 && I(B[L]);
              }
              return function(B) {
                if (S(G, B.v) && (k(B.layers), B.assets)) {
                  var L, V = B.assets.length;
                  for (L = 0; L < V; L += 1)
                    B.assets[L].layers && k(B.assets[L].layers);
                }
              };
            }(), T = function() {
              var G = [4, 1, 9];
              function I(B) {
                var L, V = B.length, U, J;
                for (L = 0; L < V; L += 1)
                  if (B[L].ty === "gr")
                    I(B[L].it);
                  else if (B[L].ty === "fl" || B[L].ty === "st")
                    if (B[L].c.k && B[L].c.k[0].i)
                      for (J = B[L].c.k.length, U = 0; U < J; U += 1)
                        B[L].c.k[U].s && (B[L].c.k[U].s[0] /= 255, B[L].c.k[U].s[1] /= 255, B[L].c.k[U].s[2] /= 255, B[L].c.k[U].s[3] /= 255), B[L].c.k[U].e && (B[L].c.k[U].e[0] /= 255, B[L].c.k[U].e[1] /= 255, B[L].c.k[U].e[2] /= 255, B[L].c.k[U].e[3] /= 255);
                    else
                      B[L].c.k[0] /= 255, B[L].c.k[1] /= 255, B[L].c.k[2] /= 255, B[L].c.k[3] /= 255;
              }
              function k(B) {
                var L, V = B.length;
                for (L = 0; L < V; L += 1)
                  B[L].ty === 4 && I(B[L].shapes);
              }
              return function(B) {
                if (S(G, B.v) && (k(B.layers), B.assets)) {
                  var L, V = B.assets.length;
                  for (L = 0; L < V; L += 1)
                    B.assets[L].layers && k(B.assets[L].layers);
                }
              };
            }(), R = function() {
              var G = [4, 4, 18];
              function I(B) {
                var L, V = B.length, U, J;
                for (L = V - 1; L >= 0; L -= 1)
                  if (B[L].ty === "sh")
                    if (B[L].ks.k.i)
                      B[L].ks.k.c = B[L].closed;
                    else
                      for (J = B[L].ks.k.length, U = 0; U < J; U += 1)
                        B[L].ks.k[U].s && (B[L].ks.k[U].s[0].c = B[L].closed), B[L].ks.k[U].e && (B[L].ks.k[U].e[0].c = B[L].closed);
                  else
                    B[L].ty === "gr" && I(B[L].it);
              }
              function k(B) {
                var L, V, U = B.length, J, q, Z, ae;
                for (V = 0; V < U; V += 1) {
                  if (L = B[V], L.hasMask) {
                    var ee = L.masksProperties;
                    for (q = ee.length, J = 0; J < q; J += 1)
                      if (ee[J].pt.k.i)
                        ee[J].pt.k.c = ee[J].cl;
                      else
                        for (ae = ee[J].pt.k.length, Z = 0; Z < ae; Z += 1)
                          ee[J].pt.k[Z].s && (ee[J].pt.k[Z].s[0].c = ee[J].cl), ee[J].pt.k[Z].e && (ee[J].pt.k[Z].e[0].c = ee[J].cl);
                  }
                  L.ty === 4 && I(L.shapes);
                }
              }
              return function(B) {
                if (S(G, B.v) && (k(B.layers), B.assets)) {
                  var L, V = B.assets.length;
                  for (L = 0; L < V; L += 1)
                    B.assets[L].layers && k(B.assets[L].layers);
                }
              };
            }();
            function F(G) {
              G.__complete || (T(G), A(G), D(G), N(G), R(G), x(G.layers, G.assets), _(G.chars, G.assets), G.__complete = !0);
            }
            function z(G) {
              G.t.a.length === 0 && "m" in G.t.p;
            }
            var O = {};
            return O.completeData = F, O.checkColors = T, O.checkChars = D, O.checkPathProperties = N, O.checkShapes = R, O.completeLayers = x, O;
          }
          if (o.dataManager || (o.dataManager = v()), o.assetLoader || (o.assetLoader = function() {
            function x($) {
              var b = $.getResponseHeader("content-type");
              return b && $.responseType === "json" && b.indexOf("json") !== -1 || $.response && _typeof$5($.response) === "object" ? $.response : $.response && typeof $.response == "string" ? JSON.parse($.response) : $.responseText ? JSON.parse($.responseText) : null;
            }
            function _($, b, M, C) {
              var S, A = new XMLHttpRequest();
              try {
                A.responseType = "json";
              } catch {
              }
              A.onreadystatechange = function() {
                if (A.readyState === 4)
                  if (A.status === 200)
                    S = x(A), M(S);
                  else
                    try {
                      S = x(A), M(S);
                    } catch (D) {
                      C && C(D);
                    }
              };
              try {
                A.open(["G", "E", "T"].join(""), $, !0);
              } catch {
                A.open(["G", "E", "T"].join(""), b + "/" + $, !0);
              }
              A.send();
            }
            return {
              load: _
            };
          }()), g.data.type === "loadAnimation")
            o.assetLoader.load(g.data.path, g.data.fullPath, function(x) {
              o.dataManager.completeData(x), o.postMessage({
                id: g.data.id,
                payload: x,
                status: "success"
              });
            }, function() {
              o.postMessage({
                id: g.data.id,
                status: "error"
              });
            });
          else if (g.data.type === "complete") {
            var y = g.data.animation;
            o.dataManager.completeData(y), o.postMessage({
              id: g.data.id,
              payload: y,
              status: "success"
            });
          } else
            g.data.type === "loadData" && o.assetLoader.load(g.data.path, g.data.fullPath, function(x) {
              o.postMessage({
                id: g.data.id,
                payload: x,
                status: "success"
              });
            }, function() {
              o.postMessage({
                id: g.data.id,
                status: "error"
              });
            });
        }), a.onmessage = function(m) {
          var g = m.data, v = g.id, y = r[v];
          r[v] = null, g.status === "success" ? y.onComplete(g.payload) : y.onError && y.onError();
        });
      }
      function d(m, g) {
        t += 1;
        var v = "processId_" + t;
        return r[v] = {
          onComplete: m,
          onError: g
        }, v;
      }
      function h(m, g, v) {
        l();
        var y = d(g, v);
        a.postMessage({
          type: "loadAnimation",
          path: m,
          fullPath: window.location.origin + window.location.pathname,
          id: y
        });
      }
      function u(m, g, v) {
        l();
        var y = d(g, v);
        a.postMessage({
          type: "loadData",
          path: m,
          fullPath: window.location.origin + window.location.pathname,
          id: y
        });
      }
      function p(m, g, v) {
        l();
        var y = d(g, v);
        a.postMessage({
          type: "complete",
          animation: m,
          id: y
        });
      }
      return {
        loadAnimation: h,
        loadData: u,
        completeAnimation: p
      };
    }(), ImagePreloader = function() {
      var t = function() {
        var _ = createTag("canvas");
        _.width = 1, _.height = 1;
        var $ = _.getContext("2d");
        return $.fillStyle = "rgba(0,0,0,0)", $.fillRect(0, 0, 1, 1), _;
      }();
      function r() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function n() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function a(_, $, b) {
        var M = "";
        if (_.e)
          M = _.p;
        else if ($) {
          var C = _.p;
          C.indexOf("images/") !== -1 && (C = C.split("/")[1]), M = $ + C;
        } else
          M = b, M += _.u ? _.u : "", M += _.p;
        return M;
      }
      function s(_) {
        var $ = 0, b = setInterval((function() {
          var M = _.getBBox();
          (M.width || $ > 500) && (this._imageLoaded(), clearInterval(b)), $ += 1;
        }).bind(this), 50);
      }
      function o(_) {
        var $ = a(_, this.assetsPath, this.path), b = createNS("image");
        isSafari ? this.testImageLoaded(b) : b.addEventListener("load", this._imageLoaded, !1), b.addEventListener("error", (function() {
          M.img = t, this._imageLoaded();
        }).bind(this), !1), b.setAttributeNS("http://www.w3.org/1999/xlink", "href", $), this._elementHelper.append ? this._elementHelper.append(b) : this._elementHelper.appendChild(b);
        var M = {
          img: b,
          assetData: _
        };
        return M;
      }
      function c(_) {
        var $ = a(_, this.assetsPath, this.path), b = createTag("img");
        b.crossOrigin = "anonymous", b.addEventListener("load", this._imageLoaded, !1), b.addEventListener("error", (function() {
          M.img = t, this._imageLoaded();
        }).bind(this), !1), b.src = $;
        var M = {
          img: b,
          assetData: _
        };
        return M;
      }
      function l(_) {
        var $ = {
          assetData: _
        }, b = a(_, this.assetsPath, this.path);
        return dataManager.loadData(b, (function(M) {
          $.img = M, this._footageLoaded();
        }).bind(this), (function() {
          $.img = {}, this._footageLoaded();
        }).bind(this)), $;
      }
      function d(_, $) {
        this.imagesLoadedCb = $;
        var b, M = _.length;
        for (b = 0; b < M; b += 1)
          _[b].layers || (!_[b].t || _[b].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(_[b]))) : _[b].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(_[b]))));
      }
      function h(_) {
        this.path = _ || "";
      }
      function u(_) {
        this.assetsPath = _ || "";
      }
      function p(_) {
        for (var $ = 0, b = this.images.length; $ < b; ) {
          if (this.images[$].assetData === _)
            return this.images[$].img;
          $ += 1;
        }
        return null;
      }
      function m() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function g() {
        return this.totalImages === this.loadedAssets;
      }
      function v() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function y(_, $) {
        _ === "svg" ? (this._elementHelper = $, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function x() {
        this._imageLoaded = r.bind(this), this._footageLoaded = n.bind(this), this.testImageLoaded = s.bind(this), this.createFootageData = l.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return x.prototype = {
        loadAssets: d,
        setAssetsPath: u,
        setPath: h,
        loadedImages: g,
        loadedFootages: v,
        destroy: m,
        getAsset: p,
        createImgData: c,
        createImageData: o,
        imageLoaded: r,
        footageLoaded: n,
        setCacheType: y
      }, x;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(r, n) {
        if (this._cbs[r])
          for (var a = this._cbs[r], s = 0; s < a.length; s += 1)
            a[s](n);
      },
      addEventListener: function(r, n) {
        return this._cbs[r] || (this._cbs[r] = []), this._cbs[r].push(n), (function() {
          this.removeEventListener(r, n);
        }).bind(this);
      },
      removeEventListener: function(r, n) {
        if (!n)
          this._cbs[r] = null;
        else if (this._cbs[r]) {
          for (var a = 0, s = this._cbs[r].length; a < s; )
            this._cbs[r][a] === n && (this._cbs[r].splice(a, 1), a -= 1, s -= 1), a += 1;
          this._cbs[r].length || (this._cbs[r] = null);
        }
      }
    };
    var markerParser = function() {
      function t(r) {
        for (var n = r.split(`\r
`), a = {}, s, o = 0, c = 0; c < n.length; c += 1)
          s = n[c].split(":"), s.length === 2 && (a[s[0]] = s[1].trim(), o += 1);
        if (o === 0)
          throw new Error();
        return a;
      }
      return function(r) {
        for (var n = [], a = 0; a < r.length; a += 1) {
          var s = r[a], o = {
            time: s.tm,
            duration: s.dr
          };
          try {
            o.payload = JSON.parse(r[a].cm);
          } catch {
            try {
              o.payload = t(r[a].cm);
            } catch {
              o.payload = {
                name: r[a].cm
              };
            }
          }
          n.push(o);
        }
        return n;
      };
    }(), ProjectInterface = function() {
      function t(r) {
        this.compositions.push(r);
      }
      return function() {
        function r(n) {
          for (var a = 0, s = this.compositions.length; a < s; ) {
            if (this.compositions[a].data && this.compositions[a].data.nm === n)
              return this.compositions[a].prepareFrame && this.compositions[a].data.xt && this.compositions[a].prepareFrame(this.currentFrame), this.compositions[a].compInterface;
            a += 1;
          }
          return null;
        }
        return r.compositions = [], r.currentFrame = 0, r.registerComposition = t, r;
      };
    }(), renderers = {}, registerRenderer = function(r, n) {
      renderers[r] = n;
    };
    function getRenderer(t) {
      return renderers[t];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var t in renderers)
        if (renderers[t])
          return t;
      return "";
    }
    function _typeof$4(t) {
      "@babel/helpers - typeof";
      return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$4(t);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(t) {
      (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
      var r = "svg";
      t.animType ? r = t.animType : t.renderer && (r = t.renderer);
      var n = getRenderer(r);
      this.renderer = new n(this, t.rendererSettings), this.imagePreloader.setCacheType(r, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = r, t.loop === "" || t.loop === null || t.loop === void 0 || t.loop === !0 ? this.loop = !0 : t.loop === !1 ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = "autoplay" in t ? t.autoplay : !0, this.name = t.name ? t.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(t, "autoloadSegments") ? t.autoloadSegments : !0, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (t.path.lastIndexOf("\\") !== -1 ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(t) {
      dataManager.completeAnimation(t, this.configAnimation);
    }, AnimationItem.prototype.setData = function(t, r) {
      r && _typeof$4(r) !== "object" && (r = JSON.parse(r));
      var n = {
        wrapper: t,
        animationData: r
      }, a = t.attributes;
      n.path = a.getNamedItem("data-animation-path") ? a.getNamedItem("data-animation-path").value : a.getNamedItem("data-bm-path") ? a.getNamedItem("data-bm-path").value : a.getNamedItem("bm-path") ? a.getNamedItem("bm-path").value : "", n.animType = a.getNamedItem("data-anim-type") ? a.getNamedItem("data-anim-type").value : a.getNamedItem("data-bm-type") ? a.getNamedItem("data-bm-type").value : a.getNamedItem("bm-type") ? a.getNamedItem("bm-type").value : a.getNamedItem("data-bm-renderer") ? a.getNamedItem("data-bm-renderer").value : a.getNamedItem("bm-renderer") ? a.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var s = a.getNamedItem("data-anim-loop") ? a.getNamedItem("data-anim-loop").value : a.getNamedItem("data-bm-loop") ? a.getNamedItem("data-bm-loop").value : a.getNamedItem("bm-loop") ? a.getNamedItem("bm-loop").value : "";
      s === "false" ? n.loop = !1 : s === "true" ? n.loop = !0 : s !== "" && (n.loop = parseInt(s, 10));
      var o = a.getNamedItem("data-anim-autoplay") ? a.getNamedItem("data-anim-autoplay").value : a.getNamedItem("data-bm-autoplay") ? a.getNamedItem("data-bm-autoplay").value : a.getNamedItem("bm-autoplay") ? a.getNamedItem("bm-autoplay").value : !0;
      n.autoplay = o !== "false", n.name = a.getNamedItem("data-name") ? a.getNamedItem("data-name").value : a.getNamedItem("data-bm-name") ? a.getNamedItem("data-bm-name").value : a.getNamedItem("bm-name") ? a.getNamedItem("bm-name").value : "";
      var c = a.getNamedItem("data-anim-prerender") ? a.getNamedItem("data-anim-prerender").value : a.getNamedItem("data-bm-prerender") ? a.getNamedItem("data-bm-prerender").value : a.getNamedItem("bm-prerender") ? a.getNamedItem("bm-prerender").value : "";
      c === "false" && (n.prerender = !1), n.path ? this.setParams(n) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(t) {
      t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
      var r = this.animationData.layers, n, a = r.length, s = t.layers, o, c = s.length;
      for (o = 0; o < c; o += 1)
        for (n = 0; n < a; ) {
          if (r[n].id === s[o].id) {
            r[n] = s[o];
            break;
          }
          n += 1;
        }
      if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets)
        for (a = t.assets.length, n = 0; n < a; n += 1)
          this.animationData.assets.push(t.assets[n]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(t) {
      this.animationData = t;
      var r = getExpressionsPlugin();
      r && r.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var t = this.animationData.segments;
      if (!t || t.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var r = t.shift();
      this.timeCompleted = r.time * this.frameRate;
      var n = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(n, this.includeLayers.bind(this), (function() {
        this.trigger("data_failed");
      }).bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var t = this.animationData.segments;
      t || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(t) {
      if (this.renderer)
        try {
          this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (r) {
          this.triggerConfigError(r);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var t = getExpressionsPlugin();
        t && t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
          this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(t, r) {
      var n = typeof t == "number" ? t : void 0, a = typeof r == "number" ? r : void 0;
      this.renderer.updateContainerSize(n, a);
    }, AnimationItem.prototype.setSubframe = function(t) {
      this.isSubframeEnabled = !!t;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (t) {
          this.triggerRenderFrameError(t);
        }
    }, AnimationItem.prototype.play = function(t) {
      t && this.name !== t || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(t) {
      t && this.name !== t || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(t) {
      t && this.name !== t || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(t) {
      t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(t) {
      for (var r, n = 0; n < this.markers.length; n += 1)
        if (r = this.markers[n], r.payload && r.payload.name === t)
          return r;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(t, r, n) {
      if (!(n && this.name !== n)) {
        var a = Number(t);
        if (isNaN(a)) {
          var s = this.getMarkerData(t);
          s && this.goToAndStop(s.time, !0);
        } else
          r ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(t, r, n) {
      if (!(n && this.name !== n)) {
        var a = Number(t);
        if (isNaN(a)) {
          var s = this.getMarkerData(t);
          s && (s.duration ? this.playSegments([s.time, s.time + s.duration], !0) : this.goToAndStop(s.time, !0));
        } else
          this.goToAndStop(a, r, n);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(t) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var r = this.currentRawFrame + t * this.frameModifier, n = !1;
        r >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(r > this.totalFrames ? r % this.totalFrames : 0) || (n = !0, r = this.totalFrames - 1) : r >= this.totalFrames ? (this.playCount += 1, this.checkSegments(r % this.totalFrames) || (this.setCurrentRawFrameValue(r % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(r) : r < 0 ? this.checkSegments(r % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + r % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (n = !0, r = 0)) : this.setCurrentRawFrameValue(r), n && (this.setCurrentRawFrameValue(r), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(t, r) {
      this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - r)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(1e-3 + r)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(t, r) {
      var n = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < t ? n = t : this.currentRawFrame + this.firstFrame > r && (n = r - t)), this.firstFrame = t, this.totalFrames = r - t, this.timeCompleted = this.totalFrames, n !== -1 && this.goToAndStop(n, !0);
    }, AnimationItem.prototype.playSegments = function(t, r) {
      if (r && (this.segments.length = 0), _typeof$4(t[0]) === "object") {
        var n, a = t.length;
        for (n = 0; n < a; n += 1)
          this.segments.push(t[n]);
      } else
        this.segments.push(t);
      this.segments.length && r && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(t) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(t) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), t), !0) : !1;
    }, AnimationItem.prototype.destroy = function(t) {
      t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
      this.currentRawFrame = t, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(t) {
      this.playSpeed = t, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(t) {
      this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(t) {
      this.loop = t;
    }, AnimationItem.prototype.setVolume = function(t, r) {
      r && this.name !== r || this.audioController.setVolume(t);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(t) {
      t && this.name !== t || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(t) {
      t && this.name !== t || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(t) {
      var r = "";
      if (t.e)
        r = t.p;
      else if (this.assetsPath) {
        var n = t.p;
        n.indexOf("images/") !== -1 && (n = n.split("/")[1]), r = this.assetsPath + n;
      } else
        r = this.path, r += t.u ? t.u : "", r += t.p;
      return r;
    }, AnimationItem.prototype.getAssetData = function(t) {
      for (var r = 0, n = this.assets.length; r < n; ) {
        if (t === this.assets[r].id)
          return this.assets[r];
        r += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(t) {
      return t ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(t, r, n) {
      try {
        var a = this.renderer.getElementByPath(t);
        a.updateDocumentData(r, n);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(t) {
      if (this._cbs && this._cbs[t])
        switch (t) {
          case "enterFrame":
            this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(t, new BMDestroyEvent(t, this));
            break;
          default:
            this.triggerEvent(t);
        }
      t === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), t === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), t === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), t === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), t === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
      var r = new BMRenderFrameErrorEvent(t, this.currentFrame);
      this.triggerEvent("error", r), this.onError && this.onError.call(this, r);
    }, AnimationItem.prototype.triggerConfigError = function(t) {
      var r = new BMConfigErrorEvent(t, this.currentFrame);
      this.triggerEvent("error", r), this.onError && this.onError.call(this, r);
    };
    var animationManager = function() {
      var t = {}, r = [], n = 0, a = 0, s = 0, o = !0, c = !1;
      function l(I) {
        for (var k = 0, B = I.target; k < a; )
          r[k].animation === B && (r.splice(k, 1), k -= 1, a -= 1, B.isPaused || p()), k += 1;
      }
      function d(I, k) {
        if (!I)
          return null;
        for (var B = 0; B < a; ) {
          if (r[B].elem === I && r[B].elem !== null)
            return r[B].animation;
          B += 1;
        }
        var L = new AnimationItem();
        return m(L, I), L.setData(I, k), L;
      }
      function h() {
        var I, k = r.length, B = [];
        for (I = 0; I < k; I += 1)
          B.push(r[I].animation);
        return B;
      }
      function u() {
        s += 1, T();
      }
      function p() {
        s -= 1;
      }
      function m(I, k) {
        I.addEventListener("destroy", l), I.addEventListener("_active", u), I.addEventListener("_idle", p), r.push({
          elem: k,
          animation: I
        }), a += 1;
      }
      function g(I) {
        var k = new AnimationItem();
        return m(k, null), k.setParams(I), k;
      }
      function v(I, k) {
        var B;
        for (B = 0; B < a; B += 1)
          r[B].animation.setSpeed(I, k);
      }
      function y(I, k) {
        var B;
        for (B = 0; B < a; B += 1)
          r[B].animation.setDirection(I, k);
      }
      function x(I) {
        var k;
        for (k = 0; k < a; k += 1)
          r[k].animation.play(I);
      }
      function _(I) {
        var k = I - n, B;
        for (B = 0; B < a; B += 1)
          r[B].animation.advanceTime(k);
        n = I, s && !c ? window.requestAnimationFrame(_) : o = !0;
      }
      function $(I) {
        n = I, window.requestAnimationFrame(_);
      }
      function b(I) {
        var k;
        for (k = 0; k < a; k += 1)
          r[k].animation.pause(I);
      }
      function M(I, k, B) {
        var L;
        for (L = 0; L < a; L += 1)
          r[L].animation.goToAndStop(I, k, B);
      }
      function C(I) {
        var k;
        for (k = 0; k < a; k += 1)
          r[k].animation.stop(I);
      }
      function S(I) {
        var k;
        for (k = 0; k < a; k += 1)
          r[k].animation.togglePause(I);
      }
      function A(I) {
        var k;
        for (k = a - 1; k >= 0; k -= 1)
          r[k].animation.destroy(I);
      }
      function D(I, k, B) {
        var L = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), V, U = L.length;
        for (V = 0; V < U; V += 1)
          B && L[V].setAttribute("data-bm-type", B), d(L[V], I);
        if (k && U === 0) {
          B || (B = "svg");
          var J = document.getElementsByTagName("body")[0];
          J.innerText = "";
          var q = createTag("div");
          q.style.width = "100%", q.style.height = "100%", q.setAttribute("data-bm-type", B), J.appendChild(q), d(q, I);
        }
      }
      function N() {
        var I;
        for (I = 0; I < a; I += 1)
          r[I].animation.resize();
      }
      function T() {
        !c && s && o && (window.requestAnimationFrame($), o = !1);
      }
      function R() {
        c = !0;
      }
      function F() {
        c = !1, T();
      }
      function z(I, k) {
        var B;
        for (B = 0; B < a; B += 1)
          r[B].animation.setVolume(I, k);
      }
      function O(I) {
        var k;
        for (k = 0; k < a; k += 1)
          r[k].animation.mute(I);
      }
      function G(I) {
        var k;
        for (k = 0; k < a; k += 1)
          r[k].animation.unmute(I);
      }
      return t.registerAnimation = d, t.loadAnimation = g, t.setSpeed = v, t.setDirection = y, t.play = x, t.pause = b, t.stop = C, t.togglePause = S, t.searchAnimations = D, t.resize = N, t.goToAndStop = M, t.destroy = A, t.freeze = R, t.unfreeze = F, t.setVolume = z, t.mute = O, t.unmute = G, t.getRegisteredAnimations = h, t;
    }(), BezierFactory = function() {
      var t = {};
      t.getBezierEasing = n;
      var r = {};
      function n($, b, M, C, S) {
        var A = S || ("bez_" + $ + "_" + b + "_" + M + "_" + C).replace(/\./g, "p");
        if (r[A])
          return r[A];
        var D = new _([$, b, M, C]);
        return r[A] = D, D;
      }
      var a = 4, s = 1e-3, o = 1e-7, c = 10, l = 11, d = 1 / (l - 1), h = typeof Float32Array == "function";
      function u($, b) {
        return 1 - 3 * b + 3 * $;
      }
      function p($, b) {
        return 3 * b - 6 * $;
      }
      function m($) {
        return 3 * $;
      }
      function g($, b, M) {
        return ((u(b, M) * $ + p(b, M)) * $ + m(b)) * $;
      }
      function v($, b, M) {
        return 3 * u(b, M) * $ * $ + 2 * p(b, M) * $ + m(b);
      }
      function y($, b, M, C, S) {
        var A, D, N = 0;
        do
          D = b + (M - b) / 2, A = g(D, C, S) - $, A > 0 ? M = D : b = D;
        while (Math.abs(A) > o && ++N < c);
        return D;
      }
      function x($, b, M, C) {
        for (var S = 0; S < a; ++S) {
          var A = v(b, M, C);
          if (A === 0)
            return b;
          var D = g(b, M, C) - $;
          b -= D / A;
        }
        return b;
      }
      function _($) {
        this._p = $, this._mSampleValues = h ? new Float32Array(l) : new Array(l), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return _.prototype = {
        get: function(b) {
          var M = this._p[0], C = this._p[1], S = this._p[2], A = this._p[3];
          return this._precomputed || this._precompute(), M === C && S === A ? b : b === 0 ? 0 : b === 1 ? 1 : g(this._getTForX(b), C, A);
        },
        // Private part
        _precompute: function() {
          var b = this._p[0], M = this._p[1], C = this._p[2], S = this._p[3];
          this._precomputed = !0, (b !== M || C !== S) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var b = this._p[0], M = this._p[2], C = 0; C < l; ++C)
            this._mSampleValues[C] = g(C * d, b, M);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(b) {
          for (var M = this._p[0], C = this._p[2], S = this._mSampleValues, A = 0, D = 1, N = l - 1; D !== N && S[D] <= b; ++D)
            A += d;
          --D;
          var T = (b - S[D]) / (S[D + 1] - S[D]), R = A + T * d, F = v(R, M, C);
          return F >= s ? x(b, R, M, C) : F === 0 ? R : y(b, A, A + d, M, C);
        }
      }, t;
    }(), pooling = function() {
      function t(r) {
        return r.concat(createSizedArray(r.length));
      }
      return {
        double: t
      };
    }(), poolFactory = function() {
      return function(t, r, n) {
        var a = 0, s = t, o = createSizedArray(s), c = {
          newElement: l,
          release: d
        };
        function l() {
          var h;
          return a ? (a -= 1, h = o[a]) : h = r(), h;
        }
        function d(h) {
          a === s && (o = pooling.double(o), s *= 2), n && n(h), o[a] = h, a += 1;
        }
        return c;
      };
    }(), bezierLengthPool = function() {
      function t() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, t);
    }(), segmentsLengthPool = function() {
      function t() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function r(n) {
        var a, s = n.lengths.length;
        for (a = 0; a < s; a += 1)
          bezierLengthPool.release(n.lengths[a]);
        n.lengths.length = 0;
      }
      return poolFactory(8, t, r);
    }();
    function bezFunction() {
      var t = Math;
      function r(m, g, v, y, x, _) {
        var $ = m * y + g * x + v * _ - x * y - _ * m - v * g;
        return $ > -1e-3 && $ < 1e-3;
      }
      function n(m, g, v, y, x, _, $, b, M) {
        if (v === 0 && _ === 0 && M === 0)
          return r(m, g, y, x, $, b);
        var C = t.sqrt(t.pow(y - m, 2) + t.pow(x - g, 2) + t.pow(_ - v, 2)), S = t.sqrt(t.pow($ - m, 2) + t.pow(b - g, 2) + t.pow(M - v, 2)), A = t.sqrt(t.pow($ - y, 2) + t.pow(b - x, 2) + t.pow(M - _, 2)), D;
        return C > S ? C > A ? D = C - S - A : D = A - S - C : A > S ? D = A - S - C : D = S - C - A, D > -1e-4 && D < 1e-4;
      }
      var a = function() {
        return function(m, g, v, y) {
          var x = getDefaultCurveSegments(), _, $, b, M, C, S = 0, A, D = [], N = [], T = bezierLengthPool.newElement();
          for (b = v.length, _ = 0; _ < x; _ += 1) {
            for (C = _ / (x - 1), A = 0, $ = 0; $ < b; $ += 1)
              M = bmPow(1 - C, 3) * m[$] + 3 * bmPow(1 - C, 2) * C * v[$] + 3 * (1 - C) * bmPow(C, 2) * y[$] + bmPow(C, 3) * g[$], D[$] = M, N[$] !== null && (A += bmPow(D[$] - N[$], 2)), N[$] = D[$];
            A && (A = bmSqrt(A), S += A), T.percents[_] = C, T.lengths[_] = S;
          }
          return T.addedLength = S, T;
        };
      }();
      function s(m) {
        var g = segmentsLengthPool.newElement(), v = m.c, y = m.v, x = m.o, _ = m.i, $, b = m._length, M = g.lengths, C = 0;
        for ($ = 0; $ < b - 1; $ += 1)
          M[$] = a(y[$], y[$ + 1], x[$], _[$ + 1]), C += M[$].addedLength;
        return v && b && (M[$] = a(y[$], y[0], x[$], _[0]), C += M[$].addedLength), g.totalLength = C, g;
      }
      function o(m) {
        this.segmentLength = 0, this.points = new Array(m);
      }
      function c(m, g) {
        this.partialLength = m, this.point = g;
      }
      var l = function() {
        var m = {};
        return function(g, v, y, x) {
          var _ = (g[0] + "_" + g[1] + "_" + v[0] + "_" + v[1] + "_" + y[0] + "_" + y[1] + "_" + x[0] + "_" + x[1]).replace(/\./g, "p");
          if (!m[_]) {
            var $ = getDefaultCurveSegments(), b, M, C, S, A, D = 0, N, T, R = null;
            g.length === 2 && (g[0] !== v[0] || g[1] !== v[1]) && r(g[0], g[1], v[0], v[1], g[0] + y[0], g[1] + y[1]) && r(g[0], g[1], v[0], v[1], v[0] + x[0], v[1] + x[1]) && ($ = 2);
            var F = new o($);
            for (C = y.length, b = 0; b < $; b += 1) {
              for (T = createSizedArray(C), A = b / ($ - 1), N = 0, M = 0; M < C; M += 1)
                S = bmPow(1 - A, 3) * g[M] + 3 * bmPow(1 - A, 2) * A * (g[M] + y[M]) + 3 * (1 - A) * bmPow(A, 2) * (v[M] + x[M]) + bmPow(A, 3) * v[M], T[M] = S, R !== null && (N += bmPow(T[M] - R[M], 2));
              N = bmSqrt(N), D += N, F.points[b] = new c(N, T), R = T;
            }
            F.segmentLength = D, m[_] = F;
          }
          return m[_];
        };
      }();
      function d(m, g) {
        var v = g.percents, y = g.lengths, x = v.length, _ = bmFloor((x - 1) * m), $ = m * g.addedLength, b = 0;
        if (_ === x - 1 || _ === 0 || $ === y[_])
          return v[_];
        for (var M = y[_] > $ ? -1 : 1, C = !0; C; )
          if (y[_] <= $ && y[_ + 1] > $ ? (b = ($ - y[_]) / (y[_ + 1] - y[_]), C = !1) : _ += M, _ < 0 || _ >= x - 1) {
            if (_ === x - 1)
              return v[_];
            C = !1;
          }
        return v[_] + (v[_ + 1] - v[_]) * b;
      }
      function h(m, g, v, y, x, _) {
        var $ = d(x, _), b = 1 - $, M = t.round((b * b * b * m[0] + ($ * b * b + b * $ * b + b * b * $) * v[0] + ($ * $ * b + b * $ * $ + $ * b * $) * y[0] + $ * $ * $ * g[0]) * 1e3) / 1e3, C = t.round((b * b * b * m[1] + ($ * b * b + b * $ * b + b * b * $) * v[1] + ($ * $ * b + b * $ * $ + $ * b * $) * y[1] + $ * $ * $ * g[1]) * 1e3) / 1e3;
        return [M, C];
      }
      var u = createTypedArray("float32", 8);
      function p(m, g, v, y, x, _, $) {
        x < 0 ? x = 0 : x > 1 && (x = 1);
        var b = d(x, $);
        _ = _ > 1 ? 1 : _;
        var M = d(_, $), C, S = m.length, A = 1 - b, D = 1 - M, N = A * A * A, T = b * A * A * 3, R = b * b * A * 3, F = b * b * b, z = A * A * D, O = b * A * D + A * b * D + A * A * M, G = b * b * D + A * b * M + b * A * M, I = b * b * M, k = A * D * D, B = b * D * D + A * M * D + A * D * M, L = b * M * D + A * M * M + b * D * M, V = b * M * M, U = D * D * D, J = M * D * D + D * M * D + D * D * M, q = M * M * D + D * M * M + M * D * M, Z = M * M * M;
        for (C = 0; C < S; C += 1)
          u[C * 4] = t.round((N * m[C] + T * v[C] + R * y[C] + F * g[C]) * 1e3) / 1e3, u[C * 4 + 1] = t.round((z * m[C] + O * v[C] + G * y[C] + I * g[C]) * 1e3) / 1e3, u[C * 4 + 2] = t.round((k * m[C] + B * v[C] + L * y[C] + V * g[C]) * 1e3) / 1e3, u[C * 4 + 3] = t.round((U * m[C] + J * v[C] + q * y[C] + Z * g[C]) * 1e3) / 1e3;
        return u;
      }
      return {
        getSegmentsLength: s,
        getNewSegment: p,
        getPointInSegment: h,
        buildBezierData: l,
        pointOnLine2D: r,
        pointOnLine3D: n
      };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(t, r) {
      var n = this.offsetTime, a;
      this.propType === "multidimensional" && (a = createTypedArray("float32", this.pv.length));
      for (var s = r.lastIndex, o = s, c = this.keyframes.length - 1, l = !0, d, h, u; l; ) {
        if (d = this.keyframes[o], h = this.keyframes[o + 1], o === c - 1 && t >= h.t - n) {
          d.h && (d = h), s = 0;
          break;
        }
        if (h.t - n > t) {
          s = o;
          break;
        }
        o < c - 1 ? o += 1 : (s = 0, l = !1);
      }
      u = this.keyframesMetadata[o] || {};
      var p, m, g, v, y, x, _ = h.t - n, $ = d.t - n, b;
      if (d.to) {
        u.bezierData || (u.bezierData = bez.buildBezierData(d.s, h.s || d.e, d.to, d.ti));
        var M = u.bezierData;
        if (t >= _ || t < $) {
          var C = t >= _ ? M.points.length - 1 : 0;
          for (m = M.points[C].point.length, p = 0; p < m; p += 1)
            a[p] = M.points[C].point[p];
        } else {
          u.__fnct ? x = u.__fnct : (x = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y, d.n).get, u.__fnct = x), g = x((t - $) / (_ - $));
          var S = M.segmentLength * g, A, D = r.lastFrame < t && r._lastKeyframeIndex === o ? r._lastAddedLength : 0;
          for (y = r.lastFrame < t && r._lastKeyframeIndex === o ? r._lastPoint : 0, l = !0, v = M.points.length; l; ) {
            if (D += M.points[y].partialLength, S === 0 || g === 0 || y === M.points.length - 1) {
              for (m = M.points[y].point.length, p = 0; p < m; p += 1)
                a[p] = M.points[y].point[p];
              break;
            } else if (S >= D && S < D + M.points[y + 1].partialLength) {
              for (A = (S - D) / M.points[y + 1].partialLength, m = M.points[y].point.length, p = 0; p < m; p += 1)
                a[p] = M.points[y].point[p] + (M.points[y + 1].point[p] - M.points[y].point[p]) * A;
              break;
            }
            y < v - 1 ? y += 1 : l = !1;
          }
          r._lastPoint = y, r._lastAddedLength = D - M.points[y].partialLength, r._lastKeyframeIndex = o;
        }
      } else {
        var N, T, R, F, z;
        if (c = d.s.length, b = h.s || d.e, this.sh && d.h !== 1)
          if (t >= _)
            a[0] = b[0], a[1] = b[1], a[2] = b[2];
          else if (t <= $)
            a[0] = d.s[0], a[1] = d.s[1], a[2] = d.s[2];
          else {
            var O = createQuaternion(d.s), G = createQuaternion(b), I = (t - $) / (_ - $);
            quaternionToEuler(a, slerp(O, G, I));
          }
        else
          for (o = 0; o < c; o += 1)
            d.h !== 1 && (t >= _ ? g = 1 : t < $ ? g = 0 : (d.o.x.constructor === Array ? (u.__fnct || (u.__fnct = []), u.__fnct[o] ? x = u.__fnct[o] : (N = d.o.x[o] === void 0 ? d.o.x[0] : d.o.x[o], T = d.o.y[o] === void 0 ? d.o.y[0] : d.o.y[o], R = d.i.x[o] === void 0 ? d.i.x[0] : d.i.x[o], F = d.i.y[o] === void 0 ? d.i.y[0] : d.i.y[o], x = BezierFactory.getBezierEasing(N, T, R, F).get, u.__fnct[o] = x)) : u.__fnct ? x = u.__fnct : (N = d.o.x, T = d.o.y, R = d.i.x, F = d.i.y, x = BezierFactory.getBezierEasing(N, T, R, F).get, d.keyframeMetadata = x), g = x((t - $) / (_ - $)))), b = h.s || d.e, z = d.h === 1 ? d.s[o] : d.s[o] + (b[o] - d.s[o]) * g, this.propType === "multidimensional" ? a[o] = z : a = z;
      }
      return r.lastIndex = s, a;
    }
    function slerp(t, r, n) {
      var a = [], s = t[0], o = t[1], c = t[2], l = t[3], d = r[0], h = r[1], u = r[2], p = r[3], m, g, v, y, x;
      return g = s * d + o * h + c * u + l * p, g < 0 && (g = -g, d = -d, h = -h, u = -u, p = -p), 1 - g > 1e-6 ? (m = Math.acos(g), v = Math.sin(m), y = Math.sin((1 - n) * m) / v, x = Math.sin(n * m) / v) : (y = 1 - n, x = n), a[0] = y * s + x * d, a[1] = y * o + x * h, a[2] = y * c + x * u, a[3] = y * l + x * p, a;
    }
    function quaternionToEuler(t, r) {
      var n = r[0], a = r[1], s = r[2], o = r[3], c = Math.atan2(2 * a * o - 2 * n * s, 1 - 2 * a * a - 2 * s * s), l = Math.asin(2 * n * a + 2 * s * o), d = Math.atan2(2 * n * o - 2 * a * s, 1 - 2 * n * n - 2 * s * s);
      t[0] = c / degToRads, t[1] = l / degToRads, t[2] = d / degToRads;
    }
    function createQuaternion(t) {
      var r = t[0] * degToRads, n = t[1] * degToRads, a = t[2] * degToRads, s = Math.cos(r / 2), o = Math.cos(n / 2), c = Math.cos(a / 2), l = Math.sin(r / 2), d = Math.sin(n / 2), h = Math.sin(a / 2), u = s * o * c - l * d * h, p = l * d * c + s * o * h, m = l * o * c + s * d * h, g = s * d * c - l * o * h;
      return [p, m, g, u];
    }
    function getValueAtCurrentTime() {
      var t = this.comp.renderedFrame - this.offsetTime, r = this.keyframes[0].t - this.offsetTime, n = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= n && t >= n || this._caching.lastFrame < r && t < r))) {
        this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var a = this.interpolateValue(t, this._caching);
        this.pv = a;
      }
      return this._caching.lastFrame = t, this.pv;
    }
    function setVValue(t) {
      var r;
      if (this.propType === "unidimensional")
        r = t * this.mult, mathAbs(this.v - r) > 1e-5 && (this.v = r, this._mdf = !0);
      else
        for (var n = 0, a = this.v.length; n < a; )
          r = t[n] * this.mult, mathAbs(this.v[n] - r) > 1e-5 && (this.v[n] = r, this._mdf = !0), n += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var t, r = this.effectsSequence.length, n = this.kf ? this.pv : this.data.k;
        for (t = 0; t < r; t += 1)
          n = this.effectsSequence[t](n);
        this.setVValue(n), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(t) {
      this.effectsSequence.push(t), this.container.addDynamicProperty(this);
    }
    function ValueProperty(t, r, n, a) {
      this.propType = "unidimensional", this.mult = n || 1, this.data = r, this.v = n ? r.k * n : r.k, this.pv = r.k, this._mdf = !1, this.elem = t, this.container = a, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(t, r, n, a) {
      this.propType = "multidimensional", this.mult = n || 1, this.data = r, this._mdf = !1, this.elem = t, this.container = a, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var s, o = r.k.length;
      for (this.v = createTypedArray("float32", o), this.pv = createTypedArray("float32", o), this.vel = createTypedArray("float32", o), s = 0; s < o; s += 1)
        this.v[s] = r.k[s] * this.mult, this.pv[s] = r.k[s];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(t, r, n, a) {
      this.propType = "unidimensional", this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = r, this.mult = n || 1, this.elem = t, this.container = a, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(t, r, n, a) {
      this.propType = "multidimensional";
      var s, o = r.k.length, c, l, d, h;
      for (s = 0; s < o - 1; s += 1)
        r.k[s].to && r.k[s].s && r.k[s + 1] && r.k[s + 1].s && (c = r.k[s].s, l = r.k[s + 1].s, d = r.k[s].to, h = r.k[s].ti, (c.length === 2 && !(c[0] === l[0] && c[1] === l[1]) && bez.pointOnLine2D(c[0], c[1], l[0], l[1], c[0] + d[0], c[1] + d[1]) && bez.pointOnLine2D(c[0], c[1], l[0], l[1], l[0] + h[0], l[1] + h[1]) || c.length === 3 && !(c[0] === l[0] && c[1] === l[1] && c[2] === l[2]) && bez.pointOnLine3D(c[0], c[1], c[2], l[0], l[1], l[2], c[0] + d[0], c[1] + d[1], c[2] + d[2]) && bez.pointOnLine3D(c[0], c[1], c[2], l[0], l[1], l[2], l[0] + h[0], l[1] + h[1], l[2] + h[2])) && (r.k[s].to = null, r.k[s].ti = null), c[0] === l[0] && c[1] === l[1] && d[0] === 0 && d[1] === 0 && h[0] === 0 && h[1] === 0 && (c.length === 2 || c[2] === l[2] && d[2] === 0 && h[2] === 0) && (r.k[s].to = null, r.k[s].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = r, this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = n || 1, this.elem = t, this.container = a, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var u = r.k[0].s.length;
      for (this.v = createTypedArray("float32", u), this.pv = createTypedArray("float32", u), s = 0; s < u; s += 1)
        this.v[s] = initFrame, this.pv[s] = initFrame;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", u)
      }, this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
      function t(n, a, s, o, c) {
        a.sid && (a = n.globalData.slotManager.getProp(a));
        var l;
        if (!a.k.length)
          l = new ValueProperty(n, a, o, c);
        else if (typeof a.k[0] == "number")
          l = new MultiDimensionalProperty(n, a, o, c);
        else
          switch (s) {
            case 0:
              l = new KeyframedValueProperty(n, a, o, c);
              break;
            case 1:
              l = new KeyframedMultidimensionalProperty(n, a, o, c);
              break;
          }
        return l.effectsSequence.length && c.addDynamicProperty(l), l;
      }
      var r = {
        getProp: t
      };
      return r;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(r) {
        this.dynamicProperties.indexOf(r) === -1 && (this.dynamicProperties.push(r), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var r, n = this.dynamicProperties.length;
        for (r = 0; r < n; r += 1)
          this.dynamicProperties[r].getValue(), this.dynamicProperties[r]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(r) {
        this.container = r, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function t() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, t);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(t, r) {
      this.c = t, this.setLength(r);
      for (var n = 0; n < r; )
        this.v[n] = pointPool.newElement(), this.o[n] = pointPool.newElement(), this.i[n] = pointPool.newElement(), n += 1;
    }, ShapePath.prototype.setLength = function(t) {
      for (; this._maxLength < t; )
        this.doubleArrayLength();
      this._length = t;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(t, r, n, a, s) {
      var o;
      switch (this._length = Math.max(this._length, a + 1), this._length >= this._maxLength && this.doubleArrayLength(), n) {
        case "v":
          o = this.v;
          break;
        case "i":
          o = this.i;
          break;
        case "o":
          o = this.o;
          break;
        default:
          o = [];
          break;
      }
      (!o[a] || o[a] && !s) && (o[a] = pointPool.newElement()), o[a][0] = t, o[a][1] = r;
    }, ShapePath.prototype.setTripleAt = function(t, r, n, a, s, o, c, l) {
      this.setXYAt(t, r, "v", c, l), this.setXYAt(n, a, "o", c, l), this.setXYAt(s, o, "i", c, l);
    }, ShapePath.prototype.reverse = function() {
      var t = new ShapePath();
      t.setPathData(this.c, this._length);
      var r = this.v, n = this.o, a = this.i, s = 0;
      this.c && (t.setTripleAt(r[0][0], r[0][1], a[0][0], a[0][1], n[0][0], n[0][1], 0, !1), s = 1);
      var o = this._length - 1, c = this._length, l;
      for (l = s; l < c; l += 1)
        t.setTripleAt(r[o][0], r[o][1], a[o][0], a[o][1], n[o][0], n[o][1], l, !1), o -= 1;
      return t;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function t() {
        return new ShapePath();
      }
      function r(s) {
        var o = s._length, c;
        for (c = 0; c < o; c += 1)
          pointPool.release(s.v[c]), pointPool.release(s.i[c]), pointPool.release(s.o[c]), s.v[c] = null, s.i[c] = null, s.o[c] = null;
        s._length = 0, s.c = !1;
      }
      function n(s) {
        var o = a.newElement(), c, l = s._length === void 0 ? s.v.length : s._length;
        for (o.setLength(l), o.c = s.c, c = 0; c < l; c += 1)
          o.setTripleAt(s.v[c][0], s.v[c][1], s.o[c][0], s.o[c][1], s.i[c][0], s.i[c][1], c);
        return o;
      }
      var a = poolFactory(4, t, r);
      return a.clone = n, a;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(t) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var t;
      for (t = 0; t < this._length; t += 1)
        shapePool.release(this.shapes[t]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var t = {
        newShapeCollection: s,
        release: o
      }, r = 0, n = 4, a = createSizedArray(n);
      function s() {
        var c;
        return r ? (r -= 1, c = a[r]) : c = new ShapeCollection(), c;
      }
      function o(c) {
        var l, d = c._length;
        for (l = 0; l < d; l += 1)
          shapePool.release(c.shapes[l]);
        c._length = 0, r === n && (a = pooling.double(a), n *= 2), a[r] = c, r += 1;
      }
      return t;
    }(), ShapePropertyFactory = function() {
      var t = -999999;
      function r(_, $, b) {
        var M = b.lastIndex, C, S, A, D, N, T, R, F, z, O = this.keyframes;
        if (_ < O[0].t - this.offsetTime)
          C = O[0].s[0], A = !0, M = 0;
        else if (_ >= O[O.length - 1].t - this.offsetTime)
          C = O[O.length - 1].s ? O[O.length - 1].s[0] : O[O.length - 2].e[0], A = !0;
        else {
          for (var G = M, I = O.length - 1, k = !0, B, L, V; k && (B = O[G], L = O[G + 1], !(L.t - this.offsetTime > _)); )
            G < I - 1 ? G += 1 : k = !1;
          if (V = this.keyframesMetadata[G] || {}, A = B.h === 1, M = G, !A) {
            if (_ >= L.t - this.offsetTime)
              F = 1;
            else if (_ < B.t - this.offsetTime)
              F = 0;
            else {
              var U;
              V.__fnct ? U = V.__fnct : (U = BezierFactory.getBezierEasing(B.o.x, B.o.y, B.i.x, B.i.y).get, V.__fnct = U), F = U((_ - (B.t - this.offsetTime)) / (L.t - this.offsetTime - (B.t - this.offsetTime)));
            }
            S = L.s ? L.s[0] : B.e[0];
          }
          C = B.s[0];
        }
        for (T = $._length, R = C.i[0].length, b.lastIndex = M, D = 0; D < T; D += 1)
          for (N = 0; N < R; N += 1)
            z = A ? C.i[D][N] : C.i[D][N] + (S.i[D][N] - C.i[D][N]) * F, $.i[D][N] = z, z = A ? C.o[D][N] : C.o[D][N] + (S.o[D][N] - C.o[D][N]) * F, $.o[D][N] = z, z = A ? C.v[D][N] : C.v[D][N] + (S.v[D][N] - C.v[D][N]) * F, $.v[D][N] = z;
      }
      function n() {
        var _ = this.comp.renderedFrame - this.offsetTime, $ = this.keyframes[0].t - this.offsetTime, b = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, M = this._caching.lastFrame;
        return M !== t && (M < $ && _ < $ || M > b && _ > b) || (this._caching.lastIndex = M < _ ? this._caching.lastIndex : 0, this.interpolateShape(_, this.pv, this._caching)), this._caching.lastFrame = _, this.pv;
      }
      function a() {
        this.paths = this.localShapeCollection;
      }
      function s(_, $) {
        if (_._length !== $._length || _.c !== $.c)
          return !1;
        var b, M = _._length;
        for (b = 0; b < M; b += 1)
          if (_.v[b][0] !== $.v[b][0] || _.v[b][1] !== $.v[b][1] || _.o[b][0] !== $.o[b][0] || _.o[b][1] !== $.o[b][1] || _.i[b][0] !== $.i[b][0] || _.i[b][1] !== $.i[b][1])
            return !1;
        return !0;
      }
      function o(_) {
        s(this.v, _) || (this.v = shapePool.clone(_), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function c() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var _;
          this.kf ? _ = this.pv : this.data.ks ? _ = this.data.ks.k : _ = this.data.pt.k;
          var $, b = this.effectsSequence.length;
          for ($ = 0; $ < b; $ += 1)
            _ = this.effectsSequence[$](_);
          this.setVValue(_), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function l(_, $, b) {
        this.propType = "shape", this.comp = _.comp, this.container = _, this.elem = _, this.data = $, this.k = !1, this.kf = !1, this._mdf = !1;
        var M = b === 3 ? $.pt.k : $.ks.k;
        this.v = shapePool.clone(M), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = a, this.effectsSequence = [];
      }
      function d(_) {
        this.effectsSequence.push(_), this.container.addDynamicProperty(this);
      }
      l.prototype.interpolateShape = r, l.prototype.getValue = c, l.prototype.setVValue = o, l.prototype.addEffect = d;
      function h(_, $, b) {
        this.propType = "shape", this.comp = _.comp, this.elem = _, this.container = _, this.offsetTime = _.data.st, this.keyframes = b === 3 ? $.pt.k : $.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var M = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, M), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t, this.reset = a, this._caching = {
          lastFrame: t,
          lastIndex: 0
        }, this.effectsSequence = [n.bind(this)];
      }
      h.prototype.getValue = c, h.prototype.interpolateShape = r, h.prototype.setVValue = o, h.prototype.addEffect = d;
      var u = function() {
        var _ = roundCorner;
        function $(b, M) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = M.d, this.elem = b, this.comp = b.comp, this.frameId = -1, this.initDynamicPropertyContainer(b), this.p = PropertyFactory.getProp(b, M.p, 1, 0, this), this.s = PropertyFactory.getProp(b, M.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return $.prototype = {
          reset: a,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var M = this.p.v[0], C = this.p.v[1], S = this.s.v[0] / 2, A = this.s.v[1] / 2, D = this.d !== 3, N = this.v;
            N.v[0][0] = M, N.v[0][1] = C - A, N.v[1][0] = D ? M + S : M - S, N.v[1][1] = C, N.v[2][0] = M, N.v[2][1] = C + A, N.v[3][0] = D ? M - S : M + S, N.v[3][1] = C, N.i[0][0] = D ? M - S * _ : M + S * _, N.i[0][1] = C - A, N.i[1][0] = D ? M + S : M - S, N.i[1][1] = C - A * _, N.i[2][0] = D ? M + S * _ : M - S * _, N.i[2][1] = C + A, N.i[3][0] = D ? M - S : M + S, N.i[3][1] = C + A * _, N.o[0][0] = D ? M + S * _ : M - S * _, N.o[0][1] = C - A, N.o[1][0] = D ? M + S : M - S, N.o[1][1] = C + A * _, N.o[2][0] = D ? M - S * _ : M + S * _, N.o[2][1] = C + A, N.o[3][0] = D ? M - S : M + S, N.o[3][1] = C - A * _;
          }
        }, extendPrototype([DynamicPropertyContainer], $), $;
      }(), p = function() {
        function _($, b) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = $, this.comp = $.comp, this.data = b, this.frameId = -1, this.d = b.d, this.initDynamicPropertyContainer($), b.sy === 1 ? (this.ir = PropertyFactory.getProp($, b.ir, 0, 0, this), this.is = PropertyFactory.getProp($, b.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp($, b.pt, 0, 0, this), this.p = PropertyFactory.getProp($, b.p, 1, 0, this), this.r = PropertyFactory.getProp($, b.r, 0, degToRads, this), this.or = PropertyFactory.getProp($, b.or, 0, 0, this), this.os = PropertyFactory.getProp($, b.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return _.prototype = {
          reset: a,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var b = Math.floor(this.pt.v) * 2, M = Math.PI * 2 / b, C = !0, S = this.or.v, A = this.ir.v, D = this.os.v, N = this.is.v, T = 2 * Math.PI * S / (b * 2), R = 2 * Math.PI * A / (b * 2), F, z, O, G, I = -Math.PI / 2;
            I += this.r.v;
            var k = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, F = 0; F < b; F += 1) {
              z = C ? S : A, O = C ? D : N, G = C ? T : R;
              var B = z * Math.cos(I), L = z * Math.sin(I), V = B === 0 && L === 0 ? 0 : L / Math.sqrt(B * B + L * L), U = B === 0 && L === 0 ? 0 : -B / Math.sqrt(B * B + L * L);
              B += +this.p.v[0], L += +this.p.v[1], this.v.setTripleAt(B, L, B - V * G * O * k, L - U * G * O * k, B + V * G * O * k, L + U * G * O * k, F, !0), C = !C, I += M * k;
            }
          },
          convertPolygonToPath: function() {
            var b = Math.floor(this.pt.v), M = Math.PI * 2 / b, C = this.or.v, S = this.os.v, A = 2 * Math.PI * C / (b * 4), D, N = -Math.PI * 0.5, T = this.data.d === 3 ? -1 : 1;
            for (N += this.r.v, this.v._length = 0, D = 0; D < b; D += 1) {
              var R = C * Math.cos(N), F = C * Math.sin(N), z = R === 0 && F === 0 ? 0 : F / Math.sqrt(R * R + F * F), O = R === 0 && F === 0 ? 0 : -R / Math.sqrt(R * R + F * F);
              R += +this.p.v[0], F += +this.p.v[1], this.v.setTripleAt(R, F, R - z * A * S * T, F - O * A * S * T, R + z * A * S * T, F + O * A * S * T, D, !0), N += M * T;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], _), _;
      }(), m = function() {
        function _($, b) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = $, this.comp = $.comp, this.frameId = -1, this.d = b.d, this.initDynamicPropertyContainer($), this.p = PropertyFactory.getProp($, b.p, 1, 0, this), this.s = PropertyFactory.getProp($, b.s, 1, 0, this), this.r = PropertyFactory.getProp($, b.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return _.prototype = {
          convertRectToPath: function() {
            var b = this.p.v[0], M = this.p.v[1], C = this.s.v[0] / 2, S = this.s.v[1] / 2, A = bmMin(C, S, this.r.v), D = A * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(b + C, M - S + A, b + C, M - S + A, b + C, M - S + D, 0, !0), this.v.setTripleAt(b + C, M + S - A, b + C, M + S - D, b + C, M + S - A, 1, !0), A !== 0 ? (this.v.setTripleAt(b + C - A, M + S, b + C - A, M + S, b + C - D, M + S, 2, !0), this.v.setTripleAt(b - C + A, M + S, b - C + D, M + S, b - C + A, M + S, 3, !0), this.v.setTripleAt(b - C, M + S - A, b - C, M + S - A, b - C, M + S - D, 4, !0), this.v.setTripleAt(b - C, M - S + A, b - C, M - S + D, b - C, M - S + A, 5, !0), this.v.setTripleAt(b - C + A, M - S, b - C + A, M - S, b - C + D, M - S, 6, !0), this.v.setTripleAt(b + C - A, M - S, b + C - D, M - S, b + C - A, M - S, 7, !0)) : (this.v.setTripleAt(b - C, M + S, b - C + D, M + S, b - C, M + S, 2), this.v.setTripleAt(b - C, M - S, b - C, M - S + D, b - C, M - S, 3))) : (this.v.setTripleAt(b + C, M - S + A, b + C, M - S + D, b + C, M - S + A, 0, !0), A !== 0 ? (this.v.setTripleAt(b + C - A, M - S, b + C - A, M - S, b + C - D, M - S, 1, !0), this.v.setTripleAt(b - C + A, M - S, b - C + D, M - S, b - C + A, M - S, 2, !0), this.v.setTripleAt(b - C, M - S + A, b - C, M - S + A, b - C, M - S + D, 3, !0), this.v.setTripleAt(b - C, M + S - A, b - C, M + S - D, b - C, M + S - A, 4, !0), this.v.setTripleAt(b - C + A, M + S, b - C + A, M + S, b - C + D, M + S, 5, !0), this.v.setTripleAt(b + C - A, M + S, b + C - D, M + S, b + C - A, M + S, 6, !0), this.v.setTripleAt(b + C, M + S - A, b + C, M + S - A, b + C, M + S - D, 7, !0)) : (this.v.setTripleAt(b - C, M - S, b - C + D, M - S, b - C, M - S, 1, !0), this.v.setTripleAt(b - C, M + S, b - C, M + S - D, b - C, M + S, 2, !0), this.v.setTripleAt(b + C, M + S, b + C - D, M + S, b + C, M + S, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: a
        }, extendPrototype([DynamicPropertyContainer], _), _;
      }();
      function g(_, $, b) {
        var M;
        if (b === 3 || b === 4) {
          var C = b === 3 ? $.pt : $.ks, S = C.k;
          S.length ? M = new h(_, $, b) : M = new l(_, $, b);
        } else
          b === 5 ? M = new m(_, $) : b === 6 ? M = new u(_, $) : b === 7 && (M = new p(_, $));
        return M.k && _.addDynamicProperty(M), M;
      }
      function v() {
        return l;
      }
      function y() {
        return h;
      }
      var x = {};
      return x.getShapeProp = g, x.getConstructorFunction = v, x.getKeyframedConstructorFunction = y, x;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = function() {
      var t = Math.cos, r = Math.sin, n = Math.tan, a = Math.round;
      function s() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function o(B) {
        if (B === 0)
          return this;
        var L = t(B), V = r(B);
        return this._t(L, -V, 0, 0, V, L, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function c(B) {
        if (B === 0)
          return this;
        var L = t(B), V = r(B);
        return this._t(1, 0, 0, 0, 0, L, -V, 0, 0, V, L, 0, 0, 0, 0, 1);
      }
      function l(B) {
        if (B === 0)
          return this;
        var L = t(B), V = r(B);
        return this._t(L, 0, V, 0, 0, 1, 0, 0, -V, 0, L, 0, 0, 0, 0, 1);
      }
      function d(B) {
        if (B === 0)
          return this;
        var L = t(B), V = r(B);
        return this._t(L, -V, 0, 0, V, L, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function h(B, L) {
        return this._t(1, L, B, 1, 0, 0);
      }
      function u(B, L) {
        return this.shear(n(B), n(L));
      }
      function p(B, L) {
        var V = t(L), U = r(L);
        return this._t(V, U, 0, 0, -U, V, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, n(B), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(V, -U, 0, 0, U, V, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function m(B, L, V) {
        return !V && V !== 0 && (V = 1), B === 1 && L === 1 && V === 1 ? this : this._t(B, 0, 0, 0, 0, L, 0, 0, 0, 0, V, 0, 0, 0, 0, 1);
      }
      function g(B, L, V, U, J, q, Z, ae, ee, se, nr, ce, oe, ur, ir, _r) {
        return this.props[0] = B, this.props[1] = L, this.props[2] = V, this.props[3] = U, this.props[4] = J, this.props[5] = q, this.props[6] = Z, this.props[7] = ae, this.props[8] = ee, this.props[9] = se, this.props[10] = nr, this.props[11] = ce, this.props[12] = oe, this.props[13] = ur, this.props[14] = ir, this.props[15] = _r, this;
      }
      function v(B, L, V) {
        return V = V || 0, B !== 0 || L !== 0 || V !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, B, L, V, 1) : this;
      }
      function y(B, L, V, U, J, q, Z, ae, ee, se, nr, ce, oe, ur, ir, _r) {
        var yr = this.props;
        if (B === 1 && L === 0 && V === 0 && U === 0 && J === 0 && q === 1 && Z === 0 && ae === 0 && ee === 0 && se === 0 && nr === 1 && ce === 0)
          return yr[12] = yr[12] * B + yr[15] * oe, yr[13] = yr[13] * q + yr[15] * ur, yr[14] = yr[14] * nr + yr[15] * ir, yr[15] *= _r, this._identityCalculated = !1, this;
        var ne = yr[0], pe = yr[1], hr = yr[2], $r = yr[3], Sr = yr[4], ze = yr[5], cr = yr[6], fr = yr[7], mr = yr[8], wr = yr[9], Nr = yr[10], xr = yr[11], Er = yr[12], Ir = yr[13], Rr = yr[14], Yr = yr[15];
        return yr[0] = ne * B + pe * J + hr * ee + $r * oe, yr[1] = ne * L + pe * q + hr * se + $r * ur, yr[2] = ne * V + pe * Z + hr * nr + $r * ir, yr[3] = ne * U + pe * ae + hr * ce + $r * _r, yr[4] = Sr * B + ze * J + cr * ee + fr * oe, yr[5] = Sr * L + ze * q + cr * se + fr * ur, yr[6] = Sr * V + ze * Z + cr * nr + fr * ir, yr[7] = Sr * U + ze * ae + cr * ce + fr * _r, yr[8] = mr * B + wr * J + Nr * ee + xr * oe, yr[9] = mr * L + wr * q + Nr * se + xr * ur, yr[10] = mr * V + wr * Z + Nr * nr + xr * ir, yr[11] = mr * U + wr * ae + Nr * ce + xr * _r, yr[12] = Er * B + Ir * J + Rr * ee + Yr * oe, yr[13] = Er * L + Ir * q + Rr * se + Yr * ur, yr[14] = Er * V + Ir * Z + Rr * nr + Yr * ir, yr[15] = Er * U + Ir * ae + Rr * ce + Yr * _r, this._identityCalculated = !1, this;
      }
      function x(B) {
        var L = B.props;
        return this.transform(L[0], L[1], L[2], L[3], L[4], L[5], L[6], L[7], L[8], L[9], L[10], L[11], L[12], L[13], L[14], L[15]);
      }
      function _() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function $(B) {
        for (var L = 0; L < 16; ) {
          if (B.props[L] !== this.props[L])
            return !1;
          L += 1;
        }
        return !0;
      }
      function b(B) {
        var L;
        for (L = 0; L < 16; L += 1)
          B.props[L] = this.props[L];
        return B;
      }
      function M(B) {
        var L;
        for (L = 0; L < 16; L += 1)
          this.props[L] = B[L];
      }
      function C(B, L, V) {
        return {
          x: B * this.props[0] + L * this.props[4] + V * this.props[8] + this.props[12],
          y: B * this.props[1] + L * this.props[5] + V * this.props[9] + this.props[13],
          z: B * this.props[2] + L * this.props[6] + V * this.props[10] + this.props[14]
        };
      }
      function S(B, L, V) {
        return B * this.props[0] + L * this.props[4] + V * this.props[8] + this.props[12];
      }
      function A(B, L, V) {
        return B * this.props[1] + L * this.props[5] + V * this.props[9] + this.props[13];
      }
      function D(B, L, V) {
        return B * this.props[2] + L * this.props[6] + V * this.props[10] + this.props[14];
      }
      function N() {
        var B = this.props[0] * this.props[5] - this.props[1] * this.props[4], L = this.props[5] / B, V = -this.props[1] / B, U = -this.props[4] / B, J = this.props[0] / B, q = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / B, Z = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / B, ae = new Matrix();
        return ae.props[0] = L, ae.props[1] = V, ae.props[4] = U, ae.props[5] = J, ae.props[12] = q, ae.props[13] = Z, ae;
      }
      function T(B) {
        var L = this.getInverseMatrix();
        return L.applyToPointArray(B[0], B[1], B[2] || 0);
      }
      function R(B) {
        var L, V = B.length, U = [];
        for (L = 0; L < V; L += 1)
          U[L] = T(B[L]);
        return U;
      }
      function F(B, L, V) {
        var U = createTypedArray("float32", 6);
        if (this.isIdentity())
          U[0] = B[0], U[1] = B[1], U[2] = L[0], U[3] = L[1], U[4] = V[0], U[5] = V[1];
        else {
          var J = this.props[0], q = this.props[1], Z = this.props[4], ae = this.props[5], ee = this.props[12], se = this.props[13];
          U[0] = B[0] * J + B[1] * Z + ee, U[1] = B[0] * q + B[1] * ae + se, U[2] = L[0] * J + L[1] * Z + ee, U[3] = L[0] * q + L[1] * ae + se, U[4] = V[0] * J + V[1] * Z + ee, U[5] = V[0] * q + V[1] * ae + se;
        }
        return U;
      }
      function z(B, L, V) {
        var U;
        return this.isIdentity() ? U = [B, L, V] : U = [B * this.props[0] + L * this.props[4] + V * this.props[8] + this.props[12], B * this.props[1] + L * this.props[5] + V * this.props[9] + this.props[13], B * this.props[2] + L * this.props[6] + V * this.props[10] + this.props[14]], U;
      }
      function O(B, L) {
        if (this.isIdentity())
          return B + "," + L;
        var V = this.props;
        return Math.round((B * V[0] + L * V[4] + V[12]) * 100) / 100 + "," + Math.round((B * V[1] + L * V[5] + V[13]) * 100) / 100;
      }
      function G() {
        for (var B = 0, L = this.props, V = "matrix3d(", U = 1e4; B < 16; )
          V += a(L[B] * U) / U, V += B === 15 ? ")" : ",", B += 1;
        return V;
      }
      function I(B) {
        var L = 1e4;
        return B < 1e-6 && B > 0 || B > -1e-6 && B < 0 ? a(B * L) / L : B;
      }
      function k() {
        var B = this.props, L = I(B[0]), V = I(B[1]), U = I(B[4]), J = I(B[5]), q = I(B[12]), Z = I(B[13]);
        return "matrix(" + L + "," + V + "," + U + "," + J + "," + q + "," + Z + ")";
      }
      return function() {
        this.reset = s, this.rotate = o, this.rotateX = c, this.rotateY = l, this.rotateZ = d, this.skew = u, this.skewFromAxis = p, this.shear = h, this.scale = m, this.setTransform = g, this.translate = v, this.transform = y, this.multiply = x, this.applyToPoint = C, this.applyToX = S, this.applyToY = A, this.applyToZ = D, this.applyToPointArray = z, this.applyToTriplePoints = F, this.applyToPointStringified = O, this.toCSS = G, this.to2dCSS = k, this.clone = b, this.cloneFromProps = M, this.equals = $, this.inversePoints = R, this.inversePoint = T, this.getInverseMatrix = N, this._t = this.transform, this.isIdentity = _, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(t) {
      "@babel/helpers - typeof";
      return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$3(t);
    }
    var lottie = {};
    function setLocation(t) {
      setLocationHref(t);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(t) {
      setSubframeEnabled(t);
    }
    function setPrefix(t) {
      setIdPrefix(t);
    }
    function loadAnimation(t) {
      return animationManager.loadAnimation(t);
    }
    function setQuality(t) {
      if (typeof t == "string")
        switch (t) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else
        !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(t, r) {
      t === "expressions" && setExpressionsPlugin(r);
    }
    function getFactory(t) {
      switch (t) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.13.0";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(t) {
      for (var r = queryString.split("&"), n = 0; n < r.length; n += 1) {
        var a = r[n].split("=");
        if (decodeURIComponent(a[0]) == t)
          return decodeURIComponent(a[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (t) {
    }
    var ShapeModifiers = function() {
      var t = {}, r = {};
      t.registerModifier = n, t.getModifier = a;
      function n(s, o) {
        r[s] || (r[s] = o);
      }
      function a(s, o, c) {
        return new r[s](o, c);
      }
      return t;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(t) {
      if (!this.closed) {
        t.sh.container.addDynamicProperty(t.sh);
        var r = {
          shape: t.sh,
          data: t,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(r), this.addShapeToModifier(r), this._isAnimated && t.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(t, r) {
      this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, r), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, r) {
      this.s = PropertyFactory.getProp(t, r.s, 0, 0.01, this), this.e = PropertyFactory.getProp(t, r.e, 0, 0.01, this), this.o = PropertyFactory.getProp(t, r.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = r.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(t) {
      t.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(t, r, n, a, s) {
      var o = [];
      r <= 1 ? o.push({
        s: t,
        e: r
      }) : t >= 1 ? o.push({
        s: t - 1,
        e: r - 1
      }) : (o.push({
        s: t,
        e: 1
      }), o.push({
        s: 0,
        e: r - 1
      }));
      var c = [], l, d = o.length, h;
      for (l = 0; l < d; l += 1)
        if (h = o[l], !(h.e * s < a || h.s * s > a + n)) {
          var u, p;
          h.s * s <= a ? u = 0 : u = (h.s * s - a) / n, h.e * s >= a + n ? p = 1 : p = (h.e * s - a) / n, c.push([u, p]);
        }
      return c.length || c.push([0, 0]), c;
    }, TrimModifier.prototype.releasePathsData = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1)
        segmentsLengthPool.release(t[r]);
      return t.length = 0, t;
    }, TrimModifier.prototype.processShapes = function(t) {
      var r, n;
      if (this._mdf || t) {
        var a = this.o.v % 360 / 360;
        if (a < 0 && (a += 1), this.s.v > 1 ? r = 1 + a : this.s.v < 0 ? r = 0 + a : r = this.s.v + a, this.e.v > 1 ? n = 1 + a : this.e.v < 0 ? n = 0 + a : n = this.e.v + a, r > n) {
          var s = r;
          r = n, n = s;
        }
        r = Math.round(r * 1e4) * 1e-4, n = Math.round(n * 1e4) * 1e-4, this.sValue = r, this.eValue = n;
      } else
        r = this.sValue, n = this.eValue;
      var o, c, l = this.shapes.length, d, h, u, p, m, g = 0;
      if (n === r)
        for (c = 0; c < l; c += 1)
          this.shapes[c].localShapeCollection.releaseShapes(), this.shapes[c].shape._mdf = !0, this.shapes[c].shape.paths = this.shapes[c].localShapeCollection, this._mdf && (this.shapes[c].pathsData.length = 0);
      else if (n === 1 && r === 0 || n === 0 && r === 1) {
        if (this._mdf)
          for (c = 0; c < l; c += 1)
            this.shapes[c].pathsData.length = 0, this.shapes[c].shape._mdf = !0;
      } else {
        var v = [], y, x;
        for (c = 0; c < l; c += 1)
          if (y = this.shapes[c], !y.shape._mdf && !this._mdf && !t && this.m !== 2)
            y.shape.paths = y.localShapeCollection;
          else {
            if (o = y.shape.paths, h = o._length, m = 0, !y.shape._mdf && y.pathsData.length)
              m = y.totalShapeLength;
            else {
              for (u = this.releasePathsData(y.pathsData), d = 0; d < h; d += 1)
                p = bez.getSegmentsLength(o.shapes[d]), u.push(p), m += p.totalLength;
              y.totalShapeLength = m, y.pathsData = u;
            }
            g += m, y.shape._mdf = !0;
          }
        var _ = r, $ = n, b = 0, M;
        for (c = l - 1; c >= 0; c -= 1)
          if (y = this.shapes[c], y.shape._mdf) {
            for (x = y.localShapeCollection, x.releaseShapes(), this.m === 2 && l > 1 ? (M = this.calculateShapeEdges(r, n, y.totalShapeLength, b, g), b += y.totalShapeLength) : M = [[_, $]], h = M.length, d = 0; d < h; d += 1) {
              _ = M[d][0], $ = M[d][1], v.length = 0, $ <= 1 ? v.push({
                s: y.totalShapeLength * _,
                e: y.totalShapeLength * $
              }) : _ >= 1 ? v.push({
                s: y.totalShapeLength * (_ - 1),
                e: y.totalShapeLength * ($ - 1)
              }) : (v.push({
                s: y.totalShapeLength * _,
                e: y.totalShapeLength
              }), v.push({
                s: 0,
                e: y.totalShapeLength * ($ - 1)
              }));
              var C = this.addShapes(y, v[0]);
              if (v[0].s !== v[0].e) {
                if (v.length > 1) {
                  var S = y.shape.paths.shapes[y.shape.paths._length - 1];
                  if (S.c) {
                    var A = C.pop();
                    this.addPaths(C, x), C = this.addShapes(y, v[1], A);
                  } else
                    this.addPaths(C, x), C = this.addShapes(y, v[1]);
                }
                this.addPaths(C, x);
              }
            }
            y.shape.paths = x;
          }
      }
    }, TrimModifier.prototype.addPaths = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1)
        r.addShape(t[n]);
    }, TrimModifier.prototype.addSegment = function(t, r, n, a, s, o, c) {
      s.setXYAt(r[0], r[1], "o", o), s.setXYAt(n[0], n[1], "i", o + 1), c && s.setXYAt(t[0], t[1], "v", o), s.setXYAt(a[0], a[1], "v", o + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(t, r, n, a) {
      r.setXYAt(t[1], t[5], "o", n), r.setXYAt(t[2], t[6], "i", n + 1), a && r.setXYAt(t[0], t[4], "v", n), r.setXYAt(t[3], t[7], "v", n + 1);
    }, TrimModifier.prototype.addShapes = function(t, r, n) {
      var a = t.pathsData, s = t.shape.paths.shapes, o, c = t.shape.paths._length, l, d, h = 0, u, p, m, g, v = [], y, x = !0;
      for (n ? (p = n._length, y = n._length) : (n = shapePool.newElement(), p = 0, y = 0), v.push(n), o = 0; o < c; o += 1) {
        for (m = a[o].lengths, n.c = s[o].c, d = s[o].c ? m.length : m.length + 1, l = 1; l < d; l += 1)
          if (u = m[l - 1], h + u.addedLength < r.s)
            h += u.addedLength, n.c = !1;
          else if (h > r.e) {
            n.c = !1;
            break;
          } else
            r.s <= h && r.e >= h + u.addedLength ? (this.addSegment(s[o].v[l - 1], s[o].o[l - 1], s[o].i[l], s[o].v[l], n, p, x), x = !1) : (g = bez.getNewSegment(s[o].v[l - 1], s[o].v[l], s[o].o[l - 1], s[o].i[l], (r.s - h) / u.addedLength, (r.e - h) / u.addedLength, m[l - 1]), this.addSegmentFromArray(g, n, p, x), x = !1, n.c = !1), h += u.addedLength, p += 1;
        if (s[o].c && m.length) {
          if (u = m[l - 1], h <= r.e) {
            var _ = m[l - 1].addedLength;
            r.s <= h && r.e >= h + _ ? (this.addSegment(s[o].v[l - 1], s[o].o[l - 1], s[o].i[0], s[o].v[0], n, p, x), x = !1) : (g = bez.getNewSegment(s[o].v[l - 1], s[o].v[0], s[o].o[l - 1], s[o].i[0], (r.s - h) / _, (r.e - h) / _, m[l - 1]), this.addSegmentFromArray(g, n, p, x), x = !1, n.c = !1);
          } else
            n.c = !1;
          h += u.addedLength, p += 1;
        }
        if (n._length && (n.setXYAt(n.v[y][0], n.v[y][1], "i", y), n.setXYAt(n.v[n._length - 1][0], n.v[n._length - 1][1], "o", n._length - 1)), h > r.e)
          break;
        o < c - 1 && (n = shapePool.newElement(), x = !0, v.push(n), p = 0);
      }
      return v;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, r.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(t, r) {
      var n = r / 100, a = [0, 0], s = t._length, o = 0;
      for (o = 0; o < s; o += 1)
        a[0] += t.v[o][0], a[1] += t.v[o][1];
      a[0] /= s, a[1] /= s;
      var c = shapePool.newElement();
      c.c = t.c;
      var l, d, h, u, p, m;
      for (o = 0; o < s; o += 1)
        l = t.v[o][0] + (a[0] - t.v[o][0]) * n, d = t.v[o][1] + (a[1] - t.v[o][1]) * n, h = t.o[o][0] + (a[0] - t.o[o][0]) * -n, u = t.o[o][1] + (a[1] - t.o[o][1]) * -n, p = t.i[o][0] + (a[0] - t.i[o][0]) * -n, m = t.i[o][1] + (a[1] - t.i[o][1]) * -n, c.setTripleAt(l, d, h, u, p, m, o);
      return c;
    }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
      var r, n, a = this.shapes.length, s, o, c = this.amount.v;
      if (c !== 0) {
        var l, d;
        for (n = 0; n < a; n += 1) {
          if (l = this.shapes[n], d = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !t))
            for (d.releaseShapes(), l.shape._mdf = !0, r = l.shape.paths.shapes, o = l.shape.paths._length, s = 0; s < o; s += 1)
              d.addShape(this.processPath(r[s], c));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var t = [0, 0];
      function r(d) {
        var h = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || h, this.a && d.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && d.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && d.skewFromAxis(-this.sk.v, this.sa.v), this.r ? d.rotate(-this.r.v) : d.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? d.translate(this.px.v, this.py.v, -this.pz.v) : d.translate(this.px.v, this.py.v, 0) : d.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function n(d) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || d) {
            var h;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var u, p;
              if (h = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (u = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / h, 0), p = this.p.getValueAtTime(this.p.keyframes[0].t / h, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (u = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / h, 0), p = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / h, 0)) : (u = this.p.pv, p = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / h, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                u = [], p = [];
                var m = this.px, g = this.py;
                m._caching.lastFrame + m.offsetTime <= m.keyframes[0].t ? (u[0] = m.getValueAtTime((m.keyframes[0].t + 0.01) / h, 0), u[1] = g.getValueAtTime((g.keyframes[0].t + 0.01) / h, 0), p[0] = m.getValueAtTime(m.keyframes[0].t / h, 0), p[1] = g.getValueAtTime(g.keyframes[0].t / h, 0)) : m._caching.lastFrame + m.offsetTime >= m.keyframes[m.keyframes.length - 1].t ? (u[0] = m.getValueAtTime(m.keyframes[m.keyframes.length - 1].t / h, 0), u[1] = g.getValueAtTime(g.keyframes[g.keyframes.length - 1].t / h, 0), p[0] = m.getValueAtTime((m.keyframes[m.keyframes.length - 1].t - 0.01) / h, 0), p[1] = g.getValueAtTime((g.keyframes[g.keyframes.length - 1].t - 0.01) / h, 0)) : (u = [m.pv, g.pv], p[0] = m.getValueAtTime((m._caching.lastFrame + m.offsetTime - 0.01) / h, m.offsetTime), p[1] = g.getValueAtTime((g._caching.lastFrame + g.offsetTime - 0.01) / h, g.offsetTime));
              } else
                p = t, u = p;
              this.v.rotate(-Math.atan2(u[1] - p[1], u[0] - p[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function a() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function s() {
      }
      function o(d) {
        this._addDynamicProperty(d), this.elem.addDynamicProperty(d), this._isDirty = !0;
      }
      function c(d, h, u) {
        if (this.elem = d, this.frameId = -1, this.propType = "transform", this.data = h, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(u || d), h.p && h.p.s ? (this.px = PropertyFactory.getProp(d, h.p.x, 0, 0, this), this.py = PropertyFactory.getProp(d, h.p.y, 0, 0, this), h.p.z && (this.pz = PropertyFactory.getProp(d, h.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(d, h.p || {
          k: [0, 0, 0]
        }, 1, 0, this), h.rx) {
          if (this.rx = PropertyFactory.getProp(d, h.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(d, h.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(d, h.rz, 0, degToRads, this), h.or.k[0].ti) {
            var p, m = h.or.k.length;
            for (p = 0; p < m; p += 1)
              h.or.k[p].to = null, h.or.k[p].ti = null;
          }
          this.or = PropertyFactory.getProp(d, h.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(d, h.r || {
            k: 0
          }, 0, degToRads, this);
        h.sk && (this.sk = PropertyFactory.getProp(d, h.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(d, h.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(d, h.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(d, h.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), h.o ? this.o = PropertyFactory.getProp(d, h.o, 0, 0.01, d) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      c.prototype = {
        applyToMatrix: r,
        getValue: n,
        precalculateMatrix: a,
        autoOrient: s
      }, extendPrototype([DynamicPropertyContainer], c), c.prototype.addDynamicProperty = o, c.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function l(d, h, u) {
        return new c(d, h, u);
      }
      return {
        getTransformProperty: l
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, r.c, 0, null, this), this.o = PropertyFactory.getProp(t, r.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, r.tr, this), this.so = PropertyFactory.getProp(t, r.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(t, r.tr.eo, 0, 0.01, this), this.data = r, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(t, r, n, a, s, o) {
      var c = o ? -1 : 1, l = a.s.v[0] + (1 - a.s.v[0]) * (1 - s), d = a.s.v[1] + (1 - a.s.v[1]) * (1 - s);
      t.translate(a.p.v[0] * c * s, a.p.v[1] * c * s, a.p.v[2]), r.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]), r.rotate(-a.r.v * c * s), r.translate(a.a.v[0], a.a.v[1], a.a.v[2]), n.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]), n.scale(o ? 1 / l : l, o ? 1 / d : d), n.translate(a.a.v[0], a.a.v[1], a.a.v[2]);
    }, RepeaterModifier.prototype.init = function(t, r, n, a) {
      for (this.elem = t, this.arr = r, this.pos = n, this.elemsData = a, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, r[n]); n > 0; )
        n -= 1, this._elements.unshift(r[n]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1)
        t[r]._processed = !1, t[r].ty === "gr" && this.resetElements(t[r].it);
    }, RepeaterModifier.prototype.cloneElements = function(t) {
      var r = JSON.parse(JSON.stringify(t));
      return this.resetElements(r), r;
    }, RepeaterModifier.prototype.changeGroupRender = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1)
        t[n]._render = r, t[n].ty === "gr" && this.changeGroupRender(t[n].it, r);
    }, RepeaterModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, c = !1;
      if (this._mdf || t) {
        var l = Math.ceil(this.c.v);
        if (this._groups.length < l) {
          for (; this._groups.length < l; ) {
            var d = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            d.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, d), this._groups.splice(0, 0, d), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), c = !0;
        }
        o = 0;
        var h;
        for (a = 0; a <= this._groups.length - 1; a += 1) {
          if (h = o < l, this._groups[a]._render = h, this.changeGroupRender(this._groups[a].it, h), !h) {
            var u = this.elemsData[a].it, p = u[u.length - 1];
            p.transform.op.v !== 0 ? (p.transform.op._mdf = !0, p.transform.op.v = 0) : p.transform.op._mdf = !1;
          }
          o += 1;
        }
        this._currentCopies = l;
        var m = this.o.v, g = m % 1, v = m > 0 ? Math.floor(m) : Math.ceil(m), y = this.pMatrix.props, x = this.rMatrix.props, _ = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var $ = 0;
        if (m > 0) {
          for (; $ < v; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), $ += 1;
          g && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, g, !1), $ += g);
        } else if (m < 0) {
          for (; $ > v; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), $ -= 1;
          g && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -g, !0), $ -= g);
        }
        a = this.data.m === 1 ? 0 : this._currentCopies - 1, s = this.data.m === 1 ? 1 : -1, o = this._currentCopies;
        for (var b, M; o; ) {
          if (r = this.elemsData[a].it, n = r[r.length - 1].transform.mProps.v.props, M = n.length, r[r.length - 1].transform.mProps._mdf = !0, r[r.length - 1].transform.op._mdf = !0, r[r.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (a / (this._currentCopies - 1)), $ !== 0) {
            for ((a !== 0 && s === 1 || a !== this._currentCopies - 1 && s === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(x[0], x[1], x[2], x[3], x[4], x[5], x[6], x[7], x[8], x[9], x[10], x[11], x[12], x[13], x[14], x[15]), this.matrix.transform(_[0], _[1], _[2], _[3], _[4], _[5], _[6], _[7], _[8], _[9], _[10], _[11], _[12], _[13], _[14], _[15]), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), b = 0; b < M; b += 1)
              n[b] = this.matrix.props[b];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), b = 0; b < M; b += 1)
              n[b] = this.matrix.props[b];
          $ += 1, o -= 1, a += s;
        }
      } else
        for (o = this._currentCopies, a = 0, s = 1; o; )
          r = this.elemsData[a].it, n = r[r.length - 1].transform.mProps.v.props, r[r.length - 1].transform.mProps._mdf = !1, r[r.length - 1].transform.op._mdf = !1, o -= 1, a += s;
      return c;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, r.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(t, r) {
      var n = shapePool.newElement();
      n.c = t.c;
      var a, s = t._length, o, c, l, d, h, u, p = 0, m, g, v, y, x, _;
      for (a = 0; a < s; a += 1)
        o = t.v[a], l = t.o[a], c = t.i[a], o[0] === l[0] && o[1] === l[1] && o[0] === c[0] && o[1] === c[1] ? (a === 0 || a === s - 1) && !t.c ? (n.setTripleAt(o[0], o[1], l[0], l[1], c[0], c[1], p), p += 1) : (a === 0 ? d = t.v[s - 1] : d = t.v[a - 1], h = Math.sqrt(Math.pow(o[0] - d[0], 2) + Math.pow(o[1] - d[1], 2)), u = h ? Math.min(h / 2, r) / h : 0, x = o[0] + (d[0] - o[0]) * u, m = x, _ = o[1] - (o[1] - d[1]) * u, g = _, v = m - (m - o[0]) * roundCorner, y = g - (g - o[1]) * roundCorner, n.setTripleAt(m, g, v, y, x, _, p), p += 1, a === s - 1 ? d = t.v[0] : d = t.v[a + 1], h = Math.sqrt(Math.pow(o[0] - d[0], 2) + Math.pow(o[1] - d[1], 2)), u = h ? Math.min(h / 2, r) / h : 0, v = o[0] + (d[0] - o[0]) * u, m = v, y = o[1] + (d[1] - o[1]) * u, g = y, x = m - (m - o[0]) * roundCorner, _ = g - (g - o[1]) * roundCorner, n.setTripleAt(m, g, v, y, x, _, p), p += 1) : (n.setTripleAt(t.v[a][0], t.v[a][1], t.o[a][0], t.o[a][1], t.i[a][0], t.i[a][1], p), p += 1);
      return n;
    }, RoundCornersModifier.prototype.processShapes = function(t) {
      var r, n, a = this.shapes.length, s, o, c = this.rd.v;
      if (c !== 0) {
        var l, d;
        for (n = 0; n < a; n += 1) {
          if (l = this.shapes[n], d = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !t))
            for (d.releaseShapes(), l.shape._mdf = !0, r = l.shape.paths.shapes, o = l.shape.paths._length, s = 0; s < o; s += 1)
              d.addShape(this.processPath(r[s], c));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(t, r) {
      return Math.abs(t - r) * 1e5 <= Math.min(Math.abs(t), Math.abs(r));
    }
    function floatZero(t) {
      return Math.abs(t) <= 1e-5;
    }
    function lerp(t, r, n) {
      return t * (1 - n) + r * n;
    }
    function lerpPoint(t, r, n) {
      return [lerp(t[0], r[0], n), lerp(t[1], r[1], n)];
    }
    function quadRoots(t, r, n) {
      if (t === 0)
        return [];
      var a = r * r - 4 * t * n;
      if (a < 0)
        return [];
      var s = -r / (2 * t);
      if (a === 0)
        return [s];
      var o = Math.sqrt(a) / (2 * t);
      return [s - o, s + o];
    }
    function polynomialCoefficients(t, r, n, a) {
      return [-t + 3 * r - 3 * n + a, 3 * t - 6 * r + 3 * n, -3 * t + 3 * r, t];
    }
    function singlePoint(t) {
      return new PolynomialBezier(t, t, t, t, !1);
    }
    function PolynomialBezier(t, r, n, a, s) {
      s && pointEqual(t, r) && (r = lerpPoint(t, a, 1 / 3)), s && pointEqual(n, a) && (n = lerpPoint(t, a, 2 / 3));
      var o = polynomialCoefficients(t[0], r[0], n[0], a[0]), c = polynomialCoefficients(t[1], r[1], n[1], a[1]);
      this.a = [o[0], c[0]], this.b = [o[1], c[1]], this.c = [o[2], c[2]], this.d = [o[3], c[3]], this.points = [t, r, n, a];
    }
    PolynomialBezier.prototype.point = function(t) {
      return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(t) {
      return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(t) {
      var r = this.derivative(t);
      return Math.atan2(r[1], r[0]);
    }, PolynomialBezier.prototype.normalAngle = function(t) {
      var r = this.derivative(t);
      return Math.atan2(r[0], r[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(t))
        return [];
      var r = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, n = r * r - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
      if (n < 0)
        return [];
      var a = Math.sqrt(n);
      return floatZero(a) ? a > 0 && a < 1 ? [r] : [] : [r - a, r + a].filter(function(s) {
        return s > 0 && s < 1;
      });
    }, PolynomialBezier.prototype.split = function(t) {
      if (t <= 0)
        return [singlePoint(this.points[0]), this];
      if (t >= 1)
        return [this, singlePoint(this.points[this.points.length - 1])];
      var r = lerpPoint(this.points[0], this.points[1], t), n = lerpPoint(this.points[1], this.points[2], t), a = lerpPoint(this.points[2], this.points[3], t), s = lerpPoint(r, n, t), o = lerpPoint(n, a, t), c = lerpPoint(s, o, t);
      return [new PolynomialBezier(this.points[0], r, s, c, !0), new PolynomialBezier(c, o, a, this.points[3], !0)];
    };
    function extrema(t, r) {
      var n = t.points[0][r], a = t.points[t.points.length - 1][r];
      if (n > a) {
        var s = a;
        a = n, n = s;
      }
      for (var o = quadRoots(3 * t.a[r], 2 * t.b[r], t.c[r]), c = 0; c < o.length; c += 1)
        if (o[c] > 0 && o[c] < 1) {
          var l = t.point(o[c])[r];
          l < n ? n = l : l > a && (a = l);
        }
      return {
        min: n,
        max: a
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var t = this.bounds();
      return {
        left: t.x.min,
        right: t.x.max,
        top: t.y.min,
        bottom: t.y.max,
        width: t.x.max - t.x.min,
        height: t.y.max - t.y.min,
        cx: (t.x.max + t.x.min) / 2,
        cy: (t.y.max + t.y.min) / 2
      };
    };
    function intersectData(t, r, n) {
      var a = t.boundingBox();
      return {
        cx: a.cx,
        cy: a.cy,
        width: a.width,
        height: a.height,
        bez: t,
        t: (r + n) / 2,
        t1: r,
        t2: n
      };
    }
    function splitData(t) {
      var r = t.bez.split(0.5);
      return [intersectData(r[0], t.t1, t.t), intersectData(r[1], t.t, t.t2)];
    }
    function boxIntersect(t, r) {
      return Math.abs(t.cx - r.cx) * 2 < t.width + r.width && Math.abs(t.cy - r.cy) * 2 < t.height + r.height;
    }
    function intersectsImpl(t, r, n, a, s, o) {
      if (boxIntersect(t, r)) {
        if (n >= o || t.width <= a && t.height <= a && r.width <= a && r.height <= a) {
          s.push([t.t, r.t]);
          return;
        }
        var c = splitData(t), l = splitData(r);
        intersectsImpl(c[0], l[0], n + 1, a, s, o), intersectsImpl(c[0], l[1], n + 1, a, s, o), intersectsImpl(c[1], l[0], n + 1, a, s, o), intersectsImpl(c[1], l[1], n + 1, a, s, o);
      }
    }
    PolynomialBezier.prototype.intersections = function(t, r, n) {
      r === void 0 && (r = 2), n === void 0 && (n = 7);
      var a = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, r, a, n), a;
    }, PolynomialBezier.shapeSegment = function(t, r) {
      var n = (r + 1) % t.length();
      return new PolynomialBezier(t.v[r], t.o[r], t.i[n], t.v[n], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(t, r) {
      var n = (r + 1) % t.length();
      return new PolynomialBezier(t.v[n], t.i[n], t.o[r], t.v[r], !0);
    };
    function crossProduct(t, r) {
      return [t[1] * r[2] - t[2] * r[1], t[2] * r[0] - t[0] * r[2], t[0] * r[1] - t[1] * r[0]];
    }
    function lineIntersection(t, r, n, a) {
      var s = [t[0], t[1], 1], o = [r[0], r[1], 1], c = [n[0], n[1], 1], l = [a[0], a[1], 1], d = crossProduct(crossProduct(s, o), crossProduct(c, l));
      return floatZero(d[2]) ? null : [d[0] / d[2], d[1] / d[2]];
    }
    function polarOffset(t, r, n) {
      return [t[0] + Math.cos(r) * n, t[1] - Math.sin(r) * n];
    }
    function pointDistance(t, r) {
      return Math.hypot(t[0] - r[0], t[1] - r[1]);
    }
    function pointEqual(t, r) {
      return floatEqual(t[0], r[0]) && floatEqual(t[1], r[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, r.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, r.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, r.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(t, r, n, a, s, o, c) {
      var l = n - Math.PI / 2, d = n + Math.PI / 2, h = r[0] + Math.cos(n) * a * s, u = r[1] - Math.sin(n) * a * s;
      t.setTripleAt(h, u, h + Math.cos(l) * o, u - Math.sin(l) * o, h + Math.cos(d) * c, u - Math.sin(d) * c, t.length());
    }
    function getPerpendicularVector(t, r) {
      var n = [r[0] - t[0], r[1] - t[1]], a = -Math.PI * 0.5, s = [Math.cos(a) * n[0] - Math.sin(a) * n[1], Math.sin(a) * n[0] + Math.cos(a) * n[1]];
      return s;
    }
    function getProjectingAngle(t, r) {
      var n = r === 0 ? t.length() - 1 : r - 1, a = (r + 1) % t.length(), s = t.v[n], o = t.v[a], c = getPerpendicularVector(s, o);
      return Math.atan2(0, 1) - Math.atan2(c[1], c[0]);
    }
    function zigZagCorner(t, r, n, a, s, o, c) {
      var l = getProjectingAngle(r, n), d = r.v[n % r._length], h = r.v[n === 0 ? r._length - 1 : n - 1], u = r.v[(n + 1) % r._length], p = o === 2 ? Math.sqrt(Math.pow(d[0] - h[0], 2) + Math.pow(d[1] - h[1], 2)) : 0, m = o === 2 ? Math.sqrt(Math.pow(d[0] - u[0], 2) + Math.pow(d[1] - u[1], 2)) : 0;
      setPoint(t, r.v[n % r._length], l, c, a, m / ((s + 1) * 2), p / ((s + 1) * 2));
    }
    function zigZagSegment(t, r, n, a, s, o) {
      for (var c = 0; c < a; c += 1) {
        var l = (c + 1) / (a + 1), d = s === 2 ? Math.sqrt(Math.pow(r.points[3][0] - r.points[0][0], 2) + Math.pow(r.points[3][1] - r.points[0][1], 2)) : 0, h = r.normalAngle(l), u = r.point(l);
        setPoint(t, u, h, o, n, d / ((a + 1) * 2), d / ((a + 1) * 2)), o = -o;
      }
      return o;
    }
    ZigZagModifier.prototype.processPath = function(t, r, n, a) {
      var s = t._length, o = shapePool.newElement();
      if (o.c = t.c, t.c || (s -= 1), s === 0)
        return o;
      var c = -1, l = PolynomialBezier.shapeSegment(t, 0);
      zigZagCorner(o, t, 0, r, n, a, c);
      for (var d = 0; d < s; d += 1)
        c = zigZagSegment(o, l, r, n, a, -c), d === s - 1 && !t.c ? l = null : l = PolynomialBezier.shapeSegment(t, (d + 1) % s), zigZagCorner(o, t, d + 1, r, n, a, c);
      return o;
    }, ZigZagModifier.prototype.processShapes = function(t) {
      var r, n, a = this.shapes.length, s, o, c = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), d = this.pointsType.v;
      if (c !== 0) {
        var h, u;
        for (n = 0; n < a; n += 1) {
          if (h = this.shapes[n], u = h.localShapeCollection, !(!h.shape._mdf && !this._mdf && !t))
            for (u.releaseShapes(), h.shape._mdf = !0, r = h.shape.paths.shapes, o = h.shape.paths._length, s = 0; s < o; s += 1)
              u.addShape(this.processPath(r[s], c, l, d));
          h.shape.paths = h.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(t, r, n) {
      var a = Math.atan2(r[0] - t[0], r[1] - t[1]);
      return [polarOffset(t, a, n), polarOffset(r, a, n)];
    }
    function offsetSegment(t, r) {
      var n, a, s, o, c, l, d;
      d = linearOffset(t.points[0], t.points[1], r), n = d[0], a = d[1], d = linearOffset(t.points[1], t.points[2], r), s = d[0], o = d[1], d = linearOffset(t.points[2], t.points[3], r), c = d[0], l = d[1];
      var h = lineIntersection(n, a, s, o);
      h === null && (h = a);
      var u = lineIntersection(c, l, s, o);
      return u === null && (u = c), new PolynomialBezier(n, h, u, l);
    }
    function joinLines(t, r, n, a, s) {
      var o = r.points[3], c = n.points[0];
      if (a === 3 || pointEqual(o, c))
        return o;
      if (a === 2) {
        var l = -r.tangentAngle(1), d = -n.tangentAngle(0) + Math.PI, h = lineIntersection(o, polarOffset(o, l + Math.PI / 2, 100), c, polarOffset(c, l + Math.PI / 2, 100)), u = h ? pointDistance(h, o) : pointDistance(o, c) / 2, p = polarOffset(o, l, 2 * u * roundCorner);
        return t.setXYAt(p[0], p[1], "o", t.length() - 1), p = polarOffset(c, d, 2 * u * roundCorner), t.setTripleAt(c[0], c[1], c[0], c[1], p[0], p[1], t.length()), c;
      }
      var m = pointEqual(o, r.points[2]) ? r.points[0] : r.points[2], g = pointEqual(c, n.points[1]) ? n.points[3] : n.points[1], v = lineIntersection(m, o, c, g);
      return v && pointDistance(v, o) < s ? (t.setTripleAt(v[0], v[1], v[0], v[1], v[0], v[1], t.length()), v) : o;
    }
    function getIntersection(t, r) {
      var n = t.intersections(r);
      return n.length && floatEqual(n[0][0], 1) && n.shift(), n.length ? n[0] : null;
    }
    function pruneSegmentIntersection(t, r) {
      var n = t.slice(), a = r.slice(), s = getIntersection(t[t.length - 1], r[0]);
      return s && (n[t.length - 1] = t[t.length - 1].split(s[0])[0], a[0] = r[0].split(s[1])[1]), t.length > 1 && r.length > 1 && (s = getIntersection(t[0], r[r.length - 1]), s) ? [[t[0].split(s[0])[0]], [r[r.length - 1].split(s[1])[1]]] : [n, a];
    }
    function pruneIntersections(t) {
      for (var r, n = 1; n < t.length; n += 1)
        r = pruneSegmentIntersection(t[n - 1], t[n]), t[n - 1] = r[0], t[n] = r[1];
      return t.length > 1 && (r = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = r[0], t[0] = r[1]), t;
    }
    function offsetSegmentSplit(t, r) {
      var n = t.inflectionPoints(), a, s, o, c;
      if (n.length === 0)
        return [offsetSegment(t, r)];
      if (n.length === 1 || floatEqual(n[1], 1))
        return o = t.split(n[0]), a = o[0], s = o[1], [offsetSegment(a, r), offsetSegment(s, r)];
      o = t.split(n[0]), a = o[0];
      var l = (n[1] - n[0]) / (1 - n[0]);
      return o = o[1].split(l), c = o[0], s = o[1], [offsetSegment(a, r), offsetSegment(c, r), offsetSegment(s, r)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, r.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, r.ml, 0, null, this), this.lineJoin = r.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(t, r, n, a) {
      var s = shapePool.newElement();
      s.c = t.c;
      var o = t.length();
      t.c || (o -= 1);
      var c, l, d, h = [];
      for (c = 0; c < o; c += 1)
        d = PolynomialBezier.shapeSegment(t, c), h.push(offsetSegmentSplit(d, r));
      if (!t.c)
        for (c = o - 1; c >= 0; c -= 1)
          d = PolynomialBezier.shapeSegmentInverted(t, c), h.push(offsetSegmentSplit(d, r));
      h = pruneIntersections(h);
      var u = null, p = null;
      for (c = 0; c < h.length; c += 1) {
        var m = h[c];
        for (p && (u = joinLines(s, p, m[0], n, a)), p = m[m.length - 1], l = 0; l < m.length; l += 1)
          d = m[l], u && pointEqual(d.points[0], u) ? s.setXYAt(d.points[1][0], d.points[1][1], "o", s.length() - 1) : s.setTripleAt(d.points[0][0], d.points[0][1], d.points[1][0], d.points[1][1], d.points[0][0], d.points[0][1], s.length()), s.setTripleAt(d.points[3][0], d.points[3][1], d.points[3][0], d.points[3][1], d.points[2][0], d.points[2][1], s.length()), u = d.points[3];
      }
      return h.length && joinLines(s, p, h[0][0], n, a), s;
    }, OffsetPathModifier.prototype.processShapes = function(t) {
      var r, n, a = this.shapes.length, s, o, c = this.amount.v, l = this.miterLimit.v, d = this.lineJoin;
      if (c !== 0) {
        var h, u;
        for (n = 0; n < a; n += 1) {
          if (h = this.shapes[n], u = h.localShapeCollection, !(!h.shape._mdf && !this._mdf && !t))
            for (u.releaseShapes(), h.shape._mdf = !0, r = h.shape.paths.shapes, o = h.shape.paths._length, s = 0; s < o; s += 1)
              u.addShape(this.processPath(r[s], c, d, l));
          h.shape.paths = h.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(t) {
      for (var r = t.fStyle ? t.fStyle.split(" ") : [], n = "normal", a = "normal", s = r.length, o, c = 0; c < s; c += 1)
        switch (o = r[c].toLowerCase(), o) {
          case "italic":
            a = "italic";
            break;
          case "bold":
            n = "700";
            break;
          case "black":
            n = "900";
            break;
          case "medium":
            n = "500";
            break;
          case "regular":
          case "normal":
            n = "400";
            break;
          case "light":
          case "thin":
            n = "200";
            break;
        }
      return {
        style: a,
        weight: t.fWeight || n
      };
    }
    var FontManager = function() {
      var t = 5e3, r = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, n = [];
      n = n.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var a = 127988, s = 917631, o = 917601, c = 917626, l = 65039, d = 8205, h = 127462, u = 127487, p = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function m(I) {
        var k = I.split(","), B, L = k.length, V = [];
        for (B = 0; B < L; B += 1)
          k[B] !== "sans-serif" && k[B] !== "monospace" && V.push(k[B]);
        return V.join(",");
      }
      function g(I, k) {
        var B = createTag("span");
        B.setAttribute("aria-hidden", !0), B.style.fontFamily = k;
        var L = createTag("span");
        L.innerText = "giItT1WQy@!-/#", B.style.position = "absolute", B.style.left = "-10000px", B.style.top = "-10000px", B.style.fontSize = "300px", B.style.fontVariant = "normal", B.style.fontStyle = "normal", B.style.fontWeight = "normal", B.style.letterSpacing = "0", B.appendChild(L), document.body.appendChild(B);
        var V = L.offsetWidth;
        return L.style.fontFamily = m(I) + ", " + k, {
          node: L,
          w: V,
          parent: B
        };
      }
      function v() {
        var I, k = this.fonts.length, B, L, V = k;
        for (I = 0; I < k; I += 1)
          this.fonts[I].loaded ? V -= 1 : this.fonts[I].fOrigin === "n" || this.fonts[I].origin === 0 ? this.fonts[I].loaded = !0 : (B = this.fonts[I].monoCase.node, L = this.fonts[I].monoCase.w, B.offsetWidth !== L ? (V -= 1, this.fonts[I].loaded = !0) : (B = this.fonts[I].sansCase.node, L = this.fonts[I].sansCase.w, B.offsetWidth !== L && (V -= 1, this.fonts[I].loaded = !0)), this.fonts[I].loaded && (this.fonts[I].sansCase.parent.parentNode.removeChild(this.fonts[I].sansCase.parent), this.fonts[I].monoCase.parent.parentNode.removeChild(this.fonts[I].monoCase.parent)));
        V !== 0 && Date.now() - this.initTime < t ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function y(I, k) {
        var B = document.body && k ? "svg" : "canvas", L, V = getFontProperties(I);
        if (B === "svg") {
          var U = createNS("text");
          U.style.fontSize = "100px", U.setAttribute("font-family", I.fFamily), U.setAttribute("font-style", V.style), U.setAttribute("font-weight", V.weight), U.textContent = "1", I.fClass ? (U.style.fontFamily = "inherit", U.setAttribute("class", I.fClass)) : U.style.fontFamily = I.fFamily, k.appendChild(U), L = U;
        } else {
          var J = new OffscreenCanvas(500, 500).getContext("2d");
          J.font = V.style + " " + V.weight + " 100px " + I.fFamily, L = J;
        }
        function q(Z) {
          return B === "svg" ? (L.textContent = Z, L.getComputedTextLength()) : L.measureText(Z).width;
        }
        return {
          measureText: q
        };
      }
      function x(I, k) {
        if (!I) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = I.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, I.list.forEach(function(nr) {
            nr.helper = y(nr), nr.cache = {};
          }), this.fonts = I.list;
          return;
        }
        var B = I.list, L, V = B.length, U = V;
        for (L = 0; L < V; L += 1) {
          var J = !0, q, Z;
          if (B[L].loaded = !1, B[L].monoCase = g(B[L].fFamily, "monospace"), B[L].sansCase = g(B[L].fFamily, "sans-serif"), !B[L].fPath)
            B[L].loaded = !0, U -= 1;
          else if (B[L].fOrigin === "p" || B[L].origin === 3) {
            if (q = document.querySelectorAll('style[f-forigin="p"][f-family="' + B[L].fFamily + '"], style[f-origin="3"][f-family="' + B[L].fFamily + '"]'), q.length > 0 && (J = !1), J) {
              var ae = createTag("style");
              ae.setAttribute("f-forigin", B[L].fOrigin), ae.setAttribute("f-origin", B[L].origin), ae.setAttribute("f-family", B[L].fFamily), ae.type = "text/css", ae.innerText = "@font-face {font-family: " + B[L].fFamily + "; font-style: normal; src: url('" + B[L].fPath + "');}", k.appendChild(ae);
            }
          } else if (B[L].fOrigin === "g" || B[L].origin === 1) {
            for (q = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), Z = 0; Z < q.length; Z += 1)
              q[Z].href.indexOf(B[L].fPath) !== -1 && (J = !1);
            if (J) {
              var ee = createTag("link");
              ee.setAttribute("f-forigin", B[L].fOrigin), ee.setAttribute("f-origin", B[L].origin), ee.type = "text/css", ee.rel = "stylesheet", ee.href = B[L].fPath, document.body.appendChild(ee);
            }
          } else if (B[L].fOrigin === "t" || B[L].origin === 2) {
            for (q = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), Z = 0; Z < q.length; Z += 1)
              B[L].fPath === q[Z].src && (J = !1);
            if (J) {
              var se = createTag("link");
              se.setAttribute("f-forigin", B[L].fOrigin), se.setAttribute("f-origin", B[L].origin), se.setAttribute("rel", "stylesheet"), se.setAttribute("href", B[L].fPath), k.appendChild(se);
            }
          }
          B[L].helper = y(B[L], k), B[L].cache = {}, this.fonts.push(B[L]);
        }
        U === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function _(I) {
        if (I) {
          this.chars || (this.chars = []);
          var k, B = I.length, L, V = this.chars.length, U;
          for (k = 0; k < B; k += 1) {
            for (L = 0, U = !1; L < V; )
              this.chars[L].style === I[k].style && this.chars[L].fFamily === I[k].fFamily && this.chars[L].ch === I[k].ch && (U = !0), L += 1;
            U || (this.chars.push(I[k]), V += 1);
          }
        }
      }
      function $(I, k, B) {
        for (var L = 0, V = this.chars.length; L < V; ) {
          if (this.chars[L].ch === I && this.chars[L].style === k && this.chars[L].fFamily === B)
            return this.chars[L];
          L += 1;
        }
        return (typeof I == "string" && I.charCodeAt(0) !== 13 || !I) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", I, k, B)), r;
      }
      function b(I, k, B) {
        var L = this.getFontByName(k), V = I;
        if (!L.cache[V]) {
          var U = L.helper;
          if (I === " ") {
            var J = U.measureText("|" + I + "|"), q = U.measureText("||");
            L.cache[V] = (J - q) / 100;
          } else
            L.cache[V] = U.measureText(I) / 100;
        }
        return L.cache[V] * B;
      }
      function M(I) {
        for (var k = 0, B = this.fonts.length; k < B; ) {
          if (this.fonts[k].fName === I)
            return this.fonts[k];
          k += 1;
        }
        return this.fonts[0];
      }
      function C(I) {
        var k = 0, B = I.charCodeAt(0);
        if (B >= 55296 && B <= 56319) {
          var L = I.charCodeAt(1);
          L >= 56320 && L <= 57343 && (k = (B - 55296) * 1024 + L - 56320 + 65536);
        }
        return k;
      }
      function S(I, k) {
        var B = I.toString(16) + k.toString(16);
        return p.indexOf(B) !== -1;
      }
      function A(I) {
        return I === d;
      }
      function D(I) {
        return I === l;
      }
      function N(I) {
        var k = C(I);
        return k >= h && k <= u;
      }
      function T(I) {
        return N(I.substr(0, 2)) && N(I.substr(2, 2));
      }
      function R(I) {
        return n.indexOf(I) !== -1;
      }
      function F(I, k) {
        var B = C(I.substr(k, 2));
        if (B !== a)
          return !1;
        var L = 0;
        for (k += 2; L < 5; ) {
          if (B = C(I.substr(k, 2)), B < o || B > c)
            return !1;
          L += 1, k += 2;
        }
        return C(I.substr(k, 2)) === s;
      }
      function z() {
        this.isLoaded = !0;
      }
      var O = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      O.isModifier = S, O.isZeroWidthJoiner = A, O.isFlagEmoji = T, O.isRegionalCode = N, O.isCombinedCharacter = R, O.isRegionalFlag = F, O.isVariationSelector = D, O.BLACK_FLAG_CODE_POINT = a;
      var G = {
        addChars: _,
        addFonts: x,
        getCharData: $,
        getFontByName: M,
        measureText: b,
        checkLoadedFonts: v,
        setIsLoaded: z
      };
      return O.prototype = G, O;
    }();
    function SlotManager(t) {
      this.animationData = t;
    }
    SlotManager.prototype.getProp = function(t) {
      return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
    };
    function slotFactory(t) {
      return new SlotManager(t);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(r) {
        this.renderableComponents.indexOf(r) === -1 && this.renderableComponents.push(r);
      },
      removeRenderableComponent: function(r) {
        this.renderableComponents.indexOf(r) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(r), 1);
      },
      prepareRenderableFrame: function(r) {
        this.checkLayerLimits(r);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(r) {
        this.data.ip - this.data.st <= r && this.data.op - this.data.st > r ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var r, n = this.renderableComponents.length;
        for (r = 0; r < n; r += 1)
          this.renderableComponents[r].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = function() {
      var t = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(r) {
        return t[r] || "";
      };
    }();
    function SliderEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function AngleEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function ColorEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 1, 0, n);
    }
    function PointEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 1, 0, n);
    }
    function LayerIndexEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function MaskIndexEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function CheckboxEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(t, r) {
      var n = t.ef || [];
      this.effectElements = [];
      var a, s = n.length, o;
      for (a = 0; a < s; a += 1)
        o = new GroupEffect(n[a], r), this.effectElements.push(o);
    }
    function GroupEffect(t, r) {
      this.init(t, r);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, r) {
      this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(r);
      var n, a = this.data.ef.length, s, o = this.data.ef;
      for (n = 0; n < a; n += 1) {
        switch (s = null, o[n].ty) {
          case 0:
            s = new SliderEffect(o[n], r, this);
            break;
          case 1:
            s = new AngleEffect(o[n], r, this);
            break;
          case 2:
            s = new ColorEffect(o[n], r, this);
            break;
          case 3:
            s = new PointEffect(o[n], r, this);
            break;
          case 4:
          case 7:
            s = new CheckboxEffect(o[n], r, this);
            break;
          case 10:
            s = new LayerIndexEffect(o[n], r, this);
            break;
          case 11:
            s = new MaskIndexEffect(o[n], r, this);
            break;
          case 5:
            s = new EffectsManager(o[n], r);
            break;
          default:
            s = new NoValueEffect(o[n]);
            break;
        }
        s && this.effectElements.push(s);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var r = 0, n = this.data.masksProperties.length; r < n; ) {
          if (this.data.masksProperties[r].mode !== "n" && this.data.masksProperties[r].cl !== !1)
            return !0;
          r += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var r = getExpressionInterfaces();
        if (r) {
          var n = r("layer"), a = r("effects"), s = r("shape"), o = r("text"), c = r("comp");
          this.layerInterface = n(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var l = a.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(l), this.data.ty === 0 || this.data.xt ? this.compInterface = c(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = s(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = o(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var r = getBlendMode(this.data.bm), n = this.baseElement || this.layerElement;
        n.style["mix-blend-mode"] = r;
      },
      initBaseData: function(r, n, a) {
        this.globalData = n, this.comp = a, this.data = r, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(r, n) {
        var a, s = this.dynamicProperties.length;
        for (a = 0; a < s; a += 1)
          (n || this._isParent && this.dynamicProperties[a].propType === "transform") && (this.dynamicProperties[a].getValue(), this.dynamicProperties[a]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(r) {
        this.dynamicProperties.indexOf(r) === -1 && this.dynamicProperties.push(r);
      }
    };
    function FootageElement(t, r, n) {
      this.initFrame(), this.initRenderable(), this.assetData = r.getAssetData(t.refId), this.footageData = r.imageLoader.getAsset(this.assetData), this.initBaseData(t, r, n);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var t = getExpressionInterfaces();
      if (t) {
        var r = t("footage");
        this.layerInterface = r(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(t, r, n) {
      this.initFrame(), this.initRenderable(), this.assetData = r.getAssetData(t.refId), this.initBaseData(t, r, n), this._isPlaying = !1, this._canPlay = !1;
      var a = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(a), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(t) {
      if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder)
        this._currentTime = t / this.data.sr;
      else {
        var r = this.tm.v;
        this._currentTime = r;
      }
      this._volume = this.lv.v[0];
      var n = this._volume * this._volumeMultiplier;
      this._previousVolume !== n && (this._previousVolume = n, this.audio.volume(n));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(t) {
      this.audio.rate(t);
    }, AudioElement.prototype.volume = function(t) {
      this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(t) {
      var r, n = this.layers.length, a;
      for (this.completeLayers = !0, r = n - 1; r >= 0; r -= 1)
        this.elements[r] || (a = this.layers[r], a.ip - a.st <= t - this.layers[r].st && a.op - a.st > t - this.layers[r].st && this.buildItem(r)), this.completeLayers = this.elements[r] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(t) {
      switch (t.ty) {
        case 2:
          return this.createImage(t);
        case 0:
          return this.createComp(t);
        case 1:
          return this.createSolid(t);
        case 3:
          return this.createNull(t);
        case 4:
          return this.createShape(t);
        case 5:
          return this.createText(t);
        case 6:
          return this.createAudio(t);
        case 13:
          return this.createCamera(t);
        case 15:
          return this.createFootage(t);
        default:
          return this.createNull(t);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(t) {
      return new AudioElement(t, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(t) {
      return new FootageElement(t, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1)
        this.buildItem(t);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(t) {
      this.completeLayers = !1;
      var r, n = t.length, a, s = this.layers.length;
      for (r = 0; r < n; r += 1)
        for (a = 0; a < s; ) {
          if (this.layers[a].id === t[r].id) {
            this.layers[a] = t[r];
            break;
          }
          a += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(t) {
      this.globalData.projectInterface = t;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(t, r, n) {
      for (var a = this.elements, s = this.layers, o = 0, c = s.length; o < c; )
        s[o].ind == r && (!a[o] || a[o] === !0 ? (this.buildItem(o), this.addPendingElement(t)) : (n.push(a[o]), a[o].setAsParent(), s[o].parent !== void 0 ? this.buildElementParenting(t, s[o].parent, n) : t.setHierarchy(n))), o += 1;
    }, BaseRenderer.prototype.addPendingElement = function(t) {
      this.pendingElements.push(t);
    }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1)
        if (t[r].xt) {
          var a = this.createComp(t[r]);
          a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
        }
    }, BaseRenderer.prototype.getElementById = function(t) {
      var r, n = this.elements.length;
      for (r = 0; r < n; r += 1)
        if (this.elements[r].data.ind === t)
          return this.elements[r];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(t) {
      var r = t.shift(), n;
      if (typeof r == "number")
        n = this.elements[r];
      else {
        var a, s = this.elements.length;
        for (a = 0; a < s; a += 1)
          if (this.elements[a].data.nm === r) {
            n = this.elements[a];
            break;
          }
      }
      return t.length === 0 ? n : n.getElementByPath(t);
    }, BaseRenderer.prototype.setupGlobalData = function(t, r) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, r), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
        w: t.w,
        h: t.h
      };
    };
    var effectTypes = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        var r = new Matrix();
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: r,
          localMat: r,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var r, n = this.finalTransform.mat, a = 0, s = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; a < s; ) {
              if (this.hierarchy[a].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              a += 1;
            }
          if (this.finalTransform._matMdf)
            for (r = this.finalTransform.mProp.v.props, n.cloneFromProps(r), a = 0; a < s; a += 1)
              n.multiply(this.hierarchy[a].finalTransform.mProp.v);
        }
        (!this.localTransforms || this.finalTransform._matMdf) && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var r = 0, n = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; r < n; )
              this.localTransforms[r]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[r]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), r += 1;
          if (this.finalTransform._localMatMdf) {
            var a = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(a), r = 1; r < n; r += 1) {
              var s = this.localTransforms[r].matrix;
              a.multiply(s);
            }
            a.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var o = this.finalTransform.localOpacity;
            for (r = 0; r < n; r += 1)
              o *= this.localTransforms[r].opacity * 0.01;
            this.finalTransform.localOpacity = o;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var r = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
          if (r.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Matrix();
            var n = 0, a = r.length;
            for (n = 0; n < a; n += 1)
              this.localTransforms.push(r[n]);
          }
        }
      },
      globalToLocal: function(r) {
        var n = [];
        n.push(this.finalTransform);
        for (var a = !0, s = this.comp; a; )
          s.finalTransform ? (s.data.hasMask && n.splice(0, 0, s.finalTransform), s = s.comp) : a = !1;
        var o, c = n.length, l;
        for (o = 0; o < c; o += 1)
          l = n[o].mat.applyToPointArray(0, 0, 0), r = [r[0] - l[0], r[1] - l[1], 0];
        return r;
      },
      mHelper: new Matrix()
    };
    function MaskElement(t, r, n) {
      this.data = t, this.element = r, this.globalData = n, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var a = this.globalData.defs, s, o = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(o), this.solidPath = "";
      var c, l = this.masksProperties, d = 0, h = [], u, p, m = createElementID(), g, v, y, x, _ = "clipPath", $ = "clip-path";
      for (s = 0; s < o; s += 1)
        if ((l[s].mode !== "a" && l[s].mode !== "n" || l[s].inv || l[s].o.k !== 100 || l[s].o.x) && (_ = "mask", $ = "mask"), (l[s].mode === "s" || l[s].mode === "i") && d === 0 ? (g = createNS("rect"), g.setAttribute("fill", "#ffffff"), g.setAttribute("width", this.element.comp.data.w || 0), g.setAttribute("height", this.element.comp.data.h || 0), h.push(g)) : g = null, c = createNS("path"), l[s].mode === "n")
          this.viewData[s] = {
            op: PropertyFactory.getProp(this.element, l[s].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[s], 3),
            elem: c,
            lastPath: ""
          }, a.appendChild(c);
        else {
          d += 1, c.setAttribute("fill", l[s].mode === "s" ? "#000000" : "#ffffff"), c.setAttribute("clip-rule", "nonzero");
          var b;
          if (l[s].x.k !== 0 ? (_ = "mask", $ = "mask", x = PropertyFactory.getProp(this.element, l[s].x, 0, null, this.element), b = createElementID(), v = createNS("filter"), v.setAttribute("id", b), y = createNS("feMorphology"), y.setAttribute("operator", "erode"), y.setAttribute("in", "SourceGraphic"), y.setAttribute("radius", "0"), v.appendChild(y), a.appendChild(v), c.setAttribute("stroke", l[s].mode === "s" ? "#000000" : "#ffffff")) : (y = null, x = null), this.storedData[s] = {
            elem: c,
            x,
            expan: y,
            lastPath: "",
            lastOperator: "",
            filterId: b,
            lastRadius: 0
          }, l[s].mode === "i") {
            p = h.length;
            var M = createNS("g");
            for (u = 0; u < p; u += 1)
              M.appendChild(h[u]);
            var C = createNS("mask");
            C.setAttribute("mask-type", "alpha"), C.setAttribute("id", m + "_" + d), C.appendChild(c), a.appendChild(C), M.setAttribute("mask", "url(" + getLocationHref() + "#" + m + "_" + d + ")"), h.length = 0, h.push(M);
          } else
            h.push(c);
          l[s].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[s] = {
            elem: c,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, l[s].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[s], 3),
            invRect: g
          }, this.viewData[s].prop.k || this.drawPath(l[s], this.viewData[s].prop.v, this.viewData[s]);
        }
      for (this.maskElement = createNS(_), o = h.length, s = 0; s < o; s += 1)
        this.maskElement.appendChild(h[s]);
      d > 0 && (this.maskElement.setAttribute("id", m), this.element.maskedElement.setAttribute($, "url(" + getLocationHref() + "#" + m + ")"), a.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(t) {
      return this.viewData[t].prop;
    }, MaskElement.prototype.renderFrame = function(t) {
      var r = this.element.finalTransform.mat, n, a = this.masksProperties.length;
      for (n = 0; n < a; n += 1)
        if ((this.viewData[n].prop._mdf || t) && this.drawPath(this.masksProperties[n], this.viewData[n].prop.v, this.viewData[n]), (this.viewData[n].op._mdf || t) && this.viewData[n].elem.setAttribute("fill-opacity", this.viewData[n].op.v), this.masksProperties[n].mode !== "n" && (this.viewData[n].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[n].invRect.setAttribute("transform", r.getInverseMatrix().to2dCSS()), this.storedData[n].x && (this.storedData[n].x._mdf || t))) {
          var s = this.storedData[n].expan;
          this.storedData[n].x.v < 0 ? (this.storedData[n].lastOperator !== "erode" && (this.storedData[n].lastOperator = "erode", this.storedData[n].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[n].filterId + ")")), s.setAttribute("radius", -this.storedData[n].x.v)) : (this.storedData[n].lastOperator !== "dilate" && (this.storedData[n].lastOperator = "dilate", this.storedData[n].elem.setAttribute("filter", null)), this.storedData[n].elem.setAttribute("stroke-width", this.storedData[n].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var t = "M0,0 ";
      return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ", t;
    }, MaskElement.prototype.drawPath = function(t, r, n) {
      var a = " M" + r.v[0][0] + "," + r.v[0][1], s, o;
      for (o = r._length, s = 1; s < o; s += 1)
        a += " C" + r.o[s - 1][0] + "," + r.o[s - 1][1] + " " + r.i[s][0] + "," + r.i[s][1] + " " + r.v[s][0] + "," + r.v[s][1];
      if (r.c && o > 1 && (a += " C" + r.o[s - 1][0] + "," + r.o[s - 1][1] + " " + r.i[0][0] + "," + r.i[0][1] + " " + r.v[0][0] + "," + r.v[0][1]), n.lastPath !== a) {
        var c = "";
        n.elem && (r.c && (c = t.inv ? this.solidPath + a : a), n.elem.setAttribute("d", c)), n.lastPath = a;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var t = {};
      t.createFilter = r, t.createAlphaToLuminanceFilter = n;
      function r(a, s) {
        var o = createNS("filter");
        return o.setAttribute("id", a), s !== !0 && (o.setAttribute("filterUnits", "objectBoundingBox"), o.setAttribute("x", "0%"), o.setAttribute("y", "0%"), o.setAttribute("width", "100%"), o.setAttribute("height", "100%")), o;
      }
      function n() {
        var a = createNS("feColorMatrix");
        return a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), a;
      }
      return t;
    }(), featureSupport = function() {
      var t = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(t) {
      var r, n = "SourceGraphic", a = t.data.ef ? t.data.ef.length : 0, s = createElementID(), o = filtersFactory.createFilter(s, !0), c = 0;
      this.filters = [];
      var l;
      for (r = 0; r < a; r += 1) {
        l = null;
        var d = t.data.ef[r].ty;
        if (registeredEffects$1[d]) {
          var h = registeredEffects$1[d].effect;
          l = new h(o, t.effectsManager.effectElements[r], t, idPrefix + c, n), n = idPrefix + c, registeredEffects$1[d].countsAsEffect && (c += 1);
        }
        l && this.filters.push(l);
      }
      c && (t.globalData.defs.appendChild(o), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")), this.filters.length && t.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(t) {
      var r, n = this.filters.length;
      for (r = 0; r < n; r += 1)
        this.filters[r].renderFrame(t);
    }, SVGEffects.prototype.getEffects = function(t) {
      var r, n = this.filters.length, a = [];
      for (r = 0; r < n; r += 1)
        this.filters[r].type === t && a.push(this.filters[r]);
      return a;
    };
    function registerEffect$1(t, r, n) {
      registeredEffects$1[t] = {
        effect: r,
        countsAsEffect: n
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var r = null;
        if (this.data.td) {
          this.matteMasks = {};
          var n = createNS("g");
          n.setAttribute("id", this.layerId), n.appendChild(this.layerElement), r = n, this.globalData.defs.appendChild(n);
        } else
          this.data.tt ? (this.matteElement.appendChild(this.layerElement), r = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var a = createNS("clipPath"), s = createNS("path");
          s.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var o = createElementID();
          if (a.setAttribute("id", o), a.appendChild(s), this.globalData.defs.appendChild(a), this.checkMasks()) {
            var c = createNS("g");
            c.setAttribute("clip-path", "url(" + getLocationHref() + "#" + o + ")"), c.appendChild(this.layerElement), this.transformedElement = c, r ? r.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + o + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
      },
      getMatte: function(r) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[r]) {
          var n = this.layerId + "_" + r, a, s, o, c;
          if (r === 1 || r === 3) {
            var l = createNS("mask");
            l.setAttribute("id", n), l.setAttribute("mask-type", r === 3 ? "luminance" : "alpha"), o = createNS("use"), o.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), l.appendChild(o), this.globalData.defs.appendChild(l), !featureSupport.maskType && r === 1 && (l.setAttribute("mask-type", "luminance"), a = createElementID(), s = filtersFactory.createFilter(a), this.globalData.defs.appendChild(s), s.appendChild(filtersFactory.createAlphaToLuminanceFilter()), c = createNS("g"), c.appendChild(o), l.appendChild(c), c.setAttribute("filter", "url(" + getLocationHref() + "#" + a + ")"));
          } else if (r === 2) {
            var d = createNS("mask");
            d.setAttribute("id", n), d.setAttribute("mask-type", "alpha");
            var h = createNS("g");
            d.appendChild(h), a = createElementID(), s = filtersFactory.createFilter(a);
            var u = createNS("feComponentTransfer");
            u.setAttribute("in", "SourceGraphic"), s.appendChild(u);
            var p = createNS("feFuncA");
            p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), u.appendChild(p), this.globalData.defs.appendChild(s);
            var m = createNS("rect");
            m.setAttribute("width", this.comp.data.w), m.setAttribute("height", this.comp.data.h), m.setAttribute("x", "0"), m.setAttribute("y", "0"), m.setAttribute("fill", "#ffffff"), m.setAttribute("opacity", "0"), h.setAttribute("filter", "url(" + getLocationHref() + "#" + a + ")"), h.appendChild(m), o = createNS("use"), o.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h.appendChild(o), featureSupport.maskType || (d.setAttribute("mask-type", "luminance"), s.appendChild(filtersFactory.createAlphaToLuminanceFilter()), c = createNS("g"), h.appendChild(m), c.appendChild(this.layerElement), h.appendChild(c)), this.globalData.defs.appendChild(d);
          }
          this.matteMasks[r] = n;
        }
        return this.matteMasks[r];
      },
      setMatte: function(r) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + r + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(r) {
        this.hierarchy = r;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var t = {
        initElement: function(n, a, s) {
          this.initFrame(), this.initBaseData(n, a, s), this.initTransform(n, a, s), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var n = this.baseElement || this.layerElement;
            n.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var n = this.baseElement || this.layerElement;
              n.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(n) {
          this._mdf = !1, this.prepareRenderableFrame(n), this.prepareProperties(n, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(t)], RenderableDOMElement);
    })();
    function IImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = r.slotManager.getProp(this.assetData)), this.initElement(t, r, n), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var t = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(t, r) {
      this.elem = t, this.pos = r;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(r) {
        var n, a = this.shapeModifiers.length;
        for (n = 0; n < a; n += 1)
          this.shapeModifiers[n].addShape(r);
      },
      isShapeInAnimatedModifiers: function(r) {
        for (var n = 0, a = this.shapeModifiers.length; n < a; )
          if (this.shapeModifiers[n].isAnimatedWithShape(r))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var r, n = this.shapes.length;
          for (r = 0; r < n; r += 1)
            this.shapes[r].sh.reset();
          n = this.shapeModifiers.length;
          var a;
          for (r = n - 1; r >= 0 && (a = this.shapeModifiers[r].processShapes(this._isFirstFrame), !a); r -= 1)
            ;
        }
      },
      searchProcessedElement: function(r) {
        for (var n = this.processedElements, a = 0, s = n.length; a < s; ) {
          if (n[a].elem === r)
            return n[a].pos;
          a += 1;
        }
        return 0;
      },
      addProcessedElement: function(r, n) {
        for (var a = this.processedElements, s = a.length; s; )
          if (s -= 1, a[s].elem === r) {
            a[s].pos = n;
            return;
          }
        a.push(new ProcessedElement(r, n));
      },
      prepareFrame: function(r) {
        this.prepareRenderableFrame(r), this.prepareProperties(r, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(t, r, n) {
      this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = n, this.lvl = r, this._isAnimated = !!n.k;
      for (var a = 0, s = t.length; a < s; ) {
        if (t[a].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        a += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(t, r) {
      this.data = t, this.type = t.ty, this.d = "", this.lvl = r, this._mdf = !1, this.closed = t.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(t, r, n, a) {
      this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(r.length), this.renderer = n, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", r.length ? r.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(a);
      var s, o = r.length || 0, c;
      for (s = 0; s < o; s += 1)
        c = PropertyFactory.getProp(t, r[s].v, 0, 0, this), this.k = c.k || this.k, this.dataProps[s] = {
          n: r[s].n,
          p: c
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(t) {
      if (!(this.elem.globalData.frameId === this.frameId && !t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
        var r = 0, n = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), r = 0; r < n; r += 1)
          this.dataProps[r].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[r].p.v : this.dashArray[r] = this.dataProps[r].p.v : this.dashoffset[0] = this.dataProps[r].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.w = PropertyFactory.getProp(t, r.w, 0, null, this), this.d = new DashProperty(t, r.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, r.c, 1, 255, this), this.style = n, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.c = PropertyFactory.getProp(t, r.c, 1, 255, this), this.style = n;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = n;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(t, r, n) {
      this.data = r, this.c = createTypedArray("uint8c", r.p * 4);
      var a = r.k.k[0].s ? r.k.k[0].s.length - r.p * 4 : r.k.k.length - r.p * 4;
      this.o = createTypedArray("float32", a), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = a, this.initDynamicPropertyContainer(n), this.prop = PropertyFactory.getProp(t, r.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(t, r) {
      for (var n = 0, a = this.o.length / 2, s; n < a; ) {
        if (s = Math.abs(t[n * 4] - t[r * 4 + n * 2]), s > 0.01)
          return !1;
        n += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var t = 0, r = this.data.k.k.length; t < r; ) {
          if (!this.comparePoints(this.data.k.k[t].s, this.data.p))
            return !1;
          t += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(t) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
        var r, n = this.data.p * 4, a, s;
        for (r = 0; r < n; r += 1)
          a = r % 4 === 0 ? 100 : 255, s = Math.round(this.prop.v[r] * a), this.c[r] !== s && (this.c[r] = s, this._cmdf = !t);
        if (this.o.length)
          for (n = this.prop.v.length, r = this.data.p * 4; r < n; r += 1)
            a = r % 2 === 0 ? 100 : 1, s = r % 2 === 0 ? Math.round(this.prop.v[r] * 100) : this.prop.v[r], this.o[r - this.data.p * 4] !== s && (this.o[r - this.data.p * 4] = s, this._omdf = !t);
        this._mdf = !t;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, r, n);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(t, r, n) {
      this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.s = PropertyFactory.getProp(t, r.s, 1, null, this), this.e = PropertyFactory.getProp(t, r.e, 1, null, this), this.h = PropertyFactory.getProp(t, r.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(t, r.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(t, r.g, this), this.style = n, this.stops = [], this.setGradientData(n.pElem, r), this.setGradientOpacity(r, n), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(t, r) {
      var n = createElementID(), a = createNS(r.t === 1 ? "linearGradient" : "radialGradient");
      a.setAttribute("id", n), a.setAttribute("spreadMethod", "pad"), a.setAttribute("gradientUnits", "userSpaceOnUse");
      var s = [], o, c, l;
      for (l = r.g.p * 4, c = 0; c < l; c += 4)
        o = createNS("stop"), a.appendChild(o), s.push(o);
      t.setAttribute(r.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + n + ")"), this.gf = a, this.cst = s;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, r) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var n, a, s, o = createNS("mask"), c = createNS("path");
        o.appendChild(c);
        var l = createElementID(), d = createElementID();
        o.setAttribute("id", d);
        var h = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
        h.setAttribute("id", l), h.setAttribute("spreadMethod", "pad"), h.setAttribute("gradientUnits", "userSpaceOnUse"), s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
        var u = this.stops;
        for (a = t.g.p * 4; a < s; a += 2)
          n = createNS("stop"), n.setAttribute("stop-color", "rgb(255,255,255)"), h.appendChild(n), u.push(n);
        c.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + l + ")"), t.ty === "gs" && (c.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), c.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), t.lj === 1 && c.setAttribute("stroke-miterlimit", t.ml)), this.of = h, this.ms = o, this.ost = u, this.maskId = d, r.msElem = c;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, r.w, 0, null, this), this.d = new DashProperty(t, r.d || {}, "svg", this), this.initGradientData(t, r, n), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(t, r, n) {
      this.transform = {
        mProps: t,
        op: r,
        container: n
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(r, n, a, s) {
      if (n === 0)
        return "";
      var o = r.o, c = r.i, l = r.v, d, h = " M" + s.applyToPointStringified(l[0][0], l[0][1]);
      for (d = 1; d < n; d += 1)
        h += " C" + s.applyToPointStringified(o[d - 1][0], o[d - 1][1]) + " " + s.applyToPointStringified(c[d][0], c[d][1]) + " " + s.applyToPointStringified(l[d][0], l[d][1]);
      return a && n && (h += " C" + s.applyToPointStringified(o[d - 1][0], o[d - 1][1]) + " " + s.applyToPointStringified(c[0][0], c[0][1]) + " " + s.applyToPointStringified(l[0][0], l[0][1]), h += "z"), h;
    }, SVGElementsRenderer = function() {
      var t = new Matrix(), r = new Matrix(), n = {
        createRenderFunction: a
      };
      function a(p) {
        switch (p.ty) {
          case "fl":
            return l;
          case "gf":
            return h;
          case "gs":
            return d;
          case "st":
            return u;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return c;
          case "tr":
            return s;
          case "no":
            return o;
          default:
            return null;
        }
      }
      function s(p, m, g) {
        (g || m.transform.op._mdf) && m.transform.container.setAttribute("opacity", m.transform.op.v), (g || m.transform.mProps._mdf) && m.transform.container.setAttribute("transform", m.transform.mProps.v.to2dCSS());
      }
      function o() {
      }
      function c(p, m, g) {
        var v, y, x, _, $, b, M = m.styles.length, C = m.lvl, S, A, D, N;
        for (b = 0; b < M; b += 1) {
          if (_ = m.sh._mdf || g, m.styles[b].lvl < C) {
            for (A = r.reset(), D = C - m.styles[b].lvl, N = m.transformers.length - 1; !_ && D > 0; )
              _ = m.transformers[N].mProps._mdf || _, D -= 1, N -= 1;
            if (_)
              for (D = C - m.styles[b].lvl, N = m.transformers.length - 1; D > 0; )
                A.multiply(m.transformers[N].mProps.v), D -= 1, N -= 1;
          } else
            A = t;
          if (S = m.sh.paths, y = S._length, _) {
            for (x = "", v = 0; v < y; v += 1)
              $ = S.shapes[v], $ && $._length && (x += buildShapeString($, $._length, $.c, A));
            m.caches[b] = x;
          } else
            x = m.caches[b];
          m.styles[b].d += p.hd === !0 ? "" : x, m.styles[b]._mdf = _ || m.styles[b]._mdf;
        }
      }
      function l(p, m, g) {
        var v = m.style;
        (m.c._mdf || g) && v.pElem.setAttribute("fill", "rgb(" + bmFloor(m.c.v[0]) + "," + bmFloor(m.c.v[1]) + "," + bmFloor(m.c.v[2]) + ")"), (m.o._mdf || g) && v.pElem.setAttribute("fill-opacity", m.o.v);
      }
      function d(p, m, g) {
        h(p, m, g), u(p, m, g);
      }
      function h(p, m, g) {
        var v = m.gf, y = m.g._hasOpacity, x = m.s.v, _ = m.e.v;
        if (m.o._mdf || g) {
          var $ = p.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          m.style.pElem.setAttribute($, m.o.v);
        }
        if (m.s._mdf || g) {
          var b = p.t === 1 ? "x1" : "cx", M = b === "x1" ? "y1" : "cy";
          v.setAttribute(b, x[0]), v.setAttribute(M, x[1]), y && !m.g._collapsable && (m.of.setAttribute(b, x[0]), m.of.setAttribute(M, x[1]));
        }
        var C, S, A, D;
        if (m.g._cmdf || g) {
          C = m.cst;
          var N = m.g.c;
          for (A = C.length, S = 0; S < A; S += 1)
            D = C[S], D.setAttribute("offset", N[S * 4] + "%"), D.setAttribute("stop-color", "rgb(" + N[S * 4 + 1] + "," + N[S * 4 + 2] + "," + N[S * 4 + 3] + ")");
        }
        if (y && (m.g._omdf || g)) {
          var T = m.g.o;
          for (m.g._collapsable ? C = m.cst : C = m.ost, A = C.length, S = 0; S < A; S += 1)
            D = C[S], m.g._collapsable || D.setAttribute("offset", T[S * 2] + "%"), D.setAttribute("stop-opacity", T[S * 2 + 1]);
        }
        if (p.t === 1)
          (m.e._mdf || g) && (v.setAttribute("x2", _[0]), v.setAttribute("y2", _[1]), y && !m.g._collapsable && (m.of.setAttribute("x2", _[0]), m.of.setAttribute("y2", _[1])));
        else {
          var R;
          if ((m.s._mdf || m.e._mdf || g) && (R = Math.sqrt(Math.pow(x[0] - _[0], 2) + Math.pow(x[1] - _[1], 2)), v.setAttribute("r", R), y && !m.g._collapsable && m.of.setAttribute("r", R)), m.s._mdf || m.e._mdf || m.h._mdf || m.a._mdf || g) {
            R || (R = Math.sqrt(Math.pow(x[0] - _[0], 2) + Math.pow(x[1] - _[1], 2)));
            var F = Math.atan2(_[1] - x[1], _[0] - x[0]), z = m.h.v;
            z >= 1 ? z = 0.99 : z <= -1 && (z = -0.99);
            var O = R * z, G = Math.cos(F + m.a.v) * O + x[0], I = Math.sin(F + m.a.v) * O + x[1];
            v.setAttribute("fx", G), v.setAttribute("fy", I), y && !m.g._collapsable && (m.of.setAttribute("fx", G), m.of.setAttribute("fy", I));
          }
        }
      }
      function u(p, m, g) {
        var v = m.style, y = m.d;
        y && (y._mdf || g) && y.dashStr && (v.pElem.setAttribute("stroke-dasharray", y.dashStr), v.pElem.setAttribute("stroke-dashoffset", y.dashoffset[0])), m.c && (m.c._mdf || g) && v.pElem.setAttribute("stroke", "rgb(" + bmFloor(m.c.v[0]) + "," + bmFloor(m.c.v[1]) + "," + bmFloor(m.c.v[2]) + ")"), (m.o._mdf || g) && v.pElem.setAttribute("stroke-opacity", m.o.v), (m.w._mdf || g) && (v.pElem.setAttribute("stroke-width", m.w.v), v.msElem && v.msElem.setAttribute("stroke-width", m.w.v));
      }
      return n;
    }();
    function SVGShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, r, n), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var t, r = this.shapes.length, n, a, s = this.stylesList.length, o, c = [], l = !1;
      for (a = 0; a < s; a += 1) {
        for (o = this.stylesList[a], l = !1, c.length = 0, t = 0; t < r; t += 1)
          n = this.shapes[t], n.styles.indexOf(o) !== -1 && (c.push(n), l = n._isAnimated || l);
        c.length > 1 && l && this.setShapesAsAnimated(c);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1)
        t[r].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(t, r) {
      var n, a = new SVGStyleData(t, r), s = a.pElem;
      if (t.ty === "st")
        n = new SVGStrokeStyleData(this, t, a);
      else if (t.ty === "fl")
        n = new SVGFillStyleData(this, t, a);
      else if (t.ty === "gf" || t.ty === "gs") {
        var o = t.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        n = new o(this, t, a), this.globalData.defs.appendChild(n.gf), n.maskId && (this.globalData.defs.appendChild(n.ms), this.globalData.defs.appendChild(n.of), s.setAttribute("mask", "url(" + getLocationHref() + "#" + n.maskId + ")"));
      } else
        t.ty === "no" && (n = new SVGNoStyleData(this, t, a));
      return (t.ty === "st" || t.ty === "gs") && (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), s.setAttribute("fill-opacity", "0"), t.lj === 1 && s.setAttribute("stroke-miterlimit", t.ml)), t.r === 2 && s.setAttribute("fill-rule", "evenodd"), t.ln && s.setAttribute("id", t.ln), t.cl && s.setAttribute("class", t.cl), t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(a), this.addToAnimatedContents(t, n), n;
    }, SVGShapeElement.prototype.createGroupElement = function(t) {
      var r = new ShapeGroupData();
      return t.ln && r.gr.setAttribute("id", t.ln), t.cl && r.gr.setAttribute("class", t.cl), t.bm && (r.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), r;
    }, SVGShapeElement.prototype.createTransformElement = function(t, r) {
      var n = TransformPropertyFactory.getTransformProperty(this, t, this), a = new SVGTransformData(n, n.o, r);
      return this.addToAnimatedContents(t, a), a;
    }, SVGShapeElement.prototype.createShapeElement = function(t, r, n) {
      var a = 4;
      t.ty === "rc" ? a = 5 : t.ty === "el" ? a = 6 : t.ty === "sr" && (a = 7);
      var s = ShapePropertyFactory.getShapeProp(this, t, a, this), o = new SVGShapeData(r, n, s);
      return this.shapes.push(o), this.addShapeToModifiers(o), this.addToAnimatedContents(t, o), o;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(t, r) {
      for (var n = 0, a = this.animatedContents.length; n < a; ) {
        if (this.animatedContents[n].element === r)
          return;
        n += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(t),
        element: r,
        data: t
      });
    }, SVGShapeElement.prototype.setElementStyles = function(t) {
      var r = t.styles, n, a = this.stylesList.length;
      for (n = 0; n < a; n += 1)
        r.indexOf(this.stylesList[n]) === -1 && !this.stylesList[n].closed && r.push(this.stylesList[n]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var t, r = this.itemsData.length;
      for (t = 0; t < r; t += 1)
        this.prevViewData[t] = this.itemsData[t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), r = this.dynamicProperties.length, t = 0; t < r; t += 1)
        this.dynamicProperties[t].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(t, r, n, a, s, o, c) {
      var l = [].concat(o), d, h = t.length - 1, u, p, m = [], g = [], v, y, x;
      for (d = h; d >= 0; d -= 1) {
        if (x = this.searchProcessedElement(t[d]), x ? r[d] = n[x - 1] : t[d]._render = c, t[d].ty === "fl" || t[d].ty === "st" || t[d].ty === "gf" || t[d].ty === "gs" || t[d].ty === "no")
          x ? r[d].style.closed = t[d].hd : r[d] = this.createStyleElement(t[d], s), t[d]._render && r[d].style.pElem.parentNode !== a && a.appendChild(r[d].style.pElem), m.push(r[d].style);
        else if (t[d].ty === "gr") {
          if (!x)
            r[d] = this.createGroupElement(t[d]);
          else
            for (p = r[d].it.length, u = 0; u < p; u += 1)
              r[d].prevViewData[u] = r[d].it[u];
          this.searchShapes(t[d].it, r[d].it, r[d].prevViewData, r[d].gr, s + 1, l, c), t[d]._render && r[d].gr.parentNode !== a && a.appendChild(r[d].gr);
        } else
          t[d].ty === "tr" ? (x || (r[d] = this.createTransformElement(t[d], a)), v = r[d].transform, l.push(v)) : t[d].ty === "sh" || t[d].ty === "rc" || t[d].ty === "el" || t[d].ty === "sr" ? (x || (r[d] = this.createShapeElement(t[d], l, s)), this.setElementStyles(r[d])) : t[d].ty === "tm" || t[d].ty === "rd" || t[d].ty === "ms" || t[d].ty === "pb" || t[d].ty === "zz" || t[d].ty === "op" ? (x ? (y = r[d], y.closed = !1) : (y = ShapeModifiers.getModifier(t[d].ty), y.init(this, t[d]), r[d] = y, this.shapeModifiers.push(y)), g.push(y)) : t[d].ty === "rp" && (x ? (y = r[d], y.closed = !0) : (y = ShapeModifiers.getModifier(t[d].ty), r[d] = y, y.init(this, t, d, r), this.shapeModifiers.push(y), c = !1), g.push(y));
        this.addProcessedElement(t[d], d + 1);
      }
      for (h = m.length, d = 0; d < h; d += 1)
        m[d].closed = !0;
      for (h = g.length, d = 0; d < h; d += 1)
        g[d].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var t, r = this.stylesList.length;
      for (t = 0; t < r; t += 1)
        this.stylesList[t].reset();
      for (this.renderShape(), t = 0; t < r; t += 1)
        (this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var t, r = this.animatedContents.length, n;
      for (t = 0; t < r; t += 1)
        n = this.animatedContents[t], (this._isFirstFrame || n.element._isAnimated) && n.data !== !0 && n.fn(n.data, n.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(t, r, n, a, s, o) {
      this.o = t, this.sw = r, this.sc = n, this.fc = a, this.m = s, this.p = o, this._mdf = {
        o: !0,
        sw: !!r,
        sc: !!n,
        fc: !!a,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(t, r, n, a, s, o) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var c = !1;
      return this.o !== t && (this.o = t, this._mdf.o = !0, c = !0), this.sw !== r && (this.sw = r, this._mdf.sw = !0, c = !0), this.sc !== n && (this.sc = n, this._mdf.sc = !0, c = !0), this.fc !== a && (this.fc = a, this._mdf.fc = !0, c = !0), this.m !== s && (this.m = s, this._mdf.m = !0, c = !0), o.length && (this.p[0] !== o[0] || this.p[1] !== o[1] || this.p[4] !== o[4] || this.p[5] !== o[5] || this.p[12] !== o[12] || this.p[13] !== o[13]) && (this.p = o, this._mdf.p = !0, c = !0), c;
    };
    function TextProperty(t, r) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, r.d && r.d.sid && (r.d = t.globalData.slotManager.getProp(r.d)), this.data = r, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(t, r) {
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      return t;
    }, TextProperty.prototype.setCurrentData = function(t) {
      t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(t) {
      this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(t) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !t)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var r = this.currentData, n = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var a, s = this.effectsSequence.length, o = t || this.data.d.k[this.keysIndex].s;
        for (a = 0; a < s; a += 1)
          n !== this.keysIndex ? o = this.effectsSequence[a](o, o.t) : o = this.effectsSequence[a](this.currentData, o.t);
        r !== o && this.setCurrentData(o), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var t = this.data.d.k, r = this.elem.comp.renderedFrame, n = 0, a = t.length; n <= a - 1 && !(n === a - 1 || t[n + 1].t > r); )
        n += 1;
      return this.keysIndex !== n && (this.keysIndex = n), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(t) {
      for (var r = [], n = 0, a = t.length, s, o, c = !1, l = !1, d = ""; n < a; )
        c = l, l = !1, s = t.charCodeAt(n), d = t.charAt(n), FontManager.isCombinedCharacter(s) ? c = !0 : s >= 55296 && s <= 56319 ? FontManager.isRegionalFlag(t, n) ? d = t.substr(n, 14) : (o = t.charCodeAt(n + 1), o >= 56320 && o <= 57343 && (FontManager.isModifier(s, o) ? (d = t.substr(n, 2), c = !0) : FontManager.isFlagEmoji(t.substr(n, 4)) ? d = t.substr(n, 4) : d = t.substr(n, 2))) : s > 56319 ? (o = t.charCodeAt(n + 1), FontManager.isVariationSelector(s) && (c = !0)) : FontManager.isZeroWidthJoiner(s) && (c = !0, l = !0), c ? (r[r.length - 1] += d, c = !1) : r.push(d), n += d.length;
      return r;
    }, TextProperty.prototype.completeTextData = function(t) {
      t.__complete = !0;
      var r = this.elem.globalData.fontManager, n = this.data, a = [], s, o, c, l = 0, d, h = n.m.g, u = 0, p = 0, m = 0, g = [], v = 0, y = 0, x, _, $ = r.getFontByName(t.f), b, M = 0, C = getFontProperties($);
      t.fWeight = C.weight, t.fStyle = C.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), o = t.finalText.length, t.finalLineHeight = t.lh;
      var S = t.tr / 1e3 * t.finalSize, A;
      if (t.sz)
        for (var D = !0, N = t.sz[0], T = t.sz[1], R, F; D; ) {
          F = this.buildFinalText(t.t), R = 0, v = 0, o = F.length, S = t.tr / 1e3 * t.finalSize;
          var z = -1;
          for (s = 0; s < o; s += 1)
            A = F[s].charCodeAt(0), c = !1, F[s] === " " ? z = s : (A === 13 || A === 3) && (v = 0, c = !0, R += t.finalLineHeight || t.finalSize * 1.2), r.chars ? (b = r.getCharData(F[s], $.fStyle, $.fFamily), M = c ? 0 : b.w * t.finalSize / 100) : M = r.measureText(F[s], t.f, t.finalSize), v + M > N && F[s] !== " " ? (z === -1 ? o += 1 : s = z, R += t.finalLineHeight || t.finalSize * 1.2, F.splice(s, z === s ? 1 : 0, "\r"), z = -1, v = 0) : (v += M, v += S);
          R += $.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && T < R ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = F, o = t.finalText.length, D = !1);
        }
      v = -S, M = 0;
      var O = 0, G;
      for (s = 0; s < o; s += 1)
        if (c = !1, G = t.finalText[s], A = G.charCodeAt(0), A === 13 || A === 3 ? (O = 0, g.push(v), y = v > y ? v : y, v = -2 * S, d = "", c = !0, m += 1) : d = G, r.chars ? (b = r.getCharData(G, $.fStyle, r.getFontByName(t.f).fFamily), M = c ? 0 : b.w * t.finalSize / 100) : M = r.measureText(d, t.f, t.finalSize), G === " " ? O += M + S : (v += M + S + O, O = 0), a.push({
          l: M,
          an: M,
          add: u,
          n: c,
          anIndexes: [],
          val: d,
          line: m,
          animatorJustifyOffset: 0
        }), h == 2) {
          if (u += M, d === "" || d === " " || s === o - 1) {
            for ((d === "" || d === " ") && (u -= M); p <= s; )
              a[p].an = u, a[p].ind = l, a[p].extra = M, p += 1;
            l += 1, u = 0;
          }
        } else if (h == 3) {
          if (u += M, d === "" || s === o - 1) {
            for (d === "" && (u -= M); p <= s; )
              a[p].an = u, a[p].ind = l, a[p].extra = M, p += 1;
            u = 0, l += 1;
          }
        } else
          a[l].ind = l, a[l].extra = 0, l += 1;
      if (t.l = a, y = v > y ? v : y, g.push(v), t.sz)
        t.boxWidth = t.sz[0], t.justifyOffset = 0;
      else
        switch (t.boxWidth = y, t.j) {
          case 1:
            t.justifyOffset = -t.boxWidth;
            break;
          case 2:
            t.justifyOffset = -t.boxWidth / 2;
            break;
          default:
            t.justifyOffset = 0;
        }
      t.lineWidths = g;
      var I = n.a, k, B;
      _ = I.length;
      var L, V, U = [];
      for (x = 0; x < _; x += 1) {
        for (k = I[x], k.a.sc && (t.strokeColorAnim = !0), k.a.sw && (t.strokeWidthAnim = !0), (k.a.fc || k.a.fh || k.a.fs || k.a.fb) && (t.fillColorAnim = !0), V = 0, L = k.s.b, s = 0; s < o; s += 1)
          B = a[s], B.anIndexes[x] = V, (L == 1 && B.val !== "" || L == 2 && B.val !== "" && B.val !== " " || L == 3 && (B.n || B.val == " " || s == o - 1) || L == 4 && (B.n || s == o - 1)) && (k.s.rn === 1 && U.push(V), V += 1);
        n.a[x].s.totalChars = V;
        var J = -1, q;
        if (k.s.rn === 1)
          for (s = 0; s < o; s += 1)
            B = a[s], J != B.anIndexes[x] && (J = B.anIndexes[x], q = U.splice(Math.floor(Math.random() * U.length), 1)[0]), B.anIndexes[x] = q;
      }
      t.yOffset = t.finalLineHeight || t.finalSize * 1.2, t.ls = t.ls || 0, t.ascent = $.ascent * t.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(t, r) {
      r = r === void 0 ? this.keysIndex : r;
      var n = this.copyData({}, this.data.d.k[r].s);
      n = this.copyData(n, t), this.data.d.k[r].s = n, this.recalculate(r), this.setCurrentData(n), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(t) {
      var r = this.data.d.k[t].s;
      r.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(r);
    }, TextProperty.prototype.canResizeFont = function(t) {
      this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(t) {
      this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var t = Math.max, r = Math.min, n = Math.floor;
      function a(o, c) {
        this._currentTextLength = -1, this.k = !1, this.data = c, this.elem = o, this.comp = o.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(o), this.s = PropertyFactory.getProp(o, c.s || {
          k: 0
        }, 0, 0, this), "e" in c ? this.e = PropertyFactory.getProp(o, c.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(o, c.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(o, c.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(o, c.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(o, c.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(o, c.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      a.prototype = {
        getMult: function(c) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var l = 0, d = 0, h = 1, u = 1;
          this.ne.v > 0 ? l = this.ne.v / 100 : d = -this.ne.v / 100, this.xe.v > 0 ? h = 1 - this.xe.v / 100 : u = 1 + this.xe.v / 100;
          var p = BezierFactory.getBezierEasing(l, d, h, u).get, m = 0, g = this.finalS, v = this.finalE, y = this.data.sh;
          if (y === 2)
            v === g ? m = c >= v ? 1 : 0 : m = t(0, r(0.5 / (v - g) + (c - g) / (v - g), 1)), m = p(m);
          else if (y === 3)
            v === g ? m = c >= v ? 0 : 1 : m = 1 - t(0, r(0.5 / (v - g) + (c - g) / (v - g), 1)), m = p(m);
          else if (y === 4)
            v === g ? m = 0 : (m = t(0, r(0.5 / (v - g) + (c - g) / (v - g), 1)), m < 0.5 ? m *= 2 : m = 1 - 2 * (m - 0.5)), m = p(m);
          else if (y === 5) {
            if (v === g)
              m = 0;
            else {
              var x = v - g;
              c = r(t(0, c + 0.5 - g), v - g);
              var _ = -x / 2 + c, $ = x / 2;
              m = Math.sqrt(1 - _ * _ / ($ * $));
            }
            m = p(m);
          } else
            y === 6 ? (v === g ? m = 0 : (c = r(t(0, c + 0.5 - g), v - g), m = (1 + Math.cos(Math.PI + Math.PI * 2 * c / (v - g))) / 2), m = p(m)) : (c >= n(g) && (c - g < 0 ? m = t(0, r(r(v, 1) - (g - c), 1)) : m = t(0, r(v - c, 1))), m = p(m));
          if (this.sm.v !== 100) {
            var b = this.sm.v * 0.01;
            b === 0 && (b = 1e-8);
            var M = 0.5 - b * 0.5;
            m < M ? m = 0 : (m = (m - M) / b, m > 1 && (m = 1));
          }
          return m * this.a.v;
        },
        getValue: function(c) {
          this.iterateDynamicProperties(), this._mdf = c || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, c && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var l = this.data.r === 2 ? 1 : 100 / this.data.totalChars, d = this.o.v / l, h = this.s.v / l + d, u = this.e.v / l + d;
          if (h > u) {
            var p = h;
            h = u, u = p;
          }
          this.finalS = h, this.finalE = u;
        }
      }, extendPrototype([DynamicPropertyContainer], a);
      function s(o, c, l) {
        return new a(o, c);
      }
      return {
        getTextSelectorProp: s
      };
    }();
    function TextAnimatorDataProperty(t, r, n) {
      var a = {
        propType: !1
      }, s = PropertyFactory.getProp, o = r.a;
      this.a = {
        r: o.r ? s(t, o.r, 0, degToRads, n) : a,
        rx: o.rx ? s(t, o.rx, 0, degToRads, n) : a,
        ry: o.ry ? s(t, o.ry, 0, degToRads, n) : a,
        sk: o.sk ? s(t, o.sk, 0, degToRads, n) : a,
        sa: o.sa ? s(t, o.sa, 0, degToRads, n) : a,
        s: o.s ? s(t, o.s, 1, 0.01, n) : a,
        a: o.a ? s(t, o.a, 1, 0, n) : a,
        o: o.o ? s(t, o.o, 0, 0.01, n) : a,
        p: o.p ? s(t, o.p, 1, 0, n) : a,
        sw: o.sw ? s(t, o.sw, 0, 0, n) : a,
        sc: o.sc ? s(t, o.sc, 1, 0, n) : a,
        fc: o.fc ? s(t, o.fc, 1, 0, n) : a,
        fh: o.fh ? s(t, o.fh, 0, 0, n) : a,
        fs: o.fs ? s(t, o.fs, 0, 0.01, n) : a,
        fb: o.fb ? s(t, o.fb, 0, 0.01, n) : a,
        t: o.t ? s(t, o.t, 0, 0, n) : a
      }, this.s = TextSelectorProp.getTextSelectorProp(t, r.s, n), this.s.t = r.s.t;
    }
    function TextAnimatorProperty(t, r, n) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = r, this._elem = n, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(n);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var t, r = this._textData.a.length, n, a = PropertyFactory.getProp;
      for (t = 0; t < r; t += 1)
        n = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, n, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: a(this._elem, this._textData.p.a, 0, 0, this),
        f: a(this._elem, this._textData.p.f, 0, 0, this),
        l: a(this._elem, this._textData.p.l, 0, 0, this),
        r: a(this._elem, this._textData.p.r, 0, 0, this),
        p: a(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = a(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(t, r) {
      if (this.lettersChangedFlag = r, !(!this._mdf && !this._isFirstFrame && !r && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var n = this._moreOptions.alignment.v, a = this._animatorsData, s = this._textData, o = this.mHelper, c = this._renderType, l = this.renderedLetters.length, d, h, u, p, m = t.l, g, v, y, x, _, $, b, M, C, S, A, D, N, T, R;
        if (this._hasMaskedPath) {
          if (R = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var F = R.v;
            this._pathData.r.v && (F = F.reverse()), g = {
              tLength: 0,
              segments: []
            }, p = F._length - 1;
            var z;
            for (D = 0, u = 0; u < p; u += 1)
              z = bez.buildBezierData(F.v[u], F.v[u + 1], [F.o[u][0] - F.v[u][0], F.o[u][1] - F.v[u][1]], [F.i[u + 1][0] - F.v[u + 1][0], F.i[u + 1][1] - F.v[u + 1][1]]), g.tLength += z.segmentLength, g.segments.push(z), D += z.segmentLength;
            u = p, R.v.c && (z = bez.buildBezierData(F.v[u], F.v[0], [F.o[u][0] - F.v[u][0], F.o[u][1] - F.v[u][1]], [F.i[0][0] - F.v[0][0], F.i[0][1] - F.v[0][1]]), g.tLength += z.segmentLength, g.segments.push(z), D += z.segmentLength), this._pathData.pi = g;
          }
          if (g = this._pathData.pi, v = this._pathData.f.v, b = 0, $ = 1, x = 0, _ = !0, S = g.segments, v < 0 && R.v.c)
            for (g.tLength < Math.abs(v) && (v = -Math.abs(v) % g.tLength), b = S.length - 1, C = S[b].points, $ = C.length - 1; v < 0; )
              v += C[$].partialLength, $ -= 1, $ < 0 && (b -= 1, C = S[b].points, $ = C.length - 1);
          C = S[b].points, M = C[$ - 1], y = C[$], A = y.partialLength;
        }
        p = m.length, d = 0, h = 0;
        var O = t.finalSize * 1.2 * 0.714, G = !0, I, k, B, L, V;
        L = a.length;
        var U, J = -1, q, Z, ae, ee = v, se = b, nr = $, ce = -1, oe, ur, ir, _r, yr, ne, pe, hr, $r = "", Sr = this.defaultPropsArray, ze;
        if (t.j === 2 || t.j === 1) {
          var cr = 0, fr = 0, mr = t.j === 2 ? -0.5 : -1, wr = 0, Nr = !0;
          for (u = 0; u < p; u += 1)
            if (m[u].n) {
              for (cr && (cr += fr); wr < u; )
                m[wr].animatorJustifyOffset = cr, wr += 1;
              cr = 0, Nr = !0;
            } else {
              for (B = 0; B < L; B += 1)
                I = a[B].a, I.t.propType && (Nr && t.j === 2 && (fr += I.t.v * mr), k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), U.length ? cr += I.t.v * U[0] * mr : cr += I.t.v * U * mr);
              Nr = !1;
            }
          for (cr && (cr += fr); wr < u; )
            m[wr].animatorJustifyOffset = cr, wr += 1;
        }
        for (u = 0; u < p; u += 1) {
          if (o.reset(), oe = 1, m[u].n)
            d = 0, h += t.yOffset, h += G ? 1 : 0, v = ee, G = !1, this._hasMaskedPath && (b = se, $ = nr, C = S[b].points, M = C[$ - 1], y = C[$], A = y.partialLength, x = 0), $r = "", hr = "", ne = "", ze = "", Sr = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (ce !== m[u].line) {
                switch (t.j) {
                  case 1:
                    v += D - t.lineWidths[m[u].line];
                    break;
                  case 2:
                    v += (D - t.lineWidths[m[u].line]) / 2;
                    break;
                }
                ce = m[u].line;
              }
              J !== m[u].ind && (m[J] && (v += m[J].extra), v += m[u].an / 2, J = m[u].ind), v += n[0] * m[u].an * 5e-3;
              var xr = 0;
              for (B = 0; B < L; B += 1)
                I = a[B].a, I.p.propType && (k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), U.length ? xr += I.p.v[0] * U[0] : xr += I.p.v[0] * U), I.a.propType && (k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), U.length ? xr += I.a.v[0] * U[0] : xr += I.a.v[0] * U);
              for (_ = !0, this._pathData.a.v && (v = m[0].an * 0.5 + (D - this._pathData.f.v - m[0].an * 0.5 - m[m.length - 1].an * 0.5) * J / (p - 1), v += this._pathData.f.v); _; )
                x + A >= v + xr || !C ? (N = (v + xr - x) / y.partialLength, Z = M.point[0] + (y.point[0] - M.point[0]) * N, ae = M.point[1] + (y.point[1] - M.point[1]) * N, o.translate(-n[0] * m[u].an * 5e-3, -(n[1] * O) * 0.01), _ = !1) : C && (x += y.partialLength, $ += 1, $ >= C.length && ($ = 0, b += 1, S[b] ? C = S[b].points : R.v.c ? ($ = 0, b = 0, C = S[b].points) : (x -= y.partialLength, C = null)), C && (M = y, y = C[$], A = y.partialLength));
              q = m[u].an / 2 - m[u].add, o.translate(-q, 0, 0);
            } else
              q = m[u].an / 2 - m[u].add, o.translate(-q, 0, 0), o.translate(-n[0] * m[u].an * 5e-3, -n[1] * O * 0.01, 0);
            for (B = 0; B < L; B += 1)
              I = a[B].a, I.t.propType && (k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), (d !== 0 || t.j !== 0) && (this._hasMaskedPath ? U.length ? v += I.t.v * U[0] : v += I.t.v * U : U.length ? d += I.t.v * U[0] : d += I.t.v * U));
            for (t.strokeWidthAnim && (ir = t.sw || 0), t.strokeColorAnim && (t.sc ? ur = [t.sc[0], t.sc[1], t.sc[2]] : ur = [0, 0, 0]), t.fillColorAnim && t.fc && (_r = [t.fc[0], t.fc[1], t.fc[2]]), B = 0; B < L; B += 1)
              I = a[B].a, I.a.propType && (k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), U.length ? o.translate(-I.a.v[0] * U[0], -I.a.v[1] * U[1], I.a.v[2] * U[2]) : o.translate(-I.a.v[0] * U, -I.a.v[1] * U, I.a.v[2] * U));
            for (B = 0; B < L; B += 1)
              I = a[B].a, I.s.propType && (k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), U.length ? o.scale(1 + (I.s.v[0] - 1) * U[0], 1 + (I.s.v[1] - 1) * U[1], 1) : o.scale(1 + (I.s.v[0] - 1) * U, 1 + (I.s.v[1] - 1) * U, 1));
            for (B = 0; B < L; B += 1) {
              if (I = a[B].a, k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), I.sk.propType && (U.length ? o.skewFromAxis(-I.sk.v * U[0], I.sa.v * U[1]) : o.skewFromAxis(-I.sk.v * U, I.sa.v * U)), I.r.propType && (U.length ? o.rotateZ(-I.r.v * U[2]) : o.rotateZ(-I.r.v * U)), I.ry.propType && (U.length ? o.rotateY(I.ry.v * U[1]) : o.rotateY(I.ry.v * U)), I.rx.propType && (U.length ? o.rotateX(I.rx.v * U[0]) : o.rotateX(I.rx.v * U)), I.o.propType && (U.length ? oe += (I.o.v * U[0] - oe) * U[0] : oe += (I.o.v * U - oe) * U), t.strokeWidthAnim && I.sw.propType && (U.length ? ir += I.sw.v * U[0] : ir += I.sw.v * U), t.strokeColorAnim && I.sc.propType)
                for (yr = 0; yr < 3; yr += 1)
                  U.length ? ur[yr] += (I.sc.v[yr] - ur[yr]) * U[0] : ur[yr] += (I.sc.v[yr] - ur[yr]) * U;
              if (t.fillColorAnim && t.fc) {
                if (I.fc.propType)
                  for (yr = 0; yr < 3; yr += 1)
                    U.length ? _r[yr] += (I.fc.v[yr] - _r[yr]) * U[0] : _r[yr] += (I.fc.v[yr] - _r[yr]) * U;
                I.fh.propType && (U.length ? _r = addHueToRGB(_r, I.fh.v * U[0]) : _r = addHueToRGB(_r, I.fh.v * U)), I.fs.propType && (U.length ? _r = addSaturationToRGB(_r, I.fs.v * U[0]) : _r = addSaturationToRGB(_r, I.fs.v * U)), I.fb.propType && (U.length ? _r = addBrightnessToRGB(_r, I.fb.v * U[0]) : _r = addBrightnessToRGB(_r, I.fb.v * U));
              }
            }
            for (B = 0; B < L; B += 1)
              I = a[B].a, I.p.propType && (k = a[B].s, U = k.getMult(m[u].anIndexes[B], s.a[B].s.totalChars), this._hasMaskedPath ? U.length ? o.translate(0, I.p.v[1] * U[0], -I.p.v[2] * U[1]) : o.translate(0, I.p.v[1] * U, -I.p.v[2] * U) : U.length ? o.translate(I.p.v[0] * U[0], I.p.v[1] * U[1], -I.p.v[2] * U[2]) : o.translate(I.p.v[0] * U, I.p.v[1] * U, -I.p.v[2] * U));
            if (t.strokeWidthAnim && (ne = ir < 0 ? 0 : ir), t.strokeColorAnim && (pe = "rgb(" + Math.round(ur[0] * 255) + "," + Math.round(ur[1] * 255) + "," + Math.round(ur[2] * 255) + ")"), t.fillColorAnim && t.fc && (hr = "rgb(" + Math.round(_r[0] * 255) + "," + Math.round(_r[1] * 255) + "," + Math.round(_r[2] * 255) + ")"), this._hasMaskedPath) {
              if (o.translate(0, -t.ls), o.translate(0, n[1] * O * 0.01 + h, 0), this._pathData.p.v) {
                T = (y.point[1] - M.point[1]) / (y.point[0] - M.point[0]);
                var Er = Math.atan(T) * 180 / Math.PI;
                y.point[0] < M.point[0] && (Er += 180), o.rotate(-Er * Math.PI / 180);
              }
              o.translate(Z, ae, 0), v -= n[0] * m[u].an * 5e-3, m[u + 1] && J !== m[u + 1].ind && (v += m[u].an / 2, v += t.tr * 1e-3 * t.finalSize);
            } else {
              switch (o.translate(d, h, 0), t.ps && o.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
                case 1:
                  o.translate(m[u].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[m[u].line]), 0, 0);
                  break;
                case 2:
                  o.translate(m[u].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[m[u].line]) / 2, 0, 0);
                  break;
              }
              o.translate(0, -t.ls), o.translate(q, 0, 0), o.translate(n[0] * m[u].an * 5e-3, n[1] * O * 0.01, 0), d += m[u].l + t.tr * 1e-3 * t.finalSize;
            }
            c === "html" ? $r = o.toCSS() : c === "svg" ? $r = o.to2dCSS() : Sr = [o.props[0], o.props[1], o.props[2], o.props[3], o.props[4], o.props[5], o.props[6], o.props[7], o.props[8], o.props[9], o.props[10], o.props[11], o.props[12], o.props[13], o.props[14], o.props[15]], ze = oe;
          }
          l <= u ? (V = new LetterProps(ze, ne, pe, hr, $r, Sr), this.renderedLetters.push(V), l += 1, this.lettersChangedFlag = !0) : (V = this.renderedLetters[u], this.lettersChangedFlag = V.update(ze, ne, pe, hr, $r, Sr) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(t, r, n) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, r, n), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, r, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(t, r) {
      var n, a = r.length, s, o = "";
      for (n = 0; n < a; n += 1)
        r[n].ty === "sh" && (s = r[n].ks.k, o += buildShapeString(s, s.i.length, !0, t));
      return o;
    }, ITextElement.prototype.updateDocumentData = function(t, r) {
      this.textProperty.updateDocumentData(t, r);
    }, ITextElement.prototype.canResizeFont = function(t) {
      this.textProperty.canResizeFont(t);
    }, ITextElement.prototype.setMinimumFontSize = function(t) {
      this.textProperty.setMinimumFontSize(t);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, r, n, a, s) {
      switch (t.ps && r.translate(t.ps[0], t.ps[1] + t.ascent, 0), r.translate(0, -t.ls, 0), t.j) {
        case 1:
          r.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[n]), 0, 0);
          break;
        case 2:
          r.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[n]) / 2, 0, 0);
          break;
      }
      r.translate(a, s, 0);
    }, ITextElement.prototype.buildColor = function(t) {
      return "rgb(" + Math.round(t[0] * 255) + "," + Math.round(t[1] * 255) + "," + Math.round(t[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(t, r, n) {
      this.textSpans = [], this.renderType = "svg", this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
      for (var r = 0, n = t.length, a = [], s = ""; r < n; )
        t[r] === String.fromCharCode(13) || t[r] === String.fromCharCode(3) ? (a.push(s), s = "") : s += t[r], r += 1;
      return a.push(s), a;
    }, SVGTextLottieElement.prototype.buildShapeData = function(t, r) {
      if (t.shapes && t.shapes.length) {
        var n = t.shapes[0];
        if (n.it) {
          var a = n.it[n.it.length - 1];
          a.s && (a.s.k[0] = r, a.s.k[1] = r);
        }
      }
      return t;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var t, r, n = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(n ? n.l.length : 0), n.fc ? this.layerElement.setAttribute("fill", this.buildColor(n.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), n.sc && (this.layerElement.setAttribute("stroke", this.buildColor(n.sc)), this.layerElement.setAttribute("stroke-width", n.sw)), this.layerElement.setAttribute("font-size", n.finalSize);
      var a = this.globalData.fontManager.getFontByName(n.f);
      if (a.fClass)
        this.layerElement.setAttribute("class", a.fClass);
      else {
        this.layerElement.setAttribute("font-family", a.fFamily);
        var s = n.fWeight, o = n.fStyle;
        this.layerElement.setAttribute("font-style", o), this.layerElement.setAttribute("font-weight", s);
      }
      this.layerElement.setAttribute("aria-label", n.t);
      var c = n.l || [], l = !!this.globalData.fontManager.chars;
      r = c.length;
      var d, h = this.mHelper, u = "", p = this.data.singleShape, m = 0, g = 0, v = !0, y = n.tr * 1e-3 * n.finalSize;
      if (p && !l && !n.sz) {
        var x = this.textContainer, _ = "start";
        switch (n.j) {
          case 1:
            _ = "end";
            break;
          case 2:
            _ = "middle";
            break;
          default:
            _ = "start";
            break;
        }
        x.setAttribute("text-anchor", _), x.setAttribute("letter-spacing", y);
        var $ = this.buildTextContents(n.finalText);
        for (r = $.length, g = n.ps ? n.ps[1] + n.ascent : 0, t = 0; t < r; t += 1)
          d = this.textSpans[t].span || createNS("tspan"), d.textContent = $[t], d.setAttribute("x", 0), d.setAttribute("y", g), d.style.display = "inherit", x.appendChild(d), this.textSpans[t] || (this.textSpans[t] = {
            span: null,
            glyph: null
          }), this.textSpans[t].span = d, g += n.finalLineHeight;
        this.layerElement.appendChild(x);
      } else {
        var b = this.textSpans.length, M;
        for (t = 0; t < r; t += 1) {
          if (this.textSpans[t] || (this.textSpans[t] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !l || !p || t === 0) {
            if (d = b > t ? this.textSpans[t].span : createNS(l ? "g" : "text"), b <= t) {
              if (d.setAttribute("stroke-linecap", "butt"), d.setAttribute("stroke-linejoin", "round"), d.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = d, l) {
                var C = createNS("g");
                d.appendChild(C), this.textSpans[t].childSpan = C;
              }
              this.textSpans[t].span = d, this.layerElement.appendChild(d);
            }
            d.style.display = "inherit";
          }
          if (h.reset(), p && (c[t].n && (m = -y, g += n.yOffset, g += v ? 1 : 0, v = !1), this.applyTextPropertiesToMatrix(n, h, c[t].line, m, g), m += c[t].l || 0, m += y), l) {
            M = this.globalData.fontManager.getCharData(n.finalText[t], a.fStyle, this.globalData.fontManager.getFontByName(n.f).fFamily);
            var S;
            if (M.t === 1)
              S = new SVGCompElement(M.data, this.globalData, this);
            else {
              var A = emptyShapeData;
              M.data && M.data.shapes && (A = this.buildShapeData(M.data, n.finalSize)), S = new SVGShapeElement(A, this.globalData, this);
            }
            if (this.textSpans[t].glyph) {
              var D = this.textSpans[t].glyph;
              this.textSpans[t].childSpan.removeChild(D.layerElement), D.destroy();
            }
            this.textSpans[t].glyph = S, S._debug = !0, S.prepareFrame(0), S.renderFrame(), this.textSpans[t].childSpan.appendChild(S.layerElement), M.t === 1 && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + n.finalSize / 100 + "," + n.finalSize / 100 + ")");
          } else
            p && d.setAttribute("transform", "translate(" + h.props[12] + "," + h.props[13] + ")"), d.textContent = c[t].val, d.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        p && d && d.setAttribute("d", u);
      }
      for (; t < this.textSpans.length; )
        this.textSpans[t].span.style.display = "none", t += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var t = this.layerElement.getBBox();
        this.bbox = {
          top: t.y,
          left: t.x,
          width: t.width,
          height: t.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var t, r = this.textSpans.length, n;
      for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)
        n = this.textSpans[t].glyph, n && (n.prepareFrame(this.comp.renderedFrame - this.data.st), n._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var t, r, n = this.textAnimator.renderedLetters, a = this.textProperty.currentData.l;
        r = a.length;
        var s, o, c;
        for (t = 0; t < r; t += 1)
          a[t].n || (s = n[t], o = this.textSpans[t].span, c = this.textSpans[t].glyph, c && c.renderFrame(), s._mdf.m && o.setAttribute("transform", s.m), s._mdf.o && o.setAttribute("opacity", s.o), s._mdf.sw && o.setAttribute("stroke-width", s.sw), s._mdf.sc && o.setAttribute("stroke", s.sc), s._mdf.fc && o.setAttribute("fill", s.fc));
      }
    };
    function ISolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var t = createNS("rect");
      t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
    };
    function NullElement(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initFrame(), this.initTransform(t, r, n), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(t) {
      this.prepareProperties(t, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
      return new NullElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(t) {
      return new SVGShapeElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(t) {
      return new SVGTextLottieElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(t) {
      return new IImageElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(t) {
      return new ISolidElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(t) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var r = this.globalData.defs;
      this.setupGlobalData(t, r), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
      var n = createNS("clipPath"), a = createNS("rect");
      a.setAttribute("width", t.w), a.setAttribute("height", t.h), a.setAttribute("x", 0), a.setAttribute("y", 0);
      var s = createElementID();
      n.setAttribute("id", s), n.appendChild(a), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), r.appendChild(n), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var t, r = this.layers ? this.layers.length : 0;
      for (t = 0; t < r; t += 1)
        this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(t) {
      var r = 0, n = this.layers.length;
      for (r = 0; r < n; r += 1)
        if (this.layers[r].ind === t)
          return r;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(t) {
      var r = this.elements;
      if (!(r[t] || this.layers[t].ty === 99)) {
        r[t] = !0;
        var n = this.createItem(this.layers[t]);
        if (r[t] = n, getExpressionsPlugin() && (this.layers[t].ty === 0 && this.globalData.projectInterface.registerComposition(n), n.initExpressions()), this.appendElementInPos(n, t), this.layers[t].tt) {
          var a = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
          if (a === -1)
            return;
          if (!this.elements[a] || this.elements[a] === !0)
            this.buildItem(a), this.addPendingElement(n);
          else {
            var s = r[a], o = s.getMatte(this.layers[t].tt);
            n.setMatte(o);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var t = this.pendingElements.pop();
        if (t.checkParenting(), t.data.tt)
          for (var r = 0, n = this.elements.length; r < n; ) {
            if (this.elements[r] === t) {
              var a = "tp" in t.data ? this.findIndexByInd(t.data.tp) : r - 1, s = this.elements[a], o = s.getMatte(this.layers[r].tt);
              t.setMatte(o);
              break;
            }
            r += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(t) {
      if (!(this.renderedFrame === t || this.destroyed)) {
        t === null ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
        var r, n = this.layers.length;
        for (this.completeLayers || this.checkLayers(t), r = n - 1; r >= 0; r -= 1)
          (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
        if (this.globalData._mdf)
          for (r = 0; r < n; r += 1)
            (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(t, r) {
      var n = t.getBaseElement();
      if (n) {
        for (var a = 0, s; a < r; )
          this.elements[a] && this.elements[a] !== !0 && this.elements[a].getBaseElement() && (s = this.elements[a].getBaseElement()), a += 1;
        s ? this.layerElement.insertBefore(n, s) : this.layerElement.appendChild(n);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initTransform(t, r, n), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !r.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(t) {
      if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = t / this.data.sr;
        else {
          var r = this.tm.v;
          r === this.data.op && (r = this.data.op - 1), this.renderedFrame = r;
        }
        var n, a = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), n = a - 1; n >= 0; n -= 1)
          (this.completeLayers || this.elements[n]) && (this.elements[n].prepareFrame(this.renderedFrame - this.layers[n].st), this.elements[n]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1)
        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, ICompElement.prototype.setElements = function(t) {
      this.elements = t;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1)
        this.elements[t] && this.elements[t].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(t, r, n) {
      this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
      return new SVGCompElement(t, this.globalData, this);
    };
    function SVGRenderer(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var n = "";
      if (r && r.title) {
        var a = createNS("title"), s = createElementID();
        a.setAttribute("id", s), a.textContent = r.title, this.svgElement.appendChild(a), n += s;
      }
      if (r && r.description) {
        var o = createNS("desc"), c = createElementID();
        o.setAttribute("id", c), o.textContent = r.description, this.svgElement.appendChild(o), n += " " + c;
      }
      n && this.svgElement.setAttribute("aria-labelledby", n);
      var l = createNS("defs");
      this.svgElement.appendChild(l);
      var d = createNS("g");
      this.svgElement.appendChild(d), this.layerElement = d, this.renderConfig = {
        preserveAspectRatio: r && r.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: r && r.contentVisibility || "visible",
        progressiveLoad: r && r.progressiveLoad || !1,
        hideOnTransparent: !(r && r.hideOnTransparent === !1),
        viewBoxOnly: r && r.viewBoxOnly || !1,
        viewBoxSize: r && r.viewBoxSize || !1,
        className: r && r.className || "",
        id: r && r.id || "",
        focusable: r && r.focusable,
        filterSize: {
          width: r && r.filterSize && r.filterSize.width || "100%",
          height: r && r.filterSize && r.filterSize.height || "100%",
          x: r && r.filterSize && r.filterSize.x || "0%",
          y: r && r.filterSize && r.filterSize.y || "0%"
        },
        width: r && r.width,
        height: r && r.height,
        runExpressions: !r || r.runExpressions === void 0 || r.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: l,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
      return new SVGCompElement(t, this.globalData, this);
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(r) {
        var n, a = r.length, s = "_";
        for (n = 0; n < a; n += 1)
          s += r[n].transform.key + "_";
        var o = this.sequences[s];
        return o || (o = {
          transforms: [].concat(r),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[s] = o, this.sequenceList.push(o)), o;
      },
      processSequence: function(r, n) {
        for (var a = 0, s = r.transforms.length, o = n; a < s && !n; ) {
          if (r.transforms[a].transform.mProps._mdf) {
            o = !0;
            break;
          }
          a += 1;
        }
        if (o)
          for (r.finalTransform.reset(), a = s - 1; a >= 0; a -= 1)
            r.finalTransform.multiply(r.transforms[a].transform.mProps.v);
        r._mdf = o;
      },
      processSequences: function(r) {
        var n, a = this.sequenceList.length;
        for (n = 0; n < a; n += 1)
          this.processSequence(this.sequenceList[n], r);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var r = "__lottie_element_luma_buffer", n = null, a = null, s = null;
      function o() {
        var d = createNS("svg"), h = createNS("filter"), u = createNS("feColorMatrix");
        return h.setAttribute("id", r), u.setAttribute("type", "matrix"), u.setAttribute("color-interpolation-filters", "sRGB"), u.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), h.appendChild(u), d.appendChild(h), d.setAttribute("id", r + "_svg"), featureSupport.svgLumaHidden && (d.style.display = "none"), d;
      }
      function c() {
        n || (s = o(), document.body.appendChild(s), n = createTag("canvas"), a = n.getContext("2d"), a.filter = "url(#" + r + ")", a.fillStyle = "rgba(0,0,0,0)", a.fillRect(0, 0, 1, 1));
      }
      function l(d) {
        return n || c(), n.width = d.width, n.height = d.height, a.filter = "url(#" + r + ")", n;
      }
      return {
        load: c,
        get: l
      };
    };
    function createCanvas(t, r) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(t, r);
      var n = createTag("canvas");
      return n.width = t, n.height = r, n;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }(), registeredEffects = {};
    function CVEffects(t) {
      var r, n = t.data.ef ? t.data.ef.length : 0;
      this.filters = [];
      var a;
      for (r = 0; r < n; r += 1) {
        a = null;
        var s = t.data.ef[r].ty;
        if (registeredEffects[s]) {
          var o = registeredEffects[s].effect;
          a = new o(t.effectsManager.effectElements[r], t);
        }
        a && this.filters.push(a);
      }
      this.filters.length && t.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(t) {
      var r, n = this.filters.length;
      for (r = 0; r < n; r += 1)
        this.filters[r].renderFrame(t);
    }, CVEffects.prototype.getEffects = function(t) {
      var r, n = this.filters.length, a = [];
      for (r = 0; r < n; r += 1)
        this.filters[r].type === t && a.push(this.filters[r]);
      return a;
    };
    function registerEffect(t, r) {
      registeredEffects[t] = {
        effect: r
      };
    }
    function CVMaskElement(t, r) {
      this.data = t, this.element = r, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var n, a = this.masksProperties.length, s = !1;
      for (n = 0; n < a; n += 1)
        this.masksProperties[n].mode !== "n" && (s = !0), this.viewData[n] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[n], 3);
      this.hasMasks = s, s && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var t = this.element.finalTransform.mat, r = this.element.canvasContext, n, a = this.masksProperties.length, s, o, c;
        for (r.beginPath(), n = 0; n < a; n += 1)
          if (this.masksProperties[n].mode !== "n") {
            this.masksProperties[n].inv && (r.moveTo(0, 0), r.lineTo(this.element.globalData.compSize.w, 0), r.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), r.lineTo(0, this.element.globalData.compSize.h), r.lineTo(0, 0)), c = this.viewData[n].v, s = t.applyToPointArray(c.v[0][0], c.v[0][1], 0), r.moveTo(s[0], s[1]);
            var l, d = c._length;
            for (l = 1; l < d; l += 1)
              o = t.applyToTriplePoints(c.o[l - 1], c.i[l], c.v[l]), r.bezierCurveTo(o[0], o[1], o[2], o[3], o[4], o[5]);
            o = t.applyToTriplePoints(c.o[l - 1], c.i[0], c.v[0]), r.bezierCurveTo(o[0], o[1], o[2], o[3], o[4], o[5]);
          }
        this.element.globalData.renderer.save(!0), r.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var r = this.globalData.canvasContext, n = assetLoader.createCanvas(r.canvas.width, r.canvas.height);
          this.buffers.push(n);
          var a = assetLoader.createCanvas(r.canvas.width, r.canvas.height);
          this.buffers.push(a), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var r = this.globalData;
        if (r.blendMode !== this.data.bm) {
          r.blendMode = this.data.bm;
          var n = getBlendMode(this.data.bm);
          r.canvasContext.globalCompositeOperation = n;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(r) {
        r.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var r = this.buffers[0], n = r.getContext("2d");
          this.clearCanvas(n), n.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var r = this.buffers[1], n = r.getContext("2d");
          this.clearCanvas(n), n.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var a = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (a.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var s = assetLoader.getLumaCanvas(this.canvasContext.canvas), o = s.getContext("2d");
            o.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(s, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(r, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(r) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !r)) {
          this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
          var n = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(n), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(n), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(t, r, n, a) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var s = 4;
      r.ty === "rc" ? s = 5 : r.ty === "el" ? s = 6 : r.ty === "sr" && (s = 7), this.sh = ShapePropertyFactory.getShapeProp(t, r, s, t);
      var o, c = n.length, l;
      for (o = 0; o < c; o += 1)
        n[o].closed || (l = {
          transforms: a.addTransformSequence(n[o].transforms),
          trNodes: []
        }, this.styledShapes.push(l), n[o].elements.push(l));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(t, r) {
      var n = {
        data: t,
        type: t.ty,
        preTransforms: this.transformsManager.addTransformSequence(r),
        transforms: [],
        elements: [],
        closed: t.hd === !0
      }, a = {};
      if (t.ty === "fl" || t.ty === "st" ? (a.c = PropertyFactory.getProp(this, t.c, 1, 255, this), a.c.k || (n.co = "rgb(" + bmFloor(a.c.v[0]) + "," + bmFloor(a.c.v[1]) + "," + bmFloor(a.c.v[2]) + ")")) : (t.ty === "gf" || t.ty === "gs") && (a.s = PropertyFactory.getProp(this, t.s, 1, null, this), a.e = PropertyFactory.getProp(this, t.e, 1, null, this), a.h = PropertyFactory.getProp(this, t.h || {
        k: 0
      }, 0, 0.01, this), a.a = PropertyFactory.getProp(this, t.a || {
        k: 0
      }, 0, degToRads, this), a.g = new GradientProperty(this, t.g, this)), a.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this), t.ty === "st" || t.ty === "gs") {
        if (n.lc = lineCapEnum[t.lc || 2], n.lj = lineJoinEnum[t.lj || 2], t.lj == 1 && (n.ml = t.ml), a.w = PropertyFactory.getProp(this, t.w, 0, null, this), a.w.k || (n.wi = a.w.v), t.d) {
          var s = new DashProperty(this, t.d, "canvas", this);
          a.d = s, a.d.k || (n.da = a.d.dashArray, n.do = a.d.dashoffset[0]);
        }
      } else
        n.r = t.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(n), a.style = n, a;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var t = {
        it: [],
        prevViewData: []
      };
      return t;
    }, CVShapeElement.prototype.createTransformElement = function(t) {
      var r = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, t.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
        }
      };
      return r;
    }, CVShapeElement.prototype.createShapeElement = function(t) {
      var r = new CVShapeData(this, t, this.stylesList, this.transformsManager);
      return this.shapes.push(r), this.addShapeToModifiers(r), r;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var t, r = this.itemsData.length;
      for (t = 0; t < r; t += 1)
        this.prevViewData[t] = this.itemsData[t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), r = this.dynamicProperties.length, t = 0; t < r; t += 1)
        this.dynamicProperties[t].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
      var r, n = this.stylesList.length;
      for (r = 0; r < n; r += 1)
        this.stylesList[r].closed || this.stylesList[r].transforms.push(t);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var t, r = this.stylesList.length;
      for (t = 0; t < r; t += 1)
        this.stylesList[t].closed || this.stylesList[t].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1)
        t[r].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(t, r, n, a, s) {
      var o, c = t.length - 1, l, d, h = [], u = [], p, m, g, v = [].concat(s);
      for (o = c; o >= 0; o -= 1) {
        if (p = this.searchProcessedElement(t[o]), p ? r[o] = n[p - 1] : t[o]._shouldRender = a, t[o].ty === "fl" || t[o].ty === "st" || t[o].ty === "gf" || t[o].ty === "gs")
          p ? r[o].style.closed = !1 : r[o] = this.createStyleElement(t[o], v), h.push(r[o].style);
        else if (t[o].ty === "gr") {
          if (!p)
            r[o] = this.createGroupElement(t[o]);
          else
            for (d = r[o].it.length, l = 0; l < d; l += 1)
              r[o].prevViewData[l] = r[o].it[l];
          this.searchShapes(t[o].it, r[o].it, r[o].prevViewData, a, v);
        } else
          t[o].ty === "tr" ? (p || (g = this.createTransformElement(t[o]), r[o] = g), v.push(r[o]), this.addTransformToStyleList(r[o])) : t[o].ty === "sh" || t[o].ty === "rc" || t[o].ty === "el" || t[o].ty === "sr" ? p || (r[o] = this.createShapeElement(t[o])) : t[o].ty === "tm" || t[o].ty === "rd" || t[o].ty === "pb" || t[o].ty === "zz" || t[o].ty === "op" ? (p ? (m = r[o], m.closed = !1) : (m = ShapeModifiers.getModifier(t[o].ty), m.init(this, t[o]), r[o] = m, this.shapeModifiers.push(m)), u.push(m)) : t[o].ty === "rp" && (p ? (m = r[o], m.closed = !0) : (m = ShapeModifiers.getModifier(t[o].ty), r[o] = m, m.init(this, t, o, r), this.shapeModifiers.push(m), a = !1), u.push(m));
        this.addProcessedElement(t[o], o + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(h), c = u.length, o = 0; o < c; o += 1)
        u[o].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(t, r) {
      (t._opMdf || r.op._mdf || this._isFirstFrame) && (r.opacity = t.opacity, r.opacity *= r.op.v, r._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var t, r = this.stylesList.length, n, a, s, o, c, l, d = this.globalData.renderer, h = this.globalData.canvasContext, u, p;
      for (t = 0; t < r; t += 1)
        if (p = this.stylesList[t], u = p.type, !((u === "st" || u === "gs") && p.wi === 0 || !p.data._shouldRender || p.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (d.save(), c = p.elements, u === "st" || u === "gs" ? (d.ctxStrokeStyle(u === "st" ? p.co : p.grd), d.ctxLineWidth(p.wi), d.ctxLineCap(p.lc), d.ctxLineJoin(p.lj), d.ctxMiterLimit(p.ml || 0)) : d.ctxFillStyle(u === "fl" ? p.co : p.grd), d.ctxOpacity(p.coOp), u !== "st" && u !== "gs" && h.beginPath(), d.ctxTransform(p.preTransforms.finalTransform.props), a = c.length, n = 0; n < a; n += 1) {
            for ((u === "st" || u === "gs") && (h.beginPath(), p.da && (h.setLineDash(p.da), h.lineDashOffset = p.do)), l = c[n].trNodes, o = l.length, s = 0; s < o; s += 1)
              l[s].t === "m" ? h.moveTo(l[s].p[0], l[s].p[1]) : l[s].t === "c" ? h.bezierCurveTo(l[s].pts[0], l[s].pts[1], l[s].pts[2], l[s].pts[3], l[s].pts[4], l[s].pts[5]) : h.closePath();
            (u === "st" || u === "gs") && (d.ctxStroke(), p.da && h.setLineDash(this.dashResetter));
          }
          u !== "st" && u !== "gs" && this.globalData.renderer.ctxFill(p.r), d.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(t, r, n, a) {
      var s, o = r.length - 1, c;
      for (c = t, s = o; s >= 0; s -= 1)
        r[s].ty === "tr" ? (c = n[s].transform, this.renderShapeTransform(t, c)) : r[s].ty === "sh" || r[s].ty === "el" || r[s].ty === "rc" || r[s].ty === "sr" ? this.renderPath(r[s], n[s]) : r[s].ty === "fl" ? this.renderFill(r[s], n[s], c) : r[s].ty === "st" ? this.renderStroke(r[s], n[s], c) : r[s].ty === "gf" || r[s].ty === "gs" ? this.renderGradientFill(r[s], n[s], c) : r[s].ty === "gr" ? this.renderShape(c, r[s].it, n[s].it) : r[s].ty;
      a && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(t, r) {
      if (this._isFirstFrame || r._mdf || t.transforms._mdf) {
        var n = t.trNodes, a = r.paths, s, o, c, l = a._length;
        n.length = 0;
        var d = t.transforms.finalTransform;
        for (c = 0; c < l; c += 1) {
          var h = a.shapes[c];
          if (h && h.v) {
            for (o = h._length, s = 1; s < o; s += 1)
              s === 1 && n.push({
                t: "m",
                p: d.applyToPointArray(h.v[0][0], h.v[0][1], 0)
              }), n.push({
                t: "c",
                pts: d.applyToTriplePoints(h.o[s - 1], h.i[s], h.v[s])
              });
            o === 1 && n.push({
              t: "m",
              p: d.applyToPointArray(h.v[0][0], h.v[0][1], 0)
            }), h.c && o && (n.push({
              t: "c",
              pts: d.applyToTriplePoints(h.o[s - 1], h.i[0], h.v[0])
            }), n.push({
              t: "z"
            }));
          }
        }
        t.trNodes = n;
      }
    }, CVShapeElement.prototype.renderPath = function(t, r) {
      if (t.hd !== !0 && t._shouldRender) {
        var n, a = r.styledShapes.length;
        for (n = 0; n < a; n += 1)
          this.renderStyledShape(r.styledShapes[n], r.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(t, r, n) {
      var a = r.style;
      (r.c._mdf || this._isFirstFrame) && (a.co = "rgb(" + bmFloor(r.c.v[0]) + "," + bmFloor(r.c.v[1]) + "," + bmFloor(r.c.v[2]) + ")"), (r.o._mdf || n._opMdf || this._isFirstFrame) && (a.coOp = r.o.v * n.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(t, r, n) {
      var a = r.style, s;
      if (!a.grd || r.g._mdf || r.s._mdf || r.e._mdf || t.t !== 1 && (r.h._mdf || r.a._mdf)) {
        var o = this.globalData.canvasContext, c = r.s.v, l = r.e.v;
        if (t.t === 1)
          s = o.createLinearGradient(c[0], c[1], l[0], l[1]);
        else {
          var d = Math.sqrt(Math.pow(c[0] - l[0], 2) + Math.pow(c[1] - l[1], 2)), h = Math.atan2(l[1] - c[1], l[0] - c[0]), u = r.h.v;
          u >= 1 ? u = 0.99 : u <= -1 && (u = -0.99);
          var p = d * u, m = Math.cos(h + r.a.v) * p + c[0], g = Math.sin(h + r.a.v) * p + c[1];
          s = o.createRadialGradient(m, g, 0, c[0], c[1], d);
        }
        var v, y = t.g.p, x = r.g.c, _ = 1;
        for (v = 0; v < y; v += 1)
          r.g._hasOpacity && r.g._collapsable && (_ = r.g.o[v * 2 + 1]), s.addColorStop(x[v * 4] / 100, "rgba(" + x[v * 4 + 1] + "," + x[v * 4 + 2] + "," + x[v * 4 + 3] + "," + _ + ")");
        a.grd = s;
      }
      a.coOp = r.o.v * n.opacity;
    }, CVShapeElement.prototype.renderStroke = function(t, r, n) {
      var a = r.style, s = r.d;
      s && (s._mdf || this._isFirstFrame) && (a.da = s.dashArray, a.do = s.dashoffset[0]), (r.c._mdf || this._isFirstFrame) && (a.co = "rgb(" + bmFloor(r.c.v[0]) + "," + bmFloor(r.c.v[1]) + "," + bmFloor(r.c.v[2]) + ")"), (r.o._mdf || n._opMdf || this._isFirstFrame) && (a.coOp = r.o.v * n.opacity), (r.w._mdf || this._isFirstFrame) && (a.wi = r.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(t, r, n) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
      var r = !1;
      t.fc ? (r = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = r;
      var n = !1;
      t.sc && (n = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
      var a = this.globalData.fontManager.getFontByName(t.f), s, o, c = t.l, l = this.mHelper;
      this.stroke = n, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, o = t.finalText.length;
      var d, h, u, p, m, g, v, y, x, _, $ = this.data.singleShape, b = t.tr * 1e-3 * t.finalSize, M = 0, C = 0, S = !0, A = 0;
      for (s = 0; s < o; s += 1) {
        d = this.globalData.fontManager.getCharData(t.finalText[s], a.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily), h = d && d.data || {}, l.reset(), $ && c[s].n && (M = -b, C += t.yOffset, C += S ? 1 : 0, S = !1), m = h.shapes ? h.shapes[0].it : [], v = m.length, l.scale(t.finalSize / 100, t.finalSize / 100), $ && this.applyTextPropertiesToMatrix(t, l, c[s].line, M, C), x = createSizedArray(v - 1);
        var D = 0;
        for (g = 0; g < v; g += 1)
          if (m[g].ty === "sh") {
            for (p = m[g].ks.k.i.length, y = m[g].ks.k, _ = [], u = 1; u < p; u += 1)
              u === 1 && _.push(l.applyToX(y.v[0][0], y.v[0][1], 0), l.applyToY(y.v[0][0], y.v[0][1], 0)), _.push(l.applyToX(y.o[u - 1][0], y.o[u - 1][1], 0), l.applyToY(y.o[u - 1][0], y.o[u - 1][1], 0), l.applyToX(y.i[u][0], y.i[u][1], 0), l.applyToY(y.i[u][0], y.i[u][1], 0), l.applyToX(y.v[u][0], y.v[u][1], 0), l.applyToY(y.v[u][0], y.v[u][1], 0));
            _.push(l.applyToX(y.o[u - 1][0], y.o[u - 1][1], 0), l.applyToY(y.o[u - 1][0], y.o[u - 1][1], 0), l.applyToX(y.i[0][0], y.i[0][1], 0), l.applyToY(y.i[0][0], y.i[0][1], 0), l.applyToX(y.v[0][0], y.v[0][1], 0), l.applyToY(y.v[0][0], y.v[0][1], 0)), x[D] = _, D += 1;
          }
        $ && (M += c[s].l, M += b), this.textSpans[A] ? this.textSpans[A].elem = x : this.textSpans[A] = {
          elem: x
        }, A += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var t = this.canvasContext;
      t.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var r, n, a, s, o, c, l = this.textAnimator.renderedLetters, d = this.textProperty.currentData.l;
      n = d.length;
      var h, u = null, p = null, m = null, g, v, y = this.globalData.renderer;
      for (r = 0; r < n; r += 1)
        if (!d[r].n) {
          if (h = l[r], h && (y.save(), y.ctxTransform(h.p), y.ctxOpacity(h.o)), this.fill) {
            for (h && h.fc ? u !== h.fc && (y.ctxFillStyle(h.fc), u = h.fc) : u !== this.values.fill && (u = this.values.fill, y.ctxFillStyle(this.values.fill)), g = this.textSpans[r].elem, s = g.length, this.globalData.canvasContext.beginPath(), a = 0; a < s; a += 1)
              for (v = g[a], c = v.length, this.globalData.canvasContext.moveTo(v[0], v[1]), o = 2; o < c; o += 6)
                this.globalData.canvasContext.bezierCurveTo(v[o], v[o + 1], v[o + 2], v[o + 3], v[o + 4], v[o + 5]);
            this.globalData.canvasContext.closePath(), y.ctxFill();
          }
          if (this.stroke) {
            for (h && h.sw ? m !== h.sw && (m = h.sw, y.ctxLineWidth(h.sw)) : m !== this.values.sWidth && (m = this.values.sWidth, y.ctxLineWidth(this.values.sWidth)), h && h.sc ? p !== h.sc && (p = h.sc, y.ctxStrokeStyle(h.sc)) : p !== this.values.stroke && (p = this.values.stroke, y.ctxStrokeStyle(this.values.stroke)), g = this.textSpans[r].elem, s = g.length, this.globalData.canvasContext.beginPath(), a = 0; a < s; a += 1)
              for (v = g[a], c = v.length, this.globalData.canvasContext.moveTo(v[0], v[1]), o = 2; o < c; o += 6)
                this.globalData.canvasContext.bezierCurveTo(v[o], v[o + 1], v[o + 2], v[o + 3], v[o + 4], v[o + 5]);
            this.globalData.canvasContext.closePath(), y.ctxStroke();
          }
          h && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.img = r.imageLoader.getAsset(this.assetData), this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var t = createTag("canvas");
        t.width = this.assetData.w, t.height = this.assetData.h;
        var r = t.getContext("2d"), n = this.img.width, a = this.img.height, s = n / a, o = this.assetData.w / this.assetData.h, c, l, d = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        s > o && d === "xMidYMid slice" || s < o && d !== "xMidYMid slice" ? (l = a, c = l * o) : (c = n, l = c / o), r.drawImage(this.img, (n - c) / 2, (a - l) / 2, c, l, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase() {
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
      return new CVShapeElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(t) {
      return new CVTextElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(t) {
      return new CVImageElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(t) {
      return new CVSolidElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
      t[0] === 1 && t[1] === 0 && t[4] === 0 && t[5] === 1 && t[12] === 0 && t[13] === 0 || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
      this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
      this.canvasContext.fillStyle = t;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
      this.canvasContext.strokeStyle = t;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
      this.canvasContext.lineWidth = t;
    }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
      this.canvasContext.lineCap = t;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
      this.canvasContext.lineJoin = t;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
      this.canvasContext.miterLimit = t;
    }, CanvasRendererBase.prototype.ctxFill = function(t) {
      this.canvasContext.fill(t);
    }, CanvasRendererBase.prototype.ctxFillRect = function(t, r, n, a) {
      this.canvasContext.fillRect(t, r, n, a);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(t) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t);
    }, CanvasRendererBase.prototype.configAnimation = function(t) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var r = this.animationItem.container.style;
        r.width = "100%", r.height = "100%";
        var n = "0px 0px 0px";
        r.transformOrigin = n, r.mozTransformOrigin = n, r.webkitTransformOrigin = n, r["-webkit-transform"] = n, r.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = {
        w: t.w,
        h: t.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(t, r) {
      this.reset();
      var n, a;
      t ? (n = t, a = r, this.canvasContext.canvas.width = n, this.canvasContext.canvas.height = a) : (this.animationItem.wrapper && this.animationItem.container ? (n = this.animationItem.wrapper.offsetWidth, a = this.animationItem.wrapper.offsetHeight) : (n = this.canvasContext.canvas.width, a = this.canvasContext.canvas.height), this.canvasContext.canvas.width = n * this.renderConfig.dpr, this.canvasContext.canvas.height = a * this.renderConfig.dpr);
      var s, o;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var c = this.renderConfig.preserveAspectRatio.split(" "), l = c[1] || "meet", d = c[0] || "xMidYMid", h = d.substr(0, 4), u = d.substr(4);
        s = n / a, o = this.transformCanvas.w / this.transformCanvas.h, o > s && l === "meet" || o < s && l === "slice" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = n / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = a / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = a / (this.transformCanvas.h / this.renderConfig.dpr)), h === "xMid" && (o < s && l === "meet" || o > s && l === "slice") ? this.transformCanvas.tx = (n - this.transformCanvas.w * (a / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : h === "xMax" && (o < s && l === "meet" || o > s && l === "slice") ? this.transformCanvas.tx = (n - this.transformCanvas.w * (a / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, u === "YMid" && (o > s && l === "meet" || o < s && l === "slice") ? this.transformCanvas.ty = (a - this.transformCanvas.h * (n / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : u === "YMax" && (o > s && l === "meet" || o < s && l === "slice") ? this.transformCanvas.ty = (a - this.transformCanvas.h * (n / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else
        this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = a / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var t, r = this.layers ? this.layers.length : 0;
      for (t = r - 1; t >= 0; t -= 1)
        this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(t, r) {
      if (!(this.renderedFrame === t && this.renderConfig.clearCanvas === !0 && !r || this.destroyed || t === -1)) {
        this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || r, this.globalData.projectInterface.currentFrame = t;
        var n, a = this.layers.length;
        for (this.completeLayers || this.checkLayers(t), n = a - 1; n >= 0; n -= 1)
          (this.completeLayers || this.elements[n]) && this.elements[n].prepareFrame(t - this.layers[n].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), n = a - 1; n >= 0; n -= 1)
            (this.completeLayers || this.elements[n]) && this.elements[n].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(t) {
      var r = this.elements;
      if (!(r[t] || this.layers[t].ty === 99)) {
        var n = this.createItem(this.layers[t], this, this.globalData);
        r[t] = n, n.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var t = this.pendingElements.pop();
        t.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
      var t, r = 15;
      for (t = 0; t < r; t += 1) {
        var n = new CanvasContext();
        this.stack[t] = n;
      }
      this._length = r, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
      var t = this._length * 2, r = 0;
      for (r = this._length; r < t; r += 1)
        this.stack[r] = new CanvasContext();
      this._length = t;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(t) {
      this.cArrPos -= 1;
      var r = this.stack[this.cArrPos], n = r.transform, a, s = this.cTr.props;
      for (a = 0; a < 16; a += 1)
        s[a] = n[a];
      if (t) {
        this.nativeContext.restore();
        var o = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = o.fillStyle, this.appliedStrokeStyle = o.strokeStyle, this.appliedLineWidth = o.lineWidth, this.appliedLineCap = o.lineCap, this.appliedLineJoin = o.lineJoin, this.appliedMiterLimit = o.miterLimit;
      }
      this.nativeContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]), (t || r.opacity !== -1 && this.currentOpacity !== r.opacity) && (this.nativeContext.globalAlpha = r.opacity, this.currentOpacity = r.opacity), this.currentFillStyle = r.fillStyle, this.currentStrokeStyle = r.strokeStyle, this.currentLineWidth = r.lineWidth, this.currentLineCap = r.lineCap, this.currentLineJoin = r.lineJoin, this.currentMiterLimit = r.miterLimit;
    }, CVContextData.prototype.save = function(t) {
      t && this.nativeContext.save();
      var r = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var n = this.stack[this.cArrPos], a;
      for (a = 0; a < 16; a += 1)
        n.transform[a] = r[a];
      this.cArrPos += 1;
      var s = this.stack[this.cArrPos];
      s.opacity = n.opacity, s.fillStyle = n.fillStyle, s.strokeStyle = n.strokeStyle, s.lineWidth = n.lineWidth, s.lineCap = n.lineCap, s.lineJoin = n.lineJoin, s.miterLimit = n.miterLimit;
    }, CVContextData.prototype.setOpacity = function(t) {
      this.stack[this.cArrPos].opacity = t;
    }, CVContextData.prototype.setContext = function(t) {
      this.nativeContext = t;
    }, CVContextData.prototype.fillStyle = function(t) {
      this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
    }, CVContextData.prototype.strokeStyle = function(t) {
      this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
    }, CVContextData.prototype.lineWidth = function(t) {
      this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
    }, CVContextData.prototype.lineCap = function(t) {
      this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
    }, CVContextData.prototype.lineJoin = function(t) {
      this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
    }, CVContextData.prototype.miterLimit = function(t) {
      this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
    }, CVContextData.prototype.transform = function(t) {
      this.transformMat.cloneFromProps(t);
      var r = this.cTr;
      this.transformMat.multiply(r), r.cloneFromProps(this.transformMat.props);
      var n = r.props;
      this.nativeContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]);
    }, CVContextData.prototype.opacity = function(t) {
      var r = this.stack[this.cArrPos].opacity;
      r *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== r && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = r);
    }, CVContextData.prototype.fill = function(t) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
    }, CVContextData.prototype.fillRect = function(t, r, n, a) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, r, n, a);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    };
    function CVCompElement(t, r, n) {
      this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var t = this.canvasContext;
      t.beginPath(), t.moveTo(0, 0), t.lineTo(this.data.w, 0), t.lineTo(this.data.w, this.data.h), t.lineTo(0, this.data.h), t.lineTo(0, 0), t.clip();
      var r, n = this.layers.length;
      for (r = n - 1; r >= 0; r -= 1)
        (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var t, r = this.layers.length;
      for (t = r - 1; t >= 0; t -= 1)
        this.elements[t] && this.elements[t].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(t) {
      return new CVCompElement(t, this.globalData, this);
    };
    function CanvasRenderer(t, r) {
      this.animationItem = t, this.renderConfig = {
        clearCanvas: r && r.clearCanvas !== void 0 ? r.clearCanvas : !0,
        context: r && r.context || null,
        progressiveLoad: r && r.progressiveLoad || !1,
        preserveAspectRatio: r && r.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: r && r.contentVisibility || "visible",
        className: r && r.className || "",
        id: r && r.id || "",
        runExpressions: !r || r.runExpressions === void 0 || r.runExpressions
      }, this.renderConfig.dpr = r && r.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = r && r.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
      return new CVCompElement(t, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var r = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var n = this.finalTransform.mat.toCSS();
          r.transform = n, r.webkitTransform = n;
        }
        this.finalTransform._opMdf && (r.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var t;
      this.data.hasMask ? (t = createNS("rect"), t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (t = createTag("div"), t.style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
    };
    function HShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, r, n), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var t;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
      else {
        t = createNS("svg");
        var r = this.comp.data ? this.comp.data : this.globalData.compSize;
        t.setAttribute("width", r.w), t.setAttribute("height", r.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
    }, HShapeElement.prototype.getTransformedPoint = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1)
        r = t[n].mProps.v.applyToPointArray(r[0], r[1], 0);
      return r;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, r) {
      var n = t.sh.v, a = t.transformers, s, o = n._length, c, l, d, h;
      if (!(o <= 1)) {
        for (s = 0; s < o - 1; s += 1)
          c = this.getTransformedPoint(a, n.v[s]), l = this.getTransformedPoint(a, n.o[s]), d = this.getTransformedPoint(a, n.i[s + 1]), h = this.getTransformedPoint(a, n.v[s + 1]), this.checkBounds(c, l, d, h, r);
        n.c && (c = this.getTransformedPoint(a, n.v[s]), l = this.getTransformedPoint(a, n.o[s]), d = this.getTransformedPoint(a, n.i[0]), h = this.getTransformedPoint(a, n.v[0]), this.checkBounds(c, l, d, h, r));
      }
    }, HShapeElement.prototype.checkBounds = function(t, r, n, a, s) {
      this.getBoundsOfCurve(t, r, n, a);
      var o = this.shapeBoundingBox;
      s.x = bmMin(o.left, s.x), s.xMax = bmMax(o.right, s.xMax), s.y = bmMin(o.top, s.y), s.yMax = bmMax(o.bottom, s.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(t, r, n, a) {
      for (var s = [[t[0], a[0]], [t[1], a[1]]], o, c, l, d, h, u, p, m = 0; m < 2; ++m)
        c = 6 * t[m] - 12 * r[m] + 6 * n[m], o = -3 * t[m] + 9 * r[m] - 9 * n[m] + 3 * a[m], l = 3 * r[m] - 3 * t[m], c |= 0, o |= 0, l |= 0, o === 0 && c === 0 || (o === 0 ? (d = -l / c, d > 0 && d < 1 && s[m].push(this.calculateF(d, t, r, n, a, m))) : (h = c * c - 4 * l * o, h >= 0 && (u = (-c + bmSqrt(h)) / (2 * o), u > 0 && u < 1 && s[m].push(this.calculateF(u, t, r, n, a, m)), p = (-c - bmSqrt(h)) / (2 * o), p > 0 && p < 1 && s[m].push(this.calculateF(p, t, r, n, a, m)))));
      this.shapeBoundingBox.left = bmMin.apply(null, s[0]), this.shapeBoundingBox.top = bmMin.apply(null, s[1]), this.shapeBoundingBox.right = bmMax.apply(null, s[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, s[1]);
    }, HShapeElement.prototype.calculateF = function(t, r, n, a, s, o) {
      return bmPow(1 - t, 3) * r[o] + 3 * bmPow(1 - t, 2) * t * n[o] + 3 * (1 - t) * bmPow(t, 2) * a[o] + bmPow(t, 3) * s[o];
    }, HShapeElement.prototype.calculateBoundingBox = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1)
        t[n] && t[n].sh ? this.calculateShapeBoundingBox(t[n], r) : t[n] && t[n].it ? this.calculateBoundingBox(t[n].it, r) : t[n] && t[n].style && t[n].w && this.expandStrokeBoundingBox(t[n].w, r);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, r) {
      var n = 0;
      if (t.keyframes) {
        for (var a = 0; a < t.keyframes.length; a += 1) {
          var s = t.keyframes[a].s;
          s > n && (n = s);
        }
        n *= t.mult;
      } else
        n = t.v * t.mult;
      r.x -= n, r.xMax += n, r.y -= n, r.yMax += n;
    }, HShapeElement.prototype.currentBoxContains = function(t) {
      return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var t = this.tempBoundingBox, r = 999999;
        if (t.x = r, t.xMax = -r, t.y = r, t.yMax = -r, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t))
          return;
        var n = !1;
        if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), n = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), n = !0), n || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
          this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var a = this.shapeCont.style, s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          a.transform = s, a.webkitTransform = s;
        }
      }
    };
    function HTextElement(t, r, n) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var t = createNS("g");
        this.maskedElement.appendChild(t), this.innerElem = t;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
      var r = this.innerElem.style, n = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
      r.fill = n, r.color = n, t.sc && (r.stroke = this.buildColor(t.sc), r.strokeWidth = t.sw + "px");
      var a = this.globalData.fontManager.getFontByName(t.f);
      if (!this.globalData.fontManager.chars)
        if (r.fontSize = t.finalSize + "px", r.lineHeight = t.finalSize + "px", a.fClass)
          this.innerElem.className = a.fClass;
        else {
          r.fontFamily = a.fFamily;
          var s = t.fWeight, o = t.fStyle;
          r.fontStyle = o, r.fontWeight = s;
        }
      var c, l, d = t.l;
      l = d.length;
      var h, u, p, m = this.mHelper, g, v = "", y = 0;
      for (c = 0; c < l; c += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[y] ? h = this.textPaths[y] : (h = createNS("path"), h.setAttribute("stroke-linecap", lineCapEnum[1]), h.setAttribute("stroke-linejoin", lineJoinEnum[2]), h.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[y] ? (u = this.textSpans[y], p = u.children[0]) : (u = createTag("div"), u.style.lineHeight = 0, p = createNS("svg"), p.appendChild(h), styleDiv(u)))) : this.isMasked ? h = this.textPaths[y] ? this.textPaths[y] : createNS("text") : this.textSpans[y] ? (u = this.textSpans[y], h = this.textPaths[y]) : (u = createTag("span"), styleDiv(u), h = createTag("span"), styleDiv(h), u.appendChild(h)), this.globalData.fontManager.chars) {
          var x = this.globalData.fontManager.getCharData(t.finalText[c], a.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily), _;
          if (x ? _ = x.data : _ = null, m.reset(), _ && _.shapes && _.shapes.length && (g = _.shapes[0].it, m.scale(t.finalSize / 100, t.finalSize / 100), v = this.createPathShape(m, g), h.setAttribute("d", v)), this.isMasked)
            this.innerElem.appendChild(h);
          else {
            if (this.innerElem.appendChild(u), _ && _.shapes) {
              document.body.appendChild(p);
              var $ = p.getBBox();
              p.setAttribute("width", $.width + 2), p.setAttribute("height", $.height + 2), p.setAttribute("viewBox", $.x - 1 + " " + ($.y - 1) + " " + ($.width + 2) + " " + ($.height + 2));
              var b = p.style, M = "translate(" + ($.x - 1) + "px," + ($.y - 1) + "px)";
              b.transform = M, b.webkitTransform = M, d[c].yOffset = $.y - 1;
            } else
              p.setAttribute("width", 1), p.setAttribute("height", 1);
            u.appendChild(p);
          }
        } else if (h.textContent = d[c].val, h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(h);
        else {
          this.innerElem.appendChild(u);
          var C = h.style, S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
          C.transform = S, C.webkitTransform = S;
        }
        this.isMasked ? this.textSpans[y] = h : this.textSpans[y] = u, this.textSpans[y].style.display = "block", this.textPaths[y] = h, y += 1;
      }
      for (; y < this.textSpans.length; )
        this.textSpans[y].style.display = "none", y += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var t;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
          var r = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          t.transform = r, t.webkitTransform = r;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var n, a, s = 0, o = this.textAnimator.renderedLetters, c = this.textProperty.currentData.l;
        a = c.length;
        var l, d, h;
        for (n = 0; n < a; n += 1)
          c[n].n ? s += 1 : (d = this.textSpans[n], h = this.textPaths[n], l = o[s], s += 1, l._mdf.m && (this.isMasked ? d.setAttribute("transform", l.m) : (d.style.webkitTransform = l.m, d.style.transform = l.m)), d.style.opacity = l.o, l.sw && l._mdf.sw && h.setAttribute("stroke-width", l.sw), l.sc && l._mdf.sc && h.setAttribute("stroke", l.sc), l.fc && l._mdf.fc && (h.setAttribute("fill", l.fc), h.style.color = l.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var u = this.innerElem.getBBox();
          this.currentBBox.w !== u.width && (this.currentBBox.w = u.width, this.svgElement.setAttribute("width", u.width)), this.currentBBox.h !== u.height && (this.currentBBox.h = u.height, this.svgElement.setAttribute("height", u.height));
          var p = 1;
          if (this.currentBBox.w !== u.width + p * 2 || this.currentBBox.h !== u.height + p * 2 || this.currentBBox.x !== u.x - p || this.currentBBox.y !== u.y - p) {
            this.currentBBox.w = u.width + p * 2, this.currentBBox.h = u.height + p * 2, this.currentBBox.x = u.x - p, this.currentBBox.y = u.y - p, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
            var m = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            t.transform = m, t.webkitTransform = m;
          }
        }
      }
    };
    function HCameraElement(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initHierarchy();
      var a = PropertyFactory.getProp;
      if (this.pe = a(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = a(this, t.ks.p.x, 1, 0, this), this.py = a(this, t.ks.p.y, 1, 0, this), this.pz = a(this, t.ks.p.z, 1, 0, this)) : this.p = a(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = a(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
        var s, o = t.ks.or.k.length;
        for (s = 0; s < o; s += 1)
          t.ks.or.k[s].to = null, t.ks.or.k[s].ti = null;
      }
      this.or = a(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = a(this, t.ks.rx, 0, degToRads, this), this.ry = a(this, t.ks.ry, 0, degToRads, this), this.rz = a(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var t, r = this.comp.threeDElements.length, n, a, s;
      for (t = 0; t < r; t += 1)
        if (n = this.comp.threeDElements[t], n.type === "3d") {
          a = n.perspectiveElem.style, s = n.container.style;
          var o = this.pe.v + "px", c = "0px 0px 0px", l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          a.perspective = o, a.webkitPerspective = o, s.transformOrigin = c, s.mozTransformOrigin = c, s.webkitTransformOrigin = c, a.transform = l, a.webkitTransform = l;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var t = this._isFirstFrame, r, n;
      if (this.hierarchy)
        for (n = this.hierarchy.length, r = 0; r < n; r += 1)
          t = this.hierarchy[r].finalTransform.mProp._mdf || t;
      if (t || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (n = this.hierarchy.length - 1, r = n; r >= 0; r -= 1) {
            var a = this.hierarchy[r].finalTransform.mProp;
            this.mat.translate(-a.p.v[0], -a.p.v[1], a.p.v[2]), this.mat.rotateX(-a.or.v[0]).rotateY(-a.or.v[1]).rotateZ(a.or.v[2]), this.mat.rotateX(-a.rx.v).rotateY(-a.ry.v).rotateZ(a.rz.v), this.mat.scale(1 / a.s.v[0], 1 / a.s.v[1], 1 / a.s.v[2]), this.mat.translate(a.a.v[0], a.a.v[1], a.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var s;
          this.p ? s = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : s = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var o = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)), c = [s[0] / o, s[1] / o, s[2] / o], l = Math.sqrt(c[2] * c[2] + c[0] * c[0]), d = Math.atan2(c[1], l), h = Math.atan2(c[0], -c[2]);
          this.mat.rotateY(h).rotateX(-d);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var u = !this._prevMat.equals(this.mat);
        if ((u || this.pe._mdf) && this.comp.threeDElements) {
          n = this.comp.threeDElements.length;
          var p, m, g;
          for (r = 0; r < n; r += 1)
            if (p = this.comp.threeDElements[r], p.type === "3d") {
              if (u) {
                var v = this.mat.toCSS();
                g = p.container.style, g.transform = v, g.webkitTransform = v;
              }
              this.pe._mdf && (m = p.perspectiveElem.style, m.perspective = this.pe.v + "px", m.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(t) {
      this.prepareProperties(t, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.initElement(t, r, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var t = this.globalData.getAssetsPath(this.assetData), r = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(r), r.crossOrigin = "anonymous", r.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: r && r.className || "",
        imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(r && r.hideOnTransparent === !1),
        filterSize: {
          width: r && r.filterSize && r.filterSize.width || "400%",
          height: r && r.filterSize && r.filterSize.height || "400%",
          x: r && r.filterSize && r.filterSize.x || "-100%",
          y: r && r.filterSize && r.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var t = this.pendingElements.pop();
        t.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(t, r) {
      var n = t.getBaseElement();
      if (n) {
        var a = this.layers[r];
        if (!a.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(n, r);
          else {
            for (var s = 0, o, c, l; s < r; )
              this.elements[s] && this.elements[s] !== !0 && this.elements[s].getBaseElement && (c = this.elements[s], l = this.layers[s].ddd ? this.getThreeDContainerByPos(s) : c.getBaseElement(), o = l || o), s += 1;
            o ? (!a.ddd || !this.supports3d) && this.layerElement.insertBefore(n, o) : (!a.ddd || !this.supports3d) && this.layerElement.appendChild(n);
          }
        else
          this.addTo3dContainer(n, r);
      }
    }, HybridRendererBase.prototype.createShape = function(t) {
      return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(t) {
      return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(t) {
      return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(t) {
      return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(t) {
      return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
      for (var r = 0, n = this.threeDElements.length; r < n; ) {
        if (this.threeDElements[r].startPos <= t && this.threeDElements[r].endPos >= t)
          return this.threeDElements[r].perspectiveElem;
        r += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(t, r) {
      var n = createTag("div"), a, s;
      styleDiv(n);
      var o = createTag("div");
      if (styleDiv(o), r === "3d") {
        a = n.style, a.width = this.globalData.compSize.w + "px", a.height = this.globalData.compSize.h + "px";
        var c = "50% 50%";
        a.webkitTransformOrigin = c, a.mozTransformOrigin = c, a.transformOrigin = c, s = o.style;
        var l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        s.transform = l, s.webkitTransform = l;
      }
      n.appendChild(o);
      var d = {
        container: o,
        perspectiveElem: n,
        startPos: t,
        endPos: t,
        type: r
      };
      return this.threeDElements.push(d), d;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var t, r = this.layers.length, n, a = "";
      for (t = 0; t < r; t += 1)
        this.layers[t].ddd && this.layers[t].ty !== 3 ? (a !== "3d" && (a = "3d", n = this.createThreeDContainer(t, "3d")), n.endPos = Math.max(n.endPos, t)) : (a !== "2d" && (a = "2d", n = this.createThreeDContainer(t, "2d")), n.endPos = Math.max(n.endPos, t));
      for (r = this.threeDElements.length, t = r - 1; t >= 0; t -= 1)
        this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(t, r) {
      for (var n = 0, a = this.threeDElements.length; n < a; ) {
        if (r <= this.threeDElements[n].endPos) {
          for (var s = this.threeDElements[n].startPos, o; s < r; )
            this.elements[s] && this.elements[s].getBaseElement && (o = this.elements[s].getBaseElement()), s += 1;
          o ? this.threeDElements[n].container.insertBefore(t, o) : this.threeDElements[n].container.appendChild(t);
          break;
        }
        n += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(t) {
      var r = createTag("div"), n = this.animationItem.wrapper, a = r.style;
      a.width = t.w + "px", a.height = t.h + "px", this.resizerElem = r, styleDiv(r), a.transformStyle = "flat", a.mozTransformStyle = "flat", a.webkitTransformStyle = "flat", this.renderConfig.className && r.setAttribute("class", this.renderConfig.className), n.appendChild(r), a.overflow = "hidden";
      var s = createNS("svg");
      s.setAttribute("width", "1"), s.setAttribute("height", "1"), styleDiv(s), this.resizerElem.appendChild(s);
      var o = createNS("defs");
      s.appendChild(o), this.data = t, this.setupGlobalData(t, s), this.globalData.defs = o, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var t, r = this.layers ? this.layers.length : 0;
      for (t = 0; t < r; t += 1)
        this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var t = this.animationItem.wrapper.offsetWidth, r = this.animationItem.wrapper.offsetHeight, n = t / r, a = this.globalData.compSize.w / this.globalData.compSize.h, s, o, c, l;
      a > n ? (s = t / this.globalData.compSize.w, o = t / this.globalData.compSize.w, c = 0, l = (r - this.globalData.compSize.h * (t / this.globalData.compSize.w)) / 2) : (s = r / this.globalData.compSize.h, o = r / this.globalData.compSize.h, c = (t - this.globalData.compSize.w * (r / this.globalData.compSize.h)) / 2, l = 0);
      var d = this.resizerElem.style;
      d.webkitTransform = "matrix3d(" + s + ",0,0,0,0," + o + ",0,0,0,0,1,0," + c + "," + l + ",0,1)", d.transform = d.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var t = this.globalData.compSize.w, r = this.globalData.compSize.h, n, a = this.threeDElements.length;
        for (n = 0; n < a; n += 1) {
          var s = this.threeDElements[n].perspectiveElem.style;
          s.webkitPerspective = Math.sqrt(Math.pow(t, 2) + Math.pow(r, 2)) + "px", s.perspective = s.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
      var r, n = t.length, a = createTag("div");
      for (r = 0; r < n; r += 1)
        if (t[r].xt) {
          var s = this.createComp(t[r], a, this.globalData.comp, null);
          s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
        }
    };
    function HCompElement(t, r, n) {
      this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(t, r) {
      for (var n = 0, a; n < r; )
        this.elements[n] && this.elements[n].getBaseElement && (a = this.elements[n].getBaseElement()), n += 1;
      a ? this.layerElement.insertBefore(t, a) : this.layerElement.appendChild(t);
    }, HCompElement.prototype.createComp = function(t) {
      return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
    };
    function HybridRenderer(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: r && r.className || "",
        imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(r && r.hideOnTransparent === !1),
        filterSize: {
          width: r && r.filterSize && r.filterSize.width || "400%",
          height: r && r.filterSize && r.filterSize.height || "400%",
          x: r && r.filterSize && r.filterSize.x || "-100%",
          y: r && r.filterSize && r.filterSize.y || "-100%"
        },
        runExpressions: !r || r.runExpressions === void 0 || r.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
      return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
    };
    var CompExpressionInterface = function() {
      return function(t) {
        function r(n) {
          for (var a = 0, s = t.layers.length; a < s; ) {
            if (t.layers[a].nm === n || t.layers[a].ind === n)
              return t.elements[a].layerInterface;
            a += 1;
          }
          return null;
        }
        return Object.defineProperty(r, "_name", {
          value: t.data.nm
        }), r.layer = r, r.pixelAspect = 1, r.height = t.data.h || t.globalData.compSize.h, r.width = t.data.w || t.globalData.compSize.w, r.pixelAspect = 1, r.frameDuration = 1 / t.globalData.frameRate, r.displayStartTime = 0, r.numLayers = t.layers.length, r;
      };
    }();
    function _typeof$2(t) {
      "@babel/helpers - typeof";
      return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$2(t);
    }
    function seedRandom(t, r) {
      var n = this, a = 256, s = 6, o = 52, c = "random", l = r.pow(a, s), d = r.pow(2, o), h = d * 2, u = a - 1, p;
      function m(b, M, C) {
        var S = [];
        M = M === !0 ? {
          entropy: !0
        } : M || {};
        var A = x(y(M.entropy ? [b, $(t)] : b === null ? _() : b, 3), S), D = new g(S), N = function() {
          for (var R = D.g(s), F = l, z = 0; R < d; )
            R = (R + z) * a, F *= a, z = D.g(1);
          for (; R >= h; )
            R /= 2, F /= 2, z >>>= 1;
          return (R + z) / F;
        };
        return N.int32 = function() {
          return D.g(4) | 0;
        }, N.quick = function() {
          return D.g(4) / 4294967296;
        }, N.double = N, x($(D.S), t), (M.pass || C || function(T, R, F, z) {
          return z && (z.S && v(z, D), T.state = function() {
            return v(D, {});
          }), F ? (r[c] = T, R) : T;
        })(N, A, "global" in M ? M.global : this == r, M.state);
      }
      r["seed" + c] = m;
      function g(b) {
        var M, C = b.length, S = this, A = 0, D = S.i = S.j = 0, N = S.S = [];
        for (C || (b = [C++]); A < a; )
          N[A] = A++;
        for (A = 0; A < a; A++)
          N[A] = N[D = u & D + b[A % C] + (M = N[A])], N[D] = M;
        S.g = function(T) {
          for (var R, F = 0, z = S.i, O = S.j, G = S.S; T--; )
            R = G[z = u & z + 1], F = F * a + G[u & (G[z] = G[O = u & O + R]) + (G[O] = R)];
          return S.i = z, S.j = O, F;
        };
      }
      function v(b, M) {
        return M.i = b.i, M.j = b.j, M.S = b.S.slice(), M;
      }
      function y(b, M) {
        var C = [], S = _typeof$2(b), A;
        if (M && S == "object")
          for (A in b)
            try {
              C.push(y(b[A], M - 1));
            } catch {
            }
        return C.length ? C : S == "string" ? b : b + "\0";
      }
      function x(b, M) {
        for (var C = b + "", S, A = 0; A < C.length; )
          M[u & A] = u & (S ^= M[u & A] * 19) + C.charCodeAt(A++);
        return $(M);
      }
      function _() {
        try {
          var b = new Uint8Array(a);
          return (n.crypto || n.msCrypto).getRandomValues(b), $(b);
        } catch {
          var M = n.navigator, C = M && M.plugins;
          return [+/* @__PURE__ */ new Date(), n, C, n.screen, $(t)];
        }
      }
      function $(b) {
        return String.fromCharCode.apply(0, b);
      }
      x(r.random(), t);
    }
    function initialize$2(t) {
      seedRandom([], t);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof$1(t) {
      "@babel/helpers - typeof";
      return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$1(t);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      initialize$2(BMMath);
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(t) {
        return t.constructor === Array || t.constructor === Float32Array;
      }
      function isNumerable(t, r) {
        return t === "number" || r instanceof Number || t === "boolean" || t === "string";
      }
      function $bm_neg(t) {
        var r = _typeof$1(t);
        if (r === "number" || t instanceof Number || r === "boolean")
          return -t;
        if ($bm_isInstanceOfArray(t)) {
          var n, a = t.length, s = [];
          for (n = 0; n < a; n += 1)
            s[n] = -t[n];
          return s;
        }
        return t.propType ? t.v : -t;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r);
        if (isNumerable(n, t) && isNumerable(a, r) || n === "string" || a === "string")
          return t + r;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r))
          return t = t.slice(0), t[0] += r, t;
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r))
          return r = r.slice(0), r[0] = t + r[0], r;
        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(r)) {
          for (var s = 0, o = t.length, c = r.length, l = []; s < o || s < c; )
            (typeof t[s] == "number" || t[s] instanceof Number) && (typeof r[s] == "number" || r[s] instanceof Number) ? l[s] = t[s] + r[s] : l[s] = r[s] === void 0 ? t[s] : t[s] || r[s], s += 1;
          return l;
        }
        return 0;
      }
      var add = sum;
      function sub(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r);
        if (isNumerable(n, t) && isNumerable(a, r))
          return n === "string" && (t = parseInt(t, 10)), a === "string" && (r = parseInt(r, 10)), t - r;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r))
          return t = t.slice(0), t[0] -= r, t;
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r))
          return r = r.slice(0), r[0] = t - r[0], r;
        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(r)) {
          for (var s = 0, o = t.length, c = r.length, l = []; s < o || s < c; )
            (typeof t[s] == "number" || t[s] instanceof Number) && (typeof r[s] == "number" || r[s] instanceof Number) ? l[s] = t[s] - r[s] : l[s] = r[s] === void 0 ? t[s] : t[s] || r[s], s += 1;
          return l;
        }
        return 0;
      }
      function mul(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r), s;
        if (isNumerable(n, t) && isNumerable(a, r))
          return t * r;
        var o, c;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r)) {
          for (c = t.length, s = createTypedArray("float32", c), o = 0; o < c; o += 1)
            s[o] = t[o] * r;
          return s;
        }
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r)) {
          for (c = r.length, s = createTypedArray("float32", c), o = 0; o < c; o += 1)
            s[o] = t * r[o];
          return s;
        }
        return 0;
      }
      function div(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r), s;
        if (isNumerable(n, t) && isNumerable(a, r))
          return t / r;
        var o, c;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r)) {
          for (c = t.length, s = createTypedArray("float32", c), o = 0; o < c; o += 1)
            s[o] = t[o] / r;
          return s;
        }
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r)) {
          for (c = r.length, s = createTypedArray("float32", c), o = 0; o < c; o += 1)
            s[o] = t / r[o];
          return s;
        }
        return 0;
      }
      function mod(t, r) {
        return typeof t == "string" && (t = parseInt(t, 10)), typeof r == "string" && (r = parseInt(r, 10)), t % r;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(t, r, n) {
        if (r > n) {
          var a = n;
          n = r, r = a;
        }
        return Math.min(Math.max(t, r), n);
      }
      function radiansToDegrees(t) {
        return t / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(t) {
        return t * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(t, r) {
        if (typeof t == "number" || t instanceof Number)
          return r = r || 0, Math.abs(t - r);
        r || (r = helperLengthArray);
        var n, a = Math.min(t.length, r.length), s = 0;
        for (n = 0; n < a; n += 1)
          s += Math.pow(r[n] - t[n], 2);
        return Math.sqrt(s);
      }
      function normalize(t) {
        return div(t, length(t));
      }
      function rgbToHsl(t) {
        var r = t[0], n = t[1], a = t[2], s = Math.max(r, n, a), o = Math.min(r, n, a), c, l, d = (s + o) / 2;
        if (s === o)
          c = 0, l = 0;
        else {
          var h = s - o;
          switch (l = d > 0.5 ? h / (2 - s - o) : h / (s + o), s) {
            case r:
              c = (n - a) / h + (n < a ? 6 : 0);
              break;
            case n:
              c = (a - r) / h + 2;
              break;
            case a:
              c = (r - n) / h + 4;
              break;
          }
          c /= 6;
        }
        return [c, l, d, t[3]];
      }
      function hue2rgb(t, r, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (r - t) * 6 * n : n < 1 / 2 ? r : n < 2 / 3 ? t + (r - t) * (2 / 3 - n) * 6 : t;
      }
      function hslToRgb(t) {
        var r = t[0], n = t[1], a = t[2], s, o, c;
        if (n === 0)
          s = a, c = a, o = a;
        else {
          var l = a < 0.5 ? a * (1 + n) : a + n - a * n, d = 2 * a - l;
          s = hue2rgb(d, l, r + 1 / 3), o = hue2rgb(d, l, r), c = hue2rgb(d, l, r - 1 / 3);
        }
        return [s, o, c, t[3]];
      }
      function linear(t, r, n, a, s) {
        if ((a === void 0 || s === void 0) && (a = r, s = n, r = 0, n = 1), n < r) {
          var o = n;
          n = r, r = o;
        }
        if (t <= r)
          return a;
        if (t >= n)
          return s;
        var c = n === r ? 0 : (t - r) / (n - r);
        if (!a.length)
          return a + (s - a) * c;
        var l, d = a.length, h = createTypedArray("float32", d);
        for (l = 0; l < d; l += 1)
          h[l] = a[l] + (s[l] - a[l]) * c;
        return h;
      }
      function random(t, r) {
        if (r === void 0 && (t === void 0 ? (t = 0, r = 1) : (r = t, t = void 0)), r.length) {
          var n, a = r.length;
          t || (t = createTypedArray("float32", a));
          var s = createTypedArray("float32", a), o = BMMath.random();
          for (n = 0; n < a; n += 1)
            s[n] = t[n] + o * (r[n] - t[n]);
          return s;
        }
        t === void 0 && (t = 0);
        var c = BMMath.random();
        return t + c * (r - t);
      }
      function createPath(t, r, n, a) {
        var s, o = t.length, c = shapePool.newElement();
        c.setPathData(!!a, o);
        var l = [0, 0], d, h;
        for (s = 0; s < o; s += 1)
          d = r && r[s] ? r[s] : l, h = n && n[s] ? n[s] : l, c.setTripleAt(t[s][0], t[s][1], h[0] + t[s][0], h[1] + t[s][1], d[0] + t[s][0], d[1] + t[s][1], s, !0);
        return c;
      }
      function initiateExpression(elem, data, property) {
        function noOp(t) {
          return t;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty._name = elem.data.nm, thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function t(r, n) {
          var a, s, o = this.pv.length ? this.pv.length : 1, c = createTypedArray("float32", o);
          r = 5;
          var l = Math.floor(time * r);
          for (a = 0, s = 0; a < l; ) {
            for (s = 0; s < o; s += 1)
              c[s] += -n + n * 2 * BMMath.random();
            a += 1;
          }
          var d = time * r, h = d - Math.floor(d), u = createTypedArray("float32", o);
          if (o > 1) {
            for (s = 0; s < o; s += 1)
              u[s] = this.pv[s] + c[s] + (-n + n * 2 * BMMath.random()) * h;
            return u;
          }
          return this.pv + c[0] + (-n + n * 2 * BMMath.random()) * h;
        }).bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(t, r) {
          return loopIn(t, r, !0);
        }
        function loopOutDuration(t, r) {
          return loopOut(t, r, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(t, r) {
          var n = [r[0] - t[0], r[1] - t[1], r[2] - t[2]], a = Math.atan2(n[0], Math.sqrt(n[1] * n[1] + n[2] * n[2])) / degToRads, s = -Math.atan2(n[1], n[2]) / degToRads;
          return [s, a, 0];
        }
        function easeOut(t, r, n, a, s) {
          return applyEase(easeOutBez, t, r, n, a, s);
        }
        function easeIn(t, r, n, a, s) {
          return applyEase(easeInBez, t, r, n, a, s);
        }
        function ease(t, r, n, a, s) {
          return applyEase(easeInOutBez, t, r, n, a, s);
        }
        function applyEase(t, r, n, a, s, o) {
          s === void 0 ? (s = n, o = a) : r = (r - n) / (a - n), r > 1 ? r = 1 : r < 0 && (r = 0);
          var c = t(r);
          if ($bm_isInstanceOfArray(s)) {
            var l, d = s.length, h = createTypedArray("float32", d);
            for (l = 0; l < d; l += 1)
              h[l] = (o[l] - s[l]) * c + s[l];
            return h;
          }
          return (o - s) * c + s;
        }
        function nearestKey(t) {
          var r, n = data.k.length, a, s;
          if (!data.k.length || typeof data.k[0] == "number")
            a = 0, s = 0;
          else if (a = -1, t *= elem.comp.globalData.frameRate, t < data.k[0].t)
            a = 1, s = data.k[0].t;
          else {
            for (r = 0; r < n - 1; r += 1)
              if (t === data.k[r].t) {
                a = r + 1, s = data.k[r].t;
                break;
              } else if (t > data.k[r].t && t < data.k[r + 1].t) {
                t - data.k[r].t > data.k[r + 1].t - t ? (a = r + 2, s = data.k[r + 1].t) : (a = r + 1, s = data.k[r].t);
                break;
              }
            a === -1 && (a = r + 1, s = data.k[r].t);
          }
          var o = {};
          return o.index = a, o.time = s / elem.comp.globalData.frameRate, o;
        }
        function key(t) {
          var r, n, a;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + t);
          t -= 1, r = {
            time: data.k[t].t / elem.comp.globalData.frameRate,
            value: []
          };
          var s = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
          for (a = s.length, n = 0; n < a; n += 1)
            r[n] = s[n], r.value[n] = s[n];
          return r;
        }
        function framesToTime(t, r) {
          return r || (r = elem.comp.globalData.frameRate), t / r;
        }
        function timeToFrames(t, r) {
          return !t && t !== 0 && (t = time), r || (r = elem.comp.globalData.frameRate), t * r;
        }
        function seedRandom(t) {
          BMMath.seedrandom(randSeed + t);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(t, r) {
          return typeof value == "string" ? r === void 0 ? value.substring(t) : value.substring(t, r) : "";
        }
        function substr(t, r) {
          return typeof value == "string" ? r === void 0 ? value.substr(t) : value.substr(t, r) : "";
        }
        function posterizeTime(t) {
          time = t === 0 ? 0 : Math.floor(time * t) / t, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(t) {
          return value = t, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var t = {};
      t.initExpressions = r, t.resetFrame = ExpressionManager.resetFrame;
      function r(n) {
        var a = 0, s = [];
        function o() {
          a += 1;
        }
        function c() {
          a -= 1, a === 0 && d();
        }
        function l(h) {
          s.indexOf(h) === -1 && s.push(h);
        }
        function d() {
          var h, u = s.length;
          for (h = 0; h < u; h += 1)
            s[h].release();
          s.length = 0;
        }
        n.renderer.compInterface = CompExpressionInterface(n.renderer), n.renderer.globalData.projectInterface.registerComposition(n.renderer), n.renderer.globalData.pushExpression = o, n.renderer.globalData.popExpression = c, n.renderer.globalData.registerExpressionProperty = l;
      }
      return t;
    }(), MaskManagerInterface = function() {
      function t(n, a) {
        this._mask = n, this._data = a;
      }
      Object.defineProperty(t.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(t.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var r = function(a) {
        var s = createSizedArray(a.viewData.length), o, c = a.viewData.length;
        for (o = 0; o < c; o += 1)
          s[o] = new t(a.viewData[o], a.masksProperties[o]);
        var l = function(h) {
          for (o = 0; o < c; ) {
            if (a.masksProperties[o].nm === h)
              return s[o];
            o += 1;
          }
          return null;
        };
        return l;
      };
      return r;
    }(), ExpressionPropertyInterface = function() {
      var t = {
        pv: 0,
        v: 0,
        mult: 1
      }, r = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function n(c, l, d) {
        Object.defineProperty(c, "velocity", {
          get: function() {
            return l.getVelocityAtTime(l.comp.currentFrame);
          }
        }), c.numKeys = l.keyframes ? l.keyframes.length : 0, c.key = function(h) {
          if (!c.numKeys)
            return 0;
          var u = "";
          "s" in l.keyframes[h - 1] ? u = l.keyframes[h - 1].s : "e" in l.keyframes[h - 2] ? u = l.keyframes[h - 2].e : u = l.keyframes[h - 2].s;
          var p = d === "unidimensional" ? new Number(u) : Object.assign({}, u);
          return p.time = l.keyframes[h - 1].t / l.elem.comp.globalData.frameRate, p.value = d === "unidimensional" ? u[0] : u, p;
        }, c.valueAtTime = l.getValueAtTime, c.speedAtTime = l.getSpeedAtTime, c.velocityAtTime = l.getVelocityAtTime, c.propertyGroup = l.propertyGroup;
      }
      function a(c) {
        (!c || !("pv" in c)) && (c = t);
        var l = 1 / c.mult, d = c.pv * l, h = new Number(d);
        return h.value = d, n(h, c, "unidimensional"), function() {
          return c.k && c.getValue(), d = c.v * l, h.value !== d && (h = new Number(d), h.value = d, h[0] = d, n(h, c, "unidimensional")), h;
        };
      }
      function s(c) {
        (!c || !("pv" in c)) && (c = r);
        var l = 1 / c.mult, d = c.data && c.data.l || c.pv.length, h = createTypedArray("float32", d), u = createTypedArray("float32", d);
        return h.value = u, n(h, c, "multidimensional"), function() {
          c.k && c.getValue();
          for (var p = 0; p < d; p += 1)
            u[p] = c.v[p] * l, h[p] = u[p];
          return h;
        };
      }
      function o() {
        return t;
      }
      return function(c) {
        return c ? c.propType === "unidimensional" ? a(c) : s(c) : o;
      };
    }(), TransformExpressionInterface = function() {
      return function(t) {
        function r(c) {
          switch (c) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return r.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return r.rotation;
            case "ADBE Rotate X":
              return r.xRotation;
            case "ADBE Rotate Y":
              return r.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return r.position;
            case "ADBE Position_0":
              return r.xPosition;
            case "ADBE Position_1":
              return r.yPosition;
            case "ADBE Position_2":
              return r.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return r.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return r.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(r, "rotation", {
          get: ExpressionPropertyInterface(t.r || t.rz)
        }), Object.defineProperty(r, "zRotation", {
          get: ExpressionPropertyInterface(t.rz || t.r)
        }), Object.defineProperty(r, "xRotation", {
          get: ExpressionPropertyInterface(t.rx)
        }), Object.defineProperty(r, "yRotation", {
          get: ExpressionPropertyInterface(t.ry)
        }), Object.defineProperty(r, "scale", {
          get: ExpressionPropertyInterface(t.s)
        });
        var n, a, s, o;
        return t.p ? o = ExpressionPropertyInterface(t.p) : (n = ExpressionPropertyInterface(t.px), a = ExpressionPropertyInterface(t.py), t.pz && (s = ExpressionPropertyInterface(t.pz))), Object.defineProperty(r, "position", {
          get: function() {
            return t.p ? o() : [n(), a(), s ? s() : 0];
          }
        }), Object.defineProperty(r, "xPosition", {
          get: ExpressionPropertyInterface(t.px)
        }), Object.defineProperty(r, "yPosition", {
          get: ExpressionPropertyInterface(t.py)
        }), Object.defineProperty(r, "zPosition", {
          get: ExpressionPropertyInterface(t.pz)
        }), Object.defineProperty(r, "anchorPoint", {
          get: ExpressionPropertyInterface(t.a)
        }), Object.defineProperty(r, "opacity", {
          get: ExpressionPropertyInterface(t.o)
        }), Object.defineProperty(r, "skew", {
          get: ExpressionPropertyInterface(t.sk)
        }), Object.defineProperty(r, "skewAxis", {
          get: ExpressionPropertyInterface(t.sa)
        }), Object.defineProperty(r, "orientation", {
          get: ExpressionPropertyInterface(t.or)
        }), r;
      };
    }(), LayerExpressionInterface = function() {
      function t(h) {
        var u = new Matrix();
        if (h !== void 0) {
          var p = this._elem.finalTransform.mProp.getValueAtTime(h);
          p.clone(u);
        } else {
          var m = this._elem.finalTransform.mProp;
          m.applyToMatrix(u);
        }
        return u;
      }
      function r(h, u) {
        var p = this.getMatrix(u);
        return p.props[12] = 0, p.props[13] = 0, p.props[14] = 0, this.applyPoint(p, h);
      }
      function n(h, u) {
        var p = this.getMatrix(u);
        return this.applyPoint(p, h);
      }
      function a(h, u) {
        var p = this.getMatrix(u);
        return p.props[12] = 0, p.props[13] = 0, p.props[14] = 0, this.invertPoint(p, h);
      }
      function s(h, u) {
        var p = this.getMatrix(u);
        return this.invertPoint(p, h);
      }
      function o(h, u) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var p, m = this._elem.hierarchy.length;
          for (p = 0; p < m; p += 1)
            this._elem.hierarchy[p].finalTransform.mProp.applyToMatrix(h);
        }
        return h.applyToPointArray(u[0], u[1], u[2] || 0);
      }
      function c(h, u) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var p, m = this._elem.hierarchy.length;
          for (p = 0; p < m; p += 1)
            this._elem.hierarchy[p].finalTransform.mProp.applyToMatrix(h);
        }
        return h.inversePoint(u);
      }
      function l(h) {
        var u = new Matrix();
        if (u.reset(), this._elem.finalTransform.mProp.applyToMatrix(u), this._elem.hierarchy && this._elem.hierarchy.length) {
          var p, m = this._elem.hierarchy.length;
          for (p = 0; p < m; p += 1)
            this._elem.hierarchy[p].finalTransform.mProp.applyToMatrix(u);
          return u.inversePoint(h);
        }
        return u.inversePoint(h);
      }
      function d() {
        return [1, 1, 1, 1];
      }
      return function(h) {
        var u;
        function p(y) {
          g.mask = new MaskManagerInterface(y, h);
        }
        function m(y) {
          g.effect = y;
        }
        function g(y) {
          switch (y) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return g.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return u;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return g.effect;
            case "ADBE Text Properties":
              return g.textInterface;
            default:
              return null;
          }
        }
        g.getMatrix = t, g.invertPoint = c, g.applyPoint = o, g.toWorld = n, g.toWorldVec = r, g.fromWorld = s, g.fromWorldVec = a, g.toComp = n, g.fromComp = l, g.sampleImage = d, g.sourceRectAtTime = h.sourceRectAtTime.bind(h), g._elem = h, u = TransformExpressionInterface(h.finalTransform.mProp);
        var v = getDescriptor(u, "anchorPoint");
        return Object.defineProperties(g, {
          hasParent: {
            get: function() {
              return h.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return h.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(u, "rotation"),
          scale: getDescriptor(u, "scale"),
          position: getDescriptor(u, "position"),
          opacity: getDescriptor(u, "opacity"),
          anchorPoint: v,
          anchor_point: v,
          transform: {
            get: function() {
              return u;
            }
          },
          active: {
            get: function() {
              return h.isInRange;
            }
          }
        }), g.startTime = h.data.st, g.index = h.data.ind, g.source = h.data.refId, g.height = h.data.ty === 0 ? h.data.h : 100, g.width = h.data.ty === 0 ? h.data.w : 100, g.inPoint = h.data.ip / h.comp.globalData.frameRate, g.outPoint = h.data.op / h.comp.globalData.frameRate, g._name = h.data.nm, g.registerMaskInterface = p, g.registerEffectsInterface = m, g;
      };
    }(), propertyGroupFactory = function() {
      return function(t, r) {
        return function(n) {
          return n = n === void 0 ? 1 : n, n <= 0 ? t : r(n - 1);
        };
      };
    }(), PropertyInterface = function() {
      return function(t, r) {
        var n = {
          _name: t
        };
        function a(s) {
          return s = s === void 0 ? 1 : s, s <= 0 ? n : r(s - 1);
        }
        return a;
      };
    }(), EffectsExpressionInterface = function() {
      var t = {
        createEffectsInterface: r
      };
      function r(s, o) {
        if (s.effectsManager) {
          var c = [], l = s.data.ef, d, h = s.effectsManager.effectElements.length;
          for (d = 0; d < h; d += 1)
            c.push(n(l[d], s.effectsManager.effectElements[d], o, s));
          var u = s.data.ef || [], p = function(g) {
            for (d = 0, h = u.length; d < h; ) {
              if (g === u[d].nm || g === u[d].mn || g === u[d].ix)
                return c[d];
              d += 1;
            }
            return null;
          };
          return Object.defineProperty(p, "numProperties", {
            get: function() {
              return u.length;
            }
          }), p;
        }
        return null;
      }
      function n(s, o, c, l) {
        function d(g) {
          for (var v = s.ef, y = 0, x = v.length; y < x; ) {
            if (g === v[y].nm || g === v[y].mn || g === v[y].ix)
              return v[y].ty === 5 ? u[y] : u[y]();
            y += 1;
          }
          throw new Error();
        }
        var h = propertyGroupFactory(d, c), u = [], p, m = s.ef.length;
        for (p = 0; p < m; p += 1)
          s.ef[p].ty === 5 ? u.push(n(s.ef[p], o.effectElements[p], o.effectElements[p].propertyGroup, l)) : u.push(a(o.effectElements[p], s.ef[p].ty, l, h));
        return s.mn === "ADBE Color Control" && Object.defineProperty(d, "color", {
          get: function() {
            return u[0]();
          }
        }), Object.defineProperties(d, {
          numProperties: {
            get: function() {
              return s.np;
            }
          },
          _name: {
            value: s.nm
          },
          propertyGroup: {
            value: h
          }
        }), d.enabled = s.en !== 0, d.active = d.enabled, d;
      }
      function a(s, o, c, l) {
        var d = ExpressionPropertyInterface(s.p);
        function h() {
          return o === 10 ? c.comp.compInterface(s.p.v) : d();
        }
        return s.p.setGroupProperty && s.p.setGroupProperty(PropertyInterface("", l)), h;
      }
      return t;
    }(), ShapePathInterface = function() {
      return function(r, n, a) {
        var s = n.sh;
        function o(l) {
          return l === "Shape" || l === "shape" || l === "Path" || l === "path" || l === "ADBE Vector Shape" || l === 2 ? o.path : null;
        }
        var c = propertyGroupFactory(o, a);
        return s.setGroupProperty(PropertyInterface("Path", c)), Object.defineProperties(o, {
          path: {
            get: function() {
              return s.k && s.getValue(), s;
            }
          },
          shape: {
            get: function() {
              return s.k && s.getValue(), s;
            }
          },
          _name: {
            value: r.nm
          },
          ix: {
            value: r.ix
          },
          propertyIndex: {
            value: r.ix
          },
          mn: {
            value: r.mn
          },
          propertyGroup: {
            value: a
          }
        }), o;
      };
    }(), ShapeExpressionInterface = function() {
      function t(v, y, x) {
        var _ = [], $, b = v ? v.length : 0;
        for ($ = 0; $ < b; $ += 1)
          v[$].ty === "gr" ? _.push(n(v[$], y[$], x)) : v[$].ty === "fl" ? _.push(a(v[$], y[$], x)) : v[$].ty === "st" ? _.push(c(v[$], y[$], x)) : v[$].ty === "tm" ? _.push(l(v[$], y[$], x)) : v[$].ty === "tr" || (v[$].ty === "el" ? _.push(h(v[$], y[$], x)) : v[$].ty === "sr" ? _.push(u(v[$], y[$], x)) : v[$].ty === "sh" ? _.push(ShapePathInterface(v[$], y[$], x)) : v[$].ty === "rc" ? _.push(p(v[$], y[$], x)) : v[$].ty === "rd" ? _.push(m(v[$], y[$], x)) : v[$].ty === "rp" ? _.push(g(v[$], y[$], x)) : v[$].ty === "gf" ? _.push(s(v[$], y[$], x)) : _.push(o(v[$], y[$])));
        return _;
      }
      function r(v, y, x) {
        var _, $ = function(C) {
          for (var S = 0, A = _.length; S < A; ) {
            if (_[S]._name === C || _[S].mn === C || _[S].propertyIndex === C || _[S].ix === C || _[S].ind === C)
              return _[S];
            S += 1;
          }
          return typeof C == "number" ? _[C - 1] : null;
        };
        $.propertyGroup = propertyGroupFactory($, x), _ = t(v.it, y.it, $.propertyGroup), $.numProperties = _.length;
        var b = d(v.it[v.it.length - 1], y.it[y.it.length - 1], $.propertyGroup);
        return $.transform = b, $.propertyIndex = v.cix, $._name = v.nm, $;
      }
      function n(v, y, x) {
        var _ = function(C) {
          switch (C) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return _.content;
            default:
              return _.transform;
          }
        };
        _.propertyGroup = propertyGroupFactory(_, x);
        var $ = r(v, y, _.propertyGroup), b = d(v.it[v.it.length - 1], y.it[y.it.length - 1], _.propertyGroup);
        return _.content = $, _.transform = b, Object.defineProperty(_, "_name", {
          get: function() {
            return v.nm;
          }
        }), _.numProperties = v.np, _.propertyIndex = v.ix, _.nm = v.nm, _.mn = v.mn, _;
      }
      function a(v, y, x) {
        function _($) {
          return $ === "Color" || $ === "color" ? _.color : $ === "Opacity" || $ === "opacity" ? _.opacity : null;
        }
        return Object.defineProperties(_, {
          color: {
            get: ExpressionPropertyInterface(y.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(y.o)
          },
          _name: {
            value: v.nm
          },
          mn: {
            value: v.mn
          }
        }), y.c.setGroupProperty(PropertyInterface("Color", x)), y.o.setGroupProperty(PropertyInterface("Opacity", x)), _;
      }
      function s(v, y, x) {
        function _($) {
          return $ === "Start Point" || $ === "start point" ? _.startPoint : $ === "End Point" || $ === "end point" ? _.endPoint : $ === "Opacity" || $ === "opacity" ? _.opacity : null;
        }
        return Object.defineProperties(_, {
          startPoint: {
            get: ExpressionPropertyInterface(y.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface(y.e)
          },
          opacity: {
            get: ExpressionPropertyInterface(y.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: v.nm
          },
          mn: {
            value: v.mn
          }
        }), y.s.setGroupProperty(PropertyInterface("Start Point", x)), y.e.setGroupProperty(PropertyInterface("End Point", x)), y.o.setGroupProperty(PropertyInterface("Opacity", x)), _;
      }
      function o() {
        function v() {
          return null;
        }
        return v;
      }
      function c(v, y, x) {
        var _ = propertyGroupFactory(A, x), $ = propertyGroupFactory(S, _);
        function b(D) {
          Object.defineProperty(S, v.d[D].nm, {
            get: ExpressionPropertyInterface(y.d.dataProps[D].p)
          });
        }
        var M, C = v.d ? v.d.length : 0, S = {};
        for (M = 0; M < C; M += 1)
          b(M), y.d.dataProps[M].p.setGroupProperty($);
        function A(D) {
          return D === "Color" || D === "color" ? A.color : D === "Opacity" || D === "opacity" ? A.opacity : D === "Stroke Width" || D === "stroke width" ? A.strokeWidth : null;
        }
        return Object.defineProperties(A, {
          color: {
            get: ExpressionPropertyInterface(y.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(y.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface(y.w)
          },
          dash: {
            get: function() {
              return S;
            }
          },
          _name: {
            value: v.nm
          },
          mn: {
            value: v.mn
          }
        }), y.c.setGroupProperty(PropertyInterface("Color", _)), y.o.setGroupProperty(PropertyInterface("Opacity", _)), y.w.setGroupProperty(PropertyInterface("Stroke Width", _)), A;
      }
      function l(v, y, x) {
        function _(b) {
          return b === v.e.ix || b === "End" || b === "end" ? _.end : b === v.s.ix ? _.start : b === v.o.ix ? _.offset : null;
        }
        var $ = propertyGroupFactory(_, x);
        return _.propertyIndex = v.ix, y.s.setGroupProperty(PropertyInterface("Start", $)), y.e.setGroupProperty(PropertyInterface("End", $)), y.o.setGroupProperty(PropertyInterface("Offset", $)), _.propertyIndex = v.ix, _.propertyGroup = x, Object.defineProperties(_, {
          start: {
            get: ExpressionPropertyInterface(y.s)
          },
          end: {
            get: ExpressionPropertyInterface(y.e)
          },
          offset: {
            get: ExpressionPropertyInterface(y.o)
          },
          _name: {
            value: v.nm
          }
        }), _.mn = v.mn, _;
      }
      function d(v, y, x) {
        function _(b) {
          return v.a.ix === b || b === "Anchor Point" ? _.anchorPoint : v.o.ix === b || b === "Opacity" ? _.opacity : v.p.ix === b || b === "Position" ? _.position : v.r.ix === b || b === "Rotation" || b === "ADBE Vector Rotation" ? _.rotation : v.s.ix === b || b === "Scale" ? _.scale : v.sk && v.sk.ix === b || b === "Skew" ? _.skew : v.sa && v.sa.ix === b || b === "Skew Axis" ? _.skewAxis : null;
        }
        var $ = propertyGroupFactory(_, x);
        return y.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", $)), y.transform.mProps.p.setGroupProperty(PropertyInterface("Position", $)), y.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", $)), y.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", $)), y.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", $)), y.transform.mProps.sk && (y.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", $)), y.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", $))), y.transform.op.setGroupProperty(PropertyInterface("Opacity", $)), Object.defineProperties(_, {
          opacity: {
            get: ExpressionPropertyInterface(y.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface(y.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface(y.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface(y.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface(y.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface(y.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface(y.transform.mProps.sa)
          },
          _name: {
            value: v.nm
          }
        }), _.ty = "tr", _.mn = v.mn, _.propertyGroup = x, _;
      }
      function h(v, y, x) {
        function _(M) {
          return v.p.ix === M ? _.position : v.s.ix === M ? _.size : null;
        }
        var $ = propertyGroupFactory(_, x);
        _.propertyIndex = v.ix;
        var b = y.sh.ty === "tm" ? y.sh.prop : y.sh;
        return b.s.setGroupProperty(PropertyInterface("Size", $)), b.p.setGroupProperty(PropertyInterface("Position", $)), Object.defineProperties(_, {
          size: {
            get: ExpressionPropertyInterface(b.s)
          },
          position: {
            get: ExpressionPropertyInterface(b.p)
          },
          _name: {
            value: v.nm
          }
        }), _.mn = v.mn, _;
      }
      function u(v, y, x) {
        function _(M) {
          return v.p.ix === M ? _.position : v.r.ix === M ? _.rotation : v.pt.ix === M ? _.points : v.or.ix === M || M === "ADBE Vector Star Outer Radius" ? _.outerRadius : v.os.ix === M ? _.outerRoundness : v.ir && (v.ir.ix === M || M === "ADBE Vector Star Inner Radius") ? _.innerRadius : v.is && v.is.ix === M ? _.innerRoundness : null;
        }
        var $ = propertyGroupFactory(_, x), b = y.sh.ty === "tm" ? y.sh.prop : y.sh;
        return _.propertyIndex = v.ix, b.or.setGroupProperty(PropertyInterface("Outer Radius", $)), b.os.setGroupProperty(PropertyInterface("Outer Roundness", $)), b.pt.setGroupProperty(PropertyInterface("Points", $)), b.p.setGroupProperty(PropertyInterface("Position", $)), b.r.setGroupProperty(PropertyInterface("Rotation", $)), v.ir && (b.ir.setGroupProperty(PropertyInterface("Inner Radius", $)), b.is.setGroupProperty(PropertyInterface("Inner Roundness", $))), Object.defineProperties(_, {
          position: {
            get: ExpressionPropertyInterface(b.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(b.r)
          },
          points: {
            get: ExpressionPropertyInterface(b.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(b.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(b.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(b.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(b.is)
          },
          _name: {
            value: v.nm
          }
        }), _.mn = v.mn, _;
      }
      function p(v, y, x) {
        function _(M) {
          return v.p.ix === M ? _.position : v.r.ix === M ? _.roundness : v.s.ix === M || M === "Size" || M === "ADBE Vector Rect Size" ? _.size : null;
        }
        var $ = propertyGroupFactory(_, x), b = y.sh.ty === "tm" ? y.sh.prop : y.sh;
        return _.propertyIndex = v.ix, b.p.setGroupProperty(PropertyInterface("Position", $)), b.s.setGroupProperty(PropertyInterface("Size", $)), b.r.setGroupProperty(PropertyInterface("Rotation", $)), Object.defineProperties(_, {
          position: {
            get: ExpressionPropertyInterface(b.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(b.r)
          },
          size: {
            get: ExpressionPropertyInterface(b.s)
          },
          _name: {
            value: v.nm
          }
        }), _.mn = v.mn, _;
      }
      function m(v, y, x) {
        function _(M) {
          return v.r.ix === M || M === "Round Corners 1" ? _.radius : null;
        }
        var $ = propertyGroupFactory(_, x), b = y;
        return _.propertyIndex = v.ix, b.rd.setGroupProperty(PropertyInterface("Radius", $)), Object.defineProperties(_, {
          radius: {
            get: ExpressionPropertyInterface(b.rd)
          },
          _name: {
            value: v.nm
          }
        }), _.mn = v.mn, _;
      }
      function g(v, y, x) {
        function _(M) {
          return v.c.ix === M || M === "Copies" ? _.copies : v.o.ix === M || M === "Offset" ? _.offset : null;
        }
        var $ = propertyGroupFactory(_, x), b = y;
        return _.propertyIndex = v.ix, b.c.setGroupProperty(PropertyInterface("Copies", $)), b.o.setGroupProperty(PropertyInterface("Offset", $)), Object.defineProperties(_, {
          copies: {
            get: ExpressionPropertyInterface(b.c)
          },
          offset: {
            get: ExpressionPropertyInterface(b.o)
          },
          _name: {
            value: v.nm
          }
        }), _.mn = v.mn, _;
      }
      return function(v, y, x) {
        var _;
        function $(M) {
          if (typeof M == "number")
            return M = M === void 0 ? 1 : M, M === 0 ? x : _[M - 1];
          for (var C = 0, S = _.length; C < S; ) {
            if (_[C]._name === M)
              return _[C];
            C += 1;
          }
          return null;
        }
        function b() {
          return x;
        }
        return $.propertyGroup = propertyGroupFactory($, b), _ = t(v, y, $.propertyGroup), $.numProperties = _.length, $._name = "Contents", $;
      };
    }(), TextExpressionInterface = function() {
      return function(t) {
        var r;
        function n(a) {
          switch (a) {
            case "ADBE Text Document":
              return n.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(n, "sourceText", {
          get: function() {
            t.textProperty.getValue();
            var s = t.textProperty.currentData.t;
            return (!r || s !== r.value) && (r = new String(s), r.value = s || new String(s), Object.defineProperty(r, "style", {
              get: function() {
                return {
                  fillColor: t.textProperty.currentData.fc
                };
              }
            })), r;
          }
        }), n;
      };
    }();
    function _typeof(t) {
      "@babel/helpers - typeof";
      return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof(t);
    }
    var FootageInterface = function() {
      var t = function(a) {
        var s = "", o = a.getFootageData();
        function c() {
          return s = "", o = a.getFootageData(), l;
        }
        function l(d) {
          if (o[d])
            return s = d, o = o[d], _typeof(o) === "object" ? l : o;
          var h = d.indexOf(s);
          if (h !== -1) {
            var u = parseInt(d.substr(h + s.length), 10);
            return o = o[u], _typeof(o) === "object" ? l : o;
          }
          return "";
        }
        return c;
      }, r = function(a) {
        function s(o) {
          return o === "Outline" ? s.outlineInterface() : null;
        }
        return s._name = "Outline", s.outlineInterface = t(a), s;
      };
      return function(n) {
        function a(s) {
          return s === "Data" ? a.dataInterface : null;
        }
        return a._name = "Data", a.dataInterface = r(n), a;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(t) {
      return interfaces[t] || null;
    }
    var expressionHelpers = function() {
      function t(c, l, d) {
        l.x && (d.k = !0, d.x = !0, d.initiateExpression = ExpressionManager.initiateExpression, d.effectsSequence.push(d.initiateExpression(c, l, d).bind(d)));
      }
      function r(c) {
        return c *= this.elem.globalData.frameRate, c -= this.offsetTime, c !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < c ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(c, this._cachingAtTime), this._cachingAtTime.lastFrame = c), this._cachingAtTime.value;
      }
      function n(c) {
        var l = -0.01, d = this.getValueAtTime(c), h = this.getValueAtTime(c + l), u = 0;
        if (d.length) {
          var p;
          for (p = 0; p < d.length; p += 1)
            u += Math.pow(h[p] - d[p], 2);
          u = Math.sqrt(u) * 100;
        } else
          u = 0;
        return u;
      }
      function a(c) {
        if (this.vel !== void 0)
          return this.vel;
        var l = -1e-3, d = this.getValueAtTime(c), h = this.getValueAtTime(c + l), u;
        if (d.length) {
          u = createTypedArray("float32", d.length);
          var p;
          for (p = 0; p < d.length; p += 1)
            u[p] = (h[p] - d[p]) / l;
        } else
          u = (h - d) / l;
        return u;
      }
      function s() {
        return this.pv;
      }
      function o(c) {
        this.propertyGroup = c;
      }
      return {
        searchExpressions: t,
        getSpeedAtTime: n,
        getVelocityAtTime: a,
        getValueAtTime: r,
        getStaticValueAtTime: s,
        setGroupProperty: o
      };
    }();
    function addPropertyDecorator() {
      function t(m, g, v) {
        if (!this.k || !this.keyframes)
          return this.pv;
        m = m ? m.toLowerCase() : "";
        var y = this.comp.renderedFrame, x = this.keyframes, _ = x[x.length - 1].t;
        if (y <= _)
          return this.pv;
        var $, b;
        v ? (g ? $ = Math.abs(_ - this.elem.comp.globalData.frameRate * g) : $ = Math.max(0, _ - this.elem.data.ip), b = _ - $) : ((!g || g > x.length - 1) && (g = x.length - 1), b = x[x.length - 1 - g].t, $ = _ - b);
        var M, C, S;
        if (m === "pingpong") {
          var A = Math.floor((y - b) / $);
          if (A % 2 !== 0)
            return this.getValueAtTime(($ - (y - b) % $ + b) / this.comp.globalData.frameRate, 0);
        } else if (m === "offset") {
          var D = this.getValueAtTime(b / this.comp.globalData.frameRate, 0), N = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), T = this.getValueAtTime(((y - b) % $ + b) / this.comp.globalData.frameRate, 0), R = Math.floor((y - b) / $);
          if (this.pv.length) {
            for (S = new Array(D.length), C = S.length, M = 0; M < C; M += 1)
              S[M] = (N[M] - D[M]) * R + T[M];
            return S;
          }
          return (N - D) * R + T;
        } else if (m === "continue") {
          var F = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), z = this.getValueAtTime((_ - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (S = new Array(F.length), C = S.length, M = 0; M < C; M += 1)
              S[M] = F[M] + (F[M] - z[M]) * ((y - _) / this.comp.globalData.frameRate) / 5e-4;
            return S;
          }
          return F + (F - z) * ((y - _) / 1e-3);
        }
        return this.getValueAtTime(((y - b) % $ + b) / this.comp.globalData.frameRate, 0);
      }
      function r(m, g, v) {
        if (!this.k)
          return this.pv;
        m = m ? m.toLowerCase() : "";
        var y = this.comp.renderedFrame, x = this.keyframes, _ = x[0].t;
        if (y >= _)
          return this.pv;
        var $, b;
        v ? (g ? $ = Math.abs(this.elem.comp.globalData.frameRate * g) : $ = Math.max(0, this.elem.data.op - _), b = _ + $) : ((!g || g > x.length - 1) && (g = x.length - 1), b = x[g].t, $ = b - _);
        var M, C, S;
        if (m === "pingpong") {
          var A = Math.floor((_ - y) / $);
          if (A % 2 === 0)
            return this.getValueAtTime(((_ - y) % $ + _) / this.comp.globalData.frameRate, 0);
        } else if (m === "offset") {
          var D = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), N = this.getValueAtTime(b / this.comp.globalData.frameRate, 0), T = this.getValueAtTime(($ - (_ - y) % $ + _) / this.comp.globalData.frameRate, 0), R = Math.floor((_ - y) / $) + 1;
          if (this.pv.length) {
            for (S = new Array(D.length), C = S.length, M = 0; M < C; M += 1)
              S[M] = T[M] - (N[M] - D[M]) * R;
            return S;
          }
          return T - (N - D) * R;
        } else if (m === "continue") {
          var F = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), z = this.getValueAtTime((_ + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (S = new Array(F.length), C = S.length, M = 0; M < C; M += 1)
              S[M] = F[M] + (F[M] - z[M]) * (_ - y) / 1e-3;
            return S;
          }
          return F + (F - z) * (_ - y) / 1e-3;
        }
        return this.getValueAtTime(($ - ((_ - y) % $ + _)) / this.comp.globalData.frameRate, 0);
      }
      function n(m, g) {
        if (!this.k)
          return this.pv;
        if (m = (m || 0.4) * 0.5, g = Math.floor(g || 5), g <= 1)
          return this.pv;
        var v = this.comp.renderedFrame / this.comp.globalData.frameRate, y = v - m, x = v + m, _ = g > 1 ? (x - y) / (g - 1) : 1, $ = 0, b = 0, M;
        this.pv.length ? M = createTypedArray("float32", this.pv.length) : M = 0;
        for (var C; $ < g; ) {
          if (C = this.getValueAtTime(y + $ * _), this.pv.length)
            for (b = 0; b < this.pv.length; b += 1)
              M[b] += C[b];
          else
            M += C;
          $ += 1;
        }
        if (this.pv.length)
          for (b = 0; b < this.pv.length; b += 1)
            M[b] /= g;
        else
          M /= g;
        return M;
      }
      function a(m) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var g = this._transformCachingAtTime.v;
        if (g.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var v = this.a.getValueAtTime(m);
          g.translate(-v[0] * this.a.mult, -v[1] * this.a.mult, v[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var y = this.s.getValueAtTime(m);
          g.scale(y[0] * this.s.mult, y[1] * this.s.mult, y[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var x = this.sk.getValueAtTime(m), _ = this.sa.getValueAtTime(m);
          g.skewFromAxis(-x * this.sk.mult, _ * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var $ = this.r.getValueAtTime(m);
          g.rotate(-$ * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var b = this.rz.getValueAtTime(m), M = this.ry.getValueAtTime(m), C = this.rx.getValueAtTime(m), S = this.or.getValueAtTime(m);
          g.rotateZ(-b * this.rz.mult).rotateY(M * this.ry.mult).rotateX(C * this.rx.mult).rotateZ(-S[2] * this.or.mult).rotateY(S[1] * this.or.mult).rotateX(S[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var A = this.px.getValueAtTime(m), D = this.py.getValueAtTime(m);
          if (this.data.p.z) {
            var N = this.pz.getValueAtTime(m);
            g.translate(A * this.px.mult, D * this.py.mult, -N * this.pz.mult);
          } else
            g.translate(A * this.px.mult, D * this.py.mult, 0);
        } else {
          var T = this.p.getValueAtTime(m);
          g.translate(T[0] * this.p.mult, T[1] * this.p.mult, -T[2] * this.p.mult);
        }
        return g;
      }
      function s() {
        return this.v.clone(new Matrix());
      }
      var o = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(m, g, v) {
        var y = o(m, g, v);
        return y.dynamicProperties.length ? y.getValueAtTime = a.bind(y) : y.getValueAtTime = s.bind(y), y.setGroupProperty = expressionHelpers.setGroupProperty, y;
      };
      var c = PropertyFactory.getProp;
      PropertyFactory.getProp = function(m, g, v, y, x) {
        var _ = c(m, g, v, y, x);
        _.kf ? _.getValueAtTime = expressionHelpers.getValueAtTime.bind(_) : _.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(_), _.setGroupProperty = expressionHelpers.setGroupProperty, _.loopOut = t, _.loopIn = r, _.smooth = n, _.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(_), _.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(_), _.numKeys = g.a === 1 ? g.k.length : 0, _.propertyIndex = g.ix;
        var $ = 0;
        return v !== 0 && ($ = createTypedArray("float32", g.a === 1 ? g.k[0].s.length : g.k.length)), _._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: $
        }, expressionHelpers.searchExpressions(m, g, _), _.k && x.addDynamicProperty(_), _;
      };
      function l(m) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), m *= this.elem.globalData.frameRate, m -= this.offsetTime, m !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < m ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = m, this.interpolateShape(m, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var d = ShapePropertyFactory.getConstructorFunction(), h = ShapePropertyFactory.getKeyframedConstructorFunction();
      function u() {
      }
      u.prototype = {
        vertices: function(g, v) {
          this.k && this.getValue();
          var y = this.v;
          v !== void 0 && (y = this.getValueAtTime(v, 0));
          var x, _ = y._length, $ = y[g], b = y.v, M = createSizedArray(_);
          for (x = 0; x < _; x += 1)
            g === "i" || g === "o" ? M[x] = [$[x][0] - b[x][0], $[x][1] - b[x][1]] : M[x] = [$[x][0], $[x][1]];
          return M;
        },
        points: function(g) {
          return this.vertices("v", g);
        },
        inTangents: function(g) {
          return this.vertices("i", g);
        },
        outTangents: function(g) {
          return this.vertices("o", g);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(g, v) {
          var y = this.v;
          v !== void 0 && (y = this.getValueAtTime(v, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(y));
          for (var x = this._segmentsLength, _ = x.lengths, $ = x.totalLength * g, b = 0, M = _.length, C = 0, S; b < M; ) {
            if (C + _[b].addedLength > $) {
              var A = b, D = y.c && b === M - 1 ? 0 : b + 1, N = ($ - C) / _[b].addedLength;
              S = bez.getPointInSegment(y.v[A], y.v[D], y.o[A], y.i[D], N, _[b]);
              break;
            } else
              C += _[b].addedLength;
            b += 1;
          }
          return S || (S = y.c ? [y.v[0][0], y.v[0][1]] : [y.v[y._length - 1][0], y.v[y._length - 1][1]]), S;
        },
        vectorOnPath: function(g, v, y) {
          g == 1 ? g = this.v.c : g == 0 && (g = 0.999);
          var x = this.pointOnPath(g, v), _ = this.pointOnPath(g + 1e-3, v), $ = _[0] - x[0], b = _[1] - x[1], M = Math.sqrt(Math.pow($, 2) + Math.pow(b, 2));
          if (M === 0)
            return [0, 0];
          var C = y === "tangent" ? [$ / M, b / M] : [-b / M, $ / M];
          return C;
        },
        tangentOnPath: function(g, v) {
          return this.vectorOnPath(g, v, "tangent");
        },
        normalOnPath: function(g, v) {
          return this.vectorOnPath(g, v, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([u], d), extendPrototype([u], h), h.prototype.getValueAtTime = l, h.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var p = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(m, g, v, y, x) {
        var _ = p(m, g, v, y, x);
        return _.propertyIndex = g.ix, _.lock = !1, v === 3 ? expressionHelpers.searchExpressions(m, g.pt, _) : v === 4 && expressionHelpers.searchExpressions(m, g.ks, _), _.k && m.addDynamicProperty(_), _;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function t() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(r, n) {
        var a = this.calculateExpression(n);
        if (r.t !== a) {
          var s = {};
          return this.copyData(s, r), s.t = a.toString(), s.__complete = !1, s;
        }
        return r;
      }, TextProperty.prototype.searchProperty = function() {
        var r = this.searchKeyframes(), n = this.searchExpressions();
        return this.kf = r || n, this.kf;
      }, TextProperty.prototype.searchExpressions = t;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function t(r, n) {
        var a = createNS("feMerge");
        a.setAttribute("result", r);
        var s, o;
        for (o = 0; o < n.length; o += 1)
          s = createNS("feMergeNode"), s.setAttribute("in", n[o]), a.appendChild(s), a.appendChild(s);
        return a;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(t, r, n, a, s) {
      this.filterManager = r;
      var o = createNS("feColorMatrix");
      o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "linearRGB"), o.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = o, o.setAttribute("result", a + "_tint_1"), t.appendChild(o), o = createNS("feColorMatrix"), o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), o.setAttribute("result", a + "_tint_2"), t.appendChild(o), this.matrixFilter = o;
      var c = this.createMergeNode(a, [s, a + "_tint_1", a + "_tint_2"]);
      t.appendChild(c);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + a + " 0"), this.matrixFilter.setAttribute("values", n[0] - r[0] + " 0 0 0 " + r[0] + " " + (n[1] - r[1]) + " 0 0 0 " + r[1] + " " + (n[2] - r[2]) + " 0 0 0 " + r[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(t, r, n, a) {
      this.filterManager = r;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", a), t.appendChild(s), this.matrixFilter = s;
    }
    SVGFillFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[2].p.v, n = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + r[0] + " 0 0 0 0 " + r[1] + " 0 0 0 0 " + r[2] + " 0 0 0 " + n + " 0");
      }
    };
    function SVGStrokeEffect(t, r, n) {
      this.initialized = !1, this.filterManager = r, this.elem = n, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var t = this.elem.layerElement.children || this.elem.layerElement.childNodes, r, n, a, s;
      for (this.filterManager.effectElements[1].p.v === 1 ? (s = this.elem.maskManager.masksProperties.length, a = 0) : (a = this.filterManager.effectElements[0].p.v - 1, s = a + 1), n = createNS("g"), n.setAttribute("fill", "none"), n.setAttribute("stroke-linecap", "round"), n.setAttribute("stroke-dashoffset", 1), a; a < s; a += 1)
        r = createNS("path"), n.appendChild(r), this.paths.push({
          p: r,
          m: a
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var o = createNS("mask"), c = createElementID();
        o.setAttribute("id", c), o.setAttribute("mask-type", "alpha"), o.appendChild(n), this.elem.globalData.defs.appendChild(o);
        var l = createNS("g");
        for (l.setAttribute("mask", "url(" + getLocationHref() + "#" + c + ")"); t[0]; )
          l.appendChild(t[0]);
        this.elem.layerElement.appendChild(l), this.masker = o, n.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (t = this.elem.layerElement.children || this.elem.layerElement.childNodes; t.length; )
            this.elem.layerElement.removeChild(t[0]);
        this.elem.layerElement.appendChild(n), this.elem.layerElement.removeAttribute("mask"), n.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = n;
    }, SVGStrokeEffect.prototype.renderFrame = function(t) {
      this.initialized || this.initialize();
      var r, n = this.paths.length, a, s;
      for (r = 0; r < n; r += 1)
        if (this.paths[r].m !== -1 && (a = this.elem.maskManager.viewData[this.paths[r].m], s = this.paths[r].p, (t || this.filterManager._mdf || a.prop._mdf) && s.setAttribute("d", a.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || a.prop._mdf)) {
          var o;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var c = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, l = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, d = s.getTotalLength();
            o = "0 0 0 " + d * c + " ";
            var h = d * (l - c), u = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, p = Math.floor(h / u), m;
            for (m = 0; m < p; m += 1)
              o += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            o += "0 " + d * 10 + " 0 0";
          } else
            o = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          s.setAttribute("stroke-dasharray", o);
        }
      if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (t || this.filterManager.effectElements[3].p._mdf)) {
        var g = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(g[0] * 255) + "," + bmFloor(g[1] * 255) + "," + bmFloor(g[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(t, r, n, a) {
      this.filterManager = r;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(s);
      var o = createNS("feComponentTransfer");
      o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", a), this.matrixFilter = o;
      var c = createNS("feFuncR");
      c.setAttribute("type", "table"), o.appendChild(c), this.feFuncR = c;
      var l = createNS("feFuncG");
      l.setAttribute("type", "table"), o.appendChild(l), this.feFuncG = l;
      var d = createNS("feFuncB");
      d.setAttribute("type", "table"), o.appendChild(d), this.feFuncB = d, t.appendChild(o);
    }
    SVGTritoneFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = this.filterManager.effectElements[2].p.v, s = a[0] + " " + n[0] + " " + r[0], o = a[1] + " " + n[1] + " " + r[1], c = a[2] + " " + n[2] + " " + r[2];
        this.feFuncR.setAttribute("tableValues", s), this.feFuncG.setAttribute("tableValues", o), this.feFuncB.setAttribute("tableValues", c);
      }
    };
    function SVGProLevelsFilter(t, r, n, a) {
      this.filterManager = r;
      var s = this.filterManager.effectElements, o = createNS("feComponentTransfer");
      (s[10].p.k || s[10].p.v !== 0 || s[11].p.k || s[11].p.v !== 1 || s[12].p.k || s[12].p.v !== 1 || s[13].p.k || s[13].p.v !== 0 || s[14].p.k || s[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", o)), (s[17].p.k || s[17].p.v !== 0 || s[18].p.k || s[18].p.v !== 1 || s[19].p.k || s[19].p.v !== 1 || s[20].p.k || s[20].p.v !== 0 || s[21].p.k || s[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", o)), (s[24].p.k || s[24].p.v !== 0 || s[25].p.k || s[25].p.v !== 1 || s[26].p.k || s[26].p.v !== 1 || s[27].p.k || s[27].p.v !== 0 || s[28].p.k || s[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", o)), (s[31].p.k || s[31].p.v !== 0 || s[32].p.k || s[32].p.v !== 1 || s[33].p.k || s[33].p.v !== 1 || s[34].p.k || s[34].p.v !== 0 || s[35].p.k || s[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", o)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (o.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(o)), (s[3].p.k || s[3].p.v !== 0 || s[4].p.k || s[4].p.v !== 1 || s[5].p.k || s[5].p.v !== 1 || s[6].p.k || s[6].p.v !== 0 || s[7].p.k || s[7].p.v !== 1) && (o = createNS("feComponentTransfer"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", a), t.appendChild(o), this.feFuncRComposed = this.createFeFunc("feFuncR", o), this.feFuncGComposed = this.createFeFunc("feFuncG", o), this.feFuncBComposed = this.createFeFunc("feFuncB", o));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(t, r) {
      var n = createNS(t);
      return n.setAttribute("type", "table"), r.appendChild(n), n;
    }, SVGProLevelsFilter.prototype.getTableValue = function(t, r, n, a, s) {
      for (var o = 0, c = 256, l, d = Math.min(t, r), h = Math.max(t, r), u = Array.call(null, {
        length: c
      }), p, m = 0, g = s - a, v = r - t; o <= 256; )
        l = o / 256, l <= d ? p = v < 0 ? s : a : l >= h ? p = v < 0 ? a : s : p = a + g * Math.pow((l - t) / v, 1 / n), u[m] = p, m += 1, o += 256 / (c - 1);
      return u.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r, n = this.filterManager.effectElements;
        this.feFuncRComposed && (t || n[3].p._mdf || n[4].p._mdf || n[5].p._mdf || n[6].p._mdf || n[7].p._mdf) && (r = this.getTableValue(n[3].p.v, n[4].p.v, n[5].p.v, n[6].p.v, n[7].p.v), this.feFuncRComposed.setAttribute("tableValues", r), this.feFuncGComposed.setAttribute("tableValues", r), this.feFuncBComposed.setAttribute("tableValues", r)), this.feFuncR && (t || n[10].p._mdf || n[11].p._mdf || n[12].p._mdf || n[13].p._mdf || n[14].p._mdf) && (r = this.getTableValue(n[10].p.v, n[11].p.v, n[12].p.v, n[13].p.v, n[14].p.v), this.feFuncR.setAttribute("tableValues", r)), this.feFuncG && (t || n[17].p._mdf || n[18].p._mdf || n[19].p._mdf || n[20].p._mdf || n[21].p._mdf) && (r = this.getTableValue(n[17].p.v, n[18].p.v, n[19].p.v, n[20].p.v, n[21].p.v), this.feFuncG.setAttribute("tableValues", r)), this.feFuncB && (t || n[24].p._mdf || n[25].p._mdf || n[26].p._mdf || n[27].p._mdf || n[28].p._mdf) && (r = this.getTableValue(n[24].p.v, n[25].p.v, n[26].p.v, n[27].p.v, n[28].p.v), this.feFuncB.setAttribute("tableValues", r)), this.feFuncA && (t || n[31].p._mdf || n[32].p._mdf || n[33].p._mdf || n[34].p._mdf || n[35].p._mdf) && (r = this.getTableValue(n[31].p.v, n[32].p.v, n[33].p.v, n[34].p.v, n[35].p.v), this.feFuncA.setAttribute("tableValues", r));
      }
    };
    function SVGDropShadowEffect(t, r, n, a, s) {
      var o = r.container.globalData.renderConfig.filterSize, c = r.data.fs || o;
      t.setAttribute("x", c.x || o.x), t.setAttribute("y", c.y || o.y), t.setAttribute("width", c.width || o.width), t.setAttribute("height", c.height || o.height), this.filterManager = r;
      var l = createNS("feGaussianBlur");
      l.setAttribute("in", "SourceAlpha"), l.setAttribute("result", a + "_drop_shadow_1"), l.setAttribute("stdDeviation", "0"), this.feGaussianBlur = l, t.appendChild(l);
      var d = createNS("feOffset");
      d.setAttribute("dx", "25"), d.setAttribute("dy", "0"), d.setAttribute("in", a + "_drop_shadow_1"), d.setAttribute("result", a + "_drop_shadow_2"), this.feOffset = d, t.appendChild(d);
      var h = createNS("feFlood");
      h.setAttribute("flood-color", "#00ff00"), h.setAttribute("flood-opacity", "1"), h.setAttribute("result", a + "_drop_shadow_3"), this.feFlood = h, t.appendChild(h);
      var u = createNS("feComposite");
      u.setAttribute("in", a + "_drop_shadow_3"), u.setAttribute("in2", a + "_drop_shadow_2"), u.setAttribute("operator", "in"), u.setAttribute("result", a + "_drop_shadow_4"), t.appendChild(u);
      var p = this.createMergeNode(a, [a + "_drop_shadow_4", s]);
      t.appendChild(p);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
          var r = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(r[0] * 255), Math.round(r[1] * 255), Math.round(r[2] * 255)));
        }
        if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var n = this.filterManager.effectElements[3].p.v, a = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s = n * Math.cos(a), o = n * Math.sin(a);
          this.feOffset.setAttribute("dx", s), this.feOffset.setAttribute("dy", o);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(t, r, n) {
      this.initialized = !1, this.filterManager = r, this.filterElem = t, this.elem = n, n.matteElement = createNS("g"), n.matteElement.appendChild(n.layerElement), n.matteElement.appendChild(n.transformedElement), n.baseElement = n.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(t) {
      for (var r = 0, n = _svgMatteSymbols.length; r < n; ) {
        if (_svgMatteSymbols[r] === t)
          return _svgMatteSymbols[r];
        r += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(t, r) {
      var n = t.layerElement.parentNode;
      if (n) {
        for (var a = n.children, s = 0, o = a.length; s < o && a[s] !== t.layerElement; )
          s += 1;
        var c;
        s <= o - 2 && (c = a[s + 1]);
        var l = createNS("use");
        l.setAttribute("href", "#" + r), c ? n.insertBefore(l, c) : n.appendChild(l);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(t, r) {
      if (!this.findSymbol(r)) {
        var n = createElementID(), a = createNS("mask");
        a.setAttribute("id", r.layerId), a.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(r);
        var s = t.globalData.defs;
        s.appendChild(a);
        var o = createNS("symbol");
        o.setAttribute("id", n), this.replaceInParent(r, n), o.appendChild(r.layerElement), s.appendChild(o);
        var c = createNS("use");
        c.setAttribute("href", "#" + n), a.appendChild(c), r.data.hd = !1, r.show();
      }
      t.setMatte(r.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var t = this.filterManager.effectElements[0].p.v, r = this.elem.comp.elements, n = 0, a = r.length; n < a; )
        r[n] && r[n].data.ind === t && this.setElementAsMask(this.elem, r[n]), n += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(t, r, n, a) {
      t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = r;
      var s = createNS("feGaussianBlur");
      s.setAttribute("result", a), t.appendChild(s), this.feGaussianBlur = s;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = 0.3, n = this.filterManager.effectElements[0].p.v * r, a = this.filterManager.effectElements[1].p.v, s = a == 3 ? 0 : n, o = a == 2 ? 0 : n;
        this.feGaussianBlur.setAttribute("stdDeviation", s + " " + o);
        var c = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", c);
      }
    };
    function TransformEffect() {
    }
    TransformEffect.prototype.init = function(t) {
      this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(t) {
      if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
        var r = this.effectsManager.effectElements, n = r[0].p.v, a = r[1].p.v, s = r[2].p.v === 1, o = r[3].p.v, c = s ? o : r[4].p.v, l = r[5].p.v, d = r[6].p.v, h = r[7].p.v;
        this.matrix.reset(), this.matrix.translate(-n[0], -n[1], n[2]), this.matrix.scale(c * 0.01, o * 0.01, 1), this.matrix.rotate(-h * degToRads), this.matrix.skewFromAxis(-l * degToRads, (d + 90) * degToRads), this.matrix.translate(a[0], a[1], 0), this._mdf = !0, this.opacity !== r[8].p.v && (this.opacity = r[8].p.v, this._opMdf = !0);
      }
    };
    function SVGTransformEffect(t, r) {
      this.init(r);
    }
    extendPrototype([TransformEffect], SVGTransformEffect);
    function CVTransformEffect(t) {
      this.init(t);
    }
    return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
})(lottie$1, lottie$1.exports);
var lottieExports = lottie$1.exports;
const lottie = /* @__PURE__ */ getDefaultExportFromCjs(lottieExports), LottieContainer = styled.div`
  ${MarginsStyles}
`, defaultOptions = {
  loop: !0,
  autoplay: !0,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
}, Lottie = ({
  options: t,
  className: r,
  onComplete: n,
  ...a
}) => {
  const s = useRef(null);
  return useEffect(() => {
    s.current && lottie.loadAnimation({
      container: s.current,
      renderer: "svg",
      ...defaultOptions,
      ...t,
      ...t.path && {
        path: t.path
      },
      ...t.animationData && {
        path: t.animationData
      }
    }).addEventListener("complete", () => n && n());
  }, [s]), /* @__PURE__ */ jsx$1(LottieContainer, {
    className: r,
    ref: s,
    role: "presentation",
    ...a
  });
}, Modal = ({
  id: t,
  open: r,
  children: n
}) => r && n ? /* @__PURE__ */ jsx$1(Portal, {
  id: t,
  children: n
}) : null, ModalContext = createContext({}), ModalProvider = ({
  children: t
}) => {
  const [r, n] = useState({
    open: !1,
    comp: null
  }), a = ({
    comp: c
  }) => {
    n({
      open: !0,
      comp: c
    }), document.body.classList.add("not-overflow");
  }, s = () => {
    n({
      open: !1,
      comp: null
    }), document.body.classList.remove("not-overflow");
  }, o = useMemo(() => ({
    isOpen: r.open,
    showModal: a,
    hideModal: s
  }), [r]);
  return /* @__PURE__ */ jsxs(ModalContext.Provider, {
    value: o,
    children: [t, /* @__PURE__ */ jsx$1(Modal, {
      open: r.open,
      children: r.comp
    })]
  });
}, useResize = () => {
  const [t, r] = useState(!1), [n, a] = useState(!1), [s, o] = useState(!1), c = () => {
    const d = window.innerWidth;
    r(d <= 600), a(d > 600 && d <= 1200), o(d > 1200);
  }, l = () => {
    c();
  };
  return useEffect(() => (window.addEventListener("resize", l), c(), () => {
    window.removeEventListener("resize", l);
  }), []), {
    isMobile: t,
    isTablet: n,
    isDesktop: s
  };
};
export {
  Accordion,
  Avatar,
  Banner,
  BannerModesEnum,
  Brand,
  Bullets,
  types$2 as ButtonTypes,
  Buttons,
  CardDirection,
  Carousel,
  CarouselModes,
  Cell$1 as Cell,
  Chip,
  ChipTypes,
  Direction,
  Doubts,
  Events,
  FlexContainer$1 as FlexContainer,
  Gap,
  HelpButtonModes,
  Icon$4 as Icon,
  IconColor,
  Illustration,
  IllustrationsDefault,
  IllustrationsStates,
  Informative,
  InformativeModes,
  InputFormTypes,
  Inputs,
  KamiForm,
  KamiInput,
  Layout,
  LayoutContext,
  LayoutDirection,
  LayoutProvider,
  index as LayoutRoot,
  Lottie,
  MandatoryLabels,
  ModalContext,
  ModalProvider,
  Modals,
  Navigation,
  Notification,
  NotificationModes,
  Portal,
  ProgressBar,
  ProgressBarCircle,
  RadioCardLayout,
  RichRow,
  Separator$1 as Separator,
  Sidebar,
  Sizes$1 as Sizes,
  Spinner,
  SpinnerModes,
  Stack,
  SubCell,
  SwitcherSize,
  Tabs,
  Text$3 as Text,
  TextInputStyles,
  ThemeProvider,
  Toast,
  ToastService,
  Tooltip,
  WrapModes,
  borderRadius$1 as borderRadius,
  bordersSizes,
  boxShadows,
  buttonSizes,
  buttonSizesLegacy,
  closeBlockContainer,
  closeLeftSidebar,
  closeRightSidebar,
  colors$1 as colors,
  colorsLegacy,
  components$1 as components,
  componentsMap,
  dimensions,
  fontSizes,
  fontSizesLegacy,
  fontWeights,
  gradientsLegacy,
  icons,
  isBlockContainer,
  isMobile,
  isOpenLeftSidebar,
  isOpenRightSidebar,
  mediaQueries,
  openBlockContainer,
  openLeftSidebar,
  openRightSidebar,
  reference$1 as reference,
  sizes,
  sizing,
  spacing$1 as spacing,
  system,
  textColors,
  toggleBlockContainer,
  toggleLeftSidebar,
  toggleRightSidebar,
  typography,
  typographyBase,
  typographyForms,
  useForm,
  useResize,
  validationParsers
};
